webpackJsonp([0,3],{

/***/ "+1bw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var assign = __webpack_require__("ZP50");
var mapValues = __webpack_require__("hr0c");
var some = __webpack_require__("2fRx");
var NgComponent = /** @class */ (function () {
    function NgComponent() {
        this.__isFirstRender = true;
        this.state = {};
        this.props = {};
    }
    /*
      eg. {
        as: {currentValue: [1, 2, 3], previousValue: [1, 2]},
        bs: {currentValue: 42, previousValue: undefined}
      }
    */
    // nb: this method is explicity exposed for unit testing
    NgComponent.prototype.$onChanges = function (changes) {
        var oldProps = this.props;
        // TODO: fix Lodash typings upstream
        var newProps = mapValues(changes, 'currentValue');
        // TODO: implement nextState (which also means implement this.setState)
        var nextProps = assign({}, this.props, newProps);
        if (this.__isFirstRender) {
            assign(this, { props: nextProps });
            this.componentWillMount();
            this.render();
            this.__isFirstRender = false;
        }
        else {
            if (!this.didPropsChange(newProps, oldProps))
                return;
            this.componentWillReceiveProps(nextProps);
            var shouldUpdate = this.shouldComponentUpdate(nextProps, this.state);
            assign(this, { props: nextProps });
            if (!shouldUpdate)
                return;
            this.componentWillUpdate(this.props, this.state);
            this.render();
            this.componentDidUpdate(this.props, this.state);
        }
    };
    NgComponent.prototype.$postLink = function () {
        this.componentDidMount();
    };
    NgComponent.prototype.$onDestroy = function () {
        this.componentWillUnmount();
    };
    NgComponent.prototype.didPropsChange = function (newProps, oldProps) {
        return some(newProps, function (v, k) { return v !== oldProps[k]; });
    };
    /*
      lifecycle hooks
    */
    NgComponent.prototype.componentWillMount = function () { };
    NgComponent.prototype.componentDidMount = function () { };
    NgComponent.prototype.componentWillReceiveProps = function (_props) { };
    NgComponent.prototype.shouldComponentUpdate = function (_nextProps, _nextState) { return true; };
    NgComponent.prototype.componentWillUpdate = function (_props, _state) { };
    NgComponent.prototype.componentDidUpdate = function (_props, _state) { };
    NgComponent.prototype.componentWillUnmount = function () { };
    NgComponent.prototype.render = function () { };
    return NgComponent;
}());
exports.default = NgComponent;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "+2WP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _data = __webpack_require__("nRO4");

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$window', 'Util', '$rootScope', 'FlexiblePromotionsRestService'];

var StoreComparisonController = function StoreComparisonController($scope, $state, $window, Util, $rootScope) {
    _classCallCheck(this, StoreComparisonController);

    var activationCodesRepo = _index.ActivationCodesRepository.getAll();
    var licensesRepo = _index.LicensesRepository.getAll();
    var userHasSubscriptions = activationCodesRepo.length > 0 || licensesRepo.length > 0;

    $scope.comparisonBundles = CWCONFIG.store.bundles;
    $scope.productsConfig = CWCONFIG.store.productsConfig;
    $scope.products = CWCONFIG.store.products;

    $scope.language = CWCONFIG.language;
    $scope.brandName = CWCONFIG.partnerConfig.name;

    // if ($rootScope.cmaGBapplies) {

    //     $scope.isFromUK = true;
    //     $scope.ukBuyUrl = 'https://www.avira.com/en/campaigns/crm/q2-fy23/f2p-antivirus-pro-mya?cookiebot_off=true';

    // }

    var languagesAwards = CWCONFIG.partnerConfig.translationsLinks.awards.languages;

    if (languagesAwards.find(function (element) {
        return element === CWCONFIG.language;
    })) {

        $scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', CWCONFIG.language);
    } else {

        $scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', 'en');
    }

    _RFC2.default.send('ConnectWeb Store Open', {
        Source: 'Direct',
        Store: 'cwStore'
    });

    // Check existing offers for discounts
    $scope.offers = {};
    _data2.default.forEach(function (offer) {

        $scope.offers[offer.productId] = offer;
        $scope.storeHasOffers = true;
    });

    $scope.appIds = {};

    var groupData = function groupData(arr, key) {

        if (!Util.deepFind($scope.appIds, key)) {

            $scope.appIds[key] = [];
        }

        arr.forEach(function (app) {

            var runtime = Util.deepFind($scope.productsConfig[app], 'runtime') || 12;
            var users = Util.deepFind($scope.productsConfig[app], 'users') || 1;
            $scope.appIds[key].push(app + '_' + runtime + '_' + users);
        });
    };

    groupData($scope.comparisonBundles, 'bundles');
    groupData($scope.products, 'products');

    // Get the prices for each product

    $scope.bundleComparisonFeatures = {};

    // Create the comparison features object for each bundle
    var comparisonFeatures = {};
    $scope.comparisonBundles.forEach(function (bundle) {

        var bundleData = _index.AppIntegrationsRepository.getById(bundle);
        $scope.bundleComparisonFeatures[bundle] = {};
        var features = Util.deepFind(bundleData, 'attributes.resource.comparisonFeatures') || [];

        features.forEach(function (feature) {

            comparisonFeatures[feature] = true;
            $scope.bundleComparisonFeatures[bundle][feature] = true;
        });
    });

    // remove isec0 feature_fix_software
    $scope.bundleComparisonFeatures.isec0.comparison_feature_fix_software = false;

    // Get product data from product catalog
    $scope.productData = {};
    $scope.comparisonBundles.concat($scope.products).forEach(function (product) {

        var productData = _index.AppIntegrationsRepository.getById(product);
        var runtime = Util.deepFind($scope.productsConfig[product], 'runtime') || 12;
        var users = Util.deepFind($scope.productsConfig[product], 'users') || 1;
        $scope.productData[product] = productData;
        $scope.productData[product].productConfig = product + '_' + runtime + '_' + users;
        $scope.productData[product].users = users;
    });

    $scope.comparisonFeatures = Object.keys(comparisonFeatures);

    //* Promotional Campaign
    //* To be commented when the campaign is over
    // $rootScope.createCMAlabels('aapd5_12_1', 'Antivirus Pro',
    // 'aapd5', '2023-06-08', '2023-06-30');
    // if (!$rootScope.cmaGBapplies) {

    //     $rootScope.createCMAlabels(
    //         'aps10_12_1',
    //         'Avira Prime',
    //         'aps10',
    //         '2023-11-23',
    //         '2023-12-03',
    //     );

    // }

    // $rootScope.createCMAlabels('aapd5_12_1', 'Antivirus Pro',
    // 'aapd5', '2023-06-08', '2023-06-30');

    // if ($rootScope.showAIACardInFreeStore) {

    //     $rootScope.createCMAlabels('adwp1_12_1', 'Identity Assistant',
    // 'adwp1', '2023-06-14', '2023-06-31');

    // }

    $scope.$on('$destroy', function () {

        $rootScope.welcomeOffers = {};
    });

    $scope.buy = function (appId) {

        var runtime = Util.deepFind($scope.productsConfig[appId], 'runtime') || 12;
        var currentPrice = _index.AppPricesRepository.getSinglePrice(appId, runtime, '1');

        var price = '';
        var discount = '';

        if (currentPrice) {

            if (Util.deepFind(currentPrice, 'attributes.promotion')) {

                price = Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                discount = Util.deepFind(currentPrice, 'attributes.promotion.discount');
            } else {

                price = Util.deepFind(currentPrice, 'attributes.price_string');
                discount = 0;
            }
        }

        _RFC2.default.send('ConnectWeb Store Buy Click', {
            'Product ID': appId,
            Page: 'Comparison Store Page',
            Runtimes: runtime.toString(),
            Price: price,
            Discount: discount
        });

        // if (appId === 'aapd5' && $scope.isFromUK) {

        //     $window.open($scope.ukBuyUrl, '_blank');
        //     return;

        // }

        // Remove the aapd5 promotion for free users < 120 days
        // const user = MeRepository.getMyUser();
        // const userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
        // const today = moment();
        // const registrtionDate = moment(userRegistrationDate);
        // const accountDays =
        //     parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;
        // const campaignBreakpoint = Util.deepFind(CWCONFIG,
        // 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;

        var subsource = 'store';
        // if (licensesRepo.length === 0 && appId === 'aapd5') {

        //     subsource = 'renew';

        // }

        $state.go('root.dashboard.store.ltb.buy', {
            ltb: 'payment-cart',
            resourceId: appId,
            subsource: subsource,
            promotion: true
        }, {
            reload: false
        });
    };

    $scope.openMarketingCard = function (appId) {

        _RFC2.default.send('ConnectWeb Learn More Click', {
            Page: 'Store',
            Product: $scope.productData[appId].attributes.resource.oeName,
            'Product ID': appId
        });

        $state.go('root.dashboard.store.ltb', {
            ltb: 'buy',
            resourceId: appId
        });
    };

    /**
     * When the user hovers on header or sidebar, Trial modal will be shown.
     * Criterias to show the trial modal:
     * - the user is free
     * - modal is configured in the config file
     * - the modal has not been seen by the user before (check local storage)
     * - $scope.enableTrialModal is 'true'
     * - do not show modal for users on mobile
     *
     * Know problem: when the user navigates to the store page from the sidebar,
     * after clicking
     * on the store page button, the mouseover event set in the sidebar is
     * fired multiple time
     * as long as the user moves the mouse over the sidebar.
     * So in order to prevent the modal
     * firing when the user just entered the page, we set '$scope.enableTrialModal' to true
     * when the user enters with the mouse over the store page content
     */
    $scope.enableTrialModal = false;
    var openTrialModal = function openTrialModal() {

        // detect device navigator OS
        var currentNavigatorOs = Util.getDeviceNavigator();

        // open trial modal
        if (!userHasSubscriptions && Util.deepFind(CWCONFIG, 'features.trialModal') && CWCONFIG.features.trialModal.showOffer && $scope.enableTrialModal && !localStorage.getItem(CWCONFIG.features.trialModal.localStorageName) && currentNavigatorOs !== 'android' && currentNavigatorOs !== 'ios') {

            $scope.enableTrialModal = false;

            _RFC2.default.send('ConnectWeb Trial Modal open', {
                Page: 'Store',
                'Product ID': Util.deepFind(CWCONFIG, 'features.trialModal.appId')
            });

            localStorage.setItem(Util.deepFind(CWCONFIG, 'features.trialModal.localStorageName'), true);

            $state.go('root.dashboard.store.ltb', {
                ltb: 'trial',
                resourceId: Util.deepFind(CWCONFIG, 'features.trialModal.appId') || []
            });
        }
    };

    _RFC4.default.subscribe('mainControlls:hover', openTrialModal);
};

var StoreComparisonDirective = function StoreComparisonDirective() {
    _classCallCheck(this, StoreComparisonDirective);

    this.template = __webpack_require__("oXJa");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $window, Util, AppPricesRestService, ErrorHandler) {
        return new StoreComparisonController($scope, $state, $window, Util, AppPricesRestService, ErrorHandler);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'StoreComparistonCtrl';
};

_directiveDependencies.push(function () {
    return new StoreComparisonDirective();
});

angular.module('directives').directive('storeComparison', _directiveDependencies);

/***/ }),

/***/ "+36T":
/***/ (function(module, exports) {

module.exports = "<div class=\"devices-page\">\n\n    <div ng-if=\"displayBanner === 'welcome-offer' && $root.hasUsCompliance\">\n        <welcome-offer ng-if=\"$root.dwmStatusLoaded && !$root.isMobileAppSession\"></welcome-offer>\n    </div>\n\n    <div ng-if=\"displayBanner === 'mobile' && $root.hasUsCompliance\" class=\"mobile-banner\">\n        <div class=\"mobile-banner-image\"></div>\n        <div class=\"mobile-banner-text\">\n            <div class=\"mobile-banner-title text-grey-2\" translate=\"cw.my_devices.mobile_banner.title\"></div>\n            <div class=\"mobile-banner-description font-super-light text-grey-3\" translate=\"cw.my_devices.mobile_banner.description\" translate-values=\"{brandname : brandName}\"></div>\n        </div>\n        <button class=\"mobile-banner-button btn-primary\" ng-click=\"deployOnCategory('mobile'); mixpanelBannerClick();\" translate=\"cw.my_devices.mobile_banner.button\"></button>\n    </div>\n\n    <h3 class=\"text-xl text-grey-1 text-center mt50\" ng-if=\"!hasDevices && $root.hasUsCompliance\" translate=\"cw.dashboard.devices.blank_state.title\" translate-values=\"{brandname : brandName}\"></h3>\n    <div ng-if=\"!$root.hasUsCompliance && !hasDevices\" class=\"text-center\">\n        <i class=\"icon-info-blue mt100\"></i>\n        <h3 class=\"text-xl text-grey-1 text-center mt20 mb20\" translate=\"cw.compliance_failed.desc\"></h3>\n        <h3 class=\"text-xl text-grey-1 text-center mb10\" translate=\"cw.compliance_failed.reason_1\"></h3>\n        <h3 class=\"text-xl text-grey-1 text-center\" translate=\"cw.compliance_failed.reason_2\"></h3>\n    </div>\n\n    <!-- <react-component callback-fn=\"callbackFn\"></react-component> -->\n    <div>\n        <div ng-if=\"hasMinimumDevices\" class=\"select-device-view\">\n            <span class=\"text-xl text-grey-4 inline-block view-text\" translate=\"cw.my_devices.view\"></span>\n            <span class=\"icon icon-grid-view icon-s icon-color inline-block v-middle crs-pointer\" ng-class=\"{'selected': devicesView === 'grid'}\" ng-click=\"gridView()\"></span>\n            <span class=\"icon icon-list-view icon-s icon-color inline-block v-middle crs-pointer\" ng-class=\"{'selected': devicesView === 'list'}\" ng-click=\"listView()\"></span>\n        </div>\n        <div ng-class=\"{'no-devices': !hasDevices}\">\n            <div ng-if=\"devicesView === 'grid'\" class=\"device-card-grid\" ng-class=\"{'increase-padding-top': !hasMinimumDevices}\">\n                <device-card></device-card>\n                <device-card source=\"onlineDevices\"></device-card>\n                <device-card source=\"offlineDevices\"></device-card>\n            </div>\n            <div ng-if=\"devicesView === 'list'\" class=\"device-card-list\">\n                <div class=\"text-xl text-grey-2 mb20\" translate=\"cw.my_devices.desktop_devices_label\"></div>\n                <device-card category=\"desktop\"></device-card>\n                <device-card source=\"onlineDesktopDevices\"></device-card>\n                <device-card source=\"offlineDesktopDevices\"></device-card>\n            </div>\n            <div ng-if=\"devicesView === 'list' && hasMobileDevices\" class=\"device-card-list\">\n                <div class=\"text-xl text-grey-2 mb20\" translate=\"cw.my_devices.mobile_devices_label\"></div>\n                <device-card category=\"mobile\"></device-card>\n                <device-card source=\"onlineMobileDevices\"></device-card>\n                <device-card source=\"offlineMobileDevices\"></device-card>\n            </div>\n            <div ng-if=\"devicesView === 'list' && !hasMobileDevices && $root.hasUsCompliance\" class=\"mobile-banner\">\n                <div class=\"text-xl text-grey-2 mb20 text-justify\" translate=\"cw.my_devices.mobile_devices_label\"></div>\n                <div class=\"mobile-banner-image\"></div>\n                <div class=\"mobile-banner-text\">\n                    <div class=\"mobile-banner-title text-grey-2\" translate=\"cw.my_devices.mobile_banner.title\"></div>\n                    <div class=\"mobile-banner-description text-super-light text-grey-3 list-padding\" translate=\"cw.my_devices.mobile_banner.description\" translate-values=\"{brandname : brandName}\"></div>\n                    <div class=\"mobile-banner-description text-grey-3 list-padding\" translate=\"cw.my_devices.mobile_banner.description\" translate-values=\"{brandname : brandName}\"></div>\n                </div>\n                <button class=\"mobile-banner-button btn-primary\" ng-click=\"deployOnCategory('mobile'); mixpanelBannerClick();\" translate=\"cw.my_devices.mobile_banner.button\"></button>\n            </div>\n        </div>\n    </div>\n    <cma-disclaimer ng-if=\"showCmaDisclaimer.banner\"></cma-disclaimer>\n</div>\n"

/***/ }),

/***/ "+ASY":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "+Tt2":
/***/ (function(module, exports) {

module.exports = "<div> <!-- Root element -->\n\n    <div class=\"card-header\" ng-if=\"!$root.hasSubscriptionOff\">\n        <h3 class=\"text-grey-1 text-l font-bold\" translate=\"cw.section.subscriptions.title\"></h3>\n        <a ng-if=\"!showDefault && !showExpiredLiceses\"\n            ui-sref=\"root.dashboard.subscriptions({tab: 'plans'})\"\n            class=\"text-s text-blue-1 top-link\"\n            translate=\"cw.homepage.general.see_more\"\n            ng-click=\"SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('See more')\"></a>\n        <a ng-if=\"!showDefault && showExpiredLiceses\"\n            ui-sref=\"root.dashboard.subscriptions({tab: 'plans'})\"\n            class=\"text-s text-blue-1 top-link\"\n            translate=\"cw.homepage.general.see_more\"\n            ng-click=\"SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('See more');SubscriptionsTimelineCtrl.setScrollToExpiredSubscriptions()\"></a>\n    </div>\n    <div ng-if=\"!$root.hasSubscriptionOff\">\n        <!-- Trials & active subscriptions -->\n        <div ng-repeat=\"license in licenses\" class=\"license-wrapper\" ng-if=\"showLiceses\">\n            <div>\n                <p class=\"font-bold text-s\" ng-class=\"{'mb5': !isBusinessProduct(license.activationCode)}\">{{license.appIntegration.attributes.resource.oeName || 'Avira'}}</p>\n                <!-- Subscription on -->\n                <div ng-if=\"license.activationCode.attributes.subscription === 1\">\n                    <a ui-sref=\"root.dashboard.subscriptions({tab: 'plans'})\" class=\"text-s text-blue-1 subscription-link\" ng-click=\"goToRenewalSettings();SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Manage renewal settings', '', 'Subscription on')\" translate=\"cw.homepage.subscriptions.manage\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                            <p translate=\"cw.subscriptions.cma.tooltip\"\n                            translate-values=\"{\n                                cancellation: '{{cancellationPolicy}}',\n                                contact: '{{contactUs}}'\n                            }\"></p>\n                        </div>\n                    </div>\n                </div>\n                <!-- End subscription on -->\n                <!-- Subscription off -->\n                <div ng-if=\"license.activationCode.attributes.subscription === 0 &&\n                    !checkStaticOTC(license.activationCode) &&\n                    !license.activationCode.removedPaymentOption &&\n                    !license.activationCode.isVoucherPurchase &&\n                    !isBusinessProduct(license.activationCode) &&\n                    !license.activationCode.attributes.has_partner_id &&\n                    !license.activationCode.attributes.expiringToday &&\n                    !$root.isMobileAppSession\">\n                    <a ng-click=\"SubscriptionsTimelineCtrl.subscriptionToggle(license.activationCode);SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Subscription off')\" class=\"text-s text-blue-1 crs-pointer subscription-link\" translate=\"cw.homepage.subscriptions.activate\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <p translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\"></p>\n                        </div>\n                    </div>\n                </div>\n                <!-- End subscription off -->\n                <!-- Card deleted -->\n                <div ng-if=\"license.activationCode.attributes.subscription === 0 && !checkStaticOTC(license.activationCode) && license.activationCode.removedPaymentOption && !$root.isMobileAppSession\">\n                    <a ng-href=\"{{cardDeletedRenewLink}}\"\n                    target=\"_blank\" ng-click=\"SubscriptionsTimelineCtrl.onRenewalClick(license.activationCode);SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Credit card deleted')\" class=\"text-s text-blue-1 crs-pointer subscription-link\" translate=\"cw.homepage.subscriptions.activate\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\"\n                        translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\">\n                        </div>\n                    </div>\n                </div>\n                <!-- End card deleted -->\n                <!-- Static OTC -->\n                <div ng-if=\"license.activationCode.attributes.subscription === 0 && checkStaticOTC(license.activationCode) && !license.activationCode.attributes.has_partner_id && !$root.isMobileAppSession\">\n                    <a ng-click=\"SubscriptionsTimelineCtrl.onRenewalClick(license);SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Static OTC')\" class=\"text-s text-blue-1 crs-pointer subscription-link\" ng-href=\"{{renewLink}}\" target=\"_blank\" translate=\"cw.homepage.subscriptions.activate\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <p translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\"></p>\n                        </div>\n                    </div>\n                </div>\n                <!-- End static OTC -->\n                <!-- Trial -->\n                <div ng-if=\"!license.activationCode && !$root.isMobileAppSession\">\n                    <a ng-click=\"SubscriptionsTimelineCtrl.onRenewalClick(license);SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Trial')\" class=\"text-s text-blue-1 crs-pointer subscription-link\" ng-href=\"{{renewLink}}\" target=\"_blank\" translate=\"cw.homepage.subscriptions.activate\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <p translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\"></p>\n                        </div>\n                    </div>\n                </div>\n                <!-- End Trial -->\n                <!-- Voucher -->\n                <div ng-if=\"license.activationCode.isVoucherPurchase && !$root.isMobileAppSession\">\n                    <a ng-href=\"{{cardDeletedRenewLink}}\"\n                    target=\"_blank\" ng-click=\"SubscriptionsTimelineCtrl.onRenewalClick(license.activationCode);SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Voucher')\" class=\"text-s text-blue-1 crs-pointer subscription-link\" translate=\"cw.homepage.subscriptions.activate\">\n                    </a>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <p translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\"></p>\n                        </div>\n                    </div>\n                </div>\n                <!-- End Voucher -->\n            </div>\n            <div>\n                <div class=\"text-s mb5\">\n                    <span class=\"uppercase text-grey-4\" translate=\"cw.homepage.subscriptions.subscription_status\"></span>\n                    <span class=\"text-green-1\" translate=\"cw.homepage.subscriptions.active\"></span>\n                </div>\n                <div class=\"text-s\">\n                    <span class=\"uppercase text-grey-4\" translate=\"cw.homepage.subscriptions.renewal_status\"></span>\n                    <span class=\"text-green-1\" ng-if=\"license.activationCode.attributes.subscription === 1\" translate=\"cw.homepage.subscriptions.active\"></span>\n                    <span class=\"text-red-1\" ng-if=\"license.activationCode.attributes.subscription === 0 || !license.activationCode\" translate=\"cw.homepage.subscriptions.inactive\"></span>\n                </div>\n            </div>\n        </div><!-- End trials & active subscriptions -->\n        <!-- Expired subscriptions -->\n        <div ng-if=\"showExpiredLiceses\">\n            <div class=\"text-center mb20\">\n                <div class=\"icon-warning-light v-middle\"></div>\n                <div class=\"inline-block v-middle text-left\">\n                    <p class=\"text-s text-grey-3\" translate=\"cw.homepage.subscriptions.expired_desc_1\"></p>\n                    <p class=\"text-s text-grey-3\" translate=\"cw.homepage.subscriptions.expired_desc_2\"></p>\n                </div>\n            </div>\n            <div class=\"license-wrapper\">\n                <div>\n                    <p class=\"font-bold text-s mb5\">{{firstExpiredLicense.appIntegration.attributes.resource.oeName || 'Avira'}}</p>\n                    <a ng-if=\"!$root.isMobileAppSession\" ui-sref=\"root.dashboard.store\" class=\"text-s text-blue-1 crs-pointer top-link\" ng-click=\"SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Go to store', '', 'Expired')\" translate=\"cw.homepage.subscriptions.go_to_store\"></a>\n                </div>\n                <div>\n                <div class=\"text-s mb5\">\n                        <span class=\"uppercase text-grey-4\" translate=\"cw.homepage.subscriptions.subscription_status\"></span>\n                        <span class=\"text-red-1\" translate=\"cw.homepage.subscriptions.inactive\"></span>\n                    </div>\n                    <div class=\"text-s\">\n                        <span class=\"uppercase text-grey-4\" translate=\"cw.homepage.subscriptions.renewal_status\"></span>\n                        <span class=\"text-red-1\" translate=\"cw.homepage.subscriptions.inactive\"></span>\n                    </div>\n                </div>\n            </div>\n        </div><!-- End expired subscriptions -->\n        <!-- No active or expired subscriptions -->\n        <div ng-if=\"showDefault\">\n            <div class=\"inline-block left-column text-center v-top\">\n                <div class=\"subscription-icon\"></div>\n            </div>\n            <div class=\"inline-block right-column v-middle\">\n                <h4 class=\"text-xl text-grey-1 mb5\" translate=\"cw.homepage.subscriptions.no_subscription_title\"></h4>\n                <p class=\"text-s text-grey-3 mb5\" translate=\"cw.homepage.subscriptions.no_subscription_desc\" translate-values=\"{brandname : brandName}\"></p>\n            </div>\n            <div class=\"text-right mt5\">\n                <a ng-if=\"!$root.isMobileAppSession\" ui-sref=\"root.dashboard.store\" class=\"text-s text-blue-1 bottom-link\"\n                    ng-click=\"SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Go to store', '', 'Free')\" translate=\"cw.homepage.subscriptions.go_to_store\">\n                </a>\n            </div>\n        </div><!-- End no active or expired v -->\n    </div>\n\n    <!-- Subscription off for ROW-->\n    <div ng-if=\"$root.hasSubscriptionOff\">\n        <div class=\"subscription-off\">\n            <i class=\"icon icon-expire-license\"></i>\n            <p class=\"mt5 text-m mb10\"\n                translate=\"cw.homepage.subscriptions.subscription_off\"\n                translate-values=\"{product: '<span>' + firstUnsubscribedLicense.productName + '</span>'}\">\n            </p>\n            <a  ng-if=\"!$root.isMobileAppSession\"\n                class=\"btn btn-medium btn-orange text-m ml25\"\n                translate=\"cw.subscriptions.cma.activate\"\n                ng-click=\"SubscriptionsTimelineCtrl.subscriptionToggle(firstUnsubscribedLicense.activationCode); SubscriptionsTimelineCtrl.sendSubscriptionsMixpanel('Activate renewal subscription', '', 'Subscription off')\"></a>\n\n            <div class=\"info-tooltip-holder inline-block v-middle\">\n                <i class=\"icon icon-info text-blue-1\"></i>\n                <div class=\"info-tooltip arrow-left subscription-notification\">\n                    <p translate=\"cw.subscriptions.cma.tooltip\"\n                        translate-values=\"{\n                            cancellation: '{{cancellationPolicy}}',\n                            contact: '{{contactUs}}'\n                        }\">\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div><!-- End Root element -->"

/***/ }),

/***/ "+Vki":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

/**
 * Expired licenses Processor - Expired licenses sorted by expiration date
 */

var processedExpiredLicenses = [];
var observableProcessedExpiredLicenses = new Rx.BehaviorSubject(processedExpiredLicenses);

/**
* @ngdoc service
* @name processors.ExpiredLicensesProcessor
*
* @description
* This class is used to process expired licenses.
*/

var ExpiredLicensesProcessor = {

    /**
     * Replace all expired licenses with received data
     * @param {Array} data
     */
    onNext: function onNext(data) {

        processedExpiredLicenses = [];

        processedExpiredLicenses = data.sort(this.sortExpiredLicenses);

        observableProcessedExpiredLicenses.onNext(processedExpiredLicenses);
    },


    /**
     * Sort expired licenses by expiration date
     * @param {Array} data
     */
    sortExpiredLicenses: function sortExpiredLicenses(currentLicenseInArray, nextLicenseInArray) {

        if (moment(currentLicenseInArray.attributes.expiration_date) >= moment(nextLicenseInArray.attributes.expiration_date)) {

            return -1;
        }

        return 1;
    },


    /**
     * @ngdoc function
     * @name processors.ExpiredLicensesProcessor#getAll
     * @methodOf processors.ExpiredLicensesProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed expired licenses.
     *
     * @returns {Array} all processed expired licenses
     */
    getAll: function getAll() {

        return processedExpiredLicenses;
    },


    /**
    * @ngdoc function
    * @name processors.ExpiredLicensesProcessor#getObservable
    * @methodOf processors.ExpiredLicensesProcessor
    * @function
    *
    * @description
    * This function can be used to get an observable object for processed expired licenses.
    * @returns {Object} an observable object for processed expired licenses.
    */
    getObservable: function getObservable() {

        return observableProcessedExpiredLicenses;
    }
};

var subjectExpiredLicensesRepository = _index.ExpiredLicensesRepository.getObservable();

subjectExpiredLicensesRepository.subscribe(function (data) {
    return ExpiredLicensesProcessor.onNext(data);
}, function () {}, function () {});

exports.default = ExpiredLicensesProcessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "+Z+8":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "+blg":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-phone-numbers\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.phone_numbers.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"phone in phoneNumbers.entries track by $index\">\n                            <div class=\"col-1 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\" ng-if=\"$index === 0\"\n                                    translate=\"cw.dwm.entity.phone_numbers.primary_phone\"></p>\n                                <p class=\"text-grey-3 text-l\" ng-if=\"$index > 0\"\n                                    translate=\"cw.dwm.entity.phone_numbers.phone\" translate-values=\"{index : $index + 1}\"></p>\n                            </div>\n                            <div class=\"col-phone col-text text-left\">\n                                <p class=\"text-grey-1 text-l\" ng-if=\"!phone.showUpdateInput\">+{{phone.countryCallingCode}} {{phone.phoneNumber}}</p>\n                                <div ng-if=\"phone.showUpdateInput\">\n                                    <div class=\"phone-number-selection\">\n                                        <div country-selector class=\"country-selector\" selected-device=\"selectedDevice\"\n                                            input-error=\"$root.phoneNumberErrorDWM\"></div>\n                                    </div>\n                                    <p class=\"error-message\" ng-show=\"$root.phoneNumberErrorDWM && !phoneExistsError\"\n                                        translate=\"cw.dwm.entity.phone_numbers.invalid_phone_number\"></p>\n                                    <p class=\"error-message\" ng-show=\"$root.phoneNumberErrorDWM && phoneExistsError\"\n                                        translate=\"cw.dwm.dupliacte_entry_error\"></p>\n                                </div>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!phone.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span>\n                                {{ $index > 0 ? '/' : '' }}\n                                <span class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\" ng-if=\"$index > 0\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-1 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.phone_numbers.phone\" translate-values=\"{index: phoneNumbers.entries.length + 1}\"></p>\n                            </div>\n\n                            <div class=\"col-2 col-text col-phone text-left\">\n                                <div class=\"phone-number-selection\">\n                                    <div country-selector class=\"country-selector\" selected-device=\"selectedDevice\"\n                                        input-error=\"$root.phoneNumberErrorDWM\"></div>\n\n                                </div>\n                                <p class=\"error-message\" ng-show=\"$root.phoneNumberErrorDWM && !phoneExistsError\"\n                                    translate=\"cw.dwm.entity.phone_numbers.invalid_phone_number\"></p>\n                                <p class=\"error-message\" ng-show=\"$root.phoneNumberErrorDWM && phoneExistsError\"\n                                        translate=\"cw.dwm.dupliacte_entry_error\"></p>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.phone_numbers.remove_phone_number_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.phone_numbers.remove_phone_number_desc\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.phone_numbers.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.phone_numbers.entity_details.desc_1\"></p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.phone_numbers.entity_details.desc_2\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\"\n                ng-if=\"showAddNewButton && (phoneNumbers.maxCount > phoneNumbers.entries.length)\" ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewPhoneIsLoading}\"\n                    ng-disabled=\"saveNewPhoneIsLoading\" ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading\" ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/phone-numbers/phone-numbers.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "+d4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),

/***/ "+htc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateLogger = exports.mixpanelLogger = exports.socketLogger = exports.httpLogger = undefined;

var _createLogger = __webpack_require__("MwII");

var _createLogger2 = _interopRequireDefault(_createLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generalLogger = (0, _createLogger2.default)({ prefix: 'General', prefixColor: '#FFDC00' });
var socketLogger = (0, _createLogger2.default)({ prefix: 'Socket', prefixColor: '#7FDBFF' });
var httpLogger = (0, _createLogger2.default)({ prefix: 'HTTP', prefixColor: '#0074D9' });
var mixpanelLogger = (0, _createLogger2.default)({ prefix: 'Mixpanel', prefixColor: '#eb7ab1' });
var stateLogger = (0, _createLogger2.default)({ prefix: 'Routing', prefixColor: '#444' });

exports.default = generalLogger;
exports.httpLogger = httpLogger;
exports.socketLogger = socketLogger;
exports.mixpanelLogger = mixpanelLogger;
exports.stateLogger = stateLogger;

/***/ }),

/***/ "+l76":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _i18next = __webpack_require__("J7wN");

var _i18next2 = _interopRequireDefault(_i18next);

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("fIlE");

var _RFC6 = _interopRequireDefault(_RFC5);

var _index2 = __webpack_require__("eyBl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.AppNotifications
*
* @description
* This class is used to process notifications on apps.
*/
/* eslint max-len: 0 */

var AppNotifications = {

    /**
     * @ngdoc function
     * @name notifications.AppNotifications#processUpdate
     * @methodOf notifications.AppNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on a app.
     *
     * @param {object} data an object with updated values on app.
    */
    processUpdate: function processUpdate(data, instance) {

        var device = _index.DevicesRepository.getById(_RFC6.default.deepFind(instance, 'relationships.device.data.id'));
        var appIntegration = _index.AppIntegrationsRepository.getById(instance.relationships.app.data.id);

        if (device) {

            if (data['attributes.state'] === 'active') {

                _RFC4.default.send('ConnectWeb Alert Triggered', {
                    'Alert Type': 'Success',
                    'Alert Name': _RFC6.default.deepFind(appIntegration, 'attributes.resource.oeName') + ' Installed'
                });

                _RFC2.default.success({
                    message: 'cw.app.install.success',
                    icon: {
                        cssClasses: 'icon-' + _RFC6.default.deepFind(device, 'attributes.type')
                    }
                }, {
                    message: {
                        appName: _RFC6.default.deepFind(appIntegration, 'attributes.resource.oeName'),
                        deviceName: (0, _index2.FilterDeviceName)(device)
                    }
                });
            }

            // Antivirus module(s) deactivated
            var deactivatedModules = this._getDeactivatedModules(data);
            if (deactivatedModules.length === 1) {

                // module was deactivated
                _RFC2.default.warning({
                    message: 'cw.service.antivirus.module.off',
                    icon: {
                        cssClasses: 'icon-warning-filled'
                    }
                }, {
                    message: {
                        deviceName: (0, _index2.FilterDeviceName)(device),
                        moduleName: deactivatedModules[0]
                    }
                });
            } else if (deactivatedModules.length > 1) {

                // modules were deactivated
                _RFC2.default.warning({
                    message: 'cw.service.antivirus.modules.off',
                    icon: {
                        cssClasses: 'icon-warning-filled'
                    }
                }, {
                    message: {
                        deviceName: (0, _index2.FilterDeviceName)(device),
                        modulesNames: deactivatedModules.join(', ')
                    }
                });
            }

            // Antivirus module(s) activated
            var activatedModules = this._getActivatedModules(data);
            if (activatedModules.length === 1) {

                // module was activated
                _RFC2.default.info({
                    message: 'cw.service.antivirus.module.on',
                    icon: {
                        cssClasses: 'icon-info'
                    }
                }, {
                    message: {
                        deviceName: (0, _index2.FilterDeviceName)(device),
                        moduleName: activatedModules[0]
                    }
                });
            } else if (activatedModules.length > 1) {

                // modules were activated
                _RFC2.default.info({
                    message: 'cw.service.antivirus.modules.on',
                    icon: {
                        cssClasses: 'icon-info'
                    }
                }, {
                    message: {
                        deviceName: (0, _index2.FilterDeviceName)(device),
                        modulesNames: activatedModules.join(', ')
                    }
                });
            }

            // Antivirus modules are activated
            if (data['attributes.app_status'] === 'protected') {

                // all modules were activated
                _RFC2.default.success({
                    message: 'cw.service.antivirus.secured',
                    icon: {
                        imageUrl: (0, _index2.FilterImageUrlParse)(appIntegration.attributes.resource.wsLargeImageUrl)
                    }
                }, {
                    message: {
                        deviceName: (0, _index2.FilterDeviceName)(device)
                    }
                });
            }
        }
    },
    _getDeactivatedModules: function _getDeactivatedModules(data) {

        var deactivatedModules = [];

        if (data['attributes.status.svc.guard'] && (+data['attributes.status.svc.guard'] === 2 || +data['attributes.status.svc.guard'] === 4)) {

            // guard was deactivated
            deactivatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.guard.name'));
        }

        if (data['attributes.status.svc.firewall'] && (+data['attributes.status.svc.firewall'] === 2 || +data['attributes.status.svc.firewall'] === 4)) {

            // guard was deactivated
            deactivatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.firewall.name'));
        }

        if (data['attributes.status.svc.mailguard'] && (+data['attributes.status.svc.mailguard'] === 2 || +data['attributes.status.svc.mailguard'] === 4)) {

            // mailguard was deactivated
            deactivatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.mailguard.name'));
        }

        if (data['attributes.status.svc.webguard'] && (+data['attributes.status.svc.webguard'] === 2 || +data['attributes.status.svc.webguard'] === 4)) {

            // webguard was deactivated
            deactivatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.webguard.name'));
        }

        return deactivatedModules;
    },
    _getActivatedModules: function _getActivatedModules(data) {

        var activatedModules = [];

        if (data['attributes.status.svc.guard'] && +data['attributes.status.svc.guard'] === 3) {

            // guard was activated
            activatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.guard.name'));
        }

        if (data['attributes.status.svc.firewall'] && +data['attributes.status.svc.firewall'] === 3) {

            // guard was activated
            activatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.firewall.name'));
        }

        if (data['attributes.status.svc.mailguard'] && +data['attributes.status.svc.mailguard'] === 3) {

            // mailguard was activated
            activatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.mailguard.name'));
        }

        if (data['attributes.status.svc.webguard'] && +data['attributes.status.svc.webguard'] === 3) {

            // webguard was activated
            activatedModules.push(_i18next2.default.t('cw.dashboard.services.windows.antivirus.webguard.name'));
        }

        return activatedModules;
    },


    /**
     * @ngdoc function
     * @name notifications.AppNotifications#processDelete
     * @methodOf notifications.AppNotifications
     * @function
     *
     * @description
     * This function can be used to process removed app.
     *
     * @param {object} instance removed app.
    */
    processDelete: function processDelete(instance) {

        var device = _index.DevicesRepository.getById(_RFC6.default.deepFind(instance, 'relationships.device.data.id'));
        var appIntegration = _index.AppIntegrationsRepository.getById(instance.relationships.app.data.id);

        if (device) {

            _RFC2.default.info({
                message: 'cw.app.remove.success',
                icon: {
                    cssClasses: 'icon-remove'
                }
            }, {
                message: {
                    appName: _RFC6.default.deepFind(appIntegration, 'attributes.resource.oeName'),
                    deviceName: (0, _index2.FilterDeviceName)(device)
                }
            });
        }
    }
};

exports.default = AppNotifications;

/***/ }),

/***/ "+quY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$filter'];

var _$scope = void 0;
var _$filter = void 0;
// let _Util;

var LastDeviceDetailsController = function () {
    function LastDeviceDetailsController($scope, $state, $filter) {
        _classCallCheck(this, LastDeviceDetailsController);

        _$scope = $scope;
        _$filter = $filter;
        _$scope.licenses = _index.LicensesRepository.getAll();
        _$scope.activationCodes = _index.ActivationCodesRepository.getAll();
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        var devicesObservable = _index.DevicesRepository.getObservable();

        devicesObservable.subscribe(this.onNextDevice, function () {}, function () {});

        $scope.deployOnCategory = function (category) {

            $state.go('root.dashboard.home.ltb.deploy', {
                ltb: 'deploy',
                resourceId: 'new',
                deviceCategory: category
            }, {
                reload: false
            });

            $scope.sendDevicesMixpanel('Add Device');
        };

        $scope.sendDevicesMixpanel = function (buttonLabel) {

            _RFC2.default.send('ConnectWeb Home Click', {
                Label: 'My devices',
                'Button label': buttonLabel
            });
        };
    }

    _createClass(LastDeviceDetailsController, [{
        key: 'onNextDevice',
        value: function onNextDevice() {

            var devices = _index.DevicesRepository.getVisibleDevices();
            if (devices.length > 0) {

                var processedDevice = void 0;
                var latestDate = devices.map(function (e) {
                    return e.attributes.date_added;
                }).sort().reverse()[0];
                _$scope.devicesLength = devices.length;

                var lastDeviceAdded = devices.find(function (device) {
                    return device.attributes.date_added === latestDate;
                });
                lastDeviceAdded.name = _$filter('deviceName')(lastDeviceAdded);

                var device = [];
                device[0] = lastDeviceAdded;
                processedDevice = _index2.DevicesProcessor.detectLicenseType(device);
                processedDevice = _index2.DevicesProcessor.detectFreeProducts(processedDevice);

                var _processedDevice = processedDevice;

                var _processedDevice2 = _slicedToArray(_processedDevice, 1);

                _$scope.lastDeviceAdded = _processedDevice2[0];
            }
        }
    }]);

    return LastDeviceDetailsController;
}();

var LastDeviceDetailsDirective = function LastDeviceDetailsDirective() {
    _classCallCheck(this, LastDeviceDetailsDirective);

    this.template = __webpack_require__("kdEy");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $filter) {
        return new LastDeviceDetailsController($scope, $state, $filter);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'lastDeviceDetailsCtrl';
};

_directiveDependencies.push(function () {
    return new LastDeviceDetailsDirective();
});

angular.module('directives').directive('lastDeviceDetails', _directiveDependencies);

/***/ }),

/***/ "+v36":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$scope', 'Util', 'UserRestService', 'Auth'];

var _Util = void 0;
var _UserRestService = void 0;
var _user = void 0;
var _$scope = void 0;
var _$rootScope = void 0;
var _confirmCode = void 0;
var _Auth = void 0;

/**
 * @ngdoc service
 * @name controllers.ChangeEmailModal
 *
 * @description
 * Crop Image controller
 */

var ChangeEmailModal = function () {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} Util
     * @param  {any} UserRestService
     */
    function ChangeEmailModal($rootScope, $scope, Util, UserRestService, Auth) {
        _classCallCheck(this, ChangeEmailModal);

        _Util = Util;
        _UserRestService = UserRestService;
        _user = _index.MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;
        _$scope.Recaptcha = _recaptcha2.default;
        _Auth = Auth;

        _$scope.submitted = false;
        _$scope.loading = false;
        _$scope.expiredCode = false;
        _$scope.requestsExceeded = false;

        // $scope assigned functions
        _$scope.onSubmit = this.onSubmit;
        _$scope.closeModal = this.closeModal;
        _$scope.resendEmail = this.resendEmail;
        _$scope.setCaptchaResponse = this.setCaptchaResponse;
        _confirmCode = this.confirmCode;

        // if there is no email value, close modal
        if (!$rootScope.changeEmail) {

            this.closeModal();
        }

        // delete changeEmail object when $scope is destroyed
        _$scope.$on('$destroy', function () {

            delete $rootScope.changeEmail;
            delete $rootScope.passwordConfirmationFor;
        });
    }

    _createClass(ChangeEmailModal, [{
        key: 'confirmCode',
        value: function confirmCode() {
            var _this = this;

            var headers = {};

            var captchaRespose = _$scope.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            var payload = {
                data: {
                    id: _user.id,
                    attributes: {
                        email: _$rootScope.changeEmail.newEmail
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: _user.relationships.partner.data.type,
                                id: _user.relationships.partner.data.id
                            }
                        }
                    },
                    type: _user.type
                },
                meta: {
                    change_email_code: this.confirmCodeForm.code.$viewValue,
                    password: _$rootScope.changeEmail.kp
                }
            };

            /* if captcha is required and there is no captcha response available,
                   trigger alert and stop login process */
            if (_$scope.captchaRequired && !_$scope.captchaRespose) {

                _Util.triggerAnimation('#error-message-captcha', 'animated shake');
                return;
            }

            _$scope.submitted = true;
            _$scope.loading = true;

            this.confirmCodeForm.code.$setValidity('serverValidation', true);

            var formIsValid = this.confirmCodeForm.$valid;

            if (formIsValid) {

                // send the payload with the PUT update user method
                _UserRestService.update(_user.id, payload, headers).then(function () {

                    _RFC4.default.send('ConnectWeb Change Email Success');

                    _this.closeModal();

                    _$scope.loading = false;
                    _$scope.expiredCode = false;
                    _$scope.requestsExceeded = false;
                    _Auth.logOut();
                }).then(null, function (error) {

                    var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                    _$scope.loading = false;

                    switch (errorCode) {

                        // invalid email code
                        case '21117':

                            _this.confirmCodeForm.code.$setValidity('serverValidation', false);

                            break;

                        // expired code case
                        case '21119':

                            _$scope.expiredCode = true;

                            break;

                        case '21120':

                            _$scope.requestsExceeded = true;

                            break;

                        // captcha is required
                        case '918':

                            _$scope.Recaptcha.execute();
                            break;

                        case '21127':
                            _this.confirmCodeForm.code.$setValidity('serverValidation', false);
                            break;

                        default:

                            _RFC2.default.error('cw.account.details.messages.error');

                    }

                    _Util.triggerAnimation('.error', 'animated shake');
                });
            } else {

                _$scope.loading = false;
                _Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'resendEmail',
        value: function resendEmail() {

            var payload = {
                data: {
                    id: _user.id,
                    attributes: {
                        email: _$rootScope.changeEmail.newEmail
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: _user.relationships.partner.data.type,
                                id: _user.relationships.partner.data.id
                            }
                        }
                    },
                    type: _user.type
                },
                meta: {
                    language: CWCONFIG.language,
                    password: _$rootScope.changeEmail.kp
                }
            };

            _UserRestService.update(_user.id, payload).then(function () {}).then(null, function (error) {

                var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                switch (errorCode) {

                    case '21118':

                        _RFC2.default.success('cw.deploy.got.mail.title');

                        break;

                    default:

                        _RFC2.default.error('cw.notification.sendEmail.error');

                }
            });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            if (_$scope.Recaptcha.isCaptchaRequired()) {

                _$scope.Recaptcha.execute();
            } else {

                var _confirmCodeBind = _confirmCode.bind(this);
                _confirmCodeBind();
            }
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {

            _Util.closeModal();
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            _$scope.Recaptcha.setCaptchaResponse(response);
            var _confirmCodeBind = _confirmCode.bind(this);
            _confirmCodeBind();
        }
    }]);

    return ChangeEmailModal;
}();

_serviceDependencies.push(ChangeEmailModal);

angular.module('controllers').controller('ChangeEmailModal', _serviceDependencies);

/***/ }),

/***/ "/+00":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Integrations Processor
 */

var AppIntegrationsProcessor = {

    /**
     * Checks if the appintegration received
     * is bundle and contains more than one app and browsers extensions
     * Also check if the received os matched the app supported os
     * @param {any} AppIntegration AppIntegration
     * @param {any} os os
     *
     */
    checkIfTrueBundle: function checkIfTrueBundle(AppIntegration, os) {

        if (AppIntegration.attributes.type === 'bundle') {

            var bundleApps = _RFCUtil2.default.deepFind(AppIntegration, 'relationships.apps.data');

            var filteredBundleApps = bundleApps.filter(function (bundleApp) {

                var appData = _index.AppIntegrationsRepository.getById(bundleApp.id);

                // check if the bundle app is not a browser extension
                var isNotBrowserExtension = !_RFCUtil2.default.deepFind(appData, 'attributes.custom.manifest.browsers');

                var bundleAppOS = _RFCUtil2.default.deepFind(appData, 'attributes.custom.manifest.os') || ['windows'];
                // check if received os is supported by the app
                var matchesOs = bundleAppOS.indexOf(os) > -1;

                return isNotBrowserExtension && matchesOs;
            });

            return filteredBundleApps.length > 1;
        }

        return false;
    }
};

exports.default = AppIntegrationsProcessor;

/***/ }),

/***/ "//V8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$http', '$q', 'Util'];
/**
 * @ngdoc service
 * @name rest.services.BaseRestService
 *
 * @description
 * This class contains generic methods for the REST services.
 */

var BaseRestService = function () {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function BaseRestService($http, $q, Util) {
        _classCallCheck(this, BaseRestService);

        this.$http = $http;
        this.Util = Util;
        this.$q = $q;
    }

    /**
     * @ngdoc function
     * @name rest.services.BaseRestService#create
     * @methodOf rest.services.BaseRestService
     * @function
     *
     * @description
     * Creates a resource
     *
     * @param {object} payload Resource payload
     * @param {string} path API Resource path
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(BaseRestService, [{
        key: 'create',
        value: function create(payload, path, extraHeaders) {

            var headers = this.getDefaultHeaders(extraHeaders);

            return this.$http({
                method: 'POST',
                url: '' + CWCONFIG.restApi.url + path,
                data: payload || {},
                timeout: CWCONFIG.timeouts.httpTimeout,
                headers: headers
            });
        }

        /**
         * @ngdoc function
         * @name rest.services.BaseRestService#post
         * @methodOf rest.services.BaseRestService
         * @function
         *
         * @description
         * Creates a resource
         *
         * @param {object} payload Resource payload
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'post',
        value: function post(payload, path, extraHeaders) {

            var headers = this.getDefaultHeaders(extraHeaders);

            return this.$http({
                method: 'POST',
                url: CWCONFIG.restApi.url + path,
                data: payload || {},
                timeout: CWCONFIG.timeouts.httpTimeout,
                headers: headers
            });
        }

        /**
         * @ngdoc function
         * @name rest.services.BaseRestService#update
         * @methodOf rest.services.BaseRestService
         * @function
         *
         * @description
         * Updates a resource
         *
         * @param {string} resourceId Resource identifier
         * @param {object} payload Resource payload
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(resourceId, payload, path, extraHeaders) {

            var headers = this.getDefaultHeaders(extraHeaders);

            return this.$http({
                method: 'PUT',
                url: '' + CWCONFIG.restApi.url + path + (resourceId || ''),
                timeout: CWCONFIG.timeouts.httpTimeout,
                data: payload || {},
                headers: headers
            });
        }

        /**
         * @ngdoc function
         * @name rest.services.BaseRestService#remove
         * @methodOf rest.services.BaseRestService
         * @function
         *
         * @description
         * Remove a resource
         *
         * @param {string} resourceId Resource identifier
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'remove',
        value: function remove(resourceId, path, extraHeaders) {

            var headers = this.getDefaultHeaders(extraHeaders);

            return this.$http({
                method: 'DELETE',
                timeout: CWCONFIG.timeouts.httpTimeout,
                url: '' + CWCONFIG.restApi.url + path + resourceId,
                data: {},
                headers: headers
            });
        }

        /**
         * @ngdoc function
         * @name rest.services.BaseRestService#getAllAsync
         * @methodOf rest.services.BaseRestService
         * @function
         *
         * @description
         * Retrieves resources from the backend.
         *
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync(path) {
            var _this = this;

            var nextLinkAttr = 'data.links.next';

            var requestResponse = void 0;
            var requestDeferred = this.$q.defer();

            var concatResponseData = function concatResponseData(response) {

                if (!requestResponse) {

                    requestResponse = response;
                } else {

                    if (requestResponse.data.data) {

                        requestResponse.data.data = requestResponse.data.data.concat(response.data.data);
                    }

                    if (requestResponse.data.included) {

                        requestResponse.data.included = requestResponse.data.included.concat(response.data.included);
                    }
                }
            };

            var loadNextResourcesAsync = function loadNextResourcesAsync(nextUrl) {

                var resourcesDeferred = _this.$q.defer();

                var loadNextResource = function loadNextResource(resource) {

                    if (resource) {

                        _this._getResourceAsync(resource).then(function (response) {

                            concatResponseData(response);
                            loadNextResource(_this.Util.deepFind(response, nextLinkAttr));
                        }).then(null, function (error) {

                            resourcesDeferred.reject(error);
                        });
                    } else {

                        resourcesDeferred.resolve();
                    }
                };

                loadNextResource(nextUrl);

                return resourcesDeferred.promise;
            };

            var headers = this.getDefaultHeaders();

            this.$http({
                method: 'GET',
                url: '' + CWCONFIG.restApi.url + path,
                timeout: CWCONFIG.timeouts.httpTimeout,
                headers: headers
            }).then(function (response) {

                concatResponseData(response);

                loadNextResourcesAsync(_this.Util.deepFind(response, nextLinkAttr)).then(function () {

                    requestDeferred.resolve(requestResponse);
                }).then(null, function (error) {

                    requestDeferred.reject(error);
                });
            }).then(null, function (error) {

                requestDeferred.reject(error);
            });

            return requestDeferred.promise;
        }

        /**
         * @ngdoc function
         * @name rest.services.BaseRestService#getPageAsync
         * @methodOf rest.services.BaseRestService
         * @function
         *
         * @description
         * Retrieves a single page of resources from the backend.
         *
         * @param {string} path API Resource path
         * @param {string} pageLink The link to the requested page
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getPageAsync',
        value: function getPageAsync(path, pageLink) {

            var requestDeferred = this.$q.defer();

            if (!pageLink) {

                // first page
                pageLink = '' + CWCONFIG.restApi.url + path;
            }

            this._getResourceAsync(pageLink).then(function (response) {

                requestDeferred.resolve(response);
            }).then(null, function (error) {

                requestDeferred.reject(error);
            });

            return requestDeferred.promise;
        }
    }, {
        key: '_getResourceAsync',
        value: function _getResourceAsync(url) {

            var headers = this.getDefaultHeaders();

            return this.$http({
                method: 'GET',
                timeout: CWCONFIG.timeouts.httpTimeout,
                url: url,
                headers: headers
            });
        }
    }, {
        key: 'getDefaultHeaders',
        value: function getDefaultHeaders(extraHeaders) {

            var token = this.Util.getToken();
            var headers = {};

            // Check if the Authorization header is already set
            var authorizationHeader = this.Util.deepFind(extraHeaders, 'Authorization');
            if (!authorizationHeader) {

                headers = {
                    Authorization: token ? 'Bearer ' + token : 'Basic ' + this.Util.base64encode(CWCONFIG.oauthKey)
                };
            }

            if (typeof extraHeaders !== 'undefined') {

                headers = angular.extend(headers, extraHeaders);
            }

            return headers;
        }
    }]);

    return BaseRestService;
}();

BaseRestService.$inject = ['$http', '$q', 'Util'];
exports.default = BaseRestService;


_serviceDependencies.push(BaseRestService);

// angular.module('rest.services')
//     .service('BaseRestService', _serviceDependencies);

BaseRestService.$inject = ['$http', '$q', 'Util'];

angular.module('rest.services').service('BaseRestService', BaseRestService);

/***/ }),

/***/ "/37h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

/* eslint no-console: 0 */

/**
 * If on debug mode, add a global function which displays the number
 * bindings
 */
angular.module('debug').run(['$window', function ($window) {

    if (CWCONFIG.features.debug) {

        $window.countBindings = function () {

            var $ = angular.element;
            var root = $(document.getElementsByTagName('body'));
            var watchers = [];

            var f = function f(element) {

                var data = element.data();
                if (_.has(data, '$scope')) {

                    angular.forEach(data.$scope.$$watchers, function (watcher) {

                        watchers.push(watcher);
                    });
                }

                angular.forEach(element.children(), function (childElement) {

                    f($(childElement));
                });
            };

            f(root);
            console.log(watchers.length + ' bindings');
        };
    }
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "/6DI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('directives').directive('fancyCheckbox', function () {
    return {
        template: __webpack_require__("rkCg"),
        restrict: 'EA',
        replace: true,
        scope: {
            twoStepValidationCheckbox: '=ngModel',
            changeCallback: '&ngChange'
        },
        link: function link(scope, elem) {

            elem.bind('click', function () {

                scope.$apply(function () {

                    scope.twoStepValidationCheckbox = !scope.twoStepValidationCheckbox;
                    scope.changeCallback()(scope.twoStepValidationCheckbox);
                });
            });
        }
    };
});

/***/ }),

/***/ "/6Pw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var event = {};

/**
 * @description
 * Utility service to be reused across the application
 * to replace $rootScope.$emit, $rootScope.$on, $rootScope.$broadcast
 */
var eventManager = {

    eventsObservable: new Rx.BehaviorSubject(event),

    broadcast: function broadcast(newEvent, data, options) {

        this.eventsObservable.onNext({ newEvent: newEvent, data: data, options: options });
    },
    subscribe: function subscribe(eventName, callback) {

        this.eventsObservable.subscribe(function (_ref) {
            var newEvent = _ref.newEvent,
                data = _ref.data,
                options = _ref.options;


            if (newEvent === eventName) {

                callback(data, options);
            }
        });
    }
};

exports.default = eventManager;

/***/ }),

/***/ "/Up0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$window', 'Util'];

var OODiskimagePageController = function () {
    function OODiskimagePageController($scope, $window, Util) {
        _classCallCheck(this, OODiskimagePageController);

        this.$scope = $scope;
        this.$window = $window;
        this.$scope.userCountry = _index.MeRepository.getMyUser().attributes.country;
        this.navigator = Util.getDeviceNavigator();
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        _RFC2.default.send('ConnectWeb Store Open', {
            Source: 'Direct',
            Store: 'OO Diskimage Page'
        });
    }

    _createClass(OODiskimagePageController, [{
        key: 'buy',
        value: function buy() {

            _RFC2.default.send('ConnectWeb Store Buy Click', {
                'Product ID': 'odsk0',
                Page: 'OO Diskimage Store Page'
            });

            var eshopUrl = this.$scope.userCountry === 'US' || this.$scope.userCountry === 'CA' ? 'https://shop.avira.com/819/purl-oodi_30?x-a-source=cw' : 'https://shop.avira.com/30/purl-oodi_30?x-a-source=cw';

            if (this.navigator === 'ios') {

                this.$window.location.href = eshopUrl;
            } else {

                this.$window.open(eshopUrl, '_blank');
            }
        }
    }]);

    return OODiskimagePageController;
}();

var OODiskimagePageDirective = function OODiskimagePageDirective() {
    _classCallCheck(this, OODiskimagePageDirective);

    this.template = __webpack_require__("Q9rA");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $window, Util) {
        return new OODiskimagePageController($scope, $window, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'ooDiskimagePageCtrl';
};

_directiveDependencies.push(function () {
    return new OODiskimagePageDirective();
});

angular.module('directives').directive('ooDiskimagePage', _directiveDependencies);

/***/ }),

/***/ "/jWC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    angular.module('directives').directive('match', function () {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                match: '='
            },
            link: function link(scope, elem, attrs, ctrl) {

                scope.$watch(function () {

                    var modelValue = ctrl.$modelValue || ctrl.$$invalidModelValue;

                    return ctrl.$pristine && angular.isUndefined(modelValue) || scope.match === modelValue;
                }, function (currentValue) {

                    ctrl.$setValidity('match', currentValue);
                });
            }
        };
    });
})();

/***/ }),

/***/ "/nLZ":
/***/ (function(module, exports) {

module.exports = "<div class=\"compliance-error\">\n    <div class=\"text-center\">\n        <i class=\"icon-info-blue mb30\"></i>\n        <h1 class=\"text-xxxl mb20\" ng-if=\"!$root.showLoginTitle\" translate=\"cw.compliance_failed.title\"></h1>\n        <h1 class=\"text-xxxl mb20\" ng-if=\"$root.showLoginTitle\" translate=\"cw.compliance_failed.title_2\"></h1>\n        <p class=\"text-grey-3 text-xl mb30\" translate=\"cw.compliance_failed.desc\">\n        </p>\n        <p class=\"text-grey-3 text-xl mb10\" translate=\"cw.compliance_failed.reason_1\">\n        </p>\n        <p class=\"text-grey-3 text-xl\" translate=\"cw.compliance_failed.reason_2\">\n        </p>\n        <div class=\"mt50\" ng-if=\"showOkButton\">\n            <a class=\"btn btn-primary btn-medium\" ng-click=\"closeHtml()\" translate=\"cw.deploy.got.it\">\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "/nQq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('Dwm', ['$http', 'Util', '$scope', '$rootScope', '$state', '$location', '$anchorScroll', function ($http, Util, $scope, $rootScope, $state, $location, $anchorScroll) {

    var aviraToken = Util.getToken();

    $scope.loadingButton = false;

    $scope.appIntegration = _index.AppIntegrationsRepository.getById('adwp1') || {};
    $scope.currentTab = $state.params.tab || 'dwm';

    $rootScope.dwmResoucesStatuses = {
        token: 'loading',
        members: false,
        alerts: false
    };

    var user = _index.MeRepository.getMyUser();
    var userLanguage = Util.deepFind(user, 'attributes.language');

    $scope.isUserCountryUS = Util.deepFind(user, 'attributes.country') === 'US';

    $scope.currentTab = $state.params.tab || 'dwm';

    $scope.changeTab = function (tab) {

        $scope.currentTab = tab;
    };

    $scope.currentPrice = _index.AppPricesRepository.getSinglePrice('adwp1', '12', '1');

    $scope.onlineSurvey = 'https://www.nortonlifelock.com/ca/en/newsroom/press-kits/2021-norton-cyber-safety-insights-report/';
    $scope.personalData = userLanguage === 'de' ? 'https://www.avira.com/de/blog/daten-im-darknet-wieviel-ist-ihre-kreditkarte-wert' : 'https://www.avira.com/en/blog/data-and-the-dark-web-how-much-is-your-personal-data-worth';

    $rootScope.alertsActivePage = 1;

    $scope.toggleMontoring = function () {

        if ($scope.activateLicensePending) {

            return;
        }

        if ($scope.aiaSubscriptioneStatus === 'active' || $scope.dwmLiteSubscriptionStatus === 'active') {

            $state.go('root.dashboard.dwm.ltb', {
                ltb: 'toggle-monitoring',
                resourceId: 'monitoring'
            }, {
                reload: false
            });

            _RFC2.default.send('ConnectWeb AIA Monitoring Click', {
                'Button Label': 'Deactivate'
            });
        }

        if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

            $scope.activateLicensePending = true;

            _RFC2.default.send('ConnectWeb AIA Monitoring Click', {
                'Button Label': 'Activate'
            });

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.enrollURL,
                headers: {
                    Authorization: 'Bearer ' + aviraToken
                },
                data: {
                    clientApplication: {
                        clientId: 'myavira'
                    }
                }

            }).then(function () {

                if ($scope.aiaSubscriptionCancelled) {

                    $rootScope.dwmStatus.products.identityAssist.subscriptionStatus = 'active';
                    $rootScope.aiaSubscriptionCancelled = false;
                    $scope.aiaSubscriptionCancelled = false;
                }

                if ($scope.dwmLiteSubscriptionCancelled) {

                    $rootScope.dwmStatus.products.dwmLite.subscriptionStatus = 'active';
                    $rootScope.dwmLiteSubscriptionCancelled = false;
                    $scope.dwmLiteSubscriptionCancelled = false;
                }

                $rootScope.aiaStatusApiCall();

                $scope.activateLicensePending = false;
            }).catch(function (errResponse) {

                $scope.activateLicensePending = false;
                _RFC4.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });

                _RFC2.default.send('ConnectWeb AIA Error', {
                    Detail: 'activate',
                    ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                    ErrorMessage: errResponse.data ? errResponse.data.message : 'N/A',
                    ErrorDescription: errResponse.data ? errResponse.data.error_description : 'N/A',
                    ErrorTrackId: errResponse.data ? errResponse.data.trackId : 'N/A',
                    ErrorStatus: errResponse.data ? errResponse.data.status : 'N/A'
                });
            });
        }
    };

    var sendDashboardOpenEvent = function sendDashboardOpenEvent() {

        var monitoring = void 0;
        if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

            monitoring = 'Off';
        } else if ($scope.aiaSubscriptionActive || $scope.dwmLiteSubscriptionActive) {

            monitoring = 'On';
        }

        if ($scope.currentTab !== 'store') {

            _RFC2.default.send('ConnectWeb AIA Dashboard Open', {
                Tab: $scope.currentTab,
                'AIA Version': $rootScope.showDWMLiteStrippedDashboard || $rootScope.showDWMLiteUpsellDashboard ? 'DWM Lite' : 'AIA',
                'AIA Monitoring': monitoring
            });
        }
    };

    if ($scope.currentTab === 'faq') {

        sendDashboardOpenEvent();
    }

    Promise.allSettled = function (promises) {

        var mappedPromises = promises.map(function (p) {
            return p.then(function (value) {
                return {
                    status: 'fulfilled',
                    value: value
                };
            }).catch(function (reason) {
                return {
                    status: 'rejected',
                    reason: reason
                };
            });
        });
        return Promise.all(mappedPromises);
    };

    var getDarkWebMonitorData = function getDarkWebMonitorData() {

        if ($scope.showUpsellPageFlag) {

            return;
        }

        $http({
            method: 'POST',
            url: CWCONFIG.dwm.restApi + '/v1/auth/tokensByPartnerToken',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                'Content-Type': 'application/json'
            },
            data: {
                partner_token: aviraToken
            }

        }).then(function (response) {

            $rootScope.dwmNortonToken = response.data.access_token;
            $rootScope.dwmResoucesStatuses.token = 'loaded';
            $rootScope.dwmResoucesStatuses.members = 'loading';
            $rootScope.dwmResoucesStatuses.alerts = 'loading';

            var assetsPromise = $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                if ($scope.aiaSubscriptionActive) {
                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;


                    _RFC2.default.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);
                    _RFC2.default.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);
                    _RFC2.default.setCommonProperty('AIA Asset Mothers Name', monitoredAccounts.mothersMaidenName.entries.length);

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    }
                } else if ($scope.dwmLiteSubscriptionActive) {

                    _RFC2.default.setCommonProperty('AIA Asset Email', 1);
                }

                $rootScope.dwmResoucesStatuses.members = 'loaded';
                $scope.loadingButton = false;
                var email = user.attributes.email;
                var primaryEmail = membersResponse.data.primaryMember.primaryEmail;


                if (email !== primaryEmail.emailAddress) {

                    var payloadEmail = {
                        primaryEmail: {
                            emailAddress: email,
                            type: 'OTHER'
                        }
                    };

                    $http({
                        method: 'PUT',
                        url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json'
                        },
                        data: payloadEmail
                    }).then(function () {

                        $http({
                            method: 'GET',
                            url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                            headers: {
                                client_id: 'avira',
                                origin: 'https://avira.com',
                                access_token: $rootScope.dwmNortonToken,
                                'Content-Type': 'application/json'
                            }

                        }).then(function (membersEmailResponse) {

                            _index.dwmRepository.replace('assets', membersEmailResponse.data);
                            $rootScope.dwmResoucesStatuses.members = 'loaded';
                            $scope.loadingButton = false;
                        }).catch(function () {

                            $rootScope.dwmResoucesStatuses.members = 'error';
                            $scope.loadingButton = false;

                            _RFC4.default.error('cw.modal.server-error.desc');
                        });
                    }).catch(function () {

                        _RFC4.default.error('cw.modal.server-error.desc');
                    });
                } else {

                    _index.dwmRepository.replace('assets', membersResponse.data);
                    $rootScope.dwmResoucesStatuses.members = 'loaded';
                    $scope.loadingButton = false;
                }

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/piiFieldRules?countryCode=' + 'DE',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (validationResponse) {

                    _index.dwmRepository.replace('validation', validationResponse.data);
                }).catch(function () {

                    $rootScope.dwmResoucesStatuses.members = 'loading';
                    _RFC4.default.error('cw.modal.server-error.desc');
                });
            }).catch(function (errResponse) {

                $rootScope.dwmResoucesStatuses.members = 'loading';
                $scope.loadingButton = false;

                _RFC4.default.error('cw.modal.server-error.desc');

                _RFC2.default.send('ConnectWeb AIA Error', {
                    Detail: 'members',
                    ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A'
                });
            });

            var alertsPromise = $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/alerts',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                    lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US'
                }

            }).then(function (alertsResponse) {

                _index.dwmRepository.replace('alerts', alertsResponse.data);
                $rootScope.dwmResoucesStatuses.alerts = 'loaded';

                var aiaUnreadAlerts = 0;
                var aiaReadAlerts = 0;

                if (alertsResponse.data.alertList.length > 0) {

                    alertsResponse.data.alertList.forEach(function (alert) {

                        if (alert.isRead === false && alert.bucket === 'inbox') {

                            aiaUnreadAlerts += 1;
                        }
                    });

                    aiaReadAlerts = alertsResponse.data.alertList.length - aiaUnreadAlerts;
                }

                if (aiaUnreadAlerts > 0) {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmUnreadNotificationsCard = true;
                    $rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;
                } else if (aiaUnreadAlerts === 0 && $scope.dwmLiteSubscriptionUpsell) {

                    $rootScope.showDwmCardHomepage = true;
                }

                if ($rootScope.scrollToNotifications) {

                    // Scroll to the notifications section
                    $location.hash('notifications');
                    $anchorScroll();

                    // Reset the scroll behaviour
                    $rootScope.scrollToNotifications = false;
                    $location.hash('');
                }

                _RFC2.default.setCommonProperty('AIA Unread Alerts', aiaUnreadAlerts);
                _RFC2.default.setCommonProperty('AIA Read Alerts', aiaReadAlerts);
            }).catch(function (errResponse) {

                $rootScope.dwmResoucesStatuses.alerts = 'error';
                _RFC4.default.error('cw.modal.server-error.desc');

                _RFC2.default.send('ConnectWeb AIA Error', {
                    Detail: 'alerts',
                    ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A'
                });
            });

            Promise.allSettled([assetsPromise, alertsPromise]).then(function () {

                sendDashboardOpenEvent();
            });
        }).catch(function (response) {

            if ($scope.aiaSubscriptioneStatus === 'cancelled') {

                $rootScope.dwmResoucesStatuses.members = 'loaded';
                $scope.loadingButton = false;
            }

            $rootScope.dwmResoucesStatuses.token = 'error';

            $scope.loadingButton = false;

            if (response.data.errorCode !== 32030) {

                _RFC2.default.send('ConnectWeb AIA Error', {
                    Detail: 'tokensByPartnerToken',
                    ErrorCode: response.data ? response.data.errorCode : 'N/A'
                });

                _RFC4.default.error('cw.modal.server-error.desc');
            } else {

                sendDashboardOpenEvent();
            }
        });
    };

    var refreshPartnerToken = void 0;
    // status api code
    $rootScope.aiaStatusApiCall = function (triggerPendingState) {

        $scope.showMainLoader = true;

        if (triggerPendingState) {

            $scope.activateLicensePending = true;
        }

        $http({
            method: 'POST',
            url: CWCONFIG.dwm.statusURL,
            headers: {
                Authorization: 'Bearer ' + aviraToken
            },
            data: {
                clientApplication: {
                    clientId: 'myavira'
                }
            }

        }).then(function (response) {

            var dwmStatus = response.data;

            var aiaStatus = Util.deepFind(dwmStatus, 'products.identityAssist');
            var dwmLiteStatus = Util.deepFind(dwmStatus, 'products.dwmLite');

            if (!aiaStatus && !dwmLiteStatus) {

                $state.go('root.dashboard.home');
            }

            _index.dwmRepository.replace('statusApi', dwmStatus);

            if (aiaStatus || dwmLiteStatus) {

                $rootScope.showDwmLeftNavigation = true;
            }

            $scope.showMainLoader = false;
            $scope.dwmStatus = dwmStatus;
            $rootScope.dwmStatus = dwmStatus;

            var aiaTileAction = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.tileAction');
            var dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

            $scope.dwmLiteSubscriptionStatus = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.subscriptionStatus');
            $scope.aiaSubscriptioneStatus = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.subscriptionStatus');

            $scope.aiaSubscriptionCancelled = $scope.aiaSubscriptioneStatus === 'cancelled' || $scope.aiaSubscriptioneStatus === 'none';
            $scope.aiaSubscriptionActive = $scope.aiaSubscriptioneStatus === 'active';
            $scope.dwmLiteSubscriptionCancelled = $scope.dwmLiteSubscriptionStatus === 'cancelled' || $scope.dwmLiteSubscriptionStatus === 'none';
            $scope.dwmLiteSubscriptionActive = $scope.dwmLiteSubscriptionStatus === 'active';
            $scope.dwmLiteSubscriptionUpsell = $scope.dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';

            $rootScope.aiaSubscriptionCancelled = $scope.aiaSubscriptioneStatus === 'cancelled' || $scope.aiaSubscriptioneStatus === 'none';

            $rootScope.dwmLiteSubscriptionCancelled = $scope.dwmLiteSubscriptionStatus === 'cancelled' || $scope.dwmLiteSubscriptionStatus === 'none';

            if ((aiaStatus || dwmLiteStatus) && ($rootScope.aiaSubscriptionCancelled || $rootScope.dwmLiteSubscriptionCancelled)) {

                $rootScope.showDwmCardHomepage = true;
            } else {

                $rootScope.showDwmCardHomepage = false;
            }

            if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                $rootScope.showAIAWelcomeOfferBanner = true;
            } else {

                $rootScope.showAIAWelcomeOfferBanner = false;
            }

            if (aiaTileAction === 'openDashboard') {

                // show aia dashboard
                getDarkWebMonitorData();
                $scope.showUpsellPage = false;
                $scope.showUpsellPageFlag = false;
                $rootScope.showDWMDashboard = true;
                $rootScope.showDWMLiteStrippedDashboard = false;
                $rootScope.showDWMLiteUpsellDashboard = false;

                if ($scope.aiaSubscriptioneStatus === 'active') {

                    refreshPartnerToken = setInterval(getDarkWebMonitorData, 600000);
                } else {

                    clearInterval(refreshPartnerToken);
                }

                if ($scope.currentTab === 'store') {

                    $state.go('root.dashboard.dwm', {
                        tab: 'dwm'
                    });
                }
            } else if (dwmLiteTileAction === 'openDashboard') {

                // show dwm lite dashboard
                if ($scope.dwmLiteSubscriptionStatus === 'active') {

                    getDarkWebMonitorData();
                    $scope.showUpsellPage = false;
                    $scope.showUpsellPageFlag = false;

                    if ($scope.dwmLiteSubscriptionStatus === 'active') {

                        refreshPartnerToken = setInterval(getDarkWebMonitorData, 600000);
                    } else {

                        clearInterval(refreshPartnerToken);
                    }
                } else {

                    sendDashboardOpenEvent();
                }

                if (aiaTileAction === 'openUpsell') {

                    // show aia upsell
                    $rootScope.showDWMLiteUpsellDashboard = true;

                    if ($scope.currentTab === 'restoration') {

                        $state.go('root.dashboard.dwm', {
                            tab: 'store'
                        });
                    }
                } else {

                    // show dwm lite - stripped version, no upsell, only email
                    $rootScope.showDWMLiteStrippedDashboard = true;

                    if ($scope.currentTab === 'restoration') {

                        $state.go('root.dashboard.dwm', {
                            tab: 'dwm'
                        });
                    }

                    if ($scope.currentTab === 'store') {

                        $state.go('root.dashboard.dwm', {
                            tab: 'dwm'
                        });
                    }
                }
            } else if (aiaTileAction === 'openUpsell') {

                // show aia store page
                $scope.showUpsellPage = true;

                $state.go('root.dashboard.dwm', {
                    tab: 'store'
                });
            }

            if (triggerPendingState) {

                $scope.activateLicensePending = false;
            }

            if ($rootScope.turnOnDwm) {

                $rootScope.turnOnDwm = false;
                $scope.toggleMontoring();
            }
        }).catch(function (response) {

            _RFC2.default.send('ConnectWeb AIA Error', {
                Detail: 'statusAPI',
                ErrorCode: response.data ? response.data.errorCode : 'N/A',
                ErrorMessage: response.data ? response.data.message : 'N/A',
                ErrorDescription: response.data ? response.data.error_description : 'N/A',
                ErrorTrackId: response.data ? response.data.trackId : 'N/A',
                ErrorStatus: response.data ? response.data.status : 'N/A'
            });

            _RFC4.default.error('cw.modal.server-error.desc');

            $rootScope.showDwmLeftNavigation = false;

            $state.go('root.dashboard.home');
        });
    };

    $rootScope.aiaStatusApiCall();
    // end status api code

    $scope.buy = function (button, appId) {

        appId = 'adwp1';
        var mixpanelData = {
            'Product ID': appId,
            Page: 'AIA Store Page',
            Runtimes: 12
        };

        _RFC2.default.send('ConnectWeb Store Buy Click', mixpanelData);

        var subsource = 'store';

        $state.go('root.dashboard.dwm.ltb.buy', {
            ltb: 'payment-cart',
            resourceId: appId,
            subsource: subsource,
            button: button
        }, {
            reload: false
        });
    };

    var purchaseListener = $rootScope.$on('dwm_purchase_completed', function () {

        $rootScope.aiaStatusApiCall();
    });

    $scope.sendMixpanelSupport = function () {

        _RFC2.default.send('ConnectWeb AIA Restoration Contact Click');
    };

    $rootScope.showUpsellPageClick = function (label) {

        $scope.showUpsellPageFlag = true;
        $rootScope.redirectFromTab = $scope.currentTab;

        _RFC2.default.send('ConnectWeb DWM Lite Upgrade Click', {
            Label: label
        });

        $state.go('root.dashboard.dwm', {
            tab: 'store'
        });
    };

    $scope.restorationTabClick = function () {

        if (!$rootScope.showDWMLiteUpsellDashboard && !$rootScope.showDWMLiteStrippedDashboard) {

            $state.go('root.dashboard.dwm', {
                tab: 'restoration'
            }, {
                reload: false
            });
        } else if ($rootScope.showDWMLiteUpsellDashboard) {

            $scope.showUpsellPageFlag = true;
            $rootScope.redirectFromTab = $scope.currentTab;

            _RFC2.default.send('ConnectWeb DWM Lite Upgrade Click', {
                Label: 'Restoration Tab'
            });

            $state.go('root.dashboard.dwm', { tab: 'store' });
        }
    };

    $scope.sendMixpanelLearnMore = function () {

        _RFC2.default.send('ConnectWeb AIA Learn More Click');
    };

    // $rootScope.createCMAlabels('adwp1_12_1', 'Avira Identity Assistant',
    // 'adwp1', '2023-06-08', '2023-06-30');

    $scope.$on('$destroy', function () {

        $rootScope.extraCMAinfoForDwm = false;
        clearInterval(refreshPartnerToken);
        purchaseListener();

        // $rootScope.welcomeOffers = {};

        $rootScope.offersDetails = [];
    });
}]);

/***/ }),

/***/ "0+3i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _pathWhitelist = __webpack_require__("di0k");

var _pathWhitelist2 = _interopRequireDefault(_pathWhitelist);

var _RFC5 = __webpack_require__("sejk");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var receivedSessionId = window.sessionStorage.getItem('websocketsId') || null;

var MAX_RETRIES = 3;
var MULTIPLYING_FACTOR = 2;
var currentDelay = 1000;
var retryAttempts = 0;

function WebSocketService() {

    var WebSocketPromise = new _RFC6.default();
    var connection = null;
    var isConnected = false;
    var pingInterval = void 0;

    var API = {
        connect: connect,
        isConnected: isConnected
    };

    function connect() {

        // only attempt to connect, if there hasn't been an attempt to connect
        if (!connection) {

            connection = new WebSocket(CWCONFIG.socket.acnsUrl);

            connection.onopen = function () {

                var token = _RFC2.default.get(CWCONFIG.cookie.token);

                var subscribePayload = {
                    acp: '1.0',
                    host: 'dashboard',
                    verb: 'SUBSCRIBE',
                    path: '/notifications',
                    id: receivedSessionId,
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                };

                connection.send(JSON.stringify(subscribePayload), function (error) {

                    if (error) {

                        _loggers.socketLogger.error(error);
                    }
                });
                _loggers.socketLogger.log({
                    type: 'SEND',
                    cmd: subscribePayload.path,
                    data: Object.assign({}, subscribePayload)
                });

                startPingInterval();
            };

            connection.onmessage = function (event) {

                // when we get a response to our request for subscription to websockets server
                // we resolve the promise, and set the ready property to true
                if (!isConnected) {

                    WebSocketPromise.resolve();
                    isConnected = true;
                }

                var message = void 0;
                var extraParams = {};
                if (event && typeof event.data === 'string') {

                    try {

                        message = JSON.parse(event.data);
                    } catch (error) {

                        _loggers.socketLogger.error('Received data is not in JSON format', error);
                    }

                    // set the session id from the backend response
                    // used for subsequent requests, or when reconnecting
                    if (!receivedSessionId && message.headers && message.headers['X-Avira-Session']) {

                        receivedSessionId = message.headers && message.headers['X-Avira-Session'];
                        window.sessionStorage.setItem('websocketsId', receivedSessionId);
                    }

                    _loggers.socketLogger.log({
                        type: 'RCV',
                        cmd: message.payload.path,
                        data: {
                            message: message
                        }
                    });

                    // for REST responses broadcast an event which contains the path in its name
                    var eventToBroadcast = void 0;
                    if (message.payload.acp) {

                        eventToBroadcast = getResourceFromPath(message.payload.path);

                        if (eventToBroadcast) {

                            _RFC4.default.broadcast('socket:' + eventToBroadcast, message.payload, extraParams);
                        }
                    }
                }
            };

            connection.onerror = function () {

                WebSocketPromise.reject();
                WebSocketPromise.promise.catch(function () {});

                resetConnectionState();
                retryToConnect();
            };

            connection.onclose = function () {

                WebSocketPromise.reject();
                WebSocketPromise.promise.catch(function () {});

                resetConnectionState();
                retryToConnect();
            };
        }

        return WebSocketPromise.promise;
    }

    function retryToConnect() {

        if (retryAttempts < MAX_RETRIES) {

            retryAttempts += 1;

            return setTimeout(function () {

                currentDelay *= MULTIPLYING_FACTOR;
                return connect();
            }, currentDelay);
        }

        return true;
    }

    // https://stackoverflow.com/questions/729921/settimeout-or-setinterval
    // we use a recursive timeout because
    // Chained-Timeout gives a guaranteed slot of free time to the browser;
    // Interval tries to ensure the function it is running executes
    // as close as possible to its scheduled times,
    // at the expense of browser UI availability.
    function startPingInterval() {

        pingInterval = setTimeout(function ping() {

            var connectionIsInClosingState = connection && (connection.readyState === 2 || connection.readyState === 3);

            if (connectionIsInClosingState) {

                resetConnectionState();
                connect();
            }
            pingInterval = setTimeout(ping, 30000);
        }, 30000);
    }

    function resetConnectionState() {

        connection = null;
        isConnected = false;
        clearTimeout(pingInterval);
    }

    return API;
}

/**
     * Extracts the resource name from a request/response path
     * For example, for the path:
     * '/v1/app-integrations?filter[to]=dashboard&include=from&lang=en'
     * the function will return 'app-integrations'
     * @param {string} path The message path
     * @return {string} The resource
     */
function getResourceFromPath(path) {

    var pieces = void 0;
    /* split the path and choose the piece which is found in cmds array */
    if (path) {

        pieces = path.split(/[/?&]/);
        return _.find(pieces, function (piece) {
            return _.contains(_pathWhitelist2.default, piece);
        });
    }

    return false;
}

exports.default = new WebSocketService();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "03rF":
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard-breadcrumb\">\n\n    <div class=\"text-m text-grey-2 breadcrumb-holder\">\n\n        <!-- Level 1 -->\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('home') > -1\" translate=\"cw.digitalhealth.title\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('my-account') > -1\" translate=\"cw.avira_account\" translate-values=\"{brandname : brandName}\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('devices') > -1\" translate=\"cw.menu.devices\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('products') > -1\" translate=\"cw.section.products_section.title\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('subscriptions') > -1\" translate=\"cw.section.subscriptions.title\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('store') > -1\" translate=\"cw.dashboard.store.title\" class=\"b-element\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('news') > -1 || breadcrumbCtrl.$state.current.name.indexOf('article') > -1\" class=\"b-element\" translate=\"cw.app_name.guides_news\"></span>\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('support') > -1\" translate=\"cw.section.support.title\" class=\"b-element\"></span>\n\n        <!-- Level 2 Device Section-->\n        <span ng-if=\"breadcrumbCtrl.$state.current.name.indexOf('device-details') > -1\" class=\"b-element\">\n            <!-- Device Category-->\n            <span class=\"device-section\">\n                <i translate=\"cw.menu.devices\" ui-sref=\"root.dashboard.devices\"></i>\n                <i class=\"mlr5\">&rsaquo;</i>\n            </span>\n\n            <!-- Device Name-->\n            <span ng-class=\"{'text-grey-4 crs-pointer': breadcrumbCtrl.$state.params.appId}\"\n                title=\"{{deviceRepo.getById(breadcrumbCtrl.$state.params.resourceId) | deviceName}}\">\n                <i class=\"device-name\" ui-sref=\"root.dashboard.device-details({resourceId: breadcrumbCtrl.$state.params.resourceId, tab: 'apps'})\">{{deviceRepo.getById(breadcrumbCtrl.$state.params.resourceId) | deviceName}}</i>\n                <i ng-if=\"breadcrumbCtrl.$state.params.appId\" class=\"mlr5\">&rsaquo;</i>\n            </span>\n\n            <!-- Service Name-->\n            <i ng-if=\"breadcrumbCtrl.$state.params.appId\">\n                {{appIntegrationsRepo.getById(breadcrumbCtrl.$state.params.appId).attributes.resource.oeName}}\n            </i>\n        </span>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "0L7t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('deviceName', function () {
    return function (device) {

        if (!device || !device.attributes) {

            return 'Unknown';
        }

        if (device) {

            if (device.attributes.alias) {

                return device.attributes.alias;
            } else if (device.attributes.name) {

                return device.attributes.name;
            } else if (device.attributes.brand && device.attributes.model) {

                if (device.attributes.model.toLowerCase().indexOf(device.attributes.brand.toLowerCase()) > -1) {

                    return device.attributes.model;
                }
                return [device.attributes.brand, device.attributes.model].join(' ');
            } else if (device.attributes.brand) {

                return device.attributes.brand;
            } else if (device.attributes.model) {

                return device.attributes.model;
            }

            return 'Unknown';
        }

        return undefined;
    };
});

/***/ }),

/***/ "0LLL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('normalizeForTranslate', function () {
    return function (input) {

        if (input) {

            return input.replace(/-/g, '_');
        }
        return false;
    };
});

/***/ }),

/***/ "0VhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobalObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__("w0ZA");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__node__["b" /* isNodeEnv */])()
        ? global
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
//# sourceMappingURL=global.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("GTd5")))

/***/ }),

/***/ "0Xe/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var Default = {
    filter: function filter(value, defaultValue) {

        return value || defaultValue;
    }
};

exports.default = Default;

/***/ }),

/***/ "0huu":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "0iGx":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("v3EM");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "12Ij":
/***/ (function(module, exports) {

module.exports = "<div class=\"not-allowed-page\">\n\n\t<div class=\"lock-device-screen\"></div>\n\n\t<h1 class=\"text-xxl mb20\" translate=\"cw.ui.general.require_permissions\"></h1>\n\n\t<p class=\"text-l text-grey-4 mb50\" translate=\"cw.lock_device.permissions_info2\" translate-values=\"{brandname : brandName}\"></p>\n\n\t<button ng-if=\"isLauncherWindow\"\n\t\tclass=\"btn btn-medium btn-primary\"\n\t\tng-click=\"notAllowedCtrl.closeLauncher()\"\n\t\ttranslate=\"cw.ui.general.close_window\">\n\n\t<button ng-if=\"!isLauncherWindow\"\n\t\tclass=\"btn btn-medium btn-primary\"\n\t\tui-sref=\"root.auth.login\"\n\t\tng-click=\"notAllowedCtrl.removeLoginCookies()\"\n\t\ttranslate=\"cw.auth.go_to_login\">\n\n</div>\n"

/***/ }),

/***/ "15Wi":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "18Q0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("eyBl");

var _RFC3 = __webpack_require__("fIlE");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("lD2H");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.DeviceNotifications
*
* @description
* This class is used to process notifications on devices.
*/
var DeviceNotifications = {

    /**
     * @ngdoc function
     * @name notifications.DeviceNotifications#processUpdate
     * @methodOf notifications.DeviceNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on a device.
     *
     * @param {object} data An object with updated values on device.
     * @param {object} prevDevice The old device object.
     * @param {object} newDevice The update device object.
     */
    processUpdate: function processUpdate(data, prevDevice, newDevice) {

        // hide notifications if not in dashboard
        if (this._hideNotifications()) {

            return;
        }

        // Device renamed
        if (data['attributes.alias'] || data['attributes.name']) {

            var prevName = (0, _index.FilterDeviceName)(prevDevice);
            var newName = (0, _index.FilterDeviceName)(newDevice);
            _RFC2.default.success({
                message: 'cw.device.rename.success',
                icon: {
                    cssClasses: 'icon-' + _RFC4.default.deepFind(newDevice, 'attributes.type')
                }
            }, {
                message: {
                    devicePrevName: prevName,
                    deviceNewName: newName
                }
            });
        }

        // Device removed
        if (data['attributes.hidden'] === 'true') {

            _RFC2.default.success({
                message: 'cw.device.remove.success',
                icon: {
                    cssClasses: 'icon-' + _RFC4.default.deepFind(newDevice, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: (0, _index.FilterDeviceName)(newDevice)
                }
            });
        }

        // Device reactivated
        if (data['attributes.hidden'] === 'false') {

            _RFC2.default.success({
                message: 'cw.device.reactivate.success',
                icon: {
                    cssClasses: 'icon-' + _RFC4.default.deepFind(newDevice, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: (0, _index.FilterDeviceName)(newDevice)
                }
            });
        }

        // Device changed state to online/offline from pending
        if (data['attributes.state']) {

            if (prevDevice.attributes.state === 'pending') {

                this._sendMixpanelForNewDevice(newDevice);
            }
        }
    },


    /**
     * @ngdoc function
     * @name notifications.DeviceNotifications#processCreate
     * @methodOf notifications.DeviceNotifications
     * @function
     *
     * @description
     * This function can be used to process the creation of a device.
     *
     * @param {object} device An object with the new device.
     */
    processCreate: function processCreate(device) {

        // hide notifications if not in dashboard
        if (this._hideNotifications()) {

            return;
        }

        if (_RFC4.default.deepFind(device, 'attributes.state') !== 'pending') {

            var stateParams = 'resourceId:' + device.id + ',tab:apps';
            var deviceName = (0, _index.FilterDeviceName)(device);
            var deviceLink = '<b><a stateTo=\'root.dashboard.device-details\' stateparams=\'' + stateParams + '\'>' + deviceName + '</a></b>';

            // a new non-pending device is added
            _RFC2.default.success({
                message: 'cw.device.add.success',
                icon: {
                    cssClasses: 'icon-' + _RFC4.default.deepFind(device, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: deviceLink
                }
            });

            this._sendMixpanelForNewDevice(device);
        }
    },
    _sendMixpanelForNewDevice: function _sendMixpanelForNewDevice(newDevice) {

        _RFC6.default.send('Connect Web Alert Triggered', {
            'Alert Type': 'Success',
            'Alert Name': (0, _index.FilterDeviceName)(newDevice) + ' Added'
        });
    },
    _hideNotifications: function _hideNotifications() {

        return window.location.pathname.indexOf('dashboard') === -1;
    }
};

exports.default = DeviceNotifications;

/***/ }),

/***/ "19sK":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"mya-section-info\">\n        <div class=\"text-xxl text-grey-3 mb10\" translate=\"cw.my_account.security.login_settings_title\"></div>\n        <div class=\"text-m mt5 text-grey-4\" ng-if=\"logintype === 'fb_auth'\" translate=\"cw.my_account.security.login_settings_desc_facebook\"></div>\n        <div class=\"text-m mt5 text-grey-4\" ng-if=\"logintype === 'gg_auth'\" translate=\"cw.my_account.security.login_settings_desc_google\"></div>\n        <div class=\"text-m mt5 text-grey-4\" ng-if=\"logintype === 'apl_auth'\" translate=\"cw.my_account.security.login_settings_desc_apple\"></div>\n    </div>\n\n    <div class=\"mya-section-forms max-width-s mt20\">\n        <div class=\"social-login-label facebook text-m\" ng-if=\"logintype === 'fb_auth'\">\n            <span class=\"icon\"></span>\n            <span class=\"inline-block w100\" translate=\"cw.my_account.security.login_settings_type_facebook\"></span>\n        </div>\n        <div class=\"social-login-label google text-m\" ng-if=\"logintype === 'gg_auth'\">\n            <span class=\"icon\"></span>\n            <span class=\"inline-block w100\" translate=\"cw.my_account.security.login_settings_type_google\"></span>\n        </div>\n        <div class=\"social-login-label apple text-m\" ng-if=\"logintype === 'apl_auth'\">\n            <span class=\"icon\"></span>\n            <span class=\"inline-block w100\" translate=\"cw.my_account.security.login_settings_type_apple\"></span>\n        </div>\n        <div class=\"mt10 text-center text-grey-4 text-s email-address-my-profile\"\n             title=\"{{userEmail}}\"\n             ng-if=\"logintype === 'fb_auth' || logintype === 'gg_auth' || logintype === 'apl_auth'\">{{userEmail}}</div>\n    </div>\n</div>\n"

/***/ }),

/***/ "1GA3":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("Wxwx"),
    shortOut = __webpack_require__("LOwu");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "1QLL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("LBU6");

var _RFC6 = _interopRequireDefault(_RFC5);

var _recaptcha2 = __webpack_require__("35YC");

var _recaptcha3 = _interopRequireDefault(_recaptcha2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$window', '$rootScope', 'Auth', 'Util', 'UserRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.twoFactorAuthController
 *
 * @description
 *  two factor authentication controller
 */

var _sendPhoneNumber = void 0;
var _recaptcha = void 0;
var _getPhoneNumber = void 0;

var _$scope = void 0;
var _user = void 0;
var _Util = void 0;
var _UserRestService = void 0;
var _sendPhoneNumberAlertSuccess = void 0;

var TwoFactorAuthController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} $rootScope
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} UserRestService
    */

    function TwoFactorAuthController($scope, $window, $rootScope, Auth, Util, UserRestService) {
        _classCallCheck(this, TwoFactorAuthController);

        _$scope = $scope;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.Auth = Auth;
        // _Util = Util;
        _Util = Util;
        // _UserRestService = UserRestService;
        _UserRestService = UserRestService;
        this.MeRepository = _index.MeRepository;
        // _user = MeRepository.getMyUser();
        _user = _index.MeRepository.getMyUser();

        _sendPhoneNumberAlertSuccess = this.sendPhoneNumberAlertSuccess;

        _$scope.tfaValidationStep = _user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
        _$scope.selectedDevice = _$scope.selectedDevice || {};
        _$scope.disabledButton = false;
        _$scope.otp = {};
        this.otpError = false;
        _$scope.inputError = false;

        _$scope.logout = false;
        _$scope.brandName = CWCONFIG.partnerConfig.name;

        _$scope.Recaptcha = _recaptcha3.default;

        _sendPhoneNumber = this.sendPhoneNumber;

        _$scope.setCaptchaResponse = this.setCaptchaResponse;
        _getPhoneNumber = this.getPhoneNumber;
        _recaptcha = _recaptcha3.default;

        _$scope.onSubmitPhone = this.onSubmitPhone;
        _$scope.onSubmitResend = this.onSubmitResend;

        _$scope.showCaptcha = false;
        // MeRepository Observable
        var meRepositoryObservable = _index.MeRepository.getObservable();
        var onNextMeRepository = function onNextMeRepository() {

            // get user from MeRepository
            _user = _index.MeRepository.getMyUser();
        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(onNextMeRepository, function () {}, function () {});

        _$scope.goBackToCrypto = function () {

            $rootScope.isComingFromCrypto = false;
        };
    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#twoStepValidationChanged
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * enable two factor authentication
     */


    _createClass(TwoFactorAuthController, [{
        key: 'enableTwoFactor',
        value: function enableTwoFactor() {

            _RFC4.default.send('ConnectWeb 2FA Activate Click');

            _$scope.tfaValidationStep = 'tfaPhoneInput';
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#twoStepValidationChanged
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * disable two factor authentication
         */

    }, {
        key: 'disableTwoFactor',
        value: function disableTwoFactor() {
            var _this = this;

            var phoneNumber = _getPhoneNumber();
            var payload = {
                data: {
                    attributes: {
                        status_tfa: 'inactive',
                        phone_tfa: phoneNumber
                    },
                    type: _user.type,
                    id: _user.id
                },
                meta: {
                    tfa_attributes: {
                        browser: window.browserName,
                        os: window.deviceOs
                    }
                }
            };

            _RFC4.default.send('ConnectWeb 2FA Deactivate Click');
            _$scope.disabledButton = true;

            _UserRestService.update(_user.id, payload).then(function (response) {

                _$scope.disabledButton = false;

                // update User Repository - status_tfa & phone_tfa
                _this.MeRepository.update(response.data.data);

                if (response.data.data.attributes.status_tfa === 'inactive') {

                    _RFC2.default.success('cw.tfa.messages.deactivated');
                    _$scope.tfaValidationStep = 'tfaDisabled';
                }
            }).then(null, function () {

                _RFC2.default.error();
                _$scope.disabledButton = false;
            });
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#sendSMS
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * by sending this command we receive the activation code via phone
         */

    }, {
        key: 'sendPhoneNumber',
        value: function sendPhoneNumber() {

            var headers = {};

            var captchaRespose = _recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            var phoneNumber = _getPhoneNumber();
            var payload = {
                data: {
                    attributes: {
                        status_tfa: 'pending',
                        phone_tfa: phoneNumber
                    },
                    type: _user.type,
                    id: _user.id
                }
            };

            var countryCode = _$scope.selectedDevice.country ? _$scope.selectedDevice.country.code.substring(0, 2) : '';

            // Check if the phone number is from international calling zone 1 and add to phoneNumber
            var isZoneOne = _$scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
            var phoneNumberZoneOne = isZoneOne ? _$scope.selectedDevice.country.dialCode.substring(3).concat(_$scope.selectedDevice.phoneNumber) : '';

            var isValidNumber = isZoneOne ? _Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) : _Util.isValidPhoneNumber(_$scope.selectedDevice.phoneNumber, countryCode);

            if (isValidNumber) {

                _$scope.disabledButton = true;
                _$scope.showCaptcha = false;
                _recaptcha.reset();

                _UserRestService.update(_user.id, payload, headers).then(function (response) {

                    // Alert success
                    _sendPhoneNumberAlertSuccess(phoneNumber);

                    _$scope.disabledButton = false;
                    _$scope.inputError = false;

                    if (response.data.data.attributes.status_tfa === 'pending') {

                        _$scope.tfaValidationStep = 'tfaCodeInput';
                    }
                }).then(null, function () {

                    _RFC2.default.error();
                    _$scope.disabledButton = false;
                });
            } else {

                _Util.triggerAnimation('.send-sms-inputs', 'animated shake');
                _$scope.inputError = true;
                _$scope.showCaptcha = false;
                _recaptcha.reset();
            }
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#sendPhoneNumberAlertSuccess
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * Notify the user that a code was sent to his phone number (ex: ******214)
         */

    }, {
        key: 'sendPhoneNumberAlertSuccess',
        value: function sendPhoneNumberAlertSuccess(phoneNumber) {

            // last 3 digits of the phone number
            var phoneNumberlastDigits = phoneNumber.substr(phoneNumber.length - 3);

            _RFC2.default.success({ message: 'cw.notification.tfa.phoneNumber' }, { message: { phoneNumber: phoneNumberlastDigits } });
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#verifyCode
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * this command is sending the otp code to the backend in order to verify the phone number
         */

    }, {
        key: 'sendOtpCode',
        value: function sendOtpCode() {
            var _this2 = this;

            var phoneNumber = _getPhoneNumber();
            var osVersion = _RFC6.default.getOSVersion();
            var payload = {
                meta: {
                    tfa_attributes: {
                        otp: _$scope.otp.code,
                        browser: this.$window.browserName,
                        os: osVersion
                    },
                    logout: _$scope.logout
                },
                data: {
                    attributes: {
                        status_tfa: 'active',
                        phone_tfa: phoneNumber
                    },
                    type: _user.type,
                    id: _user.id
                }
            };

            if (_$scope.otp.code) {

                _$scope.disabledButton = true;

                _UserRestService.update(_user.id, payload).then(function (response) {

                    _RFC4.default.send('ConnectWeb 2FA Activate Success', {
                        Logout: _$scope.logout ? 'true' : 'false'
                    });

                    if (_$scope.logout === true) {

                        _this2.Auth.removeTfaCookie();
                        _this2.Auth.logOut();
                    } else {

                        // update User Repository - status_tfa & phone_tfa
                        _this2.MeRepository.update(response.data.data);
                        _RFC2.default.success('cw.tfa.messages.activated');
                        _this2.Auth.removeTfaCookie();

                        _$scope.disabledButton = false;
                        _$scope.tfaValidationStep = 'tfaEnabled';
                        _this2.otpError = false;
                        _$scope.otp.code = '';
                    }
                }).then(null, function () {

                    _Util.triggerAnimation('.otp-code-input', 'animated shake');
                    _$scope.disabledButton = false;
                    _this2.otpError = true;

                    // show custom error alert on too many attempts error
                    if (_this2.$rootScope.errorMessage.indexOf('429') > -1) {

                        _RFC2.default.error('cw.notification.tfa.too_many_attempts');
                    }
                });
            } else {

                this.otpError = true;
                _Util.triggerAnimation('.otp-code-input', 'animated shake');
            }
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#getPhoneNumber
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * get phone number
         */

    }, {
        key: 'getPhoneNumber',
        value: function getPhoneNumber() {

            var phoneNumber = _user.attributes.phone_tfa || _user.attributes.phone;

            if (_$scope.selectedDevice.country) {

                phoneNumber = '' + _$scope.selectedDevice.country.dialCode + _$scope.selectedDevice.phoneNumber;
            }

            return phoneNumber;
        }

        /**
         * @ngdoc directive
         * @name directives.controller.twoFactorAuthController#toggleLogoutCheckbox
         * @methodOf directives.controller.twoFactorAuthController
         *
         * @description
         * toggle logout value
         */

    }, {
        key: 'toggleLogoutCheckbox',
        value: function toggleLogoutCheckbox() {

            _$scope.logout = !_$scope.logout;
        }
    }, {
        key: 'onSubmitPhone',
        value: function onSubmitPhone() {

            _$scope.showCaptcha = true;
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            _recaptcha.setCaptchaResponse(response);
            var _sendPhoneNumberBind = _sendPhoneNumber.bind(this);
            _sendPhoneNumberBind();
        }
    }]);

    return TwoFactorAuthController;
}();

/**
 * @ngdoc directive
 * @name directives.twoFactorAuthDirective
 *
 * @description
 * change password directive
 */


var TwoFactorAuthDirective = function TwoFactorAuthDirective() {
    _classCallCheck(this, TwoFactorAuthDirective);

    this.template = __webpack_require__("iJR4");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, $window, $rootScope, Auth, Util, UserRestService) {
        return new TwoFactorAuthController($scope, $window, $rootScope, Auth, Util, UserRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'TwoFactorAuthCtrl';
};

_directiveDependencies.push(function () {
    return new TwoFactorAuthDirective();
});

angular.module('directives').directive('twoFactorAuth', _directiveDependencies);

/***/ }),

/***/ "1Qa8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-len */
var moment = __webpack_require__("9dPI");

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$interval', 'Util'];

var TimeCounterController = function TimeCounterController($scope, $interval) {
    _classCallCheck(this, TimeCounterController);

    var endTimeParam = $scope.endtime;

    var intervalId = void 0;

    var transformToTwoDigitsNumber = function transformToTwoDigitsNumber(number) {
        return (number < 10 ? '0' : '') + number;
    };

    var formatTime = function formatTime() {

        var startTime = moment();
        var endTime = moment.apply(undefined, _toConsumableArray(endTimeParam));
        var days = Math.floor(moment.duration(endTime.diff(startTime)).asDays());
        var hours = Math.floor(moment.duration(endTime.diff(startTime)).asHours()) - days * 24;
        var minutes = Math.floor(moment.duration(endTime.diff(startTime)).asMinutes() - (days * 24 + hours) * 60);
        var seconds = Math.floor(moment.duration(endTime.diff(startTime)).asSeconds() - (days * 24 * 60 + hours * 60 + minutes) * 60);

        if (days >= 0) {

            $scope.days = transformToTwoDigitsNumber(days);
            $scope.hours = transformToTwoDigitsNumber(hours);
            $scope.minutes = transformToTwoDigitsNumber(minutes);
            $scope.seconds = transformToTwoDigitsNumber(seconds);
        } else {

            $scope.days = '00';
            $scope.hours = '00';
            $scope.minutes = '00';
            $scope.seconds = '00';
        }
    };

    var onTick = function onTick() {

        formatTime();
    };
    var init = function init() {

        formatTime();

        $interval.cancel(intervalId);
        intervalId = $interval(onTick, 10 * 100);
    };

    $scope.$watch('endtime', init);

    $scope.$on('$destroy', function () {

        $interval.cancel(intervalId);
    });
};

var TimeCounterDirective = function TimeCounterDirective() {
    _classCallCheck(this, TimeCounterDirective);

    this.template = '<span>{{days}}:{{hours}}:{{minutes}}:{{seconds}}</span>';
    this.restrict = 'EA';
    this.replace = true;

    this.scope = {
        endtime: '='
    };

    _controllerDependencies.push(function ($scope, $interval, Util) {
        return new TimeCounterController($scope, $interval, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'TimeCounterCtrl';
};

_directiveDependencies.push(function () {
    return new TimeCounterDirective();
});

angular.module('directives').directive('timeCounter', _directiveDependencies);

/***/ }),

/***/ "1Qb/":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div>\n        <welcome-offer ng-if=\"$root.dwmStatusLoaded && !$root.isMobileAppSession\"></welcome-offer>\n    </div>\n\n    <div class=\"security-apps-nd\">\n        <!-- Version 1 - button left-->\n        <div class=\"featured-product-banner button-left-version\"\n            ng-if=\"isWindowsOS\"\n            connectqa-free-products=\"fss\">\n            <div class=\"w60\">\n                <div class=\"text-wrapper text-left\"\n                    connectqa-free-products=\"fss_description\">\n                    <div class=\"mb10\">\n                        <h2 class=\"text-xxl text-grey-1 font-bold capitalize inline-block mr5\">{{featureAppTitle}}</h2>\n                        <i class=\"icon icon-xs icon-windows inline-block\"></i>\n                    </div>\n                    <h3 class=\"text-l mb10\"\n                        translate=\"cw.product.banner.description\">\n                    </h3>\n                    <ul class=\"text-m mb20\">\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.windows_desc_bullet_1\"></span>\n                            </p>\n                        </li>\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.windows_desc_bullet_2\"></span>\n                            </p>\n                        </li>\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.windows_desc_bullet_3\"></span>\n                            </p>\n                        </li>\n                    </ul>\n                    <div class=\"flex-space-between actions-zone\">\n                        <div class=\"install-btn-left mr50\">\n                            <a ng-click=\"installService(featureApp, 'install')\"\n                                class=\"btn btn-medium btn-primary\"\n                                translate=\"cw.deploy.install_app\" translate-values=\"{app: featureAppTitle}\"\n                                connectqa-button=\"install\">\n                            </a>\n                        </div>\n                        <div connectqa-free-products=\"fss_awards\">\n                            <div ng-if=\"language === 'de'\" class=\"inline-block\">\n                                <span class=\"icon-AV-test  mr20\"></span>\n                                <span class=\"icon-trustpilot-de mr20\"></span>\n                                <span class=\"icon-av-comparatives\"></span>\n                            </div>\n                            <div ng-if=\"!language\" class=\"awards-holder-small text-xxs\">\n                                <div class=\"icon-award mr20\">\n                                    <i class=\"icon-trustpilot-logo-stars\"></i>\n                                    <p class=\"uppercase\" translate=\"cw.product.banner.trustpillot_status\"></p>\n                                    <p class=\"text-blue-3 font-bold\">Trustpilot</p>\n                                </div>\n                                <div class=\"icon-award mr20\">\n                                    <i class=\"icon-toptenreviews-logo-stars\"></i>\n                                    <p class=\"uppercase\" translate=\"cw.product.banner.toptenreviews\" translate-values=\"{brandname : brandName}\"></p>\n                                    <p class=\"text-blue-3 font-bold\">TopTenReviews</p>\n                                </div>\n                                <div class=\"icon-award\">\n                                    <i class=\"icon-cnet-logo-stars\"></i>\n                                    <p class=\"uppercase\" translate=\"cw.product.banner.CNET\"></p>\n                                    <p class=\"text-blue-3 font-bold\">CNET</p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n\n            </div>\n            <div class=\"w30\"></div>\n            <div class=\"text-l text-center mt30 w100 what-included\" translate=\"cw.product.banner.what_included\"></div>\n            <div class='products-inside'>\n                <ul>\n                    <div class=\"font-bold text-m text-grey-3\" translate=\"cw.general.security\"></div>\n                    <li ng-repeat=\"app in servicesByCategory.security\"\n                        ng-hide=\"app.id.indexOf('aib0') > -1 \">\n                        <img class=\"product-icon inline-block\" src=\"{{app.attributes.resource.wsLargeImageUrl}}\" alt=\"{{app.attributes.resource.oeName}}\" />\n                        <div class=\"text-m inline-block v-middle\">{{app.attributes.resource.oeName}}</div>\n                        <div class='info-tooltip-holder'>\n                            <div class=\"info-tooltip arrow-bottom\">\n                                {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n                <ul>\n                    <div class=\"font-bold text-m text-grey-3\" translate=\"cw.device_info.category.privacy\"></div>\n                    <li ng-repeat=\"app in servicesByCategory.privacy\"\n                        ng-hide=\"app.id.indexOf('aib0') > -1\">\n                        <img class=\"product-icon inline-block\" src=\"{{app.attributes.resource.wsLargeImageUrl}}\" alt=\"{{app.attributes.resource.oeName}}\" />\n                        <div class=\"text-m inline-block v-middle\">{{app.attributes.resource.oeName}}</div>\n                        <div class='info-tooltip-holder'>\n                            <div class=\"info-tooltip arrow-bottom\">\n                                {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n                <ul>\n                    <div class=\"font-bold text-m text-grey-3\" translate=\"cw.device_info.category.performance\"></div>\n                    <li ng-repeat=\"app in servicesByCategory.performance\"\n                        ng-hide=\"app.id.indexOf('aib0') > -1 \">\n                        <img class=\"product-icon inline-block\" src=\"{{app.attributes.resource.wsLargeImageUrl}}\" alt=\"{{app.attributes.resource.oeName}}\" />\n                        <div class=\"text-m inline-block v-middle\">{{app.attributes.resource.oeName}}</div>\n                        <div class='info-tooltip-holder'>\n                            <div class=\"info-tooltip arrow-bottom\">\n                                {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </div>\n        <!-- Avira free security suit for mac banner -->\n        <div class=\"featured-product-banner button-left-version mac-version\"\n            ng-if=\"currentDeviceOS === 'mac_os_x'\"\n            connectqa-free-products=\"fss\">\n            <div class=\"w60\">\n                <div class=\"text-wrapper text-left mt10\"\n                    connectqa-free-products=\"fss_description\">\n                    <div>\n                        <h2 class=\"text-xxl text-grey-1 font-bold capitalize inline-block mr5 mb20\">{{featureAppTitle}}</h2>\n                        <i class=\"icon icon-xs icon-osx inline-block\"></i>\n                    </div>\n                    <h3 class=\"text-l mb10\"\n                        translate=\"cw.product.banner.description_2\">\n                    </h3>\n                    <ul class=\"text-m mb20\">\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.mac_desc_bullet_1\"></span>\n                            </p>\n                        </li>\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.mac_desc_bullet_2\"></span>\n                            </p>\n                        </li>\n                        <li>\n                            <p>\n                                <i class=\"icon icon-checked icon-xxxs text-green-1 mr5 inline-block\"></i>\n                                <span translate=\"cw.product.banner.mac_desc_bullet_3\"></span>\n                            </p>\n                        </li>\n                    </ul>\n                    <div class=\"flex-space-between actions-zone mb25\">\n                        <div class=\"install-btn-left mr50\">\n                            <a ng-click=\"installService(featureApp, 'install')\"\n                                class=\"btn btn-medium btn-primary\"\n                                translate=\"cw.deploy.install_app\" translate-values=\"{app: featureAppTitle}\"\n                                connectqa-button=\"install\">\n                            </a>\n                        </div>\n                        <div connectqa-free-products=\"fss_awards\">\n                            <div ng-if=\"language === 'de'\" class=\"inline-block\">\n                                <span class=\"icon-AV-test mr20\"></span>\n                                <span class=\"icon-trustpilot-de mr20\"></span>\n                                <span class=\"icon-av-comparatives\"></span>\n                            </div>\n                            <div ng-if=\"!language\" class=\"text-left awards-holder-small\">\n                                <div class=\"inline-block v-middle mr10\">\n                                    <div class=\"text-xxs font-bold\">4.5/5 - <span class=\"uppercase\" translate=\"cw.product.banner.trustpillot_status\"></span></div>\n                                    <div class=\"text-xxs\" translate=\"cw.product.banner.trustpillot_reviews\"></div>\n                                </div>\n                                <div class=\"inline-block v-middle\"><i class=\"icon-trustpilot-reviews\"></i></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n            </div>\n            <div class=\"w30\"></div>\n        </div>\n\n        <!-- End Version 1 - button left-->\n\n        <div class=\"products-list\">\n            <!-- mobile apps list -->\n            <ul ng-if=\"mobileApps.length > 0\">\n                <h3 class=\"text-grey-4 text-xxl category-title\"><span translate=\"cw.product.mobile_apps\"></span></h3>\n                <li ng-repeat=\"app in mobileApps | orderBy: 'attributes.custom.manifest.order'\"\n                    ng-if=\"app.attributes.custom.manifest.visible === 1\n                    && unsupportedApps.indexOf(app.id) === -1\n                    && app.id !== 'ashs0'\"\n                    connectqa-free-products=\"{{app.attributes.service}}\">\n\n                    <div class=\"flex-row\">\n                        <div class=\"content-holder text-left\">\n                            <div class=\"mb20\">\n                                <div class=\"icon-holder\">\n                                    <img ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n                                </div>\n\n                                <div class=\"inline-block v-middle\">\n                                    <h3 class=\"text-grey-1 text-l\" ng-class=\"{'font-16': app.id === 'shar0'}\">\n                                        {{app.attributes.resource.oeName}}\n                                    </h3>\n                                    <div class=\"available-os\">\n                                        <span ng-if=\"app.attributes.custom.manifest.os.length\n                                        && !app.attributes.custom.manifest.browsers.length\">\n                                            <span\n                                                ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                                ng-if=\"osType === 'android' || osType === 'ios'\"\n                                                class=\"icon icon-xxs icon-{{osType}}\">\n                                            </span>\n                                        </span>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"text-m text-grey-2 mb10\">\n                                {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                            </div>\n                        </div>\n\n                        <div class=\"action-holder\">\n                            <div class=\"installed-on\">\n                                <a class=\"show-dropdown text-blue-3\"\n                                    ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                    ng-show=\"app.mobileDevices.length\"\n                                    ng-click=\"toggleDropdown=!toggleDropdown\">\n                                    <span translate=\"cw.dashboard.services.installed_on_text\"\n                                    translate-values=\"{systemprofilename: ''}\"></span>\n                                </a>\n                                <span class=\"show-dropdown text-m\"\n                                    ng-show=\"!app.mobileDevices.length\">\n                                    <span translate=\"cw.dashboard.device.not_installed\"></span>\n                                </span>\n\n                                <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                    <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                        <li ng-repeat=\"device in app.mobileDevices\"\n                                            ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                                            <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}}\"></i>\n                                            {{device.attributes.alias || device.attributes.name}}\n                                        </li>\n                                    </div>\n                                </ul>\n                            </div>\n                            <div class=\"button-holder mb5\" ng-if=\"!app.attributes.custom.manifest.browserExtensionUrl\">\n                                <a ng-if=\"app.buttonLabel === 'install'\" ng-click=\"installService(app, 'install')\"\n                                    class=\"btn btn-medium btn-primary\"\n                                    translate=\"cw.general.ui.install\" connectqa-button=\"install\"></a>\n\n                                <a ng-if=\"app.buttonLabel === 'install_other'\" ng-click=\"installService(app, 'other_device')\"\n                                    class=\"btn btn-medium btn-primary\"\n                                    translate=\"cw.general.ui.install\" connectqa-button=\"install\"></a>\n\n                                <a ng-if=\"app.buttonLabel === 'open'\" ng-click=\"openServiceLink(app)\"\n                                    class=\"btn btn-medium btn-primary\"\n                                    translate=\"cw.general.ui.open\" connectqa-button=\"open\"></a>\n                            </div>\n                        <div class=\"learn-more text-grey-3 crs-pointer text-center white-space-nowrap\" ng-click=\"showDetails(app)\">\n                            <a class=\"text-s\" connectqa-button=\"learn-more\" translate=\"cw.general.buttons.learn_more\"></a>\n                        </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div>\n                <!-- Browser Extensions app list -->\n                <ul ng-if=\"browserExtensions.length > 0\">\n                    <h3 class=\"text-grey-4 text-xxl category-title\"><span translate=\"cw.product.browser_extensions\"></span></h3>\n                    <li ng-repeat=\"app in browserExtensions | orderBy: 'attributes.custom.manifest.order'\" class=\"card\"\n                        ng-if=\"app.attributes.custom.manifest.visible === 1 && unsupportedApps.indexOf(app.id) === -1\"\n                        connectqa-free-products=\"{{app.attributes.service}}\">\n\n                        <div class=\"flex-row\">\n                            <div class=\"content-holder\">\n                                <div class=\"mb20 text-left\">\n                                    <div class=\"icon-holder\">\n                                        <img ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n                                    </div>\n\n                                    <div class=\"inline-block v-middle\">\n                                        <h3 class=\"text-grey-1 text-l\">\n                                            {{app.attributes.resource.oeName}}\n                                        </h3>\n                                        <div class=\"available-os\">\n                                            <span ng-repeat=\"browserType in app.attributes.custom.manifest.browsers\"\n                                                    ng-if=\"app.attributes.custom.manifest.browsers.length\"\n                                                    class=\"icon icon-xxs icon-grey-4 icon-{{browserType}}\">\n                                            </span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"text-m text-grey-2 mb10 text-left\">\n                                    {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                                </div>\n                            </div>\n\n                            <div class=\"action-holder text-right\">\n                                <div class=\"installed-on\">\n                                    <a class=\"show-dropdown text-blue-3\"\n                                        ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                        ng-show=\"app.devices.length\"\n                                        ng-click=\"toggleDropdown=!toggleDropdown\">\n                                        <span translate=\"cw.dashboard.services.installed_on_text\"\n                                        translate-values=\"{systemprofilename: ''}\"></span>\n                                    </a>\n                                    <span class=\"show-dropdown text-m\"\n                                        ng-show=\"!app.devices.length\">\n                                        <span translate=\"cw.dashboard.device.not_installed\"></span>\n                                    </span>\n\n                                    <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                        <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                            <li ng-repeat=\"device in app.devices\" ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                                                <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}}\"></i>\n                                                {{device.attributes.alias || device.attributes.name}}\n                                            </li>\n                                        </div>\n                                    </ul>\n                                </div>\n\n                                <div class=\"button-holder mb5\" ng-if=\"app.attributes.custom.manifest.browserExtensionUrl\">\n                                    <!-- chrome -->\n                                    <a ng-if=\"browserName === 'chrome' && app.attributes.custom.manifest.browserExtensionUrl.chrome\"\n                                        ng-href=\"{{app.attributes.custom.manifest.browserExtensionUrl.chrome}}\"\n                                        target=\"_blank\"\n                                        ng-click=\"sendMixpanelEvent(app)\"\n                                        class=\"btn btn-medium btn-primary btn-full-width\"\n                                        translate=\"cw.general.ui.install\"\n                                        connectqa-button=\"install\"></a>\n\n                                    <!-- firefox -->\n                                    <a ng-if=\"browserName === 'firefox' && app.attributes.custom.manifest.browserExtensionUrl.firefox\"\n                                        ng-href=\"{{app.attributes.custom.manifest.browserExtensionUrl.firefox}}\"\n                                        ng-click=\"sendMixpanelEvent(app)\"\n                                        class=\"btn btn-medium btn-primary btn-full-width\"\n                                        translate=\"cw.general.ui.install\"\n                                        connectqa-button=\"install\"></a>\n\n                                    <!-- opera -->\n                                    <a ng-if=\"browserName === 'opera' && app.attributes.custom.manifest.browserExtensionUrl.opera\"\n                                        ng-click=\"installOperaExtension(app.attributes.custom.manifest.browserExtensionUrl.opera, app.id);sendMixpanelEvent(app)\"\n                                        class=\"btn btn-medium btn-primary btn-full-width text-m\"\n                                        translate=\"cw.general.ui.install\"\n                                        onnectqa-button=\"install\"></a>\n                                </div>\n\n                                <div class=\"learn-more text-grey-3 crs-pointer text-center white-space-nowrap\" ng-click=\"showDetails(app)\">\n                                    <a class=\"text-s\" connectqa-button=\"learn-more\" translate=\"cw.general.buttons.learn_more\"></a>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n                <!-- IOT apps list -->\n                <ul ng-if=\"iotApps.length > 0\">\n                    <h3 class=\"text-grey-4 text-xxl category-title\"><span translate=\"cw.general.internet_of_things\"></span></h3>\n                    <li ng-repeat=\"app in iotApps | orderBy: 'attributes.custom.manifest.order'\"\n                        ng-if=\"app.attributes.custom.manifest.visible === 1 && unsupportedApps.indexOf(app.id) === -1\"\n                        connectqa-free-products=\"{{app.attributes.service}}\">\n                        <div class=\"flex-row\">\n                            <div class=\"content-holder\">\n                                <div class=\"mb20 text-left\">\n                                    <div class=\"icon-holder\">\n                                        <img ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n                                    </div>\n\n                                    <div class=\"inline-block v-middle\">\n                                        <h3 class=\"text-grey-1 text-l\">\n                                            {{app.attributes.resource.oeName}}\n                                        </h3>\n                                        <div class=\"available-os\">\n                                            <span ng-if=\"app.attributes.custom.manifest.os.length\n                                            && !app.attributes.custom.manifest.browsers.length\">\n                                                <span\n                                                    ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                                    class=\"icon icon-xxs icon-{{osType}}\">\n                                                </span>\n                                            </span>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"text-m text-grey-2 mb10 text-left\">\n                                    {{app.attributes.resource.oneLiner | cut:true:100:'...'}}\n                                </div>\n                            </div>\n\n                            <div class=\"action-holder text-right\">\n                                <div class=\"installed-on\">\n                                    <a class=\"show-dropdown text-blue-3\"\n                                        ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                        ng-show=\"app.devices.length\"\n                                        ng-click=\"toggleDropdown=!toggleDropdown\">\n                                        <span translate=\"cw.dashboard.services.installed_on_text\"\n                                        translate-values=\"{systemprofilename: ''}\"></span>\n                                    </a>\n                                    <span class=\"show-dropdown text-m\"\n                                        ng-show=\"!app.devices.length\">\n                                        <span translate=\"cw.dashboard.device.not_installed\"></span>\n                                    </span>\n\n                                    <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                        <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                            <li ng-repeat=\"device in app.devices\" ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                                                <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}}\"></i>\n                                                {{device.attributes.alias || device.attributes.name}}\n                                            </li>\n                                        </div>\n                                    </ul>\n                                </div>\n                                <div class=\"button-holder mb5\" ng-if=\"!app.attributes.custom.manifest.browserExtensionUrl\">\n                                    <a ng-if=\"app.buttonLabel === 'install'\" ng-click=\"installService(app, 'install')\"\n                                        class=\"btn btn-medium btn-primary\"\n                                        translate=\"cw.general.ui.install\" connectqa-button=\"install\"></a>\n\n                                    <a ng-if=\"app.buttonLabel === 'install_other'\" ng-click=\"installService(app, 'other_device')\"\n                                        class=\"btn btn-medium btn-primary\"\n                                        translate=\"cw.general.ui.install\" connectqa-button=\"install\"></a>\n\n                                    <a ng-if=\"app.buttonLabel === 'open'\" ng-click=\"openServiceLink(app)\"\n                                        class=\"btn btn-medium btn-primary\"\n                                        translate=\"cw.general.ui.open\" connectqa-button=\"open\"></a>\n                                </div>\n\n                                <div class=\"learn-more text-grey-3 crs-pointer text-center white-space-nowrap\" ng-click=\"showDetails(app)\">\n                                    <a class=\"text-s\" connectqa-button=\"learn-more\" translate=\"cw.general.buttons.learn_more\"></a>\n                                </div>\n                            </div>\n                        </div>\n                    </li>\n\n                </ul>\n            </div>\n        </div>\n    </div>\n    <cma-disclaimer ng-if=\"showCmaDisclaimer.banner\"></cma-disclaimer>\n</div>\n"

/***/ }),

/***/ "1RFZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ProfileImageRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to upload images
 * using http requests.
 */

var ProfileImageRestService = function (_BaseRestService) {
    _inherits(ProfileImageRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function ProfileImageRestService($http, $q, Util) {
        _classCallCheck(this, ProfileImageRestService);

        return _possibleConstructorReturn(this, (ProfileImageRestService.__proto__ || Object.getPrototypeOf(ProfileImageRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.ProfileImageRestService#create
     * @methodOf rest.services.ProfileImageRestService
     * @function
     *
     * @description
     * This method will make a http request (POST) with image and user details
     * in order to upload the image to server.
     *
     * @param {object} imagePayload ProfileImage payload
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(ProfileImageRestService, [{
        key: 'create',
        value: function create(imagePayload) {

            return _get(ProfileImageRestService.prototype.__proto__ || Object.getPrototypeOf(ProfileImageRestService.prototype), 'create', this).call(this, imagePayload, 'profile-image/');
        }

        /**
         * @ngdoc function
         * @name rest.services.ProfileImageRestService#remove
         * @methodOf rest.services.ProfileImageRestService
         * @function
         *
         * @description
         * Remove an image.
         *
         * @param {string} imageUrl Image identifier
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'remove',
        value: function remove(imageUrl) {

            return _get(ProfileImageRestService.prototype.__proto__ || Object.getPrototypeOf(ProfileImageRestService.prototype), 'remove', this).call(this, imageUrl, 'profile-image/');
        }
    }]);

    return ProfileImageRestService;
}(_baseRestService2.default);

_serviceDependencies.push(ProfileImageRestService);

angular.module('rest.services').service('ProfileImageRestService', _serviceDependencies);

/***/ }),

/***/ "1RHo":
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),

/***/ "1SiJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Devices controller
 */
angular.module('controllers').controller('Devices', ['$scope', '$state', '$stateParams', '$window', 'Auth', 'Util', '$rootScope', function ($scope, $state, $stateParams, $window, Auth, Util, $rootScope) {

    var userId = _index.MeRepository.getMyId();
    $scope.brandName = CWCONFIG.partnerConfig.name;

    if ($stateParams.deploy) {

        // if 'deploy' query param is present, open the deploy modal for that os
        if ($stateParams.deploy === 'apps') {

            $state.go('root.dashboard.devices.ltb.deploy', {
                ltb: 'deploy',
                resourceId: 'new',
                os: Util.getDeviceNavigator()
            }, {
                reload: false,
                inherit: false
            });
        } else {

            /**
             * no condition is set for the current value of the 'deploy' query param so
             * reload the devices page removing the 'deploy' param from the url
             *
             * Note:
             * if the unknown param is left in the url, the deployment modals
             * will not work properly
             */
            $state.go('root.dashboard.devices', {}, {
                inherit: false
            });
        }
    }

    /**
    * Set static values for deviceCategory for Add Device button
    * They are linked to the DeviceCardDirective by sending category like: <device-card category="desktop"></device-card>
    * Do not change them! The function $scope.deployOnCategory will fail with other config.
    */
    $scope.desktop = 'desktop';
    $scope.mobile = 'mobile';

    /**
    * For each received device - calculates if it has antivirus installed or not
    * @param devices
    */
    var updateHasAvInstance = function updateHasAvInstance(devices) {

        devices.forEach(function (device) {

            device.attributes.hasAv = _index2.DevicesProcessor.hasAvInstalled(device.relationships.user.data.id, device.id);
        });

        return devices;
    };

    function calculateDevicesStatus() {

        $scope.onlineDevices = updateHasAvInstance(_index.DevicesRepository.getByState(['online']) || []);
        $scope.offlineDevices = updateHasAvInstance(_index.DevicesRepository.getByState(['offline']) || []);
        $scope.hasDevices = _index2.DevicesProcessor.hasDisplayedDevices();
        $scope.hasMobileDevices = _index2.DevicesProcessor.hasAtLeastOnePhoneOrTablet();
        $scope.hasDesktopDevices = _index2.DevicesProcessor.hasAtLeastOneLaptopOrPc();

        $scope.onlineDesktopDevices = $scope.onlineDevices.filter(function (device) {
            return device.attributes.type === 'pc' || device.attributes.type === 'laptop';
        });
        $scope.onlineMobileDevices = $scope.onlineDevices.filter(function (device) {
            return device.attributes.type === 'phone' || device.attributes.type === 'tablet';
        });

        $scope.offlineDesktopDevices = $scope.offlineDevices.filter(function (device) {
            return device.attributes.type === 'pc' || device.attributes.type === 'laptop';
        });
        $scope.offlineMobileDevices = $scope.offlineDevices.filter(function (device) {
            return device.attributes.type === 'phone' || device.attributes.type === 'tablet';
        });

        // update devices with licenses info
        $scope.onlineDevices = _index2.DevicesProcessor.detectLicenseType($scope.onlineDevices);
        $scope.offlineDevices = _index2.DevicesProcessor.detectLicenseType($scope.offlineDevices);
        $scope.onlineDesktopDevices = _index2.DevicesProcessor.detectLicenseType($scope.onlineDesktopDevices);
        $scope.onlineMobileDevices = _index2.DevicesProcessor.detectLicenseType($scope.onlineMobileDevices);
        $scope.offlineDesktopDevices = _index2.DevicesProcessor.detectLicenseType($scope.offlineDesktopDevices);
        $scope.offlineMobileDevices = _index2.DevicesProcessor.detectLicenseType($scope.offlineMobileDevices);

        // check if the account has a minimum of 5 devices
        var visibleDevices = _index.DevicesRepository.getVisibleDevices();
        $scope.hasMinimumDevices = Object.keys(visibleDevices).length >= 5;
    }

    var devicesLength = _index.DevicesRepository.getAll().length;

    // direct binding for devices
    var devicesObservable = _index.DevicesRepository.getObservable();
    var onNextDevice = function onNextDevice(data) {

        calculateDevicesStatus();

        if (data.length !== devicesLength) {

            $rootScope.showPendingInstallCard = false;
        }
    };
    var devicesSubscriber = devicesObservable.subscribe(onNextDevice, function () {}, function () {});

    // direct binding for licenses
    var licensesObservable = _index.LicensesRepository.getObservable();
    var onNextLicense = function onNextLicense() {

        calculateDevicesStatus();
    };
    var licensesSubscriber = licensesObservable.subscribe(onNextLicense, function () {}, function () {});

    // direct binding for instances
    var instancesObservable = _index2.AppInstancesProcessor.getObservable();
    var onNextInstance = function onNextInstance(data) {

        $scope.instances = data[userId];
        calculateDevicesStatus();
    };
    var instancesSubscriber = instancesObservable.subscribe(onNextInstance, function () {}, function () {});

    $scope.deployOn = function (deviceType) {

        $state.go('root.ltb.devicetype', {
            ltb: 'deploy',
            deviceType: deviceType
        });
    };

    $scope.deployOnCategory = function (category) {

        $state.go('root.dashboard.devices.ltb.deploy', {
            ltb: 'deploy',
            resourceId: 'new',
            deviceCategory: category
        }, {
            reload: false
        });
    };

    $scope.mixpanelBannerClick = function () {

        _RFC2.default.send('ConnectWeb Devices Mobile Banner Click', {
            View: $scope.devicesView
        });
    };

    if (!localStorage.getItem('DevicesView') || localStorage.getItem('DevicesView') === 'list' && !$scope.hasMinimumDevices) {

        localStorage.setItem('DevicesView', 'grid');
    }

    $scope.devicesView = localStorage.getItem('DevicesView');

    _RFC2.default.send('ConnectWeb Devices Open', {
        Source: Auth.loginSource || 'Direct',
        View: $scope.devicesView
    });

    // Calculate which banner should be displayed
    var offerLocalStorageName = Util.deepFind(CWCONFIG, 'features.offerBanner.localStorageName');
    var welcomeOfferWasClosed = localStorage.getItem(offerLocalStorageName) === null ? true : localStorage.getItem(offerLocalStorageName);

    if (!welcomeOfferWasClosed && $scope.devicesView === 'grid' && $scope.hasDevices && !$scope.hasMobileDevices) {

        var decidingValue = Math.floor(Math.random() * 2);

        $scope.displayBanner = decidingValue === 0 ? 'welcome-offer' : 'mobile';
    } else if ($scope.devicesView === 'list' || !$scope.hasDevices || $scope.hasMobileDevices) {

        $scope.displayBanner = 'welcome-offer';
    } else {

        $scope.displayBanner = 'mobile';
    }

    // Save a copy of the calculation to use it afterwards
    var bannerValue = $scope.displayBanner;

    $scope.gridView = function () {

        $scope.devicesView = 'grid';
        localStorage.setItem('DevicesView', $scope.devicesView);

        if (!welcomeOfferWasClosed) {

            $scope.displayBanner = bannerValue;
        } else if (!$scope.hasMobileDevices) {

            $scope.displayBanner = 'mobile';
        }

        _RFC2.default.send('ConnectWeb Devices View Click', {
            View: $scope.devicesView
        });
    };

    $scope.listView = function () {

        $scope.devicesView = 'list';
        localStorage.setItem('DevicesView', $scope.devicesView);

        $scope.displayBanner = 'welcome-offer';

        _RFC2.default.send('ConnectWeb Devices View Click', {
            View: $scope.devicesView
        });
    };

    $scope.$on('$destroy', function () {

        devicesSubscriber.dispose();
        instancesSubscriber.dispose();
        licensesSubscriber.dispose();
    });

    if (!$rootScope.hasUsCompliance) {

        $rootScope.showCmaDisclaimer.banner = false;
    }

    if ($scope.displayBanner === 'mobile') {

        $rootScope.showCmaDisclaimer.banner = false;
    }
}]); /* eslint max-len: 0 */

/***/ }),

/***/ "1WNX":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("15Wi"),
    isArray = __webpack_require__("zOp4");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "1aLy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("mko8");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('services').factory('SessionManagement', ['$modal', '$rootScope', '$interval', function ($modal, $rootScope, $interval) {

    var SessionManagement = {
        start: function start() {

            var self = this;
            this.userInactive = false;
            _RFC6.default.subscribe('session:extended:reset', function () {

                _.bind(this.restartInactivityTimer, this);
            });

            _RFC6.default.subscribe('auth:login', function (data) {

                self.setSessionTimer(data);
                self.__startSessionInterval();
                self.__startInactivityInterval();
            });
        },
        expire: function expire() {

            _RFC6.default.broadcast('session:expired');
            this.__openSessionExpiredModal();
        },
        setSessionTimer: function setSessionTimer(data) {

            var ttlSession = void 0;
            if (data) {

                ttlSession = data.data.expires_in * CWCONFIG.session.ttlToMiliseconds;
                if (ttlSession > 60000) {

                    this.sessionTimeout = ttlSession - 60000;
                } else {

                    this.sessionTimeout = 5000; // set default session expire at 10 seconds
                }
            }
        },


        /*
        Starts session timer. At certain intervals, call refresh session
        */
        __startSessionInterval: function __startSessionInterval() {

            this.sessionInterval = $interval(_.bind(this.__refreshSession, this), this.sessionTimeout);
            _RFC4.default.intervals.push(this.sessionInterval);
        },


        /**
        Start the timer for user inactivity
        */
        __startInactivityInterval: function __startInactivityInterval() {

            var self = this;
            this.inactivityInterval = $interval(function () {

                self.userInactive = true;
            }, CWCONFIG.session.userInactivityTimer); // add constant here
            _RFC4.default.intervals.push(this.inactivityInterval);
        },


        /**
        Checks if remember me token is present or if the user is active.
        Based on that, it silently refreshes
        the session or it is displaying the Session Expired Lightbox
        */
        __refreshSession: function __refreshSession() {

            // if (
            //     $location.path() === '/auth/login' ||
            //     $location.path() === 'auth/forgot'
            // ) {
            //     return;
            // }
            if (!_RFC2.default.get(CWCONFIG.cookie.token) || this.userInactive) {

                // this triggered the session expired view. This should be replaced
                // replace with an alert or with a modal
                $interval.cancel(this.sessionInterval);
                this.expire();
            }
        },
        __openSessionExpiredModal: function __openSessionExpiredModal() {

            $modal.open({
                template: __webpack_require__("u8TA"),
                controller: 'SessionExpire',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'white-modal',
                resolve: {
                    modalParams: function modalParams() {

                        return 'session-expired';
                    }
                }
            });
        },


        /**
        * Clear the former inactivity interval and starts a new one. Call this when
        * a new socket event is triggered, but except refresh session
        */
        restartInactivityTimer: function restartInactivityTimer() {

            $interval.cancel(this.inactivityInterval);
            this.__startInactivityInterval();
        },


        /*
        * Resets session timer and sets the user as active
        */
        restartSessionTimer: function restartSessionTimer() {

            this.__startSessionInterval();
            this.userInactive = false;
        }
    };

    return SessionManagement;
}]); /* eslint func-names: 0 */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "1irE":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div>\n        <div class=\"dwm-upsell-v2\" id=\"dwm-upsell-v2\">\n            <div class=\"header\" id=\"header\">\n                <a class=\"underline-hover link text-l inline-block mt20 text-blue-2 go-back crs-pointer\"\n                    ng-click=\"backToDashboard()\" ng-if=\"!showUpsellPage\">\n                    <i class=\"icon icon-arrow-right-slim inline-block v-middle icon-xxxxs ml10\"></i><span translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.go_back\"></span>\n                </a>\n                <div class=\"container\">\n                    <div class=\"content\">\n                        <h1 class=\"text-xxxl text-grey-1 mt0 font-bold\" translate=\"cw.dwm.upsell.title\"></h1>\n                        <h2 class=\"text-xxl text-grey-3\" translate=\"cw.dwm.upsellv2.subtitle\"></h2>\n                        <ul class=\"features mt30\">\n                            <li class=\"text-grey-3 text-xl\">\n                                <i class=\"icon icon-checkmark icon-green-1\"></i>\n                                <h3 class=\"font-bold text-l text-grey-1\" translate=\"cw.dwm.upsellv2.dwm_label\"></h3>\n                                <p class=\"mt5 text-s text-grey-3\" translate=\"cw.dwm.upsellv2.dwm_description\"></p>\n                            </li>\n                            <li class=\"text-grey-3 text-xl mt20\">\n                                <i class=\"icon icon-checkmark icon-green-1\"></i>\n                                <h3 class=\"font-bold text-l text-grey-1\" translate=\"cw.dwm.upsellv2.restoration_label\"></h3>\n                                <p class=\"mt5 text-s text-grey-3\" translate=\"cw.dwm.upsellv2.restoration_description\"></p>\n                            </li>\n                            <li class=\"text-grey-3 text-xl mt20\">\n                                <i class=\"icon icon-checkmark icon-green-1\"></i>\n                                <h3 class=\"font-bold text-l text-grey-1\" translate=\"cw.dwm.upsellv2.wallet_label\"></h3>\n                                <p class=\"mt5 text-s text-grey-3\" translate=\"cw.dwm.upsellv2.wallet_description\"></p>\n                            </li>\n                        </ul>\n                        <div class=\"mt30 price-boxshot-wrapper\">\n\n                            <div class=\"total-price-wrapper\">\n                                <div class=\"inline-block v-middle line-through\">\n                                    {{currentPrice.attributes.promotion.pc_price_string}}\n                                    <span>/<span translate=\"cw.general.year\">\n                                </div>\n                                <div class=\"inline-block v-middle\">\n                                    (-{{currentPrice.attributes.promotion.discount}}%)\n                                </div>\n                            </div>\n\n                            <div class=\"block\">\n                                <app-price appid=\"'adwp1' + '_12_1'\"\n                                    showyearlabel=\"true\"\n                                    showtotalprice=\"false\"\n                                    showcmalabel=\"true\"\n                                    class=\"price-wrapper\">\n                                </app-price>\n\n                                <a class=\"btn btn-medium btn-primary mt15 mb15\" ng-click=\"buy('aia-staging')\" ng-show=\"!showOPCButton || !isOneClickPaymentEnable\"\n                                    translate=\"cw.general.subscribe_now\">\n                                </a>\n\n                                <ocp-button classname='\"btn btn-medium btn-primary mt15 mb15\"' translationkey=\"'cw.general.subscribe_now'\"\n                                    action='\"Update\"' productid=\"'adwp1'\" runtime='\"12\"' page=\"'AIA Store Page'\" xacontent='\"aia_store_page_ocp_\"'\n                                    xamedium='\"aia_store_page_ocp_\"' xaaiatest=\"xParamAiaTest\" xabutton='\"aia-staging\"'>\n                                </ocp-button>\n\n                                <app-price appid=\"'adwp1' + '_12_1'\"\n                                    showyearlabel=\"true\"\n                                    showtotalprice=\"false\"\n                                    showcmalabel=\"false\"\n                                    class=\"price-wrapper\">\n                                </app-price>\n\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"container\">\n                <div class=\"detail-cards-row text-center\">\n                    <div class=\"card\">\n                        <div class=\"card-icon\">\n                            <span class=\"number text-grey-1\">24</span><span class=\"percent text-grey-3\">%</span>\n                        </div>\n                        <p class=\"text-l font-bold text-grey-1 title mb15\" translate=\"cw.dwm.upsellv2.statistics_identity_theft\"></p>\n                    </div>\n                    <div class=\"card\">\n                        <div class=\"card-icon\">\n                            <span class=\"number text-grey-1\">31</span><span class=\"percent text-grey-3\">%</span>\n                        </div>\n                        <p class=\"text-l font-bold text-grey-1 title mb15\" translate=\"cw.dwm.upsellv2.statistics_unauthorized_access\"></p>\n                    </div>\n                    <div class=\"card\">\n                        <div class=\"card-icon\">\n                            <span class=\"number text-grey-1\">12</span><span class=\"percent text-grey-3\">%</span>\n                        </div>\n                        <p class=\"text-l font-bold text-grey-1 title mb15\" translate=\"cw.dwm.upsellv2.statistics_social_media\"></p>\n                    </div>\n                </div>\n                <p class=\"text-s text-grey-3 mt15 text-center\"\n                    translate=\"cw.dwm.upsellv2.statistics_survey\"\n                    translate-values=\"{onlineSurvey : onlineSurvey}\">\n                </p>\n            </div>\n\n            <div>\n                <div class=\"container\">\n                    <h1 class=\"text-grey-1 font-bold section-title text-center\" translate=\"cw.dwm.upsellv2.how_it_works_title\"></h1>\n\n                    <div class=\"onboarding\">\n                        <div class=\"dashboard-tabs-holder\">\n                            <div class=\"dashboard-tabs text-left\">\n                                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': activeScreen === 'screen-1'}\" ng-click=\"changeActiveScreen('screen-1', 'DWM Tab')\" translate=\"cw.dwm.upsellv2.dwm_label\"></span>\n                                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': activeScreen === 'screen-2'}\" ng-click=\"changeActiveScreen('screen-2', 'IRS Tab')\" translate=\"cw.dwm.upsellv2.restoration_label\"></span>\n                                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': activeScreen === 'screen-3'}\" ng-click=\"changeActiveScreen('screen-3', 'SWA Tab')\" translate=\"cw.dwm.upsellv2.wallet_label\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"onboarding-screens\">\n                            <div class=\"screen-1\" ng-if=\"activeScreen === 'screen-1'\">\n                                <div class=\"grid\">\n                                    <div class=\"left-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.dwm_tab_picture1\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.dwm_tab_picture2\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"left-bottom\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.dwm_tab_picture3\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-bottom\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.dwm_tab_picture4\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"screen-2\" ng-if=\"activeScreen === 'screen-2'\">\n                                <div class=\"grid\">\n                                    <div class=\"left-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.restoration_tab_picture1\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.restoration_tab_picture2\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"left-bottom\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.restoration_tab_picture3\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-bottom support-card\">\n                                        <div class=\"item\">\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.restoration_tab_picture4\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"screen-3\" ng-if=\"activeScreen === 'screen-3'\">\n                                <div class=\"grid\">\n                                    <div class=\"left-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.wallet_tab_picture1\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-top\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.wallet_tab_picture2\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"left-bottom\">\n                                        <div class=\"item\">\n                                            <div class=\"item-image\"></div>\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.wallet_tab_picture3\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"right-bottom support-card\">\n                                        <div class=\"item\">\n                                            <div class=\"item-body\">\n                                                <p class=\"text-s font-bold text-grey-1\" translate=\"cw.dwm.upsellv2.wallet_tab_picture4\"></p>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"container\">\n                <h1 class=\"text-grey-1 font-bold section-title text-center\" translate=\"cw.dwm.upsellv2.faq_label\"></h1>\n                <div class=\"faqs\">\n                    <div class=\"faq\" ng-repeat=\"question in faqs\" ng-class=\"{'active': activeQuestion === question}\">\n                        <div class=\"question-wrapper\">\n                            <i class=\"icon icon-arrow-down text-blue-1\"></i>\n                            <div class=\"click-area crs-pointer\" ng-click=\"changeQuestion(question)\"></div>\n                            <h3 class=\"question text-l text-grey-1 font-bold\" translate=\"{{'cw.dwm.upsellv2.faq.q_' + question}}\"></h3>\n                        </div>\n                        <div class=\"answer text-s text-grey-3\" translate=\"{{'cw.dwm.upsellv2.faq.a_' + question}}\"></div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"container\">\n                <div class=\"footer\">\n                    <p class=\"text-m text-grey-3 mb15\" translate=\"cw.dwm.upsellv2.identity_theft_note\"></p>\n                    <p class=\"text-m text-grey-3 mb15\" translate=\"cw.dwm.upsellv2.dwm_note\"></p>\n                    <p class=\"text-m text-grey-3 mb15\" translate=\"cw.dwm.upsellv2.restoration_note\"></p>\n                </div>\n            </div>\n\n            <div class=\"sticky-banner\"\n                ng-class=\"{'visible': showStickyBanner, 'hasFooterCookie': hasFooterCookie}\"\n                id=\"sticky-banner\"\n            >\n                <div class=\"content\">\n                    <div class=\"section\">\n                        <p class=\"text-m text-grey-3\"\n                            translate=\"cw.dwm.upsellv2.banner_title\"\n                            translate-values=\"{discount : {{currentPrice.attributes.promotion.discount}}}\">\n                        </p>\n                    </div>\n                    <div class=\"section\">\n                        <div class=\"inline-block v-middle sale-price mr10\">\n                            <app-price appid=\"'adwp1' + '_12_1'\"\n                                showyearlabel=\"true\"\n                                showtotalprice=\"false\"\n                                showcmalabel=\"false\"\n                                class=\"price-wrapper\">\n                            </app-price>\n                        </div>\n\n                        <div class=\"inline-block v-middle line-through mr10\">\n                            {{currentPrice.attributes.promotion.pc_price_string}}\n                            <span>/<span translate=\"cw.general.year\">\n                        </div>\n\n                        <div class=\"inline-block v-middle\">\n                            <a class=\"btn btn-medium btn-primary\" ng-click=\"buy('aia-sticky')\" ng-show=\"!showOPCButton || !isOneClickPaymentEnable\"\n                                translate=\"cw.general.subscribe_now\">\n                            </a>\n\n                            <ocp-button classname='\"btn btn-medium btn-primary\"' translationkey=\"'cw.general.subscribe_now'\"\n                                action='\"Update\"' productid=\"'adwp1'\" runtime='\"12\"' page=\"'AIA Store Page'\" xacontent='\"aia_store_page_ocp_\"'\n                                xamedium='\"aia_store_page_ocp_\"' xaaiatest=\"xParamAiaTest\" xabutton='\"aia-sticky\"'>\n                            </ocp-button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n        <cma-disclaimer></cma-disclaimer>\n    </div>\n    <link rel=\"preconnect\" href=\"https://fonts.googleapis.com\">\n    <link rel=\"preconnect\" href=\"https://fonts.gstatic.com\" crossorigin>\n    <link href=\"https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap\" rel=\"stylesheet\">\n</div>\n"

/***/ }),

/***/ "1zte":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("0huu");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "2GqT":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("ujNk");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "2Tt8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @ngdoc service
 * @name filters.dateInMiliseconds
 *
 * @description
 * Convert date in miliseconds
 *
 * @param dateParam e.g. '2018-12-29T00:00:00Z'
 */

angular.module('filters').filter('dateInMiliseconds', function () {
    return function (dateParam) {

        if (!dateParam) {

            return '';
        }

        var date = new Date(dateParam);

        return parseInt(date.getTime(), 10);
    };
});

/***/ }),

/***/ "2ZBq":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"content-wrapper card\" connectqa-crypto-section=\"Mining cryptocurrency\">\n        <div class=\"mining tab-content\">\n            <div class=\"crypto-card-header display-flex justify-content-space-between align-item-center\">\n                <div>\n                    <i class=\"icon icon-crypto-mining round-icon\"></i>\n                    <h2 class=\"inline-block v-middle text-grey-1\"\n                        translate=\"cw.dashboard.crypto.mining.mining_crypto\">\n                    </h2>\n                </div>\n                <div class=\"text-right\" ng-if=\"rigs.length > 0\">\n                    <p ng-if=\"isMining\" class=\"text-green-1 uppercase text-l\" translate=\"cw.dashboard.crypto.tabs.mining\">\n                    </p>\n                    <p ng-if=\"!isMining\" class=\"text-red-2 uppercase text-l\" translate=\"cw.dashboard.crypto.mining.mining_off\"></p>\n                    <p class=\"text-grey-2 text-l\">{{overallHashRate}}</p>\n                </div>\n            </div>\n            <div class=\"loader-wrapper\" ng-if=\"payoutConfigIsLoading\">\n                <div class=\"main-loader\"></div>\n            </div>\n\n            <div ng-if=\"!payoutConfigIsLoading\">\n                <div\n                    class=\"display-flex justify-content-space-between align-item-center mt30 next-payout-info\">\n                    <div ng-if=\"pendingBalance\" class=\"text-left\">\n                        <div class=\"inline-block text-center\">\n                            <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.mining.pending_payout\"></p>\n                            <p class=\"text-xl text-grey-1 mt5\">{{pendingBalance}} {{currency}}</p>\n                        </div>\n                    </div>\n                    <div ng-if=\"payoutConfig\" class=\"text-center\">\n                        <div class=\"inline-block text-center\">\n                            <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.mining.minimum_payout\"></p>\n                            <p class=\"text-xl text-grey-1 mt5\">{{payoutConfig}} {{currency}}</p>\n                        </div>\n                    </div>\n                    <div class=\"text-right\">\n                        <div class=\"inline-block text-center\">\n                            <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.mining.payout_frequency\"></p>\n                            <p class=\"text-xl text-grey-1 mt5\" translate=\"cw.dashboard.crypto.mining.minutes\"\n                            translate-values=\"{ minutes : '10' }\"></p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"content-wrapper card mt50\" connectqa-crypto-section=\"My devices\">\n        <div class=\"mining tab-content\">\n            <div class=\"crypto-card-header display-flex justify-content-space-between align-item-center\">\n                <div>\n                    <i class=\"icon icon-crypto-devices large-icon inline-block v-middle\"></i>\n                    <h2 class=\"inline-block v-middle text-grey-1\"\n                        translate=\"cw.dashboard.crypto.mining.my_devices\">\n                    </h2>\n                </div>\n            </div>\n            <div class=\"loader-wrapper\" ng-if=\"miningIsLoading\">\n                <div class=\"main-loader\"></div>\n            </div>\n\n            <div ng-if=\"!miningIsLoading\">\n                <div ng-if=\"rigs.length === 0\" class=\"mt20\">\n                    <p class=\"text-xxl text-grey-3 mt40\" translate=\"cw.dashboard.crypto.mining.no_devices\"></p>\n                </div>\n                <div ng-if=\"rigs.length > 0\" class=\"mt20\">\n                    <div class=\"table-wrapper\">\n                        <table>\n                            <thead>\n                                <tr>\n                                    <td class=\"text-grey-2 text-l font-bold uppercase\" translate=\"cw.dashboard.crypto.mining.computer\"></td>\n                                    <td class=\"text-grey-2 text-l font-bold uppercase text-center\" translate=\"cw.dashboard.crypto.tabs.mining\"></td>\n                                    <td class=\"text-right\">\n                                        <span\n                                            class=\"text-grey-2 text-l font-bold uppercase inline-block v-middle mr5\" translate=\"cw.dashboard.crypto.mining.hashrate\"></span>\n                                        <span class=\"info-tooltip-holder hashrate-tooltip inline-block v-middle\">\n                                            <span class=\"icon icon-info-2 icon-blue-2 icon-xs\"></span>\n                                            <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.dashboard.crypto.mining.hashrate_desc\"></div>\n                                        </span>\n                                    </td>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr ng-repeat=\"rig in rigs\">\n                                    <td>\n                                        <i class=\"icon-pc-windows icon inline-block v-middle icon-grey-3 mr10\"></i>\n                                        <span class=\"text-grey-3 text-m inline-block v-middle\">{{rig.name}}</span>\n                                    </td>\n                                    <td class=\"text-green-1 text-m uppercase text-center\" ng-if=\"rig.isMining\" translate=\"cw.dashboard.crypto.mining.on\"></td>\n                                    <td class=\"text-red-2 text-m uppercase text-center\" ng-if=\"!rig.isMining\" translate=\"cw.dashboard.crypto.mining.off\"></td>\n                                    <td class=\"text-grey-3 text-m text-right\">{{rig.updatedHash}}</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "2fRx":
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__("AeKI"),
    baseIteratee = __webpack_require__("EAyW"),
    baseSome = __webpack_require__("2GqT"),
    isArray = __webpack_require__("zOp4"),
    isIterateeCall = __webpack_require__("c5ad");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "2kat":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$timeout'];

var DownloadTooltipController = function DownloadTooltipController($timeout) {
    _classCallCheck(this, DownloadTooltipController);

    this.$timeout = $timeout;
    this.isNotificationVisible = false;
};

var DownloadTooltipDirective = function DownloadTooltipDirective() {
    _classCallCheck(this, DownloadTooltipDirective);

    this.template = __webpack_require__("JiTH");
    this.restrict = 'E';
    this.replace = true;

    _controllerDependencies.push(function ($timeout) {
        return new DownloadTooltipController($timeout);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DownloadTooltipCtrl';
};

_directiveDependencies.push(function () {
    return new DownloadTooltipDirective();
});

angular.module('directives').directive('downloadTooltip', _directiveDependencies);

/***/ }),

/***/ "2mhJ":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("sd1L"),
    setCacheAdd = __webpack_require__("3Bpx"),
    setCacheHas = __webpack_require__("Wkhp");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "2tFT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('templates').constant('Templates', {
    modal: {
        base: '/views/modals/base.html',
        marketingCard: '/views/modals/marketing-card.html',
        sessionExpired: '/views/modals/session-expired.html',
        outdatedBrowser: '/views/modals/outdated-browser.html',
        register: '/views/modals/register.html',
        forgotPassword: '/views/modals/forgot-password.html',
        removeDevice: '/views/modals/remove-device.html',
        deploy: '/views/modals/deploy.html',
        subscriptionConfirmation: '/views/modals/subscription-confirmation.html',
        antitheftPlaySound: '/scripts/controllers/modals/antitheft/antitheft-play-sound.html',
        antitheftDeviceReport: '/views/modals/antitheft-devicereport.html',
        antitheftWipeData: '/views/modals/antitheft-wipedata.html',
        antitheftDeviceLock: '/scripts/controllers/modals/antitheft/antitheft-device-lock.html',
        antitheftDeviceUnlock: '/scripts/controllers/modals/antitheft/antitheft-device-unlock.html',
        antitheftCallDevice: '/views/modals/antitheft-calldevice.html',
        applockLock: '/views/modals/applockplus-lock.html',
        lockDevice: '/scripts/controllers/modals/device/lock-device/lock-device.html',
        unlockDevice: '/scripts/controllers/modals/device/unlock-device/unlock-device.html',
        activationConfirmation: '/views/modals/activation-confirmation.html',
        myAccount: {
            cropImage: '/scripts/controllers/modals/my-account/crop-image/crop-image.html'
        },
        changeLang: '/scripts/controllers/modals/change-lang/change-lang.html',
        languageSwitcher: '/scripts/directives/dashboard/header/language-switcher/language-switcher.html'
    },
    dashboard: {
        base: '/scripts/controllers/dashboard/dashboard.html',
        navigation: '/scripts/controllers/dashboard/navigation/navigation.html',
        products: '/scripts/controllers/dashboard/body/content/products/products.html',
        subscriptions: '/scripts/controllers/dashboard/body/content/subscriptions/subscriptions.html',
        body: '/scripts/controllers/dashboard/body/body.html',
        product: '/scripts/controllers/dashboard/body/content/service-details/service-details.html',
        store: '/scripts/controllers/dashboard/body/content/store/store.html',
        devices: '/scripts/controllers/dashboard/body/content/devices/devices.html',
        deviceDetails: '/scripts/controllers/dashboard/body/content/device-details/device-details.html',
        myAccount: '/scripts/controllers/dashboard/body/content/my-account/my-account.html',
        modals: {
            criticalError: '/scripts/controllers/modals/critical-error/critical-error.html'
        }
    },
    overview: {
        antitheft: '/views/overview/antitheft.html'
    },
    events: '/scripts/directives/dashboard/events/events.html',
    auth: {
        login: '/scripts/controllers/auth/login/login.html',
        setPassword: '/scripts/controllers/auth/set-password/set-password.html',
        landingSetPassword: '/scripts/controllers/auth/set-password/landing-set-password.html',
        tfa: '/scripts/controllers/auth/tfa/tfa.html',
        reset: '/scripts/controllers/auth/reset/reset.html',
        register: '/scripts/controllers/auth/register/register.html',
        forgot: '/scripts/controllers/auth/forgot/forgot.html',
        landingPage: './controllers/auth/landing-page.html',
        confirm: '/scripts/controllers/auth/confirm/confirm.html'
    },
    alert: '/views/alert.html',
    countrySelector: '/views/country-selector.html',

    directives: {
        controls: {
            fancyCheckbox: '/views/directives/controls/fancy-checkbox.html'
        },
        header: '/scripts/directives/dashboard/header/header.html',
        userSettings: '/scripts/directives/dashboard/header/user-settings/user-settings.html',
        accountChooser: '/scripts/directives/dashboard/header/account-chooser/account-chooser.html',
        userEvents: '/scripts/directives/dashboard/header/user-events/user-events.html',
        userInfo: '/scripts/directives/dashboard/header/user-info/user-info.html',
        deviceCard: '/scripts/directives/dashboard/device-card/device-card.html',
        breadcrumb: '/scripts/directives/dashboard/breadcrumb/breadcrumb.html',
        deploymentWizardGenerator: '/scripts/directives/dashboard/deployment/wizard-generator/deployment-wizard-generator.html',
        pcDeploymentWizard: '/scripts/directives/dashboard/deployment/pc-deployment-wizard/pc-deployment-wizard.html',
        pcEmailDeploymentSuccess: '/scripts/directives/dashboard/deployment/pc-email-deployment-success/pc-email-deployment-success.html',
        pcDownloadDeploymentSuccess: '/scripts/directives/dashboard/deployment/pc-download-deployment-success/pc-download-deployment-success.html',
        phoneSmsDeploymentSuccess: '/scripts/directives/dashboard/deployment/phone-sms-deployment-success/phone-sms-deployment-success.html',
        onlineDeploymentSuccess: '/scripts/directives/dashboard/deployment/online-deployment/online-deployment.html',
        phoneDeploymentWizard: '/scripts/directives/dashboard/deployment/phone-deployment-wizard/phone-deployment-wizard.html',
        phoneEmailDeploymentSuccess: '/scripts/directives/dashboard/deployment/phone-email-deployment-success/phone-email-deployment-success.html',
        chooseDeviceDeploymentWizard: '/scripts/directives/dashboard/deployment/choose-device-deployment-wizard/choose-device-deployment-wizard.html',
        chooseOsTypeDeploymentWizard: '/scripts/directives/dashboard/deployment/choose-os-type-deployment-wizard' + '/choose-os-type-deployment-wizard.html',
        chooseOsTypeWizard: '/scripts/directives/dashboard/deployment/choose-os-type-wizard.html',
        offlineDeploymentSuccess: '/scripts/directives/dashboard/deployment/offline-deployment/offline-deployment.html',
        paidDeploymentWizard: '/scripts/directives/dashboard/deployment/paid-deployment-wizard/paid-deployment-wizard.html',
        passwordStrength: '/scripts/directives/dashboard/auth/password-strength/password-strength.html',
        changeLanguage: '/scripts/controllers/auth/change-language/change-language.html',
        myAccount: {
            profile: {
                profileDetails: '/scripts/directives/dashboard/my-account/profile/' + 'profile-details/profile-details.html',
                profileImage: '/scripts/directives/dashboard/my-account/profile/' + 'profile-image/profile-image.html'
            },
            security: {
                securityPassword: '/scripts/directives/dashboard/my-account/security/' + 'security-password/security-password.html',
                twoFactorAuth: '/scripts/directives/dashboard/my-account/security/' + 'two-factor-auth/two-factor-auth.html'
            },
            notifications: '/scripts/directives/dashboard/my-account/notifications/' + 'notifications.html',
            dataSettings: {
                userData: '/scripts/directives/dashboard/my-account/data-settings/' + 'user-data/user-data.html',
                disableAccount: '/scripts/directives/dashboard/my-account/data-settings/' + 'disable-account/disable-account.html',
                deleteAccount: '/scripts/directives/dashboard/my-account/data-settings/' + 'delete-account/delete-account.html'
            }
        },
        deviceSettings: '/scripts/directives/dashboard/device-settings/device-settings.html'
    },
    device: {
        settings: '/scripts/directives/device/device-settings.html'
    },
    landingPages: {
        downloadKit: '/views/landingPages/download-kit.html',
        underMaintenance: '/views/landingPages/under-maintenance.html',
        notAllowed: '/scripts/controllers/landing-pages/not-allowed/not-allowed.html'
    },
    debug: '/views/directives/custom-debug.html'
});

/***/ }),

/***/ "35YC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var captchaResponse = void 0;
var widgetId = void 0;
var requiredCaptcha = false;

var Recaptcha = {

    captchaRetries: CWCONFIG.captchaConfig.captchaRetries,
    captchaKey: CWCONFIG.captchaConfig.captchaKey,

    /**
     * Initializer for the recaptcha service - loads a <script> tag in the dom
     */
    init: function init() {

        // disabled cus since angular-recaptcha@4.0
        // the script loading is done in the library

        // const SCRIPT_ID = 'captchaSrc';

        // if (window.document.getElementById(SCRIPT_ID)) {

        //     return;

        // }

        // const captchaScript = window.document.createElement('script');
        // captchaScript.type = 'text/javascript';
        // captchaScript.id = SCRIPT_ID;
        // captchaScript.async = true;
        // captchaScript.defer = true;
        // captchaScript.src = CWCONFIG.captchaConfig.captchaUrl + CWCONFIG.language;
        // const jsScripts = window.document.getElementsByTagName('script')[0];
        // jsScripts.parentNode.insertBefore(captchaScript, jsScripts);

        // this.disableCaptcha();

    },
    setWidgetId: function setWidgetId(id) {

        widgetId = id;
    },
    getWidgetId: function getWidgetId() {

        return widgetId;
    },
    execute: function execute() {

        if (window.grecaptcha) {

            window.grecaptcha.execute(widgetId);
        }
    },
    reset: function reset() {

        if (window.grecaptcha) {

            window.grecaptcha.reset(widgetId);
        }
    },
    setCaptchaResponse: function setCaptchaResponse(response) {

        captchaResponse = response;
        this.disableCaptcha();
        this.reset(widgetId);
    },
    getCaptchaResponse: function getCaptchaResponse() {

        return captchaResponse || false;
    },
    enableCaptcha: function enableCaptcha() {

        requiredCaptcha = true;
    },
    disableCaptcha: function disableCaptcha() {

        requiredCaptcha = false;
    },
    isCaptchaRequired: function isCaptchaRequired() {

        return requiredCaptcha && window.grecaptcha;
    }
};

exports.default = Recaptcha;

/***/ }),

/***/ "37Sf":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"card-header\">\n        <h3 class=\"text-grey-1 text-l font-bold\" translate=\"cw.homepage.account.title\"></h3>\n        <p class=\"text-s text-grey-3\"\n            translate=\"cw.homepage.account.registration_date\"\n            translate-values=\"{year: '{{yearAdded}}', brandname : '{{brandName}}'}\"></p>\n    </div>\n    <div class=\"inline-block left-column text-center v-middle\">\n        <div class=\"account-icon\"></div>\n    </div>\n    <div class=\"inline-block right-column v-middle\">\n        <h4 class=\"text-m text-grey-1 mb5\" translate=\"cw.homepage.account.content.title\"></h4>\n        <p class=\"text-s text-grey-3 mb5\" translate=\"cw.homepage.account.content.desc\"></p>\n        <a ui-sref=\"root.dashboard.my-account({tab: 'profile'})\" \n            class=\"text-s text-blue-1 bottom-link\" \n            translate=\"cw.homepage.general.see_more\"\n            ng-click=\"sendAccountMixpanel('See more')\"></a>\n    </div>\n</div>"

/***/ }),

/***/ "3AGJ":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "3Bpx":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "3EC6":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"modal-onb\"></div>\n    <div class=\"logo-area\">\n        <a href=\"https://www.avira.com\" class=\"btn-logo-back inline-block icon chevron-back-2 icon-grey-4 icon-xs\" ng-if=\"referralCode == 'website'\"></a>\n        <a id=\"avira-connect-logo\" ui-sref=\"root.dashboard.home\" class=\"logo-nd mb60 inline-block\" ng-click=\"onClickLogo()\">\n            <i class=\"sprite sprite-logo inline-block v-top\"></i>\n            <span class=\"text-l text-grey-1 inline-block v-top\" translate=\"cw.application_name_v3\"\n                translate-values=\"{name: '{{$root.State.partner.name}}'}\"\n            ></span>\n        </a>\n    </div>\n\n    <!-- Menu for pc/laptop -->\n    <div class=\"sidebar-menu\" ng-class=\"{'show-shadow': scrollTop !== 0}\">\n        <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n\n            <div>\n                <h6 class=\"text-s font-medium text-grey-3 uppercase mb10\" translate=\"cw.general.general\"></h6>\n                <ul class=\"mb25 text-grey-4\">\n                    <li ng-if=\"visiblePages.dashboard\"\n                        ng-class=\"{'active': currentStateName === 'root.dashboard.home'}\"\n                        connectqa-menu=\"digital-health\"\n                        id=\"featurePoint\">\n\n                        <a ui-sref=\"root.dashboard.home\" ng-click=\"onClickMenu('home')\">\n                            <i class=\"icon icon-dashboard icon-grey-4 icon-xs\"></i>\n                            <span class=\"text-l text-grey-3\" translate=\"cw.general.dashboard\"></span>\n                            <span class=\"point-circle\" ng-if=\"showFtuTooltip\"></span>\n                        </a>\n                    </li>\n                    <li ng-if=\"visiblePages.devices\"\n                        ng-class=\"{'active': currentStateName === 'root.dashboard.devices' ||\n                            currentStateName === 'root.dashboard.device-details' ||\n                            currentStateName === 'root.dashboard.device-details.app-details'}\" connectqa-menu=\"devices\">\n                        <a ui-sref=\"root.dashboard.devices\" ng-click=\"onClickMenu('devices')\">\n                            <i class=\"icon icon-pc-phone icon-grey-4 icon-xs\"></i>\n                            <span translate=\"cw.menu.devices\" class=\"text-l text-grey-3\"></span>\n                        </a>\n                    </li>\n                    <li ng-if=\"visiblePages.products && $root.hasUsCompliance\"\n                        ng-class=\"{'active': currentStateName === 'root.dashboard.products'}\" connectqa-menu=\"free-products\">\n                        <a ui-sref=\"root.dashboard.products\" ng-click=\"onClickMenu('freeProducts')\">\n                            <i class=\"icon icon-download icon-grey-4 icon-xs\"></i>\n                            <span translate=\"cw.section.products_section.title\" class=\"text-l text-grey-3\"></span>\n                        </a>\n                    </li>\n\n                    <li ng-if=\"visiblePages.subscriptions && !$root.showSubscriptionsLinkInMyAccountDropdown\"\n                        ng-class=\"{'active': currentStateName === 'root.dashboard.subscriptions' && $root.activeNavSection !== 'renewal'}\" connectqa-menu=\"subscriptions\"\n                        >\n                        <a ui-sref=\"root.dashboard.subscriptions({tab:'plans'})\" ng-click=\"onClickMenu('subscriptions')\">\n                            <i class=\"icon icon-subscriptions icon-grey-4 icon-xs\"></i>\n                            <span translate=\"cw.section.subscriptions.title\" class=\"text-l text-grey-3\"></span>\n                            <div class=\"info-tooltip-holder license-notice mr10 crs-pointer ng-scope fl-right\"\n                                ng-if=\"!isSubscriptionsPage && (showWarning || showWarningTrial) && $root.hasUsCompliance\">\n                                <span class=\"icon icon-xs icon-warning-filled icon-orange-2\"></span>\n                                <div class=\"info-tooltip arrow-bottom\"\n                                    translate=\"cw.subscriptions.expiring_tooltip\"></div>\n                            </div>\n                        </a>\n                    </li>\n                    <li ng-if=\"visiblePages.subscriptions && $root.cmaGBapplies && !$root.isMobileAppSession\" class=\"renewal-settings\"\n                        ng-class=\"{'active': $root.activeNavSection === 'renewal'}\" connectqa-menu=\"renewal-settings\">\n                        <a ui-sref=\"root.dashboard.subscriptions({tab:'plans'})\" ng-click=\"onClickMenu('renewal')\">\n                            <i class=\"icon icon-renwewal-settings icon-grey-4 icon-xs\"></i>\n                            <span class=\"text-l text-grey-3\" translate=\"cw.navigation.renewal_settings\"></span>\n                        </a>\n                    </li>\n                    <li ng-class=\"{'active': currentStateName === 'root.dashboard.store'}\"\n                        ng-if=\"!hasTPLinkLicence && visiblePages.store && $root.hasUsCompliance && !$root.isMobileAppSession\"\n                        connectqa-menu=\"store\">\n\n                        <a ng-click=\"onClickMenu('store')\" ui-sref=\"root.dashboard.store\">\n                            <i class=\"icon icon-store icon-grey-4 icon-xs\"></i>\n                            <span ng-if=\"!showPrimePage\" translate= \"cw.dashboard.store.title\" class=\"text-l text-grey-3\"></span>\n                            <span ng-if=\"showPrimePage\" translate= \"cw.dashboard.exclusiveOffer.title\" class=\"text-l text-grey-3\"></span>\n                            <span class=\"label-medium label-green label-position-right\" translate=\"cw.ui.general.new\"\n                                ng-if=\"$root.hideCryptoTab\"\n                                ng-hide=\"$root.showDwmLeftNavigation\"\n                            ></span>\n                        </a>\n\n                    </li>\n                </ul>\n            </div>\n\n            <div>\n\n                <h6 ng-if=\"$root.hasUsCompliance\" class=\"text-s font-medium text-grey-3 uppercase mb10\" translate=\"cw.general.services\"></h6>\n\n                <ul class=\"text-grey-4\">\n\n                    <li ng-if=\"visiblePages.pwm && $root.hasUsCompliance\"\n                        ng-if=\"browserName !== 'ie'\" connectqa-menu=\"passm\">\n                        <a ng-click=\"onClickMenuApp('pass1')\">\n                            <i class=\"icon icon-passm icon-grey-4 icon-xs\"></i>\n                            <span class=\"text-l text-grey-3 ng-scope\">{{productName}}</span>\n                        </a>\n                    </li>\n\n                    <li ng-class=\"{'active': currentStateName === 'root.dashboard.dwm'}\"\n                        ng-if=\"$root.showDwmLeftNavigation && $root.hasUsCompliance\" connectqa-menu=\"DWM\">\n                        <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\" ng-click=\"onClickMenu('aia')\">\n                            <i class=\"icon icon-dwm icon-grey-4 icon-xs\"></i>\n                            <span class=\"text-l text-grey-3\" translate=\"cw.app_name.dwm\"></span>\n                            <span class=\"label-medium label-green label-position-right\" translate=\"cw.ui.general.new\"></span>\n                        </a>\n                    </li>\n\n                    <li ng-class=\"{'active': currentStateName === 'root.dashboard.crypto'}\"\n                        ng-if=\"!$root.hideCryptoTab && $root.hasUsCompliance\"\n                        connectqa-menu=\"Avira Crypto\">\n                        <a ui-sref=\"root.dashboard.crypto({tab:'mining'})\">\n                            <i class=\"icon icon-crypto-navigation icon-grey-4 icon-xs\"></i>\n                            <span class=\"text-l text-grey-3\">Avira Crypto</span>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n\n            <div>\n                <ul class=\"mb25 text-grey-4\">\n                    <li ng-if=\"visiblePages.support && $root.hasUsCompliance\"\n                        ng-class=\"{'active': currentStateName === 'root.dashboard.support'}\" connectqa-menu=\"support\">\n                        <a ui-sref=\"root.dashboard.support({tab:'support'})\"\n                            ng-click=\"onClickMenu('support')\"\n                            ng-if=\"supportForPaidUsers\">\n                            <i class=\"icon icon-vip-support icon-grey-4 icon-xs\"></i>\n                            <span translate=\"cw.section.support.title\" class=\"text-l text-grey-3\"></span>\n                        </a>\n                        <a ng-href=\"{{ supportForFreeUsersLink }}\"\n                            ng-click=\"onClickMenu('support')\"\n                            target=\"_blank\"\n                            ng-if=\"!supportForPaidUsers\">\n                            <i class=\"icon icon icon-vip-support icon-grey-4 icon-xs\"></i>\n                            <span translate=\"cw.section.support.title\" class=\"text-l text-grey-3\"></span>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <div class=\"dark-mode-button-holder\" ng-style=\"$root.cookieBannerHeight\">\n        <div class=\"switch-button-theme v-middle crs-pointer\"\n            ng-class=\"{'enabled' : $root.State.theme === 'dark'}\"\n            ng-click=\"changeTheme(darkModeActivated)\">\n            <span class=\"switch-knob\"></span>\n        </div>\n        <span class=\"text-l text-grey-3 dark-mode-text\" translate=\"cw.general.dark_mode\"></span>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "3Onw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var initAppState = ['$rootScope', function ($rootScope) {

    // making explicit what properties the state object holds
    $rootScope.State = {
        page: null,
        state: null,
        ftu: null,
        loading: null,
        finishedLoadingAnimation: null,
        isThirdPartyLogin: null,
        deviceId: null,
        noscroll: null,
        skipFtu: null,
        hideDashboard: null,
        origin: null,
        hasModal: null,
        previousUrl: null,
        npsScore: null,
        theme: null,
        isFromSpotlightWebApp: null,
        deploySteps: [],
        partner: CWCONFIG.partnerConfig || null,
        unsubscribeAnimation: null
    };

    var partnerId = CWCONFIG.partnerConfig.themeId;
    window.document.body.className += ' ' + partnerId;
}];

exports.default = initAppState;

/***/ }),

/***/ "3Pqa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.UserRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */

var UserRestService = function (_BaseRestService) {
    _inherits(UserRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function UserRestService($http, $q, Util) {
        _classCallCheck(this, UserRestService);

        return _possibleConstructorReturn(this, (UserRestService.__proto__ || Object.getPrototypeOf(UserRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.UserRestService#create
    * @methodOf rest.services.UserRestService
    * @function
    *
    * @description
    * Creates a user.
    *
    * @param {object} userPayload User payload
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(UserRestService, [{
        key: 'create',
        value: function create(userPayload, headers) {

            return _get(UserRestService.prototype.__proto__ || Object.getPrototypeOf(UserRestService.prototype), 'create', this).call(this, userPayload, 'users/', headers);
        }

        /**
         * @ngdoc function
         * @name rest.services.UserRestService#getMeAsync
         * @methodOf rest.services.UserRestService
         * @function
         *
         * @description
         * Retrieves the logged user.
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getMeAsync',
        value: function getMeAsync() {

            return _get(UserRestService.prototype.__proto__ || Object.getPrototypeOf(UserRestService.prototype), 'getAllAsync', this).call(this, 'me/');
        }

        /**
         * @ngdoc function
         * @name rest.services.UserRestService#getAllAsync
         * @methodOf rest.services.UserRestService
         * @function
         *
         * @description
         * Retrieves the logged user and his friends.
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(UserRestService.prototype.__proto__ || Object.getPrototypeOf(UserRestService.prototype), 'getAllAsync', this).call(this, 'users/');
        }

        /**
         * @ngdoc function
         * @name rest.services.UserRestService#update
         * @methodOf rest.services.UserRestService
         * @function
         *
         * @description
         * Updates a resource
         *
         * @param {string} userId UserId identifier
         * @param {object} payload Resource payload
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(userId, userPayload, headers) {

            return _get(UserRestService.prototype.__proto__ || Object.getPrototypeOf(UserRestService.prototype), 'update', this).call(this, userId, userPayload, 'users/', headers);
        }
    }]);

    return UserRestService;
}(_baseRestService2.default);

exports.default = UserRestService;


_serviceDependencies.push(UserRestService);

angular.module('rest.services').service('UserRestService', _serviceDependencies);

/***/ }),

/***/ "3ZGu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['Util'];

var PcEmailDeploymentSuccessController = function () {
    function PcEmailDeploymentSuccessController(Util) {
        _classCallCheck(this, PcEmailDeploymentSuccessController);

        this.Util = Util;
    }

    _createClass(PcEmailDeploymentSuccessController, [{
        key: 'close',
        value: function close() {

            this.Util.closeModal();
        }
    }]);

    return PcEmailDeploymentSuccessController;
}();

var PcEmailDeploymentSuccessDirective = function PcEmailDeploymentSuccessDirective() {
    _classCallCheck(this, PcEmailDeploymentSuccessDirective);

    this.template = __webpack_require__("pci3");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (Util) {
        return new PcEmailDeploymentSuccessController(Util);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'PcEmailDeploymentSuccessCtrl';
};

_directiveDependencies.push(function () {
    return new PcEmailDeploymentSuccessDirective();
});

angular.module('directives').directive('pcEmailDeploymentSuccess', _directiveDependencies);

/***/ }),

/***/ "3qiv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("6/rD");

__webpack_require__("tK+i");

__webpack_require__("m0M4");

__webpack_require__("TNGQ");

__webpack_require__("cNuc");

__webpack_require__("IK18");

__webpack_require__("wla/");

__webpack_require__("eyBl");

__webpack_require__("4S1g");

__webpack_require__("/37h");

__webpack_require__("lSlM");

__webpack_require__("poBF");

__webpack_require__("QTcw");

__webpack_require__("i148");

__webpack_require__("V9tu");

__webpack_require__("uqfb");

__webpack_require__("bQF6");

__webpack_require__("n8UT");

__webpack_require__("JHUs");

__webpack_require__("P9it");

__webpack_require__("Dzt7");

/***/ }),

/***/ "3sBH":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-insuranceCards\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.insurance_cards.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"insuranceCard in insuranceCards.entries\">\n                            <div class=\"col-5 col-text text-left\" ng-if=\"!insuranceCard.showUpdateInput\">\n                                <p class=\"text-grey-3 text-l\">{{insuranceCard.providerName}}</p>\n                            </div>\n                            <div class=\"col-6 col-text text-left\" ng-if=\"!insuranceCard.showUpdateInput\">\n                                <p class=\"text-grey-1 text-l\">{{insuranceCard.policyNumber}}</p>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!insuranceCard.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                            <div class=\"col-6 col-text input-name\" ng-if=\"insuranceCard.showUpdateInput\">\n                                <input type=\"text\"\n                                    ng-class=\"{'error': !insuranceAccountNameIsValid}\"\n                                    name=\"insuranceAccountName\"\n                                    minlength=\"1\"\n                                    maxlength=\"64\"\n                                    autocomplete=\"off\"\n                                    value=\"{{insuranceCard.providerName}}\"\n                                    placeholder=\"{{ 'cw.dwm.entity.insurance_cards.account_name' | translate }}\"\n                                    class=\"update-insurance-account-name\"\n                                    ng-keyup=\"updateInsuranceAccountName($event);\">\n                                <p class=\"error-message\" ng-show=\"!insuranceAccountNameIsValid\"\n                                    translate=\"cw.dwm.entity.insurance_cards.invalid_account_name\">\n                                </p>\n                            </div>\n                            <div class=\"col-6 col-text input-number\" ng-if=\"insuranceCard.showUpdateInput\">\n                                <input type=\"text\"\n                                    ng-class=\"{'error': !insuranceAccountNumberIsValid}\"\n                                    name=\"insuranceAccountNumber\"\n                                    minlength=\"1\"\n                                    maxlength=\"50\"\n                                    autocomplete=\"off\"\n                                    placeholder=\"{{ 'cw.dwm.entity.insurance_cards.account_number' | translate }}\"\n                                    ng-keyup=\"updateInsuranceAccountNumber($event);\">\n                                <p class=\"error-message\" ng-show=\"!insuranceAccountNumberIsValid\"\n                                    translate=\"cw.dwm.entity.insurance_cards.invalid_account_number\">\n                                </p>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-6 col-text input-name\">\n                                <input type=\"text\" ng-class=\"{'error': !insuranceAccountNameIsValid}\"\n                                    name=\"insuranceAccountName\" ng-model=\"newInsuranceAccountName\" minlength=\"1\" maxlength=\"64\" autocomplete=\"off\"\n                                    placeholder=\"{{ 'cw.dwm.entity.insurance_cards.account_name' | translate }}\"\n                                    id=\"insuranceAccountName\" class=\"update-insurance-account-name\" ng-keyup=\"validateInsuranceAccountName($event)\">\n                                    <p class=\"error-message\" ng-show=\"!insuranceAccountNameIsValid\"\n                                        translate=\"cw.dwm.entity.insurance_cards.invalid_account_name\"></p>\n                            </div>\n                            <div class=\"col-6 col-text input-number\">\n                                <input type=\"text\" ng-class=\"{'error': !insuranceAccountNumberIsValid}\"\n                                    name=\"insuranceAccountNumber\" ng-model=\"newInsuranceAccountNumber\" minlength=\"1\" maxlength=\"50\" autocomplete=\"off\"\n                                    placeholder=\"{{ 'cw.dwm.entity.insurance_cards.account_number' | translate }}\"\n                                    id=\"insuranceAccountNumber\" ng-keyup=\"validateInsuranceAccountNumber($event)\">\n                                    <p class=\"error-message\" ng-show=\"!insuranceAccountNumberIsValid\"\n                                        translate=\"cw.dwm.entity.insurance_cards.invalid_account_number\"></p>                                \n                            </div>\n                        </div>\n                    \n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.insurance_cards.remove_insurance_card_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.insurance_cards.remove_insurance_card_desc\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.insurance_cards.entity_details.title\"></h3>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.insurance_cards.entity_details.desc\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\" ng-if=\"showAddNewButton && (insuranceCards.maxCount > insuranceCards.entries.length)\"\n                ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewInsuranceCardIsLoading}\"\n                    ng-disabled=\"saveNewInsuranceCardIsLoading || !insuranceAccountNameIsValid || !insuranceAccountNumberIsValid\"\n                    ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !insuranceAccountNameIsValid || !insuranceAccountNumberIsValid\"\n                    ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/insurance-cards/insurance-cards.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "3sst":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controller for the support page embedded in the dashboard
 */

/* eslint no-undef: 0 */
angular.module('controllers').controller('Support', ['$scope', '$state', 'Util', '$http', '$rootScope', '$filter', function ($scope, $state, Util, $http, $rootScope, $filter) {

    var activationCodes = _index.ActivationCodesRepository.getAll() || [];
    var freeSupport = CWCONFIG.partnerConfig.support.freeSupport;

    var currentLanguage = CWCONFIG.language;

    var redirectLanguage = '';
    if (currentLanguage === 'en') {

        redirectLanguage = 'en-us';
    } else {

        redirectLanguage = currentLanguage;
    }

    // redirect user if doesn't have any licenses
    if (activationCodes.length === 0) {

        $state.go('root.dashboard.home');
        window.open(freeSupport.replace(/\[language\]/gi, redirectLanguage), '_blank');
    }

    var supportedLanguages = CWCONFIG.partnerConfig.support.languages;
    var supportedEmailLanguages = CWCONFIG.partnerConfig.support.emailLanguages;
    var businessProducts = CWCONFIG.store.businessProducts;
    var emailSupport = CWCONFIG.partnerConfig.support.emailSupport;
    var businessEmailSupport = CWCONFIG.partnerConfig.support.businessEmailSupport;
    var phoneSupport = CWCONFIG.partnerConfig.support.phoneSupport;
    var community = CWCONFIG.partnerConfig.support.community;

    $scope.isBusinessAccount = false;
    $scope.isPersonalAccount = true;
    $scope.showEmailSupportInfo = false;
    $scope.showPhoneSupport = false;
    $scope.infoSupportURL = CWCONFIG.partnerConfig.support.infoSupport.replace(/\[language\]/gi, redirectLanguage);
    $scope.businessInfoSupportURL = CWCONFIG.partnerConfig.support.businessInfoSupport.replace(/\[language\]/gi, redirectLanguage);
    $scope.viewActivityURL = CWCONFIG.partnerConfig.support.viewActivity.replace(/\[language\]/gi, redirectLanguage);
    $scope.currentSection = 'personal';

    $scope.updatecurrentSection = function (section) {

        $scope.currentSection = section;
    };

    activationCodes.forEach(function (element) {

        if (!$scope.isBusinessAccount) {

            if (businessProducts.find(function (el) {
                return el === element.relationships.app.data.id;
            })) {

                $scope.isBusinessAccount = true;
                $scope.currentSection = 'business';
            }
        }
    });

    if (supportedLanguages.find(function (element) {
        return element === currentLanguage;
    })) {

        $scope.emailSupportURL = emailSupport.replace(/\[language\]/gi, redirectLanguage);
        $scope.phoneSupportURL = phoneSupport.replace(/\[language\]/gi, redirectLanguage);
        $scope.businessEmailSupportURL = businessEmailSupport.replace(/\[language\]/gi, redirectLanguage);
        $scope.communityURL = community.replace(/\[language\]/gi, redirectLanguage);
        var phoneSupportEnabled = CWCONFIG.partnerConfig.support.phoneSupportEnabled;


        if (phoneSupportEnabled) {

            $scope.showPhoneSupport = true;
        }
    } else {

        $scope.emailSupportURL = emailSupport.replace(/\[language\]/gi, 'en');
        $scope.businessEmailSupportURL = businessEmailSupport.replace(/\[language\]/gi, 'en');
        $scope.communityURL = community.replace(/\[language\]/gi, 'en');

        if (supportedEmailLanguages.indexOf(currentLanguage) === -1) {

            $scope.showEmailSupportInfo = true;
        }
    }

    $scope.currentTab = $state.params.tab || 'support';

    _RFC2.default.send('ConnectWeb Support Open', {
        Source: 'Direct',
        Tab: $scope.currentTab
    });

    $scope.sendMixpanelClickEvent = function (section) {

        _RFC2.default.send('ConnectWeb Support Click', {
            Source: 'Direct',
            Label: section
        });
    };

    // Chat support
    var user = _index.MeRepository.getMyUser();
    var userLanguage = Util.deepFind(user, 'attributes.language');
    var chatSupportEnabled = CWCONFIG.partnerConfig.support.chatSupportEnabled;
    var chatSupportLanguages = CWCONFIG.partnerConfig.support.chatSupportLanguages;

    var chatDepartments = CWCONFIG.partnerConfig.support.chatDepartmentByLanguage;
    var checkChatLanguage = chatSupportLanguages.find(function (lang) {
        return lang === userLanguage;
    });
    $scope.chatAvailable = false;
    $scope.filterName = $filter('friendName')(user);

    if (checkChatLanguage && chatSupportEnabled && chatDepartments) {

        $scope.showChatSupport = true;
        $scope.chatWidgetIsLoading = true;

        var chatScriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=e574cc8f-ee6b-4fa8-ac52-e9ed8324d299';

        var loadScript = function loadScript(url, callback) {

            var scriptTag = document.createElement('script');
            angular.element('body').append(scriptTag);
            scriptTag.onload = function () {

                callback();
            };

            scriptTag.src = url;
            scriptTag.id = 'ze-snippet';
        };

        loadScript(chatScriptUrl, function () {

            $http({

                method: 'GET',
                url: 'https://support-surveys.avira.com/chat/agents_online'

            }).then(function (data) {

                $scope.language = CWCONFIG.language;
                setTimeout(function () {

                    $scope.departmentKey = chatDepartments[$scope.language];

                    if ($scope.departmentKey in data.data && data.data[$scope.departmentKey] > 0) {

                        if (window.$zopim) {

                            $scope.checkLibraryLoaded();
                        } else {

                            $scope.triggerChatClickInterval = setInterval($scope.checkLibraryLoadedInterval, 1000);
                        }
                    } else {

                        window.zE('webWidget', 'hide');
                        $scope.chatAvailable = false;
                        $scope.chatWidgetIsLoading = false;
                        $scope.$apply();
                    }
                }, 1000);
            }).catch(function () {

                $scope.chatWidgetIsLoading = false;
                $scope.chatAvailable = false;
            });
        });

        $scope.openChat = function () {

            if (!$rootScope.chatIsOpened && $scope.chatAvailable) {

                $scope.sendMixpanelClickEvent('Chat support');

                $scope.chatWidgetIsLoading = true;
                $scope.chatAvailable = false;

                $scope.triggerChatClickInterval = setInterval($scope.triggerChatClick, 2000);

                window.zESettings = {
                    webWidget: {
                        offset: { horizontal: '40px', vertical: '60px' }
                    }
                };
            }
        };

        $scope.triggerChatClick = function () {

            var chatButtonIframe = angular.element('#launcher');

            if (chatButtonIframe) {

                angular.element('#launcher').css('display', 'block');
                var chatButton = chatButtonIframe.contents().find('.wrapper-3hgZT');
                chatButton.trigger('click');
                $scope.chatWidgetIsLoading = false;
                $rootScope.chatIsOpened = true;
                $scope.$apply();
                clearInterval($scope.triggerChatClickInterval);

                if (window.zE) {

                    window.zE('webWidget', 'prefill', {

                        name: { value: $scope.filterName, readOnly: true },
                        email: { value: Util.deepFind(user, 'attributes.email'), readOnly: true }

                    });
                }

                $scope.chatAvailable = false;
            }
        };

        $scope.checkLibraryLoaded = function () {

            window.$zopim.livechat.setLanguage($scope.language);
            window.$zopim.livechat.departments.filter('');
            // window.$zopim.livechat.departments.setVisitorDepartment($scope.departmentKey);
            window.$zopim.livechat.departments.setVisitorDepartment($scope.departmentKey);
            $scope.chatAvailable = true;
            $scope.chatWidgetIsLoading = false;
            $scope.$apply();

            if ($scope.checkLibraryLoadedInterval) {

                clearInterval($scope.checkLibraryLoadedInterval);
            }
        };
    }
}]);

/***/ }),

/***/ "44UD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable max-len */
/* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmCreditCards = function DwmCreditCards($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmCreditCards);

    $scope.creditCardNumberIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};
        if (assets.primaryMember) {

            $scope.creditDebitCards = assets.primaryMember.monitoredAccounts.creditDebitCards;
            $scope.creditDebitCards.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('.update-credit-card-number').trigger('focus');
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.creditCardNumberIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newCreditCardNumber = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.creditDebitCards.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                entry.cardType = 'OTHER';
                $scope.updateEntryPayload = entry;

                // Save initial entry values to use in case of update is canceled
                $scope.initialCreditCardNumber = entry.cardNumber;
                $scope.initialEntryIndex = loopIndex;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-credit-card-number').trigger('focus');
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.creditCardNumberIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.creditDebitCards.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};

        // Revert changes of the selected entry
        $scope.creditDebitCards.entries[$scope.initialEntryIndex].cardNumber = $scope.initialCreditCardNumber;
    };

    $scope.validateCreditCardNumber = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.creditCardNumberIsValid = $event.currentTarget.value && validations.creditCardNumberValidator($event.currentTarget.value.trim());
        }

        $scope.newCreditCardNumber = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.creditCardNumberIsValid = $scope.newCreditCardNumber === undefined ? false : validations.creditCardNumberValidator($scope.newCreditCardNumber.trim());

        $scope.newEntrySubmitted = true;

        if ($scope.creditCardNumberIsValid) {

            $scope.saveNewCreditCardIsLoading = true;

            var payload = {
                creditDebitCards: {
                    cardNumber: $scope.newCreditCardNumber,
                    cardType: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newCreditCardNumber = '';
                $scope.saveNewCreditCardIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;

                    _RFC4.default.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Credit cards'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewCreditCardIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            creditDebitCards: {
                id: $scope.creditDebitCards.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newCreditCardNumber = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Credit Card', monitoredAccounts.creditDebitCards.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Credit cards'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.updateCreditCardNumber = function ($event) {

        $scope.creditCardNumberIsValid = $event.currentTarget.value && validations.creditCardNumberValidator($event.currentTarget.value.trim());

        if ($scope.creditCardNumberIsValid) {

            $scope.updateEntryPayload.cardNumber = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { creditDebitCards: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Credit cards'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmCreditCards);

angular.module('controllers').controller('DwmCreditCards', _serviceDependencies);

/***/ }),

/***/ "4FJV":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu"),
    root = __webpack_require__("VjBI");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "4S1g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("rCgA");

__webpack_require__("9j1/");

__webpack_require__("bNW7");

__webpack_require__("IKj1");

__webpack_require__("gkic");

__webpack_require__("JT+/");

__webpack_require__("Lk3O");

__webpack_require__("Ff1x");

/***/ }),

/***/ "4VJD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("YW9j");

var _RFC4 = _interopRequireDefault(_RFC3);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {

    /**
     * Controller for the device details page
     */

    angular.module('controllers').controller('MyAccount', ['$scope', '$state', function ($scope, $state) {

        $scope.state = $state;

        $scope.paymentTypes = _index.PaymentTypesRepository.getAll();
        /**
        * Returnes true if the user is loggedin with facebook or google
        */
        $scope.isSocialAccount = function () {

            // facebook, google, or password
            var userLoginType = _RFC4.default.get(CWCONFIG.cookie.loginType);

            return !userLoginType || userLoginType === 'password' ? false : true;
        };

        $scope.loginAccountType = _RFC4.default.get(CWCONFIG.cookie.loginType);

        $scope.onTabClick = function (tabName) {

            _RFC2.default.send('ConnectWeb ' + tabName + ' Tab Click');
        };

        $scope.transactions = _index.TransactionsRepository.getAll().filter(function (transaction) {

            if (transaction.attributes.price) {

                var formatPrice = transaction.attributes.price.replace(',', '');

                return Number(formatPrice) > 0;
            }

            return false;
        });

        $scope.Recaptcha = _recaptcha2.default;
        $scope.setCaptchaResponse = function (response) {

            $scope.Recaptcha.setCaptchaResponse(response);
            $scope.$broadcast('captcha available');
        };

        // Check if agent id (aid) exists and has a numeric value on session storage
        if (sessionStorage.getItem('aid') && !Number.isNaN(parseInt(sessionStorage.getItem('aid'), 0))) {

            // Show the otc tab for support agents only
            $scope.showOTCTab = true;
        }

        $scope.expiredLicenses = _index2.ExpiredLicensesProcessor.getAll();
    }]);
})(); /* eslint no-unneeded-ternary: 0 */

/***/ }),

/***/ "4VYb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$timeout', '$scope', '$state', '$window'];

var BreadcrumbController = function () {
    function BreadcrumbController($timeout, $scope, $state, $window) {
        _classCallCheck(this, BreadcrumbController);

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope.deviceRepo = _index.DevicesRepository;
        this.$scope.appIntegrationsRepo = _index.AppIntegrationsRepository;
        this.$scope.isDropdownOpen = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
    }

    /*  Open dropdown and creates a listener which is watching every click.
    The listener is destroyed after one click. */

    _createClass(BreadcrumbController, [{
        key: 'openDropdown',
        value: function openDropdown(event) {
            var _this = this;

            this.$scope.isDropdownOpen = !this.$scope.isDropdownOpen;
            var bodyElement = angular.element(this.$window.document);

            if (this.$scope.isDropdownOpen) {

                bodyElement.on('click', function () {

                    _this.$timeout(function () {

                        _this.$scope.isDropdownOpen = false;
                    }, 0);

                    bodyElement.off('click');
                });
            }
            event.stopPropagation();
        }
    }, {
        key: 'addNewMobileDevice',
        value: function addNewMobileDevice(os) {

            var appId = CWCONFIG.defaultDeployedAppId[os];

            _RFC2.default.send('ConnectWeb Add New Device Click', { Page: 'Antitheft Service', 'Device OS': os });
            this.$state.go('root.dashboard.devices.ltb.deploy', {
                ltb: 'deploy',
                appId: appId,
                resourceId: 'new'
            });
        }
    }]);

    return BreadcrumbController;
}();

var BreadcrumbDirective = function BreadcrumbDirective() {
    _classCallCheck(this, BreadcrumbDirective);

    this.template = __webpack_require__("03rF");
    this.restrict = 'E';
    this.replace = false;
    this.scope = {
        app: '=',
        devices: '=',
        showDeployMobile: '@',
        selectedDevice: '=',
        selectCallback: '&'
    };

    _controllerDependencies.push(function ($timeout, $scope, $state, $window) {
        return new BreadcrumbController($timeout, $scope, $state, $window);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'breadcrumbCtrl';
};

_directiveDependencies.push(function () {
    return new BreadcrumbDirective();
});

angular.module('directives').directive('breadcrumb', _directiveDependencies);

/***/ }),

/***/ "4XN+":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "4dmE":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("hyfS");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "4fhk":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var frequency_lists;

frequency_lists = {
  passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123,football,monkey,letmein,shadow,master,696969,mustang,666666,qwertyuiop,123321,1234567890,pussy,superman,654321,1qaz2wsx,7777777,fuckyou,qazwsx,jordan,123qwe,000000,killer,trustno1,hunter,harley,zxcvbnm,asdfgh,buster,batman,soccer,tigger,charlie,sunshine,iloveyou,fuckme,ranger,hockey,computer,starwars,asshole,pepper,klaster,112233,zxcvbn,freedom,princess,maggie,pass,ginger,11111111,131313,fuck,love,cheese,159753,summer,chelsea,dallas,biteme,matrix,yankees,6969,corvette,austin,access,thunder,merlin,secret,diamond,hello,hammer,fucker,1234qwer,silver,gfhjkm,internet,samantha,golfer,scooter,test,orange,cookie,q1w2e3r4t5,maverick,sparky,phoenix,mickey,bigdog,snoopy,guitar,whatever,chicken,camaro,mercedes,peanut,ferrari,falcon,cowboy,welcome,sexy,samsung,steelers,smokey,dakota,arsenal,boomer,eagles,tigers,marina,nascar,booboo,gateway,yellow,porsche,monster,spider,diablo,hannah,bulldog,junior,london,purple,compaq,lakers,iceman,qwer1234,hardcore,cowboys,money,banana,ncc1701,boston,tennis,q1w2e3r4,coffee,scooby,123654,nikita,yamaha,mother,barney,brandy,chester,fuckoff,oliver,player,forever,rangers,midnight,chicago,bigdaddy,redsox,angel,badboy,fender,jasper,slayer,rabbit,natasha,marine,bigdick,wizard,marlboro,raiders,prince,casper,fishing,flower,jasmine,iwantu,panties,adidas,winter,winner,gandalf,password1,enter,ghbdtn,1q2w3e4r,golden,cocacola,jordan23,winston,madison,angels,panther,blowme,sexsex,bigtits,spanky,bitch,sophie,asdfasdf,horny,thx1138,toyota,tiger,dick,canada,12344321,blowjob,8675309,muffin,liverpoo,apples,qwerty123,passw0rd,abcd1234,pokemon,123abc,slipknot,qazxsw,123456a,scorpion,qwaszx,butter,startrek,rainbow,asdfghjkl,razz,newyork,redskins,gemini,cameron,qazwsxedc,florida,liverpool,turtle,sierra,viking,booger,butthead,doctor,rocket,159357,dolphins,captain,bandit,jaguar,packers,pookie,peaches,789456,asdf,dolphin,helpme,blue,theman,maxwell,qwertyui,shithead,lovers,maddog,giants,nirvana,metallic,hotdog,rosebud,mountain,warrior,stupid,elephant,suckit,success,bond007,jackass,alexis,porn,lucky,scorpio,samson,q1w2e3,azerty,rush2112,driver,freddy,1q2w3e4r5t,sydney,gators,dexter,red123,123456q,12345a,bubba,creative,voodoo,golf,trouble,america,nissan,gunner,garfield,bullshit,asdfghjk,5150,fucking,apollo,1qazxsw2,2112,eminem,legend,airborne,bear,beavis,apple,brooklyn,godzilla,skippy,4815162342,buddy,qwert,kitten,magic,shelby,beaver,phantom,asdasd,xavier,braves,darkness,blink182,copper,platinum,qweqwe,tomcat,01012011,girls,bigboy,102030,animal,police,online,11223344,voyager,lifehack,12qwaszx,fish,sniper,315475,trinity,blazer,heaven,lover,snowball,playboy,loveme,bubbles,hooters,cricket,willow,donkey,topgun,nintendo,saturn,destiny,pakistan,pumpkin,digital,sergey,redwings,explorer,tits,private,runner,therock,guinness,lasvegas,beatles,789456123,fire,cassie,christin,qwerty1,celtic,asdf1234,andrey,broncos,007007,babygirl,eclipse,fluffy,cartman,michigan,carolina,testing,alexande,birdie,pantera,cherry,vampire,mexico,dickhead,buffalo,genius,montana,beer,minecraft,maximus,flyers,lovely,stalker,metallica,doggie,snickers,speedy,bronco,lol123,paradise,yankee,horses,magnum,dreams,147258369,lacrosse,ou812,goober,enigma,qwertyu,scotty,pimpin,bollocks,surfer,cock,poohbear,genesis,star,asd123,qweasdzxc,racing,hello1,hawaii,eagle1,viper,poopoo,einstein,boobies,12345q,bitches,drowssap,simple,badger,alaska,action,jester,drummer,111222,spitfire,forest,maryjane,champion,diesel,svetlana,friday,hotrod,147258,chevy,lucky1,westside,security,google,badass,tester,shorty,thumper,hitman,mozart,zaq12wsx,boobs,reddog,010203,lizard,a123456,123456789a,ruslan,eagle,1232323q,scarface,qwerty12,147852,a12345,buddha,porno,420420,spirit,money1,stargate,qwe123,naruto,mercury,liberty,12345qwert,semperfi,suzuki,popcorn,spooky,marley,scotland,kitty,cherokee,vikings,simpsons,rascal,qweasd,hummer,loveyou,michael1,patches,russia,jupiter,penguin,passion,cumshot,vfhbyf,honda,vladimir,sandman,passport,raider,bastard,123789,infinity,assman,bulldogs,fantasy,sucker,1234554321,horney,domino,budlight,disney,ironman,usuckballz1,softball,brutus,redrum,bigred,mnbvcxz,fktrcfylh,karina,marines,digger,kawasaki,cougar,fireman,oksana,monday,cunt,justice,nigger,super,wildcats,tinker,logitech,dancer,swordfis,avalon,everton,alexandr,motorola,patriots,hentai,madonna,pussy1,ducati,colorado,connor,juventus,galore,smooth,freeuser,warcraft,boogie,titanic,wolverin,elizabet,arizona,valentin,saints,asdfg,accord,test123,password123,christ,yfnfif,stinky,slut,spiderma,naughty,chopper,hello123,ncc1701d,extreme,skyline,poop,zombie,pearljam,123qweasd,froggy,awesome,vision,pirate,fylhtq,dreamer,bullet,predator,empire,123123a,kirill,charlie1,panthers,penis,skipper,nemesis,rasdzv3,peekaboo,rolltide,cardinal,psycho,danger,mookie,happy1,wanker,chevelle,manutd,goblue,9379992,hobbes,vegeta,fyfcnfcbz,852456,picard,159951,windows,loverboy,victory,vfrcbv,bambam,serega,123654789,turkey,tweety,galina,hiphop,rooster,changeme,berlin,taurus,suckme,polina,electric,avatar,134679,maksim,raptor,alpha1,hendrix,newport,bigcock,brazil,spring,a1b2c3,madmax,alpha,britney,sublime,darkside,bigman,wolfpack,classic,hercules,ronaldo,letmein1,1q2w3e,741852963,spiderman,blizzard,123456789q,cheyenne,cjkysirj,tiger1,wombat,bubba1,pandora,zxc123,holiday,wildcat,devils,horse,alabama,147852369,caesar,12312,buddy1,bondage,pussycat,pickle,shaggy,catch22,leather,chronic,a1b2c3d4,admin,qqq111,qaz123,airplane,kodiak,freepass,billybob,sunset,katana,phpbb,chocolat,snowman,angel1,stingray,firebird,wolves,zeppelin,detroit,pontiac,gundam,panzer,vagina,outlaw,redhead,tarheels,greenday,nastya,01011980,hardon,engineer,dragon1,hellfire,serenity,cobra,fireball,lickme,darkstar,1029384756,01011,mustang1,flash,124578,strike,beauty,pavilion,01012000,bobafett,dbrnjhbz,bigmac,bowling,chris1,ytrewq,natali,pyramid,rulez,welcome1,dodgers,apache,swimming,whynot,teens,trooper,fuckit,defender,precious,135790,packard,weasel,popeye,lucifer,cancer,icecream,142536,raven,swordfish,presario,viktor,rockstar,blonde,james1,wutang,spike,pimp,atlanta,airforce,thailand,casino,lennon,mouse,741852,hacker,bluebird,hawkeye,456123,theone,catfish,sailor,goldfish,nfnmzyf,tattoo,pervert,barbie,maxima,nipples,machine,trucks,wrangler,rocks,tornado,lights,cadillac,bubble,pegasus,madman,longhorn,browns,target,666999,eatme,qazwsx123,microsoft,dilbert,christia,baller,lesbian,shooter,xfiles,seattle,qazqaz,cthutq,amateur,prelude,corona,freaky,malibu,123qweasdzxc,assassin,246810,atlantis,integra,pussies,iloveu,lonewolf,dragons,monkey1,unicorn,software,bobcat,stealth,peewee,openup,753951,srinivas,zaqwsx,valentina,shotgun,trigger,veronika,bruins,coyote,babydoll,joker,dollar,lestat,rocky1,hottie,random,butterfly,wordpass,smiley,sweety,snake,chipper,woody,samurai,devildog,gizmo,maddie,soso123aljg,mistress,freedom1,flipper,express,hjvfirf,moose,cessna,piglet,polaris,teacher,montreal,cookies,wolfgang,scully,fatboy,wicked,balls,tickle,bunny,dfvgbh,foobar,transam,pepsi,fetish,oicu812,basketba,toshiba,hotstuff,sunday,booty,gambit,31415926,impala,stephani,jessica1,hooker,lancer,knicks,shamrock,fuckyou2,stinger,314159,redneck,deftones,squirt,siemens,blaster,trucker,subaru,renegade,ibanez,manson,swinger,reaper,blondie,mylove,galaxy,blahblah,enterpri,travel,1234abcd,babylon5,indiana,skeeter,master1,sugar,ficken,smoke,bigone,sweetpea,fucked,trfnthbyf,marino,escort,smitty,bigfoot,babes,larisa,trumpet,spartan,valera,babylon,asdfghj,yankees1,bigboobs,stormy,mister,hamlet,aardvark,butterfl,marathon,paladin,cavalier,manchester,skater,indigo,hornet,buckeyes,01011990,indians,karate,hesoyam,toronto,diamonds,chiefs,buckeye,1qaz2wsx3edc,highland,hotsex,charger,redman,passwor,maiden,drpepper,storm,pornstar,garden,12345678910,pencil,sherlock,timber,thuglife,insane,pizza,jungle,jesus1,aragorn,1a2b3c,hamster,david1,triumph,techno,lollol,pioneer,catdog,321654,fktrctq,morpheus,141627,pascal,shadow1,hobbit,wetpussy,erotic,consumer,blabla,justme,stones,chrissy,spartak,goforit,burger,pitbull,adgjmptw,italia,barcelona,hunting,colors,kissme,virgin,overlord,pebbles,sundance,emerald,doggy,racecar,irina,element,1478963,zipper,alpine,basket,goddess,poison,nipple,sakura,chichi,huskers,13579,pussys,q12345,ultimate,ncc1701e,blackie,nicola,rommel,matthew1,caserta,omega,geronimo,sammy1,trojan,123qwe123,philips,nugget,tarzan,chicks,aleksandr,bassman,trixie,portugal,anakin,dodger,bomber,superfly,madness,q1w2e3r4t5y6,loser,123asd,fatcat,ybrbnf,soldier,warlock,wrinkle1,desire,sexual,babe,seminole,alejandr,951753,11235813,westham,andrei,concrete,access14,weed,letmein2,ladybug,naked,christop,trombone,tintin,bluesky,rhbcnbyf,qazxswedc,onelove,cdtnkfyf,whore,vfvjxrf,titans,stallion,truck,hansolo,blue22,smiles,beagle,panama,kingkong,flatron,inferno,mongoose,connect,poiuyt,snatch,qawsed,juice,blessed,rocker,snakes,turbo,bluemoon,sex4me,finger,jamaica,a1234567,mulder,beetle,fuckyou1,passat,immortal,plastic,123454321,anthony1,whiskey,dietcoke,suck,spunky,magic1,monitor,cactus,exigen,planet,ripper,teen,spyder,apple1,nolimit,hollywoo,sluts,sticky,trunks,1234321,14789632,pickles,sailing,bonehead,ghbdtnbr,delta,charlott,rubber,911911,112358,molly1,yomama,hongkong,jumper,william1,ilovesex,faster,unreal,cumming,memphis,1123581321,nylons,legion,sebastia,shalom,pentium,geheim,werewolf,funtime,ferret,orion,curious,555666,niners,cantona,sprite,philly,pirates,abgrtyu,lollipop,eternity,boeing,super123,sweets,cooldude,tottenha,green1,jackoff,stocking,7895123,moomoo,martini,biscuit,drizzt,colt45,fossil,makaveli,snapper,satan666,maniac,salmon,patriot,verbatim,nasty,shasta,asdzxc,shaved,blackcat,raistlin,qwerty12345,punkrock,cjkywt,01012010,4128,waterloo,crimson,twister,oxford,musicman,seinfeld,biggie,condor,ravens,megadeth,wolfman,cosmos,sharks,banshee,keeper,foxtrot,gn56gn56,skywalke,velvet,black1,sesame,dogs,squirrel,privet,sunrise,wolverine,sucks,legolas,grendel,ghost,cats,carrot,frosty,lvbnhbq,blades,stardust,frog,qazwsxed,121314,coolio,brownie,groovy,twilight,daytona,vanhalen,pikachu,peanuts,licker,hershey,jericho,intrepid,ninja,1234567a,zaq123,lobster,goblin,punisher,strider,shogun,kansas,amadeus,seven7,jason1,neptune,showtime,muscle,oldman,ekaterina,rfrfirf,getsome,showme,111222333,obiwan,skittles,danni,tanker,maestro,tarheel,anubis,hannibal,anal,newlife,gothic,shark,fighter,blue123,blues,123456z,princes,slick,chaos,thunder1,sabine,1q2w3e4r5t6y,python,test1,mirage,devil,clover,tequila,chelsea1,surfing,delete,potato,chubby,panasonic,sandiego,portland,baggins,fusion,sooners,blackdog,buttons,californ,moscow,playtime,mature,1a2b3c4d,dagger,dima,stimpy,asdf123,gangster,warriors,iverson,chargers,byteme,swallow,liquid,lucky7,dingdong,nymets,cracker,mushroom,456852,crusader,bigguy,miami,dkflbvbh,bugger,nimrod,tazman,stranger,newpass,doodle,powder,gotcha,guardian,dublin,slapshot,septembe,147896325,pepsi1,milano,grizzly,woody1,knights,photos,2468,nookie,charly,rammstein,brasil,123321123,scruffy,munchkin,poopie,123098,kittycat,latino,walnut,1701,thegame,viper1,1passwor,kolobok,picasso,robert1,barcelon,bananas,trance,auburn,coltrane,eatshit,goodluck,starcraft,wheels,parrot,postal,blade,wisdom,pink,gorilla,katerina,pass123,andrew1,shaney14,dumbass,osiris,fuck_inside,oakland,discover,ranger1,spanking,lonestar,bingo,meridian,ping,heather1,dookie,stonecol,megaman,192837465,rjntyjr,ledzep,lowrider,25802580,richard1,firefly,griffey,racerx,paradox,ghjcnj,gangsta,zaq1xsw2,tacobell,weezer,sirius,halflife,buffett,shiloh,123698745,vertigo,sergei,aliens,sobaka,keyboard,kangaroo,sinner,soccer1,0.0.000,bonjour,socrates,chucky,hotboy,sprint,0007,sarah1,scarlet,celica,shazam,formula1,sommer,trebor,qwerasdf,jeep,mailcreated5240,bollox,asshole1,fuckface,honda1,rebels,vacation,lexmark,penguins,12369874,ragnarok,formula,258456,tempest,vfhecz,tacoma,qwertz,colombia,flames,rockon,duck,prodigy,wookie,dodgeram,mustangs,123qaz,sithlord,smoker,server,bang,incubus,scoobydo,oblivion,molson,kitkat,titleist,rescue,zxcv1234,carpet,1122,bigballs,tardis,jimbob,xanadu,blueeyes,shaman,mersedes,pooper,pussy69,golfing,hearts,mallard,12312312,kenwood,patrick1,dogg,cowboys1,oracle,123zxc,nuttertools,102938,topper,1122334455,shemale,sleepy,gremlin,yourmom,123987,gateway1,printer,monkeys,peterpan,mikey,kingston,cooler,analsex,jimbo,pa55word,asterix,freckles,birdman,frank1,defiant,aussie,stud,blondes,tatyana,445566,aspirine,mariners,jackal,deadhead,katrin,anime,rootbeer,frogger,polo,scooter1,hallo,noodles,thomas1,parola,shaolin,celine,11112222,plymouth,creampie,justdoit,ohyeah,fatass,assfuck,amazon,1234567q,kisses,magnus,camel,nopass,bosco,987456,6751520,harley1,putter,champs,massive,spidey,lightnin,camelot,letsgo,gizmodo,aezakmi,bones,caliente,12121,goodtime,thankyou,raiders1,brucelee,redalert,aquarius,456654,catherin,smokin,pooh,mypass,astros,roller,porkchop,sapphire,qwert123,kevin1,a1s2d3f4,beckham,atomic,rusty1,vanilla,qazwsxedcrfv,hunter1,kaktus,cxfcnmt,blacky,753159,elvis1,aggies,blackjac,bangkok,scream,123321q,iforgot,power1,kasper,abc12,buster1,slappy,shitty,veritas,chevrole,amber1,01012001,vader,amsterdam,jammer,primus,spectrum,eduard,granny,horny1,sasha1,clancy,usa123,satan,diamond1,hitler,avenger,1221,spankme,123456qwerty,simba,smudge,scrappy,labrador,john316,syracuse,front242,falcons,husker,candyman,commando,gator,pacman,delta1,pancho,krishna,fatman,clitoris,pineappl,lesbians,8j4ye3uz,barkley,vulcan,punkin,boner,celtics,monopoly,flyboy,romashka,hamburg,123456aa,lick,gangbang,223344,area51,spartans,aaa111,tricky,snuggles,drago,homerun,vectra,homer1,hermes,topcat,cuddles,infiniti,1234567890q,cosworth,goose,phoenix1,killer1,ivanov,bossman,qawsedrf,peugeot,exigent,doberman,durango,brandon1,plumber,telefon,horndog,laguna,rbhbkk,dawg,webmaster,breeze,beast,porsche9,beefcake,leopard,redbull,oscar1,topdog,godsmack,theking,pics,omega1,speaker,viktoria,fuckers,bowler,starbuck,gjkbyf,valhalla,anarchy,blacks,herbie,kingpin,starfish,nokia,loveit,achilles,906090,labtec,ncc1701a,fitness,jordan1,brando,arsenal1,bull,kicker,napass,desert,sailboat,bohica,tractor,hidden,muppet,jackson1,jimmy1,terminator,phillies,pa55w0rd,terror,farside,swingers,legacy,frontier,butthole,doughboy,jrcfyf,tuesday,sabbath,daniel1,nebraska,homers,qwertyuio,azamat,fallen,agent007,striker,camels,iguana,looker,pinkfloy,moloko,qwerty123456,dannyboy,luckydog,789654,pistol,whocares,charmed,skiing,select,franky,puppy,daniil,vladik,vette,vfrcbvrf,ihateyou,nevada,moneys,vkontakte,mandingo,puppies,666777,mystic,zidane,kotenok,dilligaf,budman,bunghole,zvezda,123457,triton,golfball,technics,trojans,panda,laptop,rookie,01011991,15426378,aberdeen,gustav,jethro,enterprise,igor,stripper,filter,hurrican,rfnthbyf,lespaul,gizmo1,butch,132435,dthjybrf,1366613,excalibu,963852,nofear,momoney,possum,cutter,oilers,moocow,cupcake,gbpltw,batman1,splash,svetik,super1,soleil,bogdan,melissa1,vipers,babyboy,tdutybq,lancelot,ccbill,keystone,passwort,flamingo,firefox,dogman,vortex,rebel,noodle,raven1,zaphod,killme,pokemon1,coolman,danila,designer,skinny,kamikaze,deadman,gopher,doobie,warhammer,deeznuts,freaks,engage,chevy1,steve1,apollo13,poncho,hammers,azsxdc,dracula,000007,sassy,bitch1,boots,deskjet,12332,macdaddy,mighty,rangers1,manchest,sterlin,casey1,meatball,mailman,sinatra,cthulhu,summer1,bubbas,cartoon,bicycle,eatpussy,truelove,sentinel,tolkien,breast,capone,lickit,summit,123456k,peter1,daisy1,kitty1,123456789z,crazy1,jamesbon,texas1,sexygirl,362436,sonic,billyboy,redhot,microsof,microlab,daddy1,rockets,iloveyo,fernand,gordon24,danie,cutlass,polska,star69,titties,pantyhos,01011985,thekid,aikido,gofish,mayday,1234qwe,coke,anfield,sony,lansing,smut,scotch,sexx,catman,73501505,hustler,saun,dfkthbz,passwor1,jenny1,azsxdcfv,cheers,irish1,gabrie,tinman,orioles,1225,charlton,fortuna,01011970,airbus,rustam,xtreme,bigmoney,zxcasd,retard,grumpy,huskies,boxing,4runner,kelly1,ultima,warlord,fordf150,oranges,rotten,asdfjkl,superstar,denali,sultan,bikini,saratoga,thor,figaro,sixers,wildfire,vladislav,128500,sparta,mayhem,greenbay,chewie,music1,number1,cancun,fabie,mellon,poiuytrewq,cloud9,crunch,bigtime,chicken1,piccolo,bigbird,321654987,billy1,mojo,01011981,maradona,sandro,chester1,bizkit,rjirfrgbde,789123,rightnow,jasmine1,hyperion,treasure,meatloaf,armani,rovers,jarhead,01011986,cruise,coconut,dragoon,utopia,davids,cosmo,rfhbyf,reebok,1066,charli,giorgi,sticks,sayang,pass1234,exodus,anaconda,zaqxsw,illini,woofwoof,emily1,sandy1,packer,poontang,govols,jedi,tomato,beaner,cooter,creamy,lionking,happy123,albatros,poodle,kenworth,dinosaur,greens,goku,happyday,eeyore,tsunami,cabbage,holyshit,turkey50,memorex,chaser,bogart,orgasm,tommy1,volley,whisper,knopka,ericsson,walleye,321123,pepper1,katie1,chickens,tyler1,corrado,twisted,100000,zorro,clemson,zxcasdqwe,tootsie,milana,zenith,fktrcfylhf,shania,frisco,polniypizdec0211,crazybab,junebug,fugazi,rereirf,vfvekz,1001,sausage,vfczyz,koshka,clapton,justin1,anhyeuem,condom,fubar,hardrock,skywalker,tundra,cocks,gringo,150781,canon,vitalik,aspire,stocks,samsung1,applepie,abc12345,arjay,gandalf1,boob,pillow,sparkle,gmoney,rockhard,lucky13,samiam,everest,hellyeah,bigsexy,skorpion,rfrnec,hedgehog,australi,candle,slacker,dicks,voyeur,jazzman,america1,bobby1,br0d3r,wolfie,vfksirf,1qa2ws3ed,13243546,fright,yosemite,temp,karolina,fart,barsik,surf,cheetah,baddog,deniska,starship,bootie,milena,hithere,kume,greatone,dildo,50cent,0.0.0.000,albion,amanda1,midget,lion,maxell,football1,cyclone,freeporn,nikola,bonsai,kenshin,slider,balloon,roadkill,killbill,222333,jerkoff,78945612,dinamo,tekken,rambler,goliath,cinnamon,malaka,backdoor,fiesta,packers1,rastaman,fletch,sojdlg123aljg,stefano,artemis,calico,nyjets,damnit,robotech,duchess,rctybz,hooter,keywest,18436572,hal9000,mechanic,pingpong,operator,presto,sword,rasputin,spank,bristol,faggot,shado,963852741,amsterda,321456,wibble,carrera,alibaba,majestic,ramses,duster,route66,trident,clipper,steeler,wrestlin,divine,kipper,gotohell,kingfish,snake1,passwords,buttman,pompey,viagra,zxcvbnm1,spurs,332211,slutty,lineage2,oleg,macross,pooter,brian1,qwert1,charles1,slave,jokers,yzerman,swimmer,ne1469,nwo4life,solnce,seamus,lolipop,pupsik,moose1,ivanova,secret1,matador,love69,420247,ktyjxrf,subway,cinder,vermont,pussie,chico,florian,magick,guiness,allsop,ghetto,flash1,a123456789,typhoon,dfkthf,depeche,skydive,dammit,seeker,fuckthis,crysis,kcj9wx5n,umbrella,r2d2c3po,123123q,snoopdog,critter,theboss,ding,162534,splinter,kinky,cyclops,jayhawk,456321,caramel,qwer123,underdog,caveman,onlyme,grapes,feather,hotshot,fuckher,renault,george1,sex123,pippen,000001,789987,floppy,cunts,megapass,1000,pornos,usmc,kickass,great1,quattro,135246,wassup,helloo,p0015123,nicole1,chivas,shannon1,bullseye,java,fishes,blackhaw,jamesbond,tunafish,juggalo,dkflbckfd,123789456,dallas1,translator,122333,beanie,alucard,gfhjkm123,supersta,magicman,ashley1,cohiba,xbox360,caligula,12131415,facial,7753191,dfktynbyf,cobra1,cigars,fang,klingon,bob123,safari,looser,10203,deepthroat,malina,200000,tazmania,gonzo,goalie,jacob1,monaco,cruiser,misfit,vh5150,tommyboy,marino13,yousuck,sharky,vfhufhbnf,horizon,absolut,brighton,123456r,death1,kungfu,maxx,forfun,mamapapa,enter1,budweise,banker,getmoney,kostya,qazwsx12,bigbear,vector,fallout,nudist,gunners,royals,chainsaw,scania,trader,blueboy,walrus,eastside,kahuna,qwerty1234,love123,steph,01011989,cypress,champ,undertaker,ybrjkfq,europa,snowboar,sabres,moneyman,chrisbln,minime,nipper,groucho,whitey,viewsonic,penthous,wolf359,fabric,flounder,coolguy,whitesox,passme,smegma,skidoo,thanatos,fucku2,snapple,dalejr,mondeo,thesims,mybaby,panasoni,sinbad,thecat,topher,frodo,sneakers,q123456,z1x2c3,alfa,chicago1,taylor1,ghjcnjnfr,cat123,olivier,cyber,titanium,0420,madison1,jabroni,dang,hambone,intruder,holly1,gargoyle,sadie1,static,poseidon,studly,newcastl,sexxxx,poppy,johannes,danzig,beastie,musica,buckshot,sunnyday,adonis,bluedog,bonkers,2128506,chrono,compute,spawn,01011988,turbo1,smelly,wapbbs,goldstar,ferrari1,778899,quantum,pisces,boomboom,gunnar,1024,test1234,florida1,nike,superman1,multiplelo,custom,motherlode,1qwerty,westwood,usnavy,apple123,daewoo,korn,stereo,sasuke,sunflowe,watcher,dharma,555777,mouse1,assholes,babyblue,123qwerty,marius,walmart,snoop,starfire,tigger1,paintbal,knickers,aaliyah,lokomotiv,theend,winston1,sapper,rover,erotica,scanner,racer,zeus,sexy69,doogie,bayern,joshua1,newbie,scott1,losers,droopy,outkast,martin1,dodge1,wasser,ufkbyf,rjycnfynby,thirteen,12345z,112211,hotred,deejay,hotpussy,192837,jessic,philippe,scout,panther1,cubbies,havefun,magpie,fghtkm,avalanch,newyork1,pudding,leonid,harry1,cbr600,audia4,bimmer,fucku,01011984,idontknow,vfvfgfgf,1357,aleksey,builder,01011987,zerocool,godfather,mylife,donuts,allmine,redfish,777888,sascha,nitram,bounce,333666,smokes,1x2zkg8w,rodman,stunner,zxasqw12,hoosier,hairy,beretta,insert,123456s,rtyuehe,francesc,tights,cheese1,micron,quartz,hockey1,gegcbr,searay,jewels,bogey,paintball,celeron,padres,bing,syncmaster,ziggy,simon1,beaches,prissy,diehard,orange1,mittens,aleksandra,queens,02071986,biggles,thongs,southpark,artur,twinkle,gretzky,rabota,cambiami,monalisa,gollum,chuckles,spike1,gladiator,whisky,spongebob,sexy1,03082006,mazafaka,meathead,4121,ou8122,barefoot,12345678q,cfitymrf,bigass,a1s2d3,kosmos,blessing,titty,clevelan,terrapin,ginger1,johnboy,maggot,clarinet,deeznutz,336699,stumpy,stoney,footbal,traveler,volvo,bucket,snapon,pianoman,hawkeyes,futbol,casanova,tango,goodboy,scuba,honey1,sexyman,warthog,mustard,abc1234,nickel,10203040,meowmeow,1012,boricua,prophet,sauron,12qwas,reefer,andromeda,crystal1,joker1,90210,goofy,loco,lovesex,triangle,whatsup,mellow,bengals,monster1,maste,01011910,lover1,love1,123aaa,sunshin,smeghead,hokies,sting,welder,rambo,cerberus,bunny1,rockford,monke,1q2w3e4r5,goldwing,gabriell,buzzard,crjhgbjy,james007,rainman,groove,tiberius,purdue,nokia6300,hayabusa,shou,jagger,diver,zigzag,poochie,usarmy,phish,redwood,redwing,12345679,salamander,silver1,abcd123,sputnik,boobie,ripple,eternal,12qw34er,thegreat,allstar,slinky,gesperrt,mishka,whiskers,pinhead,overkill,sweet1,rhfcjnrf,montgom240,sersolution,jamie1,starman,proxy,swords,nikolay,bacardi,rasta,badgirl,rebecca1,wildman,penny1,spaceman,1007,10101,logan1,hacked,bulldog1,helmet,windsor,buffy1,runescape,trapper,123451,banane,dbrnjh,ripken,12345qwe,frisky,shun,fester,oasis,lightning,ib6ub9,cicero,kool,pony,thedog,784512,01011992,megatron,illusion,edward1,napster,11223,squash,roadking,woohoo,19411945,hoosiers,01091989,tracker,bagira,midway,leavemealone,br549,14725836,235689,menace,rachel1,feng,laser,stoned,realmadrid,787898,balloons,tinkerbell,5551212,maria1,pobeda,heineken,sonics,moonlight,optimus,comet,orchid,02071982,jaybird,kashmir,12345678a,chuang,chunky,peach,mortgage,rulezzz,saleen,chuckie,zippy,fishing1,gsxr750,doghouse,maxim,reader,shai,buddah,benfica,chou,salomon,meister,eraser,blackbir,bigmike,starter,pissing,angus,deluxe,eagles1,hardcock,135792468,mian,seahawks,godfathe,bookworm,gregor,intel,talisman,blackjack,babyface,hawaiian,dogfood,zhong,01011975,sancho,ludmila,medusa,mortimer,123456654321,roadrunn,just4me,stalin,01011993,handyman,alphabet,pizzas,calgary,clouds,password2,cgfhnfr,f**k,cubswin,gong,lexus,max123,xxx123,digital1,gfhjkm1,7779311,missy1,michae,beautifu,gator1,1005,pacers,buddie,chinook,heckfy,dutchess,sally1,breasts,beowulf,darkman,jenn,tiffany1,zhei,quan,qazwsx1,satana,shang,idontkno,smiths,puddin,nasty1,teddybea,valkyrie,passwd,chao,boxster,killers,yoda,cheater,inuyasha,beast1,wareagle,foryou,dragonball,mermaid,bhbirf,teddy1,dolphin1,misty1,delphi,gromit,sponge,qazzaq,fytxrf,gameover,diao,sergi,beamer,beemer,kittykat,rancid,manowar,adam12,diggler,assword,austin1,wishbone,gonavy,sparky1,fisting,thedude,sinister,1213,venera,novell,salsero,jayden,fuckoff1,linda1,vedder,02021987,1pussy,redline,lust,jktymrf,02011985,dfcbkbq,dragon12,chrome,gamecube,titten,cong,bella1,leng,02081988,eureka,bitchass,147369,banner,lakota,123321a,mustafa,preacher,hotbox,02041986,z1x2c3v4,playstation,01011977,claymore,electra,checkers,zheng,qing,armagedon,02051986,wrestle,svoboda,bulls,nimbus,alenka,madina,newpass6,onetime,aa123456,bartman,02091987,silverad,electron,12345t,devil666,oliver1,skylar,rhtdtlrj,gobucks,johann,12011987,milkman,02101985,camper,thunderb,bigbutt,jammin,davide,cheeks,goaway,lighter,claudi,thumbs,pissoff,ghostrider,cocaine,teng,squall,lotus,hootie,blackout,doitnow,subzero,02031986,marine1,02021988,pothead,123456qw,skate,1369,peng,antoni,neng,miao,bcfields,1492,marika,794613,musashi,tulips,nong,piao,chai,ruan,southpar,02061985,nude,mandarin,654123,ninjas,cannabis,jetski,xerxes,zhuang,kleopatra,dickie,bilbo,pinky,morgan1,1020,1017,dieter,baseball1,tottenham,quest,yfnfkmz,dirtbike,1234567890a,mango,jackson5,ipswich,iamgod,02011987,tdutybz,modena,qiao,slippery,qweasd123,bluefish,samtron,toon,111333,iscool,02091986,petrov,fuzzy,zhou,1357924680,mollydog,deng,02021986,1236987,pheonix,zhun,ghblehjr,othello,starcraf,000111,sanfran,a11111,cameltoe,badman,vasilisa,jiang,1qaz2ws,luan,sveta,12qw12,akira,chuai,369963,cheech,beatle,pickup,paloma,01011983,caravan,elizaveta,gawker,banzai,pussey,mullet,seng,bingo1,bearcat,flexible,farscape,borussia,zhuai,templar,guitar1,toolman,yfcntymrf,chloe1,xiang,slave1,guai,nuggets,02081984,mantis,slim,scorpio1,fyutkbyf,thedoors,02081987,02061986,123qq123,zappa,fergie,7ugd5hip2j,huai,asdfzxcv,sunflower,pussyman,deadpool,bigtit,01011982,love12,lassie,skyler,gatorade,carpedie,jockey,mancity,spectre,02021984,cameron1,artemka,reng,02031984,iomega,jing,moritz,spice,rhino,spinner,heater,zhai,hover,talon,grease,qiong,corleone,ltybcrf,tian,cowboy1,hippie,chimera,ting,alex123,02021985,mickey1,corsair,sonoma,aaron1,xxxpass,bacchus,webmaste,chuo,xyz123,chrysler,spurs1,artem,shei,cosmic,01020304,deutsch,gabriel1,123455,oceans,987456321,binladen,latinas,a12345678,speedo,buttercu,02081989,21031988,merlot,millwall,ceng,kotaku,jiong,dragonba,2580,stonecold,snuffy,01011999,02011986,hellos,blaze,maggie1,slapper,istanbul,bonjovi,babylove,mazda,bullfrog,phoeni,meng,porsche1,nomore,02061989,bobdylan,capslock,orion1,zaraza,teddybear,ntktajy,myname,rong,wraith,mets,niao,02041984,smokie,chevrolet,dialog,gfhjkmgfhjkm,dotcom,vadim,monarch,athlon,mikey1,hamish,pian,liang,coolness,chui,thoma,ramones,ciccio,chippy,eddie1,house1,ning,marker,cougars,jackpot,barbados,reds,pdtplf,knockers,cobalt,amateurs,dipshit,napoli,kilroy,pulsar,jayhawks,daemon,alexey,weng,shuang,9293709b13,shiner,eldorado,soulmate,mclaren,golfer1,andromed,duan,50spanks,sexyboy,dogshit,02021983,shuo,kakashka,syzygy,111111a,yeahbaby,qiang,netscape,fulham,120676,gooner,zhui,rainbow6,laurent,dog123,halifax,freeway,carlitos,147963,eastwood,microphone,monkey12,1123,persik,coldbeer,geng,nuan,danny1,fgtkmcby,entropy,gadget,just4fun,sophi,baggio,carlito,1234567891,02021989,02041983,specialk,piramida,suan,bigblue,salasana,hopeful,mephisto,bailey1,hack,annie1,generic,violetta,spencer1,arcadia,02051983,hondas,9562876,trainer,jones1,smashing,liao,159632,iceberg,rebel1,snooker,temp123,zang,matteo,fastball,q2w3e4r5,bamboo,fuckyo,shutup,astro,buddyboy,nikitos,redbird,maxxxx,shitface,02031987,kuai,kissmyass,sahara,radiohea,1234asdf,wildcard,maxwell1,patric,plasma,heynow,bruno1,shao,bigfish,misfits,sassy1,sheng,02011988,02081986,testpass,nanook,cygnus,licking,slavik,pringles,xing,1022,ninja1,submit,dundee,tiburon,pinkfloyd,yummy,shuai,guang,chopin,obelix,insomnia,stroker,1a2s3d4f,1223,playboy1,lazarus,jorda,spider1,homerj,sleeper,02041982,darklord,cang,02041988,02041987,tripod,magician,jelly,telephon,15975,vsjasnel12,pasword,iverson3,pavlov,homeboy,gamecock,amigo,brodie,budapest,yjdsqgfhjkm,reckless,02011980,pang,tiger123,2469,mason1,orient,01011979,zong,cdtnbr,maksimka,1011,bushido,taxman,giorgio,sphinx,kazantip,02101984,concorde,verizon,lovebug,georg,sam123,seadoo,qazwsxedc123,jiao,jezebel,pharmacy,abnormal,jellybea,maxime,puffy,islander,bunnies,jiggaman,drakon,010180,pluto,zhjckfd,12365,classics,crusher,mordor,hooligan,strawberry,02081985,scrabble,hawaii50,1224,wg8e3wjf,cthtuf,premium,arrow,123456qwe,mazda626,ramrod,tootie,rhjrjlbk,ghost1,1211,bounty,niang,02071984,goat,killer12,sweetnes,porno1,masamune,426hemi,corolla,mariposa,hjccbz,doomsday,bummer,blue12,zhao,bird33,excalibur,samsun,kirsty,buttfuck,kfhbcf,zhuo,marcello,ozzy,02021982,dynamite,655321,master12,123465,lollypop,stepan,1qa2ws,spiker,goirish,callum,michael2,moonbeam,attila,henry1,lindros,andrea1,sporty,lantern,12365478,nextel,violin,volcom,998877,water1,imation,inspiron,dynamo,citadel,placebo,clowns,tiao,02061988,tripper,dabears,haggis,merlin1,02031985,anthrax,amerika,iloveme,vsegda,burrito,bombers,snowboard,forsaken,katarina,a1a2a3,woofer,tigger2,fullmoon,tiger2,spock,hannah1,snoopy1,sexxxy,sausages,stanislav,cobain,robotics,exotic,green123,mobydick,senators,pumpkins,fergus,asddsa,147741,258852,windsurf,reddevil,vfitymrf,nevermind,nang,woodland,4417,mick,shui,q1q2q3,wingman,69696,superb,zuan,ganesh,pecker,zephyr,anastasiya,icu812,larry1,02081982,broker,zalupa,mihail,vfibyf,dogger,7007,paddle,varvara,schalke,1z2x3c,presiden,yankees2,tuning,poopy,02051982,concord,vanguard,stiffy,rjhjktdf,felix1,wrench,firewall,boxer,bubba69,popper,02011984,temppass,gobears,cuan,tipper,fuckme1,kamila,thong,puss,bigcat,drummer1,02031982,sowhat,digimon,tigers1,rang,jingle,bian,uranus,soprano,mandy1,dusty1,fandango,aloha,pumpkin1,postman,02061980,dogcat,bombay,pussy123,onetwo,highheel,pippo,julie1,laura1,pepito,beng,smokey1,stylus,stratus,reload,duckie,karen1,jimbo1,225588,369258,krusty,snappy,asdf12,electro,111qqq,kuang,fishin,clit,abstr,christma,qqqqq1,1234560,carnage,guyver,boxers,kittens,zeng,1000000,qwerty11,toaster,cramps,yugioh,02061987,icehouse,zxcvbnm123,pineapple,namaste,harrypotter,mygirl,falcon1,earnhard,fender1,spikes,nutmeg,01081989,dogboy,02091983,369852,softail,mypassword,prowler,bigboss,1112,harvest,heng,jubilee,killjoy,basset,keng,zaqxswcde,redsox1,biao,titan,misfit99,robot,wifey,kidrock,02101987,gameboy,enrico,1z2x3c4v,broncos1,arrows,havana,banger,cookie1,chriss,123qw,platypus,cindy1,lumber,pinball,foxy,london1,1023,05051987,02041985,password12,superma,longbow,radiohead,nigga,12051988,spongebo,qwert12345,abrakadabra,dodgers1,02101989,chillin,niceguy,pistons,hookup,santafe,bigben,jets,1013,vikings1,mankind,viktoriya,beardog,hammer1,02071980,reddwarf,magelan,longjohn,jennife,gilles,carmex2,02071987,stasik,bumper,doofus,slamdunk,pixies,garion,steffi,alessandro,beerman,niceass,warrior1,honolulu,134679852,visa,johndeer,mother1,windmill,boozer,oatmeal,aptiva,busty,delight,tasty,slick1,bergkamp,badgers,guitars,puffin,02091981,nikki1,irishman,miller1,zildjian,123000,airwolf,magnet,anai,install,02041981,02061983,astra,romans,megan1,mudvayne,freebird,muscles,dogbert,02091980,02091984,snowflak,01011900,mang,joseph1,nygiants,playstat,junior1,vjcrdf,qwer12,webhompas,giraffe,pelican,jefferso,comanche,bruiser,monkeybo,kjkszpj,123456l,micro,albany,02051987,angel123,epsilon,aladin,death666,hounddog,josephin,altima,chilly,02071988,78945,ultra,02041979,gasman,thisisit,pavel,idunno,kimmie,05051985,paulie,ballin,medion,moondog,manolo,pallmall,climber,fishbone,genesis1,153624,toffee,tbone,clippers,krypton,jerry1,picturs,compass,111111q,02051988,1121,02081977,sairam,getout,333777,cobras,22041987,bigblock,severin,booster,norwich,whiteout,ctrhtn,123456m,02061984,hewlett,shocker,fuckinside,02031981,chase1,white1,versace,123456789s,basebal,iloveyou2,bluebell,08031986,anthon,stubby,foreve,undertak,werder,saiyan,mama123,medic,chipmunk,mike123,mazdarx7,qwe123qwe,bowwow,kjrjvjnbd,celeb,choochoo,demo,lovelife,02051984,colnago,lithium,02051989,15051981,zzzxxx,welcom,anastasi,fidelio,franc,26061987,roadster,stone55,drifter,hookem,hellboy,1234qw,cbr900rr,sinned,good123654,storm1,gypsy,zebra,zachary1,toejam,buceta,02021979,testing1,redfox,lineage,mike1,highbury,koroleva,nathan1,washingt,02061982,02091985,vintage,redbaron,dalshe,mykids,11051987,macbeth,julien,james123,krasotka,111000,10011986,987123,pipeline,tatarin,sensei,codered,komodo,frogman,7894561230,nascar24,juicy,01031988,redrose,mydick,pigeon,tkbpfdtnf,smirnoff,1215,spam,winner1,flyfish,moskva,81fukkc,21031987,olesya,starligh,summer99,13041988,fishhead,freesex,super12,06061986,azazel,scoobydoo,02021981,cabron,yogibear,sheba1,konstantin,tranny,chilli,terminat,ghbywtccf,slowhand,soccer12,cricket1,fuckhead,1002,seagull,achtung,blam,bigbob,bdsm,nostromo,survivor,cnfybckfd,lemonade,boomer1,rainbow1,rober,irinka,cocksuck,peaches1,itsme,sugar1,zodiac,upyours,dinara,135791,sunny1,chiara,johnson1,02041989,solitude,habibi,sushi,markiz,smoke1,rockies,catwoman,johnny1,qwerty7,bearcats,username,01011978,wanderer,ohshit,02101986,sigma,stephen1,paradigm,02011989,flanker,sanity,jsbach,spotty,bologna,fantasia,chevys,borabora,cocker,74108520,123ewq,12021988,01061990,gtnhjdbx,02071981,01011960,sundevil,3000gt,mustang6,gagging,maggi,armstron,yfnfkb,13041987,revolver,02021976,trouble1,madcat,jeremy1,jackass1,volkswag,30051985,corndog,pool6123,marines1,03041991,pizza1,piggy,sissy,02031979,sunfire,angelus,undead,24061986,14061991,wildbill,shinobi,45m2do5bs,123qwer,21011989,cleopatr,lasvega,hornets,amorcit,11081989,coventry,nirvana1,destin,sidekick,20061988,02081983,gbhfvblf,sneaky,bmw325,22021989,nfytxrf,sekret,kalina,zanzibar,hotone,qazws,wasabi,heidi1,highlander,blues1,hitachi,paolo,23041987,slayer1,simba1,02011981,tinkerbe,kieran,01121986,172839,boiler,1125,bluesman,waffle,asdfgh01,threesom,conan,1102,reflex,18011987,nautilus,everlast,fatty,vader1,01071986,cyborg,ghbdtn123,birddog,rubble,02071983,suckers,02021973,skyhawk,12qw12qw,dakota1,joebob,nokia6233,woodie,longdong,lamer,troll,ghjcnjgfhjkm,420000,boating,nitro,armada,messiah,1031,penguin1,02091989,americ,02071989,redeye,asdqwe123,07071987,monty1,goten,spikey,sonata,635241,tokiohotel,sonyericsson,citroen,compaq1,1812,umpire,belmont,jonny,pantera1,nudes,palmtree,14111986,fenway,bighead,razor,gryphon,andyod22,aaaaa1,taco,10031988,enterme,malachi,dogface,reptile,01041985,dindom,handball,marseille,candy1,19101987,torino,tigge,matthias,viewsoni,13031987,stinker,evangelion,24011985,123456123,rampage,sandrine,02081980,thecrow,astral,28041987,sprinter,private1,seabee,shibby,02101988,25081988,fearless,junkie,01091987,aramis,antelope,draven,fuck1,mazda6,eggman,02021990,barselona,buddy123,19061987,fyfnjkbq,nancy1,12121990,10071987,sluggo,kille,hotties,irishka,zxcasdqwe123,shamus,fairlane,honeybee,soccer10,13061986,fantomas,17051988,10051987,20111986,gladiato,karachi,gambler,gordo,01011995,biatch,matthe,25800852,papito,excite,buffalo1,bobdole,cheshire,player1,28021992,thewho,10101986,pinky1,mentor,tomahawk,brown1,03041986,bismillah,bigpoppa,ijrjkfl,01121988,runaway,08121986,skibum,studman,helper,squeak,holycow,manfred,harlem,glock,gideon,987321,14021985,yellow1,wizard1,margarit,success1,medved,sf49ers,lambda,pasadena,johngalt,quasar,1776,02031980,coldplay,amand,playa,bigpimp,04041991,capricorn,elefant,sweetness,bruce1,luca,dominik,10011990,biker,09051945,datsun,elcamino,trinitro,malice,audi,voyager1,02101983,joe123,carpente,spartan1,mario1,glamour,diaper,12121985,22011988,winter1,asimov,callisto,nikolai,pebble,02101981,vendetta,david123,boytoy,11061985,02031989,iloveyou1,stupid1,cayman,casper1,zippo,yamahar1,wildwood,foxylady,calibra,02041980,27061988,dungeon,leedsutd,30041986,11051990,bestbuy,antares,dominion,24680,01061986,skillet,enforcer,derparol,01041988,196969,29071983,f00tball,purple1,mingus,25031987,21031990,remingto,giggles,klaste,3x7pxr,01011994,coolcat,29051989,megane,20031987,02051980,04041988,synergy,0000007,macman,iforget,adgjmp,vjqgfhjkm,28011987,rfvfcenhf,16051989,25121987,16051987,rogue,mamamia,08051990,20091991,1210,carnival,bolitas,paris1,dmitriy,dimas,05051989,papillon,knuckles,29011985,hola,tophat,28021990,100500,cutiepie,devo,415263,ducks,ghjuhfvvf,asdqwe,22021986,freefall,parol,02011983,zarina,buste,vitamin,warez,bigones,17061988,baritone,jamess,twiggy,mischief,bitchy,hetfield,1003,dontknow,grinch,sasha_007,18061990,12031985,12031987,calimero,224466,letmei,15011987,acmilan,alexandre,02031977,08081988,whiteboy,21051991,barney1,02071978,money123,18091985,bigdawg,02031988,cygnusx1,zoloto,31011987,firefigh,blowfish,screamer,lfybbk,20051988,chelse,11121986,01031989,harddick,sexylady,30031988,02041974,auditt,pizdec,kojak,kfgjxrf,20091988,123456ru,wp2003wp,1204,15051990,slugger,kordell1,03031986,swinging,01011974,02071979,rockie,dimples,1234123,1dragon,trucking,rusty2,roger1,marijuana,kerouac,02051978,08031985,paco,thecure,keepout,kernel,noname123,13121985,francisc,bozo,02011982,22071986,02101979,obsidian,12345qw,spud,tabasco,02051985,jaguars,dfktynby,kokomo,popova,notused,sevens,4200,magneto,02051976,roswell,15101986,21101986,lakeside,bigbang,aspen,little1,14021986,loki,suckmydick,strawber,carlos1,nokian73,dirty1,joshu,25091987,16121987,02041975,advent,17011987,slimshady,whistler,10101990,stryker,22031984,15021985,01031985,blueball,26031988,ksusha,bahamut,robocop,w_pass,chris123,impreza,prozac,bookie,bricks,13021990,alice1,cassandr,11111q,john123,4ever,korova,02051973,142857,25041988,paramedi,eclipse1,salope,07091990,1124,darkangel,23021986,999666,nomad,02051981,smackdow,01021990,yoyoma,argentin,moonligh,57chevy,bootys,hardone,capricor,galant,spanker,dkflbr,24111989,magpies,krolik,21051988,cevthrb,cheddar,22041988,bigbooty,scuba1,qwedsa,duffman,bukkake,acura,johncena,sexxy,p@ssw0rd,258369,cherries,12345s,asgard,leopold,fuck123,mopar,lalakers,dogpound,matrix1,crusty,spanner,kestrel,fenris,universa,peachy,assasin,lemmein,eggplant,hejsan,canucks,wendy1,doggy1,aikman,tupac,turnip,godlike,fussball,golden1,19283746,april1,django,petrova,captain1,vincent1,ratman,taekwondo,chocha,serpent,perfect1,capetown,vampir,amore,gymnast,timeout,nbvjatq,blue32,ksenia,k.lvbkf,nazgul,budweiser,clutch,mariya,sylveste,02051972,beaker,cartman1,q11111,sexxx,forever1,loser1,marseill,magellan,vehpbr,sexgod,jktxrf,hallo123,132456,liverpool1,southpaw,seneca,camden,357159,camero,tenchi,johndoe,145236,roofer,741963,vlad,02041978,fktyrf,zxcv123,wingnut,wolfpac,notebook,pufunga7782,brandy1,biteme1,goodgirl,redhat,02031978,challeng,millenium,hoops,maveric,noname,angus1,gaell,onion,olympus,sabrina1,ricard,sixpack,gratis,gagged,camaross,hotgirls,flasher,02051977,bubba123,goldfing,moonshin,gerrard,volkov,sonyfuck,mandrake,258963,tracer,lakers1,asians,susan1,money12,helmut,boater,diablo2,1234zxcv,dogwood,bubbles1,happy2,randy1,aries,beach1,marcius2,navigator,goodie,hellokitty,fkbyjxrf,earthlink,lookout,jumbo,opendoor,stanley1,marie1,12345m,07071977,ashle,wormix,murzik,02081976,lakewood,bluejays,loveya,commande,gateway2,peppe,01011976,7896321,goth,oreo,slammer,rasmus,faith1,knight1,stone1,redskin,ironmaiden,gotmilk,destiny1,dejavu,1master,midnite,timosha,espresso,delfin,toriamos,oberon,ceasar,markie,1a2s3d,ghhh47hj7649,vjkjrj,daddyo,dougie,disco,auggie,lekker,therock1,ou8123,start1,noway,p4ssw0rd,shadow12,333444,saigon,2fast4u,capecod,23skidoo,qazxcv,beater,bremen,aaasss,roadrunner,peace1,12345qwer,02071975,platon,bordeaux,vbkfirf,135798642,test12,supernov,beatles1,qwert40,optimist,vanessa1,prince1,ilovegod,nightwish,natasha1,alchemy,bimbo,blue99,patches1,gsxr1000,richar,hattrick,hott,solaris,proton,nevets,enternow,beavis1,amigos,159357a,ambers,lenochka,147896,suckdick,shag,intercourse,blue1234,spiral,02061977,tosser,ilove,02031975,cowgirl,canuck,q2w3e4,munch,spoons,waterboy,123567,evgeniy,savior,zasada,redcar,mamacita,terefon,globus,doggies,htubcnhfwbz,1008,cuervo,suslik,azertyui,limewire,houston1,stratfor,steaua,coors,tennis1,12345qwerty,stigmata,derf,klondike,patrici,marijuan,hardball,odyssey,nineinch,boston1,pass1,beezer,sandr,charon,power123,a1234,vauxhall,875421,awesome1,reggae,boulder,funstuff,iriska,krokodil,rfntymrf,sterva,champ1,bball,peeper,m123456,toolbox,cabernet,sheepdog,magic32,pigpen,02041977,holein1,lhfrjy,banan,dabomb,natalie1,jennaj,montana1,joecool,funky,steven1,ringo,junio,sammy123,qqqwww,baltimor,footjob,geezer,357951,mash4077,cashmone,pancake,monic,grandam,bongo,yessir,gocubs,nastia,vancouve,barley,dragon69,watford,ilikepie,02071976,laddie,123456789m,hairball,toonarmy,pimpdadd,cvthnm,hunte,davinci,lback,sophie1,firenze,q1234567,admin1,bonanza,elway7,daman,strap,azert,wxcvbn,afrika,theforce,123456t,idefix,wolfen,houdini,scheisse,default,beech,maserati,02061976,sigmachi,dylan1,bigdicks,eskimo,mizzou,02101976,riccardo,egghead,111777,kronos,ghbrjk,chaos1,jomama,rfhnjirf,rodeo,dolemite,cafc91,nittany,pathfind,mikael,password9,vqsablpzla,purpl,gabber,modelsne,myxworld,hellsing,punker,rocknrol,fishon,fuck69,02041976,lolol,twinkie,tripleh,cirrus,redbone,killer123,biggun,allegro,gthcbr,smith1,wanking,bootsy,barry1,mohawk,koolaid,5329,futurama,samoht,klizma,996633,lobo,honeys,peanut1,556677,zxasqw,joemama,javelin,samm,223322,sandra1,flicks,montag,nataly,3006,tasha1,1235789,dogbone,poker1,p0o9i8u7,goodday,smoothie,toocool,max333,metroid,archange,vagabond,billabon,22061941,tyson1,02031973,darkange,skateboard,evolutio,morrowind,wizards,frodo1,rockin,cumslut,plastics,zaqwsxcde,5201314,doit,outback,bumble,dominiqu,persona,nevermore,alinka,02021971,forgetit,sexo,all4one,c2h5oh,petunia,sheeba,kenny1,elisabet,aolsucks,woodstoc,pumper,02011975,fabio,granada,scrapper,123459,minimoni,q123456789,breaker,1004,02091976,ncc74656,slimshad,friendster,austin31,wiseguy,donner,dilbert1,132465,blackbird,buffet,jellybean,barfly,behappy,01011971,carebear,fireblad,02051975,boxcar,cheeky,kiteboy,hello12,panda1,elvisp,opennow,doktor,alex12,02101977,pornking,flamengo,02091975,snowbird,lonesome,robin1,11111a,weed420,baracuda,bleach,12345abc,nokia1,metall,singapor,mariner,herewego,dingo,tycoon,cubs,blunts,proview,123456789d,kamasutra,lagnaf,vipergts,navyseal,starwar,masterbate,wildone,peterbil,cucumber,butkus,123qwert,climax,deniro,gotribe,cement,scooby1,summer69,harrier,shodan,newyear,02091977,starwars1,romeo1,sedona,harald,doubled,sasha123,bigguns,salami,awnyce,kiwi,homemade,pimping,azzer,bradley1,warhamme,linkin,dudeman,qwe321,pinnacle,maxdog,flipflop,lfitymrf,fucker1,acidburn,esquire,sperma,fellatio,jeepster,thedon,sexybitch,pookey,spliff,widget,vfntvfnbrf,trinity1,mutant,samuel1,meliss,gohome,1q2q3q,mercede,comein,grin,cartoons,paragon,henrik,rainyday,pacino,senna,bigdog1,alleycat,12345qaz,narnia,mustang2,tanya1,gianni,apollo11,wetter,clovis,escalade,rainbows,freddy1,smart1,daisydog,s123456,cocksucker,pushkin,lefty,sambo,fyutkjxtr,hiziad,boyz,whiplash,orchard,newark,adrenalin,1598753,bootsie,chelle,trustme,chewy,golfgti,tuscl,ambrosia,5wr2i7h8,penetration,shonuf,jughead,payday,stickman,gotham,kolokol,johnny5,kolbasa,stang,puppydog,charisma,gators1,mone,jakarta,draco,nightmar,01011973,inlove,laetitia,02091973,tarpon,nautica,meadow,0192837465,luckyone,14881488,chessie,goldeney,tarakan,69camaro,bungle,wordup,interne,fuckme2,515000,dragonfl,sprout,02081974,gerbil,bandit1,02071971,melanie1,phialpha,camber,kathy1,adriano,gonzo1,10293847,bigjohn,bismarck,7777777a,scamper,12348765,rabbits,222777,bynthytn,dima123,alexander1,mallorca,dragster,favorite6,beethove,burner,cooper1,fosters,hello2,normandy,777999,sebring,1michael,lauren1,blake1,killa,02091971,nounours,trumpet1,thumper1,playball,xantia,rugby1,rocknroll,guillaum,angela1,strelok,prosper,buttercup,masterp,dbnfkbr,cambridg,venom,treefrog,lumina,1234566,supra,sexybabe,freee,shen,frogs,driller,pavement,grace1,dicky,checker,smackdown,pandas,cannibal,asdffdsa,blue42,zyjxrf,nthvbyfnjh,melrose,neon,jabber,gamma,369258147,aprilia,atticus,benessere,catcher,skipper1,azertyuiop,sixty9,thierry,treetop,jello,melons,123456789qwe,tantra,buzzer,catnip,bouncer,computer1,sexyone,ananas,young1,olenka,sexman,mooses,kittys,sephiroth,contra,hallowee,skylark,sparkles,777333,1qazxsw23edc,lucas1,q1w2e3r,gofast,hannes,amethyst,ploppy,flower2,hotass,amatory,volleyba,dixie1,bettyboo,ticklish,02061974,frenchy,phish1,murphy1,trustno,02061972,leinad,mynameis,spooge,jupiter1,hyundai,frosch,junkmail,abacab,marbles,32167,casio,sunshine1,wayne1,longhair,caster,snicker,02101973,gannibal,skinhead,hansol,gatsby,segblue2,montecar,plato,gumby,kaboom,matty,bosco1,888999,jazzy,panter,jesus123,charlie2,giulia,candyass,sex69,travis1,farmboy,special1,02041973,letsdoit,password01,allison1,abcdefg1,notredam,ilikeit,789654123,liberty1,rugger,uptown,alcatraz,123456w,airman,007bond,navajo,kenobi,terrier,stayout,grisha,frankie1,fluff,1qazzaq1,1234561,virginie,1234568,tango1,werdna,octopus,fitter,dfcbkbcf,blacklab,115599,montrose,allen1,supernova,frederik,ilovepussy,justice1,radeon,playboy2,blubber,sliver,swoosh,motocros,lockdown,pearls,thebear,istheman,pinetree,biit,1234rewq,rustydog,tampabay,titts,babycake,jehovah,vampire1,streaming,collie,camil,fidelity,calvin1,stitch,gatit,restart,puppy1,budgie,grunt,capitals,hiking,dreamcas,zorro1,321678,riffraff,makaka,playmate,napalm,rollin,amstel,zxcvb123,samanth,rumble,fuckme69,jimmys,951357,pizzaman,1234567899,tralala,delpiero,alexi,yamato,itisme,1million,vfndtq,kahlua,londo,wonderboy,carrots,tazz,ratboy,rfgecnf,02081973,nico,fujitsu,tujhrf,sergbest,blobby,02051970,sonic1,1357911,smirnov,video1,panhead,bucky,02031974,44332211,duffer,cashmoney,left4dead,bagpuss,salman,01011972,titfuck,66613666,england1,malish,dresden,lemans,darina,zapper,123456as,123456qqq,met2002,02041972,redstar,blue23,1234509876,pajero,booyah,please1,tetsuo,semper,finder,hanuman,sunlight,123456n,02061971,treble,cupoi,password99,dimitri,3ip76k2,popcorn1,lol12345,stellar,nympho,shark1,keith1,saskia,bigtruck,revoluti,rambo1,asd222,feelgood,phat,gogators,bismark,cola,puck,furball,burnout,slonik,bowtie,mommy1,icecube,fabienn,mouser,papamama,rolex,giants1,blue11,trooper1,momdad,iklo,morten,rhubarb,gareth,123456d,blitz,canada1,r2d2,brest,tigercat,usmarine,lilbit,benny1,azrael,lebowski,12345r,madagaskar,begemot,loverman,dragonballz,italiano,mazda3,naughty1,onions,diver1,cyrano,capcom,asdfg123,forlife,fisherman,weare138,requiem,mufasa,alpha123,piercing,hellas,abracadabra,duckman,caracas,macintos,02011971,jordan2,crescent,fduecn,hogtied,eatmenow,ramjet,18121812,kicksass,whatthe,discus,rfhfvtkmrf,rufus1,sqdwfe,mantle,vegitto,trek,dan123,paladin1,rudeboy,liliya,lunchbox,riversid,acapulco,libero,dnsadm,maison,toomuch,boobear,hemlock,sextoy,pugsley,misiek,athome,migue,altoids,marcin,123450,rhfcfdbwf,jeter2,rhinos,rjhjkm,mercury1,ronaldinho,shampoo,makayla,kamilla,masterbating,tennesse,holger,john1,matchbox,hores,poptart,parlament,goodyear,asdfgh1,02081970,hardwood,alain,erection,hfytnrb,highlife,implants,benjami,dipper,jeeper,bendover,supersonic,babybear,laserjet,gotenks,bama,natedogg,aol123,pokemo,rabbit1,raduga,sopranos,cashflow,menthol,pharao,hacking,334455,ghjcnbnenrf,lizzy,muffin1,pooky,penis1,flyer,gramma,dipset,becca,ireland1,diana1,donjuan,pong,ziggy1,alterego,simple1,cbr900,logger,111555,claudia1,cantona7,matisse,ljxtymrf,victori,harle,mamas,encore,mangos,iceman1,diamon,alexxx,tiamat,5000,desktop,mafia,smurf,princesa,shojou,blueberr,welkom,maximka,123890,123q123,tammy1,bobmarley,clips,demon666,ismail,termite,laser1,missie,altair,donna1,bauhaus,trinitron,mogwai,flyers88,juniper,nokia5800,boroda,jingles,qwerasdfzxcv,shakur,777666,legos,mallrats,1qazxsw,goldeneye,tamerlan,julia1,backbone,spleen,49ers,shady,darkone,medic1,justi,giggle,cloudy,aisan,douche,parkour,bluejay,huskers1,redwine,1qw23er4,satchmo,1231234,nineball,stewart1,ballsack,probes,kappa,amiga,flipper1,dortmund,963258,trigun,1237895,homepage,blinky,screwy,gizzmo,belkin,chemist,coolhand,chachi,braves1,thebest,greedisgood,pro100,banana1,101091m,123456g,wonderfu,barefeet,8inches,1111qqqq,kcchiefs,qweasdzxc123,metal1,jennifer1,xian,asdasd123,pollux,cheerleaers,fruity,mustang5,turbos,shopper,photon,espana,hillbill,oyster,macaroni,gigabyte,jesper,motown,tuxedo,buster12,triplex,cyclones,estrell,mortis,holla,456987,fiddle,sapphic,jurassic,thebeast,ghjcnjq,baura,spock1,metallica1,karaoke,nemrac58,love1234,02031970,flvbybcnhfnjh,frisbee,diva,ajax,feathers,flower1,soccer11,allday,mierda,pearl1,amature,marauder,333555,redheads,womans,egorka,godbless,159263,nimitz,aaaa1111,sashka,madcow,socce,greywolf,baboon,pimpdaddy,123456789r,reloaded,lancia,rfhfylfi,dicker,placid,grimace,22446688,olemiss,whores,culinary,wannabe,maxi,1234567aa,amelie,riley1,trample,phantom1,baberuth,bramble,asdfqwer,vides,4you,abc123456,taichi,aztnm,smother,outsider,hakr,blackhawk,bigblack,girlie,spook,valeriya,gianluca,freedo,1q2q3q4q,handbag,lavalamp,cumm,pertinant,whatup,nokia123,redlight,patrik,111aaa,poppy1,dfytxrf,aviator,sweeps,kristin1,cypher,elway,yinyang,access1,poophead,tucson,noles1,monterey,waterfal,dank,dougal,918273,suede,minnesot,legman,bukowski,ganja,mammoth,riverrat,asswipe,daredevi,lian,arizona1,kamikadze,alex1234,smile1,angel2,55bgates,bellagio,0001,wanrltw,stiletto,lipton,arsena,biohazard,bbking,chappy,tetris,as123456,darthvad,lilwayne,nopassword,7412369,123456789987654321,natchez,glitter,14785236,mytime,rubicon,moto,pyon,wazzup,tbird,shane1,nightowl,getoff,beckham7,trueblue,hotgirl,nevermin,deathnote,13131,taffy,bigal,copenhag,apricot,gallaries,dtkjcbgtl,totoro,onlyone,civicsi,jesse1,baby123,sierra1,festus,abacus,sickboy,fishtank,fungus,charle,golfpro,teensex,mario66,seaside,aleksei,rosewood,blackberry,1020304050,bedlam,schumi,deerhunt,contour,darkelf,surveyor,deltas,pitchers,741258963,dipstick,funny1,lizzard,112233445566,jupiter2,softtail,titman,greenman,z1x2c3v4b5,smartass,12345677,notnow,myworld,nascar1,chewbacc,nosferatu,downhill,dallas22,kuan,blazers,whales,soldat,craving,powerman,yfcntyf,hotrats,cfvceyu,qweasdzx,princess1,feline,qqwwee,chitown,1234qaz,mastermind,114477,dingbat,care1839,standby,kismet,atreides,dogmeat,icarus,monkeyboy,alex1,mouses,nicetits,sealteam,chopper1,crispy,winter99,rrpass1,myporn,myspace1,corazo,topolino,ass123,lawman,muffy,orgy,1love,passord,hooyah,ekmzyf,pretzel,amonra,nestle,01011950,jimbeam,happyman,z12345,stonewal,helios,manunited,harcore,dick1,gaymen,2hot4u,light1,qwerty13,kakashi,pjkjnj,alcatel,taylo,allah,buddydog,ltkmaby,mongo,blonds,start123,audia6,123456v,civilwar,bellaco,turtles,mustan,deadspin,aaa123,fynjirf,lucky123,tortoise,amor,summe,waterski,zulu,drag0n,dtxyjcnm,gizmos,strife,interacial,pusyy,goose1,bear1,equinox,matri,jaguar1,tobydog,sammys,nachos,traktor,bryan1,morgoth,444555,dasani,miami1,mashka,xxxxxx1,ownage,nightwin,hotlips,passmast,cool123,skolko,eldiablo,manu,1357908642,screwyou,badabing,foreplay,hydro,kubrick,seductive,demon1,comeon,galileo,aladdin,metoo,happines,902100,mizuno,caddy,bizzare,girls1,redone,ohmygod,sable,bonovox,girlies,hamper,opus,gizmodo1,aaabbb,pizzahut,999888,rocky2,anton1,kikimora,peavey,ocelot,a1a2a3a4,2wsx3edc,jackie1,solace,sprocket,galary,chuck1,volvo1,shurik,poop123,locutus,virago,wdtnjxtr,tequier,bisexual,doodles,makeitso,fishy,789632145,nothing1,fishcake,sentry,libertad,oaktree,fivestar,adidas1,vegitta,mississi,spiffy,carme,neutron,vantage,agassi,boners,123456789v,hilltop,taipan,barrage,kenneth1,fister,martian,willem,lfybkf,bluestar,moonman,ntktdbpjh,paperino,bikers,daffy,benji,quake,dragonfly,suckcock,danilka,lapochka,belinea,calypso,asshol,camero1,abraxas,mike1234,womam,q1q2q3q4q5,youknow,maxpower,pic\'s,audi80,sonora,raymond1,tickler,tadpole,belair,crazyman,finalfantasy,999000,jonatha,paisley,kissmyas,morgana,monste,mantra,spunk,magic123,jonesy,mark1,alessand,741258,baddest,ghbdtnrfrltkf,zxccxz,tictac,augustin,racers,7grout,foxfire,99762000,openit,nathanie,1z2x3c4v5b,seadog,gangbanged,lovehate,hondacbr,harpoon,mamochka,fisherma,bismilla,locust,wally1,spiderman1,saffron,utjhubq,123456987,20spanks,safeway,pisser,bdfyjd,kristen1,bigdick1,magenta,vfhujif,anfisa,friday13,qaz123wsx,0987654321q,tyrant,guan,meggie,kontol,nurlan,ayanami,rocket1,yaroslav,websol76,mutley,hugoboss,websolutions,elpaso,gagarin,badboys,sephirot,918273645,newuser,qian,edcrfv,booger1,852258,lockout,timoxa94,mazda323,firedog,sokolova,skydiver,jesus777,1234567890z,soulfly,canary,malinka,guillerm,hookers,dogfart,surfer1,osprey,india123,rhjkbr,stoppedby,nokia5530,123456789o,blue1,werter,divers,3000,123456f,alpina,cali,whoknows,godspeed,986532,foreskin,fuzzy1,heyyou,didier,slapnuts,fresno,rosebud1,sandman1,bears1,blade1,honeybun,queen1,baronn,pakista,philipp,9111961,topsecret,sniper1,214365,slipper,letsfuck,pippen33,godawgs,mousey,qw123456,scrotum,loveis,lighthou,bp2002,nancy123,jeffrey1,susieq,buddy2,ralphie,trout1,willi,antonov,sluttey,rehbwf,marty1,darian,losangeles,letme1n,12345d,pusssy,godiva,ender,golfnut,leonidas,a1b2c3d4e5,puffer,general1,wizzard,lehjxrf,racer1,bigbucks,cool12,buddys,zinger,esprit,vbienrf,josep,tickling,froggie,987654321a,895623,daddys,crumbs,gucci,mikkel,opiate,tracy1,christophe,came11,777555,petrovich,humbug,dirtydog,allstate,horatio,wachtwoord,creepers,squirts,rotary,bigd,georgia1,fujifilm,2sweet,dasha,yorkie,slimjim,wiccan,kenzie,system1,skunk,b12345,getit,pommes,daredevil,sugars,bucker,piston,lionheart,1bitch,515051,catfight,recon,icecold,fantom,vodafone,kontakt,boris1,vfcnth,canine,01011961,valleywa,faraon,chickenwing101,qq123456,livewire,livelife,roosters,jeepers,ilya1234,coochie,pavlik,dewalt,dfhdfhf,architec,blackops,1qaz2wsx3edc4rfv,rhfcjnf,wsxedc,teaser,sebora,25252,rhino1,ankara,swifty,decimal,redleg,shanno,nermal,candies,smirnova,dragon01,photo1,ranetki,a1s2d3f4g5,axio,wertzu,maurizio,6uldv8,zxcvasdf,punkass,flowe,graywolf,peddler,3rjs1la7qe,mpegs,seawolf,ladyboy,pianos,piggies,vixen,alexus,orpheus,gdtrfb,z123456,macgyver,hugetits,ralph1,flathead,maurici,mailru,goofball,nissan1,nikon,stopit,odin,big1,smooch,reboot,famil,bullit,anthony7,gerhard,methos,124038,morena,eagle2,jessica2,zebras,getlost,gfynthf,123581321,sarajevo,indon,comets,tatjana,rfgbnjirf,joystick,batman12,123456c,sabre,beerme,victory1,kitties,1475369,badboy1,booboo1,comcast,slava,squid,saxophon,lionhear,qaywsx,bustle,nastena,roadway,loader,hillside,starlight,24681012,niggers,access99,bazooka,molly123,blackice,bandi,cocacol,nfhfrfy,timur,muschi,horse1,quant4307s,squerting,oscars,mygirls,flashman,tangerin,goofy1,p0o9i8,housewifes,newness,monkey69,escorpio,password11,hippo,warcraft3,qazxsw123,qpalzm,ribbit,ghbdtndctv,bogota,star123,258000,lincoln1,bigjim,lacoste,firestorm,legenda,indain,ludacris,milamber,1009,evangeli,letmesee,a111111,hooters1,bigred1,shaker,husky,a4tech,cnfkrth,argyle,rjhjdf,nataha,0o9i8u7y,gibson1,sooners1,glendale,archery,hoochie,stooge,aaaaaa1,scorpions,school1,vegas1,rapier,mike23,bassoon,groupd2013,macaco,baker1,labia,freewill,santiag,silverado,butch1,vflfufcrfh,monica1,rugrat,cornhole,aerosmit,bionicle,gfgfvfvf,daniel12,virgo,fmale,favorite2,detroit1,pokey,shredder,baggies,wednesda,cosmo1,mimosa,sparhawk,firehawk,romario,911turbo,funtimes,fhntvrf,nexus6,159753456,timothy1,bajingan,terry1,frenchie,raiden,1mustang,babemagnet,74123698,nadejda,truffles,rapture,douglas1,lamborghini,motocross,rjcvjc,748596,skeeter1,dante1,angel666,telecom,carsten,pietro,bmw318,astro1,carpediem,samir,orang,helium,scirocco,fuzzball,rushmore,rebelz,hotspur,lacrimosa,chevys10,madonna1,domenico,yfnfirf,jachin,shelby1,bloke,dawgs,dunhill,atlanta1,service1,mikado,devilman,angelit,reznor,euphoria,lesbain,checkmat,browndog,phreak,blaze1,crash1,farida,mutter,luckyme,horsemen,vgirl,jediknig,asdas,cesare,allnight,rockey,starlite,truck1,passfan,close-up,samue,cazzo,wrinkles,homely,eatme1,sexpot,snapshot,dima1995,asthma,thetruth,ducky,blender,priyanka,gaucho,dutchman,sizzle,kakarot,651550,passcode,justinbieber,666333,elodie,sanjay,110442,alex01,lotus1,2300mj,lakshmi,zoomer,quake3,12349876,teapot,12345687,ramada,pennywis,striper,pilot1,chingon,optima,nudity,ethan1,euclid,beeline,loyola,biguns,zaq12345,bravo1,disney1,buffa,assmunch,vivid,6661313,wellingt,aqwzsx,madala11,9874123,sigmar,pictere,tiptop,bettyboop,dinero,tahiti,gregory1,bionic,speed1,fubar1,lexus1,denis1,hawthorn,saxman,suntzu,bernhard,dominika,camaro1,hunter12,balboa,bmw2002,seville,diablo1,vfhbyjxrf,1234abc,carling,lockerroom,punani,darth,baron1,vaness,1password,libido,picher,232425,karamba,futyn007,daydream,11001001,dragon123,friends1,bopper,rocky123,chooch,asslover,shimmer,riddler,openme,tugboat,sexy123,midori,gulnara,christo,swatch,laker,offroad,puddles,hackers,mannheim,manager1,horseman,roman1,dancer1,komputer,pictuers,nokia5130,ejaculation,lioness,123456y,evilone,nastenka,pushok,javie,lilman,3141592,mjolnir,toulouse,pussy2,bigworm,smoke420,fullback,extensa,dreamcast,belize,delboy,willie1,casablanca,csyjxtr,ricky1,bonghit,salvator,basher,pussylover,rosie1,963258741,vivitron,cobra427,meonly,armageddon,myfriend,zardoz,qwedsazxc,kraken,fzappa,starfox,333999,illmatic,capoeira,weenie,ramzes,freedom2,toasty,pupkin,shinigami,fhvfutljy,nocturne,churchil,thumbnils,tailgate,neworder,sexymama,goarmy,cerebus,michelle1,vbifyz,surfsup,earthlin,dabulls,basketbal,aligator,mojojojo,saibaba,welcome2,wifes,wdtnjr,12345w,slasher,papabear,terran,footman,hocke,153759,texans,tom123,sfgiants,billabong,aassdd,monolith,xxx777,l3tm31n,ticktock,newone,hellno,japanees,contortionist,admin123,scout1,alabama1,divx1,rochard,privat,radar1,bigdad,fhctybq,tortuga,citrus,avanti,fantasy1,woodstock,s12345,fireman1,embalmer,woodwork,bonzai,konyor,newstart,jigga,panorama,goats,smithy,rugrats,hotmama,daedalus,nonstop,fruitbat,lisenok,quaker,violator,12345123,my3sons,cajun,fraggle,gayboy,oldfart,vulva,knickerless,orgasms,undertow,binky,litle,kfcnjxrf,masturbation,bunnie,alexis1,planner,transexual,sparty,leeloo,monies,fozzie,stinger1,landrove,anakonda,scoobie,yamaha1,henti,star12,rfhlbyfk,beyonce,catfood,cjytxrf,zealots,strat,fordtruc,archangel,silvi,sativa,boogers,miles1,bigjoe,tulip,petite,greentea,shitter,jonboy,voltron,morticia,evanescence,3edc4rfv,longshot,windows1,serge,aabbcc,starbucks,sinful,drywall,prelude1,www123,camel1,homebrew,marlins,123412,letmeinn,domini,swampy,plokij,fordf350,webcam,michele1,bolivi,27731828,wingzero,qawsedrftg,shinji,sverige,jasper1,piper1,cummer,iiyama,gocats,amour,alfarome,jumanji,mike69,fantasti,1monkey,w00t88,shawn1,lorien,1a2s3d4f5g,koleso,murph,natascha,sunkist,kennwort,emine,grinder,m12345,q1q2q3q4,cheeba,money2,qazwsxedc1,diamante,prosto,pdiddy,stinky1,gabby1,luckys,franci,pornographic,moochie,gfhjdjp,samdog,empire1,comicbookdb,emili,motdepasse,iphone,braveheart,reeses,nebula,sanjose,bubba2,kickflip,arcangel,superbow,porsche911,xyzzy,nigger1,dagobert,devil1,alatam,monkey2,barbara1,12345v,vfpfafrf,alessio,babemagn,aceman,arrakis,kavkaz,987789,jasons,berserk,sublime1,rogue1,myspace,buckwhea,csyekz,pussy4me,vette1,boots1,boingo,arnaud,budlite,redstorm,paramore,becky1,imtheman,chango,marley1,milkyway,666555,giveme,mahalo,lux2000,lucian,paddy,praxis,shimano,bigpenis,creeper,newproject2004,rammstei,j3qq4h7h2v,hfljcnm,lambchop,anthony2,bugman,gfhjkm12,dreamer1,stooges,cybersex,diamant,cowboyup,maximus1,sentra,615243,goethe,manhatta,fastcar,selmer,1213141516,yfnfitymrf,denni,chewey,yankee1,elektra,123456789p,trousers,fishface,topspin,orwell,vorona,sodapop,motherfu,ibilltes,forall,kookie,ronald1,balrog,maximilian,mypasswo,sonny1,zzxxcc,tkfkdg,magoo,mdogg,heeled,gitara,lesbos,marajade,tippy,morozova,enter123,lesbean,pounded,asd456,fialka,scarab,sharpie,spanky1,gstring,sachin,12345asd,princeto,hellohel,ursitesux,billows,1234kekc,kombat,cashew,duracell,kseniya,sevenof9,kostik,arthur1,corvet07,rdfhnbhf,songoku,tiberian,needforspeed,1qwert,dropkick,kevin123,panache,libra,a123456a,kjiflm,vfhnsirf,cntgfy,iamcool,narut,buffer,sk8ordie,urlaub,fireblade,blanked,marishka,gemini1,altec,gorillaz,chief1,revival47,ironman1,space1,ramstein,doorknob,devilmaycry,nemesis1,sosiska,pennstat,monday1,pioner,shevchenko,detectiv,evildead,blessed1,aggie,coffees,tical,scotts,bullwink,marsel,krypto,adrock,rjitxrf,asmodeus,rapunzel,theboys,hotdogs,deepthro,maxpayne,veronic,fyyeirf,otter,cheste,abbey1,thanos,bedrock,bartok,google1,xxxzzz,rodent,montecarlo,hernande,mikayla,123456789l,bravehea,12locked,ltymub,pegasus1,ameteur,saltydog,faisal,milfnew,momsuck,everques,ytngfhjkz,m0nkey,businessbabe,cooki,custard,123456ab,lbvjxrf,outlaws,753357,qwerty78,udacha,insider,chees,fuckmehard,shotokan,katya,seahorse,vtldtlm,turtle1,mike12,beebop,heathe,everton1,darknes,barnie,rbcekz,alisher,toohot,theduke,555222,reddog1,breezy,bulldawg,monkeyman,baylee,losangel,mastermi,apollo1,aurelie,zxcvb12345,cayenne,bastet,wsxzaq,geibcnbr,yello,fucmy69,redwall,ladybird,bitchs,cccccc1,rktjgfnhf,ghjdthrf,quest1,oedipus,linus,impalass,fartman,12345k,fokker,159753a,optiplex,bbbbbb1,realtor,slipkno,santacru,rowdy,jelena,smeller,3984240,ddddd1,sexyme,janet1,3698741,eatme69,cazzone,today1,poobear,ignatius,master123,newpass1,heather2,snoopdogg,blondinka,pass12,honeydew,fuckthat,890098890,lovem,goldrush,gecko,biker1,llama,pendejo,avalanche,fremont,snowman1,gandolf,chowder,1a2b3c4d5e,flyguy,magadan,1fuck,pingvin,nokia5230,ab1234,lothar,lasers,bignuts,renee1,royboy,skynet,12340987,1122334,dragrace,lovely1,22334455,booter,12345612,corvett,123456qq,capital1,videoes,funtik,wyvern,flange,sammydog,hulkster,13245768,not4you,vorlon,omegared,l58jkdjp!,filippo,123mudar,samadams,petrus,chris12,charlie123,123456789123,icetea,sunderla,adrian1,123qweas,kazanova,aslan,monkey123,fktyeirf,goodsex,123ab,lbtest,banaan,bluenose,837519,asd12345,waffenss,whateve,1a2a3a4a,trailers,vfhbirf,bhbcrf,klaatu,turk182,monsoon,beachbum,sunbeam,succes,clyde1,viking1,rawhide,bubblegum,princ,mackenzi,hershey1,222555,dima55,niggaz,manatee,aquila,anechka,pamel,bugsbunn,lovel,sestra,newport1,althor,hornyman,wakeup,zzz111,phishy,cerber,torrent,thething,solnishko,babel,buckeye1,peanu,ethernet,uncencored,baraka,665544,chris2,rb26dett,willy1,choppers,texaco,biggirl,123456b,anna2614,sukebe,caralho,callofduty,rt6ytere,jesus7,angel12,1money,timelord,allblack,pavlova,romanov,tequiero,yitbos,lookup,bulls23,snowflake,dickweed,barks,lever,irisha,firestar,fred1234,ghjnjnbg,danman,gatito,betty1,milhouse,kbctyjr,masterbaiting,delsol,papit,doggys,123698741,bdfyjdf,invictus,bloods,kayla1,yourmama,apple2,angelok,bigboy1,pontiac1,verygood,yeshua,twins2,porn4me,141516,rasta69,james2,bosshog,candys,adventur,stripe,djkjlz,dokken,austin316,skins,hogwarts,vbhevbh,navigato,desperado,xxx666,cneltyn,vasiliy,hazmat,daytek,eightbal,fred1,four20,74227422,fabia,aerosmith,manue,wingchun,boohoo,hombre,sanity72,goatboy,fuckm,partizan,avrora,utahjazz,submarin,pussyeat,heinlein,control1,costaric,smarty,chuan,triplets,snowy,snafu,teacher1,vangogh,vandal,evergree,cochise,qwerty99,pyramid1,saab900,sniffer,qaz741,lebron23,mark123,wolvie,blackbelt,yoshi,feeder,janeway,nutella,fuking,asscock,deepak,poppie,bigshow,housewife,grils,tonto,cynthia1,temptress,irakli,belle1,russell1,manders,frank123,seabass,gforce,songbird,zippy1,naught,brenda1,chewy1,hotshit,topaz,43046721,girfriend,marinka,jakester,thatsme,planeta,falstaff,patrizia,reborn,riptide,cherry1,shuan,nogard,chino,oasis1,qwaszx12,goodlife,davis1,1911a1,harrys,shitfuck,12345678900,russian7,007700,bulls1,porshe,danil,dolphi,river1,sabaka,gobigred,deborah1,volkswagen,miamo,alkaline,muffdive,1letmein,fkbyrf,goodguy,hallo1,nirvan,ozzie,cannonda,cvbhyjdf,marmite,germany1,joeblow,radio1,love11,raindrop,159852,jacko,newday,fathead,elvis123,caspe,citibank,sports1,deuce,boxter,fakepass,golfman,snowdog,birthday4,nonmembe,niklas,parsifal,krasota,theshit,1235813,maganda,nikita1,omicron,cassie1,columbo,buick,sigma1,thistle,bassin,rickster,apteka,sienna,skulls,miamor,coolgirl,gravis,1qazxc,virgini,hunter2,akasha,batma,motorcyc,bambino,tenerife,fordf250,zhuan,iloveporn,markiza,hotbabes,becool,fynjybyf,wapapapa,forme,mamont,pizda,dragonz,sharon1,scrooge,mrbill,pfloyd,leeroy,natedog,ishmael,777111,tecumseh,carajo,nfy.irf,0000000000o,blackcock,fedorov,antigone,feanor,novikova,bobert,peregrin,spartan117,pumkin,rayman,manuals,tooltime,555333,bonethug,marina1,bonnie1,tonyhawk,laracroft,mahalkita,18273645,terriers,gamer,hoser,littlema,molotok,glennwei,lemon1,caboose,tater,12345654321,brians,fritz1,mistral,jigsaw,fuckshit,hornyguy,southside,edthom,antonio1,bobmarle,pitures,ilikesex,crafty,nexus,boarder,fulcrum,astonvil,yanks1,yngwie,account1,zooropa,hotlegs,sammi,gumbo,rover1,perkele,maurolarastefy,lampard,357753,barracud,dmband,abcxyz,pathfinder,335577,yuliya,micky,jayman,asdfg12345,1596321,halcyon,rerfhtre,feniks,zaxscd,gotyoass,jaycee,samson1,jamesb,vibrate,grandpri,camino,colossus,davidb,mamo4ka,nicky1,homer123,pinguin,watermelon,shadow01,lasttime,glider,823762,helen1,pyramids,tulane,osama,rostov,john12,scoote,bhbyrf,gohan,galeries,joyful,bigpussy,tonka,mowgli,astalavista,zzz123,leafs,dalejr8,unicorn1,777000,primal,bigmama,okmijn,killzone,qaz12345,snookie,zxcvvcxz,davidc,epson,rockman,ceaser,beanbag,katten,3151020,duckhunt,segreto,matros,ragnar,699669,sexsexse,123123z,fuckyeah,bigbutts,gbcmrf,element1,marketin,saratov,elbereth,blaster1,yamahar6,grime,masha,juneau,1230123,pappy,lindsay1,mooner,seattle1,katzen,lucent,polly1,lagwagon,pixie,misiaczek,666666a,smokedog,lakers24,eyeball,ironhors,ametuer,volkodav,vepsrf,kimmy,gumby1,poi098,ovation,1q2w3,drinker,penetrating,summertime,1dallas,prima,modles,takamine,hardwork,macintosh,tahoe,passthie,chiks,sundown,flowers1,boromir,music123,phaedrus,albert1,joung,malakas,gulliver,parker1,balder,sonne,jessie1,domainlock2005,express1,vfkbyf,youandme,raketa,koala,dhjnvytyjub,nhfrnjh,testibil,ybrbnjc,987654321q,axeman,pintail,pokemon123,dogggg,shandy,thesaint,11122233,x72jhhu3z,theclash,raptors,zappa1,djdjxrf,hell666,friday1,vivaldi,pluto1,lance1,guesswho,jeadmi,corgan,skillz,skippy1,mango1,gymnastic,satori,362514,theedge,cxfcnkbdfz,sparkey,deicide,bagels,lololol,lemmings,r4e3w2q1,silve,staind,schnuffi,dazzle,basebal1,leroy1,bilbo1,luckie,qwerty2,goodfell,hermione,peaceout,davidoff,yesterda,killah,flippy,chrisb,zelda1,headless,muttley,fuckof,tittys,catdaddy,photog,beeker,reaver,ram1500,yorktown,bolero,tryagain,arman,chicco,learjet,alexei,jenna1,go2hell,12s3t4p55,momsanaladventure,mustang9,protoss,rooter,ginola,dingo1,mojave,erica1,1qazse4,marvin1,redwolf,sunbird,dangerou,maciek,girsl,hawks1,packard1,excellen,dashka,soleda,toonces,acetate,nacked,jbond007,alligator,debbie1,wellhung,monkeyma,supers,rigger,larsson,vaseline,rjnzhf,maripos,123456asd,cbr600rr,doggydog,cronic,jason123,trekker,flipmode,druid,sonyvaio,dodges,mayfair,mystuff,fun4me,samanta,sofiya,magics,1ranger,arcane,sixtynin,222444,omerta,luscious,gbyudby,bobcats,envision,chance1,seaweed,holdem,tomate,mensch,slicer,acura1,goochi,qweewq,punter,repoman,tomboy,never1,cortina,gomets,147896321,369852147,dogma,bhjxrf,loglatin,eragon,strato,gazelle,growler,885522,klaudia,payton34,fuckem,butchie,scorpi,lugano,123456789k,nichola,chipper1,spide,uhbujhbq,rsalinas,vfylfhby,longhorns,bugatti,everquest,!qaz2wsx,blackass,999111,snakeman,p455w0rd,fanatic,family1,pfqxbr,777vlad,mysecret,marat,phoenix2,october1,genghis,panties1,cooker,citron,ace123,1234569,gramps,blackcoc,kodiak1,hickory,ivanhoe,blackboy,escher,sincity,beaks,meandyou,spaniel,canon1,timmy1,lancaste,polaroid,edinburg,fuckedup,hotman,cueball,golfclub,gopack,bookcase,worldcup,dkflbvbhjdbx,twostep,17171717aa,letsplay,zolushka,stella1,pfkegf,kingtut,67camaro,barracuda,wiggles,gjhjkm,prancer,patata,kjifhf,theman1,romanova,sexyass,copper1,dobber,sokolov,pomidor,algernon,cadman,amoremio,william2,silly1,bobbys,hercule,hd764nw5d7e1vb1,defcon,deutschland,robinhood,alfalfa,machoman,lesbens,pandora1,easypay,tomservo,nadezhda,goonies,saab9000,jordyn,f15eagle,dbrecz,12qwerty,greatsex,thrawn,blunted,baywatch,doggystyle,loloxx,chevy2,january1,kodak,bushel,78963214,ub6ib9,zz8807zpl,briefs,hawker,224488,first1,bonzo,brent1,erasure,69213124,sidewind,soccer13,622521,mentos,kolibri,onepiece,united1,ponyboy,keksa12,wayer,mypussy,andrej,mischa,mille,bruno123,garter,bigpun,talgat,familia,jazzy1,mustang8,newjob,747400,bobber,blackbel,hatteras,ginge,asdfjkl;,camelot1,blue44,rebbyt34,ebony1,vegas123,myboys,aleksander,ijrjkflrf,lopata,pilsner,lotus123,m0nk3y,andreev,freiheit,balls1,drjynfrnt,mazda1,waterpolo,shibumi,852963,123bbb,cezer121,blondie1,volkova,rattler,kleenex,ben123,sanane,happydog,satellit,qazplm,qazwsxedcrfvtgb,meowmix,badguy,facefuck,spice1,blondy,major1,25000,anna123,654321a,sober1,deathrow,patterso,china1,naruto1,hawkeye1,waldo1,butchy,crayon,5tgb6yhn,klopik,crocodil,mothra,imhorny,pookie1,splatter,slippy,lizard1,router,buratino,yahweh,123698,dragon11,123qwe456,peepers,trucker1,ganjaman,1hxboqg2,cheyanne,storys,sebastie,zztop,maddison,4rfv3edc,darthvader,jeffro,iloveit,victor1,hotty,delphin,lifeisgood,gooseman,shifty,insertions,dude123,abrupt,123masha,boogaloo,chronos,stamford,pimpster,kthjxrf,getmein,amidala,flubber,fettish,grapeape,dantes,oralsex,jack1,foxcg33,winchest,francis1,getin,archon,cliffy,blueman,1basebal,sport1,emmitt22,porn123,bignasty,morga,123hfjdk147,ferrar,juanito,fabiol,caseydog,steveo,peternorth,paroll,kimchi,bootleg,gaijin,secre,acacia,eatme2,amarillo,monkey11,rfhfgep,tylers,a1a2a3a4a5,sweetass,blower,rodina,babushka,camilo,cimbom,tiffan,vfnbkmlf,ohbaby,gotigers,lindsey1,dragon13,romulus,qazxsw12,zxcvbn1,dropdead,hitman47,snuggle,eleven11,bloopers,357mag,avangard,bmw320,ginscoot,dshade,masterkey,voodoo1,rootedit,caramba,leahcim,hannover,8phrowz622,tim123,cassius,000000a,angelito,zzzzz1,badkarma,star1,malaga,glenwood,footlove,golf1,summer12,helpme1,fastcars,titan1,police1,polinka,k.jdm,marusya,augusto,shiraz,pantyhose,donald1,blaise,arabella,brigada,c3por2d2,peter01,marco1,hellow,dillweed,uzumymw,geraldin,loveyou2,toyota1,088011,gophers,indy500,slainte,5hsu75kpot,teejay,renat,racoon,sabrin,angie1,shiznit,harpua,sexyred,latex,tucker1,alexandru,wahoo,teamwork,deepblue,goodison,rundmc,r2d2c3p0,puppys,samba,ayrton,boobed,999777,topsecre,blowme1,123321z,loudog,random1,pantie,drevil,mandolin,121212q,hottub,brother1,failsafe,spade1,matvey,open1234,carmen1,priscill,schatzi,kajak,gooddog,trojans1,gordon1,kayak,calamity,argent,ufhvjybz,seviyi,penfold,assface,dildos,hawkwind,crowbar,yanks,ruffles,rastus,luv2epus,open123,aquafina,dawns,jared1,teufel,12345c,vwgolf,pepsi123,amores,passwerd,01478520,boliva,smutty,headshot,password3,davidd,zydfhm,gbgbcmrf,pornpass,insertion,ceckbr,test2,car123,checkit,dbnfkbq,niggas,nyyankee,muskrat,nbuhtyjr,gunner1,ocean1,fabienne,chrissy1,wendys,loveme89,batgirl,cerveza,igorek,steel1,ragman,boris123,novifarm,sexy12,qwerty777,mike01,giveitup,123456abc,fuckall,crevice,hackerz,gspot,eight8,assassins,texass,swallows,123458,baldur,moonshine,labatt,modem,sydney1,voland,dbnfkz,hotchick,jacker,princessa,dawgs1,holiday1,booper,reliant,miranda1,jamaica1,andre1,badnaamhere,barnaby,tiger7,david12,margaux,corsica,085tzzqi,universi,thewall,nevermor,martin6,qwerty77,cipher,apples1,0102030405,seraphim,black123,imzadi,gandon,ducati99,1shadow,dkflbvbhjdyf,44magnum,bigbad,feedme,samantha1,ultraman,redneck1,jackdog,usmc0311,fresh1,monique1,tigre,alphaman,cool1,greyhoun,indycar,crunchy,55chevy,carefree,willow1,063dyjuy,xrated,assclown,federica,hilfiger,trivia,bronco1,mamita,100200300,simcity,lexingky,akatsuki,retsam,johndeere,abudfv,raster,elgato,businka,satanas,mattingl,redwing1,shamil,patate,mannn,moonstar,evil666,b123456,bowl300,tanechka,34523452,carthage,babygir,santino,bondarenko,jesuss,chico1,numlock,shyguy,sound1,kirby1,needit,mostwanted,427900,funky1,steve123,passions,anduril,kermit1,prospero,lusty,barakuda,dream1,broodwar,porky,christy1,mahal,yyyyyy1,allan1,1sexy,flintsto,capri,cumeater,heretic,robert2,hippos,blindax,marykay,collecti,kasumi,1qaz!qaz,112233q,123258,chemistr,coolboy,0o9i8u,kabuki,righton,tigress,nessie,sergej,andrew12,yfafyz,ytrhjvfyn,angel7,victo,mobbdeep,lemming,transfor,1725782,myhouse,aeynbr,muskie,leno4ka,westham1,cvbhyjd,daffodil,pussylicker,pamela1,stuffer,warehous,tinker1,2w3e4r,pluton,louise1,polarbea,253634,prime1,anatoliy,januar,wysiwyg,cobraya,ralphy,whaler,xterra,cableguy,112233a,porn69,jamesd,aqualung,jimmy123,lumpy,luckyman,kingsize,golfing1,alpha7,leeds1,marigold,lol1234,teabag,alex11,10sne1,saopaulo,shanny,roland1,basser,3216732167,carol1,year2005,morozov,saturn1,joseluis,bushed,redrock,memnoch,lalaland,indiana1,lovegod,gulnaz,buffalos,loveyou1,anteater,pattaya,jaydee,redshift,bartek,summerti,coffee1,ricochet,incest,schastie,rakkaus,h2opolo,suikoden,perro,dance1,loveme1,whoopass,vladvlad,boober,flyers1,alessia,gfcgjhn,pipers,papaya,gunsling,coolone,blackie1,gonads,gfhjkzytn,foxhound,qwert12,gangrel,ghjvtntq,bluedevi,mywife,summer01,hangman,licorice,patter,vfr750,thorsten,515253,ninguna,dakine,strange1,mexic,vergeten,12345432,8phrowz624,stampede,floyd1,sailfish,raziel,ananda,giacomo,freeme,crfprf,74185296,allstars,master01,solrac,gfnhbjn,bayliner,bmw525,3465xxx,catter,single1,michael3,pentium4,nitrox,mapet123456,halibut,killroy,xxxxx1,phillip1,poopsie,arsenalfc,buffys,kosova,all4me,32165498,arslan,opensesame,brutis,charles2,pochta,nadegda,backspac,mustang0,invis,gogeta,654321q,adam25,niceday,truckin,gfdkbr,biceps,sceptre,bigdave,lauras,user345,sandys,shabba,ratdog,cristiano,natha,march13,gumball,getsdown,wasdwasd,redhead1,dddddd1,longlegs,13572468,starsky,ducksoup,bunnys,omsairam,whoami,fred123,danmark,flapper,swanky,lakings,yfhenj,asterios,rainier,searcher,dapper,ltdjxrf,horsey,seahawk,shroom,tkfkdgo,aquaman,tashkent,number9,messi10,1asshole,milenium,illumina,vegita,jodeci,buster01,bareback,goldfinger,fire1,33rjhjds,sabian,thinkpad,smooth1,sully,bonghits,sushi1,magnavox,colombi,voiture,limpone,oldone,aruba,rooster1,zhenya,nomar5,touchdow,limpbizkit,rhfcfdxbr,baphomet,afrodita,bball1,madiso,ladles,lovefeet,matthew2,theworld,thunderbird,dolly1,123rrr,forklift,alfons,berkut,speedy1,saphire,oilman,creatine,pussylov,bastard1,456258,wicked1,filimon,skyline1,fucing,yfnfkbz,hot123,abdulla,nippon,nolimits,billiard,booty1,buttplug,westlife,coolbean,aloha1,lopas,asasin,1212121,october2,whodat,good4u,d12345,kostas,ilya1992,regal,pioneer1,volodya,focus1,bastos,nbvjif,fenix,anita1,vadimka,nickle,jesusc,123321456,teste,christ1,essendon,evgenii,celticfc,adam1,forumwp,lovesme,26exkp,chillout,burly,thelast1,marcus1,metalgear,test11,ronaldo7,socrate,world1,franki,mommie,vicecity,postov1000,charlie3,oldschool,333221,legoland,antoshka,counterstrike,buggy,mustang3,123454,qwertzui,toons,chesty,bigtoe,tigger12,limpopo,rerehepf,diddle,nokia3250,solidsnake,conan1,rockroll,963369,titanic1,qwezxc,cloggy,prashant,katharin,maxfli,takashi,cumonme,michael9,mymother,pennstate,khalid,48151623,fightclub,showboat,mateusz,elrond,teenie,arrow1,mammamia,dustydog,dominator,erasmus,zxcvb1,1a2a3a,bones1,dennis1,galaxie,pleaseme,whatever1,junkyard,galadriel,charlies,2wsxzaq1,crimson1,behemoth,teres,master11,fairway,shady1,pass99,1batman,joshua12,baraban,apelsin,mousepad,melon,twodogs,123321qwe,metalica,ryjgrf,pipiska,rerfhfxf,lugnut,cretin,iloveu2,powerade,aaaaaaa1,omanko,kovalenko,isabe,chobits,151nxjmt,shadow11,zcxfcnkbdf,gy3yt2rgls,vfhbyrf,159753123,bladerunner,goodone,wonton,doodie,333666999,fuckyou123,kitty123,chisox,orlando1,skateboa,red12345,destroye,snoogans,satan1,juancarlo,goheels,jetson,scottt,fuckup,aleksa,gfhfljrc,passfind,oscar123,derrick1,hateme,viper123,pieman,audi100,tuffy,andover,shooter1,10000,makarov,grant1,nighthaw,13576479,browneye,batigol,nfvfhf,chocolate1,7hrdnw23,petter,bantam,morlii,jediknight,brenden,argonaut,goodstuf,wisconsi,315920,abigail1,dirtbag,splurge,k123456,lucky777,valdepen,gsxr600,322223,ghjnjrjk,zaq1xsw2cde3,schwanz,walter1,letmein22,nomads,124356,codeblue,nokian70,fucke,footbal1,agyvorc,aztecs,passw0r,smuggles,femmes,ballgag,krasnodar,tamuna,schule,sixtynine,empires,erfolg,dvader,ladygaga,elite1,venezuel,nitrous,kochamcie,olivia1,trustn01,arioch,sting1,131415,tristar,555000,maroon,135799,marsik,555556,fomoco,natalka,cwoui,tartan,davecole,nosferat,hotsauce,dmitry,horus,dimasik,skazka,boss302,bluebear,vesper,ultras,tarantul,asd123asd,azteca,theflash,8ball,1footbal,titlover,lucas123,number6,sampson1,789852,party1,dragon99,adonai,carwash,metropol,psychnau,vthctltc,hounds,firework,blink18,145632,wildcat1,satchel,rice80,ghtktcnm,sailor1,cubano,anderso,rocks1,mike11,famili,dfghjc,besiktas,roygbiv,nikko,bethan,minotaur,rakesh,orange12,hfleuf,jackel,myangel,favorite7,1478520,asssss,agnieszka,haley1,raisin,htubyf,1buster,cfiekz,derevo,1a2a3a4a5a,baltika,raffles,scruffy1,clitlick,louis1,buddha1,fy.nrf,walker1,makoto,shadow2,redbeard,vfvfvskfhfve,mycock,sandydog,lineman,network1,favorite8,longdick,mustangg,mavericks,indica,1killer,cisco1,angelofwar,blue69,brianna1,bubbaa,slayer666,level42,baldrick,brutus1,lowdown,haribo,lovesexy,500000,thissuck,picker,stephy,1fuckme,characte,telecast,1bigdog,repytwjdf,thematrix,hammerhe,chucha,ganesha,gunsmoke,georgi,sheltie,1harley,knulla,sallas,westie,dragon7,conker,crappie,margosha,lisboa,3e2w1q,shrike,grifter,ghjcnjghjcnj,asdfg1,mnbvcxz1,myszka,posture,boggie,rocketman,flhtyfkby,twiztid,vostok,pi314159,force1,televizor,gtkmvtym,samhain,imcool,jadzia,dreamers,strannik,k2trix,steelhea,nikitin,commodor,brian123,chocobo,whopper,ibilljpf,megafon,ararat,thomas12,ghbrjkbcn,q1234567890,hibernia,kings1,jim123,redfive,68camaro,iawgk2,xavier1,1234567u,d123456,ndirish,airborn,halfmoon,fluffy1,ranchero,sneaker,soccer2,passion1,cowman,birthday1,johnn,razzle,glock17,wsxqaz,nubian,lucky2,jelly1,henderso,eric1,123123e,boscoe01,fuck0ff,simpson1,sassie,rjyjgkz,nascar3,watashi,loredana,janus,wilso,conman,david2,mothe,iloveher,snikers,davidj,fkmnthyfnbdf,mettss,ratfink,123456h,lostsoul,sweet16,brabus,wobble,petra1,fuckfest,otters,sable1,svetka,spartacu,bigstick,milashka,1lover,pasport,champagn,papichul,hrvatska,hondacivic,kevins,tacit,moneybag,gohogs,rasta1,246813579,ytyfdbcnm,gubber,darkmoon,vitaliy,233223,playboys,tristan1,joyce1,oriflame,mugwump,access2,autocad,thematri,qweqwe123,lolwut,ibill01,multisyn,1233211,pelikan,rob123,chacal,1234432,griffon,pooch,dagestan,geisha,satriani,anjali,rocketma,gixxer,pendrago,vincen,hellokit,killyou,ruger,doodah,bumblebe,badlands,galactic,emachines,foghorn,jackso,jerem,avgust,frontera,123369,daisymae,hornyboy,welcome123,tigger01,diabl,angel13,interex,iwantsex,rockydog,kukolka,sawdust,online1,3234412,bigpapa,jewboy,3263827,dave123,riches,333222,tony1,toggle,farter,124816,tities,balle,brasilia,southsid,micke,ghbdtn12,patit,ctdfcnjgjkm,olds442,zzzzzz1,nelso,gremlins,gypsy1,carter1,slut69,farcry,7415963,michael8,birdie1,charl,123456789abc,100001,aztec,sinjin,bigpimpi,closeup,atlas1,nvidia,doggone,classic1,manana,malcolm1,rfkbyf,hotbabe,rajesh,dimebag,ganjubas,rodion,jagr68,seren,syrinx,funnyman,karapuz,123456789n,bloomin,admin18533362,biggdogg,ocarina,poopy1,hellome,internet1,booties,blowjobs,matt1,donkey1,swede,1jennife,evgeniya,lfhbyf,coach1,444777,green12,patryk,pinewood,justin12,271828,89600506779,notredame,tuborg,lemond,sk8ter,million1,wowser,pablo1,st0n3,jeeves,funhouse,hiroshi,gobucs,angeleye,bereza,winter12,catalin,qazedc,andros,ramazan,vampyre,sweethea,imperium,murat,jamest,flossy,sandeep,morgen,salamandra,bigdogg,stroller,njdevils,nutsack,vittorio,%%passwo,playful,rjyatnrf,tookie,ubnfhf,michi,777444,shadow13,devils1,radiance,toshiba1,beluga,amormi,dandfa,trust1,killemall,smallville,polgara,billyb,landscap,steves,exploite,zamboni,damage11,dzxtckfd,trader12,pokey1,kobe08,damager,egorov,dragon88,ckfdbr,lisa69,blade2,audis4,nelson1,nibbles,23176djivanfros,mutabor,artofwar,matvei,metal666,hrfzlz,schwinn,poohbea,seven77,thinker,123456789qwerty,sobriety,jakers,karamelka,vbkfyf,volodin,iddqd,dale03,roberto1,lizaveta,qqqqqq1,cathy1,08154711,davidm,quixote,bluenote,tazdevil,katrina1,bigfoot1,bublik,marma,olechka,fatpussy,marduk,arina,nonrev67,qqqq1111,camill,wtpfhm,truffle,fairview,mashina,voltaire,qazxswedcvfr,dickface,grassy,lapdance,bosstone,crazy8,yackwin,mobil,danielit,mounta1n,player69,bluegill,mewtwo,reverb,cnthdf,pablito,a123321,elena1,warcraft1,orland,ilovemyself,rfntyjr,joyride,schoo,dthjxrf,thetachi,goodtimes,blacksun,humpty,chewbacca,guyute,123xyz,lexicon,blue45,qwe789,galatasaray,centrino,hendrix1,deimos,saturn5,craig1,vlad1996,sarah123,tupelo,ljrnjh,hotwife,bingos,1231231,nicholas1,flamer,pusher,1233210,heart1,hun999,jiggy,giddyup,oktober,123456zxc,budda,galahad,glamur,samwise,oneton,bugsbunny,dominic1,scooby2,freetime,internat,159753852,sc00ter,wantit,mazinger,inflames,laracrof,greedo,014789,godofwar,repytwjd,water123,fishnet,venus1,wallace1,tenpin,paula1,1475963,mania,novikov,qwertyasdfgh,goldmine,homies,777888999,8balls,holeinon,paper1,samael,013579,mansur,nikit,ak1234,blueline,polska1,hotcock,laredo,windstar,vbkbwbz,raider1,newworld,lfybkrf,catfish1,shorty1,piranha,treacle,royale,2234562,smurfs,minion,cadence,flapjack,123456p,sydne,135531,robinhoo,nasdaq,decatur,cyberonline,newage,gemstone,jabba,touchme,hooch,pigdog,indahous,fonzie,zebra1,juggle,patrick2,nihongo,hitomi,oldnavy,qwerfdsa,ukraina,shakti,allure,kingrich,diane1,canad,piramide,hottie1,clarion,college1,5641110,connect1,therion,clubber,velcro,dave1,astra1,13579-,astroboy,skittle,isgreat,photoes,cvzefh1gkc,001100,2cool4u,7555545,ginger12,2wsxcde3,camaro69,invader,domenow,asd1234,colgate,qwertasdfg,jack123,pass01,maxman,bronte,whkzyc,peter123,bogie,yecgaa,abc321,1qay2wsx,enfield,camaroz2,trashman,bonefish,system32,azsxdcfvgb,peterose,iwantyou,dick69,temp1234,blastoff,capa200,connie1,blazin,12233445,sexybaby,123456j,brentfor,pheasant,hommer,jerryg,thunders,august1,lager,kapusta,boobs1,nokia5300,rocco1,xytfu7,stars1,tugger,123sas,blingbling,1bubba,0wnsyo0,1george,baile,richard2,habana,1diamond,sensatio,1golfer,maverick1,1chris,clinton1,michael7,dragons1,sunrise1,pissant,fatim,mopar1,levani,rostik,pizzapie,987412365,oceans11,748159263,cum4me,palmetto,4r3e2w1q,paige1,muncher,arsehole,kratos,gaffer,banderas,billys,prakash,crabby,bungie,silver12,caddis,spawn1,xboxlive,sylvania,littlebi,524645,futura,valdemar,isacs155,prettygirl,big123,555444,slimer,chicke,newstyle,skypilot,sailormoon,fatluvr69,jetaime,sitruc,jesuschrist,sameer,bear12,hellion,yendor,country1,etnies,conejo,jedimast,darkknight,toobad,yxcvbn,snooks,porn4life,calvary,alfaromeo,ghostman,yannick,fnkfynblf,vatoloco,homebase,5550666,barret,1111111111zz,odysseus,edwardss,favre4,jerrys,crybaby,xsw21qaz,firestor,spanks,indians1,squish,kingair,babycakes,haters,sarahs,212223,teddyb,xfactor,cumload,rhapsody,death123,three3,raccoon,thomas2,slayer66,1q2q3q4q5q,thebes,mysterio,thirdeye,orkiox.,nodoubt,bugsy,schweiz,dima1996,angels1,darkwing,jeronimo,moonpie,ronaldo9,peaches2,mack10,manish,denise1,fellowes,carioca,taylor12,epaulson,makemoney,oc247ngucz,kochanie,3edcvfr4,vulture,1qw23e,1234567z,munchie,picard1,xthtgfirf,sportste,psycho1,tahoe1,creativ,perils,slurred,hermit,scoob,diesel1,cards1,wipeout,weeble,integra1,out3xf,powerpc,chrism,kalle,ariadne,kailua,phatty,dexter1,fordman,bungalow,paul123,compa,train1,thejoker,jys6wz,pussyeater,eatmee,sludge,dominus,denisa,tagheuer,yxcvbnm,bill1,ghfdlf,300zx,nikita123,carcass,semaj,ramone,muenchen,animal1,greeny,annemari,dbrf134,jeepcj7,mollys,garten,sashok,ironmaid,coyotes,astoria,george12,westcoast,primetim,123456o,panchito,rafae,japan1,framer,auralo,tooshort,egorova,qwerty22,callme,medicina,warhawk,w1w2w3w4,cristia,merli,alex22,kawaii,chatte,wargames,utvols,muaddib,trinket,andreas1,jjjjj1,cleric,scooters,cuntlick,gggggg1,slipknot1,235711,handcuff,stussy,guess1,leiceste,ppppp1,passe,lovegun,chevyman,hugecock,driver1,buttsex,psychnaut1,cyber1,black2,alpha12,melbourn,man123,metalman,yjdsqujl,blondi,bungee,freak1,stomper,caitlin1,nikitina,flyaway,prikol,begood,desperad,aurelius,john1234,whosyourdaddy,slimed123,bretagne,den123,hotwheel,king123,roodypoo,izzicam,save13tx,warpten,nokia3310,samolet,ready1,coopers,scott123,bonito,1aaaaa,yomomma,dawg1,rache,itworks,asecret,fencer,451236,polka,olivetti,sysadmin,zepplin,sanjuan,479373,lickem,hondacrx,pulamea,future1,naked1,sexyguy,w4g8at,lollol1,declan,runner1,rumple,daddy123,4snz9g,grandprix,calcio,whatthefuck,nagrom,asslick,pennst,negrit,squiggy,1223334444,police22,giovann,toronto1,tweet,yardbird,seagate,truckers,554455,scimitar,pescator,slydog,gaysex,dogfish,fuck777,12332112,qazxswed,morkovka,daniela1,imback,horny69,789123456,123456789w,jimmy2,bagger,ilove69,nikolaus,atdhfkm,rebirth,1111aaaa,pervasive,gjgeufq,dte4uw,gfhnbpfy,skeletor,whitney1,walkman,delorean,disco1,555888,as1234,ishikawa,fuck12,reaper1,dmitrii,bigshot,morrisse,purgen,qwer4321,itachi,willys,123123qwe,kisska,roma123,trafford,sk84life,326159487,pedros,idiom,plover,bebop,159875321,jailbird,arrowhea,qwaszx123,zaxscdvf,catlover,bakers,13579246,bones69,vermont1,helloyou,simeon,chevyz71,funguy,stargaze,parolparol,steph1,bubby,apathy,poppet,laxman,kelly123,goodnews,741236,boner1,gaetano,astonvilla,virtua,luckyboy,rocheste,hello2u,elohim,trigger1,cstrike,pepsicola,miroslav,96385274,fistfuck,cheval,magyar,svetlanka,lbfyjxrf,mamedov,123123123q,ronaldo1,scotty1,1nicole,pittbull,fredd,bbbbb1,dagwood,gfhkfvtyn,ghblehrb,logan5,1jordan,sexbomb,omega2,montauk,258741,dtythf,gibbon,winamp,thebomb,millerli,852654,gemin,baldy,halflife2,dragon22,mulberry,morrigan,hotel6,zorglub,surfin,951159,excell,arhangel,emachine,moses1,968574,reklama,bulldog2,cuties,barca,twingo,saber,elite11,redtruck,casablan,ashish,moneyy,pepper12,cnhtktw,rjcnbr,arschloch,phenix,cachorro,sunita,madoka,joselui,adams1,mymoney,hemicuda,fyutkjr,jake12,chicas,eeeee1,sonnyboy,smarties,birdy,kitten1,cnfcbr,island1,kurosaki,taekwond,konfetka,bennett1,omega3,jackson2,fresca,minako,octavian,kban667,feyenoord,muaythai,jakedog,fktrcfylhjdyf,1357911q,phuket,sexslave,fktrcfylhjdbx,asdfjk,89015173454,qwerty00,kindbud,eltoro,sex6969,nyknicks,12344321q,caballo,evenflow,hoddle,love22,metro1,mahalko,lawdog,tightass,manitou,buckie,whiskey1,anton123,335533,password4,primo,ramair,timbo,brayden,stewie,pedro1,yorkshir,ganster,hellothe,tippy1,direwolf,genesi,rodrig,enkeli,vaz21099,sorcerer,winky,oneshot,boggle,serebro,badger1,japanes,comicbook,kamehame,alcat,denis123,echo45,sexboy,gr8ful,hondo,voetbal,blue33,2112rush,geneviev,danni1,moosey,polkmn,matthew7,ironhead,hot2trot,ashley12,sweeper,imogen,blue21,retep,stealth1,guitarra,bernard1,tatian,frankfur,vfnhbwf,slacking,haha123,963741,asdasdas,katenok,airforce1,123456789qaz,shotgun1,12qwasz,reggie1,sharo,976431,pacifica,dhip6a,neptun,kardon,spooky1,beaut,555555a,toosweet,tiedup,11121314,startac,lover69,rediska,pirata,vfhrbp,1234qwerty,energize,hansolo1,playbo,larry123,oemdlg,cnjvfnjkju,a123123,alexan,gohawks,antonius,fcbayern,mambo,yummy1,kremlin,ellen1,tremere,vfiekz,bellevue,charlie9,izabella,malishka,fermat,rotterda,dawggy,becket,chasey,kramer1,21125150,lolit,cabrio,schlong,arisha,verity,3some,favorit,maricon,travelle,hotpants,red1234,garrett1,home123,knarf,seven777,figment,asdewq,canseco,good2go,warhol,thomas01,pionee,al9agd,panacea,chevy454,brazzers,oriole,azerty123,finalfan,patricio,northsta,rebelde,bulldo,stallone,boogie1,7uftyx,cfhfnjd,compusa,cornholi,config,deere,hoopster,sepultura,grasshop,babygurl,lesbo,diceman,proverbs,reddragon,nurbek,tigerwoo,superdup,buzzsaw,kakaroto,golgo13,edwar,123qaz123,butter1,sssss1,texas2,respekt,ou812ic,123456qaz,55555a,doctor1,mcgwire,maria123,aol999,cinders,aa1234,joness,ghbrjkmyj,makemone,sammyboy,567765,380zliki,theraven,testme,mylene,elvira26,indiglo,tiramisu,shannara,baby1,123666,gfhreh,papercut,johnmish,orange8,bogey1,mustang7,bagpipes,dimarik,vsijyjr,4637324,ravage,cogito,seven11,natashka,warzone,hr3ytm,4free,bigdee,000006,243462536,bigboi,123333,trouts,sandy123,szevasz,monica2,guderian,newlife1,ratchet,r12345,razorbac,12345i,piazza31,oddjob,beauty1,fffff1,anklet,nodrog,pepit,olivi,puravida,robert12,transam1,portman,bubbadog,steelers1,wilson1,eightball,mexico1,superboy,4rfv5tgb,mzepab,samurai1,fuckslut,colleen1,girdle,vfrcbvec,q1w2e3r4t,soldier1,19844891,alyssa1,a12345a,fidelis,skelter,nolove,mickeymouse,frehley,password69,watermel,aliska,soccer15,12345e,ladybug1,abulafia,adagio,tigerlil,takehana,hecate,bootneck,junfan,arigato,wonkette,bobby123,trustnoone,phantasm,132465798,brianjo,w12345,t34vfrc1991,deadeye,1robert,1daddy,adida,check1,grimlock,muffi,airwalk,prizrak,onclick,longbeac,ernie1,eadgbe,moore1,geniu,shadow123,bugaga,jonathan1,cjrjkjdf,orlova,buldog,talon1,westport,aenima,541233432442,barsuk,chicago2,kellys,hellbent,toughguy,iskander,skoal,whatisit,jake123,scooter2,fgjrfkbgcbc,ghandi,love13,adelphia,vjhrjdrf,adrenali,niunia,jemoeder,rainbo,all4u8,anime1,freedom7,seraph,789321,tommys,antman,firetruc,neogeo,natas,bmwm3,froggy1,paul1,mamit,bayview,gateways,kusanagi,ihateu,frederi,rock1,centurion,grizli,biggin,fish1,stalker1,3girls,ilovepor,klootzak,lollo,redsox04,kirill123,jake1,pampers,vasya,hammers1,teacup,towing,celtic1,ishtar,yingyang,4904s677075,dahc1,patriot1,patrick9,redbirds,doremi,rebecc,yoohoo,makarova,epiphone,rfgbnfy,milesd,blister,chelseafc,katana1,blackrose,1james,primrose,shock5,hard1,scooby12,c6h12o6,dustoff,boing,chisel,kamil,1william,defiant1,tyvugq,mp8o6d,aaa340,nafets,sonnet,flyhigh,242526,crewcom,love23,strike1,stairway,katusha,salamand,cupcake1,password0,007james,sunnie,multisync,harley01,tequila1,fred12,driver8,q8zo8wzq,hunter01,mozzer,temporar,eatmeraw,mrbrownxx,kailey,sycamore,flogger,tincup,rahasia,ganymede,bandera,slinger,1111122222,vander,woodys,1cowboy,khaled,jamies,london12,babyboo,tzpvaw,diogenes,budice,mavrick,135797531,cheeta,macros,squonk,blackber,topfuel,apache1,falcon16,darkjedi,cheeze,vfhvtkfl,sparco,change1,gfhfif,freestyl,kukuruza,loveme2,12345f,kozlov,sherpa,marbella,44445555,bocephus,1winner,alvar,hollydog,gonefish,iwantin,barman,godislove,amanda18,rfpfynbg,eugen,abcdef1,redhawk,thelema,spoonman,baller1,harry123,475869,tigerman,cdtnjxrf,marillio,scribble,elnino,carguy,hardhead,l2g7k3,troopers,selen,dragon76,antigua,ewtosi,ulysse,astana,paroli,cristo,carmex,marjan,bassfish,letitbe,kasparov,jay123,19933991,blue13,eyecandy,scribe,mylord,ukflbjkec,ellie1,beaver1,destro,neuken,halfpint,ameli,lilly1,satanic,xngwoj,12345trewq,asdf1,bulldogg,asakura,jesucrist,flipside,packers4,biggy,kadett,biteme69,bobdog,silverfo,saint1,bobbo,packman,knowledg,foolio,fussbal,12345g,kozerog,westcoas,minidisc,nbvcxw,martini1,alastair,rasengan,superbee,memento,porker,lena123,florenc,kakadu,bmw123,getalife,bigsky,monkee,people1,schlampe,red321,memyself,0147896325,12345678900987654321,soccer14,realdeal,gfgjxrf,bella123,juggs,doritos,celtics1,peterbilt,ghbdtnbrb,gnusmas,xcountry,ghbdtn1,batman99,deusex,gtnhjdf,blablabl,juster,marimba,love2,rerjkrf,alhambra,micros,siemens1,assmaste,moonie,dashadasha,atybrc,eeeeee1,wildrose,blue55,davidl,xrp23q,skyblue,leo123,ggggg1,bestfriend,franny,1234rmvb,fun123,rules1,sebastien,chester2,hakeem,winston2,fartripper,atlant,07831505,iluvsex,q1a2z3,larrys,009900,ghjkju,capitan,rider1,qazxsw21,belochka,andy123,hellya,chicca,maximal,juergen,password1234,howard1,quetzal,daniel123,qpwoeiruty,123555,bharat,ferrari3,numbnuts,savant,ladydog,phipsi,lovepussy,etoile,power2,mitten,britneys,chilidog,08522580,2fchbg,kinky1,bluerose,loulo,ricardo1,doqvq3,kswbdu,013cpfza,timoha,ghbdtnghbdtn,3stooges,gearhead,browns1,g00ber,super7,greenbud,kitty2,pootie,toolshed,gamers,coffe,ibill123,freelove,anasazi,sister1,jigger,natash,stacy1,weronika,luzern,soccer7,hoopla,dmoney,valerie1,canes,razdvatri,washere,greenwoo,rfhjkbyf,anselm,pkxe62,maribe,daniel2,maxim1,faceoff,carbine,xtkjdtr,buddy12,stratos,jumpman,buttocks,aqswdefr,pepsis,sonechka,steeler1,lanman,nietzsch,ballz,biscuit1,wrxsti,goodfood,juventu,federic,mattman,vika123,strelec,jledfyxbr,sideshow,4life,fredderf,bigwilly,12347890,12345671,sharik,bmw325i,fylhtqrf,dannon4,marky,mrhappy,drdoom,maddog1,pompier,cerbera,goobers,howler,jenny69,evely,letitrid,cthuttdyf,felip,shizzle,golf12,t123456,yamah,bluearmy,squishy,roxan,10inches,dollface,babygirl1,blacksta,kaneda,lexingto,canadien,222888,kukushka,sistema,224422,shadow69,ppspankp,mellons,barbie1,free4all,alfa156,lostone,2w3e4r5t,painkiller,robbie1,binger,8dihc6,jaspe,rellik,quark,sogood,hoopstar,number2,snowy1,dad2ownu,cresta,qwe123asd,hjvfyjdf,gibsonsg,qbg26i,dockers,grunge,duckling,lfiekz,cuntsoup,kasia1,1tigger,woaini,reksio,tmoney,firefighter,neuron,audia3,woogie,powerboo,powermac,fatcock,12345666,upnfmc,lustful,porn1,gotlove,amylee,kbytqrf,11924704,25251325,sarasota,sexme,ozzie1,berliner,nigga1,guatemal,seagulls,iloveyou!,chicken2,qwerty21,010203040506,1pillow,libby1,vodoley,backlash,piglets,teiubesc,019283,vonnegut,perico,thunde,buckey,gtxtymrf,manunite,iiiii1,lost4815162342,madonn,270873_,britney1,kevlar,piano1,boondock,colt1911,salamat,doma77ns,anuradha,cnhjqrf,rottweil,newmoon,topgun1,mauser,fightclu,birthday21,reviewpa,herons,aassddff,lakers32,melissa2,vredina,jiujitsu,mgoblue,shakey,moss84,12345zxcvb,funsex,benji1,garci,113322,chipie,windex,nokia5310,pwxd5x,bluemax,cosita,chalupa,trotsky,new123,g3ujwg,newguy,canabis,gnaget,happydays,felixx,1patrick,cumface,sparkie,kozlova,123234,newports,broncos7,golf18,recycle,hahah,harrypot,cachondo,open4me,miria,guessit,pepsione,knocker,usmc1775,countach,playe,wiking,landrover,cracksevi,drumline,a7777777,smile123,manzana,panty,liberta,pimp69,dolfan,quality1,schnee,superson,elaine22,webhompass,mrbrownx,deepsea,4wheel,mamasita,rockport,rollie,myhome,jordan12,kfvgjxrf,hockey12,seagrave,ford1,chelsea2,samsara,marissa1,lamesa,mobil1,piotrek,tommygun,yyyyy1,wesley1,billy123,homersim,julies,amanda12,shaka,maldini,suzenet,springst,iiiiii1,yakuza,111111aa,westwind,helpdesk,annamari,bringit,hopefull,hhhhhhh1,saywhat,mazdarx8,bulova,jennife1,baikal,gfhjkmxbr,victoria1,gizmo123,alex99,defjam,2girls,sandrock,positivo,shingo,syncmast,opensesa,silicone,fuckina,senna1,karlos,duffbeer,montagne,gehrig,thetick,pepino,hamburge,paramedic,scamp,smokeweed,fabregas,phantoms,venom121293,2583458,badone,porno69,manwhore,vfvf123,notagain,vbktyf,rfnthbyrf,wildblue,kelly001,dragon66,camell,curtis1,frolova,1212123,dothedew,tyler123,reddrago,planetx,promethe,gigolo,1001001,thisone,eugeni,blackshe,cruzazul,incognito,puller,joonas,quick1,spirit1,gazza,zealot,gordito,hotrod1,mitch1,pollito,hellcat,mythos,duluth,383pdjvl,easy123,hermos,binkie,its420,lovecraf,darien,romina,doraemon,19877891,syclone,hadoken,transpor,ichiro,intell,gargamel,dragon2,wavpzt,557744,rjw7x4,jennys,kickit,rjynfrn,likeit,555111,corvus,nec3520,133113,mookie1,bochum,samsung2,locoman0,154ugeiu,vfvfbgfgf,135792,[start],tenni,20001,vestax,hufmqw,neveragain,wizkid,kjgfnf,nokia6303,tristen,saltanat,louie1,gandalf2,sinfonia,alpha3,tolstoy,ford150,f00bar,1hello,alici,lol12,riker1,hellou,333888,1hunter,qw1234,vibrator,mets86,43211234,gonzale,cookies1,sissy1,john11,bubber,blue01,cup2006,gtkmvtyb,nazareth,heybaby,suresh,teddie,mozilla,rodeo1,madhouse,gamera,123123321,naresh,dominos,foxtrot1,taras,powerup,kipling,jasonb,fidget,galena,meatman,alpacino,bookmark,farting,humper,titsnass,gorgon,castaway,dianka,anutka,gecko1,fucklove,connery,wings1,erika1,peoria,moneymaker,ichabod,heaven1,paperboy,phaser,breakers,nurse1,westbrom,alex13,brendan1,123asd123,almera,grubber,clarkie,thisisme,welkom01,51051051051,crypto,freenet,pflybwf,black12,testme2,changeit,autobahn,attica,chaoss,denver1,tercel,gnasher23,master2,vasilii,sherman1,gomer,bigbuck,derek1,qwerzxcv,jumble,dragon23,art131313,numark,beasty,cxfcnmttcnm,updown,starion,glist,sxhq65,ranger99,monkey7,shifter,wolves1,4r5t6y,phone1,favorite5,skytommy,abracada,1martin,102030405060,gatech,giulio,blacktop,cheer1,africa1,grizzly1,inkjet,shemales,durango1,booner,11223344q,supergirl,vanyarespekt,dickless,srilanka,weaponx,6string,nashvill,spicey,boxer1,fabien,2sexy2ho,bowhunt,jerrylee,acrobat,tawnee,ulisse,nolimit8,l8g3bkde,pershing,gordo1,allover,gobrowns,123432,123444,321456987,spoon1,hhhhh1,sailing1,gardenia,teache,sexmachine,tratata,pirate1,niceone,jimbos,314159265,qsdfgh,bobbyy,ccccc1,carla1,vjkjltw,savana,biotech,frigid,123456789g,dragon10,yesiam,alpha06,oakwood,tooter,winsto,radioman,vavilon,asnaeb,google123,nariman,kellyb,dthyjcnm,password6,parol1,golf72,skate1,lthtdj,1234567890s,kennet,rossia,lindas,nataliya,perfecto,eminem1,kitana,aragorn1,rexona,arsenalf,planot,coope,testing123,timex,blackbox,bullhead,barbarian,dreamon,polaris1,cfvjktn,frdfhbev,gametime,slipknot666,nomad1,hfgcjlbz,happy69,fiddler,brazil1,joeboy,indianali,113355,obelisk,telemark,ghostrid,preston1,anonim,wellcome,verizon1,sayangku,censor,timeport,dummies,adult1,nbnfybr,donger,thales,iamgay,sexy1234,deadlift,pidaras,doroga,123qwe321,portuga,asdfgh12,happys,cadr14nu,pi3141,maksik,dribble,cortland,darken,stepanova,bommel,tropic,sochi2014,bluegras,shahid,merhaba,nacho,2580456,orange44,kongen,3cudjz,78girl,my3kids,marcopol,deadmeat,gabbie,saruman,jeepman,freddie1,katie123,master99,ronal,ballbag,centauri,killer7,xqgann,pinecone,jdeere,geirby,aceshigh,55832811,pepsimax,rayden,razor1,tallyho,ewelina,coldfire,florid,glotest,999333,sevenup,bluefin,limaperu,apostol,bobbins,charmed1,michelin,sundin,centaur,alphaone,christof,trial1,lions1,45645,just4you,starflee,vicki1,cougar1,green2,jellyfis,batman69,games1,hihje863,crazyzil,w0rm1,oklick,dogbite,yssup,sunstar,paprika,postov10,124578963,x24ik3,kanada,buckster,iloveamy,bear123,smiler,nx74205,ohiostat,spacey,bigbill,doudo,nikolaeva,hcleeb,sex666,mindy1,buster11,deacons,boness,njkcnsq,candy2,cracker1,turkey1,qwertyu1,gogreen,tazzzz,edgewise,ranger01,qwerty6,blazer1,arian,letmeinnow,cigar1,jjjjjj1,grigio,frien,tenchu,f9lmwd,imissyou,filipp,heathers,coolie,salem1,woodduck,scubadiv,123kat,raffaele,nikolaev,dapzu455,skooter,9inches,lthgfhjkm,gr8one,ffffff1,zujlrf,amanda69,gldmeo,m5wkqf,rfrltkf,televisi,bonjou,paleale,stuff1,cumalot,fuckmenow,climb7,mark1234,t26gn4,oneeye,george2,utyyflbq,hunting1,tracy71,ready2go,hotguy,accessno,charger1,rudedog,kmfdm,goober1,sweetie1,wtpmjgda,dimensio,ollie1,pickles1,hellraiser,mustdie,123zzz,99887766,stepanov,verdun,tokenbad,anatol,bartende,cidkid86,onkelz,timmie,mooseman,patch1,12345678c,marta1,dummy1,bethany1,myfamily,history1,178500,lsutiger,phydeaux,moren,dbrnjhjdbx,gnbxrf,uniden,drummers,abpbrf,godboy,daisy123,hogan1,ratpack,irland,tangerine,greddy,flore,sqrunch,billyjoe,q55555,clemson1,98745632,marios,ishot,angelin,access12,naruto12,lolly,scxakv,austin12,sallad,cool99,rockit,mongo1,mark22,ghbynth,ariadna,senha,docto,tyler2,mobius,hammarby,192168,anna12,claire1,pxx3eftp,secreto,greeneye,stjabn,baguvix,satana666,rhbcnbyjxrf,dallastx,garfiel,michaelj,1summer,montan,1234ab,filbert,squids,fastback,lyudmila,chucho,eagleone,kimberle,ar3yuk3,jake01,nokids,soccer22,1066ad,ballon,cheeto,review69,madeira,taylor2,sunny123,chubbs,lakeland,striker1,porche,qwertyu8,digiview,go1234,ferari,lovetits,aditya,minnow,green3,matman,cellphon,fortytwo,minni,pucara,69a20a,roman123,fuente,12e3e456,paul12,jacky,demian,littleman,jadakiss,vlad1997,franca,282860,midian,nunzio,xaccess2,colibri,jessica0,revilo,654456,harvey1,wolf1,macarena,corey1,husky1,arsen,milleniu,852147,crowes,redcat,combat123654,hugger,psalms,quixtar,ilovemom,toyot,ballss,ilovekim,serdar,james23,avenger1,serendip,malamute,nalgas,teflon,shagger,letmein6,vyjujnjxbt,assa1234,student1,dixiedog,gznybwf13,fuckass,aq1sw2de3,robroy,hosehead,sosa21,123345,ias100,teddy123,poppin,dgl70460,zanoza,farhan,quicksilver,1701d,tajmahal,depechemode,paulchen,angler,tommy2,recoil,megamanx,scarecro,nicole2,152535,rfvtgb,skunky,fatty1,saturno,wormwood,milwauke,udbwsk,sexlover,stefa,7bgiqk,gfnhbr,omar10,bratan,lbyfvj,slyfox,forest1,jambo,william3,tempus,solitari,lucydog,murzilka,qweasdzxc1,vehpbkrf,12312345,fixit,woobie,andre123,123456789x,lifter,zinaida,soccer17,andone,foxbat,torsten,apple12,teleport,123456i,leglover,bigcocks,vologda,dodger1,martyn,d6o8pm,naciona,eagleeye,maria6,rimshot,bentley1,octagon,barbos,masaki,gremio,siemen,s1107d,mujeres,bigtits1,cherr,saints1,mrpink,simran,ghzybr,ferrari2,secret12,tornado1,kocham,picolo,deneme,onelove1,rolan,fenster,1fuckyou,cabbie,pegaso,nastyboy,password5,aidana,mine2306,mike13,wetone,tigger69,ytreza,bondage1,myass,golova,tolik,happyboy,poilkj,nimda2k,rammer,rubies,hardcore1,jetset,hoops1,jlaudio,misskitt,1charlie,google12,theone1,phred,porsch,aalborg,luft4,charlie5,password7,gnosis,djgabbab,1daniel,vinny,borris,cumulus,member1,trogdor,darthmau,andrew2,ktjybl,relisys,kriste,rasta220,chgobndg,weener,qwerty66,fritter,followme,freeman1,ballen,blood1,peache,mariso,trevor1,biotch,gtfullam,chamonix,friendste,alligato,misha1,1soccer,18821221,venkat,superd,molotov,bongos,mpower,acun3t1x,dfcmrf,h4x3d,rfhfufylf,tigran,booyaa,plastic1,monstr,rfnhby,lookatme,anabolic,tiesto,simon123,soulman,canes1,skyking,tomcat1,madona,bassline,dasha123,tarheel1,dutch1,xsw23edc,qwerty123456789,imperator,slaveboy,bateau,paypal,house123,pentax,wolf666,drgonzo,perros,digger1,juninho,hellomoto,bladerun,zzzzzzz1,keebler,take8422,fffffff1,ginuwine,israe,caesar1,crack1,precious1,garand,magda1,zigazaga,321ewq,johnpaul,mama1234,iceman69,sanjeev,treeman,elric,rebell,1thunder,cochon,deamon,zoltan,straycat,uhbyuj,luvfur,mugsy,primer,wonder1,teetime,candycan,pfchfytw,fromage,gitler,salvatio,piggy1,23049307,zafira,chicky,sergeev,katze,bangers,andriy,jailbait,vaz2107,ghbhjlf,dbjktnnf,aqswde,zaratustra,asroma,1pepper,alyss,kkkkk1,ryan1,radish,cozumel,waterpol,pentium1,rosebowl,farmall,steinway,dbrekz,baranov,jkmuf,another1,chinacat,qqqqqqq1,hadrian,devilmaycry4,ratbag,teddy2,love21,pullings,packrat,robyn1,boobo,qw12er34,tribe1,rosey,celestia,nikkie,fortune12,olga123,danthema,gameon,vfrfhjys,dilshod,henry14,jenova,redblue,chimaera,pennywise,sokrates,danimal,qqaazz,fuaqz4,killer2,198200,tbone1,kolyan,wabbit,lewis1,maxtor,egoist,asdfas,spyglass,omegas,jack12,nikitka,esperanz,doozer,matematika,wwwww1,ssssss1,poiu0987,suchka,courtney1,gungho,alpha2,fktyjxrf,summer06,bud420,devildriver,heavyd,saracen,foucault,choclate,rjdfktyrj,goblue1,monaro,jmoney,dcpugh,efbcapa201,qqh92r,pepsicol,bbb747,ch5nmk,honeyb,beszoptad,tweeter,intheass,iseedeadpeople,123dan,89231243658s,farside1,findme,smiley1,55556666,sartre,ytcnjh,kacper,costarica,134679258,mikeys,nolimit9,vova123,withyou,5rxypn,love143,freebie,rescue1,203040,michael6,12monkey,redgreen,steff,itstime,naveen,good12345,acidrain,1dawg,miramar,playas,daddio,orion2,852741,studmuff,kobe24,senha123,stephe,mehmet,allalone,scarface1,helloworld,smith123,blueyes,vitali,memphis1,mybitch,colin1,159874,1dick,podaria,d6wnro,brahms,f3gh65,dfcbkmtd,xxxman,corran,ugejvp,qcfmtz,marusia,totem,arachnid,matrix2,antonell,fgntrf,zemfira,christos,surfing1,naruto123,plato1,56qhxs,madzia,vanille,043aaa,asq321,mutton,ohiostate,golde,cdznjckfd,rhfcysq,green5,elephan,superdog,jacqueli,bollock,lolitas,nick12,1orange,maplelea,july23,argento,waldorf,wolfer,pokemon12,zxcvbnmm,flicka,drexel,outlawz,harrie,atrain,juice2,falcons1,charlie6,19391945,tower1,dragon21,hotdamn,dirtyboy,love4ever,1ginger,thunder2,virgo1,alien1,bubblegu,4wwvte,123456789qqq,realtime,studio54,passss,vasilek,awsome,giorgia,bigbass,2002tii,sunghile,mosdef,simbas,count0,uwrl7c,summer05,lhepmz,ranger21,sugarbea,principe,5550123,tatanka,9638v,cheerios,majere,nomercy,jamesbond007,bh90210,7550055,jobber,karaganda,pongo,trickle,defamer,6chid8,1q2a3z,tuscan,nick123,.adgjm,loveyo,hobbes1,note1234,shootme,171819,loveporn,9788960,monty123,fabrice,macduff,monkey13,shadowfa,tweeker,hanna1,madball,telnet,loveu2,qwedcxzas,thatsit,vfhcbr,ptfe3xxp,gblfhfcs,ddddddd1,hakkinen,liverune,deathsta,misty123,suka123,recon1,inferno1,232629,polecat,sanibel,grouch,hitech,hamradio,rkfdbfnehf,vandam,nadin,fastlane,shlong,iddqdidkfa,ledzeppelin,sexyfeet,098123,stacey1,negras,roofing,lucifer1,ikarus,tgbyhn,melnik,barbaria,montego,twisted1,bigal1,jiggle,darkwolf,acerview,silvio,treetops,bishop1,iwanna,pornsite,happyme,gfccdjhl,114411,veritech,batterse,casey123,yhntgb,mailto,milli,guster,q12345678,coronet,sleuth,fuckmeha,armadill,kroshka,geordie,lastochka,pynchon,killall,tommy123,sasha1996,godslove,hikaru,clticic,cornbrea,vfkmdbyf,passmaster,123123123a,souris,nailer,diabolo,skipjack,martin12,hinata,mof6681,brookie,dogfight,johnso,karpov,326598,rfvbrflpt,travesti,caballer,galaxy1,wotan,antoha,art123,xakep1234,ricflair,pervert1,p00kie,ambulanc,santosh,berserker,larry33,bitch123,a987654321,dogstar,angel22,cjcbcrf,redhouse,toodles,gold123,hotspot,kennedy1,glock21,chosen1,schneide,mainman,taffy1,3ki42x,4zqauf,ranger2,4meonly,year2000,121212a,kfylsi,netzwerk,diese,picasso1,rerecz,225522,dastan,swimmer1,brooke1,blackbea,oneway,ruslana,dont4get,phidelt,chrisp,gjyxbr,xwing,kickme,shimmy,kimmy1,4815162342lost,qwerty5,fcporto,jazzbo,mierd,252627,basses,sr20det,00133,florin,howdy1,kryten,goshen,koufax,cichlid,imhotep,andyman,wrest666,saveme,dutchy,anonymou,semprini,siempre,mocha1,forest11,wildroid,aspen1,sesam,kfgekz,cbhbec,a55555,sigmanu,slash1,giggs11,vatech,marias,candy123,jericho1,kingme,123a123,drakula,cdjkjxm,mercur,oneman,hoseman,plumper,ilovehim,lancers,sergey1,takeshi,goodtogo,cranberr,ghjcnj123,harvick,qazxs,1972chev,horsesho,freedom3,letmein7,saitek,anguss,vfvfgfgfz,300000,elektro,toonporn,999111999q,mamuka,q9umoz,edelweis,subwoofer,bayside,disturbe,volition,lucky3,12345678z,3mpz4r,march1,atlantida,strekoza,seagrams,090909t,yy5rbfsc,jack1234,sammy12,sampras,mark12,eintrach,chaucer,lllll1,nochance,whitepower,197000,lbvekz,passer,torana,12345as,pallas,koolio,12qw34,nokia8800,findout,1thomas,mmmmm1,654987,mihaela,chinaman,superduper,donnas,ringo1,jeroen,gfdkjdf,professo,cdtnrf,tranmere,tanstaaf,himera,ukflbfnjh,667788,alex32,joschi,w123456,okidoki,flatline,papercli,super8,doris1,2good4u,4z34l0ts,pedigree,freeride,gsxr1100,wulfgar,benjie,ferdinan,king1,charlie7,djdxbr,fhntvbq,ripcurl,2wsx1qaz,kingsx,desade,sn00py,loveboat,rottie,evgesha,4money,dolittle,adgjmpt,buzzers,brett1,makita,123123qweqwe,rusalka,sluts1,123456e,jameson1,bigbaby,1z2z3z,ckjybr,love4u,fucker69,erhfbyf,jeanluc,farhad,fishfood,merkin,giant1,golf69,rfnfcnhjaf,camera1,stromb,smoothy,774411,nylon,juice1,rfn.irf,newyor,123456789t,marmot,star11,jennyff,jester1,hisashi,kumquat,alex777,helicopt,merkur,dehpye,cummin,zsmj2v,kristjan,april12,englan,honeypot,badgirls,uzumaki,keines,p12345,guita,quake1,duncan1,juicer,milkbone,hurtme,123456789b,qq123456789,schwein,p3wqaw,54132442,qwertyytrewq,andreeva,ruffryde,punkie,abfkrf,kristinka,anna1987,ooooo1,335533aa,umberto,amber123,456123789,456789123,beelch,manta,peeker,1112131415,3141592654,gipper,wrinkle5,katies,asd123456,james11,78n3s5af,michael0,daboss,jimmyb,hotdog1,david69,852123,blazed,sickan,eljefe,2n6wvq,gobills,rfhfcm,squeaker,cabowabo,luebri,karups,test01,melkor,angel777,smallvil,modano,olorin,4rkpkt,leslie1,koffie,shadows1,littleon,amiga1,topeka,summer20,asterix1,pitstop,aloysius,k12345,magazin,joker69,panocha,pass1word,1233214,ironpony,368ejhih,88keys,pizza123,sonali,57np39,quake2,1234567890qw,1020304,sword1,fynjif,abcde123,dfktyjr,rockys,grendel1,harley12,kokakola,super2,azathoth,lisa123,shelley1,girlss,ibragim,seven1,jeff24,1bigdick,dragan,autobot,t4nvp7,omega123,900000,hecnfv,889988,nitro1,doggie1,fatjoe,811pahc,tommyt,savage1,pallino,smitty1,jg3h4hfn,jamielee,1qazwsx,zx123456,machine1,asdfgh123,guinnes,789520,sharkman,jochen,legend1,sonic2,extreme1,dima12,photoman,123459876,nokian95,775533,vaz2109,april10,becks,repmvf,pooker,qwer12345,themaster,nabeel,monkey10,gogetit,hockey99,bbbbbbb1,zinedine,dolphin2,anelka,1superma,winter01,muggsy,horny2,669966,kuleshov,jesusis,calavera,bullet1,87t5hdf,sleepers,winkie,vespa,lightsab,carine,magister,1spider,shitbird,salavat,becca1,wc18c2,shirak,galactus,zaskar,barkley1,reshma,dogbreat,fullsail,asasa,boeder,12345ta,zxcvbnm12,lepton,elfquest,tony123,vkaxcs,savatage,sevilia1,badkitty,munkey,pebbles1,diciembr,qapmoc,gabriel2,1qa2ws3e,cbcmrb,welldone,nfyufh,kaizen,jack11,manisha,grommit,g12345,maverik,chessman,heythere,mixail,jjjjjjj1,sylvia1,fairmont,harve,skully,global1,youwish,pikachu1,badcat,zombie1,49527843,ultra1,redrider,offsprin,lovebird,153426,stymie,aq1sw2,sorrento,0000001,r3ady41t,webster1,95175,adam123,coonass,159487,slut1,gerasim,monkey99,slutwife,159963,1pass1page,hobiecat,bigtymer,all4you,maggie2,olamide,comcast1,infinit,bailee,vasileva,.ktxrf,asdfghjkl1,12345678912,setter,fuckyou7,nnagqx,lifesuck,draken,austi,feb2000,cable1,1234qwerasdf,hax0red,zxcv12,vlad7788,nosaj,lenovo,underpar,huskies1,lovegirl,feynman,suerte,babaloo,alskdjfhg,oldsmobi,bomber1,redrover,pupuce,methodman,phenom,cutegirl,countyli,gretsch,godisgood,bysunsu,hardhat,mironova,123qwe456rty,rusty123,salut,187211,555666777,11111z,mahesh,rjntyjxtr,br00klyn,dunce1,timebomb,bovine,makelove,littlee,shaven,rizwan,patrick7,42042042,bobbijo,rustem,buttmunc,dongle,tiger69,bluecat,blackhol,shirin,peaces,cherub,cubase,longwood,lotus7,gwju3g,bruin,pzaiu8,green11,uyxnyd,seventee,dragon5,tinkerbel,bluess,bomba,fedorova,joshua2,bodyshop,peluche,gbpacker,shelly1,d1i2m3a4,ghtpbltyn,talons,sergeevna,misato,chrisc,sexmeup,brend,olddog,davros,hazelnut,bridget1,hzze929b,readme,brethart,wild1,ghbdtnbr1,nortel,kinger,royal1,bucky1,allah1,drakkar,emyeuanh,gallaghe,hardtime,jocker,tanman,flavio,abcdef123,leviatha,squid1,skeet,sexse,123456x,mom4u4mm,lilred,djljktq,ocean11,cadaver,baxter1,808state,fighton,primavera,1andrew,moogle,limabean,goddess1,vitalya,blue56,258025,bullride,cicci,1234567d,connor1,gsxr11,oliveoil,leonard1,legsex,gavrik,rjnjgtc,mexicano,2bad4u,goodfellas,ornw6d,mancheste,hawkmoon,zlzfrh,schorsch,g9zns4,bashful,rossi46,stephie,rfhfntkm,sellout,123fuck,stewar1,solnze,00007,thor5200,compaq12,didit,bigdeal,hjlbyf,zebulon,wpf8eu,kamran,emanuele,197500,carvin,ozlq6qwm,3syqo15hil,pennys,epvjb6,asdfghjkl123,198000,nfbcbz,jazzer,asfnhg66,zoloft,albundy,aeiou,getlaid,planet1,gjkbyjxrf,alex2000,brianb,moveon,maggie11,eieio,vcradq,shaggy1,novartis,cocoloco,dunamis,554uzpad,sundrop,1qwertyu,alfie,feliks,briand,123www,red456,addams,fhntv1998,goodhead,theway,javaman,angel01,stratoca,lonsdale,15987532,bigpimpin,skater1,issue43,muffie,yasmina,slowride,crm114,sanity729,himmel,carolcox,bustanut,parabola,masterlo,computador,crackhea,dynastar,rockbott,doggysty,wantsome,bigten,gaelle,juicy1,alaska1,etower,sixnine,suntan,froggies,nokia7610,hunter11,njnets,alicante,buttons1,diosesamo,elizabeth1,chiron,trustnoo,amatuers,tinytim,mechta,sammy2,cthulu,trs8f7,poonam,m6cjy69u35,cookie12,blue25,jordans,santa1,kalinka,mikey123,lebedeva,12345689,kissss,queenbee,vjybnjh,ghostdog,cuckold,bearshare,rjcntyrj,alinochka,ghjcnjrdfibyj,aggie1,teens1,3qvqod,dauren,tonino,hpk2qc,iqzzt580,bears85,nascar88,theboy,njqcw4,masyanya,pn5jvw,intranet,lollone,shadow99,00096462,techie,cvtifhbrb,redeemed,gocanes,62717315,topman,intj3a,cobrajet,antivirus,whyme,berserke,ikilz083,airedale,brandon2,hopkig,johanna1,danil8098,gojira,arthu,vision1,pendragon,milen,chrissie,vampiro,mudder,chris22,blowme69,omega7,surfers,goterps,italy1,baseba11,diego1,gnatsum,birdies,semenov,joker123,zenit2011,wojtek,cab4ma99,watchmen,damia,forgotte,fdm7ed,strummer,freelanc,cingular,orange77,mcdonalds,vjhjpjdf,kariya,tombston,starlet,hawaii1,dantheman,megabyte,nbvjirf,anjing,ybrjkftdbx,hotmom,kazbek,pacific1,sashimi,asd12,coorslig,yvtte545,kitte,elysium,klimenko,cobblers,kamehameha,only4me,redriver,triforce,sidorov,vittoria,fredi,dank420,m1234567,fallout2,989244342a,crazy123,crapola,servus,volvos,1scooter,griffin1,autopass,ownzyou,deviant,george01,2kgwai,boeing74,simhrq,hermosa,hardcor,griffy,rolex1,hackme,cuddles1,master3,bujhtr,aaron123,popolo,blader,1sexyred,gerry1,cronos,ffvdj474,yeehaw,bob1234,carlos2,mike77,buckwheat,ramesh,acls2h,monster2,montess,11qq22ww,lazer,zx123456789,chimpy,masterch,sargon,lochness,archana,1234qwert,hbxfhl,sarahb,altoid,zxcvbn12,dakot,caterham,dolomite,chazz,r29hqq,longone,pericles,grand1,sherbert,eagle3,pudge,irontree,synapse,boome,nogood,summer2,pooki,gangsta1,mahalkit,elenka,lbhtrnjh,dukedog,19922991,hopkins1,evgenia,domino1,x123456,manny1,tabbycat,drake1,jerico,drahcir,kelly2,708090a,facesit,11c645df,mac123,boodog,kalani,hiphop1,critters,hellothere,tbirds,valerka,551scasi,love777,paloalto,mrbrown,duke3d,killa1,arcturus,spider12,dizzy1,smudger,goddog,75395,spammy,1357997531,78678,datalife,zxcvbn123,1122112211,london22,23dp4x,rxmtkp,biggirls,ownsu,lzbs2twz,sharps,geryfe,237081a,golakers,nemesi,sasha1995,pretty1,mittens1,d1lakiss,speedrac,gfhjkmm,sabbat,hellrais,159753258,qwertyuiop123,playgirl,crippler,salma,strat1,celest,hello5,omega5,cheese12,ndeyl5,edward12,soccer3,cheerio,davido,vfrcbr,gjhjctyjr,boscoe,inessa,shithole,ibill,qwepoi,201jedlz,asdlkj,davidk,spawn2,ariel1,michael4,jamie123,romantik,micro1,pittsbur,canibus,katja,muhtar,thomas123,studboy,masahiro,rebrov,patrick8,hotboys,sarge1,1hammer,nnnnn1,eistee,datalore,jackdani,sasha2010,mwq6qlzo,cmfnpu,klausi,cnhjbntkm,andrzej,ilovejen,lindaa,hunter123,vvvvv1,novembe,hamster1,x35v8l,lacey1,1silver,iluvporn,valter,herson,alexsandr,cojones,backhoe,womens,777angel,beatit,klingon1,ta8g4w,luisito,benedikt,maxwel,inspecto,zaq12ws,wladimir,bobbyd,peterj,asdfg12,hellspawn,bitch69,nick1234,golfer23,sony123,jello1,killie,chubby1,kodaira52,yanochka,buckfast,morris1,roaddogg,snakeeye,sex1234,mike22,mmouse,fucker11,dantist,brittan,vfrfhjdf,doc123,plokijuh,emerald1,batman01,serafim,elementa,soccer9,footlong,cthuttdbx,hapkido,eagle123,getsmart,getiton,batman2,masons,mastiff,098890,cfvfhf,james7,azalea,sherif,saun24865709,123red,cnhtrjpf,martina1,pupper,michael5,alan12,shakir,devin1,ha8fyp,palom,mamulya,trippy,deerhunter,happyone,monkey77,3mta3,123456789f,crownvic,teodor,natusik,0137485,vovchik,strutter,triumph1,cvetok,moremone,sonnen,screwbal,akira1,sexnow,pernille,independ,poopies,samapi,kbcbxrf,master22,swetlana,urchin,viper2,magica,slurpee,postit,gilgames,kissarmy,clubpenguin,limpbizk,timber1,celin,lilkim,fuckhard,lonely1,mom123,goodwood,extasy,sdsadee23,foxglove,malibog,clark1,casey2,shell1,odense,balefire,dcunited,cubbie,pierr,solei,161718,bowling1,areyukesc,batboy,r123456,1pionee,marmelad,maynard1,cn42qj,cfvehfq,heathrow,qazxcvbn,connecti,secret123,newfie,xzsawq21,tubitzen,nikusha,enigma1,yfcnz123,1austin,michaelc,splunge,wanger,phantom2,jason2,pain4me,primetime21,babes1,liberte,sugarray,undergro,zonker,labatts,djhjyf,watch1,eagle5,madison2,cntgfirf,sasha2,masterca,fiction7,slick50,bruins1,sagitari,12481632,peniss,insuranc,2b8riedt,12346789,mrclean,ssptx452,tissot,q1w2e3r4t5y6u7,avatar1,comet1,spacer,vbrjkf,pass11,wanker1,14vbqk9p,noshit,money4me,sayana,fish1234,seaways,pipper,romeo123,karens,wardog,ab123456,gorilla1,andrey123,lifesucks,jamesr,4wcqjn,bearman,glock22,matt11,dflbvrf,barbi,maine1,dima1997,sunnyboy,6bjvpe,bangkok1,666666q,rafiki,letmein0,0raziel0,dalla,london99,wildthin,patrycja,skydog,qcactw,tmjxn151,yqlgr667,jimmyd,stripclub,deadwood,863abgsg,horses1,qn632o,scatman,sonia1,subrosa,woland,kolya,charlie4,moleman,j12345,summer11,angel11,blasen,sandal,mynewpas,retlaw,cambria,mustang4,nohack04,kimber45,fatdog,maiden1,bigload,necron,dupont24,ghost123,turbo2,.ktymrf,radagast,balzac,vsevolod,pankaj,argentum,2bigtits,mamabear,bumblebee,mercury7,maddie1,chomper,jq24nc,snooky,pussylic,1lovers,taltos,warchild,diablo66,jojo12,sumerki,aventura,gagger,annelies,drumset,cumshots,azimut,123580,clambake,bmw540,birthday54,psswrd,paganini,wildwest,filibert,teaseme,1test,scampi,thunder5,antosha,purple12,supersex,hhhhhh1,brujah,111222333a,13579a,bvgthfnjh,4506802a,killians,choco,qqqwwweee,raygun,1grand,koetsu13,sharp1,mimi92139,fastfood,idontcare,bluered,chochoz,4z3al0ts,target1,sheffiel,labrat,stalingrad,147123,cubfan,corvett1,holden1,snapper1,4071505,amadeo,pollo,desperados,lovestory,marcopolo,mumbles,familyguy,kimchee,marcio,support1,tekila,shygirl1,trekkie,submissi,ilaria,salam,loveu,wildstar,master69,sales1,netware,homer2,arseniy,gerrity1,raspberr,atreyu,stick1,aldric,tennis12,matahari,alohomora,dicanio,michae1,michaeld,666111,luvbug,boyscout,esmerald,mjordan,admiral1,steamboa,616913,ybhdfyf,557711,555999,sunray,apokalipsis,theroc,bmw330,buzzy,chicos,lenusik,shadowma,eagles05,444222,peartree,qqq123,sandmann,spring1,430799,phatass,andi03,binky1,arsch,bamba,kenny123,fabolous,loser123,poop12,maman,phobos,tecate,myxworld4,metros,cocorico,nokia6120,johnny69,hater,spanked,313233,markos,love2011,mozart1,viktoriy,reccos,331234,hornyone,vitesse,1um83z,55555q,proline,v12345,skaven,alizee,bimini,fenerbahce,543216,zaqqaz,poi123,stabilo,brownie1,1qwerty1,dinesh,baggins1,1234567t,davidkin,friend1,lietuva,octopuss,spooks,12345qq,myshit,buttface,paradoxx,pop123,golfin,sweet69,rfghbp,sambuca,kayak1,bogus1,girlz,dallas12,millers,123456zx,operatio,pravda,eternal1,chase123,moroni,proust,blueduck,harris1,redbarch,996699,1010101,mouche,millenni,1123456,score1,1234565,1234576,eae21157,dave12,pussyy,gfif1991,1598741,hoppy,darrian,snoogins,fartface,ichbins,vfkbyrf,rusrap,2741001,fyfrjylf,aprils,favre,thisis,bannana,serval,wiggum,satsuma,matt123,ivan123,gulmira,123zxc123,oscar2,acces,annie2,dragon0,emiliano,allthat,pajaro,amandine,rawiswar,sinead,tassie,karma1,piggys,nokias,orions,origami,type40,mondo,ferrets,monker,biteme2,gauntlet,arkham,ascona,ingram01,klem1,quicksil,bingo123,blue66,plazma,onfire,shortie,spjfet,123963,thered,fire777,lobito,vball,1chicken,moosehea,elefante,babe23,jesus12,parallax,elfstone,number5,shrooms,freya,hacker1,roxette,snoops,number7,fellini,dtlmvf,chigger,mission1,mitsubis,kannan,whitedog,james01,ghjgecr,rfnfgekmnf,everythi,getnaked,prettybo,sylvan,chiller,carrera4,cowbo,biochem,azbuka,qwertyuiop1,midnight1,informat,audio1,alfred1,0range,sucker1,scott2,russland,1eagle,torben,djkrjlfd,rocky6,maddy1,bonobo,portos,chrissi,xjznq5,dexte,vdlxuc,teardrop,pktmxr,iamtheone,danijela,eyphed,suzuki1,etvww4,redtail,ranger11,mowerman,asshole2,coolkid,adriana1,bootcamp,longcut,evets,npyxr5,bighurt,bassman1,stryder,giblet,nastja,blackadd,topflite,wizar,cumnow,technolo,bassboat,bullitt,kugm7b,maksimus,wankers,mine12,sunfish,pimpin1,shearer9,user1,vjzgjxnf,tycobb,80070633pc,stanly,vitaly,shirley1,cinzia,carolyn1,angeliqu,teamo,qdarcv,aa123321,ragdoll,bonit,ladyluck,wiggly,vitara,jetbalance,12345600,ozzman,dima12345,mybuddy,shilo,satan66,erebus,warrio,090808qwe,stupi,bigdan,paul1234,chiapet,brooks1,philly1,dually,gowest,farmer1,1qa2ws3ed4rf,alberto1,beachboy,barne,aa12345,aliyah,radman,benson1,dfkthbq,highball,bonou2,i81u812,workit,darter,redhook,csfbr5yy,buttlove,episode1,ewyuza,porthos,lalal,abcd12,papero,toosexy,keeper1,silver7,jujitsu,corset,pilot123,simonsay,pinggolf,katerinka,kender,drunk1,fylhjvtlf,rashmi,nighthawk,maggy,juggernaut,larryb,cabibble,fyabcf,247365,gangstar,jaybee,verycool,123456789qw,forbidde,prufrock,12345zxc,malaika,blackbur,docker,filipe,koshechka,gemma1,djamaal,dfcbkmtdf,gangst,9988aa,ducks1,pthrfkj,puertorico,muppets,griffins,whippet,sauber,timofey,larinso,123456789zxc,quicken,qsefth,liteon,headcase,bigdadd,zxc321,maniak,jamesc,bassmast,bigdogs,1girls,123xxx,trajan,lerochka,noggin,mtndew,04975756,domin,wer123,fumanchu,lambada,thankgod,june22,kayaking,patchy,summer10,timepass,poiu1234,kondor,kakka,lament,zidane10,686xqxfg,l8v53x,caveman1,nfvthkfy,holymoly,pepita,alex1996,mifune,fighter1,asslicker,jack22,abc123abc,zaxxon,midnigh,winni,psalm23,punky,monkey22,password13,mymusic,justyna,annushka,lucky5,briann,495rus19,withlove,almaz,supergir,miata,bingbong,bradpitt,kamasutr,yfgjktjy,vanman,pegleg,amsterdam1,123a321,letmein9,shivan,korona,bmw520,annette1,scotsman,gandal,welcome12,sc00by,qpwoei,fred69,m1sf1t,hamburg1,1access,dfkmrbhbz,excalibe,boobies1,fuckhole,karamel,starfuck,star99,breakfas,georgiy,ywvxpz,smasher,fatcat1,allanon,12345n,coondog,whacko,avalon1,scythe,saab93,timon,khorne,atlast,nemisis,brady12,blenheim,52678677,mick7278,9skw5g,fleetwoo,ruger1,kissass,pussy7,scruff,12345l,bigfun,vpmfsz,yxkck878,evgeny,55667788,lickher,foothill,alesis,poppies,77777778,californi,mannie,bartjek,qhxbij,thehulk,xirt2k,angelo4ek,rfkmrekznjh,tinhorse,1david,sparky12,night1,luojianhua,bobble,nederland,rosemari,travi,minou,ciscokid,beehive,565hlgqo,alpine1,samsung123,trainman,xpress,logistic,vw198m2n,hanter,zaqwsx123,qwasz,mariachi,paska,kmg365,kaulitz,sasha12,north1,polarbear,mighty1,makeksa11,123456781,one4all,gladston,notoriou,polniypizdec110211,gosia,grandad,xholes,timofei,invalidp,speaker1,zaharov,maggiema,loislane,gonoles,br5499,discgolf,kaskad,snooper,newman1,belial,demigod,vicky1,pridurok,alex1990,tardis1,cruzer,hornie,sacramen,babycat,burunduk,mark69,oakland1,me1234,gmctruck,extacy,sexdog,putang,poppen,billyd,1qaz2w,loveable,gimlet,azwebitalia,ragtop,198500,qweas,mirela,rock123,11bravo,sprewell,tigrenok,jaredleto,vfhbif,blue2,rimjob,catwalk,sigsauer,loqse,doromich,jack01,lasombra,jonny5,newpassword,profesor,garcia1,123as123,croucher,demeter,4_life,rfhfvtkm,superman2,rogues,assword1,russia1,jeff1,mydream,z123456789,rascal1,darre,kimberl,pickle1,ztmfcq,ponchik,lovesporn,hikari,gsgba368,pornoman,chbjun,choppy,diggity,nightwolf,viktori,camar,vfhecmrf,alisa1,minstrel,wishmaster,mulder1,aleks,gogirl,gracelan,8womys,highwind,solstice,dbrnjhjdyf,nightman,pimmel,beertje,ms6nud,wwfwcw,fx3tuo,poopface,asshat,dirtyd,jiminy,luv2fuck,ptybnxtvgbjy,dragnet,pornogra,10inch,scarlet1,guido1,raintree,v123456,1aaaaaaa,maxim1935,hotwater,gadzooks,playaz,harri,brando1,defcon1,ivanna,123654a,arsenal2,candela,nt5d27,jaime1,duke1,burton1,allstar1,dragos,newpoint,albacore,1236987z,verygoodbot,1wildcat,fishy1,ptktysq,chris11,puschel,itdxtyrj,7kbe9d,serpico,jazzie,1zzzzz,kindbuds,wenef45313,1compute,tatung,sardor,gfyfcjybr,test99,toucan,meteora,lysander,asscrack,jowgnx,hevnm4,suckthis,masha123,karinka,marit,oqglh565,dragon00,vvvbbb,cheburashka,vfrfrf,downlow,unforgiven,p3e85tr,kim123,sillyboy,gold1,golfvr6,quicksan,irochka,froglegs,shortsto,caleb1,tishka,bigtitts,smurfy,bosto,dropzone,nocode,jazzbass,digdug,green7,saltlake,therat,dmitriev,lunita,deaddog,summer0,1212qq,bobbyg,mty3rh,isaac1,gusher,helloman,sugarbear,corvair,extrem,teatime,tujazopi,titanik,efyreg,jo9k2jw2,counchac,tivoli,utjvtnhbz,bebit,jacob6,clayton1,incubus1,flash123,squirter,dima2010,cock1,rawks,komatsu,forty2,98741236,cajun1,madelein,mudhoney,magomed,q111111,qaswed,consense,12345b,bakayaro,silencer,zoinks,bigdic,werwolf,pinkpuss,96321478,alfie1,ali123,sarit,minette,musics,chato,iaapptfcor,cobaka,strumpf,datnigga,sonic123,yfnecbr,vjzctvmz,pasta1,tribbles,crasher,htlbcrf,1tiger,shock123,bearshar,syphon,a654321,cubbies1,jlhanes,eyespy,fucktheworld,carrie1,bmw325is,suzuk,mander,dorina,mithril,hondo1,vfhnbyb,sachem,newton1,12345x,7777755102q,230857z,xxxsex,scubapro,hayastan,spankit,delasoul,searock6,fallout3,nilrem,24681357,pashka,voluntee,pharoh,willo,india1,badboy69,roflmao,gunslinger,lovergir,mama12,melange,640xwfkv,chaton,darkknig,bigman1,aabbccdd,harleyd,birdhouse,giggsy,hiawatha,tiberium,joker7,hello1234,sloopy,tm371855,greendog,solar1,bignose,djohn11,espanol,oswego,iridium,kavitha,pavell,mirjam,cyjdsvujljv,alpha5,deluge,hamme,luntik,turismo,stasya,kjkbnf,caeser,schnecke,tweety1,tralfaz,lambrett,prodigy1,trstno1,pimpshit,werty1,karman,bigboob,pastel,blackmen,matthew8,moomin,q1w2e,gilly,primaver,jimmyg,house2,elviss,15975321,1jessica,monaliza,salt55,vfylfhbyrf,harley11,tickleme,murder1,nurgle,kickass1,theresa1,fordtruck,pargolf,managua,inkognito,sherry1,gotit,friedric,metro2033,slk230,freeport,cigarett,492529,vfhctkm,thebeach,twocats,bakugan,yzerman1,charlieb,motoko,skiman,1234567w,pussy3,love77,asenna,buffie,260zntpc,kinkos,access20,mallard1,fuckyou69,monami,rrrrr1,bigdog69,mikola,1boomer,godzila,ginger2,dima2000,skorpion39,dima1234,hawkdog79,warrior2,ltleirf,supra1,jerusale,monkey01,333z333,666888,kelsey1,w8gkz2x1,fdfnfh,msnxbi,qwe123rty,mach1,monkey3,123456789qq,c123456,nezabudka,barclays,nisse,dasha1,12345678987654321,dima1993,oldspice,frank2,rabbitt,prettyboy,ov3ajy,iamthema,kawasak,banjo1,gtivr6,collants,gondor,hibees,cowboys2,codfish,buster2,purzel,rubyred,kayaker,bikerboy,qguvyt,masher,sseexx,kenshiro,moonglow,semenova,rosari,eduard1,deltaforce,grouper,bongo1,tempgod,1taylor,goldsink,qazxsw1,1jesus,m69fg2w,maximili,marysia,husker1,kokanee,sideout,googl,south1,plumber1,trillian,00001,1357900,farkle,1xxxxx,pascha,emanuela,bagheera,hound1,mylov,newjersey,swampfox,sakic19,torey,geforce,wu4etd,conrail,pigman,martin2,ber02,nascar2,angel69,barty,kitsune,cornet,yes90125,goomba,daking,anthea,sivart,weather1,ndaswf,scoubidou,masterchief,rectum,3364068,oranges1,copter,1samanth,eddies,mimoza,ahfywbz,celtic88,86mets,applemac,amanda11,taliesin,1angel,imhere,london11,bandit12,killer666,beer1,06225930,psylocke,james69,schumach,24pnz6kc,endymion,wookie1,poiu123,birdland,smoochie,lastone,rclaki,olive1,pirat,thunder7,chris69,rocko,151617,djg4bb4b,lapper,ajcuivd289,colole57,shadow7,dallas21,ajtdmw,executiv,dickies,omegaman,jason12,newhaven,aaaaaas,pmdmscts,s456123789,beatri,applesauce,levelone,strapon,benladen,creaven,ttttt1,saab95,f123456,pitbul,54321a,sex12345,robert3,atilla,mevefalkcakk,1johnny,veedub,lilleke,nitsuj,5t6y7u8i,teddys,bluefox,nascar20,vwjetta,buffy123,playstation3,loverr,qweasd12,lover2,telekom,benjamin1,alemania,neutrino,rockz,valjean,testicle,trinity3,realty,firestarter,794613852,ardvark,guadalup,philmont,arnold1,holas,zw6syj,birthday299,dover1,sexxy1,gojets,741236985,cance,blue77,xzibit,qwerty88,komarova,qweszxc,footer,rainger,silverst,ghjcnb,catmando,tatooine,31217221027711,amalgam,69dude,qwerty321,roscoe1,74185,cubby,alfa147,perry1,darock,katmandu,darknight,knicks1,freestuff,45454,kidman,4tlved,axlrose,cutie1,quantum1,joseph10,ichigo,pentium3,rfhectkm,rowdy1,woodsink,justforfun,sveta123,pornografia,mrbean,bigpig,tujheirf,delta9,portsmou,hotbod,kartal,10111213,fkbyf001,pavel1,pistons1,necromancer,verga,c7lrwu,doober,thegame1,hatesyou,sexisfun,1melissa,tuczno18,bowhunte,gobama,scorch,campeon,bruce2,fudge1,herpderp,bacon1,redsky,blackeye,19966991,19992000,ripken8,masturba,34524815,primax,paulina1,vp6y38,427cobra,4dwvjj,dracon,fkg7h4f3v6,longview,arakis,panama1,honda2,lkjhgfdsaz,razors,steels,fqkw5m,dionysus,mariajos,soroka,enriqu,nissa,barolo,king1234,hshfd4n279,holland1,flyer1,tbones,343104ky,modems,tk421,ybrbnrf,pikapp,sureshot,wooddoor,florida2,mrbungle,vecmrf,catsdogs,axolotl,nowayout,francoi,chris21,toenail,hartland,asdjkl,nikkii,onlyyou,buckskin,fnord,flutie,holen1,rincewind,lefty1,ducky1,199000,fvthbrf,redskin1,ryno23,lostlove,19mtpgam19,abercrom,benhur,jordan11,roflcopter,ranma,phillesh,avondale,igromania,p4ssword,jenny123,tttttt1,spycams,cardigan,2112yyz,sleepy1,paris123,mopars,lakers34,hustler1,james99,matrix3,popimp,12pack,eggbert,medvedev,testit,performa,logitec,marija,sexybeast,supermanboy,iwantit,rjktcj,jeffer,svarog,halo123,whdbtp,nokia3230,heyjoe,marilyn1,speeder,ibxnsm,prostock,bennyboy,charmin,codydog,parol999,ford9402,jimmer,crayola,159357258,alex77,joey1,cayuga,phish420,poligon,specops,tarasova,caramelo,draconis,dimon,cyzkhw,june29,getbent,1guitar,jimjam,dictiona,shammy,flotsam,0okm9ijn,crapper,technic,fwsadn,rhfdxtyrj,zaq11qaz,anfield1,159753q,curious1,hip-hop,1iiiii,gfhjkm2,cocteau,liveevil,friskie,crackhead,b1afra,elektrik,lancer1,b0ll0cks,jasond,z1234567,tempest1,alakazam,asdfasd,duffy1,oneday,dinkle,qazedctgb,kasimir,happy7,salama,hondaciv,nadezda,andretti,cannondale,sparticu,znbvjd,blueice,money01,finster,eldar,moosie,pappa,delta123,neruda,bmw330ci,jeanpaul,malibu1,alevtina,sobeit,travolta,fullmetal,enamorad,mausi,boston12,greggy,smurf1,ratrace,ichiban,ilovepus,davidg,wolf69,villa1,cocopuff,football12,starfury,zxc12345,forfree,fairfiel,dreams1,tayson,mike2,dogday,hej123,oldtimer,sanpedro,clicker,mollycat,roadstar,golfe,lvbnhbq1,topdevice,a1b2c,sevastopol,calli,milosc,fire911,pink123,team3x,nolimit5,snickers1,annies,09877890,jewel1,steve69,justin11,autechre,killerbe,browncow,slava1,christer,fantomen,redcloud,elenberg,beautiful1,passw0rd1,nazira,advantag,cockring,chaka,rjpzdrf,99941,az123456,biohazar,energie,bubble1,bmw323,tellme,printer1,glavine,1starwar,coolbeans,april17,carly1,quagmire,admin2,djkujuhfl,pontoon,texmex,carlos12,thermo,vaz2106,nougat,bob666,1hockey,1john,cricke,qwerty10,twinz,totalwar,underwoo,tijger,lildevil,123q321,germania,freddd,1scott,beefy,5t4r3e2w1q,fishbait,nobby,hogger,dnstuff,jimmyc,redknapp,flame1,tinfloor,balla,nfnfhby,yukon1,vixens,batata,danny123,1zxcvbnm,gaetan,homewood,greats,tester1,green99,1fucker,sc0tland,starss,glori,arnhem,goatman,1234asd,supertra,bill123,elguapo,sexylegs,jackryan,usmc69,innow,roaddog,alukard,winter11,crawler,gogiants,rvd420,alessandr,homegrow,gobbler,esteba,valeriy,happy12,1joshua,hawking,sicnarf,waynes,iamhappy,bayadera,august2,sashas,gotti,dragonfire,pencil1,halogen,borisov,bassingw,15975346,zachar,sweetp,soccer99,sky123,flipyou,spots3,xakepy,cyclops1,dragon77,rattolo58,motorhea,piligrim,helloween,dmb2010,supermen,shad0w,eatcum,sandokan,pinga,ufkfrnbrf,roksana,amista,pusser,sony1234,azerty1,1qasw2,ghbdt,q1w2e3r4t5y6u7i8,ktutylf,brehznev,zaebali,shitass,creosote,gjrtvjy,14938685,naughtyboy,pedro123,21crack,maurice1,joesakic,nicolas1,matthew9,lbyfhf,elocin,hfcgbplzq,pepper123,tiktak,mycroft,ryan11,firefly1,arriva,cyecvevhbr,loreal,peedee,jessica8,lisa01,anamari,pionex,ipanema,airbag,frfltvbz,123456789aa,epwr49,casper12,sweethear,sanandreas,wuschel,cocodog,france1,119911,redroses,erevan,xtvgbjy,bigfella,geneve,volvo850,evermore,amy123,moxie,celebs,geeman,underwor,haslo1,joy123,hallow,chelsea0,12435687,abarth,12332145,tazman1,roshan,yummie,genius1,chrisd,ilovelife,seventy7,qaz1wsx2,rocket88,gaurav,bobbyboy,tauchen,roberts1,locksmit,masterof,www111,d9ungl,volvos40,asdasd1,golfers,jillian1,7xm5rq,arwpls4u,gbhcf2,elloco,football2,muerte,bob101,sabbath1,strider1,killer66,notyou,lawnboy,de7mdf,johnnyb,voodoo2,sashaa,homedepo,bravos,nihao123,braindea,weedhead,rajeev,artem1,camille1,rockss,bobbyb,aniston,frnhbcf,oakridge,biscayne,cxfcnm,dressage,jesus3,kellyann,king69,juillet,holliste,h00ters,ripoff,123645,1999ar,eric12,123777,tommi,dick12,bilder,chris99,rulezz,getpaid,chicubs,ender1,byajhvfnbrf,milkshak,sk8board,freakshow,antonella,monolit,shelb,hannah01,masters1,pitbull1,1matthew,luvpussy,agbdlcid,panther2,alphas,euskadi,8318131,ronnie1,7558795,sweetgirl,cookie59,sequoia,5552555,ktyxbr,4500455,money7,severus,shinobu,dbityrf,phisig,rogue2,fractal,redfred,sebastian1,nelli,b00mer,cyberman,zqjphsyf6ctifgu,oldsmobile,redeemer,pimpi,lovehurts,1slayer,black13,rtynfdh,airmax,g00gle,1panther,artemon,nopasswo,fuck1234,luke1,trinit,666000,ziadma,oscardog,davex,hazel1,isgood,demond,james5,construc,555551,january2,m1911a1,flameboy,merda,nathan12,nicklaus,dukester,hello99,scorpio7,leviathan,dfcbktr,pourquoi,vfrcbv123,shlomo,rfcgth,rocky3,ignatz,ajhneyf,roger123,squeek,4815162342a,biskit,mossimo,soccer21,gridlock,lunker,popstar,ghhh47hj764,chutney,nitehawk,vortec,gamma1,codeman,dragula,kappasig,rainbow2,milehigh,blueballs,ou8124me,rulesyou,collingw,mystere,aster,astrovan,firetruck,fische,crawfish,hornydog,morebeer,tigerpaw,radost,144000,1chance,1234567890qwe,gracie1,myopia,oxnard,seminoles,evgeni,edvard,partytim,domani,tuffy1,jaimatadi,blackmag,kzueirf,peternor,mathew1,maggie12,henrys,k1234567,fasted,pozitiv,cfdtkbq,jessica7,goleafs,bandito,girl78,sharingan,skyhigh,bigrob,zorros,poopers,oldschoo,pentium2,gripper,norcal,kimba,artiller,moneymak,00197400,272829,shadow1212,thebull,handbags,all4u2c,bigman2,civics,godisgoo,section8,bandaid,suzanne1,zorba,159123,racecars,i62gbq,rambo123,ironroad,johnson2,knobby,twinboys,sausage1,kelly69,enter2,rhjirf,yessss,james12,anguilla,boutit,iggypop,vovochka,06060,budwiser,romuald,meditate,good1,sandrin,herkules,lakers8,honeybea,11111111a,miche,rangers9,lobster1,seiko,belova,midcon,mackdadd,bigdaddy1,daddie,sepultur,freddy12,damon1,stormy1,hockey2,bailey12,hedimaptfcor,dcowboys,sadiedog,thuggin,horny123,josie1,nikki2,beaver69,peewee1,mateus,viktorija,barrys,cubswin1,matt1234,timoxa,rileydog,sicilia,luckycat,candybar,julian1,abc456,pussylip,phase1,acadia,catty,246800,evertonf,bojangle,qzwxec,nikolaj,fabrizi,kagome,noncapa0,marle,popol,hahaha1,cossie,carla10,diggers,spankey,sangeeta,cucciolo,breezer,starwar1,cornholio,rastafari,spring99,yyyyyyy1,webstar,72d5tn,sasha1234,inhouse,gobuffs,civic1,redstone,234523,minnie1,rivaldo,angel5,sti2000,xenocide,11qq11,1phoenix,herman1,holly123,tallguy,sharks1,madri,superbad,ronin,jalal123,hardbody,1234567r,assman1,vivahate,buddylee,38972091,bonds25,40028922,qrhmis,wp2005,ceejay,pepper01,51842543,redrum1,renton,varadero,tvxtjk7r,vetteman,djhvbrc,curly1,fruitcak,jessicas,maduro,popmart,acuari,dirkpitt,buick1,bergerac,golfcart,pdtpljxrf,hooch1,dudelove,d9ebk7,123452000,afdjhbn,greener,123455432,parachut,mookie12,123456780,jeepcj5,potatoe,sanya,qwerty2010,waqw3p,gotika,freaky1,chihuahu,buccanee,ecstacy,crazyboy,slickric,blue88,fktdnbyf,2004rj,delta4,333222111,calient,ptbdhw,1bailey,blitz1,sheila1,master23,hoagie,pyf8ah,orbita,daveyboy,prono1,delta2,heman,1horny,tyrik123,ostrov,md2020,herve,rockfish,el546218,rfhbyjxrf,chessmaster,redmoon,lenny1,215487,tomat,guppy,amekpass,amoeba,my3girls,nottingh,kavita,natalia1,puccini,fabiana,8letters,romeos,netgear,casper2,taters,gowings,iforgot1,pokesmot,pollit,lawrun,petey1,rosebuds,007jr,gthtcnhjqrf,k9dls02a,neener,azertyu,duke11,manyak,tiger01,petros,supermar,mangas,twisty,spotter,takagi,dlanod,qcmfd454,tusymo,zz123456,chach,navyblue,gilbert1,2kash6zq,avemaria,1hxboqg2s,viviane,lhbjkjubz2957704,nowwowtg,1a2b3c4,m0rn3,kqigb7,superpuper,juehtw,gethigh,theclown,makeme,pradeep,sergik,deion21,nurik,devo2706,nbvibt,roman222,kalima,nevaeh,martin7,anathema,florian1,tamwsn3sja,dinmamma,133159,123654q,slicks,pnp0c08,yojimbo,skipp,kiran,pussyfuck,teengirl,apples12,myballs,angeli,1234a,125678,opelastra,blind1,armagedd,fish123,pitufo,chelseaf,thedevil,nugget1,cunt69,beetle1,carter15,apolon,collant,password00,fishboy,djkrjdf,deftone,celti,three11,cyrus1,lefthand,skoal1,ferndale,aries1,fred01,roberta1,chucks,cornbread,lloyd1,icecrea,cisco123,newjerse,vfhrbpf,passio,volcom1,rikimaru,yeah11,djembe,facile,a1l2e3x4,batman7,nurbol,lorenzo1,monica69,blowjob1,998899,spank1,233391,n123456,1bear,bellsout,999998,celtic67,sabre1,putas,y9enkj,alfabeta,heatwave,honey123,hard4u,insane1,xthysq,magnum1,lightsaber,123qweqwe,fisher1,pixie1,precios,benfic,thegirls,bootsman,4321rewq,nabokov,hightime,djghjc,1chelsea,junglist,august16,t3fkvkmj,1232123,lsdlsd12,chuckie1,pescado,granit,toogood,cathouse,natedawg,bmw530,123kid,hajime,198400,engine1,wessonnn,kingdom1,novembre,1rocks,kingfisher,qwerty89,jordan22,zasranec,megat,sucess,installutil,fetish01,yanshi1982,1313666,1314520,clemence,wargod,time1,newzealand,snaker,13324124,cfrehf,hepcat,mazahaka,bigjay,denisov,eastwest,1yellow,mistydog,cheetos,1596357,ginger11,mavrik,bubby1,bhbyf,pyramide,giusepp,luthien,honda250,andrewjackie,kentavr,lampoon,zaq123wsx,sonicx,davidh,1ccccc,gorodok,windsong,programm,blunt420,vlad1995,zxcvfdsa,tarasov,mrskin,sachas,mercedes1,koteczek,rawdog,honeybear,stuart1,kaktys,richard7,55555n,azalia,hockey10,scouter,francy,1xxxxxx,julie456,tequilla,penis123,schmoe,tigerwoods,1ferrari,popov,snowdrop,matthieu,smolensk,cornflak,jordan01,love2000,23wesdxc,kswiss,anna2000,geniusnet,baby2000,33ds5x,waverly,onlyone4,networkingpe,raven123,blesse,gocards,wow123,pjflkork,juicey,poorboy,freeee,billybo,shaheen,zxcvbnm.,berlit,truth1,gepard,ludovic,gunther1,bobby2,bob12345,sunmoon,septembr,bigmac1,bcnjhbz,seaking,all4u,12qw34er56ty,bassie,nokia5228,7355608,sylwia,charvel,billgate,davion,chablis,catsmeow,kjiflrf,amylynn,rfvbkkf,mizredhe,handjob,jasper12,erbol,solara,bagpipe,biffer,notime,erlan,8543852,sugaree,oshkosh,fedora,bangbus,5lyedn,longball,teresa1,bootyman,aleksand,qazwsxedc12,nujbhc,tifosi,zpxvwy,lights1,slowpoke,tiger12,kstate,password10,alex69,collins1,9632147,doglover,baseball2,security1,grunts,orange2,godloves,213qwe879,julieb,1qazxsw23edcvfr4,noidea,8uiazp,betsy1,junior2,parol123,123456zz,piehonkii,kanker,bunky,hingis,reese1,qaz123456,sidewinder,tonedup,footsie,blackpoo,jalapeno,mummy1,always1,josh1,rockyboy,plucky,chicag,nadroj,blarney,blood123,wheaties,packer1,ravens1,mrjones,gfhjkm007,anna2010,awatar,guitar12,hashish,scale1,tomwaits,amrita,fantasma,rfpfym,pass2,tigris,bigair,slicker,sylvi,shilpa,cindylou,archie1,bitches1,poppys,ontime,horney1,camaroz28,alladin,bujhm,cq2kph,alina1,wvj5np,1211123a,tetons,scorelan,concordi,morgan2,awacs,shanty,tomcat14,andrew123,bear69,vitae,fred99,chingy,octane,belgario,fatdaddy,rhodan,password23,sexxes,boomtown,joshua01,war3demo,my2kids,buck1,hot4you,monamour,12345aa,yumiko,parool,carlton1,neverland,rose12,right1,sociald,grouse,brandon0,cat222,alex00,civicex,bintang,malkav,arschloc,dodgeviper,qwerty666,goduke,dante123,boss1,ontheroc,corpsman,love14,uiegu451,hardtail,irondoor,ghjrehfnehf,36460341,konijn,h2slca,kondom25,123456ss,cfytxrf,btnjey,nando,freemail,comander,natas666,siouxsie,hummer1,biomed,dimsum,yankees0,diablo666,lesbian1,pot420,jasonm,glock23,jennyb,itsmine,lena2010,whattheh,beandip,abaddon,kishore,signup,apogee,biteme12,suzieq,vgfun4,iseeyou,rifleman,qwerta,4pussy,hawkman,guest1,june17,dicksuck,bootay,cash12,bassale,ktybyuhfl,leetch,nescafe,7ovtgimc,clapton1,auror,boonie,tracker1,john69,bellas,cabinboy,yonkers,silky1,ladyffesta,drache,kamil1,davidp,bad123,snoopy12,sanche,werthvfy,achille,nefertiti,gerald1,slage33,warszawa,macsan26,mason123,kotopes,welcome8,nascar99,kiril,77778888,hairy1,monito,comicsans,81726354,killabee,arclight,yuo67,feelme,86753099,nnssnn,monday12,88351132,88889999,websters,subito,asdf12345,vaz2108,zvbxrpl,159753456852,rezeda,multimed,noaccess,henrique,tascam,captiva,zadrot,hateyou,sophie12,123123456,snoop1,charlie8,birmingh,hardline,libert,azsxdcf,89172735872,rjpthju,bondar,philips1,olegnaruto,myword,yakman,stardog,banana12,1234567890w,farout,annick,duke01,rfj422,billard,glock19,shaolin1,master10,cinderel,deltaone,manning1,biggreen,sidney1,patty1,goforit1,766rglqy,sevendus,aristotl,armagedo,blumen,gfhfyjz,kazakov,lekbyxxx,accord1,idiota,soccer16,texas123,victoire,ololo,chris01,bobbbb,299792458,eeeeeee1,confiden,07070,clarks,techno1,kayley,stang1,wwwwww1,uuuuu1,neverdie,jasonr,cavscout,481516234,mylove1,shaitan,1qazxcvb,barbaros,123456782000,123wer,thissucks,7seven,227722,faerie,hayduke,dbacks,snorkel,zmxncbv,tiger99,unknown1,melmac,polo1234,sssssss1,1fire,369147,bandung,bluejean,nivram,stanle,ctcnhf,soccer20,blingbli,dirtball,alex2112,183461,skylin,boobman,geronto,brittany1,yyz2112,gizmo69,ktrcec,dakota12,chiken,sexy11,vg08k714,bernadet,1bulldog,beachs,hollyb,maryjoy,margo1,danielle1,chakra,alexand,hullcity,matrix12,sarenna,pablos,antler,supercar,chomsky,german1,airjordan,545ettvy,camaron,flight1,netvideo,tootall,valheru,481516,1234as,skimmer,redcross,inuyash,uthvfy,1012nw,edoardo,bjhgfi,golf11,9379992a,lagarto,socball,boopie,krazy,.adgjmptw,gaydar,kovalev,geddylee,firstone,turbodog,loveee,135711,badbo,trapdoor,opopop11,danny2,max2000,526452,kerry1,leapfrog,daisy2,134kzbip,1andrea,playa1,peekab00,heskey,pirrello,gsewfmck,dimon4ik,puppie,chelios,554433,hypnodanny,fantik,yhwnqc,ghbdtngjrf,anchorag,buffett1,fanta,sappho,024680,vialli,chiva,lucylu,hashem,exbntkm,thema,23jordan,jake11,wildside,smartie,emerica,2wj2k9oj,ventrue,timoth,lamers,baerchen,suspende,boobis,denman85,1adam12,otello,king12,dzakuni,qsawbbs,isgay,porno123,jam123,daytona1,tazzie,bunny123,amaterasu,jeffre,crocus,mastercard,bitchedup,chicago7,aynrand,intel1,tamila,alianza,mulch,merlin12,rose123,alcapone,mircea,loveher,joseph12,chelsea6,dorothy1,wolfgar,unlimite,arturik,qwerty3,paddy1,piramid,linda123,cooool,millie1,warlock1,forgotit,tort02,ilikeyou,avensis,loveislife,dumbass1,clint1,2110se,drlove,olesia,kalinina,sergey123,123423,alicia1,markova,tri5a3,media1,willia1,xxxxxxx1,beercan,smk7366,jesusislord,motherfuck,smacker,birthday5,jbaby,harley2,hyper1,a9387670a,honey2,corvet,gjmptw,rjhjkmbien,apollon,madhuri,3a5irt,cessna17,saluki,digweed,tamia1,yja3vo,cfvlehfr,1111111q,martyna,stimpy1,anjana,yankeemp,jupiler,idkfa,1blue,fromv,afric,3xbobobo,liverp00l,nikon1,amadeus1,acer123,napoleo,david7,vbhjckfdf,mojo69,percy1,pirates1,grunt1,alenushka,finbar,zsxdcf,mandy123,1fred,timewarp,747bbb,druids,julia123,123321qq,spacebar,dreads,fcbarcelona,angela12,anima,christopher1,stargazer,123123s,hockey11,brewski,marlbor,blinker,motorhead,damngood,werthrf,letmein3,moremoney,killer99,anneke,eatit,pilatus,andrew01,fiona1,maitai,blucher,zxgdqn,e5pftu,nagual,panic1,andron,openwide,alphabeta,alison1,chelsea8,fende,mmm666,1shot2,a19l1980,123456@,1black,m1chael,vagner,realgood,maxxx,vekmnbr,stifler,2509mmh,tarkan,sherzod,1234567b,gunners1,artem2010,shooby,sammie1,p123456,piggie,abcde12345,nokia6230,moldir,piter,1qaz3edc,frequenc,acuransx,1star,nikeair,alex21,dapimp,ranjan,ilovegirls,anastasiy,berbatov,manso,21436587,leafs1,106666,angelochek,ingodwetrust,123456aaa,deano,korsar,pipetka,thunder9,minka,himura,installdevic,1qqqqq,digitalprodu,suckmeoff,plonker,headers,vlasov,ktr1996,windsor1,mishanya,garfield1,korvin,littlebit,azaz09,vandamme,scripto,s4114d,passward,britt1,r1chard,ferrari5,running1,7xswzaq,falcon2,pepper76,trademan,ea53g5,graham1,volvos80,reanimator,micasa,1234554321q,kairat,escorpion,sanek94,karolina1,kolovrat,karen2,1qaz@wsx,racing1,splooge,sarah2,deadman1,creed1,nooner,minicoop,oceane,room112,charme,12345ab,summer00,wetcunt,drewman,nastyman,redfire,appels,merlin69,dolfin,bornfree,diskette,ohwell,12345678qwe,jasont,madcap,cobra2,dolemit1,whatthehell,juanit,voldemar,rocke,bianc,elendil,vtufgjkbc,hotwheels,spanis,sukram,pokerface,k1ller,freakout,dontae,realmadri,drumss,gorams,258789,snakey,jasonn,whitewolf,befree,johnny99,pooka,theghost,kennys,vfvektxrf,toby1,jumpman23,deadlock,barbwire,stellina,alexa1,dalamar,mustanggt,northwes,tesoro,chameleo,sigtau,satoshi,george11,hotcum,cornell1,golfer12,geek01d,trololo,kellym,megapolis,pepsi2,hea666,monkfish,blue52,sarajane,bowler1,skeets,ddgirls,hfccbz,bailey01,isabella1,dreday,moose123,baobab,crushme,000009,veryhot,roadie,meanone,mike18,henriett,dohcvtec,moulin,gulnur,adastra,angel9,western1,natura,sweetpe,dtnfkm,marsbar,daisys,frogger1,virus1,redwood1,streetball,fridolin,d78unhxq,midas,michelob,cantik,sk2000,kikker,macanudo,rambone,fizzle,20000,peanuts1,cowpie,stone32,astaroth,dakota01,redso,mustard1,sexylove,giantess,teaparty,bobbin,beerbong,monet1,charles3,anniedog,anna1988,cameleon,longbeach,tamere,qpful542,mesquite,waldemar,12345zx,iamhere,lowboy,canard,granp,daisymay,love33,moosejaw,nivek,ninjaman,shrike01,aaa777,88002000600,vodolei,bambush,falcor,harley69,alphaomega,severine,grappler,bosox,twogirls,gatorman,vettes,buttmunch,chyna,excelsio,crayfish,birillo,megumi,lsia9dnb9y,littlebo,stevek,hiroyuki,firehous,master5,briley2,gangste,chrisk,camaleon,bulle,troyboy,froinlaven,mybutt,sandhya,rapala,jagged,crazycat,lucky12,jetman,wavmanuk,1heather,beegee,negril,mario123,funtime1,conehead,abigai,mhorgan,patagoni,travel1,backspace,frenchfr,mudcat,dashenka,baseball3,rustys,741852kk,dickme,baller23,griffey1,suckmycock,fuhrfzgc,jenny2,spuds,berlin1,justfun,icewind,bumerang,pavlusha,minecraft123,shasta1,ranger12,123400,twisters,buthead,miked,finance1,dignity7,hello9,lvjdp383,jgthfnjh,dalmatio,paparoach,miller31,2bornot2b,fathe,monterre,theblues,satans,schaap,jasmine2,sibelius,manon,heslo,jcnhjd,shane123,natasha2,pierrot,bluecar,iloveass,harriso,red12,london20,job314,beholder,reddawg,fuckyou!,pussylick,bologna1,austintx,ole4ka,blotto,onering,jearly,balbes,lightbul,bighorn,crossfir,lee123,prapor,1ashley,gfhjkm22,wwe123,09090,sexsite,marina123,jagua,witch1,schmoo,parkview,dragon3,chilango,ultimo,abramova,nautique,2bornot2,duende,1arthur,nightwing,surfboar,quant4307,15s9pu03,karina1,shitball,walleye1,wildman1,whytesha,1morgan,my2girls,polic,baranova,berezuckiy,kkkkkk1,forzima,fornow,qwerty02,gokart,suckit69,davidlee,whatnow,edgard,tits1,bayshore,36987412,ghbphfr,daddyy,explore1,zoidberg,5qnzjx,morgane,danilov,blacksex,mickey12,balsam,83y6pv,sarahc,slaye,all4u2,slayer69,nadia1,rlzwp503,4cranker,kaylie,numberon,teremok,wolf12,deeppurple,goodbeer,aaa555,66669999,whatif,harmony1,ue8fpw,3tmnej,254xtpss,dusty197,wcksdypk,zerkalo,dfnheirf,motorol,digita,whoareyou,darksoul,manics,rounders,killer11,d2000lb,cegthgfhjkm,catdog1,beograd,pepsico,julius1,123654987,softbal,killer23,weasel1,lifeson,q123456q,444555666,bunches,andy1,darby1,service01,bear11,jordan123,amega,duncan21,yensid,lerxst,rassvet,bronco2,fortis,pornlove,paiste,198900,asdflkjh,1236547890,futur,eugene1,winnipeg261,fk8bhydb,seanjohn,brimston,matthe1,bitchedu,crisco,302731,roxydog,woodlawn,volgograd,ace1210,boy4u2ownnyc,laura123,pronger,parker12,z123456z,andrew13,longlife,sarang,drogba,gobruins,soccer4,holida,espace,almira,murmansk,green22,safina,wm00022,1chevy,schlumpf,doroth,ulises,golf99,hellyes,detlef,mydog,erkina,bastardo,mashenka,sucram,wehttam,generic1,195000,spaceboy,lopas123,scammer,skynyrd,daddy2,titani,ficker,cr250r,kbnthfnehf,takedown,sticky1,davidruiz,desant,nremtp,painter1,bogies,agamemno,kansas1,smallfry,archi,2b4dnvsx,1player,saddie,peapod,6458zn7a,qvw6n2,gfxqx686,twice2,sh4d0w3d,mayfly,375125,phitau,yqmbevgk,89211375759,kumar1,pfhfpf,toyboy,way2go,7pvn4t,pass69,chipster,spoony,buddycat,diamond3,rincewin,hobie,david01,billbo,hxp4life,matild,pokemon2,dimochka,clown1,148888,jenmt3,cuxldv,cqnwhy,cde34rfv,simone1,verynice,toobig,pasha123,mike00,maria2,lolpop,firewire,dragon9,martesana,a1234567890,birthday3,providen,kiska,pitbulls,556655,misawa,damned69,martin11,goldorak,gunship,glory1,winxclub,sixgun,splodge,agent1,splitter,dome69,ifghjb,eliza1,snaiper,wutang36,phoenix7,666425,arshavin,paulaner,namron,m69fg1w,qwert1234,terrys,zesyrmvu,joeman,scoots,dwml9f,625vrobg,sally123,gostoso,symow8,pelota,c43qpul5rz,majinbuu,lithium1,bigstuff,horndog1,kipelov,kringle,1beavis,loshara,octobe,jmzacf,12342000,qw12qw,runescape1,chargers1,krokus,piknik,jessy,778811,gjvbljh,474jdvff,pleaser,misskitty,breaker1,7f4df451,dayan,twinky,yakumo,chippers,matia,tanith,len2ski1,manni,nichol1,f00b4r,nokia3110,standart,123456789i,shami,steffie,larrywn,chucker,john99,chamois,jjjkkk,penmouse,ktnj2010,gooners,hemmelig,rodney1,merlin01,bearcat1,1yyyyy,159753z,1fffff,1ddddd,thomas11,gjkbyrf,ivanka,f1f2f3,petrovna,phunky,conair,brian2,creative1,klipsch,vbitymrf,freek,breitlin,cecili,westwing,gohabsgo,tippmann,1steve,quattro6,fatbob,sp00ky,rastas,1123581,redsea,rfnmrf,jerky1,1aaaaaa,spk666,simba123,qwert54321,123abcd,beavis69,fyfyfc,starr1,1236547,peanutbutter,sintra,12345abcde,1357246,abcde1,climbon,755dfx,mermaids,monte1,serkan,geilesau,777win,jasonc,parkside,imagine1,rockhead,producti,playhard,principa,spammer,gagher,escada,tsv1860,dbyjuhfl,cruiser1,kennyg,montgome,2481632,pompano,cum123,angel6,sooty,bear01,april6,bodyhamm,pugsly,getrich,mikes,pelusa,fosgate,jasonp,rostislav,kimberly1,128mo,dallas11,gooner1,manuel1,cocacola1,imesh,5782790,password8,daboys,1jones,intheend,e3w2q1,whisper1,madone,pjcgujrat,1p2o3i,jamesp,felicida,nemrac,phikap,firecat,jrcfyjxrf,matt12,bigfan,doedel,005500,jasonx,1234567k,badfish,goosey,utjuhfabz,wilco,artem123,igor123,spike123,jor23dan,dga9la,v2jmsz,morgan12,avery1,dogstyle,natasa,221195ws,twopac,oktober7,karthik,poop1,mightymo,davidr,zermatt,jehova,aezakmi1,dimwit,monkey5,serega123,qwerty111,blabl,casey22,boy123,1clutch,asdfjkl1,hariom,bruce10,jeep95,1smith,sm9934,karishma,bazzzz,aristo,669e53e1,nesterov,kill666,fihdfv,1abc2,anna1,silver11,mojoman,telefono,goeagles,sd3lpgdr,rfhfynby,melinda1,llcoolj,idteul,bigchief,rocky13,timberwo,ballers,gatekeep,kashif,hardass,anastasija,max777,vfuyjkbz,riesling,agent99,kappas,dalglish,tincan,orange3,turtoise,abkbvjy,mike24,hugedick,alabala,geolog,aziza,devilboy,habanero,waheguru,funboy,freedom5,natwest,seashore,impaler,qwaszx1,pastas,bmw535,tecktonik,mika00,jobsearc,pinche,puntang,aw96b6,1corvett,skorpio,foundati,zzr1100,gembird,vfnhjcrby,soccer18,vaz2110,peterp,archer1,cross1,samedi,dima1992,hunter99,lipper,hotbody,zhjckfdf,ducati1,trailer1,04325956,cheryl1,benetton,kononenko,sloneczko,rfgtkmrf,nashua,balalaika,ampere,eliston,dorsai,digge,flyrod,oxymoron,minolta,ironmike,majortom,karimov,fortun,putaria,an83546921an13,blade123,franchis,mxaigtg5,dynxyu,devlt4,brasi,terces,wqmfuh,nqdgxz,dale88,minchia,seeyou,housepen,1apple,1buddy,mariusz,bighouse,tango2,flimflam,nicola1,qwertyasd,tomek1,shumaher,kartoshka,bassss,canaries,redman1,123456789as,preciosa,allblacks,navidad,tommaso,beaudog,forrest1,green23,ryjgjxrf,go4it,ironman2,badnews,butterba,1grizzly,isaeva,rembrand,toront,1richard,bigjon,yfltymrf,1kitty,4ng62t,littlejo,wolfdog,ctvtyjd,spain1,megryan,tatertot,raven69,4809594q,tapout,stuntman,a131313,lagers,hotstuf,lfdbl11,stanley2,advokat,boloto,7894561,dooker,adxel187,cleodog,4play,0p9o8i,masterb,bimota,charlee,toystory,6820055,6666667,crevette,6031769,corsa,bingoo,dima1990,tennis11,samuri,avocado,melissa6,unicor,habari,metart,needsex,cockman,hernan,3891576,3334444,amigo1,gobuffs2,mike21,allianz,2835493,179355,midgard,joey123,oneluv,ellis1,towncar,shonuff,scouse,tool69,thomas19,chorizo,jblaze,lisa1,dima1999,sophia1,anna1989,vfvekbxrf,krasavica,redlegs,jason25,tbontb,katrine,eumesmo,vfhufhbnrf,1654321,asdfghj1,motdepas,booga,doogle,1453145,byron1,158272,kardinal,tanne,fallen1,abcd12345,ufyljy,n12345,kucing,burberry,bodger,1234578,februar,1234512,nekkid,prober,harrison1,idlewild,rfnz90,foiegras,pussy21,bigstud,denzel,tiffany2,bigwill,1234567890zzz,hello69,compute1,viper9,hellspaw,trythis,gococks,dogballs,delfi,lupine,millenia,newdelhi,charlest,basspro,1mike,joeblack,975310,1rosebud,batman11,misterio,fucknut,charlie0,august11,juancho,ilonka,jigei743ks,adam1234,889900,goonie,alicat,ggggggg1,1zzzzzzz,sexywife,northstar,chris23,888111,containe,trojan1,jason5,graikos,1ggggg,1eeeee,tigers01,indigo1,hotmale,jacob123,mishima,richard3,cjxb2014,coco123,meagain,thaman,wallst,edgewood,bundas,1power,matilda1,maradon,hookedup,jemima,r3vi3wpass,2004-10-,mudman,taz123,xswzaq,emerson1,anna21,warlord1,toering,pelle,tgwdvu,masterb8,wallstre,moppel,priora,ghjcnjrdfif,yoland,12332100,1j9e7f6f,jazzzz,yesman,brianm,42qwerty42,12345698,darkmanx,nirmal,john31,bb123456,neuspeed,billgates,moguls,fj1200,hbhlair,shaun1,ghbdfn,305pwzlr,nbu3cd,susanb,pimpdad,mangust6403,joedog,dawidek,gigante,708090,703751,700007,ikalcr,tbivbn,697769,marvi,iyaayas,karen123,jimmyboy,dozer1,e6z8jh,bigtime1,getdown,kevin12,brookly,zjduc3,nolan1,cobber,yr8wdxcq,liebe,m1garand,blah123,616879,action1,600000,sumitomo,albcaz,asian1,557799,dave69,556699,sasa123,streaker,michel1,karate1,buddy7,daulet,koks888,roadtrip,wapiti,oldguy,illini1,1234qq,mrspock,kwiatek,buterfly,august31,jibxhq,jackin,taxicab,tristram,talisker,446655,444666,chrisa,freespace,vfhbfyyf,chevell,444333,notyours,442244,christian1,seemore,sniper12,marlin1,joker666,multik,devilish,crf450,cdfoli,eastern1,asshead,duhast,voyager2,cyberia,1wizard,cybernet,iloveme1,veterok,karandash,392781,looksee,diddy,diabolic,foofight,missey,herbert1,bmw318i,premier1,zsfmpv,eric1234,dun6sm,fuck11,345543,spudman,lurker,bitem,lizzy1,ironsink,minami,339311,s7fhs127,sterne,332233,plankton,galax,azuywe,changepa,august25,mouse123,sikici,killer69,xswqaz,quovadis,gnomik,033028pw,777777a,barrakuda,spawn666,goodgod,slurp,morbius,yelnats,cujo31,norman1,fastone,earwig,aureli,wordlife,bnfkbz,yasmi,austin123,timberla,missy2,legalize,netcom,liljon,takeit,georgin,987654321z,warbird,vitalina,all4u3,mmmmmm1,bichon,ellobo,wahoos,fcazmj,aksarben,lodoss,satnam,vasili,197800,maarten,sam138989,0u812,ankita,walte,prince12,anvils,bestia,hoschi,198300,univer,jack10,ktyecbr,gr00vy,hokie,wolfman1,fuckwit,geyser,emmanue,ybrjkftd,qwerty33,karat,dblock,avocat,bobbym,womersle,1please,nostra,dayana,billyray,alternat,iloveu1,qwerty69,rammstein1,mystikal,winne,drawde,executor,craxxxs,ghjcnjnf,999888777,welshman,access123,963214785,951753852,babe69,fvcnthlfv,****me,666999666,testing2,199200,nintendo64,oscarr,guido8,zhanna,gumshoe,jbird,159357456,pasca,123452345,satan6,mithrand,fhbirf,aa1111aa,viggen,ficktjuv,radial9,davids1,rainbow7,futuro,hipho,platin,poppy123,rhenjq,fulle,rosit,chicano,scrumpy,lumpy1,seifer,uvmrysez,autumn1,xenon,susie1,7u8i9o0p,gamer1,sirene,muffy1,monkeys1,kalinin,olcrackmaster,hotmove,uconn,gshock,merson,lthtdyz,pizzaboy,peggy1,pistache,pinto1,fishka,ladydi,pandor,baileys,hungwell,redboy,rookie1,amanda01,passwrd,clean1,matty1,tarkus,jabba1,bobster,beer30,solomon1,moneymon,sesamo,fred11,sunnysid,jasmine5,thebears,putamadre,workhard,flashbac,counter1,liefde,magnat,corky1,green6,abramov,lordik,univers,shortys,david3,vip123,gnarly,1234567s,billy2,honkey,deathstar,grimmy,govinda,direktor,12345678s,linus1,shoppin,rekbrjdf,santeria,prett,berty75,mohican,daftpunk,uekmyfhf,chupa,strats,ironbird,giants56,salisbur,koldun,summer04,pondscum,jimmyj,miata1,george3,redshoes,weezie,bartman1,0p9o8i7u,s1lver,dorkus,125478,omega9,sexisgood,mancow,patric1,jetta1,074401,ghjuhtcc,gfhjk,bibble,terry2,123213,medicin,rebel2,hen3ry,4freedom,aldrin,lovesyou,browny,renwod,winnie1,belladon,1house,tyghbn,blessme,rfhfrfnbwf,haylee,deepdive,booya,phantasy,gansta,cock69,4mnveh,gazza1,redapple,structur,anakin1,manolito,steve01,poolman,chloe123,vlad1998,qazwsxe,pushit,random123,ontherocks,o236nq,brain1,dimedrol,agape,rovnogod,1balls,knigh,alliso,love01,wolf01,flintstone,beernuts,tuffguy,isengard,highfive,alex23,casper99,rubina,getreal,chinita,italian1,airsoft,qwerty23,muffdiver,willi1,grace123,orioles1,redbull1,chino1,ziggy123,breadman,estefan,ljcneg,gotoit,logan123,wideglid,mancity1,treess,qwe123456,kazumi,qweasdqwe,oddworld,naveed,protos,towson,a801016,godislov,at_asp,bambam1,soccer5,dark123,67vette,carlos123,hoser1,scouser,wesdxc,pelus,dragon25,pflhjn,abdula,1freedom,policema,tarkin,eduardo1,mackdad,gfhjkm11,lfplhfgthvf,adilet,zzzzxxxx,childre,samarkand,cegthgegth,shama,fresher,silvestr,greaser,allout,plmokn,sexdrive,nintendo1,fantasy7,oleander,fe126fd,crumpet,pingzing,dionis,hipster,yfcnz,requin,calliope,jerome1,housecat,abc123456789,doghot,snake123,augus,brillig,chronic1,gfhjkbot,expediti,noisette,master7,caliban,whitetai,favorite3,lisamari,educatio,ghjhjr,saber1,zcegth,1958proman,vtkrbq,milkdud,imajica,thehip,bailey10,hockey19,dkflbdjcnjr,j123456,bernar,aeiouy,gamlet,deltachi,endzone,conni,bcgfybz,brandi1,auckland2010,7653ajl1,mardigra,testuser,bunko18,camaro67,36936,greenie,454dfmcq,6xe8j2z4,mrgreen,ranger5,headhunt,banshee1,moonunit,zyltrc,hello3,pussyboy,stoopid,tigger11,yellow12,drums1,blue02,kils123,junkman,banyan,jimmyjam,tbbucs,sportster,badass1,joshie,braves10,lajolla,1amanda,antani,78787,antero,19216801,chich,rhett32,sarahm,beloit,sucker69,corkey,nicosnn,rccola,caracol,daffyduc,bunny2,mantas,monkies,hedonist,cacapipi,ashton1,sid123,19899891,patche,greekgod,cbr1000,leader1,19977991,ettore,chongo,113311,picass,cfif123,rhtfnbd,frances1,andy12,minnette,bigboy12,green69,alices,babcia,partyboy,javabean,freehand,qawsed123,xxx111,harold1,passwo,jonny1,kappa1,w2dlww3v5p,1merlin,222999,tomjones,jakeman,franken,markhegarty,john01,carole1,daveman,caseys,apeman,mookey,moon123,claret,titans1,residentevil,campari,curitiba,dovetail,aerostar,jackdaniels,basenji,zaq12w,glencoe,biglove,goober12,ncc170,far7766,monkey21,eclipse9,1234567v,vanechka,aristote,grumble,belgorod,abhishek,neworleans,pazzword,dummie,sashadog,diablo11,mst3000,koala1,maureen1,jake99,isaiah1,funkster,gillian1,ekaterina20,chibears,astra123,4me2no,winte,skippe,necro,windows9,vinograd,demolay,vika2010,quiksilver,19371ayj,dollar1,shecky,qzwxecrv,butterfly1,merrill1,scoreland,1crazy,megastar,mandragora,track1,dedhed,jacob2,newhope,qawsedrftgyh,shack1,samvel,gatita,shyster,clara1,telstar,office1,crickett,truls,nirmala,joselito,chrisl,lesnik,aaaabbbb,austin01,leto2010,bubbie,aaa12345,widder,234432,salinger,mrsmith,qazsedcft,newshoes,skunks,yt1300,bmw316,arbeit,smoove,123321qweewq,123qazwsx,22221111,seesaw,0987654321a,peach1,1029384756q,sereda,gerrard8,shit123,batcave,energy1,peterb,mytruck,peter12,alesya,tomato1,spirou,laputaxx,magoo1,omgkremidia,knight12,norton1,vladislava,shaddy,austin11,jlbyjxrf,kbdthgekm,punheta,fetish69,exploiter,roger2,manstein,gtnhjd,32615948worms,dogbreath,ujkjdjkjvrf,vodka1,ripcord,fatrat,kotek1,tiziana,larrybir,thunder3,nbvfnb,9kyq6fge,remembe,likemike,gavin1,shinigam,yfcnfcmz,13245678,jabbar,vampyr,ane4ka,lollipo,ashwin,scuderia,limpdick,deagle,3247562,vishenka,fdhjhf,alex02,volvov70,mandys,bioshock,caraca,tombraider,matrix69,jeff123,13579135,parazit,black3,noway1,diablos,hitmen,garden1,aminor,decembe,august12,b00ger,006900,452073t,schach,hitman1,mariner1,vbnmrf,paint1,742617000027,bitchboy,pfqxjyjr,5681392,marryher,sinnet,malik1,muffin12,aninha,piolin,lady12,traffic1,cbvjyf,6345789,june21,ivan2010,ryan123,honda99,gunny,coorslight,asd321,hunter69,7224763,sonofgod,dolphins1,1dolphin,pavlenko,woodwind,lovelov,pinkpant,gblfhfcbyf,hotel1,justinbiebe,vinter,jeff1234,mydogs,1pizza,boats1,parrothe,shawshan,brooklyn1,cbrown,1rocky,hemi426,dragon64,redwings1,porsches,ghostly,hubbahub,buttnut,b929ezzh,sorokina,flashg,fritos,b7mguk,metatron,treehous,vorpal,8902792,marcu,free123,labamba,chiefs1,zxc123zxc,keli_14,hotti,1steeler,money4,rakker,foxwoods,free1,ahjkjd,sidorova,snowwhit,neptune1,mrlover,trader1,nudelamb,baloo,power7,deltasig,bills1,trevo,7gorwell,nokia6630,nokia5320,madhatte,1cowboys,manga1,namtab,sanjar,fanny1,birdman1,adv12775,carlo1,dude1998,babyhuey,nicole11,madmike,ubvyfpbz,qawsedr,lifetec,skyhook,stalker123,toolong,robertso,ripazha,zippy123,1111111a,manol,dirtyman,analslut,jason3,dutches,minhasenha,cerise,fenrir,jayjay1,flatbush,franka,bhbyjxrf,26429vadim,lawntrax,198700,fritzy,nikhil,ripper1,harami,truckman,nemvxyheqdd5oqxyxyzi,gkfytnf,bugaboo,cableman,hairpie,xplorer,movado,hotsex69,mordred,ohyeah1,patrick3,frolov,katieh,4311111q,mochaj,presari,bigdo,753951852,freedom4,kapitan,tomas1,135795,sweet123,pokers,shagme,tane4ka,sentinal,ufgyndmv,jonnyb,skate123,123456798,123456788,very1,gerrit,damocles,dollarbi,caroline1,lloyds,pizdets,flatland,92702689,dave13,meoff,ajnjuhfabz,achmed,madison9,744744z,amonte,avrillavigne,elaine1,norma1,asseater,everlong,buddy23,cmgang1,trash1,mitsu,flyman,ulugbek,june27,magistr,fittan,sebora64,dingos,sleipnir,caterpil,cindys,212121qaz,partys,dialer,gjytltkmybr,qweqaz,janvier,rocawear,lostboy,aileron,sweety1,everest1,pornman,boombox,potter1,blackdic,44448888,eric123,112233aa,2502557i,novass,nanotech,yourname,x12345,indian1,15975300,1234567l,carla51,chicago0,coleta,cxzdsaewq,qqwweerr,marwan,deltic,hollys,qwerasd,pon32029,rainmake,nathan0,matveeva,legioner,kevink,riven,tombraid,blitzen,a54321,jackyl,chinese1,shalimar,oleg1995,beaches1,tommylee,eknock,berli,monkey23,badbob,pugwash,likewhoa,jesus2,yujyd360,belmar,shadow22,utfp5e,angelo1,minimax,pooder,cocoa1,moresex,tortue,lesbia,panthe,snoopy2,drumnbass,alway,gmcz71,6jhwmqku,leppard,dinsdale,blair1,boriqua,money111,virtuagirl,267605,rattlesn,1sunshin,monica12,veritas1,newmexic,millertime,turandot,rfvxfnrf,jaydog,kakawka,bowhunter,booboo12,deerpark,erreway,taylorma,rfkbybyf,wooglin,weegee,rexdog,iamhorny,cazzo1,vhou812,bacardi1,dctktyyfz,godpasi,peanut12,bertha1,fuckyoubitch,ghosty,altavista,jertoot,smokeit,ghjcnbvtyz,fhnehxbr,rolsen,qazxcdews,maddmaxx,redrocke,qazokm,spencer2,thekiller,asdf11,123sex,tupac1,p1234567,dbrown,1biteme,tgo4466,316769,sunghi,shakespe,frosty1,gucci1,arcana,bandit01,lyubov,poochy,dartmout,magpies1,sunnyd,mouseman,summer07,chester7,shalini,danbury,pigboy,dave99,deniss,harryb,ashley11,pppppp1,01081988m,balloon1,tkachenko,bucks1,master77,pussyca,tricky1,zzxxccvv,zoulou,doomer,mukesh,iluv69,supermax,todays,thefox,don123,dontask,diplom,piglett,shiney,fahbrf,qaz12wsx,temitope,reggin,project1,buffy2,inside1,lbpfqyth,vanilla1,lovecock,u4slpwra,fylh.irf,123211,7ertu3ds,necroman,chalky,artist1,simpso,4x7wjr,chaos666,lazyacres,harley99,ch33s3,marusa,eagle7,dilligas,computadora,lucky69,denwer,nissan350z,unforgiv,oddball,schalke0,aztec1,borisova,branden1,parkave,marie123,germa,lafayett,878kckxy,405060,cheeseca,bigwave,fred22,andreea,poulet,mercutio,psycholo,andrew88,o4izdmxu,sanctuar,newhome,milion,suckmydi,rjvgm.nth,warior,goodgame,1qwertyuiop,6339cndh,scorpio2,macker,southbay,crabcake,toadie,paperclip,fatkid,maddo,cliff1,rastafar,maries,twins1,geujdrf,anjela,wc4fun,dolina,mpetroff,rollout,zydeco,shadow3,pumpki,steeda,volvo240,terras,blowjo,blue2000,incognit,badmojo,gambit1,zhukov,station1,aaronb,graci,duke123,clipper1,qazxsw2,ledzeppe,kukareku,sexkitte,cinco,007008,lakers12,a1234b,acmilan1,afhfjy,starrr,slutty3,phoneman,kostyan,bonzo1,sintesi07,ersatz,cloud1,nephilim,nascar03,rey619,kairos,123456789e,hardon1,boeing1,juliya,hfccdtn,vgfun8,polizei,456838,keithb,minouche,ariston,savag,213141,clarkken,microwav,london2,santacla,campeo,qr5mx7,464811,mynuts,bombo,1mickey,lucky8,danger1,ironside,carter12,wyatt1,borntorun,iloveyou123,jose1,pancake1,tadmichaels,monsta,jugger,hunnie,triste,heat7777,ilovejesus,queeny,luckycharm,lieben,gordolee85,jtkirk,forever21,jetlag,skylane,taucher,neworlea,holera,000005,anhnhoem,melissa7,mumdad,massimiliano,dima1994,nigel1,madison3,slicky,shokolad,serenit,jmh1978,soccer123,chris3,drwho,rfpzdrf,1qasw23ed,free4me,wonka,sasquatc,sanan,maytag,verochka,bankone,molly12,monopoli,xfqybr,lamborgini,gondolin,candycane,needsome,jb007,scottie1,brigit,0147258369,kalamazo,lololyo123,bill1234,ilovejes,lol123123,popkorn,april13,567rntvm,downunde,charle1,angelbab,guildwars,homeworld,qazxcvbnm,superma1,dupa123,kryptoni,happyy,artyom,stormie,cool11,calvin69,saphir,konovalov,jansport,october8,liebling,druuna,susans,megans,tujhjdf,wmegrfux,jumbo1,ljb4dt7n,012345678910,kolesnik,speculum,at4gftlw,kurgan,93pn75,cahek0980,dallas01,godswill,fhifdby,chelsea4,jump23,barsoom,catinhat,urlacher,angel99,vidadi1,678910,lickme69,topaz1,westend,loveone,c12345,gold12,alex1959,mamon,barney12,1maggie,alex12345,lp2568cskt,s1234567,gjikbdctyf,anthony0,browns99,chips1,sunking,widespre,lalala1,tdutif,fucklife,master00,alino4ka,stakan,blonde1,phoebus,tenore,bvgthbz,brunos,suzjv8,uvdwgt,revenant,1banana,veroniqu,sexfun,sp1der,4g3izhox,isakov,shiva1,scooba,bluefire,wizard12,dimitris,funbags,perseus,hoodoo,keving,malboro,157953,a32tv8ls,latics,animate,mossad,yejntb,karting,qmpq39zr,busdrive,jtuac3my,jkne9y,sr20dett,4gxrzemq,keylargo,741147,rfktylfhm,toast1,skins1,xcalibur,gattone,seether,kameron,glock9mm,julio1,delenn,gameday,tommyd,str8edge,bulls123,66699,carlsberg,woodbird,adnama,45auto,codyman,truck2,1w2w3w4w,pvjegu,method1,luetdi,41d8cd98f00b,bankai,5432112345,94rwpe,reneee,chrisx,melvins,775577,sam2000,scrappy1,rachid,grizzley,margare,morgan01,winstons,gevorg,gonzal,crawdad,gfhfdjp,babilon,noneya,pussy11,barbell,easyride,c00li0,777771,311music,karla1,golions,19866891,peejay,leadfoot,hfvbkm,kr9z40sy,cobra123,isotwe,grizz,sallys,****you,aaa123a,dembel,foxs14,hillcres,webman,mudshark,alfredo1,weeded,lester1,hovepark,ratface,000777fffa,huskie,wildthing,elbarto,waikiki,masami,call911,goose2,regin,dovajb,agricola,cjytxrj,andy11,penny123,family01,a121212,1braves,upupa68,happy100,824655,cjlove,firsttim,kalel,redhair,dfhtymt,sliders,bananna,loverbo,fifa2008,crouton,chevy350,panties2,kolya1,alyona,hagrid,spagetti,q2w3e4r,867530,narkoman,nhfdvfnjkju123,1ccccccc,napolean,0072563,allay,w8sted,wigwam,jamesk,state1,parovoz,beach69,kevinb,rossella,logitech1,celula,gnocca,canucks1,loginova,marlboro1,aaaa1,kalleanka,mester,mishutka,milenko,alibek,jersey1,peterc,1mouse,nedved,blackone,ghfplybr,682regkh,beejay,newburgh,ruffian,clarets,noreaga,xenophon,hummerh2,tenshi,smeagol,soloyo,vfhnby,ereiamjh,ewq321,goomie,sportin,cellphone,sonnie,jetblack,saudan,gblfhfc,matheus,uhfvjnf,alicja,jayman1,devon1,hexagon,bailey2,vtufajy,yankees7,salty1,908070,killemal,gammas,eurocard,sydney12,tuesday1,antietam,wayfarer,beast666,19952009sa,aq12ws,eveli,hockey21,haloreach,dontcare,xxxx1,andrea11,karlmarx,jelszo,tylerb,protools,timberwolf,ruffneck,pololo,1bbbbb,waleed,sasami,twinss,fairlady,illuminati,alex007,sucks1,homerjay,scooter7,tarbaby,barmaley,amistad,vanes,randers,tigers12,dreamer2,goleafsg,googie,bernie1,as12345,godeep,james3,phanto,gwbush,cumlover,2196dc,studioworks,995511,golf56,titova,kaleka,itali,socks1,kurwamac,daisuke,hevonen,woody123,daisie,wouter,henry123,gostosa,guppie,porpoise,iamsexy,276115,paula123,1020315,38gjgeuftd,rjrfrjkf,knotty,idiot1,sasha12345,matrix13,securit,radical1,ag764ks,jsmith,coolguy1,secretar,juanas,sasha1988,itout,00000001,tiger11,1butthea,putain,cavalo,basia1,kobebryant,1232323,12345asdfg,sunsh1ne,cyfqgth,tomkat,dorota,dashit,pelmen,5t6y7u,whipit,smokeone,helloall,bonjour1,snowshoe,nilknarf,x1x2x3,lammas,1234599,lol123456,atombomb,ironchef,noclue,alekseev,gwbush1,silver2,12345678m,yesican,fahjlbnf,chapstic,alex95,open1,tiger200,lisichka,pogiako,cbr929,searchin,tanya123,alex1973,phil413,alex1991,dominati,geckos,freddi,silenthill,egroeg,vorobey,antoxa,dark666,shkola,apple22,rebellio,shamanking,7f8srt,cumsucker,partagas,bill99,22223333,arnster55,fucknuts,proxima,silversi,goblues,parcells,vfrcbvjdf,piloto,avocet,emily2,1597530,miniskir,himitsu,pepper2,juiceman,venom1,bogdana,jujube,quatro,botafogo,mama2010,junior12,derrickh,asdfrewq,miller2,chitarra,silverfox,napol,prestigio,devil123,mm111qm,ara123,max33484,sex2000,primo1,sephan,anyuta,alena2010,viborg,verysexy,hibiscus,terps,josefin,oxcart,spooker,speciali,raffaello,partyon,vfhvtkflrf,strela,a123456z,worksuck,glasss,lomonosov,dusty123,dukeblue,1winter,sergeeva,lala123,john22,cmc09,sobolev,bettylou,dannyb,gjkrjdybr,hagakure,iecnhbr,awsedr,pmdmsctsk,costco,alekseeva,fktrcttd,bazuka,flyingv,garuda,buffy16,gutierre,beer12,stomatolog,ernies,palmeiras,golf123,love269,n.kmgfy,gjkysqgbpltw,youare,joeboo,baksik,lifeguar,111a111,nascar8,mindgame,dude1,neopets,frdfkfyu,june24,phoenix8,penelopa,merlin99,mercenar,badluck,mishel,bookert,deadsexy,power9,chinchil,1234567m,alex10,skunk1,rfhkcjy,sammycat,wright1,randy2,marakesh,temppassword,elmer251,mooki,patrick0,bonoedge,1tits,chiar,kylie1,graffix,milkman1,cornel,mrkitty,nicole12,ticketmaster,beatles4,number20,ffff1,terps1,superfre,yfdbufnjh,jake1234,flblfc,1111qq,zanuda,jmol01,wpoolejr,polopol,nicolett,omega13,cannonba,123456789.,sandy69,ribeye,bo243ns,marilena,bogdan123,milla,redskins1,19733791,alias1,movie1,ducat,marzena,shadowru,56565,coolman1,pornlover,teepee,spiff,nafanya,gateway3,fuckyou0,hasher,34778,booboo69,staticx,hang10,qq12345,garnier,bosco123,1234567qw,carson1,samso,1xrg4kcq,cbr929rr,allan123,motorbik,andrew22,pussy101,miroslava,cytujdbr,camp0017,cobweb,snusmumrik,salmon1,cindy2,aliya,serendipity,co437at,tincouch,timmy123,hunter22,st1100,vvvvvv1,blanka,krondor,sweeti,nenit,kuzmich,gustavo1,bmw320i,alex2010,trees1,kyliem,essayons,april26,kumari,sprin,fajita,appletre,fghbjhb,1green,katieb,steven2,corrado1,satelite,1michell,123456789c,cfkfvfylhf,acurarsx,slut543,inhere,bob2000,pouncer,k123456789,fishie,aliso,audia8,bluetick,soccer69,jordan99,fromhell,mammoth1,fighting54,mike25,pepper11,extra1,worldwid,chaise,vfr800,sordfish,almat,nofate,listopad,hellgate,dctvghbdf,jeremia,qantas,lokiju,honker,sprint1,maral,triniti,compaq3,sixsix6,married1,loveman,juggalo1,repvtyrj,zxcasdqw,123445,whore1,123678,monkey6,west123,warcraf,pwnage,mystery1,creamyou,ant123,rehjgfnrf,corona1,coleman1,steve121,alderaan,barnaul,celeste1,junebug1,bombshel,gretzky9,tankist,targa,cachou,vaz2101,playgolf,boneyard,strateg,romawka,iforgotit,pullup,garbage1,irock,archmage,shaft1,oceano,sadies,alvin1,135135ab,psalm69,lmfao,ranger02,zaharova,33334444,perkman,realman,salguod,cmoney,astonmartin,glock1,greyfox,viper99,helpm,blackdick,46775575,family5,shazbot,dewey1,qwertyas,shivani,black22,mailman1,greenday1,57392632,red007,stanky,sanchez1,tysons,daruma,altosax,krayzie,85852008,1forever,98798798,irock.,123456654,142536789,ford22,brick1,michela,preciou,crazy4u,01telemike01,nolife,concac,safety1,annie123,brunswic,destini,123456qwer,madison0,snowball1,137946,1133557799,jarule,scout2,songohan,thedead,00009999,murphy01,spycam,hirsute,aurinko,associat,1miller,baklan,hermes1,2183rm,martie,kangoo,shweta,yvonne1,westsid,jackpot1,rotciv,maratik,fabrika,claude1,nursultan,noentry,ytnhjufnm,electra1,ghjcnjnfr1,puneet,smokey01,integrit,bugeye,trouble2,14071789,paul01,omgwtf,dmh415,ekilpool,yourmom1,moimeme,sparky11,boludo,ruslan123,kissme1,demetrio,appelsin,asshole3,raiders2,bunns,fynjybj,billygoa,p030710p$e4o,macdonal,248ujnfk,acorns,schmidt1,sparrow1,vinbylrj,weasle,jerom,ycwvrxxh,skywalk,gerlinde,solidus,postal1,poochie1,1charles,rhianna,terorist,rehnrf,omgwtfbbq,assfucke,deadend,zidan,jimboy,vengence,maroon5,7452tr,dalejr88,sombra,anatole,elodi,amazonas,147789,q12345q,gawker1,juanma,kassidy,greek1,bruces,bilbob,mike44,0o9i8u7y6t,kaligula,agentx,familie,anders1,pimpjuice,0128um,birthday10,lawncare,hownow,grandorgue,juggerna,scarfac,kensai,swatteam,123four,motorbike,repytxbr,other1,celicagt,pleomax,gen0303,godisgreat,icepick,lucifer666,heavy1,tea4two,forsure,02020,shortdog,webhead,chris13,palenque,3techsrl,knights1,orenburg,prong,nomarg,wutang1,80637852730,laika,iamfree,12345670,pillow1,12343412,bigears,peterg,stunna,rocky5,12123434,damir,feuerwehr,7418529630,danone,yanina,valenci,andy69,111222q,silvia1,1jjjjj,loveforever,passwo1,stratocaster,8928190a,motorolla,lateralu,ujujkm,chubba,ujkjdf,signon,123456789zx,serdce,stevo,wifey200,ololo123,popeye1,1pass,central1,melena,luxor,nemezida,poker123,ilovemusic,qaz1234,noodles1,lakeshow,amarill,ginseng,billiam,trento,321cba,fatback,soccer33,master13,marie2,newcar,bigtop,dark1,camron,nosgoth,155555,biglou,redbud,jordan7,159789,diversio,actros,dazed,drizzit,hjcnjd,wiktoria,justic,gooses,luzifer,darren1,chynna,tanuki,11335577,icculus,boobss,biggi,firstson,ceisi123,gatewa,hrothgar,jarhead1,happyjoy,felipe1,bebop1,medman,athena1,boneman,keiths,djljgfl,dicklick,russ120,mylady,zxcdsa,rock12,bluesea,kayaks,provista,luckies,smile4me,bootycal,enduro,123123f,heartbre,ern3sto,apple13,bigpappa,fy.njxrf,bigtom,cool69,perrito,quiet1,puszek,cious,cruella,temp1,david26,alemap,aa123123,teddies,tricolor,smokey12,kikiriki,mickey01,robert01,super5,ranman,stevenso,deliciou,money777,degauss,mozar,susanne1,asdasd12,shitbag,mommy123,wrestle1,imfree,fuckyou12,barbaris,florent,ujhijr,f8yruxoj,tefjps,anemone,toltec,2gether,left4dead2,ximen,gfkmvf,dunca,emilys,diana123,16473a,mark01,bigbro,annarbor,nikita2000,11aa11,tigres,llllll1,loser2,fbi11213,jupite,qwaszxqw,macabre,123ert,rev2000,mooooo,klapaucius,bagel1,chiquit,iyaoyas,bear101,irocz28,vfktymrfz,smokey2,love99,rfhnbyf,dracul,keith123,slicko,peacock1,orgasmic,thesnake,solder,wetass,doofer,david5,rhfcyjlfh,swanny,tammys,turkiye,tubaman,estefani,firehose,funnyguy,servo,grace17,pippa1,arbiter,jimmy69,nfymrf,asdf67nm,rjcnzy,demon123,thicknes,sexysex,kristall,michail,encarta,banderos,minty,marchenko,de1987ma,mo5kva,aircav,naomi1,bonni,tatoo,cronaldo,49ers1,mama1963,1truck,telecaster,punksnotdead,erotik,1eagles,1fender,luv269,acdeehan,tanner1,freema,1q3e5t7u,linksys,tiger6,megaman1,neophyte,australia1,mydaddy,1jeffrey,fgdfgdfg,gfgekz,1986irachka,keyman,m0b1l3,dfcz123,mikeyg,playstation2,abc125,slacker1,110491g,lordsoth,bhavani,ssecca,dctvghbdtn,niblick,hondacar,baby01,worldcom,4034407,51094didi,3657549,3630000,3578951,sweetpussy,majick,supercoo,robert11,abacabb,panda123,gfhjkm13,ford4x4,zippo1,lapin,1726354,lovesong,dude11,moebius,paravoz,1357642,matkhau,solnyshko,daniel4,multiplelog,starik,martusia,iamtheman,greentre,jetblue,motorrad,vfrcbvev,redoak,dogma1,gnorman,komlos,tonka1,1010220,666satan,losenord,lateralus,absinthe,command1,jigga1,iiiiiii1,pants1,jungfrau,926337,ufhhbgjnnth,yamakasi,888555,sunny7,gemini69,alone1,zxcvbnmz,cabezon,skyblues,zxc1234,456123a,zero00,caseih,azzurra,legolas1,menudo,murcielago,785612,779977,benidorm,viperman,dima1985,piglet1,hemligt,hotfeet,7elephants,hardup,gamess,a000000,267ksyjf,kaitlynn,sharkie,sisyphus,yellow22,667766,redvette,666420,mets69,ac2zxdty,hxxrvwcy,cdavis,alan1,noddy,579300,druss,eatshit1,555123,appleseed,simpleplan,kazak,526282,fynfyfyfhbde,birthday6,dragon6,1pookie,bluedevils,omg123,hj8z6e,x5dxwp,455445,batman23,termin,chrisbrown,animals1,lucky9,443322,kzktxrf,takayuki,fermer,assembler,zomu9q,sissyboy,sergant,felina,nokia6230i,eminem12,croco,hunt4red,festina,darknigh,cptnz062,ndshnx4s,twizzler,wnmaz7sd,aamaax,gfhfcjkmrf,alabama123,barrynov,happy5,punt0it,durandal,8xuuobe4,cmu9ggzh,bruno12,316497,crazyfrog,vfvfktyf,apple3,kasey1,mackdaddy,anthon1,sunnys,angel3,cribbage,moon1,donal,bryce1,pandabear,mwss474,whitesta,freaker,197100,bitche,p2ssw0rd,turnb,tiktonik,moonlite,ferret1,jackas,ferrum,bearclaw,liberty2,1diablo,caribe,snakeeyes,janbam,azonic,rainmaker,vetalik,bigeasy,baby1234,sureno13,blink1,kluivert,calbears,lavanda,198600,dhtlbyf,medvedeva,fox123,whirling,bonscott,freedom9,october3,manoman,segredo,cerulean,robinso,bsmith,flatus,dannon,password21,rrrrrr1,callista,romai,rainman1,trantor,mickeymo,bulldog7,g123456,pavlin,pass22,snowie,hookah,7ofnine,bubba22,cabible,nicerack,moomoo1,summer98,yoyo123,milan1,lieve27,mustang69,jackster,exocet,nadege,qaz12,bahama,watson1,libras,eclipse2,bahram,bapezm,up9x8rww,ghjcnjz,themaste,deflep27,ghost16,gattaca,fotograf,junior123,gilber,gbjyth,8vjzus,rosco1,begonia,aldebara,flower12,novastar,buzzman,manchild,lopez1,mama11,william7,yfcnz1,blackstar,spurs123,moom4242,1amber,iownyou,tightend,07931505,paquito,1johnson,smokepot,pi31415,snowmass,ayacdc,jessicam,giuliana,5tgbnhy6,harlee,giuli,bigwig,tentacle,scoubidou2,benelli,vasilina,nimda,284655,jaihind,lero4ka,1tommy,reggi,ididit,jlbyjxtcndj,mike26,qbert,wweraw,lukasz,loosee123,palantir,flint1,mapper,baldie,saturne,virgin1,meeeee,elkcit,iloveme2,blue15,themoon,radmir,number3,shyanne,missle,hannelor,jasmina,karin1,lewie622,ghjcnjqgfhjkm,blasters,oiseau,sheela,grinders,panget,rapido,positiv,twink,fltkbyf,kzsfj874,daniel01,enjoyit,nofags,doodad,rustler,squealer,fortunat,peace123,khushi,devils2,7inches,candlebo,topdawg,armen,soundman,zxcqweasd,april7,gazeta,netman,hoppers,bear99,ghbjhbntn,mantle7,bigbo,harpo,jgordon,bullshi,vinny1,krishn,star22,thunderc,galinka,phish123,tintable,nightcrawler,tigerboy,rbhgbx,messi,basilisk,masha1998,nina123,yomamma,kayla123,geemoney,0000000000d,motoman,a3jtni,ser123,owen10,italien,vintelok,12345rewq,nightime,jeepin,ch1tt1ck,mxyzptlk,bandido,ohboy,doctorj,hussar,superted,parfilev,grundle,1jack,livestrong,chrisj,matthew3,access22,moikka,fatone,miguelit,trivium,glenn1,smooches,heiko,dezember,spaghett,stason,molokai,bossdog,guitarma,waderh,boriska,photosho,path13,hfrtnf,audre,junior24,monkey24,silke,vaz21093,bigblue1,trident1,candide,arcanum,klinker,orange99,bengals1,rosebu,mjujuj,nallepuh,mtwapa1a,ranger69,level1,bissjop,leica,1tiffany,rutabega,elvis77,kellie1,sameas,barada,karabas,frank12,queenb,toutoune,surfcity,samanth1,monitor1,littledo,kazakova,fodase,mistral1,april22,carlit,shakal,batman123,fuckoff2,alpha01,5544332211,buddy3,towtruck,kenwood1,vfiekmrf,jkl123,pypsik,ranger75,sitges,toyman,bartek1,ladygirl,booman,boeing77,installsqlst,222666,gosling,bigmack,223311,bogos,kevin2,gomez1,xohzi3g4,kfnju842,klubnika,cubalibr,123456789101,kenpo,0147852369,raptor1,tallulah,boobys,jjones,1q2s3c,moogie,vid2600,almas,wombat1,extra300,xfiles1,green77,sexsex1,heyjude,sammyy,missy123,maiyeuem,nccpl25282,thicluv,sissie,raven3,fldjrfn,buster22,broncos2,laurab,letmein4,harrydog,solovey,fishlips,asdf4321,ford123,superjet,norwegen,movieman,psw333333,intoit,postbank,deepwate,ola123,geolog323,murphys,eshort,a3eilm2s2y,kimota,belous,saurus,123321qaz,i81b4u,aaa12,monkey20,buckwild,byabybnb,mapleleafs,yfcnzyfcnz,baby69,summer03,twista,246890,246824,ltcnhjth,z1z2z3,monika1,sad123,uto29321,bathory,villan,funkey,poptarts,spam967888,705499fh,sebast,porn1234,earn381,1porsche,whatthef,123456789y,polo12,brillo,soreilly,waters1,eudora,allochka,is_a_bot,winter00,bassplay,531879fiz,onemore,bjarne,red911,kot123,artur1,qazxdr,c0rvette,diamond7,matematica,klesko,beaver12,2enter,seashell,panam,chaching,edward2,browni,xenogear,cornfed,aniram,chicco22,darwin1,ancella2,sophie2,vika1998,anneli,shawn41,babie,resolute,pandora2,william8,twoone,coors1,jesusis1,teh012,cheerlea,renfield,tessa1,anna1986,madness1,bkmlfh,19719870,liebherr,ck6znp42,gary123,123654z,alsscan,eyedoc,matrix7,metalgea,chinito,4iter,falcon11,7jokx7b9du,bigfeet,tassadar,retnuh,muscle1,klimova,darion,batistuta,bigsur,1herbier,noonie,ghjrehjh,karimova,faustus,snowwhite,1manager,dasboot,michael12,analfuck,inbed,dwdrums,jaysoncj,maranell,bsheep75,164379,rolodex,166666,rrrrrrr1,almaz666,167943,russel1,negrito,alianz,goodpussy,veronik,1w2q3r4e,efremov,emb377,sdpass,william6,alanfahy,nastya1995,panther5,automag,123qwe12,vfvf2011,fishe,1peanut,speedie,qazwsx1234,pass999,171204j,ketamine,sheena1,energizer,usethis1,123abc123,buster21,thechamp,flvbhfk,frank69,chane,hopeful1,claybird,pander,anusha,bigmaxxx,faktor,housebed,dimidrol,bigball,shashi,derby1,fredy,dervish,bootycall,80988218126,killerb,cheese2,pariss,mymail,dell123,catbert,christa1,chevytru,gjgjdf,00998877,overdriv,ratten,golf01,nyyanks,dinamite,bloembol,gismo,magnus1,march2,twinkles,ryan22,duckey,118a105b,kitcat,brielle,poussin,lanzarot,youngone,ssvegeta,hero63,battle1,kiler,fktrcfylh1,newera,vika1996,dynomite,oooppp,beer4me,foodie,ljhjuf,sonshine,godess,doug1,constanc,thinkbig,steve2,damnyou,autogod,www333,kyle1,ranger7,roller1,harry2,dustin1,hopalong,tkachuk,b00bies,bill2,deep111,stuffit,fire69,redfish1,andrei123,graphix,1fishing,kimbo1,mlesp31,ifufkbyf,gurkan,44556,emily123,busman,and123,8546404,paladine,1world,bulgakov,4294967296,bball23,1wwwww,mycats,elain,delta6,36363,emilyb,color1,6060842,cdtnkfyrf,hedonism,gfgfrfhkj,5551298,scubad,gostate,sillyme,hdbiker,beardown,fishers,sektor,00000007,newbaby,rapid1,braves95,gator2,nigge,anthony3,sammmy,oou812,heffer,phishin,roxanne1,yourass,hornet1,albator,2521659,underwat,tanusha,dianas,3f3fpht7op,dragon20,bilbobag,cheroke,radiatio,dwarf1,majik,33st33,dochka,garibald,robinh,sham69,temp01,wakeboar,violet1,1w2w3w,registr,tonite,maranello,1593570,parolamea,galatasara,loranthos,1472583,asmodean,1362840,scylla,doneit,jokerr,porkypig,kungen,mercator,koolhaas,come2me,debbie69,calbear,liverpoolfc,yankees4,12344321a,kennyb,madma,85200258,dustin23,thomas13,tooling,mikasa,mistic,crfnbyf,112233445,sofia1,heinz57,colts1,price1,snowey,joakim,mark11,963147,cnhfcnm,kzinti,1bbbbbbb,rubberdu,donthate,rupert1,sasha1992,regis1,nbuhbwf,fanboy,sundial,sooner1,wayout,vjnjhjkf,deskpro,arkangel,willie12,mikeyb,celtic1888,luis1,buddy01,duane1,grandma1,aolcom,weeman,172839456,basshead,hornball,magnu,pagedown,molly2,131517,rfvtgbyhn,astonmar,mistery,madalina,cash1,1happy,shenlong,matrix01,nazarova,369874125,800500,webguy,rse2540,ashley2,briank,789551,786110,chunli,j0nathan,greshnik,courtne,suckmyco,mjollnir,789632147,asdfg1234,754321,odelay,ranma12,zebedee,artem777,bmw318is,butt1,rambler1,yankees9,alabam,5w76rnqp,rosies,mafioso,studio1,babyruth,tranzit,magical123,gfhjkm135,12345$,soboleva,709394,ubique,drizzt1,elmers,teamster,pokemons,1472583690,1597532486,shockers,merckx,melanie2,ttocs,clarisse,earth1,dennys,slobber,flagman,farfalla,troika,4fa82hyx,hakan,x4ww5qdr,cumsuck,leather1,forum1,july20,barbel,zodiak,samuel12,ford01,rushfan,bugsy1,invest1,tumadre,screwme,a666666,money5,henry8,tiddles,sailaway,starburs,100years,killer01,comando,hiromi,ranetka,thordog,blackhole,palmeira,verboten,solidsna,q1w1e1,humme,kevinc,gbrfxe,gevaudan,hannah11,peter2,vangar,sharky7,talktome,jesse123,chuchi,pammy,!qazxsw2,siesta,twenty1,wetwilly,477041,natural1,sun123,daniel3,intersta,shithead1,hellyea,bonethugs,solitair,bubbles2,father1,nick01,444000,adidas12,dripik,cameron2,442200,a7nz8546,respublika,fkojn6gb,428054,snoppy,rulez1,haslo,rachael1,purple01,zldej102,ab12cd34,cytuehjxrf,madhu,astroman,preteen,handsoff,mrblonde,biggio,testin,vfdhif,twolves,unclesam,asmara,kpydskcw,lg2wmgvr,grolsch,biarritz,feather1,williamm,s62i93,bone1,penske,337733,336633,taurus1,334433,billet,diamondd,333000,nukem,fishhook,godogs,thehun,lena1982,blue00,smelly1,unb4g9ty,65pjv22,applegat,mikehunt,giancarlo,krillin,felix123,december1,soapy,46doris,nicole23,bigsexy1,justin10,pingu,bambou,falcon12,dgthtl,1surfer,qwerty01,estrellit,nfqcjy,easygo,konica,qazqwe,1234567890m,stingers,nonrev,3e4r5t,champio,bbbbbb99,196400,allen123,seppel,simba2,rockme,zebra3,tekken3,endgame,sandy2,197300,fitte,monkey00,eldritch,littleone,rfyfgkz,1member,66chevy,oohrah,cormac,hpmrbm41,197600,grayfox,elvis69,celebrit,maxwell7,rodders,krist,1camaro,broken1,kendall1,silkcut,katenka,angrick,maruni,17071994a,tktyf,kruemel,snuffles,iro4ka,baby12,alexis01,marryme,vlad1994,forward1,culero,badaboom,malvin,hardtoon,hatelove,molley,knopo4ka,duchess1,mensuck,cba321,kickbutt,zastava,wayner,fuckyou6,eddie123,cjkysir,john33,dragonfi,cody1,jabell,cjhjrf,badseed,sweden1,marihuana,brownlov,elland,nike1234,kwiettie,jonnyboy,togepi,billyk,robert123,bb334,florenci,ssgoku,198910,bristol1,bob007,allister,yjdujhjl,gauloise,198920,bellaboo,9lives,aguilas,wltfg4ta,foxyroxy,rocket69,fifty50,babalu,master21,malinois,kaluga,gogosox,obsessio,yeahrigh,panthers1,capstan,liza2000,leigh1,paintball1,blueskie,cbr600f3,bagdad,jose98,mandreki,shark01,wonderbo,muledeer,xsvnd4b2,hangten,200001,grenden,anaell,apa195,model1,245lufpq,zip100,ghjcgtrn,wert1234,misty2,charro,juanjose,fkbcrf,frostbit,badminto,buddyy,1doctor,vanya,archibal,parviz,spunky1,footboy,dm6tzsgp,legola,samadhi,poopee,ytdxz2ca,hallowboy,dposton,gautie,theworm,guilherme,dopehead,iluvtits,bobbob1,ranger6,worldwar,lowkey,chewbaca,oooooo99,ducttape,dedalus,celular,8i9o0p,borisenko,taylor01,111111z,arlingto,p3nnywiz,rdgpl3ds,boobless,kcmfwesg,blacksab,mother2,markus1,leachim,secret2,s123456789,1derful,espero,russell2,tazzer,marykate,freakme,mollyb,lindros8,james00,gofaster,stokrotka,kilbosik,aquamann,pawel1,shedevil,mousie,slot2009,october6,146969,mm259up,brewcrew,choucho,uliana,sexfiend,fktirf,pantss,vladimi,starz,sheeps,12341234q,bigun,tiggers,crjhjcnm,libtech,pudge1,home12,zircon,klaus1,jerry2,pink1,lingus,monkey66,dumass,polopolo09,feuerweh,rjyatnf,chessy,beefer,shamen,poohbear1,4jjcho,bennevis,fatgirls,ujnbrf,cdexswzaq,9noize9,rich123,nomoney,racecar1,hacke,clahay,acuario,getsum,hondacrv,william0,cheyenn,techdeck,atljhjdf,wtcacq,suger,fallenangel,bammer,tranquil,carla123,relayer,lespaul1,portvale,idontno,bycnbnen,trooper2,gennadiy,pompon,billbob,amazonka,akitas,chinatow,atkbrc,busters,fitness1,cateye,selfok2013,1murphy,fullhous,mucker,bajskorv,nectarin,littlebitch,love24,feyenoor,bigal37,lambo1,pussybitch,icecube1,biged,kyocera,ltybcjdf,boodle,theking1,gotrice,sunset1,abm1224,fromme,sexsells,inheat,kenya1,swinger1,aphrodit,kurtcobain,rhind101,poidog,poiulkjh,kuzmina,beantown,tony88,stuttgar,drumer,joaqui,messenge,motorman,amber2,nicegirl,rachel69,andreia,faith123,studmuffin,jaiden,red111,vtkmybr,gamecocks,gumper,bosshogg,4me2know,tokyo1,kleaner,roadhog,fuckmeno,phoenix3,seeme,buttnutt,boner69,andreyka,myheart,katerin,rugburn,jvtuepip,dc3ubn,chile1,ashley69,happy99,swissair,balls2,fylhttdf,jimboo,55555d,mickey11,voronin,m7hsqstm,stufff,merete,weihnachte,dowjones,baloo1,freeones,bears34,auburn1,beverl,timberland,1elvis,guinness1,bombadil,flatron1,logging7,telefoon,merl1n,masha1,andrei1,cowabung,yousuck1,1matrix,peopl,asd123qwe,sweett,mirror1,torrente,joker12,diamond6,jackaroo,00000a,millerlite,ironhorse,2twins,stryke,gggg1,zzzxxxccc,roosevel,8363eddy,angel21,depeche1,d0ct0r,blue14,areyou,veloce,grendal,frederiksberg,cbcntvf,cb207sl,sasha2000,was.here,fritzz,rosedale,spinoza,cokeisit,gandalf3,skidmark,ashley01,12345j,1234567890qaz,sexxxxxx,beagles,lennart,12345789,pass10,politic,max007,gcheckou,12345611,tiffy,lightman,mushin,velosiped,brucewayne,gauthie,elena123,greenegg,h2oski,clocker,nitemare,123321s,megiddo,cassidy1,david13,boywonde,flori,peggy12,pgszt6md,batterie,redlands,scooter6,bckhere,trueno,bailey11,maxwell2,bandana,timoth1,startnow,ducati74,tiern,maxine1,blackmetal,suzyq,balla007,phatfarm,kirsten1,titmouse,benhogan,culito,forbin,chess1,warren1,panman,mickey7,24lover,dascha,speed2,redlion,andrew10,johnwayn,nike23,chacha1,bendog,bullyboy,goldtree,spookie,tigger99,1cookie,poutine,cyclone1,woodpony,camaleun,bluesky1,dfadan,eagles20,lovergirl,peepshow,mine1,dima1989,rjdfkmxer,11111aaaaa,machina,august17,1hhhhh,0773417k,1monster,freaksho,jazzmin,davidw,kurupt,chumly,huggies,sashenka,ccccccc1,bridge1,giggalo,cincinna,pistol1,hello22,david77,lightfoo,lucky6,jimmy12,261397,lisa12,tabaluga,mysite,belo4ka,greenn,eagle99,punkrawk,salvado,slick123,wichsen,knight99,dummys,fefolico,contrera,kalle1,anna1984,delray,robert99,garena,pretende,racefan,alons,serenada,ludmilla,cnhtkjr,l0swf9gx,hankster,dfktynbyrf,sheep1,john23,cv141ab,kalyani,944turbo,crystal2,blackfly,zrjdktdf,eus1sue1,mario5,riverplate,harddriv,melissa3,elliott1,sexybitc,cnhfyybr,jimdavis,bollix,beta1,amberlee,skywalk1,natala,1blood,brattax,shitty1,gb15kv99,ronjon,rothmans,thedoc,joey21,hotboi,firedawg,bimbo38,jibber,aftermat,nomar,01478963,phishing,domodo,anna13,materia,martha1,budman1,gunblade,exclusiv,sasha1997,anastas,rebecca2,fackyou,kallisti,fuckmyass,norseman,ipswich1,151500,1edward,intelinside,darcy1,bcrich,yjdjcnbf,failte,buzzzz,cream1,tatiana1,7eleven,green8,153351,1a2s3d4f5g6h,154263,milano1,bambi1,bruins77,rugby2,jamal1,bolita,sundaypunch,bubba12,realmadr,vfyxtcnth,iwojima,notlob,black666,valkiria,nexus1,millerti,birthday100,swiss1,appollo,gefest,greeneyes,celebrat,tigerr,slava123,izumrud,bubbabub,legoman,joesmith,katya123,sweetdream,john44,wwwwwww1,oooooo1,socal,lovespor,s5r8ed67s,258147,heidis,cowboy22,wachovia,michaelb,qwe1234567,i12345,255225,goldie1,alfa155,45colt,safeu851,antonova,longtong,1sparky,gfvznm,busen,hjlbjy,whateva,rocky4,cokeman,joshua3,kekskek1,sirocco,jagman,123456qwert,phinupi,thomas10,loller,sakur,vika2011,fullred,mariska,azucar,ncstate,glenn74,halima,aleshka,ilovemylife,verlaat,baggie,scoubidou6,phatboy,jbruton,scoop1,barney11,blindman,def456,maximus2,master55,nestea,11223355,diego123,sexpistols,sniffy,philip1,f12345,prisonbreak,nokia2700,ajnjuhfa,yankees3,colfax,ak470000,mtnman,bdfyeirf,fotball,ichbin,trebla,ilusha,riobravo,beaner1,thoradin,polkaudi,kurosawa,honda123,ladybu,valerik,poltava,saviola,fuckyouguys,754740g0,anallove,microlab1,juris01,ncc1864,garfild,shania1,qagsud,makarenko,cindy69,lebedev,andrew11,johnnybo,groovy1,booster1,sanders1,tommyb,johnson4,kd189nlcih,hondaman,vlasova,chick1,sokada,sevisgur,bear2327,chacho,sexmania,roma1993,hjcnbckfd,valley1,howdie,tuppence,jimandanne,strike3,y4kuz4,nhfnfnf,tsubasa,19955991,scabby,quincunx,dima1998,uuuuuu1,logica,skinner1,pinguino,lisa1234,xpressmusic,getfucked,qqqq1,bbbb1,matulino,ulyana,upsman,johnsmith,123579,co2000,spanner1,todiefor,mangoes,isabel1,123852,negra,snowdon,nikki123,bronx1,booom,ram2500,chuck123,fireboy,creek1,batman13,princesse,az12345,maksat,1knight,28infern,241455,r7112s,muselman,mets1986,katydid,vlad777,playme,kmfdm1,asssex,1prince,iop890,bigbroth,mollymoo,waitron,lizottes,125412,juggler,quinta,0sister0,zanardi,nata123,heckfyxbr,22q04w90e,engine2,nikita95,zamira,hammer22,lutscher,carolina1,zz6319,sanman,vfuflfy,buster99,rossco,kourniko,aggarwal,tattoo1,janice1,finger1,125521,19911992,shdwlnds,rudenko,vfvfgfgf123,galatea,monkeybu,juhani,premiumcash,classact,devilmay,helpme2,knuddel,hardpack,ramil,perrit,basil1,zombie13,stockcar,tos8217,honeypie,nowayman,alphadog,melon1,talula,125689,tiribon12,tornike,haribol,telefone,tiger22,sucka,lfytxrf,chicken123,muggins,a23456,b1234567,lytdybr,otter1,pippa,vasilisk,cooking1,helter,78978,bestboy,viper7,ahmed1,whitewol,mommys,apple5,shazam1,chelsea7,kumiko,masterma,rallye,bushmast,jkz123,entrar,andrew6,nathan01,alaric,tavasz,heimdall,gravy1,jimmy99,cthlwt,powerr,gthtrhtcnjr,canesfan,sasha11,ybrbnf_25,august9,brucie,artichok,arnie1,superdude,tarelka,mickey22,dooper,luners,holeshot,good123,gettysbu,bicho,hammer99,divine5,1zxcvbn,stronzo,q22222,disne,bmw750il,godhead,hallodu,aerith,nastik,differen,cestmoi,amber69,5string,pornosta,dirtygirl,ginger123,formel1,scott12,honda200,hotspurs,johnatha,firstone123,lexmark1,msconfig,karlmasc,l123456,123qweasdzx,baldman,sungod,furka,retsub,9811020,ryder1,tcglyued,astron,lbvfcbr,minddoc,dirt49,baseball12,tbear,simpl,schuey,artimus,bikman,plat1num,quantex,gotyou,hailey1,justin01,ellada,8481068,000002,manimal,dthjybxrf,buck123,dick123,6969696,nospam,strong1,kodeord,bama12,123321w,superman123,gladiolus,nintend,5792076,dreamgirl,spankme1,gautam,arianna1,titti,tetas,cool1234,belladog,importan,4206969,87e5nclizry,teufelo7,doller,yfl.irf,quaresma,3440172,melis,bradle,nnmaster,fast1,iverso,blargh,lucas12,chrisg,iamsam,123321az,tomjerry,kawika,2597174,standrew,billyg,muskan,gizmodo2,rz93qpmq,870621345,sathya,qmezrxg4,januari,marthe,moom4261,cum2me,hkger286,lou1988,suckit1,croaker,klaudia1,753951456,aidan1,fsunoles,romanenko,abbydog,isthebes,akshay,corgi,fuck666,walkman555,ranger98,scorpian,hardwareid,bluedragon,fastman,2305822q,iddqdiddqd,1597532,gopokes,zvfrfcb,w1234567,sputnik1,tr1993,pa$$w0rd,2i5fdruv,havvoc,1357913,1313131,bnm123,cowd00d,flexscan,thesims2,boogiema,bigsexxy,powerstr,ngc4565,joshman,babyboy1,123jlb,funfunfu,qwe456,honor1,puttana,bobbyj,daniel21,pussy12,shmuck,1232580,123578951,maxthedo,hithere1,bond0007,gehenna,nomames,blueone,r1234567,bwana,gatinho,1011111,torrents,cinta,123451234,tiger25,money69,edibey,pointman,mmcm19,wales1,caffreys,phaedra,bloodlus,321ret32,rufuss,tarbit,joanna1,102030405,stickboy,lotrfotr34,jamshid,mclarenf1,ataman,99ford,yarrak,logan2,ironlung,pushistik,dragoon1,unclebob,tigereye,pinokio,tylerj,mermaid1,stevie1,jaylen,888777,ramana,roman777,brandon7,17711771s,thiago,luigi1,edgar1,brucey,videogam,classi,birder,faramir,twiddle,cubalibre,grizzy,fucky,jjvwd4,august15,idinahui,ranita,nikita1998,123342,w1w2w3,78621323,4cancel,789963,(null,vassago,jaydog472,123452,timt42,canada99,123589,rebenok,htyfnf,785001,osipov,maks123,neverwinter,love2010,777222,67390436,eleanor1,bykemo,aquemini,frogg,roboto,thorny,shipmate,logcabin,66005918,nokian,gonzos,louisian,1abcdefg,triathlo,ilovemar,couger,letmeino,supera,runvs,fibonacci,muttly,58565254,5thgbqi,vfnehsv,electr,jose12,artemis1,newlove,thd1shr,hawkey,grigoryan,saisha,tosca,redder,lifesux,temple1,bunnyman,thekids,sabbeth,tarzan1,182838,158uefas,dell50,1super,666222,47ds8x,jackhamm,mineonly,rfnfhbyf,048ro,665259,kristina1,bombero,52545856,secure1,bigloser,peterk,alex2,51525354,anarchy1,superx,teenslut,money23,sigmapi,sanfrancisco,acme34,private5,eclips,qwerttrewq,axelle,kokain,hardguy,peter69,jesuschr,dyanna,dude69,sarah69,toyota91,amberr,45645645,bugmenot,bigted,44556677,556644,wwr8x9pu,alphaome,harley13,kolia123,wejrpfpu,revelati,nairda,sodoff,cityboy,pinkpussy,dkalis,miami305,wow12345,triplet,tannenbau,asdfasdf1,darkhors,527952,retired1,soxfan,nfyz123,37583867,goddes,515069,gxlmxbewym,1warrior,36925814,dmb2011,topten,karpova,89876065093rax,naturals,gateway9,cepseoun,turbot,493949,cock22,italia1,sasafras,gopnik,stalke,1qazxdr5,wm2006,ace1062,alieva,blue28,aracel,sandia,motoguzz,terri1,emmajane,conej,recoba,alex1995,jerkyboy,cowboy12,arenrone,precisio,31415927,scsa316,panzer1,studly1,powerhou,bensam,mashoutq,billee,eeyore1,reape,thebeatl,rul3z,montesa,doodle1,cvzefh1gk,424365,a159753,zimmerma,gumdrop,ashaman,grimreap,icandoit,borodina,branca,dima2009,keywest1,vaders,bubluk,diavolo,assss,goleta,eatass,napster1,382436,369741,5411pimo,lenchik,pikach,gilgamesh,kalimera,singer1,gordon2,rjycnbnewbz,maulwurf,joker13,2much4u,bond00,alice123,robotec,fuckgirl,zgjybz,redhorse,margaret1,brady1,pumpkin2,chinky,fourplay,1booger,roisin,1brandon,sandan,blackheart,cheez,blackfin,cntgfyjdf,mymoney1,09080706,goodboss,sebring1,rose1,kensingt,bigboner,marcus12,ym3cautj,struppi,thestone,lovebugs,stater,silver99,forest99,qazwsx12345,vasile,longboar,mkonji,huligan,rhfcbdfz,airmail,porn11,1ooooo,sofun,snake2,msouthwa,dougla,1iceman,shahrukh,sharona,dragon666,france98,196800,196820,ps253535,zjses9evpa,sniper01,design1,konfeta,jack99,drum66,good4you,station2,brucew,regedit,school12,mvtnr765,pub113,fantas,tiburon1,king99,ghjcnjgbpltw,checkito,308win,1ladybug,corneliu,svetasveta,197430,icicle,imaccess,ou81269,jjjdsl,brandon6,bimbo1,smokee,piccolo1,3611jcmg,children2,cookie2,conor1,darth1,margera,aoi856,paully,ou812345,sklave,eklhigcz,30624700,amazing1,wahooo,seau55,1beer,apples2,chulo,dolphin9,heather6,198206,198207,hergood,miracle1,njhyflj,4real,milka,silverfi,fabfive,spring12,ermine,mammy,jumpjet,adilbek,toscana,caustic,hotlove,sammy69,lolita1,byoung,whipme,barney01,mistys,tree1,buster3,kaylin,gfccgjhn,132333,aishiteru,pangaea,fathead1,smurph,198701,ryslan,gasto,xexeylhf,anisimov,chevyss,saskatoo,brandy12,tweaker,irish123,music2,denny1,palpatin,outlaw1,lovesuck,woman1,mrpibb,diadora,hfnfneq,poulette,harlock,mclaren1,cooper12,newpass3,bobby12,rfgecnfcerf,alskdjfh,mini14,dukers,raffael,199103,cleo123,1234567qwertyu,mossberg,scoopy,dctulf,starline,hjvjxrf,misfits1,rangers2,bilbos,blackhea,pappnase,atwork,purple2,daywalker,summoner,1jjjjjjj,swansong,chris10,laluna,12345qqq,charly1,lionsden,money99,silver33,hoghead,bdaddy,199430,saisg002,nosaints,tirpitz,1gggggg,jason13,kingss,ernest1,0cdh0v99ue,pkunzip,arowana,spiri,deskjet1,armine,lances,magic2,thetaxi,14159265,cacique,14142135,orange10,richard0,backdraf,255ooo,humtum,kohsamui,c43dae874d,wrestling1,cbhtym,sorento,megha,pepsiman,qweqwe12,bliss7,mario64,korolev,balls123,schlange,gordit,optiquest,fatdick,fish99,richy,nottoday,dianne1,armyof1,1234qwerasdfzxcv,bbonds,aekara,lidiya,baddog1,yellow5,funkie,ryan01,greentree,gcheckout,marshal1,liliput,000000z,rfhbyrf,gtogto43,rumpole,tarado,marcelit,aqwzsxedc,kenshin1,sassydog,system12,belly1,zilla,kissfan,tools1,desember,donsdad,nick11,scorpio6,poopoo1,toto99,steph123,dogfuck,rocket21,thx113,dude12,sanek,sommar,smacky,pimpsta,letmego,k1200rs,lytghjgtnhjdcr,abigale,buddog,deles,baseball9,roofus,carlsbad,hamzah,hereiam,genial,schoolgirlie,yfz450,breads,piesek,washear,chimay,apocalyp,nicole18,gfgf1234,gobulls,dnevnik,wonderwall,beer1234,1moose,beer69,maryann1,adpass,mike34,birdcage,hottuna,gigant,penquin,praveen,donna123,123lol123,thesame,fregat,adidas11,selrahc,pandoras,test3,chasmo,111222333000,pecos,daniel11,ingersol,shana1,mama12345,cessna15,myhero,1simpson,nazarenko,cognit,seattle2,irina1,azfpc310,rfycthdf,hardy1,jazmyn,sl1200,hotlanta,jason22,kumar123,sujatha,fsd9shtyu,highjump,changer,entertai,kolding,mrbig,sayuri,eagle21,qwertzu,jorge1,0101dd,bigdong,ou812a,sinatra1,htcnjhfy,oleg123,videoman,pbyfblf,tv612se,bigbird1,kenaidog,gunite,silverma,ardmore,123123qq,hotbot,cascada,cbr600f4,harakiri,chico123,boscos,aaron12,glasgow1,kmn5hc,lanfear,1light,liveoak,fizika,ybrjkftdyf,surfside,intermilan,multipas,redcard,72chevy,balata,coolio1,schroede,kanat,testerer,camion,kierra,hejmeddig,antonio2,tornados,isidor,pinkey,n8skfswa,ginny1,houndog,1bill,chris25,hastur,1marine,greatdan,french1,hatman,123qqq,z1z2z3z4,kicker1,katiedog,usopen,smith22,mrmagoo,1234512i,assa123,7seven7,monster7,june12,bpvtyf,149521,guenter,alex1985,voronina,mbkugegs,zaqwsxcderfv,rusty5,mystic1,master0,abcdef12,jndfkb,r4zpm3,cheesey,skripka,blackwhite,sharon69,dro8smwq,lektor,techman,boognish,deidara,heckfyf,quietkey,authcode,monkey4,jayboy,pinkerto,merengue,chulita,bushwick,turambar,kittykit,joseph2,dad123,kristo,pepote,scheiss,hambone1,bigballa,restaura,tequil,111luzer,euro2000,motox,denhaag,chelsi,flaco1,preeti,lillo,1001sin,passw,august24,beatoff,555555d,willis1,kissthis,qwertyz,rvgmw2gl,iloveboobies,timati,kimbo,msinfo,dewdrop,sdbaker,fcc5nky2,messiah1,catboy,small1,chode,beastie1,star77,hvidovre,short1,xavie,dagobah,alex1987,papageno,dakota2,toonami,fuerte,jesus33,lawina,souppp,dirtybir,chrish,naturist,channel1,peyote,flibble,gutentag,lactate,killem,zucchero,robinho,ditka,grumpy1,avr7000,boxxer,topcop,berry1,mypass1,beverly1,deuce1,9638527410,cthuttdf,kzkmrf,lovethem,band1t,cantona1,purple11,apples123,wonderwo,123a456,fuzzie,lucky99,dancer2,hoddling,rockcity,winner12,spooty,mansfiel,aimee1,287hf71h,rudiger,culebra,god123,agent86,daniel0,bunky1,notmine,9ball,goofus,puffy1,xyh28af4,kulikov,bankshot,vurdf5i2,kevinm,ercole,sexygirls,razvan,october7,goater,lollie,raissa,thefrog,mdmaiwa3,mascha,jesussaves,union1,anthony9,crossroa,brother2,areyuke,rodman91,toonsex,dopeman,gericom,vaz2115,cockgobbler,12356789,12345699,signatur,alexandra1,coolwhip,erwin1,awdrgyjilp,pens66,ghjrjgtyrj,linkinpark,emergenc,psych0,blood666,bootmort,wetworks,piroca,johnd,iamthe1,supermario,homer69,flameon,image1,bebert,fylhtq1,annapoli,apple11,hockey22,10048,indahouse,mykiss,1penguin,markp,misha123,foghat,march11,hank1,santorin,defcon4,tampico,vbnhjafy,robert22,bunkie,athlon64,sex777,nextdoor,koskesh,lolnoob,seemnemaailm,black23,march15,yeehaa,chiqui,teagan,siegheil,monday2,cornhusk,mamusia,chilis,sthgrtst,feldspar,scottm,pugdog,rfghjy,micmac,gtnhjdyf,terminato,1jackson,kakosja,bogomol,123321aa,rkbvtyrj,tresor,tigertig,fuckitall,vbkkbjy,caramon,zxc12,balin,dildo1,soccer09,avata,abby123,cheetah1,marquise,jennyc,hondavfr,tinti,anna1985,dennis2,jorel,mayflowe,icema,hal2000,nikkis,bigmouth,greenery,nurjan,leonov,liberty7,fafnir,larionov,sat321321,byteme1,nausicaa,hjvfynbrf,everto,zebra123,sergio1,titone,wisdom1,kahala,104328q,marcin1,salima,pcitra,1nnnnn,nalini,galvesto,neeraj,rick1,squeeky,agnes1,jitterbu,agshar,maria12,0112358,traxxas,stivone,prophet1,bananza,sommer1,canoneos,hotfun,redsox11,1bigmac,dctdjkjl,legion1,everclea,valenok,black9,danny001,roxie1,1theman,mudslide,july16,lechef,chula,glamis,emilka,canbeef,ioanna,cactus1,rockshox,im2cool,ninja9,thvfrjdf,june28,milo17,missyou,micky1,nbibyf,nokiaa,goldi,mattias,fuckthem,asdzxc123,ironfist,junior01,nesta,crazzy,killswit,hygge,zantac,kazama,melvin1,allston,maandag,hiccup,prototyp,specboot,dwl610,hello6,159456,baldhead,redwhite,calpoly,whitetail,agile1,cousteau,matt01,aust1n,malcolmx,gjlfhjr,semperf1,ferarri,a1b2c3d,vangelis,mkvdari,bettis36,andzia,comand,tazzman,morgaine,pepluv,anna1990,inandout,anetka,anna1997,wallpape,moonrake,huntress,hogtie,cameron7,sammy7,singe11,clownboy,newzeala,wilmar,safrane,rebeld,poopi,granat,hammertime,nermin,11251422,xyzzy1,bogeys,jkmxbr,fktrcfyl,11223311,nfyrbcn,11223300,powerpla,zoedog,ybrbnbyf,zaphod42,tarawa,jxfhjdfirf,dude1234,g5wks9,goobe,czekolada,blackros,amaranth,medical1,thereds,julija,nhecsyfujkjdt,promopas,buddy4,marmalad,weihnachten,tronic,letici,passthief,67mustan,ds7zamnw,morri,w8woord,cheops,pinarell,sonofsam,av473dv,sf161pn,5c92v5h6,purple13,tango123,plant1,1baby,xufrgemw,fitta,1rangers,spawns,kenned,taratata,19944991,11111118,coronas,4ebouux8,roadrash,corvette1,dfyjdf846,marley12,qwaszxerdfcv,68stang,67stang,racin,ellehcim,sofiko,nicetry,seabass1,jazzman1,zaqwsx1,laz2937,uuuuuuu1,vlad123,rafale,j1234567,223366,nnnnnn1,226622,junkfood,asilas,cer980,daddymac,persepho,neelam,00700,shithappens,255555,qwertyy,xbox36,19755791,qweasd1,bearcub,jerryb,a1b1c1,polkaudio,basketball1,456rty,1loveyou,marcus2,mama1961,palace1,transcend,shuriken,sudhakar,teenlove,anabelle,matrix99,pogoda,notme,bartend,jordana,nihaoma,ataris,littlegi,ferraris,redarmy,giallo,fastdraw,accountbloc,peludo,pornostar,pinoyako,cindee,glassjaw,dameon,johnnyd,finnland,saudade,losbravo,slonko,toplay,smalltit,nicksfun,stockhol,penpal,caraj,divedeep,cannibus,poppydog,pass88,viktory,walhalla,arisia,lucozade,goldenbo,tigers11,caball,ownage123,tonna,handy1,johny,capital5,faith2,stillher,brandan,pooky1,antananarivu,hotdick,1justin,lacrimos,goathead,bobrik,cgtwbfkbcn,maywood,kamilek,gbplf123,gulnar,beanhead,vfvjyn,shash,viper69,ttttttt1,hondacr,kanako,muffer,dukies,justin123,agapov58,mushka,bad11bad,muleman,jojo123,andreika,makeit,vanill,boomers,bigals,merlin11,quacker,aurelien,spartak1922,ligeti,diana2,lawnmowe,fortune1,awesom,rockyy,anna1994,oinker,love88,eastbay,ab55484,poker0,ozzy666,papasmurf,antihero,photogra,ktm250,painkill,jegr2d2,p3orion,canman,dextur,qwest123,samboy,yomismo,sierra01,herber,vfrcbvvfrcbv,gloria1,llama1,pie123,bobbyjoe,buzzkill,skidrow,grabber,phili,javier1,9379992q,geroin,oleg1994,sovereig,rollover,zaq12qaz,battery1,killer13,alina123,groucho1,mario12,peter22,butterbean,elise1,lucycat,neo123,ferdi,golfer01,randie,gfhfyjbr,ventura1,chelsea3,pinoy,mtgox,yrrim7,shoeman,mirko,ffggyyo,65mustan,ufdibyjd,john55,suckfuck,greatgoo,fvfnjhb,mmmnnn,love20,1bullshi,sucesso,easy1234,robin123,rockets1,diamondb,wolfee,nothing0,joker777,glasnost,richar1,guille,sayan,koresh,goshawk,alexx,batman21,a123456b,hball,243122,rockandr,coolfool,isaia,mary1,yjdbrjdf,lolopc,cleocat,cimbo,lovehina,8vfhnf,passking,bonapart,diamond2,bigboys,kreator,ctvtyjdf,sassy123,shellac,table54781,nedkelly,philbert,sux2bu,nomis,sparky99,python1,littlebear,numpty,silmaril,sweeet,jamesw,cbufhtnf,peggysue,wodahs,luvsex,wizardry,venom123,love4you,bama1,samat,reviewpass,ned467,cjkjdtq,mamula,gijoe,amersham,devochka,redhill,gisel,preggo,polock,cando,rewster,greenlantern,panasonik,dave1234,mikeee,1carlos,miledi,darkness1,p0o9i8u7y6,kathryn1,happyguy,dcp500,assmaster,sambuka,sailormo,antonio3,logans,18254288,nokiax2,qwertzuiop,zavilov,totti,xenon1,edward11,targa1,something1,tony_t,q1w2e3r4t5y6u7i8o9p0,02551670,vladimir1,monkeybutt,greenda,neel21,craiger,saveliy,dei008,honda450,fylhtq95,spike2,fjnq8915,passwordstandard,vova12345,talonesi,richi,gigemags,pierre1,westin,trevoga,dorothee,bastogne,25563o,brandon3,truegrit,krimml,iamgreat,servis,a112233,paulinka,azimuth,corperfmonsy,358hkyp,homerun1,dogbert1,eatmyass,cottage1,savina,baseball7,bigtex,gimmesum,asdcxz,lennon1,a159357,1bastard,413276191q,pngfilt,pchealth,netsnip,bodiroga,1matt,webtvs,ravers,adapters,siddis,mashamasha,coffee2,myhoney,anna1982,marcia1,fairchil,maniek,iloveluc,batmonh,wildon,bowie1,netnwlnk,fancy1,tom204,olga1976,vfif123,queens1,ajax01,lovess,mockba,icam4usb,triada,odinthor,rstlne,exciter,sundog,anchorat,girls69,nfnmzyrf,soloma,gti16v,shadowman,ottom,rataros,tonchin,vishal,chicken0,pornlo,christiaan,volante,likesit,mariupol,runfast,gbpltw123,missys,villevalo,kbpjxrf,ghibli,calla,cessna172,kinglear,dell11,swift1,walera,1cricket,pussy5,turbo911,tucke,maprchem56458,rosehill,thekiwi1,ygfxbkgt,mandarinka,98xa29,magnit,cjfrf,paswoord,grandam1,shenmue,leedsuni,hatrick,zagadka,angeldog,michaell,dance123,koichi,bballs,29palms,xanth,228822,ppppppp1,1kkkkk,1lllll,mynewbots,spurss,madmax1,224455,city1,mmmmmmm1,nnnnnnn1,biedronka,thebeatles,elessar,f14tomcat,jordan18,bobo123,ayi000,tedbear,86chevyx,user123,bobolink,maktub,elmer1,flyfishi,franco1,gandalf0,traxdata,david21,enlighte,dmitrij,beckys,1giants,flippe,12345678w,jossie,rugbyman,snowcat,rapeme,peanut11,gemeni,udders,techn9ne,armani1,chappie,war123,vakantie,maddawg,sewanee,jake5253,tautt1,anthony5,letterma,jimbo2,kmdtyjr,hextall,jessica6,amiga500,hotcunt,phoenix9,veronda,saqartvelo,scubas,sixer3,williamj,nightfal,shihan,melnikova,kosssss,handily,killer77,jhrl0821,march17,rushman,6gcf636i,metoyou,irina123,mine11,primus1,formatters,matthew5,infotech,gangster1,jordan45,moose69,kompas,motoxxx,greatwhi,cobra12,kirpich,weezer1,hello23,montse,tracy123,connecte,cjymrf,hemingwa,azreal,gundam00,mobila,boxman,slayers1,ravshan,june26,fktrcfylhjd,bermuda1,tylerd,maersk,qazwsx11,eybdthcbntn,ash123,camelo,kat123,backd00r,cheyenne1,1king,jerkin,tnt123,trabant,warhammer40k,rambos,punto,home77,pedrito,1frank,brille,guitarman,george13,rakas,tgbxtcrbq,flute1,bananas1,lovezp1314,thespot,postie,buster69,sexytime,twistys,zacharia,sportage,toccata,denver7,terry123,bogdanova,devil69,higgins1,whatluck,pele10,kkk666,jeffery1,1qayxsw2,riptide1,chevy11,munchy,lazer1,hooker1,ghfgjh,vergesse,playgrou,4077mash,gusev,humpin,oneputt,hydepark,monster9,tiger8,tangsoo,guy123,hesoyam1,uhtqneyu,thanku,lomond,ortezza,kronik,geetha,rabbit66,killas,qazxswe,alabaste,1234567890qwerty,capone1,andrea12,geral,beatbox,slutfuck,booyaka,jasmine7,ostsee,maestro1,beatme,tracey1,buster123,donaldduck,ironfish,happy6,konnichi,gintonic,momoney1,dugan1,today2,enkidu,destiny2,trim7gun,katuha,fractals,morganstanley,polkadot,gotime,prince11,204060,fifa2010,bobbyt,seemee,amanda10,airbrush,bigtitty,heidie,layla1,cotton1,5speed,fyfnjkmtdyf,flynavy,joxury8f,meeko,akuma,dudley1,flyboy1,moondog1,trotters,mariami,signin,chinna,legs11,pussy4,1s1h1e1f1,felici,optimus1,iluvu,marlins1,gavaec,balance1,glock40,london01,kokot,southwes,comfort1,sammy11,rockbottom,brianc,litebeer,homero,chopsuey,greenlan,charit,freecell,hampster,smalldog,viper12,blofeld,1234567890987654321,realsex,romann,cartman2,cjdthitycndj,nelly1,bmw528,zwezda,masterba,jeep99,turtl,america2,sunburst,sanyco,auntjudy,125wm,blue10,qwsazx,cartma,toby12,robbob,red222,ilovecock,losfix16,1explore,helge,vaz2114,whynotme,baba123,mugen,1qazwsxedc,albertjr,0101198,sextime,supras,nicolas2,wantsex,pussy6,checkm8,winam,24gordon,misterme,curlew,gbljhfcs,medtech,franzi,butthea,voivod,blackhat,egoiste,pjkeirf,maddog69,pakalolo,hockey4,igor1234,rouges,snowhite,homefree,sexfreak,acer12,dsmith,blessyou,199410,vfrcbvjd,falco02,belinda1,yaglasph,april21,groundho,jasmin1,nevergiveup,elvir,gborv526,c00kie,emma01,awesome2,larina,mike12345,maximu,anupam,bltynbabrfwbz,tanushka,sukkel,raptor22,josh12,schalke04,cosmodog,fuckyou8,busybee,198800,bijoux,frame1,blackmor,giveit,issmall,bear13,123-123,bladez,littlegirl,ultra123,fletch1,flashnet,loploprock,rkelly,12step,lukas1,littlewhore,cuntfinger,stinkyfinger,laurenc,198020,n7td4bjl,jackie69,camel123,ben1234,1gateway,adelheid,fatmike,thuglove,zzaaqq,chivas1,4815162342q,mamadou,nadano,james22,benwin,andrea99,rjirf,michou,abkbgg,d50gnn,aaazzz,a123654,blankman,booboo11,medicus,bigbone,197200,justine1,bendix,morphius,njhvjp,44mag,zsecyus56,goodbye1,nokiadermo,a333444,waratsea,4rzp8ab7,fevral,brillian,kirbys,minim,erathia,grazia,zxcvb1234,dukey,snaggle,poppi,hymen,1video,dune2000,jpthjdf,cvbn123,zcxfcnkbdfz,astonv,ginnie,316271,engine3,pr1ncess,64chevy,glass1,laotzu,hollyy,comicbooks,assasins,nuaddn9561,scottsda,hfcnfvfy,accobra,7777777z,werty123,metalhead,romanson,redsand,365214,shalo,arsenii,1989cc,sissi,duramax,382563,petera,414243,mamapap,jollymon,field1,fatgirl,janets,trompete,matchbox20,rambo2,nepenthe,441232,qwertyuiop10,bozo123,phezc419hv,romantika,lifestyl,pengui,decembre,demon6,panther6,444888,scanman,ghjcnjabkz,pachanga,buzzword,indianer,spiderman3,tony12,startre,frog1,fyutk,483422,tupacshakur,albert12,1drummer,bmw328i,green17,aerdna,invisibl,summer13,calimer,mustaine,lgnu9d,morefun,hesoyam123,escort1,scrapland,stargat,barabbas,dead13,545645,mexicali,sierr,gfhfpbn,gonchar,moonstafa,searock,counte,foster1,jayhawk1,floren,maremma,nastya2010,softball1,adaptec,halloo,barrabas,zxcasd123,hunny,mariana1,kafedra,freedom0,green420,vlad1234,method7,665566,tooting,hallo12,davinchi,conducto,medias,666444,invernes,madhatter,456asd,12345678i,687887,le33px,spring00,help123,bellybut,billy5,vitalik1,river123,gorila,bendis,power666,747200,footslav,acehigh,qazxswedc123,q1a1z1,richard9,peterburg,tabletop,gavrilov,123qwe1,kolosov,fredrau,run4fun,789056,jkbvgbflf,chitra,87654321q,steve22,wideopen,access88,surfe,tdfyutkbjy,impossib,kevin69,880888,cantina,887766,wxcvb,dontforg,qwer1209,asslicke,mamma123,indig,arkasha,scrapp,morelia,vehxbr,jones2,scratch1,cody11,cassie12,gerbera,dontgotm,underhil,maks2010,hollywood1,hanibal,elena2010,jason11,1010321,stewar,elaman,fireplug,goodby,sacrific,babyphat,bobcat12,bruce123,1233215,tony45,tiburo,love15,bmw750,wallstreet,2h0t4me,1346795,lamerz,munkee,134679q,granvill,1512198,armastus,aiden1,pipeutvj,g1234567,angeleyes,usmc1,102030q,putangina,brandnew,shadowfax,eagles12,1falcon,brianw,lokomoti,2022958,scooper,pegas,jabroni1,2121212,buffal,siffredi,wewiz,twotone,rosebudd,nightwis,carpet1,mickey2,2525252,sleddog,red333,jamesm,2797349,jeff12,onizuka,felixxxx,rf6666,fine1,ohlala,forplay,chicago5,muncho,scooby11,ptichka,johnnn,19851985p,dogphil3650,totenkopf,monitor2,macross7,3816778,dudder,semaj1,bounder,racerx1,5556633,7085506,ofclr278,brody1,7506751,nantucke,hedj2n4q,drew1,aessedai,trekbike,pussykat,samatron,imani,9124852,wiley1,dukenukem,iampurehaha2,9556035,obvious1,mccool24,apache64,kravchenko,justforf,basura,jamese,s0ccer,safado,darksta,surfer69,damian1,gjpbnbd,gunny1,wolley,sananton,zxcvbn123456,odt4p6sv8,sergei1,modem1,mansikka,zzzz1,rifraf,dima777,mary69,looking4,donttell,red100,ninjutsu,uaeuaeman,bigbri,brasco,queenas8151,demetri,angel007,bubbl,kolort,conny,antonia1,avtoritet,kaka22,kailayu,sassy2,wrongway,chevy3,1nascar,patriots1,chrisrey,mike99,sexy22,chkdsk,sd3utre7,padawan,a6pihd,doming,mesohorny,tamada,donatello,emma22,eather,susan69,pinky123,stud69,fatbitch,pilsbury,thc420,lovepuss,1creativ,golf1234,hurryup,1honda,huskerdu,marino1,gowron,girl1,fucktoy,gtnhjpfdjlcr,dkjfghdk,pinkfl,loreli,7777777s,donkeykong,rockytop,staples1,sone4ka,xxxjay,flywheel,toppdogg,bigbubba,aaa123456,2letmein,shavkat,paule,dlanor,adamas,0147852,aassaa,dixon1,bmw328,mother12,ilikepussy,holly2,tsmith,excaliber,fhutynbyf,nicole3,tulipan,emanue,flyvholm,currahee,godsgift,antonioj,torito,dinky1,sanna,yfcnzvjz,june14,anime123,123321456654,hanswurst,bandman,hello101,xxxyyy,chevy69,technica,tagada,arnol,v00d00,lilone,filles,drumandbass,dinamit,a1234a,eatmeat,elway07,inout,james6,dawid1,thewolf,diapason,yodaddy,qscwdv,fuckit1,liljoe,sloeber,simbacat,sascha1,qwe1234,1badger,prisca,angel17,gravedig,jakeyboy,longboard,truskawka,golfer11,pyramid7,highspee,pistola,theriver,hammer69,1packers,dannyd,alfonse,qwertgfdsa,11119999,basket1,ghjtrn,saralee,12inches,paolo1,zse4xdr5,taproot,sophieh6,grizzlie,hockey69,danang,biggums,hotbitch,5alive,beloved1,bluewave,dimon95,koketka,multiscan,littleb,leghorn,poker2,delite,skyfir,bigjake,persona1,amberdog,hannah12,derren,ziffle,1sarah,1assword,sparky01,seymur,tomtom1,123321qw,goskins,soccer19,luvbekki,bumhole,2balls,1muffin,borodin,monkey9,yfeiybrb,1alex,betmen,freder,nigger123,azizbek,gjkzrjdf,lilmike,1bigdadd,1rock,taganrog,snappy1,andrey1,kolonka,bunyan,gomango,vivia,clarkkent,satur,gaudeamus,mantaray,1month,whitehea,fargus,andrew99,ray123,redhawks,liza2009,qw12345,den12345,vfhnsyjdf,147258369a,mazepa,newyorke,1arsenal,hondas2000,demona,fordgt,steve12,birthday2,12457896,dickster,edcwsxqaz,sahalin,pantyman,skinny1,hubertus,cumshot1,chiro,kappaman,mark3434,canada12,lichking,bonkers1,ivan1985,sybase,valmet,doors1,deedlit,kyjelly,bdfysx,ford11,throatfuck,backwood,fylhsq,lalit,boss429,kotova,bricky,steveh,joshua19,kissa,imladris,star1234,lubimka,partyman,crazyd,tobias1,ilike69,imhome,whome,fourstar,scanner1,ujhjl312,anatoli,85bears,jimbo69,5678ytr,potapova,nokia7070,sunday1,kalleank,1996gta,refinnej,july1,molodec,nothanks,enigm,12play,sugardog,nhfkbdfkb,larousse,cannon1,144444,qazxcdew,stimorol,jhereg,spawn7,143000,fearme,hambur,merlin21,dobie,is3yeusc,partner1,dekal,varsha,478jfszk,flavi,hippo1,9hmlpyjd,july21,7imjfstw,lexxus,truelov,nokia5200,carlos6,anais,mudbone,anahit,taylorc,tashas,larkspur,animal2000,nibiru,jan123,miyvarxar,deflep,dolore,communit,ifoptfcor,laura2,anadrol,mamaliga,mitzi1,blue92,april15,matveev,kajlas,wowlook1,1flowers,shadow14,alucard1,1golf,bantha,scotlan,singapur,mark13,manchester1,telus01,superdav,jackoff1,madnes,bullnuts,world123,clitty,palmer1,david10,spider10,sargsyan,rattlers,david4,windows2,sony12,visigoth,qqqaaa,penfloor,cabledog,camilla1,natasha123,eagleman,softcore,bobrov,dietmar,divad,sss123,d1234567,tlbyjhju,1q1q1q1,paraiso,dav123,lfiekmrf,drachen,lzhan16889,tplate,gfghbrf,casio1,123boots1,123test,sys64738,heavymetal,andiamo,meduza,soarer,coco12,negrita,amigas,heavymet,bespin,1asdfghj,wharfrat,wetsex,tight1,janus1,sword123,ladeda,dragon98,austin2,atep1,jungle1,12345abcd,lexus300,pheonix1,alex1974,123qw123,137955,bigtim,shadow88,igor1994,goodjob,arzen,champ123,121ebay,changeme1,brooksie,frogman1,buldozer,morrowin,achim,trish1,lasse,festiva,bubbaman,scottb,kramit,august22,tyson123,passsword,oompah,al123456,fucking1,green45,noodle1,looking1,ashlynn,al1716,stang50,coco11,greese,bob111,brennan1,jasonj,1cherry,1q2345,1xxxxxxx,fifa2011,brondby,zachar1,satyam,easy1,magic7,1rainbow,cheezit,1eeeeeee,ashley123,assass1,amanda123,jerbear,1bbbbbb,azerty12,15975391,654321z,twinturb,onlyone1,denis1988,6846kg3r,jumbos,pennydog,dandelion,haileris,epervier,snoopy69,afrodite,oldpussy,green55,poopypan,verymuch,katyusha,recon7,mine69,tangos,contro,blowme2,jade1,skydive1,fiveiron,dimo4ka,bokser,stargirl,fordfocus,tigers2,platina,baseball11,raque,pimper,jawbreak,buster88,walter34,chucko,penchair,horizon1,thecure1,scc1975,adrianna1,kareta,duke12,krille,dumbfuck,cunt1,aldebaran,laverda,harumi,knopfler,pongo1,pfhbyf,dogman1,rossigno,1hardon,scarlets,nuggets1,ibelieve,akinfeev,xfhkbr,athene,falcon69,happie,billly,nitsua,fiocco,qwerty09,gizmo2,slava2,125690,doggy123,craigs,vader123,silkeborg,124365,peterm,123978,krakatoa,123699,123592,kgvebmqy,pensacol,d1d2d3,snowstor,goldenboy,gfg65h7,ev700,church1,orange11,g0dz1ll4,chester3,acheron,cynthi,hotshot1,jesuschris,motdepass,zymurgy,one2one,fietsbel,harryp,wisper,pookster,nn527hp,dolla,milkmaid,rustyboy,terrell1,epsilon1,lillian1,dale3,crhbgrf,maxsim,selecta,mamada,fatman1,ufkjxrf,shinchan,fuckuall,women1,000008,bossss,greta1,rbhjxrf,mamasboy,purple69,felicidade,sexy21,cathay,hunglow,splatt,kahless,shopping1,1gandalf,themis,delta7,moon69,blue24,parliame,mamma1,miyuki,2500hd,jackmeof,razer,rocker1,juvis123,noremac,boing747,9z5ve9rrcz,icewater,titania,alley1,moparman,christo1,oliver2,vinicius,tigerfan,chevyy,joshua99,doda99,matrixx,ekbnrf,jackfrost,viper01,kasia,cnfhsq,triton1,ssbt8ae2,rugby8,ramman,1lucky,barabash,ghtlfntkm,junaid,apeshit,enfant,kenpo1,shit12,007000,marge1,shadow10,qwerty789,richard8,vbitkm,lostboys,jesus4me,richard4,hifive,kolawole,damilola,prisma,paranoya,prince2,lisaann,happyness,cardss,methodma,supercop,a8kd47v5,gamgee,polly123,irene1,number8,hoyasaxa,1digital,matthew0,dclxvi,lisica,roy123,2468013579,sparda,queball,vaffanculo,pass1wor,repmvbx,999666333,freedom8,botanik,777555333,marcos1,lubimaya,flash2,einstei,08080,123456789j,159951159,159357123,carrot1,alina1995,sanjos,dilara,mustang67,wisteria,jhnjgtl12,98766789,darksun,arxangel,87062134,creativ1,malyshka,fuckthemall,barsic,rocksta,2big4u,5nizza,genesis2,romance1,ofcourse,1horse,latenite,cubana,sactown,789456123a,milliona,61808861,57699434,imperia,bubba11,yellow3,change12,55495746,flappy,jimbo123,19372846,19380018,cutlass1,craig123,klepto,beagle1,solus,51502112,pasha1,19822891,46466452,19855891,petshop,nikolaevna,119966,nokia6131,evenpar,hoosier1,contrasena,jawa350,gonzo123,mouse2,115511,eetfuk,gfhfvgfvgfv,1crystal,sofaking,coyote1,kwiatuszek,fhrflbq,valeria1,anthro,0123654789,alltheway,zoltar,maasikas,wildchil,fredonia,earlgrey,gtnhjczy,matrix123,solid1,slavko,12monkeys,fjdksl,inter1,nokia6500,59382113kevinp,spuddy,cachero,coorslit,password!,kiba1z,karizma,vova1994,chicony,english1,bondra12,1rocket,hunden,jimbob1,zpflhjn1,th0mas,deuce22,meatwad,fatfree,congas,sambora,cooper2,janne,clancy1,stonie,busta,kamaz,speedy2,jasmine3,fahayek,arsenal0,beerss,trixie1,boobs69,luansantana,toadman,control2,ewing33,maxcat,mama1964,diamond4,tabaco,joshua0,piper2,music101,guybrush,reynald,pincher,katiebug,starrs,pimphard,frontosa,alex97,cootie,clockwor,belluno,skyeseth,booty69,chaparra,boochie,green4,bobcat1,havok,saraann,pipeman,aekdb,jumpshot,wintermu,chaika,1chester,rjnjatq,emokid,reset1,regal1,j0shua,134679a,asmodey,sarahh,zapidoo,ciccione,sosexy,beckham23,hornets1,alex1971,delerium,manageme,connor11,1rabbit,sane4ek,caseyboy,cbljhjdf,redsox20,tttttt99,haustool,ander,pantera6,passwd1,journey1,9988776655,blue135,writerspace,xiaoyua123,justice2,niagra,cassis,scorpius,bpgjldsgjldthnf,gamemaster,bloody1,retrac,stabbin,toybox,fight1,ytpyf.,glasha,va2001,taylor11,shameles,ladylove,10078,karmann,rodeos,eintritt,lanesra,tobasco,jnrhjqcz,navyman,pablit,leshka,jessica3,123vika,alena1,platinu,ilford,storm7,undernet,sasha777,1legend,anna2002,kanmax1994,porkpie,thunder0,gundog,pallina,easypass,duck1,supermom,roach1,twincam,14028,tiziano,qwerty32,123654789a,evropa,shampoo1,yfxfkmybr,cubby1,tsunami1,fktrcttdf,yasacrac,17098,happyhap,bullrun,rodder,oaktown,holde,isbest,taylor9,reeper,hammer11,julias,rolltide1,compaq123,fourx4,subzero1,hockey9,7mary3,busines,ybrbnjcbr,wagoneer,danniash,portishead,digitex,alex1981,david11,infidel,1snoopy,free30,jaden,tonto1,redcar27,footie,moskwa,thomas21,hammer12,burzum,cosmo123,50000,burltree,54343,54354,vwpassat,jack5225,cougars1,burlpony,blackhorse,alegna,petert,katemoss,ram123,nels0n,ferrina,angel77,cstock,1christi,dave55,abc123a,alex1975,av626ss,flipoff,folgore,max1998,science1,si711ne,yams7,wifey1,sveiks,cabin1,volodia,ox3ford,cartagen,platini,picture1,sparkle1,tiedomi,service321,wooody,christi1,gnasher,brunob,hammie,iraffert,bot2010,dtcyeirf,1234567890p,cooper11,alcoholi,savchenko,adam01,chelsea5,niewiem,icebear,lllooottt,ilovedick,sweetpus,money8,cookie13,rfnthbyf1988,booboo2,angus123,blockbus,david9,chica1,nazaret,samsung9,smile4u,daystar,skinnass,john10,thegirl,sexybeas,wasdwasd1,sigge1,1qa2ws3ed4rf5tg,czarny,ripley1,chris5,ashley19,anitha,pokerman,prevert,trfnthby,tony69,georgia2,stoppedb,qwertyuiop12345,miniclip,franky1,durdom,cabbages,1234567890o,delta5,liudmila,nhfycajhvths,court1,josiew,abcd1,doghead,diman,masiania,songline,boogle,triston,deepika,sexy4me,grapple,spacebal,ebonee,winter0,smokewee,nargiza,dragonla,sassys,andy2000,menards,yoshio,massive1,suckmy1k,passat99,sexybo,nastya1996,isdead,stratcat,hokuto,infix,pidoras,daffyduck,cumhard,baldeagl,kerberos,yardman,shibainu,guitare,cqub6553,tommyy,bk.irf,bigfoo,hecto,july27,james4,biggus,esbjerg,isgod,1irish,phenmarr,jamaic,roma1990,diamond0,yjdbrjd,girls4me,tampa1,kabuto,vaduz,hanse,spieng,dianochka,csm101,lorna1,ogoshi,plhy6hql,2wsx4rfv,cameron0,adebayo,oleg1996,sharipov,bouboule,hollister1,frogss,yeababy,kablam,adelante,memem,howies,thering,cecilia1,onetwo12,ojp123456,jordan9,msorcloledbr,neveraga,evh5150,redwin,1august,canno,1mercede,moody1,mudbug,chessmas,tiikeri,stickdaddy77,alex15,kvartira,7654321a,lollol123,qwaszxedc,algore,solana,vfhbyfvfhbyf,blue72,misha1111,smoke20,junior13,mogli,threee,shannon2,fuckmylife,kevinh,saransk,karenw,isolde,sekirarr,orion123,thomas0,debra1,laketaho,alondra,curiva,jazz1234,1tigers,jambos,lickme2,suomi,gandalf7,028526,zygote,brett123,br1ttany,supafly,159000,kingrat,luton1,cool-ca,bocman,thomasd,skiller,katter,mama777,chanc,tomass,1rachel,oldno7,rfpfyjdf,bigkev,yelrah,primas,osito,kipper1,msvcr71,bigboy11,thesun,noskcaj,chicc,sonja1,lozinka,mobile1,1vader,ummagumma,waves1,punter12,tubgtn,server1,irina1991,magic69,dak001,pandemonium,dead1,berlingo,cherrypi,1montana,lohotron,chicklet,asdfgh123456,stepside,ikmvw103,icebaby,trillium,1sucks,ukrnet,glock9,ab12345,thepower,robert8,thugstools,hockey13,buffon,livefree,sexpics,dessar,ja0000,rosenrot,james10,1fish,svoloch,mykitty,muffin11,evbukb,shwing,artem1992,andrey1992,sheldon1,passpage,nikita99,fubar123,vannasx,eight888,marial,max2010,express2,violentj,2ykn5ccf,spartan11,brenda69,jackiech,abagail,robin2,grass1,andy76,bell1,taison,superme,vika1995,xtr451,fred20,89032073168,denis1984,2000jeep,weetabix,199020,daxter,tevion,panther8,h9iymxmc,bigrig,kalambur,tsalagi,12213443,racecar02,jeffrey4,nataxa,bigsam,purgator,acuracl,troutbum,potsmoke,jimmyz,manutd1,nytimes,pureevil,bearss,cool22,dragonage,nodnarb,dbrbyu,4seasons,freude,elric1,werule,hockey14,12758698,corkie,yeahright,blademan,tafkap,clave,liziko,hofner,jeffhardy,nurich,runne,stanisla,lucy1,monk3y,forzaroma,eric99,bonaire,blackwoo,fengshui,1qaz0okm,newmoney,pimpin69,07078,anonymer,laptop1,cherry12,ace111,salsa1,wilbur1,doom12,diablo23,jgtxzbhr,under1,honda01,breadfan,megan2,juancarlos,stratus1,ackbar,love5683,happytim,lambert1,cbljhtyrj,komarov,spam69,nfhtkrf,brownn,sarmat,ifiksr,spike69,hoangen,angelz,economia,tanzen,avogadro,1vampire,spanners,mazdarx,queequeg,oriana,hershil,sulaco,joseph11,8seconds,aquariu,cumberla,heather9,anthony8,burton12,crystal0,maria3,qazwsxc,snow123,notgood,198520,raindog,heehaw,consulta,dasein,miller01,cthulhu1,dukenuke,iubire,baytown,hatebree,198505,sistem,lena12,welcome01,maraca,middleto,sindhu,mitsou,phoenix5,vovan,donaldo,dylandog,domovoy,lauren12,byrjuybnj,123llll,stillers,sanchin,tulpan,smallvill,1mmmmm,patti1,folgers,mike31,colts18,123456rrr,njkmrjz,phoenix0,biene,ironcity,kasperok,password22,fitnes,matthew6,spotligh,bujhm123,tommycat,hazel5,guitar11,145678,vfcmrf,compass1,willee,1barney,jack2000,littleminge,shemp,derrek,xxx12345,littlefuck,spuds1,karolinka,camneely,qwertyu123,142500,brandon00,munson15,falcon3,passssap,z3cn2erv,goahead,baggio10,141592,denali1,37kazoo,copernic,123456789asd,orange88,bravada,rush211,197700,pablo123,uptheass,samsam1,demoman,mattylad10,heydude,mister2,werken,13467985,marantz,a22222,f1f2f3f4,fm12mn12,gerasimova,burrito1,sony1,glenny,baldeagle,rmfidd,fenomen,verbati,forgetme,5element,wer138,chanel1,ooicu812,10293847qp,minicooper,chispa,myturn,deisel,vthrehbq,boredboi4u,filatova,anabe,poiuyt1,barmalei,yyyy1,fourkids,naumenko,bangbros,pornclub,okaykk,euclid90,warrior3,kornet,palevo,patatina,gocart,antanta,jed1054,clock1,111111w,dewars,mankind1,peugeot406,liten,tahira,howlin,naumov,rmracing,corone,cunthole,passit,rock69,jaguarxj,bumsen,197101,sweet2,197010,whitecat,sawadee,money100,yfhrjnbrb,andyboy,9085603566,trace1,fagget,robot1,angel20,6yhn7ujm,specialinsta,kareena,newblood,chingada,boobies2,bugger1,squad51,133andre,call06,ashes1,ilovelucy,success2,kotton,cavalla,philou,deebee,theband,nine09,artefact,196100,kkkkkkk1,nikolay9,onelov,basia,emilyann,sadman,fkrjujkbr,teamomuch,david777,padrino,money21,firdaus,orion3,chevy01,albatro,erdfcv,2legit,sarah7,torock,kevinn,holio,soloy,enron714,starfleet,qwer11,neverman,doctorwh,lucy11,dino12,trinity7,seatleon,o123456,pimpman,1asdfgh,snakebit,chancho,prorok,bleacher,ramire,darkseed,warhorse,michael123,1spanky,1hotdog,34erdfcv,n0th1ng,dimanche,repmvbyf,michaeljackson,login1,icequeen,toshiro,sperme,racer2,veget,birthday26,daniel9,lbvekmrf,charlus,bryan123,wspanic,schreibe,1andonly,dgoins,kewell,apollo12,egypt1,fernie,tiger21,aa123456789,blowj,spandau,bisquit,12345678d,deadmau5,fredie,311420,happyface,samant,gruppa,filmstar,andrew17,bakesale,sexy01,justlook,cbarkley,paul11,bloodred,rideme,birdbath,nfkbcvfy,jaxson,sirius1,kristof,virgos,nimrod1,hardc0re,killerbee,1abcdef,pitcher1,justonce,vlada,dakota99,vespucci,wpass,outside1,puertori,rfvbkf,teamlosi,vgfun2,porol777,empire11,20091989q,jasong,webuivalidat,escrima,lakers08,trigger2,addpass,342500,mongini,dfhtybr,horndogg,palermo1,136900,babyblu,alla98,dasha2010,jkelly,kernow,yfnecz,rockhopper,toeman,tlaloc,silver77,dave01,kevinr,1234567887654321,135642,me2you,8096468644q,remmus,spider7,jamesa,jilly,samba1,drongo,770129ji,supercat,juntas,tema1234,esthe,1234567892000,drew11,qazqaz123,beegees,blome,rattrace,howhigh,tallboy,rufus2,sunny2,sou812,miller12,indiana7,irnbru,patch123,letmeon,welcome5,nabisco,9hotpoin,hpvteb,lovinit,stormin,assmonke,trill,atlanti,money1234,cubsfan,mello1,stars2,ueptkm,agate,dannym88,lover123,wordz,worldnet,julemand,chaser1,s12345678,pissword,cinemax,woodchuc,point1,hotchkis,packers2,bananana,kalender,420666,penguin8,awo8rx3wa8t,hoppie,metlife,ilovemyfamily,weihnachtsbau,pudding1,luckystr,scully1,fatboy1,amizade,dedham,jahbless,blaat,surrende,****er,1panties,bigasses,ghjuhfvbcn,asshole123,dfktyrb,likeme,nickers,plastik,hektor,deeman,muchacha,cerebro,santana5,testdrive,dracula1,canalc,l1750sq,savannah1,murena,1inside,pokemon00,1iiiiiii,jordan20,sexual1,mailliw,calipso,014702580369,1zzzzzz,1jjjjjj,break1,15253545,yomama1,katinka,kevin11,1ffffff,martijn,sslazio,daniel5,porno2,nosmas,leolion,jscript,15975312,pundai,kelli1,kkkddd,obafgkm,marmaris,lilmama,london123,rfhfnt,elgordo,talk87,daniel7,thesims3,444111,bishkek,afrika2002,toby22,1speedy,daishi,2children,afroman,qqqqwwww,oldskool,hawai,v55555,syndicat,pukimak,fanatik,tiger5,parker01,bri5kev6,timexx,wartburg,love55,ecosse,yelena03,madinina,highway1,uhfdbwfgf,karuna,buhjvfybz,wallie,46and2,khalif,europ,qaz123wsx456,bobbybob,wolfone,falloutboy,manning18,scuba10,schnuff,ihateyou1,lindam,sara123,popcor,fallengun,divine1,montblanc,qwerty8,rooney10,roadrage,bertie1,latinus,lexusis,rhfvfnjhcr,opelgt,hitme,agatka,1yamaha,dmfxhkju,imaloser,michell1,sb211st,silver22,lockedup,andrew9,monica01,sassycat,dsobwick,tinroof,ctrhtnyj,bultaco,rhfcyjzhcr,aaaassss,14ss88,joanne1,momanddad,ahjkjdf,yelhsa,zipdrive,telescop,500600,1sexsex,facial1,motaro,511647,stoner1,temujin,elephant1,greatman,honey69,kociak,ukqmwhj6,altezza,cumquat,zippos,kontiki,123max,altec1,bibigon,tontos,qazsew,nopasaran,militar,supratt,oglala,kobayash,agathe,yawetag,dogs1,cfiekmrf,megan123,jamesdea,porosenok,tiger23,berger1,hello11,seemann,stunner1,walker2,imissu,jabari,minfd,lollol12,hjvfy,1-oct,stjohns,2278124q,123456789qwer,alex1983,glowworm,chicho,mallards,bluedevil,explorer1,543211,casita,1time,lachesis,alex1982,airborn1,dubesor,changa,lizzie1,captaink,socool,bidule,march23,1861brr,k.ljxrf,watchout,fotze,1brian,keksa2,aaaa1122,matrim,providian,privado,dreame,merry1,aregdone,davidt,nounour,twenty2,play2win,artcast2,zontik,552255,shit1,sluggy,552861,dr8350,brooze,alpha69,thunder6,kamelia2011,caleb123,mmxxmm,jamesh,lfybkjd,125267,125000,124536,bliss1,dddsss,indonesi,bob69,123888,tgkbxfgy,gerar,themack,hijodeputa,good4now,ddd123,clk430,kalash,tolkien1,132forever,blackb,whatis,s1s2s3s4,lolkin09,yamahar,48n25rcc,djtiesto,111222333444555,bigbull,blade55,coolbree,kelse,ichwill,yamaha12,sakic,bebeto,katoom,donke,sahar,wahine,645202,god666,berni,starwood,june15,sonoio,time123,llbean,deadsoul,lazarev,cdtnf,ksyusha,madarchod,technik,jamesy,4speed,tenorsax,legshow,yoshi1,chrisbl,44e3ebda,trafalga,heather7,serafima,favorite4,havefun1,wolve,55555r,james13,nosredna,bodean,jlettier,borracho,mickael,marinus,brutu,sweet666,kiborg,rollrock,jackson6,macross1,ousooner,9085084232,takeme,123qwaszx,firedept,vfrfhjd,jackfros,123456789000,briane,cookie11,baby22,bobby18,gromova,systemofadown,martin01,silver01,pimaou,darthmaul,hijinx,commo,chech,skyman,sunse,2vrd6,vladimirovna,uthvfybz,nicole01,kreker,bobo1,v123456789,erxtgb,meetoo,drakcap,vfvf12,misiek1,butane,network2,flyers99,riogrand,jennyk,e12345,spinne,avalon11,lovejone,studen,maint,porsche2,qwerty100,chamberl,bluedog1,sungam,just4u,andrew23,summer22,ludic,musiclover,aguil,beardog1,libertin,pippo1,joselit,patito,bigberth,digler,sydnee,jockstra,poopo,jas4an,nastya123,profil,fuesse,default1,titan2,mendoz,kpcofgs,anamika,brillo021,bomberman,guitar69,latching,69pussy,blues2,phelge,ninja123,m7n56xo,qwertasd,alex1976,cunningh,estrela,gladbach,marillion,mike2000,258046,bypop,muffinman,kd5396b,zeratul,djkxbwf,john77,sigma2,1linda,selur,reppep,quartz1,teen1,freeclus,spook1,kudos4ever,clitring,sexiness,blumpkin,macbook,tileman,centra,escaflowne,pentable,shant,grappa,zverev,1albert,lommerse,coffee11,777123,polkilo,muppet1,alex74,lkjhgfdsazx,olesica,april14,ba25547,souths,jasmi,arashi,smile2,2401pedro,mybabe,alex111,quintain,pimp1,tdeir8b2,makenna,122333444455555,%e2%82%ac,tootsie1,pass111,zaqxsw123,gkfdfybt,cnfnbcnbrf,usermane,iloveyou12,hard69,osasuna,firegod,arvind,babochka,kiss123,cookie123,julie123,kamakazi,dylan2,223355,tanguy,nbhtqa,tigger13,tubby1,makavel,asdflkj,sambo1,mononoke,mickeys,gayguy,win123,green33,wcrfxtvgbjy,bigsmall,1newlife,clove,babyfac,bigwaves,mama1970,shockwav,1friday,bassey,yarddog,codered1,victory7,bigrick,kracker,gulfstre,chris200,sunbanna,bertuzzi,begemotik,kuolema,pondus,destinee,123456789zz,abiodun,flopsy,amadeusptfcor,geronim,yggdrasi,contex,daniel6,suck1,adonis1,moorea,el345612,f22raptor,moviebuf,raunchy,6043dkf,zxcvbnm123456789,eric11,deadmoin,ratiug,nosliw,fannies,danno,888889,blank1,mikey2,gullit,thor99,mamiya,ollieb,thoth,dagger1,websolutionssu,bonker,prive,1346798520,03038,q1234q,mommy2,contax,zhipo,gwendoli,gothic1,1234562000,lovedick,gibso,digital2,space199,b26354,987654123,golive,serious1,pivkoo,better1,824358553,794613258,nata1980,logout,fishpond,buttss,squidly,good4me,redsox19,jhonny,zse45rdx,matrixxx,honey12,ramina,213546879,motzart,fall99,newspape,killit,gimpy,photowiz,olesja,thebus,marco123,147852963,bedbug,147369258,hellbound,gjgjxrf,123987456,lovehurt,five55,hammer01,1234554321a,alina2011,peppino,ang238,questor,112358132,alina1994,alina1998,money77,bobjones,aigerim,cressida,madalena,420smoke,tinchair,raven13,mooser,mauric,lovebu,adidas69,krypton1,1111112,loveline,divin,voshod,michaelm,cocotte,gbkbuhbv,76689295,kellyj,rhonda1,sweetu70,steamforums,geeque,nothere,124c41,quixotic,steam181,1169900,rfcgthcrbq,rfvbkm,sexstuff,1231230,djctvm,rockstar1,fulhamfc,bhecbr,rfntyf,quiksilv,56836803,jedimaster,pangit,gfhjkm777,tocool,1237654,stella12,55378008,19216811,potte,fender12,mortalkombat,ball1,nudegirl,palace22,rattrap,debeers,lickpussy,jimmy6,not4u2c,wert12,bigjuggs,sadomaso,1357924,312mas,laser123,arminia,branford,coastie,mrmojo,19801982,scott11,banaan123,ingres,300zxtt,hooters6,sweeties,19821983,19831985,19833891,sinnfein,welcome4,winner69,killerman,tachyon,tigre1,nymets1,kangol,martinet,sooty1,19921993,789qwe,harsingh,1597535,thecount,phantom3,36985214,lukas123,117711,pakistan1,madmax11,willow01,19932916,fucker12,flhrci,opelagila,theword,ashley24,tigger3,crazyj,rapide,deadfish,allana,31359092,sasha1993,sanders2,discman,zaq!2wsx,boilerma,mickey69,jamesg,babybo,jackson9,orion7,alina2010,indien,breeze1,atease,warspite,bazongaz,1celtic,asguard,mygal,fitzgera,1secret,duke33,cyklone,dipascuc,potapov,1escobar2,c0l0rad0,kki177hk,1little,macondo,victoriya,peter7,red666,winston6,kl?benhavn,muneca,jackme,jennan,happylife,am4h39d8nh,bodybuil,201980,dutchie,biggame,lapo4ka,rauchen,black10,flaquit,water12,31021364,command2,lainth88,mazdamx5,typhon,colin123,rcfhlfc,qwaszx11,g0away,ramir,diesirae,hacked1,cessna1,woodfish,enigma2,pqnr67w5,odgez8j3,grisou,hiheels,5gtgiaxm,2580258,ohotnik,transits,quackers,serjik,makenzie,mdmgatew,bryana,superman12,melly,lokit,thegod,slickone,fun4all,netpass,penhorse,1cooper,nsync,asdasd22,otherside,honeydog,herbie1,chiphi,proghouse,l0nd0n,shagg,select1,frost1996,casper123,countr,magichat,greatzyo,jyothi,3bears,thefly,nikkita,fgjcnjk,nitros,hornys,san123,lightspe,maslova,kimber1,newyork2,spammm,mikejone,pumpk1n,bruiser1,bacons,prelude9,boodie,dragon4,kenneth2,love98,power5,yodude,pumba,thinline,blue30,sexxybj,2dumb2live,matt21,forsale,1carolin,innova,ilikeporn,rbgtkjd,a1s2d3f,wu9942,ruffus,blackboo,qwerty999,draco1,marcelin,hideki,gendalf,trevon,saraha,cartmen,yjhbkmcr,time2go,fanclub,ladder1,chinni,6942987,united99,lindac,quadra,paolit,mainstre,beano002,lincoln7,bellend,anomie,8520456,bangalor,goodstuff,chernov,stepashka,gulla,mike007,frasse,harley03,omnislash,8538622,maryjan,sasha2011,gineok,8807031,hornier,gopinath,princesit,bdr529,godown,bosslady,hakaone,1qwe2,madman1,joshua11,lovegame,bayamon,jedi01,stupid12,sport123,aaa666,tony44,collect1,charliem,chimaira,cx18ka,trrim777,chuckd,thedream,redsox99,goodmorning,delta88,iloveyou11,newlife2,figvam,chicago3,jasonk,12qwer,9875321,lestat1,satcom,conditio,capri50,sayaka,9933162,trunks1,chinga,snooch,alexand1,findus,poekie,cfdbyf,kevind,mike1969,fire13,leftie,bigtuna,chinnu,silence1,celos1,blackdra,alex24,gfgfif,2boobs,happy8,enolagay,sataniv1993,turner1,dylans,peugeo,sasha1994,hoppel,conno,moonshot,santa234,meister1,008800,hanako,tree123,qweras,gfitymrf,reggie31,august29,supert,joshua10,akademia,gbljhfc,zorro123,nathalia,redsox12,hfpdjl,mishmash,nokiae51,nyyankees,tu190022,strongbo,none1,not4u2no,katie2,popart,harlequi,santan,michal1,1therock,screwu,csyekmrf,olemiss1,tyrese,hoople,sunshin1,cucina,starbase,topshelf,fostex,california1,castle1,symantec,pippolo,babare,turntabl,1angela,moo123,ipvteb,gogolf,alex88,cycle1,maxie1,phase2,selhurst,furnitur,samfox,fromvermine,shaq34,gators96,captain2,delonge,tomatoe,bisous,zxcvbnma,glacius,pineapple1,cannelle,ganibal,mko09ijn,paraklast1974,hobbes12,petty43,artema,junior8,mylover,1234567890d,fatal1ty,prostreet,peruan,10020,nadya,caution1,marocas,chanel5,summer08,metal123,111lox,scrapy,thatguy,eddie666,washingto,yannis,minnesota_hp,lucky4,playboy6,naumova,azzurro,patat,dale33,pa55wd,speedster,zemanova,saraht,newto,tony22,qscesz,arkady,1oliver,death6,vkfwx046,antiflag,stangs,jzf7qf2e,brianp,fozzy,cody123,startrek1,yoda123,murciela,trabajo,lvbnhbtdf,canario,fliper,adroit,henry5,goducks,papirus,alskdj,soccer6,88mike,gogetter,tanelorn,donking,marky1,leedsu,badmofo,al1916,wetdog,akmaral,pallet,april24,killer00,nesterova,rugby123,coffee12,browseui,ralliart,paigow,calgary1,armyman,vtldtltd,frodo2,frxtgb,iambigal,benno,jaytee,2hot4you,askar,bigtee,brentwoo,palladin,eddie2,al1916w,horosho,entrada,ilovetits,venture1,dragon19,jayde,chuvak,jamesl,fzr600,brandon8,vjqvbh,snowbal,snatch1,bg6njokf,pudder,karolin,candoo,pfuflrf,satchel1,manteca,khongbiet,critter1,partridg,skyclad,bigdon,ginger69,brave1,anthony4,spinnake,chinadol,passout,cochino,nipples1,15058,lopesk,sixflags,lloo999,parkhead,breakdance,cia123,fidodido,yuitre12,fooey,artem1995,gayathri,medin,nondriversig,l12345,bravo7,happy13,kazuya,camster,alex1998,luckyy,zipcode,dizzle,boating1,opusone,newpassw,movies23,kamikazi,zapato,bart316,cowboys0,corsair1,kingshit,hotdog12,rolyat,h200svrm,qwerty4,boofer,rhtyltkm,chris999,vaz21074,simferopol,pitboss,love3,britania,tanyshka,brause,123qwerty123,abeille,moscow1,ilkaev,manut,process1,inetcfg,dragon05,fortknox,castill,rynner,mrmike,koalas,jeebus,stockpor,longman,juanpabl,caiman,roleplay,jeremi,26058,prodojo,002200,magical1,black5,bvlgari,doogie1,cbhtqa,mahina,a1s2d3f4g5h6,jblpro,usmc01,bismilah,guitar01,april9,santana1,1234aa,monkey14,sorokin,evan1,doohan,animalsex,pfqxtyjr,dimitry,catchme,chello,silverch,glock45,dogleg,litespee,nirvana9,peyton18,alydar,warhamer,iluvme,sig229,minotavr,lobzik,jack23,bushwack,onlin,football123,joshua5,federov,winter2,bigmax,fufnfrhbcnb,hfpldfnhb,1dakota,f56307,chipmonk,4nick8,praline,vbhjh123,king11,22tango,gemini12,street1,77879,doodlebu,homyak,165432,chuluthu,trixi,karlito,salom,reisen,cdtnkzxjr,pookie11,tremendo,shazaam,welcome0,00000ty,peewee51,pizzle,gilead,bydand,sarvar,upskirt,legends1,freeway1,teenfuck,ranger9,darkfire,dfymrf,hunt0802,justme1,buffy1ma,1harry,671fsa75yt,burrfoot,budster,pa437tu,jimmyp,alina2006,malacon,charlize,elway1,free12,summer02,gadina,manara,gomer1,1cassie,sanja,kisulya,money3,pujols,ford50,midiland,turga,orange6,demetriu,freakboy,orosie1,radio123,open12,vfufpby,mustek,chris33,animes,meiling,nthtvjr,jasmine9,gfdkjd,oligarh,marimar,chicago9,.kzirf,bugssgub,samuraix,jackie01,pimpjuic,macdad,cagiva,vernost,willyboy,fynjyjdf,tabby1,privet123,torres9,retype,blueroom,raven11,q12we3,alex1989,bringiton,ridered,kareltje,ow8jtcs8t,ciccia,goniners,countryb,24688642,covingto,24861793,beyblade,vikin,badboyz,wlafiga,walstib,mirand,needajob,chloes,balaton,kbpfdtnf,freyja,bond9007,gabriel12,stormbri,hollage,love4eve,fenomeno,darknite,dragstar,kyle123,milfhunter,ma123123123,samia,ghislain,enrique1,ferien12,xjy6721,natalie2,reglisse,wilson2,wesker,rosebud7,amazon1,robertr,roykeane,xtcnth,mamatata,crazyc,mikie,savanah,blowjob69,jackie2,forty1,1coffee,fhbyjxrf,bubbah,goteam,hackedit,risky1,logoff,h397pnvr,buck13,robert23,bronc,st123st,godflesh,pornog,iamking,cisco69,septiembr,dale38,zhongguo,tibbar,panther9,buffa1,bigjohn1,mypuppy,vehvfycr,april16,shippo,fire1234,green15,q123123,gungadin,steveg,olivier1,chinaski,magnoli,faithy,storm12,toadfrog,paul99,78791,august20,automati,squirtle,cheezy,positano,burbon,nunya,llebpmac,kimmi,turtle2,alan123,prokuror,violin1,durex,pussygal,visionar,trick1,chicken6,29024,plowboy,rfybreks,imbue,sasha13,wagner1,vitalogy,cfymrf,thepro,26028,gorbunov,dvdcom,letmein5,duder,fastfun,pronin,libra1,conner1,harley20,stinker1,20068,20038,amitech,syoung,dugway,18068,welcome7,jimmypag,anastaci,kafka1,pfhfnecnhf,catsss,campus100,shamal,nacho1,fire12,vikings2,brasil1,rangerover,mohamma,peresvet,14058,cocomo,aliona,14038,qwaser,vikes,cbkmdf,skyblue1,ou81234,goodlove,dfkmltvfh,108888,roamer,pinky2,static1,zxcv4321,barmen,rock22,shelby2,morgans,1junior,pasword1,logjam,fifty5,nhfrnjhbcn,chaddy,philli,nemesis2,ingenier,djkrjd,ranger3,aikman8,knothead,daddy69,love007,vsythb,ford350,tiger00,renrut,owen11,energy12,march14,alena123,robert19,carisma,orange22,murphy11,podarok,prozak,kfgeirf,wolf13,lydia1,shazza,parasha,akimov,tobbie,pilote,heather4,baster,leones,gznfxjr,megama,987654321g,bullgod,boxster1,minkey,wombats,vergil,colegiata,lincol,smoothe,pride1,carwash1,latrell,bowling3,fylhtq123,pickwick,eider,bubblebox,bunnies1,loquit,slipper1,nutsac,purina,xtutdfhf,plokiju,1qazxs,uhjpysq,zxcvbasdfg,enjoy1,1pumpkin,phantom7,mama22,swordsma,wonderbr,dogdays,milker,u23456,silvan,dfkthbr,slagelse,yeahman,twothree,boston11,wolf100,dannyg,troll1,fynjy123,ghbcnfd,bftest,ballsdeep,bobbyorr,alphasig,cccdemo,fire123,norwest,claire2,august10,lth1108,problemas,sapito,alex06,1rusty,maccom,goirish1,ohyes,bxdumb,nabila,boobear1,rabbit69,princip,alexsander,travail,chantal1,dogggy,greenpea,diablo69,alex2009,bergen09,petticoa,classe,ceilidh,vlad2011,kamakiri,lucidity,qaz321,chileno,cexfhf,99ranger,mcitra,estoppel,volvos60,carter80,webpass,temp12,touareg,fcgbhby,bubba8,sunitha,200190ru,bitch2,shadow23,iluvit,nicole0,ruben1,nikki69,butttt,shocker1,souschef,lopotok01,kantot,corsano,cfnfyf,riverat,makalu,swapna,all4u9,cdtnkfy,ntktgepbr,ronaldo99,thomasj,bmw540i,chrisw,boomba,open321,z1x2c3v4b5n6m7,gaviota,iceman44,frosya,chris100,chris24,cosette,clearwat,micael,boogyman,pussy9,camus1,chumpy,heccrbq,konoplya,chester8,scooter5,ghjgfufylf,giotto,koolkat,zero000,bonita1,ckflrbq,j1964,mandog,18n28n24a,renob,head1,shergar,ringo123,tanita,sex4free,johnny12,halberd,reddevils,biolog,dillinge,fatb0y,c00per,hyperlit,wallace2,spears1,vitamine,buheirf,sloboda,alkash,mooman,marion1,arsenal7,sunder,nokia5610,edifier,pippone,fyfnjkmtdbx,fujimo,pepsi12,kulikova,bolat,duetto,daimon,maddog01,timoshka,ezmoney,desdemon,chesters,aiden,hugues,patrick5,aikman08,robert4,roenick,nyranger,writer1,36169544,foxmulder,118801,kutter,shashank,jamjar,118811,119955,aspirina,dinkus,1sailor,nalgene,19891959,snarf,allie1,cracky,resipsa,45678912,kemerovo,19841989,netware1,alhimik,19801984,nicole123,19761977,51501984,malaka1,montella,peachfuz,jethro1,cypress1,henkie,holdon,esmith,55443322,1friend,quique,bandicoot,statistika,great123,death13,ucht36,master4,67899876,bobsmith,nikko1,jr1234,hillary1,78978978,rsturbo,lzlzdfcz,bloodlust,shadow00,skagen,bambina,yummies,88887777,91328378,matthew4,itdoes,98256518,102938475,alina2002,123123789,fubared,dannys,123456321,nikifor,suck69,newmexico,scubaman,rhbcnb,fifnfy,puffdadd,159357852,dtheyxbr,theman22,212009164,prohor,shirle,nji90okm,newmedia,goose5,roma1995,letssee,iceman11,aksana,wirenut,pimpdady,1212312121,tamplier,pelican1,domodedovo,1928374655,fiction6,duckpond,ybrecz,thwack,onetwo34,gunsmith,murphydo,fallout1,spectre1,jabberwo,jgjesq,turbo6,bobo12,redryder,blackpus,elena1971,danilova,antoin,bobo1234,bobob,bobbobbo,dean1,222222a,jesusgod,matt23,musical1,darkmage,loppol,werrew,josepha,rebel12,toshka,gadfly,hawkwood,alina12,dnomyar,sexaddict,dangit,cool23,yocrack,archimed,farouk,nhfkzkz,lindalou,111zzzzz,ghjatccjh,wethepeople,m123456789,wowsers,kbkbxrf,bulldog5,m_roesel,sissinit,yamoon6,123ewqasd,dangel,miruvor79,kaytee,falcon7,bandit11,dotnet,dannii,arsenal9,miatamx5,1trouble,strip4me,dogpile,sexyred1,rjdfktdf,google10,shortman,crystal7,awesome123,cowdog,haruka,birthday28,jitter,diabolik,boomer12,dknight,bluewate,hockey123,crm0624,blueboys,willy123,jumpup,google2,cobra777,llabesab,vicelord,hopper1,gerryber,remmah,j10e5d4,qqqqqqw,agusti,fre_ak8yj,nahlik,redrobin,scott3,epson1,dumpy,bundao,aniolek,hola123,jergens,itsasecret,maxsam,bluelight,mountai1,bongwater,1london,pepper14,freeuse,dereks,qweqw,fordgt40,rfhfdfy,raider12,hunnybun,compac,splicer,megamon,tuffgong,gymnast1,butter11,modaddy,wapbbs_1,dandelio,soccer77,ghjnbdjcnjzybt,123xyi2,fishead,x002tp00,whodaman,555aaa,oussama,brunodog,technici,pmtgjnbl,qcxdw8ry,schweden,redsox3,throbber,collecto,japan10,dbm123dm,hellhoun,tech1,deadzone,kahlan,wolf123,dethklok,xzsawq,bigguy1,cybrthc,chandle,buck01,qq123123,secreta,williams1,c32649135,delta12,flash33,123joker,spacejam,polopo,holycrap,daman1,tummybed,financia,nusrat,euroline,magicone,jimkirk,ameritec,daniel26,sevenn,topazz,kingpins,dima1991,macdog,spencer5,oi812,geoffre,music11,baffle,123569,usagi,cassiope,polla,lilcrowe,thecakeisalie,vbhjndjhtw,vthokies,oldmans,sophie01,ghoster,penny2,129834,locutus1,meesha,magik,jerry69,daddysgirl,irondesk,andrey12,jasmine123,vepsrfyn,likesdick,1accord,jetboat,grafix,tomuch,showit,protozoa,mosias98,taburetka,blaze420,esenin,anal69,zhv84kv,puissant,charles0,aishwarya,babylon6,bitter1,lenina,raleigh1,lechat,access01,kamilka,fynjy,sparkplu,daisy3112,choppe,zootsuit,1234567j,rubyrose,gorilla9,nightshade,alternativa,cghfdjxybr,snuggles1,10121v,vova1992,leonardo1,dave2,matthewd,vfhfnbr,1986mets,nobull,bacall,mexican1,juanjo,mafia1,boomer22,soylent,edwards1,jordan10,blackwid,alex86,gemini13,lunar2,dctvcjcfnm,malaki,plugger,eagles11,snafu2,1shelly,cintaku,hannah22,tbird1,maks5843,irish88,homer22,amarok,fktrcfylhjdf,lincoln2,acess,gre69kik,need4speed,hightech,core2duo,blunt1,ublhjgjybrf,dragon33,1autopas,autopas1,wwww1,15935746,daniel20,2500aa,massim,1ggggggg,96ford,hardcor1,cobra5,blackdragon,vovan_lt,orochimaru,hjlbntkb,qwertyuiop12,tallen,paradoks,frozenfish,ghjuhfvvbcn,gerri1,nuggett,camilit,doright,trans1,serena1,catch2,bkmyeh,fireston,afhvfwtdn,purple3,figure8,fuckya,scamp1,laranja,ontheoutside,louis123,yellow7,moonwalk,mercury2,tolkein,raide,amenra,a13579,dranreb,5150vh,harish,tracksta,sexking,ozzmosis,katiee,alomar,matrix19,headroom,jahlove,ringding,apollo8,132546,132613,12345672000,saretta,135798,136666,thomas7,136913,onetwothree,hockey33,calida,nefertit,bitwise,tailhook,boop4,kfgecbr,bujhmbujhm,metal69,thedark,meteoro,felicia1,house12,tinuviel,istina,vaz2105,pimp13,toolfan,nina1,tuesday2,maxmotives,lgkp500,locksley,treech,darling1,kurama,aminka,ramin,redhed,dazzler,jager1,stpiliot,cardman,rfvtym,cheeser,14314314,paramoun,samcat,plumpy,stiffie,vsajyjr,panatha,qqq777,car12345,098poi,asdzx,keegan1,furelise,kalifornia,vbhjckfd,beast123,zcfvfzkexifz,harry5,1birdie,96328i,escola,extra330,henry12,gfhfyjqz,14u2nv,max1234,templar1,1dave,02588520,catrin,pangolin,marhaba,latin1,amorcito,dave22,escape1,advance1,yasuhiro,grepw,meetme,orange01,ernes,erdna,zsergn,nautica1,justinb,soundwav,miasma,greg78,nadine1,sexmad,lovebaby,promo1,excel1,babys,dragonma,camry1,sonnenschein,farooq,wazzkaprivet,magal,katinas,elvis99,redsox24,rooney1,chiefy,peggys,aliev,pilsung,mudhen,dontdoit,dennis12,supercal,energia,ballsout,funone,claudiu,brown2,amoco,dabl1125,philos,gjdtkbntkm,servette,13571113,whizzer,nollie,13467982,upiter,12string,bluejay1,silkie,william4,kosta1,143333,connor12,sustanon,06068,corporat,ssnake,laurita,king10,tahoes,arsenal123,sapato,charless,jeanmarc,levent,algerie,marine21,jettas,winsome,dctvgbplf,1701ab,xxxp455w0rd5,lllllll1,ooooooo1,monalis,koufax32,anastasya,debugger,sarita2,jason69,ufkxjyjr,gjlcnfdf,1jerry,daniel10,balinor,sexkitten,death2,qwertasdfgzxcvb,s9te949f,vegeta1,sysman,maxxam,dimabilan,mooose,ilovetit,june23,illest,doesit,mamou,abby12,longjump,transalp,moderato,littleguy,magritte,dilnoza,hawaiiguy,winbig,nemiroff,kokaine,admira,myemail,dream2,browneyes,destiny7,dragonss,suckme1,asa123,andranik,suckem,fleshbot,dandie,timmys,scitra,timdog,hasbeen,guesss,smellyfe,arachne,deutschl,harley88,birthday27,nobody1,papasmur,home1,jonass,bunia3,epatb1,embalm,vfvekmrf,apacer,12345656,estreet,weihnachtsbaum,mrwhite,admin12,kristie1,kelebek,yoda69,socken,tima123,bayern1,fktrcfylth,tamiya,99strenght,andy01,denis2011,19delta,stokecit,aotearoa,stalker2,nicnac,conrad1,popey,agusta,bowl36,1bigfish,mossyoak,1stunner,getinnow,jessejames,gkfnjy,drako,1nissan,egor123,hotness,1hawaii,zxc123456,cantstop,1peaches,madlen,west1234,jeter1,markis,judit,attack1,artemi,silver69,153246,crazy2,green9,yoshimi,1vette,chief123,jasper2,1sierra,twentyon,drstrang,aspirant,yannic,jenna123,bongtoke,slurpy,1sugar,civic97,rusty21,shineon,james19,anna12345,wonderwoman,1kevin,karol1,kanabis,wert21,fktif6115,evil1,kakaha,54gv768,826248s,tyrone1,1winston,sugar2,falcon01,adelya,mopar440,zasxcd,leecher,kinkysex,mercede1,travka,11234567,rebon,geekboy".split(","),
  english_wikipedia: "the,of,and,in,was,is,for,as,on,with,by,he,at,from,his,an,were,are,which,doc,https,also,or,has,had,first,one,their,its,after,new,who,they,two,her,she,been,other,when,time,during,there,into,school,more,may,years,over,only,year,most,would,world,city,some,where,between,later,three,state,such,then,national,used,made,known,under,many,university,united,while,part,season,team,these,american,than,film,second,born,south,became,states,war,through,being,including,both,before,north,high,however,people,family,early,history,album,area,them,series,against,until,since,district,county,name,work,life,group,music,following,number,company,several,four,called,played,released,career,league,game,government,house,each,based,day,same,won,use,station,club,international,town,located,population,general,college,east,found,age,march,end,september,began,home,public,church,line,june,river,member,system,place,century,band,july,york,january,october,song,august,best,former,british,party,named,held,village,show,local,november,took,service,december,built,another,major,within,along,members,five,single,due,although,small,old,left,final,large,include,building,served,president,received,games,death,february,main,third,set,children,own,order,species,park,law,air,published,road,died,book,men,women,army,often,according,education,central,country,division,english,top,included,development,french,community,among,water,play,side,list,times,near,late,form,original,different,center,power,led,students,german,moved,court,six,land,council,island,u.s.,record,million,research,art,established,award,street,military,television,given,region,support,western,production,non,political,point,cup,period,business,title,started,various,election,using,england,role,produced,become,program,works,field,total,office,class,written,association,radio,union,level,championship,director,few,force,created,department,founded,services,married,though,per,n't,site,open,act,short,society,version,royal,present,northern,worked,professional,full,returned,joined,story,france,european,currently,language,social,california,india,days,design,st.,further,round,australia,wrote,san,project,control,southern,railway,board,popular,continued,free,battle,considered,video,common,position,living,half,playing,recorded,red,post,described,average,records,special,modern,appeared,announced,areas,rock,release,elected,others,example,term,opened,similar,formed,route,census,current,schools,originally,lake,developed,race,himself,forces,addition,information,upon,province,match,event,songs,result,events,win,eastern,track,lead,teams,science,human,construction,minister,germany,awards,available,throughout,training,style,body,museum,australian,health,seven,signed,chief,eventually,appointed,sea,centre,debut,tour,points,media,light,range,character,across,features,families,largest,indian,network,less,performance,players,refer,europe,sold,festival,usually,taken,despite,designed,committee,process,return,official,episode,institute,stage,followed,performed,japanese,personal,thus,arts,space,low,months,includes,china,study,middle,magazine,leading,japan,groups,aircraft,featured,federal,civil,rights,model,coach,canadian,books,remained,eight,type,independent,completed,capital,academy,instead,kingdom,organization,countries,studies,competition,sports,size,above,section,finished,gold,involved,reported,management,systems,industry,directed,market,fourth,movement,technology,bank,ground,campaign,base,lower,sent,rather,added,provided,coast,grand,historic,valley,conference,bridge,winning,approximately,films,chinese,awarded,degree,russian,shows,native,female,replaced,municipality,square,studio,medical,data,african,successful,mid,bay,attack,previous,operations,spanish,theatre,student,republic,beginning,provide,ship,primary,owned,writing,tournament,culture,introduced,texas,related,natural,parts,governor,reached,ireland,units,senior,decided,italian,whose,higher,africa,standard,income,professor,placed,regional,los,buildings,championships,active,novel,energy,generally,interest,via,economic,previously,stated,itself,channel,below,operation,leader,traditional,trade,structure,limited,runs,prior,regular,famous,saint,navy,foreign,listed,artist,catholic,airport,results,parliament,collection,unit,officer,goal,attended,command,staff,commission,lived,location,plays,commercial,places,foundation,significant,older,medal,self,scored,companies,highway,activities,programs,wide,musical,notable,library,numerous,paris,towards,individual,allowed,plant,property,annual,contract,whom,highest,initially,required,earlier,assembly,artists,rural,seat,practice,defeated,ended,soviet,length,spent,manager,press,associated,author,issues,additional,characters,lord,zealand,policy,engine,township,noted,historical,complete,financial,religious,mission,contains,nine,recent,represented,pennsylvania,administration,opening,secretary,lines,report,executive,youth,closed,theory,writer,italy,angeles,appearance,feature,queen,launched,legal,terms,entered,issue,edition,singer,greek,majority,background,source,anti,cultural,complex,changes,recording,stadium,islands,operated,particularly,basketball,month,uses,port,castle,mostly,names,fort,selected,increased,status,earth,subsequently,pacific,cover,variety,certain,goals,remains,upper,congress,becoming,studied,irish,nature,particular,loss,caused,chart,dr.,forced,create,era,retired,material,review,rate,singles,referred,larger,individuals,shown,provides,products,speed,democratic,poland,parish,olympics,cities,themselves,temple,wing,genus,households,serving,cost,wales,stations,passed,supported,view,cases,forms,actor,male,matches,males,stars,tracks,females,administrative,median,effect,biography,train,engineering,camp,offered,chairman,houses,mainly,19th,surface,therefore,nearly,score,ancient,subject,prime,seasons,claimed,experience,specific,jewish,failed,overall,believed,plot,troops,greater,spain,consists,broadcast,heavy,increase,raised,separate,campus,1980s,appears,presented,lies,composed,recently,influence,fifth,nations,creek,references,elections,britain,double,cast,meaning,earned,carried,producer,latter,housing,brothers,attempt,article,response,border,remaining,nearby,direct,ships,value,workers,politician,academic,label,1970s,commander,rule,fellow,residents,authority,editor,transport,dutch,projects,responsible,covered,territory,flight,races,defense,tower,emperor,albums,facilities,daily,stories,assistant,managed,primarily,quality,function,proposed,distribution,conditions,prize,journal,code,vice,newspaper,corps,highly,constructed,mayor,critical,secondary,corporation,rugby,regiment,ohio,appearances,serve,allow,nation,multiple,discovered,directly,scene,levels,growth,elements,acquired,1990s,officers,physical,20th,latin,host,jersey,graduated,arrived,issued,literature,metal,estate,vote,immediately,quickly,asian,competed,extended,produce,urban,1960s,promoted,contemporary,global,formerly,appear,industrial,types,opera,ministry,soldiers,commonly,mass,formation,smaller,typically,drama,shortly,density,senate,effects,iran,polish,prominent,naval,settlement,divided,basis,republican,languages,distance,treatment,continue,product,mile,sources,footballer,format,clubs,leadership,initial,offers,operating,avenue,officially,columbia,grade,squadron,fleet,percent,farm,leaders,agreement,likely,equipment,website,mount,grew,method,transferred,intended,renamed,iron,asia,reserve,capacity,politics,widely,activity,advanced,relations,scottish,dedicated,crew,founder,episodes,lack,amount,build,efforts,concept,follows,ordered,leaves,positive,economy,entertainment,affairs,memorial,ability,illinois,communities,color,text,railroad,scientific,focus,comedy,serves,exchange,environment,cars,direction,organized,firm,description,agency,analysis,purpose,destroyed,reception,planned,revealed,infantry,architecture,growing,featuring,household,candidate,removed,situated,models,knowledge,solo,technical,organizations,assigned,conducted,participated,largely,purchased,register,gained,combined,headquarters,adopted,potential,protection,scale,approach,spread,independence,mountains,titled,geography,applied,safety,mixed,accepted,continues,captured,rail,defeat,principal,recognized,lieutenant,mentioned,semi,owner,joint,liberal,actress,traffic,creation,basic,notes,unique,supreme,declared,simply,plants,sales,massachusetts,designated,parties,jazz,compared,becomes,resources,titles,concert,learning,remain,teaching,versions,content,alongside,revolution,sons,block,premier,impact,champions,districts,generation,estimated,volume,image,sites,account,roles,sport,quarter,providing,zone,yard,scoring,classes,presence,performances,representatives,hosted,split,taught,origin,olympic,claims,critics,facility,occurred,suffered,municipal,damage,defined,resulted,respectively,expanded,platform,draft,opposition,expected,educational,ontario,climate,reports,atlantic,surrounding,performing,reduced,ranked,allows,birth,nominated,younger,newly,kong,positions,theater,philadelphia,heritage,finals,disease,sixth,laws,reviews,constitution,tradition,swedish,theme,fiction,rome,medicine,trains,resulting,existing,deputy,environmental,labour,classical,develop,fans,granted,receive,alternative,begins,nuclear,fame,buried,connected,identified,palace,falls,letters,combat,sciences,effort,villages,inspired,regions,towns,conservative,chosen,animals,labor,attacks,materials,yards,steel,representative,orchestra,peak,entitled,officials,returning,reference,northwest,imperial,convention,examples,ocean,publication,painting,subsequent,frequently,religion,brigade,fully,sides,acts,cemetery,relatively,oldest,suggested,succeeded,achieved,application,programme,cells,votes,promotion,graduate,armed,supply,flying,communist,figures,literary,netherlands,korea,worldwide,citizens,1950s,faculty,draw,stock,seats,occupied,methods,unknown,articles,claim,holds,authorities,audience,sweden,interview,obtained,covers,settled,transfer,marked,allowing,funding,challenge,southeast,unlike,crown,rise,portion,transportation,sector,phase,properties,edge,tropical,standards,institutions,philosophy,legislative,hills,brand,fund,conflict,unable,founding,refused,attempts,metres,permanent,starring,applications,creating,effective,aired,extensive,employed,enemy,expansion,billboard,rank,battalion,multi,vehicle,fought,alliance,category,perform,federation,poetry,bronze,bands,entry,vehicles,bureau,maximum,billion,trees,intelligence,greatest,screen,refers,commissioned,gallery,injury,confirmed,setting,treaty,adult,americans,broadcasting,supporting,pilot,mobile,writers,programming,existence,squad,minnesota,copies,korean,provincial,sets,defence,offices,agricultural,internal,core,northeast,retirement,factory,actions,prevent,communications,ending,weekly,containing,functions,attempted,interior,weight,bowl,recognition,incorporated,increasing,ultimately,documentary,derived,attacked,lyrics,mexican,external,churches,centuries,metropolitan,selling,opposed,personnel,mill,visited,presidential,roads,pieces,norwegian,controlled,18th,rear,influenced,wrestling,weapons,launch,composer,locations,developing,circuit,specifically,studios,shared,canal,wisconsin,publishing,approved,domestic,consisted,determined,comic,establishment,exhibition,southwest,fuel,electronic,cape,converted,educated,melbourne,hits,wins,producing,norway,slightly,occur,surname,identity,represent,constituency,funds,proved,links,structures,athletic,birds,contest,users,poet,institution,display,receiving,rare,contained,guns,motion,piano,temperature,publications,passenger,contributed,toward,cathedral,inhabitants,architect,exist,athletics,muslim,courses,abandoned,signal,successfully,disambiguation,tennessee,dynasty,heavily,maryland,jews,representing,budget,weather,missouri,introduction,faced,pair,chapel,reform,height,vietnam,occurs,motor,cambridge,lands,focused,sought,patients,shape,invasion,chemical,importance,communication,selection,regarding,homes,voivodeship,maintained,borough,failure,aged,passing,agriculture,oregon,teachers,flow,philippines,trail,seventh,portuguese,resistance,reaching,negative,fashion,scheduled,downtown,universities,trained,skills,scenes,views,notably,typical,incident,candidates,engines,decades,composition,commune,chain,inc.,austria,sale,values,employees,chamber,regarded,winners,registered,task,investment,colonial,swiss,user,entirely,flag,stores,closely,entrance,laid,journalist,coal,equal,causes,turkish,quebec,techniques,promote,junction,easily,dates,kentucky,singapore,residence,violence,advance,survey,humans,expressed,passes,streets,distinguished,qualified,folk,establish,egypt,artillery,visual,improved,actual,finishing,medium,protein,switzerland,productions,operate,poverty,neighborhood,organisation,consisting,consecutive,sections,partnership,extension,reaction,factor,costs,bodies,device,ethnic,racial,flat,objects,chapter,improve,musicians,courts,controversy,membership,merged,wars,expedition,interests,arab,comics,gain,describes,mining,bachelor,crisis,joining,decade,1930s,distributed,habitat,routes,arena,cycle,divisions,briefly,vocals,directors,degrees,object,recordings,installed,adjacent,demand,voted,causing,businesses,ruled,grounds,starred,drawn,opposite,stands,formal,operates,persons,counties,compete,wave,israeli,ncaa,resigned,brief,greece,combination,demographics,historian,contain,commonwealth,musician,collected,argued,louisiana,session,cabinet,parliamentary,electoral,loan,profit,regularly,conservation,islamic,purchase,17th,charts,residential,earliest,designs,paintings,survived,moth,items,goods,grey,anniversary,criticism,images,discovery,observed,underground,progress,additionally,participate,thousands,reduce,elementary,owners,stating,iraq,resolution,capture,tank,rooms,hollywood,finance,queensland,reign,maintain,iowa,landing,broad,outstanding,circle,path,manufacturing,assistance,sequence,gmina,crossing,leads,universal,shaped,kings,attached,medieval,ages,metro,colony,affected,scholars,oklahoma,coastal,soundtrack,painted,attend,definition,meanwhile,purposes,trophy,require,marketing,popularity,cable,mathematics,mississippi,represents,scheme,appeal,distinct,factors,acid,subjects,roughly,terminal,economics,senator,diocese,prix,contrast,argentina,czech,wings,relief,stages,duties,16th,novels,accused,whilst,equivalent,charged,measure,documents,couples,request,danish,defensive,guide,devices,statistics,credited,tries,passengers,allied,frame,puerto,peninsula,concluded,instruments,wounded,differences,associate,forests,afterwards,replace,requirements,aviation,solution,offensive,ownership,inner,legislation,hungarian,contributions,actors,translated,denmark,steam,depending,aspects,assumed,injured,severe,admitted,determine,shore,technique,arrival,measures,translation,debuted,delivered,returns,rejected,separated,visitors,damaged,storage,accompanied,markets,industries,losses,gulf,charter,strategy,corporate,socialist,somewhat,significantly,physics,mounted,satellite,experienced,constant,relative,pattern,restored,belgium,connecticut,partners,harvard,retained,networks,protected,mode,artistic,parallel,collaboration,debate,involving,journey,linked,salt,authors,components,context,occupation,requires,occasionally,policies,tamil,ottoman,revolutionary,hungary,poem,versus,gardens,amongst,audio,makeup,frequency,meters,orthodox,continuing,suggests,legislature,coalition,guitarist,eighth,classification,practices,soil,tokyo,instance,limit,coverage,considerable,ranking,colleges,cavalry,centers,daughters,twin,equipped,broadway,narrow,hosts,rates,domain,boundary,arranged,12th,whereas,brazilian,forming,rating,strategic,competitions,trading,covering,baltimore,commissioner,infrastructure,origins,replacement,praised,disc,collections,expression,ukraine,driven,edited,austrian,solar,ensure,premiered,successor,wooden,operational,hispanic,concerns,rapid,prisoners,childhood,meets,influential,tunnel,employment,tribe,qualifying,adapted,temporary,celebrated,appearing,increasingly,depression,adults,cinema,entering,laboratory,script,flows,romania,accounts,fictional,pittsburgh,achieve,monastery,franchise,formally,tools,newspapers,revival,sponsored,processes,vienna,springs,missions,classified,13th,annually,branches,lakes,gender,manner,advertising,normally,maintenance,adding,characteristics,integrated,decline,modified,strongly,critic,victims,malaysia,arkansas,nazi,restoration,powered,monument,hundreds,depth,15th,controversial,admiral,criticized,brick,honorary,initiative,output,visiting,birmingham,progressive,existed,carbon,1920s,credits,colour,rising,hence,defeating,superior,filmed,listing,column,surrounded,orleans,principles,territories,struck,participation,indonesia,movements,index,commerce,conduct,constitutional,spiritual,ambassador,vocal,completion,edinburgh,residing,tourism,finland,bears,medals,resident,themes,visible,indigenous,involvement,basin,electrical,ukrainian,concerts,boats,styles,processing,rival,drawing,vessels,experimental,declined,touring,supporters,compilation,coaching,cited,dated,roots,string,explained,transit,traditionally,poems,minimum,representation,14th,releases,effectively,architectural,triple,indicated,greatly,elevation,clinical,printed,10th,proposal,peaked,producers,romanized,rapidly,stream,innings,meetings,counter,householder,honour,lasted,agencies,document,exists,surviving,experiences,honors,landscape,hurricane,harbor,panel,competing,profile,vessel,farmers,lists,revenue,exception,customers,11th,participants,wildlife,utah,bible,gradually,preserved,replacing,symphony,begun,longest,siege,provinces,mechanical,genre,transmission,agents,executed,videos,benefits,funded,rated,instrumental,ninth,similarly,dominated,destruction,passage,technologies,thereafter,outer,facing,affiliated,opportunities,instrument,governments,scholar,evolution,channels,shares,sessions,widespread,occasions,engineers,scientists,signing,battery,competitive,alleged,eliminated,supplies,judges,hampshire,regime,portrayed,penalty,taiwan,denied,submarine,scholarship,substantial,transition,victorian,http,nevertheless,filed,supports,continental,tribes,ratio,doubles,useful,honours,blocks,principle,retail,departure,ranks,patrol,yorkshire,vancouver,inter,extent,afghanistan,strip,railways,component,organ,symbol,categories,encouraged,abroad,civilian,periods,traveled,writes,struggle,immediate,recommended,adaptation,egyptian,graduating,assault,drums,nomination,historically,voting,allies,detailed,achievement,percentage,arabic,assist,frequent,toured,apply,and/or,intersection,maine,touchdown,throne,produces,contribution,emerged,obtain,archbishop,seek,researchers,remainder,populations,clan,finnish,overseas,fifa,licensed,chemistry,festivals,mediterranean,injuries,animated,seeking,publisher,volumes,limits,venue,jerusalem,generated,trials,islam,youngest,ruling,glasgow,germans,songwriter,persian,municipalities,donated,viewed,belgian,cooperation,posted,tech,dual,volunteer,settlers,commanded,claiming,approval,delhi,usage,terminus,partly,electricity,locally,editions,premiere,absence,belief,traditions,statue,indicate,manor,stable,attributed,possession,managing,viewers,chile,overview,seed,regulations,essential,minority,cargo,segment,endemic,forum,deaths,monthly,playoffs,erected,practical,machines,suburb,relation,mrs.,descent,indoor,continuous,characterized,solutions,caribbean,rebuilt,serbian,summary,contested,psychology,pitch,attending,muhammad,tenure,drivers,diameter,assets,venture,punk,airlines,concentration,athletes,volunteers,pages,mines,influences,sculpture,protest,ferry,behalf,drafted,apparent,furthermore,ranging,romanian,democracy,lanka,significance,linear,d.c.,certified,voters,recovered,tours,demolished,boundaries,assisted,identify,grades,elsewhere,mechanism,1940s,reportedly,aimed,conversion,suspended,photography,departments,beijing,locomotives,publicly,dispute,magazines,resort,conventional,platforms,internationally,capita,settlements,dramatic,derby,establishing,involves,statistical,implementation,immigrants,exposed,diverse,layer,vast,ceased,connections,belonged,interstate,uefa,organised,abuse,deployed,cattle,partially,filming,mainstream,reduction,automatic,rarely,subsidiary,decides,merger,comprehensive,displayed,amendment,guinea,exclusively,manhattan,concerning,commons,radical,serbia,baptist,buses,initiated,portrait,harbour,choir,citizen,sole,unsuccessful,manufactured,enforcement,connecting,increases,patterns,sacred,muslims,clothing,hindu,unincorporated,sentenced,advisory,tanks,campaigns,fled,repeated,remote,rebellion,implemented,texts,fitted,tribute,writings,sufficient,ministers,21st,devoted,jurisdiction,coaches,interpretation,pole,businessman,peru,sporting,prices,cuba,relocated,opponent,arrangement,elite,manufacturer,responded,suitable,distinction,calendar,dominant,tourist,earning,prefecture,ties,preparation,anglo,pursue,worship,archaeological,chancellor,bangladesh,scores,traded,lowest,horror,outdoor,biology,commented,specialized,loop,arriving,farming,housed,historians,'the,patent,pupils,christianity,opponents,athens,northwestern,maps,promoting,reveals,flights,exclusive,lions,norfolk,hebrew,extensively,eldest,shops,acquisition,virtual,renowned,margin,ongoing,essentially,iranian,alternate,sailed,reporting,conclusion,originated,temperatures,exposure,secured,landed,rifle,framework,identical,martial,focuses,topics,ballet,fighters,belonging,wealthy,negotiations,evolved,bases,oriented,acres,democrat,heights,restricted,vary,graduation,aftermath,chess,illness,participating,vertical,collective,immigration,demonstrated,leaf,completing,organic,missile,leeds,eligible,grammar,confederate,improvement,congressional,wealth,cincinnati,spaces,indicates,corresponding,reaches,repair,isolated,taxes,congregation,ratings,leagues,diplomatic,submitted,winds,awareness,photographs,maritime,nigeria,accessible,animation,restaurants,philippine,inaugural,dismissed,armenian,illustrated,reservoir,speakers,programmes,resource,genetic,interviews,camps,regulation,computers,preferred,travelled,comparison,distinctive,recreation,requested,southeastern,dependent,brisbane,breeding,playoff,expand,bonus,gauge,departed,qualification,inspiration,shipping,slaves,variations,shield,theories,munich,recognised,emphasis,favour,variable,seeds,undergraduate,territorial,intellectual,qualify,mini,banned,pointed,democrats,assessment,judicial,examination,attempting,objective,partial,characteristic,hardware,pradesh,execution,ottawa,metre,drum,exhibitions,withdrew,attendance,phrase,journalism,logo,measured,error,christians,trio,protestant,theology,respective,atmosphere,buddhist,substitute,curriculum,fundamental,outbreak,rabbi,intermediate,designation,globe,liberation,simultaneously,diseases,experiments,locomotive,difficulties,mainland,nepal,relegated,contributing,database,developments,veteran,carries,ranges,instruction,lodge,protests,obama,newcastle,experiment,physician,describing,challenges,corruption,delaware,adventures,ensemble,succession,renaissance,tenth,altitude,receives,approached,crosses,syria,croatia,warsaw,professionals,improvements,worn,airline,compound,permitted,preservation,reducing,printing,scientist,activist,comprises,sized,societies,enters,ruler,gospel,earthquake,extend,autonomous,croatian,serial,decorated,relevant,ideal,grows,grass,tier,towers,wider,welfare,columns,alumni,descendants,interface,reserves,banking,colonies,manufacturers,magnetic,closure,pitched,vocalist,preserve,enrolled,cancelled,equation,2000s,nickname,bulgaria,heroes,exile,mathematical,demands,input,structural,tube,stem,approaches,argentine,axis,manuscript,inherited,depicted,targets,visits,veterans,regard,removal,efficiency,organisations,concepts,lebanon,manga,petersburg,rally,supplied,amounts,yale,tournaments,broadcasts,signals,pilots,azerbaijan,architects,enzyme,literacy,declaration,placing,batting,incumbent,bulgarian,consistent,poll,defended,landmark,southwestern,raid,resignation,travels,casualties,prestigious,namely,aims,recipient,warfare,readers,collapse,coached,controls,volleyball,coup,lesser,verse,pairs,exhibited,proteins,molecular,abilities,integration,consist,aspect,advocate,administered,governing,hospitals,commenced,coins,lords,variation,resumed,canton,artificial,elevated,palm,difficulty,civic,efficient,northeastern,inducted,radiation,affiliate,boards,stakes,byzantine,consumption,freight,interaction,oblast,numbered,seminary,contracts,extinct,predecessor,bearing,cultures,functional,neighboring,revised,cylinder,grants,narrative,reforms,athlete,tales,reflect,presidency,compositions,specialist,cricketer,founders,sequel,widow,disbanded,associations,backed,thereby,pitcher,commanding,boulevard,singers,crops,militia,reviewed,centres,waves,consequently,fortress,tributary,portions,bombing,excellence,nest,payment,mars,plaza,unity,victories,scotia,farms,nominations,variant,attacking,suspension,installation,graphics,estates,comments,acoustic,destination,venues,surrender,retreat,libraries,quarterback,customs,berkeley,collaborated,gathered,syndrome,dialogue,recruited,shanghai,neighbouring,psychological,saudi,moderate,exhibit,innovation,depot,binding,brunswick,situations,certificate,actively,shakespeare,editorial,presentation,ports,relay,nationalist,methodist,archives,experts,maintains,collegiate,bishops,maintaining,temporarily,embassy,essex,wellington,connects,reformed,bengal,recalled,inches,doctrine,deemed,legendary,reconstruction,statements,palestinian,meter,achievements,riders,interchange,spots,auto,accurate,chorus,dissolved,missionary,thai,operators,e.g.,generations,failing,delayed,cork,nashville,perceived,venezuela,cult,emerging,tomb,abolished,documented,gaining,canyon,episcopal,stored,assists,compiled,kerala,kilometers,mosque,grammy,theorem,unions,segments,glacier,arrives,theatrical,circulation,conferences,chapters,displays,circular,authored,conductor,fewer,dimensional,nationwide,liga,yugoslavia,peer,vietnamese,fellowship,armies,regardless,relating,dynamic,politicians,mixture,serie,somerset,imprisoned,posts,beliefs,beta,layout,independently,electronics,provisions,fastest,logic,headquartered,creates,challenged,beaten,appeals,plains,protocol,graphic,accommodate,iraqi,midfielder,span,commentary,freestyle,reflected,palestine,lighting,burial,virtually,backing,prague,tribal,heir,identification,prototype,criteria,dame,arch,tissue,footage,extending,procedures,predominantly,updated,rhythm,preliminary,cafe,disorder,prevented,suburbs,discontinued,retiring,oral,followers,extends,massacre,journalists,conquest,larvae,pronounced,behaviour,diversity,sustained,addressed,geographic,restrictions,voiced,milwaukee,dialect,quoted,grid,nationally,nearest,roster,twentieth,separation,indies,manages,citing,intervention,guidance,severely,migration,artwork,focusing,rivals,trustees,varied,enabled,committees,centered,skating,slavery,cardinals,forcing,tasks,auckland,youtube,argues,colored,advisor,mumbai,requiring,theological,registration,refugees,nineteenth,survivors,runners,colleagues,priests,contribute,variants,workshop,concentrated,creator,lectures,temples,exploration,requirement,interactive,navigation,companion,perth,allegedly,releasing,citizenship,observation,stationed,ph.d.,sheep,breed,discovers,encourage,kilometres,journals,performers,isle,saskatchewan,hybrid,hotels,lancashire,dubbed,airfield,anchor,suburban,theoretical,sussex,anglican,stockholm,permanently,upcoming,privately,receiver,optical,highways,congo,colours,aggregate,authorized,repeatedly,varies,fluid,innovative,transformed,praise,convoy,demanded,discography,attraction,export,audiences,ordained,enlisted,occasional,westminster,syrian,heavyweight,bosnia,consultant,eventual,improving,aires,wickets,epic,reactions,scandal,i.e.,discrimination,buenos,patron,investors,conjunction,testament,construct,encountered,celebrity,expanding,georgian,brands,retain,underwent,algorithm,foods,provision,orbit,transformation,associates,tactical,compact,varieties,stability,refuge,gathering,moreover,manila,configuration,gameplay,discipline,entity,comprising,composers,skill,monitoring,ruins,museums,sustainable,aerial,altered,codes,voyage,friedrich,conflicts,storyline,travelling,conducting,merit,indicating,referendum,currency,encounter,particles,automobile,workshops,acclaimed,inhabited,doctorate,cuban,phenomenon,dome,enrollment,tobacco,governance,trend,equally,manufacture,hydrogen,grande,compensation,download,pianist,grain,shifted,neutral,evaluation,define,cycling,seized,array,relatives,motors,firms,varying,automatically,restore,nicknamed,findings,governed,investigate,manitoba,administrator,vital,integral,indonesian,confusion,publishers,enable,geographical,inland,naming,civilians,reconnaissance,indianapolis,lecturer,deer,tourists,exterior,rhode,bassist,symbols,scope,ammunition,yuan,poets,punjab,nursing,cent,developers,estimates,presbyterian,nasa,holdings,generate,renewed,computing,cyprus,arabia,duration,compounds,gastropod,permit,valid,touchdowns,facade,interactions,mineral,practiced,allegations,consequence,goalkeeper,baronet,copyright,uprising,carved,targeted,competitors,mentions,sanctuary,fees,pursued,tampa,chronicle,capabilities,specified,specimens,toll,accounting,limestone,staged,upgraded,philosophical,streams,guild,revolt,rainfall,supporter,princeton,terrain,hometown,probability,assembled,paulo,surrey,voltage,developer,destroyer,floors,lineup,curve,prevention,potentially,onwards,trips,imposed,hosting,striking,strict,admission,apartments,solely,utility,proceeded,observations,euro,incidents,vinyl,profession,haven,distant,expelled,rivalry,runway,torpedo,zones,shrine,dimensions,investigations,lithuania,idaho,pursuit,copenhagen,considerably,locality,wireless,decrease,genes,thermal,deposits,hindi,habitats,withdrawn,biblical,monuments,casting,plateau,thesis,managers,flooding,assassination,acknowledged,interim,inscription,guided,pastor,finale,insects,transported,activists,marshal,intensity,airing,cardiff,proposals,lifestyle,prey,herald,capitol,aboriginal,measuring,lasting,interpreted,occurring,desired,drawings,healthcare,panels,elimination,oslo,ghana,blog,sabha,intent,superintendent,governors,bankruptcy,p.m.,equity,disk,layers,slovenia,prussia,quartet,mechanics,graduates,politically,monks,screenplay,nato,absorbed,topped,petition,bold,morocco,exhibits,canterbury,publish,rankings,crater,dominican,enhanced,planes,lutheran,governmental,joins,collecting,brussels,unified,streak,strategies,flagship,surfaces,oval,archive,etymology,imprisonment,instructor,noting,remix,opposing,servant,rotation,width,trans,maker,synthesis,excess,tactics,snail,ltd.,lighthouse,sequences,cornwall,plantation,mythology,performs,foundations,populated,horizontal,speedway,activated,performer,diving,conceived,edmonton,subtropical,environments,prompted,semifinals,caps,bulk,treasury,recreational,telegraph,continent,portraits,relegation,catholics,graph,velocity,rulers,endangered,secular,observer,learns,inquiry,idol,dictionary,certification,estimate,cluster,armenia,observatory,revived,nadu,consumers,hypothesis,manuscripts,contents,arguments,editing,trails,arctic,essays,belfast,acquire,promotional,undertaken,corridor,proceedings,antarctic,millennium,labels,delegates,vegetation,acclaim,directing,substance,outcome,diploma,philosopher,malta,albanian,vicinity,degc,legends,regiments,consent,terrorist,scattered,presidents,gravity,orientation,deployment,duchy,refuses,estonia,crowned,separately,renovation,rises,wilderness,objectives,agreements,empress,slopes,inclusion,equality,decree,ballot,criticised,rochester,recurring,struggled,disabled,henri,poles,prussian,convert,bacteria,poorly,sudan,geological,wyoming,consistently,minimal,withdrawal,interviewed,proximity,repairs,initiatives,pakistani,republicans,propaganda,viii,abstract,commercially,availability,mechanisms,naples,discussions,underlying,lens,proclaimed,advised,spelling,auxiliary,attract,lithuanian,editors,o'brien,accordance,measurement,novelist,ussr,formats,councils,contestants,indie,facebook,parishes,barrier,battalions,sponsor,consulting,terrorism,implement,uganda,crucial,unclear,notion,distinguish,collector,attractions,filipino,ecology,investments,capability,renovated,iceland,albania,accredited,scouts,armor,sculptor,cognitive,errors,gaming,condemned,successive,consolidated,baroque,entries,regulatory,reserved,treasurer,variables,arose,technological,rounded,provider,rhine,agrees,accuracy,genera,decreased,frankfurt,ecuador,edges,particle,rendered,calculated,careers,faction,rifles,americas,gaelic,portsmouth,resides,merchants,fiscal,premises,coin,draws,presenter,acceptance,ceremonies,pollution,consensus,membrane,brigadier,nonetheless,genres,supervision,predicted,magnitude,finite,differ,ancestry,vale,delegation,removing,proceeds,placement,emigrated,siblings,molecules,payments,considers,demonstration,proportion,newer,valve,achieving,confederation,continuously,luxury,notre,introducing,coordinates,charitable,squadrons,disorders,geometry,winnipeg,ulster,loans,longtime,receptor,preceding,belgrade,mandate,wrestler,neighbourhood,factories,buddhism,imported,sectors,protagonist,steep,elaborate,prohibited,artifacts,prizes,pupil,cooperative,sovereign,subspecies,carriers,allmusic,nationals,settings,autobiography,neighborhoods,analog,facilitate,voluntary,jointly,newfoundland,organizing,raids,exercises,nobel,machinery,baltic,crop,granite,dense,websites,mandatory,seeks,surrendered,anthology,comedian,bombs,slot,synopsis,critically,arcade,marking,equations,halls,indo,inaugurated,embarked,speeds,clause,invention,premiership,likewise,presenting,demonstrate,designers,organize,examined,km/h,bavaria,troop,referee,detection,zurich,prairie,rapper,wingspan,eurovision,luxembourg,slovakia,inception,disputed,mammals,entrepreneur,makers,evangelical,yield,clergy,trademark,defunct,allocated,depicting,volcanic,batted,conquered,sculptures,providers,reflects,armoured,locals,walt,herzegovina,contracted,entities,sponsorship,prominence,flowing,ethiopia,marketed,corporations,withdraw,carnegie,induced,investigated,portfolio,flowering,opinions,viewing,classroom,donations,bounded,perception,leicester,fruits,charleston,academics,statute,complaints,smallest,deceased,petroleum,resolved,commanders,algebra,southampton,modes,cultivation,transmitter,spelled,obtaining,sizes,acre,pageant,bats,abbreviated,correspondence,barracks,feast,tackles,raja,derives,geology,disputes,translations,counted,constantinople,seating,macedonia,preventing,accommodation,homeland,explored,invaded,provisional,transform,sphere,unsuccessfully,missionaries,conservatives,highlights,traces,organisms,openly,dancers,fossils,absent,monarchy,combining,lanes,stint,dynamics,chains,missiles,screening,module,tribune,generating,miners,nottingham,seoul,unofficial,owing,linking,rehabilitation,citation,louisville,mollusk,depicts,differential,zimbabwe,kosovo,recommendations,responses,pottery,scorer,aided,exceptions,dialects,telecommunications,defines,elderly,lunar,coupled,flown,25th,espn,formula_1,bordered,fragments,guidelines,gymnasium,valued,complexity,papal,presumably,maternal,challenging,reunited,advancing,comprised,uncertain,favorable,twelfth,correspondent,nobility,livestock,expressway,chilean,tide,researcher,emissions,profits,lengths,accompanying,witnessed,itunes,drainage,slope,reinforced,feminist,sanskrit,develops,physicians,outlets,isbn,coordinator,averaged,termed,occupy,diagnosed,yearly,humanitarian,prospect,spacecraft,stems,enacted,linux,ancestors,karnataka,constitute,immigrant,thriller,ecclesiastical,generals,celebrations,enhance,heating,advocated,evident,advances,bombardment,watershed,shuttle,wicket,twitter,adds,branded,teaches,schemes,pension,advocacy,conservatory,cairo,varsity,freshwater,providence,seemingly,shells,cuisine,specially,peaks,intensive,publishes,trilogy,skilled,nacional,unemployment,destinations,parameters,verses,trafficking,determination,infinite,savings,alignment,linguistic,countryside,dissolution,measurements,advantages,licence,subfamily,highlands,modest,regent,algeria,crest,teachings,knockout,brewery,combine,conventions,descended,chassis,primitive,fiji,explicitly,cumberland,uruguay,laboratories,bypass,elect,informal,preceded,holocaust,tackle,minneapolis,quantity,securities,console,doctoral,religions,commissioners,expertise,unveiled,precise,diplomat,standings,infant,disciplines,sicily,endorsed,systematic,charted,armored,mild,lateral,townships,hurling,prolific,invested,wartime,compatible,galleries,moist,battlefield,decoration,convent,tubes,terrestrial,nominee,requests,delegate,leased,dubai,polar,applying,addresses,munster,sings,commercials,teamed,dances,eleventh,midland,cedar,flee,sandstone,snails,inspection,divide,asset,themed,comparable,paramount,dairy,archaeology,intact,institutes,rectangular,instances,phases,reflecting,substantially,applies,vacant,lacked,copa,coloured,encounters,sponsors,encoded,possess,revenues,ucla,chaired,a.m.,enabling,playwright,stoke,sociology,tibetan,frames,motto,financing,illustrations,gibraltar,chateau,bolivia,transmitted,enclosed,persuaded,urged,folded,suffolk,regulated,bros.,submarines,myth,oriental,malaysian,effectiveness,narrowly,acute,sunk,replied,utilized,tasmania,consortium,quantities,gains,parkway,enlarged,sided,employers,adequate,accordingly,assumption,ballad,mascot,distances,peaking,saxony,projected,affiliation,limitations,metals,guatemala,scots,theaters,kindergarten,verb,employer,differs,discharge,controller,seasonal,marching,guru,campuses,avoided,vatican,maori,excessive,chartered,modifications,caves,monetary,sacramento,mixing,institutional,celebrities,irrigation,shapes,broadcaster,anthem,attributes,demolition,offshore,specification,surveys,yugoslav,contributor,auditorium,lebanese,capturing,airports,classrooms,chennai,paths,tendency,determining,lacking,upgrade,sailors,detected,kingdoms,sovereignty,freely,decorative,momentum,scholarly,georges,gandhi,speculation,transactions,undertook,interact,similarities,cove,teammate,constituted,painters,tends,madagascar,partnerships,afghan,personalities,attained,rebounds,masses,synagogue,reopened,asylum,embedded,imaging,catalogue,defenders,taxonomy,fiber,afterward,appealed,communists,lisbon,rica,judaism,adviser,batsman,ecological,commands,lgbt,cooling,accessed,wards,shiva,employs,thirds,scenic,worcester,tallest,contestant,humanities,economist,textile,constituencies,motorway,tram,percussion,cloth,leisure,1880s,baden,flags,resemble,riots,coined,sitcom,composite,implies,daytime,tanzania,penalties,optional,competitor,excluded,steering,reversed,autonomy,reviewer,breakthrough,professionally,damages,pomeranian,deputies,valleys,ventures,highlighted,electorate,mapping,shortened,executives,tertiary,specimen,launching,bibliography,sank,pursuing,binary,descendant,marched,natives,ideology,turks,adolf,archdiocese,tribunal,exceptional,nigerian,preference,fails,loading,comeback,vacuum,favored,alter,remnants,consecrated,spectators,trends,patriarch,feedback,paved,sentences,councillor,astronomy,advocates,broader,commentator,commissions,identifying,revealing,theatres,incomplete,enables,constituent,reformation,tract,haiti,atmospheric,screened,explosive,czechoslovakia,acids,symbolic,subdivision,liberals,incorporate,challenger,erie,filmmaker,laps,kazakhstan,organizational,evolutionary,chemicals,dedication,riverside,fauna,moths,maharashtra,annexed,gen.,resembles,underwater,garnered,timeline,remake,suited,educator,hectares,automotive,feared,latvia,finalist,narrator,portable,airways,plaque,designing,villagers,licensing,flank,statues,struggles,deutsche,migrated,cellular,jacksonville,wimbledon,defining,highlight,preparatory,planets,cologne,employ,frequencies,detachment,readily,libya,resign,halt,helicopters,reef,landmarks,collaborative,irregular,retaining,helsinki,folklore,weakened,viscount,interred,professors,memorable,mega,repertoire,rowing,dorsal,albeit,progressed,operative,coronation,liner,telugu,domains,philharmonic,detect,bengali,synthetic,tensions,atlas,dramatically,paralympics,xbox,shire,kiev,lengthy,sued,notorious,seas,screenwriter,transfers,aquatic,pioneers,unesco,radius,abundant,tunnels,syndicated,inventor,accreditation,janeiro,exeter,ceremonial,omaha,cadet,predators,resided,prose,slavic,precision,abbot,deity,engaging,cambodia,estonian,compliance,demonstrations,protesters,reactor,commodore,successes,chronicles,mare,extant,listings,minerals,tonnes,parody,cultivated,traders,pioneering,supplement,slovak,preparations,collision,partnered,vocational,atoms,malayalam,welcomed,documentation,curved,functioning,presently,formations,incorporates,nazis,botanical,nucleus,ethical,greeks,metric,automated,whereby,stance,europeans,duet,disability,purchasing,email,telescope,displaced,sodium,comparative,processor,inning,precipitation,aesthetic,import,coordination,feud,alternatively,mobility,tibet,regained,succeeding,hierarchy,apostolic,catalog,reproduction,inscriptions,vicar,clusters,posthumously,rican,loosely,additions,photographic,nowadays,selective,derivative,keyboards,guides,collectively,affecting,combines,operas,networking,decisive,terminated,continuity,finishes,ancestor,consul,heated,simulation,leipzig,incorporating,georgetown,formula_2,circa,forestry,portrayal,councillors,advancement,complained,forewings,confined,transaction,definitions,reduces,televised,1890s,rapids,phenomena,belarus,alps,landscapes,quarterly,specifications,commemorate,continuation,isolation,antenna,downstream,patents,ensuing,tended,saga,lifelong,columnist,labeled,gymnastics,papua,anticipated,demise,encompasses,madras,antarctica,interval,icon,rams,midlands,ingredients,priory,strengthen,rouge,explicit,gaza,aging,securing,anthropology,listeners,adaptations,underway,vista,malay,fortified,lightweight,violations,concerto,financed,jesuit,observers,trustee,descriptions,nordic,resistant,opted,accepts,prohibition,andhra,inflation,negro,wholly,imagery,spur,instructed,gloucester,cycles,middlesex,destroyers,statewide,evacuated,hyderabad,peasants,mice,shipyard,coordinate,pitching,colombian,exploring,numbering,compression,countess,hiatus,exceed,raced,archipelago,traits,soils,o'connor,vowel,android,facto,angola,amino,holders,logistics,circuits,emergence,kuwait,partition,emeritus,outcomes,submission,promotes,barack,negotiated,loaned,stripped,50th,excavations,treatments,fierce,participant,exports,decommissioned,cameo,remarked,residences,fuselage,mound,undergo,quarry,node,midwest,specializing,occupies,etc.,showcase,molecule,offs,modules,salon,exposition,revision,peers,positioned,hunters,competes,algorithms,reside,zagreb,calcium,uranium,silicon,airs,counterpart,outlet,collectors,sufficiently,canberra,inmates,anatomy,ensuring,curves,aviv,firearms,basque,volcano,thrust,sheikh,extensions,installations,aluminum,darker,sacked,emphasized,aligned,asserted,pseudonym,spanning,decorations,eighteenth,orbital,spatial,subdivided,notation,decay,macedonian,amended,declining,cyclist,feat,unusually,commuter,birthplace,latitude,activation,overhead,30th,finalists,whites,encyclopedia,tenor,qatar,survives,complement,concentrations,uncommon,astronomical,bangalore,pius,genome,memoir,recruit,prosecutor,modification,paired,container,basilica,arlington,displacement,germanic,mongolia,proportional,debates,matched,calcutta,rows,tehran,aerospace,prevalent,arise,lowland,24th,spokesman,supervised,advertisements,clash,tunes,revelation,wanderers,quarterfinals,fisheries,steadily,memoirs,pastoral,renewable,confluence,acquiring,strips,slogan,upstream,scouting,analyst,practitioners,turbine,strengthened,heavier,prehistoric,plural,excluding,isles,persecution,turin,rotating,villain,hemisphere,unaware,arabs,corpus,relied,singular,unanimous,schooling,passive,angles,dominance,instituted,aria,outskirts,balanced,beginnings,financially,structured,parachute,viewer,attitudes,subjected,escapes,derbyshire,erosion,addressing,styled,declaring,originating,colts,adjusted,stained,occurrence,fortifications,baghdad,nitrogen,localities,yemen,galway,debris,lodz,victorious,pharmaceutical,substances,unnamed,dwelling,atop,developmental,activism,voter,refugee,forested,relates,overlooking,genocide,kannada,insufficient,oversaw,partisan,dioxide,recipients,factions,mortality,capped,expeditions,receptors,reorganized,prominently,atom,flooded,flute,orchestral,scripts,mathematician,airplay,detached,rebuilding,dwarf,brotherhood,salvation,expressions,arabian,cameroon,poetic,recruiting,bundesliga,inserted,scrapped,disabilities,evacuation,pasha,undefeated,crafts,rituals,aluminium,norm,pools,submerged,occupying,pathway,exams,prosperity,wrestlers,promotions,basal,permits,nationalism,trim,merge,gazette,tributaries,transcription,caste,porto,emerge,modeled,adjoining,counterparts,paraguay,redevelopment,renewal,unreleased,equilibrium,similarity,minorities,soviets,comprise,nodes,tasked,unrelated,expired,johan,precursor,examinations,electrons,socialism,exiled,admiralty,floods,wigan,nonprofit,lacks,brigades,screens,repaired,hanover,fascist,labs,osaka,delays,judged,statutory,colt,col.,offspring,solving,bred,assisting,retains,somalia,grouped,corresponds,tunisia,chaplain,eminent,chord,22nd,spans,viral,innovations,possessions,mikhail,kolkata,icelandic,implications,introduces,racism,workforce,alto,compulsory,admits,censorship,onset,reluctant,inferior,iconic,progression,liability,turnout,satellites,behavioral,coordinated,exploitation,posterior,averaging,fringe,krakow,mountainous,greenwich,para,plantations,reinforcements,offerings,famed,intervals,constraints,individually,nutrition,1870s,taxation,threshold,tomatoes,fungi,contractor,ethiopian,apprentice,diabetes,wool,gujarat,honduras,norse,bucharest,23rd,arguably,accompany,prone,teammates,perennial,vacancy,polytechnic,deficit,okinawa,functionality,reminiscent,tolerance,transferring,myanmar,concludes,neighbours,hydraulic,economically,slower,plots,charities,synod,investor,catholicism,identifies,bronx,interpretations,adverse,judiciary,hereditary,nominal,sensor,symmetry,cubic,triangular,tenants,divisional,outreach,representations,passages,undergoing,cartridge,testified,exceeded,impacts,limiting,railroads,defeats,regain,rendering,humid,retreated,reliability,governorate,antwerp,infamous,implied,packaging,lahore,trades,billed,extinction,ecole,rejoined,recognizes,projection,qualifications,stripes,forts,socially,lexington,accurately,sexuality,westward,wikipedia,pilgrimage,abolition,choral,stuttgart,nests,expressing,strikeouts,assessed,monasteries,reconstructed,humorous,marxist,fertile,consort,urdu,patronage,peruvian,devised,lyric,baba,nassau,communism,extraction,popularly,markings,inability,litigation,accounted,processed,emirates,tempo,cadets,eponymous,contests,broadly,oxide,courtyard,frigate,directory,apex,outline,regency,chiefly,patrols,secretariat,cliffs,residency,privy,armament,australians,dorset,geometric,genetics,scholarships,fundraising,flats,demographic,multimedia,captained,documentaries,updates,canvas,blockade,guerrilla,songwriting,administrators,intake,drought,implementing,fraction,cannes,refusal,inscribed,meditation,announcing,exported,ballots,formula_3,curator,basel,arches,flour,subordinate,confrontation,gravel,simplified,berkshire,patriotic,tuition,employing,servers,castile,posting,combinations,discharged,miniature,mutations,constellation,incarnation,ideals,necessity,granting,ancestral,crowds,pioneered,mormon,methodology,rama,indirect,complexes,bavarian,patrons,uttar,skeleton,bollywood,flemish,viable,bloc,breeds,triggered,sustainability,tailed,referenced,comply,takeover,latvian,homestead,platoon,communal,nationality,excavated,targeting,sundays,posed,physicist,turret,endowment,marginal,dispatched,commentators,renovations,attachment,collaborations,ridges,barriers,obligations,shareholders,prof.,defenses,presided,rite,backgrounds,arbitrary,affordable,gloucestershire,thirteenth,inlet,miniseries,possesses,detained,pressures,subscription,realism,solidarity,proto,postgraduate,noun,burmese,abundance,homage,reasoning,anterior,robust,fencing,shifting,vowels,garde,profitable,loch,anchored,coastline,samoa,terminology,prostitution,magistrate,venezuelan,speculated,regulate,fixture,colonists,digit,induction,manned,expeditionary,computational,centennial,principally,vein,preserving,engineered,numerical,cancellation,conferred,continually,borne,seeded,advertisement,unanimously,treaties,infections,ions,sensors,lowered,amphibious,lava,fourteenth,bahrain,niagara,nicaragua,squares,congregations,26th,periodic,proprietary,1860s,contributors,seller,overs,emission,procession,presumed,illustrator,zinc,gases,tens,applicable,stretches,reproductive,sixteenth,apparatus,accomplishments,canoe,guam,oppose,recruitment,accumulated,limerick,namibia,staging,remixes,ordnance,uncertainty,pedestrian,temperate,treason,deposited,registry,cerambycidae,attracting,lankan,reprinted,shipbuilding,homosexuality,neurons,eliminating,1900s,resume,ministries,beneficial,blackpool,surplus,northampton,licenses,constructing,announcer,standardized,alternatives,taipei,inadequate,failures,yields,medalist,titular,obsolete,torah,burlington,predecessors,lublin,retailers,castles,depiction,issuing,gubernatorial,propulsion,tiles,damascus,discs,alternating,pomerania,peasant,tavern,redesignated,27th,illustration,focal,mans,codex,specialists,productivity,antiquity,controversies,promoter,pits,companions,behaviors,lyrical,prestige,creativity,swansea,dramas,approximate,feudal,tissues,crude,campaigned,unprecedented,chancel,amendments,surroundings,allegiance,exchanges,align,firmly,optimal,commenting,reigning,landings,obscure,1850s,contemporaries,paternal,devi,endurance,communes,incorporation,denominations,exchanged,routing,resorts,amnesty,slender,explores,suppression,heats,pronunciation,centred,coupe,stirling,freelance,treatise,linguistics,laos,informs,discovering,pillars,encourages,halted,robots,definitive,maturity,tuberculosis,venetian,silesian,unchanged,originates,mali,lincolnshire,quotes,seniors,premise,contingent,distribute,danube,gorge,logging,dams,curling,seventeenth,specializes,wetlands,deities,assess,thickness,rigid,culminated,utilities,substrate,insignia,nile,assam,shri,currents,suffrage,canadians,mortar,asteroid,bosnian,discoveries,enzymes,sanctioned,replica,hymn,investigators,tidal,dominate,derivatives,converting,leinster,verbs,honoured,criticisms,dismissal,discrete,masculine,reorganization,unlimited,wurttemberg,sacks,allocation,bahn,jurisdictions,participates,lagoon,famine,communion,culminating,surveyed,shortage,cables,intersects,cassette,foremost,adopting,solicitor,outright,bihar,reissued,farmland,dissertation,turnpike,baton,photographed,christchurch,kyoto,finances,rails,histories,linebacker,kilkenny,accelerated,dispersed,handicap,absorption,rancho,ceramic,captivity,cites,font,weighed,mater,utilize,bravery,extract,validity,slovenian,seminars,discourse,ranged,duel,ironically,warships,sega,temporal,surpassed,prolonged,recruits,northumberland,greenland,contributes,patented,eligibility,unification,discusses,reply,translates,beirut,relies,torque,northward,reviewers,monastic,accession,neural,tramway,heirs,sikh,subscribers,amenities,taliban,audit,rotterdam,wagons,kurdish,favoured,combustion,meanings,persia,browser,diagnostic,niger,formula_4,denomination,dividing,parameter,branding,badminton,leningrad,sparked,hurricanes,beetles,propeller,mozambique,refined,diagram,exhaust,vacated,readings,markers,reconciliation,determines,concurrent,imprint,primera,organism,demonstrating,filmmakers,vanderbilt,affiliates,traction,evaluated,defendants,megachile,investigative,zambia,assassinated,rewarded,probable,staffordshire,foreigners,directorate,nominees,consolidation,commandant,reddish,differing,unrest,drilling,bohemia,resembling,instrumentation,considerations,haute,promptly,variously,dwellings,clans,tablet,enforced,cockpit,semifinal,hussein,prisons,ceylon,emblem,monumental,phrases,correspond,crossover,outlined,characterised,acceleration,caucus,crusade,protested,composing,rajasthan,habsburg,rhythmic,interception,inherent,cooled,ponds,spokesperson,gradual,consultation,kuala,globally,suppressed,builders,avengers,suffix,integer,enforce,fibers,unionist,proclamation,uncovered,infrared,adapt,eisenhower,utilizing,captains,stretched,observing,assumes,prevents,analyses,saxophone,caucasus,notices,villains,dartmouth,mongol,hostilities,stretching,veterinary,lenses,texture,prompting,overthrow,excavation,islanders,masovian,battleship,biographer,replay,degradation,departing,luftwaffe,fleeing,oversight,immigrated,serbs,fishermen,strengthening,respiratory,italians,denotes,radial,escorted,motif,wiltshire,expresses,accessories,reverted,establishments,inequality,protocols,charting,famously,satirical,entirety,trench,friction,atletico,sampling,subset,weekday,upheld,sharply,correlation,incorrect,mughal,travelers,hasan,earnings,offset,evaluate,specialised,recognizing,flexibility,nagar,postseason,algebraic,capitalism,crystals,melodies,polynomial,racecourse,defences,austro,wembley,attracts,anarchist,resurrection,reviewing,decreasing,prefix,ratified,mutation,displaying,separating,restoring,assemblies,ordinance,priesthood,cruisers,appoint,moldova,imports,directive,epidemic,militant,senegal,signaling,restriction,critique,retrospective,nationalists,undertake,sioux,canals,algerian,redesigned,philanthropist,depict,conceptual,turbines,intellectuals,eastward,applicants,contractors,vendors,undergone,namesake,ensured,tones,substituted,hindwings,arrests,tombs,transitional,principality,reelection,taiwanese,cavity,manifesto,broadcasters,spawned,thoroughbred,identities,generators,proposes,hydroelectric,johannesburg,cortex,scandinavian,killings,aggression,boycott,catalyst,physiology,fifteenth,waterfront,chromosome,organist,costly,calculation,cemeteries,flourished,recognise,juniors,merging,disciples,ashore,workplace,enlightenment,diminished,debated,hailed,podium,educate,mandated,distributor,litre,electromagnetic,flotilla,estuary,peterborough,staircase,selections,melodic,confronts,wholesale,integrate,intercepted,catalonia,unite,immense,palatinate,switches,earthquakes,occupational,successors,praising,concluding,faculties,firstly,overhaul,empirical,metacritic,inauguration,evergreen,laden,winged,philosophers,amalgamated,geoff,centimeters,napoleonic,upright,planting,brewing,fined,sensory,migrants,wherein,inactive,headmaster,warwickshire,siberia,terminals,denounced,academia,divinity,bilateral,clive,omitted,peerage,relics,apartheid,syndicate,fearing,fixtures,desirable,dismantled,ethnicity,valves,biodiversity,aquarium,ideological,visibility,creators,analyzed,tenant,balkan,postwar,supplier,smithsonian,risen,morphology,digits,bohemian,wilmington,vishnu,demonstrates,aforementioned,biographical,mapped,khorasan,phosphate,presentations,ecosystem,processors,calculations,mosaic,clashes,penned,recalls,coding,angular,lattice,macau,accountability,extracted,pollen,therapeutic,overlap,violinist,deposed,candidacy,infants,covenant,bacterial,restructuring,dungeons,ordination,conducts,builds,invasive,customary,concurrently,relocation,cello,statutes,borneo,entrepreneurs,sanctions,packet,rockefeller,piedmont,comparisons,waterfall,receptions,glacial,surge,signatures,alterations,advertised,enduring,somali,botanist,100th,canonical,motifs,longitude,circulated,alloy,indirectly,margins,preserves,internally,besieged,shale,peripheral,drained,baseman,reassigned,tobago,soloist,socio,grazing,contexts,roofs,portraying,ottomans,shrewsbury,noteworthy,lamps,supplying,beams,qualifier,portray,greenhouse,stronghold,hitter,rites,cretaceous,urging,derive,nautical,aiming,fortunes,verde,donors,reliance,exceeding,exclusion,exercised,simultaneous,continents,guiding,pillar,gradient,poznan,eruption,clinics,moroccan,indicator,trams,piers,parallels,fragment,teatro,potassium,satire,compressed,businessmen,influx,seine,perspectives,shelters,decreases,mounting,formula_5,confederacy,equestrian,expulsion,mayors,liberia,resisted,affinity,shrub,unexpectedly,stimulus,amtrak,deported,perpendicular,statesman,wharf,storylines,romanesque,weights,surfaced,interceptions,dhaka,crambidae,orchestras,rwanda,conclude,constitutes,subsidiaries,admissions,prospective,shear,bilingual,campaigning,presiding,domination,commemorative,trailing,confiscated,petrol,acquisitions,polymer,onlyinclude,chloride,elevations,resolutions,hurdles,pledged,likelihood,objected,erect,encoding,databases,aristotle,hindus,marshes,bowled,ministerial,grange,acronym,annexation,squads,ambient,pilgrims,botany,sofla,astronomer,planetary,descending,bestowed,ceramics,diplomacy,metabolism,colonization,potomac,africans,engraved,recycling,commitments,resonance,disciplinary,jamaican,narrated,spectral,tipperary,waterford,stationary,arbitration,transparency,threatens,crossroads,slalom,oversee,centenary,incidence,economies,livery,moisture,newsletter,autobiographical,bhutan,propelled,dependence,moderately,adobe,barrels,subdivisions,outlook,labelled,stratford,arising,diaspora,barony,automobiles,ornamental,slated,norms,primetime,generalized,analysts,vectors,libyan,yielded,certificates,rooted,vernacular,belarusian,marketplace,prediction,fairfax,malawi,viruses,wooded,demos,mauritius,prosperous,coincided,liberties,huddersfield,ascent,warnings,hinduism,glucose,pulitzer,unused,filters,illegitimate,acquitted,protestants,canopy,staple,psychedelic,winding,abbas,pathways,cheltenham,lagos,niche,invaders,proponents,barred,conversely,doncaster,recession,embraced,rematch,concession,emigration,upgrades,bowls,tablets,remixed,loops,kensington,shootout,monarchs,organizers,harmful,punjabi,broadband,exempt,neolithic,profiles,portrays,parma,cyrillic,quasi,attested,regimental,revive,torpedoes,heidelberg,rhythms,spherical,denote,hymns,icons,theologian,qaeda,exceptionally,reinstated,comune,playhouse,lobbying,grossing,viceroy,delivers,visually,armistice,utrecht,syllable,vertices,analogous,annex,refurbished,entrants,knighted,disciple,rhetoric,detailing,inactivated,ballads,algae,intensified,favourable,sanitation,receivers,pornography,commemorated,cannons,entrusted,manifold,photographers,pueblo,textiles,steamer,myths,marquess,onward,liturgical,romney,uzbekistan,consistency,denoted,hertfordshire,convex,hearings,sulfur,universidad,podcast,selecting,emperors,arises,justices,1840s,mongolian,exploited,termination,digitally,infectious,sedan,symmetric,penal,illustrate,formulation,attribute,problematic,modular,inverse,berth,searches,rutgers,leicestershire,enthusiasts,lockheed,upwards,transverse,accolades,backward,archaeologists,crusaders,nuremberg,defects,ferries,vogue,containers,openings,transporting,separates,lumpur,purchases,attain,wichita,topology,woodlands,deleted,periodically,syntax,overturned,musicals,corp.,strasbourg,instability,nationale,prevailing,cache,marathi,versailles,unmarried,grains,straits,antagonist,segregation,assistants,d'etat,contention,dictatorship,unpopular,motorcycles,criterion,analytical,salzburg,militants,hanged,worcestershire,emphasize,paralympic,erupted,convinces,offences,oxidation,nouns,populace,atari,spanned,hazardous,educators,playable,births,baha'i,preseason,generates,invites,meteorological,handbook,foothills,enclosure,diffusion,mirza,convergence,geelong,coefficient,connector,formula_6,cylindrical,disasters,pleaded,knoxville,contamination,compose,libertarian,arrondissement,franciscan,intercontinental,susceptible,initiation,malaria,unbeaten,consonants,waived,saloon,popularized,estadio,pseudo,interdisciplinary,transports,transformers,carriages,bombings,revolves,ceded,collaborator,celestial,exemption,colchester,maltese,oceanic,ligue,crete,shareholder,routed,depictions,ridden,advisors,calculate,lending,guangzhou,simplicity,newscast,scheduling,snout,eliot,undertaking,armenians,nottinghamshire,whitish,consulted,deficiency,salle,cinemas,superseded,rigorous,kerman,convened,landowners,modernization,evenings,pitches,conditional,scandinavia,differed,formulated,cyclists,swami,guyana,dunes,electrified,appalachian,abdomen,scenarios,prototypes,sindh,consonant,adaptive,boroughs,wolverhampton,modelling,cylinders,amounted,minimize,ambassadors,lenin,settler,coincide,approximation,grouping,murals,bullying,registers,rumours,engagements,energetic,vertex,annals,bordering,geologic,yellowish,runoff,converts,allegheny,facilitated,saturdays,colliery,monitored,rainforest,interfaces,geographically,impaired,prevalence,joachim,paperback,slowed,shankar,distinguishing,seminal,categorized,authorised,auspices,bandwidth,asserts,rebranded,balkans,supplemented,seldom,weaving,capsule,apostles,populous,monmouth,payload,symphonic,densely,shoreline,managerial,masonry,antioch,averages,textbooks,royalist,coliseum,tandem,brewers,diocesan,posthumous,walled,incorrectly,distributions,ensued,reasonably,graffiti,propagation,automation,harmonic,augmented,middleweight,limbs,elongated,landfall,comparatively,literal,grossed,koppen,wavelength,1830s,cerebral,boasts,congestion,physiological,practitioner,coasts,cartoonist,undisclosed,frontal,launches,burgundy,qualifiers,imposing,stade,flanked,assyrian,raided,multiplayer,montane,chesapeake,pathology,drains,vineyards,intercollegiate,semiconductor,grassland,convey,citations,predominant,rejects,benefited,yahoo,graphs,busiest,encompassing,hamlets,explorers,suppress,minors,graphical,calculus,sediment,intends,diverted,mainline,unopposed,cottages,initiate,alumnus,towed,autism,forums,darlington,modernist,oxfordshire,lectured,capitalist,suppliers,panchayat,actresses,foundry,southbound,commodity,wesleyan,divides,palestinians,luton,caretaker,nobleman,mutiny,organizer,preferences,nomenclature,splits,unwilling,offenders,timor,relying,halftime,semitic,arithmetic,milestone,jesuits,arctiidae,retrieved,consuming,contender,edged,plagued,inclusive,transforming,khmer,federally,insurgents,distributing,amherst,rendition,prosecutors,viaduct,disqualified,kabul,liturgy,prevailed,reelected,instructors,swimmers,aperture,churchyard,interventions,totals,darts,metropolis,fuels,fluent,northbound,correctional,inflicted,barrister,realms,culturally,aristocratic,collaborating,emphasizes,choreographer,inputs,ensembles,humboldt,practised,endowed,strains,infringement,archaeologist,congregational,magna,relativity,efficiently,proliferation,mixtape,abruptly,regeneration,commissioning,yukon,archaic,reluctantly,retailer,northamptonshire,universally,crossings,boilers,nickelodeon,revue,abbreviation,retaliation,scripture,routinely,medicinal,benedictine,kenyan,retention,deteriorated,glaciers,apprenticeship,coupling,researched,topography,entrances,anaheim,pivotal,compensate,arched,modify,reinforce,dusseldorf,journeys,motorsport,conceded,sumatra,spaniards,quantitative,loire,cinematography,discarded,botswana,morale,engined,zionist,philanthropy,sainte,fatalities,cypriot,motorsports,indicators,pricing,institut,bethlehem,implicated,gravitational,differentiation,rotor,thriving,precedent,ambiguous,concessions,forecast,conserved,fremantle,asphalt,landslide,middlesbrough,formula_7,humidity,overseeing,chronological,diaries,multinational,crimean,turnover,improvised,youths,declares,tasmanian,canadiens,fumble,refinery,weekdays,unconstitutional,upward,guardians,brownish,imminent,hamas,endorsement,naturalist,martyrs,caledonia,chords,yeshiva,reptiles,severity,mitsubishi,fairs,installment,substitution,repertory,keyboardist,interpreter,silesia,noticeable,rhineland,transmit,inconsistent,booklet,academies,epithet,pertaining,progressively,aquatics,scrutiny,prefect,toxicity,rugged,consume,o'donnell,evolve,uniquely,cabaret,mediated,landowner,transgender,palazzo,compilations,albuquerque,induce,sinai,remastered,efficacy,underside,analogue,specify,possessing,advocating,compatibility,liberated,greenville,mecklenburg,header,memorials,sewage,rhodesia,1800s,salaries,atoll,coordinating,partisans,repealed,amidst,subjective,optimization,nectar,evolving,exploits,madhya,styling,accumulation,raion,postage,responds,buccaneers,frontman,brunei,choreography,coated,kinetic,sampled,inflammatory,complementary,eclectic,norte,vijay,a.k.a,mainz,casualty,connectivity,laureate,franchises,yiddish,reputed,unpublished,economical,periodicals,vertically,bicycles,brethren,capacities,unitary,archeological,tehsil,domesday,wehrmacht,justification,angered,mysore,fielded,abuses,nutrients,ambitions,taluk,battleships,symbolism,superiority,neglect,attendees,commentaries,collaborators,predictions,yorker,breeders,investing,libretto,informally,coefficients,memorandum,pounder,collingwood,tightly,envisioned,arbor,mistakenly,captures,nesting,conflicting,enhancing,streetcar,manufactures,buckinghamshire,rewards,commemorating,stony,expenditure,tornadoes,semantic,relocate,weimar,iberian,sighted,intending,ensign,beverages,expectation,differentiate,centro,utilizes,saxophonist,catchment,transylvania,ecosystems,shortest,sediments,socialists,ineffective,kapoor,formidable,heroine,guantanamo,prepares,scattering,pamphlet,verified,elector,barons,totaling,shrubs,pyrenees,amalgamation,mutually,longitudinal,comte,negatively,masonic,envoy,sexes,akbar,mythical,tonga,bishopric,assessments,malaya,warns,interiors,reefs,reflections,neutrality,musically,nomadic,waterways,provence,collaborate,scaled,adulthood,emerges,euros,optics,incentives,overland,periodical,liege,awarding,realization,slang,affirmed,schooner,hokkaido,czechoslovak,protectorate,undrafted,disagreed,commencement,electors,spruce,swindon,fueled,equatorial,inventions,suites,slovene,backdrop,adjunct,energies,remnant,inhabit,alliances,simulcast,reactors,mosques,travellers,outfielder,plumage,migratory,benin,experimented,fibre,projecting,drafting,laude,evidenced,northernmost,indicted,directional,replication,croydon,comedies,jailed,organizes,devotees,reservoirs,turrets,originate,economists,songwriters,junta,trenches,mounds,proportions,comedic,apostle,azerbaijani,farmhouse,resembled,disrupted,playback,mixes,diagonal,relevance,govern,programmer,gdansk,maize,soundtracks,tendencies,mastered,impacted,believers,kilometre,intervene,chairperson,aerodrome,sails,subsidies,ensures,aesthetics,congresses,ratios,sardinia,southernmost,functioned,controllers,downward,randomly,distortion,regents,palatine,disruption,spirituality,vidhan,tracts,compiler,ventilation,anchorage,symposium,assert,pistols,excelled,avenues,convoys,moniker,constructions,proponent,phased,spines,organising,schleswig,policing,campeonato,mined,hourly,croix,lucrative,authenticity,haitian,stimulation,burkina,espionage,midfield,manually,staffed,awakening,metabolic,biographies,entrepreneurship,conspicuous,guangdong,preface,subgroup,mythological,adjutant,feminism,vilnius,oversees,honourable,tripoli,stylized,kinase,societe,notoriety,altitudes,configurations,outward,transmissions,announces,auditor,ethanol,clube,nanjing,mecca,haifa,blogs,postmaster,paramilitary,depart,positioning,potent,recognizable,spire,brackets,remembrance,overlapping,turkic,articulated,scientology,operatic,deploy,readiness,biotechnology,restrict,cinematographer,inverted,synonymous,administratively,westphalia,commodities,replaces,downloads,centralized,munitions,preached,sichuan,fashionable,implementations,matrices,hiv/aids,loyalist,luzon,celebrates,hazards,heiress,mercenaries,synonym,creole,ljubljana,technician,auditioned,technicians,viewpoint,wetland,mongols,princely,sharif,coating,dynasties,southward,doubling,formula_8,mayoral,harvesting,conjecture,goaltender,oceania,spokane,welterweight,bracket,gatherings,weighted,newscasts,mussolini,affiliations,disadvantage,vibrant,spheres,sultanate,distributors,disliked,establishes,marches,drastically,yielding,jewellery,yokohama,vascular,airlift,canons,subcommittee,repression,strengths,graded,outspoken,fused,pembroke,filmography,redundant,fatigue,repeal,threads,reissue,pennant,edible,vapor,corrections,stimuli,commemoration,dictator,anand,secession,amassed,orchards,pontifical,experimentation,greeted,bangor,forwards,decomposition,quran,trolley,chesterfield,traverse,sermons,burials,skier,climbs,consultants,petitioned,reproduce,parted,illuminated,kurdistan,reigned,occupants,packaged,geometridae,woven,regulating,protagonists,crafted,affluent,clergyman,consoles,migrant,supremacy,attackers,caliph,defect,convection,rallies,huron,resin,segunda,quota,warship,overseen,criticizing,shrines,glamorgan,lowering,beaux,hampered,invasions,conductors,collects,bluegrass,surrounds,substrates,perpetual,chronology,pulmonary,executions,crimea,compiling,noctuidae,battled,tumors,minsk,novgorod,serviced,yeast,computation,swamps,theodor,baronetcy,salford,uruguayan,shortages,odisha,siberian,novelty,cinematic,invitational,decks,dowager,oppression,bandits,appellate,state-of-the-art,clade,palaces,signalling,galaxies,industrialist,tensor,learnt,incurred,magistrates,binds,orbits,ciudad,willingness,peninsular,basins,biomedical,shafts,marlborough,bournemouth,withstand,fitzroy,dunedin,variance,steamship,integrating,muscular,fines,akron,bulbophyllum,malmo,disclosed,cornerstone,runways,medicines,twenty20,gettysburg,progresses,frigates,bodied,transformations,transforms,helens,modelled,versatile,regulator,pursuits,legitimacy,amplifier,scriptures,voyages,examines,presenters,octagonal,poultry,formula_9,anatolia,computed,migrate,directorial,hybrids,localized,preferring,guggenheim,persisted,grassroots,inflammation,fishery,otago,vigorous,professions,instructional,inexpensive,insurgency,legislators,sequels,surnames,agrarian,stainless,nairobi,minas,forerunner,aristocracy,transitions,sicilian,showcased,doses,hiroshima,summarized,gearbox,emancipation,limitation,nuclei,seismic,abandonment,dominating,appropriations,occupations,electrification,hilly,contracting,exaggerated,entertainer,kazan,oricon,cartridges,characterization,parcel,maharaja,exceeds,aspiring,obituary,flattened,contrasted,narration,replies,oblique,outpost,fronts,arranger,talmud,keynes,doctrines,endured,confesses,fortification,supervisors,kilometer,academie,jammu,bathurst,piracy,prostitutes,navarre,cumulative,cruises,lifeboat,twinned,radicals,interacting,expenditures,wexford,libre,futsal,curated,clockwise,colloquially,procurement,immaculate,lyricist,enhancement,porcelain,alzheimer,highlighting,judah,disagreements,storytelling,sheltered,wroclaw,vaudeville,contrasts,neoclassical,compares,contrasting,deciduous,francaise,descriptive,cyclic,reactive,antiquities,meiji,repeats,creditors,forcibly,newmarket,picturesque,impending,uneven,bison,raceway,solvent,ecumenical,optic,professorship,harvested,waterway,banjo,pharaoh,geologist,scanning,dissent,recycled,unmanned,retreating,gospels,aqueduct,branched,tallinn,groundbreaking,syllables,hangar,designations,procedural,craters,cabins,encryption,anthropologist,montevideo,outgoing,inverness,chattanooga,fascism,calais,chapels,groundwater,downfall,misleading,robotic,tortricidae,pixel,handel,prohibit,crewe,renaming,reprised,kickoff,leftist,spaced,integers,causeway,pines,authorship,organise,ptolemy,accessibility,virtues,lesions,iroquois,qur'an,atheist,synthesized,biennial,confederates,dietary,skaters,stresses,tariff,koreans,intercity,republics,quintet,baroness,naive,amplitude,insistence,tbilisi,residues,grammatical,diversified,egyptians,accompaniment,vibration,repository,mandal,topological,distinctions,coherent,invariant,batters,nuevo,internationals,implements,follower,bahia,widened,independents,cantonese,totaled,guadalajara,wolverines,befriended,muzzle,surveying,hungarians,medici,deportation,rayon,approx,recounts,attends,clerical,hellenic,furnished,alleging,soluble,systemic,gallantry,bolshevik,intervened,hostel,gunpowder,specialising,stimulate,leiden,removes,thematic,floral,bafta,printers,conglomerate,eroded,analytic,successively,lehigh,thessaloniki,kilda,clauses,ascended,nehru,scripted,tokugawa,competence,diplomats,exclude,consecration,freedoms,assaults,revisions,blacksmith,textual,sparse,concacaf,slain,uploaded,enraged,whaling,guise,stadiums,debuting,dormitory,cardiovascular,yunnan,dioceses,consultancy,notions,lordship,archdeacon,collided,medial,airfields,garment,wrestled,adriatic,reversal,refueling,verification,jakob,horseshoe,intricate,veracruz,sarawak,syndication,synthesizer,anthologies,stature,feasibility,guillaume,narratives,publicized,antrim,intermittent,constituents,grimsby,filmmaking,doping,unlawful,nominally,transmitting,documenting,seater,internationale,ejected,steamboat,alsace,boise,ineligible,geared,vassal,mustered,ville,inline,pairing,eurasian,kyrgyzstan,barnsley,reprise,stereotypes,rushes,conform,firefighters,deportivo,revolutionaries,rabbis,concurrency,charters,sustaining,aspirations,algiers,chichester,falkland,morphological,systematically,volcanoes,designate,artworks,reclaimed,jurist,anglia,resurrected,chaotic,feasible,circulating,simulated,environmentally,confinement,adventist,harrisburg,laborers,ostensibly,universiade,pensions,influenza,bratislava,octave,refurbishment,gothenburg,putin,barangay,annapolis,breaststroke,illustrates,distorted,choreographed,promo,emphasizing,stakeholders,descends,exhibiting,intrinsic,invertebrates,evenly,roundabout,salts,formula_10,strata,inhibition,branching,stylistic,rumored,realises,mitochondrial,commuted,adherents,logos,bloomberg,telenovela,guineas,charcoal,engages,winery,reflective,siena,cambridgeshire,ventral,flashback,installing,engraving,grasses,traveller,rotated,proprietor,nationalities,precedence,sourced,trainers,cambodian,reductions,depleted,saharan,classifications,biochemistry,plaintiffs,arboretum,humanist,fictitious,aleppo,climates,bazaar,his/her,homogeneous,multiplication,moines,indexed,linguist,skeletal,foliage,societal,differentiated,informing,mammal,infancy,archival,cafes,malls,graeme,musee,schizophrenia,fargo,pronouns,derivation,descend,ascending,terminating,deviation,recaptured,confessions,weakening,tajikistan,bahadur,pasture,b/hip,donegal,supervising,sikhs,thinkers,euclidean,reinforcement,friars,portage,fuscous,lucknow,synchronized,assertion,choirs,privatization,corrosion,multitude,skyscraper,royalties,ligament,usable,spores,directs,clashed,stockport,fronted,dependency,contiguous,biologist,backstroke,powerhouse,frescoes,phylogenetic,welding,kildare,gabon,conveyed,augsburg,severn,continuum,sahib,lille,injuring,passeriformesfamily,succeeds,translating,unitarian,startup,turbulent,outlying,philanthropic,stanislaw,idols,claremont,conical,haryana,armagh,blended,implicit,conditioned,modulation,rochdale,labourers,coinage,shortstop,potsdam,gears,obesity,bestseller,advisers,bouts,comedians,jozef,lausanne,taxonomic,correlated,columbian,marne,indications,psychologists,libel,edict,beaufort,disadvantages,renal,finalized,racehorse,unconventional,disturbances,falsely,zoology,adorned,redesign,executing,narrower,commended,appliances,stalls,resurgence,saskatoon,miscellaneous,permitting,epoch,formula_11,cumbria,forefront,vedic,eastenders,disposed,supermarkets,rower,inhibitor,magnesium,colourful,yusuf,harrow,formulas,centrally,balancing,ionic,nocturnal,consolidate,ornate,raiding,charismatic,accelerate,nominate,residual,dhabi,commemorates,attribution,uninhabited,mindanao,atrocities,genealogical,romani,applicant,enactment,abstraction,trough,pulpit,minuscule,misconduct,grenades,timely,supplements,messaging,curvature,ceasefire,telangana,susquehanna,braking,redistribution,shreveport,neighbourhoods,gregorian,widowed,khuzestan,empowerment,scholastic,evangelist,peptide,topical,theorist,historia,thence,sudanese,museo,jurisprudence,masurian,frankish,headlined,recounted,netball,petitions,tolerant,hectare,truncated,southend,methane,captives,reigns,massif,subunit,acidic,weightlifting,footballers,sabah,britannia,tunisian,segregated,sawmill,withdrawing,unpaid,weaponry,somme,perceptions,unicode,alcoholism,durban,wrought,waterfalls,jihad,auschwitz,upland,eastbound,adjective,anhalt,evaluating,regimes,guildford,reproduced,pamphlets,hierarchical,maneuvers,hanoi,fabricated,repetition,enriched,arterial,replacements,tides,globalization,adequately,westbound,satisfactory,fleets,phosphorus,lastly,neuroscience,anchors,xinjiang,membranes,improvisation,shipments,orthodoxy,submissions,bolivian,mahmud,ramps,leyte,pastures,outlines,flees,transmitters,fares,sequential,stimulated,novice,alternately,symmetrical,breakaway,layered,baronets,lizards,blackish,edouard,horsepower,penang,principals,mercantile,maldives,overwhelmingly,hawke,rallied,prostate,conscription,juveniles,maccabi,carvings,strikers,sudbury,spurred,improves,lombardy,macquarie,parisian,elastic,distillery,shetland,humane,brentford,wrexham,warehouses,routines,encompassed,introductory,isfahan,instituto,palais,revolutions,sporadic,impoverished,portico,fellowships,speculative,enroll,dormant,adhere,fundamentally,sculpted,meritorious,template,upgrading,reformer,rectory,uncredited,indicative,creeks,galveston,radically,hezbollah,firearm,educating,prohibits,trondheim,locus,refit,headwaters,screenings,lowlands,wasps,coarse,attaining,sedimentary,perished,pitchfork,interned,cerro,stagecoach,aeronautical,liter,transitioned,haydn,inaccurate,legislatures,bromwich,knesset,spectroscopy,butte,asiatic,degraded,concordia,catastrophic,lobes,wellness,pensacola,periphery,hapoel,theta,horizontally,freiburg,liberalism,pleas,durable,warmian,offenses,mesopotamia,shandong,unsuitable,hospitalized,appropriately,phonetic,encompass,conversions,observes,illnesses,breakout,assigns,crowns,inhibitors,nightly,manifestation,fountains,maximize,alphabetical,sloop,expands,newtown,widening,gaddafi,commencing,camouflage,footprint,tyrol,barangays,universite,highlanders,budgets,query,lobbied,westchester,equator,stipulated,pointe,distinguishes,allotted,embankment,advises,storing,loyalists,fourier,rehearsals,starvation,gland,rihanna,tubular,expressive,baccalaureate,intersections,revered,carbonate,eritrea,craftsmen,cosmopolitan,sequencing,corridors,shortlisted,bangladeshi,persians,mimic,parades,repetitive,recommends,flanks,promoters,incompatible,teaming,ammonia,greyhound,solos,improper,legislator,newsweek,recurrent,vitro,cavendish,eireann,crises,prophets,mandir,strategically,guerrillas,formula_12,ghent,contenders,equivalence,drone,sociological,hamid,castes,statehood,aland,clinched,relaunched,tariffs,simulations,williamsburg,rotate,mediation,smallpox,harmonica,lodges,lavish,restrictive,o'sullivan,detainees,polynomials,echoes,intersecting,learners,elects,charlemagne,defiance,epsom,liszt,facilitating,absorbing,revelations,padua,pieter,pious,penultimate,mammalian,montenegrin,supplementary,widows,aromatic,croats,roanoke,trieste,legions,subdistrict,babylonian,grasslands,volga,violently,sparsely,oldies,telecommunication,respondents,quarries,downloadable,commandos,taxpayer,catalytic,malabar,afforded,copying,declines,nawab,junctions,assessing,filtering,classed,disused,compliant,christoph,gottingen,civilizations,hermitage,caledonian,whereupon,ethnically,springsteen,mobilization,terraces,indus,excel,zoological,enrichment,simulate,guitarists,registrar,cappella,invoked,reused,manchu,configured,uppsala,genealogy,mergers,casts,curricular,rebelled,subcontinent,horticultural,parramatta,orchestrated,dockyard,claudius,decca,prohibiting,turkmenistan,brahmin,clandestine,obligatory,elaborated,parasitic,helix,constraint,spearheaded,rotherham,eviction,adapting,albans,rescues,sociologist,guiana,convicts,occurrences,kamen,antennas,asturias,wheeled,sanitary,deterioration,trier,theorists,baseline,announcements,valea,planners,factual,serialized,serials,bilbao,demoted,fission,jamestown,cholera,alleviate,alteration,indefinite,sulfate,paced,climatic,valuation,artisans,proficiency,aegean,regulators,fledgling,sealing,influencing,servicemen,frequented,cancers,tambon,narayan,bankers,clarified,embodied,engraver,reorganisation,dissatisfied,dictated,supplemental,temperance,ratification,puget,nutrient,pretoria,papyrus,uniting,ascribed,cores,coptic,schoolhouse,barrio,1910s,armory,defected,transatlantic,regulates,ported,artefacts,specifies,boasted,scorers,mollusks,emitted,navigable,quakers,projective,dialogues,reunification,exponential,vastly,banners,unsigned,dissipated,halves,coincidentally,leasing,purported,escorting,estimation,foxes,lifespan,inflorescence,assimilation,showdown,staunch,prologue,ligand,superliga,telescopes,northwards,keynote,heaviest,taunton,redeveloped,vocalists,podlaskie,soyuz,rodents,azores,moravian,outset,parentheses,apparel,domestically,authoritative,polymers,monterrey,inhibit,launcher,jordanian,folds,taxis,mandates,singled,liechtenstein,subsistence,marxism,ousted,governorship,servicing,offseason,modernism,prism,devout,translators,islamist,chromosomes,pitted,bedfordshire,fabrication,authoritarian,javanese,leaflets,transient,substantive,predatory,sigismund,assassinate,diagrams,arrays,rediscovered,reclamation,spawning,fjord,peacekeeping,strands,fabrics,highs,regulars,tirana,ultraviolet,athenian,filly,barnet,naacp,nueva,favourites,terminates,showcases,clones,inherently,interpreting,bjorn,finely,lauded,unspecified,chola,pleistocene,insulation,antilles,donetsk,funnel,nutritional,biennale,reactivated,southport,primate,cavaliers,austrians,interspersed,restarted,suriname,amplifiers,wladyslaw,blockbuster,sportsman,minogue,brightness,benches,bridgeport,initiating,israelis,orbiting,newcomers,externally,scaling,transcribed,impairment,luxurious,longevity,impetus,temperament,ceilings,tchaikovsky,spreads,pantheon,bureaucracy,1820s,heraldic,villas,formula_13,galician,meath,avoidance,corresponded,headlining,connacht,seekers,rappers,solids,monograph,scoreless,opole,isotopes,himalayas,parodies,garments,microscopic,republished,havilland,orkney,demonstrators,pathogen,saturated,hellenistic,facilitates,aerodynamic,relocating,indochina,laval,astronomers,bequeathed,administrations,extracts,nagoya,torquay,demography,medicare,ambiguity,renumbered,pursuant,concave,syriac,electrode,dispersal,henan,bialystok,walsall,crystalline,puebla,janata,illumination,tianjin,enslaved,coloration,championed,defamation,grille,johor,rejoin,caspian,fatally,planck,workings,appointing,institutionalized,wessex,modernized,exemplified,regatta,jacobite,parochial,programmers,blending,eruptions,insurrection,regression,indices,sited,dentistry,mobilized,furnishings,levant,primaries,ardent,nagasaki,conqueror,dorchester,opined,heartland,amman,mortally,wellesley,bowlers,outputs,coveted,orthography,immersion,disrepair,disadvantaged,curate,childless,condensed,codice_1,remodeled,resultant,bolsheviks,superfamily,saxons,2010s,contractual,rivalries,malacca,oaxaca,magnate,vertebrae,quezon,olympiad,yucatan,tyres,macro,specialization,commendation,caliphate,gunnery,exiles,excerpts,fraudulent,adjustable,aramaic,interceptor,drumming,standardization,reciprocal,adolescents,federalist,aeronautics,favorably,enforcing,reintroduced,zhejiang,refining,biplane,banknotes,accordion,intersect,illustrating,summits,classmate,militias,biomass,massacres,epidemiology,reworked,wrestlemania,nantes,auditory,taxon,elliptical,chemotherapy,asserting,avoids,proficient,airmen,yellowstone,multicultural,alloys,utilization,seniority,kuyavian,huntsville,orthogonal,bloomington,cultivars,casimir,internment,repulsed,impedance,revolving,fermentation,parana,shutout,partnering,empowered,islamabad,polled,classify,amphibians,greyish,obedience,4x100,projectile,khyber,halfback,relational,d'ivoire,synonyms,endeavour,padma,customized,mastery,defenceman,berber,purge,interestingly,covent,promulgated,restricting,condemnation,hillsborough,walkers,privateer,intra,captaincy,naturalized,huffington,detecting,hinted,migrating,bayou,counterattack,anatomical,foraging,unsafe,swiftly,outdated,paraguayan,attire,masjid,endeavors,jerseys,triassic,quechua,growers,axial,accumulate,wastewater,cognition,fungal,animator,pagoda,kochi,uniformly,antibody,yerevan,hypotheses,combatants,italianate,draining,fragmentation,snowfall,formative,inversion,kitchener,identifier,additive,lucha,selects,ashland,cambrian,racetrack,trapping,congenital,primates,wavelengths,expansions,yeomanry,harcourt,wealthiest,awaited,punta,intervening,aggressively,vichy,piloted,midtown,tailored,heyday,metadata,guadalcanal,inorganic,hadith,pulses,francais,tangent,scandals,erroneously,tractors,pigment,constabulary,jiangsu,landfill,merton,basalt,astor,forbade,debuts,collisions,exchequer,stadion,roofed,flavour,sculptors,conservancy,dissemination,electrically,undeveloped,existent,surpassing,pentecostal,manifested,amend,formula_14,superhuman,barges,tunis,analytics,argyll,liquids,mechanized,domes,mansions,himalayan,indexing,reuters,nonlinear,purification,exiting,timbers,triangles,decommissioning,departmental,causal,fonts,americana,sept.,seasonally,incomes,razavi,sheds,memorabilia,rotational,terre,sutra,protege,yarmouth,grandmaster,annum,looted,imperialism,variability,liquidation,baptised,isotope,showcasing,milling,rationale,hammersmith,austen,streamlined,acknowledging,contentious,qaleh,breadth,turing,referees,feral,toulon,unofficially,identifiable,standout,labeling,dissatisfaction,jurgen,angrily,featherweight,cantons,constrained,dominates,standalone,relinquished,theologians,markedly,italics,downed,nitrate,likened,gules,craftsman,singaporean,pixels,mandela,moray,parity,departement,antigen,academically,burgh,brahma,arranges,wounding,triathlon,nouveau,vanuatu,banded,acknowledges,unearthed,stemming,authentication,byzantines,converge,nepali,commonplace,deteriorating,recalling,palette,mathematicians,greenish,pictorial,ahmedabad,rouen,validation,u.s.a.,'best,malvern,archers,converter,undergoes,fluorescent,logistical,notification,transvaal,illicit,symphonies,stabilization,worsened,fukuoka,decrees,enthusiast,seychelles,blogger,louvre,dignitaries,burundi,wreckage,signage,pinyin,bursts,federer,polarization,urbana,lazio,schism,nietzsche,venerable,administers,seton,kilograms,invariably,kathmandu,farmed,disqualification,earldom,appropriated,fluctuations,kermanshah,deployments,deformation,wheelbase,maratha,psalm,bytes,methyl,engravings,skirmish,fayette,vaccines,ideally,astrology,breweries,botanic,opposes,harmonies,irregularities,contended,gaulle,prowess,constants,aground,filipinos,fresco,ochreous,jaipur,willamette,quercus,eastwards,mortars,champaign,braille,reforming,horned,hunan,spacious,agitation,draught,specialties,flourishing,greensboro,necessitated,swedes,elemental,whorls,hugely,structurally,plurality,synthesizers,embassies,assad,contradictory,inference,discontent,recreated,inspectors,unicef,commuters,embryo,modifying,stints,numerals,communicated,boosted,trumpeter,brightly,adherence,remade,leases,restrained,eucalyptus,dwellers,planar,grooves,gainesville,daimler,anzac,szczecin,cornerback,prized,peking,mauritania,khalifa,motorized,lodging,instrumentalist,fortresses,cervical,formula_15,passerine,sectarian,researches,apprenticed,reliefs,disclose,gliding,repairing,queue,kyushu,literate,canoeing,sacrament,separatist,calabria,parkland,flowed,investigates,statistically,visionary,commits,dragoons,scrolls,premieres,revisited,subdued,censored,patterned,elective,outlawed,orphaned,leyland,richly,fujian,miniatures,heresy,plaques,countered,nonfiction,exponent,moravia,dispersion,marylebone,midwestern,enclave,ithaca,federated,electronically,handheld,microscopy,tolls,arrivals,climbers,continual,cossacks,moselle,deserts,ubiquitous,gables,forecasts,deforestation,vertebrates,flanking,drilled,superstructure,inspected,consultative,bypassed,ballast,subsidy,socioeconomic,relic,grenada,journalistic,administering,accommodated,collapses,appropriation,reclassified,foreword,porte,assimilated,observance,fragmented,arundel,thuringia,gonzaga,shenzhen,shipyards,sectional,ayrshire,sloping,dependencies,promenade,ecuadorian,mangrove,constructs,goalscorer,heroism,iteration,transistor,omnibus,hampstead,cochin,overshadowed,chieftain,scalar,finishers,ghanaian,abnormalities,monoplane,encyclopaedia,characterize,travancore,baronetage,bearers,biking,distributes,paving,christened,inspections,banco,humber,corinth,quadratic,albanians,lineages,majored,roadside,inaccessible,inclination,darmstadt,fianna,epilepsy,propellers,papacy,montagu,bhutto,sugarcane,optimized,pilasters,contend,batsmen,brabant,housemates,sligo,ascot,aquinas,supervisory,accorded,gerais,echoed,nunavut,conservatoire,carniola,quartermaster,gminas,impeachment,aquitaine,reformers,quarterfinal,karlsruhe,accelerator,coeducational,archduke,gelechiidae,seaplane,dissident,frenchman,palau,depots,hardcover,aachen,darreh,denominational,groningen,parcels,reluctance,drafts,elliptic,counters,decreed,airship,devotional,contradiction,formula_16,undergraduates,qualitative,guatemalan,slavs,southland,blackhawks,detrimental,abolish,chechen,manifestations,arthritis,perch,fated,hebei,peshawar,palin,immensely,havre,totalling,rampant,ferns,concourse,triples,elites,olympian,larva,herds,lipid,karabakh,distal,monotypic,vojvodina,batavia,multiplied,spacing,spellings,pedestrians,parchment,glossy,industrialization,dehydrogenase,patriotism,abolitionist,mentoring,elizabethan,figurative,dysfunction,abyss,constantin,middletown,stigma,mondays,gambia,gaius,israelites,renounced,nepalese,overcoming,buren,sulphur,divergence,predation,looting,iberia,futuristic,shelved,anthropological,innsbruck,escalated,clermont,entrepreneurial,benchmark,mechanically,detachments,populist,apocalyptic,exited,embryonic,stanza,readership,chiba,landlords,expansive,boniface,therapies,perpetrators,whitehall,kassel,masts,carriageway,clinch,pathogens,mazandaran,undesirable,teutonic,miocene,nagpur,juris,cantata,compile,diffuse,dynastic,reopening,comptroller,o'neal,flourish,electing,scientifically,departs,welded,modal,cosmology,fukushima,libertadores,chang'an,asean,generalization,localization,afrikaans,cricketers,accompanies,emigrants,esoteric,southwards,shutdown,prequel,fittings,innate,wrongly,equitable,dictionaries,senatorial,bipolar,flashbacks,semitism,walkway,lyrically,legality,sorbonne,vigorously,durga,samoan,karel,interchanges,patna,decider,registering,electrodes,anarchists,excursion,overthrown,gilan,recited,michelangelo,advertiser,kinship,taboo,cessation,formula_17,premiers,traversed,madurai,poorest,torneo,exerted,replicate,spelt,sporadically,horde,landscaping,razed,hindered,esperanto,manchuria,propellant,jalan,baha'is,sikkim,linguists,pandit,racially,ligands,dowry,francophone,escarpment,behest,magdeburg,mainstay,villiers,yangtze,grupo,conspirators,martyrdom,noticeably,lexical,kazakh,unrestricted,utilised,sired,inhabits,proofs,joseon,pliny,minted,buddhists,cultivate,interconnected,reuse,viability,australasian,derelict,resolving,overlooks,menon,stewardship,playwrights,thwarted,filmfare,disarmament,protections,bundles,sidelined,hypothesized,singer/songwriter,forage,netted,chancery,townshend,restructured,quotation,hyperbolic,succumbed,parliaments,shenandoah,apical,kibbutz,storeys,pastors,lettering,ukrainians,hardships,chihuahua,avail,aisles,taluka,antisemitism,assent,ventured,banksia,seamen,hospice,faroe,fearful,woreda,outfield,chlorine,transformer,tatar,panoramic,pendulum,haarlem,styria,cornice,importing,catalyzes,subunits,enamel,bakersfield,realignment,sorties,subordinates,deanery,townland,gunmen,tutelage,evaluations,allahabad,thrace,veneto,mennonite,sharia,subgenus,satisfies,puritan,unequal,gastrointestinal,ordinances,bacterium,horticulture,argonauts,adjectives,arable,duets,visualization,woolwich,revamped,euroleague,thorax,completes,originality,vasco,freighter,sardar,oratory,sects,extremes,signatories,exporting,arisen,exacerbated,departures,saipan,furlongs,d'italia,goring,dakar,conquests,docked,offshoot,okrug,referencing,disperse,netting,summed,rewritten,articulation,humanoid,spindle,competitiveness,preventive,facades,westinghouse,wycombe,synthase,emulate,fostering,abdel,hexagonal,myriad,caters,arjun,dismay,axiom,psychotherapy,colloquial,complemented,martinique,fractures,culmination,erstwhile,atrium,electronica,anarchism,nadal,montpellier,algebras,submitting,adopts,stemmed,overcame,internacional,asymmetric,gallipoli,gliders,flushing,extermination,hartlepool,tesla,interwar,patriarchal,hitherto,ganges,combatant,marred,philology,glastonbury,reversible,isthmus,undermined,southwark,gateshead,andalusia,remedies,hastily,optimum,smartphone,evade,patrolled,beheaded,dopamine,waivers,ugandan,gujarati,densities,predicting,intestinal,tentative,interstellar,kolonia,soloists,penetrated,rebellions,qeshlaq,prospered,colegio,deficits,konigsberg,deficient,accessing,relays,kurds,politburo,codified,incarnations,occupancy,cossack,metaphysical,deprivation,chopra,piccadilly,formula_18,makeshift,protestantism,alaskan,frontiers,faiths,tendon,dunkirk,durability,autobots,bonuses,coinciding,emails,gunboat,stucco,magma,neutrons,vizier,subscriptions,visuals,envisaged,carpets,smoky,schema,parliamentarian,immersed,domesticated,parishioners,flinders,diminutive,mahabharata,ballarat,falmouth,vacancies,gilded,twigs,mastering,clerics,dalmatia,islington,slogans,compressor,iconography,congolese,sanction,blends,bulgarians,moderator,outflow,textures,safeguard,trafalgar,tramways,skopje,colonialism,chimneys,jazeera,organisers,denoting,motivations,ganga,longstanding,deficiencies,gwynedd,palladium,holistic,fascia,preachers,embargo,sidings,busan,ignited,artificially,clearwater,cemented,northerly,salim,equivalents,crustaceans,oberliga,quadrangle,historiography,romanians,vaults,fiercely,incidental,peacetime,tonal,bhopal,oskar,radha,pesticides,timeslot,westerly,cathedrals,roadways,aldershot,connectors,brahmins,paler,aqueous,gustave,chromatic,linkage,lothian,specialises,aggregation,tributes,insurgent,enact,hampden,ghulam,federations,instigated,lyceum,fredrik,chairmanship,floated,consequent,antagonists,intimidation,patriarchate,warbler,heraldry,entrenched,expectancy,habitation,partitions,widest,launchers,nascent,ethos,wurzburg,lycee,chittagong,mahatma,merseyside,asteroids,yokosuka,cooperatives,quorum,redistricting,bureaucratic,yachts,deploying,rustic,phonology,chorale,cellist,stochastic,crucifixion,surmounted,confucian,portfolios,geothermal,crested,calibre,tropics,deferred,nasir,iqbal,persistence,essayist,chengdu,aborigines,fayetteville,bastion,interchangeable,burlesque,kilmarnock,specificity,tankers,colonels,fijian,quotations,enquiry,quito,palmerston,delle,multidisciplinary,polynesian,iodine,antennae,emphasised,manganese,baptists,galilee,jutland,latent,excursions,skepticism,tectonic,precursors,negligible,musique,misuse,vitoria,expressly,veneration,sulawesi,footed,mubarak,chongqing,chemically,midday,ravaged,facets,varma,yeovil,ethnographic,discounted,physicists,attache,disbanding,essen,shogunate,cooperated,waikato,realising,motherwell,pharmacology,sulfide,inward,expatriate,devoid,cultivar,monde,andean,groupings,goran,unaffected,moldovan,postdoctoral,coleophora,delegated,pronoun,conductivity,coleridge,disapproval,reappeared,microbial,campground,olsztyn,fostered,vaccination,rabbinical,champlain,milestones,viewership,caterpillar,effected,eupithecia,financier,inferred,uzbek,bundled,bandar,balochistan,mysticism,biosphere,holotype,symbolizes,lovecraft,photons,abkhazia,swaziland,subgroups,measurable,falkirk,valparaiso,ashok,discriminatory,rarity,tabernacle,flyweight,jalisco,westernmost,antiquarian,extracellular,margrave,colspan=9,midsummer,digestive,reversing,burgeoning,substitutes,medallist,khrushchev,guerre,folio,detonated,partido,plentiful,aggregator,medallion,infiltration,shaded,santander,fared,auctioned,permian,ramakrishna,andorra,mentors,diffraction,bukit,potentials,translucent,feminists,tiers,protracted,coburg,wreath,guelph,adventurer,he/she,vertebrate,pipelines,celsius,outbreaks,australasia,deccan,garibaldi,unionists,buildup,biochemical,reconstruct,boulders,stringent,barbed,wording,furnaces,pests,befriends,organises,popes,rizal,tentacles,cadre,tallahassee,punishments,occidental,formatted,mitigation,rulings,rubens,cascades,inducing,choctaw,volta,synagogues,movable,altarpiece,mitigate,practise,intermittently,encountering,memberships,earns,signify,retractable,amounting,pragmatic,wilfrid,dissenting,divergent,kanji,reconstituted,devonian,constitutions,levied,hendrik,starch,costal,honduran,ditches,polygon,eindhoven,superstars,salient,argus,punitive,purana,alluvial,flaps,inefficient,retracted,advantageous,quang,andersson,danville,binghamton,symbolize,conclave,shaanxi,silica,interpersonal,adept,frans,pavilions,lubbock,equip,sunken,limburg,activates,prosecutions,corinthian,venerated,shootings,retreats,parapet,orissa,riviere,animations,parodied,offline,metaphysics,bluffs,plume,piety,fruition,subsidized,steeplechase,shanxi,eurasia,angled,forecasting,suffragan,ashram,larval,labyrinth,chronicler,summaries,trailed,merges,thunderstorms,filtered,formula_19,advertisers,alpes,informatics,parti,constituting,undisputed,certifications,javascript,molten,sclerosis,rumoured,boulogne,hmong,lewes,breslau,notts,bantu,ducal,messengers,radars,nightclubs,bantamweight,carnatic,kaunas,fraternal,triggering,controversially,londonderry,visas,scarcity,offaly,uprisings,repelled,corinthians,pretext,kuomintang,kielce,empties,matriculated,pneumatic,expos,agile,treatises,midpoint,prehistory,oncology,subsets,hydra,hypertension,axioms,wabash,reiterated,swapped,achieves,premio,ageing,overture,curricula,challengers,subic,selangor,liners,frontline,shutter,validated,normalized,entertainers,molluscs,maharaj,allegation,youngstown,synth,thoroughfare,regionally,pillai,transcontinental,pedagogical,riemann,colonia,easternmost,tentatively,profiled,herefordshire,nativity,meuse,nucleotide,inhibits,huntingdon,throughput,recorders,conceding,domed,homeowners,centric,gabled,canoes,fringes,breeder,subtitled,fluoride,haplogroup,zionism,izmir,phylogeny,kharkiv,romanticism,adhesion,usaaf,delegations,lorestan,whalers,biathlon,vaulted,mathematically,pesos,skirmishes,heisman,kalamazoo,gesellschaft,launceston,interacts,quadruple,kowloon,psychoanalysis,toothed,ideologies,navigational,valence,induces,lesotho,frieze,rigging,undercarriage,explorations,spoof,eucharist,profitability,virtuoso,recitals,subterranean,sizeable,herodotus,subscriber,huxley,pivot,forewing,warring,boleslaw,bharatiya,suffixes,trois,percussionist,downturn,garrisons,philosophies,chants,mersin,mentored,dramatist,guilds,frameworks,thermodynamic,venomous,mehmed,assembling,rabbinic,hegemony,replicas,enlargement,claimant,retitled,utica,dumfries,metis,deter,assortment,tubing,afflicted,weavers,rupture,ornamentation,transept,salvaged,upkeep,callsign,rajput,stevenage,trimmed,intracellular,synchronization,consular,unfavorable,royalists,goldwyn,fasting,hussars,doppler,obscurity,currencies,amiens,acorn,tagore,townsville,gaussian,migrations,porta,anjou,graphite,seaport,monographs,gladiators,metrics,calligraphy,sculptural,swietokrzyskie,tolombeh,eredivisie,shoals,queries,carts,exempted,fiberglass,mirrored,bazar,progeny,formalized,mukherjee,professed,amazon.com,cathode,moreton,removable,mountaineers,nagano,transplantation,augustinian,steeply,epilogue,adapter,decisively,accelerating,mediaeval,substituting,tasman,devonshire,litres,enhancements,himmler,nephews,bypassing,imperfect,argentinian,reims,integrates,sochi,ascii,licences,niches,surgeries,fables,versatility,indra,footpath,afonso,crore,evaporation,encodes,shelling,conformity,simplify,updating,quotient,overt,firmware,umpires,architectures,eocene,conservatism,secretion,embroidery,f.c..,tuvalu,mosaics,shipwreck,prefectural,cohort,grievances,garnering,centerpiece,apoptosis,djibouti,bethesda,formula_20,shonen,richland,justinian,dormitories,meteorite,reliably,obtains,pedagogy,hardness,cupola,manifolds,amplification,steamers,familial,dumbarton,jerzy,genital,maidstone,salinity,grumman,signifies,presbytery,meteorology,procured,aegis,streamed,deletion,nuestra,mountaineering,accords,neuronal,khanate,grenoble,axles,dispatches,tokens,turku,auctions,propositions,planters,proclaiming,recommissioned,stravinsky,obverse,bombarded,waged,saviour,massacred,reformist,purportedly,resettlement,ravenna,embroiled,minden,revitalization,hikers,bridging,torpedoed,depletion,nizam,affectionately,latitudes,lubeck,spore,polymerase,aarhus,nazism,101st,buyout,galerie,diets,overflow,motivational,renown,brevet,deriving,melee,goddesses,demolish,amplified,tamworth,retake,brokerage,beneficiaries,henceforth,reorganised,silhouette,browsers,pollutants,peron,lichfield,encircled,defends,bulge,dubbing,flamenco,coimbatore,refinement,enshrined,grizzlies,capacitor,usefulness,evansville,interscholastic,rhodesian,bulletins,diamondbacks,rockers,platted,medalists,formosa,transporter,slabs,guadeloupe,disparate,concertos,violins,regaining,mandible,untitled,agnostic,issuance,hamiltonian,brampton,srpska,homology,downgraded,florentine,epitaph,kanye,rallying,analysed,grandstand,infinitely,antitrust,plundered,modernity,colspan=3|total,amphitheatre,doric,motorists,yemeni,carnivorous,probabilities,prelate,struts,scrapping,bydgoszcz,pancreatic,signings,predicts,compendium,ombudsman,apertura,appoints,rebbe,stereotypical,valladolid,clustered,touted,plywood,inertial,kettering,curving,d'honneur,housewives,grenadier,vandals,barbarossa,necked,waltham,reputedly,jharkhand,cistercian,pursues,viscosity,organiser,cloister,islet,stardom,moorish,himachal,strives,scripps,staggered,blasts,westwards,millimeters,angolan,hubei,agility,admirals,mordellistena,coincides,platte,vehicular,cordillera,riffs,schoolteacher,canaan,acoustics,tinged,reinforcing,concentrates,daleks,monza,selectively,musik,polynesia,exporter,reviving,macclesfield,bunkers,ballets,manors,caudal,microbiology,primes,unbroken,outcry,flocks,pakhtunkhwa,abelian,toowoomba,luminous,mould,appraisal,leuven,experimentally,interoperability,hideout,perak,specifying,knighthood,vasily,excerpt,computerized,niels,networked,byzantium,reaffirmed,geographer,obscured,fraternities,mixtures,allusion,accra,lengthened,inquest,panhandle,pigments,revolts,bluetooth,conjugate,overtaken,foray,coils,breech,streaks,impressionist,mendelssohn,intermediary,panned,suggestive,nevis,upazila,rotunda,mersey,linnaeus,anecdotes,gorbachev,viennese,exhaustive,moldavia,arcades,irrespective,orator,diminishing,predictive,cohesion,polarized,montage,avian,alienation,conus,jaffna,urbanization,seawater,extremity,editorials,scrolling,dreyfus,traverses,topographic,gunboats,extratropical,normans,correspondents,recognises,millennia,filtration,ammonium,voicing,complied,prefixes,diplomas,figurines,weakly,gated,oscillator,lucerne,embroidered,outpatient,airframe,fractional,disobedience,quarterbacks,formula_21,shinto,chiapas,epistle,leakage,pacifist,avignon,penrith,renders,mantua,screenplays,gustaf,tesco,alphabetically,rations,discharges,headland,tapestry,manipur,boolean,mediator,ebenezer,subchannel,fable,bestselling,ateneo,trademarks,recurrence,dwarfs,britannica,signifying,vikram,mediate,condensation,censuses,verbandsgemeinde,cartesian,sprang,surat,britons,chelmsford,courtenay,statistic,retina,abortions,liabilities,closures,mississauga,skyscrapers,saginaw,compounded,aristocrat,msnbc,stavanger,septa,interpretive,hinder,visibly,seeding,shutouts,irregularly,quebecois,footbridge,hydroxide,implicitly,lieutenants,simplex,persuades,midshipman,heterogeneous,officiated,crackdown,lends,tartu,altars,fractions,dissidents,tapered,modernisation,scripting,blazon,aquaculture,thermodynamics,sistan,hasidic,bellator,pavia,propagated,theorized,bedouin,transnational,mekong,chronicled,declarations,kickstarter,quotas,runtime,duquesne,broadened,clarendon,brownsville,saturation,tatars,electorates,malayan,replicated,observable,amphitheater,endorsements,referral,allentown,mormons,pantomime,eliminates,typeface,allegorical,varna,conduction,evoke,interviewer,subordinated,uyghur,landscaped,conventionally,ascend,edifice,postulated,hanja,whitewater,embarking,musicologist,tagalog,frontage,paratroopers,hydrocarbons,transliterated,nicolae,viewpoints,surrealist,asheville,falklands,hacienda,glide,opting,zimbabwean,discal,mortgages,nicaraguan,yadav,ghosh,abstracted,castilian,compositional,cartilage,intergovernmental,forfeited,importation,rapping,artes,republika,narayana,condominium,frisian,bradman,duality,marche,extremist,phosphorylation,genomes,allusions,valencian,habeas,ironworks,multiplex,harpsichord,emigrate,alternated,breda,waffen,smartphones,familiarity,regionalliga,herbaceous,piping,dilapidated,carboniferous,xviii,critiques,carcinoma,sagar,chippewa,postmodern,neapolitan,excludes,notoriously,distillation,tungsten,richness,installments,monoxide,chand,privatisation,molded,maths,projectiles,luoyang,epirus,lemma,concentric,incline,erroneous,sideline,gazetted,leopards,fibres,renovate,corrugated,unilateral,repatriation,orchestration,saeed,rockingham,loughborough,formula_22,bandleader,appellation,openness,nanotechnology,massively,tonnage,dunfermline,exposes,moored,ridership,motte,eurobasket,majoring,feats,silla,laterally,playlist,downwards,methodologies,eastbourne,daimyo,cellulose,leyton,norwalk,oblong,hibernian,opaque,insular,allegory,camogie,inactivation,favoring,masterpieces,rinpoche,serotonin,portrayals,waverley,airliner,longford,minimalist,outsourcing,excise,meyrick,qasim,organisational,synaptic,farmington,gorges,scunthorpe,zoned,tohoku,librarians,davao,decor,theatrically,brentwood,pomona,acquires,planter,capacitors,synchronous,skateboarding,coatings,turbocharged,ephraim,capitulation,scoreboard,hebrides,ensues,cereals,ailing,counterpoint,duplication,antisemitic,clique,aichi,oppressive,transcendental,incursions,rename,renumbering,powys,vestry,bitterly,neurology,supplanted,affine,susceptibility,orbiter,activating,overlaps,ecoregion,raman,canoer,darfur,microorganisms,precipitated,protruding,torun,anthropologists,rennes,kangaroos,parliamentarians,edits,littoral,archived,begum,rensselaer,microphones,ypres,empower,etruscan,wisden,montfort,calibration,isomorphic,rioting,kingship,verbally,smyrna,cohesive,canyons,fredericksburg,rahul,relativistic,micropolitan,maroons,industrialized,henchmen,uplift,earthworks,mahdi,disparity,cultured,transliteration,spiny,fragmentary,extinguished,atypical,inventors,biosynthesis,heralded,curacao,anomalies,aeroplane,surya,mangalore,maastricht,ashkenazi,fusiliers,hangzhou,emitting,monmouthshire,schwarzenegger,ramayana,peptides,thiruvananthapuram,alkali,coimbra,budding,reasoned,epithelial,harbors,rudimentary,classically,parque,ealing,crusades,rotations,riparian,pygmy,inertia,revolted,microprocessor,calendars,solvents,kriegsmarine,accademia,cheshmeh,yoruba,ardabil,mitra,genomic,notables,propagate,narrates,univision,outposts,polio,birkenhead,urinary,crocodiles,pectoral,barrymore,deadliest,rupees,chaim,protons,comical,astrophysics,unifying,formula_23,vassals,cortical,audubon,pedals,tenders,resorted,geophysical,lenders,recognising,tackling,lanarkshire,doctrinal,annan,combating,guangxi,estimating,selectors,tribunals,chambered,inhabiting,exemptions,curtailed,abbasid,kandahar,boron,bissau,150th,codenamed,wearer,whorl,adhered,subversive,famer,smelting,inserting,mogadishu,zoologist,mosul,stumps,almanac,olympiacos,stamens,participatory,cults,honeycomb,geologists,dividend,recursive,skiers,reprint,pandemic,liber,percentages,adversely,stoppage,chieftains,tubingen,southerly,overcrowding,unorganized,hangars,fulfil,hails,cantilever,woodbridge,pinus,wiesbaden,fertilization,fluorescence,enhances,plenary,troublesome,episodic,thrissur,kickboxing,allele,staffing,garda,televisions,philatelic,spacetime,bullpen,oxides,leninist,enrolling,inventive,truro,compatriot,ruskin,normative,assay,gotha,murad,illawarra,gendarmerie,strasse,mazraeh,rebounded,fanfare,liaoning,rembrandt,iranians,emirate,governs,latency,waterfowl,chairmen,katowice,aristocrats,eclipsed,sentient,sonatas,interplay,sacking,decepticons,dynamical,arbitrarily,resonant,petar,velocities,alludes,wastes,prefectures,belleville,sensibility,salvadoran,consolidating,medicaid,trainees,vivekananda,molar,porous,upload,youngster,infused,doctorates,wuhan,annihilation,enthusiastically,gamespot,kanpur,accumulating,monorail,operetta,tiling,sapporo,finns,calvinist,hydrocarbon,sparrows,orienteering,cornelis,minster,vuelta,plebiscite,embraces,panchayats,focussed,remediation,brahman,olfactory,reestablished,uniqueness,northumbria,rwandan,predominately,abode,ghats,balances,californian,uptake,bruges,inert,westerns,reprints,cairn,yarra,resurfaced,audible,rossini,regensburg,italiana,fleshy,irrigated,alerts,yahya,varanasi,marginalized,expatriates,cantonment,normandie,sahitya,directives,rounder,hulls,fictionalized,constables,inserts,hipped,potosi,navies,biologists,canteen,husbandry,augment,fortnight,assamese,kampala,o'keefe,paleolithic,bluish,promontory,consecutively,striving,niall,reuniting,dipole,friendlies,disapproved,thrived,netflix,liberian,dielectric,medway,strategist,sankt,pickups,hitters,encode,rerouted,claimants,anglesey,partitioned,cavan,flutes,reared,repainted,armaments,bowed,thoracic,balliol,piero,chaplains,dehestan,sender,junkers,sindhi,sickle,dividends,metallurgy,honorific,berths,namco,springboard,resettled,gansu,copyrighted,criticizes,utopian,bendigo,ovarian,binomial,spaceflight,oratorio,proprietors,supergroup,duplicated,foreground,strongholds,revolved,optimize,layouts,westland,hurler,anthropomorphic,excelsior,merchandising,reeds,vetoed,cryptography,hollyoaks,monash,flooring,ionian,resilience,johnstown,resolves,lawmakers,alegre,wildcards,intolerance,subculture,selector,slums,formulate,bayonet,istvan,restitution,interchangeably,awakens,rostock,serpentine,oscillation,reichstag,phenotype,recessed,piotr,annotated,preparedness,consultations,clausura,preferential,euthanasia,genoese,outcrops,freemasonry,geometrical,genesee,islets,prometheus,panamanian,thunderbolt,terraced,stara,shipwrecks,futebol,faroese,sharqi,aldermen,zeitung,unify,formula_24,humanism,syntactic,earthen,blyth,taxed,rescinded,suleiman,cymru,dwindled,vitality,superieure,resupply,adolphe,ardennes,rajiv,profiling,olympique,gestation,interfaith,milosevic,tagline,funerary,druze,silvery,plough,shrubland,relaunch,disband,nunatak,minimizing,excessively,waned,attaching,luminosity,bugle,encampment,electrostatic,minesweeper,dubrovnik,rufous,greenock,hochschule,assyrians,extracting,malnutrition,priya,attainment,anhui,connotations,predicate,seabirds,deduced,pseudonyms,gopal,plovdiv,refineries,imitated,kwazulu,terracotta,tenets,discourses,brandeis,whigs,dominions,pulmonate,landslides,tutors,determinant,richelieu,farmstead,tubercles,technicolor,hegel,redundancy,greenpeace,shortening,mules,distilled,xxiii,fundamentalist,acrylic,outbuildings,lighted,corals,signaled,transistors,cavite,austerity,76ers,exposures,dionysius,outlining,commutative,permissible,knowledgeable,howrah,assemblage,inhibited,crewmen,mbit/s,pyramidal,aberdeenshire,bering,rotates,atheism,howitzer,saone,lancet,fermented,contradicted,materiel,ofsted,numeric,uniformity,josephus,nazarene,kuwaiti,noblemen,pediment,emergent,campaigner,akademi,murcia,perugia,gallen,allsvenskan,finned,cavities,matriculation,rosters,twickenham,signatory,propel,readable,contends,artisan,flamboyant,reggio,italo,fumbles,widescreen,rectangle,centimetres,collaborates,envoys,rijeka,phonological,thinly,refractive,civilisation,reductase,cognate,dalhousie,monticello,lighthouses,jitsu,luneburg,socialite,fermi,collectible,optioned,marquee,jokingly,architecturally,kabir,concubine,nationalisation,watercolor,wicklow,acharya,pooja,leibniz,rajendra,nationalized,stalemate,bloggers,glutamate,uplands,shivaji,carolingian,bucuresti,dasht,reappears,muscat,functionally,formulations,hinged,hainan,catechism,autosomal,incremental,asahi,coeur,diversification,multilateral,fewest,recombination,finisher,harrogate,hangul,feasts,photovoltaic,paget,liquidity,alluded,incubation,applauded,choruses,malagasy,hispanics,bequest,underparts,cassava,kazimierz,gastric,eradication,mowtowr,tyrosine,archbishopric,e9e9e9,unproductive,uxbridge,hydrolysis,harbours,officio,deterministic,devonport,kanagawa,breaches,freetown,rhinoceros,chandigarh,janos,sanatorium,liberator,inequalities,agonist,hydrophobic,constructors,nagorno,snowboarding,welcomes,subscribed,iloilo,resuming,catalysts,stallions,jawaharlal,harriers,definitively,roughriders,hertford,inhibiting,elgar,randomized,incumbents,episcopate,rainforests,yangon,improperly,kemal,interpreters,diverged,uttarakhand,umayyad,phnom,panathinaikos,shabbat,diode,jiangxi,forbidding,nozzle,artistry,licensee,processions,staffs,decimated,expressionism,shingle,palsy,ontology,mahayana,maribor,sunil,hostels,edwardian,jetty,freehold,overthrew,eukaryotic,schuylkill,rawalpindi,sheath,recessive,ferenc,mandibles,berlusconi,confessor,convergent,ababa,slugging,rentals,sephardic,equivalently,collagen,markov,dynamically,hailing,depressions,sprawling,fairgrounds,indistinguishable,plutarch,pressurized,banff,coldest,braunschweig,mackintosh,sociedad,wittgenstein,tromso,airbase,lecturers,subtitle,attaches,purified,contemplated,dreamworks,telephony,prophetic,rockland,aylesbury,biscay,coherence,aleksandar,judoka,pageants,theses,homelessness,luthor,sitcoms,hinterland,fifths,derwent,privateers,enigmatic,nationalistic,instructs,superimposed,conformation,tricycle,dusan,attributable,unbeknownst,laptops,etching,archbishops,ayatollah,cranial,gharbi,interprets,lackawanna,abingdon,saltwater,tories,lender,minaj,ancillary,ranching,pembrokeshire,topographical,plagiarism,murong,marque,chameleon,assertions,infiltrated,guildhall,reverence,schenectady,formula_25,kollam,notary,mexicana,initiates,abdication,basra,theorems,ionization,dismantling,eared,censors,budgetary,numeral,verlag,excommunicated,distinguishable,quarried,cagliari,hindustan,symbolizing,watertown,descartes,relayed,enclosures,militarily,sault,devolved,dalian,djokovic,filaments,staunton,tumour,curia,villainous,decentralized,galapagos,moncton,quartets,onscreen,necropolis,brasileiro,multipurpose,alamos,comarca,jorgen,concise,mercia,saitama,billiards,entomologist,montserrat,lindbergh,commuting,lethbridge,phoenician,deviations,anaerobic,denouncing,redoubt,fachhochschule,principalities,negros,announcers,seconded,parrots,konami,revivals,approving,devotee,riyadh,overtook,morecambe,lichen,expressionist,waterline,silverstone,geffen,sternites,aspiration,behavioural,grenville,tripura,mediums,genders,pyotr,charlottesville,sacraments,programmable,ps100,shackleton,garonne,sumerian,surpass,authorizing,interlocking,lagoons,voiceless,advert,steeple,boycotted,alouettes,yosef,oxidative,sassanid,benefiting,sayyid,nauru,predetermined,idealism,maxillary,polymerization,semesters,munchen,conor,outfitted,clapham,progenitor,gheorghe,observational,recognitions,numerically,colonized,hazrat,indore,contaminants,fatality,eradicate,assyria,convocation,cameos,skillful,skoda,corfu,confucius,overtly,ramadan,wollongong,placements,d.c..,permutation,contemporaneous,voltages,elegans,universitat,samar,plunder,dwindling,neuter,antonin,sinhala,campania,solidified,stanzas,fibrous,marburg,modernize,sorcery,deutscher,florets,thakur,disruptive,infielder,disintegration,internazionale,vicariate,effigy,tripartite,corrective,klamath,environs,leavenworth,sandhurst,workmen,compagnie,hoseynabad,strabo,palisades,ordovician,sigurd,grandsons,defection,viacom,sinhalese,innovator,uncontrolled,slavonic,indexes,refrigeration,aircrew,superbike,resumption,neustadt,confrontations,arras,hindenburg,ripon,embedding,isomorphism,dwarves,matchup,unison,lofty,argos,louth,constitutionally,transitive,newington,facelift,degeneration,perceptual,aviators,enclosing,igneous,symbolically,academician,constitutionality,iso/iec,sacrificial,maturation,apprentices,enzymology,naturalistic,hajji,arthropods,abbess,vistula,scuttled,gradients,pentathlon,etudes,freedmen,melaleuca,thrice,conductive,sackville,franciscans,stricter,golds,kites,worshiped,monsignor,trios,orally,tiered,primacy,bodywork,castleford,epidemics,alveolar,chapelle,chemists,hillsboro,soulful,warlords,ngati,huguenot,diurnal,remarking,luger,motorways,gauss,jahan,cutoff,proximal,bandai,catchphrase,jonubi,ossetia,codename,codice_2,throated,itinerant,chechnya,riverfront,leela,evoked,entailed,zamboanga,rejoining,circuitry,haymarket,khartoum,feuds,braced,miyazaki,mirren,lubusz,caricature,buttresses,attrition,characterizes,widnes,evanston,materialism,contradictions,marist,midrash,gainsborough,ulithi,turkmen,vidya,escuela,patrician,inspirations,reagent,premierships,humanistic,euphrates,transitioning,belfry,zedong,adaption,kaliningrad,lobos,epics,waiver,coniferous,polydor,inductee,refitted,moraine,unsatisfactory,worsening,polygamy,rajya,nested,subgenre,broadside,stampeders,lingua,incheon,pretender,peloton,persuading,excitation,multan,predates,tonne,brackish,autoimmune,insulated,podcasts,iraqis,bodybuilding,condominiums,midlothian,delft,debtor,asymmetrical,lycaenidae,forcefully,pathogenic,tamaulipas,andaman,intravenous,advancements,senegalese,chronologically,realigned,inquirer,eusebius,dekalb,additives,shortlist,goldwater,hindustani,auditing,caterpillars,pesticide,nakhon,ingestion,lansdowne,traditionalist,northland,thunderbirds,josip,nominating,locale,ventricular,animators,verandah,epistles,surveyors,anthems,dredd,upheaval,passaic,anatolian,svalbard,associative,floodplain,taranaki,estuaries,irreducible,beginners,hammerstein,allocate,coursework,secreted,counteract,handwritten,foundational,passover,discoverer,decoding,wares,bourgeoisie,playgrounds,nazionale,abbreviations,seanad,golan,mishra,godavari,rebranding,attendances,backstory,interrupts,lettered,hasbro,ultralight,hormozgan,armee,moderne,subdue,disuse,improvisational,enrolment,persists,moderated,carinthia,hatchback,inhibitory,capitalized,anatoly,abstracts,albemarle,bergamo,insolvency,sentai,cellars,walloon,joked,kashmiri,dirac,materialized,renomination,homologous,gusts,eighteens,centrifugal,storied,baluchestan,formula_26,poincare,vettel,infuriated,gauges,streetcars,vedanta,stately,liquidated,goguryeo,swifts,accountancy,levee,acadian,hydropower,eustace,comintern,allotment,designating,torsion,molding,irritation,aerobic,halen,concerted,plantings,garrisoned,gramophone,cytoplasm,onslaught,requisitioned,relieving,genitive,centrist,jeong,espanola,dissolving,chatterjee,sparking,connaught,varese,arjuna,carpathian,empowering,meteorologist,decathlon,opioid,hohenzollern,fenced,ibiza,avionics,footscray,scrum,discounts,filament,directories,a.f.c,stiffness,quaternary,adventurers,transmits,harmonious,taizong,radiating,germantown,ejection,projectors,gaseous,nahuatl,vidyalaya,nightlife,redefined,refuted,destitute,arista,potters,disseminated,distanced,jamboree,kaohsiung,tilted,lakeshore,grained,inflicting,kreis,novelists,descendents,mezzanine,recast,fatah,deregulation,ac/dc,australis,kohgiluyeh,boreal,goths,authoring,intoxicated,nonpartisan,theodosius,pyongyang,shree,boyhood,sanfl,plenipotentiary,photosynthesis,presidium,sinaloa,honshu,texan,avenida,transmembrane,malays,acropolis,catalunya,vases,inconsistencies,methodists,quell,suisse,banat,simcoe,cercle,zealanders,discredited,equine,sages,parthian,fascists,interpolation,classifying,spinoff,yehuda,cruised,gypsum,foaled,wallachia,saraswati,imperialist,seabed,footnotes,nakajima,locales,schoolmaster,drosophila,bridgehead,immanuel,courtier,bookseller,niccolo,stylistically,portmanteau,superleague,konkani,millimetres,arboreal,thanjavur,emulation,sounders,decompression,commoners,infusion,methodological,osage,rococo,anchoring,bayreuth,formula_27,abstracting,symbolized,bayonne,electrolyte,rowed,corvettes,traversing,editorship,sampler,presidio,curzon,adirondack,swahili,rearing,bladed,lemur,pashtun,behaviours,bottling,zaire,recognisable,systematics,leeward,formulae,subdistricts,smithfield,vijaya,buoyancy,boosting,cantonal,rishi,airflow,kamakura,adana,emblems,aquifer,clustering,husayn,woolly,wineries,montessori,turntable,exponentially,caverns,espoused,pianists,vorpommern,vicenza,latterly,o'rourke,williamstown,generale,kosice,duisburg,poirot,marshy,mismanagement,mandalay,dagenham,universes,chiral,radiated,stewards,vegan,crankshaft,kyrgyz,amphibian,cymbals,infrequently,offenbach,environmentalist,repatriated,permutations,midshipmen,loudoun,refereed,bamberg,ornamented,nitric,selim,translational,dorsum,annunciation,gippsland,reflector,informational,regia,reactionary,ahmet,weathering,erlewine,legalized,berne,occupant,divas,manifests,analyzes,disproportionate,mitochondria,totalitarian,paulista,interscope,anarcho,correlate,brookfield,elongate,brunel,ordinal,precincts,volatility,equaliser,hittite,somaliland,ticketing,monochrome,ubuntu,chhattisgarh,titleholder,ranches,referendums,blooms,accommodates,merthyr,religiously,ryukyu,tumultuous,checkpoints,anode,mi'kmaq,cannonball,punctuation,remodelled,assassinations,criminology,alternates,yonge,pixar,namibian,piraeus,trondelag,hautes,lifeboats,shoal,atelier,vehemently,sadat,postcode,jainism,lycoming,undisturbed,lutherans,genomics,popmatters,tabriz,isthmian,notched,autistic,horsham,mites,conseil,bloomsbury,seung,cybertron,idris,overhauled,disbandment,idealized,goldfields,worshippers,lobbyist,ailments,paganism,herbarium,athenians,messerschmitt,faraday,entangled,'olya,untreated,criticising,howitzers,parvati,lobed,debussy,atonement,tadeusz,permeability,mueang,sepals,degli,optionally,fuelled,follies,asterisk,pristina,lewiston,congested,overpass,affixed,pleads,telecasts,stanislaus,cryptographic,friesland,hamstring,selkirk,antisubmarine,inundated,overlay,aggregates,fleur,trolleybus,sagan,ibsen,inductees,beltway,tiled,ladders,cadbury,laplace,ascetic,micronesia,conveying,bellingham,cleft,batches,usaid,conjugation,macedon,assisi,reappointed,brine,jinnah,prairies,screenwriting,oxidized,despatches,linearly,fertilizers,brazilians,absorbs,wagga,modernised,scorsese,ashraf,charlestown,esque,habitable,nizhny,lettres,tuscaloosa,esplanade,coalitions,carbohydrates,legate,vermilion,standardised,galleria,psychoanalytic,rearrangement,substation,competency,nationalised,reshuffle,reconstructions,mehdi,bougainville,receivership,contraception,enlistment,conducive,aberystwyth,solicitors,dismisses,fibrosis,montclair,homeowner,surrealism,s.h.i.e.l.d,peregrine,compilers,1790s,parentage,palmas,rzeszow,worldview,eased,svenska,housemate,bundestag,originator,enlisting,outwards,reciprocity,formula_28,carbohydrate,democratically,firefighting,romagna,acknowledgement,khomeini,carbide,quests,vedas,characteristically,guwahati,brixton,unintended,brothels,parietal,namur,sherbrooke,moldavian,baruch,milieu,undulating,laurier,entre,dijon,ethylene,abilene,heracles,paralleling,ceres,dundalk,falun,auspicious,chisinau,polarity,foreclosure,templates,ojibwe,punic,eriksson,biden,bachchan,glaciation,spitfires,norsk,nonviolent,heidegger,algonquin,capacitance,cassettes,balconies,alleles,airdate,conveys,replays,classifies,infrequent,amine,cuttings,rarer,woking,olomouc,amritsar,rockabilly,illyrian,maoist,poignant,tempore,stalinist,segmented,bandmate,mollusc,muhammed,totalled,byrds,tendered,endogenous,kottayam,aisne,oxidase,overhears,illustrators,verve,commercialization,purplish,directv,moulded,lyttelton,baptismal,captors,saracens,georgios,shorten,polity,grids,fitzwilliam,sculls,impurities,confederations,akhtar,intangible,oscillations,parabolic,harlequin,maulana,ovate,tanzanian,singularity,confiscation,qazvin,speyer,phonemes,overgrown,vicarage,gurion,undocumented,niigata,thrones,preamble,stave,interment,liiga,ataturk,aphrodite,groupe,indentured,habsburgs,caption,utilitarian,ozark,slovenes,reproductions,plasticity,serbo,dulwich,castel,barbuda,salons,feuding,lenape,wikileaks,swamy,breuning,shedding,afield,superficially,operationally,lamented,okanagan,hamadan,accolade,furthering,adolphus,fyodor,abridged,cartoonists,pinkish,suharto,cytochrome,methylation,debit,colspan=9|,refine,taoist,signalled,herding,leaved,bayan,fatherland,rampart,sequenced,negation,storyteller,occupiers,barnabas,pelicans,nadir,conscripted,railcars,prerequisite,furthered,columba,carolinas,markup,gwalior,franche,chaco,eglinton,ramparts,rangoon,metabolites,pollination,croat,televisa,holyoke,testimonial,setlist,safavid,sendai,georgians,shakespearean,galleys,regenerative,krzysztof,overtones,estado,barbary,cherbourg,obispo,sayings,composites,sainsbury,deliberation,cosmological,mahalleh,embellished,ascap,biala,pancras,calumet,grands,canvases,antigens,marianas,defenseman,approximated,seedlings,soren,stele,nuncio,immunology,testimonies,glossary,recollections,suitability,tampere,venous,cohomology,methanol,echoing,ivanovich,warmly,sterilization,imran,multiplying,whitechapel,undersea,xuanzong,tacitus,bayesian,roundhouse,correlations,rioters,molds,fiorentina,bandmates,mezzo,thani,guerilla,200th,premiums,tamils,deepwater,chimpanzees,tribesmen,selwyn,globo,turnovers,punctuated,erode,nouvelle,banbury,exponents,abolishing,helical,maimonides,endothelial,goteborg,infield,encroachment,cottonwood,mazowiecki,parable,saarbrucken,reliever,epistemology,artistes,enrich,rationing,formula_29,palmyra,subfamilies,kauai,zoran,fieldwork,arousal,creditor,friuli,celts,comoros,equated,escalation,negev,tallied,inductive,anion,netanyahu,mesoamerican,lepidoptera,aspirated,remit,westmorland,italic,crosse,vaclav,fuego,owain,balmain,venetians,ethnicities,deflected,ticino,apulia,austere,flycatcher,reprising,repressive,hauptbahnhof,subtype,ophthalmology,summarizes,eniwetok,colonisation,subspace,nymphalidae,earmarked,tempe,burnet,crests,abbots,norwegians,enlarge,ashoka,frankfort,livorno,malware,renters,singly,iliad,moresby,rookies,gustavus,affirming,alleges,legume,chekhov,studded,abdicated,suzhou,isidore,townsite,repayment,quintus,yankovic,amorphous,constructor,narrowing,industrialists,tanganyika,capitalization,connective,mughals,rarities,aerodynamics,worthing,antalya,diagnostics,shaftesbury,thracian,obstetrics,benghazi,multiplier,orbitals,livonia,roscommon,intensify,ravel,oaths,overseer,locomotion,necessities,chickasaw,strathclyde,treviso,erfurt,aortic,contemplation,accrington,markazi,predeceased,hippocampus,whitecaps,assemblyman,incursion,ethnography,extraliga,reproducing,directorship,benzene,byway,stupa,taxable,scottsdale,onondaga,favourably,countermeasures,lithuanians,thatched,deflection,tarsus,consuls,annuity,paralleled,contextual,anglian,klang,hoisted,multilingual,enacting,samaj,taoiseach,carthaginian,apologised,hydrology,entrant,seamless,inflorescences,mugabe,westerners,seminaries,wintering,penzance,mitre,sergeants,unoccupied,delimitation,discriminate,upriver,abortive,nihon,bessarabia,calcareous,buffaloes,patil,daegu,streamline,berks,chaparral,laity,conceptions,typified,kiribati,threaded,mattel,eccentricity,signified,patagonia,slavonia,certifying,adnan,astley,sedition,minimally,enumerated,nikos,goalless,walid,narendra,causa,missoula,coolant,dalek,outcrop,hybridization,schoolchildren,peasantry,afghans,confucianism,shahr,gallic,tajik,kierkegaard,sauvignon,commissar,patriarchs,tuskegee,prussians,laois,ricans,talmudic,officiating,aesthetically,baloch,antiochus,separatists,suzerainty,arafat,shading,u.s.c,chancellors,inc..,toolkit,nepenthes,erebidae,solicited,pratap,kabbalah,alchemist,caltech,darjeeling,biopic,spillway,kaiserslautern,nijmegen,bolstered,neath,pahlavi,eugenics,bureaus,retook,northfield,instantaneous,deerfield,humankind,selectivity,putative,boarders,cornhuskers,marathas,raikkonen,aliabad,mangroves,garages,gulch,karzai,poitiers,chernobyl,thane,alexios,belgrano,scion,solubility,urbanized,executable,guizhou,nucleic,tripled,equalled,harare,houseguests,potency,ghazi,repeater,overarching,regrouped,broward,ragtime,d'art,nandi,regalia,campsites,mamluk,plating,wirral,presumption,zenit,archivist,emmerdale,decepticon,carabidae,kagoshima,franconia,guarani,formalism,diagonally,submarginal,denys,walkways,punts,metrolink,hydrographic,droplets,upperside,martyred,hummingbird,antebellum,curiously,mufti,friary,chabad,czechs,shaykh,reactivity,berklee,turbonilla,tongan,sultans,woodville,unlicensed,enmity,dominicans,operculum,quarrying,watercolour,catalyzed,gatwick,'what,mesozoic,auditors,shizuoka,footballing,haldane,telemundo,appended,deducted,disseminate,o'shea,pskov,abrasive,entente,gauteng,calicut,lemurs,elasticity,suffused,scopula,staining,upholding,excesses,shostakovich,loanwords,naidu,championnat,chromatography,boasting,goaltenders,engulfed,salah,kilogram,morristown,shingles,shi'a,labourer,renditions,frantisek,jekyll,zonal,nanda,sheriffs,eigenvalues,divisione,endorsing,ushered,auvergne,cadres,repentance,freemasons,utilising,laureates,diocletian,semiconductors,o'grady,vladivostok,sarkozy,trackage,masculinity,hydroxyl,mervyn,muskets,speculations,gridiron,opportunistic,mascots,aleutian,fillies,sewerage,excommunication,borrowers,capillary,trending,sydenham,synthpop,rajah,cagayan,deportes,kedah,faure,extremism,michoacan,levski,culminates,occitan,bioinformatics,unknowingly,inciting,emulated,footpaths,piacenza,dreadnought,viceroyalty,oceanographic,scouted,combinatorial,ornithologist,cannibalism,mujahideen,independiente,cilicia,hindwing,minimized,odeon,gyorgy,rubles,purchaser,collieries,kickers,interurban,coiled,lynchburg,respondent,plzen,detractors,etchings,centering,intensification,tomography,ranjit,warblers,retelling,reinstatement,cauchy,modulus,redirected,evaluates,beginner,kalateh,perforated,manoeuvre,scrimmage,internships,megawatts,mottled,haakon,tunbridge,kalyan,summarised,sukarno,quetta,canonized,henryk,agglomeration,coahuila,diluted,chiropractic,yogyakarta,talladega,sheik,cation,halting,reprisals,sulfuric,musharraf,sympathizers,publicised,arles,lectionary,fracturing,startups,sangha,latrobe,rideau,ligaments,blockading,cremona,lichens,fabaceae,modulated,evocative,embodies,battersea,indistinct,altai,subsystem,acidity,somatic,formula_30,tariq,rationality,sortie,ashlar,pokal,cytoplasmic,valour,bangla,displacing,hijacking,spectrometry,westmeath,weill,charing,goias,revolvers,individualized,tenured,nawaz,piquet,chanted,discard,bernd,phalanx,reworking,unilaterally,subclass,yitzhak,piloting,circumvent,disregarded,semicircular,viscous,tibetans,endeavours,retaliated,cretan,vienne,workhouse,sufficiency,aurangzeb,legalization,lipids,expanse,eintracht,sanjak,megas,125th,bahraini,yakima,eukaryotes,thwart,affirmation,peloponnese,retailing,carbonyl,chairwoman,macedonians,dentate,rockaway,correctness,wealthier,metamorphic,aragonese,fermanagh,pituitary,schrodinger,evokes,spoiler,chariots,akita,genitalia,combe,confectionery,desegregation,experiential,commodores,persepolis,viejo,restorations,virtualization,hispania,printmaking,stipend,yisrael,theravada,expended,radium,tweeted,polygonal,lippe,charente,leveraged,cutaneous,fallacy,fragrant,bypasses,elaborately,rigidity,majid,majorca,kongo,plasmodium,skits,audiovisual,eerste,staircases,prompts,coulthard,northwestward,riverdale,beatrix,copyrights,prudential,communicates,mated,obscenity,asynchronous,analyse,hansa,searchlight,farnborough,patras,asquith,qarah,contours,fumbled,pasteur,redistributed,almeria,sanctuaries,jewry,israelite,clinicians,koblenz,bookshop,affective,goulburn,panelist,sikorsky,cobham,mimics,ringed,portraiture,probabilistic,girolamo,intelligible,andalusian,jalal,athenaeum,eritrean,auxiliaries,pittsburg,devolution,sangam,isolating,anglers,cronulla,annihilated,kidderminster,synthesize,popularised,theophilus,bandstand,innumerable,chagrin,retroactively,weser,multiples,birdlife,goryeo,pawnee,grosser,grappling,tactile,ahmadinejad,turboprop,erdogan,matchday,proletarian,adhering,complements,austronesian,adverts,luminaries,archeology,impressionism,conifer,sodomy,interracial,platoons,lessen,postings,pejorative,registrations,cookery,persecutions,microbes,audits,idiosyncratic,subsp,suspensions,restricts,colouring,ratify,instrumentals,nucleotides,sulla,posits,bibliotheque,diameters,oceanography,instigation,subsumed,submachine,acceptor,legation,borrows,sedge,discriminated,loaves,insurers,highgate,detectable,abandons,kilns,sportscaster,harwich,iterations,preakness,arduous,tensile,prabhu,shortwave,philologist,shareholding,vegetative,complexities,councilors,distinctively,revitalize,automaton,amassing,montreux,khanh,surabaya,nurnberg,pernambuco,cuisines,charterhouse,firsts,tercera,inhabitant,homophobia,naturalism,einar,powerplant,coruna,entertainments,whedon,rajputs,raton,democracies,arunachal,oeuvre,wallonia,jeddah,trolleybuses,evangelism,vosges,kiowa,minimise,encirclement,undertakes,emigrant,beacons,deepened,grammars,publius,preeminent,seyyed,repechage,crafting,headingley,osteopathic,lithography,hotly,bligh,inshore,betrothed,olympians,formula_31,dissociation,trivandrum,arran,petrovic,stettin,disembarked,simplification,bronzes,philo,acrobatic,jonsson,conjectured,supercharged,kanto,detects,cheeses,correlates,harmonics,lifecycle,sudamericana,reservists,decayed,elitserien,parametric,113th,dusky,hogarth,modulo,symbiotic,monopolies,discontinuation,converges,southerners,tucuman,eclipses,enclaves,emits,famicom,caricatures,artistically,levelled,mussels,erecting,mouthparts,cunard,octaves,crucible,guardia,unusable,lagrangian,droughts,ephemeral,pashto,canis,tapering,sasebo,silurian,metallurgical,outscored,evolves,reissues,sedentary,homotopy,greyhawk,reagents,inheriting,onshore,tilting,rebuffed,reusable,naturalists,basingstoke,insofar,offensives,dravidian,curators,planks,rajan,isoforms,flagstaff,preside,globular,egalitarian,linkages,biographers,goalscorers,molybdenum,centralised,nordland,jurists,ellesmere,rosberg,hideyoshi,restructure,biases,borrower,scathing,redress,tunnelling,workflow,magnates,mahendra,dissenters,plethora,transcriptions,handicrafts,keyword,xi'an,petrograd,unser,prokofiev,90deg,madan,bataan,maronite,kearny,carmarthen,termini,consulates,disallowed,rockville,bowery,fanzine,docklands,bests,prohibitions,yeltsin,selassie,naturalization,realisation,dispensary,tribeca,abdulaziz,pocahontas,stagnation,pamplona,cuneiform,propagating,subsurface,christgau,epithelium,schwerin,lynching,routledge,hanseatic,upanishad,glebe,yugoslavian,complicity,endowments,girona,mynetworktv,entomology,plinth,ba'ath,supercup,torus,akkadian,salted,englewood,commandery,belgaum,prefixed,colorless,dartford,enthroned,caesarea,nominative,sandown,safeguards,hulled,formula_32,leamington,dieppe,spearhead,generalizations,demarcation,llanelli,masque,brickwork,recounting,sufism,strikingly,petrochemical,onslow,monologues,emigrating,anderlecht,sturt,hossein,sakhalin,subduction,novices,deptford,zanjan,airstrikes,coalfield,reintroduction,timbaland,hornby,messianic,stinging,universalist,situational,radiocarbon,strongman,rowling,saloons,traffickers,overran,fribourg,cambrai,gravesend,discretionary,finitely,archetype,assessor,pilipinas,exhumed,invocation,interacted,digitized,timisoara,smelter,teton,sexism,precepts,srinagar,pilsudski,carmelite,hanau,scoreline,hernando,trekking,blogging,fanbase,wielded,vesicles,nationalization,banja,rafts,motoring,luang,takeda,girder,stimulates,histone,sunda,nanoparticles,attains,jumpers,catalogued,alluding,pontus,ancients,examiners,shinkansen,ribbentrop,reimbursement,pharmacological,ramat,stringed,imposes,cheaply,transplanted,taiping,mizoram,looms,wallabies,sideman,kootenay,encased,sportsnet,revolutionized,tangier,benthic,runic,pakistanis,heatseekers,shyam,mishnah,presbyterians,stadt,sutras,straddles,zoroastrian,infer,fueling,gymnasts,ofcom,gunfight,journeyman,tracklist,oshawa,ps500,pa'in,mackinac,xiongnu,mississippian,breckinridge,freemason,bight,autoroute,liberalization,distantly,thrillers,solomons,presumptive,romanization,anecdotal,bohemians,unpaved,milder,concurred,spinners,alphabets,strenuous,rivieres,kerrang,mistreatment,dismounted,intensively,carlist,dancehall,shunting,pluralism,trafficked,brokered,bonaventure,bromide,neckar,designates,malian,reverses,sotheby,sorghum,serine,environmentalists,languedoc,consulship,metering,bankstown,handlers,militiamen,conforming,regularity,pondicherry,armin,capsized,consejo,capitalists,drogheda,granular,purged,acadians,endocrine,intramural,elicit,terns,orientations,miklos,omitting,apocryphal,slapstick,brecon,pliocene,affords,typography,emigre,tsarist,tomasz,beset,nishi,necessitating,encyclical,roleplaying,journeyed,inflow,sprints,progressives,novosibirsk,cameroonian,ephesus,speckled,kinshasa,freiherr,burnaby,dalmatian,torrential,rigor,renegades,bhakti,nurburgring,cosimo,convincingly,reverting,visayas,lewisham,charlottetown,charadriiformesfamily,transferable,jodhpur,converters,deepening,camshaft,underdeveloped,protease,polonia,uterine,quantify,tobruk,dealerships,narasimha,fortran,inactivity,1780s,victors,categorised,naxos,workstation,skink,sardinian,chalice,precede,dammed,sondheim,phineas,tutored,sourcing,uncompromising,placer,tyneside,courtiers,proclaims,pharmacies,hyogo,booksellers,sengoku,kursk,spectrometer,countywide,wielkopolski,bobsleigh,shetty,llywelyn,consistory,heretics,guinean,cliches,individualism,monolithic,imams,usability,bursa,deliberations,railings,torchwood,inconsistency,balearic,stabilizer,demonstrator,facet,radioactivity,outboard,educates,d'oyly,heretical,handover,jurisdictional,shockwave,hispaniola,conceptually,routers,unaffiliated,trentino,formula_33,cypriots,intervenes,neuchatel,formulating,maggiore,delisted,alcohols,thessaly,potable,estimator,suborder,fluency,mimicry,clergymen,infrastructures,rivals.com,baroda,subplot,majlis,plano,clinching,connotation,carinae,savile,intercultural,transcriptional,sandstones,ailerons,annotations,impresario,heinkel,scriptural,intermodal,astrological,ribbed,northeastward,posited,boers,utilise,kalmar,phylum,breakwater,skype,textured,guideline,azeri,rimini,massed,subsidence,anomalous,wolfsburg,polyphonic,accrediting,vodacom,kirov,captaining,kelantan,logie,fervent,eamon,taper,bundeswehr,disproportionately,divination,slobodan,pundits,hispano,kinetics,reunites,makati,ceasing,statistician,amending,chiltern,eparchy,riverine,melanoma,narragansett,pagans,raged,toppled,breaching,zadar,holby,dacian,ochre,velodrome,disparities,amphoe,sedans,webpage,williamsport,lachlan,groton,baring,swastika,heliport,unwillingness,razorbacks,exhibitors,foodstuffs,impacting,tithe,appendages,dermot,subtypes,nurseries,balinese,simulating,stary,remakes,mundi,chautauqua,geologically,stockade,hakka,dilute,kalimantan,pahang,overlapped,fredericton,baha'u'llah,jahangir,damping,benefactors,shomali,triumphal,cieszyn,paradigms,shielded,reggaeton,maharishi,zambian,shearing,golestan,mirroring,partitioning,flyover,songbook,incandescent,merrimack,huguenots,sangeet,vulnerabilities,trademarked,drydock,tantric,honoris,queenstown,labelling,iterative,enlists,statesmen,anglicans,herge,qinghai,burgundian,islami,delineated,zhuge,aggregated,banknote,qatari,suitably,tapestries,asymptotic,charleroi,majorities,pyramidellidae,leanings,climactic,tahir,ramsar,suppressor,revisionist,trawler,ernakulam,penicillium,categorization,slits,entitlement,collegium,earths,benefice,pinochet,puritans,loudspeaker,stockhausen,eurocup,roskilde,alois,jaroslav,rhondda,boutiques,vigor,neurotransmitter,ansar,malden,ferdinando,sported,relented,intercession,camberwell,wettest,thunderbolts,positional,oriel,cloverleaf,penalized,shoshone,rajkumar,completeness,sharjah,chromosomal,belgians,woolen,ultrasonic,sequentially,boleyn,mordella,microsystems,initiator,elachista,mineralogy,rhododendron,integrals,compostela,hamza,sawmills,stadio,berlioz,maidens,stonework,yachting,tappeh,myocardial,laborer,workstations,costumed,nicaea,lanark,roundtable,mashhad,nablus,algonquian,stuyvesant,sarkar,heroines,diwan,laments,intonation,intrigues,almaty,feuded,grandes,algarve,rehabilitate,macrophages,cruciate,dismayed,heuristic,eliezer,kozhikode,covalent,finalised,dimorphism,yaroslavl,overtaking,leverkusen,middlebury,feeders,brookings,speculates,insoluble,lodgings,jozsef,cysteine,shenyang,habilitation,spurious,brainchild,mtdna,comique,albedo,recife,partick,broadening,shahi,orientated,himalaya,swabia,palme,mennonites,spokeswoman,conscripts,sepulchre,chartres,eurozone,scaffold,invertebrate,parishad,bagan,heian,watercolors,basse,supercomputer,commences,tarragona,plainfield,arthurian,functor,identically,murex,chronicling,pressings,burrowing,histoire,guayaquil,goalkeeping,differentiable,warburg,machining,aeneas,kanawha,holocene,ramesses,reprisal,qingdao,avatars,turkestan,cantatas,besieging,repudiated,teamsters,equipping,hydride,ahmadiyya,euston,bottleneck,computations,terengganu,kalinga,stela,rediscovery,'this,azhar,stylised,karelia,polyethylene,kansai,motorised,lounges,normalization,calculators,1700s,goalkeepers,unfolded,commissary,cubism,vignettes,multiverse,heaters,briton,sparingly,childcare,thorium,plock,riksdag,eunuchs,catalysis,limassol,perce,uncensored,whitlam,ulmus,unites,mesopotamian,refraction,biodiesel,forza,fulda,unseated,mountbatten,shahrak,selenium,osijek,mimicking,antimicrobial,axons,simulcasting,donizetti,swabian,sportsmen,hafiz,neared,heraclius,locates,evaded,subcarpathian,bhubaneswar,negeri,jagannath,thaksin,aydin,oromo,lateran,goldsmiths,multiculturalism,cilia,mihai,evangelists,lorient,qajar,polygons,vinod,mechanised,anglophone,prefabricated,mosses,supervillain,airliners,biofuels,iodide,innovators,valais,wilberforce,logarithm,intelligentsia,dissipation,sanctioning,duchies,aymara,porches,simulators,mostar,telepathic,coaxial,caithness,burghs,fourths,stratification,joaquim,scribes,meteorites,monarchist,germination,vries,desiring,replenishment,istria,winemaking,tammany,troupes,hetman,lanceolate,pelagic,triptych,primeira,scant,outbound,hyphae,denser,bentham,basie,normale,executes,ladislaus,kontinental,herat,cruiserweight,activision,customization,manoeuvres,inglewood,northwood,waveform,investiture,inpatient,alignments,kiryat,rabat,archimedes,ustad,monsanto,archetypal,kirkby,sikhism,correspondingly,catskill,overlaid,petrels,widowers,unicameral,federalists,metalcore,gamerankings,mussel,formula_34,lymphocytes,cystic,southgate,vestiges,immortals,kalam,strove,amazons,pocono,sociologists,sopwith,adheres,laurens,caregivers,inspecting,transylvanian,rebroadcast,rhenish,miserables,pyrams,blois,newtonian,carapace,redshirt,gotland,nazir,unilever,distortions,linebackers,federalism,mombasa,lumen,bernoulli,favouring,aligarh,denounce,steamboats,dnieper,stratigraphic,synths,bernese,umass,icebreaker,guanajuato,heisenberg,boldly,diodes,ladakh,dogmatic,scriptwriter,maritimes,battlestar,symposia,adaptable,toluca,bhavan,nanking,ieyasu,picardy,soybean,adalbert,brompton,deutsches,brezhnev,glandular,laotian,hispanicized,ibadan,personification,dalit,yamuna,regio,dispensed,yamagata,zweibrucken,revising,fandom,stances,participle,flavours,khitan,vertebral,crores,mayaguez,dispensation,guntur,undefined,harpercollins,unionism,meena,leveling,philippa,refractory,telstra,judea,attenuation,pylons,elaboration,elegy,edging,gracillariidae,residencies,absentia,reflexive,deportations,dichotomy,stoves,sanremo,shimon,menachem,corneal,conifers,mordellidae,facsimile,diagnoses,cowper,citta,viticulture,divisive,riverview,foals,mystics,polyhedron,plazas,airspeed,redgrave,motherland,impede,multiplicity,barrichello,airships,pharmacists,harvester,clays,payloads,differentiating,popularize,caesars,tunneling,stagnant,circadian,indemnity,sensibilities,musicology,prefects,serfs,metra,lillehammer,carmarthenshire,kiosks,welland,barbican,alkyl,tillandsia,gatherers,asociacion,showings,bharati,brandywine,subversion,scalable,pfizer,dawla,barium,dardanelles,nsdap,konig,ayutthaya,hodgkin,sedimentation,completions,purchasers,sponsorships,maximizing,banked,taoism,minot,enrolls,fructose,aspired,capuchin,outages,artois,carrollton,totality,osceola,pawtucket,fontainebleau,converged,queretaro,competencies,botha,allotments,sheaf,shastri,obliquely,banding,catharines,outwardly,monchengladbach,driest,contemplative,cassini,ranga,pundit,kenilworth,tiananmen,disulfide,formula_35,townlands,codice_3,looping,caravans,rachmaninoff,segmentation,fluorine,anglicised,gnostic,dessau,discern,reconfigured,altrincham,rebounding,battlecruiser,ramblers,1770s,convective,triomphe,miyagi,mourners,instagram,aloft,breastfeeding,courtyards,folkestone,changsha,kumamoto,saarland,grayish,provisionally,appomattox,uncial,classicism,mahindra,elapsed,supremes,monophyletic,cautioned,formula_36,noblewoman,kernels,sucre,swaps,bengaluru,grenfell,epicenter,rockhampton,worshipful,licentiate,metaphorical,malankara,amputated,wattle,palawan,tankobon,nobunaga,polyhedra,transduction,jilin,syrians,affinities,fluently,emanating,anglicized,sportscar,botanists,altona,dravida,chorley,allocations,kunming,luanda,premiering,outlived,mesoamerica,lingual,dissipating,impairments,attenborough,balustrade,emulator,bakhsh,cladding,increments,ascents,workington,qal'eh,winless,categorical,petrel,emphasise,dormer,toros,hijackers,telescopic,solidly,jankovic,cession,gurus,madoff,newry,subsystems,northside,talib,englishmen,farnese,holographic,electives,argonne,scrivener,predated,brugge,nauvoo,catalyses,soared,siddeley,graphically,powerlifting,funicular,sungai,coercive,fusing,uncertainties,locos,acetic,diverge,wedgwood,dressings,tiebreaker,didactic,vyacheslav,acreage,interplanetary,battlecruisers,sunbury,alkaloids,hairpin,automata,wielkie,interdiction,plugins,monkees,nudibranch,esporte,approximations,disabling,powering,characterisation,ecologically,martinsville,termen,perpetuated,lufthansa,ascendancy,motherboard,bolshoi,athanasius,prunus,dilution,invests,nonzero,mendocino,charan,banque,shaheed,counterculture,unita,voivode,hospitalization,vapour,supermarine,resistor,steppes,osnabruck,intermediates,benzodiazepines,sunnyside,privatized,geopolitical,ponta,beersheba,kievan,embody,theoretic,sangh,cartographer,blige,rotors,thruway,battlefields,discernible,demobilized,broodmare,colouration,sagas,policymakers,serialization,augmentation,hoare,frankfurter,transnistria,kinases,detachable,generational,converging,antiaircraft,khaki,bimonthly,coadjutor,arkhangelsk,kannur,buffers,livonian,northwich,enveloped,cysts,yokozuna,herne,beeching,enron,virginian,woollen,excepting,competitively,outtakes,recombinant,hillcrest,clearances,pathe,cumbersome,brasov,u.s.a,likud,christiania,cruciform,hierarchies,wandsworth,lupin,resins,voiceover,sitar,electrochemical,mediacorp,typhus,grenadiers,hepatic,pompeii,weightlifter,bosniak,oxidoreductase,undersecretary,rescuers,ranji,seleucid,analysing,exegesis,tenancy,toure,kristiansand,110th,carillon,minesweepers,poitou,acceded,palladian,redevelop,naismith,rifled,proletariat,shojo,hackensack,harvests,endpoint,kuban,rosenborg,stonehenge,authorisation,jacobean,revocation,compatriots,colliding,undetermined,okayama,acknowledgment,angelou,fresnel,chahar,ethereal,mg/kg,emmet,mobilised,unfavourable,cultura,characterizing,parsonage,skeptics,expressways,rabaul,medea,guardsmen,visakhapatnam,caddo,homophobic,elmwood,encircling,coexistence,contending,seljuk,mycologist,infertility,moliere,insolvent,covenants,underpass,holme,landesliga,workplaces,delinquency,methamphetamine,contrived,tableau,tithes,overlying,usurped,contingents,spares,oligocene,molde,beatification,mordechai,balloting,pampanga,navigators,flowered,debutant,codec,orogeny,newsletters,solon,ambivalent,ubisoft,archdeaconry,harpers,kirkus,jabal,castings,kazhagam,sylhet,yuwen,barnstaple,amidships,causative,isuzu,watchtower,granules,canaveral,remuneration,insurer,payout,horizonte,integrative,attributing,kiwis,skanderbeg,asymmetry,gannett,urbanism,disassembled,unaltered,precluded,melodifestivalen,ascends,plugin,gurkha,bisons,stakeholder,industrialisation,abbotsford,sextet,bustling,uptempo,slavia,choreographers,midwives,haram,javed,gazetteer,subsection,natively,weighting,lysine,meera,redbridge,muchmusic,abruzzo,adjoins,unsustainable,foresters,kbit/s,cosmopterigidae,secularism,poetics,causality,phonograph,estudiantes,ceausescu,universitario,adjoint,applicability,gastropods,nagaland,kentish,mechelen,atalanta,woodpeckers,lombards,gatineau,romansh,avraham,acetylcholine,perturbation,galois,wenceslaus,fuzhou,meandering,dendritic,sacristy,accented,katha,therapeutics,perceives,unskilled,greenhouses,analogues,chaldean,timbre,sloped,volodymyr,sadiq,maghreb,monogram,rearguard,caucuses,mures,metabolite,uyezd,determinism,theosophical,corbet,gaels,disruptions,bicameral,ribosomal,wolseley,clarksville,watersheds,tarsi,radon,milanese,discontinuous,aristotelian,whistleblower,representational,hashim,modestly,localised,atrial,hazara,ravana,troyes,appointees,rubus,morningside,amity,aberdare,ganglia,wests,zbigniew,aerobatic,depopulated,corsican,introspective,twinning,hardtop,shallower,cataract,mesolithic,emblematic,graced,lubrication,republicanism,voronezh,bastions,meissen,irkutsk,oboes,hokkien,sprites,tenet,individualist,capitulated,oakville,dysentery,orientalist,hillsides,keywords,elicited,incised,lagging,apoel,lengthening,attractiveness,marauders,sportswriter,decentralization,boltzmann,contradicts,draftsman,precipitate,solihull,norske,consorts,hauptmann,riflemen,adventists,syndromes,demolishing,customize,continuo,peripherals,seamlessly,linguistically,bhushan,orphanages,paraul,lessened,devanagari,quarto,responders,patronymic,riemannian,altoona,canonization,honouring,geodetic,exemplifies,republica,enzymatic,porters,fairmount,pampa,sufferers,kamchatka,conjugated,coachella,uthman,repositories,copious,headteacher,awami,phoneme,homomorphism,franconian,moorland,davos,quantified,kamloops,quarks,mayoralty,weald,peacekeepers,valerian,particulate,insiders,perthshire,caches,guimaraes,piped,grenadines,kosciuszko,trombonist,artemisia,covariance,intertidal,soybeans,beatified,ellipse,fruiting,deafness,dnipropetrovsk,accrued,zealous,mandala,causation,junius,kilowatt,bakeries,montpelier,airdrie,rectified,bungalows,toleration,debian,pylon,trotskyist,posteriorly,two-and-a-half,herbivorous,islamists,poetical,donne,wodehouse,frome,allium,assimilate,phonemic,minaret,unprofitable,darpa,untenable,leaflet,bitcoin,zahir,thresholds,argentino,jacopo,bespoke,stratified,wellbeing,shiite,basaltic,timberwolves,secrete,taunts,marathons,isomers,carre,consecrators,penobscot,pitcairn,sakha,crosstown,inclusions,impassable,fenders,indre,uscgc,jordi,retinue,logarithmic,pilgrimages,railcar,cashel,blackrock,macroscopic,aligning,tabla,trestle,certify,ronson,palps,dissolves,thickened,silicate,taman,walsingham,hausa,lowestoft,rondo,oleksandr,cuyahoga,retardation,countering,cricketing,holborn,identifiers,hells,geophysics,infighting,sculpting,balaji,webbed,irradiation,runestone,trusses,oriya,sojourn,forfeiture,colonize,exclaimed,eucharistic,lackluster,glazing,northridge,gutenberg,stipulates,macroeconomic,priori,outermost,annular,udinese,insulating,headliner,godel,polytope,megalithic,salix,sharapova,derided,muskegon,braintree,plateaus,confers,autocratic,isomer,interstitial,stamping,omits,kirtland,hatchery,evidences,intifada,111th,podgorica,capua,motivating,nuneaton,jakub,korsakov,amitabh,mundial,monrovia,gluten,predictor,marshalling,d'orleans,levers,touchscreen,brantford,fricative,banishment,descendent,antagonism,ludovico,loudspeakers,formula_37,livelihoods,manassas,steamships,dewsbury,uppermost,humayun,lures,pinnacles,dependents,lecce,clumps,observatories,paleozoic,dedicating,samiti,draughtsman,gauls,incite,infringing,nepean,pythagorean,convents,triumvirate,seigneur,gaiman,vagrant,fossa,byproduct,serrated,renfrewshire,sheltering,achaemenid,dukedom,catchers,sampdoria,platelet,bielefeld,fluctuating,phenomenology,strikeout,ethnology,prospectors,woodworking,tatra,wildfires,meditations,agrippa,fortescue,qureshi,wojciech,methyltransferase,accusative,saatchi,amerindian,volcanism,zeeland,toyama,vladimirovich,allege,polygram,redox,budgeted,advisories,nematode,chipset,starscream,tonbridge,hardening,shales,accompanist,paraded,phonographic,whitefish,sportive,audiobook,kalisz,hibernation,latif,duels,ps200,coxeter,nayak,safeguarding,cantabria,minesweeping,zeiss,dunams,catholicos,sawtooth,ontological,nicobar,bridgend,unclassified,intrinsically,hanoverian,rabbitohs,kenseth,alcalde,northumbrian,raritan,septuagint,presse,sevres,origen,dandenong,peachtree,intersected,impeded,usages,hippodrome,novara,trajectories,customarily,yardage,inflected,yanow,kalan,taverns,liguria,librettist,intermarriage,1760s,courant,gambier,infanta,ptolemaic,ukulele,haganah,sceptical,manchukuo,plexus,implantation,hilal,intersex,efficiencies,arbroath,hagerstown,adelphi,diario,marais,matti,lifes,coining,modalities,divya,bletchley,conserving,ivorian,mithridates,generative,strikeforce,laymen,toponymy,pogrom,satya,meticulously,agios,dufferin,yaakov,fortnightly,cargoes,deterrence,prefrontal,przemysl,mitterrand,commemorations,chatsworth,gurdwara,abuja,chakraborty,badajoz,geometries,artiste,diatonic,ganglion,presides,marymount,nanak,cytokines,feudalism,storks,rowers,widens,politico,evangelicals,assailants,pittsfield,allowable,bijapur,telenovelas,dichomeris,glenelg,herbivores,keita,inked,radom,fundraisers,constantius,boheme,portability,komnenos,crystallography,derrida,moderates,tavistock,fateh,spacex,disjoint,bristles,commercialized,interwoven,empirically,regius,bulacan,newsday,showa,radicalism,yarrow,pleura,sayed,structuring,cotes,reminiscences,acetyl,edicts,escalators,aomori,encapsulated,legacies,bunbury,placings,fearsome,postscript,powerfully,keighley,hildesheim,amicus,crevices,deserters,benelux,aurangabad,freeware,ioannis,carpathians,chirac,seceded,prepaid,landlocked,naturalised,yanukovych,soundscan,blotch,phenotypic,determinants,twente,dictatorial,giessen,composes,recherche,pathophysiology,inventories,ayurveda,elevating,gravestone,degeneres,vilayet,popularizing,spartanburg,bloemfontein,previewed,renunciation,genotype,ogilvy,tracery,blacklisted,emissaries,diploid,disclosures,tupolev,shinjuku,antecedents,pennine,braganza,bhattacharya,countable,spectroscopic,ingolstadt,theseus,corroborated,compounding,thrombosis,extremadura,medallions,hasanabad,lambton,perpetuity,glycol,besancon,palaiologos,pandey,caicos,antecedent,stratum,laserdisc,novitiate,crowdfunding,palatal,sorceress,dassault,toughness,celle,cezanne,vientiane,tioga,hander,crossbar,gisborne,cursor,inspectorate,serif,praia,sphingidae,nameplate,psalter,ivanovic,sitka,equalised,mutineers,sergius,outgrowth,creationism,haredi,rhizomes,predominate,undertakings,vulgate,hydrothermal,abbeville,geodesic,kampung,physiotherapy,unauthorised,asteraceae,conservationist,minoan,supersport,mohammadabad,cranbrook,mentorship,legitimately,marshland,datuk,louvain,potawatomi,carnivores,levies,lyell,hymnal,regionals,tinto,shikoku,conformal,wanganui,beira,lleida,standstill,deloitte,formula_40,corbusier,chancellery,mixtapes,airtime,muhlenberg,formula_39,bracts,thrashers,prodigious,gironde,chickamauga,uyghurs,substitutions,pescara,batangas,gregarious,gijon,paleo,mathura,pumas,proportionally,hawkesbury,yucca,kristiania,funimation,fluted,eloquence,mohun,aftermarket,chroniclers,futurist,nonconformist,branko,mannerisms,lesnar,opengl,altos,retainers,ashfield,shelbourne,sulaiman,divisie,gwent,locarno,lieder,minkowski,bivalve,redeployed,cartography,seaway,bookings,decays,ostend,antiquaries,pathogenesis,formula_38,chrysalis,esperance,valli,motogp,homelands,bridged,bloor,ghazal,vulgaris,baekje,prospector,calculates,debtors,hesperiidae,titian,returner,landgrave,frontenac,kelowna,pregame,castelo,caius,canoeist,watercolours,winterthur,superintendents,dissonance,dubstep,adorn,matic,salih,hillel,swordsman,flavoured,emitter,assays,monongahela,deeded,brazzaville,sufferings,babylonia,fecal,umbria,astrologer,gentrification,frescos,phasing,zielona,ecozone,candido,manoj,quadrilateral,gyula,falsetto,prewar,puntland,infinitive,contraceptive,bakhtiari,ohrid,socialization,tailplane,evoking,havelock,macapagal,plundering,104th,keynesian,templars,phrasing,morphologically,czestochowa,humorously,catawba,burgas,chiswick,ellipsoid,kodansha,inwards,gautama,katanga,orthopaedic,heilongjiang,sieges,outsourced,subterminal,vijayawada,hares,oration,leitrim,ravines,manawatu,cryogenic,tracklisting,about.com,ambedkar,degenerated,hastened,venturing,lobbyists,shekhar,typefaces,northcote,rugen,'good,ornithology,asexual,hemispheres,unsupported,glyphs,spoleto,epigenetic,musicianship,donington,diogo,kangxi,bisected,polymorphism,megawatt,salta,embossed,cheetahs,cruzeiro,unhcr,aristide,rayleigh,maturing,indonesians,noire,llano,ffffff,camus,purges,annales,convair,apostasy,algol,phage,apaches,marketers,aldehyde,pompidou,kharkov,forgeries,praetorian,divested,retrospectively,gornji,scutellum,bitumen,pausanias,magnification,imitations,nyasaland,geographers,floodlights,athlone,hippolyte,expositions,clarinetist,razak,neutrinos,rotax,sheykh,plush,interconnect,andalus,cladogram,rudyard,resonator,granby,blackfriars,placido,windscreen,sahel,minamoto,haida,cations,emden,blackheath,thematically,blacklist,pawel,disseminating,academical,undamaged,raytheon,harsher,powhatan,ramachandran,saddles,paderborn,capping,zahra,prospecting,glycine,chromatin,profane,banska,helmand,okinawan,dislocation,oscillators,insectivorous,foyle,gilgit,autonomic,tuareg,sluice,pollinated,multiplexed,granary,narcissus,ranchi,staines,nitra,goalscoring,midwifery,pensioners,algorithmic,meetinghouse,biblioteca,besar,narva,angkor,predate,lohan,cyclical,detainee,occipital,eventing,faisalabad,dartmoor,kublai,courtly,resigns,radii,megachilidae,cartels,shortfall,xhosa,unregistered,benchmarks,dystopian,bulkhead,ponsonby,jovanovic,accumulates,papuan,bhutanese,intuitively,gotaland,headliners,recursion,dejan,novellas,diphthongs,imbued,withstood,analgesic,amplify,powertrain,programing,maidan,alstom,affirms,eradicated,summerslam,videogame,molla,severing,foundered,gallium,atmospheres,desalination,shmuel,howmeh,catolica,bossier,reconstructing,isolates,lyase,tweets,unconnected,tidewater,divisible,cohorts,orebro,presov,furnishing,folklorist,simplifying,centrale,notations,factorization,monarchies,deepen,macomb,facilitation,hennepin,declassified,redrawn,microprocessors,preliminaries,enlarging,timeframe,deutschen,shipbuilders,patiala,ferrous,aquariums,genealogies,vieux,unrecognized,bridgwater,tetrahedral,thule,resignations,gondwana,registries,agder,dataset,felled,parva,analyzer,worsen,coleraine,columella,blockaded,polytechnique,reassembled,reentry,narvik,greys,nigra,knockouts,bofors,gniezno,slotted,hamasaki,ferrers,conferring,thirdly,domestication,photojournalist,universality,preclude,ponting,halved,thereupon,photosynthetic,ostrava,mismatch,pangasinan,intermediaries,abolitionists,transited,headings,ustase,radiological,interconnection,dabrowa,invariants,honorius,preferentially,chantilly,marysville,dialectical,antioquia,abstained,gogol,dirichlet,muricidae,symmetries,reproduces,brazos,fatwa,bacillus,ketone,paribas,chowk,multiplicative,dermatitis,mamluks,devotes,adenosine,newbery,meditative,minefields,inflection,oxfam,conwy,bystrica,imprints,pandavas,infinitesimal,conurbation,amphetamine,reestablish,furth,edessa,injustices,frankston,serjeant,4x200,khazar,sihanouk,longchamp,stags,pogroms,coups,upperparts,endpoints,infringed,nuanced,summing,humorist,pacification,ciaran,jamaat,anteriorly,roddick,springboks,faceted,hypoxia,rigorously,cleves,fatimid,ayurvedic,tabled,ratna,senhora,maricopa,seibu,gauguin,holomorphic,campgrounds,amboy,coordinators,ponderosa,casemates,ouachita,nanaimo,mindoro,zealander,rimsky,cluny,tomaszow,meghalaya,caetano,tilak,roussillon,landtag,gravitation,dystrophy,cephalopods,trombones,glens,killarney,denominated,anthropogenic,pssas,roubaix,carcasses,montmorency,neotropical,communicative,rabindranath,ordinated,separable,overriding,surged,sagebrush,conciliation,codice_4,durrani,phosphatase,qadir,votive,revitalized,taiyuan,tyrannosaurus,graze,slovaks,nematodes,environmentalism,blockhouse,illiteracy,schengen,ecotourism,alternation,conic,wields,hounslow,blackfoot,kwame,ambulatory,volhynia,hordaland,croton,piedras,rohit,drava,conceptualized,birla,illustrative,gurgaon,barisal,tutsi,dezong,nasional,polje,chanson,clarinets,krasnoyarsk,aleksandrovich,cosmonaut,d'este,palliative,midseason,silencing,wardens,durer,girders,salamanders,torrington,supersonics,lauda,farid,circumnavigation,embankments,funnels,bajnoksag,lorries,cappadocia,jains,warringah,retirees,burgesses,equalization,cusco,ganesan,algal,amazonian,lineups,allocating,conquerors,usurper,mnemonic,predating,brahmaputra,ahmadabad,maidenhead,numismatic,subregion,encamped,reciprocating,freebsd,irgun,tortoises,governorates,zionists,airfoil,collated,ajmer,fiennes,etymological,polemic,chadian,clerestory,nordiques,fluctuated,calvados,oxidizing,trailhead,massena,quarrels,dordogne,tirunelveli,pyruvate,pulsed,athabasca,sylar,appointee,serer,japonica,andronikos,conferencing,nicolaus,chemin,ascertained,incited,woodbine,helices,hospitalised,emplacements,to/from,orchestre,tyrannical,pannonia,methodism,pop/rock,shibuya,berbers,despot,seaward,westpac,separator,perpignan,alamein,judeo,publicize,quantization,ethniki,gracilis,menlo,offside,oscillating,unregulated,succumbing,finnmark,metrical,suleyman,raith,sovereigns,bundesstrasse,kartli,fiduciary,darshan,foramen,curler,concubines,calvinism,larouche,bukhara,sophomores,mohanlal,lutheranism,monomer,eamonn,'black,uncontested,immersive,tutorials,beachhead,bindings,permeable,postulates,comite,transformative,indiscriminate,hofstra,associacao,amarna,dermatology,lapland,aosta,babur,unambiguous,formatting,schoolboys,gwangju,superconducting,replayed,adherent,aureus,compressors,forcible,spitsbergen,boulevards,budgeting,nossa,annandale,perumal,interregnum,sassoon,kwajalein,greenbrier,caldas,triangulation,flavius,increment,shakhtar,nullified,pinfall,nomen,microfinance,depreciation,cubist,steeper,splendour,gruppe,everyman,chasers,campaigners,bridle,modality,percussive,darkly,capes,velar,picton,triennial,factional,padang,toponym,betterment,norepinephrine,112th,estuarine,diemen,warehousing,morphism,ideologically,pairings,immunization,crassus,exporters,sefer,flocked,bulbous,deseret,booms,calcite,bohol,elven,groot,pulau,citigroup,wyeth,modernizing,layering,pastiche,complies,printmaker,condenser,theropod,cassino,oxyrhynchus,akademie,trainings,lowercase,coxae,parte,chetniks,pentagonal,keselowski,monocoque,morsi,reticulum,meiosis,clapboard,recoveries,tinge,an/fps,revista,sidon,livre,epidermis,conglomerates,kampong,congruent,harlequins,tergum,simplifies,epidemiological,underwriting,tcp/ip,exclusivity,multidimensional,mysql,columbine,ecologist,hayat,sicilies,levees,handset,aesop,usenet,pacquiao,archiving,alexandrian,compensatory,broadsheet,annotation,bahamian,d'affaires,interludes,phraya,shamans,marmara,customizable,immortalized,ambushes,chlorophyll,diesels,emulsion,rheumatoid,voluminous,screenwriters,tailoring,sedis,runcorn,democratization,bushehr,anacostia,constanta,antiquary,sixtus,radiate,advaita,antimony,acumen,barristers,reichsbahn,ronstadt,symbolist,pasig,cursive,secessionist,afrikaner,munnetra,inversely,adsorption,syllabic,moltke,idioms,midline,olimpico,diphosphate,cautions,radziwill,mobilisation,copelatus,trawlers,unicron,bhaskar,financiers,minimalism,derailment,marxists,oireachtas,abdicate,eigenvalue,zafar,vytautas,ganguly,chelyabinsk,telluride,subordination,ferried,dived,vendee,pictish,dimitrov,expiry,carnation,cayley,magnitudes,lismore,gretna,sandwiched,unmasked,sandomierz,swarthmore,tetra,nanyang,pevsner,dehradun,mormonism,rashi,complying,seaplanes,ningbo,cooperates,strathcona,mornington,mestizo,yulia,edgbaston,palisade,ethno,polytopes,espirito,tymoshenko,pronunciations,paradoxical,taichung,chipmunks,erhard,maximise,accretion,kanda,`abdu'l,narrowest,umpiring,mycenaean,divisor,geneticist,ceredigion,barque,hobbyists,equates,auxerre,spinose,cheil,sweetwater,guano,carboxylic,archiv,tannery,cormorant,agonists,fundacion,anbar,tunku,hindrance,meerut,concordat,secunderabad,kachin,achievable,murfreesboro,comprehensively,forges,broadest,synchronised,speciation,scapa,aliyev,conmebol,tirelessly,subjugated,pillaged,udaipur,defensively,lakhs,stateless,haasan,headlamps,patterning,podiums,polyphony,mcmurdo,mujer,vocally,storeyed,mucosa,multivariate,scopus,minimizes,formalised,certiorari,bourges,populate,overhanging,gaiety,unreserved,borromeo,woolworths,isotopic,bashar,purify,vertebra,medan,juxtaposition,earthwork,elongation,chaudhary,schematic,piast,steeped,nanotubes,fouls,achaea,legionnaires,abdur,qmjhl,embraer,hardback,centerville,ilocos,slovan,whitehorse,mauritian,moulding,mapuche,donned,provisioning,gazprom,jonesboro,audley,lightest,calyx,coldwater,trigonometric,petroglyphs,psychoanalyst,congregate,zambezi,fissure,supervises,bexley,etobicoke,wairarapa,tectonics,emphasises,formula_41,debugging,linfield,spatially,ionizing,ungulates,orinoco,clades,erlangen,news/talk,vols.,ceara,yakovlev,finsbury,entanglement,fieldhouse,graphene,intensifying,grigory,keyong,zacatecas,ninian,allgemeine,keswick,societa,snorri,femininity,najib,monoclonal,guyanese,postulate,huntly,abbeys,machinist,yunus,emphasising,ishaq,urmia,bremerton,pretenders,lumiere,thoroughfares,chikara,dramatized,metathorax,taiko,transcendence,wycliffe,retrieves,umpired,steuben,racehorses,taylors,kuznetsov,montezuma,precambrian,canopies,gaozong,propodeum,disestablished,retroactive,shoreham,rhizome,doubleheader,clinician,diwali,quartzite,shabaab,agassiz,despatched,stormwater,luxemburg,callao,universidade,courland,skane,glyph,dormers,witwatersrand,curacy,qualcomm,nansen,entablature,lauper,hausdorff,lusaka,ruthenian,360deg,cityscape,douai,vaishnava,spars,vaulting,rationalist,gygax,sequestration,typology,pollinates,accelerators,leben,colonials,cenotaph,imparted,carthaginians,equaled,rostrum,gobind,bodhisattva,oberst,bicycling,arabi,sangre,biophysics,hainaut,vernal,lunenburg,apportioned,finches,lajos,nenad,repackaged,zayed,nikephoros,r.e.m,swaminarayan,gestalt,unplaced,crags,grohl,sialkot,unsaturated,gwinnett,linemen,forays,palakkad,writs,instrumentalists,aircrews,badged,terrapins,180deg,oneness,commissariat,changi,pupation,circumscribed,contador,isotropic,administrated,fiefs,nimes,intrusions,minoru,geschichte,nadph,tainan,changchun,carbondale,frisia,swapo,evesham,hawai'i,encyclopedic,transporters,dysplasia,formula_42,onsite,jindal,guetta,judgements,narbonne,permissions,paleogene,rationalism,vilna,isometric,subtracted,chattahoochee,lamina,missa,greville,pervez,lattices,persistently,crystallization,timbered,hawaiians,fouling,interrelated,masood,ripening,stasi,gamal,visigothic,warlike,cybernetics,tanjung,forfar,cybernetic,karelian,brooklands,belfort,greifswald,campeche,inexplicably,refereeing,understory,uninterested,prius,collegiately,sefid,sarsfield,categorize,biannual,elsevier,eisteddfod,declension,autonoma,procuring,misrepresentation,novelization,bibliographic,shamanism,vestments,potash,eastleigh,ionized,turan,lavishly,scilly,balanchine,importers,parlance,'that,kanyakumari,synods,mieszko,crossovers,serfdom,conformational,legislated,exclave,heathland,sadar,differentiates,propositional,konstantinos,photoshop,manche,vellore,appalachia,orestes,taiga,exchanger,grozny,invalidated,baffin,spezia,staunchly,eisenach,robustness,virtuosity,ciphers,inlets,bolagh,understandings,bosniaks,parser,typhoons,sinan,luzerne,webcomic,subtraction,jhelum,businessweek,ceske,refrained,firebox,mitigated,helmholtz,dilip,eslamabad,metalwork,lucan,apportionment,provident,gdynia,schooners,casement,danse,hajjiabad,benazir,buttress,anthracite,newsreel,wollaston,dispatching,cadastral,riverboat,provincetown,nantwich,missal,irreverent,juxtaposed,darya,ennobled,electropop,stereoscopic,maneuverability,laban,luhansk,udine,collectibles,haulage,holyrood,materially,supercharger,gorizia,shkoder,townhouses,pilate,layoffs,folkloric,dialectic,exuberant,matures,malla,ceuta,citizenry,crewed,couplet,stopover,transposition,tradesmen,antioxidant,amines,utterance,grahame,landless,isere,diction,appellant,satirist,urbino,intertoto,subiaco,antonescu,nehemiah,ubiquitin,emcee,stourbridge,fencers,103rd,wranglers,monteverdi,watertight,expounded,xiamen,manmohan,pirie,threefold,antidepressant,sheboygan,grieg,cancerous,diverging,bernini,polychrome,fundamentalism,bihari,critiqued,cholas,villers,tendulkar,dafydd,vastra,fringed,evangelization,episcopalian,maliki,sana'a,ashburton,trianon,allegany,heptathlon,insufficiently,panelists,pharrell,hexham,amharic,fertilized,plumes,cistern,stratigraphy,akershus,catalans,karoo,rupee,minuteman,quantification,wigmore,leutnant,metanotum,weeknights,iridescent,extrasolar,brechin,deuterium,kuching,lyricism,astrakhan,brookhaven,euphorbia,hradec,bhagat,vardar,aylmer,positron,amygdala,speculators,unaccompanied,debrecen,slurry,windhoek,disaffected,rapporteur,mellitus,blockers,fronds,yatra,sportsperson,precession,physiologist,weeknight,pidgin,pharma,condemns,standardize,zetian,tibor,glycoprotein,emporia,cormorants,amalie,accesses,leonhard,denbighshire,roald,116th,will.i.am,symbiosis,privatised,meanders,chemnitz,jabalpur,shing,secede,ludvig,krajina,homegrown,snippets,sasanian,euripides,peder,cimarron,streaked,graubunden,kilimanjaro,mbeki,middleware,flensburg,bukovina,lindwall,marsalis,profited,abkhaz,polis,camouflaged,amyloid,morgantown,ovoid,bodleian,morte,quashed,gamelan,juventud,natchitoches,storyboard,freeview,enumeration,cielo,preludes,bulawayo,1600s,olympiads,multicast,faunal,asura,reinforces,puranas,ziegfeld,handicraft,seamount,kheil,noche,hallmarks,dermal,colorectal,encircle,hessen,umbilicus,sunnis,leste,unwin,disclosing,superfund,montmartre,refuelling,subprime,kolhapur,etiology,bismuth,laissez,vibrational,mazar,alcoa,rumsfeld,recurve,ticonderoga,lionsgate,onlookers,homesteads,filesystem,barometric,kingswood,biofuel,belleza,moshav,occidentalis,asymptomatic,northeasterly,leveson,huygens,numan,kingsway,primogeniture,toyotomi,yazoo,limpets,greenbelt,booed,concurrence,dihedral,ventrites,raipur,sibiu,plotters,kitab,109th,trackbed,skilful,berthed,effendi,fairing,sephardi,mikhailovich,lockyer,wadham,invertible,paperbacks,alphabetic,deuteronomy,constitutive,leathery,greyhounds,estoril,beechcraft,poblacion,cossidae,excreted,flamingos,singha,olmec,neurotransmitters,ascoli,nkrumah,forerunners,dualism,disenchanted,benefitted,centrum,undesignated,noida,o'donoghue,collages,egrets,egmont,wuppertal,cleave,montgomerie,pseudomonas,srinivasa,lymphatic,stadia,resold,minima,evacuees,consumerism,ronde,biochemist,automorphism,hollows,smuts,improvisations,vespasian,bream,pimlico,eglin,colne,melancholic,berhad,ousting,saale,notaulices,ouest,hunslet,tiberias,abdomina,ramsgate,stanislas,donbass,pontefract,sucrose,halts,drammen,chelm,l'arc,taming,trolleys,konin,incertae,licensees,scythian,giorgos,dative,tanglewood,farmlands,o'keeffe,caesium,romsdal,amstrad,corte,oglethorpe,huntingdonshire,magnetization,adapts,zamosc,shooto,cuttack,centrepiece,storehouse,winehouse,morbidity,woodcuts,ryazan,buddleja,buoyant,bodmin,estero,austral,verifiable,periyar,christendom,curtail,shura,kaifeng,cotswold,invariance,seafaring,gorica,androgen,usman,seabird,forecourt,pekka,juridical,audacious,yasser,cacti,qianlong,polemical,d'amore,espanyol,distrito,cartographers,pacifism,serpents,backa,nucleophilic,overturning,duplicates,marksman,oriente,vuitton,oberleutnant,gielgud,gesta,swinburne,transfiguration,1750s,retaken,celje,fredrikstad,asuka,cropping,mansard,donates,blacksmiths,vijayanagara,anuradhapura,germinate,betis,foreshore,jalandhar,bayonets,devaluation,frazione,ablaze,abidjan,approvals,homeostasis,corollary,auden,superfast,redcliffe,luxembourgish,datum,geraldton,printings,ludhiana,honoree,synchrotron,invercargill,hurriedly,108th,three-and-a-half,colonist,bexar,limousin,bessemer,ossetian,nunataks,buddhas,rebuked,thais,tilburg,verdicts,interleukin,unproven,dordrecht,solent,acclamation,muammar,dahomey,operettas,4x400,arrears,negotiators,whitehaven,apparitions,armoury,psychoactive,worshipers,sculptured,elphinstone,airshow,kjell,o'callaghan,shrank,professorships,predominance,subhash,coulomb,sekolah,retrofitted,samos,overthrowing,vibrato,resistors,palearctic,datasets,doordarshan,subcutaneous,compiles,immorality,patchwork,trinidadian,glycogen,pronged,zohar,visigoths,freres,akram,justo,agora,intakes,craiova,playwriting,bukhari,militarism,iwate,petitioners,harun,wisla,inefficiency,vendome,ledges,schopenhauer,kashi,entombed,assesses,tenn.,noumea,baguio,carex,o'donovan,filings,hillsdale,conjectures,blotches,annuals,lindisfarne,negated,vivek,angouleme,trincomalee,cofactor,verkhovna,backfield,twofold,automaker,rudra,freighters,darul,gharana,busway,formula_43,plattsburgh,portuguesa,showrunner,roadmap,valenciennes,erdos,biafra,spiritualism,transactional,modifies,carne,107th,cocos,gcses,tiverton,radiotherapy,meadowlands,gunma,srebrenica,foxtel,authenticated,enslavement,classicist,klaipeda,minstrels,searchable,infantrymen,incitement,shiga,nadp+,urals,guilders,banquets,exteriors,counterattacks,visualized,diacritics,patrimony,svensson,transepts,prizren,telegraphy,najaf,emblazoned,coupes,effluent,ragam,omani,greensburg,taino,flintshire,cd/dvd,lobbies,narrating,cacao,seafarers,bicolor,collaboratively,suraj,floodlit,sacral,puppetry,tlingit,malwa,login,motionless,thien,overseers,vihar,golem,specializations,bathhouse,priming,overdubs,winningest,archetypes,uniao,acland,creamery,slovakian,lithographs,maryborough,confidently,excavating,stillborn,ramallah,audiencia,alava,ternary,hermits,rostam,bauxite,gawain,lothair,captions,gulfstream,timelines,receded,mediating,petain,bastia,rudbar,bidders,disclaimer,shrews,tailings,trilobites,yuriy,jamil,demotion,gynecology,rajinikanth,madrigals,ghazni,flycatchers,vitebsk,bizet,computationally,kashgar,refinements,frankford,heralds,europe/africa,levante,disordered,sandringham,queues,ransacked,trebizond,verdes,comedie,primitives,figurine,organists,culminate,gosport,coagulation,ferrying,hoyas,polyurethane,prohibitive,midfielders,ligase,progesterone,defectors,sweetened,backcountry,diodorus,waterside,nieuport,khwaja,jurong,decried,gorkha,ismaili,300th,octahedral,kindergartens,paseo,codification,notifications,disregarding,risque,reconquista,shortland,atolls,texarkana,perceval,d'etudes,kanal,herbicides,tikva,nuova,gatherer,dissented,soweto,dexterity,enver,bacharach,placekicker,carnivals,automate,maynooth,symplectic,chetnik,militaire,upanishads,distributive,strafing,championing,moiety,miliband,blackadder,enforceable,maung,dimer,stadtbahn,diverges,obstructions,coleophoridae,disposals,shamrocks,aural,banca,bahru,coxed,grierson,vanadium,watermill,radiative,ecoregions,berets,hariri,bicarbonate,evacuations,mallee,nairn,rushden,loggia,slupsk,satisfactorily,milliseconds,cariboo,reine,cyclo,pigmentation,postmodernism,aqueducts,vasari,bourgogne,dilemmas,liquefied,fluminense,alloa,ibaraki,tenements,kumasi,humerus,raghu,labours,putsch,soundcloud,bodybuilder,rakyat,domitian,pesaro,translocation,sembilan,homeric,enforcers,tombstones,lectureship,rotorua,salamis,nikolaos,inferences,superfortress,lithgow,surmised,undercard,tarnow,barisan,stingrays,federacion,coldstream,haverford,ornithological,heerenveen,eleazar,jyoti,murali,bamako,riverbed,subsidised,theban,conspicuously,vistas,conservatorium,madrasa,kingfishers,arnulf,credential,syndicalist,sheathed,discontinuity,prisms,tsushima,coastlines,escapees,vitis,optimizing,megapixel,overground,embattled,halide,sprinters,buoys,mpumalanga,peculiarities,106th,roamed,menezes,macao,prelates,papyri,freemen,dissertations,irishmen,pooled,sverre,reconquest,conveyance,subjectivity,asturian,circassian,formula_45,comdr,thickets,unstressed,monro,passively,harmonium,moveable,dinar,carlsson,elysees,chairing,b'nai,confusingly,kaoru,convolution,godolphin,facilitator,saxophones,eelam,jebel,copulation,anions,livres,licensure,pontypridd,arakan,controllable,alessandria,propelling,stellenbosch,tiber,wolka,liberators,yarns,d'azur,tsinghua,semnan,amhara,ablation,melies,tonality,historique,beeston,kahne,intricately,sonoran,robespierre,gyrus,boycotts,defaulted,infill,maranhao,emigres,framingham,paraiba,wilhelmshaven,tritium,skyway,labial,supplementation,possessor,underserved,motets,maldivian,marrakech,quays,wikimedia,turbojet,demobilization,petrarch,encroaching,sloops,masted,karbala,corvallis,agribusiness,seaford,stenosis,hieronymus,irani,superdraft,baronies,cortisol,notability,veena,pontic,cyclin,archeologists,newham,culled,concurring,aeolian,manorial,shouldered,fords,philanthropists,105th,siddharth,gotthard,halim,rajshahi,jurchen,detritus,practicable,earthenware,discarding,travelogue,neuromuscular,elkhart,raeder,zygmunt,metastasis,internees,102nd,vigour,upmarket,summarizing,subjunctive,offsets,elizabethtown,udupi,pardubice,repeaters,instituting,archaea,substandard,technische,linga,anatomist,flourishes,velika,tenochtitlan,evangelistic,fitchburg,springbok,cascading,hydrostatic,avars,occasioned,filipina,perceiving,shimbun,africanus,consternation,tsing,optically,beitar,45deg,abutments,roseville,monomers,huelva,lotteries,hypothalamus,internationalist,electromechanical,hummingbirds,fibreglass,salaried,dramatists,uncovers,invokes,earners,excretion,gelding,ancien,aeronautica,haverhill,stour,ittihad,abramoff,yakov,ayodhya,accelerates,industrially,aeroplanes,deleterious,dwelt,belvoir,harpalus,atpase,maluku,alasdair,proportionality,taran,epistemological,interferometer,polypeptide,adjudged,villager,metastatic,marshalls,madhavan,archduchess,weizmann,kalgoorlie,balan,predefined,sessile,sagaing,brevity,insecticide,psychosocial,africana,steelworks,aether,aquifers,belem,mineiro,almagro,radiators,cenozoic,solute,turbocharger,invicta,guested,buccaneer,idolatry,unmatched,paducah,sinestro,dispossessed,conforms,responsiveness,cyanobacteria,flautist,procurator,complementing,semifinalist,rechargeable,permafrost,cytokine,refuges,boomed,gelderland,franchised,jinan,burnie,doubtless,randomness,colspan=12,angra,ginebra,famers,nuestro,declarative,roughness,lauenburg,motile,rekha,issuer,piney,interceptors,napoca,gipsy,formulaic,formula_44,viswanathan,ebrahim,thessalonica,galeria,muskogee,unsold,html5,taito,mobutu,icann,carnarvon,fairtrade,morphisms,upsilon,nozzles,fabius,meander,murugan,strontium,episcopacy,sandinista,parasol,attenuated,bhima,primeval,panay,ordinator,negara,osteoporosis,glossop,ebook,paradoxically,grevillea,modoc,equating,phonetically,legumes,covariant,dorje,quatre,bruxelles,pyroclastic,shipbuilder,zhaozong,obscuring,sveriges,tremolo,extensible,barrack,multnomah,hakon,chaharmahal,parsing,volumetric,astrophysical,glottal,combinatorics,freestanding,encoder,paralysed,cavalrymen,taboos,heilbronn,orientalis,lockport,marvels,ozawa,dispositions,waders,incurring,saltire,modulate,papilio,phenol,intermedia,rappahannock,plasmid,fortify,phenotypes,transiting,correspondences,leaguer,larnaca,incompatibility,mcenroe,deeming,endeavoured,aboriginals,helmed,salar,arginine,werke,ferrand,expropriated,delimited,couplets,phoenicians,petioles,ouster,anschluss,protectionist,plessis,urchins,orquesta,castleton,juniata,bittorrent,fulani,donji,mykola,rosemont,chandos,scepticism,signer,chalukya,wicketkeeper,coquitlam,programmatic,o'brian,carteret,urology,steelhead,paleocene,konkan,bettered,venkatesh,surfacing,longitudinally,centurions,popularization,yazid,douro,widths,premios,leonards,gristmill,fallujah,arezzo,leftists,ecliptic,glycerol,inaction,disenfranchised,acrimonious,depositing,parashah,cockatoo,marechal,bolzano,chios,cablevision,impartiality,pouches,thickly,equities,bentinck,emotive,boson,ashdown,conquistadors,parsi,conservationists,reductive,newlands,centerline,ornithologists,waveguide,nicene,philological,hemel,setanta,masala,aphids,convening,casco,matrilineal,chalcedon,orthographic,hythe,replete,damming,bolivarian,admixture,embarks,borderlands,conformed,nagarjuna,blenny,chaitanya,suwon,shigeru,tatarstan,lingayen,rejoins,grodno,merovingian,hardwicke,puducherry,prototyping,laxmi,upheavals,headquarter,pollinators,bromine,transom,plantagenet,arbuthnot,chidambaram,woburn,osamu,panelling,coauthored,zhongshu,hyaline,omissions,aspergillus,offensively,electrolytic,woodcut,sodom,intensities,clydebank,piotrkow,supplementing,quipped,focke,harbinger,positivism,parklands,wolfenbuttel,cauca,tryptophan,taunus,curragh,tsonga,remand,obscura,ashikaga,eltham,forelimbs,analogs,trnava,observances,kailash,antithesis,ayumi,abyssinia,dorsally,tralee,pursuers,misadventures,padova,perot,mahadev,tarim,granth,licenced,compania,patuxent,baronial,korda,cochabamba,codices,karna,memorialized,semaphore,playlists,mandibular,halal,sivaji,scherzinger,stralsund,foundries,ribosome,mindfulness,nikolayevich,paraphyletic,newsreader,catalyze,ioannina,thalamus,gbit/s,paymaster,sarab,500th,replenished,gamepro,cracow,formula_46,gascony,reburied,lessing,easement,transposed,meurthe,satires,proviso,balthasar,unbound,cuckoos,durbar,louisbourg,cowes,wholesalers,manet,narita,xiaoping,mohamad,illusory,cathal,reuptake,alkaloid,tahrir,mmorpg,underlies,anglicanism,repton,aharon,exogenous,buchenwald,indigent,odostomia,milled,santorum,toungoo,nevsky,steyr,urbanisation,darkseid,subsonic,canaanite,akiva,eglise,dentition,mediators,cirencester,peloponnesian,malmesbury,durres,oerlikon,tabulated,saens,canaria,ischemic,esterhazy,ringling,centralization,walthamstow,nalanda,lignite,takht,leninism,expiring,circe,phytoplankton,promulgation,integrable,breeches,aalto,menominee,borgo,scythians,skrull,galleon,reinvestment,raglan,reachable,liberec,airframes,electrolysis,geospatial,rubiaceae,interdependence,symmetrically,simulcasts,keenly,mauna,adipose,zaidi,fairport,vestibular,actuators,monochromatic,literatures,congestive,sacramental,atholl,skytrain,tycho,tunings,jamia,catharina,modifier,methuen,tapings,infiltrating,colima,grafting,tauranga,halides,pontificate,phonetics,koper,hafez,grooved,kintetsu,extrajudicial,linkoping,cyberpunk,repetitions,laurentian,parnu,bretton,darko,sverdlovsk,foreshadowed,akhenaten,rehnquist,gosford,coverts,pragmatism,broadleaf,ethiopians,instated,mediates,sodra,opulent,descriptor,enugu,shimla,leesburg,officership,giffard,refectory,lusitania,cybermen,fiume,corus,tydfil,lawrenceville,ocala,leviticus,burghers,ataxia,richthofen,amicably,acoustical,watling,inquired,tiempo,multiracial,parallelism,trenchard,tokyopop,germanium,usisl,philharmonia,shapur,jacobites,latinized,sophocles,remittances,o'farrell,adder,dimitrios,peshwa,dimitar,orlov,outstretched,musume,satish,dimensionless,serialised,baptisms,pagasa,antiviral,1740s,quine,arapaho,bombardments,stratosphere,ophthalmic,injunctions,carbonated,nonviolence,asante,creoles,sybra,boilermakers,abington,bipartite,permissive,cardinality,anheuser,carcinogenic,hohenlohe,surinam,szeged,infanticide,generically,floorball,'white,automakers,cerebellar,homozygous,remoteness,effortlessly,allude,'great,headmasters,minting,manchurian,kinabalu,wemyss,seditious,widgets,marbled,almshouses,bards,subgenres,tetsuya,faulting,kickboxer,gaulish,hoseyn,malton,fluvial,questionnaires,mondale,downplayed,traditionalists,vercelli,sumatran,landfills,gamesradar,exerts,franciszek,unlawfully,huesca,diderot,libertarians,professorial,laane,piecemeal,conidae,taiji,curatorial,perturbations,abstractions,szlachta,watercraft,mullah,zoroastrianism,segmental,khabarovsk,rectors,affordability,scuola,diffused,stena,cyclonic,workpiece,romford,'little,jhansi,stalag,zhongshan,skipton,maracaibo,bernadotte,thanet,groening,waterville,encloses,sahrawi,nuffield,moorings,chantry,annenberg,islay,marchers,tenses,wahid,siegen,furstenberg,basques,resuscitation,seminarians,tympanum,gentiles,vegetarianism,tufted,venkata,fantastical,pterophoridae,machined,superposition,glabrous,kaveri,chicane,executors,phyllonorycter,bidirectional,jasta,undertones,touristic,majapahit,navratilova,unpopularity,barbadian,tinian,webcast,hurdler,rigidly,jarrah,staphylococcus,igniting,irrawaddy,stabilised,airstrike,ragas,wakayama,energetically,ekstraklasa,minibus,largemouth,cultivators,leveraging,waitangi,carnaval,weaves,turntables,heydrich,sextus,excavate,govind,ignaz,pedagogue,uriah,borrowings,gemstones,infractions,mycobacterium,batavian,massing,praetor,subalpine,massoud,passers,geostationary,jalil,trainsets,barbus,impair,budejovice,denbigh,pertain,historicity,fortaleza,nederlandse,lamenting,masterchef,doubs,gemara,conductance,ploiesti,cetaceans,courthouses,bhagavad,mihailovic,occlusion,bremerhaven,bulwark,morava,kaine,drapery,maputo,conquistador,kaduna,famagusta,first-past-the-post,erudite,galton,undated,tangential,filho,dismembered,dashes,criterium,darwen,metabolized,blurring,everard,randwick,mohave,impurity,acuity,ansbach,chievo,surcharge,plantain,algoma,porosity,zirconium,selva,sevenoaks,venizelos,gwynne,golgi,imparting,separatism,courtesan,idiopathic,gravestones,hydroelectricity,babar,orford,purposeful,acutely,shard,ridgewood,viterbo,manohar,expropriation,placenames,brevis,cosine,unranked,richfield,newnham,recoverable,flightless,dispersing,clearfield,abu'l,stranraer,kempe,streamlining,goswami,epidermal,pieta,conciliatory,distilleries,electrophoresis,bonne,tiago,curiosities,candidature,picnicking,perihelion,lintel,povoa,gullies,configure,excision,facies,signers,1730s,insufficiency,semiotics,streatham,deactivation,entomological,skippers,albacete,parodying,escherichia,honorees,singaporeans,counterterrorism,tiruchirappalli,omnivorous,metropole,globalisation,athol,unbounded,codice_5,landforms,classifier,farmhouses,reaffirming,reparation,yomiuri,technologists,mitte,medica,viewable,steampunk,konya,kshatriya,repelling,edgewater,lamiinae,devas,potteries,llandaff,engendered,submits,virulence,uplifted,educationist,metropolitans,frontrunner,dunstable,forecastle,frets,methodius,exmouth,linnean,bouchet,repulsion,computable,equalling,liceo,tephritidae,agave,hydrological,azarenka,fairground,l'homme,enforces,xinhua,cinematographers,cooperstown,sa'id,paiute,christianization,tempos,chippenham,insulator,kotor,stereotyped,dello,cours,hisham,d'souza,eliminations,supercars,passau,rebrand,natures,coote,persephone,rededicated,cleaved,plenum,blistering,indiscriminately,cleese,safed,recursively,compacted,revues,hydration,shillong,echelons,garhwal,pedimented,grower,zwolle,wildflower,annexing,methionine,petah,valens,famitsu,petiole,specialities,nestorian,shahin,tokaido,shearwater,barberini,kinsmen,experimenter,alumnae,cloisters,alumina,pritzker,hardiness,soundgarden,julich,ps300,watercourse,cementing,wordplay,olivet,demesne,chasseurs,amide,zapotec,gaozu,porphyry,absorbers,indium,analogies,devotions,engravers,limestones,catapulted,surry,brickworks,gotra,rodham,landline,paleontologists,shankara,islip,raucous,trollope,arpad,embarkation,morphemes,recites,picardie,nakhchivan,tolerances,formula_47,khorramabad,nichiren,adrianople,kirkuk,assemblages,collider,bikaner,bushfires,roofline,coverings,reredos,bibliotheca,mantras,accentuated,commedia,rashtriya,fluctuation,serhiy,referential,fittipaldi,vesicle,geeta,iraklis,immediacy,chulalongkorn,hunsruck,bingen,dreadnoughts,stonemason,meenakshi,lebesgue,undergrowth,baltistan,paradoxes,parlement,articled,tiflis,dixieland,meriden,tejano,underdogs,barnstable,exemplify,venter,tropes,wielka,kankakee,iskandar,zilina,pharyngeal,spotify,materialised,picts,atlantique,theodoric,prepositions,paramilitaries,pinellas,attlee,actuated,piedmontese,grayling,thucydides,multifaceted,unedited,autonomously,universelle,utricularia,mooted,preto,incubated,underlie,brasenose,nootka,bushland,sensu,benzodiazepine,esteghlal,seagoing,amenhotep,azusa,sappers,culpeper,smokeless,thoroughbreds,dargah,gorda,alumna,mankato,zdroj,deleting,culvert,formula_49,punting,wushu,hindering,immunoglobulin,standardisation,birger,oilfield,quadrangular,ulama,recruiters,netanya,1630s,communaute,istituto,maciej,pathan,meher,vikas,characterizations,playmaker,interagency,intercepts,assembles,horthy,introspection,narada,matra,testes,radnicki,estonians,csiro,instar,mitford,adrenergic,crewmembers,haaretz,wasatch,lisburn,rangefinder,ordre,condensate,reforestation,corregidor,spvgg,modulator,mannerist,faulted,aspires,maktoum,squarepants,aethelred,piezoelectric,mulatto,dacre,progressions,jagiellonian,norge,samaria,sukhoi,effingham,coxless,hermetic,humanists,centrality,litters,stirlingshire,beaconsfield,sundanese,geometrically,caretakers,habitually,bandra,pashtuns,bradenton,arequipa,laminar,brickyard,hitchin,sustains,shipboard,ploughing,trechus,wheelers,bracketed,ilyushin,subotica,d'hondt,reappearance,bridgestone,intermarried,fulfilment,aphasia,birkbeck,transformational,strathmore,hornbill,millstone,lacan,voids,solothurn,gymnasiums,laconia,viaducts,peduncle,teachta,edgware,shinty,supernovae,wilfried,exclaim,parthia,mithun,flashpoint,moksha,cumbia,metternich,avalanches,militancy,motorist,rivadavia,chancellorsville,federals,gendered,bounding,footy,gauri,caliphs,lingam,watchmaker,unrecorded,riverina,unmodified,seafloor,droit,pfalz,chrysostom,gigabit,overlordship,besiege,espn2,oswestry,anachronistic,ballymena,reactivation,duchovny,ghani,abacetus,duller,legio,watercourses,nord-pas-de-calais,leiber,optometry,swarms,installer,sancti,adverbs,iheartmedia,meiningen,zeljko,kakheti,notional,circuses,patrilineal,acrobatics,infrastructural,sheva,oregonian,adjudication,aamir,wloclawek,overfishing,obstructive,subtracting,aurobindo,archeologist,newgate,'cause,secularization,tehsils,abscess,fingal,janacek,elkhorn,trims,kraftwerk,mandating,irregulars,faintly,congregationalist,sveti,kasai,mishaps,kennebec,provincially,durkheim,scotties,aicte,rapperswil,imphal,surrenders,morphs,nineveh,hoxha,cotabato,thuringian,metalworking,retold,shogakukan,anthers,proteasome,tippeligaen,disengagement,mockumentary,palatial,erupts,flume,corrientes,masthead,jaroslaw,rereleased,bharti,labors,distilling,tusks,varzim,refounded,enniskillen,melkite,semifinalists,vadodara,bermudian,capstone,grasse,origination,populus,alesi,arrondissements,semigroup,verein,opossum,messrs.,portadown,bulbul,tirupati,mulhouse,tetrahedron,roethlisberger,nonverbal,connexion,warangal,deprecated,gneiss,octet,vukovar,hesketh,chambre,despatch,claes,kargil,hideo,gravelly,tyndale,aquileia,tuners,defensible,tutte,theotokos,constructivist,ouvrage,dukla,polisario,monasticism,proscribed,commutation,testers,nipissing,codon,mesto,olivine,concomitant,exoskeleton,purports,coromandel,eyalet,dissension,hippocrates,purebred,yaounde,composting,oecophoridae,procopius,o'day,angiogenesis,sheerness,intelligencer,articular,felixstowe,aegon,endocrinology,trabzon,licinius,pagodas,zooplankton,hooghly,satie,drifters,sarthe,mercian,neuilly,tumours,canal+,scheldt,inclinations,counteroffensive,roadrunners,tuzla,shoreditch,surigao,predicates,carnot,algeciras,militaries,generalize,bulkheads,gawler,pollutant,celta,rundgren,microrna,gewog,olimpija,placental,lubelski,roxburgh,discerned,verano,kikuchi,musicale,l'enfant,ferocity,dimorphic,antigonus,erzurum,prebendary,recitative,discworld,cyrenaica,stigmella,totnes,sutta,pachuca,ulsan,downton,landshut,castellan,pleural,siedlce,siecle,catamaran,cottbus,utilises,trophic,freeholders,holyhead,u.s.s,chansons,responder,waziristan,suzuka,birding,shogi,asker,acetone,beautification,cytotoxic,dixit,hunterdon,cobblestone,formula_48,kossuth,devizes,sokoto,interlaced,shuttered,kilowatts,assiniboine,isaak,salto,alderney,sugarloaf,franchising,aggressiveness,toponyms,plaintext,antimatter,henin,equidistant,salivary,bilingualism,mountings,obligate,extirpated,irenaeus,misused,pastoralists,aftab,immigrating,warping,tyrolean,seaforth,teesside,soundwave,oligarchy,stelae,pairwise,iupac,tezuka,posht,orchestrations,landmass,ironstone,gallia,hjalmar,carmelites,strafford,elmhurst,palladio,fragility,teleplay,gruffudd,karoly,yerba,potok,espoo,inductance,macaque,nonprofits,pareto,rock'n'roll,spiritualist,shadowed,skateboarder,utterances,generality,congruence,prostrate,deterred,yellowknife,albarn,maldon,battlements,mohsen,insecticides,khulna,avellino,menstruation,glutathione,springdale,parlophone,confraternity,korps,countrywide,bosphorus,preexisting,damodar,astride,alexandrovich,sprinting,crystallized,botev,leaching,interstates,veers,angevin,undaunted,yevgeni,nishapur,northerners,alkmaar,bethnal,grocers,sepia,tornus,exemplar,trobe,charcot,gyeonggi,larne,tournai,lorain,voided,genji,enactments,maxilla,adiabatic,eifel,nazim,transducer,thelonious,pyrite,deportiva,dialectal,bengt,rosettes,labem,sergeyevich,synoptic,conservator,statuette,biweekly,adhesives,bifurcation,rajapaksa,mammootty,republique,yusef,waseda,marshfield,yekaterinburg,minnelli,fundy,fenian,matchups,dungannon,supremacist,panelled,drenthe,iyengar,fibula,narmada,homeport,oceanside,precept,antibacterial,altarpieces,swath,ospreys,lillooet,legnica,lossless,formula_50,galvatron,iorga,stormont,rsfsr,loggers,kutno,phenomenological,medallists,cuatro,soissons,homeopathy,bituminous,injures,syndicates,typesetting,displacements,dethroned,makassar,lucchese,abergavenny,targu,alborz,akb48,boldface,gastronomy,sacra,amenity,accumulator,myrtaceae,cornices,mourinho,denunciation,oxbow,diddley,aargau,arbitrage,bedchamber,gruffydd,zamindar,klagenfurt,caernarfon,slowdown,stansted,abrasion,tamaki,suetonius,dukakis,individualistic,ventrally,hotham,perestroika,ketones,fertilisation,sobriquet,couplings,renderings,misidentified,rundfunk,sarcastically,braniff,concours,dismissals,elegantly,modifiers,crediting,combos,crucially,seafront,lieut,ischemia,manchus,derivations,proteases,aristophanes,adenauer,porting,hezekiah,sante,trulli,hornblower,foreshadowing,ypsilanti,dharwad,khani,hohenstaufen,distillers,cosmodrome,intracranial,turki,salesian,gorzow,jihlava,yushchenko,leichhardt,venables,cassia,eurogamer,airtel,curative,bestsellers,timeform,sortied,grandview,massillon,ceding,pilbara,chillicothe,heredity,elblag,rogaland,ronne,millennial,batley,overuse,bharata,fille,campbelltown,abeyance,counterclockwise,250cc,neurodegenerative,consigned,electromagnetism,sunnah,saheb,exons,coxswain,gleaned,bassoons,worksop,prismatic,immigrate,pickets,takeo,bobsledder,stosur,fujimori,merchantmen,stiftung,forli,endorses,taskforce,thermally,atman,gurps,floodplains,enthalpy,extrinsic,setubal,kennesaw,grandis,scalability,durations,showrooms,prithvi,outro,overruns,andalucia,amanita,abitur,hipper,mozambican,sustainment,arsene,chesham,palaeolithic,reportage,criminality,knowsley,haploid,atacama,shueisha,ridgefield,astern,getafe,lineal,timorese,restyled,hollies,agincourt,unter,justly,tannins,mataram,industrialised,tarnovo,mumtaz,mustapha,stretton,synthetase,condita,allround,putra,stjepan,troughs,aechmea,specialisation,wearable,kadokawa,uralic,aeros,messiaen,existentialism,jeweller,effigies,gametes,fjordane,cochlear,interdependent,demonstrative,unstructured,emplacement,famines,spindles,amplitudes,actuator,tantalum,psilocybe,apnea,monogatari,expulsions,seleucus,tsuen,hospitaller,kronstadt,eclipsing,olympiakos,clann,canadensis,inverter,helio,egyptologist,squamous,resonate,munir,histology,torbay,khans,jcpenney,veterinarians,aintree,microscopes,colonised,reflectors,phosphorylated,pristimantis,tulare,corvinus,multiplexing,midweek,demosthenes,transjordan,ecija,tengku,vlachs,anamorphic,counterweight,radnor,trinitarian,armidale,maugham,njsiaa,futurism,stairways,avicenna,montebello,bridgetown,wenatchee,lyonnais,amass,surinamese,streptococcus,m*a*s*h,hydrogenation,frazioni,proscenium,kalat,pennsylvanian,huracan,tallying,kralove,nucleolar,phrygian,seaports,hyacinthe,ignace,donning,instalment,regnal,fonds,prawn,carell,folktales,goaltending,bracknell,vmware,patriarchy,mitsui,kragujevac,pythagoras,soult,thapa,disproved,suwalki,secures,somoza,l'ecole,divizia,chroma,herders,technologist,deduces,maasai,rampur,paraphrase,raimi,imaged,magsaysay,ivano,turmeric,formula_51,subcommittees,axillary,ionosphere,organically,indented,refurbishing,pequot,violinists,bearn,colle,contralto,silverton,mechanization,etruscans,wittelsbach,pasir,redshirted,marrakesh,scarp,plein,wafers,qareh,teotihuacan,frobenius,sinensis,rehoboth,bundaberg,newbridge,hydrodynamic,traore,abubakar,adjusts,storytellers,dynamos,verbandsliga,concertmaster,exxonmobil,appreciable,sieradz,marchioness,chaplaincy,rechristened,cunxu,overpopulation,apolitical,sequencer,beaked,nemanja,binaries,intendant,absorber,filamentous,indebtedness,nusra,nashik,reprises,psychedelia,abwehr,ligurian,isoform,resistive,pillaging,mahathir,reformatory,lusatia,allerton,ajaccio,tepals,maturin,njcaa,abyssinian,objector,fissures,sinuous,ecclesiastic,dalits,caching,deckers,phosphates,wurlitzer,navigated,trofeo,berea,purefoods,solway,unlockable,grammys,kostroma,vocalizations,basilan,rebuke,abbasi,douala,helsingborg,ambon,bakar,runestones,cenel,tomislav,pigmented,northgate,excised,seconda,kirke,determinations,dedicates,vilas,pueblos,reversion,unexploded,overprinted,ekiti,deauville,masato,anaesthesia,endoplasmic,transponders,aguascalientes,hindley,celluloid,affording,bayeux,piaget,rickshaws,eishockey,camarines,zamalek,undersides,hardwoods,hermitian,mutinied,monotone,blackmails,affixes,jpmorgan,habermas,mitrovica,paleontological,polystyrene,thana,manas,conformist,turbofan,decomposes,logano,castration,metamorphoses,patroness,herbicide,mikolaj,rapprochement,macroeconomics,barranquilla,matsudaira,lintels,femina,hijab,spotsylvania,morpheme,bitola,baluchistan,kurukshetra,otway,extrusion,waukesha,menswear,helder,trung,bingley,protester,boars,overhang,differentials,exarchate,hejaz,kumara,unjustified,timings,sharpness,nuovo,taisho,sundar,etc..,jehan,unquestionably,muscovy,daltrey,canute,paneled,amedeo,metroplex,elaborates,telus,tetrapods,dragonflies,epithets,saffir,parthenon,lucrezia,refitting,pentateuch,hanshin,montparnasse,lumberjacks,sanhedrin,erectile,odors,greenstone,resurgent,leszek,amory,substituents,prototypical,viewfinder,monck,universiteit,joffre,revives,chatillon,seedling,scherzo,manukau,ashdod,gympie,homolog,stalwarts,ruinous,weibo,tochigi,wallenberg,gayatri,munda,satyagraha,storefronts,heterogeneity,tollway,sportswriters,binocular,gendarmes,ladysmith,tikal,ortsgemeinde,ja'far,osmotic,linlithgow,bramley,telecoms,pugin,repose,rupaul,sieur,meniscus,garmisch,reintroduce,400th,shoten,poniatowski,drome,kazakhstani,changeover,astronautics,husserl,herzl,hypertext,katakana,polybius,antananarivo,seong,breguet,reliquary,utada,aggregating,liangshan,sivan,tonawanda,audiobooks,shankill,coulee,phenolic,brockton,bookmakers,handsets,boaters,wylde,commonality,mappings,silhouettes,pennines,maurya,pratchett,singularities,eschewed,pretensions,vitreous,ibero,totalitarianism,poulenc,lingered,directx,seasoning,deputation,interdict,illyria,feedstock,counterbalance,muzik,buganda,parachuted,violist,homogeneity,comix,fjords,corsairs,punted,verandahs,equilateral,laoghaire,magyars,117th,alesund,televoting,mayotte,eateries,refurbish,nswrl,yukio,caragiale,zetas,dispel,codecs,inoperable,outperformed,rejuvenation,elstree,modernise,contributory,pictou,tewkesbury,chechens,ashina,psionic,refutation,medico,overdubbed,nebulae,sandefjord,personages,eccellenza,businessperson,placename,abenaki,perryville,threshing,reshaped,arecibo,burslem,colspan=3|turnout,rebadged,lumia,erinsborough,interactivity,bitmap,indefatigable,theosophy,excitatory,gleizes,edsel,bermondsey,korce,saarinen,wazir,diyarbakir,cofounder,liberalisation,onsen,nighthawks,siting,retirements,semyon,d'histoire,114th,redditch,venetia,praha,'round,valdosta,hieroglyphic,postmedial,edirne,miscellany,savona,cockpits,minimization,coupler,jacksonian,appeasement,argentines,saurashtra,arkwright,hesiod,folios,fitzalan,publica,rivaled,civitas,beermen,constructivism,ribeira,zeitschrift,solanum,todos,deformities,chilliwack,verdean,meagre,bishoprics,gujrat,yangzhou,reentered,inboard,mythologies,virtus,unsurprisingly,rusticated,museu,symbolise,proportionate,thesaban,symbian,aeneid,mitotic,veliki,compressive,cisterns,abies,winemaker,massenet,bertolt,ahmednagar,triplemania,armorial,administracion,tenures,smokehouse,hashtag,fuerza,regattas,gennady,kanazawa,mahmudabad,crustal,asaph,valentinian,ilaiyaraaja,honeyeater,trapezoidal,cooperatively,unambiguously,mastodon,inhospitable,harnesses,riverton,renewables,djurgardens,haitians,airings,humanoids,boatswain,shijiazhuang,faints,veera,punjabis,steepest,narain,karlovy,serre,sulcus,collectives,1500m,arion,subarctic,liberally,apollonius,ostia,droplet,headstones,norra,robusta,maquis,veronese,imola,primers,luminance,escadrille,mizuki,irreconcilable,stalybridge,temur,paraffin,stuccoed,parthians,counsels,fundamentalists,vivendi,polymath,sugababes,mikko,yonne,fermions,vestfold,pastoralist,kigali,unseeded,glarus,cusps,amasya,northwesterly,minorca,astragalus,verney,trevelyan,antipathy,wollstonecraft,bivalves,boulez,royle,divisao,quranic,bareilly,coronal,deviates,lulea,erectus,petronas,chandan,proxies,aeroflot,postsynaptic,memoriam,moyne,gounod,kuznetsova,pallava,ordinating,reigate,'first,lewisburg,exploitative,danby,academica,bailiwick,brahe,injective,stipulations,aeschylus,computes,gulden,hydroxylase,liveries,somalis,underpinnings,muscovite,kongsberg,domus,overlain,shareware,variegated,jalalabad,agence,ciphertext,insectivores,dengeki,menuhin,cladistic,baerum,betrothal,tokushima,wavelet,expansionist,pottsville,siyuan,prerequisites,carpi,nemzeti,nazar,trialled,eliminator,irrorated,homeward,redwoods,undeterred,strayed,lutyens,multicellular,aurelian,notated,lordships,alsatian,idents,foggia,garros,chalukyas,lillestrom,podlaski,pessimism,hsien,demilitarized,whitewashed,willesden,kirkcaldy,sanctorum,lamia,relaying,escondido,paediatric,contemplates,demarcated,bluestone,betula,penarol,capitalise,kreuznach,kenora,115th,hold'em,reichswehr,vaucluse,m.i.a,windings,boys/girls,cajon,hisar,predictably,flemington,ysgol,mimicked,clivina,grahamstown,ionia,glyndebourne,patrese,aquaria,sleaford,dayal,sportscenter,malappuram,m.b.a.,manoa,carbines,solvable,designator,ramanujan,linearity,academicians,sayid,lancastrian,factorial,strindberg,vashem,delos,comyn,condensing,superdome,merited,kabaddi,intransitive,bideford,neuroimaging,duopoly,scorecards,ziggler,heriot,boyars,virology,marblehead,microtubules,westphalian,anticipates,hingham,searchers,harpist,rapides,morricone,convalescent,mises,nitride,metrorail,matterhorn,bicol,drivetrain,marketer,snippet,winemakers,muban,scavengers,halberstadt,herkimer,peten,laborious,stora,montgomeryshire,booklist,shamir,herault,eurostar,anhydrous,spacewalk,ecclesia,calliostoma,highschool,d'oro,suffusion,imparts,overlords,tagus,rectifier,counterinsurgency,ministered,eilean,milecastle,contre,micromollusk,okhotsk,bartoli,matroid,hasidim,thirunal,terme,tarlac,lashkar,presque,thameslink,flyby,troopship,renouncing,fatih,messrs,vexillum,bagration,magnetite,bornholm,androgynous,vehement,tourette,philosophic,gianfranco,tuileries,codice_6,radially,flexion,hants,reprocessing,setae,burne,palaeographically,infantryman,shorebirds,tamarind,moderna,threading,militaristic,crohn,norrkoping,125cc,stadtholder,troms,klezmer,alphanumeric,brome,emmanuelle,tiwari,alchemical,formula_52,onassis,bleriot,bipedal,colourless,hermeneutics,hosni,precipitating,turnstiles,hallucinogenic,panhellenic,wyandotte,elucidated,chita,ehime,generalised,hydrophilic,biota,niobium,rnzaf,gandhara,longueuil,logics,sheeting,bielsko,cuvier,kagyu,trefoil,docent,pancrase,stalinism,postures,encephalopathy,monckton,imbalances,epochs,leaguers,anzio,diminishes,pataki,nitrite,amuro,nabil,maybach,l'aquila,babbler,bacolod,thutmose,evora,gaudi,breakage,recur,preservative,60deg,mendip,functionaries,columnar,maccabiah,chert,verden,bromsgrove,clijsters,dengue,pastorate,phuoc,principia,viareggio,kharagpur,scharnhorst,anyang,bosons,l'art,criticises,ennio,semarang,brownian,mirabilis,asperger,calibers,typographical,cartooning,minos,disembark,supranational,undescribed,etymologically,alappuzha,vilhelm,lanao,pakenham,bhagavata,rakoczi,clearings,astrologers,manitowoc,bunuel,acetylene,scheduler,defamatory,trabzonspor,leaded,scioto,pentathlete,abrahamic,minigames,aldehydes,peerages,legionary,1640s,masterworks,loudness,bryansk,likeable,genocidal,vegetated,towpath,declination,pyrrhus,divinely,vocations,rosebery,associazione,loaders,biswas,oeste,tilings,xianzong,bhojpuri,annuities,relatedness,idolator,psers,constriction,chuvash,choristers,hanafi,fielders,grammarian,orpheum,asylums,millbrook,gyatso,geldof,stabilise,tableaux,diarist,kalahari,panini,cowdenbeath,melanin,4x100m,resonances,pinar,atherosclerosis,sheringham,castlereagh,aoyama,larks,pantograph,protrude,natak,gustafsson,moribund,cerevisiae,cleanly,polymeric,holkar,cosmonauts,underpinning,lithosphere,firuzabad,languished,mingled,citrate,spadina,lavas,daejeon,fibrillation,porgy,pineville,ps1000,cobbled,emamzadeh,mukhtar,dampers,indelible,salonika,nanoscale,treblinka,eilat,purporting,fluctuate,mesic,hagiography,cutscenes,fondation,barrens,comically,accrue,ibrox,makerere,defections,'there,hollandia,skene,grosseto,reddit,objectors,inoculation,rowdies,playfair,calligrapher,namor,sibenik,abbottabad,propellants,hydraulically,chloroplasts,tablelands,tecnico,schist,klasse,shirvan,bashkortostan,bullfighting,north/south,polski,hanns,woodblock,kilmore,ejecta,ignacy,nanchang,danubian,commendations,snohomish,samaritans,argumentation,vasconcelos,hedgehogs,vajrayana,barents,kulkarni,kumbakonam,identifications,hillingdon,weirs,nayanar,beauvoir,messe,divisors,atlantiques,broods,affluence,tegucigalpa,unsuited,autodesk,akash,princeps,culprits,kingstown,unassuming,goole,visayan,asceticism,blagojevich,irises,paphos,unsound,maurier,pontchartrain,desertification,sinfonietta,latins,especial,limpet,valerenga,glial,brainstem,mitral,parables,sauropod,judean,iskcon,sarcoma,venlo,justifications,zhuhai,blavatsky,alleviated,usafe,steppenwolf,inversions,janko,chagall,secretory,basildon,saguenay,pergamon,hemispherical,harmonized,reloading,franjo,domaine,extravagance,relativism,metamorphosed,labuan,baloncesto,gmail,byproducts,calvinists,counterattacked,vitus,bubonic,120th,strachey,ritually,brookwood,selectable,savinja,incontinence,meltwater,jinja,1720s,brahmi,morgenthau,sheaves,sleeved,stratovolcano,wielki,utilisation,avoca,fluxus,panzergrenadier,philately,deflation,podlaska,prerogatives,kuroda,theophile,zhongzong,gascoyne,magus,takao,arundell,fylde,merdeka,prithviraj,venkateswara,liepaja,daigo,dreamland,reflux,sunnyvale,coalfields,seacrest,soldering,flexor,structuralism,alnwick,outweighed,unaired,mangeshkar,batons,glaad,banshees,irradiated,organelles,biathlete,cabling,chairlift,lollapalooza,newsnight,capacitive,succumbs,flatly,miramichi,burwood,comedienne,charteris,biotic,workspace,aficionados,sokolka,chatelet,o'shaughnessy,prosthesis,neoliberal,refloated,oppland,hatchlings,econometrics,loess,thieu,androids,appalachians,jenin,pterostichinae,downsized,foils,chipsets,stencil,danza,narrate,maginot,yemenite,bisects,crustacean,prescriptive,melodious,alleviation,empowers,hansson,autodromo,obasanjo,osmosis,daugava,rheumatism,moraes,leucine,etymologies,chepstow,delaunay,bramall,bajaj,flavoring,approximates,marsupials,incisive,microcomputer,tactically,waals,wilno,fisichella,ursus,hindmarsh,mazarin,lomza,xenophobia,lawlessness,annecy,wingers,gornja,gnaeus,superieur,tlaxcala,clasps,symbolises,slats,rightist,effector,blighted,permanence,divan,progenitors,kunsthalle,anointing,excelling,coenzyme,indoctrination,dnipro,landholdings,adriaan,liturgies,cartan,ethmia,attributions,sanctus,trichy,chronicon,tancred,affinis,kampuchea,gantry,pontypool,membered,distrusted,fissile,dairies,hyposmocoma,craigie,adarsh,martinsburg,taxiway,30deg,geraint,vellum,bencher,khatami,formula_53,zemun,teruel,endeavored,palmares,pavements,u.s..,internationalization,satirized,carers,attainable,wraparound,muang,parkersburg,extinctions,birkenfeld,wildstorm,payers,cohabitation,unitas,culloden,capitalizing,clwyd,daoist,campinas,emmylou,orchidaceae,halakha,orientales,fealty,domnall,chiefdom,nigerians,ladislav,dniester,avowed,ergonomics,newsmagazine,kitsch,cantilevered,benchmarking,remarriage,alekhine,coldfield,taupo,almirante,substations,apprenticeships,seljuq,levelling,eponym,symbolising,salyut,opioids,underscore,ethnologue,mohegan,marikina,libro,bassano,parse,semantically,disjointed,dugdale,padraig,tulsi,modulating,xfinity,headlands,mstislav,earthworms,bourchier,lgbtq,embellishments,pennants,rowntree,betel,motet,mulla,catenary,washoe,mordaunt,dorking,colmar,girardeau,glentoran,grammatically,samad,recreations,technion,staccato,mikoyan,spoilers,lyndhurst,victimization,chertsey,belafonte,tondo,tonsberg,narrators,subcultures,malformations,edina,augmenting,attests,euphemia,cabriolet,disguising,1650s,navarrese,demoralized,cardiomyopathy,welwyn,wallachian,smoothness,planktonic,voles,issuers,sardasht,survivability,cuauhtemoc,thetis,extruded,signet,raghavan,lombok,eliyahu,crankcase,dissonant,stolberg,trencin,desktops,bursary,collectivization,charlottenburg,triathlete,curvilinear,involuntarily,mired,wausau,invades,sundaram,deletions,bootstrap,abellio,axiomatic,noguchi,setups,malawian,visalia,materialist,kartuzy,wenzong,plotline,yeshivas,parganas,tunica,citric,conspecific,idlib,superlative,reoccupied,blagoevgrad,masterton,immunological,hatta,courbet,vortices,swallowtail,delves,haridwar,diptera,boneh,bahawalpur,angering,mardin,equipments,deployable,guanine,normality,rimmed,artisanal,boxset,chandrasekhar,jools,chenar,tanakh,carcassonne,belatedly,millville,anorthosis,reintegration,velde,surfactant,kanaan,busoni,glyphipterix,personas,fullness,rheims,tisza,stabilizers,bharathi,joost,spinola,mouldings,perching,esztergom,afzal,apostate,lustre,s.league,motorboat,monotheistic,armature,barat,asistencia,bloomsburg,hippocampal,fictionalised,defaults,broch,hexadecimal,lusignan,ryanair,boccaccio,breisgau,southbank,bskyb,adjoined,neurobiology,aforesaid,sadhu,langue,headship,wozniacki,hangings,regulus,prioritized,dynamism,allier,hannity,shimin,antoninus,gymnopilus,caledon,preponderance,melayu,electrodynamics,syncopated,ibises,krosno,mechanistic,morpeth,harbored,albini,monotheism,'real,hyperactivity,haveli,writer/director,minato,nimoy,caerphilly,chitral,amirabad,fanshawe,l'oreal,lorde,mukti,authoritarianism,valuing,spyware,hanbury,restarting,stato,embed,suiza,empiricism,stabilisation,stari,castlemaine,orbis,manufactory,mauritanian,shoji,taoyuan,prokaryotes,oromia,ambiguities,embodying,slims,frente,innovate,ojibwa,powdery,gaeltacht,argentinos,quatermass,detergents,fijians,adaptor,tokai,chileans,bulgars,oxidoreductases,bezirksliga,conceicao,myosin,nellore,500cc,supercomputers,approximating,glyndwr,polypropylene,haugesund,cockerell,tudman,ashbourne,hindemith,bloodlines,rigveda,etruria,romanos,steyn,oradea,deceleration,manhunter,laryngeal,fraudulently,janez,wendover,haplotype,janaki,naoki,belizean,mellencamp,cartographic,sadhana,tricolour,pseudoscience,satara,bytow,s.p.a.,jagdgeschwader,arcot,omagh,sverdrup,masterplan,surtees,apocrypha,ahvaz,d'amato,socratic,leumit,unnumbered,nandini,witold,marsupial,coalesced,interpolated,gimnasia,karadzic,keratin,mamoru,aldeburgh,speculator,escapement,irfan,kashyap,satyajit,haddington,solver,rothko,ashkelon,kickapoo,yeomen,superbly,bloodiest,greenlandic,lithic,autofocus,yardbirds,poona,keble,javan,sufis,expandable,tumblr,ursuline,swimwear,winwood,counsellors,aberrations,marginalised,befriending,workouts,predestination,varietal,siddhartha,dunkeld,judaic,esquimalt,shabab,ajith,telefonica,stargard,hoysala,radhakrishnan,sinusoidal,strada,hiragana,cebuano,monoid,independencia,floodwaters,mildura,mudflats,ottokar,translit,radix,wigner,philosophically,tephritid,synthesizing,castletown,installs,stirner,resettle,bushfire,choirmaster,kabbalistic,shirazi,lightship,rebus,colonizers,centrifuge,leonean,kristofferson,thymus,clackamas,ratnam,rothesay,municipally,centralia,thurrock,gulfport,bilinear,desirability,merite,psoriasis,macaw,erigeron,consignment,mudstone,distorting,karlheinz,ramen,tailwheel,vitor,reinsurance,edifices,superannuation,dormancy,contagion,cobden,rendezvoused,prokaryotic,deliberative,patricians,feigned,degrades,starlings,sopot,viticultural,beaverton,overflowed,convener,garlands,michiel,ternopil,naturelle,biplanes,bagot,gamespy,ventspils,disembodied,flattening,profesional,londoners,arusha,scapular,forestall,pyridine,ulema,eurodance,aruna,callus,periodontal,coetzee,immobilized,o'meara,maharani,katipunan,reactants,zainab,microgravity,saintes,britpop,carrefour,constrain,adversarial,firebirds,brahmo,kashima,simca,surety,surpluses,superconductivity,gipuzkoa,cumans,tocantins,obtainable,humberside,roosting,'king,formula_54,minelayer,bessel,sulayman,cycled,biomarkers,annealing,shusha,barda,cassation,djing,polemics,tuple,directorates,indomitable,obsolescence,wilhelmine,pembina,bojan,tambo,dioecious,pensioner,magnificat,1660s,estrellas,southeasterly,immunodeficiency,railhead,surreptitiously,codeine,encores,religiosity,tempera,camberley,efendi,boardings,malleable,hagia,input/output,lucasfilm,ujjain,polymorphisms,creationist,berners,mickiewicz,irvington,linkedin,endures,kinect,munition,apologetics,fairlie,predicated,reprinting,ethnographer,variances,levantine,mariinsky,jadid,jarrow,asia/oceania,trinamool,waveforms,bisexuality,preselection,pupae,buckethead,hieroglyph,lyricists,marionette,dunbartonshire,restorer,monarchical,pazar,kickoffs,cabildo,savannas,gliese,dench,spoonbills,novelette,diliman,hypersensitivity,authorising,montefiore,mladen,qu'appelle,theistic,maruti,laterite,conestoga,saare,californica,proboscis,carrickfergus,imprecise,hadassah,baghdadi,jolgeh,deshmukh,amusements,heliopolis,berle,adaptability,partenkirchen,separations,baikonur,cardamom,southeastward,southfield,muzaffar,adequacy,metropolitana,rajkot,kiyoshi,metrobus,evictions,reconciles,librarianship,upsurge,knightley,badakhshan,proliferated,spirituals,burghley,electroacoustic,professing,featurette,reformists,skylab,descriptors,oddity,greyfriars,injects,salmond,lanzhou,dauntless,subgenera,underpowered,transpose,mahinda,gatos,aerobatics,seaworld,blocs,waratahs,joris,giggs,perfusion,koszalin,mieczyslaw,ayyubid,ecologists,modernists,sant'angelo,quicktime,him/her,staves,sanyo,melaka,acrocercops,qigong,iterated,generalizes,recuperation,vihara,circassians,psychical,chavo,memoires,infiltrates,notaries,pelecaniformesfamily,strident,chivalric,pierrepont,alleviating,broadsides,centipede,b.tech,reinterpreted,sudetenland,hussite,covenanters,radhika,ironclads,gainsbourg,testis,penarth,plantar,azadegan,beano,espn.com,leominster,autobiographies,nbcuniversal,eliade,khamenei,montferrat,undistinguished,ethnological,wenlock,fricatives,polymorphic,biome,joule,sheaths,astrophysicist,salve,neoclassicism,lovat,downwind,belisarius,forma,usurpation,freie,depopulation,backbench,ascenso,'high,aagpbl,gdanski,zalman,mouvement,encapsulation,bolshevism,statny,voyageurs,hywel,vizcaya,mazra'eh,narthex,azerbaijanis,cerebrospinal,mauretania,fantail,clearinghouse,bolingbroke,pequeno,ansett,remixing,microtubule,wrens,jawahar,palembang,gambian,hillsong,fingerboard,repurposed,sundry,incipient,veolia,theologically,ulaanbaatar,atsushi,foundling,resistivity,myeloma,factbook,mazowiecka,diacritic,urumqi,clontarf,provokes,intelsat,professes,materialise,portobello,benedictines,panionios,introverted,reacquired,bridport,mammary,kripke,oratorios,vlore,stoning,woredas,unreported,antti,togolese,fanzines,heuristics,conservatories,carburetors,clitheroe,cofounded,formula_57,erupting,quinnipiac,bootle,ghostface,sittings,aspinall,sealift,transferase,boldklub,siskiyou,predominated,francophonie,ferruginous,castrum,neogene,sakya,madama,precipitous,'love,posix,bithynia,uttara,avestan,thrushes,seiji,memorably,septimius,libri,cibernetico,hyperinflation,dissuaded,cuddalore,peculiarity,vaslui,grojec,albumin,thurles,casks,fasteners,fluidity,buble,casals,terek,gnosticism,cognates,ulnar,radwanska,babylonians,majuro,oxidizer,excavators,rhythmically,liffey,gorakhpur,eurydice,underscored,arborea,lumumba,tuber,catholique,grama,galilei,scrope,centreville,jacobin,bequests,ardeche,polygamous,montauban,terai,weatherboard,readability,attainder,acraea,transversely,rivets,winterbottom,reassures,bacteriology,vriesea,chera,andesite,dedications,homogenous,reconquered,bandon,forrestal,ukiyo,gurdjieff,tethys,sparc,muscogee,grebes,belchatow,mansa,blantyre,palliser,sokolow,fibroblasts,exmoor,misaki,soundscapes,housatonic,middelburg,convenor,leyla,antipope,histidine,okeechobee,alkenes,sombre,alkene,rubik,macaques,calabar,trophee,pinchot,'free,frusciante,chemins,falaise,vasteras,gripped,schwarzenberg,cumann,kanchipuram,acoustically,silverbacks,fangio,inset,plympton,kuril,vaccinations,recep,theropods,axils,stavropol,encroached,apoptotic,papandreou,wailers,moonstone,assizes,micrometers,hornchurch,truncation,annapurna,egyptologists,rheumatic,promiscuity,satiric,fleche,caloptilia,anisotropy,quaternions,gruppo,viscounts,awardees,aftershocks,sigint,concordance,oblasts,gaumont,stent,commissars,kesteven,hydroxy,vijayanagar,belorussian,fabricius,watermark,tearfully,mamet,leukaemia,sorkh,milepost,tattooing,vosta,abbasids,uncompleted,hedong,woodwinds,extinguishing,malus,multiplexes,francoist,pathet,responsa,bassists,'most,postsecondary,ossory,grampian,saakashvili,alito,strasberg,impressionistic,volador,gelatinous,vignette,underwing,campanian,abbasabad,albertville,hopefuls,nieuwe,taxiways,reconvened,recumbent,pathologists,unionized,faversham,asymptotically,romulo,culling,donja,constricted,annesley,duomo,enschede,lovech,sharpshooter,lansky,dhamma,papillae,alanine,mowat,delius,wrest,mcluhan,podkarpackie,imitators,bilaspur,stunting,pommel,casemate,handicaps,nagas,testaments,hemings,necessitate,rearward,locative,cilla,klitschko,lindau,merion,consequential,antic,soong,copula,berthing,chevrons,rostral,sympathizer,budokan,ranulf,beria,stilt,replying,conflated,alcibiades,painstaking,yamanashi,calif.,arvid,ctesiphon,xizong,rajas,caxton,downbeat,resurfacing,rudders,miscegenation,deathmatch,foregoing,arthropod,attestation,karts,reapportionment,harnessing,eastlake,schola,dosing,postcolonial,imtiaz,formula_55,insulators,gunung,accumulations,pampas,llewelyn,bahnhof,cytosol,grosjean,teaneck,briarcliff,arsenio,canara,elaborating,passchendaele,searchlights,holywell,mohandas,preventable,gehry,mestizos,ustinov,cliched,'national,heidfeld,tertullian,jihadist,tourer,miletus,semicircle,outclassed,bouillon,cardinalate,clarifies,dakshina,bilayer,pandyan,unrwa,chandragupta,formula_56,portola,sukumaran,lactation,islamia,heikki,couplers,misappropriation,catshark,montt,ploughs,carib,stator,leaderboard,kenrick,dendrites,scape,tillamook,molesworth,mussorgsky,melanesia,restated,troon,glycoside,truckee,headwater,mashup,sectoral,gangwon,docudrama,skirting,psychopathology,dramatised,ostroleka,infestations,thabo,depolarization,wideroe,eisenbahn,thomond,kumaon,upendra,foreland,acronyms,yaqui,retaking,raphaelite,specie,dupage,villars,lucasarts,chloroplast,werribee,balsa,ascribe,havant,flava,khawaja,tyumen,subtract,interrogators,reshaping,buzzcocks,eesti,campanile,potemkin,apertures,snowboarder,registrars,handbooks,boyar,contaminant,depositors,proximate,jeunesse,zagora,pronouncements,mists,nihilism,deified,margraviate,pietersen,moderators,amalfi,adjectival,copepods,magnetosphere,pallets,clemenceau,castra,perforation,granitic,troilus,grzegorz,luthier,dockyards,antofagasta,ffestiniog,subroutine,afterword,waterwheel,druce,nitin,undifferentiated,emacs,readmitted,barneveld,tapers,hittites,infomercials,infirm,braathens,heligoland,carpark,geomagnetic,musculoskeletal,nigerien,machinima,harmonize,repealing,indecency,muskoka,verite,steubenville,suffixed,cytoskeleton,surpasses,harmonia,imereti,ventricles,heterozygous,envisions,otsego,ecoles,warrnambool,burgenland,seria,rawat,capistrano,welby,kirin,enrollments,caricom,dragonlance,schaffhausen,expanses,photojournalism,brienne,etude,referent,jamtland,schemas,xianbei,cleburne,bicester,maritima,shorelines,diagonals,bjelke,nonpublic,aliasing,m.f.a,ovals,maitreya,skirmishing,grothendieck,sukhothai,angiotensin,bridlington,durgapur,contras,gakuen,skagit,rabbinate,tsunamis,haphazard,tyldesley,microcontroller,discourages,hialeah,compressing,septimus,larvik,condoleezza,psilocybin,protectionism,songbirds,clandestinely,selectmen,wargame,cinemascope,khazars,agronomy,melzer,latifah,cherokees,recesses,assemblymen,basescu,banaras,bioavailability,subchannels,adenine,o'kelly,prabhakar,leonese,dimethyl,testimonials,geoffroy,oxidant,universiti,gheorghiu,bohdan,reversals,zamorin,herbivore,jarre,sebastiao,infanterie,dolmen,teddington,radomsko,spaceships,cuzco,recapitulation,mahoning,bainimarama,myelin,aykroyd,decals,tokelau,nalgonda,rajasthani,121st,quelled,tambov,illyrians,homilies,illuminations,hypertrophy,grodzisk,inundation,incapacity,equilibria,combats,elihu,steinitz,berengar,gowda,canwest,khosrau,maculata,houten,kandinsky,onside,leatherhead,heritable,belvidere,federative,chukchi,serling,eruptive,patan,entitlements,suffragette,evolutions,migrates,demobilisation,athleticism,trope,sarpsborg,kensal,translink,squamish,concertgebouw,energon,timestamp,competences,zalgiris,serviceman,codice_7,spoofing,assange,mahadevan,skien,suceava,augustan,revisionism,unconvincing,hollande,drina,gottlob,lippi,broglie,darkening,tilapia,eagerness,nacht,kolmogorov,photometric,leeuwarden,jrotc,haemorrhage,almanack,cavalli,repudiation,galactose,zwickau,cetinje,houbraken,heavyweights,gabonese,ordinals,noticias,museveni,steric,charaxes,amjad,resection,joinville,leczyca,anastasius,purbeck,subtribe,dalles,leadoff,monoamine,jettisoned,kaori,anthologized,alfreton,indic,bayezid,tottori,colonizing,assassinating,unchanging,eusebian,d'estaing,tsingtao,toshio,transferases,peronist,metrology,equus,mirpur,libertarianism,kovil,indole,'green,abstention,quantitatively,icebreakers,tribals,mainstays,dryandra,eyewear,nilgiri,chrysanthemum,inositol,frenetic,merchantman,hesar,physiotherapist,transceiver,dancefloor,rankine,neisse,marginalization,lengthen,unaided,rework,pageantry,savio,striated,funen,witton,illuminates,frass,hydrolases,akali,bistrita,copywriter,firings,handballer,tachinidae,dmytro,coalesce,neretva,menem,moraines,coatbridge,crossrail,spoofed,drosera,ripen,protour,kikuyu,boleslav,edwardes,troubadours,haplogroups,wrasse,educationalist,sroda,khaneh,dagbladet,apennines,neuroscientist,deplored,terje,maccabees,daventry,spaceport,lessening,ducats,singer/guitarist,chambersburg,yeong,configurable,ceremonially,unrelenting,caffe,graaf,denizens,kingsport,ingush,panhard,synthesised,tumulus,homeschooled,bozorg,idiomatic,thanhouser,queensway,radek,hippolytus,inking,banovina,peacocks,piaui,handsworth,pantomimes,abalone,thera,kurzweil,bandura,augustinians,bocelli,ferrol,jiroft,quadrature,contravention,saussure,rectification,agrippina,angelis,matanzas,nidaros,palestrina,latium,coriolis,clostridium,ordain,uttering,lanchester,proteolytic,ayacucho,merseburg,holbein,sambalpur,algebraically,inchon,ostfold,savoia,calatrava,lahiri,judgeship,ammonite,masaryk,meyerbeer,hemorrhagic,superspeedway,ningxia,panicles,encircles,khmelnytsky,profusion,esher,babol,inflationary,anhydride,gaspe,mossy,periodicity,nacion,meteorologists,mahjong,interventional,sarin,moult,enderby,modell,palgrave,warners,montcalm,siddha,functionalism,rilke,politicized,broadmoor,kunste,orden,brasileira,araneta,eroticism,colquhoun,mamba,blacktown,tubercle,seagrass,manoel,camphor,neoregelia,llandudno,annexe,enplanements,kamien,plovers,statisticians,iturbide,madrasah,nontrivial,publican,landholders,manama,uninhabitable,revivalist,trunkline,friendliness,gurudwara,rocketry,unido,tripos,besant,braque,evolutionarily,abkhazian,staffel,ratzinger,brockville,bohemond,intercut,djurgarden,utilitarianism,deploys,sastri,absolutism,subhas,asghar,fictions,sepinwall,proportionately,titleholders,thereon,foursquare,machinegun,knightsbridge,siauliai,aqaba,gearboxes,castaways,weakens,phallic,strzelce,buoyed,ruthenia,pharynx,intractable,neptunes,koine,leakey,netherlandish,preempted,vinay,terracing,instigating,alluvium,prosthetics,vorarlberg,politiques,joinery,reduplication,nebuchadnezzar,lenticular,banka,seaborne,pattinson,helpline,aleph,beckenham,californians,namgyal,franziska,aphid,branagh,transcribe,appropriateness,surakarta,takings,propagates,juraj,b0d3fb,brera,arrayed,tailback,falsehood,hazleton,prosody,egyptology,pinnate,tableware,ratan,camperdown,ethnologist,tabari,classifiers,biogas,126th,kabila,arbitron,apuestas,membranous,kincardine,oceana,glories,natick,populism,synonymy,ghalib,mobiles,motherboards,stationers,germinal,patronised,formula_58,gaborone,torts,jeezy,interleague,novaya,batticaloa,offshoots,wilbraham,filename,nswrfl,'well,trilobite,pythons,optimally,scientologists,rhesus,pilsen,backdrops,batang,unionville,hermanos,shrikes,fareham,outlawing,discontinuing,boisterous,shamokin,scanty,southwestward,exchangers,unexpired,mewar,h.m.s,saldanha,pawan,condorcet,turbidity,donau,indulgences,coincident,cliques,weeklies,bardhaman,violators,kenai,caspase,xperia,kunal,fistula,epistemic,cammell,nephi,disestablishment,rotator,germaniawerft,pyaar,chequered,jigme,perlis,anisotropic,popstars,kapil,appendices,berat,defecting,shacks,wrangel,panchayath,gorna,suckling,aerosols,sponheim,talal,borehole,encodings,enlai,subduing,agong,nadar,kitsap,syrmia,majumdar,pichilemu,charleville,embryology,booting,literati,abutting,basalts,jussi,repubblica,hertogenbosch,digitization,relents,hillfort,wiesenthal,kirche,bhagwan,bactrian,oases,phyla,neutralizing,helsing,ebooks,spearheading,margarine,'golden,phosphor,picea,stimulants,outliers,timescale,gynaecology,integrator,skyrocketed,bridgnorth,senecio,ramachandra,suffragist,arrowheads,aswan,inadvertent,microelectronics,118th,sofer,kubica,melanesian,tuanku,balkh,vyborg,crystallographic,initiators,metamorphism,ginzburg,looters,unimproved,finistere,newburyport,norges,immunities,franchisees,asterism,kortrijk,camorra,komsomol,fleurs,draughts,patagonian,voracious,artin,collaborationist,revolucion,revitalizing,xaver,purifying,antipsychotic,disjunct,pompeius,dreamwave,juvenal,beinn,adiyaman,antitank,allama,boletus,melanogaster,dumitru,caproni,aligns,athabaskan,stobart,phallus,veikkausliiga,hornsey,buffering,bourbons,dobruja,marga,borax,electrics,gangnam,motorcyclist,whidbey,draconian,lodger,galilean,sanctification,imitates,boldness,underboss,wheatland,cantabrian,terceira,maumee,redefining,uppercase,ostroda,characterise,universalism,equalized,syndicalism,haringey,masovia,deleuze,funkadelic,conceals,thuan,minsky,pluralistic,ludendorff,beekeeping,bonfires,endoscopic,abuts,prebend,jonkoping,amami,tribunes,yup'ik,awadh,gasification,pforzheim,reforma,antiwar,vaishnavism,maryville,inextricably,margrethe,empresa,neutrophils,sanctified,ponca,elachistidae,curiae,quartier,mannar,hyperplasia,wimax,busing,neologism,florins,underrepresented,digitised,nieuw,cooch,howards,frege,hughie,plied,swale,kapellmeister,vajpayee,quadrupled,aeronautique,dushanbe,custos,saltillo,kisan,tigray,manaus,epigrams,shamanic,peppered,frosts,promotion/relegation,concedes,zwingli,charentes,whangarei,hyung,spring/summer,sobre,eretz,initialization,sawai,ephemera,grandfathered,arnaldo,customised,permeated,parapets,growths,visegrad,estudios,altamont,provincia,apologises,stoppard,carburettor,rifts,kinematic,zhengzhou,eschatology,prakrit,folate,yvelines,scapula,stupas,rishon,reconfiguration,flutist,1680s,apostolate,proudhon,lakshman,articulating,stortford,faithfull,bitterns,upwelling,qur'anic,lidar,interferometry,waterlogged,koirala,ditton,wavefunction,fazal,babbage,antioxidants,lemberg,deadlocked,tolled,ramapo,mathematica,leiria,topologies,khali,photonic,balti,1080p,corrects,recommenced,polyglot,friezes,tiebreak,copacabana,cholmondeley,armband,abolishment,sheamus,buttes,glycolysis,cataloged,warrenton,sassari,kishan,foodservice,cryptanalysis,holmenkollen,cosplay,machi,yousuf,mangal,allying,fertiliser,otomi,charlevoix,metallurg,parisians,bottlenose,oakleigh,debug,cidade,accede,ligation,madhava,pillboxes,gatefold,aveyron,sorin,thirsk,immemorial,menelik,mehra,domingos,underpinned,fleshed,harshness,diphthong,crestwood,miskolc,dupri,pyrausta,muskingum,tuoba,prodi,incidences,waynesboro,marquesas,heydar,artesian,calinescu,nucleation,funders,covalently,compaction,derbies,seaters,sodor,tabular,amadou,peckinpah,o'halloran,zechariah,libyans,kartik,daihatsu,chandran,erzhu,heresies,superheated,yarder,dorde,tanjore,abusers,xuanwu,juniperus,moesia,trusteeship,birdwatching,beatz,moorcock,harbhajan,sanga,choreographic,photonics,boylston,amalgamate,prawns,electrifying,sarath,inaccurately,exclaims,powerpoint,chaining,cpusa,adulterous,saccharomyces,glogow,vfl/afl,syncretic,simla,persisting,functors,allosteric,euphorbiaceae,juryo,mlada,moana,gabala,thornycroft,kumanovo,ostrovsky,sitio,tutankhamun,sauropods,kardzhali,reinterpretation,sulpice,rosyth,originators,halesowen,delineation,asesoria,abatement,gardai,elytra,taillights,overlays,monsoons,sandpipers,ingmar,henrico,inaccuracy,irwell,arenabowl,elche,pressburg,signalman,interviewees,sinkhole,pendle,ecommerce,cellos,nebria,organometallic,surrealistic,propagandist,interlaken,canandaigua,aerials,coutinho,pascagoula,tonopah,letterkenny,gropius,carbons,hammocks,childe,polities,hosiery,donitz,suppresses,diaghilev,stroudsburg,bagram,pistoia,regenerating,unitarians,takeaway,offstage,vidin,glorification,bakunin,yavapai,lutzow,sabercats,witney,abrogated,gorlitz,validating,dodecahedron,stubbornly,telenor,glaxosmithkline,solapur,undesired,jellicoe,dramatization,four-and-a-half,seawall,waterpark,artaxerxes,vocalization,typographic,byung,sachsenhausen,shepparton,kissimmee,konnan,belsen,dhawan,khurd,mutagenesis,vejle,perrot,estradiol,formula_60,saros,chiloe,misiones,lamprey,terrains,speke,miasto,eigenvectors,haydock,reservist,corticosteroids,savitri,shinawatra,developmentally,yehudi,berates,janissaries,recapturing,rancheria,subplots,gresley,nikkatsu,oryol,cosmas,boavista,formula_59,playfully,subsections,commentated,kathakali,dorid,vilaine,seepage,hylidae,keiji,kazakhs,triphosphate,1620s,supersede,monarchists,falla,miyako,notching,bhumibol,polarizing,secularized,shingled,bronislaw,lockerbie,soleyman,bundesbahn,latakia,redoubts,boult,inwardly,invents,ondrej,minangkabau,newquay,permanente,alhaji,madhav,malini,ellice,bookmaker,mankiewicz,etihad,o'dea,interrogative,mikawa,wallsend,canisius,bluesy,vitruvius,noord,ratifying,mixtec,gujranwala,subprefecture,keelung,goiania,nyssa,shi'ite,semitone,ch'uan,computerised,pertuan,catapults,nepomuk,shruti,millstones,buskerud,acolytes,tredegar,sarum,armia,dell'arte,devises,custodians,upturned,gallaudet,disembarking,thrashed,sagrada,myeon,undeclared,qumran,gaiden,tepco,janesville,showground,condense,chalon,unstaffed,pasay,undemocratic,hauts,viridis,uninjured,escutcheon,gymkhana,petaling,hammam,dislocations,tallaght,rerum,shias,indios,guaranty,simplicial,benares,benediction,tajiri,prolifically,huawei,onerous,grantee,ferencvaros,otranto,carbonates,conceit,digipak,qadri,masterclasses,swamiji,cradock,plunket,helmsman,119th,salutes,tippecanoe,murshidabad,intelligibility,mittal,diversifying,bidar,asansol,crowdsourcing,rovere,karakoram,grindcore,skylights,tulagi,furrows,ligne,stuka,sumer,subgraph,amata,regionalist,bulkeley,teletext,glorify,readied,lexicographer,sabadell,predictability,quilmes,phenylalanine,bandaranaike,pyrmont,marksmen,quisling,viscountess,sociopolitical,afoul,pediments,swazi,martyrology,nullify,panagiotis,superconductors,veldenz,jujuy,l'isle,hematopoietic,shafi,subsea,hattiesburg,jyvaskyla,kebir,myeloid,landmine,derecho,amerindians,birkenau,scriabin,milhaud,mucosal,nikaya,freikorps,theoretician,proconsul,o'hanlon,clerked,bactria,houma,macular,topologically,shrubby,aryeh,ghazali,afferent,magalhaes,moduli,ashtabula,vidarbha,securitate,ludwigsburg,adoor,varun,shuja,khatun,chengde,bushels,lascelles,professionnelle,elfman,rangpur,unpowered,citytv,chojnice,quaternion,stokowski,aschaffenburg,commutes,subramaniam,methylene,satrap,gharb,namesakes,rathore,helier,gestational,heraklion,colliers,giannis,pastureland,evocation,krefeld,mahadeva,churchmen,egret,yilmaz,galeazzo,pudukkottai,artigas,generalitat,mudslides,frescoed,enfeoffed,aphorisms,melilla,montaigne,gauliga,parkdale,mauboy,linings,prema,sapir,xylophone,kushan,rockne,sequoyah,vasyl,rectilinear,vidyasagar,microcosm,san'a,carcinogen,thicknesses,aleut,farcical,moderating,detested,hegemonic,instalments,vauban,verwaltungsgemeinschaft,picayune,razorback,magellanic,moluccas,pankhurst,exportation,waldegrave,sufferer,bayswater,1up.com,rearmament,orangutans,varazdin,b.o.b,elucidate,harlingen,erudition,brankovic,lapis,slipway,urraca,shinde,unwell,elwes,euboea,colwyn,srivijaya,grandstands,hortons,generalleutnant,fluxes,peterhead,gandhian,reals,alauddin,maximized,fairhaven,endow,ciechanow,perforations,darters,panellist,manmade,litigants,exhibitor,tirol,caracalla,conformance,hotelier,stabaek,hearths,borac,frisians,ident,veliko,emulators,schoharie,uzbeks,samarra,prestwick,wadia,universita,tanah,bucculatrix,predominates,genotypes,denounces,roadsides,ganassi,keokuk,philatelist,tomic,ingots,conduits,samplers,abdus,johar,allegories,timaru,wolfpacks,secunda,smeaton,sportivo,inverting,contraindications,whisperer,moradabad,calamities,bakufu,soundscape,smallholders,nadeem,crossroad,xenophobic,zakir,nationalliga,glazes,retroflex,schwyz,moroder,rubra,quraysh,theodoros,endemol,infidels,km/hr,repositioned,portraitist,lluis,answerable,arges,mindedness,coarser,eyewall,teleported,scolds,uppland,vibraphone,ricoh,isenburg,bricklayer,cuttlefish,abstentions,communicable,cephalopod,stockyards,balto,kinston,armbar,bandini,elphaba,maxims,bedouins,sachsen,friedkin,tractate,pamir,ivanovo,mohini,kovalainen,nambiar,melvyn,orthonormal,matsuyama,cuernavaca,veloso,overstated,streamer,dravid,informers,analyte,sympathized,streetscape,gosta,thomasville,grigore,futuna,depleting,whelks,kiedis,armadale,earner,wynyard,dothan,animating,tridentine,sabri,immovable,rivoli,ariege,parley,clinker,circulates,junagadh,fraunhofer,congregants,180th,buducnost,formula_62,olmert,dedekind,karnak,bayernliga,mazes,sandpiper,ecclestone,yuvan,smallmouth,decolonization,lemmy,adjudicated,retiro,legia,benue,posit,acidification,wahab,taconic,floatplane,perchlorate,atria,wisbech,divestment,dallara,phrygia,palustris,cybersecurity,rebates,facie,mineralogical,substituent,proteges,fowey,mayenne,smoothbore,cherwell,schwarzschild,junin,murrumbidgee,smalltalk,d'orsay,emirati,calaveras,titusville,theremin,vikramaditya,wampanoag,burra,plaines,onegin,emboldened,whampoa,langa,soderbergh,arnaz,sowerby,arendal,godunov,pathanamthitta,damselfly,bestowing,eurosport,iconoclasm,outfitters,acquiesced,badawi,hypotension,ebbsfleet,annulus,sohrab,thenceforth,chagatai,necessitates,aulus,oddities,toynbee,uniontown,innervation,populaire,indivisible,rossellini,minuet,cyrene,gyeongju,chania,cichlids,harrods,1690s,plunges,abdullahi,gurkhas,homebuilt,sortable,bangui,rediff,incrementally,demetrios,medaille,sportif,svend,guttenberg,tubules,carthusian,pleiades,torii,hoppus,phenyl,hanno,conyngham,teschen,cronenberg,wordless,melatonin,distinctiveness,autos,freising,xuanzang,dunwich,satanism,sweyn,predrag,contractually,pavlovic,malaysians,micrometres,expertly,pannonian,abstaining,capensis,southwesterly,catchphrases,commercialize,frankivsk,normanton,hibernate,verso,deportees,dubliners,codice_8,condors,zagros,glosses,leadville,conscript,morrisons,usury,ossian,oulton,vaccinium,civet,ayman,codrington,hadron,nanometers,geochemistry,extractor,grigori,tyrrhenian,neocollyris,drooping,falsification,werft,courtauld,brigantine,orhan,chapultepec,supercopa,federalized,praga,havering,encampments,infallibility,sardis,pawar,undirected,reconstructionist,ardrossan,varuna,pastimes,archdiocesan,fledging,shenhua,molise,secondarily,stagnated,replicates,ciencias,duryodhana,marauding,ruislip,ilyich,intermixed,ravenswood,shimazu,mycorrhizal,icosahedral,consents,dunblane,follicular,pekin,suffield,muromachi,kinsale,gauche,businesspeople,thereto,watauga,exaltation,chelmno,gorse,proliferate,drainages,burdwan,kangra,transducers,inductor,duvalier,maguindanao,moslem,uncaf,givenchy,plantarum,liturgics,telegraphs,lukashenko,chenango,andante,novae,ironwood,faubourg,torme,chinensis,ambala,pietermaritzburg,virginians,landform,bottlenecks,o'driscoll,darbhanga,baptistery,ameer,needlework,naperville,auditoriums,mullingar,starrer,animatronic,topsoil,madura,cannock,vernet,santurce,catocala,ozeki,pontevedra,multichannel,sundsvall,strategists,medio,135th,halil,afridi,trelawny,caloric,ghraib,allendale,hameed,ludwigshafen,spurned,pavlo,palmar,strafed,catamarca,aveiro,harmonization,surah,predictors,solvay,mande,omnipresent,parenthesis,echolocation,equaling,experimenters,acyclic,lithographic,sepoys,katarzyna,sridevi,impoundment,khosrow,caesarean,nacogdoches,rockdale,lawmaker,caucasians,bahman,miyan,rubric,exuberance,bombastic,ductile,snowdonia,inlays,pinyon,anemones,hurries,hospitallers,tayyip,pulleys,treme,photovoltaics,testbed,polonium,ryszard,osgoode,profiting,ironwork,unsurpassed,nepticulidae,makai,lumbini,preclassic,clarksburg,egremont,videography,rehabilitating,ponty,sardonic,geotechnical,khurasan,solzhenitsyn,henna,phoenicia,rhyolite,chateaux,retorted,tomar,deflections,repressions,harborough,renan,brumbies,vandross,storia,vodou,clerkenwell,decking,universo,salon.com,imprisoning,sudwest,ghaziabad,subscribing,pisgah,sukhumi,econometric,clearest,pindar,yildirim,iulia,atlases,cements,remaster,dugouts,collapsible,resurrecting,batik,unreliability,thiers,conjunctions,colophon,marcher,placeholder,flagella,wolds,kibaki,viviparous,twelver,screenshots,aroostook,khadr,iconographic,itasca,jaume,basti,propounded,varro,be'er,jeevan,exacted,shrublands,creditable,brocade,boras,bittern,oneonta,attentional,herzliya,comprehensible,lakeville,discards,caxias,frankland,camerata,satoru,matlab,commutator,interprovincial,yorkville,benefices,nizami,edwardsville,amigaos,cannabinoid,indianola,amateurliga,pernicious,ubiquity,anarchic,novelties,precondition,zardari,symington,sargodha,headphone,thermopylae,mashonaland,zindagi,thalberg,loewe,surfactants,dobro,crocodilians,samhita,diatoms,haileybury,berwickshire,supercritical,sofie,snorna,slatina,intramolecular,agung,osteoarthritis,obstetric,teochew,vakhtang,connemara,deformations,diadem,ferruccio,mainichi,qualitatively,refrigerant,rerecorded,methylated,karmapa,krasinski,restatement,rouvas,cubitt,seacoast,schwarzkopf,homonymous,shipowner,thiamine,approachable,xiahou,160th,ecumenism,polistes,internazionali,fouad,berar,biogeography,texting,inadequately,'when,4kids,hymenoptera,emplaced,cognomen,bellefonte,supplant,michaelmas,uriel,tafsir,morazan,schweinfurt,chorister,ps400,nscaa,petipa,resolutely,ouagadougou,mascarene,supercell,konstanz,bagrat,harmonix,bergson,shrimps,resonators,veneta,camas,mynydd,rumford,generalmajor,khayyam,web.com,pappus,halfdan,tanana,suomen,yutaka,bibliographical,traian,silat,noailles,contrapuntal,agaricus,'special,minibuses,1670s,obadiah,deepa,rorschach,malolos,lymington,valuations,imperials,caballeros,ambroise,judicature,elegiac,sedaka,shewa,checksum,gosforth,legionaries,corneille,microregion,friedrichshafen,antonis,surnamed,mycelium,cantus,educations,topmost,outfitting,ivica,nankai,gouda,anthemic,iosif,supercontinent,antifungal,belarusians,mudaliar,mohawks,caversham,glaciated,basemen,stevan,clonmel,loughton,deventer,positivist,manipuri,tensors,panipat,changeup,impermeable,dubbo,elfsborg,maritimo,regimens,bikram,bromeliad,substratum,norodom,gaultier,queanbeyan,pompeo,redacted,eurocopter,mothballed,centaurs,borno,copra,bemidji,'home,sopron,neuquen,passo,cineplex,alexandrov,wysokie,mammoths,yossi,sarcophagi,congreve,petkovic,extraneous,waterbirds,slurs,indias,phaeton,discontented,prefaced,abhay,prescot,interoperable,nordisk,bicyclists,validly,sejong,litovsk,zanesville,kapitanleutnant,kerch,changeable,mcclatchy,celebi,attesting,maccoll,sepahan,wayans,veined,gaudens,markt,dansk,soane,quantized,petersham,forebears,nayarit,frenzied,queuing,bygone,viggo,ludwik,tanka,hanssen,brythonic,cornhill,primorsky,stockpiles,conceptualization,lampeter,hinsdale,mesoderm,bielsk,rosenheim,ultron,joffrey,stanwyck,khagan,tiraspol,pavelic,ascendant,empoli,metatarsal,descentralizado,masada,ligier,huseyin,ramadi,waratah,tampines,ruthenium,statoil,mladost,liger,grecian,multiparty,digraph,maglev,reconsideration,radiography,cartilaginous,taizu,wintered,anabaptist,peterhouse,shoghi,assessors,numerator,paulet,painstakingly,halakhic,rocroi,motorcycling,gimel,kryptonian,emmeline,cheeked,drawdown,lelouch,dacians,brahmana,reminiscence,disinfection,optimizations,golders,extensor,tsugaru,tolling,liman,gulzar,unconvinced,crataegus,oppositional,dvina,pyrolysis,mandan,alexius,prion,stressors,loomed,moated,dhivehi,recyclable,relict,nestlings,sarandon,kosovar,solvers,czeslaw,kenta,maneuverable,middens,berkhamsted,comilla,folkways,loxton,beziers,batumi,petrochemicals,optimised,sirjan,rabindra,musicality,rationalisation,drillers,subspaces,'live,bbwaa,outfielders,tsung,danske,vandalised,norristown,striae,kanata,gastroenterology,steadfastly,equalising,bootlegging,mannerheim,notodontidae,lagoa,commentating,peninsulas,chishti,seismology,modigliani,preceptor,canonically,awardee,boyaca,hsinchu,stiffened,nacelle,bogor,dryness,unobstructed,yaqub,scindia,peeters,irritant,ammonites,ferromagnetic,speechwriter,oxygenated,walesa,millais,canarian,faience,calvinistic,discriminant,rasht,inker,annexes,howth,allocates,conditionally,roused,regionalism,regionalbahn,functionary,nitrates,bicentenary,recreates,saboteurs,koshi,plasmids,thinned,124th,plainview,kardashian,neuville,victorians,radiates,127th,vieques,schoolmates,petru,tokusatsu,keying,sunaina,flamethrower,'bout,demersal,hosokawa,corelli,omniscient,o'doherty,niksic,reflectivity,transdev,cavour,metronome,temporally,gabba,nsaids,geert,mayport,hematite,boeotia,vaudreuil,torshavn,sailplane,mineralogist,eskisehir,practises,gallifrey,takumi,unease,slipstream,hedmark,paulinus,ailsa,wielkopolska,filmworks,adamantly,vinaya,facelifted,franchisee,augustana,toppling,velvety,crispa,stonington,histological,genealogist,tactician,tebow,betjeman,nyingma,overwinter,oberoi,rampal,overwinters,petaluma,lactarius,stanmore,balikpapan,vasant,inclines,laminate,munshi,sociedade,rabbah,septal,boyband,ingrained,faltering,inhumans,nhtsa,affix,l'ordre,kazuki,rossendale,mysims,latvians,slaveholders,basilicata,neuburg,assize,manzanillo,scrobipalpa,formula_61,belgique,pterosaurs,privateering,vaasa,veria,northport,pressurised,hobbyist,austerlitz,sahih,bhadra,siliguri,bistrica,bursaries,wynton,corot,lepidus,lully,libor,libera,olusegun,choline,mannerism,lymphocyte,chagos,duxbury,parasitism,ecowas,morotai,cancion,coniston,aggrieved,sputnikmusic,parle,ammonian,civilisations,malformation,cattaraugus,skyhawks,d'arc,demerara,bronfman,midwinter,piscataway,jogaila,threonine,matins,kohlberg,hubli,pentatonic,camillus,nigam,potro,unchained,chauvel,orangeville,cistercians,redeployment,xanthi,manju,carabinieri,pakeha,nikolaevich,kantakouzenos,sesquicentennial,gunships,symbolised,teramo,ballo,crusading,l'oeil,bharatpur,lazier,gabrovo,hysteresis,rothbard,chaumont,roundel,ma'mun,sudhir,queried,newts,shimane,presynaptic,playfield,taxonomists,sensitivities,freleng,burkinabe,orfeo,autovia,proselytizing,bhangra,pasok,jujutsu,heung,pivoting,hominid,commending,formula_64,epworth,christianized,oresund,hantuchova,rajputana,hilversum,masoretic,dayak,bakri,assen,magog,macromolecules,waheed,qaida,spassky,rumped,protrudes,preminger,misogyny,glencairn,salafi,lacunae,grilles,racemes,areva,alighieri,inari,epitomized,photoshoot,one-of-a-kind,tring,muralist,tincture,backwaters,weaned,yeasts,analytically,smaland,caltrans,vysocina,jamuna,mauthausen,175th,nouvelles,censoring,reggina,christology,gilad,amplifying,mehmood,johnsons,redirects,eastgate,sacrum,meteoric,riverbanks,guidebooks,ascribes,scoparia,iconoclastic,telegraphic,chine,merah,mistico,lectern,sheung,aethelstan,capablanca,anant,uspto,albatrosses,mymensingh,antiretroviral,clonal,coorg,vaillant,liquidator,gigas,yokai,eradicating,motorcyclists,waitakere,tandon,nears,montenegrins,250th,tatsuya,yassin,atheistic,syncretism,nahum,berisha,transcended,owensboro,lakshmana,abteilung,unadorned,nyack,overflows,harrisonburg,complainant,uematsu,frictional,worsens,sangguniang,abutment,bulwer,sarma,apollinaire,shippers,lycia,alentejo,porpoises,optus,trawling,augustow,blackwall,workbench,westmount,leaped,sikandar,conveniences,stornoway,culverts,zoroastrians,hristo,ansgar,assistive,reassert,fanned,compasses,delgada,maisons,arima,plonsk,verlaine,starstruck,rakhine,befell,spirally,wyclef,expend,colloquium,formula_63,albertus,bellarmine,handedness,holon,introns,movimiento,profitably,lohengrin,discoverers,awash,erste,pharisees,dwarka,oghuz,hashing,heterodox,uloom,vladikavkaz,linesman,rehired,nucleophile,germanicus,gulshan,songz,bayerische,paralympian,crumlin,enjoined,khanum,prahran,penitent,amersfoort,saranac,semisimple,vagrants,compositing,tualatin,oxalate,lavra,ironi,ilkeston,umpqua,calum,stretford,zakat,guelders,hydrazine,birkin,spurring,modularity,aspartate,sodermanland,hopital,bellary,legazpi,clasico,cadfael,hypersonic,volleys,pharmacokinetics,carotene,orientale,pausini,bataille,lunga,retailed,m.phil,mazowieckie,vijayan,rawal,sublimation,promissory,estimators,ploughed,conflagration,penda,segregationist,otley,amputee,coauthor,sopra,pellew,wreckers,tollywood,circumscription,permittivity,strabane,landward,articulates,beaverbrook,rutherglen,coterminous,whistleblowers,colloidal,surbiton,atlante,oswiecim,bhasa,lampooned,chanter,saarc,landkreis,tribulation,tolerates,daiichi,hatun,cowries,dyschirius,abercromby,attock,aldwych,inflows,absolutist,l'histoire,committeeman,vanbrugh,headstock,westbourne,appenzell,hoxton,oculus,westfalen,roundabouts,nickelback,trovatore,quenching,summarises,conservators,transmutation,talleyrand,barzani,unwillingly,axonal,'blue,opining,enveloping,fidesz,rafah,colborne,flickr,lozenge,dulcimer,ndebele,swaraj,oxidize,gonville,resonated,gilani,superiore,endeared,janakpur,shepperton,solidifying,memoranda,sochaux,kurnool,rewari,emirs,kooning,bruford,unavailability,kayseri,judicious,negating,pterosaur,cytosolic,chernihiv,variational,sabretooth,seawolves,devalued,nanded,adverb,volunteerism,sealers,nemours,smederevo,kashubian,bartin,animax,vicomte,polotsk,polder,archiepiscopal,acceptability,quidditch,tussock,seminaire,immolation,belge,coves,wellingborough,khaganate,mckellen,nayaka,brega,kabhi,pontoons,bascule,newsreels,injectors,cobol,weblog,diplo,biggar,wheatbelt,erythrocytes,pedra,showgrounds,bogdanovich,eclecticism,toluene,elegies,formalize,andromedae,airworthiness,springville,mainframes,overexpression,magadha,bijelo,emlyn,glutamine,accenture,uhuru,metairie,arabidopsis,patanjali,peruvians,berezovsky,accion,astrolabe,jayanti,earnestly,sausalito,recurved,1500s,ramla,incineration,galleons,laplacian,shiki,smethwick,isomerase,dordevic,janow,jeffersonville,internationalism,penciled,styrene,ashur,nucleoside,peristome,horsemanship,sedges,bachata,medes,kristallnacht,schneerson,reflectance,invalided,strutt,draupadi,destino,partridges,tejas,quadrennial,aurel,halych,ethnomusicology,autonomist,radyo,rifting,shi'ar,crvena,telefilm,zawahiri,plana,sultanates,theodorus,subcontractors,pavle,seneschal,teleports,chernivtsi,buccal,brattleboro,stankovic,safar,dunhuang,electrocution,chastised,ergonomic,midsomer,130th,zomba,nongovernmental,escapist,localize,xuzhou,kyrie,carinthian,karlovac,nisan,kramnik,pilipino,digitisation,khasi,andronicus,highwayman,maior,misspelling,sebastopol,socon,rhaetian,archimandrite,partway,positivity,otaku,dingoes,tarski,geopolitics,disciplinarian,zulfikar,kenzo,globose,electrophilic,modele,storekeeper,pohang,wheldon,washers,interconnecting,digraphs,intrastate,campy,helvetic,frontispiece,ferrocarril,anambra,petraeus,midrib,endometrial,dwarfism,mauryan,endocytosis,brigs,percussionists,furtherance,synergistic,apocynaceae,krona,berthier,circumvented,casal,siltstone,precast,ethnikos,realists,geodesy,zarzuela,greenback,tripathi,persevered,interments,neutralization,olbermann,departements,supercomputing,demobilised,cassavetes,dunder,ministering,veszprem,barbarism,'world,pieve,apologist,frentzen,sulfides,firewalls,pronotum,staatsoper,hachette,makhachkala,oberland,phonon,yoshihiro,instars,purnima,winslet,mutsu,ergative,sajid,nizamuddin,paraphrased,ardeidae,kodagu,monooxygenase,skirmishers,sportiva,o'byrne,mykolaiv,ophir,prieta,gyllenhaal,kantian,leche,copan,herero,ps250,gelsenkirchen,shalit,sammarinese,chetwynd,wftda,travertine,warta,sigmaringen,concerti,namespace,ostergotland,biomarker,universals,collegio,embarcadero,wimborne,fiddlers,likening,ransomed,stifled,unabated,kalakaua,khanty,gongs,goodrem,countermeasure,publicizing,geomorphology,swedenborg,undefended,catastrophes,diverts,storyboards,amesbury,contactless,placentia,festivity,authorise,terrane,thallium,stradivarius,antonine,consortia,estimations,consecrate,supergiant,belichick,pendants,butyl,groza,univac,afire,kavala,studi,teletoon,paucity,gonbad,koninklijke,128th,stoichiometric,multimodal,facundo,anatomic,melamine,creuse,altan,brigands,mcguinty,blomfield,tsvangirai,protrusion,lurgan,warminster,tenzin,russellville,discursive,definable,scotrail,lignin,reincorporated,o'dell,outperform,redland,multicolored,evaporates,dimitrie,limbic,patapsco,interlingua,surrogacy,cutty,potrero,masud,cahiers,jintao,ardashir,centaurus,plagiarized,minehead,musings,statuettes,logarithms,seaview,prohibitively,downforce,rivington,tomorrowland,microbiologist,ferric,morag,capsid,kucinich,clairvaux,demotic,seamanship,cicada,painterly,cromarty,carbonic,tupou,oconee,tehuantepec,typecast,anstruther,internalized,underwriters,tetrahedra,flagrant,quakes,pathologies,ulrik,nahal,tarquini,dongguan,parnassus,ryoko,senussi,seleucia,airasia,einer,sashes,d'amico,matriculating,arabesque,honved,biophysical,hardinge,kherson,mommsen,diels,icbms,reshape,brasiliensis,palmach,netaji,oblate,functionalities,grigor,blacksburg,recoilless,melanchthon,reales,astrodome,handcrafted,memes,theorizes,isma'il,aarti,pirin,maatschappij,stabilizes,honiara,ashbury,copts,rootes,defensed,queiroz,mantegna,galesburg,coraciiformesfamily,cabrillo,tokio,antipsychotics,kanon,173rd,apollonia,finial,lydian,hadamard,rangi,dowlatabad,monolingual,platformer,subclasses,chiranjeevi,mirabeau,newsgroup,idmanyurdu,kambojas,walkover,zamoyski,generalist,khedive,flanges,knowle,bande,157th,alleyn,reaffirm,pininfarina,zuckerberg,hakodate,131st,aditi,bellinzona,vaulter,planking,boscombe,colombians,lysis,toppers,metered,nahyan,queensryche,minho,nagercoil,firebrand,foundress,bycatch,mendota,freeform,antena,capitalisation,martinus,overijssel,purists,interventionist,zgierz,burgundians,hippolyta,trompe,umatilla,moroccans,dictionnaire,hydrography,changers,chota,rimouski,aniline,bylaw,grandnephew,neamt,lemnos,connoisseurs,tractive,rearrangements,fetishism,finnic,apalachicola,landowning,calligraphic,circumpolar,mansfeld,legible,orientalism,tannhauser,blamey,maximization,noinclude,blackbirds,angara,ostersund,pancreatitis,glabra,acleris,juried,jungian,triumphantly,singlet,plasmas,synesthesia,yellowhead,unleashes,choiseul,quanzhong,brookville,kaskaskia,igcse,skatepark,jatin,jewellers,scaritinae,techcrunch,tellurium,lachaise,azuma,codeshare,dimensionality,unidirectional,scolaire,macdill,camshafts,unassisted,verband,kahlo,eliya,prelature,chiefdoms,saddleback,sockers,iommi,coloratura,llangollen,biosciences,harshest,maithili,k'iche,plical,multifunctional,andreu,tuskers,confounding,sambre,quarterdeck,ascetics,berdych,transversal,tuolumne,sagami,petrobras,brecker,menxia,instilling,stipulating,korra,oscillate,deadpan,v/line,pyrotechnic,stoneware,prelims,intracoastal,retraining,ilija,berwyn,encrypt,achievers,zulfiqar,glycoproteins,khatib,farmsteads,occultist,saman,fionn,derulo,khilji,obrenovic,argosy,toowong,dementieva,sociocultural,iconostasis,craigslist,festschrift,taifa,intercalated,tanjong,penticton,sharad,marxian,extrapolation,guises,wettin,prabang,exclaiming,kosta,famas,conakry,wanderings,'aliabad,macleay,exoplanet,bancorp,besiegers,surmounting,checkerboard,rajab,vliet,tarek,operable,wargaming,haldimand,fukuyama,uesugi,aggregations,erbil,brachiopods,tokyu,anglais,unfavorably,ujpest,escorial,armagnac,nagara,funafuti,ridgeline,cocking,o'gorman,compactness,retardant,krajowa,barua,coking,bestows,thampi,chicagoland,variably,o'loughlin,minnows,schwa,shaukat,polycarbonate,chlorinated,godalming,gramercy,delved,banqueting,enlil,sarada,prasanna,domhnall,decadal,regressive,lipoprotein,collectable,surendra,zaporizhia,cycliste,suchet,offsetting,formula_65,pudong,d'arte,blyton,quonset,osmania,tientsin,manorama,proteomics,bille,jalpaiguri,pertwee,barnegat,inventiveness,gollancz,euthanized,henricus,shortfalls,wuxia,chlorides,cerrado,polyvinyl,folktale,straddled,bioengineering,eschewing,greendale,recharged,olave,ceylonese,autocephalous,peacebuilding,wrights,guyed,rosamund,abitibi,bannockburn,gerontology,scutari,souness,seagram,codice_9,'open,xhtml,taguig,purposed,darbar,orthopedics,unpopulated,kisumu,tarrytown,feodor,polyhedral,monadnock,gottorp,priam,redesigning,gasworks,elfin,urquiza,homologation,filipovic,bohun,manningham,gornik,soundness,shorea,lanus,gelder,darke,sandgate,criticality,paranaense,153rd,vieja,lithograph,trapezoid,tiebreakers,convalescence,yan'an,actuaries,balad,altimeter,thermoelectric,trailblazer,previn,tenryu,ancaster,endoscopy,nicolet,discloses,fracking,plaine,salado,americanism,placards,absurdist,propylene,breccia,jirga,documenta,ismailis,161st,brentano,dallas/fort,embellishment,calipers,subscribes,mahavidyalaya,wednesbury,barnstormers,miwok,schembechler,minigame,unterberger,dopaminergic,inacio,nizamabad,overridden,monotype,cavernous,stichting,sassafras,sotho,argentinean,myrrh,rapidity,flatts,gowrie,dejected,kasaragod,cyprinidae,interlinked,arcseconds,degeneracy,infamously,incubate,substructure,trigeminal,sectarianism,marshlands,hooliganism,hurlers,isolationist,urania,burrard,switchover,lecco,wilts,interrogator,strived,ballooning,volterra,raciborz,relegating,gilding,cybele,dolomites,parachutist,lochaber,orators,raeburn,backend,benaud,rallycross,facings,banga,nuclides,defencemen,futurity,emitters,yadkin,eudonia,zambales,manasseh,sirte,meshes,peculiarly,mcminnville,roundly,boban,decrypt,icelanders,sanam,chelan,jovian,grudgingly,penalised,subscript,gambrinus,poaceae,infringements,maleficent,runciman,148th,supersymmetry,granites,liskeard,eliciting,involution,hallstatt,kitzbuhel,shankly,sandhills,inefficiencies,yishuv,psychotropic,nightjars,wavell,sangamon,vaikundar,choshu,retrospectives,pitesti,gigantea,hashemi,bosna,gakuin,siochana,arrangers,baronetcies,narayani,temecula,creston,koscierzyna,autochthonous,wyandot,anniston,igreja,mobilise,buzau,dunster,musselburgh,wenzhou,khattak,detoxification,decarboxylase,manlius,campbells,coleoptera,copyist,sympathisers,suisun,eminescu,defensor,transshipment,thurgau,somerton,fluctuates,ambika,weierstrass,lukow,giambattista,volcanics,romanticized,innovated,matabeleland,scotiabank,garwolin,purine,d'auvergne,borderland,maozhen,pricewaterhousecoopers,testator,pallium,scout.com,mv/pi,nazca,curacies,upjohn,sarasvati,monegasque,ketrzyn,malory,spikelets,biomechanics,haciendas,rapped,dwarfed,stews,nijinsky,subjection,matsu,perceptible,schwarzburg,midsection,entertains,circuitous,epiphytic,wonsan,alpini,bluefield,sloths,transportable,braunfels,dictum,szczecinek,jukka,wielun,wejherowo,hucknall,grameen,duodenum,ribose,deshpande,shahar,nexstar,injurious,dereham,lithographer,dhoni,structuralist,progreso,deschutes,christus,pulteney,quoins,yitzchak,gyeongsang,breviary,makkah,chiyoda,jutting,vineland,angiosperms,necrotic,novelisation,redistribute,tirumala,140th,featureless,mafic,rivaling,toyline,2/1st,martius,saalfeld,monthan,texian,kathak,melodramas,mithila,regierungsbezirk,509th,fermenting,schoolmate,virtuosic,briain,kokoda,heliocentric,handpicked,kilwinning,sonically,dinars,kasim,parkways,bogdanov,luxembourgian,halland,avesta,bardic,daugavpils,excavator,qwest,frustrate,physiographic,majoris,'ndrangheta,unrestrained,firmness,montalban,abundances,preservationists,adare,executioners,guardsman,bonnaroo,neglects,nazrul,pro12,hoorn,abercorn,refuting,kabud,cationic,parapsychology,troposphere,venezuelans,malignancy,khoja,unhindered,accordionist,medak,visby,ejercito,laparoscopic,dinas,umayyads,valmiki,o'dowd,saplings,stranding,incisions,illusionist,avocets,buccleuch,amazonia,fourfold,turboprops,roosts,priscus,turnstile,areal,certifies,pocklington,spoofs,viseu,commonalities,dabrowka,annam,homesteaders,daredevils,mondrian,negotiates,fiestas,perennials,maximizes,lubavitch,ravindra,scrapers,finials,kintyre,violas,snoqualmie,wilders,openbsd,mlawa,peritoneal,devarajan,congke,leszno,mercurial,fakir,joannes,bognor,overloading,unbuilt,gurung,scuttle,temperaments,bautzen,jardim,tradesman,visitations,barbet,sagamore,graaff,forecasters,wilsons,assis,l'air,shariah,sochaczew,russa,dirge,biliary,neuve,heartbreakers,strathearn,jacobian,overgrazing,edrich,anticline,parathyroid,petula,lepanto,decius,channelled,parvathi,puppeteers,communicators,francorchamps,kahane,longus,panjang,intron,traite,xxvii,matsuri,amrit,katyn,disheartened,cacak,omonia,alexandrine,partaking,wrangling,adjuvant,haskovo,tendrils,greensand,lammermoor,otherworld,volusia,stabling,one-and-a-half,bresson,zapatista,eotvos,ps150,webisodes,stepchildren,microarray,braganca,quanta,dolne,superoxide,bellona,delineate,ratha,lindenwood,bruhl,cingulate,tallies,bickerton,helgi,bevin,takoma,tsukuba,statuses,changeling,alister,bytom,dibrugarh,magnesia,duplicating,outlier,abated,goncalo,strelitz,shikai,mardan,musculature,ascomycota,springhill,tumuli,gabaa,odenwald,reformatted,autocracy,theresienstadt,suplex,chattopadhyay,mencken,congratulatory,weatherfield,systema,solemnity,projekt,quanzhou,kreuzberg,postbellum,nobuo,mediaworks,finisterre,matchplay,bangladeshis,kothen,oocyte,hovered,aromas,afshar,browed,teases,chorlton,arshad,cesaro,backbencher,iquique,vulcans,padmini,unabridged,cyclase,despotic,kirilenko,achaean,queensberry,debre,octahedron,iphigenia,curbing,karimnagar,sagarmatha,smelters,surrealists,sanada,shrestha,turridae,leasehold,jiedushi,eurythmics,appropriating,correze,thimphu,amery,musicomh,cyborgs,sandwell,pushcart,retorts,ameliorate,deteriorates,stojanovic,spline,entrenchments,bourse,chancellorship,pasolini,lendl,personage,reformulated,pubescens,loiret,metalurh,reinvention,nonhuman,eilema,tarsal,complutense,magne,broadview,metrodome,outtake,stouffville,seinen,bataillon,phosphoric,ostensible,opatow,aristides,beefheart,glorifying,banten,romsey,seamounts,fushimi,prophylaxis,sibylla,ranjith,goslar,balustrades,georgiev,caird,lafitte,peano,canso,bankura,halfpenny,segregate,caisson,bizerte,jamshedpur,euromaidan,philosophie,ridged,cheerfully,reclassification,aemilius,visionaries,samoans,wokingham,chemung,wolof,unbranched,cinerea,bhosle,ourense,immortalised,cornerstones,sourcebook,khufu,archimedean,universitatea,intermolecular,fiscally,suffices,metacomet,adjudicator,stablemate,specks,glace,inowroclaw,patristic,muharram,agitating,ashot,neurologic,didcot,gamla,ilves,putouts,siraj,laski,coaling,diarmuid,ratnagiri,rotulorum,liquefaction,morbihan,harel,aftershock,gruiformesfamily,bonnier,falconiformesfamily,adorns,wikis,maastrichtian,stauffenberg,bishopsgate,fakhr,sevenfold,ponders,quantifying,castiel,opacity,depredations,lenten,gravitated,o'mahony,modulates,inuktitut,paston,kayfabe,vagus,legalised,balked,arianism,tendering,sivas,birthdate,awlaki,khvajeh,shahab,samtgemeinde,bridgeton,amalgamations,biogenesis,recharging,tsukasa,mythbusters,chamfered,enthronement,freelancers,maharana,constantia,sutil,messines,monkton,okanogan,reinvigorated,apoplexy,tanahashi,neues,valiants,harappan,russes,carding,volkoff,funchal,statehouse,imitative,intrepidity,mellotron,samaras,turkana,besting,longitudes,exarch,diarrhoea,transcending,zvonareva,darna,ramblin,disconnection,137th,refocused,diarmait,agricole,ba'athist,turenne,contrabass,communis,daviess,fatimids,frosinone,fittingly,polyphyletic,qanat,theocratic,preclinical,abacha,toorak,marketplaces,conidia,seiya,contraindicated,retford,bundesautobahn,rebuilds,climatology,seaworthy,starfighter,qamar,categoria,malai,hellinsia,newstead,airworthy,catenin,avonmouth,arrhythmias,ayyavazhi,downgrade,ashburnham,ejector,kinematics,petworth,rspca,filmation,accipitridae,chhatrapati,g/mol,bacau,agama,ringtone,yudhoyono,orchestrator,arbitrators,138th,powerplants,cumbernauld,alderley,misamis,hawai`i,cuando,meistriliiga,jermyn,alans,pedigrees,ottavio,approbation,omnium,purulia,prioress,rheinland,lymphoid,lutsk,oscilloscope,ballina,iliac,motorbikes,modernising,uffizi,phylloxera,kalevala,bengalis,amravati,syntheses,interviewers,inflectional,outflank,maryhill,unhurt,profiler,nacelles,heseltine,personalised,guarda,herpetologist,airpark,pigot,margaretha,dinos,peleliu,breakbeat,kastamonu,shaivism,delamere,kingsville,epigram,khlong,phospholipids,journeying,lietuvos,congregated,deviance,celebes,subsoil,stroma,kvitova,lubricating,layoff,alagoas,olafur,doron,interuniversity,raycom,agonopterix,uzice,nanna,springvale,raimundo,wrested,pupal,talat,skinheads,vestige,unpainted,handan,odawara,ammar,attendee,lapped,myotis,gusty,ciconiiformesfamily,traversal,subfield,vitaphone,prensa,hasidism,inwood,carstairs,kropotkin,turgenev,dobra,remittance,purim,tannin,adige,tabulation,lethality,pacha,micronesian,dhruva,defensemen,tibeto,siculus,radioisotope,sodertalje,phitsanulok,euphonium,oxytocin,overhangs,skinks,fabrica,reinterred,emulates,bioscience,paragliding,raekwon,perigee,plausibility,frolunda,erroll,aznar,vyasa,albinus,trevally,confederacion,terse,sixtieth,1530s,kendriya,skateboarders,frontieres,muawiyah,easements,shehu,conservatively,keystones,kasem,brutalist,peekskill,cowry,orcas,syllabary,paltz,elisabetta,denticles,hampering,dolni,eidos,aarau,lermontov,yankton,shahbaz,barrages,kongsvinger,reestablishment,acetyltransferase,zulia,mrnas,slingsby,eucalypt,efficacious,weybridge,gradation,cinematheque,malthus,bampton,coexisted,cisse,hamdi,cupertino,saumarez,chionodes,libertine,formers,sakharov,pseudonymous,vol.1,mcduck,gopalakrishnan,amberley,jorhat,grandmasters,rudiments,dwindle,param,bukidnon,menander,americanus,multipliers,pulawy,homoerotic,pillbox,cd+dvd,epigraph,aleksandrow,extrapolated,horseshoes,contemporain,angiography,hasselt,shawinigan,memorization,legitimized,cyclades,outsold,rodolphe,kelis,powerball,dijkstra,analyzers,incompressible,sambar,orangeburg,osten,reauthorization,adamawa,sphagnum,hypermarket,millipedes,zoroaster,madea,ossuary,murrayfield,pronominal,gautham,resellers,ethers,quarrelled,dolna,stragglers,asami,tangut,passos,educacion,sharaf,texel,berio,bethpage,bezalel,marfa,noronha,36ers,genteel,avram,shilton,compensates,sweetener,reinstalled,disables,noether,1590s,balakrishnan,kotaro,northallerton,cataclysm,gholam,cancellara,schiphol,commends,longinus,albinism,gemayel,hamamatsu,volos,islamism,sidereal,pecuniary,diggings,townsquare,neosho,lushan,chittoor,akhil,disputation,desiccation,cambodians,thwarting,deliberated,ellipsis,bahini,susumu,separators,kohneh,plebeians,kultur,ogaden,pissarro,trypeta,latur,liaodong,vetting,datong,sohail,alchemists,lengthwise,unevenly,masterly,microcontrollers,occupier,deviating,farringdon,baccalaureat,theocracy,chebyshev,archivists,jayaram,ineffectiveness,scandinavians,jacobins,encomienda,nambu,g/cm3,catesby,paavo,heeded,rhodium,idealised,10deg,infective,mecyclothorax,halevy,sheared,minbari,audax,lusatian,rebuffs,hitfix,fastener,subjugate,tarun,binet,compuserve,synthesiser,keisuke,amalric,ligatures,tadashi,ignazio,abramovich,groundnut,otomo,maeve,mortlake,ostrogoths,antillean,todor,recto,millimetre,espousing,inaugurate,paracetamol,galvanic,harpalinae,jedrzejow,reassessment,langlands,civita,mikan,stikine,bijar,imamate,istana,kaiserliche,erastus,federale,cytosine,expansionism,hommes,norrland,smriti,snapdragon,gulab,taleb,lossy,khattab,urbanised,sesto,rekord,diffuser,desam,morganatic,silting,pacts,extender,beauharnais,purley,bouches,halfpipe,discontinuities,houthi,farmville,animism,horni,saadi,interpretative,blockades,symeon,biogeographic,transcaucasian,jetties,landrieu,astrocytes,conjunto,stumpings,weevils,geysers,redux,arching,romanus,tazeh,marcellinus,casein,opava,misrata,anare,sattar,declarer,dreux,oporto,venta,vallis,icosahedron,cortona,lachine,mohammedan,sandnes,zynga,clarin,diomedes,tsuyoshi,pribram,gulbarga,chartist,superettan,boscawen,altus,subang,gating,epistolary,vizianagaram,ogdensburg,panna,thyssen,tarkovsky,dzogchen,biograph,seremban,unscientific,nightjar,legco,deism,n.w.a,sudha,siskel,sassou,flintlock,jovial,montbeliard,pallida,formula_66,tranquillity,nisei,adornment,'people,yamhill,hockeyallsvenskan,adopters,appian,lowicz,haplotypes,succinctly,starogard,presidencies,kheyrabad,sobibor,kinesiology,cowichan,militum,cromwellian,leiningen,ps1.5,concourses,dalarna,goldfield,brzeg,faeces,aquarii,matchless,harvesters,181st,numismatics,korfball,sectioned,transpires,facultative,brandishing,kieron,forages,menai,glutinous,debarge,heathfield,1580s,malang,photoelectric,froome,semiotic,alwar,grammophon,chiaroscuro,mentalist,maramures,flacco,liquors,aleutians,marvell,sutlej,patnaik,qassam,flintoff,bayfield,haeckel,sueno,avicii,exoplanets,hoshi,annibale,vojislav,honeycombs,celebrant,rendsburg,veblen,quails,141st,carronades,savar,narrations,jeeva,ontologies,hedonistic,marinette,godot,munna,bessarabian,outrigger,thame,gravels,hoshino,falsifying,stereochemistry,nacionalista,medially,radula,ejecting,conservatorio,odile,ceiba,jaina,essonne,isometry,allophones,recidivism,iveco,ganda,grammarians,jagan,signposted,uncompressed,facilitators,constancy,ditko,propulsive,impaling,interbank,botolph,amlaib,intergroup,sorbus,cheka,debye,praca,adorning,presbyteries,dormition,strategos,qarase,pentecostals,beehives,hashemite,goldust,euronext,egress,arpanet,soames,jurchens,slovenska,copse,kazim,appraisals,marischal,mineola,sharada,caricaturist,sturluson,galba,faizabad,overwintering,grete,uyezds,didsbury,libreville,ablett,microstructure,anadolu,belenenses,elocution,cloaks,timeslots,halden,rashidun,displaces,sympatric,germanus,tuples,ceska,equalize,disassembly,krautrock,babangida,memel,deild,gopala,hematology,underclass,sangli,wawrinka,assur,toshack,refrains,nicotinic,bhagalpur,badami,racetracks,pocatello,walgreens,nazarbayev,occultation,spinnaker,geneon,josias,hydrolyzed,dzong,corregimiento,waistcoat,thermoplastic,soldered,anticancer,lactobacillus,shafi'i,carabus,adjournment,schlumberger,triceratops,despotate,mendicant,krishnamurti,bahasa,earthworm,lavoisier,noetherian,kalki,fervently,bhawan,saanich,coquille,gannet,motagua,kennels,mineralization,fitzherbert,svein,bifurcated,hairdressing,felis,abounded,dimers,fervour,hebdo,bluffton,aetna,corydon,clevedon,carneiro,subjectively,deutz,gastropoda,overshot,concatenation,varman,carolla,maharshi,mujib,inelastic,riverhead,initialized,safavids,rohini,caguas,bulges,fotbollforbund,hefei,spithead,westville,maronites,lytham,americo,gediminas,stephanus,chalcolithic,hijra,gnu/linux,predilection,rulership,sterility,haidar,scarlatti,saprissa,sviatoslav,pointedly,sunroof,guarantor,thevar,airstrips,pultusk,sture,129th,divinities,daizong,dolichoderus,cobourg,maoists,swordsmanship,uprated,bohme,tashi,largs,chandi,bluebeard,householders,richardsonian,drepanidae,antigonish,elbasan,occultism,marca,hypergeometric,oirat,stiglitz,ignites,dzungar,miquelon,pritam,d'automne,ulidiid,niamey,vallecano,fondo,billiton,incumbencies,raceme,chambery,cadell,barenaked,kagame,summerside,haussmann,hatshepsut,apothecaries,criollo,feint,nasals,timurid,feltham,plotinus,oxygenation,marginata,officinalis,salat,participations,ising,downe,izumo,unguided,pretence,coursed,haruna,viscountcy,mainstage,justicia,powiat,takara,capitoline,implacable,farben,stopford,cosmopterix,tuberous,kronecker,galatians,kweli,dogmas,exhorted,trebinje,skanda,newlyn,ablative,basidia,bhiwani,encroachments,stranglers,regrouping,tubal,shoestring,wawel,anionic,mesenchymal,creationists,pyrophosphate,moshi,despotism,powerbook,fatehpur,rupiah,segre,ternate,jessore,b.i.g,shevardnadze,abounds,gliwice,densest,memoria,suborbital,vietcong,ratepayers,karunanidhi,toolbar,descents,rhymney,exhortation,zahedan,carcinomas,hyperbaric,botvinnik,billets,neuropsychological,tigranes,hoards,chater,biennially,thistles,scotus,wataru,flotillas,hungama,monopolistic,payouts,vetch,generalissimo,caries,naumburg,piran,blizzards,escalates,reactant,shinya,theorize,rizzoli,transitway,ecclesiae,streptomyces,cantal,nisibis,superconductor,unworkable,thallus,roehampton,scheckter,viceroys,makuuchi,ilkley,superseding,takuya,klodzko,borbon,raspberries,operand,w.a.k.o,sarabande,factionalism,egalitarianism,temasek,torbat,unscripted,jorma,westerner,perfective,vrije,underlain,goldfrapp,blaenau,jomon,barthes,drivetime,bassa,bannock,umaga,fengxiang,zulus,sreenivasan,farces,codice_10,freeholder,poddebice,imperialists,deregulated,wingtip,o'hagan,pillared,overtone,hofstadter,149th,kitano,saybrook,standardizing,aldgate,staveley,o'flaherty,hundredths,steerable,soltan,empted,cruyff,intramuros,taluks,cotonou,marae,karur,figueres,barwon,lucullus,niobe,zemlya,lathes,homeported,chaux,amyotrophic,opines,exemplars,bhamo,homomorphisms,gauleiter,ladin,mafiosi,airdrieonians,b/soul,decal,transcaucasia,solti,defecation,deaconess,numidia,sampradaya,normalised,wingless,schwaben,alnus,cinerama,yakutsk,ketchikan,orvieto,unearned,monferrato,rotem,aacsb,loong,decoders,skerries,cardiothoracic,repositioning,pimpernel,yohannan,tenebrionoidea,nargis,nouvel,costliest,interdenominational,noize,redirecting,zither,morcha,radiometric,frequenting,irtysh,gbagbo,chakri,litvinenko,infotainment,ravensbruck,harith,corbels,maegashira,jousting,natan,novus,falcao,minis,railed,decile,rauma,ramaswamy,cavitation,paranaque,berchtesgaden,reanimated,schomberg,polysaccharides,exclusionary,cleon,anurag,ravaging,dhanush,mitchells,granule,contemptuous,keisei,rolleston,atlantean,yorkist,daraa,wapping,micrometer,keeneland,comparably,baranja,oranje,schlafli,yogic,dinajpur,unimpressive,masashi,recreativo,alemannic,petersfield,naoko,vasudeva,autosport,rajat,marella,busko,wethersfield,ssris,soulcalibur,kobani,wildland,rookery,hoffenheim,kauri,aliphatic,balaclava,ferrite,publicise,victorias,theism,quimper,chapbook,functionalist,roadbed,ulyanovsk,cupen,purpurea,calthorpe,teofilo,mousavi,cochlea,linotype,detmold,ellerslie,gakkai,telkom,southsea,subcontractor,inguinal,philatelists,zeebrugge,piave,trochidae,dempo,spoilt,saharanpur,mihrab,parasympathetic,barbarous,chartering,antiqua,katsina,bugis,categorizes,altstadt,kandyan,pambansa,overpasses,miters,assimilating,finlandia,uneconomic,am/fm,harpsichordist,dresdner,luminescence,authentically,overpowers,magmatic,cliftonville,oilfields,skirted,berthe,cuman,oakham,frelimo,glockenspiel,confection,saxophonists,piaseczno,multilevel,antipater,levying,maltreatment,velho,opoczno,harburg,pedophilia,unfunded,palettes,plasterwork,breve,dharmendra,auchinleck,nonesuch,blackmun,libretti,rabbani,145th,hasselbeck,kinnock,malate,vanden,cloverdale,ashgabat,nares,radians,steelworkers,sabor,possums,catterick,hemispheric,ostra,outpaced,dungeness,almshouse,penryn,texians,1000m,franchitti,incumbency,texcoco,newar,tramcars,toroidal,meitetsu,spellbound,agronomist,vinifera,riata,bunko,pinas,ba'al,github,vasilyevich,obsolescent,geodesics,ancestries,tujue,capitalised,unassigned,throng,unpaired,psychometric,skegness,exothermic,buffered,kristiansund,tongued,berenger,basho,alitalia,prolongation,archaeologically,fractionation,cyprinid,echinoderms,agriculturally,justiciar,sonam,ilium,baits,danceable,grazer,ardahan,grassed,preemption,glassworks,hasina,ugric,umbra,wahhabi,vannes,tinnitus,capitaine,tikrit,lisieux,scree,hormuz,despenser,jagiellon,maisonneuve,gandaki,santarem,basilicas,lancing,landskrona,weilburg,fireside,elysian,isleworth,krishnamurthy,filton,cynon,tecmo,subcostal,scalars,triglycerides,hyperplane,farmingdale,unione,meydan,pilings,mercosur,reactivate,akiba,fecundity,jatra,natsume,zarqawi,preta,masao,presbyter,oakenfold,rhodri,ferran,ruizong,cloyne,nelvana,epiphanius,borde,scutes,strictures,troughton,whitestone,sholom,toyah,shingon,kutuzov,abelard,passant,lipno,cafeterias,residuals,anabaptists,paratransit,criollos,pleven,radiata,destabilizing,hadiths,bazaars,mannose,taiyo,crookes,welbeck,baoding,archelaus,nguesso,alberni,wingtips,herts,viasat,lankans,evreux,wigram,fassbinder,ryuichi,storting,reducible,olesnica,znojmo,hyannis,theophanes,flatiron,mustering,rajahmundry,kadir,wayang,prome,lethargy,zubin,illegality,conall,dramedy,beerbohm,hipparchus,ziarat,ryuji,shugo,glenorchy,microarchitecture,morne,lewinsky,cauvery,battenberg,hyksos,wayanad,hamilcar,buhari,brazo,bratianu,solms,aksaray,elamite,chilcotin,bloodstock,sagara,dolny,reunified,umlaut,proteaceae,camborne,calabrian,dhanbad,vaxjo,cookware,potez,rediffusion,semitones,lamentations,allgau,guernica,suntory,pleated,stationing,urgell,gannets,bertelsmann,entryway,raphitomidae,acetaldehyde,nephrology,categorizing,beiyang,permeate,tourney,geosciences,khana,masayuki,crucis,universitaria,slaskie,khaimah,finno,advani,astonishingly,tubulin,vampiric,jeolla,sociale,cleethorpes,badri,muridae,suzong,debater,decimation,kenyans,mutualism,pontifex,middlemen,insee,halevi,lamentation,psychopathy,brassey,wenders,kavya,parabellum,prolactin,inescapable,apses,malignancies,rinzai,stigmatized,menahem,comox,ateliers,welshpool,setif,centimetre,truthfulness,downfield,drusus,woden,glycosylation,emanated,agulhas,dalkeith,jazira,nucky,unifil,jobim,operon,oryzomys,heroically,seances,supernumerary,backhouse,hashanah,tatler,imago,invert,hayato,clockmaker,kingsmill,swiecie,analogously,golconda,poste,tacitly,decentralised,ge'ez,diplomatically,fossiliferous,linseed,mahavira,pedestals,archpriest,byelection,domiciled,jeffersonian,bombus,winegrowing,waukegan,uncultivated,haverfordwest,saumur,communally,disbursed,cleeve,zeljeznicar,speciosa,vacationers,sigur,vaishali,zlatko,iftikhar,cropland,transkei,incompleteness,bohra,subantarctic,slieve,physiologic,similis,klerk,replanted,'right,chafee,reproducible,bayburt,regicide,muzaffarpur,plurals,hanyu,orthologs,diouf,assailed,kamui,tarik,dodecanese,gorne,on/off,179th,shimoga,granaries,carlists,valar,tripolitania,sherds,simmern,dissociated,isambard,polytechnical,yuvraj,brabazon,antisense,pubmed,glans,minutely,masaaki,raghavendra,savoury,podcasting,tachi,bienville,gongsun,ridgely,deform,yuichi,binders,canna,carcetti,llobregat,implored,berri,njegos,intermingled,offload,athenry,motherhouse,corpora,kakinada,dannebrog,imperio,prefaces,musicologists,aerospatiale,shirai,nagapattinam,servius,cristoforo,pomfret,reviled,entebbe,stane,east/west,thermometers,matriarchal,siglo,bodil,legionnaire,ze'ev,theorizing,sangeetha,horticulturist,uncountable,lookalike,anoxic,ionospheric,genealogists,chicopee,imprinting,popish,crematoria,diamondback,cyathea,hanzhong,cameramen,halogaland,naklo,waclaw,storehouses,flexed,comuni,frits,glauca,nilgiris,compresses,nainital,continuations,albay,hypoxic,samajwadi,dunkerque,nanticoke,sarwar,interchanged,jubal,corba,jalgaon,derleth,deathstroke,magny,vinnytsia,hyphenated,rimfire,sawan,boehner,disrepute,normalize,aromanian,dualistic,approximant,chama,karimabad,barnacles,sanok,stipends,dyfed,rijksmuseum,reverberation,suncorp,fungicides,reverie,spectrograph,stereophonic,niazi,ordos,alcan,karaite,lautrec,tableland,lamellar,rieti,langmuir,russula,webern,tweaks,hawick,southerner,morphy,naturalisation,enantiomer,michinoku,barbettes,relieves,carburettors,redruth,oblates,vocabularies,mogilev,bagmati,galium,reasserted,extolled,symon,eurosceptic,inflections,tirtha,recompense,oruro,roping,gouverneur,pared,yayoi,watermills,retooled,leukocytes,jubilant,mazhar,nicolau,manheim,touraine,bedser,hambledon,kohat,powerhouses,tlemcen,reuven,sympathetically,afrikaners,interes,handcrafts,etcher,baddeley,wodonga,amaury,155th,vulgarity,pompadour,automorphisms,1540s,oppositions,prekmurje,deryni,fortifying,arcuate,mahila,bocage,uther,nozze,slashes,atlantica,hadid,rhizomatous,azeris,'with,osmena,lewisville,innervated,bandmaster,outcropping,parallelogram,dominicana,twang,ingushetia,extensional,ladino,sastry,zinoviev,relatable,nobilis,cbeebies,hitless,eulima,sporangia,synge,longlisted,criminalized,penitential,weyden,tubule,volyn,priestesses,glenbrook,kibbutzim,windshaft,canadair,falange,zsolt,bonheur,meine,archangels,safeguarded,jamaicans,malarial,teasers,badging,merseyrail,operands,pulsars,gauchos,biotin,bambara,necaxa,egmond,tillage,coppi,anxiolytic,preah,mausoleums,plautus,feroz,debunked,187th,belediyespor,mujibur,wantage,carboxyl,chettiar,murnau,vagueness,racemic,backstretch,courtland,municipio,palpatine,dezful,hyperbola,sreekumar,chalons,altay,arapahoe,tudors,sapieha,quilon,burdensome,kanya,xxviii,recension,generis,siphuncle,repressor,bitrate,mandals,midhurst,dioxin,democratique,upholds,rodez,cinematographic,epoque,jinping,rabelais,zhytomyr,glenview,rebooted,khalidi,reticulata,122nd,monnaie,passersby,ghazals,europaea,lippmann,earthbound,tadic,andorran,artvin,angelicum,banksy,epicentre,resemblances,shuttled,rathaus,bernt,stonemasons,balochi,siang,tynemouth,cygni,biosynthetic,precipitates,sharecroppers,d'annunzio,softbank,shiji,apeldoorn,polycyclic,wenceslas,wuchang,samnites,tamarack,silmarillion,madinah,palaeontology,kirchberg,sculpin,rohtak,aquabats,oviparous,thynne,caney,blimps,minimalistic,whatcom,palatalization,bardstown,direct3d,paramagnetic,kamboja,khash,globemaster,lengua,matej,chernigov,swanage,arsenals,cascadia,cundinamarca,tusculum,leavers,organics,warplanes,'three,exertions,arminius,gandharva,inquires,comercio,kuopio,chabahar,plotlines,mersenne,anquetil,paralytic,buckminster,ambit,acrolophus,quantifiers,clacton,ciliary,ansaldo,fergana,egoism,thracians,chicoutimi,northbrook,analgesia,brotherhoods,hunza,adriaen,fluoridation,snowfalls,soundboard,fangoria,cannibalistic,orthogonius,chukotka,dindigul,manzoni,chainz,macromedia,beltline,muruga,schistura,provable,litex,initio,pneumoniae,infosys,cerium,boonton,cannonballs,d'une,solvency,mandurah,houthis,dolmens,apologists,radioisotopes,blaxploitation,poroshenko,stawell,coosa,maximilien,tempelhof,espouse,declaratory,hambro,xalapa,outmoded,mihiel,benefitting,desirous,archeparchy,repopulated,telescoping,captor,mackaye,disparaged,ramanathan,crowne,tumbled,technetium,silted,chedi,nievre,hyeon,cartoonish,interlock,infocom,rediff.com,dioramas,timekeeping,concertina,kutaisi,cesky,lubomirski,unapologetic,epigraphic,stalactites,sneha,biofilm,falconry,miraflores,catena,'outstanding,prospekt,apotheosis,o'odham,pacemakers,arabica,gandhinagar,reminisces,iroquoian,ornette,tilling,neoliberalism,chameleons,pandava,prefontaine,haiyan,gneisenau,utama,bando,reconstitution,azaria,canola,paratroops,ayckbourn,manistee,stourton,manifestos,lympne,denouement,tractatus,rakim,bellflower,nanometer,sassanids,turlough,presbyterianism,varmland,20deg,phool,nyerere,almohad,manipal,vlaanderen,quickness,removals,makow,circumflex,eatery,morane,fondazione,alkylation,unenforceable,galliano,silkworm,junior/senior,abducts,phlox,konskie,lofoten,buuren,glyphosate,faired,naturae,cobbles,taher,skrulls,dostoevsky,walkout,wagnerian,orbited,methodically,denzil,sarat,extraterritorial,kohima,d'armor,brinsley,rostropovich,fengtian,comitatus,aravind,moche,wrangell,giscard,vantaa,viljandi,hakoah,seabees,muscatine,ballade,camanachd,sothern,mullioned,durad,margraves,maven,arete,chandni,garifuna,142nd,reading/literature,thickest,intensifies,trygve,khaldun,perinatal,asana,powerline,acetylation,nureyev,omiya,montesquieu,riverwalk,marly,correlating,intermountain,bulgar,hammerheads,underscores,wiretapping,quatrain,ruisseau,newsagent,tuticorin,polygyny,hemsworth,partisanship,banna,istrian,evaporator".split(","),
  female_names: "mary,patricia,linda,barbara,elizabeth,jennifer,maria,susan,margaret,dorothy,lisa,nancy,karen,betty,helen,sandra,donna,carol,ruth,sharon,michelle,laura,sarah,kimberly,deborah,jessica,shirley,cynthia,angela,melissa,brenda,amy,anna,rebecca,virginia,kathleen,pamela,martha,debra,amanda,stephanie,carolyn,christine,marie,janet,catherine,frances,ann,joyce,diane,alice,julie,heather,teresa,doris,gloria,evelyn,jean,cheryl,mildred,katherine,joan,ashley,judith,rose,janice,kelly,nicole,judy,christina,kathy,theresa,beverly,denise,tammy,irene,jane,lori,rachel,marilyn,andrea,kathryn,louise,sara,anne,jacqueline,wanda,bonnie,julia,ruby,lois,tina,phyllis,norma,paula,diana,annie,lillian,emily,robin,peggy,crystal,gladys,rita,dawn,connie,florence,tracy,edna,tiffany,carmen,rosa,cindy,grace,wendy,victoria,edith,kim,sherry,sylvia,josephine,thelma,shannon,sheila,ethel,ellen,elaine,marjorie,carrie,charlotte,monica,esther,pauline,emma,juanita,anita,rhonda,hazel,amber,eva,debbie,april,leslie,clara,lucille,jamie,joanne,eleanor,valerie,danielle,megan,alicia,suzanne,michele,gail,bertha,darlene,veronica,jill,erin,geraldine,lauren,cathy,joann,lorraine,lynn,sally,regina,erica,beatrice,dolores,bernice,audrey,yvonne,annette,marion,dana,stacy,ana,renee,ida,vivian,roberta,holly,brittany,melanie,loretta,yolanda,jeanette,laurie,katie,kristen,vanessa,alma,sue,elsie,beth,jeanne,vicki,carla,tara,rosemary,eileen,terri,gertrude,lucy,tonya,ella,stacey,wilma,gina,kristin,jessie,natalie,agnes,vera,charlene,bessie,delores,melinda,pearl,arlene,maureen,colleen,allison,tamara,joy,georgia,constance,lillie,claudia,jackie,marcia,tanya,nellie,minnie,marlene,heidi,glenda,lydia,viola,courtney,marian,stella,caroline,dora,vickie,mattie,maxine,irma,mabel,marsha,myrtle,lena,christy,deanna,patsy,hilda,gwendolyn,jennie,nora,margie,nina,cassandra,leah,penny,kay,priscilla,naomi,carole,olga,billie,dianne,tracey,leona,jenny,felicia,sonia,miriam,velma,becky,bobbie,violet,kristina,toni,misty,mae,shelly,daisy,ramona,sherri,erika,katrina,claire,lindsey,lindsay,geneva,guadalupe,belinda,margarita,sheryl,cora,faye,ada,sabrina,isabel,marguerite,hattie,harriet,molly,cecilia,kristi,brandi,blanche,sandy,rosie,joanna,iris,eunice,angie,inez,lynda,madeline,amelia,alberta,genevieve,monique,jodi,janie,kayla,sonya,jan,kristine,candace,fannie,maryann,opal,alison,yvette,melody,luz,susie,olivia,flora,shelley,kristy,mamie,lula,lola,verna,beulah,antoinette,candice,juana,jeannette,pam,kelli,whitney,bridget,karla,celia,latoya,patty,shelia,gayle,della,vicky,lynne,sheri,marianne,kara,jacquelyn,erma,blanca,myra,leticia,pat,krista,roxanne,angelica,robyn,adrienne,rosalie,alexandra,brooke,bethany,sadie,bernadette,traci,jody,kendra,nichole,rachael,mable,ernestine,muriel,marcella,elena,krystal,angelina,nadine,kari,estelle,dianna,paulette,lora,mona,doreen,rosemarie,desiree,antonia,janis,betsy,christie,freda,meredith,lynette,teri,cristina,eula,leigh,meghan,sophia,eloise,rochelle,gretchen,cecelia,raquel,henrietta,alyssa,jana,gwen,jenna,tricia,laverne,olive,tasha,silvia,elvira,delia,kate,patti,lorena,kellie,sonja,lila,lana,darla,mindy,essie,mandy,lorene,elsa,josefina,jeannie,miranda,dixie,lucia,marta,faith,lela,johanna,shari,camille,tami,shawna,elisa,ebony,melba,ora,nettie,tabitha,ollie,winifred,kristie,alisha,aimee,rena,myrna,marla,tammie,latasha,bonita,patrice,ronda,sherrie,addie,francine,deloris,stacie,adriana,cheri,abigail,celeste,jewel,cara,adele,rebekah,lucinda,dorthy,effie,trina,reba,sallie,aurora,lenora,etta,lottie,kerri,trisha,nikki,estella,francisca,josie,tracie,marissa,karin,brittney,janelle,lourdes,laurel,helene,fern,elva,corinne,kelsey,ina,bettie,elisabeth,aida,caitlin,ingrid,iva,eugenia,christa,goldie,maude,jenifer,therese,dena,lorna,janette,latonya,candy,consuelo,tamika,rosetta,debora,cherie,polly,dina,jewell,fay,jillian,dorothea,nell,trudy,esperanza,patrica,kimberley,shanna,helena,cleo,stefanie,rosario,ola,janine,mollie,lupe,alisa,lou,maribel,susanne,bette,susana,elise,cecile,isabelle,lesley,jocelyn,paige,joni,rachelle,leola,daphne,alta,ester,petra,graciela,imogene,jolene,keisha,lacey,glenna,gabriela,keri,ursula,lizzie,kirsten,shana,adeline,mayra,jayne,jaclyn,gracie,sondra,carmela,marisa,rosalind,charity,tonia,beatriz,marisol,clarice,jeanine,sheena,angeline,frieda,lily,shauna,millie,claudette,cathleen,angelia,gabrielle,autumn,katharine,jodie,staci,lea,christi,justine,elma,luella,margret,dominique,socorro,martina,margo,mavis,callie,bobbi,maritza,lucile,leanne,jeannine,deana,aileen,lorie,ladonna,willa,manuela,gale,selma,dolly,sybil,abby,ivy,dee,winnie,marcy,luisa,jeri,magdalena,ofelia,meagan,audra,matilda,leila,cornelia,bianca,simone,bettye,randi,virgie,latisha,barbra,georgina,eliza,leann,bridgette,rhoda,haley,adela,nola,bernadine,flossie,ila,greta,ruthie,nelda,minerva,lilly,terrie,letha,hilary,estela,valarie,brianna,rosalyn,earline,catalina,ava,mia,clarissa,lidia,corrine,alexandria,concepcion,tia,sharron,rae,dona,ericka,jami,elnora,chandra,lenore,neva,marylou,melisa,tabatha,serena,avis,allie,sofia,jeanie,odessa,nannie,harriett,loraine,penelope,milagros,emilia,benita,allyson,ashlee,tania,esmeralda,eve,pearlie,zelma,malinda,noreen,tameka,saundra,hillary,amie,althea,rosalinda,lilia,alana,clare,alejandra,elinor,lorrie,jerri,darcy,earnestine,carmella,noemi,marcie,liza,annabelle,louisa,earlene,mallory,carlene,nita,selena,tanisha,katy,julianne,lakisha,edwina,maricela,margery,kenya,dollie,roxie,roslyn,kathrine,nanette,charmaine,lavonne,ilene,tammi,suzette,corine,kaye,chrystal,lina,deanne,lilian,juliana,aline,luann,kasey,maryanne,evangeline,colette,melva,lawanda,yesenia,nadia,madge,kathie,ophelia,valeria,nona,mitzi,mari,georgette,claudine,fran,alissa,roseann,lakeisha,susanna,reva,deidre,chasity,sheree,elvia,alyce,deirdre,gena,briana,araceli,katelyn,rosanne,wendi,tessa,berta,marva,imelda,marietta,marci,leonor,arline,sasha,madelyn,janna,juliette,deena,aurelia,josefa,augusta,liliana,lessie,amalia,savannah,anastasia,vilma,natalia,rosella,lynnette,corina,alfreda,leanna,amparo,coleen,tamra,aisha,wilda,karyn,maura,mai,evangelina,rosanna,hallie,erna,enid,mariana,lacy,juliet,jacklyn,freida,madeleine,mara,cathryn,lelia,casandra,bridgett,angelita,jannie,dionne,annmarie,katina,beryl,millicent,katheryn,diann,carissa,maryellen,liz,lauri,helga,gilda,rhea,marquita,hollie,tisha,tamera,angelique,francesca,kaitlin,lolita,florine,rowena,reyna,twila,fanny,janell,ines,concetta,bertie,alba,brigitte,alyson,vonda,pansy,elba,noelle,letitia,deann,brandie,louella,leta,felecia,sharlene,lesa,beverley,isabella,herminia,terra,celina,tori,octavia,jade,denice,germaine,michell,cortney,nelly,doretha,deidra,monika,lashonda,judi,chelsey,antionette,margot,adelaide,leeann,elisha,dessie,libby,kathi,gayla,latanya,mina,mellisa,kimberlee,jasmin,renae,zelda,elda,justina,gussie,emilie,camilla,abbie,rocio,kaitlyn,edythe,ashleigh,selina,lakesha,geri,allene,pamala,michaela,dayna,caryn,rosalia,jacquline,rebeca,marybeth,krystle,iola,dottie,belle,griselda,ernestina,elida,adrianne,demetria,delma,jaqueline,arleen,virgina,retha,fatima,tillie,eleanore,cari,treva,wilhelmina,rosalee,maurine,latrice,jena,taryn,elia,debby,maudie,jeanna,delilah,catrina,shonda,hortencia,theodora,teresita,robbin,danette,delphine,brianne,nilda,danna,cindi,bess,iona,winona,vida,rosita,marianna,racheal,guillermina,eloisa,celestine,caren,malissa,lona,chantel,shellie,marisela,leora,agatha,soledad,migdalia,ivette,christen,athena,janel,veda,pattie,tessie,tera,marilynn,lucretia,karrie,dinah,daniela,alecia,adelina,vernice,shiela,portia,merry,lashawn,dara,tawana,verda,alene,zella,sandi,rafaela,maya,kira,candida,alvina,suzan,shayla,lettie,samatha,oralia,matilde,larissa,vesta,renita,delois,shanda,phillis,lorri,erlinda,cathrine,barb,isabell,ione,gisela,roxanna,mayme,kisha,ellie,mellissa,dorris,dalia,bella,annetta,zoila,reta,reina,lauretta,kylie,christal,pilar,charla,elissa,tiffani,tana,paulina,leota,breanna,jayme,carmel,vernell,tomasa,mandi,dominga,santa,melodie,lura,alexa,tamela,mirna,kerrie,venus,felicita,cristy,carmelita,berniece,annemarie,tiara,roseanne,missy,cori,roxana,pricilla,kristal,jung,elyse,haydee,aletha,bettina,marge,gillian,filomena,zenaida,harriette,caridad,vada,aretha,pearline,marjory,marcela,flor,evette,elouise,alina,damaris,catharine,belva,nakia,marlena,luanne,lorine,karon,dorene,danita,brenna,tatiana,louann,julianna,andria,philomena,lucila,leonora,dovie,romona,mimi,jacquelin,gaye,tonja,misti,chastity,stacia,roxann,micaela,velda,marlys,johnna,aura,ivonne,hayley,nicki,majorie,herlinda,yadira,perla,gregoria,antonette,shelli,mozelle,mariah,joelle,cordelia,josette,chiquita,trista,laquita,georgiana,candi,shanon,hildegard,stephany,magda,karol,gabriella,tiana,roma,richelle,oleta,jacque,idella,alaina,suzanna,jovita,tosha,nereida,marlyn,kyla,delfina,tena,stephenie,sabina,nathalie,marcelle,gertie,darleen,thea,sharonda,shantel,belen,venessa,rosalina,genoveva,clementine,rosalba,renate,renata,georgianna,floy,dorcas,ariana,tyra,theda,mariam,juli,jesica,vikki,verla,roselyn,melvina,jannette,ginny,debrah,corrie,violeta,myrtis,latricia,collette,charleen,anissa,viviana,twyla,nedra,latonia,hellen,fabiola,annamarie,adell,sharyn,chantal,niki,maud,lizette,lindy,kesha,jeana,danelle,charline,chanel,valorie,dortha,cristal,sunny,leone,leilani,gerri,debi,andra,keshia,eulalia,easter,dulce,natividad,linnie,kami,georgie,catina,brook,alda,winnifred,sharla,ruthann,meaghan,magdalene,lissette,adelaida,venita,trena,shirlene,shameka,elizebeth,dian,shanta,latosha,carlotta,windy,rosina,mariann,leisa,jonnie,dawna,cathie,astrid,laureen,janeen,holli,fawn,vickey,teressa,shante,rubye,marcelina,chanda,terese,scarlett,marnie,lulu,lisette,jeniffer,elenor,dorinda,donita,carman,bernita,altagracia,aleta,adrianna,zoraida,lyndsey,janina,starla,phylis,phuong,kyra,charisse,blanch,sanjuanita,rona,nanci,marilee,maranda,brigette,sanjuana,marita,kassandra,joycelyn,felipa,chelsie,bonny,mireya,lorenza,kyong,ileana,candelaria,sherie,lucie,leatrice,lakeshia,gerda,edie,bambi,marylin,lavon,hortense,garnet,evie,tressa,shayna,lavina,kyung,jeanetta,sherrill,shara,phyliss,mittie,anabel,alesia,thuy,tawanda,joanie,tiffanie,lashanda,karissa,enriqueta,daria,daniella,corinna,alanna,abbey,roxane,roseanna,magnolia,lida,joellen,coral,carleen,tresa,peggie,novella,nila,maybelle,jenelle,carina,nova,melina,marquerite,margarette,josephina,evonne,cinthia,albina,toya,tawnya,sherita,myriam,lizabeth,lise,keely,jenni,giselle,cheryle,ardith,ardis,alesha,adriane,shaina,linnea,karolyn,felisha,dori,darci,artie,armida,zola,xiomara,vergie,shamika,nena,nannette,maxie,lovie,jeane,jaimie,inge,farrah,elaina,caitlyn,felicitas,cherly,caryl,yolonda,yasmin,teena,prudence,pennie,nydia,mackenzie,orpha,marvel,lizbeth,laurette,jerrie,hermelinda,carolee,tierra,mirian,meta,melony,kori,jennette,jamila,yoshiko,susannah,salina,rhiannon,joleen,cristine,ashton,aracely,tomeka,shalonda,marti,lacie,kala,jada,ilse,hailey,brittani,zona,syble,sherryl,nidia,marlo,kandice,kandi,alycia,ronna,norene,mercy,ingeborg,giovanna,gemma,christel,audry,zora,vita,trish,stephaine,shirlee,shanika,melonie,mazie,jazmin,inga,hettie,geralyn,fonda,estrella,adella,sarita,rina,milissa,maribeth,golda,evon,ethelyn,enedina,cherise,chana,velva,tawanna,sade,mirta,karie,jacinta,elna,davina,cierra,ashlie,albertha,tanesha,nelle,mindi,lorinda,larue,florene,demetra,dedra,ciara,chantelle,ashly,suzy,rosalva,noelia,lyda,leatha,krystyna,kristan,karri,darline,darcie,cinda,cherrie,awilda,almeda,rolanda,lanette,jerilyn,gisele,evalyn,cyndi,cleta,carin,zina,zena,velia,tanika,charissa,talia,margarete,lavonda,kaylee,kathlene,jonna,irena,ilona,idalia,candis,candance,brandee,anitra,alida,sigrid,nicolette,maryjo,linette,hedwig,christiana,alexia,tressie,modesta,lupita,lita,gladis,evelia,davida,cherri,cecily,ashely,annabel,agustina,wanita,shirly,rosaura,hulda,yetta,verona,thomasina,sibyl,shannan,mechelle,leandra,lani,kylee,kandy,jolynn,ferne,eboni,corene,alysia,zula,nada,moira,lyndsay,lorretta,jammie,hortensia,gaynell,adria,vina,vicenta,tangela,stephine,norine,nella,liana,leslee,kimberely,iliana,glory,felica,emogene,elfriede,eden,eartha,carma,ocie,lennie,kiara,jacalyn,carlota,arielle,otilia,kirstin,kacey,johnetta,joetta,jeraldine,jaunita,elana,dorthea,cami,amada,adelia,vernita,tamar,siobhan,renea,rashida,ouida,nilsa,meryl,kristyn,julieta,danica,breanne,aurea,anglea,sherron,odette,malia,lorelei,leesa,kenna,kathlyn,fiona,charlette,suzie,shantell,sabra,racquel,myong,mira,martine,lucienne,lavada,juliann,elvera,delphia,christiane,charolette,carri,asha,angella,paola,ninfa,leda,stefani,shanell,palma,machelle,lissa,kecia,kathryne,karlene,julissa,jettie,jenniffer,corrina,carolann,alena,rosaria,myrtice,marylee,liane,kenyatta,judie,janey,elmira,eldora,denna,cristi,cathi,zaida,vonnie,viva,vernie,rosaline,mariela,luciana,lesli,karan,felice,deneen,adina,wynona,tarsha,sheron,shanita,shani,shandra,randa,pinkie,nelida,marilou,lyla,laurene,laci,janene,dorotha,daniele,dani,carolynn,carlyn,berenice,ayesha,anneliese,alethea,thersa,tamiko,rufina,oliva,mozell,marylyn,kristian,kathyrn,kasandra,kandace,janae,domenica,debbra,dannielle,chun,arcelia,zenobia,sharen,sharee,lavinia,kacie,jackeline,huong,felisa,emelia,eleanora,cythia,cristin,claribel,anastacia,zulma,zandra,yoko,tenisha,susann,sherilyn,shay,shawanda,romana,mathilda,linsey,keiko,joana,isela,gretta,georgetta,eugenie,desirae,delora,corazon,antonina,anika,willene,tracee,tamatha,nichelle,mickie,maegan,luana,lanita,kelsie,edelmira,bree,afton,teodora,tamie,shena,linh,keli,kaci,danyelle,arlette,albertine,adelle,tiffiny,simona,nicolasa,nichol,nakisha,maira,loreen,kizzy,fallon,christene,bobbye,ying,vincenza,tanja,rubie,roni,queenie,margarett,kimberli,irmgard,idell,hilma,evelina,esta,emilee,dennise,dania,carie,risa,rikki,particia,masako,luvenia,loree,loni,lien,gigi,florencia,denita,billye,tomika,sharita,rana,nikole,neoma,margarite,madalyn,lucina,laila,kali,jenette,gabriele,evelyne,elenora,clementina,alejandrina,zulema,violette,vannessa,thresa,retta,patience,noella,nickie,jonell,chaya,camelia,bethel,anya,suzann,mila,lilla,laverna,keesha,kattie,georgene,eveline,estell,elizbeth,vivienne,vallie,trudie,stephane,magaly,madie,kenyetta,karren,janetta,hermine,drucilla,debbi,celestina,candie,britni,beckie,amina,zita,yolande,vivien,vernetta,trudi,pearle,patrina,ossie,nicolle,loyce,letty,katharina,joselyn,jonelle,jenell,iesha,heide,florinda,florentina,elodia,dorine,brunilda,brigid,ashli,ardella,twana,tarah,shavon,serina,rayna,ramonita,margurite,lucrecia,kourtney,kati,jesenia,crista,ayana,alica,alia,vinnie,suellen,romelia,rachell,olympia,michiko,kathaleen,jolie,jessi,janessa,hana,elease,carletta,britany,shona,salome,rosamond,regena,raina,ngoc,nelia,louvenia,lesia,latrina,laticia,larhonda,jina,jacki,emmy,deeann,coretta,arnetta,thalia,shanice,neta,mikki,micki,lonna,leana,lashunda,kiley,joye,jacqulyn,ignacia,hyun,hiroko,henriette,elayne,delinda,dahlia,coreen,consuela,conchita,babette,ayanna,anette,albertina,shawnee,shaneka,quiana,pamelia,merri,merlene,margit,kiesha,kiera,kaylene,jodee,jenise,erlene,emmie,dalila,daisey,casie,belia,babara,versie,vanesa,shelba,shawnda,nikia,naoma,marna,margeret,madaline,lawana,kindra,jutta,jazmine,janett,hannelore,glendora,gertrud,garnett,freeda,frederica,florance,flavia,carline,beverlee,anjanette,valda,tamala,shonna,sarina,oneida,merilyn,marleen,lurline,lenna,katherin,jeni,gracia,glady,farah,enola,dominque,devona,delana,cecila,caprice,alysha,alethia,vena,theresia,tawny,shakira,samara,sachiko,rachele,pamella,marni,mariel,maren,malisa,ligia,lera,latoria,larae,kimber,kathern,karey,jennefer,janeth,halina,fredia,delisa,debroah,ciera,angelika,andree,altha,vivan,terresa,tanna,sudie,signe,salena,ronni,rebbecca,myrtie,malika,maida,leonarda,kayleigh,ethyl,ellyn,dayle,cammie,brittni,birgit,avelina,asuncion,arianna,akiko,venice,tyesha,tonie,tiesha,takisha,steffanie,sindy,meghann,manda,macie,kellye,kellee,joslyn,inger,indira,glinda,glennis,fernanda,faustina,eneida,elicia,digna,dell,arletta,willia,tammara,tabetha,sherrell,sari,rebbeca,pauletta,natosha,nakita,mammie,kenisha,kazuko,kassie,earlean,daphine,corliss,clotilde,carolyne,bernetta,augustina,audrea,annis,annabell,tennille,tamica,selene,rosana,regenia,qiana,markita,macy,leeanne,laurine,jessenia,janita,georgine,genie,emiko,elvie,deandra,dagmar,corie,collen,cherish,romaine,porsha,pearlene,micheline,merna,margorie,margaretta,lore,jenine,hermina,fredericka,elke,drusilla,dorathy,dione,celena,brigida,allegra,tamekia,synthia,sook,slyvia,rosann,reatha,raye,marquetta,margart,ling,layla,kymberly,kiana,kayleen,katlyn,karmen,joella,emelda,eleni,detra,clemmie,cheryll,chantell,cathey,arnita,arla,angle,angelic,alyse,zofia,thomasine,tennie,sherly,sherley,sharyl,remedios,petrina,nickole,myung,myrle,mozella,louanne,lisha,latia,krysta,julienne,jeanene,jacqualine,isaura,gwenda,earleen,cleopatra,carlie,audie,antonietta,alise,verdell,tomoko,thao,talisha,shemika,savanna,santina,rosia,raeann,odilia,nana,minna,magan,lynelle,karma,joeann,ivana,inell,ilana,gudrun,dreama,crissy,chante,carmelina,arvilla,annamae,alvera,aleida,yanira,vanda,tianna,stefania,shira,nicol,nancie,monserrate,melynda,melany,lovella,laure,kacy,jacquelynn,hyon,gertha,eliana,christena,christeen,charise,caterina,carley,candyce,arlena,ammie,willette,vanita,tuyet,syreeta,penney,nyla,maryam,marya,magen,ludie,loma,livia,lanell,kimberlie,julee,donetta,diedra,denisha,deane,dawne,clarine,cherryl,bronwyn,alla,valery,tonda,sueann,soraya,shoshana,shela,sharleen,shanelle,nerissa,meridith,mellie,maye,maple,magaret,lili,leonila,leonie,leeanna,lavonia,lavera,kristel,kathey,kathe,jann,ilda,hildred,hildegarde,genia,fumiko,evelin,ermelinda,elly,dung,doloris,dionna,danae,berneice,annice,alix,verena,verdie,shawnna,shawana,shaunna,rozella,randee,ranae,milagro,lynell,luise,loida,lisbeth,karleen,junita,jona,isis,hyacinth,hedy,gwenn,ethelene,erline,donya,domonique,delicia,dannette,cicely,branda,blythe,bethann,ashlyn,annalee,alline,yuko,vella,trang,towanda,tesha,sherlyn,narcisa,miguelina,meri,maybell,marlana,marguerita,madlyn,lory,loriann,leonore,leighann,laurice,latesha,laronda,katrice,kasie,kaley,jadwiga,glennie,gearldine,francina,epifania,dyan,dorie,diedre,denese,demetrice,delena,cristie,cleora,catarina,carisa,barbera,almeta,trula,tereasa,solange,sheilah,shavonne,sanora,rochell,mathilde,margareta,maia,lynsey,lawanna,launa,kena,keena,katia,glynda,gaylene,elvina,elanor,danuta,danika,cristen,cordie,coletta,clarita,carmon,brynn,azucena,aundrea,angele,verlie,verlene,tamesha,silvana,sebrina,samira,reda,raylene,penni,norah,noma,mireille,melissia,maryalice,laraine,kimbery,karyl,karine,jolanda,johana,jesusa,jaleesa,jacquelyne,iluminada,hilaria,hanh,gennie,francie,floretta,exie,edda,drema,delpha,barbar,assunta,ardell,annalisa,alisia,yukiko,yolando,wonda,waltraud,veta,temeka,tameika,shirleen,shenita,piedad,ozella,mirtha,marilu,kimiko,juliane,jenice,janay,jacquiline,hilde,elois,echo,devorah,chau,brinda,betsey,arminda,aracelis,apryl,annett,alishia,veola,usha,toshiko,theola,tashia,talitha,shery,renetta,reiko,rasheeda,obdulia,mika,melaine,meggan,marlen,marget,marceline,mana,magdalen,librada,lezlie,latashia,lasandra,kelle,isidra,inocencia,gwyn,francoise,erminia,erinn,dimple,devora,criselda,armanda,arie,ariane,angelena,aliza,adriene,adaline,xochitl,twanna,tomiko,tamisha,taisha,susy,rutha,rhona,noriko,natashia,merrie,marinda,mariko,margert,loris,lizzette,leisha,kaila,joannie,jerrica,jene,jannet,janee,jacinda,herta,elenore,doretta,delaine,daniell,claudie,britta,apolonia,amberly,alease,yuri,waneta,tomi,sharri,sandie,roselle,reynalda,raguel,phylicia,patria,olimpia,odelia,mitzie,minda,mignon,mica,mendy,marivel,maile,lynetta,lavette,lauryn,latrisha,lakiesha,kiersten,kary,josphine,jolyn,jetta,janise,jacquie,ivelisse,glynis,gianna,gaynelle,danyell,danille,dacia,coralee,cher,ceola,arianne,aleshia,yung,williemae,trinh,thora,sherika,shemeka,shaunda,roseline,ricki,melda,mallie,lavonna,latina,laquanda,lala,lachelle,klara,kandis,johna,jeanmarie,jaye,grayce,gertude,emerita,ebonie,clorinda,ching,chery,carola,breann,blossom,bernardine,becki,arletha,argelia,alita,yulanda,yessenia,tobi,tasia,sylvie,shirl,shirely,shella,shantelle,sacha,rebecka,providencia,paulene,misha,miki,marline,marica,lorita,latoyia,lasonya,kerstin,kenda,keitha,kathrin,jaymie,gricelda,ginette,eryn,elina,elfrieda,danyel,cheree,chanelle,barrie,aurore,annamaria,alleen,ailene,aide,yasmine,vashti,treasa,tiffaney,sheryll,sharie,shanae,raisa,neda,mitsuko,mirella,milda,maryanna,maragret,mabelle,luetta,lorina,letisha,latarsha,lanelle,lajuana,krissy,karly,karena,jessika,jerica,jeanelle,jalisa,jacelyn,izola,euna,etha,domitila,dominica,daina,creola,carli,camie,brittny,ashanti,anisha,aleen,adah,yasuko,valrie,tona,tinisha,terisa,taneka,simonne,shalanda,serita,ressie,refugia,olene,margherita,mandie,maire,lyndia,luci,lorriane,loreta,leonia,lavona,lashawnda,lakia,kyoko,krystina,krysten,kenia,kelsi,jeanice,isobel,georgiann,genny,felicidad,eilene,deloise,deedee,conception,clora,cherilyn,calandra,armandina,anisa,tiera,theressa,stephania,sima,shyla,shonta,shera,shaquita,shala,rossana,nohemi,nery,moriah,melita,melida,melani,marylynn,marisha,mariette,malorie,madelene,ludivina,loria,lorette,loralee,lianne,lavenia,laurinda,lashon,kimi,keila,katelynn,jone,joane,jayna,janella,hertha,francene,elinore,despina,delsie,deedra,clemencia,carolin,bulah,brittanie,blondell,bibi,beaulah,beata,annita,agripina,virgen,valene,twanda,tommye,tarra,tari,tammera,shakia,sadye,ruthanne,rochel,rivka,pura,nenita,natisha,ming,merrilee,melodee,marvis,lucilla,leena,laveta,larita,lanie,keren,ileen,georgeann,genna,frida,eufemia,emely,edyth,deonna,deadra,darlena,chanell,cathern,cassondra,cassaundra,bernarda,berna,arlinda,anamaria,vertie,valeri,torri,stasia,sherise,sherill,sanda,ruthe,rosy,robbi,ranee,quyen,pearly,palmira,onita,nisha,niesha,nida,merlyn,mayola,marylouise,marth,margene,madelaine,londa,leontine,leoma,leia,lauralee,lanora,lakita,kiyoko,keturah,katelin,kareen,jonie,johnette,jenee,jeanett,izetta,hiedi,heike,hassie,giuseppina,georgann,fidela,fernande,elwanda,ellamae,eliz,dusti,dotty,cyndy,coralie,celesta,alverta,xenia,wava,vanetta,torrie,tashina,tandy,tambra,tama,stepanie,shila,shaunta,sharan,shaniqua,shae,setsuko,serafina,sandee,rosamaria,priscila,olinda,nadene,muoi,michelina,mercedez,maryrose,marcene,magali,mafalda,lannie,kayce,karoline,kamilah,kamala,justa,joline,jennine,jacquetta,iraida,georgeanna,franchesca,emeline,elane,ehtel,earlie,dulcie,dalene,classie,chere,charis,caroyln,carmina,carita,bethanie,ayako,arica,alysa,alessandra,akilah,adrien,zetta,youlanda,yelena,yahaira,xuan,wendolyn,tijuana,terina,teresia,suzi,sherell,shavonda,shaunte,sharda,shakita,sena,ryann,rubi,riva,reginia,rachal,parthenia,pamula,monnie,monet,michaele,melia,malka,maisha,lisandra,lekisha,lean,lakendra,krystin,kortney,kizzie,kittie,kera,kendal,kemberly,kanisha,julene,jule,johanne,jamee,halley,gidget,fredricka,fleta,fatimah,eusebia,elza,eleonore,dorthey,doria,donella,dinorah,delorse,claretha,christinia,charlyn,bong,belkis,azzie,andera,aiko,adena,yajaira,vania,ulrike,toshia,tifany,stefany,shizue,shenika,shawanna,sharolyn,sharilyn,shaquana,shantay,rozanne,roselee,remona,reanna,raelene,phung,petronila,natacha,nancey,myrl,miyoko,miesha,merideth,marvella,marquitta,marhta,marchelle,lizeth,libbie,lahoma,ladawn,kina,katheleen,katharyn,karisa,kaleigh,junie,julieann,johnsie,janean,jaimee,jackqueline,hisako,herma,helaine,gwyneth,gita,eustolia,emelina,elin,edris,donnette,donnetta,dierdre,denae,darcel,clarisa,cinderella,chia,charlesetta,charita,celsa,cassy,cassi,carlee,bruna,brittaney,brande,billi,antonetta,angla,angelyn,analisa,alane,wenona,wendie,veronique,vannesa,tobie,tempie,sumiko,sulema,somer,sheba,sharice,shanel,shalon,rosio,roselia,renay,rema,reena,ozie,oretha,oralee,ngan,nakesha,milly,marybelle,margrett,maragaret,manie,lurlene,lillia,lieselotte,lavelle,lashaunda,lakeesha,kaycee,kalyn,joya,joette,jenae,janiece,illa,grisel,glayds,genevie,gala,fredda,eleonor,debera,deandrea,corrinne,cordia,contessa,colene,cleotilde,chantay,cecille,beatris,azalee,arlean,ardath,anjelica,anja,alfredia,aleisha,zada,yuonne,xiao,willodean,vennie,vanna,tyisha,tova,torie,tonisha,tilda,tien,sirena,sherril,shanti,shan,senaida,samella,robbyn,renda,reita,phebe,paulita,nobuko,nguyet,neomi,mikaela,melania,maximina,marg,maisie,lynna,lilli,lashaun,lakenya,lael,kirstie,kathline,kasha,karlyn,karima,jovan,josefine,jennell,jacqui,jackelyn,hien,grazyna,florrie,floria,eleonora,dwana,dorla,delmy,deja,dede,dann,crysta,clelia,claris,chieko,cherlyn,cherelle,charmain,chara,cammy,arnette,ardelle,annika,amiee,amee,allena,yvone,yuki,yoshie,yevette,yael,willetta,voncile,venetta,tula,tonette,timika,temika,telma,teisha,taren,stacee,shawnta,saturnina,ricarda,pasty,onie,nubia,marielle,mariella,marianela,mardell,luanna,loise,lisabeth,lindsy,lilliana,lilliam,lelah,leigha,leanora,kristeen,khalilah,keeley,kandra,junko,joaquina,jerlene,jani,jamika,hsiu,hermila,genevive,evia,eugena,emmaline,elfreda,elene,donette,delcie,deeanna,darcey,clarinda,cira,chae,celinda,catheryn,casimira,carmelia,camellia,breana,bobette,bernardina,bebe,basilia,arlyne,amal,alayna,zonia,zenia,yuriko,yaeko,wynell,willena,vernia,tora,terrilyn,terica,tenesha,tawna,tajuana,taina,stephnie,sona,sina,shondra,shizuko,sherlene,sherice,sharika,rossie,rosena,rima,rheba,renna,natalya,nancee,melodi,meda,matha,marketta,maricruz,marcelene,malvina,luba,louetta,leida,lecia,lauran,lashawna,laine,khadijah,katerine,kasi,kallie,julietta,jesusita,jestine,jessia,jeffie,janyce,isadora,georgianne,fidelia,evita,eura,eulah,estefana,elsy,eladia,dodie,denisse,deloras,delila,daysi,crystle,concha,claretta,charlsie,charlena,carylon,bettyann,asley,ashlea,amira,agueda,agnus,yuette,vinita,victorina,tynisha,treena,toccara,tish,thomasena,tegan,soila,shenna,sharmaine,shantae,shandi,saran,sarai,sana,rosette,rolande,regine,otelia,olevia,nicholle,necole,naida,myrta,myesha,mitsue,minta,mertie,margy,mahalia,madalene,loura,lorean,lesha,leonida,lenita,lavone,lashell,lashandra,lamonica,kimbra,katherina,karry,kanesha,jong,jeneva,jaquelyn,gilma,ghislaine,gertrudis,fransisca,fermina,ettie,etsuko,ellan,elidia,edra,dorethea,doreatha,denyse,deetta,daine,cyrstal,corrin,cayla,carlita,camila,burma,bula,buena,barabara,avril,alaine,zana,wilhemina,wanetta,verline,vasiliki,tonita,tisa,teofila,tayna,taunya,tandra,takako,sunni,suanne,sixta,sharell,seema,rosenda,robena,raymonde,pamila,ozell,neida,mistie,micha,merissa,maurita,maryln,maryetta,marcell,malena,makeda,lovetta,lourie,lorrine,lorilee,laurena,lashay,larraine,laree,lacresha,kristle,keva,keira,karole,joie,jinny,jeannetta,jama,heidy,gilberte,gema,faviola,evelynn,enda,elli,ellena,divina,dagny,collene,codi,cindie,chassidy,chasidy,catrice,catherina,cassey,caroll,carlena,candra,calista,bryanna,britteny,beula,bari,audrie,audria,ardelia,annelle,angila,alona,allyn".split(","),
  surnames: "smith,johnson,williams,jones,brown,davis,miller,wilson,moore,taylor,anderson,jackson,white,harris,martin,thompson,garcia,martinez,robinson,clark,rodriguez,lewis,lee,walker,hall,allen,young,hernandez,king,wright,lopez,hill,green,adams,baker,gonzalez,nelson,carter,mitchell,perez,roberts,turner,phillips,campbell,parker,evans,edwards,collins,stewart,sanchez,morris,rogers,reed,cook,morgan,bell,murphy,bailey,rivera,cooper,richardson,cox,howard,ward,torres,peterson,gray,ramirez,watson,brooks,sanders,price,bennett,wood,barnes,ross,henderson,coleman,jenkins,perry,powell,long,patterson,hughes,flores,washington,butler,simmons,foster,gonzales,bryant,alexander,griffin,diaz,hayes,myers,ford,hamilton,graham,sullivan,wallace,woods,cole,west,owens,reynolds,fisher,ellis,harrison,gibson,mcdonald,cruz,marshall,ortiz,gomez,murray,freeman,wells,webb,simpson,stevens,tucker,porter,hicks,crawford,boyd,mason,morales,kennedy,warren,dixon,ramos,reyes,burns,gordon,shaw,holmes,rice,robertson,hunt,black,daniels,palmer,mills,nichols,grant,knight,ferguson,stone,hawkins,dunn,perkins,hudson,spencer,gardner,stephens,payne,pierce,berry,matthews,arnold,wagner,willis,watkins,olson,carroll,duncan,snyder,hart,cunningham,lane,andrews,ruiz,harper,fox,riley,armstrong,carpenter,weaver,greene,elliott,chavez,sims,peters,kelley,franklin,lawson,fields,gutierrez,schmidt,carr,vasquez,castillo,wheeler,chapman,montgomery,richards,williamson,johnston,banks,meyer,bishop,mccoy,howell,alvarez,morrison,hansen,fernandez,garza,harvey,burton,nguyen,jacobs,reid,fuller,lynch,garrett,romero,welch,larson,frazier,burke,hanson,mendoza,moreno,bowman,medina,fowler,brewer,hoffman,carlson,silva,pearson,holland,fleming,jensen,vargas,byrd,davidson,hopkins,herrera,wade,soto,walters,neal,caldwell,lowe,jennings,barnett,graves,jimenez,horton,shelton,barrett,obrien,castro,sutton,mckinney,lucas,miles,rodriquez,chambers,holt,lambert,fletcher,watts,bates,hale,rhodes,pena,beck,newman,haynes,mcdaniel,mendez,bush,vaughn,parks,dawson,santiago,norris,hardy,steele,curry,powers,schultz,barker,guzman,page,munoz,ball,keller,chandler,weber,walsh,lyons,ramsey,wolfe,schneider,mullins,benson,sharp,bowen,barber,cummings,hines,baldwin,griffith,valdez,hubbard,salazar,reeves,warner,stevenson,burgess,santos,tate,cross,garner,mann,mack,moss,thornton,mcgee,farmer,delgado,aguilar,vega,glover,manning,cohen,harmon,rodgers,robbins,newton,blair,higgins,ingram,reese,cannon,strickland,townsend,potter,goodwin,walton,rowe,hampton,ortega,patton,swanson,goodman,maldonado,yates,becker,erickson,hodges,rios,conner,adkins,webster,malone,hammond,flowers,cobb,moody,quinn,pope,osborne,mccarthy,guerrero,estrada,sandoval,gibbs,gross,fitzgerald,stokes,doyle,saunders,wise,colon,gill,alvarado,greer,padilla,waters,nunez,ballard,schwartz,mcbride,houston,christensen,klein,pratt,briggs,parsons,mclaughlin,zimmerman,buchanan,moran,copeland,pittman,brady,mccormick,holloway,brock,poole,logan,bass,marsh,drake,wong,jefferson,morton,abbott,sparks,norton,huff,massey,figueroa,carson,bowers,roberson,barton,tran,lamb,harrington,boone,cortez,clarke,mathis,singleton,wilkins,cain,underwood,hogan,mckenzie,collier,luna,phelps,mcguire,bridges,wilkerson,nash,summers,atkins,wilcox,pitts,conley,marquez,burnett,cochran,chase,davenport,hood,gates,ayala,sawyer,vazquez,dickerson,hodge,acosta,flynn,espinoza,nicholson,monroe,wolf,morrow,whitaker,oconnor,skinner,ware,molina,kirby,huffman,gilmore,dominguez,oneal,lang,combs,kramer,hancock,gallagher,gaines,shaffer,wiggins,mathews,mcclain,fischer,wall,melton,hensley,bond,dyer,grimes,contreras,wyatt,baxter,snow,mosley,shepherd,larsen,hoover,beasley,petersen,whitehead,meyers,garrison,shields,horn,savage,olsen,schroeder,hartman,woodard,mueller,kemp,deleon,booth,patel,calhoun,wiley,eaton,cline,navarro,harrell,humphrey,parrish,duran,hutchinson,hess,dorsey,bullock,robles,beard,dalton,avila,rich,blackwell,johns,blankenship,trevino,salinas,campos,pruitt,callahan,montoya,hardin,guerra,mcdowell,stafford,gallegos,henson,wilkinson,booker,merritt,atkinson,orr,decker,hobbs,tanner,knox,pacheco,stephenson,glass,rojas,serrano,marks,hickman,sweeney,strong,mcclure,conway,roth,maynard,farrell,lowery,hurst,nixon,weiss,trujillo,ellison,sloan,juarez,winters,mclean,boyer,villarreal,mccall,gentry,carrillo,ayers,lara,sexton,pace,hull,leblanc,browning,velasquez,leach,chang,sellers,herring,noble,foley,bartlett,mercado,landry,durham,walls,barr,mckee,bauer,rivers,bradshaw,pugh,velez,rush,estes,dodson,morse,sheppard,weeks,camacho,bean,barron,livingston,middleton,spears,branch,blevins,chen,kerr,mcconnell,hatfield,harding,solis,frost,giles,blackburn,pennington,woodward,finley,mcintosh,koch,mccullough,blanchard,rivas,brennan,mejia,kane,benton,buckley,valentine,maddox,russo,mcknight,buck,moon,mcmillan,crosby,berg,dotson,mays,roach,chan,richmond,meadows,faulkner,oneill,knapp,kline,ochoa,jacobson,gay,hendricks,horne,shepard,hebert,cardenas,mcintyre,waller,holman,donaldson,cantu,morin,gillespie,fuentes,tillman,bentley,peck,key,salas,rollins,gamble,dickson,santana,cabrera,cervantes,howe,hinton,hurley,spence,zamora,yang,mcneil,suarez,petty,gould,mcfarland,sampson,carver,bray,macdonald,stout,hester,melendez,dillon,farley,hopper,galloway,potts,joyner,stein,aguirre,osborn,mercer,bender,franco,rowland,sykes,pickett,sears,mayo,dunlap,hayden,wilder,mckay,coffey,mccarty,ewing,cooley,vaughan,bonner,cotton,holder,stark,ferrell,cantrell,fulton,lott,calderon,pollard,hooper,burch,mullen,fry,riddle,levy,duke,odonnell,britt,daugherty,berger,dillard,alston,frye,riggs,chaney,odom,duffy,fitzpatrick,valenzuela,mayer,alford,mcpherson,acevedo,barrera,cote,reilly,compton,mooney,mcgowan,craft,clemons,wynn,nielsen,baird,stanton,snider,rosales,bright,witt,hays,holden,rutledge,kinney,clements,castaneda,slater,hahn,burks,delaney,pate,lancaster,sharpe,whitfield,talley,macias,burris,ratliff,mccray,madden,kaufman,beach,goff,cash,bolton,mcfadden,levine,byers,kirkland,kidd,workman,carney,mcleod,holcomb,finch,sosa,haney,franks,sargent,nieves,downs,rasmussen,bird,hewitt,foreman,valencia,oneil,delacruz,vinson,dejesus,hyde,forbes,gilliam,guthrie,wooten,huber,barlow,boyle,mcmahon,buckner,rocha,puckett,langley,knowles,cooke,velazquez,whitley,vang,shea,rouse,hartley,mayfield,elder,rankin,hanna,cowan,lucero,arroyo,slaughter,haas,oconnell,minor,boucher,archer,boggs,dougherty,andersen,newell,crowe,wang,friedman,bland,swain,holley,pearce,childs,yarbrough,galvan,proctor,meeks,lozano,mora,rangel,bacon,villanueva,schaefer,rosado,helms,boyce,goss,stinson,ibarra,hutchins,covington,crowley,hatcher,mackey,bunch,womack,polk,dodd,childress,childers,villa,springer,mahoney,dailey,belcher,lockhart,griggs,costa,brandt,walden,moser,tatum,mccann,akers,lutz,pryor,orozco,mcallister,lugo,davies,shoemaker,rutherford,newsome,magee,chamberlain,blanton,simms,godfrey,flanagan,crum,cordova,escobar,downing,sinclair,donahue,krueger,mcginnis,gore,farris,webber,corbett,andrade,starr,lyon,yoder,hastings,mcgrath,spivey,krause,harden,crabtree,kirkpatrick,arrington,ritter,mcghee,bolden,maloney,gagnon,dunbar,ponce,pike,mayes,beatty,mobley,kimball,butts,montes,eldridge,braun,hamm,gibbons,moyer,manley,herron,plummer,elmore,cramer,rucker,pierson,fontenot,rubio,goldstein,elkins,wills,novak,hickey,worley,gorman,katz,dickinson,broussard,woodruff,crow,britton,nance,lehman,bingham,zuniga,whaley,shafer,coffman,steward,delarosa,neely,mata,davila,mccabe,kessler,hinkle,welsh,pagan,goldberg,goins,crouch,cuevas,quinones,mcdermott,hendrickson,samuels,denton,bergeron,ivey,locke,haines,snell,hoskins,byrne,arias,corbin,beltran,chappell,downey,dooley,tuttle,couch,payton,mcelroy,crockett,groves,cartwright,dickey,mcgill,dubois,muniz,tolbert,dempsey,cisneros,sewell,latham,vigil,tapia,rainey,norwood,stroud,meade,tipton,kuhn,hilliard,bonilla,teague,gunn,greenwood,correa,reece,pineda,phipps,frey,kaiser,ames,gunter,schmitt,milligan,espinosa,bowden,vickers,lowry,pritchard,costello,piper,mcclellan,lovell,sheehan,hatch,dobson,singh,jeffries,hollingsworth,sorensen,meza,fink,donnelly,burrell,tomlinson,colbert,billings,ritchie,helton,sutherland,peoples,mcqueen,thomason,givens,crocker,vogel,robison,dunham,coker,swartz,keys,ladner,richter,hargrove,edmonds,brantley,albright,murdock,boswell,muller,quintero,padgett,kenney,daly,connolly,inman,quintana,lund,barnard,villegas,simons,huggins,tidwell,sanderson,bullard,mcclendon,duarte,draper,marrero,dwyer,abrams,stover,goode,fraser,crews,bernal,godwin,conklin,mcneal,baca,esparza,crowder,bower,brewster,mcneill,rodrigues,leal,coates,raines,mccain,mccord,miner,holbrook,swift,dukes,carlisle,aldridge,ackerman,starks,ricks,holliday,ferris,hairston,sheffield,lange,fountain,doss,betts,kaplan,carmichael,bloom,ruffin,penn,kern,bowles,sizemore,larkin,dupree,seals,metcalf,hutchison,henley,farr,mccauley,hankins,gustafson,curran,waddell,ramey,cates,pollock,cummins,messer,heller,funk,cornett,palacios,galindo,cano,hathaway,pham,enriquez,salgado,pelletier,painter,wiseman,blount,feliciano,houser,doherty,mead,mcgraw,swan,capps,blanco,blackmon,thomson,mcmanus,burkett,gleason,dickens,cormier,voss,rushing,rosenberg,hurd,dumas,benitez,arellano,marin,caudill,bragg,jaramillo,huerta,gipson,colvin,biggs,vela,platt,cassidy,tompkins,mccollum,dolan,daley,crump,sneed,kilgore,grove,grimm,davison,brunson,prater,marcum,devine,dodge,stratton,rosas,choi,tripp,ledbetter,hightower,feldman,epps,yeager,posey,scruggs,cope,stubbs,richey,overton,trotter,sprague,cordero,butcher,stiles,burgos,woodson,horner,bassett,purcell,haskins,akins,ziegler,spaulding,hadley,grubbs,sumner,murillo,zavala,shook,lockwood,driscoll,dahl,thorpe,redmond,putnam,mcwilliams,mcrae,romano,joiner,sadler,hedrick,hager,hagen,fitch,coulter,thacker,mansfield,langston,guidry,ferreira,corley,conn,rossi,lackey,baez,saenz,mcnamara,mcmullen,mckenna,mcdonough,link,engel,browne,roper,peacock,eubanks,drummond,stringer,pritchett,parham,mims,landers,grayson,schafer,egan,timmons,ohara,keen,hamlin,finn,cortes,mcnair,nadeau,moseley,michaud,rosen,oakes,kurtz,jeffers,calloway,beal,bautista,winn,suggs,stern,stapleton,lyles,laird,montano,dawkins,hagan,goldman,bryson,barajas,lovett,segura,metz,lockett,langford,hinson,eastman,hooks,smallwood,shapiro,crowell,whalen,triplett,chatman,aldrich,cahill,youngblood,ybarra,stallings,sheets,reeder,connelly,bateman,abernathy,winkler,wilkes,masters,hackett,granger,gillis,schmitz,sapp,napier,souza,lanier,gomes,weir,otero,ledford,burroughs,babcock,ventura,siegel,dugan,bledsoe,atwood,wray,varner,spangler,anaya,staley,kraft,fournier,belanger,wolff,thorne,bynum,burnette,boykin,swenson,purvis,pina,khan,duvall,darby,xiong,kauffman,healy,engle,benoit,valle,steiner,spicer,shaver,randle,lundy,chin,calvert,staton,neff,kearney,darden,oakley,medeiros,mccracken,crenshaw,perdue,dill,whittaker,tobin,washburn,hogue,goodrich,easley,bravo,dennison,shipley,kerns,jorgensen,crain,villalobos,maurer,longoria,keene,coon,witherspoon,staples,pettit,kincaid,eason,madrid,echols,lusk,stahl,currie,thayer,shultz,mcnally,seay,maher,gagne,barrow,nava,moreland,honeycutt,hearn,diggs,caron,whitten,westbrook,stovall,ragland,munson,meier,looney,kimble,jolly,hobson,goddard,culver,burr,presley,negron,connell,tovar,huddleston,ashby,salter,root,pendleton,oleary,nickerson,myrick,judd,jacobsen,bain,adair,starnes,matos,busby,herndon,hanley,bellamy,doty,bartley,yazzie,rowell,parson,gifford,cullen,christiansen,benavides,barnhart,talbot,mock,crandall,connors,bonds,whitt,gage,bergman,arredondo,addison,lujan,dowdy,jernigan,huynh,bouchard,dutton,rhoades,ouellette,kiser,herrington,hare,blackman,babb,allred,rudd,paulson,ogden,koenig,geiger,begay,parra,lassiter,hawk,esposito,waldron,ransom,prather,chacon,vick,sands,roark,parr,mayberry,greenberg,coley,bruner,whitman,skaggs,shipman,leary,hutton,romo,medrano,ladd,kruse,askew,schulz,alfaro,tabor,mohr,gallo,bermudez,pereira,bliss,reaves,flint,comer,woodall,naquin,guevara,delong,carrier,pickens,tilley,schaffer,knutson,fenton,doran,vogt,vann,prescott,mclain,landis,corcoran,zapata,hyatt,hemphill,faulk,dove,boudreaux,aragon,whitlock,trejo,tackett,shearer,saldana,hanks,mckinnon,koehler,bourgeois,keyes,goodson,foote,lunsford,goldsmith,flood,winslow,sams,reagan,mccloud,hough,esquivel,naylor,loomis,coronado,ludwig,braswell,bearden,huang,fagan,ezell,edmondson,cronin,nunn,lemon,guillory,grier,dubose,traylor,ryder,dobbins,coyle,aponte,whitmore,smalls,rowan,malloy,cardona,braxton,borden,humphries,carrasco,ruff,metzger,huntley,hinojosa,finney,madsen,ernst,dozier,burkhart,bowser,peralta,daigle,whittington,sorenson,saucedo,roche,redding,fugate,avalos,waite,lind,huston,hawthorne,hamby,boyles,boles,regan,faust,crook,beam,barger,hinds,gallardo,willoughby,willingham,eckert,busch,zepeda,worthington,tinsley,hoff,hawley,carmona,varela,rector,newcomb,kinsey,dube,whatley,ragsdale,bernstein,becerra,yost,mattson,felder,cheek,handy,grossman,gauthier,escobedo,braden,beckman,mott,hillman,flaherty,dykes,stockton,stearns,lofton,coats,cavazos,beavers,barrios,tang,mosher,cardwell,coles,burnham,weller,lemons,beebe,aguilera,parnell,harman,couture,alley,schumacher,redd,dobbs,blum,blalock,merchant,ennis,denson,cottrell,brannon,bagley,aviles,watt,sousa,rosenthal,rooney,dietz,blank,paquette,mcclelland,duff,velasco,lentz,grubb,burrows,barbour,ulrich,shockley,rader,beyer,mixon,layton,altman,weathers,stoner,squires,shipp,priest,lipscomb,cutler,caballero,zimmer,willett,thurston,storey,medley,epperson,shah,mcmillian,baggett,torrez,hirsch,dent,poirier,peachey,farrar,creech,barth,trimble,dupre,albrecht,sample,lawler,crisp,conroy,wetzel,nesbitt,murry,jameson,wilhelm,patten,minton,matson,kimbrough,guinn,croft,toth,pulliam,nugent,newby,littlejohn,dias,canales,bernier,baron,singletary,renteria,pruett,mchugh,mabry,landrum,brower,stoddard,cagle,stjohn,scales,kohler,kellogg,hopson,gant,tharp,gann,zeigler,pringle,hammons,fairchild,deaton,chavis,carnes,rowley,matlock,kearns,irizarry,carrington,starkey,lopes,jarrell,craven,baum,littlefield,linn,humphreys,etheridge,cuellar,chastain,bundy,speer,skelton,quiroz,pyle,portillo,ponder,moulton,machado,killian,hutson,hitchcock,dowling,cloud,burdick,spann,pedersen,levin,leggett,hayward,dietrich,beaulieu,barksdale,wakefield,snowden,briscoe,bowie,berman,ogle,mcgregor,laughlin,helm,burden,wheatley,schreiber,pressley,parris,alaniz,agee,swann,snodgrass,schuster,radford,monk,mattingly,harp,girard,cheney,yancey,wagoner,ridley,lombardo,hudgins,gaskins,duckworth,coburn,willey,prado,newberry,magana,hammonds,elam,whipple,slade,serna,ojeda,liles,dorman,diehl,upton,reardon,michaels,goetz,eller,bauman,baer,layne,hummel,brenner,amaya,adamson,ornelas,dowell,cloutier,castellanos,wellman,saylor,orourke,moya,montalvo,kilpatrick,durbin,shell,oldham,kang,garvin,foss,branham,bartholomew,templeton,maguire,holton,rider,monahan,mccormack,beaty,anders,streeter,nieto,nielson,moffett,lankford,keating,heck,gatlin,delatorre,callaway,adcock,worrell,unger,robinette,nowak,jeter,brunner,steen,parrott,overstreet,nobles,montanez,clevenger,brinkley,trahan,quarles,pickering,pederson,jansen,grantham,gilchrist,crespo,aiken,schell,schaeffer,lorenz,leyva,harms,dyson,wallis,pease,leavitt,cheng,cavanaugh,batts,warden,seaman,rockwell,quezada,paxton,linder,houck,fontaine,durant,caruso,adler,pimentel,mize,lytle,cleary,cason,acker,switzer,isaacs,higginbotham,waterman,vandyke,stamper,sisk,shuler,riddick,mcmahan,levesque,hatton,bronson,bollinger,arnett,okeefe,gerber,gannon,farnsworth,baughman,silverman,satterfield,mccrary,kowalski,grigsby,greco,cabral,trout,rinehart,mahon,linton,gooden,curley,baugh,wyman,weiner,schwab,schuler,morrissey,mahan,bunn,thrasher,spear,waggoner,qualls,purdy,mcwhorter,mauldin,gilman,perryman,newsom,menard,martino,graf,billingsley,artis,simpkins,salisbury,quintanilla,gilliland,fraley,foust,crouse,scarborough,grissom,fultz,marlow,markham,madrigal,lawton,barfield,whiting,varney,schwarz,gooch,arce,wheat,truong,poulin,hurtado,selby,gaither,fortner,culpepper,coughlin,brinson,boudreau,bales,stepp,holm,schilling,morrell,kahn,heaton,gamez,causey,turpin,shanks,schrader,meek,isom,hardison,carranza,yanez,scroggins,schofield,runyon,ratcliff,murrell,moeller,irby,currier,butterfield,ralston,pullen,pinson,estep,carbone,hawks,ellington,casillas,spurlock,sikes,motley,mccartney,kruger,isbell,houle,burk,tomlin,quigley,neumann,lovelace,fennell,cheatham,bustamante,skidmore,hidalgo,forman,culp,bowens,betancourt,aquino,robb,milner,martel,gresham,wiles,ricketts,dowd,collazo,bostic,blakely,sherrod,kenyon,gandy,ebert,deloach,allard,sauer,robins,olivares,gillette,chestnut,bourque,paine,hite,hauser,devore,crawley,chapa,talbert,poindexter,meador,mcduffie,mattox,kraus,harkins,choate,wren,sledge,sanborn,kinder,geary,cornwell,barclay,abney,seward,rhoads,howland,fortier,benner,vines,tubbs,troutman,rapp,mccurdy,deluca,westmoreland,havens,guajardo,clary,seal,meehan,herzog,guillen,ashcraft,waugh,renner,milam,elrod,churchill,breaux,bolin,asher,windham,tirado,pemberton,nolen,noland,knott,emmons,cornish,christenson,brownlee,barbee,waldrop,pitt,olvera,lombardi,gruber,gaffney,eggleston,banda,archuleta,slone,prewitt,pfeiffer,nettles,mena,mcadams,henning,gardiner,cromwell,chisholm,burleson,vest,oglesby,mccarter,lumpkin,wofford,vanhorn,thorn,teel,swafford,stclair,stanfield,ocampo,herrmann,hannon,arsenault,roush,mcalister,hiatt,gunderson,forsythe,duggan,delvalle,cintron,wilks,weinstein,uribe,rizzo,noyes,mclendon,gurley,bethea,winstead,maples,guyton,giordano,alderman,valdes,polanco,pappas,lively,grogan,griffiths,bobo,arevalo,whitson,sowell,rendon,fernandes,farrow,benavidez,ayres,alicea,stump,smalley,seitz,schulte,gilley,gallant,canfield,wolford,omalley,mcnutt,mcnulty,mcgovern,hardman,harbin,cowart,chavarria,brink,beckett,bagwell,armstead,anglin,abreu,reynoso,krebs,jett,hoffmann,greenfield,forte,burney,broome,sisson,trammell,partridge,mace,lomax,lemieux,gossett,frantz,fogle,cooney,broughton,pence,paulsen,muncy,mcarthur,hollins,beauchamp,withers,osorio,mulligan,hoyle,dockery,cockrell,begley,amador,roby,rains,lindquist,gentile,everhart,bohannon,wylie,sommers,purnell,fortin,dunning,breeden,vail,phelan,phan,marx,cosby,colburn,boling,biddle,ledesma,gaddis,denney,chow,bueno,berrios,wicker,tolliver,thibodeaux,nagle,lavoie,fisk,crist,barbosa,reedy,locklear,kolb,himes,behrens,beckwith,weems,wahl,shorter,shackelford,rees,muse,cerda,valadez,thibodeau,saavedra,ridgeway,reiter,mchenry,majors,lachance,keaton,ferrara,clemens,blocker,applegate,needham,mojica,kuykendall,hamel,escamilla,doughty,burchett,ainsworth,vidal,upchurch,thigpen,strauss,spruill,sowers,riggins,ricker,mccombs,harlow,buffington,sotelo,olivas,negrete,morey,macon,logsdon,lapointe,bigelow,bello,westfall,stubblefield,lindley,hein,hawes,farrington,breen,birch,wilde,steed,sepulveda,reinhardt,proffitt,minter,messina,mcnabb,maier,keeler,gamboa,donohue,basham,shinn,crooks,cota,borders,bills,bachman,tisdale,tavares,schmid,pickard,gulley,fonseca,delossantos,condon,batista,wicks,wadsworth,martell,littleton,ison,haag,folsom,brumfield,broyles,brito,mireles,mcdonnell,leclair,hamblin,gough,fanning,binder,winfield,whitworth,soriano,palumbo,newkirk,mangum,hutcherson,comstock,carlin,beall,bair,wendt,watters,walling,putman,otoole,morley,mares,lemus,keener,hundley,dial,damico,billups,strother,mcfarlane,lamm,eaves,crutcher,caraballo,canty,atwell,taft,siler,rust,rawls,rawlings,prieto,mcneely,mcafee,hulsey,hackney,galvez,escalante,delagarza,crider,bandy,wilbanks,stowe,steinberg,renfro,masterson,massie,lanham,haskell,hamrick,dehart,burdette,branson,bourne,babin,aleman,worthy,tibbs,smoot,slack,paradis,mull,luce,houghton,gantt,furman,danner,christianson,burge,ashford,arndt,almeida,stallworth,shade,searcy,sager,noonan,mclemore,mcintire,maxey,lavigne,jobe,ferrer,falk,coffin,byrnes,aranda,apodaca,stamps,rounds,peek,olmstead,lewandowski,kaminski,dunaway,bruns,brackett,amato,reich,mcclung,lacroix,koontz,herrick,hardesty,flanders,cousins,cato,cade,vickery,shank,nagel,dupuis,croteau,cotter,stuckey,stine,porterfield,pauley,moffitt,knudsen,hardwick,goforth,dupont,blunt,barrows,barnhill,shull,rash,loftis,lemay,kitchens,horvath,grenier,fuchs,fairbanks,culbertson,calkins,burnside,beattie,ashworth,albertson,wertz,vaught,vallejo,turk,tuck,tijerina,sage,peterman,marroquin,marr,lantz,hoang,demarco,cone,berube,barnette,wharton,stinnett,slocum,scanlon,sander,pinto,mancuso,lima,headley,epstein,counts,clarkson,carnahan,boren,arteaga,adame,zook,whittle,whitehurst,wenzel,saxton,reddick,puente,handley,haggerty,earley,devlin,chaffin,cady,acuna,solano,sigler,pollack,pendergrass,ostrander,janes,francois,crutchfield,chamberlin,brubaker,baptiste,willson,reis,neeley,mullin,mercier,lira,layman,keeling,higdon,espinal,chapin,warfield,toledo,pulido,peebles,nagy,montague,mello,lear,jaeger,hogg,graff,furr,soliz,poore,mendenhall,mclaurin,maestas,gable,barraza,tillery,snead,pond,neill,mcculloch,mccorkle,lightfoot,hutchings,holloman,harness,dorn,bock,zielinski,turley,treadwell,stpierre,starling,somers,oswald,merrick,easterling,bivens,truitt,poston,parry,ontiveros,olivarez,moreau,medlin,lenz,knowlton,fairley,cobbs,chisolm,bannister,woodworth,toler,ocasio,noriega,neuman,moye,milburn,mcclanahan,lilley,hanes,flannery,dellinger,danielson,conti,blodgett,beers,weatherford,strain,karr,hitt,denham,custer,coble,clough,casteel,bolduc,batchelor,ammons,whitlow,tierney,staten,sibley,seifert,schubert,salcedo,mattison,laney,haggard,grooms,dees,cromer,cooks,colson,caswell,zarate,swisher,shin,ragan,pridgen,mcvey,matheny,lafleur,franz,ferraro,dugger,whiteside,rigsby,mcmurray,lehmann,jacoby,hildebrand,hendrick,headrick,goad,fincher,drury,borges,archibald,albers,woodcock,trapp,soares,seaton,monson,luckett,lindberg,kopp,keeton,healey,garvey,gaddy,fain,burchfield,wentworth,strand,stack,spooner,saucier,ricci,plunkett,pannell,ness,leger,freitas,fong,elizondo,duval,beaudoin,urbina,rickard,partin,mcgrew,mcclintock,ledoux,forsyth,faison,devries,bertrand,wasson,tilton,scarbrough,leung,irvine,garber,denning,corral,colley,castleberry,bowlin,bogan,beale,baines,trice,rayburn,parkinson,nunes,mcmillen,leahy,kimmel,higgs,fulmer,carden,bedford,taggart,spearman,prichard,morrill,koonce,heinz,hedges,guenther,grice,findley,dover,creighton,boothe,bayer,arreola,vitale,valles,raney,osgood,hanlon,burley,bounds,worden,weatherly,vetter,tanaka,stiltner,nevarez,mosby,montero,melancon,harter,hamer,goble,gladden,gist,ginn,akin,zaragoza,tarver,sammons,royster,oreilly,muir,morehead,luster,kingsley,kelso,grisham,glynn,baumann,alves,yount,tamayo,paterson,oates,menendez,longo,hargis,gillen,desantis,conover,breedlove,sumpter,scherer,rupp,reichert,heredia,creel,cohn,clemmons,casas,bickford,belton,bach,williford,whitcomb,tennant,sutter,stull,mccallum,langlois,keel,keegan,dangelo,dancy,damron,clapp,clanton,bankston,oliveira,mintz,mcinnis,martens,mabe,laster,jolley,hildreth,hefner,glaser,duckett,demers,brockman,blais,alcorn,agnew,toliver,tice,seeley,najera,musser,mcfall,laplante,galvin,fajardo,doan,coyne,copley,clawson,cheung,barone,wynne,woodley,tremblay,stoll,sparrow,sparkman,schweitzer,sasser,samples,roney,legg,heim,farias,colwell,christman,bratcher,winchester,upshaw,southerland,sorrell,sells,mccloskey,martindale,luttrell,loveless,lovejoy,linares,latimer,embry,coombs,bratton,bostick,venable,tuggle,toro,staggs,sandlin,jefferies,heckman,griffis,crayton,clem,browder,thorton,sturgill,sprouse,royer,rousseau,ridenour,pogue,perales,peeples,metzler,mesa,mccutcheon,mcbee,hornsby,heffner,corrigan,armijo,plante,peyton,paredes,macklin,hussey,hodgson,granados,frias,becnel,batten,almanza,turney,teal,sturgeon,meeker,mcdaniels,limon,keeney,hutto,holguin,gorham,fishman,fierro,blanchette,rodrigue,reddy,osburn,oden,lerma,kirkwood,keefer,haugen,hammett,chalmers,brinkman,baumgartner,zhang,valerio,tellez,steffen,shumate,sauls,ripley,kemper,guffey,evers,craddock,carvalho,blaylock,banuelos,balderas,wheaton,turnbull,shuman,pointer,mosier,mccue,ligon,kozlowski,johansen,ingle,herr,briones,snipes,rickman,pipkin,pantoja,orosco,moniz,lawless,kunkel,hibbard,galarza,enos,bussey,schott,salcido,perreault,mcdougal,mccool,haight,garris,easton,conyers,atherton,wimberly,utley,spellman,smithson,slagle,ritchey,rand,petit,osullivan,oaks,nutt,mcvay,mccreary,mayhew,knoll,jewett,harwood,cardoza,ashe,arriaga,zeller,wirth,whitmire,stauffer,rountree,redden,mccaffrey,martz,larose,langdon,humes,gaskin,faber,devito,cass,almond,wingfield,wingate,villareal,tyner,smothers,severson,reno,pennell,maupin,leighton,janssen,hassell,hallman,halcomb,folse,fitzsimmons,fahey,cranford,bolen,battles,battaglia,wooldridge,trask,rosser,regalado,mcewen,keefe,fuqua,echevarria,caro,boynton,andrus,viera,vanmeter,taber,spradlin,seibert,provost,prentice,oliphant,laporte,hwang,hatchett,hass,greiner,freedman,covert,chilton,byars,wiese,venegas,swank,shrader,roberge,mullis,mortensen,mccune,marlowe,kirchner,keck,isaacson,hostetler,halverson,gunther,griswold,fenner,durden,blackwood,ahrens,sawyers,savoy,nabors,mcswain,mackay,lavender,lash,labbe,jessup,fullerton,cruse,crittenden,correia,centeno,caudle,canady,callender,alarcon,ahern,winfrey,tribble,salley,roden,musgrove,minnick,fortenberry,carrion,bunting,batiste,whited,underhill,stillwell,rauch,pippin,perrin,messenger,mancini,lister,kinard,hartmann,fleck,wilt,treadway,thornhill,spalding,rafferty,pitre,patino,ordonez,linkous,kelleher,homan,galbraith,feeney,curtin,coward,camarillo,buss,bunnell,bolt,beeler,autry,alcala,witte,wentz,stidham,shively,nunley,meacham,martins,lemke,lefebvre,hynes,horowitz,hoppe,holcombe,dunne,derr,cochrane,brittain,bedard,beauregard,torrence,strunk,soria,simonson,shumaker,scoggins,oconner,moriarty,kuntz,ives,hutcheson,horan,hales,garmon,fitts,bohn,atchison,wisniewski,vanwinkle,sturm,sallee,prosser,moen,lundberg,kunz,kohl,keane,jorgenson,jaynes,funderburk,freed,durr,creamer,cosgrove,batson,vanhoose,thomsen,teeter,smyth,redmon,orellana,maness,heflin,goulet,frick,forney,bunker,asbury,aguiar,talbott,southard,mowery,mears,lemmon,krieger,hickson,elston,duong,delgadillo,dayton,dasilva,conaway,catron,bruton,bradbury,bordelon,bivins,bittner,bergstrom,beals,abell,whelan,tejada,pulley,pino,norfleet,nealy,maes,loper,gatewood,frierson,freund,finnegan,cupp,covey,catalano,boehm,bader,yoon,walston,tenney,sipes,rawlins,medlock,mccaskill,mccallister,marcotte,maclean,hughey,henke,harwell,gladney,gilson,chism,caskey,brandenburg,baylor,villasenor,veal,thatcher,stegall,petrie,nowlin,navarrete,lombard,loftin,lemaster,kroll,kovach,kimbrell,kidwell,hershberger,fulcher,cantwell,bustos,boland,bobbitt,binkley,wester,weis,verdin,tong,tiller,sisco,sharkey,seymore,rosenbaum,rohr,quinonez,pinkston,malley,logue,lessard,lerner,lebron,krauss,klinger,halstead,haller,getz,burrow,alger,shores,pfeifer,perron,nelms,munn,mcmaster,mckenney,manns,knudson,hutchens,huskey,goebel,flagg,cushman,click,castellano,carder,bumgarner,wampler,spinks,robson,neel,mcreynolds,mathias,maas,loera,jenson,florez,coons,buckingham,brogan,berryman,wilmoth,wilhite,thrash,shephard,seidel,schulze,roldan,pettis,obryan,maki,mackie,hatley,frazer,fiore,chesser,bottoms,bisson,benefield,allman,wilke,trudeau,timm,shifflett,mundy,milliken,mayers,leake,kohn,huntington,horsley,hermann,guerin,fryer,frizzell,foret,flemming,fife,criswell,carbajal,bozeman,boisvert,angulo,wallen,tapp,silvers,ramsay,oshea,orta,moll,mckeever,mcgehee,linville,kiefer,ketchum,howerton,groce,gass,fusco,corbitt,betz,bartels,amaral,aiello,weddle,sperry,seiler,runyan,raley,overby,osteen,olds,mckeown,matney,lauer,lattimore,hindman,hartwell,fredrickson,fredericks,espino,clegg,carswell,cambell,burkholder,woodbury,welker,totten,thornburg,theriault,stitt,stamm,stackhouse,scholl,saxon,rife,razo,quinlan,pinkerton,olivo,nesmith,nall,mattos,lafferty,justus,giron,geer,fielder,drayton,dortch,conners,conger,boatwright,billiot,barden,armenta,tibbetts,steadman,slattery,rinaldi,raynor,pinckney,pettigrew,milne,matteson,halsey,gonsalves,fellows,durand,desimone,cowley,cowles,brill,barham,barela,barba,ashmore,withrow,valenti,tejeda,spriggs,sayre,salerno,peltier,peel,merriman,matheson,lowman,lindstrom,hyland,giroux,earls,dugas,dabney,collado,briseno,baxley,whyte,wenger,vanover,vanburen,thiel,schindler,schiller,rigby,pomeroy,passmore,marble,manzo,mahaffey,lindgren,laflamme,greathouse,fite,calabrese,bayne,yamamoto,wick,townes,thames,reinhart,peeler,naranjo,montez,mcdade,mast,markley,marchand,leeper,kellum,hudgens,hennessey,hadden,gainey,coppola,borrego,bolling,beane,ault,slaton,pape,null,mulkey,lightner,langer,hillard,ethridge,enright,derosa,baskin,weinberg,turman,somerville,pardo,noll,lashley,ingraham,hiller,hendon,glaze,cothran,cooksey,conte,carrico,abner,wooley,swope,summerlin,sturgis,sturdivant,stott,spurgeon,spillman,speight,roussel,popp,nutter,mckeon,mazza,magnuson,lanning,kozak,jankowski,heyward,forster,corwin,callaghan,bays,wortham,usher,theriot,sayers,sabo,poling,loya,lieberman,laroche,labelle,howes,harr,garay,fogarty,everson,durkin,dominquez,chaves,chambliss,witcher,vieira,vandiver,terrill,stoker,schreiner,moorman,liddell,lawhorn,krug,irons,hylton,hollenbeck,herrin,hembree,goolsby,goodin,gilmer,foltz,dinkins,daughtry,caban,brim,briley,bilodeau,wyant,vergara,tallent,swearingen,stroup,scribner,quillen,pitman,mccants,maxfield,martinson,holtz,flournoy,brookins,brody,baumgardner,straub,sills,roybal,roundtree,oswalt,mcgriff,mcdougall,mccleary,maggard,gragg,gooding,godinez,doolittle,donato,cowell,cassell,bracken,appel,zambrano,reuter,perea,nakamura,monaghan,mickens,mcclinton,mcclary,marler,kish,judkins,gilbreath,freese,flanigan,felts,erdmann,dodds,chew,brownell,boatright,barreto,slayton,sandberg,saldivar,pettway,odum,narvaez,moultrie,montemayor,merrell,lees,keyser,hoke,hardaway,hannan,gilbertson,fogg,dumont,deberry,coggins,buxton,bucher,broadnax,beeson,araujo,appleton,amundson,aguayo,ackley,yocum,worsham,shivers,sanches,sacco,robey,rhoden,pender,ochs,mccurry,madera,luong,knotts,jackman,heinrich,hargrave,gault,comeaux,chitwood,caraway,boettcher,bernhardt,barrientos,zink,wickham,whiteman,thorp,stillman,settles,schoonover,roque,riddell,pilcher,phifer,novotny,macleod,hardee,haase,grider,doucette,clausen,bevins,beamon,badillo,tolley,tindall,soule,snook,seale,pinkney,pellegrino,nowell,nemeth,mondragon,mclane,lundgren,ingalls,hudspeth,hixson,gearhart,furlong,downes,dibble,deyoung,cornejo,camara,brookshire,boyette,wolcott,surratt,sellars,segal,salyer,reeve,rausch,labonte,haro,gower,freeland,fawcett,eads,driggers,donley,collett,bromley,boatman,ballinger,baldridge,volz,trombley,stonge,shanahan,rivard,rhyne,pedroza,matias,jamieson,hedgepeth,hartnett,estevez,eskridge,denman,chiu,chinn,catlett,carmack,buie,bechtel,beardsley,bard,ballou,ulmer,skeen,robledo,rincon,reitz,piazza,munger,moten,mcmichael,loftus,ledet,kersey,groff,fowlkes,crumpton,clouse,bettis,villagomez,timmerman,strom,santoro,roddy,penrod,musselman,macpherson,leboeuf,harless,haddad,guido,golding,fulkerson,fannin,dulaney,dowdell,cottle,ceja,cate,bosley,benge,albritton,voigt,trowbridge,soileau,seely,rohde,pearsall,paulk,orth,nason,mota,mcmullin,marquardt,madigan,hoag,gillum,gabbard,fenwick,danforth,cushing,cress,creed,cazares,bettencourt,barringer,baber,stansberry,schramm,rutter,rivero,oquendo,necaise,mouton,montenegro,miley,mcgough,marra,macmillan,lamontagne,jasso,horst,hetrick,heilman,gaytan,gall,fortney,dingle,desjardins,dabbs,burbank,brigham,breland,beaman,arriola,yarborough,wallin,toscano,stowers,reiss,pichardo,orton,michels,mcnamee,mccrory,leatherman,kell,keister,horning,hargett,guay,ferro,deboer,dagostino,carper,blanks,beaudry,towle,tafoya,stricklin,strader,soper,sonnier,sigmon,schenk,saddler,pedigo,mendes,lunn,lohr,lahr,kingsbury,jarman,hume,holliman,hofmann,haworth,harrelson,hambrick,flick,edmunds,dacosta,crossman,colston,chaplin,carrell,budd,weiler,waits,valentino,trantham,tarr,solorio,roebuck,powe,plank,pettus,pagano,mink,luker,leathers,joslin,hartzell,gambrell,cepeda,carty,caputo,brewington,bedell,ballew,applewhite,warnock,walz,urena,tudor,reel,pigg,parton,mickelson,meagher,mclellan,mcculley,mandel,leech,lavallee,kraemer,kling,kipp,kehoe,hochstetler,harriman,gregoire,grabowski,gosselin,gammon,fancher,edens,desai,brannan,armendariz,woolsey,whitehouse,whetstone,ussery,towne,testa,tallman,studer,strait,steinmetz,sorrells,sauceda,rolfe,paddock,mitchem,mcginn,mccrea,lovato,hazen,gilpin,gaynor,fike,devoe,delrio,curiel,burkhardt,bode,backus,zinn,watanabe,wachter,vanpelt,turnage,shaner,schroder,sato,riordan,quimby,portis,natale,mckoy,mccown,kilmer,hotchkiss,hesse,halbert,gwinn,godsey,delisle,chrisman,canter,arbogast,angell,acree,yancy,woolley,wesson,weatherspoon,trainor,stockman,spiller,sipe,rooks,reavis,propst,porras,neilson,mullens,loucks,llewellyn,kumar,koester,klingensmith,kirsch,kester,honaker,hodson,hennessy,helmick,garrity,garibay,drain,casarez,callis,botello,aycock,avant,wingard,wayman,tully,theisen,szymanski,stansbury,segovia,rainwater,preece,pirtle,padron,mincey,mckelvey,mathes,larrabee,kornegay,klug,ingersoll,hecht,germain,eggers,dykstra,deering,decoteau,deason,dearing,cofield,carrigan,bonham,bahr,aucoin,appleby,almonte,yager,womble,wimmer,weimer,vanderpool,stancil,sprinkle,romine,remington,pfaff,peckham,olivera,meraz,maze,lathrop,koehn,hazelton,halvorson,hallock,haddock,ducharme,dehaven,caruthers,brehm,bosworth,bost,bias,beeman,basile,bane,aikens,wold,walther,tabb,suber,strawn,stocker,shirey,schlosser,riedel,rembert,reimer,pyles,peele,merriweather,letourneau,latta,kidder,hixon,hillis,hight,herbst,henriquez,haygood,hamill,gabel,fritts,eubank,dawes,correll,bushey,buchholz,brotherton,botts,barnwell,auger,atchley,westphal,veilleux,ulloa,stutzman,shriver,ryals,pilkington,moyers,marrs,mangrum,maddux,lockard,laing,kuhl,harney,hammock,hamlett,felker,doerr,depriest,carrasquillo,carothers,bogle,bischoff,bergen,albanese,wyckoff,vermillion,vansickle,thibault,tetreault,stickney,shoemake,ruggiero,rawson,racine,philpot,paschal,mcelhaney,mathison,legrand,lapierre,kwan,kremer,jiles,hilbert,geyer,faircloth,ehlers,egbert,desrosiers,dalrymple,cotten,cashman,cadena,boardman,alcaraz,wyrick,therrien,tankersley,strickler,puryear,plourde,pattison,pardue,mcginty,mcevoy,landreth,kuhns,koon,hewett,giddens,emerick,eades,deangelis,cosme,ceballos,birdsong,benham,bemis,armour,anguiano,welborn,tsosie,storms,shoup,sessoms,samaniego,rood,rojo,rhinehart,raby,northcutt,myer,munguia,morehouse,mcdevitt,mallett,lozada,lemoine,kuehn,hallett,grim,gillard,gaylor,garman,gallaher,feaster,faris,darrow,dardar,coney,carreon,braithwaite,boylan,boyett,bixler,bigham,benford,barragan,barnum,zuber,wyche,westcott,vining,stoltzfus,simonds,shupe,sabin,ruble,rittenhouse,richman,perrone,mulholland,millan,lomeli,kite,jemison,hulett,holler,hickerson,herold,hazelwood,griffen,gause,forde,eisenberg,dilworth,charron,chaisson,bristow,breunig,brace,boutwell,bentz,belk,bayless,batchelder,baran,baeza,zimmermann,weathersby,volk,toole,theis,tedesco,searle,schenck,satterwhite,ruelas,rankins,partida,nesbit,morel,menchaca,levasseur,kaylor,johnstone,hulse,hollar,hersey,harrigan,harbison,guyer,gish,giese,gerlach,geller,geisler,falcone,elwell,doucet,deese,darr,corder,chafin,byler,bussell,burdett,brasher,bowe,bellinger,bastian,barner,alleyne,wilborn,weil,wegner,tatro,spitzer,smithers,schoen,resendez,parisi,overman,obrian,mudd,mahler,maggio,lindner,lalonde,lacasse,laboy,killion,kahl,jessen,jamerson,houk,henshaw,gustin,graber,durst,duenas,davey,cundiff,conlon,colunga,coakley,chiles,capers,buell,bricker,bissonnette,bartz,bagby,zayas,volpe,treece,toombs,thom,terrazas,swinney,skiles,silveira,shouse,senn,ramage,moua,langham,kyles,holston,hoagland,herd,feller,denison,carraway,burford,bickel,ambriz,abercrombie,yamada,weidner,waddle,verduzco,thurmond,swindle,schrock,sanabria,rosenberger,probst,peabody,olinger,nazario,mccafferty,mcbroom,mcabee,mazur,matherne,mapes,leverett,killingsworth,heisler,griego,gosnell,frankel,franke,ferrante,fenn,ehrlich,christopherso,chasse,caton,brunelle,bloomfield,babbitt,azevedo,abramson,ables,abeyta,youmans,wozniak,wainwright,stowell,smitherman,samuelson,runge,rothman,rosenfeld,peake,owings,olmos,munro,moreira,leatherwood,larkins,krantz,kovacs,kizer,kindred,karnes,jaffe,hubbell,hosey,hauck,goodell,erdman,dvorak,doane,cureton,cofer,buehler,bierman,berndt,banta,abdullah,warwick,waltz,turcotte,torrey,stith,seger,sachs,quesada,pinder,peppers,pascual,paschall,parkhurst,ozuna,oster,nicholls,lheureux,lavalley,kimura,jablonski,haun,gourley,gilligan,croy,cotto,cargill,burwell,burgett,buckman,booher,adorno,wrenn,whittemore,urias,szabo,sayles,saiz,rutland,rael,pharr,pelkey,ogrady,nickell,musick,moats,mather,massa,kirschner,kieffer,kellar,hendershot,gott,godoy,gadson,furtado,fiedler,erskine,dutcher,dever,daggett,chevalier,brake,ballesteros,amerson,wingo,waldon,trott,silvey,showers,schlegel,ritz,pepin,pelayo,parsley,palermo,moorehead,mchale,lett,kocher,kilburn,iglesias,humble,hulbert,huckaby,hartford,hardiman,gurney,grigg,grasso,goings,fillmore,farber,depew,dandrea,cowen,covarrubias,burrus,bracy,ardoin,thompkins,standley,radcliffe,pohl,persaud,parenteau,pabon,newson,newhouse,napolitano,mulcahy,malave,keim,hooten,hernandes,heffernan,hearne,greenleaf,glick,fuhrman,fetter,faria,dishman,dickenson,crites,criss,clapper,chenault,castor,casto,bugg,bove,bonney,anderton,allgood,alderson,woodman,warrick,toomey,tooley,tarrant,summerville,stebbins,sokol,searles,schutz,schumann,scheer,remillard,raper,proulx,palmore,monroy,messier,melo,melanson,mashburn,manzano,lussier,jenks,huneycutt,hartwig,grimsley,fulk,fielding,fidler,engstrom,eldred,dantzler,crandell,calder,brumley,breton,brann,bramlett,boykins,bianco,bancroft,almaraz,alcantar,whitmer,whitener,welton,vineyard,rahn,paquin,mizell,mcmillin,mckean,marston,maciel,lundquist,liggins,lampkin,kranz,koski,kirkham,jiminez,hazzard,harrod,graziano,grammer,gendron,garrido,fordham,englert,dryden,demoss,deluna,crabb,comeau,brummett,blume,benally,wessel,vanbuskirk,thorson,stumpf,stockwell,reams,radtke,rackley,pelton,niemi,newland,nelsen,morrissette,miramontes,mcginley,mccluskey,marchant,luevano,lampe,lail,jeffcoat,infante,hinman,gaona,eady,desmarais,decosta,dansby,cisco,choe,breckenridge,bostwick,borg,bianchi,alberts,wilkie,whorton,vargo,tait,soucy,schuman,ousley,mumford,lippert,leath,lavergne,laliberte,kirksey,kenner,johnsen,izzo,hiles,gullett,greenwell,gaspar,galbreath,gaitan,ericson,delapaz,croom,cottingham,clift,bushnell,bice,beason,arrowood,waring,voorhees,truax,shreve,shockey,schatz,sandifer,rubino,rozier,roseberry,pieper,peden,nester,nave,murphey,malinowski,macgregor,lafrance,kunkle,kirkman,hipp,hasty,haddix,gervais,gerdes,gamache,fouts,fitzwater,dillingham,deming,deanda,cedeno,cannady,burson,bouldin,arceneaux,woodhouse,whitford,wescott,welty,weigel,torgerson,toms,surber,sunderland,sterner,setzer,riojas,pumphrey,puga,metts,mcgarry,mccandless,magill,lupo,loveland,llamas,leclerc,koons,kahler,huss,holbert,heintz,haupt,grimmett,gaskill,ellingson,dorr,dingess,deweese,desilva,crossley,cordeiro,converse,conde,caldera,cairns,burmeister,burkhalter,brawner,bott,youngs,vierra,valladares,shrum,shropshire,sevilla,rusk,rodarte,pedraza,nino,merino,mcminn,markle,mapp,lajoie,koerner,kittrell,kato,hyder,hollifield,heiser,hazlett,greenwald,fant,eldredge,dreher,delafuente,cravens,claypool,beecher,aronson,alanis,worthen,wojcik,winger,whitacre,valverde,valdivia,troupe,thrower,swindell,suttles,stroman,spires,slate,shealy,sarver,sartin,sadowski,rondeau,rolon,rascon,priddy,paulino,nolte,munroe,molloy,mciver,lykins,loggins,lenoir,klotz,kempf,hupp,hollowell,hollander,haynie,harkness,harker,gottlieb,frith,eddins,driskell,doggett,densmore,charette,cassady,byrum,burcham,buggs,benn,whitted,warrington,vandusen,vaillancourt,steger,siebert,scofield,quirk,purser,plumb,orcutt,nordstrom,mosely,michalski,mcphail,mcdavid,mccraw,marchese,mannino,lefevre,largent,lanza,kress,isham,hunsaker,hoch,hildebrandt,guarino,grijalva,graybill,fick,ewell,ewald,cusick,crumley,coston,cathcart,carruthers,bullington,bowes,blain,blackford,barboza,yingling,wert,weiland,varga,silverstein,sievers,shuster,shumway,runnels,rumsey,renfroe,provencher,polley,mohler,middlebrooks,kutz,koster,groth,glidden,fazio,deen,chipman,chenoweth,champlin,cedillo,carrero,carmody,buckles,brien,boutin,bosch,berkowitz,altamirano,wilfong,wiegand,waites,truesdale,toussaint,tobey,tedder,steelman,sirois,schnell,robichaud,richburg,plumley,pizarro,piercy,ortego,oberg,neace,mertz,mcnew,matta,lapp,lair,kibler,howlett,hollister,hofer,hatten,hagler,falgoust,engelhardt,eberle,dombrowski,dinsmore,daye,casares,braud,balch,autrey,wendel,tyndall,strobel,stoltz,spinelli,serrato,reber,rathbone,palomino,nickels,mayle,mathers,mach,loeffler,littrell,levinson,leong,lemire,lejeune,lazo,lasley,koller,kennard,hoelscher,hintz,hagerman,greaves,fore,eudy,engler,corrales,cordes,brunet,bidwell,bennet,tyrrell,tharpe,swinton,stribling,southworth,sisneros,savoie,samons,ruvalcaba,ries,ramer,omara,mosqueda,millar,mcpeak,macomber,luckey,litton,lehr,lavin,hubbs,hoard,hibbs,hagans,futrell,exum,evenson,culler,carbaugh,callen,brashear,bloomer,blakeney,bigler,addington,woodford,unruh,tolentino,sumrall,stgermain,smock,sherer,rayner,pooler,oquinn,nero,mcglothlin,linden,kowal,kerrigan,ibrahim,harvell,hanrahan,goodall,geist,fussell,fung,ferebee,eley,eggert,dorsett,dingman,destefano,colucci,clemmer,burnell,brumbaugh,boddie,berryhill,avelar,alcantara,winder,winchell,vandenberg,trotman,thurber,thibeault,stlouis,stilwell,sperling,shattuck,sarmiento,ruppert,rumph,renaud,randazzo,rademacher,quiles,pearman,palomo,mercurio,lowrey,lindeman,lawlor,larosa,lander,labrecque,hovis,holifield,henninger,hawkes,hartfield,hann,hague,genovese,garrick,fudge,frink,eddings,dinh,cribbs,calvillo,bunton,brodeur,bolding,blanding,agosto,zahn,wiener,trussell,tello,teixeira,speck,sharma,shanklin,sealy,scanlan,santamaria,roundy,robichaux,ringer,rigney,prevost,polson,nord,moxley,medford,mccaslin,mcardle,macarthur,lewin,lasher,ketcham,keiser,heine,hackworth,grose,grizzle,gillman,gartner,frazee,fleury,edson,edmonson,derry,cronk,conant,burress,burgin,broom,brockington,bolick,boger,birchfield,billington,baily,bahena,armbruster,anson,yoho,wilcher,tinney,timberlake,thielen,sutphin,stultz,sikora,serra,schulman,scheffler,santillan,rego,preciado,pinkham,mickle,lomas,lizotte,lent,kellerman,keil,johanson,hernadez,hartsfield,haber,gorski,farkas,eberhardt,duquette,delano,cropper,cozart,cockerham,chamblee,cartagena,cahoon,buzzell,brister,brewton,blackshear,benfield,aston,ashburn,arruda,wetmore,weise,vaccaro,tucci,sudduth,stromberg,stoops,showalter,shears,runion,rowden,rosenblum,riffle,renfrow,peres,obryant,leftwich,lark,landeros,kistler,killough,kerley,kastner,hoggard,hartung,guertin,govan,gatling,gailey,fullmer,fulford,flatt,esquibel,endicott,edmiston,edelstein,dufresne,dressler,dickman,chee,busse,bonnett,berard,yoshida,velarde,veach,vanhouten,vachon,tolson,tolman,tennyson,stites,soler,shutt,ruggles,rhone,pegues,neese,muro,moncrief,mefford,mcphee,mcmorris,mceachern,mcclurg,mansour,mader,leija,lecompte,lafountain,labrie,jaquez,heald,hash,hartle,gainer,frisby,farina,eidson,edgerton,dyke,durrett,duhon,cuomo,cobos,cervantez,bybee,brockway,borowski,binion,beery,arguello,amaro,acton,yuen,winton,wigfall,weekley,vidrine,vannoy,tardiff,shoop,shilling,schick,safford,prendergast,pilgrim,pellerin,osuna,nissen,nalley,moller,messner,messick,merrifield,mcguinness,matherly,marcano,mahone,lemos,lebrun,jara,hoffer,herren,hecker,haws,haug,gwin,gober,gilliard,fredette,favela,echeverria,downer,donofrio,desrochers,crozier,corson,bechtold,argueta,aparicio,zamudio,westover,westerman,utter,troyer,thies,tapley,slavin,shirk,sandler,roop,rimmer,raymer,radcliff,otten,moorer,millet,mckibben,mccutchen,mcavoy,mcadoo,mayorga,mastin,martineau,marek,madore,leflore,kroeger,kennon,jimerson,hostetter,hornback,hendley,hance,guardado,granado,gowen,goodale,flinn,fleetwood,fitz,durkee,duprey,dipietro,dilley,clyburn,brawley,beckley,arana,weatherby,vollmer,vestal,tunnell,trigg,tingle,takahashi,sweatt,storer,snapp,shiver,rooker,rathbun,poisson,perrine,perri,parmer,parke,pare,papa,palmieri,midkiff,mecham,mccomas,mcalpine,lovelady,lillard,lally,knopp,kile,kiger,haile,gupta,goldsberry,gilreath,fulks,friesen,franzen,flack,findlay,ferland,dreyer,dore,dennard,deckard,debose,crim,coulombe,chancey,cantor,branton,bissell,barns,woolard,witham,wasserman,spiegel,shoffner,scholz,ruch,rossman,petry,palacio,paez,neary,mortenson,millsap,miele,menke,mckim,mcanally,martines,lemley,larochelle,klaus,klatt,kaufmann,kapp,helmer,hedge,halloran,glisson,frechette,fontana,eagan,distefano,danley,creekmore,chartier,chaffee,carillo,burg,bolinger,berkley,benz,basso,bash,zelaya,woodring,witkowski,wilmot,wilkens,wieland,verdugo,urquhart,tsai,timms,swiger,swaim,sussman,pires,molnar,mcatee,lowder,loos,linker,landes,kingery,hufford,higa,hendren,hammack,hamann,gillam,gerhardt,edelman,delk,deans,curl,constantine,cleaver,claar,casiano,carruth,carlyle,brophy,bolanos,bibbs,bessette,beggs,baugher,bartel,averill,andresen,amin,adames,valente,turnbow,swink,sublett,stroh,stringfellow,ridgway,pugliese,poteat,ohare,neubauer,murchison,mingo,lemmons,kwon,kellam,kean,jarmon,hyden,hudak,hollinger,henkel,hemingway,hasson,hansel,halter,haire,ginsberg,gillispie,fogel,flory,etter,elledge,eckman,deas,currin,crafton,coomer,colter,claxton,bulter,braddock,bowyer,binns,bellows,baskerville,barros,ansley,woolf,wight,waldman,wadley,tull,trull,tesch,stouffer,stadler,slay,shubert,sedillo,santacruz,reinke,poynter,neri,neale,mowry,moralez,monger,mitchum,merryman,manion,macdougall,litchfield,levitt,lepage,lasalle,khoury,kavanagh,karns,ivie,huebner,hodgkins,halpin,garica,eversole,dutra,dunagan,duffey,dillman,dillion,deville,dearborn,damato,courson,coulson,burdine,bousquet,bonin,bish,atencio,westbrooks,wages,vaca,toner,tillis,swett,struble,stanfill,solorzano,slusher,sipple,silvas,shults,schexnayder,saez,rodas,rager,pulver,penton,paniagua,meneses,mcfarlin,mcauley,matz,maloy,magruder,lohman,landa,lacombe,jaimes,holzer,holst,heil,hackler,grundy,gilkey,farnham,durfee,dunton,dunston,duda,dews,craver,corriveau,conwell,colella,chambless,bremer,boutte,bourassa,blaisdell,backman,babineaux,audette,alleman,towner,taveras,tarango,sullins,suiter,stallard,solberg,schlueter,poulos,pimental,owsley,okelley,moffatt,metcalfe,meekins,medellin,mcglynn,mccowan,marriott,marable,lennox,lamoureux,koss,kerby,karp,isenberg,howze,hockenberry,highsmith,hallmark,gusman,greeley,giddings,gaudet,gallup,fleenor,eicher,edington,dimaggio,dement,demello,decastro,bushman,brundage,brooker,bourg,blackstock,bergmann,beaton,banister,argo,appling,wortman,watterson,villalpando,tillotson,tighe,sundberg,sternberg,stamey,shipe,seeger,scarberry,sattler,sain,rothstein,poteet,plowman,pettiford,penland,partain,pankey,oyler,ogletree,ogburn,moton,merkel,lucier,lakey,kratz,kinser,kershaw,josephson,imhoff,hendry,hammon,frisbie,frawley,fraga,forester,eskew,emmert,drennan,doyon,dandridge,cawley,carvajal,bracey,belisle,batey,ahner,wysocki,weiser,veliz,tincher,sansone,sankey,sandstrom,rohrer,risner,pridemore,pfeffer,persinger,peery,oubre,nowicki,musgrave,murdoch,mullinax,mccary,mathieu,livengood,kyser,klink,kimes,kellner,kavanaugh,kasten,imes,hoey,hinshaw,hake,gurule,grube,grillo,geter,gatto,garver,garretson,farwell,eiland,dunford,decarlo,corso,colman,collard,cleghorn,chasteen,cavender,carlile,calvo,byerly,brogdon,broadwater,breault,bono,bergin,behr,ballenger,amick,tamez,stiffler,steinke,simmon,shankle,schaller,salmons,sackett,saad,rideout,ratcliffe,ranson,plascencia,petterson,olszewski,olney,olguin,nilsson,nevels,morelli,montiel,monge,michaelson,mertens,mcchesney,mcalpin,mathewson,loudermilk,lineberry,liggett,kinlaw,kight,jost,hereford,hardeman,halpern,halliday,hafer,gaul,friel,freitag,forsberg,evangelista,doering,dicarlo,dendy,delp,deguzman,dameron,curtiss,cosper,cauthen,bradberry,bouton,bonnell,bixby,bieber,beveridge,bedwell,barhorst,bannon,baltazar,baier,ayotte,attaway,arenas,abrego,turgeon,tunstall,thaxton,tenorio,stotts,sthilaire,shedd,seabolt,scalf,salyers,ruhl,rowlett,robinett,pfister,perlman,pepe,parkman,nunnally,norvell,napper,modlin,mckellar,mcclean,mascarenas,leibowitz,ledezma,kuhlman,kobayashi,hunley,holmquist,hinkley,hazard,hartsell,gribble,gravely,fifield,eliason,doak,crossland,carleton,bridgeman,bojorquez,boggess,auten,woosley,whiteley,wexler,twomey,tullis,townley,standridge,santoyo,rueda,riendeau,revell,pless,ottinger,nigro,nickles,mulvey,menefee,mcshane,mcloughlin,mckinzie,markey,lockridge,lipsey,knisley,knepper,kitts,kiel,jinks,hathcock,godin,gallego,fikes,fecteau,estabrook,ellinger,dunlop,dudek,countryman,chauvin,chatham,bullins,brownfield,boughton,bloodworth,bibb,baucom,barbieri,aubin,armitage,alessi,absher,abbate,zito,woolery,wiggs,wacker,tynes,tolle,telles,tarter,swarey,strode,stockdale,stalnaker,spina,schiff,saari,risley,rameriz,rakes,pettaway,penner,paulus,palladino,omeara,montelongo,melnick,mehta,mcgary,mccourt,mccollough,marchetti,manzanares,lowther,leiva,lauderdale,lafontaine,kowalczyk,knighton,joubert,jaworski,huth,hurdle,housley,hackman,gulick,gordy,gilstrap,gehrke,gebhart,gaudette,foxworth,endres,dunkle,cimino,caddell,brauer,braley,bodine,blackmore,belden,backer,ayer,andress,wisner,vuong,valliere,twigg,tavarez,strahan,steib,staub,sowder,seiber,schutt,scharf,schade,rodriques,risinger,renshaw,rahman,presnell,piatt,nieman,nevins,mcilwain,mcgaha,mccully,mccomb,massengale,macedo,lesher,kearse,jauregui,husted,hudnall,holmberg,hertel,hardie,glidewell,frausto,fassett,dalessandro,dahlgren,corum,constantino,conlin,colquitt,colombo,claycomb,cardin,buller,boney,bocanegra,biggers,benedetto,araiza,andino,albin,zorn,werth,weisman,walley,vanegas,ulibarri,towe,tedford,teasley,suttle,steffens,stcyr,squire,singley,sifuentes,shuck,schram,sass,rieger,ridenhour,rickert,richerson,rayborn,rabe,raab,pendley,pastore,ordway,moynihan,mellott,mckissick,mcgann,mccready,mauney,marrufo,lenhart,lazar,lafave,keele,kautz,jardine,jahnke,jacobo,hord,hardcastle,hageman,giglio,gehring,fortson,duque,duplessis,dicken,derosier,deitz,dalessio,cram,castleman,candelario,callison,caceres,bozarth,biles,bejarano,bashaw,avina,armentrout,alverez,acord,waterhouse,vereen,vanlandingham,strawser,shotwell,severance,seltzer,schoonmaker,schock,schaub,schaffner,roeder,rodrigez,riffe,rasberry,rancourt,railey,quade,pursley,prouty,perdomo,oxley,osterman,nickens,murphree,mounts,merida,maus,mattern,masse,martinelli,mangan,lutes,ludwick,loney,laureano,lasater,knighten,kissinger,kimsey,kessinger,honea,hollingshead,hockett,heyer,heron,gurrola,gove,glasscock,gillett,galan,featherstone,eckhardt,duron,dunson,dasher,culbreth,cowden,cowans,claypoole,churchwell,chabot,caviness,cater,caston,callan,byington,burkey,boden,beckford,atwater,archambault,alvey,alsup,whisenant,weese,voyles,verret,tsang,tessier,sweitzer,sherwin,shaughnessy,revis,remy,prine,philpott,peavy,paynter,parmenter,ovalle,offutt,nightingale,newlin,nakano,myatt,muth,mohan,mcmillon,mccarley,mccaleb,maxson,marinelli,maley,liston,letendre,kain,huntsman,hirst,hagerty,gulledge,greenway,grajeda,gorton,goines,gittens,frederickson,fanelli,embree,eichelberger,dunkin,dixson,dillow,defelice,chumley,burleigh,borkowski,binette,biggerstaff,berglund,beller,audet,arbuckle,allain,alfano,youngman,wittman,weintraub,vanzant,vaden,twitty,stollings,standifer,sines,shope,scalise,saville,posada,pisano,otte,nolasco,mier,merkle,mendiola,melcher,mejias,mcmurry,mccalla,markowitz,manis,mallette,macfarlane,lough,looper,landin,kittle,kinsella,kinnard,hobart,helman,hellman,hartsock,halford,hage,gordan,glasser,gayton,gattis,gastelum,gaspard,frisch,fitzhugh,eckstein,eberly,dowden,despain,crumpler,crotty,cornelison,chouinard,chamness,catlin,cann,bumgardner,budde,branum,bradfield,braddy,borst,birdwell,bazan,banas,bade,arango,ahearn,addis,zumwalt,wurth,wilk,widener,wagstaff,urrutia,terwilliger,tart,steinman,staats,sloat,rives,riggle,revels,reichard,prickett,poff,pitzer,petro,pell,northrup,nicks,moline,mielke,maynor,mallon,magness,lingle,lindell,lieb,lesko,lebeau,lammers,lafond,kiernan,ketron,jurado,holmgren,hilburn,hayashi,hashimoto,harbaugh,guillot,gard,froehlich,feinberg,falco,dufour,drees,doney,diep,delao,daves,dail,crowson,coss,congdon,carner,camarena,butterworth,burlingame,bouffard,bloch,bilyeu,barta,bakke,baillargeon,avent,aquilar,zeringue,yarber,wolfson,vogler,voelker,truss,troxell,thrift,strouse,spielman,sistrunk,sevigny,schuller,schaaf,ruffner,routh,roseman,ricciardi,peraza,pegram,overturf,olander,odaniel,millner,melchor,maroney,machuca,macaluso,livesay,layfield,laskowski,kwiatkowski,kilby,hovey,heywood,hayman,havard,harville,haigh,hagood,grieco,glassman,gebhardt,fleischer,fann,elson,eccles,cunha,crumb,blakley,bardwell,abshire,woodham,wines,welter,wargo,varnado,tutt,traynor,swaney,stricker,stoffel,stambaugh,sickler,shackleford,selman,seaver,sansom,sanmiguel,royston,rourke,rockett,rioux,puleo,pitchford,nardi,mulvaney,middaugh,malek,leos,lathan,kujawa,kimbro,killebrew,houlihan,hinckley,herod,hepler,hamner,hammel,hallowell,gonsalez,gingerich,gambill,funkhouser,fricke,fewell,falkner,endsley,dulin,drennen,deaver,dambrosio,chadwell,castanon,burkes,brune,brisco,brinker,bowker,boldt,berner,beaumont,beaird,bazemore,barrick,albano,younts,wunderlich,weidman,vanness,toland,theobald,stickler,steiger,stanger,spies,spector,sollars,smedley,seibel,scoville,saito,rummel,rowles,rouleau,roos,rogan,roemer,ream,raya,purkey,priester,perreira,penick,paulin,parkins,overcash,oleson,neves,muldrow,minard,midgett,michalak,melgar,mcentire,mcauliffe,marte,lydon,lindholm,leyba,langevin,lagasse,lafayette,kesler,kelton,kaminsky,jaggers,humbert,huck,howarth,hinrichs,higley,gupton,guimond,gravois,giguere,fretwell,fontes,feeley,faucher,eichhorn,ecker,earp,dole,dinger,derryberry,demars,deel,copenhaver,collinsworth,colangelo,cloyd,claiborne,caulfield,carlsen,calzada,caffey,broadus,brenneman,bouie,bodnar,blaney,blanc,beltz,behling,barahona,yockey,winkle,windom,wimer,villatoro,trexler,teran,taliaferro,sydnor,swinson,snelling,smtih,simonton,simoneaux,simoneau,sherrer,seavey,scheel,rushton,rupe,ruano,rippy,reiner,reiff,rabinowitz,quach,penley,odle,nock,minnich,mckown,mccarver,mcandrew,longley,laux,lamothe,lafreniere,kropp,krick,kates,jepson,huie,howse,howie,henriques,haydon,haught,hatter,hartzog,harkey,grimaldo,goshorn,gormley,gluck,gilroy,gillenwater,giffin,fluker,feder,eyre,eshelman,eakins,detwiler,delrosario,davisson,catalan,canning,calton,brammer,botelho,blakney,bartell,averett,askins,aker,witmer,winkelman,widmer,whittier,weitzel,wardell,wagers,ullman,tupper,tingley,tilghman,talton,simard,seda,scheller,sala,rundell,rost,ribeiro,rabideau,primm,pinon,peart,ostrom,ober,nystrom,nussbaum,naughton,murr,moorhead,monti,monteiro,melson,meissner,mclin,mcgruder,marotta,makowski,majewski,madewell,lunt,lukens,leininger,lebel,lakin,kepler,jaques,hunnicutt,hungerford,hoopes,hertz,heins,halliburton,grosso,gravitt,glasper,gallman,gallaway,funke,fulbright,falgout,eakin,dostie,dorado,dewberry,derose,cutshall,crampton,costanzo,colletti,cloninger,claytor,chiang,campagna,burd,brokaw,broaddus,bretz,brainard,binford,bilbrey,alpert,aitken,ahlers,zajac,woolfolk,witten,windle,wayland,tramel,tittle,talavera,suter,straley,specht,sommerville,soloman,skeens,sigman,sibert,shavers,schuck,schmit,sartain,sabol,rosenblatt,rollo,rashid,rabb,polston,nyberg,northrop,navarra,muldoon,mikesell,mcdougald,mcburney,mariscal,lozier,lingerfelt,legere,latour,lagunas,lacour,kurth,killen,kiely,kayser,kahle,isley,huertas,hower,hinz,haugh,gumm,galicia,fortunato,flake,dunleavy,duggins,doby,digiovanni,devaney,deltoro,cribb,corpuz,coronel,coen,charbonneau,caine,burchette,blakey,blakemore,bergquist,beene,beaudette,bayles,ballance,bakker,bailes,asberry,arwood,zucker,willman,whitesell,wald,walcott,vancleave,trump,strasser,simas,shick,schleicher,schaal,saleh,rotz,resnick,rainer,partee,ollis,oller,oday,noles,munday,mong,millican,merwin,mazzola,mansell,magallanes,llanes,lewellen,lepore,kisner,keesee,jeanlouis,ingham,hornbeck,hawn,hartz,harber,haffner,gutshall,guth,grays,gowan,finlay,finkelstein,eyler,enloe,dungan,diez,dearman,cull,crosson,chronister,cassity,campion,callihan,butz,breazeale,blumenthal,berkey,batty,batton,arvizu,alderete,aldana,albaugh,abernethy,wolter,wille,tweed,tollefson,thomasson,teter,testerman,sproul,spates,southwick,soukup,skelly,senter,sealey,sawicki,sargeant,rossiter,rosemond,repp,pifer,ormsby,nickelson,naumann,morabito,monzon,millsaps,millen,mcelrath,marcoux,mantooth,madson,macneil,mackinnon,louque,leister,lampley,kushner,krouse,kirwan,jessee,janson,jahn,jacquez,islas,hutt,holladay,hillyer,hepburn,hensel,harrold,gingrich,geis,gales,fults,finnell,ferri,featherston,epley,ebersole,eames,dunigan,drye,dismuke,devaughn,delorenzo,damiano,confer,collum,clower,clow,claussen,clack,caylor,cawthon,casias,carreno,bluhm,bingaman,bewley,belew,beckner,auld,amey,wolfenbarger,wilkey,wicklund,waltman,villalba,valero,valdovinos,ullrich,tyus,twyman,trost,tardif,tanguay,stripling,steinbach,shumpert,sasaki,sappington,sandusky,reinhold,reinert,quijano,placencia,pinkard,phinney,perrotta,pernell,parrett,oxendine,owensby,orman,nuno,mori,mcroberts,mcneese,mckamey,mccullum,markel,mardis,maines,lueck,lubin,lefler,leffler,larios,labarbera,kershner,josey,jeanbaptiste,izaguirre,hermosillo,haviland,hartshorn,hafner,ginter,getty,franck,fiske,dufrene,doody,davie,dangerfield,dahlberg,cuthbertson,crone,coffelt,chidester,chesson,cauley,caudell,cantara,campo,caines,bullis,bucci,brochu,bogard,bickerstaff,benning,arzola,antonelli,adkinson,zellers,wulf,worsley,woolridge,whitton,westerfield,walczak,vassar,truett,trueblood,trawick,townsley,topping,tobar,telford,steverson,stagg,sitton,sill,sergent,schoenfeld,sarabia,rutkowski,rubenstein,rigdon,prentiss,pomerleau,plumlee,philbrick,patnode,oloughlin,obregon,nuss,morell,mikell,mele,mcinerney,mcguigan,mcbrayer,lollar,kuehl,kinzer,kamp,joplin,jacobi,howells,holstein,hedden,hassler,harty,halle,greig,gouge,goodrum,gerhart,geier,geddes,gast,forehand,ferree,fendley,feltner,esqueda,encarnacion,eichler,egger,edmundson,eatmon,doud,donohoe,donelson,dilorenzo,digiacomo,diggins,delozier,dejong,danford,crippen,coppage,cogswell,clardy,cioffi,cabe,brunette,bresnahan,blomquist,blackstone,biller,bevis,bevan,bethune,benbow,baty,basinger,balcom,andes,aman,aguero,adkisson,yandell,wilds,whisenhunt,weigand,weeden,voight,villar,trottier,tillett,suazo,setser,scurry,schuh,schreck,schauer,samora,roane,rinker,reimers,ratchford,popovich,parkin,natal,melville,mcbryde,magdaleno,loehr,lockman,lingo,leduc,larocca,lamere,laclair,krall,korte,koger,jalbert,hughs,higbee,henton,heaney,haith,gump,greeson,goodloe,gholston,gasper,gagliardi,fregoso,farthing,fabrizio,ensor,elswick,elgin,eklund,eaddy,drouin,dorton,dizon,derouen,deherrera,davy,dampier,cullum,culley,cowgill,cardoso,cardinale,brodsky,broadbent,brimmer,briceno,branscum,bolyard,boley,bennington,beadle,baur,ballentine,azure,aultman,arciniega,aguila,aceves,yepez,woodrum,wethington,weissman,veloz,trusty,troup,trammel,tarpley,stivers,steck,sprayberry,spraggins,spitler,spiers,sohn,seagraves,schiffman,rudnick,rizo,riccio,rennie,quackenbush,puma,plott,pearcy,parada,paiz,munford,moskowitz,mease,mcnary,mccusker,lozoya,longmire,loesch,lasky,kuhlmann,krieg,koziol,kowalewski,konrad,kindle,jowers,jolin,jaco,horgan,hine,hileman,hepner,heise,heady,hawkinson,hannigan,haberman,guilford,grimaldi,garton,gagliano,fruge,follett,fiscus,ferretti,ebner,easterday,eanes,dirks,dimarco,depalma,deforest,cruce,craighead,christner,candler,cadwell,burchell,buettner,brinton,brazier,brannen,brame,bova,bomar,blakeslee,belknap,bangs,balzer,athey,armes,alvis,alverson,alvardo,yeung,wheelock,westlund,wessels,volkman,threadgill,thelen,tague,symons,swinford,sturtevant,straka,stier,stagner,segarra,seawright,rutan,roux,ringler,riker,ramsdell,quattlebaum,purifoy,poulson,permenter,peloquin,pasley,pagel,osman,obannon,nygaard,newcomer,munos,motta,meadors,mcquiston,mcniel,mcmann,mccrae,mayne,matte,legault,lechner,kucera,krohn,kratzer,koopman,jeske,horrocks,hock,hibbler,hesson,hersh,harvin,halvorsen,griner,grindle,gladstone,garofalo,frampton,forbis,eddington,diorio,dingus,dewar,desalvo,curcio,creasy,cortese,cordoba,connally,cluff,cascio,capuano,canaday,calabro,bussard,brayton,borja,bigley,arnone,arguelles,acuff,zamarripa,wooton,widner,wideman,threatt,thiele,templin,teeters,synder,swint,swick,sturges,stogner,stedman,spratt,siegfried,shetler,scull,savino,sather,rothwell,rook,rone,rhee,quevedo,privett,pouliot,poche,pickel,petrillo,pellegrini,peaslee,partlow,otey,nunnery,morelock,morello,meunier,messinger,mckie,mccubbin,mccarron,lerch,lavine,laverty,lariviere,lamkin,kugler,krol,kissel,keeter,hubble,hickox,hetzel,hayner,hagy,hadlock,groh,gottschalk,goodsell,gassaway,garrard,galligan,firth,fenderson,feinstein,etienne,engleman,emrick,ellender,drews,doiron,degraw,deegan,dart,crissman,corr,cookson,coil,cleaves,charest,chapple,chaparro,castano,carpio,byer,bufford,bridgewater,bridgers,brandes,borrero,bonanno,aube,ancheta,abarca,abad,wooster,wimbush,willhite,willams,wigley,weisberg,wardlaw,vigue,vanhook,unknow,torre,tasker,tarbox,strachan,slover,shamblin,semple,schuyler,schrimsher,sayer,salzman,rubalcava,riles,reneau,reichel,rayfield,rabon,pyatt,prindle,poss,polito,plemmons,pesce,perrault,pereyra,ostrowski,nilsen,niemeyer,munsey,mundell,moncada,miceli,meader,mcmasters,mckeehan,matsumoto,marron,marden,lizarraga,lingenfelter,lewallen,langan,lamanna,kovac,kinsler,kephart,keown,kass,kammerer,jeffreys,hysell,hosmer,hardnett,hanner,guyette,greening,glazer,ginder,fromm,fluellen,finkle,fessler,essary,eisele,duren,dittmer,crochet,cosentino,cogan,coelho,cavin,carrizales,campuzano,brough,bopp,bookman,bobb,blouin,beesley,battista,bascom,bakken,badgett,arneson,anselmo,albino,ahumada,woodyard,wolters,wireman,willison,warman,waldrup,vowell,vantassel,twombly,toomer,tennison,teets,tedeschi,swanner,stutz,stelly,sheehy,schermerhorn,scala,sandidge,salters,salo,saechao,roseboro,rolle,ressler,renz,renn,redford,raposa,rainbolt,pelfrey,orndorff,oney,nolin,nimmons,nardone,myhre,morman,menjivar,mcglone,mccammon,maxon,marciano,manus,lowrance,lorenzen,lonergan,lollis,littles,lindahl,lamas,lach,kuster,krawczyk,knuth,knecht,kirkendall,keitt,keever,kantor,jarboe,hoye,houchens,holter,holsinger,hickok,helwig,helgeson,hassett,harner,hamman,hames,hadfield,goree,goldfarb,gaughan,gaudreau,gantz,gallion,frady,foti,flesher,ferrin,faught,engram,donegan,desouza,degroot,cutright,crowl,criner,coan,clinkscales,chewning,chavira,catchings,carlock,bulger,buenrostro,bramblett,brack,boulware,bookout,bitner,birt,baranowski,baisden,allmon,acklin,yoakum,wilbourn,whisler,weinberger,washer,vasques,vanzandt,vanatta,troxler,tomes,tindle,tims,throckmorton,thach,stpeter,stlaurent,stenson,spry,spitz,songer,snavely,shroyer,shortridge,shenk,sevier,seabrook,scrivner,saltzman,rosenberry,rockwood,robeson,roan,reiser,ramires,raber,posner,popham,piotrowski,pinard,peterkin,pelham,peiffer,peay,nadler,musso,millett,mestas,mcgowen,marques,marasco,manriquez,manos,mair,lipps,leiker,krumm,knorr,kinslow,kessel,kendricks,kelm,irick,ickes,hurlburt,horta,hoekstra,heuer,helmuth,heatherly,hampson,hagar,haga,greenlaw,grau,godbey,gingras,gillies,gibb,gayden,gauvin,garrow,fontanez,florio,finke,fasano,ezzell,ewers,eveland,eckenrode,duclos,drumm,dimmick,delancey,defazio,dashiell,cusack,crowther,crigger,cray,coolidge,coldiron,cleland,chalfant,cassel,camire,cabrales,broomfield,brittingham,brisson,brickey,braziel,brazell,bragdon,boulanger,boman,bohannan,beem,barre,azar,ashbaugh,armistead,almazan,adamski,zendejas,winburn,willaims,wilhoit,westberry,wentzel,wendling,visser,vanscoy,vankirk,vallee,tweedy,thornberry,sweeny,spradling,spano,smelser,shim,sechrist,schall,scaife,rugg,rothrock,roesler,riehl,ridings,render,ransdell,radke,pinero,petree,pendergast,peluso,pecoraro,pascoe,panek,oshiro,navarrette,murguia,moores,moberg,michaelis,mcwhirter,mcsweeney,mcquade,mccay,mauk,mariani,marceau,mandeville,maeda,lunde,ludlow,loeb,lindo,linderman,leveille,leith,larock,lambrecht,kulp,kinsley,kimberlin,kesterson,hoyos,helfrich,hanke,grisby,goyette,gouveia,glazier,gile,gerena,gelinas,gasaway,funches,fujimoto,flynt,fenske,fellers,fehr,eslinger,escalera,enciso,duley,dittman,dineen,diller,devault,collings,clymer,clowers,chavers,charland,castorena,castello,camargo,bunce,bullen,boyes,borchers,borchardt,birnbaum,birdsall,billman,benites,bankhead,ange,ammerman,adkison,winegar,wickman,warr,warnke,villeneuve,veasey,vassallo,vannatta,vadnais,twilley,towery,tomblin,tippett,theiss,talkington,talamantes,swart,swanger,streit,stines,stabler,spurling,sobel,sine,simmers,shippy,shiflett,shearin,sauter,sanderlin,rusch,runkle,ruckman,rorie,roesch,richert,rehm,randel,ragin,quesenberry,puentes,plyler,plotkin,paugh,oshaughnessy,ohalloran,norsworthy,niemann,nader,moorefield,mooneyham,modica,miyamoto,mickel,mebane,mckinnie,mazurek,mancilla,lukas,lovins,loughlin,lotz,lindsley,liddle,levan,lederman,leclaire,lasseter,lapoint,lamoreaux,lafollette,kubiak,kirtley,keffer,kaczmarek,housman,hiers,hibbert,herrod,hegarty,hathorn,greenhaw,grafton,govea,futch,furst,franko,forcier,foran,flickinger,fairfield,eure,emrich,embrey,edgington,ecklund,eckard,durante,deyo,delvecchio,dade,currey,creswell,cottrill,casavant,cartier,cargile,capel,cammack,calfee,burse,burruss,brust,brousseau,bridwell,braaten,borkholder,bloomquist,bjork,bartelt,amburgey,yeary,whitefield,vinyard,vanvalkenburg,twitchell,timmins,tapper,stringham,starcher,spotts,slaugh,simonsen,sheffer,sequeira,rosati,rhymes,quint,pollak,peirce,patillo,parkerson,paiva,nilson,nevin,narcisse,mitton,merriam,merced,meiners,mckain,mcelveen,mcbeth,marsden,marez,manke,mahurin,mabrey,luper,krull,hunsicker,hornbuckle,holtzclaw,hinnant,heston,hering,hemenway,hegwood,hearns,halterman,guiterrez,grote,granillo,grainger,glasco,gilder,garren,garlock,garey,fryar,fredricks,fraizer,foshee,ferrel,felty,everitt,evens,esser,elkin,eberhart,durso,duguay,driskill,doster,dewall,deveau,demps,demaio,delreal,deleo,darrah,cumberbatch,culberson,cranmer,cordle,colgan,chesley,cavallo,castellon,castelli,carreras,carnell,carlucci,bontrager,blumberg,blasingame,becton,artrip,andujar,alkire,alder,zukowski,zuckerman,wroblewski,wrigley,woodside,wigginton,westman,westgate,werts,washam,wardlow,walser,waiters,tadlock,stringfield,stimpson,stickley,standish,spurlin,spindler,speller,spaeth,sotomayor,sluder,shryock,shepardson,shatley,scannell,santistevan,rosner,resto,reinhard,rathburn,prisco,poulsen,pinney,phares,pennock,pastrana,oviedo,ostler,nauman,mulford,moise,moberly,mirabal,metoyer,metheny,mentzer,meldrum,mcinturff,mcelyea,mcdougle,massaro,lumpkins,loveday,lofgren,lirette,lesperance,lefkowitz,ledger,lauzon,lachapelle,klassen,keough,kempton,kaelin,jeffords,hsieh,hoyer,horwitz,hoeft,hennig,haskin,gourdine,golightly,girouard,fulgham,fritsch,freer,frasher,foulk,firestone,fiorentino,fedor,ensley,englehart,eells,dunphy,donahoe,dileo,dibenedetto,dabrowski,crick,coonrod,conder,coddington,chunn,chaput,cerna,carreiro,calahan,braggs,bourdon,bollman,bittle,bauder,barreras,aubuchon,anzalone,adamo,zerbe,willcox,westberg,weikel,waymire,vroman,vinci,vallejos,truesdell,troutt,trotta,tollison,toles,tichenor,symonds,surles,strayer,stgeorge,sroka,sorrentino,solares,snelson,silvestri,sikorski,shawver,schumaker,schorr,schooley,scates,satterlee,satchell,rymer,roselli,robitaille,riegel,regis,reames,provenzano,priestley,plaisance,pettey,palomares,nowakowski,monette,minyard,mclamb,mchone,mccarroll,masson,magoon,maddy,lundin,licata,leonhardt,landwehr,kircher,kinch,karpinski,johannsen,hussain,houghtaling,hoskinson,hollaway,holeman,hobgood,hiebert,goggin,geissler,gadbois,gabaldon,fleshman,flannigan,fairman,eilers,dycus,dunmire,duffield,dowler,deloatch,dehaan,deemer,clayborn,christofferso,chilson,chesney,chatfield,carron,canale,brigman,branstetter,bosse,borton,bonar,biron,barroso,arispe,zacharias,zabel,yaeger,woolford,whetzel,weakley,veatch,vandeusen,tufts,troxel,troche,traver,townsel,talarico,swilley,sterrett,stenger,speakman,sowards,sours,souders,souder,soles,sobers,snoddy,smither,shute,shoaf,shahan,schuetz,scaggs,santini,rosson,rolen,robidoux,rentas,recio,pixley,pawlowski,pawlak,paull,overbey,orear,oliveri,oldenburg,nutting,naugle,mossman,misner,milazzo,michelson,mcentee,mccullar,mccree,mcaleer,mazzone,mandell,manahan,malott,maisonet,mailloux,lumley,lowrie,louviere,lipinski,lindemann,leppert,leasure,labarge,kubik,knisely,knepp,kenworthy,kennelly,kelch,kanter,houchin,hosley,hosler,hollon,holleman,heitman,haggins,gwaltney,goulding,gorden,geraci,gathers,frison,feagin,falconer,espada,erving,erikson,eisenhauer,ebeling,durgin,dowdle,dinwiddie,delcastillo,dedrick,crimmins,covell,cournoyer,coria,cohan,cataldo,carpentier,canas,campa,brode,brashears,blaser,bicknell,bednar,barwick,ascencio,althoff,almodovar,alamo,zirkle,zabala,wolverton,winebrenner,wetherell,westlake,wegener,weddington,tuten,trosclair,tressler,theroux,teske,swinehart,swensen,sundquist,southall,socha,sizer,silverberg,shortt,shimizu,sherrard,shaeffer,scheid,scheetz,saravia,sanner,rubinstein,rozell,romer,rheaume,reisinger,randles,pullum,petrella,payan,nordin,norcross,nicoletti,nicholes,newbold,nakagawa,monteith,milstead,milliner,mellen,mccardle,liptak,leitch,latimore,larrison,landau,laborde,koval,izquierdo,hymel,hoskin,holte,hoefer,hayworth,hausman,harrill,harrel,hardt,gully,groover,grinnell,greenspan,graver,grandberry,gorrell,goldenberg,goguen,gilleland,fuson,feldmann,everly,dyess,dunnigan,downie,dolby,deatherage,cosey,cheever,celaya,caver,cashion,caplinger,cansler,byrge,bruder,breuer,breslin,brazelton,botkin,bonneau,bondurant,bohanan,bogue,bodner,boatner,blatt,bickley,belliveau,beiler,beier,beckstead,bachmann,atkin,altizer,alloway,allaire,albro,abron,zellmer,yetter,yelverton,wiens,whidden,viramontes,vanwormer,tarantino,tanksley,sumlin,strauch,strang,stice,spahn,sosebee,sigala,shrout,seamon,schrum,schneck,schantz,ruddy,romig,roehl,renninger,reding,polak,pohlman,pasillas,oldfield,oldaker,ohanlon,ogilvie,norberg,nolette,neufeld,nellis,mummert,mulvihill,mullaney,monteleone,mendonca,meisner,mcmullan,mccluney,mattis,massengill,manfredi,luedtke,lounsbury,liberatore,lamphere,laforge,jourdan,iorio,iniguez,ikeda,hubler,hodgdon,hocking,heacock,haslam,haralson,hanshaw,hannum,hallam,haden,garnes,garces,gammage,gambino,finkel,faucett,ehrhardt,eggen,dusek,durrant,dubay,dones,depasquale,delucia,degraff,decamp,davalos,cullins,conard,clouser,clontz,cifuentes,chappel,chaffins,celis,carwile,byram,bruggeman,bressler,brathwaite,brasfield,bradburn,boose,bodie,blosser,bertsch,bernardi,bernabe,bengtson,barrette,astorga,alday,albee,abrahamson,yarnell,wiltse,wiebe,waguespack,vasser,upham,turek,traxler,torain,tomaszewski,tinnin,tiner,tindell,styron,stahlman,staab,skiba,sheperd,seidl,secor,schutte,sanfilippo,ruder,rondon,rearick,procter,prochaska,pettengill,pauly,neilsen,nally,mullenax,morano,meads,mcnaughton,mcmurtry,mcmath,mckinsey,matthes,massenburg,marlar,margolis,malin,magallon,mackin,lovette,loughran,loring,longstreet,loiselle,lenihan,kunze,koepke,kerwin,kalinowski,kagan,innis,innes,holtzman,heinemann,harshman,haider,haack,grondin,grissett,greenawalt,goudy,goodlett,goldston,gokey,gardea,galaviz,gafford,gabrielson,furlow,fritch,fordyce,folger,elizalde,ehlert,eckhoff,eccleston,ealey,dubin,diemer,deschamps,delapena,decicco,debolt,cullinan,crittendon,crase,cossey,coppock,coots,colyer,cluck,chamberland,burkhead,bumpus,buchan,borman,birkholz,berardi,benda,behnke,barter,amezquita,wotring,wirtz,wingert,wiesner,whitesides,weyant,wainscott,venezia,varnell,tussey,thurlow,tabares,stiver,stell,starke,stanhope,stanek,sisler,sinnott,siciliano,shehan,selph,seager,scurlock,scranton,santucci,santangelo,saltsman,rogge,rettig,renwick,reidy,reider,redfield,premo,parente,paolucci,palmquist,ohler,netherton,mutchler,morita,mistretta,minnis,middendorf,menzel,mendosa,mendelson,meaux,mcspadden,mcquaid,mcnatt,manigault,maney,mager,lukes,lopresti,liriano,letson,lechuga,lazenby,lauria,larimore,krupp,krupa,kopec,kinchen,kifer,kerney,kerner,kennison,kegley,karcher,justis,johson,jellison,janke,huskins,holzman,hinojos,hefley,hatmaker,harte,halloway,hallenbeck,goodwyn,glaspie,geise,fullwood,fryman,frakes,fraire,farrer,enlow,engen,ellzey,eckles,earles,dunkley,drinkard,dreiling,draeger,dinardo,dills,desroches,desantiago,curlee,crumbley,critchlow,coury,courtright,coffield,cleek,charpentier,cardone,caples,cantin,buntin,bugbee,brinkerhoff,brackin,bourland,blassingame,beacham,banning,auguste,andreasen,amann,almon,alejo,adelman,abston,yerger,wymer,woodberry,windley,whiteaker,westfield,weibel,wanner,waldrep,villani,vanarsdale,utterback,updike,triggs,topete,tolar,tigner,thoms,tauber,tarvin,tally,swiney,sweatman,studebaker,stennett,starrett,stannard,stalvey,sonnenberg,smithey,sieber,sickles,shinault,segars,sanger,salmeron,rothe,rizzi,restrepo,ralls,ragusa,quiroga,papenfuss,oropeza,okane,mudge,mozingo,molinaro,mcvicker,mcgarvey,mcfalls,mccraney,matus,magers,llanos,livermore,linehan,leitner,laymon,lawing,lacourse,kwong,kollar,kneeland,kennett,kellett,kangas,janzen,hutter,huling,hofmeister,hewes,harjo,habib,guice,grullon,greggs,grayer,granier,grable,gowdy,giannini,getchell,gartman,garnica,ganey,gallimore,fetters,fergerson,farlow,fagundes,exley,esteves,enders,edenfield,easterwood,drakeford,dipasquale,desousa,deshields,deeter,dedmon,debord,daughtery,cutts,courtemanche,coursey,copple,coomes,collis,cogburn,clopton,choquette,chaidez,castrejon,calhoon,burbach,bulloch,buchman,bruhn,bohon,blough,baynes,barstow,zeman,zackery,yardley,yamashita,wulff,wilken,wiliams,wickersham,wible,whipkey,wedgeworth,walmsley,walkup,vreeland,verrill,umana,traub,swingle,summey,stroupe,stockstill,steffey,stefanski,statler,stapp,speights,solari,soderberg,shunk,shorey,shewmaker,sheilds,schiffer,schank,schaff,sagers,rochon,riser,rickett,reale,raglin,polen,plata,pitcock,percival,palen,orona,oberle,nocera,navas,nault,mullings,montejano,monreal,minick,middlebrook,meece,mcmillion,mccullen,mauck,marshburn,maillet,mahaney,magner,maclin,lucey,litteral,lippincott,leite,leaks,lamarre,jurgens,jerkins,jager,hurwitz,hughley,hotaling,horstman,hohman,hocker,hively,hipps,hessler,hermanson,hepworth,helland,hedlund,harkless,haigler,gutierez,grindstaff,glantz,giardina,gerken,gadsden,finnerty,farnum,encinas,drakes,dennie,cutlip,curtsinger,couto,cortinas,corby,chiasson,carle,carballo,brindle,borum,bober,blagg,berthiaume,beahm,batres,basnight,backes,axtell,atterberry,alvares,alegria,woodell,wojciechowski,winfree,winbush,wiest,wesner,wamsley,wakeman,verner,truex,trafton,toman,thorsen,theus,tellier,tallant,szeto,strope,stills,simkins,shuey,shaul,servin,serio,serafin,salguero,ryerson,rudder,ruark,rother,rohrbaugh,rohrbach,rohan,rogerson,risher,reeser,pryce,prokop,prins,priebe,prejean,pinheiro,petrone,petri,penson,pearlman,parikh,natoli,murakami,mullikin,mullane,motes,morningstar,mcveigh,mcgrady,mcgaughey,mccurley,marchan,manske,lusby,linde,likens,licon,leroux,lemaire,legette,laskey,laprade,laplant,kolar,kittredge,kinley,kerber,kanagy,jetton,janik,ippolito,inouye,hunsinger,howley,howery,horrell,holthaus,hiner,hilson,hilderbrand,hartzler,harnish,harada,hansford,halligan,hagedorn,gwynn,gudino,greenstein,greear,gracey,goudeau,goodner,ginsburg,gerth,gerner,fujii,frier,frenette,folmar,fleisher,fleischmann,fetzer,eisenman,earhart,dupuy,dunkelberger,drexler,dillinger,dilbeck,dewald,demby,deford,craine,chesnut,casady,carstens,carrick,carino,carignan,canchola,bushong,burman,buono,brownlow,broach,britten,brickhouse,boyden,boulton,borland,bohrer,blubaugh,bever,berggren,benevides,arocho,arends,amezcua,almendarez,zalewski,witzel,winkfield,wilhoite,vangundy,vanfleet,vanetten,vandergriff,urbanski,troiano,thibodaux,straus,stoneking,stjean,stillings,stange,speicher,speegle,smeltzer,slawson,simmonds,shuttleworth,serpa,senger,seidman,schweiger,schloss,schimmel,schechter,sayler,sabatini,ronan,rodiguez,riggleman,richins,reamer,prunty,porath,plunk,piland,philbrook,pettitt,perna,peralez,pascale,padula,oboyle,nivens,nickols,mundt,munden,montijo,mcmanis,mcgrane,mccrimmon,manzi,mangold,malick,mahar,maddock,losey,litten,leedy,leavell,ladue,krahn,kluge,junker,iversen,imler,hurtt,huizar,hubbert,howington,hollomon,holdren,hoisington,heiden,hauge,hartigan,gutirrez,griffie,greenhill,gratton,granata,gottfried,gertz,gautreaux,furry,furey,funderburg,flippen,fitzgibbon,drucker,donoghue,dildy,devers,detweiler,despres,denby,degeorge,cueto,cranston,courville,clukey,cirillo,chivers,caudillo,butera,bulluck,buckmaster,braunstein,bracamonte,bourdeau,bonnette".split(","),
  us_tv_and_film: "you,i,to,that,it,me,what,this,know,i'm,no,have,my,don't,just,not,do,be,your,we,it's,so,but,all,well,oh,about,right,you're,get,here,out,going,like,yeah,if,can,up,want,think,that's,now,go,him,how,got,did,why,see,come,good,really,look,will,okay,back,can't,mean,tell,i'll,hey,he's,could,didn't,yes,something,because,say,take,way,little,make,need,gonna,never,we're,too,she's,i've,sure,our,sorry,what's,let,thing,maybe,down,man,very,there's,should,anything,said,much,any,even,off,please,doing,thank,give,thought,help,talk,god,still,wait,find,nothing,again,things,let's,doesn't,call,told,great,better,ever,night,away,believe,feel,everything,you've,fine,last,keep,does,put,around,stop,they're,i'd,guy,isn't,always,listen,wanted,guys,huh,those,big,lot,happened,thanks,won't,trying,kind,wrong,talking,guess,care,bad,mom,remember,getting,we'll,together,dad,leave,understand,wouldn't,actually,hear,baby,nice,father,else,stay,done,wasn't,course,might,mind,every,enough,try,hell,came,someone,you'll,whole,yourself,idea,ask,must,coming,looking,woman,room,knew,tonight,real,son,hope,went,hmm,happy,pretty,saw,girl,sir,friend,already,saying,next,job,problem,minute,thinking,haven't,heard,honey,matter,myself,couldn't,exactly,having,probably,happen,we've,hurt,boy,dead,gotta,alone,excuse,start,kill,hard,you'd,today,car,ready,without,wants,hold,wanna,yet,seen,deal,once,gone,morning,supposed,friends,head,stuff,worry,live,truth,face,forget,true,cause,soon,knows,telling,wife,who's,chance,run,move,anyone,person,bye,somebody,heart,miss,making,meet,anyway,phone,reason,damn,lost,looks,bring,case,turn,wish,tomorrow,kids,trust,check,change,anymore,least,aren't,working,makes,taking,means,brother,hate,ago,says,beautiful,gave,fact,crazy,sit,afraid,important,rest,fun,kid,word,watch,glad,everyone,sister,minutes,everybody,bit,couple,whoa,either,mrs,feeling,daughter,wow,gets,asked,break,promise,door,close,hand,easy,question,tried,far,walk,needs,mine,killed,hospital,anybody,alright,wedding,shut,able,die,perfect,stand,comes,hit,waiting,dinner,funny,husband,almost,pay,answer,cool,eyes,news,child,shouldn't,yours,moment,sleep,read,where's,sounds,sonny,pick,sometimes,bed,date,plan,hours,lose,hands,serious,shit,behind,inside,ahead,week,wonderful,fight,past,cut,quite,he'll,sick,it'll,eat,nobody,goes,save,seems,finally,lives,worried,upset,carly,met,brought,seem,sort,safe,weren't,leaving,front,shot,loved,asking,running,clear,figure,hot,felt,parents,drink,absolutely,how's,daddy,sweet,alive,sense,meant,happens,bet,blood,ain't,kidding,lie,meeting,dear,seeing,sound,fault,ten,buy,hour,speak,lady,jen,thinks,christmas,outside,hang,possible,worse,mistake,ooh,handle,spend,totally,giving,here's,marriage,realize,unless,sex,send,needed,scared,picture,talked,ass,hundred,changed,completely,explain,certainly,sign,boys,relationship,loves,hair,lying,choice,anywhere,future,weird,luck,she'll,turned,touch,kiss,crane,questions,obviously,wonder,pain,calling,somewhere,throw,straight,cold,fast,words,food,none,drive,feelings,they'll,marry,drop,cannot,dream,protect,twenty,surprise,sweetheart,poor,looked,mad,except,gun,y'know,dance,takes,appreciate,especially,situation,besides,pull,hasn't,worth,sheridan,amazing,expect,swear,piece,busy,happening,movie,we'd,catch,perhaps,step,fall,watching,kept,darling,dog,honor,moving,till,admit,problems,murder,he'd,evil,definitely,feels,honest,eye,broke,missed,longer,dollars,tired,evening,starting,entire,trip,niles,suppose,calm,imagine,fair,caught,blame,sitting,favor,apartment,terrible,clean,learn,frasier,relax,accident,wake,prove,smart,message,missing,forgot,interested,table,nbsp,mouth,pregnant,ring,careful,shall,dude,ride,figured,wear,shoot,stick,follow,angry,write,stopped,ran,standing,forgive,jail,wearing,ladies,kinda,lunch,cristian,greenlee,gotten,hoping,phoebe,thousand,ridge,paper,tough,tape,count,boyfriend,proud,agree,birthday,they've,share,offer,hurry,feet,wondering,decision,ones,finish,voice,herself,would've,mess,deserve,evidence,cute,dress,interesting,hotel,enjoy,quiet,concerned,staying,beat,sweetie,mention,clothes,fell,neither,mmm,fix,respect,prison,attention,holding,calls,surprised,bar,keeping,gift,hadn't,putting,dark,owe,ice,helping,normal,aunt,lawyer,apart,plans,jax,girlfriend,floor,whether,everything's,box,judge,upstairs,sake,mommy,possibly,worst,acting,accept,blow,strange,saved,conversation,plane,mama,yesterday,lied,quick,lately,stuck,difference,store,she'd,bought,doubt,listening,walking,cops,deep,dangerous,buffy,sleeping,chloe,rafe,join,card,crime,gentlemen,willing,window,walked,guilty,likes,fighting,difficult,soul,joke,favorite,uncle,promised,bother,seriously,cell,knowing,broken,advice,somehow,paid,losing,push,helped,killing,boss,liked,innocent,rules,learned,thirty,risk,letting,speaking,ridiculous,afternoon,apologize,nervous,charge,patient,boat,how'd,hide,detective,planning,huge,breakfast,horrible,awful,pleasure,driving,hanging,picked,sell,quit,apparently,dying,notice,congratulations,visit,could've,c'mon,letter,decide,forward,fool,showed,smell,seemed,spell,memory,pictures,slow,seconds,hungry,hearing,kitchen,ma'am,should've,realized,kick,grab,discuss,fifty,reading,idiot,suddenly,agent,destroy,bucks,shoes,peace,arms,demon,livvie,consider,papers,incredible,witch,drunk,attorney,tells,knock,ways,gives,nose,skye,turns,keeps,jealous,drug,sooner,cares,plenty,extra,outta,weekend,matters,gosh,opportunity,impossible,waste,pretend,jump,eating,proof,slept,arrest,breathe,perfectly,warm,pulled,twice,easier,goin,dating,suit,romantic,drugs,comfortable,finds,checked,divorce,begin,ourselves,closer,ruin,smile,laugh,treat,fear,what'd,otherwise,excited,mail,hiding,stole,pacey,noticed,fired,excellent,bringing,bottom,note,sudden,bathroom,honestly,sing,foot,remind,charges,witness,finding,tree,dare,hardly,that'll,steal,silly,contact,teach,shop,plus,colonel,fresh,trial,invited,roll,reach,dirty,choose,emergency,dropped,butt,credit,obvious,locked,loving,nuts,agreed,prue,goodbye,condition,guard,fuckin,grow,cake,mood,crap,crying,belong,partner,trick,pressure,dressed,taste,neck,nurse,raise,lots,carry,whoever,drinking,they'd,breaking,file,lock,wine,spot,paying,assume,asleep,turning,viki,bedroom,shower,nikolas,camera,fill,reasons,forty,bigger,nope,breath,doctors,pants,freak,movies,folks,cream,wild,truly,desk,convince,client,threw,hurts,spending,answers,shirt,chair,rough,doin,sees,ought,empty,wind,aware,dealing,pack,tight,hurting,guest,arrested,salem,confused,surgery,expecting,deacon,unfortunately,goddamn,bottle,beyond,whenever,pool,opinion,starts,jerk,secrets,falling,necessary,barely,dancing,tests,copy,cousin,ahem,twelve,tess,skin,fifteen,speech,orders,complicated,nowhere,escape,biggest,restaurant,grateful,usual,burn,address,someplace,screw,everywhere,regret,goodness,mistakes,details,responsibility,suspect,corner,hero,dumb,terrific,whoo,hole,memories,o'clock,teeth,ruined,bite,stenbeck,liar,showing,cards,desperate,search,pathetic,spoke,scare,marah,afford,settle,stayed,checking,hired,heads,concern,blew,alcazar,champagne,connection,tickets,happiness,saving,kissing,hated,personally,suggest,prepared,onto,downstairs,ticket,it'd,loose,holy,duty,convinced,throwing,kissed,legs,loud,saturday,babies,where'd,warning,miracle,carrying,blind,ugly,shopping,hates,sight,bride,coat,clearly,celebrate,brilliant,wanting,forrester,lips,custody,screwed,buying,toast,thoughts,reality,lexie,attitude,advantage,grandfather,sami,grandma,someday,roof,marrying,powerful,grown,grandmother,fake,must've,ideas,exciting,familiar,bomb,bout,harmony,schedule,capable,practically,correct,clue,forgotten,appointment,deserves,threat,bloody,lonely,shame,jacket,hook,scary,investigation,invite,shooting,lesson,criminal,victim,funeral,considering,burning,strength,harder,sisters,pushed,shock,pushing,heat,chocolate,miserable,corinthos,nightmare,brings,zander,crash,chances,sending,recognize,healthy,boring,feed,engaged,headed,treated,knife,drag,badly,hire,paint,pardon,behavior,closet,warn,gorgeous,milk,survive,ends,dump,rent,remembered,thanksgiving,rain,revenge,prefer,spare,pray,disappeared,aside,statement,sometime,meat,fantastic,breathing,laughing,stood,affair,ours,depends,protecting,jury,brave,fingers,murdered,explanation,picking,blah,stronger,handsome,unbelievable,anytime,shake,oakdale,wherever,pulling,facts,waited,lousy,circumstances,disappointed,weak,trusted,license,nothin,trash,understanding,slip,sounded,awake,friendship,stomach,weapon,threatened,mystery,vegas,understood,basically,switch,frankly,cheap,lifetime,deny,clock,garbage,why'd,tear,ears,indeed,changing,singing,tiny,decent,avoid,messed,filled,touched,disappear,exact,pills,kicked,harm,fortune,pretending,insurance,fancy,drove,cared,belongs,nights,lorelai,lift,timing,guarantee,chest,woke,burned,watched,heading,selfish,drinks,doll,committed,elevator,freeze,noise,wasting,ceremony,uncomfortable,staring,files,bike,stress,permission,thrown,possibility,borrow,fabulous,doors,screaming,bone,xander,what're,meal,apology,anger,honeymoon,bail,parking,fixed,wash,stolen,sensitive,stealing,photo,chose,lets,comfort,worrying,pocket,mateo,bleeding,shoulder,ignore,talent,tied,garage,dies,demons,dumped,witches,rude,crack,bothering,radar,soft,meantime,gimme,kinds,fate,concentrate,throat,prom,messages,intend,ashamed,somethin,manage,guilt,interrupt,guts,tongue,shoe,basement,sentence,purse,glasses,cabin,universe,repeat,mirror,wound,travers,tall,engagement,therapy,emotional,jeez,decisions,soup,thrilled,stake,chef,moves,extremely,moments,expensive,counting,shots,kidnapped,cleaning,shift,plate,impressed,smells,trapped,aidan,knocked,charming,attractive,argue,puts,whip,embarrassed,package,hitting,bust,stairs,alarm,pure,nail,nerve,incredibly,walks,dirt,stamp,terribly,friendly,damned,jobs,suffering,disgusting,stopping,deliver,riding,helps,disaster,bars,crossed,trap,talks,eggs,chick,threatening,spoken,introduce,confession,embarrassing,bags,impression,gate,reputation,presents,chat,suffer,argument,talkin,crowd,homework,coincidence,cancel,pride,solve,hopefully,pounds,pine,mate,illegal,generous,outfit,maid,bath,punch,freaked,begging,recall,enjoying,prepare,wheel,defend,signs,painful,yourselves,maris,that'd,suspicious,cooking,button,warned,sixty,pity,yelling,awhile,confidence,offering,pleased,panic,hers,gettin,refuse,grandpa,testify,choices,cruel,mental,gentleman,coma,cutting,proteus,guests,expert,benefit,faces,jumped,toilet,sneak,halloween,privacy,smoking,reminds,twins,swing,solid,options,commitment,crush,ambulance,wallet,gang,eleven,option,laundry,assure,stays,skip,fail,discussion,clinic,betrayed,sticking,bored,mansion,soda,sheriff,suite,handled,busted,load,happier,studying,romance,procedure,commit,assignment,suicide,minds,swim,yell,llanview,chasing,proper,believes,humor,hopes,lawyers,giant,latest,escaped,parent,tricks,insist,dropping,cheer,medication,flesh,routine,sandwich,handed,false,beating,warrant,awfully,odds,treating,thin,suggesting,fever,sweat,silent,clever,sweater,mall,sharing,assuming,judgment,goodnight,divorced,surely,steps,confess,math,listened,comin,answered,vulnerable,bless,dreaming,chip,zero,pissed,nate,kills,tears,knees,chill,brains,unusual,packed,dreamed,cure,lookin,grave,cheating,breaks,locker,gifts,awkward,thursday,joking,reasonable,dozen,curse,quartermaine,millions,dessert,rolling,detail,alien,delicious,closing,vampires,wore,tail,secure,salad,murderer,spit,offense,dust,conscience,bread,answering,lame,invitation,grief,smiling,pregnancy,prisoner,delivery,guards,virus,shrink,freezing,wreck,massimo,wire,technically,blown,anxious,cave,holidays,cleared,wishes,caring,candles,bound,charm,pulse,jumping,jokes,boom,occasion,silence,nonsense,frightened,slipped,dimera,blowing,relationships,kidnapping,spin,tool,roxy,packing,blaming,wrap,obsessed,fruit,torture,personality,there'll,fairy,necessarily,seventy,print,motel,underwear,grams,exhausted,believing,freaking,carefully,trace,touching,messing,recovery,intention,consequences,belt,sacrifice,courage,enjoyed,attracted,remove,testimony,intense,heal,defending,unfair,relieved,loyal,slowly,buzz,alcohol,surprises,psychiatrist,plain,attic,who'd,uniform,terrified,cleaned,zach,threaten,fella,enemies,satisfied,imagination,hooked,headache,forgetting,counselor,andie,acted,badge,naturally,frozen,sakes,appropriate,trunk,dunno,costume,sixteen,impressive,kicking,junk,grabbed,understands,describe,clients,owns,affect,witnesses,starving,instincts,happily,discussing,deserved,strangers,surveillance,admire,questioning,dragged,barn,deeply,wrapped,wasted,tense,hoped,fellas,roommate,mortal,fascinating,stops,arrangements,agenda,literally,propose,honesty,underneath,sauce,promises,lecture,eighty,torn,shocked,backup,differently,ninety,deck,biological,pheebs,ease,creep,waitress,telephone,ripped,raising,scratch,rings,prints,thee,arguing,ephram,asks,oops,diner,annoying,taggert,sergeant,blast,towel,clown,habit,creature,bermuda,snap,react,paranoid,handling,eaten,therapist,comment,sink,reporter,nurses,beats,priority,interrupting,warehouse,loyalty,inspector,pleasant,excuses,threats,guessing,tend,praying,motive,unconscious,mysterious,unhappy,tone,switched,rappaport,sookie,neighbor,loaded,swore,piss,balance,toss,misery,thief,squeeze,lobby,goa'uld,geez,exercise,forth,booked,sandburg,poker,eighteen,d'you,bury,everyday,digging,creepy,wondered,liver,hmmm,magical,fits,discussed,moral,helpful,searching,flew,depressed,aisle,cris,amen,vows,neighbors,darn,cents,arrange,annulment,useless,adventure,resist,fourteen,celebrating,inch,debt,violent,sand,teal'c,celebration,reminded,phones,paperwork,emotions,stubborn,pound,tension,stroke,steady,overnight,chips,beef,suits,boxes,cassadine,collect,tragedy,spoil,realm,wipe,surgeon,stretch,stepped,nephew,neat,limo,confident,perspective,climb,punishment,finest,springfield,hint,furniture,blanket,twist,proceed,fries,worries,niece,gloves,soap,signature,disappoint,crawl,convicted,flip,counsel,doubts,crimes,accusing,shaking,remembering,hallway,halfway,bothered,madam,gather,cameras,blackmail,symptoms,rope,ordinary,imagined,cigarette,supportive,explosion,trauma,ouch,furious,cheat,avoiding,whew,thick,oooh,boarding,approve,urgent,shhh,misunderstanding,drawer,phony,interfere,catching,bargain,tragic,respond,punish,penthouse,thou,rach,ohhh,insult,bugs,beside,begged,absolute,strictly,socks,senses,sneaking,reward,polite,checks,tale,physically,instructions,fooled,blows,tabby,bitter,adorable,y'all,tested,suggestion,jewelry,alike,jacks,distracted,shelter,lessons,constable,circus,audition,tune,shoulders,mask,helpless,feeding,explains,sucked,robbery,objection,behave,valuable,shadows,courtroom,confusing,talented,smarter,mistaken,customer,bizarre,scaring,motherfucker,alert,vecchio,reverend,foolish,compliment,bastards,worker,wheelchair,protective,gentle,reverse,picnic,knee,cage,wives,wednesday,voices,toes,stink,scares,pour,cheated,slide,ruining,filling,exit,cottage,upside,proves,parked,diary,complaining,confessed,pipe,merely,massage,chop,spill,prayer,betray,waiter,scam,rats,fraud,brush,tables,sympathy,pill,filthy,seventeen,employee,bracelet,pays,fairly,deeper,arrive,tracking,spite,shed,recommend,oughta,nanny,menu,diet,corn,roses,patch,dime,devastated,subtle,bullets,beans,pile,confirm,strings,parade,borrowed,toys,straighten,steak,premonition,planted,honored,exam,convenient,traveling,laying,insisted,dish,aitoro,kindly,grandson,donor,temper,teenager,proven,mothers,denial,backwards,tent,swell,noon,happiest,drives,thinkin,spirits,potion,holes,fence,whatsoever,rehearsal,overheard,lemme,hostage,bench,tryin,taxi,shove,moron,impress,needle,intelligent,instant,disagree,stinks,rianna,recover,groom,gesture,constantly,bartender,suspects,sealed,legally,hears,dresses,sheet,psychic,teenage,knocking,judging,accidentally,waking,rumor,manners,homeless,hollow,desperately,tapes,referring,item,genoa,gear,majesty,cried,tons,spells,instinct,quote,motorcycle,convincing,fashioned,aids,accomplished,grip,bump,upsetting,needing,invisible,forgiveness,feds,compare,bothers,tooth,inviting,earn,compromise,cocktail,tramp,jabot,intimate,dignity,dealt,souls,informed,gods,dressing,cigarettes,alistair,leak,fond,corky,seduce,liquor,fingerprints,enchantment,butters,stuffed,stavros,emotionally,transplant,tips,oxygen,nicely,lunatic,drill,complain,announcement,unfortunate,slap,prayers,plug,opens,oath,o'neill,mutual,yacht,remembers,fried,extraordinary,bait,warton,sworn,stare,safely,reunion,burst,might've,dive,aboard,expose,buddies,trusting,booze,sweep,sore,scudder,properly,parole,ditch,canceled,speaks,glow,wears,thirsty,skull,ringing,dorm,dining,bend,unexpected,pancakes,harsh,flattered,ahhh,troubles,fights,favourite,eats,rage,undercover,spoiled,sloane,shine,destroying,deliberately,conspiracy,thoughtful,sandwiches,plates,nails,miracles,fridge,drank,contrary,beloved,allergic,washed,stalking,solved,sack,misses,forgiven,bent,maciver,involve,dragging,cooked,pointing,foul,dull,beneath,heels,faking,deaf,stunt,jealousy,hopeless,fears,cuts,scenario,necklace,crashed,accuse,restraining,homicide,helicopter,firing,safer,auction,videotape,tore,reservations,pops,appetite,wounds,vanquish,ironic,fathers,excitement,anyhow,tearing,sends,rape,laughed,belly,dealer,cooperate,accomplish,wakes,spotted,sorts,reservation,ashes,tastes,supposedly,loft,intentions,integrity,wished,towels,suspected,investigating,inappropriate,lipstick,lawn,compassion,cafeteria,scarf,precisely,obsession,loses,lighten,infection,granddaughter,explode,balcony,this'll,spying,publicity,depend,cracked,conscious,ally,absurd,vicious,invented,forbid,directions,defendant,bare,announce,screwing,salesman,robbed,leap,lakeview,insanity,reveal,possibilities,kidnap,gown,chairs,wishing,setup,punished,criminals,regrets,raped,quarters,lamp,dentist,anyways,anonymous,semester,risks,owes,lungs,explaining,delicate,tricked,eager,doomed,adoption,stab,sickness,scum,floating,envelope,vault,sorel,pretended,potatoes,plea,photograph,payback,misunderstood,kiddo,healing,cascade,capeside,stabbed,remarkable,brat,privilege,passionate,nerves,lawsuit,kidney,disturbed,cozy,tire,shirts,oven,ordering,delay,risky,monsters,honorable,grounded,closest,breakdown,bald,abandon,scar,collar,worthless,sucking,enormous,disturbing,disturb,distract,deals,conclusions,vodka,dishes,crawling,briefcase,wiped,whistle,sits,roast,rented,pigs,flirting,deposit,bottles,topic,riot,overreacting,logical,hostile,embarrass,casual,beacon,amusing,altar,claus,survival,skirt,shave,porch,ghosts,favors,drops,dizzy,chili,advise,strikes,rehab,photographer,peaceful,leery,heavens,fortunately,fooling,expectations,cigar,weakness,ranch,practicing,examine,cranes,bribe,sail,prescription,hush,fragile,forensics,expense,drugged,cows,bells,visitor,suitcase,sorta,scan,manticore,insecure,imagining,hardest,clerk,wrist,what'll,starters,silk,pump,pale,nicer,haul,flies,boot,thumb,there'd,how're,elders,quietly,pulls,idiots,erase,denying,ankle,amnesia,accepting,heartbeat,devane,confront,minus,legitimate,fixing,arrogant,tuna,supper,slightest,sins,sayin,recipe,pier,paternity,humiliating,genuine,snack,rational,minded,guessed,weddings,tumor,humiliated,aspirin,spray,picks,eyed,drowning,contacts,ritual,perfume,hiring,hating,docks,creatures,visions,thanking,thankful,sock,nineteen,fork,throws,teenagers,stressed,slice,rolls,plead,ladder,kicks,detectives,assured,tellin,shallow,responsibilities,repay,howdy,girlfriends,deadly,comforting,ceiling,verdict,insensitive,spilled,respected,messy,interrupted,halliwell,blond,bleed,wardrobe,takin,murders,backs,underestimate,justify,harmless,frustrated,fold,enzo,communicate,bugging,arson,whack,salary,rumors,obligation,liking,dearest,congratulate,vengeance,rack,puzzle,fires,courtesy,caller,blamed,tops,quiz,prep,curiosity,circles,barbecue,sunnydale,spinning,psychotic,cough,accusations,resent,laughs,freshman,envy,drown,bartlet,asses,sofa,poster,highness,dock,apologies,theirs,stat,stall,realizes,psych,mmmm,fools,understandable,treats,succeed,stir,relaxed,makin,gratitude,faithful,accent,witter,wandering,locate,inevitable,gretel,deed,crushed,controlling,smelled,robe,gossip,gambling,cosmetics,accidents,surprising,stiff,sincere,rushed,refrigerator,preparing,nightmares,mijo,ignoring,hunch,fireworks,drowned,brass,whispering,sophisticated,luggage,hike,explore,emotion,crashing,contacted,complications,shining,rolled,righteous,reconsider,goody,geek,frightening,ethics,creeps,courthouse,camping,affection,smythe,haircut,essay,baked,apologized,vibe,respects,receipt,mami,hats,destructive,adore,adopt,tracked,shorts,reminding,dough,creations,cabot,barrel,snuck,slight,reporters,pressing,magnificent,madame,lazy,glorious,fiancee,bits,visitation,sane,kindness,shoulda,rescued,mattress,lounge,lifted,importantly,glove,enterprises,disappointment,condo,beings,admitting,yelled,waving,spoon,screech,satisfaction,reads,nailed,worm,tick,resting,marvelous,fuss,cortlandt,chased,pockets,luckily,lilith,filing,conversations,consideration,consciousness,worlds,innocence,forehead,aggressive,trailer,slam,quitting,inform,delighted,daylight,danced,confidential,aunts,washing,tossed,spectra,marrow,lined,implying,hatred,grill,corpse,clues,sober,offended,morgue,infected,humanity,distraction,cart,wired,violation,promising,harassment,glue,d'angelo,cursed,brutal,warlocks,wagon,unpleasant,proving,priorities,mustn't,lease,flame,disappearance,depressing,thrill,sitter,ribs,flush,earrings,deadline,corporal,collapsed,update,snapped,smack,melt,figuring,delusional,coulda,burnt,tender,sperm,realise,pork,popped,interrogation,esteem,choosing,undo,pres,prayed,plague,manipulate,insulting,detention,delightful,coffeehouse,betrayal,apologizing,adjust,wrecked,wont,whipped,rides,reminder,monsieur,faint,bake,distress,correctly,complaint,blocked,tortured,risking,pointless,handing,dumping,cups,alibi,struggling,shiny,risked,mummy,mint,hose,hobby,fortunate,fleischman,fitting,curtain,counseling,rode,puppet,modeling,memo,irresponsible,humiliation,hiya,freakin,felony,choke,blackmailing,appreciated,tabloid,suspicion,recovering,pledge,panicked,nursery,louder,jeans,investigator,homecoming,frustrating,buys,busting,buff,sleeve,irony,dope,declare,autopsy,workin,torch,prick,limb,hysterical,goddamnit,fetch,dimension,crowded,clip,climbing,bonding,woah,trusts,negotiate,lethal,iced,fantasies,deeds,bore,babysitter,questioned,outrageous,kiriakis,insulted,grudge,driveway,deserted,definite,beep,wires,suggestions,searched,owed,lend,drunken,demanding,costanza,conviction,bumped,weigh,touches,tempted,shout,resolve,relate,poisoned,meals,invitations,haunted,bogus,autograph,affects,tolerate,stepping,spontaneous,sleeps,probation,manny,fist,spectacular,hostages,heroin,havin,habits,encouraging,consult,burgers,boyfriends,bailed,baggage,watches,troubled,torturing,teasing,sweetest,qualities,postpone,overwhelmed,malkovich,impulse,classy,charging,amazed,policeman,hypocrite,humiliate,hideous,d'ya,costumes,bluffing,betting,bein,bedtime,alcoholic,vegetable,tray,suspicions,spreading,splendid,shrimp,shouting,pressed,nooo,grieving,gladly,fling,eliminate,cereal,aaah,sonofabitch,paralyzed,lotta,locks,guaranteed,dummy,despise,dental,briefing,bluff,batteries,whatta,sounding,servants,presume,handwriting,fainted,dried,allright,acknowledge,whacked,toxic,reliable,quicker,overwhelming,lining,harassing,fatal,endless,dolls,convict,whatcha,unlikely,shutting,positively,overcome,goddam,essence,dose,diagnosis,cured,bully,ahold,yearbook,tempting,shelf,prosecution,pouring,possessed,greedy,wonders,thorough,spine,rath,psychiatric,meaningless,latte,jammed,ignored,fiance,evidently,contempt,compromised,cans,weekends,urge,theft,suing,shipment,scissors,responding,proposition,noises,matching,hormones,hail,grandchildren,gently,smashed,sexually,sentimental,nicest,manipulated,intern,handcuffs,framed,errands,entertaining,crib,carriage,barge,spends,slipping,seated,rubbing,rely,reject,recommendation,reckon,headaches,float,embrace,corners,whining,sweating,skipped,mountie,motives,listens,cristobel,cleaner,cheerleader,balsom,unnecessary,stunning,scent,quartermaines,pose,montega,loosen,info,hottest,haunt,gracious,forgiving,errand,cakes,blames,abortion,sketch,shifts,plotting,perimeter,pals,mere,mattered,lonigan,interference,eyewitness,enthusiasm,diapers,strongest,shaken,punched,portal,catches,backyard,terrorists,sabotage,organs,needy,cuff,civilization,woof,who'll,prank,obnoxious,mates,hereby,gabby,faked,cellar,whitelighter,void,strangle,sour,muffins,interfering,demonic,clearing,boutique,barrington,terrace,smoked,righty,quack,petey,pact,knot,ketchup,disappearing,cordy,uptight,ticking,terrifying,tease,swamp,secretly,rejection,reflection,realizing,rays,mentally,marone,doubted,deception,congressman,cheesy,toto,stalling,scoop,ribbon,immune,expects,destined,bets,bathing,appreciation,accomplice,wander,shoved,sewer,scroll,retire,lasts,fugitive,freezer,discount,cranky,crank,clearance,bodyguard,anxiety,accountant,whoops,volunteered,talents,stinking,remotely,garlic,decency,cord,beds,altogether,uniforms,tremendous,popping,outa,observe,lung,hangs,feelin,dudes,donation,disguise,curb,bites,antique,toothbrush,realistic,predict,landlord,hourglass,hesitate,consolation,babbling,tipped,stranded,smartest,repeating,puke,psst,paycheck,overreacted,macho,juvenile,grocery,freshen,disposal,cuffs,caffeine,vanished,unfinished,ripping,pinch,flattering,expenses,dinners,colleague,ciao,belthazor,attorneys,woulda,whereabouts,waitin,truce,tripped,tasted,steer,poisoning,manipulative,immature,husbands,heel,granddad,delivering,condoms,addict,trashed,raining,pasta,needles,leaning,detector,coolest,batch,appointments,almighty,vegetables,spark,perfection,pains,momma,mole,meow,hairs,getaway,cracking,compliments,behold,verge,tougher,timer,tapped,taped,specialty,snooping,shoots,rendezvous,pentagon,leverage,jeopardize,janitor,grandparents,forbidden,clueless,bidding,ungrateful,unacceptable,tutor,serum,scuse,pajamas,mouths,lure,irrational,doom,cries,beautifully,arresting,approaching,traitor,sympathetic,smug,smash,rental,prostitute,premonitions,jumps,inventory,darlin,committing,banging,asap,worms,violated,vent,traumatic,traced,sweaty,shaft,overboard,insight,healed,grasp,experiencing,crappy,crab,chunk,awww,stain,shack,reacted,pronounce,poured,moms,marriages,jabez,handful,flipped,fireplace,embarrassment,disappears,concussion,bruises,brakes,twisting,swept,summon,splitting,sloppy,settling,reschedule,notch,hooray,grabbing,exquisite,disrespect,thornhart,straw,slapped,shipped,shattered,ruthless,refill,payroll,numb,mourning,manly,hunk,entertain,drift,dreadful,doorstep,confirmation,chops,appreciates,vague,tires,stressful,stashed,stash,sensed,preoccupied,predictable,noticing,madly,gunshot,dozens,dork,confuse,cleaners,charade,chalk,cappuccino,bouquet,amulet,addiction,who've,warming,unlock,satisfy,sacrificed,relaxing,lone,blocking,blend,blankets,addicted,yuck,hunger,hamburger,greeting,greet,gravy,gram,dreamt,dice,caution,backpack,agreeing,whale,taller,supervisor,sacrifices,phew,ounce,irrelevant,gran,felon,favorites,farther,fade,erased,easiest,convenience,compassionate,cane,backstage,agony,adores,veins,tweek,thieves,surgical,strangely,stetson,recital,proposing,productive,meaningful,immunity,hassle,goddamned,frighten,dearly,cease,ambition,wage,unstable,salvage,richer,refusing,raging,pumping,pressuring,mortals,lowlife,intimidated,intentionally,inspire,forgave,devotion,despicable,deciding,dash,comfy,breach,bark,aaaah,switching,swallowed,stove,screamed,scars,russians,pounding,poof,pipes,pawn,legit,invest,farewell,curtains,civilized,caviar,boost,token,superstition,supernatural,sadness,recorder,psyched,motivated,microwave,hallelujah,fraternity,dryer,cocoa,chewing,acceptable,unbelievably,smiled,smelling,simpler,respectable,remarks,khasinau,indication,gutter,grabs,fulfill,flashlight,ellenor,blooded,blink,blessings,beware,uhhh,turf,swings,slips,shovel,shocking,puff,mirrors,locking,heartless,fras,childish,cardiac,utterly,tuscany,ticked,stunned,statesville,sadly,purely,kiddin,jerks,hitch,flirt,fare,equals,dismiss,christening,casket,c'mere,breakup,biting,antibiotics,accusation,abducted,witchcraft,thread,runnin,punching,paramedics,newest,murdering,masks,lawndale,initials,grampa,choking,charms,careless,bushes,buns,bummed,shred,saves,saddle,rethink,regards,precinct,persuade,meds,manipulating,llanfair,leash,hearted,guarantees,fucks,disgrace,deposition,bookstore,boil,vitals,veil,trespassing,sidewalk,sensible,punishing,overtime,optimistic,obsessing,notify,mornin,jeopardy,jaffa,injection,hilarious,desires,confide,cautious,yada,where're,vindictive,vial,teeny,stroll,sittin,scrub,rebuild,posters,ordeal,nuns,intimacy,inheritance,exploded,donate,distracting,despair,crackers,wildwind,virtue,thoroughly,tails,spicy,sketches,sights,sheer,shaving,seize,scarecrow,refreshing,prosecute,platter,napkin,misplaced,merchandise,loony,jinx,heroic,frankenstein,ambitious,syrup,solitary,resemblance,reacting,premature,lavery,flashes,cheque,awright,acquainted,wrapping,untie,salute,realised,priceless,partying,lightly,lifting,kasnoff,insisting,glowing,generator,explosives,cutie,confronted,buts,blouse,ballistic,antidote,analyze,allowance,adjourned,unto,understatement,tucked,touchy,subconscious,screws,sarge,roommates,rambaldi,offend,nerd,knives,irresistible,incapable,hostility,goddammit,fuse,frat,curfew,blackmailed,walkin,starve,sleigh,sarcastic,recess,rebound,pinned,parlor,outfits,livin,heartache,haired,fundraiser,doorman,discreet,dilucca,cracks,considerate,climbed,catering,apophis,zoey,urine,strung,stitches,sordid,sark,protector,phoned,pets,hostess,flaw,flavor,deveraux,consumed,confidentiality,bourbon,straightened,specials,spaghetti,prettier,powerless,playin,playground,paranoia,instantly,havoc,exaggerating,eavesdropping,doughnuts,diversion,deepest,cutest,comb,bela,behaving,anyplace,accessory,workout,translate,stuffing,speeding,slime,royalty,polls,marital,lurking,lottery,imaginary,greetings,fairwinds,elegant,elbow,credibility,credentials,claws,chopped,bridal,bedside,babysitting,witty,unforgivable,underworld,tempt,tabs,sophomore,selfless,secrecy,restless,okey,movin,metaphor,messes,meltdown,lecter,incoming,gasoline,diefenbaker,buckle,admired,adjustment,warmth,throats,seduced,queer,parenting,noses,luckiest,graveyard,gifted,footsteps,dimeras,cynical,wedded,verbal,unpredictable,tuned,stoop,slides,sinking,rigged,plumbing,lingerie,hankey,greed,everwood,elope,dresser,chauffeur,bulletin,bugged,bouncing,temptation,strangest,slammed,sarcasm,pending,packages,orderly,obsessive,murderers,meteor,inconvenience,glimpse,froze,execute,courageous,consulate,closes,bosses,bees,amends,wuss,wolfram,wacky,unemployed,testifying,syringe,stew,startled,sorrow,sleazy,shaky,screams,rsquo,remark,poke,nutty,mentioning,mend,inspiring,impulsive,housekeeper,foam,fingernails,conditioning,baking,whine,thug,starved,sniffing,sedative,programmed,picket,paged,hound,homosexual,homo,hips,forgets,flipping,flea,flatter,dwell,dumpster,choo,assignments,ants,vile,unreasonable,tossing,thanked,steals,souvenir,scratched,psychopath,outs,obstruction,obey,lump,insists,harass,gloat,filth,edgy,didn,coroner,confessing,bruise,betraying,bailing,appealing,adebisi,wrath,wandered,waist,vain,traps,stepfather,poking,obligated,heavenly,dilemma,crazed,contagious,coaster,cheering,bundle,vomit,thingy,speeches,robbing,raft,pumped,pillows,peep,packs,neglected,m'kay,loneliness,intrude,helluva,gardener,forresters,drooling,betcha,vase,supermarket,squat,spitting,rhyme,relieve,receipts,racket,pictured,pause,overdue,motivation,morgendorffer,kidnapper,insect,horns,feminine,eyeballs,dumps,disappointing,crock,convertible,claw,clamp,canned,cambias,bathtub,avanya,artery,weep,warmer,suspense,summoned,spiders,reiber,raving,pushy,postponed,ohhhh,noooo,mold,laughter,incompetent,hugging,groceries,drip,communicating,auntie,adios,wraps,wiser,willingly,weirdest,timmih,thinner,swelling,swat,steroids,sensitivity,scrape,rehearse,prophecy,ledge,justified,insults,hateful,handles,doorway,chatting,buyer,buckaroo,bedrooms,askin,ammo,tutoring,subpoena,scratching,privileges,pager,mart,intriguing,idiotic,grape,enlighten,corrupt,brunch,bridesmaid,barking,applause,acquaintance,wretched,superficial,soak,smoothly,sensing,restraint,posing,pleading,payoff,oprah,nemo,morals,loaf,jumpy,ignorant,herbal,hangin,germs,generosity,flashing,doughnut,clumsy,chocolates,captive,behaved,apologise,vanity,stumbled,preview,poisonous,perjury,parental,onboard,mugged,minding,linen,knots,interviewing,humour,grind,greasy,goons,drastic,coop,comparing,cocky,clearer,bruised,brag,bind,worthwhile,whoop,vanquishing,tabloids,sprung,spotlight,sentencing,racist,provoke,pining,overly,locket,imply,impatient,hovering,hotter,fest,endure,dots,doren,debts,crawled,chained,brit,breaths,weirdo,warmed,wand,troubling,tok'ra,strapped,soaked,skipping,scrambled,rattle,profound,musta,mocking,misunderstand,limousine,kacl,hustle,forensic,enthusiastic,duct,drawers,devastating,conquer,clarify,chores,cheerleaders,cheaper,callin,blushing,barging,abused,yoga,wrecking,wits,waffles,virginity,vibes,uninvited,unfaithful,teller,strangled,scheming,ropes,rescuing,rave,postcard,o'reily,morphine,lotion,lads,kidneys,judgement,itch,indefinitely,grenade,glamorous,genetically,freud,discretion,delusions,crate,competent,bakery,argh,ahhhh,wedge,wager,unfit,tripping,torment,superhero,stirring,spinal,sorority,seminar,scenery,rabble,pneumonia,perks,override,ooooh,mija,manslaughter,mailed,lime,lettuce,intimidate,guarded,grieve,grad,frustration,doorbell,chinatown,authentic,arraignment,annulled,allergies,wanta,verify,vegetarian,tighter,telegram,stalk,spared,shoo,satisfying,saddam,requesting,pens,overprotective,obstacles,notified,nasedo,grandchild,genuinely,flushed,fluids,floss,escaping,ditched,cramp,corny,bunk,bitten,billions,bankrupt,yikes,wrists,ultrasound,ultimatum,thirst,sniff,shakes,salsa,retrieve,reassuring,pumps,neurotic,negotiating,needn't,monitors,millionaire,lydecker,limp,incriminating,hatchet,gracias,gordie,fills,feeds,doubting,decaf,biopsy,whiz,voluntarily,ventilator,unpack,unload,toad,spooked,snitch,schillinger,reassure,persuasive,mystical,mysteries,matrimony,mails,jock,headline,explanations,dispatch,curly,cupid,condolences,comrade,cassadines,bulb,bragging,awaits,assaulted,ambush,adolescent,abort,yank,whit,vaguely,undermine,tying,swamped,stabbing,slippers,slash,sincerely,sigh,setback,secondly,rotting,precaution,pcpd,melting,liaison,hots,hooking,headlines,haha,ganz,fury,felicity,fangs,encouragement,earring,dreidel,dory,donut,dictate,decorating,cocktails,bumps,blueberry,believable,backfired,backfire,apron,adjusting,vous,vouch,vitamins,ummm,tattoos,slimy,sibling,shhhh,renting,peculiar,parasite,paddington,marries,mailbox,magically,lovebirds,knocks,informant,exits,drazen,distractions,disconnected,dinosaurs,dashwood,crooked,conveniently,wink,warped,underestimated,tacky,shoving,seizure,reset,pushes,opener,mornings,mash,invent,indulge,horribly,hallucinating,festive,eyebrows,enjoys,desperation,dealers,darkest,daph,boragora,belts,bagel,authorization,auditions,agitated,wishful,wimp,vanish,unbearable,tonic,suffice,suction,slaying,safest,rocking,relive,puttin,prettiest,noisy,newlyweds,nauseous,misguided,mildly,midst,liable,judgmental,indy,hunted,givin,fascinated,elephants,dislike,deluded,decorate,crummy,contractions,carve,bottled,bonded,bahamas,unavailable,twenties,trustworthy,surgeons,stupidity,skies,remorse,preferably,pies,nausea,napkins,mule,mourn,melted,mashed,inherit,greatness,golly,excused,dumbo,drifting,delirious,damaging,cubicle,compelled,comm,chooses,checkup,boredom,bandages,alarms,windshield,who're,whaddya,transparent,surprisingly,sunglasses,slit,roar,reade,prognosis,probe,pitiful,persistent,peas,nosy,nagging,morons,masterpiece,martinis,limbo,liars,irritating,inclined,hump,hoynes,fiasco,eatin,cubans,concentrating,colorful,clam,cider,brochure,barto,bargaining,wiggle,welcoming,weighing,vanquished,stains,sooo,snacks,smear,sire,resentment,psychologist,pint,overhear,morality,landingham,kisser,hoot,holling,handshake,grilled,formality,elevators,depths,confirms,boathouse,accidental,westbridge,wacko,ulterior,thugs,thighs,tangled,stirred,snag,sling,sleaze,rumour,ripe,remarried,puddle,pins,perceptive,miraculous,longing,lockup,librarian,impressions,immoral,hypothetically,guarding,gourmet,gabe,faxed,extortion,downright,digest,cranberry,bygones,buzzing,burying,bikes,weary,taping,takeout,sweeping,stepmother,stale,senor,seaborn,pros,pepperoni,newborn,ludicrous,injected,geeks,forged,faults,drue,dire,dief,desi,deceiving,caterer,calmed,budge,ankles,vending,typing,tribbiani,there're,squared,snowing,shades,sexist,rewrite,regretted,raises,picky,orphan,mural,misjudged,miscarriage,memorize,leaking,jitters,invade,interruption,illegally,handicapped,glitch,gittes,finer,distraught,dispose,dishonest,digs,dads,cruelty,circling,canceling,butterflies,belongings,barbrady,amusement,alias,zombies,where've,unborn,swearing,stables,squeezed,sensational,resisting,radioactive,questionable,privileged,portofino,owning,overlook,orson,oddly,interrogate,imperative,impeccable,hurtful,hors,heap,graders,glance,disgust,devious,destruct,crazier,countdown,chump,cheeseburger,burglar,berries,ballroom,assumptions,annoyed,allergy,admirer,admirable,activate,underpants,twit,tack,strokes,stool,sham,scrap,retarded,resourceful,remarkably,refresh,pressured,precautions,pointy,nightclub,mustache,maui,lace,hunh,hubby,flare,dont,dokey,dangerously,crushing,clinging,choked,chem,cheerleading,checkbook,cashmere,calmly,blush,believer,amazingly,alas,what've,toilets,tacos,stairwell,spirited,sewing,rubbed,punches,protects,nuisance,motherfuckers,mingle,kynaston,knack,kinkle,impose,gullible,godmother,funniest,friggin,folding,fashions,eater,dysfunctional,drool,dripping,ditto,cruising,criticize,conceive,clone,cedars,caliber,brighter,blinded,birthdays,banquet,anticipate,annoy,whim,whichever,volatile,veto,vested,shroud,rests,reindeer,quarantine,pleases,painless,orphans,orphanage,offence,obliged,negotiation,narcotics,mistletoe,meddling,manifest,lookit,lilah,intrigued,injustice,homicidal,gigantic,exposing,elves,disturbance,disastrous,depended,demented,correction,cooped,cheerful,buyers,brownies,beverage,basics,arvin,weighs,upsets,unethical,swollen,sweaters,stupidest,sensation,scalpel,props,prescribed,pompous,objections,mushrooms,mulwray,manipulation,lured,internship,insignificant,inmate,incentive,fulfilled,disagreement,crypt,cornered,copied,brightest,beethoven,attendant,amaze,yogurt,wyndemere,vocabulary,tulsa,tactic,stuffy,respirator,pretends,polygraph,pennies,ordinarily,olives,necks,morally,martyr,leftovers,joints,hopping,homey,hints,heartbroken,forge,florist,firsthand,fiend,dandy,crippled,corrected,conniving,conditioner,clears,chemo,bubbly,bladder,beeper,baptism,wiring,wench,weaknesses,volunteering,violating,unlocked,tummy,surrogate,subid,stray,startle,specifics,slowing,scoot,robbers,rightful,richest,qfxmjrie,puffs,pierced,pencils,paralysis,makeover,luncheon,linksynergy,jerky,jacuzzi,hitched,hangover,fracture,flock,firemen,disgusted,darned,clams,borrowing,banged,wildest,weirder,unauthorized,stunts,sleeves,sixties,shush,shalt,retro,quits,pegged,painfully,paging,omelet,memorized,lawfully,jackets,intercept,ingredient,grownup,glued,fulfilling,enchanted,delusion,daring,compelling,carton,bridesmaids,bribed,boiling,bathrooms,bandage,awaiting,assign,arrogance,antiques,ainsley,turkeys,trashing,stockings,stalked,stabilized,skates,sedated,robes,respecting,psyche,presumptuous,prejudice,paragraph,mocha,mints,mating,mantan,lorne,loads,listener,itinerary,hepatitis,heave,guesses,fading,examining,dumbest,dishwasher,deceive,cunning,cripple,convictions,confided,compulsive,compromising,burglary,bumpy,brainwashed,benes,arnie,affirmative,adrenaline,adamant,watchin,waitresses,transgenic,toughest,tainted,surround,stormed,spree,spilling,spectacle,soaking,shreds,sewers,severed,scarce,scamming,scalp,rewind,rehearsing,pretentious,potions,overrated,obstacle,nerds,meems,mcmurphy,maternity,maneuver,loathe,fertility,eloping,ecstatic,ecstasy,divorcing,dignan,costing,clubhouse,clocks,candid,bursting,breather,braces,bending,arsonist,adored,absorb,valiant,uphold,unarmed,topolsky,thrilling,thigh,terminate,sustain,spaceship,snore,sneeze,smuggling,salty,quaint,patronize,patio,morbid,mamma,kettle,joyous,invincible,interpret,insecurities,impulses,illusions,holed,exploit,drivin,defenseless,dedicate,cradle,coupon,countless,conjure,cardboard,booking,backseat,accomplishment,wordsworth,wisely,valet,vaccine,urges,unnatural,unlucky,truths,traumatized,tasting,swears,strawberries,steaks,stats,skank,seducing,secretive,scumbag,screwdriver,schedules,rooting,rightfully,rattled,qualifies,puppets,prospects,pronto,posse,polling,pedestal,palms,muddy,morty,microscope,merci,lecturing,inject,incriminate,hygiene,grapefruit,gazebo,funnier,cuter,bossy,booby,aides,zende,winthrop,warrants,valentines,undressed,underage,truthfully,tampered,suffers,speechless,sparkling,sidelines,shrek,railing,puberty,pesky,outrage,outdoors,motions,moods,lunches,litter,kidnappers,itching,intuition,imitation,humility,hassling,gallons,drugstore,dosage,disrupt,dipping,deranged,debating,cuckoo,cremated,craziness,cooperating,circumstantial,chimney,blinking,biscuits,admiring,weeping,triad,trashy,soothing,slumber,slayers,skirts,siren,shindig,sentiment,rosco,riddance,quaid,purity,proceeding,pretzels,panicking,mckechnie,lovin,leaked,intruding,impersonating,ignorance,hamburgers,footprints,fluke,fleas,festivities,fences,feisty,evacuate,emergencies,deceived,creeping,craziest,corpses,conned,coincidences,bounced,bodyguards,blasted,bitterness,baloney,ashtray,apocalypse,zillion,watergate,wallpaper,telesave,sympathize,sweeter,startin,spades,sodas,snowed,sleepover,signor,seein,retainer,restroom,rested,repercussions,reliving,reconcile,prevail,preaching,overreact,o'neil,noose,moustache,manicure,maids,landlady,hypothetical,hopped,homesick,hives,hesitation,herbs,hectic,heartbreak,haunting,gangs,frown,fingerprint,exhausting,everytime,disregard,cling,chevron,chaperone,blinding,bitty,beads,battling,badgering,anticipation,upstanding,unprofessional,unhealthy,turmoil,truthful,toothpaste,tippin,thoughtless,tagataya,shooters,senseless,rewarding,propane,preposterous,pigeons,pastry,overhearing,obscene,negotiable,loner,jogging,itchy,insinuating,insides,hospitality,hormone,hearst,forthcoming,fists,fifties,etiquette,endings,destroys,despises,deprived,cuddy,crust,cloak,circumstance,chewed,casserole,bidder,bearer,artoo,applaud,appalling,vowed,virgins,vigilante,undone,throttle,testosterone,tailor,symptom,swoop,suitcases,stomp,sticker,stakeout,spoiling,snatched,smoochy,smitten,shameless,restraints,researching,renew,refund,reclaim,raoul,puzzles,purposely,punks,prosecuted,plaid,picturing,pickin,parasites,mysteriously,multiply,mascara,jukebox,interruptions,gunfire,furnace,elbows,duplicate,drapes,deliberate,decoy,cryptic,coupla,condemn,complicate,colossal,clerks,clarity,brushed,banished,argon,alarmed,worships,versa,uncanny,technicality,sundae,stumble,stripping,shuts,schmuck,satin,saliva,robber,relentless,reconnect,recipes,rearrange,rainy,psychiatrists,policemen,plunge,plugged,patched,overload,o'malley,mindless,menus,lullaby,lotte,leavin,killin,karinsky,invalid,hides,grownups,griff,flaws,flashy,flaming,fettes,evicted,dread,degrassi,dealings,dangers,cushion,bowel,barged,abide,abandoning,wonderfully,wait'll,violate,suicidal,stayin,sorted,slamming,sketchy,shoplifting,raiser,quizmaster,prefers,needless,motherhood,momentarily,migraine,lifts,leukemia,leftover,keepin,hinks,hellhole,gowns,goodies,gallon,futures,entertained,eighties,conspiring,cheery,benign,apiece,adjustments,abusive,abduction,wiping,whipping,welles,unspeakable,unidentified,trivial,transcripts,textbook,supervise,superstitious,stricken,stimulating,spielberg,slices,shelves,scratches,sabotaged,retrieval,repressed,rejecting,quickie,ponies,peeking,outraged,o'connell,moping,moaning,mausoleum,licked,kovich,klutz,interrogating,interfered,insulin,infested,incompetence,hyper,horrified,handedly,gekko,fraid,fractured,examiner,eloped,disoriented,dashing,crashdown,courier,cockroach,chipped,brushing,bombed,bolts,baths,baptized,astronaut,assurance,anemia,abuela,abiding,withholding,weave,wearin,weaker,suffocating,straws,straightforward,stench,steamed,starboard,sideways,shrinks,shortcut,scram,roasted,roaming,riviera,respectfully,repulsive,psychiatry,provoked,penitentiary,painkillers,ninotchka,mitzvah,milligrams,midge,marshmallows,looky,lapse,kubelik,intellect,improvise,implant,goa'ulds,giddy,geniuses,fruitcake,footing,fightin,drinkin,doork,detour,cuddle,crashes,combo,colonnade,cheats,cetera,bailiff,auditioning,assed,amused,alienate,aiding,aching,unwanted,topless,tongues,tiniest,superiors,soften,sheldrake,rawley,raisins,presses,plaster,nessa,narrowed,minions,merciful,lawsuits,intimidating,infirmary,inconvenient,imposter,hugged,honoring,holdin,hades,godforsaken,fumes,forgery,foolproof,folder,flattery,fingertips,exterminator,explodes,eccentric,dodging,disguised,crave,constructive,concealed,compartment,chute,chinpokomon,bodily,astronauts,alimony,accustomed,abdominal,wrinkle,wallow,valium,untrue,uncover,trembling,treasures,torched,toenails,timed,termites,telly,taunting,taransky,talker,succubus,smarts,sliding,sighting,semen,seizures,scarred,savvy,sauna,saddest,sacrificing,rubbish,riled,ratted,rationally,provenance,phonse,perky,pedal,overdose,nasal,nanites,mushy,movers,missus,midterm,merits,melodramatic,manure,knitting,invading,interpol,incapacitated,hotline,hauling,gunpoint,grail,ganza,framing,flannel,faded,eavesdrop,desserts,calories,breathtaking,bleak,blacked,batter,aggravated,yanked,wigand,whoah,unwind,undoubtedly,unattractive,twitch,trimester,torrance,timetable,taxpayers,strained,stared,slapping,sincerity,siding,shenanigans,shacking,sappy,samaritan,poorer,politely,paste,oysters,overruled,nightcap,mosquito,millimeter,merrier,manhood,lucked,kilos,ignition,hauled,harmed,goodwill,freshmen,fenmore,fasten,farce,exploding,erratic,drunks,ditching,d'artagnan,cramped,contacting,closets,clientele,chimp,bargained,arranging,anesthesia,amuse,altering,afternoons,accountable,abetting,wolek,waved,uneasy,toddy,tattooed,spauldings,sliced,sirens,schibetta,scatter,rinse,remedy,redemption,pleasures,optimism,oblige,mmmmm,masked,malicious,mailing,kosher,kiddies,judas,isolate,insecurity,incidentally,heals,headlights,growl,grilling,glazed,flunk,floats,fiery,fairness,exercising,excellency,disclosure,cupboard,counterfeit,condescending,conclusive,clicked,cleans,cholesterol,cashed,broccoli,brats,blueprints,blindfold,billing,attach,appalled,alrighty,wynant,unsolved,unreliable,toots,tighten,sweatshirt,steinbrenner,steamy,spouse,sonogram,slots,sleepless,shines,retaliate,rephrase,redeem,rambling,quilt,quarrel,prying,proverbial,priced,prescribe,prepped,pranks,possessive,plaintiff,pediatrics,overlooked,outcast,nightgown,mumbo,mediocre,mademoiselle,lunchtime,lifesaver,leaned,lambs,interns,hounding,hellmouth,hahaha,goner,ghoul,gardening,frenzy,foyer,extras,exaggerate,everlasting,enlightened,dialed,devote,deceitful,d'oeuvres,cosmetic,contaminated,conspired,conning,cavern,carving,butting,boiled,blurry,babysit,ascension,aaaaah,wildly,whoopee,whiny,weiskopf,walkie,vultures,vacations,upfront,unresolved,tampering,stockholders,snaps,sleepwalking,shrunk,sermon,seduction,scams,revolve,phenomenal,patrolling,paranormal,ounces,omigod,nightfall,lashing,innocents,infierno,incision,humming,haunts,gloss,gloating,frannie,fetal,feeny,entrapment,discomfort,detonator,dependable,concede,complication,commotion,commence,chulak,caucasian,casually,brainer,bolie,ballpark,anwar,analyzing,accommodations,youse,wring,wallowing,transgenics,thrive,tedious,stylish,strippers,sterile,squeezing,squeaky,sprained,solemn,snoring,shattering,shabby,seams,scrawny,revoked,residue,reeks,recite,ranting,quoting,predicament,plugs,pinpoint,petrified,pathological,passports,oughtta,nighter,navigate,kippie,intrigue,intentional,insufferable,hunky,how've,horrifying,hearty,hamptons,grazie,funerals,forks,fetched,excruciating,enjoyable,endanger,dumber,drying,diabolical,crossword,corry,comprehend,clipped,classmates,candlelight,brutally,brutality,boarded,bathrobe,authorize,assemble,aerobics,wholesome,whiff,vermin,trophies,trait,tragically,toying,testy,tasteful,stocked,spinach,sipping,sidetracked,scrubbing,scraping,sanctity,robberies,ridin,retribution,refrain,realities,radiant,protesting,projector,plutonium,payin,parting,o'reilly,nooooo,motherfucking,measly,manic,lalita,juggling,jerking,intro,inevitably,hypnosis,huddle,horrendous,hobbies,heartfelt,harlin,hairdresser,gonorrhea,fussing,furtwangler,fleeting,flawless,flashed,fetus,eulogy,distinctly,disrespectful,denies,crossbow,cregg,crabs,cowardly,contraction,contingency,confirming,condone,coffins,cleansing,cheesecake,certainty,cages,c'est,briefed,bravest,bosom,boils,binoculars,bachelorette,appetizer,ambushed,alerted,woozy,withhold,vulgar,utmost,unleashed,unholy,unhappiness,unconditional,typewriter,typed,twists,supermodel,subpoenaed,stringing,skeptical,schoolgirl,romantically,rocked,revoir,reopen,puncture,preach,polished,planetarium,penicillin,peacefully,nurturing,more'n,mmhmm,midgets,marklar,lodged,lifeline,jellyfish,infiltrate,hutch,horseback,heist,gents,frickin,freezes,forfeit,flakes,flair,fathered,eternally,epiphany,disgruntled,discouraged,delinquent,decipher,danvers,cubes,credible,coping,chills,cherished,catastrophe,bombshell,birthright,billionaire,ample,affections,admiration,abbotts,whatnot,watering,vinegar,unthinkable,unseen,unprepared,unorthodox,underhanded,uncool,timeless,thump,thermometer,theoretically,tapping,tagged,swung,stares,spiked,solves,smuggle,scarier,saucer,quitter,prudent,powdered,poked,pointers,peril,penetrate,penance,opium,nudge,nostrils,neurological,mockery,mobster,medically,loudly,insights,implicate,hypocritical,humanly,holiness,healthier,hammered,haldeman,gunman,gloom,freshly,francs,flunked,flawed,emptiness,drugging,dozer,derevko,deprive,deodorant,cryin,crocodile,coloring,colder,cognac,clocked,clippings,charades,chanting,certifiable,caterers,brute,brochures,botched,blinders,bitchin,banter,woken,ulcer,tread,thankfully,swine,swimsuit,swans,stressing,steaming,stamped,stabilize,squirm,snooze,shuffle,shredded,seafood,scratchy,savor,sadistic,rhetorical,revlon,realist,prosecuting,prophecies,polyester,petals,persuasion,paddles,o'leary,nuthin,neighbour,negroes,muster,meningitis,matron,lockers,letterman,legged,indictment,hypnotized,housekeeping,hopelessly,hallucinations,grader,goldilocks,girly,flask,envelopes,downside,doves,dissolve,discourage,disapprove,diabetic,deliveries,decorator,crossfire,criminally,containment,comrades,complimentary,chatter,catchy,cashier,cartel,caribou,cardiologist,brawl,booted,barbershop,aryan,angst,administer,zellie,wreak,whistles,vandalism,vamps,uterus,upstate,unstoppable,understudy,tristin,transcript,tranquilizer,toxins,tonsils,stempel,spotting,spectator,spatula,softer,snotty,slinging,showered,sexiest,sensual,sadder,rimbaud,restrain,resilient,remission,reinstate,rehash,recollection,rabies,popsicle,plausible,pediatric,patronizing,ostrich,ortolani,oooooh,omelette,mistrial,marseilles,loophole,laughin,kevvy,irritated,infidelity,hypothermia,horrific,groupie,grinding,graceful,goodspeed,gestures,frantic,extradition,echelon,disks,dawnie,dared,damsel,curled,collateral,collage,chant,calculating,bumping,bribes,boardwalk,blinds,blindly,bleeds,bickering,beasts,backside,avenge,apprehended,anguish,abusing,youthful,yells,yanking,whomever,when'd,vomiting,vengeful,unpacking,unfamiliar,undying,tumble,trolls,treacherous,tipping,tantrum,tanked,summons,straps,stomped,stinkin,stings,staked,squirrels,sprinkles,speculate,sorting,skinned,sicko,sicker,shootin,shatter,seeya,schnapps,s'posed,ronee,respectful,regroup,regretting,reeling,reckoned,ramifications,puddy,projections,preschool,plissken,platonic,permalash,outdone,outburst,mutants,mugging,misfortune,miserably,miraculously,medications,margaritas,manpower,lovemaking,logically,leeches,latrine,kneel,inflict,impostor,hypocrisy,hippies,heterosexual,heightened,hecuba,healer,gunned,grooming,groin,gooey,gloomy,frying,friendships,fredo,firepower,fathom,exhaustion,evils,endeavor,eggnog,dreaded,d'arcy,crotch,coughing,coronary,cookin,consummate,congrats,companionship,caved,caspar,bulletproof,brilliance,breakin,brash,blasting,aloud,airtight,advising,advertise,adultery,aches,wronged,upbeat,trillion,thingies,tending,tarts,surreal,specs,specialize,spade,shrew,shaping,selves,schoolwork,roomie,recuperating,rabid,quart,provocative,proudly,pretenses,prenatal,pharmaceuticals,pacing,overworked,originals,nicotine,murderous,mileage,mayonnaise,massages,losin,interrogated,injunction,impartial,homing,heartbreaker,hacks,glands,giver,fraizh,flips,flaunt,englishman,electrocuted,dusting,ducking,drifted,donating,cylon,crutches,crates,cowards,comfortably,chummy,chitchat,childbirth,businesswoman,brood,blatant,bethy,barring,bagged,awakened,asbestos,airplanes,worshipped,winnings,why're,visualize,unprotected,unleash,trays,thicker,therapists,takeoff,streisand,storeroom,stethoscope,stacked,spiteful,sneaks,snapping,slaughtered,slashed,simplest,silverware,shits,secluded,scruples,scrubs,scraps,ruptured,roaring,receptionist,recap,raditch,radiator,pushover,plastered,pharmacist,perverse,perpetrator,ornament,ointment,nineties,napping,nannies,mousse,moors,momentary,misunderstandings,manipulator,malfunction,laced,kivar,kickin,infuriating,impressionable,holdup,hires,hesitated,headphones,hammering,groundwork,grotesque,graces,gauze,gangsters,frivolous,freeing,fours,forwarding,ferrars,faulty,fantasizing,extracurricular,empathy,divorces,detonate,depraved,demeaning,deadlines,dalai,cursing,cufflink,crows,coupons,comforted,claustrophobic,casinos,camped,busboy,bluth,bennetts,baskets,attacker,aplastic,angrier,affectionate,zapped,wormhole,weaken,unrealistic,unravel,unimportant,unforgettable,twain,suspend,superbowl,stutter,stewardess,stepson,standin,spandex,souvenirs,sociopath,skeletons,shivering,sexier,selfishness,scrapbook,ritalin,ribbons,reunite,remarry,relaxation,rattling,rapist,psychosis,prepping,poses,pleasing,pisses,piling,persecuted,padded,operatives,negotiator,natty,menopause,mennihan,martimmys,loyalties,laynie,lando,justifies,intimately,inexperienced,impotent,immortality,horrors,hooky,hinges,heartbreaking,handcuffed,gypsies,guacamole,grovel,graziella,goggles,gestapo,fussy,ferragamo,feeble,eyesight,explosions,experimenting,enchanting,doubtful,dizziness,dismantle,detectors,deserving,defective,dangling,dancin,crumble,creamed,cramping,conceal,clockwork,chrissakes,chrissake,chopping,cabinets,brooding,bonfire,blurt,bloated,blackmailer,beforehand,bathed,bathe,barcode,banish,badges,babble,await,attentive,aroused,antibodies,animosity,ya'll,wrinkled,wonderland,willed,whisk,waltzing,waitressing,vigilant,upbringing,unselfish,uncles,trendy,trajectory,striped,stamina,stalled,staking,stacks,spoils,snuff,snooty,snide,shrinking,senora,secretaries,scoundrel,saline,salads,rundown,riddles,relapse,recommending,raspberry,plight,pecan,pantry,overslept,ornaments,niner,negligent,negligence,nailing,mucho,mouthed,monstrous,malpractice,lowly,loitering,logged,lingering,lettin,lattes,kamal,juror,jillefsky,jacked,irritate,intrusion,insatiable,infect,impromptu,icing,hmmmm,hefty,gasket,frightens,flapping,firstborn,faucet,estranged,envious,dopey,doesn,disposition,disposable,disappointments,dipped,dignified,deceit,dealership,deadbeat,curses,coven,counselors,concierge,clutches,casbah,callous,cahoots,brotherly,britches,brides,bethie,beige,autographed,attendants,attaboy,astonishing,appreciative,antibiotic,aneurysm,afterlife,affidavit,zoning,whats,whaddaya,vasectomy,unsuspecting,toula,topanga,tonio,toasted,tiring,terrorized,tenderness,tailing,sweats,suffocated,sucky,subconsciously,starvin,sprouts,spineless,sorrows,snowstorm,smirk,slicery,sledding,slander,simmer,signora,sigmund,seventies,sedate,scented,sandals,rollers,retraction,resigning,recuperate,receptive,racketeering,queasy,provoking,priors,prerogative,premed,pinched,pendant,outsiders,orbing,opportunist,olanov,neurologist,nanobot,mommies,molested,misread,mannered,laundromat,intercom,inspect,insanely,infatuation,indulgent,indiscretion,inconsiderate,hurrah,howling,herpes,hasta,harassed,hanukkah,groveling,groosalug,gander,galactica,futile,fridays,flier,fixes,exploiting,exorcism,evasive,endorse,emptied,dreary,dreamy,downloaded,dodged,doctored,disobeyed,disneyland,disable,dehydrated,contemplating,coconuts,cockroaches,clogged,chilling,chaperon,cameraman,bulbs,bucklands,bribing,brava,bracelets,bowels,bluepoint,appetizers,appendix,antics,anointed,analogy,almonds,yammering,winch,weirdness,wangler,vibrations,vendor,unmarked,unannounced,twerp,trespass,travesty,transfusion,trainee,towelie,tiresome,straightening,staggering,sonar,socializing,sinus,sinners,shambles,serene,scraped,scones,scepter,sarris,saberhagen,ridiculously,ridicule,rents,reconciled,radios,publicist,pubes,prune,prude,precrime,postponing,pluck,perish,peppermint,peeled,overdo,nutshell,nostalgic,mulan,mouthing,mistook,meddle,maybourne,martimmy,lobotomy,livelihood,lippman,likeness,kindest,kaffee,jocks,jerked,jeopardizing,jazzed,insured,inquisition,inhale,ingenious,holier,helmets,heirloom,heinous,haste,harmsway,hardship,hanky,gutters,gruesome,groping,goofing,godson,glare,finesse,figuratively,ferrie,endangerment,dreading,dozed,dorky,dmitri,divert,discredit,dialing,cufflinks,crutch,craps,corrupted,cocoon,cleavage,cannery,bystander,brushes,bruising,bribery,brainstorm,bolted,binge,ballistics,astute,arroway,adventurous,adoptive,addicts,addictive,yadda,whitelighters,wematanye,weeds,wedlock,wallets,vulnerability,vroom,vents,upped,unsettling,unharmed,trippin,trifle,tracing,tormenting,thats,syphilis,subtext,stickin,spices,sores,smacked,slumming,sinks,signore,shitting,shameful,shacked,septic,seedy,righteousness,relish,rectify,ravishing,quickest,phoebs,perverted,peeing,pedicure,pastrami,passionately,ozone,outnumbered,oregano,offender,nukes,nosed,nighty,nifty,mounties,motivate,moons,misinterpreted,mercenary,mentality,marsellus,lupus,lumbar,lovesick,lobsters,leaky,laundering,latch,jafar,instinctively,inspires,indoors,incarcerated,hundredth,handkerchief,gynecologist,guittierez,groundhog,grinning,goodbyes,geese,fullest,eyelashes,eyelash,enquirer,endlessly,elusive,disarm,detest,deluding,dangle,cotillion,corsage,conjugal,confessional,cones,commandment,coded,coals,chuckle,christmastime,cheeseburgers,chardonnay,celery,campfire,calming,burritos,brundle,broflovski,brighten,borderline,blinked,bling,beauties,bauers,battered,articulate,alienated,ahhhhh,agamemnon,accountants,y'see,wrongful,wrapper,workaholic,winnebago,whispered,warts,vacate,unworthy,unanswered,tonane,tolerated,throwin,throbbing,thrills,thorns,thereof,there've,tarot,sunscreen,stretcher,stereotype,soggy,sobbing,sizable,sightings,shucks,shrapnel,sever,senile,seaboard,scorned,saver,rebellious,rained,putty,prenup,pores,pinching,pertinent,peeping,paints,ovulating,opposites,occult,nutcracker,nutcase,newsstand,newfound,mocked,midterms,marshmallow,marbury,maclaren,leans,krudski,knowingly,keycard,junkies,juilliard,jolinar,irritable,invaluable,inuit,intoxicating,instruct,insolent,inexcusable,incubator,illustrious,hunsecker,houseguest,homosexuals,homeroom,hernia,harming,handgun,hallways,hallucination,gunshots,groupies,groggy,goiter,gingerbread,giggling,frigging,fledged,fedex,fairies,exchanging,exaggeration,esteemed,enlist,drags,dispense,disloyal,disconnect,desks,dentists,delacroix,degenerate,daydreaming,cushions,cuddly,corroborate,complexion,compensated,cobbler,closeness,chilled,checkmate,channing,carousel,calms,bylaws,benefactor,ballgame,baiting,backstabbing,artifact,airspace,adversary,actin,accuses,accelerant,abundantly,abstinence,zissou,zandt,yapping,witchy,willows,whadaya,vilandra,veiled,undress,undivided,underestimating,ultimatums,twirl,truckload,tremble,toasting,tingling,tents,tempered,sulking,stunk,sponges,spills,softly,snipers,scourge,rooftop,riana,revolting,revisit,refreshments,redecorating,recapture,raysy,pretense,prejudiced,precogs,pouting,poofs,pimple,piles,pediatrician,padre,packets,paces,orvelle,oblivious,objectivity,nighttime,nervosa,mexicans,meurice,melts,matchmaker,maeby,lugosi,lipnik,leprechaun,kissy,kafka,introductions,intestines,inspirational,insightful,inseparable,injections,inadvertently,hussy,huckabees,hittin,hemorrhaging,headin,haystack,hallowed,grudges,granilith,grandkids,grading,gracefully,godsend,gobbles,fragrance,fliers,finchley,farts,eyewitnesses,expendable,existential,dorms,delaying,degrading,deduction,darlings,danes,cylons,counsellor,contraire,consciously,conjuring,congratulating,cokes,buffay,brooch,bitching,bistro,bijou,bewitched,benevolent,bends,bearings,barren,aptitude,amish,amazes,abomination,worldly,whispers,whadda,wayward,wailing,vanishing,upscale,untouchable,unspoken,uncontrollable,unavoidable,unattended,trite,transvestite,toupee,timid,timers,terrorizing,swana,stumped,strolling,storybook,storming,stomachs,stoked,stationery,springtime,spontaneity,spits,spins,soaps,sentiments,scramble,scone,rooftops,retract,reflexes,rawdon,ragged,quirky,quantico,psychologically,prodigal,pounce,potty,pleasantries,pints,petting,perceive,onstage,notwithstanding,nibble,newmans,neutralize,mutilated,millionaires,mayflower,masquerade,mangy,macreedy,lunatics,lovable,locating,limping,lasagna,kwang,keepers,juvie,jaded,ironing,intuitive,intensely,insure,incantation,hysteria,hypnotize,humping,happenin,griet,grasping,glorified,ganging,g'night,focker,flunking,flimsy,flaunting,fixated,fitzwallace,fainting,eyebrow,exonerated,ether,electrician,egotistical,earthly,dusted,dignify,detonation,debrief,dazzling,dan'l,damnedest,daisies,crushes,crucify,contraband,confronting,collapsing,cocked,clicks,cliche,circled,chandelier,carburetor,callers,broads,breathes,bloodshed,blindsided,blabbing,bialystock,bashing,ballerina,aviva,arteries,anomaly,airstrip,agonizing,adjourn,aaaaa,yearning,wrecker,witnessing,whence,warhead,unsure,unheard,unfreeze,unfold,unbalanced,ugliest,troublemaker,toddler,tiptoe,threesome,thirties,thermostat,swipe,surgically,subtlety,stung,stumbling,stubs,stride,strangling,sprayed,socket,smuggled,showering,shhhhh,sabotaging,rumson,rounding,risotto,repairman,rehearsed,ratty,ragging,radiology,racquetball,racking,quieter,quicksand,prowl,prompt,premeditated,prematurely,prancing,porcupine,plated,pinocchio,peeked,peddle,panting,overweight,overrun,outing,outgrown,obsess,nursed,nodding,negativity,negatives,musketeers,mugger,motorcade,merrily,matured,masquerading,marvellous,maniacs,lovey,louse,linger,lilies,lawful,kudos,knuckle,juices,judgments,itches,intolerable,intermission,inept,incarceration,implication,imaginative,huckleberry,holster,heartburn,gunna,groomed,graciously,fulfillment,fugitives,forsaking,forgives,foreseeable,flavors,flares,fixation,fickle,fantasize,famished,fades,expiration,exclamation,erasing,eiffel,eerie,earful,duped,dulles,dissing,dissect,dispenser,dilated,detergent,desdemona,debriefing,damper,curing,crispina,crackpot,courting,cordial,conflicted,comprehension,commie,cleanup,chiropractor,charmer,chariot,cauldron,catatonic,bullied,buckets,brilliantly,breathed,booths,boardroom,blowout,blindness,blazing,biologically,bibles,biased,beseech,barbaric,balraj,audacity,anticipating,alcoholics,airhead,agendas,admittedly,absolution,youre,yippee,wittlesey,withheld,willful,whammy,weakest,washes,virtuous,videotapes,vials,unplugged,unpacked,unfairly,turbulence,tumbling,tricking,tremendously,traitors,torches,tinga,thyroid,teased,tawdry,taker,sympathies,swiped,sundaes,suave,strut,stepdad,spewing,spasm,socialize,slither,simulator,shutters,shrewd,shocks,semantics,schizophrenic,scans,savages,rya'c,runny,ruckus,royally,roadblocks,rewriting,revoke,repent,redecorate,recovers,recourse,ratched,ramali,racquet,quince,quiche,puppeteer,puking,puffed,problemo,praises,pouch,postcards,pooped,poised,piled,phoney,phobia,patching,parenthood,pardner,oozing,ohhhhh,numbing,nostril,nosey,neatly,nappa,nameless,mortuary,moronic,modesty,midwife,mcclane,matuka,maitre,lumps,lucid,loosened,loins,lawnmower,lamotta,kroehner,jinxy,jessep,jamming,jailhouse,jacking,intruders,inhuman,infatuated,indigestion,implore,implanted,hormonal,hoboken,hillbilly,heartwarming,headway,hatched,hartmans,harping,grapevine,gnome,forties,flyin,flirted,fingernail,exhilarating,enjoyment,embark,dumper,dubious,drell,docking,disillusioned,dishonor,disbarred,dicey,custodial,counterproductive,corned,cords,contemplate,concur,conceivable,cobblepot,chickened,checkout,carpe,cap'n,campers,buyin,bullies,braid,boxed,bouncy,blueberries,blubbering,bloodstream,bigamy,beeped,bearable,autographs,alarming,wretch,wimps,widower,whirlwind,whirl,warms,vandelay,unveiling,undoing,unbecoming,turnaround,touche,togetherness,tickles,ticker,teensy,taunt,sweethearts,stitched,standpoint,staffers,spotless,soothe,smothered,sickening,shouted,shepherds,shawl,seriousness,schooled,schoolboy,s'mores,roped,reminders,raggedy,preemptive,plucked,pheromones,particulars,pardoned,overpriced,overbearing,outrun,ohmigod,nosing,nicked,neanderthal,mosquitoes,mortified,milky,messin,mecha,markinson,marivellas,mannequin,manderley,madder,macready,lookie,locusts,lifetimes,lanna,lakhi,kholi,impersonate,hyperdrive,horrid,hopin,hogging,hearsay,harpy,harboring,hairdo,hafta,grasshopper,gobble,gatehouse,foosball,floozy,fished,firewood,finalize,felons,euphemism,entourage,elitist,elegance,drokken,drier,dredge,dossier,diseased,diarrhea,diagnose,despised,defuse,d'amour,contesting,conserve,conscientious,conjured,collars,clogs,chenille,chatty,chamomile,casing,calculator,brittle,breached,blurted,birthing,bikinis,astounding,assaulting,aroma,appliance,antsy,amnio,alienating,aliases,adolescence,xerox,wrongs,workload,willona,whistling,werewolves,wallaby,unwelcome,unseemly,unplug,undermining,ugliness,tyranny,tuesdays,trumpets,transference,ticks,tangible,tagging,swallowing,superheroes,studs,strep,stowed,stomping,steffy,sprain,spouting,sponsoring,sneezing,smeared,slink,shakin,sewed,seatbelt,scariest,scammed,sanctimonious,roasting,rightly,retinal,rethinking,resented,reruns,remover,racks,purest,progressing,presidente,preeclampsia,postponement,portals,poppa,pliers,pinning,pelvic,pampered,padding,overjoyed,ooooo,one'll,octavius,nonono,nicknames,neurosurgeon,narrows,misled,mislead,mishap,milltown,milking,meticulous,mediocrity,meatballs,machete,lurch,layin,knockin,khruschev,jurors,jumpin,jugular,jeweler,intellectually,inquiries,indulging,indestructible,indebted,imitate,ignores,hyperventilating,hyenas,hurrying,hermano,hellish,heheh,harshly,handout,grunemann,glances,giveaway,getup,gerome,furthest,frosting,frail,forwarded,forceful,flavored,flammable,flaky,fingered,fatherly,ethic,embezzlement,duffel,dotted,distressed,disobey,disappearances,dinky,diminish,diaphragm,deuces,creme,courteous,comforts,coerced,clots,clarification,chunks,chickie,chases,chaperoning,cartons,caper,calves,caged,bustin,bulging,bringin,boomhauer,blowin,blindfolded,biscotti,ballplayer,bagging,auster,assurances,aschen,arraigned,anonymity,alters,albatross,agreeable,adoring,abduct,wolfi,weirded,watchers,washroom,warheads,vincennes,urgency,understandably,uncomplicated,uhhhh,twitching,treadmill,thermos,tenorman,tangle,talkative,swarm,surrendering,summoning,strive,stilts,stickers,squashed,spraying,sparring,soaring,snort,sneezed,slaps,skanky,singin,sidle,shreck,shortness,shorthand,sharper,shamed,sadist,rydell,rusik,roulette,resumes,respiration,recount,reacts,purgatory,princesses,presentable,ponytail,plotted,pinot,pigtails,phillippe,peddling,paroled,orbed,offends,o'hara,moonlit,minefield,metaphors,malignant,mainframe,magicks,maggots,maclaine,loathing,leper,leaps,leaping,lashed,larch,larceny,lapses,ladyship,juncture,jiffy,jakov,invoke,infantile,inadmissible,horoscope,hinting,hideaway,hesitating,heddy,heckles,hairline,gripe,gratifying,governess,goebbels,freddo,foresee,fascination,exemplary,executioner,etcetera,escorts,endearing,eaters,earplugs,draped,disrupting,disagrees,dimes,devastate,detain,depositions,delicacy,darklighter,cynicism,cyanide,cutters,cronus,continuance,conquering,confiding,compartments,combing,cofell,clingy,cleanse,christmases,cheered,cheekbones,buttle,burdened,bruenell,broomstick,brained,bozos,bontecou,bluntman,blazes,blameless,bizarro,bellboy,beaucoup,barkeep,awaken,astray,assailant,appease,aphrodisiac,alleys,yesss,wrecks,woodpecker,wondrous,wimpy,willpower,wheeling,weepy,waxing,waive,videotaped,veritable,untouched,unlisted,unfounded,unforeseen,twinge,triggers,traipsing,toxin,tombstone,thumping,therein,testicles,telephones,tarmac,talby,tackled,swirling,suicides,suckered,subtitles,sturdy,strangler,stockbroker,stitching,steered,standup,squeal,sprinkler,spontaneously,splendor,spiking,spender,snipe,snagged,skimming,siddown,showroom,shovels,shotguns,shoelaces,shitload,shellfish,sharpest,shadowy,seizing,scrounge,scapegoat,sayonara,saddled,rummaging,roomful,renounce,reconsidered,recharge,realistically,radioed,quirks,quadrant,punctual,practising,pours,poolhouse,poltergeist,pocketbook,plainly,picnics,pesto,pawing,passageway,partied,oneself,numero,nostalgia,nitwit,neuro,mixer,meanest,mcbeal,matinee,margate,marce,manipulations,manhunt,manger,magicians,loafers,litvack,lightheaded,lifeguard,lawns,laughingstock,ingested,indignation,inconceivable,imposition,impersonal,imbecile,huddled,housewarming,horizons,homicides,hiccups,hearse,hardened,gushing,gushie,greased,goddamit,freelancer,forging,fondue,flustered,flung,flinch,flicker,fixin,festivus,fertilizer,farted,faggots,exonerate,evict,enormously,encrypted,emdash,embracing,duress,dupres,dowser,doormat,disfigured,disciplined,dibbs,depository,deathbed,dazzled,cuttin,cures,crowding,crepe,crammed,copycat,contradict,confidant,condemning,conceited,commute,comatose,clapping,circumference,chuppah,chore,choksondik,chestnuts,briault,bottomless,bonnet,blokes,berluti,beret,beggars,bankroll,bania,athos,arsenic,apperantly,ahhhhhh,afloat,accents,zipped,zeros,zeroes,zamir,yuppie,youngsters,yorkers,wisest,wipes,wield,whyn't,weirdos,wednesdays,vicksburg,upchuck,untraceable,unsupervised,unpleasantness,unhook,unconscionable,uncalled,trappings,tragedies,townie,thurgood,things'll,thine,tetanus,terrorize,temptations,tanning,tampons,swarming,straitjacket,steroid,startling,starry,squander,speculating,sollozzo,sneaked,slugs,skedaddle,sinker,silky,shortcomings,sellin,seasoned,scrubbed,screwup,scrapes,scarves,sandbox,salesmen,rooming,romances,revere,reproach,reprieve,rearranging,ravine,rationalize,raffle,punchy,psychobabble,provocation,profoundly,prescriptions,preferable,polishing,poached,pledges,pirelli,perverts,oversized,overdressed,outdid,nuptials,nefarious,mouthpiece,motels,mopping,mongrel,missin,metaphorically,mertin,memos,melodrama,melancholy,measles,meaner,mantel,maneuvering,mailroom,luring,listenin,lifeless,licks,levon,legwork,kneecaps,kippur,kiddie,kaput,justifiable,insistent,insidious,innuendo,innit,indecent,imaginable,horseshit,hemorrhoid,hella,healthiest,haywire,hamsters,hairbrush,grouchy,grisly,gratuitous,glutton,glimmer,gibberish,ghastly,gentler,generously,geeky,fuhrer,fronting,foolin,faxes,faceless,extinguisher,expel,etched,endangering,ducked,dodgeball,dives,dislocated,discrepancy,devour,derail,dementia,daycare,cynic,crumbling,cowardice,covet,cornwallis,corkscrew,cookbook,commandments,coincidental,cobwebs,clouded,clogging,clicking,clasp,chopsticks,chefs,chaps,cashing,carat,calmer,brazen,brainwashing,bradys,bowing,boned,bloodsucking,bleachers,bleached,bedpan,bearded,barrenger,bachelors,awwww,assures,assigning,asparagus,apprehend,anecdote,amoral,aggravation,afoot,acquaintances,accommodating,yakking,worshipping,wladek,willya,willies,wigged,whoosh,whisked,watered,warpath,volts,violates,valuables,uphill,unwise,untimely,unsavory,unresponsive,unpunished,unexplained,tubby,trolling,toxicology,tormented,toothache,tingly,timmiihh,thursdays,thoreau,terrifies,temperamental,telegrams,talkie,takers,symbiote,swirl,suffocate,stupider,strapping,steckler,springing,someway,sleepyhead,sledgehammer,slant,slams,showgirl,shoveling,shmoopy,sharkbait,shan't,scrambling,schematics,sandeman,sabbatical,rummy,reykjavik,revert,responsive,rescheduled,requisition,relinquish,rejoice,reckoning,recant,rebadow,reassurance,rattlesnake,ramble,primed,pricey,prance,pothole,pocus,persist,perpetrated,pekar,peeling,pastime,parmesan,pacemaker,overdrive,ominous,observant,nothings,noooooo,nonexistent,nodded,nieces,neglecting,nauseating,mutated,musket,mumbling,mowing,mouthful,mooseport,monologue,mistrust,meetin,masseuse,mantini,mailer,madre,lowlifes,locksmith,livid,liven,limos,liberating,lhasa,leniency,leering,laughable,lashes,lasagne,laceration,korben,katan,kalen,jittery,jammies,irreplaceable,intubate,intolerant,inhaler,inhaled,indifferent,indifference,impound,impolite,humbly,heroics,heigh,guillotine,guesthouse,grounding,grips,gossiping,goatee,gnomes,gellar,frutt,frobisher,freudian,foolishness,flagged,femme,fatso,fatherhood,fantasized,fairest,faintest,eyelids,extravagant,extraterrestrial,extraordinarily,escalator,elevate,drivel,dissed,dismal,disarray,dinnertime,devastation,dermatologist,delicately,defrost,debutante,debacle,damone,dainty,cuvee,culpa,crucified,creeped,crayons,courtship,convene,congresswoman,concocted,compromises,comprende,comma,coleslaw,clothed,clinically,chickenshit,checkin,cesspool,caskets,calzone,brothel,boomerang,bodega,blasphemy,bitsy,bicentennial,berlini,beatin,beards,barbas,barbarians,backpacking,arrhythmia,arousing,arbitrator,antagonize,angling,anesthetic,altercation,aggressor,adversity,acathla,aaahhh,wreaking,workup,wonderin,wither,wielding,what'm,what'cha,waxed,vibrating,veterinarian,venting,vasey,valor,validate,upholstery,untied,unscathed,uninterrupted,unforgiving,undies,uncut,twinkies,tucking,treatable,treasured,tranquility,townspeople,torso,tomei,tipsy,tinsel,tidings,thirtieth,tantrums,tamper,talky,swayed,swapping,suitor,stylist,stirs,standoff,sprinklers,sparkly,snobby,snatcher,smoother,sleepin,shrug,shoebox,sheesh,shackles,setbacks,sedatives,screeching,scorched,scanned,satyr,roadblock,riverbank,ridiculed,resentful,repellent,recreate,reconvene,rebuttal,realmedia,quizzes,questionnaire,punctured,pucker,prolong,professionalism,pleasantly,pigsty,penniless,paychecks,patiently,parading,overactive,ovaries,orderlies,oracles,oiled,offending,nudie,neonatal,neighborly,moops,moonlighting,mobilize,mmmmmm,milkshake,menial,meats,mayan,maxed,mangled,magua,lunacy,luckier,liters,lansbury,kooky,knowin,jeopardized,inkling,inhalation,inflated,infecting,incense,inbound,impractical,impenetrable,idealistic,i'mma,hypocrites,hurtin,humbled,hologram,hokey,hocus,hitchhiking,hemorrhoids,headhunter,hassled,harts,hardworking,haircuts,hacksaw,genitals,gazillion,gammy,gamesphere,fugue,footwear,folly,flashlights,fives,filet,extenuating,estrogen,entails,embezzled,eloquent,egomaniac,ducts,drowsy,drones,doree,donovon,disguises,diggin,deserting,depriving,defying,deductible,decorum,decked,daylights,daybreak,dashboard,damnation,cuddling,crunching,crickets,crazies,councilman,coughed,conundrum,complimented,cohaagen,clutching,clued,clader,cheques,checkpoint,chats,channeling,ceases,carasco,capisce,cantaloupe,cancelling,campsite,burglars,breakfasts,bra'tac,blueprint,bleedin,blabbed,beneficiary,basing,avert,atone,arlyn,approves,apothecary,antiseptic,aleikuum,advisement,zadir,wobbly,withnail,whattaya,whacking,wedged,wanders,vaginal,unimaginable,undeniable,unconditionally,uncharted,unbridled,tweezers,tvmegasite,trumped,triumphant,trimming,treading,tranquilizers,toontown,thunk,suture,suppressing,strays,stonewall,stogie,stepdaughter,stace,squint,spouses,splashed,speakin,sounder,sorrier,sorrel,sombrero,solemnly,softened,snobs,snippy,snare,smoothing,slump,slimeball,slaving,silently,shiller,shakedown,sensations,scrying,scrumptious,screamin,saucy,santoses,roundup,roughed,rosary,robechaux,retrospect,rescind,reprehensible,repel,remodeling,reconsidering,reciprocate,railroaded,psychics,promos,prob'ly,pristine,printout,priestess,prenuptial,precedes,pouty,phoning,peppy,pariah,parched,panes,overloaded,overdoing,nymphs,nother,notebooks,nearing,nearer,monstrosity,milady,mieke,mephesto,medicated,marshals,manilow,mammogram,m'lady,lotsa,loopy,lesion,lenient,learner,laszlo,kross,kinks,jinxed,involuntary,insubordination,ingrate,inflatable,incarnate,inane,hypoglycemia,huntin,humongous,hoodlum,honking,hemorrhage,helpin,hathor,hatching,grotto,grandmama,gorillas,godless,girlish,ghouls,gershwin,frosted,flutter,flagpole,fetching,fatter,faithfully,exert,evasion,escalate,enticing,enchantress,elopement,drills,downtime,downloading,dorks,doorways,divulge,dissociative,disgraceful,disconcerting,deteriorate,destinies,depressive,dented,denim,decruz,decidedly,deactivate,daydreams,curls,culprit,cruelest,crippling,cranberries,corvis,copped,commend,coastguard,cloning,cirque,churning,chock,chivalry,catalogues,cartwheels,carols,canister,buttered,bundt,buljanoff,bubbling,brokers,broaden,brimstone,brainless,bores,badmouthing,autopilot,ascertain,aorta,ampata,allenby,accosted,absolve,aborted,aaagh,aaaaaah,yonder,yellin,wyndham,wrongdoing,woodsboro,wigging,wasteland,warranty,waltzed,walnuts,vividly,veggie,unnecessarily,unloaded,unicorns,understated,unclean,umbrellas,twirling,turpentine,tupperware,triage,treehouse,tidbit,tickled,threes,thousandth,thingie,terminally,teething,tassel,talkies,swoon,switchboard,swerved,suspiciously,subsequentlyne,subscribe,strudel,stroking,strictest,stensland,starin,stannart,squirming,squealing,sorely,softie,snookums,sniveling,smidge,sloth,skulking,simian,sightseeing,siamese,shudder,shoppers,sharpen,shannen,semtex,secondhand,seance,scowl,scorn,safekeeping,russe,rummage,roshman,roomies,roaches,rinds,retrace,retires,resuscitate,rerun,reputations,rekall,refreshment,reenactment,recluse,ravioli,raves,raking,purses,punishable,punchline,puked,prosky,previews,poughkeepsie,poppins,polluted,placenta,pissy,petulant,perseverance,pears,pawns,pastries,partake,panky,palate,overzealous,orchids,obstructing,objectively,obituaries,obedient,nothingness,musty,motherly,mooning,momentous,mistaking,minutemen,milos,microchip,meself,merciless,menelaus,mazel,masturbate,mahogany,lysistrata,lillienfield,likable,liberate,leveled,letdown,larynx,lardass,lainey,lagged,klorel,kidnappings,keyed,karmic,jeebies,irate,invulnerable,intrusive,insemination,inquire,injecting,informative,informants,impure,impasse,imbalance,illiterate,hurled,hunts,hematoma,headstrong,handmade,handiwork,growling,gorky,getcha,gesundheit,gazing,galley,foolishly,fondness,floris,ferocious,feathered,fateful,fancies,fakes,faker,expire,ever'body,essentials,eskimos,enlightening,enchilada,emissary,embolism,elsinore,ecklie,drenched,drazi,doped,dogging,doable,dislikes,dishonesty,disengage,discouraging,derailed,deformed,deflect,defer,deactivated,crips,constellations,congressmen,complimenting,clubbing,clawing,chromium,chimes,chews,cheatin,chaste,cellblock,caving,catered,catacombs,calamari,bucking,brulee,brits,brisk,breezes,bounces,boudoir,binks,better'n,bellied,behrani,behaves,bedding,balmy,badmouth,backers,avenging,aromatherapy,armpit,armoire,anythin,anonymously,anniversaries,aftershave,affliction,adrift,admissible,adieu,acquittal,yucky,yearn,whitter,whirlpool,wendigo,watchdog,wannabes,wakey,vomited,voicemail,valedictorian,uttered,unwed,unrequited,unnoticed,unnerving,unkind,unjust,uniformed,unconfirmed,unadulterated,unaccounted,uglier,turnoff,trampled,tramell,toads,timbuktu,throwback,thimble,tasteless,tarantula,tamale,takeovers,swish,supposing,streaking,stargher,stanzi,stabs,squeamish,splattered,spiritually,spilt,speciality,smacking,skywire,skips,skaara,simpatico,shredding,showin,shortcuts,shite,shielding,shamelessly,serafine,sentimentality,seasick,schemer,scandalous,sainted,riedenschneider,rhyming,revel,retractor,retards,resurrect,remiss,reminiscing,remanded,reiben,regains,refuel,refresher,redoing,redheaded,reassured,rearranged,rapport,qumar,prowling,prejudices,precarious,powwow,pondering,plunger,plunged,pleasantville,playpen,phlegm,perfected,pancreas,paley,ovary,outbursts,oppressed,ooohhh,omoroca,offed,o'toole,nurture,nursemaid,nosebleed,necktie,muttering,munchies,mucking,mogul,mitosis,misdemeanor,miscarried,millionth,migraines,midler,manicurist,mandelbaum,manageable,malfunctioned,magnanimous,loudmouth,longed,lifestyles,liddy,lickety,leprechauns,komako,klute,kennel,justifying,irreversible,inventing,intergalactic,insinuate,inquiring,ingenuity,inconclusive,incessant,improv,impersonation,hyena,humperdinck,hubba,housework,hoffa,hither,hissy,hippy,hijacked,heparin,hellooo,hearth,hassles,hairstyle,hahahaha,hadda,guys'll,gutted,gulls,gritty,grievous,graft,gossamer,gooder,gambled,gadgets,fundamentals,frustrations,frolicking,frock,frilly,foreseen,footloose,fondly,flirtation,flinched,flatten,farthest,exposer,evading,escrow,empathize,embryos,embodiment,ellsberg,ebola,dulcinea,dreamin,drawbacks,doting,doose,doofy,disturbs,disorderly,disgusts,detox,denominator,demeanor,deliriously,decode,debauchery,croissant,cravings,cranked,coworkers,councilor,confuses,confiscate,confines,conduit,compress,combed,clouding,clamps,cinch,chinnery,celebratory,catalogs,carpenters,carnal,canin,bundys,bulldozer,buggers,bueller,brainy,booming,bookstores,bloodbath,bittersweet,bellhop,beeping,beanstalk,beady,baudelaire,bartenders,bargains,averted,armadillo,appreciating,appraised,antlers,aloof,allowances,alleyway,affleck,abject,zilch,youore,xanax,wrenching,wouldn,witted,wicca,whorehouse,whooo,whips,vouchers,victimized,vicodin,untested,unsolicited,unfocused,unfettered,unfeeling,unexplainable,understaffed,underbelly,tutorial,tryst,trampoline,towering,tirade,thieving,thang,swimmin,swayzak,suspecting,superstitions,stubbornness,streamers,strattman,stonewalling,stiffs,stacking,spout,splice,sonrisa,smarmy,slows,slicing,sisterly,shrill,shined,seeming,sedley,seatbelts,scour,scold,schoolyard,scarring,salieri,rustling,roxbury,rewire,revved,retriever,reputable,remodel,reins,reincarnation,rance,rafters,rackets,quail,pumbaa,proclaim,probing,privates,pried,prewedding,premeditation,posturing,posterity,pleasurable,pizzeria,pimps,penmanship,penchant,pelvis,overturn,overstepped,overcoat,ovens,outsmart,outed,ooohh,oncologist,omission,offhand,odour,nyazian,notarized,nobody'll,nightie,navel,nabbed,mystique,mover,mortician,morose,moratorium,mockingbird,mobsters,mingling,methinks,messengered,merde,masochist,martouf,martians,marinara,manray,majorly,magnifying,mackerel,lurid,lugging,lonnegan,loathsome,llantano,liberace,leprosy,latinos,lanterns,lamest,laferette,kraut,intestine,innocencia,inhibitions,ineffectual,indisposed,incurable,inconvenienced,inanimate,improbable,implode,hydrant,hustling,hustled,huevos,how'm,hooey,hoods,honcho,hinge,hijack,heimlich,hamunaptra,haladki,haiku,haggle,gutsy,grunting,grueling,gribbs,greevy,grandstanding,godparents,glows,glistening,gimmick,gaping,fraiser,formalities,foreigner,folders,foggy,fitty,fiends,fe'nos,favours,eyeing,extort,expedite,escalating,epinephrine,entitles,entice,eminence,eights,earthlings,eagerly,dunville,dugout,doublemeat,doling,dispensing,dispatcher,discoloration,diners,diddly,dictates,diazepam,derogatory,delights,defies,decoder,dealio,danson,cutthroat,crumbles,croissants,crematorium,craftsmanship,could'a,cordless,cools,conked,confine,concealing,complicates,communique,cockamamie,coasters,clobbered,clipping,clipboard,clemenza,cleanser,circumcision,chanukah,certainaly,cellmate,cancels,cadmium,buzzed,bumstead,bucko,browsing,broth,braver,boggling,bobbing,blurred,birkhead,benet,belvedere,bellies,begrudge,beckworth,banky,baldness,baggy,babysitters,aversion,astonished,assorted,appetites,angina,amiss,ambulances,alibis,airway,admires,adhesive,yoyou,xxxxxx,wreaked,wracking,woooo,wooing,wised,wilshire,wedgie,waging,violets,vincey,uplifting,untrustworthy,unmitigated,uneventful,undressing,underprivileged,unburden,umbilical,tweaking,turquoise,treachery,tosses,torching,toothpick,toasts,thickens,tereza,tenacious,teldar,taint,swill,sweatin,subtly,subdural,streep,stopwatch,stockholder,stillwater,stalkers,squished,squeegee,splinters,spliced,splat,spied,spackle,sophistication,snapshots,smite,sluggish,slithered,skeeters,sidewalks,sickly,shrugs,shrubbery,shrieking,shitless,settin,sentinels,selfishly,scarcely,sangria,sanctum,sahjhan,rustle,roving,rousing,rosomorf,riddled,responsibly,renoir,remoray,remedial,refundable,redirect,recheck,ravenwood,rationalizing,ramus,ramelle,quivering,pyjamas,psychos,provocations,prouder,protestors,prodded,proctologist,primordial,pricks,prickly,precedents,pentangeli,pathetically,parka,parakeet,panicky,overthruster,outsmarted,orthopedic,oncoming,offing,nutritious,nuthouse,nourishment,nibbling,newlywed,narcissist,mutilation,mundane,mummies,mumble,mowed,morvern,mortem,mopes,molasses,misplace,miscommunication,miney,midlife,menacing,memorizing,massaging,masking,magnets,luxuries,lounging,lothario,liposuction,lidocaine,libbets,levitate,leeway,launcelot,larek,lackeys,kumbaya,kryptonite,knapsack,keyhole,katarangura,juiced,jakey,ironclad,invoice,intertwined,interlude,interferes,injure,infernal,indeedy,incur,incorrigible,incantations,impediment,igloo,hysterectomy,hounded,hollering,hindsight,heebie,havesham,hasenfuss,hankering,hangers,hakuna,gutless,gusto,grubbing,grrrr,grazed,gratification,grandeur,gorak,godammit,gnawing,glanced,frostbite,frees,frazzled,fraulein,fraternizing,fortuneteller,formaldehyde,followup,foggiest,flunky,flickering,firecrackers,figger,fetuses,fates,eyeliner,extremities,extradited,expires,exceedingly,evaporate,erupt,epileptic,entrails,emporium,egregious,eggshells,easing,duwayne,droll,dreyfuss,dovey,doubly,doozy,donkeys,donde,distrust,distressing,disintegrate,discreetly,decapitated,dealin,deader,dashed,darkroom,dares,daddies,dabble,cushy,cupcakes,cuffed,croupier,croak,crapped,coursing,coolers,contaminate,consummated,construed,condos,concoction,compulsion,commish,coercion,clemency,clairvoyant,circulate,chesterton,checkered,charlatan,chaperones,categorically,cataracts,carano,capsules,capitalize,burdon,bullshitting,brewed,breathless,breasted,brainstorming,bossing,borealis,bonsoir,bobka,boast,blimp,bleep,bleeder,blackouts,bisque,billboards,beatings,bayberry,bashed,bamboozled,balding,baklava,baffled,backfires,babak,awkwardness,attest,attachments,apologizes,anyhoo,antiquated,alcante,advisable,aahhh,aaahh,zatarc,yearbooks,wuddya,wringing,womanhood,witless,winging,whatsa,wetting,waterproof,wastin,vogelman,vocation,vindicated,vigilance,vicariously,venza,vacuuming,utensils,uplink,unveil,unloved,unloading,uninhibited,unattached,tweaked,turnips,trinkets,toughen,toting,topside,terrors,terrify,technologically,tarnish,tagliati,szpilman,surly,supple,summation,suckin,stepmom,squeaking,splashmore,souffle,solitaire,solicitation,solarium,smokers,slugged,slobbering,skylight,skimpy,sinuses,silenced,sideburns,shrinkage,shoddy,shhhhhh,shelled,shareef,shangri,seuss,serenade,scuffle,scoff,scanners,sauerkraut,sardines,sarcophagus,salvy,rusted,russells,rowboat,rolfsky,ringside,respectability,reparations,renegotiate,reminisce,reimburse,regimen,raincoat,quibble,puzzled,purposefully,pubic,proofing,prescribing,prelim,poisons,poaching,personalized,personable,peroxide,pentonville,payphone,payoffs,paleontology,overflowing,oompa,oddest,objecting,o'hare,o'daniel,notches,nobody'd,nightstand,neutralized,nervousness,nerdy,needlessly,naquadah,nappy,nantucket,nambla,mountaineer,motherfuckin,morrie,monopolizing,mohel,mistreated,misreading,misbehave,miramax,minivan,milligram,milkshakes,metamorphosis,medics,mattresses,mathesar,matchbook,matata,marys,malucci,magilla,lymphoma,lowers,lordy,linens,lindenmeyer,limelight,leapt,laxative,lather,lapel,lamppost,laguardia,kindling,kegger,kawalsky,juries,jokin,jesminder,interning,innermost,injun,infallible,industrious,indulgence,incinerator,impossibility,impart,illuminate,iguanas,hypnotic,hyped,hospitable,hoses,homemaker,hirschmuller,helpers,headset,guardianship,guapo,grubby,granola,granddaddy,goren,goblet,gluttony,globes,giorno,getter,geritol,gassed,gaggle,foxhole,fouled,foretold,floorboards,flippers,flaked,fireflies,feedings,fashionably,farragut,fallback,facials,exterminate,excites,everything'll,evenin,ethically,ensue,enema,empath,eluded,eloquently,eject,edema,dumpling,droppings,dolled,distasteful,disputing,displeasure,disdain,deterrent,dehydration,defied,decomposing,dawned,dailies,custodian,crusts,crucifix,crowning,crier,crept,craze,crawls,couldn,correcting,corkmaster,copperfield,cooties,contraption,consumes,conspire,consenting,consented,conquers,congeniality,complains,communicator,commendable,collide,coladas,colada,clout,clooney,classifieds,clammy,civility,cirrhosis,chink,catskills,carvers,carpool,carelessness,cardio,carbs,capades,butabi,busmalis,burping,burdens,bunks,buncha,bulldozers,browse,brockovich,breakthroughs,bravado,boogety,blossoms,blooming,bloodsucker,blight,betterton,betrayer,belittle,beeps,bawling,barts,bartending,bankbooks,babish,atropine,assertive,armbrust,anyanka,annoyance,anemic,anago,airwaves,aimlessly,aaargh,aaand,yoghurt,writhing,workable,winking,winded,widen,whooping,whiter,whatya,wazoo,voila,virile,vests,vestibule,versed,vanishes,urkel,uproot,unwarranted,unscheduled,unparalleled,undergrad,tweedle,turtleneck,turban,trickery,transponder,toyed,townhouse,thyself,thunderstorm,thinning,thawed,tether,technicalities,tau'ri,tarnished,taffeta,tacked,systolic,swerve,sweepstakes,swabs,suspenders,superwoman,sunsets,succulent,subpoenas,stumper,stosh,stomachache,stewed,steppin,stepatech,stateside,spicoli,sparing,soulless,sonnets,sockets,snatching,smothering,slush,sloman,slashing,sitters,simpleton,sighs,sidra,sickens,shunned,shrunken,showbiz,shopped,shimmering,shagging,semblance,segue,sedation,scuzzlebutt,scumbags,screwin,scoundrels,scarsdale,scabs,saucers,saintly,saddened,runaways,runaround,rheya,resenting,rehashing,rehabilitated,regrettable,refreshed,redial,reconnecting,ravenous,raping,rafting,quandary,pylea,putrid,puffing,psychopathic,prunes,probate,prayin,pomegranate,plummeting,planing,plagues,pinata,pithy,perversion,personals,perched,peeps,peckish,pavarotti,pajama,packin,pacifier,overstepping,okama,obstetrician,nutso,nuance,normalcy,nonnegotiable,nomak,ninny,nines,nicey,newsflash,neutered,nether,negligee,necrosis,navigating,narcissistic,mylie,muses,momento,moisturizer,moderation,misinformed,misconception,minnifield,mikkos,methodical,mebbe,meager,maybes,matchmaking,masry,markovic,malakai,luzhin,lusting,lumberjack,loopholes,loaning,lightening,leotard,launder,lamaze,kubla,kneeling,kibosh,jumpsuit,joliet,jogger,janover,jakovasaurs,irreparable,innocently,inigo,infomercial,inexplicable,indispensable,impregnated,impossibly,imitating,hunches,hummus,houmfort,hothead,hostiles,hooves,hooligans,homos,homie,hisself,heyyy,hesitant,hangout,handsomest,handouts,hairless,gwennie,guzzling,guinevere,grungy,goading,glaring,gavel,gardino,gangrene,fruitful,friendlier,freckle,freakish,forthright,forearm,footnote,flops,fixer,firecracker,finito,figgered,fezzik,fastened,farfetched,fanciful,familiarize,faire,fahrenheit,extravaganza,exploratory,explanatory,everglades,eunuch,estas,escapade,erasers,emptying,embarassing,dweeb,dutiful,dumplings,dries,drafty,dollhouse,dismissing,disgraced,discrepancies,disbelief,disagreeing,digestion,didnt,deviled,deviated,demerol,delectable,decaying,decadent,dears,dateless,d'algout,cultivating,cryto,crumpled,crumbled,cronies,crease,craves,cozying,corduroy,congratulated,confidante,compressions,complicating,compadre,coerce,classier,chums,chumash,chivalrous,chinpoko,charred,chafing,celibacy,carted,carryin,carpeting,carotid,cannibals,candor,butterscotch,busts,busier,bullcrap,buggin,brookside,brodski,brassiere,brainwash,brainiac,botrelle,bonbon,boatload,blimey,blaring,blackness,bipartisan,bimbos,bigamist,biebe,biding,betrayals,bestow,bellerophon,bedpans,bassinet,basking,barzini,barnyard,barfed,backups,audited,asinine,asalaam,arouse,applejack,annoys,anchovies,ampule,alameida,aggravate,adage,accomplices,yokel,y'ever,wringer,witwer,withdrawals,windward,willfully,whorfin,whimsical,whimpering,weddin,weathered,warmest,wanton,volant,visceral,vindication,veggies,urinate,uproar,unwritten,unwrap,unsung,unsubstantiated,unspeakably,unscrupulous,unraveling,unquote,unqualified,unfulfilled,undetectable,underlined,unattainable,unappreciated,ummmm,ulcers,tylenol,tweak,turnin,tuatha,tropez,trellis,toppings,tootin,toodle,tinkering,thrives,thespis,theatrics,thatherton,tempers,tavington,tartar,tampon,swelled,sutures,sustenance,sunflowers,sublet,stubbins,strutting,strewn,stowaway,stoic,sternin,stabilizing,spiraling,spinster,speedometer,speakeasy,soooo,soiled,sneakin,smithereens,smelt,smacks,slaughterhouse,slacks,skids,sketching,skateboards,sizzling,sixes,sirree,simplistic,shouts,shorted,shoelace,sheeit,shards,shackled,sequestered,selmak,seduces,seclusion,seamstress,seabeas,scoops,scooped,scavenger,satch,s'more,rudeness,romancing,rioja,rifkin,rieper,revise,reunions,repugnant,replicating,repaid,renewing,relaxes,rekindle,regrettably,regenerate,reels,reciting,reappear,readin,ratting,rapes,rancher,rammed,rainstorm,railroading,queers,punxsutawney,punishes,pssst,prudy,proudest,protectors,procrastinating,proactive,priss,postmortem,pompoms,poise,pickings,perfectionist,peretti,people'll,pecking,patrolman,paralegal,paragraphs,paparazzi,pankot,pampering,overstep,overpower,outweigh,omnipotent,odious,nuwanda,nurtured,newsroom,neeson,needlepoint,necklaces,neato,muggers,muffler,mousy,mourned,mosey,mopey,mongolians,moldy,misinterpret,minibar,microfilm,mendola,mended,melissande,masturbating,masbath,manipulates,maimed,mailboxes,magnetism,m'lord,m'honey,lymph,lunge,lovelier,lefferts,leezak,ledgers,larraby,laloosh,kundun,kozinski,knockoff,kissin,kiosk,kennedys,kellman,karlo,kaleidoscope,jeffy,jaywalking,instructing,infraction,informer,infarction,impulsively,impressing,impersonated,impeach,idiocy,hyperbole,hurray,humped,huhuh,hsing,hordes,hoodlums,honky,hitchhiker,hideously,heaving,heathcliff,headgear,headboard,hazing,harem,handprint,hairspray,gutiurrez,goosebumps,gondola,glitches,gasping,frolic,freeways,frayed,fortitude,forgetful,forefathers,fonder,foiled,foaming,flossing,flailing,fitzgeralds,firehouse,finders,fiftieth,fellah,fawning,farquaad,faraway,fancied,extremists,exorcist,exhale,ethros,entrust,ennui,energized,encephalitis,embezzling,elster,elixir,electrolytes,duplex,dryers,drexl,dredging,drawback,don'ts,dobisch,divorcee,disrespected,disprove,disobeying,disinfectant,dingy,digress,dieting,dictating,devoured,devise,detonators,desist,deserter,derriere,deron,deceptive,debilitating,deathwok,daffodils,curtsy,cursory,cuppa,cumin,cronkite,cremation,credence,cranking,coverup,courted,countin,counselling,cornball,contentment,consensual,compost,cluett,cleverly,cleansed,cleanliness,chopec,chomp,chins,chime,cheswick,chessler,cheapest,chatted,cauliflower,catharsis,catchin,caress,camcorder,calorie,cackling,bystanders,buttoned,buttering,butted,buries,burgel,buffoon,brogna,bragged,boutros,bogeyman,blurting,blurb,blowup,bloodhound,blissful,birthmark,bigot,bestest,belted,belligerent,beggin,befall,beeswax,beatnik,beaming,barricade,baggoli,badness,awoke,artsy,artful,aroun,armpits,arming,annihilate,anise,angiogram,anaesthetic,amorous,ambiance,alligators,adoration,admittance,adama,abydos,zonked,zhivago,yorkin,wrongfully,writin,wrappers,worrywart,woops,wonderfalls,womanly,wickedness,whoopie,wholeheartedly,whimper,which'll,wheelchairs,what'ya,warranted,wallop,wading,wacked,virginal,vermouth,vermeil,verger,ventriss,veneer,vampira,utero,ushers,urgently,untoward,unshakable,unsettled,unruly,unlocks,ungodly,undue,uncooperative,uncontrollably,unbeatable,twitchy,tumbler,truest,triumphs,triplicate,tribbey,tortures,tongaree,tightening,thorazine,theres,testifies,teenaged,tearful,taxing,taldor,syllabus,swoops,swingin,suspending,sunburn,stuttering,stupor,strides,strategize,strangulation,stooped,stipulation,stingy,stapled,squeaks,squawking,spoilsport,splicing,spiel,spencers,spasms,spaniard,softener,sodding,soapbox,smoldering,smithbauer,skittish,sifting,sickest,sicilians,shuffling,shrivel,segretti,seeping,securely,scurrying,scrunch,scrote,screwups,schenkman,sawing,savin,satine,sapiens,salvaging,salmonella,sacrilege,rumpus,ruffle,roughing,rotted,rondall,ridding,rickshaw,rialto,rhinestone,restrooms,reroute,requisite,repress,rednecks,redeeming,rayed,ravell,raked,raincheck,raffi,racked,pushin,profess,prodding,procure,presuming,preppy,prednisone,potted,posttraumatic,poorhouse,podiatrist,plowed,pledging,playroom,plait,placate,pinback,picketing,photographing,pharoah,petrak,petal,persecuting,perchance,pellets,peeved,peerless,payable,pauses,pathologist,pagliacci,overwrought,overreaction,overqualified,overheated,outcasts,otherworldly,opinionated,oodles,oftentimes,occured,obstinate,nutritionist,numbness,nubile,nooooooo,nobodies,nepotism,neanderthals,mushu,mucus,mothering,mothballs,monogrammed,molesting,misspoke,misspelled,misconstrued,miscalculated,minimums,mince,mildew,mighta,middleman,mementos,mellowed,mayol,mauled,massaged,marmalade,mardi,makings,lundegaard,lovingly,loudest,lotto,loosing,loompa,looming,longs,loathes,littlest,littering,lifelike,legalities,laundered,lapdog,lacerations,kopalski,knobs,knitted,kittridge,kidnaps,kerosene,karras,jungles,jockeys,iranoff,invoices,invigorating,insolence,insincere,insectopia,inhumane,inhaling,ingrates,infestation,individuality,indeterminate,incomprehensible,inadequacy,impropriety,importer,imaginations,illuminating,ignite,hysterics,hypodermic,hyperventilate,hyperactive,humoring,honeymooning,honed,hoist,hoarding,hitching,hiker,hightail,hemoglobin,hell'd,heinie,growin,grasped,grandparent,granddaughters,gouged,goblins,gleam,glades,gigantor,get'em,geriatric,gatekeeper,gargoyles,gardenias,garcon,garbo,gallows,gabbing,futon,fulla,frightful,freshener,fortuitous,forceps,fogged,fodder,foamy,flogging,flaun,flared,fireplaces,feverish,favell,fattest,fattening,fallow,extraordinaire,evacuating,errant,envied,enchant,enamored,egocentric,dussander,dunwitty,dullest,dropout,dredged,dorsia,doornail,donot,dongs,dogged,dodgy,ditty,dishonorable,discriminating,discontinue,dings,dilly,dictation,dialysis,delly,delightfully,daryll,dandruff,cruddy,croquet,cringe,crimp,credo,crackling,courtside,counteroffer,counterfeiting,corrupting,copping,conveyor,contusions,contusion,conspirator,consoling,connoisseur,confetti,composure,compel,colic,coddle,cocksuckers,coattails,cloned,claustrophobia,clamoring,churn,chugga,chirping,chasin,chapped,chalkboard,centimeter,caymans,catheter,casings,caprica,capelli,cannolis,cannoli,camogli,camembert,butchers,butchered,busboys,bureaucrats,buckled,bubbe,brownstone,bravely,brackley,bouquets,botox,boozing,boosters,bodhi,blunders,blunder,blockage,biocyte,betrays,bested,beryllium,beheading,beggar,begbie,beamed,bastille,barstool,barricades,barbecues,barbecued,bandwagon,backfiring,bacarra,avenged,autopsies,aunties,associating,artichoke,arrowhead,appendage,apostrophe,antacid,ansel,annul,amuses,amped,amicable,amberg,alluring,adversaries,admirers,adlai,acupuncture,abnormality,aaaahhhh,zooming,zippity,zipping,zeroed,yuletide,yoyodyne,yengeese,yeahhh,wrinkly,wracked,withered,winks,windmills,whopping,wendle,weigart,waterworks,waterbed,watchful,wantin,wagging,waaah,vying,ventricle,varnish,vacuumed,unreachable,unprovoked,unmistakable,unfriendly,unfolding,underpaid,uncuff,unappealing,unabomber,typhoid,tuxedos,tushie,turds,tumnus,troubadour,trinium,treaters,treads,transpired,transgression,tought,thready,thins,thinners,techs,teary,tattaglia,tassels,tarzana,tanking,tablecloths,synchronize,symptomatic,sycophant,swimmingly,sweatshop,surfboard,superpowers,sunroom,sunblock,sugarplum,stupidly,strumpet,strapless,stooping,stools,stealthy,stalks,stairmaster,staffer,sshhh,squatting,squatters,spectacularly,sorbet,socked,sociable,snubbed,snorting,sniffles,snazzy,snakebite,smuggler,smorgasbord,smooching,slurping,slouch,slingshot,slaved,skimmed,sisterhood,silliest,sidarthur,sheraton,shebang,sharpening,shanghaied,shakers,sendoff,scurvy,scoliosis,scaredy,scagnetti,sawchuk,saugus,sasquatch,sandbag,saltines,s'pose,roston,rostle,riveting,ristle,rifling,revulsion,reverently,retrograde,restful,resents,reptilian,reorganize,renovating,reiterate,reinvent,reinmar,reibers,reechard,recuse,reconciling,recognizance,reclaiming,recitation,recieved,rebate,reacquainted,rascals,railly,quintuplets,quahog,pygmies,puzzling,punctuality,prosthetic,proms,probie,preys,preserver,preppie,poachers,plummet,plumbers,plannin,pitying,pitfalls,piqued,pinecrest,pinches,pillage,pigheaded,physique,pessimistic,persecute,perjure,percentile,pentothal,pensky,penises,peini,pazzi,pastels,parlour,paperweight,pamper,pained,overwhelm,overalls,outrank,outpouring,outhouse,outage,ouija,obstructed,obsessions,obeying,obese,o'riley,o'higgins,nosebleeds,norad,noooooooo,nononono,nonchalant,nippy,neurosis,nekhorvich,necronomicon,naquada,n'est,mystik,mystified,mumps,muddle,mothership,moped,monumentally,monogamous,mondesi,misogynistic,misinterpreting,mindlock,mending,megaphone,meeny,medicating,meanie,masseur,markstrom,marklars,margueritas,manifesting,maharajah,lukewarm,loveliest,loran,lizardo,liquored,lipped,lingers,limey,lemkin,leisurely,lathe,latched,lapping,ladle,krevlorneswath,kosygin,khakis,kenaru,keats,kaitlan,julliard,jollies,jaundice,jargon,jackals,invisibility,insipid,inflamed,inferiority,inexperience,incinerated,incinerate,incendiary,incan,inbred,implicating,impersonator,hunks,horsing,hooded,hippopotamus,hiked,hetson,hetero,hessian,henslowe,hendler,hellstrom,headstone,hayloft,harbucks,handguns,hallucinate,haldol,haggling,gynaecologist,gulag,guilder,guaranteeing,groundskeeper,grindstone,grimoir,grievance,griddle,gribbit,greystone,graceland,gooders,goeth,gentlemanly,gelatin,gawking,ganged,fukes,fromby,frenchmen,foursome,forsley,forbids,footwork,foothold,floater,flinging,flicking,fittest,fistfight,fireballs,fillings,fiddling,fennyman,felonious,felonies,feces,favoritism,fatten,fanatics,faceman,excusing,excepted,entwined,entree,ensconced,eladio,ehrlichman,easterland,dueling,dribbling,drape,downtrodden,doused,dosed,dorleen,dokie,distort,displeased,disown,dismount,disinherited,disarmed,disapproves,diperna,dined,diligent,dicaprio,depress,decoded,debatable,dealey,darsh,damsels,damning,dad'll,d'oeuvre,curlers,curie,cubed,crikey,crepes,countrymen,cornfield,coppers,copilot,copier,cooing,conspiracies,consigliere,condoning,commoner,commies,combust,comas,colds,clawed,clamped,choosy,chomping,chimps,chigorin,chianti,cheep,checkups,cheaters,celibate,cautiously,cautionary,castell,carpentry,caroling,carjacking,caritas,caregiver,cardiology,candlesticks,canasta,cain't,burro,burnin,bunking,bumming,bullwinkle,brummel,brooms,brews,breathin,braslow,bracing,botulism,boorish,bloodless,blayne,blatantly,blankie,bedbugs,becuase,barmaid,bared,baracus,banal,bakes,backpacks,attentions,atrocious,ativan,athame,asunder,astound,assuring,aspirins,asphyxiation,ashtrays,aryans,arnon,apprehension,applauding,anvil,antiquing,antidepressants,annoyingly,amputate,altruistic,alotta,alerting,afterthought,affront,affirm,actuality,abysmal,absentee,yeller,yakushova,wuzzy,wriggle,worrier,woogyman,womanizer,windpipe,windbag,willin,whisking,whimsy,wendall,weeny,weensy,weasels,watery,watcha,wasteful,waski,washcloth,waaay,vouched,viznick,ventriloquist,vendettas,veils,vayhue,vamanos,vadimus,upstage,uppity,unsaid,unlocking,unintentionally,undetected,undecided,uncaring,unbearably,tween,tryout,trotting,trini,trimmings,trickier,treatin,treadstone,trashcan,transcendent,tramps,townsfolk,torturous,torrid,toothpicks,tolerable,tireless,tiptoeing,timmay,tillinghouse,tidying,tibia,thumbing,thrusters,thrashing,these'll,thatos,testicular,teriyaki,tenors,tenacity,tellers,telemetry,tarragon,switchblade,swicker,swells,sweatshirts,swatches,surging,supremely,sump'n,succumb,subsidize,stumbles,stuffs,stoppin,stipulate,stenographer,steamroll,stasis,stagger,squandered,splint,splendidly,splashy,splashing,specter,sorcerers,somewheres,somber,snuggled,snowmobile,sniffed,snags,smugglers,smudged,smirking,smearing,slings,sleet,sleepovers,sleek,slackers,siree,siphoning,singed,sincerest,sickened,shuffled,shriveled,shorthanded,shittin,shish,shipwrecked,shins,sheetrock,shawshank,shamu,sha're,servitude,sequins,seascape,scrapings,scoured,scorching,sandpaper,saluting,salud,ruffled,roughnecks,rougher,rosslyn,rosses,roost,roomy,romping,revolutionize,reprimanded,refute,refrigerated,reeled,redundancies,rectal,recklessly,receding,reassignment,reapers,readout,ration,raring,ramblings,raccoons,quarantined,purging,punters,psychically,premarital,pregnancies,predisposed,precautionary,pollute,podunk,plums,plaything,pixilated,pitting,piranhas,pieced,piddles,pickled,photogenic,phosphorous,pffft,pestilence,pessimist,perspiration,perps,penticoff,passageways,pardons,panics,pancamo,paleontologist,overwhelms,overstating,overpaid,overdid,outlive,orthodontist,orgies,oreos,ordover,ordinates,ooooooh,oooohhh,omelettes,officiate,obtuse,obits,nymph,novocaine,noooooooooo,nipping,nilly,nightstick,negate,neatness,natured,narcotic,narcissism,namun,nakatomi,murky,muchacho,mouthwash,motzah,morsel,morph,morlocks,mooch,moloch,molest,mohra,modus,modicum,mockolate,misdemeanors,miscalculation,middies,meringue,mercilessly,meditating,mayakovsky,maximillian,marlee,markovski,maniacal,maneuvered,magnificence,maddening,lutze,lunged,lovelies,lorry,loosening,lookee,littered,lilac,lightened,laces,kurzon,kurtzweil,kind've,kimono,kenji,kembu,keanu,kazuo,jonesing,jilted,jiggling,jewelers,jewbilee,jacqnoud,jacksons,ivories,insurmountable,innocuous,innkeeper,infantery,indulged,indescribable,incoherent,impervious,impertinent,imperfections,hunnert,huffy,horsies,horseradish,hollowed,hogwash,hockley,hissing,hiromitsu,hidin,hereafter,helpmann,hehehe,haughty,happenings,hankie,handsomely,halliwells,haklar,haise,gunsights,grossly,grope,grocer,grits,gripping,grabby,glorificus,gizzard,gilardi,gibarian,geminon,gasses,garnish,galloping,gairwyn,futterman,futility,fumigated,fruitless,friendless,freon,foregone,forego,floored,flighty,flapjacks,fizzled,ficus,festering,farbman,fabricate,eyghon,extricate,exalted,eventful,esophagus,enterprising,entail,endor,emphatically,embarrasses,electroshock,easel,duffle,drumsticks,dissection,dissected,disposing,disparaging,disorientation,disintegrated,disarming,devoting,dessaline,deprecating,deplorable,delve,degenerative,deduct,decomposed,deathly,dearie,daunting,dankova,cyclotron,cyberspace,cutbacks,culpable,cuddled,crumpets,cruelly,crouching,cranium,cramming,cowering,couric,cordesh,conversational,conclusively,clung,clotting,cleanest,chipping,chimpanzee,chests,cheapen,chainsaws,censure,catapult,caravaggio,carats,captivating,calrissian,butlers,busybody,bussing,bunion,bulimic,budging,brung,browbeat,brokenhearted,brecher,breakdowns,bracebridge,boning,blowhard,blisters,blackboard,bigotry,bialy,bhamra,bended,begat,battering,baste,basquiat,barricaded,barometer,balled,baited,badenweiler,backhand,ascenscion,argumentative,appendicitis,apparition,anxiously,antagonistic,angora,anacott,amniotic,ambience,alonna,aleck,akashic,ageless,abouts,aawwww,aaaaarrrrrrggghhh,aaaaaa,zendi,yuppies,yodel,y'hear,wrangle,wombosi,wittle,withstanding,wisecracks,wiggling,wierd,whittlesley,whipper,whattya,whatsamatter,whatchamacallit,whassup,whad'ya,weakling,warfarin,waponis,wampum,wadn't,vorash,vizzini,virtucon,viridiana,veracity,ventilated,varicose,varcon,vandalized,vamos,vamoose,vaccinated,vacationing,usted,urinal,uppers,unwittingly,unsealed,unplanned,unhinged,unhand,unfathomable,unequivocally,unbreakable,unadvisedly,udall,tynacorp,tuxes,tussle,turati,tunic,tsavo,trussed,troublemakers,trollop,tremors,transsexual,transfusions,toothbrushes,toned,toddlers,tinted,tightened,thundering,thorpey,this'd,thespian,thaddius,tenuous,tenths,tenement,telethon,teleprompter,teaspoon,taunted,tattle,tardiness,taraka,tappy,tapioca,tapeworm,talcum,tacks,swivel,swaying,superpower,summarize,sumbitch,sultry,suburbia,styrofoam,stylings,strolls,strobe,stockpile,stewardesses,sterilized,sterilize,stealin,stakeouts,squawk,squalor,squabble,sprinkled,sportsmanship,spokes,spiritus,sparklers,spareribs,sowing,sororities,sonovabitch,solicit,softy,softness,softening,snuggling,snatchers,snarling,snarky,snacking,smears,slumped,slowest,slithering,sleazebag,slayed,slaughtering,skidded,skated,sivapathasundaram,sissies,silliness,silences,sidecar,sicced,shylock,shtick,shrugged,shriek,shoves,should'a,shortcake,shockingly,shirking,shaves,shatner,sharpener,shapely,shafted,sexless,septum,selflessness,seabea,scuff,screwball,scoping,scooch,scolding,schnitzel,schemed,scalper,santy,sankara,sanest,salesperson,sakulos,safehouse,sabers,runes,rumblings,rumbling,ruijven,ringers,righto,rhinestones,retrieving,reneging,remodelling,relentlessly,regurgitate,refills,reeking,reclusive,recklessness,recanted,ranchers,rafer,quaking,quacks,prophesied,propensity,profusely,problema,prided,prays,postmark,popsicles,poodles,pollyanna,polaroids,pokes,poconos,pocketful,plunging,plugging,pleeease,platters,pitied,pinetti,piercings,phooey,phonies,pestering,periscope,pentagram,pelts,patronized,paramour,paralyze,parachutes,pales,paella,paducci,owatta,overdone,overcrowded,overcompensating,ostracized,ordinate,optometrist,operandi,omens,okayed,oedipal,nuttier,nuptial,nunheim,noxious,nourish,notepad,nitroglycerin,nibblet,neuroses,nanosecond,nabbit,mythic,munchkins,multimillion,mulroney,mucous,muchas,mountaintop,morlin,mongorians,moneybags,mom'll,molto,mixup,misgivings,mindset,michalchuk,mesmerized,merman,mensa,meaty,mbwun,materialize,materialistic,masterminded,marginally,mapuhe,malfunctioning,magnify,macnamara,macinerney,machinations,macadamia,lysol,lurks,lovelorn,lopsided,locator,litback,litany,linea,limousines,limes,lighters,liebkind,levity,levelheaded,letterhead,lesabre,leron,lepers,lefts,leftenant,laziness,layaway,laughlan,lascivious,laryngitis,lapsed,landok,laminated,kurten,kobol,knucklehead,knowed,knotted,kirkeby,kinsa,karnovsky,jolla,jimson,jettison,jeric,jawed,jankis,janitors,jango,jalopy,jailbreak,jackers,jackasses,invalidate,intercepting,intercede,insinuations,infertile,impetuous,impaled,immerse,immaterial,imbeciles,imagines,idyllic,idolized,icebox,i'd've,hypochondriac,hyphen,hurtling,hurried,hunchback,hullo,horsting,hoooo,homeboys,hollandaise,hoity,hijinks,hesitates,herrero,herndorff,helplessly,heeyy,heathen,hearin,headband,harrassment,harpies,halstrom,hahahahaha,hacer,grumbling,grimlocks,grift,greets,grandmothers,grander,grafts,gordievsky,gondorff,godorsky,glscripts,gaudy,gardeners,gainful,fuses,fukienese,frizzy,freshness,freshening,fraught,frantically,foxbooks,fortieth,forked,foibles,flunkies,fleece,flatbed,fisted,firefight,fingerpaint,filibuster,fhloston,fenceline,femur,fatigues,fanucci,fantastically,familiars,falafel,fabulously,eyesore,expedient,ewwww,eviscerated,erogenous,epidural,enchante,embarassed,embarass,embalming,elude,elspeth,electrocute,eigth,eggshell,echinacea,eases,earpiece,earlobe,dumpsters,dumbshit,dumbasses,duloc,duisberg,drummed,drinkers,dressy,dorma,doily,divvy,diverting,dissuade,disrespecting,displace,disorganized,disgustingly,discord,disapproving,diligence,didja,diced,devouring,detach,destructing,desolate,demerits,delude,delirium,degrade,deevak,deemesa,deductions,deduce,debriefed,deadbeats,dateline,darndest,damnable,dalliance,daiquiri,d'agosta,cussing,cryss,cripes,cretins,crackerjack,cower,coveting,couriers,countermission,cotswolds,convertibles,conversationalist,consorting,consoled,consarn,confides,confidentially,commited,commiserate,comme,comforter,comeuppance,combative,comanches,colosseum,colling,coexist,coaxing,cliffside,chutes,chucked,chokes,childlike,childhoods,chickening,chenowith,charmingly,changin,catsup,captioning,capsize,cappucino,capiche,candlewell,cakewalk,cagey,caddie,buxley,bumbling,bulky,buggered,brussel,brunettes,brumby,brotha,bronck,brisket,bridegroom,braided,bovary,bookkeeper,bluster,bloodline,blissfully,blase,billionaires,bicker,berrisford,bereft,berating,berate,bendy,belive,belated,beikoku,beens,bedspread,bawdy,barreling,baptize,banya,balthazar,balmoral,bakshi,bails,badgered,backstreet,awkwardly,auras,attuned,atheists,astaire,assuredly,arrivederci,appetit,appendectomy,apologetic,antihistamine,anesthesiologist,amulets,albie,alarmist,aiight,adstream,admirably,acquaint,abound,abominable,aaaaaaah,zekes,zatunica,wussy,worded,wooed,woodrell,wiretap,windowsill,windjammer,windfall,whisker,whims,whatiya,whadya,weirdly,weenies,waunt,washout,wanto,waning,victimless,verdad,veranda,vandaley,vancomycin,valise,vaguest,upshot,unzip,unwashed,untrained,unstuck,unprincipled,unmentionables,unjustly,unfolds,unemployable,uneducated,unduly,undercut,uncovering,unconsciousness,unconsciously,tyndareus,turncoat,turlock,tulle,tryouts,trouper,triplette,trepkos,tremor,treeger,trapeze,traipse,tradeoff,trach,torin,tommorow,tollan,toity,timpani,thumbprint,thankless,tell'em,telepathy,telemarketing,telekinesis,teevee,teeming,tarred,tambourine,talentless,swooped,switcheroo,swirly,sweatpants,sunstroke,suitors,sugarcoat,subways,subterfuge,subservient,subletting,stunningly,strongbox,striptease,stravanavitch,stradling,stoolie,stodgy,stocky,stifle,stealer,squeezes,squatter,squarely,sprouted,spool,spindly,speedos,soups,soundly,soulmates,somebody'll,soliciting,solenoid,sobering,snowflakes,snowballs,snores,slung,slimming,skulk,skivvies,skewered,skewer,sizing,sistine,sidebar,sickos,shushing,shunt,shugga,shone,shol'va,sharpened,shapeshifter,shadowing,shadoe,selectman,sefelt,seared,scrounging,scribbling,scooping,scintillating,schmoozing,scallops,sapphires,sanitarium,sanded,safes,rudely,roust,rosebush,rosasharn,rondell,roadhouse,riveted,rewrote,revamp,retaliatory,reprimand,replicators,replaceable,remedied,relinquishing,rejoicing,reincarnated,reimbursed,reevaluate,redid,redefine,recreating,reconnected,rebelling,reassign,rearview,rayne,ravings,ratso,rambunctious,radiologist,quiver,quiero,queef,qualms,pyrotechnics,pulsating,psychosomatic,proverb,promiscuous,profanity,prioritize,preying,predisposition,precocious,precludes,prattling,prankster,povich,potting,postpartum,porridge,polluting,plowing,pistachio,pissin,pickpocket,physicals,peruse,pertains,personified,personalize,perjured,perfecting,pepys,pepperdine,pembry,peering,peels,pedophile,patties,passkey,paratrooper,paraphernalia,paralyzing,pandering,paltry,palpable,pagers,pachyderm,overstay,overestimated,overbite,outwit,outgrow,outbid,ooops,oomph,oohhh,oldie,obliterate,objectionable,nygma,notting,noches,nitty,nighters,newsstands,newborns,neurosurgery,nauseated,nastiest,narcolepsy,mutilate,muscled,murmur,mulva,mulling,mukada,muffled,morgues,moonbeams,monogamy,molester,molestation,molars,moans,misprint,mismatched,mirth,mindful,mimosas,millander,mescaline,menstrual,menage,mellowing,medevac,meddlesome,matey,manicures,malevolent,madmen,macaroons,lydell,lycra,lunchroom,lunching,lozenges,looped,litigious,liquidate,linoleum,lingk,limitless,limber,lilacs,ligature,liftoff,lemmiwinks,leggo,learnin,lazarre,lawyered,lactose,knelt,kenosha,kemosabe,jussy,junky,jordy,jimmies,jeriko,jakovasaur,issacs,isabela,irresponsibility,ironed,intoxication,insinuated,inherits,ingest,ingenue,inflexible,inflame,inevitability,inedible,inducement,indignant,indictments,indefensible,incomparable,incommunicado,improvising,impounded,illogical,ignoramus,hydrochloric,hydrate,hungover,humorless,humiliations,hugest,hoverdrone,hovel,hmmph,hitchhike,hibernating,henchman,helloooo,heirlooms,heartsick,headdress,hatches,harebrained,hapless,hanen,handsomer,hallows,habitual,guten,gummy,guiltier,guidebook,gstaad,gruff,griss,grieved,grata,gorignak,goosed,goofed,glowed,glitz,glimpses,glancing,gilmores,gianelli,geraniums,garroway,gangbusters,gamblers,galls,fuddy,frumpy,frowning,frothy,fro'tak,frere,fragrances,forgettin,follicles,flowery,flophouse,floatin,flirts,flings,flatfoot,fingerprinting,fingerprinted,fingering,finald,fillet,fianc,femoral,federales,fawkes,fascinates,farfel,fambly,falsified,fabricating,exterminators,expectant,excusez,excrement,excercises,evian,etins,esophageal,equivalency,equate,equalizer,entrees,enquire,endearment,empathetic,emailed,eggroll,earmuffs,dyslexic,duper,duesouth,drunker,druggie,dreadfully,dramatics,dragline,downplay,downers,dominatrix,doers,docket,docile,diversify,distracts,disloyalty,disinterested,discharging,disagreeable,dirtier,dinghy,dimwitted,dimoxinil,dimmy,diatribe,devising,deviate,detriment,desertion,depressants,depravity,deniability,delinquents,defiled,deepcore,deductive,decimate,deadbolt,dauthuille,dastardly,daiquiris,daggers,dachau,curiouser,curdled,cucamonga,cruller,cruces,crosswalk,crinkle,crescendo,cremate,counseled,couches,cornea,corday,copernicus,contrition,contemptible,constipated,conjoined,confounded,condescend,concoct,conch,compensating,committment,commandeered,comely,coddled,cockfight,cluttered,clunky,clownfish,cloaked,clenched,cleanin,civilised,circumcised,cimmeria,cilantro,chutzpah,chucking,chiseled,chicka,chattering,cervix,carrey,carpal,carnations,cappuccinos,candied,calluses,calisthenics,bushy,burners,budington,buchanans,brimming,braids,boycotting,bouncers,botticelli,botherin,bookkeeping,bogyman,bogged,bloodthirsty,blintzes,blanky,binturong,billable,bigboote,bewildered,betas,bequeath,behoove,befriend,bedpost,bedded,baudelaires,barreled,barboni,barbeque,bangin,baltus,bailout,backstabber,baccarat,awning,augie,arguillo,archway,apricots,apologising,annyong,anchorman,amenable,amazement,allspice,alannis,airfare,airbags,ahhhhhhhhh,ahhhhhhhh,ahhhhhhh,agitator,adrenal,acidosis,achoo,accessorizing,accentuate,abrasions,abductor,aaaahhh,aaaaaaaa,aaaaaaa,zeroing,zelner,zeldy,yevgeny,yeska,yellows,yeesh,yeahh,yamuri,wouldn't've,workmanship,woodsman,winnin,winked,wildness,whoring,whitewash,whiney,when're,wheezer,wheelman,wheelbarrow,westerburg,weeding,watermelons,washboard,waltzes,wafting,voulez,voluptuous,vitone,vigilantes,videotaping,viciously,vices,veruca,vermeer,verifying,vasculitis,valets,upholstered,unwavering,untold,unsympathetic,unromantic,unrecognizable,unpredictability,unmask,unleashing,unintentional,unglued,unequivocal,underrated,underfoot,unchecked,unbutton,unbind,unbiased,unagi,uhhhhh,tugging,triads,trespasses,treehorn,traviata,trappers,transplants,trannie,tramping,tracheotomy,tourniquet,tooty,toothless,tomarrow,toasters,thruster,thoughtfulness,thornwood,tengo,tenfold,telltale,telephoto,telephoned,telemarketer,tearin,tastic,tastefully,tasking,taser,tamed,tallow,taketh,taillight,tadpoles,tachibana,syringes,sweated,swarthy,swagger,surges,supermodels,superhighway,sunup,sun'll,sulfa,sugarless,sufficed,subside,strolled,stringy,strengthens,straightest,straightens,storefront,stopper,stockpiling,stimulant,stiffed,steyne,sternum,stepladder,stepbrother,steers,steelheads,steakhouse,stathis,stankylecartmankennymr,standoffish,stalwart,squirted,spritz,sprig,sprawl,spousal,sphincter,spenders,spearmint,spatter,spangled,southey,soured,sonuvabitch,somethng,snuffed,sniffs,smokescreen,smilin,slobs,sleepwalker,sleds,slays,slayage,skydiving,sketched,skanks,sixed,siphoned,siphon,simpering,sigfried,sidearm,siddons,sickie,shuteye,shuffleboard,shrubberies,shrouded,showmanship,shouldn't've,shoplift,shiatsu,sentries,sentance,sensuality,seething,secretions,searing,scuttlebutt,sculpt,scowling,scouring,scorecard,schoolers,schmucks,scepters,scaly,scalps,scaffolding,sauces,sartorius,santen,salivating,sainthood,saget,saddens,rygalski,rusting,ruination,rueland,rudabaga,rottweiler,roofies,romantics,rollerblading,roldy,roadshow,rickets,rible,rheza,revisiting,retentive,resurface,restores,respite,resounding,resorting,resists,repulse,repressing,repaying,reneged,refunds,rediscover,redecorated,reconstructive,recommitted,recollect,receptacle,reassess,reanimation,realtors,razinin,rationalization,ratatouille,rashum,rasczak,rancheros,rampler,quizzing,quips,quartered,purring,pummeling,puede,proximo,prospectus,pronouncing,prolonging,procreation,proclamations,principled,prides,preoccupation,prego,precog,prattle,pounced,potshots,potpourri,porque,pomegranates,polenta,plying,pluie,plesac,playmates,plantains,pillowcase,piddle,pickers,photocopied,philistine,perpetuate,perpetually,perilous,pawned,pausing,pauper,parter,parlez,parlay,pally,ovulation,overtake,overstate,overpowering,overpowered,overconfident,overbooked,ovaltine,outweighs,outings,ottos,orrin,orifice,orangutan,oopsy,ooooooooh,oooooo,ooohhhh,ocular,obstruct,obscenely,o'dwyer,nutjob,nunur,notifying,nostrand,nonny,nonfat,noblest,nimble,nikes,nicht,newsworthy,nestled,nearsighted,ne'er,nastier,narco,nakedness,muted,mummified,mudda,mozzarella,moxica,motivator,motility,mothafucka,mortmain,mortgaged,mores,mongers,mobbed,mitigating,mistah,misrepresented,mishke,misfortunes,misdirection,mischievous,mineshaft,millaney,microwaves,metzenbaum,mccovey,masterful,masochistic,marliston,marijawana,manya,mantumbi,malarkey,magnifique,madrona,madox,machida,m'hidi,lullabies,loveliness,lotions,looka,lompoc,litterbug,litigator,lithe,liquorice,linds,limericks,lightbulb,lewises,letch,lemec,layover,lavatory,laurels,lateness,laparotomy,laboring,kuato,kroff,krispy,krauts,knuckleheads,kitschy,kippers,kimbrow,keypad,keepsake,kebab,karloff,junket,judgemental,jointed,jezzie,jetting,jeeze,jeeter,jeesus,jeebs,janeane,jails,jackhammer,ixnay,irritates,irritability,irrevocable,irrefutable,irked,invoking,intricacies,interferon,intents,insubordinate,instructive,instinctive,inquisitive,inlay,injuns,inebriated,indignity,indecisive,incisors,incacha,inalienable,impresses,impregnate,impregnable,implosion,idolizes,hypothyroidism,hypoglycemic,huseni,humvee,huddling,honing,hobnobbing,hobnob,histrionics,histamine,hirohito,hippocratic,hindquarters,hikita,hikes,hightailed,hieroglyphics,heretofore,herbalist,hehey,hedriks,heartstrings,headmistress,headlight,hardheaded,happend,handlebars,hagitha,habla,gyroscope,guys'd,guy'd,guttersnipe,grump,growed,grovelling,groan,greenbacks,gravedigger,grating,grasshoppers,grandiose,grandest,grafted,gooood,goood,gooks,godsakes,goaded,glamorama,giveth,gingham,ghostbusters,germane,georgy,gazzo,gazelles,gargle,garbled,galgenstein,gaffe,g'day,fyarl,furnish,furies,fulfills,frowns,frowned,frighteningly,freebies,freakishly,forewarned,foreclose,forearms,fordson,fonics,flushes,flitting,flemmer,flabby,fishbowl,fidgeting,fevers,feigning,faxing,fatigued,fathoms,fatherless,fancier,fanatical,factored,eyelid,eyeglasses,expresso,expletive,expectin,excruciatingly,evidentiary,ever'thing,eurotrash,eubie,estrangement,erlich,epitome,entrap,enclose,emphysema,embers,emasculating,eighths,eardrum,dyslexia,duplicitous,dumpty,dumbledore,dufus,duddy,duchamp,drunkenness,drumlin,drowns,droid,drinky,drifts,drawbridge,dramamine,douggie,douchebag,dostoyevsky,doodling,don'tcha,domineering,doings,dogcatcher,doctoring,ditzy,dissimilar,dissecting,disparage,disliking,disintegrating,dishwalla,dishonored,dishing,disengaged,disavowed,dippy,diorama,dimmed,dilate,digitalis,diggory,dicing,diagnosing,devola,desolation,dennings,denials,deliverance,deliciously,delicacies,degenerates,degas,deflector,defile,deference,decrepit,deciphered,dawdle,dauphine,daresay,dangles,dampen,damndest,cucumbers,cucaracha,cryogenically,croaks,croaked,criticise,crisper,creepiest,creams,crackle,crackin,covertly,counterintelligence,corrosive,cordially,cops'll,convulsions,convoluted,conversing,conga,confrontational,confab,condolence,condiments,complicit,compiegne,commodus,comings,cometh,collusion,collared,cockeyed,clobber,clemonds,clarithromycin,cienega,christmasy,christmassy,chloroform,chippie,chested,cheeco,checklist,chauvinist,chandlers,chambermaid,chakras,cellophane,caveat,cataloguing,cartmanland,carples,carny,carded,caramels,cappy,caped,canvassing,callback,calibrated,calamine,buttermilk,butterfingers,bunsen,bulimia,bukatari,buildin,budged,brobich,bringer,brendell,brawling,bratty,braised,boyish,boundless,botch,boosh,bookies,bonbons,bodes,bobunk,bluntly,blossoming,bloomers,bloodstains,bloodhounds,blech,biter,biometric,bioethics,bijan,bigoted,bicep,bereaved,bellowing,belching,beholden,beached,batmobile,barcodes,barch,barbecuing,bandanna,backwater,backtrack,backdraft,augustino,atrophy,atrocity,atley,atchoo,asthmatic,assoc,armchair,arachnids,aptly,appetizing,antisocial,antagonizing,anorexia,anini,andersons,anagram,amputation,alleluia,airlock,aimless,agonized,agitate,aggravating,aerosol,acing,accomplishing,accidently,abuser,abstain,abnormally,aberration,aaaaahh,zlotys,zesty,zerzura,zapruder,zantopia,yelburton,yeess,y'knowwhati'msayin,wwhat,wussies,wrenched,would'a,worryin,wormser,wooooo,wookiee,wolchek,wishin,wiseguys,windbreaker,wiggy,wieners,wiedersehen,whoopin,whittled,wherefore,wharvey,welts,wellstone,wedges,wavered,watchit,wastebasket,wango,waken,waitressed,wacquiem,vrykolaka,voula,vitally,visualizing,viciousness,vespers,vertes,verily,vegetarians,vater,vaporize,vannacutt,vallens,ussher,urinating,upping,unwitting,untangle,untamed,unsanitary,unraveled,unopened,unisex,uninvolved,uninteresting,unintelligible,unimaginative,undeserving,undermines,undergarments,unconcerned,tyrants,typist,tykes,tybalt,twosome,twits,tutti,turndown,tularemia,tuberculoma,tsimshian,truffaut,truer,truant,trove,triumphed,tripe,trigonometry,trifled,trifecta,tribulations,tremont,tremoille,transcends,trafficker,touchin,tomfoolery,tinkered,tinfoil,tightrope,thousan,thoracotomy,thesaurus,thawing,thatta,tessio,temps,taxidermist,tator,tachycardia,t'akaya,swelco,sweetbreads,swatting,supercollider,sunbathing,summarily,suffocation,sueleen,succinct,subsided,submissive,subjecting,subbing,subatomic,stupendous,stunted,stubble,stubbed,streetwalker,strategizing,straining,straightaway,stoli,stiffer,stickup,stens,steamroller,steadwell,steadfast,stateroom,stans,sshhhh,squishing,squinting,squealed,sprouting,sprimp,spreadsheets,sprawled,spotlights,spooning,spirals,speedboat,spectacles,speakerphone,southglen,souse,soundproof,soothsayer,sommes,somethings,solidify,soars,snorted,snorkeling,snitches,sniping,snifter,sniffin,snickering,sneer,snarl,smila,slinking,slanted,slanderous,slammin,skimp,skilosh,siteid,sirloin,singe,sighing,sidekicks,sicken,showstopper,shoplifter,shimokawa,sherborne,shavadai,sharpshooters,sharking,shagged,shaddup,senorita,sesterces,sensuous,seahaven,scullery,scorcher,schotzie,schnoz,schmooze,schlep,schizo,scents,scalping,scalped,scallop,scalding,sayeth,saybrooke,sawed,savoring,sardine,sandstorm,sandalwood,salutations,sagman,s'okay,rsvp'd,rousted,rootin,romper,romanovs,rollercoaster,rolfie,robinsons,ritzy,ritualistic,ringwald,rhymed,rheingold,rewrites,revoking,reverts,retrofit,retort,retinas,respirations,reprobate,replaying,repaint,renquist,renege,relapsing,rekindled,rejuvenating,rejuvenated,reinstating,recriminations,rechecked,reassemble,rears,reamed,reacquaint,rayanne,ravish,rathole,raspail,rarest,rapists,rants,racketeer,quittin,quitters,quintessential,queremos,quellek,quelle,quasimodo,pyromaniac,puttanesca,puritanical,purer,puree,pungent,pummel,puedo,psychotherapist,prosecutorial,prosciutto,propositioning,procrastination,probationary,primping,preventative,prevails,preservatives,preachy,praetorians,practicality,powders,potus,postop,positives,poser,portolano,portokalos,poolside,poltergeists,pocketed,poach,plummeted,plucking,plimpton,playthings,plastique,plainclothes,pinpointed,pinkus,pinks,pigskin,piffle,pictionary,piccata,photocopy,phobias,perignon,perfumes,pecks,pecked,patently,passable,parasailing,paramus,papier,paintbrush,pacer,paaiint,overtures,overthink,overstayed,overrule,overestimate,overcooked,outlandish,outgrew,outdoorsy,outdo,orchestrate,oppress,opposable,oooohh,oomupwah,okeydokey,okaaay,ohashi,of'em,obscenities,oakie,o'gar,nurection,nostradamus,norther,norcom,nooch,nonsensical,nipped,nimbala,nervously,neckline,nebbleman,narwhal,nametag,n'n't,mycenae,muzak,muumuu,mumbled,mulvehill,muggings,muffet,mouthy,motivates,motaba,moocher,mongi,moley,moisturize,mohair,mocky,mmkay,mistuh,missis,misdeeds,mincemeat,miggs,miffed,methadone,messieur,menopausal,menagerie,mcgillicuddy,mayflowers,matrimonial,matick,masai,marzipan,maplewood,manzelle,mannequins,manhole,manhandle,malfunctions,madwoman,machiavelli,lynley,lynched,lurconis,lujack,lubricant,looove,loons,loofah,lonelyhearts,lollipops,lineswoman,lifers,lexter,lepner,lemony,leggy,leafy,leadeth,lazerus,lazare,lawford,languishing,lagoda,ladman,kundera,krinkle,krendler,kreigel,kowolski,knockdown,knifed,kneed,kneecap,kids'll,kennie,kenmore,keeled,kazootie,katzenmoyer,kasdan,karak,kapowski,kakistos,julyan,jockstrap,jobless,jiggly,jaunt,jarring,jabbering,irrigate,irrevocably,irrationally,ironies,invitro,intimated,intently,intentioned,intelligently,instill,instigator,instep,inopportune,innuendoes,inflate,infects,infamy,indiscretions,indiscreet,indio,indignities,indict,indecision,inconspicuous,inappropriately,impunity,impudent,impotence,implicates,implausible,imperfection,impatience,immutable,immobilize,idealist,iambic,hysterically,hyperspace,hygienist,hydraulics,hydrated,huzzah,husks,hunched,huffed,hubris,hubbub,hovercraft,houngan,hosed,horoscopes,hopelessness,hoodwinked,honorably,honeysuckle,homegirl,holiest,hippity,hildie,hieroglyphs,hexton,herein,heckle,heaping,healthilizer,headfirst,hatsue,harlot,hardwired,halothane,hairstyles,haagen,haaaaa,gutting,gummi,groundless,groaning,gristle,grills,graynamore,grabbin,goodes,goggle,glittering,glint,gleaming,glassy,girth,gimbal,giblets,gellers,geezers,geeze,garshaw,gargantuan,garfunkel,gangway,gandarium,gamut,galoshes,gallivanting,gainfully,gachnar,fusionlips,fusilli,furiously,frugal,fricking,frederika,freckling,frauds,fountainhead,forthwith,forgo,forgettable,foresight,foresaw,fondling,fondled,fondle,folksy,fluttering,fluffing,floundering,flirtatious,flexing,flatterer,flaring,fixating,finchy,figurehead,fiendish,fertilize,ferment,fending,fellahs,feelers,fascinate,fantabulous,falsify,fallopian,faithless,fairer,fainter,failings,facetious,eyepatch,exxon,extraterrestrials,extradite,extracurriculars,extinguish,expunged,expelling,exorbitant,exhilarated,exertion,exerting,excercise,everbody,evaporated,escargot,escapee,erases,epizootics,epithelials,ephrum,entanglements,enslave,engrossed,emphatic,emeralds,ember,emancipated,elevates,ejaculate,effeminate,eccentricities,easygoing,earshot,dunks,dullness,dulli,dulled,drumstick,dropper,driftwood,dregs,dreck,dreamboat,draggin,downsizing,donowitz,dominoes,diversions,distended,dissipate,disraeli,disqualify,disowned,dishwashing,disciplining,discerning,disappoints,dinged,digested,dicking,detonating,despising,depressor,depose,deport,dents,defused,deflecting,decryption,decoys,decoupage,decompress,decibel,decadence,deafening,dawning,dater,darkened,dappy,dallying,dagon,czechoslovakians,cuticles,cuteness,cupboards,culottes,cruisin,crosshairs,cronyn,criminalistics,creatively,creaming,crapping,cranny,cowed,contradicting,constipation,confining,confidences,conceiving,conceivably,concealment,compulsively,complainin,complacent,compels,communing,commode,comming,commensurate,columnists,colonoscopy,colchicine,coddling,clump,clubbed,clowning,cliffhanger,clang,cissy,choosers,choker,chiffon,channeled,chalet,cellmates,cathartic,caseload,carjack,canvass,canisters,candlestick,candlelit,camry,calzones,calitri,caldy,byline,butterball,bustier,burlap,bureaucrat,buffoons,buenas,brookline,bronzed,broiled,broda,briss,brioche,briar,breathable,brays,brassieres,boysenberry,bowline,boooo,boonies,booklets,bookish,boogeyman,boogey,bogas,boardinghouse,bluuch,blundering,bluer,blowed,blotchy,blossomed,bloodwork,bloodied,blithering,blinks,blathering,blasphemous,blacking,birdson,bings,bfmid,bfast,bettin,berkshires,benjamins,benevolence,benched,benatar,bellybutton,belabor,behooves,beddy,beaujolais,beattle,baxworth,baseless,barfing,bannish,bankrolled,banek,ballsy,ballpoint,baffling,badder,badda,bactine,backgammon,baako,aztreonam,authoritah,auctioning,arachtoids,apropos,aprons,apprised,apprehensive,anythng,antivenin,antichrist,anorexic,anoint,anguished,angioplasty,angio,amply,ampicillin,amphetamines,alternator,alcove,alabaster,airlifted,agrabah,affidavits,admonished,admonish,addled,addendum,accuser,accompli,absurdity,absolved,abrusso,abreast,aboot,abductions,abducting,aback,ababwa,aaahhhh,zorin,zinthar,zinfandel,zillions,zephyrs,zatarcs,zacks,youuu,yokels,yardstick,yammer,y'understand,wynette,wrung,wreaths,wowed,wouldn'ta,worming,wormed,workday,woodsy,woodshed,woodchuck,wojadubakowski,withering,witching,wiseass,wiretaps,wining,willoby,wiccaning,whupped,whoopi,whoomp,wholesaler,whiteness,whiner,whatchya,wharves,wenus,weirdoes,weaning,watusi,waponi,waistband,wackos,vouching,votre,vivica,viveca,vivant,vivacious,visor,visitin,visage,vicrum,vetted,ventriloquism,venison,varnsen,vaporized,vapid,vanstock,uuuuh,ushering,urologist,urination,upstart,uprooted,unsubtitled,unspoiled,unseat,unseasonably,unseal,unsatisfying,unnerve,unlikable,unleaded,uninsured,uninspired,unicycle,unhooked,unfunny,unfreezing,unflattering,unfairness,unexpressed,unending,unencumbered,unearth,undiscovered,undisciplined,understan,undershirt,underlings,underline,undercurrent,uncivilized,uncharacteristic,umpteenth,uglies,tuney,trumps,truckasaurus,trubshaw,trouser,tringle,trifling,trickster,trespassers,trespasser,traumas,trattoria,trashes,transgressions,trampling,tp'ed,toxoplasmosis,tounge,tortillas,topsy,topple,topnotch,tonsil,tions,timmuh,timithious,tilney,tighty,tightness,tightens,tidbits,ticketed,thyme,threepio,thoughtfully,thorkel,thommo,thing'll,thefts,that've,thanksgivings,tetherball,testikov,terraforming,tepid,tendonitis,tenboom,telex,teenybopper,tattered,tattaglias,tanneke,tailspin,tablecloth,swooping,swizzle,swiping,swindled,swilling,swerving,sweatshops,swaddling,swackhammer,svetkoff,supossed,superdad,sumptuous,sugary,sugai,subvert,substantiate,submersible,sublimating,subjugation,stymied,strychnine,streetlights,strassmans,stranglehold,strangeness,straddling,straddle,stowaways,stotch,stockbrokers,stifling,stepford,steerage,steena,statuary,starlets,staggeringly,ssshhh,squaw,spurt,spungeon,spritzer,sprightly,sprays,sportswear,spoonful,splittin,splitsville,speedily,specialise,spastic,sparrin,souvlaki,southie,sourpuss,soupy,soundstage,soothes,somebody'd,softest,sociopathic,socialized,snyders,snowmobiles,snowballed,snatches,smugness,smoothest,smashes,sloshed,sleight,skyrocket,skied,skewed,sixpence,sipowicz,singling,simulates,shyness,shuvanis,showoff,shortsighted,shopkeeper,shoehorn,shithouse,shirtless,shipshape,shifu,shelve,shelbyville,sheepskin,sharpens,shaquille,shanshu,servings,sequined,seizes,seashells,scrambler,scopes,schnauzer,schmo,schizoid,scampered,savagely,saudis,santas,sandovals,sanding,saleswoman,sagging,s'cuse,rutting,ruthlessly,runneth,ruffians,rubes,rosalita,rollerblades,rohypnol,roasts,roadies,ritten,rippling,ripples,rigoletto,richardo,rethought,reshoot,reserving,reseda,rescuer,reread,requisitions,repute,reprogram,replenish,repetitious,reorganizing,reinventing,reinvented,reheat,refrigerators,reenter,recruiter,recliner,rawdy,rashes,rajeski,raison,raisers,rages,quinine,questscape,queller,pygmalion,pushers,pusan,purview,pumpin,pubescent,prudes,provolone,propriety,propped,procrastinate,processional,preyed,pretrial,portent,pooling,poofy,polloi,policia,poacher,pluses,pleasuring,platitudes,plateaued,plaguing,pittance,pinheads,pincushion,pimply,pimped,piggyback,piecing,phillipe,philipse,philby,pharaohs,petyr,petitioner,peshtigo,pesaram,persnickety,perpetrate,percolating,pepto,penne,penell,pemmican,peeks,pedaling,peacemaker,pawnshop,patting,pathologically,patchouli,pasts,pasties,passin,parlors,paltrow,palamon,padlock,paddling,oversleep,overheating,overdosed,overcharge,overblown,outrageously,ornery,opportune,oooooooooh,oohhhh,ohhhhhh,ogres,odorless,obliterated,nyong,nymphomaniac,ntozake,novocain,nough,nonnie,nonissue,nodules,nightmarish,nightline,niceties,newsman,needra,nedry,necking,navour,nauseam,nauls,narim,namath,nagged,naboo,n'sync,myslexia,mutator,mustafi,musketeer,murtaugh,murderess,munching,mumsy,muley,mouseville,mortifying,morgendorffers,moola,montel,mongoloid,molestered,moldings,mocarbies,mo'ss,mixers,misrell,misnomer,misheard,mishandled,miscreant,misconceptions,miniscule,millgate,mettle,metricconverter,meteors,menorah,mengele,melding,meanness,mcgruff,mcarnold,matzoh,matted,mastectomy,massager,marveling,marooned,marmaduke,marick,manhandled,manatees,man'll,maltin,maliciously,malfeasance,malahide,maketh,makeovers,maiming,machismo,lumpectomy,lumbering,lucci,lording,lorca,lookouts,loogie,loners,loathed,lissen,lighthearted,lifer,lickin,lewen,levitation,lestercorp,lessee,lentils,legislate,legalizing,lederhosen,lawmen,lasskopf,lardner,lambeau,lamagra,ladonn,lactic,lacquer,labatier,krabappel,kooks,knickknacks,klutzy,kleynach,klendathu,kinross,kinkaid,kind'a,ketch,kesher,karikos,karenina,kanamits,junshi,jumbled,joust,jotted,jobson,jingling,jigalong,jerries,jellies,jeeps,javna,irresistable,internist,intercranial,inseminated,inquisitor,infuriate,inflating,infidelities,incessantly,incensed,incase,incapacitate,inasmuch,inaccuracies,imploding,impeding,impediments,immaturity,illegible,iditarod,icicles,ibuprofen,i'i'm,hymie,hydrolase,hunker,humps,humons,humidor,humdinger,humbling,huggin,huffing,housecleaning,hothouse,hotcakes,hosty,hootenanny,hootchie,hoosegow,honks,honeymooners,homily,homeopathic,hitchhikers,hissed,hillnigger,hexavalent,hewwo,hershe,hermey,hergott,henny,hennigans,henhouse,hemolytic,helipad,heifer,hebrews,hebbing,heaved,headlock,harrowing,harnessed,hangovers,handi,handbasket,halfrek,hacene,gyges,guys're,gundersons,gumption,gruntmaster,grubs,grossie,groped,grins,greaseball,gravesite,gratuity,granma,grandfathers,grandbaby,gradski,gracing,gossips,gooble,goners,golitsyn,gofer,godsake,goddaughter,gnats,gluing,glares,givers,ginza,gimmie,gimmee,gennero,gemme,gazpacho,gazed,gassy,gargling,gandhiji,galvanized,gallbladder,gaaah,furtive,fumigation,fucka,fronkonsteen,frills,freezin,freewald,freeloader,frailty,forger,foolhardy,fondest,fomin,followin,follicle,flotation,flopping,floodgates,flogged,flicked,flenders,fleabag,fixings,fixable,fistful,firewater,firelight,fingerbang,finalizing,fillin,filipov,fiderer,felling,feldberg,feign,faunia,fatale,farkus,fallible,faithfulness,factoring,eyeful,extramarital,exterminated,exhume,exasperated,eviscerate,estoy,esmerelda,escapades,epoxy,enticed,enthused,entendre,engrossing,endorphins,emptive,emmys,eminently,embezzler,embarressed,embarrassingly,embalmed,eludes,eling,elated,eirie,egotitis,effecting,eerily,eecom,eczema,earthy,earlobes,eally,dyeing,dwells,duvet,duncans,dulcet,droves,droppin,drools,drey'auc,downriver,domesticity,dollop,doesnt,dobler,divulged,diversionary,distancing,dispensers,disorienting,disneyworld,dismissive,disingenuous,disheveled,disfiguring,dinning,dimming,diligently,dilettante,dilation,dickensian,diaphragms,devastatingly,destabilize,desecrate,deposing,deniece,demony,delving,delicates,deigned,defraud,deflower,defibrillator,defiantly,defenceless,defacing,deconstruction,decompose,deciphering,decibels,deceptively,deceptions,decapitation,debutantes,debonair,deadlier,dawdling,davic,darwinism,darnit,darks,danke,danieljackson,dangled,cytoxan,cutout,cutlery,curveball,curfews,cummerbund,crunches,crouched,crisps,cripples,crilly,cribs,crewman,creepin,creeds,credenza,creak,crawly,crawlin,crawlers,crated,crackheads,coworker,couldn't've,corwins,coriander,copiously,convenes,contraceptives,contingencies,contaminating,conniption,condiment,concocting,comprehending,complacency,commendatore,comebacks,com'on,collarbone,colitis,coldly,coiffure,coffers,coeds,codependent,cocksucking,cockney,cockles,clutched,closeted,cloistered,cleve,cleats,clarifying,clapped,cinnabar,chunnel,chumps,cholinesterase,choirboy,chocolatey,chlamydia,chigliak,cheesie,chauvinistic,chasm,chartreuse,charo,charnier,chapil,chalked,chadway,certifiably,cellulite,celled,cavalcade,cataloging,castrated,cassio,cashews,cartouche,carnivore,carcinogens,capulet,captivated,capt'n,cancellations,campin,callate,callar,caffeinated,cadavers,cacophony,cackle,buzzes,buttoning,busload,burglaries,burbs,buona,bunions,bullheaded,buffs,bucyk,buckling,bruschetta,browbeating,broomsticks,broody,bromly,brolin,briefings,brewskies,breathalyzer,breakups,bratwurst,brania,braiding,brags,braggin,bradywood,bottomed,bossa,bordello,bookshelf,boogida,bondsman,bolder,boggles,bludgeoned,blowtorch,blotter,blips,blemish,bleaching,blainetologists,blading,blabbermouth,birdseed,bimmel,biloxi,biggly,bianchinni,betadine,berenson,belus,belloq,begets,befitting,beepers,beelzebub,beefed,bedridden,bedevere,beckons,beaded,baubles,bauble,battleground,bathrobes,basketballs,basements,barroom,barnacle,barkin,barked,baretta,bangles,bangler,banality,bambang,baltar,ballplayers,bagman,baffles,backroom,babysat,baboons,averse,audiotape,auctioneer,atten,atcha,astonishment,arugula,arroz,antihistamines,annoyances,anesthesiology,anatomically,anachronism,amiable,amaretto,allahu,alight,aimin,ailment,afterglow,affronte,advil,adrenals,actualization,acrost,ached,accursed,accoutrements,absconded,aboveboard,abetted,aargh,aaaahh,zuwicky,zolda,ziploc,zakamatak,youve,yippie,yesterdays,yella,yearns,yearnings,yearned,yawning,yalta,yahtzee,y'mean,y'are,wuthering,wreaks,worrisome,workiiing,wooooooo,wonky,womanizing,wolodarsky,wiwith,withdraws,wishy,wisht,wipers,wiper,winos,windthorne,windsurfing,windermere,wiggled,wiggen,whwhat,whodunit,whoaaa,whittling,whitesnake,whereof,wheezing,wheeze,whatd'ya,whataya,whammo,whackin,wellll,weightless,weevil,wedgies,webbing,weasly,wayside,waxes,waturi,washy,washrooms,wandell,waitaminute,waddya,waaaah,vornac,vishnoor,virulent,vindictiveness,vinceres,villier,vigeous,vestigial,ventilate,vented,venereal,veering,veered,veddy,vaslova,valosky,vailsburg,vaginas,vagas,urethra,upstaged,uploading,unwrapping,unwieldy,untapped,unsatisfied,unquenchable,unnerved,unmentionable,unlovable,unknowns,uninformed,unimpressed,unhappily,unguarded,unexplored,undergarment,undeniably,unclench,unclaimed,uncharacteristically,unbuttoned,unblemished,ululd,uhhhm,tweeze,tutsami,tushy,tuscarora,turkle,turghan,turbinium,tubers,trucoat,troxa,tropicana,triquetra,trimmers,triceps,trespassed,traya,traumatizing,transvestites,trainors,tradin,trackers,townies,tourelles,toucha,tossin,tortious,topshop,topes,tonics,tongs,tomsk,tomorrows,toiling,toddle,tizzy,tippers,timmi,thwap,thusly,ththe,thrusts,throwers,throwed,throughway,thickening,thermonuclear,thelwall,thataway,terrifically,tendons,teleportation,telepathically,telekinetic,teetering,teaspoons,tarantulas,tapas,tanned,tangling,tamales,tailors,tahitian,tactful,tachy,tablespoon,syrah,synchronicity,synch,synapses,swooning,switchman,swimsuits,sweltering,sweetly,suvolte,suslov,surfed,supposition,suppertime,supervillains,superfluous,superego,sunspots,sunning,sunless,sundress,suckah,succotash,sublevel,subbasement,studious,striping,strenuously,straights,stonewalled,stillness,stilettos,stevesy,steno,steenwyck,stargates,stammering,staedert,squiggly,squiggle,squashing,squaring,spreadsheet,spramp,spotters,sporto,spooking,splendido,spittin,spirulina,spiky,spate,spartacus,spacerun,soonest,something'll,someth,somepin,someone'll,sofas,soberly,sobered,snowmen,snowbank,snowballing,snivelling,sniffling,snakeskin,snagging,smush,smooter,smidgen,smackers,slumlord,slossum,slimmer,slighted,sleepwalk,sleazeball,skokie,skeptic,sitarides,sistah,sipped,sindell,simpletons,simony,silkwood,silks,silken,sightless,sideboard,shuttles,shrugging,shrouds,showy,shoveled,shouldn'ta,shoplifters,shitstorm,sheeny,shapetype,shaming,shallows,shackle,shabbily,shabbas,seppuku,senility,semite,semiautomatic,selznick,secretarial,sebacio,scuzzy,scummy,scrutinized,scrunchie,scribbled,scotches,scolded,scissor,schlub,scavenging,scarin,scarfing,scallions,scald,savour,savored,saute,sarcoidosis,sandbar,saluted,salish,saith,sailboats,sagittarius,sacre,saccharine,sacamano,rushdie,rumpled,rumba,rulebook,rubbers,roughage,rotisserie,rootie,roofy,roofie,romanticize,rittle,ristorante,rippin,rinsing,ringin,rincess,rickety,reveling,retest,retaliating,restorative,reston,restaurateur,reshoots,resetting,resentments,reprogramming,repossess,repartee,renzo,remore,remitting,remeber,relaxants,rejuvenate,rejections,regenerated,refocus,referrals,reeno,recycles,recrimination,reclining,recanting,reattach,reassigning,razgul,raved,rattlesnakes,rattles,rashly,raquetball,ransack,raisinettes,raheem,radisson,radishes,raban,quoth,qumari,quints,quilts,quilting,quien,quarreled,purty,purblind,punchbowl,publically,psychotics,psychopaths,psychoanalyze,pruning,provasik,protectin,propping,proportioned,prophylactic,proofed,prompter,procreate,proclivities,prioritizing,prinze,pricked,press'll,presets,prescribes,preocupe,prejudicial,prefex,preconceived,precipice,pralines,pragmatist,powerbar,pottie,pottersville,potsie,potholes,posses,posies,portkey,porterhouse,pornographers,poring,poppycock,poppers,pomponi,pokin,poitier,podiatry,pleeze,pleadings,playbook,platelets,plane'arium,placebos,place'll,pistachios,pirated,pinochle,pineapples,pinafore,pimples,piggly,piddling,picon,pickpockets,picchu,physiologically,physic,phobic,philandering,phenomenally,pheasants,pewter,petticoat,petronis,petitioning,perturbed,perpetuating,permutat,perishable,perimeters,perfumed,percocet,per'sus,pepperjack,penalize,pelting,pellet,peignoir,pedicures,peckers,pecans,pawning,paulsson,pattycake,patrolmen,patois,pathos,pasted,parishioner,parcheesi,parachuting,papayas,pantaloons,palpitations,palantine,paintballing,overtired,overstress,oversensitive,overnights,overexcited,overanxious,overachiever,outwitted,outvoted,outnumber,outlast,outlander,out've,orphey,orchestrating,openers,ooooooo,okies,ohhhhhhhhh,ohhhhhhhh,ogling,offbeat,obsessively,obeyed,o'hana,o'bannon,o'bannion,numpce,nummy,nuked,nuances,nourishing,nosedive,norbu,nomlies,nomine,nixed,nihilist,nightshift,newmeat,neglectful,neediness,needin,naphthalene,nanocytes,nanite,naivete,n'yeah,mystifying,myhnegon,mutating,musing,mulled,muggy,muerto,muckraker,muchachos,mountainside,motherless,mosquitos,morphed,mopped,moodoo,moncho,mollem,moisturiser,mohicans,mocks,mistresses,misspent,misinterpretation,miscarry,minuses,mindee,mimes,millisecond,milked,mightn't,mightier,mierzwiak,microchips,meyerling,mesmerizing,mershaw,meecrob,medicate,meddled,mckinnons,mcgewan,mcdunnough,mcats,mbien,matzah,matriarch,masturbated,masselin,martialed,marlboros,marksmanship,marinate,marchin,manicured,malnourished,malign,majorek,magnon,magnificently,macking,machiavellian,macdougal,macchiato,macaws,macanaw,m'self,lydells,lusts,lucite,lubricants,lopper,lopped,loneliest,lonelier,lomez,lojack,loath,liquefy,lippy,limps,likin,lightness,liesl,liebchen,licious,libris,libation,lhamo,leotards,leanin,laxatives,lavished,latka,lanyard,lanky,landmines,lameness,laddies,lacerated,labored,l'amour,kreskin,kovitch,kournikova,kootchy,konoss,knknow,knickety,knackety,kmart,klicks,kiwanis,kissable,kindergartners,kilter,kidnet,kid'll,kicky,kickbacks,kickback,kholokov,kewpie,kendo,katra,kareoke,kafelnikov,kabob,junjun,jumba,julep,jordie,jondy,jolson,jenoff,jawbone,janitorial,janiro,ipecac,invigorated,intruded,intros,intravenously,interruptus,interrogations,interject,interfacing,interestin,insuring,instilled,insensitivity,inscrutable,inroads,innards,inlaid,injector,ingratitude,infuriates,infra,infliction,indelicate,incubators,incrimination,inconveniencing,inconsolable,incestuous,incas,incarcerate,inbreeding,impudence,impressionists,impeached,impassioned,imipenem,idling,idiosyncrasies,icebergs,hypotensive,hydrochloride,hushed,humus,humph,hummm,hulking,hubcaps,hubald,howya,howbout,how'll,housebroken,hotwire,hotspots,hotheaded,horrace,hopsfield,honto,honkin,honeymoons,homewrecker,hombres,hollers,hollerin,hoedown,hoboes,hobbling,hobble,hoarse,hinky,highlighters,hexes,heru'ur,hernias,heppleman,hell're,heighten,heheheheheh,heheheh,hedging,heckling,heckled,heavyset,heatshield,heathens,heartthrob,headpiece,hayseed,haveo,hauls,hasten,harridan,harpoons,hardens,harcesis,harbouring,hangouts,halkein,haleh,halberstam,hairnet,hairdressers,hacky,haaaa,h'yah,gusta,gushy,gurgling,guilted,gruel,grudging,grrrrrr,grosses,groomsmen,griping,gravest,gratified,grated,goulash,goopy,goona,goodly,godliness,godawful,godamn,glycerin,glutes,glowy,globetrotters,glimpsed,glenville,glaucoma,girlscout,giraffes,gilbey,gigglepuss,ghora,gestating,gelato,geishas,gearshift,gayness,gasped,gaslighting,garretts,garba,gablyczyck,g'head,fumigating,fumbling,fudged,fuckwad,fuck're,fuchsia,fretting,freshest,frenchies,freezers,fredrica,fraziers,fraidy,foxholes,fourty,fossilized,forsake,forfeits,foreclosed,foreal,footsies,florists,flopped,floorshow,floorboard,flinching,flecks,flaubert,flatware,flatulence,flatlined,flashdance,flail,flagging,fiver,fitzy,fishsticks,finetti,finelli,finagle,filko,fieldstone,fibber,ferrini,feedin,feasting,favore,fathering,farrouhk,farmin,fairytale,fairservice,factoid,facedown,fabled,eyeballin,extortionist,exquisitely,expedited,exorcise,existentialist,execs,exculpatory,exacerbate,everthing,eventuality,evander,euphoric,euphemisms,estamos,erred,entitle,enquiries,enormity,enfants,endive,encyclopedias,emulating,embittered,effortless,ectopic,ecirc,easely,earphones,earmarks,dweller,durslar,durned,dunois,dunking,dunked,dumdum,dullard,dudleys,druthers,druggist,drossos,drooled,driveways,drippy,dreamless,drawstring,drang,drainpipe,dozing,dotes,dorkface,doorknobs,doohickey,donnatella,doncha,domicile,dokos,dobermans,dizzying,divola,ditsy,distaste,disservice,dislodged,dislodge,disinherit,disinformation,discounting,dinka,dimly,digesting,diello,diddling,dictatorships,dictators,diagnostician,devours,devilishly,detract,detoxing,detours,detente,destructs,desecrated,derris,deplore,deplete,demure,demolitions,demean,delish,delbruck,delaford,degaulle,deftly,deformity,deflate,definatly,defector,decrypted,decontamination,decapitate,decanter,dardis,dampener,damme,daddy'll,dabbling,dabbled,d'etre,d'argent,d'alene,d'agnasti,czechoslovakian,cymbal,cyberdyne,cutoffs,cuticle,curvaceous,curiousity,crowing,crowed,croutons,cropped,criminy,crescentis,crashers,cranwell,coverin,courtrooms,countenance,cosmically,cosign,corroboration,coroners,cornflakes,copperpot,copperhead,copacetic,coordsize,convulsing,consults,conjures,congenial,concealer,compactor,commercialism,cokey,cognizant,clunkers,clumsily,clucking,cloves,cloven,cloths,clothe,clods,clocking,clings,clavicle,classless,clashing,clanking,clanging,clamping,civvies,citywide,circulatory,circuited,chronisters,chromic,choos,chloroformed,chillun,cheesed,chatterbox,chaperoned,channukah,cerebellum,centerpieces,centerfold,ceecee,ccedil,cavorting,cavemen,cauterized,cauldwell,catting,caterine,cassiopeia,carves,cartwheel,carpeted,carob,caressing,carelessly,careening,capricious,capitalistic,capillaries,candidly,camaraderie,callously,calfskin,caddies,buttholes,busywork,busses,burps,burgomeister,bunkhouse,bungchow,bugler,buffets,buffed,brutish,brusque,bronchitis,bromden,brolly,broached,brewskis,brewin,brean,breadwinner,brana,bountiful,bouncin,bosoms,borgnine,bopping,bootlegs,booing,bombosity,bolting,boilerplate,bluey,blowback,blouses,bloodsuckers,bloodstained,bloat,bleeth,blackface,blackest,blackened,blacken,blackballed,blabs,blabbering,birdbrain,bipartisanship,biodegradable,biltmore,bilked,big'uns,bidet,besotted,bernheim,benegas,bendiga,belushi,bellboys,belittling,behinds,begone,bedsheets,beckoning,beaute,beaudine,beastly,beachfront,bathes,batak,baser,baseballs,barbella,bankrolling,bandaged,baerly,backlog,backin,babying,azkaban,awwwww,aviary,authorizes,austero,aunty,attics,atreus,astounded,astonish,artemus,arses,arintero,appraiser,apathetic,anybody'd,anxieties,anticlimactic,antar,anglos,angleman,anesthetist,androscoggin,andolini,andale,amway,amuck,amniocentesis,amnesiac,americano,amara,alvah,altruism,alternapalooza,alphabetize,alpaca,allus,allergist,alexandros,alaikum,akimbo,agoraphobia,agides,aggrhh,aftertaste,adoptions,adjuster,addictions,adamantium,activator,accomplishes,aberrant,aaaaargh,aaaaaaaaaaaaa,a'ight,zzzzzzz,zucchini,zookeeper,zirconia,zippers,zequiel,zellary,zeitgeist,zanuck,zagat,you'n,ylang,yes'm,yenta,yecchh,yecch,yawns,yankin,yahdah,yaaah,y'got,xeroxed,wwooww,wristwatch,wrangled,wouldst,worthiness,worshiping,wormy,wormtail,wormholes,woosh,wollsten,wolfing,woefully,wobbling,wintry,wingding,windstorm,windowtext,wiluna,wilting,wilted,willick,willenholly,wildflowers,wildebeest,whyyy,whoppers,whoaa,whizzing,whizz,whitest,whistled,whist,whinny,wheelies,whazzup,whatwhatwhaaat,whato,whatdya,what'dya,whacks,wewell,wetsuit,welluh,weeps,waylander,wavin,wassail,wasnt,warneford,warbucks,waltons,wallbanger,waiving,waitwait,vowing,voucher,vornoff,vorhees,voldemort,vivre,vittles,vindaloo,videogames,vichyssoise,vicarious,vesuvius,verguenza,ven't,velveteen,velour,velociraptor,vastness,vasectomies,vapors,vanderhof,valmont,validates,valiantly,vacuums,usurp,usernum,us'll,urinals,unyielding,unvarnished,unturned,untouchables,untangled,unsecured,unscramble,unreturned,unremarkable,unpretentious,unnerstand,unmade,unimpeachable,unfashionable,underwrite,underlining,underling,underestimates,underappreciated,uncouth,uncork,uncommonly,unclog,uncircumcised,unchallenged,uncas,unbuttoning,unapproved,unamerican,unafraid,umpteen,umhmm,uhwhy,ughuh,typewriters,twitches,twitched,twirly,twinkling,twinges,twiddling,turners,turnabout,tumblin,tryed,trowel,trousseau,trivialize,trifles,tribianni,trenchcoat,trembled,traumatize,transitory,transients,transfuse,transcribing,tranq,trampy,traipsed,trainin,trachea,traceable,touristy,toughie,toscanini,tortola,tortilla,torreon,toreador,tommorrow,tollbooth,tollans,toidy,togas,tofurkey,toddling,toddies,toasties,toadstool,to've,tingles,timin,timey,timetables,tightest,thuggee,thrusting,thrombus,throes,thrifty,thornharts,thinnest,thicket,thetas,thesulac,tethered,testaburger,tersenadine,terrif,terdlington,tepui,temping,tector,taxidermy,tastebuds,tartlets,tartabull,tar'd,tantamount,tangy,tangles,tamer,tabula,tabletops,tabithia,szechwan,synthedyne,svenjolly,svengali,survivalists,surmise,surfboards,surefire,suprise,supremacists,suppositories,superstore,supercilious,suntac,sunburned,summercliff,sullied,sugared,suckle,subtleties,substantiated,subsides,subliminal,subhuman,strowman,stroked,stroganoff,streetlight,straying,strainer,straighter,straightener,stoplight,stirrups,stewing,stereotyping,stepmommy,stephano,stashing,starshine,stairwells,squatsie,squandering,squalid,squabbling,squab,sprinkling,spreader,spongy,spokesmen,splintered,spittle,spitter,spiced,spews,spendin,spect,spearchucker,spatulas,southtown,soused,soshi,sorter,sorrowful,sooth,some'in,soliloquy,soiree,sodomized,sobriki,soaping,snows,snowcone,snitching,snitched,sneering,snausages,snaking,smoothed,smoochies,smarten,smallish,slushy,slurring,sluman,slithers,slippin,sleuthing,sleeveless,skinless,skillfully,sketchbook,skagnetti,sista,sinning,singularly,sinewy,silverlake,siguto,signorina,sieve,sidearms,shying,shunning,shtud,shrieks,shorting,shortbread,shopkeepers,shmancy,shizzit,shitheads,shitfaced,shipmates,shiftless,shelving,shedlow,shavings,shatters,sharifa,shampoos,shallots,shafter,sha'nauc,sextant,serviceable,sepsis,senores,sendin,semis,semanski,selflessly,seinfelds,seers,seeps,seductress,secaucus,sealant,scuttling,scusa,scrunched,scissorhands,schreber,schmancy,scamps,scalloped,savoir,savagery,sarong,sarnia,santangel,samool,sallow,salino,safecracker,sadism,sacrilegious,sabrini,sabath,s'aright,ruttheimer,rudest,rubbery,rousting,rotarian,roslin,roomed,romari,romanica,rolltop,rolfski,rockettes,roared,ringleader,riffing,ribcage,rewired,retrial,reting,resuscitated,restock,resale,reprogrammed,replicant,repentant,repellant,repays,repainting,renegotiating,rendez,remem,relived,relinquishes,relearn,relaxant,rekindling,rehydrate,refueled,refreshingly,refilling,reexamine,reeseman,redness,redeemable,redcoats,rectangles,recoup,reciprocated,reassessing,realy,realer,reachin,re'kali,rawlston,ravages,rappaports,ramoray,ramming,raindrops,rahesh,radials,racists,rabartu,quiches,quench,quarreling,quaintly,quadrants,putumayo,put'em,purifier,pureed,punitis,pullout,pukin,pudgy,puddings,puckering,pterodactyl,psychodrama,psats,protestations,protectee,prosaic,propositioned,proclivity,probed,printouts,prevision,pressers,preset,preposition,preempt,preemie,preconceptions,prancan,powerpuff,potties,potpie,poseur,porthole,poops,pooping,pomade,polyps,polymerized,politeness,polisher,polack,pocketknife,poatia,plebeian,playgroup,platonically,platitude,plastering,plasmapheresis,plaids,placemats,pizzazz,pintauro,pinstripes,pinpoints,pinkner,pincer,pimento,pileup,pilates,pigmen,pieeee,phrased,photocopies,phoebes,philistines,philanderer,pheromone,phasers,pfeffernuesse,pervs,perspire,personify,perservere,perplexed,perpetrating,perkiness,perjurer,periodontist,perfunctory,perdido,percodan,pentameter,pentacle,pensive,pensione,pennybaker,pennbrooke,penhall,pengin,penetti,penetrates,pegnoir,peeve,peephole,pectorals,peckin,peaky,peaksville,paxcow,paused,patted,parkishoff,parkers,pardoning,paraplegic,paraphrasing,paperers,papered,pangs,paneling,palooza,palmed,palmdale,palatable,pacify,pacified,owwwww,oversexed,overrides,overpaying,overdrawn,overcompensate,overcomes,overcharged,outmaneuver,outfoxed,oughtn't,ostentatious,oshun,orthopedist,or'derves,ophthalmologist,operagirl,oozes,oooooooh,onesie,omnis,omelets,oktoberfest,okeydoke,ofthe,ofher,obstetrical,obeys,obeah,o'henry,nyquil,nyanyanyanyah,nuttin,nutsy,nutball,nurhachi,numbskull,nullifies,nullification,nucking,nubbin,nourished,nonspecific,noing,noinch,nohoho,nobler,nitwits,newsprint,newspaperman,newscaster,neuropathy,netherworld,neediest,navasky,narcissists,napped,nafta,mache,mykonos,mutilating,mutherfucker,mutha,mutates,mutate,musn't,murchy,multitasking,mujeeb,mudslinging,muckraking,mousetrap,mourns,mournful,motherf,mostro,morphing,morphate,moralistic,moochy,mooching,monotonous,monopolize,monocle,molehill,moland,mofet,mockup,mobilizing,mmmmmmm,mitzvahs,mistreating,misstep,misjudge,misinformation,misdirected,miscarriages,miniskirt,mindwarped,minced,milquetoast,miguelito,mightily,midstream,midriff,mideast,microbe,methuselah,mesdames,mescal,men'll,memma,megaton,megara,megalomaniac,meeee,medulla,medivac,meaninglessness,mcnuggets,mccarthyism,maypole,may've,mauve,mateys,marshack,markles,marketable,mansiere,manservant,manse,manhandling,mallomars,malcontent,malaise,majesties,mainsail,mailmen,mahandra,magnolias,magnified,magev,maelstrom,machu,macado,m'boy,m'appelle,lustrous,lureen,lunges,lumped,lumberyard,lulled,luego,lucks,lubricated,loveseat,loused,lounger,loski,lorre,loora,looong,loonies,loincloth,lofts,lodgers,lobbing,loaner,livered,liqueur,ligourin,lifesaving,lifeguards,lifeblood,liaisons,let'em,lesbianism,lence,lemonlyman,legitimize,leadin,lazars,lazarro,lawyering,laugher,laudanum,latrines,lations,laters,lapels,lakefront,lahit,lafortunata,lachrymose,l'italien,kwaini,kruczynski,kramerica,kowtow,kovinsky,korsekov,kopek,knowakowski,knievel,knacks,kiowas,killington,kickball,keyworth,keymaster,kevie,keveral,kenyons,keggers,keepsakes,kechner,keaty,kavorka,karajan,kamerev,kaggs,jujyfruit,jostled,jonestown,jokey,joists,jocko,jimmied,jiggled,jests,jenzen,jenko,jellyman,jedediah,jealitosis,jaunty,jarmel,jankle,jagoff,jagielski,jackrabbits,jabbing,jabberjaw,izzat,irresponsibly,irrepressible,irregularity,irredeemable,inuvik,intuitions,intubated,intimates,interminable,interloper,intercostal,instyle,instigate,instantaneously,ining,ingrown,ingesting,infusing,infringe,infinitum,infact,inequities,indubitably,indisputable,indescribably,indentation,indefinable,incontrovertible,inconsequential,incompletes,incoherently,inclement,incidentals,inarticulate,inadequacies,imprudent,improprieties,imprison,imprinted,impressively,impostors,importante,imperious,impale,immodest,immobile,imbedded,imbecilic,illegals,idn't,hysteric,hypotenuse,hygienic,hyeah,hushpuppies,hunhh,humpback,humored,hummed,humiliates,humidifier,huggy,huggers,huckster,hotbed,hosing,hosers,horsehair,homebody,homebake,holing,holies,hoisting,hogwallop,hocks,hobbits,hoaxes,hmmmmm,hisses,hippest,hillbillies,hilarity,heurh,herniated,hermaphrodite,hennifer,hemlines,hemline,hemery,helplessness,helmsley,hellhound,heheheheh,heeey,hedda,heartbeats,heaped,healers,headstart,headsets,headlong,hawkland,havta,haulin,harvey'll,hanta,hansom,hangnail,handstand,handrail,handoff,hallucinogen,hallor,halitosis,haberdashery,gypped,guy'll,gumbel,guerillas,guava,guardrail,grunther,grunick,groppi,groomer,grodin,gripes,grinds,grifters,gretch,greevey,greasing,graveyards,grandkid,grainy,gouging,gooney,googly,goldmuff,goldenrod,goingo,godly,gobbledygook,gobbledegook,glues,gloriously,glengarry,glassware,glamor,gimmicks,giggly,giambetti,ghoulish,ghettos,ghali,gether,geriatrics,gerbils,geosynchronous,georgio,gente,gendarme,gelbman,gazillionth,gayest,gauging,gastro,gaslight,gasbag,garters,garish,garas,gantu,gangy,gangly,gangland,galling,gadda,furrowed,funnies,funkytown,fugimotto,fudging,fuckeen,frustrates,froufrou,froot,fromberge,frizzies,fritters,frightfully,friendliest,freeloading,freelancing,freakazoid,fraternization,framers,fornication,fornicating,forethought,footstool,foisting,focussing,focking,flurries,fluffed,flintstones,fledermaus,flayed,flawlessly,flatters,flashbang,flapped,fishies,firmer,fireproof,firebug,fingerpainting,finessed,findin,financials,finality,fillets,fiercest,fiefdom,fibbing,fervor,fentanyl,fenelon,fedorchuk,feckless,feathering,faucets,farewells,fantasyland,fanaticism,faltered,faggy,faberge,extorting,extorted,exterminating,exhumation,exhilaration,exhausts,exfoliate,excels,exasperating,exacting,everybody'd,evasions,espressos,esmail,errrr,erratically,eroding,ernswiler,epcot,enthralled,ensenada,enriching,enrage,enhancer,endear,encrusted,encino,empathic,embezzle,emanates,electricians,eking,egomaniacal,egging,effacing,ectoplasm,eavesdropped,dummkopf,dugray,duchaisne,drunkard,drudge,droop,droids,drips,dripped,dribbles,drazens,downy,downsize,downpour,dosages,doppelganger,dopes,doohicky,dontcha,doneghy,divining,divest,diuretics,diuretic,distrustful,disrupts,dismemberment,dismember,disinfect,disillusionment,disheartening,discourteous,discotheque,discolored,dirtiest,diphtheria,dinks,dimpled,didya,dickwad,diatribes,diathesis,diabetics,deviants,detonates,detests,detestable,detaining,despondent,desecration,derision,derailing,deputized,depressors,dependant,dentures,denominators,demur,demonology,delts,dellarte,delacour,deflated,defib,defaced,decorators,deaqon,davola,datin,darwinian,darklighters,dandelions,dampened,damaskinos,dalrimple,d'peshu,d'hoffryn,d'astier,cynics,cutesy,cutaway,curmudgeon,curdle,culpability,cuisinart,cuffing,crypts,cryptid,crunched,crumblers,crudely,crosscheck,croon,crissake,crevasse,creswood,creepo,creases,creased,creaky,cranks,crabgrass,coveralls,couple'a,coughs,coslaw,corporeal,cornucopia,cornering,corks,cordoned,coolly,coolin,cookbooks,contrite,contented,constrictor,confound,confit,confiscating,condoned,conditioners,concussions,comprendo,comers,combustible,combusted,collingswood,coldness,coitus,codicil,coasting,clydesdale,cluttering,clunker,clunk,clumsiness,clotted,clothesline,clinches,clincher,cleverness,clench,clein,cleanses,claymores,clammed,chugging,chronically,christsakes,choque,chompers,chiseling,chirpy,chirp,chinks,chingachgook,chickenpox,chickadee,chewin,chessboard,chargin,chanteuse,chandeliers,chamdo,chagrined,chaff,certs,certainties,cerreno,cerebrum,censured,cemetary,caterwauling,cataclysmic,casitas,cased,carvel,carting,carrear,carolling,carolers,carnie,cardiogram,carbuncle,capulets,canines,candaules,canape,caldecott,calamitous,cadillacs,cachet,cabeza,cabdriver,buzzards,butai,businesswomen,bungled,bumpkins,bummers,bulldoze,buffybot,bubut,bubbies,brrrrr,brownout,brouhaha,bronzing,bronchial,broiler,briskly,briefcases,bricked,breezing,breeher,breakable,breadstick,bravenet,braved,brandies,brainwaves,brainiest,braggart,bradlee,boys're,boys'll,boys'd,boutonniere,bossed,bosomy,borans,boosts,bookshelves,bookends,boneless,bombarding,bollo,boinked,boink,bluest,bluebells,bloodshot,blockhead,blockbusters,blithely,blather,blankly,bladders,blackbeard,bitte,bippy,biogenetics,bilge,bigglesworth,bicuspids,beususe,betaseron,besmirch,bernece,bereavement,bentonville,benchley,benching,bembe,bellyaching,bellhops,belie,beleaguered,behrle,beginnin,begining,beenie,beefs,beechwood,becau,beaverhausen,beakers,bazillion,baudouin,barrytown,barringtons,barneys,barbs,barbers,barbatus,bankrupted,bailiffs,backslide,baby'd,baaad,b'fore,awwwk,aways,awakes,automatics,authenticate,aught,aubyn,attired,attagirl,atrophied,asystole,astroturf,assertiveness,artichokes,arquillians,aright,archenemy,appraise,appeased,antin,anspaugh,anesthetics,anaphylactic,amscray,ambivalence,amalio,alriiight,alphabetized,alpena,alouette,allora,alliteration,allenwood,allegiances,algerians,alcerro,alastor,ahaha,agitators,aforethought,advertises,admonition,adirondacks,adenoids,acupuncturist,acula,actuarial,activators,actionable,achingly,accusers,acclimated,acclimate,absurdly,absorbent,absolvo,absolutes,absences,abdomenizer,aaaaaaaaah,aaaaaaaaaa,a'right".split(","),
  male_names: "james,john,robert,michael,william,david,richard,charles,joseph,thomas,christopher,daniel,paul,mark,donald,george,kenneth,steven,edward,brian,ronald,anthony,kevin,jason,matthew,gary,timothy,jose,larry,jeffrey,frank,scott,eric,stephen,andrew,raymond,gregory,joshua,jerry,dennis,walter,patrick,peter,harold,douglas,henry,carl,arthur,ryan,roger,joe,juan,jack,albert,jonathan,justin,terry,gerald,keith,samuel,willie,ralph,lawrence,nicholas,roy,benjamin,bruce,brandon,adam,harry,fred,wayne,billy,steve,louis,jeremy,aaron,randy,eugene,carlos,russell,bobby,victor,ernest,phillip,todd,jesse,craig,alan,shawn,clarence,sean,philip,chris,johnny,earl,jimmy,antonio,danny,bryan,tony,luis,mike,stanley,leonard,nathan,dale,manuel,rodney,curtis,norman,marvin,vincent,glenn,jeffery,travis,jeff,chad,jacob,melvin,alfred,kyle,francis,bradley,jesus,herbert,frederick,ray,joel,edwin,don,eddie,ricky,troy,randall,barry,bernard,mario,leroy,francisco,marcus,micheal,theodore,clifford,miguel,oscar,jay,jim,tom,calvin,alex,jon,ronnie,bill,lloyd,tommy,leon,derek,darrell,jerome,floyd,leo,alvin,tim,wesley,dean,greg,jorge,dustin,pedro,derrick,dan,zachary,corey,herman,maurice,vernon,roberto,clyde,glen,hector,shane,ricardo,sam,rick,lester,brent,ramon,tyler,gilbert,gene,marc,reginald,ruben,brett,nathaniel,rafael,edgar,milton,raul,ben,cecil,duane,andre,elmer,brad,gabriel,ron,roland,jared,adrian,karl,cory,claude,erik,darryl,neil,christian,javier,fernando,clinton,ted,mathew,tyrone,darren,lonnie,lance,cody,julio,kurt,allan,clayton,hugh,max,dwayne,dwight,armando,felix,jimmie,everett,ian,ken,bob,jaime,casey,alfredo,alberto,dave,ivan,johnnie,sidney,byron,julian,isaac,clifton,willard,daryl,virgil,andy,salvador,kirk,sergio,seth,kent,terrance,rene,eduardo,terrence,enrique,freddie,stuart,fredrick,arturo,alejandro,joey,nick,luther,wendell,jeremiah,evan,julius,donnie,otis,trevor,luke,homer,gerard,doug,kenny,hubert,angelo,shaun,lyle,matt,alfonso,orlando,rex,carlton,ernesto,pablo,lorenzo,omar,wilbur,blake,horace,roderick,kerry,abraham,rickey,ira,andres,cesar,johnathan,malcolm,rudolph,damon,kelvin,rudy,preston,alton,archie,marco,pete,randolph,garry,geoffrey,jonathon,felipe,bennie,gerardo,dominic,loren,delbert,colin,guillermo,earnest,benny,noel,rodolfo,myron,edmund,salvatore,cedric,lowell,gregg,sherman,devin,sylvester,roosevelt,israel,jermaine,forrest,wilbert,leland,simon,irving,owen,rufus,woodrow,sammy,kristopher,levi,marcos,gustavo,jake,lionel,marty,gilberto,clint,nicolas,laurence,ismael,orville,drew,ervin,dewey,wilfred,josh,hugo,ignacio,caleb,tomas,sheldon,erick,frankie,darrel,rogelio,terence,alonzo,elias,bert,elbert,ramiro,conrad,noah,grady,phil,cornelius,lamar,rolando,clay,percy,bradford,merle,darin,amos,terrell,moses,irvin,saul,roman,darnell,randal,tommie,timmy,darrin,brendan,toby,van,abel,dominick,emilio,elijah,cary,domingo,aubrey,emmett,marlon,emanuel,jerald,edmond,emil,dewayne,otto,teddy,reynaldo,bret,jess,trent,humberto,emmanuel,stephan,louie,vicente,lamont,garland,micah,efrain,heath,rodger,demetrius,ethan,eldon,rocky,pierre,eli,bryce,antoine,robbie,kendall,royce,sterling,grover,elton,cleveland,dylan,chuck,damian,reuben,stan,leonardo,russel,erwin,benito,hans,monte,blaine,ernie,curt,quentin,agustin,jamal,devon,adolfo,tyson,wilfredo,bart,jarrod,vance,denis,damien,joaquin,harlan,desmond,elliot,darwin,gregorio,kermit,roscoe,esteban,anton,solomon,norbert,elvin,nolan,carey,rod,quinton,hal,brain,rob,elwood,kendrick,darius,moises,marlin,fidel,thaddeus,cliff,marcel,ali,raphael,bryon,armand,alvaro,jeffry,dane,joesph,thurman,ned,sammie,rusty,michel,monty,rory,fabian,reggie,kris,isaiah,gus,avery,loyd,diego,adolph,millard,rocco,gonzalo,derick,rodrigo,gerry,rigoberto,alphonso,rickie,noe,vern,elvis,bernardo,mauricio,hiram,donovan,basil,nickolas,scot,vince,quincy,eddy,sebastian,federico,ulysses,heriberto,donnell,denny,gavin,emery,romeo,jayson,dion,dante,clement,coy,odell,jarvis,bruno,issac,dudley,sanford,colby,carmelo,nestor,hollis,stefan,donny,linwood,beau,weldon,galen,isidro,truman,delmar,johnathon,silas,frederic,irwin,merrill,charley,marcelino,carlo,trenton,kurtis,aurelio,winfred,vito,collin,denver,leonel,emory,pasquale,mohammad,mariano,danial,landon,dirk,branden,adan,numbers,clair,buford,bernie,wilmer,emerson,zachery,jacques,errol,josue,edwardo,wilford,theron,raymundo,daren,tristan,robby,lincoln,jame,genaro,octavio,cornell,hung,arron,antony,herschel,alva,giovanni,garth,cyrus,cyril,ronny,stevie,lon,kennith,carmine,augustine,erich,chadwick,wilburn,russ,myles,jonas,mitchel,mervin,zane,jamel,lazaro,alphonse,randell,johnie,jarrett,ariel,abdul,dusty,luciano,seymour,scottie,eugenio,mohammed,arnulfo,lucien,ferdinand,thad,ezra,aldo,rubin,mitch,earle,abe,marquis,lanny,kareem,jamar,boris,isiah,emile,elmo,aron,leopoldo,everette,josef,eloy,dorian,rodrick,reinaldo,lucio,jerrod,weston,hershel,lemuel,lavern,burt,jules,gil,eliseo,ahmad,nigel,efren,antwan,alden,margarito,refugio,dino,osvaldo,les,deandre,normand,kieth,ivory,trey,norberto,napoleon,jerold,fritz,rosendo,milford,sang,deon,christoper,alfonzo,lyman,josiah,brant,wilton,rico,jamaal,dewitt,brenton,yong,olin,faustino,claudio,judson,gino,edgardo,alec,jarred,donn,trinidad,tad,porfirio,odis,lenard,chauncey,tod,mel,marcelo,kory,augustus,keven,hilario,bud,sal,orval,mauro,dannie,zachariah,olen,anibal,milo,jed,thanh,amado,lenny,tory,richie,horacio,brice,mohamed,delmer,dario,mac,jonah,jerrold,robt,hank,sung,rupert,rolland,kenton,damion,chi,antone,waldo,fredric,bradly,kip,burl,tyree,jefferey,ahmed,willy,stanford,oren,moshe,mikel,enoch,brendon,quintin,jamison,florencio,darrick,tobias,minh,hassan,giuseppe,demarcus,cletus,tyrell,lyndon,keenan,werner,theo,geraldo,columbus,chet,bertram,markus,huey,hilton,dwain,donte,tyron,omer,isaias,hipolito,fermin,chung,adalberto,jamey,teodoro,mckinley,maximo,raleigh,lawerence,abram,rashad,emmitt,daron,chong,samual,otha,miquel,eusebio,dong,domenic,darron,wilber,renato,hoyt,haywood,ezekiel,chas,florentino,elroy,clemente,arden,neville,edison,deshawn,carrol,shayne,nathanial,jordon,danilo,claud,sherwood,raymon,rayford,cristobal,ambrose,titus,hyman,felton,ezequiel,erasmo,lonny,milan,lino,jarod,herb,andreas,rhett,jude,douglass,cordell,oswaldo,ellsworth,virgilio,toney,nathanael,benedict,mose,hong,isreal,garret,fausto,arlen,zack,modesto,francesco,manual,gaylord,gaston,filiberto,deangelo,michale,granville,malik,zackary,tuan,nicky,cristopher,antione,malcom,korey,jospeh,colton,waylon,hosea,shad,santo,rudolf,rolf,renaldo,marcellus,lucius,kristofer,harland,arnoldo,rueben,leandro,kraig,jerrell,jeromy,hobert,cedrick,arlie,winford,wally,luigi,keneth,jacinto,graig,franklyn,edmundo,leif,jeramy,willian,vincenzo,shon,michal,lynwood,jere,elden,darell,broderick,alonso".split(",")
};

module.exports = frequency_lists;

//# sourceMappingURL=frequency_lists.js.map


/***/ }),

/***/ "4nGL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* @ngdoc controllers
* @name controllers.LoginJWT
*
* @description
* 1. Handles login with JWT token
*
* @param {any} $stateParams $stateParams
* @param {any} Auth service used to login the user
*/
angular.module('controllers').controller('LoginJWT', ['$stateParams', '$rootScope', '$location', 'Auth', 'JWT', 'Sso', 'ErrorHandler', function ($stateParams, $rootScope, $location, Auth, JWT, Sso, ErrorHandler) {

    var hash = $location.hash();

    // stores all URL params
    $rootScope.loginJWTUrlParams = $stateParams.options;
    $rootScope.currentUrl = $location.url();

    if (hash) {

        $rootScope.urlHash = hash;
    }

    Auth.loginSource = 'Token';
    Auth.loginType = 'Token';

    var token = $stateParams.token;

    var tokenPayload = JWT.getTokenPayload(token);

    // if the JWT token received is not for the dashboard we need to get one for the dashboard
    // this happens after a user purchase and comes with a token from MYA
    if (!tokenPayload.cid || tokenPayload.cid !== 'dashboard') {

        // setting the token on a cookie so that it can be read from by the baseRestService
        var data = {
            data: {
                access_token: token
            }
        };

        Auth.setLoginCookies(data);
        Sso.getClientToken('dashboard').then(function (response) {

            token = response.data.access_token;

            Auth.loginWithToken(token);
        }).catch(function (exception) {

            var errorLocation = 'loginJwt.Sso.getClientToken Error';

            ErrorHandler.handleError(exception, errorLocation);
        });
    } else {

        Auth.loginWithToken(token);
    }
}]);

/***/ }),

/***/ "4qO9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name controllers.Register
 * @description
 * Register controller for anonymous user.
 */

angular.module('controllers').controller('RegisterModal', ['$rootScope', '$scope', '$stateParams', 'Auth', function ($rootScope, $scope, $stateParams, Auth) {

    if ($stateParams.service) {

        $scope.service = $stateParams.service;
    }
    $scope.next = $stateParams.next;
    if ($scope.next && $scope.next.indexOf('deploy') >= 0 && !$scope.service) {

        $scope.deploy = true;
    }

    $scope.loginHandler = _RFC4.default.subscribe('auth:login', function (userData) {

        var User = {};

        Auth.clearSession();
        Auth.removeLoginCookies();
        Auth.setLoginCookies(userData);
        Auth.request = true;

        User.id = userData.u;
        User.deferred.resolve(userData);
        $rootScope.State.deviceId = null;
        if (userData.newdid) {

            $rootScope.State.deviceId = userData.newdid;
        }
    });

    // Unbind the login handler when the scope is destroyed
    $scope.$on('$destroy', function () {

        $scope.loginHandler();
    });

    // if user closes the popup by clicking outside
    // store input values in cookies
    $scope.$on('inputData', function (event, inputData) {

        var currentModal = $stateParams.ltb;

        $scope.saveData = function () {

            if (currentModal === 'register' && !_RFC2.default.get('used_anonForm_reg')) {

                _RFC2.default.set('user_fullname', inputData.fullName, { path: '/' });
                _RFC2.default.set('user_email', inputData.email, { path: '/' });
                _RFC2.default.set('saved_reg', true, { path: '/' });
            } else if (currentModal === 'login' && !_RFC2.default.get('used_anonForm_login')) {

                _RFC2.default.set('user_email', inputData.email, { path: '/' });
                _RFC2.default.set('saved_login', true, { path: '/' });
            }
        };

        // add data from cookies to input fields
        if (_RFC2.default.get('saved_reg') && currentModal === 'register') {

            inputData.fullName = _RFC2.default.get('user_fullname');
            inputData.email = _RFC2.default.get('user_email');
            _RFC2.default.set('used_anonForm_reg', true, { path: '/' });
        } else if (_RFC2.default.get('saved_login') && currentModal === 'login') {

            inputData.email = _RFC2.default.get('user_email');
            _RFC2.default.set('used_anonForm_login', true, { path: '/' });
        }

        _RFC2.default.remove('user_fullname', { path: '/' });
        _RFC2.default.remove('user_email', { path: '/' });
        _RFC2.default.remove('saved_reg', { path: '/' });
        _RFC2.default.remove('saved_login', { path: '/' });
    });
}]);

/***/ }),

/***/ "4sKI":
/***/ (function(module, exports) {

module.exports = "<div ng-mouseenter=\"enableTrialModal = true\">\n\n    <div class=\"store\">\n\n        <div ng-if=\"ShowPrimePage\">\n            <prime-page></prime-page>\n        </div>\n\n        <!-- <div ng-if=\"ShowOODiskImagePage\">\n            <oo-diskimage-page></oo-diskimage-page>\n        </div> -->\n    </div>\n\n    <store-comparison ng-if=\"showComparison\"></store-comparison>\n\n</div>"

/***/ }),

/***/ "52y7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util', 'DeviceRestService', 'UserRestService'];

/**
 * @ngdoc service
 * @name rest.services.DeploymentUrlsRestService
 *
 * @description
 * This class contains methods used to retrieve information about deployment-urls
 * using http requests.
*/

var DeploymentUrlsRestService = function (_BaseRestService) {
    _inherits(DeploymentUrlsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     * @param  {any} DeviceRestService
     * @param  {any} UserRestService
     */
    function DeploymentUrlsRestService($http, $q, Util, DeviceRestService, UserRestService) {
        _classCallCheck(this, DeploymentUrlsRestService);

        return _possibleConstructorReturn(this, (DeploymentUrlsRestService.__proto__ || Object.getPrototypeOf(DeploymentUrlsRestService)).call(this, $http, $q, Util, DeviceRestService, UserRestService, _index.UsersRepository, _index.DevicesRepository));
    }

    /**
     * @ngdoc function
     * @name rest.services.DeploymentUrlsRestService#deploy
     * @methodOf rest.services.DeploymentUrlsRestService
     * @function
     *
     * @description
     * Makes the call to the deployment-urls endpoint to retreave download url or send email and sms
     *
     * @param {object} deploymentPayload deployment payload
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(DeploymentUrlsRestService, [{
        key: 'deploy',
        value: function deploy(data) {
            var _this2 = this;

            var appId = data.appId,
                os = data.os;

            // Check if we should use local config (only for mobile OS)

            if (os === 'android' || os === 'ios') {

                var localUrl = this.getLocalDownloadUrl(appId, os);
                if (localUrl) {

                    // Make it asynchronous to match XHR behavior
                    return this.$q.resolve({
                        data: {
                            data: {
                                attributes: {
                                    download_url: localUrl
                                }
                            }
                        }
                    }).then(function (response) {
                        return (
                            // Add a small delay to allow DOM to stabilize (like XHR calls)
                            _this2.$q(function (resolve) {

                                setTimeout(function () {
                                    return resolve(response);
                                }, 500);
                            })
                        );
                    });
                }
            }

            var deploymentPayload = {
                data: {
                    attributes: {
                        appId: appId,
                        os: data.os,
                        license_number: data.license_number,
                        license_type: data.license_type,
                        download_source: data.license_type === 'paid' ? 'wdp' : 'wdf',
                        beta: data.beta
                    }
                },
                meta: data.meta || {}
            };

            return _get(DeploymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(DeploymentUrlsRestService.prototype), 'create', this).call(this, deploymentPayload, 'deployment-urls/');
        }

        /**
         * Gets download URL from local configuration for mobile deployments
         */

    }, {
        key: 'getLocalDownloadUrl',
        value: function getLocalDownloadUrl(appId, os) {
            var _CWCONFIG = CWCONFIG,
                downloadUrls = _CWCONFIG.downloadUrls,
                fallbackPatterns = _CWCONFIG.fallbackPatterns;


            if (!downloadUrls || !downloadUrls[os]) {

                return null;
            }

            // Find matching URL for the appId
            var matchingConfig = downloadUrls[os].find(function (configItem) {
                return configItem.apps.includes(appId);
            });

            if (matchingConfig) {

                return matchingConfig.url;
            }

            // Try fallback patterns
            if (fallbackPatterns && fallbackPatterns[os]) {

                var fallbackMatch = fallbackPatterns[os].find(function (fallback) {
                    return fallback.pattern.test(appId);
                });

                if (fallbackMatch) {

                    var fallbackConfig = downloadUrls[os].find(function (configItem) {
                        return configItem.apps.includes(fallbackMatch.fallbackToApp);
                    });

                    if (fallbackConfig) {

                        return fallbackConfig.url;
                    }
                }
            }

            return null;
        }
    }]);

    return DeploymentUrlsRestService;
}(_baseRestService2.default);

exports.default = DeploymentUrlsRestService;


_serviceDependencies.push(DeploymentUrlsRestService);

angular.module('rest.services').service('DeploymentUrlsRestService', _serviceDependencies);

/***/ }),

/***/ "57js":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-auth\">\n    <div class=\"auth-region\">\n\n        <a ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n            <i class=\"sprite sprite-logo\"></i>\n            <h1>{{State.partner.name}}</h1>\n        </a>\n\n        <div class=\"form-wrapper\">\n\n            <h1 class=\"text-xxl2 text-grey-3 mb5\" translate=\"cw.auth.set-password.title\" connectqa-login=\"header\"></h1>\n            <h2 class=\"text-l text-grey-4 mb15\"\n                translate=\"cw.auth.set-password.description\"\n                connectqa-login=\"paragraph\"></h2>\n\n            <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock error': setPasswordForm.$error.serverValidation}\">\n                <h5 class=\"text-m text-red-2\" ng-if=\"setPasswordForm.$error.serverValidation\" translate=\"cw.notification.set-password.error\" translate-compile></h5>\n            </div>\n\n            <form class=\"auth-form\" name=\"setPasswordForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.setPassword()\">\n                <div class=\"form-group\">\n                    <input type=\"text\"\n                           ng-model=\"user.email\"\n                           name=\"email\"\n                           maxlength=\"100\"\n                           ng-class=\"{'error': setPasswordForm.email.$invalid && submitted}\"\n                           id=\"email\"\n                           placeholder=\"{{ 'cw.form.email' | translate }}\"\n                           required connectqa-login=\"email-address\"\n                           disabled/>\n\n                    <label ng-hide=\"setPasswordForm.email.$viewValue.length > 0\" class=\"fallback-input\" for=\"email\" translate=\"cw.form.email\"></label>\n                </div>\n\n                <div class=\"form-group\" ng-init=\"passwordFocus = false\">\n                    <input type=\"password\"\n                           ng-model=\"user.password\"\n                           name=\"password\"\n                           ng-focus=\"passwordFocus = true\"\n                           ng-blur=\"passwordFocus = false\"\n                           ng-class=\"{'error': (setPasswordForm.password.$invalid || !oauthCtrl.passwordScore.valid) && submitted}\"\n                           maxlength=\"100\"\n                           autocomplete=\"off\"\n                           placeholder=\"{{ 'cw.form.password' | translate }}\"\n                           ng-minlength=\"8\"\n                           ng-keyup=\"oauthCtrl.getPasswordScore(setPasswordForm.password.$viewValue)\"\n                           class=\"no-text-error\"\n                           id=\"password\"\n                           ng-pattern=\"passwordRegExp\"\n                           required connectqa-register=\"password\"/>\n                    <label ng-hide=\"setPasswordForm.password.$viewValue.length > 0\" translate=\"cw.form.password\" for=\"password\" class=\"fallback-input\"></label>\n                    <p class=\"error-message\"\n                       ng-show=\"(setPasswordForm.password.$error.required ||\n                                (!oauthCtrl.passwordScore.valid && !setPasswordForm.password.$viewValue)) && submitted\"\n                       translate=\"cw.validator.password.error.enter_password\"></p>\n\n                    <p class=\"error-message\"\n                        ng-show=\"setPasswordForm.password.$viewValue.length === 100\"\n                        translate=\"cw.validator.messages.password.maximum_length\"></p>\n\n                    <span class=\"show-password\" ng-class=\"{'text': inputType === 'text'}\" ng-click=\"oauthCtrl.showPassword()\"></span>\n\n                    <div ng-if=\"passwordFocus\" class=\"tooltip-input left\">\n                        <password-strength\n                            passlength=\"setPasswordForm.password.$viewValue.length\"\n                            passpattern=\"setPasswordForm.password.$valid\"\n                            passwordscore=\"oauthCtrl.passwordScore\">\n                        </password-strength>\n                    </div>\n                </div>\n\n                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                        translate=\"cw.auth.continue\"\n                        ng-disabled=\"oauthCtrl.Auth.loading\" connectqa-login=\"continue-button\">\n                </button>\n\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "5EEQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

/**
 * Controller for the store page embedded in the dashboard
 * And new ConnectWeb Store Page
 */

angular.module('controllers').controller('Store', ['$scope', 'Util', function ($scope, Util) {

    var primeIds = Util.deepFind(CWCONFIG, 'features.primeOffer.primeIds') || [];
    var activationCodesRepo = _index.ActivationCodesRepository.getAll();
    var licensesRepo = _index.LicensesRepository.getAll();
    var userHasSubscriptions = activationCodesRepo.length > 0 || licensesRepo.length > 0;
    var userHasCustomPrimeSubscription = null;

    $scope.ShowPrimePage = false;
    $scope.showComparison = false;

    if (userHasSubscriptions) {

        var aps20shortestRuntime = 0;
        $scope.ShowPrimePage = true;

        // check if has Avira Prime (aps10 || aps20) and the runtime is 1,12 or 24
        activationCodesRepo.forEach(function (activationCode) {

            var foundPrimeSubscription = primeIds.indexOf(activationCode.attributes.app) > -1;

            // show prime page if the user has any subscription other than aps20 with runtime 36
            if (foundPrimeSubscription && activationCode.attributes.app === 'aps20' && activationCode.attributes.runtime > aps20shortestRuntime) {

                $scope.ShowPrimePage = true;
                aps20shortestRuntime = activationCode.attributes.runtime;
            }

            // f the user has aps20 with runtime 36 show comparison page
            if (aps20shortestRuntime === 36) {

                $scope.ShowPrimePage = false;
                userHasCustomPrimeSubscription = true;
            }
        });
    } else {

        // show comparison page
        $scope.showComparison = true;
    }

    if (userHasCustomPrimeSubscription) {

        // $scope.ShowOODiskImagePage = true;
        // temporary solution - show comparison instead of O&O
        $scope.showComparison = true;
    }

    // $scope.$on('$destroy', () => {

    //     if ($rootScope.showPrimeTrialModal) {

    //         const trialModalClosed = sessionStorage.getItem('trialModalClosed');
    //         if (!trialModalClosed) {

    //             $state.go('root.dashboard.store.ltb', {
    //                 ltb: 'trial-modal',
    //                 resourceId: 'trial',
    //             });

    //         }

    //     }

    // });
}]); /* eslint no-undef: 0 */

/***/ }),

/***/ "5JJD":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content payment-cart-modal\" connectqa-modal=\"payment-cart\" ng-class=\"{'payment-cart-large': cartVariant === 'checkout'}\">\n    <!-- LOADING -->\n    <div class=\"main-loader\" ng-if=\"showLoading\"></div>\n\n    <!-- CART IFRAME -->\n    <div id=\"iframe-holder\" class=\"iframe-holder\" ng-if=\"showCartIframe\">\n        <cart-iframe width=\"iframeWidth\" height=\"iframeHeight\" url=\"shopUrl\" error=\"onIframeError\"\n            iframeready=\"onIframeReady\" purchasecomplete=\"onPurchaseReady\" frameloaded=\"onIframeContentLoaded\"\n            getmodalwidth=\"getModalWidth\"></cart-iframe>\n    </div>\n\n    <!-- SUCCESS MODAL -->\n    <div class=\"payment-cart-success\" ng-show=\"showSuccessModal\" connectqa-payment-cart=\"success-modal\">\n        <div class=\"icon-success\" connectqa-payment-cart=\"success-icon\"></div>\n        <div class=\"separator-grey-mbt40\"></div>\n        <div class=\"text-left\">\n            <p class=\"text-l font-bold text-grey-1 mb20\" translate=\"cw.general.order_reference_number\"\n                translate-values=\"{ referenceNumber : transactionId }\" connectqa-payment-cart=\"success-order-number\">\n            </p>\n            <p ng-if=\"isAnnual\" class=\"text-m text-grey-3 mb5\">\n                <span translate=\"cw.purchase_success.annual.title\"\n                translate-values=\"{\n                    date: nextBillingEvent,\n                    price: nextBillingPrice\n                }\"></span>\n                <span translate=\"cw.ocp.cma_desc.renewal_prices\"></span>\n            </p>\n            <p ng-if=\"isMonthly\" class=\"text-m text-grey-3 mb5\">\n                <span translate=\"cw.purchase_success.monthly.title\"\n                translate-values=\"{\n                    date: nextBillingEvent,\n                    price: nextBillingPrice\n                }\"></span>\n                <span translate=\"cw.ocp.cma_desc.renewal_prices\"></span>\n            </p>\n            <div ng-if=\"showMergedLicensesSuccess\">\n                <div ng-if=\"showTitleWithTwoProducts\">\n                    <p ng-if=\"extraRuntime > 1\" class=\"text-m text-grey-3 mb5\"\n                        translate=\"cw.purchase_success.merged_subscription_plural\"\n                        translate-values=\"{\n                            days : extraRuntime,\n                            product1 : onMergingApp.attributes.name,\n                            product2 : app.attributes.name\n                        }\"></p>\n                    <p ng-if=\"extraRuntime === 1\" class=\"text-m text-grey-3 mb5\"\n                        translate=\"cw.purchase_success.merged_subscription_singular\"\n                        translate-values=\"{\n                            days : extraRuntime,\n                            product1 : onMergingApp.attributes.name,\n                            product2 : app.attributes.name\n                        }\"></p>\n                </div>\n                <div ng-if=\"!showTitleWithTwoProducts\">\n                    <p ng-if=\"totalRuntime > 1\" class=\"text-m text-grey-3 mb5\"\n                        translate=\"cw.purchase_success.extented_subscription_plural\"\n                        translate-values=\"{\n                            days : totalRuntime,\n                            product : app.attributes.name\n                        }\"></p>\n                    <p ng-if=\"totalRuntime === 1\" class=\"text-m text-grey-3 mb5\"\n                        translate=\"cw.purchase_success.extented_subscription_singular\"\n                        translate-values=\"{\n                            days : totalRuntime,\n                            product : app.attributes.name\n                        }\"></p>\n                </div>\n            </div>\n            <p class=\"text-m text-grey-3 mb20\" translate=\"cw.purchase_success.email_confirmation\"></p>\n            <p class=\"text-m text-grey-1 mb20 font-bold\" translate=\"cw.purchase_success.terms_title\"></p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span>\n                <span translate=\"cw.purchase_success.annual.contract_type_desc\" ng-if=\"isAnnual\"></span>\n                <span translate=\"cw.purchase_success.monthly.contract_type_desc\" ng-if=\"isMonthly\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span>\n                <span translate=\"cw.purchase_success.annual.renewal_cycle_desc\" ng-if=\"isAnnual\"></span>\n                <span translate=\"cw.purchase_success.monthly.renewal_cycle_desc\" ng-if=\"isMonthly\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\" ng-if=\"showFreeTrialCmaInfo\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.free_trial\"></span>\n                <span translate=\"cw.cma_disclaimer.free_trial_desc\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.purchase_success.annual.billing_cycle\"></span>\n                <span translate=\"cw.purchase_success.annual.billing_cycle_desc\" ng-if=\"isAnnual\"></span>\n                <span translate=\"cw.purchase_success.monthly.billing_cycle_desc\" ng-if=\"isMonthly\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span>\n                <span translate=\"cw.purchase_success.annual.cancellation_desc\" ng-if=\"isAnnual\"\n                translate-values=\"{cancellation: cancellation}\"></span>\n                <span translate=\"cw.purchase_success.monthly.cancellation_desc\" ng-if=\"isMonthly\"\n                translate-values=\"{cancellation: cancellation}\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.purchase_success.annual.your_info\"></span>\n                <span translate=\"cw.purchase_success.annual.your_info_desc\"\n                translate-values=\"{globalPrivacy: globalPrivacy}\"></span>\n            </p>\n            <div class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_settings\"></span><span translate=\"cw.subscribe.renewal_settings_desc\" translate-values=\"{siteLink: siteLink}\"></span>\n                <div class=\"info-tooltip-holder inline-block v-middle\">\n                    <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                    <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <span translate=\"cw.subscribe.renewal_settings_tooltip.desc_1\"></span>\n                        <ol>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_2\"></li>\n                            <li ng-show=\"$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_3\"></li>\n                            <li ng-show=\"!$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_6\"></li>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_4\"></li>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_5\"></li>\n                        </ol>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"separator-grey-mbt40\"></div>\n        <div class=\"text-center\">\n            <button class=\"btn btn-large btn-primary mb10\" ng-click=\"actionDone()\"\n                translate=\"cw.tour.user.action_done\" connectqa-payment-cart=\"success-done\"></button>\n\n            <div>\n                <a translate=\"cw.ocp.print_invoice\" ui-sref=\"root.dashboard.subscriptions({tab: 'history'})\"\n                    class=\"text-s text-blue-2 crs-pointer\" connectqa-payment-cart=\"print-invoice\"></a>\n            </div>\n        </div>\n        <p class=\"text-m text-grey-3 mt20 text-left\" ng-if=\"$root.isPartOfEEA\" translate=\"cw.purchase_success.eea_info\"\n            translate-values=\"{cancellation: cancellation }\"></p>\n    </div>\n</div>\n";
var path = 'scripts/controllers/modals/payment-cart/payment-cart.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "5R2H":
/***/ (function(module, exports) {

module.exports = "<div class=\"disclaimer-bar\" ng-show=\"disclaimerBarCtrl.isDisclaimerVisible\">\n\n    <div class=\"text-m\" translate=\"cw.disclaimer.vpn\"></div>\n    <a class=\"icon icon-close icon-xxxs crs-pointer\" ng-click=\"disclaimerBarCtrl.closeDisclaimer()\"></a>\n\n</div>"

/***/ }),

/***/ "5TFR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

(function () {

    angular.module('services').factory('Interpolation', function () {
        return {
            setLocale: function setLocale() {},

            interpolate: function interpolate(string, interpolateParams) {

                if (!angular.isObject(interpolateParams)) {

                    return string;
                }
                string = string.split(' ');
                string = _.map(string, function (word) {

                    var startIdx = word.indexOf('__');
                    var endIdx = word.lastIndexOf('__');
                    var solved = '';
                    if (startIdx >= 0 && endIdx >= 0 && startIdx !== endIdx) {

                        solved = interpolateParams[word.slice(startIdx + 2, endIdx)];
                        if (!angular.isUndefined(solved)) {

                            word = word.slice(0, startIdx) + solved + word.slice(endIdx + 2);
                        }
                        return word;
                    }
                    return word;
                });
                return string.join(' ');
            }
        };
    });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "5cCM":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("tZex"),
    eq = __webpack_require__("0huu");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "5e2f":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("1zte");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "5sbn":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email license-m\" connectqa-deploy-modal=\"mobile-device\">\n\n    <!-- IF AUTOINSTALL -->\n    <div ng-show=\"phoneDeploymentWizardCtrl.autoInstall\">\n        <div class=\"downloading-image-mobile m-auto mb20\"></div>\n\n        <div class=\"mb10\">\n            <p class=\"text-l text-grey-3 deploy-text-container measure mb40\"\n                translate=\"cw.deploy.modal.auto-install.mobile.title\"\n                translate-values=\"{product: '{{phoneDeploymentWizardCtrl.app.attributes.resource.oeName}}' }\"\n                id=\"deployActionDownload\">\n            </p>\n\n            <button class=\"btn btn-large btn-primary\"\n                    ng-click=\"phoneDeploymentWizardCtrl.deployOnAnotherDevice();\"\n                    translate=\"cw.deploy.modal.auto-install.button.primary-action\">\n            </button>\n        </div>\n\n    </div>\n\n    <!-- IF CLASSIC INSTALL -->\n    <div ng-show=\"!phoneDeploymentWizardCtrl.autoInstall\" class=\"download-v2\">\n        <div class=\"content-wrapper mobile-margin-bottom\">\n            <div class=\"text-left flex-wrapper\">\n                <div class=\"app-icon inline-block v-top\"\n                    ng-class=\"{'v-middle': !app.attributes.resource.shortDescription && !app.attributes.resource.cmsShortdescription}\">\n                    <img ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\"\n                            ng-if=\"app.attributes.resource.wsLargeImageUrl\" />\n                    <img\n                        ng-if=\"app.attributes.type === 'bundle' && !app.attributes.resource.wsLargeImageUrl\"\n                        src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                    <img\n                        ng-if=\"app.attributes.type !== 'bundle' && !app.attributes.resource.wsLargeImageUrl\"\n                        src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n                </div>\n\n                <div class=\"inline-block v-top mlr20 product-description w63\"\n                    ng-class=\"{'v-middle': !app.attributes.resource.shortDescription && !app.attributes.resource.cmsShortdescription}\"\n                    connectqa-deploy-modal=\"license-description\">\n                    <h3 class=\"text-xl mb5\">{{app.attributes.resource.oeName}}</h3>\n                    <p ng-if=\"app.attributes.resource.shortDescription\" class=\"text-grey-3 text-s\">\n                        {{app.attributes.resource.shortDescription}}\n                    </p>\n                    <p ng-if=\"!app.attributes.resource.shortDescription && app.attributes.resource.cmsShortdescription\" class=\"text-grey-3 text-s\">\n                        {{app.attributes.resource.cmsShortdescription}}\n                    </p>\n                </div>\n                <div ng-if=\"deviceOs === 'windows' || deviceOs === 'mac_os_x'\" class=\"inline-block w25\">\n                    <div ng-if=\"showFallbackQRcode\" class=\"qr-image\"></div>\n                    <div ng-if=\"!showFallbackQRcode\" id=\"deploy-mobile-qrcode\" class=\"m-auto dynamic-qr-image\" connectwebqa=\"deploy-modal/qr-image\"></div>\n                </div>\n            </div>\n        </div>\n        <!--TABS-->\n        <div class=\"content-wrapper mobile-margin-bottom deploy-options\">\n            <div class=\"mb10 mobile-visible\" ng-if=\"deviceOs === 'android' || deviceOs === 'ios'\">\n                <p class=\"text-m text-grey-2\" ng-if=\"inputData.os === 'ios'\" translate=\"cw.deploy.download.appstore_label\"></p>\n                <p class=\"text-m text-grey-2\" ng-if=\"inputData.os === 'android'\" translate=\"cw.deploy.download.playstore_label\"></p>\n                <a class=\"btn btn-medium btn-primary download-apple-appstore external-store-download\"\n                    ng-click=\"phoneDeploymentWizardCtrl.deployViaAppStoreMixpanel()\"\n                    ng-if=\"inputData.os === 'ios'\"\n                    ng-href=\"{{externalDownloadUrl}}\"\n                    target=\"_blank\">\n                    <i class=\"inline-block icon-apple-app-store v-middle\"></i>\n                    <span class=\"inline-block v-middle\" translate=\"cw.deploy.download.appstore_button\">\n                    </span>\n                </a>\n                <a class=\"btn btn-medium btn-primary download-google-playstore external-store-download\"\n                    ng-click=\"phoneDeploymentWizardCtrl.deployViaAppStoreMixpanel()\"\n                    ng-if=\"inputData.os === 'android'\"\n                    ng-href=\"{{externalDownloadUrl}}\"\n                    target=\"_blank\">\n                    <i class=\"inline-block icon-google-play-store v-middle\"></i>\n                    <span class=\"inline-block v-middle\" translate=\"cw.deploy.download.playstore_button\">\n                    </span>\n                </a>\n            </div>\n            <div>\n                <p class=\"text-m text-grey-2\"\n                    translate=\"cw.deploy.download.send_email_v2\"\n                    translate-values=\"{email: inputData.emails[0]}\">\n                </p>\n                <button class=\"btn btn-medium btn-primary\"\n                    ng-disabled=\"phoneDeploymentWizardCtrl.deployChoose.waitingResponse\"\n                    ng-click=\"phoneDeploymentWizardCtrl.deployViaEmail()\"\n                    translate=\"cw.deploy.product.send_email\" connectqa-deploy-modal=\"send-via-email-button\">\n                </button>\n            </div>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),

/***/ "6/rD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _i18next = __webpack_require__("J7wN");

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__("JLvu");

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// insert translationHash from grunt at build time
// @@insertConfigHash
/* eslint-disable */
var languageHashObject = { 'de': '', 'es': '', 'fr': '', 'it': '', 'ja': '', 'ko': '', 'nl': '', 'pl': '', 'pt-br': '', 'ru': '', 'tr': '', 'zh-cn': '', 'zh-tw': '', 'id': '', 'vi': '', 'in': '', 'en': '' };

var i18nPromise = function i18nPromise() {
    return new Promise(function (resolve, reject) {

        _i18next2.default.use(_i18nextXhrBackend2.default).init({
            lng: CWCONFIG.language,
            debug: false,
            interpolation: {
                prefix: '__',
                suffix: '__',
                escapeValue: false
            },
            backend: {
                loadPath: CWCONFIG.cdn + '/lang/' + "a24774b8e621ab1d79" + '-' + CWCONFIG.language + '.json',
                crossDomain: true
            },
            nsSeparator: false
        }, function (err) {

            // initialized and ready to go!
            if (err) {

                reject(err);
            }

            resolve('i18n has loaded');
        });
    });
};

exports.default = i18nPromise;

/***/ }),

/***/ "6FPD":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon dwm-icon-addresses\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb5\" translate=\"cw.dwm.entity.address.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div ng-repeat=\"address in addresses.entries track by $index\" class=\"border-botton\">\n                            <div class=\"row display-flex align-item-center\" ng-if=\"!address.showUpdateInput\">\n                                <div class=\"col-1 col-text text-left\">\n                                    <p class=\"text-grey-3 text-l\" translate=\"cw.dwm.entity.address.primary_address\" ng-if=\"$index === 0\"></p>\n                                    <p class=\"text-grey-3 text-l\" translate=\"cw.dwm.entity.address.address\" translate-values=\"{\n                                        index: $index + 1\n                                    }\" ng-if=\"$index > 0\"></p>\n                                </div>\n                                <div class=\"col-2 col-text text-left\">\n                                    <p class=\"text-grey-1 text-l\">{{address.street1}}{{ address.street2 ? ' '+ address.street2 : '' }}, {{address.city}}, {{address.postalCode}}</p>\n                                </div>\n                                <div class=\"col-3 col-text text-right\">\n                                    <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> \n                                    {{ $index > 0 ? '/' : '' }}\n                                    <span\n                                        class=\"action\" ng-click=\"removeEntry($index)\" ng-if=\"$index > 0\" translate=\"cw.my_devices.link.remove\"></span>\n                                </div>\n                            </div>\n                            <div class=\"row display-flex align-item-center address-row\" ng-if=\"address.showUpdateInput\">\n                                <div class=\"col-2 col-text text-left\">\n                                    <input type=\"text\" ng-class=\"{'error': !address1IsValid}\" name=\"address-1\"\n                                        maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.address_line_1' | translate }}\" id=\"address-1\"\n                                        ng-keyup=\"entryUpdateValue($event, 'street1')\" value=\"{{address.street1}}\">\n                                    <p class=\"error-message\" ng-show=\"!address1IsValid\" translate=\"cw.dwm.entity.address.address_line.error\">\n                                    </p>\n                                </div>\n                                <div class=\"col-2 input-name col-text text-left\">\n                                    <input type=\"text\" ng-class=\"{'error': !address2IsValid}\" name=\"address-2\"\n                                        maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.address_line_2' | translate }}\" id=\"address-2\"\n                                        ng-keyup=\"entryUpdateValue($event, 'street2')\" value=\"{{address.street2}}\">\n                                    <p class=\"error-message\" ng-show=\"!address2IsValid\" translate=\"cw.dwm.entity.address.address_line.error\">\n                                    </p>\n                                </div>\n                                <div class=\"col-2 col-text text-left mt10 postal-code\">\n                                    <input type=\"text\" ng-class=\"{'error': !postalCodeIsValid}\" name=\"postal-code\" \n                                        maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.postal_code' | translate }}\" id=\"postal-code\"\n                                        ng-keyup=\"entryUpdateValue($event, 'postalCode')\" value=\"{{address.postalCode}}\">\n                                    <p class=\"error-message\" ng-show=\"!postalCodeIsValid\" translate=\"cw.dwm.entity.address.postal_code_error\">\n                                    </p>\n                                </div>\n                                <div class=\"col-2 col-text text-left mt10\">\n                                    <input type=\"text\" ng-class=\"{'error': !cityIsValid}\" name=\"city\" value=\"{{address.city}}\"\n                                        maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.city' | translate }}\" id=\"city\"\n                                        ng-keyup=\"entryUpdateValue($event, 'city')\">\n                                    <p class=\"error-message\" ng-show=\"!cityIsValid\" translate=\"cw.dwm.entity.address.city_error\">\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center address-row\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-2 col-text text-left\">\n                                <input type=\"text\" ng-class=\"{'error': !address1IsValid}\" name=\"address-1\" ng-model=\"newAddress1\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.address_line_1' | translate }}\" id=\"address-1\"\n                                    ng-keyup=\"validateAddress1($event)\">\n                                <p class=\"error-message\" ng-show=\"!address1IsValid\" translate=\"cw.dwm.entity.address.address_line.error\">\n                                </p>\n                            </div>\n                            <div class=\"col-2 input-name col-text text-left\">\n                                <input type=\"text\" ng-class=\"{'error': !address2IsValid}\" name=\"address-2\" ng-model=\"newAddress2\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.address_line_2' | translate }}\"  id=\"address-2\"\n                                    ng-keyup=\"validateAddress2($event)\">\n                                <p class=\"error-message\" ng-show=\"!address2IsValid\" translate=\"cw.dwm.entity.address.address_line.error\">\n                                </p>\n                            </div>\n                            <div class=\"col-2 col-text text-left mt10 postal-code\">\n                                <input type=\"text\" ng-class=\"{'error': !postalCodeIsValid}\" name=\"postal-code\" ng-model=\"newPostalCode\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.postal_code' | translate }}\" id=\"postal-code\"\n                                    ng-keyup=\"validatePostalCode($event)\">\n                                <p class=\"error-message\" ng-show=\"!postalCodeIsValid\" translate=\"cw.dwm.entity.address.postal_code_error\">\n                                </p>\n                            </div>\n                            <div class=\"col-2 col-text text-left mt10\">\n                                <input type=\"text\" ng-class=\"{'error': !cityIsValid}\" name=\"city\" ng-model=\"newCity\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.address.city' | translate }}\" id=\"city\"\n                                    ng-keyup=\"validateCity($event)\">\n                                <p class=\"error-message\" ng-show=\"!cityIsValid\" translate=\"cw.dwm.entity.address.city_error\">\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.address.remove_address_title\">\n                        </h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.address.remove_address_desc_1\">\n                        </p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\">\n                        </p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.address.entity_details.title\">\n                    </h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.address.entity_details.desc_1\">\n                    </p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.address.entity_details.desc_2\">\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\"\n                ng-if=\"showAddNewButton && (addresses.maxCount > addresses.entries.length)\" ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewAddressIsLoading}\"\n                    ng-disabled=\"saveNewAddressIsLoading || !formIsValid\" ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !updateFormIsValid\" ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/addresses/addresses.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "6JCO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint max-len: 0 */

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', 'Util', '$scope', 'RecommendationsRestService', '$translate', '$rootScope', '$location', '$anchorScroll'];

var RecommendationBannerController = function () {
    function RecommendationBannerController($state, Util, $scope, RecommendationsRestService, $translate, $rootScope, $location, $anchorScroll) {
        var _this = this;

        _classCallCheck(this, RecommendationBannerController);

        this.$state = $state;
        this.issues = [];
        this.$scope = $scope;
        this.Util = Util;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;

        $scope.showRecommendation = false;
        $scope.showRecommendationPrime = false;
        $scope.showRecommendationAIA = false;
        $rootScope.showRecommendation = false;
        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.product1 = _index.AppIntegrationsRepository.getAppName('pasm0');
        $scope.product2 = _index.AppIntegrationsRepository.getAppName('swoe0');
        $scope.hasValidPayment = $rootScope.hasValidPayment;
        var subscriptions = _index.ActivationCodesRepository.getAll();

        $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;

        $scope.gotoAnchor = function (anchor) {

            _this.$location.hash(anchor);
            _this.$anchorScroll();
        };

        var currentUserAppId = Util.deepFind(subscriptions[0], 'attributes.app');
        var recommendedApp = _index.AppIntegrationsRepository.getById(currentUserAppId) || {};

        // hide the learn more button for app recommendations without comparison features
        if (Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

            $scope.showLearnMoreButton = true;
        } else {

            $scope.showLearnMoreButton = false;
        }

        if (subscriptions.length > 0) {

            RecommendationsRestService.getAllAsync().then(function (response) {

                _index.RecommendationsRepository.replace(response.data.data);
            });

            // get recommendation for user
            var recommendationObservable = _index.RecommendationsRepository.getObservable();
            var recommendationsSubscriber = recommendationObservable.subscribe(function (data) {

                // recommendation is available, show banner
                if (data.length > 0) {

                    var hasPrime = _index.LicensesRepository.getLicenseByAppId('aps10') || _index.LicensesRepository.getLicenseByAppId('aps20');

                    if (hasPrime) {

                        var userCountry = Util.deepFind(_index.MeRepository.getMyUser(), 'attributes.country');

                        if (userCountry === 'DE') {

                            _this.recommendation = [data.find(function (product) {
                                return product.attributes.acronym === 'adwp1';
                            })];
                            $scope.recommendationDetails = data.find(function (product) {
                                return product.attributes.acronym === 'adwp1';
                            });

                            // show recommendation only for CB region. CA region (USA) is excluded
                            if ($scope.recommendationDetails.attributes.pg === 'CB') {

                                $scope.showRecommendation = true;
                                $scope.showRecommendationAIA = true;
                                $rootScope.showRecommendation = true;
                            }

                            var aiaRecommendation = data.find(function (product) {
                                return product.attributes.acronym === 'adwp1';
                            });

                            // $rootScope.createCMAlabels('adwp1_12_1', 'Identity Assistant', 'adwp1', '2023-11-23', '2023-12-03');

                            $scope.recommendedProduct = _index.AppIntegrationsRepository.getById(aiaRecommendation.attributes.acronym);

                            var subscriptionsProductIds = [];
                            subscriptions.forEach(function (subscription) {

                                subscriptionsProductIds.push(subscription.relationships.app.data.id);
                            });

                            var mixpanelDetails = {
                                'Recommendation ID': aiaRecommendation.id,
                                Page: 'Subscriptions',
                                'Product ID': $scope.recommendedProduct.id,
                                Product: $scope.recommendedProduct.attributes.name,
                                'User subscriptions': subscriptionsProductIds.sort().join(',')
                            };

                            _RFC2.default.send('ConnectWeb OCP Recommendation Show', mixpanelDetails);
                        } else {

                            $scope.showRecommendation = false;
                            $rootScope.showRecommendation = false;
                        }
                    } else {

                        _this.recommendation = data;
                        $scope.recommendationDetails = data.find(function (product) {
                            return product.attributes.acronym === 'aps10';
                        });

                        // show recommendation only for CB region. CA region (USA) is excluded
                        if ($scope.recommendationDetails.attributes.pg === 'CB') {

                            $scope.showRecommendation = true;
                            $scope.showRecommendationPrime = true;
                            $rootScope.showRecommendation = true;
                        }

                        var primeRecommendation = data.find(function (product) {
                            return product.attributes.acronym === 'aps10';
                        });

                        //* Promotional Campaign
                        //* To be commented when the campaign is over
                        // if (!$rootScope.cmaGBapplies) {

                        //     $rootScope.createCMAlabels(
                        //         'aps10_12_1',
                        //         'Avira Prime',
                        //         'aps10',
                        //         '2023-11-23',
                        //         '2023-12-03',
                        //     );

                        // }

                        $scope.recommendedProduct = _index.AppIntegrationsRepository.getById(primeRecommendation.attributes.acronym);

                        var recommendedProduct = _index.AppIntegrationsRepository.getById(subscriptions[0].relationships.app.data.id);

                        var productPrototype = '';

                        // check if first product from recommendation is bundle
                        if (recommendedProduct.attributes.prototype === null && recommendedProduct.attributes.type === 'bundle') {

                            // get product prototype from app relationship
                            recommendedProduct.relationships.apps.data.forEach(function (app) {

                                var appInt = _index.AppIntegrationsRepository.getById(app.id);

                                if (appInt.attributes.prototype === 'updater' || appInt.attributes.prototype === 'passm') {

                                    productPrototype = appInt;
                                }
                            });
                        } else if (recommendedProduct.attributes.prototype === 'app') {

                            productPrototype = recommendedProduct.attributes.prototype;
                        }

                        // if product prototype exists and is software updater or password manager,
                        // the product thire feature will be updated
                        if (productPrototype) {

                            if (productPrototype.attributes.prototype === 'updater') {

                                $scope.recommendedProduct.attributes.resource.bannerFeatures[2].description = _this.$translate.instant('cw.recommendation.feature.software_updater', { brandname: $scope.brandName, product: $scope.product1 });
                            } else if (productPrototype.attributes.prototype === 'passm') {

                                $scope.recommendedProduct.attributes.resource.bannerFeatures[2].description = _this.$translate.instant('cw.recommendation.feature.password_manager', { brandname: $scope.brandName, product: $scope.product2 });
                            }
                        }

                        $scope.isYearlyPayment = $scope.recommendationDetails.attributes.subscription_type === 'annual';

                        var _subscriptionsProductIds = [];
                        subscriptions.forEach(function (subscription) {

                            _subscriptionsProductIds.push(subscription.relationships.app.data.id);
                        });

                        var _mixpanelDetails = {
                            'Recommendation ID': data[0].id,
                            Page: 'Subscriptions',
                            'Product ID': $scope.recommendedProduct.id,
                            Product: $scope.recommendedProduct.attributes.name,
                            'User subscriptions': _subscriptionsProductIds.sort().join(',')
                        };

                        _RFC2.default.send('ConnectWeb OCP Recommendation Show', _mixpanelDetails);
                    }
                } else {

                    $scope.showRecommendation = false;
                    $rootScope.showRecommendation = false;
                }
            }, function () {}, function () {});

            $scope.$on('$destroy', function () {

                recommendationsSubscriber.dispose();
                $rootScope.welcomeOffers = {};
            });
        }

        _RFC4.default.subscribe('purchase completed', function () {

            RecommendationsRestService.getAllAsync().then(function (response) {

                _index.RecommendationsRepository.replace(response.data.data);
            });
        });

        if ($scope.showRecommendation) {

            $rootScope.showCmaDisclaimer.banner = true;
        }
    }

    _createClass(RecommendationBannerController, [{
        key: 'tryRecommendation',
        value: function tryRecommendation(action, xacontent, xamedium) {

            this.$rootScope.ocp_xa_content = xacontent;
            this.$rootScope.ocp_xa_medium = xamedium;

            var ltbName = 'one-click-payment';
            var subsource = void 0;
            var promotion = void 0;
            var stateName = this.$state.current.name;

            if (stateName.indexOf('.ltb') === -1) {

                stateName += '.ltb';
            }

            // Learn More modal
            // if user doesnt have a valid payment, open payment card
            if (action === 'Learn More') {

                ltbName = 'ocp-comparison';
            } else if (this.$scope.hasValidPayment === false) {

                stateName += '.banner';
                ltbName = 'payment-cart';
                subsource = 'banner';
                promotion = true;
            }

            var mixpanelDetails = {
                Product: this.$scope.recommendedProduct.attributes.name,
                'Product ID': this.$scope.recommendedProduct.id,
                'Recommendation ID': this.recommendation[0].id,
                'Button Label': action,
                Page: 'Subscriptions'
            };

            _RFC2.default.send('ConnectWeb OCP Button Click', mixpanelDetails);

            if (this.$scope.recommendedProduct.id !== 'adwp1' || action !== 'Learn More') {

                // open modal
                this.$state.go(stateName, {
                    ltb: ltbName,
                    resourceId: this.$scope.recommendedProduct.id,
                    subsource: subsource,
                    promotion: promotion
                }, {
                    reload: false
                });
            }
        }
    }]);

    return RecommendationBannerController;
}();

var RecommendationBannerDirective = function RecommendationBannerDirective() {
    _classCallCheck(this, RecommendationBannerDirective);

    this.template = __webpack_require__("JTpj");
    this.restrict = 'EA';
    this.replace = true;
    this.scope = { source: '=', licenses: '=' };

    if (CWCONFIG.features.oneClickPayment) {

        _controllerDependencies.push(function ($state, DeployRestService, Util, $scope, $translate, $rootScope, $location, $anchorScroll) {
            return new RecommendationBannerController($state, DeployRestService, Util, $scope, $translate, $rootScope, $location, $anchorScroll);
        });
        this.controller = _controllerDependencies;
        this.controllerAs = 'recommendationBannerController';
    }
};

_directiveDependencies.push(function () {
    return new RecommendationBannerDirective();
});

angular.module('directives').directive('recommendationBanner', _directiveDependencies);

/***/ }),

/***/ "6Tbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("YW9j");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$document', '$window', '$rootScope'];

var DwmStoreController = function DwmStoreController($scope, $state, $document, $window, $rootScope) {
    _classCallCheck(this, DwmStoreController);

    _RFC2.default.send('ConnectWeb AIA Store Open');

    $scope.showOPCButton = false;
    $scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;

    _RFC4.default.subscribe('showRecommendation:true', function () {

        $scope.showOPCButton = true;
    });
    _RFC4.default.subscribe('showRecommendation:false', function () {

        $scope.showOPCButton = false;
    });

    $scope.activeScreen = 'screen-1';

    $scope.changeActiveScreen = function (screen, tab) {

        $scope.activeScreen = screen;

        _RFC2.default.send('ConnectWeb ' + tab + ' Click');
    };

    $scope.faqs = ['dark_web', 'dark_web_monitoring', 'dark_web_assets', 'dark_web_notifications', 'identity_theft', 'dark_web_technology', 'stolen_wallet'];

    $scope.changeQuestion = function (question) {

        $scope.activeQuestion = question !== $scope.activeQuestion ? question : '';

        _RFC2.default.send('ConnectWeb DWM Upsell FAQ', {
            Question: question
        });
    };

    $scope.backToDashboard = function () {

        if ($rootScope.redirectFromTab === undefined || $rootScope.redirectFromTab === 'dwm') {

            $state.go('root.dashboard.dwm', {
                tab: 'dwm'
            });
        } else if ($rootScope.redirectFromTab === 'faq') {

            $state.go('root.dashboard.dwm', {
                tab: 'faq'
            });
        }
    };

    $document.on('scroll', function () {

        $scope.$apply(function () {

            $scope.hasFooterCookie = !_RFC6.default.get(CWCONFIG.cookie.cookiePolicy);

            var pageHeight = angular.element('div#dwm-upsell-v2')[0] && angular.element('div#dwm-upsell-v2')[0].offsetHeight;
            var headerHeight = angular.element('div#header')[0] && angular.element('div#header')[0].offsetHeight;
            var footerHeight = angular.element('div#cma-disclaimer')[0] && angular.element('div#cma-disclaimer')[0].offsetHeight;
            var bannerHeight = angular.element('div#sticky-banner')[0] && angular.element('div#sticky-banner')[0].offsetHeight;

            var minHeight = headerHeight - bannerHeight;
            var maxHeight = pageHeight - (footerHeight + bannerHeight);

            if ($window.scrollY > minHeight && $window.scrollY < maxHeight) {

                $scope.showStickyBanner = true;
            } else {

                $scope.showStickyBanner = false;
            }
        });
    });
};

var DwmStoreDirective = function DwmStoreDirective() {
    _classCallCheck(this, DwmStoreDirective);

    this.template = __webpack_require__("1irE");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $document, $window, $rootScope) {
        return new DwmStoreController($scope, $state, $document, $window, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DwmStoreCtrl';
};

_directiveDependencies.push(function () {
    return new DwmStoreDirective();
});

angular.module('directives').directive('dwmStore', _directiveDependencies);

/***/ }),

/***/ "6ZU/":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content large-modal-holder ocp-modal\">\n\n    <h1 class=\"text-xxl mb10\" connectqa-ocpmodal=\"title\">{{recommendedApp.attributes.name}}</h1>\n    <p class=\"text-m w50 m-auto text-grey-3\" translate=\"cw.ocp.isec_comparison_desc\" connectqa-ocpmodal=\"description\"></p>\n\n    <ul class=\"comparison-products\" connectqa-ocpmodal=\"comparison-table\">\n        <li class=\"title-bar\">\n            <h6></h6>\n            <p><strong>{{currentUserApp.attributes.name}}</strong></p>\n            <p><strong>{{recommendedApp.attributes.resource.oeName}}</strong></p>\n        </li>\n\n        <li ng-repeat=\"feature in recommendationAppFeatures[resourceId]\">\n            <h6 translate=\"{{'cw.ocp.' + feature}}\" translate-compile connectqa-ocpmodal=\"{{feature}}\"></h6>\n            <p>\n                <span class=\"missing-feature\" ng-show=\"!checkFeature(feature)\"></span>\n                <i class=\"icon icon-checked icon-xs text-green-1\" ng-show=\"checkFeature(feature)\"></i>\n            </p>\n            <p><i class=\"icon icon-checked icon-xs text-green-1\"></i></p>\n        </li>\n\n        <!-- <li>\n            <h6></h6>\n            <p><span class=\"text-grey-5\" translate=\"cw.ocp.current_plan\"></span></p>\n            <p ng-if=\"recommendationDetails[0].attributes.acronym === resourceId\">\n                <strong translate=\"cw.ocp.price_and_year\"\n                        translate-values=\" {price: recommendationDetails[0].attributes.total_price + ' ' +\n                                                   recommendationDetails[0].attributes.currency}\"></strong>\n                <br />\n                <span ng-if=\"recommendationDetails[0].attributes.pc_price\"\n                    class=\"text-strike text-grey-4\"\n                    translate=\"cw.ocp.price_and_year\"\n                    translate-values=\" {price: recommendationDetails[0].attributes.pc_price + ' ' +\n                                           recommendationDetails[0].attributes.currency}\"></span>\n            </p>\n            <p ng-if=\"recommendationDetails[0].attributes.acronym !== resourceId\" class=\"offer-prices\">\n                <app-price appid='resourceId + \"_12_1\"' showyearlabel=\"true\">\n                </app-price>\n            </p>\n        </li> -->\n    </ul>\n\n    <button translate=\"cw.general.ui.close\" ng-click=\"closeModal()\" class=\"btn btn-large btn-primary mt40\" connectqa-ocpmodal=\"upgrade-now-button\"></button>\n\n    <div class=\"ocp-awards\" connectqa-ocpmodal=\"awards\">\n        <span ng-if=\"language === 'de'\" class=\"icon-trustpilot-de mr10\"></span>\n        <span ng-if=\"!language\" class=\"icon-trustpilot-reviews mr10\"></span>\n        <span class=\"icon-av-comparatives mr10\"></span>\n        <span class=\"icon-av-lab mr10\"></span>\n        <span class=\"icon-top-product\"></span>\n    </div>\n</div>";
var path = 'views/modals/ocp-comparison.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "6fSb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$q', 'DeviceRestService', 'UserRestService', 'LicenseRestService', 'AppInstanceRestService', 'AppIntegrationRestService', 'ErrorHandler', 'Util', 'Auth', 'PaymentTypesRestService', 'ActivationCodeRestService', 'GdprActionsRestService', 'TransactionRestService', 'AppPricesRestService', 'FlexiblePromotionsRestService', 'RecommendationsRestService', '$http'];

/**
 * @ngdoc service
 * @name services.DashboardResolver
 *
 * @description
 * This class is the Dashboard Resolver.
 * Here we get all the dashboard resources needed for setup.
 */

var DashboardResolver = function () {

    /**
     * @param  {any} $rootScope
     * @param  {any} $q
     * @param  {any} DeviceRestService
     * @param  {any} UserRestService
     * @param  {any} LicenseRestService
     * @param  {any} AppInstanceRestService
     * @param  {any} AppIntegrationRestService
     * @param  {any} ErrorHandler
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} PaymentTypesRestService
     * @param  {any} ActivationCodeRestService
     * @param  {any} GdprActionsRestService
     * @param  {any} TransactionRestService
     * @param  {any} AppPricesRestService
     * @param  {any} FlexiblePromotionsRestService
     * @param  {any} RecommendationsRestService
     */

    function DashboardResolver($rootScope, $q, DeviceRestService, UserRestService, LicenseRestService, AppInstanceRestService, AppIntegrationRestService, ErrorHandler, Util, Auth, PaymentTypesRestService, ActivationCodeRestService, GdprActionsRestService, TransactionRestService, AppPricesRestService, FlexiblePromotionsRestService, RecommendationsRestService, $http) {
        _classCallCheck(this, DashboardResolver);

        this.$q = $q;
        this.$rootScope = $rootScope;
        this.ErrorHandler = ErrorHandler;
        this.Util = Util;
        this.Auth = Auth;
        this.$http = $http;

        // resoruces promises
        this.DeviceRestService = DeviceRestService;
        this.AppIntegrationRestService = AppIntegrationRestService;
        this.AppInstanceRestService = AppInstanceRestService;
        this.LicenseRestService = LicenseRestService;
        this.UserRestService = UserRestService;
        this.PaymentTypesRestService = PaymentTypesRestService;
        this.ActivationCodeRestService = ActivationCodeRestService;
        this.GdprActionsRestService = GdprActionsRestService;
        this.TransactionRestService = TransactionRestService;
        this.AppPricesRestService = AppPricesRestService;
        this.FlexiblePromotionsRestService = FlexiblePromotionsRestService;
        this.RecommendationsRestService = RecommendationsRestService;

        // repositories
        this.DevicesRepository = _index.DevicesRepository;
        this.AppInstancesRepository = _index.AppInstancesRepository;
        this.LicensesRepository = _index.LicensesRepository;
        this.UsersRepository = _index.UsersRepository;
        this.ActivationCodesRepository = _index.ActivationCodesRepository;
        this.GdprActionsRepository = _index.GdprActionsRepository;
        this.TransactionsRepository = _index.TransactionsRepository;
        this.AppPricesRepository = _index.AppPricesRepository;
        this.FlexiblePromotionsRepository = _index.FlexiblePromotionsRepository;
        this.ExpiredLicensesRepository = _index.ExpiredLicensesRepository;
        this.RecommendationsRepository = _index.RecommendationsRepository;
        this.dwmRepository = _index.dwmRepository;
    }

    _createClass(DashboardResolver, [{
        key: 'getDashboardResourcesPromise',
        value: function getDashboardResourcesPromise() {
            var _this = this;

            var dashboardPromise = this.$q.defer();

            // if the user doesn't have token, go to login
            if (!this.Util.getToken()) {

                dashboardPromise.reject();
                this.Auth.gotoLogin();
            } else if (this.Util.isAnonymous()) {

                dashboardPromise.reject();
                this.Auth.gotoRegister();
            } else {

                var appIntegrationsPromise = this.AppIntegrationRestService.getAllAsync();
                var usersPromise = this.UserRestService.getAllAsync();
                var paymentTypesPromise = this.PaymentTypesRestService.getAllAsync();
                var activationCodesPromise = this.ActivationCodeRestService.getAllAsync();
                var GdprActionsPromise = this.GdprActionsRestService.getAllAsync();
                var transactionsPromise = this.TransactionRestService.getAllAsync();
                var appPricesPromise = this.AppPricesRestService.getAllAsync();

                var aviraToken = this.Util.getToken();

                var aiaStatusApiPromise = this.$http({
                    method: 'POST',
                    url: CWCONFIG.dwm.statusURL,
                    headers: {
                        Authorization: 'Bearer ' + aviraToken
                    },
                    data: {
                        clientApplication: {
                            clientId: 'myavira'
                        }
                    }

                });

                var getAiaMonitorData = function getAiaMonitorData() {

                    _this.$http({
                        method: 'POST',
                        url: CWCONFIG.dwm.restApi + '/v1/auth/tokensByPartnerToken',
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            'Content-Type': 'application/json'
                        },
                        data: {
                            partner_token: aviraToken
                        }

                    }).then(function (response) {

                        _this.$http({
                            method: 'GET',
                            url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                            headers: {
                                client_id: 'avira',
                                origin: 'https://avira.com',
                                access_token: response.data.access_token,
                                'Content-Type': 'application/json'
                            }

                        }).then(function (membersResponse) {

                            if (_this.aiaSubscriptionActive) {

                                _this.dwmRepository.replace('assets', membersResponse.data);

                                var dwmCardStatus = membersResponse.data.primaryMember.dwmCardStatus;


                                if (dwmCardStatus === 'add-more-data') {

                                    _this.$rootScope.showDwmAddMoreDataCard = true;

                                    if (_this.$rootScope.noUnreadAlerts) {

                                        _this.$rootScope.showDwmCardHomepage = true;
                                    }
                                }
                            }
                        }).catch(function () {});

                        _this.$http({
                            method: 'GET',
                            url: CWCONFIG.dwm.restApi + '/v1/partner/alerts',
                            headers: {
                                client_id: 'avira',
                                origin: 'https://avira.com',
                                access_token: response.data.access_token,
                                'Content-Type': 'application/json',
                                lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US'
                            }

                        }).then(function (alertsResponse) {

                            _this.dwmRepository.replace('alerts', alertsResponse.data);

                            var aiaUnreadAlerts = 0;

                            if (alertsResponse.data.alertList.length > 0) {

                                alertsResponse.data.alertList.forEach(function (alert) {

                                    if (alert.isRead === false && alert.bucket === 'inbox') {

                                        aiaUnreadAlerts += 1;
                                    }
                                });
                            }

                            if (aiaUnreadAlerts > 0) {

                                _this.$rootScope.showDwmCardHomepage = true;
                                _this.$rootScope.showDwmUnreadNotificationsCard = true;
                                _this.$rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;
                            } else if (aiaUnreadAlerts === 0 && _this.dwmLiteSubscriptionUpsell || _this.$rootScope.showDwmAddMoreDataCard) {

                                _this.$rootScope.showDwmCardHomepage = true;
                            } else {

                                _this.$rootScope.noUnreadAlerts = true;
                            }
                        }).catch(function () {});
                    }).catch(function () {});
                };

                // below repos depend on appIntegrations to load first
                var devicesPromise = this.$q.defer();
                var appInstancesPromise = this.$q.defer();
                var licensesPromise = this.$q.defer();

                var usersPromiseQ = this.$q.defer();
                var paymentTypesPromiseQ = this.$q.defer();
                var activationCodesPromiseQ = this.$q.defer();
                var GdprActionsPromiseQ = this.$q.defer();
                var appPricesPromiseQ = this.$q.defer();
                var aiaStatusApiPromiseQ = this.$q.defer();

                // get aia status
                aiaStatusApiPromise.then(function (response) {

                    var dwmStatus = response.data || {};
                    _this.$rootScope.dwmStatus = dwmStatus;

                    // root.hideAIACardInFreeStore
                    var aiaTileAction = _this.Util.deepFind(dwmStatus, 'products.identityAssist.tileAction');
                    var dwmLiteTileAction = _this.Util.deepFind(_this.$rootScope.dwmStatus, 'products.dwmLite.tileAction');

                    if (aiaTileAction === 'openUpsell') {

                        _this.$rootScope.showAIACardInFreeStore = true;
                    }

                    if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                        _this.$rootScope.showAIAWelcomeOfferBanner = true;
                    } else {

                        _this.$rootScope.showAIAWelcomeOfferBanner = false;
                    }

                    var aiaStatus = _this.Util.deepFind(dwmStatus, 'products.identityAssist');
                    var dwmLiteStatus = _this.Util.deepFind(dwmStatus, 'products.dwmLite');

                    var aiaSubscriptionStatus = _this.Util.deepFind(dwmStatus, 'products.identityAssist.subscriptionStatus');
                    var dwmLiteSubscriptionStatus = _this.Util.deepFind(dwmStatus, 'products.dwmLite.subscriptionStatus');

                    var aiaSubscriptionCancelled = aiaSubscriptionStatus === 'cancelled' || aiaSubscriptionStatus === 'none';
                    _this.aiaSubscriptionActive = aiaSubscriptionStatus === 'active';
                    var dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';
                    _this.dwmLiteSubscriptionUpsell = dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';
                    _this.dwmLiteSubscriptionActive = dwmLiteSubscriptionStatus === 'active';

                    if ((aiaStatus || dwmLiteStatus) && (aiaSubscriptionCancelled || dwmLiteSubscriptionCancelled)) {

                        _this.$rootScope.showDwmCardHomepage = true;
                    } else {

                        _this.$rootScope.showDwmCardHomepage = false;
                    }

                    _this.dwmRepository.replace('statusApi', dwmStatus);

                    if (aiaStatus || dwmLiteStatus) {

                        _this.$rootScope.showDwmLeftNavigation = true;
                    }

                    if (_this.aiaSubscriptionActive || _this.dwmLiteSubscriptionActive) {

                        getAiaMonitorData();
                    }

                    _this.$rootScope.dwmStatusLoaded = true;

                    aiaStatusApiPromiseQ.resolve();
                }).catch(function () {

                    _this.$rootScope.showDwmLeftNavigation = false;
                    _this.$rootScope.dwmStatusLoaded = true;
                    aiaStatusApiPromiseQ.resolve();
                });

                // get app integrations
                appIntegrationsPromise.then(function (response) {

                    _index.AppIntegrationsRepository.replace(response.data.data, response.data.included);

                    // get app instances
                    _this.AppInstanceRestService.getAllAsync().then(function (responseValue) {

                        _this.AppInstancesRepository.replace(responseValue.data.data);
                        appInstancesPromise.resolve();
                    });

                    // get licenses
                    _this.LicenseRestService.getAllAsync().then(function (responseValue) {

                        _this.LicensesRepository.replace(responseValue.data.data);
                        // save also all the expired licenses
                        _this.ExpiredLicensesRepository.replace(responseValue.data.data);
                        licensesPromise.resolve();
                    });

                    // get devices
                    _this.DeviceRestService.getAllAsync().then(function (responseValue) {

                        _this.DevicesRepository.replace(responseValue.data.data);
                        devicesPromise.resolve();
                    });
                });

                usersPromise.then(function (response) {

                    _this.UsersRepository.replace(response.data.data);
                    usersPromiseQ.resolve();
                });

                paymentTypesPromise.then(function (response) {

                    _index.PaymentTypesRepository.replace(response.data.data);
                    paymentTypesPromiseQ.resolve();
                });

                activationCodesPromise.then(function (response) {

                    _this.ActivationCodesRepository.replace(response.data.data);

                    var activationCodes = _this.ActivationCodesRepository.getAll() || [];
                    activationCodes.forEach(function (activationCode) {

                        if (activationCode.attributes.promotion_id) {

                            _this.FlexiblePromotionsRestService.getPromotionById(activationCode.attributes.promotion_id).then(function (promotionResponse) {

                                var promotionResponseArray = [];

                                promotionResponseArray.push(promotionResponse.data.data);

                                _this.FlexiblePromotionsRepository.add(promotionResponseArray);
                            });
                        }
                    });

                    if (activationCodes.length > 0) {

                        _this.RecommendationsRestService.getAllAsync().then(function (responseValue) {

                            _this.RecommendationsRepository.replace(responseValue.data.data);
                        });
                    }

                    activationCodesPromiseQ.resolve();
                });

                GdprActionsPromise.then(function (response) {

                    _this.GdprActionsRepository.replace(response.data.data);
                    GdprActionsPromiseQ.resolve();
                });

                transactionsPromise.then(function (response) {

                    _this.TransactionsRepository.replace(response.data.data);
                });

                // 97% off av campaign
                // const user = MeRepository.getMyUser();
                // const userRegistrationDate = this.Util.deepFind(user, 'attributes.date_registered');
                // const campaignBreakpoint = this.Util.deepFind(CWCONFIG,
                // 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;
                // const today = moment();
                // const registrtionDate = moment(userRegistrationDate);
                // const accountDays =
                //     parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;
                // end 97% off av campaign

                // App prices and promotions get
                appPricesPromise.then(function (prices) {

                    var promotionsPromises = [];
                    var promotionsResponses = [];

                    _this.AppPricesRepository.replace(prices.data.data);

                    var promotions = CWCONFIG.flexiblePromotions;

                    promotions.forEach(function (promotion) {

                        // this.$rootScope.showFreeStorePromotionDisclaimer = true;

                        // 97% off av campaign
                        // if (accountDays <= campaignBreakpoint) {

                        //     if (promotion.product !== 'aapd5') {

                        //         promotionsPromises
                        //             .push(this.FlexiblePromotionsRestService.
                        // getPromotion(promotion));

                        //     }

                        // } else {

                        //     this.$rootScope.showFreeStorePromotionDisclaimer = true;
                        //     promotionsPromises
                        //         .push(this.FlexiblePromotionsRestService.getPromotion(promotion));

                        // }
                        // end 97% off av campaign

                        promotionsPromises.push(_this.FlexiblePromotionsRestService.getPromotion(promotion));
                    });

                    //* Promotional Campaign : get first year prices CMA disclaimer
                    //* To be commented when the campaign is over
                    // this.$rootScope.firstYearPrices = {};
                    // const firstYearPricePromotionAntivirus = {
                    //     type: 'public',
                    //     source: 'cd',
                    //     purchaseType: 'new',
                    //     country: 'All',
                    //     product: 'aapd5',
                    //     runtime: 12,
                    //     devices: 1,
                    // };

                    // const firstYearPricePromotionAIA = {
                    //     type: 'public',
                    //     source: 'cd',
                    //     purchaseType: 'new',
                    //     country: 'All',
                    //     product: 'adwp1',
                    //     runtime: 12,
                    //     devices: 1,
                    // };

                    // const firstYearPricePromotionPrime5 = {
                    //     type: 'public',
                    //     source: 'cd',
                    //     purchaseType: 'new',
                    //     country: 'All',
                    //     product: 'aps10',
                    //     runtime: 12,
                    //     devices: 1,
                    // };

                    // const firstYearPricePromotionPrime25 = {
                    //     type: 'public',
                    //     source: 'cd',
                    //     purchaseType: 'new',
                    //     country: 'All',
                    //     product: 'aps20',
                    //     runtime: 12,
                    //     devices: 1,
                    // };

                    // this.FlexiblePromotionsRestService
                    //     .getPromotion(firstYearPricePromotionAntivirus).then((response) => {

                    //         [this.$rootScope.firstYearPrices.aapd5] = response.data.data;

                    //     });

                    // this.FlexiblePromotionsRestService
                    //     .getPromotion(firstYearPricePromotionAIA).then((response) => {

                    //         [this.$rootScope.firstYearPrices.adwp1] = response.data.data;

                    //     });

                    // this.FlexiblePromotionsRestService
                    //     .getPromotion(firstYearPricePromotionPrime5).then((response) => {

                    //         [this.$rootScope.firstYearPrices.aps10] = response.data.data;

                    //     });

                    // this.FlexiblePromotionsRestService
                    //     .getPromotion(firstYearPricePromotionPrime25).then((response) => {

                    //         [this.$rootScope.firstYearPrices.aps20] = response.data.data;

                    //     });

                    Promise.allSettled = function (promises) {

                        var mappedPromises = promises.map(function (p) {
                            return p.then(function (value) {
                                return {
                                    status: 'fulfilled',
                                    value: value
                                };
                            }).catch(function (reason) {
                                return {
                                    status: 'rejected',
                                    reason: reason
                                };
                            });
                        });
                        return Promise.all(mappedPromises);
                    };

                    Promise.allSettled(promotionsPromises).then(function (results) {

                        results.forEach(function (result) {

                            if (result.status === 'fulfilled') {

                                promotionsResponses = promotionsResponses.concat(result.value.data.data);
                            }
                        });

                        _this.FlexiblePromotionsRepository.add(promotionsResponses);
                    });

                    appPricesPromiseQ.resolve();
                });

                // wait for all resources to be loaded
                this.$q.all([devicesPromise.promise, appIntegrationsPromise, appInstancesPromise.promise, licensesPromise.promise, usersPromiseQ.promise, paymentTypesPromiseQ.promise, activationCodesPromiseQ.promise, GdprActionsPromiseQ.promise, appPricesPromiseQ.promise, aiaStatusApiPromiseQ.promise]).then(function () {

                    // resolve promise and hide dashboard loading state
                    dashboardPromise.resolve();
                }).catch(function (error) {

                    var errorLocation = 'Dashboard Resolver';

                    dashboardPromise.reject();
                    _this.ErrorHandler.handleError(error, errorLocation);
                });
            }

            return dashboardPromise.promise;
        }
    }]);

    return DashboardResolver;
}();

_serviceDependencies.push(DashboardResolver);

angular.module('services').service('DashboardResolver', _serviceDependencies);

/***/ }),

/***/ "6yWV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint vars-on-top: 0 */


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', '$rootScope', '$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.DeleteAccountController
 *
 * @description
 * edit form for user details controller
 */

var DeleteAccountController = function () {
    function DeleteAccountController($state, $rootScope, $scope) {
        _classCallCheck(this, DeleteAccountController);

        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$scope.deleteAccountVerificationPassed = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
    }

    _createClass(DeleteAccountController, [{
        key: 'deleteAccount',
        value: function deleteAccount() {

            _RFC2.default.send('ConnectWeb Delete Account Click');

            this.$state.go('root.dashboard.my-account.ltb', {
                ltb: 'delete-account-confirmation'
            });
        }
    }]);

    return DeleteAccountController;
}();

/**
 * @ngdoc directive
 * @name directives.DeleteAccountDirective
 *
 * @description
 * edit form for user details directive
 */


var DeleteAccountDirective = function DeleteAccountDirective() {
    _classCallCheck(this, DeleteAccountDirective);

    this.template = __webpack_require__("q8ap");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($state, $rootScope, $scope) {
        return new DeleteAccountController($state, $rootScope, $scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'deleteAccountCtrl';
};

_directiveDependencies.push(function () {
    return new DeleteAccountDirective();
});

angular.module('directives').directive('deleteAccount', _directiveDependencies);

/***/ }),

/***/ "719l":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("Hz9n"),
    hashDelete = __webpack_require__("MFCq"),
    hashGet = __webpack_require__("xsvA"),
    hashHas = __webpack_require__("aELU"),
    hashSet = __webpack_require__("ubfM");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "73RG":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"mb10 ml20\" translate=\"cw.password_validation.title\"></div>\n\n    <div class=\"text-s\" pass-strength-length>\n        <span class=\"icon-circle mr5\" ng-show=\"!passlength || passlength < 8\" pass-strength-length=\"unchecked\"></span>\n        <span class=\"icon icon-xxxs icon-checkmark inline-block icon-green-3 mr5\" ng-show=\"passlength > 7\" pass-strength-length=\"checked\"></span>\n        <span class=\"inline-block\" translate=\"cw.password_validation.character_count\"></span>\n    </div>\n    <div class=\"text-s\" pass-strength-number>\n        <span class=\"icon-circle mr5\" ng-show=\"!passwordscore.containsNumber\" pass-strength-number=\"unchecked\"></span>\n        <span class=\"icon icon-xxxs icon-checkmark inline-block icon-green-3 mr5\" ng-show=\"passwordscore.containsNumber\" pass-strength-number=\"checked\"></span>\n        <span class=\"inline-block\" translate=\"cw.password_validation.contains_numbers\"></span>\n    </div>\n    <div class=\"text-s\" pass-strength-uppercase>\n        <span class=\"icon-circle mr5\" ng-show=\"!passwordscore.containsUppercase\" pass-strength-uppercase=\"unchecked\"></span>\n        <span class=\"icon icon-xxxs icon-checkmark inline-block icon-green-3 mr5\" ng-show=\"passwordscore.containsUppercase\" pass-strength-uppercase=\"checked\"></span>\n        <span class=\"inline-block\" translate=\"cw.password_validation.contains_uppercase\"></span>\n    </div>\n    <div class=\"text-s\" pass-strength-words>\n        <span class=\"icon-circle mr5\" ng-show=\"!passwordscore.value || passwordscore.value === 0\" pass-strength-words=\"unchecked\"></span>\n        <span class=\"icon icon-xxxs icon-checkmark inline-block icon-green-3 mr5\"\n              ng-show=\"passwordscore.value && passwordscore.value !== 0\" pass-strength-words=\"checked\"></span>\n        <span class=\"inline-block\" translate=\"cw.password_validation.common_words\"></span>\n    </div>\n\n    <div class=\"password-strength\" pass-strength=\"rating\">\n        <div class=\"strength-bar\" ng-class=\"{\n            'default': !passlength,\n            'weak': passlength && (!passpattern || (passwordscore.value === 0 && passpattern)),\n            'fair': passlength && (passwordscore.value === 1 || passwordscore.value === 2) && passpattern,\n            'good': passlength && (passwordscore.value === 3 || passwordscore.value === 4) && passpattern }\">\n\n            <span class=\"text-default\" translate=\"cw.auth.password.strength\"></span>\n            <span class=\"text-weak\" translate=\"cw.auth.password.weak\" pass-strength=\"weak\"></span>\n            <span class=\"text-fair\" translate=\"cw.auth.password.fair\" pass-strength=\"fair\"></span>\n            <span class=\"text-good\" translate=\"cw.auth.password.good\" pass-strength=\"good\"></span>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "7RjL":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"card-header\">\n        <h3 class=\"text-grey-1 text-l font-bold\" translate=\"cw.section.support.title\"></h3>\n    </div>\n    <div class=\"inline-block left-column text-center v-middle\">\n        <div class=\"support-graphic\"></div>\n    </div>\n    <div class=\"inline-block right-column v-middle\">\n        <h4 class=\"text-m text-grey-1 mb5\" translate=\"cw.homepage.support.content.title\"></h4>\n        <p class=\"text-s text-grey-3\" translate=\"cw.homepage.support.content.desc\" translate-values=\"{brandname: brandName}\"></p>\n        <div class=\"text-right mt5\">\n            <a ui-sref=\"root.dashboard.support({tab: 'support'})\" \n            class=\"text-s text-blue-1 bottom-link\"\n            translate=\"cw.homepage.general.see_more\"\n            ng-click=\"sendSupportMixpanel('See more')\"></a>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "7XHk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment, _) {

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

var _RFCSession = __webpack_require__("DyxV");

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
/* eslint max-len: 0 */

angular.module('controllers').controller('DashboardNavigation', ['$scope', '$state', '$stateParams', '$rootScope', 'Util', '$window', function ($scope, $state, $stateParams, $rootScope, Util, $window) {
    var _CWCONFIG = CWCONFIG,
        sidebarServices = _CWCONFIG.sidebarServices;
    var freeSupport = CWCONFIG.partnerConfig.support.freeSupport;

    var serviceIdFromParam = $state.params.resourceId;
    var currentDateInMiliseconds = new Date().getTime();
    var lang = CWCONFIG.language;
    $scope.visiblePages = CWCONFIG.partnerConfig.pages;

    $rootScope.activeNavSection = window.activeNavSection;

    $rootScope.activeNavSection = window.activeNavSection;

    $scope.referralCode = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ReferralCode) || '';

    if (localStorage.getItem('theme') === 'dark') {

        $scope.darkModeActivated = true;
    } else {

        $scope.darkModeActivated = false;
    }

    // get variant value from 'AB Test Subscriptions Expire Banner'
    $scope.expireBannerVariant = localStorage.getItem('ExpireBannerVariant');

    /**
    * Check if news are available
    */
    var blogLanguages = CWCONFIG.news.languages;
    var isAvailable = blogLanguages.find(function (language) {
        return language === lang;
    });
    if (isAvailable) {

        $scope.newsAvailable = true;
    } else {

        $scope.newsAvailable = false;
        $scope.blogURL = 'https://www.avira.com/en/blog/';
    }

    /**
    * Check if how-to category is avalable, if not set threats category default
    */
    if (lang === 'en' || lang === 'de') {

        $scope.availableNewsCategory = 'how-to';
    } else if (lang === 'fr' || lang === 'it') {

        $scope.availableNewsCategory = 'threats';
    }

    if (lang === 'en') {

        $scope.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, 'en-us');
    } else {

        $scope.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, lang);
    }

    var activationCodesRepo = _index.ActivationCodesRepository.getAll();
    var licensesRepo = _index.LicensesRepository.getAll();

    // hide store and exclusive offer tab if user has an TP link licence
    $scope.hasTPLinkLicence = _index.ActivationCodesRepository.hasTPLinkLicence();

    var _ref = CWCONFIG || [],
        primeAppIds = _ref.primeAppIds;

    var userHasSubscriptions = activationCodesRepo.length > 0 || licensesRepo.length > 0;

    $scope.showPrimePage = false;

    if (userHasSubscriptions) {

        $scope.showPrimePage = true;

        // if the user has aps20 with runtime 36 dont show prime page
        activationCodesRepo.forEach(function (activationCode) {

            if (activationCode.attributes.app === 'aps20' && activationCode.attributes.runtime === 36) {

                $scope.showPrimePage = false;
            }
        });
    }

    var subjectActivationCodesRepository = _index.ActivationCodesRepository.getObservable();
    subjectActivationCodesRepository.subscribe(function (data) {
        return onNext(data);
    }, function () {}, function () {});

    var subjectLicenseRepository = _index.LicensesRepository.getObservable();
    subjectLicenseRepository.subscribe(function (data) {
        return onNextLicenses(data);
    }, function () {}, function () {});

    // Scrollbar
    $scope.scrollTop = 0;
    $scope.onScroll = function (scrollTop) {

        $scope.scrollTop = scrollTop;
    };

    function onNext(data) {

        var activationCodes = data;
        var expiringActivationCodes = [];
        $scope.showWarning = false;
        // Don't redirect the user to the subscriptions page if other subscriptions are expiring.
        // (redirect the user only if auto-renewal for Prime is OFF)
        $scope.hasActivePrime = _index.ActivationCodesRepository.hasActivePrime();

        if (activationCodes.length > 0) {

            $scope.supportForPaidUsers = true;
        }

        activationCodes.forEach(function (activationCode) {

            var expireNotificationDays = getExpireNotificationDays(activationCode);
            var appId = activationCode.relationships.app.data.id;

            // Find expiring licenses
            var expirationDate = activationCode.attributes.date_expire;
            if (expirationDate) {

                var subscriptionExpirationDateInMs = moment(expirationDate).valueOf();
                var remainingDaysUntilExpiration = Math.ceil(moment.duration(subscriptionExpirationDateInMs - currentDateInMiliseconds).asDays());

                if (remainingDaysUntilExpiration <= expireNotificationDays && activationCode.attributes.subscription === 0 && !Util.isNonrenewableApp(appId) && !$scope.hasActivePrime) {

                    $scope.showWarning = true;

                    var appName = _index.AppIntegrationsRepository.getById(Util.deepFind(activationCode, 'relationships.app.data.id'));

                    expiringActivationCodes.push(Util.deepFind(appName, 'attributes.resource.oeName'));
                }
            }
        });

        // Send mixpanel event if there is at least one expiring license
        if (expiringActivationCodes.length) {

            // redirect to subscriptions page
            if (expiringActivationCodes.length === activationCodes.length) {

                if (!$rootScope.redirectedToSubscriptions && $state.current.name.indexOf('.print-gdpr-report') === -1) {

                    if ($state.current.name !== 'root.dashboard.subscriptions.ltb') {

                        $rootScope.redirectedToSubscriptions = true;

                        $state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        }).then(function () {

                            // Hide the warning icon when the current page is subscriptions
                            $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;
                        });
                    }
                }
            }

            _RFC2.default.send('Subscription Expire Notification', {
                'Paid Products List': expiringActivationCodes.sort().join()
            });
        }
    }

    function onNextLicenses(data) {

        var licenses = data.filter(function (license) {
            return Util.deepFind(license, 'attributes.type') === 'eval';
        });
        // Don't redirect the user to the subscriptions page if other subscriptions are expiring.
        // (redirect the user only if auto-renewal for Prime is OFF)
        $scope.hasActivePrime = _index.ActivationCodesRepository.hasActivePrime();
        $scope.showWarningTrial = false;
        var expiringLicenses = [];
        var primeTrials = licenses.find(function (license) {
            return primeAppIds.indexOf(Util.deepFind(license, 'relationships.app.data.id')) > -1;
        });

        // find expiring licenses
        licenses.forEach(function (license) {

            var expirationDate = license.attributes.expiration_date;
            var expireNotificationDays = getExpireNotificationDays(license);

            if (expirationDate) {

                var subscriptionExpirationDateInMs = moment(expirationDate).valueOf();
                var remainingDaysUntilExpiration = Math.ceil(moment.duration(subscriptionExpirationDateInMs - currentDateInMiliseconds).asDays());

                if (remainingDaysUntilExpiration <= expireNotificationDays && license.attributes.subscription === 0 && !$scope.hasActivePrime) {

                    $scope.showWarningTrial = true;

                    var appName = _index.AppIntegrationsRepository.getById(Util.deepFind(license, 'relationships.app.data.id'));
                    var appId = Util.deepFind(license, 'relationships.app.data.id');
                    if (primeAppIds.indexOf(appId) === -1 && primeTrials) {

                        $scope.showWarningTrial = false;
                    }
                    expiringLicenses.push(Util.deepFind(appName, 'attributes.resource.oeName'));

                    // prevent multiple redirects to subscriptions page
                    if (!$rootScope.redirectedToSubscriptions) {

                        if ($state.current.name !== 'root.dashboard.subscriptions.ltb' && $scope.showWarningTrial) {

                            $rootScope.redirectedToSubscriptions = true;
                            $state.go('root.dashboard.subscriptions', {
                                tab: 'plans'
                            }).then(function () {

                                // Hide the warning icon when the current page is subscriptions
                                $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;
                            });
                        }
                    }
                }
            }

            return $scope.showWarningTrial;
        });

        // Send mixpanel event if there is at least one expiring trial
        if (expiringLicenses.length) {

            _RFC2.default.send('Subscription Expire Notification', {
                'Trial Products List': expiringLicenses.sort().join()
            });
        }
    }

    // return the number of days to notify users that their subscription will expire based
    // param {obj} activationCode || license

    function getExpireNotificationDays(data) {

        var monthlyExpireNotificationDays = CWCONFIG.monthlySubscriptionExpirationReminderDays || 20;
        var annualExpireNotificationDays = CWCONFIG.annualSubscriptionExpirationReminderDays || 60;
        var annualSubscriptionTypes = ['annual', 'annual-trial', 'yearly'];
        var isAnnualSubscription = false;

        if (annualSubscriptionTypes.indexOf(data.attributes.subscription_type) > -1) {

            if (data.attributes.type === 'eval' && (data.attributes.runtime_unit === 'months' && data.attributes.runtime <= 1 || data.attributes.runtime_unit === 'days' && data.attributes.runtime <= 30)) {

                isAnnualSubscription = false;
            } else {

                isAnnualSubscription = true;
            }
        }

        return isAnnualSubscription ? annualExpireNotificationDays : monthlyExpireNotificationDays;
    }

    $scope.browserName = $window.browserName.toLowerCase();
    $scope.betaMode = CWCONFIG.betaMode;
    $scope.currentStateName = $state.current.name;
    $scope.currentResourceId = $state.params.resourceId;

    /* getServiceById looks through sidebar services which are located in the config file
    and returns the whole service object */
    var getServiceById = function getServiceById(serviceId) {

        var service = _.findWhere(sidebarServices, { id: serviceId });

        return service;
    };

    // highlight in the navigation bar which service was selected
    // (ex: finantz blick or family locator)
    var setSelectedService = function setSelectedService(serviceId) {

        var service = getServiceById(serviceId) || {};

        $scope.selectedServiceId = service.id;
    };
    setSelectedService(serviceIdFromParam);

    $scope.$on('$stateChangeSuccess', function () {

        $scope.currentStateName = $state.current.name;
        $scope.currentResourceId = $state.params.resourceId;
        $rootScope.showMobileMenu = false;
    });

    /**
     * Handler for clicking on a tab.
     * @param {string} tabName The name of the clicked tab: 'securityApps',
     * 'devices', 'store'
     */
    $scope.onClickMenu = function (tabName) {

        $scope.content = tabName;
        $rootScope.showMobileMenu = false;
        $rootScope.mobileMenuAttribute = 'open-mobile-menu';
        $rootScope.redirectedToSubscriptions = true;
        $rootScope.activeNavSection = '';
        setTimeout(function () {

            // Hide the warning icon when the current page is subscriptions
            $scope.isSubscriptionsPage = $state.current.name.indexOf('.subscriptions') > -1;
        }, 0);

        /* mixpanel events */
        switch (tabName) {

            case 'devices':
                _RFC2.default.send('ConnectWeb Sidebar Devices Click');
                break;
            case 'freeProducts':
                _RFC2.default.send('ConnectWeb Sidebar Free Products Click');
                break;
            case 'store':
                _RFC2.default.send('ConnectWeb Sidebar Store Click');
                break;
            case 'subscriptions':
                _RFC2.default.send('ConnectWeb Sidebar Subscriptions Click');
                break;
            case 'home':
                _RFC2.default.send('ConnectWeb Sidebar Dashboard');
                break;
            case 'support':
                _RFC2.default.send('ConnectWeb Sidebar Support Click');
                break;
            case 'news':
                _RFC2.default.send('ConnectWeb Sidebar News Click');
                break;
            case 'aia':
                _RFC2.default.send('ConnectWeb Sidebar AIA Click');
                break;
            case 'renewal':
                _RFC2.default.send('ConnectWeb Sidebar Renewal Settings Click');
                $rootScope.activeNavSection = 'renewal';
                break;
            default:
                break;

        }

        var newsPages = _index.NewsRepository.getPageNumber();
        $scope.newsCurrentPage = newsPages.threats;
    };

    $rootScope.cookieBannerHeight = { 'padding-bottom': angular.element('.bottom-page-notification').outerHeight() + 8 + 'px' };

    if (window.matchMedia) {

        window.matchMedia('(prefers-color-scheme: dark)').addListener(function (e) {

            if (e.matches) {

                $rootScope.State.theme = 'dark';
                $scope.currentTheme = 'dark';
                $scope.darkModeActivated = true;
            } else {

                $rootScope.State.theme = 'light';
                $scope.currentTheme = 'light';
                $scope.darkModeActivated = false;
            }

            if ($state.current.name.indexOf('.print-gdpr-report') === -1) {

                $rootScope.$apply();
            }
        });
    }

    $scope.changeTheme = function () {

        var color = void 0;
        if ($scope.darkModeActivated) {

            $scope.darkModeActivated = false;
            color = 'light';
        } else {

            $scope.darkModeActivated = true;
            color = 'dark';
        }

        localStorage.setItem('theme', color);

        if (localStorage.getItem('theme') === 'dark') {

            $rootScope.State.theme = 'dark';
            $scope.currentTheme = 'dark';
            _RFC2.default.setCommonProperty('Theme', 'Dark');
        } else {

            $rootScope.State.theme = 'light';
            $scope.currentTheme = 'light';
            _RFC2.default.setCommonProperty('Theme', 'Light');
        }

        _RFC2.default.send('ConnectWeb Theme Select Click', {
            Label: color
        });
    };

    $scope.onClickLogo = function () {

        _RFC2.default.send('ConnectWeb Sidebar Logo Click');
    };

    $scope.onClickFeedback = function () {

        _RFC2.default.send('ConnectWeb Sidebar Feedback Click');
        $rootScope.showMobileMenu = false;
    };

    $scope.onClickPrevVersion = function () {

        _RFC2.default.send('ConnectWeb Sidebar Old Dashboard Click');
        $rootScope.showMobileMenu = false;
    };

    $scope.onClickMenuApp = function (appId) {

        var app = _index.AppIntegrationsRepository.getById(appId);

        var appName = Util.deepFind(app, 'attributes.resource.oeName');

        _RFC2.default.send('ConnectWeb Sidebar ' + appName + ' Click');

        window.open(app.attributes.custom.manifest.product_url, '_blank');
    };

    $scope.productName = Util.deepFind(_index.AppIntegrationsRepository.getById('pass1'), 'attributes.resource.oeName');

    _RFC4.default.subscribe('user-menu:clicked', function () {

        $scope.onClickMenu('user-menu');
    });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI"), __webpack_require__("lQta")))

/***/ }),

/***/ "7Zib":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "7jJu":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("Qkpc"),
    getValue = __webpack_require__("+Z+8");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "7onk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _cryptoData = {};
var _rigs = [];

var observableCryptoData = new Rx.BehaviorSubject(_cryptoData);
var observableRigs = new Rx.BehaviorSubject(_rigs);

var CryptoRepository = {
    getAll: function getAll(key) {

        return key ? _cryptoData[key] : _cryptoData;
    },
    replaceRigs: function replaceRigs(data) {

        if (data) {

            _rigs = data;
        }

        observableRigs.onNext(_rigs);
    },
    getAllRigs: function getAllRigs() {

        return _rigs;
    },
    replace: function replace(key, data) {

        if (key) {

            _cryptoData[key] = data;
        }

        observableCryptoData.onNext(_cryptoData);
    },
    getObservable: function getObservable() {

        return observableCryptoData;
    },
    getObservableRigs: function getObservableRigs() {

        return observableRigs;
    }
};

exports.default = CryptoRepository;

/***/ }),

/***/ "7roQ":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "7tCK":
/***/ (function(module, exports) {

module.exports = "<div class=\"centerVert\">\n    <div class=\"info-usr settings crs-pointer\" ng-class=\"{'without-picture': !userInfoCtrl.User.attributes.profile_image_medium}\">\n\n        <div class=\"centerVert\" ng-click=\"userInfoCtrl.changePicture();\">\n            <!-- User name / email -->\n            <div class=\"info-holder-usr\">\n                <h6 class=\"text-m title-header text-shadowLight text-left\" connectqa-settings=\"username\">\n                    <span ng-if=\"userInfoCtrl.User.id\">\n                        <a title=\"{{userInfoCtrl.User | friendName}}\" class=\"user-email crs-pointer text-grey-2\">\n                            {{userInfoCtrl.User | friendName}}\n                        </a>\n                    </span>\n                </h6>\n            </div>\n\n            <!-- User Photo -->\n            <div class=\"pic-holder-usr\">\n                <a class=\"profile-image text-m text-white crs-pointer\" connectqa-settings=\"profile-image\">\n                    <span ng-if=\"!userInfoCtrl.User.attributes.profile_image_medium\" class=\"icon my-account-2 icon-grey-2 icon-xxs\"></span>\n                    <span class=\"image-hld\" ng-if=\"userInfoCtrl.User.attributes.profile_image_medium\">\n                        <img src=\"{{userInfoCtrl.User.attributes.profile_image_medium}}\" alt=\"{{ userInfoCtrl.User | friendName }}\" />\n                    </span>\n                </a>\n            </div>\n        </div>\n\n         <!--User Settings-->\n         <user-settings></user-settings>\n    </div>\n</div>\n"

/***/ }),

/***/ "8+/4":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("v3EM");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "84dZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _googleLibphonenumber = __webpack_require__("gFvG");

var i18n = _interopRequireWildcard(_googleLibphonenumber);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

angular.module('filters').filter('formatPhoneNumber', function () {
    return function (input, regionCode) {

        var phoneUtil = void 0;
        var number = void 0;

        if (input) {

            phoneUtil = i18n.PhoneNumberUtil.getInstance();
            number = phoneUtil.parseAndKeepRawInput(input);

            if (!regionCode) {

                regionCode = phoneUtil.getRegionCodeForNumber(number);
            }

            return phoneUtil.formatOutOfCountryCallingNumber(number, regionCode);
        }

        return input;
    };
});

/***/ }),

/***/ "8E7j":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("Hnr2"),
    isArguments = __webpack_require__("Qziv"),
    isArray = __webpack_require__("zOp4"),
    isIndex = __webpack_require__("U8js"),
    isLength = __webpack_require__("mL1V"),
    toKey = __webpack_require__("4dmE");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "8ILr":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content gdpr-report\"\n    ng-class=\"{'modal-large-width' : hasReport}\">\n    <div ng-if=\"$root.gdprReportsLoading\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"hasReport && !$root.gdprReportsLoading\">\n        <div class=\"text-left modal-header mb30\">\n            <div class='text-left'>\n            <h2 class=\"text-xl text-grey-1 mt0\"\n                translate=\"cw.my_account.data_settings.gdpr_modal.title_2\" translate-values=\"{brandname : brandName}\"></h2>\n            <p class=\"text-m text-grey-3 mt0\" translate=\"cw.my_account.data_settings.gdpr_modal.user_report_date\"\n                translate-values='{ date: gdprReportTimestamp }'></p>\n            </div>\n            <a\n                class=\"btn btn-medium btn-secondary spin-loader printer-button\"\n                ng-click=\"print()\"\n                translate=\"cw.my_account.data_settings.gdpr_modal.print_report\"\n                target=\"_blank\"\n                href=\"/en/dashboard/print-gdpr-report\">\n            </a>\n        </div>\n        <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n            <div ng-repeat=\"report in finalReport\" class='report-wrapper'>\n                <div ng-repeat=\"singleReport in report\">\n                    <div class=\"text-left report-category\">\n                        <h3 class=\"text-m text-grey-1 mt0 mb0\">\n                            {{singleReport.key}}\n                        </h3>\n                        <div class=\"toggle-wrapper opened\">\n                            <div ng-repeat=\"value in singleReport.value\" class=\"mb25 inline-block w50 v-top\">\n                                <p ng-repeat=\"(key, value) in value\" class=\"text-s text-grey-3\">\n                                    <span class='font-bold inline-block v-middle'>{{key}}</span> : <span class='v-middle inline-block'>{{value}}</span>\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"!hasReport && !$root.gdprReportsLoading\">\n        <h2 class=\"text-xl text-grey-1 mt0 mb10\"\n            translate=\"cw.my_account.data_settings.gdpr_modal.report_expired_title\"></h2>\n        <p class=\"text-m text-grey-3 mt0 mb30\"\n            translate=\"cw.my_account.data_settings.gdpr_modal.report_expired_desc\"></p>\n        <button\n            class=\"btn btn-large btn-primary mb0 mt5 spin-loader\"\n            ng-click=\"getReport()\"\n            ng-disabled=\"loading\"\n            translate=\"cw.general.get_report\">\n        </button>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/gdpr-report/gdpr-report.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "8S8G":
/***/ (function(module, exports) {

module.exports = "<div class=\"tab-content\">\n    <div class=\"crypto-card-header display-flex justify-content-space-between align-item-center\">\n        <div class=\"w100\">\n            <i class=\"icon icon-crypto-eth-round inline-block large-icon\"></i>\n            <h2 class=\"inline-block v-middle text-grey-1\" translate=\"cw.dashboard.crypto.transactions.title\">\n            </h2>\n        </div>\n    </div>\n    <div class=\"loader-wrapper\" ng-if=\"txHistoryIsLoading\">\n        <div class=\"main-loader\"></div>\n    </div>\n    <div ng-if=\"!txHistoryIsLoading\">\n        <p class=\"text-xxl text-grey-3 mt40\" ng-if=\"transactions.length === 0\" translate=\"cw.dashboard.crypto.transactions.no_transactions\"></p>\n        <div class=\"table-wrapper\">\n            <table class=\"mt20\" ng-if=\"transactions.length > 0\">\n                <thead>\n                    <tr>\n                        <td class=\"text-grey-2 text-l font-bold uppercase\" translate=\"cw.dashboard.crypto.transactions.past_transactions\"></td>\n                        <td class=\"text-grey-2 text-l font-bold uppercase\" translate=\"cw.dashboard.crypto.transactions.date\"></td>\n                        <td class=\"text-grey-2 text-l font-bold uppercase\" translate=\"cw.dashboard.crypto.transactions.type\"></td>\n                        <td class=\"text-grey-2 text-l font-bold uppercase\" translate=\"cw.dashboard.crypto.transactions.amount\"></td>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr ng-repeat=\"transaction in transactions\">\n                        <td class=\"text-grey-3 text-m\">\n                            <i class=\"icon-payment-{{transaction.direction.toLowerCase()}}\">\n                                <span ng-if=\"transaction.direction === 'IN'\">+</span>\n                                <span ng-if=\"transaction.direction === 'OUT'\">-</span>\n                            </i>\n                        </td>\n                        <td class=\"text-grey-3 text-m\">\n                            {{transaction.date}}, {{transaction.hour}}\n                        </td>\n                        <td class=\"text-grey-3 text-m\">\n                            <p ng-if=\"transaction.direction === 'IN'\" translate=\"cw.dashboard.crypto.transactions.mining_payout\"></p>\n                            <p ng-if=\"transaction.direction === 'OUT'\" translate=\"cw.dashboard.crypto.transactions.withdrawal\"></p>\n                        </td>\n                        <td class=\"text-grey-3 text-m\">\n                            <p ng-if=\"transaction.direction === 'IN'\" class=\"text-blue-1\">+ {{transaction.value}}\n                                {{transaction.currency}}</p>\n                            <p ng-if=\"transaction.direction === 'OUT'\" class=\"text-red-2\">- {{transaction.value}}\n                                {{transaction.currency}}</p>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "8Wj0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _deploy = __webpack_require__("LCDH");

var _deploy2 = _interopRequireDefault(_deploy);

var _marketingCard = __webpack_require__("TYTJ");

var _marketingCard2 = _interopRequireDefault(_marketingCard);

var _removeDevice = __webpack_require__("V27j");

var _removeDevice2 = _interopRequireDefault(_removeDevice);

var _lockDevice = __webpack_require__("kodP");

var _lockDevice2 = _interopRequireDefault(_lockDevice);

var _unlockDevice = __webpack_require__("fOfF");

var _unlockDevice2 = _interopRequireDefault(_unlockDevice);

var _subscriptionConfirmation = __webpack_require__("Ldw3");

var _subscriptionConfirmation2 = _interopRequireDefault(_subscriptionConfirmation);

var _oneClickPayment = __webpack_require__("BtZ8");

var _oneClickPayment2 = _interopRequireDefault(_oneClickPayment);

var _ocpComparison = __webpack_require__("6ZU/");

var _ocpComparison2 = _interopRequireDefault(_ocpComparison);

var _activationConfirmation = __webpack_require__("KjhX");

var _activationConfirmation2 = _interopRequireDefault(_activationConfirmation);

var _cropImage = __webpack_require__("xImZ");

var _cropImage2 = _interopRequireDefault(_cropImage);

var _changeLang = __webpack_require__("vUnG");

var _changeLang2 = _interopRequireDefault(_changeLang);

var _changeEmailModal = __webpack_require__("fv8o");

var _changeEmailModal2 = _interopRequireDefault(_changeEmailModal);

var _deleteAccountConfirmation = __webpack_require__("OcT+");

var _deleteAccountConfirmation2 = _interopRequireDefault(_deleteAccountConfirmation);

var _passwordConfirmation = __webpack_require__("OEuF");

var _passwordConfirmation2 = _interopRequireDefault(_passwordConfirmation);

var _getReport = __webpack_require__("wPTc");

var _getReport2 = _interopRequireDefault(_getReport);

var _welcomeModal = __webpack_require__("wW1Q");

var _welcomeModal2 = _interopRequireDefault(_welcomeModal);

var _welcomeModalSpotlight = __webpack_require__("gbut");

var _welcomeModalSpotlight2 = _interopRequireDefault(_welcomeModalSpotlight);

var _RFC = __webpack_require__("mko8");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _languageSwitcher = __webpack_require__("fDpe");

var _languageSwitcher2 = _interopRequireDefault(_languageSwitcher);

var _productCard = __webpack_require__("iRhb");

var _productCard2 = _interopRequireDefault(_productCard);

var _addPayment = __webpack_require__("JLYd");

var _addPayment2 = _interopRequireDefault(_addPayment);

var _paymentCart = __webpack_require__("5JJD");

var _paymentCart2 = _interopRequireDefault(_paymentCart);

var _trialCard = __webpack_require__("M40U");

var _trialCard2 = _interopRequireDefault(_trialCard);

var _gdprReport = __webpack_require__("8ILr");

var _gdprReport2 = _interopRequireDefault(_gdprReport);

var _confirmLogin = __webpack_require__("uOGN");

var _confirmLogin2 = _interopRequireDefault(_confirmLogin);

var _threatsLandscape = __webpack_require__("tBMr");

var _threatsLandscape2 = _interopRequireDefault(_threatsLandscape);

var _coinbaseAccount = __webpack_require__("M4Mx");

var _coinbaseAccount2 = _interopRequireDefault(_coinbaseAccount);

var _bankAccounts = __webpack_require__("ACWg");

var _bankAccounts2 = _interopRequireDefault(_bankAccounts);

var _creditCards = __webpack_require__("mbrn");

var _creditCards2 = _interopRequireDefault(_creditCards);

var _addresses = __webpack_require__("6FPD");

var _addresses2 = _interopRequireDefault(_addresses);

var _phoneNumbers = __webpack_require__("+blg");

var _phoneNumbers2 = _interopRequireDefault(_phoneNumbers);

var _emails = __webpack_require__("XO/S");

var _emails2 = _interopRequireDefault(_emails);

var _mothersName = __webpack_require__("s6Ep");

var _mothersName2 = _interopRequireDefault(_mothersName);

var _driversLicense = __webpack_require__("dslW");

var _driversLicense2 = _interopRequireDefault(_driversLicense);

var _insuranceCards = __webpack_require__("3sBH");

var _insuranceCards2 = _interopRequireDefault(_insuranceCards);

var _gamerTags = __webpack_require__("NLSq");

var _gamerTags2 = _interopRequireDefault(_gamerTags);

var _notifications = __webpack_require__("eMvg");

var _notifications2 = _interopRequireDefault(_notifications);

var _dwmUpsell = __webpack_require__("DkO2");

var _dwmUpsell2 = _interopRequireDefault(_dwmUpsell);

var _toggleMonitoring = __webpack_require__("J6bV");

var _toggleMonitoring2 = _interopRequireDefault(_toggleMonitoring);

var _trialModal = __webpack_require__("p8C+");

var _trialModal2 = _interopRequireDefault(_trialModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Modal controller
 */
angular.module('modals').service('Modals', function () {
    return {

        // 'language': {
        //     templatePath: languageTemplate,
        //     controller: 'ChangeLanguage'
        // },
        activate: {
            templatePath: _marketingCard2.default,
            controller: 'MarketingCard'
        },
        buy: {
            templatePath: _productCard2.default,
            controller: 'ProductCard'
        },
        'remove-device': {
            templatePath: _removeDevice2.default,
            controller: 'RemoveDevice'
        },
        deploy: {
            templatePath: _deploy2.default,
            controller: 'Deploy'
        },
        confirm: {
            templatePath: _subscriptionConfirmation2.default,
            controller: 'SubscriptionConfirmation'
        },
        'one-click-payment': {
            templatePath: _oneClickPayment2.default,
            controller: 'OneClickPayment'
        },
        'lock-device': {
            templatePath: _lockDevice2.default,
            controller: 'LockDevice'
        },
        'unlock-device': {
            templatePath: _unlockDevice2.default,
            controller: 'UnlockDevice'
        },
        'activation-confirmation': {
            templatePath: _activationConfirmation2.default,
            controller: 'ActivationConfirmation'
        },
        'crop-image': {
            templatePath: _cropImage2.default,
            controller: 'CropImage'
        },
        'change-lang': {
            templatePath: _changeLang2.default,
            controller: 'ChangeLangCtrl'
        },
        'change-email': {
            templatePath: _changeEmailModal2.default,
            controller: 'ChangeEmailModal'
        },
        'password-confirmation': {
            templatePath: _passwordConfirmation2.default,
            controller: 'PasswordConfirmationModal'
        },
        'delete-account-confirmation': {
            templatePath: _deleteAccountConfirmation2.default,
            controller: 'DeleteAccountConfirmation'
        },
        'get-report': {
            templatePath: _getReport2.default,
            controller: 'GetReport'
        },
        'welcome-modal': {
            templatePath: _welcomeModal2.default,
            controller: 'WelcomeModal'
        },
        'welcome-modal-spotlight': {
            templatePath: _welcomeModalSpotlight2.default,
            controller: 'WelcomeModalSpotlight'
        },
        'language-switcher': {
            templatePath: _languageSwitcher2.default,
            controller: 'LanguageSwitcherCtrl'
        },
        'ocp-comparison': {
            templatePath: _ocpComparison2.default,
            controller: 'OcpComparison'
        },
        'add-payment': {
            templatePath: _addPayment2.default,
            controller: 'AddPayment'
        },
        'payment-cart': {
            templatePath: _paymentCart2.default,
            controller: 'PaymentCart'
        },
        trial: {
            templatePath: _trialCard2.default,
            controller: 'TrialCard'
        },
        'gdpr-report': {
            templatePath: _gdprReport2.default,
            controller: 'GdprReport'
        },
        'confirm-login': {
            templatePath: _confirmLogin2.default,
            controller: 'ConfirmLogin'
        },
        'threats-landscape': {
            templatePath: _threatsLandscape2.default,
            controller: 'ThreatsLandscape'
        },
        'coinbase-account': {
            templatePath: _coinbaseAccount2.default,
            controller: 'CoinbaseAccount'
        },
        // DWM
        bankAccounts: {
            templatePath: _bankAccounts2.default,
            controller: 'DwmBankAccounts'
        },
        creditDebitCards: {
            templatePath: _creditCards2.default,
            controller: 'DwmCreditCards'
        },
        addresses: {
            templatePath: _addresses2.default,
            controller: 'DwmAddresses'
        },
        phoneNumbers: {
            templatePath: _phoneNumbers2.default,
            controller: 'DwmPhoneNumbers'
        },
        emails: {
            templatePath: _emails2.default,
            controller: 'DwmEmails'
        },
        mothersMaidenName: {
            templatePath: _mothersName2.default,
            controller: 'DwmMothersName'
        },
        driversLicense: {
            templatePath: _driversLicense2.default,
            controller: 'DwmDriversLicense'
        },
        insuranceCards: {
            templatePath: _insuranceCards2.default,
            controller: 'DwmInsuranceCards'
        },
        gamerTags: {
            templatePath: _gamerTags2.default,
            controller: 'DwmGamerTags'
        },
        notifications: {
            templatePath: _notifications2.default,
            controller: 'DwmNotifications'
        },
        dwmUpsell: {
            templatePath: _dwmUpsell2.default,
            controller: 'DwmUpsell'
        },
        'toggle-monitoring': {
            templatePath: _toggleMonitoring2.default,
            controller: 'DwmToggleMonitoring'
        },
        'trial-modal': {
            templatePath: _trialModal2.default,
            controller: 'TrialModal'
        }
    };
});
// Trial modal

// DWM
/* eslint import/no-unresolved: 0 */
/* eslint import/no-webpack-loader-syntax: 0 */

angular.module('modals').openModal = function ($rootScope, $state, $stateParams, $controller, $modal, Templates, Modals, $timeout) {
    var ltb = $stateParams.ltb;

    var scope = void 0;
    var modal = void 0;

    if (_.keys(Modals).indexOf(ltb) >= 0) {

        modal = _.extend({}, Modals[ltb]);
        scope = $rootScope.$new(true);
        scope.template = modal.templatePath;
        scope.modalController = $controller('BaseModal', { $scope: scope });

        modal.template = __webpack_require__("Wxmz");
        modal.scope = scope;

        $stateParams.modal = $modal.open(modal);
        $rootScope.State.hasModal = true;

        $stateParams.modal.result.then(function () {}, function () {

            $state.go($state.current.name.split('.').slice(0, -1).join('.'));
        });

        // send an open modal event on open
        _RFC4.default.broadcast('modal:open', {
            modal: $stateParams.ltb,
            service: $stateParams.service
        });
    } else {

        // we use a timeout to ensure the function is executed in the next tick
        $timeout(function () {

            $state.go('root.dashboard.home');
        }, 0);
    }
};

angular.module('modals').openModal.$inject = ['$rootScope', '$state', '$stateParams', '$controller', '$modal', 'Templates', 'Modals', '$timeout'];

angular.module('modals').closeModal = function ($rootScope, $timeout, $state, $stateParams) {

    if ($stateParams.modal) {

        $stateParams.modal.close();

        $timeout(function () {

            $rootScope.State.hasModal = false;
        }, 0);
    }

    // send a close modal event on close
    _RFC4.default.broadcast('modal:close', {
        modal: $stateParams.ltb,
        service: $stateParams.service
    });
};

angular.module('modals').closeModal.$inject = ['$rootScope', '$timeout', '$state', '$stateParams'];

angular.module('modals').service('ModalFix', ['$rootScope', '$timeout', '$window', function ($rootScope, $timeout, $window) {

    var repaintTimeout = 500;
    // Due to a bug in webkit browsers, the backdrop may not be painted
    // from time to time. Force a repaint
    _RFC4.default.subscribe('modal:open', function () {

        _RFC2.default.timeouts.push($timeout(function () {

            if ($window.document.querySelector) {

                var modal = $window.document.querySelector('.modal-backdrop');

                if (modal) {

                    modal.style.display = 'none';
                    // modal.offsetHeight;
                    modal.style.display = 'block';
                }
            }
        }, repaintTimeout));
    });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "8Xy5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__("W2+e"),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),

/***/ "8ZmK":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ "8f6X":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("GTd5")))

/***/ }),

/***/ "8hbc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Lock device controller
 * Handles lock-device modal template.
 */

angular.module('controllers').controller('LockDevice', ['$scope', '$stateParams', function ($scope, $stateParams) {
    var deviceId = $stateParams.deviceId;


    $scope.userId = _index.MeRepository.getMyId();
    $scope.device = _index.DevicesRepository.getById(deviceId);

    $scope.lockDevice = function () {

        _RFC2.default.send('Click Confirm Lock Device Modal');
    };
}]);

/***/ }),

/***/ "8j2B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
     * Usage:
     * <update-time
     *  time="600000"
     *  format=""
     *  timeTranslateResource="cw.device.status.offline"
     *  timeTranslateValues="{status: '{{device.attributes.last_online | formatTime}}'}">
     * </update-time>
     * Result:
     * <update-time>10 minutes ago</update-time>
     *
     * Note that the directive keeps a timer that updates the minutes passed in real time.
     */

angular.module('directives').directive('updateTime', ['$filter', '$timeout', 'Util', '$interval', function ($filter, $timeout, Util, $interval) {
    return {
        restrict: 'E',
        replace: true,
        template: '<span ng-bind="translatedTime" connectqa-famloc="last-located"></span>',
        scope: {
            time: '=',
            format: '@format',
            timeTranslateResource: '@timeTranslateResource',
            timeTranslateValues: '@timeTranslateValues'
        },
        /**
             * General algorithm:
             * initialize the start time and a timer
             * on each timer tick compute the difference
             * between the current time and the start time and display it
             */
        link: function link(scope) {

            var intervalId = void 0;
            var start = void 0;

            var showTime = function showTime(elapsed) {

                if (!scope.timeTranslateResource) {

                    scope.translatedTime = $filter('formatTime')(elapsed, null, null, scope.format);
                } else {

                    scope.translatedTime = $filter('translate')(scope.timeTranslateResource, scope.timeTranslateValues || {});
                }
            };

            var onTick = function onTick() {

                var elapsed = Date.now() - start;
                showTime(elapsed);
            };
            var init = function init() {

                var elapsed = Util.getElapsedMilli(scope.time);

                // current time - time elapsed since the updateTime directive started counting
                start = Date.now() - elapsed;

                showTime(elapsed);

                $interval.cancel(intervalId);
                intervalId = $interval(onTick, 10 * 100);
            };

            scope.$watch('time', init);

            scope.$on('$destroy', function () {

                $interval.cancel(intervalId);
            });
        }
    };
}]);

/***/ }),

/***/ "8v5l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$rootScope', 'Util'];

var CmaDisclaimerController = function CmaDisclaimerController($scope, $rootScope, Util) {
    _classCallCheck(this, CmaDisclaimerController);

    // CMA Links
    var currentLanguage = CWCONFIG.language;
    var configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
    var redirectSupportLanguage = '';

    if (configSupportLanguages.find(function (lang) {
        return lang === currentLanguage;
    })) {

        if (currentLanguage === 'en') {

            redirectSupportLanguage = 'en-us';
        } else {

            redirectSupportLanguage = currentLanguage;
        }
    } else {

        redirectSupportLanguage = 'en-us';
    }

    $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
    $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
    $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
    $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
    $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
    $scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
    $scope.learnHow = CWCONFIG.cma.subscriptions.learnHow.replace(/\[language\]/gi, currentLanguage);
    $scope.cancelOrRefund = CWCONFIG.cma.subscriptions.cancelOrRefund.replace(/\[language\]/gi, currentLanguage);
    $scope.yourAccount = CWCONFIG.cma.subscriptions.yourAccount.replace(/\[language\]/gi, currentLanguage);
    $scope.cancelContractDetails = CWCONFIG.cma.subscriptions.cancelContractDetails.replace(/\[language\]/gi, redirectSupportLanguage);
    $scope.cancelContractDetailsNew = CWCONFIG.cma.subscriptions.cancelContractDetailsNew.replace(/\[language\]/gi, redirectSupportLanguage);
    var displang3 = Util.getIso3LangCode(currentLanguage);
    var displocale3 = Util.getIso3CountryCode($rootScope.accountCountry, displang3);
    $scope.euWithdrawFromContract = CWCONFIG.cma.subscriptions.euWithdrawFromContract.replace('[displang3]', displang3).replace('[displocale3]', displocale3);
    // End CMA links

    $scope.trackEuWithdrawClick = function trackEuWithdrawClick($event) {

        if ($event.target && $event.target.tagName.toLowerCase() === 'a') {

            _RFC2.default.send('ConnectWeb EU Withdraw From Contract Click');
        }
    };

    $rootScope.cmaDisclaimerHeight = { 'padding-bottom': angular.element('.bottom-page-notification').outerHeight() + 8 + 'px' };
};

var CmaDisclaimerDirective = function CmaDisclaimerDirective() {
    _classCallCheck(this, CmaDisclaimerDirective);

    this.template = __webpack_require__("tGka");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $rootScope, Util) {
        return new CmaDisclaimerController($scope, $rootScope, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'cmaDisclaimerCtrl';
};

_directiveDependencies.push(function () {
    return new CmaDisclaimerDirective();
});

angular.module('directives').directive('cmaDisclaimer', _directiveDependencies);

/***/ }),

/***/ "8wEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$location', '$rootScope', '$translate'];

var DeployBreadcrumbController = function () {
    function DeployBreadcrumbController($scope, $state, $location, $rootScope, $translate) {
        var _this = this;

        _classCallCheck(this, DeployBreadcrumbController);

        this.$scope = $scope;
        this.$state = $state;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.$scope.currentPage = $state.current.name;
        this.$translate = $translate;

        this.$scope.breadcrumbSteps = [{ id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_os') }, { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_license') }, { id: 'step3', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') }, { id: 'step4', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') }];

        var queryParams = this.$location.search();
        var deviceCategory = queryParams.deviceCategory || 'all';

        this.updateBreadcrumb();

        this.$scope.$watch('inputdata', function () {

            _this.updateBreadcrumb();
        });

        setTimeout(function () {

            _this.buildBreadcrumb();
            _this.updateBreadcrumb();
        }, 0);

        this.$scope.breadcrumbClick = function (stepNumber) {

            angular.element('.deploy-modal .deploy-steps div').removeClass('disabled');

            var route = $state.current.name;

            if (route.indexOf('.deploy') === -1) {

                route += '.deploy';
            }

            // Products
            if (_this.$state.current.name.indexOf('.products') > -1) {

                // It has the select os step
                if (_this.$scope.breadcrumbSteps.length === 3) {

                    if (stepNumber === 'step1') {

                        var params = { deviceId: 'new', deployType: 'other', os: '' };

                        _this.$scope.changewizard(route, params, {
                            reload: false
                        });

                        _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Select OS',
                            page: 'Products'
                        });
                    }

                    if (stepNumber === 'step2') {

                        var _params = { deviceId: 'new', os: _this.$scope.inputdata.os };

                        _this.$scope.changewizard(route, _params, {
                            reload: false
                        });

                        _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            Page: 'Products'
                        });
                    }
                } else if (_this.$scope.breadcrumbSteps.length === 2) {

                    if (stepNumber === 'step1') {

                        var _params2 = { deviceId: 'new', os: _this.$scope.inputdata.os };

                        _this.$scope.changewizard(route, _params2, {
                            reload: false
                        });

                        _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            page: 'Products'
                        });
                    }
                }

                // Homepage & Devices
            } else if (_this.$state.current.name.indexOf('.home') > -1 || _this.$state.current.name.indexOf('.devices') > -1) {

                var _params3 = void 0;
                var page = void 0;

                if (_this.$state.current.name.indexOf('.home') > -1) {

                    page = 'Homepage';
                } else {

                    page = 'Devices';
                }

                if (stepNumber === 'step1') {

                    _params3 = { deviceCategory: deviceCategory, appId: '', os: '' };

                    _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Select OS',
                        page: page
                    });
                } else if (stepNumber === 'step2') {

                    _params3 = { os: _this.$scope.inputdata.os, appId: '' };

                    _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Select License',
                        page: page
                    });
                } else if (stepNumber === 'step3') {

                    _params3 = { os: _this.$scope.inputdata.os, appId: _this.$scope.inputdata.appId };

                    _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Download',
                        page: page
                    });
                }

                _this.$scope.changewizard(route, _params3, {
                    reload: false
                });

                // Subscriptions
            } else if (_this.$state.current.name.indexOf('.subscriptions') > -1) {

                if (_this.$scope.breadcrumbSteps.length === 4) {

                    var _params4 = void 0;
                    var savedRoute = _this.$rootScope.State.deploySteps[0];

                    if (stepNumber === 'step1' && savedRoute) {

                        _params4 = {
                            deviceId: savedRoute.deviceId,
                            appId: savedRoute.appId,
                            resourceId: savedRoute.resourceId,
                            os: ''
                        };

                        _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Select OS',
                            page: 'Subscriptions'
                        });
                    }

                    if (stepNumber === 'step2' && savedRoute) {

                        _params4 = {
                            deviceId: savedRoute.deviceId,
                            appId: savedRoute.appId,
                            resourceId: savedRoute.resourceId,
                            os: savedRoute.os
                        };

                        if (savedRoute && (savedRoute.os === 'ios' || savedRoute.os === 'android')) {

                            _this.$scope.changewizard(route, _params4, {
                                reload: false
                            });

                            _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                                'Button label': 'Select License',
                                page: 'Subscriptions'
                            });
                        }

                        return;
                    }

                    if (stepNumber === 'step3' && savedRoute) {

                        if (!savedRoute.currentAppId) {

                            _params4 = {
                                deviceId: savedRoute.deviceId,
                                appId: savedRoute.appId,
                                resourceId: savedRoute.resourceId,
                                os: savedRoute.os
                            };
                        } else {

                            _params4 = {
                                appId: savedRoute.currentAppId,
                                resourceId: 'new',
                                os: savedRoute.os
                            };
                        }

                        _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                            'Button label': 'Download',
                            page: 'Subscriptions'
                        });
                    }

                    if (savedRoute) {

                        _this.$scope.changewizard(route, _params4, {
                            reload: false
                        });
                    }
                }
            } else if (_this.$state.current.name.indexOf('.device-details') > -1) {

                if (stepNumber === 'step1' && !_this.$scope.inputdata.completedSteps) {

                    var _params5 = { appId: _this.$scope.inputdata.appId };

                    _this.$scope.changewizard(route, _params5, {
                        reload: false
                    });

                    _RFC2.default.send('ConnectWeb Modal Breadcrumb Click', {
                        'Button label': 'Download',
                        page: 'Device Details'
                    });
                }
            }
        };

        if (queryParams.autoInstall === 'true' || this.$scope.inputdata.autoInstall === 'true') {

            this.$scope.hideBreadcrumb = true;
        }
    }

    _createClass(DeployBreadcrumbController, [{
        key: 'buildBreadcrumb',
        value: function buildBreadcrumb() {

            var queryParams = this.$location.search();

            if (queryParams.autoInstall === 'true' || queryParams.os === 'webapp' || this.$scope.inputdata.autoInstall === 'true') {

                this.$scope.hideBreadcrumb = true;
            }

            // Build the breadcrumb items

            // Products
            if (this.$state.current.name.indexOf('.products') > -1) {

                var appDetails = _index.AppIntegrationsRepository.getById(this.$state.params.resourceId);

                if (appDetails.attributes.platform.type.length > 1) {

                    this.$scope.breadcrumbSteps = [{ id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.select_os') }, { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') }, { id: 'step3', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') }];
                } else {

                    this.$scope.breadcrumbSteps = [{ id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') }, { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') }];
                }
            } else if (this.$state.current.name.indexOf('.device-details') > -1) {

                this.$scope.breadcrumbSteps = [{ id: 'step1', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.download') }, { id: 'step2', status: '', name: this.$translate.instant('cw.deploy.breadcrumb.done') }];
            }
        }
    }, {
        key: 'updateBreadcrumb',
        value: function updateBreadcrumb() {
            var _this2 = this;

            var queryParams = this.$location.search();

            // Deploy on an existing device
            if (this.$scope.inputdata.completedSteps) {

                this.$scope.breadcrumbSteps.forEach(function (step) {

                    step.status = 'done';
                });

                return;
            }

            // Products
            if (this.$state.current.name.indexOf('.products') > -1) {

                if (this.$scope.breadcrumbSteps.length === 3) {

                    // Select OS
                    if (queryParams.deployType === 'other' && queryParams.deviceId || queryParams.deviceId === 'new' && queryParams.autoInstall === 'false') {

                        this.$scope.breadcrumbSteps[0].status = 'active';
                        this.$scope.breadcrumbSteps[1].status = '';
                        this.$scope.breadcrumbSteps[2].status = '';

                        // Download/send email screen
                    } else if ((queryParams.os !== 'android' || queryParams.os !== 'ios') && !this.$scope.inputdata.showSuccessScreen || queryParams.deployType === 'other' && queryParams.os && !this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'active';
                        this.$scope.breadcrumbSteps[2].status = '';

                        // Donwload complete
                    } else if ((queryParams.os !== 'android' || queryParams.os !== 'ios') && this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'done';
                        this.$scope.breadcrumbSteps[2].status = 'done';
                    }
                } else if (this.$scope.breadcrumbSteps.length === 2) {

                    // Download/send email screen
                    if ((queryParams.os !== 'android' || queryParams.os !== 'ios') && !this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'active';
                        this.$scope.breadcrumbSteps[1].status = '';

                        // Success screen
                    } else if ((queryParams.os !== 'android' || queryParams.os !== 'ios') && this.$scope.inputdata.showSuccessScreen) {

                        this.$scope.breadcrumbSteps[0].status = 'done';
                        this.$scope.breadcrumbSteps[1].status = 'done';
                    }
                }

                setTimeout(function () {

                    _this2.$scope.$apply();
                }, 0);

                // Homepage & Devices
            } else if (this.$state.current.name.indexOf('.home') > -1 || this.$state.current.name.indexOf('.devices') > -1) {

                // Select OS screen

                if (queryParams.deviceCategory === 'all' || queryParams.deviceCategory === 'mobile' || queryParams.deviceCategory === 'desktop') {

                    this.$scope.breadcrumbSteps[0].status = 'active';
                    this.$scope.breadcrumbSteps[1].status = '';
                    this.$scope.breadcrumbSteps[2].status = '';
                    this.$scope.breadcrumbSteps[3].status = '';

                    // Select license screen
                } else if (queryParams.os && !queryParams.appId) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'active';
                    this.$scope.breadcrumbSteps[2].status = '';
                    this.$scope.breadcrumbSteps[3].status = '';

                    // Download/send email screen
                } else if (queryParams.os && queryParams.appId && !this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'done';
                    this.$scope.breadcrumbSteps[2].status = 'active';
                    this.$scope.breadcrumbSteps[3].status = '';

                    // Success screen
                } else if (this.$scope.inputdata.showSuccessScreen === true) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'done';
                    this.$scope.breadcrumbSteps[2].status = 'done';
                    this.$scope.breadcrumbSteps[3].status = 'done';
                }

                // subscriptions
            } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                if (this.$scope.breadcrumbSteps.length >= 4) {

                    if (this.$scope.inputdata.deviceType !== 'phone') {

                        if (queryParams.deviceId === 'new' && queryParams.appId && !queryParams.os) {

                            this.$scope.breadcrumbSteps[0].status = 'active';
                            this.$scope.breadcrumbSteps[1].status = '';
                            this.$scope.breadcrumbSteps[2].status = '';
                            this.$scope.breadcrumbSteps[3].status = '';
                        } else if (queryParams.deviceId === 'new' && queryParams.appId && queryParams.os && !this.$scope.inputdata.showSuccessScreen || queryParams.appId && queryParams.os && !this.$scope.inputdata.showSuccessScreen) {

                            this.$scope.breadcrumbSteps[0].status = 'done';
                            this.$scope.breadcrumbSteps[1].status = 'done';
                            this.$scope.breadcrumbSteps[2].status = 'active';
                            this.$scope.breadcrumbSteps[3].status = '';
                        } else if (this.$scope.inputdata.showSuccessScreen) {

                            this.$scope.breadcrumbSteps[0].status = 'done';
                            this.$scope.breadcrumbSteps[1].status = 'done';
                            this.$scope.breadcrumbSteps[2].status = 'done';
                            this.$scope.breadcrumbSteps[3].status = 'done';
                        }
                    } else if (this.$scope.inputdata.deviceType === 'phone') {

                        if (queryParams.deviceId === 'new' && queryParams.appId && queryParams.os && !this.$scope.inputdata.showSuccessScreen) {

                            this.$scope.breadcrumbSteps[0].status = 'done';
                            this.$scope.breadcrumbSteps[1].status = 'active';
                            this.$scope.breadcrumbSteps[2].status = '';
                            this.$scope.breadcrumbSteps[3].status = '';
                        }
                    }
                }
            } else if (this.$state.current.name.indexOf('.device-details') > -1) {

                if (queryParams.appId && !this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'active';
                    this.$scope.breadcrumbSteps[1].status = '';
                } else if (this.$scope.inputdata.showSuccessScreen) {

                    this.$scope.breadcrumbSteps[0].status = 'done';
                    this.$scope.breadcrumbSteps[1].status = 'done';
                }
            }
        }
    }]);

    return DeployBreadcrumbController;
}();

var DeployBreadcrumbDirective = function DeployBreadcrumbDirective() {
    _classCallCheck(this, DeployBreadcrumbDirective);

    this.template = __webpack_require__("A4qa");
    this.restrict = 'EA';
    this.replace = true;

    this.scope = {
        inputdata: '=',
        changewizard: '='
    };

    _controllerDependencies.push(function ($scope, $state, $location, $rootScope, $translate) {
        return new DeployBreadcrumbController($scope, $state, $location, $rootScope, $translate);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DeployBreadcrumbCtrl';
};

_directiveDependencies.push(function () {
    return new DeployBreadcrumbDirective();
});

angular.module('directives').directive('deployBreadcrumb', _directiveDependencies);

/***/ }),

/***/ "8wya":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("S8m2"),
    arrayMap = __webpack_require__("eKAY"),
    isArray = __webpack_require__("zOp4"),
    isSymbol = __webpack_require__("hyfS");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "9EHJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("YW9j");

var _RFC4 = _interopRequireDefault(_RFC3);

var _browser = __webpack_require__("W/hB");

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _modal = void 0;
var _rootScope = void 0;
var _location = void 0;
var _Util = void 0;
var _JWT = void 0;
var _serviceDependencies = ['$modal', '$rootScope', '$location', 'Util', 'JWT'];

/**
 * @ngdoc service
 * @name services.ErrorHandler
 *
 * @description
 * Service for handling errors when requesting critial resources
 */

var ErrorHandler = function () {
    function ErrorHandler($modal, $rootScope, $location, Util, JWT) {
        _classCallCheck(this, ErrorHandler);

        _modal = $modal;
        _rootScope = $rootScope;
        _location = $location;
        _Util = Util;
        _JWT = JWT;
    }

    /**
     * @ngdoc function
     * @name services.ErrorHandler.handleError
     *
     * @description
     * Decide how to handle the error based on its type
     */


    _createClass(ErrorHandler, [{
        key: 'handleError',
        value: function handleError(errorResponse, errorLocation) {

            var errorReason = void 0;

            // do not show modal if password reset token is expired
            if (_Util.deepFind(errorResponse, 'data.error') && errorResponse.data.error === 'expired_token') {

                // check if on password reset page
                if (_location.path().indexOf('auth/reset') > -1) {

                    return;
                }
            }

            if (_Util.deepFind(errorResponse, 'data.error')) {

                errorReason = errorResponse.data.error;
            } else if (_Util.deepFind(errorResponse, 'data.errors')) {

                errorReason = errorResponse.data.errors[0].detail;
            }

            // Show critical error modal for unhandled status codes

            this.openCriticalErrorModal(errorResponse);

            if (String(errorResponse.status) !== '401' && String(errorResponse.status) !== '403') {

                Sentry.withScope(function (scope) {

                    scope.setLevel('error');
                    Sentry.captureMessage('ErrorPage Opened with status code ' + String(errorResponse.status), undefined, errorResponse);
                });
            }

            var token = _RFC4.default.get(CWCONFIG.cookie.token);
            var tokenSource = 'none';
            var tokenClient = 'none';

            if (token) {

                tokenSource = _JWT.getTokenPayload(token).src || 'none';
                tokenClient = _JWT.getTokenPayload(token).cid || 'none';
            }

            _RFC2.default.send('ConnectWeb ErrorPage Open', {
                'Error Name': errorResponse.statusText,
                'Error Code': String(errorResponse.status),
                'API Resource': _Util.getRestResourceFromUrl(errorResponse.config.url),
                'Error Reason': errorReason,
                'Error Object Data': errorResponse.data,
                'Error Location': errorLocation,
                'Token Source': tokenSource,
                'Token Client': tokenClient
            });
        }

        /**
         * @ngdoc function
         * @name services.ErrorHandler.openCriticalErrorModal
         *
         * @description
         * Open a Critical Error Modal
         * when a request for critial resource from the backend returns an error
         */

    }, {
        key: 'openCriticalErrorModal',
        value: function openCriticalErrorModal(errorResponse) {

            _rootScope.State.loading = false;

            _modal.open({
                template: __webpack_require__("H6q6"),
                controller: 'CriticalError',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'white-modal error-modal',
                resolve: {
                    modalParams: function modalParams() {

                        return errorResponse;
                    }
                }
            });
        }

        /**
         * @ngdoc function
         * @name services.ErrorHandler.reportError
         *
         * @description
         * Report a custom event via Mixpanel
         */

    }, {
        key: 'reportEvent',
        value: function reportEvent(resource, detail) {

            _RFC2.default.send('ConnectWeb Report Event', {
                Resource: resource,
                Detail: detail
            });
        }
    }]);

    return ErrorHandler;
}();

_serviceDependencies.push(ErrorHandler);

angular.module('services').service('ErrorHandler', _serviceDependencies);

/***/ }),

/***/ "9MNA":
/***/ (function(module, exports) {

module.exports = " <div>\n    <div class=\"device-details\">\n        <div class=\"top-holder\">\n\n            <div class=\"device-icon-holder\">\n                <div class=\"device-iconset\">\n                    <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}} icon-grey-3 icon-l\"></i>\n                    <i ng-if=\"hasAv\" class=\"icon icon-s icon-protected device-status-icon icon-green-2 {{device.attributes.type}}\" ng-class=\"{'icon-warning-filled icon-red-2': deviceIssues.length > 0}\"></i>\n                </div>\n                <div ng-if=\"device.attributes.locked\">\n                    <div class=\"icon icon-xxs icon-grey-3 icon-lock inline-block v-top mr5\"></div>\n                    <span class=\"text-m text-grey-3 inline-block top-m1\" translate=\"cw.ui.general.require_permissions\"></span>\n                </div>\n            </div>\n\n            <div class=\"device-info\" ng-class=\"{'noAv': !hasAv}\">\n                <device-rename data=\"device\"></device-rename>\n\n                <span ng-if=\"device.attributes.type === 'laptop' || device.attributes.type === 'pc'\" connectqa-device=\"last-online\">\n                    <h2 ng-if=\"device.attributes.state === 'offline' && device.attributes.last_online\" class=\"text-m text-grey-3 mb5 device-status offline\">\n                        <update-time\n                            time=\"device.attributes.last_online\"\n                            time-translate-resource=\"cw.device.status.offline\"\n                            time-translate-values=\"{status: '{{device.attributes.last_online | formatTime}}'}\">\n                        </update-time>\n                    </h2>\n                    <h2 ng-if=\"device.attributes.state === 'online'\" class=\"text-m text-grey-2 mb5 device-status online\" translate=\"cw.device.status.online\"> </h2>\n                </span>\n\n                <div class=\"mt5\">\n                    <span class=\"text-m text-grey-3 inline-block v-top mr5 info-text\" translate=\"cw.general.settings\"></span>\n                    <div class=\"inline-block device-list-header\">\n                        <device-settings device-id=\"device.id\" is-locked=\"isDeviceLocked\"></device-settings>\n                    </div>\n                </div>\n                <br />\n                <!-- Info box for installed license name -->\n                <div class=\"actions-holder inline-block\">\n                    <div class=\"license-wrap\">\n                        <!-- No license -->\n                        <div ng-if=\"licenseNames.length === 0\">\n                            {{'cw.device_info.installed_license_label' | translate }} <span class=\"no-license text-grey-1\" translate=\"cw.general.none\"\n                                connectqa-device=\"no-license\"></span>\n                            <!-- <a ng-if=\"$root.hasUsCompliance\" class=\"btn btn-orange btn-medium ml20\" ng-click=\"getOffer();\">\n                                <span\n                                    translate=\"cw.banner.btn_upgrade\"\n                                    translate-values=\"{product : offerProductDetails.attributes.resource.oeName || 'Prime'}\">\n                                </span>\n                            </a> -->\n                        </div>\n\n                        <!-- 1 license -->\n                        <div ng-if=\"licenseNames.length === 1\">{{'cw.device_info.installed_license_label' | translate }}\n                            <span class=\"license-name\" connectqa-device=\"one-license\">{{licenseNames[0]}}</span></div>\n\n                        <!-- Multiple licenses -->\n                        <div ng-if=\"licenseNames.length > 1\">\n                            <a class=\"show-dropdown\"\n                                ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                ng-click=\"toggleDropdown=!toggleDropdown\"\n                                connectqa-device=\"multiple-licenses\">\n                                <span>{{'cw.device_info.installed_license_label' | translate }}</span>\n                            </a>\n\n                            <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                    <li ng-repeat=\"licenseName in licenseNames\">\n                                        {{licenseName}}\n                                    </li>\n                                </div>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <!-- Tabs -->\n        <div class=\"middle-holder\">\n            <div class=\"dashboard-tabs-holder ng-scope\">\n                <div class=\"dashboard-tabs text-center\">\n                    <span class=\"text-l crs-pointer\"\n                          ng-class=\"{'active': state.params.tab === 'apps'}\"\n                          translate=\"cw.general.apps\"\n                          ui-sref=\"root.dashboard.device-details({tab: 'apps'})\"\n                          ng-click=\"onTabClick('Apps')\" connectqa-device=\"apps\"></span>\n                    <span class=\"text-l text-dark crs-pointer\"\n                          ng-class=\"{'active': state.params.tab === 'info'}\"\n                          translate=\"cw.antitheft.modal.device_report.subtitle\"\n                          ui-sref=\"root.dashboard.device-details({tab: 'info'})\"\n                          ng-if=\"deviceInfo\"\n                          ng-click=\"onTabClick('Info')\" connectqa-device=\"device-info\"></span>\n                </div>\n            </div>\n\n            <!-- Content Tabs -->\n\n            <!-- App Integrations and Active Instances - List -->\n            <div class=\"text-center\" ng-if=\"state.params.tab === 'apps'\">\n                <div class=\"m-auto\">\n                    <!-- Loop over categories & create each category box -->\n                    <div class=\"main-section\" ng-repeat=\"(key, category) in servicesByCategory\" ng-if=\"category.active.length > 0 || category.inactive.length > 0\">\n                        <div class=\"apps-wrap\">\n                            <h2 class=\"text-grey-3 capitalize font-bold m-auto mb20\"\n                                translate=\"{{'cw.device_details.' + key }}\"\n                                translate-values=\"{brandname : brandName}\"\n                            ></h2>\n                            <!-- Loop over both services types of the category (active / inactive) -->\n                            <ul ng-repeat=\"categoryType in category\" ng-if=\"categoryType.length > 0\" class=\"text-left\">\n                                <!-- Loop over each service -->\n                                <li ng-repeat=\"service in categoryType | orderBy:['customAppInfo.order', 'attributes.custom.manifest.order']\"\n                                    ng-class=\"{'installed-state': service.attributes.state === 'active' || service.attributes.state === 'pending'}\"\n                                    connectqa-device=\"{{ service.customAppInfo.prototype || service.attributes.prototype }}\"\n                                >\n                                    <div class=\"left-col\">\n                                        <img ng-src=\"{{service.customAppInfo.icon || service.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                                        <!-- Product title -->\n                                        <h4 class=\"text-m inline-block icon-grey-2\">\n                                            {{service.customAppInfo.name || service.attributes.resource.oeName}}\n                                            <span\n                                                ng-if=\"!service.customAppInfo.name.toLowercase().contains('pro') &&\n                                                    service.relationships.license &&\n                                                    !service.relationships.license.data.id.includes('-0-') &&\n                                                    service.relationships.license.data.id.slice(-2) !== '-0'\"\n                                                translate=\"cw.ui.general.pro_version\">\n                                            </span>\n                                            <br />\n                                            <!-- Learn more -->\n                                            <span\n                                                translate=\"cw.dashboard.services.mkt\"\n                                                ng-click=\"showLearnMore(service, isInstalled(service.relationships), key)\"\n                                                connectqa-device=\"learn-more\"\n                                                class=\"learn-more text-s crs-pointer\">\n                                            </span>\n                                        </h4>\n                                    </div>\n                                    <div class=\"right-col\">\n\n                                        <!-- install status -->\n                                        <div ng-if=\"!isInstalled(service.relationships)\">\n                                            <!-- install btn for browser extension all devices -->\n                                            <div ng-if=\"service.attributes.custom.manifest.browserExtensionUrl && $root.hasUsCompliance\">\n\n                                                <a ng-if=\"browserName === 'chrome' && service.attributes.custom.manifest.browserExtensionUrl.chrome\"\n                                                    ng-href=\"{{service.attributes.custom.manifest.browserExtensionUrl.chrome}}\" class=\"btn btn-primary btn-small\"\n                                                    target=\"_blank\"\n                                                    ng-click=\"sendMixpanelEvent(service)\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></a>\n\n                                                <a ng-if=\"browserName === 'firefox' && service.attributes.custom.manifest.browserExtensionUrl.firefox\"\n                                                    ng-href=\"{{service.attributes.custom.manifest.browserExtensionUrl.firefox}}\" class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"sendMixpanelEvent(service)\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></a>\n\n                                                <a ng-if=\"browserName === 'opera' && service.attributes.custom.manifest.browserExtensionUrl.opera\"\n                                                    class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"sendMixpanelEvent(service);installOperaExtension(service.attributes.custom.manifest.browserExtensionUrl.opera, service.id)\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></a>\n\n                                            </div>\n                                            <!-- install btn for browser extension all devices -->\n                                            <div ng-if=\"!service.attributes.custom.manifest.browserExtensionUrl && key === 'internet_of_things' && $root.hasUsCompliance\">\n                                                <span class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"deployOn(service, key)\"\n                                                    ng-if=\"!service.attributes.custom.manifest.product_url\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></span>\n                                                <a class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"sendMixpanelEvent(service)\"\n                                                    ng-if=\"service.attributes.custom.manifest.product_url\"\n                                                    ng-href=\"{{service.attributes.custom.manifest.product_url}}\"\n                                                    target=\"_blank\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></a>\n                                            </div>\n                                            <!-- not installed for windows and mac devices -->\n                                            <div ng-if=\"!service.attributes.custom.manifest.browserExtensionUrl &&\n                                                key === 'fss_apps' &&\n                                                (device.attributes.os === 'windows' || device.attributes.os === 'osx')\">\n                                                <span class=\"text-grey-3 text-m capitalize\"\n                                                    ng-show=\"!app.mobileDevices.length\">\n                                                    <span translate=\"cw.dashboard.device.not_installed\"></span>\n                                                </span>\n                                            </div>\n                                            <!-- install btn for mobile device -->\n                                            <div ng-if=\"!service.attributes.custom.manifest.browserExtensionUrl &&\n                                                key === 'fss_apps' &&\n                                                (device.attributes.os === 'ios' || device.attributes.os === 'android') && $root.hasUsCompliance\">\n                                                <span class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"deployOn(service, key)\"\n                                                    ng-if=\"!service.attributes.custom.manifest.product_url\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></span>\n                                                <a class=\"btn btn-primary btn-small\"\n                                                    ng-click=\"sendMixpanelEvent(service)\"\n                                                    ng-if=\"service.attributes.custom.manifest.product_url\"\n                                                    ng-href=\"{{service.attributes.custom.manifest.product_url}}\"\n                                                    target=\"_blank\"\n                                                    translate=\"cw.mkt.antitheft.card.activation_button_nd\" connectqa-device=\"install\"></a>\n                                            </div>\n                                        </div>\n\n                                        <!-- Installed label -->\n                                        <span ng-if=\"isInstalled(service.relationships) && service.attributes.state === 'active'\" class=\"label-installed\" translate=\"cw.deploy.service.installed\"></span>\n\n                                        <!-- Pending btn -->\n                                        <span ng-if=\"isInstalled(service.relationships) && service.attributes.state === 'pending'\">\n                                            <span class=\"text-grey-3 text-m capitalize\">\n                                                <span translate=\"cw.general.ui.pending\" connectqa-device=\"pending\"></span>\n                                            </span>\n                                            <!-- Info tooltip -->\n                                            <span class=\"text-l p-relative\">\n                                                <div class=\"info-tooltip-p inline-block v-middle\">\n                                                    <span class=\"info-round\">\n                                                        <em>i</em>\n                                                        <div class=\"settings_dropdown top-tooltip\">\n                                                            <div class=\"settings_dropdown_wrap settings_dropdown_wrap-top grey-b padd10 text-center text-s\">\n                                                                <span translate=\"cw.device.pending_tooltip\"\n                                                                        ng-if=\"!service.customAppInfo.browsers\"></span>\n                                                                <span translate=\"cw.deploy.extension_pending_info\"\n                                                                        ng-if=\"service.customAppInfo.browsers\"></span>\n                                                            </div>\n                                                        </div>\n                                                    </span>\n                                                </div>\n                                            </span>\n\n                                            <!-- cancel pending btn -->\n                                            <span class=\"crs-pointer inline-block icon icon-close icon-xxxs icon-grey-3 ml10\"\n                                            ng-click=\"removePendingInstance(service)\" connectqa-device=\"cancel-pending\"></span>\n                                        </span>\n                                        <!-- Learn more -->\n                                        <span\n                                            translate=\"cw.dashboard.services.mkt\"\n                                            ng-click=\"showLearnMore(service, isInstalled(service.relationships), key)\"\n                                            connectqa-device=\"learn-more\"\n                                            class=\"learn-more-right text-s crs-pointer\">\n                                        </span>\n                                    </div>\n                                </li>\n                            </ul>\n                            <!-- download btn for my app window( sptl1) and mac (fss0) -->\n                            <div ng-if=\"showFSSDownloadButton(key) && $root.hasUsCompliance\" class=\"flex-space-between mt20\" connectqa-device=\"fss\">\n                                <p class=\"text-m\" translate=\"cw.device_details.install_desc\" translate-values=\"{title: 'Avira Security Suite'}\"></p>\n                                <a ng-click=\"deployOn(featuredApp, key)\"\n                                class=\"btn btn-primary btn-medium\"\n                                translate=\"cw.general.ui.install\" connectqa-button=\"install\"></a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Device Info -->\n            <div ng-if=\"state.params.tab === 'info'\">\n                <div ng-if=\"(device.attributes.type === 'pc' || device.attributes.type === 'laptop') && deviceInfo\">\n                    <ul class=\"device-info-list\" connectqa-devinfo=\"content\">\n                        <li ng-if=\"device.attributes.others.disks\"\n                            ng-repeat=\"hdd in device.attributes.others.disks\" connectqa-devinfo=\"HDD-{{ $index + 1 }}\">\n                            <h5><span translate=\"cw.device_info.hdd\"></span> <span ng-if=\"$index > 0\">({{$index + 1}})</span></h5>\n                            <h6>\n                                {{hdd.name}} ({{hdd.size | formatSize: 'kb'}})\n                            </h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.cpu.name\" connectqa-devinfo=\"CPU\">\n                            <h5 translate=\"cw.device_info.cpu\"></h5>\n                            <h6>{{device.attributes.others.cpu.name}} ({{device.attributes.others.cpu.freq / 1000}}\n                                <span translate=\"cw.device_info.ghz\"></span>)\n                            </h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.gpus\"\n                            ng-repeat=\"gpu in device.attributes.others.gpus\" connectqa-devinfo=\"GPU-{{ $index + 1 }}\">\n                            <h5><span translate=\"cw.device_info.gpu\"></span> <span ng-if=\"$index > 0\">({{$index + 1}})</span></h5>\n                            <h6>{{gpu.name}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.memory.size\" connectqa-devinfo=\"RAM\">\n                            <h5 translate=\"cw.device_info.ram\"></h5>\n                            <h6 translate=\"cw.device_info.memory_size\" translate-values=\"{memorySize: '{{device.attributes.others.memory.size | formatSize: 'kb'}}'}\"></h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.motherboard.brand ||\n                                   device.attributes.others.motherboard.model\" connectqa-devinfo=\"motherboard\">\n                            <h5 translate=\"cw.my_devices.system_info.model\"></h5>\n                            <h6>{{device.attributes.others.motherboard.brand}} - ({{device.attributes.others.motherboard.model}})</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.resolution\" connectqa-devinfo=\"resolution\">\n                            <h5 translate=\"cw.device_info.resolution\"></h5>\n                            <h6>{{device.attributes.others.resolution}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.osType\" connectqa-devinfo=\"OS\">\n                            <h5 translate=\"cw.my_devices.system_info.os\"></h5>\n                            <h6>\n                                <span class=\"capitalize\">{{device.attributes.os.toLowerCase()}}\n                                {{device.attributes.others.osver | convertOSVersion : device.attributes.others.osType}}</span>\n                                <span ng-if=\"device.attributes.others.sp\">- {{device.attributes.others.sp}}</span>\n                            </h6>\n                        </li>\n                    </ul>\n                </div>\n\n                <div ng-if=\"(device.attributes.type === 'phone' || device.attributes.type === 'tablet') && deviceInfo\">\n                    <ul class=\"device-info-list\" connectqa-devinfo=\"content\">\n                        <li ng-if=\"device.attributes.others.systemInfo.totalSpace\">\n                            <h5 translate=\"cw.my_devices.system_info.disk_space.title\"></h5>\n                            <h6 translate=\"cw.device_info.total_space\" translate-values=\"{totalSpace: '{{device.attributes.others.systemInfo.totalSpace | formatSize: 'kb'}}'}\"></h6>\n                        </li>\n                        <li ng-if=\"device.attributes.model || device.attributes.brand\" connectqa-devinfo=\"model\">\n                            <h5 translate=\"cw.my_devices.system_info.model\"></h5>\n                            <h6>{{device.attributes.brand | ucfirst}} -\n                                {{(device.attributes.model | convertOSVersion : device.attributes.others.osType) || device.attributes.model}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.osver\" connectqa-devinfo=\"OS-version\">\n                            <h5 translate=\"cw.my_devices.system_info.os\"></h5>\n                            <h6>{{device.attributes.os | ucfirst}} {{device.attributes.others.osver | versionNumber:1}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.agver\" connectqa-devinfo=\"others\">\n                            <h5 translate=\"cw.my_devices.system_info.avira_app_version\" translate-values=\"{brandname : brandName}\"></h5>\n                            <h6>{{device.attributes.others.agver | versionNumber:1}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.serial\" connectqa-devinfo=\"serial\">\n                            <h5 translate=\"cw.my_devices.system_info.serial\"></h5>\n                            <h6>{{device.attributes.others.serial}}</h6>\n                        </li>\n                        <li ng-if=\"device.attributes.others.phoneNo &&\n                                   device.attributes.others.phoneNo.toLowerCase() !== 'unknown'\">\n                            <h5 translate=\"cw.my_devices.system_info.phone_number\"></h5>\n                            <h6>{{device.attributes.others.phoneNo}}</h6>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n\n            <!-- App Instance Details TBD -->\n            <div ng-if=\"state.current.name === 'root.dashboard.device-details.app-details'\">\n                <h6 class=\"text-xxl mb40\">AppInstance Details - {{appInstanceDetails.relationships.app.data.id}}</h6>\n                <div class=\"text-m\">\n                    {{appInstanceDetails}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "9MtQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__("ccIB"),n=__webpack_require__("W2+e"),r=__webpack_require__("dH6z");function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),

/***/ "9bIT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$rootScope'];

var DwmAlertsController = function DwmAlertsController($scope, $state, $rootScope) {
    _classCallCheck(this, DwmAlertsController);

    $scope.alertsLoading = true;

    var buildAlerts = function buildAlerts() {

        if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

            $scope.alertsLoading = false;
        }
    };

    buildAlerts();

    var dwmStatusListener = $rootScope.$on('dwm_status_fetch_completed', function () {

        buildAlerts();
    });

    var paginate = function paginate(arr, size) {
        return arr.reduce(function (acc, val, i) {

            var idx = Math.floor(i / size);
            var page = acc[idx] || (acc[idx] = []);
            page.push(val);

            return acc;
        }, []);
    };

    var onDwmDataNext = function onDwmDataNext() {

        var alerts = _index.dwmRepository.getAll('alerts') || {};
        $scope.unreadAlerts = 0;

        if (alerts.alertList) {

            $scope.activePage = $rootScope.alertsActivePage;

            alerts.alertList.forEach(function (alert) {

                alert.formattedDate = moment(alert.createdAt).format('L');
                if (alert.isRead === false && alert.bucket === 'inbox') {

                    $scope.unreadAlerts += 1;
                }
            });

            $scope.alerts = paginate(alerts.alertList, 10);
            $scope.alertsLoading = false;

            if ($rootScope.alertsActivePage < $scope.alerts.length) {

                $scope.nextArrowEnabled = true;
            }

            if ($rootScope.alertsActivePage === 1) {

                $scope.prevArrowEnabled = false;
            }
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.nextPage = function () {

        $scope.activePage += 1;
        $rootScope.alertsActivePage = $scope.activePage;
        $scope.nextArrowEnabled = !!($scope.activePage < $scope.alerts.length);
        $scope.prevArrowEnabled = !!($scope.activePage !== 1);
    };

    $scope.prevPage = function () {

        $scope.activePage -= 1;
        $rootScope.alertsActivePage = $scope.activePage;
        $scope.nextArrowEnabled = !!($scope.activePage < $scope.alerts.length);
        $scope.prevArrowEnabled = !!($scope.activePage !== 1);
    };

    $scope.openAlertModal = function (alertId) {

        _RFC2.default.send('ConnectWeb AIA Notification Click');

        $state.go('root.dashboard.dwm.ltb', {
            ltb: 'notifications',
            resourceId: alertId
        });
    };

    $scope.$on('$destroy', function () {

        dwmStatusListener();
    });
};

var CryptoFaqDirective = function CryptoFaqDirective() {
    _classCallCheck(this, CryptoFaqDirective);

    this.template = __webpack_require__("aZcI");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $rootScope) {
        return new DwmAlertsController($scope, $state, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DwmAlertsCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoFaqDirective();
});

angular.module('directives').directive('dwmAlerts', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "9dPI":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    //! moment.js locale configuration

    hooks.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$1 = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-dz', {
        months: months$1,
        monthsShort: months$1,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm$1 = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals$1 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$1 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$1(number),
                    str = plurals$1[u][pluralForm$1(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$2 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-ly', {
        months: months$2,
        monthsShort: months$2,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$1('s'),
            ss: pluralize$1('s'),
            m: pluralize$1('m'),
            mm: pluralize$1('m'),
            h: pluralize$1('h'),
            hh: pluralize$1('h'),
            d: pluralize$1('d'),
            dd: pluralize$1('d'),
            M: pluralize$1('M'),
            MM: pluralize$1('M'),
            y: pluralize$1('y'),
            yy: pluralize$1('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$1 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    hooks.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$1[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$2 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$1 = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm$2 = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals$2 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$2 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$2(number),
                    str = plurals$2[u][pluralForm$2(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$3 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar', {
        months: months$3,
        monthsShort: months$3,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$2('s'),
            ss: pluralize$2('s'),
            m: pluralize$2('m'),
            mm: pluralize$2('m'),
            h: pluralize$2('h'),
            hh: pluralize$2('h'),
            d: pluralize$2('d'),
            dd: pluralize$2('d'),
            M: pluralize$2('M'),
            MM: pluralize$2('M'),
            y: pluralize$2('y'),
            yy: pluralize$2('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$1[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$2[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    hooks.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    hooks.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$3 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$2 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$2[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$3[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$4 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$3 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$3[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$4[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$5 = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap$4 = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    hooks.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap$4[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$5[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex$1 =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    hooks.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex$1,
        monthsShortRegex: monthsRegex$1,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$4 = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse$1 = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex$2 =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural$1(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    hooks.defineLocale('cs', {
        months: months$4,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse$1,
        longMonthsParse: monthsParse$1,
        shortMonthsParse: monthsParse$1,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate$1,
            ss: translate$1,
            m: translate$1,
            mm: translate$1,
            h: translate$1,
            hh: translate$1,
            d: translate$1,
            dd: translate$1,
            M: translate$1,
            MM: translate$1,
            y: translate$1,
            yy: translate$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$1,
            mm: '%d Minuten',
            h: processRelativeTime$1,
            hh: '%d Stunden',
            d: processRelativeTime$1,
            dd: processRelativeTime$1,
            w: processRelativeTime$1,
            ww: '%d Wochen',
            M: processRelativeTime$1,
            MM: processRelativeTime$1,
            y: processRelativeTime$1,
            yy: processRelativeTime$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$2,
            mm: '%d Minuten',
            h: processRelativeTime$2,
            hh: '%d Stunden',
            d: processRelativeTime$2,
            dd: processRelativeTime$2,
            w: processRelativeTime$2,
            ww: '%d Wochen',
            M: processRelativeTime$2,
            MM: processRelativeTime$2,
            y: processRelativeTime$2,
            yy: processRelativeTime$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$5 = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    hooks.defineLocale('dv', {
        months: months$5,
        monthsShort: months$5,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function isFunction$1(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    hooks.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction$1(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$2 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$3 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$1[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$2,
        longMonthsParse: monthsParse$2,
        shortMonthsParse: monthsParse$2,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$1 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$3 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$4 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$2[m.month()];
            } else {
                return monthsShortDot$1[m.month()];
            }
        },
        monthsRegex: monthsRegex$4,
        monthsShortRegex: monthsRegex$4,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$3,
        longMonthsParse: monthsParse$3,
        shortMonthsParse: monthsParse$3,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    var monthsShortDot$2 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$4 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$5 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$3[m.month()];
            } else {
                return monthsShortDot$2[m.month()];
            }
        },
        monthsRegex: monthsRegex$5,
        monthsShortRegex: monthsRegex$5,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$4,
        longMonthsParse: monthsParse$4,
        shortMonthsParse: monthsParse$4,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$3 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$5 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$6 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$3;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$4[m.month()];
            } else {
                return monthsShortDot$3[m.month()];
            }
        },
        monthsRegex: monthsRegex$6,
        monthsShortRegex: monthsRegex$6,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$5,
        longMonthsParse: monthsParse$5,
        shortMonthsParse: monthsParse$5,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime$3,
            ss: processRelativeTime$3,
            m: processRelativeTime$3,
            mm: processRelativeTime$3,
            h: processRelativeTime$3,
            hh: processRelativeTime$3,
            d: processRelativeTime$3,
            dd: '%d päeva',
            M: processRelativeTime$3,
            MM: processRelativeTime$3,
            y: processRelativeTime$3,
            yy: processRelativeTime$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$6 = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap$5 = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    hooks.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap$5[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$6[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    hooks.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate$2,
            ss: translate$2,
            m: translate$2,
            mm: translate$2,
            h: translate$2,
            hh: translate$2,
            d: translate$2,
            dd: translate$2,
            M: translate$2,
            MM: translate$2,
            y: translate$2,
            yy: translate$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsStrictRegex$1 =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex$1 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex$7 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse$6 = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    hooks.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex$7,
        monthsShortRegex: monthsRegex$7,
        monthsStrictRegex: monthsStrictRegex$1,
        monthsShortStrictRegex: monthsShortStrictRegex$1,
        monthsParse: monthsParse$6,
        longMonthsParse: monthsParse$6,
        shortMonthsParse: monthsParse$6,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    hooks.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$6 = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort$5 = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays$1 = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    hooks.defineLocale('ga', {
        months: months$6,
        monthsShort: monthsShort$5,
        monthsParseExact: true,
        weekdays: weekdays$1,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$7 = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort$6 = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays$2 = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort$1 = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin$1 = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    hooks.defineLocale('gd', {
        months: months$7,
        monthsShort: monthsShort$6,
        monthsParseExact: true,
        weekdays: weekdays$2,
        weekdaysShort: weekdaysShort$1,
        weekdaysMin: weekdaysMin$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime$4,
            ss: processRelativeTime$4,
            m: processRelativeTime$4,
            mm: processRelativeTime$4,
            h: processRelativeTime$4,
            hh: processRelativeTime$4,
            d: processRelativeTime$4,
            dd: processRelativeTime$4,
            M: processRelativeTime$4,
            MM: processRelativeTime$4,
            y: processRelativeTime$4,
            yy: processRelativeTime$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime$5,
            ss: processRelativeTime$5,
            m: processRelativeTime$5,
            mm: processRelativeTime$5,
            h: processRelativeTime$5,
            hh: processRelativeTime$5,
            d: processRelativeTime$5,
            dd: processRelativeTime$5,
            M: processRelativeTime$5,
            MM: processRelativeTime$5,
            y: processRelativeTime$5,
            yy: processRelativeTime$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$7 = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap$6 = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    hooks.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap$6[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$7[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$8 = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$7 = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse$7 = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    hooks.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse$7,
        longMonthsParse: monthsParse$7,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$7[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$8[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function translate$3(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate$3,
            m: translate$3,
            mm: translate$3,
            h: translate$3,
            hh: translate$3,
            d: 'dan',
            dd: translate$3,
            M: 'mjesec',
            MM: translate$3,
            y: 'godinu',
            yy: translate$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    hooks.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate$4,
            ss: translate$4,
            m: translate$4,
            mm: translate$4,
            h: translate$4,
            hh: translate$4,
            d: translate$4,
            dd: translate$4,
            M: translate$4,
            MM: translate$4,
            y: translate$4,
            yy: translate$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$2(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural$2(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    hooks.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate$5,
            ss: translate$5,
            m: translate$5,
            mm: translate$5,
            h: 'klukkustund',
            hh: translate$5,
            d: translate$5,
            dd: translate$5,
            M: translate$5,
            MM: translate$5,
            y: translate$5,
            yy: translate$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    //! moment.js locale configuration

    var suffixes$1 = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    hooks.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$9 = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap$8 = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    hooks.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap$8[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$9[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$a = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap$9 = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    hooks.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap$9[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$a[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    //! moment.js locale configuration

    var symbolMap$b = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$a = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months$8 = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    hooks.defineLocale('ku', {
        months: months$8,
        monthsShort: months$8,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$a[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$b[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$2 = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    hooks.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    hooks.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime$6,
            mm: '%d Minutten',
            h: processRelativeTime$6,
            hh: '%d Stonnen',
            d: processRelativeTime$6,
            dd: '%d Deeg',
            M: processRelativeTime$6,
            MM: '%d Méint',
            y: processRelativeTime$6,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    hooks.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate$6,
            m: translateSingular,
            mm: translate$6,
            h: translateSingular,
            hh: translate$6,
            d: translateSingular,
            dd: translate$6,
            M: translateSingular,
            MM: translate$6,
            y: translateSingular,
            yy: translate$6,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var units$1 = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format$1(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + ' ' + format$1(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format$1(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    hooks.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural$1,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural$1,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural$1,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural$1,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural$1,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    hooks.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    //! moment.js locale configuration

    function translate$7(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    hooks.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate$7,
            ss: translate$7,
            m: translate$7,
            mm: translate$7,
            h: translate$7,
            hh: translate$7,
            d: translate$7,
            dd: translate$7,
            M: translate$7,
            MM: translate$7,
            y: translate$7,
            yy: translate$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$c = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$b = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    hooks.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$b[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$c[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$d = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap$c = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    hooks.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap$c[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$d[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$e = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$d = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    hooks.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$d[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$e[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$1 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$1 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$8 = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$8 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$1[m.month()];
            } else {
                return monthsShortWithDots$1[m.month()];
            }
        },

        monthsRegex: monthsRegex$8,
        monthsShortRegex: monthsRegex$8,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$8,
        longMonthsParse: monthsParse$8,
        shortMonthsParse: monthsParse$8,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$2 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$2 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$9 = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$9 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$2[m.month()];
            } else {
                return monthsShortWithDots$2[m.month()];
            }
        },

        monthsRegex: monthsRegex$9,
        monthsShortRegex: monthsRegex$9,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$9,
        longMonthsParse: monthsParse$9,
        shortMonthsParse: monthsParse$9,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    //! moment.js locale configuration

    var symbolMap$f = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap$e = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    hooks.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap$e[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$f[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse$a = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural$3(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural$3(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural$3(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural$3(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural$3(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural$3(number) ? 'lata' : 'lat');
        }
    }

    hooks.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse$a,
        longMonthsParse: monthsParse$a,
        shortMonthsParse: monthsParse$a,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate$8,
            m: translate$8,
            mm: translate$8,
            h: translate$8,
            hh: translate$8,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate$8,
            M: 'miesiąc',
            MM: translate$8,
            y: 'rok',
            yy: translate$8,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    hooks.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural$2,
            m: 'un minut',
            mm: relativeTimeWithPlural$2,
            h: 'o oră',
            hh: relativeTimeWithPlural$2,
            d: 'o zi',
            dd: relativeTimeWithPlural$2,
            w: 'o săptămână',
            ww: relativeTimeWithPlural$2,
            M: 'o lună',
            MM: relativeTimeWithPlural$2,
            y: 'un an',
            yy: relativeTimeWithPlural$2,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$4(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural$4(format[key], +number);
        }
    }
    var monthsParse$b = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    hooks.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse$b,
        longMonthsParse: monthsParse$b,
        shortMonthsParse: monthsParse$b,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural$3,
            m: relativeTimeWithPlural$3,
            mm: relativeTimeWithPlural$3,
            h: 'час',
            hh: relativeTimeWithPlural$3,
            d: 'день',
            dd: relativeTimeWithPlural$3,
            w: 'неделя',
            ww: relativeTimeWithPlural$3,
            M: 'месяц',
            MM: relativeTimeWithPlural$3,
            y: 'год',
            yy: relativeTimeWithPlural$3,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$9 = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days$1 = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    hooks.defineLocale('sd', {
        months: months$9,
        monthsShort: months$9,
        weekdays: days$1,
        weekdaysShort: days$1,
        weekdaysMin: days$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    /*jshint -W100*/
    hooks.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    //! moment.js locale configuration

    var months$a =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort$7 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural$5(n) {
        return n > 1 && n < 5;
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    hooks.defineLocale('sk', {
        months: months$a,
        monthsShort: monthsShort$7,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate$9,
            ss: translate$9,
            m: translate$9,
            mm: translate$9,
            h: translate$9,
            hh: translate$9,
            d: translate$9,
            dd: translate$9,
            M: translate$9,
            MM: translate$9,
            y: translate$9,
            yy: translate$9,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    hooks.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime$7,
            ss: processRelativeTime$7,
            m: processRelativeTime$7,
            mm: processRelativeTime$7,
            h: processRelativeTime$7,
            hh: processRelativeTime$7,
            d: processRelativeTime$7,
            dd: processRelativeTime$7,
            M: processRelativeTime$7,
            MM: processRelativeTime$7,
            y: processRelativeTime$7,
            yy: processRelativeTime$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$1 = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$1.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$1.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator$1.translate,
            m: translator$1.translate,
            mm: translator$1.translate,
            h: translator$1.translate,
            hh: translator$1.translate,
            d: translator$1.translate,
            dd: translator$1.translate,
            M: translator$1.translate,
            MM: translator$1.translate,
            y: translator$1.translate,
            yy: translator$1.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$2 = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$2.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$2.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator$2.translate,
            m: translator$2.translate,
            mm: translator$2.translate,
            h: translator$2.translate,
            hh: translator$2.translate,
            d: translator$2.translate,
            dd: translator$2.translate,
            M: translator$2.translate,
            MM: translator$2.translate,
            y: translator$2.translate,
            yy: translator$2.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$g = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap$f = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    hooks.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap$f[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$g[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$3 = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    hooks.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    //! moment.js locale configuration

    var suffixes$4 = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    hooks.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    hooks.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate$a,
            m: 'wa’ tup',
            mm: translate$a,
            h: 'wa’ rep',
            hh: translate$a,
            d: 'wa’ jaj',
            dd: translate$a,
            M: 'wa’ jar',
            MM: translate$a,
            y: 'wa’ DIS',
            yy: translate$a,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$5 = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    hooks.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    hooks.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime$8,
            ss: processRelativeTime$8,
            m: processRelativeTime$8,
            mm: processRelativeTime$8,
            h: processRelativeTime$8,
            hh: processRelativeTime$8,
            d: processRelativeTime$8,
            dd: processRelativeTime$8,
            M: processRelativeTime$8,
            MM: processRelativeTime$8,
            y: processRelativeTime$8,
            yy: processRelativeTime$8,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    //! moment.js locale configuration

    hooks.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$6(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural$6(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    hooks.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural$4,
            m: relativeTimeWithPlural$4,
            mm: relativeTimeWithPlural$4,
            h: 'годину',
            hh: relativeTimeWithPlural$4,
            d: 'день',
            dd: relativeTimeWithPlural$4,
            M: 'місяць',
            MM: relativeTimeWithPlural$4,
            y: 'рік',
            yy: relativeTimeWithPlural$4,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$b = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days$2 = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    hooks.defineLocale('ur', {
        months: months$b,
        monthsShort: months$b,
        weekdays: days$2,
        weekdaysShort: days$2,
        weekdaysMin: days$2,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    hooks.locale('en');

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("E4vQ")(module)))

/***/ }),

/***/ "9j1/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listen events for Device Model
 */
angular.module('listeners').service('DevicesListener', function () {

    _RFC2.default.subscribe('socket:devices', function (response) {

        if (response.verb === 'POST') {

            _index.DevicesRepository.add(response.payload.data);
        }

        if (response.verb === 'PUT') {

            _index.DevicesRepository.update(response.payload.data);
        }

        if (response.verb === 'DELETE') {

            _index.DevicesRepository.remove(response.payload.data.id);
        }
    });
});

/***/ }),

/***/ "9u6A":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu"),
    root = __webpack_require__("VjBI");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "9wlN":
/***/ (function(module, exports) {

module.exports = "<div ui-view class=\"fade\"></div>\n<div vc-recaptcha\n    class=\"captcha2\"\n    key=\"Recaptcha.captchaKey\"\n    on-create=\"Recaptcha.setWidgetId(widgetId)\"\n    on-success=\"setCaptchaResponse(response)\"\n    size=\"invisible\">\n</div>"

/***/ }),

/***/ "9xPA":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-addDevice\" connectqa-modal=\"deploy-by-os\">\n    <div class=\"content-wrapper\">\n        <div class=\"top-elements\">\n            <i class=\"icon icon-avira-logo mb20\"></i>\n            <h2 class=\"text-xxl2 text-grey-2 mb10\" translate=\"cw.deploy.install_app\" translate-values=\"{app: chooseDeviceOsDeploymentWizardCtrl.app.attributes.resource.oeName}\"></h2>\n            <p class=\"text-l text-grey-2 mb25\" translate=\"cw.deploy.add_new_subtitle\" translate-values=\"{app: chooseDeviceOsDeploymentWizardCtrl.app.attributes.resource.oeName}\"></p>\n            <p class=\"text-m text-grey-4 mb20\" translate=\"cw.deploy.select_your_os\"></p>\n\n            <div class=\"content-wrapper-select\">\n                <ul>\n                    <li ng-repeat=\"os in chooseDeviceOsDeploymentWizardCtrl.supportedOs\"\n                        class=\"deploy-e\"\n                        ng-click=\"chooseDeviceOsDeploymentWizardCtrl.deployOn(os);\" connectqa-deploy-os=\"{{os}}\">\n                        <div class=\"icon icon-m icon-{{os | lowercase}} icon-grey-3 icon-inner-shadow-gray mt20\"></div>\n                        <span translate=\"cw.general.os.{{os | lowercase}}\" class=\"text-grey-3 inline-block text-m mt15\"></span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "A1RL":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"mya-section-info mb20\">\n        <h1 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.profile.picture.title\"></h1>\n        <p class=\"text-m mt5 text-grey-3\" translate=\"cw.profile.picture.desc\"></p>\n    </div>\n\n    <div class=\"mya-section-forms\">\n\n        <div class=\"profile-picture-elements\">\n            <div class=\"picture-holder\" ng-class=\"{'no-pic': !user.attributes.profile_image_medium}\">\n                <div class=\"no-picture-holder\" ng-if=\"!user.attributes.profile_image_medium\">\n                    <span class=\"text-white inline-block text-xxl\">\n                        {{user.attributes.first_name.toUpperCase() | limitTo: 1}}\n                        {{user.attributes.last_name.toUpperCase() | limitTo: 1}}\n                    </span>\n                </div>\n                <img ng-if=\"user.attributes.profile_image_medium\"\n                     ng-src=\"{{user.attributes.profile_image_medium}}\" />\n            </div>\n\n            <div>\n                <div class=\"upload-button-holder\">\n                    <input type=\"file\" id=\"inputFile\" ng-click=\"profileImageCtrl.onOpenFileBrowser()\" connectqa-mya=\"upload-picture\"/>\n                    <span class=\"btn btn-medium btn-secondary\" translate=\"cw.profile.picture.upload_btn\"></span>\n                </div>\n                <a class=\"text-s link crs-pointer v-middle\"\n                    ng-click=\"profileImageCtrl.removeImage('delete')\" translate=\"cw.my_devices.link.remove\"\n                    ng-if=\"user.attributes.profile_image_medium\" connectqa-mya=\"remove-picture\"></a>\n            </div>\n        </div>\n\n        <div class=\"text-m text-red-2 mt15\">\n            <p ng-if=\"imageFile.error === 'tooLarge'\" translate=\"cw.profile.picture.alerts.size_exceeded\"></p>\n            <p ng-if=\"imageFile.error === 'wrongFormat'\" translate=\"cw.profile.picture.alerts.wrong_format\"></p>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "A4qa":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy-steps\" ng-show=\"!hideBreadcrumb\">\n    <div ng-repeat=\"step in breadcrumbSteps\">\n        <div\n            class=\"step\"\n            ng-click=\"step.status === 'done' && !$last && breadcrumbClick(step.id)\"\n            ng-class=\"{'active': step.status === 'active',\n                    'done': step.status === 'done',\n                    'crs-pointer': !$last && step.status === 'done'}\">\n            <span class=\"number\">{{$index + 1}}</span>\n            <i class=\"icon icon-checked2\"></i>\n            <span>{{step.name}}</span>\n        </div>\n        <div class='separator' ng-if=\"!$last\"></div>\n    </div>\n</div>"

/***/ }),

/***/ "ACWg":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-bank-accounts\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.bank_accounts.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"bankAccount in bankAccounts.entries\">\n                            <div class=\"col-0 col-text text-left\">\n                                <p class=\"text-grey-1 text-l\" ng-if=\"!bankAccount.showUpdateInput\">\n                                    {{bankAccount.name}} {{bankAccount.iban ? '- ' + bankAccount.iban : ''}} {{bankAccount.accountNumber ? '- ' + bankAccount.accountNumber.slice(-4) : ''}}\n                                </p>\n                                <div class=\"mb20\" ng-if=\"bankAccount.showUpdateInput\">\n                                    <input type=\"text\"\n                                        ng-class=\"{'error': !bankNameIsValid}\"\n                                        name=\"bankName\"\n                                        minlength=\"3\"\n                                        maxlength=\"25\"\n                                        autocomplete=\"off\"\n                                        value=\"{{bankAccount.name}}\"\n                                        placeholder=\"{{ 'cw.dwm.entity.bank_accounts.bank_name' | translate }}\"\n                                        class=\"update-bank-name\"\n                                        ng-keyup=\"updateBankName($event);\">\n                                    <p class=\"error-message\" ng-show=\"!bankNameIsValid\"\n                                        translate=\"cw.dwm.entity.bank_account.errors.valid_bank_name\">\n                                    </p>\n                                </div>\n                                <div class=\"mb20\" ng-if=\"bankAccount.showUpdateInput\">\n                                    <input type=\"text\"\n                                        ng-class=\"{'error': !ibanIsValid}\"\n                                        name=\"iban\"\n                                        minlength=\"3\"\n                                        maxlength=\"34\"\n                                        autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.general.iban' | translate }}\"\n                                        class=\"update-bank-iban\"\n                                        ng-keyup=\"updateiban($event);\">\n                                    <p class=\"error-message\" ng-show=\"!ibanIsValid\"\n                                        translate=\"cw.dwm.entity.bank_account.errors.valid_iban\">\n                                    </p>\n                                </div>\n                                <div ng-if=\"bankAccount.showUpdateInput\">\n                                    <input type=\"text\"\n                                        ng-class=\"{'error': !bankAccountNumberIsValid}\"\n                                        name=\"bankAccountNumber\"\n                                        minlength=\"4\"\n                                        maxlength=\"34\"\n                                        autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.dwm.entity.bank_accounts.bank_account_number_optional' | translate }}\"\n                                        ng-keyup=\"updateBankAccountNumber($event);\">\n                                    <p class=\"error-message\" ng-show=\"!bankAccountNumberIsValid && bankAccountNumberIsNumeric\"\n                                        translate=\"cw.dwm.entity.bank_account.errors.valid_bank_account_number\">\n                                    </p>\n                                    <p class=\"error-message\" ng-show=\"!bankAccountNumberIsNumeric\"\n                                        translate=\"cw.dwm.entity.bank_account.errors.numeric\">\n                                    </p>\n                                </div>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!bankAccount.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-0 col-text text-left\">\n                                <div class=\"mb20\">\n                                    <input type=\"text\" ng-class=\"{'error': !bankNameIsValid}\"\n                                        name=\"bankName\" ng-model=\"newBankName\" minlength=\"3\" maxlength=\"25\" autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.dwm.entity.bank_accounts.bank_name' | translate }}\"\n                                        id=\"bankName\" class=\"update-bank-name\" ng-keyup=\"validateBankName($event)\">\n                                        <p class=\"error-message\" ng-show=\"!bankNameIsValid\"\n                                            translate=\"cw.dwm.entity.bank_account.errors.valid_bank_name\">\n                                        </p>\n                                </div>\n                                <div class=\"mb20\">\n                                    <input type=\"text\" ng-class=\"{'error': !ibanIsValid}\"\n                                        name=\"iban\" ng-model=\"newIban\" minlength=\"3\" maxlength=\"34\" autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.general.iban' | translate }}\"\n                                        id=\"iban\" class=\"update-bank-iban\" ng-keyup=\"validateiban($event)\">\n                                        <p class=\"error-message\" ng-show=\"!ibanIsValid\"\n                                            translate=\"cw.dwm.entity.bank_account.errors.valid_iban\">\n                                        </p>\n                                </div>\n                                <div>\n                                    <input type=\"text\" ng-class=\"{'error': !bankAccountNumberIsValid}\"\n                                        name=\"bankAccountNumber\" ng-model=\"newBankAccountNumber\" minlength=\"4\" maxlength=\"34\" autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.dwm.entity.bank_accounts.bank_account_number_optional' | translate }}\"\n                                        id=\"bankAccountNumber\" ng-keyup=\"validateBankAccountNumber($event)\">\n                                        <p class=\"error-message\" ng-show=\"!bankAccountNumberIsValid && bankAccountNumberIsNumeric\"\n                                            translate=\"cw.dwm.entity.bank_account.errors.valid_bank_account_number\">\n                                        </p>\n                                        <p class=\"error-message\" ng-show=\"!bankAccountNumberIsNumeric\"\n                                            translate=\"cw.dwm.entity.bank_account.errors.numeric\">\n                                        </p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.bank_accounts.remove_bank_account_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.bank_accounts.remove_bank_account_desc\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.bank_accounts.entity_details.title\"></h3>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.bank_accounts.entity_details.desc\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\" ng-if=\"showAddNewButton && (bankAccounts.maxCount > bankAccounts.entries.length)\"\n                ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewBankAccountIsLoading}\"\n                    ng-disabled=\"saveNewBankAccountIsLoading || !ibanIsValid || !bankAccountNumberIsValid\"\n                    ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !ibanIsValid || !bankAccountNumberIsValid\"\n                    ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/bank-accounts/bank-accounts.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "AJH6":
/***/ (function(module, exports) {

module.exports = "<div>\n<div ng-if=\"customDebug\" ng-repeat=\"msg in debugObj.messages\">\n    <div ng-if=\"(msg.type === 'string')\" class=\"red-text\">\n        {{msg.options.text}}\n    </div>\n    <div ng-if=\"(msg.type === 'object')\">\n        <span class=\"{{msg.options.color}}-text\">{{msg.options.type}}</span>\n        <span class=\"black-background\">{{msg.options.cmd}}</span>\n        <span class=\"blue-text\">({{msg.options.cid || ''}})</span>\n        <span class=\"red-text\">{{msg.options.duration}}</span>\n        <span class=\"blue-text\">{{msg.options.user}}</span>\n        {{msg.options.msg}}\n    </div>\n</div>\n</div>\n"

/***/ }),

/***/ "Abc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("YW9j");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$scope', 'Util', 'Auth', 'GdprActionsRestService'];

var _$rootScope = void 0;
var _$scope = void 0;
var _Util = void 0;
var _Auth = void 0;
var _User = void 0;
var _GdprActionsRestService = void 0;
var _formIsValid = null;
var _formPasswordValue = void 0;

/**
 * @ngdoc service
 * @name controllers.DeleteAccountConfirmation
 *
 * @description
 * Crop Image controller
 */

var DeleteAccountConfirmation = function () {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} GdprActionsRestService
     */

    function DeleteAccountConfirmation($rootScope, $scope, Util, Auth, GdprActionsRestService) {
        _classCallCheck(this, DeleteAccountConfirmation);

        _Util = Util;
        _Auth = Auth;
        _GdprActionsRestService = GdprActionsRestService;
        _User = _index.MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;

        // functions
        _$scope.closeModal = this.closeModal;
        _$scope.setEmail = this.setEmail;
        _$scope.confirmDeleteAccount = this.confirmDeleteAccount;
        _$scope.continueToPassword = this.continueToPassword;

        // variables

        _$scope.authError = false;
        _$scope.loading = false;
        _$scope.loadingConfirm = false;
        _$scope.failedLogins = 0;
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        _$scope.passwordStep = false;
        _$scope.submitted = false;

        var logintype = _RFC6.default.get(CWCONFIG.cookie.loginType);
        _$scope.socialLogin = logintype === 'gg_auth' || logintype === 'fb_auth' || logintype === 'apl_auth';

        _$scope.$on('$destroy', function () {

            delete $rootScope.passwordConfirmationFor;
        });
    }

    _createClass(DeleteAccountConfirmation, [{
        key: 'closeModal',
        value: function closeModal() {

            _Util.closeModal();
        }
    }, {
        key: 'continueToPassword',
        value: function continueToPassword() {

            _$scope.passwordStep = true;
        }
    }, {
        key: 'confirmDeleteAccount',
        value: function confirmDeleteAccount() {
            var _this = this;

            if (this.verifyIdentityForm) {

                _formIsValid = this.verifyIdentityForm.$valid;

                _formPasswordValue = this.verifyIdentityForm.password.$viewValue;
            }

            if (_formIsValid || _$scope.socialLogin) {

                _$scope.loadingConfirm = true;

                var payload = {
                    data: {
                        attributes: {
                            action_type: 'gdpr_delete_account'
                        }
                    },
                    meta: {
                        delete_source: 'dashboard',
                        password: _formPasswordValue
                    }
                };

                _GdprActionsRestService.create(payload).then(function () {

                    _RFC4.default.send('ConnectWeb Delete Account Confirm');

                    localStorage.removeItem('lastLogin');
                    _Auth.logOut();
                }).then(null, function (error) {

                    var errorReason = void 0;
                    _$scope.loadingConfirm = false;

                    if (_Util.deepFind(error, 'data.error')) {

                        errorReason = error.data.code;
                    } else if (_Util.deepFind(error, 'data.errors')) {

                        errorReason = error.data.errors[0].code;
                    }

                    if (errorReason === '1808') {

                        _this.closeModal();
                        _RFC2.default.error('cw.delete_account.already_requested_error');
                    } else if (error.data.error === 'invalid_credentials') {

                        _this.closeModal();
                        _RFC2.default.error('cw.auth.login.error.email_password');
                    } else {

                        _this.closeModal();
                        _RFC2.default.error('cw.delete_account.error');
                    }
                });
            } else {

                _$scope.submitted = true;

                _Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'setEmail',
        value: function setEmail() {

            _$rootScope.forgotEmail = _User.attributes.email;
        }
    }]);

    return DeleteAccountConfirmation;
}();

_serviceDependencies.push(DeleteAccountConfirmation);

angular.module('controllers').controller('DeleteAccountConfirmation', _serviceDependencies);

/***/ }),

/***/ "AeKI":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "Ah1u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("poBF");

(function () {

    /**
     * Body controller
     */
    angular.module('controllers').controller('DashboardBody', ['$scope', function ($scope) {

        var devicesObservable = _index.DevicesProcessor.getObservable();
        var onNextDevice = function onNextDevice() {

            $scope.hasDevices = _index.DevicesProcessor.hasDisplayedDevices();
            $scope.hasMobileDevices = _index.DevicesProcessor.hasAtLeastOnePhoneOrTablet();
        };
        var devicesSubscriber = devicesObservable.subscribe(onNextDevice, function () {}, function () {});

        $scope.$on('$destroy', function () {

            devicesSubscriber.dispose();
        });
    }]);
})();

/***/ }),

/***/ "Akpe":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"card-header\">\n        <h3 class=\"text-grey-1 text-l font-bold\" ng-if=\"showDWMLitecard || showAIAcard\" translate=\"cw.homepage.dwm.title\"></h3>\n        <h3 class=\"text-grey-1 text-l font-bold\" ng-if=\"showDWMLiteUpsellcard\" translate=\"cw.homepage.dwm.upsell_title\"></h3>\n        <h3 class=\"text-grey-1 text-l font-bold\" ng-if=\"showAIAAddMoreDatacard\" translate=\"cw.dwm.tabs.dwm\"></h3>\n        <h3 class=\"text-grey-1 text-l font-bold\" ng-if=\"showAIAUnreadNotificationscard\" translate=\"cw.homepage.dwm.unread_notifications_title\"></h3>\n        <i class=\"icon icon-warning-filled icon-orange-2\" ng-if=\"showDWMLitecard || showAIAcard\"></i>\n        <div class=\"notifications-dot\" ng-if=\"showAIAUnreadNotificationscard\"></div>\n    </div>\n    <div class=\"inline-block left-column text-center v-middle\">\n        <div class=\"icon icon-dwm\"\n            ng-class=\"{'icon-grey-3': showAIAAddMoreDatacard || showAIAUnreadNotificationscard,\n                'icon-orange-2': showDWMLitecard || showAIAcard || showDWMLiteUpsellcard}\">\n        </div>\n    </div>\n    <div class=\"inline-block right-column v-middle\">\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showDWMLitecard\" translate=\"cw.homepage.dwm.desc_dwm_lite\"></p>\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showAIAcard\" translate=\"cw.homepage.dwm.desc_aia\"></p>\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showDWMLiteUpsellcard\" translate=\"cw.homepage.dwm.desc_dwm_lite_upsell\"></p>\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showAIAAddMoreDatacard\" translate=\"cw.homepage.dwm.desc_aia_add_more_data\"></p>\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showAIAUnreadNotificationscard && notifications === 1\"\n            translate=\"cw.homepage.dwm.desc_unread_notifications_one\">\n        </p>\n        <p class=\"text-s text-grey-3 mb5\" ng-if=\"showAIAUnreadNotificationscard && notifications > 1\"\n            translate=\"cw.homepage.dwm.desc_unread_notifications_multiple\"\n            translate-values=\"{notifications : notifications}\">\n        </p>\n        <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n            class=\"text-s text-blue-1 bottom-link\"\n            ng-click=\"turnOnDwm('DWM Lite')\"\n            ng-if=\"showDWMLitecard\"\n            translate=\"cw.homepage.dwm.action\">\n        </a>\n        <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n            class=\"text-s text-blue-1 bottom-link\"\n            ng-click=\"turnOnDwm('AIA')\"\n            ng-if=\"showAIAcard\"\n            translate=\"cw.homepage.dwm.action\">\n        </a>\n        <a ui-sref=\"root.dashboard.dwm({tab: 'store'})\"\n            class=\"text-s text-blue-1 bottom-link\"\n            ng-click=\"sendMixpanelEvent('DWM Lite Upsell')\"\n            ng-if=\"showDWMLiteUpsellcard\"\n            translate=\"cw.homepage.general.see_more\">\n        </a>\n        <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n            class=\"text-s text-blue-1 bottom-link\"\n            ng-click=\"sendMixpanelEvent('AIA Add more data')\"\n            ng-if=\"showAIAAddMoreDatacard\"\n            translate=\"cw.homepage.general.add_more_data\">\n        </a>\n        <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n            class=\"text-s text-blue-1 bottom-link\"\n            ng-click=\"sendMixpanelEvent('AIA Unread Notifications'); setScrollToNotifications()\"\n            ng-if=\"showAIAUnreadNotificationscard\"\n            translate=\"cw.homepage.general.see_more\">\n        </a>\n    </div>\n</div>"

/***/ }),

/***/ "B2oT":
/***/ (function(module, exports) {

module.exports = "<div class=\"faq tab-content\">\n    <div class=\"dwm-card-header display-flex justify-content-space-between align-item-center\">\n        <div class=\"w100\">\n            <i class=\"icon-crypto-faq icon inline-block large-icon\"></i>\n            <h2 class=\"inline-block v-middle text-grey-1\" translate=\"cw.dashboard.crypto.faq.title\">\n            </h2>\n        </div>\n    </div>\n    <div class=\"faq-wrapper display-flex justify-content-space-between align-item-flex-start mt40\">\n        <div class=\"questions\">\n            <ul>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q1', 'crs-pointer text-grey-4': activeQuestion !== 'q1'}\"\n                        ng-click=\"changeQuestion('q1')\" translate=\"cw.dashboard.dwm.faq.q_1\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q2', 'crs-pointer text-grey-4': activeQuestion !== 'q2'}\"\n                        ng-click=\"changeQuestion('q2')\" translate=\"cw.dashboard.dwm.faq.q_2\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q3', 'crs-pointer text-grey-4': activeQuestion !== 'q3'}\"\n                        ng-click=\"changeQuestion('q3')\" translate=\"cw.dashboard.dwm.faq.q_3\"></p>\n                </li>\n            </ul>\n        </div>\n        <div class=\"answers\">\n            <div ng-if=\"activeQuestion === 'q1'\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_1_desc_1\"></p>\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_1_desc_2\"></p>\n                <p class=\"text-m text-grey-4 mb20\" translate=\"cw.dashboard.dwm.faq.a_1_desc_3\"></p>\n                <iframe width=\"100%\" height=\"315\"\n                    ng-if=\"currentLanguage !== 'de'\"\n                    src=\"https://www.youtube.com/embed/c3uOvBrb8gs\"\n                    title=\"YouTube video player\"\n                    frameborder=\"0\"\n                    allow=\"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\n                    allowfullscreen></iframe>\n                <iframe width=\"100%\" height=\"315\"\n                    ng-if=\"currentLanguage === 'de'\"\n                    src=\"https://www.youtube.com/embed/y1GBDMMlXXg\"\n                    title=\"YouTube video player\"\n                    frameborder=\"0\"\n                    allow=\"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture\"\n                    allowfullscreen></iframe>\n            </div>\n            <div ng-if=\"activeQuestion === 'q2'\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_2_desc_1\"></p>\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_2_desc_2\"></p>\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_2_desc_3\"></p>\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.dwm.faq.a_2_desc_4\"></p>\n            </div>\n            <div ng-if=\"activeQuestion === 'q3'\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_3_desc_1\"></p>\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.dwm.faq.a_3_desc_2\"></p>\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.dwm.faq.a_3_desc_3\"></p>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "BE9B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable max-len */
/* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmBankAccounts = function DwmBankAccounts($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmBankAccounts);

    $scope.ibanIsValid = true;
    $scope.bankNameIsValid = true;
    $scope.bankAccountNumberIsValid = true;
    $scope.bankAccountNumberIsNumeric = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};
        if (assets.primaryMember) {

            $scope.bankAccounts = assets.primaryMember.monitoredAccounts.bankAccounts;

            $scope.bankAccounts.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('.update-bank-name').trigger('focus');
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.ibanIsValid = true;
        $scope.bankNameIsValid = true;
        $scope.bankAccountNumberIsValid = true;
        $scope.bankAccountNumberIsNumeric = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newIban = '';
        $scope.newBankName = '';
        $scope.newBankAccountNumber = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.bankAccounts.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                $scope.updateEntryPayload = entry;

                // Save initial entry values to use in case of update is canceled
                $scope.initialIban = entry.iban;
                $scope.initialBankName = entry.name;
                $scope.intialBankAccountNumber = entry.accountNumber;
                $scope.initialEntryIndex = loopIndex;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-bank-name').trigger('focus');
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.ibanIsValid = true;
        $scope.bankNameIsValid = true;
        $scope.bankAccountNumberIsValid = true;
        $scope.bankAccountNumberIsNumeric = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.bankAccounts.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};

        // Revert changes of the selected entry
        $scope.bankAccounts.entries[$scope.initialEntryIndex].name = $scope.initialBankName;
        $scope.bankAccounts.entries[$scope.initialEntryIndex].iban = $scope.initialIban;
        $scope.bankAccounts.entries[$scope.initialEntryIndex].accountNumber = $scope.intialBankAccountNumber;
    };

    $scope.validateBankName = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.bankNameIsValid = $event.currentTarget.value && validations.bankNameValidator($event.currentTarget.value.trim());
        }

        $scope.newBankName = $event.currentTarget.value;
    };

    $scope.validateiban = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.ibanIsValid = $event.currentTarget.value && validations.ibanValidator($event.currentTarget.value.trim());
        }

        $scope.newIban = $event.currentTarget.value;
    };

    $scope.validateBankAccountNumber = function ($event) {

        if ($scope.newEntrySubmitted) {

            if ($event.currentTarget.value.length) {

                $scope.bankAccountNumberIsValid = $event.currentTarget.value && validations.bankAccountNumberValidator($event.currentTarget.value.trim());
                $scope.bankAccountNumberIsNumeric = $event.currentTarget.value && /^\d+$/.test($event.currentTarget.value.trim());
            } else {

                $scope.bankAccountNumberIsValid = true;
                $scope.bankAccountNumberIsNumeric = true;
            }
        }

        $scope.newBankAccountNumber = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.ibanIsValid = $scope.newIban === undefined ? false : validations.ibanValidator($scope.newIban.trim());

        $scope.bankNameIsValid = $scope.newBankName === undefined ? false : validations.bankNameValidator($scope.newBankName.trim());

        if ($scope.newBankAccountNumber) {

            $scope.bankAccountNumberIsValid = validations.bankAccountNumberValidator($scope.newBankAccountNumber.trim());
            $scope.bankAccountNumberIsNumeric = $scope.newBankAccountNumber === undefined ? false : /^\d+$/.test($scope.newBankAccountNumber.trim());
        } else {

            $scope.bankAccountNumberIsValid = true;
        }

        $scope.newEntrySubmitted = true;

        if ($scope.ibanIsValid && $scope.bankAccountNumberIsValid && $scope.bankNameIsValid) {

            $scope.saveNewBankAccountIsLoading = true;

            var payload = {
                bankAccounts: {
                    iban: $scope.newIban,
                    name: $scope.newBankName,
                    accountNumber: $scope.newBankAccountNumber,
                    type: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newIban = '';
                $scope.newBankName = '';
                $scope.newBankAccountNumber = '';
                $scope.saveNewBankAccountIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;

                    _RFC4.default.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Bank accounts'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewBankAccountIsLoading = false;

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            bankAccounts: {
                id: $scope.bankAccounts.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newIban = '';
            $scope.newBankName = '';
            $scope.newBankAccountNumber = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Bank Account', monitoredAccounts.bankAccounts.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Bank accounts'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.updateBankName = function ($event) {

        $scope.bankNameIsValid = $event.currentTarget.value && validations.bankNameValidator($event.currentTarget.value.trim());

        if ($scope.bankNameIsValid) {

            $scope.updateEntryPayload.name = $event.currentTarget.value;
        }
    };

    $scope.updateiban = function ($event) {

        $scope.ibanIsValid = $event.currentTarget.value && validations.ibanValidator($event.currentTarget.value.trim());

        if ($scope.ibanIsValid) {

            $scope.updateEntryPayload.iban = $event.currentTarget.value;
        }
    };

    $scope.updateBankAccountNumber = function ($event) {

        $scope.bankAccountNumberIsValid = $event.currentTarget.value && validations.bankAccountNumberValidator($event.currentTarget.value.trim());
        $scope.bankAccountNumberIsNumeric = $event.currentTarget.value && /^\d+$/.test($event.currentTarget.value.trim());

        if ($scope.bankAccountNumberIsValid) {

            $scope.updateEntryPayload.accountNumber = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { bankAccounts: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Bank accounts'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data.errorCode === 4013) {

                _RFC2.default.error('cw.dwm.dupliacte_entry_error');
            } else {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };
};

_serviceDependencies.push(DwmBankAccounts);

angular.module('controllers').controller('DwmBankAccounts', _serviceDependencies);

/***/ }),

/***/ "BRoG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFCSession = __webpack_require__("DyxV");

var _initi18n = __webpack_require__("6/rD");

var _initi18n2 = _interopRequireDefault(_initi18n);

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$q', '$rootScope', '$location', '$window', 'Util', 'Auth', 'Redirect', 'Sso', '$http', '$state'];

/**
* @ngdoc service
* @name services.RootResolver
*
* @description
* This class is the Application Root Resolver. Here we check:
* 1. if the user is anonymous
* 2. if the user's email is confirmed
* 2. if token exists
* 3. if the URL has parameters
* After this steps we redirect the user accordingly.
*/

var RootResolver = function () {

    /**
     * @param  {any} $q
     * @param  {any} $rootScope
     * @param  {any} $location
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} Redirect
     * @param  {any} Sso
     */

    function RootResolver($q, $rootScope, $location, $window, Util, Auth, Redirect, Sso, $http, $state) {
        var _this = this;

        _classCallCheck(this, RootResolver);

        $rootScope.State.loading = true;

        this.rootPromise = $q.defer();
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.Util = Util;
        this.Auth = Auth;
        this.Redirect = Redirect;
        this.path = $location.path();
        this.MeRepository = _index.MeRepository;
        this.meSubscriber = {};
        this.Sso = Sso;
        this.hasSeenConfirmationScreen = false;
        this.$state = $state;

        this.initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));

        $http({

            method: 'GET',
            url: CWCONFIG.restApi.url + 'ping'
        }).then(function (response) {

            if (response.headers) {

                var headers = response.headers();
                $rootScope.requestCountry = Util.deepFind(headers, 'x-avira-country-code');
            }
        }).catch(function (error) {

            var errorObj = _this.Util.deepFind(error, 'data.errors')[0];
            var errorCode = _this.Util.deepFind(errorObj, 'code');

            if (errorCode === '929') {

                $rootScope.isComingFromEmbargoedCountry = true;

                _RFC4.default.send('ConnectWeb Restricted Country');
                if (_this.initialUrl.indexOf('client_id=spotlight') > -1) {

                    _this.$state.go('complianceFailed');
                }
            }
        });

        // SSO save extra url params for thirdParty login
        this.Sso.saveExtraParams();

        // observable for MeRepository
        var meObservable = _index.MeRepository.getObservable();
        var onNextMe = function onNextMe(user) {

            // if user exists and is not newly registered
            // we need to show the confirmation page later because the launcher authentication
            // depends on the second /oauth POST we make after we create the user
            if (user && !_this.$rootScope.newRegisteredUser) {

                _this.checkUserAndRedirect();
            }
        };
        this.meSubscriber = meObservable.subscribe(onNextMe, function () {}, function () {});

        // whether the translations used for the react components
        // load we still want to show the dashboard currently
        // this behaviour might change in the future
        // also wait until the SSO exhanges the received JWT with a dashboard JWT
        Promise.all([(0, _initi18n2.default)(), this.Sso.exchangeToken()]).then(function (params) {

            _this.init(params);
        }).catch(function () {

            _this.init();
        });

        return this.rootPromise.promise;
    }

    _createClass(RootResolver, [{
        key: 'init',
        value: function init(params) {

            this.userHasToken = this.Util.getToken();
            var functionParams = params || [];
            var tokenScope = functionParams.find(function (item) {
                return item === 'passwords';
            });

            /* if token exists and the URL has no extra params, get user data from backend */
            if (this.userHasToken && !this.urlHasExtraParams() && this.Sso.enableAutoLogon() && tokenScope !== 'passwords') {

                this.Auth.getMeAsync();
            } else {

                /* if the url has extra params like jwt,
                myat etc, we resolve the promise and we don't get user data from here.
                The GET command with the user data will be executed from Auth.js service.  */
                this.rootPromise.resolve();

                /* hide loading state after root resolver is ready and url has no params */
                if (!this.urlHasExtraParams()) {

                    this.$rootScope.State.loading = false;
                }
            }
        }

        // check if the url has extra params

    }, {
        key: 'urlHasExtraParams',
        value: function urlHasExtraParams() {

            return !!(this.path.indexOf('/auth/login') === 0 && (/auth\/login\/t/.test(this.path) || /auth\/login\/adt/.test(this.path) || /auth\/login\/myat/.test(this.path) || /auth\/login\/jwt/.test(this.path)));
        }

        // check user status and redirect him accordingly

    }, {
        key: 'checkUserAndRedirect',
        value: function checkUserAndRedirect() {
            var _this2 = this;

            this.rootPromise.resolve();
            var user = this.MeRepository.getMyUser();
            var isNewUser = this.Util.deepFind(user, 'attributes.password_not_set');
            var gdprConfirmed = this.Util.deepFind(user, 'attributes.gdpr_confirm');
            var tfaStatus = this.Util.deepFind(user, 'attributes.status_tfa');
            var tfaCookie = this.Auth.getTfaCookie();
            var tfaSessionStorage = sessionStorage.getItem('TfaSessionStorage');
            var usCompliance = user.attributes.status_us_compliance_approved;
            var usComplianceRequested = user.attributes.status_us_compliance_requested;
            var loginType = _RFC2.default.get(CWCONFIG.cookie.loginType);

            if (this.$rootScope.isComingFromEmbargoedCountry && this.initialUrl.indexOf('client_id=spotlight') > -1) {

                this.$state.go('complianceFailed');
            } else if (this.Util.isAnonymous()) {

                if (this.Sso.isThirdPartyLogin() && this.Sso.getEmailAddress() || this.initialUrl.indexOf('action=gotologin') > -1) {

                    this.Auth.gotoLogin();
                } else {

                    // if the user is anonymous, go to register page
                    this.Auth.gotoRegister();
                }
            } else if (usCompliance === null && !usComplianceRequested) {

                if (loginType === 'fb_auth' || loginType === 'gg_auth' || loginType === 'apl_auth') {

                    this.$rootScope.socialLoginValidation = true;
                    this.$rootScope.userCheckSync = true;
                    this.Auth.gotoRegister();
                } else if (this.initialUrl.indexOf('client_id=spotlight') > -1 && this.initialUrl.indexOf('action=user_check_sync') > -1) {

                    this.$rootScope.socialLoginValidation = true;
                    this.$rootScope.userCheckSync = true;
                    this.Auth.gotoRegister();
                } else if (isNewUser) {

                    this.Auth.gotoSetPassword();
                } else {

                    this.$rootScope.socialLoginValidation = true;
                    this.Auth.gotoRegister();
                }
            } else if (!gdprConfirmed || gdprConfirmed === '') {

                this.hasSeenConfirmationScreen = true;
                this.Auth.gotoConfirm();
            } else if (tfaStatus === 'active' && !tfaCookie && !tfaSessionStorage && this.path === '/auth/login') {

                /* if user's two-factor authentification is active and the browser is not trusted,
                it means that the user should go through all login steps (must be logged out) */
                this.Auth.logOut();
            } else if (this.Sso.isThirdPartyLogin()) {

                // SSO check for thirdPartyLogin and
                // redirect user after login to the received redirect_uri with the token
                this.Sso.redirect();
            } else if (isNewUser) {

                // if user doesn't have a password
                this.Auth.gotoSetPassword();
            } else if (!user.attributes.email) {

                /* if user's email or option attributes are null and is not anonymous, it means that
                the user configuration has a problem and must be logged out */
                this.Auth.logOut();
            } else {

                /* this condition prevents overwriting the dashboard language from URL parameter.
                When you are logged in dasbhoard,
                the language can be changed only from My Account options */
                if (CWCONFIG.language !== user.attributes.language) {

                    // Keep the received params in auth page
                    var extraUrlParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams);

                    var acceptedDomains = ['https://my.avira.com', 'https://oeacc.avira.com', 'https://beta.my.avira.com', 'https://beta.oeacc.avira.com'];

                    var isAcceptedDomain = false;

                    acceptedDomains.forEach(function (domain) {

                        if (window.location.href.indexOf(domain) === 0) {

                            isAcceptedDomain = true;
                        }
                    });

                    var unsafeCharacters = ['(', ')', '[', ']', '{', '}', '<', '>', '^', '|', 'javascript'];

                    var hasUnsafeChars = unsafeCharacters.find(function (char) {
                        return _this2.$window.location.href.indexOf(char) > -1;
                    });

                    if (isAcceptedDomain && !hasUnsafeChars) {

                        if (extraUrlParams) {

                            // this condition prevents the duplication of the parameters
                            if (this.$window.location.href.indexOf(extraUrlParams) === -1) {

                                this.$window.location.href = '' + this.$window.location.href.replace(CWCONFIG.language, user.attributes.language) + extraUrlParams;
                            } else {

                                this.$window.location.href = this.$window.location.href.replace(CWCONFIG.language, user.attributes.language);
                            }
                        } else {

                            this.$window.location.pathname = this.$window.location.pathname.replace(CWCONFIG.language, user.attributes.language);
                        }
                    } else {

                        this.$window.location.href = 'https://my.avira.com';
                    }
                }

                // close confirmation screen from Spotlight if the user is confirmed
                if (this.hasSeenConfirmationScreen && window.external && 'CloseHtml' in window.external) {

                    window.external.CloseHtml('confirmed');
                } else {

                    /* redirect to dashboard if the user's email is confirmed
                    and the route is not already /dashboard */

                    // Some URLs need to be redirected (old routes)
                    this.Redirect.redirectUrl();
                }

                /* unsubscribe meObservable after we make sure the user
                is not anonymous or the email is confirmed */
                this.meSubscriber.dispose();
            }
        }
    }]);

    return RootResolver;
}();

_serviceDependencies.push(RootResolver);

angular.module('services').service('RootResolver', _serviceDependencies);

/***/ }),

/***/ "Bn/k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint array-callback-return: 0 */
/* eslint consistent-return: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['DeploymentUrlsRestService', '$window', '$timeout', '$scope', '$rootScope', 'Util', '$state'];

var WebAppDeploymentController = function () {
    function WebAppDeploymentController(DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope, Util, $state) {
        _classCallCheck(this, WebAppDeploymentController);

        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.user = _index.MeRepository.getMyUser();
        this.Util = Util;
        this.LicensesRepository = _index.LicensesRepository;
        this.deployCheck = {
            isEmailValid: false,
            showEmailError: false
        };

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.osType = Util.deepFind(this.app, 'attributes.custom.manifest.compatibleWithServer') ? 'server' : 'desktop';
        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';

        this.$state = $state;

        _RFC6.default.broadcast('modal.closeBtn:hide');

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();
        }

        this.deployViaRedirect();
    }

    // find and return license from /licenses


    _createClass(WebAppDeploymentController, [{
        key: 'getLicense',
        value: function getLicense() {
            var _this = this;

            // try to get license from LicenseRepository based of app id (case for bundle)
            var licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);

            // license not found, try to find license based on component
            if (typeof licenseData === 'undefined') {

                var allLicenses = this.LicensesRepository.getAll();

                /**
                 * Search each appid of each license in appIntegrationRepository
                 */
                allLicenses.forEach(function (license) {

                    // bundle id of each license
                    var licenseBundleId = license.relationships.app.data.id;

                    // get app integration for the bundle id of license
                    var appIntegration = _index.AppIntegrationsRepository.getById(licenseBundleId);

                    // stop at first find
                    if (!licenseData && _this.Util.deepFind(appIntegration, 'relationships.apps')) {

                        // search component to be deployed (from URL) in components of the bundle
                        appIntegration.relationships.apps.data.find(function (app) {

                            // component found === license found
                            if (app.id === _this.$scope.inputData.appId) {

                                licenseData = license;
                                return true;
                            }
                        });
                    }
                });
            }

            return licenseData;
        }
    }, {
        key: 'deployViaRedirect',
        value: function deployViaRedirect() {
            var _this2 = this;

            _RFC4.default.send('ConnectWeb Deployment Download Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId
            });

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                license_number: this.licenseId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                // success handler

                var downloadUrl = _this2.Util.deepFind(response, 'data.data.attributes.download_url');
                var appId = _this2.Util.deepFind(response, 'data.data.attributes.appId');

                if (appId === 'adwp1') {

                    _this2.$timeout(function () {

                        _this2.$state.go('root.dashboard.dwm', {
                            tab: 'dwm'
                        });
                    }, 3000);
                } else if (downloadUrl) {

                    _this2.$timeout(function () {

                        _this2.$window.location.href = downloadUrl;
                    }, 3000);
                } else {

                    _RFC2.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {
                            cssClasses: 'icon-pc'
                        }
                    });
                    _this2.Util.closeModal();
                }
            }, function () {

                // error handler

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc'
                    }
                });
                _this2.Util.closeModal();
            });
        }
    }]);

    return WebAppDeploymentController;
}();

var WebAppDeploymentDirective = function WebAppDeploymentDirective() {
    _classCallCheck(this, WebAppDeploymentDirective);

    this.template = __webpack_require__("oNKH");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope, Util, $state) {
        return new WebAppDeploymentController(DeploymentUrlsRestService, $window, $timeout, $scope, $rootScope, Util, $state);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'webAppDeploymentCtrl';
};

_directiveDependencies.push(function () {
    return new WebAppDeploymentDirective();
});

angular.module('directives').directive('webAppDeployment', _directiveDependencies);

/***/ }),

/***/ "BqL9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loggers = __webpack_require__("+htc");

var _browser = __webpack_require__("W/hB");

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Http Interceptor for logging REST calls into the console.
 */
angular.module('services').factory('RetryRequestInterceptor', ['$injector', '$q', '$timeout', function ($injector, $q, $timeout) {

    var MAX_RETRIES = 3;
    var REQUEST_DELAY = 1000; // in milliseconds;
    var retryData = {
        attempts: 0,
        lastErrorCode: 'N/A'
    };

    return {
        responseError: function responseError(response) {

            // because there is an error appearing in IE
            // where the response.config seems to be undefined sometimes
            if (response && response.config) {

                // disable retry mechanism for ocp flow
                if (response.config.url.indexOf('/payments/') > -1) {

                    return $q.reject(response);
                }

                response.config.cwRetry = response.config.cwRetry || Object.assign({}, retryData);

                var errorCode = String(response.status);
                var isServerError = errorCode.lastIndexOf('5', 0) === 0 && errorCode.length === 3;
                var shouldRetryRequest = isServerError || errorCode === '-1' || errorCode === '0';

                if (shouldRetryRequest && response.config.cwRetry.attempts < MAX_RETRIES && response.config.method === 'GET') {

                    return $timeout(function () {

                        var $http = $injector.get('$http');
                        response.config.cwRetry.attempts += 1;
                        response.config.cwRetry.lastErrorCode = errorCode;

                        _loggers.httpLogger.log({
                            type: 'RCV HTTP REST',
                            cmd: 'SERVER.ERROR ' + response.config.method + ' ' + response.config.url,
                            data: {
                                msg: 'Request failed. This is retry attempt number ' + response.config.cwRetry.attempts
                            }
                        });

                        return $http(response.config);
                    }, REQUEST_DELAY);
                }
            }

            if (response && response.config && response.config.cwRetry && response.config.cwRetry.attempts === MAX_RETRIES) {

                Sentry.withScope(function (scope) {

                    scope.setLevel('error');
                    Sentry.captureMessage('Request retrying failed for ' + response.config.url + ' with errorCode: ' + response.config.cwRetry.lastErrorCode);
                });
            }

            // !!Important Must use promise api's q.reject()
            // to properly implement this interceptor
            // or the response will go the success handler of the caller
            return $q.reject(response);
        }
    };
}]);

/***/ }),

/***/ "BqaP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint vars-on-top: 0 */

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.DisableAccountController
 *
 * @description
 * edit form for user details controller
 */

var DisableAccountController = function DisableAccountController($scope) {
    _classCallCheck(this, DisableAccountController);

    this.$scope = $scope;
    this.$scope.linkText = CWCONFIG.partnerConfig.translationsLinks.mailToDataPrivacy.text;
    this.$scope.href = CWCONFIG.partnerConfig.translationsLinks.mailToDataPrivacy.href;
    this.$scope.brandName = CWCONFIG.partnerConfig.name;
};

/**
     * @ngdoc directive
     * @name directives.DisableAccountDirective
     *
     * @description
     * edit form for user details directive
     */


var DisableAccountDirective = function DisableAccountDirective() {
    _classCallCheck(this, DisableAccountDirective);

    this.template = __webpack_require__("FJvE");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope) {
        return new DisableAccountController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'disableAccountCtrl';
};

_directiveDependencies.push(function () {
    return new DisableAccountDirective();
});

angular.module('directives').directive('disableAccount', _directiveDependencies);

/***/ }),

/***/ "BrLi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint no-console: 0 */
/* eslint no-empty-function: 0 */
/* eslint no-continue: 0 */
/* eslint no-shadow: 0 */
/* eslint no-unused-vars: 0 */
/* eslint class-methods-use-this: 0 */
/* eslint no-restricted-syntax: 0 */
/* eslint no-constant-condition: 0 */

/**
 * @ngdoc service
 *
 * @description
 * Object comparer service to be reused across the application.
 */

var VALUE_CREATED = 'created';
var VALUE_UPDATED = 'updated';
var VALUE_DELETED = 'deleted';
var VALUE_UNCHANGED = 'unchanged';

var ObjectComparer = {
    getFlattenDiff: function getFlattenDiff(oldValue, newValue) {

        var diff = this._map(oldValue, newValue);
        return this._flatten(diff);
    },
    _map: function _map(oldValue, newValue) {

        if (angular.isFunction(oldValue) || angular.isFunction(newValue)) {

            throw new Error('Invalid argument. Function given, object expected.');
        }

        if (this._isValue(oldValue) || this._isValue(newValue)) {

            var type = this._compareValues(oldValue, newValue);

            if (type === VALUE_UPDATED) {

                if (newValue === true || newValue === false) {

                    return String(newValue);
                }

                if (angular.isNumber(newValue)) {

                    return String(newValue);
                }

                return newValue || oldValue;
            }

            return undefined;
        }

        var diff = {};

        for (var key in oldValue) {

            if (Object.prototype.hasOwnProperty.call(oldValue, key)) {

                if (angular.isFunction(oldValue[key])) {

                    continue;
                }

                var value2 = void 0;
                if (_typeof(newValue[key] !== 'undefined')) {

                    value2 = newValue[key];
                }

                var value = this._map(oldValue[key], value2);
                if (value) {

                    diff[key] = value;
                }
            }
        }

        for (var _key in newValue) {

            if (Object.prototype.hasOwnProperty.call(newValue, _key)) {

                if (angular.isFunction(newValue[_key]) || typeof diff[_key] !== 'undefined') {

                    continue;
                }

                var _value = this._map(undefined, newValue[_key]);
                if (_value) {

                    diff[_key] = this._map(undefined, newValue[_key]);
                }
            }
        }

        return diff;
    },
    _flatten: function _flatten(data) {

        var result = {};

        function recurse(cur, prop) {

            if (Object(cur) !== cur) {

                result[prop] = cur;
            } else if (angular.isArray(cur)) {

                var l = 0;
                for (var i = 0, _l = cur.length; i < _l; i += 1) {

                    recurse(cur[i], prop + '[' + i + ']');
                }

                if (l === 0) {

                    result[prop] = [];
                }
            } else {

                var isEmpty = true;
                for (var p in cur) {

                    if (Object.prototype.hasOwnProperty.call(cur, p)) {

                        isEmpty = false;
                        recurse(cur[p], prop ? prop + '.' + p : p);
                    }
                }
            }
        }

        recurse(data, '');

        return result;
    },
    _compareValues: function _compareValues(oldValue, newValue) {

        if (oldValue === newValue) {

            return VALUE_UNCHANGED;
        }

        if (typeof oldValue === 'undefined') {

            return VALUE_CREATED;
        }

        if (typeof newValue === 'undefined') {

            return VALUE_DELETED;
        }

        return VALUE_UPDATED;
    },
    _isValue: function _isValue(obj) {

        return !angular.isObject(obj) && !angular.isArray(obj);
    }
};

exports.default = ObjectComparer;

/***/ }),

/***/ "BtZ8":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content large-modal-holder recommendations-modal-holder\" connectqa-modal=\"recommendations-modal\">\n\n    <!-- One Click Payment -->\n    <div ng-show=\"showOcpScreen\" ng-class=\"{'box-shot' : isYearlyPayment}\">\n        <div class=\"recommendations-modal\">\n            <div>\n\n                <div class=\"app-icon-holder\" ng-if=\"!isYearlyPayment\">\n                    <img src=\"{{recommendedProduct.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"app-icon-holder\" ng-if=\"isYearlyPayment\">\n                    <img ng-src=\"{{recommendedProduct.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"app-description-holder clear\">\n                    <div class=\"inline-block\">\n                        <h2 class=\"text-xl text-grey-1\">{{recommendedProduct.attributes.name}}</h2>\n                        <p class=\"text-s text-grey-2\">\n                            <span ng-if=\"!isYearlyPayment\" translate=\"cw.recommendations.subscription.monthly\"></span>\n\n                            <span ng-if=\"isYearlyPayment && recommendedProduct.id === 'isec0'\">\n                                <span ng-if=\"recommendation.attributes.users === 1\" translate=\"cw.ocp.quantity_and_type_sing_1\">\n                                </span>\n                                <span ng-if=\"recommendation.attributes.users > 1\" translate=\"cw.ocp.quantity_and_type_plural_1\"\n                                translate-values=\"{\n                                    devices: recommendation.attributes.users\n                                }\">\n                                </span>\n                            </span>\n\n                            <span ng-if=\"isYearlyPayment && recommendedProduct.id === 'aps10'\">\n                                <span translate=\"cw.ocp.quantity_and_type_plural_1\"\n                                translate-values=\"{\n                                    devices: '5'\n                                }\">\n                                </span>\n                            </span>\n\n                            <span ng-if=\"isYearlyPayment && recommendedProduct.id === 'aps20'\">\n                                <span translate=\"cw.ocp.quantity_and_type_plural_1\"\n                                translate-values=\"{\n                                    devices: '25'\n                                }\">\n                                </span>\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"info-tooltip-holder ml5 crs-pointer inline-block\">\n                        <div class=\"icon icon-help-border icon-xs text-grey-2 inline-block\"></div>\n\n                        <div class=\"info-tooltip arrow-left\">\n                            <div>{{recommendedProduct.attributes.resource.shortDescription}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"separator-grey-mbt40 mt20\" ng-if=\"isYearlyPayment\"></div>\n\n            <div connectqa-modal=\"license-activation-eula\">\n                <p class=\"text-l font-bold text-grey-1 mb20\" translate=\"cw.ocp.cma_desc.title\">\n                </p>\n                    <p class=\"text-m text-grey-3 mb5\">\n                        <span class=\"font-bold text-grey-1\" translate=\"cw.ocp.cma_desc.subscription_start\"></span>\n                        <span translate=\"cw.ocp.cma_desc.subscription_start_desc\"></span>\n                    </p>\n                    <p class=\"text-m text-grey-3 mb5\">\n                        <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span>\n                        <span translate=\"cw.ocp.cma_desc.renewal_cycle_desc\"></span>\n                    </p>\n                    <p class=\"text-m text-grey-3 mb5\">\n                        <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_prices\"></span>\n                        <span translate=\"cw.subscribe.renewal_prices_desc_annual\"></span>\n                        <span ng-if=\"$root.cmaGBapplies\" translate=\"cw.ocp.cma_desc.renewal_prices\" translate-values=\"{\n                            renewalPrices: renewalPrices\n                        }\"></span>\n                    </p>\n                    <div class=\"text-m text-grey-3 mb20 renewal-settings-section\">\n                        <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_settings\"></span>\n                        <span translate=\"cw.subscribe.renewal_settings_desc\" translate-values=\"{siteLink: siteLink}\"></span>\n                        <div class=\"info-tooltip-holder inline-block v-middle\">\n                            <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                            <div class=\"info-tooltip arrow-left subscription-notification\">\n                                <span translate=\"cw.subscribe.renewal_settings_tooltip.desc_1\"></span>\n                                <ol>\n                                    <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_2\"></li>\n                                    <li ng-show=\"$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_3\"></li>\n                                    <li ng-show=\"!$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_6\"></li>\n                                    <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_4\"></li>\n                                    <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_5\"></li>\n                                </ol>\n                            </div>\n                        </div>\n                    </div>\n                    <p class=\"text-m text-grey-3 mb20\" translate=\"cw.ocp.cma_desc.agreement\"\n                    translate-values=\"{\n                        globalPrivacy: globalPrivacy\n                    }\"></p>\n                    <div ng-if=\"!$root.cmaGBapplies\">\n                        <div class=\"fake-radio mb20 input-checkbox text-left\"\n                            ng-class=\"{\n                                'error': !acceptedRowTerms && submitted\n                            }\">\n                            <input type=\"checkbox\" connectqa-subscriptions=\"agreement-checkbox-ocp\" id=\"agreement-row-annual\" ng-model=\"acceptedRowTerms\" ng-change=\"onChangeCheckboxROW()\" />\n                            <label class=\"input-checkbox label\" for=\"agreement-row-annual\">\n                                <span>\n                                    <p class=\"text-m text-grey-3 inline-block v-middle\"\n                                    translate=\"cw.ocp.cma.checkbox_1_row\" translate-values=\"{\n                                        globalPrivacy: globalPrivacy,\n                                        termsOfSale: termsOfSale,\n                                        licenseAgreement: licenseAgreement\n                                    }\">\n                                    </p>\n                                </span>\n                            </label>\n                        </div>\n                    </div>\n                    <div ng-if=\"$root.cmaGBapplies\">\n                        <div class=\"fake-radio input-checkbox mb20 text-left\"\n                        ng-class=\"{\n                            'error': !acceptedGbTerms1 && submitted\n                        }\">\n                            <input type=\"checkbox\" id=\"agreement-gb-annual-1\" ng-model=\"acceptedGbTerms1\" ng-change=\"onChangeCheckboxGB1()\" />\n                            <label class=\"input-checkbox label\" for=\"agreement-gb-annual-1\">\n                                <span>\n                                    <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.ocp.cma.checkbox_1_gb\">\n                                    </p>\n                                </span>\n                            </label>\n                        </div>\n                        <div class=\"fake-radio input-checkbox mb20 text-left\"\n                        ng-class=\"{\n                            'error': !acceptedGbTerms2 && submitted\n                        }\">\n                            <input type=\"checkbox\" id=\"agreement-gb-annual-2\" ng-model=\"acceptedGbTerms2\" ng-change=\"onChangeCheckboxGB2()\" />\n                            <label class=\"input-checkbox label\" for=\"agreement-gb-annual-2\">\n                                <span>\n                                    <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.ocp.cma.checkbox_2_gb\" translate-values=\"{\n                                        globalPrivacy: globalPrivacy,\n                                        termsOfSale: termsOfSale,\n                                        licenseAgreement: licenseAgreement\n                                    }\">\n                                    </p>\n                                </span>\n                            </label>\n                        </div>\n                    </div>\n                    <p class=\"text-m text-grey-3\" ng-if=\"$root.isPartOfEEA\" translate=\"cw.ocp.cma.eea_note\" translate-values=\"{\n                        cancellation: cancellation\n                    }\">\n                    </p>\n            </div>\n\n            <ul ng-if=\"!isYearlyPayment\">\n                <li class=\"text-grey-3\" translate=\"cw.recommendation.try_premium_free\"></li>\n                <li class=\"text-grey-3\" translate=\"cw.recommendation.cancel_anytime\"></li>\n                <li class=\"text-grey-3\" translate=\"cw.recommendation.no_charge_first_month\"></li>\n            </ul>\n\n\n            <p class=\"inline-block payment-method-copy text-s\" ng-if=\"!isYearlyPayment\">\n                <span translate=\"cw.recommendation.saved_card_reason\"></span>\n            </p>\n\n            <div class=\"separator-grey-mbt40\" ng-if=\"isYearlyPayment\"></div>\n\n            <div ng-if=\"isYearlyPayment\">\n                <div class=\"eula-trusted-payment\">\n                    <h3 class=\"text-s font-medium\" translate=\"cw.saved_payment_method\"></h3>\n\n                    <div class=\"payment-method-holder\">\n\n                        <!-- Paypal -->\n                        <div ng-show=\"paymentInfo.payment_type.toLowerCase().indexOf('paypal') > -1\"\n                            class=\"payment-type payment-paypal text-grey-4\">\n                            <span></span> PayPal\n                        </div>\n\n                        <!-- Debit card -->\n                        <div ng-show=\"paymentInfo.payment_type.toLowerCase().indexOf('debit') > -1\"\n                            class=\"payment-type payment-debit text-grey-4\">\n                            <span></span> {{'cw.direct_debit' | translate}}\n                        </div>\n\n                        <!-- Credit card -->\n                        <div ng-show=\"paymentInfo.payment_type.toLowerCase().indexOf('debit') === -1 && paymentInfo.payment_type.toLowerCase().indexOf('paypal') === -1\"\n                            class=\"payment-type payment-card text-grey-4\">\n                            <span></span>●●●● {{paymentInfo.last_digits}}\n                        </div>\n                    </div>\n                    <div class=\"trusted-payment\"></div>\n                </div>\n\n                <div class=\"price-buy-now-wrapper\">\n                    <div class=\"price-wrapper\">\n                        <h2 class=\"text-xxl font-regular text-grey-2\" translate=\"cw.general.total_price\"\n                            translate-values=\"{ price : recommendation.attributes.total_price + ' ' + recommendation.attributes.currency }\">\n                        </h2>\n                        <span class=\"text-grey-3 text-l text-strike\" ng-if=\"recommendedProduct.id !== 'aps20'\">{{recommendation.attributes.pc_price + ' ' +\n                            recommendation.attributes.currency}}</span>\n                        <br ng-if=\"recommendedProduct.id !== 'aps20'\"/>\n                        <span class=\"text-grey-3\" translate=\"cw.general.includes_vat\"></span>\n                    </div>\n                    <div class=\"buy-now-cta\" ng-class=\"{'custom-mt': recommendedProduct.id === 'aps20'}\">\n                        <button class=\"btn btn-medium btn-three-quarters-width btn-primary\"\n                            ng-click=\"activateRecommendations()\" translate=\"cw.ocp.cma.pay_now\">\n                        </button>\n                        <!-- <button class=\"btn btn-medium btn-three-quarters-width btn-primary\"\n                            ng-click=\"activateRecommendations()\" ng-disabled=\"!acceptedRowTerms\" ng-if=\"!$root.cmaGBapplies\" translate=\"cw.ocp.cma.pay_now\">\n                        </button>\n                        <button class=\"btn btn-medium btn-three-quarters-width btn-primary\"\n                            ng-click=\"activateRecommendations()\" ng-disabled=\"!activateButtonEnabled\" ng-if=\"$root.cmaGBapplies\" translate=\"cw.ocp.cma.pay_now\">\n                        </button> -->\n                    </div>\n                </div>\n\n                <div class=\"auerbach-foundation-wrapper\" ng-if=\"recommendation.attributes.foundation_fee > 0\">\n                    <div class=\"logo-wrapper\">\n                        <div class=\"auerbach-foundation-logo\"></div>\n                    </div>\n                    <p class=\"auerbach-foundation-description\" translate=\"cw.ocp.auerbach_foundation\"></p>\n                </div>\n\n            </div>\n\n            <div class=\"ctas-wrap text-center\" ng-if=\"!isYearlyPayment\">\n                <div class=\"buttons-wrap\">\n                    <button class=\"btn btn-large btn-primary\" connectqa-button=\"try-for-free-modal\"\n                        ng-click=\"activateRecommendations()\" translate=\"cw.general.buttons.try_for_free\"></button>\n                    <button class=\"btn btn-large btn-secondary \" ng-click=\"cancel()\"\n                        translate=\"cw.form.profile.cancel\"></button>\n                </div>\n\n                <p class=\"text-m\" translate=\"cw.recommendation.price_per_month\"\n                    translate-values=\"{price: recommendation.attributes.price + ' ' + recommendation.attributes.currency}\">\n                </p>\n            </div>\n\n        </div>\n    </div>\n\n    <!-- Pending -->\n    <div class=\"recommendation-status-modal\" ng-show=\"showPendingScreen\" connectqa-recommendation=\"pending-screen\">\n        <div class=\"icon-pending\"></div>\n        <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.recommendation.processing_request.title\"\n            connectqa-recommendation=\"pending-screen-title\"></h2>\n        <p class=\"text-m text-grey-2\" translate=\"cw.recommendation.processing_request.description\"\n            connectqa-recommendation=\"pending-screen-description\"></p>\n    </div>\n\n    <!-- Success -->\n    <div class=\"recommendation-status-modal text-center\" ng-show=\"showSuccessScreen\"\n        connectqa-recommendation=\"success-screen\">\n        <div class=\"icon-success\"></div>\n\n        <div class=\"separator-grey-mbt40\"></div>\n        <div class=\"text-left\" connectqa-modal=\"activation-success-eula\">\n            <p class=\"text-l font-bold text-grey-1 mb20\" translate=\"cw.general.order_reference_number\"\n                translate-values=\"{ referenceNumber : transactionId }\" connectqa-payment-cart=\"success-order-number\">\n            </p>\n            <p ng-if=\"isYearlyPayment\" class=\"text-m text-grey-3 mb5\">\n                <span translate=\"cw.purchase_success.annual.title\"\n                translate-values=\"{\n                    date: nextBillingEvent,\n                    price: nextBillingPrice\n                }\"></span>\n                <span translate=\"cw.ocp.cma_desc.renewal_prices\"></span>\n            </p>\n            <p ng-if=\"isMonthly\" class=\"text-m text-grey-3 mb5\">\n                <span translate=\"cw.purchase_success.monthly.title\"\n                translate-values=\"{\n                    date: nextBillingEvent,\n                    price: nextBillingPrice\n                }\"></span>\n                <span translate=\"cw.ocp.cma_desc.renewal_prices\"></span>\n            </p>\n\n            <div ng-if=\"onMergingApp.attributes.name !== recommendedProduct.attributes.name\">\n                <p ng-if=\"extraRuntime > 1\" class=\"text-m text-grey-3 mb5\"\n                    translate=\"cw.purchase_success.merged_subscription_plural\"\n                    translate-values=\"{\n                        days : extraRuntime,\n                        product1 : onMergingApp.attributes.name,\n                        product2 : recommendedProduct.attributes.name\n                    }\"></p>\n\n                <p ng-if=\"extraRuntime === 1\" class=\"text-m text-grey-3 mb5\"\n                    translate=\"cw.purchase_success.merged_subscription_singular\"\n                    translate-values=\"{\n                        days : extraRuntime,\n                        product1 : onMergingApp.attributes.name,\n                        product2 : recommendedProduct.attributes.name\n                    }\"></p>\n            </div>\n            <div ng-if=\"onMergingApp.attributes.name === recommendedProduct.attributes.name\">\n                <p ng-if=\"totalRuntime > 1\" class=\"text-m text-grey-3 mb5\"\n                    translate=\"cw.purchase_success.extented_subscription_plural\"\n                    translate-values=\"{\n                        days : totalRuntime,\n                        product : recommendedProduct.attributes.name\n                    }\"></p>\n                <p ng-if=\"totalRuntime === 1\" class=\"text-m text-grey-3 mb5\"\n                    translate=\"cw.purchase_success.extented_subscription_singular\"\n                    translate-values=\"{\n                        days : totalRuntime,\n                        product : recommendedProduct.attributes.name\n                    }\"></p>\n            </div>\n\n            <p class=\"text-m text-grey-3 mb20\" translate=\"cw.purchase_success.email_confirmation\"></p>\n            <p class=\"text-m text-grey-1 mb20 font-bold\" translate=\"cw.purchase_success.terms_title\"></p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span>\n                <span translate=\"cw.purchase_success.annual.contract_type_desc\" ng-if=\"isYearlyPayment\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span>\n                <span translate=\"cw.purchase_success.annual.renewal_cycle_desc\" ng-if=\"isYearlyPayment\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.purchase_success.annual.billing_cycle\"></span>\n                <span translate=\"cw.purchase_success.annual.billing_cycle_desc\" ng-if=\"isYearlyPayment\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span>\n                <span translate=\"cw.purchase_success.annual.cancellation_desc\" ng-if=\"isYearlyPayment\"\n                translate-values=\"{cancellation: cancellation}\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.purchase_success.annual.your_info\"></span>\n                <span translate=\"cw.purchase_success.annual.your_info_desc\"\n                translate-values=\"{globalPrivacy: globalPrivacy}\"></span>\n            </p>\n            <div class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_settings\"></span><span translate=\"cw.subscribe.renewal_settings_desc\" translate-values=\"{siteLink: siteLinks}\"></span>\n                <div class=\"info-tooltip-holder inline-block v-middle\">\n                    <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                    <div class=\"info-tooltip arrow-left subscription-notification\">\n                        <span translate=\"cw.subscribe.renewal_settings_tooltip.desc_1\"></span>\n                        <ol>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_2\"></li>\n                            <li ng-show=\"$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_3\"></li>\n                            <li ng-show=\"!$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_6\"></li>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_4\"></li>\n                            <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_5\"></li>\n                        </ol>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"separator-grey-mbt40\"></div>\n        <button class=\"btn btn-large btn-primary mb10\" ng-click=\"closeOCP();redirectToSubscriptionPage()\"\n            translate=\"cw.tour.user.action_done\" connectqa-recommendation=\"success-screen-done-button\"></button>\n\n        <div ng-if=\"isYearlyPayment\">\n            <a translate=\"cw.ocp.print_invoice\" ui-sref=\"root.dashboard.subscriptions({tab: 'history'})\"\n                class=\"text-s text-blue-2 crs-pointer\"></a>\n        </div>\n\n        <p class=\"text-m text-grey-3 mt20 text-left\" ng-if=\"$root.isPartOfEEA\" translate=\"cw.purchase_success.eea_info\"\n            translate-values=\"{cancellation: cancellation}\"></p>\n    </div>\n\n    <!-- Error -->\n    <div class=\"recommendation-status-modal\" ng-show=\"showErrorScreen\" connectqa-recommendation=\"error-screen\">\n        <div class=\"icon-failed\"></div>\n\n        <!-- Cleverbridge failed -->\n        <div ng-show=\"cleverBridgeError\">\n            <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.recommendation.error.title\"\n                connectqa-recommendation=\"error-screen-cleverBridge-title\"></h2>\n            <p class=\"text-m text-grey-2 mb20\" translate=\"cw.general.error.payment_failed\"\n                connectqa-recommendation=\"error-screen-cleverBridge-description\">.</p>\n        </div>\n\n        <!-- General error -->\n        <div ng-show=\"!cleverBridgeError\">\n            <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.recommendation.error.title\"\n                connectqa-recommendation=\"error-screen-title\"></h2>\n            <p class=\"text-m text-grey-2 mb20\" translate=\"cw.recommendation.error.connection_failed\"\n                translate-values=\"{url: supportUrl, brandname : brandName}\"\n                connectqa-recommendation=\"error-screen-description\"></p>\n        </div>\n\n        <button class=\"btn btn-large btn-secondary\" ng-click=\"closeOCP()\" translate=\"cw.general.ui.close\"></button>\n\n        <span class=\"text-xxs text-grey-6 error-code\" ng-if=\"errorCode\">Error code: {{errorCode}}</span>\n    </div>\n</div>\n";
var path = 'views/modals/one-click-payment.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "BuSR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$rootScope'];

var DisclaimerBarController = function () {
    function DisclaimerBarController($rootScope) {
        _classCallCheck(this, DisclaimerBarController);

        this.$rootScope = $rootScope;

        // Check vpn disclaimer
        this.isDisclaimerVisible = this.$rootScope.vpnINdisclaimer;
    }

    _createClass(DisclaimerBarController, [{
        key: 'closeDisclaimer',
        value: function closeDisclaimer() {

            this.isDisclaimerVisible = false;

            localStorage.setItem('disclaimerBar', 'closed');

            angular.element('body').removeClass('show-disclaimer-bar');
        }
    }]);

    return DisclaimerBarController;
}();

var DisclaimerBarDirective = function DisclaimerBarDirective() {
    _classCallCheck(this, DisclaimerBarDirective);

    this.template = __webpack_require__("5R2H");
    this.restrict = 'E';
    this.replace = true;

    _controllerDependencies.push(function ($rootScope) {
        return new DisclaimerBarController($rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'disclaimerBarCtrl';
};

_directiveDependencies.push(function () {
    return new DisclaimerBarDirective();
});

angular.module('directives').directive('disclaimerBar', _directiveDependencies);

/***/ }),

/***/ "C0bq":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "C2H/":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "CA8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', 'Auth'];

var UserSettingsController = function () {
    function UserSettingsController($state, Auth) {
        _classCallCheck(this, UserSettingsController);

        var freeSupport = CWCONFIG.partnerConfig.support.freeSupport;


        this.topQA = 'https://www.avira.com/' + CWCONFIG.language + '/support';
        this.privacyPolicyUrl = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);

        if (CWCONFIG.language === 'en') {

            this.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, 'en-us');
        } else {

            this.supportForFreeUsersLink = freeSupport.replace(/\[language\]/gi, CWCONFIG.language);
        }

        this.User = _index.MeRepository.getMyUser();
        this.$state = $state;
        this.Auth = Auth;

        var activationCodes = _index.ActivationCodesRepository.getAll() || [];

        if (activationCodes.length > 0) {

            this.supportForPaidUsers = true;
        }
    }

    _createClass(UserSettingsController, [{
        key: 'sendMixpanel',
        value: function sendMixpanel(modalName) {

            _RFC2.default.send('ConnectWeb ' + modalName + ' Click', {
                Label: 'User Settings Menu'
            });
        }
    }, {
        key: 'openMyAccount',
        value: function openMyAccount() {

            _RFC2.default.send('ConnectWeb My Account Open');
            this.sentEventManager();
            this.$state.go('root.dashboard.my-account', { tab: 'profile' });
        }
    }, {
        key: 'openSubscriptions',
        value: function openSubscriptions() {

            this.$state.go('root.dashboard.subscriptions', { tab: 'plans' });
        }
    }, {
        key: 'logOut',
        value: function logOut() {

            this.Auth.logOut();
        }
    }, {
        key: 'sentEventManager',
        value: function sentEventManager() {

            _RFC4.default.broadcast('user-menu:clicked');
        }
    }]);

    return UserSettingsController;
}();

var UserSettingsDirective = function UserSettingsDirective() {
    _classCallCheck(this, UserSettingsDirective);

    this.template = __webpack_require__("Vj+m");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state, Auth) {
        return new UserSettingsController($state, Auth);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'userSettingsCtrl';
};

_directiveDependencies.push(function () {
    return new UserSettingsDirective();
});

angular.module('directives').directive('userSettings', _directiveDependencies);

/***/ }),

/***/ "CExF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.ActionNotifications
*
* @description
* This class is used to process action notifications.
*/
var ActionNotifications = {

    /**
     * @ngdoc function
     * @name notifications.ActionNotifications#processUpdate
     * @methodOf notifications.ActionNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on actions.
     *
     * @param {object} data An object with updated values on action.
     * @param {object} prevAction The old action object.
     * @param {object} currentAction The update action object.
     */

    processUpdate: function processUpdate(data, prevAction, currentAction) {

        var actionType = currentAction.attributes.action_type;

        // Logout user
        if (actionType === 'logout') {

            var cookieConfig = CWCONFIG.cookie;
            var domain = cookieConfig.domain,
                rootDomain = cookieConfig.rootDomain;

            // Remove loginType cookie

            _RFC2.default.remove(cookieConfig.loginType, {
                path: '/',
                domain: domain
            });

            // Remove login cookies
            _RFC2.default.remove(cookieConfig.token, {
                path: '/',
                domain: domain
            });

            _RFC2.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: domain
            });

            _RFC2.default.remove(cookieConfig.token, {
                path: '/',
                domain: rootDomain
            });

            _RFC2.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: rootDomain
            });

            // Remove SSO cookies
            // get all cookies
            var cookies = document.cookie;
            // regex to match all sso keys
            // example: prod_launcher_sso or prod_launcher_refresh_sso
            var regex = new RegExp('^(' + CWCONFIG.cookie.ssoToken + '[a-z]+[_a-z]*?_sso)', 'g');
            cookies.split('; ').map(function (cookie) {

                // check if cookie matches the regex
                var match = cookie.match(regex);
                if (match) {

                    _RFC2.default.remove(match[0], {
                        path: '/',
                        domain: domain
                    });

                    _RFC2.default.remove(match[0], {
                        path: '/',
                        domain: rootDomain
                    });
                }

                return '';
            });

            // wait for location path to be changed firefox/safari bug
            setTimeout(function () {

                window.location.reload();
                window.location.href = '/en/auth/login';
            }, 0);
        }
    }
};

exports.default = ActionNotifications;

/***/ }),

/***/ "CI1E":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("qJJc");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "CKgr":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu"),
    root = __webpack_require__("VjBI");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "CM3t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controller for the device details page
 */

angular.module('controllers').controller('DeviceDetails', ['$scope', '$filter', '$state', '$translate', '$stateParams', 'AppInstanceRestService', 'PaymentUrlsRestService', 'Util', '$window', function ($scope, $filter, $state, $translate, $stateParams, AppInstanceRestService, PaymentUrlsRestService, Util, $window) {

    $scope.state = $state;
    $scope.processedInstances = [];
    $scope.deviceId = $state.params.resourceId;
    $scope.device = _index.DevicesRepository.getById($scope.deviceId);
    $scope.brandName = CWCONFIG.partnerConfig.name;
    if (!$scope.device) {

        return $state.go('root.dashboard.devices');
    }

    $scope.browserName = $window.browserName.toLowerCase();

    // get details of free bundle current offer
    var defaultDeployedAppId = void 0;
    if ($scope.device.attributes.os === 'windows') {

        defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.windows || 'sptl1';
    } else if ($scope.device.attributes.os === 'osx') {

        defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.osx || 'fass0';
    }
    $scope.featuredApp = _index.AppIntegrationsRepository.getById(defaultDeployedAppId) || {};

    $scope.showFSSDownloadButton = function (category) {
        return !!(category === 'fss_apps' && $scope.servicesByCategory[category].inactive.length > 0 && ($scope.device.attributes.os === 'windows' || $scope.device.attributes.os === 'osx'));
    };

    /**
     * Get the details of the app of the current offer
     */
    var offerProductId = 'aps10';
    $scope.offerProductDetails = _index.AppIntegrationsRepository.getById(offerProductId);

    /**
     * Model to group the instances of the current device by their category
     */
    $scope.servicesByCategory = {
        fss_apps: {
            inactive: [],
            active: []
        },
        browser_extensions: {
            inactive: [],
            active: []
        },
        internet_of_things: {
            inactive: [],
            active: []
        }
    };

    // store license/licenses names that are installed on the current device
    $scope.licenseNames = [];
    $scope.deviceAppInstances = _index2.AppInstancesProcessor.getInstancesByDevice($scope.device.relationships.user.data.id, $scope.deviceId);

    if ($scope.deviceAppInstances) {

        /**
         * Get the license name for each active instance on the device
         * Only paid licenses are needed
         */
        $scope.deviceAppInstances.forEach(function (instance) {

            if (instance && instance.attributes.state === 'active') {

                var instanceLicense = _index.LicensesRepository.getLicenseById(instance.relationships.license.data.id);

                if (instanceLicense) {

                    var integrationDetails = _index.AppIntegrationsRepository.getById(instanceLicense.relationships.app.data.id);

                    if (integrationDetails) {
                        var oeName = integrationDetails.attributes.resource.oeName;

                        // make sure not to store doubles

                        if ($scope.licenseNames.indexOf(oeName) === -1) {

                            $scope.licenseNames.push(oeName);
                        }
                    }
                }
            }
        });
    }

    $scope.hasAv = false;

    var isMobileDevice = _index.DevicesRepository.isMobile($scope.deviceId);
    var issueSeparator = ', ';
    var isProInstalled = '';

    var tabs = ['apps', 'events', 'info'];
    var isValidTab = tabs.indexOf($stateParams.tab || '') >= 0;

    // check if the device details tab is available
    if (isValidTab) {

        // if device doesn't exists, go to dashboard
        if (!$scope.device) {

            return $state.go('root.dashboard.home');
        }
    } else {

        return $state.go('root.dashboard.device-details', {
            resourceId: $stateParams.resourceId,
            tab: 'apps'
        });
    }

    $scope.detectDeviceIssues = function () {

        $scope.deviceIssues = [];
        $scope.issuesAvModules = '';
        _.each($scope.instancesWithIssues, function (issue) {

            if (issue && String(issue.relationships.device.data.id) === String($scope.deviceId)) {

                if (issue.attributes.status.svc.guard === 2 || issue.attributes.status.svc.guard === 4 || issue.attributes.status.svc.guard === 0) {

                    $scope.deviceIssues.push('guard');
                    $scope.issuesAvModules += $translate.instant('cw.dashboard.services.windows.antivirus.guard.name') + issueSeparator;
                }
                if (issue.attributes.status.svc.firewall === 2 || issue.attributes.status.svc.firewall === 4 || issue.attributes.status.svc.firewall === 0) {

                    $scope.deviceIssues.push('firewall');
                    $scope.issuesAvModules += $translate.instant('cw.dashboard.services.windows.antivirus.firewall.name') + issueSeparator;
                }
                if (issue.attributes.status.svc.mailguard === 2 || issue.attributes.status.svc.mailguard === 4 || issue.attributes.status.svc.mailguard === 0) {

                    $scope.deviceIssues.push('mailguard');
                    $scope.issuesAvModules += $translate.instant('cw.dashboard.services.windows.antivirus.mailguard.name') + issueSeparator;
                }
                if (issue.attributes.status.svc.webguard === 2 || issue.attributes.status.svc.webguard === 4 || issue.attributes.status.svc.webguard === 0) {

                    $scope.deviceIssues.push('webguard');
                    $scope.issuesAvModules += $translate.instant('cw.dashboard.services.windows.antivirus.webguard.name') + issueSeparator;
                }
            }
        });

        if ($scope.issuesAvModules) {

            $scope.issuesAvModules = $scope.issuesAvModules.slice(0, $scope.issuesAvModules.length - issueSeparator.length);
        }

        if ($scope.device) {

            $scope.hasAv = _index2.DevicesProcessor.hasAvInstalled($scope.device.relationships.user.data.id, $scope.deviceId);
        }
    };

    /*  lock/unlock functionality is available only for PC's/Laptops
    with Windows operating system */
    function checkLockAvailability() {

        return !isMobileDevice && $scope.device.attributes.os === 'windows' ? true : false;
    }

    // returns lock status {boolean}
    function checkDeviceLockStatus() {

        return $scope.device.attributes.locked;
    }

    $scope.isDeviceLocked = checkDeviceLockStatus();
    $scope.isLockFunctionalityAvailable = checkLockAvailability();

    // direct binding for issues
    var issuesObservable = _index2.IssuesProcessor.getObservable();
    issuesObservable.subscribe(function (data) {

        $scope.instancesWithIssues = _.values(data);
        $scope.detectDeviceIssues();
    }, function () {}, function () {});

    // direct binding for devices
    var deviceObservable = _index.DevicesRepository.getObservable();
    var onNextDevice = function onNextDevice() {

        $scope.device = _index.DevicesRepository.getById($scope.deviceId);

        // goToDevices if the devices was removed or hidden
        if (!$scope.device || $scope.device.attributes.hidden) {

            return $state.go('root.dashboard.devices');
        }

        // detect if the device has info (OS, HDD, RAM, CPU etc...)
        var deviceSectionKeys = ['disks', 'partitions', 'cpu', 'gpus', 'memory', 'motherboard', 'resolution', 'osver', 'sp', 'totalSpace', 'freeSpace', 'batteryLevel', 'osver', 'imei', 'serial', 'phoneNo', 'systemInfo'];
        var deviceOthersKeys = _.keys($scope.device.attributes.others);

        $scope.deviceInfo = _.find(deviceOthersKeys, function (item) {
            return deviceSectionKeys.indexOf(item) > -1;
        });

        // after updating DeviceRepository, check device lock status
        $scope.isDeviceLocked = checkDeviceLockStatus();
    };

    var devicesSubscriber = deviceObservable.subscribe(onNextDevice, function () {}, function () {});

    var filterInstances = function filterInstances(devices) {

        var currentDeviceHasInstances = Object.keys(devices).indexOf($scope.deviceId) !== -1;
        var processedInstances = [];

        if (currentDeviceHasInstances) {

            var currentDeviceInstances = devices[$scope.deviceId];
            var hiddenInstances = [];

            // to filter browser extensions that are compatible for device
            var deviceCompatibleExtensions = function deviceCompatibleExtensions(instance) {

                // browser not supported, skip this filter
                if (Util.deepFind(instance, 'customAppInfo.browsers') && instance.customAppInfo.browsers.indexOf($scope.browserName) === -1) {

                    return false;
                }

                var compatibleProductBrowsers = Util.deepFind(instance, 'customAppInfo.browsers');
                var isBrowserExtension = compatibleProductBrowsers !== undefined;

                var isPendingInstance = Util.deepFind(instance, 'attributes.state') === 'pending';

                // if instance is not a browser extension so we skip this filter
                if (!isBrowserExtension) {

                    return true;
                    // but if it is a browser extension and it's state is not pending
                    // (product is installed), we display it in the view
                } else if (!isPendingInstance) {

                    return true;
                }

                var deviceHasBrowsers = Util.deepFind($scope.device, 'attributes.others.browsers');

                if (!deviceHasBrowsers) {

                    return false;
                }

                var deviceBrowserListString = deviceHasBrowsers.map(function (browser) {
                    return browser.name && browser.name.toLowerCase();
                }).reduce(function (previous, current) {
                    return previous + '.' + current;
                }, '');

                var canBeInstalled = compatibleProductBrowsers.filter(function (browser) {
                    return deviceBrowserListString.indexOf(browser) !== -1;
                });

                if (canBeInstalled.length > 0) {

                    return true;
                }

                return false;
            };

            currentDeviceInstances.map(function (data) {

                // we only hide instances that have been explicitly hidden
                // - i.e. have the visible attribute = 0
                var instanceCanBeShown = data.customAppInfo.visible !== 0 && data.customAppInfo.name ? true : false;

                // check if instance is already added
                var instanceExists = _.find(processedInstances, function (instance) {
                    return instance.relationships.app.data.id === data.relationships.app.data.id;
                });

                if (!instanceExists && instanceCanBeShown) {

                    processedInstances.push(data);
                }

                if (!instanceCanBeShown) {

                    hiddenInstances.push(data);
                }

                isProInstalled = isProInstalled || data.relationships.app.data.id === 'aasc0' || data.relationships.app.data.id === 'mspa0' || data.relationships.app.data.id === 'mspi0';
            });

            if (processedInstances.length > 0) {

                processedInstances = processedInstances.filter(deviceCompatibleExtensions);
            }

            if (hiddenInstances.length > 0) {

                _loggers2.default.log({
                    type: 'Product Catalog - hidden instances',
                    cmd: '',
                    data: hiddenInstances
                });
            }
        }

        return processedInstances;
    };
    // end

    /**
     * Check if an instance is installed on current device
     * If the instance's relationship attribute is an empty object,
     * the instance is not installed
     *
     * Note: the instances were filtered before to only be for the current device
     */
    $scope.isInstalled = function (instanceRelationship) {
        return !angular.equals({}, instanceRelationship);
    };

    /**
     * Whenever an observable for the active instances or
     * inactive integrations is triggered, sort the new data to it's specific
     * category in servicesByCategory model
     *
     * @param {*} services Array of either instances or inactive integrations
     * @param {*} servicesType String active/inactive
     */
    var sortServicesToCategory = function sortServicesToCategory(services, servicesType) {

        /**
         * Every time the method is called with new data, we need to reset
         * clear all data for all categories of the serviceType before push the new data
         *
         * E.g. clear all inactive values for all the categories
         */
        Object.keys($scope.servicesByCategory).forEach(function (key) {

            $scope.servicesByCategory[key][servicesType] = [];
        });

        // loop through all the services and store each integration in designated category
        services.forEach(function (integration) {

            // e.g. antivirus
            var serviceName = integration.attributes.prototype || integration.attributes.service;

            if (serviceName !== 'iot' || $scope.device.attributes.os !== 'windows') {

                var category = CWCONFIG.servicesByCategoryDeviceDetails[serviceName];

                if (category === 'browser_extensions' && ($scope.device.attributes.os === 'ios' || $scope.device.attributes.os === 'android')) {

                    category = 'fss_apps';
                }

                if (category && servicesType) {

                    $scope.servicesByCategory[category][servicesType].push(integration);
                }
            }
        });
    };

    /* 1. direct binding for instances
    2. Instances must be filtered before integrations.
    This condition will remain until we will fix Family Locator acronym */
    var instancesObservable = _index2.AppInstancesProcessor.getObservable();
    var onNextInstance = function onNextInstance(data) {

        // if we actually have an instance, do we bother to filter
        if (data.length > 0) {

            var filteredInstances = filterInstances(data[$scope.device.relationships.user.data.id]);

            sortServicesToCategory(filteredInstances, 'active');
        }
    };
    var instancesSubscriber = instancesObservable.subscribe(onNextInstance, function () {}, function () {});

    // for each device we look for its integrations and hide
    // them from the view if they can't be shown in the view
    function filterIntegrations(devices) {

        var currentDeviceHasIntegrations = Object.keys(devices).indexOf($scope.deviceId) !== -1;

        var filteredIntegrations = [];

        // we show items that pass both filters,
        // both only log items that don't pass the second
        if (currentDeviceHasIntegrations) {

            var currentDeviceIntegrations = devices[$scope.deviceId];
            var hiddenIntegrations = [];

            var firstFilter = function firstFilter(integration) {
                return (integration.attributes.custom.manifest.visible === 1 || integration.attributes.custom.manifest.visible === 3) && integration.attributes.custom.manifest.scope !== 'user' && (!isProInstalled || isProInstalled && integration.id !== 'free0') ? true : false;
            };

            var deviceCompatibleExtensions = function deviceCompatibleExtensions(integration) {

                // browser not supported, skip this filter
                var productManifest = integration.attributes.custom.manifest;
                if (Util.deepFind(integration, 'attributes.custom.manifest.browsers') && productManifest.browsers.indexOf($scope.browserName) === -1) {

                    return false;
                }

                var compatibleProductBrowsers = Util.deepFind(integration, 'attributes.custom.manifest.browsers');
                var isBrowserExtension = compatibleProductBrowsers !== undefined;

                // integrations is not a browser extension so we skip this filter
                if (!isBrowserExtension) {

                    return true;
                }

                var deviceHasBrowsers = Util.deepFind($scope.device, 'attributes.others.browsers');

                if (!deviceHasBrowsers) {

                    return false;
                }

                var deviceBrowserListString = deviceHasBrowsers.map(function (browser) {
                    return browser.name && browser.name.toLowerCase();
                }).reduce(function (previous, current) {
                    return previous + '.' + current;
                }, '');

                var canBeInstalled = compatibleProductBrowsers.filter(function (browser) {
                    return deviceBrowserListString.indexOf(browser) !== -1;
                });

                if (canBeInstalled.length > 0) {

                    return true;
                }

                return false;
            };

            // only log elements to console if they don't pass this filter
            var lastFilter = function lastFilter(integration) {

                var filterCondition = integration.attributes.custom.manifest.name && integration.attributes.custom.manifest.os ? true : false;

                if (!filterCondition) {

                    hiddenIntegrations.push(integration);

                    return false;
                }
                return true;
            };
            // because SPTL1 doesn't return instance of Privacy Pal so we hide it
            var isPrivacyPalNotInstalled = function isPrivacyPalNotInstalled(integration) {

                hiddenIntegrations.push(integration);
                return !(integration.id === 'pg001' && !$scope.isInstalled(integration.relationships));
            };

            filteredIntegrations = currentDeviceIntegrations.filter(firstFilter).filter(deviceCompatibleExtensions).filter(lastFilter).filter(isPrivacyPalNotInstalled);

            if (hiddenIntegrations.length > 0) {

                _loggers2.default.log({
                    type: 'Product Catalog - hidden integrations for device with id - ' + $scope.deviceId,
                    cmd: '',
                    data: hiddenIntegrations
                });
            }
        }

        return filteredIntegrations;
    }

    // inactive integrations
    var inactiveIntegrationsObservable = _index2.AppIntegrationsInactiveProcessor.getObservable();
    var onNextInactiveIntegration = function onNextInactiveIntegration(data) {

        var inactiveIntegrations = filterIntegrations(data[$scope.device.relationships.user.data.id]);

        sortServicesToCategory(inactiveIntegrations, 'inactive');
    };
    var inactiveIntegrationsSubscriber = inactiveIntegrationsObservable.subscribe(onNextInactiveIntegration, function () {}, function () {});

    // TBD for App details
    if ($scope.state.current.name === 'root.dashboard.device-details.app-details') {
        var appId = $state.params.appId;

        $scope.appInstanceDetails = _index.AppInstancesRepository.getByDeviceIdAndAppId($scope.deviceId, appId);
    }

    $scope.showLearnMore = function (app, isInstalled, category) {

        var appId = isInstalled ? app.relationships.app.data.id : app.id;

        _RFC4.default.send('ConnectWeb Learn More Click', {
            Page: 'Device Details',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': appId
        });
        if ($scope.showFSSDownloadButton(category) && !isInstalled) {

            $state.go('root.dashboard.device-details.ltb.activate', {
                ltb: 'activate',
                resourceId: $scope.device.id,
                appId: appId,
                bundle: defaultDeployedAppId
            }, {
                reload: false
            });
        } else if ($scope.servicesByCategory[category].inactive.length === 0 || isInstalled) {

            $state.go('root.dashboard.device-details.ltb.activate', {
                ltb: 'activate',
                resourceId: $scope.device.id,
                appId: appId,
                installed: true
            }, {
                reload: false
            });
        } else {

            $state.go('root.dashboard.device-details.ltb.activate', {
                ltb: 'activate',
                resourceId: $scope.device.id,
                appId: appId
            }, {
                reload: false
            });
        }
    };

    /**
     * Redirect the user to the configured product in the cart when
     * clicking on the offer button
     */
    $scope.getOffer = function () {

        var currentPrice = _index.AppPricesRepository.getSinglePrice('aps10', '12', '1');

        var price = '';
        var discount = '';

        if (currentPrice) {

            if (Util.deepFind(currentPrice, 'attributes.promotion')) {

                price = Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                discount = Util.deepFind(currentPrice, 'attributes.promotion.discount');
            } else {

                price = Util.deepFind(currentPrice, 'attributes.price_string');
                discount = 0;
            }
        }

        // configure product offer
        var currentOffer = {
            product: 'Avira Prime',
            productId: 'aps10'
        };

        _RFC4.default.send('ConnectWeb Get Offer Click', {
            Product: currentOffer.product,
            ProductId: currentOffer.productId,
            Page: 'Device Details',
            Runtimes: '12',
            Price: price,
            Discount: discount
        });

        $state.go('root.dashboard.device-details.ltb.buy', {
            ltb: 'payment-cart',
            appId: currentOffer.productId,
            subsource: 'store_prime',
            promotion: true
        }, {
            reload: false
        });
    };

    $scope.deployOn = function (app, category) {

        _RFC4.default.send('ConnectWeb Install Click', {
            Page: 'Device Details',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });

        var conditionsForAutoInstall = !!(category === 'fss_apps' && $scope.showFSSDownloadButton(category) || category === 'internet_of_things' && $scope.device.attributes.os === 'windows');

        if (conditionsForAutoInstall) {

            $state.go('root.dashboard.device-details.ltb.deploy', {
                ltb: 'deploy',
                resourceId: $scope.device.id,
                appId: app.id,
                autoInstall: true
            }, {
                reload: false
            });
        } else {

            $state.go('root.dashboard.device-details.ltb.deploy', {
                ltb: 'deploy',
                resourceId: $scope.device.id,
                appId: app.id
            }, {
                reload: false
            });
        }
    };

    /**
     * @param {String} extensionId The extension id for Opera
     * @param {String} appId The app integration id
     */
    $scope.installOperaExtension = function (extensionId, appId) {

        var operaObj = $window.opr || {};

        if (operaObj.addons) {

            operaObj.addons.installExtension(extensionId);
        } else {

            var extensionUrl = CWCONFIG.operaExtensions[appId];
            extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

            $window.open(extensionUrl, '_blank');
        }
    };

    $scope.onTabClick = function (tabName) {

        _RFC4.default.send('ConnectWeb Device Details ' + tabName + ' Click');
    };

    $scope.removePendingInstance = function (instance) {

        AppInstanceRestService.remove(instance.id).then(function () {

            _index.AppInstancesRepository.remove(instance.id);
        }).then(null, function () {

            _RFC2.default.error({
                message: 'cw.app.remove.error',
                icon: {
                    imageUrl: $filter('imageUrlParse')(instance.customAppInfo.icon)
                }
            }, {
                message: {
                    appName: instance.customAppInfo.name
                }
            });
        });
    };

    $scope.$on('$destroy', function () {

        instancesSubscriber.dispose();
        inactiveIntegrationsSubscriber.dispose();
        devicesSubscriber.dispose();
    });
}]); /* eslint no-unneeded-ternary: 0 */
/* eslint array-callback-return: 0 */
/* eslint no-confusing-arrow: 0 */
/* eslint consistent-return: 0 */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "CYsp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _RFC = __webpack_require__("fIlE");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Integrations Inactive Processor - inactive apps based on the difference between app-integrations
 * and active instances which are grouped by userId and device
 */

var _processedAppIntegrations = [];

var observableProcessedAppIntegrations = new Rx.BehaviorSubject(_processedAppIntegrations);
var _subjectAppIntegrationsRepository = _index.AppIntegrationsRepository.getObservable();

var AppIntegrationsInactiveProcessor = {

    /**
     * Calculates the inactive integrations for each userId and device
     */
    calculateInactiveAppIntegrations: function calculateInactiveAppIntegrations() {

        var integrations = _subjectAppIntegrationsRepository.value;

        if (integrations.length === 0) {

            return;
        }

        var processedInstances = _index2.AppInstancesProcessor.getAll();
        var devices = _index.DevicesRepository.getAll();

        devices.forEach(function (device) {

            /**
                 * for each device look for the integrations which are not installed or pending
                 * on that device
                 */
            var userId = device.relationships.user.data.id;
            _processedAppIntegrations[userId] = _processedAppIntegrations[userId] || {};
            _processedAppIntegrations[userId][device.id] = [];

            integrations.forEach(function (integration) {

                /**
                     * for each integration look for at least one instance installed or pending;
                     * if it's found, the integration should not be added in the
                     * inactive integrations array
                     */
                var foundInstance = false;

                if (processedInstances.length > 0 && processedInstances[userId]) {

                    (processedInstances[userId][device.id] || []).forEach(function (instance) {

                        /**
                             * for each instance, based on prototype check if:
                             * is an instance of the current integration
                             * is installed/pending on the current device
                             * if it is, don't push the integration in the
                             * inactive integrations array;
                             * instances which don't have a device are ignored
                             */

                        if (_RFC2.default.deepFind(instance, 'customAppInfo.prototype') === integration.attributes.prototype && String(_RFC2.default.deepFind(instance, 'relationships.device.data.id')) === String(device.id)) {

                            foundInstance = true;
                        }
                    });
                }

                if (!foundInstance) {

                    var compatibleOsTypes = _RFC2.default.deepFind(integration, 'attributes.custom.manifest.os') || [];
                    var isCompatibleWithDevice = compatibleOsTypes.indexOf(device.attributes.os) > -1;

                    if (isCompatibleWithDevice) {

                        _processedAppIntegrations[userId][device.id].push(integration);
                    }
                }
            });
        });

        observableProcessedAppIntegrations.onNext(_processedAppIntegrations);
    },
    getObservable: function getObservable() {

        return observableProcessedAppIntegrations;
    }
};

_index.AppInstancesRepository.getObservable().subscribe(function () {
    return AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations();
}, function () {}, function () {});
_index.DevicesRepository.getObservable().subscribe(function () {
    return AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations();
}, function () {}, function () {});
_index.AppIntegrationsRepository.getObservable().subscribe(function () {
    return AppIntegrationsInactiveProcessor.calculateInactiveAppIntegrations();
}, function () {}, function () {});

exports.default = AppIntegrationsInactiveProcessor;

/***/ }),

/***/ "Cj2j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.DeviceLocationsRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/

var LogoutRestService = function (_BaseRestService) {
    _inherits(LogoutRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     */
    function LogoutRestService($http, $q, Util) {
        _classCallCheck(this, LogoutRestService);

        return _possibleConstructorReturn(this, (LogoutRestService.__proto__ || Object.getPrototypeOf(LogoutRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceLocationsRestService#getAllAsync
     * @methodOf rest.services.DeviceLocationsRestService
     * @function
     *
     * @description
     * Retrieves all devices.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(LogoutRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            var refreshToken = _RFC2.default.get(CWCONFIG.cookie.refreshToken);
            return _get(LogoutRestService.prototype.__proto__ || Object.getPrototypeOf(LogoutRestService.prototype), 'getAllAsync', this).call(this, 'logout/?refresh_token=' + refreshToken);
        }
    }]);

    return LogoutRestService;
}(_baseRestService2.default);

exports.default = LogoutRestService;


_serviceDependencies.push(LogoutRestService);

angular.module('rest.services').service('LogoutRestService', _serviceDependencies);

/***/ }),

/***/ "CsP/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable max-len */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmDriversLicense = function DwmDriversLicense($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmDriversLicense);

    $scope.driversLicenseNumberIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};

        if (assets.primaryMember) {

            $scope.driversLicense = assets.primaryMember.monitoredAccounts.driversLicense;
            $scope.driversLicense.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showfEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('.update-drivers-license-number').trigger('focus');
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.driversLicenseNumberIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newDriversLicenseNumber = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.driversLicense.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                $scope.updateEntryPayload = entry;
                $scope.initialDriversLicenseNumber = entry.driversLicenseNumber;
                $scope.initialEntryIndex = loopIndex;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-drivers-license-number').trigger('focus');
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.driversLicenseNumberIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.driversLicense.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};

        // Revert changes of the selected entry
        $scope.driversLicense.entries[$scope.initialEntryIndex].driversLicenseNumber = $scope.initialDriversLicenseNumber;
    };

    $scope.validateDriversLicenseNumber = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.driversLicenseNumberIsValid = $event.currentTarget.value && validations.driversLicenseNumberValidator($event.currentTarget.value.trim());
        }

        $scope.newDriversLicenseNumber = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.driversLicenseNumberIsValid = $scope.newDriversLicenseNumber === undefined ? false : validations.driversLicenseNumberValidator($scope.newDriversLicenseNumber.trim());

        $scope.newEntrySubmitted = true;

        if ($scope.driversLicenseNumberIsValid) {

            $scope.saveNewDriversLicenseIsLoading = true;

            var payload = {
                driversLicense: {
                    driversLicenseNumber: $scope.newDriversLicenseNumber,
                    type: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newDriversLicenseNumber = '';
                $scope.saveNewDriversLicenseIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;

                    _RFC4.default.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Drivers license'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewDriversLicenseIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else if (responseError.data.errorCode === 24000) {

                        _RFC2.default.error('cw.dwm.entity.drivers_license.invalid_number');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            driversLicense: {
                id: $scope.driversLicense.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newDriversLicenseNumber = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Drivers license'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.updateDriversLicenseNumber = function ($event) {

        $scope.driversLicenseNumberIsValid = $event.currentTarget.value && validations.driversLicenseNumberValidator($event.currentTarget.value.trim());

        if ($scope.driversLicenseNumberIsValid) {

            $scope.updateEntryPayload.driversLicenseNumber = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { driversLicense: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Drivers license'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else if (responseError.data.errorCode === 24000) {

                    _RFC2.default.error('cw.dwm.entity.drivers_license.invalid_number');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmDriversLicense);

angular.module('controllers').controller('DwmDriversLicense', _serviceDependencies);

/***/ }),

/***/ "CyOw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$timeout', '$filter', 'DeviceRestService', 'Util'];

var DeviceRenameController = function DeviceRenameController($scope, $state, $timeout, $filter, DeviceRestService, Util) {
    _classCallCheck(this, DeviceRenameController);

    this.$state = $state;

    $scope.form = {
        submitted: false,
        errorSubmission: false,
        waitingResponse: false,
        renameDevice: {}
    };

    $scope.localDevice = {
        name: $filter('deviceName')($scope.data),
        nameRegExp: /^[^:<>"+&%$#*^/\\]+$/i,
        isEditable: false,
        status: $scope.data && $scope.data.attributes.state,
        type: $scope.data && $scope.data.attributes.type
    };

    var invalidNameHandler = function invalidNameHandler() {

        $scope.form.errorSubmission = true;
        $scope.form.waitingResponse = false;

        $timeout(function () {

            $scope.form.submitted = true;
            $scope.form.errorSubmission = false;
        }, 400);

        return false;
    };

    var updateDeviceHandler = function updateDeviceHandler() {

        var devicePayload = {
            data: {
                attributes: {
                    alias: $scope.localDevice.name
                },
                type: 'devices',
                id: $scope.data.id
            }
        };

        DeviceRestService.update($scope.data.id, devicePayload).then(function (response) {

            _index.DevicesRepository.update(response.data.data);

            _RFC4.default.send('ConnectWeb Device Rename Click', {
                Page: $state.current.name.indexOf('device-details') >= 0 ? 'Device Details' : 'My Devices'
            });

            $scope.form.submitted = false;
            $scope.form.errorSubmission = false;
            $scope.form.waitingResponse = false;
            $scope.localDevice.isEditable = false;
        }).then(null, function () {

            _RFC2.default.error({
                message: 'cw.device.rename.error',
                icon: {
                    cssClasses: 'icon-' + Util.deepFind($scope.data, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: $filter('deviceName')($scope.data)
                }
            });

            $scope.localDevice.name = $filter('deviceName')($scope.data);
            $scope.localDevice.isEditable = false;
            $scope.form.waitingResponse = false;
        });
    };

    $scope.rename = _.debounce(function () {

        $scope.form.submitted = false;
        $scope.form.waitingResponse = true;

        if (!$scope.form.renameDevice.$valid) {

            if ($scope.form.renameDevice.name.$error.required) {

                $scope.localDevice.name = $filter('deviceName')($scope.data);
                return true;
            }

            return invalidNameHandler();
        }

        return updateDeviceHandler();
    }, 300, true);

    $scope.localDevice.isEditable = false;
    $scope.devicesView = localStorage.getItem('DevicesView');

    var isOnDeviceDetails = this.$state.current.name === 'root.dashboard.device-details';
    $scope.isOnListView = $scope.devicesView === 'list' && !isOnDeviceDetails;

    $scope.toggleEditable = function () {

        if ($scope.devicesView === 'grid' || isOnDeviceDetails) {

            $scope.localDevice.isEditable = !$scope.localDevice.isEditable;
        }
    };

    // HACK: fixes a bug when we rename the device and change the state,
    // and are left with the old input in the model
    // until we change it again
    $scope.$watch('data', function (newData, oldData) {

        if (newData !== oldData) {

            $scope.localDevice.name = $filter('deviceName')(newData);
        }
    });
};

var DeviceRenameDirective = function DeviceRenameDirective() {
    _classCallCheck(this, DeviceRenameDirective);

    this.template = __webpack_require__("l+/6");
    this.restrict = 'E';
    this.replace = true;
    this.scope = { data: '=' };
    this.link = function ($scope, elem) {

        var input = elem.find('#renameDevice');
        // whenever the edit button is clicked we focus on the input and select the entire text
        $scope.$watch('localDevice.isEditable', function (newValue) {

            if (newValue === true) {

                input.focus();
            }
        });
    };

    _controllerDependencies.push(function ($scope, $state, $timeout, $filter, DeviceRestService, Util) {
        return new DeviceRenameController($scope, $state, $timeout, $filter, DeviceRestService, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'deviceRenameCtrl';
};

_directiveDependencies.push(function () {
    return new DeviceRenameDirective();
});

angular.module('directives').directive('deviceRename', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "D7Ue":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _scope = void 0;
var _userRestService = void 0;
var _auth = void 0;

var _serviceDependencies = ['$scope', '$focus', '$state', '$window', '$location', 'Auth', 'Util', 'UserRestService', 'Sso'];

/**
 * @ngdoc service
 * @name controllers.Confirm
 *
 * @description
 * Account Confirmation controller
 */

var Confirm = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $focus
     * @param  {any} $state
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} UserRestService
     * @param  {any} Sso
     */
    function Confirm($scope, $focus, $state, $window, $location, Auth, Util, UserRestService, Sso) {
        _classCallCheck(this, Confirm);

        // if the user doesn't have token, go to login
        if (!Util.getToken()) {

            Auth.gotoLogin();
        } else {

            _RFC4.default.send('ConnectWeb Account Confirmation Open', {
                Source: 'Direct'
            });
        }

        this.Util = Util;
        this.$window = $window;
        this.$state = $state;
        this.Auth = Auth;
        this.$focus = $focus;
        this.MeRepository = _index.MeRepository;
        this.Sso = Sso;

        _scope = $scope;

        _userRestService = UserRestService;
        _auth = Auth;
        _auth.loading = false;
        _auth.error = false;

        _scope.submitted = false;
        _scope.isDisabled = true;
        _scope.emailRegExp = this.Util.getEmailValidationRegExp();
        _scope.email = _index.MeRepository.getMyEmail();

        _scope.Recaptcha = _recaptcha2.default;

        this.resendEmailRetries = 0;

        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            _scope.showChangeLang = this.Sso.getChangeLang();

            _scope.clientId = this.Sso.getClientId();
        }

        // meRepository obeservable
        // const meObservable = MeRepository.getObservable();
        // const onNextMe = (data) => {

        //     // redirect to dashboard if the user gdpr is confirmed
        //     if (data && data.data.attributes.gdpr_confirm) {

        //          $location.path('/dashboard/devices');

        //     }

        // };
        // const meSubscriber = meObservable.subscribe(onNextMe, () => { }, () => { });

        Auth.sendAcpPing();

        // _scope.$on('$destroy', () => {

        //     meSubscriber.dispose();

        // });
    }

    _createClass(Confirm, [{
        key: 'changeEmail',
        value: function changeEmail() {

            _scope.isDisabled = false;
            this.$focus(_scope, 'email');
        }
    }, {
        key: 'resendEmail',
        value: function resendEmail() {
            var _this = this;

            var captchaRespose = _scope.Recaptcha.getCaptchaResponse();
            var headers = {};

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            // Check if the email is valid
            var formIsValid = _scope.confirmAccountForm.$valid;

            _RFC4.default.send('ConnectWeb Resend Confirmation Email Click', {
                Page: 'Auth Confirm'
            });

            _scope.submitted = true;

            if (formIsValid) {

                _auth.loading = true;

                var updateEmailPayload = {};
                var userId = this.MeRepository.getMyId();

                updateEmailPayload = {
                    data: {
                        attributes: {
                            email: _scope.email,
                            language: CWCONFIG.language
                        },
                        type: 'users',
                        id: userId
                    },
                    meta: {
                        send_verify_email: true,
                        captcha: captchaRespose
                    }
                };

                _userRestService.update(userId, updateEmailPayload, headers).then(function () {

                    _auth.loading = false;
                    _scope.isDisabled = true;
                    _auth.error = false;
                    _this.resendEmailRetries = 0;
                    _scope.Recaptcha.disableCaptcha();
                    _scope.Recaptcha.setCaptchaResponse();
                    _RFC2.default.success('cw.auth.confirm.change_email_success');
                }).then(null, function (err) {

                    _auth.loading = false;
                    _auth.error = true;

                    var errors = _this.Util.deepFind(err, 'data.errors');

                    if (errors && errors.length) {

                        var errorCode = errors[0].code;
                        if (errorCode === '918') {

                            _scope.Recaptcha.execute();
                        }
                    }
                });
            } else {

                this.Util.triggerAnimation('.auth-form', 'animated shake');
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            if (CWCONFIG.captchaConfig.accountConfirmationCaptchaRetries <= this.resendEmailRetries) {

                _scope.Recaptcha.enableCaptcha();
            }

            if (_scope.Recaptcha.isCaptchaRequired()) {

                _scope.Recaptcha.execute();
            } else {

                this.resendEmail();
            }
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            _scope.Recaptcha.setCaptchaResponse(response);
            this.resendEmail();
        }
    }]);

    return Confirm;
}();

_serviceDependencies.push(Confirm);

angular.module('controllers').controller('Confirm', _serviceDependencies);

/***/ }),

/***/ "DH9m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('controllers').controller('ServiceCtrl', ['$scope', '$state', function ($scope, $state) {

    var serviceId = $state.params.resourceId.toLowerCase();

    var checkService = function checkService() {

        var familyLocator = CWCONFIG.features.familyLocator ? 'family-locator' : '';
        var validServices = [familyLocator];

        return validServices.indexOf(serviceId) >= 0;
    };

    if (!checkService()) {

        $state.go('root.dashboard.home');
        return;
    }

    if (serviceId) {

        $scope.dynamicDirectiveTag = '<' + serviceId + '-service></' + serviceId + '-service>';
    }
}]);

/***/ }),

/***/ "DL1i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// import Util from 'common/services/util/-RFC.util';


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$rootScope', '$state', '$window', 'Util', '$location', '$anchorScroll', 'AppPricesRestService', 'PaymentUrlsRestService', 'ErrorHandler'];

var PrimePageController = function () {
    function PrimePageController($scope, $rootScope, $state, $window, Util, $location, $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler) {
        var _this = this;

        _classCallCheck(this, PrimePageController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$window = $window;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        var productsDetails = [];
        this.$scope.windowsProducts = [];
        this.$scope.osxProducts = [];
        this.$scope.androidProducts = [];
        this.$scope.iosProducts = [];
        this.AppPricesRestService = AppPricesRestService;
        this.PaymentUrlsRestService = PaymentUrlsRestService;
        this.ErrorHandler = ErrorHandler;
        this.$scope.price = '';
        this.$scope.products = _index.AppIntegrationsRepository.getById('aps10');
        var productsIds = this.$scope.products.relationships.apps.data;
        this.$scope.AllPrices = _index.AppPricesRepository.getAll();
        this.$scope.browsersExtensions = [];
        this.$scope.numberOfUsers = '1';
        this.$scope.runtime = '12';
        var browsersExtensions = ['pasm1', 'absn0', 'assh0'];
        this.Util = Util;
        this.navigator = Util.getDeviceNavigator();
        this.$scope.numberOfDevices = '5';

        this.$scope.activeProduct = 'aps10';
        this.$scope.product = _index.AppIntegrationsRepository.getAppName('aps10');
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        this.$scope.language = CWCONFIG.language === 'de' ? 'de' : null;

        this.$rootScope.isPrimeStore = true;

        this.$scope.showOPCButton = false;
        this.$scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;

        _RFC4.default.subscribe('showRecommendation:true', function () {

            _this.$scope.showOPCButton = true;
        });
        _RFC4.default.subscribe('showRecommendation:false', function () {

            _this.$scope.showOPCButton = false;
        });

        _RFC2.default.send('ConnectWeb Store Open', {
            Source: 'Direct',
            Store: 'Prime Page'
        });

        var hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];
        if (productsIds) {

            productsIds.forEach(function (product) {

                if (!hiddenAppInBundleIds.find(function (id) {
                    return product.id === id;
                })) {

                    productsDetails.push(_index.AppIntegrationsRepository.getById(product.id));
                }
            });
        }

        // sort products by os
        productsDetails.forEach(function (product) {

            var platform = product.attributes.custom.manifest.os;
            var isWindows = platform.find(function (os) {
                return os === 'windows';
            });
            var isOsx = platform.find(function (os) {
                return os === 'osx';
            });
            var isAndroid = platform.find(function (os) {
                return os === 'android';
            });
            var isIos = platform.find(function (os) {
                return os === 'ios';
            });

            if (isWindows) {

                _this.$scope.windowsProducts.push(product);
            }
            if (isOsx) {

                _this.$scope.osxProducts.push(product);
            }
            if (isAndroid) {

                _this.$scope.androidProducts.push(product);
            }
            if (isIos) {

                _this.$scope.iosProducts.push(product);
            }
        });

        // get browsers extensions
        browsersExtensions.forEach(function (product) {

            _this.$scope.browsersExtensions.push(_index.AppIntegrationsRepository.getById(product));
        });

        var primeLicenses = this.checkPrimeActivationCodes();

        this.$scope.hasAps20 = primeLicenses.find(function (license) {
            return license.attributes.app === 'aps20';
        });

        if (!this.$scope.hasAps20) {

            this.$scope.hasAps10 = primeLicenses.find(function (license) {
                return license.attributes.app === 'aps10';
            });
        }

        if ($scope.hasAps20) {

            this.$scope.activeProduct = 'aps20';
            this.$scope.numberOfDevices = '25';
        }

        if ($scope.hasAps10) {

            this.$scope.activeProduct = 'aps10';
            this.$scope.numberOfDevices = '5';
        }

        this.groupPrices(this.$scope.AllPrices);

        this.$scope.$on('$destroy', function () {

            _this.$rootScope.welcomeOffers = {};
        });

        //* Promotional Campaign: create CMA disclaimer for price promotion in prime page
        //* To be commented when the campaign is over
        // if (!$rootScope.cmaGBapplies) {

        //     $rootScope.createCMAlabels(
        //         'aps20_12_1',
        //         'Avira Prime 25',
        //         'aps20',
        //         '2023-11-23',
        //         '2023-12-03',
        //     );
        //     $rootScope.createCMAlabels(
        //         'aps10_12_1',
        //         'Avira Prime',
        //         'aps10',
        //         '2023-11-23',
        //         '2023-12-03',
        //     );

        // }

    }

    // get selected configuration price


    _createClass(PrimePageController, [{
        key: 'updateRuntime',
        value: function updateRuntime(runtime) {

            _RFC4.default.broadcast('runtime:changed', { runtime: runtime });
            var product = this.$scope.activeProduct;
            this.$scope.runtime = runtime;
            var currentPrice = this.$scope.prices[product].find(function (price) {
                return price.attributes.runtimes === runtime.toString();
            });
            this.$scope.currentPrice = currentPrice;
            var discount = this.Util.deepFind(this.$scope.currentPrice, 'attributes.promotion.discount');
            this.$scope.discount = discount ? discount + '%' : '20%';

            // lang fix for discount
            if (CWCONFIG.language === 'de') {

                this.$scope.discount = discount ? discount + ' %' : '20 %';
            }
            if (CWCONFIG.language === 'tr') {

                this.$scope.discount = discount ? '%' + discount : '%20';
            }
        }

        // Group prices by app acronym, @param: array

    }, {
        key: 'groupPrices',
        value: function groupPrices(prices) {
            var _this2 = this;

            var primeLicenses = this.checkPrimeActivationCodes();
            var groupedPrices = {};
            groupedPrices.aps10 = [];
            groupedPrices.aps20 = [];
            var aps10longestRuntime = 0;
            var aps20longestRuntime = 0;

            var aps20 = primeLicenses.find(function (license) {
                return license.attributes.app === 'aps20';
            });
            var aps10 = primeLicenses.find(function (license) {
                return license.attributes.app === 'aps10';
            });

            primeLicenses.forEach(function (prime) {

                var runtime = _this2.Util.deepFind(prime, 'attributes.runtime');

                if (!aps20) {

                    if (prime.attributes.app.indexOf('aps10') === 0) {

                        aps10longestRuntime = runtime === 1 ? '1' : '12';
                    }
                }

                if (prime.attributes.app.indexOf('aps20') === 0 && runtime > aps20longestRuntime) {

                    aps20longestRuntime = runtime === 1 ? '1' : '12';
                }
            });

            prices.forEach(function (price) {

                var runtime = _this2.Util.deepFind(price, 'attributes.runtimes');
                if (runtime < 36) {

                    if (!aps20) {

                        if (price.id.indexOf('aps10') === 0 && runtime >= aps10longestRuntime) {

                            groupedPrices.aps10.push(price);
                        }
                    }

                    if (price.id.indexOf('aps20') === 0 && runtime >= aps20longestRuntime) {

                        groupedPrices.aps20.push(price);
                    }
                }
            });

            if (aps10) {

                this.$scope.activeProduct = 'aps20';
                this.$scope.numberOfDevices = '25';
            }

            this.$scope.prices = {};
            this.$scope.prices.aps10 = groupedPrices.aps10;
            this.$scope.prices.aps20 = groupedPrices.aps20;
            this.updateRuntime(this.$scope.runtime);
            this.updateCurrentProduct(this.$scope.activeProduct, this.$scope.numberOfDevices);

            return groupedPrices;
        }

        // Returns an array with prime activation codes

    }, {
        key: 'checkPrimeActivationCodes',
        value: function checkPrimeActivationCodes() {
            var _this3 = this;

            var primeArr = [];
            var actvationCodes = _index.ActivationCodesRepository.getAll();
            actvationCodes.forEach(function (activationCode) {

                var appId = _this3.Util.deepFind(activationCode, 'relationships.app.data.id');
                if (appId && (appId === 'aps10' || appId === 'aps20')) {

                    primeArr.push(activationCode);
                }
            });

            return primeArr;
        }
    }, {
        key: 'buy',
        value: function buy(appId, runtimes) {

            var currentPrice = _index.AppPricesRepository.getSinglePrice(appId, runtimes, '1');

            var price = '';
            var discount = '';

            if (currentPrice) {

                if (this.Util.deepFind(currentPrice, 'attributes.promotion')) {

                    price = this.Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                    discount = this.Util.deepFind(currentPrice, 'attributes.promotion.discount');
                } else {

                    price = this.Util.deepFind(currentPrice, 'attributes.price_string');
                    discount = 0;
                }
            }

            var mixpanelData = {
                'Product ID': appId,
                Page: 'Prime Store Page',
                Runtimes: runtimes,
                Price: price,
                Discount: discount
            };

            _RFC2.default.send('ConnectWeb Store Buy Click', mixpanelData);

            this.$state.go('root.dashboard.store.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'store_prime',
                promotion: true,
                runtime: runtimes
            }, {
                reload: false
            });
        }

        // Scroll top when see plans button is clicked
        // Scroll down when 'find out more' is clicked

    }, {
        key: 'gotoAnchor',
        value: function gotoAnchor(anchor) {

            this.$location.hash(anchor);
            this.$anchorScroll();
        }

        // @param - app acronym(aps10, aps20) and number of devices: 5, 25

    }, {
        key: 'updateCurrentProduct',
        value: function updateCurrentProduct(activeProduct, numberOfDevices) {

            _RFC4.default.broadcast('product:changed', { activeProduct: activeProduct });
            this.$scope.numberOfDevices = numberOfDevices;
            this.$scope.activeProduct = activeProduct;
            var appPrices = this.$scope.prices[activeProduct];
            this.$scope.currentPrice = appPrices.find(function (price) {
                return parseInt(price.attributes.runtimes, 0) >= 12;
            });
            this.updateRuntime(this.$scope.currentPrice.attributes.runtimes);
        }
    }]);

    return PrimePageController;
}();

var PrimePageDirective = function PrimePageDirective() {
    _classCallCheck(this, PrimePageDirective);

    this.template = __webpack_require__("WK8i");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $rootScope, $window, Util, $location, $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler) {
        return new PrimePageController($scope, $rootScope, $window, Util, $location, $anchorScroll, AppPricesRestService, PaymentUrlsRestService, ErrorHandler);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'primePageCtrl';
};

_directiveDependencies.push(function () {
    return new PrimePageDirective();
});

angular.module('directives').directive('primePage', _directiveDependencies);

/***/ }),

/***/ "DLiH":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 *
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function (root, factory) {

	/* CommonJS */
  if (true) module.exports = factory()

  /* AMD module */
  else if (typeof define == 'function' && define.amd) define(factory)

  /* Global */
  else root.QRCode = factory()

}(this, function () {	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];

	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}

	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;

		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);

			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}

		return android;
	}

	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(col), "y": String(row)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		/**
		 * Draw the QRCode
		 *
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];

			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');

				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}

				aHTML.push('</tr>');
			}

			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');

			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;

			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
			}
		};

		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};

		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";
		}

		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage;
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}

	        	drawImage.apply(this, arguments);
	    	};
		}

		/**
		 * Check whether the user's browser supports Data URI or not
		 *
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};

		/**
		 * Drawing QRCode by using canvas
		 *
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();

			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};

		/**
		 * Draw the QRCode
		 *
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;

			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);

					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);

					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}

			this._bIsPainted = true;
		};

		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};

		/**
		 * Return whether the QRCode is painted or not
		 *
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};

		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};

		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}

			return Math.floor(nNumber * 1000) / 1000;
		};

		return Drawing;
	})();

	/**
	 * Get the type by string length
	 *
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {
		var nType = 1;
		var length = _getUTF8Length(sText);

		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;

			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}

			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}

		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}

		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}

	/**
	 * @class QRCode
	 * @constructor
	 * @example
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 *
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H]
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256,
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};

		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}

		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}

		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}

		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);

		if (this._htOption.text) {
			this.makeCode(this._htOption.text);
		}
	};

	/**
	 * Make the QRCode
	 *
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);
		this.makeImage();
	};

	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 *
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};

	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};

	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
	
	return QRCode;
	
}));


/***/ }),

/***/ "DYPj":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "DaMF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _appIntegrations = [];
var observableAppIntegrations = new Rx.BehaviorSubject(_appIntegrations);

var AppIntegrationsRepository = {
    replace: function replace(data, included) {

        included.forEach(function (includedApp) {

            var includedAppId = includedApp.id;
            // take the manifest from the 'data' param
            var appData = data.find(function (app) {
                return String(app.id) === includedAppId + '-dashboard';
            });
            includedApp.attributes.custom = appData.attributes.custom;
        });
        _appIntegrations = included;
        observableAppIntegrations.onNext(_appIntegrations);
    },


    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getSupportedOsTypes
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function returns all supported os of an app
     *
     * @param {string} appId the app integration id.
     *
     * @returns {Array} supported os list
     */
    getSupportedOs: function getSupportedOs(appId) {

        var appDetails = this.getById(appId);
        var supportedOSTypes = _RFCUtil2.default.deepFind(appDetails, 'attributes.custom.manifest.os');

        return supportedOSTypes;
    },
    getAll: function getAll() {

        return _appIntegrations;
    },
    getObservable: function getObservable() {

        return observableAppIntegrations;
    },


    /**
     * Return the integration details for a given integration id.
     * @param appIntegrationId The integration id(acronym)
     */
    getById: function getById(appIntegrationId) {

        return _appIntegrations.find(function (integration) {
            return String(integration.id) === String(appIntegrationId);
        });
    },


    /**
     * Return the integration details for a given prototype.
     * @param prototype The integration prototype(ex: antivirus)
     */
    getByPrototype: function getByPrototype(prototype) {

        return _appIntegrations.find(function (integration) {
            return String(integration.attributes.prototype) === String(prototype);
        });
    },


    /**
     * Return the integration details for a given prototype and license type.
     * @param prototype The integration prototype(ex: antivirus)
     * @param licenseType The license type (ex: free / paid / trial)
     */
    getByPrototypeAndLicenseType: function getByPrototypeAndLicenseType(prototype, licenseType) {

        return _appIntegrations.find(function (integration) {
            return String(integration.attributes.prototype) === String(prototype) && integration.attributes.license_type === licenseType;
        });
    },


    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getSidebarAppByPrototype
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function looks the app which is displayed in the left sidebar based of its prototype
     *
     * @param {string} prototype the prototype.
     *
     * @returns {Object} the app integration object
     */
    getSidebarAppByPrototype: function getSidebarAppByPrototype(prototype) {

        return _appIntegrations.find(function (integration) {
            return _RFCUtil2.default.deepFind(integration, 'attributes.prototype') === prototype && _RFCUtil2.default.deepFind(integration, 'attributes.custom.manifest.appType');
        });
    },


    /**
     * @ngdoc function
     * @name repositories.AppIntegrationsRepository#getAppByPrototype
     * @methodOf repositories.AppIntegrationsRepository
     * @function
     *
     * @description
     * This function returns the appIntegration  by prototype
     *
     * @param {string} prototype the prototype.
     *
     * @returns {Object} the app integration object
     */
    getAppByPrototype: function getAppByPrototype(prototype) {

        return _appIntegrations.find(function (integration) {
            return _RFCUtil2.default.deepFind(integration, 'attributes.prototype') === prototype;
        });
    },


    /**
     *
     * @param userId to be deleted
     * @param appId
     * @param checkOnlyPaidApps optional -if is true, return only the paid bundle components
     * @returns {{apps: Array, components: Array}}
     */
    getIncludes: function getIncludes(userId, appId, checkOnlyPaidApps) {

        var includedApps = [];
        var includedComponents = [];
        var self = this;

        var app = _.findWhere(observableAppIntegrations.value, { id: appId });

        if (!angular.isUndefined(app)) {

            if (app.attributes.type === 'bundle') {

                includedApps = app.relationships.apps.data;
                _.each(includedApps, function (item) {

                    var componentApp = _.findWhere(self.observableAppIntegrations.value, { id: item.id });
                    if (!angular.isUndefined(componentApp)) {

                        if (componentApp.attributes.prototype) {

                            if (checkOnlyPaidApps) {

                                if (componentApp.attributes.license_type === 'paid') {

                                    includedComponents.push(componentApp.attributes.prototype);
                                }
                            } else {

                                includedComponents.push(componentApp.attributes.prototype);
                            }
                        }
                    }
                });
            } else if (checkOnlyPaidApps) {

                if (app.attributes.license_type === 'paid') {

                    includedComponents.push(app.attributes.prototype);
                }
            } else {

                includedComponents.push(app.attributes.prototype);
            }
        }
        return { apps: includedApps, components: includedComponents };
    },

    /**
     * Return the app integration name for a given integration id.
     * @param appIntegrationId The integration id(acronym)
     */
    getAppName: function getAppName(appIntegrationId) {

        var app = this.getById(appIntegrationId);
        return _RFCUtil2.default.deepFind(app, 'attributes.resource.oeName');
    }
};

exports.default = AppIntegrationsRepository;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "DkO2":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox\">\n    <div class=\"text-center mt50 mb50\">\n        <a class=\"btn-medium btn-primary\" ng-click=\"buy()\">buy</a>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/dwm-upsell/dwm-upsell.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "DpBW":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"security-password\">\n\n        <div class=\"mya-section-info\">\n            <div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.security.change_email_title\"></div>\n            <div class=\"text-m mt5 text-grey-3\" translate=\"cw.my_account.security.change_email_desc\"></div>\n        </div>\n\n        <div class=\"mya-section-forms max-width-s\">\n            <div class=\"password-form\">\n                <form name=\"changeEmailForm\" role=\"form\" novalidate ng-submit=\"changeEmailCtrl.onSubmit()\">\n\n                    <div>\n                        <div class=\"text-m text-grey-3 pass-text\" translate=\"cw.form.email\"></div>\n                        <div class=\"form-group\">\n                            <input type=\"text\"\n                                ng-model=\"email\"\n                                name=\"email\"\n                                ng-keyup=\"changeEmailCtrl.checkEmailAddresses()\"\n                                maxlength=\"100\"\n                                autocomplete=\"off\"\n                                placeholder=\"{{ 'cw.form.email' | translate }}\"\n                                ng-class=\"{'error': (changeEmailForm.email.$invalid ||\n                                                    !isEmailDifferent ||\n                                                    emailError) && submitted}\"\n                                id=\"email\"\n                                ng-pattern=\"emailRegExp\"\n                                required />\n\n                            <label ng-hide=\"changeEmailForm.email.$viewValue.length > 0\" class=\"fallback-input\" for=\"email\" translate=\"cw.form.email\"></label>\n\n                            <p class=\"error-message\"\n                               ng-show=\"changeEmailForm.email.$invalid && submitted\"\n                               translate=\"cw.validator.messages.email\"></p>\n\n                            <p class=\"error-message\"\n                               ng-show=\"!isEmailDifferent && submitted\"\n                               translate=\"cw.my_account.security.error.same_email\"></p>\n\n                            <p class=\"error-message\"\n                               translate=\"cw.validator.messages.duplicate_email\"\n                               ng-show=\"emailError && submitted && changeEmailForm.email.$pristine\"></p>\n                        </div>\n                    </div>\n                    <div>\n                        <div class=\"text-m text-grey-3 pass-text\" translate=\"cw.form.current_password\"></div>\n                        <div class=\"form-group\">\n                            <input type=\"password\"\n                            ng-model=\"password\"\n                            ng-keyup=\"submitted = false\"\n                            name=\"password\"\n                            maxlength=\"100\"\n                            autocomplete=\"off\"\n                            ng-class=\"{'error': (changeEmailForm.password.$invalid) && submitted}\"\n                            id=\"password\"\n                            required connectqa-mya=\"current-password\"/>\n\n                            <span class=\"show-password\" ng-class=\"{'text': inputType === 'text'}\"\n                                ng-click=\"changeEmailCtrl.showPassword()\"></span>\n\n                            <div ng-show=\"changeEmailForm.password.$error.serverValidation && submitted\">\n                                <p class=\"error-message\"\n                                    ng-show=\"changeEmailForm.password.$error.serverValidation && submitted\"\n                                    translate=\"cw.notification.profile.change_password.invalid_current_password\"></p>\n                                <a ui-sref=\"root.auth.forgot\" class=\"text-blue-2 error-message\" ng-show=\"changeEmailForm.password.$error.serverValidation && submitted && loginFailedAttempts>=2\"\n                                    ng-click=\"changeEmailCtrl.setEmail(); changeEmailCtrl.Auth.removeLoginCookies()\" translate=\"cw.auth.login.error.recover\"></a>\n                            </div>\n\n                            <p class=\"error-message\"\n                                ng-show=\"changeEmailForm.password.$error.required && submitted\"\n                                translate=\"cw.input.current_password.error.no_characters\"></p>\n                            </div>\n                    </div>\n\n                    <button class=\"btn btn-large btn-primary mb10 spin-loader mt5\" ng-disabled=\"loading\" translate=\"cw.general.change_email\"></button>\n                </form>\n\n                <p class=\"text-grey-3 text-s\" translate=\"cw.my_account.security.change_email_info\" translate-values=\"{brandname : brandName}\"></p>\n\n            </div>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "DxG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _index = __webpack_require__("lSlM");

angular.module('controllers').controller('Applockplus', ['$scope', '$rootScope', '$stateParams', '$timeout', '$state', '$focus', '$interval', '$translate', 'Util', 'DeviceRestService', function ($scope, $rootScope, $stateParams, $timeout, $state, $focus, $interval, $translate, Util, DeviceRestService) {

    $scope.userId = _index.MeRepository.getMyId();
    $scope.deviceId = $stateParams.deviceId;

    /**
    * The user confirmed locking this device
    */
    $scope.confirmStopManage = function () {

        /**
         * if the device is locked, 'applockplus' from the others.managed property
         * must be deleted
         */
        // TODO
        // var managed = Device.getManaged($scope.userId, $scope.deviceId);
        var managed = []; // TODO this var
        var managedParam = _.without(managed, 'applockplus');

        /* send the REST */
        var devicePayload = {
            data: {
                attributes: {
                    others: {
                        managed: _.isEmpty(managedParam) ? undefined : managedParam
                    }
                },
                type: 'devices',
                id: $scope.deviceId
            }
        };

        DeviceRestService.update($scope.deviceId, devicePayload);

        /* close the drilldown and go to the dashboard */
        $state.go('root.dashboard.home');
    };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "DyxV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _session = {};
var _observableKeys = {};
var _emptyObject = {};

var ISessionObservable = function () {
    function ISessionObservable(context) {
        _classCallCheck(this, ISessionObservable);

        this._context = context;
    }

    _createClass(ISessionObservable, [{
        key: 'from',
        value: function from(key) {

            if (!_session[key]) {

                _session[key] = _emptyObject;
            }

            var value = _observableKeys[key] || (_observableKeys[key] = new Rx.Subject(_session[key]));

            return value;
        }
    }]);

    return ISessionObservable;
}();

/**
* @ngdoc service
* @name oe.enums.SessionKeys
*
* @description
* Values used for Session keys.
* @example
* 1. SessionKeys.ReferralCode
* 2. SessionKeys.PlaySoundTimer
* 3. SessionKeys.LockDeviceTimer
* 4. SessionKeys.UnlockDeviceTimer
* 5. SessionKeys.WipeData
* 6. SessionKeys.DeviceId
* 7. SessionKeys.SubscriptionDeployAppId
*/

var SessionKeys = {
    ReferralCode: 'referralCode',
    PlaySoundTimer: 'playSoundTimer',
    LockDeviceTimer: 'lockDeviceTimer',
    UnlockDeviceTimer: 'unlockDeviceTimer',
    WipeDataTimer: 'wipeDataTimer',
    DeviceId: 'deviceId',
    SubscriptionDeployAppId: 'subscriptionDeployAppId',
    SsoExtraUrlParams: 'ssoExtraUrlParams',
    ThirdPartyLogin: 'thirdPartyLogin',
    ExtraUrlParams: 'extraUrlParams'
};

/**
 * @ngdoc service
 * @name oe.core.Session
 *
 * @description
 * This class is used to save objects related to the session of application.
 */

var SessionCls = function () {
    function SessionCls() {
        _classCallCheck(this, SessionCls);
    }

    _createClass(SessionCls, [{
        key: 'Observable',


        /**
         * @ngdoc function
         * @name oe.core.Session#Observable
         * @methodOf oe.core.Session
         * @function
         *
         * @description
         * This function can be used to get an observable session object.
         * @returns {Object} An observable session object.
         */
        value: function Observable() {

            var observable = this._observable || (this._observable = new ISessionObservable(this));
            return observable;
        }

        /**
        * @ngdoc function
        * @name oe.core.Session#setValue
        * @methodOf oe.core.Session
        * @function
        *
        * @description
        * This function can be used to set a value for a specific key in session object.
        * @param {String} key A string used to identify the value in session object
           (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).
         * @param {*} value Value for specified key in session object.
        */

    }, {
        key: 'setValue',
        value: function setValue(key, value) {

            _session[key] = value;

            if (_observableKeys[key]) {

                _observableKeys[key].onNext(value);
            }
        }

        /**
        * @ngdoc function
        * @name oe.core.Session#getValue
        * @methodOf oe.core.Session
        * @function
        *
        * @description
        * This function can be used to get the value for a
        * specific key in session object.
        * @param {String} key A string used to identify the value in session object
           (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).
         * @returns {*} Value for specified key in session object
        */

    }, {
        key: 'getValue',
        value: function getValue(key) {

            return _session[key];
        }

        /**
        * @ngdoc function
        * @name oe.core.Session#hasValue
        * @methodOf oe.core.Session
        * @function
        *
        * @description
        * This function can be used to check if was assigned a value for specified key
        * @param {String} key A string used to identify the value in session object
           (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).
         * @returns {Boolean} True if session[key] has assigned a value.
        */

    }, {
        key: 'hasValue',
        value: function hasValue(key) {

            return _session[key] && _session[key] !== _emptyObject;
        }

        /**
        * @ngdoc function
        * @name oe.core.Session#clear
        * @methodOf oe.core.Session
        * @function
        *
        * @description
        * This function can be used to unassigned value of a specific key.
        * @param {String} key A string used to identify the value in session object
           (_**Note**: Is recommended to use the values from **{@link oe.enums.SessionKeys}** enum_).
         */

    }, {
        key: 'clear',
        value: function clear(key) {

            _session[key] = _emptyObject;
        }

        /**
        * @ngdoc function
        * @name oe.core.Session#clearAll
        * @methodOf oe.core.Session
        * @function
        *
        * @description
        * This function can be used to unassigned all values from session object.
        */

    }, {
        key: 'clearAll',
        value: function clearAll() {

            _session = {};
        }
    }]);

    return SessionCls;
}();

var Session = new SessionCls();

exports.SessionKeys = SessionKeys;
exports.Session = Session;

/***/ }),

/***/ "Dzt7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react2angular = __webpack_require__("mJvl");

var _react = __webpack_require__("ccQ0");

angular.module('directives')
//     .component('reactComponent', react2angular(MyComponent, ['callbackFn'],
// ['$http', 'AppIntegrationRestService', 'DevicesRepository']))
.component('alertComponent', (0, _react2angular.react2angular)(_react.AlertComponent, [], ['$state', '$rootScope']));

/***/ }),

/***/ "E0M5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
    Parse images URL in order to display them corectly.
    If the value is null the function returns a default image.
 */

var FilterImageUrlParse = function FilterImageUrlParse(value) {

    if (value) {

        return JSON.parse('"' + value + '"');
    }
    return 'https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png';
};

exports.default = FilterImageUrlParse;

/***/ }),

/***/ "E4A5":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("xwKO");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "E4vQ":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "EAai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFCSession = __webpack_require__("DyxV");

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$timeout', '$state', '$location', '$urlMatcherFactory', 'Util', '$rootScope'];

/**
* @ngdoc service
* @name controllers.Deploy
*
* @description
* Deploy controller
*/

var Deploy = function () {

    /**
     * @param $scope
     * @param $state
     * @param $location
     * @param $urlMatcherFactory
     */
    function Deploy($scope, $timeout, $state, $location, $urlMatcherFactory, Util, $rootScope) {
        var _this = this;

        _classCallCheck(this, Deploy);

        this.currentDeviceOS = window.deviceOs;

        this.$urlMatcherFactory = $urlMatcherFactory;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$scope = $scope;
        this.$state = $state;
        this.Util = Util;
        this.$rootScope = $rootScope;
        this.user = _index.MeRepository.getMyUser();

        this.$scope.AppIntegrationsRepository = _index.AppIntegrationsRepository;
        this.DevicesRepository = _index.DevicesRepository;
        this.LicensesRepository = _index.LicensesRepository;
        this.DevicesProcessor = _index2.DevicesProcessor;

        this.$scope.changeWizard = function (stateName, params, options) {

            _this.$state.go(stateName, params, options).then(function () {

                _this._routes();
            }).catch(function (e) {
                return _loggers2.default.log(e);
            });
        };

        this.$scope.showSuccessScreen = function (category, deviceType) {

            var queryParams = _this.$location.search();

            if (!queryParams.autoInstall) {

                if (deviceType === 'pc') {

                    if (category === 'download') {

                        _this.$scope.dynamicDirectiveTag = '<pc-download-deployment-success />';
                    } else if (category === 'email') {

                        _this.$scope.dynamicDirectiveTag = '<pc-email-deployment-success />';
                    }
                } else if (deviceType === 'phone') {

                    if (category === 'email') {

                        _this.$scope.dynamicDirectiveTag = '<phone-email-deployment-success />';
                    }
                }

                var updatedInputData = angular.extend({}, _this.$scope.inputData, {

                    showSuccessScreen: true

                });

                _this.$scope.inputData = updatedInputData;
            }
        };

        this.$scope.deployOnDeviceSuccess = function (device, appId) {

            _this.$scope.inputData = angular.extend({}, _this.$scope.inputData, {

                deviceId: device.id,
                appId: appId,
                completedSteps: true

            });

            if (device.attributes.os === 'osx') {

                // show download modal for osx
                _this.$scope.inputData.os = device.attributes.os;
                _this.$scope.dynamicDirectiveTag = '<pc-deployment-wizard />';
            } else if (device.attributes.state === 'online') {

                _this.$scope.dynamicDirectiveTag = '<online-deployment />';
            } else {

                _this.$scope.dynamicDirectiveTag = '<offline-deployment />';
            }
        };

        this._init();
    }

    _createClass(Deploy, [{
        key: '_init',
        value: function _init() {

            this._routes();
        }
    }, {
        key: '_routes',
        value: function _routes() {

            var queryParams = this.$location.search();

            // My Devices
            if (this._isMatching('/dashboard/devices/new/ltb/deploy')) {

                var paramsWithDefaultOs = angular.extend({}, this.$state.params, {
                    os: 'windows'
                });

                this.$scope.changeWizard('root.dashboard.devices.ltb.deploy', paramsWithDefaultOs, {
                    reload: false
                });
            } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?os')) {

                var licenses = this.LicensesRepository.getAll();

                if (licenses.length) {

                    this.$scope.inputData = {
                        appId: queryParams.appId,
                        licenses: licenses,
                        os: queryParams.os,
                        deviceType: this.Util.getDeviceTypeBy(queryParams.os)
                    };

                    this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';
                    return;
                }
                var paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                    appId: CWCONFIG.defaultDeployedAppId[queryParams.os],
                    os: queryParams.os
                });

                this.$scope.changeWizard('root.dashboard.devices.ltb.deploy', paramsWithDefaultApp, {
                    reload: false
                });
            } else if (this._isMatching('/dashboard/home/new/ltb/deploy?os')) {

                var _licenses = this.LicensesRepository.getAll();

                if (_licenses.length) {

                    this.$scope.inputData = {
                        appId: queryParams.appId,
                        licenses: _licenses,
                        os: queryParams.os,
                        deviceType: this.Util.getDeviceTypeBy(queryParams.os)
                    };

                    this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';
                    return;
                }
                var _paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                    appId: CWCONFIG.defaultDeployedAppId[queryParams.os],
                    os: queryParams.os
                });

                this.$scope.changeWizard('root.dashboard.home.ltb.deploy', _paramsWithDefaultApp, {
                    reload: false
                });
            } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?appId')) {
                var appId = queryParams.appId;

                var app = this._checkForApp(appId);

                if (app) {

                    this.$scope.inputData = {
                        resourceId: this.$state.params.resourceId,
                        appId: appId
                    };
                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                } else {

                    this.Util.closeModal();
                }
            } else if (this._isMatching('/dashboard/devices/new/ltb/deploy?appId&os')) {

                this._showDeployWizard(queryParams);
            } else if (this._isMatching('/dashboard/home/new/ltb/deploy?appId&os')) {

                this._showDeployWizard(queryParams);
            } else if (this._isMatching('/dashboard/devices/:resourceId/tabs/:tab/ltb/deploy?appId') || this._isMatching('/dashboard/devices/:resourceId/tabs/:tab/ltb/deploy?appId?autoInstall')) {

                // Device Details
                var deviceId = this.$state.params.resourceId;
                var device = this.DevicesRepository.getById(deviceId);
                var mobileTypes = ['tablet', 'phone'];

                this.$scope.inputData = {
                    appId: queryParams.appId,
                    deviceId: deviceId
                };

                if (!device) {

                    this.Util.closeModal();
                    return;
                }

                // Show download modal if device os is osx
                if (device.attributes.os === 'osx' || device.attributes.os === 'windows') {

                    queryParams.os = device.attributes.os;
                    this._showDeployWizard(angular.extend(queryParams, {
                        autoInstall: queryParams.autoInstall
                    }));
                    return;
                }

                if (mobileTypes.indexOf(device.attributes.type) >= 0) {

                    queryParams.os = device.attributes.os;
                    this._showDeployWizard(queryParams);
                    return;
                }

                // if (device.attributes.state === 'online') {

                //     this.$scope.dynamicDirectiveTag = '<online-deployment />';
                //     return;

                // }

                // this.$scope.dynamicDirectiveTag = '<offline-deployment />';
            } else if (this._isMatching('/dashboard/products/:resourceId/ltb/deploy') || this._isMatching('/dashboard/products/:resourceId/ltb/deploy?os&deployType')) {

                // My Products
                if (!this._checkForApp(this.$state.params.resourceId)) {

                    this.Util.closeModal();
                    return;
                }

                this.$scope.inputData = {
                    resourceId: this.$state.params.resourceId,
                    appId: this.$state.params.resourceId
                };

                if (this.$state.params.deployType && this.$state.params.os) {

                    angular.extend(this.$scope.inputData, {
                        deployType: this.$state.params.deployType,
                        os: this.$state.params.os
                    });
                }

                var _app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
                this.compatibleDevicesList = this.DevicesProcessor.getCompatibleDevices(_app.id, _app.attributes.prototype);
                if (this.compatibleDevicesList.length === 0) {

                    if (this.$state.params.deployType) {

                        // Products
                        this._showDeployWizard(angular.extend(queryParams, {
                            appId: this.$state.params.resourceId,
                            autoInstall: queryParams.autoInstall
                        }));
                    } else {

                        this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                    }
                } else {

                    this.$scope.dynamicDirectiveTag = '<choose-device-deployment-wizard />';
                }
            } else if (this._isMatching('/dashboard/devices/:resourceId/ltb/deploy?deviceCategory')) {

                this.$scope.inputData = {
                    deviceCategory: this.$state.params.deviceCategory
                };

                this.$scope.dynamicDirectiveTag = '<choose-os-type-wizard />';
            } else if (this._isMatching('/dashboard/home/:resourceId/ltb/deploy?deviceCategory')) {

                this.$scope.inputData = {
                    deviceCategory: this.$state.params.deviceCategory
                };

                this.$scope.dynamicDirectiveTag = '<choose-os-type-wizard />';
            } else if (this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId') || this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&autoInstall') || this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&deployType')) {

                // Products
                if (queryParams.deviceId === 'new') {

                    this.$scope.inputData = {
                        resourceId: this.$state.params.resourceId,
                        appId: this.$state.params.resourceId,
                        deployType: this.$state.params.deployType
                    };

                    if (this.$state.params.deployType) {

                        angular.extend(this.$scope.inputData, {
                            deployType: this.$state.params.deployType
                        });
                    }

                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                } else {

                    this.Util.closeModal();
                }
            } else if (this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&os') || this._isMatching('/dashboard/products/:resourceId/ltb/deploy?deviceId&os&autoInstall')) {

                // Products
                this._showDeployWizard(angular.extend(queryParams, { appId: this.$state.params.resourceId, autoInstall: queryParams.autoInstall }));
            } else if (
            // My Subscriptions
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId') || this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&autoInstall')) {

                var deploymentAppId = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SubscriptionDeployAppId);

                if (queryParams.deviceId === 'new') {

                    this.$scope.inputData = {
                        resourceId: this.$state.params.resourceId,
                        appId: this.$state.params.appId
                    };
                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                } else if (deploymentAppId) {

                    var license = this.LicensesRepository.getLicenseByAppId(deploymentAppId);
                    var activationCode = this.Util.deepFind(license, 'relationships.activation-code.data.id');
                    var matchingOS = this.DevicesProcessor.getDeployOSfor(deploymentAppId, this.currentDeviceOS) || null;
                    var appToDeploy = deploymentAppId;

                    if (license) {

                        var authExtraUrlParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams);
                        var queryParameters = authExtraUrlParams.substring(authExtraUrlParams.indexOf('?'));
                        var deployQueryParams = _.isEmpty(this.$location.search()) ? this.Util.getParams(queryParameters) : this.$location.search();
                        var deployPayload = angular.extend({}, {
                            ltb: 'deploy',
                            resourceId: activationCode,
                            deviceId: 'new',
                            appId: appToDeploy,
                            os: matchingOS,
                            tab: 'plans'
                        }, deployQueryParams);

                        // if we receive the autoInstall attribute and it's set to true
                        // we also check if we have an os on which to install the product
                        var canBeAutoInstalled = deployPayload.autoInstall && deployPayload.autoInstall === 'true' && deployPayload.os !== null;

                        if (!canBeAutoInstalled || appToDeploy === 'adwp1') {

                            deployPayload.autoInstall = false; // disable autoInstall

                            // set a default os for which to display the modal
                            // first in the list of compatible oses for the product
                            var supportedOs = _index.AppIntegrationsRepository.getSupportedOs(deploymentAppId);
                            deployPayload.os = supportedOs && supportedOs.length > 0 && supportedOs[0];
                        }

                        this._showDeployWizard(angular.extend(deployPayload));
                        _RFCSession.Session.clear(_RFCSession.SessionKeys.SubscriptionDeployAppId);
                    } else {

                        this.Util.closeModal();
                    }
                } else {

                    this.Util.closeModal();
                }
            } else if (
            // My Subscriptions
            this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&os') || this._isMatching('/dashboard/subscriptions/tabs/:tab/:resourceId/ltb/deploy?deviceId&appId&os&autoInstall')) {

                var appData = _index.AppIntegrationsRepository.getById(queryParams.appId);
                var appType = this.Util.deepFind(appData, 'attributes.type');

                if (appType === 'bundle' && (queryParams.os === 'android' || queryParams.os === 'ios')) {

                    // Send only the current license
                    var _licenses2 = [];
                    if (!this.LicensesRepository.getLicenseBy(this.$state.params.resourceId)) {

                        // Trial
                        _licenses2[0] = this.LicensesRepository.getLicenseById(this.$state.params.resourceId);
                    } else {

                        _licenses2[0] = this.LicensesRepository.getLicenseBy(this.$state.params.resourceId);
                    }

                    this.$scope.inputData = {
                        licenses: _licenses2,
                        os: queryParams.os,
                        deviceType: this.Util.getDeviceTypeBy(queryParams.os)
                    };

                    this.$scope.dynamicDirectiveTag = '<paid-deployment-wizard />';
                } else {

                    this._showDeployWizard(angular.extend(queryParams, { resourceId: this.$state.params.resourceId }));
                }
            } else if (this._isMatching('/dashboard/apps/:resourceId/devices/:deviceId/ltb/deploy?appId')) {

                // Sidebar apps page deploy

                if (!this._checkForApp(queryParams.appId)) {

                    this.Util.closeModal();
                    return;
                }

                if (this.$state.params.deviceId === 'new') {

                    this.$scope.inputData = {
                        resourceId: this.$state.params.resourceId,
                        appId: queryParams.appId
                    };
                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                } else {

                    this.Util.closeModal();
                }
            } else if (this._isMatching('/dashboard/apps/:resourceId/devices/:deviceId/ltb/deploy?appId&os')) {

                this._showDeployWizard(angular.extend(queryParams, { appId: queryParams.appId }));
            } else if (this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&appId') || this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&autoInstall')) {

                // store
                if (queryParams.deviceId === 'new') {

                    this.$scope.inputData = {
                        resourceId: this.$state.params.resourceId,
                        appId: this.$state.params.appId
                    };
                    this.$scope.dynamicDirectiveTag = '<choose-os-type-deployment-wizard />';
                } else {

                    this.Util.closeModal();
                }
            } else if (this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&os') || this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&os&autoInstall') || this._isMatching('/dashboard/store/:resourceId/ltb/deploy?deviceId&appId&os&autoInstall')) {

                // store
                this._showDeployWizard(angular.extend(queryParams, { appId: this.$state.params.appId, autoInstall: queryParams.autoInstall }));
            }

            if (this.$scope.inputData && !this.$scope.inputData.emails) {

                this.$scope.inputData = angular.extend(this.$scope.inputData, { emails: [this.user.attributes.email] });
            }

            // Save the license id or the activation code on $rootScope
            // to be able to go back if the user selects ios or android
            // from deploy on another device modal on subscriptions
            if (this.$state.params.resourceId.length >= 25 || this.$state.params.resourceId.length === 20) {

                this.$rootScope.State.deploySteps[0] = this.$state.params;
            }

            // currentAppId is used for deploy modal breadcrumb
            // it creates a relationship between a bundle and a product
            if (this.$rootScope.State.deploySteps.length > 0) {

                if (this.$rootScope.State.deploySteps[0].appId !== this.$state.params.appId) {

                    this.$rootScope.State.deploySteps[0].currentAppId = this.$state.params.appId;
                }
            }
        }
    }, {
        key: '_isMatching',
        value: function _isMatching(pattern) {

            var urlMatcher = this.$urlMatcherFactory.compile(pattern);

            return this.$location.url() === urlMatcher.format(angular.extend(this.$state.params, this.$location.search()));
        }
    }, {
        key: '_checkForApp',
        value: function _checkForApp(appId) {

            var app = _index.AppIntegrationsRepository.getById(appId);
            var hasApp = !!app;

            return hasApp;
        }
    }, {
        key: '_showDeployWizard',
        value: function _showDeployWizard(queryParams) {

            this.$scope.inputData = {
                appId: queryParams.appId,
                resourceId: queryParams.appId,
                os: queryParams.os,
                autoInstall: queryParams.autoInstall
            };

            if (!this._checkForApp(queryParams.appId)) {

                this.Util.closeModal();
                return;
            }

            if (queryParams.os === 'webapp') {

                this.$scope.dynamicDirectiveTag = '<web-app-deployment />';
                return;
            }

            if (queryParams.os === 'windows' || queryParams.os === 'osx') {

                this.$scope.dynamicDirectiveTag = '<pc-deployment-wizard />';
                return;
            }

            if (queryParams.os === 'android' || queryParams.os === 'ios') {

                this.$scope.dynamicDirectiveTag = '<phone-deployment-wizard />';
                return;
            }

            this.Util.closeModal();
        }
    }]);

    return Deploy;
}();

_serviceDependencies.push(Deploy);

angular.module('controllers').controller('Deploy', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "EAyW":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("unVR"),
    baseMatchesProperty = __webpack_require__("h+b5"),
    identity = __webpack_require__("atk5"),
    isArray = __webpack_require__("zOp4"),
    property = __webpack_require__("cerT");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "EFQi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('OSName', ['$translate', 'Util', function ($translate, Util) {
    return function (os) {

        os = (os || '').toLowerCase();

        switch (os) {

            case 'osx':
                return $translate.instant('cw.general.os.osx');
            case 'ios':
                return $translate.instant('cw.general.os.ios');
            case 'windows':
                return $translate.instant('cw.general.os.windows');
            case 'android':
                return $translate.instant('cw.general.os.android');
            default:
                return Util.capitalizeFirstLetter(os);

        }
    };
}]);

/***/ }),

/***/ "EZpZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', 'GdprActionsRestService', 'Util', '$rootScope'];

var GdprReport = function GdprReport($scope, $state, GdprActionsRestService, Util, $rootScope) {
    _classCallCheck(this, GdprReport);

    var GdprReports = _index.GdprReportsRepository.getAll();
    $scope.finalReport = _index.GdprReportsRepository.getAll();
    var gdprReportsObservable = _index.GdprReportsRepository.getObservable();
    $scope.hasReport = true;
    $scope.brandName = CWCONFIG.partnerConfig.name;

    var onNextAction = function onNextAction() {

        if ($rootScope.gdprReportTimestamp) {

            $scope.gdprReportTimestamp = $rootScope.gdprReportTimestamp;
        }

        if (GdprReports.length > 0) {

            $scope.hasReport = true;
        } else {

            $scope.hasReport = false;
        }
    };

    var mixpanelPayload = {
        Modal: 'GDPR Report',
        Page: Util.getPageName()
    };

    _RFC2.default.send('ConnectWeb Modal Open ', mixpanelPayload);

    var gdprReportsSubscriber = gdprReportsObservable.subscribe(onNextAction, function () {}, function () {});

    $scope.$on('$destroy', function () {

        gdprReportsSubscriber.dispose();
    });

    $scope.getReport = function () {

        var payload = {
            data: {
                attributes: {
                    action_type: 'gdpr_get_data'
                }
            }
        };

        _RFC2.default.send('ConnectWeb Request Report Click');

        GdprActionsRestService.create(payload).then(function () {

            GdprActionsRestService.getAllAsync().then(function (response) {

                _index.GdprActionsRepository.replace(response.data.data);
            });

            $state.go('root.dashboard.my-account.ltb', {
                ltb: 'get-report'
            });
        }).then(null, function (error) {

            var errorReason = void 0;

            if (Util.deepFind(error, 'data.error')) {

                errorReason = error.data.code;
            } else if (Util.deepFind(error, 'data.errors')) {

                errorReason = error.data.errors[0].code;
            }

            if (errorReason === '1808') {

                _RFC4.default.error('cw.get_report.already_requested_error');
            } else {

                _RFC4.default.error('cw.get_report.error');
            }
        });
    };

    $scope.print = function () {

        _RFC2.default.send('Connect Web GDPR Print Click');
    };
};

_serviceDependencies.push(GdprReport);

angular.module('controllers').controller('GdprReport', _serviceDependencies);

/***/ }),

/***/ "EcjD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
/* eslint guard-for-in: 0 */
/* eslint no-restricted-syntax: 0 */


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

var _RFC3 = __webpack_require__("YW9j");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFCSession = __webpack_require__("DyxV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['Auth', '$location', '$state', '$window', 'ErrorHandler', 'OAuthRestService', '$rootScope', 'JWT', 'Util', '$q', 'Facebook', 'Google'];

/**
 * @ngdoc service
 * @name services.Sso
 *
 * @description
 * This class is used to save extra params
 * received in the auth url and redirect to the received uri after login
 */

var Sso = function () {

    /**
     * @param {any} Auth Auth
     * @param {any} $location $location
     * @param {any} $state $state
     * @param {any} $window config
     * @param {any} ErrorHandler config
     * @param {any} OAuthRestService config
     * @param {any} $rootScope $rootScope
     * @param {any} JWT JWT
     * @param {any} $q $q
     * @param {any} Facebook Facebook
     * @param {any} Google Google
     */
    function Sso(Auth, $location, $state, $window, ErrorHandler, OAuthRestService, $rootScope, JWT, Util, $q, Facebook, Google) {
        _classCallCheck(this, Sso);

        this.Auth = Auth;
        this.Util = Util;
        this.$location = $location;
        this.$window = $window;
        this.ErrorHandler = ErrorHandler;
        this.OAuthRestService = OAuthRestService;
        this.$rootScope = $rootScope;
        this.JWT = JWT;
        this.$q = $q;
        this.$state = $state;
        this.Facebook = Facebook;
        this.Google = Google;

        // If the token contains the agent id set it to session storage
        // in order to display the otc tab from subscriptions page for support agents only
        var queryParams = this.$location.search();
        var token = queryParams.access_token;

        if (token) {

            var decodedToken = this.JWT.getTokenPayload(token);
            if ('aid' in decodedToken) {

                sessionStorage.setItem('aid', decodedToken.aid);
            }
        }
    }

    /**
     * @ngdoc function
     * @name services.Sso#saveExtraParams
     * @methodOf services.saveExtraParams
     * @function
     *
     * @description
     * This method is used to saveExtraParams from the auth URL
     *
     */


    _createClass(Sso, [{
        key: 'saveExtraParams',
        value: function saveExtraParams() {

            var queryParams = this.$location.search();
            var path = this.$location.path();

            // save extra params in to session to use them even if the url changes
            _RFCSession.Session.setValue(_RFCSession.SessionKeys.SsoExtraUrlParams, queryParams);

            /* save client_id, campaign, content_id and campaign_type and redirect_uri,
               in session storage to be saved after refresh */
            var ssoSessionStorage = sessionStorage.getItem('SsoExtraUrlParams');
            if (!ssoSessionStorage || ssoSessionStorage === '{}') {

                var ssoExtraUrlParams = {
                    client_id: queryParams.client_id,
                    campaign: queryParams.campaign,
                    content_id: queryParams.content_id,
                    campaign_type: queryParams.campaign_type,
                    redirect_uri: queryParams.redirect_uri,
                    cw_ref_code: queryParams.cw_ref_code
                };

                if (queryParams.action !== 'gotologin') {

                    ssoExtraUrlParams.action = queryParams.action;
                }
                sessionStorage.setItem('SsoExtraUrlParams', JSON.stringify(ssoExtraUrlParams));
            }

            if ((queryParams.src || '').toLowerCase() === 'mobileapp') {

                document.cookie = 'oe_mobile_session=1; path=/; SameSite=Strict; Secure';
            }

            /* the SSO link is not a thirdParyLogin if the URL contains
               a client id and the path is /auth/reset */
            if (queryParams.client_id && path !== '/auth/reset') {

                _RFCSession.Session.setValue(_RFCSession.SessionKeys.ThirdPartyLogin, true);
                this.$rootScope.State.isThirdPartyLogin = true;
            }

            // Always ask for login, clean cookies for testing purposes only
            // or the clients that need this feature
            // ( to be able to switch users in the Alexa app for tests enable this in the config)
            if (this.getClientConfig('removeCookie') === true) {

                this.Auth.removeLoginCookies();
            }

            // Save token and device id in session storage for launcher forgot flow
            var tokenPayload = this.JWT.getTokenPayload(queryParams.anon_token) || this.JWT.getTokenPayload(queryParams.access_token);

            if (tokenPayload && tokenPayload.anon === true && tokenPayload.cid === 'launcher' && tokenPayload.did) {

                localStorage.setItem('ConnectClientToken', queryParams.anon_token || queryParams.access_token);
                localStorage.setItem('ConnectClientDeviceID', JSON.stringify(tokenPayload.did));
            }
        }

        /**
         * @ngdoc function
         * @name services.Sso#exchangeToken
         * @methodOf services.exchangeToken
         * @function
         *
         * @description
         * This method is used to change the received token with a dashboard token
         *
         */

    }, {
        key: 'exchangeToken',
        value: function exchangeToken() {
            var _this = this;

            this.echangePromise = this.$q.defer();

            var queryParams = this.$location.search();

            // set the anon_token in cookies received as param to be used in the register flow
            if (queryParams.anon_token || queryParams.access_token) {

                var tokenPayload = {
                    data: {
                        access_token: queryParams.anon_token || queryParams.access_token
                    }
                };

                var tokenData = this.JWT.getTokenPayload(queryParams.anon_token) || this.JWT.getTokenPayload(queryParams.access_token);

                // if the token clientId is not dashboard exhange token
                if (tokenData.cid !== 'dashboard' && tokenData.scope !== 'passwords') {

                    // get a new token for dashboard
                    this.getClientToken('dashboard', tokenPayload.data.access_token, queryParams.response_type).then(function (response) {

                        var oauthResponse = response.data;
                        var dashboardTokenPayload = {
                            data: {
                                access_token: oauthResponse.access_token,
                                refresh_token: oauthResponse.refresh_token,
                                expires_in: oauthResponse.expires_in
                            }
                        };
                        _this.Auth.setLoginCookies(dashboardTokenPayload);
                        _this.redirectToAuth();
                    }).catch(function (exception) {

                        var errorLocation = 'Sso.saveExtraParams Error';

                        _this.ErrorHandler.handleError(exception, errorLocation);

                        _this.Auth.removeLoginCookies();
                        _this.redirectToAuth();
                    });
                } else {

                    this.Auth.setLoginCookies(tokenPayload);
                    this.redirectToAuth(tokenData.scope);
                }
            } else {

                this.redirectToAuth();
            }

            return this.echangePromise.promise;
        }

        /**
         * @ngdoc function
         * @name services.Sso#redirectToAuth
         * @methodOf services.redirectToAuth
         * @function
         *
         * @description
         * This method is used to clear any jwt token from params
         * and redirect to login or register controller
         *
         * @param
         * String - Describe token scope
         */

    }, {
        key: 'redirectToAuth',
        value: function redirectToAuth(tokenScope) {

            var queryParams = this.$location.search();
            // remove the anon_token param so that second time will go on with the redirect
            delete queryParams.anon_token;
            delete queryParams.access_token;
            _RFCSession.Session.setValue(_RFCSession.SessionKeys.SsoExtraUrlParams, queryParams);

            this.echangePromise.resolve(tokenScope);
        }

        /**
         * @ngdoc function
         * @name services.Sso#getAnonToken
         * @methodOf services.getAnonToken
         * @function
         *
         * @description
         * This method is used to get the anon token received as parameter
         *
         */

    }, {
        key: 'getAnonToken',
        value: function getAnonToken() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            if (queryParams.anon_token || queryParams.access_token) {

                return queryParams.anon_token || queryParams.access_token;
            }

            return false;
        }

        /**
         * @ngdoc function
         * @name services.Sso#showCloseButton
         * @methodOf services.showCloseButton
         * @function
         *
         * @description
         * This method is used to check if the close button need to be visible in the login or register
         *
         */

    }, {
        key: 'getCloseButton',
        value: function getCloseButton() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            if (queryParams.close_button) {

                return queryParams.close_button;
            }

            return false;
        }

        /**
         * @ngdoc function
         * @name services.Sso#getClientId
         * @methodOf services.getClientId
         * @function
         *
         * @description
         * This method is used to get the client_id received as param in url
         *
         */

    }, {
        key: 'getClientId',
        value: function getClientId() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            return queryParams.client_id || '';
        }

        /**
         * @ngdoc function
         * @name services.Sso#getClientConfig
         * @methodOf services.getClientConfig
         * @function
         *
         * @description
         * This method is used to check get the configs for the current client_id
         * If the feature param is set it will return the feature configuration
         *
         */

    }, {
        key: 'getClientConfig',
        value: function getClientConfig(feature) {

            var ssoClientConfig = CWCONFIG.ssoConfig[this.getClientId()];
            if (ssoClientConfig && feature) {

                return ssoClientConfig[feature];
            }

            return ssoClientConfig;
        }

        /**
         * @ngdoc function
         * @name services.Sso#showSkipButton
         * @methodOf services.showSkipButton
         * @function
         *
         * @description
         * This method is used to check if the skip button need to be visible in the login or register
         *
         */

    }, {
        key: 'getSkipUri',
        value: function getSkipUri() {

            var skipUri = this.getClientConfig('skip_uri');
            return skipUri || false;
        }

        /**
         * @ngdoc function
         * @name services.Sso#showChangeLang
         * @methodOf services.showChangeLang
         * @function
         *
         * @description
         * This method is used to check if the change language param
         *
         */

    }, {
        key: 'getChangeLang',
        value: function getChangeLang() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            if (queryParams.change_lang && queryParams.change_lang === 'false') {

                return false;
            }

            return true;
        }

        /**
         * @ngdoc function
         * @name services.Sso#getSocialLogin
         * @methodOf services.getSocialLogin
         * @function
         *
         * @description
         * This method is used to check social login param
         *
         */

    }, {
        key: 'getSocialLogin',
        value: function getSocialLogin() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            if (queryParams.social_login && queryParams.social_login === 'false') {

                return false;
            }

            return true;
        }

        /**
         * @ngdoc function
         * @name services.Sso#getEmbeddedSocialLogin
         * @methodOf services.getEmbeddedSocialLogin
         * @function
         *
         * @description
         * This method is used to check the embedded social login param
         *
         */

    }, {
        key: 'getEmbeddedSocialLogin',
        value: function getEmbeddedSocialLogin() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            return queryParams.embedded_social && queryParams.embedded_social === 'true';
        }

        /**
         * @ngdoc function
         * @name services.Sso#getEmailAddress
         * @methodOf services.getEmailAddress
         * @function
         *
         * @description
         * This method is used to check if the email_adreess param exists
         *
         */

    }, {
        key: 'getEmailAddress',
        value: function getEmailAddress() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            return queryParams.email_address || '';
        }

        /**
         * @ngdoc function
         * @name services.Sso#getDecodedEmailAddress
         * @methodOf services.getDecodedEmailAddress
         * @function
         *
         * @description
         * This method is used to check if the email param exists and decodes it
         *
         */

    }, {
        key: 'getDecodedEmailAddress',
        value: function getDecodedEmailAddress() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);

            var emailAddress = queryParams.email ? this.Util.base64decode(queryParams.email) : '';

            return emailAddress;
        }

        /**
         * @ngdoc function
         * @name services.Sso#isThirdPartyLogin
         * @methodOf services.isThirdPartyLogin
         * @function
         *
         * @description
         * This method is used to check if the login is a thirdParty login
         *
         */

    }, {
        key: 'isThirdPartyLogin',
        value: function isThirdPartyLogin() {

            return _RFCSession.Session.getValue(_RFCSession.SessionKeys.ThirdPartyLogin);
        }

        /**
         * @ngdoc function
         * @name services.Sso#redirect
         * @methodOf services.redirect
         * @function
         *
         * @description
         * This method is used to redirect to the received uri in the auth url
         *
         */

    }, {
        key: 'redirect',
        value: function redirect() {
            var _this2 = this;

            // thirdparty login
            if (this.isThirdPartyLogin()) {

                var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);
                var user = _index.MeRepository.getMyUser();
                var language = user.attributes.language;


                this.getClientToken(queryParams.client_id, null, queryParams.response_type).then(function (response) {

                    var oauthResponse = response.data;
                    // set # as parameter separator for Alexa
                    var separator = queryParams.client_id === 'alexa' ? '#' : '?';
                    var urlParams = '';

                    // Append received params and the oauth params to the redirect_uri
                    if (_this2.getClientConfig('appendUrlParams') === true) {

                        // append received params to the redirect_uri
                        angular.forEach(queryParams, function (value, key) {

                            // ignore redirect_uri and client_id these two won't be appended
                            if (key !== 'redirect_uri' && key !== 'client_id') {

                                urlParams += '' + (urlParams.indexOf(separator) === -1 ? separator : '&') + key + '=' + value;
                            }
                        });

                        // append to the redirect url the token,
                        // expiring time, refresh token and token type
                        angular.forEach(oauthResponse, function (value, key) {

                            // ignore redirect_uri this won't be appended
                            if (key !== 'redirect_uri') {

                                urlParams += '' + (urlParams.indexOf(separator) === -1 ? separator : '&') + key + '=' + value;
                            }
                        });
                    }

                    _RFC2.default.send('ConnectWeb Auth Login/Register/Forgot/Set Password Open', {
                        Source: 'Login ',
                        'Redirect Client': queryParams.client_id || 'None'
                    });

                    // Clean cookies for testing purposes only
                    // or the clients that need this feature
                    // ( to be able to switch users in the Alexa app
                    // for tests enable this in the config)
                    if (_this2.getClientConfig('removeCookie') === true) {

                        _this2.Auth.removeLoginCookies();
                    }

                    // disable sso redirect for spotlight using backend redirect_uri
                    if (queryParams.client_id === 'spotlight' && queryParams.embedded === 'false') {

                        _this2.$location.path('/dashboard/devices');
                        angular.element('body').removeClass('spotlight');

                        return;
                    }

                    // Match received redirect_uri with the client_id uri configured in backend
                    // Only for alexa and for backwards compatibility
                    // If we don't receive any redirect_uri we check the one sent by the backend
                    // otherwise we redirect user to dashboard
                    if (queryParams.redirect_uri && _this2.matchDomain(queryParams.redirect_uri, oauthResponse.redirect_uri)) {

                        _this2.setClientCookies(queryParams.client_id, oauthResponse);
                        var redirectUrl = queryParams.redirect_uri;
                        if (_this2.getClientConfig('appendUrlParams') === true) {

                            redirectUrl += urlParams;
                        }

                        // dashboard SSO
                        if (queryParams.client_id === 'dashboard') {

                            _this2.$window.location.href = '/' + language + redirectUrl;
                        } else {

                            _this2.$window.location.href = redirectUrl;
                        }
                    } else if (oauthResponse.redirect_uri && oauthResponse.redirect_uri !== '') {

                        _this2.setClientCookies(queryParams.client_id, oauthResponse);
                        var _redirectUrl = oauthResponse.redirect_uri;

                        if (_this2.getClientConfig('appendUrlParams') === true) {

                            _redirectUrl += urlParams;
                        }

                        // dashboard rules for links without "redirect_uri" params
                        if (queryParams.client_id === 'dashboard' && oauthResponse.redirect_uri.indexOf('dashboard') > -1) {

                            // auth reset password rule
                            if (_this2.$location.path().indexOf('/auth/reset') > -1) {

                                var getParams = _this2.Util.getParams(_this2.$location.url());
                                var resetToken = getParams ? getParams.anon_token || getParams.access_token : '';

                                _this2.$window.location.href = '/' + language + '/auth/reset/' + resetToken;
                            } else if (queryParams['x-a-medium']) {

                                _this2.$state.go('root.dashboard.home.ltb', {
                                    resourceId: queryParams['x-a-medium'],
                                    ltb: 'welcome-modal'
                                });
                            } else {

                                // general rule for rest of the links
                                _this2.$window.location.href = '/' + language + '/dashboard';
                            }
                        } else if (queryParams.client_id === 'unicorn' || queryParams.client_id === 'avira-macsupport') {

                            _this2.$state.go('root.dashboard.home');
                            _this2.$window.location.href = _redirectUrl;
                        } else {

                            _this2.$window.location.href = _redirectUrl;
                        }
                    } else {

                        // disable SSO for the next calls
                        _RFCSession.Session.setValue(_RFCSession.SessionKeys.ThirdPartyLogin, false);

                        // display the prime trial modal for social login
                        if (queryParams['x-a-medium']) {

                            _this2.$state.go('root.dashboard.home.ltb', {
                                resourceId: queryParams['x-a-medium'],
                                ltb: 'welcome-modal'
                            });
                        } else {

                            // redirect to dashboard if is not matched
                            _this2.$location.path('/dashboard');
                        }
                    }
                }).catch(function (exception) {

                    var errorLocation = 'Sso.redirect Error';

                    _this2.ErrorHandler.handleError(exception, errorLocation);

                    _this2.Auth.removeLoginCookies();

                    _this2.$location.path('/auth/login');
                });
            }
        }

        /**
         * @ngdoc function
         * @name services.Sso#setClientCookies
         * @methodOf services.setClientCookies
         * @function
         *
         * @description
         * This method is used to set client cookies
         *
         */

    }, {
        key: 'setClientCookies',
        value: function setClientCookies(clientId, data) {
            var _CWCONFIG$cookie = CWCONFIG.cookie,
                domain = _CWCONFIG$cookie.domain,
                rootDomain = _CWCONFIG$cookie.rootDomain,
                ssoToken = _CWCONFIG$cookie.ssoToken;

            // the expire time is received in seconds and we convert it to days

            var tokenExpireInDays = parseInt(data.expires_in, 10) / 60 / 60 / 24;

            // Cookies to store jwt token
            var ssoTokenCookie = '' + ssoToken + clientId + '_sso';
            _RFC4.default.set(ssoTokenCookie, data.access_token, {
                expires: Math.round(tokenExpireInDays) || 1,
                path: '/',
                domain: rootDomain || domain
            });
            // Cookies to store token expiration time
            var ssoTokenExpiresInCookie = '' + ssoToken + clientId + '_lifetime_sso';
            _RFC4.default.set(ssoTokenExpiresInCookie, data.expires_in, {
                expires: Math.round(tokenExpireInDays) || 1,
                path: '/',
                domain: rootDomain || domain
            });
            // Cookies to store refresh_token
            var ssoRefreshTokenCookie = '' + ssoToken + clientId + '_refresh_sso';
            _RFC4.default.set(ssoRefreshTokenCookie, data.refresh_token, {
                expires: Math.round(tokenExpireInDays) || 1,
                path: '/',
                domain: rootDomain || domain
            });
        }

        /**
         * @ngdoc function
         * @name services.Sso#enableAutoLogon
         * @methodOf services.enableAutoLogon
         * @function
         *
         * @description
         * This method is used to check if autologon using
         * the existing token is enabled or disabled for that clientId
         *
         */

    }, {
        key: 'enableAutoLogon',
        value: function enableAutoLogon() {

            if (this.getClientConfig('disableSsoAutoLogin') === true) {

                return false;
            }

            return true;
        }

        /**
         * @ngdoc function
         * @name services.Sso#getClientToken
         * @methodOf services.Sso
         *
         * @description
         * Get client token for thirdparty login using the dashboard token
         */

    }, {
        key: 'getClientToken',
        value: function getClientToken(clientId, token, responseType) {

            var oauthPayload = {
                grant_type: 'client_token',
                client_id: clientId,
                response_type: responseType
            };

            var oauthHeader = {
                'X-Avira-Token': this.Auth.getTfaCookie()
            };

            if (token) {

                oauthHeader.Authorization = 'Bearer ' + token;
            }

            return this.OAuthRestService.post(oauthPayload, oauthHeader);
        }

        /**
         * @ngdoc function
         * @name services.Sso#getParams
         * @methodOf services.Sso
         *
         * @description
         * Get received params
         */

    }, {
        key: 'getParams',
        value: function getParams() {

            var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);
            return queryParams;
        }

        /**
         * $ngdoc function
         * @name services.Sso#matchDomain
         * @methodOf services.Sso
         *
         * @description
         * Match urls domain
         */

    }, {
        key: 'matchDomain',
        value: function matchDomain(url, urlToBeMatched) {

            if (urlToBeMatched) {

                var decodedRedirectUri = String(decodeURIComponent(url));
                var regex = new RegExp(String(urlToBeMatched), 'gi');

                return regex.test(decodedRedirectUri);
            }

            return false;
        }
    }]);

    return Sso;
}();

_serviceDependencies.push(Sso);

angular.module('services').service('Sso', _serviceDependencies);

/***/ }),

/***/ "EyJ2":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "FEPM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @description
 * Controller for under maintenance
 */

angular.module('controllers').controller('underMaintenance', ['$window', '$scope', '$rootScope', function ($window, $scope, $rootScope) {

    $rootScope.State.loading = false;
}]);

/***/ }),

/***/ "FJvE":
/***/ (function(module, exports) {

module.exports = "<div>\n\t<div class=\"mya-section-info disable-account\">\n\t\t<div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.data_settings.disable_account_title\"></div>\n\t\t<div class=\"text-m mt5 text-grey-3\" translate=\"cw.my_account.data_settings.disable_account_desc\" translate-values=\"{brandname : brandName, linktext : linkText, href : href}\"></div>\n\t</div>\n</div>"

/***/ }),

/***/ "FMLl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Pqwy");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('BaseModal', ['$scope', '$rootScope', '$state', 'Util', '$location', function ($scope, $rootScope, $state, Util, $location) {

    $scope.close = function (newState) {

        var currentState = void 0;

        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw

        var licenses = _index.LicensesRepository.getAll();
        var activationCodes = _index.ActivationCodesRepository.getAll();

        var hasPrimeTrial = licenses.find(function (license) {
            return license.relationships.app.data.id === 'aps10' || license.relationships.app.data.id === 'aps20';
        });
        var hasPrimeLicense = activationCodes.find(function (activationCode) {
            return activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20';
        });

        if ($rootScope.showPrimeTrialModal && !hasPrimeLicense && !hasPrimeTrial) {

            var trialModalClosed = sessionStorage.getItem('trialModalClosed');
            if (($location.path().indexOf('payment-cart') > -1 || $location.path().indexOf('one-click-payment') > -1) && !trialModalClosed && $location.path().indexOf('adwp1') === -1) {

                $state.go($state.current.name, {
                    ltb: 'trial-modal'
                });

                return;
            }

            if ($location.path().indexOf('trial-modal') > -1 && !trialModalClosed) {

                sessionStorage.setItem('trialModalClosed', 'true');
            }
        }
        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw

        if (!newState) {

            currentState = $state.current.name;
            newState = currentState.substr(0, currentState.indexOf('.ltb')) || 'root.dashboard.home';
        }
        $state.go(newState);
    };
    // when deploy come from email
    // check if path location contains params 'subscription' and 'deploy'
    // then disable close modal on backdrop click
    var path = $location.path();
    if (path.indexOf('subscription') > -1 && path.indexOf('deploy') > -1) {

        $scope.disableCloseModal = true;
    }

    // Disable close modal on backdrop click for the payment cart
    if (path.indexOf('/ltb/payment-cart') > -1 || path.indexOf('trial-modal') > -1) {

        $scope.disableCloseModalPaymentCart = true;
    }

    // function to save input data for anon modals
    $scope.saveData = function () {};

    $scope.register = function (ev) {

        _RFC4.default.addEvent('#lightbox ' + Util.elementToStr(ev.target));
    };

    $scope.changeState = function (stateName, stateParams) {

        $state.go(stateName, stateParams);
    };

    $scope.sendMixpanel = function (msg) {

        _RFC2.default.send(msg);
    };

    // initialize modal with default behaviour;
    $scope.cdn = $rootScope.cdn;
    $scope.visibleLog = false;
    $scope.customDebug = CWCONFIG.features.customDebug;
    $scope.hideControls = $rootScope.State.hideDashboard ? $rootScope.State.hideDashboard : false;
    $scope.showCloseBtn = true;

    // adjust behaviour on demand based on certain event
    _RFC6.default.subscribe('modal.closeBtn:show', function () {

        $scope.showCloseBtn = true;
    });

    _RFC6.default.subscribe('modal.closeBtn:hide', function () {

        $scope.showCloseBtn = false;
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        if (fromParams.ltb === 'deploy') {

            $scope.disableCloseModal = true;
        }

        if (fromParams.ltb === 'payment-cart') {

            $scope.disableCloseModalPaymentCart = true;
        }
    });
}]);

/***/ }),

/***/ "Fa4y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("BrLi");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("c7s0");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _users = [];
var observableUsers = new Rx.BehaviorSubject(_users);

/**
 * @ngdoc service
 * @name repositories.UsersRepository
 *
 * @description
 * This class is used to save/add users objects.
 */
var UsersRepository = {

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#add
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to add a new user to repository.
     *
     * @param {object} user An user object.
     */
    add: function add(user) {

        var indexOfUser = _users.findIndex(function (_user) {
            return String(_user.id) === String(user.id);
        });

        if (indexOfUser === -1) {

            _users.push(user);
            observableUsers.onNext(_users);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#update
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to update a user from repository.
     *
     * @param {object} user a user object with new values.
     */
    update: function update(user) {

        var indexOfUser = this.getIndex(user.id);

        if (indexOfUser >= 0) {

            var flattenDiff = _RFC2.default.getFlattenDiff(_users[indexOfUser], user);
            _RFC4.default.processUpdate(flattenDiff);

            _users[indexOfUser] = user;
            observableUsers.onNext(_users);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#replace
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored users with provided data.
     *
     * @param {Array} data An array with new users.
     */
    replace: function replace(data) {

        _users = data;
        observableUsers.onNext(_users);
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getAll
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all users from repository.
     *
     * @returns {Array} users all users from repository
     */
    getAll: function getAll() {

        return _users;
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getById
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves user from repository by id.
     *
     * @param {integer} userId the id of user.
     *
     * @returns {object} user user with specified id from repository
     */
    getById: function getById(userId) {

        var user = void 0;
        var indexOfUser = this.getIndex(userId);

        if (indexOfUser >= 0) {

            user = _users[indexOfUser];
        }

        return user;
    },


    /**
    * @ngdoc function
    * @name repositories.UsersRepository#getByEmail
    * @methodOf repositories.UsersRepository
    * @function
    *
    * @description
    * This function can be used to retrieves user from repository by email.
    *
    * @param {string} email email of user.
    *
    * @returns {object} user user with specified email from repository
    */
    getByEmail: function getByEmail(email) {

        var user = _users.find(function (u) {
            return u.attributes.email === email;
        });
        return user;
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getIndex
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves index of user from repository by id.
     *
     * @param {integer} userId the id of user.
     *
     * @returns {integer} user index of user from repository
     */
    getIndex: function getIndex(userId) {

        return _users.findIndex(function (_user) {
            return String(_user.id) === String(userId);
        });
    },


    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getObservable
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for users repository.
     * @returns {Object} an observable object for users repository.
     */
    getObservable: function getObservable() {

        return observableUsers;
    }
};

exports.default = UsersRepository;

/***/ }),

/***/ "Ff1x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('listeners').service('ActivationCodesListener', function () {

    _RFC2.default.subscribe('socket:activation-codes', function (response) {

        if (response.verb === 'POST') {

            _index.ActivationCodesRepository.add(response.payload.data);
        }

        // This method was removed because we need to test all scenarios
        // if (response.verb === 'PUT') {

        //     ActivationCodesRepository.update(response.payload.data);

        // }
    });
});

/***/ }),

/***/ "Fg7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$stateParams', '$location', '$state', '$filter', 'DeviceRestService'];

var _$scope = void 0;
var _$state = void 0;
var _$filter = void 0;
var _DeviceRestService = void 0;
var _DevicesRepository = void 0;
/**
 * @ngdoc service
 * @name controllers.LockDevice
 *
 * @description
 * Lock Device
 */

var LockDevice = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $filter
     * @param  {any} $stateParams
     * @param  {any} $location
     * @param  {any} $state
     * @param  {any} DeviceRestService
     */
    function LockDevice($scope, $stateParams, $location, $state, $filter, DeviceRestService) {
        _classCallCheck(this, LockDevice);

        var deviceId = $stateParams.resourceId;

        if (!deviceId) {

            return $location.path('/dashboard/home');
        }

        _DeviceRestService = DeviceRestService;
        _DevicesRepository = _index.DevicesRepository;

        _$scope = $scope;
        _$filter = $filter;
        _$state = $state;
        _$scope.device = _index.DevicesRepository.getById(deviceId);
        _$scope.brandName = CWCONFIG.partnerConfig.name;

        // $scope assigned function
        _$scope.lockDevice = this.lockDevice;
    }

    _createClass(LockDevice, [{
        key: 'lockDevice',
        value: function lockDevice() {

            var parentState = _$state.current.parent;
            var page = '';

            if (parentState === 'dashboard.devices') {

                page = 'My Devices';
            } else if (parentState === 'dashboard.device-details') {

                page = 'Device Details';
            }

            _RFC4.default.send('ConnectWeb Lock Confirm Click', {
                Page: page
            });

            var devicePayload = {
                data: {
                    attributes: {
                        locked: true
                    },
                    type: 'devices',
                    id: _$scope.device.id
                }
            };

            _DeviceRestService.update(_$scope.device && _$scope.device.id, devicePayload).then(function (response) {

                // update device repository, close modal and alert success
                _DevicesRepository.update(response.data.data);
                _$scope.close();
                _RFC2.default.success({
                    message: 'cw.lock_device.success'
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device),
                        brandname: CWCONFIG.partnerConfig.name
                    }
                });
            }).then(null, function () {

                // close modal and alert error
                _$scope.close();
                _RFC2.default.error({
                    message: 'cw.lock_device.error'
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device)
                    }
                });
            });
        }
    }]);

    return LockDevice;
}();

_serviceDependencies.push(LockDevice);

angular.module('controllers').controller('LockDevice', _serviceDependencies);

/***/ }),

/***/ "Fh6p":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("E4A5"),
    keys = __webpack_require__("d+Uu");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "Fjo9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('MarketingCard', ['$scope', '$state', '$stateParams', '$window', '$location', 'Util', function ($scope, $state, $stateParams, $window, $location, Util) {

    var queryParams = $location.search();

    $scope.browserName = $window.browserName.toLowerCase();
    $scope.User = _index.MeRepository.getMyUser();
    $scope.screenshotSelected = false;
    $scope.tab = 'screenshots';
    $scope.appId = queryParams.appId || $stateParams.resourceId;
    $scope.bundleAppId = queryParams.bundle;
    $scope.app = _index.AppIntegrationsRepository.getById($scope.appId);
    $scope.deviceData = _index2.DevicesProcessor.getAll();
    $scope.isbundleInstalled = queryParams.installed;
    $scope.deviceId = $state.params.resourceId;

    // check if device has prime licence in order to show/not show buy button
    var licsenses = _index.LicensesRepository.getAll();
    $scope.hasPrime = licsenses.find(function (license) {

        var appId = license.relationships.app.data.id;
        return appId === 'aps10' || appId === 'aps20' || appId === 'aps30';
    });

    if ($state.current.name.indexOf('.device-details') > -1) {

        $scope.isDeviceDetailsPage = true;
    }

    /**
     * Checks if the app is compatible with the user devices and if it's already installed
     * Returns activate if can be deployed or install if there is no
     * @param {Object} app
     */
    var getButtonLabel = function getButtonLabel() {

        // Webapp
        var productUrl = Util.deepFind($scope.app, 'attributes.custom.manifest.product_url');

        if ($scope.bundleAppId) {

            return 'install_bundle';
        }

        if (productUrl) {

            return 'open';
        } else if ($scope.app.devices && $scope.app.devices.length > 0) {

            return 'install_other';
        }

        return 'install';
    };
    $scope.buttonLabel = getButtonLabel();

    $scope.close = function (newState) {

        var currentState = void 0;
        if (!newState) {

            currentState = $state.current.name;
            newState = currentState.substr(0, currentState.indexOf('.ltb'));
        }
        $state.go(newState);
    };

    if ($stateParams.modal) {

        $stateParams.modal.result.then(function () {}, function () {

            $scope.close();
        });
    }

    $scope.init = function () {

        // redirect to dashboard if the service is not active
        if (!$scope.app) {

            $scope.close();
            return;
        }

        _RFC2.default.send('ConnectWeb Marketing Card Open', {
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            Source: 'Direct'
        });

        $scope.features = $scope.app.attributes.resource.oeFeatures;
    };

    $scope.backScreen = function () {

        $scope.screenshotSelected = false;
    };

    $scope.loadPictures = function () {

        angular.element('.screenshots-cnt img').on('click', function () {

            $scope.screenshotSelected = true;
            if (!angular.element(this).hasClass('big-pic')) {

                angular.element('.big-pic').remove();
                angular.element('.screenshots-cnt img').removeClass('selected');
                angular.element(this).addClass('selected');
                angular.element('.screenshots-cnt').append('<img class="big-pic" src="' + this.src + '" />');
            }
        });
        angular.element('.screenshots-cnt img').on('mouseover', function () {

            if ($scope.screenshotSelected === true) {

                if (!angular.element(this).hasClass('big-pic')) {

                    angular.element('.big-pic').remove();
                    angular.element('.screenshots-cnt img').removeClass('selected');
                    angular.element(this).addClass('selected');
                    angular.element('.screenshots-cnt').append('<img class="big-pic" src="' + this.src + '" />');
                }
            }
        });
    };

    /**
    * Show deploy modal.
    *
    * @param {String} serviceId Service id
    */
    $scope.activateService = function (serviceId, installType) {

        var currentDeviceOS = window.deviceOs;

        // check whether we can deploy the product on the current device
        var matchingOS = _index2.DevicesProcessor.getDeployOSfor(serviceId, currentDeviceOS) || null;
        var hasMatchingOS = !!matchingOS;

        var stateName = $state.current.name;
        if (stateName.indexOf('.deploy') === -1) {

            stateName += '.deploy';
        }

        _RFC2.default.send('ConnectWeb Install Click', {
            Page: 'Marketing Card',
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            'Product ID': serviceId
        });

        // Fix for device details
        if (stateName.indexOf('.device-details') > -1 && installType === 'install_bundle') {

            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                os: matchingOS,
                autoInstall: hasMatchingOS,
                appId: serviceId
            }, {
                reload: false
            });

            return;
        }
        if (stateName.indexOf('.device-details') > -1 && installType === 'install') {

            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                appId: serviceId
            }, {
                reload: false
            });

            return;
        }

        // install on other device
        if (installType === 'other_device') {

            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                resourceId: serviceId,
                deployType: 'other'
            }, {
                reload: false
            });
        } else {

            // normal install
            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                resourceId: serviceId,
                os: matchingOS,
                autoInstall: hasMatchingOS
            }, {
                reload: false
            });
        }
    };

    /**
     * Open product link in new tab
     */
    $scope.openServiceLink = function (service) {

        _RFC2.default.send('ConnectWeb Open Click', {
            Page: 'Marketing Card',
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            'Product ID': service.id
        });

        $window.open(service.attributes.custom.manifest.product_url, '_blank');
    };

    $scope.onTabClick = function (tabName) {

        $scope.tab = tabName;

        _RFC2.default.send('ConnectWeb ' + tabName + ' Click', {
            Page: 'Marketing Card',
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName')
        });
    };

    /**
     * @param {String} extensionId The extension id for Opera
     * @param {String} appId The app integration id
     */
    $scope.installOperaExtension = function (extensionId, appId) {

        var operaObj = $window.opr || {};

        if (operaObj.addons) {

            operaObj.addons.installExtension(extensionId);
        } else {

            var extensionUrl = CWCONFIG.operaExtensions[appId];
            extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

            $window.open(extensionUrl, '_blank');
        }
    };

    /**
     * @param {Object} app The app integration object
     */
    $scope.sendMixpanelEvent = function (app) {

        _RFC2.default.send('ConnectWeb Install Click', {
            Page: 'Marketing Card',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });
    };

    /**
    * Open cart iframe
    *
    * @param {String} appId Service id
    */
    $scope.buy = function (appId) {

        _RFC2.default.send('ConnectWeb Buy Click', {
            Page: 'Marketing Card',
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName'),
            'Product ID': appId
        });
        if ($state.current.name.indexOf('.device-details') > -1) {

            $state.go('root.dashboard.device-details.ltb.buy', {
                ltb: 'payment-cart',
                appId: appId,
                subsource: 'card_buy',
                promotion: true
            }, {
                reload: false
            });
        } else {

            $state.go('root.dashboard.products.ltb.buy', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'card_buy',
                promotion: true
            }, {
                reload: false
            });
        }
    };

    $scope.init();
}]); /* eslint func-names: 0 */

/***/ }),

/***/ "FlpK":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "G/k0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.GdprActionsRestService
 *
 * @description
 * This class contains methods used for GDPR actions
*/

var GdprActionsRestService = function (_BaseRestService) {
    _inherits(GdprActionsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function GdprActionsRestService($http, $q, Util) {
        _classCallCheck(this, GdprActionsRestService);

        return _possibleConstructorReturn(this, (GdprActionsRestService.__proto__ || Object.getPrototypeOf(GdprActionsRestService)).call(this, $http, $q, Util));
    }

    /*
    * @name rest.services.GdprActionsRestService#getAllAsync
    * @methodOf rest.services.GdprActionsRestService
    * @function
    *
    * @description
    * Makes a get request to the gdpr-actions endpoint to get all actions
    *
    * @param {object} payload gdpr payload
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(GdprActionsRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(GdprActionsRestService.prototype.__proto__ || Object.getPrototypeOf(GdprActionsRestService.prototype), 'getAllAsync', this).call(this, 'gdpr-actions/');
        }

        /**
         * @ngdoc function
          /**
          * @ngdoc function
          * @name rest.services.GdprActionsRestService#deploy
          * @methodOf rest.services.GdprActionsRestService
          * @function
          *
          * @description
          * Makes the call to the gdpr-actions endpoint delete account or get report
          *
          * @param {object} payload gdpr payload
          *
          * @returns {Promise} The promise of the call.
          */

    }, {
        key: 'create',
        value: function create(payload) {

            return _get(GdprActionsRestService.prototype.__proto__ || Object.getPrototypeOf(GdprActionsRestService.prototype), 'create', this).call(this, payload, 'gdpr-actions/');
        }
    }]);

    return GdprActionsRestService;
}(_baseRestService2.default);

exports.default = GdprActionsRestService;


_serviceDependencies.push(GdprActionsRestService);

angular.module('rest.services').service('GdprActionsRestService', _serviceDependencies);

/***/ }),

/***/ "G5bk":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("8f6X");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("E4vQ")(module)))

/***/ }),

/***/ "G8aX":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("1zte");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "GARZ":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var time_estimates;

time_estimates = {
  estimate_attack_times: function(guesses) {
    var crack_times_display, crack_times_seconds, scenario, seconds;
    crack_times_seconds = {
      online_throttling_100_per_hour: guesses / (100 / 3600),
      online_no_throttling_10_per_second: guesses / 10,
      offline_slow_hashing_1e4_per_second: guesses / 1e4,
      offline_fast_hashing_1e10_per_second: guesses / 1e10
    };
    crack_times_display = {};
    for (scenario in crack_times_seconds) {
      seconds = crack_times_seconds[scenario];
      crack_times_display[scenario] = this.display_time(seconds);
    }
    return {
      crack_times_seconds: crack_times_seconds,
      crack_times_display: crack_times_display,
      score: this.guesses_to_score(guesses)
    };
  },
  guesses_to_score: function(guesses) {
    var DELTA;
    DELTA = 5;
    if (guesses < 1e3 + DELTA) {
      return 0;
    } else if (guesses < 1e6 + DELTA) {
      return 1;
    } else if (guesses < 1e8 + DELTA) {
      return 2;
    } else if (guesses < 1e10 + DELTA) {
      return 3;
    } else {
      return 4;
    }
  },
  display_time: function(seconds) {
    var base, century, day, display_num, display_str, hour, minute, month, ref, year;
    minute = 60;
    hour = minute * 60;
    day = hour * 24;
    month = day * 31;
    year = month * 12;
    century = year * 100;
    ref = seconds < 1 ? [null, 'less than a second'] : seconds < minute ? (base = Math.round(seconds), [base, base + " second"]) : seconds < hour ? (base = Math.round(seconds / minute), [base, base + " minute"]) : seconds < day ? (base = Math.round(seconds / hour), [base, base + " hour"]) : seconds < month ? (base = Math.round(seconds / day), [base, base + " day"]) : seconds < year ? (base = Math.round(seconds / month), [base, base + " month"]) : seconds < century ? (base = Math.round(seconds / year), [base, base + " year"]) : [null, 'centuries'], display_num = ref[0], display_str = ref[1];
    if ((display_num != null) && display_num !== 1) {
      display_str += 's';
    }
    return display_str;
  }
};

module.exports = time_estimates;

//# sourceMappingURL=time_estimates.js.map


/***/ }),

/***/ "GBDS":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "GLmR":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("8wya");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "Gdal":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("atk5"),
    overRest = __webpack_require__("ORg+"),
    setToString = __webpack_require__("1GA3");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "GozI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _dwmData = {
    alertsDetails: {},
    statusApi: {}
};

var observableCryptoData = new Rx.BehaviorSubject(_dwmData);

var dwmRepository = {
    getAll: function getAll(key) {

        return key ? _dwmData[key] : _dwmData;
    },
    replace: function replace(key, data) {

        if (key) {

            _dwmData[key] = data;
        }

        if (data.primaryMember) {

            if (Object.keys(data.primaryMember.primaryAddress).length > 0) {

                var addresses = data.primaryMember.monitoredAccounts.addresses.entries;
                var primaryAddresses = data.primaryMember.primaryAddress;

                var hasPrimaryAddress = addresses.find(function (address) {
                    return address.street1 === primaryAddresses.street1 && address.city === primaryAddresses.city && address.postalCode === primaryAddresses.postalCode;
                });

                if (!hasPrimaryAddress) {

                    data.primaryMember.monitoredAccounts.addresses.entries.unshift(data.primaryMember.primaryAddress);
                }
            }

            if (Object.keys(data.primaryMember.primaryPhone).length > 0) {

                var numbers = data.primaryMember.monitoredAccounts.phoneNumbers.entries;
                var primaryNumber = data.primaryMember.primaryPhone;

                var hasPrimaryPhone = numbers.find(function (number) {
                    return number.phoneNumber === primaryNumber.phoneNumber;
                });

                if (!hasPrimaryPhone) {

                    data.primaryMember.monitoredAccounts.phoneNumbers.entries.unshift(data.primaryMember.primaryPhone);
                }
            }

            this.updateCardStatus(data.primaryMember);
        }

        observableCryptoData.onNext(_dwmData);
    },
    updateAlertsDetails: function updateAlertsDetails(key, value) {

        if (key) {

            _dwmData.alertsDetails[key] = value;
        }

        observableCryptoData.onNext(_dwmData);
    },
    updateCardStatus: function updateCardStatus(data) {

        var monitoredAssets = Object.keys(data.monitoredAccounts).filter(function (asset) {
            return data.monitoredAccounts[asset].entries.length > 0;
        });

        if (monitoredAssets.length === 0) {

            data.dwmCardStatus = 'add-more-data';
        }
    },
    getObservable: function getObservable() {

        return observableCryptoData;
    }
};

exports.default = dwmRepository;

/***/ }),

/***/ "H/dH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint max-len: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', 'DeployRestService', 'Util', '$scope'];

var DeviceCardController = function () {
    function DeviceCardController($state, DeployRestService, Util, $scope) {
        var _this = this;

        _classCallCheck(this, DeviceCardController);

        this.$state = $state;
        this.$scope = $scope;
        this.DeployRestService = DeployRestService;
        this.MeRepository = _index.MeRepository;
        this.UsersRepository = _index.UsersRepository;
        this.LicensesRepository = _index.LicensesRepository;
        this.ActivationCodesRepository = _index.ActivationCodesRepository;
        this.AppIntegrationsRepository = _index.AppIntegrationsRepository;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.product = _index.AppIntegrationsRepository.getAppName('fass0');

        this.Util = Util;
        this.myId = _index.MeRepository.getMyId();
        this.devicesView = localStorage.getItem('DevicesView');

        // direct binding for licenses
        var licensesObservable = _index.LicensesRepository.getObservable();
        var licensesSubscriber = licensesObservable.subscribe(function (data) {
            return _this.onNextLicense(data);
        }, function () {}, function () {});

        $scope.$on('$destroy', function () {

            licensesSubscriber.dispose();
        });

        var activationCodes = this.ActivationCodesRepository.getAll();
        var hasAia = activationCodes.find(function (activationCode) {
            return activationCode.attributes.app === 'adwp1';
        });
        this.$scope.hasOnlyAiaLicense = !!(activationCodes.length === 1 && hasAia);
    }

    _createClass(DeviceCardController, [{
        key: 'detectIfDeviceHasLicenses',
        value: function detectIfDeviceHasLicenses() {

            var activationCodesRepo = this.ActivationCodesRepository.getAll();
            var licensesRepo = this.LicensesRepository.getAll();
            this.$scope.userHasSubscriptions = activationCodesRepo.length > 0 || licensesRepo.length > 0;
        }
    }, {
        key: 'onNextLicense',
        value: function onNextLicense() {

            this.detectIfDeviceHasLicenses();
        }
    }, {
        key: 'deployOn',
        value: function deployOn(os) {

            _RFC4.default.send('ConnectWeb Add New Device Click', { Page: 'My Devices', 'Device Os': os });
            this.$state.go('root.dashboard.devices.ltb.deploy', {
                ltb: 'deploy',
                resourceId: 'new',
                os: os
            }, {
                reload: false
            });
        }
    }, {
        key: 'deployOnCategory',
        value: function deployOnCategory(category) {

            this.$state.go('root.dashboard.devices.ltb.deploy', {
                ltb: 'deploy',
                resourceId: 'new',
                deviceCategory: category
            }, {
                reload: false
            });
        }
    }, {
        key: 'resendDevice',
        value: function resendDevice(device) {
            var _this2 = this;

            this.DeployRestService.deployOnDevice({
                appId: CWCONFIG.defaultDeployedAppId[device.attributes.os],
                userId: device.relationships.user.data.id,
                deviceId: device.id,
                meta: {
                    resend: true,
                    force_send_email: true
                }
            }).then(function () {

                _RFC2.default.success({
                    message: 'cw.device.resend.success',
                    icon: {
                        cssClasses: 'icon-' + _this2.Util.deepFind(device, 'attributes.type')
                    }
                });
            }).then(null, function (error) {

                var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                switch (errorCode) {

                    case '1208':
                        // maximum number of SMS exceeded

                        _RFC2.default.error({
                            message: 'cw.device.resend.sms_error',
                            icon: {
                                cssClasses: 'icon-' + _this2.Util.deepFind(device, 'attributes.type')
                            }
                        });

                        break;

                    default:

                        _RFC2.default.error({
                            message: 'cw.device.resend.error',
                            icon: {
                                cssClasses: 'icon-' + _this2.Util.deepFind(device, 'attributes.type')
                            }
                        });

                }
            });
        }

        /**
         * @ngdoc function
         * @name controllers.DeviceCardController#getUserName
         * @methodOf controllers.DeviceCardController
         * @function
         *
         * @description
         * Return the name of the user who owns the device.
         *
         * @param {object} device A device object.
         */

    }, {
        key: 'getUserName',
        value: function getUserName(device) {

            var user = this.UsersRepository.getById(this.Util.deepFind(device, 'relationships.user.data.id'));

            var firstName = this.Util.deepFind(user, 'attributes.first_name');
            var lastName = this.Util.deepFind(user, 'attributes.last_name');

            return (firstName || '') + ' ' + (lastName || '');
        }
    }, {
        key: 'sendMixpanelEvent',
        value: function sendMixpanelEvent(event, eventDetails) {

            if (event === 'tooltip') {

                _RFC4.default.send('ConnectWeb Device Tooltip Click', {
                    Tooltip: eventDetails
                });
            } else if (event === 'add_device') {

                _RFC4.default.send('ConnectWeb Device Add Device List View Click');
            } else if (event === 'device_details') {

                _RFC4.default.send('ConnectWeb Device Details Click');
            }
        }
    }, {
        key: 'viewDetailsFromListView',
        value: function viewDetailsFromListView(deviceId) {

            if (this.devicesView === 'list') {

                this.$state.go('root.dashboard.device-details', {
                    resourceId: deviceId,
                    tab: 'apps'
                });
            }
        }
    }]);

    return DeviceCardController;
}();

var DeviceCardDirective = function DeviceCardDirective() {
    _classCallCheck(this, DeviceCardDirective);

    this.template = __webpack_require__("vL8v");
    this.restrict = 'EA';
    this.replace = true;
    this.scope = { source: '=', category: '=' };

    _controllerDependencies.push(function ($state, DeployRestService, Util, $scope) {
        return new DeviceCardController($state, DeployRestService, Util, $scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'deviceCardCtrl';
};

_directiveDependencies.push(function () {
    return new DeviceCardDirective();
});

angular.module('directives').directive('deviceCard', _directiveDependencies);

/***/ }),

/***/ "H6q6":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div id=\"lightbox\" class=\"central-position no-background\">\n        <div class=\"table-display\">\n            <div class=\"table-cell-display\">\n                <div class=\"lightbox-content\">\n\n                    <!-- content for session expired -->\n                    <div ng-if=\"modalParams === 'session-expired'\">\n                        <div class=\"error-img error-expire\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.dashboard.session_expired.title\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb10\" translate=\"cw.dashboard.session_expired.reload_text\"></h2>\n                        <h2 class=\"text-l text-grey-5 mb30\"><span translate=\"cw.general.ui.error\"></span>: {{errorCode}} - {{modalParamsObj.data.error}}</h2>\n                    </div>\n\n                    <!-- content for offline -->\n                    <div ng-if=\"modalParams === 'offline'\">\n                        <div class=\"error-img error-expire\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.general.oouch\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb30\" translate=\"cw.modal.offline_text\"></h2>\n                    </div>\n\n                    <!-- content for unauthorised -->\n                    <div ng-if=\"modalParams === 'unauthorised'\">\n                        <div class=\"error-img error-unauthorised\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.modal.unauthorised.title\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb10\" translate=\"cw.modal.unauthorised.desc\"></h2>\n                        <h2 class=\"text-l text-grey-5 mb30\"><span translate=\"cw.general.ui.error\"></span>: {{errorCode}} - {{modalParamsObj.data.error}}</h2>\n                    </div>\n\n                    <!-- content for bad request -->\n                    <div ng-if=\"modalParams === 'bad-request'\">\n                        <div class=\"error-img error-bad-request\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.modal.bad-request.title\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb10\" translate=\"cw.modal.bad-request.desc\"></h2>\n                        <h2 class=\"text-l text-grey-5 mb30\"><span translate=\"cw.general.ui.error\"></span>: {{errorCode}} - {{modalParamsObj.data.error}}</h2>\n                    </div>\n\n                    <!-- content for server error -->\n                    <div ng-if=\"modalParams === 'server-error'\">\n                        <div class=\"error-img error-server\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.modal.server-error.title\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb10\" translate=\"cw.modal.server-error.desc\"></h2>\n                        <h2 class=\"text-l text-grey-5 mb30\"><span translate=\"cw.general.ui.error\"></span>: {{errorCode}} - {{modalParamsObj.data.error}}</h2>\n                    </div>\n\n                    <!-- content for client error -->\n                    <div ng-if=\"modalParams === 'client-error'\">\n                        <div class=\"error-img error-server\"></div>\n                        <h1 class=\"text-xxxl mb10\" translate=\"cw.notification.system.error\"></h1>\n                        <h2 class=\"text-xl text-grey-4 mb30\"><span translate=\"cw.general.ui.error\"></span>: {{errorCode}} - {{modalParamsObj.data.error}}</h2>\n                    </div>\n\n                    <button class=\"btn btn-large btn-primary\" ng-click=\"refreshPage()\" ng-disabled=\"waitingResponse\" translate=\"cw.general.reload_page\"></button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "H7I6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint array-callback-return: 0 */
/* eslint no-unneeded-ternary: 0 */
/* eslint max-len: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var currentDeviceOS = window.deviceOs;

var _licenseRestService = void 0;
var _activationCodeRestService = void 0;
var _activationCodesRepository = void 0;
var _RecommendationsRestService = void 0;
var _devicesProcessor = void 0;
var _licensesRepository = void 0;
var _flexiblePromotionsRepository = void 0;
var _util = void 0;
var _$scope = void 0;
var _$state = void 0;
var _$translate = void 0;
var _$window = void 0;
var _$timeout = void 0;
var _activationCodesProcessor = void 0;
var _expiredLicensesProcessor = void 0;
var _expiringActivationCodes = void 0;
var _expiringLicenses = void 0;
var _transactionRestService = void 0;
var _$rootScope = void 0;
var _UsersRepository = void 0;
var _sessionAddPaymentTooltips = {};
var _paymentTypes = void 0;

var _serviceDependencies = ['$scope', '$state', '$window', '$timeout', '$location', '$anchorScroll', '$rootScope', '$translate', 'ActivationCodeRestService', 'Util', 'LicenseRestService', 'RecommendationsRestService', 'TransactionRestService'];

/**
 * @ngdoc service
 * @name controllers.Subscriptions
 *
 * @description
 * Subscriptions controller
 */

var Subscriptions = function () {
    function Subscriptions($scope, $state, $window, $timeout, $location, $anchorScroll, $rootScope, $translate, ActivationCodeRestService, Util, LicenseRestService, RecommendationsRestService, TransactionRestService) {
        var _this = this;

        _classCallCheck(this, Subscriptions);

        _licenseRestService = LicenseRestService;
        _activationCodesRepository = _index.ActivationCodesRepository;
        _activationCodeRestService = ActivationCodeRestService;
        _RecommendationsRestService = RecommendationsRestService;
        _licensesRepository = _index.LicensesRepository;
        _devicesProcessor = _index2.DevicesProcessor;
        _activationCodesProcessor = _index2.ActivationCodesProcessor;
        _transactionRestService = TransactionRestService;
        _UsersRepository = _index.UsersRepository;
        _flexiblePromotionsRepository = _index.FlexiblePromotionsRepository;
        _expiredLicensesProcessor = _index2.ExpiredLicensesProcessor;
        _paymentTypes = _index.PaymentTypesRepository.getAll();

        _util = Util;

        _$scope = $scope;
        _$rootScope = $rootScope;
        _$translate = $translate;
        _$state = $state;

        _$window = $window;
        _$timeout = $timeout;

        _$scope.appIntegrations = {};

        _$scope.activationStatus = '';
        _$scope.licenses = {};
        _$scope.finalStepActivationWizard = false;
        _$scope.isStaticOTC = false;
        _$scope.inputActivationCode = '';
        _$scope.loadingButton = false;
        _$scope.bannerButtonLoading = false;
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        _$scope.primeAppIds = CWCONFIG.primeAppIds || [];

        _$scope.paymentTypes = _index.PaymentTypesRepository.getAll();

        $scope.onTabClick = function (tabName) {

            _RFC4.default.send('ConnectWeb ' + tabName + ' Tab Click');
        };

        if (_$rootScope.scrollToExpiredSubscriptions) {

            $location.hash('expired-subscriptions-anchor');
            $anchorScroll();
        }

        var currentLanguage = CWCONFIG.language;
        var configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        var redirectSupportLanguage = '';

        if (configSupportLanguages.find(function (lang) {
            return lang === currentLanguage;
        })) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';
            } else {

                redirectSupportLanguage = currentLanguage;
            }
        } else {

            redirectSupportLanguage = 'en-us';
        }

        _$scope.cancellationPolicy = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        _$scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
        _$scope.mobileAppInfoLink = CWCONFIG.cma.subscriptions.mobileAppInfoLink.replace(/\[language\]/gi, redirectSupportLanguage);

        // AV Pro campaign - save campaign query params to localstorage
        var extraUrlParams = JSON.parse(sessionStorage.getItem('SsoExtraUrlParams'));

        if (extraUrlParams && extraUrlParams.campaign) {

            localStorage.setItem('offerAutoSubscription', extraUrlParams.campaign);
        }

        // Check if agent id (aid) exists and has a numeric value on session storage
        if (sessionStorage.getItem('aid') && !Number.isNaN(parseInt(sessionStorage.getItem('aid'), 0))) {

            // Show the otc tab for support agents only
            _$scope.showOTCTab = true;
        }

        // session storage obj
        _sessionAddPaymentTooltips = JSON.parse(sessionStorage.getItem('staticOTCs')) || {};

        // This object is used to display the discount tooltip
        _$rootScope.promotionsTooltips = {};

        // Hide the prepaid subscription toggle for US and CA users
        // TBD in the future
        var users = _UsersRepository.getAll();
        var userCountry = _util.deepFind(users[0], 'attributes.country');
        _$scope.checkUserCountryForPrepaid = function (activatioCode) {

            if (activatioCode.attributes.subscription_type !== 'prepaid') {

                return true;
            }

            return userCountry !== 'US' && userCountry !== 'CA';
        };

        _$scope.AppIntegrationsRepository = _index.AppIntegrationsRepository;

        // Filter all the transactions that have the price 0
        _$scope.transactions = _index.TransactionsRepository.getAll().filter(function (transaction) {

            if (transaction.attributes.price) {

                var formatPrice = transaction.attributes.price.replace(',', '');

                return Number(formatPrice) > 0;
            }

            return false;
        });

        // Format each transaction date
        _$scope.transactions.forEach(function (transaction) {

            var dateCreate = _util.deepFind(transaction, 'attributes.date_create');
            transaction.attributes.formatted_date_create = moment(dateCreate).format('L');
        });

        _$scope.refreshRequests = 0;
        _$scope.deviceOs = Util.getDeviceNavigator();
        _$scope.isBusinessProduct = this.isBusinessProduct;
        _$scope.getDateDifference = this.getDateDifference;
        _$scope.isMobilePurchase = this.isMobilePurchase;
        _$scope.isVoucherPurchase = this.isVoucherPurchase;
        _$scope.isUsComplied = this.isUsComplied;
        _$scope.successAnimation = false;
        _$scope.currentTab = _$state.params.tab || 'plans';

        _RFC4.default.send('ConnectWeb Subscriptions Open', {
            Source: 'Direct',
            Tab: _$scope.currentTab,
            Section: _$rootScope.activeNavSection === 'renewal' ? 'Renewal Settings' : 'Subscriptions'
        });

        this.activationCodeLength = 29;
        this.currentDateInMiliseconds = new Date().getTime();

        _$scope.isPrimeOfferActive = Util.deepFind(CWCONFIG, 'features.offerBanner.showOffer');

        this.subjectActivationCodes = _activationCodesProcessor.getObservable();
        this.activationCodesSubscriber = this.subjectActivationCodes.subscribe(function (data) {
            return _this.onActivationCodesNext(data);
        }, function () {}, function () {});

        this.activationCodesSubscriber = this.subjectActivationCodes.subscribe(function (data) {
            return _this.onFlexiblePromotionsNext(data);
        }, function () {}, function () {});

        this.licensesRepository = _licensesRepository.getObservable();
        this.licensesSubscriber = this.licensesRepository.subscribe(function (data) {
            return _this.onLicensesNext(data);
        }, function () {}, function () {});

        this.subjectFlexiblePromotions = _flexiblePromotionsRepository.getObservable();
        this.flexiblePromotionsSubscriber = this.subjectFlexiblePromotions.subscribe(function (data) {
            return _this.onFlexiblePromotionsNext(data);
        }, function () {}, function () {});

        this.expiredLicensesProcessor = _expiredLicensesProcessor.getObservable();
        this.expiredLicensesSubscriber = this.expiredLicensesProcessor.subscribe(function (data) {
            return _this.onExpiredLicensesNext(data);
        }, function () {}, function () {});

        $rootScope.showCmaDisclaimer.withdrawalConsent = !!$rootScope.euWithdrawalConsentEligible && _$scope.currentTab === 'plans';

        _$scope.$on('$destroy', function () {

            _this.activationCodesSubscriber.dispose();
            _this.licensesSubscriber.dispose();
            _this.expiredLicensesSubscriber.dispose();
            $rootScope.activeNavSection = '';
            $rootScope.scrollToExpiredSubscriptions = false;
            $rootScope.showCmaDisclaimer.withdrawalConsent = false;
        });

        // open subscription history tab if is detected in $rootScope.urlHash
        if ($rootScope.urlHash === 'history') {

            $rootScope.urlHash = '';

            _$state.go('root.dashboard.subscriptions', {
                tab: 'history'
            });
        }

        // redirect to "plans" tab if there are no transactions on history page
        if (_$scope.currentTab === 'history' && _$scope.transactions.length === 0) {

            _$state.go('root.dashboard.subscriptions', {
                tab: 'plans'
            });
        }

        if (_$scope.finalStepActivationWizard === true || _$scope.activationCodes.length !== 0 || _$scope.userTrialLicenses.length !== 0 || !_$rootScope.hasUsCompliance) {

            _$rootScope.showCmaDisclaimer.banner = false;
        }

        if (_$scope.firstexpiringLicense && !_$scope.firstexpiringLicense.attributes.customInfo.isNonrenewableApp && !_$scope.firstexpiringLicense.attributes.has_partner_id && !_$scope.userHaveActivePrime && !_$scope.firstexpiringLicense.attributes.customInfo.hideTrialExpiringNotification && !_$scope.firstexpiringLicense.isCardDeleted && _$rootScope.hasUsCompliance) {

            if (_$scope.firstexpiringLicense.isStaticOTC === false && _$scope.firstexpiringLicense.attributes.type !== 'eval') {

                _$rootScope.showCmaDisclaimer.banner = false;
            } else {

                _$rootScope.showCmaDisclaimer.banner = true;
            }
        }
    }

    /**
     * Replace all licenses with received data
     * @param {Array} data
     */


    _createClass(Subscriptions, [{
        key: 'onLicensesNext',
        value: function onLicensesNext(data) {
            var _this2 = this;

            _expiringLicenses = [];

            _$scope.userTrialLicenses = data.filter(function (license) {
                return _util.deepFind(license, 'attributes.type') === 'eval';
            });

            // hide trial expiring notification for other licenses if we have an prime in trials list
            var primeTrials = _$scope.userTrialLicenses.filter(function (license) {
                return _$scope.primeAppIds.indexOf(license.relationships.app.data.id) > -1;
            });
            var hasPrimeTrial = primeTrials.length > 0;

            _$scope.userTrialLicenses.forEach(function (license) {

                var appId = _util.deepFind(license, 'relationships.app.data.id');

                var expirationDate = _util.deepFind(license, 'attributes.date_expire');
                var dateExpiring = _util.deepFind(license, 'attributes.expiration_date');
                license.attributes.customInfo = {};
                license.attributes.customInfo.hideTrialExpiringNotification = hasPrimeTrial && _$scope.primeAppIds.indexOf(appId) === -1;
                var expireNotificationDays = _this2.getExpireNotificationDays(license);

                license.attributes.customInfo.formatted_expiration_date = moment(dateExpiring).format('L');

                if (appId && !_$scope.appIntegrations[appId]) {

                    _$scope.appIntegrations[appId] = _index.AppIntegrationsRepository.getById(appId) || {};
                    _$scope.appIntegrations[appId].appComponents = [];

                    var includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                    var hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                    if (includedApps.data) {

                        includedApps.data.forEach(function (app) {

                            if (!hiddenAppInBundleIds.find(function (id) {
                                return app.id === id;
                            }) && _index.AppIntegrationsRepository.getById(app.id) !== undefined) {

                                _$scope.appIntegrations[appId].appComponents.push(_index.AppIntegrationsRepository.getById(app.id));
                            }
                        });
                    }
                }

                // add the remaining days until subscription expires in activation code object - custom info
                if (expirationDate) {

                    var remainingDaysUntilExpiration = _this2.getDateDifference(expirationDate);

                    license.attributes.customInfo.remainingDaysUntilExpiration = remainingDaysUntilExpiration;
                    license.attributes.customInfo.showExpirationNotification = false;

                    if (remainingDaysUntilExpiration <= expireNotificationDays && license.attributes.subscription === 0 && license.attributes.app.indexOf('aib0') === -1) {

                        license.attributes.customInfo.showExpirationNotification = true;
                    } else {

                        license.attributes.customInfo.showExpirationNotification = false;
                    }
                }

                if (dateExpiring) {

                    var _remainingDaysUntilExpiration = _this2.getDateDifference(dateExpiring);

                    license.attributes.customInfo.remainingDaysUntilExpiration = _remainingDaysUntilExpiration;
                    license.attributes.customInfo.showExpirationNotification = false;

                    if (_remainingDaysUntilExpiration <= expireNotificationDays) {

                        license.attributes.customInfo.showExpirationNotification = true;

                        var found = _expiringLicenses.find(function (element) {
                            return element.id === license.id;
                        });

                        if (!found) {

                            _expiringLicenses.push(license);
                        }
                    } else {

                        license.attributes.customInfo.showExpirationNotification = false;
                    }
                }

                _this2.returnFirstExpirationDate();
                license.attributes.customInfo.devices = _devicesProcessor.getDevicesByLicenseId(license.id);
            });
        }

        /**
         * Replace all events with received data
         * @param {Array} data
         */

    }, {
        key: 'onActivationCodesNext',
        value: function onActivationCodesNext(data) {
            var _this3 = this;

            _$scope.activationCodes = data;
            // dont show expiring banner for other subscriptions. (show banner only if auto-renewal for Prime is OFF)
            _$scope.userHaveActivePrime = _index.ActivationCodesRepository.hasActivePrime();

            // Hide the ocp banner if the user already has prime
            // const hasPrime = _$scope.activationCodes
            //    .find(activationCode => (activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20'));
            // $scope.hideRecommendationBanner = !!(hasPrime);

            _expiringActivationCodes = [];
            var allTransactions = _index.TransactionsRepository.getAll();

            _$scope.activationCodes.forEach(function (activationCode) {

                var appId = _util.deepFind(activationCode, 'relationships.app.data.id');
                var expirationDate = _util.deepFind(activationCode, 'attributes.date_expire');
                var nextBillingEvent = _util.deepFind(activationCode, 'attributes.next_billing_event');
                var subscriptionType = _util.deepFind(activationCode, 'attributes.subscription_type');
                activationCode.attributes.customInfo = {};
                var isNonrenewableApp = _util.isNonrenewableApp(appId);

                if (subscriptionType === 'yearly' || subscriptionType === 'annual' || subscriptionType === 'annual-trial') {

                    activationCode.attributes.customInfo.showAnnual = true;
                } else if (subscriptionType === 'monthly' || subscriptionType === 'monthly-trial') {

                    activationCode.attributes.customInfo.showMonthly = true;
                }

                if (isNonrenewableApp) {

                    activationCode.attributes.customInfo.isNonrenewableApp = true;
                }

                if (!nextBillingEvent) {

                    switch (subscriptionType) {

                        case 'yearly':
                            nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                            break;
                        case 'monthly':
                            nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                            break;
                        case 'annual':
                            nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                            break;
                        case 'monthly-trial':
                            nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                            break;
                        case 'annual-trial':
                            nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                            break;
                        default:
                            nextBillingEvent = expirationDate;

                    }
                }

                // get purchase date
                var activationCodePurchaseDate = allTransactions.find(function (transaction) {
                    return transaction.attributes.activation_code === activationCode.id;
                });
                var paymentGateway = _util.deepFind(activationCodePurchaseDate, 'attributes.payment_gateway');

                if (subscriptionType === 'annual' && (paymentGateway === 'CB' || paymentGateway === 'CA')) {

                    var nextBillingEventTimeStamp = new Date(expirationDate).getTime();

                    var startDate1 = new Date('2022-04-03').getTime();
                    var endDate1 = new Date('2022-04-10').getTime();

                    var startDate2 = new Date('2022-04-11').getTime();
                    var endDate2 = new Date('2022-04-18').getTime();

                    var startDate3 = new Date('2022-04-19').getTime();
                    var endDate3 = new Date('2022-04-26T00:00:00Z').getTime();

                    var startDate4 = new Date('2022-04-27').getTime();
                    var endDate4 = new Date('2022-05-02').getTime();

                    if (nextBillingEventTimeStamp >= startDate1 && nextBillingEventTimeStamp <= endDate1) {

                        activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-21')).format('L');
                    } else if (nextBillingEventTimeStamp >= startDate2 && nextBillingEventTimeStamp <= endDate2) {

                        activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-22')).format('L');
                    } else if (nextBillingEventTimeStamp >= startDate3 && nextBillingEventTimeStamp <= endDate3) {

                        activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-23')).format('L');
                    } else if (nextBillingEventTimeStamp >= startDate4 && nextBillingEventTimeStamp <= endDate4) {

                        activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-28')).format('L');
                    } else {

                        activationCode.attributes.customInfo.formatted_next_billing_event = moment(nextBillingEvent).format('L');
                    }
                } else {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(nextBillingEvent).format('L');
                }

                activationCode.attributes.customBillingDateForCMA = activationCode.attributes.customInfo.formatted_next_billing_event;

                activationCode.attributes.customInfo.formatted_date_expire = moment(expirationDate).format('L');

                // get transaction id from filtered transactions (hide transaction id for transactions with price 0)
                var activationCodeTransactionId = _$scope.transactions.find(function (transaction) {
                    return transaction.attributes.activation_code === activationCode.id;
                });

                // Check if the payment type associated with the current activation code was removed
                // Get transaction id associated with the current activation code
                var paymentTransactionId = _util.deepFind(activationCodeTransactionId, 'attributes.payment_transaction_id');

                // Get payment type details based on the transaction id
                var paymentTypeDetails = _paymentTypes.find(function (payment) {
                    return payment.id === paymentTransactionId;
                });

                // If the card was removed, so we need to disable the auto-renewal toggle
                if (_util.isPaymentCardDeleted(paymentTypeDetails)) {

                    activationCode.removedPaymentOption = true;
                }

                if (activationCodePurchaseDate) {

                    activationCode.attributes.customInfo.purchaseDate = _util.deepFind(activationCodePurchaseDate, 'attributes.date_create');
                    activationCode.attributes.customInfo.transactionId = _util.deepFind(activationCodeTransactionId, 'attributes.payment_transaction_id');
                    var purchaseDate = _util.deepFind(activationCodePurchaseDate, 'attributes.date_create');

                    activationCode.attributes.customInfo.purchaseDate = moment(purchaseDate).format('L');
                } else {

                    var runtime = _util.deepFind(activationCode, 'attributes.runtime');
                    var runtimeUnit = _util.deepFind(activationCode, 'attributes.runtime_unit');

                    if (runtime === 1 && runtimeUnit === 'months') {

                        runtime = 30;
                        runtimeUnit = 'days';
                    } else if (subscriptionType === 'annual-trial') {

                        runtimeUnit = 'trial-days';
                    }

                    // convert runtime date to ms
                    var activationDate = new Date(expirationDate);
                    if (runtimeUnit === 'days') {

                        activationDate = activationDate.setDate(activationDate.getDate() - runtime);
                    } else if (runtimeUnit === 'months') {

                        activationDate = activationDate.setMonth(new Date(expirationDate).getMonth() - runtime);
                    } else if (runtimeUnit === 'trial-days') {

                        var _license = _licensesRepository.getLicenseBy(activationCode.id);
                        var creationDate = _util.deepFind(_license, 'attributes.creation_date');
                        activationDate = new Date(creationDate);
                    }

                    activationCode.attributes.customInfo.purchaseDate = moment(activationDate).format('L');
                }

                var expireNotificationDays = _this3.getExpireNotificationDays(activationCode);

                if (appId && !_$scope.appIntegrations[appId]) {

                    _$scope.appIntegrations[appId] = _index.AppIntegrationsRepository.getById(appId) || {};
                    _$scope.appIntegrations[appId].appComponents = [];

                    var includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                    var hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                    if (includedApps.data) {

                        includedApps.data.forEach(function (app) {

                            if (!hiddenAppInBundleIds.find(function (id) {
                                return app.id === id;
                            }) && _index.AppIntegrationsRepository.getById(app.id) !== undefined) {

                                _$scope.appIntegrations[appId].appComponents.push(_index.AppIntegrationsRepository.getById(app.id));
                            }
                        });
                    }
                }

                _$scope.licenses[activationCode.id] = _licensesRepository.getLicenseBy(activationCode.id);

                // add the remaining days until subscription expires in activation code object - custom info
                if (expirationDate) {

                    var todayFormatted = moment().format('L');
                    var expirationDateFormatted = moment(expirationDate).format('L');

                    var remainingDaysUntilExpiration = _this3.getDateDifference(expirationDate);

                    activationCode.attributes.customInfo.remainingDaysUntilExpiration = remainingDaysUntilExpiration;
                    activationCode.attributes.customInfo.showExpirationNotification = false;

                    if (_this3.checkStaticOTC(activationCode)) {

                        activationCode.attributes.customInfo.expiringToday = false;
                    } else {

                        activationCode.attributes.customInfo.expiringToday = !!(todayFormatted === expirationDateFormatted);
                    }

                    if (remainingDaysUntilExpiration <= expireNotificationDays && activationCode.attributes.subscription === 0 && !activationCode.attributes.customInfo.isNonrenewableApp) {

                        activationCode.attributes.customInfo.showExpirationNotification = true;

                        var found = _expiringActivationCodes.find(function (element) {
                            return element.id === activationCode.id;
                        });

                        if (!found) {

                            _expiringActivationCodes.push(activationCode);
                        }
                    } else {

                        activationCode.attributes.customInfo.showExpirationNotification = false;
                    }
                }

                var license = _index.LicensesRepository.getLicenseBy(activationCode.id) || {};
                activationCode.attributes.customInfo.devices = _devicesProcessor.getDevicesByLicenseId(license.id);
                _this3.returnFirstExpirationDate();

                _this3.setSessionStorageStaticOTCs(activationCode);

                _$scope.switchedToMonthlyTooltips = JSON.parse(sessionStorage.getItem('switchedToMonthlyTooltips'));
            });

            this.filterActivatonCodes(_$scope.activationCodes);

            setTimeout(function () {

                _$scope.$apply();
            }, 1000);
        }

        /**
         * Replace all expired licenses with received data
         * @param {Array} data
         */

    }, {
        key: 'onExpiredLicensesNext',
        value: function onExpiredLicensesNext(data) {

            _$scope.expiredLicenses = data;

            if (_$scope.expiredLicenses.length > 0) {

                // Show the Expired Licenses tab
                _$scope.showExpiredLicensesTab = true;

                _$scope.expiredLicenses.forEach(function (license) {

                    var appId = _util.deepFind(license, 'relationships.app.data.id');
                    var activationCode = _util.deepFind(license, 'relationships.activation-code.data.id');
                    var expirationDate = _util.deepFind(license, 'attributes.expiration_date');

                    license.attributes.formatted_expiration_date = moment(expirationDate).format('L');

                    if (appId && !_$scope.appIntegrations[appId]) {

                        _$scope.appIntegrations[appId] = _index.AppIntegrationsRepository.getById(appId) || {};
                        _$scope.appIntegrations[appId].appComponents = [];

                        var includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                        var hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                        if (includedApps.data) {

                            includedApps.data.forEach(function (app) {

                                if (!hiddenAppInBundleIds.find(function (id) {
                                    return app.id === id;
                                }) && _index.AppIntegrationsRepository.getById(app.id) !== undefined) {

                                    _$scope.appIntegrations[appId].appComponents.push(_index.AppIntegrationsRepository.getById(app.id));
                                }
                            });
                        }
                    }

                    // get transaction id only for regular subscriptions
                    if (license.attributes.subscription_type !== 'prepaid') {

                        _$scope.transactions.forEach(function (transaction) {

                            if (transaction.attributes.activation_code === activationCode && transaction.attributes.app === license.relationships.app.data.id) {

                                license.attributes.transactionId = transaction.attributes.payment_transaction_id;
                            }
                        });
                    }
                });
            }
        }

        // return the number of days to notify users that their subscription will expire
        // param {obj} activationCode || license

    }, {
        key: 'getExpireNotificationDays',
        value: function getExpireNotificationDays(data) {

            var monthlyExpireNotificationDays = CWCONFIG.monthlySubscriptionExpirationReminderDays || 20;
            var annualExpireNotificationDays = CWCONFIG.annualSubscriptionExpirationReminderDays || 60;
            var annualSubscriptionTypes = ['annual', 'annual-trial', 'yearly'];
            var isAnnualSubscription = false;

            if (annualSubscriptionTypes.indexOf(data.attributes.subscription_type) > -1) {

                if (data.attributes.type === 'eval' && (data.attributes.runtime_unit === 'months' && data.attributes.runtime <= 1 || data.attributes.runtime_unit === 'days' && data.attributes.runtime <= 30)) {

                    isAnnualSubscription = false;
                } else {

                    isAnnualSubscription = true;
                }
            }

            return isAnnualSubscription ? annualExpireNotificationDays : monthlyExpireNotificationDays;
        }
    }, {
        key: 'onFlexiblePromotionsNext',
        value: function onFlexiblePromotionsNext() {

            var flexiblePromotions = _flexiblePromotionsRepository.getAll() || [];

            flexiblePromotions.forEach(function (promotion) {

                _$scope.activationCodes.forEach(function (activationCode) {

                    if (promotion.id === activationCode.attributes.promotion_id) {

                        activationCode.attributes.promotion = {};
                        activationCode.attributes.promotion = promotion;
                    }
                });
            });
        }

        /**
         * Returns the difference in days until the expiration
         * @param {Date} date
         */

    }, {
        key: 'timeUntilExpiration',
        value: function timeUntilExpiration(license) {

            var duration = this.getDateDifference(license.attributes.expiration_date);

            if (duration === 1 && license.attributes.expired === false) {

                return _$translate.instant('cw.subscription.day', { interval: duration });
            }
            if (duration > 1 && license.attributes.expired === false) {

                return _$translate.instant('cw.subscription.days', { interval: duration });
            }
            if (duration < 0 && license.attributes.expired === true) {

                return _$translate.instant('cw.subscription.expired');
            }
            return '';
        }

        /**
         * Compares received date string with the current date
         * Returns the difference in days as int
         * If the diffrence is less than a day, always returns 1 day.
         * @param {String} date
         */

    }, {
        key: 'getDateDifference',
        value: function getDateDifference(date) {

            var startTime = moment();
            var endTime = moment(date);
            var difference = parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;

            return difference;
        }

        // filter activations that are not properly configured and print them in console

    }, {
        key: 'filterActivatonCodes',
        value: function filterActivatonCodes(activationCodes) {

            var hiddenActivationCodes = [];

            activationCodes.forEach(function (activationCode) {

                var appId = _util.deepFind(activationCode, 'relationships.app.data.id');
                var appCorrespondingToActivation = _index.AppIntegrationsRepository.getById(appId);
                var canBeShown = appCorrespondingToActivation && _util.deepFind(appCorrespondingToActivation, 'attributes.custom.manifest.name') && _util.deepFind(appCorrespondingToActivation, 'attributes.custom.manifest.os') ? true : false;
                if (!canBeShown) {

                    // if the app is missing from appIntegration resource, we log only the appId
                    hiddenActivationCodes.push(appCorrespondingToActivation || appId);

                    _RFC4.default.send('ConnectWeb Subscription App Error', {
                        appId: appId
                    });
                }
            });

            if (hiddenActivationCodes.length > 0) {

                _loggers2.default.log({
                    type: 'Product Catalog - subscriptions that don\'t meet the criteria to be visible',
                    cmd: 'show hiddenActivationCodes',
                    data: hiddenActivationCodes
                });
            }
        }

        // check if OTC is static

    }, {
        key: 'checkStaticOTC',
        value: function checkStaticOTC(activationCode) {

            return activationCode.attributes.subscription === 0 && (activationCode.attributes.subscription_type === 'yearly' || activationCode.attributes.subscription_type === 'prepaid');
        }
    }, {
        key: 'isBusinessProduct',
        value: function isBusinessProduct(activationCode) {
            var _ref = CWCONFIG.store || [],
                businessProducts = _ref.businessProducts;

            return !!businessProducts.find(function (app) {
                return activationCode.attributes.app === app;
            });
        }
    }, {
        key: 'activateSubscription',
        value: function activateSubscription(activationCodeId) {
            var _this4 = this;

            var activationCode = _activationCodesRepository.getById(activationCodeId);
            var appId = _util.deepFind(activationCode, 'relationships.app.data.id') || 'New OTC';
            var appIntegration = _index.AppIntegrationsRepository.getById(appId);

            _$scope.appName = _util.deepFind(appIntegration, 'attributes.resource.oeName') || 'New OTC';

            _RFC4.default.send('ConnectWeb My Subscriptions Activate Click', {
                Product: _$scope.appName,
                'Product ID': appId
            });

            if (this.activationCodeLength !== activationCodeId.length) {

                _util.triggerAnimation('.error', 'animated shake');
                _$scope.activationStatus = 'error';
                return;
            }

            _$scope.loadingButton = true;

            var licensePayload = {
                data: {
                    type: 'licenses',
                    relationships: {
                        'activation-code': {
                            data: { type: 'activation-codes', id: activationCodeId }
                        },
                        provider: {
                            data: { type: 'providers', id: _$window.appName }
                        }
                    }
                }
            };

            _licenseRestService.create(licensePayload).then(function (response) {

                var licenseAppId = _util.deepFind(response, 'data.data.relationships.app.data.id');
                var licenseAppIntegration = _index.AppIntegrationsRepository.getById(licenseAppId);
                _$scope.appName = _util.deepFind(licenseAppIntegration, 'attributes.resource.oeName');

                _RFC4.default.send('ConnectWeb My Subscriptions Activate Success', {
                    Product: _$scope.appName,
                    'Product ID': appId
                });

                if (_$scope.activationCodes.length === 0) {

                    _$scope.finalStepActivationWizard = true;

                    // detect static OTC
                    _$scope.isStaticOTC = _this4.checkStaticOTC(response.data.data);
                } else {

                    _$scope.successAnimation = true;
                    _$scope.inputActivationCode = '';
                }

                _$scope.activationStatus = 'success';
                _$scope.loadingButton = false;

                _$timeout(function () {

                    _this4.fetchActivationCodes();
                }, 2500);
            }).then(null, function (error) {

                var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                _$scope.activationStatus = 'serverError';
                _$scope.serverErrorTranslate = '';
                _$scope.loadingButton = false;

                _RFC4.default.send('ConnectWeb My Subscriptions Activate Error', {
                    Product: _$scope.appName,
                    'Product ID': appId,
                    'Error Code': errorCode
                });

                switch (errorCode) {

                    case '21224':
                        // activation code was not found

                        _util.triggerAnimation('.error', 'animated shake');
                        _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_not_found';
                        break;

                    case '21223': // activation code invalid
                    case '21246':
                        // code not found in database

                        _util.triggerAnimation('.error', 'animated shake');
                        _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_invalid';
                        break;

                    case '21236':
                        // activation code already used

                        _util.triggerAnimation('.error', 'animated shake');
                        _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_already_used';
                        break;

                    case '21225':
                        // activation code expired

                        _util.triggerAnimation('.error', 'animated shake');
                        _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_expired';
                        break;

                    case '21241':
                        // maximum users for activation code

                        _util.triggerAnimation('.error', 'animated shake');
                        _$scope.serverErrorTranslate = 'cw.subscription.error.max_users_reached';
                        break;

                    default:

                        _RFC2.default.error('cw.notification.system.error');
                        _$scope.serverErrorTranslate = undefined;

                }
            });
        }
    }, {
        key: 'fetchActivationCodes',
        value: function fetchActivationCodes() {

            _activationCodeRestService.getAllAsync().then(function (response) {

                _activationCodesRepository.replace(response.data.data);
                _$scope.successAnimation = false;

                /**
                 * Get recommendations will be empty, observable in recommendations banner
                 * will be triggered and hide the banner
                 */
                _RecommendationsRestService.getAllAsync().then(function (res) {

                    _index.RecommendationsRepository.replace(res.data.data);
                });

                if (_$scope.finalStepActivationWizard === false) {

                    _$state.go('root.dashboard.subscriptions', {
                        tab: 'plans'
                    });
                }
            }).then(null, function () {

                _RFC2.default.error();
                _$scope.successAnimation = false;
            });
        }
    }, {
        key: 'subscriptionToggle',
        value: function subscriptionToggle(activationCode, label) {

            var newToggleState = activationCode.attributes.subscription !== 0 ? 'Off' : 'On';

            if (newToggleState === 'Off') {

                var runtime = this.getDateDifference(activationCode.attributes.date_expire);

                _RFC4.default.send('ConnectWeb Subscription ' + newToggleState + ' Click', {
                    Page: 'Subscriptions',
                    Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                    'Product ID': activationCode.relationships.app.data.id,
                    'Current Runtime': runtime,
                    'Subscription Runtime': activationCode.attributes.runtime,
                    'Subscription Type': activationCode.attributes.subscription_type
                });
            }

            if (newToggleState === 'On') {

                var _runtime = this.getDateDifference(activationCode.attributes.date_expire);

                _RFC4.default.send('ConnectWeb Subscription ' + newToggleState + ' Click', {
                    Page: 'Subscriptions',
                    Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                    'Product ID': activationCode.relationships.app.data.id,
                    'Current Runtime': _runtime,
                    'Subscription Runtime': activationCode.attributes.runtime,
                    'Subscription Type': activationCode.attributes.subscription_type,
                    Label: label ? label : ''

                });
            }

            if (this.checkStaticOTC(activationCode) && activationCode.attributes.add_payment_details_link) {

                this.onRenewalClick(activationCode, 'OTC');
            } else {

                var allTransactions = _index.TransactionsRepository.getAll();
                var transaction = allTransactions.find(function (el) {
                    return el.attributes.activation_code === activationCode.id;
                });
                if (transaction) {

                    _$rootScope.dateABTest = transaction.attributes.date_create;
                }
                _$state.go('root.dashboard.subscriptions.ltb', {
                    ltb: 'confirm',
                    resourceId: activationCode.id
                }, {
                    reload: false
                });
            }
        }
    }, {
        key: 'onRenewalClick',
        value: function onRenewalClick(activationCode, type, campaign) {

            var mixPanelPayload = {
                Page: 'Subscriptions',
                Label: 'Activation Codes List',
                Type: type,
                Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                'Campaign Name': campaign ? activationCode.attributes.cmp : 'None'
            };

            _RFC4.default.send('ConnectWeb Renew Click', mixPanelPayload);

            var appId = _util.deepFind(activationCode, 'relationships.app.data.id');
            var isIframeProduct = CWCONFIG.subscriptions.iframeProducts.find(function (product) {
                return product === appId;
            });

            if (isIframeProduct && campaign !== 'cobi2020avpro') {

                var licenseId = activationCode.type === 'licenses' ? activationCode.id : _licensesRepository.getLicenseBy(activationCode.id).id;

                _$state.go('root.dashboard.subscriptions.ltb.renew', {
                    ltb: 'payment-cart',
                    resourceId: appId,
                    subsource: 'renew',
                    licenseId: licenseId
                }, {
                    reload: false
                });
            }

            _$scope.renewLink = isIframeProduct ? '' : _util.deepFind(activationCode, 'attributes.renewal_link') + '&x-a-source=cw';
        }
    }, {
        key: 'getButtonAction',
        value: function getButtonAction(resource) {

            if (resource.type === 'licenses') {

                var license = resource;

                var isWebApp = !!this.isWebApp(license.relationships.app.data.id);

                if (isWebApp) {

                    return 'open';
                }

                return 'install';
            } else if (resource.type === 'activation-codes') {

                var activationCode = resource;

                var readyToInstall = !!(activationCode.attributes.status === 'used' && _util.deepFind(_$scope.appIntegrations[activationCode.relationships.app.data.id], 'attributes.custom.manifest.os') && _$scope.licenses[activationCode.id]);

                var readyToActivate = !!(activationCode.attributes.status !== 'used');

                var _isWebApp = !!this.isWebApp(activationCode.relationships.app.data.id);

                if (_isWebApp) {

                    return 'open';
                } else if (readyToInstall) {

                    return 'install';
                } else if (readyToActivate) {

                    return 'activate';
                }
            }

            return '';
        }
    }, {
        key: 'isWebApp',
        value: function isWebApp(app) {

            var appData = _index.AppIntegrationsRepository.getById(app);

            if (!appData) {

                return false;
            }

            var platformList = _util.deepFind(appData, 'attributes.platform.type') || _util.deepFind(appData, 'attributes.custom.manifest.os'); // fallback option;

            if (!platformList) {

                return false;
            }

            var isWebApp = platformList.indexOf('webapp') !== -1;

            if (isWebApp) {

                return true;
            }

            return false;
        }
    }, {
        key: 'showService',
        value: function showService(app, subscriptionId, currentTab, campaignName, installType) {

            var stateName = _$state.current.name;

            _RFC4.default.send('ConnectWeb Install Click', {
                Page: 'Subscriptions',
                Product: _$scope.appIntegrations[app].attributes.resource.oeName,
                'Product ID': app,
                'Campaign Name': campaignName ? campaignName : 'None',
                Label: installType || 'install'
            });

            if (stateName.indexOf('.ltb.deploy') === -1) {

                stateName += '.ltb.deploy';
            }

            // hide ocp tooltip
            _$rootScope.ocpSubscriptionTooltipAppId = null;

            var isWebApp = this.isWebApp(app);

            if (isWebApp) {

                // open modal for redirecting to webapp url
                _$state.go(stateName, {
                    ltb: 'deploy',
                    resourceId: subscriptionId,
                    deviceId: 'new',
                    appId: app,
                    os: 'webapp',
                    tabs: currentTab,
                    licenseId: ''
                }, {
                    reload: false
                });
            } else {

                var matchingOS = _devicesProcessor.getDeployOSfor(app, currentDeviceOS) || null;

                var hasMatchingOS = !!matchingOS;

                if (installType === 'other_device') {

                    _$state.go(stateName, {
                        ltb: 'deploy',
                        resourceId: subscriptionId,
                        deviceId: 'new',
                        appId: app,
                        tabs: currentTab,
                        licenseId: ''
                    }, {
                        reload: false
                    });
                } else {

                    var appToInstall = app;
                    var autoInstallValue = hasMatchingOS;

                    _$state.go(stateName, {
                        ltb: 'deploy',
                        resourceId: subscriptionId,
                        deviceId: 'new',
                        appId: appToInstall,
                        os: matchingOS,
                        tabs: currentTab,
                        licenseId: '',
                        autoInstall: autoInstallValue
                    }, {
                        reload: false
                    });
                }
            }
        }
    }, {
        key: 'closeActivationWizard',
        value: function closeActivationWizard() {

            _$scope.finalStepActivationWizard = false;
            _$scope.inputActivationCode = '';
            _$state.go('root.dashboard.subscriptions', {
                tab: 'plans'
            });
        }
    }, {
        key: 'goToStore',
        value: function goToStore(mixpanelValue) {

            _RFC4.default.send(mixpanelValue);
            _$state.go('root.dashboard.store');
        }
    }, {
        key: 'resetActivationStatus',
        value: function resetActivationStatus() {

            _$scope.activationStatus = '';
        }
    }, {
        key: 'activateCode',
        value: function activateCode(activationCode) {

            _$state.go('root.dashboard.subscriptions.ltb', {
                ltb: 'activation-confirmation',
                resourceId: activationCode.id
            });
        }

        /**
         * If appId is found in appsForDevices, the copy in view will be forced to be 'devices'
         */

    }, {
        key: 'hardcodeDeviceLicenseType',
        value: function hardcodeDeviceLicenseType(appId) {

            var appsForDevices = ['aapd0', 'aapd5', 'ispm0', 'isec0', 'asu60', 'atss0', 'aapl0', 'swoe0', 'ao001', 'aps10', 'aps20'];

            if (appsForDevices.indexOf(appId) > -1) {

                return true;
            }

            return false;
        }

        /**
         * If appId is found in apps, the copy in view will have a harcoded number of devices
         */

    }, {
        key: 'hardcodeDevicesNumber',
        value: function hardcodeDevicesNumber(appId) {

            var apps = ['aps10', 'aps20'];

            var appsDevices = {
                aps10: {
                    devices: 5
                },
                aps20: {
                    devices: 25
                }
            };

            if (apps.indexOf(appId) > -1) {

                return appsDevices[appId].devices;
            }

            return false;
        }
    }, {
        key: 'returnFirstExpirationDate',
        value: function returnFirstExpirationDate() {

            var expiring = [];
            _$scope.firstexpiringLicense = '';

            if (_expiringActivationCodes) {

                _expiringActivationCodes.forEach(function (activationCode) {

                    expiring.push(activationCode);
                });
            }

            if (_expiringLicenses) {

                _expiringLicenses.forEach(function (license) {

                    expiring.push(license);
                });
            }

            if (expiring.length > 1) {

                // first expiring will be only Prime if we have an Prime license/activation code
                var expiringPrimeLicense = expiring.filter(function (license) {
                    return _$scope.primeAppIds.indexOf(license.relationships.app.data.id) > -1;
                });
                var firstExpiring = void 0;
                if (expiringPrimeLicense.length > 0) {

                    firstExpiring = expiringPrimeLicense.reduce(function (previous, current) {
                        return previous.attributes.customInfo.remainingDaysUntilExpiration < current.attributes.customInfo.remainingDaysUntilExpiration ? previous : current;
                    });
                } else {

                    firstExpiring = expiring.reduce(function (previous, current) {
                        return previous.attributes.customInfo.remainingDaysUntilExpiration < current.attributes.customInfo.remainingDaysUntilExpiration ? previous : current;
                    });
                }

                _$scope.firstexpiringLicense = firstExpiring;
            } else if (expiring.length === 1) {
                _$scope.firstexpiringLicense = expiring[0];
            }

            if (_$scope.firstexpiringLicense) {

                if (this.checkStaticOTC(_$scope.firstexpiringLicense)) {

                    _$scope.firstexpiringLicense.isStaticOTC = true;
                } else {

                    _$scope.firstexpiringLicense.isStaticOTC = false;
                }
            }
        }
    }, {
        key: 'activateFirstExpiringLicense',
        value: function activateFirstExpiringLicense(activationCode, type) {

            if (this.isVoucherPurchase(activationCode)) {

                this.firstExpiringLicenseEvent(activationCode, type);

                _RFC4.default.send('ConnectWeb Auto Renew Click', {
                    Page: 'Subscriptions',
                    Label: 'Banner',
                    Type: type,
                    Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName
                });
            } else {

                _$scope.bannerButtonLoading = true;
                var key = activationCode.id || '';

                var payloadActivationCode = {
                    data: {
                        attributes: {
                            subscription: '1'
                        },
                        relationships: {
                            provider: {
                                data: {
                                    type: 'providers',
                                    id: _$window.appName
                                }
                            }
                        }
                    }
                };

                _activationCodeRestService.updateAsync(key, payloadActivationCode).then(function (response) {

                    _activationCodesRepository.update(response.data.data);
                    _$scope.bannerButtonLoading = false;

                    _RFC4.default.send('ConnectWeb Auto Renew Click', {
                        Page: 'Subscriptions',
                        Label: 'Banner',
                        Type: type,
                        Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName
                    });
                }).then(null, function (error) {

                    var responseError = error.data && error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                    _$scope.bannerButtonLoading = false;

                    switch (responseError) {

                        case '21312':
                            _RFC2.default.error('cw.subscription.error.no-payment');
                            break;

                        case '21313':
                            _RFC2.default.error('cw.subscription.error.status_no_change_appstore');
                            break;

                        case '21315':
                            _RFC2.default.error('cw.subscription.error.no-payment');
                            break;

                        case '21316':
                            _RFC2.default.error('cw.subscription.error.status_no_change_google_play');
                            break;

                        case '21317':
                            _RFC2.default.error('cw.subscription.error.status_no_change_google_play');
                            break;

                        default:
                            _RFC2.default.error('cw.notification.system.error');

                    }
                });
            }
        }
    }, {
        key: 'refreshTransactions',
        value: function refreshTransactions() {

            _$scope.refreshLoader = true;

            _transactionRestService.getAllAsync().then(function (response) {

                _index.TransactionsRepository.replace(response.data.data);

                _$scope.transactions = _index.TransactionsRepository.getAll();

                // Format each transaction date
                _$scope.transactions.forEach(function (transaction) {

                    var dateCreate = _util.deepFind(transaction, 'attributes.date_create');
                    transaction.attributes.formatted_date_create = moment(dateCreate).format('L');
                });

                _$scope.refreshLoader = false;
                _$scope.refreshRequests += 1;

                _RFC2.default.success();
            }).catch(function () {

                _$scope.refreshRequests += 1;
                _RFC2.default.error();
            });
        }
    }, {
        key: 'firstExpiringLicenseEvent',
        value: function firstExpiringLicenseEvent(license, type) {

            _RFC4.default.send('ConnectWeb Renew Click', {
                Page: 'Subscriptions',
                Label: 'Banner',
                Type: type,
                Product: _$scope.appIntegrations[license.relationships.app.data.id].attributes.resource.oeName
            });

            var appId = _util.deepFind(license, 'relationships.app.data.id');
            var isIframeProduct = CWCONFIG.subscriptions.iframeProducts.find(function (product) {
                return product === appId;
            });

            if (isIframeProduct) {

                var licenseId = license.type === 'licenses' ? license.id : _licensesRepository.getLicenseBy(license.id).id;
                _$state.go('root.dashboard.subscriptions.ltb.renew', {
                    ltb: 'payment-cart',
                    resourceId: appId,
                    subsource: 'renew',
                    licenseId: licenseId
                }, {
                    reload: false
                });
            }
            _$scope.renewLinkBanner = isIframeProduct ? '' : _util.deepFind(license, 'attributes.renewal_link') + '&x-a-source=cw';
        }
    }, {
        key: 'setSessionStorageStaticOTCs',
        value: function setSessionStorageStaticOTCs(activationCode) {

            // for each static OTC a new key is added in staticOTC obj from session storage
            if (this.checkStaticOTC(activationCode) && activationCode.attributes.add_payment_details_link) {

                if (_sessionAddPaymentTooltips[activationCode.id] === undefined || _sessionAddPaymentTooltips[activationCode.id] === null) {

                    _sessionAddPaymentTooltips[activationCode.id] = true;
                }
            }

            _$scope.showAddPaymentTooltips = _sessionAddPaymentTooltips;
            sessionStorage.setItem('staticOTCs', JSON.stringify(_sessionAddPaymentTooltips));
        }

        // close the tooltip for the current session

    }, {
        key: 'closeActivationTooltip',
        value: function closeActivationTooltip(activationCode) {

            if (_sessionAddPaymentTooltips[activationCode.id]) {

                _sessionAddPaymentTooltips[activationCode.id] = false;
            }

            _$scope.showAddPaymentTooltips = _sessionAddPaymentTooltips;
            sessionStorage.setItem('staticOTCs', JSON.stringify(_sessionAddPaymentTooltips));
        }
    }, {
        key: 'sendMixpanelEventDetailsButton',
        value: function sendMixpanelEventDetailsButton(activationCode, label) {

            _RFC4.default.send('ConnectWeb Subscription Details Click', {
                Page: 'Subscriptions',
                Label: label,
                Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName
            });
        }
    }, {
        key: 'sendMixpanelEventEnableSubscription',
        value: function sendMixpanelEventEnableSubscription(activationCode, label, action) {

            _RFC4.default.send('ConnectWeb Subscription Short View Click', {
                Page: 'Subscriptions',
                'Button Label': label,
                Action: action,
                Product: _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                'Subscription Runtime': activationCode.attributes.runtime,
                'Subscription Type': activationCode.attributes.subscription_type
            });
        }
    }, {
        key: 'sendMixpanelEventEnableSubscriptionDiscountBanner',
        value: function sendMixpanelEventEnableSubscriptionDiscountBanner() {

            _RFC4.default.send('ConnectWeb Banner Discount Auto-Renew Click');
        }

        // check if this was purchased from Google or Apple

    }, {
        key: 'isMobilePurchase',
        value: function isMobilePurchase(activateCode) {

            var tranzactions = _index.TransactionsRepository.getAll().find(function (transaction) {
                return transaction.attributes.activation_code === activateCode.id;
            });
            var paymentGateway = tranzactions ? tranzactions.attributes.payment_gateway : undefined;

            if (paymentGateway === 'GOOG') {

                _$scope.paymentGateway = 'Google';
                return true;
            } else if (paymentGateway === 'AAPL') {

                _$scope.paymentGateway = 'Apple';
                return true;
            }

            return false;
        }

        // check if this was purchased by family and friend voucher so we will hide autorenew toogle and enable subscription button

    }, {
        key: 'isVoucherPurchase',
        value: function isVoucherPurchase(activateCode) {

            var transactionWithVoucher = _index.TransactionsRepository.getAll().find(function (transaction) {
                return transaction.attributes.activation_code === activateCode.id;
            });

            if (transactionWithVoucher && transactionWithVoucher.attributes) {

                return transactionWithVoucher.attributes.payment_type === 'Voucher' ? true : false;
            }

            return false;
        }

        // check if the user has US compliance - the subscription can only be turned off

    }, {
        key: 'isUsComplied',
        value: function isUsComplied(activationCode) {

            if (activationCode.attributes.subscription === 0 && !_$rootScope.hasUsCompliance) {

                return false;
            }

            return true;
        }
    }, {
        key: 'sendMixpanelEventAIAPrimeDetails',
        value: function sendMixpanelEventAIAPrimeDetails() {

            _RFC4.default.send('ConnectWeb AIA Prime Details Click');
        }
    }]);

    return Subscriptions;
}();

_serviceDependencies.push(Subscriptions);

angular.module('controllers').controller('Subscriptions', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "HSGj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loggers = __webpack_require__("+htc");

/**
 * Http Interceptor for logging REST calls into the console.
 */

var getResourceFromUrl = function getResourceFromUrl(url) {

    var res = /https?:\/\/.+(\/[a-z0-9]+\/.+?)+[/|?]/.exec(url);
    return res && res[1];
};

angular.module('services').factory('LogHttpRESTAPIInterceptor', ['$injector', '$q', '$rootScope', function ($injector, $q, $rootScope) {
    var url = CWCONFIG.restApi.url;

    return {
        request: function request(_request) {

            if (_request.url.indexOf(url) > -1) {

                var resource = getResourceFromUrl(_request.url);

                _loggers.httpLogger.info({
                    type: 'API REQ ' + _request.method + ' ' + resource,
                    data: _request.data
                });
            }

            return _request;
        },
        response: function response(_response) {

            if (_response.config.url.indexOf(url) > -1) {

                var resource = getResourceFromUrl(_response.config.url);

                // REST HTTP CALL
                _loggers.httpLogger.info({
                    type: 'API RES',
                    cmd: _response.config.method + ' ' + resource + ' ' + _response.status,
                    data: _response.data
                });
            }

            return _response;
        },
        responseError: function responseError(response) {

            var ErrorHandler = $injector.get('ErrorHandler');
            var Util = $injector.get('Util');

            // token has expired, show expired token modal
            if (response.status === 401 && Util.deepFind(response, 'data.error') && response.data.error === 'expired_token') {

                var errorLocation = 'HttpInterceptor 401 Expired Token Error';

                ErrorHandler.handleError(response, errorLocation);
            }
            // save data error on $rootScope so it can be used in alert component
            if (response.data && response.status && (response.data.error || response.data.errors || response.data.errorCode || response.data.message)) {

                var errorMsg = '';

                if (response.data.error) {

                    errorMsg = response.data.error;
                }
                if (response.data.errors && response.data.errors.length) {

                    errorMsg = response.data.errors[0].detail;
                }
                if (response.data.errorCode) {

                    errorMsg = response.data.errorCode;
                }

                if (response.data.message) {

                    errorMsg = response.data.message;
                }

                $rootScope.errorMessage = response.status + ' (' + errorMsg + ')';

                setTimeout(function () {

                    $rootScope.errorMessage = '';
                }, 2000);
            }

            if (response.config) {

                _loggers.httpLogger.log({
                    type: 'API RES',
                    cmd: 'ERROR ' + response.status + ' ' + response.config.method + ' ' + (getResourceFromUrl(response.config.url) || ''),
                    data: response.data
                });
            }

            if (response.status === -1) {

                $rootScope.errorMessage = 'Connection Error (-1)';
            }

            if (window.external && 'WriteLog' in window.external) {

                var message = {
                    status: response.status,
                    errorMessage: $rootScope.errorMessage,
                    data: response.data
                };

                window.external.WriteLog('ERROR', JSON.stringify(message));
            }

            // !!Important Must use promise api's q.reject()
            // to properly implement this interceptor
            // or the response will go the success handler of the caller
            return $q.reject(response);
        }
    };
}]);

/***/ }),

/***/ "HimL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _recommendations = [];
var observableRecommendations = new Rx.BehaviorSubject(_recommendations);

/**
 * @ngdoc service
 * @name repositories.RecommendationsRepository
 *
 * @description
 * RecommendationsRepository
 */
var RecommendationsRepository = {
    replace: function replace(data) {

        _recommendations = data;
        observableRecommendations.onNext(_recommendations);
    },
    getAll: function getAll() {

        return _recommendations;
    },
    getObservable: function getObservable() {

        return observableRecommendations;
    }
};

exports.default = RecommendationsRepository;

/***/ }),

/***/ "Hnr2":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("zOp4"),
    isKey = __webpack_require__("Kxtb"),
    stringToPath = __webpack_require__("p8AI"),
    toString = __webpack_require__("GLmR");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "HqoE":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("S8m2"),
    Uint8Array = __webpack_require__("wTs6"),
    eq = __webpack_require__("0huu"),
    equalArrays = __webpack_require__("yGKA"),
    mapToArray = __webpack_require__("nc0B"),
    setToArray = __webpack_require__("4XN+");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "Hz9n":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("SiCv");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "I/a1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['$state', '$scope', 'Util'];

var ChooseDeviceOsWizardController = function () {
    function ChooseDeviceOsWizardController($state, $scope, Util) {
        _classCallCheck(this, ChooseDeviceOsWizardController);

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;

        this.deviceCategory = this.$scope.inputData.deviceCategory;

        if (this.deviceCategory === 'all') {

            this.supportedOs = ['windows', 'android', 'ios', 'osx'];
        } else if (this.deviceCategory === 'desktop') {

            this.supportedOs = ['windows', 'osx'];
        } else if (this.deviceCategory === 'mobile') {

            this.supportedOs = ['android', 'ios'];
        }
    }

    _createClass(ChooseDeviceOsWizardController, [{
        key: 'deployOn',
        value: function deployOn(os) {

            if (this.$state.current.name.indexOf('.home') > -1) {

                _RFC2.default.send('ConnectWeb Add New Device Click', { Page: 'Homepage', 'Device Os': os });

                this.$scope.changeWizard()('root.dashboard.home.ltb.deploy', {
                    os: os
                }, {
                    reload: false
                });
            } else {

                _RFC2.default.send('ConnectWeb Add New Device Click', { Page: 'My Devices', 'Device Os': os });

                this.$scope.changeWizard()('root.dashboard.devices.ltb.deploy', {
                    os: os
                }, {
                    reload: false
                });
            }
        }
    }]);

    return ChooseDeviceOsWizardController;
}();

var ChooseDeviceOsWizardDirective = function ChooseDeviceOsWizardDirective() {
    _classCallCheck(this, ChooseDeviceOsWizardDirective);

    this.template = __webpack_require__("h4dL");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state, $scope, Util) {
        return new ChooseDeviceOsWizardController($state, $scope, Util);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'chooseDeviceOsWizardCtrl';
};

_directiveDependencies.push(function () {
    return new ChooseDeviceOsWizardDirective();
});

angular.module('directives').directive('chooseOsTypeWizard', _directiveDependencies);

/***/ }),

/***/ "I2sd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('ProductCard', ['$scope', '$state', '$stateParams', '$window', '$location', 'Util', function ($scope, $state, $stateParams, $window, $location, Util) {

    var queryParams = $location.search();

    $scope.browserName = $window.browserName.toLowerCase();
    $scope.User = _index.MeRepository.getMyUser();
    $scope.screenshotSelected = false;
    $scope.tab = 'screenshots';
    $scope.appId = queryParams.appId || $stateParams.resourceId;

    $scope.app = _index.AppIntegrationsRepository.getById($scope.appId);
    $scope.deviceData = _index2.DevicesProcessor.getAll();

    $scope.close = function (newState) {

        var currentState = void 0;
        if (!newState) {

            currentState = $state.current.name;
            newState = currentState.substr(0, currentState.indexOf('.ltb'));
        }
        $state.go(newState);
    };

    if ($stateParams.modal) {

        $stateParams.modal.result.then(function () {}, function () {

            $scope.close();
        });
    }

    $scope.init = function () {

        // redirect to dashboard if the service is not active
        if (!$scope.app) {

            $scope.close();
            return;
        }

        _RFC2.default.send('ConnectWeb Store Product Card Open', {
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName')
        });

        $scope.features = $scope.app.attributes.resource.oeFeatures;
    };

    $scope.backScreen = function () {

        $scope.screenshotSelected = false;
    };

    $scope.loadPictures = function () {

        angular.element('.screenshots-cnt img').on('click', function () {

            $scope.screenshotSelected = true;
            if (!angular.element(this).hasClass('big-pic')) {

                angular.element('.big-pic').remove();
                angular.element('.screenshots-cnt img').removeClass('selected');
                angular.element(this).addClass('selected');
                angular.element('.screenshots-cnt').append('<img class="big-pic" src="' + this.src + '" />');
            }
        });
        angular.element('.screenshots-cnt img').on('mouseover', function () {

            if ($scope.screenshotSelected === true) {

                if (!angular.element(this).hasClass('big-pic')) {

                    angular.element('.big-pic').remove();
                    angular.element('.screenshots-cnt img').removeClass('selected');
                    angular.element(this).addClass('selected');
                    angular.element('.screenshots-cnt').append('<img class="big-pic" src="' + this.src + '" />');
                }
            }
        });
    };

    /**
    * Open cart iframe
    *
    * @param {String} appId Service id
    */
    $scope.buy = function (appId) {

        _RFC2.default.send('ConnectWeb Store Buy Click', {
            'Product ID': appId
        });

        $state.go('root.dashboard.store.ltb.buy', {
            ltb: 'payment-cart',
            resourceId: appId,
            subsource: 'store',
            promotion: true
        }, {
            reload: false
        });
    };

    $scope.onTabClick = function (tabName) {

        $scope.tab = tabName;

        _RFC2.default.send('ConnectWeb ' + tabName + ' Click', {
            Page: 'Store Product Card',
            Product: Util.deepFind($scope.app, 'attributes.resource.oeName')
        });
    };

    $scope.init();
}]); /* eslint func-names: 0 */

/***/ }),

/***/ "IAQu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
     * @ngdoc directive
     * @name directives.$focus
     *
     * @description
     * Listens for a `focus` event and focuses its element
     * if the event is for it
     */
angular.module('directives').directive('focus', function () {
    return function (scope, elem, attrs) {

        scope.$on('focus', function (e, name) {

            if (attrs.focus === name) {

                elem[0].focus();
            }
        });
    };
});

/***/ }),

/***/ "ICfp":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("JzEn"),
    listCacheDelete = __webpack_require__("5e2f"),
    listCacheGet = __webpack_require__("qACu"),
    listCacheHas = __webpack_require__("LgeR"),
    listCacheSet = __webpack_require__("G8aX");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "IDO2":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var BRUTEFORCE_CARDINALITY, MIN_GUESSES_BEFORE_GROWING_SEQUENCE, MIN_SUBMATCH_GUESSES_MULTI_CHAR, MIN_SUBMATCH_GUESSES_SINGLE_CHAR, adjacency_graphs, calc_average_degree, k, scoring, v;

adjacency_graphs = __webpack_require__("NQhb");

calc_average_degree = function(graph) {
  var average, k, key, n, neighbors, v;
  average = 0;
  for (key in graph) {
    neighbors = graph[key];
    average += ((function() {
      var len, o, results;
      results = [];
      for (o = 0, len = neighbors.length; o < len; o++) {
        n = neighbors[o];
        if (n) {
          results.push(n);
        }
      }
      return results;
    })()).length;
  }
  average /= ((function() {
    var results;
    results = [];
    for (k in graph) {
      v = graph[k];
      results.push(k);
    }
    return results;
  })()).length;
  return average;
};

BRUTEFORCE_CARDINALITY = 10;

MIN_GUESSES_BEFORE_GROWING_SEQUENCE = 10000;

MIN_SUBMATCH_GUESSES_SINGLE_CHAR = 10;

MIN_SUBMATCH_GUESSES_MULTI_CHAR = 50;

scoring = {
  nCk: function(n, k) {
    var d, o, r, ref;
    if (k > n) {
      return 0;
    }
    if (k === 0) {
      return 1;
    }
    r = 1;
    for (d = o = 1, ref = k; 1 <= ref ? o <= ref : o >= ref; d = 1 <= ref ? ++o : --o) {
      r *= n;
      r /= d;
      n -= 1;
    }
    return r;
  },
  log10: function(n) {
    return Math.log(n) / Math.log(10);
  },
  log2: function(n) {
    return Math.log(n) / Math.log(2);
  },
  factorial: function(n) {
    var f, i, o, ref;
    if (n < 2) {
      return 1;
    }
    f = 1;
    for (i = o = 2, ref = n; 2 <= ref ? o <= ref : o >= ref; i = 2 <= ref ? ++o : --o) {
      f *= i;
    }
    return f;
  },
  most_guessable_match_sequence: function(password, matches, _exclude_additive) {
    var _, bruteforce_update, guesses, k, l, len, len1, len2, lst, m, make_bruteforce_match, matches_by_j, n, o, optimal, optimal_l, optimal_match_sequence, q, ref, ref1, u, unwind, update, w;
    if (_exclude_additive == null) {
      _exclude_additive = false;
    }
    n = password.length;
    matches_by_j = (function() {
      var o, ref, results;
      results = [];
      for (_ = o = 0, ref = n; 0 <= ref ? o < ref : o > ref; _ = 0 <= ref ? ++o : --o) {
        results.push([]);
      }
      return results;
    })();
    for (o = 0, len = matches.length; o < len; o++) {
      m = matches[o];
      matches_by_j[m.j].push(m);
    }
    for (q = 0, len1 = matches_by_j.length; q < len1; q++) {
      lst = matches_by_j[q];
      lst.sort(function(m1, m2) {
        return m1.i - m2.i;
      });
    }
    optimal = {
      m: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })(),
      pi: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })(),
      g: (function() {
        var ref, results, u;
        results = [];
        for (_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u) {
          results.push({});
        }
        return results;
      })()
    };
    update = (function(_this) {
      return function(m, l) {
        var competing_g, competing_l, g, k, pi, ref;
        k = m.j;
        pi = _this.estimate_guesses(m, password);
        if (l > 1) {
          pi *= optimal.pi[m.i - 1][l - 1];
        }
        g = _this.factorial(l) * pi;
        if (!_exclude_additive) {
          g += Math.pow(MIN_GUESSES_BEFORE_GROWING_SEQUENCE, l - 1);
        }
        ref = optimal.g[k];
        for (competing_l in ref) {
          competing_g = ref[competing_l];
          if (competing_l > l) {
            continue;
          }
          if (competing_g <= g) {
            return;
          }
        }
        optimal.g[k][l] = g;
        optimal.m[k][l] = m;
        return optimal.pi[k][l] = pi;
      };
    })(this);
    bruteforce_update = (function(_this) {
      return function(k) {
        var i, l, last_m, ref, results, u;
        m = make_bruteforce_match(0, k);
        update(m, 1);
        results = [];
        for (i = u = 1, ref = k; 1 <= ref ? u <= ref : u >= ref; i = 1 <= ref ? ++u : --u) {
          m = make_bruteforce_match(i, k);
          results.push((function() {
            var ref1, results1;
            ref1 = optimal.m[i - 1];
            results1 = [];
            for (l in ref1) {
              last_m = ref1[l];
              l = parseInt(l);
              if (last_m.pattern === 'bruteforce') {
                continue;
              }
              results1.push(update(m, l + 1));
            }
            return results1;
          })());
        }
        return results;
      };
    })(this);
    make_bruteforce_match = (function(_this) {
      return function(i, j) {
        return {
          pattern: 'bruteforce',
          token: password.slice(i, +j + 1 || 9e9),
          i: i,
          j: j
        };
      };
    })(this);
    unwind = (function(_this) {
      return function(n) {
        var candidate_g, candidate_l, g, k, l, optimal_match_sequence, ref;
        optimal_match_sequence = [];
        k = n - 1;
        l = void 0;
        g = Infinity;
        ref = optimal.g[k];
        for (candidate_l in ref) {
          candidate_g = ref[candidate_l];
          if (candidate_g < g) {
            l = candidate_l;
            g = candidate_g;
          }
        }
        while (k >= 0) {
          m = optimal.m[k][l];
          optimal_match_sequence.unshift(m);
          k = m.i - 1;
          l--;
        }
        return optimal_match_sequence;
      };
    })(this);
    for (k = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; k = 0 <= ref ? ++u : --u) {
      ref1 = matches_by_j[k];
      for (w = 0, len2 = ref1.length; w < len2; w++) {
        m = ref1[w];
        if (m.i > 0) {
          for (l in optimal.m[m.i - 1]) {
            l = parseInt(l);
            update(m, l + 1);
          }
        } else {
          update(m, 1);
        }
      }
      bruteforce_update(k);
    }
    optimal_match_sequence = unwind(n);
    optimal_l = optimal_match_sequence.length;
    if (password.length === 0) {
      guesses = 1;
    } else {
      guesses = optimal.g[n - 1][optimal_l];
    }
    return {
      password: password,
      guesses: guesses,
      guesses_log10: this.log10(guesses),
      sequence: optimal_match_sequence
    };
  },
  estimate_guesses: function(match, password) {
    var estimation_functions, guesses, min_guesses;
    if (match.guesses != null) {
      return match.guesses;
    }
    min_guesses = 1;
    if (match.token.length < password.length) {
      min_guesses = match.token.length === 1 ? MIN_SUBMATCH_GUESSES_SINGLE_CHAR : MIN_SUBMATCH_GUESSES_MULTI_CHAR;
    }
    estimation_functions = {
      bruteforce: this.bruteforce_guesses,
      dictionary: this.dictionary_guesses,
      spatial: this.spatial_guesses,
      repeat: this.repeat_guesses,
      sequence: this.sequence_guesses,
      regex: this.regex_guesses,
      date: this.date_guesses
    };
    guesses = estimation_functions[match.pattern].call(this, match);
    match.guesses = Math.max(guesses, min_guesses);
    match.guesses_log10 = this.log10(match.guesses);
    return match.guesses;
  },
  bruteforce_guesses: function(match) {
    var guesses, min_guesses;
    guesses = Math.pow(BRUTEFORCE_CARDINALITY, match.token.length);
    if (guesses === Number.POSITIVE_INFINITY) {
      guesses = Number.MAX_VALUE;
    }
    min_guesses = match.token.length === 1 ? MIN_SUBMATCH_GUESSES_SINGLE_CHAR + 1 : MIN_SUBMATCH_GUESSES_MULTI_CHAR + 1;
    return Math.max(guesses, min_guesses);
  },
  repeat_guesses: function(match) {
    return match.base_guesses * match.repeat_count;
  },
  sequence_guesses: function(match) {
    var base_guesses, first_chr;
    first_chr = match.token.charAt(0);
    if (first_chr === 'a' || first_chr === 'A' || first_chr === 'z' || first_chr === 'Z' || first_chr === '0' || first_chr === '1' || first_chr === '9') {
      base_guesses = 4;
    } else {
      if (first_chr.match(/\d/)) {
        base_guesses = 10;
      } else {
        base_guesses = 26;
      }
    }
    if (!match.ascending) {
      base_guesses *= 2;
    }
    return base_guesses * match.token.length;
  },
  MIN_YEAR_SPACE: 20,
  REFERENCE_YEAR: new Date().getFullYear(),
  regex_guesses: function(match) {
    var char_class_bases, year_space;
    char_class_bases = {
      alpha_lower: 26,
      alpha_upper: 26,
      alpha: 52,
      alphanumeric: 62,
      digits: 10,
      symbols: 33
    };
    if (match.regex_name in char_class_bases) {
      return Math.pow(char_class_bases[match.regex_name], match.token.length);
    } else {
      switch (match.regex_name) {
        case 'recent_year':
          year_space = Math.abs(parseInt(match.regex_match[0]) - this.REFERENCE_YEAR);
          year_space = Math.max(year_space, this.MIN_YEAR_SPACE);
          return year_space;
      }
    }
  },
  date_guesses: function(match) {
    var guesses, year_space;
    year_space = Math.max(Math.abs(match.year - this.REFERENCE_YEAR), this.MIN_YEAR_SPACE);
    guesses = year_space * 365;
    if (match.separator) {
      guesses *= 4;
    }
    return guesses;
  },
  KEYBOARD_AVERAGE_DEGREE: calc_average_degree(adjacency_graphs.qwerty),
  KEYPAD_AVERAGE_DEGREE: calc_average_degree(adjacency_graphs.keypad),
  KEYBOARD_STARTING_POSITIONS: ((function() {
    var ref, results;
    ref = adjacency_graphs.qwerty;
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(k);
    }
    return results;
  })()).length,
  KEYPAD_STARTING_POSITIONS: ((function() {
    var ref, results;
    ref = adjacency_graphs.keypad;
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(k);
    }
    return results;
  })()).length,
  spatial_guesses: function(match) {
    var L, S, U, d, guesses, i, j, o, possible_turns, q, ref, ref1, ref2, ref3, s, shifted_variations, t, u;
    if ((ref = match.graph) === 'qwerty' || ref === 'dvorak') {
      s = this.KEYBOARD_STARTING_POSITIONS;
      d = this.KEYBOARD_AVERAGE_DEGREE;
    } else {
      s = this.KEYPAD_STARTING_POSITIONS;
      d = this.KEYPAD_AVERAGE_DEGREE;
    }
    guesses = 0;
    L = match.token.length;
    t = match.turns;
    for (i = o = 2, ref1 = L; 2 <= ref1 ? o <= ref1 : o >= ref1; i = 2 <= ref1 ? ++o : --o) {
      possible_turns = Math.min(t, i - 1);
      for (j = q = 1, ref2 = possible_turns; 1 <= ref2 ? q <= ref2 : q >= ref2; j = 1 <= ref2 ? ++q : --q) {
        guesses += this.nCk(i - 1, j - 1) * s * Math.pow(d, j);
      }
    }
    if (match.shifted_count) {
      S = match.shifted_count;
      U = match.token.length - match.shifted_count;
      if (S === 0 || U === 0) {
        guesses *= 2;
      } else {
        shifted_variations = 0;
        for (i = u = 1, ref3 = Math.min(S, U); 1 <= ref3 ? u <= ref3 : u >= ref3; i = 1 <= ref3 ? ++u : --u) {
          shifted_variations += this.nCk(S + U, i);
        }
        guesses *= shifted_variations;
      }
    }
    return guesses;
  },
  dictionary_guesses: function(match) {
    var reversed_variations;
    match.base_guesses = match.rank;
    match.uppercase_variations = this.uppercase_variations(match);
    match.l33t_variations = this.l33t_variations(match);
    reversed_variations = match.reversed && 2 || 1;
    return match.base_guesses * match.uppercase_variations * match.l33t_variations * reversed_variations;
  },
  START_UPPER: /^[A-Z][^A-Z]+$/,
  END_UPPER: /^[^A-Z]+[A-Z]$/,
  ALL_UPPER: /^[^a-z]+$/,
  ALL_LOWER: /^[^A-Z]+$/,
  uppercase_variations: function(match) {
    var L, U, chr, i, len, o, q, ref, ref1, regex, variations, word;
    word = match.token;
    if (word.match(this.ALL_LOWER) || word.toLowerCase() === word) {
      return 1;
    }
    ref = [this.START_UPPER, this.END_UPPER, this.ALL_UPPER];
    for (o = 0, len = ref.length; o < len; o++) {
      regex = ref[o];
      if (word.match(regex)) {
        return 2;
      }
    }
    U = ((function() {
      var len1, q, ref1, results;
      ref1 = word.split('');
      results = [];
      for (q = 0, len1 = ref1.length; q < len1; q++) {
        chr = ref1[q];
        if (chr.match(/[A-Z]/)) {
          results.push(chr);
        }
      }
      return results;
    })()).length;
    L = ((function() {
      var len1, q, ref1, results;
      ref1 = word.split('');
      results = [];
      for (q = 0, len1 = ref1.length; q < len1; q++) {
        chr = ref1[q];
        if (chr.match(/[a-z]/)) {
          results.push(chr);
        }
      }
      return results;
    })()).length;
    variations = 0;
    for (i = q = 1, ref1 = Math.min(U, L); 1 <= ref1 ? q <= ref1 : q >= ref1; i = 1 <= ref1 ? ++q : --q) {
      variations += this.nCk(U + L, i);
    }
    return variations;
  },
  l33t_variations: function(match) {
    var S, U, chr, chrs, i, o, p, possibilities, ref, ref1, subbed, unsubbed, variations;
    if (!match.l33t) {
      return 1;
    }
    variations = 1;
    ref = match.sub;
    for (subbed in ref) {
      unsubbed = ref[subbed];
      chrs = match.token.toLowerCase().split('');
      S = ((function() {
        var len, o, results;
        results = [];
        for (o = 0, len = chrs.length; o < len; o++) {
          chr = chrs[o];
          if (chr === subbed) {
            results.push(chr);
          }
        }
        return results;
      })()).length;
      U = ((function() {
        var len, o, results;
        results = [];
        for (o = 0, len = chrs.length; o < len; o++) {
          chr = chrs[o];
          if (chr === unsubbed) {
            results.push(chr);
          }
        }
        return results;
      })()).length;
      if (S === 0 || U === 0) {
        variations *= 2;
      } else {
        p = Math.min(U, S);
        possibilities = 0;
        for (i = o = 1, ref1 = p; 1 <= ref1 ? o <= ref1 : o >= ref1; i = 1 <= ref1 ? ++o : --o) {
          possibilities += this.nCk(U + S, i);
        }
        variations *= possibilities;
      }
    }
    return variations;
  }
};

module.exports = scoring;

//# sourceMappingURL=scoring.js.map


/***/ }),

/***/ "IK18":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFCSession = __webpack_require__("DyxV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name controllers.BaseAuth
 *
 * @description
 * The base controller of the auth section.
 * It is the parent controller of login, forgot, reset, signup sections
 */
angular.module('controllers').controller('BaseAuth', ['$scope', '$rootScope', 'Facebook', 'Google', 'Auth', 'AppleIDService', '$window', function ($scope, $rootScope, Facebook, Google, Auth, AppleIDService, $window) {

    $rootScope.State.finishedLoadingAnimation = true;
    $scope.browserName = $window.browserName.toLowerCase();

    var initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));

    if (initialUrl.indexOf('action=login_reactivate_license') > -1) {

        $scope.showReactivateLogin = true;
        Auth.gotoLogin();
        $scope.cancelReactivateLicense = function () {

            if (window.external && 'CloseHtml' in window.external) {

                window.external.CloseHtml('cancel reactivate license');
            }
        };
    }

    if (localStorage.getItem('theme') === 'dark') {

        $rootScope.State.theme = 'dark';
    } else {

        $rootScope.State.theme = 'light';
    }

    if (window.external && 'CloseHtml' in window.external) {

        $rootScope.State.isFromSpotlightWebApp = 'spotlight';
    }

    _recaptcha2.default.init();

    $scope.Recaptcha = _recaptcha2.default;

    // facebook config
    $scope.fb = {
        feature: CWCONFIG.features.facebook,
        loaded: false
    };

    // google plus config
    $scope.gplus = {
        feature: CWCONFIG.features.google,
        loaded: false
    };

    // Apple ID config
    $scope.appleID = {
        feature: CWCONFIG.features.appleID,
        loaded: false,
        inProgress: false
    };

    /**
     * @description
     * Facebook authenticate method.
     */
    $scope.fb.authenticate = function (page) {

        // initiate facebook service only when the user clicks on the button
        if ($scope.fb.loaded === false) {

            Facebook.init();

            Facebook.loaded().then(function () {

                $scope.fb.loaded = true;
                executeFacebookLogin(page);
            });
        } else {

            // if the scripts are loaded, execute only the login function
            executeFacebookLogin(page);
        }
    };

    function executeFacebookLogin(page) {

        Auth.loginType = 'Facebook'; // Login type for mixpanel event

        _RFC2.default.send('ConnectWeb Facebook Click', {
            Page: 'Auth ' + page
        });

        Facebook.login(function (response) {

            if (response.authResponse) {

                Auth.loginWithFacebook(response.authResponse, page);
            }
        }, {
            scope: 'email'
        });
    }

    /**
     * @description
     * Google authenticate method.
     */
    $scope.gplus.authenticate = function (page) {

        // initiate google service only when the user clicks on the button
        if ($scope.gplus.loaded === false) {

            Google.init();

            Google.loaded().then(function () {

                $scope.gplus.loaded = true;
                executeGoogleLogin(page);
            });
        } else {

            // if the scripts are loaded, execute only the login function
            executeGoogleLogin(page);
        }
    };

    function executeGoogleLogin(page) {

        Auth.loginType = 'Google Plus'; // Login type for mixpanel event

        _RFC2.default.send('ConnectWeb Google Plus Click', {
            Page: 'Auth ' + page
        });

        Google.login().then(function (response) {

            Auth.loginWithGooglePlus(response, page);
        });
    }

    $scope.setCaptchaResponse = function (response) {

        _recaptcha2.default.setCaptchaResponse(response);
    };

    // Apple ID Authentication
    $scope.appleID.authenticate = function (page) {

        Auth.loginType = 'Apple ID';

        _RFC2.default.send('ConnectWeb Apple ID Click', {
            Page: 'Auth ' + page
        });

        // initiate google service only when the user clicks on the button
        if ($scope.appleID.loaded === false) {

            AppleIDService.init().then(function () {

                document.addEventListener('AppleIDSignInOnSuccess', function (data) {

                    Auth.loginWithAppleID(data.detail.authorization.code, page);
                });

                // Listen for authorization failures
                document.addEventListener('AppleIDSignInOnFailure', function (error) {

                    _loggers2.default.debug({
                        type: 'Apple Error - ' + error.detail.error,
                        data: {}
                    });
                });

                $scope.appleID.loaded = true;
                $window.AppleID.auth.signIn();
            }).catch(function () {

                _RFC4.default.error('cw.notification.system.error');
                $scope.appleID.inProgress = false;
            });
        } else {

            // if the scripts are loaded, execute only the login function
            $window.AppleID.auth.signIn();
        }
    };
}]);

/***/ }),

/***/ "IKj1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('listeners').service('LicenseListener', function () {

    _RFC2.default.subscribe('socket:licenses', function (response) {

        if (response.verb === 'POST') {

            _index.LicensesRepository.add(response.payload.data);
        }

        if (response.verb === 'PUT') {

            _index.LicensesRepository.update(response.payload.data);
        }

        if (response.verb === 'DELETE') {

            if (response.payload.data.id) {

                // Get the license that will be deleted
                var licenseToBeDeleted = _index.LicensesRepository.getLicenseById(response.payload.data.id);

                if (licenseToBeDeleted) {

                    // Get the activation code that will be deleted
                    var activationCodeToBeDeleted = licenseToBeDeleted.relationships['activation-code'].data.id;

                    // Delete the activvation code from the repository
                    _index.ActivationCodesRepository.deleteActivationCodeById(activationCodeToBeDeleted);
                }

                // Delete the license code from the repository
                _index.LicensesRepository.deleteLicenseById(response.payload.data.id);
            }
        }
    });
});

/***/ }),

/***/ "IRPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */

var _serviceDependencies = ['$http', '$scope', 'Util', '$rootScope'];

var DwmToggleMonitoring = function DwmToggleMonitoring($http, $scope, Util, $rootScope) {
    _classCallCheck(this, DwmToggleMonitoring);

    var aviraToken = Util.getToken();

    $scope.disableMonitoring = function () {

        $scope.activateLicensePending = true;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            'Button Label': 'Deactivate',
            Modal: 'AIA Monitoring'
        });

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.enrollURL,
            headers: {
                Authorization: 'Bearer ' + aviraToken
            },
            data: {
                clientApplication: {
                    clientId: 'myavira'
                }
            }

        }).then(function () {

            $scope.activateLicensePending = false;
            Util.closeModal();
            $rootScope.aiaStatusApiCall('triggerPendingState');
        }).catch(function (errResponse) {

            $scope.activateLicensePending = false;
            _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                message: {
                    brandname: CWCONFIG.partnerConfig.name,
                    url: '/dashboard/support/tabs/support'
                }
            });

            _RFC4.default.send('ConnectWeb AIA Error', {
                Detail: 'deactivate',
                ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                ErrorMessage: errResponse.data ? errResponse.data.message : 'N/A',
                ErrorDescription: errResponse.data ? errResponse.data.error_description : 'N/A',
                ErrorTrackId: errResponse.data ? errResponse.data.trackId : 'N/A',
                ErrorStatus: errResponse.data ? errResponse.data.status : 'N/A'
            });
        });
    };

    $scope.cancel = function () {

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            'Button Label': 'Cancel',
            Modal: 'AIA Monitoring'
        });

        Util.closeModal();
    };
};

_serviceDependencies.push(DwmToggleMonitoring);

angular.module('controllers').controller('DwmToggleMonitoring', _serviceDependencies);

/***/ }),

/***/ "IY0V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.DeviceRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/

var DeviceRestService = function (_BaseRestService) {
    _inherits(DeviceRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function DeviceRestService($http, $q, Util) {
        _classCallCheck(this, DeviceRestService);

        return _possibleConstructorReturn(this, (DeviceRestService.__proto__ || Object.getPrototypeOf(DeviceRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceRestService#create
     * @methodOf rest.services.DeviceRestService
     * @function
     *
     * @description
     * Creates a device.
     *
     * @param {object} devicePayload Device payload
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(DeviceRestService, [{
        key: 'create',
        value: function create(devicePayload) {

            return _get(DeviceRestService.prototype.__proto__ || Object.getPrototypeOf(DeviceRestService.prototype), 'create', this).call(this, devicePayload, 'devices/');
        }

        /**
         * @ngdoc function
         * @name rest.services.DeviceRestService#update
         * @methodOf rest.services.DeviceRestService
         * @function
         *
         * @description
         * Updates a device.
         *
         * @param {number} deviceId Device identifier
         * @param {object} devicePayload Device payload
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(deviceId, devicePayload) {

            return _get(DeviceRestService.prototype.__proto__ || Object.getPrototypeOf(DeviceRestService.prototype), 'update', this).call(this, deviceId, devicePayload, 'devices/');
        }

        /**
         * @ngdoc function
         * @name rest.services.DeviceRestService#remove
         * @methodOf rest.services.DeviceRestService
         * @function
         *
         * @description
         * Remove a device.
         *
         * @param {number} deviceId Device identifier
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'remove',
        value: function remove(deviceId) {

            return _get(DeviceRestService.prototype.__proto__ || Object.getPrototypeOf(DeviceRestService.prototype), 'remove', this).call(this, deviceId, 'devices/');
        }

        /**
         * @ngdoc function
         * @name rest.services.DeviceRestService#getAllAsync
         * @methodOf rest.services.DeviceRestService
         * @function
         *
         * @description
         * Retrieves all devices.
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(DeviceRestService.prototype.__proto__ || Object.getPrototypeOf(DeviceRestService.prototype), 'getAllAsync', this).call(this, 'devices/');
        }
    }]);

    return DeviceRestService;
}(_baseRestService2.default);

exports.default = DeviceRestService;


_serviceDependencies.push(DeviceRestService);

angular.module('rest.services').service('DeviceRestService', _serviceDependencies);

/***/ }),

/***/ "IfBK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$rootScope', 'Util'];

var CryptoWalletController = function CryptoWalletController($scope, $state, $rootScope, Util) {
    _classCallCheck(this, CryptoWalletController);

    $scope.currency = $rootScope.cryptoCurrency;
    var user = _index.MeRepository.getMyUser();
    $scope.tfaValidationStep = user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
    var dateTFAactivated = user.attributes.date_tfa_activated;
    $scope.customToFixed = Util.toFixed;

    var getDateDifference = function getDateDifference(date) {

        var now = moment();
        var end = moment(date);
        var duration = moment.duration(now.diff(end));
        var days = Util.toFixed(duration.asHours(), 2);
        return days;
    };

    if (dateTFAactivated) {

        if (parseFloat(getDateDifference(dateTFAactivated)) > 24) {

            $scope.showWithdrawButton = true;
            $scope.showTimeNotification = false;
        } else {

            $scope.showWithdrawButton = false;
            $scope.showTimeNotification = true;
        }
    } else if (!dateTFAactivated && $scope.tfaValidationStep === 'tfaEnabled') {

        $scope.showWithdrawButton = true;
    }

    $scope.changeCurrency = function (currency) {

        $scope.currency = currency;
        $rootScope.cryptoCurrency = $scope.currency;
        localStorage.setItem('CryptoCurrency', $scope.currency);

        $scope.ethPrice = Util.toFixed($scope.prices.conversionRateMap[$scope.currency], 2);
        $scope.getBalances($scope.wallets);
    };

    $scope.connectCoinbase = function () {

        _RFC2.default.send('ConnectWeb Crypto Click', {
            Label: 'Withdraw'
        });

        $state.go('root.dashboard.crypto.ltb', {
            ltb: 'coinbase-account'
        });
    };

    // Calculate overall Balances
    $scope.getBalances = function (data) {

        var cryptoCurrencies = [];
        var moneyBalance = 0;
        var cryptoBalance = 0;
        Object.keys(data).forEach(function (key) {

            moneyBalance += $scope.prices.conversionRateMap[$scope.currency] * data[key].balance;
            cryptoBalance += data[key].balance;
            cryptoCurrencies.push(key);
        });

        $scope.moneyBalance = '' + Util.toFixed(moneyBalance, 2);
        $rootScope.moneyBalance = $scope.moneyBalance;
        $scope.cryptoBalance = '' + Util.toFixed(cryptoBalance, 6);
        $rootScope.cryptoBalance = $scope.cryptoBalance;
        $scope.cryptoCurrencies = cryptoCurrencies;
    };

    $scope.updateWallet = function () {

        $scope.wallets = _index.CryptoRepository.getAll('wallets') || {};
        $scope.prices = _index.CryptoRepository.getAll('prices') || {};
        if ($scope.prices.conversionRateMap) {

            $scope.currencies = Object.keys($scope.prices.conversionRateMap).sort();
            $scope.ethPrice = Util.toFixed($scope.prices.conversionRateMap[$scope.currency], 2);
        }

        if (Object.keys($scope.wallets).length > 0) {

            $scope.getBalances($scope.wallets);
        }
    };

    $scope.updateWallet();

    var onCryptoDataNext = function onCryptoDataNext() {

        $scope.updateWallet();
    };

    this.cryptoRepository = _index.CryptoRepository.getObservable();
    this.cryptoSubscriber = this.cryptoRepository.subscribe(function (data) {
        return onCryptoDataNext(data);
    }, function () {}, function () {});

    $scope.goToTFA = function () {

        $rootScope.isComingFromCrypto = true;
    };
};

var CryptoWalletDirective = function CryptoWalletDirective() {
    _classCallCheck(this, CryptoWalletDirective);

    this.template = __webpack_require__("jhMV");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $rootScope, Util) {
        return new CryptoWalletController($scope, $state, $rootScope, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'CryptoWalletCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoWalletDirective();
});

angular.module('directives').directive('cryptoWallet', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "Iq1o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var me = void 0;
var observableMe = new Rx.BehaviorSubject(me);

/**
     * @ngdoc service
     * @name repositories.MeRepository
     *
     * @description
     * MeRepository.
     */
var MeRepository = {

    /**
         * @ngdoc function
         * @name repositories.MeRepository#replace
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored users with provided data.
         *
         * @param {object} data, current logged user.
        */
    replace: function replace(data) {

        me = data;
        observableMe.onNext(me);
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#update
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to update the current logged user from repository.
         *
         * @param {object} data, object with new values.
        */
    update: function update(data) {

        me = me || {};
        me.data = data;
        observableMe.onNext(me);
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyUser
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user from repository.
         *
         * @returns {object} current logged user data.
        */
    getMyUser: function getMyUser() {

        return _RFCUtil2.default.deepFind(me, 'data');
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyId
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user id from repository.
         *
         * @returns {number} current logged user id.
        */
    getMyId: function getMyId() {

        return _RFCUtil2.default.deepFind(me, 'data.id');
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyEmail
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive current logged user email from repository.
         *
         * @returns {string} current logged user email.
        */
    getMyEmail: function getMyEmail() {

        return _RFCUtil2.default.deepFind(me, 'data.attributes.email');
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyaUrl
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive Mya Url from repository.
         *
         * @returns {string} MyaURL
        */
    getMyaUrl: function getMyaUrl() {

        return _RFCUtil2.default.deepFind(me, 'meta.mya_url');
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getMyaHash
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to retrive Mya Hash from repository.
         *
         * @returns {string} MyaHash
        */
    getMyaHash: function getMyaHash() {

        return _RFCUtil2.default.deepFind(me, 'meta.mya_hash');
    },


    /**
         * @ngdoc function
         * @name repositories.MeRepository#getObservable
         * @methodOf repositories.MeRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for me repository.
         * @returns {Object} an observable object for me repository.
        */
    getObservable: function getObservable() {

        return observableMe;
    }
};

exports.default = MeRepository;

/***/ }),

/***/ "J6bV":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox-toggle-monitoring\">\n    <div class=\"text-center\">\n        <i class=\"icon icon-dwm icon-xs mb30\"></i>\n        <h2 class=\"inline-block text-xxl v-middle text-grey-3 mb10\" translate=\"cw.dwm.deactivate_modal.title\"></h2>\n        <p class=\"text-grey-3 text-s mb30\" translate=\"cw.dwm.deactivate_modal.description\"></p>\n        <div class=\"buttons\">\n            <button class=\"btn btn-secondary btn-medium mlr10\" ng-click=\"cancel()\"\n                translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium mlr10\" ng-click=\"disableMonitoring()\"\n                ng-class=\"{'spin-loader': activateLicensePending}\" ng-disabled=\"activateLicensePending\"\n                translate=\"cw.dwm.deactivate_modal.deactivate\" connect-qa-action=\"deactivate\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/toggle-monitoring/toggle-monitoring.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "J7wN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/objectSpread.js

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("FlpK");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (typeof_default()(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/i18next/dist/esm/i18next.js









var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var i18next_Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new i18next_Logger();

var i18next_EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function i18next_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (typeof mix === 'string') return mix;
      if (p && typeof mix[p] === 'string') return mix[p];
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var i18next_ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      i18next_EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(i18next_EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var i18next_Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      i18next_EventEmitter.call(_assertThisInitialized(_this));
    }

    i18next_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread({}, options, {
          interpolation: _objectSpread({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(i18next_EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var i18next_LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var i18next_PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var i18next_Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var i18next_Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      i18next_EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(i18next_EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var i18next_I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      i18next_EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new i18next_LanguageUtil(this.options);
        this.store = new i18next_ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new i18next_PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new i18next_Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new i18next_Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new i18next_Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new i18next_Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(i18next_EventEmitter);

var i18next = new i18next_I18n();

/* harmony default export */ var esm_i18next = __webpack_exports__["default"] = (i18next);


/***/ }),

/***/ "JHUs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("onJI");

__webpack_require__("VtEJ");

__webpack_require__("iw+y");

__webpack_require__("yA7R");

__webpack_require__("//V8");

__webpack_require__("fk3e");

__webpack_require__("IY0V");

__webpack_require__("Cj2j");

__webpack_require__("KI5/");

__webpack_require__("NXX9");

__webpack_require__("jb5T");

__webpack_require__("oKEH");

__webpack_require__("vlgB");

__webpack_require__("axOg");

__webpack_require__("3Pqa");

__webpack_require__("KF23");

__webpack_require__("1RFZ");

__webpack_require__("cxqI");

__webpack_require__("52y7");

__webpack_require__("rZS/");

__webpack_require__("G/k0");

__webpack_require__("OSI/");

__webpack_require__("vKGA");

__webpack_require__("TxrT");

__webpack_require__("shbC");

__webpack_require__("qubf");

__webpack_require__("OweZ");

__webpack_require__("e4WZ");

/***/ }),

/***/ "JLYd":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content add-payment-modal\" connectqa-modal=\"add-payment\">\n\n    <!-- Confirmation MODAL -->\n    <div class=\"addpayment-confirmation\" ng-hide=\"showCartIframe || cartIframeReady\" connectqa-addpayment=\"confirmation-modal\">\n        <div class=\"modal-image\" connectqa-addpayment=\"confirmation-icon\"></div>\n        <h2 class=\"text-xxl text-grey-3 font-regular mt20 mb20\" translate=\"cw.add_payment.confirmation.title\" connectqa-addpayment=\"confirmation-title\"></h2>\n        <div class=\"text-s text-grey-4 mb30\" translate=\"cw.add_payment.confirmation.sub_title\" connectqa-addpayment=\"confirmation-description\"></div>\n\n        <div class=\"mb40 features\" connectqa-addpayment=\"confirmation-features\">\n            <div>\n                <div class=\"feature-icon text-grey-3 feature-icon-1\" connectqa-addpayment=\"confirmation-feature1-icon\"></div>\n                <div class=\"feature-label\" translate=\"cw.add_payment.confirmation.feature1\" connectqa-addpayment=\"confirmation-feature1-label\"></div>\n            </div>\n            <div>\n                <div class=\"feature-icon text-grey-3 feature-icon-2\" connectqa-addpayment=\"confirmation-feature2-icon\"></div>\n                <div class=\"feature-label\" translate=\"cw.add_payment.confirmation.feature2\" connectqa-addpayment=\"confirmation-feature2-label\"></div>\n            </div>\n            <div>\n                <div class=\"feature-icon text-grey-3 feature-icon-3\" connectqa-addpayment=\"confirmation-feature3-icon\"></div>\n                <div class=\"feature-label\" translate=\"cw.add_payment.confirmation.feature3\" connectqa-addpayment=\"confirmation-feature3-label\"></div>\n            </div>\n        </div>\n\n        <button class=\"btn btn-medium btn-secondary mr10\" ng-click=\"closeModal()\" translate=\"cw.form.profile.cancel\" connectqa-addpayment=\"confirmation-cancel\"></button>\n        <button class=\"btn btn-medium btn-primary\" ng-click=\"confirm()\" translate=\"cw.auth.continue\" connectqa-addpayment=\"confirmation-continue\"></button>\n\n        <div class=\"confirmation-footer-label text-xs text-grey-4 mt20\" translate=\"cw.add_payment.confirmation.footer_label\" connectqa-addpayment=\"confirmation-footer\"></div>\n    </div>\n\n    <!-- LOADING -->\n    <div class=\"main-loader\" ng-if=\"showLoading\"></div>\n\n    <!-- CART IFRAME -->\n    <div id=\"iframe-holder\" class=\"iframe-holder\" ng-if=\"showCartIframe\">\n        <cart-iframe\n            width=\"iframeWidth\" height=\"iframeHeight\" url=\"shopUrl\"\n            error=\"onIframeError\"\n            iframeready=\"onIframeReady\"\n            purchasecomplete=\"onPurchaseReady\"\n            frameloaded=\"onIframeContentLoaded\"\n            getmodalwidth=\"getModalWidth\"\n        ></cart-iframe>\n    </div>\n\n    <!-- SUCCESS MODAL -->\n    <div class=\"add-payment-success\" ng-show=\"showSuccessModal\" connectqa-addpayment=\"success-modal\">\n        <div class=\"icon-success\" connectqa-addpayment=\"success-icon\"></div>\n\n        <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.add_payment.succes.title\" connectqa-addpayment=\"success-title\"></h2>\n        <p class=\"text-l text-grey-2 mb20 bold-span\" translate=\"cw.general.order_reference_number\"\n            translate-values=\"{ referenceNumber : transactionId }\" connectqa-addpayment=\"success-order-number\"></p>\n\n        <p class=\"text-s text-grey-4 mb40\" translate=\"cw.add_payment.succes.sub_title\" translate-values=\"{ brandname : brandName }\" connectqa-addpayment=\"success-description\"></p>\n\n        <div class=\"text-center mt40 mb40\">\n            <div class=\"inline-block\" connectqa-addpayment=\"success-product-support\">\n                <h6 class=\"text-m text-grey-3\"\n                    translate=\"cw.general.got_a_question\"></h6>\n                <a ui-sref=\"root.dashboard.support({tab: 'support'})\"\n                    translate=\"cw.general.avira_support\"\n                    class=\"text-s text-blue-2 internal-link\">\n                </a>\n            </div>\n        </div>\n\n        <button class=\"btn btn-large btn-primary mb20\" ng-click=\"closeModal()\" translate=\"cw.tour.user.action_done\" connectqa-addpayment=\"success-done\"></button>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/add-payment/add-payment.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "JLvu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("Zigd").default;


/***/ }),

/***/ "JT+/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listen events for User Model
 */
angular.module('listeners').service('UserListener', ['$rootScope', '$modal', '$window', function ($rootScope, $modal, $window) {

    _RFC2.default.subscribe('socket:users', function (response) {

        var userId = void 0;
        if (response.verb === 'POST') {

            _index.UsersRepository.add(response.payload.data);
        }

        if (response.verb === 'PUT') {

            userId = _index.MeRepository.getMyId();

            /* replace MeRepository with the response data if the
            userId from response is the current logged user */
            if (userId === response.payload.data.id) {

                _index.MeRepository.update(response.payload.data);
            }

            _index.UsersRepository.update(response.payload.data);
        }
    });

    // Detect user's internet connection status (online/offline)
    $rootScope.online = navigator.onLine;

    $window.addEventListener('offline', function () {

        $rootScope.$apply(function () {

            $rootScope.online = false;

            // Trigger offline modal when the user don't have internet connection
            $modal.open({
                template: __webpack_require__("u8TA"),
                controller: 'SessionExpire',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'white-modal error-modal',
                resolve: {
                    modalParams: function modalParams() {

                        return 'offline';
                    }
                }
            });
        });
    }, false);

    $window.addEventListener('online', function () {

        $rootScope.$apply(function () {

            $rootScope.online = true;
            _RFC2.default.broadcast('connection:online');
        });
    }, false);
}]);

/***/ }),

/***/ "JTpj":
/***/ (function(module, exports) {

module.exports = "<ul class=\"subscriptions recommendations-banner\" ng-show=\"showRecommendation\">\n    <li class =\"mb50\" ng-show=\"showRecommendationPrime\">\n        <div class=\"activated mb20\" ng-class=\"{'box-shot' : isYearlyPayment}\">\n\n            <div class=\"recommendation-title\">\n                <div class=\"icon-holder\" ng-if=\"!isYearlyPayment\">\n                    <img\n                        ng-if=\"recommendedProduct.attributes.resource.wsLargeImageUrl\"\n                        ng-src=\"{{recommendedProduct.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"icon-holder box-shot-holder\" ng-if=\"isYearlyPayment\">\n                    <img\n                        ng-if=\"recommendedProduct.attributes.resource.cwStoreBoxshot\"\n                        ng-src=\"{{recommendedProduct.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"v-middle inline-block\">\n                    <h1 class=\"text-xxl text-white\">{{recommendedProduct.attributes.name}}</h1>\n                    <a class=\"text-blue-2 text-m crs-pointer ml15\"\n                       ng-if=\"isYearlyPayment && showLearnMoreButton\"\n                       ng-click=\"recommendationBannerController.tryRecommendation('Learn More', 'banner_ocp_', 'banner_ocp_')\">\n                        <span>+ </span><span translate=\"cw.subscriptions.see_what_you_get\"></span>\n                    </a>\n                </div>\n            </div>\n\n            <div class=\"recommendation-action\">\n                <div class=\"cma-label-wrapper\">\n                    <p class=\"text-xxs text-white\" translate=\"cw.cma.discount_price_label_annual\"\n                        translate-values=\"{price: recommendationDetails.attributes.pc_price + recommendationDetails.attributes.currency }\"></p>\n                    <!-- Promotional Campaign: CAM disclaimer with discounted price-->\n                    <!-- <p class=\"text-xxs text-white\" ng-if=\"!$root.cmaGBapplies\"\n                        translate=\"cw.offer.generic_disclaimer_row\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers.aps10_12_1.endDate,\n                            discountedPrice: $root.welcomeOffers.aps10_12_1.discountedPrice,\n                            discountedAmount: $root.welcomeOffers.aps10_12_1.discountedAmount,\n                            firstYearPrice: $root.welcomeOffers.aps10_12_1.firstYearPrice,\n                            renewalPrice: $root.welcomeOffers.aps10_12_1.renewalPrice\n                        }\"\n                    ></p> -->\n                    <!-- <p class=\"text-xxs text-white\" ng-if=\"$root.cmaGBapplies\"\n                        translate=\"cw.offer.generic_disclaimer_uk\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers.aps10_12_1.endDate,\n                            renewalPrice: $root.welcomeOffers.aps10_12_1.renewalPrice\n                        }\"\n                    ></p> -->\n                    <!-- End of Promotional Campaign-->\n                    <a class=\"text-blue-2 text-xxs crs-pointer\" translate=\"cw.cma.subscription_details\"\n                        ng-click=\"gotoAnchor('cma-disclaimer')\"></a>\n                </div>\n\n                <button class=\"btn btn-medium btn-primary\"\n                        ng-if=\"!isYearlyPayment\"\n                        connectqa-button=\"try-for-free\"\n                        ng-click=\"recommendationBannerController.tryRecommendation('Try', 'banner_ocp_', 'banner_ocp_')\"\n                        translate=\"cw.general.buttons.try_for_free\"></button>\n\n                <button class=\"btn btn-medium btn-primary mb5\"\n                        ng-if=\"isYearlyPayment\"\n                        connectqa-button=\"upgrade\"\n                        ng-click=\"recommendationBannerController.tryRecommendation('Upgrade', 'banner_ocp_', 'banner_ocp_')\"\n                        translate=\"cw.general.upgrade_now\"></button>\n\n                <p class=\"first-month-copy text-xl text-white\"\n                   ng-if=\"!isYearlyPayment\"\n                   translate=\"cw.recommendation.free_first_month\"></p>\n\n                <div ng-if=\"isYearlyPayment\">\n                    <!-- Banner without discount -->\n                    <div ng-if=\"recommendationDetails.attributes.discount === 0\">\n                        <p class=\"first-month-copy text-l text-white\">\n                            <span translate=\"cw.ocp.yearly_price\"\n                                translate-values=\"{ price : recommendationDetails.attributes.total_price + ' ' + recommendationDetails.attributes.currency }\">\n                            </span>\n                            /\n                            <span translate=\"cw.general.devices.many\" ng-if=\"recommendationDetails.attributes.users > 1\"\n                                translate-values=\"{ total: recommendationDetails.attributes.users }\"></span>\n                            <span translate=\"cw.general.devices.one\" ng-if=\"recommendationDetails.attributes.users === 1\"></span>\n                        </p>\n\n                        <p class=\"text-m text-grey-5\">{{recommendedProduct.attributes.resource.oneLiner}}</p>\n                    </div>\n                    <!-- Banner with discount -->\n                    <div ng-if=\"recommendationDetails.attributes.discount > 0\">\n                        <p class=\"first-month-copy text-l text-white\">\n                            {{recommendationDetails.attributes.total_price + ' ' + recommendationDetails.attributes.currency}}\n                            / <span translate=\"cw.general.first_year\"></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <ul class=\"features-holder\">\n            <li ng-repeat=\"feature in recommendedProduct.attributes.resource.bannerFeatures\">\n                <div class=\"fetures-img\">\n                    <img ng-src=\"{{feature.icon}}\" />\n                </div>\n                <div class=\"features-copy\">\n                    <p class=\"text-m text-grey-5\">{{feature.description}}</p>\n                </div>\n            </li>\n        </ul>\n    </li>\n    <li class =\"mb50\" ng-show=\"showRecommendationAIA && $root.showAIAWelcomeOfferBanner\">\n        <div class=\"activated mb20\" ng-class=\"box-shot\">\n\n            <div class=\"recommendation-title\">\n                <div class=\"icon-holder box-shot-holder\">\n                    <img\n                        ng-if=\"recommendedProduct.attributes.resource.cwStoreBoxshot\"\n                        ng-src=\"{{recommendedProduct.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"v-middle inline-block\">\n                    <h1 class=\"text-xxl text-white\">{{recommendedProduct.attributes.name}}</h1>\n                    <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n                        ng-click=\"recommendationBannerController.tryRecommendation('Learn More', 'banner_ocp_', 'banner_ocp_')\"\n                        class=\"text-blue-2 text-m crs-pointer ml15 see-more-link \">\n                        <span translate=\"cw.homepage.general.see_more\"></span>\n                    </a>\n                </div>\n            </div>\n\n            <div class=\"recommendation-action\">\n                <div class=\"cma-label-wrapper\">\n                    <p class=\"text-xxs text-white\" translate=\"cw.cma.discount_price_label_annual\"\n                        translate-values=\"{price: recommendationDetails.attributes.pc_price + recommendationDetails.attributes.currency }\"></p>\n\n                    <!-- <p class=\"text-xxs text-white\" ng-if=\"!$root.cmaGBapplies\"\n                        translate=\"cw.offer.generic_disclaimer_row\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers.adwp1_12_1.endDate,\n                            discountedPrice: $root.welcomeOffers.adwp1_12_1.discountedPrice,\n                            discountedAmount: $root.welcomeOffers.adwp1_12_1.discountedAmount,\n                            firstYearPrice: $root.welcomeOffers.adwp1_12_1.firstYearPrice,\n                            renewalPrice: $root.welcomeOffers.adwp1_12_1.renewalPrice\n                        }\"\n                    ></p> -->\n                    <!-- <p class=\"text-xxs text-white\" ng-if=\"$root.cmaGBapplies\"\n                        translate=\"cw.offer.generic_disclaimer_uk\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers.adwp1_12_1.endDate,\n                            renewalPrice: $root.welcomeOffers.adwp1_12_1.renewalPrice\n                        }\" -->\n                    ></p>\n                    <a class=\"text-blue-2 text-xxs crs-pointer\" translate=\"cw.cma.subscription_details\"\n                        ng-click=\"gotoAnchor('cma-disclaimer')\"></a>\n                </div>\n\n                <button class=\"btn btn-medium btn-primary mb5\"\n                        connectqa-button=\"upgrade\"\n                        ng-click=\"recommendationBannerController.tryRecommendation('Upgrade', 'banner_ocp_', 'banner_ocp_')\"\n                        translate=\"cw.general.buy\"></button>\n\n                <div>\n                    <!-- Banner without discount -->\n                    <div ng-if=\"recommendationDetails.attributes.discount === 0\">\n                        <p class=\"first-month-copy text-l text-white\">\n                            <span translate=\"cw.ocp.yearly_price\"\n                                translate-values=\"{ price : recommendationDetails.attributes.total_price + ' ' + recommendationDetails.attributes.currency }\">\n                            </span>\n                            /\n                            <span translate=\"cw.general.devices.many\" ng-if=\"recommendationDetails.attributes.users > 1\"\n                                translate-values=\"{ total: recommendationDetails.attributes.users }\"></span>\n                            <span translate=\"cw.general.devices.one\" ng-if=\"recommendationDetails.attributes.users === 1\"></span>\n                        </p>\n\n                        <p class=\"text-m text-grey-5\">{{recommendedProduct.attributes.resource.oneLiner}}</p>\n                    </div>\n\n                    <!-- Banner with discount -->\n                    <div ng-if=\"recommendationDetails.attributes.discount > 0\">\n                        <p class=\"first-month-copy text-l text-white\">\n                            {{recommendationDetails.attributes.total_price + ' ' + recommendationDetails.attributes.currency}}\n                            / <span translate=\"cw.general.first_year\"></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <ul class=\"features-holder\">\n            <li ng-repeat=\"feature in recommendedProduct.attributes.resource.bannerFeatures\">\n                <div class=\"fetures-img\">\n                    <img ng-src=\"{{feature.icon}}\" />\n                </div>\n                <div class=\"features-copy\">\n                    <p class=\"text-m text-grey-5\">{{feature.description}}</p>\n                </div>\n            </li>\n        </ul>\n    </li>\n</ul>"

/***/ }),

/***/ "Jcyh":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-chooseDevice\">\n    <div class=\"top-elements content-wrapper\">\n\n        <div class=\"mb20\">\n            <div class=\"app-icon inline-block\">\n                <img ng-if=\"chooseDeviceDeploymentWizardCtrl.app.attributes.resource.wsLargeImageUrl\"\n                    ng-src=\"{{chooseDeviceDeploymentWizardCtrl.app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n    \n                <img ng-if=\"chooseDeviceDeploymentWizardCtrl.app.attributes.type !== 'bundle' && !chooseDeviceDeploymentWizardCtrl.app.attributes.resource.wsLargeImageUrl\"\n                    ng-src=\"{{imgPath}}/no-image.png\" />\n    \n                <img ng-if=\"chooseDeviceDeploymentWizardCtrl.app.attributes.type === 'bundle' && !chooseDeviceDeploymentWizardCtrl.app.attributes.resource.wsLargeImageUrl\"\n                    ng-src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n            </div>\n        </div>\n\n        <h2 class=\"text-xxl2 text-grey-2 mb10\" translate=\"cw.deploy.install_app\" translate-values=\"{app: chooseDeviceDeploymentWizardCtrl.app.attributes.resource.oeName}\"></h2>\n        <p class=\"text-l text-grey-2 mb30\" translate=\"cw.deploy.add_new_subtitle\" translate-values=\"{app: chooseDeviceDeploymentWizardCtrl.app.attributes.resource.oeName}\"></p>\n\n        <div class=\"content-wrapper-select\">\n            <ul>\n                <li ng-repeat=\"device in displayedDevicesList\"\n                    class=\"deploy-e\"\n                    ng-click=\"chooseDeviceDeploymentWizardCtrl.deployOn(device)\" connectqa-deploy-modal=\"{{device.attributes.type}}\">\n                    <div class=\"device-icon-holder medium-holder\">\n                        <div class=\"p-relative inline-block\">\n                            <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}} icon-grey-3 icon-l\"></i>\n                        </div>\n                    </div>\n\n                    <h2 translate=\"{{device | deviceName}}\" class=\"text-grey-3 text-m\"></h2>\n                    <div class=\"deviceStatus\" ng-class=\"{online: device.attributes.state === 'online'}\"></div>\n                </li>\n\n                <li class=\"deploy-e\" ng-click=\"chooseDeviceDeploymentWizardCtrl.addNewDeviceFromView();\" connectqa-deploy-modal=\"add-new-device\">\n                    <div class=\"device-icon-holder medium-holder\">\n                        <div class=\"p-relative inline-block\">\n                            <i class=\"icon icon-pc-phone icon-grey-3 icon-l\"></i>\n                            <i class=\"icon icon-plus icon-plus-medium icon-plus-bg-blue\"></i>\n                        </div>\n                    </div>\n\n                    <h2 class=\"text-grey-3 text-m\" translate=\"cw.deploy.new_device\"></h2>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "JiTH":
/***/ (function(module, exports) {

module.exports = "<div class=\"download-tooltip tv\">\n    <div class=\"info-download-kit animated bounce\" connectqa-devices=\"download-tooltip\">\n        <div class=\"logo-holder centerFlex\">\n            <i class=\"icon icon-avira-logo \"></i>\n        </div>\n        <div class=\"tooltip\" >\n            <p translate=\"cw.download-tooltip\"></p>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "Jsc+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable prefer-destructuring */


var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$rootScope'];

var DwmAssetsController = function DwmAssetsController($scope, $state, $rootScope) {
    _classCallCheck(this, DwmAssetsController);

    $scope.assetsLoading = true;

    var buildAssets = function buildAssets() {

        if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

            $scope.assets = {
                emails: {
                    maxCount: 5,
                    entries: [],
                    order: 1
                },
                phoneNumbers: {
                    maxCount: 5,
                    entries: [],
                    order: 2
                },
                creditDebitCards: {
                    maxCount: 10,
                    entries: [],
                    order: 3
                },
                bankAccounts: {
                    maxCount: 10,
                    entries: [],
                    order: 4
                },
                addresses: {
                    maxCount: 5,
                    entries: [],
                    order: 5
                },
                driversLicense: {
                    maxCount: 1,
                    entries: [],
                    order: 6
                },
                gamerTags: {
                    maxCount: 10,
                    entries: [],
                    order: 7
                },
                insuranceCards: {
                    maxCount: 5,
                    entries: [],
                    order: 8
                },
                mothersMaidenName: {
                    maxCount: 1,
                    entries: [],
                    order: 9
                }
            };

            $scope.assetsLoading = false;
        }
    };

    buildAssets();

    var dwmStatusListener = $rootScope.$on('dwm_status_fetch_completed', function () {

        buildAssets();
    });

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};

        if (assets.primaryMember) {

            var assetsObj = assets.primaryMember.monitoredAccounts;

            if (assetsObj.emails) {

                assetsObj.emails.order = 1;
            }

            if (assetsObj.phoneNumbers) {

                assetsObj.phoneNumbers.order = 2;
            }

            if (assetsObj.creditDebitCards) {

                assetsObj.creditDebitCards.order = 3;
            }

            if (assetsObj.bankAccounts) {

                assetsObj.bankAccounts.order = 4;
            }

            if (assetsObj.addresses) {

                assetsObj.addresses.order = 5;
            }

            if (assetsObj.driversLicense) {

                assetsObj.driversLicense.order = 6;
            }

            if (assetsObj.gamerTags) {

                assetsObj.gamerTags.order = 7;
            }

            if (assetsObj.insuranceCards) {

                assetsObj.insuranceCards.order = 8;
            }

            if (assetsObj.mothersMaidenName) {

                assetsObj.mothersMaidenName.order = 9;
            }

            $scope.assets = assetsObj;

            var orders = [1, 2, 3, 4, 5, 6, 7, 8, 9];

            var sortedAssets = {};

            orders.forEach(function (index) {

                Object.entries(assetsObj).forEach(function (entry) {

                    if (index === entry[1].order) {

                        sortedAssets[entry[0]] = entry[1];
                    }
                });
            });

            $scope.assets = sortedAssets;

            $scope.assetsLoading = false;
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.openAssetModal = function (modal) {

        _RFC2.default.send('ConnectWeb AIA Entity Click', {
            Name: modal
        });

        $state.go('root.dashboard.dwm.ltb', {
            ltb: modal,
            resourceId: 'asset'
        });
    };

    $scope.$on('$destroy', function () {

        dwmStatusListener();
    });
};

var CryptoFaqDirective = function CryptoFaqDirective() {
    _classCallCheck(this, CryptoFaqDirective);

    this.template = __webpack_require__("aTk1");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $rootScope) {
        return new DwmAssetsController($scope, $state, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DwmAssetsCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoFaqDirective();
});

angular.module('directives').directive('dwmAssets', _directiveDependencies);

/***/ }),

/***/ "JzEn":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "K2yx":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("xOlx"),
    isLength = __webpack_require__("mL1V");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "K3ju":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable max-len */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _data = __webpack_require__("nRO4");

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$rootScope', '$scope', '$state', '$window', 'Util', 'PaymentUrlsRestService'];

var WelcomeOfferController = function () {
    function WelcomeOfferController($rootScope, $scope, $state, $window, Util, PaymentUrlsRestService) {
        var _this = this;

        _classCallCheck(this, WelcomeOfferController);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Util = Util;
        this.PaymentUrlsRestService = PaymentUrlsRestService;
        this.LicensesRepository = _index.LicensesRepository;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.endCampaignDay = Util.deepFind(CWCONFIG, 'features.offerBanner.endCampaignDay');
        this.$scope.showOPCButton = false;
        this.$scope.isOneClickPaymentEnable = CWCONFIG.features.oneClickPayment;
        $scope.showLearnMoreButton = true;
        this.$scope.language = CWCONFIG.language;
        var activationCodesRepo = _index.ActivationCodesRepository.getAll();
        $scope.activationCodesRepoLength = activationCodesRepo.length;

        if ($scope.activationCodesRepoLength) {

            $scope.hasOnlyAia = !!(activationCodesRepo.length === 1 && activationCodesRepo.find(function (activationCode) {
                return activationCode.attributes.app === 'adwp1';
            }));
        }

        // if ($rootScope.cmaGBapplies) {

        //     $scope.isFromUK = true;
        //     $scope.avProBuyUrl = 'https://www.avira.com/en/campaigns/crm/q2-fy23/f2p-antivirus-pro-mya?cookiebot_off=true';

        // }

        // const licensesRepo = LicensesRepository.getAll();
        // const user = MeRepository.getMyUser();
        // const userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
        this.runtime = 12;
        // const campaignBreakpoint =
        // Util.deepFind(CWCONFIG, 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;
        // end 97% off av campaign

        this.$scope.devicesLength = _index.DevicesRepository.getAll().length;

        this.$scope.hideBannerForThisSession = !sessionStorage.getItem('hideWOB');

        // hide welcome offer banner if user has an TP link licence
        this.$scope.hasTPLinkLicence = _index.ActivationCodesRepository.hasTPLinkLicence();

        // filter offers if has already the license for that offer
        var filteredOffers = _data2.default.filter(function (offer) {

            var userLicense = _this.LicensesRepository.getLicenseByAppId(offer.productId);

            if (userLicense) {

                return offer.productId !== userLicense.relationships.app.data.id;
            }

            return true;
        });

        // AIA Banner
        var hasPrime10 = activationCodesRepo.find(function (activationCode) {
            return activationCode.attributes.app === 'aps10';
        });
        var hasPrime20 = activationCodesRepo.find(function (activationCode) {
            return activationCode.attributes.app === 'aps20';
        });
        var hasIsec = this.LicensesRepository.getLicenseByAppId('isec0');
        // const hasIdentityAssistant = this.LicensesRepository.getLicenseByAppId('adwp1');
        var userCountry = Util.deepFind(_index.MeRepository.getMyUser(), 'attributes.country');
        // const isFromROW = !$rootScope.cmaGBapplies;
        // const isFromUK = $rootScope.cmaGBapplies;

        var aiaOffer = {
            product: 'Identity Assistant',
            productId: 'adwp1',
            learnMoreUrl: 'https://www.avira.com/de/avira-identity-assistant?x-a-source=cw',
            translationKeys: {
                discountDesc: userCountry === 'US' ? 'cw.dwm.offer.description' : 'cw.dwm.offer.description_row',
                learnMore: 'cw.dwm.offer.btn_learn_more',
                button: 'cw.general.buy'
            }
        };

        if ($rootScope.showAIAWelcomeOfferBanner) {

            if (hasPrime10 || hasPrime20 || hasIsec) {

                if (hasPrime20) {

                    filteredOffers = [aiaOffer];
                } else if (hasPrime10) {

                    filteredOffers[0] = aiaOffer;
                } else if (hasIsec) {

                    filteredOffers = filteredOffers.concat(aiaOffer);
                }

                var getRandomInt = function getRandomInt(max) {
                    return Math.floor(Math.random() * max);
                };
                this.currentOffer = filteredOffers[getRandomInt(filteredOffers.length)];

                if (this.currentOffer.productId === 'adwp1') {

                    $scope.showIdentityAssistantBanner = true;
                } else {

                    $scope.showDefaultBanner = true;
                }
            } else if (!$scope.showAvBanner) {

                var _getRandomInt = function _getRandomInt(max) {
                    return Math.floor(Math.random() * max);
                };
                this.currentOffer = filteredOffers[_getRandomInt(filteredOffers.length)];

                if (this.currentOffer.productId === 'isec0') {

                    this.currentOffer = aiaOffer;
                    $scope.showIdentityAssistantBanner = true;
                } else {

                    $scope.showDefaultBanner = true;
                }
            }
        } else if (!$scope.showAvBanner) {

            var _getRandomInt2 = function _getRandomInt2(max) {
                return Math.floor(Math.random() * max);
            };
            this.currentOffer = filteredOffers[_getRandomInt2(filteredOffers.length)];
            $scope.showDefaultBanner = true;
        }

        //* Promotional Campaign : BF 2023 logic
        //* To be commented when the campaign is over
        // if (isFromUK) {

        //     const getRandomInt = max => Math.floor(Math.random() * max);
        //     this.currentOffer =
        //         filteredOffers[getRandomInt(filteredOffers.length)];
        //     $scope.showDefaultBanner = true;

        // } else {

        //     if (!hasPrime10 && !hasPrime20) {

        //         $scope.showPrime5Banner = true;
        //         $scope.activePromotionProduct = 'aps10_12_1';

        //         this.currentOffer = offersConfiguration.find(offer => offer.productId === 'aps10');
        //         this.currentOffer.translationKeys = {
        //             title: 'cw.offer4.campaign_description_aps10',
        //         };

        //         $rootScope.createCMAlabels(`${this.currentOffer.productId}_12_1`, this.currentOffer.product, this.currentOffer.productId, '2023-11-23', '2023-12-03');

        //     }

        //     if (activationCodesRepo.length > 0 && hasPrime10 && !hasPrime20) {

        //         $scope.showPrime25Banner = true;
        //         $scope.activePromotionProduct = 'aps20_12_1';

        //         this.currentOffer = {
        //             product: 'Avira Prime 25',
        //             productId: 'aps20',
        //             translationKeys: {
        //                 title: 'cw.offer4.campaign_description_aps20',
        //             },
        //         };

        //         $rootScope.createCMAlabels(`${this.currentOffer.productId}_12_1`, this.currentOffer.product, this.currentOffer.productId, '2023-11-23', '2023-12-03');

        //     }
        //     if ($rootScope.showAIAWelcomeOfferBanner && !hasIdentityAssistant && hasPrime20) {

        //         this.currentOffer = aiaOffer;
        //         $scope.showIdentityAssistantBanner = true;

        //     }

        // }

        // we listen to event when OCP is available in order to show OCP button
        _RFC4.default.subscribe('showRecommendation:true', function () {

            _this.$scope.showOPCButton = true;
        });
        _RFC4.default.subscribe('showRecommendation:false', function () {

            _this.$scope.showOPCButton = false;
        });

        // If user have trial prime license we show Prime offer
        var primeLicense = this.LicensesRepository.getLicenseByAppId('aps10') || this.LicensesRepository.getLicenseByAppId('aps20');
        if (primeLicense && primeLicense.attributes.type === 'eval') {

            if ($scope.showIdentityAssistantBanner) {

                this.currentOffer = aiaOffer;
            } else {

                this.currentOffer = _data2.default.find(function (offer) {
                    return offer.productId === 'aps10';
                });
            }
        }

        var pageUrl = this.$state.current.url || ' Undefined';
        this.$scope.pageName = pageUrl.substr(1);

        // Check if we still have some offer
        if (this.currentOffer) {

            // hide the learn more button redirect to comparison modal
            // for app recommendations without comparison features
            var currentUserAppId = Util.deepFind(activationCodesRepo[0], 'attributes.app');
            var recommendedApp = _index.AppIntegrationsRepository.getById(currentUserAppId) || {};

            if (!Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

                $scope.showLearnMoreButton = false;
            }

            // get discount from flexible promotion
            var currentAppPrices = _index.AppPricesRepository.getSinglePrice(this.currentOffer.productId, 12, 1);

            this.$scope.price = this.Util.deepFind(currentAppPrices, 'attributes.promotion.price');
            var _discount = this.Util.deepFind(currentAppPrices, 'attributes.promotion.discount');

            this.$scope.discount = _discount ? _discount + '%' : '20%';

            // lang fix for discount
            if (CWCONFIG.language === 'de') {

                this.$scope.discount = _discount ? _discount + ' %' : '20 %';
            }
            if (CWCONFIG.language === 'tr') {

                this.$scope.discount = _discount ? '%' + _discount : '%20';
            }

            // hide banner for this bundleIds if available in the users subscriptions
            var bundleIds = Util.deepFind(this.currentOffer, 'bundleIds') || [];

            this.$scope.voucher = Util.deepFind(this.currentOffer, 'voucher');
            this.$scope.isOfferActive = Util.deepFind(CWCONFIG, 'features.offerBanner.showOffer');
            // hide the close button if current page is subscriptions
            this.$scope.hideInSubscription = $state.current.name !== 'root.dashboard.subscriptions';
            this.$scope.hasOfferSubscriptions = false;
            this.$scope.translationKeys = this.currentOffer.translationKeys;

            if (this.currentOffer.productId === 'aapd5') {

                var appIntegration = _index.AppIntegrationsRepository.getById(this.currentOffer.productId);
                this.$scope.product = Util.deepFind(appIntegration, 'attributes.resource.name');
            } else {

                this.$scope.brandName = CWCONFIG.partnerConfig.name;
                this.$scope.product = _index.AppIntegrationsRepository.getAppName(this.currentOffer.productId);
            }

            // get offer local storage name from config
            this.offerLocalStorageName = Util.deepFind(CWCONFIG, 'features.offerBanner.localStorageName');

            // check if the offer was closed
            this.$scope.welcomeOfferWasClosed = localStorage.getItem(this.offerLocalStorageName);

            var isecComponents = ['aapd0', 'aapd5', 'aasc0', 'pasm1', 'mspi3', 'swoe0'];

            $scope.hasIsecComponents = false;

            // check if has Avira Prime or isec components
            activationCodesRepo.forEach(function (activationCode) {

                bundleIds.forEach(function (primeId) {

                    if (activationCode.attributes.app === primeId) {

                        _this.$scope.hasOfferSubscriptions = true;
                    }
                });

                isecComponents.forEach(function (component) {

                    if (activationCode.attributes.app === component) {

                        $scope.hasIsecComponents = true;
                    }
                });
            });

            this.$scope.hasAps10 = activationCodesRepo.find(function (activationCode) {
                return activationCode.attributes.app === 'aps10';
            });
            this.$scope.hasAps20 = activationCodesRepo.find(function (activationCode) {
                return activationCode.attributes.app === 'aps20';
            });
            this.$scope.primeIntegration = _index.AppIntegrationsRepository.getById('aps10');

            // Code for Prime 25 banner
            if (this.$scope.hasAps10 && this.$scope.devicesLength > 3 && !$rootScope.showAIAWelcomeOfferBanner) {

                this.currentOffer = {
                    product: 'Avira Prime 25',
                    productId: 'aps20',
                    translationKeys: {
                        title: 'cw.banner.prime_25.title',
                        description: 'cw.banner.prime_25.description',
                        button: 'cw.banner.prime_25.button'
                    }
                };

                this.$scope.showUpsellPrime25 = true;
                this.$scope.translationKeys = this.currentOffer.translationKeys;
            }
            // Code for Prime 25 banner

            // Norton Life Lock Banner
            // if (($rootScope.requestCountry === 'US' && this.$scope.language === 'en') &&
            //     ((this.$scope.hasAps10 && this.$scope.devicesLength <= 3)
            //     || this.$scope.hasAps20)) {

            //     this.variant = 'Identity Theft Protection';
            //     this.$scope.showNortonLifeLockUpsell = true;

            //     // get offer local storage name from config
            //     this.offerLocalStorageName =
            // Util.deepFind(CWCONFIG, 'features.offerBannerNortonLifeLock.localStorageName');
            //     this.$scope.welcomeOfferWasClosed =
            //         localStorage.getItem(this.offerLocalStorageName);

            //     Mixpanel.send('ConnectWeb Banner Offer Show',
            //         { variant: 'NLOK Identity Theft Protection' }
            //     );

            // }

            setTimeout(function () {

                if ($scope.isOfferActive && (!$scope.welcomeOfferWasClosed || !$scope.hideInSubscription) && !$scope.hasOfferSubscriptions || $scope.isOfferActive && $scope.showUpsellPrime25 && !$scope.welcomeOfferWasClosed) {

                    var currentAppPrice = _index.AppPricesRepository.getSinglePrice(_this.currentOffer.productId, '12', '1');
                    var finalPrice = '';
                    if (currentAppPrice) {

                        finalPrice = _this.Util.deepFind(currentAppPrice, 'attributes.promotion.total_price_string');
                    }

                    _RFC2.default.send('ConnectWeb Banner Offer Show', {
                        Page: _this.Util.getPageName(),
                        Price: finalPrice,
                        Product: _this.currentOffer.product,
                        ProductId: _this.currentOffer.productId
                    });
                }
            }, 100);
        }

        var price = '';
        var discount = '';
        if (this.currentOffer) {

            var currentPrice = _index.AppPricesRepository.getSinglePrice(this.currentOffer.productId, '12', '1');

            if (currentPrice) {

                if (this.Util.deepFind(currentPrice, 'attributes.promotion')) {

                    price = this.Util.deepFind(currentPrice, 'attributes.promotion.total_price_string');
                    discount = this.Util.deepFind(currentPrice, 'attributes.promotion.discount');
                } else {

                    price = this.Util.deepFind(currentPrice, 'attributes.price_string');
                    discount = 0;
                }
            }
        }

        this.mixpanelPayload = {
            Product: this.currentOffer ? this.currentOffer.product : '',
            ProductId: this.currentOffer ? this.currentOffer.productId : '',
            Page: this.Util.getPageName(),
            FallbackShopUrl: false,
            Price: price,
            Discount: discount,
            Runtimes: this.runtime
        };

        if (!this.$scope.hasTPLinkLicence && this.$scope.isOfferActive && (!this.$scope.welcomeOfferWasClosed || !this.$scope.hideInSubscription) && !this.$scope.hasOfferSubscriptions || this.$scope.isOfferActive && this.$scope.showUpsellPrime25 && !this.$scope.welcomeOfferWasClosed) {

            this.$rootScope.showCmaDisclaimer.banner = true;
        }

        if (this.$scope.welcomeOfferWasClosed === 'closed') {

            this.$rootScope.showCmaDisclaimer.banner = false;

            if (!this.$scope.hideInSubscription) {

                this.$rootScope.showCmaDisclaimer.banner = true;
            }
        }

        //* Promotional Campaign: $rootScope.welcomeOffer.campaign variable is used to show the campaing line in bottom discalimer
        //* To be commented when the campaign is over
        // $scope.$on('$destroy', () => {

        //     $rootScope.welcomeOffers = {};

        // });
    }

    _createClass(WelcomeOfferController, [{
        key: 'close',
        value: function close() {

            // set data on local storage when the offer is closed
            localStorage.setItem(this.offerLocalStorageName, 'closed');

            // update view
            this.$scope.welcomeOfferWasClosed = localStorage.getItem(this.offerLocalStorageName);
            this.$rootScope.showCmaDisclaimer.banner = false;
            _RFC2.default.send('ConnectWeb Banner Offer Close');
        }
    }, {
        key: 'sendMixpanelLearnMore',
        value: function sendMixpanelLearnMore() {

            _RFC2.default.send('ConnectWeb Banner Learn More Click', {
                ProductId: this.currentOffer.productId
            });
        }
    }, {
        key: 'getOfferUK',
        value: function getOfferUK() {

            _RFC2.default.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);
        }
    }, {
        key: 'getOffer',
        value: function getOffer() {

            _RFC2.default.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);

            this.$state.go(this.$state.current.name + '.ltb.banner', {
                ltb: 'payment-cart',
                resourceId: this.currentOffer.productId,
                subsource: 'banner',
                promotion: true,
                runtime: this.runtime
            }, {
                reload: false
            });
        }
    }, {
        key: 'nortonLifeLockUpsell',
        value: function nortonLifeLockUpsell() {

            _RFC2.default.send('ConnectWeb Banner Offer Click', this.mixpanelPayload);
        }
    }, {
        key: 'learnMore',
        value: function learnMore() {

            var activationCodesRepo = _index.ActivationCodesRepository.getAll();
            if (activationCodesRepo.length === 1 && this.$scope.showLearnMoreButton) {

                var stateName = this.$state.current.name;

                if (stateName.indexOf('.ltb') === -1) {

                    stateName += '.ltb';
                }
                // open OCP modal
                this.$state.go(stateName, {
                    ltb: 'ocp-comparison',
                    resourceId: this.currentOffer.productId
                }, {
                    reload: false
                });
            } else {

                var learnMoreUrl = this.Util.deepFind(this.currentOffer, 'learnMoreUrl');
                learnMoreUrl = learnMoreUrl.replace('{language}', CWCONFIG.language);

                if ((CWCONFIG.language === 'en' || CWCONFIG.language === 'de') && this.currentOffer.productId === 'isec0') {

                    /*  the new ISEC page from website doesn't contain '-suite' section in URL
                        for EN and DE languages */
                    learnMoreUrl = learnMoreUrl.replace('-suite', '');
                    this.$window.open(learnMoreUrl, '_blank');
                } else {

                    this.$window.open(learnMoreUrl, '_blank');
                }
            }
        }
    }, {
        key: 'redirectToUpsellPage',
        value: function redirectToUpsellPage() {

            this.$rootScope.redirectFromTab = 'dwm';

            this.$state.go('root.dashboard.dwm', {
                tab: 'store'
            });
        }
    }]);

    return WelcomeOfferController;
}();

var WelcomeOfferDirective = function WelcomeOfferDirective() {
    _classCallCheck(this, WelcomeOfferDirective);

    this.template = __webpack_require__("LEPB");
    this.restrict = 'E';
    this.replace = true;

    _controllerDependencies.push(function ($rootScope, $scope, $state, $window, Util, PaymentUrlsRestService) {
        return new WelcomeOfferController($rootScope, $scope, $state, $window, Util, PaymentUrlsRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'welcomeOfferCtrl';
};

_directiveDependencies.push(function () {
    return new WelcomeOfferDirective();
});

angular.module('directives').directive('welcomeOffer', _directiveDependencies);

/***/ }),

/***/ "K4GD":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"security-password\">\n\n        <div class=\"mya-section-info\">\n            <div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.profile.change_password.submit\"></div>\n            <div class=\"text-m mt5 text-grey-3\" translate=\"cw.form.profile.change_password.deff\"></div>\n        </div>\n\n        <div class=\"mya-section-forms max-width-s\">\n            <div class=\"password-form\">\n                <form name=\"resetPasswordForm\" role=\"form\" novalidate ng-submit=\"securityPasswordCtrl.changePassword()\">\n                    <div>\n                        <div class=\"text-m text-grey-3 pass-text\" translate=\"cw.form.current_password\"></div>\n\n                        <div class=\"form-group\" ng-init=\"oldPasswordFocus = false\">\n                            <input type=\"password\"\n                                   ng-model=\"oldPassword\"\n                                   ng-focus=\"oldPasswordFocus = true\"\n                                   ng-blur=\"oldPasswordFocus = false\"\n                                   ng-keyup=\"submitted = false\"\n                                   name=\"oldPassword\"\n                                   maxlength=\"100\"\n                                   autocomplete=\"off\"\n                                   ng-class=\"{'error animated shake': resetPasswordForm.oldPassword.$invalid && submitted}\"\n                                   id=\"oldPassword\"\n                                   required connectqa-mya=\"current-password\"/>\n\n                            <span class=\"show-password\" ng-class=\"{'text': oldInputType === 'text'}\" ng-click=\"securityPasswordCtrl.showPassword('oldPassword')\"></span>\n\n                            <div ng-show=\"resetPasswordForm.oldPassword.$error.required && submitted\">\n                                <p class=\"error-message\"\n                                   ng-show=\"resetPasswordForm.oldPassword.$error.required && submitted\"\n                                   translate=\"cw.input.current_password.error.no_characters\"></p>\n                            </div>\n                            <div ng-show=\"resetPasswordForm.oldPassword.$error.serverValidation && submitted\">\n                                <p class=\"error-message\"\n                                   ng-show=\"resetPasswordForm.oldPassword.$error.serverValidation && submitted\"\n                                   translate=\"cw.notification.profile.change_password.invalid_current_password\"></p>\n                                <p class=\"error-message no-margin\"\n                                   ng-show=\"resetPasswordForm.oldPassword.$error.serverValidation && submitted && resetPasswordFailedAttempts>=2\"\n                                   translate=\"cw.notification.profile.change_password.reset_password\">\n                                </p>\n                                <a ui-sref=\"root.auth.forgot\" class=\"text-blue-2 error-message\" ng-show=\"resetPasswordForm.oldPassword.$error.serverValidation && submitted && resetPasswordFailedAttempts>=2\"\n                                    ng-click=\"securityPasswordCtrl.Auth.removeLoginCookies(); securityPasswordCtrl.setEmail()\" translate=\"cw.general.recover\"></a>\n                            </div>\n\n                            <p class=\"error-message\"\n                                ng-show=\"resetPasswordForm.oldPassword.$viewValue.length === 100\"\n                                translate=\"cw.validator.messages.password.maximum_length\"></p>\n\n                        </div>\n                    </div>\n\n                    <div>\n                        <div class=\"text-m mt10 text-grey-3 pass-text\" translate=\"cw.form.new_password\"></div>\n\n                        <div class=\"form-group\" ng-init=\"newPasswordFocus = false\">\n                            <input type=\"password\"\n                                   ng-model=\"newPassword\"\n                                   ng-focus=\"newPasswordFocus = true\"\n                                   ng-blur=\"newPasswordFocus = false\"\n                                   ng-keyup=\"submitted = false;\n                                             securityPasswordCtrl.getPasswordScore(resetPasswordForm.newPassword.$viewValue)\"\n                                   name=\"newPassword\"\n                                   maxlength=\"100\"\n                                   autocomplete=\"off\"\n                                   ng-class=\"{'error animated shake':\n                                             submitted &&\n                                             (resetPasswordForm.newPassword.$invalid || !securityPasswordCtrl.passwordScore.valid ||\n                                             (resetPasswordForm.oldPassword.$viewValue === resetPasswordForm.newPassword.$viewValue))}\"\n                                   id=\"newPassword\"\n                                   ng-pattern=\"passwordRegExp\"\n                                   required connectqa-mya=\"new-password\"/>\n\n                            <span class=\"show-password\" ng-class=\"{'text': newInputType === 'text'}\" ng-click=\"securityPasswordCtrl.showPassword('newPassword')\"></span>\n\n                            <div ng-show=\"(resetPasswordForm.oldPassword.$viewValue.length > 0 && resetPasswordForm.newPassword.$viewValue.length > 0) && submitted\">\n\n                                <p class=\"error-message\"\n                                   ng-show=\"resetPasswordForm.oldPassword.$viewValue ===  resetPasswordForm.newPassword.$viewValue\"\n                                   translate=\"cw.validator.messages.passwords_match\"></p>\n                            </div>\n\n                            <div ng-show=\"(resetPasswordForm.newPassword.$error.required ||\n                                          (!securityPasswordCtrl.passwordScore.valid && !resetPasswordForm.newPassword.$viewValue)) && submitted\">\n                                <p class=\"error-message\"\n                                   ng-show=\"resetPasswordForm.newPassword.$error.required && submitted\"\n                                   translate=\"cw.validator.password.error.enter_password\"></p>\n                            </div>\n\n                            <p class=\"error-message\"\n                                ng-show=\"resetPasswordForm.newPassword.$viewValue.length === 100\"\n                                translate=\"cw.validator.messages.password.maximum_length\"></p>\n\n                            <div ng-if=\"newPasswordFocus\" class=\"tooltip-input left\">\n                                <password-strength\n                                    passlength=\"resetPasswordForm.newPassword.$viewValue.length\"\n                                    passpattern=\"resetPasswordForm.newPassword.$valid\"\n                                    passwordscore=\"securityPasswordCtrl.passwordScore\">\n                                </password-strength>\n                            </div>\n                        </div>\n                    </div>\n\n                    <button class=\"btn btn-large btn-primary mb10 mt5 spin-loader\"\n                            ng-disabled=\"loading\" translate=\"cw.form.profile.save\" connectqa-mya=\"save-security-changes\">\n                    </button>\n                </form>\n\n                <p class=\"text-grey-3 text-s\" translate=\"cw.my_account.security.change_email_info\" translate-values=\"{brandname : brandName}\"></p>\n            </div>\n        </div>\n\n\n    </div>\n</div>\n"

/***/ }),

/***/ "KB0t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

var _RFC5 = __webpack_require__("liN6");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', '$rootScope', '$window', 'Auth', 'Util', '$http', 'JWT'];
var EU_WITHDRAW_WINDOW_DAYS = 14;

var Dashboard = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} $window
     * @param  {any} $state
     * @param  {any} Auth
     */

    function Dashboard($scope, $state, $rootScope, $window, Auth, Util, $http, JWT) {
        var _this = this;

        _classCallCheck(this, Dashboard);

        this.$rootScope = $rootScope;
        this.$rootScope.State.finishedLoadingAnimation = true;
        this.$state = $state;
        this.$scope = $scope;

        this.Util = Util;

        this.$rootScope.showCmaDisclaimer = {
            otc: false,
            trial: false,
            banner: false,
            cardDeleted: false,
            withdrawalConsent: false
        };

        var user = _index.MeRepository.getMyUser();
        var isNewUser = Util.deepFind(user, 'attributes.password_not_set');
        var gdprConfirmed = Util.deepFind(user, 'attributes.gdpr_confirm');
        var usCompliance = user.attributes.status_us_compliance_approved;
        var primaryLocaleSelector = user.attributes.language + '-' + user.attributes.country;
        var secondaryLocaleSelector = user.attributes.language;
        $rootScope.accountCountry = Util.deepFind(user, 'attributes.country');
        angular.lowercase = function (text) {
            return text.toLowerCase();
        };

        // if the user lanuge is English and the user is
        // not from US, show our default format (DD/MM/YYY)
        if (secondaryLocaleSelector === 'en' && user.attributes.country !== 'US') {

            secondaryLocaleSelector = 'en-gb';
        }

        // set locale for moment js in order to show the correct date format
        moment.locale([primaryLocaleSelector, secondaryLocaleSelector]);

        /* This method prevents the user from accessing dashboard homepage if
            the user clicks on the back button from browser
            or is accessing the homepage route directly and his account is not
            confirmed or doesn't have a password.
        */
        if (!gdprConfirmed || gdprConfirmed === '') {

            Auth.gotoConfirm();
        } else if (isNewUser) {

            Auth.gotoSetPassword();
        }

        // Suppress renewal touchpoints when src=mobileApp (Google Play Store compliance)
        $rootScope.isMobileAppSession = document.cookie.split('; ').some(function (c) {
            return c === 'oe_mobile_session=1';
        });

        // Check if dashboard should be full visible based on US compliance status
        if ($rootScope.isComingFromEmbargoedCountry) {

            $rootScope.hasUsCompliance = false;
        } else if (usCompliance === false) {

            $rootScope.hasUsCompliance = false;
        } else {

            $rootScope.hasUsCompliance = true;
        }

        // Sort licenses alphabetically by acronym
        var sortLicenses = function sortLicenses(data) {
            return data.sort(function (a, b) {

                var firstAcronym = Util.deepFind(a, 'relationships.app.data.id');
                var secondAcronym = Util.deepFind(b, 'relationships.app.data.id');

                if (firstAcronym < secondAcronym) {

                    return -1;
                }
                if (firstAcronym > secondAcronym) {

                    return 1;
                }
                return 0;
            });
        };

        // Update mixpanel super properties
        var licenses = void 0;
        var activationCodes = void 0;
        var licensesAcronyms = void 0;
        var licensesNames = void 0;
        var runtimesRemaining = void 0;
        var subscriptionStatuses = void 0;
        var subscriptionTypes = void 0;
        var subscriptionRuntimes = void 0;

        var setMixpanelCommonProperties = function setMixpanelCommonProperties() {

            licensesAcronyms = [];
            licensesNames = [];
            runtimesRemaining = [];
            subscriptionStatuses = [];
            subscriptionTypes = [];
            subscriptionRuntimes = [];

            licenses = _index.LicensesRepository.getAll();
            activationCodes = _index.ActivationCodesRepository.getAll();
            var transactions = _index.TransactionsRepository.getAll();
            var paymentTypeValues = [];

            var sortedLicenses = sortLicenses(licenses);
            sortedLicenses.forEach(function (license) {

                var acronym = Util.deepFind(license, 'relationships.app.data.id');
                var app = _index.AppIntegrationsRepository.getById(acronym);
                var appName = Util.deepFind(app, 'attributes.resource.oeName');
                var subscriptionType = license.attributes.subscription_type;
                // Get remaining days
                var expirationDate = Util.deepFind(license, 'attributes.expiration_date');
                var startTime = moment();
                var endTime = moment(expirationDate);
                var difference = parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;
                var runtime = Util.deepFind(license, 'attributes.runtime');

                // Get the corresponding activation code in order to determine subscription type
                var licenseActivationCode = Util.deepFind(license, 'relationships.activation-code.data.id');
                var activationCode = activationCodes.find(function (code) {
                    return code.id === licenseActivationCode;
                });
                if (licenseActivationCode && activationCode) {

                    var isStaticOTC = activationCode.attributes.subscription === 0 && (activationCode.attributes.subscription_type === 'yearly' || activationCode.attributes.subscription_type === 'prepaid');
                    var isVoucher = _index.TransactionsRepository.isVoucherPurchase(activationCode.id);

                    if (!isStaticOTC && !isVoucher) {

                        if (activationCode.attributes.subscription === 0 && activationCode.attributes.type !== 'eval') {

                            subscriptionStatuses.push('Auto-Renewal OFF');
                        } else if (activationCode.attributes.subscription === 1 && activationCode.attributes.type !== 'eval') {

                            subscriptionStatuses.push('Auto-Renewal ON');
                        }
                    } else if (isStaticOTC) {

                        _this.$rootScope.showCmaDisclaimer.otc = true;
                        subscriptionStatuses.push('Static OTC');
                    } else if (isVoucher) {

                        subscriptionStatuses.push('Voucher');
                    }
                } else if (license.attributes.type === 'eval') {

                    _this.$rootScope.showCmaDisclaimer.trial = true;
                    subscriptionStatuses.push('Trial');
                }

                if (activationCode && transactions.length > 0) {

                    var transactionId = transactions.find(function (transaction) {
                        return transaction.attributes.activation_code === activationCode.id;
                    });
                    if (transactionId) {

                        paymentTypeValues.push(Util.deepFind(transactionId, 'attributes.payment_type'));
                    }
                }

                licensesAcronyms.push(acronym);
                licensesNames.push(appName);
                runtimesRemaining.push(difference);
                subscriptionTypes.push(subscriptionType);
                subscriptionRuntimes.push(runtime);
            });

            var licenseType = 'free';

            var hasTrial = licenses.find(function (license) {
                return license.attributes.type === 'eval';
            });
            var hasPaid = licenses.find(function (license) {
                return license.attributes.type === 'paid';
            });

            if (hasTrial && hasPaid) {

                licenseType = 'paid';
            } else if (hasTrial && !hasPaid) {

                licenseType = 'trial';
            } else if (!hasTrial && hasPaid) {

                licenseType = 'paid';
            }
            // a/b test unsubscribe animation
            // only apply for paid users
            if (activationCodes.length > 0 && CWCONFIG.unsubscribeAnimation) {

                if (localStorage.getItem('animation') === 'true') {

                    $rootScope.State.unsubscribeAnimation = true;

                    _RFC2.default.setCommonProperty('A/B Test unsubscribe animation', true);
                } else {

                    $rootScope.State.unsubscribeAnimation = false;
                    _RFC2.default.setCommonProperty('A/B Test unsubscribe animation', false);
                }
            }
            // verify if user has an valid payment method
            var paymentTypes = _index.PaymentTypesRepository.getAll();
            var validPayment = paymentTypes.findIndex(function (payment) {

                var paymentType = Util.deepFind(payment, 'attributes.payment_type');
                var isVoucherPayment = paymentType ? paymentType.toLowerCase().indexOf('voucher') > -1 : false;

                var paymentExpirationDate = Util.deepFind(payment, 'attributes.expiration_date');
                if (paymentExpirationDate && paymentExpirationDate.indexOf('-') > -1) {

                    return !_RFC6.default.isCardExpired(payment, 0);
                }
                if (Util.isPaymentCardDeleted(payment)) {

                    _this.$rootScope.showCmaDisclaimer.cardDeleted = true;
                    return false;
                }
                return !isVoucherPayment;
            });
            var validPaymentMethod = !!(paymentTypes.length > 0 && validPayment > -1);
            $rootScope.hasValidPayment = validPaymentMethod;

            _RFC2.default.setCommonProperty('License Type', licenseType);
            _RFC2.default.setCommonProperty('License Count', licenses.length);
            _RFC2.default.setCommonProperty('Licenses', licensesAcronyms);
            _RFC2.default.setCommonProperty('Licenses Names', licensesNames);
            _RFC2.default.setCommonProperty('Runtimes Remaining', runtimesRemaining);
            _RFC2.default.setCommonProperty('Runtimes Remaining Min', runtimesRemaining.length > 0 ? Math.min.apply(Math, _toConsumableArray(runtimesRemaining)) : 'None');
            _RFC2.default.setCommonProperty('Runtimes Remaining Max', runtimesRemaining.length > 0 ? Math.max.apply(Math, _toConsumableArray(runtimesRemaining)) : 'None');
            _RFC2.default.setCommonProperty('Subscription Statuses', subscriptionStatuses);
            _RFC2.default.setCommonProperty('Subscription Types', subscriptionTypes);
            _RFC2.default.setCommonProperty('Valid Payment Method', validPaymentMethod ? 'yes' : 'no');
            _RFC2.default.setCommonProperty('Subscription Runtimes', subscriptionRuntimes);
            _RFC2.default.setCommonProperty('Payment Type', paymentTypeValues);

            // A/B Test Identity Assistant Banner
            // const hasPrime =
            //    LicensesRepository.getLicenseByAppId('aps10') ||
            //    LicensesRepository.getLicenseByAppId('aps20');
            // const hasIdentityAssistant = LicensesRepository.getLicenseByAppId('adwp1');
            // const country = Util.deepFind(MeRepository.getMyUser(), 'attributes.country');

            // if (country === 'DE' && !hasPrime && !hasIdentityAssistant) {

            //    if (!localStorage.getItem('IdentityAssistantBanner')) {

            //        localStorage.setItem('IdentityAssistantBanner',
            //            Math.floor(Math.random() * 2));

            //    }

            //    const testGroup =
            //        localStorage.getItem('IdentityAssistantBanner') === '0' ? 'control' : 'test';
            //    Mixpanel.setCommonProperty('AB Test', testGroup);

            // }

            // A/B Test Auto-Renew Offer
            // const autoRenewOfferEligibleIds = [];
            // const isTestEnabled = CWCONFIG.enableAutoRenewDiscountABtest;

            // const hasPrimeOn = activationCodes
            //     .find(activationCode => ((activationCode.attributes.app ===
            // 'aps10' && activationCode.attributes.subscription === 1) ||
            // (activationCode.attributes.app === 'aps20' &&
            // activationCode.attributes.subscription === 1)));

            // $rootScope.autoRenewOfferEligibleIds = [];
            // activationCodes.forEach((activationCode) => {

            //     const transactionId = transactions
            //         .find(transaction =>
            //             transaction.attributes.activation_code === activationCode.id);

            //     let paymentType;
            //     if (transactionId) {

            //         paymentType =
            //             paymentTypes.find(payment =>
            //                 payment.id === transactionId.attributes.payment_transaction_id);

            //     }

            //     const isCardDeleted = Util.isPaymentCardDeleted(paymentType);
            //     const hasActivePromotion = activationCode.attributes.promotion_id;
            //     const appId = activationCode.attributes.app;
            //     const subscriptionStatus = activationCode.attributes.subscription;
            //     const isStaticOTC = subscriptionStatus === 0 &&
            //     (
            //         activationCode.attributes.subscription_type === 'yearly' ||
            //         activationCode.attributes.subscription_type === 'prepaid'
            //     );
            //     const isVoucher = TransactionsRepository.isVoucherPurchase(activationCode.id);
            //     const { runtime } = activationCode.attributes;

            //     if (((appId === 'aps10' || appId === 'aps20') ||
            // (((appId === 'aapd5' || appId === 'aapd0') && runtime > 1))) &&
            //         (!isStaticOTC && !isVoucher && !isCardDeleted) &&
            //         subscriptionStatus === 0 && !hasActivePromotion && isTestEnabled &&
            //         !hasPrimeOn) {

            //         autoRenewOfferEligibleIds.push(activationCode.id);

            //         if (!localStorage.getItem('testAutoRenewDiscountReview')) {

            //             const randomValueTest = Math.floor(Math.random() * 3) + 1;
            //             let testGroupRenewOffer = '';

            //             if (randomValueTest === 1) {

            //                 testGroupRenewOffer = 'control';

            //             } else if (randomValueTest === 2) {

            //                 testGroupRenewOffer = 'activate';

            //             } else if (randomValueTest === 3) {

            //                 testGroupRenewOffer = 'save';

            //             }

            //             localStorage.setItem('testAutoRenewDiscountReview', testGroupRenewOffer);

            //         }

            //     }

            // });

            // $rootScope.autoRenewOfferEligibleIds = autoRenewOfferEligibleIds;
            // localStorage.setItem('autoRenewOfferEligibleIds',
            // JSON.stringify(autoRenewOfferEligibleIds));
        };

        _RFC4.default.subscribe('purchase completed', function () {

            setMixpanelCommonProperties();
        });

        var subjectActivationCodes = _index.ActivationCodesRepository.getObservable();
        var activationCodesSubscriber = subjectActivationCodes.subscribe(function () {
            return setMixpanelCommonProperties();
        }, function () {}, function () {});

        var devices = _index.DevicesRepository.getVisibleDevices();

        var userRegistrationDate = Util.deepFind(user, 'attributes.date_registered');
        var today = moment();
        var registrtionDate = moment(userRegistrationDate);
        var accountDays = parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;

        // let autoRenewOfferVersion;
        // if ($rootScope.autoRenewOfferEligibleIds.length === 0) {

        //     autoRenewOfferVersion = 'Not qualified';

        // } else if (localStorage.getItem('testAutoRenewDiscountReview')) {

        //     autoRenewOfferVersion = localStorage.getItem('testAutoRenewDiscountReview');

        // }

        // Country detection code
        var userDetails = _index.MeRepository.getMyUser();
        var userCountry = userDetails.attributes.country;
        $rootScope.accountCountry = userCountry;

        if ($rootScope.requestCountry === 'GB' || $rootScope.accountCountry === 'GB') {

            $rootScope.cmaGBapplies = true;
        }

        if ($rootScope.requestCountry === 'US' || $rootScope.accountCountry === 'US') {

            $rootScope.cmaUSapplies = true;
        }

        if ($rootScope.requestCountry === 'NL' || $rootScope.accountCountry === 'NL') {

            $rootScope.cmaNLapplies = true;
        }

        if ($rootScope.requestCountry === 'IN' && !localStorage.getItem('disclaimerBar')) {

            $rootScope.vpnINdisclaimer = true;
        }

        if ($rootScope.requestCountry === 'DE' || $rootScope.accountCountry === 'DE') {

            $rootScope.cmaDEapplies = true;
        }

        if ($rootScope.requestCountry === 'FR' || $rootScope.accountCountry === 'FR') {

            $rootScope.cmaFRapplies = true;
        }

        var _CWCONFIG$cma = CWCONFIG.cma,
            eeaCountriesList = _CWCONFIG$cma.eeaCountriesList,
            euWithdrawalConsentCountryCodes = _CWCONFIG$cma.euWithdrawalConsentCountryCodes;


        $rootScope.isPartOfEEA = !!(eeaCountriesList.find(function (country) {
            return country.code === $rootScope.requestCountry;
        }) || eeaCountriesList.find(function (country) {
            return country.code === $rootScope.accountCountry;
        }));

        var isPartOfEU = euWithdrawalConsentCountryCodes.includes($rootScope.requestCountry) || euWithdrawalConsentCountryCodes.includes($rootScope.accountCountry);

        var allSubscriptions = [].concat(_toConsumableArray(licenses || []), _toConsumableArray(activationCodes || []));
        var hasRecentEuPurchase = allSubscriptions.some(function (item) {

            var dateCreate = Util.deepFind(item, 'attributes.creation_date');
            var type = Util.deepFind(item, 'attributes.type');
            var subscriptionType = Util.deepFind(item, 'attributes.subscription_type');
            if (!dateCreate || type !== 'paid' || subscriptionType.indexOf('trial') > -1) return false;
            var daysDiff = moment().diff(moment(dateCreate), 'days');
            return daysDiff >= 0 && daysDiff <= EU_WITHDRAW_WINDOW_DAYS;
        });
        $rootScope.euWithdrawalConsentEligible = isPartOfEU && hasRecentEuPurchase;

        // End country detection code

        // Hide subscriptions widget from homepage
        var hasATrial = licenses.length;
        var hasAPaidLicense = activationCodes.length;
        if ((hasAPaidLicense || hasATrial) && !$rootScope.cmaGBapplies) {

            $rootScope.hideHomepageSubscriptionWidget = true;
        } else {

            $rootScope.hideHomepageSubscriptionWidget = false;
        }
        // End hide subscriptions widget from homepage

        if (!$rootScope.cmaGBapplies) {

            $rootScope.showSubscriptionsLinkInMyAccountDropdown = true;
        }

        _RFC2.default.setCommonProperty('Devices Count', devices.length);
        _RFC2.default.setCommonProperty('Account days', accountDays);

        var testGroup = void 0;
        if (!$rootScope.showAIAWelcomeOfferBanner) {

            testGroup = 'Not qualified';
        } else {

            if (!localStorage.getItem('aiaBannerVariant')) {

                localStorage.setItem('aiaBannerVariant', Math.floor(Math.random() * 2));
            }

            testGroup = localStorage.getItem('aiaBannerVariant') === '0' ? 'control' : 'test';
        }

        $rootScope.aiaBannerVariant = testGroup;
        _RFC2.default.setCommonProperty('A/B Test AIA Banner Learn More', testGroup);

        _RFC2.default.send('ConnectWeb Home Open', {
            'Devices OS': devices.map(function (device) {
                return device.attributes.os;
            }).filter(function (os) {
                return os;
            }).sort(),
            Source: Auth.loginSource || 'Direct',
            'Login Type': Auth.loginType || 'Refresh',
            Restricted: $rootScope.hasUsCompliance === false ? 'true' : 'false'
        });

        Auth.sendAcpPing();

        // save the login details object on local storage
        Util.updateLastLoginObjectInLocalStorage(user);

        $scope.$on('$stateChangeSuccess', function (event, toState, fromParam, fromState) {

            // scroll page up when state changes
            if (toState.name.indexOf('ltb') === -1 && fromState.name.indexOf('ltb') === -1) {

                $window.scrollTo(0, 0);
            }
        });

        if (localStorage.getItem('theme') === 'dark') {

            $rootScope.State.theme = 'dark';
        } else {

            $rootScope.State.theme = 'light';
        }

        // show welcome modal if coming from spotlight campaign
        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            // open spotlight welcome modal only for en and de
            if (CWCONFIG.language === 'en' || CWCONFIG.language === 'de') {

                this.$state.go('root.dashboard.home.ltb', {
                    ltb: 'welcome-modal-spotlight',
                    resourceId: 'aps10'
                });
            }

            /* remove TrialSourceSpotlight sessionStorage in order to show
               the welcome modal only once */
            sessionStorage.removeItem('TrialSourceSpotlight');
        }

        // broadcast when the user mouseover the sidebar
        $scope.broadcastMouseOver = function () {

            _RFC4.default.broadcast('mainControlls:hover');
        };

        $rootScope.mobileMenuAttribute = 'open-mobile-menu';

        _RFC4.default.subscribe('zendesk-chat:started', function () {

            if (window.zE) {

                window.zE('webWidget:on', 'chat:end', function () {

                    _RFC2.default.send('ConnectWeb Chat Closed');
                });
            }
        });

        $rootScope.cryptoCurrency = localStorage.getItem('CryptoCurrency') ? localStorage.getItem('CryptoCurrency') : 'USD';

        var nortonGuid = void 0;
        var token = Util.getToken();

        if (token) {

            var decodedToken = JWT.getTokenPayload(token);

            if ('aguid' in decodedToken) {

                nortonGuid = decodedToken.aguid;
            }
        }

        $rootScope.hideCryptoTab = true;
        var _CWCONFIG = CWCONFIG,
            cryptoRestApi = _CWCONFIG.cryptoRestApi;

        if (CWCONFIG.showCrypto) {

            $http({
                method: 'GET',
                url: cryptoRestApi + '/wallet/api/balance/' + nortonGuid + '/',
                headers: {
                    Authorization: 'Bearer ' + token,
                    'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
                }

            }).then(function (response) {

                if ($state.current.name === 'root.dashboard.crypto' || response.data.wallets.ETH.balance !== 0) {

                    $rootScope.hideCryptoTab = false;
                }
            }).catch(function (error) {

                if ($state.current.name === 'root.dashboard.crypto') {

                    $rootScope.hideCryptoTab = false;
                } else {

                    $rootScope.hideCryptoTab = true;
                }

                if (error.status !== 404) {

                    _RFC2.default.send('ConnectWeb Crypto Error', {
                        'Error Code': error.status,
                        'Error Name': error.data ? error.data : 'No error message',
                        Resource: 'GET balance'
                    });
                }
            });
        } else {

            $rootScope.hideCryptoTab = true;
            if ($state.current.name === 'root.dashboard.crypto') {

                $state.go('root.dashboard.home');
            }
        }

        // Code for displaying the DWM feature
        // if (CWCONFIG.dwm.showFeature) {

        //     this.$rootScope.showDWM = false;
        //     const dwmSupportedCountries = CWCONFIG.dwm.availableCountries;
        //     const isInSupportedCountries =
        //         dwmSupportedCountries.find(country => country === $rootScope.accountCountry);
        //     const hasDwmLicense = activationCodes.find(activationCode =>
        // activationCode.attributes.app === 'adwp1');
        //     const hasPrimeLicense = activationCodes.find(activationCode =>
        // activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20');

        //     if (isInSupportedCountries || hasDwmLicense || hasPrimeLicense) {

        //         this.$rootScope.showDWM = true;

        //     }

        // }

        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw
        var hasPrimeTrial = licenses.find(function (license) {
            return license.relationships.app.data.id === 'aps10' || license.relationships.app.data.id === 'aps20';
        });
        var hasPrimeLicense = activationCodes.find(function (activationCode) {
            return activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20';
        });

        if (!hasPrimeTrial && !hasPrimeLicense) {

            $rootScope.showPrimeTrialModal = true;
        }
        // OE-7619-cw-add-free-trial-card-when-users-are-dropping-the-purchase-process-in-cw


        var aviraToken = Util.getToken();

        var aiaStatusApiCall = function aiaStatusApiCall() {

            if (!$rootScope.showDwmLeftNavigation && window.location.pathname.indexOf('/dashboard/identity-assistant/') === -1) {

                $http({
                    method: 'POST',
                    url: CWCONFIG.dwm.statusURL,
                    headers: {
                        Authorization: 'Bearer ' + aviraToken
                    },
                    data: {
                        clientApplication: {
                            clientId: 'myavira'
                        }
                    }

                }).then(function (response) {

                    var dwmStatus = response.data || {};
                    $rootScope.dwmStatus = dwmStatus;

                    // root.hideAIACardInFreeStore
                    var aiaTileAction = Util.deepFind(dwmStatus, 'products.identityAssist.tileAction');
                    var dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

                    if (aiaTileAction === 'openUpsell') {

                        $rootScope.showAIACardInFreeStore = true;
                    }

                    if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                        $rootScope.showAIAWelcomeOfferBanner = true;
                    } else {

                        $rootScope.showAIAWelcomeOfferBanner = false;
                    }

                    var aiaStatus = Util.deepFind(dwmStatus, 'products.identityAssist');
                    var dwmLiteStatus = Util.deepFind(dwmStatus, 'products.dwmLite');

                    var aiaSubscriptionStatus = Util.deepFind(dwmStatus, 'products.identityAssist.subscriptionStatus');
                    var dwmLiteSubscriptionStatus = Util.deepFind(dwmStatus, 'products.dwmLite.subscriptionStatus');

                    var aiaSubscriptionCancelled = aiaSubscriptionStatus === 'cancelled' || aiaSubscriptionStatus === 'none';
                    var dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';

                    if ((aiaStatus || dwmLiteStatus) && (aiaSubscriptionCancelled || dwmLiteSubscriptionCancelled)) {

                        $rootScope.showDwmCardHomepage = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    _index.dwmRepository.replace('statusApi', dwmStatus);

                    if (aiaStatus || dwmLiteStatus) {

                        $rootScope.showDwmLeftNavigation = true;
                    }

                    $rootScope.dwmStatusLoaded = true;
                }).catch(function () {

                    $rootScope.showDwmLeftNavigation = false;
                    $rootScope.dwmStatusLoaded = true;
                });
            }
        };

        var purchaseListenerAia = $rootScope.$on('dwm_purchase_completed', function () {

            aiaStatusApiCall();
        });

        var purchaseListenerPrime = $rootScope.$on('prime_purchase_completed', function () {

            aiaStatusApiCall();
        });

        // End code for displaying the DWM feature

        //* Promotional Campaign : Create a global variable for displaying CMA disclaimer
        //* To be commented when the campaign is over
        // $rootScope.welcomeOffers = {};
        // $rootScope.createCMAlabels =
        //     (productId, productName, productAcronym, startDate, endDate) => {

        //         const firstYearPriceDetails = $rootScope.firstYearPrices[productAcronym];

        //         const formattedStartDate = new Date(startDate).getTime();
        //         const formattedEndDate = new Date(endDate).getTime();

        //         const currentAppPrices =
        //         AppPricesRepository.getSinglePrice(productAcronym, 12, 1);

        //         // do not show disclaimer for unsubscribe flexible promotion
        //         const promotionCode =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.code')
        //         const isUnsubscribePromotion = promotionCode === 'cw_unsubscribe_20';
        //         if (isUnsubscribePromotion) {

        //             return;

        //         }

        //         const currentPrice =
        // this.Util.deepFind(currentAppPrices, 'attributes.promotion.price');

        //         // Start code for banner label
        //         const pcPrice =
        //         this.Util.deepFind(firstYearPriceDetails, 'attributes.total_price');

        //         const firstYearPrice =
        // this.Util.deepFind(firstYearPriceDetails, 'attributes.total_price_string');

        //         const discountedPrice =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.total_price_string');

        //         const pcPriceString =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.pc_price_string');

        //         const promotionCurrency =
        //         this.Util.deepFind(currentAppPrices, 'attributes.promotion.currency');

        //         let currency = '';

        //         let priceDiff = Math.round(pcPrice - currentPrice).toFixed(2);

        //         if (discountedPrice) {

        //             currency = discountedPrice
        //                 .replace(/[0-9]/g, '').replace(/\./g, '').replace(/,/g, '');
        //             if (promotionCurrency === 'RUB') {

        //                 currency = currency.replace(/\s/g, '');
        //                 priceDiff =
        //     `${Math.round(pcPrice - currentPrice).toFixed(2)} ${currency}`;

        //             } else if (discountedPrice.indexOf(currency) > 0) {

        //                 priceDiff =
        //     `${Math.round(pcPrice - currentPrice).toFixed(2)}${currency}`;

        //             } else {

        //                 priceDiff =
        //     `${currency}${Math.round(pcPrice - currentPrice).toFixed(2)}`;

        //             }

        //         }

        //         $rootScope.welcomeOffers[productId] =
        //         {
        //             discountedPrice,
        //             firstYearPrice,
        //             product: productName,
        //             discountedAmount: priceDiff,
        //             renewalPrice: pcPriceString,
        //             startDate: moment(formattedStartDate).format('L'),
        //             endDate: moment(formattedEndDate).format('L'),
        //         };

        //     };

        $scope.$on('$destroy', function () {

            purchaseListenerAia();
            purchaseListenerPrime();
            activationCodesSubscriber.dispose();
        });
    }

    _createClass(Dashboard, [{
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {

            this.$rootScope.showMobileMenu = !this.$rootScope.showMobileMenu;

            if (this.$rootScope.showMobileMenu) {

                this.$rootScope.mobileMenuAttribute = 'close-mobile-menu';
            } else {

                this.$rootScope.mobileMenuAttribute = 'open-mobile-menu';
            }
        }
    }]);

    return Dashboard;
}();

_serviceDependencies.push(Dashboard);

angular.module('controllers').controller('Dashboard', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "KF23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.UserNotificationsRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */

var UserNotificationsRestService = function (_BaseRestService) {
    _inherits(UserNotificationsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function UserNotificationsRestService($http, $q, Util) {
        _classCallCheck(this, UserNotificationsRestService);

        return _possibleConstructorReturn(this, (UserNotificationsRestService.__proto__ || Object.getPrototypeOf(UserNotificationsRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.UserNotificationsRestService#getAllAsync
     * @methodOf rest.services.UserNotificationsRestService
     * @function
     *
     * @description
     * Retrieves the logged user and his friends.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(UserNotificationsRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(UserNotificationsRestService.prototype.__proto__ || Object.getPrototypeOf(UserNotificationsRestService.prototype), 'getAllAsync', this).call(this, 'user-notifications/');
        }

        /**
         * @ngdoc function
         * @name rest.services.UserNotificationsRestService#update
         * @methodOf rest.services.UserNotificationsRestService
         * @function
         *
         * @description
         * Updates a resource
         *
         * @param {string} userId UserId identifier
         * @param {object} payload Resource payload
         * @param {string} path API Resource path
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(userId, userPayload, headers) {

            return _get(UserNotificationsRestService.prototype.__proto__ || Object.getPrototypeOf(UserNotificationsRestService.prototype), 'update', this).call(this, userId, userPayload, 'user-notifications/', headers);
        }
    }]);

    return UserNotificationsRestService;
}(_baseRestService2.default);

exports.default = UserNotificationsRestService;


_serviceDependencies.push(UserNotificationsRestService);

angular.module('rest.services').service('UserNotificationsRestService', _serviceDependencies);

/***/ }),

/***/ "KI5/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ActionsRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/

var ActionsRestService = function (_BaseRestService) {
    _inherits(ActionsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function ActionsRestService($http, $q, Util) {
        _classCallCheck(this, ActionsRestService);

        return _possibleConstructorReturn(this, (ActionsRestService.__proto__ || Object.getPrototypeOf(ActionsRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.ActionsRestService#create
     * @methodOf rest.services.ActionsRestService
     * @function
     *
     * @description
     * Create an action
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(ActionsRestService, [{
        key: 'create',
        value: function create(payload) {

            return _get(ActionsRestService.prototype.__proto__ || Object.getPrototypeOf(ActionsRestService.prototype), 'create', this).call(this, payload, 'actions/');
        }
    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(ActionsRestService.prototype.__proto__ || Object.getPrototypeOf(ActionsRestService.prototype), 'getAllAsync', this).call(this, 'actions/');
        }
    }]);

    return ActionsRestService;
}(_baseRestService2.default);

exports.default = ActionsRestService;


_serviceDependencies.push(ActionsRestService);

angular.module('rest.services').service('ActionsRestService', _serviceDependencies);

/***/ }),

/***/ "KU+w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$filter', '$rootScope'];

var Homepage = function Homepage($scope, $filter, $rootScope) {
    _classCallCheck(this, Homepage);

    var user = _index.MeRepository.getMyUser();
    $scope.filterName = $filter('friendName')(user);
    var date = new Date();

    $scope.todayDate = moment(date).format('L');

    var onLicensesNext = function onLicensesNext(data) {

        $scope.numberOfLicenses = data.length;
    };

    this.licensesRepository = _index.LicensesRepository.getObservable();
    this.licensesSubscriber = this.licensesRepository.subscribe(function (data) {
        return onLicensesNext(data);
    }, function () {}, function () {});

    var onActivationCodesNext = function onActivationCodesNext(data) {

        // Hide subscriptions widget from homepage
        if (data.length) {

            $rootScope.hasSubscriptionOff = !$rootScope.cmaGBapplies ? data.find(function (activationCode) {
                return activationCode.attributes.subscription === 0;
            }) : false;

            if (!$rootScope.cmaGBapplies && !$rootScope.hasSubscriptionOff) {

                $rootScope.hideHomepageSubscriptionWidget = true;
            } else {

                $rootScope.hideHomepageSubscriptionWidget = false;
            }
        }
    };

    this.activationCodesRepository = _index.ActivationCodesRepository.getObservable();
    this.activationCodesSubscriber = this.activationCodesRepository.subscribe(function (data) {
        return onActivationCodesNext(data);
    }, function () {}, function () {});

    if (!$rootScope.hasUsCompliance) {

        $rootScope.showCmaDisclaimer.banner = false;
    }
};

_serviceDependencies.push(Homepage);

angular.module('controllers').controller('Homepage', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "KjhX":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content\">\n\n    <div>\n        <div class=\"device-icon-holder mb30\">\n            <div class=\"p-relative inline-block v-top\">\n                <div class=\"activate-subscription-img\"></div>\n            </div>\n        </div>\n\n        <h2 class=\"text-xxl text-grey-2 mb20\" translate=\"cw.subscription.activate_title\"></h2>\n        <p class=\"text-m text-grey-4 mb40\" translate=\"cw.subscription.activate_desc\"></p>\n    </div>\n\n\t<button class=\"btn btn-large btn-secondary mlr5\" ng-click=\"cancel()\" translate=\"cw.form.profile.cancel\"></button>\n\t<button class=\"btn btn-large btn-primary mlr5\" ng-click=\"confirm()\" translate=\"cw.general.ui.confirm\"></button>\n</div>\n";
var path = 'views/modals/activation-confirmation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "Kxtb":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("zOp4"),
    isSymbol = __webpack_require__("hyfS");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "L/rC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("poBF");

var _RFC = __webpack_require__("fIlE");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$location', '$anchorScroll'];

var AppPriceController = function AppPriceController($scope, $location, $anchorScroll) {
    _classCallCheck(this, AppPriceController);

    var appPricesProcessorObservable = _index.AppPricesProcessor.getObservable();

    $scope.showYearLabel = $scope.showyearlabel;
    $scope.showMonthLabel = $scope.showmonthlabel;
    $scope.showUpsellYearlyPrice = $scope.showupsellyearlyprice;
    $scope.showTotalPrice = $scope.showtotalprice;
    $scope.subscriptionMonths = $scope.subscriptionmonths || 12;
    $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
    $scope.showCmaLabel = $scope.showcmalabel;

    $scope.gotoAnchor = function (anchor) {

        $location.hash(anchor);
        $anchorScroll();
    };

    var onNextAppPricesProcessor = function onNextAppPricesProcessor() {

        $scope.appPrices = _index.AppPricesProcessor.getAll();
        var currentPriceID = $scope.appid;
        $scope.currentPrice = $scope.appPrices.find(function (price) {
            return price.id === currentPriceID;
        });

        if ($scope.currentPrice) {

            $scope.currentAnnual = $scope.appPrices.find(function (price) {
                return price.id === $scope.currentPrice.relationships.app.data.id + '_12_1';
            });
        }

        $scope.currentPrice.attributes.upsellYearlyPrice = $scope.checkUpsellYearlyPrice($scope.currentPrice.attributes.price, $scope.currentPrice.attributes.price_string);

        if ($scope.currentPrice.attributes.promotion) {

            $scope.currentPrice.attributes.promotion.upsellYearlyPrice = $scope.checkUpsellYearlyPrice($scope.currentPrice.attributes.promotion.price, $scope.currentPrice.attributes.promotion.total_price_string);
        }

        if ($scope.currentPrice && _RFC2.default.deepFind($scope.currentPrice, 'attributes.promotion')) {

            $scope.hasPromotion = true;
        } else {

            $scope.hasPromotion = false;
        }
    };

    $scope.$watch('appid', function () {

        onNextAppPricesProcessor();
    });

    $scope.checkUpsellYearlyPrice = function (price, priceString) {

        var monthlyPriceString = priceString;
        var yearlyPrice = price;

        // Calculate the new price (save it as a string)
        var newPrice = String(parseFloat(yearlyPrice / $scope.subscriptionMonths).toFixed(2));

        // Replace dot notation (if necessary)
        newPrice = monthlyPriceString.indexOf(',') > -1 ? newPrice.split('.').join(',') : newPrice;

        // Check digit positions
        var regex = new RegExp('\\d', 'g');
        var digit = void 0;
        var positions = [];
        // eslint-disable-next-line no-cond-assign
        while (digit = regex.exec(monthlyPriceString)) {

            positions.push(digit.index);
        }

        // Save the new price in the price_string format
        var upsellYearlyPrice = positions[0] === 0 ? newPrice.concat(monthlyPriceString.substring(positions[positions.length - 1] + 1)) : monthlyPriceString.substring(0, positions[0]).concat(newPrice);

        return upsellYearlyPrice;
    };

    this.appPricesRepositorySubscriber = appPricesProcessorObservable.subscribe(onNextAppPricesProcessor, function () {}, function () {});
};

var AppPriceDirective = function AppPriceDirective() {
    _classCallCheck(this, AppPriceDirective);

    this.template = __webpack_require__("cHGQ");
    this.restrict = 'EA';
    this.replace = true;

    this.scope = {
        appid: '=',
        showyearlabel: '=',
        showmonthlabel: '=',
        showupsellyearlyprice: '=',
        subscriptionmonths: '=',
        showtotalprice: '=',
        showcmalabel: '='
    };

    _controllerDependencies.push(function ($scope, $location, $anchorScroll) {
        return new AppPriceController($scope, $location, $anchorScroll);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'AppPriceCtrl';
};

_directiveDependencies.push(function () {
    return new AppPriceDirective();
});

angular.module('directives').directive('appPrice', _directiveDependencies);

/***/ }),

/***/ "L91C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint max-len: 0 */


var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _RFC = __webpack_require__("fIlE");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Device Processor - devices grouped by userId and device state (active/pending/hidden)
 */

var processedDevices = [];
var observableProcessedDevices = new Rx.BehaviorSubject(processedDevices);

/**
* @ngdoc service
* @name processors.DevicesProcessor
*
* @description
* This class is used to process devices.
*/
var DevicesProcessor = {

    /**
     * Replace all devices with received data
     * @param {Array} data
     */
    onNext: function onNext(data) {
        var _this = this;

        processedDevices = [];
        data.forEach(function (device) {
            return _this._addDevice(device);
        });
        observableProcessedDevices.onNext(processedDevices);
    },


    /**
     * Add device based on its userId and state
     * @param device
     */
    _addDevice: function _addDevice(device) {

        var userId = device.relationships.user.data.id;
        var state = device.attributes.state;


        processedDevices[userId] = processedDevices[userId] || {};
        processedDevices[userId][state] = processedDevices[userId][state] || [];
        processedDevices[userId][state].push(device);
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getAll
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed devices.
     *
     * @returns {Array} all processed devices
     */
    getAll: function getAll() {

        return processedDevices;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getByUserId
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function can be used to return devices of a specified user.
     *
     * @returns {Array} all processed devices
     */
    getByUserId: function getByUserId(userId) {

        return processedDevices[userId];
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#hasDisplayedDevices
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function can be used to check for displayed devices.
     * @returns {bool} true or false.
     */
    hasDisplayedDevices: function hasDisplayedDevices() {

        var index = _index.DevicesRepository.getAll().findIndex(function (_device) {
            return _index.DevicesRepository.isVisible(_device);
        });

        return index >= 0;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#hasAtLeastOneLaptopOrPc
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function can be used to check if the user has at least one visible PC or Laptop.
     * @returns {Object} Device object
     * @returns {Undefined} if devices was not found
     */
    hasAtLeastOneLaptopOrPc: function hasAtLeastOneLaptopOrPc() {

        var visibleDevices = _index.DevicesRepository.getVisibleDevices();

        return visibleDevices.find(function (device) {
            return device.attributes.type === 'pc' || device.attributes.type === 'laptop';
        });
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#hasAtLeastOnePhoneOrTablet
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function can be used to check if the user has at least one visible Phone or Tablet.
     * @returns {Object} Device object
     * @returns {Undefined} if devices was not found
     */
    hasAtLeastOnePhoneOrTablet: function hasAtLeastOnePhoneOrTablet() {

        var visibleDevices = _index.DevicesRepository.getVisibleDevices();

        return visibleDevices.find(function (device) {
            return device.attributes.type === 'phone' || device.attributes.type === 'tablet';
        });
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getDevicesByApp
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function returns the devices which have the specified app installed.
     *
     * @param {Object} app the object of the specified app.
     *
     * @returns {Array} devices which have the app installed.
     */
    getDevicesByApp: function getDevicesByApp(app) {

        var instances = [];
        var devices = [];

        if (!app) {

            return instances;
        }

        instances = _index2.AppInstancesProcessor.getInstancesByPrototype(_index.MeRepository.getMyId(), app.attributes.prototype);

        _.values(instances).forEach(function (instance) {

            if (_RFC2.default.deepFind(instance, 'relationships.device')) {

                var device = _index.DevicesRepository.getById(instance.relationships.device.data.id);
                if (!_.contains(devices, device) && _index.DevicesRepository.isVisible(device)) {

                    devices.push(device);
                }
            }
        });

        return devices;
    },

    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getDevicesByApp
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function returns the devices which have the specified app installed.
     *
     * @param {string} licenseId.
     *
     * @returns {Array} devices which have the app installed.
     */
    getDevicesByLicenseId: function getDevicesByLicenseId(licenseId) {

        var instances = [];
        var devices = [];

        instances = _index2.AppInstancesProcessor.getInstancesByLicenseId(_index.MeRepository.getMyId(), licenseId);

        instances.forEach(function (instance) {

            if (instance.attributes.state === 'active') {

                var device = _index.DevicesRepository.getById(instance.relationships.device.data.id);

                if (device) {

                    var indexOfdevice = devices.findIndex(function (item) {
                        return item.id === instance.relationships.device.data.id;
                    });

                    if (indexOfdevice === -1) {

                        if (device.attributes.hidden === false && device.attributes.state !== 'pending') {

                            devices.push(device);
                        }
                    }
                }
            }
        });
        return devices;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getFirstDeviceOf
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function calculates the selected device which has the specified app installed.
     * If the app is not installed on any device, return 'new'.
     *
     * @param {Object} app the specified app.
     *
     * @returns {Object} the selected device for that app.
     */
    getFirstDeviceOf: function getFirstDeviceOf(app) {

        var devices = this.getDevicesByApp(app);
        return devices.length ? devices[0] : null;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getFirstMobileDeviceOf
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function calculates the selected mobile device which has the specified app installed.
     * If the app is not installed on any mobile device, return 'new'.
     *
     * @param {Object} app the specified app.
     *
     * @returns {Object} the selected mobile device for that app.
     */
    getFirstMobileDeviceOf: function getFirstMobileDeviceOf(app) {

        var devices = this.getDevicesByApp(app);
        var mobileDevices = void 0;

        if (devices) {

            mobileDevices = devices.filter(function (device) {
                return device.attributes.type === 'phone' || device.attributes.type === 'tablet';
            });
        }
        return mobileDevices.length ? mobileDevices[0] : null;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getLocation
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * Returns the location of a device.
     *
     * @param {int} userId the user.
     * @param {String} prototype the prototype of the family locator service.
     * @param {Object} device the device object.
     *
     * @returns {Object} the location of the device.
     */
    getLocation: function getLocation(userId, prototype, device) {

        var instances = _index2.AppInstancesProcessor.getInstancesByPrototypeAndDevice(userId, prototype, device);

        if (!instances.length) {

            return undefined;
        }

        var locationInstance = instances.find(function (instance) {
            return _index2.AppInstancesProcessor.hasLocationInfo(instance);
        });

        return _RFC2.default.deepFind(locationInstance, 'attributes.status.LOCATE');
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#hasAvInstalled
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * Checks if the device has antivirus installed.
     *
     * @param {String} userId the user id.
     * @param {String} deviceId the device id.
     * @returns {Boolean} True if the device has av installed.
     */
    hasAvInstalled: function hasAvInstalled(userId, deviceId) {

        var deviceInstances = _index2.AppInstancesProcessor.getInstancesByDevice(userId, deviceId);

        var avInstance = _.values(deviceInstances).find(function (instance) {

            if (instance.attributes.state !== 'active') {

                return false;
            }

            if (instance.customAppInfo.prototype === 'antivirus') {

                return true;
            }

            var appId = _RFC2.default.deepFind(instance, 'relationships.app.data.id');
            // if antivirus is installed on the phone
            if (appId === CWCONFIG.defaultDeployedAppId.android || appId === CWCONFIG.defaultDeployedAppId.ios || appId === 'aasc0' || appId === 'mspa0' || appId === 'mspi0') {

                return true;
            }

            return false;
        });

        return !!avInstance;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getDeployOSfor
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * We use this function to find a suitable deployment os for a product and a device we're on
     * if one exists
     * @returns {String} a valid os on which to deploy a product.
     */
    getDeployOSfor: function getDeployOSfor(appId, currentDeviceOS) {

        var os = void 0;

        if (currentDeviceOS === 'mac_os_x') {

            currentDeviceOS = 'osx';
        }

        var osList = _index.AppIntegrationsRepository.getSupportedOs(appId);

        if (osList && osList.length > 0) {

            os = osList.filter(function (osName) {
                return currentDeviceOS.indexOf(osName) > -1;
            });
            if (os.length === 0) {

                os = null;
            } else {
                // we want to return a string;

                var _os = os;

                var _os2 = _slicedToArray(_os, 1);

                os = _os2[0];
            }
        }

        return os;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#getCompatibleDevices
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function returns the list of pc and laptop
     * existing devices on which an integration may be installed.
     *
     * @param {string} appIntegrationId id of integration
     * @param {string} prototype of integration
     *
     * @returns {Array} Array with the devices on which the integration may be installed.
     */
    getCompatibleDevices: function getCompatibleDevices(appIntegrationId, prototype) {

        var compatibleDevices = [];
        var userId = _index.MeRepository.getMyId();
        var displayedDevices = _index.DevicesRepository.getByState(['online', 'offline'], false);

        if (!displayedDevices) {

            return compatibleDevices;
        }

        displayedDevices.forEach(function (device) {

            if (!_index.DevicesRepository.isMobile(device.id) && _index.DevicesRepository.isDeviceCompatibleWithIntegration(device.id, appIntegrationId) && !_index2.AppInstancesProcessor.getByAppPrototypeAndDevice(userId, prototype, device.id)) {

                compatibleDevices.push(device);
            }
        });

        return compatibleDevices;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#detectLicenseType
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function returns a list of devices and info about the license installed on them
     *
     * @param {Array} devices
     *
     * @returns {Array} Array with devices with the updated info about licenses
     */

    detectLicenseType: function detectLicenseType(devices) {

        var expireNotificationDays = CWCONFIG.subscriptionExpirationReminderDays || 15;
        var currentDateInMiliseconds = new Date().getTime();

        if (devices && devices.length) {

            devices.forEach(function (device) {

                device.attributes.licenses = [];
                device.attributes.showLicenseWarning = false;

                var deviceAppInstances = _index2.AppInstancesProcessor.getInstancesByDevice(device.relationships.user.data.id, device.id);

                if (deviceAppInstances) {

                    deviceAppInstances.forEach(function (instance) {

                        if (instance && instance.attributes.state === 'active') {

                            device.attributes.hasInstances = true;

                            var instanceLicense = _index.LicensesRepository.getLicenseById(instance.relationships.license.data.id);

                            if (instanceLicense) {

                                var integrationDetails = _index.AppIntegrationsRepository.getById(instanceLicense.relationships.app.data.id);

                                if (integrationDetails) {

                                    // make sure not to store doubles
                                    var oeName = integrationDetails.attributes.resource.oeName;


                                    if (device.attributes.licenses.indexOf(oeName) === -1) {

                                        device.attributes.licenses.push(oeName);
                                    }
                                }

                                if (CWCONFIG.devices.bundles.indexOf(instanceLicense.relationships.app.data.id) > -1) {

                                    device.attributes.hasBundle = true;
                                }

                                // check if the license expires to display the warning tooltip
                                var expirationDate = instanceLicense.attributes.expiration_date;
                                var appId = instanceLicense.relationships.app.data.id || '';

                                if (expirationDate) {

                                    var subscriptionExpirationDateInMs = moment(expirationDate).valueOf();
                                    var remainingDaysUntilExpiration = Math.ceil(moment.duration(subscriptionExpirationDateInMs - currentDateInMiliseconds).asDays());

                                    if (remainingDaysUntilExpiration <= expireNotificationDays && instanceLicense.attributes.subscription === 0 && !_RFC2.default.isNonrenewableApp(appId)) {

                                        device.attributes.showLicenseWarning = true;
                                    }
                                }
                            } else {

                                // Check if the license is not compatible with the device os
                                var licensesByOs = _index.LicensesRepository.getLicensesByOs(device.attributes.os);

                                if (licensesByOs && licensesByOs.length === 0) {

                                    device.attributes.hasIncompatibleLicense = true;
                                }
                            }
                        }
                    });
                }
            });
        }

        return devices;
    },


    /**
     * @ngdoc function
     * @name processors.DevicesProcessor#detectFreeProducts
     * @methodOf processors.DevicesProcessor
     * @function
     *
     * @description
     * This function returns a list of devices and info about the free products installed on them
     *
     * @param {Array} devices
     *
     * @returns {Array} Array with devices with the updated info about free products installed
     */

    detectFreeProducts: function detectFreeProducts(devices) {

        if (devices && devices.length) {

            devices.forEach(function (device) {

                device.attributes.freeProductsInstalled = [];

                var deviceAppInstances = _index2.AppInstancesProcessor.getInstancesByDevice(device.relationships.user.data.id, device.id);

                if (deviceAppInstances) {

                    deviceAppInstances.forEach(function (instance) {

                        if (instance && instance.attributes.state === 'active' && instance.customAppInfo.visible && instance.customAppInfo.visible !== 0) {

                            if (instance.relationships.license.data.id.includes('-0-') || instance.relationships.license.data.id.slice(-2) === '-0') {

                                device.attributes.freeProductsInstalled.push(instance.customAppInfo.name);
                            }
                        }
                    });
                }
            });
        }

        return devices;
    },


    /**
    * @ngdoc function
    * @name processors.DevicesProcessor#getObservable
    * @methodOf processors.DevicesProcessor
    * @function
    *
    * @description
    * This function can be used to get an observable object for processed devices.
    * @returns {Object} an observable object for processed devices.
    */
    getObservable: function getObservable() {

        return observableProcessedDevices;
    }
};

var subjectDevicesRepository = _index.DevicesRepository.getObservable();

subjectDevicesRepository.subscribe(function (data) {
    return DevicesProcessor.onNext(data);
}, function () {}, function () {});

exports.default = DevicesProcessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta"), __webpack_require__("9dPI")))

/***/ }),

/***/ "LBU6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var os = {
    name: '',
    version: ''
};

var userAgent = window.navigator.userAgent;


if (userAgent.indexOf('Windows') !== -1) {

    os.name = 'Windows';

    if (userAgent.indexOf('Windows NT 5.1') !== -1) {

        os.version = 'XP';
    } else if (userAgent.indexOf('Windows NT 6.1') !== -1) {

        os.version = '7';
    } else if (userAgent.indexOf('Windows NT 6.0') !== -1) {

        os.version = 'Vista';
    } else if (userAgent.indexOf('Windows NT 6.2') !== -1) {

        os.version = '8';
    } else if (userAgent.indexOf('Windows NT 5.0') !== -1) {

        os.version = '2000';
    }
} else if (userAgent.indexOf('Mac') !== -1) {

    os.name = 'Mac/iOS';
} else if (userAgent.indexOf('Linux') !== -1) {

    os.name = 'Linux';
} else if (userAgent.indexOf('X11') !== -1) {

    os.name = 'UNIX';
} else if (userAgent.indexOf('sunos') !== -1) {

    os.name = 'Solaris';
} else {

    os.name = userAgent.replace(/_/g, '.');
}

os.fullVersion = os.name + ' ' + os.version;

var OSBrowserDetection = {
    OS: os.name,
    OSVersion: os.fullVersion,
    getOSVersion: function getOSVersion() {
        return os.fullVersion;
    }
};

exports.default = OSBrowserDetection;

/***/ }),

/***/ "LCDH":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content large-modal-holder deploy-modal\" connectqa-modal=\"deploy-modal\">\n    <deploy-breadcrumb \n        inputdata=\"inputData\"\n        changewizard=\"changeWizard\">\n    </deploy-breadcrumb>\n    <deployment-wizard-generator\n        dynamic-directive-tag=\"dynamicDirectiveTag\"\n        input-data=\"inputData\"\n        change-wizard=\"changeWizard\"\n        show-success-screen=\"showSuccessScreen\"\n        deploy-on-device-success=\"deployOnDeviceSuccess\">\n    </deployment-wizard-generator>\n</div>\n\n";
var path = 'views/modals/deploy.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "LEPB":
/***/ (function(module, exports) {

module.exports = "<div>\n    <!-- Banner Type 1 -->\n    <!-- <div class=\"welcome-offer\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w60 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 top1 w70\">\n                    <h3 class=\"text-xxl uppercase text-orange-2 mt5\"\n                        translate=\"cw.offer.discount\"\n                        translate-values=\"{ percent: discount }\"></h3>\n\n                    <p class=\"text-grey-2 text-m\"\n                       translate={{translationKeys.discountDesc}}\n                       translate-values=\"{ percent: discount }\"></p>\n\n                    <a class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\" ng-click=\"welcomeOfferCtrl.learnMore()\" translate={{translationKeys.learnMore}}></a>\n                </div>\n            </div>\n\n            <div class=\"w39 inline-block text-right top1\">\n                <div class=\"v-middle inline-block text-l font-medium top1 w40 mr20\">\n                    <span class=\"text-grey-2 uppercase inside-text-orange\"\n                          translate=\"cw.offer.voucher\"\n                          translate-values=\"{ voucher: voucher}\"></span>\n                </div>\n\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary\"\n                       ng-click=\"welcomeOfferCtrl.getOffer()\"\n                       translate={{translationKeys.button}}></a>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close()\"></a>\n\n        </div> -->\n\n    <!-- Banner Type 2 -->\n    <!-- <div class=\"welcome-offer version-2\"\n            ng-if=\"isOfferActive &&\n                   (!welcomeOfferWasClosed || !hideInSubscription) &&\n                   !hasOfferSubscriptions\">\n\n           <div class=\"w30 inline-block text-left v-middle\">\n                <div class=\"v-middle inline-block top1 version-2-bg black-friday\">\n                    <h3 class=\"text-m font-medium uppercase text-grey-2\"\n                        translate=\"cw.offer.discount\"\n                        translate-values=\"{ percent: discount }\"></h3>\n                </div>\n           </div>\n\n           <div class=\"w69 inline-block text-right top1 v-middle\">\n\n               <div class=\"v-middle inline-block top1 version-2-info-text\">\n                    <p class=\"text-grey-2 uppercase inside-text-white text-l font-medium mb10\"\n                         translate=\"cw.offer.voucher\"\n                         translate-values=\"{ voucher: voucher}\"></p>\n\n                    <p class=\"text-grey-2 text-m\"\n                       translate={{translationKeys.discountDesc}}\n                       translate-values=\"{ percent: discount }\"></p>\n\n                    <a class=\"text-s inline-block text-grey-5 crs-pointer underline mb5\" ng-click=\"welcomeOfferCtrl.learnMore()\" translate={{translationKeys.learnMore}}></a>\n                </div>\n\n               <div class=\"v-middle inline-block ml20\">\n                   <a class=\"btn btn-large btn-primary\"\n                      ng-click=\"welcomeOfferCtrl.getOffer()\"\n                      translate={{translationKeys.button}}></a>\n               </div>\n           </div>\n\n           <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close()\"></a>\n\n        </div> -->\n\n\n    <!-- Banner Type 3 -->\n    <!-- <div class=\"welcome-offer version-3\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w80 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img version-3\"></div>\n                </div>\n                <div class=\"v-top inline-block\">\n                    <div class=\"year-img version-3\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml15 top1 w64\">\n                    <h3 class=\"text-xxxl text-white mt5\" translate=\"cw.banner.new_year.title\"></h3>\n\n                    <p class=\"text-white text-m mt5\">\n                        <span translate=\"cw.banner.new_year.desc\"\n                              translate-values=\"{ percent: discount, brandname: brandName, product: product }\"></span>\n                        <a class=\"text-m inline-block text-white underline crs-pointer underline-hover mt5\"\n                           ng-click=\"welcomeOfferCtrl.learnMore()\"\n                           translate={{translationKeys.learnMore}}></a>\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w19 inline-block text-right top1\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary p-relative\"\n                       ng-click=\"welcomeOfferCtrl.getOffer()\">\n                       <span translate={{translationKeys.button}}></span>\n                       <span class=\"banner-sticker\"\n                             translate=\"cw.banner.discount_sticker\"\n                             translate-values=\"{ percent: discount }\"></span>\n                    </a>\n\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close()\"></a>\n\n        </div> -->\n\n    <!-- Banner Type 4 - no voucher code -->\n\n    <!-- <div class=\"welcome-offer version-no-discount\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w70 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img static\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 top1 w80\">\n                    <h3 class=\"text-xxl uppercase text-orange-2 mt5 mb5\"\n                        translate=\"cw.offer.discount\"\n                        translate-values=\"{ percent: discount }\"></h3>\n\n                    <p class=\"text-grey-2 text-m\"\n                       translate={{translationKeys.discountDesc}}\n                       translate-values=\"{ percent: discount }\"></p>\n\n                    <a class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\" ng-click=\"welcomeOfferCtrl.learnMore()\" translate={{translationKeys.learnMore}}></a>\n                </div>\n            </div>\n\n            <div class=\"w29 inline-block text-right top1\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary\"\n                       ng-click=\"welcomeOfferCtrl.getOffer('Static')\"\n                       translate={{translationKeys.button}}></a>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close('Static')\"></a>\n\n        </div> -->\n\n    <!-- Live Animated gif LIVE 2020\n    <div ng-if=\"bannerVariant === '0' && !hasTPLinkLicence\">\n        <div class=\"welcome-offer version-no-discount\"\n            ng-if=\"isOfferActive &&\n                            (!welcomeOfferWasClosed || !hideInSubscription) &&\n                            !hasOfferSubscriptions\">\n\n            <div class=\"w70 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 top1 w80\">\n                    <h3 class=\"text-xxl uppercase text-orange-2 mt5 mb5\" translate=\"cw.offer.discount\"\n                        translate-values=\"{ percent: discount }\"></h3>\n\n                    <p class=\"text-grey-2 text-m\" translate={{translationKeys.discountDesc}}\n                        translate-values=\"{ product : product }\"></p>\n\n                    <a  ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                        class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"\n                        ng-click=\"welcomeOfferCtrl.learnMore()\" translate={{translationKeys.learnMore}} translate-values=\"{product: product, brandname: brandName}\"></a>\n                    <ocp-button classname='\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"'\n                        translationkey='translationKeys.learnMore'\n                        action='\"Learn More\"'\n                        productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                        runtime='\"12\"'\n                        page=\"pageName\"></ocp-button>\n                </div>\n            </div>\n\n            <div class=\"w29 inline-block text-right top10\">\n\n                <div class=\"v-middle inline-block\">\n                    <button class=\"btn btn-large btn-primary\"\n                        ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                        ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\"\n                        translate={{translationKeys.button}}></button>\n\n                    <ocp-button classname='\"btn btn-large btn-primary\"'\n                        translationkey='translationKeys.button'\n                        action='\"Update\"'\n                        productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                        runtime='\"12\"'\n                        page=\"pageName\"></ocp-button>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n                ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n\n        </div>\n    </div> -->\n\n\n\n    <!-- generic banner template with price/discounted price  -->\n    <div ng-if=\"!hasTPLinkLicence && showDefaultBanner\">\n        <div class=\"welcome-offer version-discount-price\" ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w64 inline-block text-left white-space-nowrap\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 top1 w75 white-space-normal\">\n\n\n                    <h3 class=\"text-xxl text-orange-2 mt5 mb5\">\n                        <span ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\" translate=\"cw.offer.title_prime\"></span>\n                        <span ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'isec0'\" translate=\"cw.ocp.isec_one_liner\"></span>\n                        <div class='info-tooltip-holder inline-block v-middle ml5'\n                            ng-if=\"(hasIsecComponents || product === 'Prime') && activationCodesRepoLength > 0 && !hasOnlyAia\">\n                            <i class=\"icon icon-info icon-xxs icon-grey-4 v-middle inline-block\"></i>\n                            <div class=\"info-tooltip arrow-left\" translate=\"cw.cma.remaining_runtime\">\n                            </div>\n                        </div>\n                    </h3>\n                    <p class=\"text-grey-2 text-m\" ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\" translate={{translationKeys.discountDesc}}\n                        translate-values=\"{ product: product }\"></p>\n                    <p class=\"text-grey-2 text-m\" ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'isec0'\" translate={{translationKeys.discountDesc}}\n                        translate-values=\"{ product: 'Avira '+product }\"></p>\n\n                    <a ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                        class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"\n                        ng-click=\"welcomeOfferCtrl.learnMore();welcomeOfferCtrl.sendMixpanelLearnMore()\" translate={{translationKeys.learnMore}}\n                        translate-values=\"{product: product, brandname: brandName}\"\n                        ng-click=\"welcomeOfferCtrl.sendMixpanelLearnMore()\"></a>\n                    <ocp-button classname='\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"'\n                        translationkey='translationKeys.learnMore'\n                        translationvalues=\"{product: product, brandname: brandName}\" action='\"Learn More\"'\n                        productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"' page=\"pageName\"\n                        xacontent='\"banner_main_ocp_\"'\n                        xamedium='\"banner_main_ocp_\"'\n                        ng-click=\"welcomeOfferCtrl.sendMixpanelLearnMore();\"></ocp-button>\n                </div>\n            </div>\n\n            <div class=\" w35 v-middle inline-block text-right top1\">\n\n                <div class=\"inline-block offer-group\">\n                    <app-price appid='welcomeOfferCtrl.currentOffer.productId + \"_12_1\"' showyearlabel=\"true\" showcmalabel=\"true\"  class=\"offer-prices\">\n                    </app-price>\n                    <div>\n                        <button ng-if=\"!showOPCButton || !isOneClickPaymentEnable\" class=\"btn btn-medium btn-primary\"\n                            ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\"\n                            translate={{translationKeys.button}}></button>\n                        <ocp-button classname='\"btn btn-medium btn-primary\"' translationkey='translationKeys.button'\n                            action='\"Update\"' productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"'\n                            page=\"pageName\"\n                            xacontent='\"banner_main_ocp_\"'\n                            xamedium='\"banner_main_ocp_\"'></ocp-button>\n                    </div>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n                ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n        </div>\n    </div>\n\n    <!-- A/B Test Identity Assistant Banner -->\n    <div ng-if=\"!hasTPLinkLicence && showIdentityAssistantBanner\">\n        <div class=\"welcome-offer version-discount-price identity-assitant-background\"\n            ng-class=\"{\n                'no-price': $root.aiaBannerVariant === 'test'\n            }\"\n            ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w64 inline-block text-left white-space-nowrap\">\n\n                <div class=\"v-middle inline-block ml20 top1 w75 white-space-normal identity-assistant-text\">\n\n                    <h3 class=\"text-xl mt25 font-bold mb10\">\n                        <span translate=\"cw.offer_aia.higher_banner.title\"></span>\n                    </h3>\n                    <p class=\"text-grey-3 text-m\" translate=\"cw.offer_aia.higher_banner.desc\"></p>\n\n                    <a class=\"btn btn-medium btn-primary mt50 mb30\"\n                        translate=\"cw.dashboard.services.mkt\"\n                        ng-click=\"welcomeOfferCtrl.sendMixpanelLearnMore(); welcomeOfferCtrl.redirectToUpsellPage();\"\n                        ng-if=\"$root.aiaBannerVariant === 'test'\"></a>\n\n                    <a class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"\n                        translate={{translationKeys.learnMore}}\n                        translate-values=\"{product: product, brandname: brandName}\"\n                        ng-click=\"welcomeOfferCtrl.sendMixpanelLearnMore(); welcomeOfferCtrl.redirectToUpsellPage();\"\n                        ng-if=\"$root.aiaBannerVariant === 'control'\"></a>\n\n                    <div class=\"identity-assistant-cta-section\" ng-if=\"$root.aiaBannerVariant === 'control'\">\n\n                        <app-price appid='welcomeOfferCtrl.currentOffer.productId + \"_12_1\"' showyearlabel=\"true\" showcmalabel=\"true\"  class=\"offer-prices\">\n                        </app-price>\n                        <div>\n                            <button class=\"btn btn-medium btn-primary\" ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                                translate={{translationKeys.button}}\n                                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n                            </button>\n                            <ocp-button classname='\"btn btn-medium btn-primary\"' translationkey='translationKeys.button'\n                                action='\"Update\"' productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"' page=\"pageName\" xacontent='\"banner_main_ocp_\"'\n                                xamedium='\"banner_main_ocp_\"'>\n                            </ocp-button>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n                ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n        </div>\n    </div>\n\n    <!-- Banner Type 5 Easter -->\n    <!-- <div class=\"welcome-offer version-4\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w80 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img version-4 {{ welcomeOfferCtrl.currentOffer.productId }}\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block top1 w64\">\n                    <h3 class=\"text-xxxl text-white\" translate=\"cw.banner.easter.title\"></h3>\n\n                    <p class=\"text-m text-white font-regular mt5\">\n                        <span translate=\"cw.banner.easter.desc\"\n                              translate-values=\"{ percent: discount, product: welcomeOfferCtrl.currentOffer.product }\"></span>.\n                        <a class=\"text-m inline-block text-white underline crs-pointer underline-hover\"\n                           ng-click=\"welcomeOfferCtrl.learnMore()\"\n                           translate={{translationKeys.learnMore}}></a>\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w19 inline-block text-right\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary p-relative\"\n                       ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n                       <span translate={{translationKeys.button}}></span>\n                       <span class=\"banner-sticker\"\n                             translate=\"cw.banner.discount_sticker\"\n                             translate-values=\"{ percent: discount }\"></span>\n                    </a>\n\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-white icon-xxxs\"\n               ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n\n        </div> -->\n\n    <!-- Banner Type 6 -->\n    <!-- <div class=\"welcome-offer version-with-box-shot display-none\"\n             id=\"welcomeBannerVariantA\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w75 inline-block text-left\">\n                <div class=\"v-middle inline-block prime-box-shot-holder\">\n                    <div class=\"prime-box-shot\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 top1 w75\">\n                    <h3 class=\"text-xxl uppercase text-orange-2 mt5 mb5\"\n                        translate=\"cw.offer.discount\"\n                        translate-values=\"{ percent: discount }\"></h3>\n\n                    <p class=\"text-grey-2 text-m\"\n                       translate={{translationKeys.discountDesc}}\n                       translate-values=\"{ product : welcomeOfferCtrl.currentOffer.product }\"></p>\n\n                    <a class=\"text-m inline-block text-blue-3 crs-pointer underline-hover mt5\" ng-click=\"welcomeOfferCtrl.learnMore()\" translate={{translationKeys.learnMore}}></a>\n                </div>\n            </div>\n\n            <div class=\"w24 inline-block text-right top1\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary\"\n                       ng-click=\"welcomeOfferCtrl.getOffer('Static')\"\n                       translate={{translationKeys.button}}></a>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close('Static')\"></a>\n\n        </div> -->\n\n    <!-- Banner Type 7 Late Summer -->\n    <!-- <div class=\"welcome-offer version-5\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w80 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img version-4 {{ welcomeOfferCtrl.currentOffer.productId }}\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block top1 w64\">\n                    <div class=\"text-m banner-white-ribbon\">\n                        <span class=\"inline-block v-middle\" translate=\"cw.banner.ribbon_limited_time\"></span>\n                        <span class=\"inline-block v-middle ribbon-holder\"></span>\n                    </div>\n                    <h3 class=\"text-xxl text-white\" translate=\"cw.banner.late_summer.desc\"\n                        translate-values=\"{ percent: discount, product: welcomeOfferCtrl.currentOffer.product }\"></h3>\n\n                    <p class=\"text-m text-white font-regular mt5\">\n                        <a class=\"text-m inline-block text-white underline crs-pointer underline-hover\"\n                           ng-click=\"welcomeOfferCtrl.learnMore()\"\n                           translate={{translationKeys.learnMore}}></a>\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w19 inline-block text-right\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary p-relative\"\n                       ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n                       <span translate={{translationKeys.button}}></span>\n                       <span class=\"banner-sticker\"\n                             translate=\"cw.banner.discount_sticker\"\n                             translate-values=\"{ percent: discount }\"></span>\n                    </a>\n\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-3 icon-xxxs\"\n               ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\" style=\"top:7px;\"></a>\n\n        </div> -->\n\n    <!-- Black - Friday 2019 -->\n    <!-- <div class=\"welcome-offer version-5 {{welcomeOfferCtrl.currentOffer.productId}}\"\n             ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w80 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img version-4 {{ welcomeOfferCtrl.currentOffer.productId }}\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block top1 w69\">\n                    <h3 class=\"text-xxl text-white\"\n                        translate={{translationKeys.title}}\n                        translate-values=\"{ percent: discount, product: welcomeOfferCtrl.currentOffer.product }\"></h3>\n\n                    <p class=\"text-l text-white mt10\" >\n                        <span translate={{translationKeys.discountDesc}}></span>\n\n                        <a class=\"text-l inline-block text-white crs-pointer underline\"\n                        ng-click=\"welcomeOfferCtrl.learnMore()\"\n                        translate={{translationKeys.learnMore}}\n                        translate-values=\"{ product: welcomeOfferCtrl.currentOffer.product }\">\n                     </a>\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w19 inline-block text-right\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary p-relative\"\n                       ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n                       <span translate={{translationKeys.button}}></span>\n                    </a>\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-white icon-xxxs\"\n               ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\" style=\"top:7px;\"></a>\n\n        </div> -->\n\n    <!-- Banner Type winter campaign-->\n    <!-- <div class=\"welcome-offer version-4\"\n            ng-if=\"isOfferActive &&\n                    (!welcomeOfferWasClosed || !hideInSubscription) &&\n                    !hasOfferSubscriptions\">\n\n            <div class=\"w80 inline-block text-left\">\n                <div class=\"v-middle inline-block\">\n                    <div class=\"gift-img version-4 {{ welcomeOfferCtrl.currentOffer.productId }}\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block top1 w64\">\n                    <h3 class=\"text-xxxl mt5\" translate=\"cw.banner.winter.title\"></h3>\n\n                    <p class=\"text-m mt5 text-black\">\n                        <span translate=\"cw.banner.winter.desc\"\n                            translate-values=\"{ percent: discount, brandname: brandName, product: productPrime }\"></span>.\n                        <a class=\"text-m inline-block text-black underline crs-pointer underline-hover mt5\"\n                        ng-click=\"welcomeOfferCtrl.learnMore()\"\n                        translate={{translationKeys.learnMore}}></a>\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w19 inline-block text-right\">\n                <div class=\"v-middle inline-block\">\n                    <a class=\"btn btn-large btn-primary p-relative\"\n                    ng-click=\"welcomeOfferCtrl.getOffer()\">\n                    <span translate={{translationKeys.button}}></span>\n                    <span class=\"banner-sticker\"\n                            translate=\"cw.banner.discount_sticker\"\n                            translate-values=\"{ percent: discount }\"></span>\n                    </a>\n\n                </div>\n            </div>\n\n            <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\" ng-click=\"welcomeOfferCtrl.close()\"></a>\n\n        </div> -->\n\n    <!-- Summer Campaign 2021-->\n    <!-- <div class=\"welcome-offer campaign centerFlex\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        hideBannerForThisSession &&\n        !hasOfferSubscriptions\">\n\n        <div class=\"w64 inline-block text-left\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\" class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <div class=\"counter-holder mb5\">\n                    <div class=\"counter text-white inline-block text-xs\">\n                        <span translate=\"cw.offer.ends_in\">Ends in:</span>\n                        <time-counter endtime='endCampaignDay'></time-counter>\n                    </div>\n                </div>\n\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-black text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5' && language !== 'de'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: '' }\"\n                    class=\"text-black text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5' && language === 'de'\"\n                    translate=\"cw.offer.campaign_avpro\"\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        price: price }\"\n                    class=\"text-black text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\">\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\">\n            </ocp-button>\n        </div>\n\n    </div> -->\n\n    <!-- Feb 2022 campaign -->\n    <!-- <div class=\"welcome-offer mid-june-campaign centerFlex campaign\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions && showAvBanner\">\n\n        <div class=\"w64 inline-block text-left\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10' || welcomeOfferCtrl.currentOffer.productId === 'aps20'\" class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps20'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: '' }\"\n                    class=\"text-white text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\">\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\"\n                xacontent='\"banner_main_ocp_\"'\n                xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n    </div>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        translate=\"cw.offer4.campaign_disclaimer\"\n        translate-values=\"{\n            totalPriceString : totalPriceString,\n            priceDiff: priceDiff,\n            pcPriceString: pcPriceString }\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showAvBanner\">\n    </p> -->\n    <!-- Feb 2022 campaign -->\n\n    <!-- Upsell Prime 25 -->\n    <div class=\"welcome-offer centerFlex campaign-prime-25\" ng-if=\"isOfferActive && showUpsellPrime25 && !welcomeOfferWasClosed\">\n\n        <div class=\"w70 inline-block text-left\">\n            <div class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <h2 class=\"text-grey-1 font-bold\" >\n                    <span translate={{translationKeys.title}}\n                        class=\"inline-block v-middle\"></span>\n                    <div class='info-tooltip-holder inline-block v-middle ml5'>\n                        <i class=\"icon icon-info icon-xxs icon-grey-4 v-middle inline-block\"></i>\n                        <div class=\"info-tooltip arrow-left\" translate=\"cw.cma.remaining_runtime\">\n                        </div>\n                    </div>\n                </h2>\n                <p class=\"text-m text-grey-3\" translate={{translationKeys.description}}></p>\n            </div>\n        </div>\n\n        <div class=\"w29 text-right v-middle inline-block\">\n            <div class=\"inline-block offer-group\"\n                ng-class=\"{\n                    'no-discount': showUpsellPrime25\n                }\">\n                <app-price appid='welcomeOfferCtrl.currentOffer.productId + \"_12_1\"' showyearlabel=\"true\" showcmalabel=\"true\"  class=\"offer-prices\"></app-price>\n            </div>\n            <button class=\"btn btn-medium btn-primary\" ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-medium btn-primary\"' translationkey='translationKeys.button'\n                action='\"Update\"' productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"' page=\"pageName\" xacontent='\"banner_main_ocp_\"'\n                xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close()\"></a>\n\n    </div>\n    <!-- End upsell Prime 25 -->\n\n    <!-- End of Summer Campaign 2021 -->\n    <!-- <div class=\"welcome-offer end-of-summer-campaign centerFlex campaign\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions &&\n        hideBannerForThisSession\">\n\n        <div class=\"w64 inline-block text-left\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\" class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n\n                <div class=\"counter-holder mb5 inline-block\">\n                    <div class=\"counter text-white inline-block text-xs\">\n                        <span translate=\"cw.offer.ends_in\">Ends in:</span>\n                        <time-counter endtime='endCampaignDay'></time-counter>\n                    </div>\n                </div>\n\n                <div class='info-tooltip-holder inline-block v-middle ml5 custom-v-align'\n                    ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\">\n                    <i class=\"icon icon-info icon-xxs icon-grey-4 v-middle inline-block\"></i>\n                    <div class=\"info-tooltip arrow-left\" translate=\"cw.general.merging_lincenses_info\">\n                    </div>\n                </div>\n\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: '' }\"\n                    class=\"text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\">\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\">\n            </ocp-button>\n        </div>\n\n    </div> -->\n\n    <!-- Upsell NortonLifeLock -->\n    <!-- <div ng-if=\"showNortonLifeLockUpsell && !welcomeOfferWasClosed\" class=\"welcome-offer centerFlex us-campaign\">\n        <a class=\"inline-block w100\"\n            ng-href=\"https://www.lifelock.com/lp/sh/avira/?promocode=LLAVIRA&om_ext_cid=ext_avira_lifelock-cart-offers_my.avira.com-banner%20%0d\"\n            target=\"_blank\"\n            ng-click=\"welcomeOfferCtrl.nortonLifeLockUpsell()\">\n            <div class=\"w64 inline-block text-left\">\n                <div class=\"icon-avira-logo-white inline-block v-middle\"></div>\n                <div class=\"v-middle inline-block offer-body\">\n                    <h2 class=\"text-white text-xxl mb5\">Special offer for Avira customers</h2>\n                    <p class=\"text-white text-l offer-description\">\n                        Get a great deal on LifeLock Identity Theft Protection.\n                    </p>\n                </div>\n            </div>\n\n            <div class=\"w35 text-right v-middle inline-block\">\n                <button class=\"btn btn-medium btn-primary ml20\">\n                    Learn more\n                </button>\n            </div>\n        </a>\n        <span ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close()\"></span>\n    </div> -->\n\n    <!-- System Speed Up Campaign -->\n    <!-- <div class=\"welcome-offer mid-june-campaign centerFlex campaign\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions && showSystemSpeedUpBanner\">\n        <div class=\"w64 inline-block text-left\">\n            <div class=\"prime-box-shot\">\n                <img src=\"{{speedUpIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n            <div class=\"v-middle inline-block offer-body\">\n                <p\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p>\n            </div>\n        </div>\n        <div class=\"w35 text-right v-middle inline-block\">\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"!isFromUK\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n            <a class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"isFromUK\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOfferUK(welcomeOfferCtrl.currentOffer.productId)\"\n                ng-href=\"{{ukBuyUrl}}\"\n                target=\"_blank\">\n            </a>\n        </div>\n        <span ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close()\"></span>\n    </div>\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        translate=\"cw.offer5.campaign_disclaimer\"\n        translate-values=\"{\n            totalPriceString : totalPriceString,\n            priceDiff: priceDiff,\n            pcPriceString: pcPriceString }\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showSystemSpeedUpBanner\">\n    </p> -->\n    <!-- Emd System Speed Up Campaign -->\n\n    <!-- September 2022 campaign -->\n    <!-- <div class=\"welcome-offer centerFlex campaign\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions && (showAvBanner || showPrimeBanner)\"\n            ng-class=\"{\n                'av-banner': showAvBanner,\n                'prime-banner': showPrimeBanner\n            }\"\n        >\n\n        <div class=\"w64 inline-block text-left\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10' || welcomeOfferCtrl.currentOffer.productId === 'aps20'\" class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps20'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p>\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: '' }\"\n                    class=\"text-white text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\" ng-if=\"showAvBanner || showPrimeBanner\">\n\n            <a class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"isFromUK\"\n                translate={{translationKeys.button}}\n                ng-href=\"{{avProBuyUrl}}\"\n                target=\"_blank\">\n            </a>\n\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"(!showOPCButton || !isOneClickPaymentEnable) && !isFromUK\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                ng-if=\"!isFromUK\"\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\"\n                xacontent='\"banner_main_ocp_\"'\n                xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n\n    </div>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        translate=\"cw.offer7.avpro.label\"\n        translate-values=\"{\n            totalPriceString : totalPriceString,\n            priceDiff: priceDiff,\n            pcPriceString: pcPriceString }\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showAvBanner\">\n    </p>\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        translate=\"cw.5.avpro.label\"\n        translate-values=\"{\n            totalPriceString : totalPriceString,\n            priceDiff: priceDiff,\n            pcPriceString: pcPriceString }\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showPrimeBanner\">\n    </p> -->\n    <!-- September 2022 campaign -->\n\n    <!-- BF 2022 campaign -->\n    <div class=\"welcome-offer centerFlex campaign\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions && (showAvBanner || showPrimeBanner)\"\n            ng-class=\"{\n                'av-banner': showAvBanner,\n                'prime-banner': showPrimeBanner\n            }\"\n        >\n\n        <div class=\"w64 inline-block text-left\">\n            <!-- <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10' || welcomeOfferCtrl.currentOffer.productId === 'aps20'\" class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div> -->\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n\n                <!-- <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps10'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p> -->\n                <!-- <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aps20'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                    class=\"text-white text-xl offer-description\"></p> -->\n                <p  ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\"\n                    translate={{translationKeys.title}}\n                    translate-values=\"{\n                        discountedPrice: $root.welcomeOffer.discountedPrice\n                    }\"\n                    class=\"text-white text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\" ng-if=\"showAvBanner || showPrimeBanner\">\n\n            <a class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"isFromUK\"\n                translate={{translationKeys.button}}\n                ng-href=\"{{avProBuyUrl}}\"\n                target=\"_blank\">\n            </a>\n\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"(!showOPCButton || !isOneClickPaymentEnable) && !isFromUK\"\n                translate={{translationKeys.button}}\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                ng-if=\"!isFromUK\"\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\"\n                xacontent='\"banner_main_ocp_\"'\n                xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n\n    </div>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showAvBanner && !$root.cmaGBapplies\"\n            translate=\"cw.offer8.campaign_disclaimer_row\"\n            translate-values=\"{\n                discountedPrice : $root.welcomeOffer.discountedPrice,\n                priceDiff: $root.welcomeOffer.discountedAmount,\n                firstYearPrice: $root.welcomeOffer.firstYearPrice,\n                fullPrice: $root.welcomeOffer.renewalPrice\n            }\"\n            >\n    </p>\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showAvBanner && $root.cmaGBapplies\"\n        translate=\"cw.offer8.campaign_disclaimer_uk\"\n        translate-values=\"{\n            fullPrice: $root.welcomeOffer.renewalPrice\n        }\"\n        >\n    </p>\n    <!-- <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        translate=\"cw.5.avpro.label\"\n        translate-values=\"{\n            totalPriceString : totalPriceString,\n            priceDiff: priceDiff,\n            pcPriceString: pcPriceString }\"\n        ng-if=\"isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions && showPrimeBanner\">\n    </p> -->\n    <!-- BF 2022 campaign -->\n\n\n    <!-- <div class=\"welcome-offer centerFlex campaign spring-campaign-2023\"\n        ng-if=\"isOfferActive &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions && showAvCampaignBanner && !$root.cmaGBapplies\">\n\n        <div class=\"w64 inline-block text-left\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <p translate=\"cw.offer8.campaign_description_row\"\n                    class=\"text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\" ng-if=\"showAvCampaignBanner\">\n\n            <a class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"isFromUK\"\n                translate=\"cw.offer6.avpro.cta\"\n                ng-href=\"{{avProBuyUrl}}\"\n                target=\"_blank\">\n            </a>\n\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"(!showOPCButton || !isOneClickPaymentEnable) && !isFromUK\"\n                translate=\"cw.offer6.avpro.cta\"\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"'\n                ng-if=\"!isFromUK\"\n                translationkey='translationKeys.button'\n                action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\"\n                runtime='\"12\"'\n                page=\"pageName\"\n                xacontent='\"banner_main_ocp_\"'\n                xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-6 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n\n    </div>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\" \n    ng-if=\"showAvCampaignBanner && isOfferActive && !$root.cmaGBapplies &&\n        (!welcomeOfferWasClosed || !hideInSubscription) &&\n        !hasOfferSubscriptions\"\n    translate-values=\"{\n            endDate: $root.welcomeOffers[activePromotionProduct].endDate,\n            discountedPrice: $root.welcomeOffers[activePromotionProduct].discountedPrice,\n            discountedAmount: $root.welcomeOffers[activePromotionProduct].discountedAmount,\n            firstYearPrice: $root.welcomeOffers[activePromotionProduct].firstYearPrice,\n            renewalPrice: $root.welcomeOffers[activePromotionProduct].renewalPrice\n        }\"\n        translate=\"cw.offer.generic_disclaimer_row\">\n    </p> -->\n\n\n    <div class=\"welcome-offer centerFlex campaign aia-campaign-banner\" ng-if=\"showAIAbanner && isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions\">\n\n        <div class=\"w64 inline-block text-left\" ng-if=\"showAvBanner\">\n            <div ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <p ng-if=\"welcomeOfferCtrl.currentOffer.productId === 'aapd5'\" translate={{translationKeys.title}}\n                    translate-values=\"{\n                            discountedPrice: $root.welcomeOffer.discountedPrice\n                        }\" class=\"text-white text-xl offer-description\"></p>\n            </div>\n        </div>\n\n        <div class=\"text-left\">\n\n            <div class=\"content-row\">\n\n                <div class=\"box-shot-wrapper\">\n                    <div class=\"discount\" ng-if=\"userLang !== 'de'\">\n                        <span translate=\"cw.offer9.aia_save_label\"></span>\n                        50%*\n                    </div>\n                    <div class=\"discount\" ng-if=\"userLang === 'de'\">\n                        50%\n                        <span>\n                        <span translate=\"cw.offer9.aia_save_label\"></span>*\n                        </span>\n                    </div>\n                    <div class=\"icon-AIA-box\"></div>\n                </div>\n\n                <div class=\"v-middle inline-block ml20 white-space-normal identity-assistant-text\">\n\n                    <h3 class=\"text-xl mt25 font-bold mb10\" translate=\"cw.offer9.aia_title\"></h3>\n                    <p class=\"text-grey-3 text-m mb5\" translate=\"cw.offer9.aia_desc_1\"></p>\n                    <p class=\"text-grey-3 text-m\" translate=\"cw.offer9.aia_desc_2\"></p>\n\n                    <a class=\"text-m inline-block text-blue-2 crs-pointer underline-hover mt5\"\n                        translate={{translationKeys.learnMore}}\n                        translate-values=\"{product: product, brandname: brandName}\"\n                        ng-click=\"welcomeOfferCtrl.sendMixpanelLearnMore(); welcomeOfferCtrl.redirectToUpsellPage();\"></a>\n\n                    <div class=\"identity-assistant-cta-section\">\n\n                        <app-price appid='welcomeOfferCtrl.currentOffer.productId + \"_12_1\"' showyearlabel=\"true\"\n                            showcmalabel=\"false\" class=\"offer-prices\">\n                        </app-price>\n                        <div>\n                            <button class=\"btn btn-medium btn-orange\" ng-if=\"!showOPCButton || !isOneClickPaymentEnable\"\n                                translate='cw.offer.banner_button'\n                                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n                            </button>\n                            <ocp-button classname='\"btn btn-medium btn-orange\"' translationkey='\"cw.offer.banner_button\"'\n                                action='\"Update\"' productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"'\n                                page=\"pageName\" xacontent='\"banner_main_ocp_\"' xamedium='\"banner_main_ocp_\"'>\n                            </ocp-button>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-4 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n    </div>\n\n    <div class=\"welcome-offer centerFlex campaign prime-5-bf-banner\" ng-if=\"(showPrime5Banner || showPrime25Banner || showAvCampaignBanner) && isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions\">\n\n        <div class=\"w64 inline-block text-left\" ng-if=\"showPrime5Banner\">\n            <div class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <p class=\"text-white text-xl offer-description\"\n                    translate={{welcomeOfferCtrl.currentOffer.translationKeys.title}}\n                    translate-values=\"{ product : product,\n                        discount: discount,\n                        brandname: brandName }\"\n                 ></p>\n            </div>\n        </div>\n\n        <div class=\"w64 inline-block text-left\" ng-if=\"showPrime25Banner\">\n            <div class=\"prime-box-shot\">\n                <img src=\"{{primeIntegration.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n            </div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <p class=\"text-grey-1 text-xl offer-description\" translate=\"cw.offer8.prime25_campaign_description\"></p>\n            </div>\n        </div>\n\n\n        <div class=\"w64 inline-block text-left\" ng-if=\"showAvCampaignBanner\">\n            <div class=\"icon-AV-box\"></div>\n\n            <div class=\"v-middle inline-block offer-body\">\n                <p class=\"text-grey-1 text-xl offer-description\" translate=\"cw.offer8.campaign_description_row\"></p>\n            </div>\n        </div>\n\n        <div class=\"w35 text-right v-middle inline-block\">\n\n            <button class=\"btn btn-large btn-primary ml20 mr20\"\n                ng-if=\"(!showOPCButton || !isOneClickPaymentEnable) && !isFromUK\" translate='cw.offer.banner_button'\n                ng-click=\"welcomeOfferCtrl.getOffer(welcomeOfferCtrl.currentOffer.productId)\">\n            </button>\n\n            <ocp-button classname='\"btn btn-large btn-primary ml20 mr20\"' ng-if=\"!isFromUK\"\n                translationkey='\"cw.offer.banner_button\"' action='\"Update\"'\n                productid=\"welcomeOfferCtrl.currentOffer.productId\" runtime='\"12\"' page=\"pageName\"\n                xacontent='\"banner_main_ocp_\"' xamedium='\"banner_main_ocp_\"'>\n            </ocp-button>\n        </div>\n\n        <a ng-if=\"hideInSubscription\" class=\"icon icon-close icon-grey-4 icon-xxxs\"\n            ng-click=\"welcomeOfferCtrl.close(welcomeOfferCtrl.currentOffer.productId)\"></a>\n    </div>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\" \n        ng-if=\"(showPrime5Banner || showAIAbanner || showAvCampaignBanner) && isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions\"\n        translate-values=\"{\n                endDate: $root.welcomeOffers[activePromotionProduct].endDate,\n                discountedPrice: $root.welcomeOffers[activePromotionProduct].discountedPrice,\n                discountedAmount: $root.welcomeOffers[activePromotionProduct].discountedAmount,\n                firstYearPrice: $root.welcomeOffers[activePromotionProduct].firstYearPrice,\n                renewalPrice: $root.welcomeOffers[activePromotionProduct].renewalPrice\n            }\"\n            translate=\"cw.offer.generic_disclaimer_row\">\n    </p>\n\n    <p class=\"text-center text-xs text-grey-3 welcome-offer-label\"\n        ng-if=\"showPrime25Banner && isOfferActive &&\n            (!welcomeOfferWasClosed || !hideInSubscription) &&\n            !hasOfferSubscriptions\" translate=\"cw.offer.prime25_generic_disclaimer_row\"\n            translate-values=\"{\n                endDate: $root.welcomeOffers[activePromotionProduct].endDate,\n                renewalPrice: $root.welcomeOffers[activePromotionProduct].renewalPrice\n            }\"\n            >\n    </p>\n\n\n\n\n</div>"

/***/ }),

/***/ "LOwu":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "LdeT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmAddresses = function DwmAddresses($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmAddresses);

    $scope.formIsValid = true;
    $scope.updateFormIsValid = true;

    $scope.address1IsValid = true;
    $scope.address2IsValid = true;
    $scope.postalCodeIsValid = true;
    $scope.cityIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};

        if (assets.primaryMember) {

            $scope.addresses = assets.primaryMember.monitoredAccounts.addresses;
            $scope.addresses.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.formIsValid = true;
        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('#address-1').focus();
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.formIsValid = true;
        $scope.address1IsValid = true;
        $scope.address2IsValid = true;
        $scope.postalCodeIsValid = true;
        $scope.cityIsValid = true;

        $scope.newAddress1 = '';
        $scope.newAddress2 = '';
        $scope.newPostalCode = '';
        $scope.newCity = '';

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.address1IsValid = true;
        $scope.address2IsValid = true;
        $scope.postalCodeIsValid = true;
        $scope.cityIsValid = true;

        $scope.addresses.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                var newEntry = Object.assign({}, entry);
                $scope.updateEntryPayload = newEntry;
            } else {

                entry.showUpdateInput = false;
            }
        });
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.updateFormIsValid = true;
        $scope.address1IsValid = true;
        $scope.address2IsValid = true;
        $scope.postalCodeIsValid = true;
        $scope.cityIsValid = true;

        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.addresses.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};
    };

    $scope.validateAddress1 = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.address1IsValid = validations.addressStreet1Validator($event.currentTarget.value);
        }

        $scope.newAddress1 = $event.currentTarget.value;

        $scope.formIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid;
    };

    $scope.validateAddress2 = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.address2IsValid = validations.addressStreet2Validator($event.currentTarget.value);
        }

        $scope.newAddress2 = $event.currentTarget.value;

        $scope.formIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid;
    };

    $scope.validatePostalCode = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.postalCodeIsValid = validations.postalCodeValidator($event.currentTarget.value);
        }

        $scope.newPostalCode = $event.currentTarget.value;

        $scope.formIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid;
    };

    $scope.validateCity = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.cityIsValid = validations.cityValidator($event.currentTarget.value);
        }

        $scope.newCity = $event.currentTarget.value;

        $scope.formIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid;
    };

    $scope.validateForm = function () {

        if ($scope.newEntrySubmitted) {

            $scope.address1IsValid = validations.addressStreet1Validator($scope.newAddress1);
            $scope.address2IsValid = validations.addressStreet2Validator($scope.newAddress2);
            $scope.postalCodeIsValid = validations.postalCodeValidator($scope.newPostalCode);
            $scope.cityIsValid = validations.cityValidator($scope.newCity);
        }

        $scope.addressExists = $scope.addresses.entries.find(function (address) {
            return address.street1 === $scope.newAddress1 && address.street2 === $scope.newAddress2 && address.postalCode === $scope.newPostalCode && address.city === $scope.newCity;
        });

        $scope.formIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid && !$scope.addressExists;
    };

    $scope.saveNewEntry = function () {

        $scope.newEntrySubmitted = true;
        $scope.validateForm();

        if ($scope.formIsValid) {

            $scope.saveNewAddressIsLoading = true;

            var payload = void 0;
            if ($scope.addresses.entries.length === 0) {

                payload = {
                    primaryAddress: {
                        street1: $scope.newAddress1,
                        street2: $scope.newAddress2,
                        postalCode: $scope.newPostalCode,
                        city: $scope.newCity,
                        countryCode: 'DE',
                        type: 'CURRENT',
                        isPrimaryAddressEmpty: true
                    }
                };
            } else {

                payload = {
                    addresses: {
                        street1: $scope.newAddress1,
                        street2: $scope.newAddress2,
                        postalCode: $scope.newPostalCode,
                        city: $scope.newCity,
                        countryCode: 'DE'
                    }
                };
            }

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newAddress1 = '';
                $scope.newAddress2 = '';
                $scope.newPostalCode = '';
                $scope.newCity = '';

                $scope.saveNewAddressIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;


                    _RFC4.default.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Addresses'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewAddressIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        } else if ($scope.addressExists) {

            _RFC2.default.error('cw.dwm.dupliacte_entry_error');
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            addresses: {
                id: $scope.addresses.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newAddress1 = '';
            $scope.newAddress2 = '';
            $scope.newPostalCode = '';
            $scope.newCity = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Addresses'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.entryUpdateValue = function ($event, key) {

        if (key === 'street1') {

            $scope.address1IsValid = validations.addressStreet1Validator($event.currentTarget.value);
        }

        if (key === 'street2') {

            $scope.address2IsValid = validations.addressStreet2Validator($event.currentTarget.value);
        }

        if (key === 'postalCode') {

            $scope.postalCodeIsValid = validations.postalCodeValidator($event.currentTarget.value);
        }

        if (key === 'city') {

            $scope.cityIsValid = validations.cityValidator($event.currentTarget.value);
        }

        $scope.updateEntryPayload[key] = $event.currentTarget.value;

        $scope.updateFormIsValid = $scope.address1IsValid && $scope.address2IsValid && $scope.postalCodeIsValid && $scope.cityIsValid;
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $scope.addressExistsUpdate = $scope.addresses.entries.find(function (address) {
            return address.street1 === $scope.updateEntryPayload.street1 && address.street2 === $scope.updateEntryPayload.street2 && address.postalCode === $scope.updateEntryPayload.postalCode && address.city === $scope.updateEntryPayload.city;
        });

        if (!$scope.updateFormIsValid || $scope.addressExistsUpdate) {

            if ($scope.addressExistsUpdate) {

                $scope.saveUpdatedEntryIsLoading = false;
                _RFC2.default.error('cw.dwm.dupliacte_entry_error');
            }

            return;
        }

        var data = void 0;

        if ($scope.updateEntryPayload.type === 'CURRENT') {

            data = {
                primaryAddress: {
                    street1: $scope.updateEntryPayload.street1,
                    street2: $scope.updateEntryPayload.street2,
                    postalCode: $scope.updateEntryPayload.postalCode,
                    city: $scope.updateEntryPayload.city,
                    countryCode: 'DE',
                    stateCode: '',
                    type: $scope.updateEntryPayload.type,
                    isPrimaryAddressEmpty: false
                },
                status: '',
                type: $scope.updateEntryPayload.type

            };
        } else {

            data = {
                addresses: {
                    street1: $scope.updateEntryPayload.street1,
                    street2: $scope.updateEntryPayload.street2,
                    postalCode: $scope.updateEntryPayload.postalCode,
                    city: $scope.updateEntryPayload.city,
                    id: $scope.updateEntryPayload.id,
                    countryCode: 'DE'
                }
            };
        }

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: data
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Addresses'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmAddresses);

angular.module('controllers').controller('DwmAddresses', _serviceDependencies);

/***/ }),

/***/ "Ldw3":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content large-modal-holder unsubscribe-modal\" id=\"unsubscribe-modal\"\n    connectqa-modal=\"subscriptions-modal\"\n    ng-class=\"{'discount-modal': variant === '1', 'reasons-modal': showPhoneAndDiscount, 'benefits-modal': (showCancelScreenRow || showBenefitsModal), 'unsubscribe-modal-aia': appIntegration.id === 'adwp1' && showCancelScreenRow, 'unsubscribe-modal-confirmation': showSuccessCancellationScreen}\">\n\n    <!-- Activate Subscription -->\n    <div ng-if=\"activationCode.attributes.subscription !== 1\n            && !surveyFlow\" class=\"medium-modal-holder\">\n\n        <!-- Activate annual -->\n        <div ng-if=\"showAnnual\">\n            <div class=\"p-relative inline-block v-top\">\n                <i class=\"icon icon-enable-license\"></i>\n            </div>\n            <h2 class=\"text-xxl text-grey-2 mt20 mb10\" translate=\"cw.subscribe.annual.title\"></h2>\n            <p class=\"text-m text-grey-3 mb40 measure-extra-wide m-auto\"\n                translate=\"cw.subscribe.desc\"\n                translate-values=\"{\n                    nextBilling: activationCode.formatted_next_billing_event,\n                    price: nextBillingPrice,\n                    renewalPrices: renewalPrices\n                }\">\n            </p>\n\n            <div class=\"text-left\">\n                <p class=\"text-l font-bold text-grey-1 mb10\" translate=\"cw.subscribe.authorization\"></p>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span><span translate=\"cw.subscribe.contract_type_desc_annual\"></span></p>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span><span translate=\"cw.subscribe.renewal_cycle_desc_annual\"></span></p>\n                <div class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_settings\"></span><span translate=\"cw.subscribe.renewal_settings_desc\" translate-values=\"{siteLink: siteLink}\"></span>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                            <span translate=\"cw.subscribe.renewal_settings_tooltip.desc_1\"></span>\n                            <ol>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_2\"></li>\n                                <li ng-show=\"$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_3\"></li>\n                                <li ng-show=\"!$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_6\"></li>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_4\"></li>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_5\"></li>\n                            </ol>\n                        </div>\n                    </div>\n                </div>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_prices\"></span><span translate=\"cw.subscribe.renewal_prices_desc_annual\"></span></p>\n                <p class=\"text-m text-grey-3 mb20\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span><span translate=\"cw.subscribe.cancellation_refund_desc_annual\" translate-values=\"{cancellation: cancellation}\"></span></p>\n\n                <p class=\"text-m text-grey-3 mb20\" translate=\"cw.subscribe.agree_details\" translate-values=\"{globalPrivacy: globalPrivacy}\"></p>\n            </div>\n\n            <div ng-if=\"!$root.cmaGBapplies\">\n                <div class=\"fake-radio input-checkbox mb40 text-left\"\n                    ng-class=\"{\n                        'error': !acceptedRowTerms && submitted\n                    }\">\n                    <input type=\"checkbox\" connectqa-subscriptions=\"agreement-checkbox\" id=\"agreement-row-annual\" ng-model=\"acceptedRowTerms\" ng-change=\"onChangeCheckboxROW()\" />\n                    <label class=\"input-checkbox label\" for=\"agreement-row-annual\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_row\"\n                            translate-values=\"{\n                                globalPrivacy: globalPrivacy,\n                                termsOfSale: termsOfSale,\n                                licenseAgreement: licenseAgreement,\n                            }\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <button class=\"btn btn-large btn-primary mb20 confirm-btn\"\n                    ng-click=\"confirm('Enable Subscription', appIntegration.id)\" ng-class=\"{'spin-loader': loading}\"\n                    ng-disabled=\"loading\" translate=\"cw.subscribe.activate\" connectqa-subscriptions=\"activate-subscription-renewal\">\n                </button>\n            </div>\n            <div ng-if=\"$root.cmaGBapplies\">\n                <div class=\"fake-radio input-checkbox mb20 text-left\"\n                ng-class=\"{\n                    'error': !acceptedGbTerms1 && submitted\n                }\">\n                    <input type=\"checkbox\" id=\"agreement-gb-annual-1\" ng-model=\"acceptedGbTerms1\" ng-change=\"onChangeCheckboxGB1()\" />\n                    <label class=\"input-checkbox label\" for=\"agreement-gb-annual-1\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_gb_1_annual\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <div class=\"fake-radio input-checkbox mb40 text-left\"\n                ng-class=\"{\n                    'error': !acceptedGbTerms2 && submitted\n                }\">\n                    <input type=\"checkbox\" id=\"agreement-gb-annual-2\" ng-model=\"acceptedGbTerms2\" ng-change=\"onChangeCheckboxGB2()\" />\n                    <label class=\"input-checkbox label\" for=\"agreement-gb-annual-2\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_gb_2\" translate-values=\"{\n                                globalPrivacy: globalPrivacy,\n                                termsOfSale: termsOfSale,\n                                licenseAgreement: licenseAgreement,\n                            }\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <button class=\"btn btn-large btn-primary mb20 confirm-btn\"\n                    ng-click=\"confirm('Enable Subscription', appIntegration.id)\" ng-class=\"{'spin-loader': loading}\"\n                    ng-disabled=\"loading\" translate=\"cw.subscribe.activate\" connectqa-subscriptions=\"activate-subscription-renewal\">\n                </button>\n            </div>\n            <div class=\"text-grey-3 text-m crs-pointer underline-hover inline-block\"\n                ng-click=\"cancel('Enable Subscription', appIntegration.id)\" translate=\"cw.form.profile.cancel\"></div>\n        </div><!-- End activate annual -->\n\n        <!-- Activate monthly -->\n        <div ng-if=\"showMonthly\">\n            <div class=\"p-relative inline-block v-top\">\n                <i class=\"icon icon-enable-license\"></i>\n            </div>\n            <h2 class=\"text-xxl text-grey-2 mt20 mb10\" translate=\"cw.subscribe.monthly.title\"></h2>\n            <p class=\"text-m text-grey-3 mb40 measure-extra-wide m-auto\"\n                translate=\"cw.subscribe.monthly_desc\"\n                translate-values=\"{\n                    nextBilling: activationCode.formatted_next_billing_event,\n                    price: nextBillingPrice,\n                    renewalPrices: renewalPrices\n                }\">\n            </p>\n\n            <div class=\"text-left\">\n                <p class=\"text-l font-bold text-grey-1 mb10\" translate=\"cw.subscribe.authorization\"></p>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span><span translate=\"cw.subscribe.contract_type_desc_monthly\"></span></p>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span><span translate=\"cw.subscribe.renewal_cycle_desc_monthly\"></span></p>\n                <div class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_settings\"></span><span translate=\"cw.subscribe.renewal_settings_desc\" translate-values=\"{siteLink: siteLink}\"></span>\n                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                        <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                        <div class=\"info-tooltip arrow-left subscription-notification\">\n                            <span translate=\"cw.subscribe.renewal_settings_tooltip.desc_1\"></span>\n                            <ol>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_2\"></li>\n                                <li ng-show=\"$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_3\"></li>\n                                <li ng-show=\"!$root.cmaGBapplies\" translate=\"cw.subscribe.renewal_settings_tooltip.desc_6\"></li>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_4\"></li>\n                                <li translate=\"cw.subscribe.renewal_settings_tooltip.desc_5\"></li>\n                            </ol>\n                        </div>\n                    </div>\n                </div>\n                <p class=\"text-m text-grey-3 mb5\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_prices\"></span><span translate=\"cw.subscribe.renewal_prices_desc_monthly\"></span></p>\n                <p class=\"text-m text-grey-3 mb20\"><span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span><span translate=\"cw.subscribe.cancellation_refund_desc_monthly\" translate-values=\"{cancellation: cancellation}\"></span></p>\n                <p class=\"text-m text-grey-3 mb20\" translate=\"cw.subscribe.agree_details\" translate-values=\"{globalPrivacy: globalPrivacy}\"></p>\n            </div>\n\n            <div ng-if=\"!$root.cmaGBapplies\">\n                <div class=\"fake-radio input-checkbox mb40 text-left\"\n                ng-class=\"{\n                    'error': !acceptedRowTerms && submitted\n                }\">\n                    <input type=\"checkbox\" connectqa-subscriptions=\"agreement-checkbox\" id=\"agreement-row-monthly\" ng-model=\"acceptedRowTerms\" ng-change=\"onChangeCheckboxROW()\" />\n                    <label class=\"input-checkbox label\" for=\"agreement-row-monthly\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_row\"\n                            translate-values=\"{\n                                globalPrivacy: globalPrivacy,\n                                termsOfSale: termsOfSale,\n                                licenseAgreement: licenseAgreement,\n                            }\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <button class=\"btn btn-large btn-primary mb20 confirm-btn\"\n                    ng-click=\"confirm('Enable Subscription', appIntegration.id)\" ng-class=\"{'spin-loader': loading}\"\n                    ng-disabled=\"loading\" translate=\"cw.subscribe.activate\" connectqa-subscriptions=\"activate-subscription-renewal\">\n                </button>\n            </div>\n            <div ng-if=\"$root.cmaGBapplies\">\n                <div class=\"fake-radio input-checkbox mb20 text-left\"\n                ng-class=\"{\n                    'error': !acceptedGbTerms1 && submitted\n                }\">\n                    <input type=\"checkbox\" id=\"agreement-gb-monthly-1\" ng-model=\"acceptedGbTerms1\" ng-change=\"onChangeCheckboxGB1()\"/>\n                    <label class=\"input-checkbox label\" for=\"agreement-gb-monthly-1\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_gb_1_monthly\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <div class=\"fake-radio input-checkbox mb40 text-left\"\n                ng-class=\"{\n                    'error': !acceptedGbTerms2 && submitted\n                }\">\n                    <input type=\"checkbox\" id=\"agreement-gb-monthly-2\" ng-model=\"acceptedGbTerms2\" ng-change=\"onChangeCheckboxGB2()\" />\n                    <label class=\"input-checkbox label\" for=\"agreement-gb-monthly-2\">\n                        <span>\n                            <p class=\"text-m text-grey-3 inline-block v-middle\" translate=\"cw.subscribe.terms_gb_2\" translate-values=\"{\n                                globalPrivacy: globalPrivacy,\n                                termsOfSale: termsOfSale,\n                                licenseAgreement: licenseAgreement,\n                            }\">\n                            </p>\n                        </span>\n                    </label>\n                </div>\n                <button class=\"btn btn-large btn-primary mb20 confirm-btn\"\n                    ng-click=\"confirm('Enable Subscription', appIntegration.id)\" ng-class=\"{'spin-loader': loading}\"\n                    ng-disabled=\"loading\" translate=\"cw.subscribe.activate\" connectqa-subscriptions=\"activate-subscription-renewal\">\n                </button>\n            </div>\n            <div class=\"text-grey-3 text-m crs-pointer underline-hover inline-block\"\n                ng-click=\"cancel('Enable Subscription', appIntegration.id)\" translate=\"cw.form.profile.cancel\"></div>\n        </div><!-- End activate monthly -->\n\n    </div>\n    <!-- End Activate Subscription -->\n\n    <!-- -10% AV Pro campaign modal && A/B Test Auto-Renew Offer -->\n    <!-- <div ng-if=\"(activationCode.attributes.subscription !== 1 && !surveyFlow && isCampaignOfferDiscount) ||\n        (activationCode.attributes.subscription !== 1 && !surveyFlow)\">\n\n        <div class='loader-wrapper' ng-if=\"!showDiscountScreen && isLoadingAvCampaign\">\n            <div class=\"main-loader\"></div>\n        </div>\n\n        <div ng-if=\"showDiscountScreen && !isLoadingAvCampaign && !showDiscountAddedScreen\" class=\"discount-screen\">\n            <h2 class=\"text-xxl text-grey-2 mt20 mb0\" connectqa-subscriptions=\"custom-unsubscribe-header\"\n                translate=\"cw.subscription.unsubscribe_modal.discount_title\"\n                translate-values=\"{percent:  promotionDetails.attributes.discount, product: '<strong>' + appIntegration.attributes.resource.oeName + '</strong>'}\">\n            </h2>\n            <div class=\"discount\">\n                <span class='inline-block v-top percent font-bold'>{{promotionDetails.attributes.discount}}</span>\n                <div class='inline-block text-left v-top'>\n                    <span class='inline-block v-middle percent-icon font-bold'>%</span>\n                    <span class='inline-block v-middle percent-text font-bold'>off</span>\n                </div>\n            </div>\n            <div class=\"price\">\n                <span class='total-price text-grey-4 text-m'>\n                    {{promotionDetails.attributes.pc_price}}\n                </span>\n                <span class='discounted-price text-m'>\n                    {{promotionDetails.attributes.total_price_string}}\n                </span>\n            </div>\n            <p class=\"text-m text-grey-3 mb20\" connectqa-subscriptions=\"custom-unsubscribe-paragraph\"\n                translate=\"cw.subscription.unsubscribe_modal.discount_info\">\n            </p>\n            <div class=\"actions\">\n                <button class=\"btn btn-large btn-secondary mlr5\"\n                    ng-click=\"cancel('Enable Subscription', appIntegration.id)\"\n                    translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-large btn-primary mlr5\"\n                    ng-click=\"applyDiscount('Apply discount and Enable Subscription', appIntegration.id)\"\n                    ng-class=\"{'spin-loader': loading}\" ng-disabled=\"loading\"\n                    translate=\"cw.general.ui.confirm\"></button>\n            </div>\n        </div>\n\n        <div ng-if=\"showDiscountAddedScreen\" class='discount-applied'>\n            <div class=\"success-icon\"></div>\n            <h2 class=\"text-xxl text-grey-2 mb20\" translate=\"cw.subscription.unsubscribe_modal.success_title\">\n            </h2>\n            <p class=\"text-m text-grey-4 mb50\" translate=\"cw.subscription.unsubscribe_modal.success_desc\"\n                translate-values=\"{percent:  promotionDetails.attributes.discount, date: formattedNextBillingEvent }\">\n            </p>\n            <button class=\"btn btn-primary btn-half-width btn-large inline-block\" ng-click=\"closeModal()\"\n                translate=\"cw.general.ui.close\"></button>\n        </div>\n\n    </div> -->\n    <!-- End -10% AV Pro campaign -->\n\n    <!-- Cancel Subscription -->\n    <div ng-if=\"activationCode.attributes.subscription === 1 && !surveyFlow\" ng-class=\"{'cancellation-screen-aia': appIntegration.id === 'adwp1' && showCancelScreenRow}\">\n        <!-- Options Modal - Discount & Monthly Offer -->\n        <div>\n            <!-- Options Modal -->\n            <div class=\"options-modal options-modal-only-discount\" id=\"options-modal\" ng-if=\"showOptions && !isLoading && !showUnsubscribeFeedbackModal\">\n                <div ng-if=\"canOfferDiscount && !$root.cmaGBapplies\">\n                    <p class=\"text-m text-grey-4 mb10\" translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"></p>\n                    <h2 class=\"text-xxl text-grey-2 mb30\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.title\"\n                        translate-values=\"{\n                            percent: promotionDetails.attributes.discount\n                        }\"></h2>\n\n                    <div class=\"card-large\">\n                        <p class=\"text-grey-4 text-s\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_1\"\n                            translate-values=\"{\n                            percent: promotionDetails.attributes.discount\n                            }\"></p>\n                        <p class=\"large-text text-green-1\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_2\"\n                        translate-values=\"{\n                            days: discountFreeDays\n                        }\"></p>\n                        <div class=\"icon\">\n                            <svg id=\"Icons\" xmlns=\"http://www.w3.org/2000/svg\" width=\"57.969\" height=\"70\" viewBox=\"0 0 57.969 70\">\n                                <g id=\"Group_9\" data-name=\"Group 9\">\n                                    <path id=\"Path_5\" data-name=\"Path 5\" d=\"M22.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,31.938,18H22.094A1.1,1.1,0,0,0,21,19.094v9.844A1.1,1.1,0,0,0,22.094,30.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 1.688)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_6\" data-name=\"Path 6\" d=\"M37.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,46.937,18H37.094A1.1,1.1,0,0,0,36,19.094v9.844A1.1,1.1,0,0,0,37.094,30.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 1.688)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_7\" data-name=\"Path 7\" d=\"M37.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,46.937,33H37.094A1.1,1.1,0,0,0,36,34.094v9.844A1.1,1.1,0,0,0,37.094,45.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 3.094)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_8\" data-name=\"Path 8\" d=\"M37.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,46.937,48H37.094A1.1,1.1,0,0,0,36,49.094v9.844A1.1,1.1,0,0,0,37.094,60.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 4.5)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_9\" data-name=\"Path 9\" d=\"M7.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,16.938,33H7.094A1.1,1.1,0,0,0,6,34.094v9.844A1.1,1.1,0,0,0,7.094,45.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 3.094)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_10\" data-name=\"Path 10\" d=\"M22.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,31.938,33H22.094A1.1,1.1,0,0,0,21,34.094v9.844A1.1,1.1,0,0,0,22.094,45.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 3.094)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_11\" data-name=\"Path 11\" d=\"M7.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,16.938,48H7.094A1.1,1.1,0,0,0,6,49.094v9.844A1.1,1.1,0,0,0,7.094,60.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 4.5)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_12\" data-name=\"Path 12\" d=\"M22.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,31.938,48H22.094A1.1,1.1,0,0,0,21,49.094v9.844A1.1,1.1,0,0,0,22.094,60.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 4.5)\" fill=\"#838b93\"/>\n                                    <path id=\"Path_13\" data-name=\"Path 13\" d=\"M52.5,4.375H50.313V1.094A1.1,1.1,0,0,0,49.219,0H44.844A1.1,1.1,0,0,0,43.75,1.094V4.375H15.313V1.094A1.1,1.1,0,0,0,14.219,0H9.844A1.1,1.1,0,0,0,8.75,1.094V4.375H5.469A5.471,5.471,0,0,0,0,9.844V64.531A5.471,5.471,0,0,0,5.469,70H52.5a5.471,5.471,0,0,0,5.469-5.469V9.844A5.471,5.471,0,0,0,52.5,4.375ZM45.938,2.188h2.188V4.375H45.938Zm-35,0h2.188V4.375H10.938ZM2.188,9.844A3.291,3.291,0,0,1,5.469,6.563H52.5a3.291,3.291,0,0,1,3.281,3.281v4.375H2.188ZM55.781,64.531A3.291,3.291,0,0,1,52.5,67.813H5.469a3.291,3.291,0,0,1-3.281-3.281V16.417H55.781Z\" fill=\"#838b93\"/>\n                                </g>\n                            </svg>\n                        </div>\n                        <a class=\"btn btn-secondary btn-medium inline-block\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.card.cta\"\n                            ng-click=\"applyDiscount('Unsubscribe Options', appIntegration.id)\"\n                            ng-class=\"{'disabled spin-loader': isLoading}\">\n                        </a>\n                    </div>\n                    <p class=\"text-s text-grey-4 mt30 mb30\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.info\"\n                        translate-values=\"{\n                            percent: promotionDetails.attributes.discount\n                        }\"></p>\n                    <a class=\"btn btn-secondary btn-medium inline-block\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"\n                        ng-click=\"goToCancelScreenRow()\">\n                    </a>\n                </div>\n                <div ng-if=\"!canOfferDiscount || $root.cmaGBapplies\">\n                    <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal.title\">\n                    </h2>\n                    <p class=\"text-m text-grey-4 mb5\" translate=\"cw.subscription.unsubscribe_modal.desc_1\"\n                        ng-class=\"{'mb50': !canOfferDiscount}\">\n                    </p>\n                    <p class=\"text-m text-grey-4 mb50\" translate=\"cw.subscription.unsubscribe_modal.desc_2\"\n                        ng-if=\"canOfferDiscount\">\n                    </p>\n                    <div class=\"cards-wrapper mb30\" ng-class=\"{'mt50': canOfferChatSupport && offerChatSupport}\"\n                        id=\"options-list\">\n                        <a ng-if=\"!$root.cmaGBapplies\" ng-click=\"contactSupport()\" class=\"large-card\" ui-sref=\"root.dashboard.support({tab:'support'})\">\n                            <i class=\"icon icon-vip-support\"></i>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.contact_support\"></p>\n                        </a>\n                        <button class=\"large-card cancel-card\"\n                            ng-if=\"$root.cmaGBapplies\"\n                            ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\"\n                            ng-class=\"{'show-loading': loading}\" ng-disabled=\"loading\" connectqa-subscriptions=\"unsubscribe-now-reasons\">\n                            <div>\n                                <div class='loader-wrapper' ng-if=\"loading\">\n                                    <div class=\"main-loader\"></div>\n                                </div>\n                                <p translate=\"cw.subscription.unsubscribe_modal.cancel_now\"></p>\n                            </div>\n                        </button>\n                        <div class=\"large-card chat-card green-border\" ng-if=\"canOfferChatSupport && offerChatSupport\"\n                            id=\"chat-option\" ng-click=\"showChatScreen()\" ng-class=\"{'animated fadeIn': isAnimationEnable}\">\n                            <div class=\"info-tooltip arrow-bottom\" ng-if=\"showMultipleLicensesTooltip\">\n                                <div>\n                                    <span class=\"agent-avatar\"></span>\n                                    <span class=\"w80\"\n                                        translate=\"cw.subscription.unsubscribe_modal.multiple_licenses_tooltip\"\n                                        translate-values=\"{name: filterName}\"></span>\n                                </div>\n                            </div>\n                            <div class=\"info-tooltip arrow-bottom\" ng-if=\"!showMultipleLicensesTooltip\">\n                                <div>\n                                    <span class=\"agent-avatar\"></span>\n                                    <span class=\"w80\" translate=\"cw.subscription.unsubscribe_modal.chat_tooltip\"\n                                        translate-values=\"{username: filterName}\"></span>\n                                </div>\n                            </div>\n                            <div class=\"background-holder phone-holder\">\n                                <i class=\"icon icon-vip-support\"></i>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.options_modal.chat_support\"></p>\n                        </div>\n                        <div class=\"large-card\" ng-click=\"showPhoneScreen()\" ng-if=\"canOfferPhoneSupport\" id=\"phone-option\"\n                            ng-class=\"{'animated fadeIn': isAnimationEnable}\">\n                            <div class=\"background-holder phone-holder\">\n                                <i class=\"icon icon-phone-receiver\"></i>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.options_modal.phone_support\"></p>\n                        </div>\n                        <div class=\"large-card\" ng-click=\"showPromotionScreen()\" ng-if=\"canOfferDiscount\"\n                            ng-class=\"{'animated fadeIn': isAnimationEnable}\" id=\"promotion-option\">\n                            <div class=\"discount background-holder discount-holder\">\n                                <span\n                                    class='inline-block v-top percent font-bold'>{{promotionDetails.attributes.discount}}</span>\n                                <div class='inline-block text-left v-top'>\n                                    <span class='inline-block v-middle percent-icon font-bold'>%</span>\n                                    <span class='inline-block v-middle percent-text font-bold'>off</span>\n                                </div>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.discount\"></p>\n                        </div>\n                    </div>\n                    <div ng-if=\"!$root.cmaGBapplies\" class=\"text-center\">\n                        <span class=\"crs-pointer text-m text-grey-4 underline-hover\" ng-click=\"goToCancelScreenRow()\"\n                            translate=\"cw.subscription.unsubscribe_modal.cancel_now\">\n                        </span>\n                    </div>\n                </div>\n            </div><!-- End Options Modal -->\n\n            <!-- Cancellation screen ROW -->\n            <div class=\"benefits-screen\" ng-if=\"showCancelScreenRow\" ng-class=\"{'benefits-screen-aia': appIntegration.id === 'adwp1'}\">\n                <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal_row.title\"\n                    ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length === 0 || !appIntegration.attributes.resource.comparisonFeatures\">\n                </h2>\n                <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal_row.benefits_title\"\n                    ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\">\n                </h2>\n                <p class=\"text-m text-grey-4 mb5\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\" translate=\"cw.subscription.unsubscribe_modal_row.desc\">\n                </p>\n                <p class=\"text-l text-grey-4 mb40\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length === 0 || !appIntegration.attributes.resource.comparisonFeatures\" translate=\"cw.subscription.unsubscribe_modal.desc_1\"></p>\n                <div class=\"benefits-comparison-wrapper\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\">\n                    <div class=\"features-container\">\n                        <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                            <i class=\"icon icon-close icon-red-2\"></i>\n                            <p translate=\"{{ 'cw.ocp.' + feature }}\" class=\"text-m text-grey-4 ml20\"></p>\n                        </div>\n                    </div>\n                    <div class=\"benefits-container\" ng-class=\"{'benefits-container-aia': appIntegration.id === 'adwp1'}\">\n                        <div class=\"benefit highlighted\">\n                            <div translate=\"cw.subscription.unsubscribe_modal_row.current_subscription\" class=\"title text-m text-grey-2 font-bold\"></div>\n                            <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                                <i class=\"icon icon-checkmark-bold icon-green-2\"></i>\n                            </div>\n                        </div>\n                        <div class=\"benefit\">\n                            <div translate=\"cw.subscription.unsubscribe_modal_row.after_subscription\" class=\"title text-m text-grey-2 font-bold\"></div>\n                            <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                                <i class=\"icon icon-close icon-red-2\"></i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"buttons text-center\">\n                    <button ng-if=\"showCloseButton\" class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                    ng-class=\"{'spin-loader': loading}\"\n                    ng-click=\"onCloseButtonClick('Disable Subscription')\" ng-disabled=\"loading\" translate=\"cw.general.ui.close\">\n                    </button>\n                    <button class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                        ng-class=\"{'spin-loader': loading}\"\n                        ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\" ng-disabled=\"loading\" translate=\"cw.subscription.unsubscribe_modal_row.cancel_now\">\n                    </button>\n                    <div class=\"btn-primary btn-medium inline-block crs-pointer mlr5 mt10\" ng-click=\"cancel('Disable Subscription', appIntegration.id)\" translate=\"cw.subscription.unsubscribe_modal_row.keep_subscription\">\n                    </div>\n                </div>\n            </div><!-- End cancellation screen ROW -->\n\n            <!-- Promotion Modal -->\n            <div class=\"promotion-modal discount-screen\" ng-if=\"showPromotionModal\">\n                <!-- <h2 class=\"text-xxl text-grey-2 mt20 mb0\" connectqa-subscriptions=\"custom-unsubscribe-header\"\n                    translate=\"cw.subscription.unsubscribe_modal.discount_title\"\n                    translate-values=\"{percent:  promotionDetails.attributes.discount, product: '<strong>' + appIntegration.attributes.resource.oeName + '</strong>'}\">\n                </h2> -->\n                <h2 class=\"text-xxl text-grey-2 mt20 mb0\" connectqa-subscriptions=\"custom-unsubscribe-header\"\n                    translate=\"cw.subscription.unsubscribe_modal.discount_title_2\"\n                    translate-values=\"{percent:  promotionDetails.attributes.discount, product: '<strong>' + appIntegration.attributes.resource.oeName + '</strong>'}\">\n                </h2>\n                <div class=\"discount\">\n                    <span class='inline-block v-top percent font-bold'>{{promotionDetails.attributes.discount}}</span>\n                    <div class='inline-block text-left v-top'>\n                        <span class='inline-block v-middle percent-icon font-bold'>%</span>\n                        <span class='inline-block v-middle percent-text font-bold'>off</span>\n                    </div>\n                </div>\n                <div class=\"price\">\n                    <span class='total-price text-grey-4 text-xl'>\n                        {{promotionDetails.attributes.pc_price}}\n                    </span>\n                    <span class='discounted-price text-xl'>\n                        {{promotionDetails.attributes.total_price_string}}\n                    </span>\n                    <span class='text-xl discounted-price'>\n                        /\n                    </span>\n                    <span class='text-xl discounted-price' ng-if=\"showAnnual\" translate=\"cw.general.year\"></span>\n                    <span class='text-xl discounted-price' ng-if=\"showMonthly\" translate=\"cw.general.month\"></span>\n                </div>\n                <p class=\"text-m text-grey-3 mb20\" ng-if=\"showAnnual\" connectqa-subscriptions=\"custom-unsubscribe-paragraph\"\n                    translate=\"cw.subscription.unsubscribe_modal.discount_info_2\"\n                    translate-values=\"{price: promotionDetails.attributes.pc_price_string}\">\n                </p>\n                <p class=\"text-m text-grey-3 mb20\" ng-if=\"showMonthly\" connectqa-subscriptions=\"custom-unsubscribe-paragraph\"\n                    translate=\"cw.subscription.unsubscribe_modal.discount_info_monthly\"\n                    translate-values=\"{price: promotionDetails.attributes.pc_price_string}\">\n                </p>\n                <div class=\"actions\">\n                    <div class=\"mb10\" ng-if=\"$root.cmaGBapplies\">\n                        <button class=\"btn btn-large btn-primary mlr5\"\n                            ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\"\n                            ng-class=\"{'spin-loader': loading}\" ng-disabled=\"loading\"\n                            translate=\"cw.subscription.unsubscribe_modal.cancel_now\">\n                        </button>\n                    </div>\n                    <button class=\"btn btn-large btn-primary\"\n                        ng-click=\"applyDiscount('Unsubscribe Options', appIntegration.id)\"\n                        ng-class=\"{\n                            'mt10': !$root.cmaGBapplies\n                        }\"\n                        translate=\"cw.subscription.unsubscribe_modal.discount_button\"\n                        ng-if=\"!enableUnsubscribeButtonInDiscountModal\">\n                    </button>\n                    <div class=\"mt20\" ng-if=\"!$root.cmaGBapplies\">\n                        <span class=\"crs-pointer text-m text-grey-4 underline-hover\"\n                            ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\"\n                            translate=\"cw.subscription.unsubscribe_modal.cancel_now\">\n                    </span>\n                    </div>\n                </div>\n            </div><!-- End Promotion Modal -->\n\n            <!-- Loader -->\n            <div class='loader-wrapper' ng-if=\"isLoading\">\n                <div class=\"main-loader\"></div>\n            </div>\n            <!-- End Loader -->\n\n            <!-- Discount applied -->\n            <div ng-if=\"showDiscountAdded\" class='discount-applied'>\n                <div class=\"success-icon\"></div>\n                <h2 class=\"text-xxl text-grey-2 mb20\" translate=\"cw.subscription.unsubscribe_modal.success_title\">\n                </h2>\n                <!-- <p class=\"text-m text-grey-4 mb50\" translate=\"cw.subscription.unsubscribe_modal.success_desc\"\n                    translate-values=\"{percent:  promotionDetails.attributes.discount, date: formattedNextBillingEvent }\"></p> -->\n                <p class=\"text-m text-grey-4 mb50\" ng-if=\"showAnnual\" translate=\"cw.subscription.unsubscribe_modal.success_desc_2\"\n                    translate-values=\"{percent: promotionDetails.attributes.discount, date: formattedNextBillingEvent,\n                    price: promotionDetails.attributes.pc_price_string}\">\n                </p>\n                <p class=\"text-m text-grey-4 mb50\" ng-if=\"showMonthly\" translate=\"cw.subscription.unsubscribe_modal.success_desc_monthly\"\n                    translate-values=\"{percent: promotionDetails.attributes.discount, date: formattedNextBillingEvent,\n                    price: promotionDetails.attributes.pc_price_string}\">\n                </p>\n                <button class=\"btn btn-primary btn-half-width btn-large inline-block\" ng-click=\"closeModal()\"\n                    translate=\"cw.general.ui.close\"></button>\n            </div><!-- End discount applied -->\n\n            <div class=\"phone-modal\" ng-if=\"showPhoneModal\">\n                <div class=\"subscription-image\"></div>\n                <h3 class=\"text-xxl mt50 mb10\"><span\n                        translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.phone_number\">Phone\n                        number:</span> +49 7542 507 9006</h3>\n                <p class=\"text-l text-grey-3 mb50\" translate=\"cw.subscription.unsubscribe_modal.phone_modal_schedule\">\n                </p>\n                <span class=\"secondary-link text-grey-4 text-m inline-block crs-pointer underline-hover\"\n                    ng-click=\"backToOptions()\" translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.go_back\">\n                </span>\n            </div><!-- End Phone Modal -->\n\n            <!-- Chat modal -->\n            <div class=\"chat-modal\" ng-if=\"showChatModal\">\n                <div class=\"icon-support-logo\"></div>\n                <h3 class=\"text-xxl mt50 mb10\"\n                    translate=\"cw.subscription.unsubscribe_modal.options_modal.chat_support_modal.title\"></h3>\n                <div class=\"mb50\">\n                    <p class=\"text-l text-grey-3\" ng-if=\"!chatWidgetIsLoading\"\n                        translate=\"cw.subscription.unsubscribe_modal.options_modal.chat_support_modal.desc\"></p>\n                </div>\n                <div class=\"chat-loader-wrapper\" ng-if=\"chatWidgetIsLoading\">\n                    <div class=\"main-loader\"></div>\n                </div>\n                <span class=\"secondary-link text-grey-4 text-m inline-block crs-pointer underline-hover\"\n                    ng-click=\"backToOptions()\" translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.go_back\">\n                </span>\n            </div><!-- End Chat Modal -->\n\n\n            <div class=\"options-modal options-modal-only-discount\" id=\"options-modal\" ng-if=\"showOptions && !isLoading && showUnsubscribeFeedbackModal\">\n                <div ng-if=\"canOfferDiscount && !$root.cmaGBapplies\">\n                    <div ng-if=\"!showFeedbackModalFirst\">\n                        <p class=\"text-m text-grey-4 mb10\" translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"></p>\n                        <h2 class=\"text-xxl text-grey-2 mb30\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.title\"\n                            translate-values=\"{\n                                percent: promotionDetails.attributes.discount\n                            }\"></h2>\n\n                        <div class=\"card-large\">\n                            <p class=\"text-grey-4 text-s\"\n                                translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_1\"\n                                translate-values=\"{\n                                percent: promotionDetails.attributes.discount\n                                }\"></p>\n                            <p class=\"large-text text-green-1\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_2\"\n                            translate-values=\"{\n                                days: discountFreeDays\n                            }\"></p>\n                            <div class=\"icon\">\n                                <svg id=\"Icons\" xmlns=\"http://www.w3.org/2000/svg\" width=\"57.969\" height=\"70\" viewBox=\"0 0 57.969 70\">\n                                    <g id=\"Group_9\" data-name=\"Group 9\">\n                                        <path id=\"Path_5\" data-name=\"Path 5\" d=\"M22.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,31.938,18H22.094A1.1,1.1,0,0,0,21,19.094v9.844A1.1,1.1,0,0,0,22.094,30.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 1.688)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_6\" data-name=\"Path 6\" d=\"M37.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,46.937,18H37.094A1.1,1.1,0,0,0,36,19.094v9.844A1.1,1.1,0,0,0,37.094,30.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 1.688)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_7\" data-name=\"Path 7\" d=\"M37.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,46.937,33H37.094A1.1,1.1,0,0,0,36,34.094v9.844A1.1,1.1,0,0,0,37.094,45.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 3.094)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_8\" data-name=\"Path 8\" d=\"M37.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,46.937,48H37.094A1.1,1.1,0,0,0,36,49.094v9.844A1.1,1.1,0,0,0,37.094,60.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 4.5)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_9\" data-name=\"Path 9\" d=\"M7.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,16.938,33H7.094A1.1,1.1,0,0,0,6,34.094v9.844A1.1,1.1,0,0,0,7.094,45.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 3.094)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_10\" data-name=\"Path 10\" d=\"M22.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,31.938,33H22.094A1.1,1.1,0,0,0,21,34.094v9.844A1.1,1.1,0,0,0,22.094,45.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 3.094)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_11\" data-name=\"Path 11\" d=\"M7.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,16.938,48H7.094A1.1,1.1,0,0,0,6,49.094v9.844A1.1,1.1,0,0,0,7.094,60.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 4.5)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_12\" data-name=\"Path 12\" d=\"M22.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,31.938,48H22.094A1.1,1.1,0,0,0,21,49.094v9.844A1.1,1.1,0,0,0,22.094,60.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 4.5)\" fill=\"#838b93\"/>\n                                        <path id=\"Path_13\" data-name=\"Path 13\" d=\"M52.5,4.375H50.313V1.094A1.1,1.1,0,0,0,49.219,0H44.844A1.1,1.1,0,0,0,43.75,1.094V4.375H15.313V1.094A1.1,1.1,0,0,0,14.219,0H9.844A1.1,1.1,0,0,0,8.75,1.094V4.375H5.469A5.471,5.471,0,0,0,0,9.844V64.531A5.471,5.471,0,0,0,5.469,70H52.5a5.471,5.471,0,0,0,5.469-5.469V9.844A5.471,5.471,0,0,0,52.5,4.375ZM45.938,2.188h2.188V4.375H45.938Zm-35,0h2.188V4.375H10.938ZM2.188,9.844A3.291,3.291,0,0,1,5.469,6.563H52.5a3.291,3.291,0,0,1,3.281,3.281v4.375H2.188ZM55.781,64.531A3.291,3.291,0,0,1,52.5,67.813H5.469a3.291,3.291,0,0,1-3.281-3.281V16.417H55.781Z\" fill=\"#838b93\"/>\n                                    </g>\n                                </svg>\n                            </div>\n                            <a class=\"btn btn-secondary btn-medium inline-block\"\n                                translate=\"cw.subscription.unsubscribe_modal_only_discount.card.cta\"\n                                ng-click=\"applyDiscount('Unsubscribe Options', appIntegration.id)\"\n                                ng-class=\"{'disabled spin-loader': isLoading}\">\n                            </a>\n                        </div>\n                        <p class=\"text-s text-grey-4 mt30 mb30\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.info\"\n                            translate-values=\"{\n                                percent: promotionDetails.attributes.discount\n                            }\"></p>\n                        <a class=\"btn btn-secondary btn-medium inline-block\"\n                            translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"\n                            ng-click=\"goToSurveyModal()\">\n                        </a>\n                    </div>\n                    <div ng-if=\"showFeedbackModalFirst\">\n                        <div>\n                            <i class=\"icon take-survey-icon mt10\"></i>\n                            <h2 class=\"text-xxl text-grey-2 mt30 mb10\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_title2\">\n                            </h2>\n                            <p class=\"text-m text-grey-4 mb30\" translate=\"cw.subscription.unsubscribe_modal.reasons_modal_desc2\">\n                            </p>\n                            <div class=\"cards-wrapper\">\n                                <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedAutoRenew}\" ng-click=\"sendFeedbackFromModal('Auto-Renew')\">\n                                    <i class=\"icon icon-reload\"></i>\n                                    <div class=\"card-label\">\n                                        <p class=\"text-m text-grey-3\"\n                                            translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_1_1\">\n                                        </p>\n                                    </div>\n                                </div>\n                                <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedQuality}\" ng-click=\"sendFeedbackFromModal('Quality')\">\n                                    <i class=\"icon icon-quality\"></i>\n                                    <div class=\"card-label\">\n                                        <p class=\"text-m text-grey-3\"\n                                            translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2_1\">\n                                        </p>\n                                    </div>\n                                </div>\n                                <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedSupport}\" ng-click=\"sendFeedbackFromModal('Support')\">\n                                    <i class=\"icon icon-support-2\"></i>\n                                    <div class=\"card-label\">\n                                        <p class=\"text-m text-grey-3\"\n                                            translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2\"></p>\n                                    </div>\n                                </div>\n                                <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedPrice}\" ng-click=\"sendFeedbackFromModal('Price')\">\n                                    <i class=\"icon icon-dolar-circle\"></i>\n                                    <div class=\"card-label\">\n                                        <p class=\"text-m text-grey-3\"\n                                            translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_4_1\">\n                                        </p>\n                                    </div>\n                                </div>\n                                <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedOther}\" ng-click=\"sendFeedbackFromModal('Other')\">\n                                    <i class=\"icon icon-note\"></i>\n                                    <div class=\"card-label\">\n                                        <p class=\"text-m text-grey-3\"\n                                            translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_5_1\">\n                                         </p>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"buttons text-center\">\n                            <button ng-if=\"showCloseButton\" class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                                ng-class=\"{'spin-loader': loading}\"\n                                ng-click=\"onCloseButtonClick('Unsubscribe Options')\" ng-disabled=\"loading\" translate=\"cw.general.ui.close\">\n                            </button>\n                            <button class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                                ng-class=\"{'spin-loader': loading}\"\n                                ng-click=\"goToBenefitsModal()\" ng-disabled=\"loading\" translate=\"cw.subscription.unsubscribe_modal_row.cancel_now\">\n                            </button>\n                            <div class=\"btn-primary btn-medium inline-block crs-pointer mlr5 mt10\" ng-click=\"cancel('Disable Subscription', appIntegration.id)\" translate=\"cw.subscription.unsubscribe_modal_row.keep_subscription\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"!canOfferDiscount || $root.cmaGBapplies\">\n                    <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal.title\">\n                    </h2>\n                    <p class=\"text-m text-grey-4 mb5\" translate=\"cw.subscription.unsubscribe_modal.desc_1\"\n                        ng-class=\"{'mb50': !canOfferDiscount}\">\n                    </p>\n                    <p class=\"text-m text-grey-4 mb50\" translate=\"cw.subscription.unsubscribe_modal.desc_2\"\n                        ng-if=\"canOfferDiscount\">\n                    </p>\n                    <div class=\"cards-wrapper mb30\" ng-class=\"{'mt50': canOfferChatSupport && offerChatSupport}\"\n                        id=\"options-list\">\n                        <a ng-if=\"!$root.cmaGBapplies\" ng-click=\"contactSupport()\" class=\"large-card\" ui-sref=\"root.dashboard.support({tab:'support'})\">\n                            <i class=\"icon icon-vip-support\"></i>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.contact_support\"></p>\n                        </a>\n                        <button class=\"large-card cancel-card\"\n                            ng-if=\"$root.cmaGBapplies\"\n                            ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\"\n                            ng-class=\"{'show-loading': loading}\" ng-disabled=\"loading\" connectqa-subscriptions=\"unsubscribe-now-reasons\">\n                            <div>\n                                <div class='loader-wrapper' ng-if=\"loading\">\n                                    <div class=\"main-loader\"></div>\n                                </div>\n                                <p translate=\"cw.subscription.unsubscribe_modal.cancel_now\"></p>\n                            </div>\n                        </button>\n                        <div class=\"large-card chat-card green-border\" ng-if=\"canOfferChatSupport && offerChatSupport\"\n                            id=\"chat-option\" ng-click=\"showChatScreen()\" ng-class=\"{'animated fadeIn': isAnimationEnable}\">\n                            <div class=\"info-tooltip arrow-bottom\" ng-if=\"showMultipleLicensesTooltip\">\n                                <div>\n                                    <span class=\"agent-avatar\"></span>\n                                    <span class=\"w80\"\n                                        translate=\"cw.subscription.unsubscribe_modal.multiple_licenses_tooltip\"\n                                        translate-values=\"{name: filterName}\"></span>\n                                </div>\n                            </div>\n                            <div class=\"info-tooltip arrow-bottom\" ng-if=\"!showMultipleLicensesTooltip\">\n                                <div>\n                                    <span class=\"agent-avatar\"></span>\n                                    <span class=\"w80\" translate=\"cw.subscription.unsubscribe_modal.chat_tooltip\"\n                                        translate-values=\"{username: filterName}\"></span>\n                                </div>\n                            </div>\n                            <div class=\"background-holder phone-holder\">\n                                <i class=\"icon icon-vip-support\"></i>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.options_modal.chat_support\"></p>\n                        </div>\n                        <div class=\"large-card\" ng-click=\"showPhoneScreen()\" ng-if=\"canOfferPhoneSupport\" id=\"phone-option\"\n                            ng-class=\"{'animated fadeIn': isAnimationEnable}\">\n                            <div class=\"background-holder phone-holder\">\n                                <i class=\"icon icon-phone-receiver\"></i>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.options_modal.phone_support\"></p>\n                        </div>\n                        <div class=\"large-card\" ng-click=\"showPromotionScreen()\" ng-if=\"canOfferDiscount\"\n                            ng-class=\"{'animated fadeIn': isAnimationEnable}\" id=\"promotion-option\">\n                            <div class=\"discount background-holder discount-holder\">\n                                <span\n                                    class='inline-block v-top percent font-bold'>{{promotionDetails.attributes.discount}}</span>\n                                <div class='inline-block text-left v-top'>\n                                    <span class='inline-block v-middle percent-icon font-bold'>%</span>\n                                    <span class='inline-block v-middle percent-text font-bold'>off</span>\n                                </div>\n                            </div>\n                            <p class=\"mt15\" translate=\"cw.subscription.unsubscribe_modal.dach_options_modal.discount\"></p>\n                        </div>\n                    </div>\n                    <div ng-if=\"!$root.cmaGBapplies\" class=\"text-center\">\n                        <span class=\"crs-pointer text-m text-grey-4 underline-hover\" ng-click=\"goToSurveyModal()\"\n                            translate=\"cw.subscription.unsubscribe_modal.cancel_now\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"survey-modal\" ng-if=\"showSurveyModal\">\n                <div>\n                    <i class=\"icon take-survey-icon mt10\"></i>\n                    <h2 class=\"text-xxl text-grey-2 mt30 mb10\"\n                        translate=\"cw.subscription.unsubscribe_modal.reasons_modal_title2\">\n                    </h2>\n                    <p class=\"text-m text-grey-4 mb30\" translate=\"cw.subscription.unsubscribe_modal.reasons_modal_desc2\">\n                    </p>\n                    <div class=\"cards-wrapper\">\n                        <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedAutoRenew}\" ng-click=\"sendFeedbackFromModal('Auto-Renew')\">\n                            <i class=\"icon icon-reload\"></i>\n                            <div class=\"card-label\">\n                                <p class=\"text-m text-grey-3\"\n                                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_1_1\">\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedQuality}\" ng-click=\"sendFeedbackFromModal('Quality')\">\n                            <i class=\"icon icon-quality\"></i>\n                            <div class=\"card-label\">\n                                <p class=\"text-m text-grey-3\"\n                                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2_1\">\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedSupport}\" ng-click=\"sendFeedbackFromModal('Support')\">\n                            <i class=\"icon icon-support-2\"></i>\n                            <div class=\"card-label\">\n                                <p class=\"text-m text-grey-3\"\n                                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2\"></p>\n                            </div>\n                        </div>\n                        <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedPrice}\" ng-click=\"sendFeedbackFromModal('Price')\">\n                            <i class=\"icon icon-dolar-circle\"></i>\n                            <div class=\"card-label\">\n                                <p class=\"text-m text-grey-3\"\n                                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_4_1\">\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"card-with-icon feedback-card\" ng-class=\"{'feedback-card-focused': feedbackFocusedOther}\" ng-click=\"sendFeedbackFromModal('Other')\">\n                            <i class=\"icon icon-note\"></i>\n                            <div class=\"card-label\">\n                                <p class=\"text-m text-grey-3\"\n                                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_5_1\">\n                                 </p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"buttons text-center\">\n                    <button ng-if=\"showCloseButton\" class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                    ng-class=\"{'spin-loader': loading}\"\n                    ng-click=\"onCloseButtonClick('Disable Subscription')\" ng-disabled=\"loading\" translate=\"cw.general.ui.close\">\n                    </button>                    \n                    <button class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                        ng-class=\"{'spin-loader': loading}\"\n                        ng-click=\"goToBenefitsModal()\" ng-disabled=\"loading\" translate=\"cw.subscription.unsubscribe_modal_row.cancel_now\">\n                    </button>\n                    <div class=\"btn-primary btn-medium inline-block crs-pointer mlr5 mt10\" ng-click=\"cancel('Disable Subscription', appIntegration.id)\" translate=\"cw.subscription.unsubscribe_modal_row.keep_subscription\">\n                    </div>\n                </div>\n           </div>\n\n            <div class=\"benefits-screen\" ng-if=\"showBenefitsModal\" ng-class=\"{'benefits-screen-aia': appIntegration.id === 'adwp1'}\">\n                <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal_row.title\"\n                    ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length === 0 || !appIntegration.attributes.resource.comparisonFeatures\">\n                </h2>\n                <h2 class=\"text-xxl text-grey-2 mb10\" translate=\"cw.subscription.unsubscribe_modal_row.benefits_title\"\n                    ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\">\n                </h2>\n                <p class=\"text-m text-grey-4 mb5\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\" translate=\"cw.subscription.unsubscribe_modal_row.desc\">\n                </p>\n                <p class=\"text-l text-grey-4 mb40\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length === 0 || !appIntegration.attributes.resource.comparisonFeatures\" translate=\"cw.subscription.unsubscribe_modal.desc_1\"></p>\n                    <div class=\"benefits-comparison-wrapper\" ng-if=\"appIntegration.attributes.resource.comparisonFeatures.length > 0\">\n                        <div class=\"features-container\">\n                            <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                                <i class=\"icon icon-close icon-red-2\"></i>\n                                <p translate=\"{{ 'cw.ocp.' + feature }}\" class=\"text-m text-grey-4 ml20\"></p>\n                            </div>\n                        </div>\n                        <div class=\"benefits-container\" ng-class=\"{'benefits-container-aia': appIntegration.id === 'adwp1'}\">\n                            <div class=\"benefit highlighted\">\n                                <div translate=\"cw.subscription.unsubscribe_modal_row.current_subscription\" class=\"title text-m text-grey-2 font-bold\"></div>\n                                <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                                    <i class=\"icon icon-checkmark-bold icon-green-2\"></i>\n                                </div>\n                            </div>\n                            <div class=\"benefit\">\n                                <div translate=\"cw.subscription.unsubscribe_modal_row.after_subscription\" class=\"title text-m text-grey-2 font-bold\"></div>\n                                <div ng-repeat=\"feature in appIntegration.attributes.resource.comparisonFeatures\" class=\"feature\">\n                                    <i class=\"icon icon-close icon-red-2\"></i>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"buttons text-center\">\n                        <button ng-if=\"showCloseButton\" class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                            ng-class=\"{'spin-loader': loading}\"\n                            ng-click=\"onCloseButtonClick('Disable Subscription')\" ng-disabled=\"loading\" translate=\"cw.general.ui.close\">\n                        </button>\n                        <button class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                            ng-class=\"{'spin-loader': loading}\"\n                            ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\" ng-disabled=\"loading\" translate=\"cw.subscription.unsubscribe_modal_row.cancel_now\"\n                            ng-hide=\"showFeedbackModalFirst\">\n                        </button>\n                        <button class=\"btn-grey-faded btn-medium inline-block mlr5 mt30 crs-pointer\"\n                            ng-class=\"{'spin-loader': loading}\"\n                            ng-click=\"determineModalToOpen()\" translate=\"cw.subscription.unsubscribe_modal_row.cancel_now\"\n                            ng-show=\"showFeedbackModalFirst\">\n                        </button>\n                        <div class=\"btn-primary btn-medium inline-block crs-pointer mlr5 mt10\" ng-click=\"cancel('Disable Subscription', appIntegration.id)\" translate=\"cw.subscription.unsubscribe_modal_row.keep_subscription\">\n                        </div>\n                    </div>\n            </div>\n\n            <div class=\"options-modal options-modal-only-discount\" ng-if=\"showDiscountModal\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"></p>\n                <h2 class=\"text-xxl text-grey-2 mb30\"\n                    translate=\"cw.subscription.unsubscribe_modal_only_discount.title\"\n                    translate-values=\"{\n                        percent: promotionDetails.attributes.discount\n                    }\"></h2>\n\n                <div class=\"card-large\">\n                    <p class=\"text-grey-4 text-s\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_1\"\n                        translate-values=\"{\n                        percent: promotionDetails.attributes.discount\n                        }\"></p>\n                    <p class=\"large-text text-green-1\"\n                    translate=\"cw.subscription.unsubscribe_modal_only_discount.card.title_2\"\n                    translate-values=\"{\n                        days: discountFreeDays\n                    }\"></p>\n                    <div class=\"icon\">\n                        <svg id=\"Icons\" xmlns=\"http://www.w3.org/2000/svg\" width=\"57.969\" height=\"70\" viewBox=\"0 0 57.969 70\">\n                            <g id=\"Group_9\" data-name=\"Group 9\">\n                                <path id=\"Path_5\" data-name=\"Path 5\" d=\"M22.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,31.938,18H22.094A1.1,1.1,0,0,0,21,19.094v9.844A1.1,1.1,0,0,0,22.094,30.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 1.688)\" fill=\"#838b93\"/>\n                                <path id=\"Path_6\" data-name=\"Path 6\" d=\"M37.094,30.031h9.844a1.1,1.1,0,0,0,1.094-1.094V19.094A1.1,1.1,0,0,0,46.937,18H37.094A1.1,1.1,0,0,0,36,19.094v9.844A1.1,1.1,0,0,0,37.094,30.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 1.688)\" fill=\"#838b93\"/>\n                                <path id=\"Path_7\" data-name=\"Path 7\" d=\"M37.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,46.937,33H37.094A1.1,1.1,0,0,0,36,34.094v9.844A1.1,1.1,0,0,0,37.094,45.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 3.094)\" fill=\"#838b93\"/>\n                                <path id=\"Path_8\" data-name=\"Path 8\" d=\"M37.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,46.937,48H37.094A1.1,1.1,0,0,0,36,49.094v9.844A1.1,1.1,0,0,0,37.094,60.031Zm1.094-9.844h7.656v7.656H38.188Z\" transform=\"translate(3.375 4.5)\" fill=\"#838b93\"/>\n                                <path id=\"Path_9\" data-name=\"Path 9\" d=\"M7.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,16.938,33H7.094A1.1,1.1,0,0,0,6,34.094v9.844A1.1,1.1,0,0,0,7.094,45.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 3.094)\" fill=\"#838b93\"/>\n                                <path id=\"Path_10\" data-name=\"Path 10\" d=\"M22.094,45.031h9.844a1.1,1.1,0,0,0,1.094-1.094V34.094A1.1,1.1,0,0,0,31.938,33H22.094A1.1,1.1,0,0,0,21,34.094v9.844A1.1,1.1,0,0,0,22.094,45.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 3.094)\" fill=\"#838b93\"/>\n                                <path id=\"Path_11\" data-name=\"Path 11\" d=\"M7.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,16.938,48H7.094A1.1,1.1,0,0,0,6,49.094v9.844A1.1,1.1,0,0,0,7.094,60.031Zm1.094-9.844h7.656v7.656H8.187Z\" transform=\"translate(0.563 4.5)\" fill=\"#838b93\"/>\n                                <path id=\"Path_12\" data-name=\"Path 12\" d=\"M22.094,60.031h9.844a1.1,1.1,0,0,0,1.094-1.094V49.094A1.1,1.1,0,0,0,31.938,48H22.094A1.1,1.1,0,0,0,21,49.094v9.844A1.1,1.1,0,0,0,22.094,60.031Zm1.094-9.844h7.656v7.656H23.188Z\" transform=\"translate(1.969 4.5)\" fill=\"#838b93\"/>\n                                <path id=\"Path_13\" data-name=\"Path 13\" d=\"M52.5,4.375H50.313V1.094A1.1,1.1,0,0,0,49.219,0H44.844A1.1,1.1,0,0,0,43.75,1.094V4.375H15.313V1.094A1.1,1.1,0,0,0,14.219,0H9.844A1.1,1.1,0,0,0,8.75,1.094V4.375H5.469A5.471,5.471,0,0,0,0,9.844V64.531A5.471,5.471,0,0,0,5.469,70H52.5a5.471,5.471,0,0,0,5.469-5.469V9.844A5.471,5.471,0,0,0,52.5,4.375ZM45.938,2.188h2.188V4.375H45.938Zm-35,0h2.188V4.375H10.938ZM2.188,9.844A3.291,3.291,0,0,1,5.469,6.563H52.5a3.291,3.291,0,0,1,3.281,3.281v4.375H2.188ZM55.781,64.531A3.291,3.291,0,0,1,52.5,67.813H5.469a3.291,3.291,0,0,1-3.281-3.281V16.417H55.781Z\" fill=\"#838b93\"/>\n                            </g>\n                        </svg>\n                    </div>\n                    <a class=\"btn btn-secondary btn-medium inline-block\"\n                        translate=\"cw.subscription.unsubscribe_modal_only_discount.card.cta\"\n                        ng-click=\"applyDiscount('Unsubscribe Options', appIntegration.id)\"\n                        ng-class=\"{'disabled spin-loader': isLoading}\">\n                    </a>\n                </div>\n                <p class=\"text-s text-grey-4 mt30 mb30\"\n                    translate=\"cw.subscription.unsubscribe_modal_only_discount.info\"\n                    translate-values=\"{\n                        percent: promotionDetails.attributes.discount\n                    }\"></p>\n                <button class=\"btn btn-secondary btn-medium inline-block\"\n                    translate=\"cw.subscription.unsubscribe_modal_only_discount.cancel_renewal\"\n                    ng-click=\"confirm('Disable Subscription', appIntegration.id, '')\"\n                    ng-class=\"{'spin-loader': loading}\" ng-disabled=\"loading\">\n                </button>\n            </div>\n\n            <div ng-if=\"showSuccessCancellationScreen\" class=\"success-screen\">\n                <div class=\"success-image-modal\"></div>\n                    <h1 class=\"text-xl mt40 mb10 text-grey-3 font-regular\" translate=\"cw.cancellation.success_title\"></h1>\n                    <p class=\"text-l text-grey-4 mb40\" translate=\"cw.cancellation.success_desc\" translate-values=\"{date: formattedexpireDate}\">\n                    </p>\n                    <button class=\"btn btn-primary btn-half-width btn-large inline-block mb20\" ng-click=\"closeModal()\"\n                            translate=\"cw.general.ui.close\"></button>\n            </div>\n        </div><!-- End Options Modal - Discount & Monthly Offer -->\n    </div>\n\n    <!-- Survey flow -->\n    <div ng-if=\"surveyFlow\">\n        <div ng-if=\"showTakeSurveyScreen\">\n            <div class=\"survey-modal\">\n                <i class=\"icon take-survey-icon mt10\"></i>\n                <h2 class=\"text-xxl text-grey-2 mt30 mb10\"\n                    translate=\"cw.subscription.unsubscribe_modal.reasons_modal_title\">\n                </h2>\n                <p class=\"text-m text-grey-4 mb30\" translate=\"cw.subscription.unsubscribe_modal.reasons_modal_desc\"\n                    translate-values=\"{date: formattedexpireDate}\">\n                </p>\n                <div class=\"cards-wrapper\">\n                    <div class=\"card-with-icon feedback-card\" ng-click=\"sendFeedback('Auto-Renew')\">\n                        <i class=\"icon icon-reload\"></i>\n                        <div class=\"card-label\">\n                            <p class=\"text-m text-grey-3\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_1_1\">\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"card-with-icon feedback-card\" ng-click=\"sendFeedback('Quality')\">\n                        <i class=\"icon icon-quality\"></i>\n                        <div class=\"card-label\">\n                            <p class=\"text-m text-grey-3\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2_1\">\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"card-with-icon feedback-card\" ng-click=\"sendFeedback('Support')\">\n                        <i class=\"icon icon-support-2\"></i>\n                        <div class=\"card-label\">\n                            <p class=\"text-m text-grey-3\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_2\"></p>\n                        </div>\n                    </div>\n                    <div class=\"card-with-icon feedback-card\" ng-click=\"sendFeedback('Price')\">\n                        <i class=\"icon icon-dolar-circle\"></i>\n                        <div class=\"card-label\">\n                            <p class=\"text-m text-grey-3\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_4_1\">\n                            </p>\n                        </div>\n                    </div>\n                    <div class=\"card-with-icon feedback-card\" ng-click=\"sendFeedback('Other')\">\n                        <i class=\"icon icon-note\"></i>\n                        <div class=\"card-label\">\n                            <p class=\"text-m text-grey-3\"\n                                translate=\"cw.subscription.unsubscribe_modal.reasons_modal_reason_5_1\">\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!-- Survey success screen -->\n        <div ng-show=\"showSuccessScreen\" class=\"success-screen\">\n            <div class=\"success-image-modal\"></div>\n            <h1 class=\"text-xl mt40 mb10 text-grey-3 font-regular\" translate=\"cw.feedback.success_title\"></h1>\n            <p class=\"text-l text-grey-4 mb40\" translate=\"cw.feedback.success_desc\">\n            </p>\n            <button class=\"btn btn-primary btn-half-width btn-large inline-block mb20\" ng-click=\"closeModal()\"\n                translate=\"cw.general.ui.close\"></button>\n        </div>\n    </div>\n\n</div>\n";
var path = 'views/modals/subscription-confirmation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "LgeR":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("1zte");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "Lk3O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listen events for Actions Model
 */
angular.module('listeners').service('ActionsListener', ['ActionsRepository', function (ActionsRepository) {

    _RFC2.default.subscribe('socket:actions', function (response) {

        if (response.verb === 'PUT') {

            ActionsRepository.update(response.payload.data);
        }
    });
}]);

/***/ }),

/***/ "M40U":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-xlarge-width trial-card-cnt\" ng-class=\"{'no-bg': trialDeploySuccess}\">\n\n    <div id=\"trial-card\" class=\"trial-card\">\n\n        <!-- Trial details screen -->\n        <div class=\"trial-promotion\" ng-if=\"!trialDeploySuccess\">\n            <div class=\"box\"></div>\n            <div class=\"trial-description\">\n                <div class=\"trial-first-screen\" ng-show=\"showFirstScreen\">\n                    <h2 class=\"font-bold\" translate=\"cw.modal.trial.title\"></h2>\n                    <h3 class=\"mb20\" translate=\"cw.modal.trial.subtitle\" translate-values= \"{product: product}\"></h3>\n            \n                    <button ng-click=\"activateTrial();\" class=\"btn btn-primary btn-medium full-width mb20\" ng-disabled=\"loadingButton\">\n                        <span ng-if=\"hasWindowsDevice\" translate=\"cw.modal.trial.btn_activate\" translate-values= \"{product: product}\"></span>\n                        <span ng-if=\"!hasWindowsDevice\" translate=\"cw.modal.trial.btn_install\"></span>\n                    </button>\n\n                    <p ng-if=\"hasWindowsDevice\" class=\"text-s text-grey-3 mb50\" translate=\"cw.modal.trial.fine_print\" translate-values= \"{brandname: brandName, product: product}\"></p>\n            \n                    <span ng-click=\"showFirstScreen = false\" class=\"text-xl text-blue-2 crs-pointer\"><i class=\"icon icon-info icon-xxs inline-block\"></i> <span translate=\"cw.modal.trial.learn_more\"  translate-values= \"{brandname: brandName, product: product}\"></span></span>\n                </div>\n\n                <div class=\"trial-details\" ng-show=\"!showFirstScreen\">\n                    <h2 class=\"font-bold\" translate=\"cw.modal.trial.more_info.title\" translate-values= \"{brandname: brandName, product: product}\"></h2>\n                    <h3 class=\"mb20\" translate=\"cw.modal.trial.more_info.subtitle\"></h3>\n\n                    <ul class=\"features\">\n                        <li>\n                            <i class=\"icon icon-checkmark text-m inline-block\"></i>\n                            <span class=\"text-l\" translate=\"cw.modal.trial.features.feature1\"></span>\n                        </li>\n                        <li>\n                            <i class=\"icon icon-checkmark text-m inline-block\"></i>\n                            <span class=\"text-l\" translate=\"cw.modal.trial.features.feature2\"></span>\n                        </li>\n                        <li>\n                            <i class=\"icon icon-checkmark text-m inline-block\"></i>\n                            <span class=\"text-l\" translate=\"cw.modal.trial.features.feature3\"></span>\n                        </li>\n                        <li>\n                            <i class=\"icon icon-checkmark text-m inline-block\"></i>\n                            <span class=\"text-l\" translate=\"cw.modal.trial.features.feature4\"></span>\n                        </li>\n                    </ul>\n            \n                    <button ng-click=\"activateTrial();\" class=\"btn btn-primary btn-medium full-width mb20\" ng-disabled=\"loadingButton\">\n                        <span ng-if=\"hasWindowsDevice\" translate=\"cw.modal.trial.btn_activate\" translate-values= \"{product: product}\"></span>\n                        <span ng-if=\"!hasWindowsDevice\" translate=\"cw.modal.trial.btn_install\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <!-- Success screen -->\n        <div class=\"trial-success\" ng-if=\"trialDeploySuccess\">\n            <div class=\"box-wrap\">\n                <div class=\"box\"></div>\n            </div>\n\n            <h3 class=\"text-xxxl mb10\" translate=\"cw.modal.trial.success.title\" translate-values= \"{brandname: brandName, product: product}\"></h3>\n    \n            <p class=\"text-l text-grey-2 mb30\" translate=\"cw.modal.trial.success.description\"></p>\n    \n            <div>\n                <button ng-click=\"goToSubscriptions();\" class=\"btn btn-primary btn-medium\" translate=\"cw.general.fixed_it\"></button>\n            </div>\n        </div>\n        \n    </div>\n</div>\n";
var path = 'scripts/controllers/modals/store-trial-card/trial-card.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "M4Mx":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content coinbase-account\" ng-class=\"{'small-padding': isLoggedInCoinbase}\">\n    <div class=\"loader-wrapper\" ng-if=\"dataIsLoading\">\n        <div class=\"main-loader\"></div>\n    </div>\n    <div ng-if=\"!isLoggedInCoinbase && !dataIsLoading\">\n        <!-- Step 1 -->\n        <div class=\"text-center\">\n            <div class=\"coinbase-logo mt50 mb50\"></div>\n            <div class=\"loader-wrapper small-wrapper mb50\" ng-if=\"waitingForCoinbase\">\n                <div class=\"main-loader\"></div>\n            </div>\n            <div>\n                <a class=\"btn btn-primary btn-medium\" ng-click=\"proceedToCoinbase()\" translate=\"cw.dashboard.crypto.coinbase.link_account\">\n                </a>\n            </div>\n            <div class=\"mt20 mb50\">\n                <a href=\"https://coinbase.com\" target=\"_blank\" class=\"btn btn-secondary btn-medium\" translate=\"cw.dashboard.crypto.coinbase.create_account\">\n                </a>\n            </div>\n        </div><!-- End step 1 -->\n    </div>\n\n    <div ng-if=\"isLoggedInCoinbase && !dataIsLoading\" class=\"withdraw-options text-left\">\n        <!-- Withdraw step 1 -->\n        <div ng-if=\"withdrawStep === '1'\">\n            <h2 class=\"text-xxl text-grey-3 text-center\" translate=\"cw.dashboard.crypto.coinbase.withdraw_to_coinbase\"></h2>\n            <div class=\"text-center\">\n                <div class=\"{{activeCrypto.toLowerCase()}}-green-icon\"></div>\n                <div class=\"text-center inline-block v-middle\">\n                    <p class=\"text-m text-grey-3\" translate=\"cw.dashboard.crypto.coinbase.available_balance\"></p>\n                    <p class=\"font-bold text-xxl text-grey-1\">{{balance}} {{activeCrypto}}</p>\n                </div>\n            </div>\n            <div class=\"input-holder mt30\">\n                <div class=\"text-s text-grey-4 pass-text\">\n                    <span translate=\"cw.dashboard.crypto.coinbase.withdraw_from\"></span>\n                </div>\n                <ui-select class=\"text-m\" \n                    ng-model=\"withdrawFromWallet.selected\"\n                    ng-change=\"validateWithdrawFrom($select.selected)\" \n                    ng-class=\"{'error': WithdrawFromError }\"\n                    theme=\"selectize\">\n                    <ui-select-match class=\"text-m\" placeholder=\"{{ 'cw.dashboard.crypto.coinbase.select_account' | translate }}\">\n                        <span data-ng-bind=\"'Avira ' + $select.selected + ' Wallet'\"></span>\n                    </ui-select-match>\n\n                    <ui-select-choices class=\"text-m\" repeat=\"currency in walletCurrencies\">\n                        <span class=\"text-m\" data-ng-bind=\"'Avira ' + currency + ' Wallet'\"></span>\n                    </ui-select-choices>\n                </ui-select>\n                <p class=\"error-message\" ng-if=\"WithdrawFromError\" translate=\"cw.dashboard.crypto.coinbase.select_account_error\"></p>\n            </div>\n\n            <div class=\"input-holder mt20\">\n                <div class=\"text-s text-grey-4 pass-text\">\n                    <span translate=\"cw.dashboard.crypto.coinbase.withdraw_to\"></span>\n                </div>\n                <ui-select class=\"text-m\" \n                    ng-model=\"withdrawToWallet.selected\"\n                    ng-change=\"validateWithdrawTo($select.selected)\" \n                    ng-class=\"{'error': WithdrawFromError }\"\n                    theme=\"selectize\">\n                    <ui-select-match class=\"text-m\" placeholder=\"{{ 'cw.dashboard.crypto.coinbase.select_account' | translate }}\">\n                        <span data-ng-bind=\"'Coinbase ' + $select.selected.name\"></span>\n                    </ui-select-match>\n\n                    <ui-select-choices class=\"text-m\" repeat=\"account in coinbaseAccounts\">\n                        <span class=\"text-m\" data-ng-bind=\"'Coinbase ' + account.name\"></span>\n                    </ui-select-choices>\n                </ui-select>\n                <p class=\"error-message\" ng-if=\"WithdrawToError\" translate=\"cw.dashboard.crypto.coinbase.select_account_error\"></p>\n            </div>\n\n            <div class=\"input-holder mt20 w100 amount-input\">\n                <div class=\"text-s text-grey-4 pass-text\">\n                    <span translate=\"cw.dashboard.crypto.transactions.amount\"></span>\n                </div>\n                <div class=\"form-group p-relative\">\n                    <input type=\"text\" id=\"amount\" autocomplete=\"off\" id=\"userFirstName\"\n                        ng-model=\"amountValue\" ng-keyup=\"validateAmount($event)\" ng-class=\"{'error': amountError }\" />\n                    <p class=\"currency text-grey-4 text-s\">{{activeCrypto}}</p>\n                    <a class=\"max-button crs-pointer uppercase\" ng-click=\"maxAmoutValue()\" translate=\"cw.dashboard.crypto.coinbase.max\"></a>\n                </div>\n                <p class=\"error-message\" ng-if=\"amountError\">{{amountErrorMessage}}</p>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-center mt30\">\n                <div class=\"text-grey-3 text-s\">\n                    <span class=\"inline-block v-middle mr5\" translate=\"cw.dashboard.crypto.coinbase.processing_time\"></span>\n                    <span class=\"info-tooltip-holder inline-block v-middle\">\n                        <span class=\"icon icon-info-2 icon-blue-2 icon-xs\"></span>\n                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.dashboard.crypto.coinbase.processing_time_desc\">\n                        </div>\n                    </span>\n                </div>\n                <p class=\"text-grey-3 text-s\" translate=\"cw.dashboard.crypto.coinbase.transfer_time\"></pss>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-center mt5\">\n                <div class=\"text-grey-3 text-s\">\n                    <span class=\"inline-block v-middle mr5\" translate=\"cw.dashboard.crypto.coinbase.network_fee\"></span>\n                    <span class=\"info-tooltip-holder inline-block v-middle\">\n                        <span class=\"icon icon-info-2 icon-blue-2 icon-xs\"></span>\n                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.dashboard.crypto.coinbase.network_fee_desc\">\n                        </div>\n                    </span>\n                </div>\n                <p class=\"text-grey-3 text-s\">{{quote.networkFee}}</p>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-flex-start mt30\">\n                <div>\n                    <p class=\"text-grey-1 font-bold uppercase text-s\" translate=\"cw.dashboard.crypto.coinbase.total_to_transfer\"></p>\n                    <p class=\"text-grey-3 text-xs\" translate=\"cw.dashboard.crypto.coinbase.after_fee\"></p>\n                </div>\n                <p class=\"text-grey-1 text-s\"><b>{{quote.transfer}}</b></p>\n            </div>\n            <div class=\"mt30 text-center\">\n                <a class=\"btn btn-primary btn-medium\" ng-click=\"reviewWithdraw()\"\n                    ng-class=\"{'disabled': hasErrorsReviewWithdraw}\"\n                    translate=\"cw.dashboard.crypto.coinbase.review_withdraw\">\n                </a>\n            </div>\n        </div><!-- End withdraw step 1 -->\n        <!-- Withdraw step 2 -->\n        <div ng-if=\"withdrawStep === '2'\">\n            <h2 class=\"text-xxl text-grey-3 text-center\" translate=\"cw.dashboard.crypto.coinbase.confirm_withdraw\"></h2>\n            <div class=\"display-flex justify-content-space-between align-item-center mt30 withdraw-step-2-heaader\">\n                <div class=\"w40\">\n                    <div class=\"{{activeCrypto.toLowerCase()}}-green-icon\"></div>\n                    <div class=\"text-left inline-block v-middle\">\n                        <p class=\"text-m text-grey-3\" translate=\"cw.dashboard.crypto.coinbase.withdrawing\"></p>\n                        <p class=\"font-bold text-xxl text-grey-1\">{{amountValue}} {{activeCrypto}}</p>\n                    </div>\n                </div>\n                <div>\n                    <i class=\"icon icon-arrow-right-slim text-grey-4\"></i>\n                </div>\n                <div class=\"w40\">\n                    <p class=\"text-grey-3 text-m text-right\">\n                        <span translate=\"cw.dashboard.crypto.coinbase.to_coinbase\"></span> <br>({{userName}})</p>\n                </div>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-center mt30\">\n                <div class=\"text-grey-3 text-s\">\n                    <span class=\"inline-block v-middle mr5\" translate=\"cw.dashboard.crypto.coinbase.processing_time\"></span>\n                    <span class=\"info-tooltip-holder inline-block v-middle\">\n                        <span class=\"icon icon-info-2 icon-blue-2 icon-xs\"></span>\n                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.dashboard.crypto.coinbase.processing_time_desc\">\n                        </div>\n                    </span>\n                </div>\n                <p class=\"text-grey-3 text-s\" translate=\"cw.dashboard.crypto.coinbase.transfer_time\"></pss>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-center mt5\">\n                <div class=\"text-grey-3 text-s\">\n                    <span class=\"inline-block v-middle mr5\" translate=\"cw.dashboard.crypto.coinbase.network_fee\"></span>\n                    <span class=\"info-tooltip-holder inline-block v-middle\">\n                        <span class=\"icon icon-info-2 icon-blue-2 icon-xs\"></span>\n                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.dashboard.crypto.coinbase.network_fee_desc\">\n                        </div>\n                    </span>\n                </div>\n                <p class=\"text-grey-3 text-s\">{{quote.networkFee}}</p>\n            </div>\n            <div class=\"display-flex justify-content-space-between align-item-flex-start mt30\">\n                <div>\n                    <p class=\"text-grey-1 font-bold uppercase text-s\" translate=\"cw.dashboard.crypto.coinbase.total_to_transfer\"></p>\n                    <p class=\"text-grey-3 text-xs\" translate=\"cw.dashboard.crypto.coinbase.after_fee\"></p>\n                </div>\n                <p class=\"text-grey-1 text-s\"><b>{{quote.transfer}}</b></p>\n            </div>\n            <div class=\"fake-radio input-checkbox\" ng-class=\"{'error': transactionConsentError}\">\n                <input type=\"checkbox\" id=\"transaction_info\" ng-model=\"transactionConsent\"\n                    ng-change=\"onChangeCheckbox()\" />\n                <label class=\"input-checkbox label\" for=\"transaction_info\">\n                    <span>\n                        <p class=\"text-grey-3 text-l inline-block v-middle\" translate=\"cw.dashboard.crypto.coinbase.accept_terms\"></p>\n                    </span>\n                </label>\n            </div>\n            <div class=\"mt30 text-center\">\n                <a class=\"btn btn-primary btn-medium\" ng-click=\"withdraw()\" ng-class=\"{'disabled': hasErrorsWithdraw}\" translate=\"cw.dashboard.crypto.wallet.withdraw\">\n                </a>\n                <div class=\"mt30\">\n                    <a class=\"crs-pointer link text-l inline-block text-blue-2 display-flex align-item-center back-link\"\n                        ng-click=\"back()\">\n                        <i class=\"icon icon-back\"></i>\n                        <span translate=\"cw.dashboard.crypto.coinbase.go_back\"></span>\n                    </a>\n                </div>\n            </div>\n        </div><!-- End withdraw step 2 -->\n        <!-- Withdraw step loading -->\n        <div ng-if=\"withdrawStep === 'loading'\">\n            <div class=\"loader-wrapper\">\n                <div class=\"main-loader\"></div>\n            </div>\n        </div>\n        <!--End withdraw step loading -->\n\n        <!-- Withdraw complete -->\n        <div ng-if=\"withdrawStep === 'withdraw-complete'\" class=\"text-center\">\n            <h2 class=\"text-xxl text-grey-3\" translate=\"cw.dashboard.crypto.coinbase.withdraw_complete\"></h2>\n            <div class=\"success-icon\"></div>\n            <p class=\"font-bold text-xl text-grey-1\"><b>{{quote.transfer}}</b></p>\n            <p class=\"text-grey-3 text-m mt10\">\n                <span translate=\"cw.dashboard.crypto.coinbase.transferred\"></span> <br>({{userName}})</p>\n            <a class=\"btn btn-primary btn-medium mt50\" ng-click=\"closeModal()\" translate=\"cw.general.ui.close\"></a>\n        </div>\n        <!--End withdraw complete -->\n    </div>\n</div>";
var path = 'scripts/controllers/modals/coinbase-account/coinbase-account.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "MCvD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

/**
 * License Processor - licenses grouped by userId
 */

// these are the licenses grouped by userId and state
var processedLicenses = [];

var observableProcessedLicenses = new Rx.BehaviorSubject(processedLicenses);
var subjectLicensesRepository = _index.LicensesRepository.getObservable();

/**
 * @ngdoc service
 * @name processors.LicensesProcessor
 *
 * @description
 * This class is used to process licenses.
 */
var LicensesProcessor = {

    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#onNext
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * Processing made when the licenses array from the repository changes.
     *
     * @param {Array} data The modified licenses array
     *
     */
    onNext: function onNext(data) {
        var _this = this;

        processedLicenses = [];
        data.forEach(function (license) {
            return _this.addLicense(license);
        });
        observableProcessedLicenses.onNext(processedLicenses);
    },


    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#addLicense
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * Add license based on its userId
     *
     * @param {Object} license A license object
     *
     */
    addLicense: function addLicense(license) {

        var userId = license.relationships.user.data.id;
        processedLicenses[userId] = processedLicenses[userId] || [];
        processedLicenses[userId].push(license);
    },


    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#getObservable
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * This function can be used to get an observable object for the processed licenses.
     * @returns {Object} an observable object for processed licenses.
     */
    getObservable: function getObservable() {

        return observableProcessedLicenses;
    },


    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#calculateLicensesInfo
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * Calculates custom info for each license.
     *
     * @param {int} userId The user id
     * @param {string} deviceTypeFilter A device filter
     * @param {string} serviceFilter A service filter
     *
     *
     * @returns {Object} Licenses info grouped by each license id.
     */
    calculateLicensesInfo: function calculateLicensesInfo(userId, deviceTypeFilter, serviceFilter) {

        var licensesInfo = {};
        var devActivations = {};
        var userLicenses = processedLicenses[userId];

        if (userLicenses && userLicenses.length > 0) {

            userLicenses.forEach(function (licenseItem) {

                var licenseApp = _index.AppIntegrationsRepository.getById(licenseItem.relationships.app.data.id);
                var expireDate = new Date(licenseItem.attributes.expiration_date);

                if (!angular.isUndefined(licenseApp) && expireDate >= new Date().getTime()) {

                    var skipLicense = licenseItem.attributes.type === 'eval';

                    if (!angular.isUndefined(deviceTypeFilter) && deviceTypeFilter !== null) {

                        deviceTypeFilter = deviceTypeFilter.toLowerCase();

                        if (licenseApp.attributes.custom.manifest.devices && !_.contains(licenseApp.attributes.custom.manifest.devices, deviceTypeFilter)) {

                            skipLicense = true;
                        }
                    }

                    var appIncludes = _index.AppIntegrationsRepository.getIncludes(userId, licenseApp.id);

                    if (!angular.isUndefined(serviceFilter) && serviceFilter !== null) {

                        if (appIncludes.components.length > 1 || appIncludes.components[0] !== serviceFilter) {

                            skipLicense = true;
                        }
                    }

                    if (!skipLicense) {

                        var licId = licenseItem.id;
                        var isActivation = false;
                        var deviceType = null;

                        if (licenseItem.relationships.license) {

                            licId = licenseItem.relationships.license.data.id;
                            isActivation = true;

                            if (licenseItem.relationships.device) {

                                var devActivationsId = devActivations[licenseItem.relationships.device.data.id];

                                if (angular.isUndefined(devActivationsId)) {

                                    devActivations[licenseItem.relationships.device.data.id] = true;
                                } else {

                                    isActivation = false;
                                }
                                var activatedDevice = _index.DevicesRepository.getById(licenseItem.relationships.device.data.id);
                                if (activatedDevice) {

                                    deviceType = activatedDevice.attributes.type.toLowerCase();
                                }
                            }
                        }

                        if (!licensesInfo[licId]) {

                            var maxActivations = licenseItem.attributes.devices_limit;
                            var computerActivation = 0;
                            var mobileActivation = 0;

                            if (isActivation) {

                                maxActivations -= 1;
                                if (deviceType === 'pc' || deviceType === 'laptop') {

                                    computerActivation += 1;
                                } else {

                                    mobileActivation += 1;
                                }
                            }

                            licensesInfo[licId] = {
                                numberOfAvailableActivations: maxActivations,
                                numberOfActivationsByDevice: {
                                    computer: computerActivation,
                                    mobile: mobileActivation
                                },
                                numberOfTotalActivations: licenseItem.attributes.devices_limit,
                                licInfo: {
                                    id: licId,
                                    expirationDate: licenseItem.attributes.expiration_date,
                                    runtime: licenseItem.attributes.runtime,
                                    runtimeUnit: licenseItem.attributes.runtime_unit
                                },
                                appInfo: {
                                    name: licenseApp.attributes.custom.manifest.name,
                                    id: licenseApp.id,
                                    devices: licenseApp.attributes.custom.manifest.devices,
                                    includes: appIncludes
                                }
                            };
                        } else if (isActivation) {

                            licensesInfo[licId].numberOfAvailableActivations -= 1;

                            if (licensesInfo[licId].numberOfAvailableActivations < 0) {

                                licensesInfo[licId].numberOfAvailableActivations = 0;
                            }

                            if (deviceType === 'pc' || deviceType === 'laptop') {

                                licensesInfo[licId].numberOfActivationsByDevice.computer += 1;
                            } else {

                                licensesInfo[licId].numberOfActivationsByDevice.computer += 1;
                            }
                        }
                    }
                }
            });
        }
        return licensesInfo;
    },


    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#calculateAvailableActivations
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * Calculates:
     * * how many available license activations exist for each app and
     * * total available licence activations, for all apps
     *
     * @returns {Object} An object with two keys:
     * * availableActivations - the available license activations for each app
     * * totalAvailableActivations - the total available activations for all apps
     */
    calculateAvailableActivations: function calculateAvailableActivations() {

        var availableActivations = {};
        var totalAvailableActivations = 0;
        var licenses = this.calculateLicensesInfo(_index.MeRepository.getMyId());
        var licenseKeys = Object.keys(licenses);
        licenseKeys.forEach(function (licenseKey) {

            var licItem = licenses[licenseKey];
            var appId = licItem.appInfo.id;
            if (!availableActivations[appId]) {

                availableActivations[appId] = {};
                availableActivations[appId].name = licItem.appInfo.name;
                availableActivations[appId].activations = 0;
            }

            availableActivations[appId].activations += licItem.numberOfAvailableActivations;
            totalAvailableActivations += licItem.numberOfAvailableActivations;
        });

        return {
            availableActivations: availableActivations,
            totalAvailableActivations: totalAvailableActivations
        };
    },


    /**
     * @ngdoc function
     * @name processors.LicensesProcessor#isProUser
     * @methodOf processors.LicensesProcessor
     * @function
     *
     * @description
     * Checks if an user has at least one pro license.
     *
     * @param {int} userId The user id
     *
     * @returns {Boolean} True if the user has at least one pro license, fase otherwise
     */
    isProUser: function isProUser(userId) {

        var isPro = false;
        if (processedLicenses[userId]) {

            processedLicenses[userId].find(function (license) {

                if (license && license.attributes && license.attributes.type === 'paid') {

                    isPro = true;
                    return true;
                }

                return false;
            });
            return isPro;
        }
        return isPro;
    }
};

subjectLicensesRepository.subscribe(function (data) {
    return LicensesProcessor.onNext(data);
}, function () {}, function () {});

exports.default = LicensesProcessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "MDzN":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("v3EM");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "MFCq":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "MS9Y":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("eVeQ"),
    baseIsEqual = __webpack_require__("zzbF");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "MWVi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];

var PasswordStrengthDirective = function PasswordStrengthDirective() {
    _classCallCheck(this, PasswordStrengthDirective);

    this.template = __webpack_require__("73RG");
    this.restrict = 'EA';
    this.replace = true;
    this.scope = { passlength: '=', passpattern: '=', passwordscore: '=' };
};

_directiveDependencies.push(function () {
    return new PasswordStrengthDirective();
});

angular.module('directives').directive('passwordStrength', _directiveDependencies);

/***/ }),

/***/ "Mbmr":
/***/ (function(module, exports) {

module.exports = "<div class=\"report-page\" ng-if=\"hasReport\">\n    <div class=\"text-center\">\n        <div class=\"avira-logo mb30\">\n            <svg id=\"avira-logo\" xmlns=\"http://www.w3.org/2000/svg\" width=\"158.32\" height=\"50\" viewBox=\"0 0 158.32 50\">\n                <g id=\"My_Avira_Account_1_\" transform=\"translate(64.628 9.824)\">\n                    <g id=\"Group_1662\" data-name=\"Group 1662\" transform=\"translate(0 0)\">\n                        <path id=\"Path_1174\" data-name=\"Path 1174\" d=\"M70.882,9.4h3.385L85.838,39.532H81.907l-2.73-7.423H65.423L62.7,39.532H59.2Zm7.2,19.76L74.265,18.788a27.571,27.571,0,0,1-1.092-3.057c-.218-.765-.547-1.528-.765-2.183h0c-.218.765-.547,1.528-.765,2.293l-1.092,2.833L66.623,29.05H78.087Z\" transform=\"translate(-59.2 -8.962)\" fill=\"#31323a\"/>\n                        <path id=\"Path_1175\" data-name=\"Path 1175\" d=\"M85.1,17.2h3.6l6.113,17.358h.117l6.1-17.358h3.385L96.345,38.815H93.288Z\" transform=\"translate(-56.825 -8.247)\" fill=\"#31323a\"/>\n                        <path id=\"Path_1176\" data-name=\"Path 1176\" d=\"M108.9,13.8a2.423,2.423,0,0,1-2.4-2.4h0A2.333,2.333,0,0,1,108.794,9h.108a2.333,2.333,0,0,1,2.4,2.293v.11a2.333,2.333,0,0,1-2.293,2.4Zm-1.638,4.148h3.385V39.569h-3.385Z\" transform=\"translate(-54.862 -8.999)\" fill=\"#31323a\"/>\n                        <path id=\"Path_1177\" data-name=\"Path 1177\" d=\"M117.3,17.243h3.275v3.385a4.847,4.847,0,0,1,.873-1.2,13.083,13.083,0,0,1,1.2-1.31,6.515,6.515,0,0,1,1.638-.983,5.787,5.787,0,0,1,3.6-.218l.765.218-.765,3.167-.655-.218a5.315,5.315,0,0,0-1.31-.11,4.97,4.97,0,0,0-2.183.547,6.647,6.647,0,0,0-1.638,1.31,7.4,7.4,0,0,0-1.528,2.512V38.968H117.3Z\" transform=\"translate(-53.872 -8.291)\" fill=\"#31323a\"/>\n                        <path id=\"Path_1178\" data-name=\"Path 1178\" d=\"M136.221,39.526a6.167,6.167,0,0,1-4.477-1.638A5.24,5.24,0,0,1,130,33.631a6.093,6.093,0,0,1,1.092-3.6,7.872,7.872,0,0,1,2.73-2.293,15.82,15.82,0,0,1,3.822-1.31,23.866,23.866,0,0,1,3.93-.333h.983V24.133a4.812,4.812,0,0,0-.983-3.6,4.948,4.948,0,0,0-3.275-1.092,8.2,8.2,0,0,0-2.833.547,9.813,9.813,0,0,0-2.833,1.857l-1.747-2.293a11,11,0,0,1,7.642-2.948,8.188,8.188,0,0,1,5.458,1.747,7.068,7.068,0,0,1,1.965,5.458V33.958a24.694,24.694,0,0,0,.11,2.948l.333,1.965h-3.275a8.066,8.066,0,0,0-.218-1.31,6.262,6.262,0,0,1-.11-1.31,8.237,8.237,0,0,1-2.833,2.293A7.26,7.26,0,0,1,136.221,39.526Zm.547-2.948a6.667,6.667,0,0,0,3.275-.873,7.193,7.193,0,0,0,2.512-2.293V28.5h-.983c-1.092,0-2.183.11-3.275.218a6.89,6.89,0,0,0-2.512.873,4.377,4.377,0,0,0-1.638,1.528,4.3,4.3,0,0,0-.655,2.293,3.021,3.021,0,0,0,.333,1.42,6,6,0,0,0,.765.983,3.415,3.415,0,0,0,1.092.547,1.968,1.968,0,0,0,1.092.218Z\" transform=\"translate(-52.706 -8.302)\" fill=\"#31323a\"/>\n                    </g>\n                </g>\n                <path id=\"Path_1179\" data-name=\"Path 1179\" d=\"M28.737,15.629C18.8,9.952,7.667,21.2,13.017,30.586Z\" transform=\"translate(1.067 1.293)\" fill=\"#da1213\"/>\n                <path id=\"Path_1180\" data-name=\"Path 1180\" d=\"M46.288,0H3.712A3.775,3.775,0,0,0,0,3.822V46.288A3.682,3.682,0,0,0,3.712,50H46.178a3.682,3.682,0,0,0,3.712-3.712h0V3.822A3.617,3.617,0,0,0,46.288,0ZM38.865,36.245a5.137,5.137,0,0,1-3.6,1.528,5.485,5.485,0,0,1-4.148-1.528l-7.752-8.188-10.48,9.935A16.113,16.113,0,0,1,36.245,15.833L26.2,25.333l7.315,7.752c.11.11.11.218.218.218a2.02,2.02,0,0,0,2.73.11h0a2.02,2.02,0,0,0,.11-2.73l2.73-2.62V28.4h0a5.818,5.818,0,0,1,1.42,3.712,6.6,6.6,0,0,1-1.857,4.148Z\" transform=\"translate(0)\" fill=\"#da1213\"/>\n            </svg>\n        </div>\n    </div>\n    <h1 class=\"text-xxl mt0 text-center mb10\" translate=\"cw.my_account.data_settings.gdpr_modal.title_2\" translate-values=\"{brandname : brandName}\"></h1>\n    <p class=\"text-m text-center mb50\"\n        ng-if=\"gdprReportTimestamp\"\n        translate=\"cw.my_account.data_settings.gdpr_modal.user_report_date\"\n        translate-values=\"{ date: gdprReportTimestamp }\"></p>\n\n        <div ng-repeat=\"report in finalReport\" class=\"report-wrapper\">\n            <div ng-repeat=\"singleReport in report\">\n                <div class=\"text-left report-category\">\n                    <div class=\"spacer\"></div>\n                    <h3 class=\"text-m mt0\">\n                        {{singleReport.key}}\n                    </h3>\n                    <div ng-repeat=\"value in singleReport.value\"\n                        class=\"mt0 inline-block v-top data-column\"\n                        ng-class=\"{'w50': singleReport.value.length > 1, 'w100': singleReport.value.length === 1}\">\n                        <div class=\"spacer\"></div>\n                        <p ng-repeat=\"(key, value) in value\" class=\"text-m\">\n                            <span class='font-bold inline-block v-middle'>{{key}}</span> : <span class='v-middle inline-block'>{{value}}</span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-repeat=\"report in finalReport\" class=\"report-wrapper-print\">\n            <div ng-repeat=\"singleReport in report\">\n                <div class=\"text-left\">\n                    <hr />\n                    <span class=\"print-title-gdpr\">\n                        {{singleReport.key}}\n                    </span>\n                    <hr />\n                    <span ng-repeat=\"value in singleReport.value\" class=\"w100\">\n                        <p ng-repeat=\"(key, value) in value\">\n                            <span class='font-bold inline-block v-middle'>{{key}}</span> : <span class='v-middle inline-block'>{{value}}</span>\n                        </p>\n                    </span>\n                </div>\n            </div>\n        </div>\n        <div class=\"print-fixed-button\" ng-click=\"print()\">\n            <i class=\"icon icon-printer\"></i>\n        </div>\n</div>"

/***/ }),

/***/ "Mh/1":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.logdown=e():t.logdown=e()}(window,function(){return function(r){var n={};function o(t){if(n[t])return n[t].exports;var e=n[t]={i:t,l:!1,exports:{}};return r[t].call(e.exports,e,e.exports,o),e.l=!0,e.exports}return o.m=r,o.c=n,o.d=function(t,e,r){o.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},o.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(o.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)o.d(r,n,function(t){return e[t]}.bind(null,n));return r},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,"a",e),e},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o.p="",o(o.s=0)}([function(t,e,r){var n,o=r(1)(),i=r(3),s=r(5),f=r(8)();o.prefixColors=["#F2777A","#F99157","#FFCC66","#99CC99","#66CCCC","#6699CC","#CC99CC"],o._setPrefixRegExps=function(){try{f.localStorage&&"string"==typeof f.localStorage.getItem("debug")&&(o._prefixRegExps=[],f.localStorage.getItem("debug").split(",").forEach(function(t){var e="enable";"-"===(t=t.trim())[0]&&(t=t.substr(1),e="disable");var r=o._prepareRegExpForPrefixSearch(t);o._prefixRegExps.push({type:e,regExp:r})}))}catch(t){}},o._getNextPrefixColor=(n=0,function(){return n+=1,o.prefixColors[n%o.prefixColors.length]}),o.prototype._getDecoratedPrefix=function(){var t=[];return s()?(t.push("%c"+this.opts.prefix+"%c "),t.push("color:"+this.opts.prefixColor+"; font-weight:bold;","")):t.push("["+this.opts.prefix+"] "),t},o.prototype._prepareOutput=function(t){var e,r=this._getDecoratedPrefix();return"string"==typeof t[0]?this.opts.markdown&&s()?(e=i.parse(t[0]),r[0]=r[0]+e.text,r=r.concat(e.styles)):r[0]=r[0]+t[0]:r.push(t[0]),1<t.length&&(r=r.concat(t.slice(1))),r},o._setPrefixRegExps(),t.exports=o},function(t,e,r){var f=r(2);t.exports=function(){function s(t,e){return this instanceof s?s._isPrefixAlreadyInUse(t)?s._getInstanceByPrefix(t):(this.opts=s._normalizeOpts(t,e),this.state=s._getInitialState(this.opts),s._decorateLoggerMethods(this),s._instances.push(this),this):new s(t,e)}return s.transports=[],s._instances=[],s._prefixRegExps=[],s._prepareRegExpForPrefixSearch=function(t){return new RegExp("^"+t.replace(/\*/g,".*?")+"$")},s._isPrefixAlreadyInUse=function(e){return s._instances.some(function(t){return t.opts.prefix===e})},s._getInstanceByPrefix=function(e){return s._instances.filter(function(t){return t.opts.prefix===e})[0]},s._normalizeOpts=function(t,e){if("string"!=typeof t)throw new TypeError("prefix must be a string");var r=void 0===(e=e||{}).markdown||Boolean(e.markdown),n=e.prefixColor||s._getNextPrefixColor();return{logger:e.logger||console,markdown:r,plaintext:Boolean(e.plaintext),prefix:t,prefixColor:n}},s._getInitialState=function(t){return{isEnabled:s._getEnableState(t)}},s._getEnableState=function(e){var r=!1;return s._prefixRegExps.forEach(function(t){"enable"===t.type&&t.regExp.test(e.prefix)?r=!0:"disable"===t.type&&t.regExp.test(e.prefix)&&(r=!1)}),r},s._decorateLoggerMethods=function(t){var i=t.opts.logger,e=Object.keys(i).filter(function(t){return"function"==typeof i[t]});0===e.length&&(e=["debug","log","warn","error","info"]),e.forEach(function(o){t[o]=function(){var e=f(arguments),r=this.opts.prefix;if(s.transports.length){var n="["+r+"] "+e.filter(function(t){return"object"!=typeof t}).join(" ");s.transports.forEach(function(t){t({state:this.state,instance:r,level:o,args:e,msg:n})}.bind(this))}if(this.state.isEnabled){var t=this._prepareOutput(e,o);i[o].apply(i,t)}}})},s}},function(t,e){t.exports=function(t){return Array.prototype.slice.call(t,0)}},function(t,e,r){var n=[];function o(e){return function(t){return n.push(e),n.push(""),"%c"+t+"%c"}}var i=new(r(4))({renderer:{"*":o("font-weight:bold;"),_:o("font-style:italic;"),"`":o("background-color:rgba(255,204,102, 0.1);color:#FFCC66;padding:2px 5px;border-radius:2px;")}});t.exports={parse:function(t){var e={text:i.parse(t),styles:[].concat(n)};return n.length=0,e}}},function(t,e){var x=/([_*`\\]|[^_*`\\]+)/g,r=/[_*`]/;function n(t){this.renderer=t.renderer}function d(t){return r.test(t)}n.prototype.parse=function(t){if(""===t)return"";var r,e,n,o=t.match(x),i=this.renderer,s="",f=[],u={},a=0;function p(t){for(var e="";r&&r.tag!==t;)e=r.tag+r.text+e,u[r.tag]=!1,r=f.pop();return e}for(;n=o[a];){if(e="",a++,d(n))if(u[n])e=p(n),e=i[r.tag](r.text+e),u[n]=!1,r=f.pop();else{var c="";if("`"===n){var l=o.indexOf(n,a);-1!==l&&(s+=p(),c=o.slice(a,l).join(""),a=l)}r&&f.push(r),u[n]=!0,r={tag:n,text:c}}else if("\\"===(e=n)){var g=o[a];(d(g)||"\\"===g)&&(e=g,a++)}e&&(r?r.text+=e:s+=e,e="")}return s+p()},t.exports=n},function(t,e,r){var n=r(6),o=r(7);t.exports=function(){return n()||o()}},function(t,e){t.exports=function(){try{return"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent)}catch(t){return!1}}},function(t,e){t.exports=function(){try{return/firefox\/(\d+)/i.test(navigator.userAgent)}catch(t){return!1}}},function(r,t,e){(function(t){function e(t,e){return"object"==typeof t&&t.self===t&&t||"object"==typeof e&&e.global===e&&e||this}r.exports=e.bind(this,self,t),r.exports.getGlobal=e}).call(this,e(9))},function(ob,pb){var qb;qb=function(){return this}();try{qb=qb||Function("return this")()||eval("this")}catch(ob){"object"==typeof window&&(qb=window)}ob.exports=qb}])});


/***/ }),

/***/ "MwII":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _logdown = __webpack_require__("Mh/1");

var _logdown2 = _interopRequireDefault(_logdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var noop = function noop() {};

var customize = function customize(logdownInstance) {

    var isObject = function isObject(variable) {
        return variable !== null && variable instanceof Array === false && (typeof variable === 'undefined' ? 'undefined' : _typeof(variable)) === 'object';
    };

    var loggerMethodKeys = Object.keys(logdownInstance).filter(function (method) {
        return typeof logdownInstance[method] === 'function';
    });

    var pristineLoggerMethods = loggerMethodKeys.reduce(function (acc, methodKey) {

        acc[methodKey] = logdownInstance[methodKey];
        return acc;
    }, {});

    var formatText = function formatText(stringArray) {

        var response = [];

        var textStyling = ['font-weight: 100'].join(';');

        var successColors = ['color: #0e3e14', 'background: #2ECC40', 'font-size: 12px', 'padding: 2px 4px', 'font-weight: 200'].join(';');

        var errorColors = ['color: #FFFFFF', 'background: #E7040F', 'font-size: 12px', 'padding: 2px 4px', 'font-weight: 200'].join(';');

        var _stringArray = _toArray(stringArray),
            type = _stringArray[0],
            _stringArray$ = _stringArray[1],
            cmd = _stringArray$ === undefined ? '' : _stringArray$,
            rest = _stringArray.slice(2);

        if (cmd !== '') {

            var isError = cmd.indexOf('ERROR') > -1;
            var colors = isError ? errorColors : successColors;

            response.push.apply(response, ['%c ' + type + ' %c ' + cmd, textStyling, colors].concat(_toConsumableArray(rest)));
        } else {

            response.push.apply(response, ['%c ' + type, textStyling].concat(_toConsumableArray(rest)));
        }

        return response;
    };

    loggerMethodKeys.forEach(function (key) {

        var debuggingIsDisabled = !CWCONFIG.features.debug;
        if (debuggingIsDisabled) {

            logdownInstance[key] = noop;
        } else {

            logdownInstance[key] = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (isObject(args[0])) {
                    var _args$ = args[0],
                        _args$$type = _args$.type,
                        type = _args$$type === undefined ? '' : _args$$type,
                        _args$$cmd = _args$.cmd,
                        cmd = _args$$cmd === undefined ? '' : _args$$cmd,
                        _args$$data = _args$.data,
                        data = _args$$data === undefined ? null : _args$$data,
                        rest = _objectWithoutProperties(_args$, ['type', 'cmd', 'data']);

                    if (data !== null && pristineLoggerMethods.groupCollapsed && pristineLoggerMethods.groupEnd) {

                        // Function.prototype.apply.call(logFn, console, args);
                        pristineLoggerMethods.groupCollapsed.apply(logdownInstance, formatText([type, cmd]));
                        pristineLoggerMethods[key].apply(logdownInstance, [Object.assign({}, data, { rest: rest })]);
                        pristineLoggerMethods.groupEnd.apply(logdownInstance);
                    } else {

                        pristineLoggerMethods[key].apply(logdownInstance, formatText([type, cmd].concat(_toConsumableArray(rest))));
                    }
                    return false;
                }

                return pristineLoggerMethods[key].apply(logdownInstance, [].concat(args));
            };
        }
    });

    return logdownInstance;
};

var createLogger = function createLogger(opts) {

    var APP_PREFIX = 'CW-';

    var _opts$prefix = opts.prefix,
        prefix = _opts$prefix === undefined ? 'App' : _opts$prefix,
        _opts$prefixColor = opts.prefixColor,
        prefixColor = _opts$prefixColor === undefined ? '#AAA' : _opts$prefixColor;


    var finalPrefix = APP_PREFIX.concat(prefix);

    var log = customize(new _logdown2.default(finalPrefix, {
        prefixColor: prefixColor
    }));

    alignPrefixes();

    return log;
};

function alignPrefixes() {

    var longest = _logdown2.default._instances.sort(function (a, b) {
        return b.opts.prefix.length - a.opts.prefix.length;
    })[0];

    _logdown2.default._instances.forEach(function (instance) {

        var padding = new Array(Math.max(longest.opts.prefix.length - instance.opts.prefix.length + 1, 0)).join(' ');
        instance.opts.prefix += padding;
    });
}

exports.default = createLogger;

/***/ }),

/***/ "NH+E":
/***/ (function(module, exports) {

module.exports = "<div class=\"bottom-page-notification\"\n     ng-show=\"cookiePolicyCtrl.isNotificationVisible\">\n\n    <div class=\"text-m text-grey-3 child-link\" id=\"policyUrl\" translate=\"cw.cookie_policy\" translate-values=\"{website: webSite, brandname: brandName}\"></div>\n    <a class=\"icon icon-close icon-xxxs icon-grey-4 crs-pointer\" ng-click=\"cookiePolicyCtrl.closeNotification()\"\n        connectqa-cookie=\"close-cookie-notification\"></a>\n\n</div>"

/***/ }),

/***/ "NLSq":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm dwm-lightbox-gamer-tags\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon dwm-icon-gamerTags\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb5\" translate=\"cw.dwm.entity.gamer_tags.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"tag in gamerTags.entries\">\n                            <div class=\"col-2 col-text text-left\">\n                                <p class=\"text-grey-1 text-l\" ng-if=\"!tag.showUpdateInput\">{{tag.tag}}</p>\n                                <div ng-if=\"tag.showUpdateInput\">\n                                    <input type=\"text\" ng-class=\"{'error': !tagIsValid}\" name=\"tag\" maxlength=\"100\"\n                                        autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.gamer_tags.placeholder' | translate }}\" class=\"update-tag\"\n                                        ng-keyup=\"entryUpdateValue($event);\" value=\"{{tag.tag}}\">\n                                    <p class=\"error-message\" ng-show=\"!tagIsValid\" translate=\"cw.validator.messages.valid_entry\"></p>\n                                </div>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!tag.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-2 col-text text-left\">\n                                <input type=\"text\" ng-class=\"{'error': !tagIsValid}\" name=\"tag\" ng-model=\"newGamerTag\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.gamer_tags.placeholder' | translate }}\" id=\"tag\"\n                                    ng-keyup=\"validateTag($event)\">\n                                <p class=\"error-message\" ng-show=\"!tagIsValid\" translate=\"cw.validator.messages.valid_entry\"></p>\n                            </div>\n                            <div class=\"col-3 text-right\">\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.gamer_tags.remove_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.gamer_tags.remove_desc_1\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.gamer_tags.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.gamer_tags.entity_details.desc_1\"></p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.gamer_tags.entity_details.desc_2\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\"\n                ng-if=\"showAddNewButton && (gamerTags.maxCount > gamerTags.entries.length)\" ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': savenewGamerTagIsLoading}\"\n                    ng-disabled=\"savenewGamerTagIsLoading || !tagIsValid\" ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !tagIsValid\" ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/gamer-tags/gamer-tags.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "NQhb":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
var adjacency_graphs;

adjacency_graphs = {
  qwerty: {
    "!": ["`~", null, null, "2@", "qQ", null],
    "\"": [";:", "[{", "]}", null, null, "/?"],
    "#": ["2@", null, null, "4$", "eE", "wW"],
    "$": ["3#", null, null, "5%", "rR", "eE"],
    "%": ["4$", null, null, "6^", "tT", "rR"],
    "&": ["6^", null, null, "8*", "uU", "yY"],
    "'": [";:", "[{", "]}", null, null, "/?"],
    "(": ["8*", null, null, "0)", "oO", "iI"],
    ")": ["9(", null, null, "-_", "pP", "oO"],
    "*": ["7&", null, null, "9(", "iI", "uU"],
    "+": ["-_", null, null, null, "]}", "[{"],
    ",": ["mM", "kK", "lL", ".>", null, null],
    "-": ["0)", null, null, "=+", "[{", "pP"],
    ".": [",<", "lL", ";:", "/?", null, null],
    "/": [".>", ";:", "'\"", null, null, null],
    "0": ["9(", null, null, "-_", "pP", "oO"],
    "1": ["`~", null, null, "2@", "qQ", null],
    "2": ["1!", null, null, "3#", "wW", "qQ"],
    "3": ["2@", null, null, "4$", "eE", "wW"],
    "4": ["3#", null, null, "5%", "rR", "eE"],
    "5": ["4$", null, null, "6^", "tT", "rR"],
    "6": ["5%", null, null, "7&", "yY", "tT"],
    "7": ["6^", null, null, "8*", "uU", "yY"],
    "8": ["7&", null, null, "9(", "iI", "uU"],
    "9": ["8*", null, null, "0)", "oO", "iI"],
    ":": ["lL", "pP", "[{", "'\"", "/?", ".>"],
    ";": ["lL", "pP", "[{", "'\"", "/?", ".>"],
    "<": ["mM", "kK", "lL", ".>", null, null],
    "=": ["-_", null, null, null, "]}", "[{"],
    ">": [",<", "lL", ";:", "/?", null, null],
    "?": [".>", ";:", "'\"", null, null, null],
    "@": ["1!", null, null, "3#", "wW", "qQ"],
    "A": [null, "qQ", "wW", "sS", "zZ", null],
    "B": ["vV", "gG", "hH", "nN", null, null],
    "C": ["xX", "dD", "fF", "vV", null, null],
    "D": ["sS", "eE", "rR", "fF", "cC", "xX"],
    "E": ["wW", "3#", "4$", "rR", "dD", "sS"],
    "F": ["dD", "rR", "tT", "gG", "vV", "cC"],
    "G": ["fF", "tT", "yY", "hH", "bB", "vV"],
    "H": ["gG", "yY", "uU", "jJ", "nN", "bB"],
    "I": ["uU", "8*", "9(", "oO", "kK", "jJ"],
    "J": ["hH", "uU", "iI", "kK", "mM", "nN"],
    "K": ["jJ", "iI", "oO", "lL", ",<", "mM"],
    "L": ["kK", "oO", "pP", ";:", ".>", ",<"],
    "M": ["nN", "jJ", "kK", ",<", null, null],
    "N": ["bB", "hH", "jJ", "mM", null, null],
    "O": ["iI", "9(", "0)", "pP", "lL", "kK"],
    "P": ["oO", "0)", "-_", "[{", ";:", "lL"],
    "Q": [null, "1!", "2@", "wW", "aA", null],
    "R": ["eE", "4$", "5%", "tT", "fF", "dD"],
    "S": ["aA", "wW", "eE", "dD", "xX", "zZ"],
    "T": ["rR", "5%", "6^", "yY", "gG", "fF"],
    "U": ["yY", "7&", "8*", "iI", "jJ", "hH"],
    "V": ["cC", "fF", "gG", "bB", null, null],
    "W": ["qQ", "2@", "3#", "eE", "sS", "aA"],
    "X": ["zZ", "sS", "dD", "cC", null, null],
    "Y": ["tT", "6^", "7&", "uU", "hH", "gG"],
    "Z": [null, "aA", "sS", "xX", null, null],
    "[": ["pP", "-_", "=+", "]}", "'\"", ";:"],
    "\\": ["]}", null, null, null, null, null],
    "]": ["[{", "=+", null, "\\|", null, "'\""],
    "^": ["5%", null, null, "7&", "yY", "tT"],
    "_": ["0)", null, null, "=+", "[{", "pP"],
    "`": [null, null, null, "1!", null, null],
    "a": [null, "qQ", "wW", "sS", "zZ", null],
    "b": ["vV", "gG", "hH", "nN", null, null],
    "c": ["xX", "dD", "fF", "vV", null, null],
    "d": ["sS", "eE", "rR", "fF", "cC", "xX"],
    "e": ["wW", "3#", "4$", "rR", "dD", "sS"],
    "f": ["dD", "rR", "tT", "gG", "vV", "cC"],
    "g": ["fF", "tT", "yY", "hH", "bB", "vV"],
    "h": ["gG", "yY", "uU", "jJ", "nN", "bB"],
    "i": ["uU", "8*", "9(", "oO", "kK", "jJ"],
    "j": ["hH", "uU", "iI", "kK", "mM", "nN"],
    "k": ["jJ", "iI", "oO", "lL", ",<", "mM"],
    "l": ["kK", "oO", "pP", ";:", ".>", ",<"],
    "m": ["nN", "jJ", "kK", ",<", null, null],
    "n": ["bB", "hH", "jJ", "mM", null, null],
    "o": ["iI", "9(", "0)", "pP", "lL", "kK"],
    "p": ["oO", "0)", "-_", "[{", ";:", "lL"],
    "q": [null, "1!", "2@", "wW", "aA", null],
    "r": ["eE", "4$", "5%", "tT", "fF", "dD"],
    "s": ["aA", "wW", "eE", "dD", "xX", "zZ"],
    "t": ["rR", "5%", "6^", "yY", "gG", "fF"],
    "u": ["yY", "7&", "8*", "iI", "jJ", "hH"],
    "v": ["cC", "fF", "gG", "bB", null, null],
    "w": ["qQ", "2@", "3#", "eE", "sS", "aA"],
    "x": ["zZ", "sS", "dD", "cC", null, null],
    "y": ["tT", "6^", "7&", "uU", "hH", "gG"],
    "z": [null, "aA", "sS", "xX", null, null],
    "{": ["pP", "-_", "=+", "]}", "'\"", ";:"],
    "|": ["]}", null, null, null, null, null],
    "}": ["[{", "=+", null, "\\|", null, "'\""],
    "~": [null, null, null, "1!", null, null]
  },
  dvorak: {
    "!": ["`~", null, null, "2@", "'\"", null],
    "\"": [null, "1!", "2@", ",<", "aA", null],
    "#": ["2@", null, null, "4$", ".>", ",<"],
    "$": ["3#", null, null, "5%", "pP", ".>"],
    "%": ["4$", null, null, "6^", "yY", "pP"],
    "&": ["6^", null, null, "8*", "gG", "fF"],
    "'": [null, "1!", "2@", ",<", "aA", null],
    "(": ["8*", null, null, "0)", "rR", "cC"],
    ")": ["9(", null, null, "[{", "lL", "rR"],
    "*": ["7&", null, null, "9(", "cC", "gG"],
    "+": ["/?", "]}", null, "\\|", null, "-_"],
    ",": ["'\"", "2@", "3#", ".>", "oO", "aA"],
    "-": ["sS", "/?", "=+", null, null, "zZ"],
    ".": [",<", "3#", "4$", "pP", "eE", "oO"],
    "/": ["lL", "[{", "]}", "=+", "-_", "sS"],
    "0": ["9(", null, null, "[{", "lL", "rR"],
    "1": ["`~", null, null, "2@", "'\"", null],
    "2": ["1!", null, null, "3#", ",<", "'\""],
    "3": ["2@", null, null, "4$", ".>", ",<"],
    "4": ["3#", null, null, "5%", "pP", ".>"],
    "5": ["4$", null, null, "6^", "yY", "pP"],
    "6": ["5%", null, null, "7&", "fF", "yY"],
    "7": ["6^", null, null, "8*", "gG", "fF"],
    "8": ["7&", null, null, "9(", "cC", "gG"],
    "9": ["8*", null, null, "0)", "rR", "cC"],
    ":": [null, "aA", "oO", "qQ", null, null],
    ";": [null, "aA", "oO", "qQ", null, null],
    "<": ["'\"", "2@", "3#", ".>", "oO", "aA"],
    "=": ["/?", "]}", null, "\\|", null, "-_"],
    ">": [",<", "3#", "4$", "pP", "eE", "oO"],
    "?": ["lL", "[{", "]}", "=+", "-_", "sS"],
    "@": ["1!", null, null, "3#", ",<", "'\""],
    "A": [null, "'\"", ",<", "oO", ";:", null],
    "B": ["xX", "dD", "hH", "mM", null, null],
    "C": ["gG", "8*", "9(", "rR", "tT", "hH"],
    "D": ["iI", "fF", "gG", "hH", "bB", "xX"],
    "E": ["oO", ".>", "pP", "uU", "jJ", "qQ"],
    "F": ["yY", "6^", "7&", "gG", "dD", "iI"],
    "G": ["fF", "7&", "8*", "cC", "hH", "dD"],
    "H": ["dD", "gG", "cC", "tT", "mM", "bB"],
    "I": ["uU", "yY", "fF", "dD", "xX", "kK"],
    "J": ["qQ", "eE", "uU", "kK", null, null],
    "K": ["jJ", "uU", "iI", "xX", null, null],
    "L": ["rR", "0)", "[{", "/?", "sS", "nN"],
    "M": ["bB", "hH", "tT", "wW", null, null],
    "N": ["tT", "rR", "lL", "sS", "vV", "wW"],
    "O": ["aA", ",<", ".>", "eE", "qQ", ";:"],
    "P": [".>", "4$", "5%", "yY", "uU", "eE"],
    "Q": [";:", "oO", "eE", "jJ", null, null],
    "R": ["cC", "9(", "0)", "lL", "nN", "tT"],
    "S": ["nN", "lL", "/?", "-_", "zZ", "vV"],
    "T": ["hH", "cC", "rR", "nN", "wW", "mM"],
    "U": ["eE", "pP", "yY", "iI", "kK", "jJ"],
    "V": ["wW", "nN", "sS", "zZ", null, null],
    "W": ["mM", "tT", "nN", "vV", null, null],
    "X": ["kK", "iI", "dD", "bB", null, null],
    "Y": ["pP", "5%", "6^", "fF", "iI", "uU"],
    "Z": ["vV", "sS", "-_", null, null, null],
    "[": ["0)", null, null, "]}", "/?", "lL"],
    "\\": ["=+", null, null, null, null, null],
    "]": ["[{", null, null, null, "=+", "/?"],
    "^": ["5%", null, null, "7&", "fF", "yY"],
    "_": ["sS", "/?", "=+", null, null, "zZ"],
    "`": [null, null, null, "1!", null, null],
    "a": [null, "'\"", ",<", "oO", ";:", null],
    "b": ["xX", "dD", "hH", "mM", null, null],
    "c": ["gG", "8*", "9(", "rR", "tT", "hH"],
    "d": ["iI", "fF", "gG", "hH", "bB", "xX"],
    "e": ["oO", ".>", "pP", "uU", "jJ", "qQ"],
    "f": ["yY", "6^", "7&", "gG", "dD", "iI"],
    "g": ["fF", "7&", "8*", "cC", "hH", "dD"],
    "h": ["dD", "gG", "cC", "tT", "mM", "bB"],
    "i": ["uU", "yY", "fF", "dD", "xX", "kK"],
    "j": ["qQ", "eE", "uU", "kK", null, null],
    "k": ["jJ", "uU", "iI", "xX", null, null],
    "l": ["rR", "0)", "[{", "/?", "sS", "nN"],
    "m": ["bB", "hH", "tT", "wW", null, null],
    "n": ["tT", "rR", "lL", "sS", "vV", "wW"],
    "o": ["aA", ",<", ".>", "eE", "qQ", ";:"],
    "p": [".>", "4$", "5%", "yY", "uU", "eE"],
    "q": [";:", "oO", "eE", "jJ", null, null],
    "r": ["cC", "9(", "0)", "lL", "nN", "tT"],
    "s": ["nN", "lL", "/?", "-_", "zZ", "vV"],
    "t": ["hH", "cC", "rR", "nN", "wW", "mM"],
    "u": ["eE", "pP", "yY", "iI", "kK", "jJ"],
    "v": ["wW", "nN", "sS", "zZ", null, null],
    "w": ["mM", "tT", "nN", "vV", null, null],
    "x": ["kK", "iI", "dD", "bB", null, null],
    "y": ["pP", "5%", "6^", "fF", "iI", "uU"],
    "z": ["vV", "sS", "-_", null, null, null],
    "{": ["0)", null, null, "]}", "/?", "lL"],
    "|": ["=+", null, null, null, null, null],
    "}": ["[{", null, null, null, "=+", "/?"],
    "~": [null, null, null, "1!", null, null]
  },
  keypad: {
    "*": ["/", null, null, null, "-", "+", "9", "8"],
    "+": ["9", "*", "-", null, null, null, null, "6"],
    "-": ["*", null, null, null, null, null, "+", "9"],
    ".": ["0", "2", "3", null, null, null, null, null],
    "/": [null, null, null, null, "*", "9", "8", "7"],
    "0": [null, "1", "2", "3", ".", null, null, null],
    "1": [null, null, "4", "5", "2", "0", null, null],
    "2": ["1", "4", "5", "6", "3", ".", "0", null],
    "3": ["2", "5", "6", null, null, null, ".", "0"],
    "4": [null, null, "7", "8", "5", "2", "1", null],
    "5": ["4", "7", "8", "9", "6", "3", "2", "1"],
    "6": ["5", "8", "9", "+", null, null, "3", "2"],
    "7": [null, null, null, "/", "8", "5", "4", null],
    "8": ["7", null, "/", "*", "9", "6", "5", "4"],
    "9": ["8", "/", "*", "-", "+", null, "6", "5"]
  },
  mac_keypad: {
    "*": ["/", null, null, null, null, null, "-", "9"],
    "+": ["6", "9", "-", null, null, null, null, "3"],
    "-": ["9", "/", "*", null, null, null, "+", "6"],
    ".": ["0", "2", "3", null, null, null, null, null],
    "/": ["=", null, null, null, "*", "-", "9", "8"],
    "0": [null, "1", "2", "3", ".", null, null, null],
    "1": [null, null, "4", "5", "2", "0", null, null],
    "2": ["1", "4", "5", "6", "3", ".", "0", null],
    "3": ["2", "5", "6", "+", null, null, ".", "0"],
    "4": [null, null, "7", "8", "5", "2", "1", null],
    "5": ["4", "7", "8", "9", "6", "3", "2", "1"],
    "6": ["5", "8", "9", "-", "+", null, "3", "2"],
    "7": [null, null, null, "=", "8", "5", "4", null],
    "8": ["7", null, "=", "/", "9", "6", "5", "4"],
    "9": ["8", "=", "/", "*", "-", "+", "6", "5"],
    "=": [null, null, null, null, "/", "9", "8", "7"]
  }
};

module.exports = adjacency_graphs;

//# sourceMappingURL=adjacency_graphs.js.map


/***/ }),

/***/ "NRXx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

var CryptoFaqController = function CryptoFaqController($scope) {
    _classCallCheck(this, CryptoFaqController);

    $scope.activeQuestion = 'q1';

    $scope.changeQuestion = function (question) {

        $scope.activeQuestion = question;
    };
};

var CryptoFaqDirective = function CryptoFaqDirective() {
    _classCallCheck(this, CryptoFaqDirective);

    this.template = __webpack_require__("eMXG");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope) {
        return new CryptoFaqController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'CryptoFaqCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoFaqDirective();
});

angular.module('directives').directive('cryptoFaq', _directiveDependencies);

/***/ }),

/***/ "NXX9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.EventRestService
 *
 * @description
 * This class contains methods used to retrieve/add information about events
 * using http requests.
*/

var EventRestService = function (_BaseRestService) {
    _inherits(EventRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function EventRestService($http, $q, Util) {
        _classCallCheck(this, EventRestService);

        return _possibleConstructorReturn(this, (EventRestService.__proto__ || Object.getPrototypeOf(EventRestService)).call(this, $http, $q, Util));
    }

    _createClass(EventRestService, [{
        key: 'getByDevice',
        value: function getByDevice(deviceId) {

            return _get(EventRestService.prototype.__proto__ || Object.getPrototypeOf(EventRestService.prototype), 'getAllAsync', this).call(this, 'events/?filter[device]=' + deviceId);
        }

        /**
         * @ngdoc function
         * @name rest.services.EventRestService#getAllAsync
         * @methodOf rest.services.EventRestService
         * @function
         *
         * @description
         * Retrieves all events.
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(EventRestService.prototype.__proto__ || Object.getPrototypeOf(EventRestService.prototype), 'getAllAsync', this).call(this, 'events/');
        }
    }]);

    return EventRestService;
}(_baseRestService2.default);

exports.default = EventRestService;


_serviceDependencies.push(EventRestService);

angular.module('rest.services').service('EventRestService', _serviceDependencies);

/***/ }),

/***/ "NYtY":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("r1rA"),
    isLength = __webpack_require__("mL1V"),
    isObjectLike = __webpack_require__("7Zib");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "Nmx8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("LBU6");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$state', '$rootScope', '$scope', '$window', 'Auth', 'Util'];

/**
 * @ngdoc service
 * @name controllers.Forgot
 *
 * @description
 * Forgot password controller
 */

var Tfa = function () {

    /**
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     */
    function Tfa($state, $rootScope, $scope, $window, Auth, Util) {
        _classCallCheck(this, Tfa);

        this.Auth = Auth;
        this.Util = Util;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$window = $window;
        this.$scope.submitted = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.tfaSetCookie = true;
        this.$scope.phone = '316';
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        /**
         * Redirects to login if email & password are undefined
         */
        if (typeof this.$rootScope.userCredentials === 'undefined') {

            this.$state.go('root.auth.login');
            return;
        }

        _RFC2.default.send('ConnectWeb Auth Tfa Open', {
            Source: 'Direct'
        });
    }

    /**
     * @ngdoc controllers
     * @name controllers.Tfa#getTfaPayload
     * @methodOf controllers.Tfa
     *
     * @description
     * This method sets and returns TFA payload
     */


    _createClass(Tfa, [{
        key: 'getTfaPayload',
        value: function getTfaPayload() {

            var username = this.$rootScope.userCredentials.email;
            var password = this.$rootScope.userCredentials.password;

            var grantType = this.$rootScope.userCredentials.grant_type || 'password';
            var partner = this.$rootScope.userCredentials.partner;
            var token = this.$rootScope.userCredentials.token;

            // payload for normal login (username, password, grant_type)

            var tfaPayload = {
                grant_type: grantType,
                username: username,
                password: password
            };

            // payload for Google, Facebook login or Apple (token, partner, grant_type)
            if (grantType === 'gg_auth' || grantType === 'fb_auth' || grantType === 'apl_auth') {

                tfaPayload = {
                    grant_type: grantType,
                    partner: partner,
                    token: token
                };
            }

            return tfaPayload;
        }

        /**
         * @ngdoc controllers
         * @name controllers.Tfa#tfaAuth
         * @methodOf controllers.Tfa
         *
         * @description
         * sends 2FA authentication code to server and logins(if successful)
         */

    }, {
        key: 'tfaAuth',
        value: function tfaAuth() {

            this.Auth.rememberTfa = this.$scope.tfaSetCookie;

            var tfaPayload = this.getTfaPayload();

            var tfaHeader = {
                'X-Avira-Otp': this.$scope.tfaCode,
                'X-Avira-Browser': this.$window.browserName,
                'X-Avira-Browser-Trusted': this.Auth.rememberTfa,
                'X-Avira-Os': _RFC4.default.getOSVersion()
            };

            var formIsValid = this.$scope.tfaAuthLogin.$valid;

            this.$scope.submitted = true;

            if (formIsValid) {

                this.Auth.loading = true;
                this.Auth.tfaLogin(tfaPayload, tfaHeader);
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }

        /**
         * @ngdoc controllers
         * @name controllers.Tfa#tfaResend
         * @methodOf controllers.Tfa
         *
         * @description
         * resends 2FA authentication code to user
         */

    }, {
        key: 'tfaResend',
        value: function tfaResend() {

            var tfaPayload = this.getTfaPayload();
            var isResendRequest = true;

            this.Auth.tfaLogin(tfaPayload, null, isResendRequest);
        }
    }]);

    return Tfa;
}();

_serviceDependencies.push(Tfa);

angular.module('controllers').controller('Tfa', _serviceDependencies);

/***/ }),

/***/ "OEuF":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-standard-width form-modal-standard {{modalStylingClasses.modalClasses}}\">\n\t<div\n\t\tng-if=\"$root.passwordComnfirmationFor === 'delete-account-confirmation'\"\n\t\tclass=\"icon-warning-light mb10\">\n\t</div>\n\n\t<h2 class=\"text-xxl mb15 font-regular {{modalStylingClasses.titleColor}} \"\n\t\ttranslate={{modalStylingClasses.titleKey}}>\n\t</h2>\n\n\t<div ng-class=\"{'mb20' : authError || captchaRequired }\">\n\t\t<div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': authError}\">\n\n\t\t\t<!-- invalid credentials error message -->\n\t\t\t<p class=\"text-m text-red-2\" id=\"error-message-form\" ng-if=\"authError && submitted\"\n\t\t\t\ttranslate=\"cw.auth.login.error.email_password\" connectqa-login=\"form-general-error\"></p>\n\n\t\t\t<!-- reset password message -->\n\t\t\t<a ui-sref=\"root.auth.forgot\" class=\"text-m text-blue-2\"\n\t\t\t\tng-click=\"setEmail(); Auth.removeLoginCookies()\"\n\t\t\t\tng-if=\"authError && submitted && failedLogins === 2 && !oauthCtrl.Auth.captchaRequired\"\n\t\t\t\ttranslate=\"cw.auth.login.error.recover\" connectqa-login=\"reset-password-error-message\"></a>\n\t\t</div>\n\n\t\t<!-- <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': captchaRequired}\">\n\t\t\t<p class=\"text-m text-red-2\"\n\t\t\t\tid=\"error-message-captcha\"\n\t\t\t\tng-show=\"submitted && captchaRequired\"\n\t\t\t\ttranslate=\"cw.notification.auth.signup.require_captcha\">\n\t\t\t</p>\n\t\t</div> -->\n\t</div>\n\n\t<form name=\"verifyIdentityForm\" role=\"form\" novalidate ng-submit=\"onSubmit()\">\n\n\t\t<div class=\"text-left mb20\">\n\n\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.input_title.password\"></div>\n\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<input type=\"password\" ng-model=\"password\" name=\"password\" ng-minlength=\"5\" maxlength=\"100\"\n\t\t\t\t\tautocomplete=\"off\" ng-class=\"{ 'error':(verifyIdentityForm.password.$invalid ||\n\t\t\t\t\t\tverifyIdentityForm.password.$error.serverValidation) && submitted }\" id=\"password\" required />\n\n\t\t\t\t<p class=\"error-message\" ng-show=\"verifyIdentityForm.password.$invalid && submitted\"\n\t\t\t\t\ttranslate=\"cw.input.current_password.error.no_characters\" connectqa-login=\"password-too-short\"></p>\n\t\t\t\t<p class=\"error-message\" ng-show=\"verifyIdentityForm.password.$viewValue.length === 100\"\n\t\t\t\t\ttranslate=\"cw.validator.messages.password.maximum_length\"></p>\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<!-- Default Buttons -->\n\t\t<div ng-if=\"$root.passwordComnfirmationFor !== 'delete-account-confirmation'\">\n\t\t\t<button class=\"btn btn-large btn-half-width btn-secondary fl-left\" translate=\"cw.form.profile.cancel\"\n\t\t\t\tng-click=\"closeModal()\">\n\t\t\t</button>\n\n\t\t\t<button class=\"btn btn-large btn-half-width spin-loader fl-right {{modalStylingClasses.btnColor}}\" ng-disabled=\"loading\"\n\t\t\t\ttranslate=\"cw.auth.continue\">\n\t\t\t</button>\n\t\t</div>\n\n\t\t<!-- Buttons for delete account -->\n\t\t<div ng-if=\"$root.passwordComnfirmationFor === 'delete-account-confirmation'\">\n\t\t\t<a class=\"btn btn-medium btn-primary mlr5 mw-150\" translate=\"cw.form.profile.cancel\"\n\t\t\t\tng-click=\"closeModal()\">\n\t\t\t</a>\n\n\t\t\t<button class=\"btn btn-medium btn-secondary mlr5 mw-150\" ng-disabled=\"loading\"\n\t\t\t\ttranslate=\"cw.auth.continue\">\n\t\t\t</button>\n\t\t</div>\n\n\t</form>\n\t<div class=\"form-group mb0 auth-nomargin\">\n\t\t<div vc-recaptcha class=\"captcha2\" key=\"Recaptcha.captchaKey\" on-create=\"Recaptcha.setWidgetId(widgetId)\"\n\t\t\ton-success=\"setCaptchaResponse(response)\" size=\"invisible\">\n\t\t</div>\n\t</div>\n</div>";
var path = 'scripts/controllers/modals/my-account/password-confirmation/password-confirmation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "OHSR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFCSession = __webpack_require__("DyxV");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$scope'];

var UsComplianceFailed = function UsComplianceFailed($rootScope, $scope) {
    _classCallCheck(this, UsComplianceFailed);

    var initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));
    if (initialUrl.indexOf('client_id=spotlight') > -1) {

        $scope.showOkButton = true;
        if (window.external && 'CloseHtml' in window.external) {

            $scope.closeHtml = function () {

                window.external.CloseHtml('confirmed');
            };
        }
    }

    _RFC2.default.send('ConnectWeb Restricted Page Open');
    $rootScope.State.finishedLoadingAnimation = true;
    $rootScope.State.loading = false;
};

_serviceDependencies.push(UsComplianceFailed);

angular.module('controllers').controller('UsComplianceFailed', _serviceDependencies);

/***/ }),

/***/ "OMn1":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-auth\">\n    <div class=\"auth-region\">\n\n        <a ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n            <i class=\"sprite sprite-logo\"></i>\n            <h1>{{State.partner.name}}</h1>\n        </a>\n\n        <div class=\"form-wrapper\">\n\n            <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                <change-language></change-language>\n            </h3>\n\n            <h1 class=\"text-xxl text-grey-1 mb5\" translate=\"cw.auth.reset.title\"></h1>\n            <h2 class=\"text-l text-grey-4 mb15\" translate=\"cw.auth.reset.desc\" translate-values=\"{brandname : brandName}\"></h2>\n\n            <!-- Expired Token Error -->\n            <p class=\"text-m text-red-2\"\n                ng-show=\"Auth.error && Auth.errorReason === 'expired_token' && submitted\" translate=\"cw.validator.messages.password.expiredToken\"></p>\n\n            <!-- Placement for errors specific to form but not to specific field -->\n            <p class=\"text-m text-red-2\"\n                ng-show=\"((resetPasswordForm.password.$viewValue !== resetPasswordForm.passwordConfirm.$viewValue) || !resetPasswordForm.passwordConfirm.$viewValue)\n                && submitted\" translate=\"cw.validator.messages.equal_to_password\"></p>\n\n            <form class=\"auth-form\" name=\"resetPasswordForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.resetPassword()\">\n\n\n                <div class=\"form-group\" ng-init=\"passwordFocus = false\">\n                    <input type=\"password\"\n                           ng-model=\"password\"\n                           name=\"password\"\n                           ng-focus=\"passwordFocus = true\"\n                           ng-blur=\"passwordFocus = false\"\n                           maxlength=\"100\"\n                           autocomplete=\"off\"\n                           ng-class=\"{'error': (resetPasswordForm.password.$invalid || !oauthCtrl.passwordScore.valid) && submitted}\"\n                           id=\"password\"\n                           placeholder=\"{{ 'cw.form.password' | translate }}\"\n                           ng-pattern=\"passwordRegExp\"\n                           required\n                           ng-keyup=\"oauthCtrl.getPasswordScore(resetPasswordForm.password.$viewValue)\" />\n\n                    <label ng-hide=\"resetPasswordForm.password.$viewValue.length > 0\" class=\"fallback-input\" for=\"password\" translate=\"cw.form.password\"></label>\n                    <p class=\"error-message\"\n                       ng-show=\"(resetPasswordForm.password.$error.required ||\n                                (!oauthCtrl.passwordScore.valid && !resetPasswordForm.password.$viewValue)) && submitted\"\n                       translate=\"cw.validator.password.error.enter_password\"></p>\n\n                    <p class=\"error-message\"\n                        ng-show=\"resetPasswordForm.password.$viewValue.length === 100\"\n                        translate=\"cw.validator.messages.password.maximum_length\"></p>\n\n                    <span class=\"show-password\" ng-class=\"{'text': inputType === 'text'}\" ng-click=\"oauthCtrl.showPassword()\"></span>\n\n                    <div ng-if=\"passwordFocus\" class=\"tooltip-input left\">\n                        <password-strength\n                            passlength=\"resetPasswordForm.password.$viewValue.length\"\n                            passpattern=\"resetPasswordForm.password.$valid\"\n                            passwordscore=\"oauthCtrl.passwordScore\">\n                        </password-strength>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <input type=\"password\"\n                           ng-model=\"passwordConfirm\"\n                           name=\"passwordConfirm\"\n                           maxlength=\"100\"\n                           autocomplete=\"off\"\n                           ng-class=\"{'error': (resetPasswordForm.password.$viewValue !== resetPasswordForm.passwordConfirm.$viewValue || !resetPasswordForm.passwordConfirm.$viewValue) && submitted}\"\n                           id=\"passwordConfirm\"\n                           placeholder=\"{{ 'cw.form.confirm_password' | translate }}\"\n                           required />\n\n                    <label ng-hide=\"resetPasswordForm.passwordConfirm.$viewValue.length > 0\" class=\"fallback-input\" for=\"passwordConfirm\" translate=\"cw.form.confirm_password\"></label>\n\n                    <p class=\"error-message\"\n                        ng-show=\"resetPasswordForm.passwordConfirm.$viewValue.length === 100\"\n                        translate=\"cw.validator.messages.password.maximum_length\"></p>\n\n                </div>\n\n                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                        ng-disabled=\"oauthCtrl.Auth.loading\" translate=\"cw.auth.reset.button\">\n                </button>\n\n                <div class=\"auth-actions\">\n                    <a class=\"text-m text-blue-2 mt10 inline-block\" ui-sref=\"root.auth.login\"><span class=\"text-xl\">&lsaquo; </span><span translate=\"cw.auth.go_to_login\"></span></a>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "ORg+":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("W/Il");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "OSI/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

var GdprReportsRestService = function (_BaseRestService) {
    _inherits(GdprReportsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function GdprReportsRestService($http, $q, Util) {
        _classCallCheck(this, GdprReportsRestService);

        return _possibleConstructorReturn(this, (GdprReportsRestService.__proto__ || Object.getPrototypeOf(GdprReportsRestService)).call(this, $http, $q, Util));
    }

    _createClass(GdprReportsRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(GdprReportsRestService.prototype.__proto__ || Object.getPrototypeOf(GdprReportsRestService.prototype), 'getAllAsync', this).call(this, 'gdpr-reports/');
        }
    }]);

    return GdprReportsRestService;
}(_baseRestService2.default);

exports.default = GdprReportsRestService;


_serviceDependencies.push(GdprReportsRestService);

angular.module('rest.services').service('GdprReportsRestService', _serviceDependencies);

/***/ }),

/***/ "OTi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("liN6");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _payments = [];
var observablePaymentTypes = new Rx.BehaviorSubject(_payments);

/**
 * @ngdoc service
 * @name repositories.PaymentTypesRepository
 *
 * @description
 * PaymentsRepository.
 */
var PaymentTypesRepository = {
    replace: function replace(data) {

        _payments = data;
        observablePaymentTypes.onNext(_payments);
        _RFC2.default.processCheckPayments(_payments);
    },
    getAll: function getAll() {

        return _payments;
    },
    getObservable: function getObservable() {

        return observablePaymentTypes;
    }
};

exports.default = PaymentTypesRepository;

/***/ }),

/***/ "OWtL":
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard\"\n     ng-class=\"{'showMobileMenu': $root.showMobileMenu}\">\n\n    <!--Disclaimer Bar-->\n    <disclaimer-bar></disclaimer-bar>\n\n    <header></header>\n\n    <div class=\"icon icon-m icon-grey-4 icon-menu-details mobile-menu\"\n         ng-class=\"{'showMobileMenu': $root.showMobileMenu}\"\n         ng-click=\"dashboardCtrl.toggleMobileMenu()\"\n         connectqa-mobile=\"{{$root.mobileMenuAttribute}}\"></div>\n\n    <div class=\"backdrop-mobile\"\n         ng-click=\"dashboardCtrl.toggleMobileMenu()\"\n         ng-class=\"{'showMobileMenu': $root.showMobileMenu}\"></div>\n\n    <div class=\"left-sidebar-nd\" ng-class=\"{'showMobileMenu': $root.showMobileMenu}\" ng-mouseover=\"broadcastMouseOver()\">\n\n        <div ui-view=\"dashboard.navigation\"></div>\n    </div>\n\n    <div class=\"right-region-nd\">\n        <div ui-view=\"dashboard.body\"></div>\n    </div>\n\n    <div ui-view=\"dashboard.abstract\"></div>\n\n</div>\n"

/***/ }),

/***/ "OcT+":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-standard-width form-modal-standard delete-account\">\n\n\t<div ng-if=\"!passwordStep\">\n\t\t<div class=\"icon-warning-light mb10\"></div>\n\t\t<h2 class=\"text-xxl mb30\" translate=\"cw.delete_account.confirm_title\"></h2>\n\n\t\t<ul class=\"text-left mb30 inline-block\">\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.delete_account.text1\"></li>\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.delete_account.text5\"></li>\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.delete_account.text2\"></li>\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.delete_account.text3\"></li>\n\t\t\t<li class=\"text-m text-grey-2\" translate=\"cw.delete_account.text4\"></li>\n\t\t</ul>\n\n\t\t<p class=\"text-xs text-grey-4 mb20\" translate=\"cw.delete_account.confirm_extra_info2\" translate-values=\"{brandname : brandName}\"></p>\n\n\t\t<div>\n\t\t\t<button class=\"btn btn-medium btn-primary mlr5 mw-150\"\n\t\t\t\t\ttranslate=\"cw.form.profile.cancel\"\n\t\t\t\t\tng-click=\"closeModal()\"></button>\n\n\t\t\t<button ng-if=\"!socialLogin\" class=\"btn btn-medium btn-secondary mlr5 mw-150\"\n\t\t\t\t\tng-disabled=\"loadingConfirm\"\n\t\t\t\t\tng-click=\"continueToPassword()\"\n\t\t\t\t\ttranslate=\"cw.auth.continue\"></button>\n\n\t\t\t<button ng-if=\"socialLogin\" class=\"btn btn-medium btn-secondary mlr5 mw-150\"\n\t\t\t\t\tng-disabled=\"loadingConfirm\"\n\t\t\t\t\tng-click=\"confirmDeleteAccount()\"\n\t\t\t\t\ttranslate=\"cw.general.ui.confirm\"></button>\n\t\t</div>\n\t</div>\n\n\t<div ng-if=\"passwordStep\">\n\t\t<div class=\"icon-warning-light mb10\"></div>\n\n\t\t<h2 class=\"text-xxl mb15 font-regular text-grey-2 mb30\"\n\t\t\ttranslate=\"cw.validator.password.error.enter_password\">\n\t\t</h2>\n\n\t\t<form name=\"verifyIdentityForm\" role=\"form\" novalidate>\n\n\t\t\t<div class=\"text-left mb20\">\n\n\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.input_title.password\"></div>\n\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<input type=\"password\" ng-model=\"password\" name=\"password\" ng-minlength=\"5\" maxlength=\"100\"\n\t\t\t\t\t\tautocomplete=\"off\" ng-class=\"{ 'error':(verifyIdentityForm.password.$invalid ||\n\t\t\t\t\t\t\tverifyIdentityForm.password.$error.serverValidation) && submitted }\" id=\"password\" required />\n\n\t\t\t\t\t<p class=\"error-message\" ng-show=\"verifyIdentityForm.password.$invalid && submitted\"\n\t\t\t\t\t\ttranslate=\"cw.input.current_password.error.no_characters\"></p>\n\t\t\t\t\t<p class=\"error-message\" ng-show=\"verifyIdentityForm.password.$viewValue.length === 100\"\n\t\t\t\t\t\ttranslate=\"cw.validator.messages.password.maximum_length\"></p>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div>\n\t\t\t\t<a class=\"btn btn-medium btn-primary mlr5 mw-150\" translate=\"cw.form.profile.cancel\"\n\t\t\t\t\tng-click=\"closeModal()\">\n\t\t\t\t</a>\n\n\t\t\t\t<button class=\"btn btn-medium btn-secondary mlr5 mw-150\" ng-disabled=\"loading\" translate=\"cw.general.ui.confirm\"\n\t\t\t\t\tng-click=\"confirmDeleteAccount()\">\n\t\t\t\t</button>\n\t\t\t</div>\n\n\t\t</form>\n\t</div>\n</div>\n";
var path = 'scripts/controllers/modals/my-account/delete-account-confirmation/delete-account-confirmation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "OjAK":
/***/ (function(module, exports) {

module.exports = {"name":"Connect-Web","version":"6.15.0","dependencies":{"@sentry/browser":"^6.13.3","@sentry/integrations":"^6.13.3","angular":"1.8.3","angular-animate":"1.8.3","angular-bindonce":"~0.3.1","angular-jwt":"~0.1.10","angular-recaptcha":"~4.0.0","angular-sanitize":"1.8.3","angular-scroll":"^0.6.2","angular-translate":"~2.18.1","angular-ui-router":"~0.4.2","angular-utf8-base64":"~0.0.5","ansi-html-community":"0.0.8","babel-jest":"^23.0.1","babel-polyfill":"^6.26.0","babel-preset-react-app":"^3.1.2","cross-env":"^3.2.4","crypto-js":"^3.1.9-1","dotenv-webpack":"^1.5.7","enzyme":"^3.0.0","enzyme-adapter-react-16":"^1.1.1","enzyme-to-json":"^3.3.4","es5-shim":"^4.0.0","es6-shim":"^0.35.3","google-libphonenumber":"^3.1.15","i18next":"20.0.0","i18next-xhr-backend":"^1.5.1","iltorb":"^2.4.5","jest":"^27.0.0","jquery":"3.6.0","jquery.scrollbar":"^0.2.11","json3":"^3.3.2","jwt-decode":"^2.2.0","lodash.template":"^4.5.0","logdown":"^3.2.7","mixpanel-browser":"^2.7.2","moment":"2.29.4","prop-types":"^15.6.1","qrcodejs2":"0.0.2","react":"^16.4.1","react-dom":"^16.4.1","react-test-renderer":"^16.4.1","react2angular":"^4.0.2","rx":"^2.4.0","sockjs-client":"^1.1.5","superstatic":"^7.0.0","uglify-js":"3.17.4","ui-cropper":"^1.0.6","ui-select":"0.19.8","underscore":"^1.7.0","underscore.string":"3.3.5","zxcvbn":"^4.4.2"},"scripts":{"build":"npm run get-translations && npm run lint-js && cross-env NODE_ENV=production PLATFORM=web webpack -p","profile-build":"npm run clean && cross-env NODE_ENV=production webpack --profile --json > stats.json && webpack-bundle-analyzer stats.json","clean":"rimraf desktop/dist/","get-translations":"node webpack/processTranslations.js","clean-translations":"node webpack/translationCleaner.js","docs":"node webpack/generateDocs.js","dev":"npm run get-translations & npm run lint-js && cross-env NODE_ENV=development PLATFORM=web webpack","lint":"npm run lint-js","lint-js":"eslint \"./desktop/app/scripts/**/*.{js,es6}\" --ignore-path .gitignore","lint-css":"stylelint \"./desktop/app/styles/**/*.less\"","start":"cross-env NODE_ENV=development PLATFORM=web PORT=3000 webpack-dev-server --progress --colors","test":"node scripts/runTests.js","preinstall":"npx npm-force-resolutions"},"devDependencies":{"@types/prop-types":"^15.7.1","@types/react":"^16.8.18","@types/react-dom":"^16.8.4","ajv-keywords":"^3.4.0","angular-mocks":"^1.2.27","autoprefixer":"latest","babel-core":"latest","babel-loader":"^7.1.5","babel-plugin-angularjs-annotate":"latest","babel-plugin-transform-es2015-classes":"latest","babel-preset-es2015":"latest","babel-preset-react":"^6.24.1","chunk-manifest-webpack-plugin":"^1.1.2","clean-webpack-plugin":"^0.1.19","connect-livereload":"~0.3.2","connect-modrewrite":"~0.5.11","copy-webpack-plugin":"^4.0.1","css-loader":"3.6.0","cssnano":"4.1.10","dotenv":"^6.0.0","eslint":"^4.18.1","eslint-config-airbnb":"^16.1.0","eslint-plugin-import":"^2.9.0","eslint-plugin-jsx-a11y":"^6.0.3","eslint-plugin-react":"^7.7.0","exports-loader":"^0.6.4","expose-loader":"^0.7.3","extract-text-webpack-plugin":"^3.0.0","file-loader":"^0.11.2","glob":"8.0.3","html-loader":"^0.4.5","html-webpack-exclude-assets-plugin":"^0.0.5","html-webpack-plugin":"^2.30.1","ini":"^2.0.0","inline-source-map":"^0.6.2","jshint-stylish":"~0.1.5","less":"^3.0.0","less-loader":"^4.0.4","merge":"^2.0.0","mustache":"^2.3.0","ng-annotate":"^1.2.2","ng-cache-loader":"0.0.25","ngtemplate-loader":"^2.0.1","node-plantuml":"^0.6.1","optimize-css-assets-webpack-plugin":"^2.0.0","postcss-less":"^1.1.0","postcss-loader":"4.3.0","raw-loader":"^0.5.1","requirejs":"~2.1.11","rimraf":"^2.6.3","script-ext-html-webpack-plugin":"^1.8.5","simple-git":"^1.110.0","style-loader":"^0.18.2","stylelint":"^7.7.0","stylelint-webpack-plugin":"^0.8.0","to-string-loader":"^1.1.5","webpack":"^3.12.0","webpack-bundle-analyzer":"^2.8.3","webpack-chunk-hash":"^0.4.0","webpack-dev-server":"^2.11.1","webpack-hot-middleware":"^2.21.0","webpack-manifest-plugin":"^1.3.2","webpack-md5-hash":"^0.0.5","serialize-javascript":"^3.1.0","color-string":"^1.5.5","js-yaml":"^3.14.1","normalize-url":"4.5.1","yargs-parser":"13.1.2","set-value":"4.0.1","minimist":"1.2.5","node-fetch":"2.6.7","ansi-html":"https://registry.npmjs.org/ansi-html-community/-/ansi-html-community-0.0.8.tgz","ajv":"6.12.6","ansi-regex":"5.0.1","faye-websocket":"0.11.4","glob-parent":"5.1.2","sockjs":"0.3.20","ssri":"8.0.1","trim-newlines":"3.0.1","postcss":"7.0.39","css-what":"5.1.0","nth-check":"2.0.1"},"jest":{"collectCoverageFrom":["<rootDir>/desktop/**/*.{js,jsx}"],"testPathIgnorePatterns":["<rootDir>[/\\\\](build|docs|node_modules|scripts|desktop/bower_components)[/\\\\]"],"testEnvironment":"node","testURL":"http://localhost","transform":{"^.+\\.(js|jsx)$":"babel-jest","^.+\\.css$":"<rootDir>/testSetup/cssTransform.js","^(?!.*\\.(js|jsx|css|json)$)":"<rootDir>/testSetup/fileTransform.js"},"transformIgnorePatterns":["[/\\\\]node_modules[/\\\\].+\\.(js|jsx)$"],"moduleNameMapper":{"^react-native$":"react-native-web"},"setupTestFrameworkScriptFile":"<rootDir>/testSetup/setupTests.js"},"babel":{"presets":["react-app"]},"engines":{"node":">6.x","npm":">3.x"},"private":true,"resolutions":{"serialize-javascript":"^3.1.0","color-string":"^1.5.5","js-yaml":"^3.14.1","yargs-parser":"13.1.2","set-value":"4.0.1","minimist":"1.2.6","node-fetch":"2.6.7","simple-get":"4.0.1","ansi-html":"https://registry.npmjs.org/ansi-html-community/-/ansi-html-community-0.0.8.tgz","ajv":"6.12.6","ansi-regex":"5.0.1","glob-parent":"5.1.2","sockjs":"0.3.20","ssri":"8.0.1","faye-websocket":"0.11.4","trim-newlines":"3.0.1","postcss":"7.0.39","css-what":"5.1.0","nth-check":"2.0.1","normalize-url":"^4.5.1","node-forge":"1.0.0","follow-redirects":"1.14.7","async":"3.2.2","eventsource":"2.0.2","url-parse":"1.5.9","angular":"1.8.3","got":"11.8.5","minimatch":"5.1.0","json5":"2.2.2"}}

/***/ }),

/***/ "OkiX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'UserNotificationsRestService', 'UserRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.NotificationsController
 *
 * @description
 * email notifications form controller
 */

var NotificationsController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} UserNotificationsRestService
     */
    function NotificationsController($scope, UserNotificationsRestService, UserRestService) {
        _classCallCheck(this, NotificationsController);

        this.$scope = $scope;
        this.MeRepository = _index.MeRepository;
        this.UserNotificationsRestService = UserNotificationsRestService;
        this.user = _index.MeRepository.getMyUser();
        this.$scope.notifications = angular.copy(this.user.attributes.notifications);
        this.$scope.loading = false;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.UserRestService = UserRestService;
    }

    /**
     * @ngdoc directive
     * @name directives.controller.NotificationsController#method
     * @methodOf directives.controller.NotificationsController
     *
     * @description
     * change the email notifications
    */


    _createClass(NotificationsController, [{
        key: 'changeNotifications',
        value: function changeNotifications() {
            var _this = this;

            // form model values === user email notifications values
            var formIsValid = !angular.equals(this.$scope.notifications, this.user.attributes.notifications);

            var payload = {
                data: {
                    attributes: {
                        notifications: this.$scope.notifications
                    },
                    type: this.user.type,
                    id: this.user.id
                }
            };

            // if form has been changed
            if (formIsValid) {

                this.$scope.loading = true;
                // send the payload with the PUT update user method
                this.UserNotificationsRestService.update(this.user.id, payload).then(function () {

                    // update the user repository
                    _this.UserRestService.getMeAsync().then(function (response) {

                        _this.$scope.loading = false;

                        _this.MeRepository.update(response.data.data);

                        // update form with the latest user data email notifications from repository
                        _this.user = _this.MeRepository.getMyUser();
                        _this.$scope.notifications = angular.copy(_this.user.attributes.notifications);

                        _RFC4.default.success('cw.notifications.messages.success_extra_info');
                    });

                    _RFC2.default.send('ConnectWeb Edit Notifications Click');
                }).then(null, function () {

                    _this.$scope.loading = false;
                    _RFC4.default.error('cw.notifications.messages.error');
                });
            }
        }
    }]);

    return NotificationsController;
}();

/**
 * @ngdoc directive
 * @name directives.NotificationsDirective
 *
 * @description
 * email notifications form directive
 */


var NotificationsDirective = function NotificationsDirective() {
    _classCallCheck(this, NotificationsDirective);

    this.template = __webpack_require__("mec4");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, UserNotificationsRestService, UserRestService) {
        return new NotificationsController($scope, UserNotificationsRestService, UserRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'NotificationsCtrl';
};

_directiveDependencies.push(function () {
    return new NotificationsDirective();
});

angular.module('directives').directive('notifications', _directiveDependencies);

/***/ }),

/***/ "OweZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

var FlexiblePromotionsRestService = function (_BaseRestService) {
    _inherits(FlexiblePromotionsRestService, _BaseRestService);

    function FlexiblePromotionsRestService() {
        _classCallCheck(this, FlexiblePromotionsRestService);

        return _possibleConstructorReturn(this, (FlexiblePromotionsRestService.__proto__ || Object.getPrototypeOf(FlexiblePromotionsRestService)).apply(this, arguments));
    }

    _createClass(FlexiblePromotionsRestService, [{
        key: 'getPromotion',
        value: function getPromotion(promotion) {

            return _get(FlexiblePromotionsRestService.prototype.__proto__ || Object.getPrototypeOf(FlexiblePromotionsRestService.prototype), 'getAllAsync', this).call(this, 'flexible-promotions/?filter[type]=' + promotion.type + '&filter[source]=' + promotion.source + '&filter[purchase_type]=' + promotion.purchaseType + '&filter[product]=' + promotion.product + '&filter[runtime]=' + promotion.runtime + '&filter[devices]=' + promotion.devices);
        }
    }, {
        key: 'getPromotionById',
        value: function getPromotionById(promotionId) {

            return _get(FlexiblePromotionsRestService.prototype.__proto__ || Object.getPrototypeOf(FlexiblePromotionsRestService.prototype), 'getAllAsync', this).call(this, 'flexible-promotions/' + promotionId + '/');
        }
    }, {
        key: 'getPromotionByActivationCode',
        value: function getPromotionByActivationCode(activationCode, runtime, product) {

            return _get(FlexiblePromotionsRestService.prototype.__proto__ || Object.getPrototypeOf(FlexiblePromotionsRestService.prototype), 'getAllAsync', this).call(this, 'flexible-promotions/?filter[activation_code]=' + activationCode + '&filter[type]=public&filter[source]=cw' + (runtime ? '&filter[runtime]=' + runtime : '') + (product ? '&filter[product]=' + product : ''));
        }
    }]);

    return FlexiblePromotionsRestService;
}(_baseRestService2.default);

exports.default = FlexiblePromotionsRestService;


_serviceDependencies.push(FlexiblePromotionsRestService);

angular.module('rest.services').service('FlexiblePromotionsRestService', _serviceDependencies);

/***/ }),

/***/ "P3ym":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.loginTypeController
 *
 * @description
 * Login type controller
 */

var LoginTypeController =

/**
 * @param  {any} $scope
 */
function LoginTypeController($scope) {
    _classCallCheck(this, LoginTypeController);

    this.$scope = $scope;
    this.$scope.logintype = _RFC2.default.get(CWCONFIG.cookie.loginType);
    this.$scope.userEmail = _index.MeRepository.getMyEmail();
};

/**
 * @ngdoc directive
 * @name directives.LoginTypeDirective
 *
 * @description
 * Login type directive
 */


var LoginTypeDirective = function LoginTypeDirective() {
    _classCallCheck(this, LoginTypeDirective);

    this.template = __webpack_require__("19sK");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope) {
        return new LoginTypeController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'LoginTypeCtrl';
};

_directiveDependencies.push(function () {
    return new LoginTypeDirective();
});

angular.module('directives').directive('loginType', _directiveDependencies);

/***/ }),

/***/ "P9it":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("XtWt");

__webpack_require__("XOr9");

__webpack_require__("W3A/");

__webpack_require__("35YC");

__webpack_require__("saA2");

__webpack_require__("w/r9");

__webpack_require__("cyi/");

__webpack_require__("RNqL");

__webpack_require__("cJxR");

/***/ }),

/***/ "PKth":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$rootScope', 'UserRestService', 'Util', 'Auth'];

/**
 * @ngdoc directive
 * @name directives.controller.changeEmailController
 *
 * @description
 * change email controller
 */

var ChangeEmailController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} $rootScope
     * @param  {any} Auth
     */
    function ChangeEmailController($scope, $state, $rootScope, UserRestService, Util, Auth) {
        var _this = this;

        _classCallCheck(this, ChangeEmailController);

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.MeRepository = _index.MeRepository;
        this.UserRestService = UserRestService;
        this.Util = Util;
        this.Auth = Auth;
        this.Recaptcha = _recaptcha2.default;
        this.user = _index.MeRepository.getMyUser();

        this.$scope.submitted = false;
        this.$scope.loading = false;
        this.$scope.emailError = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.email = this.user.attributes.email;
        this.$scope.password = null;
        this.$scope.loginFailedAttempts = 0;
        this.$scope.captchaRequired = 0;
        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        // MeRepository Observable
        var meRepositoryObservable = _index.MeRepository.getObservable();
        var onNextMeRepository = function onNextMeRepository() {

            _this.user = _index.MeRepository.getMyUser();
        };

        this.meRepositorySubscriber = meRepositoryObservable.subscribe(onNextMeRepository, function () {}, function () {});
        this.$scope.$on('captcha available', function () {
            return _this.setCaptchaResponse();
        });
    }

    // check if the current email and the entered one are different


    _createClass(ChangeEmailController, [{
        key: 'checkEmailAddresses',
        value: function checkEmailAddresses() {

            this.$scope.isEmailDifferent = this.$scope.email !== this.user.attributes.email;
        }
    }, {
        key: 'changeEmail',
        value: function changeEmail() {
            var _this2 = this;

            _RFC4.default.send('ConnectWeb Change Email Click');

            var headers = {};

            var captchaRespose = this.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            var payload = {
                data: {
                    id: this.user.id,
                    attributes: {
                        email: this.$scope.email
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: this.user.relationships.partner.data.type,
                                id: this.user.relationships.partner.data.id
                            }
                        }
                    },
                    type: this.user.type
                },
                meta: {
                    language: CWCONFIG.language,
                    password: this.$scope.changeEmailForm.password.$viewValue
                }
            };

            this.checkEmailAddresses();
            this.$scope.changeEmailForm.password.$setValidity('serverValidation', true);
            /* beside form validation, we also check if the email addresses
            are different in order to validate the form */
            var formIsValid = this.$scope.changeEmailForm.$valid && this.$scope.isEmailDifferent;
            this.$scope.changeEmailForm.$setPristine();
            this.$scope.submitted = true;
            this.$scope.loading = true;

            if (formIsValid) {

                this.UserRestService.update(this.user.id, payload, headers).then(function () {

                    _this2.$scope.password = null;
                    _this2.$scope.loading = false;
                    _this2.$scope.submitted = false;
                    _this2.$scope.emailError = false;
                    _this2.Recaptcha.disableCaptcha();
                }).then(null, function (error) {

                    var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                    _this2.$scope.loading = false;

                    switch (errorCode) {

                        // email already exists
                        case '21112':
                            _this2.$scope.submitted = true;
                            _this2.$scope.emailError = true;

                            break;

                        // open modal and enter the received code
                        case '21118':

                            _this2.$scope.emailError = false;
                            _this2.$scope.submitted = false;
                            _this2.$scope.password = null;

                            _this2.$state.go('root.dashboard.my-account.ltb', {
                                ltb: 'change-email'
                            });

                            // save email information on $rootScope in order to use it in Change Email modal
                            _this2.$rootScope.changeEmail = {
                                currentEmail: _this2.user.attributes.email,
                                newEmail: _this2.$scope.email,
                                kp: _this2.$scope.changeEmailForm.password.$viewValue
                            };

                            break;

                        // invalid credential
                        case '21133':

                            _this2.$scope.loginFailedAttempts += 1;
                            _this2.$scope.changeEmailForm.password.$setPristine();
                            _this2.$scope.changeEmailForm.password.$setValidity('serverValidation', false);

                            break;

                        // captcha is required
                        case '918':

                            if (_this2.$scope.captchaRequired >= 2) {

                                _this2.$state.reload();
                                _RFC2.default.error('cw.auth.tfa.error.retries_exceeded');
                            }

                            _this2.Recaptcha.execute();
                            _this2.$scope.captchaRequired += 1;
                            break;

                        default:

                            _RFC2.default.error('cw.account.details.messages.error');

                    }

                    _this2.Util.triggerAnimation('.error', 'animated shake');
                });
            } else {

                this.$scope.loading = false;
                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            if (this.Recaptcha.isCaptchaRequired()) {

                this.Recaptcha.execute();
            } else {

                this.changeEmail();
            }
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse() {

            this.changeEmail();
        }
    }, {
        key: 'showPassword',
        value: function showPassword() {

            var input = angular.element('#password')[0];

            input.type = input.type === 'text' ? 'password' : 'text';

            this.$scope.inputType = input.type;
        }
    }, {
        key: 'setEmail',
        value: function setEmail() {

            this.$rootScope.forgotEmail = this.user.attributes.email;
        }
    }]);

    return ChangeEmailController;
}();

/**
 * @ngdoc directive
 * @name directives.changeEmailDirective
 *
 * @description
 * change email directive
 */


var ChangeEmailDirective = function ChangeEmailDirective() {
    _classCallCheck(this, ChangeEmailDirective);

    this.template = __webpack_require__("DpBW");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, $state, $rootScope, UserRestService, Util, Auth) {
        return new ChangeEmailController($scope, $state, $rootScope, UserRestService, Util, Auth);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'changeEmailCtrl';
};

_directiveDependencies.push(function () {
    return new ChangeEmailDirective();
});

angular.module('directives').directive('changeEmail', _directiveDependencies);

/***/ }),

/***/ "PLm0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _RFCSession = __webpack_require__("DyxV");

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$interval', 'Auth', 'Util', '$rootScope', 'Sso', '$window', '$state'];

/**
     * @ngdoc service
     * @name controllers.Login
     *
     * @description
     * Login controller
     */

var Login = function () {

    /**
         * @param  {any} $scope
         * @param  {any} $interval
         * @param  {any} Auth
         * @param  {any} Util
         * @param  {any} rootScope
         * @param  {any} Sso
         * @param  {any} $window
         */
    function Login($scope, $interval, Auth, Util, $rootScope, Sso, $window, $state) {
        var _this = this;

        _classCallCheck(this, Login);

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.Sso = Sso;
        this.$window = $window;
        this.$interval = $interval;
        this.$scope.submitted = false;
        this.Auth.loading = false;
        this.Auth.error = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.showChangeLang = true;
        this.$scope.showSocialLogin = true;
        this.$scope.showEmbeddedSocialLogin = false;
        this.Recaptcha = _recaptcha2.default;
        this.$scope.clientId = 'dashboard';
        this.$scope.activeSlide = 'slide-1';
        this.$scope.sliderAutoplay = true;
        this.$state = $state;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
        this.$scope.hrefLegalTerms = CWCONFIG.partnerConfig.translationsLinks.eula.legalTerms.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralPrivacy = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralImprint = CWCONFIG.partnerConfig.translationsLinks.generalImprint.replace('{language}', CWCONFIG.language);
        this.$scope.showSimplifiedLogin = false;
        var supportedLanguagesAwards = CWCONFIG.partnerConfig.translationsLinks.awards.languages;

        if (supportedLanguagesAwards.find(function (element) {
            return element === CWCONFIG.language;
        })) {

            this.$scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', CWCONFIG.language);
        } else {

            this.$scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', 'en');
        }

        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);

        var initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));

        this.socialLoginUrl = initialUrl;
        this.$scope.showCustomAuth = false;

        var mixpanelPayload = { Source: 'Direct' };

        var counter = 1;
        this.sliderInterval = this.$interval(function () {

            counter += 1;

            if (counter < 4) {

                _this.switchSlide('slide-' + counter);
            } else {

                counter = 1;
                _this.switchSlide('slide-' + counter);
            }
        }, 5000);

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();

            // show the embedded social login button if we receive a embedded_social=true param
            this.$scope.showEmbeddedSocialLogin = this.Sso.getEmbeddedSocialLogin();

            this.$scope.clientId = this.Sso.getClientId();

            // prefill email address if we receive an email param
            // param should be 64base encoded
            this.$scope.email = this.isBase64();

            if (initialUrl.indexOf('client_id=spotlight') > -1) {

                /**
                 * Set the URL for the social button that will redirect to the Sso page
                 * in the browser with other default values
                 */
                var token = Util.getToken();
                // close the embedded sso page if sso token is missing
                if (!token || token === 'undefined') {

                    if (window.external && 'CloseHtml' in window.external) {

                        window.external.CloseHtml('social login redirect to dashboard');
                    }
                }
                this.socialLoginUrl = this.socialLoginUrl.replace('embedded_social=true', 'embedded_social=false').replace('social_login=false', 'social_login=true').replace('change_lang=false', 'change_lang=true').replace('embedded=true', 'embedded=false').replace(Util.getParams(initialUrl).access_token, token);

                // this means user landed in register page and switched tabs to register
                // so our redirect must now be to login
                if (this.socialLoginUrl.indexOf('auth/register') > -1) {

                    this.socialLoginUrl = this.socialLoginUrl.replace('auth/register', 'auth/login');
                }

                this.$scope.email = this.Sso.getEmailAddress() || '';
            }
        }
        // conditions in order to show simplified Login view :
        // exist an lastLogin obj in localstorage
        // link is not from spotlight ( doestn't contain 'embedded=true' )
        var lastLogin = localStorage.getItem('lastLogin');
        this.$scope.lastLogin = this.decodeLastLogin(lastLogin);

        if (this.$scope.lastLogin && this.$scope.lastLogin.loginType && this.socialLoginUrl.indexOf('embedded=true') === -1) {

            var isSocialLoginAvailable = this.$scope.lastLogin.loginType === 'fb_auth' && this.$scope.fb.feature || this.$scope.lastLogin.loginType === 'gg_auth' && this.$scope.gplus.feature || this.$scope.lastLogin.loginType === 'apl_auth' && this.$scope.appleID.feature && this.$scope.browserName !== 'ie';

            if (this.$scope.lastLogin.loginType === 'password') {

                this.$scope.showSimplifiedLogin = true;
                this.$scope.email = this.$scope.lastLogin.email;
            } else {

                this.$scope.showSimplifiedLogin = isSocialLoginAvailable;
            }
        }

        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            mixpanelPayload = { Source: 'ws_spotlight' };
        }

        _RFC2.default.setCommonProperty('Simplified Login', this.$scope.showSimplifiedLogin);
        _RFC2.default.send('ConnectWeb Auth Login Open', mixpanelPayload);

        this.$scope.$on('$destroy', function () {

            if (_this.$scope.showCustomAuth) {

                angular.element('.landing-page-auth').show();
            }
        });
    }

    _createClass(Login, [{
        key: 'switchLoginView',
        value: function switchLoginView() {

            this.$scope.showSimplifiedLogin = false;
            var lastLoginType = void 0;
            switch (this.$scope.lastLogin.loginType) {

                case 'gg_auth':
                    lastLoginType = 'Google';
                    break;
                case 'fb_auth':
                    lastLoginType = 'Facebook';
                    break;
                case 'apl_auth':
                    lastLoginType = 'Apple ID';
                    break;
                case 'password':
                    lastLoginType = 'Password';
                    break;
                default:
                    lastLoginType = '';

            }
            _RFC2.default.send('ConnectWeb Other Login Options Click', {
                'Last Login': lastLoginType
            });
        }
    }, {
        key: 'isBase64',
        value: function isBase64() {

            try {

                return this.Sso.getDecodedEmailAddress();
            } catch (err) {

                return '';
            }
        }

        // SSO skip the login and redirect to skip_uri received in params

    }, {
        key: 'skip',
        value: function skip() {

            _RFC2.default.send('ConnectWeb Skip Click', {
                Page: 'Auth Login'
            });

            this.$window.location = this.skip_uri;
        }
    }, {
        key: 'login',
        value: function login() {

            // errors from authentification are hidden on start of form submission
            this.Auth.error = false;

            var oauthPayload = {
                grant_type: 'password',
                username: this.$scope.email,
                password: this.$scope.password
            };

            var headers = {
                'X-Avira-Token': this.Auth.getTfaCookie()
            };

            var captchaRespose = this.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            // Check if the user email and password are valid
            var formIsValid = this.$scope.loginForm.$valid;

            _RFC2.default.send('ConnectWeb Login Click', {
                Page: 'Auth Login'
            });

            this.$scope.submitted = true;

            var mixpanelError = '';

            if (formIsValid) {

                this.Auth.loading = true;
                this.Auth.loginType = 'Login'; // Login type for mixpanel event
                this.Auth.login(oauthPayload, headers);
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');

                if (this.$scope.loginForm.email.$invalid) {

                    if (typeof this.$scope.loginForm.email.$viewValue === 'undefined' || this.$scope.loginForm.email.$viewValue === '') {

                        mixpanelError += 'email is empty, ';
                    } else {

                        mixpanelError += 'email format not correct, ';
                    }
                }

                if (this.$scope.loginForm.password.$invalid) {

                    if (typeof this.$scope.loginForm.password.$viewValue === 'undefined' || this.$scope.loginForm.password.$viewValue === '') {

                        mixpanelError += 'password is empty, ';
                    } else {

                        mixpanelError += 'password format not correct, ';
                    }
                }

                _RFC2.default.send('ConnectWeb Login Error', {
                    'Error Name': mixpanelError.replace(/,\s*$/, '') // remove last ',' and ' '
                });
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _this2 = this;

            if (this.Recaptcha.captchaRetries <= this.Auth.failedLogins) {

                this.Recaptcha.enableCaptcha();
            }

            if (this.Recaptcha.isCaptchaRequired()) {

                this.Recaptcha.execute();
            } else if (this.$scope.clientId === 'centercode') {

                _RFC2.default.send('ConnectWeb Login Confirmation Modal Open');
                this.$state.go('root.auth.login.ltb', {
                    ltb: 'confirm-login'
                });
            } else {

                this.login();
            }
            _RFC4.default.subscribe('confirm-login:true', function () {

                _this2.login();
            });
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            this.Recaptcha.setCaptchaResponse(response);
            this.login();
        }
    }, {
        key: 'setEmail',
        value: function setEmail() {

            this.$rootScope.forgotEmail = this.$scope.email;
        }

        // redirect from Spotlight to dashboard Sso in the default browser of the user

    }, {
        key: 'socialLoginRedirect',
        value: function socialLoginRedirect() {

            if (window.external && 'OpenUrl' in window.external) {

                window.external.OpenUrl(this.socialLoginUrl);
            } else {

                window.open(this.socialLoginUrl, '_blank');
            }

            if (window.external && 'CloseHtml' in window.external) {

                window.external.CloseHtml('social login redirect to dashboard');
            }
        }

        // animation switch slide

    }, {
        key: 'switchSlide',
        value: function switchSlide(currentSlide) {

            this.$scope.activeSlide = currentSlide;
        }
    }, {
        key: 'stopAutoPlay',
        value: function stopAutoPlay() {

            this.$interval.cancel(this.sliderInterval);
        }
    }, {
        key: 'decodeLastLogin',
        value: function decodeLastLogin(value) {

            if (value) {

                try {

                    return JSON.parse(this.Util.base64decode(value));
                } catch (err) {

                    var encodedLastLogin = this.Util.base64encode(value);
                    localStorage.setItem('lastLogin', encodedLastLogin);
                    return JSON.parse(value);
                }
            }

            return null;
        }
    }]);

    return Login;
}();

_serviceDependencies.push(Login);

angular.module('controllers').controller('Login', _serviceDependencies);

/***/ }),

/***/ "POGy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _repositories = __webpack_require__("lSlM");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var processedAppPrices = [];
var observableProcessedAppPrices = new Rx.BehaviorSubject(processedAppPrices);

/**
* @ngdoc service
* @name processors.AppPricesProcessor
*
* @description
* This class is used to process app prices.
*/
var AppPricesProcessor = {
    onNextAppPrices: function onNextAppPrices(data) {

        processedAppPrices = data;
    },
    onNextPromotions: function onNextPromotions(data) {

        processedAppPrices = [].concat(_toConsumableArray(_repositories.AppPricesRepository.getAll()));

        if (processedAppPrices.length > 0) {

            processedAppPrices.forEach(function (appPrice) {

                var currentPromotion = data.find(function (promotion) {
                    return promotion.price_id === appPrice.id;
                });

                if (currentPromotion && currentPromotion.attributes.discount > 0) {

                    appPrice.attributes.promotion = currentPromotion.attributes;
                }
            });
        }

        observableProcessedAppPrices.onNext(processedAppPrices);
    },
    getAll: function getAll() {

        return processedAppPrices;
    },
    getSinglePrice: function getSinglePrice(dataId, runtime, devices) {

        return processedAppPrices.find(function (_appPrice) {
            return String(_appPrice.id) === String(dataId + '_' + runtime + '_' + devices);
        });
    },
    getObservable: function getObservable() {

        return observableProcessedAppPrices;
    }
};

var subjectAppPricesRepository = _repositories.AppPricesRepository.getObservable();
subjectAppPricesRepository.subscribe(function (data) {
    return AppPricesProcessor.onNextAppPrices(data);
}, function () {}, function () {});

var subjectFlexiblePromotionsRepository = _repositories.FlexiblePromotionsRepository.getObservable();
subjectFlexiblePromotionsRepository.subscribe(function (data) {
    return AppPricesProcessor.onNextPromotions(data);
}, function () {}, function () {});

exports.default = AppPricesProcessor;

/***/ }),

/***/ "PONE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("BrLi");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("18Q0");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _devices = [];
var observableDevices = new Rx.BehaviorSubject(_devices);

/**
 * @ngdoc service
 * @name repositories.DevicesRepository
 *
 * @description
 * This class is used to save/add devices objects.
 */
var DevicesRepository = {

    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#replace
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored devices with provided data.
     *
     * @param {Array} data An array with new devices.
     */
    replace: function replace(data) {

        _devices = (data || []).filter(function (device) {

            if (String(_RFCUtil2.default.deepFind(device, 'relationships.user.data.id')) === String(_index.MeRepository.getMyId())) {

                return device;
            }

            return false;
        });
        observableDevices.onNext(_devices);
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#add
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to add a new device to repository.
     *
     * @param {object} device An device object.
     */
    add: function add(device) {

        if (String(_RFCUtil2.default.deepFind(device, 'relationships.user.data.id')) === String(_index.MeRepository.getMyId())) {

            var indexOfDevice = _devices.findIndex(function (_device) {
                return String(_device.id) === String(device.id);
            });

            if (indexOfDevice === -1) {

                _RFC4.default.processCreate(device);

                _devices.push(device);
                observableDevices.onNext(_devices);
            }
        }
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#remove
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to remove a device from repository.
     *
     * @param {integer} deviceId Id of device to be removed.
     */
    remove: function remove(deviceId) {

        var indexOfDevice = _devices.findIndex(function (_device) {
            return String(_device.id) === String(deviceId);
        });

        if (indexOfDevice >= 0) {

            _devices.splice(indexOfDevice, 1);
            observableDevices.onNext(_devices);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#update
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to update a device from repository.
     *
     * @param {object} device a device object with new values.
     */
    update: function update(device) {

        if (String(_RFCUtil2.default.deepFind(device, 'relationships.user.data.id')) === String(_index.MeRepository.getMyId())) {

            var indexOfDevice = _devices.findIndex(function (_device) {
                return String(_device.id) === String(device.id);
            });

            if (indexOfDevice >= 0) {

                var flattenDiff = _RFC2.default.getFlattenDiff(_devices[indexOfDevice], device);
                _RFC4.default.processUpdate(flattenDiff, _devices[indexOfDevice], device);

                if (!angular.equals(flattenDiff, {})) {

                    _devices[indexOfDevice] = device;
                    observableDevices.onNext(_devices);
                }
            }
        }
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#isDeviceCompatibleWithIntegration
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function checks if an integration can be installed on a specified device.
     *
     * @param {int} deviceId id of device
     * @param {string} appIntegrationId id of integration
     *
     * @returns {boolean} True if the device is compatible with the integration; false otherwise
     */
    isDeviceCompatibleWithIntegration: function isDeviceCompatibleWithIntegration(deviceId, appIntegrationId) {

        var integrationDetails = _index.AppIntegrationsRepository.getById(appIntegrationId);
        var deviceDetails = this.getById(deviceId);

        /* check deviceType */
        var supportedDeviceTypes = _RFCUtil2.default.deepFind(integrationDetails, 'attributes.custom.manifest.devices') || [];
        if (supportedDeviceTypes.indexOf(deviceDetails.attributes.type) === -1) {

            return false;
        }

        /* check device OS */
        var supportedOS = _RFCUtil2.default.deepFind(integrationDetails, 'attributes.custom.manifest.os') || [];
        if (supportedOS.indexOf(deviceDetails.attributes.os) === -1) {

            return false;
        }

        return true;
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#isMobile
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function checks if a device is phone or tablet.
     *
     * @param {int} deviceId id of device
     *
     * @returns {boolean} True if the device is tablet or phone.
     */
    isMobile: function isMobile(deviceId) {

        var deviceDetails = this.getById(deviceId);

        if (deviceDetails) {

            return deviceDetails.attributes.type === 'phone' || deviceDetails.attributes.type === 'tablet';
        }

        return false;
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#isVisible
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function checks if a device is visible.
     *
     * @param {Object} device device object
     *
     * @returns {boolean} True if the device is visible.
     */
    isVisible: function isVisible(device) {

        return device && (device.attributes.state === 'online' || device.attributes.state === 'offline') && !device.attributes.hidden;
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getAll
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all devices from repository.
     *
     * @returns {Array} devices all devices from repository
     */
    getAll: function getAll() {

        return _devices;
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getById
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to retrieves a device based on specified id.
     *
     * @param {integer} deviceId id of device
     *
     * @returns {object} a device based on specified id
     */
    getById: function getById(deviceId) {

        return _devices.find(function (device) {
            return String(device.id) === String(deviceId);
        });
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getByStatus
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to retrieve devices with specified state.
     *
     * @param {Array} stateList array with device states.
     * @param {boolean} [includeHidden=true]  if true return also hidden devices
     *
     * @returns {Array} an array with devices filtered by state.
     */
    getByState: function getByState(stateList) {
        var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


        return _devices.filter(function (device) {

            if (stateList.indexOf(device.attributes.state) > -1) {

                if (!includeHidden && device.attributes.hidden) {

                    return false;
                }

                return device;
            }

            return false;
        });
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getObservable
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for devices repository.
     * @returns {Object} an observable object for devices repository.
     */
    getObservable: function getObservable() {

        return observableDevices;
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getDevicesByState
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function returns all devices by state online/offline
     *
     * @param {String} state online/offline
     *
     * @returns {Array} returns devices list.
     */
    getDevicesByState: function getDevicesByState(state) {

        return _devices.filter(function (device) {
            return device.attributes.state === state && device.attributes.hidden === false;
        });
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getVisibleDevices
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function returns all visible devices.
     *
     * @returns {Array} returns visible devices list.
     */
    getVisibleDevices: function getVisibleDevices() {

        return _devices.filter(function (device) {
            return device.attributes.hidden === false && device.attributes.state !== 'pending';
        });
    },


    /**
     * @ngdoc function
     * @name repositories.DevicesRepository#getDevicesByOs
     * @methodOf repositories.DevicesRepository
     * @function
     *
     * @description
     * This function returns all devices for a specifc OS.
     *
     * @param {String} os device OS.
     *
     * @returns {Array} returns filtered devices.
     */
    getDevicesByOs: function getDevicesByOs(os) {

        return _devices.filter(function (device) {
            return device.attributes.os === os && device.attributes.hidden === false && device.attributes.state !== 'pending';
        });
    }
};

exports.default = DevicesRepository;

/***/ }),

/***/ "PTny":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var DATE_MAX_YEAR, DATE_MIN_YEAR, DATE_SPLITS, GRAPHS, L33T_TABLE, RANKED_DICTIONARIES, REGEXEN, adjacency_graphs, build_ranked_dict, frequency_lists, lst, matching, name, scoring;

frequency_lists = __webpack_require__("4fhk");

adjacency_graphs = __webpack_require__("NQhb");

scoring = __webpack_require__("IDO2");

build_ranked_dict = function(ordered_list) {
  var i, len1, o, result, word;
  result = {};
  i = 1;
  for (o = 0, len1 = ordered_list.length; o < len1; o++) {
    word = ordered_list[o];
    result[word] = i;
    i += 1;
  }
  return result;
};

RANKED_DICTIONARIES = {};

for (name in frequency_lists) {
  lst = frequency_lists[name];
  RANKED_DICTIONARIES[name] = build_ranked_dict(lst);
}

GRAPHS = {
  qwerty: adjacency_graphs.qwerty,
  dvorak: adjacency_graphs.dvorak,
  keypad: adjacency_graphs.keypad,
  mac_keypad: adjacency_graphs.mac_keypad
};

L33T_TABLE = {
  a: ['4', '@'],
  b: ['8'],
  c: ['(', '{', '[', '<'],
  e: ['3'],
  g: ['6', '9'],
  i: ['1', '!', '|'],
  l: ['1', '|', '7'],
  o: ['0'],
  s: ['$', '5'],
  t: ['+', '7'],
  x: ['%'],
  z: ['2']
};

REGEXEN = {
  recent_year: /19\d\d|200\d|201\d/g
};

DATE_MAX_YEAR = 2050;

DATE_MIN_YEAR = 1000;

DATE_SPLITS = {
  4: [[1, 2], [2, 3]],
  5: [[1, 3], [2, 3]],
  6: [[1, 2], [2, 4], [4, 5]],
  7: [[1, 3], [2, 3], [4, 5], [4, 6]],
  8: [[2, 4], [4, 6]]
};

matching = {
  empty: function(obj) {
    var k;
    return ((function() {
      var results;
      results = [];
      for (k in obj) {
        results.push(k);
      }
      return results;
    })()).length === 0;
  },
  extend: function(lst, lst2) {
    return lst.push.apply(lst, lst2);
  },
  translate: function(string, chr_map) {
    var chr;
    return ((function() {
      var len1, o, ref, results;
      ref = string.split('');
      results = [];
      for (o = 0, len1 = ref.length; o < len1; o++) {
        chr = ref[o];
        results.push(chr_map[chr] || chr);
      }
      return results;
    })()).join('');
  },
  mod: function(n, m) {
    return ((n % m) + m) % m;
  },
  sorted: function(matches) {
    return matches.sort(function(m1, m2) {
      return (m1.i - m2.i) || (m1.j - m2.j);
    });
  },
  omnimatch: function(password) {
    var len1, matcher, matchers, matches, o;
    matches = [];
    matchers = [this.dictionary_match, this.reverse_dictionary_match, this.l33t_match, this.spatial_match, this.repeat_match, this.sequence_match, this.regex_match, this.date_match];
    for (o = 0, len1 = matchers.length; o < len1; o++) {
      matcher = matchers[o];
      this.extend(matches, matcher.call(this, password));
    }
    return this.sorted(matches);
  },
  dictionary_match: function(password, _ranked_dictionaries) {
    var dictionary_name, i, j, len, matches, o, p, password_lower, rank, ranked_dict, ref, ref1, ref2, word;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    matches = [];
    len = password.length;
    password_lower = password.toLowerCase();
    for (dictionary_name in _ranked_dictionaries) {
      ranked_dict = _ranked_dictionaries[dictionary_name];
      for (i = o = 0, ref = len; 0 <= ref ? o < ref : o > ref; i = 0 <= ref ? ++o : --o) {
        for (j = p = ref1 = i, ref2 = len; ref1 <= ref2 ? p < ref2 : p > ref2; j = ref1 <= ref2 ? ++p : --p) {
          if (password_lower.slice(i, +j + 1 || 9e9) in ranked_dict) {
            word = password_lower.slice(i, +j + 1 || 9e9);
            rank = ranked_dict[word];
            matches.push({
              pattern: 'dictionary',
              i: i,
              j: j,
              token: password.slice(i, +j + 1 || 9e9),
              matched_word: word,
              rank: rank,
              dictionary_name: dictionary_name,
              reversed: false,
              l33t: false
            });
          }
        }
      }
    }
    return this.sorted(matches);
  },
  reverse_dictionary_match: function(password, _ranked_dictionaries) {
    var len1, match, matches, o, ref, reversed_password;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    reversed_password = password.split('').reverse().join('');
    matches = this.dictionary_match(reversed_password, _ranked_dictionaries);
    for (o = 0, len1 = matches.length; o < len1; o++) {
      match = matches[o];
      match.token = match.token.split('').reverse().join('');
      match.reversed = true;
      ref = [password.length - 1 - match.j, password.length - 1 - match.i], match.i = ref[0], match.j = ref[1];
    }
    return this.sorted(matches);
  },
  set_user_input_dictionary: function(ordered_list) {
    return RANKED_DICTIONARIES['user_inputs'] = build_ranked_dict(ordered_list.slice());
  },
  relevant_l33t_subtable: function(password, table) {
    var chr, len1, letter, o, password_chars, ref, relevant_subs, sub, subs, subtable;
    password_chars = {};
    ref = password.split('');
    for (o = 0, len1 = ref.length; o < len1; o++) {
      chr = ref[o];
      password_chars[chr] = true;
    }
    subtable = {};
    for (letter in table) {
      subs = table[letter];
      relevant_subs = (function() {
        var len2, p, results;
        results = [];
        for (p = 0, len2 = subs.length; p < len2; p++) {
          sub = subs[p];
          if (sub in password_chars) {
            results.push(sub);
          }
        }
        return results;
      })();
      if (relevant_subs.length > 0) {
        subtable[letter] = relevant_subs;
      }
    }
    return subtable;
  },
  enumerate_l33t_subs: function(table) {
    var chr, dedup, helper, k, keys, l33t_chr, len1, len2, o, p, ref, sub, sub_dict, sub_dicts, subs;
    keys = (function() {
      var results;
      results = [];
      for (k in table) {
        results.push(k);
      }
      return results;
    })();
    subs = [[]];
    dedup = function(subs) {
      var assoc, deduped, label, len1, members, o, sub, v;
      deduped = [];
      members = {};
      for (o = 0, len1 = subs.length; o < len1; o++) {
        sub = subs[o];
        assoc = (function() {
          var len2, p, results;
          results = [];
          for (v = p = 0, len2 = sub.length; p < len2; v = ++p) {
            k = sub[v];
            results.push([k, v]);
          }
          return results;
        })();
        assoc.sort();
        label = ((function() {
          var len2, p, results;
          results = [];
          for (v = p = 0, len2 = assoc.length; p < len2; v = ++p) {
            k = assoc[v];
            results.push(k + ',' + v);
          }
          return results;
        })()).join('-');
        if (!(label in members)) {
          members[label] = true;
          deduped.push(sub);
        }
      }
      return deduped;
    };
    helper = function(keys) {
      var dup_l33t_index, first_key, i, l33t_chr, len1, len2, next_subs, o, p, q, ref, ref1, rest_keys, sub, sub_alternative, sub_extension;
      if (!keys.length) {
        return;
      }
      first_key = keys[0];
      rest_keys = keys.slice(1);
      next_subs = [];
      ref = table[first_key];
      for (o = 0, len1 = ref.length; o < len1; o++) {
        l33t_chr = ref[o];
        for (p = 0, len2 = subs.length; p < len2; p++) {
          sub = subs[p];
          dup_l33t_index = -1;
          for (i = q = 0, ref1 = sub.length; 0 <= ref1 ? q < ref1 : q > ref1; i = 0 <= ref1 ? ++q : --q) {
            if (sub[i][0] === l33t_chr) {
              dup_l33t_index = i;
              break;
            }
          }
          if (dup_l33t_index === -1) {
            sub_extension = sub.concat([[l33t_chr, first_key]]);
            next_subs.push(sub_extension);
          } else {
            sub_alternative = sub.slice(0);
            sub_alternative.splice(dup_l33t_index, 1);
            sub_alternative.push([l33t_chr, first_key]);
            next_subs.push(sub);
            next_subs.push(sub_alternative);
          }
        }
      }
      subs = dedup(next_subs);
      return helper(rest_keys);
    };
    helper(keys);
    sub_dicts = [];
    for (o = 0, len1 = subs.length; o < len1; o++) {
      sub = subs[o];
      sub_dict = {};
      for (p = 0, len2 = sub.length; p < len2; p++) {
        ref = sub[p], l33t_chr = ref[0], chr = ref[1];
        sub_dict[l33t_chr] = chr;
      }
      sub_dicts.push(sub_dict);
    }
    return sub_dicts;
  },
  l33t_match: function(password, _ranked_dictionaries, _l33t_table) {
    var chr, k, len1, len2, match, match_sub, matches, o, p, ref, ref1, sub, subbed_chr, subbed_password, token, v;
    if (_ranked_dictionaries == null) {
      _ranked_dictionaries = RANKED_DICTIONARIES;
    }
    if (_l33t_table == null) {
      _l33t_table = L33T_TABLE;
    }
    matches = [];
    ref = this.enumerate_l33t_subs(this.relevant_l33t_subtable(password, _l33t_table));
    for (o = 0, len1 = ref.length; o < len1; o++) {
      sub = ref[o];
      if (this.empty(sub)) {
        break;
      }
      subbed_password = this.translate(password, sub);
      ref1 = this.dictionary_match(subbed_password, _ranked_dictionaries);
      for (p = 0, len2 = ref1.length; p < len2; p++) {
        match = ref1[p];
        token = password.slice(match.i, +match.j + 1 || 9e9);
        if (token.toLowerCase() === match.matched_word) {
          continue;
        }
        match_sub = {};
        for (subbed_chr in sub) {
          chr = sub[subbed_chr];
          if (token.indexOf(subbed_chr) !== -1) {
            match_sub[subbed_chr] = chr;
          }
        }
        match.l33t = true;
        match.token = token;
        match.sub = match_sub;
        match.sub_display = ((function() {
          var results;
          results = [];
          for (k in match_sub) {
            v = match_sub[k];
            results.push(k + " -> " + v);
          }
          return results;
        })()).join(', ');
        matches.push(match);
      }
    }
    return this.sorted(matches.filter(function(match) {
      return match.token.length > 1;
    }));
  },
  spatial_match: function(password, _graphs) {
    var graph, graph_name, matches;
    if (_graphs == null) {
      _graphs = GRAPHS;
    }
    matches = [];
    for (graph_name in _graphs) {
      graph = _graphs[graph_name];
      this.extend(matches, this.spatial_match_helper(password, graph, graph_name));
    }
    return this.sorted(matches);
  },
  SHIFTED_RX: /[~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?]/,
  spatial_match_helper: function(password, graph, graph_name) {
    var adj, adjacents, cur_char, cur_direction, found, found_direction, i, j, last_direction, len1, matches, o, prev_char, shifted_count, turns;
    matches = [];
    i = 0;
    while (i < password.length - 1) {
      j = i + 1;
      last_direction = null;
      turns = 0;
      if ((graph_name === 'qwerty' || graph_name === 'dvorak') && this.SHIFTED_RX.exec(password.charAt(i))) {
        shifted_count = 1;
      } else {
        shifted_count = 0;
      }
      while (true) {
        prev_char = password.charAt(j - 1);
        found = false;
        found_direction = -1;
        cur_direction = -1;
        adjacents = graph[prev_char] || [];
        if (j < password.length) {
          cur_char = password.charAt(j);
          for (o = 0, len1 = adjacents.length; o < len1; o++) {
            adj = adjacents[o];
            cur_direction += 1;
            if (adj && adj.indexOf(cur_char) !== -1) {
              found = true;
              found_direction = cur_direction;
              if (adj.indexOf(cur_char) === 1) {
                shifted_count += 1;
              }
              if (last_direction !== found_direction) {
                turns += 1;
                last_direction = found_direction;
              }
              break;
            }
          }
        }
        if (found) {
          j += 1;
        } else {
          if (j - i > 2) {
            matches.push({
              pattern: 'spatial',
              i: i,
              j: j - 1,
              token: password.slice(i, j),
              graph: graph_name,
              turns: turns,
              shifted_count: shifted_count
            });
          }
          i = j;
          break;
        }
      }
    }
    return matches;
  },
  repeat_match: function(password) {
    var base_analysis, base_guesses, base_matches, base_token, greedy, greedy_match, i, j, lastIndex, lazy, lazy_anchored, lazy_match, match, matches, ref;
    matches = [];
    greedy = /(.+)\1+/g;
    lazy = /(.+?)\1+/g;
    lazy_anchored = /^(.+?)\1+$/;
    lastIndex = 0;
    while (lastIndex < password.length) {
      greedy.lastIndex = lazy.lastIndex = lastIndex;
      greedy_match = greedy.exec(password);
      lazy_match = lazy.exec(password);
      if (greedy_match == null) {
        break;
      }
      if (greedy_match[0].length > lazy_match[0].length) {
        match = greedy_match;
        base_token = lazy_anchored.exec(match[0])[1];
      } else {
        match = lazy_match;
        base_token = match[1];
      }
      ref = [match.index, match.index + match[0].length - 1], i = ref[0], j = ref[1];
      base_analysis = scoring.most_guessable_match_sequence(base_token, this.omnimatch(base_token));
      base_matches = base_analysis.sequence;
      base_guesses = base_analysis.guesses;
      matches.push({
        pattern: 'repeat',
        i: i,
        j: j,
        token: match[0],
        base_token: base_token,
        base_guesses: base_guesses,
        base_matches: base_matches,
        repeat_count: match[0].length / base_token.length
      });
      lastIndex = j + 1;
    }
    return matches;
  },
  MAX_DELTA: 5,
  sequence_match: function(password) {
    var delta, i, j, k, last_delta, o, ref, result, update;
    if (password.length === 1) {
      return [];
    }
    update = (function(_this) {
      return function(i, j, delta) {
        var ref, sequence_name, sequence_space, token;
        if (j - i > 1 || Math.abs(delta) === 1) {
          if ((0 < (ref = Math.abs(delta)) && ref <= _this.MAX_DELTA)) {
            token = password.slice(i, +j + 1 || 9e9);
            if (/^[a-z]+$/.test(token)) {
              sequence_name = 'lower';
              sequence_space = 26;
            } else if (/^[A-Z]+$/.test(token)) {
              sequence_name = 'upper';
              sequence_space = 26;
            } else if (/^\d+$/.test(token)) {
              sequence_name = 'digits';
              sequence_space = 10;
            } else {
              sequence_name = 'unicode';
              sequence_space = 26;
            }
            return result.push({
              pattern: 'sequence',
              i: i,
              j: j,
              token: password.slice(i, +j + 1 || 9e9),
              sequence_name: sequence_name,
              sequence_space: sequence_space,
              ascending: delta > 0
            });
          }
        }
      };
    })(this);
    result = [];
    i = 0;
    last_delta = null;
    for (k = o = 1, ref = password.length; 1 <= ref ? o < ref : o > ref; k = 1 <= ref ? ++o : --o) {
      delta = password.charCodeAt(k) - password.charCodeAt(k - 1);
      if (last_delta == null) {
        last_delta = delta;
      }
      if (delta === last_delta) {
        continue;
      }
      j = k - 1;
      update(i, j, last_delta);
      i = j;
      last_delta = delta;
    }
    update(i, password.length - 1, last_delta);
    return result;
  },
  regex_match: function(password, _regexen) {
    var matches, regex, rx_match, token;
    if (_regexen == null) {
      _regexen = REGEXEN;
    }
    matches = [];
    for (name in _regexen) {
      regex = _regexen[name];
      regex.lastIndex = 0;
      while (rx_match = regex.exec(password)) {
        token = rx_match[0];
        matches.push({
          pattern: 'regex',
          token: token,
          i: rx_match.index,
          j: rx_match.index + rx_match[0].length - 1,
          regex_name: name,
          regex_match: rx_match
        });
      }
    }
    return this.sorted(matches);
  },
  date_match: function(password) {
    var best_candidate, candidate, candidates, distance, dmy, i, j, k, l, len1, len2, matches, maybe_date_no_separator, maybe_date_with_separator, metric, min_distance, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rx_match, s, t, token;
    matches = [];
    maybe_date_no_separator = /^\d{4,8}$/;
    maybe_date_with_separator = /^(\d{1,4})([\s\/\\_.-])(\d{1,2})\2(\d{1,4})$/;
    for (i = o = 0, ref = password.length - 4; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o) {
      for (j = p = ref1 = i + 3, ref2 = i + 7; ref1 <= ref2 ? p <= ref2 : p >= ref2; j = ref1 <= ref2 ? ++p : --p) {
        if (j >= password.length) {
          break;
        }
        token = password.slice(i, +j + 1 || 9e9);
        if (!maybe_date_no_separator.exec(token)) {
          continue;
        }
        candidates = [];
        ref3 = DATE_SPLITS[token.length];
        for (q = 0, len1 = ref3.length; q < len1; q++) {
          ref4 = ref3[q], k = ref4[0], l = ref4[1];
          dmy = this.map_ints_to_dmy([parseInt(token.slice(0, k)), parseInt(token.slice(k, l)), parseInt(token.slice(l))]);
          if (dmy != null) {
            candidates.push(dmy);
          }
        }
        if (!(candidates.length > 0)) {
          continue;
        }
        best_candidate = candidates[0];
        metric = function(candidate) {
          return Math.abs(candidate.year - scoring.REFERENCE_YEAR);
        };
        min_distance = metric(candidates[0]);
        ref5 = candidates.slice(1);
        for (r = 0, len2 = ref5.length; r < len2; r++) {
          candidate = ref5[r];
          distance = metric(candidate);
          if (distance < min_distance) {
            ref6 = [candidate, distance], best_candidate = ref6[0], min_distance = ref6[1];
          }
        }
        matches.push({
          pattern: 'date',
          token: token,
          i: i,
          j: j,
          separator: '',
          year: best_candidate.year,
          month: best_candidate.month,
          day: best_candidate.day
        });
      }
    }
    for (i = s = 0, ref7 = password.length - 6; 0 <= ref7 ? s <= ref7 : s >= ref7; i = 0 <= ref7 ? ++s : --s) {
      for (j = t = ref8 = i + 5, ref9 = i + 9; ref8 <= ref9 ? t <= ref9 : t >= ref9; j = ref8 <= ref9 ? ++t : --t) {
        if (j >= password.length) {
          break;
        }
        token = password.slice(i, +j + 1 || 9e9);
        rx_match = maybe_date_with_separator.exec(token);
        if (rx_match == null) {
          continue;
        }
        dmy = this.map_ints_to_dmy([parseInt(rx_match[1]), parseInt(rx_match[3]), parseInt(rx_match[4])]);
        if (dmy == null) {
          continue;
        }
        matches.push({
          pattern: 'date',
          token: token,
          i: i,
          j: j,
          separator: rx_match[2],
          year: dmy.year,
          month: dmy.month,
          day: dmy.day
        });
      }
    }
    return this.sorted(matches.filter(function(match) {
      var is_submatch, len3, other_match, u;
      is_submatch = false;
      for (u = 0, len3 = matches.length; u < len3; u++) {
        other_match = matches[u];
        if (match === other_match) {
          continue;
        }
        if (other_match.i <= match.i && other_match.j >= match.j) {
          is_submatch = true;
          break;
        }
      }
      return !is_submatch;
    }));
  },
  map_ints_to_dmy: function(ints) {
    var dm, int, len1, len2, len3, o, over_12, over_31, p, possible_year_splits, q, ref, ref1, rest, under_1, y;
    if (ints[1] > 31 || ints[1] <= 0) {
      return;
    }
    over_12 = 0;
    over_31 = 0;
    under_1 = 0;
    for (o = 0, len1 = ints.length; o < len1; o++) {
      int = ints[o];
      if ((99 < int && int < DATE_MIN_YEAR) || int > DATE_MAX_YEAR) {
        return;
      }
      if (int > 31) {
        over_31 += 1;
      }
      if (int > 12) {
        over_12 += 1;
      }
      if (int <= 0) {
        under_1 += 1;
      }
    }
    if (over_31 >= 2 || over_12 === 3 || under_1 >= 2) {
      return;
    }
    possible_year_splits = [[ints[2], ints.slice(0, 2)], [ints[0], ints.slice(1, 3)]];
    for (p = 0, len2 = possible_year_splits.length; p < len2; p++) {
      ref = possible_year_splits[p], y = ref[0], rest = ref[1];
      if ((DATE_MIN_YEAR <= y && y <= DATE_MAX_YEAR)) {
        dm = this.map_ints_to_dm(rest);
        if (dm != null) {
          return {
            year: y,
            month: dm.month,
            day: dm.day
          };
        } else {
          return;
        }
      }
    }
    for (q = 0, len3 = possible_year_splits.length; q < len3; q++) {
      ref1 = possible_year_splits[q], y = ref1[0], rest = ref1[1];
      dm = this.map_ints_to_dm(rest);
      if (dm != null) {
        y = this.two_to_four_digit_year(y);
        return {
          year: y,
          month: dm.month,
          day: dm.day
        };
      }
    }
  },
  map_ints_to_dm: function(ints) {
    var d, len1, m, o, ref, ref1;
    ref = [ints, ints.slice().reverse()];
    for (o = 0, len1 = ref.length; o < len1; o++) {
      ref1 = ref[o], d = ref1[0], m = ref1[1];
      if ((1 <= d && d <= 31) && (1 <= m && m <= 12)) {
        return {
          day: d,
          month: m
        };
      }
    }
  },
  two_to_four_digit_year: function(year) {
    if (year > 99) {
      return year;
    } else if (year > 50) {
      return year + 1900;
    } else {
      return year + 2000;
    }
  }
};

module.exports = matching;

//# sourceMappingURL=matching.js.map


/***/ }),

/***/ "Pohv":
/***/ (function(module, exports) {

module.exports = "<news-tabs></news-tabs>\n<div class=\"news-container article-view\">\n    <div class='article-body article-card' connectwebqa=\"guides-news/{{currentCategory}}-article-card\">\n        <div ng-if=\"isLoading === true\" class=\"main-loader\"><i></i></div>\n        <div class=\"text-center mb25\">\n            <h1 connectwebqa=\"guides-news/{{currentCategory}}-article-title\">\n                <strong ng-bind-html=\"currentArticle.title.rendered\"></strong>\n            </h1>\n            <div class=\"details\">\n                <span \n                    class='inline-block v-middle'\n                    translate=\"cw.news.article_view.details\"\n                    translate-values=\"{\n                        date: '{{currentArticle.date}}',\n                        minutes: '{{timeToRead}}',\n                        author: '{{currentArticle._embedded.author[0].name}}',\n                        category: currentCategoryName }\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-time-author\">\n                </span>\n\n                <span class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-empty' \n                    ng-if=\"bookmarkStatus === false\" \n                    ng-click=\"ArticleCtrl.saveArticle(articleId)\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-empty-heart\"></span>\n                <span class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-filled-blue' \n                    ng-if=\"bookmarkStatus === true\" \n                    ng-click=\"ArticleCtrl.removeArticle(articleId)\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-filled-heart\"></span>\n            </div>\n        </div>\n        <div class=\"placeholder\">\n            <img ng-if=\"currentArticle._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url\" src=\"{{currentArticle._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url}}\"\n                connectwebqa=\"guides-news/{{currentCategory}}-article-image\">\n\n            <img ng-if=\"!currentArticle._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url\" src=\"{{currentArticle._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url}}\"\n                connectwebqa=\"guides-news/{{currentCategory}}-article-image\">\n        </div>\n\n        <div class=\"content\" ng-bind-html=\"trustedHtmlContent\" connectwebqa=\"guides-news/{{currentCategory}}-article-content\"></div>\n    </div>\n</div>\n"

/***/ }),

/***/ "Pqwy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var eventDebugger = {

    events: [],
    addEvent: function addEvent(ev) {

        this.events.push(ev);
        if (this.events.length > CWCONFIG.debug.eventStackSize) {

            this.events = this.events.slice(-CWCONFIG.debug.eventStackSize);
        }
    },
    getEvents: function getEvents() {

        return this.events;
    }
};

exports.default = eventDebugger;

/***/ }),

/***/ "Psd9":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{\n    'reactivate-license': showReactivateLogin\n}\">\n    <div class=\"text-center mt15 plr20 reactivate-license-header\" ng-if=\"showReactivateLogin\">\n        <h1 class=\"mb5\" translate=\"cw.auth.reactivate_license.title\"></h1>\n        <p class=\"text-grey-3 text-xl\" translate=\"cw.auth.reactivate_license.description\"></p>\n    </div>\n\n    <div class=\"main-auth\" ng-class=\"{'two-columns-auth' : showCustomAuth }\">\n        <div class=\"auth-region auth-form-tabs\">\n\n            <!-- SSO SKIP -->\n            <div ng-if=\"showSkipButton || showCloseButton\" class=\"auth-sso-header\">\n                <div class=\"sso-move\" ng-if=\"showCloseButton\" onmousedown=\"window.external.Execute('aoe://Move')\"></div>\n                <div ng-if=\"showSkipButton\" class=\"sso-skip\" ng-click=\"oauthCtrl.skip()\">\n                    <i class=\"icon icon-back icon-grey-4 icon-xxs fl-left\"></i>\n                    <a class=\"text-m text-grey-4 fl-left ml10\" translate=\"cw.general.ui.back\"></a>\n                </div>\n                <div class=\"sso-logo centerMiddle\"></div>\n                <div ng-if=\"showCloseButton\" class=\"sso-close\">\n                    <a class=\"text-m text-grey-4 fl-right\" href=\"aoe://close\">\n                        <i class=\"icon icon-close3 icon-grey-4 icon-xxs fl-right ml10\"></i>\n                        <span class=\"text-m text-grey-4 fl-right\" translate=\"cw.general.ui.close\"></span>\n                    </a>\n                </div>\n            </div>\n            <!-- end -->\n\n            <div class=\"right fixed\">\n                <a ng-if=\"!showSkipButton && !showCloseButton\" ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n                    <i class=\"sprite sprite-logo\"></i>\n                    <h1>{{State.partner.name}}</h1>\n                </a>\n                <ul class=\"auth-tabs\" ng-if=\"!$root.socialLoginValidation\">\n                    <li class=\"fl-left active\" connectqa-auth-tab=\"register\">\n                        <span translate=\"cw.auth.login.create_account\"></span>\n                    </li>\n                    <li class=\"fl-right\" ui-sref=\"root.auth.login\" connectqa-auth-tab=\"login\">\n                        <span translate=\"cw.auth.login_label\"></span>\n                    </li>\n                </ul>\n\n                <div class=\"form-wrapper auth-nopadding-left-right\">\n\n                    <div class=\"auth-padding60-left-right\">\n\n                        <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                            <change-language ng-if=\"showChangeLang\"></change-language>\n                        </h3>\n\n                        <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': oauthCtrl.Auth.error && submitted}\">\n                            <h5 class=\"text-m text-red-2\" id=\"error-message-form\" ng-if=\"oauthCtrl.Auth.error && submitted\"\n                                connectqa-register=\"existing-account-error-message\">\n                                <span translate=\"cw.auth.register.error.email_exists\" translate-compile></span>\n                            </h5>\n                        </div>\n                        <div ng-if=\"showSocialLogin && $root.registerActiveStep === '1' && !$root.socialLoginValidation\">\n                            <div class=\"mb20\">\n                                <a ng-if=\"fb.feature\" ng-click=\"fb.authenticate('Register')\" class=\"button-scm fb-nd text-m\"\n                                    ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'facebook'}\"\n                                    connectqa-register=\"login-with-facebook\"><i></i><em>Facebook</em></a>\n\n                                <a ng-if=\"gplus.feature\" ng-click=\"gplus.authenticate('Register')\"\n                                    class=\"button-scm gp-nd text-m\"\n                                    ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'google'}\"\n                                    connectqa-register=\"login-with-google\"><i></i><em>Google</em></a>\n\n                                <span class=\"inline-block p-relative w100 info-tooltip-holder\"\n                                    ng-show=\"appleID.feature && browserName !== 'ie'\">\n                                    <a ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'apple'}\"\n                                        ng-click=\"appleID.authenticate('Register')\" class=\"button-scm apple-nd text-m\"\n                                        connectqa-login=\"login-with-appleID\"><i></i><em>Apple ID</em></a>\n                                    <span class=\"info-tooltip-holder auth-btn-tooltip-holder\">\n                                        <span class=\"icon icon-info icon-grey-5 icon-xs\"></span>\n                                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\"\n                                            translate=\"cw.auth.apple_regitration_info\"\n                                            translate-values=\"{brandname : brandName}\"></div>\n                                    </span>\n                                </span>\n                            </div>\n\n                            <div ng-if=\"fb.feature || gplus.feature || (appleID.feature && browserName !== 'ie')\"\n                                class=\"mb5 text-m text-grey-4 text-medium uppercase\" translate=\"cw.form.or\"></div>\n                        </div>\n\n                        <div ng-if=\"showEmbeddedSocialLogin && $root.registerActiveStep === '1' && !$root.socialLoginValidation\">\n                            <a ng-click=\"oauthCtrl.socialLoginRedirect()\"\n                                class=\"btn btn-large btn-full-width spotlight-btn-secondary spotlight-social-login text-m\"\n                                connectqa-login=\"login-with-social\">\n                                <i class=\"fb\" ng-if=\"fb.feature\"></i>\n                                <i class=\"gp\" ng-if=\"gplus.feature\"></i>\n                                <i class=\"apl\" ng-show=\"appleID.feature\"></i>\n                                <em translate=\"cw.auth.login.continue_with\"></em>\n                            </a>\n\n                            <div class=\"mt10 mb5 text-m text-grey-4 text-medium uppercase\" translate=\"cw.form.or\"></div>\n                        </div>\n\n                        <div ng-if=\"$root.registerActiveStep === '2'\">\n                            <h2 class=\"mb20\" connectqa-register=\"almost-done\">\n                                <span translate=\"cw.general.almost_done\"></span><br>\n                                <span translate=\"cw.general.complete_info\"></span>\n                            </h2>\n                        </div>\n                        <form class=\"auth-form register-form\" name=\"registerForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.onSubmit()\"\n                            ng-show=\"!$root.socialLoginValidation\">\n\n                            <div ng-show=\"$root.registerActiveStep === '1'\">\n                                <div class=\"form-group\">\n                                    <input type=\"email\" spellcheck=\"false\" autocorrect=\"off\" autocomplete=\"off\"\n                                        autocapitalize=\"off\" ng-model=\"email\" name=\"email\" maxlength=\"100\"\n                                        autocomplete=\"off\" ng-class=\"{'error': registerForm.email.$invalid && firstStepSubmited}\"\n                                        id=\"email\" placeholder=\"{{ 'cw.form.email' | translate }}\" ng-pattern=\"emailRegExp\"\n                                        required connectqa-register=\"email-address\" ng-change=\"validateConfirmEnail()\" />\n\n                                    <label ng-hide=\"registerForm.email.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"email\" translate=\"cw.form.email\"></label>\n                                    <p class=\"error-message\" ng-show=\"registerForm.email.$invalid && firstStepSubmited\"\n                                        translate=\"cw.validator.messages.email\"\n                                        connectqa-register=\"empty-email-error-message\"></p>\n                                </div>\n\n                                <div class=\"form-group\">\n                                    <input type=\"email\" spellcheck=\"false\" autocorrect=\"off\" autocomplete=\"off\"\n                                        autocapitalize=\"off\" ng-model=\"confirmEmail\" name=\"confirmEmail\" maxlength=\"100\"\n                                        autocomplete=\"off\" ng-class=\"{'error': validateEmailError && firstStepSubmited}\"\n                                        id=\"confirm-email\" placeholder=\"{{ 'cw.general.confirm_email' | translate }}\" required\n                                        connectqa-register=\"confirm-email-address\"\n                                        ng-change=\"validateConfirmEnail()\" />\n\n                                    <label ng-hide=\"registerForm.confirmEmail.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"confirm-email\" translate=\"cw.general.confirm_email\">\n                                    </label>\n\n                                    <p ng-show=\"validateEmailError && firstStepSubmited\" class=\"error-message\" connectqa-register=\"confirm-email-address-error-message\" translate=\"cw.general.confirm_email_error\">\n                                    </p>\n                                </div>\n\n                                <div class=\"form-group\" ng-init=\"passwordFocus = false\" ng-init=\"pas = false\">\n                                    <input type=\"password\" ng-model=\"password\" name=\"password\"\n                                        ng-focus=\"passwordFocus = true\" ng-blur=\"passwordFocus = false\"\n                                        ng-class=\"{'error': (registerForm.password.$invalid || !oauthCtrl.passwordScore.valid) && firstStepSubmited}\"\n                                        maxlength=\"100\" autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.form.password' | translate }}\" ng-minlength=\"8\"\n                                        ng-keyup=\"oauthCtrl.getPasswordScore(registerForm.password.$viewValue)\"\n                                        id=\"password\" ng-pattern=\"passwordRegExp\" required\n                                        connectqa-register=\"password\" />\n\n                                    <label ng-hide=\"registerForm.password.$viewValue.length > 0\"\n                                        translate=\"cw.form.password\" for=\"password\" class=\"fallback-input\"></label>\n\n                                    <p class=\"error-message\"\n                                        ng-show=\"(registerForm.password.$error.required ||\n                                                (!oauthCtrl.passwordScore.valid && !registerForm.password.$viewValue)) && firstStepSubmited\"\n                                        translate=\"cw.validator.password.error.enter_password\"\n                                        connectqa-register=\"empty-password-error-message\"></p>\n\n                                    <p class=\"error-message\" ng-show=\"registerForm.password.$viewValue.length === 100\"\n                                        translate=\"cw.validator.messages.password.maximum_length\"\n                                        connectqa-register=\"password-too-long\"></p>\n\n                                    <span class=\"show-password\" ng-class=\"{'text': inputType === 'text'}\"\n                                        ng-click=\"oauthCtrl.showPassword()\" connectqa-register=\"show-password\">\n                                    </span>\n\n                                    <div ng-if=\"passwordFocus\" class=\"tooltip-input left\">\n                                        <password-strength passlength=\"registerForm.password.$viewValue.length\"\n                                            passpattern=\"registerForm.password.$valid\"\n                                            passwordscore=\"oauthCtrl.passwordScore\">\n                                        </password-strength>\n                                    </div>\n                                </div>\n                                <span class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                                    connectqa-register=\"register-next-button\"\n                                    ng-click=\"oauthCtrl.proceedToNextStep()\"\n                                    translate=\"cw.general.next\">\n                                </span>\n                            </div>\n\n                            <div ng-show=\"$root.registerActiveStep === '2'\">\n                                <div class=\"form-group\">\n                                    <input type=\"text\" ng-model=\"firstName\" name=\"firstName\" maxlength=\"100\"\n                                        ng-class=\"{'error': registerForm.firstName.$invalid && submitted}\" id=\"username\"\n                                        autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.form.profile.first_name' | translate }}\"\n                                        ng-pattern=\"firstNameRegExp\" required connectqa-register=\"first-name\" />\n\n                                    <label ng-hide=\"registerForm.firstName.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"username\" translate=\"cw.form.profile.first_name\"></label>\n                                    <p class=\"error-message\" ng-show=\"registerForm.firstName.$invalid && submitted\"\n                                        connectqa-register=\"first-name-error-message\" translate=\"cw.general.first_name_error\">\n                                    </p>\n                                </div>\n\n                                <div class=\"form-group\">\n                                    <input type=\"text\" ng-model=\"lastName\" name=\"lastName\" maxlength=\"100\"\n                                        ng-class=\"{'error': registerForm.lastName.$invalid && submitted}\" id=\"last-name\"\n                                        autocomplete=\"off\" placeholder=\"{{ 'cw.form.profile.last_name' | translate }}\" ng-pattern=\"lastNameRegExp\" required\n                                        connectqa-register=\"last-name\" />\n\n                                    <label ng-hide=\"registerForm.lastName.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"last-name\" translate=\"cw.form.profile.last_name\"></label>\n                                    <p class=\"error-message\" ng-show=\"registerForm.lastName.$invalid && submitted\"\n                                        connectqa-register=\"last-name-error-message\" translate=\"cw.general.last_name_error\">\n                                    </p>\n                                </div>\n\n                                <div class=\"form-group text-left\">\n                                    <div class=\"input-holder v-top w100\" connectqa-register=\"country\">\n                                        <ui-select class=\"\" ng-model=\"country\" theme=\"selectize\"\n                                            ng-change=\"validateCountry($select.selected)\"\n                                            ng-class=\"{'error': countryError}\">\n                                            <ui-select-match class=\"text-m\" placeholder=\"Country\">\n                                                <span data-ng-bind=\"$select.selected.name\"></span>\n                                            </ui-select-match>\n                                            <ui-select-choices class=\"text-m\" repeat=\"userCountry in countries | filterCountry : $select.search\">\n                                                <span class=\"text-m\" data-ng-bind=\"userCountry.name\"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <p class=\"error-message\" ng-show=\"countryError\" connectqa-register=\"country-error-message\"\n                                        translate=\"cw.general.country_error\">\n                                    </p>\n                                </div>\n\n                                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                                    ng-disabled=\"oauthCtrl.Auth.loading\" translate=\"cw.general.create_account\"\n                                    connectqa-register=\"register-button\">\n                                </button>\n                            </div>\n\n                        </form>\n                        <form class=\"auth-form\" name=\"registerFormSocialMedia\" role=\"form\" novalidate ng-submit=\"oauthCtrl.onSubmitSocialMedia()\"\n                            ng-show=\"$root.socialLoginValidation\">\n                            <h2 class=\"mb20\" connectqa-register=\"almost-done\">\n                                <span translate=\"cw.general.almost_done\"></span><br>\n                                <span translate=\"cw.general.complete_info\"></span>\n                            </h2>\n                            <div>\n                                <div class=\"form-group\">\n                                    <input type=\"text\" ng-model=\"firstName\" name=\"firstName\" maxlength=\"100\"\n                                        ng-class=\"{'error': registerFormSocialMedia.firstName.$invalid && socialMediaSubmitted}\" id=\"first-name\"\n                                        autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.form.profile.first_name' | translate }}\"\n                                        ng-pattern=\"firstNameRegExp\"\n                                        required connectqa-register=\"first-name-sm\" />\n\n                                    <label ng-hide=\"registerFormSocialMedia.firstName.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"first-name\" translate=\"cw.form.profile.first_name\"></label>\n                                    <p class=\"error-message\" ng-show=\"registerFormSocialMedia.firstName.$invalid && socialMediaSubmitted\"\n                                        connectqa-register=\"first-name-sm-error-message\" translate=\"cw.general.first_name_error\">\n                                    </p>\n                                </div>\n\n                                <div class=\"form-group\">\n                                    <input type=\"text\" ng-model=\"lastName\" name=\"lastName\" maxlength=\"100\"\n                                        ng-class=\"{'error': registerFormSocialMedia.lastName.$invalid && socialMediaSubmitted}\" id=\"last-name\"\n                                        autocomplete=\"off\"\n                                        placeholder=\"{{ 'cw.form.profile.last_name' | translate }}\"\n                                        ng-pattern=\"lastNameRegExp\" required\n                                        connectqa-register=\"last-name-sm\" />\n\n                                    <label ng-hide=\"registerFormSocialMedia.lastName.$viewValue.length > 0\" class=\"fallback-input\"\n                                        for=\"last-name\" translate=\"cw.form.profile.last_name\"></label>\n                                    <p class=\"error-message\" ng-show=\"registerFormSocialMedia.lastName.$invalid && socialMediaSubmitted\"\n                                        connectqa-register=\"last-name-sm-error-message\" translate=\"cw.general.last_name_error\">\n                                    </p>\n                                </div>\n\n                                <div class=\"form-group text-left\">\n                                    <div class=\"input-holder v-top w100\" connectqa-register=\"country-sm\">\n                                        <ui-select class=\"\" ng-model=\"country\" theme=\"selectize\"\n                                            ng-change=\"validateCountry($select.selected)\"\n                                            ng-class=\"{'error': countryError}\"\n                                            required>\n                                            <ui-select-match class=\"text-m\" placeholder=\"Country\">\n                                                <span data-ng-bind=\"$select.selected.name\"></span>\n                                            </ui-select-match>\n                                            <ui-select-choices class=\"text-m\" repeat=\"userCountry in countries | filterCountry : $select.search\">\n                                                <span class=\"text-m\" data-ng-bind=\"userCountry.name\"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <p class=\"error-message\" ng-show=\"countryError\" connectqa-register=\"country-sm-error-message\" translate=\"cw.general.country_error\">\n                                    </p>\n                                </div>\n\n                                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                                    ng-disabled=\"submitSocialMediaLoading\" translate=\"cw.general.create_account\"\n                                    connectqa-register=\"register-button-sm\">\n                                </button>\n                            </div>\n\n                        </form>\n                    </div>\n\n                    <div class=\"section-social-media v2\">\n                        <div class=\"input-checkbox white-bg eula\">\n                            <span class=\"text-s text-grey-4\" translate=\"cw.auth.eula_v2\"\n                                translate-values=\"{hrefenduser : hrefEndUser, hreflegalterms : hrefLegalTerms}\"\n                                connectqa-register=\"eula-and-privacy-policy\"></span>\n                        </div>\n                        <div class=\"text-center text-grey-4 eula text-xs\">\n                            <span translate=\"cw.auth.privacy_policy\"\n                                translate-values=\"{hrefGeneralPrivacy : hrefGeneralPrivacy}\"></span>\n                            <span class=\"separator\"></span>\n                            <span translate=\"cw.auth.imprint\"\n                                translate-values=\"{hrefGeneralImprint : hrefGeneralImprint}\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"text-center plr20\" ng-if=\"showReactivateLogin\">\n        <a class=\"inline-block text-xl mt15 text-blue-1 crs-pointer\" ng-click=\"cancelReactivateLicense()\" translate=\"cw.auth.reactivate_license.action\"></a>\n    </div>\n</div>"

/***/ }),

/***/ "PtFa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('Crypto', ['$scope', 'Util', 'JWT', '$http', '$state', '$rootScope', function ($scope, Util, JWT, $http, $state, $rootScope) {

    $scope.activeTab = $state.params.tab || 'mining';
    $scope.miningIsLoading = true;
    $scope.walletIsLoading = true;
    $scope.txHistoryIsLoading = true;
    $scope.payoutConfigIsLoading = true;

    var _CWCONFIG = CWCONFIG,
        cryptoRestApi = _CWCONFIG.cryptoRestApi;


    if (!CWCONFIG.showCrypto) {

        return;
    }

    Promise.allSettled = function (promises) {

        var mappedPromises = promises.map(function (p) {
            return p.then(function (value) {
                return {
                    status: 'fulfilled',
                    value: value
                };
            }).catch(function (reason) {
                return {
                    status: 'rejected',
                    reason: reason
                };
            });
        });
        return Promise.all(mappedPromises);
    };

    $scope.switchTab = function (tabId, tabName) {

        $scope.activeTab = tabId;

        $state.go('root.dashboard.crypto', {
            tab: tabId
        });

        _RFC2.default.send('Connect Web Crypto ' + tabName + ' Tab Click');
    };

    $scope.disabledMiningModalClosed = sessionStorage.getItem('disabledMiningModalClosed');

    $scope.openWallet = function () {

        sessionStorage.setItem('disabledMiningModalClosed', true);

        $scope.activeTab = 'wallet';

        $state.go('root.dashboard.crypto', {
            tab: 'wallet'
        });
    };

    $scope.closeDisabledMiningModal = function () {

        sessionStorage.setItem('disabledMiningModalClosed', true);
        $scope.disabledMiningModalClosed = sessionStorage.getItem('disabledMiningModalClosed');
    };

    $scope.getHashRate = function (hash, resultType) {

        var updatedHash = hash / (1000 * 1000);
        var hashValue = void 0;

        if (updatedHash / 1000 > 1) {

            updatedHash = hash / 1000;
        }
        if (resultType && resultType === 'number') {

            hashValue = Util.toFixed(updatedHash, 1);
        } else {

            hashValue = Util.toFixed(updatedHash, 1) + ' MH/s';
        }

        return hashValue;
    };

    var nortonGuid = void 0;
    var token = Util.getToken();

    if (token) {

        var decodedToken = JWT.getTokenPayload(token);

        if ('aguid' in decodedToken) {

            nortonGuid = decodedToken.aguid;
            $rootScope.nortonGuid = nortonGuid;
        }
    }

    // Get Wallets
    var getBalance = function getBalance() {
        return $http({
            method: 'GET',
            url: cryptoRestApi + '/wallet/api/balance/' + nortonGuid + '/',
            headers: {
                Authorization: 'Bearer ' + token,
                'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
            }

        }).then(function (response) {

            _index.CryptoRepository.replace('wallets', response.data.wallets);
            var pendingBalances = {};

            Object.keys(response.data.wallets).map(function (key) {

                pendingBalances[key] = response.data.wallets[key].pendingBalance;
                return pendingBalances;
            });

            _index.CryptoRepository.replace('pendingBalances', pendingBalances);
            $scope.walletIsLoading = false;
        }).catch(function (error) {

            if (error.status === 404) {

                $http({
                    method: 'POST',
                    url: cryptoRestApi + '/wallet/api/wallet',
                    headers: {
                        Authorization: 'Bearer ' + token,
                        'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
                    },
                    data: {
                        nortonGuid: nortonGuid,
                        currency: 'ETH'
                    }
                }).then(function () {

                    getBalance();
                }).catch(function () {

                    getBalance();
                });
            }

            _index.CryptoRepository.replace('wallets', {});
            _index.CryptoRepository.replace('pendingBalances', {});

            _RFC2.default.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'GET balance'
            });
        });
    };

    // Used for mixpanel
    var getBalancePromise = $http({
        method: 'GET',
        url: cryptoRestApi + '/wallet/api/balance/' + nortonGuid + '/',
        headers: {
            Authorization: 'Bearer ' + token,
            'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
        }

    }).then(function (response) {

        _index.CryptoRepository.replace('wallets', response.data.wallets);
        var pendingBalances = {};

        Object.keys(response.data.wallets).map(function (key) {

            pendingBalances[key] = response.data.wallets[key].pendingBalance;
            return pendingBalances;
        });

        _index.CryptoRepository.replace('pendingBalances', pendingBalances);
    }).catch(function () {

        _index.CryptoRepository.replace('wallets', {});
        _index.CryptoRepository.replace('pendingBalances', {});
    });

    // Get Price
    var getPrices = $http({

        method: 'GET',
        url: cryptoRestApi + '/pricing/api/price?symbol=ETH',
        headers: {
            Authorization: 'Bearer ' + token,
            'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
        }

    }).then(function (response) {

        _index.CryptoRepository.replace('prices', response.data);
        getBalance();
    }).catch(function (error) {

        _index.CryptoRepository.replace('prices', []);
        _RFC2.default.send('ConnectWeb Crypto Error', {
            'Error Code': error.status,
            'Error Name': error.data ? error.data : 'No error message',
            Resource: 'GET price'
        });
    });

    // Get Tx History
    var getTxHistory = $http({

        method: 'GET',
        url: cryptoRestApi + '/wallet/api/txHistory/' + nortonGuid + '/',
        headers: {
            Authorization: 'Bearer ' + token,
            'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
        }

    }).then(function (response) {

        _index.CryptoRepository.replace('transactions', response.data.transactionList.reverse());
        $scope.txHistoryIsLoading = false;
    }).catch(function (error) {

        _index.CryptoRepository.replace('transactions', []);
        $scope.txHistoryIsLoading = false;
        _RFC2.default.send('ConnectWeb Crypto Error', {
            'Error Code': error.status,
            'Error Name': error.data ? error.data : 'No error message',
            Resource: 'GET txHistory'
        });
    });

    // Get Tx Fees
    var getTXFees = $http({

        method: 'GET',
        url: cryptoRestApi + '/wallet/api/txFees',
        headers: {
            Authorization: 'Bearer ' + token,
            'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
        }

    }).then(function (response) {

        _index.CryptoRepository.replace('fees', response.data);
    }).catch(function (error) {

        _index.CryptoRepository.replace('fees', []);
        _RFC2.default.send('ConnectWeb Crypto Error', {
            'Error Code': error.status,
            'Error Name': error.data ? error.data : 'No error message',
            Resource: 'GET txFees'
        });
    });

    // Get Payout Config
    var getPayoutConfig = $http({
        method: 'GET',
        url: cryptoRestApi + '/payouts/api/payoutConfig?currency=ETH',
        headers: {
            Authorization: 'Bearer ' + token,
            'x-nlok-user-agent': 'ConnectWeb/1.0/Web'
        }

    }).then(function (response) {

        _index.CryptoRepository.replace('payoutConfig', response.data.payoutConfig);
    }).catch(function (error) {

        _index.CryptoRepository.replace('payoutConfig', {});
        _RFC2.default.send('ConnectWeb Crypto Error', {
            'Error Code': error.status,
            'Error Name': error.data ? error.data : 'No error message',
            Resource: 'GET payoutConfig'
        });
    });

    var pendingBalanceArray = [getPayoutConfig, getBalancePromise];

    Promise.allSettled(pendingBalanceArray).then(function () {

        $scope.payoutConfigIsLoading = false;
    });

    var cryptoResources = [getPrices, getTxHistory, getTXFees, getPayoutConfig, getBalancePromise];

    Promise.allSettled(cryptoResources).then(function () {

        var cryptoData = _index.CryptoRepository.getAll();
        var cryptoRigs = _index.CryptoRepository.getAllRigs();

        var overallHashRate = 0;

        if (cryptoRigs.length > 0) {

            cryptoRigs.forEach(function (rig) {

                if (!rig.hashRate) {

                    rig.hashRate = 0;
                }

                overallHashRate += parseFloat(rig.hashRate);
            });
        }

        if (cryptoData.prices.conversionRateMap) {

            cryptoData.currencies = Object.keys(cryptoData.prices.conversionRateMap).sort();
            var ethPrice = Util.toFixed(cryptoData.prices.conversionRateMap.USD, 2);
            _RFC2.default.setCommonProperty('ETH Price USD', ethPrice);
        }

        if (Object.keys(cryptoData.wallets).length > 0) {

            _RFC2.default.setCommonProperty('ETH Balance', Util.toFixed(cryptoData.wallets.ETH.balance, 6));
        }

        if (Object.keys(cryptoData.wallets).length > 0 && cryptoData.prices.conversionRateMap) {

            var moneyBalance = 0;
            var cryptoBalance = 0;
            Object.keys(cryptoData.wallets).forEach(function (key) {

                moneyBalance += cryptoData.prices.conversionRateMap[$rootScope.cryptoCurrency] * cryptoData.wallets[key].balance;
                cryptoBalance += cryptoData.wallets[key].balance;
                $rootScope.cryptoSymbol = key;
            });

            $rootScope.moneyBalance = '' + Util.toFixed(moneyBalance, 2);
            $rootScope.cryptoBalance = '' + Util.toFixed(cryptoBalance, 6);
        }

        if (Object.keys(cryptoData.pendingBalances).length > 0) {

            _RFC2.default.setCommonProperty('ETH Pending', Util.toFixed(cryptoData.pendingBalances.ETH, 6));
        }

        _RFC2.default.setCommonProperty('Rig count', cryptoRigs.length);
        _RFC2.default.setCommonProperty('Hashrate', $scope.getHashRate(overallHashRate, 'number'));

        var user = _index.MeRepository.getMyUser();
        var tfaStatus = user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
        var dateTFAactivated = user.attributes.date_tfa_activated;

        var getDateDifference = function getDateDifference(date) {

            var now = moment();
            var end = moment(date);
            var duration = moment.duration(now.diff(end));
            var days = Util.toFixed(duration.asHours(), 2);
            return days;
        };

        if (dateTFAactivated) {

            if (parseFloat(getDateDifference(dateTFAactivated)) > 24) {

                _RFC2.default.setCommonProperty('TFA State', 'active');
            } else {

                _RFC2.default.setCommonProperty('TFA State', 'pending');
            }
        } else if (!dateTFAactivated && tfaStatus === 'tfaEnabled') {

            _RFC2.default.setCommonProperty('TFA State', 'active');
        } else if (!dateTFAactivated && tfaStatus === 'tfaDisabled') {

            _RFC2.default.setCommonProperty('TFA State', 'inactive');
        }

        _RFC2.default.send('ConnectWeb Crypto Open', {
            Tab: $scope.activeTab
        });
    });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "PwY5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("YW9j");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFCSession = __webpack_require__("DyxV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', '$window', 'Auth', 'Util', '$location', 'JWT'];

/**
     * @ngdoc service
     * @name controllers.Reset
     *
     * @description
     * Reset password controller
     */

var Reset = function () {

    /**
         * @param  {any} $scope
         * @param  {any} $window
         * @param  {any} $state
         * @param  {any} Auth
         * @param  {any} Util
         * @param  {any} JWT
         */
    function Reset($scope, $state, $window, Auth, Util, $location, JWT) {
        _classCallCheck(this, Reset);

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$scope.submitted = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.Auth = this.Auth;
        this.passwordScore = {};
        this.token = _RFC4.default.get(CWCONFIG.cookie.token) || '';
        this.JWT = JWT;

        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        _RFC2.default.send('ConnectWeb Auth Reset Open', {
            Source: 'Email'
        });

        // if the flow is from SSO
        if (this.token) {

            // remove saved token from SSO if the reset page view is closed
            $scope.$on('$destroy', function () {

                Auth.removeLoginCookies();
                _RFCSession.Session.setValue(_RFCSession.SessionKeys.ExtraUrlParams, '');
            });

            // Save device id in session storage for launcher forgot flow
            var tokenPayload = this.JWT.getTokenPayload(this.token);
            if (tokenPayload.did) {

                localStorage.setItem('ResetEmailDeviceID', JSON.stringify(tokenPayload.did));
            }

            // delete query params
            var queryParams = $location.search();

            delete queryParams.client_id;
            $location.path('/auth/reset');
        } else {

            $location.path('/auth/login');
        }
    }

    _createClass(Reset, [{
        key: 'resetPassword',
        value: function resetPassword() {

            var resetPasswordPayload = {
                data: {
                    type: 'passwords',
                    relationships: {
                        partner: {
                            data: {
                                type: 'partners',
                                id: this.$window.appName
                            }
                        }
                    },
                    attributes: {
                        password: this.$scope.password
                    }
                },
                meta: {
                    logout: this.$scope.logoutFromAllDevices
                }
            };

            var token = this.token;


            this.getPasswordScore(this.$scope.password);

            // Check if password and confirm password input fields are valid
            var formIsValid = this.$scope.resetPasswordForm.$valid && this.$scope.resetPasswordForm.password.$viewValue === this.$scope.resetPasswordForm.passwordConfirm.$viewValue && this.passwordScore.valid;

            _RFC2.default.send('ConnectWeb Reset Password Click', {
                Page: 'Auth Reset'
            });

            this.$scope.submitted = true;

            if (formIsValid) {

                this.Auth.loading = true;
                this.Auth.resetPassword(resetPasswordPayload, token);
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'showPassword',
        value: function showPassword() {

            var inputType = angular.element('#password')[0];

            if (inputType.type === 'text') {

                inputType.type = 'password';
            } else {

                inputType.type = 'text';
            }

            this.$scope.inputType = inputType.type;
        }
    }, {
        key: 'getPasswordScore',
        value: function getPasswordScore(password) {

            this.passwordScore = this.Util.getPasswordScore(password);
        }
    }]);

    return Reset;
}();

_serviceDependencies.push(Reset);

angular.module('controllers').controller('Reset', _serviceDependencies);

/***/ }),

/***/ "Pyvz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint vars-on-top: 0 */


var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$rootScope', 'GdprActionsRestService', 'Util', 'GdprReportsRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.UserDataController
 *
 * @description
 * edit form for user details controller
 */

var UserDataController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $rootScope
     * @param  {any} GdprActionsRestService
     * @param  {any} Util
     * @param  {any} GdprReportsRestService
     */
    function UserDataController($scope, $state, $rootScope, GdprActionsRestService, Util, GdprReportsRestService) {
        var _this = this;

        _classCallCheck(this, UserDataController);

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.GdprActionsRestService = GdprActionsRestService;
        this.GdprReportsRestService = GdprReportsRestService;
        this.Util = Util;
        this.GdprReports = _index.GdprReportsRepository.getAll();
        this.showGdprButton = CWCONFIG.features.showGdprButton;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        var gdprActionsObservable = _index.GdprActionsRepository.getObservable();
        var onNextAction = function onNextAction(data) {

            var dataReportRequested = data.find(function (action) {
                return action.attributes.action_type === 'gdpr_get_data';
            });
            var maxDaysGdprReportDelivery = CWCONFIG.maxDaysGdprReportDelivery || 60;

            if (dataReportRequested) {

                var today = new Date();
                var requestDate = new Date(dataReportRequested.attributes.date_added);
                var timeDifference = Math.abs(today.getTime() - requestDate.getTime());
                var daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

                /**
                If the no. of days passed since GDPR report was requested is less than configured
                no. of days for delivery, show pending message
                */
                if (daysDifference <= maxDaysGdprReportDelivery) {

                    _this.$scope.dataReportPending = dataReportRequested.attributes.status === 'pending';
                    _this.$scope.dataReportDate = moment(dataReportRequested.attributes.date_added).format('L');
                }
            }
        };

        var gdprActionsSubscriber = gdprActionsObservable.subscribe(onNextAction, function () {}, function () {});

        this.$scope.$on('$destroy', function () {

            gdprActionsSubscriber.dispose();
        });

        if (!this.$rootScope.gdprReportsLoaded) {

            // Used to display the loader in the gdpr report modal
            this.$rootScope.gdprReportsLoading = true;

            GdprReportsRestService.getAllAsync().then(function (response) {

                if (response.data.data.length > 0) {

                    response.data.data.forEach(function (report) {

                        var gdprReportTimestamp = Util.deepFind(report, 'attributes.request_received_timestamp');

                        if (gdprReportTimestamp) {

                            _this.$rootScope.gdprReportTimestamp = moment(gdprReportTimestamp).format('L');
                        }

                        var finalReport = Util.deepFind(report, 'attributes.final_report');

                        if (finalReport) {

                            _index.GdprReportsRepository.add(JSON.parse(finalReport));
                            _this.$scope.hasReport = true;
                            _this.$rootScope.gdprReportsLoaded = true;
                        }
                    });

                    _this.$rootScope.gdprReportsLoading = false;
                } else {

                    _this.$rootScope.gdprReportsLoading = false;
                    _this.$scope.hasReport = false;
                }
            }).catch(function () {

                _this.$rootScope.gdprReportsLoading = false;
                _this.$scope.hasReport = false;
            });
        }
        if (this.GdprReports.length > 0) {

            this.$scope.hasReport = true;
        }
    }

    _createClass(UserDataController, [{
        key: 'getReport',
        value: function getReport() {
            var _this2 = this;

            var payload = {
                data: {
                    attributes: {
                        action_type: 'gdpr_get_data'
                    }
                }
            };

            _RFC4.default.send('ConnectWeb Request Report Click');

            this.GdprActionsRestService.create(payload).then(function () {

                _this2.GdprActionsRestService.getAllAsync().then(function (response) {

                    _index.GdprActionsRepository.replace(response.data.data);
                });

                _this2.$state.go('root.dashboard.my-account.ltb', {
                    ltb: 'get-report'
                });
            }).then(null, function (error) {

                var errorReason = void 0;

                if (_this2.Util.deepFind(error, 'data.error')) {

                    errorReason = error.data.code;
                } else if (_this2.Util.deepFind(error, 'data.errors')) {

                    errorReason = error.data.errors[0].code;
                }

                if (errorReason === '1808') {

                    _RFC2.default.error('cw.get_report.already_requested_error');
                } else {

                    _RFC2.default.error('cw.get_report.error');
                }
            });
        }
    }, {
        key: 'showReport',
        value: function showReport() {

            this.$state.go('root.dashboard.my-account.ltb', {
                ltb: 'gdpr-report'
            });
        }
    }]);

    return UserDataController;
}();

/**
     * @ngdoc directive
     * @name directives.UserDataDirective
     *
     * @description
     * edit form for user details directive
     */


var UserDataDirective = function UserDataDirective() {
    _classCallCheck(this, UserDataDirective);

    this.template = __webpack_require__("nFaA");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, $state, $rootScope, GdprActionsRestService, Util, GdprReportsRestService) {
        return new UserDataController($scope, $state, $rootScope, GdprActionsRestService, Util, GdprReportsRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'userDataCtrl';
};

_directiveDependencies.push(function () {
    return new UserDataDirective();
});

angular.module('directives').directive('userData', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "Q9rA":
/***/ (function(module, exports) {

module.exports = "<div class=\"store-oo-diskimage\">\n    <div class=\"header\">\n        <div class=\"container\">\n            <div class=\"content-wrapper\">\n                <h2 class=\"text-xxxl text-grey-1 mt0 font-bold\"\n                    translate=\"cw.store.oo_diskimage.title\"></h2>\n                <h3 class=\"text-xxl text-grey-2 mt0 mb30\"\n                    translate=\"cw.store.oo_diskimage.subtitle\"\n                    translate-values= \"{brandname: brandName}\">\n                </h3>\n                <ul class=\"checklist text-xl text-grey-3\">\n                    <li>\n                        <i class=\"icon icon-checkmark icon-green-1 icon-xxs\"></i>\n                        <span translate=\"cw.store.oo_diskimage.feature_1\"><span>\n                    </li>\n                    <li>\n                        <i class=\"icon icon-checkmark icon-green-1 icon-xxs\"></i>\n                        <span translate=\"cw.store.oo_diskimage.feature_2\"><span>\n                    </li>\n                    <li>\n                        <i class=\"icon icon-checkmark icon-green-1 icon-xxs\"></i>\n                        <span translate=\"cw.store.oo_diskimage.feature_3\"><span>\n                    </li>\n                </ul>\n\n                <div class=\"row mt50\">\n                    <div class=\"col4 v-top\">\n                        <div ng-if=\"userCountry === 'GB'\">\n                            <p class=\"price text-xxxl text-green-2 mt0 mb10 mr20 font-bold\">&pound;19.95</p>\n                            <p class=\"price text-xl text-grey-3 mt0 mb10 text-strike\">&pound;32.99</p>\n                        </div>\n\n                        <div ng-if=\"userCountry === 'CH'\">\n                            <p class=\"price text-xxxl text-green-2 mt0 mb10 mr20 font-bold\">CHF29.95</p>\n                            <p class=\"price text-xl text-grey-3 mt0 mb10 text-strike\">CHF49.90</p>\n                        </div>\n\n                        <div ng-if=\"userCountry === 'US' || userCountry === 'CA'\">\n                            <p class=\"price text-xxxl text-green-2 mt0 mb10 mr20 font-bold\">$29.95</p>\n                            <p class=\"price text-xl text-grey-3 mt0 mb10 text-strike\">$49.95</p>\n                        </div>\n\n                        <div ng-if=\"userCountry !== 'GB' && userCountry !== 'CH' && userCountry !== 'US' && userCountry !== 'CA'\">\n                            <p class=\"price text-xxxl text-green-2 mt0 mb10 mr20 font-bold\">29.95&euro;</p>\n                            <p class=\"price text-xl text-grey-3 mt0 mb10 text-strike\">49.90&euro;</p>\n                        </div>\n\n                        <button class=\"btn btn-large btn-primary\"\n                        ng-click=\"ooDiskimagePageCtrl.buy()\" translate=\"cw.general.buy\"></button>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"os-support\">\n            <i class=\"icon icon-windows icon-white icon-xs\"></i>\n            <span class=\"text-xl text-white\" translate=\"cw.store.oo_diskimage.os_support\"></span>\n        </div>\n\n    </div>\n\n    <div class=\"medium-container\">\n        <div class=\"text-center\">\n            <h2 class=\"text-xxl text-grey-1 mt70 font-bold\"\n                translate=\"cw.store.oo_diskimage.presentation_header\"></h2>\n            <h3 class=\"text-xl text-grey-3 mt10 presentation-paragraph\"\n                translate=\"cw.store.oo_diskimage.presentation_paragraph\"></h3>\n        </div>\n    </div>\n\n    <div class=\"container\">\n\n        <div class=\"row mt50 products-row\">\n            <div class=\"col3\">\n                <div class=\"upgrade-icon mb10\"></div>\n            </div>\n            <div class=\"col3\">\n                <div class=\"migrate-icon mb10\"></div>\n            </div>\n            <div class=\"col3\">\n                <div class=\"preserve-icon mb10\"></div>\n            </div>\n            <div class=\"col3\">\n                <div class=\"ransom-proof-icon mb10\"></div>\n            </div>\n        </div>\n\n        <div class=\"row text-center\">\n            <div class=\"col3 text-center v-top block\">\n                <h2 class=\"text-xl text-blue-3 mt20 mb10 mr30 ml10\"\n                    translate=\"cw.store.oo_diskimage.upgrade_feature\"></h2>\n            </div>\n            <div class=\"col3 text-center v-top block\">\n                <h2 class=\"text-xl text-blue-3 mt20 mb10 mr30 ml10\"\n                    translate=\"cw.store.oo_diskimage.migrate_feature\"></h2>\n            </div>\n            <div class=\"col3 text-center v-top block\">\n                <h2 class=\"text-xl text-blue-3 mt20 mb10 mr30 ml10\"\n                    translate=\"cw.store.oo_diskimage.preserve_feature\"></h2>\n            </div>\n            <div class=\"col3 text-center v-top block\">\n                <h2 class=\"text-xl text-blue-3 mt20 mb10 mr30 ml10\"\n                    translate=\"cw.store.oo_diskimage.ransom_proof_feature\"></h2>\n            </div>\n        </div>\n\n    </div>\n\n</div>"

/***/ }),

/***/ "QHS2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

var DwmFaqController = function DwmFaqController($scope) {
    _classCallCheck(this, DwmFaqController);

    $scope.activeQuestion = 'q1';

    var sendQuestionClickEvent = function sendQuestionClickEvent(q) {

        if (q === 'q1') {

            _RFC2.default.send('ConnectWeb AIA FAQ Click', {
                Title: 'What is AIA?'
            });
        } else if (q === 'q2') {

            _RFC2.default.send('ConnectWeb AIA FAQ Click', {
                Title: 'DWM Notification'
            });
        } else {

            _RFC2.default.send('ConnectWeb AIA FAQ Click', {
                Title: 'What is DWM?'
            });
        }
    };

    $scope.changeQuestion = function (question) {

        $scope.activeQuestion = question;
        sendQuestionClickEvent(question);
    };

    $scope.currentLanguage = CWCONFIG.language;
};

var DwmFaqDirective = function DwmFaqDirective() {
    _classCallCheck(this, DwmFaqDirective);

    this.template = __webpack_require__("B2oT");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope) {
        return new DwmFaqController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DwmFaqCtrl';
};

_directiveDependencies.push(function () {
    return new DwmFaqDirective();
});

angular.module('directives').directive('dwmFaq', _directiveDependencies);

/***/ }),

/***/ "QRZr":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "QTcw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("v0w9");

__webpack_require__("wdeh");

__webpack_require__("6fSb");

__webpack_require__("BRoG");

/***/ }),

/***/ "Qc0x":
/***/ (function(module, exports) {

module.exports = "<div>\n\n    <div class=\"dashboard-content\">\n        <div ui-view=\"dashboard.body.content\"></div>\n    </div>\n\n    <div ui-view=\"dashboard.body.tour.abstract\"></div>\n</div>\n"

/***/ }),

/***/ "QcWw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ngHtmlCompile', []).directive('ngHtmlCompile', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {

            scope.$watch(attrs.ngHtmlCompile, function (newValue) {

                if (!newValue) {

                    return;
                }

                element.html(newValue);
                $compile(element.contents())(scope);
            });
        }
    };
}]).directive('directiveCompile', ['$compile', function ($compile) {
    return {
        restrict: 'A',
        replace: true,
        link: function link(scope, element, attrs) {

            element.html('<div' + attrs.directiveCompile + '></div>');
            $compile(element.contents())(scope);
        }
    };
}]);

/***/ }),

/***/ "Qkpc":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("xOlx"),
    isMasked = __webpack_require__("dW4B"),
    isObject = __webpack_require__("xwKO"),
    toSource = __webpack_require__("wHLP");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "QoJf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {

    var _directiveDependencies = [];
    var _controllerDependencies = ['$scope', '$state', '$window'];

    /**
     * @ngdoc directive
     * @name directives.controller.ChangeLanguageController
     *
     * @description
     * change the language in the authentication pages controller
     */

    var ChangeLanguageController = function () {

        /**
         * @param  {any} $scope
         * @param  {any} $state
         * @param  {any} $window
         */
        function ChangeLanguageController($scope, $state, $window) {
            _classCallCheck(this, ChangeLanguageController);

            this.$scope = $scope;
            this.$state = $state;
            this.$window = $window;

            this.$scope.currentLanguage = CWCONFIG.languages[CWCONFIG.language] || CWCONFIG.language.toUpperCase();
        }

        /**
         * @ngdoc directive
         * @name directives.controller.ChangeLanguageController#openModal
         * @methodOf directives.controller.ChangeLanguageController
         *
         * @description
         * open the language modal
         */

        _createClass(ChangeLanguageController, [{
            key: 'openModal',
            value: function openModal(modal) {

                this.$state.go(this.$state.current.name + '.ltb', {
                    ltb: modal
                });
            }
        }]);

        return ChangeLanguageController;
    }();

    /**
     * @ngdoc directive
     * @name directives.ChangeLanguageDirective
     *
     * @description
     * change the language in the authentication pages directive
     */


    var ChangeLanguageDirective = function ChangeLanguageDirective() {
        _classCallCheck(this, ChangeLanguageDirective);

        this.template = __webpack_require__("jdje");
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push(function ($scope, $state, $window) {
            return new ChangeLanguageController($scope, $state, $window);
        });
        this.controller = _controllerDependencies;
        this.controllerAs = 'ChangeLanguageCtrl';
    };

    _directiveDependencies.push(function () {
        return new ChangeLanguageDirective();
    });

    angular.module('directives').directive('changeLanguage', _directiveDependencies);
})();

/***/ }),

/***/ "Quiy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('CriticalError', ['$scope', '$rootScope', '$document', '$location', '$window', '$modal', '$modalInstance', 'modalParams', 'Util', 'Auth', function ($scope, $rootScope, $document, $location, $window, $modal, $modalInstance, modalParams, Util, Auth) {

    // set the modal type based on the params received
    function setErrorType() {

        var errorCode = String(modalParams.status);
        $scope.errorCode = errorCode;
        $scope.modalParamsObj = modalParams;

        if (errorCode === '400') {

            return 'bad-request';
        } else if (errorCode === '401' || errorCode === '403') {

            // logout user if the token has expired or access is unauthorized
            Auth.removeLoginCookies();
            $location.path('/auth/login');

            if (Util.deepFind(modalParams, 'data.error') && modalParams.data.error === 'expired_token') {

                return 'session-expired';
            }

            // Refresh the page if an one time token was reused
            if (Util.deepFind(modalParams, 'data.error') && modalParams.data.error === 'used_token') {

                if (window.external && 'CloseHtml' in window.external) {

                    if ($location.$$search.retry_request) {

                        window.external.CloseHtml('error_used_token');
                    } else {

                        _RFC2.default.send('ConnectWeb Spotlight Errors', {
                            Error: modalParams.data.error,
                            Description: modalParams.data.error_description,
                            'Error Code': errorCode,
                            'Client Id': 'spotlight'
                        });

                        // Send a retry request
                        $window.location.href = CWCONFIG.ssoConfig.spotlight.oauth + '?retry_request=1';
                    }
                }

                $window.location.href = $location.path();
            }

            return 'unauthorised';
        } else if (errorCode.startsWith('5')) {

            return 'server-error';
        }

        return 'client-error';
    }

    $scope.modalParams = setErrorType();

    // append class to body when session expire modal appears
    angular.element($document[0].body).addClass('critical-error');

    $scope.refreshPage = function () {

        $window.location.href = $location.path();
    };
}]);

/***/ }),

/***/ "Qxat":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _appPrices = [];
var observableAppPrices = new Rx.BehaviorSubject(_appPrices);

/**
 * @ngdoc service
 * @name repositories.AppPricesRepository
 *
 * @description
 * AppPricesRepository.
 */
var AppPricesRepository = {
    add: function add(data) {
        var _this = this;

        data.forEach(function (item) {

            var indexOfProduct = _this.getIndex(item.id);

            if (indexOfProduct === -1) {

                _appPrices.push(item);
                observableAppPrices.onNext(_appPrices);
            }
        });
    },
    update: function update(data) {
        var _this2 = this;

        data.forEach(function (item) {

            var indexOfProduct = _this2.getIndex(item.id);

            if (indexOfProduct >= 0) {

                _appPrices[indexOfProduct] = item;
                observableAppPrices.onNext(_appPrices);
            }
        });
    },
    replace: function replace(data) {

        _appPrices = data;
        observableAppPrices.onNext(_appPrices);
    },
    getAll: function getAll() {

        return _appPrices;
    },
    getIndex: function getIndex(dataId, runtime, devices) {

        return _appPrices.findIndex(function (_appPrice) {
            return String(_appPrice.id) === String(dataId + "_" + runtime + "_" + devices);
        });
    },
    getSinglePrice: function getSinglePrice(dataId, runtime, devices) {

        return _appPrices.find(function (_appPrice) {
            return String(_appPrice.id) === String(dataId + "_" + runtime + "_" + devices);
        });
    },
    getObservable: function getObservable() {

        return observableAppPrices;
    }
};

exports.default = AppPricesRepository;

/***/ }),

/***/ "Qziv":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("x5Bi"),
    isObjectLike = __webpack_require__("7Zib");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "R2es":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-restricted-properties: 0 */

angular.module('filters').filter('formatSize', function () {

    var displayFormat = void 0;

    function display(size, type, digits) {

        switch (displayFormat) {

            case 'type':
                return type;
            case 'short':
                return parseFloat(size.toFixed(digits));
            default:
                return parseFloat(size.toFixed(digits)) + type;

        }
    }

    return function (size, units, format) {

        var cSize = void 0;
        var multiplier = 1;
        var digits = 1;

        displayFormat = format || 'long';
        units = units || 'b';

        switch (units) {

            case 'kb':
                multiplier = 1024;
                break;
            case 'mb':
                multiplier = 1024 * 1024;
                break;
            case 'gb':
                multiplier = Math.pow(1024, 3);
                break;
            default:
                multiplier = 1024;

        }

        size *= multiplier;

        cSize = size / Math.pow(1024, 4); // TB

        if (cSize > 0.5) {

            return display(cSize, 'TB', digits);
        }

        cSize = size / Math.pow(1024, 3); // GB
        if (cSize > 0.5) {

            return display(cSize, 'GB', digits);
        }
        cSize = size / (1024 * 1024); // MB
        if (cSize > 0.5) {

            return display(cSize, 'MB', digits);
        }
        cSize = size / 1024; // KB
        if (cSize > 0.5) {

            return display(cSize, 'KB', digits);
        }

        return display(size, units.toLocaleUpperCase(), digits);
    };
});

/***/ }),

/***/ "RCtT":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("NYtY"),
    baseUnary = __webpack_require__("+ASY"),
    nodeUtil = __webpack_require__("G5bk");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "RIV0":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu"),
    root = __webpack_require__("VjBI");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "RNqL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = [];
/**
 * @ngdoc service
 * @name rest.services.MyAccountStatesService
 *
 * @description
 * contains the list of states from US and their code
 */

var MyAccountStatesService = function () {

    /**
     * @param  {any}
     */
    function MyAccountStatesService() {
        _classCallCheck(this, MyAccountStatesService);

        this.states = [{ code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AS', name: 'American Samoa' }, { code: 'AZ', name: 'Arizona' }, { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' }, { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'DC', name: 'District Of Columbia' }, { code: 'FM', name: 'Federated States Of Micronesia' }, { code: 'FL', name: 'Florida' }, { code: 'GA', name: 'Georgia' }, { code: 'GU', name: 'Guam' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' }, { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' }, { code: 'MH', name: 'Marshall Islands' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' }, { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' }, { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' }, { code: 'ND', name: 'North Dakota' }, { code: 'MP', name: 'Northern Mariana Islands' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' }, { code: 'PW', name: 'Palau' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'PR', name: 'Puerto Rico' }, { code: 'RI', name: 'Rhode Island' }, { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' }, { code: 'VI', name: 'Virgin Islands' }, { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }];
    }

    /**
     * @ngdoc function
     * @name rest.services.MyAccountStatesService#create
     * @methodOf rest.services.MyAccountStatesService
     * @function
     *
     * @description
     * returns the list of states
     */


    _createClass(MyAccountStatesService, [{
        key: 'getStates',
        value: function getStates() {

            return this.states;
        }
    }]);

    return MyAccountStatesService;
}();

_serviceDependencies.push(MyAccountStatesService);

angular.module('rest.services').service('MyAccountStatesService', _serviceDependencies);

/***/ }),

/***/ "ROsk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _reports = [];
var observableReports = new Rx.BehaviorSubject(_reports);

/**
 * @ngdoc service
 * @name repositories.GdprReportsRepository
 *
 * @description
 * This class is used to save/add devices objects.
 */
var GdprReportsRepository = {

    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#replace
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored actions with provided data.
     *
     * @param {Array} data An array with new actions.
     */
    replace: function replace(data) {

        _reports = data || [];
        observableReports.onNext(_reports);
    },


    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#add
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to add a new action to repository.
     *
     * @param {object} action An action object.
     */
    add: function add(report) {

        var indexOfActions = _reports.findIndex(function (_report) {
            return String(_report.id) === String(report.id);
        });

        if (indexOfActions === -1) {

            _reports.push(report);

            observableReports.onNext(_reports);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#getAll
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all actions from repository.
     *
     * @returns {Array} actions all actions from repository
     */
    getAll: function getAll() {

        return _reports;
    },


    /**
     * @ngdoc function
     * @name repositories.GdprReportsRepository#getObservable
     * @methodOf repositories.GdprReportsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for actios repository.
     * @returns {Object} an observable object for actions repository.
     */
    getObservable: function getObservable() {

        return observableReports;
    }
};

exports.default = GdprReportsRepository;

/***/ }),

/***/ "RW/c":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("5cCM"),
    baseAssignValue = __webpack_require__("tZex");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "RfKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ObjProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SymbolProto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return supportsArrayBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return supportsDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return nativeIsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return nativeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return nativeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return nativeIsView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _isFinite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasEnumBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return nonEnumerableProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_ARRAY_INDEX; });
// Current version.
var VERSION = '1.13.1';

// Establish the root object, `window` (`self`) in the browser, `global`
// on the server, or `this` in some virtual machines. We use `self`
// instead of `window` for `WebWorker` support.
var root = typeof self == 'object' && self.self === self && self ||
          typeof global == 'object' && global.global === global && global ||
          Function('return this')() ||
          {};

// Save bytes in the minified (but not gzipped) version:
var ArrayProto = Array.prototype, ObjProto = Object.prototype;
var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

// Create quick reference variables for speed access to core prototypes.
var push = ArrayProto.push,
    slice = ArrayProto.slice,
    toString = ObjProto.toString,
    hasOwnProperty = ObjProto.hasOwnProperty;

// Modern feature detection.
var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
    supportsDataView = typeof DataView !== 'undefined';

// All **ECMAScript 5+** native function implementations that we hope to use
// are declared here.
var nativeIsArray = Array.isArray,
    nativeKeys = Object.keys,
    nativeCreate = Object.create,
    nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

// Create references to these builtin functions because we override them.
var _isNaN = isNaN,
    _isFinite = isFinite;

// Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
  'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

// The largest integer that can be represented exactly.
var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("GTd5")))

/***/ }),

/***/ "RvKr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("fIlE");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', '$http', '$stateParams'];

/**
 * @ngdoc service
 * @name controllers.News
 *
 * @description
 * News controller
 */

var _$scope = void 0;
var _$state = void 0;
var _$http = void 0;
var _NewsRepository = void 0;
var languages = {};
var lang = CWCONFIG.language;
var parsedBookmarks = void 0;
var callUrl = CWCONFIG.news.getUrl;
var pagesNumber = CWCONFIG.news.numberOfPages;
var numberOfArticles = CWCONFIG.news.articlesOnPage;
var _Util = void 0;

var News = function () {
    function News($scope, $state, $http, $stateParams) {
        var _this = this;

        _classCallCheck(this, News);

        languages = {
            en: {
                threats: 2,
                'how-to': 2282
            },
            de: {
                threats: 2,
                'how-to': 1214
            },
            fr: {
                threats: 2,
                'how-to': 2300
            },
            es: {
                threats: 2,
                'how-to': 6858
            },
            it: {
                threats: 2,
                'how-to': 2300
            },
            'pt-br': {
                threats: 2,
                'how-to': 6858
            }
        };

        /**
         * Set default category
         */
        var availableCategory = 'how-to';

        /**
         * Check if blog is avalable
         */
        if (!languages[lang]) {

            $state.go('root.dashboard.home');
            return false;
        }

        /**
         * Check if language was changed
         */
        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1'
                });
            }
        }

        /**
         * Check if are missing params
         */
        if (!$state.params.tab || !$stateParams.page) {

            $state.go('root.dashboard.news', {
                tab: availableCategory,
                page: '1'
            });
            return false;
        }

        /**
         * Check if page is valid
         */
        if ($stateParams.page) {

            if (!Number.isInteger(parseInt($stateParams.page, 0)) || parseInt($stateParams.page, 0) > pagesNumber) {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1'
                });
                return false;
            }
        }

        /**
         * Check if tab is valid
         */
        if ($state.params.tab) {

            if ($state.params.tab !== 'how-to' && $state.params.tab !== 'threats' && $state.params.tab !== 'bookmarks') {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1'
                });
                return false;
            }
        }

        /**
         * Check if blog language was updated
         */

        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                localStorage.setItem('news_language', lang);
            }
        } else {

            localStorage.setItem('news_language', lang);
        }

        _$http = $http;
        _$scope = $scope;
        _$state = $state;
        _NewsRepository = _index.NewsRepository;
        _Util = _RFC4.default;

        this.checkIfcategoryIsAvailable(languages[lang], $state.params.tab, _$state);

        _$scope.currentCategory = $state.params.tab;

        _$scope.categories = ['threats', 'how-to'];

        _$scope.currentPage = $stateParams.page;
        _$scope.bookmarks = _NewsRepository.getAllBookmarks();
        var newsList = _NewsRepository.getAll();
        _$scope.isLoading = true;
        _$scope.currentPages = _NewsRepository.getPageNumber();
        _$scope.availableCategories = languages[lang];
        _$scope.currentLanguage = lang;

        _NewsRepository.updateCurrentPage($state.params.tab, $stateParams.page);
        parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));

        if (_$scope.bookmarks) {

            _$scope.isLoading = false;
        }

        if (parsedBookmarks) {

            this.getSavedArticles();

            if (parsedBookmarks[lang].length === 0) {

                _$scope.isLoading = false;
            }
        } else {

            this.initBookmarks();
            _$scope.isLoading = false;
        }

        var url = '';
        var categoryId = languages[lang][_$scope.currentCategory];

        url = callUrl + '?categories=' + categoryId + '&page=' + _$scope.currentPage + '&per_page=' + numberOfArticles + '&_embed&lang=' + lang;

        if (!newsList.length || newsList[$stateParams.page - 1] === null) {

            _NewsRepository.setPages(pagesNumber);

            if (_$scope.currentCategory === 'how-to' || _$scope.currentCategory === 'threats') {

                _$http({

                    method: 'GET',
                    url: '' + url

                }).then(function (response) {

                    if (Array.isArray(response.data)) {

                        _this.getShortDescription(response.data);
                        _this.formatDate(response.data);
                        _this.setBookmarkStatus(response.data);
                        _this.updateBookmarkStatus(response.data);
                        _this.checkLoadingStatus(_$scope.currentPage);
                        _this.updateImagePath(response.data);

                        _NewsRepository.replace(response.data, _$scope.currentPage, _$scope.currentCategory);
                    }
                    setTimeout(function () {

                        _this.getAllArticles();
                        _this.getSavedArticles();
                    }, 200);
                });
            }
        } else {

            _$scope.isLoading = false;
        }

        _$scope.news = _NewsRepository.getAll();

        if (newsList.length) {

            this.checkBookmarksStatus();
        }

        if (_$scope.currentCategory === 'how-to' || _$scope.currentCategory === 'threats') {

            this.checkLoadingStatus(_$scope.currentPage);
        }

        _RFC2.default.send('ConnectWeb News Open', {
            Tab: $state.params.tab
        });
    }

    /**
     * After first page is loaded,
     * this function makes async calls to get the rest of the pages
     */


    _createClass(News, [{
        key: 'getAllArticles',
        value: function getAllArticles() {
            var _this2 = this;

            _$scope.news.forEach(function (item, index) {

                var pageNumber = index + 1;

                _$scope.categories.forEach(function (category) {

                    var url = '';

                    var categoryId = languages[lang][category];

                    if (Object.prototype.hasOwnProperty.call(languages[lang], category)) {

                        url = callUrl + '?categories=' + categoryId + '&page=' + pageNumber + '&per_page=' + numberOfArticles + '&_embed&lang=' + lang;

                        if (!_$scope.news[index] || !_$scope.news[index][category].length) {

                            _$http({

                                method: 'GET',
                                url: '' + url

                            }).then(function (response) {

                                if (Array.isArray(response.data)) {

                                    _this2.getShortDescription(response.data);
                                    _this2.formatDate(response.data);
                                    _this2.setBookmarkStatus(response.data);
                                    _this2.updateBookmarkStatus(response.data);
                                    _this2.checkLoadingStatus(_$scope.currentPage);
                                    _this2.updateImagePath(response.data);
                                    _NewsRepository.replace(response.data, pageNumber, category);
                                }
                            });
                        }
                    }
                });
            });
        }

        /**
         * Update short desciption for each article
         * Split by first 200 characters
         * param @array
         */

    }, {
        key: 'getShortDescription',
        value: function getShortDescription(data) {

            data.forEach(function (item) {

                var string = item.excerpt.rendered.split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 200);
                item.shortDescription = string + '...';
            });
        }

        /**
         * Update image source path
         * param @array
         */

    }, {
        key: 'updateImagePath',
        value: function updateImagePath(data) {

            data.forEach(function (item) {

                var thumbnailURL = _Util.deepFind(item, '_embedded.wp:featuredmedia.0.media_details.sizes.thumbnail.source_url');
                var articleListingURL = _Util.deepFind(item, '_embedded.wp:featuredmedia.0.media_details.sizes.article-medium-listing-thumbnail-1x.source_url');

                if (thumbnailURL) {

                    item.image = thumbnailURL;
                } else if (articleListingURL) {

                    item.image = articleListingURL;
                }
            });
        }

        /**
         * Update article date by removing the time
         */

    }, {
        key: 'formatDate',
        value: function formatDate(data) {

            data.forEach(function (item) {

                var date = item.date.split('T');

                var _date = _slicedToArray(date, 1);

                item.date = _date[0];
            });
        }

        /**
         * Update short desciption for a single article
         * Split by first 200 characters
         * param @object
         */

    }, {
        key: 'getShortDescriptionSingleArticle',
        value: function getShortDescriptionSingleArticle(data) {

            var string = data.excerpt.rendered.split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 200);
            data.shortDescription = string + '...';
        }

        /**
         * Adding the bookmark status position for each article
         * default = false
         * param @array
         */

    }, {
        key: 'setBookmarkStatus',
        value: function setBookmarkStatus(data) {

            data.forEach(function (item) {

                item.bookmarkStatus = false;
            });
        }

        /**
         * Updating the bookmark status for each article
         * This function is parsing each id saved in local storage
         * param @array
         */

    }, {
        key: 'updateBookmarkStatus',
        value: function updateBookmarkStatus(data) {

            data.forEach(function (article) {

                if (JSON.parse(localStorage.getItem('bookmarks'))[lang] !== null || JSON.parse(localStorage.getItem('bookmarks'))[lang].length > 0) {

                    JSON.parse(localStorage.getItem('bookmarks'))[lang].forEach(function (item) {

                        if (article.id === item) {

                            article.bookmarkStatus = true;
                        }
                    });
                }
            });
        }

        /**
         * Setting local storage object with four positions: en, de, fr, it;
         * default = null
         */

    }, {
        key: 'initBookmarks',
        value: function initBookmarks() {

            if (parsedBookmarks === null) {

                var bookmarks = {};

                Object.keys(languages).forEach(function (language) {

                    bookmarks[language] = [];
                });

                localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
                parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));
            }
        }

        /**
         * Adding the article id in bookmarks object
         * Setting the article bookmark status to true
         * params @string @string @int @string
         */

    }, {
        key: 'saveArticle',
        value: function saveArticle(articleId, thisBookmarkStatus, page, category) {

            if (thisBookmarkStatus === false) {

                var articlePosition = _$scope.news[page][category].find(function (element) {
                    return element.id === articleId;
                });

                parsedBookmarks[lang].push(articleId);
                localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                articlePosition.bookmarkStatus = true;

                this.getSavedArticle(articleId, lang);

                _RFC2.default.send('ConnectWeb News Bookmark Click', {
                    Bookmark: 'Save'
                });
            }
        }

        /**
         * Removing the article id from bookmarks object
         * Setting the article bookmark status to false
         * params @string @string @int @string
         */

    }, {
        key: 'removeArticle',
        value: function removeArticle(articleId, bookmarkStatus, page, category) {

            if (bookmarkStatus === true) {

                var articlePosition = _$scope.news[page][category].find(function (element) {
                    return element.id === articleId;
                });

                parsedBookmarks[lang].forEach(function (localStorageItem) {

                    if (localStorageItem === articleId) {

                        var remove = function remove(array, element) {

                            return array.filter(function (el) {
                                return el !== element;
                            });
                        };

                        parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                        localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                        articlePosition.bookmarkStatus = false;
                        _NewsRepository.deleteBookmark(articleId, lang);
                    }
                });

                _RFC2.default.send('ConnectWeb News Bookmark Click', {
                    Bookmark: 'Unsave'
                });
            }
        }

        /**
         * Removing the article id from bookmarks object
         * Setting the article bookmark status to false
         * params @int
         */

    }, {
        key: 'removeArticleBookmarksTab',
        value: function removeArticleBookmarksTab(articleId) {

            parsedBookmarks[lang].forEach(function (localStorageItem) {

                if (localStorageItem === articleId) {

                    var remove = function remove(array, element) {

                        return array.filter(function (el) {
                            return el !== element;
                        });
                    };

                    parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                    localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                    _NewsRepository.deleteBookmark(articleId, lang);
                    _$scope.bookmarks = _NewsRepository.getAllBookmarks();
                }
            });

            _$scope.news.forEach(function (item) {

                if (item !== null) {

                    Object.keys(item).forEach(function (category) {

                        item[category].forEach(function (article) {

                            if (article.id === articleId) {

                                if (article.bookmarkStatus === true) {

                                    article.bookmarkStatus = false;
                                }
                            }
                        });
                    });
                }
            });

            _RFC2.default.send('ConnectWeb News Bookmark Click', {
                Bookmark: 'Unsave'
            });
        }

        /**
         * Get an article by id
         * Push it to repo
         * params @int
         */

    }, {
        key: 'getSavedArticle',
        value: function getSavedArticle(articleId) {
            var _this3 = this;

            _$http({

                method: 'GET',
                url: callUrl + '/' + articleId

            }).then(function (response) {

                _NewsRepository.addBookmark(response.data, lang);
                _this3.getShortDescriptionSingleArticle(response.data);
            });
        }

        /**
         * Get a list of articles
         * If article is not saved in repo
         */

    }, {
        key: 'getSavedArticles',
        value: function getSavedArticles() {
            var _this4 = this;

            var currentBookmarks = parsedBookmarks[lang];
            var repoBookmarks = _NewsRepository.getAllBookmarks();

            currentBookmarks.forEach(function (currentArticle) {

                var found = repoBookmarks[lang].find(function (element) {
                    return element.id === currentArticle;
                });

                if (!found) {

                    if (currentBookmarks.length > 0) {

                        _$http({

                            method: 'GET',
                            url: callUrl + '/' + currentArticle

                        }).then(function (response) {

                            _NewsRepository.replaceBookmarks(response.data, lang);
                            _this4.getShortDescriptionSingleArticle(response.data);
                        });
                    }
                }
            });
        }

        /**
         * Check if any article status was changed
         * in listing or article view
         */

    }, {
        key: 'checkBookmarksStatus',
        value: function checkBookmarksStatus() {

            var currentBookmarks = parsedBookmarks[lang];
            var repoBookmarks = _NewsRepository.getAllBookmarks();

            _$scope.news.forEach(function (item) {

                if (item) {

                    Object.keys(item).forEach(function (category) {

                        item[category].forEach(function (article) {

                            if (currentBookmarks.length === 0) {

                                article.bookmarkStatus = false;
                            } else {

                                currentBookmarks.forEach(function () {

                                    var found = repoBookmarks[lang].find(function (element) {
                                        return element.id === article.id;
                                    });

                                    if (found) {

                                        article.bookmarkStatus = true;
                                    } else {

                                        article.bookmarkStatus = false;
                                    }
                                });
                            }
                        });
                    });
                }
            });
        }

        /**
         * Check if articles from page are loaded
         * Show or hide the loader
         * params @int
         */

    }, {
        key: 'checkLoadingStatus',
        value: function checkLoadingStatus(page) {

            if (!_$scope.news[parseInt(page, 0) - 1]) {

                _$scope.isLoading = true;
            } else {

                _$scope.isLoading = false;
            }
        }
    }, {
        key: 'checkIfcategoryIsAvailable',
        value: function checkIfcategoryIsAvailable(categories, currentCategory, $state) {

            if (currentCategory !== 'bookmarks' && currentCategory !== 'threats-landscape') {

                if (!categories[currentCategory]) {

                    $state.go('root.dashboard.news', {
                        tab: 'how-to',
                        page: '1'
                    });
                }
            }
        }
    }, {
        key: 'switchPage',
        value: function switchPage(pageIndex) {

            _$state.go('root.dashboard.news', {
                tab: _$scope.currentCategory,
                page: pageIndex
            });

            _RFC2.default.send('ConnectWeb News Page Click');
        }
    }, {
        key: 'switchView',
        value: function switchView(articleId, pageIndex) {

            _$state.go('root.dashboard.article', {
                tab: _$scope.currentCategory,
                id: articleId,
                page: pageIndex
            });

            _RFC2.default.send('ConnectWeb News Article Click');
        }
    }]);

    return News;
}();

_serviceDependencies.push(News);

angular.module('controllers').controller('News', _serviceDependencies);

/***/ }),

/***/ "RwMB":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("Gdal"),
    isIterateeCall = __webpack_require__("c5ad");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "S2n6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("eyBl");

var _RFC5 = __webpack_require__("YW9j");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Remove device controller
 * Handles remove-device modal template.
 */

angular.module('controllers').controller('RemoveDevice', ['$scope', '$stateParams', '$state', '$filter', 'Util', 'DeviceRestService', 'Auth', '$rootScope', 'JWT', function ($scope, $stateParams, $state, $filter, Util, DeviceRestService, Auth, $rootScope, JWT) {

    var deviceId = $stateParams.resourceId;
    $scope.device = _index.DevicesRepository.getById(deviceId);
    $scope.brandName = CWCONFIG.partnerConfig.name;

    // Method to confirm deletion of a device.
    // Triggered by "confirm delete" template button.
    $scope.confirmDelete = function () {

        var devicePromise = DeviceRestService.remove(deviceId);

        // send the DELETE verb permanently delete the device
        devicePromise.then(function () {

            _RFC2.default.success({
                message: 'cw.device.remove.success',
                icon: {
                    cssClasses: 'icon-' + Util.deepFind($scope.device, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: (0, _index2.FilterDeviceName)($scope.device)
                }
            });
            _index.DevicesRepository.remove(deviceId);

            var isFromDeviceDetails = $state.current.name.indexOf('device-details') > -1;

            _RFC4.default.send('ConnectWeb Device Remove Click', {
                Delete: 'true',
                Page: isFromDeviceDetails ? 'Device Details' : 'My Devices'
            });

            // logout user after the deveice is deleted because
            // the token will not work anymore
            // (only if the session is from that device)
            var token = _RFC6.default.get(CWCONFIG.cookie.token) || '';
            var tokenPayload = JWT.getTokenPayload(token);

            if (tokenPayload.did && tokenPayload.did === Number(deviceId)) {

                Auth.logOut();
            }

            if (isFromDeviceDetails) {

                $scope.close();
                $state.go('root.dashboard.devices');
            } else {

                $scope.close();
            }
        }).catch(function () {

            _RFC2.default.error({
                message: 'cw.device.remove.error',
                icon: {
                    cssClasses: 'icon-' + Util.deepFind($scope.device, 'attributes.type')
                }
            }, {
                message: {
                    deviceName: $filter('deviceName')($scope.device)
                }
            });
        });

        // clear Digital Health deviceIDs if the device is removed
        delete $rootScope.digitalHealthSelectedDeviceId;
        delete $rootScope.digitalHealthSelectedDevice;
    };

    // Method to cancel and close the the "remove device" lightbox.
    $scope.cancel = function () {

        Util.closeModal();
    };
}]);

/***/ }),

/***/ "S3Zr":
/***/ (function(module, exports) {

module.exports = "<div>\n    <!-- Tabs -->\n    <div class=\"middle-holder\">\n        <div class=\"dashboard-tabs-holder\">\n            <div class=\"dashboard-tabs text-left multiple-tabs\">\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': state.params.tab === 'profile'}\" translate=\"cw.general.profile\" ui-sref=\"root.dashboard.my-account({tab: 'profile'})\" ng-click=\"onTabClick('Profile')\" connectqa-mya=\"profile-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': state.params.tab === 'security'}\" translate=\"cw.general.security\" ui-sref=\"root.dashboard.my-account({tab: 'security'})\" ng-click=\"onTabClick('Security')\" connectqa-mya=\"security-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': state.params.tab === 'data-settings'}\" translate=\"cw.profile.tabs.dataSettings\" ui-sref=\"root.dashboard.my-account({tab: 'data-settings'})\" ng-click=\"onTabClick('Manage Account')\" connectqa-mya=\"data-settings-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': state.params.tab === 'notifications'}\" translate=\"cw.profile.tabs.notifications\" ui-sref=\"root.dashboard.my-account({tab: 'notifications'})\" ng-click=\"onTabClick('Notifications')\" connectqa-mya=\"notifications-tab\"></span>\n                <span ng-if=\"paymentTypes.length\" class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': state.params.tab === 'payment'}\" translate=\"cw.profile.tabs.payment\" ui-sref=\"root.dashboard.my-account({tab: 'payment'})\" ng-click=\"onTabClick('Payment')\" connectqa-mya=\"payment-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ui-sref=\"root.dashboard.subscriptions({tab: 'history'})\" translate=\"cw.my_account.menu.payment_history\" ng-if=\"transactions.length > 0\" connectqa-subscriptions=\"payment-history\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ui-sref=\"root.dashboard.subscriptions({tab: 'otc'})\" translate=\"cw.subscriptions.tab_otc\" ng-if=\"showOTCTab\" connectqa-subscriptions=\"activate-license\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ui-sref=\"root.dashboard.subscriptions({tab: 'plans'})\" translate=\"cw.section.subscriptions.title\" connectqa-subscriptions=\"licenses\"></span>\n            </div>\n        </div>\n\n        <div class=\"mya-wrapper\">\n            <!-- User Profile -->\n            <div ng-if=\"state.params.tab === 'profile'\">\n                <profile-image></profile-image>\n\n                <div class=\"separator-grey-mbt40\"></div>\n\n                <div class=\"mb60\">\n                    <profile-details></profile-details>\n                </div>\n\n            </div>\n\n            <!-- Security -->\n            <div ng-if=\"state.params.tab === 'security'\">\n\n                <change-email ng-if=\"!isSocialAccount()\"></change-email>\n                <div vc-recaptcha\n                    class=\"captcha2\"\n                    key=\"Recaptcha.captchaKey\"\n                    on-create=\"Recaptcha.setWidgetId(widgetId)\"\n                    on-success=\"setCaptchaResponse(response)\"\n                    size=\"invisible\"\n                >\n                </div>\n\n                <login-type ng-if=\"isSocialAccount()\"></login-type>\n\n                <div class=\"separator-grey-mbt40\"></div>\n\n                <two-factor-auth ng-if=\"loginAccountType !== 'apl_auth'\"></two-factor-auth>\n\n                <div ng-if=\"!isSocialAccount()\" class=\"mb100\">\n\n                    <div class=\"separator-grey-mbt40\"></div>\n\n                    <security-password></security-password>\n                </div>\n            </div>\n\n            <!-- Payment -->\n            <div ng-if=\"state.params.tab === 'payment'\">\n                <payment></payment>\n            </div>\n\n            <!-- Notifications -->\n            <div ng-if=\"state.params.tab === 'notifications'\">\n                <notifications></notifications>\n            </div>\n\n            <!-- Data Settings -->\n            <div ng-if=\"state.params.tab === 'data-settings'\">\n\n                <user-data></user-data>\n\n                <div class=\"separator-grey-mbt40\"></div>\n\n                <disable-account></disable-account>\n\n                <div class=\"separator-grey-mbt40\"></div>\n\n                <delete-account></delete-account>\n            </div>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),

/***/ "S8m2":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("VjBI");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "SV2/":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"cb-iframe\" id=\"cbFrame\"></div>"

/***/ }),

/***/ "Sf4F":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-auth\">\n    <div class=\"auth-region\">\n\n        <a ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n            <i class=\"sprite sprite-logo\"></i>\n            <h1>{{State.partner.name}}</h1>\n        </a>\n\n        <div class=\"form-wrapper\">\n\n            <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                <change-language></change-language>\n            </h3>\n\n            <h1 class=\"text-xxl text-grey-1 mb5\" translate=\"cw.auth.tfa.title\" connectqa-forgot=\"header\"></h1>\n            <h2 class=\"text-l text-grey-4 mb15\" translate=\"cw.auth.tfa.desc2\" connectqa-forgot=\"paragraph\" translate-values=\"{number: phone}\"></h2>\n\n\n            <form class=\"auth-form\" name=\"tfaAuthLogin\" role=\"form\" novalidate ng-submit=\"oauthCtrl.tfaAuth()\">\n                <div class=\"form-group\">\n                    <input type=\"text\"\n                           ng-model=\"tfaCode\"\n                           name=\"tfaCode\"\n                           minlength=\"1\"\n                           maxlength=\"100\"\n                           autocomplete=\"off\"\n                           ng-class=\"{'error': tfaAuthLogin.tfaCode.$invalid && submitted}\"\n                           id=\"tfa\"\n                           placeholder=\"Code\"\n                           required connectqa-forgot=\"email-address\"/>\n\n                    <p class=\"error-message fl-left\" ng-show=\"tfaAuthLogin.tfaCode.$invalid && submitted\" translate=\"cw.validator.messages.required\"></p>\n\n                    <p class=\"error-message fl-left\" ng-if=\"oauthCtrl.Auth.error && submitted\" translate=\"cw.tfa.messages.invalid_code\"></p>\n                </div>\n\n                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                        ng-disabled=\"oauthCtrl.Auth.loading\" translate=\"cw.auth.tfa.button\" translate-values=\"{brandname : brandName}\" connectqa-forgot=\"password-reset\">\n                </button>\n                <div class=\"input-checkbox mt10\">\n                    <input id=\"rm\" type=\"checkbox\" ng-model=\"tfaSetCookie\" class=\"ng-valid ng-dirty\">\n                    <label for=\"rm\" class=\"text-m text-grey-4 ng-scope\" translate=\"cw.form.remember_browser\"></label>\n                </div>\n                <div class=\"auth-actions mt10\">\n                    <a class=\"text-m text-blue-2 crs-pointer\" ng-click=\"oauthCtrl.tfaResend()\" translate=\"cw.auth.tfa.resend\" connectqa-login=\"footer-register-link\"></a>\n                </div>\n\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "SiCv":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "SlEY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', 'GdprReportsRestService', 'Util'];

var PrintGDPRReport = function PrintGDPRReport($scope, $state, GdprReportsRestService, Util) {
    _classCallCheck(this, PrintGDPRReport);

    $scope.brandName = CWCONFIG.partnerConfig.name;

    angular.element('body').addClass('print-page');

    setTimeout(function () {

        angular.element('body').removeClass('dark');
    }, 0);

    GdprReportsRestService.getAllAsync().then(function (response) {

        if (response.data.data.length > 0) {

            response.data.data.forEach(function (report) {

                var gdprReportTimestamp = Util.deepFind(report, 'attributes.report_received_timestamp');

                if (gdprReportTimestamp) {

                    $scope.gdprReportTimestamp = moment(gdprReportTimestamp).format('L');
                }

                var finalReport = Util.deepFind(report, 'attributes.final_report');

                if (finalReport) {

                    _index.GdprReportsRepository.add(JSON.parse(finalReport));
                    $scope.hasReport = true;
                    $scope.finalReport = _index.GdprReportsRepository.getAll();

                    setTimeout(function () {

                        window.print();
                    }, 500);
                } else {

                    $state.go('root.dashboard.my-account', {
                        tab: 'data-settings'
                    }, {
                        reload: true
                    });
                }
            });
        } else {

            $state.go('root.dashboard.my-account', {
                tab: 'data-settings'
            }, {
                reload: true
            });
        }
    }).catch(function () {

        $state.go('root.dashboard.my-account', {
            tab: 'data-settings'
        }, {
            reload: true
        });
    });

    $scope.print = function () {

        window.print();
    };
};

_serviceDependencies.push(PrintGDPRReport);

angular.module('controllers').controller('PrintGDPRReport', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "SyJ6":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "TA+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description
 * Controller for /debug route
 */
angular.module('controllers').controller('forceDebug', ['$rootScope', '$state', '$location', '$window', function ($rootScope, $state, $location, $window) {

    var cookieConfig = CWCONFIG.cookie;
    var domain = cookieConfig.domain;


    if ($state.params.deviceId) {

        $rootScope.State.deviceId = $state.params.deviceId;
    }

    _RFC2.default.set(cookieConfig.debug, true, { path: '/', domain: domain });

    $location.path('/auth/login');

    setTimeout(function () {

        $window.location.reload();
    }, 300);
}]);

/***/ }),

/***/ "TBo3":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("VEBJ"),
    keys = __webpack_require__("d+Uu");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "TNGQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Add / to pathname if is missing from the end of the string
 */
if (window.location.href.indexOf('#') !== -1 && window.location.pathname.slice(-1) !== '/') {

    window.location.pathname += window.location.pathname + '/';
}

(function () {
    var _window = window,
        defaultLanguage = _window.defaultLanguage;

    var base = window.location.pathname.split('/')[1];
    var head = document.getElementsByTagName('head')[0];
    var regEx = /^(([a-z]{2}-[a-z]{2})|([a-z]{2})|(lang))$/i;

    /**
     *   Add html tag
     */
    function addTag(tag, attrs) {

        var elem = document.createElement(tag);

        Object.keys(attrs).map(function (name) {

            if (attrs[name]) {

                elem.setAttribute(name, attrs[name]);
            }

            return true;
        });

        head.appendChild(elem);
    }

    // @ToDo Replace condition with language detection regexp
    if (base.match(regEx)) {

        addTag('base', { href: ['/', base, '/'].join('') });
    } else {

        window.location.pathname = defaultLanguage + window.location.pathname;
    }
})();

/***/ }),

/***/ "TYTJ":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content no-padding marketing-card-cnt\" oe-mcard-container=\"{{service}}\">\n\n    <!-- <perfect-scrollbar wheel-propagation=\"true\" wheel-speed=\"2\"> -->\n        <div id=\"marketing-card\" class=\"mkt_card\" ng-class=\"{'screenshot-active': screenshotSelected}\">\n\n            <div class=\"top-cnt\"></div>\n\n            <div class=\"mid-cnt\">\n                <div class=\"mkt-block-iconapp\">\n                    <div class=\"back-screen\" ng-show=\"screenshotSelected\" ng-click=\"backScreen()\"> < </div>\n                    <img class=\"sprite-serviceSmall mb10\" ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n                    <div class=\"mkt-apps-stars\"><div class=\"mkt-show-stars s5\"></div></div>\n                </div>\n\n                <div class=\"mkt-block-infoapp\">\n\n                    <!-- Regular app buttons -->\n                    <div class=\"btn-holder\" ng-if=\"!app.attributes.custom.manifest.browserExtensionUrl && !isbundleInstalled && $root.hasUsCompliance\">\n\n                        <!-- Install btn -->\n                        <!-- Products -->\n                        <a ng-click=\"activateService(app.id, 'install')\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.ui.install\"\n                            ng-if=\"User.id && service !== 'idgrd' && !app.attributes.custom.manifest.product_url && buttonLabel === 'install' && !isDeviceDetailsPage\"\n                            connectqa-mcard=\"install\"></a>\n\n                        <!-- Device Details -->\n                        <a ng-click=\"activateService(app.id, 'install')\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.ui.install\"\n                            ng-if=\"User.id && service !== 'idgrd' && !app.attributes.custom.manifest.product_url && buttonLabel === 'install' && isDeviceDetailsPage\"\n                            connectqa-mcard=\"install\"></a>\n\n                        <!-- Install on another device btn -->\n                        <!-- Products -->\n                        <a ng-click=\"activateService(app.id, 'other_device')\" class=\"btn btn-medium btn-primary\" translate=\"cw.deploy.modal.auto-install.button.primary-action\"\n                            ng-if=\"User.id && service !== 'idgrd' && !app.attributes.custom.manifest.product_url && buttonLabel === 'install_other' && !isDeviceDetailsPage\" connectqa-mcard=\"install\"></a>\n\n                        <!-- Device Details -->\n                        <a ng-click=\"activateService(app.id, 'other_device')\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.ui.install\"\n                            ng-if=\"User.id && service !== 'idgrd' && !app.attributes.custom.manifest.product_url && buttonLabel === 'install_other' && isDeviceDetailsPage\"\n                            connectqa-mcard=\"install\"></a>\n\n                        <!-- Activate btn -->\n                        <a ng-click=\"activateService(app.id)\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.ui.activate_now\"\n                            ng-if=\"User.id && service === 'idgrd' && deviceData[User.id].online.length > 0 && !app.attributes.custom.manifest.product_url\" connectqa-mcard=\"activate\"></a>\n\n                        <!-- Open btn -->\n                        <a ng-click=\"openServiceLink(app)\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.ui.open\"\n                            ng-if=\"app.attributes.custom.manifest.product_url\" connectqa-mcard=\"open\"></a>\n\n                        <!-- Download Fss btn -->\n                        <a ng-click=\"activateService(bundleAppId, 'install_bundle')\"\n                            class=\"btn btn-medium btn-primary\"\n                            translate=\"cw.general.ui.install\"\n                            ng-if=\"User.id && service !== 'idgrd' &&\n                            !app.attributes.custom.manifest.product_url &&\n                            buttonLabel === 'install_bundle' &&\n                            isDeviceDetailsPage\"\n                            connectqa-mcard=\"install\"></a>\n                    </div>\n\n\n                    <!-- Browser extension buttons -->\n                    <div class=\"btn-holder\" ng-if=\"app.attributes.custom.manifest.browserExtensionUrl && !isbundleInstalled && $root.hasUsCompliance\">\n                        <!-- chrome -->\n                        <a ng-if=\"browserName === 'chrome' && app.attributes.custom.manifest.browserExtensionUrl.chrome\"\n                            ng-href=\"{{app.attributes.custom.manifest.browserExtensionUrl.chrome}}\"\n                            target=\"_blank\"\n                            ng-click=\"sendMixpanelEvent(app)\"\n                            class=\"btn btn-medium btn-primary\"\n                            translate=\"cw.general.ui.install\"\n                            connectqa-mcard=\"install\"></a>\n\n                        <!-- firefox -->\n                        <a ng-if=\"browserName === 'firefox' && app.attributes.custom.manifest.browserExtensionUrl.firefox\"\n                            ng-href=\"{{app.attributes.custom.manifest.browserExtensionUrl.firefox}}\"\n                            ng-click=\"sendMixpanelEvent(app)\"\n                            class=\"btn btn-medium btn-primary\"\n                            translate=\"cw.general.ui.install\"\n                            connectqa-mcard=\"install\"></a>\n\n                        <!-- opera -->\n                        <a ng-if=\"browserName === 'opera' && app.attributes.custom.manifest.browserExtensionUrl.opera\"\n                            ng-click=\"installOperaExtension(app.attributes.custom.manifest.browserExtensionUrl.opera, app.id);sendMixpanelEvent(app)\"\n                            class=\"btn btn-medium btn-primary\"\n                            translate=\"cw.general.ui.install\"\n                            connectqa-mcard=\"install\"></a>\n                    </div>\n\n                    <h3 class=\"text-xl title-cards\">{{app.attributes.resource.oeName}}</h3>\n                    <div ng-hide=\"screenshotSelected\" class=\"available-os-holder\">\n                        <div class=\"inline-block available-os\">\n                            <span ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                ng-if=\"app.attributes.custom.manifest.os.length &&\n                                        !app.attributes.custom.manifest.browsers.length\"\n                                class=\"icon icon-xxs icon-grey-4 icon-{{osType}}\"\n                                ng-hide=\"service === 'antivirus' && osType === 'ios'\">\n                            </span>\n                        </div>\n\n                        <div class=\"inline-block available-os\">\n                            <span ng-repeat=\"browserType in app.attributes.custom.manifest.browsers\"\n                                ng-if=\"app.attributes.custom.manifest.browsers.length\"\n                                class=\"icon icon-xxs icon-grey-4 icon-{{browserType}}\"\n                                ng-hide=\"service === 'antivirus' && osType === 'ios'\">\n                            </span>\n                        </div>\n\n                    </div>\n\n                    <p class=\"text-m text-grey-3 mt10 mb20\"> {{app.attributes.resource.shortDescription}}</p>\n\n                </div>\n            </div>\n\n            <div class=\"mkt-card-tabs\">\n                <a ng-class=\"{'active': tab === 'screenshots'}\">\n                    <span translate=\"cw.mkt.card.tabs.screenshots\" ng-click=\"onTabClick('screenshots')\" connectqa-mcard=\"screenshots\"></span>\n                    <i></i>\n                </a>\n                <a ng-class=\"{'active': tab === 'details'}\">\n                    <span ng-click=\"onTabClick('details')\" translate=\"cw.dashboard.button.details\" connectqa-mcard=\"details\"></span>\n                    <i></i>\n                </a>\n                <a ng-class=\"{'active': tab === 'features'}\" ng-show=\"features.length > 0\">\n                    <span translate=\"cw.mkt.card.tabs.features\" ng-click=\"onTabClick('features')\" connectqa-mcard=\"features\"></span>\n                    <i></i>\n                </a>\n            </div>\n\n            <div class=\"mkt-content-tabs\">\n                <div class=\"screenshots-cnt\"\n                    ng-class=\"{'hide-background': app.attributes.resource.screenshots.length}\"\n                    ng-show=\"tab === 'screenshots'\"\n                >\n                    <img ng-repeat=\"screenshot in app.attributes.resource.screenshots\" ng-src=\"{{screenshot.img_src | imageUrlParse}}\" width=\"180\" height=\"120\" connectqa-mcard=\"image\"/>\n                </div>\n                <div class=\"details-cnt\" ng-show=\"tab === 'details'\">\n                    <p class=\"text-m\" ng-bind-html=\"app.attributes.resource.longDescription\"></p>\n                </div>\n\n                <div class=\"features-cnt\"  ng-show=\"tab === 'features'\" ng-init=\"idx = 0;\">\n                    <ul class=\"features-title\">\n                        <li ng-class=\"{active: ($parent.idx === $index)}\" ng-click=\"$parent.idx = $index;\"\n                            ng-repeat=\"feature in features track by $index\" connectqa-mcard=\"{{features[$index].title | lowercase}}\">\n                            <a class=\"text-grey-4 text-l\">{{features[$index].title}}</a><i></i>\n                        </li>\n                    </ul>\n                    <div class=\"ft-list\">\n                        <ul>\n                            <li class=\"text-black text-m\" ng-bind-html=\"features[idx].description\"></li>\n                        </ul>\n                    </div>\n                    <div class=\"vertical-bar\"></div>\n                    <div class=\"clear\"></div>\n                </div>\n            </div>\n        </div>\n    <!-- </perfect-scrollbar> -->\n\n    <!-- activate event handlers for screenshots functionality when html is ready -->\n    {{loadPictures()}}\n</div>\n";
var path = 'views/modals/marketing-card.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "Tk6B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var message = {};
var oMessages = new Rx.BehaviorSubject(message);

function Alert() {

    var sendMessage = function sendMessage(type, args, params, timeout) {

        oMessages.onNext({
            type: type,
            args: args,
            params: params,
            timeout: timeout
        });
    };

    return {
        success: function success(args, params, timeout) {

            sendMessage('success', args, params, timeout);
        },
        error: function error(args, params, timeout) {

            sendMessage('error', args, params, timeout);
        },
        warning: function warning(args, params, timeout) {

            sendMessage('warning', args, params, timeout);
        },
        info: function info(args, params, timeout) {

            sendMessage('info', args, params, timeout);
        },
        getObservable: function getObservable() {

            return oMessages;
        }
    };
}

exports.default = Alert();

/***/ }),

/***/ "Tv9X":
/***/ (function(module, exports) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['fred', 30], ['barney', 40]]);
 * // => { 'fred': 30, 'barney': 40 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs ? pairs.length : 0,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),

/***/ "TxrT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */

var PaymentsRestService = function (_BaseRestService) {
    _inherits(PaymentsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function PaymentsRestService($http, $q, Util) {
        _classCallCheck(this, PaymentsRestService);

        return _possibleConstructorReturn(this, (PaymentsRestService.__proto__ || Object.getPrototypeOf(PaymentsRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.PaymentsRestService#create
     * @methodOf rest.services.PaymentsRestService
     * @function
     *
     * @description
     * Create an action
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(PaymentsRestService, [{
        key: 'create',
        value: function create(payload) {

            return _get(PaymentsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentsRestService.prototype), 'create', this).call(this, payload, 'payments/');
        }
    }]);

    return PaymentsRestService;
}(_baseRestService2.default);

exports.default = PaymentsRestService;


_serviceDependencies.push(PaymentsRestService);

angular.module('rest.services').service('PaymentsRestService', _serviceDependencies);

/***/ }),

/***/ "U8js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "UiIt":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var feedback, matching, scoring, time, time_estimates, zxcvbn;

matching = __webpack_require__("PTny");

scoring = __webpack_require__("IDO2");

time_estimates = __webpack_require__("GARZ");

feedback = __webpack_require__("bVi6");

time = function() {
  return (new Date()).getTime();
};

zxcvbn = function(password, user_inputs) {
  var arg, attack_times, i, len, matches, prop, ref, result, sanitized_inputs, start, val;
  if (user_inputs == null) {
    user_inputs = [];
  }
  start = time();
  sanitized_inputs = [];
  for (i = 0, len = user_inputs.length; i < len; i++) {
    arg = user_inputs[i];
    if ((ref = typeof arg) === "string" || ref === "number" || ref === "boolean") {
      sanitized_inputs.push(arg.toString().toLowerCase());
    }
  }
  matching.set_user_input_dictionary(sanitized_inputs);
  matches = matching.omnimatch(password);
  result = scoring.most_guessable_match_sequence(password, matches);
  result.calc_time = time() - start;
  attack_times = time_estimates.estimate_attack_times(result.guesses);
  for (prop in attack_times) {
    val = attack_times[prop];
    result[prop] = val;
  }
  result.feedback = feedback.get_feedback(result.score, result.sequence);
  return result;
};

module.exports = zxcvbn;

//# sourceMappingURL=main.js.map


/***/ }),

/***/ "UlFJ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("VjBI"),
    stubFalse = __webpack_require__("dUTw");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("E4vQ")(module)))

/***/ }),

/***/ "UqIc":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "UvpQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

angular.module('filters').filter('filterCurrencies', function () {
    return function (currencies, query) {

        if (angular.isUndefined(query) || !query) {

            return currencies;
        }
        return _.filter(currencies, function (currency) {

            if (!currency) {

                return false;
            }
            return currency.toLowerCase().indexOf(query.toLowerCase()) === 0;
        });
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "Ux8H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),

/***/ "V27j":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-standard-width remove-device\" connectqa-modal=\"remove-device\">\n\t<div class=\"content-holder\">\n\t\t<div class=\"mb10\">\n\t\t\t<i class=\"icon-warning-light\"></i>\n\t\t</div>\n\t\t<h2 class=\"text-xxl mb30\" translate=\"cw.devices.remove_device_confirmation.title\"></h2>\n\t\t<ul class=\"text-left mb30\">\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.devices.remove_device_confirmation.text1\" translate-values=\"{brandname : brandName}\"></li>\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.devices.remove_device_confirmation.text2\"></li>\n\t\t\t<li class=\"text-m text-grey-2 mb10\" translate=\"cw.devices.remove_device_confirmation.text3\" translate-values=\"{brandname : brandName}\"></li>\n\t\t</ul>\n\t\t<div class=\"mt30 mb20\">\n\t\t\t<button class=\"btn btn-medium btn-primary mlr5\" ng-click=\"cancel()\" translate=\"cw.devices.keep-device\"\n\t\t\t\tconnectqa-button=\"cancel\"></button>\n\t\t\t<button class=\"btn btn-medium btn-secondary mlr5\" ng-click=\"confirmDelete()\" translate=\"cw.devices.remove\"\n\t\t\t\tconnectqa-button=\"remove-device\"></button>\n\t\t</div>\n\t\t<p class=\"text-xs text-grey-4\" translate=\"cw.devices.remove_device_confirmation.footnote\"></p>\n\t</div>\n</div>\n";
var path = 'views/modals/remove-device.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "V5z1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['$scope', '$state', '$window', 'Util', 'DeploymentUrlsRestService'];

var PaidDeploymentWizardController = function () {
    function PaidDeploymentWizardController($scope, $state, $window, Util, DeploymentUrlsRestService) {
        var _this = this;

        _classCallCheck(this, PaidDeploymentWizardController);

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.Util = Util;
        this.AppIntegrationsProcessor = _index2.AppIntegrationsProcessor;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        $scope.imgPath = CWCONFIG.imgPath;

        /* this array can contain paid apps, bundles and apps from bundles.
        e.g. [ {id: asu60, licenseId: 233312-356397, type: 'apps', oeName: 'Antivirus'} ] */
        this.allPaidApps = [];

        this.licenses = this.$scope.inputData.licenses;

        $scope.osDefaultAppId = CWCONFIG.defaultDeployedAppId[$scope.inputData.os];
        $scope.appIntegrations = {};
        $scope.osDefaultIntegration = _index.AppIntegrationsRepository.getById($scope.osDefaultAppId);
        $scope.showFreeApp = true;
        this.$scope.isMobileDeploy = false;

        var selectedOS = this.$scope.inputData.os;
        this.componentsUsefulInfo = {};

        // If user has a paid license, hide FSS
        if (this.licenses.length > 0) {

            $scope.showFreeApp = false;
        }

        if (this.$state.current.name.indexOf('.home') > -1) {

            this.page = 'Homepage';
        } else if (this.$state.current.name.indexOf('.devices') > -1) {

            this.page = 'Devices';
        } else if (this.$state.current.name.indexOf('.products') > -1) {

            this.page = 'Products';
        } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

            this.page = 'Subscriptions';
        }

        this.licenses.forEach(function (license) {

            var appId = Util.deepFind(license, 'relationships.app.data.id');
            var appIntegration = _index.AppIntegrationsRepository.getById(appId);
            var appType = Util.deepFind(appIntegration, 'attributes.type');
            var appIntegrationOSes = Util.deepFind(appIntegration, 'attributes.custom.manifest.os') || ['windows'];

            if (appIntegration) {

                /* here we iterate through all bundle apps
                and add them into 'allPaidApps' array only if
                the selected operating system is "android" or "ios" */
                if (appType === 'bundle' && (selectedOS === 'android' || selectedOS === 'ios')) {

                    _this.$scope.isMobileDeploy = true;

                    appIntegration.relationships.apps.data.forEach(function (bundleAppIntegration) {

                        var bundleAppData = _index.AppIntegrationsRepository.getById(bundleAppIntegration.id);

                        if (bundleAppData) {

                            var bundleAppOSes = Util.deepFind(bundleAppData, 'attributes.custom.manifest.os') || ['windows'];

                            // check if the bundle app OS is compatible
                            // with the selected OS "$scope.inputData.os"
                            if (_.contains(bundleAppOSes, $scope.inputData.os)) {

                                // save app information (name, icon etc...)
                                // into "$scope.appIntegrations" object
                                if (!$scope.appIntegrations[bundleAppIntegration.id]) {

                                    $scope.appIntegrations[bundleAppIntegration.id] = bundleAppData;
                                }

                                // check if the app already exists in "allPaidApps" array
                                var isAppDuplicated = _this.allPaidApps.find(function (app) {
                                    return app.id === bundleAppIntegration.id;
                                });

                                // if the app doesn't exists in "allPaidApps" array, push the app
                                if (!isAppDuplicated) {

                                    _this.allPaidApps.push({
                                        id: bundleAppIntegration.id,
                                        licenseId: license.id,
                                        type: bundleAppIntegration.type,
                                        oeName: bundleAppData.attributes.resource.oeName
                                    });

                                    _this.componentsUsefulInfo[bundleAppIntegration.id] = {
                                        is_beta_otc: license.attributes.is_beta_otc
                                    };
                                }
                            }
                        }
                    });
                }

                /* here we add all the bundles and standalone apps into 'allPaidApps' array after
                we check if the app OSes are compatible with the selected OS '$scope.inputData.os'
                */
                if (_.contains(appIntegrationOSes, $scope.inputData.os)) {

                    /* here we check if we show the default free app for the selected OS
                        OS default free app prototype and paid apps prototype must be the same
                    */
                    if (appType === 'bundle') {

                        appIntegration.relationships.apps.data.forEach(function (bundleAppIntegration) {

                            var bundleAppData = _index.AppIntegrationsRepository.getById(bundleAppIntegration.id);

                            if (bundleAppData) {

                                var bundleAppOSes = Util.deepFind(bundleAppData, 'attributes.custom.manifest.os') || ['windows'];

                                // check if the bundle app OS is compatible
                                // with the selected OS "$scope.inputData.os"
                                if (_.contains(bundleAppOSes, $scope.inputData.os)) {

                                    if (bundleAppData.attributes.prototype === $scope.osDefaultIntegration.attributes.prototype) {

                                        $scope.showFreeApp = false;
                                    }
                                }
                            }
                        });
                    }

                    // save information regarding the the app (name, icon etc...)
                    // into "$scope.appIntegrations" object
                    if (appIntegration.id && !$scope.appIntegrations[appIntegration.id]) {

                        $scope.appIntegrations[appIntegration.id] = _index.AppIntegrationsRepository.getById(appIntegration.id);
                    }

                    // check if the app already exists in "allPaidApps" array
                    var isAppDuplicated = _this.allPaidApps.find(function (app) {
                        return app.id === appIntegration.id;
                    });

                    // check if the app has been split into components
                    var appIntegrationHasBeenSplit = _this.allPaidApps.find(function (app) {

                        if (appIntegration.relationships.apps) {

                            return appIntegration.relationships.apps.data.find(function (appInt) {
                                return appInt.id === app.id;
                            });
                        }

                        return false;
                    });

                    // if the app doesn't exists in "allPaidApps" array &
                    // if the app has now been split into individual components, push to allPaidApps
                    if (!isAppDuplicated && !appIntegrationHasBeenSplit) {

                        _this.allPaidApps.push({
                            id: appIntegration.id,
                            licenseId: license.id,
                            type: appType,
                            trueBundle: _this.AppIntegrationsProcessor.checkIfTrueBundle(appIntegration, $scope.inputData.os),
                            oeName: appIntegration.attributes.resource.oeName
                            // browsers: appIntegration.attributes.custom.manifest.browsers
                        });
                    }
                }
            }

            // If the user has already Prime or a single license,
            // skip the select license step
            if ((appId === 'aps10' || appId === 'aps20') && (_this.$scope.inputData.os === 'windows' || _this.$scope.inputData.os === 'osx') || _this.licenses.length === 1 && (_this.$scope.inputData.os === 'windows' || _this.$scope.inputData.os === 'osx') || (_this.$scope.inputData.os === 'android' || _this.$scope.inputData.os === 'ios') && _this.allPaidApps.length === 1 && _this.licenses.length === 1) {

                setTimeout(function () {

                    angular.element('.deploy-modal .deploy-steps div:nth-child(2)').addClass('disabled');

                    var deployPage = 'root.dashboard.devices.ltb.deploy';

                    if (_this.$state.current.name.indexOf('.home') > -1) {

                        deployPage = 'root.dashboard.home.ltb.deploy';
                    } else if (_this.$state.current.name.indexOf('.subscriptions') > -1) {

                        deployPage = 'root.dashboard.subscriptions.ltb.deploy';
                    }

                    _this.$scope.changeWizard()(deployPage, {
                        appId: appId,
                        os: _this.$scope.inputData.os,
                        ltb: 'deploy',
                        resourceId: 'new'
                    }, {
                        reload: false
                    });
                }, 0);
            }
        });

        /*
        // check if a bundle with 'Antivirus' name exists
        let antivirusBundleNameExists =
            this.allPaidApps.findIndex(
                (app) => app.oeName === 'Antivirus' && app.type === 'bundle') !== -1;
         // if a bundle with 'Antivirus'
        // name exists, remove all standalone apps that have 'Antivirus' name
        if (antivirusBundleNameExists) {
             this.allPaidApps.forEach((app, index) => {
                 if ((app.type === 'app' || app.type === 'apps') && app.oeName === 'Antivirus') {
                     delete this.allPaidApps[index];
                }
            });
        }
        */

        // if there are no paid apps, show default app for the selected OS
        if (!this.allPaidApps.length) {

            var paramsWithDefaultApp = angular.extend({}, this.$state.params, {
                appId: CWCONFIG.defaultDeployedAppId[$scope.inputData.os],
                os: $scope.inputData.os
            });

            setTimeout(function () {

                if (_this.$state.current.name.indexOf('.home') > -1) {

                    _this.$scope.changeWizard()('root.dashboard.home.ltb.deploy', paramsWithDefaultApp, {
                        reload: false
                    });
                } else {

                    _this.$scope.changeWizard()('root.dashboard.devices.ltb.deploy', paramsWithDefaultApp, {
                        reload: false
                    });
                }
            }, 0);
        }
    }

    _createClass(PaidDeploymentWizardController, [{
        key: 'selectApp',
        value: function selectApp(appId, event, appName) {
            var _this2 = this;

            /**
             * Mobile users will install the mobile components from their app stores:
             *
             * Google Play for Android users
             * App Store for ios users
             */

            _RFC2.default.send('ConnectWeb Select License', {
                License: appName,
                'Device Os': window.deviceOs,
                Page: this.page,
                'Product ID': appId
            });

            if (this.Util.getDeviceNavigator() === 'android' && this.$scope.inputData.os === 'android' || this.Util.getDeviceNavigator() === 'ios' && this.$scope.inputData.os === 'ios') {

                // disable button until backend responds
                angular.element(event.target).addClass('disabled');

                var isBeta = false;

                if (this.componentsUsefulInfo[appId] && this.componentsUsefulInfo[appId].is_beta_otc) {

                    isBeta = this.componentsUsefulInfo[appId].is_beta_otc;
                }

                var deploymentPayload = {
                    appId: appId,
                    beta: isBeta,
                    os: this.$scope.inputData.os
                };

                this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                    // enable button
                    angular.element(event.target).removeClass('disabled');

                    // redirect user to app store
                    _this2.$window.location.href = response.data.data.attributes.download_url;
                }).catch(function () {

                    // enable button
                    angular.element(event.target).removeClass('disabled');

                    _RFC4.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {
                            cssClasses: 'icon-pc'
                        }
                    });
                });
            } else {

                var deployPage = 'root.dashboard.devices.ltb.deploy';

                if (this.$state.current.name.indexOf('.home') > -1) {

                    deployPage = 'root.dashboard.home.ltb.deploy';
                } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                    deployPage = 'root.dashboard.subscriptions.ltb.deploy';
                }

                this.$scope.changeWizard()(deployPage, {
                    appId: appId,
                    os: this.$scope.inputData.os,
                    ltb: 'deploy',
                    resourceId: 'new'
                }, {
                    reload: false
                });
            }
        }
    }]);

    return PaidDeploymentWizardController;
}();

var PaidDeploymentWizardDirective = function PaidDeploymentWizardDirective() {
    _classCallCheck(this, PaidDeploymentWizardDirective);

    this.template = __webpack_require__("lQ6f");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, $window, Util, DeploymentUrlsRestService) {
        return new PaidDeploymentWizardController($scope, $state, $window, Util, DeploymentUrlsRestService);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'paidDeploymentWizardCtrl';
};

_directiveDependencies.push(function () {
    return new PaidDeploymentWizardDirective();
});

angular.module('directives').directive('paidDeploymentWizard', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "V9tu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("TA+K");

__webpack_require__("ov1h");

__webpack_require__("FEPM");

__webpack_require__("4nGL");

__webpack_require__("D7Ue");

__webpack_require__("Wd9Q");

__webpack_require__("uOJ5");

__webpack_require__("PLm0");

__webpack_require__("XWmG");

__webpack_require__("PwY5");

__webpack_require__("Nmx8");

__webpack_require__("nnQ5");

__webpack_require__("KB0t");

__webpack_require__("Ah1u");

__webpack_require__("7XHk");

__webpack_require__("CM3t");

__webpack_require__("1SiJ");

__webpack_require__("4VJD");

__webpack_require__("zSYf");

__webpack_require__("DH9m");

__webpack_require__("5EEQ");

__webpack_require__("H7I6");

__webpack_require__("RvKr");

__webpack_require__("oY6I");

__webpack_require__("3sst");

__webpack_require__("KU+w");

__webpack_require__("SlEY");

__webpack_require__("PtFa");

__webpack_require__("OHSR");

__webpack_require__("/nQq");

__webpack_require__("nylO");

__webpack_require__("Quiy");

__webpack_require__("rHek");

__webpack_require__("DxG2");

__webpack_require__("FMLl");

__webpack_require__("XVVd");

__webpack_require__("8hbc");

__webpack_require__("Fjo9");

__webpack_require__("4qO9");

__webpack_require__("S2n6");

__webpack_require__("xSqx");

__webpack_require__("vjep");

__webpack_require__("iqiA");

__webpack_require__("qj7e");

__webpack_require__("Fg7e");

__webpack_require__("hm4D");

__webpack_require__("dFQA");

__webpack_require__("+v36");

__webpack_require__("rqSe");

__webpack_require__("Abc1");

__webpack_require__("v7hp");

__webpack_require__("dWpk");

__webpack_require__("s8o5");

__webpack_require__("hjls");

__webpack_require__("I2sd");

__webpack_require__("XIoT");

__webpack_require__("yUGW");

__webpack_require__("qGAt");

__webpack_require__("EZpZ");

__webpack_require__("ffBx");

__webpack_require__("m7dZ");

__webpack_require__("yjMe");

__webpack_require__("BE9B");

__webpack_require__("44UD");

__webpack_require__("LdeT");

__webpack_require__("z/zf");

__webpack_require__("vZC1");

__webpack_require__("nZXu");

__webpack_require__("CsP/");

__webpack_require__("s42q");

__webpack_require__("jVrz");

__webpack_require__("kEiM");

__webpack_require__("mTRq");

__webpack_require__("IRPu");

__webpack_require__("iDtk");

/***/ }),

/***/ "VEBJ":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("GBDS");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "VHf/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('shortFriendName', function () {
    return function (friend) {

        if (angular.isUndefined(friend)) {

            return null;
        }
        if (friend.f) {

            return friend.f;
        } else if (friend.l) {

            return friend.l;
        } else if (friend.e) {

            if (friend.e.indexOf('@') >= 0) {

                return friend.e.split('@')[0];
            }
            return friend.e;
        }
        return null;
    };
});

/***/ }),

/***/ "VZjL":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("EyJ2"),
    isArguments = __webpack_require__("Qziv"),
    isArray = __webpack_require__("zOp4"),
    isBuffer = __webpack_require__("UlFJ"),
    isIndex = __webpack_require__("U8js"),
    isTypedArray = __webpack_require__("RCtT");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "VetG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFC = __webpack_require__("fIlE");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-undef */

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$window'];

var CartIframeController = function CartIframeController($scope, $window) {
    var _this = this;

    _classCallCheck(this, CartIframeController);

    this.$scope = $scope;
    this.$window = $window;

    var browser = $window.browserName.toLowerCase() + $window.browserVersion;

    if (typeof Cleverbridge !== 'undefined' && browser !== 'ie11') {

        // Set fallback iframe size
        var iframeWidth = 750 - 2; // 2px for the border
        var iframeHeight = 700 - 2; // 2px for the border

        if (this.$scope.getmodalwidth && typeof this.$scope.getmodalwidth === 'function') {

            iframeWidth = this.$scope.getmodalwidth();
        }

        var storeDomain = _RFC2.default.deepFind(CWCONFIG, 'addPayment.eShopDomain') || 'e-shop.avira.com';
        _loggers2.default.debug('storeDomain', storeDomain);

        Cleverbridge.init('cbFrame', {
            debug: true,
            storeDomain: storeDomain,
            iframe: {
                width: iframeWidth,
                height: iframeHeight
            }
        });

        // Resize the iframe inside modal
        angular.element(window).bind('resize', function () {

            iframeWidth = _this.$scope.getmodalwidth();
            Cleverbridge.setWidth(iframeWidth);
        });

        var checkoutUrl = this.$scope.url;

        if (localStorage.getItem('theme') === 'dark') {

            checkoutUrl += '&x-theme=dark';
        }

        Cleverbridge.on('frameready', function () {

            _loggers2.default.debug('CB event frameready');

            if (_this.$scope.iframeready && typeof _this.$scope.iframeready === 'function') {

                _this.$scope.iframeready();
            }
        });

        Cleverbridge.on('frameloaded', function () {

            _loggers2.default.debug('CB event frameloaded');

            if (_this.$scope.frameloaded && typeof _this.$scope.frameloaded === 'function') {

                _this.$scope.frameloaded();
            }
        });

        Cleverbridge.on('purchasecomplete', function () {

            _loggers2.default.debug('CB event purchasecomplete');

            if (_this.$scope.purchasecomplete && typeof _this.$scope.purchasecomplete === 'function') {

                var transactionId = Cleverbridge.getPurchaseId();
                _this.$scope.purchasecomplete(transactionId);
            }
        });

        Cleverbridge.on('error', function (eventData) {

            _loggers2.default.error('CB IFRAME ERROR', eventData);

            if (_this.$scope.url) {

                // Fallback open the shop url in a new browser tab
                _this.$window.open(_this.$scope.url, '_blank');

                if (_this.$scope.error && typeof _this.$scope.error === 'function') {

                    _this.$scope.error(eventData);
                }
            }

            Cleverbridge.resetCallbacks();
        });

        Cleverbridge.handleCTAClick(checkoutUrl);
    } else {

        if (this.$scope.error && typeof this.$scope.error === 'function') {

            this.$scope.error({ code: 0, message: 'Cleverbridge library not loaded' });
        }

        _loggers2.default.error('CB LIB ERROR', { statusCode: 0, message: 'Cleverbridge library not loaded' });

        // Fallback open the shop url in a new browser tab
        $window.open(this.$scope.url, '_blank');
    }

    $scope.$on('$destroy', function () {

        // Disable the callbacks execution after the modal was closed
        if (typeof Cleverbridge !== 'undefined') {

            Cleverbridge.resetCallbacks();
            Cleverbridge.reset();
        }
    });
};

var CartIframeDirective = function CartIframeDirective() {
    _classCallCheck(this, CartIframeDirective);

    this.template = __webpack_require__("SV2/");
    this.restrict = 'EA';
    this.replace = true;

    this.scope = {
        width: '=',
        height: '=',
        url: '=',
        error: '=',
        iframeready: '=',
        purchasecomplete: '=',
        getmodalwidth: '=',
        frameloaded: '='
    };

    _controllerDependencies.push(function ($scope, $window) {
        return new CartIframeController($scope, $window);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'cartIframeCtrl';
};

_directiveDependencies.push(function () {
    return new CartIframeDirective();
});

angular.module('directives').directive('cartIframe', _directiveDependencies);

/***/ }),

/***/ "Vf/c":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("Hnr2"),
    toKey = __webpack_require__("4dmE");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "Vj+m":
/***/ (function(module, exports) {

module.exports = "<div class=\"settings settings-usr\">\n\n    <i class=\"icon icon-filled-arrow-down icon-white\" ng-mouseover=\"userSettingsCtrl.mixpClickHdl('settings')\" ng-click=\"userSettingsCtrl.settingsMenu.active = !userSettingsCtrl.settingsMenu.active\" connectqa-settings=\"arrow\"></i>\n\n    <div class=\"settings_dropdown\"\n         ng-click=\"userSettingsCtrl.settingsMenu.active = !userSettingsCtrl.settingsMenu.active\" ng-class=\"{'showCssBlock' : userSettingsCtrl.settingsMenu.active}\">\n\n        <ul class=\"settings_dropdown_wrap settings_dropdown_wrap-small settings_dropdown_wrap-bottom\">\n            <li ng-if=\"User.id\">\n                <a ng-click=\"userSettingsCtrl.openMyAccount()\" connectqa-settings=\"edit-profile\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-user\"></i> {{'cw.my_account.title' | translate}}\n                </a>\n            </li>\n            <li>\n                <a ng-click=\"userSettingsCtrl.sendMixpanel('Subscriptions');userSettingsCtrl.openSubscriptions()\" connectqa-settings=\"subscriptions\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-subscriptions\"></i> {{'cw.section.subscriptions.title' | translate}}\n                </a>\n            </li>\n            <li ng-if=\"$root.hasUsCompliance\" class=\"nav-help\">\n                <a ng-if=\"userSettingsCtrl.supportForPaidUsers\"\n                   ng-click=\"userSettingsCtrl.sendMixpanel('Support');userSettingsCtrl.sentEventManager()\"\n                   ui-sref=\"root.dashboard.support({tab:'support'})\"\n                   connectqa-settings=\"help\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-vip-support\"></i> {{'cw.section.support.title' | translate}}\n                </a>\n\n                <a ng-if=\"!userSettingsCtrl.supportForPaidUsers\"\n                   ng-click=\"userSettingsCtrl.sendMixpanel('Support')\"\n                   ng-href=\"{{ userSettingsCtrl.supportForFreeUsersLink }}\"\n                   target=\"_blank\"\n                   connectqa-settings=\"help\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-vip-support\"></i> {{'cw.section.support.title' | translate}}\n                </a>\n            </li>\n            <li class=\"nav-privacy\">\n                <a ng-click=\"userSettingsCtrl.sendMixpanel('Privacy')\" ng-href=\"{{ userSettingsCtrl.privacyPolicyUrl }}\" target=\"_blank\" connectqa-settings=\"privacy\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-privacy\"></i> {{'cw.menu.privacy_policy' | translate}}\n                </a>\n            </li>\n            <li ng-if=\"User.id\">\n                <a ng-click=\"userSettingsCtrl.logOut(); userSettingsCtrl.sendMixpanel('Logout')\" connectqa-settings=\"logout\">\n                    <i class=\"icon icon-xxs icon-grey-3 icon-logout\"></i> {{'cw.menu.logout' | translate}}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "VjBI":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("8f6X");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "VqLu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ "VrlS":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("sd1L");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "VtEJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppInstanceRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about app instances
 * using http requests.
 */

var AppInstanceRestService = function (_BaseRestService) {
    _inherits(AppInstanceRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function AppInstanceRestService($http, $q, Util) {
        _classCallCheck(this, AppInstanceRestService);

        return _possibleConstructorReturn(this, (AppInstanceRestService.__proto__ || Object.getPrototypeOf(AppInstanceRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.AppInstanceRestService#create
     * @methodOf rest.services.AppInstanceRestService
     * @function
     *
     * @description
     * Creates an instance.
     *
     * @param {object} instancePayload Instance payload
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(AppInstanceRestService, [{
        key: 'create',
        value: function create(instancePayload) {

            return _get(AppInstanceRestService.prototype.__proto__ || Object.getPrototypeOf(AppInstanceRestService.prototype), 'create', this).call(this, instancePayload, 'app-instances/');
        }

        /**
         * @ngdoc function
         * @name rest.services.AppInstanceRestService#update
         * @methodOf rest.services.AppInstanceRestService
         * @function
         *
         * @description
         * Updates an instance.
         *
         * @param {string} appInstanceId Instance identifier
         * @param {object} appInstancePayload Instance payload
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(appInstanceId, appInstancePayload) {

            return _get(AppInstanceRestService.prototype.__proto__ || Object.getPrototypeOf(AppInstanceRestService.prototype), 'update', this).call(this, appInstanceId, appInstancePayload, 'app-instances/');
        }

        /**
         * @ngdoc function
         * @name rest.services.AppInstanceRestService#remove
         * @methodOf rest.services.AppInstanceRestService
         * @function
         *
         * @description
         * Remove an instance.
         *
         * @param {number} instanceId Instance identifier
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'remove',
        value: function remove(instanceId) {

            return _get(AppInstanceRestService.prototype.__proto__ || Object.getPrototypeOf(AppInstanceRestService.prototype), 'remove', this).call(this, instanceId, 'app-instances/');
        }

        /**
         * @ngdoc function
         * @name rest.services.AppInstanceRestService#getAllAsync
         * @methodOf rest.services.AppInstanceRestService
         * @function
         *
         * @description
         * Retrieves app instances.
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(AppInstanceRestService.prototype.__proto__ || Object.getPrototypeOf(AppInstanceRestService.prototype), 'getAllAsync', this).call(this, 'app-instances/');
        }
    }]);

    return AppInstanceRestService;
}(_baseRestService2.default);

exports.default = AppInstanceRestService;


_serviceDependencies.push(AppInstanceRestService);

angular.module('rest.services').service('AppInstanceRestService', _serviceDependencies);

/***/ }),

/***/ "Vygv":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("eVeQ"),
    equalArrays = __webpack_require__("yGKA"),
    equalByTag = __webpack_require__("HqoE"),
    equalObjects = __webpack_require__("CI1E"),
    getTag = __webpack_require__("gfIQ"),
    isArray = __webpack_require__("zOp4"),
    isBuffer = __webpack_require__("UlFJ"),
    isTypedArray = __webpack_require__("RCtT");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "W/Il":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "W/hB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var integrations_namespaceObject = {};
__webpack_require__.d(integrations_namespaceObject, "FunctionToString", function() { return FunctionToString; });
__webpack_require__.d(integrations_namespaceObject, "InboundFilters", function() { return inboundfilters_InboundFilters; });
var transports_namespaceObject = {};
__webpack_require__.d(transports_namespaceObject, "BaseTransport", function() { return base_BaseTransport; });
__webpack_require__.d(transports_namespaceObject, "FetchTransport", function() { return fetch_FetchTransport; });
__webpack_require__.d(transports_namespaceObject, "XHRTransport", function() { return xhr_XHRTransport; });
var esm_integrations_namespaceObject = {};
__webpack_require__.d(esm_integrations_namespaceObject, "GlobalHandlers", function() { return globalhandlers_GlobalHandlers; });
__webpack_require__.d(esm_integrations_namespaceObject, "TryCatch", function() { return trycatch_TryCatch; });
__webpack_require__.d(esm_integrations_namespaceObject, "Breadcrumbs", function() { return breadcrumbs_Breadcrumbs; });
__webpack_require__.d(esm_integrations_namespaceObject, "LinkedErrors", function() { return linkederrors_LinkedErrors; });
__webpack_require__.d(esm_integrations_namespaceObject, "UserAgent", function() { return useragent_UserAgent; });
__webpack_require__.d(esm_integrations_namespaceObject, "Dedupe", function() { return dedupe_Dedupe; });

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("xgwM");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/loglevel.js
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/session.js
/**
 * Session Status
 */
var SessionStatus;
(function (SessionStatus) {
    /** JSDoc */
    SessionStatus["Ok"] = "ok";
    /** JSDoc */
    SessionStatus["Exited"] = "exited";
    /** JSDoc */
    SessionStatus["Crashed"] = "crashed";
    /** JSDoc */
    SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus || (SessionStatus = {}));
var RequestSessionStatus;
(function (RequestSessionStatus) {
    /** JSDoc */
    RequestSessionStatus["Ok"] = "ok";
    /** JSDoc */
    RequestSessionStatus["Errored"] = "errored";
    /** JSDoc */
    RequestSessionStatus["Crashed"] = "crashed";
})(RequestSessionStatus || (RequestSessionStatus = {}));
//# sourceMappingURL=session.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/severity.js
/** JSDoc */
// eslint-disable-next-line import/export
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/status.js
/** The status of an event. */
// eslint-disable-next-line import/export
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error occurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/transaction.js
var TransactionSamplingMethod;
(function (TransactionSamplingMethod) {
    TransactionSamplingMethod["Explicit"] = "explicitly_set";
    TransactionSamplingMethod["Sampler"] = "client_sampler";
    TransactionSamplingMethod["Rate"] = "client_rate";
    TransactionSamplingMethod["Inheritance"] = "inheritance";
})(TransactionSamplingMethod || (TransactionSamplingMethod = {}));
//# sourceMappingURL=transaction.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/transport.js
var Outcome;
(function (Outcome) {
    Outcome["BeforeSend"] = "before_send";
    Outcome["EventProcessor"] = "event_processor";
    Outcome["NetworkError"] = "network_error";
    Outcome["QueueOverflow"] = "queue_overflow";
    Outcome["RateLimitBackoff"] = "ratelimit_backoff";
    Outcome["SampleRate"] = "sample_rate";
})(Outcome || (Outcome = {}));
//# sourceMappingURL=transport.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/types/esm/index.js






//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/async.js
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__("v/3v");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/polyfill.js
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/error.js


/** An error emitted by Sentry SDKs and related utilities. */
var error_SentryError = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var dsn_Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, publicKey = _a.publicKey;
        return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new error_SentryError(ERROR_MESSAGE);
        }
        var _a = Object(tslib_es6["c" /* __read */])(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        // TODO this is for backwards compatibility, and can be removed in a future version
        if ('user' in components && !('publicKey' in components)) {
            components.publicKey = components.user;
        }
        this.user = components.publicKey || '';
        this.protocol = components.protocol;
        this.publicKey = components.publicKey || '';
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'publicKey', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new error_SentryError(ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new error_SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new error_SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new error_SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__("0VhR");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__("+d4d");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/logger.js

// TODO: Implement different loggers for different environments
var logger_global = Object(esm_global["a" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/**
 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
 * Restores wrapping after the callback completes.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = Object(esm_global["a" /* getGlobalObject */])();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            logger_global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            logger_global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            logger_global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
logger_global.__SENTRY__ = logger_global.__SENTRY__ || {};
var logger = logger_global.__SENTRY__.logger || (logger_global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__("k9SW");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/stacktrace.js
var esm_stacktrace = __webpack_require__("c8NG");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/supports.js


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(esm_global["a" /* getGlobalObject */])())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(esm_global["a" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in Object(esm_global["a" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(esm_global["a" /* getGlobalObject */])();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/instrument.js







var instrument_global = Object(esm_global["a" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            logger.warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = Object(tslib_es6["f" /* __values */])(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(esm_stacktrace["a" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in instrument_global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in instrument_global.console)) {
            return;
        }
        Object(object["c" /* fill */])(instrument_global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, instrument_global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    Object(object["c" /* fill */])(instrument_global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', Object(tslib_es6["a" /* __assign */])({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(instrument_global, args).then(function (response) {
                triggerHandlers('fetch', Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in instrument_global && Object(is["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in instrument_global && Object(is["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in instrument_global)) {
        return;
    }
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    Object(object["c" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: Object(is["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (Object(is["k" /* isString */])(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
                                xhr.__sentry_xhr__.body = args_1[0];
                            }
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(object["c" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    Object(object["c" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            requestKeys.push(this);
            requestValues.push(args);
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = instrument_global.onpopstate;
    instrument_global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = instrument_global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(object["c" /* fill */])(instrument_global.history, 'pushState', historyReplacementFunction);
    Object(object["c" /* fill */])(instrument_global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = instrument_global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in instrument_global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    instrument_global.document.addEventListener('click', globalDOMEventHandler, false);
    instrument_global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = instrument_global[target] && instrument_global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(object["c" /* fill */])(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        Object(object["c" /* fill */])(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = instrument_global.onerror;
    instrument_global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = instrument_global.onunhandledrejection;
    instrument_global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/memo.js
var memo = __webpack_require__("Ux8H");

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__("mjKZ");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/misc.js



/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = Object(esm_global["a" /* getGlobalObject */])();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var _a;
    if (!event.exception || !event.exception.values) {
        return;
    }
    var exceptionValue0 = event.exception.values[0];
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = exceptionValue0.mechanism;
    exceptionValue0.mechanism = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, (_a = currentMechanism) === null || _a === void 0 ? void 0 : _a.data), newMechanism.data);
        exceptionValue0.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return Object(string["c" /* snipLine */])(line, 0); });
    frame.context_line = Object(string["c" /* snipLine */])(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return Object(string["c" /* snipLine */])(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if ((_a = exception) === null || _a === void 0 ? void 0 : _a.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        Object.defineProperty(exception, '__sentry_captured__', {
            value: true,
        });
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/node.js
var node = __webpack_require__("w0ZA");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        // eslint-disable-next-line no-plusplus
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function path_resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    /* eslint-disable no-param-reassign */
    from = path_resolve(from).substr(1);
    to = path_resolve(to).substr(1);
    /* eslint-enable no-param-reassign */
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/syncpromise.js
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var syncpromise_SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(is["m" /* isThenable */])(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                void SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/promisebuffer.js


/** A simple queue that holds promises. */
var promisebuffer_PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (taskProducer) {
        var _this = this;
        if (!this.isReady()) {
            return syncpromise_SyncPromise.reject(new error_SentryError('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        void task
            .then(function () { return _this.remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add another catch here because `this.remove()` starts a new promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new syncpromise_SyncPromise(function (resolve) {
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            void syncpromise_SyncPromise.all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map
// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__("nNKG");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/utils/esm/index.js



















//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/hub/esm/scope.js


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var scope_Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = Object(tslib_es6["e" /* __spread */])(scope._breadcrumbs);
            newScope._tags = Object(tslib_es6["a" /* __assign */])({}, scope._tags);
            newScope._extra = Object(tslib_es6["a" /* __assign */])({}, scope._extra);
            newScope._contexts = Object(tslib_es6["a" /* __assign */])({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = Object(tslib_es6["e" /* __spread */])(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        }
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._tags), captureContext._tags);
            this._extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._extra), captureContext._extra);
            this._contexts = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if (Object(is["h" /* isPlainObject */])(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._tags), captureContext.tags);
            this._extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._extra), captureContext.extra);
            this._contexts = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = Object(tslib_es6["a" /* __assign */])({ timestamp: Object(time["a" /* dateTimestampInSeconds */])() }, breadcrumb);
        this._breadcrumbs = Object(tslib_es6["e" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        var _a;
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = Object(tslib_es6["a" /* __assign */])({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
            if (transactionName) {
                event.tags = Object(tslib_es6["a" /* __assign */])({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = Object(tslib_es6["e" /* __spread */])((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(Object(tslib_es6["e" /* __spread */])(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new syncpromise_SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(Object(tslib_es6["a" /* __assign */])({}, event), hint);
                if (Object(is["m" /* isThenable */])(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = Object(esm_global["a" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function scope_addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/hub/esm/session.js


/**
 * @inheritdoc
 */
var session_Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = uuid4();
        this.duration = 0;
        this.status = SessionStatus.Ok;
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = Object(time["b" /* timestampInSeconds */])();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || Object(time["b" /* timestampInSeconds */])();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : uuid4();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === SessionStatus.Ok) {
            this.update({ status: SessionStatus.Exited });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return Object(object["a" /* dropUndefinedKeys */])({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: Object(object["a" /* dropUndefinedKeys */])({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            }),
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/hub/esm/hub.js

/* eslint-disable max-lines */




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var hub_Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new scope_Scope(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = scope_Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = uuid4();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = Object(time["a" /* dateTimestampInSeconds */])();
        var mergedBreadcrumb = Object(tslib_es6["a" /* __assign */])({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var _a, _b, _c, _d, _e;
        (_c = (_b = (_a = this.getStackTop()) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.getSession()) === null || _c === void 0 ? void 0 : _c.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        (_e = (_d = this.getStackTop()) === null || _d === void 0 ? void 0 : _d.scope) === null || _e === void 0 ? void 0 : _e.setSession();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = Object(esm_global["a" /* getGlobalObject */])();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new session_Session(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === SessionStatus.Ok) {
                currentSession.update({ status: SessionStatus.Exited });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, Object(tslib_es6["e" /* __spread */])(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = Object(esm_global["a" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function hub_getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new hub_Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(node["b" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    var _a, _b, _c;
    try {
        var activeDomain = (_c = (_b = (_a = getMainCarrier().__SENTRY__) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new hub_Hub(registryHubTopStack.client, scope_Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new hub_Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/hub/esm/sessionflusher.js



/**
 * @inheritdoc
 */
var sessionflusher_SessionFlusher = /** @class */ (function () {
    function SessionFlusher(transport, attrs) {
        var _this = this;
        this.flushTimeout = 60;
        this._pendingAggregates = {};
        this._isEnabled = true;
        this._transport = transport;
        // Call to setInterval, so that flush is called every 60 seconds
        this._intervalId = setInterval(function () { return _this.flush(); }, this.flushTimeout * 1000);
        this._sessionAttrs = attrs;
    }
    /** Sends session aggregates to Transport */
    SessionFlusher.prototype.sendSessionAggregates = function (sessionAggregates) {
        if (!this._transport.sendSession) {
            logger.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        void this._transport.sendSession(sessionAggregates).then(null, function (reason) {
            logger.error("Error while sending session: " + reason);
        });
    };
    /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSessions` */
    SessionFlusher.prototype.flush = function () {
        var sessionAggregates = this.getSessionAggregates();
        if (sessionAggregates.aggregates.length === 0) {
            return;
        }
        this._pendingAggregates = {};
        this.sendSessionAggregates(sessionAggregates);
    };
    /** Massages the entries in `pendingAggregates` and returns aggregated sessions */
    SessionFlusher.prototype.getSessionAggregates = function () {
        var _this = this;
        var aggregates = Object.keys(this._pendingAggregates).map(function (key) {
            return _this._pendingAggregates[parseInt(key)];
        });
        var sessionAggregates = {
            attrs: this._sessionAttrs,
            aggregates: aggregates,
        };
        return Object(object["a" /* dropUndefinedKeys */])(sessionAggregates);
    };
    /** JSDoc */
    SessionFlusher.prototype.close = function () {
        clearInterval(this._intervalId);
        this._isEnabled = false;
        this.flush();
    };
    /**
     * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
     * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
     * `_incrementSessionStatusCount` along with the start date
     */
    SessionFlusher.prototype.incrementSessionStatusCount = function () {
        var _a, _b;
        if (!this._isEnabled) {
            return;
        }
        var scope = hub_getCurrentHub().getScope();
        var requestSession = (_a = scope) === null || _a === void 0 ? void 0 : _a.getRequestSession();
        if (requestSession && requestSession.status) {
            this._incrementSessionStatusCount(requestSession.status, new Date());
            // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
            // case captureRequestSession is called more than once to prevent double count
            (_b = scope) === null || _b === void 0 ? void 0 : _b.setRequestSession(undefined);
            /* eslint-enable @typescript-eslint/no-unsafe-member-access */
        }
    };
    /**
     * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
     * the session received
     */
    SessionFlusher.prototype._incrementSessionStatusCount = function (status, date) {
        // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
        var sessionStartedTrunc = new Date(date).setSeconds(0, 0);
        this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
        // corresponds to aggregated sessions in one specific minute bucket
        // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
        var aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
        if (!aggregationCounts.started) {
            aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
        }
        switch (status) {
            case RequestSessionStatus.Errored:
                aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
                return aggregationCounts.errored;
            case RequestSessionStatus.Ok:
                aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
                return aggregationCounts.exited;
            case RequestSessionStatus.Crashed:
                aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
                return aggregationCounts.crashed;
        }
    };
    return SessionFlusher;
}());

//# sourceMappingURL=sessionflusher.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/hub/esm/index.js




//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/minimal/esm/index.js


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = hub_getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, Object(tslib_es6["e" /* __spread */])(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, Object(tslib_es6["a" /* __assign */])({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, Object(tslib_es6["e" /* __spread */])(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', Object(tslib_es6["a" /* __assign */])({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/api.js

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 **/
var api_API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata, tunnel) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = new dsn_Dsn(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */
    API.prototype.forceEnvelope = function () {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this.getDsn();
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        if (this.forceEnvelope()) {
            return this._tunnel;
        }
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this.getDsn();
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
        var dsn = this.getDsn();
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.publicKey);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this.getDsn();
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'dsn') {
                continue;
            }
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        if (this._tunnel) {
            return this._tunnel;
        }
        var base = this.getBaseApiEndpoint();
        var dsn = this.getDsn();
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this.getDsn();
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.publicKey,
            sentry_version: SENTRY_API_VERSION,
        };
        return Object(object["f" /* urlEncode */])(auth);
    };
    return API;
}());

//# sourceMappingURL=api.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/integration.js



var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && Object(tslib_es6["e" /* __spread */])(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = Object(tslib_es6["e" /* __spread */])(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = Object(tslib_es6["e" /* __spread */])(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, Object(tslib_es6["e" /* __spread */])(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(scope_addGlobalEventProcessor, hub_getCurrentHub);
    installedIntegrations.push(integration.name);
    logger.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    Object.defineProperty(integrations, 'initialized', { value: true });
    return integrations;
}
//# sourceMappingURL=integration.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/baseclient.js

/* eslint-disable max-lines */




var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var baseclient_BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new dsn_Dsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if (checkOrSetAlreadyCaught(exception)) {
            logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = Object(is["i" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _a;
        // ensure we haven't captured this very object before
        if (((_a = hint) === null || _a === void 0 ? void 0 : _a.originalException) && checkOrSetAlreadyCaught(hint.originalException)) {
            logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            logger.warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) {
            logger.warn('Discarded session because of missing or non-string release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = Object(tslib_es6["f" /* __values */])(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === SessionStatus.Ok;
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, (crashed && { status: SessionStatus.Crashed })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new syncpromise_SyncPromise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : uuid4()), timestamp: event.timestamp || Object(time["a" /* dateTimestampInSeconds */])() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = scope_Scope.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = syncpromise_SyncPromise.resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, b), (b.data && {
                data: Object(object["d" /* normalize */])(b.data, depth),
            }))); }),
        })), (event.user && {
            user: Object(object["d" /* normalize */])(event.user, depth),
        })), (event.contexts && {
            contexts: Object(object["d" /* normalize */])(event.contexts, depth),
        })), (event.extra && {
            extra: Object(object["d" /* normalize */])(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        var _a = this.getOptions()._experiments, _experiments = _a === void 0 ? {} : _a;
        if (_experiments.ensureNoCircularStructures) {
            return Object(object["d" /* normalize */])(normalized);
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = Object(string["d" /* truncate */])(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(string["d" /* truncate */])(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = Object(string["d" /* truncate */])(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = Object(tslib_es6["e" /* __spread */])((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            logger.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a, _b;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _c = this.getOptions(), beforeSend = _c.beforeSend, sampleRate = _c.sampleRate;
        var transport = this.getTransport();
        if (!this._isEnabled()) {
            return syncpromise_SyncPromise.reject(new error_SentryError('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, Outcome.SampleRate, 'event');
            return syncpromise_SyncPromise.reject(new error_SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            var _a, _b;
            if (prepared === null) {
                (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, Outcome.EventProcessor, event.type || 'event');
                throw new error_SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _this._ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            var _a, _b;
            if (processedEvent === null) {
                (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, Outcome.BeforeSend, event.type || 'event');
                throw new error_SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof error_SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new error_SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    /**
     * Verifies that return value of configured `beforeSend` is of expected type.
     */
    BaseClient.prototype._ensureBeforeSendRv = function (rv) {
        var nullErr = '`beforeSend` method has to return `null` or a valid event.';
        if (Object(is["m" /* isThenable */])(rv)) {
            return rv.then(function (event) {
                if (!(Object(is["h" /* isPlainObject */])(event) || event === null)) {
                    throw new error_SentryError(nullErr);
                }
                return event;
            }, function (e) {
                throw new error_SentryError("beforeSend rejected with " + e);
            });
        }
        else if (!(Object(is["h" /* isPlainObject */])(rv) || rv === null)) {
            throw new error_SentryError(nullErr);
        }
        return rv;
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/transports/noop.js


/** Noop transport */
var noop_NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return syncpromise_SyncPromise.resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: Status.Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return syncpromise_SyncPromise.resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/basebackend.js


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var basebackend_BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            logger.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new error_SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new error_SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        void this._transport.sendEvent(event).then(null, function (reason) {
            logger.error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            logger.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        void this._transport.sendSession(session).then(null, function (reason) {
            logger.error("Error while sending session: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new noop_NoopTransport();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/request.js

/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = Object(tslib_es6["e" /* __spread */])((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = Object(tslib_es6["e" /* __spread */])((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = JSON.stringify(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (api.forceEnvelope() && { dsn: api.getDsn().toString() })));
    // I know this is hacky but we don't want to add `session` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    var itemHeaders = JSON.stringify({
        type: type,
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: type,
        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
    };
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || api.forceEnvelope();
    var _a = event.debug_meta || {}, transactionSampling = _a.transactionSampling, metadata = Object(tslib_es6["d" /* __rest */])(_a, ["transactionSampling"]);
    var _b = transactionSampling || {}, samplingMethod = _b.method, sampleRate = _b.rate;
    if (Object.keys(metadata).length === 0) {
        delete event.debug_meta;
    }
    else {
        event.debug_meta = metadata;
    }
    var req = {
        body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        type: eventType,
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (api.forceEnvelope() && { dsn: api.getDsn().toString() })));
        var itemHeaders = JSON.stringify({
            type: eventType,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/sdk.js


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    var _a;
    if (options.debug === true) {
        logger.enable();
    }
    var hub = hub_getCurrentHub();
    (_a = hub.getScope()) === null || _a === void 0 ? void 0 : _a.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/version.js
var SDK_VERSION = '6.14.3';
//# sourceMappingURL=version.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/integrations/functiontostring.js
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/integrations/inboundfilters.js



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var inboundfilters_InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        scope_addGlobalEventProcessor(function (event) {
            var hub = hub_getCurrentHub();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                // This checks prevents most of the occurrences of the bug linked below:
                // https://github.com/getsentry/sentry-javascript/issues/2622
                // The bug is caused by multiple SDK instances, where one is minified and one is using non-mangled code.
                // Unfortunatelly we cannot fix it reliably (thus reserved property in rollup's terser config),
                // as we cannot force people using multiple instances in their apps to sync SDK versions.
                var options = typeof self._mergeOptions === 'function' ? self._mergeOptions(clientOptions) : {};
                if (typeof self._shouldDropEvent !== 'function') {
                    return event;
                }
                return self._shouldDropEvent(event, options) ? null : event;
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + getEventDescription(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + getEventDescription(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(string["a" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return Object(string["a" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return Object(string["a" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: Object(tslib_es6["e" /* __spread */])((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: Object(tslib_es6["e" /* __spread */])((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: Object(tslib_es6["e" /* __spread */])((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                logger.error("Cannot extract message for event " + getEventDescription(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getLastValidUrl = function (frames) {
        if (frames === void 0) { frames = []; }
        var _a, _b;
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (((_a = frame) === null || _a === void 0 ? void 0 : _a.filename) !== '<anonymous>' && ((_b = frame) === null || _b === void 0 ? void 0 : _b.filename) !== '[native code]') {
                return frame.filename || null;
            }
        }
        return null;
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return this._getLastValidUrl(frames_1);
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return this._getLastValidUrl(frames_2);
            }
            return null;
        }
        catch (oO) {
            logger.error("Cannot extract url for event " + getEventDescription(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/core/esm/index.js











//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/tracekit.js
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var tracekit_chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            popSize = ex.framesToPop;
        }
        else if (reactMinifiedRegexp.test(ex.message)) {
            popSize = 1;
        }
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    var _a, _b;
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = tracekit_chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            // Arpad: Working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
            // prefix here seems like the quickest solution for now.
            var url = parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2];
            // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
            // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
            var func = parts[1] || UNKNOWN_FUNCTION;
            _a = Object(tslib_es6["c" /* __read */])(extractSafariExtensionDetails(func, url), 2), func = _a[0], url = _a[1];
            element = {
                url: url,
                func: func,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            var url = parts[3];
            var func = parts[1] || UNKNOWN_FUNCTION;
            _b = Object(tslib_es6["c" /* __read */])(extractSafariExtensionDetails(func, url), 2), func = _b[0], url = _b[1];
            element = {
                url: url,
                func: func,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunatelly "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, url) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + url : "safari-web-extension:" + url,
        ]
        : [func, url];
};
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/parsers.js


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(is["f" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(object["b" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(object["e" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = computeStackTrace(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
//# sourceMappingURL=parsers.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/eventbuilder.js





/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return syncpromise_SyncPromise.resolve(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return syncpromise_SyncPromise.resolve(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(is["e" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = eventFromStacktrace(computeStackTrace(exception));
        return event;
    }
    if (Object(is["a" /* isDOMError */])(exception) || Object(is["b" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name, code, and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(is["a" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        addExceptionTypeValue(event, message);
        if ('code' in domException) {
            event.tags = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (Object(is["d" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = eventFromStacktrace(computeStackTrace(exception));
        return event;
    }
    if (Object(is["h" /* isPlainObject */])(exception) || Object(is["f" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, options.rejection);
        addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    addExceptionTypeValue(event, "" + exception, undefined);
    addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = computeStackTrace(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/transports/utils.js

var utils_global = Object(esm_global["a" /* getGlobalObject */])();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    var _a, _b;
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if (isNativeFetch(utils_global.fetch)) {
        return (cachedFetchImpl = utils_global.fetch.bind(utils_global));
    }
    var document = utils_global.document;
    var fetchImpl = utils_global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (typeof ((_a = document) === null || _a === void 0 ? void 0 : _a.createElement) === "function") {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            if ((_b = sandbox.contentWindow) === null || _b === void 0 ? void 0 : _b.fetch) {
                fetchImpl = sandbox.contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(utils_global));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(utils_global && utils_global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof utils_global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = utils_global.navigator.sendBeacon.bind(utils_global.navigator);
        return sendBeacon(url, body);
    }
    if (supportsFetch()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}
//# sourceMappingURL=utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/transports/base.js





var CATEGORY_MAPPING = {
    event: 'error',
    transaction: 'transaction',
    session: 'session',
    attachment: 'attachment',
};
var base_global = Object(esm_global["a" /* getGlobalObject */])();
/** Base Transport class implementation */
var base_BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new promisebuffer_PromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = new api_API(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
        if (this.options.sendClientReports && base_global.document) {
            base_global.document.addEventListener('visibilitychange', function () {
                if (base_global.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new error_SentryError('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = CATEGORY_MAPPING[category] + ":" + reason;
        logger.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            logger.log('No outcomes to flush');
            return;
        }
        logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = this._api.getEnvelopeEndpointWithUrlEncodedAuth();
        // Envelope header is required to be at least an empty object
        var envelopeHeader = JSON.stringify(Object(tslib_es6["a" /* __assign */])({}, (this.options.tunnel && { dsn: this._api.getDsn().toString() })));
        var itemHeaders = JSON.stringify({
            type: 'client_report',
        });
        var item = JSON.stringify({
            timestamp: Object(time["a" /* dateTimestampInSeconds */])(),
            discarded_events: Object.keys(outcomes).map(function (key) {
                var _a = Object(tslib_es6["c" /* __read */])(key.split(':'), 2), category = _a[0], reason = _a[1];
                return {
                    reason: reason,
                    category: category,
                    quantity: outcomes[key],
                };
            }),
        });
        var envelope = envelopeHeader + "\n" + itemHeaders + "\n" + item;
        try {
            sendReport(url, envelope);
        }
        catch (e) {
            logger.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = Status.fromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited)
            logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === Status.Success) {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = CATEGORY_MAPPING[requestType];
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        return this._disabledUntil(requestType) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for (var _c = Object(tslib_es6["f" /* __values */])(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, Object(tslib_es6["f" /* __values */])(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + parseRetryAfterHeader(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/transports/fetch.js






/** `fetch` based transport */
var fetch_FetchTransport = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent(Outcome.RateLimitBackoff, sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (supportsReferrerPolicy() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new syncpromise_SyncPromise(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error_SentryError) {
                _this.recordLostEvent(Outcome.QueueOverflow, sentryRequest.type);
            }
            else {
                _this.recordLostEvent(Outcome.NetworkError, sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(base_BaseTransport));

//# sourceMappingURL=fetch.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/transports/xhr.js





/** `XHR` based transport */
var xhr_XHRTransport = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent(Outcome.RateLimitBackoff, sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new syncpromise_SyncPromise(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof error_SentryError) {
                _this.recordLostEvent(Outcome.QueueOverflow, sentryRequest.type);
            }
            else {
                _this.recordLostEvent(Outcome.NetworkError, sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(base_BaseTransport));

//# sourceMappingURL=xhr.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/transports/index.js



//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/backend.js






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var backend_BrowserBackend = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventFromException(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = Severity.Info; }
        return eventFromMessage(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (supportsFetch()) {
            return new fetch_FetchTransport(transportOptions);
        }
        return new xhr_XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(basebackend_BaseBackend));

//# sourceMappingURL=backend.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/helpers.js



var helpers_global = Object(esm_global["a" /* getGlobalObject */])();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = Object(tslib_es6["a" /* __assign */])({}, event);
                    if (options.mechanism) {
                        addExceptionTypeValue(processedEvent, undefined, undefined);
                        addExceptionMechanism(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, processedEvent.extra), { arguments: args });
                    return processedEvent;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!helpers_global.document) {
        return;
    }
    if (!options.eventId) {
        logger.error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        logger.error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = helpers_global.document.createElement('script');
    script.async = true;
    script.src = new api_API(options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = helpers_global.document.head || helpers_global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/globalhandlers.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var globalhandlers_GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = Object(tslib_es6["a" /* __assign */])({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            logger.log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            logger.log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        addInstrumentationHandler({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (data) {
                var error = data.error;
                var currentHub = hub_getCurrentHub();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || shouldIgnoreOnError() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = error === undefined && Object(is["k" /* isString */])(data.msg)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(eventFromUnknownInput(error || data.msg, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                addExceptionMechanism(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        addInstrumentationHandler({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = hub_getCurrentHub();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || shouldIgnoreOnError() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = Object(is["i" /* isPrimitive */])(error)
                    ? _this._eventFromRejectionWithPrimitive(error)
                    : eventFromUnknownInput(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = Severity.Error;
                addExceptionMechanism(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(is["e" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
            name = groups[1];
            message = groups[2];
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * Create an event from a promise rejection where the `reason` is a primitive.
     *
     * @param reason: The `reason` property of the promise rejection
     * @returns An Event object with an appropriate `exception` value
     */
    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                        value: "Non-Error promise rejection captured with value: " + String(reason),
                    },
                ],
            },
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(is["k" /* isString */])(url) && url.length > 0 ? url : Object(browser["a" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var trycatch_TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = Object(tslib_es6["a" /* __assign */])({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = Object(esm_global["a" /* getGlobalObject */])();
        if (this._options.setTimeout) {
            Object(object["c" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            Object(object["c" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            Object(object["c" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            Object(object["c" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = wrap(originalCallback, {
                mechanism: {
                    data: { function: Object(esm_stacktrace["a" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(esm_stacktrace["a" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = Object(esm_global["a" /* getGlobalObject */])();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(object["c" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(esm_stacktrace["a" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(esm_stacktrace["a" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(object["c" /* fill */])(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (eventName, fn, options) {
                var _a;
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */
                var wrappedEventHandler = fn;
                try {
                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
                    if (originalEventHandler) {
                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                    }
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Object(object["c" /* fill */])(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(esm_stacktrace["a" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = Object(esm_stacktrace["a" /* getFunctionName */])(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return wrap(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var breadcrumbs_Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = Object(tslib_es6["a" /* __assign */])({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        hub_getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, Object(tslib_es6["e" /* __spread */])(args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, Object(tslib_es6["e" /* __spread */])(args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, Object(tslib_es6["e" /* __spread */])(args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, Object(tslib_es6["e" /* __spread */])(args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, Object(tslib_es6["e" /* __spread */])(args));
                },
                type: 'history',
            });
        }
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: Severity.fromString(handlerData.level),
            message: Object(string["b" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(string["b" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        hub_getCurrentHub().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        var keyAttrs = typeof this._options.dom === 'object' ? this._options.dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(browser["b" /* htmlTreeAsString */])(handlerData.event.target, keyAttrs)
                : Object(browser["b" /* htmlTreeAsString */])(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        hub_getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            hub_getCurrentHub().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code,
                },
                type: 'http',
            }, {
                xhr: handlerData.xhr,
                input: body,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            hub_getCurrentHub().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: Severity.Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            hub_getCurrentHub().addBreadcrumb({
                category: 'fetch',
                data: Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, handlerData.fetchData), { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(esm_global["a" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = parseUrl(global.location.href);
        var parsedFrom = parseUrl(from);
        var parsedTo = parseUrl(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        hub_getCurrentHub().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

//# sourceMappingURL=breadcrumbs.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/linkederrors.js





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var linkederrors_LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        scope_addGlobalEventProcessor(function (event, hint) {
            var self = hub_getCurrentHub().getIntegration(LinkedErrors);
            if (self) {
                var handler = self._handler && self._handler.bind(self);
                return typeof handler === 'function' ? handler(event, hint) : event;
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(is["g" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = Object(tslib_es6["e" /* __spread */])(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(is["g" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = computeStackTrace(error[key]);
        var exception = exceptionFromStacktrace(stacktrace);
        return this._walkErrorTree(error[key], key, Object(tslib_es6["e" /* __spread */])([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/useragent.js



var useragent_global = Object(esm_global["a" /* getGlobalObject */])();
/** UserAgent */
var useragent_UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        scope_addGlobalEventProcessor(function (event) {
            var _a, _b, _c;
            if (hub_getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!useragent_global.navigator && !useragent_global.location && !useragent_global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = useragent_global.location) === null || _b === void 0 ? void 0 : _b.href);
                var referrer = (useragent_global.document || {}).referrer;
                var userAgent = (useragent_global.navigator || {}).userAgent;
                var headers = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, (url && { url: url })), { headers: headers });
                return Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/dedupe.js

/** Deduplication filter */
var dedupe_Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (self._shouldDropEvent(currentEvent, self._previousEvent)) {
                        logger.warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /** JSDoc */
    Dedupe.prototype._shouldDropEvent = function (currentEvent, previousEvent) {
        if (!previousEvent) {
            return false;
        }
        if (this._isSameMessageEvent(currentEvent, previousEvent)) {
            return true;
        }
        if (this._isSameExceptionEvent(currentEvent, previousEvent)) {
            return true;
        }
        return false;
    };
    /** JSDoc */
    Dedupe.prototype._isSameMessageEvent = function (currentEvent, previousEvent) {
        var currentMessage = currentEvent.message;
        var previousMessage = previousEvent.message;
        // If neither event has a message property, they were both exceptions, so bail out
        if (!currentMessage && !previousMessage) {
            return false;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
            return false;
        }
        if (currentMessage !== previousMessage) {
            return false;
        }
        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._getFramesFromEvent = function (event) {
        var exception = event.exception;
        if (exception) {
            try {
                // @ts-ignore Object could be undefined
                return exception.values[0].stacktrace.frames;
            }
            catch (_oO) {
                return undefined;
            }
        }
        else if (event.stacktrace) {
            return event.stacktrace.frames;
        }
        return undefined;
    };
    /** JSDoc */
    Dedupe.prototype._isSameStacktrace = function (currentEvent, previousEvent) {
        var currentFrames = this._getFramesFromEvent(currentEvent);
        var previousFrames = this._getFramesFromEvent(previousEvent);
        // If neither event has a stacktrace, they are assumed to be the same
        if (!currentFrames && !previousFrames) {
            return true;
        }
        // If only one event has a stacktrace, but not the other one, they are not the same
        if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
            return false;
        }
        currentFrames = currentFrames;
        previousFrames = previousFrames;
        // If number of frames differ, they are not the same
        if (previousFrames.length !== currentFrames.length) {
            return false;
        }
        // Otherwise, compare the two
        for (var i = 0; i < previousFrames.length; i++) {
            var frameA = previousFrames[i];
            var frameB = currentFrames[i];
            if (frameA.filename !== frameB.filename ||
                frameA.lineno !== frameB.lineno ||
                frameA.colno !== frameB.colno ||
                frameA.function !== frameB.function) {
                return false;
            }
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._getExceptionFromEvent = function (event) {
        return event.exception && event.exception.values && event.exception.values[0];
    };
    /** JSDoc */
    Dedupe.prototype._isSameExceptionEvent = function (currentEvent, previousEvent) {
        var previousException = this._getExceptionFromEvent(previousEvent);
        var currentException = this._getExceptionFromEvent(currentEvent);
        if (!previousException || !currentException) {
            return false;
        }
        if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
            return false;
        }
        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
            return false;
        }
        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
            return false;
        }
        return true;
    };
    /** JSDoc */
    Dedupe.prototype._isSameFingerprint = function (currentEvent, previousEvent) {
        var currentFingerprint = currentEvent.fingerprint;
        var previousFingerprint = previousEvent.fingerprint;
        // If neither event has a fingerprint, they are assumed to be the same
        if (!currentFingerprint && !previousFingerprint) {
            return true;
        }
        // If only one event has a fingerprint, but not the other one, they are not the same
        if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
            return false;
        }
        currentFingerprint = currentFingerprint;
        previousFingerprint = previousFingerprint;
        // Otherwise, compare the two
        try {
            return !!(currentFingerprint.join('') === previousFingerprint.join(''));
        }
        catch (_oO) {
            return false;
        }
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

//# sourceMappingURL=dedupe.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/client.js






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var client_BrowserClient = /** @class */ (function (_super) {
    Object(tslib_es6["b" /* __extends */])(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: SDK_VERSION,
                },
            ],
            version: SDK_VERSION,
        };
        _this = _super.call(this, backend_BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(esm_global["a" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            logger.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        injectReportDialog(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(breadcrumbs_Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(baseclient_BaseClient));

//# sourceMappingURL=client.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/sdk.js






var sdk_defaultIntegrations = [
    new integrations_namespaceObject.InboundFilters(),
    new integrations_namespaceObject.FunctionToString(),
    new trycatch_TryCatch(),
    new breadcrumbs_Breadcrumbs(),
    new globalhandlers_GlobalHandlers(),
    new linkederrors_LinkedErrors(),
    new dedupe_Dedupe(),
    new useragent_UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = sdk_defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(esm_global["a" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(client_BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    var hub = hub_getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        options.user = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, scope.getUser()), options.user);
    }
    if (!options.eventId) {
        options.eventId = hub.lastEventId();
    }
    var client = hub.getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return hub_getCurrentHub().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
    var client = hub_getCurrentHub().getClient();
    if (client) {
        return client.flush(timeout);
    }
    logger.warn('Cannot flush events. No client defined.');
    return syncpromise_SyncPromise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
    var client = hub_getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    logger.warn('Cannot flush events and disable SDK. No client defined.');
    return syncpromise_SyncPromise.resolve(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
    return wrap(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = Object(esm_global["a" /* getGlobalObject */])();
    var document = window.document;
    if (typeof document === 'undefined') {
        logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = hub_getCurrentHub();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (typeof hub.startSession !== 'function' || typeof hub.captureSession !== 'function') {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
    // We want to create a session for every navigation as well
    addInstrumentationHandler({
        callback: function (_a) {
            var from = _a.from, to = _a.to;
            // Don't create an additional session for the initial route or if the location did not change
            if (from === undefined || from === to) {
                return;
            }
            hub.startSession({ ignoreDuration: true });
            hub.captureSession();
        },
        type: 'history',
    });
}
//# sourceMappingURL=sdk.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/version.js
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var SDK_NAME = 'sentry.javascript.browser';
//# sourceMappingURL=version.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/exports.js







//# sourceMappingURL=exports.js.map
// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/@sentry/browser/esm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Integrations", function() { return INTEGRATIONS; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Severity", function() { return Severity; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Status", function() { return Status; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "addGlobalEventProcessor", function() { return scope_addGlobalEventProcessor; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return addBreadcrumb; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "captureException", function() { return captureException; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "captureEvent", function() { return captureEvent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "captureMessage", function() { return captureMessage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "configureScope", function() { return configureScope; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getHubFromCarrier", function() { return getHubFromCarrier; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "getCurrentHub", function() { return hub_getCurrentHub; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Hub", function() { return hub_Hub; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "makeMain", function() { return makeMain; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Scope", function() { return scope_Scope; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "startTransaction", function() { return startTransaction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SDK_VERSION", function() { return SDK_VERSION; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setContext", function() { return setContext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setExtra", function() { return setExtra; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setExtras", function() { return setExtras; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setTag", function() { return setTag; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setTags", function() { return setTags; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "setUser", function() { return setUser; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withScope", function() { return withScope; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BrowserClient", function() { return client_BrowserClient; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "injectReportDialog", function() { return injectReportDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "eventFromException", function() { return eventFromException; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "eventFromMessage", function() { return eventFromMessage; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaultIntegrations", function() { return sdk_defaultIntegrations; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forceLoad", function() { return forceLoad; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lastEventId", function() { return lastEventId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "onLoad", function() { return onLoad; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "showReportDialog", function() { return showReportDialog; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "close", function() { return sdk_close; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrap", function() { return sdk_wrap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "SDK_NAME", function() { return SDK_NAME; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Transports", function() { return transports_namespaceObject; });






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = Object(esm_global["a" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "W2+e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "W3A/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('services').service('Google', ['$q', '$window', function ($q, $window) {

    /**
        A deferred object for keeping the status of loading the FB SDK
        @type {$q.defer}
    */
    var deferred = $q.defer();
    /**
        The script tag HTML id for the Google JS SDK
        @type String
    */
    var SCRIPT_ID = 'google-jssdk';

    /**
        The Google Client API id
        $type String
    */

    var CLIENT_ID = '719247549433-t3io58co4udt58deh995uiet3p2rpikk.apps.googleusercontent.com';

    var SCOPES = 'https://www.googleapis.com/auth/plus.login';
    SCOPES += ' https://www.googleapis.com/auth/userinfo.email';
    SCOPES += ' https://www.googleapis.com/auth/userinfo.profile';

    /**
         Initializes the GOOGLE JS SDK.
    */
    function initAPI() {

        deferred.resolve();
    }

    /**
        Initializer for the Sandbox extension.
        Loads the Facebook JS SDK and sets up its initialization.
    */
    function init() {

        if (!$window || !$window.document) {

            deferred.reject();
            return;
        }

        if ($window.document.getElementById(SCRIPT_ID)) {

            deferred.resolve();
            return;
        }

        window.___gcfg = {
            lang: CWCONFIG.language ? CWCONFIG.language : 'en'
        };

        var gplusScript = $window.document.createElement('script');
        gplusScript.type = 'text/javascript';
        gplusScript.async = true;
        gplusScript.id = SCRIPT_ID;
        gplusScript.src = 'https://apis.google.com/js/client:plusone.js?onload=gplusAsyncInit';

        var jsScripts = $window.document.getElementsByTagName('script')[0];
        jsScripts.parentNode.insertBefore(gplusScript, jsScripts);

        $window.gplusAsyncInit = initAPI;
    }

    /**
        Callback for login API event
    */
    function handleAuthResult(authResult) {

        if (authResult && !authResult.error) {

            deferred.resolve(authResult);
        } else {

            deferred.reject();
        }
    }

    function login() {

        $window.gapi.auth.authorize({
            client_id: CLIENT_ID,
            scope: SCOPES,
            immediate: false
        }, handleAuthResult);

        deferred = $q.defer();
        return deferred.promise;
    }

    /**
        Makes API call to get user info
    */

    function getUserInfo(callback) {

        $window.gapi.client.load('plus', 'v1', function () {

            var request = $window.gapi.client.plus.people.get({
                userId: 'me'
            });
            request.execute(function (resp) {

                callback(resp);
            });
        });
    }

    /**
        Returns a promise that will be resolved when the G+ SDK is loaded
        @returns {jQuery.Promise}
    */
    function loaded() {

        return deferred.promise;
    }

    var exports = {
        init: init,
        loaded: loaded,
        login: login,
        getUserInfo: getUserInfo
    };

    return exports;
}]);

/***/ }),

/***/ "W4hc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state'];

var DeviceSettingsController = function () {
    function DeviceSettingsController($scope, $state) {
        _classCallCheck(this, DeviceSettingsController);

        this.$scope = $scope;
        this.$state = $state;
        this.device = _index.DevicesRepository.getById($scope.deviceId);
        this.isMobileDevice = _index.DevicesRepository.isMobile($scope.deviceId);
        this.isLockFunctionalityAvailable = this.checkLockAvailability();
    }

    _createClass(DeviceSettingsController, [{
        key: 'onSettingsItemClick',
        value: function onSettingsItemClick(itemName) {

            var currentPage = this.$state.current.name;
            var currentPageMixpanel = void 0;

            if (currentPage === 'root.dashboard.devices') {

                currentPageMixpanel = 'My Devices';

                if (itemName === 'Lock') {

                    this.$state.go('root.dashboard.devices.ltb', {
                        ltb: 'lock-device',
                        resourceId: this.device.id
                    });
                } else if (itemName === 'Unlock') {

                    this.$state.go('root.dashboard.devices.ltb', {
                        ltb: 'unlock-device',
                        resourceId: this.device.id
                    });
                } else if (itemName === 'Remove') {

                    this.$state.go('root.dashboard.devices.ltb', {
                        ltb: 'remove-device',
                        resourceId: this.device.id
                    });
                }
            } else if (currentPage === 'root.dashboard.device-details') {

                currentPageMixpanel = 'Device Details';

                if (itemName === 'Lock') {

                    this.$state.go('root.dashboard.device-details.ltb', {
                        ltb: 'lock-device',
                        resourceId: this.device.id
                    });
                } else if (itemName === 'Unlock') {

                    this.$state.go('root.dashboard.device-details.ltb', {
                        ltb: 'unlock-device',
                        resourceId: this.device.id
                    });
                } else if (itemName === 'Remove') {

                    this.$state.go('root.dashboard.device-details.ltb', {
                        ltb: 'remove-device',
                        resourceId: this.device.id
                    });
                }
            }

            _RFC2.default.send('ConnectWeb Device Settings ' + itemName + ' Click', {
                Page: currentPageMixpanel
            });
        }

        /*  lock/unlock functionality is available only for PC's/Laptops
            with Windows operating system */

    }, {
        key: 'checkLockAvailability',
        value: function checkLockAvailability() {

            return !this.isMobileDevice && this.device && this.device.attributes.os === 'windows';
        }
    }]);

    return DeviceSettingsController;
}();

var DeviceSettingsDirective = function DeviceSettingsDirective() {
    _classCallCheck(this, DeviceSettingsDirective);

    this.template = __webpack_require__("vTUv");
    this.restrict = 'E';
    this.replace = true;
    this.scope = { deviceId: '=', isLocked: '=' };

    _controllerDependencies.push(function ($scope, $state) {
        return new DeviceSettingsController($scope, $state);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'deviceSettingsCtrl';
};

_directiveDependencies.push(function () {
    return new DeviceSettingsDirective();
});

angular.module('directives').directive('deviceSettings', _directiveDependencies);

/***/ }),

/***/ "WK8i":
/***/ (function(module, exports) {

module.exports = "<div class=\"store-prime\">\n\n    <div class=\"header\" ng-class=\"{'header-five-devices' : hasAps10 || hasAps20}\">\n        <div class=\"container\">\n            <div class=\"content-wrapper\">\n                <div ng-if=\"hasAps10 || hasAps20\">\n                    <h2 class=\"text-xxxl text-grey-1 mt0 font-bold\" translate=\"cw.dashboard.store_prime.title_upsell\"\n                        translate-values=\"{product: product}\"></h2>\n                    <h3 class=\"text-xl text-grey-3 mt0 measure-narrow\" translate=\"cw.dashboard.store_prime.desc\">\n                    </h3>\n                </div>\n                <div ng-if=\"!hasAps10 && !hasAps20\">\n                    <h2 class=\"text-xxxl text-grey-1 mt0 font-bold\" translate=\"cw.dashboard.store_prime.title3\"></h2>\n                    <h3 class=\"text-xl text-grey-3 mt0 measure-narrow\" translate=\"cw.dashboard.store_prime.desc4\"></h3>\n                </div>\n                <div class=\"card-small mt20 mb30 pa3\" ng-class=\"{'card-small-DE': language === 'de'}\">\n                    <div class=\"box-shot-container\">\n                        <div class=\"box-shot-icon\">\n                            <img src=\"{{products.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                        </div>\n                    </div>\n                    <div class=\"awards-container\">\n                        <div>\n                            <p class=\"text-m\" translate=\"cw.dashboard.store_prime.award_title\"\n                                translate-values=\"{brandname: brandName}\"></p>\n                            <a class=\"text-m text-blue-3\" ng-click=\"primePageCtrl.gotoAnchor('FindMore')\"\n                                translate=\"cw.general.find-out-more\"></a>\n                        </div>\n                        <div ng-if=\"language === 'de'\" class=\"awards-holder-DE mt10\">\n                            <span class=\"icon-trustpilot-de mr10\"></span>\n                            <span class=\"icon-av-comparatives mr10\"></span>\n                            <span class=\"icon-av-lab mr10\"></span>\n                            <span class=\"icon-top-product\"></span>\n                        </div>\n                        <div ng-if=\"!language\" class=\"awards-holder mt10\">\n                            <span class=\"icon-avira-review\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"transition\"></div>\n    </div>\n\n\n    <div class=\"container\">\n        <div class=\"card\" id=\"anchor-prices\">\n            <div class=\"card-wrapper\">\n                <!-- <div ng-if=\"currentPrice.attributes.promotion.discount\" class=\"discount font-bold text-xxl\">{{discount}}\n                </div> -->\n                <div class=\"row\">\n                    <div class=\"col4 v-middle\">\n                        <p class=\"text-xl text-grey-2 mt0 mb10\"\n                            translate=\"cw.dashboard.store_prime.price_list.dropdown_label\"></p>\n\n                        <div class=\"custom-select mb10\"\n                            ng-class=\"{'opened' : openDropdown, 'closed': !openDropdown, 'crs-pointer': prices['aps10'].length > 0 && prices['aps20'].length > 0}\"\n                            ng-click=\"openDropdown = !openDropdown\">\n                            <p class=\"active mb0 mt0 text-grey-3 text-l\"\n                                translate=\"cw.dashboard.store_prime.price_list.number_of_devices\"\n                                translate-values=\"{devices : numberOfDevices}\" ng-if=\"numberOfDevices !== '1'\"></p>\n                            <i class=\"icon icon-arrow-down icon-grey-3 icon-xxxs\"\n                                ng-if=\"prices['aps10'].length > 0 && prices['aps20'].length > 0\"></i>\n                            <div class=\"options\" ng-if=\"prices['aps10'].length > 0 && prices['aps20'].length > 0\">\n\n                                <p class=\"mb0 mt0 text-grey-3 text-l\" ng-if=\"prices['aps10'].length > 0\"\n                                    ng-click=\"primePageCtrl.updateCurrentProduct('aps10', '5')\"\n                                    translate=\"cw.dashboard.store_prime.price_list.number_of_devices\"\n                                    translate-values=\"{devices : '5'}\"></p>\n\n                                <p class=\"mb0 mt0 text-grey-3 text-l\" ng-if=\"prices['aps20'].length > 0\"\n                                    ng-click=\"primePageCtrl.updateCurrentProduct('aps20', '25')\"\n                                    translate=\"cw.dashboard.store_prime.price_list.number_of_devices\"\n                                    translate-values=\"{devices : '25'}\"></p>\n                            </div>\n                        </div>\n\n                        <p class=\"mb0 mt0 text-grey-3 text-m ng-scope mr20\"\n                            translate=\"cw.dashboard.store_prime.price_list.desc\"\n                            translate-values=\"{devices : numberOfDevices}\"></p>\n\n                    </div>\n\n                    <div class=\"col4 v-middle\">\n                        <div class=\"radio-button mb15 text-left\" ng-repeat=\"price in prices[activeProduct]\"\n                            ng-class=\"{'active': price.attributes.runtimes === runtime.toString()}\"\n                            ng-click=\"primePageCtrl.updateRuntime(price.attributes.runtimes)\">\n                            <span class=\"radio v-middle\"></span>\n\n                            <p class=\"label mb0 mt0 text-grey-2 text-l inline-block v-middle\"\n                                ng-if=\"price.attributes.runtimes === '1'\">\n                                <span translate=\"cw.dashboard.store_prime.price_list.month_singular\" class=\"inline-block v-middle\"></span> \n                                <i class=\"icon-arrow-in icon inline-block v-middle\"></i>\n                                <app-price appid='price.id' class=\"inline-block v-middle\"></app-price>\n                            </p>\n\n                            <p class=\"label mb0 mt0 text-grey-2 text-l inline-block v-middle\"\n                                ng-if=\"price.attributes.runtimes === '12'\">\n                                <span translate=\"cw.dashboard.store_prime.price_list.year_singular\" class=\"inline-block v-middle\"></span>\n                                <i class=\"icon-arrow-in icon inline-block v-middle\"></i>\n                                <app-price appid='price.id' class=\"inline-block v-middle\"></app-price>\n                            </p>\n\n                            <p class=\"label mb0 mt0 text-grey-2 text-l inline-block v-middle\"\n                                ng-if=\"price.attributes.runtimes === '24'\">\n                                <span translate=\"cw.dashboard.store_prime.price_list.year_plural\"\n                                    translate-values=\"{years: '2'}\" class=\"inline-block v-middle\"></span> \n                                <i class=\"icon-arrow-in icon inline-block v-middle\"></i>\n                                <app-price appid='price.id'  class=\"inline-block v-middle\"></app-price>\n                            </p>\n                        </div>\n                    </div>\n\n                    <div class=\"col4 text-center v-middle button-col\">\n                        <!-- <p class=\"price text-xxxl text-green-2 mt0 mb10 font-bold\"\n                            ng-if=\"!currentPrice.attributes.promotion\">\n                            {{currentPrice.attributes.price_string}}\n                        </p>\n                        <p class=\"price text-xxxl text-green-2 mt0 mb10 font-bold line-through\"\n                            ng-if=\"currentPrice.attributes.promotion\">\n                            {{currentPrice.attributes.price_string}}\n                        </p> -->\n\n                        <app-price ng-if=\"currentPrice.attributes.runtimes > '1'\" appid='currentPrice.id' showyearlabel=\"true\" showcmalabel=\"true\" class=\"product-price\"></app-price>\n                        <app-price ng-if=\"currentPrice.attributes.runtimes === '1'\" appid='currentPrice.id' showmonthlabel=\"true\" showcmalabel=\"true\" class=\"product-price\"></app-price>\n\n                        <button ng-if=\"!showOPCButton || !isOneClickPaymentEnable\" class=\"btn btn-large btn-primary\"\n                            ng-click=\"primePageCtrl.buy(activeProduct, currentPrice.attributes.runtimes)\"\n                            translate=\"cw.general.upgrade_now\"></button>\n                        <ocp-button classname='\"btn btn-large btn-primary\"' translationkey='\"cw.general.upgrade_now\"'\n                            action='\"Update\"' productid=\"activeProduct\" runtime=\"runtime\" page='\"Prime Store\"'\n                            xacontent='\"prime_store_ocp_\"'\n                            xamedium='\"prime_store_ocp_\"'></ocp-button>\n\n                        <!-- <div class=\"text-m mt15 text-orange-2 font-medium\"\n                            ng-if=\"primeDiscount && currentPrice.attributes.runtimes !== '1'\"\n                            translate=\"cw.store.discount\"\n                            translate-values=\"{ percent: primeDiscount }\"></div>\n                        <div class=\"text-m mt15 text-orange-2 font-medium\"\n                            ng-if=\"primeDiscount && currentPrice.attributes.runtimes === '1' && activeProduct === 'aps20'\"\n                            translate=\"cw.store.discount\"\n                            translate-values=\"{ percent: primeDiscount }\"></div> -->\n                    </div>\n                </div>\n            </div>\n            <div class=\"card-label text-grey-3\" translate=\"cw.cma.remaining_runtime\"></div>\n        </div>\n    </div>\n    <div id=\"FindMore\"></div>\n    <div class=\"large-container\">\n        <div class=\"text-center\">\n            <h2 class=\"text-xxxl text-grey-1 mt90 font-bold\"\n                translate=\"cw.dashboard.store_prime.price_list.products_title\"></h2>\n            <h2 class=\"text-xxxl text-grey-1 mt10\" translate=\"cw.dashboard.store_prime.price_list.products_desc\"></h2>\n        </div>\n        <div class=\"row mt50 products-row\">\n            <div class=\"col2\">\n                <i class=\"icon icon-laptop-windows-2 icon-l mb10 icon-grey-3\"></i>\n                <p class=\"text-xl text-grey-3 mt0 mb30 text-center\"\n                    translate=\"cw.dashboard.store_prime.price_list.products.windows\"></p>\n                <div class=\"products-wrapper text-left\">\n                    <div ng-repeat=\"product in windowsProducts | orderBy: 'attributes.custom.manifest.order'\"\n                        class=\"w100 mb10\" ng-hide=\"product.id.indexOf('aib0') > -1\">\n                        <div class=\"icon-holder inline-block v-middle\">\n                            <img ng-src=\"{{product.attributes.resource.wsLargeImageUrl}}\">\n                        </div>\n                        <p class=\"text-blue-3 text-m inline-block v-middle mt0 mb0 ml10\">\n                            {{product.attributes.resource.oeName}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col2\">\n                <i class=\"icon icon-laptop-osx-2 icon-l mb10 icon-grey-3\"></i>\n                <p class=\"text-xl text-grey-3 mt0 mb30 text-center\"\n                    translate=\"cw.dashboard.store_prime.price_list.products.mac\"></p>\n                <div class=\"products-wrapper text-left\">\n                    <div ng-repeat=\"product in osxProducts | orderBy: 'attributes.custom.manifest.order'\"\n                        class=\"w100 mb10\">\n                        <div class=\"icon-holder inline-block v-middle\">\n                            <img ng-src=\"{{product.attributes.resource.wsLargeImageUrl}}\">\n                        </div>\n                        <p class=\"text-blue-3 text-m inline-block v-middle mt0 mb0 ml10\">\n                            {{product.attributes.resource.oeName}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col2\">\n                <i class=\"icon icon-phone-tablet-android icon-l mb10 icon-grey-3\"></i>\n                <p class=\"text-xl text-grey-3 mt0 mb30 text-center\"\n                    translate=\"cw.dashboard.store_prime.price_list.products.android\"></p>\n                <div class=\"products-wrapper text-left\">\n                    <div ng-repeat=\"product in androidProducts | orderBy: 'attributes.custom.manifest.order'\"\n                        class=\"w100 mb10\">\n                        <div class=\"icon-holder inline-block v-middle\">\n                            <img ng-src=\"{{product.attributes.resource.wsLargeImageUrl}}\">\n                        </div>\n                        <p class=\"text-blue-3 text-m inline-block v-middle mt0 mb0 ml10\">\n                            {{product.attributes.resource.oeName}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col2\">\n                <i class=\"icon icon-phone-tablet-ios icon-l mb10 icon-grey-3\"></i>\n                <p class=\"text-xl text-grey-3 mt0 mb30 text-center\"\n                    translate=\"cw.dashboard.store_prime.price_list.products.ios\"></p>\n                <div class=\"products-wrapper text-left\">\n                    <div ng-repeat=\"product in iosProducts | orderBy: 'attributes.custom.manifest.order'\"\n                        class=\"w100 mb10\">\n                        <div class=\"icon-holder inline-block v-middle\">\n                            <img ng-src=\"{{product.attributes.resource.wsLargeImageUrl}}\">\n                        </div>\n                        <p class=\"text-blue-3 text-m inline-block v-middle mt0 mb0 ml10\">\n                            {{product.attributes.resource.oeName}}</p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col2\">\n                <i class=\"icon icon-browsers icon-l mb10 icon-grey-3\"></i>\n                <p class=\"text-xl text-grey-3 mt0 mb30 text-center\"\n                    translate=\"cw.dashboard.store_prime.price_list.products.browsers\"></p>\n                <div class=\"products-wrapper text-left\">\n                    <div ng-repeat=\"product in browsersExtensions | orderBy: 'attributes.custom.manifest.order'\"\n                        class=\"w100 mb10\">\n                        <div class=\"icon-holder inline-block v-middle\">\n                            <img ng-src=\"{{product.attributes.resource.wsLargeImageUrl}}\">\n                        </div>\n                        <p class=\"text-blue-3 text-m inline-block v-middle mt0 mb0 ml10\">\n                            {{product.attributes.resource.oeName}}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <div class=\"text-center\">\n            <h2 class=\"text-xxxl text-grey-1 mt70 font-bold\"\n                translate=\"cw.dashboard.store_prime.price_list.more_features.title\"\n                translate-values=\"{brandname: brandName}\"></h2>\n        </div>\n\n        <div class=\"row mt50 text-center\">\n            <div class=\"col4 text-center v-top\">\n                <i class=\"icon icon-vip-support icon-m mb10 icon-blue-3\"></i>\n                <h2 class=\"text-xxl text-grey-1 mt30 mb10\"\n                    translate=\"cw.dashboard.store_prime.price_list.more_features.vip_support.title\"></h2>\n                <p class=\"text-m text-grey-3 mt0 description\"\n                    translate=\"cw.dashboard.store_prime.price_list.more_features.vip_support.desc\"\n                    translate-values=\"{brandname: brandName, product: product}\"></p>\n            </div>\n            <div class=\"col4 text-center v-top\">\n                <i class=\"icon icon-flexibility icon-m mb10 icon-blue-3\"></i>\n                <h2 class=\"text-xxl text-grey-1 mt30 mb10\"\n                    translate=\"cw.dashboard.store_prime.price_list.more_features.full_flexibility.title\"></h2>\n                <p class=\"text-m text-grey-3 mt0 description\"\n                    translate=\"cw.dashboard.store_prime.price_list.more_features.full_flexibility.desc\"\n                    translate-values=\"{brandname: brandName, product: product}\"></p>\n            </div>\n        </div>\n\n        <div class=\"mt50 mb50 text-center\">\n            <button class=\"btn btn-large btn-primary\" ng-click=\"primePageCtrl.gotoAnchor('top')\"\n                translate=\"cw.dashboard.store_prime.price_list.more_features.see_plans_and_pricing\"></button>\n        </div>\n    </div>\n    <cma-disclaimer></cma-disclaimer>\n</div>"

/***/ }),

/***/ "Wd9Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$window', 'Auth', 'Util', '$rootScope', 'Sso'];

/**
 * @ngdoc service
 * @name controllers.Forgot
 *
 * @description
 * Forgot password controller
 */

var Forgot = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} $rootScope
     * @param  {any} Sso
     */
    function Forgot($scope, $window, Auth, Util, $rootScope, Sso) {
        _classCallCheck(this, Forgot);

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.Auth.loading = false;
        this.Auth.error = false;
        this.Recaptcha = _recaptcha2.default;
        this.Sso = Sso;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.captchaRequired = false;
        this.$scope.submitted = false;

        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();
        }

        // prefill email address if we receive an email param
        // this param should be base64 encoded
        this.$scope.email = this.isBase64();

        if (this.$rootScope.forgotEmail) {

            this.$scope.email = this.$rootScope.forgotEmail;
            delete this.$rootScope.forgotEmail;
        }

        _RFC2.default.send('ConnectWeb Auth Forgot Open', {
            Source: 'Direct'
        });
    }

    _createClass(Forgot, [{
        key: 'isBase64',
        value: function isBase64() {

            try {

                return this.Sso.getDecodedEmailAddress();
            } catch (err) {

                return '';
            }
        }

        // SSO skip the login and redirect to skip_uri received in params

    }, {
        key: 'skip',
        value: function skip() {

            _RFC2.default.send('ConnectWeb Skip Click', {
                Page: 'Auth Login'
            });

            this.$window.location = this.$scope.skipUri;
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword() {

            var forgotPasswordPayload = {
                data: {
                    attributes: {
                        email: this.$scope.email
                    },
                    type: 'passwords',
                    relationships: {
                        partner: {
                            data: {
                                type: 'partners',
                                id: this.$window.appName
                            }
                        }
                    }
                },
                meta: {
                    language: CWCONFIG.language
                }
            };

            var token = this.Util.getToken();

            var headers = {
                Authorization: token ? 'Bearer ' + token : 'Basic ' + this.Util.base64encode(CWCONFIG.oauthKey)
            };

            var captchaRespose = this.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            this.$scope.submitted = true;

            _RFC2.default.send('ConnectWeb Forgot Password Click', {
                Page: 'Auth Forgot'
            });

            if (this.$scope.forgotPasswordForm.$valid) {

                this.Auth.loading = true;
                this.Auth.forgotPassword(forgotPasswordPayload, headers);
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            if (this.$window.grecaptcha) {

                this.Recaptcha.execute();
            } else {

                this.forgotPassword();
            }
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            this.Recaptcha.setCaptchaResponse(response);
            this.forgotPassword();
        }
    }]);

    return Forgot;
}();

_serviceDependencies.push(Forgot);

angular.module('controllers').controller('Forgot', _serviceDependencies);

/***/ }),

/***/ "WfqQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("7roQ"),
    stubArray = __webpack_require__("C2H/");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "Wkhp":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "WqM0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'UserRestService', 'Util', 'Auth', '$rootScope'];

/**
 * @ngdoc directive
 * @name directives.controller.securityPasswordController
 *
 * @description
 * change password controller
 */

var SecurityPasswordController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} $rootScope
     */
    function SecurityPasswordController($scope, UserRestService, Util, Auth, $rootScope) {
        _classCallCheck(this, SecurityPasswordController);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$scope.resetPasswordFailedAttempts = 0;
        this.Auth = Auth;
        this.MeRepository = _index.MeRepository;
        this.UserRestService = UserRestService;
        this.Util = Util;
        this.user = _index.MeRepository.getMyUser();
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.submitted = false;
        this.$scope.loading = false;
        this.passwordScore = {};
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
    }

    /**
     * @ngdoc directive
     * @name directives.controller.securityPasswordController#changePassword
     * @methodOf directives.controller.securityPasswordController
     *
     * @description
     * changes the user password
     */


    _createClass(SecurityPasswordController, [{
        key: 'changePassword',
        value: function changePassword() {
            var _this = this;

            var payload = {
                data: {
                    id: this.user.id,
                    type: this.user.type,
                    attributes: {
                        password: this.$scope.newPassword
                    }
                },
                meta: {
                    logout: this.$scope.logoutFromAllDevices,
                    old_password: this.$scope.oldPassword
                }
            };

            this.getPasswordScore(this.$scope.newPassword);

            var passwordsAreDifferent = this.$scope.resetPasswordForm.oldPassword.$viewValue !== this.$scope.resetPasswordForm.newPassword.$viewValue;

            this.$scope.resetPasswordForm.oldPassword.$setValidity('serverValidation', true);

            var formIsValid = this.$scope.resetPasswordForm.$valid && passwordsAreDifferent && this.passwordScore.valid;

            this.$scope.submitted = true;

            if (formIsValid) {

                this.$scope.loading = true;

                this.UserRestService.update(this.user.id, payload).then(function () {

                    _this.$scope.oldPassword = null;
                    _this.$scope.newPassword = null;
                    _this.$scope.submitted = false;
                    _this.$scope.loading = false;

                    _RFC4.default.send('ConnectWeb Change Password Click', {
                        Logout: _this.$scope.logoutFromAllDevices ? 'true' : 'false'
                    });

                    _this.Auth.logOut();
                }).catch(function (error) {

                    var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                    _this.$scope.loading = false;
                    switch (errorCode) {

                        // if the current password is not valid
                        case '21114':
                            _this.$scope.resetPasswordFailedAttempts += 1;
                            _this.$scope.resetPasswordForm.oldPassword.$setPristine();
                            _this.$scope.resetPasswordForm.oldPassword.$setValidity('serverValidation', false);
                            break;

                        default:
                            _RFC2.default.error('cw.notification.security.change_password.error');
                            break;

                    }
                });
            }
        }

        /**
         * @ngdoc directive
         * @name directives.controller.securityPasswordController#setEmail
         * @methodOf directives.controller.securityPasswordController
         *
         * @description
         * set the email for the forgot page on the rootScope
         */

    }, {
        key: 'setEmail',
        value: function setEmail() {

            this.$rootScope.forgotEmail = this.user.attributes.email;
        }

        /**
         * @ngdoc directive
         * @name directives.controller.securityPasswordController#showPassword
         * @methodOf directives.controller.securityPasswordController
         *
         * @description
         * makes the input fields type - text or password
         */

    }, {
        key: 'showPassword',
        value: function showPassword(inputId) {

            var input = angular.element('#' + inputId)[0];

            input.type = input.type === 'text' ? 'password' : 'text';

            if (inputId === 'oldPassword') {

                this.$scope.oldInputType = input.type;
            } else if (inputId === 'newPassword') {

                this.$scope.newInputType = input.type;
            }
        }
    }, {
        key: 'getPasswordScore',
        value: function getPasswordScore(password) {

            this.passwordScore = this.Util.getPasswordScore(password);
        }
    }]);

    return SecurityPasswordController;
}();

/**
 * @ngdoc directive
 * @name directives.securityPasswordDirective
 *
 * @description
 * change password directive
 */


var SecurityPasswordDirective = function SecurityPasswordDirective() {
    _classCallCheck(this, SecurityPasswordDirective);

    this.template = __webpack_require__("K4GD");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, UserRestService, Util, Auth, $rootScope) {
        return new SecurityPasswordController($scope, UserRestService, Util, Auth, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'securityPasswordCtrl';
};

_directiveDependencies.push(function () {
    return new SecurityPasswordDirective();
});

angular.module('directives').directive('securityPassword', _directiveDependencies);

/***/ }),

/***/ "Wxmz":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div ng-if=\"hideControls === false\" id=\"lightbox\" class=\"central-position\" ng-click=\"close(); saveData()\">\n        <div class=\"table-display\">\n            <div class=\"table-cell-display\">\n                <div class =\"no-click-area\" ng-click=\"$event.stopPropagation()\"\n                    ng-if=\"disableCloseModal || disableCloseModalPaymentCart || $root.disableCloseModalOCP\"></div>\n                <div class=\"click-area-lightbox\" ng-click=\"register($event); $event.stopPropagation();\"\n                    ng-class=\"{'z-index5':disableCloseModal}\">\n                    <i ng-if=\"hideControls === false && showCloseBtn === true\" id=\"close_button_modal\" class=\"close-lightbox icon icon-close icon-grey-2\" ng-click=\"close();\"></i>\n                    <i ng-if=\"hideControls === false\" class=\"close-lightbox-mobile\" ng-click=\"close();\"></i>\n                    <div ng-include=\"template\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"hideControls === true\" class=\"mktLauncher\" id=\"lightbox\">\n        <div class=\"click-area-lightbox\">\n            <div ng-include=\"template\"></div>\n        </div>\n\n        <button class=\"debug-button\" ng-show=\"hideControls && customDebug\" ng-click=\"(visibleLog = !visibleLog)\">Show/Hide log</button>\n        <custom-debug class=\"debug\" ng-show=\"(hideControls && visibleLog && customDebug)\"></custom-debug>\n    </div>\n</div>"

/***/ }),

/***/ "Wxwx":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("UqIc"),
    defineProperty = __webpack_require__("jmhn"),
    identity = __webpack_require__("atk5");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "X1NH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('directives').directive('openPopup', function () {
    return {
        template: '',
        restrict: 'A',
        replace: false,
        link: function link(scope, element) {

            element.on('click', function () {

                // show/hide popup on mobile
                if (window.deviceType === 'mobile') {

                    if (element.hasClass('active')) {

                        element.removeClass('active');
                        element.next().removeClass('showBlock');
                    } else {

                        element.addClass('active');
                        element.next().addClass('showBlock');
                    }
                }
            });
        }
    };
});

/***/ }),

/***/ "X9N5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$rootScope', '$scope', '$state', 'Util', 'ProfileImageRestService', 'UserRestService'];

var _$scope = void 0;
var _$state = void 0;
var _Util = void 0;
var _UserRestService = void 0;
var _MeRepository = void 0;

var ProfileImageController = function () {
    function ProfileImageController($rootScope, $scope, $state, Util, ProfileImageRestService, UserRestService) {
        _classCallCheck(this, ProfileImageController);

        this.ProfileImageRestService = ProfileImageRestService;

        _UserRestService = UserRestService;
        _MeRepository = _index.MeRepository;
        _Util = Util;
        _$scope = $scope;
        _$state = $state;

        _$scope.user = _index.MeRepository.getMyUser();
        _$scope.imageFile = {};

        // MeRepository Observable
        var meRepositoryObservable = _index.MeRepository.getObservable();
        var onNextMeRepository = function onNextMeRepository() {

            // get user from MeRepository
            _$scope.user = _index.MeRepository.getMyUser();
        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(onNextMeRepository, function () {}, function () {});

        // validate image size: maximum 2 MB
        var isImageSizeValid = function isImageSizeValid(size) {
            return size < 2000 * 1000;
        };

        // validate image formats: gif, jpg, png, jpeg
        var isImageTypeValid = function isImageTypeValid(type) {
            return !!type.match(/(?:gif|jpg|png|jpeg)$/);
        };

        var inputFileElement = angular.element('#inputFile');

        /* on change event;
            here we are using $scope.$apply because angular
            does not have direct binding for "on change event" */
        inputFileElement.bind('change', function (event) {

            var fileExists = _Util.deepFind(event, 'currentTarget.files.length');

            if (fileExists) {

                var file = inputFileElement[0].files[0];

                if (isImageSizeValid(file.size) && isImageTypeValid(file.type)) {

                    /* 1. set on $rootScope the @event param data.
                        2. the @event data will be used by "ui-cropper" directive */
                    $rootScope.imageFileEvent = event;

                    // remove error message if the image file is valid
                    _$scope.$apply(function () {

                        delete _$scope.imageFile.error;
                    });

                    // open image cropping modal
                    _$state.go('root.dashboard.my-account.ltb', {
                        ltb: 'crop-image'
                    });
                }

                // error cases
                if (!isImageSizeValid(file.size)) {

                    _$scope.$apply(function () {

                        _$scope.imageFile.error = 'tooLarge';
                    });
                }

                if (!isImageTypeValid(file.type)) {

                    _$scope.$apply(function () {

                        _$scope.imageFile.error = 'wrongFormat';
                    });
                }
            } else {

                // remove error message if the user closes the browsing files window
                _$scope.$apply(function () {

                    delete _$scope.imageFile.error;
                });
            }
        });
    }

    _createClass(ProfileImageController, [{
        key: 'removeImage',
        value: function removeImage(action) {

            _RFC2.default.send('ConnectWeb Remove Photo Click');

            // this call removes the image from server
            this.ProfileImageRestService.remove(action).then(function () {

                var userImagePayload = {
                    data: {
                        attributes: {
                            profile_image_medium: ''
                        },
                        type: 'users',
                        id: _$scope.user.id
                    }
                };

                // update user attribute "profile_image_medium" with an empty string
                _UserRestService.update(_$scope.user.id, userImagePayload).then(function (response) {

                    _MeRepository.update(response.data.data);
                    _Util.updateLastLoginObjectInLocalStorage(response.data.data);
                    _RFC4.default.success('cw.profile.picture.alerts.remove_success');
                }).then(null, function () {

                    _RFC4.default.error('cw.profile.picture.alerts.remove_error');
                });
            }).then(null, function () {

                _RFC4.default.error('cw.profile.picture.alerts.remove_error');
            });
        }
    }, {
        key: 'onOpenFileBrowser',
        value: function onOpenFileBrowser() {

            _RFC2.default.send('ConnectWeb Upload Photo Click');

            // reset input value every time we click it in order to emit "on change" event
            angular.element('#inputFile')[0].value = '';
        }
    }]);

    return ProfileImageController;
}();

var ProfileImageDirective = function ProfileImageDirective() {
    _classCallCheck(this, ProfileImageDirective);

    this.template = __webpack_require__("A1RL");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($rootScope, $scope, $state, Util, ProfileImageRestService, UserRestService) {
        return new ProfileImageController($rootScope, $scope, $state, Util, ProfileImageRestService, UserRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'profileImageCtrl';
};

_directiveDependencies.push(function () {
    return new ProfileImageDirective();
});

angular.module('directives').directive('profileImage', _directiveDependencies);

/***/ }),

/***/ "XEU7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("BrLi");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("+l76");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _appInstances = [];
var observableAppInstances = new Rx.BehaviorSubject(_appInstances);
var observableSingleInstances = [];

/**
     * @ngdoc service
     * @name repositories.AppInstancesRepository
     *
     * @description
     * This class is used to save/add app instances objects.
     */
var AppInstancesRepository = {
    replace: function replace(data) {

        _appInstances = data;
        observableAppInstances.onNext(_appInstances);
        observableSingleInstances.forEach(function (observableInstance) {

            observableInstance.observable.onNext(data.find(function (newInstance) {
                return newInstance.id === observableInstance.id;
            }));
        });
    },


    /**
         * @ngdoc function
         * @name repositories.AppInstancesRepository#update
         * @methodOf repositories.AppInstancesRepository
         * @function
         *
         * @description
         * This function can be used to update an instance from repository.
         *
         * @param {object} instance an instance object with new values.
         */
    update: function update(instance) {

        var indexOfInstance = _appInstances.findIndex(function (_instance) {
            return String(_instance.id) === String(instance.id);
        });
        if (indexOfInstance >= 0) {

            var flattenDiff = _RFC2.default.getFlattenDiff(_appInstances[indexOfInstance], instance);
            _RFC4.default.processUpdate(flattenDiff, this.getById(instance.id));

            _appInstances[indexOfInstance] = instance;

            observableAppInstances.onNext(_appInstances);
            var singleInstanceObservable = this.searchObservableFor(instance);
            if (singleInstanceObservable) {

                singleInstanceObservable.observable.onNext(instance);
            }
        }
    },


    /**
         * @ngdoc function
         * @name repositories.AppInstancesRepository#add
         * @methodOf repositories.AppInstancesRepository
         * @function
         *
         * @description
         * This function can be used to add a new instance to repository.
         *
         * @param {object} instance An instance object.
         */
    add: function add(instance) {

        var indexOfInstance = _appInstances.findIndex(function (_instance) {
            return String(_instance.id) === String(instance.id);
        });
        if (indexOfInstance === -1) {

            _appInstances.push(instance);
            observableAppInstances.onNext(_appInstances);
        }
    },


    /**
         * @ngdoc function
         * @name repositories.AppInstancesRepository#remove
         * @methodOf repositories.AppInstancesRepository
         * @function
         *
         * @description
         * This function can be used to remove an instance from repository.
         *
         * @param {integer} instanceId Id of the instance to be removed.
         */
    remove: function remove(instanceId) {

        var indexOfInstance = _appInstances.findIndex(function (_instance) {
            return String(_instance.id) === String(instanceId);
        });

        if (indexOfInstance >= 0) {

            _RFC4.default.processDelete(this.getById(instanceId));

            _appInstances.splice(indexOfInstance, 1);
            observableAppInstances.onNext(_appInstances);

            var singleInstanceObservableIndex = observableSingleInstances.findIndex(function (observableInstance) {

                if (observableInstance.id === instanceId) {

                    observableInstance.observable.onNext(undefined);
                    return true;
                }

                return false;
            });
            observableSingleInstances.splice(singleInstanceObservableIndex, 1);
        }
    },
    getAll: function getAll() {

        return _appInstances;
    },


    /**
         * Returns the instance object after its id.
         * @param id
         */
    getById: function getById(id) {

        return _appInstances.find(function (appInstance) {
            return String(appInstance.id) === String(id);
        });
    },


    /**
     * Returns the instance for a specific app and a specific device.
     * @param appId
     * @param deviceId
     */
    getByDeviceIdAndAppId: function getByDeviceIdAndAppId(deviceId, appId) {

        return _appInstances.find(function (appInstance) {

            if (appInstance.relationships.device) {

                return String(appInstance.relationships.device.data.id) === String(deviceId) && String(appInstance.relationships.app.data.id) === String(appId);
            }

            return false;
        });
    },


    /**
         * Returns the instances of an user for a specific integration.
         * @param userId
         * @param integrationId
         */
    getByAppIntegration: function getByAppIntegration(userId, integrationId) {

        var instances = [];

        _appInstances.forEach(function (instance) {

            if (String(instance.relationships.user.data.id) === String(userId) && String(instance.relationships.app.data.id) === String(integrationId)) {

                instances.push(instance);
            }
        });

        return instances;
    },
    getObservable: function getObservable() {

        return observableAppInstances;
    },


    /**
         * @ngdoc function
         * @name repositories.AppInstancesRepository#searchObservableFor
         * @methodOf repositories.AppInstancesRepository
         * @function
         *
         * @description
         * Searches for the observable object of an instance.
         *
         * @param {object} instance The instance object.
         *
         * @return {object} The observable object of the instance; undefined if it doesn't exist.
         */
    searchObservableFor: function searchObservableFor(instance) {

        return observableSingleInstances.find(function (observableInstance) {
            return String(observableInstance.id) === String(instance.id);
        });
    },


    /**
         * @ngdoc function
         * @name repositories.AppInstancesRepository#getObservableFor
         * @methodOf repositories.AppInstancesRepository
         * @function
         *
         * @description
         * Returns an observable object for an instance.
         *
         * @param {object} instance The instance object.
         *
         * @return {object} The observable object of the instance.
         */
    getObservableFor: function getObservableFor(instance) {

        var existingObservableInstance = this.searchObservableFor(instance);
        if (existingObservableInstance) {

            return existingObservableInstance.observable;
        }

        // create one if it doesn't exist
        var newObservableInstance = new Rx.Subject(instance);
        observableSingleInstances.push({ id: instance.id, observable: newObservableInstance });
        return newObservableInstance;
    }
};

exports.default = AppInstancesRepository;

/***/ }),

/***/ "XG/J":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-sms\">\n    <div class=\"top-elements\">\n\n        <h2 class=\"text-xxl mb10\" translate=\"cw.deploy.product.sent\"></h2>\n        <p class=\"text-l text-grey-4 mb40 green-span\" translate=\"cw.deploy.product.sent_sms\" translate-values=\"{number: ((inputData.dialCode + inputData.phoneNumber) | formatPhoneNumber)}\"></p>\n\n        <ul class=\"tour-tutorial-steps mb10 deploy-product-mobile\">\n            <li>\n                <div class=\"icon icon-l icon-phone icon-grey-4 mb15\">\n                    <i class=\"step-number font-regular\">1</i>\n                    <div class=\"icon icon-send-sms centerMiddle\"></div>\n                </div>\n                <p class=\"text-l text-grey-4 ng-scope green-span\" translate=\"cw.deploy.product.step_1_mobile_sms\"></p>\n            </li>\n\n            <li>\n                <div class=\"icon icon-l icon-phone icon-grey-4 mb15\">\n                    <i class=\"step-number font-regular\">2</i>\n                </div>\n                <div class=\"centerMiddle text-center tiny-elem\">\n                    <p class=\"text-xs\" translate=\"cw.tour.user.step_2\"></p>\n                    <button class=\"btn btn-small btn-primary nohover-primary\" translate=\"cw.general.ui.download\"></button>\n                </div>\n                <p class=\"text-l text-grey-4\" translate=\"cw.tour.user.tap_link\"></p>\n            </li>\n\n            <li>\n                <div class=\"icon icon-l icon-phone icon-grey-4 mb15\">\n                    <i class=\"step-number font-regular\">3</i>\n                    <div class=\"icon icon-s icon-download icon-orange-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-l text-grey-4\" translate=\"cw.tour.user.step_3\"></p>\n            </li>\n        </ul>\n\n        <button class=\"btn btn-primary btn-large mb30\" translate=\"cw.general.fixed_it\" ng-click=\"PhoneSmsDeploymentSuccessCtrl.close()\"></button>\n\n        <p class=\"subtitle-modal\">\n            <span translate=\"cw.deploy.got.text.not_received\" class=\"text-m text-grey-4\"></span>\n            <a ng-click=\"PhoneSmsDeploymentSuccessCtrl.resendSms();\" translate=\"cw.deploy.got.text.resend\" class=\"crs-pointer text-m\"></a>\n        </p>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "XH9K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _RFCSession = __webpack_require__("DyxV");

var storeUrlParamLogic = ['$rootScope', '$location', '$window', function ($rootScope, $location, $window) {

    var path = decodeURIComponent($location.$$url);

    // save extra params reveived in url to be preserved
    // if language is changed or on page refresh
    var dashboardRoutes = ['/auth/login', '/auth/register', '/auth/forgot', '/auth/reset', '/auth/set-password', '/auth/tfa', '/auth/confirm', '/dashboard/subscriptions'];
    var currentUrl = $window.location.href;

    _RFCSession.Session.setValue(_RFCSession.SessionKeys.InitalUrl, currentUrl);

    var _dashboardRoutes$filt = dashboardRoutes.filter(function (route) {
        return $location.path().indexOf(route) > -1;
    }),
        _dashboardRoutes$filt2 = _slicedToArray(_dashboardRoutes$filt, 1),
        currentPath = _dashboardRoutes$filt2[0];

    if (currentPath) {

        var index = currentUrl.indexOf(currentPath) + currentPath.length;
        var extraParams = currentUrl.substr(index);
        if (extraParams.length) {

            _RFCSession.Session.setValue(_RFCSession.SessionKeys.ExtraUrlParams, extraParams);
        }
    }
    // end

    if (path.indexOf('deviceid') > -1 || path.indexOf('referral/') > -1) {

        /**
         * @description
         * removes the 'deviceid/123' or 'referral/website' string
         * inputString = '/auth/login/otherparams/deviceid/id'
         * @example
         * // returns '/auth/login/otherparams'
         *
         */

        var paramToRemove = path.indexOf('deviceid') > -1 ? 'deviceid' : 'referral';
        var paramValue = path.slice(path.indexOf(paramToRemove)).split('/')[1];

        path = path.slice(0, path.indexOf('/' + paramToRemove)) + path.slice(path.lastIndexOf(paramValue) + paramValue.length);

        if (paramToRemove === 'deviceid') {

            _RFCSession.Session.setValue(_RFCSession.SessionKeys.DeviceId, paramValue);
        } else {

            _RFCSession.Session.setValue(_RFCSession.SessionKeys.ReferralCode, paramValue);
        }

        $location.url(path);
    } else if (path.indexOf('subscriptions') > -1 && path.indexOf('deploy') > -1) {

        /* check if the URL has "subscriptions" and "deploy" params.
        This is the shop purchase process. (Deploying paid apps) */

        var splitPathArray = path.split('/');

        var queryParams = $location.search();

        if (queryParams.appId) {
            var appId = queryParams.appId;

            _RFCSession.Session.setValue(_RFCSession.SessionKeys.SubscriptionDeployAppId, appId);
        } else {

            // iterate through every parameter from url
            _.find(splitPathArray, function (value, index) {

                if (value === 'subscriptions') {

                    // we need to check for this because the rewrite rule sometimes
                    // excecutes after the .run block where this logic is
                    var hasTabsSet = !!(splitPathArray[index + 1] === 'tabs');

                    if (hasTabsSet) {

                        // get the appId. We know that the appId
                        // is after subscriptions parameter
                        // "/subscriptions/tabs/plans/{appId}"
                        var _appId = splitPathArray[index + 3];

                        // set appId
                        _RFCSession.Session.setValue(_RFCSession.SessionKeys.SubscriptionDeployAppId, _appId);

                        return true;
                    } else if (!hasTabsSet) {

                        // get the appId. We know that the appId
                        // is after subscriptions parameter "/subscriptions/{appId}"
                        var _appId2 = splitPathArray[index + 1];

                        // set appId
                        _RFCSession.Session.setValue(_RFCSession.SessionKeys.SubscriptionDeployAppId, _appId2);

                        return true;
                    }
                }

                return false;
            });
        }
    }

    if (path.indexOf('/dashboard') > -1) {

        // stores all URL params
        $rootScope.loginUrlRedirect = path;

        if ($location.hash()) {

            $rootScope.urlHash = $location.hash();
        }

        if (path.indexOf('/dashboard') > -1 && path.indexOf('/subscriptions') > -1) {

            _RFCSession.Session.setValue(_RFCSession.SessionKeys.ExtraUrlParams, path);
        }
    }
}];

exports.default = storeUrlParamLogic;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "XIoT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__("dOW8");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-undef */


angular.module('controllers').controller('AddPayment', ['$scope', '$stateParams', 'Util', 'ActivationCodeRestService', 'TransactionRestService', 'PaymentTypesRestService', function ($scope, $stateParams, Util, ActivationCodeRestService, TransactionRestService, PaymentTypesRestService) {

    $scope.iframeWidth = window.innerWidth;
    $scope.iframeWidth = window.innerHeight;

    $scope.activationCode = _index.ActivationCodesRepository.getById($stateParams.resourceId);
    $scope.shopUrl = $scope.activationCode.attributes.add_payment_details_link + '&x-a-source=cw';
    $scope.app = _index.AppIntegrationsRepository.getById($scope.activationCode.attributes.app);
    $scope.brandName = CWCONFIG.partnerConfig.name;

    var mixpanelPayload = {
        Source: 'Subscriptions',
        Modal: 'Add Payment Confirmation Modal',
        Product: $scope.app.attributes.name,
        'Product ID': $scope.app.id,
        Page: Util.getPageName()
    };

    _RFC2.default.send('ConnectWeb Modal Open ', mixpanelPayload);

    $scope.closeModal = function () {

        Util.closeModal();
    };

    $scope.onIframeError = function (error) {

        clearInterval($scope.fallbackInterval);

        var mixpanelDetails = {
            'Error object data': error
        };

        _RFC2.default.send('ConnectWeb Add Payment Error', mixpanelDetails);

        if (!$scope.error) {

            // TODO: Check status code in eventData
            $scope.error = true;
            Util.closeModal();
        }
    };

    $scope.onIframeReady = function () {

        if (!$scope.cartIframeReady) {

            var mixpanelDetails = {
                Source: 'Subscriptions',
                Modal: 'Add Payment Cart Iframe Modal',
                Product: $scope.app.attributes.name,
                'Product ID': $scope.app.id,
                Page: Util.getPageName()
            };

            _RFC2.default.send('ConnectWeb Modal Open ', mixpanelDetails);

            $scope.cartIframeReady = true;
            $scope.showLoading = true;
        }
    };

    $scope.onIframeContentLoaded = function () {

        $scope.showLoading = false;
        $scope.$apply();
    };

    $scope.onPurchaseReady = function (transactionId) {

        var language = CWCONFIG.language === 'de' ? 'de' : 'en';
        // link to support page
        $scope.supportUrl = 'https://www.avira.com/' + language + '/support';
        // reset of the world region
        $scope.paymentSupportUrlRegionCB = 'https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=' + language;

        $scope.transactionId = transactionId;

        $scope.showCartIframe = false;

        ActivationCodeRestService.getAllAsync().then(function (response) {

            _index.ActivationCodesRepository.replace(response.data.data);
        });

        if (!$scope.showSuccessModal) {

            var mixpanelDetails = {
                Source: 'Subscriptions',
                Modal: 'Add Payment Success Modal',
                Product: $scope.app.attributes.name,
                'Product ID': $scope.app.id,
                Page: Util.getPageName()
            };

            _RFC2.default.send('ConnectWeb Modal Open ', mixpanelDetails);

            $scope.showSuccessModal = true;

            $scope.updateTransactionAndPaymentData();
        }

        clearInterval($scope.fallbackInterval);
    };

    $scope.updateTransactionAndPaymentData = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return PaymentTypesRestService.getAllAsync().then(function (response) {

                            _index.PaymentTypesRepository.replace(response.data.data);
                        });

                    case 2:
                        _context.next = 4;
                        return TransactionRestService.getAllAsync().then(function (response) {

                            _index.TransactionsRepository.replace(response.data.data);
                        });

                    case 4:
                        _RFC4.default.broadcast('purchase completed');

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    // Display cart iframe
    $scope.confirm = function () {

        var mixpanelDetails = {
            Modal: 'Add Payment Confirmation Modal',
            'Button Label': 'Continue',
            Product: $scope.app.attributes.name,
            'Product ID': $scope.app.id,
            'Subscription Runtime': $scope.activationCode.attributes.runtime,
            'Subscription Type': $scope.activationCode.attributes.subscription_type,
            Page: Util.getPageName()
        };

        _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelDetails);
        $scope.showCartIframe = true;
        $scope.fallbackInterval = setInterval($scope.checkUserTransactions, 15000);
    };

    // add payment timeout error fallback
    $scope.checkUserTransactions = function () {

        TransactionRestService.getAllAsync().then(function (response) {

            var transactions = response.data.data || [];
            var activationCodeID = $scope.activationCode.id || '';

            var transactionSucces = transactions.find(function (transaction) {
                return transaction.relationships['activation-code'].data.id === activationCodeID;
            });

            // check if the current activation code exists in any transaction
            if (transactionSucces) {

                var mixpanelDetails = {
                    Source: 'Subscriptions',
                    Modal: 'Add Payment Success Modal - fallback function',
                    Product: $scope.app.attributes.name,
                    'Product ID': $scope.app.id,
                    Page: Util.getPageName()
                };

                _RFC2.default.send('ConnectWeb Modal Open ', mixpanelDetails);
                $scope.transactionId = transactionSucces.attributes.payment_transaction_id;
                $scope.showCartIframe = false;
                $scope.showSuccessModal = true;

                ActivationCodeRestService.getAllAsync().then(function (activationCodesResponse) {

                    _index.ActivationCodesRepository.replace(activationCodesResponse.data.data);
                });

                PaymentTypesRestService.getAllAsync().then(function (paymentTypesResponse) {

                    _index.PaymentTypesRepository.replace(paymentTypesResponse.data.data);
                });

                clearInterval($scope.fallbackInterval);
            }
        });
    };

    $scope.getModalWidth = function () {

        var defaultModalWidth = 750 - 2; // 2px for the border;
        var viewPortWidth = window.innerWidth;
        var clickAreaWidth = 32;

        return viewPortWidth > 830 ? defaultModalWidth : viewPortWidth - clickAreaWidth;
    };

    $scope.$on('$destroy', function () {

        clearInterval($scope.fallbackInterval);
    });
}]);

/***/ }),

/***/ "XLyR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {

    var _serviceDependencies = ['jwtHelper'];

    /**
    * @ngdoc service
    * @name Util.JWT
    *
    * @description
    * This class is used to process a JWT token
    */

    var JWT = function () {
        function JWT(jwtHelper) {
            _classCallCheck(this, JWT);

            this.jwtHelper = jwtHelper;
        }

        /**
         * @ngdoc function
         * @name Util.JWT#getTokenPayload
         * @methodOf  Util.JWT
         * @function
         *
         * @description
         * This function returns the decoded JWT token if it exists
         * if not it will return undefined
         */


        _createClass(JWT, [{
            key: 'getTokenPayload',
            value: function getTokenPayload(token) {

                if (token) {

                    try {

                        return this.jwtHelper.decodeToken(token);
                    } catch (err) {

                        var body = angular.element('body');

                        body.append('' + ('<div class="testing" style="width:300px; padding:5px;' + 'background-color:#727272; position:fixed; top:0; color:#fff; max-height:300px;' + 'z-index:1000; font-size:14px; word-break:break-word; overflow:auto;">') + err + '</div>');

                        _loggers2.default.error(err);
                        return undefined;
                    }
                }

                return undefined;
            }
        }]);

        return JWT;
    }();

    _serviceDependencies.push(JWT);

    angular.module('services').service('JWT', _serviceDependencies);
})();

/***/ }),

/***/ "XO/S":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded' && !$root.showDWMLiteUpsellDashboard\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-emails\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.email.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"display-flex dwm-lightbox-content-box align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\">\n                            <div class=\"col-1 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\" translate=\"cw.dwm.entity.email.primary_email\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <p class=\"text-grey-1 text-l break-word\">{{primaryEmail.emailAddress}}</p>\n                                <p class=\"text-grey-4 text-xxs\" translate=\"cw.dwm.entity.email.primary_email_label\"></p>\n                            </div>\n                            <div class=\"col-3 col-text text-right\">\n                                <span class=\"action\"\n                                    ui-sref=\"root.dashboard.my-account({tab: 'security'})\" translate=\"cw.dwm.entity.email.update\"></span>\n                            </div>\n                        </div>\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"email in emails.entries\">\n                            <div class=\"col-1 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.email.email\" translate-values=\"{index : email.index}\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <p class=\"text-grey-1 text-l break-word\" ng-if=\"!email.showUpdateInput\">{{email.emailAddress}}</p>\n                                <div ng-if=\"email.showUpdateInput\">\n                                    <input type=\"text\" ng-class=\"{'error': !emailIsValid}\" name=\"email\" maxlength=\"100\"\n                                        autocomplete=\"off\" placeholder=\"{{ 'cw.form.email' | translate }}\" class=\"update-email\"\n                                        ng-keyup=\"entryUpdateValue($event);\" value=\"{{email.emailAddress}}\">\n                                    <p class=\"error-message\" ng-show=\"!emailIsValid\"\n                                        translate=\"cw.validator.messages.email\"></p>\n                                </div>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!email.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-1 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.email.email\" translate-values=\"{index: emails.entries.length + 2}\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <input type=\"text\" ng-class=\"{'error': !emailIsValid}\" name=\"email\" ng-model=\"newEmail\"\n                                    maxlength=\"100\" autocomplete=\"off\" placeholder=\"{{ 'cw.form.email' | translate }}\" id=\"email\"\n                                    ng-keyup=\"validateEmail($event)\">\n                                <p class=\"error-message\" ng-show=\"!emailIsValid\"\n                                    translate=\"cw.validator.messages.email\"></p>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.email.remove_email_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\"translate=\"cw.dwm.entity.email.remove_email_desc_1\">\n                        </p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_email_desc_2\">\n                        </p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.email.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.email.entity_details.desc_1\">\n                    </p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.email.entity_details.desc_2\">\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen && (!$root.showDWMLiteUpsellDashboard && !$root.showDWMLiteStrippedDashboard)\">\n            <button class=\"btn btn-primary btn-medium\"\n                ng-if=\"showAddNewButton && (emails.maxCount - 1 > emails.entries.length)\" ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewEmailIsLoading}\"\n                    ng-disabled=\"saveNewEmailIsLoading || !emailIsValid\" ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !emailIsValid\" ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen && !$root.showDWMLite\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n\n    <!-- DWM Lite Emails Modal-->\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded' && $root.showDWMLiteUpsellDashboard\">\n        <div class=\"display-block\">\n            <div class=\"dwm-lightbox-icon icon-emails\"></div>\n            <h2 class=\"text-grey-1 text-xxl mt10 mb10\" translate=\"cw.dwm.entity.email.title_v2\"></h2>\n            <p class=\"text-grey-3 text-s emails-subtitle\" translate=\"cw.dwm.entity.email.subtitle\"></p>\n        </div>\n\n        <div class=\"dwm-lightbox-content emails-dwm-lite mt40\">\n            <div class=\"display-flex dwm-lightbox-content-box align-item-stretch\">\n                <div class=\"left-column w55\">\n                    <div>\n                        <div class=\"row display-flex align-item-center main-row\">\n                            <div class=\"col-1 col-text text-left\">\n                                <div class=\"circle\">\n                                    <p class=\"text-grey-3 text-l\">1</p>\n                                </div>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <p class=\"text-grey-3 text-xs uppercase\" translate=\"cw.dwm.entity.email.primary_email_v2\"></p>\n                                <p class=\"text-grey-1 text-l break-word\">{{primaryEmail.emailAddress}}</p>\n                                <p class=\"text-grey-4 text-xxs\" translate=\"cw.dwm.entity.email.primary_email_label_v2\"></p>\n                            </div>\n                            <div class=\"col-3 col-text text-right\">\n                                <span class=\"action\"\n                                    ui-sref=\"root.dashboard.my-account({tab: 'security'})\" translate=\"cw.dwm.entity.email.change\"></span>\n                            </div>\n                        </div>\n                        <div class=\"crs-pointer\" ng-click=\"$root.showUpsellPageClick('Emails Upgrade Section')\">\n                            <div class=\"row display-flex align-item-center upgrade-row\" ng-repeat=\"item in [2, 3, 4, 5]\">\n                                <div class=\"col-1 col-text text-left\">\n                                    <div class=\"circle\">\n                                        <p class=\"text-grey-3 text-l\">{{item}}</p>\n                                    </div>\n                                </div>\n                                <div class=\"col-2 col-text text-left\">\n                                    <p class=\"text-grey-4 text-xs\" translate=\"cw.dwm.entity.email.upgrade_more\"></p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"right-column w45 text-center\">\n                    <h3 class=\"text-xl mb20 text-grey-1\" translate=\"cw.dwm.entity.email.entity_details.title_v2\"></h3>\n                    <p class=\"text-s mb10 text-grey-3\" translate=\"cw.dwm.entity.email.entity_details.desc_1_v2\"></p>\n                    <span class=\"action\" ng-click=\"$root.showUpsellPageClick('Emails Learn More')\"\n                        translate=\"cw.dashboard.services.mkt\" connect-qa-dwm-action=\"dwm-lite-upsell-emails-learn-more\"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
var path = 'scripts/controllers/modals/dwm/emails/emails.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "XOr9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* jshint unused: false */
/* eslint no-unused-vars: 0 */
angular.module('services').service('FakeLightbox', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {

    function updateFakeLightbox(state) {

        $timeout(function () {

            $rootScope.FakeLightbox.active = state;
        }, 0);
    }

    var OE = {
        ltx: {
            open: function open() {

                updateFakeLightbox(true);
            },
            close: function close() {

                updateFakeLightbox(false);
            }
        }
    };

    $window.OE = OE;
}])
/* Autorun service */
.run(['$rootScope', 'FakeLightbox', function ($rootScope, FakeLightbox) {

    $rootScope.FakeLightbox = {
        active: 0
    };
}]);

/***/ }),

/***/ "XVVd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-restricted-syntax: 0 */


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFCSession = __webpack_require__("DyxV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {

    var _serviceDependencies = ['$scope', '$window', '$state', '$timeout'];
    var _$scope = void 0;
    var _$window = void 0;
    var _$state = void 0;
    var _$timeout = void 0;

    /**
     * @ngdoc service
     * @name controllers.ChangeLang
     *
     * @description
     * change the language in the authentication pages - modal controller
     */

    var ChangeLang = function () {

        /**
         * @param  {any} $scope
         * @param  {any} $window
         * @param  {any} $timeout
         */
        function ChangeLang($scope, $window, $state, $timeout) {
            _classCallCheck(this, ChangeLang);

            _$scope = $scope;
            _$window = $window;
            _$state = $state;
            _$timeout = $timeout;
            _$scope.languages = [];
            _$scope.changeLanguage = this.changeLanguage;
            _$scope.currentLanguage = _$window.location.pathname;

            angular.forEach(CWCONFIG.languages, function (value, key) {

                _$scope.languages.push({ code: key, name: value });
            });
        }

        /**
         * @ngdoc controllers
         * @name controllers.ChangeLang#changeLanguage
         * @methodOf controllers.ChangeLang
         *
         * @description
         * change the language
         */


        _createClass(ChangeLang, [{
            key: 'changeLanguage',
            value: function changeLanguage(inputLanguage) {

                _$timeout(function () {

                    // Keep the received params in auth page
                    var extraUrlParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams);
                    if (extraUrlParams) {

                        _$window.location.href = '' + _$window.location.href.replace(CWCONFIG.language, inputLanguage) + extraUrlParams;
                    } else {

                        _$window.location.pathname = _$window.location.pathname.replace(CWCONFIG.language, inputLanguage);
                    }
                }, 100);

                _RFC2.default.send('ConnectWeb My Account Open', {
                    Language: inputLanguage
                });
                _$state.go(_$state.current.name.replace('.ltb', ''));
            }
        }]);

        return ChangeLang;
    }();

    _serviceDependencies.push(ChangeLang);

    angular.module('controllers').controller('ChangeLangCtrl', _serviceDependencies);
})();

/***/ }),

/***/ "XWmG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _userRestService = void 0;
var _util = void 0;

var _serviceDependencies = ['$scope', 'UserRestService', 'Util', 'Auth', '$rootScope'];

/**
 * @ngdoc service
 * @name controllers.SetPassword
 *
 * @description
 * SetPassword controller
 */

var SetPassword = function () {
    function SetPassword($scope, UserRestService, Util, Auth, $rootScope) {
        _classCallCheck(this, SetPassword);

        $rootScope.State.finishedLoadingAnimation = true;

        this.$scope = $scope;
        this.$scope.passwordRegExp = Util.getPasswordValidationRegExp();
        this.Auth = Auth;
        this.$rootScope = $rootScope;
        this.Auth.loading = false;
        this.MeRepository = _index.MeRepository;

        _userRestService = UserRestService;
        _util = Util;

        var mixpanelPayload = { Source: 'Direct' };

        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            mixpanelPayload = { Source: 'ws_spotlight' };
        }

        _RFC2.default.send('ConnectWeb Auth Set Password Open', mixpanelPayload);

        $scope.user = {
            email: this.MeRepository.getMyEmail(),
            password: ''
        };
        this.passwordScore = {};
    }

    _createClass(SetPassword, [{
        key: 'setPassword',
        value: function setPassword() {
            var _this = this;

            var userId = this.MeRepository.getMyId();

            this.$scope.submitted = true;
            this.$scope.setPasswordForm.$setValidity('serverValidation', true);

            _RFC2.default.send('ConnectWeb Set Password Click');

            var payload = {
                data: {
                    attributes: {
                        password: this.$scope.user.password
                    },
                    type: 'users',
                    id: userId
                }
            };

            this.getPasswordScore(this.$scope.user.password);

            var formIsValid = this.$scope.setPasswordForm.$valid && this.passwordScore.valid;

            if (formIsValid) {

                this.Auth.loading = true;

                _userRestService.update(userId, payload).then(function (response) {

                    _this.MeRepository.update(response.data.data);
                }).then(null, function () {

                    _this.Auth.loading = false;

                    _this.$scope.setPasswordForm.$setValidity('serverValidation', false);
                    _util.triggerAnimation('.error', 'animated shake');
                });
            } else {

                _util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'showPassword',
        value: function showPassword() {

            var inputType = angular.element('#password')[0];

            if (inputType.type === 'text') {

                inputType.type = 'password';
            } else {

                inputType.type = 'text';
            }

            this.$scope.inputType = inputType.type;
        }
    }, {
        key: 'getPasswordScore',
        value: function getPasswordScore(password) {

            this.passwordScore = _util.getPasswordScore(password);
        }
    }]);

    return SetPassword;
}();

_serviceDependencies.push(SetPassword);

angular.module('controllers').controller('SetPassword', _serviceDependencies);

/***/ }),

/***/ "Xo2h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),

/***/ "XtWt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

angular.module('services').factory('Countries', function () {

    var countries = {
        AF: {
            name: 'Afghanistan',
            dialCode: '+93'
        },
        AL: {
            name: 'Albania',
            dialCode: '+355'
        },
        DZ: {
            name: 'Algeria',
            dialCode: '+213'
        },
        AS: {
            name: 'American Samoa',
            dialCode: '+1 684'
        },
        AD: {
            name: 'Andorra',
            dialCode: '+376'
        },
        AO: {
            name: 'Angola',
            dialCode: '+244'
        },
        AI: {
            name: 'Anguilla',
            dialCode: '+1 264'
        },
        AG: {
            name: 'Antigua and Barbuda',
            dialCode: '+1 268'
        },
        AR: {
            name: 'Argentina',
            dialCode: '+54'
        },
        AM: {
            name: 'Armenia',
            dialCode: '+374'
        },
        AW: {
            name: 'Aruba',
            dialCode: '+297'
        },
        AU: {
            name: 'Australia',
            dialCode: '+61'
        },
        AT: {
            name: 'Austria',
            dialCode: '+43'
        },
        AZ: {
            name: 'Azerbaijan',
            dialCode: '+994'
        },
        BS: {
            name: 'Bahamas',
            dialCode: '+1 242'
        },
        BH: {
            name: 'Bahrain',
            dialCode: '+973'
        },
        BD: {
            name: 'Bangladesh',
            dialCode: '+880'
        },
        BB: {
            name: 'Barbados',
            dialCode: '+1 246'
        },
        BY: {
            name: 'Belarus',
            dialCode: '+375'
        },
        BE: {
            name: 'Belgium',
            dialCode: '+32'
        },
        BZ: {
            name: 'Belize',
            dialCode: '+501'
        },
        BJ: {
            name: 'Benin',
            dialCode: '+229'
        },
        BM: {
            name: 'Bermuda',
            dialCode: '+1 441'
        },
        BT: {
            name: 'Bhutan',
            dialCode: '+975'
        },
        BO: {
            name: 'Bolivia',
            dialCode: '+591'
        },
        BA: {
            name: 'Bosnia and Herzegovina',
            dialCode: '+387'
        },
        BW: {
            name: 'Botswana',
            dialCode: '+267'
        },
        BR: {
            name: 'Brazil',
            dialCode: '+55'
        },
        IO: {
            name: 'British Indian Ocean Territory',
            dialCode: '+246'
        },
        VG: {
            name: 'British Virgin Islands',
            dialCode: '+1 284'
        },
        BN: {
            name: 'Brunei',
            dialCode: '+673'
        },
        BG: {
            name: 'Bulgaria',
            dialCode: '+359'
        },
        BF: {
            name: 'Burkina Faso',
            dialCode: '+226'
        },
        BI: {
            name: 'Burundi',
            dialCode: '+257'
        },
        KH: {
            name: 'Cambodia',
            dialCode: '+855'
        },
        CM: {
            name: 'Cameroon',
            dialCode: '+237'
        },
        CA: {
            name: 'Canada',
            dialCode: '+1'
        },
        CV: {
            name: 'Cape Verde',
            dialCode: '+238'
        },
        KY: {
            name: 'Cayman Islands',
            dialCode: '+ 345'
        },
        CF: {
            name: 'Central African Republic',
            dialCode: '+236'
        },
        TD: {
            name: 'Chad',
            dialCode: '+235'
        },
        CL: {
            name: 'Chile',
            dialCode: '+56'
        },
        CN: {
            name: 'China',
            dialCode: '+86'
        },
        CC: {
            name: 'Cocos (Keeling) Islands',
            dialCode: '+891'
        },
        CO: {
            name: 'Colombia',
            dialCode: '+57'
        },
        KM: {
            name: 'Comoros',
            dialCode: '+269'
        },
        CD: {
            name: 'Congo [DRC]',
            dialCode: '+243'
        },
        CG: {
            name: 'Congo [Republic]',
            dialCode: '+242'
        },
        CK: {
            name: 'Cook Islands',
            dialCode: '+682'
        },
        CR: {
            name: 'Costa Rica',
            dialCode: '+506'
        },
        CI: {
            name: 'Côte d’Ivoire',
            dialCode: '+225'
        },
        HR: {
            name: 'Croatia',
            dialCode: '+385'
        },
        CU: {
            name: 'Cuba',
            dialCode: '+53'
        },
        CY: {
            name: 'Cyprus',
            dialCode: '+357'
        },
        CZ: {
            name: 'Czech Republic',
            dialCode: '+420'
        },
        DK: {
            name: 'Denmark',
            dialCode: '+45'
        },
        DJ: {
            name: 'Djibouti',
            dialCode: '+253'
        },
        DM: {
            name: 'Dominica',
            dialCode: '+1 767'
        },
        DO: {
            name: 'Dominican Republic',
            dialCode: '+1 809'
        },
        EC: {
            name: 'Ecuador',
            dialCode: '+593'
        },
        EG: {
            name: 'Egypt',
            dialCode: '+20'
        },
        SV: {
            name: 'El Salvador',
            dialCode: '+503'
        },
        GQ: {
            name: 'Equatorial Guinea',
            dialCode: '+240'
        },
        ER: {
            name: 'Eritrea',
            dialCode: '+291'
        },
        EE: {
            name: 'Estonia',
            dialCode: '+372'
        },
        ET: {
            name: 'Ethiopia',
            dialCode: '+251'
        },
        FK: {
            name: 'Falkland Islands [Islas Malvinas]',
            dialCode: '+500'
        },
        FO: {
            name: 'Faroe Islands',
            dialCode: '+298'
        },
        FJ: {
            name: 'Fiji',
            dialCode: '+679'
        },
        FI: {
            name: 'Finland',
            dialCode: '+358'
        },
        FR: {
            name: 'France',
            dialCode: '+33'
        },
        GF: {
            name: 'French Guiana',
            dialCode: '+594'
        },
        PF: {
            name: 'French Polynesia',
            dialCode: '+689'
        },
        GA: {
            name: 'Gabon',
            dialCode: '+241'
        },
        GM: {
            name: 'Gambia',
            dialCode: '+220'
        },
        GE: {
            name: 'Georgia',
            dialCode: '+995'
        },
        DE: {
            name: 'Germany',
            dialCode: '+49'
        },
        GH: {
            name: 'Ghana',
            dialCode: '+233'
        },
        GI: {
            name: 'Gibraltar',
            dialCode: '+350'
        },
        GR: {
            name: 'Greece',
            dialCode: '+30'
        },
        GL: {
            name: 'Greenland',
            dialCode: '+299'
        },
        GD: {
            name: 'Grenada',
            dialCode: '+1 473'
        },
        GP: {
            name: 'Guadeloupe',
            dialCode: '+590'
        },
        GU: {
            name: 'Guam',
            dialCode: '+1 671'
        },
        GT: {
            name: 'Guatemala',
            dialCode: '+502'
        },
        GG: {
            name: 'Guernsey',
            dialCode: '+44'
        },
        GN: {
            name: 'Guinea',
            dialCode: '+224'
        },
        GW: {
            name: 'Guinea-Bissau',
            dialCode: '+245'
        },
        GY: {
            name: 'Guyana',
            dialCode: '+595'
        },
        HT: {
            name: 'Haiti',
            dialCode: '+509'
        },
        HN: {
            name: 'Honduras',
            dialCode: '+504'
        },
        HK: {
            name: 'Hong Kong',
            dialCode: '+852'
        },
        HU: {
            name: 'Hungary',
            dialCode: '+36'
        },
        IS: {
            name: 'Iceland',
            dialCode: '+354'
        },
        IN: {
            name: 'India',
            dialCode: '+91'
        },
        ID: {
            name: 'Indonesia',
            dialCode: '+62'
        },
        IR: {
            name: 'Iran',
            dialCode: '+98'
        },
        IQ: {
            name: 'Iraq',
            dialCode: '+964'
        },
        IE: {
            name: 'Ireland',
            dialCode: '+353'
        },
        IM: {
            name: 'Isle of Man',
            dialCode: '+44'
        },
        IL: {
            name: 'Israel',
            dialCode: '+972'
        },
        IT: {
            name: 'Italy',
            dialCode: '+39'
        },
        JM: {
            name: 'Jamaica',
            dialCode: '+1 876'
        },
        JP: {
            name: 'Japan',
            dialCode: '+81'
        },
        JE: {
            name: 'Jersey',
            dialCode: '+44'
        },
        JO: {
            name: 'Jordan',
            dialCode: '+962'
        },
        KZ: {
            name: 'Kazakhstan',
            dialCode: '+7'
        },
        KE: {
            name: 'Kenya',
            dialCode: '+254'
        },
        KI: {
            name: 'Kiribati',
            dialCode: '+686'
        },
        KW: {
            name: 'Kuwait',
            dialCode: '+965'
        },
        KG: {
            name: 'Kyrgyzstan',
            dialCode: '+996'
        },
        LA: {
            name: 'Laos',
            dialCode: '+856'
        },
        LV: {
            name: 'Latvia',
            dialCode: '+371'
        },
        LB: {
            name: 'Lebanon',
            dialCode: '+961'
        },
        LS: {
            name: 'Lesotho',
            dialCode: '+266'
        },
        LR: {
            name: 'Liberia',
            dialCode: '+231'
        },
        LY: {
            name: 'Libya',
            dialCode: '+218'
        },
        LI: {
            name: 'Liechtenstein',
            dialCode: '+423'
        },
        LT: {
            name: 'Lithuania',
            dialCode: '+370'
        },
        LU: {
            name: 'Luxembourg',
            dialCode: '+352'
        },
        MO: {
            name: 'Macau',
            dialCode: '+853'
        },
        MK: {
            name: 'Macedonia [FYROM]',
            dialCode: '+389'
        },
        MG: {
            name: 'Madagascar',
            dialCode: '+261'
        },
        MW: {
            name: 'Malawi',
            dialCode: '+265'
        },
        MY: {
            name: 'Malaysia',
            dialCode: '+60'
        },
        MV: {
            name: 'Maldives',
            dialCode: '+960'
        },
        ML: {
            name: 'Mali',
            dialCode: '+223'
        },
        MT: {
            name: 'Malta',
            dialCode: '+356'
        },
        MH: {
            name: 'Marshall Islands',
            dialCode: '+692'
        },
        MQ: {
            name: 'Martinique',
            dialCode: '+596'
        },
        MR: {
            name: 'Mauritania',
            dialCode: '+222'
        },
        MU: {
            name: 'Mauritius',
            dialCode: '+230'
        },
        YT: {
            name: 'Mayotte',
            dialCode: '+262'
        },
        MX: {
            name: 'Mexico',
            dialCode: '+52'
        },
        FM: {
            name: 'Micronesia',
            dialCode: '+691'
        },
        MD: {
            name: 'Moldova',
            dialCode: '+373'
        },
        MC: {
            name: 'Monaco',
            dialCode: '+377'
        },
        MN: {
            name: 'Mongolia',
            dialCode: '+976'
        },
        MS: {
            name: 'Monserrat',
            dialCode: '+1 664'
        },
        ME: {
            name: 'Montenegro',
            dialCode: '+382'
        },
        MA: {
            name: 'Morocco',
            dialCode: '+212'
        },
        MZ: {
            name: 'Mozambique',
            dialCode: '+258'
        },
        MM: {
            name: 'Myanmar [Burma]',
            dialCode: '+95'
        },
        NA: {
            name: 'Namibia',
            dialCode: '+264'
        },
        NR: {
            name: 'Nauru',
            dialCode: '+674'
        },
        NP: {
            name: 'Nepal',
            dialCode: '+977'
        },
        NL: {
            name: 'Netherlands',
            dialCode: '+31'
        },
        AN: {
            name: 'Netherlands Antilles',
            dialCode: '+599'
        },
        NC: {
            name: 'New Caledonia',
            dialCode: '+687'
        },
        NZ: {
            name: 'New Zealand',
            dialCode: '+64'
        },
        NI: {
            name: 'Nicaragua',
            dialCode: '+505'
        },
        NE: {
            name: 'Niger',
            dialCode: '+227'
        },
        NG: {
            name: 'Nigeria',
            dialCode: '+234'
        },
        NU: {
            name: 'Niue',
            dialCode: '+683'
        },
        NF: {
            name: 'Norfolk Island',
            dialCode: '+672'
        },
        KP: {
            name: 'North Korea',
            dialCode: '+850'
        },
        MP: {
            name: 'Northern Mariana Islands',
            dialCode: '+1 670'
        },
        NO: {
            name: 'Norway',
            dialCode: '+47'
        },
        OM: {
            name: 'Oman',
            dialCode: '+968'
        },
        PK: {
            name: 'Pakistan',
            dialCode: '+92'
        },
        PW: {
            name: 'Palau',
            dialCode: '+680'
        },
        PS: {
            name: 'Palestinian Territories',
            dialCode: '+970'
        },
        PA: {
            name: 'Panama',
            dialCode: '+507'
        },
        PG: {
            name: 'Papua New Guinea',
            dialCode: '+675'
        },
        PY: {
            name: 'Paraguay',
            dialCode: '+595'
        },
        PE: {
            name: 'Peru',
            dialCode: '+51'
        },
        PH: {
            name: 'Philippines',
            dialCode: '+63'
        },
        PN: {
            name: 'Pitcairn',
            dialCode: '+872'
        },
        PL: {
            name: 'Poland',
            dialCode: '+48'
        },
        PT: {
            name: 'Portugal',
            dialCode: '+351'
        },
        PR: {
            name: 'Puerto Rico',
            dialCode: '+1 939'
        },
        PR2: {
            name: 'Puerto Rico',
            dialCode: '+1 787'
        },
        QA: {
            name: 'Qatar',
            dialCode: '+974'
        },
        RE: {
            name: 'Réunion',
            dialCode: '+262'
        },
        RO: {
            name: 'Romania',
            dialCode: '+40'
        },
        RU: {
            name: 'Russia',
            dialCode: '+7'
        },
        RW: {
            name: 'Rwanda',
            dialCode: '+250'
        },
        GS: {
            name: 'S. Georgia and S. Sandwich Isl.',
            dialCode: '+500'
        },
        BL: {
            name: 'Saint Barthélemy',
            dialCode: '+590'
        },
        SH: {
            name: 'Saint Helena',
            dialCode: '+290'
        },
        KN: {
            name: 'Saint Kitts and Nevis',
            dialCode: '+1 869'
        },
        LC: {
            name: 'Saint Lucia',
            dialCode: '+1 758'
        },
        MF: {
            name: 'Saint Martin (French part)',
            dialCode: '+590'
        },
        PM: {
            name: 'Saint Pierre and Miquelon',
            dialCode: '+508'
        },
        VC: {
            name: 'Saint Vincent and the Grenadines',
            dialCode: '+1 784'
        },
        WS: {
            name: 'Samoa',
            dialCode: '+685'
        },
        SM: {
            name: 'San Marino',
            dialCode: '+378'
        },
        ST: {
            name: 'Sao Tome and Principe',
            dialCode: '+239'
        },
        SA: {
            name: 'Saudi Arabia',
            dialCode: '+966'
        },
        SN: {
            name: 'Senegal',
            dialCode: '+221'
        },
        RS: {
            name: 'Serbia',
            dialCode: '+381'
        },
        SC: {
            name: 'Seychelles',
            dialCode: '+248'
        },
        SL: {
            name: 'Sierra Leone',
            dialCode: '+232'
        },
        SG: {
            name: 'Singapore',
            dialCode: '+65'
        },
        SK: {
            name: 'Slovakia',
            dialCode: '+421'
        },
        SI: {
            name: 'Slovenia',
            dialCode: '+386'
        },
        SB: {
            name: 'Solomon Islands',
            dialCode: '+677'
        },
        SO: {
            name: 'Somalia',
            dialCode: '+252'
        },
        ZA: {
            name: 'South Africa',
            dialCode: '+27'
        },
        KR: {
            name: 'South Korea',
            dialCode: '+82'
        },
        ES: {
            name: 'Spain',
            dialCode: '+34'
        },
        LK: {
            name: 'Sri Lanka',
            dialCode: '+94'
        },
        SD: {
            name: 'Sudan',
            dialCode: '+249'
        },
        SR: {
            name: 'Suriname',
            dialCode: '+597'
        },
        SZ: {
            name: 'Swaziland',
            dialCode: '+268'
        },
        SE: {
            name: 'Sweden',
            dialCode: '+46'
        },
        CH: {
            name: 'Switzerland',
            dialCode: '+41'
        },
        SY: {
            name: 'Syria',
            dialCode: '+963'
        },
        TW: {
            name: 'Taiwan',
            dialCode: '+886'
        },
        TJ: {
            name: 'Tajikistan',
            dialCode: '+992'
        },
        TZ: {
            name: 'Tanzania',
            dialCode: '+255'
        },
        TH: {
            name: 'Thailand',
            dialCode: '+66'
        },
        TL: {
            name: 'Timor-Leste',
            dialCode: '+670'
        },
        TG: {
            name: 'Togo',
            dialCode: '+228'
        },
        TK: {
            name: 'Tokelau',
            dialCode: '+690'
        },
        TO: {
            name: 'Tonga',
            dialCode: '+676'
        },
        TT: {
            name: 'Trinidad and Tobago',
            dialCode: '+1 868'
        },
        TN: {
            name: 'Tunisia',
            dialCode: '+216'
        },
        TR: {
            name: 'Türkiye',
            dialCode: '+90'
        },
        TM: {
            name: 'Turkmenistan',
            dialCode: '+993'
        },
        TC: {
            name: 'Turks and Caicos Islands',
            dialCode: '+1 649'
        },
        TV: {
            name: 'Tuvalu',
            dialCode: '+688'
        },
        VI: {
            name: 'U.S. Virgin Islands',
            dialCode: '+1 340'
        },
        UG: {
            name: 'Uganda',
            dialCode: '+256'
        },
        UA: {
            name: 'Ukraine',
            dialCode: '+380'
        },
        AE: {
            name: 'United Arab Emirates',
            dialCode: '+971'
        },
        GB: {
            name: 'United Kingdom',
            dialCode: '+44'
        },
        US: {
            name: 'United States',
            dialCode: '+1'
        },
        UY: {
            name: 'Uruguay',
            dialCode: '+598'
        },
        UZ: {
            name: 'Uzbekistan',
            dialCode: '+998'
        },
        VU: {
            name: 'Vanuatu',
            dialCode: '+678'
        },
        VA: {
            name: 'Vatican City',
            dialCode: '+379'
        },
        VE: {
            name: 'Venezuela',
            dialCode: '+58'
        },
        VN: {
            name: 'Vietnam',
            dialCode: '+84'
        },
        WF: {
            name: 'Wallis and Futuna',
            dialCode: '+681'
        },
        YE: {
            name: 'Yemen',
            dialCode: '+967'
        },
        ZM: {
            name: 'Zambia',
            dialCode: '+260'
        },
        ZW: {
            name: 'Zimbabwe',
            dialCode: '+263'
        }
    };

    return _.sortBy(_.each(countries, function (options, country) {
        return _.extend(options, { code: country.toLowerCase() });
    }), function (country) {
        return country.name;
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "Y4ls":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, moment) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint no-nested-ternary: 0 */
/* eslint no-restricted-globals: 0 */
/* eslint no-undef: 0 */
/* eslint valid-typeof: 0 */
/* eslint consistent-return: 0 */
/* eslint no-mixed-operators: 0 */
/* eslint no-unneeded-ternary: 0 */
/* eslint max-len: 0 */
/* eslint no-multi-assign: 0 */


var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _googleLibphonenumber = __webpack_require__("gFvG");

var i18n = _interopRequireWildcard(_googleLibphonenumber);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc service
 * @name services.Util
 *
 * @description
 * Utility service to be reused across the application.
 */

angular.module('services').factory('Util', ['$window', '$state', '$timeout', 'base64', 'JWT', '$filter', '$rootScope', function ($window, $state, $timeout, base64, JWT, $filter, $rootScope) {

    var Util = {
        /**
         * @ngdoc function
         * @name services.Util#capitalizeFirstLetter
         * @methodOf services.Util
         * @function
         *
         * @description
         * Capitalizes the first letter of the given string.
         *
         * @param {String} string String to be capitalized.
         * @returns {String} The given string having the first letter capitalized.
         */
        capitalizeFirstLetter: function capitalizeFirstLetter(string) {

            if (!string) {

                return '';
            }
            return string.charAt(0).toUpperCase() + string.slice(1);
        },


        /**
         * @ngdoc function
         * @name services.Util#base64encode
         * @methodOf services.Util
         * @function
         *
         * @description
         * Encode strings in base64
         * @param {String} value String.
         * @returns {String} Encoded string.
         */
        base64encode: function base64encode(value) {

            return base64.encode(value);
        },


        /**
         * @ngdoc function
         * @name services.Util#base64decode
         * @methodOf services.Util
         * @function
         *
         * @description
         * Decode strings in base64
         * @param {String} value String.
         * @returns {String} Decode string.
         */
        base64decode: function base64decode(value) {

            return base64.decode(value);
        },


        /**
         * @ngdoc function
         * @name services.Util#getScreenWidth
         * @methodOf services.Util
         * @function
         *
         * @description
         * On mobile devices, screen.availWidth stays the same regardless of the orientation
         * of the device.
         *
         * @returns {Number} The screen width.
         */
        getScreenWidth: function getScreenWidth() {

            var orientation = Math.abs($window.orientation) - 90 === 0 ? 'landscape' : 'portrait';
            return orientation === 'landscape' ? screen.availHeight : screen.availWidth;
        },


        /**
         * @ngdoc function
         * @name services.Util#param
         * @methodOf services.Util
         * @function
         *
         * @description
         * The implementation is identical to $.param. Useful to serialize
         * an array of form elements or a set of key/values into a query string.
         *
         * Below are some examples of objects and their serialized form version.
         *
         * | JSON                                  | Serialized form version      |
         * |---------------------------------------|------------------------------|
         * | 1. {"a": 1, "b": 2}                   | a=1&b=2                      |
         *
         * @param {Object} obj The object to be transformed for a _Post form request_.
         * @returns {String} The _serialized form version_ of the given object.
         */
        param: function param(obj) {

            var s = [];
            var add = function add(key, value) {

                // If value is a function, invoke it and return its value
                value = angular.isFunction(value) ? value() : value === null ? '' : value;
                s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
            };

            // If an array was passed in, assume that it is an array of form elements.
            if (angular.isArray(obj)) {

                // Serialize the form elements
                angular.forEach(obj, function (value, key) {

                    add(key, value);
                });
            } else {

                // If traditional, encode the "old" way (the way 1.3.2 or older
                // did it), otherwise encode params recursively.
                _.each(obj, function (value, prefix) {

                    Util.__buildParams(prefix, obj[prefix], add);
                });
            }

            // Return the resulting serialization
            return s.join('&').replace(/%20/g, '+');
        },


        /**
         * Helper function for Util.param
         * @param {String} prefix
         * @param {Object} obj
         * @param {Function} add
         */
        __buildParams: function __buildParams(prefix, obj, add) {

            if (angular.isArray(obj)) {

                // Serialize array item.
                _.each(obj, function (value, idx) {

                    if (/\[\]$/.test(prefix)) {

                        // Treat each array item as a scalar.
                        add(prefix, value);
                    } else {

                        // Item is non-scalar (array or object), encode its numeric index.
                        Util.__buildParams(prefix + '[' + ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? idx : '') + ']', value, add);
                    }
                });
            } else if (obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {

                // Serialize object item.
                _.each(obj, function (value, name) {

                    Util.__buildParams(prefix + '[' + name + ']', obj[name], add);
                });
            } else {

                // Serialize scalar item.
                add(prefix, obj);
            }
        },


        /**
         * @ngdoc function
         * @name services.Util#getNameFromEmail
         * @methodOf services.Util
         * @function
         *
         * @description
         * Tries to extract the real name from an email address.
         *
         * @param {String} email The given email address.
         * @returns {String} The real name based on the given email address.
         */
        getNameFromEmail: function getNameFromEmail(email) {

            var name = email ? email.split('@')[0] : '';

            if (name) {

                name = name.replace(/[^a-zA-Z0-9]/g, ' ').replace(/\s\s+/g, ' ').replace(/^\s+|\s+$/g, '');

                return Util.toTitleCase(name);
            }

            return '';
        },


        /**
         * @ngdoc function
         * @name services.Util#toTitleCase
         * @methodOf services.Util
         * @function
         * @description
         * Capitalizes first letter of each word.
         *
         * @param {String} string The string to be titleized.
         * @returns {String} The titleized version of the given string.
         */
        toTitleCase: function toTitleCase(string) {

            return string.replace(/\w\S*/g, function (word) {
                return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
            });
        },


        /**
         * @ngdoc function
         * @name services.Util#getLastScan
         * @methodOf services.Util
         * @function
         *
         * @param {Object} status Instance status
         * @return {Object} The last scan date and vdf update of the given status
         */
        getLastScan: function getLastScan(status) {

            var lastScan = 0;
            var lastVdfUpdate = 0;
            var serverTime = moment.utc(status.serverTime).valueOf();

            if (!status) {

                return { lastScan: false, lastVdfUpdate: false };
            }

            // get last scan time for an AV device
            if (status.data && status.data.lscan && status.data.lscan.date) {

                lastScan = moment(+status.data.lscan.date * 1000).valueOf();
            }
            // get last scan time for an anonymous AV device
            if (status.data && status.data.status && status.data.status.lscan && status.data.status.lscan.date) {

                lastScan = moment(+status.data.status.lscan.date * 1000).valueOf();
            }
            // get the last vdf update time for an AV device
            if (status.data && status.data.about && status.data.about.vdate) {

                lastVdfUpdate = moment(+status.data.about.vdate * 1000).valueOf();
            }
            // get last scan time for an BK device
            if (status.data && status.data.lastUpdate) {

                lastScan = moment.utc(status.data.lastUpdate).valueOf();
            }
            // get last scan time for an AT device (iphone)
            if (status.data && status.data.lastScanDate) {

                lastScan = moment.utc(status.data.lastScanDate).valueOf();
            }
            // get last scan time for an AT device (android)
            if (status.data && status.data.lastLocationDate) {

                lastScan = moment(status.data.lastLocationDate).valueOf();
            }
            // get last remote session for Pilot overview
            if (status.lastRemoteSession) {

                lastScan = moment.utc(status.lastRemoteSession).valueOf();
            }
            // get last remote session for Pilot slider
            if (status.date) {

                lastScan = moment.utc(status.date).valueOf();
            }

            if (lastScan > 0) {

                lastScan = Math.floor(serverTime - lastScan);
                if (lastScan === 0) {

                    lastScan = 1;
                }
            } else {

                lastScan = false;
            }

            return {
                lastScan: lastScan,
                lastVdfUpdate: lastVdfUpdate > 0 ? Math.floor(serverTime - lastVdfUpdate) : false
            };
        },


        /**
         * @ngdoc function
         * @name services.Util#inArray
         * @methodOf services.Util
         * @function
         *
         * @description
         * Returns true if value can be found in array or false otherwise.
         * Pass true for 'isSorted' to use a faster binary search when array is sorted.
         *
         * @param {Array} array The array to search in.
         * @param {String} value The value to search for.
         * @param {Boolean} isSorted Is the given array already sorted?
         * @returns {Boolean} Is the value in array?
         */
        inArray: function inArray(array, value, isSorted) {

            return _.indexOf(array, value, isSorted) === -1;
        },


        /**
         * @ngdoc function
         * @name services.Util#fbSalutation
         * @methodOf services.Util
         * @function
         *
         * @description
         * @param {String} gender Male / Female.
         * @returns {String} Salutation shortcut: Mr / Ms.
         */
        fbSalutation: function fbSalutation(gender) {

            if (gender === 'male') {

                return 'MR_';
            } else if (gender === 'female') {

                return 'MS_';
            }

            return '';
        },


        /**
         * @ngdoc function
         * @name services.Util#elementToStr
         * @methodOf services.Util
         * @function
         *
         * @description
         * Returns a stringified version of a HTML element, based on its id and class
         *
         * @param {Object} el HTMLElement.
         * @returns {String} Stringified element version.
         */
        elementToStr: function elementToStr(el) {

            if (!el) {

                return '';
            }

            var id = el.id ? '#' + el.id : '';
            var className = el.className && typeof el.className === 'string' ? '.' + el.className.split(' ').join('.') : '';
            return el.nodeName.toLowerCase() + id + className;
        },


        /**
         * @ngdoc function
         * @name services.Util#elementOffset
         * @methodOf services.Util
         * @function
         *
         * @description
         * Returns the current coordinates of the element relative to the document
         *
         * @param {Object} el HTMLElement.
         * @returns {Object} HTMLElement top and left coordinates.
         */
        elementOffset: function elementOffset(el) {

            var box = { top: 0, left: 0 };
            var doc = el && el.ownerDocument;

            var pYOffset = $window.pageYOffset;
            var pXOffset = $window.pageXOffset;

            if (!doc) {

                return;
            }

            var docEl = doc.documentElement;

            if (_typeof(el.getBoundingClientRect) !== undefined) {

                box = el.getBoundingClientRect();
            }

            return {
                top: box.top + (pYOffset || docEl.scrollTop) - (docEl.clientTop || 0),
                left: box.left + (pXOffset || docEl.scrollLeft) - (docEl.clientLeft || 0)
            };
        },


        /**
         * @ngdoc function
         * @name services.Util#orderBy
         * @methodOf services.Util
         * @function
         *
         * @description
         * Returns a listed with sorted objects.
         * Similar with _.sortBy in multiple cases, but works better
         * for string comparison.
         *
         * @param {Array} objects THe list of objects to be sorted.
         * @param {String} key The key after which the sort is done.
         * @param {String} order `Asc` for ascending order,
         *      `Desc` for descending order.
         * @param {Function} iterator Function to be applied to the values which
         *  are compared.
         * @returns {Array} List with sorted objects.
         */
        orderBy: function orderBy(objects, key, order, iterator) {

            if (angular.isDefined(order) && order && order.toLowerCase() === 'desc') {

                order = -1;
            } else {

                order = 1;
            }

            if (!angular.isFunction(iterator)) {

                iterator = angular.identity;
            }

            return objects.sort(function (a, b) {

                if (angular.isString(key)) {

                    a = a[key];
                    b = b[key];
                }
                a = iterator(a);
                b = iterator(b);

                if (a < b) {

                    return -1 * order;
                } else if (a === b) {

                    return 0;
                }
                return 1 * order;
            });
        },
        centerPopup: function centerPopup(defaultParams) {

            var width = defaultParams.width || 300;
            var height = defaultParams.height || 200;
            var left = (screen.width - width) / 2;
            var top = (screen.height - height) / 2;
            var params = 'width=' + width + ', height=' + height;

            params += ', top=' + top + ', left=' + left;
            params += ', directories=no';
            params += ', location=no';
            params += ', menubar=no';
            params += ', resizable=no';
            params += ', scrollbars=no';
            params += ', status=no';
            params += ', toolbar=no';

            return params;
        },
        getUserId: function getUserId($stateParams, User) {

            if ($stateParams.userId === 'ftu') {

                return $stateParams.userId;
            }
            return $stateParams.userId || User.id;
        },
        sanitizeBrowserName: function sanitizeBrowserName(browserName) {

            var name = browserName ? browserName.toLowerCase() : '';

            if (name.indexOf('chrome') !== -1) {

                return 'Chrome';
            } else if (name.indexOf('firefox') !== -1) {

                return 'Firefox';
            }

            return browserName;
        },


        /**
         * @ngdoc function
         * @name services.Util#isBeta
         * @methodOf services.Util
         * @function
         *
         * @description
         * Returns a boolean, depending either the current environment is
         * a beta or not.
         */
        isBeta: function isBeta() {

            return $window.location.host.indexOf('beta.') === 0;
        },


        /**
         * @ngdoc function
         * @name service.util#mixpanelDeviceType
         * @methodOf services.Util
         * @function
         *
         * @description
         * Converts device type to mixpanel device type
         */
        mixpanelDeviceType: function mixpanelDeviceType(deviceType) {

            var mixpanelType = {
                pc: 'PC',
                laptop: 'laptop',
                tablet: 'tablet',
                phone: 'phone'
            };

            return deviceType ? mixpanelType[deviceType.toLowerCase()] : deviceType;
        },
        hasAbs: function hasAbs() {

            var el = $window.document.querySelector('.abs-installed');
            return el && el.nodeName.toLowerCase() === 'body';
        },


        /**
         * Return the RegExp object which validates the emails from the whole app.
         * @return RegExp The RegExp object for email validation
         */
        getEmailValidationRegExp: function getEmailValidationRegExp() {

            // var acceptedWord = '[-!#$%&\'*+/=?^_`{}|~0-9A-ZÄÖÜäöüß]+';
            var acceptedWord = '[-!#$%&\'*+/=?^_`{}|~0-9A-Z]+'; // no umlauts
            var r = '(^' + acceptedWord + '(\\.' + acceptedWord + ')*';
            r = r + '|';
            r = r + '^"([\\001-\\010\\013\\014\\016-\\037!#-\\[\\]-\\177]';
            r = r + '|\\\\[\\001-\\011\\013\\014\\016-\\177])*")\\@';
            // r = r + '(?:[A-Z0-9](?:[A-Z0-9ÄÖÜäöüß-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})\\.?$';
            r = r + '(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}|[A-Z0-9-]{2,})\\.?$'; // no umlauts

            return new RegExp(r, 'i');
        },


        /**
         * Return the RegExp object which validates the passwords from the whole app.
         * @return RegExp The RegExp object for password validation
         */
        getPasswordValidationRegExp: function getPasswordValidationRegExp() {

            var r = '^(?=.*?[A-Z])(?=.*?[0-9]).{8,100}$';

            return new RegExp(r);
        },


        /**
         * Returns the password strength via a scoring algorithm.
         */
        getPasswordScore: function getPasswordScore(password) {

            var passwordScorePlugin = __webpack_require__("UiIt");
            var passwordScore = void 0;

            if (password) {

                var scoreValue = passwordScorePlugin(password).score;
                var containsNumber = /\d/.test(password);
                var containsUppercase = /[A-Z]/.test(password);

                /*  The scoreValue can have a value between 0 and 4.
                    If the scoreValue is 0 it means that the password is not valid. */
                if (scoreValue === 0) {

                    passwordScore = {
                        valid: false,
                        value: scoreValue,
                        containsNumber: containsNumber,
                        containsUppercase: containsUppercase
                    };
                } else {

                    passwordScore = {
                        valid: true,
                        value: scoreValue,
                        containsNumber: containsNumber,
                        containsUppercase: containsUppercase
                    };
                }
                return passwordScore;
            }

            return false;
        },


        /**
         * Return the RegExp object which validates the full name from the whole app.
         * @return RegExp The RegExp object for full name validation
         */
        getFullNameValidationRegExp: function getFullNameValidationRegExp() {

            var r = '^[^:<>"+&%$#*^/\\\\]+$';

            return new RegExp(r, 'i');
        },


        /**
         * Return the RegExp object which validates the generic input from the whole app.
         * @return RegExp The RegExp object for generic input validation
         */
        getGenericInputValidationRegExp: function getGenericInputValidationRegExp() {

            var r = '^[^:<>"+&%$#*^/{}()[\\]\\\\]+$';

            return new RegExp(r, 'i');
        },


        /**
         * Checks if a user is anonymous.
         * @return boolean True if the JWT attribute anon is true
         */
        isAnonymous: function isAnonymous() {

            var token = _RFC2.default.get(CWCONFIG.cookie.token);

            return JWT.getTokenPayload(token) && JWT.getTokenPayload(token).anon === true ? true : false;
        },


        /**
         * Checks if the client has an operating system with 64bits or not.
         * If the user has MacOs, false is returned.
         */
        is64OS: function is64OS() {

            if ($window.navigator.platform && window.navigator.platform === 'MacIntel') {

                return false;
            }

            if ($window.navigator.userAgent.indexOf('WOW64') !== -1 || $window.navigator.userAgent.indexOf('Win64') !== -1) {

                return true;
            }
            return false;
        },


        /**
         * @param path {string} path
         * @param opts {Object} options
         * @return {?Object}
         *
         * @description
         * Normalizes the given path, returning a regular expression
         * and the original path.
         *
         * Inspired by pathRexp in visionmedia/express/lib/utils.js.
         */
        pathRegExp: function pathRegExp(path, opts) {

            var insensitive = opts.caseInsensitiveMatch;
            var ret = {
                originalPath: path,
                regexp: path
            };
            var keys = ret.keys = [];

            path = path.replace(/([().])/g, '\\$1').replace(/(\/)?:(\w+)([?*])?/g, function (_, slash, key, option) {

                var optional = option === '?' ? option : null;
                var star = option === '*' ? option : null;
                keys.push({ name: key, optional: !!optional });
                slash = slash || '';
                return (optional ? '' : slash) + '(?:' + (optional ? slash : '') + (star && '(.+?)' || '([^/]+)') + (optional || '') + ')' + (optional || '');
            }).replace(/([/$*])/g, '\\$1');

            ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
            return ret;
        },


        /**
         * @ngdoc function
         * @name services.Util#getNextDelimiter
         * @methodOf services.Util
         * @function
         *
         * @description
         * Given an URI path, returns the next delimiter between the path and the query params -
         * it may be ? or &
         *
         * @param {string} path The path
         *
         * @returns {string} The next delimiter: ? or &
         */
        getNextDelimiter: function getNextDelimiter(path) {

            var delimiter = '?';
            if (path.indexOf('?') > -1) {

                delimiter = '&';
            }

            return delimiter;
        },


        /**
         * @ngdoc function
         * @name services.Util#closeModal
         * @methodOf services.Util
         * @function
         *
         * @description
         * Closes a modal.
         *
         * @param {string} nextState If provided, this will be the next state.
         *
         */
        closeModal: function closeModal(nextState) {

            var currentState = void 0;

            if (!nextState) {

                currentState = $state.current.name;

                nextState = currentState.substr(0, currentState.indexOf('.ltb')) || 'root.dashboard.home';
            }
            $state.go(nextState);
        },


        /**
         * @ngdoc function
         * @name services.Util#deepFind
         * @methodOf services.Util
         * @function
         *
         * @description
         * Get nested object value from path without throwing error.
         *
         * @param {Object} obj obj.
         * @param {string} path path.
         */
        deepFind: function deepFind(obj, path) {

            var current = void 0;
            var i = void 0;
            if (!obj) {

                return;
            }

            var paths = path.split('.');
            current = obj;

            for (i = 0; i < paths.length; i += 1) {

                if (current[paths[i]] === undefined || current[paths[i]] === null) {

                    return;
                }

                current = current[paths[i]];
            }

            return current;
        },


        /**
         * @ngdoc function
         * @name services.Util#getDeviceTypeBy
         * @methodOf services.Util
         * @function
         *
         * @description
         * Get device type for a specified os.
         *
         * @param {string} os os.
         */
        getDeviceTypeBy: function getDeviceTypeBy(os) {

            var deviceType = void 0;

            switch (os) {

                case 'osx':
                case 'windows':
                    deviceType = 'pc';
                    break;
                case 'ios':
                case 'android':
                    deviceType = 'phone';
                    break;
                default:
                    deviceType = 'pc';

            }

            return deviceType;
        },
        isValidPhoneNumber: function isValidPhoneNumber(phoneNumber, countryCode) {

            var result = void 0;
            var phoneUtil = void 0;
            var number = void 0;
            if (!phoneNumber || !countryCode) {

                return false;
            }

            result = false;
            var countryCodeUppercase = countryCode.toUpperCase();

            if (!countryCodeUppercase) {

                return false;
            }

            try {

                phoneUtil = i18n.PhoneNumberUtil.getInstance();
                number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCodeUppercase);

                result = phoneUtil.isValidNumber(number);
            } catch (err) {

                return false;
            }

            return result;
        },
        getElapsedMilli: function getElapsedMilli(date) {

            var currentMilli = void 0;
            var eventMilli = void 0;
            if (!angular.isNumber(date)) {

                // convert Date to milliseconds
                currentMilli = Date.now();
                eventMilli = new Date(date).getTime();
                return currentMilli - eventMilli;
            }

            return date;
        },


        /**
         * @description
         * This method is used to retrieve the authentication token from cookie
         */

        getToken: function getToken() {

            return _RFC2.default.get(CWCONFIG.cookie.token);
        },


        /**
         * @description
         * This method is used to trigger an animation on html elements
         */

        triggerAnimation: function triggerAnimation(id, animationClass) {

            // make sure this runs in the next tick,
            // so that the element with the class is in the DOM.
            $timeout(function () {

                angular.element(id).removeClass(animationClass);
            }, 50);

            $timeout(function () {

                angular.element(id).addClass(animationClass);
            }, 100);
        },


        /**
        * @description
        * This method is used to get the REST resource name from the URL
        */

        getRestResourceFromUrl: function getRestResourceFromUrl(url) {

            var regex = /^.*\/v[1-9]\/([a-z0-9-]*).*$/i;
            var parseUrl = url && url.match(regex);

            return parseUrl && parseUrl[1];
        },


        /**
         * @description
         * This method encode strings in MD5
         */

        encodeMD5: function encodeMD5(string) {

            var crypto = __webpack_require__("l+DQ");

            if (string && crypto) {

                return crypto(string).toString();
            }

            return false;
        },
        getParams: function getParams(query) {

            if (!query) {

                return {};
            }

            return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
                var _param$split = param.split('='),
                    _param$split2 = _slicedToArray(_param$split, 2),
                    key = _param$split2[0],
                    value = _param$split2[1];

                params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                return params;
            }, {});
        },


        /**
         * @description
         * This method returns the device navigator based on the operating system which
         * is automatically populated by server in index.html => window.deviceOs = '{{ m_os }}';
         * The default case is when the server didn't populate window.deviceOs. Eg. http://localhost
         */

        getDeviceNavigator: function getDeviceNavigator() {

            var navigator = window.deviceOs.toLowerCase();
            var fallbackNavigator = window.navigator.platform.toLowerCase();

            switch (true) {

                case navigator.indexOf('windows') > -1:
                    return 'windows';

                case navigator.indexOf('mac') > -1:
                    return 'osx';

                case navigator.indexOf('android') > -1:
                    return 'android';

                case navigator.indexOf('ios') > -1:
                    return 'ios';

                default:
                    if (fallbackNavigator.indexOf('mac') !== -1) {

                        return 'osx';
                    } else if (fallbackNavigator.indexOf('win') !== -1) {

                        return 'windows';
                    }

                    return fallbackNavigator;

            }
        },
        isBrowserCookieEnabled: function isBrowserCookieEnabled() {

            var isCookieEnabled = navigator.cookieEnabled;

            if (!isCookieEnabled) {

                document.cookie = 'testcookie';
                isCookieEnabled = document.cookie.indexOf('testcookie') !== -1;
            }

            return isCookieEnabled;
        },
        isPaymentCardDeleted: function isPaymentCardDeleted(paymentTypeDetails) {

            // Get payment type (Debit Card, PayPal, American Express ...)
            var paymentType = paymentTypeDetails && paymentTypeDetails.attributes.payment_type ? paymentTypeDetails.attributes.payment_type.toLowerCase() : '';
            if (paymentTypeDetails && paymentType.indexOf('paypal') === -1 && paymentType.indexOf('debit') === -1 && paymentType.indexOf('voucher') === -1 && paymentType.indexOf('wire transfer') === -1) {

                // If the last digits are missing from payment details, it means the card was removed
                return !paymentTypeDetails.attributes.last_digits;
            }
            return false;
        },

        // this is to check if the appId is one of the app that we no longer promote upsell in dashboard
        isNonrenewableApp: function isNonrenewableApp(appId) {
            var _CWCONFIG = CWCONFIG,
                nonrenewableApps = _CWCONFIG.nonrenewableApps;

            return !!nonrenewableApps.find(function (id) {
                return id === appId;
            });
        },


        /**
         * Maps an ISO 639-1 two-letter language code to an ISO 639-2 alpha-3 code.
         * Returns 'ENG' as the fallback for unrecognised codes.
         */
        getIso3LangCode: function getIso3LangCode(lang) {

            var LANG_TO_ISO3 = {
                en: 'ENG',
                de: 'DEU',
                fr: 'FRA',
                es: 'SPA',
                it: 'ITA',
                ru: 'RUS',
                nl: 'NLD',
                pl: 'POL',
                pt: 'POR',
                'pt-br': 'POR',
                ja: 'JPN',
                tr: 'TUR',
                'zh-cn': 'ZHO',
                'zh-tw': 'ZHO'
            };
            return LANG_TO_ISO3[lang] || 'ENG';
        },


        /**
         * Maps an ISO 3166-1 alpha-2 country code to an ISO 3166-1 alpha-3 code.
         * Falls back to the provided fallback value (or 'ENG') when the code is not found.
         */
        getIso3CountryCode: function getIso3CountryCode(country, fallback) {

            var COUNTRY_TO_ISO3 = {
                AT: 'AUT',
                BE: 'BEL',
                BG: 'BGR',
                HR: 'HRV',
                CY: 'CYP',
                CZ: 'CZE',
                DK: 'DNK',
                EE: 'EST',
                FI: 'FIN',
                FR: 'FRA',
                DE: 'DEU',
                GR: 'GRC',
                HU: 'HUN',
                IE: 'IRL',
                IT: 'ITA',
                LV: 'LVA',
                LT: 'LTU',
                LU: 'LUX',
                MT: 'MLT',
                NL: 'NLD',
                PL: 'POL',
                PT: 'PRT',
                RO: 'ROU',
                SK: 'SVK',
                SI: 'SVN',
                ES: 'ESP',
                SE: 'SWE'
            };
            return COUNTRY_TO_ISO3[country] || fallback || 'ENG';
        },
        compareString: function compareString(stringOne, stringTwo) {

            if (stringOne && stringTwo) {

                stringOne = stringOne.toLowerCase();
                stringTwo = stringTwo.toLowerCase();

                if (stringOne.length < stringTwo.length) {

                    return stringTwo.indexOf(stringOne) > -1;
                }
                return stringOne.indexOf(stringTwo) > -1;
            }

            return false;
        },

        /**
         * @description
         * This method is used to retrieve the remaining runtime until expiration date
         * @param
         * activation code or license
         */
        getRemainingRuntime: function getRemainingRuntime(activationCode) {

            var expirationDate = this.deepFind(activationCode, 'attributes.date_expire') || this.deepFind(activationCode, 'attributes.expiration_date');
            var startTime = moment();
            var endTime = moment(expirationDate);
            return parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;
        },

        /**
         * @description
         * This method is used to get extra runtime of a license after a merge(new purchase, OCP, renew)
         * @param
         * license
         */
        getExtraRuntime: function getExtraRuntime(license) {

            var currentRuntime = this.getRemainingRuntime(license);
            var purchasedRuntime = parseInt(this.deepFind(license, 'attributes.runtime'), 10);
            var purchaseRuntimeAsDays = void 0;
            switch (purchasedRuntime) {

                case 1:
                    purchaseRuntimeAsDays = 30;
                    break;
                case 12:
                    purchaseRuntimeAsDays = 365;
                    break;
                case 24:
                    purchaseRuntimeAsDays = 730;
                    break;
                case 36:
                    purchaseRuntimeAsDays = 1095;
                    break;
                default:
                    purchaseRuntimeAsDays = currentRuntime;

            }

            return currentRuntime - purchaseRuntimeAsDays;
        },

        // this function is used to update the lastLogin object in local storage in order to show simplified Log in view
        updateLastLoginObjectInLocalStorage: function updateLastLoginObjectInLocalStorage(userObject) {

            var loginObject = {
                firstName: $filter('friendName')(userObject),
                lastName: this.deepFind(userObject, 'attributes.last_name'),
                email: this.deepFind(userObject, 'attributes.email'),
                profilePic: this.deepFind(userObject, 'attributes.profile_image_medium'),
                loginType: _RFC2.default.get(CWCONFIG.cookie.loginType)
            };

            var encodedLoginObject = Util.base64encode(JSON.stringify(loginObject));

            localStorage.setItem('lastLogin', encodedLoginObject);
        },


        // this function is used to get the page name
        getPageName: function getPageName() {

            var urlName = $state.current.name;
            var splitedUrl = urlName.split('.');

            if (splitedUrl[2]) {

                var pageName = Util.capitalizeFirstLetter(splitedUrl[2]);

                if (splitedUrl[2] === 'store') {

                    if ($rootScope.isPrimeStore) {

                        pageName = 'Prime Store Page';
                    } else {

                        pageName = 'Comparison Store Page';
                    }
                }

                if (splitedUrl[2] === 'home') {

                    pageName = 'Homepage';
                }

                if (splitedUrl[2] === 'devices') {

                    pageName = 'My devices';
                }

                return pageName;
            }

            return '';
        },
        toFixed: function toFixed(num, fixed) {

            if (Math.abs(num) < 1.0) {

                var e = parseInt(num.toString().split('e-')[1], 0);
                if (e) {

                    // eslint-disable-next-line no-restricted-properties
                    num *= Math.pow(10, e - 1);
                    num = '0.' + new Array(e).join('0') + num.toString().substring(2);
                }
            } else {

                var _e = parseInt(num.toString().split('+')[1], 0);
                if (_e > 20) {

                    _e -= 20;
                    // eslint-disable-next-line no-restricted-properties
                    num /= Math.pow(10, _e);
                    num += new Array(_e + 1).join('0');
                }
            }

            num = num.toString();
            var formattedNum = num;

            if (num.length > 8) {

                var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');
                var modifiedNum = num.toString().match(re)[0];
                formattedNum = modifiedNum;
            }

            return formattedNum;
        }
    };

    return Util;
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta"), __webpack_require__("9dPI")))

/***/ }),

/***/ "Y592":
/***/ (function(module, exports) {

module.exports = "<div class=\"homepage\">\n    <div class=\"welcome-container\">\n        <div class=\"flex-row-align-center mt30\">\n            <h1 class=\"text-xl text-grey-1\"\n            translate=\"cw.general.hello\"\n            translate-values=\"{name: filterName}\"></h1>\n            <p class=\"text-grey-1 text-m\">{{todayDate}}</p>\n        </div>\n    </div>\n\n    <div ng-if=\"$root.hasUsCompliance\">\n        <welcome-offer ng-if=\"$root.dwmStatusLoaded && !$root.isMobileAppSession\"></welcome-offer>\n    </div>\n\n    <div class=\"homepage-container\" ng-class=\"{\n        'hide-subscriptions-widget': $root.hideHomepageSubscriptionWidget\n    }\">\n        <div ng-if=\"$root.hasUsCompliance\">\n            <div ng-if=\"numberOfLicenses > 3 && !$root.hasSubscriptionOff\" class=\"flex-row\">\n                <div ng-class=\"{\n                    'flex-row full-width': $root.hideHomepageSubscriptionWidget\n                }\">\n                    <div class=\"card last-device\">\n                        <last-device-details></last-device-details>\n                    </div>\n                    <div class=\"card dwm-card has-bottom-link\" ng-if=\"$root.showDwmCardHomepage\">\n                        <dwm-card></dwm-card>\n                    </div>\n                    <div class=\"card account-details has-bottom-link\">\n                        <account-details></account-details>\n                    </div>\n                    <div class=\"card support-card has-bottom-link\">\n                        <support></support>\n                    </div>\n                </div>\n                <div>\n                    <div class=\"card subscriptions-card\">\n                        <subscriptions-timeline></subscriptions-timeline>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"numberOfLicenses <= 3 || $root.hasSubscriptionOff\" class=\"flex-row\">\n                <div class=\"card last-device\">\n                    <last-device-details></last-device-details>\n                </div>\n                <div class=\"card subscriptions-card\">\n                    <subscriptions-timeline></subscriptions-timeline>\n                </div>\n                <div class=\"card dwm-card has-bottom-link\" ng-if=\"$root.showDwmCardHomepage\">\n                    <dwm-card></dwm-card>\n                </div>\n                <div class=\"card account-details has-bottom-link\">\n                    <account-details></account-details>\n                </div>\n                <div class=\"card support-card has-bottom-link\">\n                    <support></support>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"!$root.hasUsCompliance\" class=\"text-center\">\n            <i class=\"icon-info-blue mt100\"></i>\n            <h3 class=\"text-xl text-grey-1 text-center mt20 mb20\" translate=\"cw.compliance_failed.desc\"></h3>\n            <h3 class=\"text-xl text-grey-1 text-center mb10\" translate=\"cw.compliance_failed.reason_1\"></h3>\n            <h3 class=\"text-xl text-grey-1 text-center\" translate=\"cw.compliance_failed.reason_2\"></h3>\n        </div>\n    </div>\n    <cma-disclaimer ng-if=\"(showCmaDisclaimer.otc || showCmaDisclaimer.banner || showCmaDisclaimer.trial || showCmaDisclaimer.cardDeleted)\"></cma-disclaimer>\n</div>\n"

/***/ }),

/***/ "YW9j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/* eslint func-names: 0 */
/* eslint no-multi-assign: 0 */
/* eslint consistent-return: 0 */
/* eslint no-cond-assign: 0 */

/* !
 * Angular JS Service inspired by jQuery Cookie Plugin v1.4.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */

var pluses = /\+/g;
var isLocal = isLocalEnvironment();
var cookie = {};
var cookieConfig = void 0;

function isLocalEnvironment() {

    return !!(CWCONFIG.cdn.indexOf('localhost:') > -1);
}

// force cookies to have the secure attribute enabled by default
// except for the local environment
function configureSecureFlag(allowInsecure) {

    if (isLocal) {

        return '';
    }

    return allowInsecure ? '' : '; secure';
}

function encode(s) {

    return cookieConfig.raw ? s : encodeURIComponent(s);
}

function decode(s) {

    return cookieConfig.raw ? s : decodeURIComponent(s);
}

function stringifyCookieValue(value) {

    return encode(cookieConfig.json ? angular.toJson(value) : String(value));
}

function parseCookieValue(s) {

    if (s.indexOf('"') === 0) {

        // This is a quoted cookie as according to RFC2068, unescape...
        s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    try {

        // Replace server-side written pluses with spaces.
        // If we can't decode the cookie, ignore it, it's unusable.
        s = decodeURIComponent(s.replace(pluses, ' '));
    } catch (e) {

        return;
    }

    try {

        // If we can't parse the cookie, ignore it, it's unusable.
        return cookieConfig.json ? angular.fromJson(s) : s;
    } catch (e) {

        throw e;
    }
}

function read(s, converter) {

    var value = cookieConfig.raw ? s : parseCookieValue(s);
    return angular.isFunction(converter) ? converter(value) : value;
}

cookieConfig = cookie.set = cookie.get = function (key, value, options) {

    // Write
    if (value !== undefined && !angular.isFunction(value)) {

        options = angular.extend({}, options);

        if (typeof options.expires === 'number') {

            var days = options.expires;
            var t = options.expires = new Date();
            t.setDate(t.getDate() + days);
        }

        document.cookie = [encode(key), '=', stringifyCookieValue(value),
        // use expires attribute, max-age is not supported by IE
        options.expires ? '; expires=' + options.expires.toUTCString() : '', options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', configureSecureFlag(options.allowInsecure)].join('');

        return document.cookie;
    }

    // Read

    var result = key ? undefined : {};

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all. Also prevents odd result when
    // calling Cookie().
    var cookies = document.cookie ? document.cookie.split('; ') : [];

    for (var i = 0, l = cookies.length; i < l; i += 1) {

        var parts = cookies[i].split('=');
        var name = decode(parts.shift());
        var cookieTemp = parts.join('=');

        if (key && key === name) {

            // If second argument (value) is a function it's a converter...
            result = read(cookieTemp, value);
            break;
        }

        // Prevent storing a cookie that we couldn't decode.
        if (!key && (cookieTemp = read(cookieTemp)) !== undefined) {

            result[name] = cookieTemp;
        }
    }

    return result;
};

cookie.remove = function (key, options) {

    if (cookie.get(key) !== undefined) {

        // Must not alter options, thus extending a fresh object...
        cookie.set(key, '', angular.extend({}, options, { expires: -1 }));
        return true;
    }
    return false;
};

var Cookie = cookie;

exports.default = Cookie;

/***/ }),

/***/ "Z24y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _qrcodejs = __webpack_require__("DLiH");

var _qrcodejs2 = _interopRequireDefault(_qrcodejs);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$stateParams', '$state', '$window', '$timeout', '$scope', 'Util', 'DeploymentUrlsRestService'];

var PhoneDeploymentWizardController = function () {
    function PhoneDeploymentWizardController($stateParams, $state, $window, $timeout, $scope, Util, DeploymentUrlsRestService) {
        var _this = this;

        _classCallCheck(this, PhoneDeploymentWizardController);

        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.Util = Util;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.LicensesRepository = _index.LicensesRepository;

        this.user = _index.MeRepository.getMyUser();
        this.isMyEmailConfirmed = this.user.attributes.optin !== 'single';

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.$scope.app = this.app;

        this.$scope.deviceOs = window.deviceOs;

        // Remove previous qrcodes
        this.$scope.qrcode = '';

        if (!this.$scope.qrcode) {

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                var deployUrl = _this.Util.deepFind(response, 'data.data.attributes.download_url');
                _loggers2.default.info(['appId=', _this.$scope.inputData.appId, ', DeploymentUrl=', deployUrl || 'undefined'].join(''));
                _this.$scope.externalDownloadUrl = deployUrl;

                if (deployUrl) {

                    var qrCodeElemnt = document.getElementById('deploy-mobile-qrcode');

                    // Remove previous qrcodes
                    if (_this.$scope.deviceOs === 'windows' || _this.$scope.deviceOs === 'mac_os_x') {

                        if (qrCodeElemnt) {

                            qrCodeElemnt.innerHTML = '';
                        }

                        _this.$scope.qrcode = new _qrcodejs2.default(qrCodeElemnt, {
                            text: deployUrl,
                            width: 180,
                            height: 180,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: _qrcodejs2.default.CorrectLevel.H
                        });
                    }
                } else {

                    _this.$scope.showFallbackQRcode = true;
                }
            }).catch(function (err) {

                _this.$scope.showFallbackQRcode = true;
                _loggers2.default.error(err);
            });
        }

        this.$scope.inputData = angular.extend(this.$scope.inputData, { emails: [this.user.attributes.email] });

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();
        }

        this.deployChoose = {
            option: 'email',
            isForMe: !!this.user.id,
            waitingResponse: false
        };

        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(function () {

            var deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload a'));
            deployViaDownloadElement.on('click', function () {
                return _this.deployViaAppStore();
            });
        }, 0);

        // check if we should display the auto install UI
        this.autoInstall = this.$scope.inputData.autoInstall;

        // if we can automatically install the product initiate deploy sequence
        if (this.autoInstall) {

            this.deployViaAppStore();
        }

        // if we get back to the deployment wizard a second time
        // when we deploy on another device, we disable auto install
        this.$scope.inputData = angular.extend(this.$scope.inputData, {
            autoInstall: false
        });
    }

    _createClass(PhoneDeploymentWizardController, [{
        key: 'getPageName',
        value: function getPageName() {

            var pageName = '';

            if (this.$state.current.name.indexOf('.home') > -1) {

                pageName = 'Homepage';
            } else if (this.$state.current.name.indexOf('.devices') > -1) {

                pageName = 'Devices';
            } else if (this.$state.current.name.indexOf('.products') > -1) {

                pageName = 'Products';
            } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                pageName = 'Subscriptions';
            }

            return pageName;
        }
    }, {
        key: 'getLicense',
        value: function getLicense() {
            var _this2 = this;

            var licenseData = void 0;
            var licenseResourceId = this.$state.params.resourceId;

            // try to get license from license id or activation code from URL resourceId param
            licenseData = this.LicensesRepository.getLicenseBy(licenseResourceId) || this.LicensesRepository.getLicenseById(licenseResourceId);

            // try to get license from LicenseRepository based of app id (case for bundle)
            if (!licenseData) {

                licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);
            }

            // license not found, try to find license based on component
            if (typeof licenseData === 'undefined') {

                var allLicenses = this.LicensesRepository.getAll();

                /**
                 * Search each appid of each license in appIntegrationRepository
                 */
                allLicenses.forEach(function (license) {

                    // bundle id of each license
                    var licenseBundleId = license.relationships.app.data.id;

                    // get app integration for the bundle id of license
                    var appIntegration = _index.AppIntegrationsRepository.getById(licenseBundleId);

                    // stop at first find
                    if (!licenseData && _this2.Util.deepFind(appIntegration, 'relationships.apps')) {

                        // search component to be deployed (from URL) in components of the bundle
                        appIntegration.relationships.apps.data.find(function (app) {

                            // component found === license found
                            if (app.id === _this2.$scope.inputData.appId) {

                                licenseData = license;
                                return true;
                            }

                            return false;
                        });
                    }
                });
            }

            return licenseData;
        }
    }, {
        key: 'qrSelected',
        value: function qrSelected() {
            var _this3 = this;

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os
            };

            // Generate the qrcode only once
            if (!this.$scope.qrcode) {

                this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                    var deployUrl = _this3.Util.deepFind(response, 'data.data.attributes.download_url');
                    _loggers2.default.info(['appId=', _this3.$scope.inputData.appId, ', DeploymentUrl=', deployUrl || 'undefined'].join(''));
                    if (deployUrl) {

                        var qrCodeElemnt = document.getElementById('deploy-mobile-qrcode');

                        // Remove previous qrcodes
                        if (qrCodeElemnt) {

                            qrCodeElemnt.innerHTML = '';
                        }

                        _this3.$scope.qrcode = new _qrcodejs2.default(qrCodeElemnt, {
                            text: deployUrl,
                            width: 180,
                            height: 180,
                            colorDark: '#000000',
                            colorLight: '#ffffff',
                            correctLevel: _qrcodejs2.default.CorrectLevel.H
                        });
                    } else {

                        _this3.$scope.showFallbackQRcode = true;
                    }
                }).catch(function (err) {

                    _this3.$scope.showFallbackQRcode = true;
                    _loggers2.default.error(err);
                });
            }

            this.deployChoose.option = 'qr';
            _RFC4.default.send('ConnectWeb Deployment QR Scan Tab Open', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': !this.deployChoose.isForMe,
                'Product ID': this.app.id
            });
        }
    }, {
        key: 'deployViaEmail',
        value: function deployViaEmail() {
            var _this4 = this;

            _RFC4.default.send('ConnectWeb Deployment Email Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': !this.deployChoose.isForMe,
                'Product ID': this.app.id,
                'Device Os': window.deviceOs,
                Page: this.getPageName()
            });

            this.deployChoose.waitingResponse = true;

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                licenseId: this.licenseId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os,
                meta: {
                    send_email: true,
                    email: this.user.attributes.email
                }
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function () {

                // success handler

                _this4.deployChoose.waitingResponse = false;
                _this4.$scope.inputData = { emails: [_this4.user.attributes.email] };
                _this4.$scope.showSuccessScreen()('email', 'phone', {});
            }, function () {

                // error handler

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-phone'
                    }
                });
                _this4.Util.closeModal();
            });
        }
    }, {
        key: 'deployViaSMS',
        value: function deployViaSMS() {
            var _this5 = this;

            var isValidPhoneNumber = this.Util.isValidPhoneNumber(this.Util.deepFind(this.$scope.selectedDevice, 'phoneNumber'), this.Util.deepFind(this.$scope.selectedDevice, 'country.code'));
            if (!isValidPhoneNumber) {

                _RFC2.default.error({
                    message: 'cw.notification.svc.instance.error.phone_invalid',
                    icon: {
                        cssClasses: 'icon-phone'
                    }
                });
                return;
            }

            this.deployChoose.waitingResponse = true;
            _RFC4.default.send('ConnectWeb Deployment SMS Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.app.id
            });
            var countryCode = this.Util.deepFind(this.$scope.selectedDevice, 'country.dialCode') || '';

            if (this.$scope.selectedDevice.phoneNumber.indexOf(countryCode) === 0) {

                this.phoneNumber = this.$scope.selectedDevice.phoneNumber.replace(countryCode, '');
            } else {

                this.phoneNumber = this.$scope.selectedDevice.phoneNumber;
            }

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                licenseId: this.licenseId,
                os: this.$scope.inputData.os,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                meta: {
                    send_sms: true,
                    phone_number: countryCode + this.phoneNumber
                }
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function () {

                // success handler
                _this5.$scope.inputData = {
                    phoneNumber: _this5.phoneNumber,
                    dialCode: countryCode,
                    appId: _this5.app.id,
                    appName: _this5.Util.deepFind(_this5.app, 'attributes.resource.oeName'),
                    os: _this5.$scope.inputData.os
                };
                _this5.$scope.dynamicDirectiveTag = '<phone-sms-deployment-success />';
            }, function (error) {

                var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                switch (errorCode) {

                    case '1208':
                        // maximum number of SMS exceeded

                        _RFC2.default.error({
                            message: 'cw.device.resend.sms_error',
                            icon: {
                                cssClasses: 'icon-phone'
                            }
                        });

                        break;

                    default:

                        _RFC2.default.error({
                            message: 'cw.modal.server-error.desc',
                            icon: {
                                cssClasses: 'icon-phone'
                            }
                        });

                }

                _this5.Util.closeModal();
            });
        }
    }, {
        key: 'deployViaAppStore',
        value: function deployViaAppStore() {
            var _this6 = this;

            _RFC4.default.send('ConnectWeb Deployment Download Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId
            });

            this.deployChoose.waitingResponse = true;

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                license_number: this.licenseId,
                os: this.$scope.inputData.os
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                // success handler


                _this6.deployChoose.waitingResponse = false;
                var downloadUrl = _this6.Util.deepFind(response, 'data.data.attributes.download_url');
                _loggers2.default.info(['appId=', _this6.$scope.inputData.appId, ', DeploymentUrl=', downloadUrl || 'undefined'].join(''));
                if (downloadUrl) {

                    downloadUrl = '' + downloadUrl + _this6.Util.getNextDelimiter(downloadUrl) + 'utm_source=cw';
                    _this6.$window.location.href = downloadUrl;
                } else {

                    _RFC2.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {
                            cssClasses: 'icon-pc'
                        }
                    });
                    _this6.Util.closeModal();
                }
            }, function () {

                // error handler

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc'
                    }
                });
                _this6.Util.closeModal();
            });
        }
    }, {
        key: 'deployOnAnotherDevice',
        value: function deployOnAnotherDevice() {

            var stateName = this.$state.current.name;

            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';
            }

            var stateParams = angular.extend({ ltb: 'deploy' }, this.$stateParams);

            // if we're on the subscriptions page we always install on a new device
            // to simplify the flow
            if (stateName.indexOf('subscriptions') !== -1 || stateName.indexOf('home') !== -1) {

                stateParams = angular.extend(stateParams, { deviceId: 'new', appId: this.$scope.inputData.appId });
            }

            var page = 'None';

            if (stateName.indexOf('.products') !== -1) {

                page = 'Products';
            } else if (stateName.indexOf('.subscriptions') !== -1) {

                page = 'Subscriptions';
            } else if (stateName.indexOf('.home') !== -1) {

                page = 'Homepage';
            }

            _RFC4.default.send('ConnectWeb Install Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product ID': this.app.id,
                Page: page,
                Label: 'Other Device'
            });

            this.$scope.changeWizard()(stateName, stateParams, {
                reload: false
            });
        }
    }, {
        key: 'deployViaAppStoreMixpanel',
        value: function deployViaAppStoreMixpanel() {

            _RFC4.default.send('ConnectWeb Deployment AppStore Click', {
                'Product OS': this.$scope.inputData.os
            });
        }
    }]);

    return PhoneDeploymentWizardController;
}();

var PhoneDeploymentWizardDirective = function PhoneDeploymentWizardDirective() {
    _classCallCheck(this, PhoneDeploymentWizardDirective);

    this.template = __webpack_require__("5sbn");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($stateParams, $state, $window, $timeout, $scope, Util, DeploymentUrlsRestService) {
        return new PhoneDeploymentWizardController($stateParams, $state, $window, $timeout, $scope, Util, DeploymentUrlsRestService);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'phoneDeploymentWizardCtrl';
};

_directiveDependencies.push(function () {
    return new PhoneDeploymentWizardDirective();
});

angular.module('directives').directive('phoneDeploymentWizard', _directiveDependencies);

/***/ }),

/***/ "Z9TC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'Util'];

var CryptoTransactionsController = function CryptoTransactionsController($scope, Util) {
    _classCallCheck(this, CryptoTransactionsController);

    $scope.transactions = _index.CryptoRepository.getAll('transactions') || [];

    var onCryptoDataNext = function onCryptoDataNext() {

        $scope.transactions = _index.CryptoRepository.getAll('transactions') || [];

        $scope.transactions.forEach(function (transaction) {

            var formattedDate = new Date(transaction.timestamp * 1000);

            transaction.value = Util.toFixed(transaction.value, 6);
            transaction.date = moment(formattedDate).format('L');
            transaction.hour = moment(formattedDate).format('LT');
        });
    };

    this.cryptoRepository = _index.CryptoRepository.getObservable();
    this.cryptoSubscriber = this.cryptoRepository.subscribe(function (data) {
        return onCryptoDataNext(data);
    }, function () {}, function () {});
};

var CryptoTransactionsDirective = function CryptoTransactionsDirective() {
    _classCallCheck(this, CryptoTransactionsDirective);

    this.template = __webpack_require__("8S8G");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, Util) {
        return new CryptoTransactionsController($scope, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'CryptoTransactionsCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoTransactionsDirective();
});

angular.module('directives').directive('cryptoTransactions', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "ZP50":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("5cCM"),
    copyObject = __webpack_require__("RW/c"),
    createAssigner = __webpack_require__("RwMB"),
    isArrayLike = __webpack_require__("K2yx"),
    isPrototype = __webpack_require__("g5RI"),
    keys = __webpack_require__("d+Uu");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "Zigd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__("Xo2h");

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__("xcrU");

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),

/***/ "aELU":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("SiCv");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "aMXR":
/***/ (function(module, exports) {

module.exports = "<div class=\"centerVert\">\n    <span class=\"crs-pointer header-language-switcher\" ng-click=\"languageSwitcherCtrl.openModal('language-switcher')\">\n        <span class=\"text-grey-2 font-light text-m mlr5 ng-binding\" connectqa-settings=\"language\">{{languageSwitcherCtrl.Language}}</span>\n        <span class=\"inline-block icon language-switcher icon-grey-2 icon-xxs top-1\"></span>\n    </span>\n</div>\n\n"

/***/ }),

/***/ "aTk1":
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2 class=\"inline-block text-xl v-middle text-grey-1 mb5 mt10\" translate=\"cw.dwm.assets.desc_1\"\n        connect-qa-dwm-zone=\"assets-title\"></h2>\n    <p class=\"text-grey-3 text-s\" translate=\"cw.dwm.assets.desc_2\" connect-qa-dwm-zone=\"assets-subtitle\"></p>\n\n    <div class=\"loader-wrapper\" ng-if=\"assetsLoading\">\n        <div class=\"main-loader\"></div>\n    </div>\n\n    <div ng-if=\"!assetsLoading && (!aiaSubscriptionCancelled && !dwmLiteSubscriptionCancelled)\">\n        <div ng-if=\"$root.showDWMDashboard\"\n            class=\"mt30 display-flex justify-content-space-between flex-wrap align-item-stretch cards-wrapper\"\n            connect-qa-dwm-zone=\"assets\">\n            <div class=\"card display-flex align-item-center {{key}}\" ng-repeat=\"(key, value) in assets\"\n                connect-qa-dwm-asset-status=\"enabled\">\n                <div class=\"card-icon dwm-icon-{{key}}\"></div>\n                <div class=\"card-content\">\n                    <p class=\"text-grey card-title\" translate=\"{{'cw.dwm.assets.' + key}}\"></p>\n                    <div ng-if=\"key === 'emails'\">\n                        <p class=\"mb1 text-line\">\n                            <span>{{value.entries.length + 1}}/{{value.maxCount}}</span>\n                            <span class=\"uppercase\" translate=\"cw.dwm.assets.used\"></span>\n                        </p>\n                    </div>\n\n                    <div ng-if=\"key !== 'emails'\">\n                        <p class=\"mb1 text-line text-orange-2 uppercase\" ng-if=\"value.entries.length === 0\"\n                            translate=\"cw.dwm.assets.needs_info\">\n                        </p>\n                        <p class=\"mb1 text-line\" ng-if=\"value.entries.length > 0\">\n                            <span>{{value.entries.length}}/{{value.maxCount}}</span>\n                            <span class=\"uppercase\" translate=\"cw.dwm.assets.used\"></span>\n                        </p>\n                    </div>\n\n                    <div ng-click=\"openAssetModal(key)\" ng-if=\"key !== 'emails'\">\n                        <span class=\"action\" ng-if=\"value.entries.length === 0\" translate=\"cw.general.add\"></span>\n                        <span class=\"action\" ng-if=\"value.entries.length > 0\" translate=\"cw.general.edit\"></span>\n                    </div>\n\n                    <div ng-click=\"openAssetModal(key)\" ng-if=\"key === 'emails'\">\n                        <span class=\"action\" translate=\"cw.general.edit\">\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"$root.showDWMLiteUpsellDashboard\"\n            class=\"mt30 display-flex justify-content-space-between flex-wrap align-item-stretch upsell-cards\"\n            connect-qa-dwm-zone=\"assets\">\n            <div class=\"card display-flex align-item-center {{key}}\" ng-repeat=\"(key, value) in assets\"\n                connect-qa-dwm-asset-status=\"{{key === 'emails' ? 'enabled' : 'disabled'}}\" ng-class=\"{\n                    'disabled info-tooltip-holder': key !== 'emails'\n                }\">\n                <div class=\"info-tooltip arrow-bottom text-center\" connect-qa-dwm-tooltip=\"dwm-lite-upsell\">\n                    <p class=\"mb5\" translate=\"cw.dwm.upsell_tooltip_line_1\"></p>\n                    <ul>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_2\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_3\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_4\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_5\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_6\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_7\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_8\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_9\"></li>\n                        <li translate=\"cw.dwm.upsell_tooltip_line_10\"></li>\n                    </ul>\n                    <div class=\"text-center\">\n                        <button class=\"btn btn-primary btn-medium mt10\"\n                            ng-click=\"showUpsellPageClick('Tooltip')\" translate=\"cw.dashboard.services.mkt\" connect-qa-dwm-action=\"dwm-lite-upsell\">\n                        </button>\n                    </div>\n                </div>\n                <div class=\"card-icon dwm-icon-{{key}}\"></div>\n                <div class=\"card-content\">\n                    <div>\n                        <p class=\"text-grey card-title\" translate=\"{{'cw.dwm.assets.' + key}}\"></p>\n                        <div ng-if=\"key === 'emails'\">\n                            <p class=\"text-xxs text-grey\" class=\"mb1\">\n                                <span class=\"text-line\">1/1</span>\n                                <span class=\"uppercase text-line\" translate=\"cw.dwm.assets.used\"></span>\n                            </p>\n                            <p class=\"text-line\" translate=\"cw.dwm.upsell.email_info\"></p>\n                        </div>\n\n                        <div ng-if=\"key !== 'emails'\" class=\"mb1 text-line\">\n                            <span>0/{{value.maxCount}}</span>\n                            <span class=\"uppercase\" translate=\"cw.dwm.assets.used\"></span>\n                        </div>\n\n                        <div ng-if=\"key !== 'emails'\" class=\"mb1\">\n                            <p class=\"uppercase text-line red-text\" translate=\"cw.dwm.upsell.not_monitored\"></p>\n                        </div>\n                    </div>\n                    <div ng-if=\"key === 'emails'\">\n                        <p class=\"action font-bold\" ng-click=\"openAssetModal(key)\">\n                            <i class=\"icon icon-edit\"></i>\n                            <span translate=\"cw.general.edit\"></span>\n                        </p>\n                    </div>\n                </div>\n            </div>\n            <div class=\"text-center mt30 mb30 w100\">\n                <h2 class=\"text-grey-1 text-m\" translate=\"cw.dwm.upsell.title_2\"></h2>\n                <button class=\"btn btn-primary btn-medium mt20 learn-more-btn\"\n                    ng-click=\"showUpsellPageClick('Main Page')\" translate=\"cw.dashboard.services.mkt\" connect-qa-dwm-action=\"dwm-lite-upsell-main-page\">\n                </button>\n            </div>\n        </div>\n\n        <div ng-if=\"$root.showDWMLiteStrippedDashboard\"\n            class=\"mt30 display-flex justify-content-space-between flex-wrap align-item-stretch cards-wrapper\"\n            connect-qa-dwm-zone=\"assets\">\n            <div class=\"card display-flex align-item-center emails\" connect-qa-dwm-asset-status=\"enabled\">\n                <div class=\"card-icon dwm-icon-emails\"></div>\n                <div class=\"card-content\">\n                    <p class=\"text-grey card-title\" translate=\"cw.dwm.assets.emails\"></p>\n                    <div>\n                        <p class=\"mb1 text-line\">\n                            <span>1/1</span>\n                            <span class=\"uppercase\" translate=\"cw.dwm.assets.used\"></span>\n                        </p>\n                    </div>\n\n                    <div ng-click=\"openAssetModal('emails')\">\n                        <span class=\"action\" translate=\"cw.general.edit\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"!assetsLoading && (aiaSubscriptionCancelled || dwmLiteSubscriptionCancelled)\"\n        class=\"monitoring-disabled\">\n        <div ng-if=\"aiaSubscriptionCancelled || (dwmLiteSubscriptionCancelled && $root.showDWMLiteUpsellDashboard)\"\n            class=\"mt30 display-flex justify-content-space-between flex-wrap align-item-stretch cards-wrapper\"\n            connect-qa-dwm-zone=\"assets\">\n            <div class=\"card display-flex align-item-center disabled {{key}}\" ng-repeat=\"(key, value) in assets\"\n                connect-qa-dwm-asset-status=\"disabled\">\n                <div class=\"card-icon dwm-icon-{{key}}\"></div>\n                <div class=\"card-content\">\n                    <p class=\"text-grey card-title\" translate=\"{{'cw.dwm.assets.' + key}}\"></p>\n                    <div>\n                        <p class=\"mb1 text-line uppercase\">\n                            <p class=\"uppercase text-line red-text\" translate=\"cw.dwm.upsell.not_monitored\"></p>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"dwmLiteSubscriptionCancelled && !$root.showDWMLiteUpsellDashboard\"\n            class=\"mt30 display-flex justify-content-space-between flex-wrap align-item-stretch cards-wrapper\"\n            connect-qa-dwm-zone=\"assets\">\n            <div class=\"card display-flex align-item-center disabled emails\" connect-qa-dwm-asset-status=\"disabled\">\n                <div class=\"card-icon dwm-icon-emails\"></div>\n                <div class=\"card-content\">\n                    <p class=\"text-grey card-title\" translate=\"cw.dwm.assets.emails\"></p>\n                    <div>\n                        <p class=\"mb1 text-line uppercase\">\n                            <span translate=\"cw.dwm.assets.needs_info_2\" class=\"ng-scope\"></span>\n                        </p>\n                    </div>\n\n                    <div>\n                        <span class=\"action\" translate=\"cw.general.edit\"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"section-separator mt10 mb30\"></div>\n</div>\n"

/***/ }),

/***/ "aZcI":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div id=\"notifications\"></div>\n    <div class=\"section-header display-flex justify-content-space-between align-item-flex-end mb30\">\n        <h2 class=\"section-title inline-block text-xl v-middle text-grey-1\" translate=\"cw.dwm.alerts.title\" connect-qa-dwm-zone=\"alerts-title\"></h2>\n        <p class=\"text-green-1 text-s text-right uppercase status\" ng-if=\"!alertsLoading && (!aiaSubscriptionCancelled && !dwmLiteSubscriptionCancelled)\" connect-qa-dwm-zone=\"alerts-number\">\n            <span class=\"inline-block v-middle\" ng-class=\"{\n                    'text-green-1': (alerts[activePage].length === 0 || !alerts[activePage - 1]) && !alertsLoading,\n                    'text-orange-2': !alertsLoading && alerts[activePage - 1].length > 0\n                }\" translate=\"cw.dwm.alerts.notifications\" translate-values=\"{ alerts : unreadAlerts }\"></span>\n        </p>\n    </div>\n\n    <div class=\"loader-wrapper\" ng-if=\"alertsLoading\">\n        <div class=\"main-loader\"></div>\n    </div>\n\n    <div ng-if=\"!alertsLoading && (!aiaSubscriptionCancelled && !dwmLiteSubscriptionCancelled)\">\n        <div class=\"alerts\" ng-if=\"!alertsLoading && alerts[activePage - 1].length > 0\" connect-qa-dwm-alerts-zone=\"alerts\">\n            <div class=\"alerts-row display-flex justify-content-space-between flex-wrap align-item-stretch\">\n                <div class=\"col-1\">\n                    <p class=\"text-grey-2 text-l uppercase\" translate=\"cw.dashboard.crypto.transactions.date\"></p>\n                </div>\n                <div class=\"col-2\">\n                    <p class=\"text-grey-2 text-l uppercase\" translate=\"cw.dwm.alerts.type_and_desc\"></p>\n                </div>\n                <div class=\"col-3\">\n                </div>\n            </div>\n            <div class=\"alerts-row display-flex justify-content-space-between flex-wrap align-item-center\"\n                ng-repeat=\"alert in alerts[activePage - 1]\">\n                <div class=\"col-1\">\n                    <p class=\"text-grey-4 break-word text-s\">{{alert.formattedDate}}</p>\n                </div>\n                <div class=\"col-2\" ng-class=\"{'unread': alert.isRead === false && alert.bucket === 'inbox'}\">\n                    <p class=\"text-grey-1 text-s\">{{alert.title}}</p>\n                    <p class=\"text-grey-4 text-s\">{{alert.subTitle}}</p>\n                </div>\n                <div class=\"col-3 text-right\">\n                    <span class=\"action\" translate=\"cw.dwm.alerts.view_details\"\n                        ng-click=\"openAlertModal(alert.id)\"></span>\n                </div>\n            </div>\n        </div>\n        <div class=\"dwm-pagination mt30 text-center\" ng-if=\"!alertsLoading && alerts.length > 1\">\n            <span class=\"arrow arrow-prev text-grey-4 crs-pointer\" ng-click=\"prevPage()\"\n                ng-class=\"{'disabled': !prevArrowEnabled}\">\n                <i class=\"icon chevron-back-2 text-grey-3\"></i>\n            </span>\n            <span class=\"text-m mr10 ml10 inline-block v-middle\">\n                {{activePage}} / {{alerts.length}}\n            </span>\n            <span class=\"arrow arrow-next text-grey-4 crs-pointer\" ng-click=\"nextPage()\"\n                ng-class=\"{'disabled': !nextArrowEnabled}\">\n                <i class=\"icon chevron-back-2 text-grey-3\"></i>\n            </span>\n        </div>\n        <div ng-if=\"(alerts[activePage].length === 0 || !alerts[activePage - 1]) && !alertsLoading\" class=\"no-alerts\" connect-qa-dwm-alerts-zone=\"no-alerts\">\n            <i class=\"icon icon-dwm-no-alerts icon-grey-3\"></i>\n            <h2 class=\"inline-block text-xl v-middle text-grey-3\" translate=\"cw.dwm.alerts.no_alerts\"></h2>\n        </div>\n    </div>\n\n    <div ng-if=\"!alertsLoading && (aiaSubscriptionCancelled || dwmLiteSubscriptionCancelled)\">\n        <div class=\"no-alerts\" connect-qa-dwm-alerts-zone=\"disabled-alerts\">\n            <h2 class=\"inline-block text-xxl v-middle text-grey-3 mb10\" translate=\"cw.dwm.alerts.notifications_disabled\"></h2>\n            <p class=\"text-grey-3 text-s\" translate=\"cw.dwm.alerts.notifications_disabled_desc\"></p>\n            <div class=\"text-center mt30\">\n                <button class=\"btn btn-primary btn-medium\" ng-click=\"toggleMontoring()\" ng-class=\"{'spin-loader': activateLicensePending}\"\n                ng-disabled=\"activateLicensePending\" translate=\"cw.dwm.alerts.enable_monitoring\" connect-qa-dwm-action=\"enable-monitoring\"></button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "amg2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['Util', '$scope'];

var PhoneSmsDeploymentSuccessController = function () {
    function PhoneSmsDeploymentSuccessController(Util, $scope) {
        _classCallCheck(this, PhoneSmsDeploymentSuccessController);

        this.Util = Util;
        this.$scope = $scope;
    }

    _createClass(PhoneSmsDeploymentSuccessController, [{
        key: 'close',
        value: function close() {

            this.Util.closeModal();
        }
    }, {
        key: 'resendSms',
        value: function resendSms() {

            this.$scope.inputData = {
                appId: this.$scope.inputData.appId,
                os: this.$scope.inputData.os
            };

            this.$scope.dynamicDirectiveTag = '<phone-deployment-wizard />';
        }
    }]);

    return PhoneSmsDeploymentSuccessController;
}();

var PhoneSmsDeploymentSuccessDirective = function PhoneSmsDeploymentSuccessDirective() {
    _classCallCheck(this, PhoneSmsDeploymentSuccessDirective);

    this.template = __webpack_require__("XG/J");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (Util, $scope) {
        return new PhoneSmsDeploymentSuccessController(Util, $scope);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'PhoneSmsDeploymentSuccessCtrl';
};

_directiveDependencies.push(function () {
    return new PhoneSmsDeploymentSuccessDirective();
});

angular.module('directives').directive('phoneSmsDeploymentSuccess', _directiveDependencies);

/***/ }),

/***/ "aqbE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$rootScope', 'Util'];

var DwmCardController = function DwmCardController($scope, $rootScope, Util) {
    _classCallCheck(this, DwmCardController);

    $scope.turnOnDwm = function (variant) {

        $rootScope.turnOnDwm = true;

        $scope.sendMixpanelEvent(variant);
    };

    var aiaTileAction = Util.deepFind($rootScope.dwmStatus, 'products.identityAssist.tileAction');
    var dwmLiteTileAction = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.tileAction');

    var dwmLiteSubscriptionStatus = Util.deepFind($rootScope.dwmStatus, 'products.dwmLite.subscriptionStatus');
    var dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';
    var dwmLiteSubscriptionUpsell = dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';

    var cardVariant = void 0;

    if ($rootScope.showDwmUnreadNotificationsCard) {

        // show aia unread notifications card
        $scope.showAIAUnreadNotificationscard = true;
        $scope.notifications = $rootScope.dwmCardUnreadNotifications;
        cardVariant = 'AIA - Unread notifications';
    } else if ($rootScope.showDwmAddMoreDataCard) {

        // show aia add more data card
        $scope.showAIAAddMoreDatacard = true;
        cardVariant = 'AIA - Add more data';
    } else if (aiaTileAction === 'openDashboard') {

        // show aia dashboard
        $scope.showAIAcard = true;
        cardVariant = 'AIA - Disabled';
    } else if (dwmLiteTileAction === 'openDashboard' && dwmLiteSubscriptionCancelled) {

        // show dwm lite dashboard
        $scope.showDWMLitecard = true;
        cardVariant = 'DWM Lite - Disabled';
    } else if (dwmLiteTileAction === 'openDashboard' && dwmLiteSubscriptionUpsell) {

        // show dwm lite upsell
        $scope.showDWMLiteUpsellcard = true;
        cardVariant = 'DWM Lite - Get full version';
    }

    _RFC2.default.send('ConnectWeb Home Widget Show', {
        Label: cardVariant
    });

    $scope.sendMixpanelEvent = function (variant) {

        var buttonLabel = void 0;

        if (variant === 'DWM Lite' || variant === 'AIA') {

            buttonLabel = 'Turn ON - ' + variant;
        } else if (variant === 'DWM Lite Upsell') {

            buttonLabel = 'See more - AIA - Get full version';
        } else if (variant === 'AIA Add more data') {

            buttonLabel = 'Add more data - AIA';
        } else if (variant === 'AIA Unread Notifications') {

            buttonLabel = 'Unread notification - AIA';
        }

        _RFC2.default.send('ConnectWeb Home Click', {
            'Button label': buttonLabel
        });
    };

    $scope.setScrollToNotifications = function () {

        $rootScope.scrollToNotifications = true;
    };
};

var DwmCardDirective = function DwmCardDirective() {
    _classCallCheck(this, DwmCardDirective);

    this.template = __webpack_require__("Akpe");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $rootScope, Util) {
        return new DwmCardController($scope, $rootScope, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'DwmCardCtrl';
};

_directiveDependencies.push(function () {
    return new DwmCardDirective();
});

angular.module('directives').directive('dwmCard', _directiveDependencies);

/***/ }),

/***/ "atk5":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "axOg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.TransactionRestService
 *
 * @description
 * This class contains methods used to manage information about transactions
 * using http requests.
 * https://portal.avira.org/display/CSIN/Transactions+Resource
 */

var TransactionRestService = function (_BaseRestService) {
    _inherits(TransactionRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function TransactionRestService($http, $q, Util) {
        _classCallCheck(this, TransactionRestService);

        return _possibleConstructorReturn(this, (TransactionRestService.__proto__ || Object.getPrototypeOf(TransactionRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.TransactionRestService#getAllAsync
     * @methodOf rest.services.TransactionRestService
     * @function
     *
     * @description
     * Retrieves the transactions.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(TransactionRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(TransactionRestService.prototype.__proto__ || Object.getPrototypeOf(TransactionRestService.prototype), 'getAllAsync', this).call(this, 'transactions?filter[operation]=payment');
        }

        /**
         * @ngdoc function
         * @name rest.services.TransactionRestService#getPageAsync
         * @methodOf rest.services.TransactionRestService
         * @function
         *
         * @description
         * Retrieves a single page of transactions from the backend.
         *
         * @param {string} pageLink The link to the requested page
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'getPageAsync',
        value: function getPageAsync(pageLink) {

            return _get(TransactionRestService.prototype.__proto__ || Object.getPrototypeOf(TransactionRestService.prototype), 'getPageAsync', this).call(this, 'transactions?filter[operation]=payment', pageLink);
        }
    }]);

    return TransactionRestService;
}(_baseRestService2.default);

exports.default = TransactionRestService;


_serviceDependencies.push(TransactionRestService);

angular.module('rest.services').service('TransactionRestService', _serviceDependencies);

/***/ }),

/***/ "bNW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listen events for Events Model
 */
angular.module('listeners').service('EventsListener', function () {

    _RFC2.default.subscribe('socket:events', function (response) {

        if (response.verb === 'POST') {

            _index.EventsRepository.add(response.payload.data);
        }
    });
});

/***/ }),

/***/ "bQF6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("84dZ");

__webpack_require__("xmlI");

__webpack_require__("obUG");

__webpack_require__("0LLL");

__webpack_require__("nIVx");

__webpack_require__("pl0f");

__webpack_require__("2Tt8");

__webpack_require__("syvy");

__webpack_require__("UvpQ");

/***/ }),

/***/ "bVi6":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.10.0
var feedback, scoring;

scoring = __webpack_require__("IDO2");

feedback = {
  default_feedback: {
    warning: '',
    suggestions: ["Use a few words, avoid common phrases", "No need for symbols, digits, or uppercase letters"]
  },
  get_feedback: function(score, sequence) {
    var extra_feedback, i, len, longest_match, match, ref;
    if (sequence.length === 0) {
      return this.default_feedback;
    }
    if (score > 2) {
      return {
        warning: '',
        suggestions: []
      };
    }
    longest_match = sequence[0];
    ref = sequence.slice(1);
    for (i = 0, len = ref.length; i < len; i++) {
      match = ref[i];
      if (match.token.length > longest_match.token.length) {
        longest_match = match;
      }
    }
    feedback = this.get_match_feedback(longest_match, sequence.length === 1);
    extra_feedback = 'Add another word or two. Uncommon words are better.';
    if (feedback != null) {
      feedback.suggestions.unshift(extra_feedback);
      if (feedback.warning == null) {
        feedback.warning = '';
      }
    } else {
      feedback = {
        warning: '',
        suggestions: [extra_feedback]
      };
    }
    return feedback;
  },
  get_match_feedback: function(match, is_sole_match) {
    var layout, warning;
    switch (match.pattern) {
      case 'dictionary':
        return this.get_dictionary_match_feedback(match, is_sole_match);
      case 'spatial':
        layout = match.graph.toUpperCase();
        warning = match.turns === 1 ? 'Straight rows of keys are easy to guess' : 'Short keyboard patterns are easy to guess';
        return {
          warning: warning,
          suggestions: ['Use a longer keyboard pattern with more turns']
        };
      case 'repeat':
        warning = match.base_token.length === 1 ? 'Repeats like "aaa" are easy to guess' : 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"';
        return {
          warning: warning,
          suggestions: ['Avoid repeated words and characters']
        };
      case 'sequence':
        return {
          warning: "Sequences like abc or 6543 are easy to guess",
          suggestions: ['Avoid sequences']
        };
      case 'regex':
        if (match.regex_name === 'recent_year') {
          return {
            warning: "Recent years are easy to guess",
            suggestions: ['Avoid recent years', 'Avoid years that are associated with you']
          };
        }
        break;
      case 'date':
        return {
          warning: "Dates are often easy to guess",
          suggestions: ['Avoid dates and years that are associated with you']
        };
    }
  },
  get_dictionary_match_feedback: function(match, is_sole_match) {
    var ref, result, suggestions, warning, word;
    warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? 'This is a top-10 common password' : match.rank <= 100 ? 'This is a top-100 common password' : 'This is a very common password' : match.guesses_log10 <= 4 ? 'This is similar to a commonly used password' : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? 'A word by itself is easy to guess' : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? 'Names and surnames by themselves are easy to guess' : 'Common names and surnames are easy to guess' : '';
    suggestions = [];
    word = match.token;
    if (word.match(scoring.START_UPPER)) {
      suggestions.push("Capitalization doesn't help very much");
    } else if (word.match(scoring.ALL_UPPER) && word.toLowerCase() !== word) {
      suggestions.push("All-uppercase is almost as easy to guess as all-lowercase");
    }
    if (match.reversed && match.token.length >= 4) {
      suggestions.push("Reversed words aren't much harder to guess");
    }
    if (match.l33t) {
      suggestions.push("Predictable substitutions like '@' instead of 'a' don't help very much");
    }
    result = {
      warning: warning,
      suggestions: suggestions
    };
    return result;
  }
};

module.exports = feedback;

//# sourceMappingURL=feedback.js.map


/***/ }),

/***/ "bcrZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFC3 = __webpack_require__("Pqwy");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Register a global subscriber callback for the TraceKit reporter
 */
angular.module('oe').run(['$document', 'Util', function ($document, Util) {

    angular.element($document).on('click', function (ev) {

        var el = ev.target;
        var elName = Util.elementToStr(el.parentNode) + ' > ' + Util.elementToStr(el);

        _RFC4.default.addEvent(elName);
    });
}]).run(['Raven', function (Raven) {

    if (CWCONFIG.features.debug) {

        return false;
    }

    Raven.getEvents = function () {

        var events = _RFC2.default.getEvents().slice();
        _RFC2.default.clearEvents();

        return events;
    };
}]); /* eslint-disable */


angular.module('services').service('Raven', ['$window', function ($window) {

    var Raven = $window.Raven;
    if (!Raven || CWCONFIG.features.debug) {

        return null;
    }

    Raven.config(CWCONFIG.debug.logServer, {}).install();

    return Raven;
}]);

/**
 * Catch angular exceptions (if not in debug mode) and report them to Tracekit
 */
angular.module('services').factory('$exceptionHandler', ['Raven', function (Raven) {

    return function (exception) {

        // exception has 3 main attributes: message, name & stack
        if (Raven && Raven.captureException && !CWCONFIG.features.debug) {

            Raven.captureException(exception, { extra: { events: _RFC4.default.getEvents() } });
        } else {
            var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
            _loggers2.default.error(args);
        }
    };
}]);

/***/ }),

/***/ "c5ad":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("0huu"),
    isArrayLike = __webpack_require__("K2yx"),
    isIndex = __webpack_require__("U8js"),
    isObject = __webpack_require__("xwKO");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "c7s0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.UserNotifications
*
* @description
* This class is used to process notifications on user.
*/
var UserNotifications = {

    /**
    * @ngdoc function
    * @name notifications.UserNotifications#processUpdate
    * @methodOf notifications.UserNotifications
    * @function
    *
    * @description
    * This function can be used to process updates made on a user.
    *
    * @param {object} data an object with updated values on user.
    */
    processUpdate: function processUpdate(data) {

        if (data['attributes.optin'] === 'double_confirmed') {

            if (CWCONFIG.features.accountConfirmation) {

                _RFC2.default.success('cw.notification.account_verification.verified', null, 60000);
            }
        }

        // TODO: check for change of photo:  Mixpanel.send('Change Photo Success');
    }
};

exports.default = UserNotifications;

/***/ }),

/***/ "c8NG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFunctionName;
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),

/***/ "cHGQ":
/***/ (function(module, exports) {

module.exports = "<div class=\"price-container\">\n    <div ng-if=\"!showupsellyearlyprice\">\n        <!-- Regular price from appPrices -->\n        <span class=\"total-price\" ng-if=\"!hasPromotion\">\n            {{currentPrice.attributes.price_string}} \n            <span ng-if=\"showYearLabel\">/ <span translate=\"cw.general.year\"></span></span>\n            <span ng-if=\"showMonthLabel\">/ <span translate=\"cw.general.month\"></span></span>\n        </span>\n\n        <div class=\"has-promotion\" ng-if=\"hasPromotion\">\n            <!-- Regular price from Flexible Promotions -->\n            <span class=\"total-price\" ng-if=\"showTotalPrice || $root.welcomeOffers[currentPrice.id] && !$root.cmaGBapplies\">\n                {{currentPrice.attributes.price_string}} \n                <span ng-if=\"showYearLabel\">/ <span translate=\"cw.general.first_year\"></span></span>\n                <span ng-if=\"showMonthLabel\">/ <span translate=\"cw.general.first_month\"></span></span>\n            </span>\n            <!-- Sale price from Flexible Promotions -->\n            <span class=\"sale-price\"\n                ng-class=\"{\n                    'text-orange-2': showTotalPrice || $root.welcomeOffers[currentPrice.id] && !$root.cmaGBapplies\n                }\"\n                >\n                {{currentPrice.attributes.promotion.total_price_string}}\n                <span ng-if=\"showYearLabel && currentPrice.attributes.runtimes === '12'\">/ <span translate=\"cw.general.first_year\"></span></span>\n                <span ng-if=\"showYearLabel && currentPrice.attributes.runtimes === '24'\">/ <span translate=\"cw.general.first_two_years\"></span></span>\n                <span ng-if=\"showYearLabel && currentPrice.attributes.runtimes === '36'\">/ <span translate=\"cw.general.first_three_years\"></span></span>\n                <span ng-if=\"showMonthLabel && currentPrice.attributes.runtimes === '1'\">/ <span translate=\"cw.general.first_month\"></span></span>\n            </span>\n        </div>\n        <div ng-if=\"showCmaLabel\">\n            <div ng-if=\"hasPromotion && currentPrice.attributes.runtimes !== '1'\" class=\"app-price-label\">\n                <p class=\"text-xxs text-grey-3\" translate=\"cw.cma.discount_price_label_annual\"\n                    translate-values=\"{price: currentAnnual.attributes.price_string }\" ng-if=\"!$root.welcomeOffers[currentPrice.id]\"></p>\n\n                <p class=\"text-xxs text-grey-3\"\n                    ng-if=\"$root.welcomeOffers[currentPrice.id] && !$root.cmaGBapplies\"\n                >\n                    <span ng-if=\"currentPrice.id !== 'aps20_12_1'\"\n                        translate=\"cw.offer.generic_disclaimer_row\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers[currentPrice.id].endDate,\n                            discountedPrice: $root.welcomeOffers[currentPrice.id].discountedPrice,\n                            discountedAmount: $root.welcomeOffers[currentPrice.id].discountedAmount,\n                            firstYearPrice: $root.welcomeOffers[currentPrice.id].firstYearPrice,\n                            renewalPrice: $root.welcomeOffers[currentPrice.id].renewalPrice\n                        }\"\n                    ></span>\n                    <span ng-if=\"currentPrice.id === 'aps20_12_1'\"\n                        translate=\"cw.offer.prime25_generic_disclaimer_row\"\n                        translate-values=\"{\n                            endDate: $root.welcomeOffers[currentPrice.id].endDate,\n                            renewalPrice: $root.welcomeOffers[currentPrice.id].renewalPrice\n                        }\"\n                    ></span>\n                </p>\n\n                <p class=\"text-xxs text-grey-3\"\n                    ng-if=\"$root.welcomeOffers[currentPrice.id] && $root.cmaGBapplies\"\n                    translate=\"cw.offer.generic_disclaimer_uk\"\n                    translate-values=\"{\n                        endDate: $root.welcomeOffers[currentPrice.id].endDate,\n                        renewalPrice: $root.welcomeOffers[currentPrice.id].renewalPrice\n                    }\"\n                ></p>\n\n                <a ng-click=\"gotoAnchor('cma-disclaimer')\" class=\"text-blue-1 text-xxs crs-pointer\" translate=\"cw.cma.subscription_details\"></a>\n            </div>\n            <div ng-if=\"hasPromotion && currentPrice.attributes.runtimes === '1'\" class=\"app-price-label\">\n                <p class=\"text-xxs text-grey-3\" translate=\"cw.cma.discount_price_label_monthly\"\n                    translate-values=\"{price: currentPrice.attributes.price_string }\"></p>\n                <a ng-click=\"gotoAnchor('cma-disclaimer')\" class=\"text-blue-1 text-xxs crs-pointer\" translate=\"cw.cma.subscription_details\"></a>\n            </div>\n            <div ng-if=\"!hasPromotion\" class=\"app-price-label\">\n                <p class=\"text-xxs text-grey-3\" translate=\"cw.cma.total_price_label\"></p>\n                <a ng-click=\"gotoAnchor('cma-disclaimer')\" class=\"text-blue-1 text-xxs crs-pointer\" translate=\"cw.cma.subscription_details\"></a>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"showupsellyearlyprice\">\n        <!-- Regular price from appPrices -->\n        <span class=\"total-price\" ng-if=\"!hasPromotion\">\n            {{currentPrice.attributes.upsellYearlyPrice}} \n            <span ng-if=\"showYearLabel\">/ <span translate=\"cw.general.year\"></span></span>\n            <span ng-if=\"showMonthLabel\">/ <span translate=\"cw.general.month\"></span></span>\n        </span>\n\n        <div class=\"has-promotion\" ng-if=\"hasPromotion\">\n            <!-- Regular price from Flexible Promotions -->\n            <span class=\"total-price\">\n                {{currentPrice.attributes.upsellYearlyPrice}} \n                <span ng-if=\"showYearLabel\">/ <span translate=\"cw.general.year\"></span></span>\n                <span ng-if=\"showMonthLabel\">/ <span translate=\"cw.general.month\"></span></span>\n            </span>\n            <!-- Sale price from Flexible Promotions -->\n            <span class=\"sale-price\">\n                {{currentPrice.attributes.promotion.upsellYearlyPrice}} \n                <span ng-if=\"showYearLabel\">/ <span translate=\"cw.general.year\"></span></span>\n                <span ng-if=\"showMonthLabel\">/ <span translate=\"cw.general.month\"></span></span>\n            </span>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "cJxR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('services').service('AppleIDService', ['$q', '$window', function ($q, $window) {

    var deferred = $q.defer();

    var clientId = CWCONFIG.appleIDConfig.clientId;
    var redirectURI = CWCONFIG.appleIDConfig.redirectURI;
    var state = CWCONFIG.appleIDConfig.state;
    var scope = CWCONFIG.appleIDConfig.scope;


    function init() {

        var appleSignInScript = $window.document.createElement('script');
        appleSignInScript.type = 'text/javascript';
        appleSignInScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        appleSignInScript.onload = onScriptLoad;
        appleSignInScript.onerror = onScriptLoadError;

        var jsScripts = $window.document.getElementsByTagName('script')[0];
        jsScripts.parentNode.insertBefore(appleSignInScript, jsScripts);

        return deferred.promise;
    }

    function onScriptLoad() {

        if ($window.AppleID && $window.AppleID.auth) {

            $window.AppleID.auth.init({
                clientId: clientId,
                scope: scope,
                redirectURI: redirectURI,
                state: state,
                usePopup: true
            });

            deferred.resolve();
        }
    }

    function onScriptLoadError() {

        deferred.reject();
    }

    var exports = {
        init: init
    };

    return exports;
}]);

/***/ }),

/***/ "cNuc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _arguments = arguments;
/* eslint no-extend-native: 0 */

/**
 * Add object.create polyfill
 */
if (!Object.create) {

    Object.create = function () {

        function F() {}

        return function (obj) {

            if (_arguments.length !== 1) {

                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = obj;
            return new F();
        };
    }();
}

if (!Array.prototype.indexOf) {

    Array.prototype.indexOf = function (searchElement, fromIndex) {
        var length = undefined.length;


        if (undefined === undefined || undefined === null) {

            throw new Error('"this" is null or not defined');
        }

        fromIndex = +fromIndex || 0;

        if (Math.abs(fromIndex) === Infinity) {

            fromIndex = 0;
        }

        if (fromIndex < 0) {

            fromIndex += length;

            if (fromIndex < 0) {

                fromIndex = 0;
            }
        }

        for (; fromIndex < length; fromIndex += 1) {

            if (undefined[fromIndex] === searchElement) {

                return fromIndex;
            }
        }

        return -1;
    };
}

if (!String.prototype.endsWith) {

    String.prototype.endsWith = function (search, thisLen) {

        if (thisLen === undefined || thisLen > undefined.length) {

            thisLen = undefined.length;
        }
        return undefined.substring(thisLen - search.length, thisLen) === search;
    };
}

/* eslint-disable */
/**
 * Protect window.console method calls, e.g. console is not defined on IE
 * unless dev tools are open, and IE doesn't define console.debug
 *
 * Chrome 41.0.2272.118: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 * Firefox 37.0.1: log,info,warn,error,exception,debug,table,trace,dir,group,groupCollapsed,groupEnd,time,timeEnd,profile,profileEnd,assert,count
 * Internet Explorer 11: select,log,info,warn,error,debug,assert,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd,trace,clear,dir,dirxml,count,countReset,cd
 * Safari 6.2.4: debug,error,log,info,warn,clear,dir,dirxml,table,trace,assert,count,profile,profileEnd,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd
 * Opera 28.0.1750.48: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 */
(function () {
    // Union of Chrome, Firefox, IE, Opera, and Safari console methods
    var methods = ["assert", "cd", "clear", "count", "countReset", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "select", "table", "time", "timeEnd", "timeStamp", "timeline", "timelineEnd", "trace", "warn"];
    var length = methods.length;
    var console = window.console = window.console || {};
    var method;
    var noop = function noop() {};
    while (length--) {
        method = methods[length];
        // define undefined methods as noops to prevent errors
        if (!console[method]) console[method] = noop;
    }
})();

/***/ }),

/***/ "cb0B":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ICfp");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "cbBA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

var AccountDetailsController = function AccountDetailsController($scope) {
    _classCallCheck(this, AccountDetailsController);

    var me = _index.MeRepository.getMyUser();
    var dateAdded = new Date(me.attributes.date_added);
    $scope.yearAdded = dateAdded.getFullYear();
    $scope.brandName = CWCONFIG.partnerConfig.name;

    $scope.sendAccountMixpanel = function (buttonLabel) {

        _RFC2.default.send('ConnectWeb Home Click', {
            Label: 'Your Account',
            'Button label': buttonLabel
        });
    };
};

var AccountDetailsDirective = function AccountDetailsDirective() {
    _classCallCheck(this, AccountDetailsDirective);

    this.template = __webpack_require__("37Sf");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope) {
        return new AccountDetailsController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'accountDetailsCtrl';
};

_directiveDependencies.push(function () {
    return new AccountDetailsDirective();
});

angular.module('directives').directive('accountDetails', _directiveDependencies);

/***/ }),

/***/ "ccIB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("8Xy5");
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),

/***/ "ccQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AlertComponent = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("ccIB");

var _react2 = _interopRequireDefault(_react);

var _i18next = __webpack_require__("J7wN");

var _i18next2 = _interopRequireDefault(_i18next);

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("YW9j");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */

var DEFAULT_KEYS = {
    success: {
        title: 'cw.general.success',
        message: ''
    },
    error: {
        title: 'cw.general.ui.error',
        message: 'cw.modal.server-error.desc'
    },
    warning: {
        title: 'cw.general.warning',
        message: ''
    },
    info: {
        title: 'cw.general.information',
        message: ''
    }
};

var DEFAULT_DELAY = CWCONFIG.timeouts.notification || 4000;
var counter = 0;
var cookieConfig = CWCONFIG.cookie;
var domain = cookieConfig.domain,
    rootDomain = cookieConfig.rootDomain;

var AlertComponent = function (_React$Component) {
    _inherits(AlertComponent, _React$Component);

    function AlertComponent(props) {
        _classCallCheck(this, AlertComponent);

        var _this = _possibleConstructorReturn(this, (AlertComponent.__proto__ || Object.getPrototypeOf(AlertComponent)).call(this, props));

        _this.state = {
            messages: {}
        };

        _this.messageRef = {};

        _this.onClose = _this.onClose.bind(_this);
        _this.handleStateChange = _this.handleStateChange.bind(_this);

        return _this;
    }

    _createClass(AlertComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var messageObservable = _RFC2.default.getObservable();
            var onNextMessage = function onNextMessage(data) {

                // Rx fires first time empty
                if (Object.keys(data).length === 0 && data.constructor === Object) {

                    return;
                }

                var currentMessages = _this2.state.messages;
                var processedMessage = _this2.buildAlertMessage(data);
                var uniqueId = counter;
                currentMessages[uniqueId] = processedMessage;
                counter++;

                _this2.setState({ messages: currentMessages }, function () {

                    var timeoutId = setTimeout(function () {
                        _this2.onClose({
                            messageId: uniqueId
                        });
                    }, processedMessage.delay);
                });
            };
            messageObservable.subscribe(onNextMessage, function () {}, function () {});
        }
    }, {
        key: 'onClose',
        value: function onClose(_ref) {
            var messageId = _ref.messageId;


            var currentMessages = this.state.messages;
            if (!currentMessages[messageId]) {

                return;
            }
            delete currentMessages[messageId];

            this.setState({
                messages: currentMessages
            });
        }
        // Remove all token cookies set at login

    }, {
        key: 'removeLoginCookies',
        value: function removeLoginCookies() {

            _RFC4.default.remove(cookieConfig.token, {
                path: '/',
                domain: domain
            });

            _RFC4.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: domain
            });

            _RFC4.default.remove(cookieConfig.token, {
                path: '/',
                domain: rootDomain
            });

            _RFC4.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: rootDomain
            });
        }
    }, {
        key: 'handleStateChange',
        value: function handleStateChange(state, index) {

            // because ui-sref directives are not handled in the angular context
            // state change doesn't work
            // so we instead get a reference to the dom element
            // and look for a stateTo and stateParams attributes
            // to then navigate to a certain state
            var messageDOMref = this.messageRef[index];
            var hasStateTotransition = messageDOMref.querySelector('[stateTo]');
            var isModal = messageDOMref.querySelector('[modal]');
            if (hasStateTotransition) {
                var stateToTransition = hasStateTotransition.attributes.stateto.value;
                var stateParams = hasStateTotransition.attributes.stateparams && hasStateTotransition.attributes.stateparams.value;
                var paramsValues = stateParams ? stateParams.split(',') : [];
                var parsedStateParams = {};
                paramsValues.forEach(function (value) {
                    var param = value.split(':');
                    if (param.length > 0) {
                        parsedStateParams[param[0]] = param[1];
                    }
                });

                if (isModal) {

                    if (this.props.$state.current.name.indexOf('.ltb') > -1) {

                        this.props.$state.go('' + this.props.$state.current.name, parsedStateParams);
                    } else {

                        this.props.$state.go(this.props.$state.current.name + '.ltb', parsedStateParams);
                    }
                } else {

                    this.props.$state.go(stateToTransition, parsedStateParams);
                }
            }
            var clearAuthCookiesNeeded = messageDOMref.querySelector('[clearAuthCookies]');
            if (clearAuthCookiesNeeded) {
                this.removeLoginCookies();
            }
        }
    }, {
        key: 'isObject',
        value: function isObject(variable) {

            return variable !== null && (typeof variable === 'undefined' ? 'undefined' : _typeof(variable)) === 'object';
        }

        // construct the alert message structure

    }, {
        key: 'buildAlertMessage',
        value: function buildAlertMessage(data) {
            var args = data.args,
                params = data.params,
                type = data.type,
                timeout = data.timeout;

            var response = {
                args: {},
                params: {},
                delay: timeout || DEFAULT_DELAY,
                type: type
            };

            // check if it is not an object, put the args string in the message property
            if (!this.isObject(args)) {

                response.args = {
                    message: args
                };

                response.params = {
                    title: {},
                    message: params
                };
            } else {

                response.args = args;
                response.params = this.isObject(params) ? params : { title: {}, message: {} };
            }

            // set default values if missing
            response.args.title = response.args.title ? response.args.title : DEFAULT_KEYS[type].title;
            response.args.message = response.args.message ? response.args.message : DEFAULT_KEYS[type].message;
            response.args.icon = response.args.icon ? response.args.icon : {};

            // if alert is type error, we show addtional info about the server response data from http interceptors
            var errorMessage = this.props.$rootScope.errorMessage;

            if (type === 'error' && errorMessage) {

                var translatedErrorKey = _i18next2.default.t('cw.general.ui.error');
                response.args.serverResponse = translatedErrorKey + ' ' + errorMessage;
            }

            return this.translateMessage(response);
        }

        // translate the keys

    }, {
        key: 'translateMessage',
        value: function translateMessage(alertMessage) {

            alertMessage.args.title = _i18next2.default.t(alertMessage.args.title, alertMessage.params.title);
            alertMessage.args.message = _i18next2.default.t(alertMessage.args.message, alertMessage.params.message);

            return alertMessage;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { className: 'ui-alert-container' },
                Object.keys(this.state.messages).reverse().map(function (messageKey, index) {

                    var message = _this3.state.messages[messageKey];

                    return _react2.default.createElement(
                        'div',
                        { id: 'ui-alert', key: messageKey, className: 'ui-alert ' + message.type + ' ' + (message.args.icon.imageUrl && 'nobg'), 'connectqa-notif': 'body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'icon-holder' },
                            message.args.icon.imageUrl ? _react2.default.createElement(
                                'div',
                                { className: 'img-holder' },
                                _react2.default.createElement('img', { src: message.args.icon.imageUrl })
                            ) : _react2.default.createElement('div', { className: 'icon icon-white ' + (message.args.icon.cssClasses || 'default-icon') + ' icon-s' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'message-holder' },
                            _react2.default.createElement('h3', { dangerouslySetInnerHTML: { __html: message.args.title }, className: 'text-grey-1 text-l', 'connectqa-notif': 'title' }),
                            _react2.default.createElement('h4', { ref: function ref(_ref2) {
                                    return _this3.messageRef[index] = _ref2;
                                }, onClick: function onClick(e) {
                                    return _this3.handleStateChange(e, index);
                                }, dangerouslySetInnerHTML: { __html: message.args.message }, className: 'text-grey-2 text-s', 'connectqa-notif': 'message' }),
                            _react2.default.createElement('h5', { dangerouslySetInnerHTML: { __html: message.args.serverResponse }, className: 'text-grey-5 text-xs' })
                        ),
                        _react2.default.createElement('a', { onClick: function onClick() {
                                return _this3.onClose({ messageId: messageKey });
                            }, className: 'icon icon-close icon-grey-3 icon-xxs', 'connectqa-notif': 'close' })
                    );
                })
            );
        }
    }]);

    return AlertComponent;
}(_react2.default.Component);

exports.AlertComponent = AlertComponent;

/***/ }),

/***/ "cerT":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("SyJ6"),
    basePropertyDeep = __webpack_require__("mvQj"),
    isKey = __webpack_require__("Kxtb"),
    toKey = __webpack_require__("4dmE");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "cgV+":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div>\n        <div class=\"staging-area\" id=\"statusStaging\" ng-mouseover=\"broadcastMouseOver()\">\n            <div class=\"staging-holder\">\n\n                <i class=\"mobile-logo sprite sprite-logo inline-block v-top\"></i>\n\n                <div class=\"inline-block logo-area v-middle\">\n                    <a href=\"https://www.avira.com\"\n                       class=\"btn-logo-back inline-block icon chevron-back-2 icon-grey-4 icon-xs\"\n                       ng-if=\"referralCode.indexOf('website') > -1\"></a>\n                    <a id=\"avira-connect-logo\" ui-sref=\"root.dashboard.home\" class=\"logo-nd inline-block\" ng-click=\"onClickLogo()\">\n                        <i class=\"sprite sprite-logo inline-block v-top\"></i>\n                        <span class=\"text-l text-grey-1 inline-block v-top\" translate=\"cw.application_name_v3\"\n                            translate-values=\"{name: '{{$root.State.partner.name}}'}\"\n                        ></span>\n                    </a>\n                </div>\n\n                <!--Account Chooser-->\n                <account-chooser ng-if=\"!User.id\"> </account-chooser>\n\n                <div class=\"info-user-nd v-top\" ng-if=\"User.id\">\n\n                    <!--Language Switcher-->\n                    <language-switcher></language-switcher>\n\n                    <!--User Events-->\n                    <!--<user-events></user-events>-->\n\n                    <!--User Info-->\n                    <user-info></user-info>\n\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "crKe":
/***/ (function(module, exports) {

module.exports = "<div class=\"info-user-nd v-top\">\n    <div class=\"reg-anon\">\n        <a ng-click=\"accountChooserCtrl.mixpClickHdlAnon('register')\" ui-sref=\"ltb({ltb: 'register'})\"><b class=\"btn-large btn-large text-m\" translate=\"cw.dashboard.anonymous.register\"></b></a>\n        <var translate=\"cw.form.or\"></var>\n        <a ng-click=\"accountChooserCtrl.mixpClickHdlAnon('login')\" ui-sref=\"ltb({ltb: 'login'})\" class=\"reg-anon\"><b class=\"btn-large btn-large text-m\" translate=\"cw.dashboard.anonymous.login\"></b></a>\n    </div>\n</div>\n"

/***/ }),

/***/ "cxqI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentTypesRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about users
 * using http requests.
 */

var PaymentTypesRestService = function (_BaseRestService) {
    _inherits(PaymentTypesRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function PaymentTypesRestService($http, $q, Util) {
        _classCallCheck(this, PaymentTypesRestService);

        return _possibleConstructorReturn(this, (PaymentTypesRestService.__proto__ || Object.getPrototypeOf(PaymentTypesRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.PaymentTypesRestService#getAllAsync
     * @methodOf rest.services.PaymentTypesRestService
     * @function
     *
     * @description
     * Retrieves the user payment types
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(PaymentTypesRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(PaymentTypesRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentTypesRestService.prototype), 'getAllAsync', this).call(this, 'payment-types/');
        }
    }]);

    return PaymentTypesRestService;
}(_baseRestService2.default);

exports.default = PaymentTypesRestService;


_serviceDependencies.push(PaymentTypesRestService);

angular.module('rest.services').service('PaymentTypesRestService', _serviceDependencies);

/***/ }),

/***/ "cyi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = [];
/**
 * @ngdoc service
 * @name rest.services.MyAccountCountriesService
 *
 * @description
 * contains the list of countries and their code
 */

var MyAccountCountriesService = function () {

    /**
     * @param  {any}
     */
    function MyAccountCountriesService() {
        _classCallCheck(this, MyAccountCountriesService);

        this.countries = [{ code: 'AF', name: 'Afghanistan' }, { code: 'AX', name: 'Åland Islands' }, { code: 'AL', name: 'Albania' }, { code: 'DZ', name: 'Algeria' }, { code: 'AS', name: 'American Samoa' }, { code: 'AD', name: 'Andorra' }, { code: 'AO', name: 'Angola' }, { code: 'AI', name: 'Anguilla' }, { code: 'AQ', name: 'Antarctica' }, { code: 'AG', name: 'Antigua and Barbuda' }, { code: 'AR', name: 'Argentina' }, { code: 'AM', name: 'Armenia' }, { code: 'AW', name: 'Aruba' }, { code: 'AU', name: 'Australia' }, { code: 'AT', name: 'Austria' }, { code: 'AZ', name: 'Azerbaijan' }, { code: 'BS', name: 'Bahamas' }, { code: 'BH', name: 'Bahrain' }, { code: 'BD', name: 'Bangladesh' }, { code: 'BB', name: 'Barbados' }, { code: 'BY', name: 'Belarus' }, { code: 'BE', name: 'Belgium' }, { code: 'BZ', name: 'Belize' }, { code: 'BJ', name: 'Benin' }, { code: 'BM', name: 'Bermuda' }, { code: 'BT', name: 'Bhutan' }, { code: 'BO', name: 'Bolivia' }, { code: 'BA', name: 'Bosnia and Herzegovina' }, { code: 'BW', name: 'Botswana' }, { code: 'BV', name: 'Bouvet Island' }, { code: 'BR', name: 'Brazil' }, { code: 'IO', name: 'British Indian Ocean Territory' }, { code: 'VG', name: 'British Virgin Islands' }, { code: 'BN', name: 'Brunei' }, { code: 'BG', name: 'Bulgaria' }, { code: 'BF', name: 'Burkina Faso' }, { code: 'BI', name: 'Burundi' }, { code: 'KH', name: 'Cambodia' }, { code: 'CM', name: 'Cameroon' }, { code: 'CA', name: 'Canada' }, { code: 'CV', name: 'Cape Verde' }, { code: 'KY', name: 'Cayman Islands' }, { code: 'CF', name: 'Central African Republic' }, { code: 'TD', name: 'Chad' }, { code: 'CL', name: 'Chile' }, { code: 'CN', name: 'China' }, { code: 'CX', name: 'Christmas Island' }, { code: 'CC', name: 'Cocos (Keeling) Islands' }, { code: 'CO', name: 'Colombia' }, { code: 'KM', name: 'Comoros' }, { code: 'CD', name: 'Congo [DRC]' }, { code: 'CG', name: 'Congo [Republic]' }, { code: 'CK', name: 'Cook Islands' }, { code: 'CR', name: 'Costa Rica' }, { code: 'CI', name: 'Côte d’Ivoire' }, { code: 'HR', name: 'Croatia' }, { code: 'CU', name: 'Cuba' }, { code: 'CY', name: 'Cyprus' }, { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' }, { code: 'DJ', name: 'Djibouti' }, { code: 'DM', name: 'Dominica' }, { code: 'DO', name: 'Dominican Republic' }, { code: 'EC', name: 'Ecuador' }, { code: 'EG', name: 'Egypt' }, { code: 'SV', name: 'El Salvador' }, { code: 'GQ', name: 'Equatorial Guinea' }, { code: 'ER', name: 'Eritrea' }, { code: 'EE', name: 'Estonia' }, { code: 'ET', name: 'Ethiopia' }, { code: 'FK', name: 'Falkland Islands [Islas Malvinas]' }, { code: 'FO', name: 'Faroe Islands' }, { code: 'FJ', name: 'Fiji' }, { code: 'FI', name: 'Finland' }, { code: 'FR', name: 'France' }, { code: 'GF', name: 'French Guiana' }, { code: 'PF', name: 'French Polynesia' }, { code: 'TF', name: 'French Southern Territories' }, { code: 'GA', name: 'Gabon' }, { code: 'GM', name: 'Gambia' }, { code: 'GE', name: 'Georgia' }, { code: 'DE', name: 'Germany' }, { code: 'GH', name: 'Ghana' }, { code: 'GI', name: 'Gibraltar' }, { code: 'GR', name: 'Greece' }, { code: 'GL', name: 'Greenland' }, { code: 'GD', name: 'Grenada' }, { code: 'GP', name: 'Guadeloupe' }, { code: 'GU', name: 'Guam' }, { code: 'GT', name: 'Guatemala' }, { code: 'GG', name: 'Guernsey' }, { code: 'GN', name: 'Guinea' }, { code: 'GW', name: 'Guinea-Bissau' }, { code: 'GY', name: 'Guyana' }, { code: 'HT', name: 'Haiti' }, { code: 'HM', name: 'Heard Isl. and Mcdonald Isl' }, { code: 'HN', name: 'Honduras' }, { code: 'HK', name: 'Hong Kong' }, { code: 'HU', name: 'Hungary' }, { code: 'IS', name: 'Iceland' }, { code: 'IN', name: 'India' }, { code: 'ID', name: 'Indonesia' }, { code: 'IR', name: 'Iran' }, { code: 'IQ', name: 'Iraq' }, { code: 'IE', name: 'Ireland' }, { code: 'IM', name: 'Isle of Man' }, { code: 'IL', name: 'Israel' }, { code: 'IT', name: 'Italy' }, { code: 'JM', name: 'Jamaica' }, { code: 'JP', name: 'Japan' }, { code: 'JE', name: 'Jersey' }, { code: 'JO', name: 'Jordan' }, { code: 'KZ', name: 'Kazakhstan' }, { code: 'KE', name: 'Kenya' }, { code: 'KI', name: 'Kiribati' }, { code: 'KW', name: 'Kuwait' }, { code: 'KG', name: 'Kyrgyzstan' }, { code: 'LA', name: 'Laos' }, { code: 'LV', name: 'Latvia' }, { code: 'LB', name: 'Lebanon' }, { code: 'LS', name: 'Lesotho' }, { code: 'LR', name: 'Liberia' }, { code: 'LY', name: 'Libya' }, { code: 'LI', name: 'Liechtenstein' }, { code: 'LT', name: 'Lithuania' }, { code: 'LU', name: 'Luxembourg' }, { code: 'MO', name: 'Macau' }, { code: 'MK', name: 'Macedonia [FYROM]' }, { code: 'MG', name: 'Madagascar' }, { code: 'MW', name: 'Malawi' }, { code: 'MY', name: 'Malaysia' }, { code: 'MV', name: 'Maldives' }, { code: 'ML', name: 'Mali' }, { code: 'MT', name: 'Malta' }, { code: 'MH', name: 'Marshall Islands' }, { code: 'MQ', name: 'Martinique' }, { code: 'MR', name: 'Mauritania' }, { code: 'MU', name: 'Mauritius' }, { code: 'YT', name: 'Mayotte' }, { code: 'MX', name: 'Mexico' }, { code: 'FM', name: 'Micronesia' }, { code: 'MD', name: 'Moldova' }, { code: 'MC', name: 'Monaco' }, { code: 'MN', name: 'Mongolia' }, { code: 'MS', name: 'Monserrat' }, { code: 'ME', name: 'Montenegro' }, { code: 'MA', name: 'Morocco' }, { code: 'MZ', name: 'Mozambique' }, { code: 'MM', name: 'Myanmar [Burma]' }, { code: 'NA', name: 'Namibia' }, { code: 'NR', name: 'Nauru' }, { code: 'NP', name: 'Nepal' }, { code: 'NL', name: 'Netherlands' }, { code: 'AN', name: 'Netherlands Antilles' }, { code: 'NC', name: 'New Caledonia' }, { code: 'NZ', name: 'New Zealand' }, { code: 'NI', name: 'Nicaragua' }, { code: 'NE', name: 'Niger' }, { code: 'NG', name: 'Nigeria' }, { code: 'NU', name: 'Niue' }, { code: 'NF', name: 'Norfolk Island' }, { code: 'KP', name: 'North Korea' }, { code: 'MP', name: 'Northern Mariana Islands' }, { code: 'NO', name: 'Norway' }, { code: 'OM', name: 'Oman' }, { code: 'PK', name: 'Pakistan' }, { code: 'PW', name: 'Palau' }, { code: 'PS', name: 'Palestinian Territories' }, { code: 'PA', name: 'Panama' }, { code: 'PG', name: 'Papua New Guinea' }, { code: 'PY', name: 'Paraguay' }, { code: 'PE', name: 'Peru' }, { code: 'PH', name: 'Philippines' }, { code: 'PN', name: 'Pitcairn' }, { code: 'PL', name: 'Poland' }, { code: 'PT', name: 'Portugal' }, { code: 'PR', name: 'Puerto Rico' }, { code: 'QA', name: 'Qatar' }, { code: 'RE', name: 'Réunion' }, { code: 'RO', name: 'Romania' }, { code: 'RU', name: 'Russia' }, { code: 'RW', name: 'Rwanda' }, { code: 'GS', name: 'S. Georgia and S. Sandwich Isl.' }, { code: 'BL', name: 'Saint BarthÃ©lemy' }, { code: 'SH', name: 'Saint Helena' }, { code: 'KN', name: 'Saint Kitts and Nevis' }, { code: 'LC', name: 'Saint Lucia' }, { code: 'MF', name: 'Saint Martin (French part)' }, { code: 'PM', name: 'Saint Pierre and Miquelon' }, { code: 'VC', name: 'Saint Vincent and the Grenadines' }, { code: 'WS', name: 'Samoa' }, { code: 'SM', name: 'San Marino' }, { code: 'ST', name: 'Sao Tome and Principe' }, { code: 'SA', name: 'Saudi Arabia' }, { code: 'SN', name: 'Senegal' }, { code: 'RS', name: 'Serbia' }, { code: 'SC', name: 'Seychelles' }, { code: 'SL', name: 'Sierra Leone' }, { code: 'SG', name: 'Singapore' }, { code: 'SX', name: 'Sint Maarten' }, { code: 'SK', name: 'Slovakia' }, { code: 'SI', name: 'Slovenia' }, { code: 'SB', name: 'Solomon Islands' }, { code: 'SO', name: 'Somalia' }, { code: 'ZA', name: 'South Africa' }, { code: 'KR', name: 'South Korea' }, { code: 'ES', name: 'Spain' }, { code: 'LK', name: 'Sri Lanka' }, { code: 'SD', name: 'Sudan' }, { code: 'SR', name: 'Suriname' }, { code: 'SJ', name: 'Svalbard and Jan Mayen' }, { code: 'SZ', name: 'Swaziland' }, { code: 'SE', name: 'Sweden' }, { code: 'CH', name: 'Switzerland' }, { code: 'SY', name: 'Syria' }, { code: 'TW', name: 'Taiwan' }, { code: 'TJ', name: 'Tajikistan' }, { code: 'TZ', name: 'Tanzania' }, { code: 'TH', name: 'Thailand' }, { code: 'TL', name: 'Timor-Leste' }, { code: 'TG', name: 'Togo' }, { code: 'TK', name: 'Tokelau' }, { code: 'TO', name: 'Tonga' }, { code: 'TT', name: 'Trinidad and Tobago' }, { code: 'TN', name: 'Tunisia' }, { code: 'TR', name: 'Türkiye' }, { code: 'TM', name: 'Turkmenistan' }, { code: 'TC', name: 'Turks and Caicos Islands' }, { code: 'TV', name: 'Tuvalu' }, { code: 'UM', name: 'U. S. Minor Outlying Islands' }, { code: 'VI', name: 'U.S. Virgin Islands' }, { code: 'UG', name: 'Uganda' }, { code: 'UA', name: 'Ukraine' }, { code: 'AE', name: 'United Arab Emirates' }, { code: 'GB', name: 'United Kingdom' }, { code: 'US', name: 'United States' }, { code: 'UY', name: 'Uruguay' }, { code: 'UZ', name: 'Uzbekistan' }, { code: 'VU', name: 'Vanuatu' }, { code: 'VA', name: 'Vatican City' }, { code: 'VE', name: 'Venezuela' }, { code: 'VN', name: 'Vietnam' }, { code: 'WF', name: 'Wallis and Futuna' }, { code: 'EH', name: 'Western Sahara' }, { code: 'YE', name: 'Yemen' }, { code: 'ZM', name: 'Zambia' }, { code: 'ZW', name: 'Zimbabwe' }];
    }

    /**
     * @ngdoc function
     * @name rest.services.MyAccountCountriesService#create
     * @methodOf rest.services.MyAccountCountriesService
     * @function
     *
     * @description
     * returns the list of countries
     */


    _createClass(MyAccountCountriesService, [{
        key: 'getCountries',
        value: function getCountries() {

            return this.countries;
        }
    }]);

    return MyAccountCountriesService;
}();

_serviceDependencies.push(MyAccountCountriesService);

angular.module('rest.services').service('MyAccountCountriesService', _serviceDependencies);

/***/ }),

/***/ "d+Uu":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("VZjL"),
    baseKeys = __webpack_require__("mX7V"),
    isArrayLike = __webpack_require__("K2yx");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "dFQA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this : 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$scope', '$state', '$window', 'Util', 'ProfileImageRestService', 'UserRestService'];

var _user = void 0;
var _$scope = void 0;
var _UserRestService = void 0;
var _MeRepository = void 0;
var _Util = void 0;
var _file = void 0;
var _ProfileImageRestService = void 0;

/**
 * @ngdoc service
 * @name controllers.CropImage
 *
 * @description
 * Crop Image controller
 */

var CropImage = function () {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} ProfileImageRestService
     * @param  {any} UserRestService
     */
    function CropImage($rootScope, $scope, $state, $window, Util, ProfileImageRestService, UserRestService) {
        _classCallCheck(this, CropImage);

        var imageFileEvent = $rootScope.imageFileEvent;


        _user = _index.MeRepository.getMyUser();
        _$scope = $scope;
        _UserRestService = UserRestService;
        _MeRepository = _index.MeRepository;
        _ProfileImageRestService = ProfileImageRestService;
        _Util = Util;

        this.$state = $state;

        _$scope.image = '';
        _$scope.croppedImage = '';
        _$scope.disabledButton = true;

        // $scope assigned functions
        _$scope.closeModal = this.closeModal;
        _$scope.onLoadDone = this.onLoadDone;
        _$scope.onError = this.onError;
        _$scope.uploadImage = this.uploadImage;

        // check if image file event exists
        if (imageFileEvent) {

            this.handleSelectedFile(imageFileEvent);
        } else {

            _Util.closeModal();
        }
    }

    _createClass(CropImage, [{
        key: 'handleSelectedFile',
        value: function handleSelectedFile(eventData) {

            var reader = new FileReader();

            var _eventData$currentTar = _slicedToArray(eventData.currentTarget.files, 1);

            _file = _eventData$currentTar[0];


            reader.onload = function (event) {

                _$scope.image = event.target.result;
            };

            reader.readAsDataURL(_file);
        }

        // when image loading process is done, activate save button

    }, {
        key: 'onLoadDone',
        value: function onLoadDone() {

            _$scope.disabledButton = false;
        }

        // this is a fallback if the ui-cropper directive returns error

    }, {
        key: 'onError',
        value: function onError() {

            _RFC2.default.error('cw.profile.picture.alerts.wrong_format');
            _Util.closeModal();
        }
    }, {
        key: 'uploadImage',
        value: function uploadImage() {

            var fileExtension = _file.type.split('/')[1];

            var profileImagePayload = {
                crm_id: _user.attributes.crm_id,
                ext: fileExtension,
                profile_image_medium: this.$parent.croppedImage
            };

            _$scope.disabledButton = true;

            _ProfileImageRestService.create(profileImagePayload).then(function (response) {

                var userImagePayload = {
                    data: {
                        attributes: {
                            profile_image_medium: response.data.profile_image_medium
                        },
                        type: 'users',
                        id: _user.id
                    }
                };

                _UserRestService.update(_user.id, userImagePayload).then(function (user) {

                    _Util.closeModal();
                    _MeRepository.update(user.data.data);
                    _Util.updateLastLoginObjectInLocalStorage(user.data.data);

                    _RFC2.default.success('cw.profile.picture.alerts.upload_success');
                }).then(null, function () {

                    _Util.closeModal();
                    _RFC2.default.error('cw.profile.picture.alerts.upload_error');
                });
            }).then(null, function () {

                _Util.closeModal();
                _RFC2.default.error('cw.profile.picture.alerts.upload_error');
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {

            _Util.closeModal();
        }
    }]);

    return CropImage;
}();

_serviceDependencies.push(CropImage);

angular.module('controllers').controller('CropImage', _serviceDependencies);

/***/ }),

/***/ "dH6z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("VqLu");
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),

/***/ "dOW8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("xfUU");


/***/ }),

/***/ "dUTw":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "dV7H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('friendName', function () {
    return function (friend) {

        if (angular.isUndefined(friend)) {

            return null;
        }
        if (friend.attributes.first_name && friend.attributes.last_name) {

            return friend.attributes.first_name + ' ' + friend.attributes.last_name;
        } else if (friend.attributes.first_name) {

            return friend.attributes.first_name;
        } else if (friend.attributes.last_name) {

            return friend.attributes.last_name;
        } else if (friend.attributes.email) {

            var firstEmailPart = friend.attributes.email.split('@')[0];

            return firstEmailPart;
        }
        return null;
    };
});

/***/ }),

/***/ "dW4B":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("zw2X");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "dWpk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc service
 * @name controllers.WelcomeModal
 *
 * @description
 * Welcome Modal
 */
angular.module('controllers').controller('WelcomeModal', ['$scope', '$state', '$document', 'LicenseRestService', 'Sso', 'ActivationCodeRestService', 'Util', 'DeployRestService', function ($scope, $state, $document, LicenseRestService, Sso, ActivationCodeRestService, Util, DeployRestService) {

    angular.element($document[0].body).addClass('splash-screen');

    // retrieve the x-a-* params and forward them to the backend
    var ssoParams = Sso.getParams();
    var metaParams = {};
    Object.keys(ssoParams).forEach(function (key) {

        if (key.indexOf('x-a-') > -1) {

            metaParams[key] = ssoParams[key];
        }
    });

    $scope.license = _index.LicensesRepository.getLicenseByAppId($state.params.resourceId);
    $scope.brandName = CWCONFIG.partnerConfig.name;
    $scope.product = _index.AppIntegrationsRepository.getAppName('aps10');
    if (!$scope.license) {

        var licensePayload = {
            data: {
                relationships: {
                    app: {
                        data: {
                            type: 'apps',
                            id: $state.params.resourceId
                        }
                    }
                }
            },
            meta: {
                'x-params': metaParams
            }
        };
        // add campgain param in meta
        if (metaParams['x-a-channel']) {

            licensePayload.meta.cmp = metaParams['x-a-channel'];
        }
        LicenseRestService.create(licensePayload).then(function (license) {

            $scope.license = license;

            // get activationCode after the license is received
            ActivationCodeRestService.getAllAsync().then(function (response) {

                _index.ActivationCodesRepository.replace(response.data.data);
            });
        }).catch(function () {

            Util.closeModal();
        });
    }

    var mixpanelPayload = {
        Source: metaParams['x-a-source'],
        Modal: 'Prime Trial Welcome Modal',
        Page: Util.getPageName()
    };

    _RFC2.default.send('ConnectWeb Modal Open ', mixpanelPayload);

    $scope.$on('$destroy', function () {

        angular.element($document[0].body).removeClass('splash-screen');
    });

    $scope.installApp = function () {

        var mixpanelData = {
            Modal: 'Prime Trial Welcome Modal',
            'Button Label': 'Install now',
            'Product ID': $state.params.resourceId,
            Page: Util.getPageName()
        };

        _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelData);

        var devices = _index.DevicesRepository.getVisibleDevices();

        devices.forEach(function (device) {

            // if device has Windows OS
            if (device.attributes.os === 'windows') {

                var deploymentPayload = {
                    deviceId: device.id,
                    userId: Util.deepFind(device, 'relationships.user.data.id'),
                    appId: 'aps10'
                };

                DeployRestService.deployOnDevice(deploymentPayload).then(function () {

                    $state.go('root.dashboard.home');
                }).then(null, function (e) {

                    /* 409 === Conflict
                    An instance for this application already
                    exists (pending) - ignore */
                    if (e.status === 409) {

                        return;
                    }

                    _RFC4.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {

                            cssClasses: 'icon-' + Util.deepFind(device, 'attributes.type')

                        }

                    });
                });
            }
        });
    };

    $scope.closeModal = function () {

        Util.closeModal();
    };
}]);

/***/ }),

/***/ "di0k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @ngdoc object
 *
 * @description
 * Available paths for which we accept websocket notifications
 */
var whitelistedPaths = ['apps', 'app-instances', 'app-integrations', 'devices', 'licenses', 'users', 'actions', 'events', 'activation-codes'];

exports.default = whitelistedPaths;

/***/ }),

/***/ "dj/A":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("v3EM");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "dslW":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-drivers-license\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.drivers_license.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"driversLicense in driversLicense.entries\">\n                            <div class=\"col-6 col-text text-left\" ng-if=\"!driversLicense.showUpdateInput\">\n                                <p class=\"break-word text-grey-3 text-l\" translate=\"cw.dwm.entity.drivers_license.number\"></p> \n                            </div>\n                            <div class=\"col-5 col-text text-left\" ng-if=\"!driversLicense.showUpdateInput\">\n                                <p class=\"text-grey-1 text-l account-number\">{{driversLicense.driversLicenseNumber}}</p>\n                            </div>\n                            <div class=\"col-5 col-text col-text text-right\" ng-if=\"!driversLicense.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                            <div class=\"col-8 col-text text-left\" ng-class=\"{'col-8-error': !driversLicenseNumberIsValid}\" ng-if=\"driversLicense.showUpdateInput\">\n                                    <p class=\"text-grey-3 break-word text-l\"\n                                    translate=\"cw.dwm.entity.drivers_license.number\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\" ng-if=\"driversLicense.showUpdateInput\">\n                                <div>\n                                    <input type=\"text\"\n                                        ng-class=\"{'error': !driversLicenseNumberIsValid}\"\n                                        name=\"driversLicenseNumber\"\n                                        minlength=\"4\"\n                                        maxlength=\"20\"\n                                        autocomplete=\"off\"\n                                        class=\"update-drivers-license-number\"\n                                        ng-keyup=\"updateDriversLicenseNumber($event);\">\n                                    <p class=\"error-message\" ng-show=\"!driversLicenseNumberIsValid\"\n                                        translate=\"cw.dwm.entity.drivers_license.invalid_number\">\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-8 col-text text-left\" ng-class=\"{'col-8-error': !driversLicenseNumberIsValid}\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.drivers_license.number\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <div>\n                                    <input type=\"text\" ng-class=\"{'error': !driversLicenseNumberIsValid}\"\n                                        name=\"driversLicenseNumber\" ng-model=\"newDriversLicenseNumber\" minlength=\"4\" maxlength=\"20\" autocomplete=\"off\"\n                                        id=\"driversLicenseNumber\" class=\"update-drivers-license-number\" ng-keyup=\"validateDriversLicenseNumber($event)\">\n                                        <p class=\"error-message\" ng-show=\"!driversLicenseNumberIsValid\"\n                                            translate=\"cw.dwm.entity.drivers_license.invalid_number\"></p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.drivers_license.remove_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.drivers_license.remove_desc_1\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.drivers_license.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.drivers_license.entity_details.desc_1\"></p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.drivers_license.entity_details.desc_2\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\" ng-if=\"showAddNewButton && (driversLicense.maxCount > driversLicense.entries.length)\"\n                ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewDriversLicenseIsLoading}\"\n                    ng-disabled=\"saveNewDriversLicenseIsLoading || !driversLicenseNumberIsValid\"\n                    ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewDriversLicenseIsLoading}\"\n                    ng-disabled=\"saveNewDriversLicenseIsLoading || !driversLicenseNumberIsValid\"\n                    ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/drivers-license/drivers-license.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "dwD7":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "dxLk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    /**
     * @ngdoc service
     * @name services.$focus
     *
     * @description
     * Sends a `focus` event to a directive which will focus its element
     */
    angular.module('services').factory('$focus', ['$timeout', function ($timeout) {
        return function (scope, name, timeout) {

            $timeout(function () {

                scope.$broadcast('focus', name);
            }, timeout || 250);
        };
    }]);
})();

/***/ }),

/***/ "e4MQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("fIlE");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.ActivationCodeNotifications
*
* @description
* This class is used to process notifications on activation code.
*/
var ActivationCodeNotifications = {
    getAppNameByActivationCode: function getAppNameByActivationCode(activationCode) {

        var appId = _RFC4.default.deepFind(activationCode, 'relationships.app.data.id');
        var appIntegration = _index.AppIntegrationsRepository.getById(appId);
        var appName = _RFC4.default.deepFind(appIntegration, 'attributes.resource.oeName');

        return appName;
    },


    /**
    * @ngdoc function
    * @name notifications.ActivationCodeNotifications#processCreate
    * @methodOf notifications.ActivationCodeNotifications
    * @function
    *
    * @description
    * This function can be used to process a new activation code.
    *
    * @param {object} data an activationCode.
    */
    processCreate: function processCreate(data) {

        var appName = this.getAppNameByActivationCode(data);

        _RFC2.default.success({
            message: 'cw.subscription.activation_success_desc'
        }, {
            message: {
                appName: appName
            }
        });
    },


    /**
     * @ngdoc function
     * @name notifications.ActivationCodeNotifications#processUpdate
     * @methodOf notifications.ActivationCodeNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on an activation code.
     *
     * @param {object} data An object with updated values on activation code.
     * @param {object} prevDevice The old activation code object.
     * @param {object} newDevice The update activation code object.
     */
    processUpdate: function processUpdate(data, prevActivationCode, newActivationCode) {

        // Subscription turned on
        if (data['attributes.subscription'] === '1') {

            _RFC2.default.success('cw.subscription.on_success');
        }

        // Subscription turned off
        if (data['attributes.subscription'] === '0') {

            _RFC2.default.success('cw.subscription.off');
        }

        // Subscription used/activated
        if (data['attributes.status'] === 'used') {

            var appName = this.getAppNameByActivationCode(newActivationCode);

            _RFC2.default.success({
                message: 'cw.subscription.activation_success_desc'
            }, {
                message: {
                    appName: appName
                }
            });
        }
    }
};

exports.default = ActivationCodeNotifications;

/***/ }),

/***/ "e4WZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

var ChangePaymentUrlsRestService = function (_BaseRestService) {
    _inherits(ChangePaymentUrlsRestService, _BaseRestService);

    function ChangePaymentUrlsRestService($http, $q, Util) {
        _classCallCheck(this, ChangePaymentUrlsRestService);

        return _possibleConstructorReturn(this, (ChangePaymentUrlsRestService.__proto__ || Object.getPrototypeOf(ChangePaymentUrlsRestService)).call(this, $http, $q, Util));
    }

    _createClass(ChangePaymentUrlsRestService, [{
        key: 'changePaymentUrlByTransactionId',
        value: function changePaymentUrlByTransactionId(transactionId) {

            return _get(ChangePaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(ChangePaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'change-payment-urls?filter[orderid]=' + transactionId);
        }
    }]);

    return ChangePaymentUrlsRestService;
}(_baseRestService2.default);

exports.default = ChangePaymentUrlsRestService;


_serviceDependencies.push(ChangePaymentUrlsRestService);

angular.module('rest.services').service('ChangePaymentUrlsRestService', _serviceDependencies);

/***/ }),

/***/ "eIoM":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("sK5d"),
    hasPath = __webpack_require__("8E7j");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "eKAY":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "eMXG":
/***/ (function(module, exports) {

module.exports = "<div class=\"faq tab-content\">\n    <div class=\"crypto-card-header display-flex justify-content-space-between align-item-center\">\n        <div class=\"w100\">\n            <i class=\"icon-crypto-faq icon inline-block large-icon\"></i>\n            <h2 class=\"inline-block v-middle text-grey-1\" translate=\"cw.dashboard.crypto.faq.title\">\n            </h2>\n        </div>\n    </div>\n    <div class=\"faq-wrapper display-flex justify-content-space-between align-item-flex-start mt40\">\n        <div class=\"questions\">\n            <ul>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q1', 'crs-pointer text-grey-4': activeQuestion !== 'q1'}\"\n                        ng-click=\"changeQuestion('q1')\" translate=\"cw.dashboard.crypto.faq.q_6\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q2', 'crs-pointer text-grey-4': activeQuestion !== 'q2'}\"\n                        ng-click=\"changeQuestion('q2')\" translate=\"cw.dashboard.crypto.faq.q_7\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q3', 'crs-pointer text-grey-4': activeQuestion !== 'q3'}\"\n                        ng-click=\"changeQuestion('q3')\" translate=\"cw.dashboard.crypto.faq.q_8\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q4', 'crs-pointer text-grey-4': activeQuestion !== 'q4'}\"\n                        ng-click=\"changeQuestion('q4')\" translate=\"cw.dashboard.crypto.faq.q_9\"></p>\n                </li>\n                <li>\n                    <p class=\"text-l\"\n                        ng-class=\"{'text-grey-2 active': activeQuestion === 'q5', ' crs-pointer text-grey-4': activeQuestion !== 'q5'}\"\n                        ng-click=\"changeQuestion('q5')\" translate=\"cw.dashboard.crypto.faq.q_10\"></p>\n                </li>\n            </ul>\n        </div>\n        <div class=\"answers\">\n            <div ng-if=\"activeQuestion === 'q1'\">\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.faq.a_6_desc_1\"></p>\n            </div>\n            <div ng-if=\"activeQuestion === 'q2'\">\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.faq.a_7_desc_1\">\n                </p>\n            </div>\n            <div ng-if=\"activeQuestion === 'q3'\">\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.faq.a_8_desc_1\"></p>\n            </div>\n            <div ng-if=\"activeQuestion === 'q4'\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.crypto.faq.a_9_desc_1\"></p>\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.faq.a_9_desc_2\"></p>\n            </div>\n            <div ng-if=\"activeQuestion === 'q5'\">\n                <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.crypto.faq.a_10_desc_1\"></p>\n                <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.faq.a_10_desc_2\"></p>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "eMuH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint max-len: 0 */

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', 'Util', '$scope', '$rootScope'];

var OneClickPaymentButtonController = function () {
    function OneClickPaymentButtonController($state, Util, $scope, $rootScope) {
        var _this = this;

        _classCallCheck(this, OneClickPaymentButtonController);

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;
        this.$rootScope = $rootScope;

        $scope.showRecommendation = false;
        var subscriptions = _index.ActivationCodesRepository.getAll();

        $scope.showLearnMoreButton = true;

        if (this.$scope.productid === 'aps10') {

            // hide the learn more button for app recommendations without comparison features
            var currentUserAppId = Util.deepFind(subscriptions[0], 'attributes.app');
            var recommendedApp = _index.AppIntegrationsRepository.getById(currentUserAppId) || {};

            if (!Util.deepFind(recommendedApp, 'attributes.resource.comparisonFeatures')) {

                $scope.showLearnMoreButton = false;
            }
        }

        if (subscriptions.length > 0) {

            // get recommendation for user
            var recommendationObservable = _index.RecommendationsRepository.getObservable();
            var recommendationsSubscriber = recommendationObservable.subscribe(function (data) {

                // recommendation is available, show banner
                if (data.length > 0) {

                    _this.recommendations = data;

                    // feature/OE-7610-a-b-test-aia-banner-copy-ocp
                    $scope.recommendationDetails = _this.recommendations.find(function (recommendation) {
                        return recommendation.attributes.acronym === $scope.productid;
                    });
                    // feature/OE-7610-a-b-test-aia-banner-copy-ocp

                    if ($scope.recommendationDetails) {

                        // show recommendation only for CB region. CA region (USA) is excluded
                        if ($scope.recommendationDetails.attributes.pg === 'CB' && $scope.productid === $scope.recommendationDetails.attributes.acronym && $scope.runtime === '12' && $rootScope.hasValidPayment === true) {

                            $scope.showRecommendation = true;
                            _RFC4.default.broadcast('showRecommendation:true');
                        }

                        $scope.recommendedProduct = _index.AppIntegrationsRepository.getById($scope.recommendationDetails.attributes.acronym);
                    }
                } else {

                    $scope.showRecommendation = false;
                    _RFC4.default.broadcast('showRecommendation:false');
                }
            }, function () {}, function () {});

            $scope.$on('$destroy', function () {

                recommendationsSubscriber.dispose();
            });
        }
        $scope.$watch('runtime', function () {

            _this.toggleOcpButton();
        });
        $scope.$watch('productid', function () {

            _this.toggleOcpButton();
        });
    }

    _createClass(OneClickPaymentButtonController, [{
        key: 'toggleOcpButton',
        value: function toggleOcpButton() {

            var appId = this.Util.deepFind(this.$scope.recommendationDetails, 'attributes.acronym');
            if (this.$scope.runtime === '12' && this.$scope.productid === appId && this.$rootScope.hasValidPayment === true) {

                this.$scope.showRecommendation = true;
                _RFC4.default.broadcast('showRecommendation:true');
            } else {

                this.$scope.showRecommendation = false;
                _RFC4.default.broadcast('showRecommendation:false');
            }
        }
    }, {
        key: 'tryRecommendation',
        value: function tryRecommendation(action) {

            this.$rootScope.ocp_xa_content = this.$scope.xacontent;
            this.$rootScope.ocp_xa_medium = this.$scope.xamedium;
            this.$rootScope.ocp_xa_aiatest = this.$scope.xaaiatest;
            this.$rootScope.ocp_xa_button = this.$scope.xabutton;

            var ltbName = 'one-click-payment';
            var stateName = this.$state.current.name;

            if (stateName.indexOf('.ltb') === -1) {

                stateName += '.ltb';
            }

            // Learn More modal
            if (action === 'Learn More') {

                ltbName = 'ocp-comparison';
            }

            var mixpanelDetails = {
                Product: this.$scope.recommendedProduct.attributes.name,
                'Product ID': this.$scope.recommendedProduct.id,
                'Recommendation ID': this.$scope.recommendationDetails.id,
                'Button Label': action,
                Page: this.Util.capitalizeFirstLetter(this.$scope.page)
            };

            _RFC2.default.send('ConnectWeb OCP Button Click', mixpanelDetails);

            // open modal
            this.$state.go(stateName, {
                ltb: ltbName,
                resourceId: this.$scope.recommendedProduct.id
            }, {
                reload: false
            });
        }
    }]);

    return OneClickPaymentButtonController;
}();

var OneClickPaymentButtonDirective = function OneClickPaymentButtonDirective() {
    var _this2 = this;

    _classCallCheck(this, OneClickPaymentButtonDirective);

    this.template = '<div>\n                            <button class={{classname}}\n                                    ng-if="showRecommendation && action === \'Update\'"\n                                    connectqa-button="upgrade"\n                                    ng-click="oneClickPaymentButtonController.tryRecommendation(\'Update\')"\n                                    translate={{translationkey}}>\n                            </button>\n                            <a class={{classname}}\n                                    ng-if="showRecommendation && action === \'Learn More\' && showLearnMoreButton"\n                                    connectqa-button="upgrade"\n                                    ng-click="oneClickPaymentButtonController.tryRecommendation(\'Learn More\')"\n                                    translate={{translationkey}}\n                                    translate-values={{translationvalues}}>\n                            </a>\n                        </div>';
    this.restrict = 'EA';
    this.replace = true;
    this.scope = {
        source: '=',
        licenses: '=',
        classname: '=',
        translationkey: '=',
        action: '=',
        translationvalues: '=',
        productid: '=',
        runtime: '=',
        page: '=',
        xacontent: '=',
        xamedium: '=',
        xaaiatest: '=',
        xabutton: '='
    };

    if (CWCONFIG.features.oneClickPayment) {

        _controllerDependencies.push(function ($state, DeployRestService, Util, $scope, $rootScope) {
            return new OneClickPaymentButtonController($state, DeployRestService, Util, $scope, $rootScope);
        });
        this.controller = _controllerDependencies;
        this.controllerAs = 'oneClickPaymentButtonController';
    }
    _RFC4.default.subscribe('runtime:changed', function (data) {

        _this2.scope.runtime = data.runtime;
    });
    _RFC4.default.subscribe('product:changed', function (data) {

        _this2.scope.productid = data.activeProduct;
    });
};

_directiveDependencies.push(function () {
    return new OneClickPaymentButtonDirective();
});

angular.module('directives').directive('ocpButton', _directiveDependencies);

/***/ }),

/***/ "eMvg":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm-lightbox-notification dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || notificationStatus === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && notificationStatus === 'loaded'\" ng-hide=\"showOtpScreen\">\n\n        <div class=\"dwm-pagination text-left mb15\" ng-if=\"hasPagination\">\n            <span class=\"arrow arrow-prev text-grey-4 crs-pointer\" ng-click=\"prevPage()\" ng-class=\"{'disabled': !prevArrowEnabled}\">\n                <i class=\"icon chevron-back-2 text-grey-3\"></i>\n            </span>\n            <span class=\"text-m mr10 ml10 inline-block v-middle\" connectwebqa=\"alert_details_no_of_pages\">\n                {{activePage}} / {{notifications.detailViews.length}}\n            </span>\n            <span class=\"arrow arrow-next text-grey-4 crs-pointer\" ng-click=\"nextPage()\" ng-class=\"{'disabled': !nextArrowEnabled}\">\n                <i class=\"icon chevron-back-2 text-grey-3\"></i>\n            </span>\n        </div>\n\n        <i class=\"icon icon-dwm-notification icon-grey-1\"></i>\n        <h2 class=\"text-xxxl mb10 font-regular\" connectwebqa=\"alert_details_main_title\">{{notifications.title}}</h2>\n        <p class=\"text-l text-grey-4 mb50\" connectwebqa=\"alert_details_main_subtitle\">{{notifications.subTitle}}</p>\n\n        <div class=\"text-left text-l\">\n            <div ng-repeat=\"section in notification.sections\" connectwebqa=\"{{section.sectionId}}\">\n\n                <div ng-if=\"section.sectionId === 'overview'\" class=\"mb20 font-bold\">{{section.title}}</div>\n\n                <div class=\"list-dwm-notification\" ng-class=\"{'no-border top-section-dwm-notif': section.sectionId === 'overview'}\">\n\n                    <div ng-hide=\"section.sectionId === 'overview'\" class=\"mb30 font-bold\">{{section.title}}</div>\n\n                    <div ng-repeat=\"info in section.data\" ng-class=\"{'inline-block w49': section.sectionId === 'overview'}\" class=\"info\" connectwebqa=\"alert_section_info\">\n                        <div ng-if=\"section.sectionId === 'overview'\">\n                            <div class=\"text-l\">{{info.label}}</div>\n                            <div class=\"font-bold\">{{info.value}}</div>\n                        </div>\n                        <div ng-if=\"section.sectionId === 'exposed_information'\">\n\n                            <div class=\"section-info inline-block mb10 w40 v-top\">{{info.label}}</div>\n                            <div class=\"section-info inline-block w40 v-top\">{{info.value}}</div>\n\n                            <div ng-if=\"section.params && info.cta\" class=\"section-params inline-block w19 v-top\">\n                                <div class=\"param-{{param.action}} param\" ng-repeat=\"param in section.params\">\n                                    <i class=\"icon icon-param-{{param.action}} inline-block v-top w19\"\n                                        ng-if=\"param.action !== 'verifyEmail'\"></i>\n                                    <span ng-if=\"param.action === 'verifyEmail'\"\n                                        class=\"crs-pointer text-blue-1\"\n                                        ng-click=\"showPassword(param.actionValue)\">{{param.displayText}}</span>\n                                    <span ng-if=\"param.action !== 'verifyEmail'\"\n                                        class=\"inline-block v-top w80\">{{param.displayText}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-if=\"section.sectionId === 'next_steps'\" class=\"text-grey-3 dot-dwm-notification mb15\" ng-bind-html=\"info\"></div>\n                    </div>\n\n                    <div ng-repeat=\"text in section.text\" connectwebqa=\"alert_section_text\">\n                        <div class=\"text-grey-3\" ng-class=\"{'mb10': section.sectionId === 'breach_details'}\" ng-bind-html=\"text\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-hide=\"!showOtpScreen\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-emails\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.alert.password_combo.title\"><h2>\n        </div>\n\n        <div class=\"text-l text-grey-2 dwm-lightbox-content mt20\">\n            <div ng-show=\"!showOtpSuccess\">\n                <!-- Send Code Screen -->\n                <div ng-hide=\"addOtpScreen\">\n                    <p class=\"mt40 notification-verify-email\" translate=\"cw.dwm.alert.password_combo.send_code.title\"></p>\n                    <p class=\"mt20 font-regular\">{{currentNotificationEmailAddress}}</p>\n                    <button class=\"notification-btn btn btn-primary btn-medium mt20 mb20 w20\"\n                            ng-click=\"sendOtpOnEmail()\"\n                            ng-disabled=\"loading\" translate=\"cw.dwm.alert.password_combo.send_code.get_code\"></button>\n                    <div class=\"mb40\">\n                        <a class=\"text-blue-1 crs-pointer text-xs\" ng-click=\"showAddOtpScreen()\" translate=\"cw.dwm.alert.password_combo.send_code.have_a_code\"></a>\n                    </div>\n                </div>\n\n                <!-- Verify Code Screen -->\n                <div ng-hide=\"!addOtpScreen\">\n                    <p class=\"mt40\" translate=\"cw.dwm.alert.password_combo.verify_code.title\" translate-values=\"{email: currentNotificationEmailAddress}\"></p>\n                    <div class=\"w30 m-auto notification-input\">\n                        <input\n                            ng-model=\"otpCode.value\"\n                            maxlength=\"6\"\n                            autocomplete=\"off\"\n                            placeholder=\"XXXXXX\"\n                            type=\"text\"\n                            ng-keyup=\"updateOtpError()\"\n                            class=\"mt20 w30 code-input\"\n                            required />\n                            <p class=\"error-message text-center\"\n                            ng-show=\"otpError\"\n                            translate=\"cw.tfa.messages.invalid_code\"></p>\n                    </div>\n\n                    <button class=\"notification-btn btn btn-primary btn-medium mt20 mb20 w20\"\n                        ng-disabled=\"loading\"\n                        ng-click=\"verifyOtpOnEmail()\" translate=\"cw.dwm.alert.password_combo.verify_code.verify\"></button>\n\n                    <div class=\"mb40 text-xs verify-text\">\n                        <p>\n                            <span translate=\"cw.dwm.alert.password_combo.verify_code.note\"></span>\n                            <a class=\"crs-pointer text-blue-1\" ng-click=\"requestNewCode()\" translate=\"cw.dwm.alert.password_combo.verify_code.request_a_new_code\"></a>\n                        </p>\n                    </div>\n                </div>\n            </div>\n            <!-- Verify Code Screen Success -->\n            <div ng-show=\"showOtpSuccess\">\n                <div class=\"success-icon\"></div>\n                <p class=\"mt40\" translate=\"cw.dwm.alert.password_combo.success.title\"></p>\n                <p class=\"mt10 font-regular\">{{currentNotificationEmailAddress}}</p>\n                <a class=\"notification-btn crs-pointer btn btn-primary btn-medium w20 mt40 mb40\" ng-click=\"backToNotification()\" translate=\"cw.dwm.alert.password_combo.success.back\"></a>\n            </div>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/notifications/notifications.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "eN/O":
/***/ (function(module, exports) {

module.exports = "<div>\n    <ul class=\"profile-payments\">\n        <!-- List of user payments -->\n        <li class=\"payment\" ng-repeat=\"payment in PaymentCtrl.payments | orderBy : 'expired'\">\n            <!-- Product details , icon and name -->\n            <div class=\"product-data\">\n                <!-- Product icon -->\n                <div class=\"box-shot-holder\" ng-if=\"payment.appdata.attributes.resource.cwStoreBoxshot\">\n\n                    <img ng-src=\"{{payment.appdata.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n\n                </div>\n                <div class=\"icon-holder\" ng-if=\"!payment.appdata.attributes.resource.cwStoreBoxshot\">\n\n                    <img ng-if=\"payment.appdata.attributes.resource.wsLargeImageUrl\"\n                        ng-src=\"{{payment.appdata.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                    <img ng-if=\"payment.appdata.attributes.type === 'bundle' && !payment.appdata.attributes.resource.wsLargeImageUrl\"\n                        src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                    <img ng-if=\"payment.appdata.attributes.type !== 'bundle' && !payment.appdata.attributes.resource.wsLargeImageUrl\"\n                        src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n\n                </div>\n                <!-- Product name -->\n                <h2 class=\"inline-block text-xl\">{{payment.appdata.attributes.resource.oeName}}</h2>\n\n            </div>\n            <!-- Payment details, card type, last digits, expiration date -->\n            <div class=\"payment-data\">\n                <div class=\"payment-type\" ng-class=\"{'payment-card': payment.attributes.payment_type.indexOf('PayPal') === -1,'payment-paypal':payment.attributes.payment_type.indexOf('PayPal') > -1}\">\n                    <div ng-if=\"payment.expired\" class=\"payment-card-expired\"></div>\n                </div>\n                <div class=\"inline-block v-middle\">\n                    <div ng-if=\"payment.attributes.payment_type.indexOf('PayPal') > -1\" class=\"payment-type-label font-regular v-middle text-s text-grey-4\" translate=\"cw.payment.paypal\"></div>\n                    <div ng-if=\"payment.attributes.payment_type.indexOf('Voucher') > -1\" class=\"payment-type-label font-regular v-middle text-s text-grey-4\" translate=\"cw.payment.voucher\"></div>\n                    <div ng-if=\"payment.attributes.payment_type.indexOf('Wire Transfer') > -1\" class=\"payment-type-label font-regular v-middle text-s text-grey-4\" translate=\"cw.payment.wire_transfer\"></div>\n                    <div ng-if=\"payment.attributes.payment_type.indexOf('PayPal') === -1 &&\n                        payment.attributes.payment_type.indexOf('Voucher') === -1 &&\n                        payment.attributes.payment_type.indexOf('Wire Transfer') === -1\"\n                        class=\"payment-type-label font-regular v-middle text-s text-grey-4\" translate=\"cw.payment.card\"></div>\n                </div>\n                <div class=\"showBlock\">\n                    <!-- <div ng-if=\"payment.attributes.payment_type.indexOf('PayPal') > -1\" class=\"payment-lastdigits text-m text-grey-2\">{{payment.attributes.last_digits}}</div> -->\n                    <div ng-if=\"payment.attributes.payment_type.indexOf('PayPal') === -1 && payment.attributes.last_digits\" class=\"payment-lastdigits text-m text-grey-4\" ng-class=\"{'expired': payment.expired}\">●●●●  ●●●●  ●●●●  {{payment.attributes.last_digits}}</div>\n                    <div ng-if=\"payment.attributes.expiration_date\" class=\"payment-expiration text-s text-grey-4\" ng-class=\"{'expired': payment.expired}\" translate=\"cw.payment.expiration\" translate-values=\"{date: payment.expiration_date}\"></div>\n                </div>\n\n                <h5 ng-if=\"payment.expired\" class=\"payment-expired expired text-m\" translate=\"cw.payment.expired\"></h5>\n\n            </div>\n            <!-- Edit button-->\n            <button ng-if=\"PaymentCtrl.showChangePaymentButton(payment) && $root.hasUsCompliance\"\n                class=\"btn btn-medium btn-primary\"\n                ng-click=\"PaymentCtrl.editPayment(payment, $event)\" translate=\"cw.payment.edit\">\n            </button>\n        </li>\n        <!-- End of list -->\n    </ul>\n</div>"

/***/ }),

/***/ "eQXF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['$scope', 'Util', 'DeployRestService'];

var OnlineDeploymentController = function () {
    function OnlineDeploymentController($scope, Util, DeployRestService) {
        _classCallCheck(this, OnlineDeploymentController);

        this.Util = Util;
        this.$scope = $scope;
        this.DevicesRepository = _index.DevicesRepository;
        this.DeployRestService = DeployRestService;
        this.randomNumber = Math.floor(Math.random() * 1000 + 1);

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();
        } else {

            this._deploy();
        }
    }

    _createClass(OnlineDeploymentController, [{
        key: '_deploy',
        value: function _deploy() {
            var _this = this;

            this.deploying = true;

            var device = this.DevicesRepository.getById(this.$scope.inputData.deviceId);
            var deploymentPayload = {
                deviceId: device.id,
                userId: this.Util.deepFind(device, 'relationships.user.data.id'),
                appId: this.app.id
            };

            this.DeployRestService.deployOnDevice(deploymentPayload).then(function () {

                _this.deploying = false;
            }).then(null, function () {

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-' + _this.Util.deepFind(device, 'attributes.type')
                    }
                });
                _this.Util.closeModal();
            });
        }
    }, {
        key: 'close',
        value: function close() {

            this.Util.closeModal();
        }
    }]);

    return OnlineDeploymentController;
}();

var OnlineDeploymentDirective = function OnlineDeploymentDirective() {
    _classCallCheck(this, OnlineDeploymentDirective);

    this.template = __webpack_require__("ldPQ");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, Util, DeployRestService) {
        return new OnlineDeploymentController($scope, Util, DeployRestService);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'OnlineDeploymentCtrl';
};

_directiveDependencies.push(function () {
    return new OnlineDeploymentDirective();
});

angular.module('directives').directive('onlineDeployment', _directiveDependencies);

/***/ }),

/***/ "eVeQ":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ICfp"),
    stackClear = __webpack_require__("cb0B"),
    stackDelete = __webpack_require__("nPrn"),
    stackGet = __webpack_require__("vajS"),
    stackHas = __webpack_require__("zcic"),
    stackSet = __webpack_require__("vDBK");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "eWdr":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu"),
    root = __webpack_require__("VjBI");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "eZcD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint vars-on-top: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("YW9j");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', '$timeout', '$window', 'MyAccountCountriesService', 'UserRestService', 'Util', 'MyAccountStatesService', '$rootScope'];

/**
 * @ngdoc directive
 * @name directives.controller.ProfileDetailsController
 *
 * @description
 * edit form for user details controller
 */

var ProfileDetailsController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} $timeout
     * @param  {any} $window
     * @param  {any} MyAccountCountriesService
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} MyAccountStatesService
     */
    function ProfileDetailsController($scope, $state, $timeout, $window, MyAccountCountriesService, UserRestService, Util, MyAccountStatesService, $rootScope) {
        var _this = this;

        _classCallCheck(this, ProfileDetailsController);

        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.MeRepository = _index.MeRepository;
        this.UserRestService = UserRestService;
        this.MyAccountCountriesService = MyAccountCountriesService;
        this.MyAccountStatesService = MyAccountStatesService;
        this.Util = Util;
        this.user = _index.MeRepository.getMyUser();
        this.$scope.countries = MyAccountCountriesService.getCountries();
        this.$scope.states = MyAccountStatesService.getStates();
        this.$scope.userEmail = this.user.attributes.email;
        this.$scope.userFirstName = this.user.attributes.first_name;
        this.$scope.userLastName = this.user.attributes.last_name;
        this.$scope.billingAddress = this.user.attributes.address;
        this.$scope.city = this.user.attributes.city;
        this.$scope.zipcode = this.user.attributes.zip;
        this.$scope.userFirstNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.userLastNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.billingAddressRegExp = this.Util.getGenericInputValidationRegExp();
        this.$scope.cityRegExp = this.Util.getGenericInputValidationRegExp();
        this.$scope.userLanguage = {};
        this.$scope.userCountry = {};
        this.$scope.userState = {};
        this.$scope.languages = [];
        this.$scope.submitted = false;
        this.$scope.isValidNumber = true;
        this.$scope.phoneInputError = false;
        this.$scope.zipcodeRegexPattern = new RegExp('^([\xC0-\u017F a-z0-9]{0,})$', 'i');
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$rootScope = $rootScope;

        // init phone number on selectedDevice object
        this.$scope.selectedDevice = this.$scope.selectedDevice || { phoneNumber: this.user.attributes.phone };

        // default user details (ex: phone, city, zip etc.)
        this.$scope.userDetails = this.user.attributes;

        // facebook, google, or password
        var userLoginType = _RFC6.default.get(CWCONFIG.cookie.loginType);

        // allow user to change his email if he is logged in with email and password account
        this.$scope.canChangeEmail = !userLoginType || userLoginType === 'password';

        angular.forEach(CWCONFIG.languages, function (value, key) {

            _this.$scope.languages.push({ code: key, name: value });
        });

        this.$scope.userLanguage.selectedValue = this.$scope.languages.find(function (value) {
            return value.code === _this.user.attributes.language;
        });

        this.$scope.userCountry.selectedValue = this.$scope.countries.find(function (value) {
            return value.code === _this.user.attributes.country;
        });

        this.$scope.userState.selectedValue = this.$scope.states.find(function (value) {
            return value.code === _this.user.attributes.land;
        });

        // MeRepository Observable
        var meRepositoryObservable = _index.MeRepository.getObservable();
        var onNextMeRepository = function onNextMeRepository() {

            // update form inputs
            _this.updateForm();
        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(onNextMeRepository, function () {}, function () {});
    }

    /**
     * @ngdoc directive
     * @name directives.controller.ProfileDetailsController#getPhoneNumber
     * @methodOf directives.controller.ProfileDetailsController
     *
     * @description
     * get phone number
     */


    _createClass(ProfileDetailsController, [{
        key: 'getPhoneNumber',
        value: function getPhoneNumber() {

            var phoneNumber = this.user.attributes.phone || null;

            if (this.$scope.selectedDevice.country) {

                phoneNumber = '' + this.$scope.selectedDevice.country.dialCode + this.$scope.selectedDevice.phoneNumber;
            }

            return phoneNumber || null;
        }

        /**
         * @ngdoc directive
         * @name directives.controller.ProfileDetailsController#method
         * @methodOf directives.controller.ProfileDetailsController
         *
         * @description
         * change user first name, last name, country and - or language
         */

    }, {
        key: 'changeProfileDetails',
        value: function changeProfileDetails() {
            var _this2 = this;

            // set the submitted flag for input errors to be shown when user tries to submit
            this.$scope.submitted = true;

            // reset the value of the validtions happening on the server
            this.$scope.profileDetailsForm.userFirstName.$setValidity('serverValidation', true);
            this.$scope.profileDetailsForm.userLastName.$setValidity('serverValidation', true);
            this.$scope.profileDetailsForm.billingAddress.$setValidity('serverValidation', true);
            this.$scope.profileDetailsForm.city.$setValidity('serverValidation', true);
            this.$scope.profileDetailsForm.zipcode.$setValidity('serverValidation', true);

            // exit the function early if the form is $invalid
            if (this.$scope.profileDetailsForm.$invalid) {

                this.Util.triggerAnimation('.error', 'animated shake');
                return;
            }

            var countryCode = this.$scope.selectedDevice.country ? this.$scope.selectedDevice.country.code.substring(0, 2) : '';

            // delete number if the phone input is empty
            if (this.$scope.selectedDevice.phoneNumber === '') {

                this.$scope.isValidNumber = true;
            } else {

                // Check if the phone number is from international calling zone 1 and add to phoneNumber
                var isZoneOne = this.$scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
                var phoneNumberZoneOne = isZoneOne ? this.$scope.selectedDevice.country.dialCode.substring(3).concat(this.$scope.selectedDevice.phoneNumber) : '';

                this.$scope.isValidNumber = isZoneOne ? this.Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) : this.Util.isValidPhoneNumber(this.$scope.selectedDevice.phoneNumber, countryCode);
            }

            var userLanguageChanged = this.$scope.userLanguage.selectedValue.code !== this.user.attributes.language;

            // data to be send
            var payload = {
                data: {
                    id: this.user.id,
                    attributes: {
                        first_name: this.$scope.userFirstName ? this.$scope.userFirstName : null,
                        last_name: this.$scope.userLastName ? this.$scope.userLastName : null,
                        address: this.$scope.billingAddress ? this.$scope.billingAddress : null,
                        country: this.$scope.userCountry.selectedValue.code,
                        land: this.$scope.userState.selectedValue && this.$scope.userCountry.selectedValue.code === 'US' ? this.$scope.userState.selectedValue.code : null,
                        city: this.$scope.city ? this.$scope.city : null,
                        zip: this.$scope.zipcode ? this.$scope.zipcode : null,
                        language: this.$scope.userLanguage.selectedValue.code
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: this.user.relationships.partner.data.type,
                                id: this.user.relationships.partner.data.id
                            }
                        }
                    },
                    type: this.user.type
                }
            };

            // user has a phone number
            if (this.user.attributes.phone) {

                if (this.$scope.isValidNumber) {

                    this.$scope.phoneInputError = false;

                    // delete number if the phone input is empty
                    if (this.$scope.selectedDevice.phoneNumber === '') {

                        angular.extend(payload.data.attributes, { phone: '' });
                    } else {

                        // phone number must be part of the payload only if a phone number exists,
                        // else backend phone validation returns an error
                        angular.extend(payload.data.attributes, { phone: this.getPhoneNumber() });
                    }
                } else {

                    this.$scope.phoneInputError = true;
                    this.Util.triggerAnimation('.error', 'animated shake');
                    return;
                }
            }

            if (this.$scope.profileDetailsForm.$dirty) {

                // send the payload with the PUT update user method
                this.UserRestService.update(this.user.id, payload).then(function (response) {

                    _this2.$scope.submitted = false;
                    _this2.$scope.profileDetailsForm.$setPristine();

                    // update the user repository
                    _this2.MeRepository.update(response.data.data);

                    // update form with the latest user data from repository
                    _this2.updateForm();

                    _RFC2.default.send('ConnectWeb Edit Account Click');
                    _RFC4.default.success('cw.account.details.messages.success');

                    // update user info in local storage
                    _this2.Util.updateLastLoginObjectInLocalStorage(response.data.data);

                    // set locale for moment js in order to show the correct date format
                    if (_this2.user.attributes.language === 'en') {

                        var currentLocale = moment.locale();

                        if (_this2.user.attributes.country !== 'US' && currentLocale !== 'en-gb') {

                            moment.locale('en-gb');
                        } else if (_this2.user.attributes.country === 'US' && currentLocale !== 'en') {

                            moment.locale('en');
                        }
                    }

                    if (_this2.$rootScope.accountCountry !== _this2.user.attributes.country) {

                        _this2.$window.location.reload();
                    }

                    // refresh the page on language change
                    if (userLanguageChanged) {

                        _this2.$timeout(function () {

                            _this2.$window.location.pathname = _this2.$window.location.pathname.replace(CWCONFIG.language, response.data.data.attributes.language);
                        }, 100);

                        _RFC2.default.send('ConnectWeb ChangeLanguage Success', {
                            Language: response.data.data.attributes.language,
                            'Old Language': CWCONFIG.language
                        });
                    }
                }).then(null, function (error) {

                    var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

                    switch (errorCode) {

                        // if illegal characters have been used
                        // in the first name we give out a more specific error
                        case '21109':
                            _this2.$scope.profileDetailsForm.userFirstName.$setPristine();
                            _this2.$scope.profileDetailsForm.userFirstName.$setValidity('serverValidation', false);
                            break;

                        case '21110':
                            _this2.$scope.profileDetailsForm.userLastName.$setPristine();
                            _this2.$scope.profileDetailsForm.userLastName.$setValidity('serverValidation', false);
                            break;

                        case '21153':
                            _this2.$scope.profileDetailsForm.city.$setPristine();
                            _this2.$scope.profileDetailsForm.city.$setValidity('serverValidation', false);
                            break;

                        case '21154':
                            _this2.$scope.profileDetailsForm.billingAddress.$setPristine();
                            _this2.$scope.profileDetailsForm.billingAddress.$setValidity('serverValidation', false);
                            break;

                        case '21155':
                            _this2.$scope.profileDetailsForm.zipcode.$setPristine();
                            _this2.$scope.profileDetailsForm.zipcode.$setValidity('serverValidation', false);
                            break;

                        case '1003':
                            _this2.$scope.phoneInputError = true;
                            _this2.$scope.isValidNumber = false;
                            break;

                        default:
                            _RFC4.default.error('cw.account.details.messages.error');
                            break;

                    }
                    // without a timeout it doesn't find the classes added by ng-class
                    _this2.Util.triggerAnimation('.error', 'animated shake');
                });
            }
        }

        /**
         * @ngdoc directive
         * @name directives.controller.ProfileDetailsController#method
         * @methodOf directives.controller.ProfileDetailsController
         *
         * @description
         * update form with the user details from MeRepository
        */

    }, {
        key: 'updateForm',
        value: function updateForm() {
            var _this3 = this;

            this.user = this.MeRepository.getMyUser();

            this.$scope.userFirstName = this.user.attributes.first_name;
            this.$scope.userLastName = this.user.attributes.last_name;

            this.$scope.userLanguage.selectedValue = this.$scope.languages.find(function (value) {
                return value.code === _this3.user.attributes.language;
            });

            this.$scope.userCountry.selectedValue = this.$scope.countries.find(function (value) {
                return value.code === _this3.user.attributes.country;
            });

            this.$scope.userState.selectedValue = this.$scope.states.find(function (value) {
                return value.code === _this3.user.attributes.land;
            });
        }
    }]);

    return ProfileDetailsController;
}();

/**
     * @ngdoc directive
     * @name directives.ProfileDetailsDirective
     *
     * @description
     * edit form for user details directive
     */


var ProfileDetailsDirective = function ProfileDetailsDirective() {
    _classCallCheck(this, ProfileDetailsDirective);

    this.template = __webpack_require__("pW+S");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, $state, $timeout, $window, MyAccountCountriesService, UserRestService, Util, MyAccountStatesService, $rootScope) {
        return new ProfileDetailsController($scope, $state, $timeout, $window, MyAccountCountriesService, UserRestService, Util, MyAccountStatesService, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'ProfileDetailsCtrl';
};

_directiveDependencies.push(function () {
    return new ProfileDetailsDirective();
});

angular.module('directives').directive('profileDetails', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "ef7C":
/***/ (function(module, exports) {

module.exports = "<div>\n</div>"

/***/ }),

/***/ "enUf":
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard-tabs text-left news-tabs\"\n    ng-class=\"{ 'inactive' : isLoading }\">\n    <span class=\"text-l text-dark crs-pointer\"\n        ng-class=\"{'active': currentCategory === 'how-to'}\"\n        ng-if=\"availableCategories['how-to']\"\n        ui-sref=\"root.dashboard.news({tab: 'how-to', page: currentPages['how-to']})\"\n        translate=\"cw.news.category_name.how_to\"\n        connectwebqa=\"guides-news/how-to-tab\"></span>\n    <span class=\"text-l text-dark crs-pointer\"\n        ng-class=\"{'active': currentCategory === 'threats'}\"\n        ng-if=\"availableCategories['threats']\"\n        ui-sref=\"root.dashboard.news({tab: 'threats', page: currentPages['threats']})\"\n        translate=\"cw.news.category_name.threats\"\n        connectwebqa=\"guides-news/threats-tab\"></span>\n    <span class=\"text-l text-dark crs-pointer\"\n        ng-class=\"{'active': currentCategory === 'bookmarks'}\"\n        ui-sref=\"root.dashboard.news({tab: 'bookmarks', page: '1'})\"\n        translate=\"cw.news.category_name.bookmarks\"\n        connectwebqa=\"guides-news/bookmarks-tab\"></span>\n    <span class=\"text-l text-dark crs-pointer\"\n        translate=\"cw.news.category_name.threats_landscape\"\n        ng-click=\"openThreatsLandscape()\"\n        connectwebqa=\"guides-news/threats-landscape\"\n        ng-if=\"showThreatsTab\"></span>\n</div>\n"

/***/ }),

/***/ "erZH":
/***/ (function(module, exports) {

module.exports = "<div class=\"centerVert notification-usr\">\n    <i class=\"icon icon-3x icon-white icon-activity\"></i>\n</div>"

/***/ }),

/***/ "et4X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

angular.module('services').factory('dwmValidations', function () {

    var dwmValidations = {
        getValidationRules: function getValidationRules() {

            var rulesValidation = _index.dwmRepository.getAll('validation') || {};
            return rulesValidation;
        },
        emailValidator: function emailValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.emails.emailAddress.validation.rules[0].regex;
            var _rulesValidation$emai = rulesValidation.emails.emailAddress.validation,
                minLength = _rulesValidation$emai.minLength,
                maxLength = _rulesValidation$emai.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        bankAccountNumberValidator: function bankAccountNumberValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.bankAccounts.accountNumber.validation.rules[0].regex;
            var _rulesValidation$bank = rulesValidation.bankAccounts.accountNumber.validation,
                minLength = _rulesValidation$bank.minLength,
                maxLength = _rulesValidation$bank.maxLength;


            if (!input && minLength === 0) {

                return true;
            }

            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        bankNameValidator: function bankNameValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.bankAccounts.name.validation.rules[0].regex;
            var _rulesValidation$bank2 = rulesValidation.bankAccounts.name.validation,
                minLength = _rulesValidation$bank2.minLength,
                maxLength = _rulesValidation$bank2.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        ibanValidator: function ibanValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.bankAccounts.iban.validation.rules[0].regex;
            var _rulesValidation$bank3 = rulesValidation.bankAccounts.iban.validation,
                minLength = _rulesValidation$bank3.minLength,
                maxLength = _rulesValidation$bank3.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        creditCardNumberValidator: function creditCardNumberValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.creditDebitCards.cardNumber.validation.rules[0].regex;
            var _rulesValidation$cred = rulesValidation.creditDebitCards.cardNumber.validation,
                minLength = _rulesValidation$cred.minLength,
                maxLength = _rulesValidation$cred.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        creditCardTypeValidator: function creditCardTypeValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var minLength = rulesValidation.creditDebitCards.cardType.minLength;


            return input.length >= minLength;
        },
        addressStreet1Validator: function addressStreet1Validator(input) {

            if (!input) {

                return false;
            }

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.addresses.street1.validation.rules[0].regex;
            var _rulesValidation$addr = rulesValidation.addresses.street1.validation,
                minLength = _rulesValidation$addr.minLength,
                maxLength = _rulesValidation$addr.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        addressStreet2Validator: function addressStreet2Validator(input) {

            if (!input) {

                return true;
            }

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.addresses.street2.validation.rules[0].regex;
            var _rulesValidation$addr2 = rulesValidation.addresses.street2.validation,
                minLength = _rulesValidation$addr2.minLength,
                maxLength = _rulesValidation$addr2.maxLength;


            var validator = new RegExp(regex);

            if (input.length === 0) {

                return true;
            }

            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        cityValidator: function cityValidator(input) {

            if (!input) {

                return false;
            }

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.addresses.city.validation.rules[0].regex;
            var _rulesValidation$addr3 = rulesValidation.addresses.city.validation,
                minLength = _rulesValidation$addr3.minLength,
                maxLength = _rulesValidation$addr3.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        postalCodeValidator: function postalCodeValidator(input) {

            if (!input) {

                return false;
            }

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.addresses.postalCode.validation.rules[0].regex;
            var _rulesValidation$addr4 = rulesValidation.addresses.postalCode.validation,
                minLength = _rulesValidation$addr4.minLength,
                maxLength = _rulesValidation$addr4.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        stateCodeValidator: function stateCodeValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.addresses.stateCode.validation.rules[0].regex;
            var _rulesValidation$addr5 = rulesValidation.addresses.stateCode.validation,
                minLength = _rulesValidation$addr5.minLength,
                maxLength = _rulesValidation$addr5.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        driversLicenseNumberValidator: function driversLicenseNumberValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.driversLicense.driversLicenseNumber.validation.rules[0].regex;
            var _rulesValidation$driv = rulesValidation.driversLicense.driversLicenseNumber.validation,
                minLength = _rulesValidation$driv.minLength,
                maxLength = _rulesValidation$driv.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        phoneNumberValidator: function phoneNumberValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.phoneNumbers.phoneNumber.validation.rules[0].regex;
            var _rulesValidation$phon = rulesValidation.phoneNumbers.phoneNumber.validation,
                minLength = _rulesValidation$phon.minLength,
                maxLength = _rulesValidation$phon.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        phoneCountryCodeValidator: function phoneCountryCodeValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.phoneNumbers.countryCode.validation.rules[0].regex;
            var _rulesValidation$phon2 = rulesValidation.phoneNumbers.countryCode.validation,
                minLength = _rulesValidation$phon2.minLength,
                maxLength = _rulesValidation$phon2.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        mothersMaidenNameValidator: function mothersMaidenNameValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.mothersMaidenName.name.validation.rules[0].regex;
            var _rulesValidation$moth = rulesValidation.mothersMaidenName.name.validation,
                minLength = _rulesValidation$moth.minLength,
                maxLength = _rulesValidation$moth.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        insuranceNameValidator: function insuranceNameValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.insuranceCards.providerName.validation.rules[0].regex;
            var _rulesValidation$insu = rulesValidation.insuranceCards.providerName.validation,
                minLength = _rulesValidation$insu.minLength,
                maxLength = _rulesValidation$insu.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        insuranceNumberValidator: function insuranceNumberValidator(input) {

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.insuranceCards.policyNumber.validation.rules[0].regex;
            var _rulesValidation$insu2 = rulesValidation.insuranceCards.policyNumber.validation,
                minLength = _rulesValidation$insu2.minLength,
                maxLength = _rulesValidation$insu2.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        },
        gamerTagValidator: function gamerTagValidator(input) {

            if (!input) {

                return false;
            }

            var rulesValidation = dwmValidations.getValidationRules();
            var regex = rulesValidation.gamerTags.tag.validation.rules[0].regex;
            var _rulesValidation$game = rulesValidation.gamerTags.tag.validation,
                minLength = _rulesValidation$game.minLength,
                maxLength = _rulesValidation$game.maxLength;


            var validator = new RegExp(regex);
            return validator.test(input) && input.length >= minLength && input.length <= maxLength;
        }
    };

    return dwmValidations;
}); /* eslint-disable max-len */

/***/ }),

/***/ "eyBl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterImageUrlParse = exports.Default = exports.FilterDeviceName = undefined;

var _RFC = __webpack_require__("i3TI");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("0Xe/");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("E0M5");

var _RFC6 = _interopRequireDefault(_RFC5);

__webpack_require__("heYd");

__webpack_require__("0L7t");

__webpack_require__("R2es");

__webpack_require__("kaM4");

__webpack_require__("dV7H");

__webpack_require__("kxrs");

__webpack_require__("EFQi");

__webpack_require__("VHf/");

__webpack_require__("xy7b");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FilterDeviceName = _RFC2.default;
exports.Default = _RFC4.default;
exports.FilterImageUrlParse = _RFC6.default;

/***/ }),

/***/ "f+JQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint array-callback-return: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'UserRestService', '$window', 'Util', 'ChangePaymentUrlsRestService'];

/**
 * @ngdoc controller
 * @name directives.controller.PaymentController
 *
 * @description
 * Payment controller
 */

var PaymentController = function () {

    /**
     * @param  {any} $scope
     * @param  {any} UserRestService
     * @param  {any} $window
     */
    function PaymentController($scope, UserRestService, $window, Util, ChangePaymentUrlsRestService) {
        var _this = this;

        _classCallCheck(this, PaymentController);

        this.$scope = $scope;
        this.MeRepository = _index.MeRepository;
        this.UserRestService = UserRestService;
        this.$window = $window;
        this.user = _index.MeRepository.getMyUser();
        this.PaymentTypesRepository = _index.PaymentTypesRepository;
        this.Util = Util;
        this.payments = [];
        this.ChangePaymentUrlsRestService = ChangePaymentUrlsRestService;

        var paymentTypesObservable = this.PaymentTypesRepository.getObservable();

        paymentTypesObservable.subscribe(function (data) {

            _this.payments = data;
        }, function () {}, function () {});

        this.payments.map(function (payment) {

            payment.appdata = _index.AppIntegrationsRepository.getById(payment.relationships.app.data.id);

            // check if the expiration date has this format 2018-11-16T15:02:04+02:00
            if (!payment.attributes.expiration_date || payment.attributes.expiration_date.indexOf('-') === -1) {

                return;
            }

            // notify with 10days before
            var daysBeforeExpiration = CWCONFIG.features.paymentTypesDaysBeforeExpiration || 10;
            var now = moment();
            var formatedDate = payment.attributes.expiration_date.split('-');
            if (formatedDate.length > 1) {

                // create a new date at last day of month
                var expirationDate = moment(new Date(Number(formatedDate[0]), Number(formatedDate[1]), 0));
                if (expirationDate.diff(now, 'days') <= daysBeforeExpiration) {

                    payment.expired = true;
                }
                payment.expiration_date = expirationDate.format('MM/YYYY');
            }
        });
    }

    _createClass(PaymentController, [{
        key: 'editPayment',
        value: function editPayment(payment, $event) {
            var _this2 = this;

            angular.element($event.target).addClass('disabled');

            // Fallback link in case the response is null
            var paymentLink = this.Util.deepFind(payment, 'attributes.update_payment');

            var transactionId = this.Util.deepFind(payment, 'id');
            var navigator = this.Util.getDeviceNavigator();
            var browserName = this.$window.browserName.toLowerCase();

            this.ChangePaymentUrlsRestService.changePaymentUrlByTransactionId(transactionId).then(function (response) {

                if (response.data.data.length > 0) {

                    paymentLink = response.data.data[0].attributes.url;
                }
                angular.element($event.target).removeClass('disabled');

                if (navigator === 'ios' || browserName === 'safari') {

                    _this2.$window.location.href = paymentLink;
                } else {

                    _this2.$window.open(paymentLink, '_blank');
                }
            }).then(null, function () {

                angular.element($event.target).removeClass('disabled');

                if (navigator === 'ios' || browserName === 'safari') {

                    _this2.$window.location.href = paymentLink;
                } else {

                    _this2.$window.open(paymentLink, '_blank');
                }
            });

            _RFC2.default.send('ConnectWeb Edit Payment Click');
        }

        // if user requested to delete their card (last_digits will be empty)
        // then we dont show change payment button

    }, {
        key: 'showChangePaymentButton',
        value: function showChangePaymentButton(payment) {

            return !this.Util.isPaymentCardDeleted(payment);
        }
    }]);

    return PaymentController;
}();

/**
 * @ngdoc directive
 * @name directives.PaymentDirective
 *
 * @description
 * email Payment form directive
 */


var PaymentDirective = function PaymentDirective() {
    _classCallCheck(this, PaymentDirective);

    this.template = __webpack_require__("eN/O");
    this.restrict = 'EA';
    this.replace = false;
    this.scope = {};

    _controllerDependencies.push(function ($scope, UserRestService, $window, Util, ChangePaymentUrlsRestService) {
        return new PaymentController($scope, UserRestService, $window, Util, ChangePaymentUrlsRestService);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'PaymentCtrl';
};

_directiveDependencies.push(function () {
    return new PaymentDirective();
});

angular.module('directives').directive('payment', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "fDpe":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content crop-modal change-lang\" connectqa-modal=\"change-language\">\n    <div class=\"text-xxxl text-center mb50 font-regular\" translate=\"cw.change.lang\"></div>\n    <div class=\"lang-selector\">\n        <div class=\"text-l mb20 fl-left w33 p-relative text-left\"\n            ng-class=\"currentLanguage.indexOf(language.code) === 1 ? 'font-regular' : 'text-grey-3'\"\n            ng-repeat=\"language in languages\">\n            <span class=\"p-absolute\" ng-class=\"{'icon icon-checked2':currentLanguage.indexOf(language.code) === 1 }\"></span>\n            <a class=\"text-left crs-pointer\" ng-click=\"changeLanguage(language.code)\" connectqa-changelang=\"{{language.code}}\">{{language.name}}</a>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/language-switcher/language-switcher.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "fDqN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
     * @ngdoc service
     * @name services.Launcher
     *
     * @description
     * Send commands to the launcher.
     */
angular.module('services').service('Launcher', ['$window', function ($window) {

    var Launcher = {
        /**
             * Activates a service.
             * @param {string} service The service to activate.
             */
        activateService: function activateService(service) {

            this.execute('aoe://requestServiceDeployment?service=' + service);
            if (service !== 'antitheft') {

                this.execute('aoe://openMiniGui');
            }
        },


        /**
             * Resizes the modal shown by the launcher.
             * @param {integer} width The width.
             * @param {integer} height The height.
             */
        resizeModal: function resizeModal(width, height) {

            this.execute('aoe://resize?width=' + width + '&height=' + height);
        },


        /**
             * Minimizes the modal shown by the launcher.
             */
        minimizeModal: function minimizeModal() {

            this.execute('aoe://minimize');
        },


        /**
             * Closes the modal shown by the launcher.
             */
        closeModal: function closeModal() {

            this.execute('aoe://close');
        },


        /**
             * Moves the modal shown by the launcher.
             */
        moveModal: function moveModal() {

            this.execute('aoe://Move');
        },


        /**
             * Opens the dashboard
             */
        openDashboard: function openDashboard(service) {

            this.execute('aoe://openDashboardUrl?section=register&service=' + service);
        },


        /**
             * Executes a command with $window.external.Execute
             * @param {string} command The command to be executed.
             */
        execute: function execute(command) {

            if (!$window.external) {

                return;
            }
            try {

                $window.external.Execute(command);
            } catch (e) {

                _loggers2.default.error({
                    type: 'ERROR',
                    cmd: 'window.external.Execute',
                    data: e.message,
                    i: -1
                });
            }
        }
    };

    return Launcher;
}]);

/***/ }),

/***/ "fFqN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _events = [];
var _init = {};
var observableEvents = new Rx.BehaviorSubject(_events);

/**
 * @ngdoc service
 * @name repositories.EventsRepository
 *
 * @description
 * This class is used to get events objects.
 */
var EventsRepository = {

    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getAll
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all events from repository.
     *
     * @returns {Array} events all events from repository
     */
    getAll: function getAll() {

        return _events;
    },


    /**
     * @ngdoc function
     * @name repositories.EventsRepository#add
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to add a new event to repository.
     *
     * @param {object} event An event object.
     */
    add: function add(event) {

        var indexOfEvent = _events.findIndex(function (_event) {
            return String(_event.id) === String(event.id);
        });

        if (indexOfEvent === -1) {

            _events.unshift(event);
            observableEvents.onNext(_events);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.EventsRepository#replace
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored events with provided data.
     *
     * @param {Array} data An array with new events.
     */
    replace: function replace(data, deviceId) {

        _events = data;
        _init = _defineProperty({}, deviceId, true);
        observableEvents.onNext(_events);
    },


    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getObservable
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for events repository.
     * @returns {Object} an observable object for events repository.
     */
    getObservable: function getObservable() {

        return observableEvents;
    },


    /**
     * @ngdoc function
     * @name repositories.EventsRepository#getInitState
     * @methodOf repositories.EventsRepository
     * @function
     *
     * @description
     * This function can be used to get the state of the events repository
     * in order to make the call to the rest service only once
     * @returns {Object} an observable object for events repository.
     */
    getInitState: function getInitState(deviceId) {

        return _init[deviceId];
    }
};

exports.default = EventsRepository;

/***/ }),

/***/ "fIlE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint consistent-return: 0 */
/* eslint no-unneeded-ternary: 0 */
var jwtDecode = __webpack_require__("wByq");

var Util = {
    /**
     * @ngdoc function
     * @name services.Util#deepFind
     * @methodOf services.Util
     * @function
     *
     * @description
     * Get nested object value from path without throwing error.
     *
     * @param {Object} obj obj.
     * @param {string} path path.
     */
    deepFind: function deepFind(obj, path) {

        var current = void 0;
        var i = void 0;
        if (!obj) {

            return;
        }

        var paths = path.split('.');
        current = obj;

        for (i = 0; i < paths.length; i += 1) {

            if (current[paths[i]] === undefined || current[paths[i]] === null) {

                return;
            }

            current = current[paths[i]];
        }

        return current;
    },


    /**
     * Checks if a user is anonymous.
     * @return boolean True if the JWT attribute anon is true
     */
    isAnonymous: function isAnonymous() {

        var token = _RFC2.default.get(CWCONFIG.cookie.token);

        if (token) {

            try {

                var decodedToken = jwtDecode(token);
                return decodedToken.anon === true;
            } catch (err) {

                _loggers2.default.error(err);
                return false;
            }
        }
        return false;
    },

    // this is to check if the appId is one of the app that we no longer promote upsell in dashboard
    isNonrenewableApp: function isNonrenewableApp(appId) {
        var _CWCONFIG = CWCONFIG,
            nonrenewableApps = _CWCONFIG.nonrenewableApps;

        return !!nonrenewableApps.find(function (id) {
            return id === appId;
        });
    }
};

exports.default = Util;

/***/ }),

/***/ "fOfF":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content\">\n\n\t<div class=\"unlock-device-screen\"></div>\n\n\t<h1 class=\"text-xxl mb20\" translate=\"cw.my_devices.unlock_device.button\"></h1>\n\n\t<p class=\"text-l text-grey-4 mb30\" translate=\"cw.unlock_device.confirmation\" translate-values=\"{device: (device | deviceName), brandname : brandName}\"></p>\n\n\t<button class=\"btn btn-secondary btn-medium inline-block mlr10\" ng-click=\"close()\" translate=\"cw.general.ui.decline\"></button>\n\n\t<button class=\"btn btn-primary btn-medium inline-block\" ng-click=\"unlockDevice()\" translate=\"cw.general.ui.confirm\"></button>\n</div>\n";
var path = 'scripts/controllers/modals/device/unlock-device/unlock-device.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "ffBx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', 'Util'];

var ConfirmLogin = function ConfirmLogin($scope, Util) {
    _classCallCheck(this, ConfirmLogin);

    _RFC2.default.broadcast('modal.closeBtn:hide');

    $scope.brandName = CWCONFIG.partnerConfig.name;
    $scope.confirm = function () {

        _RFC4.default.send('ConnectWeb Login Confirmation Modal Click', {
            'Button Label': 'Confirm'
        });
        _RFC2.default.broadcast('confirm-login:true');
        Util.closeModal();
    };
    $scope.cancel = function () {

        _RFC4.default.send('ConnectWeb Login Confirmation Modal Click', {
            'Button Label': 'Cancel'
        });
        Util.closeModal();
    };
};

_serviceDependencies.push(ConfirmLogin);

angular.module('controllers').controller('ConfirmLogin', _serviceDependencies);

/***/ }),

/***/ "fk3e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['AppInstanceRestService', 'DeviceRestService', '$q', 'UserRestService'];

/**
 * @ngdoc service
 * @name rest.services.DeployRestService
 *
 * @description
 * This class contains methods used to deploy instances on devices
 * using http requests.
*/

var DeployRestService = function () {

    /**
     * @param  {any} AppInstanceRestService
     */
    function DeployRestService(AppInstanceRestService, DeviceRestService, $q, UserRestService) {
        _classCallCheck(this, DeployRestService);

        this.AppInstanceRestService = AppInstanceRestService;
        this.DeviceRestService = DeviceRestService;
        this.UserRestService = UserRestService;
        this.UsersRepository = _index.UsersRepository;
        this.DevicesRepository = _index.DevicesRepository;
        this.AppInstancesRepository = _index.AppInstancesRepository;
        this.$q = $q;
    }

    _createClass(DeployRestService, [{
        key: 'deployOnNewDevice',
        value: function deployOnNewDevice(data) {
            var _this = this;

            var deployDeferred = this.$q.defer();
            var devicePayload = {
                data: {
                    attributes: {
                        state: 'pending',
                        os: data.os,
                        type: ['android', 'ios'].indexOf(data.os.toLowerCase()) > -1 ? 'phone' : 'pc',
                        os_type: data.os_type
                    },
                    relationships: {
                        user: {
                            data: {
                                id: data.userId,
                                type: 'users'
                            }
                        }
                    }
                }
            };

            this.DeviceRestService.create(devicePayload).then(function (device) {

                _this.DevicesRepository.add(device.data.data);

                _this.deployOnDevice({
                    userId: data.userId,
                    appId: data.appId,
                    deviceId: device.data.data.id,
                    licenseId: data.licenseId,
                    os_type: data.os_type,
                    meta: data.meta || {}
                }).then(function (appInstance) {

                    deployDeferred.resolve(appInstance);
                }).then(null, function (err) {

                    deployDeferred.reject(err);
                });
            }).then(null, function (err) {

                deployDeferred.reject(err);
            });

            return deployDeferred.promise;
        }
    }, {
        key: 'deployOnDevice',
        value: function deployOnDevice(data) {
            var _this2 = this;

            var relationshipsObj = {
                device: {
                    data: {
                        type: 'devices',
                        id: data.deviceId
                    }
                },
                user: {
                    data: {
                        type: 'users',
                        id: data.userId
                    }
                },
                app: {
                    data: {
                        type: 'apps',
                        id: data.appId
                    }
                }
            };

            if (data.licenseId) {

                relationshipsObj.license = {
                    data: {
                        type: 'license',
                        id: data.licenseId
                    }
                };
            }

            var deploymentPayload = {
                data: {
                    relationships: relationshipsObj,
                    attributes: {
                        download_source: 'wd',
                        state: 'pending'
                    },
                    type: 'app-instances'
                },
                meta: data.meta || {}
            };

            return this.AppInstanceRestService.create(deploymentPayload).then(function (response) {

                if (angular.isArray(response.data.data)) {

                    response.data.data.forEach(function (instance) {

                        _this2.AppInstancesRepository.add(instance);
                    });
                } else {

                    _this2.AppInstancesRepository.add(response.data.data);
                }

                return response.data;
            });
        }
    }]);

    return DeployRestService;
}();

exports.default = DeployRestService;


_serviceDependencies.push(DeployRestService);

angular.module('rest.services').service('DeployRestService', _serviceDependencies);

/***/ }),

/***/ "frJZ":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("VrlS");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "fv8o":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content crop-modal\">\n\n\t<h1 class=\"text-xxl mb10\" translate=\"cw.my_account.security.change_email_confirmation_title\"></h1>\n\t<h2 class=\"text-m text-grey-2 mb20 w90 m-auto\"\n\t\ttranslate=\"cw.my_account.security.change_email_confirmation_desc\"\n\t\ttranslate-values=\"{\tnewEmail: $root.changeEmail.newEmail,\n\t\t\t\t\t\t   \tcurrentEmail: $root.changeEmail.currentEmail,\n\t\t\t\t\t\t\tnumber: '15' }\"></h2>\n\n\t<form name=\"confirmCodeForm\" role=\"form\" novalidate ng-submit=\"onSubmit()\">\n\n\t\t<div class=\"text-left m-auto w60 mb30\">\n\n\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.tfa.code.title\"></div>\n\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<input type=\"text\"\n\t\t\t\t\tng-model=\"code\"\n\t\t\t\t\tname=\"code\"\n\t\t\t\t\tmaxlength=\"5\"\n\t\t\t\t\tng-minlength=\"5\"\n\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\tplaceholder=\"XXXXX\"\n\t\t\t\t\tclass=\"code-input\"\n\t\t\t\t\tng-class=\"{ 'error':(confirmCodeForm.code.$invalid ||\n\t\t\t\t\t\t\t\t\t\tconfirmCodeForm.code.$error.serverValidation) && submitted }\"\n\t\t\t\t\tid=\"code\"\n\t\t\t\t\trequired />\n\n\t\t\t\t<label ng-hide=\"confirmCodeForm.code.$viewValue.length > 0\" class=\"fallback-input\" for=\"code\">XXXXX</label>\n\n\t\t\t\t<p class=\"error-message\"\n\t\t\t\t   ng-show=\"(confirmCodeForm.code.$invalid || confirmCodeForm.code.$error.serverValidation) && submitted\"\n\t\t\t\t   translate=\"cw.tfa.messages.invalid_code\"></p>\n\n\t\t\t\t<p class=\"error-message\"\n\t\t\t\t   ng-show=\"expiredCode && submitted\"\n\t\t\t\t   translate=\"cw.my_account.security.error.code_expired\"></p>\n\n\t\t\t\t<p class=\"error-message\"\n\t\t\t\t   translate=\"cw.auth.tfa.error.retries_exceeded\"\n\t\t\t\t   ng-show=\"requestsExceeded && submitted\"></p>\n\t\t\t</div>\n\n\t\t\t<a class=\"text-m text-blue-2 crs-pointer underline-hover\" ng-click=\"resendEmail()\" translate=\"cw.auth.tfa.resend\"></a>\n\t\t</div>\n\n\t\t<button class=\"btn btn-large btn-half-width btn-secondary mlr5\"\n\t\t   translate=\"cw.form.profile.cancel\"\n\t\t   ng-click=\"closeModal()\"></button>\n\n\t\t<button class=\"btn btn-large btn-half-width btn-primary mlr5 spin-loader\"\n\t\t\t\tng-disabled=\"loading\"\n\t\t\t\ttranslate=\"cw.general.ui.confirm\"></button>\n\t</form>\n\t<div class=\"form-group mb40 auth-nomargin\">\n\t\t<div vc-recaptcha\n\t\t\tclass=\"captcha2\"\n\t\t\tkey=\"Recaptcha.captchaKey\"\n\t\t\ton-create=\"Recaptcha.setWidgetId(widgetId)\"\n\t\t\ton-success=\"setCaptchaResponse(response)\"\n\t\t\tsize=\"invisible\">\n\t\t</div>\n\t</div>\n</div>\n";
var path = 'scripts/controllers/modals/my-account/change-email/change-email-modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "g5RI":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "gE/G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _licenses = [];
var observableLicenses = new Rx.BehaviorSubject(_licenses);

/**
     * @ngdoc service
     * @name repositories.LicensesRepository
     *
     * @description
     * This class is used to save/add license objects.
     */
var LicensesRepository = {

    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#replace
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored licenses with provided data.
         *
         * @param {Array} data An array with new licenses.
         */
    replace: function replace(data) {

        _licenses = this.removeExpired(data);
        observableLicenses.onNext(_licenses);
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#removeExpired
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to remove the expired licenses.
         *
         * @param {Array} data An array with all licenses.
         */
    removeExpired: function removeExpired(data) {

        return data.filter(function (license) {
            return !license.attributes.expired;
        });
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#add
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to add a new license to repository.
         *
         * @param {object} license A license object.
         */
    add: function add(license) {

        var indexOfLicense = _licenses.findIndex(function (_license) {
            return String(_license.id) === String(license.id);
        });

        if (indexOfLicense === -1) {

            _licenses.push(license);
            observableLicenses.onNext(_licenses);
        }
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#update
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to update a license from repository.
         *
         * @param {object} license a license object with new values.
         */
    update: function update(license) {

        var indexOfLicense = _licenses.findIndex(function (_license) {
            return String(_license.id) === String(license.id);
        });

        if (indexOfLicense >= 0) {

            _licenses[indexOfLicense] = license;
            observableLicenses.onNext(_licenses);
        }
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#getAll
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to retrieves all licenses from repository.
         *
         * @returns {Array} licenses all licenses from repository
         */
    getAll: function getAll() {

        return _licenses;
    },


    /**
         * @ngdoc function
         * @name rest.services.LicensesRepository#getLicensesByOs
         * @methodOf rest.services.LicensesRepository
         * @function
         *
         * @description
         * Returns the licenses for an os.
         *
         * @param {string} os
         *
         * @returns {Array}
         */
    getLicensesByOs: function getLicensesByOs(os) {

        var licensesByOs = [];

        _licenses.forEach(function (license) {

            var appId = _RFCUtil2.default.deepFind(license, 'relationships.app.data.id');
            var app = _index.AppIntegrationsRepository.getById(appId);
            var oses = _RFCUtil2.default.deepFind(app, 'attributes.custom.manifest.os');

            if (oses && _.contains(oses, os)) {

                return licensesByOs.push(license);
            }

            return false;
        });

        return licensesByOs;
    },


    /**
         * @ngdoc function
         * @name rest.services.LicensesRepository#getLicenseBy
         * @methodOf rest.services.LicensesRepository
         * @function
         *
         * @description
         * Returns the license object for an activation code
         *
         * @param {string} activationCode
         *
         * @returns {Object}
         */
    getLicenseBy: function getLicenseBy(activationCode) {

        return _licenses.find(function (license) {
            return _RFCUtil2.default.deepFind(license, 'relationships.activation-code.data.id') === activationCode;
        });
    },


    /**
         * @ngdoc function
         * @name rest.services.LicensesRepository#getLicenseByAppId
         * @methodOf rest.services.LicensesRepository
         * @function
         *
         * @description
         * Returns the license object for a specific app id
         *
         * @param {string} appId
         *
         * @returns {Object}
         */
    getLicenseByAppId: function getLicenseByAppId(appId) {

        return _licenses.find(function (license) {
            return _RFCUtil2.default.deepFind(license, 'relationships.app.data.id') === appId;
        });
    },


    /**
     * @ngdoc function
     * @name rest.services.LicensesRepository#getLicenseById
     * @methodOf rest.services.LicensesRepository
     * @function
     *
     * @description
     * Returns the license object for a specific license id
     *
     * @param {string} licenseId
     *
     * @returns {Object}
     */
    getLicenseById: function getLicenseById(licenseId) {

        return _licenses.find(function (license) {
            return license.id === licenseId;
        });
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#getObservable
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for licenses repository.
         * @returns {Object} an observable object for licenses repository.
         */
    getObservable: function getObservable() {

        return observableLicenses;
    },


    /**
         * @ngdoc function
         * @name repositories.LicensesRepository#deleteLicenseById
         * @methodOf repositories.LicensesRepository
         * @function
         *
         * @description
         * This function can be used to delete a specific license from repository based on id.
         * @returns {Object}
         */
    deleteLicenseById: function deleteLicenseById(licenseId) {

        _licenses = _licenses.filter(function (license) {
            return license.id !== licenseId;
        });
        observableLicenses.onNext(_licenses);
    }
};

exports.default = LicensesRepository;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "gFvG":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var $jscomp=$jscomp||{};$jscomp.scope={};$jscomp.createTemplateTagFirstArg=function(a){return a.raw=a};$jscomp.createTemplateTagFirstArgWithRaw=function(a,b){a.raw=b;return a};$jscomp.arrayIteratorImpl=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}};$jscomp.arrayIterator=function(a){return{next:$jscomp.arrayIteratorImpl(a)}};$jscomp.makeIterator=function(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):$jscomp.arrayIterator(a)};
$jscomp.arrayFromIterator=function(a){for(var b,c=[];!(b=a.next()).done;)c.push(b.value);return c};$jscomp.arrayFromIterable=function(a){return a instanceof Array?a:$jscomp.arrayFromIterator($jscomp.makeIterator(a))};$jscomp.checkStringArgs=function(a,b,c){if(null==a)throw new TypeError("The 'this' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""};
$jscomp.ASSUME_ES5=!1;$jscomp.ASSUME_NO_NATIVE_MAP=!1;$jscomp.ASSUME_NO_NATIVE_SET=!1;$jscomp.SIMPLE_FROUND_POLYFILL=!1;$jscomp.ISOLATE_POLYFILLS=!1;$jscomp.FORCE_POLYFILL_PROMISE=!1;$jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;$jscomp.defineProperty=$jscomp.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
$jscomp.getGlobal=function(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");};$jscomp.global=$jscomp.getGlobal(this);$jscomp.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");$jscomp.TRUST_ES6_POLYFILLS=!$jscomp.ISOLATE_POLYFILLS||$jscomp.IS_SYMBOL_NATIVE;$jscomp.polyfills={};
$jscomp.propertyToPolyfillSymbol={};$jscomp.POLYFILL_PREFIX="$jscp$";var $jscomp$lookupPolyfilledValue=function(a,b){var c=$jscomp.propertyToPolyfillSymbol[b];if(null==c)return a[b];c=a[c];return void 0!==c?c:a[b]};$jscomp.polyfill=function(a,b,c,d){b&&($jscomp.ISOLATE_POLYFILLS?$jscomp.polyfillIsolated(a,b,c,d):$jscomp.polyfillUnisolated(a,b,c,d))};
$jscomp.polyfillUnisolated=function(a,b,c,d){c=$jscomp.global;a=a.split(".");for(d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))return;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&$jscomp.defineProperty(c,a,{configurable:!0,writable:!0,value:b})};
$jscomp.polyfillIsolated=function(a,b,c,d){var e=a.split(".");a=1===e.length;d=e[0];d=!a&&d in $jscomp.polyfills?$jscomp.polyfills:$jscomp.global;for(var f=0;f<e.length-1;f++){var g=e[f];if(!(g in d))return;d=d[g]}e=e[e.length-1];c=$jscomp.IS_SYMBOL_NATIVE&&"es6"===c?d[e]:null;b=b(c);null!=b&&(a?$jscomp.defineProperty($jscomp.polyfills,e,{configurable:!0,writable:!0,value:b}):b!==c&&($jscomp.propertyToPolyfillSymbol[e]=$jscomp.IS_SYMBOL_NATIVE?$jscomp.global.Symbol(e):$jscomp.POLYFILL_PREFIX+e,e=
$jscomp.propertyToPolyfillSymbol[e],$jscomp.defineProperty(d,e,{configurable:!0,writable:!0,value:b})))};$jscomp.polyfill("String.prototype.endsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"endsWith");b+="";void 0===c&&(c=d.length);c=Math.max(0,Math.min(c|0,d.length));for(var e=b.length;0<e&&0<c;)if(d[--c]!=b[--e])return!1;return 0>=e}},"es6","es3");
$jscomp.findInternal=function(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{i:e,v:f}}return{i:-1,v:void 0}};$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(b,c){return $jscomp.findInternal(this,b,c).v}},"es6","es3");
$jscomp.polyfill("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=$jscomp.checkStringArgs(this,b,"startsWith");b+="";var e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var g=0;g<f&&c<e;)if(d[c++]!=b[g++])return!1;return g>=f}},"es6","es3");
$jscomp.polyfill("String.prototype.repeat",function(a){return a?a:function(b){var c=$jscomp.checkStringArgs(this,null,"repeat");if(0>b||1342177279<b)throw new RangeError("Invalid count value");b|=0;for(var d="";b;)if(b&1&&(d+=c),b>>>=1)c+=c;return d}},"es6","es3");$jscomp.initSymbol=function(){};
$jscomp.polyfill("Symbol",function(a){if(a)return a;var b=function(e,f){this.$jscomp$symbol$id_=e;$jscomp.defineProperty(this,"description",{configurable:!0,writable:!0,value:f})};b.prototype.toString=function(){return this.$jscomp$symbol$id_};var c=0,d=function(e){if(this instanceof d)throw new TypeError("Symbol is not a constructor");return new b("jscomp_symbol_"+(e||"")+"_"+c++,e)};return d},"es6","es3");
$jscomp.polyfill("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=$jscomp.global[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&$jscomp.defineProperty(d.prototype,a,{configurable:!0,writable:!0,value:function(){return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this))}})}return a},"es6",
"es3");$jscomp.iteratorPrototype=function(a){a={next:a};a[Symbol.iterator]=function(){return this};return a};$jscomp.iteratorFromArray=function(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e};$jscomp.polyfill("Array.prototype.keys",function(a){return a?a:function(){return $jscomp.iteratorFromArray(this,function(b){return b})}},"es6","es3");
$jscomp.polyfill("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}},"es6","es3");$jscomp.polyfill("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}},"es7","es3");
$jscomp.polyfill("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==$jscomp.checkStringArgs(this,b,"includes").indexOf(b,c||0)}},"es6","es3");var COMPILED=!0,goog=goog||{};goog.global=this||self;
goog.exportPath_=function(a,b,c,d){a=a.split(".");d=d||goog.global;a[0]in d||"undefined"==typeof d.execScript||d.execScript("var "+a[0]);for(var e;a.length&&(e=a.shift());)if(a.length||void 0===b)d=d[e]&&d[e]!==Object.prototype[e]?d[e]:d[e]={};else if(!c&&goog.isObject(b)&&goog.isObject(d[e]))for(var f in b)b.hasOwnProperty(f)&&(d[e][f]=b[f]);else d[e]=b};
goog.define=function(a,b){if(!COMPILED){var c=goog.global.CLOSURE_UNCOMPILED_DEFINES,d=goog.global.CLOSURE_DEFINES;c&&void 0===c.nodeType&&Object.prototype.hasOwnProperty.call(c,a)?b=c[a]:d&&void 0===d.nodeType&&Object.prototype.hasOwnProperty.call(d,a)&&(b=d[a])}return b};goog.FEATURESET_YEAR=2012;goog.DEBUG=!0;goog.LOCALE="en";goog.TRUSTED_SITE=!0;goog.DISALLOW_TEST_ONLY_CODE=COMPILED&&!goog.DEBUG;goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING=!1;
goog.provide=function(a){if(goog.isInModuleLoader_())throw Error("goog.provide cannot be used within a module.");if(!COMPILED&&goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');goog.constructNamespace_(a)};goog.constructNamespace_=function(a,b,c){if(!COMPILED){delete goog.implicitNamespaces_[a];for(var d=a;(d=d.substring(0,d.lastIndexOf(".")))&&!goog.getObjectByName(d);)goog.implicitNamespaces_[d]=!0}goog.exportPath_(a,b,c)};
goog.getScriptNonce=function(a){if(a&&a!=goog.global)return goog.getScriptNonce_(a.document);null===goog.cspNonce_&&(goog.cspNonce_=goog.getScriptNonce_(goog.global.document));return goog.cspNonce_};goog.NONCE_PATTERN_=/^[\w+/_-]+[=]{0,2}$/;goog.cspNonce_=null;goog.getScriptNonce_=function(a){return(a=a.querySelector&&a.querySelector("script[nonce]"))&&(a=a.nonce||a.getAttribute("nonce"))&&goog.NONCE_PATTERN_.test(a)?a:""};goog.VALID_MODULE_RE_=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module=function(a){if("string"!==typeof a||!a||-1==a.search(goog.VALID_MODULE_RE_))throw Error("Invalid module identifier");if(!goog.isInGoogModuleLoader_())throw Error("Module "+a+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
if(goog.moduleLoaderState_.moduleName)throw Error("goog.module may only be called once per module.");goog.moduleLoaderState_.moduleName=a;if(!COMPILED){if(goog.isProvided_(a))throw Error('Namespace "'+a+'" already declared.');delete goog.implicitNamespaces_[a]}};goog.module.get=function(a){return goog.module.getInternal_(a)};
goog.module.getInternal_=function(a){if(!COMPILED){if(a in goog.loadedModules_)return goog.loadedModules_[a].exports;if(!goog.implicitNamespaces_[a])return a=goog.getObjectByName(a),null!=a?a:null}return null};goog.ModuleType={ES6:"es6",GOOG:"goog"};goog.moduleLoaderState_=null;goog.isInModuleLoader_=function(){return goog.isInGoogModuleLoader_()||goog.isInEs6ModuleLoader_()};goog.isInGoogModuleLoader_=function(){return!!goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.GOOG};
goog.isInEs6ModuleLoader_=function(){if(goog.moduleLoaderState_&&goog.moduleLoaderState_.type==goog.ModuleType.ES6)return!0;var a=goog.global.$jscomp;return a?"function"!=typeof a.getCurrentModulePath?!1:!!a.getCurrentModulePath():!1};
goog.module.declareLegacyNamespace=function(){if(!COMPILED&&!goog.isInGoogModuleLoader_())throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");if(!COMPILED&&!goog.moduleLoaderState_.moduleName)throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");goog.moduleLoaderState_.declareLegacyNamespace=!0};
goog.declareModuleId=function(a){if(!COMPILED){if(!goog.isInEs6ModuleLoader_())throw Error("goog.declareModuleId may only be called from within an ES6 module");if(goog.moduleLoaderState_&&goog.moduleLoaderState_.moduleName)throw Error("goog.declareModuleId may only be called once per module.");if(a in goog.loadedModules_)throw Error('Module with namespace "'+a+'" already exists.');}if(goog.moduleLoaderState_)goog.moduleLoaderState_.moduleName=a;else{var b=goog.global.$jscomp;if(!b||"function"!=typeof b.getCurrentModulePath)throw Error('Module with namespace "'+
a+'" has been loaded incorrectly.');b=b.require(b.getCurrentModulePath());goog.loadedModules_[a]={exports:b,type:goog.ModuleType.ES6,moduleId:a}}};goog.setTestOnly=function(a){if(goog.DISALLOW_TEST_ONLY_CODE)throw a=a||"",Error("Importing test-only code into non-debug environment"+(a?": "+a:"."));};goog.forwardDeclare=function(a){};COMPILED||(goog.isProvided_=function(a){return a in goog.loadedModules_||!goog.implicitNamespaces_[a]&&null!=goog.getObjectByName(a)},goog.implicitNamespaces_={"goog.module":!0});
goog.getObjectByName=function(a,b){a=a.split(".");b=b||goog.global;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b};goog.addDependency=function(a,b,c,d){!COMPILED&&goog.DEPENDENCIES_ENABLED&&goog.debugLoader_.addDependency(a,b,c,d)};goog.ENABLE_DEBUG_LOADER=!0;goog.logToConsole_=function(a){goog.global.console&&goog.global.console.error(a)};
goog.require=function(a){if(!COMPILED){goog.ENABLE_DEBUG_LOADER&&goog.debugLoader_.requested(a);if(goog.isProvided_(a)){if(goog.isInModuleLoader_())return goog.module.getInternal_(a)}else if(goog.ENABLE_DEBUG_LOADER){var b=goog.moduleLoaderState_;goog.moduleLoaderState_=null;try{goog.debugLoader_.load_(a)}finally{goog.moduleLoaderState_=b}}return null}};goog.requireType=function(a){return{}};goog.basePath="";goog.nullFunction=function(){};
goog.abstractMethod=function(){throw Error("unimplemented abstract method");};goog.addSingletonGetter=function(a){a.instance_=void 0;a.getInstance=function(){if(a.instance_)return a.instance_;goog.DEBUG&&(goog.instantiatedSingletons_[goog.instantiatedSingletons_.length]=a);return a.instance_=new a}};goog.instantiatedSingletons_=[];goog.LOAD_MODULE_USING_EVAL=!0;goog.SEAL_MODULE_EXPORTS=goog.DEBUG;goog.loadedModules_={};goog.DEPENDENCIES_ENABLED=!COMPILED&&goog.ENABLE_DEBUG_LOADER;goog.TRANSPILE="detect";
goog.ASSUME_ES_MODULES_TRANSPILED=!1;goog.TRANSPILE_TO_LANGUAGE="";goog.TRANSPILER="transpile.js";goog.hasBadLetScoping=null;goog.useSafari10Workaround=function(){if(null==goog.hasBadLetScoping){try{var a=!eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";')}catch(b){a=!1}goog.hasBadLetScoping=a}return goog.hasBadLetScoping};goog.workaroundSafari10EvalBug=function(a){return"(function(){"+a+"\n;})();\n"};
goog.loadModule=function(a){var b=goog.moduleLoaderState_;try{goog.moduleLoaderState_={moduleName:"",declareLegacyNamespace:!1,type:goog.ModuleType.GOOG};var c={},d=c;if("function"===typeof a)d=a.call(void 0,d);else if("string"===typeof a)goog.useSafari10Workaround()&&(a=goog.workaroundSafari10EvalBug(a)),d=goog.loadModuleFromSource_.call(void 0,d,a);else throw Error("Invalid module definition");var e=goog.moduleLoaderState_.moduleName;if("string"===typeof e&&e)goog.moduleLoaderState_.declareLegacyNamespace?
goog.constructNamespace_(e,d,c!==d):goog.SEAL_MODULE_EXPORTS&&Object.seal&&"object"==typeof d&&null!=d&&Object.seal(d),goog.loadedModules_[e]={exports:d,type:goog.ModuleType.GOOG,moduleId:goog.moduleLoaderState_.moduleName};else throw Error('Invalid module name "'+e+'"');}finally{goog.moduleLoaderState_=b}};goog.loadModuleFromSource_=function(a,b){eval(b);return a};
goog.normalizePath_=function(a){a=a.split("/");for(var b=0;b<a.length;)"."==a[b]?a.splice(b,1):b&&".."==a[b]&&a[b-1]&&".."!=a[b-1]?a.splice(--b,2):b++;return a.join("/")};goog.loadFileSync_=function(a){if(goog.global.CLOSURE_LOAD_FILE_SYNC)return goog.global.CLOSURE_LOAD_FILE_SYNC(a);try{var b=new goog.global.XMLHttpRequest;b.open("get",a,!1);b.send();return 0==b.status||200==b.status?b.responseText:null}catch(c){return null}};
goog.transpile_=function(a,b,c){var d=goog.global.$jscomp;d||(goog.global.$jscomp=d={});var e=d.transpile;if(!e){var f=goog.basePath+goog.TRANSPILER,g=goog.loadFileSync_(f);if(g){(function(){(0,eval)(g+"\n//# sourceURL="+f)}).call(goog.global);if(goog.global.$gwtExport&&goog.global.$gwtExport.$jscomp&&!goog.global.$gwtExport.$jscomp.transpile)throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: '+JSON.stringify(goog.global.$gwtExport));goog.global.$jscomp.transpile=
goog.global.$gwtExport.$jscomp.transpile;d=goog.global.$jscomp;e=d.transpile}}e||(e=d.transpile=function(h,k){goog.logToConsole_(k+" requires transpilation but no transpiler was found.");return h});return e(a,b,c)};goog.typeOf=function(a){var b=typeof a;return"object"!=b?b:a?Array.isArray(a)?"array":b:"null"};goog.isArrayLike=function(a){var b=goog.typeOf(a);return"array"==b||"object"==b&&"number"==typeof a.length};goog.isDateLike=function(a){return goog.isObject(a)&&"function"==typeof a.getFullYear};
goog.isObject=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b};goog.getUid=function(a){return Object.prototype.hasOwnProperty.call(a,goog.UID_PROPERTY_)&&a[goog.UID_PROPERTY_]||(a[goog.UID_PROPERTY_]=++goog.uidCounter_)};goog.hasUid=function(a){return!!a[goog.UID_PROPERTY_]};goog.removeUid=function(a){null!==a&&"removeAttribute"in a&&a.removeAttribute(goog.UID_PROPERTY_);try{delete a[goog.UID_PROPERTY_]}catch(b){}};goog.UID_PROPERTY_="closure_uid_"+(1E9*Math.random()>>>0);
goog.uidCounter_=0;goog.cloneObject=function(a){var b=goog.typeOf(a);if("object"==b||"array"==b){if("function"===typeof a.clone)return a.clone();b="array"==b?[]:{};for(var c in a)b[c]=goog.cloneObject(a[c]);return b}return a};goog.bindNative_=function(a,b,c){return a.call.apply(a.bind,arguments)};
goog.bindJs_=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}};goog.bind=function(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?goog.bind=goog.bindNative_:goog.bind=goog.bindJs_;return goog.bind.apply(null,arguments)};
goog.partial=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}};goog.mixin=function(a,b){for(var c in b)a[c]=b[c]};goog.now=function(){return Date.now()};goog.globalEval=function(a){(0,eval)(a)};
goog.getCssName=function(a,b){if("."==String(a).charAt(0))throw Error('className passed in goog.getCssName must not start with ".". You passed: '+a);var c=function(e){return goog.cssNameMapping_[e]||e},d=function(e){e=e.split("-");for(var f=[],g=0;g<e.length;g++)f.push(c(e[g]));return f.join("-")};d=goog.cssNameMapping_?"BY_WHOLE"==goog.cssNameMappingStyle_?c:d:function(e){return e};a=b?a+"-"+d(b):d(a);return goog.global.CLOSURE_CSS_NAME_MAP_FN?goog.global.CLOSURE_CSS_NAME_MAP_FN(a):a};
goog.setCssNameMapping=function(a,b){goog.cssNameMapping_=a;goog.cssNameMappingStyle_=b};!COMPILED&&goog.global.CLOSURE_CSS_NAME_MAPPING&&(goog.cssNameMapping_=goog.global.CLOSURE_CSS_NAME_MAPPING);goog.getMsg=function(a,b,c){c&&c.html&&(a=a.replace(/</g,"&lt;"));c&&c.unescapeHtmlEntities&&(a=a.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&apos;/g,"'").replace(/&quot;/g,'"').replace(/&amp;/g,"&"));b&&(a=a.replace(/\{\$([^}]+)}/g,function(d,e){return null!=b&&e in b?b[e]:d}));return a};
goog.getMsgWithFallback=function(a,b){return a};goog.exportSymbol=function(a,b,c){goog.exportPath_(a,b,!0,c)};goog.exportProperty=function(a,b,c){a[b]=c};goog.inherits=function(a,b){function c(){}c.prototype=b.prototype;a.superClass_=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.base=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}};
goog.scope=function(a){if(goog.isInModuleLoader_())throw Error("goog.scope is not supported within a module.");a.call(goog.global)};COMPILED||(goog.global.COMPILED=COMPILED);
goog.defineClass=function(a,b){var c=b.constructor,d=b.statics;c&&c!=Object.prototype.constructor||(c=function(){throw Error("cannot instantiate an interface (no constructor defined).");});c=goog.defineClass.createSealingConstructor_(c,a);a&&goog.inherits(c,a);delete b.constructor;delete b.statics;goog.defineClass.applyProperties_(c.prototype,b);null!=d&&(d instanceof Function?d(c):goog.defineClass.applyProperties_(c,d));return c};goog.defineClass.SEAL_CLASS_INSTANCES=goog.DEBUG;
goog.defineClass.createSealingConstructor_=function(a,b){return goog.defineClass.SEAL_CLASS_INSTANCES?function(){var c=a.apply(this,arguments)||this;c[goog.UID_PROPERTY_]=c[goog.UID_PROPERTY_];return c}:a};goog.defineClass.OBJECT_PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_=function(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c]);for(var d=0;d<goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++)c=goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d],Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c])};
!COMPILED&&goog.DEPENDENCIES_ENABLED&&(goog.inHtmlDocument_=function(){var a=goog.global.document;return null!=a&&"write"in a},goog.isDocumentLoading_=function(){var a=goog.global.document;return a.attachEvent?"complete"!=a.readyState:"loading"==a.readyState},goog.findBasePath_=function(){if(void 0!=goog.global.CLOSURE_BASE_PATH&&"string"===typeof goog.global.CLOSURE_BASE_PATH)goog.basePath=goog.global.CLOSURE_BASE_PATH;else if(goog.inHtmlDocument_()){var a=goog.global.document,b=a.currentScript;
a=b?[b]:a.getElementsByTagName("SCRIPT");for(b=a.length-1;0<=b;--b){var c=a[b].src,d=c.lastIndexOf("?");d=-1==d?c.length:d;if("base.js"==c.substr(d-7,7)){goog.basePath=c.substr(0,d-7);break}}}},goog.findBasePath_(),goog.Transpiler=function(){this.requiresTranspilation_=null;this.transpilationTarget_=goog.TRANSPILE_TO_LANGUAGE},goog.Transpiler.prototype.createRequiresTranspilation_=function(){function a(g,h){e?d[g]=!0:h()?(c=g,d[g]=!1):e=d[g]=!0}function b(g){try{return!!eval(g)}catch(h){return!1}}
var c="es3",d={es3:!1},e=!1,f=goog.global.navigator&&goog.global.navigator.userAgent?goog.global.navigator.userAgent:"";a("es5",function(){return b("[1,].length==1")});a("es6",function(){return f.match(/Edge\/(\d+)(\.\d)*/i)?!1:b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()')});
a("es7",function(){return b("2 ** 2 == 4")});a("es8",function(){return b("async () => 1, true")});a("es9",function(){return b("({...rest} = {}), true")});a("es_next",function(){return!1});return{target:c,map:d}},goog.Transpiler.prototype.needsTranspile=function(a,b){if("always"==goog.TRANSPILE)return!0;if("never"==goog.TRANSPILE)return!1;if(!this.requiresTranspilation_){var c=this.createRequiresTranspilation_();this.requiresTranspilation_=c.map;this.transpilationTarget_=this.transpilationTarget_||
c.target}if(a in this.requiresTranspilation_)return this.requiresTranspilation_[a]?!0:!goog.inHtmlDocument_()||"es6"!=b||"noModule"in goog.global.document.createElement("script")?!1:!0;throw Error("Unknown language mode: "+a);},goog.Transpiler.prototype.transpile=function(a,b){return goog.transpile_(a,b,this.transpilationTarget_)},goog.transpiler_=new goog.Transpiler,goog.protectScriptTag_=function(a){return a.replace(/<\/(SCRIPT)/ig,"\\x3c/$1")},goog.DebugLoader_=function(){this.dependencies_={};
this.idToPath_={};this.written_={};this.loadingDeps_=[];this.depsToLoad_=[];this.paused_=!1;this.factory_=new goog.DependencyFactory(goog.transpiler_);this.deferredCallbacks_={};this.deferredQueue_=[]},goog.DebugLoader_.prototype.bootstrap=function(a,b){function c(){d&&(goog.global.setTimeout(d,0),d=null)}var d=b;if(a.length){b=[];for(var e=0;e<a.length;e++){var f=this.getPathFromDeps_(a[e]);if(!f)throw Error("Unregonized namespace: "+a[e]);b.push(this.dependencies_[f])}f=goog.require;var g=0;for(e=
0;e<a.length;e++)f(a[e]),b[e].onLoad(function(){++g==a.length&&c()})}else c()},goog.DebugLoader_.prototype.loadClosureDeps=function(){this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath+"deps.js"),"deps.js",[],[],{},!1));this.loadDeps_()},goog.DebugLoader_.prototype.requested=function(a,b){(a=this.getPathFromDeps_(a))&&(b||this.areDepsLoaded_(this.dependencies_[a].requires))&&(b=this.deferredCallbacks_[a])&&(delete this.deferredCallbacks_[a],b())},goog.DebugLoader_.prototype.setDependencyFactory=
function(a){this.factory_=a},goog.DebugLoader_.prototype.load_=function(a){if(this.getPathFromDeps_(a)){var b=this,c=[],d=function(e){var f=b.getPathFromDeps_(e);if(!f)throw Error("Bad dependency path or symbol: "+e);if(!b.written_[f]){b.written_[f]=!0;e=b.dependencies_[f];for(f=0;f<e.requires.length;f++)goog.isProvided_(e.requires[f])||d(e.requires[f]);c.push(e)}};d(a);a=!!this.depsToLoad_.length;this.depsToLoad_=this.depsToLoad_.concat(c);this.paused_||a||this.loadDeps_()}else throw a="goog.require could not find: "+
a,goog.logToConsole_(a),Error(a);},goog.DebugLoader_.prototype.loadDeps_=function(){for(var a=this,b=this.paused_;this.depsToLoad_.length&&!b;)(function(){var c=!1,d=a.depsToLoad_.shift(),e=!1;a.loading_(d);var f={pause:function(){if(c)throw Error("Cannot call pause after the call to load.");b=!0},resume:function(){c?a.resume_():b=!1},loaded:function(){if(e)throw Error("Double call to loaded.");e=!0;a.loaded_(d)},pending:function(){for(var g=[],h=0;h<a.loadingDeps_.length;h++)g.push(a.loadingDeps_[h]);
return g},setModuleState:function(g){goog.moduleLoaderState_={type:g,moduleName:"",declareLegacyNamespace:!1}},registerEs6ModuleExports:function(g,h,k){k&&(goog.loadedModules_[k]={exports:h,type:goog.ModuleType.ES6,moduleId:k||""})},registerGoogModuleExports:function(g,h){goog.loadedModules_[g]={exports:h,type:goog.ModuleType.GOOG,moduleId:g}},clearModuleState:function(){goog.moduleLoaderState_=null},defer:function(g){if(c)throw Error("Cannot register with defer after the call to load.");a.defer_(d,
g)},areDepsLoaded:function(){return a.areDepsLoaded_(d.requires)}};try{d.load(f)}finally{c=!0}})();b&&this.pause_()},goog.DebugLoader_.prototype.pause_=function(){this.paused_=!0},goog.DebugLoader_.prototype.resume_=function(){this.paused_&&(this.paused_=!1,this.loadDeps_())},goog.DebugLoader_.prototype.loading_=function(a){this.loadingDeps_.push(a)},goog.DebugLoader_.prototype.loaded_=function(a){for(var b=0;b<this.loadingDeps_.length;b++)if(this.loadingDeps_[b]==a){this.loadingDeps_.splice(b,1);
break}for(b=0;b<this.deferredQueue_.length;b++)if(this.deferredQueue_[b]==a.path){this.deferredQueue_.splice(b,1);break}if(this.loadingDeps_.length==this.deferredQueue_.length&&!this.depsToLoad_.length)for(;this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(),!0);a.loaded()},goog.DebugLoader_.prototype.areDepsLoaded_=function(a){for(var b=0;b<a.length;b++){var c=this.getPathFromDeps_(a[b]);if(!c||!(c in this.deferredCallbacks_||goog.isProvided_(a[b])))return!1}return!0},goog.DebugLoader_.prototype.getPathFromDeps_=
function(a){return a in this.idToPath_?this.idToPath_[a]:a in this.dependencies_?a:null},goog.DebugLoader_.prototype.defer_=function(a,b){this.deferredCallbacks_[a.path]=b;this.deferredQueue_.push(a.path)},goog.LoadController=function(){},goog.LoadController.prototype.pause=function(){},goog.LoadController.prototype.resume=function(){},goog.LoadController.prototype.loaded=function(){},goog.LoadController.prototype.pending=function(){},goog.LoadController.prototype.registerEs6ModuleExports=function(a,
b,c){},goog.LoadController.prototype.setModuleState=function(a){},goog.LoadController.prototype.clearModuleState=function(){},goog.LoadController.prototype.defer=function(a){},goog.LoadController.prototype.areDepsLoaded=function(){},goog.Dependency=function(a,b,c,d,e){this.path=a;this.relativePath=b;this.provides=c;this.requires=d;this.loadFlags=e;this.loaded_=!1;this.loadCallbacks_=[]},goog.Dependency.prototype.getPathName=function(){var a=this.path,b=a.indexOf("://");0<=b&&(a=a.substring(b+3),b=
a.indexOf("/"),0<=b&&(a=a.substring(b+1)));return a},goog.Dependency.prototype.onLoad=function(a){this.loaded_?a():this.loadCallbacks_.push(a)},goog.Dependency.prototype.loaded=function(){this.loaded_=!0;var a=this.loadCallbacks_;this.loadCallbacks_=[];for(var b=0;b<a.length;b++)a[b]()},goog.Dependency.defer_=!1,goog.Dependency.callbackMap_={},goog.Dependency.registerCallback_=function(a){var b=Math.random().toString(32);goog.Dependency.callbackMap_[b]=a;return b},goog.Dependency.unregisterCallback_=
function(a){delete goog.Dependency.callbackMap_[a]},goog.Dependency.callback_=function(a,b){if(a in goog.Dependency.callbackMap_){for(var c=goog.Dependency.callbackMap_[a],d=[],e=1;e<arguments.length;e++)d.push(arguments[e]);c.apply(void 0,d)}else throw Error("Callback key "+a+" does not exist (was base.js loaded more than once?).");},goog.Dependency.prototype.load=function(a){if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var b=
goog.global.document;if("complete"==b.readyState&&!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING){if(/\bdeps.js$/.test(this.path)){a.loaded();return}throw Error('Cannot write "'+this.path+'" after document load');}var c=goog.getScriptNonce();if(!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING&&goog.isDocumentLoading_()){var d=function(h){h.readyState&&"complete"!=h.readyState?h.onload=d:(goog.Dependency.unregisterCallback_(e),a.loaded())};var e=goog.Dependency.registerCallback_(d);c=c?' nonce="'+c+'"':"";
var f='<script src="'+this.path+'"'+c+(goog.Dependency.defer_?" defer":"")+' id="script-'+e+'">\x3c/script>';f+="<script"+c+">";f=goog.Dependency.defer_?f+("document.getElementById('script-"+e+"').onload = function() {\n  goog.Dependency.callback_('"+e+"', this);\n};\n"):f+("goog.Dependency.callback_('"+e+"', document.getElementById('script-"+e+"'));");f+="\x3c/script>";b.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(f):f)}else{var g=b.createElement("script");g.defer=goog.Dependency.defer_;
g.async=!1;c&&(g.nonce=c);goog.DebugLoader_.IS_OLD_IE_?(a.pause(),g.onreadystatechange=function(){if("loaded"==g.readyState||"complete"==g.readyState)a.loaded(),a.resume()}):g.onload=function(){g.onload=null;a.loaded()};g.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path):this.path;b.head.appendChild(g)}}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),"deps.js"==this.relativePath?(goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."),
a.loaded()):a.pause()},goog.Es6ModuleDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e)},goog.inherits(goog.Es6ModuleDependency,goog.Dependency),goog.Es6ModuleDependency.prototype.load=function(a){function b(l,p){var m="",n=goog.getScriptNonce();n&&(m=' nonce="'+n+'"');l=p?'<script type="module" crossorigin'+m+">"+p+"\x3c/script>":'<script type="module" crossorigin src="'+l+'"'+m+">\x3c/script>";d.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(l):l)}function c(l,
p){var m=d.createElement("script");m.defer=!0;m.async=!1;m.type="module";m.setAttribute("crossorigin",!0);var n=goog.getScriptNonce();n&&(m.nonce=n);p?m.text=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScript(p):p:m.src=goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createScriptURL(l):l;d.head.appendChild(m)}if(goog.global.CLOSURE_IMPORT_SCRIPT)goog.global.CLOSURE_IMPORT_SCRIPT(this.path)?a.loaded():a.pause();else if(goog.inHtmlDocument_()){var d=goog.global.document,e=this;
if(goog.isDocumentLoading_()){var f=b;goog.Dependency.defer_=!0}else f=c;var g=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(g);a.setModuleState(goog.ModuleType.ES6)});f(void 0,'goog.Dependency.callback_("'+g+'")');f(this.path,void 0);var h=goog.Dependency.registerCallback_(function(l){goog.Dependency.unregisterCallback_(h);a.registerEs6ModuleExports(e.path,l,goog.moduleLoaderState_.moduleName)});f(void 0,'import * as m from "'+this.path+'"; goog.Dependency.callback_("'+
h+'", m)');var k=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(k);a.clearModuleState();a.loaded()});f(void 0,'goog.Dependency.callback_("'+k+'")')}else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."),a.pause()},goog.TransformedDependency=function(a,b,c,d,e){goog.Dependency.call(this,a,b,c,d,e);this.contents_=null;this.lazyFetch_=!goog.inHtmlDocument_()||!("noModule"in goog.global.document.createElement("script"))},goog.inherits(goog.TransformedDependency,
goog.Dependency),goog.TransformedDependency.prototype.load=function(a){function b(){e.contents_=goog.loadFileSync_(e.path);e.contents_&&(e.contents_=e.transform(e.contents_),e.contents_&&(e.contents_+="\n//# sourceURL="+e.path))}function c(){e.lazyFetch_&&b();if(e.contents_){f&&a.setModuleState(goog.ModuleType.ES6);try{var p=e.contents_;e.contents_=null;goog.globalEval(p);if(f)var m=goog.moduleLoaderState_.moduleName}finally{f&&a.clearModuleState()}f&&goog.global.$jscomp.require.ensure([e.getPathName()],
function(){a.registerEs6ModuleExports(e.path,goog.global.$jscomp.require(e.getPathName()),m)});a.loaded()}}function d(){var p=goog.global.document,m=goog.Dependency.registerCallback_(function(){goog.Dependency.unregisterCallback_(m);c()}),n=goog.getScriptNonce();n="<script"+(n?' nonce="'+n+'"':"")+">"+goog.protectScriptTag_('goog.Dependency.callback_("'+m+'");')+"\x3c/script>";p.write(goog.TRUSTED_TYPES_POLICY_?goog.TRUSTED_TYPES_POLICY_.createHTML(n):n)}var e=this;if(goog.global.CLOSURE_IMPORT_SCRIPT)b(),
this.contents_&&goog.global.CLOSURE_IMPORT_SCRIPT("",this.contents_)?(this.contents_=null,a.loaded()):a.pause();else{var f=this.loadFlags.module==goog.ModuleType.ES6;this.lazyFetch_||b();var g=1<a.pending().length,h=g&&goog.DebugLoader_.IS_OLD_IE_;g=goog.Dependency.defer_&&(g||goog.isDocumentLoading_());if(h||g)a.defer(function(){c()});else{var k=goog.global.document;h=goog.inHtmlDocument_()&&"ActiveXObject"in goog.global;if(f&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()&&!h){goog.Dependency.defer_=
!0;a.pause();var l=k.onreadystatechange;k.onreadystatechange=function(){"interactive"==k.readyState&&(k.onreadystatechange=l,c(),a.resume());"function"===typeof l&&l.apply(void 0,arguments)}}else!goog.DebugLoader_.IS_OLD_IE_&&goog.inHtmlDocument_()&&goog.isDocumentLoading_()?d():c()}}},goog.TransformedDependency.prototype.transform=function(a){},goog.TranspiledDependency=function(a,b,c,d,e,f){goog.TransformedDependency.call(this,a,b,c,d,e);this.transpiler=f},goog.inherits(goog.TranspiledDependency,
goog.TransformedDependency),goog.TranspiledDependency.prototype.transform=function(a){return this.transpiler.transpile(a,this.getPathName())},goog.PreTranspiledEs6ModuleDependency=function(a,b,c,d,e){goog.TransformedDependency.call(this,a,b,c,d,e)},goog.inherits(goog.PreTranspiledEs6ModuleDependency,goog.TransformedDependency),goog.PreTranspiledEs6ModuleDependency.prototype.transform=function(a){return a},goog.GoogModuleDependency=function(a,b,c,d,e,f,g){goog.TransformedDependency.call(this,a,b,c,
d,e);this.needsTranspile_=f;this.transpiler_=g},goog.inherits(goog.GoogModuleDependency,goog.TransformedDependency),goog.GoogModuleDependency.prototype.transform=function(a){this.needsTranspile_&&(a=this.transpiler_.transpile(a,this.getPathName()));return goog.LOAD_MODULE_USING_EVAL&&void 0!==goog.global.JSON?"goog.loadModule("+goog.global.JSON.stringify(a+"\n//# sourceURL="+this.path+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+a+"\n;return exports});\n//# sourceURL="+this.path+
"\n"},goog.DebugLoader_.IS_OLD_IE_=!(goog.global.atob||!goog.global.document||!goog.global.document.all),goog.DebugLoader_.prototype.addDependency=function(a,b,c,d){b=b||[];a=a.replace(/\\/g,"/");var e=goog.normalizePath_(goog.basePath+a);d&&"boolean"!==typeof d||(d=d?{module:goog.ModuleType.GOOG}:{});c=this.factory_.createDependency(e,a,b,c,d,goog.transpiler_.needsTranspile(d.lang||"es3",d.module));this.dependencies_[e]=c;for(c=0;c<b.length;c++)this.idToPath_[b[c]]=e;this.idToPath_[a]=e},goog.DependencyFactory=
function(a){this.transpiler=a},goog.DependencyFactory.prototype.createDependency=function(a,b,c,d,e,f){return e.module==goog.ModuleType.GOOG?new goog.GoogModuleDependency(a,b,c,d,e,f,this.transpiler):f?new goog.TranspiledDependency(a,b,c,d,e,this.transpiler):e.module==goog.ModuleType.ES6?"never"==goog.TRANSPILE&&goog.ASSUME_ES_MODULES_TRANSPILED?new goog.PreTranspiledEs6ModuleDependency(a,b,c,d,e):new goog.Es6ModuleDependency(a,b,c,d,e):new goog.Dependency(a,b,c,d,e)},goog.debugLoader_=new goog.DebugLoader_,
goog.loadClosureDeps=function(){goog.debugLoader_.loadClosureDeps()},goog.setDependencyFactory=function(a){goog.debugLoader_.setDependencyFactory(a)},goog.TRUSTED_TYPES_POLICY_=goog.TRUSTED_TYPES_POLICY_NAME?goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#base"):null,goog.global.CLOSURE_NO_DEPS||goog.debugLoader_.loadClosureDeps(),goog.bootstrap=function(a,b){goog.debugLoader_.bootstrap(a,b)});goog.TRUSTED_TYPES_POLICY_NAME="goog";goog.identity_=function(a){return a};
goog.createTrustedTypesPolicy=function(a){var b=null,c=goog.global.trustedTypes;if(!c||!c.createPolicy)return b;try{b=c.createPolicy(a,{createHTML:goog.identity_,createScript:goog.identity_,createScriptURL:goog.identity_})}catch(d){goog.logToConsole_(d.message)}return b};goog.debug={};function module$contents$goog$debug$Error_DebugError(a){if(Error.captureStackTrace)Error.captureStackTrace(this,module$contents$goog$debug$Error_DebugError);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a));this.reportErrorToServer=!0}goog.inherits(module$contents$goog$debug$Error_DebugError,Error);module$contents$goog$debug$Error_DebugError.prototype.name="CustomError";goog.debug.Error=module$contents$goog$debug$Error_DebugError;goog.dom={};goog.dom.NodeType={ELEMENT:1,ATTRIBUTE:2,TEXT:3,CDATA_SECTION:4,ENTITY_REFERENCE:5,ENTITY:6,PROCESSING_INSTRUCTION:7,COMMENT:8,DOCUMENT:9,DOCUMENT_TYPE:10,DOCUMENT_FRAGMENT:11,NOTATION:12};goog.asserts={};goog.asserts.ENABLE_ASSERTS=goog.DEBUG;goog.asserts.AssertionError=function(a,b){module$contents$goog$debug$Error_DebugError.call(this,goog.asserts.subs_(a,b));this.messagePattern=a};goog.inherits(goog.asserts.AssertionError,module$contents$goog$debug$Error_DebugError);goog.asserts.AssertionError.prototype.name="AssertionError";goog.asserts.DEFAULT_ERROR_HANDLER=function(a){throw a;};goog.asserts.errorHandler_=goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_=function(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");return c+a[d]};goog.asserts.doAssertFailure_=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);a=new goog.asserts.AssertionError(""+e,f||[]);goog.asserts.errorHandler_(a)};goog.asserts.setErrorHandler=function(a){goog.asserts.ENABLE_ASSERTS&&(goog.asserts.errorHandler_=a)};
goog.asserts.assert=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!a&&goog.asserts.doAssertFailure_("",null,b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertExists=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&null==a&&goog.asserts.doAssertFailure_("Expected to exist: %s.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.fail=function(a,b){goog.asserts.ENABLE_ASSERTS&&goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1)))};goog.asserts.assertNumber=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"number"!==typeof a&&goog.asserts.doAssertFailure_("Expected number but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertString=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"string"!==typeof a&&goog.asserts.doAssertFailure_("Expected string but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertFunction=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"function"!==typeof a&&goog.asserts.doAssertFailure_("Expected function but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObject=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!goog.isObject(a)&&goog.asserts.doAssertFailure_("Expected object but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertArray=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&!Array.isArray(a)&&goog.asserts.doAssertFailure_("Expected array but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertBoolean=function(a,b,c){goog.asserts.ENABLE_ASSERTS&&"boolean"!==typeof a&&goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};goog.asserts.assertElement=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||goog.isObject(a)&&a.nodeType==goog.dom.NodeType.ELEMENT||goog.asserts.doAssertFailure_("Expected Element but got %s: %s.",[goog.typeOf(a),a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertInstanceof=function(a,b,c,d){!goog.asserts.ENABLE_ASSERTS||a instanceof b||goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.",[goog.asserts.getType_(b),goog.asserts.getType_(a)],c,Array.prototype.slice.call(arguments,3));return a};goog.asserts.assertFinite=function(a,b,c){!goog.asserts.ENABLE_ASSERTS||"number"==typeof a&&isFinite(a)||goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.",[a],b,Array.prototype.slice.call(arguments,2));return a};
goog.asserts.assertObjectPrototypeIsIntact=function(){for(var a in Object.prototype)goog.asserts.fail(a+" should not be enumerable in Object.prototype.")};goog.asserts.getType_=function(a){return a instanceof Function?a.displayName||a.name||"unknown type name":a instanceof Object?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):null===a?"null":typeof a};goog.array={};goog.NATIVE_ARRAY_PROTOTYPES=goog.TRUSTED_SITE;var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS=2012<goog.FEATURESET_YEAR;goog.array.ASSUME_NATIVE_FUNCTIONS=module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;function module$contents$goog$array_peek(a){return a[a.length-1]}goog.array.peek=module$contents$goog$array_peek;goog.array.last=module$contents$goog$array_peek;
var module$contents$goog$array_indexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.indexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,c);for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1};goog.array.indexOf=module$contents$goog$array_indexOf;
var module$contents$goog$array_lastIndexOf=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.lastIndexOf)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.lastIndexOf.call(a,b,null==c?a.length-1:c)}:function(a,b,c){c=null==c?a.length-1:c;0>c&&(c=Math.max(0,a.length+c));if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.lastIndexOf(b,c);for(;0<=c;c--)if(c in a&&a[c]===b)return c;return-1};
goog.array.lastIndexOf=module$contents$goog$array_lastIndexOf;var module$contents$goog$array_forEach=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.forEach)?function(a,b,c){goog.asserts.assert(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};goog.array.forEach=module$contents$goog$array_forEach;
function module$contents$goog$array_forEachRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;--d)d in e&&b.call(c,e[d],d,a)}goog.array.forEachRight=module$contents$goog$array_forEachRight;
var module$contents$goog$array_filter=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.filter)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,g="string"===typeof a?a.split(""):a,h=0;h<d;h++)if(h in g){var k=g[h];b.call(c,k,h,a)&&(e[f++]=k)}return e};goog.array.filter=module$contents$goog$array_filter;
var module$contents$goog$array_map=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.map)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f="string"===typeof a?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e};goog.array.map=module$contents$goog$array_map;
var module$contents$goog$array_reduce=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduce)?function(a,b,c,d){goog.asserts.assert(null!=a.length);d&&(b=goog.bind(b,d));return Array.prototype.reduce.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEach(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduce=module$contents$goog$array_reduce;
var module$contents$goog$array_reduceRight=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.reduceRight)?function(a,b,c,d){goog.asserts.assert(null!=a.length);goog.asserts.assert(null!=b);d&&(b=goog.bind(b,d));return Array.prototype.reduceRight.call(a,b,c)}:function(a,b,c,d){var e=c;module$contents$goog$array_forEachRight(a,function(f,g){e=b.call(d,e,f,g,a)});return e};goog.array.reduceRight=module$contents$goog$array_reduceRight;
var module$contents$goog$array_some=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.some)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};goog.array.some=module$contents$goog$array_some;
var module$contents$goog$array_every=goog.NATIVE_ARRAY_PROTOTYPES&&(module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS||Array.prototype.every)?function(a,b,c){goog.asserts.assert(null!=a.length);return Array.prototype.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};goog.array.every=module$contents$goog$array_every;
function module$contents$goog$array_count(a,b,c){var d=0;module$contents$goog$array_forEach(a,function(e,f,g){b.call(c,e,f,g)&&++d},c);return d}goog.array.count=module$contents$goog$array_count;function module$contents$goog$array_find(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.find=module$contents$goog$array_find;
function module$contents$goog$array_findIndex(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}goog.array.findIndex=module$contents$goog$array_findIndex;function module$contents$goog$array_findRight(a,b,c){b=module$contents$goog$array_findIndexRight(a,b,c);return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}goog.array.findRight=module$contents$goog$array_findRight;
function module$contents$goog$array_findIndexRight(a,b,c){var d=a.length,e="string"===typeof a?a.split(""):a;for(--d;0<=d;d--)if(d in e&&b.call(c,e[d],d,a))return d;return-1}goog.array.findIndexRight=module$contents$goog$array_findIndexRight;function module$contents$goog$array_contains(a,b){return 0<=module$contents$goog$array_indexOf(a,b)}goog.array.contains=module$contents$goog$array_contains;function module$contents$goog$array_isEmpty(a){return 0==a.length}goog.array.isEmpty=module$contents$goog$array_isEmpty;
function module$contents$goog$array_clear(a){if(!Array.isArray(a))for(var b=a.length-1;0<=b;b--)delete a[b];a.length=0}goog.array.clear=module$contents$goog$array_clear;function module$contents$goog$array_insert(a,b){module$contents$goog$array_contains(a,b)||a.push(b)}goog.array.insert=module$contents$goog$array_insert;function module$contents$goog$array_insertAt(a,b,c){module$contents$goog$array_splice(a,c,0,b)}goog.array.insertAt=module$contents$goog$array_insertAt;
function module$contents$goog$array_insertArrayAt(a,b,c){goog.partial(module$contents$goog$array_splice,a,c,0).apply(null,b)}goog.array.insertArrayAt=module$contents$goog$array_insertArrayAt;function module$contents$goog$array_insertBefore(a,b,c){var d;2==arguments.length||0>(d=module$contents$goog$array_indexOf(a,c))?a.push(b):module$contents$goog$array_insertAt(a,b,d)}goog.array.insertBefore=module$contents$goog$array_insertBefore;
function module$contents$goog$array_remove(a,b){b=module$contents$goog$array_indexOf(a,b);var c;(c=0<=b)&&module$contents$goog$array_removeAt(a,b);return c}goog.array.remove=module$contents$goog$array_remove;function module$contents$goog$array_removeLast(a,b){b=module$contents$goog$array_lastIndexOf(a,b);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeLast=module$contents$goog$array_removeLast;
function module$contents$goog$array_removeAt(a,b){goog.asserts.assert(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length}goog.array.removeAt=module$contents$goog$array_removeAt;function module$contents$goog$array_removeIf(a,b,c){b=module$contents$goog$array_findIndex(a,b,c);return 0<=b?(module$contents$goog$array_removeAt(a,b),!0):!1}goog.array.removeIf=module$contents$goog$array_removeIf;
function module$contents$goog$array_removeAllIf(a,b,c){var d=0;module$contents$goog$array_forEachRight(a,function(e,f){b.call(c,e,f,a)&&module$contents$goog$array_removeAt(a,f)&&d++});return d}goog.array.removeAllIf=module$contents$goog$array_removeAllIf;function module$contents$goog$array_concat(a){return Array.prototype.concat.apply([],arguments)}goog.array.concat=module$contents$goog$array_concat;function module$contents$goog$array_join(a){return Array.prototype.concat.apply([],arguments)}
goog.array.join=module$contents$goog$array_join;function module$contents$goog$array_toArray(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}var module$contents$goog$array_clone=goog.array.toArray=module$contents$goog$array_toArray;goog.array.clone=module$contents$goog$array_clone;
function module$contents$goog$array_extend(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(goog.isArrayLike(d)){var e=a.length||0,f=d.length||0;a.length=e+f;for(var g=0;g<f;g++)a[e+g]=d[g]}else a.push(d)}}goog.array.extend=module$contents$goog$array_extend;function module$contents$goog$array_splice(a,b,c,d){goog.asserts.assert(null!=a.length);return Array.prototype.splice.apply(a,module$contents$goog$array_slice(arguments,1))}goog.array.splice=module$contents$goog$array_splice;
function module$contents$goog$array_slice(a,b,c){goog.asserts.assert(null!=a.length);return 2>=arguments.length?Array.prototype.slice.call(a,b):Array.prototype.slice.call(a,b,c)}goog.array.slice=module$contents$goog$array_slice;
function module$contents$goog$array_removeDuplicates(a,b,c){b=b||a;var d=function(k){return goog.isObject(k)?"o"+goog.getUid(k):(typeof k).charAt(0)+k};c=c||d;d={};for(var e=0,f=0;f<a.length;){var g=a[f++],h=c(g);Object.prototype.hasOwnProperty.call(d,h)||(d[h]=!0,b[e++]=g)}b.length=e}goog.array.removeDuplicates=module$contents$goog$array_removeDuplicates;
function module$contents$goog$array_binarySearch(a,b,c){return module$contents$goog$array_binarySearch_(a,c||module$contents$goog$array_defaultCompare,!1,b)}goog.array.binarySearch=module$contents$goog$array_binarySearch;function module$contents$goog$array_binarySelect(a,b,c){return module$contents$goog$array_binarySearch_(a,b,!0,void 0,c)}goog.array.binarySelect=module$contents$goog$array_binarySelect;
function module$contents$goog$array_binarySearch_(a,b,c,d,e){for(var f=0,g=a.length,h;f<g;){var k=f+(g-f>>>1);var l=c?b.call(e,a[k],k,a):b(d,a[k]);0<l?f=k+1:(g=k,h=!l)}return h?f:-f-1}function module$contents$goog$array_sort(a,b){a.sort(b||module$contents$goog$array_defaultCompare)}goog.array.sort=module$contents$goog$array_sort;
function module$contents$goog$array_stableSort(a,b){for(var c=Array(a.length),d=0;d<a.length;d++)c[d]={index:d,value:a[d]};var e=b||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(c,function(f,g){return e(f.value,g.value)||f.index-g.index});for(d=0;d<a.length;d++)a[d]=c[d].value}goog.array.stableSort=module$contents$goog$array_stableSort;
function module$contents$goog$array_sortByKey(a,b,c){var d=c||module$contents$goog$array_defaultCompare;module$contents$goog$array_sort(a,function(e,f){return d(b(e),b(f))})}goog.array.sortByKey=module$contents$goog$array_sortByKey;function module$contents$goog$array_sortObjectsByKey(a,b,c){module$contents$goog$array_sortByKey(a,function(d){return d[b]},c)}goog.array.sortObjectsByKey=module$contents$goog$array_sortObjectsByKey;
function module$contents$goog$array_isSorted(a,b,c){b=b||module$contents$goog$array_defaultCompare;for(var d=1;d<a.length;d++){var e=b(a[d-1],a[d]);if(0<e||0==e&&c)return!1}return!0}goog.array.isSorted=module$contents$goog$array_isSorted;function module$contents$goog$array_equals(a,b,c){if(!goog.isArrayLike(a)||!goog.isArrayLike(b)||a.length!=b.length)return!1;var d=a.length;c=c||module$contents$goog$array_defaultCompareEquality;for(var e=0;e<d;e++)if(!c(a[e],b[e]))return!1;return!0}
goog.array.equals=module$contents$goog$array_equals;function module$contents$goog$array_compare3(a,b,c){c=c||module$contents$goog$array_defaultCompare;for(var d=Math.min(a.length,b.length),e=0;e<d;e++){var f=c(a[e],b[e]);if(0!=f)return f}return module$contents$goog$array_defaultCompare(a.length,b.length)}goog.array.compare3=module$contents$goog$array_compare3;function module$contents$goog$array_defaultCompare(a,b){return a>b?1:a<b?-1:0}goog.array.defaultCompare=module$contents$goog$array_defaultCompare;
function module$contents$goog$array_inverseDefaultCompare(a,b){return-module$contents$goog$array_defaultCompare(a,b)}goog.array.inverseDefaultCompare=module$contents$goog$array_inverseDefaultCompare;function module$contents$goog$array_defaultCompareEquality(a,b){return a===b}goog.array.defaultCompareEquality=module$contents$goog$array_defaultCompareEquality;
function module$contents$goog$array_binaryInsert(a,b,c){c=module$contents$goog$array_binarySearch(a,b,c);return 0>c?(module$contents$goog$array_insertAt(a,b,-(c+1)),!0):!1}goog.array.binaryInsert=module$contents$goog$array_binaryInsert;function module$contents$goog$array_binaryRemove(a,b,c){b=module$contents$goog$array_binarySearch(a,b,c);return 0<=b?module$contents$goog$array_removeAt(a,b):!1}goog.array.binaryRemove=module$contents$goog$array_binaryRemove;
function module$contents$goog$array_bucket(a,b,c){for(var d={},e=0;e<a.length;e++){var f=a[e],g=b.call(c,f,e,a);void 0!==g&&(d[g]||(d[g]=[])).push(f)}return d}goog.array.bucket=module$contents$goog$array_bucket;function module$contents$goog$array_toObject(a,b,c){var d={};module$contents$goog$array_forEach(a,function(e,f){d[b.call(c,e,f,a)]=e});return d}goog.array.toObject=module$contents$goog$array_toObject;
function module$contents$goog$array_range(a,b,c){var d=[],e=0,f=a;c=c||1;void 0!==b&&(e=a,f=b);if(0>c*(f-e))return[];if(0<c)for(a=e;a<f;a+=c)d.push(a);else for(a=e;a>f;a+=c)d.push(a);return d}goog.array.range=module$contents$goog$array_range;function module$contents$goog$array_repeat(a,b){for(var c=[],d=0;d<b;d++)c[d]=a;return c}goog.array.repeat=module$contents$goog$array_repeat;
function module$contents$goog$array_flatten(a){for(var b=[],c=0;c<arguments.length;c++){var d=arguments[c];if(Array.isArray(d))for(var e=0;e<d.length;e+=8192){var f=module$contents$goog$array_slice(d,e,e+8192);f=module$contents$goog$array_flatten.apply(null,f);for(var g=0;g<f.length;g++)b.push(f[g])}else b.push(d)}return b}goog.array.flatten=module$contents$goog$array_flatten;
function module$contents$goog$array_rotate(a,b){goog.asserts.assert(null!=a.length);a.length&&(b%=a.length,0<b?Array.prototype.unshift.apply(a,a.splice(-b,b)):0>b&&Array.prototype.push.apply(a,a.splice(0,-b)));return a}goog.array.rotate=module$contents$goog$array_rotate;function module$contents$goog$array_moveItem(a,b,c){goog.asserts.assert(0<=b&&b<a.length);goog.asserts.assert(0<=c&&c<a.length);b=Array.prototype.splice.call(a,b,1);Array.prototype.splice.call(a,c,0,b[0])}goog.array.moveItem=module$contents$goog$array_moveItem;
function module$contents$goog$array_zip(a){if(!arguments.length)return[];for(var b=[],c=arguments[0].length,d=1;d<arguments.length;d++)arguments[d].length<c&&(c=arguments[d].length);for(d=0;d<c;d++){for(var e=[],f=0;f<arguments.length;f++)e.push(arguments[f][d]);b.push(e)}return b}goog.array.zip=module$contents$goog$array_zip;function module$contents$goog$array_shuffle(a,b){b=b||Math.random;for(var c=a.length-1;0<c;c--){var d=Math.floor(b()*(c+1)),e=a[c];a[c]=a[d];a[d]=e}}goog.array.shuffle=module$contents$goog$array_shuffle;
function module$contents$goog$array_copyByIndex(a,b){var c=[];module$contents$goog$array_forEach(b,function(d){c.push(a[d])});return c}goog.array.copyByIndex=module$contents$goog$array_copyByIndex;function module$contents$goog$array_concatMap(a,b,c){return module$contents$goog$array_concat.apply([],module$contents$goog$array_map(a,b,c))}goog.array.concatMap=module$contents$goog$array_concatMap;goog.dom.asserts={};goog.dom.asserts.assertIsLocation=function(a){if(goog.asserts.ENABLE_ASSERTS){var b=goog.dom.asserts.getWindow_(a);b&&(!a||!(a instanceof b.Location)&&a instanceof b.Element)&&goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s",goog.dom.asserts.debugStringForType_(a))}return a};
goog.dom.asserts.assertIsElementType_=function(a,b){if(goog.asserts.ENABLE_ASSERTS){var c=goog.dom.asserts.getWindow_(a);c&&"undefined"!=typeof c[b]&&(a&&(a instanceof c[b]||!(a instanceof c.Location||a instanceof c.Element))||goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s",b,goog.dom.asserts.debugStringForType_(a)))}return a};goog.dom.asserts.assertIsHTMLAnchorElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAnchorElement")};
goog.dom.asserts.assertIsHTMLButtonElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLButtonElement")};goog.dom.asserts.assertIsHTMLLinkElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLLinkElement")};goog.dom.asserts.assertIsHTMLImageElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLImageElement")};goog.dom.asserts.assertIsHTMLAudioElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLAudioElement")};
goog.dom.asserts.assertIsHTMLVideoElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLVideoElement")};goog.dom.asserts.assertIsHTMLInputElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLInputElement")};goog.dom.asserts.assertIsHTMLTextAreaElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLTextAreaElement")};goog.dom.asserts.assertIsHTMLCanvasElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLCanvasElement")};
goog.dom.asserts.assertIsHTMLEmbedElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLEmbedElement")};goog.dom.asserts.assertIsHTMLFormElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFormElement")};goog.dom.asserts.assertIsHTMLFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLFrameElement")};goog.dom.asserts.assertIsHTMLIFrameElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLIFrameElement")};
goog.dom.asserts.assertIsHTMLObjectElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLObjectElement")};goog.dom.asserts.assertIsHTMLScriptElement=function(a){return goog.dom.asserts.assertIsElementType_(a,"HTMLScriptElement")};
goog.dom.asserts.debugStringForType_=function(a){if(goog.isObject(a))try{return a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(b){return"<object could not be stringified>"}else return void 0===a?"undefined":null===a?"null":typeof a};goog.dom.asserts.getWindow_=function(a){try{var b=a&&a.ownerDocument,c=b&&(b.defaultView||b.parentWindow);c=c||goog.global;if(c.Element&&c.Location)return c}catch(d){}return null};goog.dom.HtmlElement=function(){};goog.functions={};goog.functions.constant=function(a){return function(){return a}};goog.functions.FALSE=function(){return!1};goog.functions.TRUE=function(){return!0};goog.functions.NULL=function(){return null};goog.functions.identity=function(a,b){return a};goog.functions.error=function(a){return function(){throw Error(a);}};goog.functions.fail=function(a){return function(){throw a;}};
goog.functions.lock=function(a,b){b=b||0;return function(){return a.apply(this,Array.prototype.slice.call(arguments,0,b))}};goog.functions.nth=function(a){return function(){return arguments[a]}};goog.functions.partialRight=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=this;d===goog.global&&(d=void 0);var e=Array.prototype.slice.call(arguments);e.push.apply(e,c);return a.apply(d,e)}};
goog.functions.withReturnValue=function(a,b){return goog.functions.sequence(a,goog.functions.constant(b))};goog.functions.equalTo=function(a,b){return function(c){return b?a==c:a===c}};goog.functions.compose=function(a,b){var c=arguments,d=c.length;return function(){var e;d&&(e=c[d-1].apply(this,arguments));for(var f=d-2;0<=f;f--)e=c[f].call(this,e);return e}};goog.functions.sequence=function(a){var b=arguments,c=b.length;return function(){for(var d,e=0;e<c;e++)d=b[e].apply(this,arguments);return d}};
goog.functions.and=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(!b[d].apply(this,arguments))return!1;return!0}};goog.functions.or=function(a){var b=arguments,c=b.length;return function(){for(var d=0;d<c;d++)if(b[d].apply(this,arguments))return!0;return!1}};goog.functions.not=function(a){return function(){return!a.apply(this,arguments)}};
goog.functions.create=function(a,b){var c=function(){};c.prototype=a.prototype;c=new c;a.apply(c,Array.prototype.slice.call(arguments,1));return c};goog.functions.CACHE_RETURN_VALUE=!0;goog.functions.cacheReturnValue=function(a){var b=!1,c;return function(){if(!goog.functions.CACHE_RETURN_VALUE)return a();b||(c=a(),b=!0);return c}};goog.functions.once=function(a){var b=a;return function(){if(b){var c=b;b=null;c()}}};
goog.functions.debounce=function(a,b,c){var d=0;return function(e){goog.global.clearTimeout(d);var f=arguments;d=goog.global.setTimeout(function(){a.apply(c,f)},b)}};goog.functions.throttle=function(a,b,c){var d=0,e=!1,f=[],g=function(){d=0;e&&(e=!1,h())},h=function(){d=goog.global.setTimeout(g,b);a.apply(c,f)};return function(k){f=arguments;d?e=!0:h()}};goog.functions.rateLimit=function(a,b,c){var d=0,e=function(){d=0};return function(f){d||(d=goog.global.setTimeout(e,b),a.apply(c,arguments))}};
goog.functions.isFunction=function(a){return"function"===typeof a};goog.dom.TagName=function(){};goog.dom.TagName.cast=function(a,b){return a};goog.dom.TagName.prototype.toString=function(){};goog.dom.TagName.A="A";goog.dom.TagName.ABBR="ABBR";goog.dom.TagName.ACRONYM="ACRONYM";goog.dom.TagName.ADDRESS="ADDRESS";goog.dom.TagName.APPLET="APPLET";goog.dom.TagName.AREA="AREA";goog.dom.TagName.ARTICLE="ARTICLE";goog.dom.TagName.ASIDE="ASIDE";goog.dom.TagName.AUDIO="AUDIO";goog.dom.TagName.B="B";goog.dom.TagName.BASE="BASE";goog.dom.TagName.BASEFONT="BASEFONT";
goog.dom.TagName.BDI="BDI";goog.dom.TagName.BDO="BDO";goog.dom.TagName.BIG="BIG";goog.dom.TagName.BLOCKQUOTE="BLOCKQUOTE";goog.dom.TagName.BODY="BODY";goog.dom.TagName.BR="BR";goog.dom.TagName.BUTTON="BUTTON";goog.dom.TagName.CANVAS="CANVAS";goog.dom.TagName.CAPTION="CAPTION";goog.dom.TagName.CENTER="CENTER";goog.dom.TagName.CITE="CITE";goog.dom.TagName.CODE="CODE";goog.dom.TagName.COL="COL";goog.dom.TagName.COLGROUP="COLGROUP";goog.dom.TagName.COMMAND="COMMAND";goog.dom.TagName.DATA="DATA";
goog.dom.TagName.DATALIST="DATALIST";goog.dom.TagName.DD="DD";goog.dom.TagName.DEL="DEL";goog.dom.TagName.DETAILS="DETAILS";goog.dom.TagName.DFN="DFN";goog.dom.TagName.DIALOG="DIALOG";goog.dom.TagName.DIR="DIR";goog.dom.TagName.DIV="DIV";goog.dom.TagName.DL="DL";goog.dom.TagName.DT="DT";goog.dom.TagName.EM="EM";goog.dom.TagName.EMBED="EMBED";goog.dom.TagName.FIELDSET="FIELDSET";goog.dom.TagName.FIGCAPTION="FIGCAPTION";goog.dom.TagName.FIGURE="FIGURE";goog.dom.TagName.FONT="FONT";
goog.dom.TagName.FOOTER="FOOTER";goog.dom.TagName.FORM="FORM";goog.dom.TagName.FRAME="FRAME";goog.dom.TagName.FRAMESET="FRAMESET";goog.dom.TagName.H1="H1";goog.dom.TagName.H2="H2";goog.dom.TagName.H3="H3";goog.dom.TagName.H4="H4";goog.dom.TagName.H5="H5";goog.dom.TagName.H6="H6";goog.dom.TagName.HEAD="HEAD";goog.dom.TagName.HEADER="HEADER";goog.dom.TagName.HGROUP="HGROUP";goog.dom.TagName.HR="HR";goog.dom.TagName.HTML="HTML";goog.dom.TagName.I="I";goog.dom.TagName.IFRAME="IFRAME";
goog.dom.TagName.IMG="IMG";goog.dom.TagName.INPUT="INPUT";goog.dom.TagName.INS="INS";goog.dom.TagName.ISINDEX="ISINDEX";goog.dom.TagName.KBD="KBD";goog.dom.TagName.KEYGEN="KEYGEN";goog.dom.TagName.LABEL="LABEL";goog.dom.TagName.LEGEND="LEGEND";goog.dom.TagName.LI="LI";goog.dom.TagName.LINK="LINK";goog.dom.TagName.MAIN="MAIN";goog.dom.TagName.MAP="MAP";goog.dom.TagName.MARK="MARK";goog.dom.TagName.MATH="MATH";goog.dom.TagName.MENU="MENU";goog.dom.TagName.MENUITEM="MENUITEM";goog.dom.TagName.META="META";
goog.dom.TagName.METER="METER";goog.dom.TagName.NAV="NAV";goog.dom.TagName.NOFRAMES="NOFRAMES";goog.dom.TagName.NOSCRIPT="NOSCRIPT";goog.dom.TagName.OBJECT="OBJECT";goog.dom.TagName.OL="OL";goog.dom.TagName.OPTGROUP="OPTGROUP";goog.dom.TagName.OPTION="OPTION";goog.dom.TagName.OUTPUT="OUTPUT";goog.dom.TagName.P="P";goog.dom.TagName.PARAM="PARAM";goog.dom.TagName.PICTURE="PICTURE";goog.dom.TagName.PRE="PRE";goog.dom.TagName.PROGRESS="PROGRESS";goog.dom.TagName.Q="Q";goog.dom.TagName.RP="RP";
goog.dom.TagName.RT="RT";goog.dom.TagName.RTC="RTC";goog.dom.TagName.RUBY="RUBY";goog.dom.TagName.S="S";goog.dom.TagName.SAMP="SAMP";goog.dom.TagName.SCRIPT="SCRIPT";goog.dom.TagName.SECTION="SECTION";goog.dom.TagName.SELECT="SELECT";goog.dom.TagName.SMALL="SMALL";goog.dom.TagName.SOURCE="SOURCE";goog.dom.TagName.SPAN="SPAN";goog.dom.TagName.STRIKE="STRIKE";goog.dom.TagName.STRONG="STRONG";goog.dom.TagName.STYLE="STYLE";goog.dom.TagName.SUB="SUB";goog.dom.TagName.SUMMARY="SUMMARY";
goog.dom.TagName.SUP="SUP";goog.dom.TagName.SVG="SVG";goog.dom.TagName.TABLE="TABLE";goog.dom.TagName.TBODY="TBODY";goog.dom.TagName.TD="TD";goog.dom.TagName.TEMPLATE="TEMPLATE";goog.dom.TagName.TEXTAREA="TEXTAREA";goog.dom.TagName.TFOOT="TFOOT";goog.dom.TagName.TH="TH";goog.dom.TagName.THEAD="THEAD";goog.dom.TagName.TIME="TIME";goog.dom.TagName.TITLE="TITLE";goog.dom.TagName.TR="TR";goog.dom.TagName.TRACK="TRACK";goog.dom.TagName.TT="TT";goog.dom.TagName.U="U";goog.dom.TagName.UL="UL";
goog.dom.TagName.VAR="VAR";goog.dom.TagName.VIDEO="VIDEO";goog.dom.TagName.WBR="WBR";goog.object={};goog.object.forEach=function(a,b,c){for(var d in a)b.call(c,a[d],d,a)};goog.object.filter=function(a,b,c){var d={},e;for(e in a)b.call(c,a[e],e,a)&&(d[e]=a[e]);return d};goog.object.map=function(a,b,c){var d={},e;for(e in a)d[e]=b.call(c,a[e],e,a);return d};goog.object.some=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return!0;return!1};goog.object.every=function(a,b,c){for(var d in a)if(!b.call(c,a[d],d,a))return!1;return!0};
goog.object.getCount=function(a){var b=0,c;for(c in a)b++;return b};goog.object.getAnyKey=function(a){for(var b in a)return b};goog.object.getAnyValue=function(a){for(var b in a)return a[b]};goog.object.contains=function(a,b){return goog.object.containsValue(a,b)};goog.object.getValues=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b};goog.object.getKeys=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b};
goog.object.getValueByKeys=function(a,b){var c=goog.isArrayLike(b),d=c?b:arguments;for(c=c?0:1;c<d.length;c++){if(null==a)return;a=a[d[c]]}return a};goog.object.containsKey=function(a,b){return null!==a&&b in a};goog.object.containsValue=function(a,b){for(var c in a)if(a[c]==b)return!0;return!1};goog.object.findKey=function(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d};goog.object.findValue=function(a,b,c){return(b=goog.object.findKey(a,b,c))&&a[b]};
goog.object.isEmpty=function(a){for(var b in a)return!1;return!0};goog.object.clear=function(a){for(var b in a)delete a[b]};goog.object.remove=function(a,b){var c;(c=b in a)&&delete a[b];return c};goog.object.add=function(a,b,c){if(null!==a&&b in a)throw Error('The object already contains the key "'+b+'"');goog.object.set(a,b,c)};goog.object.get=function(a,b,c){return null!==a&&b in a?a[b]:c};goog.object.set=function(a,b,c){a[b]=c};
goog.object.setIfUndefined=function(a,b,c){return b in a?a[b]:a[b]=c};goog.object.setWithReturnValueIfNotSet=function(a,b,c){if(b in a)return a[b];c=c();return a[b]=c};goog.object.equals=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(var d in b)if(!(d in a))return!1;return!0};goog.object.clone=function(a){var b={},c;for(c in a)b[c]=a[c];return b};
goog.object.unsafeClone=function(a){if(!a||"object"!==typeof a)return a;if("function"===typeof a.clone)return a.clone();var b=Array.isArray(a)?[]:"function"!==typeof ArrayBuffer||"function"!==typeof ArrayBuffer.isView||!ArrayBuffer.isView(a)||a instanceof DataView?{}:new a.constructor(a.length),c;for(c in a)b[c]=goog.object.unsafeClone(a[c]);return b};goog.object.transpose=function(a){var b={},c;for(c in a)b[a[c]]=c;return b};goog.object.PROTOTYPE_FIELDS_="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<goog.object.PROTOTYPE_FIELDS_.length;f++)c=goog.object.PROTOTYPE_FIELDS_[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};
goog.object.create=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.create.apply(null,arguments[0]);if(b%2)throw Error("Uneven number of arguments");for(var c={},d=0;d<b;d+=2)c[arguments[d]]=arguments[d+1];return c};goog.object.createSet=function(a){var b=arguments.length;if(1==b&&Array.isArray(arguments[0]))return goog.object.createSet.apply(null,arguments[0]);for(var c={},d=0;d<b;d++)c[arguments[d]]=!0;return c};
goog.object.createImmutableView=function(a){var b=a;Object.isFrozen&&!Object.isFrozen(a)&&(b=Object.create(a),Object.freeze(b));return b};goog.object.isImmutableView=function(a){return!!Object.isFrozen&&Object.isFrozen(a)};
goog.object.getAllPropertyNames=function(a,b,c){if(!a)return[];if(!Object.getOwnPropertyNames||!Object.getPrototypeOf)return goog.object.getKeys(a);for(var d={};a&&(a!==Object.prototype||b)&&(a!==Function.prototype||c);){for(var e=Object.getOwnPropertyNames(a),f=0;f<e.length;f++)d[e[f]]=!0;a=Object.getPrototypeOf(a)}return goog.object.getKeys(d)};goog.object.getSuperClass=function(a){return(a=Object.getPrototypeOf(a.prototype))&&a.constructor};goog.dom.tags={};goog.dom.tags.VOID_TAGS_={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};goog.dom.tags.isVoidTag=function(a){return!0===goog.dom.tags.VOID_TAGS_[a]};goog.string={};goog.string.TypedString=function(){};goog.string.Const=function(a,b){this.stringConstValueWithSecurityContract__googStringSecurityPrivate_=a===goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_&&b||"";this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_=goog.string.Const.TYPE_MARKER_};goog.string.Const.prototype.implementsGoogStringTypedString=!0;goog.string.Const.prototype.getTypedStringValue=function(){return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_};
goog.DEBUG&&(goog.string.Const.prototype.toString=function(){return"Const{"+this.stringConstValueWithSecurityContract__googStringSecurityPrivate_+"}"});goog.string.Const.unwrap=function(a){if(a instanceof goog.string.Const&&a.constructor===goog.string.Const&&a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_===goog.string.Const.TYPE_MARKER_)return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;goog.asserts.fail("expected object of type Const, got '"+a+"'");return"type_error:Const"};
goog.string.Const.from=function(a){return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_,a)};goog.string.Const.TYPE_MARKER_={};goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_={};goog.string.Const.EMPTY=goog.string.Const.from("");goog.html={};goog.html.trustedtypes={};goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse=function(){if(!goog.TRUSTED_TYPES_POLICY_NAME)return null;void 0===goog.html.trustedtypes.cachedPolicy_&&(goog.html.trustedtypes.cachedPolicy_=goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME+"#html"));return goog.html.trustedtypes.cachedPolicy_};var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeScript_SafeScript=function(a,b){this.privateDoNotAccessOrElseSafeScriptWrappedValue_=b===module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};module$contents$goog$html$SafeScript_SafeScript.fromConstant=function(a){a=goog.string.Const.unwrap(a);return 0===a.length?module$contents$goog$html$SafeScript_SafeScript.EMPTY:module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs=function(a,b){for(var c=[],d=1;d<arguments.length;d++)c.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[d]));return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("("+goog.string.Const.unwrap(a)+")("+c.join(", ")+");")};module$contents$goog$html$SafeScript_SafeScript.fromJson=function(a){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(a))};
module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString()};module$contents$goog$html$SafeScript_SafeScript.unwrap=function(a){return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(a).toString()};
module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript=function(a){if(a instanceof module$contents$goog$html$SafeScript_SafeScript&&a.constructor===module$contents$goog$html$SafeScript_SafeScript)return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeScript, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeScript"};
module$contents$goog$html$SafeScript_SafeScript.stringify_=function(a){return JSON.stringify(a).replace(/</g,"\\x3c")};module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScript(a):a;return new module$contents$goog$html$SafeScript_SafeScript(a,module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE)};
goog.DEBUG&&(module$contents$goog$html$SafeScript_SafeScript.prototype.toString=function(){return"SafeScript{"+this.privateDoNotAccessOrElseSafeScriptWrappedValue_+"}"});module$contents$goog$html$SafeScript_SafeScript.EMPTY=function(){return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("")}();goog.html.SafeScript=module$contents$goog$html$SafeScript_SafeScript;goog.fs={};goog.fs.url={};goog.fs.url.createObjectUrl=function(a){return goog.fs.url.getUrlObject_().createObjectURL(a)};goog.fs.url.revokeObjectUrl=function(a){goog.fs.url.getUrlObject_().revokeObjectURL(a)};goog.fs.url.UrlObject_=function(){};goog.fs.url.UrlObject_.prototype.createObjectURL=function(a){};goog.fs.url.UrlObject_.prototype.revokeObjectURL=function(a){};
goog.fs.url.getUrlObject_=function(){var a=goog.fs.url.findUrlObject_();if(null!=a)return a;throw Error("This browser doesn't seem to support blob URLs");};goog.fs.url.findUrlObject_=function(){return void 0!==goog.global.URL&&void 0!==goog.global.URL.createObjectURL?goog.global.URL:void 0!==goog.global.webkitURL&&void 0!==goog.global.webkitURL.createObjectURL?goog.global.webkitURL:void 0!==goog.global.createObjectURL?goog.global:null};
goog.fs.url.browserSupportsObjectUrls=function(){return null!=goog.fs.url.findUrlObject_()};goog.fs.blob={};goog.fs.blob.getBlob=function(a){var b=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==b){b=new b;for(var c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments))};
goog.fs.blob.getBlobWithProperties=function(a,b,c){var d=goog.global.BlobBuilder||goog.global.WebKitBlobBuilder;if(void 0!==d){d=new d;for(var e=0;e<a.length;e++)d.append(a[e],c);return d.getBlob(b)}if(void 0!==goog.global.Blob)return d={},b&&(d.type=b),c&&(d.endings=c),new Blob(a,d);throw Error("This browser doesn't seem to support creating Blobs");};goog.i18n={};goog.i18n.bidi={};goog.i18n.bidi.FORCE_RTL=!1;
goog.i18n.bidi.IS_RTL=goog.i18n.bidi.FORCE_RTL||("ar"==goog.LOCALE.substring(0,2).toLowerCase()||"fa"==goog.LOCALE.substring(0,2).toLowerCase()||"he"==goog.LOCALE.substring(0,2).toLowerCase()||"iw"==goog.LOCALE.substring(0,2).toLowerCase()||"ps"==goog.LOCALE.substring(0,2).toLowerCase()||"sd"==goog.LOCALE.substring(0,2).toLowerCase()||"ug"==goog.LOCALE.substring(0,2).toLowerCase()||"ur"==goog.LOCALE.substring(0,2).toLowerCase()||"yi"==goog.LOCALE.substring(0,2).toLowerCase())&&(2==goog.LOCALE.length||
"-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))||3<=goog.LOCALE.length&&"ckb"==goog.LOCALE.substring(0,3).toLowerCase()&&(3==goog.LOCALE.length||"-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))||7<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(2,3)||"_"==goog.LOCALE.substring(2,3))&&("adlm"==goog.LOCALE.substring(3,7).toLowerCase()||"arab"==goog.LOCALE.substring(3,7).toLowerCase()||"hebr"==goog.LOCALE.substring(3,7).toLowerCase()||"nkoo"==goog.LOCALE.substring(3,
7).toLowerCase()||"rohg"==goog.LOCALE.substring(3,7).toLowerCase()||"thaa"==goog.LOCALE.substring(3,7).toLowerCase())||8<=goog.LOCALE.length&&("-"==goog.LOCALE.substring(3,4)||"_"==goog.LOCALE.substring(3,4))&&("adlm"==goog.LOCALE.substring(4,8).toLowerCase()||"arab"==goog.LOCALE.substring(4,8).toLowerCase()||"hebr"==goog.LOCALE.substring(4,8).toLowerCase()||"nkoo"==goog.LOCALE.substring(4,8).toLowerCase()||"rohg"==goog.LOCALE.substring(4,8).toLowerCase()||"thaa"==goog.LOCALE.substring(4,8).toLowerCase());
goog.i18n.bidi.Format={LRE:"\u202a",RLE:"\u202b",PDF:"\u202c",LRM:"\u200e",RLM:"\u200f"};goog.i18n.bidi.Dir={LTR:1,RTL:-1,NEUTRAL:0};goog.i18n.bidi.RIGHT="right";goog.i18n.bidi.LEFT="left";goog.i18n.bidi.I18N_RIGHT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.LEFT:goog.i18n.bidi.RIGHT;goog.i18n.bidi.I18N_LEFT=goog.i18n.bidi.IS_RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir=function(a,b){return"number"==typeof a?0<a?goog.i18n.bidi.Dir.LTR:0>a?goog.i18n.bidi.Dir.RTL:b?null:goog.i18n.bidi.Dir.NEUTRAL:null==a?null:a?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};goog.i18n.bidi.ltrChars_="A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0900-\u1fff\u200e\u2c00-\ud801\ud804-\ud839\ud83c-\udbff\uf900-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";goog.i18n.bidi.rtlChars_="\u0591-\u06ef\u06fa-\u08ff\u200f\ud802-\ud803\ud83a-\ud83b\ufb1d-\ufdff\ufe70-\ufefc";
goog.i18n.bidi.htmlSkipReg_=/<[^>]*>|&[^;]+;/g;goog.i18n.bidi.stripHtmlIfNeeded_=function(a,b){return b?a.replace(goog.i18n.bidi.htmlSkipReg_,""):a};goog.i18n.bidi.rtlCharReg_=new RegExp("["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.ltrCharReg_=new RegExp("["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.hasAnyRtl=function(a,b){return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.hasRtlChar=goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr=function(a,b){return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.ltrRe_=new RegExp("^["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlRe_=new RegExp("^["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.isRtlChar=function(a){return goog.i18n.bidi.rtlRe_.test(a)};goog.i18n.bidi.isLtrChar=function(a){return goog.i18n.bidi.ltrRe_.test(a)};goog.i18n.bidi.isNeutralChar=function(a){return!goog.i18n.bidi.isLtrChar(a)&&!goog.i18n.bidi.isRtlChar(a)};
goog.i18n.bidi.ltrDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.rtlChars_+"]*["+goog.i18n.bidi.ltrChars_+"]");goog.i18n.bidi.rtlDirCheckRe_=new RegExp("^[^"+goog.i18n.bidi.ltrChars_+"]*["+goog.i18n.bidi.rtlChars_+"]");goog.i18n.bidi.startsWithRtl=function(a,b){return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlText=goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr=function(a,b){return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrText=goog.i18n.bidi.startsWithLtr;goog.i18n.bidi.isRequiredLtrRe_=/^http:\/\/.*/;goog.i18n.bidi.isNeutralText=function(a,b){a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b);return goog.i18n.bidi.isRequiredLtrRe_.test(a)||!goog.i18n.bidi.hasAnyLtr(a)&&!goog.i18n.bidi.hasAnyRtl(a)};
goog.i18n.bidi.ltrExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.ltrChars_+"][^"+goog.i18n.bidi.rtlChars_+"]*$");goog.i18n.bidi.rtlExitDirCheckRe_=new RegExp("["+goog.i18n.bidi.rtlChars_+"][^"+goog.i18n.bidi.ltrChars_+"]*$");goog.i18n.bidi.endsWithLtr=function(a,b){return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isLtrExitText=goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl=function(a,b){return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a,b))};goog.i18n.bidi.isRtlExitText=goog.i18n.bidi.endsWithRtl;goog.i18n.bidi.rtlLocalesRe_=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;goog.i18n.bidi.isRtlLanguage=function(a){return goog.i18n.bidi.rtlLocalesRe_.test(a)};goog.i18n.bidi.bracketGuardTextRe_=/(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText=function(a,b){b=(void 0===b?goog.i18n.bidi.hasAnyRtl(a):b)?goog.i18n.bidi.Format.RLM:goog.i18n.bidi.Format.LRM;return a.replace(goog.i18n.bidi.bracketGuardTextRe_,b+"$&"+b)};goog.i18n.bidi.enforceRtlInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=rtl"):"\n<span dir=rtl>"+a+"</span>"};goog.i18n.bidi.enforceRtlInText=function(a){return goog.i18n.bidi.Format.RLE+a+goog.i18n.bidi.Format.PDF};
goog.i18n.bidi.enforceLtrInHtml=function(a){return"<"==a.charAt(0)?a.replace(/<\w+/,"$& dir=ltr"):"\n<span dir=ltr>"+a+"</span>"};goog.i18n.bidi.enforceLtrInText=function(a){return goog.i18n.bidi.Format.LRE+a+goog.i18n.bidi.Format.PDF};goog.i18n.bidi.dimensionsRe_=/:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;goog.i18n.bidi.leftRe_=/left/gi;goog.i18n.bidi.rightRe_=/right/gi;goog.i18n.bidi.tempRe_=/%%%%/g;
goog.i18n.bidi.mirrorCSS=function(a){return a.replace(goog.i18n.bidi.dimensionsRe_,":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_,"%%%%").replace(goog.i18n.bidi.rightRe_,goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_,goog.i18n.bidi.RIGHT)};goog.i18n.bidi.doubleQuoteSubstituteRe_=/([\u0591-\u05f2])"/g;goog.i18n.bidi.singleQuoteSubstituteRe_=/([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote=function(a){return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_,"$1\u05f4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_,"$1\u05f3")};goog.i18n.bidi.wordSeparatorRe_=/\s+/;goog.i18n.bidi.hasNumeralsRe_=/[\d\u06f0-\u06f9]/;goog.i18n.bidi.rtlDetectionThreshold_=.4;
goog.i18n.bidi.estimateDirection=function(a,b){var c=0,d=0,e=!1;a=goog.i18n.bidi.stripHtmlIfNeeded_(a,b).split(goog.i18n.bidi.wordSeparatorRe_);for(b=0;b<a.length;b++){var f=a[b];goog.i18n.bidi.startsWithRtl(f)?(c++,d++):goog.i18n.bidi.isRequiredLtrRe_.test(f)?e=!0:goog.i18n.bidi.hasAnyLtr(f)?d++:goog.i18n.bidi.hasNumeralsRe_.test(f)&&(e=!0)}return 0==d?e?goog.i18n.bidi.Dir.LTR:goog.i18n.bidi.Dir.NEUTRAL:c/d>goog.i18n.bidi.rtlDetectionThreshold_?goog.i18n.bidi.Dir.RTL:goog.i18n.bidi.Dir.LTR};
goog.i18n.bidi.detectRtlDirectionality=function(a,b){return goog.i18n.bidi.estimateDirection(a,b)==goog.i18n.bidi.Dir.RTL};goog.i18n.bidi.setElementDirAndAlign=function(a,b){a&&(b=goog.i18n.bidi.toDir(b))&&(a.style.textAlign=b==goog.i18n.bidi.Dir.RTL?goog.i18n.bidi.RIGHT:goog.i18n.bidi.LEFT,a.dir=b==goog.i18n.bidi.Dir.RTL?"rtl":"ltr")};
goog.i18n.bidi.setElementDirByTextDirectionality=function(a,b){switch(goog.i18n.bidi.estimateDirection(b)){case goog.i18n.bidi.Dir.LTR:"ltr"!==a.dir&&(a.dir="ltr");break;case goog.i18n.bidi.Dir.RTL:"rtl"!==a.dir&&(a.dir="rtl");break;default:a.removeAttribute("dir")}};goog.i18n.bidi.DirectionalString=function(){};goog.html.TrustedResourceUrl=function(a,b){this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_=b===goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString=!0;goog.html.TrustedResourceUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString()};goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.TrustedResourceUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.html.TrustedResourceUrl.prototype.cloneWithParams=function(a,b){var c=goog.html.TrustedResourceUrl.unwrap(this);c=goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);var d=c[3]||"";return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1]+goog.html.TrustedResourceUrl.stringifyParams_("?",c[2]||"",a)+goog.html.TrustedResourceUrl.stringifyParams_("#",d,b))};
goog.DEBUG&&(goog.html.TrustedResourceUrl.prototype.toString=function(){return"TrustedResourceUrl{"+this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_+"}"});goog.html.TrustedResourceUrl.unwrap=function(a){return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString()};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL=function(a){if(a instanceof goog.html.TrustedResourceUrl&&a.constructor===goog.html.TrustedResourceUrl)return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;goog.asserts.fail("expected object of type TrustedResourceUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:TrustedResourceUrl"};
goog.html.TrustedResourceUrl.format=function(a,b){var c=goog.string.Const.unwrap(a);if(!goog.html.TrustedResourceUrl.BASE_URL_.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof goog.string.Const?goog.string.Const.unwrap(d):
encodeURIComponent(String(d))});return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.FORMAT_MARKER_=/%{(\w+)}/g;goog.html.TrustedResourceUrl.BASE_URL_=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;goog.html.TrustedResourceUrl.URL_PARAM_PARSER_=/^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams=function(a,b,c,d){return goog.html.TrustedResourceUrl.format(a,b).cloneWithParams(c,d)};goog.html.TrustedResourceUrl.fromConstant=function(a){return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.TrustedResourceUrl.fromConstants=function(a){for(var b="",c=0;c<a.length;c++)b+=goog.string.Const.unwrap(a[c]);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.TrustedResourceUrl.fromSafeScript=function(a){a=goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(a)],"text/javascript");a=goog.fs.url.createObjectUrl(a);return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse=function(a){var b=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=b?b.createScriptURL(a):a;return new goog.html.TrustedResourceUrl(a,goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.TrustedResourceUrl.stringifyParams_=function(a,b,c){if(null==c)return b;if("string"===typeof c)return c?a+encodeURIComponent(c):"";for(var d in c)if(Object.prototype.hasOwnProperty.call(c,d)){var e=c[d];e=Array.isArray(e)?e:[e];for(var f=0;f<e.length;f++){var g=e[f];null!=g&&(b||(b=a),b+=(b.length>a.length?"&":"")+encodeURIComponent(d)+"="+encodeURIComponent(String(g)))}}return b};goog.string.internal={};goog.string.internal.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};goog.string.internal.endsWith=function(a,b){var c=a.length-b.length;return 0<=c&&a.indexOf(b,c)==c};goog.string.internal.caseInsensitiveStartsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(0,b.length))};goog.string.internal.caseInsensitiveEndsWith=function(a,b){return 0==goog.string.internal.caseInsensitiveCompare(b,a.substr(a.length-b.length,b.length))};
goog.string.internal.caseInsensitiveEquals=function(a,b){return a.toLowerCase()==b.toLowerCase()};goog.string.internal.isEmptyOrWhitespace=function(a){return/^[\s\xa0]*$/.test(a)};goog.string.internal.trim=goog.TRUSTED_SITE&&String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};goog.string.internal.caseInsensitiveCompare=function(a,b){a=String(a).toLowerCase();b=String(b).toLowerCase();return a<b?-1:a==b?0:1};
goog.string.internal.newLineToBr=function(a,b){return a.replace(/(\r\n|\r|\n)/g,b?"<br />":"<br>")};
goog.string.internal.htmlEscape=function(a,b){if(b)a=a.replace(goog.string.internal.AMP_RE_,"&amp;").replace(goog.string.internal.LT_RE_,"&lt;").replace(goog.string.internal.GT_RE_,"&gt;").replace(goog.string.internal.QUOT_RE_,"&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;").replace(goog.string.internal.NULL_RE_,"&#0;");else{if(!goog.string.internal.ALL_RE_.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(goog.string.internal.AMP_RE_,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(goog.string.internal.LT_RE_,
"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(goog.string.internal.GT_RE_,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(goog.string.internal.QUOT_RE_,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(goog.string.internal.SINGLE_QUOTE_RE_,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(goog.string.internal.NULL_RE_,"&#0;"))}return a};goog.string.internal.AMP_RE_=/&/g;goog.string.internal.LT_RE_=/</g;goog.string.internal.GT_RE_=/>/g;goog.string.internal.QUOT_RE_=/"/g;goog.string.internal.SINGLE_QUOTE_RE_=/'/g;
goog.string.internal.NULL_RE_=/\x00/g;goog.string.internal.ALL_RE_=/[\x00&<>"']/;goog.string.internal.whitespaceEscape=function(a,b){return goog.string.internal.newLineToBr(a.replace(/  /g," &#160;"),b)};goog.string.internal.contains=function(a,b){return-1!=a.indexOf(b)};goog.string.internal.caseInsensitiveContains=function(a,b){return goog.string.internal.contains(a.toLowerCase(),b.toLowerCase())};
goog.string.internal.compareVersions=function(a,b){var c=0;a=goog.string.internal.trim(String(a)).split(".");b=goog.string.internal.trim(String(b)).split(".");for(var d=Math.max(a.length,b.length),e=0;0==c&&e<d;e++){var f=a[e]||"",g=b[e]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];if(0==f[0].length&&0==g[0].length)break;c=0==f[1].length?0:parseInt(f[1],10);var h=0==g[1].length?0:parseInt(g[1],10);c=goog.string.internal.compareElements_(c,h)||goog.string.internal.compareElements_(0==
f[2].length,0==g[2].length)||goog.string.internal.compareElements_(f[2],g[2]);f=f[3];g=g[3]}while(0==c)}return c};goog.string.internal.compareElements_=function(a,b){return a<b?-1:a>b?1:0};goog.html.SafeUrl=function(a,b){this.privateDoNotAccessOrElseSafeUrlWrappedValue_=b===goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeUrl.INNOCUOUS_STRING="about:invalid#zClosurez";goog.html.SafeUrl.prototype.implementsGoogStringTypedString=!0;goog.html.SafeUrl.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString()};goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString=!0;
goog.html.SafeUrl.prototype.getDirection=function(){return goog.i18n.bidi.Dir.LTR};goog.DEBUG&&(goog.html.SafeUrl.prototype.toString=function(){return"SafeUrl{"+this.privateDoNotAccessOrElseSafeUrlWrappedValue_+"}"});goog.html.SafeUrl.unwrap=function(a){if(a instanceof goog.html.SafeUrl&&a.constructor===goog.html.SafeUrl)return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;goog.asserts.fail("expected object of type SafeUrl, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeUrl"};
goog.html.SafeUrl.fromConstant=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a))};goog.html.SAFE_MIME_TYPE_PATTERN_=/^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i;goog.html.SafeUrl.isSafeMimeType=function(a){return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a)};
goog.html.SafeUrl.fromBlob=function(a){a=goog.html.SafeUrl.isSafeMimeType(a.type)?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.revokeObjectUrl=function(a){a=a.getTypedStringValue();a!==goog.html.SafeUrl.INNOCUOUS_STRING&&goog.fs.url.revokeObjectUrl(a)};
goog.html.SafeUrl.fromMediaSource=function(a){goog.asserts.assert("MediaSource"in goog.global,"No support for MediaSource");a=a instanceof MediaSource?goog.fs.url.createObjectUrl(a):goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.DATA_URL_PATTERN_=/^data:(.*);base64,[a-z0-9+\/]+=*$/i;
goog.html.SafeUrl.tryFromDataUrl=function(a){a=String(a);a=a.replace(/(%0A|%0D)/g,"");var b=a.match(goog.html.DATA_URL_PATTERN_);return b&&goog.html.SafeUrl.isSafeMimeType(b[1])?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):null};goog.html.SafeUrl.fromDataUrl=function(a){return goog.html.SafeUrl.tryFromDataUrl(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.fromTelUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"tel:")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SIP_URL_PATTERN_=/^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;goog.html.SafeUrl.fromSipUrl=function(a){goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a))||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromFacebookMessengerUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"fb-messenger://share")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.fromWhatsAppUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"whatsapp://send")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.fromSmsUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"sms:")&&goog.html.SafeUrl.isSmsUrlBodyValid_(a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.isSmsUrlBodyValid_=function(a){var b=a.indexOf("#");0<b&&(a=a.substring(0,b));b=a.match(/[?&]body=/gi);if(!b)return!0;if(1<b.length)return!1;a=a.match(/[?&]body=([^&]*)/)[1];if(!a)return!0;try{decodeURIComponent(a)}catch(c){return!1}return/^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a)};
goog.html.SafeUrl.fromSshUrl=function(a){goog.string.internal.caseInsensitiveStartsWith(a,"ssh://")||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};goog.html.SafeUrl.sanitizeChromeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeFirefoxExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//,a,b)};goog.html.SafeUrl.sanitizeEdgeExtensionUrl=function(a,b){return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//,a,b)};
goog.html.SafeUrl.sanitizeExtensionUrl_=function(a,b,c){(a=a.exec(b))?(a=a[1],-1==(c instanceof goog.string.Const?[goog.string.Const.unwrap(c)]:c.map(function(d){return goog.string.Const.unwrap(d)})).indexOf(a)&&(b=goog.html.SafeUrl.INNOCUOUS_STRING)):b=goog.html.SafeUrl.INNOCUOUS_STRING;return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};goog.html.SafeUrl.fromTrustedResourceUrl=function(a){return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a))};
goog.html.SAFE_URL_PATTERN_=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;goog.html.SafeUrl.SAFE_URL_PATTERN=goog.html.SAFE_URL_PATTERN_;goog.html.SafeUrl.trySanitize=function(a){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SAFE_URL_PATTERN_.test(a)?goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a):goog.html.SafeUrl.tryFromDataUrl(a)};
goog.html.SafeUrl.sanitize=function(a){return goog.html.SafeUrl.trySanitize(a)||goog.html.SafeUrl.INNOCUOUS_URL};
goog.html.SafeUrl.sanitizeAssertUnchanged=function(a,b){if(a instanceof goog.html.SafeUrl)return a;a="object"==typeof a&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);if(b&&/^data:/i.test(a)&&(b=goog.html.SafeUrl.fromDataUrl(a),b.getTypedStringValue()==a))return b;goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a),"%s does not match the safe URL pattern",a)||(a=goog.html.SafeUrl.INNOCUOUS_STRING);return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeUrl(a,goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_)};goog.html.SafeUrl.INNOCUOUS_URL=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING);goog.html.SafeUrl.ABOUT_BLANK=goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");goog.html.SafeStyle=function(a,b){this.privateDoNotAccessOrElseSafeStyleWrappedValue_=b===goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_?a:""};goog.html.SafeStyle.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeStyle.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return goog.html.SafeStyle.EMPTY;goog.asserts.assert(goog.string.internal.endsWith(a,";"),"Last character of style string is not ';': "+a);goog.asserts.assert(goog.string.internal.contains(a,":"),"Style string must contain at least one ':', to specify a \"name: value\" pair: "+a);return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a)};
goog.html.SafeStyle.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleWrappedValue_};goog.DEBUG&&(goog.html.SafeStyle.prototype.toString=function(){return"SafeStyle{"+this.privateDoNotAccessOrElseSafeStyleWrappedValue_+"}"});
goog.html.SafeStyle.unwrap=function(a){if(a instanceof goog.html.SafeStyle&&a.constructor===goog.html.SafeStyle)return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;goog.asserts.fail("expected object of type SafeStyle, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyle"};goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_={};goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse=function(a){return new goog.html.SafeStyle(a,goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeStyle.EMPTY=goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyle.INNOCUOUS_STRING="zClosurez";
goog.html.SafeStyle.create=function(a){var b="",c;for(c in a)if(Object.prototype.hasOwnProperty.call(a,c)){if(!/^[-_a-zA-Z0-9]+$/.test(c))throw Error("Name allows only [-_a-zA-Z0-9], got: "+c);var d=a[c];null!=d&&(d=Array.isArray(d)?module$contents$goog$array_map(d,goog.html.SafeStyle.sanitizePropertyValue_).join(" "):goog.html.SafeStyle.sanitizePropertyValue_(d),b+=c+":"+d+";")}return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};
goog.html.SafeStyle.sanitizePropertyValue_=function(a){if(a instanceof goog.html.SafeUrl)return'url("'+goog.html.SafeUrl.unwrap(a).replace(/</g,"%3c").replace(/[\\"]/g,"\\$&")+'")';a=a instanceof goog.string.Const?goog.string.Const.unwrap(a):goog.html.SafeStyle.sanitizePropertyValueString_(String(a));if(/[{;}]/.test(a))throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.",[a]);return a};
goog.html.SafeStyle.sanitizePropertyValueString_=function(a){var b=a.replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_,"$1").replace(goog.html.SafeStyle.URL_RE_,"url");if(goog.html.SafeStyle.VALUE_RE_.test(b)){if(goog.html.SafeStyle.COMMENT_RE_.test(a))return goog.asserts.fail("String value disallows comments, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedQuotes_(a))return goog.asserts.fail("String value requires balanced quotes, got: "+
a),goog.html.SafeStyle.INNOCUOUS_STRING;if(!goog.html.SafeStyle.hasBalancedSquareBrackets_(a))return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING}else return goog.asserts.fail("String value allows only "+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+" and simple functions, got: "+a),goog.html.SafeStyle.INNOCUOUS_STRING;return goog.html.SafeStyle.sanitizeUrl_(a)};
goog.html.SafeStyle.hasBalancedQuotes_=function(a){for(var b=!0,c=!0,d=0;d<a.length;d++){var e=a.charAt(d);"'"==e&&c?b=!b:'"'==e&&b&&(c=!c)}return b&&c};goog.html.SafeStyle.hasBalancedSquareBrackets_=function(a){for(var b=!0,c=/^[-_a-zA-Z0-9]$/,d=0;d<a.length;d++){var e=a.charAt(d);if("]"==e){if(b)return!1;b=!0}else if("["==e){if(!b)return!1;b=!1}else if(!b&&!c.test(e))return!1}return b};goog.html.SafeStyle.VALUE_ALLOWED_CHARS_="[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_=new RegExp("^"+goog.html.SafeStyle.VALUE_ALLOWED_CHARS_+"+$");goog.html.SafeStyle.URL_RE_=/\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;goog.html.SafeStyle.ALLOWED_FUNCTIONS_="calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" ");
goog.html.SafeStyle.FUNCTIONS_RE_=new RegExp("\\b("+goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|")+")\\([-+*/0-9a-z.%\\[\\], ]+\\)","g");goog.html.SafeStyle.COMMENT_RE_=/\/\*/;goog.html.SafeStyle.sanitizeUrl_=function(a){return a.replace(goog.html.SafeStyle.URL_RE_,function(b,c,d,e){var f="";d=d.replace(/^(['"])(.*)\1$/,function(g,h,k){f=h;return k});b=goog.html.SafeUrl.sanitize(d).getTypedStringValue();return c+f+b+f+e})};
goog.html.SafeStyle.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=goog.html.SafeStyle.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return b?goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b):goog.html.SafeStyle.EMPTY};var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE={},module$contents$goog$html$SafeStyleSheet_SafeStyleSheet=function(a,b){this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_=b===module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE?a:"";this.implementsGoogStringTypedString=!0};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule=function(a,b){if((0,goog.string.internal.contains)(a,"<"))throw Error("Selector does not allow '<', got: "+a);var c=a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g,"");if(!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: "+a);if(!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(c))throw Error("() and [] in selector must be balanced, got: "+
a);b instanceof goog.html.SafeStyle||(b=goog.html.SafeStyle.create(b));a=a+"{"+goog.html.SafeStyle.unwrap(b).replace(/</g,"\\3C ")+"}";return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_=function(a){for(var b={"(":")","[":"]"},c=[],d=0;d<a.length;d++){var e=a[d];if(b[e])c.push(b[e]);else if(goog.object.contains(b,e)&&c.pop()!=e)return!1}return 0==c.length};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat=function(a){var b="",c=function(d){Array.isArray(d)?module$contents$goog$array_forEach(d,c):b+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(d)};module$contents$goog$array_forEach(arguments,c);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant=function(a){a=goog.string.Const.unwrap(a);if(0===a.length)return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY;(0,goog.asserts.assert)(!(0,goog.string.internal.contains)(a,"<"),"Forbidden '<' character in style sheet string: "+a);return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a)};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap=function(a){if(a instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet&&a.constructor===module$contents$goog$html$SafeStyleSheet_SafeStyleSheet)return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;(0,goog.asserts.fail)("expected object of type SafeStyleSheet, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeStyleSheet"};
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse=function(a){return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(a,module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE)};goog.DEBUG&&(module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString=function(){return"SafeStyleSheet{"+this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_+"}"});
module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");goog.html.SafeStyleSheet=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet;goog.labs={};goog.labs.userAgent={};goog.labs.userAgent.util={};goog.labs.userAgent.util.getNativeUserAgentString_=function(){var a=goog.labs.userAgent.util.getNavigator_();return a&&(a=a.userAgent)?a:""};goog.labs.userAgent.util.getNavigator_=function(){return goog.global.navigator};goog.labs.userAgent.util.userAgent_=goog.labs.userAgent.util.getNativeUserAgentString_();goog.labs.userAgent.util.setUserAgent=function(a){goog.labs.userAgent.util.userAgent_=a||goog.labs.userAgent.util.getNativeUserAgentString_()};
goog.labs.userAgent.util.getUserAgent=function(){return goog.labs.userAgent.util.userAgent_};goog.labs.userAgent.util.matchUserAgent=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.contains(b,a)};goog.labs.userAgent.util.matchUserAgentIgnoreCase=function(a){var b=goog.labs.userAgent.util.getUserAgent();return goog.string.internal.caseInsensitiveContains(b,a)};
goog.labs.userAgent.util.extractVersionTuples=function(a){for(var b=/(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g,c=[],d;d=b.exec(a);)c.push([d[1],d[2],d[3]||void 0]);return c};goog.labs.userAgent.browser={};goog.labs.userAgent.browser.matchOpera_=function(){return goog.labs.userAgent.util.matchUserAgent("Opera")};goog.labs.userAgent.browser.matchIE_=function(){return goog.labs.userAgent.util.matchUserAgent("Trident")||goog.labs.userAgent.util.matchUserAgent("MSIE")};goog.labs.userAgent.browser.matchEdgeHtml_=function(){return goog.labs.userAgent.util.matchUserAgent("Edge")};goog.labs.userAgent.browser.matchEdgeChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("Edg/")};
goog.labs.userAgent.browser.matchOperaChromium_=function(){return goog.labs.userAgent.util.matchUserAgent("OPR")};goog.labs.userAgent.browser.matchFirefox_=function(){return goog.labs.userAgent.util.matchUserAgent("Firefox")||goog.labs.userAgent.util.matchUserAgent("FxiOS")};
goog.labs.userAgent.browser.matchSafari_=function(){return goog.labs.userAgent.util.matchUserAgent("Safari")&&!(goog.labs.userAgent.browser.matchChrome_()||goog.labs.userAgent.browser.matchCoast_()||goog.labs.userAgent.browser.matchOpera_()||goog.labs.userAgent.browser.matchEdgeHtml_()||goog.labs.userAgent.browser.matchEdgeChromium_()||goog.labs.userAgent.browser.matchOperaChromium_()||goog.labs.userAgent.browser.matchFirefox_()||goog.labs.userAgent.browser.isSilk()||goog.labs.userAgent.util.matchUserAgent("Android"))};
goog.labs.userAgent.browser.matchCoast_=function(){return goog.labs.userAgent.util.matchUserAgent("Coast")};goog.labs.userAgent.browser.matchIosWebview_=function(){return(goog.labs.userAgent.util.matchUserAgent("iPad")||goog.labs.userAgent.util.matchUserAgent("iPhone"))&&!goog.labs.userAgent.browser.matchSafari_()&&!goog.labs.userAgent.browser.matchChrome_()&&!goog.labs.userAgent.browser.matchCoast_()&&!goog.labs.userAgent.browser.matchFirefox_()&&goog.labs.userAgent.util.matchUserAgent("AppleWebKit")};
goog.labs.userAgent.browser.matchChrome_=function(){return(goog.labs.userAgent.util.matchUserAgent("Chrome")||goog.labs.userAgent.util.matchUserAgent("CriOS"))&&!goog.labs.userAgent.browser.matchEdgeHtml_()};goog.labs.userAgent.browser.matchAndroidBrowser_=function(){return goog.labs.userAgent.util.matchUserAgent("Android")&&!(goog.labs.userAgent.browser.isChrome()||goog.labs.userAgent.browser.isFirefox()||goog.labs.userAgent.browser.isOpera()||goog.labs.userAgent.browser.isSilk())};
goog.labs.userAgent.browser.isOpera=goog.labs.userAgent.browser.matchOpera_;goog.labs.userAgent.browser.isIE=goog.labs.userAgent.browser.matchIE_;goog.labs.userAgent.browser.isEdge=goog.labs.userAgent.browser.matchEdgeHtml_;goog.labs.userAgent.browser.isEdgeChromium=goog.labs.userAgent.browser.matchEdgeChromium_;goog.labs.userAgent.browser.isOperaChromium=goog.labs.userAgent.browser.matchOperaChromium_;goog.labs.userAgent.browser.isFirefox=goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari=goog.labs.userAgent.browser.matchSafari_;goog.labs.userAgent.browser.isCoast=goog.labs.userAgent.browser.matchCoast_;goog.labs.userAgent.browser.isIosWebview=goog.labs.userAgent.browser.matchIosWebview_;goog.labs.userAgent.browser.isChrome=goog.labs.userAgent.browser.matchChrome_;goog.labs.userAgent.browser.isAndroidBrowser=goog.labs.userAgent.browser.matchAndroidBrowser_;goog.labs.userAgent.browser.isSilk=function(){return goog.labs.userAgent.util.matchUserAgent("Silk")};
goog.labs.userAgent.browser.getVersion=function(){function a(e){e=module$contents$goog$array_find(e,d);return c[e]||""}var b=goog.labs.userAgent.util.getUserAgent();if(goog.labs.userAgent.browser.isIE())return goog.labs.userAgent.browser.getIEVersion_(b);b=goog.labs.userAgent.util.extractVersionTuples(b);var c={};module$contents$goog$array_forEach(b,function(e){c[e[0]]=e[1]});var d=goog.partial(goog.object.containsKey,c);return goog.labs.userAgent.browser.isOpera()?a(["Version","Opera"]):goog.labs.userAgent.browser.isEdge()?
a(["Edge"]):goog.labs.userAgent.browser.isEdgeChromium()?a(["Edg"]):goog.labs.userAgent.browser.isChrome()?a(["Chrome","CriOS","HeadlessChrome"]):(b=b[2])&&b[1]||""};goog.labs.userAgent.browser.isVersionOrHigher=function(a){return 0<=goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(),a)};
goog.labs.userAgent.browser.getIEVersion_=function(a){var b=/rv: *([\d\.]*)/.exec(a);if(b&&b[1])return b[1];b="";var c=/MSIE +([\d\.]+)/.exec(a);if(c&&c[1])if(a=/Trident\/(\d.\d)/.exec(a),"7.0"==c[1])if(a&&a[1])switch(a[1]){case "4.0":b="8.0";break;case "5.0":b="9.0";break;case "6.0":b="10.0";break;case "7.0":b="11.0"}else b="7.0";else b=c[1];return b};goog.html.SafeHtml=function(a,b,c){this.privateDoNotAccessOrElseSafeHtmlWrappedValue_=c===goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_?a:"";this.dir_=b};goog.html.SafeHtml.ENABLE_ERROR_MESSAGES=goog.DEBUG;goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE=!0;goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString=!0;goog.html.SafeHtml.prototype.getDirection=function(){return this.dir_};goog.html.SafeHtml.prototype.implementsGoogStringTypedString=!0;
goog.html.SafeHtml.prototype.getTypedStringValue=function(){return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString()};goog.DEBUG&&(goog.html.SafeHtml.prototype.toString=function(){return"SafeHtml{"+this.privateDoNotAccessOrElseSafeHtmlWrappedValue_+"}"});goog.html.SafeHtml.unwrap=function(a){return goog.html.SafeHtml.unwrapTrustedHTML(a).toString()};
goog.html.SafeHtml.unwrapTrustedHTML=function(a){if(a instanceof goog.html.SafeHtml&&a.constructor===goog.html.SafeHtml)return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;goog.asserts.fail("expected object of type SafeHtml, got '"+a+"' of type "+goog.typeOf(a));return"type_error:SafeHtml"};
goog.html.SafeHtml.htmlEscape=function(a){if(a instanceof goog.html.SafeHtml)return a;var b="object"==typeof a,c=null;b&&a.implementsGoogI18nBidiDirectionalString&&(c=a.getDirection());a=b&&a.implementsGoogStringTypedString?a.getTypedStringValue():String(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a),c)};
goog.html.SafeHtml.htmlEscapePreservingNewlines=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)),a.getDirection())};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces=function(a){if(a instanceof goog.html.SafeHtml)return a;a=goog.html.SafeHtml.htmlEscape(a);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)),a.getDirection())};goog.html.SafeHtml.from=goog.html.SafeHtml.htmlEscape;
goog.html.SafeHtml.comment=function(a){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("\x3c!--"+goog.string.internal.htmlEscape(a)+"--\x3e",null)};goog.html.SafeHtml.VALID_NAMES_IN_TAG_=/^[a-zA-Z0-9-]+$/;goog.html.SafeHtml.URL_ATTRIBUTES_={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};
goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_=goog.object.createSet(goog.dom.TagName.APPLET,goog.dom.TagName.BASE,goog.dom.TagName.EMBED,goog.dom.TagName.IFRAME,goog.dom.TagName.LINK,goog.dom.TagName.MATH,goog.dom.TagName.META,goog.dom.TagName.OBJECT,goog.dom.TagName.SCRIPT,goog.dom.TagName.STYLE,goog.dom.TagName.SVG,goog.dom.TagName.TEMPLATE);
goog.html.SafeHtml.create=function(a,b,c){goog.html.SafeHtml.verifyTagName(String(a));return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a),b,c)};
goog.html.SafeHtml.verifyTagName=function(a){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Invalid tag name <"+a+">.":"");if(a.toUpperCase()in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"Tag name <"+a+"> is not allowed for SafeHtml.":"");};
goog.html.SafeHtml.createIframe=function(a,b,c,d){a&&goog.html.TrustedResourceUrl.unwrap(a);var e={};e.src=a||null;e.srcdoc=b&&goog.html.SafeHtml.unwrap(b);a=goog.html.SafeHtml.combineAttributes(e,{sandbox:""},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.createSandboxIframe=function(a,b,c,d){if(!goog.html.SafeHtml.canUseSandboxIframe())throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?"The browser does not support sandboxed iframes.":"");var e={};e.src=a?goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)):null;e.srcdoc=b||null;e.sandbox="";a=goog.html.SafeHtml.combineAttributes(e,{},c);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe",a,d)};
goog.html.SafeHtml.canUseSandboxIframe=function(){return goog.global.HTMLIFrameElement&&"sandbox"in goog.global.HTMLIFrameElement.prototype};goog.html.SafeHtml.createScriptSrc=function(a,b){goog.html.TrustedResourceUrl.unwrap(a);a=goog.html.SafeHtml.combineAttributes({src:a},{},b);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",a)};
goog.html.SafeHtml.createScript=function(a,b){for(var c in b)if(Object.prototype.hasOwnProperty.call(b,c)){var d=c.toLowerCase();if("language"==d||"src"==d||"text"==d||"type"==d)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot set "'+d+'" attribute':"");}c="";a=module$contents$goog$array_concat(a);for(d=0;d<a.length;d++)c+=module$contents$goog$html$SafeScript_SafeScript.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script",
b,a)};goog.html.SafeHtml.createStyle=function(a,b){b=goog.html.SafeHtml.combineAttributes({type:"text/css"},{},b);var c="";a=module$contents$goog$array_concat(a);for(var d=0;d<a.length;d++)c+=module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(a[d]);a=goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c,goog.i18n.bidi.Dir.NEUTRAL);return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style",b,a)};
goog.html.SafeHtml.createMetaRefresh=function(a,b){a=goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));(goog.labs.userAgent.browser.isIE()||goog.labs.userAgent.browser.isEdge())&&goog.string.internal.contains(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'");return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta",{"http-equiv":"refresh",content:(b||0)+"; url="+a})};
goog.html.SafeHtml.getAttrNameAndValue_=function(a,b,c){if(c instanceof goog.string.Const)c=goog.string.Const.unwrap(c);else if("style"==b.toLowerCase())if(goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE)c=goog.html.SafeHtml.getStyleValue_(c);else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "style" not supported.':"");else{if(/^on/i.test(b))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" requires goog.string.Const value, "'+c+'" given.':"");if(b.toLowerCase()in
goog.html.SafeHtml.URL_ATTRIBUTES_)if(c instanceof goog.html.TrustedResourceUrl)c=goog.html.TrustedResourceUrl.unwrap(c);else if(c instanceof goog.html.SafeUrl)c=goog.html.SafeUrl.unwrap(c);else if("string"===typeof c)c=goog.html.SafeUrl.sanitize(c).getTypedStringValue();else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Attribute "'+b+'" on tag "'+a+'" requires goog.html.SafeUrl, goog.string.Const, or string, value "'+c+'" given.':"");}c.implementsGoogStringTypedString&&(c=c.getTypedStringValue());
goog.asserts.assert("string"===typeof c||"number"===typeof c,"String or number value expected, got "+typeof c+" with value: "+c);return b+'="'+goog.string.internal.htmlEscape(String(c))+'"'};goog.html.SafeHtml.getStyleValue_=function(a){if(!goog.isObject(a))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'The "style" attribute requires goog.html.SafeStyle or map of style properties, '+typeof a+" given: "+a:"");a instanceof goog.html.SafeStyle||(a=goog.html.SafeStyle.create(a));return goog.html.SafeStyle.unwrap(a)};
goog.html.SafeHtml.createWithDir=function(a,b,c,d){b=goog.html.SafeHtml.create(b,c,d);b.dir_=a;return b};
goog.html.SafeHtml.join=function(a,b){a=goog.html.SafeHtml.htmlEscape(a);var c=a.getDirection(),d=[],e=function(f){Array.isArray(f)?module$contents$goog$array_forEach(f,e):(f=goog.html.SafeHtml.htmlEscape(f),d.push(goog.html.SafeHtml.unwrap(f)),f=f.getDirection(),c==goog.i18n.bidi.Dir.NEUTRAL?c=f:f!=goog.i18n.bidi.Dir.NEUTRAL&&c!=f&&(c=null))};module$contents$goog$array_forEach(b,e);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)),c)};
goog.html.SafeHtml.concat=function(a){return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY,Array.prototype.slice.call(arguments))};goog.html.SafeHtml.concatWithDir=function(a,b){var c=goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments,1));c.dir_=a;return c};goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_={};
goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse=function(a,b){var c=goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();a=c?c.createHTML(a):a;return new goog.html.SafeHtml(a,b,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_)};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse=function(a,b,c){var d=null;var e="<"+a+goog.html.SafeHtml.stringifyAttributes(a,b);null==c?c=[]:Array.isArray(c)||(c=[c]);goog.dom.tags.isVoidTag(a.toLowerCase())?(goog.asserts.assert(!c.length,"Void tag <"+a+"> does not allow content."),e+=">"):(d=goog.html.SafeHtml.concat(c),e+=">"+goog.html.SafeHtml.unwrap(d)+"</"+a+">",d=d.getDirection());(a=b&&b.dir)&&(d=/^(ltr|rtl|auto)$/i.test(a)?goog.i18n.bidi.Dir.NEUTRAL:null);return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e,
d)};goog.html.SafeHtml.stringifyAttributes=function(a,b){var c="";if(b)for(var d in b)if(Object.prototype.hasOwnProperty.call(b,d)){if(!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Invalid attribute name "'+d+'".':"");var e=b[d];null!=e&&(c+=" "+goog.html.SafeHtml.getAttrNameAndValue_(a,d,e))}return c};
goog.html.SafeHtml.combineAttributes=function(a,b,c){var d={},e;for(e in a)Object.prototype.hasOwnProperty.call(a,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=a[e]);for(e in b)Object.prototype.hasOwnProperty.call(b,e)&&(goog.asserts.assert(e.toLowerCase()==e,"Must be lower case"),d[e]=b[e]);if(c)for(e in c)if(Object.prototype.hasOwnProperty.call(c,e)){var f=e.toLowerCase();if(f in a)throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES?'Cannot override "'+f+'" attribute, got "'+
e+'" with value "'+c[e]+'"':"");f in b&&delete d[f];d[e]=c[e]}return d};goog.html.SafeHtml.DOCTYPE_HTML=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.SafeHtml.EMPTY=new goog.html.SafeHtml(goog.global.trustedTypes&&goog.global.trustedTypes.emptyHTML||"",goog.i18n.bidi.Dir.NEUTRAL,goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
goog.html.SafeHtml.BR=function(){return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>",goog.i18n.bidi.Dir.NEUTRAL)}();goog.html.uncheckedconversions={};goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract=function(a,b,c){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b,c||null)};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b)};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract=function(a,b){goog.asserts.assertString(goog.string.Const.unwrap(a),"must provide justification");goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)),"must provide non-empty justification");return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b)};goog.dom.safe={};goog.dom.safe.InsertAdjacentHtmlPosition={AFTERBEGIN:"afterbegin",AFTEREND:"afterend",BEFOREBEGIN:"beforebegin",BEFOREEND:"beforeend"};goog.dom.safe.insertAdjacentHtml=function(a,b,c){a.insertAdjacentHTML(b,goog.html.SafeHtml.unwrapTrustedHTML(c))};goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};
goog.dom.safe.isInnerHtmlCleanupRecursive_=goog.functions.cacheReturnValue(function(){if(goog.DEBUG&&"undefined"===typeof document)return!1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(goog.DEBUG&&!a.firstChild)return!1;b=a.firstChild.firstChild;a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);return!b.parentElement});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse=function(a,b){if(goog.dom.safe.isInnerHtmlCleanupRecursive_())for(;a.lastChild;)a.removeChild(a.lastChild);a.innerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setInnerHtml=function(a,b){if(goog.asserts.ENABLE_ASSERTS&&a.tagName){var c=a.tagName.toUpperCase();if(goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+a.tagName+".");}goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a,b)};
goog.dom.safe.setInnerHtmlFromConstant=function(a,b){goog.dom.safe.setInnerHtml(a,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."),goog.string.Const.unwrap(b)))};goog.dom.safe.setOuterHtml=function(a,b){a.outerHTML=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setFormElementAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLFormElement(a).action=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setButtonFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLButtonElement(a).formAction=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setInputFormAction=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);goog.dom.asserts.assertIsHTMLInputElement(a).formAction=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setStyle=function(a,b){a.style.cssText=goog.html.SafeStyle.unwrap(b)};goog.dom.safe.documentWrite=function(a,b){a.write(goog.html.SafeHtml.unwrapTrustedHTML(b))};
goog.dom.safe.setAnchorHref=function(a,b){goog.dom.asserts.assertIsHTMLAnchorElement(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setImageSrc=function(a,b){goog.dom.asserts.assertIsHTMLImageElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:image\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setAudioSrc=function(a,b){goog.dom.asserts.assertIsHTMLAudioElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:audio\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.setVideoSrc=function(a,b){goog.dom.asserts.assertIsHTMLVideoElement(a);if(!(b instanceof goog.html.SafeUrl)){var c=/^data:video\//i.test(b);b=goog.html.SafeUrl.sanitizeAssertUnchanged(b,c)}a.src=goog.html.SafeUrl.unwrap(b)};
goog.dom.safe.setEmbedSrc=function(a,b){goog.dom.asserts.assertIsHTMLEmbedElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setFrameSrc=function(a,b){goog.dom.asserts.assertIsHTMLFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};goog.dom.safe.setIframeSrc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.src=goog.html.TrustedResourceUrl.unwrap(b)};
goog.dom.safe.setIframeSrcdoc=function(a,b){goog.dom.asserts.assertIsHTMLIFrameElement(a);a.srcdoc=goog.html.SafeHtml.unwrapTrustedHTML(b)};
goog.dom.safe.setLinkHrefAndRel=function(a,b,c){goog.dom.asserts.assertIsHTMLLinkElement(a);a.rel=c;goog.string.internal.caseInsensitiveContains(c,"stylesheet")?(goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl,'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'),a.href=goog.html.TrustedResourceUrl.unwrap(b)):a.href=b instanceof goog.html.TrustedResourceUrl?goog.html.TrustedResourceUrl.unwrap(b):b instanceof goog.html.SafeUrl?goog.html.SafeUrl.unwrap(b):goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(b))};
goog.dom.safe.setObjectData=function(a,b){goog.dom.asserts.assertIsHTMLObjectElement(a);a.data=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b)};goog.dom.safe.setScriptSrc=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.src=goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);goog.dom.safe.setNonceForScriptElement_(a)};
goog.dom.safe.setScriptContent=function(a,b){goog.dom.asserts.assertIsHTMLScriptElement(a);a.textContent=module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(b);goog.dom.safe.setNonceForScriptElement_(a)};goog.dom.safe.setNonceForScriptElement_=function(a){var b=goog.getScriptNonce(a.ownerDocument&&a.ownerDocument.defaultView);b&&a.setAttribute("nonce",b)};
goog.dom.safe.setLocationHref=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.href=goog.html.SafeUrl.unwrap(b)};goog.dom.safe.assignLocation=function(a,b){goog.dom.asserts.assertIsLocation(a);b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.assign(goog.html.SafeUrl.unwrap(b))};
goog.dom.safe.replaceLocation=function(a,b){b=b instanceof goog.html.SafeUrl?b:goog.html.SafeUrl.sanitizeAssertUnchanged(b);a.replace(goog.html.SafeUrl.unwrap(b))};goog.dom.safe.openInWindow=function(a,b,c,d,e){a=a instanceof goog.html.SafeUrl?a:goog.html.SafeUrl.sanitizeAssertUnchanged(a);b=b||goog.global;c=c instanceof goog.string.Const?goog.string.Const.unwrap(c):c||"";return b.open(goog.html.SafeUrl.unwrap(a),c,d,e)};
goog.dom.safe.parseFromStringHtml=function(a,b){return goog.dom.safe.parseFromString(a,b,"text/html")};goog.dom.safe.parseFromString=function(a,b,c){return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b),c)};
goog.dom.safe.createImageFromBlob=function(a){if(!/^image\/.*/g.test(a.type))throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");var b=goog.global.URL.createObjectURL(a);a=new goog.global.Image;a.onload=function(){goog.global.URL.revokeObjectURL(b)};goog.dom.safe.setImageSrc(a,goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."),b));return a};goog.string.DETECT_DOUBLE_ESCAPING=!1;goog.string.FORCE_NON_DOM_HTML_UNESCAPING=!1;goog.string.Unicode={NBSP:"\u00a0"};goog.string.startsWith=goog.string.internal.startsWith;goog.string.endsWith=goog.string.internal.endsWith;goog.string.caseInsensitiveStartsWith=goog.string.internal.caseInsensitiveStartsWith;goog.string.caseInsensitiveEndsWith=goog.string.internal.caseInsensitiveEndsWith;goog.string.caseInsensitiveEquals=goog.string.internal.caseInsensitiveEquals;
goog.string.subs=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};goog.string.collapseWhitespace=function(a){return a.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};goog.string.isEmptyOrWhitespace=goog.string.internal.isEmptyOrWhitespace;goog.string.isEmptyString=function(a){return 0==a.length};goog.string.isEmpty=goog.string.isEmptyOrWhitespace;goog.string.isEmptyOrWhitespaceSafe=function(a){return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a))};
goog.string.isEmptySafe=goog.string.isEmptyOrWhitespaceSafe;goog.string.isBreakingWhitespace=function(a){return!/[^\t\n\r ]/.test(a)};goog.string.isAlpha=function(a){return!/[^a-zA-Z]/.test(a)};goog.string.isNumeric=function(a){return!/[^0-9]/.test(a)};goog.string.isAlphaNumeric=function(a){return!/[^a-zA-Z0-9]/.test(a)};goog.string.isSpace=function(a){return" "==a};goog.string.isUnicodeChar=function(a){return 1==a.length&&" "<=a&&"~">=a||"\u0080"<=a&&"\ufffd">=a};
goog.string.stripNewlines=function(a){return a.replace(/(\r\n|\r|\n)+/g," ")};goog.string.canonicalizeNewlines=function(a){return a.replace(/(\r\n|\r|\n)/g,"\n")};goog.string.normalizeWhitespace=function(a){return a.replace(/\xa0|\s/g," ")};goog.string.normalizeSpaces=function(a){return a.replace(/\xa0|[ \t]+/g," ")};goog.string.collapseBreakingSpaces=function(a){return a.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};goog.string.trim=goog.string.internal.trim;
goog.string.trimLeft=function(a){return a.replace(/^[\s\xa0]+/,"")};goog.string.trimRight=function(a){return a.replace(/[\s\xa0]+$/,"")};goog.string.caseInsensitiveCompare=goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_=function(a,b,c){if(a==b)return 0;if(!a)return-1;if(!b)return 1;for(var d=a.toLowerCase().match(c),e=b.toLowerCase().match(c),f=Math.min(d.length,e.length),g=0;g<f;g++){c=d[g];var h=e[g];if(c!=h)return a=parseInt(c,10),!isNaN(a)&&(b=parseInt(h,10),!isNaN(b)&&a-b)?a-b:c<h?-1:1}return d.length!=e.length?d.length-e.length:a<b?-1:1};goog.string.intAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\D+/g)};
goog.string.floatAwareCompare=function(a,b){return goog.string.numberAwareCompare_(a,b,/\d+|\.\d+|\D+/g)};goog.string.numerateCompare=goog.string.floatAwareCompare;goog.string.urlEncode=function(a){return encodeURIComponent(String(a))};goog.string.urlDecode=function(a){return decodeURIComponent(a.replace(/\+/g," "))};goog.string.newLineToBr=goog.string.internal.newLineToBr;
goog.string.htmlEscape=function(a,b){a=goog.string.internal.htmlEscape(a,b);goog.string.DETECT_DOUBLE_ESCAPING&&(a=a.replace(goog.string.E_RE_,"&#101;"));return a};goog.string.E_RE_=/e/g;goog.string.unescapeEntities=function(a){return goog.string.contains(a,"&")?!goog.string.FORCE_NON_DOM_HTML_UNESCAPING&&"document"in goog.global?goog.string.unescapeEntitiesUsingDom_(a):goog.string.unescapePureXmlEntities_(a):a};
goog.string.unescapeEntitiesWithDocument=function(a,b){return goog.string.contains(a,"&")?goog.string.unescapeEntitiesUsingDom_(a,b):a};
goog.string.unescapeEntitiesUsingDom_=function(a,b){var c={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'};var d=b?b.createElement("div"):goog.global.document.createElement("div");return a.replace(goog.string.HTML_ENTITY_PATTERN_,function(e,f){var g=c[e];if(g)return g;"#"==f.charAt(0)&&(f=Number("0"+f.substr(1)),isNaN(f)||(g=String.fromCharCode(f)));g||(goog.dom.safe.setInnerHtml(d,goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."),
e+" ")),g=d.firstChild.nodeValue.slice(0,-1));return c[e]=g})};goog.string.unescapePureXmlEntities_=function(a){return a.replace(/&([^;]+);/g,function(b,c){switch(c){case "amp":return"&";case "lt":return"<";case "gt":return">";case "quot":return'"';default:return"#"!=c.charAt(0)||(c=Number("0"+c.substr(1)),isNaN(c))?b:String.fromCharCode(c)}})};goog.string.HTML_ENTITY_PATTERN_=/&([^;\s<&]+);?/g;goog.string.whitespaceEscape=function(a,b){return goog.string.newLineToBr(a.replace(/  /g," &#160;"),b)};
goog.string.preserveSpaces=function(a){return a.replace(/(^|[\n ]) /g,"$1"+goog.string.Unicode.NBSP)};goog.string.stripQuotes=function(a,b){for(var c=b.length,d=0;d<c;d++){var e=1==c?b:b.charAt(d);if(a.charAt(0)==e&&a.charAt(a.length-1)==e)return a.substring(1,a.length-1)}return a};goog.string.truncate=function(a,b,c){c&&(a=goog.string.unescapeEntities(a));a.length>b&&(a=a.substring(0,b-3)+"...");c&&(a=goog.string.htmlEscape(a));return a};
goog.string.truncateMiddle=function(a,b,c,d){c&&(a=goog.string.unescapeEntities(a));if(d&&a.length>b){d>b&&(d=b);var e=a.length-d;a=a.substring(0,b-d)+"..."+a.substring(e)}else a.length>b&&(d=Math.floor(b/2),e=a.length-d,a=a.substring(0,d+b%2)+"..."+a.substring(e));c&&(a=goog.string.htmlEscape(a));return a};goog.string.specialEscapeChars_={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"\\u003C"};goog.string.jsEscapeCache_={"'":"\\'"};
goog.string.quote=function(a){a=String(a);for(var b=['"'],c=0;c<a.length;c++){var d=a.charAt(c),e=d.charCodeAt(0);b[c+1]=goog.string.specialEscapeChars_[d]||(31<e&&127>e?d:goog.string.escapeChar(d))}b.push('"');return b.join("")};goog.string.escapeString=function(a){for(var b=[],c=0;c<a.length;c++)b[c]=goog.string.escapeChar(a.charAt(c));return b.join("")};
goog.string.escapeChar=function(a){if(a in goog.string.jsEscapeCache_)return goog.string.jsEscapeCache_[a];if(a in goog.string.specialEscapeChars_)return goog.string.jsEscapeCache_[a]=goog.string.specialEscapeChars_[a];var b=a.charCodeAt(0);if(31<b&&127>b)var c=a;else{if(256>b){if(c="\\x",16>b||256<b)c+="0"}else c="\\u",4096>b&&(c+="0");c+=b.toString(16).toUpperCase()}return goog.string.jsEscapeCache_[a]=c};goog.string.contains=goog.string.internal.contains;goog.string.caseInsensitiveContains=goog.string.internal.caseInsensitiveContains;
goog.string.countOf=function(a,b){return a&&b?a.split(b).length-1:0};goog.string.removeAt=function(a,b,c){var d=a;0<=b&&b<a.length&&0<c&&(d=a.substr(0,b)+a.substr(b+c,a.length-b-c));return d};goog.string.remove=function(a,b){return a.replace(b,"")};goog.string.removeAll=function(a,b){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,"")};goog.string.replaceAll=function(a,b,c){b=new RegExp(goog.string.regExpEscape(b),"g");return a.replace(b,c.replace(/\$/g,"$$$$"))};
goog.string.regExpEscape=function(a){return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};goog.string.repeat=String.prototype.repeat?function(a,b){return a.repeat(b)}:function(a,b){return Array(b+1).join(a)};goog.string.padNumber=function(a,b,c){a=void 0!==c?a.toFixed(c):String(a);c=a.indexOf(".");-1==c&&(c=a.length);return goog.string.repeat("0",Math.max(0,b-c))+a};goog.string.makeSafe=function(a){return null==a?"":String(a)};
goog.string.buildString=function(a){return Array.prototype.join.call(arguments,"")};goog.string.getRandomString=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^goog.now()).toString(36)};goog.string.compareVersions=goog.string.internal.compareVersions;goog.string.hashCode=function(a){for(var b=0,c=0;c<a.length;++c)b=31*b+a.charCodeAt(c)>>>0;return b};goog.string.uniqueStringCounter_=2147483648*Math.random()|0;
goog.string.createUniqueString=function(){return"goog_"+goog.string.uniqueStringCounter_++};goog.string.toNumber=function(a){var b=Number(a);return 0==b&&goog.string.isEmptyOrWhitespace(a)?NaN:b};goog.string.isLowerCamelCase=function(a){return/^[a-z]+([A-Z][a-z]*)*$/.test(a)};goog.string.isUpperCamelCase=function(a){return/^([A-Z][a-z]*)+$/.test(a)};goog.string.toCamelCase=function(a){return String(a).replace(/\-([a-z])/g,function(b,c){return c.toUpperCase()})};
goog.string.toSelectorCase=function(a){return String(a).replace(/([A-Z])/g,"-$1").toLowerCase()};goog.string.toTitleCase=function(a,b){b="string"===typeof b?goog.string.regExpEscape(b):"\\s";return a.replace(new RegExp("(^"+(b?"|["+b+"]+":"")+")([a-z])","g"),function(c,d,e){return d+e.toUpperCase()})};goog.string.capitalize=function(a){return String(a.charAt(0)).toUpperCase()+String(a.substr(1)).toLowerCase()};
goog.string.parseInt=function(a){isFinite(a)&&(a=String(a));return"string"===typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN};goog.string.splitLimit=function(a,b,c){a=a.split(b);for(var d=[];0<c&&a.length;)d.push(a.shift()),c--;a.length&&d.push(a.join(b));return d};goog.string.lastComponent=function(a,b){if(b)"string"==typeof b&&(b=[b]);else return a;for(var c=-1,d=0;d<b.length;d++)if(""!=b[d]){var e=a.lastIndexOf(b[d]);e>c&&(c=e)}return-1==c?a:a.slice(c+1)};
goog.string.editDistance=function(a,b){var c=[],d=[];if(a==b)return 0;if(!a.length||!b.length)return Math.max(a.length,b.length);for(var e=0;e<b.length+1;e++)c[e]=e;for(e=0;e<a.length;e++){d[0]=e+1;for(var f=0;f<b.length;f++)d[f+1]=Math.min(d[f]+1,c[f+1]+1,c[f]+Number(a[e]!=b[f]));for(f=0;f<c.length;f++)c[f]=d[f]}return d[b.length]};goog.proto2={};goog.proto2.Descriptor=function(a,b,c){this.messageType_=a;this.name_=b.name||null;this.fullName_=b.fullName||null;this.containingType_=b.containingType;this.fields_={};for(a=0;a<c.length;a++)b=c[a],this.fields_[b.getTag()]=b};goog.proto2.Descriptor.prototype.getName=function(){return this.name_};goog.proto2.Descriptor.prototype.getFullName=function(){return this.fullName_};
goog.proto2.Descriptor.prototype.getContainingType=function(){return this.containingType_?this.containingType_.getDescriptor():null};goog.proto2.Descriptor.prototype.getFields=function(){var a=goog.object.getValues(this.fields_);module$contents$goog$array_sort(a,function(b,c){return b.getTag()-c.getTag()});return a};goog.proto2.Descriptor.prototype.getFieldsMap=function(){return this.fields_};
goog.proto2.Descriptor.prototype.findFieldByName=function(a){return goog.object.findValue(this.fields_,function(b,c,d){return b.getName()==a})||null};goog.proto2.Descriptor.prototype.findFieldByTag=function(a){goog.asserts.assert(goog.string.isNumeric(a));return this.fields_[parseInt(a,10)]||null};goog.proto2.Descriptor.prototype.createMessageInstance=function(){return new this.messageType_};goog.proto2.FieldDescriptor=function(a,b,c){this.parent_=a;goog.asserts.assert(goog.string.isNumeric(b));this.tag_=b;this.name_=c.name;this.isPacked_=!!c.packed;this.isRepeated_=!!c.repeated;this.isRequired_=!!c.required;this.fieldType_=c.fieldType;this.nativeType_=c.type;this.deserializationConversionPermitted_=!1;switch(this.fieldType_){case goog.proto2.FieldDescriptor.FieldType.INT64:case goog.proto2.FieldDescriptor.FieldType.UINT64:case goog.proto2.FieldDescriptor.FieldType.FIXED64:case goog.proto2.FieldDescriptor.FieldType.SFIXED64:case goog.proto2.FieldDescriptor.FieldType.SINT64:case goog.proto2.FieldDescriptor.FieldType.FLOAT:case goog.proto2.FieldDescriptor.FieldType.DOUBLE:this.deserializationConversionPermitted_=
!0}this.defaultValue_=c.defaultValue};goog.proto2.FieldDescriptor.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.FieldDescriptor.prototype.getTag=function(){return this.tag_};goog.proto2.FieldDescriptor.prototype.getContainingType=function(){return this.parent_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.getName=function(){return this.name_};
goog.proto2.FieldDescriptor.prototype.getDefaultValue=function(){if(void 0===this.defaultValue_){var a=this.nativeType_;if(a===Boolean)this.defaultValue_=!1;else if(a===Number)this.defaultValue_=0;else if(a===String)this.defaultValue_=this.deserializationConversionPermitted_?"0":"";else return new a}return this.defaultValue_};goog.proto2.FieldDescriptor.prototype.getFieldType=function(){return this.fieldType_};goog.proto2.FieldDescriptor.prototype.getNativeType=function(){return this.nativeType_};
goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted=function(){return this.deserializationConversionPermitted_};goog.proto2.FieldDescriptor.prototype.getFieldMessageType=function(){return this.nativeType_.prototype.getDescriptor()};goog.proto2.FieldDescriptor.prototype.isCompositeType=function(){return this.fieldType_==goog.proto2.FieldDescriptor.FieldType.MESSAGE||this.fieldType_==goog.proto2.FieldDescriptor.FieldType.GROUP};goog.proto2.FieldDescriptor.prototype.isPacked=function(){return this.isPacked_};
goog.proto2.FieldDescriptor.prototype.isRepeated=function(){return this.isRepeated_};goog.proto2.FieldDescriptor.prototype.isRequired=function(){return this.isRequired_};goog.proto2.FieldDescriptor.prototype.isOptional=function(){return!this.isRepeated_&&!this.isRequired_};goog.proto2.Message=function(){this.values_={};this.fields_=this.getDescriptor().getFieldsMap();this.deserializedFields_=this.lazyDeserializer_=null};goog.proto2.Message.FieldType={DOUBLE:1,FLOAT:2,INT64:3,UINT64:4,INT32:5,FIXED64:6,FIXED32:7,BOOL:8,STRING:9,GROUP:10,MESSAGE:11,BYTES:12,UINT32:13,ENUM:14,SFIXED32:15,SFIXED64:16,SINT32:17,SINT64:18};goog.proto2.Message.prototype.initializeForLazyDeserializer=function(a,b){this.lazyDeserializer_=a;this.values_=b;this.deserializedFields_={}};
goog.proto2.Message.prototype.setUnknown=function(a,b){goog.asserts.assert(!this.fields_[a],"Field is not unknown in this message");goog.asserts.assert(1<=a,"Tag "+a+' has value "'+b+'" in descriptor '+this.getDescriptor().getName());goog.asserts.assert(null!==b,"Value cannot be null");this.values_[a]=b;this.deserializedFields_&&delete this.deserializedFields_[a]};
goog.proto2.Message.prototype.forEachUnknown=function(a,b){b=b||this;for(var c in this.values_){var d=Number(c);this.fields_[d]||a.call(b,d,this.values_[c])}};goog.proto2.Message.prototype.getDescriptor=goog.abstractMethod;goog.proto2.Message.prototype.has=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.has$Value(a.getTag())};
goog.proto2.Message.prototype.arrayOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.array$Values(a.getTag())};goog.proto2.Message.prototype.countOf=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.count$Values(a.getTag())};
goog.proto2.Message.prototype.get=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$Value(a.getTag(),b)};goog.proto2.Message.prototype.getOrDefault=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");return this.get$ValueOrDefault(a.getTag(),b)};
goog.proto2.Message.prototype.set=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.set$Value(a.getTag(),b)};goog.proto2.Message.prototype.add=function(a,b){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.add$Value(a.getTag(),b)};
goog.proto2.Message.prototype.clear=function(a){goog.asserts.assert(a.getContainingType()==this.getDescriptor(),"The current message does not contain the given field");this.clear$Field(a.getTag())};
goog.proto2.Message.prototype.equals=function(a){if(!a||this.constructor!=a.constructor)return!1;for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(this.has$Value(e)!=a.has$Value(e))return!1;if(this.has$Value(e)){var f=d.isCompositeType(),g=this.getValueForTag_(e);e=a.getValueForTag_(e);if(d.isRepeated()){if(g.length!=e.length)return!1;for(d=0;d<g.length;d++){var h=g[d],k=e[d];if(f?!h.equals(k):h!=k)return!1}}else if(f?!g.equals(e):g!=e)return!1}}return!0};
goog.proto2.Message.prototype.copyFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");this!=a&&(this.values_={},this.deserializedFields_&&(this.deserializedFields_={}),this.mergeFrom(a))};
goog.proto2.Message.prototype.mergeFrom=function(a){goog.asserts.assert(this.constructor==a.constructor,"The source message must have the same type.");for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag();if(a.has$Value(e)){this.deserializedFields_&&delete this.deserializedFields_[d.getTag()];var f=d.isCompositeType();if(d.isRepeated()){d=a.array$Values(e);for(var g=0;g<d.length;g++)this.add$Value(e,f?d[g].clone():d[g])}else d=a.getValueForTag_(e),f?(f=this.getValueForTag_(e))?
f.mergeFrom(d):this.set$Value(e,d.clone()):this.set$Value(e,d)}}};goog.proto2.Message.prototype.clone=function(){var a=new this.constructor;a.copyFrom(this);return a};
goog.proto2.Message.prototype.initDefaults=function(a){for(var b=this.getDescriptor().getFields(),c=0;c<b.length;c++){var d=b[c],e=d.getTag(),f=d.isCompositeType();this.has$Value(e)||d.isRepeated()||(f?this.values_[e]=new (d.getNativeType()):a&&(this.values_[e]=d.getDefaultValue()));if(f)if(d.isRepeated())for(d=this.array$Values(e),e=0;e<d.length;e++)d[e].initDefaults(a);else this.get$Value(e).initDefaults(a)}};goog.proto2.Message.prototype.has$Value=function(a){return null!=this.values_[a]};
goog.proto2.Message.prototype.getValueForTag_=function(a){var b=this.values_[a];return null==b?null:this.lazyDeserializer_?a in this.deserializedFields_?this.deserializedFields_[a]:(b=this.lazyDeserializer_.deserializeField(this,this.fields_[a],b),this.deserializedFields_[a]=b):b};
goog.proto2.Message.prototype.get$Value=function(a,b){var c=this.getValueForTag_(a);return this.fields_[a].isRepeated()?(a=b||0,goog.asserts.assert(0<=a&&a<c.length,"Given index %s is out of bounds.  Repeated field length: %s",a,c.length),c[a]):c};goog.proto2.Message.prototype.get$ValueOrDefault=function(a,b){return this.has$Value(a)?this.get$Value(a,b):this.fields_[a].getDefaultValue()};goog.proto2.Message.prototype.array$Values=function(a){return this.getValueForTag_(a)||[]};
goog.proto2.Message.prototype.count$Values=function(a){return this.fields_[a].isRepeated()?this.has$Value(a)?this.values_[a].length:0:this.has$Value(a)?1:0};goog.proto2.Message.prototype.set$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]=b;this.deserializedFields_&&(this.deserializedFields_[a]=b)};
goog.proto2.Message.prototype.add$Value=function(a,b){goog.asserts.ENABLE_ASSERTS&&this.checkFieldType_(this.fields_[a],b);this.values_[a]||(this.values_[a]=[]);this.values_[a].push(b);this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.prototype.checkFieldType_=function(a,b){a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM?goog.asserts.assertNumber(b):goog.asserts.assert(Object(b).constructor==a.getNativeType())};
goog.proto2.Message.prototype.clear$Field=function(a){delete this.values_[a];this.deserializedFields_&&delete this.deserializedFields_[a]};goog.proto2.Message.createDescriptor=function(a,b){var c=[],d=b[0],e;for(e in b)0!=e&&c.push(new goog.proto2.FieldDescriptor(a,e,b[e]));return new goog.proto2.Descriptor(a,d,c)};goog.proto2.Serializer=function(){};goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS=!1;goog.proto2.Serializer.prototype.serialize=goog.abstractMethod;goog.proto2.Serializer.prototype.getSerializedValue=function(a,b){return a.isCompositeType()?this.serialize(b):"number"!==typeof b||isFinite(b)?b:b.toString()};goog.proto2.Serializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();this.deserializeTo(a,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};
goog.proto2.Serializer.prototype.deserializeTo=goog.abstractMethod;
goog.proto2.Serializer.prototype.getDeserializedValue=function(a,b){if(a.isCompositeType())return b instanceof goog.proto2.Message?b:this.deserialize(a.getFieldMessageType(),b);if(a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.ENUM)return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS&&"string"===typeof b&&(a=a.getNativeType(),a.hasOwnProperty(b))?a[b]:"string"===typeof b&&goog.proto2.Serializer.INTEGER_REGEX.test(b)&&(a=Number(b),0<a)?a:b;if(!a.deserializationConversionPermitted())return b;
a=a.getNativeType();if(a===String){if("number"===typeof b)return String(b)}else if(a===Number&&"string"===typeof b&&("Infinity"===b||"-Infinity"===b||"NaN"===b||goog.proto2.Serializer.INTEGER_REGEX.test(b)))return Number(b);return b};goog.proto2.Serializer.INTEGER_REGEX=/^-?[0-9]+$/;goog.proto2.LazyDeserializer=function(){};goog.inherits(goog.proto2.LazyDeserializer,goog.proto2.Serializer);goog.proto2.LazyDeserializer.prototype.deserialize=function(a,b){a=a.createMessageInstance();a.initializeForLazyDeserializer(this,b);goog.asserts.assert(a instanceof goog.proto2.Message);return a};goog.proto2.LazyDeserializer.prototype.deserializeTo=function(a,b){throw Error("Unimplemented");};goog.proto2.LazyDeserializer.prototype.deserializeField=goog.abstractMethod;goog.proto2.PbLiteSerializer=function(){};goog.inherits(goog.proto2.PbLiteSerializer,goog.proto2.LazyDeserializer);goog.proto2.PbLiteSerializer.prototype.zeroIndexing_=!1;goog.proto2.PbLiteSerializer.prototype.setZeroIndexed=function(a){this.zeroIndexing_=a};
goog.proto2.PbLiteSerializer.prototype.serialize=function(a){for(var b=a.getDescriptor().getFields(),c=[],d=this.zeroIndexing_,e=0;e<b.length;e++){var f=b[e];if(a.has(f)){var g=f.getTag();g=d?g-1:g;if(f.isRepeated()){c[g]=[];for(var h=0;h<a.countOf(f);h++)c[g][h]=this.getSerializedValue(f,a.get(f,h))}else c[g]=this.getSerializedValue(f,a.get(f))}}a.forEachUnknown(function(k,l){c[d?k-1:k]=l});return c};
goog.proto2.PbLiteSerializer.prototype.deserializeField=function(a,b,c){if(null==c)return c;if(b.isRepeated()){a=[];goog.asserts.assert(Array.isArray(c),"Value must be array: %s",c);for(var d=0;d<c.length;d++)a[d]=this.getDeserializedValue(b,c[d]);return a}return this.getDeserializedValue(b,c)};
goog.proto2.PbLiteSerializer.prototype.getSerializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?b?1:0:goog.proto2.Serializer.prototype.getSerializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.getDeserializedValue=function(a,b){return a.getFieldType()==goog.proto2.FieldDescriptor.FieldType.BOOL?(goog.asserts.assert("number"===typeof b||"boolean"===typeof b,"Value is expected to be a number or boolean"),!!b):goog.proto2.Serializer.prototype.getDeserializedValue.apply(this,arguments)};
goog.proto2.PbLiteSerializer.prototype.deserialize=function(a,b){var c=b;if(this.zeroIndexing_){c=[];for(var d in b)c[parseInt(d,10)+1]=b[d]}return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this,a,c)};goog.string.StringBuffer=function(a,b){null!=a&&this.append.apply(this,arguments)};goog.string.StringBuffer.prototype.buffer_="";goog.string.StringBuffer.prototype.set=function(a){this.buffer_=""+a};goog.string.StringBuffer.prototype.append=function(a,b,c){this.buffer_+=String(a);if(null!=b)for(var d=1;d<arguments.length;d++)this.buffer_+=arguments[d];return this};goog.string.StringBuffer.prototype.clear=function(){this.buffer_=""};goog.string.StringBuffer.prototype.getLength=function(){return this.buffer_.length};
goog.string.StringBuffer.prototype.toString=function(){return this.buffer_};/*

 Protocol Buffer 2 Copyright 2008 Google Inc.
 All other code copyright its respective owners.
 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
var i18n={phonenumbers:{}};i18n.phonenumbers.NumberFormat=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.NumberFormat,goog.proto2.Message);i18n.phonenumbers.NumberFormat.descriptor_=null;i18n.phonenumbers.NumberFormat.prototype.getPattern=function(){return this.get$Value(1)};i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.NumberFormat.prototype.setPattern=function(a){this.set$Value(1,a)};
i18n.phonenumbers.NumberFormat.prototype.hasPattern=function(){return this.has$Value(1)};i18n.phonenumbers.NumberFormat.prototype.patternCount=function(){return this.count$Values(1)};i18n.phonenumbers.NumberFormat.prototype.clearPattern=function(){this.clear$Field(1)};i18n.phonenumbers.NumberFormat.prototype.getFormat=function(){return this.get$Value(2)};i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.NumberFormat.prototype.setFormat=function(a){this.set$Value(2,a)};i18n.phonenumbers.NumberFormat.prototype.hasFormat=function(){return this.has$Value(2)};i18n.phonenumbers.NumberFormat.prototype.formatCount=function(){return this.count$Values(2)};i18n.phonenumbers.NumberFormat.prototype.clearFormat=function(){this.clear$Field(2)};i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern=function(a){return this.get$Value(3,a)};
i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault=function(a){return this.get$ValueOrDefault(3,a)};i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern=function(a){this.add$Value(3,a)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray=function(){return this.array$Values(3)};i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern=function(){return this.has$Value(3)};i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount=function(){return this.count$Values(3)};
i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern=function(){this.clear$Field(3)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule=function(){return this.get$Value(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule=function(a){this.set$Value(4,a)};
i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule=function(){return this.has$Value(4)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount=function(){return this.count$Values(4)};i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule=function(){this.clear$Field(4)};i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting=function(){return this.get$Value(6)};
i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting=function(a){this.set$Value(6,a)};i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting=function(){return this.has$Value(6)};i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount=function(){return this.count$Values(6)};
i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting=function(){this.clear$Field(6)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule=function(){return this.get$Value(5)};i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule=function(a){this.set$Value(5,a)};
i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule=function(){return this.has$Value(5)};i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount=function(){return this.count$Values(5)};i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumberDesc=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumberDesc,goog.proto2.Message);
i18n.phonenumbers.PhoneNumberDesc.descriptor_=null;i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern=function(){return this.has$Value(2)};
i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength=function(a){return this.get$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault=function(a){return this.get$ValueOrDefault(9,a)};
i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength=function(a){this.add$Value(9,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray=function(){return this.array$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength=function(){this.clear$Field(9)};
i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly=function(a){return this.get$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault=function(a){return this.get$ValueOrDefault(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly=function(a){this.add$Value(10,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray=function(){return this.array$Values(10)};
i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata=function(){goog.proto2.Message.call(this)};
goog.inherits(i18n.phonenumbers.PhoneMetadata,goog.proto2.Message);i18n.phonenumbers.PhoneMetadata.descriptor_=null;i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc=function(a){this.set$Value(1,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc=function(){return this.has$Value(1)};
i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault=function(){return this.get$ValueOrDefault(2)};i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine=function(a){this.set$Value(2,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneMetadata.prototype.getMobile=function(){return this.get$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault=function(){return this.get$ValueOrDefault(3)};
i18n.phonenumbers.PhoneMetadata.prototype.setMobile=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMobile=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneMetadata.prototype.mobileCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneMetadata.prototype.clearMobile=function(){this.clear$Field(3)};i18n.phonenumbers.PhoneMetadata.prototype.getTollFree=function(){return this.get$Value(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneMetadata.prototype.setTollFree=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount=function(){return this.count$Values(4)};i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree=function(){this.clear$Field(4)};
i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate=function(a){this.set$Value(5,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount=function(){return this.count$Values(5)};
i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault=function(){return this.get$ValueOrDefault(6)};i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost=function(){return this.has$Value(6)};
i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber=function(){return this.get$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber=function(a){this.set$Value(7,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount=function(){return this.count$Values(7)};i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneMetadata.prototype.getVoip=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault=function(){return this.get$ValueOrDefault(8)};
i18n.phonenumbers.PhoneMetadata.prototype.setVoip=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoip=function(){return this.has$Value(8)};i18n.phonenumbers.PhoneMetadata.prototype.voipCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneMetadata.prototype.clearVoip=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneMetadata.prototype.getPager=function(){return this.get$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault=function(){return this.get$ValueOrDefault(21)};
i18n.phonenumbers.PhoneMetadata.prototype.setPager=function(a){this.set$Value(21,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPager=function(){return this.has$Value(21)};i18n.phonenumbers.PhoneMetadata.prototype.pagerCount=function(){return this.count$Values(21)};i18n.phonenumbers.PhoneMetadata.prototype.clearPager=function(){this.clear$Field(21)};i18n.phonenumbers.PhoneMetadata.prototype.getUan=function(){return this.get$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault=function(){return this.get$ValueOrDefault(25)};
i18n.phonenumbers.PhoneMetadata.prototype.setUan=function(a){this.set$Value(25,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasUan=function(){return this.has$Value(25)};i18n.phonenumbers.PhoneMetadata.prototype.uanCount=function(){return this.count$Values(25)};i18n.phonenumbers.PhoneMetadata.prototype.clearUan=function(){this.clear$Field(25)};i18n.phonenumbers.PhoneMetadata.prototype.getEmergency=function(){return this.get$Value(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault=function(){return this.get$ValueOrDefault(27)};i18n.phonenumbers.PhoneMetadata.prototype.setEmergency=function(a){this.set$Value(27,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency=function(){return this.has$Value(27)};i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount=function(){return this.count$Values(27)};i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency=function(){this.clear$Field(27)};
i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail=function(){return this.get$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault=function(){return this.get$ValueOrDefault(28)};i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail=function(a){this.set$Value(28,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail=function(){return this.has$Value(28)};i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount=function(){return this.count$Values(28)};
i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail=function(){this.clear$Field(28)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCode=function(){return this.get$Value(29)};i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault=function(){return this.get$ValueOrDefault(29)};i18n.phonenumbers.PhoneMetadata.prototype.setShortCode=function(a){this.set$Value(29,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode=function(){return this.has$Value(29)};
i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount=function(){return this.count$Values(29)};i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode=function(){this.clear$Field(29)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate=function(){return this.get$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault=function(){return this.get$ValueOrDefault(30)};i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate=function(a){this.set$Value(30,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate=function(){return this.has$Value(30)};i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount=function(){return this.count$Values(30)};i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate=function(){this.clear$Field(30)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific=function(){return this.get$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault=function(){return this.get$ValueOrDefault(31)};
i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific=function(a){this.set$Value(31,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific=function(){return this.has$Value(31)};i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount=function(){return this.count$Values(31)};i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific=function(){this.clear$Field(31)};i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices=function(){return this.get$Value(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault=function(){return this.get$ValueOrDefault(33)};i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices=function(a){this.set$Value(33,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices=function(){return this.has$Value(33)};i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount=function(){return this.count$Values(33)};i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices=function(){this.clear$Field(33)};
i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling=function(){return this.get$Value(24)};i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault=function(){return this.get$ValueOrDefault(24)};i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling=function(a){this.set$Value(24,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling=function(){return this.has$Value(24)};
i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount=function(){return this.count$Values(24)};i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling=function(){this.clear$Field(24)};i18n.phonenumbers.PhoneMetadata.prototype.getId=function(){return this.get$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault=function(){return this.get$ValueOrDefault(9)};i18n.phonenumbers.PhoneMetadata.prototype.setId=function(a){this.set$Value(9,a)};
i18n.phonenumbers.PhoneMetadata.prototype.hasId=function(){return this.has$Value(9)};i18n.phonenumbers.PhoneMetadata.prototype.idCount=function(){return this.count$Values(9)};i18n.phonenumbers.PhoneMetadata.prototype.clearId=function(){this.clear$Field(9)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode=function(){return this.get$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(10)};
i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode=function(a){this.set$Value(10,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode=function(){return this.has$Value(10)};i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount=function(){return this.count$Values(10)};i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode=function(){this.clear$Field(10)};i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix=function(){return this.get$Value(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(11)};i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix=function(a){this.set$Value(11,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix=function(){return this.has$Value(11)};i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount=function(){return this.count$Values(11)};i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix=function(){this.clear$Field(11)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix=function(){return this.get$Value(17)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault=function(){return this.get$ValueOrDefault(17)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix=function(a){this.set$Value(17,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix=function(){return this.has$Value(17)};
i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount=function(){return this.count$Values(17)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix=function(){this.clear$Field(17)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix=function(){return this.get$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault=function(){return this.get$ValueOrDefault(12)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix=function(a){this.set$Value(12,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix=function(){return this.has$Value(12)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount=function(){return this.count$Values(12)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix=function(){this.clear$Field(12)};i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix=function(){return this.get$Value(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault=function(){return this.get$ValueOrDefault(13)};i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix=function(a){this.set$Value(13,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix=function(){return this.has$Value(13)};i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount=function(){return this.count$Values(13)};i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix=function(){this.clear$Field(13)};
i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing=function(){return this.get$Value(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault=function(){return this.get$ValueOrDefault(15)};i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing=function(a){this.set$Value(15,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing=function(){return this.has$Value(15)};
i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount=function(){return this.count$Values(15)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing=function(){this.clear$Field(15)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule=function(){return this.get$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault=function(){return this.get$ValueOrDefault(16)};
i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule=function(a){this.set$Value(16,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule=function(){return this.has$Value(16)};i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount=function(){return this.count$Values(16)};i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule=function(){this.clear$Field(16)};
i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern=function(){return this.get$Value(18)};i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault=function(){return this.get$ValueOrDefault(18)};i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern=function(a){this.set$Value(18,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern=function(){return this.has$Value(18)};
i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount=function(){return this.count$Values(18)};i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern=function(){this.clear$Field(18)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat=function(a){return this.get$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(19,a)};
i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat=function(a){this.add$Value(19,a)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray=function(){return this.array$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat=function(){return this.has$Value(19)};i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount=function(){return this.count$Values(19)};i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat=function(){this.clear$Field(19)};
i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat=function(a){return this.get$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault=function(a){return this.get$ValueOrDefault(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat=function(a){this.add$Value(20,a)};i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray=function(){return this.array$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat=function(){return this.has$Value(20)};
i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount=function(){return this.count$Values(20)};i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat=function(){this.clear$Field(20)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode=function(){return this.get$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault=function(){return this.get$ValueOrDefault(22)};
i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode=function(a){this.set$Value(22,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode=function(){return this.has$Value(22)};i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount=function(){return this.count$Values(22)};i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode=function(){this.clear$Field(22)};i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits=function(){return this.get$Value(23)};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault=function(){return this.get$ValueOrDefault(23)};i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits=function(a){this.set$Value(23,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits=function(){return this.has$Value(23)};i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount=function(){return this.count$Values(23)};i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits=function(){this.clear$Field(23)};
i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible=function(){return this.get$Value(26)};i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault=function(){return this.get$ValueOrDefault(26)};i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible=function(a){this.set$Value(26,a)};i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible=function(){return this.has$Value(26)};i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount=function(){return this.count$Values(26)};
i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible=function(){this.clear$Field(26)};i18n.phonenumbers.PhoneMetadataCollection=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneMetadataCollection,goog.proto2.Message);i18n.phonenumbers.PhoneMetadataCollection.descriptor_=null;i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata=function(a){return this.get$Value(1,a)};
i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault=function(a){return this.get$ValueOrDefault(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata=function(a){this.add$Value(1,a)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray=function(){return this.array$Values(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount=function(){return this.count$Values(1)};
i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata=function(){this.clear$Field(1)};
i18n.phonenumbers.NumberFormat.prototype.getDescriptor=function(){var a=i18n.phonenumbers.NumberFormat.descriptor_;a||(i18n.phonenumbers.NumberFormat.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat,{0:{name:"NumberFormat",fullName:"i18n.phonenumbers.NumberFormat"},1:{name:"pattern",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},2:{name:"format",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},3:{name:"leading_digits_pattern",
repeated:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"national_prefix_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"national_prefix_optional_when_formatting",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},5:{name:"domestic_carrier_code_formatting_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.NumberFormat.getDescriptor=i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumberDesc.descriptor_;a||(i18n.phonenumbers.PhoneNumberDesc.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc,{0:{name:"PhoneNumberDesc",fullName:"i18n.phonenumbers.PhoneNumberDesc"},2:{name:"national_number_pattern",fieldType:goog.proto2.Message.FieldType.STRING,type:String},9:{name:"possible_length",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},
10:{name:"possible_length_local_only",repeated:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},6:{name:"example_number",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumberDesc.getDescriptor=i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadata.descriptor_;a||(i18n.phonenumbers.PhoneMetadata.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata,{0:{name:"PhoneMetadata",fullName:"i18n.phonenumbers.PhoneMetadata"},1:{name:"general_desc",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},2:{name:"fixed_line",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},
3:{name:"mobile",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},4:{name:"toll_free",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},5:{name:"premium_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},6:{name:"shared_cost",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},7:{name:"personal_number",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},8:{name:"voip",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},21:{name:"pager",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},25:{name:"uan",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},27:{name:"emergency",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},28:{name:"voicemail",fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.PhoneNumberDesc},29:{name:"short_code",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},30:{name:"standard_rate",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},31:{name:"carrier_specific",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},33:{name:"sms_services",fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},24:{name:"no_international_dialling",
fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneNumberDesc},9:{name:"id",required:!0,fieldType:goog.proto2.Message.FieldType.STRING,type:String},10:{name:"country_code",fieldType:goog.proto2.Message.FieldType.INT32,type:Number},11:{name:"international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},17:{name:"preferred_international_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},12:{name:"national_prefix",fieldType:goog.proto2.Message.FieldType.STRING,
type:String},13:{name:"preferred_extn_prefix",fieldType:goog.proto2.Message.FieldType.STRING,type:String},15:{name:"national_prefix_for_parsing",fieldType:goog.proto2.Message.FieldType.STRING,type:String},16:{name:"national_prefix_transform_rule",fieldType:goog.proto2.Message.FieldType.STRING,type:String},18:{name:"same_mobile_and_fixed_line_pattern",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},19:{name:"number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,
type:i18n.phonenumbers.NumberFormat},20:{name:"intl_number_format",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.NumberFormat},22:{name:"main_country_for_code",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean},23:{name:"leading_digits",fieldType:goog.proto2.Message.FieldType.STRING,type:String},26:{name:"leading_zero_possible",fieldType:goog.proto2.Message.FieldType.BOOL,defaultValue:!1,type:Boolean}}));return a};
i18n.phonenumbers.PhoneMetadata.getDescriptor=i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneMetadataCollection.descriptor_;a||(i18n.phonenumbers.PhoneMetadataCollection.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection,{0:{name:"PhoneMetadataCollection",fullName:"i18n.phonenumbers.PhoneMetadataCollection"},1:{name:"metadata",repeated:!0,fieldType:goog.proto2.Message.FieldType.MESSAGE,type:i18n.phonenumbers.PhoneMetadata}}));return a};
i18n.phonenumbers.PhoneMetadataCollection.getDescriptor=i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;i18n.phonenumbers.PhoneNumber=function(){goog.proto2.Message.call(this)};goog.inherits(i18n.phonenumbers.PhoneNumber,goog.proto2.Message);i18n.phonenumbers.PhoneNumber.descriptor_=null;i18n.phonenumbers.PhoneNumber.prototype.getCountryCode=function(){return this.get$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault=function(){return this.get$ValueOrDefault(1)};i18n.phonenumbers.PhoneNumber.prototype.setCountryCode=function(a){this.set$Value(1,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode=function(){return this.has$Value(1)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount=function(){return this.count$Values(1)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode=function(){this.clear$Field(1)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber=function(){return this.get$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault=function(){return this.get$ValueOrDefault(2)};
i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber=function(a){this.set$Value(2,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber=function(){return this.has$Value(2)};i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount=function(){return this.count$Values(2)};i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber=function(){this.clear$Field(2)};i18n.phonenumbers.PhoneNumber.prototype.getExtension=function(){return this.get$Value(3)};
i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault=function(){return this.get$ValueOrDefault(3)};i18n.phonenumbers.PhoneNumber.prototype.setExtension=function(a){this.set$Value(3,a)};i18n.phonenumbers.PhoneNumber.prototype.hasExtension=function(){return this.has$Value(3)};i18n.phonenumbers.PhoneNumber.prototype.extensionCount=function(){return this.count$Values(3)};i18n.phonenumbers.PhoneNumber.prototype.clearExtension=function(){this.clear$Field(3)};
i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero=function(){return this.get$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault=function(){return this.get$ValueOrDefault(4)};i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero=function(a){this.set$Value(4,a)};i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero=function(){return this.has$Value(4)};i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount=function(){return this.count$Values(4)};
i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero=function(){this.clear$Field(4)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros=function(){return this.get$Value(8)};i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault=function(){return this.get$ValueOrDefault(8)};i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros=function(a){this.set$Value(8,a)};i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros=function(){return this.has$Value(8)};
i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount=function(){return this.count$Values(8)};i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros=function(){this.clear$Field(8)};i18n.phonenumbers.PhoneNumber.prototype.getRawInput=function(){return this.get$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault=function(){return this.get$ValueOrDefault(5)};i18n.phonenumbers.PhoneNumber.prototype.setRawInput=function(a){this.set$Value(5,a)};
i18n.phonenumbers.PhoneNumber.prototype.hasRawInput=function(){return this.has$Value(5)};i18n.phonenumbers.PhoneNumber.prototype.rawInputCount=function(){return this.count$Values(5)};i18n.phonenumbers.PhoneNumber.prototype.clearRawInput=function(){this.clear$Field(5)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource=function(){return this.get$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault=function(){return this.get$ValueOrDefault(6)};
i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource=function(a){this.set$Value(6,a)};i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource=function(){return this.has$Value(6)};i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount=function(){return this.count$Values(6)};i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource=function(){this.clear$Field(6)};i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode=function(){return this.get$Value(7)};
i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault=function(){return this.get$ValueOrDefault(7)};i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode=function(a){this.set$Value(7,a)};i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode=function(){return this.has$Value(7)};i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount=function(){return this.count$Values(7)};
i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode=function(){this.clear$Field(7)};i18n.phonenumbers.PhoneNumber.CountryCodeSource={UNSPECIFIED:0,FROM_NUMBER_WITH_PLUS_SIGN:1,FROM_NUMBER_WITH_IDD:5,FROM_NUMBER_WITHOUT_PLUS_SIGN:10,FROM_DEFAULT_COUNTRY:20};
i18n.phonenumbers.PhoneNumber.prototype.getDescriptor=function(){var a=i18n.phonenumbers.PhoneNumber.descriptor_;a||(i18n.phonenumbers.PhoneNumber.descriptor_=a=goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber,{0:{name:"PhoneNumber",fullName:"i18n.phonenumbers.PhoneNumber"},1:{name:"country_code",required:!0,fieldType:goog.proto2.Message.FieldType.INT32,type:Number},2:{name:"national_number",required:!0,fieldType:goog.proto2.Message.FieldType.UINT64,type:Number},3:{name:"extension",
fieldType:goog.proto2.Message.FieldType.STRING,type:String},4:{name:"italian_leading_zero",fieldType:goog.proto2.Message.FieldType.BOOL,type:Boolean},8:{name:"number_of_leading_zeros",fieldType:goog.proto2.Message.FieldType.INT32,defaultValue:1,type:Number},5:{name:"raw_input",fieldType:goog.proto2.Message.FieldType.STRING,type:String},6:{name:"country_code_source",fieldType:goog.proto2.Message.FieldType.ENUM,defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED,type:i18n.phonenumbers.PhoneNumber.CountryCodeSource},
7:{name:"preferred_domestic_carrier_code",fieldType:goog.proto2.Message.FieldType.STRING,type:String}}));return a};i18n.phonenumbers.PhoneNumber.ctor=i18n.phonenumbers.PhoneNumber;i18n.phonenumbers.PhoneNumber.ctor.getDescriptor=i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;/*

 Copyright (C) 2010 The Libphonenumber Authors

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.metadata={};
i18n.phonenumbers.metadata.countryCodeToRegionCodeMap={1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),7:["RU","KZ"],20:["EG"],27:["ZA"],30:["GR"],31:["NL"],32:["BE"],33:["FR"],34:["ES"],36:["HU"],39:["IT","VA"],40:["RO"],41:["CH"],43:["AT"],44:["GB","GG","IM","JE"],45:["DK"],46:["SE"],47:["NO","SJ"],48:["PL"],49:["DE"],51:["PE"],52:["MX"],53:["CU"],54:["AR"],55:["BR"],56:["CL"],57:["CO"],58:["VE"],60:["MY"],61:["AU","CC","CX"],62:["ID"],63:["PH"],64:["NZ"],
65:["SG"],66:["TH"],81:["JP"],82:["KR"],84:["VN"],86:["CN"],90:["TR"],91:["IN"],92:["PK"],93:["AF"],94:["LK"],95:["MM"],98:["IR"],211:["SS"],212:["MA","EH"],213:["DZ"],216:["TN"],218:["LY"],220:["GM"],221:["SN"],222:["MR"],223:["ML"],224:["GN"],225:["CI"],226:["BF"],227:["NE"],228:["TG"],229:["BJ"],230:["MU"],231:["LR"],232:["SL"],233:["GH"],234:["NG"],235:["TD"],236:["CF"],237:["CM"],238:["CV"],239:["ST"],240:["GQ"],241:["GA"],242:["CG"],243:["CD"],244:["AO"],245:["GW"],246:["IO"],247:["AC"],248:["SC"],
249:["SD"],250:["RW"],251:["ET"],252:["SO"],253:["DJ"],254:["KE"],255:["TZ"],256:["UG"],257:["BI"],258:["MZ"],260:["ZM"],261:["MG"],262:["RE","YT"],263:["ZW"],264:["NA"],265:["MW"],266:["LS"],267:["BW"],268:["SZ"],269:["KM"],290:["SH","TA"],291:["ER"],297:["AW"],298:["FO"],299:["GL"],350:["GI"],351:["PT"],352:["LU"],353:["IE"],354:["IS"],355:["AL"],356:["MT"],357:["CY"],358:["FI","AX"],359:["BG"],370:["LT"],371:["LV"],372:["EE"],373:["MD"],374:["AM"],375:["BY"],376:["AD"],377:["MC"],378:["SM"],380:["UA"],
381:["RS"],382:["ME"],383:["XK"],385:["HR"],386:["SI"],387:["BA"],389:["MK"],420:["CZ"],421:["SK"],423:["LI"],500:["FK"],501:["BZ"],502:["GT"],503:["SV"],504:["HN"],505:["NI"],506:["CR"],507:["PA"],508:["PM"],509:["HT"],590:["GP","BL","MF"],591:["BO"],592:["GY"],593:["EC"],594:["GF"],595:["PY"],596:["MQ"],597:["SR"],598:["UY"],599:["CW","BQ"],670:["TL"],672:["NF"],673:["BN"],674:["NR"],675:["PG"],676:["TO"],677:["SB"],678:["VU"],679:["FJ"],680:["PW"],681:["WF"],682:["CK"],683:["NU"],685:["WS"],686:["KI"],
687:["NC"],688:["TV"],689:["PF"],690:["TK"],691:["FM"],692:["MH"],800:["001"],808:["001"],850:["KP"],852:["HK"],853:["MO"],855:["KH"],856:["LA"],870:["001"],878:["001"],880:["BD"],881:["001"],882:["001"],883:["001"],886:["TW"],888:["001"],960:["MV"],961:["LB"],962:["JO"],963:["SY"],964:["IQ"],965:["KW"],966:["SA"],967:["YE"],968:["OM"],970:["PS"],971:["AE"],972:["IL"],973:["BH"],974:["QA"],975:["BT"],976:["MN"],977:["NP"],979:["001"],992:["TJ"],993:["TM"],994:["AZ"],995:["GE"],996:["KG"],998:["UZ"]};
i18n.phonenumbers.metadata.countryToMetadata={AC:[,[,,"(?:[01589]\\d|[46])\\d{4}",,,,,,,[5,6]],[,,"6[2-467]\\d{3}",,,,"62889",,,[5]],[,,"4\\d{4}",,,,"40123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AC",247,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:0[1-9]|[1589]\\d)\\d{4}",,,,"542011",,,[6]],,,[,,,,,,,,,[-1]]],AD:[,[,,"(?:1|6\\d)\\d{7}|[135-9]\\d{5}",,,,,,,[6,8,9]],[,,"[78]\\d{5}",,,,"712345",,,[6]],[,,"690\\d{6}|[356]\\d{5}",,,,"312345",
,,[6,9]],[,,"180[02]\\d{4}",,,,"18001234",,,[8]],[,,"[19]\\d{5}",,,,"912345",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AD",376,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],[,"(\\d{4})(\\d{4})","$1 $2",["1"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],,[,,,,,,,,,[-1]],,,[,,"1800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AE:[,[,,"(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"[2-4679][2-8]\\d{6}",,,,"22345678",,,[8],[7]],
[,,"5[024-68]\\d{7}",,,,"501234567",,,[9]],[,,"400\\d{6}|800\\d{2,9}",,,,"800123456"],[,,"900[02]\\d{5}",,,,"900234567",,,[9]],[,,"700[05]\\d{5}",,,,"700012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AE",971,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],[,"(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"600[25]\\d{5}",,,,"600212345",
,,[9]],,,[,,,,,,,,,[-1]]],AF:[,[,,"[2-7]\\d{8}",,,,,,,[9],[7]],[,,"(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",,,,"234567890",,,,[7]],[,,"7\\d{8}",,,,"701234567",,,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AF",93,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
AG:[,[,,"(?:268|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",,,,"2684601234",,,,[7]],[,,"268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}",,,,"2684641234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"26848[01]\\d{4}",,,,"2684801234",,,,[7]],"AG",1,"011","1",,,"1|([457]\\d{6})$","268$1",,,,,[,,"26840[69]\\d{4}",,,,"2684061234",,,,[7]],,"268",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AI:[,[,,"(?:264|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"264(?:292|4(?:6[12]|9[78]))\\d{4}",,,,"2644612345",,,,[7]],[,,"264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}",,,,"2642351234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,
,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AI",1,"011","1",,,"1|([2457]\\d{6})$","264$1",,,,,[,,"264724\\d{4}",,,,"2647241234",,,,[7]],,"264",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AL:[,[,,"(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
,,,,,,[6,7,8,9],[5]],[,,"4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}",,,,"22345678",,,[8],[5,6,7]],[,,"6(?:[78][2-9]|9\\d)\\d{6}",,,,"672123456",,,[9]],[,,"800\\d{4}",,,,"8001234",,,[7]],[,,"900[1-9]\\d\\d",,,,"900123",,,[6]],[,,"808[1-9]\\d\\d",,,,"808123",,,[6]],[,,"700[2-9]\\d{4}",,,,"70021234",,,[8]],[,,,,,,,,,[-1]],"AL",355,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AM:[,[,,"(?:[1-489]\\d|55|60|77)\\d{6}",,,,,,,[8],[5,6]],[,,"(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}",,,,"10123456",,,,[5,6]],[,,"(?:33|4[1349]|55|77|88|9[13-9])\\d{6}",,,,"77123456"],[,,"800\\d{5}",,,,"80012345"],
[,,"90[016]\\d{5}",,,,"90012345"],[,,"80[1-4]\\d{5}",,,,"80112345"],[,,,,,,,,,[-1]],[,,"60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}",,,,"60271234"],"AM",374,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],[,"(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AO:[,[,,"[29]\\d{8}",,,,,,,[9]],[,,"2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
,,,"222123456"],[,,"9[1-49]\\d{7}",,,,"923123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AO",244,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AR:[,[,,"(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",,,,,,,[10,11],[6,7,8]],[,,"3888[013-9]\\d{5}|(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"1123456789",,,[10],[6,7,8]],[,,"93888[013-9]\\d{5}|9(?:29(?:54|66)|3(?:777|865))[2-8]\\d{5}|93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|302|657|920)|3(?:4(?:8[27]|92)|541|755|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|32[03]|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-8]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:[03][45]|[17][2-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
,,,"91123456789",,,,[6,7,8]],[,,"800\\d{7,8}",,,,"8001234567"],[,,"60[04579]\\d{7}",,,,"6001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AR",54,"00","0",,,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
"9$1",,,[[,"(\\d{3})","$1",["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]],[,"(\\d{2})(\\d{4})","$1-$2",["[1-9]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[1-8]"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1"],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1"]],[[,"(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
"2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],
"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",,1],[,"(\\d)(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
"9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"]],
[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3-$4",["91"]],[,"(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3-$4",["9"]]],[,,,,,,,,,[-1]],,,[,,"810\\d{7}",,,,,,,[10]],[,,"810\\d{7}",,,,"8101234567",,,[10]],,,[,,,,,,,,,[-1]]],AS:[,[,,"(?:[58]\\d\\d|684|900)\\d{7}",,,,,,,[10],[7]],[,,"6846(?:22|33|44|55|77|88|9[19])\\d{4}",,,,"6846221234",,,,[7]],[,,"684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}",,,,"6847331234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"AS",1,"011","1",,,"1|([267]\\d{6})$","684$1",,,,,[,,,,,,,,,[-1]],,"684",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AT:[,[,,"1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
,,,,,,[4,5,6,7,8,9,10,11,12,13],[3]],[,,"1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}",,,,"1234567890",,,,[3]],[,,"6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}",,,,"664123456",,,[7,8,9,10,11,12,13]],[,,"800\\d{6,10}",
,,,"800123456",,,[9,10,11,12,13]],[,,"9(?:0[01]|3[019])\\d{6,10}",,,,"900123456",,,[9,10,11,12,13]],[,,"8(?:10|2[018])\\d{6,10}|828\\d{5}",,,,"810123456",,,[8,9,10,11,12,13]],[,,,,,,,,,[-1]],[,,"5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}",,,,"780123456",,,[5,6,7,8,9,10,11,12,13]],"AT",43,"00","0",,,"0",,,,[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{3,10})",
"$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[[,"(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],[,"(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],[,"(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],[,"(\\d{4})(\\d{3,9})",
"$1 $2",["[2-467]|5[2-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AU:[,[,,"1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",,,,,,,[5,6,7,8,9,10]],[,,"(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
,,,"212345678",,,[9],[8]],[,,"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,,"1300123456",,,[6,8,10]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"AU",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|(183[12])",,"0011",,
[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["13"]],[,"(\\d{3})(\\d{3})","$1 $2",["19"]],[,"(\\d{3})(\\d{4})","$1 $2",["180","1802"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["19"]],[,"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[[,"(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],[,
"(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)","$CC ($1)"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],[,,"163\\d{2,6}",,,,"1631234",,,[5,6,7,8,9]],1,,[,,"1[38]00\\d{6}|1(?:345[0-4]|802)\\d{3}|13\\d{4}",,,,,,,[6,7,8,10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AW:[,[,,"(?:[25-79]\\d\\d|800)\\d{4}",,,,,,,[7]],[,,"5(?:2\\d|8[1-9])\\d{4}",,,,"5212345"],[,,"(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}",
,,,"5601234"],[,,"800\\d{4}",,,,"8001234"],[,,"900\\d{4}",,,,"9001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:28\\d|501)\\d{4}",,,,"5011234"],"AW",297,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],AX:[,[,,"2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"18[1-8]\\d{3,6}",,,,"181234567",,,[6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",,,,"412345678",
,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AX",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,,,[,,,,,,,,,[-1]],,"18",[,,,,,,,,,[-1]],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",,,,"10112345"],,,[,,,,,,,,,[-1]]],AZ:[,[,,"365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",,,
,,,,[9],[7]],[,,"(?:222[0-79]\\d|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}|(?:(?:1[28]|46)\\d|2(?:[045]2|1[24]|2[34]|33|6[23]))\\d{6}",,,,"123123456",,,,[7]],[,,"(?:36554|99[2-9]\\d\\d)\\d{4}|(?:[16]0|4[04]|5[015]|7[07])\\d{7}",,,,"401234567"],[,,"88\\d{7}",,,,"881234567"],[,,"900200\\d{3}",,,,"900200123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"AZ",994,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[1-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365|46","1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,
[-1]]],BA:[,[,,"6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",,,,,,,[8,9],[6]],[,,"(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}",,,,"30212345",,,[8],[6]],[,,"6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}",,,,"61123456"],[,,"8[08]\\d{6}",,,,"80123456",,,[8]],[,,"9[0246]\\d{6}",,,,"90123456",,,[8]],[,,"8[12]\\d{6}",,,,"82123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BA",387,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})",
"$1-$2",["[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}",,,,"70341234",
,,[8]],,,[,,,,,,,,,[-1]]],BB:[,[,,"(?:246|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}",,,,"2464123456",,,,[7]],[,,"246(?:2(?:[3568]\\d|4[0-57-9])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}",,,,"2462501234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"(?:246976|900[2-9]\\d\\d)\\d{4}",,,,"9002123456",,,,[7]],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,"24631\\d{5}",,,,"2463101234",,,,[7]],"BB",1,"011","1",,,"1|([2-9]\\d{6})$","246$1",,,,,[,,,,,,,,,[-1]],,"246",[,,,,,,,,,[-1]],[,,"246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}",,,,"2464301234",,,,[7]],,,[,,,,,,,,,[-1]]],BD:[,[,,"[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",,,,,,,[6,7,8,9,10]],[,,"(?:465[3578]\\d{4}|8332[6-9])\\d\\d|465(?:(?:3|[57]\\d)\\d{3,4}|8\\d{3})|(?:3(?:03[56]|224)|422[25])\\d{3,4}|(?:4(?:31\\d\\d|423|65(?:28|4\\d))|5222)\\d{3}(?:\\d{2})?|(?:3(?:42[47]|529|823)|4(?:027|525)|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|56\\d)|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|627)|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:(?:[19]3|35|59|6[3-59])\\d\\d|4(?:25|[39]\\d\\d))|4(?:0(?:33|9\\d\\d)|(?:1|2[3-5]\\d)\\d|3(?:32|[459]\\d\\d)|4(?:2[246]|5[25])|6(?:2[35]|[349]\\d\\d|5(?:[019]\\d|2[0-79])|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:21(?:4\\d|7)|3[12]|[5-7]1)|9(?:[24]1|82\\d\\d))\\d{5}|(?:3(?:1(?:2[5-7]|[5-7])|822)|4(?:[257]1|[4689][18])|(?:5[2-57-9]|6[03-589])1)\\d{5}|(?:3[2-8]|[59])1\\d{5}",
,,,"27111234"],[,,"(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}",,,,"1812345678",,,[10]],[,,"80[03]\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}",,,,"9604123456",,,[10]],"BD",880,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1-$2",["38[013-9]|4(?:6[168]|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|8(?:0[014-9]|1|2[1-3])|[34]7|7[2-589]|9[35]|(?:3[2-6]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[248])1|(?:44|66)[01346-9]",
"38[013-9]|4(?:6[168]|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|8(?:0[014-9]|1|2(?:1[78]|[23]))|[34]7|7[2-589]|9[35]|(?:3[2-6]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[248])1|(?:44|66)[01346-9]"],"0$1"],[,"(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],[,"(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BE:[,[,,"4\\d{8}|[1-9]\\d{7}",,,,,,,[8,9]],[,,"80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}",,,,"12345678",
,,[8]],[,,"4[5-9]\\d{7}",,,,"470123456",,,[9]],[,,"800[1-9]\\d{4}",,,,"80012345",,,[8]],[,,"(?:70(?:2[0-57]|3[04-7]|44|69|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[013-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",,,,"90012345",,,[8]],[,,"7879\\d{4}",,,,"78791234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BE",32,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[15-8]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078]|9\\d)\\d{4}",,,,"78102345",,,[8]],,,[,,,,,,,,,[-1]]],BF:[,[,,"[025-7]\\d{7}",,,,,,,[8]],[,,"2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}",,,,"20491234"],[,,"(?:0[1267]|5[1-8]|[67]\\d)\\d{6}",,,,"70123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],"BF",226,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BG:[,[,,"[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",,,,,,,[6,7,8,9],[4,5]],[,,"2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}",,,,"2123456",,,[6,7,8],[4,5]],[,,"43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}",,,,"48123456",,,[8,9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90\\d{6}",,,
,"90123456",,,[8]],[,,"700\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BG",359,"00","0",,,"0",,,,[[,"(\\d{6})","$1",["1"]],[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[[,"(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],
[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BH:[,[,,"[136-9]\\d{7}",,,,,,,[8]],[,,"(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",,,,"17001234"],[,,"(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}",,,,"36001234"],[,,"80\\d{6}",,,,"80123456"],[,
,"(?:87|9[014578])\\d{6}",,,,"90123456"],[,,"84\\d{6}",,,,"84123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BH",973,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[13679]|8[047]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BI:[,[,,"(?:[267]\\d|31)\\d{6}",,,,,,,[8]],[,,"22\\d{6}",,,,"22201234"],[,,"(?:29|31|6[1289]|7[125-9])\\d{6}",,,,"79561234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BI",257,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[2367]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BJ:[,[,,"[25689]\\d{7}",,,,,,,[8]],[,,"2(?:02|1[037]|2[45]|3[68])\\d{5}",,,,"20211234"],[,,"(?:5[1-35-8]|6\\d|9[013-9])\\d{6}",,,,"90011234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"857[58]\\d{4}",,,,"85751234"],"BJ",229,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25689]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"81\\d{6}",,,,"81123456"],,,[,,,,,,,,,[-1]]],
BL:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:2[7-9]|5[12]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"BL",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BM:[,[,,"(?:441|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",,,,"4414123456",,,,[7]],
[,,"441(?:[2378]\\d|5[0-39])\\d{5}",,,,"4413701234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"BM",1,"011","1",,,"1|([2-8]\\d{6})$","441$1",,,,,[,,,,,,,,,[-1]],
,"441",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BN:[,[,,"[2-578]\\d{6}",,,,,,,[7]],[,,"22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}",,,,"2345678"],[,,"(?:22[89]|[78]\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[34]\\d{5}",,,,"5345678"],"BN",673,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BO:[,[,,"(?:[2-467]\\d\\d|8001)\\d{5}",,,,,,,[8,9],[7]],[,,"(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}",
,,,"22123456",,,[8],[7]],[,,"[67]\\d{7}",,,,"71234567",,,[8]],[,,"8001[07]\\d{4}",,,,"800171234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BO",591,"00(?:1\\d)?","0",,,"0(1\\d)?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[23]|4[46]"],,"0$CC $1"],[,"(\\d{8})","$1",["[67]"],,"0$CC $1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"],,"0$CC $1"]],,[,,,,,,,,,[-1]],,,[,,"8001[07]\\d{4}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BQ:[,[,,"(?:[34]1|7\\d)\\d{5}",,,,,,,[7]],[,,"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}",
,,,"7151234"],[,,"(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}",,,,"3181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BQ",599,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"[347]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BR:[,[,,"(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",,,,,,,[8,9,10,11]],[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}",,,,"1123456789",,,[10],[8]],
[,,"(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}",,,,"11961234567",,,[10,11],[8,9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"300\\d{6}|[59]00\\d{6,7}",,,,"300123456",,,[9,10]],[,,"300\\d{7}|[34]00\\d{5}|4(?:02|37)0\\d{4}",,,,"40041234",,,[8,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BR",55,"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","0",,,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2",,,[[,"(\\d{3,6})","$1",["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]],
[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],[,"(\\d{4})(\\d{4})","$1-$2",["[2-57]","[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{5})(\\d{4})","$1-$2",["9"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[[,"(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)",
"4(?:02|37)0|[34]00"]],[,"(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)","0 $CC ($1)"],[,"(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)","0 $CC ($1)"]],[,,,,,,,,,[-1]],,,[,,"4020\\d{4}|[34]00\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BS:[,[,,"(?:242|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
,,,"2423456789",,,,[7]],[,,"242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}",,,,"2423591234",,,,[7]],[,,"242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456",,,,[7]],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"BS",1,"011","1",,,"1|([3-8]\\d{6})$","242$1",,,,,[,,,,,,,,,[-1]],,"242",[,,,,,,,,,[-1]],[,,"242225\\d{4}",,,,"2422250123"],,,[,,,,,,,,,[-1]]],BT:[,[,,"[17]\\d{7}|[2-8]\\d{6}",,,,,,,[7,8],[6]],[,,"(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}",,,,"2345678",,,[7],[6]],[,,"(?:1[67]|77)\\d{6}",,,,"17123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BT",975,"00",,,,,,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{3})",
"$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BW:[,[,,"(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
,,,"2401234",,,[7]],[,,"(?:321|7(?:[1-7]\\d|8[01]))\\d{5}",,,,"71123456",,,[8]],[,,"(?:0800|800\\d)\\d{6}",,,,"0800012345",,,[10]],[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"79(?:1(?:[01]\\d|20)|2[0-2]\\d)\\d{3}",,,,"79101234",,,[8]],"BW",267,"00",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["90"]],[,"(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-79]"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",
["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BY:[,[,,"(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}",,,,"152450911",,,[9],[5,6,7]],[,,"(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
,,,"294911911",,,[9]],[,,"800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",,,,"8011234567"],[,,"(?:810|902)\\d{7}",,,,"9021234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"249\\d{6}",,,,"249123456",,,[9]],"BY",375,"810","8",,,"0|80?",,"8~10",,[[,"(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],[,"(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],[,"(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
"8 0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,"800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],BZ:[,[,,"(?:0800\\d|[2-8])\\d{6}",,,,,,,[7,11]],[,,"(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}",,,,"2221234",,,[7]],[,,"6[0-35-7]\\d{5}",
,,,"6221234",,,[7]],[,,"0800\\d{7}",,,,"08001234123",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"BZ",501,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],[,"(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CA:[,[,,"(?:[2-8]\\d|90)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
,,,"5062345678",,,,[7]],[,,"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",,,,"5062345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}",
,,,"5002345678"],[,,"600[2-9]\\d{6}",,,,"6002012345"],"CA",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CC:[,[,,"1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10]],[,,"8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",,,,"891621234",,,[9],[8]],[,,"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,,"1300123456",,,[6,8,10]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CC",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|([59]\\d{7})$","8$1","0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CD:[,[,,"[189]\\d{8}|[1-68]\\d{6}",,,,,,,[7,9]],[,,"12\\d{7}|[1-6]\\d{6}",
,,,"1234567"],[,,"88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}",,,,"991234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CD",243,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CF:[,[,,"(?:[27]\\d{3}|8776)\\d{4}",,,,,,,
[8]],[,,"2[12]\\d{6}",,,,"21612345"],[,,"7[0257]\\d{6}",,,,"70012345"],[,,,,,,,,,[-1]],[,,"8776\\d{4}",,,,"87761234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CF",236,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CG:[,[,,"(?:0\\d\\d|222|800)\\d{6}",,,,,,,[9]],[,,"222[1-589]\\d{5}",,,,"222123456"],[,,"026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",,,,"061234567"],
[,,,,,,,,,[-1]],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CG",242,"00",,,,,,,,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CH:[,[,,"8\\d{11}|[2-9]\\d{8}",,,,,,,[9,12]],[,,"(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}",,,,"212345678",,,[9]],[,,"7[35-9]\\d{7}",,,,"781234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[016]\\d{6}",
,,,"900123456",,,[9]],[,,"84[0248]\\d{6}",,,,"840123456",,,[9]],[,,"878\\d{6}",,,,"878123456",,,[9]],[,,,,,,,,,[-1]],"CH",41,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],,[,,"74[0248]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"5[18]\\d{7}",,,,"581234567",,,[9]],,,[,,"860\\d{9}",,,,"860123456789",,,[12]]],CI:[,
[,,"[02]\\d{9}",,,,,,,[10]],[,,"2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}",,,,"2123456789"],[,,"0704[0-7]\\d{5}|0(?:[15]\\d\\d|7(?:0[0-37-9]|[4-9][7-9]))\\d{6}",,,,"0123456789"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CI",225,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
CK:[,[,,"[2-578]\\d{4}",,,,,,,[5]],[,,"(?:2\\d|3[13-7]|4[1-5])\\d{3}",,,,"21234"],[,,"[578]\\d{4}",,,,"71234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CK",682,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CL:[,[,,"12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",,,,,,,[9,10,11]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
,,,"221234567",,,[9]],[,,"2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600))|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",,,,"221234567",,,[9]],[,,"(?:123|8)00\\d{6}",,,,"800123456",,,[9,11]],[,,,,,,,,,[-1]],[,,"600\\d{7,8}",,,,"6001234567",
,,[10,11]],[,,,,,,,,,[-1]],[,,"44\\d{7}",,,,"441234567",,,[9]],"CL",56,"(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",,,,,,,1,[[,"(\\d{4})","$1",["1(?:[03-589]|21)|[29]0|78"]],[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[[,"(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-3]"],"($1)"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],[,"(\\d{4})(\\d{3})(\\d{4})",
"$1 $2 $3",["1"]],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]],[,,,,,,,,,[-1]],,,[,,"600\\d{7,8}",,,,,,,[10,11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CM:[,[,,"[26]\\d{8}|88\\d{6,7}",,,,,,,[8,9]],[,,"2(?:22|33)\\d{6}",,,,"222123456",,,[9]],[,,"(?:24[23]|6[5-9]\\d)\\d{6}",,,,"671234567",,,[9]],[,,"88\\d{6,7}",,,,"88012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CM",237,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4 $5",["[26]|88"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CN:[,[,,"1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",,,,,,,[7,8,9,10,11,12],[5,6]],[,,"(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
,,,"1012345678",,,[7,8,9,10,11],[5,6]],[,,"1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}",,,,"13123456789",,,[11]],[,,"(?:(?:10|21)8|8)00\\d{7}",,,,"8001234567",,,[10,12]],[,,"16[08]\\d{5}",,,,"16812345",,,[8]],[,,"400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
,,,"4001234567",,,[7,8,9,10,11],[5,6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CN",86,"00|1(?:[12]\\d|79)\\d\\d00","0",,,"0|(1(?:[12]\\d|79)\\d\\d)",,"00",,[[,"(\\d{5,6})","$1",["96"]],[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],[,"(\\d{4})(\\d{4})",
"$1 $2",["16[08]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
"85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],
"0$1","$CC $1"],[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]","1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])","26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
"26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})",
"$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[[,"(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","(?:10|2[0-57-9])(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
"(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
"85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1","$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
"0$1","$CC $1",1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{7,8})","$1 $2",["9"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1","$CC $1",1],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"],,"$CC $1"],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}",,,,,,,[10,11,12]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CO:[,[,,"(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}",,,,,,,[8,10,11],[7]],[,,"60[124-8][2-9]\\d{6}|[124-8][2-9]\\d{6}",,,,"12345678",,,[8,10],[7]],[,,"3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[2-6]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}",,,,"3211234567",,,[10]],[,,"1800\\d{7}",
,,,"18001234567",,,[11]],[,,"19(?:0[01]|4[78])\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CO",57,"00(?:4(?:[14]4|56)|[579])","0",,,"0([3579]|4(?:[14]4|56))?",,,,[[,"(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["[39]"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1"]],[[,"(\\d)(\\d{7})","$1 $2",["[146][2-9]|[2578]"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})",
"$1 $2",["6"],"($1)","0$CC $1"],[,"(\\d{3})(\\d{7})","$1 $2",["[39]"],,"0$CC $1"],[,"(\\d)(\\d{3})(\\d{7})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CR:[,[,,"(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",,,,,,,[8,10]],[,,"210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",,,,"22123456",,,[8]],[,,"(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}",,,,"83123456",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"90[059]\\d{7}",,,,"9001234567",,
,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210[0-6]|4\\d{3}|5100)\\d{4}",,,,"40001234",,,[8]],"CR",506,"00",,,,"(19(?:0[0-2468]|1[09]|20|66|77|99))",,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CU:[,[,,"[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}",,,,,,,[6,7,8,10],[4,5]],[,,"(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
,,,"71234567",,,,[4,5]],[,,"5\\d{7}",,,,"51234567",,,[8]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,,,,,,,,[-1]],[,,"807\\d{7}",,,,"8071234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CU",53,"119","0",,,"0",,,,[[,"(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],[,"(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["5"],"0$1"],[,"(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CV:[,[,,"(?:[2-59]\\d\\d|800)\\d{4}",,
,,,,,[7]],[,,"2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",,,,"2211234"],[,,"(?:[34][36]|5[1-389]|9\\d)\\d{5}",,,,"9911234"],[,,"800\\d{4}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CV",238,"0",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CW:[,[,,"(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",,,,,,,[7,8]],[,,"9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
,,,"94351234"],[,,"953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}",,,,"95181234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"60[0-2]\\d{4}",,,,"6001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"CW",599,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[3467]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],,[,,"955\\d{5}",,,,"95581234",,,[8]],1,"[69]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CX:[,[,,"1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}",,,,,,,[6,7,8,9,10]],[,,"8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
,,,"891641234",,,[9],[8]],[,,"4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",,,,"412345678",,,[9]],[,,"180(?:0\\d{3}|2)\\d{3}",,,,"1800123456",,,[7,10]],[,,"190[0-26]\\d{6}",,,,"1900123456",,,[10]],[,,"13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}",,,,"1300123456",,,[6,8,10]],[,,,,,,,,,[-1]],[,,"14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",,,,"147101234",,,[9]],"CX",61,"001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","0",,,"0|([59]\\d{7})$","8$1",
"0011",,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],CY:[,[,,"(?:[279]\\d|[58]0)\\d{6}",,,,,,,[8]],[,,"2[2-6]\\d{6}",,,,"22345678"],[,,"9[4-79]\\d{6}",,,,"96123456"],[,,"800\\d{5}",,,,"80001234"],[,,"90[09]\\d{5}",,,,"90012345"],[,,"80[1-9]\\d{5}",,,,"80112345"],[,,"700\\d{5}",,,,"70012345"],[,,,,,,,,,[-1]],"CY",357,"00",,,,,,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:50|77)\\d{6}",,,,"77123456"],,,[,,,,,,,,,[-1]]],CZ:[,[,,"(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
,,,,,,[9,10,11,12]],[,,"(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",,,,"212345678",,,[9]],[,,"(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}",,,,"601123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:0[05689]|76)\\d{6}",,,,"900123456",,,[9]],[,,"8[134]\\d{7}",,,,"811234567",,,[9]],[,,"70[01]\\d{6}",,,,"700123456",,,[9]],[,,"9[17]0\\d{6}",,,,"910123456",,,[9]],"CZ",420,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],
[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"9(?:5\\d|7[2-4])\\d{6}",,,,"972123456",,,[9]],,,[,,"9(?:3\\d{9}|6\\d{7,10})",,,,"93123456789"]],DE:[,[,,"[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}",,,,,,,[4,5,6,7,8,9,10,11,12,13,14,15],[2,3]],[,,"32\\d{9,11}|49[2-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
,,,"30123456",,,[5,6,7,8,9,10,11,12,13,14,15],[2,3,4]],[,,"15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}",,,,"15123456789",,,[10,11]],[,,"800\\d{7,12}",,,,"8001234567890",,,[10,11,12,13,14,15]],[,,"(?:137[7-9]|900(?:[135]|9\\d))\\d{6}",,,,"9001234567",,,[10,11]],[,,"180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}",,,,"18012345",,,[7,8,9,10,11,12,13,14]],[,,"700\\d{8}",,,,"70012345678",,,[11]],[,,,,,,,,,[-1]],"DE",49,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],[,"(\\d{3})(\\d{3,12})",
"$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],[,"(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],[,"(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],[,"(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],[,"(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],[,"(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],[,"(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],[,"(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],
[,"(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],[,"(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],,[,,"16(?:4\\d{1,10}|[89]\\d{1,11})",,,,"16412345",,,[4,5,6,7,8,9,10,11,12,13,14]],,,[,,,,,,,,,[-1]],[,,"18(?:1\\d{5,11}|[2-9]\\d{8})",,,,"18500123456",,,[8,9,10,11,12,13,14]],,,[,,"1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
,,,"177991234567",,,[12,13]]],DJ:[,[,,"(?:2\\d|77)\\d{6}",,,,,,,[8]],[,,"2(?:1[2-5]|7[45])\\d{5}",,,,"21360003"],[,,"77\\d{6}",,,,"77831001"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DJ",253,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DK:[,[,,"[2-9]\\d{7}",,,,,,,[8]],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",,,,"32123456"],[,,"(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
,,,"32123456"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"DK",45,"00",,,,,,,1,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DM:[,[,,"(?:[58]\\d\\d|767|900)\\d{7}",,,,,,,[10],[7]],[,,"767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",,,,"7674201234",,,,[7]],[,,"767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}",,,,"7672251234",,,,[7]],
[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DM",1,"011","1",,,"1|([2-7]\\d{6})$","767$1",,,,,[,,,,,,,,,[-1]],,"767",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
DO:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",,,,"8092345678",,,,[7]],[,,"8[024]9[2-9]\\d{6}",,,,"8092345678",,,,[7]],[,,"8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"DO",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"8001|8[024]9",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],DZ:[,[,,"(?:[1-4]|[5-79]\\d|80)\\d{7}",,,,,,,[8,9]],[,
,"9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}",,,,"12345678"],[,,"(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}",,,,"551234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"80[3-689]1\\d{5}",,,,"808123456",,,[9]],[,,"80[12]1\\d{5}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,"98[23]\\d{6}",,,,"983123456",,,[9]],"DZ",213,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EC:[,[,,"1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",,,,,,,[8,9,10,11],[7]],[,,"[2-7][2-7]\\d{6}",,,,"22123456",,,[8],[7]],[,,"964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}",,,,"991234567",,,[9]],[,,"1800\\d{7}|1[78]00\\d{6}",,,,"18001234567",,,[10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[2-7]890\\d{4}",,,,"28901234",,,[8]],"EC",593,"00","0",,,
"0",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-7]"]],[,"(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-7]"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EE:[,[,,"8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",,,,,,,[7,8,10]],[,,"(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
,,,"3212345",,,[7]],[,,"5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",,,,"51234567",,,[7,8]],[,,"800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}",,,,"80012345"],[,,"(?:40\\d\\d|900)\\d{4}",,,,"9001234",
,,[7,8]],[,,,,,,,,,[-1]],[,,"70[0-2]\\d{5}",,,,"70012345",,,[8]],[,,,,,,,,,[-1]],"EE",372,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],[,"(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,"800[2-9]\\d{3}",,,,,,,[7]],[,,,,,,,
,,[-1]],,,[,,,,,,,,,[-1]]],EG:[,[,,"[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}",,,,"234567890",,,[8,9],[6,7]],[,,"1[0-25]\\d{8}",,,,"1001234567",,,[10]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"EG",20,"00","0",,,"0",,,,[[,"(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],[,"(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],
"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[189]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],EH:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"528[89]\\d{5}",,,,"528812345"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"EH",212,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"528[89]",[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ER:[,[,,"[178]\\d{6}",,,,,,,[7],[6]],[,,"(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}",,,,"8370362",,,,[6]],[,,"(?:17[1-3]|7\\d\\d)\\d{4}",,,,"7123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ER",291,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ES:[,[,,"[5-9]\\d{8}",,,,,,,[9]],[,,"96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
,,,"810123456"],[,,"(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}",,,,"612345678"],[,,"[89]00\\d{6}",,,,"800123456"],[,,"80[367]\\d{6}",,,,"803123456"],[,,"90[12]\\d{6}",,,,"901123456"],[,,"70\\d{7}",,,,"701234567"],[,,,,,,,,,[-1]],"ES",34,"00",,,,,,,,[[,"(\\d{4})","$1",["905"]],[,"(\\d{6})","$1",["[79]9"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],
[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"51\\d{7}",,,,"511234567"],,,[,,,,,,,,,[-1]]],ET:[,[,,"(?:11|[2-59]\\d)\\d{7}",,,,,,,[9],[7]],[,,"11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
,,,"111112345",,,,[7]],[,,"9\\d{8}",,,,"911234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ET",251,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FI:[,[,,"[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",,,,,,,[5,6,7,8,9,10,11,12]],[,,"(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",,,,"131234567",,,[5,6,7,8,9]],[,,"4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
,,,"412345678",,,[6,7,8,9,10]],[,,"800\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"[67]00\\d{5,6}",,,,"600123456",,,[8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FI",358,"00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","0",,,"0",,"00",,[[,"(\\d{5})","$1",["75[12]"],"0$1"],[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{6})","$1",["11"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,
"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[[,"(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],[,"(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],[,"(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],[,"(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],[,,,,,,,,,[-1]],1,"1[03-79]|[2-9]",[,,"20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],[,,"20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
,,,"10112345"],,,[,,,,,,,,,[-1]]],FJ:[,[,,"45\\d{5}|(?:0800\\d|[235-9])\\d{6}",,,,,,,[7,11]],[,,"603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}",,,,"3212345",,,[7]],[,,"(?:[279]\\d|45|5[01568]|8[034679])\\d{5}",,,,"7012345",,,[7]],[,,"0800\\d{7}",,,,"08001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FJ",679,"0(?:0|52)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]]],FK:[,[,,"[2-7]\\d{4}",,,,,,,[5]],[,,"[2-47]\\d{4}",,,,"31234"],[,,"[56]\\d{4}",,,,"51234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FK",500,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FM:[,[,,"(?:[39]\\d\\d|820)\\d{4}",,,,,,,[7]],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",,,,"3201234"],[,,"31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
,,,"3501234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"FM",691,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[389]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FO:[,[,,"[2-9]\\d{5}",,,,,,,[6]],[,,"(?:20|[34]\\d|8[19])\\d{4}",,,,"201234"],[,,"(?:[27][1-9]|5\\d|91)\\d{4}",,,,"211234"],[,,"80[257-9]\\d{3}",,,,"802123"],[,,"90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",,,,"901123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:6[0-36]|88)\\d{4}",,
,,"601234"],"FO",298,"00",,,,"(10(?:01|[12]0|88))",,,,[[,"(\\d{6})","$1",["[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],FR:[,[,,"[1-9]\\d{8}",,,,,,,[9]],[,,"(?:[1-35]\\d|4[1-9])\\d{7}",,,,"123456789"],[,,"(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}",,,,"612345678"],[,,"80[0-5]\\d{6}",,,,"801234567"],[,,"836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",,,,"891123456"],[,,"8(?:1[01]|2[0156]|84)\\d{6}",
,,,"884012345"],[,,,,,,,,,[-1]],[,,"9\\d{8}",,,,"912345678"],"FR",33,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["10"]],[,"(\\d{3})(\\d{3})","$1 $2",["1"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"80[6-9]\\d{6}",,,,"806123456"],
,,[,,,,,,,,,[-1]]],GA:[,[,,"(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",,,,,,,[7,8]],[,,"[01]1\\d{6}",,,,"01441234",,,[8]],[,,"(?:0[2-7]|6[256]|7[47])\\d{6}|[2-7]\\d{6}",,,,"06031234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GA",241,"00",,,,"0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})","$1",,,[[,"(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["0"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GB:[,[,,"[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",,,,,,,[7,9,10],[4,5,6,8]],[,,"(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[02459]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
,,,"1212345678",,,[9,10],[4,5,6,7,8]],[,,"7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",,,,"7400123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",
,,[10]],"GB",44,"00","0"," x",,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])",
"[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,,"7640123456",,,[10]],1,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GD:[,[,,"(?:473|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
,,,"4732691234",,,,[7]],[,,"473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}",,,,"4734031234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GD",
1,"011","1",,,"1|([2-9]\\d{6})$","473$1",,,,,[,,,,,,,,,[-1]],,"473",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GE:[,[,,"(?:[3-57]\\d\\d|800)\\d{6}",,,,,,,[9],[6,7]],[,,"(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}",,,,"322123456",,,,[6,7]],[,,"5(?:(?:0555|1177)[5-9]|757(?:7[7-9]|8[01]))\\d{3}|5(?:0070|(?:11|33)33|[25]222)[0-4]\\d{3}|5(?:00(?:0\\d|50)|11(?:00|1\\d|2[0-4])|5200|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
,,,"555123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70[67]\\d{6}",,,,"706123456"],"GE",995,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"70[67]\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GF:[,[,,"(?:[56]94|80\\d|976)\\d{6}",
,,,,,,[9]],[,,"594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[0-4])\\d{4}",,,,"594101234"],[,,"694(?:[0-249]\\d|3[0-48])\\d{4}",,,,"694201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976\\d{6}",,,,"976012345"],"GF",594,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GG:[,[,,"(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
,,,,,,[7,9,10],[6]],[,,"1481[25-9]\\d{5}",,,,"1481256789",,,[10],[6]],[,,"7(?:(?:781|839)\\d|911[17])\\d{5}",,,,"7781123456",,,[10]],[,,"80[08]\\d{7}|800\\d{6}|8001111",,,,"8001234567"],[,,"(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",,,,"9012345678",,,[7,10]],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,"56\\d{8}",,,,"5612345678",,,[10]],"GG",44,"00","0",,,"0|([25-9]\\d{5})$","1481$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",
,,,"7640123456",,,[10]],,,[,,,,,,,,,[-1]],[,,"(?:3[0347]|55)\\d{8}",,,,"5512345678",,,[10]],,,[,,,,,,,,,[-1]]],GH:[,[,,"(?:[235]\\d{3}|800)\\d{5}",,,,,,,[8,9],[7]],[,,"3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}",,,,"302345678",,,[9],[7]],[,,"(?:2(?:[0346-8]\\d|5[67])|5(?:[0457]\\d|6[01]|9[1-9]))\\d{6}",,,,"231234567",,,[9]],[,,"800\\d{5}",,,,"80012345",
,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GH",233,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[237]|8[0-2]"]],[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[[,"(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"800\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GI:[,[,,"(?:[25]\\d\\d|606)\\d{5}",,,,,,,[8]],[,,"21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}",
,,,"20012345"],[,,"(?:5[146-8]\\d|606)\\d{5}",,,,"57123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GI",350,"00",,,,,,,,[[,"(\\d{3})(\\d{5})","$1 $2",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GL:[,[,,"(?:19|[2-689]\\d|70)\\d{4}",,,,,,,[6]],[,,"(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}",,,,"321000"],[,,"[245]\\d{5}",,,,"221234"],[,,"80\\d{4}",,,,"801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3[89]\\d{4}",
,,,"381234"],"GL",299,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GM:[,[,,"[2-9]\\d{6}",,,,,,,[7]],[,,"(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}",,,,"5661234"],[,,"(?:[23679]\\d|5[0-389])\\d{5}",,,,"3012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GM",220,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",
["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GN:[,[,,"722\\d{6}|(?:3|6\\d)\\d{7}",,,,,,,[8,9]],[,,"3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}",,,,"30241234",,,[8]],[,,"6[0-356]\\d{7}",,,,"601123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"722\\d{6}",,,,"722123456",,,[9]],"GN",224,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[67]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GP:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}",,,,"590201234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"GP",590,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",
["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GQ:[,[,,"222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",,,,,,,[9]],[,,"33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}",,,,"333091234"],[,,"(?:222|55\\d)\\d{6}",,,,"222123456"],[,,"80\\d[1-9]\\d{5}",,,,"800123456"],[,,"90\\d[1-9]\\d{5}",,,,"900123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GQ",240,"00",,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",
["[235]"]],[,"(\\d{3})(\\d{6})","$1 $2",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GR:[,[,,"5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",,,,,,,[10,11,12]],[,,"2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
,,,"2123456789",,,[10]],[,,"68[57-9]\\d{7}|(?:69|94)\\d{8}",,,,"6912345678",,,[10]],[,,"800\\d{7,9}",,,,"8001234567"],[,,"90[19]\\d{7}",,,,"9091234567",,,[10]],[,,"8(?:0[16]|12|[27]5|50)\\d{7}",,,,"8011234567",,,[10]],[,,"70\\d{8}",,,,"7012345678",,,[10]],[,,,,,,,,,[-1]],"GR",30,"00",,,,,,,,[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],[,"(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],[,"(\\d{3})(\\d{3,4})(\\d{5})",
"$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"5005000\\d{3}",,,,"5005000123",,,[10]],,,[,,,,,,,,,[-1]]],GT:[,[,,"(?:1\\d{3}|[2-7])\\d{7}",,,,,,,[8,11]],[,,"[267][2-9]\\d{6}",,,,"22456789",,,[8]],[,,"[3-5]\\d{7}",,,,"51234567",,,[8]],[,,"18[01]\\d{8}",,,,"18001112222",,,[11]],[,,"19\\d{9}",,,,"19001112222",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GT",502,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GU:[,[,,"(?:[58]\\d\\d|671|900)\\d{7}",,,,,,,[10],[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",,,,"6713001234",,,,[7]],[,,"671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
,,,"6713001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"GU",1,"011","1",,,"1|([3-9]\\d{6})$","671$1",,1,,,[,,,,,,,,,[-1]],,"671",[,,,,,,,,,[-1]],[,,,,,,,
,,[-1]],,,[,,,,,,,,,[-1]]],GW:[,[,,"[49]\\d{8}|4\\d{6}",,,,,,,[7,9]],[,,"443\\d{6}",,,,"443201234",,,[9]],[,,"9(?:5\\d|6[569]|77)\\d{6}",,,,"955012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"40\\d{5}",,,,"4012345",,,[7]],"GW",245,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["40"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],GY:[,[,,"(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}",,,,,,,[7]],
[,,"(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",,,,"2201234"],[,,"6\\d{6}",,,,"6091234"],[,,"(?:289|862)\\d{4}",,,,"2891234"],[,,"9008\\d{3}",,,,"9008123"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"GY",592,"001",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HK:[,[,,"8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",,,,,,,[5,
6,7,8,9,11]],[,,"(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-6]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}",,,,"21234567",,,[8]],[,,"(?:46(?:[07][0-7]|1[0-6]|4[0-57-9]|5[0-8]|6[0-4])|5730|6(?:26[013-7]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|929[03-9])\\d{4}|(?:46[238]|5(?:[1-59][0-46-9]|6[0-4689]|7[0-2469])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}",,,,"51234567",,,[8]],[,,"800\\d{6}",,,,"800123456",
,,[9]],[,,"900(?:[0-24-9]\\d{7}|3\\d{1,4})",,,,"90012345678",,,[5,6,7,8,11]],[,,,,,,,,,[-1]],[,,"8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}",,,,"81123456",,,[8]],[,,,,,,,,,[-1]],"HK",852,"00(?:30|5[09]|[126-9]?)",,,,,,"00",,[[,"(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],,[,,"7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
,,,"71123456",,,[8]],,,[,,,,,,,,,[-1]],[,,"30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}",,,,"30161234",,,[8]],,,[,,,,,,,,,[-1]]],HN:[,[,,"8\\d{10}|[237-9]\\d{7}",,,,,,,[8,11]],[,,"2(?:2(?:0[0-39]|1[1-367]|[23]\\d|4[03-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-9]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|74|80)|6(?:[056]\\d|17|2[07]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",,,,"22123456",,,[8]],[,,"[37-9]\\d{7}",
,,,"91234567",,,[8]],[,,"8002\\d{7}",,,,"80021234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"HN",504,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["8"]]],[[,"(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]],[,,,,,,,,,[-1]],,,[,,"8002\\d{7}",,,,,,,[11]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HR:[,[,,"(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",,,,,,,[6,7,8,9]],[,,"1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
,,,"12345678",,,[8,9],[6,7]],[,,"9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}",,,,"921234567",,,[8,9]],[,,"80[01]\\d{4,6}",,,,"800123456",,,[7,8,9]],[,,"6[01459]\\d{6}|6[01]\\d{4,5}",,,,"611234",,,[6,7,8]],[,,,,,,,,,[-1]],[,,"7[45]\\d{6}",,,,"74123456",,,[8]],[,,,,,,,,,[-1]],"HR",385,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"62\\d{6,7}|72\\d{6}",,,,"62123456",,,[8,9]],,,[,,,,,,,,,[-1]]],HT:[,[,,"[2-489]\\d{7}",,,,,,,[8]],[,,"2(?:2\\d|5[1-5]|81|9[149])\\d{5}",,,,"22453300"],[,,"[34]\\d{7}",,,,"34101234"],[,,"8\\d{7}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
,,,"98901234"],"HT",509,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],HU:[,[,,"[235-7]\\d{8}|[1-9]\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}",,,,"12345678",,,[8],[6,7]],[,,"(?:[257]0|3[01])\\d{7}",,,,"201234567",,,[9]],[,,"(?:[48]0\\d|6802)\\d{5}",,,,"80123456"],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"21\\d{7}",
,,,"211234567",,,[9]],"HU",36,"00","06",,,"06",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],,[,,,,,,,,,[-1]],,,[,,"(?:[48]0\\d|6802)\\d{5}"],[,,"38\\d{7}",,,,"381234567",,,[9]],,,[,,,,,,,,,[-1]]],ID:[,[,,"(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",,,,,,,[7,8,9,10,11,12,13],[5,6]],[,
,"2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",,,,"218350123",,,[7,8,9,10,11],[5,6]],[,,"8[1-35-9]\\d{7,10}",
,,,"812345678",,,[9,10,11,12]],[,,"00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}",,,,"8001234567",,,[8,9,10,11,12,13]],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,"804\\d{7}",,,,"8041234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ID",62,"00[89]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",
["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["001"]],[,"(\\d{2})(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],[,"(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],[,"(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],
[,"(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],[,"(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],[,"(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],[,"(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"001803\\d{6,7}|(?:007803\\d|8071)\\d{6}",,,,,,,[10,12,13]],[,,"(?:1500|8071\\d{3})\\d{3}",,,,"8071123456",,,[7,10]],,,[,,,,,,,,,[-1]]],IE:[,[,,"(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
,,,,,,[7,8,9,10],[5,6]],[,,"(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}",,,,"2212345",,,,[5,6]],[,,"8(?:22|[35-9]\\d)\\d{6}",,,,"850123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,"15(?:1[2-8]|[2-8]0|9[089])\\d{6}",,,,"1520123456",,,[10]],[,,"18[59]0\\d{6}",,,,"1850123456",,,[10]],[,,"700\\d{6}",,,,"700123456",,,[9]],[,,"76\\d{7}",,,,"761234567",,,[9]],"IE",353,"00",
"0",,,"0",,,,[[,"(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],[,"(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],[,"(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["4"],"(0$1)"],[,"(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"18[59]0\\d{6}",,,,,,,[10]],[,,"818\\d{6}",,,,"818123456",,,[9]],,,[,,"88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}",,,,"8551234567",,,[10]]],IL:[,[,,"1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",,,,,,,[7,8,9,10,11,12]],[,,"153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}",,,,"21234567",,,[8,11,12],[7]],[,,"5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
,,,"502345678",,,[9]],[,,"1(?:255|80[019]\\d{3})\\d{3}",,,,"1800123456",,,[7,10]],[,,"1212\\d{4}|1(?:200|9(?:0[01]|19))\\d{6}",,,,"1919123456",,,[8,10]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,"7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[58]|7\\d|82|9[235-9])\\d{6}",,,,"771234567",,,[9]],"IL",972,"0(?:0|1[2-9])","0",,,"0",,,,[[,"(\\d{4})(\\d{3})","$1-$2",["125"]],[,"(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],[,"(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],
[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],[,"(\\d{4})(\\d{6})","$1-$2",["159"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],[,"(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],,[,,,,,,,,,[-1]],,,[,,"1700\\d{6}",,,,,,,[10]],[,,"1599\\d{6}",,,,"1599123456",,,[10]],,,[,,"151\\d{8,9}",,,,"15112340000",,,[11,12]]],IM:[,[,,"1624\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1624(?:230|[5-8]\\d\\d)\\d{3}",,,,"1624756789",
,,,[6]],[,,"76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}",,,,"7924123456"],[,,"808162\\d{4}",,,,"8081624567"],[,,"8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}",,,,"9016247890"],[,,,,,,,,,[-1]],[,,"70\\d{8}",,,,"7012345678"],[,,"56\\d{8}",,,,"5612345678"],"IM",44,"00","0",,,"0|([25-8]\\d{5})$","1624$1",,,,,[,,,,,,,,,[-1]],,"74576|(?:16|7[56])24",[,,,,,,,,,[-1]],[,,"3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}",,,,"5512345678"],,,[,,,,,,,,,[-1]]],
IN:[,[,,"(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",,,,,,,[8,9,10,11,12,13],[6,7]],[,,"2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
,,,"7410410123",,,[10],[6,7,8]],[,,"(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
,,,"8123456789",,,[10]],[,,"000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))",,,,"1800123456"],[,,"186[12]\\d{9}",,,,"1861123456789",,,[13]],[,,"1860\\d{7}",,,,"18603451234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IN",91,"00","0",,,"0",,,,[[,"(\\d{7})","$1",["575"]],[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],,,1]],[[,"(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],,,1],[,"(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],,,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
"1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],
"0$1",,1],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
"1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",,1],[,"(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",,1],[,"(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],,,1],[,"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["18"],,,1]],[,,,,,,,,,[-1]],,,[,,"1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"],[,,"140\\d{7}",,,,"1409305260",,,[10]],,,[,,,,,,,,,[-1]]],IO:[,[,,"3\\d{6}",,,,,,,[7]],[,,"37\\d{5}",,,,"3709100"],[,,"38\\d{5}",,,,"3801234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IO",246,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IQ:[,[,,"(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
,,,,,,[8,9,10],[6,7]],[,,"1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}",,,,"12345678",,,[8,9],[6,7]],[,,"7[3-9]\\d{8}",,,,"7912345678",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IQ",964,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],IR:[,
[,,"[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",,,,,,,[4,5,6,7,10],[8]],[,,"(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}",,,,"2123456789",,,[6,7,10],[4,5,8]],[,,"9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:(?:[0-3]\\d|4[0145])\\d|5[15]0|8(?:1\\d|88)|9(?:0[013]|[19]\\d|21|77|8[7-9])))\\d{5}",,,,"9123456789",,,[10]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"IR",98,"00","0",,,"0",,,,[[,"(\\d{4,5})","$1",["96"],"0$1"],[,"(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))",,,,,,,[4,5,10]],[,,"96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
,,,"9601",,,[4,5]],,,[,,,,,,,,,[-1]]],IS:[,[,,"(?:38\\d|[4-9])\\d{6}",,,,,,,[7,9]],[,,"(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}",,,,"4101234",,,[7]],[,,"(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[28]))\\d{4}",,,,"6111234"],[,,"80[08]\\d{4}",,,,"8001234",,,[7]],[,,"90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"49[0-24-79]\\d{4}",,,,"4921234",,,[7]],"IS",354,"00|1(?:0(?:01|[12]0)|100)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"809\\d{4}",,,,"8091234",,,[7]],,,[,,"(?:689|8(?:7[18]|80)|95[48])\\d{4}",,,,"6891234",,,[7]]],IT:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
,,,"0212345678",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",,,,"800123456",,,[6,9]],[,,"(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"IT",39,"00",,,,,,,,[[,"(\\d{4,5})","$1",["1(?:0|9[246])","1(?:0|9(?:2[2-9]|[46]))"]],
[,"(\\d{6})","$1",["1(?:1|92)"]],[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],[,"(\\d{2})(\\d{4})(\\d{5})",
"$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[[,"(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],[,"(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],[,"(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],[,"(\\d{4})(\\d{4})","$1 $2",["894"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1[4679]|[38]"]],
[,"(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],[,"(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],[,,,,,,,,,[-1]],1,,[,,"848\\d{6}",,,,,,,[9]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],JE:[,[,,"1534\\d{6}|(?:[3578]\\d|90)\\d{8}",,,,,,,[10],[6]],[,,"1534[0-24-8]\\d{5}",,,,"1534456789",,,,[6]],[,,"7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",,,,"7797712345"],
[,,"80(?:07(?:35|81)|8901)\\d{4}",,,,"8007354567"],[,,"(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}",,,,"9018105678"],[,,,,,,,,,[-1]],[,,"701511\\d{4}",,,,"7015115678"],[,,"56\\d{8}",,,,"5612345678"],"JE",44,"00","0",,,"0|([0-24-8]\\d{5})$","1534$1",,,,,[,,"76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}",,,,"7640123456"],,,[,,,,,,,,,[-1]],[,,"(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
,,,"5512345678"],,,[,,,,,,,,,[-1]]],JM:[,[,,"(?:[58]\\d\\d|658|900)\\d{7}",,,,,,,[10],[7]],[,,"8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}",,,,"8765230123",,,,[7]],[,,"(?:658295|876(?:2(?:0[6-9]|[14-9]\\d|2[013-9]|3[7-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
,,,"8762101234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"JM",1,"011","1",,,"1",,,,,,[,,,,,,,,,[-1]],,"658|876",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,
,[-1]]],JO:[,[,,"(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",,,,,,,[8,9]],[,,"87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
,,,"62001234",,,[8]],[,,"7(?:[78][0-25-9]|9\\d)\\d{6}",,,,"790123456",,,[9]],[,,"80\\d{6}",,,,"80012345",,,[8]],[,,"9\\d{7}",,,,"90012345",,,[8]],[,,"85\\d{6}",,,,"85012345",,,[8]],[,,"70\\d{7}",,,,"700123456",,,[9]],[,,,,,,,,,[-1]],"JO",962,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],[,"(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],,[,,"74(?:66|77)\\d{5}",,,,"746612345",
,,[9]],,,[,,,,,,,,,[-1]],[,,"8(?:10|8\\d)\\d{5}",,,,"88101234",,,[8]],,,[,,,,,,,,,[-1]]],JP:[,[,,"00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",,,,,,,[8,9,10,11,12,13,14,15,16,17]],[,,"(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}",,,,"312345678",,,[9]],[,,"[7-9]0[1-9]\\d{7}",
,,,"9012345678",,,[10]],[,,"00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}",,,,"120123456"],[,,"990\\d{6}",,,,"990123456",,,[9]],[,,,,,,,,,[-1]],[,,"60\\d{7}",,,,"601234567",,,[9]],[,,"50[1-9]\\d{7}",,,,"5012345678",,,[10]],"JP",81,"010","0",,,"0",,,,[[,"(\\d{4})(\\d{4})","$1-$2",["007","0077","00777","00777[01]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
"1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{4})(\\d{2})(\\d{3,4})","$1-$2-$3",["007","0077"]],[,"(\\d{4})(\\d{2})(\\d{4})","$1-$2-$3",["008"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3,4})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{4})(\\d{4,5})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{5})(\\d{5,6})","$1-$2-$3",["0"]],[,"(\\d{4})(\\d{6})(\\d{6,7})","$1-$2-$3",
["0"]]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],[,"(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
"1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],
"0$1"],[,"(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],[,,"20\\d{8}",,,,"2012345678",,,[10]],,,[,,"00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],[,,"570\\d{6}",,,,"570123456",,,[9]],,,[,,,,,,,,,[-1]]],KE:[,[,,"(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",,,,,,,[7,8,9,10]],[,,"(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
,,,"202012345",,,[7,8,9]],[,,"(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}",,,,"712123456",,,[9]],[,,"800[24-8]\\d{5,6}",,,,"800223456",,,[9,10]],[,,"900[02-9]\\d{5}",,,,"900223456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KE",254,"000","0",,,"0",,,,[[,"(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KG:[,[,,"8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
,,,,,,[9,10],[5,6]],[,,"312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}",,,,"312123456",,,[9],[5,6]],[,,"312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}",,,,"700123456",,,[9]],[,,"800\\d{6,7}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,
,,,,,,,[-1]],[,,,,,,,,,[-1]],"KG",996,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],[,"(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KH:[,[,,"1\\d{9}|[1-9]\\d{7,8}",,,,,,,[8,9,10],[6,7]],[,,"23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
,,,"23756789",,,[8,9],[6,7]],[,,"(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}",,,,"91234567",,,[8,9]],[,,"1800(?:1\\d|2[019])\\d{4}",,,,"1800123456",,,[10]],[,,"1900(?:1\\d|2[09])\\d{4}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KH",855,"00[14-9]","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],
,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KI:[,[,,"(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",,,,,,,[5,8]],[,,"(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}",,,,"31234"],[,,"(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}",,,,"72001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"30(?:0[01]\\d\\d|12(?:11|20))\\d\\d",,,,"30010000",,,[8]],
"KI",686,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KM:[,[,,"[3478]\\d{6}",,,,,,,[7],[4]],[,,"7[4-7]\\d{5}",,,,"7712345",,,,[4]],[,,"[34]\\d{6}",,,,"3212345"],[,,,,,,,,,[-1]],[,,"8\\d{6}",,,,"8001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KM",269,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KN:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
,,,"8692361234",,,,[7]],[,,"869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}",,,,"8697652917",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"KN",1,"011","1",,,"1|([2-7]\\d{6})$",
"869$1",,,,,[,,,,,,,,,[-1]],,"869",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KP:[,[,,"85\\d{6}|(?:19\\d|[2-7])\\d{7}",,,,,,,[8,10],[6,7]],[,,"(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}",,,,"21234567",,,,[6,7]],[,,"19[1-3]\\d{7}",,,,"1921234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KP",850,"00|99","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})",
"$1 $2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KR:[,[,,"00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",,,,,,,[5,6,8,9,10,11,12,13,14],[3,4,7]],[,,"(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",,,,"22123456",,,[5,6,8,9,10],[3,4,7]],[,,"1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
,,,"1020000000",,,[9,10]],[,,"00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}",,,,"801234567",,,[9,11,12,13,14]],[,,"60[2-9]\\d{6}",,,,"602345678",,,[9]],[,,,,,,,,,[-1]],[,,"50\\d{8,9}",,,,"5012345678",,,[10,11]],[,,"70\\d{8}",,,,"7012345678",,,[10]],"KR",82,"00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","0",,,"0(8(?:[1-46-8]|5\\d\\d))?",,,,[[,"(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"],"0$1"],[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,
"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3})(\\d{3})","$1 $2 $3",["003","0030"]],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"],[,"(\\d{5})(\\d{3,4})(\\d{4})","$1 $2 $3",["0"]],[,"(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3 $4",["0"]]],[[,"(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1","0$CC-$1"],[,"(\\d{4})(\\d{4})","$1-$2",["1"]],[,"(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1","0$CC-$1"],[,"(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1","0$CC-$1"]],[,,"15\\d{7,8}",,,,"1523456789",
,,[9,10]],,,[,,"00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})",,,,,,,[11,12,13,14]],[,,"1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))\\d{4}",,,,"15441234",,,[8]],,,[,,,,,,,,,[-1]]],KW:[,[,,"(?:18|[2569]\\d\\d)\\d{5}",,,,,,,[7,8]],[,,"2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}",,,,"22345678",,,[8]],[,,"(?:5(?:2(?:22|5[25])|7(?:55|77)|88[58])|6(?:222|333|444|70[013-9]|888|93[039])|9(?:11[01]|3(?:00|33)|500))\\d{4}|(?:5(?:[05]\\d|1[0-7]|6[56])|6(?:0[034679]|5[015-9]|6\\d|7[67]|9[069])|9(?:0[09]|22|[4679]\\d|55|8[057-9]))\\d{5}",
,,,"50012345",,,[8]],[,,"18\\d{5}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"KW",965,"00",,,,,,,,[[,"(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],[,"(\\d{3})(\\d{5})","$1 $2",["[25]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KY:[,[,,"(?:345|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}",,,
,"3452221234",,,,[7]],[,,"345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}",,,,"3453231234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"(?:345976|900[2-9]\\d\\d)\\d{4}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"KY",1,"011","1",,,"1|([2-9]\\d{6})$","345$1",,,,,[,,"345849\\d{4}",,,,"3458491234"],,"345",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],KZ:[,[,,"(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",,,,,,,[10,14],[5,6,7]],[,,"(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
,,,"7123456789",,,[10],[5,6,7]],[,,"7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}",,,,"7710009998",,,[10]],[,,"8(?:00|108\\d{3})\\d{7}",,,,"8001234567"],[,,"809\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,"751\\d{7}",,,,"7511234567",,,[10]],"KZ",7,"810","8",,,"8",,"8~10",,,,[,,,,,,,,,[-1]],,"33|7",[,,"751\\d{7}",,,,,,,[10]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LA:[,[,,"[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",,,,,,,[8,9,10],[6]],[,,"(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
,,,"21212862",,,[8],[6]],[,,"(?:20(?:[239]\\d|5[24-9]|7[6-8])|302\\d)\\d{6}",,,,"2023123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LA",856,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"30[013-9]\\d{6}",,,,"301234567",,,[9]],,,[,,
,,,,,,,[-1]]],LB:[,[,,"[27-9]\\d{7}|[13-9]\\d{6}",,,,,,,[7,8]],[,,"7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}",,,,"1123456"],[,,"793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}",,,,"71123456"],[,,,,,,,,,[-1]],[,,"9[01]\\d{6}",,,,"90123456",,,[8]],[,,"80\\d{6}",,,,"80123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LB",961,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LC:[,[,,"(?:[58]\\d\\d|758|900)\\d{7}",,,,,,,[10],[7]],[,,"758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}",,,,"7584305678",,,,[7]],[,,"758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}",,,,"7582845678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"LC",1,"011","1",,,"1|([2-8]\\d{6})$","758$1",,,,,[,,,,,,,,,[-1]],,"758",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LI:[,[,,"90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}",,,,,,,[7,9]],[,,"(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
,,,"2345678",,,[7]],[,,"(?:6(?:4(?:69|[7-9]\\d)|5[0-4]\\d|6(?:[024]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}",,,,"660234567"],[,,"80(?:02[28]|9\\d\\d)\\d\\d",,,,"8002222",,,[7]],[,,"90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",,,,"9002222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LI",423,"00","0",,,"0|(1001)",,,,[[,"(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"],,"$CC $1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],
,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"870(?:28|87)\\d\\d",,,,"8702812",,,[7]],,,[,,"697(?:42|56|[78]\\d)\\d{4}",,,,"697861234",,,[9]]],LK:[,[,,"[1-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}",,,,"112345678",,,,[7]],[,,"7(?:[0-25-8]\\d|4[01])\\d{6}",,,,"712345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LK",94,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})",
"$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"1973\\d{5}",,,,"197312345"],,,[,,,,,,,,,[-1]]],LR:[,[,,"(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}",,,,,,,[7,8,9]],[,,"(?:2\\d{3}|33333)\\d{4}",,,,"21234567",,,[8,9]],[,,"(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}",,,,"770123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"332(?:02|[34]\\d)\\d{4}",,,,"332021234",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LR",231,"00","0",
,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3578]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LS:[,[,,"(?:[256]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"2\\d{7}",,,,"22123456"],[,,"[56]\\d{7}",,,,"50123456"],[,,"800[256]\\d{4}",,,,"80021234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LS",266,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",
["[2568]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LT:[,[,,"(?:[3469]\\d|52|[78]0)\\d{6}",,,,,,,[8]],[,,"(?:3[1478]|4[124-6]|52)\\d{6}",,,,"31234567"],[,,"6\\d{7}",,,,"61234567"],[,,"80[02]\\d{5}",,,,"80012345"],[,,"9(?:0[0239]|10)\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,"70[05]\\d{5}",,,,"70012345"],[,,"[89]01\\d{5}",,,,"80123456"],"LT",370,"00","8",,,"[08]",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",,1],[,"(\\d{3})(\\d{2})(\\d{3})",
"$1 $2 $3",["[7-9]"],"8 $1",,1],[,"(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",,1],[,"(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70[67]\\d{5}",,,,"70712345"],,,[,,,,,,,,,[-1]]],LU:[,[,,"35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",,,,,,,[4,5,6,7,8,9,10,11]],[,,"(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",,,,"27123456"],[,,"6(?:[269][18]|5[1568]|7[189]|81)\\d{6}",
,,,"628123456",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"90[015]\\d{5}",,,,"90012345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,,,,,,,,[-1]],[,,"20(?:1\\d{5}|[2-689]\\d{1,7})",,,,"20201234",,,[4,5,6,7,8,9,10]],"LU",352,"00",,,,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"],,"$CC $1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"],,"$CC $1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",
["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],,"$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],LV:[,[,,"(?:[268]\\d|90)\\d{6}",,,,,,,[8]],[,,"6\\d{7}",,,,"63123456"],[,,"2\\d{7}",,,,"21234567"],[,,"80\\d{6}",,,,"80123456"],[,,"90\\d{6}",,,,"90123456"],[,,"81\\d{6}",,,,"81123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LV",371,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
LY:[,[,,"[2-9]\\d{8}",,,,,,,[9],[7]],[,,"(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",,,,"212345678",,,,[7]],[,,"9[1-6]\\d{7}",,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"LY",218,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MA:[,[,,"[5-8]\\d{8}",,,,,,,[9]],[,,"5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}",,,,"520123456"],[,,"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|1[0-3]|6[1267]|7[0-57]))\\d{6}",,,,"650123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89\\d{7}",,,,"891234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"592(?:4[0-2]|93)\\d{4}",,,,"592401234"],"MA",212,"00",
"0",,,"0",,,,[[,"(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]","5(?:29|38)[89]0"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],[,"(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],[,"(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],[,"(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],,[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MC:[,[,,"(?:[3489]|6\\d)\\d{7}",,,,,,,[8,9]],[,,"(?:870|9[2-47-9]\\d)\\d{5}",
,,,"99123456",,,[8]],[,,"4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}",,,,"612345678"],[,,"(?:800|90\\d)\\d{5}",,,,"90123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MC",377,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["87"]],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],
"0$1"],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],[,"(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],[,,,,,,,,,[-1]],,,[,,"8[07]0\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MD:[,[,,"(?:[235-7]\\d|[89]0)\\d{6}",,,,,,,[8]],[,,"(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}",,,,"22212345"],[,,"562\\d{5}|(?:6\\d|7[16-9])\\d{6}",,,,"62112345"],[,,"800\\d{5}",,,,"80012345"],[,,"90[056]\\d{5}",,,,"90012345"],[,,"808\\d{5}",,,,"80812345"],[,,,,,,,,,[-1]],
[,,"3[08]\\d{6}",,,,"30123456"],"MD",373,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"803\\d{5}",,,,"80312345"],,,[,,,,,,,,,[-1]]],ME:[,[,,"(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",,,,,,,[8,9],[6]],[,,"(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",,,,"30234567",,,[8],[6]],[,,"6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
,,,"67622901",,,[8]],[,,"80(?:[0-2578]|9\\d)\\d{5}",,,,"80080002"],[,,"9(?:4[1568]|5[178])\\d{5}",,,,"94515151",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"78[1-49]\\d{5}",,,,"78108780",,,[8]],"ME",382,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"77[1-9]\\d{5}",,,,"77273012",,,[8]],,,[,,,,,,,,,[-1]]],MF:[,[,,"(?:590|(?:69|80)\\d|976)\\d{6}",,,,,,,[9]],[,,"590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}",,,,"590271234"],[,,"69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
,,,"690001234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976[01]\\d{5}",,,,"976012345"],"MF",590,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MG:[,[,,"[23]\\d{8}",,,,,,,[9],[7]],[,,"2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}",,,,"202123456",,,,[7]],[,,"3[2-489]\\d{7}",,,,"321234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"22\\d{7}",,,,"221234567"],"MG",
261,"00","0",,,"0|([24-9]\\d{6})$","20$1",,,[[,"(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MH:[,[,,"329\\d{4}|(?:[256]\\d|45)\\d{5}",,,,,,,[7]],[,,"(?:247|528|625)\\d{4}",,,,"2471234"],[,,"(?:(?:23|54)5|329|45[56])\\d{4}",,,,"2351234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"635\\d{4}",,,,"6351234"],"MH",692,"011","1",,,"1",,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],,[,,,,,,,,
,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MK:[,[,,"[2-578]\\d{7}",,,,,,,[8],[6,7]],[,,"(?:2(?:[23]\\d|5[0-24578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}",,,,"22012345",,,,[6,7]],[,,"7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[2-4]|42|9[23])\\d{5}",,,,"72345678"],[,,"800\\d{5}",,,,"80012345"],[,,"5[02-9]\\d{6}",,,,"50012345"],[,,"8(?:0[1-9]|[1-9]\\d)\\d{5}",,,,"80123456"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],"MK",389,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ML:[,[,,"[24-9]\\d{7}",,,,,,,[8]],[,,"2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}",,,,"20212345"],[,,"2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}",,,,"65012345"],[,,"80\\d{6}",
,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ML",223,"00",,,,,,,,[[,"(\\d{4})","$1",["67[057-9]|74[045]","67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]],[,,,,,,,,,[-1]],,,[,,"80\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MM:[,[,,"1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",,,,,,,[6,7,8,9,10],[5]],[,,"(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
,,,"1234567",,,[6,7,8,9],[5]],[,,"(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}",,,,"92123456",,,[7,8,9,10]],[,,"80080(?:[01][1-9]|2\\d)\\d{3}",,,,"8008001234",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1333\\d{4}|[12]468\\d{4}",,,,"13331234",,,[8]],"MM",95,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],[,"(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],[,"(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],,[,,,
,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MN:[,[,,"[12]\\d{7,9}|[57-9]\\d{7}",,,,,,,[8,9,10],[4,5,6]],[,,"[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}",,,,"53123456",,,,[4,5,6]],[,,"(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}",,,,"88123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"712[0-79]\\d{4}|7(?:1[013-9]|[5-8]\\d)\\d{5}",,,,"75123456",,,[8]],"MN",976,"001",
"0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[57-9]"]],[,"(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],[,"(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],[,"(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MO:[,[,,"0800\\d{3}|(?:28|[68]\\d)\\d{6}",,,,,,,[7,8]],[,,"(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
,,,"28212345",,,[8]],[,,"6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}",,,,"66123456",,,[8]],[,,"0800\\d{3}",,,,"0800501",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MO",853,"00",,,,,,,,[[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{4})(\\d{4})","$1 $2",["[268]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MP:[,[,,"[58]\\d{9}|(?:67|90)0\\d{7}",,,,,,,[10],[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
,,,"6702345678",,,,[7]],[,,"670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",,,,"6702345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MP",1,"011","1",,,"1|([2-9]\\d{6})$","670$1",,1,,,[,,,,,,,,,[-1]],,"670",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MQ:[,[,,"(?:69|80)\\d{7}|(?:59|97)6\\d{6}",,,,,,,[9]],[,,"596(?:0[0-8]|10|2[7-9]|3[04-9]|[4-7]\\d|8[09]|9[4-9])\\d{4}",,,,"596301234"],[,,"69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}",,,,"696201234"],[,,"80[0-5]\\d{6}",,,,"800012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"976(?:6\\d|7[0-367])\\d{4}",,,,"976612345"],"MQ",596,"00","0",
,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MR:[,[,,"(?:[2-4]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"(?:25[08]|35\\d|45[1-7])\\d{5}",,,,"35123456"],[,,"[2-4][0-46-9]\\d{6}",,,,"22123456"],[,,"800\\d{5}",,,,"80012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MR",222,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[2-48]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MS:[,[,,"(?:[58]\\d\\d|664|900)\\d{7}",,,,,,,[10],[7]],[,,"6644(?:1[0-3]|91)\\d{4}",,,,"6644912345",,,,[7]],[,,"664(?:3(?:49|9[1-6])|49[2-6])\\d{4}",,,,"6644923456",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"MS",1,"011","1",,,"1|([34]\\d{6})$","664$1",,,,,[,,,,,,,,,[-1]],,"664",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MT:[,[,,"3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",,,,,,,[8]],[,,"20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}",,,,"21001234"],[,,"(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}",,,,"96961234"],[,,"800[3467]\\d{4}",,,,"80071234"],[,,"5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",,,,"50037123"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3550\\d{4}",,,,"35501234"],"MT",356,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]],,[,,"7117\\d{4}",,,,"71171234"],,,[,,,,,,,,,[-1]],[,,"501\\d{5}",,,,"50112345"],,,[,,,,,,,,,[-1]]],MU:[,[,,"(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}",,,,,,,[7,8,10]],[,,"(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}",,,,"54480123",,,[7,8]],[,,"5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-589]|[57]\\d|8[0-689]|9[0-8])\\d{5}",
,,,"52512345",,,[8]],[,,"802\\d{7}|80[0-2]\\d{4}",,,,"8001234",,,[7,10]],[,,"30\\d{5}",,,,"3012345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"3(?:20|9\\d)\\d{4}",,,,"3201234",,,[7]],"MU",230,"0(?:0|[24-7]0|3[03])",,,,,,"020",,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],[,"(\\d{4})(\\d{4})","$1 $2",["5"]],[,"(\\d{5})(\\d{5})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MV:[,[,,"(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",,,,,,,[7,10]],[,,"(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}",
,,,"6701234",,,[7]],[,,"46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}",,,,"7712345",,,[7]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MV",960,"0(?:0|19)",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1-$2",["[3467]|9[13-9]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"4[05]0\\d{4}",,,,"4001234",,,[7]],,,[,,,,,,,,,[-1]]],MW:[,[,,"(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}",,,,,,,[7,9]],[,,"(?:1[2-9]|21\\d\\d)\\d{5}",
,,,"1234567"],[,,"111\\d{6}|(?:31|77|88|9[89])\\d{7}",,,,"991234567",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MW",265,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MX:[,[,,"1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
,,,,,,[10,11],[7,8]],[,,"6571\\d{6}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",,,,"2001234567",,,[10],[7,8]],[,,"6571\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
,,,"12221234567",,,,[7,8]],[,,"8(?:00|88)\\d{7}",,,,"8001234567",,,[10]],[,,"900\\d{7}",,,,"9001234567",,,[10]],[,,"300\\d{7}",,,,"3001234567",,,[10]],[,,"500\\d{7}",,,,"5001234567",,,[10]],[,,,,,,,,,[-1]],"MX",52,"0[09]","01",,,"0(?:[12]|4[45])|1",,"00",,[[,"(\\d{5})","$1",["53"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})",
"$2 $3 $4",["1"],,,1]],[[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],,,1],[,"(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],,,1],[,"(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],,,1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MY:[,[,,"1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",,,,,,,[8,9,10],[6,7]],[,,"(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
,,,"323856789",,,[8,9],[6,7]],[,,"1(?:1888[69]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}",,,,"123456789",,,[9,10]],[,,"1[378]00\\d{6}",,,,"1300123456",,,[10]],[,,"1600\\d{6}",,,,"1600123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
,,,"1546012345",,,[10]],"MY",60,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9])|8"],"0$1"],[,"(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],MZ:[,[,,"(?:2|8\\d)\\d{7}",
,,,,,,[8,9]],[,,"2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}",,,,"21123456",,,[8]],[,,"8[2-79]\\d{7}",,,,"821234567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"MZ",258,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NA:[,[,,"[68]\\d{7,8}",,,,,,,[8,9]],[,,"64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
,,,"61221234"],[,,"(?:60|8[1245])\\d{7}",,,,"811234567",,,[9]],[,,"80\\d{7}",,,,"800123456",,,[9]],[,,"8701\\d{5}",,,,"870123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8(?:3\\d\\d|86)\\d{5}",,,,"88612345"],"NA",264,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,,[,,,,,,,,,[-1]]],NC:[,[,,"[2-57-9]\\d{5}",,,,,,,[6]],[,,"(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}",,,,"201234"],[,,"(?:5[0-4]|[79]\\d|8[0-79])\\d{4}",,,,"751234"],[,,,,,,,,,[-1]],[,,"36\\d{4}",,,,"366711"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NC",687,"00",,,,,,,,[[,"(\\d{3})","$1",["5[6-8]"]],[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]],[[,"(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-57-9]"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NE:[,[,,"[027-9]\\d{7}",
,,,,,,[8]],[,,"2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}",,,,"20201234"],[,,"(?:23|7[04]|[89]\\d)\\d{6}",,,,"93123456"],[,,"08\\d{6}",,,,"08123456"],[,,"09\\d{6}",,,,"09123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NE",227,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[04]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NF:[,[,
,"[13]\\d{5}",,,,,,,[6],[5]],[,,"(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}",,,,"106609",,,,[5]],[,,"(?:14|3[58])\\d{4}",,,,"381234",,,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NF",672,"00",,,,"([0-258]\\d{4})$","3$1",,,[[,"(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],[,"(\\d)(\\d{5})","$1 $2",["[13]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NG:[,[,,"(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",,,,,,,[7,8,10,11,12,13,14],[5,6]],
[,,"(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}",,,,"18040123",,,[7,8],[5,6]],[,,"(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[2356]))\\d{7}",,,,"8021234567",,,[10]],[,,"800\\d{7,11}",,,,"80017591759",,,[10,11,12,13,14]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NG",234,"009","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{3})",
"$1 $2 $3",["78"],"0$1"],[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],[,"(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"700\\d{7,11}",,,,"7001234567",,,[10,11,12,13,14]],,,[,,,,,,,,,[-1]]],NI:[,[,,"(?:1800|[25-8]\\d{3})\\d{4}",,,,,,,[8]],[,,"2\\d{7}",
,,,"21234567"],[,,"(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}",,,,"81234567"],[,,"1800\\d{4}",,,,"18001234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NI",505,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NL:[,[,,"(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",,,,,,,[5,6,7,8,9,10]],[,,"(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
,,,"101234567",,,[9]],[,,"6[1-58]\\d{7}",,,,"612345678",,,[9]],[,,"800\\d{4,7}",,,,"8001234",,,[7,8,9,10]],[,,"90[069]\\d{4,7}",,,,"9061234",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:85|91)\\d{7}",,,,"851234567",,,[9]],"NL",31,"00","0",,,"0",,,,[[,"(\\d{4})","$1",["1[238]|[34]"]],[,"(\\d{2})(\\d{3,4})","$1 $2",["14"]],[,"(\\d{6})","$1",["1"]],[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})",
"$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],[[,"(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],[,"(\\d)(\\d{8})","$1 $2",["6"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-57-9]"],"0$1"]],[,,"66\\d{7}",,,,"662345678",,,[9]],,,[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d",
,,,,,,[5,6]],[,,"140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",,,,"14020",,,[5,6,9]],,,[,,,,,,,,,[-1]]],NO:[,[,,"(?:0|[2-9]\\d{3})\\d{4}",,,,,,,[5,8]],[,,"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",,,,"21234567",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",,,,"40612345",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",
,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"NO",47,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[489]|59"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],,[,,,,,,,,,[-1]],1,"[02-689]|7[0-8]",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",,,,"81212345",,,[8]]],NP:[,[,,"(?:1\\d|9)\\d{9}|[1-9]\\d{7}",,,,,,,[8,10,11],[6,7]],[,,"(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}",
,,,"14567890",,,[8],[6,7]],[,,"9(?:6[0-3]|7[245]|8[0-24-68])\\d{7}",,,,"9841234567",,,[10]],[,,"1(?:66001|800\\d\\d)\\d{5}",,,,"16600101234",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NP",977,"00","0",,,"0",,,,[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]],[,"(\\d{4})(\\d{2})(\\d{5})","$1-$2-$3",["1"]]],[[,"(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],[,"(\\d{2})(\\d{6})",
"$1-$2",["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],"0$1"],[,"(\\d{3})(\\d{7})","$1-$2",["9"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NR:[,[,,"(?:444|(?:55|8\\d)\\d|666)\\d{4}",,,,,,,[7]],[,,"444\\d{4}",,,,"4441234"],[,,"(?:55[3-9]|666|8\\d\\d)\\d{4}",,,,"5551234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NR",674,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],
NU:[,[,,"(?:[47]|888\\d)\\d{3}",,,,,,,[4,7]],[,,"[47]\\d{3}",,,,"7012",,,[4]],[,,"888[4-9]\\d{3}",,,,"8884012",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"NU",683,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],NZ:[,[,,"[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",,,,,,,[5,6,7,8,9,10]],[,,"24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}",
,,,"32345678",,,[8],[7]],[,,"2[0-27-9]\\d{7,8}|21\\d{6}",,,,"211234567",,,[8,9,10]],[,,"508\\d{6,7}|80\\d{6,8}",,,,"800123456",,,[8,9,10]],[,,"(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}",,,,"900123456",,,[7,8,9,10]],[,,,,,,,,,[-1]],[,,"70\\d{7}",,,,"701234567",,,[9]],[,,,,,,,,,[-1]],"NZ",64,"0(?:0|161)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],[,"(\\d)(\\d{3})(\\d{4})",
"$1-$2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],,[,,"[28]6\\d{6,7}",,,,"26123456",,,[8,9]],,,[,,,,,,,,,[-1]],[,,"8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}",,,,"83012378"],,,[,,,,,,,,,[-1]]],OM:[,[,,"(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",,,,,,,[7,8,9]],[,,"2[2-6]\\d{6}",
,,,"23123456",,,[8]],[,,"1505\\d{4}|(?:7(?:[1289]\\d|70)|9(?:0[1-9]|[1-9]\\d))\\d{5}",,,,"92123456",,,[8]],[,,"8007\\d{4,5}|(?:500|800[05])\\d{4}",,,,"80071234"],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"OM",968,"00",,,,,,,,[[,"(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],[,"(\\d{2})(\\d{6})","$1 $2",["2"]],[,"(\\d{4})(\\d{4})","$1 $2",["[179]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PA:[,[,,"(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
,,,,,,[7,8,10,11]],[,,"(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[139])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[026-9])|3(?:[089]\\d|1[014-7]|2[0-5]|33|4[0-79]|55|6[068]|7[03-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[6-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",,,,"2001234",,,[7]],[,,"(?:1[16]1|21[89]|6(?:[02-9]\\d|1[0-8])\\d|8(?:1[01]|7[23]))\\d{4}",
,,,"61234567",,,[7,8]],[,,"800\\d{4,5}|(?:00800|800\\d)\\d{6}",,,,"8001234"],[,,"(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}",,,,"8601234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PA",507,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],[,"(\\d{4})(\\d{4})","$1-$2",["[68]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PE:[,[,,"(?:[14-8]|9\\d)\\d{7}",,,,,,,[8,9],[6,7]],[,,"(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}",
,,,"11234567",,,[8],[6,7]],[,,"9\\d{8}",,,,"912345678",,,[9]],[,,"800\\d{5}",,,,"80012345",,,[8]],[,,"805\\d{5}",,,,"80512345",,,[8]],[,,"801\\d{5}",,,,"80112345",,,[8]],[,,"80[24]\\d{5}",,,,"80212345",,,[8]],[,,,,,,,,,[-1]],"PE",51,"19(?:1[124]|77|90)00","0"," Anexo ",,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],[,"(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],[,"(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,,[,,,,,,,,,[-1]]],PF:[,[,,"4\\d{5}(?:\\d{2})?|8\\d{7,8}",,,,,,,[6,8,9]],[,,"4(?:0[4-689]|9[4-68])\\d{5}",,,,"40412345",,,[8]],[,,"8[7-9]\\d{6}",,,,"87123456",,,[8]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"499\\d{5}",,,,"49901234",,,[8]],"PF",689,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,
,,,,,,[-1]],,,[,,"44\\d{4}",,,,,,,[6]],[,,"44\\d{4}",,,,"440123",,,[6]],,,[,,,,,,,,,[-1]]],PG:[,[,,"(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",,,,,,,[7,8]],[,,"(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}",,,,"3123456",,,[7]],[,,"(?:7\\d|8[18])\\d{6}",,,,"70123456",,,[8]],[,,"180\\d{4}",,,,"1801234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"2(?:0[0-47]|7[568])\\d{4}",,,,"2751234",,,[7]],"PG",675,"00|140[1-3]",,,,,,"00",,[[,"(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],
[,"(\\d{4})(\\d{4})","$1 $2",["[78]"]]],,[,,"27[01]\\d{4}",,,,"2700123",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PH:[,[,,"(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",,,,,,,[6,8,9,10,11,12,13],[4,5,7]],[,,"(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",,,,"232345678",,,[6,8,9,10],[4,5,7]],[,,"(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[2357]\\d|4[2-9]|6[0-35-9]|8[135-9]|9[1-9]))\\d{7}",,,,"9051234567",,,[10]],[,,
"1800\\d{7,9}",,,,"180012345678",,,[11,12,13]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PH",63,"00","0",,,"0",,,,[[,"(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],[,"(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],[,"(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],
[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PK:[,[,,"122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
,,,,,,[8,9,10,11,12],[5,6,7]],[,,"(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}",,,,"2123456789",,,[9,10],[5,6,7,8]],[,,"3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}",,,,"3012345678",,,[10]],[,,"800\\d{5}(?:\\d{3})?",,,,"80012345",,,[8,11]],[,,"900\\d{5}",,,,"90012345",,,[8]],[,,,,,,,,,[-1]],
[,,"122\\d{6}",,,,"122044444",,,[9]],[,,,,,,,,,[-1]],"PK",92,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["1"]],[,"(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
"(0$1)"],[,"(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],[,"(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],[,"(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],[,"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
,,,"21111825888",,,[11,12]],,,[,,,,,,,,,[-1]]],PL:[,[,,"6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",,,,,,,[6,7,8,9,10]],[,,"47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",,,,"123456789",,,[7,9]],[,,"211(?:1\\d|3[1-5])\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}",,,,"512345678",,,[9]],[,,"800\\d{6,7}",,,,"800123456",,,[9,10]],[,,"70[01346-8]\\d{6}",,,,"701234567",,,[9]],[,,"801\\d{6}",,,,"801234567",
,,[9]],[,,,,,,,,,[-1]],[,,"39\\d{7}",,,,"391234567",,,[9]],"PL",48,"00",,,,,,,,[[,"(\\d{5})","$1",["19"]],[,"(\\d{3})(\\d{3})","$1 $2",["11|64"]],[,"(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],[,"(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]],,[,,"64\\d{4,7}",,,,"641234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]],[,,"804\\d{6}",,,,"804123456",,,[9]],,,[,,,,,,,,,[-1]]],PM:[,[,,"(?:[45]|80\\d\\d)\\d{5}",,,,,,,[6,9]],[,,"(?:4[1-3]|50)\\d{4}",,,,"430123",,,[6]],[,,"(?:4[02-4]|5[05])\\d{4}",,,,"551234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PM",508,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3",["[45]"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PR:[,[,,"(?:[589]\\d\\d|787)\\d{7}",,,,,,,[10],[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"(?:787|939)[2-9]\\d{6}",,,,"7872345678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"PR",1,"011","1",,,"1",,,1,,,[,,,,,,,,,[-1]],,"787|939",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PS:[,[,,"[2489]2\\d{6}|(?:1\\d|5)\\d{8}",,,,,,,[8,9,10],[7]],[,,"(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}",,,,"22234567",,,[8],[7]],[,,"5[69]\\d{7}",,,,"599123456",,,[9]],[,,"1800\\d{6}",,,,"1800123456",,,[10]],[,,,,,,,,,[-1]],[,,"1700\\d{6}",,,,"1700123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PS",970,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",
["[2489]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PT:[,[,,"1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",,,,,,,[9]],[,,"2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}",,,,"212345678"],[,,"6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}",,,,"912345678"],[,,"80[02]\\d{6}",,,,"800123456"],[,,"(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
,,,"760123456"],[,,"80(?:8\\d|9[1579])\\d{5}",,,,"808123456"],[,,"884[0-4689]\\d{5}",,,,"884123456"],[,,"30\\d{7}",,,,"301234567"],"PT",351,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"70(?:7\\d|8[17])\\d{5}",,,,"707123456"],,,[,,"600\\d{6}",,,,"600110000"]],PW:[,[,,"(?:[24-8]\\d\\d|345|900)\\d{4}",,,,,,,[7]],[,,"(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
,,,"2771234"],[,,"(?:46[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}",,,,"6201234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"PW",680,"01[12]",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],PY:[,[,,"59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",,,,,,,[6,7,8,9,10,11],[5]],[,,"(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
,,,"212345678",,,[7,8,9],[5,6]],[,,"9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}",,,,"961456789",,,[9]],[,,"9800\\d{5,7}",,,,"98000123456",,,[9,10,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"8700[0-4]\\d{4}",,,,"870012345",,,[9]],"PY",595,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],[,"(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],[,"(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],[,"(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"[2-9]0\\d{4,7}",,,,"201234567",,,[6,7,8,9]],,,[,,,,,,,,,[-1]]],QA:[,[,,"[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}",,,,,,,[7,8,9]],[,,"4141\\d{4}|(?:23|4[04])\\d{6}",,,,"44123456",
,,[8]],[,,"(?:28|[35-7]\\d)\\d{6}",,,,"33123456",,,[8]],[,,"800\\d{4}(?:\\d{2})?",,,,"8001234",,,[7,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"QA",974,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],[,"(\\d{4})(\\d{4})","$1 $2",["[2-7]"]]],,[,,"2(?:[12]\\d|61)\\d{4}",,,,"2123456",,,[7]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RE:[,[,,"9769\\d{5}|(?:26|[68]\\d)\\d{7}",,,,,,,[9]],[,,"26(?:2\\d\\d|30[0-5])\\d{4}",,,,"262161234"],[,,"(?:69(?:2\\d\\d|3(?:[06][0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}",
,,,"692123456"],[,,"80\\d{7}",,,,"801234567"],[,,"89[1-37-9]\\d{6}",,,,"891123456"],[,,"8(?:1[019]|2[0156]|84|90)\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RE",262,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],,[,,,,,,,,,[-1]],1,"26[23]|69|[89]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RO:[,[,,"(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",,,,,,,[6,9]],[,,"[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",,,,"211234567"],[,,"7020\\d{5}|7(?:0[013-9]|1[0-2]|[2-7]\\d|8[03-8]|9[019])\\d{6}",
,,,"712034567",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"90[0136]\\d{6}",,,,"900123456",,,[9]],[,,"801\\d{6}",,,,"801123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RO",40,"00","0"," int ",,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],[,"(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:37\\d|80[578])\\d{6}",,,,"372123456",
,,[9]],,,[,,,,,,,,,[-1]]],RS:[,[,,"38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",,,,,,,[6,7,8,9,10,11,12],[4,5]],[,,"(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}",,,,"10234567",,,[7,8,9,10,11,12],[4,5,6]],[,,"6(?:[0-689]|7\\d)\\d{6,7}",,,,"601234567",,,[8,9,10]],[,,"800\\d{3,9}",,,,"80012345"],[,,"(?:78\\d|90[0169])\\d{3,7}",,,,"90012345",,,[6,7,8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],"RS",381,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],[,"(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7[06]\\d{4,10}",,,,"700123456"],,,[,,,,,,,,,[-1]]],RU:[,[,,"8\\d{13}|[347-9]\\d{9}",,,,,,,[10,14],[7]],[,,"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}",,,,"3011234567",,,[10],[7]],[,,"9\\d{9}",
,,,"9123456789",,,[10]],[,,"8(?:0[04]|108\\d{3})\\d{7}",,,,"8001234567"],[,,"80[39]\\d{7}",,,,"8091234567",,,[10]],[,,,,,,,,,[-1]],[,,"808\\d{7}",,,,"8081234567",,,[10]],[,,,,,,,,,[-1]],"RU",7,"810","8",,,"8",,"8~10",,[[,"(\\d{3})(\\d{2})(\\d{2})","$1-$2-$3",["[0-79]"]],[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
"$1 $2 $3 $4",["8"],"8 ($1)"]],[[,"(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",,1],[,"(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",,1],[,"(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],[,,,,,,,,,[-1]],1,"3[04-689]|[489]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],RW:[,[,,"(?:06|[27]\\d\\d|[89]00)\\d{6}",,,,,,,[8,9]],[,,"(?:06|2[23568]\\d)\\d{6}",,,,"250123456"],[,,"7[2389]\\d{7}",,,,"720123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,
"900\\d{6}",,,,"900123456",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"RW",250,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SA:[,[,,"92\\d{7}|(?:[15]|8\\d)\\d{8}",,,,,,,[9,10],[7]],[,,"1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}",,,,"112345678",,,[9],[7]],[,,"579[01]\\d{5}|5(?:[013-689]\\d|7[0-36-8])\\d{6}",
,,,"512345678",,,[9]],[,,"800\\d{7}",,,,"8001234567",,,[10]],[,,"925\\d{6}",,,,"925012345",,,[9]],[,,"920\\d{6}",,,,"920012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SA",966,"00","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["9"]],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"811\\d{7}",,,,"8110123456",
,,[10]],,,[,,,,,,,,,[-1]]],SB:[,[,,"(?:[1-6]|[7-9]\\d\\d)\\d{4}",,,,,,,[5,7]],[,,"(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}",,,,"40123",,,[5]],[,,"48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}",,,,"7421234"],[,,"1[38]\\d{3}",,,,"18123",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[12]\\d{3}",,,,"51123",,,[5]],"SB",677,"0[01]",,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],,[,,,,,,,,,[-1]],,,
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SC:[,[,,"8000\\d{3}|(?:[249]\\d|64)\\d{5}",,,,,,,[7]],[,,"4[2-46]\\d{5}",,,,"4217123"],[,,"2[5-8]\\d{5}",,,,"2510123"],[,,"8000\\d{3}",,,,"8000000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"971\\d{4}|(?:64|95)\\d{5}",,,,"6412345"],"SC",248,"010|0[0-2]",,,,,,"00",,[[,"(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SD:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1(?:5\\d|8[35-7])\\d{6}",
,,,"153123456"],[,,"(?:1[0-2]|9[0-3569])\\d{7}",,,,"911231234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SD",249,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SE:[,[,,"(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",,,,,,,[6,7,8,9,10,12]],[,,"(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
,,,"8123456",,,[7,8,9]],[,,"7[02369]\\d{7}",,,,"701234567",,,[9]],[,,"20\\d{4,7}",,,,"20123456",,,[6,7,8,9]],[,,"649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}",,,,"9001234567",,,[7,8,9,10]],[,,"77[0-7]\\d{6}",,,,"771234567",,,[9]],[,,"75[1-8]\\d{6}",,,,"751234567",,,[9]],[,,,,,,,,,[-1]],"SE",46,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1"],[,"(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1"],
[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1"],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})",
"$1-$2 $3 $4",["8"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1"],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1"]],[[,"(\\d{2})(\\d{2,3})(\\d{2})","$1 $2 $3",["20"]],[,"(\\d{3})(\\d{4})","$1 $2",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]],[,"(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2,3})(\\d{2})","$1 $2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2,3})(\\d{3})","$1 $2 $3",["9(?:00|39|44)"]],[,"(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["10|7"]],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["9"]],[,"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]],[,,"74[02-9]\\d{6}",,,,"740123456",,,[9]],,,[,,,,,,,,,[-1]],[,,"10[1-8]\\d{6}",,,,"102345678",,,[9]],,,[,,"(?:25[245]|67[3-68])\\d{9}",,,,"254123456789",,,[12]]],SG:[,[,,"(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",,,,,,,[8,10,11]],[,,"662[0-24-9]\\d{4}|6(?:[1-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
,,,"61234567",,,[8]],[,,"(?:8(?:0(?:[13]\\d|2[013-9]|4[0-35-7])|[1-8]\\d\\d|9(?:[0-4]\\d|5[0-2]))|9[0-8]\\d\\d)\\d{4}",,,,"81234567",,,[8]],[,,"(?:18|8)00\\d{7}",,,,"18001234567",,,[10,11]],[,,"1900\\d{7}",,,,"19001234567",,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:3[12]\\d|666)\\d{5}",,,,"31234567",,,[8]],"SG",65,"0[0-3]\\d",,,,,,,,[[,"(\\d{4,5})","$1",["1[013-9]|77","1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]],[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-4]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",
["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[[,"(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-4]|[1-9])"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],[,"(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],[,"(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"7000\\d{7}",,,,"70001234567",,,[11]],,,[,,,,,,,,,[-1]]],SH:[,[,,"(?:[256]\\d|8)\\d{3}",,,,,,,[4,5]],[,,"2(?:[0-57-9]\\d|6[4-9])\\d\\d",,,,"22158"],[,,"[56]\\d{4}",
,,,"51234",,,[5]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"262\\d\\d",,,,"26212",,,[5]],"SH",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],1,"[256]",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SI:[,[,,"[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",,,,,,,[5,6,7,8]],[,,"(?:[1-357][2-8]|4[24-8])\\d{6}",,,,"12345678",,,[8],[7]],[,,"65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}",,,,"31234567",,,[8]],[,,"80\\d{4,6}",,,,"80123456",,,[6,7,8]],[,,"89[1-3]\\d{2,5}|90\\d{4,6}",,,,
"90123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}",,,,"59012345",,,[8]],"SI",386,"00|10(?:22|66|88|99)","0",,,"0",,"00",,[[,"(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],[,"(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],[,"(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,
,,,,,[-1]]],SJ:[,[,,"0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",,,,,,,[5,8]],[,,"79\\d{6}",,,,"79123456",,,[8]],[,,"(?:4[015-8]|59|9\\d)\\d{6}",,,,"41234567",,,[8]],[,,"80[01]\\d{5}",,,,"80012345",,,[8]],[,,"82[09]\\d{5}",,,,"82012345",,,[8]],[,,"810(?:0[0-6]|[2-8]\\d)\\d{3}",,,,"81021234",,,[8]],[,,"880\\d{5}",,,,"88012345",,,[8]],[,,"85[0-5]\\d{5}",,,,"85012345",,,[8]],"SJ",47,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"79",[,,,,,,,,,[-1]],[,,"(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}",,,,"02000"],,,[,,"81[23]\\d{5}",
,,,"81212345",,,[8]]],SK:[,[,,"[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",,,,,,,[6,7,9]],[,,"(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d",,,,"221234567"],[,,"909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}",,,,"912123456",,,[9]],[,,"800\\d{6}",,,,"800123456",,,[9]],[,,"9(?:00|[78]\\d)\\d{6}",,,,"900123456",,,[9]],[,,"8[5-9]\\d{7}",,,,"850123456",,,[9]],[,,,,,,,,,[-1]],[,,"6(?:02|5[0-4]|9[0-6])\\d{6}",,,,"690123456",
,,[9]],"SK",421,"00","0",,,"0",,,,[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[[,"(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],[,"(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",
["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],[,"(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],[,,"9090\\d{3}",,,,"9090123",,,[7]],,,[,,"9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}",,,,,,,[7,9]],[,,"96\\d{7}",,,,"961234567",,,[9]],,,[,,,,,,,,,[-1]]],SL:[,[,,"(?:[237-9]\\d|66)\\d{6}",,,,,,,[8],[6]],[,,"22[2-4][2-9]\\d{4}",,,,"22221234",,,,[6]],[,,"(?:25|3[0-5]|66|7[3-9]|8[08]|9[09])\\d{6}",
,,,"25123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SL",232,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SM:[,[,,"(?:0549|[5-7]\\d)\\d{6}",,,,,,,[8,10],[6]],[,,"0549(?:8[0157-9]|9\\d)\\d{4}",,,,"0549886377",,,[10],[6]],[,,"6[16]\\d{6}",,,,"66661212",,,[8]],[,,,,,,,,,[-1]],[,,"7[178]\\d{6}",,,,"71123456",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"5[158]\\d{6}",
,,,"58001110",,,[8]],"SM",378,"00",,,,"([89]\\d{5})$","0549$1",,,[[,"(\\d{6})","$1",["[89]"]],[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],[,"(\\d{4})(\\d{6})","$1 $2",["0"]]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SN:[,[,,"(?:[378]\\d|93)\\d{7}",,,,,,,[9]],[,,"3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}",,,,"301012345"],[,,"75(?:01|[38]3)\\d{5}|7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}",
,,,"701234567"],[,,"800\\d{6}",,,,"800123456"],[,,"88[4689]\\d{6}",,,,"884123456"],[,,"81[02468]\\d{6}",,,,"810123456"],[,,,,,,,,,[-1]],[,,"(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}",,,,"933301234"],"SN",221,"00",,,,,,,,[[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SO:[,[,,"[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",,,,,,,[6,7,8,9]],[,,
"(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",,,,"4012345",,,[6,7]],[,,"(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}",,,,"71123456",,,[7,8,9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SO",252,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{4})","$1 $2",["8[125]"]],[,"(\\d{6})","$1",["[134]"]],[,"(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],[,"(\\d)(\\d{7})",
"$1 $2",["24|[67]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3478]|64|90"]],[,"(\\d{2})(\\d{5,7})","$1 $2",["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SR:[,[,,"(?:[2-5]|68|[78]\\d)\\d{5}",,,,,,,[6,7]],[,,"(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}",,,,"211234"],[,,"(?:7[124-7]|8[124-9])\\d{5}",,,,"7412345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"56\\d{4}",,,,"561234",,,[6]],"SR",597,"00",,,,,,,
,[[,"(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],[,"(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],[,"(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SS:[,[,,"[19]\\d{8}",,,,,,,[9]],[,,"1[89]\\d{7}",,,,"181234567"],[,,"(?:12|9[1257-9])\\d{7}",,,,"977123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SS",211,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,
,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ST:[,[,,"(?:22|9\\d)\\d{5}",,,,,,,[7]],[,,"22\\d{5}",,,,"2221234"],[,,"900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}",,,,"9812345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"ST",239,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[29]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SV:[,[,,"[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",,,,,,,[7,8,11]],[,,"2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",,,,"21234567",
,,[8]],[,,"66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}",,,,"70123456",,,[8]],[,,"800\\d{4}(?:\\d{4})?",,,,"8001234",,,[7,11]],[,,"900\\d{4}(?:\\d{4})?",,,,"9001234",,,[7,11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SV",503,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[89]"]],[,"(\\d{4})(\\d{4})","$1 $2",["[267]"]],[,"(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SX:[,[,,"7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
,,,,,,[10],[7]],[,,"7215(?:4[2-8]|8[239]|9[056])\\d{4}",,,,"7215425678",,,,[7]],[,,"7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}",,,,"7215205678",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002123456"],[,,"900[2-9]\\d{6}",,,,"9002123456"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,
,"5002345678"],[,,,,,,,,,[-1]],"SX",1,"011","1",,,"1|(5\\d{6})$","721$1",,,,,[,,,,,,,,,[-1]],,"721",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SY:[,[,,"[1-39]\\d{8}|[1-5]\\d{7}",,,,,,,[8,9],[6,7]],[,,"21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}",,,,"112345678",,,,[6,7]],[,,"9(?:22|[3-689]\\d)\\d{6}",,,,"944567890",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"SY",963,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3})(\\d{3,4})",
"$1 $2 $3",["[1-5]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],SZ:[,[,,"0800\\d{4}|(?:[237]\\d|900)\\d{6}",,,,,,,[8,9]],[,,"[23][2-5]\\d{6}",,,,"22171234",,,[8]],[,,"7[6-9]\\d{6}",,,,"76123456",,,[8]],[,,"0800\\d{4}",,,,"08001234",,,[8]],[,,"900\\d{6}",,,,"900012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"70\\d{6}",,,,"70012345",,,[8]],"SZ",268,"00",,,,,,,,[[,"(\\d{4})(\\d{4})","$1 $2",["[0237]"]],[,
"(\\d{5})(\\d{4})","$1 $2",["9"]]],,[,,,,,,,,,[-1]],,,[,,"0800\\d{4}",,,,,,,[8]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TA:[,[,,"8\\d{3}",,,,,,,[4]],[,,"8\\d{3}",,,,"8999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TA",290,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"8",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TC:[,[,,"(?:[58]\\d\\d|649|900)\\d{7}",,,,,,,[10],[7]],[,,"649(?:266|712|9(?:4\\d|50))\\d{4}",,,,"6497121234",,,,[7]],[,,"649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
,,,"6492311234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,"649(?:71[01]|966)\\d{4}",,,,"6497101234",,,,[7]],"TC",1,"011","1",,,"1|([2-479]\\d{6})$","649$1",,,,,[,,,,,,,,
,[-1]],,"649",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TD:[,[,,"(?:22|[69]\\d|77)\\d{6}",,,,,,,[8]],[,,"22(?:[37-9]0|5[0-5]|6[89])\\d{4}",,,,"22501234"],[,,"(?:6[023568]|77|9\\d)\\d{6}",,,,"63012345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TD",235,"00|16",,,,,,"00",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TG:[,[,,"[279]\\d{7}",,,,,,,[8]],[,,"2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
,,,"22212345"],[,,"(?:7[09]|9[0-36-9])\\d{6}",,,,"90112345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TG",228,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TH:[,[,,"(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",,,,,,,[8,9,10,13]],[,,"(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}",,,,"21234567",,,[8]],[,,"671[0-3]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",,,,"812345678",
,,[9]],[,,"(?:001800\\d|1800)\\d{6}",,,,"1800123456",,,[10,13]],[,,"1900\\d{6}",,,,"1900123456",,,[10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"6[08]\\d{7}",,,,"601234567",,,[9]],"TH",66,"00[1-9]","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],[,"(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TJ:[,[,,"(?:00|11|[2-57-9]\\d)\\d{7}",,,,,,,[9],[3,5,6,7]],[,,"(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
,,,"372123456",,,,[3,5,6,7]],[,,"41[18]\\d{6}|(?:[034]0|11|2[02]|5[05]|7[07]|8[08]|9\\d)\\d{7}",,,,"917123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TJ",992,"810","8",,,"8",,"8~10",,[[,"(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"],,,1],[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"],,,1],[,"(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"],,,1],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02-57-9]|11"],,,1]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TK:[,[,,"[2-47]\\d{3,6}",,,,,,,[4,5,6,7]],[,,"(?:2[2-4]|[34]\\d)\\d{2,5}",,,,"3101"],[,,"7[2-4]\\d{2,5}",,,,"7290"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TK",690,"00",,,,,,,,,,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TL:[,[,,"7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",,,,,,,[7,8]],[,,"(?:2[1-5]|3[1-9]|4[1-4])\\d{5}",,,,"2112345",,,[7]],[,,"7[2-8]\\d{6}",,,,"77212345",,,[8]],[,,"80\\d{5}",,,,"8012345",,,[7]],
[,,"90\\d{5}",,,,"9012345",,,[7]],[,,,,,,,,,[-1]],[,,"70\\d{5}",,,,"7012345",,,[7]],[,,,,,,,,,[-1]],"TL",670,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],[,"(\\d{4})(\\d{4})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TM:[,[,,"[1-6]\\d{7}",,,,,,,[8]],[,,"(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}",,,,"12345678"],[,,"6\\d{7}",,,,"66123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TM",993,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],[,"(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],[,"(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TN:[,[,,"[2-57-9]\\d{7}",,,,,,,[8]],[,,"81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}",,,,"30010123"],[,,"3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
,,,"20123456"],[,,"8010\\d{4}",,,,"80101234"],[,,"88\\d{6}",,,,"88123456"],[,,"8[12]10\\d{4}",,,,"81101234"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TN",216,"00",,,,,,,,[[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TO:[,[,,"(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",,,,,,,[5,7]],[,,"(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}",,,,"20123",,,[5]],[,,"(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
,,,"7715123",,,[7]],[,,"0800\\d{3}",,,,"0800222",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"55[0-37-9]\\d{4}",,,,"5510123",,,[7]],"TO",676,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],[,"(\\d{4})(\\d{3})","$1 $2",["0"]],[,"(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TR:[,[,,"4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",,,,,,,[7,10,12,13]],[,,"(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
,,,"2123456789",,,[10]],[,,"56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}",,,,"5012345678",,,[10]],[,,"8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})",,,,"8001234567",,,[10,12,13]],[,,"(?:8[89]8|900)\\d{7}",,,,"9001234567",,,[10]],[,,,,,,,,,[-1]],[,,"592(?:21[12]|461)\\d{4}",,,,"5922121234",,,[10]],[,,"850\\d{7}",,,,"8500123456",,,[10]],"TR",90,"00","0",,,"0",,,,[[,"(\\d{3})(\\d)(\\d{3})","$1 $2 $3",["444"],,,1],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
"$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",,1],[,"(\\d{3})(\\d{3})(\\d{6,7})",
"$1 $2 $3",["80"],"0$1",,1]],[,,"512\\d{7}",,,,"5123456789",,,[10]],,,[,,"(?:444|811\\d{3})\\d{4}",,,,,,,[7,10]],[,,"444\\d{4}",,,,"4441444",,,[7]],,,[,,,,,,,,,[-1]]],TT:[,[,,"(?:[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"868(?:2(?:0[13]|1[89]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}",,,,"8682211234",,,,[7]],[,,"868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",,,,"8682911234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"TT",1,"011","1",,,"1|([2-46-8]\\d{6})$","868$1",,,,,[,,,,,,,,,[-1]],,"868",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"868619\\d{4}",,,,"8686191234",,,,[7]]],TV:[,[,,"(?:2|7\\d\\d|90)\\d{4}",
,,,,,,[5,6,7]],[,,"2[02-9]\\d{3}",,,,"20123",,,[5]],[,,"(?:7[01]\\d|90)\\d{4}",,,,"901234",,,[6,7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"TV",688,"00",,,,,,,,[[,"(\\d{2})(\\d{3})","$1 $2",["2"]],[,"(\\d{2})(\\d{4})","$1 $2",["90"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],TW:[,[,,"[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",,,,,,,[7,8,9,10,11]],[,,"(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
,,,"221234567",,,[8,9]],[,,"(?:40001[0-2]|9[0-8]\\d{4})\\d{3}",,,,"912345678",,,[9]],[,,"80[0-79]\\d{6}|800\\d{5}",,,,"800123456",,,[8,9]],[,,"20(?:[013-9]\\d\\d|2)\\d{4}",,,,"203123456",,,[7,9]],[,,,,,,,,,[-1]],[,,"99\\d{7}",,,,"990123456",,,[9]],[,,"7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}",,,,"7012345678",,,[10,11]],"TW",886,"0(?:0[25-79]|19)","0","#",,"0",,,,[[,"(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],[,"(\\d)(\\d{3,4})(\\d{4})",
"$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"50[0-46-9]\\d{6}",,,,"500123456",,,[9]],,,[,,,,,,,,,[-1]]],TZ:[,[,,"(?:[26-8]\\d|41|90)\\d{7}",,,,,,,[9]],[,,"2[2-8]\\d{7}",,,,"222345678"],[,,"77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}",,,,"621234567"],[,,"80[08]\\d{6}",,,,"800123456"],[,,"90\\d{7}",
,,,"900123456"],[,,"8(?:40|6[01])\\d{6}",,,,"840123456"],[,,,,,,,,,[-1]],[,,"41\\d{7}",,,,"412345678"],"TZ",255,"00[056]","0",,,"0",,,,[[,"(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,"(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UA:[,[,,"[89]\\d{9}|[3-9]\\d{8}",,,,,,,[9,10],[5,6,7]],[,,"(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",,,
,"311234567",,,[9],[5,6,7]],[,,"(?:50|6[36-8]|7[1-3]|9[1-9])\\d{7}",,,,"501234567",,,[9]],[,,"800[1-8]\\d{5,6}",,,,"800123456"],[,,"900[239]\\d{5,6}",,,,"900212345"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"89[1-579]\\d{6}",,,,"891234567",,,[9]],"UA",380,"00","0",,,"0",,"0~0",,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",
["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]","4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"],"0$1"],[,"(\\d{4})(\\d{5})","$1 $2",["[3-6]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UG:[,[,,"800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",,,,,,,[9],[5,6,7]],[,,"20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[0147]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
,,,"312345678",,,,[5,6,7]],[,,"726[01]\\d{5}|7(?:[0157-9]\\d|20|36|[46][0-4])\\d{6}",,,,"712345678"],[,,"800[1-3]\\d{5}",,,,"800123456"],[,,"90[1-3]\\d{6}",,,,"901123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UG",256,"00[057]","0",,,"0",,,,[[,"(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],[,"(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],US:[,[,,"[2-9]\\d{9}",
,,,,,,[10],[7]],[,,"5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-2]|[28]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
,,,"2015550123",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"US",1,"011","1",,,"1",,,1,[[,"(\\d{3})(\\d{4})","$1-$2",["[2-9]"]],[,"(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",
["[2-9]"],,,1]],[[,"(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[2-9]"]]],[,,,,,,,,,[-1]],1,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UY:[,[,,"4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}",,,,,,,[7,8,10]],[,,"(?:2\\d|4[2-7])\\d{6}",,,,"21231234",,,[8],[7]],[,,"9[1-9]\\d{6}",,,,"94231234",,,[8]],[,,"(?:4\\d{5}|80[05])\\d{4}|405\\d{4}",,,,"8001234",,,[7,10]],[,,"90[0-8]\\d{4}",,,,"9001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UY",598,"0(?:0|1[3-9]\\d)","0"," int. ",,"0",,"00",,[[,
"(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],[,"(\\d{4})(\\d{4})","$1 $2",["[24]"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],UZ:[,[,,"(?:33|55|[679]\\d|88)\\d{7}",,,,,,,[9]],[,,"(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
,,,"669050123"],[,,"(?:(?:33|88|9[0-57-9])\\d{3}|55(?:50[013]|90\\d)|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
,,,"912345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"UZ",998,"810","8",,,"8",,"8~10",,[[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[35-9]"],"8 $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VA:[,[,,"0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",,,,,,,[6,7,8,9,10,11,12]],[,,"06698\\d{1,6}",,,,"0669812345",,,[6,7,8,9,10,11]],[,,"3[1-9]\\d{8}|3[2-9]\\d{7}",,,,"3123456789",,,[9,10]],[,,"80(?:0\\d{3}|3)\\d{3}",
,,,"800123456",,,[6,9]],[,,"(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",,,,"899123456",,,[6,8,9,10]],[,,"84(?:[08]\\d{3}|[17])\\d{3}",,,,"848123456",,,[6,9]],[,,"1(?:78\\d|99)\\d{6}",,,,"1781234567",,,[9,10]],[,,"55\\d{8}",,,,"5512345678",,,[10]],"VA",39,"00",,,,,,,,,,[,,,,,,,,,[-1]],,"06698",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"3[2-8]\\d{9,10}",,,,"33101234501",,,[11,12]]],VC:[,[,,"(?:[58]\\d\\d|784|900)\\d{7}",,,,,,,[10],[7]],[,,"784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}",
,,,"7842661234",,,,[7]],[,,"784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}",,,,"7844301234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VC",
1,"011","1",,,"1|([2-7]\\d{6})$","784$1",,,,,[,,,,,,,,,[-1]],,"784",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VE:[,[,,"[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",,,,,,,[10],[7]],[,,"(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}",,,,"2121234567",,,,[7]],[,,"4(?:1[24-8]|2[46])\\d{7}",,,,"4121234567"],[,,"800\\d{7}",,,,"8001234567"],[,,"90[01]\\d{7}",,,,"9001234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"VE",58,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{7})","$1-$2",["[24-689]"],
"0$1","$CC $1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"501\\d{7}",,,,"5010123456",,,,[7]],,,[,,,,,,,,,[-1]]],VG:[,[,,"(?:284|[58]\\d\\d|900)\\d{7}",,,,,,,[10],[7]],[,,"284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}",,,,"2842291234",,,,[7]],[,,"284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}",,,,"2843001234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],
[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",,,,"5002345678"],[,,,,,,,,,[-1]],"VG",1,"011","1",,,"1|([2-578]\\d{6})$","284$1",,,,,[,,,,,,,,,[-1]],,"284",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VI:[,[,,"[58]\\d{9}|(?:34|90)0\\d{7}",,,,,,,[10],[7]],[,,"340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
,,,"3406421234",,,,[7]],[,,"340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",,,,"3406421234",,,,[7]],[,,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",,,,"8002345678"],[,,"900[2-9]\\d{6}",,,,"9002345678"],[,,,,,,,,,[-1]],[,,"52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}",
,,,"5002345678"],[,,,,,,,,,[-1]],"VI",1,"011","1",,,"1|([2-9]\\d{6})$","340$1",,1,,,[,,,,,,,,,[-1]],,"340",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],VN:[,[,,"[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",,,,,,,[7,8,9,10]],[,,"2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}",,,,"2101234567",,,[10]],[,,"(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}",,,,"912345678",,,[9]],[,,"1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
,,,"1800123456",,,[8,9,10]],[,,"1900\\d{4,6}",,,,"1900123456",,,[8,9,10]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"672\\d{6}",,,,"672012345",,,[9]],"VN",84,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1",,1],[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})",
"$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[[,"(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",,1],[,"(\\d{4})(\\d{4,6})","$1 $2",["1"],,,1],[,"(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1",,1],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1",,1],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",,1],[,"(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",,1]],[,,,,,,,,,[-1]],,,[,,"[17]99\\d{4}|69\\d{5,6}",,,,,,,[7,8]],[,,"(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
,,,"1992000",,,[7,8]],,,[,,,,,,,,,[-1]]],VU:[,[,,"[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",,,,,,,[5,7]],[,,"(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}",,,,"22123",,,[5]],[,,"(?:[58]\\d|7[013-7])\\d{5}",,,,"5912345",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"9(?:0[1-9]|1[01])\\d{4}",,,,"9010123",,,[7]],"VU",678,"00",,,,,,,,[[,"(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"(?:3[03]|900\\d)\\d{3}",,,,"30123"],,,[,,,,,,,,,[-1]]],WF:[,
[,,"(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",,,,,,,[6,9]],[,,"72\\d{4}",,,,"721234",,,[6]],[,,"(?:72|8[23])\\d{4}",,,,"821234",,,[6]],[,,"80[0-5]\\d{6}",,,,"800012345",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WF",681,"00",,,,,,,,[[,"(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],[,"(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"[48]0\\d{4}",,,,"401234",,,[6]]],WS:[,[,,"(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
,,,,,,[5,6,7,10]],[,,"6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}",,,,"22123",,,[5,6]],[,,"(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}",,,,"7212345",,,[7,10]],[,,"800\\d{3}",,,,"800123",,,[6]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"WS",685,"0",,,,,,,,[[,"(\\d{5})","$1",["[2-5]|6[1-9]"]],[,"(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],[,"(\\d{2})(\\d{5})","$1 $2",["7"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],XK:[,[,,"[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",,,,,,,[8,
9]],[,,"(?:2[89]|39)0\\d{6}|[23][89]\\d{6}",,,,"28012345"],[,,"4[3-9]\\d{6}",,,,"43201234",,,[8]],[,,"800\\d{5}",,,,"80001234",,,[8]],[,,"900\\d{5}",,,,"90001234",,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"XK",383,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YE:[,[,,"(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
,,,,,,[7,8,9],[6]],[,,"78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}",,,,"1234567",,,[7,8],[6]],[,,"7[0137]\\d{7}",,,,"712345678",,,[9]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YE",967,"00","0",,,"0",,,,[[,"(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],YT:[,[,,"80\\d{7}|(?:26|63)9\\d{6}",
,,,,,,[9]],[,,"269(?:0[67]|5[0-3]|6\\d|[78]0)\\d{4}",,,,"269601234"],[,,"639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}",,,,"639012345"],[,,"80\\d{7}",,,,"801234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"YT",262,"00","0",,,"0",,,,,,[,,,,,,,,,[-1]],,"269|63",[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],ZA:[,[,,"[1-79]\\d{8}|8\\d{4,9}",,,,,,,[5,6,7,8,9,10]],[,,"(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",,,,"101234567",
,,[9]],[,,"(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",,,,"711234567",,,[5,6,7,8,9]],[,,"80\\d{7}",,,,"801234567",,,[9]],[,,"(?:86[2-9]|9[0-2]\\d)\\d{6}",,,,"862345678",,,[9]],[,,"860\\d{6}",,,,"860123456",,,[9]],[,,,,,,,,,[-1]],[,,"87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
,,,"871234567",,,[9]],"ZA",27,"00","0",,,"0",,,,[[,"(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"861\\d{6,7}",,,,"861123456",,,[9,10]],,,[,,,,,,,,,[-1]]],ZM:[,[,,"(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}",,,,,,,[9],[6]],[,,"21[1-8]\\d{6}",
,,,"211234567",,,,[6]],[,,"(?:7[679]|9[5-8])\\d{7}",,,,"955123456"],[,,"800\\d{6}",,,,"800123456"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"630\\d{6}",,,,"630012345"],"ZM",260,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3})","$1 $2",["[1-9]"]],[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],[,"(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,,[,,,,,,,,,[-1]]],ZW:[,[,,"2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",,,,,,,[5,6,7,8,9,10],[3,4]],[,,"(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
,,,"1312345",,,,[3,4]],[,,"7(?:[178]\\d|3[1-9])\\d{6}",,,,"712345678",,,[9]],[,,"80(?:[01]\\d|20|8[0-8])\\d{3}",,,,"8001234",,,[7]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"86(?:1[12]|22|30|44|55|77|8[368])\\d{6}",,,,"8686123456",,,[10]],"ZW",263,"00","0",,,"0",,,,[[,"(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],[,"(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],[,"(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],
[,"(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],[,"(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],[,"(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],[,"(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],[,"(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
"0$1"],[,"(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],[,"(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],800:[,[,,"(?:005|[1-9]\\d\\d)\\d{5}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:005|[1-9]\\d\\d)\\d{5}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",800,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["\\d"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,
,,,,[-1]],,,[,,,,,,,,,[-1]]],808:[,[,,"[1-9]\\d{7}",,,,,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1-9]\\d{7}",,,,"12345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",808,,,,,,,,1,[[,"(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],870:[,[,,"7\\d{11}|[35-7]\\d{8}",,,,,,,[9,12]],[,,,,,,,,,[-1]],[,,"(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}",,,,"301234567"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],[,,,,,,,,,[-1]],"001",870,,,,,,,,,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],878:[,[,,"10\\d{10}",,,,,,,[12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"10\\d{10}",,,,"101234567890"],"001",878,,,,,,,,1,[[,"(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],881:[,[,,"[0-36-9]\\d{8}",,,,,,,[9]],
[,,,,,,,,,[-1]],[,,"[0-36-9]\\d{8}",,,,"612345678"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",881,,,,,,,,,[[,"(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],882:[,[,,"[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}",,,,,,,[7,8,9,10,11,12]],[,,,,,,,,,[-1]],[,,"342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}",,,,"3421234",,,[7,8,9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,
,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}",,,,"390123456789"],"001",882,,,,,,,,,[[,"(\\d{2})(\\d{5})","$1 $2",["16|342"]],[,"(\\d{2})(\\d{6})","$1 $2",["4"]],[,"(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[19]"]],[,"(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],[,"(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],[,"(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["34[57]"]],[,"(\\d{3})(\\d{4})(\\d{4})",
"$1 $2 $3",["34"]],[,"(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-3]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,"348[57]\\d{7}",,,,"34851234567",,,[11]]],883:[,[,,"210\\d{7}|51\\d{7}(?:\\d{3})?",,,,,,,[9,10,12]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"(?:210|51[013]0\\d)\\d{7}|5100\\d{5}",,,,"510012345"],"001",883,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],[,"(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2"]],[,
"(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["510"]],[,"(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["5"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]],888:[,[,,"\\d{11}",,,,,,,[11]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",888,,,,,,,,1,[[,"(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,"\\d{11}",,,,"12345678901"],,,[,,,,,,,,,[-1]]],979:[,[,,"[1359]\\d{8}",,,,,,,[9],[8]],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,"[1359]\\d{8}",,,,"123456789",,,,[8]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],"001",979,,,,,,,,1,[[,"(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],,[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2010 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.PhoneNumberUtil=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);i18n.phonenumbers.Error={INVALID_COUNTRY_CODE:"Invalid country calling code",NOT_A_NUMBER:"The string supplied did not seem to be a phone number",TOO_SHORT_AFTER_IDD:"Phone number too short after IDD",TOO_SHORT_NSN:"The string supplied is too short to be a phone number",TOO_LONG:"The string supplied is too long to be a phone number"};
i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_=1;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_=2;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_=17;i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_=3;i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_=250;i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_="ZZ";i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_="3";i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_={54:"9"};
i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_=[52,54,55];i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN="+";i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_="*";i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_=";ext=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_="tel:";i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_=";phone-context=";i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_=";isub=";
i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9"};
i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN,"*":"*","#":"#"};i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_={A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9","\uff10":"0","\uff11":"1","\uff12":"2","\uff13":"3","\uff14":"4","\uff15":"5","\uff16":"6","\uff17":"7","\uff18":"8","\uff19":"9","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u06f0":"0","\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9",
A:"2",B:"2",C:"2",D:"3",E:"3",F:"3",G:"4",H:"4",I:"4",J:"5",K:"5",L:"5",M:"6",N:"6",O:"6",P:"7",Q:"7",R:"7",S:"7",T:"8",U:"8",V:"8",W:"9",X:"9",Y:"9",Z:"9"};
i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_={0:"0",1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",A:"A",B:"B",C:"C",D:"D",E:"E",F:"F",G:"G",H:"H",I:"I",J:"J",K:"K",L:"L",M:"M",N:"N",O:"O",P:"P",Q:"Q",R:"R",S:"S",T:"T",U:"U",V:"V",W:"W",X:"X",Y:"Y",Z:"Z",a:"A",b:"B",c:"C",d:"D",e:"E",f:"F",g:"G",h:"H",i:"I",j:"J",k:"K",l:"L",m:"M",n:"N",o:"O",p:"P",q:"Q",r:"R",s:"S",t:"T",u:"U",v:"V",w:"W",x:"X",y:"Y",z:"Z","-":"-","\uff0d":"-","\u2010":"-","\u2011":"-","\u2012":"-",
"\u2013":"-","\u2014":"-","\u2015":"-","\u2212":"-","/":"/","\uff0f":"/"," ":" ","\u3000":" ","\u2060":" ",".":".","\uff0e":"."};i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_=/[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION="-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_="0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_="A-Za-z";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_="+\uff0b";i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]+");i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]+";
i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN=new RegExp("(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"])");i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_=new RegExp("["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]");i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_=/[\\\/] *x/;
i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_=new RegExp("[^"+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+"#]+$");i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_=/(?:.*?[A-Za-z]){3}.*/;i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_="["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_+"}";
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_="["+i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_+"]*(?:["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+"]*["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]){3,}["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_+i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]*";
i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_=" ext. ";i18n.phonenumbers.PhoneNumberUtil.extnDigits_=function(a){return"(["+i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_+"]{1,"+a+"})"};
i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_=function(){var a=i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"),b="[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|\u0434\u043e\u0431|anexo)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20")+"#?",c="[ \u00a0\\t,]*(?:[x\uff58#\uff03~\uff5e]|int|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+
"#?",d="[- ]+"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6")+"#",e="[ \u00a0\\t]*(?:,{2}|;)[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15")+"#?",f="[ \u00a0\\t]*(?:,)+[:\\.\uff0e]?[ \u00a0\\t,-]*"+i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9")+"#?";return a+"|"+b+"|"+c+"|"+d+"|"+e+"|"+f};i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_=new RegExp("(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")$","i");
i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_=new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_+"$|^"+i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_+"(?:"+i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_()+")?$","i");i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_=/\D+/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_=/(\$\d)/;i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_=/\$NP/;i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_=/\$FG/;
i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_=/\$CC/;i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_=/^\(?\$1\)?$/;i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY="001";i18n.phonenumbers.PhoneNumberFormat={E164:0,INTERNATIONAL:1,NATIONAL:2,RFC3966:3};i18n.phonenumbers.PhoneNumberType={FIXED_LINE:0,MOBILE:1,FIXED_LINE_OR_MOBILE:2,TOLL_FREE:3,PREMIUM_RATE:4,SHARED_COST:5,VOIP:6,PERSONAL_NUMBER:7,PAGER:8,UAN:9,VOICEMAIL:10,UNKNOWN:-1};
i18n.phonenumbers.PhoneNumberUtil.MatchType={NOT_A_NUMBER:0,NO_MATCH:1,SHORT_NSN_MATCH:2,NSN_MATCH:3,EXACT_MATCH:4};i18n.phonenumbers.PhoneNumberUtil.ValidationResult={IS_POSSIBLE:0,IS_POSSIBLE_LOCAL_ONLY:4,INVALID_COUNTRY_CODE:1,TOO_SHORT:2,INVALID_LENGTH:5,TOO_LONG:3};
i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber=function(a){var b=a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);0<=b?(a=a.substring(b),a=a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_,""),b=a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_),0<=b&&(a=a.substring(0,b))):a="";return a};
i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber=function(a){return a.length<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_,a)};
i18n.phonenumbers.PhoneNumberUtil.normalize=function(a){return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a)?i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!0):i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a)};i18n.phonenumbers.PhoneNumberUtil.normalizeSB_=function(a){var b=i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());a.clear();a.append(b)};
i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS,!0)};i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_,!0)};
i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber=function(a){return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a,i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_,!1)};i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));return null!=b&&(b.hasNationalPrefix()||a.hasItalianLeadingZero())&&this.isNumberGeographical(a)?this.getLengthOfNationalDestinationCode(a):0};
i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode=function(a){if(a.hasExtension()){var b=a.clone();b.clearExtension()}else b=a;b=this.format(b,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);0==b[0].length&&b.shift();return 2>=b.length?0:this.getNumberType(a)==i18n.phonenumbers.PhoneNumberType.MOBILE&&(a=i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()),""!=a)?b[2].length+
a.length:b[1].length};i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken=function(a){return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a]||""};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return isNaN(a)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes=function(){return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(a){return!isNaN(a)}).map(function(a){return parseInt(a,10)})};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes=function(){var a=Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);return[].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()),$jscomp.arrayFromIterable(a.map(function(b){return parseInt(b,10)})))};i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_=function(a){return null!=a&&(1!=a.possibleLengthCount()||-1!=a.possibleLengthArray()[0])};
i18n.phonenumbers.PhoneNumberUtil.descHasData_=function(a){return null!=a&&(a.hasExampleNumber()||i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a)||a.hasNationalNumberPattern())};
i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_=function(a){var b=[];goog.object.forEach(i18n.phonenumbers.PhoneNumberType,function(c){if(c!=i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE&&c!=i18n.phonenumbers.PhoneNumberType.UNKNOWN){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a,c);i18n.phonenumbers.PhoneNumberUtil.descHasData_(d)&&b.push(c)}});return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion=function(a){return this.isValidRegionCode_(a)?i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)):[]};i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity=function(a){a=this.getMetadataForNonGeographicalRegion(a);return null==a?[]:i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a)};
i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_=function(a,b,c){for(var d=new goog.string.StringBuffer,e,f,g=a.length,h=0;h<g;++h)e=a.charAt(h),f=b[e.toUpperCase()],null!=f?d.append(f):c||d.append(e);return d.toString()};i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly=function(a){return 0==a.length||i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical=function(a){var b=this.getNumberType(a);return b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||b==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE||i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(a.getCountryCodeOrDefault())&&b==i18n.phonenumbers.PhoneNumberType.MOBILE};i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_=function(a){return null!=a&&isNaN(a)&&a.toUpperCase()in i18n.phonenumbers.metadata.countryToMetadata};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_=function(a){return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap};
i18n.phonenumbers.PhoneNumberUtil.prototype.format=function(a,b){if(0==a.getNationalNumber()&&a.hasRawInput()){var c=a.getRawInputOrDefault();if(0<c.length)return c}c=a.getCountryCodeOrDefault();var d=this.getNationalSignificantNumber(a);if(b==i18n.phonenumbers.PhoneNumberFormat.E164)return this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.E164,d,"");if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,
e);a=this.maybeGetFormattedExtension_(a,e,b);d=this.formatNsn_(d,e,b);return this.prefixNumberWithCountryCallingCode_(c,b,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern=function(a,b,c){var d=a.getCountryCodeOrDefault(),e=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(d))return e;var f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);var g=this.chooseFormattingPatternForNumber_(c,e);if(null!=g){c=g.clone();g=g.getNationalPrefixFormattingRuleOrDefault();if(0<g.length){var h=f.getNationalPrefixOrDefault();0<h.length?(g=g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_,
h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_,"$1"),c.setNationalPrefixFormattingRule(g)):c.clearNationalPrefixFormattingRule()}e=this.formatNsnUsingPattern_(e,c,b)}a=this.maybeGetFormattedExtension_(a,f,b);return this.prefixNumberWithCountryCallingCode_(d,b,e,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;var e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);a=this.maybeGetFormattedExtension_(a,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);b=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b);return this.prefixNumberWithCountryCallingCode_(c,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL,b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_=function(a,b){return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==b?this.getMetadataForNonGeographicalRegion(a):this.getMetadataForRegion(b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode=function(a,b){return this.formatNationalNumberWithCarrierCode(a,0<a.getPreferredDomesticCarrierCodeOrDefault().length?a.getPreferredDomesticCarrierCodeOrDefault():b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing=function(a,b,c){var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return a.hasRawInput()?a.getRawInputOrDefault():"";var e="";a=a.clone();a.clearExtension();var f=this.getRegionCodeForCountryCode(d),g=this.getNumberType(a),h=g!=i18n.phonenumbers.PhoneNumberType.UNKNOWN;if(b==f)e=g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE||g==i18n.phonenumbers.PhoneNumberType.MOBILE||g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE,
"CO"==f&&g==i18n.phonenumbers.PhoneNumberType.FIXED_LINE?e=this.formatNationalNumberWithCarrierCode(a,i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_):"BR"==f&&e?e=0<a.getPreferredDomesticCarrierCodeOrDefault().length?this.formatNationalNumberWithPreferredCarrierCode(a,""):"":d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_?(b=this.getMetadataForRegion(b),e=this.canBeInternationallyDialled(a)&&this.testNumberLength_(this.getNationalSignificantNumber(a),b)!=i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT?
this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)):e=(f==i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY||("MX"==f||"CL"==f||"UZ"==f)&&e)&&this.canBeInternationallyDialled(a)?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);else if(h&&this.canBeInternationallyDialled(a))return c?this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL):
this.format(a,i18n.phonenumbers.PhoneNumberFormat.E164);return c?e:i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber=function(a,b){if(!this.isValidRegionCode_(b))return this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);var c=a.getCountryCodeOrDefault(),d=this.getNationalSignificantNumber(a);if(!this.hasValidCountryCallingCode_(c))return d;if(c==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return c+" "+this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}else if(c==this.getCountryCodeForValidRegion_(b))return this.format(a,
i18n.phonenumbers.PhoneNumberFormat.NATIONAL);var e=this.getMetadataForRegion(b),f=e.getInternationalPrefixOrDefault();b="";e.hasPreferredInternationalPrefix()?b=e.getPreferredInternationalPrefixOrDefault():i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,f)&&(b=f);e=this.getRegionCodeForCountryCode(c);e=this.getMetadataForRegionOrCallingCode_(c,e);d=this.formatNsn_(d,e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);a=this.maybeGetFormattedExtension_(a,
e,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+c+" "+d+a:this.prefixNumberWithCountryCallingCode_(c,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,d,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat=function(a,b){if(a.hasRawInput()&&!this.hasFormattingPatternForNumber_(a))return a.getRawInputOrDefault();if(!a.hasCountryCodeSource())return this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);switch(a.getCountryCodeSource()){case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:b=
this.formatOutOfCountryCallingNumber(a,b);break;case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);break;default:var c=this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()),d=this.getNddPrefixForRegion(c,!0);b=this.format(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL);if(null!=d&&0!=d.length&&!this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(),d,c)&&(c=this.getMetadataForRegion(c),
d=this.getNationalSignificantNumber(a),c=this.chooseFormattingPatternForNumber_(c.numberFormatArray(),d),null!=c)){d=c.getNationalPrefixFormattingRuleOrDefault();var e=d.indexOf("$1");0>=e||(d=d.substring(0,e),d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d),0!=d.length&&(b=c.clone(),b.clearNationalPrefixFormattingRule(),b=this.formatByPattern(a,i18n.phonenumbers.PhoneNumberFormat.NATIONAL,[b])))}}a=a.getRawInputOrDefault();null!=b&&0<a.length&&(c=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(b),
d=i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(a),c!=d&&(b=a));return b};i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_=function(a,b,c){a=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);if(goog.string.startsWith(a,b))try{return this.isValidNumber(this.parse(a.substring(b.length),c))}catch(d){}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_=function(a){var b=a.getCountryCodeOrDefault(),c=this.getRegionCodeForCountryCode(b);b=this.getMetadataForRegionOrCallingCode_(b,c);if(null==b)return!1;a=this.getNationalSignificantNumber(a);return null!=this.chooseFormattingPatternForNumber_(b.numberFormatArray(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars=function(a,b){var c=a.getRawInputOrDefault();if(0==c.length)return this.formatOutOfCountryCallingNumber(a,b);var d=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(d))return c;c=i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c,i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_,!0);var e=this.getNationalSignificantNumber(a);if(3<e.length){var f=c.indexOf(e.substring(0,3));-1!=f&&(c=
c.substring(f))}f=this.getMetadataForRegion(b);if(d==i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_){if(this.isNANPACountry(b))return d+" "+c}else if(null!=f&&d==this.getCountryCodeForValidRegion_(b)){d=this.chooseFormattingPatternForNumber_(f.numberFormatArray(),e);if(null==d)return c;d=d.clone();d.setPattern("(\\d+)(.*)");d.setFormat("$1$2");return this.formatNsnUsingPattern_(c,d,i18n.phonenumbers.PhoneNumberFormat.NATIONAL)}b="";null!=f&&(b=f.getInternationalPrefixOrDefault(),b=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,
b)?b:f.getPreferredInternationalPrefixOrDefault());f=this.getRegionCodeForCountryCode(d);f=this.getMetadataForRegionOrCallingCode_(d,f);a=this.maybeGetFormattedExtension_(a,f,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);return 0<b.length?b+" "+d+" "+c+a:this.prefixNumberWithCountryCallingCode_(d,i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL,c,a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_=function(a,b,c,d){switch(b){case i18n.phonenumbers.PhoneNumberFormat.E164:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+c+d;case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+" "+c+d;case i18n.phonenumbers.PhoneNumberFormat.RFC3966:return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+a+"-"+c+d;default:return c+
d}};i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_=function(a,b,c,d){b=0==b.intlNumberFormatArray().length||c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL?b.numberFormatArray():b.intlNumberFormatArray();b=this.chooseFormattingPatternForNumber_(b,a);return null==b?a:this.formatNsnUsingPattern_(a,b,c,d)};
i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_=function(a,b){for(var c,d=a.length,e=0;e<d;++e){c=a[e];var f=c.leadingDigitsPatternCount();if(0==f||0==b.search(c.getLeadingDigitsPattern(f-1)))if(f=new RegExp(c.getPattern()),i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,b))return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_=function(a,b,c,d){var e=b.getFormatOrDefault(),f=new RegExp(b.getPattern()),g=b.getDomesticCarrierCodeFormattingRuleOrDefault();c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&null!=d&&0<d.length&&0<g.length?(b=g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_,d),e=e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b),a=a.replace(f,e)):(b=b.getNationalPrefixFormattingRuleOrDefault(),a=c==i18n.phonenumbers.PhoneNumberFormat.NATIONAL&&
null!=b&&0<b.length?a.replace(f,e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_,b)):a.replace(f,e));c==i18n.phonenumbers.PhoneNumberFormat.RFC3966&&(a=a.replace(new RegExp("^"+i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_),""),a=a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_,"g"),"-"));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber=function(a){return this.getExampleNumberForType(a,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType=function(a,b){if(!this.isValidRegionCode_(a))return null;b=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a),b);try{if(b.hasExampleNumber())return this.parse(b.getExampleNumber(),a)}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity=function(a){var b=this.getMetadataForNonGeographicalRegion(a);if(null!=b&&(b=[b.getMobile(),b.getTollFree(),b.getSharedCost(),b.getVoip(),b.getVoicemail(),b.getUan(),b.getPremiumRate()].find(function(c,d){return c.hasExampleNumber()}),void 0!==b))try{return this.parse("+"+a+b.getExampleNumber(),"ZZ")}catch(c){}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_=function(a,b,c){return a.hasExtension()&&0!=a.getExtension().length?c==i18n.phonenumbers.PhoneNumberFormat.RFC3966?i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_+a.getExtension():b.hasPreferredExtnPrefix()?b.getPreferredExtnPrefix()+a.getExtensionOrDefault():i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_+a.getExtensionOrDefault():""};
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_=function(a,b){switch(b){case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:return a.getPremiumRate();case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:return a.getTollFree();case i18n.phonenumbers.PhoneNumberType.MOBILE:return a.getMobile();case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:return a.getFixedLine();case i18n.phonenumbers.PhoneNumberType.SHARED_COST:return a.getSharedCost();
case i18n.phonenumbers.PhoneNumberType.VOIP:return a.getVoip();case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:return a.getPersonalNumber();case i18n.phonenumbers.PhoneNumberType.PAGER:return a.getPager();case i18n.phonenumbers.PhoneNumberType.UAN:return a.getUan();case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:return a.getVoicemail();default:return a.getGeneralDesc()}};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType=function(a){var b=this.getRegionCodeForNumber(a);b=this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(),b);if(null==b)return i18n.phonenumbers.PhoneNumberType.UNKNOWN;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_=function(a,b){return this.isNumberMatchingDesc_(a,b.getGeneralDesc())?this.isNumberMatchingDesc_(a,b.getPremiumRate())?i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:this.isNumberMatchingDesc_(a,b.getTollFree())?i18n.phonenumbers.PhoneNumberType.TOLL_FREE:this.isNumberMatchingDesc_(a,b.getSharedCost())?i18n.phonenumbers.PhoneNumberType.SHARED_COST:this.isNumberMatchingDesc_(a,b.getVoip())?i18n.phonenumbers.PhoneNumberType.VOIP:this.isNumberMatchingDesc_(a,
b.getPersonalNumber())?i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:this.isNumberMatchingDesc_(a,b.getPager())?i18n.phonenumbers.PhoneNumberType.PAGER:this.isNumberMatchingDesc_(a,b.getUan())?i18n.phonenumbers.PhoneNumberType.UAN:this.isNumberMatchingDesc_(a,b.getVoicemail())?i18n.phonenumbers.PhoneNumberType.VOICEMAIL:this.isNumberMatchingDesc_(a,b.getFixedLine())?b.getSameMobileAndFixedLinePattern()||this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
i18n.phonenumbers.PhoneNumberType.FIXED_LINE:!b.getSameMobileAndFixedLinePattern()&&this.isNumberMatchingDesc_(a,b.getMobile())?i18n.phonenumbers.PhoneNumberType.MOBILE:i18n.phonenumbers.PhoneNumberType.UNKNOWN:i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion=function(a){if(null==a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.metadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion=function(a){return this.getMetadataForRegion(""+a)};i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_=function(a,b){var c=a.length;return 0<b.possibleLengthCount()&&-1==b.possibleLengthArray().indexOf(c)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber=function(a){var b=this.getRegionCodeForNumber(a);return this.isValidNumberForRegion(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion=function(a,b){var c=a.getCountryCodeOrDefault(),d=this.getMetadataForRegionOrCallingCode_(c,b);if(null==d||i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY!=b&&c!=this.getCountryCodeForValidRegion_(b))return!1;a=this.getNationalSignificantNumber(a);return this.getNumberTypeHelper_(a,d)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber=function(a){if(null==a)return null;var b=a.getCountryCodeOrDefault();b=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];return null==b?null:1==b.length?b[0]:this.getRegionCodeForNumberFromRegionList_(a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_=function(a,b){a=this.getNationalSignificantNumber(a);for(var c,d=b.length,e=0;e<d;e++){c=b[e];var f=this.getMetadataForRegion(c);if(f.hasLeadingDigits()){if(0==a.search(f.getLeadingDigits()))return c}else if(this.getNumberTypeHelper_(a,f)!=i18n.phonenumbers.PhoneNumberType.UNKNOWN)return c}return null};
i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_:a[0]};i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode=function(a){a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];return null==a?[]:a};
i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion=function(a){return this.isValidRegionCode_(a)?this.getCountryCodeForValidRegion_(a):0};i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_=function(a){var b=this.getMetadataForRegion(a);if(null==b)throw Error("Invalid region code: "+a);return b.getCountryCodeOrDefault()};
i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion=function(a,b){a=this.getMetadataForRegion(a);if(null==a)return null;a=a.getNationalPrefixOrDefault();if(0==a.length)return null;b&&(a=a.replace("~",""));return a};i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry=function(a){return null!=a&&i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(a.toUpperCase())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber=function(a){if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a))return!1;a=new goog.string.StringBuffer(a);this.maybeStripExtension(a);return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_,a.toString())};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber=function(a){a=this.isPossibleNumberWithReason(a);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType=function(a,b){a=this.isPossibleNumberForTypeWithReason(a,b);return a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE||a==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_=function(a,b){return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,c),e=0==d.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():d.possibleLengthArray();d=d.possibleLengthLocalOnlyArray();if(c==i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE)if(i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.FIXED_LINE)))c=
i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b,i18n.phonenumbers.PhoneNumberType.MOBILE),i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c)&&(e=e.concat(0==c.possibleLengthCount()?b.getGeneralDesc().possibleLengthArray():c.possibleLengthArray()),e.sort(),0==d.length?d=c.possibleLengthLocalOnlyArray():(d=d.concat(c.possibleLengthLocalOnlyArray()),d.sort()));else return this.testNumberLengthForType_(a,b,i18n.phonenumbers.PhoneNumberType.MOBILE);if(-1==e[0])return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
a=a.length;if(-1<d.indexOf(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;b=e[0];return b==a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:b>a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT:e[e.length-1]<a?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG:-1<e.indexOf(a,1)?i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE:i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason=function(a){return this.isPossibleNumberForTypeWithReason(a,i18n.phonenumbers.PhoneNumberType.UNKNOWN)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason=function(a,b){var c=this.getNationalSignificantNumber(a);a=a.getCountryCodeOrDefault();if(!this.hasValidCountryCallingCode_(a))return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;var d=this.getRegionCodeForCountryCode(a);a=this.getMetadataForRegionOrCallingCode_(a,d);return this.testNumberLengthForType_(c,a,b)};
i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString=function(a,b){try{return this.isPossibleNumber(this.parse(a,b))}catch(c){return!1}};
i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber=function(a){if(this.isValidNumber(a))return!0;var b=a.clone(),c=a.getNationalNumberOrDefault();do if(c=Math.floor(c/10),b.setNationalNumber(c),0==c||this.isPossibleNumberWithReason(b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT)return!1;while(!this.isValidNumber(b));a.setNationalNumber(c);return!0};
i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode=function(a,b){a=a.toString();if(0==a.length||"0"==a.charAt(0))return 0;for(var c,d=a.length,e=1;e<=i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_&&e<=d;++e)if(c=parseInt(a.substring(0,e),10),c in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap)return b.append(a.substring(e)),c;return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode=function(a,b,c,d,e){if(0==a.length)return 0;a=new goog.string.StringBuffer(a);var f;null!=b&&(f=b.getInternationalPrefix());null==f&&(f="NonMatch");f=this.maybeStripInternationalPrefixAndNormalize(a,f);d&&e.setCountryCodeSource(f);if(f!=i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY){if(a.getLength()<=i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
b=this.extractCountryCode(a,c);if(0!=b)return e.setCountryCode(b),b;throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);}if(null!=b){f=b.getCountryCodeOrDefault();var g=""+f,h=a.toString();if(goog.string.startsWith(h,g)&&(g=new goog.string.StringBuffer(h.substring(g.length)),h=b.getGeneralDesc(),h=new RegExp(h.getNationalNumberPatternOrDefault()),this.maybeStripNationalPrefixAndCarrierCode(g,b,null),g=g.toString(),!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,a.toString())&&i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(h,
g)||this.testNumberLength_(a.toString(),b)==i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG))return c.append(g),d&&e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN),e.setCountryCode(f),f}e.setCountryCode(0);return 0};
i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_=function(a,b){var c=b.toString();if(0==c.search(a)){a=c.match(a)[0].length;var d=c.substring(a).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);if(d&&null!=d[1]&&0<d[1].length&&"0"==i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d[1]))return!1;b.clear();b.append(c.substring(a));return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize=function(a,b){var c=a.toString();if(0==c.length)return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(c))return c=c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),a.clear(),a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)),i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
b=new RegExp(b);i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);return this.parsePrefixAsIdd_(b,a)?i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode=function(a,b,c){var d=a.toString(),e=d.length,f=b.getNationalPrefixForParsing();if(0==e||null==f||0==f.length)return!1;var g=new RegExp("^(?:"+f+")");if(e=g.exec(d)){f=new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());var h=i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d),k=e.length-1;b=b.getNationalPrefixTransformRule();if(null==b||0==b.length||null==e[k]||0==e[k].length){if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,
d.substring(e[0].length)))return!1;null!=c&&0<k&&null!=e[k]&&c.append(e[1]);a.set(d.substring(e[0].length))}else{d=d.replace(g,b);if(h&&!i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(f,d))return!1;null!=c&&0<k&&c.append(e[1]);a.set(d)}return!0}return!1};
i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension=function(a){var b=a.toString(),c=b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);if(0<=c&&i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0,c)))for(var d=b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_),e=d.length,f=1;f<e;++f)if(null!=d[f]&&0<d[f].length)return a.clear(),a.append(b.substring(0,c)),d[f];return""};
i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_=function(a,b){return this.isValidRegionCode_(b)||null!=a&&0<a.length&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(a)};i18n.phonenumbers.PhoneNumberUtil.prototype.parse=function(a,b){return this.parseHelper_(a,b,!1,!0)};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput=function(a,b){if(!this.isValidRegionCode_(b)&&0<a.length&&a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN)throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);return this.parseHelper_(a,b,!0,!0)};i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_=function(a,b){if(1<a.length&&"0"==a.charAt(0)){b.setItalianLeadingZero(!0);for(var c=1;c<a.length-1&&"0"==a.charAt(c);)c++;1!=c&&b.setNumberOfLeadingZeros(c)}};
i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_=function(a,b,c,d){if(null==a)throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(a.length>i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_)throw Error(i18n.phonenumbers.Error.TOO_LONG);var e=new goog.string.StringBuffer;this.buildNationalNumberForParsing_(a,e);if(!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString()))throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);if(d&&!this.checkRegionForParsing_(e.toString(),b))throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
d=new i18n.phonenumbers.PhoneNumber;c&&d.setRawInput(a);a=this.maybeStripExtension(e);0<a.length&&d.setExtension(a);var f=this.getMetadataForRegion(b);a=new goog.string.StringBuffer;var g=0,h=e.toString();try{g=this.maybeExtractCountryCode(h,f,a,c,d)}catch(k){if(k.message==i18n.phonenumbers.Error.INVALID_COUNTRY_CODE&&i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(h)){if(h=h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN,""),g=this.maybeExtractCountryCode(h,
f,a,c,d),0==g)throw k;}else throw k;}0!=g?(e=this.getRegionCodeForCountryCode(g),e!=b&&(f=this.getMetadataForRegionOrCallingCode_(g,e))):(i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e),a.append(e.toString()),null!=b?(g=f.getCountryCodeOrDefault(),d.setCountryCode(g)):c&&d.clearCountryCodeSource());if(a.getLength()<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);null!=f&&(b=new goog.string.StringBuffer,e=new goog.string.StringBuffer(a.toString()),
this.maybeStripNationalPrefixAndCarrierCode(e,f,b),f=this.testNumberLength_(e.toString(),f),g=i18n.phonenumbers.PhoneNumberUtil.ValidationResult,f!=g.TOO_SHORT&&f!=g.IS_POSSIBLE_LOCAL_ONLY&&f!=g.INVALID_LENGTH&&(a=e,c&&0<b.toString().length&&d.setPreferredDomesticCarrierCode(b.toString())));c=a.toString();a=c.length;if(a<i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);if(a>i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_)throw Error(i18n.phonenumbers.Error.TOO_LONG);
i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c,d);d.setNationalNumber(parseInt(c,10));return d};
i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_=function(a,b){var c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);if(0<=c){var d=c+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;if(a.charAt(d)==i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN){var e=a.indexOf(";",d);0<e?b.append(a.substring(d,e)):b.append(a.substring(d))}d=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);b.append(a.substring(0<=d?d+i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length:
0,c))}else b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));a=b.toString();c=a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);0<c&&(b.clear(),b.append(a.substring(0,c)))};
i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_=function(a){var b=new i18n.phonenumbers.PhoneNumber;b.setCountryCode(a.getCountryCodeOrDefault());b.setNationalNumber(a.getNationalNumberOrDefault());0<a.getExtensionOrDefault().length&&b.setExtension(a.getExtensionOrDefault());a.getItalianLeadingZero()&&(b.setItalianLeadingZero(!0),b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));return b};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch=function(a,b){if("string"==typeof a)try{var c=this.parse(a,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_)}catch(f){if(f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE)return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;if("string"!=typeof b){var d=this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());if(d!=i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_){try{c=this.parse(a,d)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}var e=
this.isNumberMatch(c,b);return e==i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:e}}try{c=this.parseHelper_(a,null,!1,!1)}catch(g){return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER}}else c=a.clone();if("string"==typeof b)try{return e=this.parse(b,i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_),this.isNumberMatch(a,e)}catch(f){return f.message!=i18n.phonenumbers.Error.INVALID_COUNTRY_CODE?i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER:
this.isNumberMatch(b,c)}else e=b.clone();a=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);e=i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);if(a.hasExtension()&&e.hasExtension()&&a.getExtension()!=e.getExtension())return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;b=a.getCountryCodeOrDefault();c=e.getCountryCodeOrDefault();if(0!=b&&0!=c)return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH:b==c&&this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:
i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;a.setCountryCode(0);e.setCountryCode(0);return a.equals(e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH:this.isNationalNumberSuffixOfTheOther_(a,e)?i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH:i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH};
i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_=function(a,b){a=""+a.getNationalNumber();b=""+b.getNationalNumber();return goog.string.endsWith(a,b)||goog.string.endsWith(b,a)};i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled=function(a){var b=this.getMetadataForRegion(this.getRegionCodeForNumber(a));if(null==b)return!0;a=this.getNationalSignificantNumber(a);return!this.isNumberMatchingDesc_(a,b.getNoInternationalDialling())};
i18n.phonenumbers.PhoneNumberUtil.matchesEntirely=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")$"):b.match(a))&&a[0].length==b.length?!0:!1};i18n.phonenumbers.PhoneNumberUtil.matchesPrefix=function(a,b){return(a="string"==typeof a?b.match("^(?:"+a+")"):b.match(a))&&goog.string.startsWith(b,a[0])?!0:!1};i18n.phonenumbers.shortnumbermetadata={};i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap={0:"AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ")};
i18n.phonenumbers.shortnumbermetadata.countryToMetadata={AC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AD:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],,,,"AD",,,,,,,,,,,,,,,,,,[,,"11[0268]",,,,"110"],,[,,"11[0268]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AE:[,[,,"[149]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|99[7-9]",
,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AE",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"112|445[16]|99[7-9]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"445\\d",,,,"4450",,,[4]]],AF:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"AF",,,,,,,,,,,,,,,,,,[,,"1(?:0[02]|19)",,,,"100",,,[3]],,[,,"1(?:0[02]|19)|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AG:[,[,,"[19]\\d\\d",,,,,,,[3]],,,
[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"AG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"176|9(?:11|99)",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AI:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"AI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AL:[,[,,"[15]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)",,,,"112",,,[3,6]],[,,"5\\d{4}",,,,"50000",
,,[5]],,,,"AL",,,,,,,,,,,,,,,,,,[,,"1(?:12|2[7-9])",,,,"112",,,[3]],,[,,"1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])",,,,"110"],[,,,,,,,,,[-1]],[,,"123",,,,"123",,,[3]],,[,,"131|5\\d{4}",,,,"131",,,[3,5]]],AM:[,[,,"[148]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AM",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"(?:1|8[1-7])\\d\\d|40404",,,,"100"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",
,,[5]]],AO:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],,,,"AO",,,,,,,,,,,,,,,,,,[,,"11[235]",,,,"112"],,[,,"11[235]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AR:[,[,,"[01389]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911",,,,"19",,,[2,3]],[,,,,,,,,,[-1]],,,,"AR",,,,,,,,,,,,,,,,,,[,,"10[017]|911",,,,"100",,,[3]],,[,,"000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911",,,,"19"],[,,,,,,,,,[-1]],[,,"893\\d\\d",
,,,"89300",,,[5]],,[,,"(?:337|893\\d)\\d",,,,"3370",,,[4,5]]],AS:[,[,,"[49]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"911",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"AS",,,,,,,,,,,,,,,,,,[,,"911",,,,"911",,,[3]],,[,,"40404|911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],AT:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"116\\d{3}|1(?:[12]2|33|44)",,,,"112"],[,,,,,,,,,[-1]],,,,"AT",,,,,,,,,,,,,,,,,,[,,"1(?:[12]2|33|44)",,,,"112",,,[3]],,[,,"116(?:00[06]|1(?:17|23))|1(?:[12]2|33|44)",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AU:[,[,,"[0-27]\\d{2,7}",,,,,,,[3,4,5,6,7,8]],,,[,,"000|1(?:06|12|258885|55\\d)|733",,,,"000",,,[3,4,7]],[,,"1(?:2(?:34|456)|9\\d{4,6})",,,,"1234",,,[4,5,6,7,8]],,,,"AU",,,,,,,,,,,,,,,,,,[,,"000|1(?:06|12)",,,,"000",,,[3]],,[,,"000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",,,,"000"],[,,"1(?:1[09]\\d|24733)|225|767",,,,"225",,,[3,4,6]],[,,"1(?:258885|55\\d)",
,,,"1550",,,[4,7]],,[,,"19\\d{4,6}",,,,"190000",,,[6,7,8]]],AW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"100|911",,,,"100"],[,,,,,,,,,[-1]],,,,"AW",,,,,,,,,,,,,,,,,,[,,"100|911",,,,"100"],,[,,"1(?:00|18|76)|91[13]",,,,"100"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],AX:[,[,,"[17]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"AX",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"112|75[12]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],AZ:[,[,
,"[148]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"AZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-3]|12)|(?:404|880)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:404|880)\\d",,,,"4040",,,[4]],,[,,"(?:404|880)\\d",,,,"4040",,,[4]]],BA:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:16\\d{3}|2[2-4])",,,,"122",,,[3,6]],[,,,,,,,,,[-1]],,,,"BA",,,,,,,,,,,,,,,,,,[,,"12[2-4]",,,,"122",,,[3]],,[,,"1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?",
,,,"122"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BB:[,[,,"[2-689]\\d\\d",,,,,,,[3]],,,[,,"[2359]11",,,,"211"],[,,,,,,,,,[-1]],,,,"BB",,,,,,,,,,,,,,,,,,[,,"[2359]11",,,,"211"],,[,,"[2-689]11",,,,"211"],[,,,,,,,,,[-1]],[,,"[468]11",,,,"411"],,[,,,,,,,,,[-1]]],BD:[,[,,"[1579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10[0-26]|[19]99",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"BD",,,,,,,,,,,,,,,,,,[,,"10[0-2]|[19]99",,,,"100",,,[3]],,[,,"1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:11|2[13])|(?:501|959)\\d|786",,,,"111",,,[3,4]],,[,,"959\\d",,,,"9590",,,[4]]],BE:[,[,,"[1-9]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:0[0-25-8]|1[02]|7(?:12|77)|813)|(?:116|8)\\d{3}",,,,"100"],[,,"1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",,,,"1204",,,[4]],,,,"BE",,,,,,,,,,,,,,,,,,[,,"1(?:0[01]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-8]|1(?:[027]|6117)|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]",
,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"[2-9]\\d{3}",,,,"2000",,,[4]]],BF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"BF",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BG:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],,,,"BG",,,,,,,,,,,,,,,,,,[,,"1(?:12|50|6[06])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|50|6[06])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,
[-1]],,[,,,,,,,,,[-1]]],BH:[,[,,"[0189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"(?:0[167]|81)\\d{3}|[19]99",,,,"199"],[,,"9[148]\\d{3}",,,,"91000",,,[5]],,,,"BH",,,,,,,,,,,,,,,,,,[,,"[19]99",,,,"199",,,[3]],,[,,"1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",,,,"100"],[,,,,,,,,,[-1]],[,,"0[67]\\d{3}|88000|98555",,,,"06000",,,[5]],,[,,"88000|98555",,,,"88000",,,[5]]],BI:[,[,,"[16-9]\\d{2,3}",,,,,,,[3,4]],,,[,,"11[237]|611",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"BI",,,,,,
,,,,,,,,,,,,[,,"11[237]",,,,"112",,,[3]],,[,,"1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900",,,,"110"],[,,,,,,,,,[-1]],[,,"611|7(?:10|77)|888|900",,,,"611",,,[3]],,[,,"(?:71|90)0",,,,"710",,,[3]]],BJ:[,[,,"[17]\\d{2,3}",,,,,,,[3,4]],,,[,,"11[78]|7[3-5]\\d\\d",,,,"117"],[,,,,,,,,,[-1]],,,,"BJ",,,,,,,,,,,,,,,,,,[,,"11[78]",,,,"117",,,[3]],,[,,"1(?:1[78]|2[02-5]|60)|7[0-5]\\d\\d",,,,"117"],[,,,,,,,,,[-1]],[,,"12[02-5]",,,,"120",,,[3]],,[,,,,,,,,,[-1]]],BL:[,[,,"1\\d",,,,,,,[2]],,,[,,"18",,
,,"18"],[,,,,,,,,,[-1]],,,,"BL",,,,,,,,,,,,,,,,,,[,,"18",,,,"18"],,[,,"18",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"BM",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BN:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],,,,"BN",,,,,,,,,,,,,,,,,,[,,"99[135]",,,,"991"],,[,,"99[135]",,,,"991"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],BO:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[089]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BO",,,,,,,,,,,,,,,,,,[,,"11[089]",,,,"110",,,[3]],,[,,"11[089]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],BQ:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"BQ",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],BR:[,[,,"[1-69]\\d{2,5}",,,,,,,[3,
4,5,6]],,,[,,"1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911",,,,"100",,,[3,4]],[,,,,,,,,,[-1]],,,,"BR",,,,,,,,,,,,,,,,,,[,,"1(?:12|28|9[023])|911",,,,"112",,,[3]],,[,,"1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
,,,"100"],[,,"102|273\\d\\d|321",,,,"102",,,[3,5]],[,,"151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)",,,,"151",,,[3,4,5]],,[,,"285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}",,,,"321"]],BS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"91[19]",,,,"911"],[,,,,,,,,,[-1]],,,,"BS",,,,,,,,,,,,,,,,,,[,,"91[19]",,,,"911"],,[,,"91[19]",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[023]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"BT",,,,,,,,,,,,
,,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"11[0-6]|40404",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],BW:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"BW",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[7-9])",,,,"911",,,[3]],,[,,"1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"131\\d\\d",,,,"13100",,,[5]],,[,,"131\\d\\d",,,,"13100",,,[5]]],BY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],
,,,"BY",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],BZ:[,[,,"9\\d\\d?",,,,,,,[2,3]],,,[,,"9(?:0|11)",,,,"90"],[,,,,,,,,,[-1]],,,,"BZ",,,,,,,,,,,,,,,,,,[,,"9(?:0|11)",,,,"90"],,[,,"9(?:0|11)",,,,"90"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CA:[,[,,"[1-9]\\d\\d(?:\\d\\d(?:\\d(?:\\d{2})?)?)?",,,,,,,[3,5,6,8]],,,[,,"112|[29]11",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CA",
,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"112|30000\\d{3}|[1-35-9]\\d{4,5}|[2-9]11",,,,"112"],[,,,,,,,,,[-1]],[,,"[235-7]11",,,,"211",,,[3]],,[,,"300\\d{5}|[1-35-9]\\d{4,5}",,,,"10000",,,[5,6,8]]],CC:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],,,,"CC",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CD:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],[,,,,,,,,,[-1]],
,,,"CD",,,,,,,,,,,,,,,,,,[,,"1(?:1[348]|77|88)",,,,"113",,,[3]],,[,,"1(?:1[348]|23|77|88)|40404",,,,"113"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],CF:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|22\\d)",,,,"117"],[,,,,,,,,,[-1]],,,,"CF",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|220)",,,,"117"],,[,,"1(?:1[478]|220)",,,,"114"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CG:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[178]",,,,"111"],[,,,,,,,,,[-1]],,,,"CG",,,,,,,,,,,,,
,,,,,[,,"11[78]",,,,"117"],,[,,"11[126-8]",,,,"111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CH:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[278]|6\\d{3})|4[47])|5200",,,,"112",,,[3,4,6]],[,,"1(?:14|8[01589])\\d|543|83111",,,,"543",,,[3,4,5]],,,,"CH",,,,,,,,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],,[,,"1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[45])|6(?:00|[1-46])|8(?:02|1[189]|50|7|8[08]|99))|[2-9]\\d{2,4}",,,,"112"],[,,"1(?:4[035]|6[1-46])|1(?:41|60)\\d",,,,
"140",,,[3,4]],[,,"5(?:200|35)",,,,"535",,,[3,4]],,[,,"[2-9]\\d{2,4}",,,,"200",,,[3,4,5]]],CI:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"CI",,,,,,,,,,,,,,,,,,[,,"1(?:1[01]|[78]0)",,,,"110",,,[3]],,[,,"1(?:1[01]|[78]0)|4443",,,,"110"],[,,,,,,,,,[-1]],[,,"444\\d",,,,"4440",,,[4]],,[,,"444\\d",,,,"4440",,,[4]]],CK:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[689]",,,,"996"],[,,,,,,,,,[-1]],,,,"CK",,,,,,,,,,,,,,,,,,[,,"99[689]",,,,"996"],,[,,"99[689]",,,,"996"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CL:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:213|3[1-3])|434\\d|911",,,,"131",,,[3,4]],[,,"1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d",,,,"1060",,,[4,5]],,,,"CL",,,,,,,,,,,,,,,,,,[,,"13[1-3]|911",,,,"131",,,[3]],,[,,"1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
,,,"100"],[,,"(?:200|333)\\d",,,,"2000",,,[4]],[,,,,,,,,,[-1]],,[,,"13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d",,,,"1060",,,[4,5]]],CM:[,[,,"[18]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],[,,,,,,,,,[-1]],,,,"CM",,,,,,,,,,,,,,,,,,[,,"1(?:1[37]|[37])",,,,"13",,,[2,3]],,[,,"1(?:1[37]|[37])|8711",
,,,"13"],[,,,,,,,,,[-1]],[,,"871\\d",,,,"8710",,,[4]],,[,,"871\\d",,,,"8710",,,[4]]],CN:[,[,,"[19]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"1(?:1[09]|20)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"CN",,,,,,,,,,,,,,,,,,[,,"1(?:1[09]|20)",,,,"110",,,[3]],,[,,"1(?:00\\d\\d|1[029]|20)|95\\d{3,4}",,,,"110"],[,,"1(?:00\\d\\d|12)|95\\d{3,4}",,,,"112"],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CO:[,[,,"[148]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CO",,,,,,,,,,,,,,
,,,,[,,"1(?:1[29]|23|32|56)",,,,"112",,,[3]],,[,,"1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|40404|85432",,,,"106"],[,,,,,,,,,[-1]],[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]],,[,,"(?:40|85)4\\d\\d",,,,"40400",,,[5]]],CR:[,[,,"[1359]\\d{2,3}",,,,,,,[3,4]],,,[,,"112|911",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"CR",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:385|5(?:0[34]|51))\\d",,,,"3850",,,[4]]],CU:[,[,,"[12]\\d\\d(?:\\d{3,4})?",,,,,,,[3,6,7]],,,[,,"10[4-7]|(?:116|204\\d)\\d{3}",,,,"104"],[,,,,,,,,,[-1]],,,,"CU",,,,,,,,,,,,,,,,,,[,,"10[4-6]",,,,"104",,,[3]],,[,,"1(?:0[4-7]|1(?:6111|8)|40)|2045252",,,,"104"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CV:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"13[0-2]",,,,"130"],[,,,,,,,,,[-1]],,,,"CV",,,,,,,,,,,,,,,,,,[,,"13[0-2]",,,,"130"],,[,,"13[0-2]",,,,"130"],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CW:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],,,,"CW",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"1(?:12|76)|911",,,,"112"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],CX:[,[,,"[01]\\d\\d",,,,,,,[3]],,,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],,,,"CX",,,,,,,,,,,,,,,,,,[,,"000|112",,,,"000"],,[,,"000|112",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CY:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"1(?:1(?:2|6\\d{3})|99)",
,,,"112"],[,,,,,,,,,[-1]],,,,"CY",,,,,,,,,,,,,,,,,,[,,"1(?:12|99)",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111))|99)",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],CZ:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5[0568])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"CZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|5[0568])",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5[0568]|99)|1(?:16|4)\\d{3}",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DE:[,[,,"1\\d\\d(?:\\d{2,3})?",
,,,,,,[3,5,6]],,,[,,"11(?:[02]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"DE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|118\\d\\d",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DJ:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"DJ",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DK:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:[24]|6\\d{3})",
,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"DK",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"1(?:1(?:[2-48]|6(?:00[06]|111))|8(?:[08]1|1[0238]|28|30|5[13]))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DM:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],,,,"DM",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DO:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],
,,,"DO",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112"],,[,,"112|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],DZ:[,[,,"[17]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:12|[47]|54\\d)",,,,"14"],[,,,,,,,,,[-1]],,,,"DZ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[47])",,,,"14",,,[2,3]],,[,,"1(?:055|12|[47]|548)|730",,,,"14"],[,,,,,,,,,[-1]],[,,"730",,,,"730",,,[3]],,[,,"730",,,,"730",,,[3]]],EC:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],,,,"EC",,,,,,,,,,,,,,,,,,[,,"1(?:0[12]|12)|911",
,,,"101"],,[,,"1(?:0[12]|12)|911",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],EE:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))",,,,"110"],[,,"1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
,,,"123",,,[3,4,5]],,,,"EE",,,,,,,,,,,,,,,,,,[,,"11[02]",,,,"110",,,[3]],,[,,"1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
,,,"126",,,[3,4,5]]],EG:[,[,,"[13]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],[,,,,,,,,,[-1]],,,,"EG",,,,,,,,,,,,,,,,,,[,,"1(?:2[23]|80)",,,,"122",,,[3]],,[,,"1(?:2[23]|[69]\\d{3}|80)|34400",,,,"122"],[,,,,,,,,,[-1]],[,,"344\\d\\d",,,,"34400",,,[5]],,[,,"344\\d\\d",,,,"34400",,,[5]]],EH:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"EH",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,
,,,,,,,,[-1]]],ER:[,[,,"[12]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11[2-46]|(?:12[47]|20[12])\\d{3}",,,,"112"],[,,,,,,,,,[-1]],,,,"ER",,,,,,,,,,,,,,,,,,[,,"1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],,[,,"1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ES:[,[,,"[0-379]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}",,,,"016",,,[3,4,6]],[,,"[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
,,,"120"],,,,"ES",,,,,,,,,,,,,,,,,,[,,"08[58]|112",,,,"085",,,[3]],,[,,"0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}",,,,"010"],[,,"0(?:[16][0-2]|80|9[12])|21\\d{4}",,,,"010",,,[3,6]],[,,"1(?:3[34]|77)|[12]2\\d{1,4}",,,,"120"],,[,,"(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d",,,,"22000",,,[5,6]]],ET:[,[,,"9\\d\\d?",,,,,
,,[2,3]],,,[,,"9(?:07|11?|2|39?|9[17])",,,,"91"],[,,,,,,,,,[-1]],,,,"ET",,,,,,,,,,,,,,,,,,[,,"9(?:11?|2|39?|9[17])",,,,"91"],,[,,"9(?:07|11?|2|39?|45|9[17])",,,,"91"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FI:[,[,,"[17]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"FI",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|11[17]))|75[12]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FJ:[,[,,"[0-579]\\d(?:\\d(?:\\d{2})?)?",
,,,,,,[2,3,5]],,,[,,"91[17]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"FJ",,,,,,,,,,,,,,,,,,[,,"91[17]",,,,"911",,,[3]],,[,,"0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75",,,,"22"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"404\\d\\d",,,,"40400",,,[5]]],FK:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"FK",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1\\d\\d|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FM:[,[,,"[39]\\d\\d(?:\\d{3})?",,,,,,,[3,6]],
,,[,,"320\\d{3}|911",,,,"911"],[,,,,,,,,,[-1]],,,,"FM",,,,,,,,,,,,,,,,,,[,,"(?:32022|91)1",,,,"911"],,[,,"(?:32022|91)1",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FO:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[24]",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"FO",,,,,,,,,,,,,,,,,,[,,"11[24]",,,,"112",,,[3]],,[,,"11[248]|1(?:4[124]|71|8[7-9])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],FR:[,[,,"[1-8]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:0(?:07|[13]3)|1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d",
,,,"15"],[,,"(?:118|[4-8]\\d)\\d{3}|36665",,,,"36665",,,[5,6]],,,,"FR",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15",,,[2,3]],,[,,"1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)",,,,"15"],[,,"10(?:[134]4|2[23]|5\\d|99)|202\\d|3(?:646|9[07]0)|634|70[06]|(?:106|61)[14]",,,,"611",,,[3,4]],[,,"118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",,,,"224",,,[3,4,5,6]],,[,,"114|[3-8]\\d{4}",,,,"114",,,[3,5]]],GA:[,[,
,"1\\d(?:\\d{2})?",,,,,,,[2,4]],,,[,,"18|1(?:3\\d|73)\\d",,,,"18"],[,,,,,,,,,[-1]],,,,"GA",,,,,,,,,,,,,,,,,,[,,"1(?:3\\d\\d|730|8)",,,,"18"],,[,,"1(?:3\\d\\d|730|8)",,,,"18"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GB:[,[,,"[1-46-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999",,,,"105"],[,,,,,,,,,[-1]],,,,"GB",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901",,,,"202",,,[3,4,5]],,[,,"(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d",,,,"1250",,,[4,5]]],GD:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"GD",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"176|911",,,,"176"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],GE:[,[,,"[014]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],[,,,,,,,,,[-1]],,,,
"GE",,,,,,,,,,,,,,,,,,[,,"0(?:11|33)|11[1-3]|[01]22",,,,"011",,,[3]],,[,,"0(?:11|33)|11[1-3]|40404|[01]22",,,,"011"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GG:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"GG",,,,,,,,,,,,,,,,,,[,,"112|999",
,,,"112",,,[3]],,[,,"1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GH:[,[,,"[14589]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"19[1-3]|999",,,,"191",,,[3]],[,,,,,,,,,[-1]],,,,"GH",,,,,,,,,,,,,,,,,,[,,"19[1-3]|999",,,,"191",,,[3]],,[,,"19[1-3]|40404|(?:54|83)00|999",,,,"191"],[,,,,,,,,,[-1]],[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]],,[,,"404\\d\\d|(?:54|83)0\\d",,,,"5400",,,[4,5]]],GI:[,[,,"[158]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,
"1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d",,,,"100",,,[3,4,6]],[,,"8[1-69]\\d\\d",,,,"8100",,,[4]],,,,"GI",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[09])",,,,"112",,,[3]],,[,,"1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])",,,,"100"],[,,"150|87\\d\\d",,,,"150",,,[3,4]],[,,"1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])",,,,"100",,,[3,5]],,[,,,,,,,,,[-1]]],GL:[,[,,"1\\d\\d",,,,,,,[3]],,,
[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"GL",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GM:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],,,,"GM",,,,,,,,,,,,,,,,,,[,,"1(?:1[6-8]|[6-8])",,,,"16"],,[,,"1(?:1[6-8]|[6-8])",,,,"16"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,,,"GN",,,,,,,,,,,,,,,,,,[,,,,,,,,,[-1]],,[,,"12\\d|40404",
,,,"120"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GP:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"GP",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GR:[,[,,"1\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"1(?:0[089]|1(?:2|6\\d{3})|66|99)",,,,"100",,,[3,6]],[,,,,,,,,,[-1]],,,,"GR",,,,,,,,,,,,,,,,,,[,,"1(?:00|12|66|99)",,,,"100",,,[3]],,[,,"1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
,,,"100"],[,,"113\\d\\d",,,,"11300",,,[5]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GT:[,[,,"[14]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:10|2[03])",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"GT",,,,,,,,,,,,,,,,,,[,,"1(?:10|2[03])",,,,"110",,,[3]],,[,,"110|40404|1(?:2|[57]\\d)\\d",,,,"110"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],GU:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"GU",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GW:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],,,,"GW",,,,,,,,,,,,,,,,,,[,,"11[378]",,,,"113"],,[,,"11[378]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],GY:[,[,,"[019]\\d{2,3}",,,,,,,[3,4]],,,[,,"91[1-3]",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"GY",,,,,,,,,,,,,,,,,,[,,"91[1-3]",,,,"911",,,[3]],,[,,"0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]",,,,"002"],[,,,,,,,,,[-1]],[,,"144\\d",,,,"1440",,,[4]],
,[,,"144\\d",,,,"1440",,,[4]]],HK:[,[,,"[19]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"112|99[29]",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"HK",,,,,,,,,,,,,,,,,,[,,"112|99[29]",,,,"112",,,[3]],,[,,"1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]",,,,"100"],[,,,,,,,,,
[-1]],[,,"109|1(?:08|85\\d)\\d",,,,"109",,,[3,4,5]],,[,,"992",,,,"992",,,[3]]],HN:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"HN",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40404",,,,"199"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HR:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d",,,,"93",,,[2,3,5,6]],[,,"118\\d\\d",,,,"11800",,,[5]],,,,"HR",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])|9[34]",
,,,"93",,,[2,3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]",,,,"93"],[,,,,,,,,,[-1]],[,,"139\\d\\d",,,,"13900",,,[5]],,[,,"139\\d\\d",,,,"13900",,,[5]]],HT:[,[,,"[14]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[48]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"HT",,,,,,,,,,,,,,,,,,[,,"11[48]",,,,"114",,,[3]],,[,,"11[48]|40404",,,,"114"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],HU:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:0[457]|1(?:2|6\\d{3}))",
,,,"104",,,[3,6]],[,,,,,,,,,[-1]],,,,"HU",,,,,,,,,,,,,,,,,,[,,"1(?:0[457]|12)",,,,"104",,,[3]],,[,,"1(?:0[457]|1(?:2|6(?:000|1(?:11|23)))|2(?:20|7[02])|37(?:00|37|7[07])|414|777|8(?:1[27-9]|2[04]|40|[589]))",,,,"104"],[,,,,,,,,,[-1]],[,,"1(?:2[27]|41|77)\\d",,,,"1220",,,[4]],,[,,"184\\d",,,,"1840",,,[4]]],ID:[,[,,"[178]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11[02389]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"ID",,,,,,,,,,,,,,,,,,[,,"11[02389]",,,,"110",,,[3]],,[,,"1(?:1[02389]|40\\d\\d|50264)|71400|89887",
,,,"110"],[,,,,,,,,,[-1]],[,,"(?:714|898)\\d\\d",,,,"71400",,,[5]],,[,,"714\\d\\d",,,,"71400",,,[5]]],IE:[,[,,"[159]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})|999",,,,"112",,,[3,6]],[,,"5[37]\\d{3}",,,,"53000",,,[5]],,,,"IE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d",,,,"112"],[,,"51\\d{3}",,,,"51000",,,[5]],[,,"51210",,,,"51210",,,[5]],,[,,"51210|(?:118|5[037]\\d)\\d\\d",,,,"11800",,,[5]]],IL:[,[,,"[12]\\d{2,4}",
,,,,,,[3,4,5]],,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IL",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-2]|12)",,,,"100",,,[3]],,[,,"1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00",,,,"100"],[,,,,,,,,,[-1]],[,,"104\\d\\d",,,,"10400",,,[5]],,[,,"104\\d\\d",,,,"10400",,,[5]]],IM:[,[,,"[189]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"IM",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999",,,,"100"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,"8(?:64|98)\\d\\d",,,,"86400",,,[5]]],IN:[,[,,"[12578]\\d{2,8}",,,,,,,[3,4,5,6,7,8,9]],,,[,,"1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",,,,"100",,,[3,4,5,6]],[,,"11[67]\\d{4}|56161561",,,,"1160000",,,[7,8]],,,,"IN",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-28]|12|298)|2611",,,,"100",,,[3,4]],,[,,"1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
,,,"100"],[,,"5(?:14(?:2[5-9]|[34]\\d)|757555)",,,,"51425",,,[5,7]],[,,"1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])",,,,"118",,,[3,4,5,6,7,8]],,[,,"1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)",,,,"139",,,[3,4,5,7,8]]],IQ:[,[,,"[1479]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"IQ",,,,,,,,,,,,,,,,,,[,,"1(?:0[04]|15|22)",,,,"100",,,[3]],,[,,"1(?:0[04]|15|22)|4432|71117|9988",,,,"100"],[,
,,,,,,,,[-1]],[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]],,[,,"(?:443|711\\d|998)\\d",,,,"4430",,,[4,5]]],IR:[,[,,"[129]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1[0-68]|2[0-59]|9[0-579])|911",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"IR",,,,,,,,,,,,,,,,,,[,,"1(?:1[025]|25)|911",,,,"110",,,[3]],,[,,"1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
,,,"110"],[,,"1(?:5[0-469]|8[0-489])\\d",,,,"1500",,,[4]],[,,"(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d",,,,"1500",,,[4,6]],,[,,"990\\d{3}",,,,"990000",,,[6]]],IS:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:12|71\\d)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"IS",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)",,,,"112"],[,,,,,,,,,[-1]],[,,"14(?:0\\d|41)",,,,"1400",,,[4]],,[,,"1(?:415|90\\d)",
,,,"1415",,,[4]]],IT:[,[,,"[14]\\d{2,6}",,,,,,,[3,4,5,6,7]],,,[,,"1(?:1(?:[2358]|6\\d{3})|87)",,,,"112",,,[3,6]],[,,"(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"1200",,,[4,5,7]],,,,"IT",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112",,,[3]],,[,,"1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,"4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d",,,,"43000",,,[5,7]]],JE:[,[,,"[129]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"JE",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],JM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[029]|911",,,,"110"],[,,,,,,,,,[-1]],
,,,"JM",,,,,,,,,,,,,,,,,,[,,"11[029]|911",,,,"110"],,[,,"1(?:1[029]|76)|911",,,,"110"],[,,,,,,,,,[-1]],[,,"176",,,,"176"],,[,,"176",,,,"176"]],JO:[,[,,"[19]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"1(?:1[24]|9[127])|911",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"JO",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[127])|911",,,,"112",,,[3]],,[,,"1(?:09|1[0-248]|9[0-24-79])|9(?:0903|11|8788)",,,,"109"],[,,,,,,,,,[-1]],[,,"9(?:09|87)\\d\\d",,,,"90900",,,[5]],,[,,"9(?:09|87)\\d\\d",,,,"90900",,,[5]]],JP:[,[,,"1\\d\\d",,,,,,,[3]],
,,[,,"11[089]",,,,"110"],[,,,,,,,,,[-1]],,,,"JP",,,,,,,,,,,,,,,,,,[,,"11[09]",,,,"110"],,[,,"1(?:0[24]|1[089]|44|89)",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KE:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999",,,,"112"],[,,"909\\d\\d",,,,"90900",,,[5]],,,,"KE",,,,,,,,,,,,,,,,,,[,,"11[24]|999",,,,"112",,,[3]],,[,,"1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988",
,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d",,,,"130"],,[,,"1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",,,,"141"]],KG:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"10[1-3]",,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"KG",,,,,,,,,,,,,,,,,,[,,"10[1-3]",,,,"101",,,[3]],,[,,"10[1-3]|4040",,,,"101"],[,,,,,,,,,[-1]],[,,"404\\d",,,,"4040",,,[4]],,[,,"404\\d",,,,"4040",,
,[4]]],KH:[,[,,"[146]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[7-9]|666",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"KH",,,,,,,,,,,,,,,,,,[,,"11[7-9]|666",,,,"117",,,[3]],,[,,"11[7-9]|40404|666",,,,"117"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],KI:[,[,,"[179]\\d{2,3}",,,,,,,[3,4]],,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],[,,,,,,,,,[-1]],,,,"KI",,,,,,,,,,,,,,,,,,[,,"19[2-5]|99[2-4]",,,,"192",,,[3]],,[,,"1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]",,,,"100"],[,,"103",
,,,"103",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KM:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"KM",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KN:[,[,,"[39]\\d\\d",,,,,,,[3]],,,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],,,,"KN",,,,,,,,,,,,,,,,,,[,,"333|9(?:11|99)",,,,"333"],,[,,"333|9(?:11|99)",,,,"333"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KP:[,[,,"[18]\\d\\d",,,,,,,[3]],,,[,,"11[29]|819",,,,"112"],
[,,,,,,,,,[-1]],,,,"KP",,,,,,,,,,,,,,,,,,[,,"11[29]|819",,,,"112"],,[,,"11[29]|819",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KR:[,[,,"1\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[27-9]|28|330|82)",,,,"112",,,[3,4]],[,,,,,,,,,[-1]],,,,"KR",,,,,,,,,,,,,,,,,,[,,"11[29]",,,,"112",,,[3]],,[,,"1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])",,,,"100"],[,,,,,,,,,[-1]],[,,"1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d",,,,"100",
,,[3,5]],,[,,,,,,,,,[-1]]],KW:[,[,,"[18]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"KW",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"1[0-7]\\d|89887",,,,"100"],[,,,,,,,,,[-1]],[,,"898\\d\\d",,,,"89800",,,[5]],,[,,,,,,,,,[-1]]],KY:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"KY",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],KZ:[,[,,"[134]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:0[1-3]|12)",
,,,"101",,,[3]],[,,,,,,,,,[-1]],,,,"KZ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101",,,[3]],,[,,"1(?:0[1-4]|12)|(?:3040|404)0",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]],,[,,"(?:304\\d|404)\\d",,,,"4040",,,[4,5]]],LA:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],,,,"LA",,,,,,,,,,,,,,,,,,[,,"19[015]",,,,"190"],,[,,"19[015]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LB:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:12|40|75)|999",,,,"112"],[,
,,,,,,,,[-1]],,,,"LB",,,,,,,,,,,,,,,,,,[,,"1(?:12|40|75)|999",,,,"112"],,[,,"1(?:12|40|75)|999",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"LC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LI:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"LI",,,,,,,,,,,,,,,,,,[,,"1(?:1[278]|44)",,,,"112",,,[3]],
,[,,"1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LK:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[02689]",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"LK",,,,,,,,,,,,,,,,,,[,,"11[02689]",,,,"110",,,[3]],,[,,"1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LR:[,[,,"[3489]\\d{2,3}",
,,,,,,[3,4]],,,[,,"355|911",,,,"355",,,[3]],[,,,,,,,,,[-1]],,,,"LR",,,,,,,,,,,,,,,,,,[,,"355|911",,,,"355",,,[3]],,[,,"355|4040|8(?:400|933)|911",,,,"355"],[,,,,,,,,,[-1]],[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]],,[,,"(?:404|8(?:40|93))\\d",,,,"4040",,,[4]]],LS:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],,,,"LS",,,,,,,,,,,,,,,,,,[,,"11[257]",,,,"112"],,[,,"11[257]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LT:[,[,,"[01]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,
6]],,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d",,,,"01"],[,,,,,,,,,[-1]],,,,"LT",,,,,,,,,,,,,,,,,,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|12)",,,,"01",,,[2,3]],,[,,"0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LU:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:[23]|6\\d{3})",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"LU",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],,[,,"11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d",
,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],LV:[,[,,"[018]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"0[1-3]|11(?:[023]|6\\d{3})",,,,"01",,,[2,3,6]],[,,"1180|821\\d\\d",,,,"1180",,,[4,5]],,,,"LV",,,,,,,,,,,,,,,,,,[,,"0[1-3]|11[023]",,,,"01",,,[2,3]],,[,,"0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4",,,,"01"],[,,"1181",,,,"1181",,,[4]],[,,"165\\d",,,,"1650",,,[4]],,[,,,,,,,,,[-1]]],LY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[013]",,,,"190"],[,,,,,,,,,[-1]],,,,"LY",,,,,,,,,,,
,,,,,,,[,,"19[013]",,,,"190"],,[,,"19[013]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MA:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],,,,"MA",,,,,,,,,,,,,,,,,,[,,"1(?:[59]|77)",,,,"15"],,[,,"1(?:[59]|77)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MC:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"MC",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|41|[578])",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],MD:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MD",,,,,,,,,,,,,,,,,,[,,"112|90[1-3]",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ME:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:12|2[2-4])",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"ME",,,,,,,,,,,,,,,,,,[,,"1(?:12|2[2-4])",,,,"112",
,,[3]],,[,,"1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"MF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MG:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],,,,"MG",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|[78])",,,,"17"],
,[,,"1(?:1[78]|[78])",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MH:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"MH",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MK:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"1(?:1(?:2|6\\d{3})|9[2-4])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"MK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112",,,[3]],,[,,"1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}",,,,"112"],
[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ML:[,[,,"[136-8]\\d{1,4}",,,,,,,[2,3,4,5]],,,[,,"1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d",,,,"15",,,[2,4,5]],[,,"(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)",,,,"1220",,,[4,5]],,,,"ML",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",,,,"15"],[,,"37(?:433|575)|7400|8001\\d",,,,"7400",,,[4,5]],[,
,"3503\\d|(?:3[67]\\d|800)\\d\\d",,,,"35030",,,[5]],,[,,"374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d",,,,"7400",,,[4,5]]],MM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"199",,,,"199"],[,,,,,,,,,[-1]],,,,"MM",,,,,,,,,,,,,,,,,,[,,"199",,,,"199"],,[,,"199",,,,"199"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],,,,"MN",,,,,,,,,,,,,,,,,,[,,"10[0-35]",,,,"100"],,[,,"10[0-35]",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],
MO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"MO",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MP:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"MP",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MQ:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"MQ",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|[578])",
,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MR:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"MR",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"MS",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MT:[,[,,"1\\d\\d(?:\\d{3})?",,,,,,,[3,6]],,,[,,"11(?:2|6\\d{3})",
,,,"112"],[,,,,,,,,,[-1]],,,,"MT",,,,,,,,,,,,,,,,,,[,,"112",,,,"112",,,[3]],,[,,"11(?:2|6(?:000|1(?:11|23)))",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MU:[,[,,"[189]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"11[45]|99[59]",,,,"114",,,[3]],[,,,,,,,,,[-1]],,,,"MU",,,,,,,,,,,,,,,,,,[,,"11[45]|99[59]",,,,"114",,,[3]],,[,,"1\\d{2,4}|(?:8\\d\\d|99)\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],MV:[,[,,"[14]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:02|1[89])",,,,"102",,,[3]],[,,,,,,,,,[-1]],
,,,"MV",,,,,,,,,,,,,,,,,,[,,"1(?:02|1[89])",,,,"102",,,[3]],,[,,"1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1",,,,"100"],[,,,,,,,,,[-1]],[,,"1[45]1",,,,"141",,,[3]],,[,,,,,,,,,[-1]]],MW:[,[,,"[189]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"199|99[7-9]",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"MW",,,,,,,,,,,,,,,,,,[,,"199|99[7-9]",,,,"199",,,[3]],,[,,"199|80400|99[7-9]",,,,"199"],[,,,,,,,,,[-1]],[,,"804\\d\\d",,,,"80400",,,[5]],,[,,"804\\d\\d",,,,"80400",,,[5]]],MX:[,[,,"[0579]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"0(?:6[0568]|80)|911",
,,,"060",,,[3]],[,,"(?:530\\d|776)\\d",,,,"7760",,,[4,5]],,,,"MX",,,,,,,,,,,,,,,,,,[,,"0(?:6[0568]|80)|911",,,,"060",,,[3]],,[,,"0[1-9]\\d|53053|7766|911",,,,"010"],[,,,,,,,,,[-1]],[,,"0(?:[249]0|[35][01])",,,,"020",,,[3]],,[,,,,,,,,,[-1]]],MY:[,[,,"[1369]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"112|999",,,,"112",,,[3]],[,,,,,,,,,[-1]],,,,"MY",,,,,,,,,,,,,,,,,,[,,"112|999",,,,"112",,,[3]],,[,,"1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
,,,"100"],[,,"666\\d\\d",,,,"66600",,,[5]],[,,,,,,,,,[-1]],,[,,"(?:3[23679]\\d|666)\\d\\d",,,,"32000",,,[5]]],MZ:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[79]|9[78])",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"MZ",,,,,,,,,,,,,,,,,,[,,"1(?:1[79]|9[78])",,,,"117",,,[3]],,[,,"1(?:[02-5]\\d\\d|1[79]|9[78])",,,,"117"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NA:[,[,,"[19]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"10111",,,,"10111",,,[5]],[,,,,,,,,,[-1]],,,,"NA",,,,,,,,,,,,,,,,,,[,,"10111",,,,"10111",,,[5]],,[,,
"(?:10|93)111|(?:1\\d|9)\\d\\d",,,,"900"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NC:[,[,,"[135]\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577",,,,"15"],[,,,,,,,,,[-1]],,,,"NC",,,,,,,,,,,,,,,,,,[,,"1[5-8]",,,,"15",,,[2]],,[,,"1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d",,,,"15"],[,,"5(?:67|88)",,,,"567",,,[3]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NE:[,[,,"[1-3578]\\d(?:\\d(?:\\d{3})?)?",,,,,,,[2,3,6]],,,[,,"1(?:18|[578])|723\\d{3}",
,,,"15"],[,,,,,,,,,[-1]],,,,"NE",,,,,,,,,,,,,,,,,,[,,"1(?:18|[578])|723141",,,,"15"],,[,,"1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888",,,,"15"],[,,,,,,,,,[-1]],[,,"1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888",,,,"100",,,[3]],,[,,,,,,,,,[-1]]],NF:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],,,,"NF",,,,,,,,,,,,,,,,,,[,,"9(?:11|55|77)",,,,"911"],,[,,"9(?:11|55|77)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NG:[,[,,"[14]\\d\\d(?:\\d{2})?",
,,,,,,[3,5]],,,[,,"199",,,,"199",,,[3]],[,,,,,,,,,[-1]],,,,"NG",,,,,,,,,,,,,,,,,,[,,"199",,,,"199",,,[3]],,[,,"199|40700",,,,"199"],[,,,,,,,,,[-1]],[,,"407\\d\\d",,,,"40700",,,[5]],,[,,"407\\d\\d",,,,"40700",,,[5]]],NI:[,[,,"[12467]\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[58]|2[08])|737\\d",,,,"115"],[,,,,,,,,,[-1]],,,,"NI",,,,,,,,,,,,,,,,,,[,,"1(?:1[58]|2[08])",,,,"115",,,[3]],,[,,"1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00",,,,"115"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NL:[,
[,,"[1349]\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:2|6\\d{3})|911",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"NL",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911",,,,"112"],[,,,,,,,,,[-1]],[,,"120\\d",,,,"1200",,,[4]],,[,,"[34]00\\d",,,,"3000",,,[4]]],NO:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11(?:[023]|6\\d{3})",,,,"110",,,[3,6]],[,,,,,,,,,[-1]],,,,"NO",,,,,,,,,,,,,
,,,,,[,,"11[023]",,,,"110",,,[3]],,[,,"1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8[5-9]\\d|90)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NP:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-36]|12)|1(?:09|11)\\d",,,,"100"],[,,,,,,,,,[-1]],,,,"NP",,,,,,,,,,,,,,,,,,[,,"1(?:0[0-3]|12)",,,,"100",,,[3]],,[,,"1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NR:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[0-2]",,,,"110"],[,,,,,,,,,[-1]],,,,
"NR",,,,,,,,,,,,,,,,,,[,,"11[0-2]",,,,"110"],,[,,"1(?:1[0-2]|23|92)",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],NU:[,[,,"[019]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"NU",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"01[05]|101|999",,,,"010"],[,,,,,,,,,[-1]],[,,"010",,,,"010"],,[,,,,,,,,,[-1]]],NZ:[,[,,"\\d{3,4}",,,,,,,[3,4]],,,[,,"111",,,,"111",,,[3]],[,,"018",,,,"018",,,[3]],,,,"NZ",,,,,,,,,,,,,,,,,,[,,"111",,,,"111",,,[3]],,[,,"018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
,,,"018"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}",,,,"018"]],OM:[,[,,"[19]\\d{3}",,,,,,,[4]],,,[,,"1444|999\\d",,,,"1444"],[,,,,,,,,,[-1]],,,,"OM",,,,,,,,,,,,,,,,,,[,,"1444|9999",,,,"1444"],,[,,"1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d",,,,"1111"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PA:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PA",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],
,[,,"10[2-4]|911",,,,"102"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PE:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],,,,"PE",,,,,,,,,,,,,,,,,,[,,"1(?:05|1[67])",,,,"105"],,[,,"1(?:05|1[67])",,,,"105"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"PF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PG:[,[,,"[01]\\d{2,6}",,,,,,,[3,
4,5,6,7]],,,[,,"000|11[01]",,,,"000",,,[3]],[,,,,,,,,,[-1]],,,,"PG",,,,,,,,,,,,,,,,,,[,,"000|11[01]",,,,"000",,,[3]],,[,,"000|1(?:1[01]|5\\d\\d|6\\d{2,5})",,,,"000"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"16\\d{2,5}",,,,"1600",,,[4,5,6,7]]],PH:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],,,,"PH",,,,,,,,,,,,,,,,,,[,,"11[27]|911",,,,"112"],,[,,"11[27]|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PK:[,[,,"1\\d{1,3}",,,,,,,[2,3,4]],,,[,,"1(?:1(?:2\\d?|5)|[56])",
,,,"15"],[,,,,,,,,,[-1]],,,,"PK",,,,,,,,,,,,,,,,,,[,,"1(?:1(?:22?|5)|[56])",,,,"15"],,[,,"1(?:122|3[014]|[56])|11[2457-9]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PL:[,[,,"[19]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"11(?:2|6\\d{3})|99[7-9]",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"PL",,,,,,,,,,,,,,,,,,[,,"112|99[7-9]",,,,"112",,,[3]],,[,,"1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PM:[,[,,"[13]\\d(?:\\d{2})?",
,,,,,,[2,4]],,,[,,"1[578]",,,,"15",,,[2]],[,,,,,,,,,[-1]],,,,"PM",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15",,,[2]],,[,,"1[578]|3103",,,,"15"],[,,,,,,,,,[-1]],[,,"310\\d",,,,"3100",,,[4]],,[,,,,,,,,,[-1]]],PR:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PR",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PS:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:0[0-2]|66)",,,,"100",,,[3]],[,,,,,,,,,[-1]],,,,"PS",,,,,,,,,,,,,,,,,,[,,"10[0-2]",
,,,"100",,,[3]],,[,,"1(?:0[0-2]|122|44|66|99)",,,,"100"],[,,,,,,,,,[-1]],[,,"112\\d",,,,"1120",,,[4]],,[,,,,,,,,,[-1]]],PT:[,[,,"1\\d\\d(?:\\d(?:\\d{2})?)?",,,,,,,[3,4,6]],,,[,,"11[25]|1(?:16\\d\\d|5[1589]|8[279])\\d",,,,"112"],[,,,,,,,,,[-1]],,,,"PT",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112",,,[3]],,[,,"1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,
,,,,[-1]]],PW:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"PW",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],PY:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"128|911",,,,"128"],[,,,,,,,,,[-1]],,,,"PY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128"],,[,,"1[1-4]\\d|911",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],QA:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"QA",,,,,,,,,,,,,,,,,,[,
,"999",,,,"999",,,[3]],,[,,"999|(?:1|20|9[27]\\d)\\d\\d",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RE:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],,,,"RE",,,,,,,,,,,,,,,,,,[,,"1(?:12|[578])",,,,"15"],,[,,"1(?:12|[578])",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RO:[,[,,"[18]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})",,,,"112",,,[3,6]],[,,"(?:1(?:18[39]|[24])|8[48])\\d\\d",,,,"1200",,,[4,6]],,,,"RO",,,,,,,,,,,,,,,,,,[,,"112",,,
,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"(?:1[24]|8[48])\\d\\d",,,,"1200",,,[4]]],RS:[,[,,"[19]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"112|9[2-4]",,,,"92",,,[2,3]],[,,,,,,,,,[-1]],,,,"RS",,,,,,,,,,,,,,,,,,[,,"112|9[2-4]",,,,"92",,,[2,3]],,[,,"1[189]\\d{1,4}|9[2-4]",,,,"92"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RU:[,[,,"[01]\\d\\d?",,,,,,,
[2,3]],,,[,,"112|(?:0|10)[1-3]",,,,"01"],[,,,,,,,,,[-1]],,,,"RU",,,,,,,,,,,,,,,,,,[,,"112|(?:0|10)[1-3]",,,,"01"],,[,,"112|(?:0|10)[1-4]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],RW:[,[,,"[14]\\d\\d",,,,,,,[3]],,,[,,"11[1245]",,,,"111"],[,,,,,,,,,[-1]],,,,"RW",,,,,,,,,,,,,,,,,,[,,"11[12]",,,,"111"],,[,,"1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SA:[,[,,"[19]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:2|6\\d{3})|9(?:11|37|9[7-9])",
,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SA",,,,,,,,,,,,,,,,,,[,,"112|9(?:11|9[79])",,,,"112",,,[3]],,[,,"1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])",,,,"112"],[,,"141\\d",,,,"1410",,,[4]],[,,"1(?:10|41)\\d|90[24679]",,,,"902",,,[3,4]],,[,,,,,,,,,[-1]]],SB:[,[,,"[127-9]\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SB",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SC:[,[,,"[19]\\d{2,3}",,,,,,,[3,4]],,,[,,"999",,,,"999",,,[3]],[,,,,,,,,,[-1]],,,,"SC",,,,,,,,,,,,,,,,,,[,,"999",,,,"999",,,[3]],,[,,"1(?:0\\d|1[027]|2[0-8]|3[13]|4[0-2]|[59][15]|6[1-9]|7[124-6]|8[158])|9(?:6\\d\\d|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SD:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SD",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],SE:[,[,,"[1-37-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|(?:116\\d|900)\\d\\d",,,,"112",,,[3,5,6]],[,,"11811[89]|72\\d{3}",,,,"72000",,,[5,6]],,,,"SE",,,,,,,,,,,,,,,,,,[,,"112|90000",,,,"112",,,[3,5]],,[,,"11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])",,,,"112"],[,,,,,,,,,[-1]],[,,"2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
,,,"220",,,[3]],,[,,"7\\d{4}",,,,"70000",,,[5]]],SG:[,[,,"[179]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"99[359]",,,,"993",,,[3]],[,,,,,,,,,[-1]],,,,"SG",,,,,,,,,,,,,,,,,,[,,"99[359]",,,,"993",,,[3]],,[,,"1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,"772\\d\\d",,,,"77200",,,[5]]],SH:[,[,,"[129]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"9(?:11|99)",,,,"911",,,[3]],[,,,,,,,,,[-1]],,,,"SH",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911",,,[3]],,[,,
"1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SI:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)",,,,"112"],[,,,,,,,,,[-1]],,,,"SI",,,,,,,,,,,,,,,,,,[,,"11[23]",,,,"112",,,[3]],,[,,"1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SJ:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[023]",,,,"110"],[,,,,,,,
,,[-1]],,,,"SJ",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110"],,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SK:[,[,,"1\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:1(?:2|6\\d{3})|5[058])",,,,"112",,,[3,6]],[,,,,,,,,,[-1]],,,,"SK",,,,,,,,,,,,,,,,,,[,,"1(?:12|5[058])",,,,"112",,,[3]],,[,,"1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SL:[,[,,"[069]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"(?:01|99)9",,,,"019",,,[3]],[,,,,,,
,,,[-1]],,,,"SL",,,,,,,,,,,,,,,,,,[,,"(?:01|99)9",,,,"019",,,[3]],,[,,"(?:01|99)9|60400",,,,"019"],[,,,,,,,,,[-1]],[,,"604\\d\\d",,,,"60400",,,[5]],,[,,"604\\d\\d",,,,"60400",,,[5]]],SM:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],,,,"SM",,,,,,,,,,,,,,,,,,[,,"11[358]",,,,"113"],,[,,"11[358]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SN:[,[,,"[12]\\d{1,5}",,,,,,,[2,3,4,5,6]],,,[,,"1(?:515|[78])|2(?:00|1)\\d{3}",,,,"17",,,[2,4,5,6]],[,,"2(?:0[246]|[468])\\d{3}",
,,,"24000",,,[5,6]],,,,"SN",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17",,,[2]],,[,,"1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]",,,,"12"],[,,"2(?:01|2)\\d{3}",,,,"22000",,,[5,6]],[,,"1[46]\\d\\d",,,,"1400",,,[4]],,[,,"2[468]\\d{3}",,,,"24000",,,[5]]],SO:[,[,,"[57-9]\\d\\d",,,,,,,[3]],,,[,,"555|888|999",,,,"555"],[,,,,,,,,,[-1]],,,,"SO",,,,,,,,,,,,,,,,,,[,,"555|888|999",,,,"555"],,[,,"555|777|888|999",,,,"555"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SR:[,[,,"1\\d{2,3}",,,,,
,,[3,4]],,,[,,"115",,,,"115",,,[3]],[,,,,,,,,,[-1]],,,,"SR",,,,,,,,,,,,,,,,,,[,,"115",,,,"115",,,[3]],,[,,"1\\d{2,3}",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SS:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SS",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ST:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"ST",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],
[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SV:[,[,,"[149]\\d\\d(?:\\d{2,3})?",,,,,,,[3,5,6]],,,[,,"116\\d{3}|911",,,,"911",,,[3,6]],[,,,,,,,,,[-1]],,,,"SV",,,,,,,,,,,,,,,,,,[,,"91[13]",,,,"911",,,[3]],,[,,"1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)",,,,"112"],[,,,,,,,,,[-1]],[,,"404\\d\\d",,,,"40400",,,[5]],,[,,"404\\d\\d",,,,"40400",,,[5]]],SX:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"919",,,,"919"],[,,,,,,,,,[-1]],,,,"SX",,,,,,,,,,,,,,,,,,[,,"919",,,,"919"],,[,,"919",,,,"919"],[,,,,,,,,,[-1]],[,,,,
,,,,,[-1]],,[,,,,,,,,,[-1]]],SY:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],,,,"SY",,,,,,,,,,,,,,,,,,[,,"11[023]",,,,"110"],,[,,"11[023]",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],SZ:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"SZ",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TC",,,,,,,,,,,,,,,,,,[,
,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TD:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],,,,"TD",,,,,,,,,,,,,,,,,,[,,"1[78]",,,,"17"],,[,,"1[78]",,,,"17"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TG:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1[78]|7[127])",,,,"117",,,[3]],[,,,,,,,,,[-1]],,,,"TG",,,,,,,,,,,,,,,,,,[,,"1(?:1[78]|7[127])",,,,"117",,,[3]],,[,,"1(?:011|1[078]|7[127])",,,,"110"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],
,[,,,,,,,,,[-1]]],TH:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55",,,,"191"],[,,"1(?:113|2[23]\\d|5(?:09|56))",,,,"1113",,,[4]],,,,"TH",,,,,,,,,,,,,,,,,,[,,"1(?:669|9[19])",,,,"191"],,[,,"1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
,,,"100"],[,,"1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d",,,,"1103",,,[4]],[,,"114[89]",,,,"1148",,,[4]],,[,,,,,,,,,[-1]]],TJ:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],,,,"TJ",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,,"101"],,[,,"1(?:0[1-3]|12)",,,,"101"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TL:[,[,,"1\\d\\d",
,,,,,,[3]],,,[,,"11[25]",,,,"112"],[,,,,,,,,,[-1]],,,,"TL",,,,,,,,,,,,,,,,,,[,,"11[25]",,,,"112"],,[,,"1(?:0[02]|1[25]|2[0138]|72|9[07])",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TM:[,[,,"0\\d",,,,,,,[2]],,,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],,,,"TM",,,,,,,,,,,,,,,,,,[,,"0[1-3]",,,,"01"],,[,,"0[1-49]",,,,"01"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],,,,"TN",,,,,,,,,,,,,,,,,,[,,"19[078]",,,,"190"],
,[,,"19[078]",,,,"190"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TO:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"TO",,,,,,,,,,,,,,,,,,[,,"9(?:11|22|33|99)",,,,"911"],,[,,"9(?:11|22|33|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TR:[,[,,"[1-9]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)",,,,"110",,,[3]],[,,,,,,,,,[-1]],,,,"TR",,,,,,,,,,,,,,,,,,[,,"1(?:1[02]|55)",,,,"110",,,[3]],,[,,"1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
,,,"110"],[,,"(?:285|542)0",,,,"2850",,,[4]],[,,,,,,,,,[-1]],,[,,"1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d",,,,"144",,,[3,4]]],TT:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"99[09]",,,,"990"],[,,,,,,,,,[-1]],,,,"TT",,,,,,,,,,,,,,,,,,[,,"99[09]",,,,"990"],,[,,"99[09]",,,,"990"],[,
,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TV:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"TV",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"1\\d\\d|911",,,,"100"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TW:[,[,,"1\\d{2,3}",,,,,,,[3,4]],,,[,,"11[0289]|1(?:81|92)\\d",,,,"110"],[,,"10[56]",,,,"105",,,[3]],,,,"TW",,,,,,,,,,,,,,,,,,[,,"11[029]",,,,"110",,,[3]],,[,,"1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",,,,"100"],[,
,"1(?:65|9(?:1\\d|50|85|98))",,,,"165"],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],TZ:[,[,,"[149]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"11[12]|999",,,,"111",,,[3]],[,,,,,,,,,[-1]],,,,"TZ",,,,,,,,,,,,,,,,,,[,,"11[12]|999",,,,"111",,,[3]],,[,,"11[128]|46400|999",,,,"111"],[,,,,,,,,,[-1]],[,,"464\\d\\d",,,,"46400",,,[5]],,[,,"464\\d\\d",,,,"46400",,,[5]]],UA:[,[,,"[189]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"1(?:0[1-3]|1(?:2|6\\d{3}))",,,,"101",,,[3,6]],[,,,,,,,,,[-1]],,,,"UA",,,,,,,,,,,,,,,,,,[,,"1(?:0[1-3]|12)",,,
,"101",,,[3]],,[,,"1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d",,,,"101"],[,,,,,,,,,[-1]],[,,"(?:118|[89]00)\\d\\d?",,,,"1180",,,[4,5]],,[,,,,,,,,,[-1]]],UG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"999",,,,"999"],[,,,,,,,,,[-1]],,,,"UG",,,,,,,,,,,,,,,,,,[,,"999",,,,"999"],,[,,"999",,,,"999"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],US:[,[,,"[1-9]\\d{2,5}",,,,,,,[3,4,5,6]],,,[,,"112|[69]11",,,,"112",,,[3]],[,,"24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7",
,,,"24280",,,[5]],,,,"US",,,,,,,,,,,,,,,,,,[,,"112|911",,,,"112",,,[3]],,[,,"11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-9]11",,,,"112"],[,,"2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",,,,"23333",,,[5,6]],[,,"336\\d\\d|[2-9]\\d{3}|[2356]11",,,,"211",,,[3,4,5]],,[,,"[2-9]\\d{4,5}",,,,"20000",,,[5,6]]],UY:[,[,,"[19]\\d{2,3}",,,,,,,[3,4]],,,[,,"128|911",,,,"128",,,[3]],[,,,,,,,,,[-1]],,
,,"UY",,,,,,,,,,,,,,,,,,[,,"128|911",,,,"128",,,[3]],,[,,"1(?:0[4-9]|1[2368]|2[0-3568]|787)|911",,,,"104"],[,,"178\\d",,,,"1780",,,[4]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],UZ:[,[,,"[04]\\d(?:\\d(?:\\d{2})?)?",,,,,,,[2,3,5]],,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],[,,,,,,,,,[-1]],,,,"UZ",,,,,,,,,,,,,,,,,,[,,"0(?:0[1-3]|[1-3]|50)",,,,"01",,,[2,3]],,[,,"0(?:0[1-3]|[1-3]|50)|45400",,,,"01"],[,,,,,,,,,[-1]],[,,"454\\d\\d",,,,"45400",,,[5]],,[,,"454\\d\\d",,,,"45400",,,[5]]],VA:[,[,,"1\\d\\d",,,,,,,
[3]],,,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],,,,"VA",,,,,,,,,,,,,,,,,,[,,"11[2358]",,,,"112"],,[,,"11[2358]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VC:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VC",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VE:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],,,,"VE",,,,,,,,,,,,,,,,,,[,,"1(?:12|71)|911",,,,"112"],
,[,,"1(?:12|71)|911",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VG:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],,,,"VG",,,,,,,,,,,,,,,,,,[,,"9(?:11|99)",,,,"911"],,[,,"9(?:11|99)",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VI:[,[,,"9\\d\\d",,,,,,,[3]],,,[,,"911",,,,"911"],[,,,,,,,,,[-1]],,,,"VI",,,,,,,,,,,,,,,,,,[,,"911",,,,"911"],,[,,"911",,,,"911"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VN:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"11[3-5]",
,,,"113"],[,,,,,,,,,[-1]],,,,"VN",,,,,,,,,,,,,,,,,,[,,"11[3-5]",,,,"113"],,[,,"11[3-5]",,,,"113"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],VU:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"112",,,,"112"],[,,,,,,,,,[-1]],,,,"VU",,,,,,,,,,,,,,,,,,[,,"112",,,,"112"],,[,,"112",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],WF:[,[,,"1\\d",,,,,,,[2]],,,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],,,,"WF",,,,,,,,,,,,,,,,,,[,,"1[578]",,,,"15"],,[,,"1[578]",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,
,,,[-1]]],WS:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"9(?:11|9[4-69])",,,,"911"],[,,,,,,,,,[-1]],,,,"WS",,,,,,,,,,,,,,,,,,[,,"9(?:11|9[4-69])",,,,"911"],,[,,"1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])",,,,"111"],[,,,,,,,,,[-1]],[,,"12[0-6]",,,,"120"],,[,,,,,,,,,[-1]]],XK:[,[,,"1\\d\\d",,,,,,,[3]],,,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],,,,"XK",,,,,,,,,,,,,,,,,,[,,"1(?:12|9[2-4])",,,,"112"],,[,,"1(?:12|9[2-4])",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YE:[,[,,"1\\d\\d",,,,,,,[3]],
,,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],,,,"YE",,,,,,,,,,,,,,,,,,[,,"19[1459]",,,,"191"],,[,,"19[1459]",,,,"191"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],YT:[,[,,"1\\d\\d?",,,,,,,[2,3]],,,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],,,,"YT",,,,,,,,,,,,,,,,,,[,,"1(?:12|5)",,,,"15"],,[,,"1(?:12|5)",,,,"15"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZA:[,[,,"[134]\\d{2,4}",,,,,,,[3,4,5]],,,[,,"1(?:01\\d\\d|12)",,,,"112",,,[3,5]],[,,"41(?:348|851)",,,,"41348",,,[5]],,,,"ZA",,,,,,,,,,,,
,,,,,,[,,"1(?:01(?:11|77)|12)",,,,"112",,,[3,5]],,[,,"1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}",,,,"107"],[,,"3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699",,,,"30782",,,[5]],[,,"111",,,,"111",,,[3]],,[,,"[34]\\d{4}",,,,"30000",,,[5]]],ZM:[,[,,"[19]\\d\\d",,,,,,,[3]],,,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],,,,"ZM",,,,,,,,,,,,,,,,,,[,,"112|99[139]",,,,"112"],,[,,"112|99[139]",,,,"112"],[,,,,,,,,,[-1]],[,,,,,,,,,[-1]],,[,,,,,,,,,[-1]]],ZW:[,[,
,"[139]\\d\\d(?:\\d{2})?",,,,,,,[3,5]],,,[,,"112|9(?:5[023]|61|9[3-59])",,,,"112",,,[3]],[,,"3[013-57-9]\\d{3}",,,,"30000",,,[5]],,,,"ZW",,,,,,,,,,,,,,,,,,[,,"112|99[3-59]",,,,"112",,,[3]],,[,,"11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])",,,,"112"],[,,,,,,,,,[-1]],[,,"114|9(?:5[023]|6[0-25])",,,,"114",,,[3]],,[,,,,,,,,,[-1]]]};/*

 Copyright (C) 2018 The Libphonenumber Authors.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
i18n.phonenumbers.ShortNumberInfo=function(){this.regionToMetadataMap={}};goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo);i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_=["BR","CL","NI"];i18n.phonenumbers.ShortNumberInfo.ShortNumberCost={TOLL_FREE:0,STANDARD_RATE:1,PREMIUM_RATE:2,UNKNOWN_COST:3};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_=function(a){return(a=i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a])?a:[]};
i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_=function(a,b){a=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());return null!=b&&a.includes(b)};i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a).length;return b.getGeneralDesc().possibleLengthArray().includes(a)};
i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());a=this.getNationalSignificantNumber_(a).length;for(var c=0;c<b.length;c++){var d=this.getMetadataForRegion_(b[c]);if(d&&d.getGeneralDesc().possibleLengthArray().includes(a))return!0}return!1};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);if(!b)return!1;a=this.getNationalSignificantNumber_(a);var c=b.getGeneralDesc();if(!this.matchesPossibleNumberAndNationalNumber_(a,c))return!1;b=b.getShortCode();return this.matchesPossibleNumberAndNationalNumber_(a,b)};
i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault()),c=this.getRegionCodeForShortNumberFromRegionList_(a,b);return 1<b.length&&null!=c?!0:this.isValidShortNumberForRegion(a,c)};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion=function(a,b){var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;if(!this.regionDialingFromMatchesNumber_(a,b))return c.UNKNOWN_COST;var d=this.getMetadataForRegion_(b);if(!d)return c.UNKNOWN_COST;a=this.getNationalSignificantNumber_(a);return d.getGeneralDesc().possibleLengthArray().includes(a.length)?this.matchesPossibleNumberAndNationalNumber_(a,d.getPremiumRate())?c.PREMIUM_RATE:this.matchesPossibleNumberAndNationalNumber_(a,
d.getStandardRate())?c.STANDARD_RATE:this.matchesPossibleNumberAndNationalNumber_(a,d.getTollFree())||this.isEmergencyNumber(a,b)?c.TOLL_FREE:c.UNKNOWN_COST:c.UNKNOWN_COST};
i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost=function(a){var b=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,c=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());if(0===c.length)return b.UNKNOWN_COST;if(1===c.length)return this.getExpectedCostForRegion(a,c[0]);for(var d=b.TOLL_FREE,e=0;e<c.length;e++){var f=this.getExpectedCostForRegion(a,c[e]);switch(f){case b.PREMIUM_RATE:return b.PREMIUM_RATE;case b.UNKNOWN_COST:d=b.UNKNOWN_COST;break;case b.STANDARD_RATE:d!==b.UNKNOWN_COST&&
(d=b.STANDARD_RATE);break;case b.TOLL_FREE:break;default:throw Error("Unrecognized cost for region: "+f);}}return d};i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_=function(a,b){if(0===b.length)return null;if(1===b.length)return b[0];a=this.getNationalSignificantNumber_(a);for(var c=0;c<b.length;c++){var d=b[c],e=this.getMetadataForRegion_(d);if(e&&this.matchesPossibleNumberAndNationalNumber_(a,e.getShortCode()))return d}return null};
i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions=function(){return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(a){return isNaN(a)})};i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber=function(a){a=this.getMetadataForRegion_(a);if(!a)return"";a=a.getShortCode();return a.hasExampleNumber()?a.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost=function(a,b){a=this.getMetadataForRegion_(a);if(!a)return"";var c=i18n.phonenumbers.ShortNumberInfo.ShortNumberCost,d=null;switch(b){case c.TOLL_FREE:d=a.getTollFree();break;case c.STANDARD_RATE:d=a.getStandardRate();break;case c.PREMIUM_RATE:d=a.getPremiumRate()}return d&&d.hasExampleNumber()?d.getExampleNumber()||"":""};
i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!0)};i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber=function(a,b){return this.matchesEmergencyNumberHelper_(a,b,!1)};
i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_=function(a){if(!a)return null;a=a.toUpperCase();var b=this.regionToMetadataMap[a];if(null==b){b=new goog.proto2.PbLiteSerializer;var c=i18n.phonenumbers.shortnumbermetadata.countryToMetadata[a];if(null==c)return null;b=b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(),c);this.regionToMetadataMap[a]=b}return b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_=function(a,b,c){var d=i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a);if(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d))return!1;a=this.getMetadataForRegion_(b);if(null==a||!a.hasEmergency())return!1;d=i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(d);b=c&&!i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(b);c=a.getEmergency().getNationalNumberPatternOrDefault();
return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(c,d)||b&&i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(c,d)};i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific=function(a){var b=this.getRegionCodesForCountryCode_(a.getCountryCodeOrDefault());b=this.getRegionCodeForShortNumberFromRegionList_(a,b);a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;a=this.getNationalSignificantNumber_(a);b=this.getMetadataForRegion_(b);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getCarrierSpecific())};
i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion=function(a,b){if(!this.regionDialingFromMatchesNumber_(a,b))return!1;b=this.getMetadataForRegion_(b);a=this.getNationalSignificantNumber_(a);return!!b&&this.matchesPossibleNumberAndNationalNumber_(a,b.getSmsServices())};
i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_=function(a){if(!a.hasNationalNumber())return"";var b=""+a.getNationalNumber();return a.hasItalianLeadingZero()&&a.getItalianLeadingZero()&&0<a.getNumberOfLeadingZerosOrDefault()?Array(a.getNumberOfLeadingZerosOrDefault()+1).join("0")+b:b};
i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_=function(a,b){return 0<b.possibleLengthArray().length&&!b.possibleLengthArray().includes(a.length)?!1:i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(b.getNationalNumberPatternOrDefault(),a.toString())};i18n.phonenumbers.AsYouTypeFormatter=function(a){this.DIGIT_PLACEHOLDER_="\u2008";this.DIGIT_PATTERN_=new RegExp(this.DIGIT_PLACEHOLDER_);this.currentOutput_="";this.formattingTemplate_=new goog.string.StringBuffer;this.currentFormattingPattern_="";this.accruedInput_=new goog.string.StringBuffer;this.accruedInputWithoutFormatting_=new goog.string.StringBuffer;this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=this.inputHasFormatting_=!1;this.phoneUtil_=i18n.phonenumbers.PhoneNumberUtil.getInstance();
this.positionToRemember_=this.originalPosition_=this.lastMatchPosition_=0;this.prefixBeforeNationalNumber_=new goog.string.StringBuffer;this.shouldAddSpaceAfterNationalPrefix_=!1;this.extractedNationalPrefix_="";this.nationalNumber_=new goog.string.StringBuffer;this.possibleFormats_=[];this.defaultCountry_=a;this.defaultMetadata_=this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_)};i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_=" ";
i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_=new i18n.phonenumbers.PhoneMetadata;i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_=new RegExp("^["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*(\\$\\d["+i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION+"]*)+$");i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_=/[- ]/;
i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_=3;i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_=function(a){a=this.phoneUtil_.getCountryCodeForRegion(a);a=this.phoneUtil_.getRegionCodeForCountryCode(a);a=this.phoneUtil_.getMetadataForRegion(a);return null!=a?a:i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_=function(){for(var a=this.possibleFormats_.length,b=0;b<a;++b){var c=this.possibleFormats_[b],d=c.getPatternOrDefault();if(this.currentFormattingPattern_==d)return!1;if(this.createFormattingTemplate_(c))return this.currentFormattingPattern_=d,this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()),this.lastMatchPosition_=0,!0}return this.ableToFormat_=
!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_=function(a){for(var b=this.isCompleteNumber_&&0==this.extractedNationalPrefix_.length&&0<this.currentMetadata_.intlNumberFormatCount()?this.currentMetadata_.intlNumberFormatArray():this.currentMetadata_.numberFormatArray(),c=b.length,d=0;d<c;++d){var e=b[d];0<this.extractedNationalPrefix_.length&&this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())&&!e.getNationalPrefixOptionalWhenFormatting()&&!e.hasDomesticCarrierCodeFormattingRule()||
(0!=this.extractedNationalPrefix_.length||this.isCompleteNumber_||this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())||e.getNationalPrefixOptionalWhenFormatting())&&i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(e.getFormatOrDefault())&&this.possibleFormats_.push(e)}this.narrowDownPossibleFormats_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_=function(a){for(var b=[],c=a.length-i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_,d=this.possibleFormats_.length,e=0;e<d;++e){var f=this.possibleFormats_[e];if(0==f.leadingDigitsPatternCount())b.push(this.possibleFormats_[e]);else{var g=Math.min(c,f.leadingDigitsPatternCount()-1);f=f.getLeadingDigitsPattern(g);0==a.search(f)&&b.push(this.possibleFormats_[e])}}this.possibleFormats_=b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_=function(a){var b=a.getPatternOrDefault();this.formattingTemplate_.clear();a=this.getFormattingTemplate_(b,a.getFormatOrDefault());return 0<a.length?(this.formattingTemplate_.append(a),!0):!1};i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_=function(a,b){var c="999999999999999".match(a)[0];if(c.length<this.nationalNumber_.getLength())return"";a=c.replace(new RegExp(a,"g"),b);return a=a.replace(/9/g,this.DIGIT_PLACEHOLDER_)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.clear=function(){this.currentOutput_="";this.accruedInput_.clear();this.accruedInputWithoutFormatting_.clear();this.formattingTemplate_.clear();this.lastMatchPosition_=0;this.currentFormattingPattern_="";this.prefixBeforeNationalNumber_.clear();this.extractedNationalPrefix_="";this.nationalNumber_.clear();this.ableToFormat_=!0;this.inputHasFormatting_=!1;this.originalPosition_=this.positionToRemember_=0;this.isExpectingCountryCallingCode_=this.isCompleteNumber_=
!1;this.possibleFormats_=[];this.shouldAddSpaceAfterNationalPrefix_=!1;this.currentMetadata_!=this.defaultMetadata_&&(this.currentMetadata_=this.getMetadataForRegion_(this.defaultCountry_))};i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition=function(a){return this.currentOutput_=this.inputDigitWithOptionToRememberPosition_(a,!0)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_=function(a,b){this.accruedInput_.append(a);b&&(this.originalPosition_=this.accruedInput_.getLength());this.isDigitOrLeadingPlusSign_(a)?a=this.normalizeAndAccrueDigitsAndPlusSign_(a,b):(this.ableToFormat_=!1,this.inputHasFormatting_=!0);if(!this.ableToFormat_){if(!this.inputHasFormatting_)if(this.attemptToExtractIdd_()){if(this.attemptToExtractCountryCallingCode_())return this.attemptToChoosePatternWithPrefixExtracted_()}else if(this.ableToExtractLongerNdd_())return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.attemptToChoosePatternWithPrefixExtracted_();
return this.accruedInput_.toString()}switch(this.accruedInputWithoutFormatting_.getLength()){case 0:case 1:case 2:return this.accruedInput_.toString();case 3:if(this.attemptToExtractIdd_())this.isExpectingCountryCallingCode_=!0;else return this.extractedNationalPrefix_=this.removeNationalPrefixFromNationalNumber_(),this.attemptToChooseFormattingPattern_();default:if(this.isExpectingCountryCallingCode_)return this.attemptToExtractCountryCallingCode_()&&(this.isExpectingCountryCallingCode_=!1),this.prefixBeforeNationalNumber_.toString()+
this.nationalNumber_.toString();if(0<this.possibleFormats_.length){a=this.inputDigitHelper_(a);b=this.attemptToFormatAccruedDigits_();if(0<b.length)return b;this.narrowDownPossibleFormats_(this.nationalNumber_.toString());return this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.ableToFormat_?this.appendNationalNumber_(a):this.accruedInput_.toString()}return this.attemptToChooseFormattingPattern_()}};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_=function(){this.ableToFormat_=!0;this.isExpectingCountryCallingCode_=!1;this.possibleFormats_=[];this.lastMatchPosition_=0;this.formattingTemplate_.clear();this.currentFormattingPattern_="";return this.attemptToChooseFormattingPattern_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_=function(){return this.extractedNationalPrefix_};
i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_=function(){if(0<this.extractedNationalPrefix_.length){var a=this.nationalNumber_.toString();this.nationalNumber_.clear();this.nationalNumber_.append(this.extractedNationalPrefix_);this.nationalNumber_.append(a);a=this.prefixBeforeNationalNumber_.toString();var b=a.lastIndexOf(this.extractedNationalPrefix_);this.prefixBeforeNationalNumber_.clear();this.prefixBeforeNationalNumber_.append(a.substring(0,b))}return this.extractedNationalPrefix_!=
this.removeNationalPrefixFromNationalNumber_()};i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_=function(a){return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a)||1==this.accruedInput_.getLength()&&i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_=function(){for(var a=this.nationalNumber_.toString(),b=this.possibleFormats_.length,c=0;c<b;++c){var d=this.possibleFormats_[c],e=d.getPatternOrDefault();if((new RegExp("^(?:"+e+")$")).test(a)&&(this.shouldAddSpaceAfterNationalPrefix_=i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()),d=a.replace(new RegExp(e,"g"),d.getFormat()),d=this.appendNationalNumber_(d),
i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d)==this.accruedInputWithoutFormatting_))return d}return""};
i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_=function(a){var b=this.prefixBeforeNationalNumber_.getLength();return this.shouldAddSpaceAfterNationalPrefix_&&0<b&&this.prefixBeforeNationalNumber_.toString().charAt(b-1)!=i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_?this.prefixBeforeNationalNumber_+i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_+a:this.prefixBeforeNationalNumber_+a};
i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition=function(){if(!this.ableToFormat_)return this.originalPosition_;for(var a=0,b=0,c=this.accruedInputWithoutFormatting_.toString(),d=this.currentOutput_.toString();a<this.positionToRemember_&&b<d.length;)c.charAt(a)==d.charAt(b)&&a++,b++;return b};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_=function(){var a=this.nationalNumber_.toString();return a.length>=i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_?(this.getAvailableFormats_(a),a=this.attemptToFormatAccruedDigits_(),0<a.length?a:this.maybeCreateNewTemplate_()?this.inputAccruedNationalNumber_():this.accruedInput_.toString()):this.appendNationalNumber_(a)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=a.length;if(0<b){for(var c="",d=0;d<b;d++)c=this.inputDigitHelper_(a.charAt(d));return this.ableToFormat_?this.appendNationalNumber_(c):this.accruedInput_.toString()}return this.prefixBeforeNationalNumber_.toString()};
i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_=function(){if(1!=this.currentMetadata_.getCountryCode())return!1;var a=this.nationalNumber_.toString();return"1"==a.charAt(0)&&"0"!=a.charAt(1)&&"1"!=a.charAt(1)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_=function(){var a=this.nationalNumber_.toString(),b=0;if(this.isNanpaNumberWithNationalPrefix_())b=1,this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),this.isCompleteNumber_=!0;else if(this.currentMetadata_.hasNationalPrefixForParsing()){var c=new RegExp("^(?:"+this.currentMetadata_.getNationalPrefixForParsing()+")");c=a.match(c);null!=c&&
null!=c[0]&&0<c[0].length&&(this.isCompleteNumber_=!0,b=c[0].length,this.prefixBeforeNationalNumber_.append(a.substring(0,b)))}this.nationalNumber_.clear();this.nationalNumber_.append(a.substring(b));return a.substring(0,b)};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_=function(){var a=this.accruedInputWithoutFormatting_.toString(),b=new RegExp("^(?:\\"+i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN+"|"+this.currentMetadata_.getInternationalPrefix()+")");b=a.match(b);return null!=b&&null!=b[0]&&0<b[0].length?(this.isCompleteNumber_=!0,b=b[0].length,this.nationalNumber_.clear(),this.nationalNumber_.append(a.substring(b)),this.prefixBeforeNationalNumber_.clear(),this.prefixBeforeNationalNumber_.append(a.substring(0,
b)),a.charAt(0)!=i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN&&this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_),!0):!1};
i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_=function(){if(0==this.nationalNumber_.getLength())return!1;var a=new goog.string.StringBuffer,b=this.phoneUtil_.extractCountryCode(this.nationalNumber_,a);if(0==b)return!1;this.nationalNumber_.clear();this.nationalNumber_.append(a.toString());a=this.phoneUtil_.getRegionCodeForCountryCode(b);i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY==a?this.currentMetadata_=this.phoneUtil_.getMetadataForNonGeographicalRegion(b):
a!=this.defaultCountry_&&(this.currentMetadata_=this.getMetadataForRegion_(a));this.prefixBeforeNationalNumber_.append(""+b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);this.extractedNationalPrefix_="";return!0};
i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_=function(a,b){if(a==i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN){var c=a;this.accruedInputWithoutFormatting_.append(a)}else c=i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a],this.accruedInputWithoutFormatting_.append(c),this.nationalNumber_.append(c);b&&(this.positionToRemember_=this.accruedInputWithoutFormatting_.getLength());return c};
i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_=function(a){var b=this.formattingTemplate_.toString();if(0<=b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)){var c=b.search(this.DIGIT_PATTERN_);a=b.replace(this.DIGIT_PATTERN_,a);this.formattingTemplate_.clear();this.formattingTemplate_.append(a);this.lastMatchPosition_=c;return a.substring(0,this.lastMatchPosition_+1)}1==this.possibleFormats_.length&&(this.ableToFormat_=!1);this.currentFormattingPattern_="";return this.accruedInput_.toString()};Object.defineProperty(exports,"__esModule",{value:!0});exports.default=i18n.phonenumbers;module.exports=exports["default"];

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("GTd5")))

/***/ }),

/***/ "gPoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];

var UserEventsDirective = function UserEventsDirective() {
    _classCallCheck(this, UserEventsDirective);

    this.template = __webpack_require__("erZH");
    this.restrict = 'EA';
    this.replace = true;
};

_directiveDependencies.push(function () {
    return new UserEventsDirective();
});

angular.module('directives').directive('userEvents', _directiveDependencies);

/***/ }),

/***/ "gbut":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"splash-screen-modal spotlight-welcome-modal\">\n    <div class=\"splash-screen-close-button crs-pointer \" ng-click=\"closeModal()\">\n        <i class=\"icon icon-s icon-close3 mb10\"></i>\n        <a class=\"text-s\"\n            translate=\"cw.modal.welcome.close\">\n        </a>\n    </div>\n    <div class=\"splash-screen-content\">\n        <h1 class=\"text-white text-xxxxl mb10\" translate=\"cw.modal.spotlight_welcome.title\"></h1>\n        <h2 class=\"text-l text-grey-6 mb70\" translate=\"cw.modal.spotlight_welcome.subtitle\" translate-values= \"{brandname: brandName, product: product}\"></h2>\n        <ul class=\"splash-screen-features text-l text-grey-5 mb50\">\n            <li translate=\"cw.modal.spotlight_welcome.feature1\"></li>\n            <li translate=\"cw.modal.spotlight_welcome.feature2\"></li>\n        </ul>\n        <button\n            ng-if=\"license\"\n            class=\"btn btn-primary btn-large\"\n            ng-click=\"installApp()\"\n            translate=\"cw.modal.welcome.install\">\n        </button>\n    </div>\n</div>\n";
var path = 'scripts/controllers/modals/welcome-modal-spotlight/welcome-modal-spotlight.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "gfIQ":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("eWdr"),
    Map = __webpack_require__("9u6A"),
    Promise = __webpack_require__("4FJV"),
    Set = __webpack_require__("RIV0"),
    WeakMap = __webpack_require__("CKgr"),
    baseGetTag = __webpack_require__("r1rA"),
    toSource = __webpack_require__("wHLP");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "gkic":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* jshint unused: false */
/* eslint no-unused-vars: 0 */

/**
 * Listener module
 * Initialize all model listeners by depending on them at runtime
 * No need to actually do something else
 */
angular.module('listeners').run(['UserListener', 'DevicesListener', 'EventsListener', 'LicenseListener', 'AppInstancesListener', 'ActionsListener', 'ActivationCodesListener', function (UserListener, DevicesListener, EventsListener, LicenseListener, AppInstancesListener, ActionsListener, ActivationCodesListener) {}]);

/***/ }),

/***/ "h+b5":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("zzbF"),
    get = __webpack_require__("vzeB"),
    hasIn = __webpack_require__("eIoM"),
    isKey = __webpack_require__("Kxtb"),
    isStrictComparable = __webpack_require__("E4A5"),
    matchesStrictComparable = __webpack_require__("jszl"),
    toKey = __webpack_require__("4dmE");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "h4dL":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-addDevice\" connectqa-modal=\"deploy-by-os\">\n    <div class='content-wrapper'>\n        <div class=\"top-elements\">\n            <i class=\"icon icon-avira-logo mb20\"></i>\n            <h2 class=\"text-xxl2 text-grey-2 mb30\" translate=\"cw.device.protect\"></h2>\n            <p class=\"text-m text-grey-4 mb20\" translate=\"cw.deploy.select_your_os\"></p>\n            <div class=\"content-wrapper-select\">\n                <ul>\n                    <li ng-repeat=\"os in chooseDeviceOsWizardCtrl.supportedOs\"\n                        class=\"deploy-e\"\n                        ng-click=\"chooseDeviceOsWizardCtrl.deployOn(os);\" connectqa-deploy-os=\"{{os}}\">\n                        <div class=\"icon icon-m icon-{{os | lowercase}} icon-grey-3 icon-inner-shadow-gray mt20\"></div>\n                        <span translate=\"cw.general.os.{{os | lowercase}}\" class=\"text-grey-3 inline-block text-m mt15\"></span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "hIFk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Directive which writes the debug messages in a div, instead of the browser console.
 */
angular.module('directives').directive('customDebug', ['$translate', '$rootScope', function ($translate, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        template: __webpack_require__("AJH6"),
        scope: {},
        link: function link(scope) {

            scope.debugObj = $rootScope.Debug;
            scope.customDebug = CWCONFIG.features.customDebug;
        }
    };
}]);

/***/ }),

/***/ "he/w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _arguments = arguments;

var _loggers = __webpack_require__("+htc");

var appStateDebugger = ['$rootScope', function ($rootScope) {

    var appStateDebuggerIsEnabled = localStorage.getItem('debug_state');

    if (!appStateDebuggerIsEnabled) {

        return;
    }

    var stateChange = {
        flow: []
    };

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        var fromState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'empty state';
        var fromParams = arguments[4];


        _loggers.stateLogger.info({
            type: 'State Transition event $stateChangeStart to ' + toState.name + ' - fired when the transition begins.',
            cmd: '',
            data: {
                fromState: fromState,
                fromParams: fromParams,
                toState: toState,
                toParams: toParams
            }

        });
    });
    $rootScope.$on('$stateChangeError', function () {

        var argumentsArray = Array.prototype.slice.call(_arguments);

        _loggers.stateLogger.info({
            type: 'State Transition Error',
            cmd: '',
            data: '$stateChangeError -  fired when an error in state transition happens.',
            params: argumentsArray
        });
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

        _loggers.stateLogger.info({
            type: 'State Transition event $stateChangeSuccess to ' + toState.name + ' - fired when the transition begins.',
            cmd: '',
            data: {
                fromState: fromState,
                fromParams: fromParams,
                toState: toState,
                toParams: toParams
            }
        });
        stateChange.flow.push(fromState.name + ' --> ' + toState.name);
        _loggers.stateLogger.info({
            type: 'State transition flow up to this point, including latest stateChange',
            cmd: '',
            data: {
                stateChange: stateChange
            }

        });
        stateChange.flow.push(fromState.name + ' --> ' + toState.name);
        _loggers.stateLogger.info({
            type: 'State transition flow up to this point, including latest stateChange',
            cmd: '',
            data: {
                stateChange: stateChange
            }

        });
    });

    $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {

        _loggers.stateLogger.info({
            type: 'State Transition event $stateNotFound to ' + unfoundState.to + ' - fired when a state cannot be found by its name.',
            cmd: '',
            data: {
                event: event,
                fromState: fromState,
                fromParams: fromParams,
                unfoundState: unfoundState
            }
        });
    });
}];

exports.default = appStateDebugger;

/***/ }),

/***/ "heYd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('default', function () {
    return function (value, defaultValue) {
        return value || defaultValue;
    };
});

/***/ }),

/***/ "hjls":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$window', 'UserRestService', '$state'];
var _$scope = void 0;
var _$window = void 0;
var _UserRestService = void 0;
var _user = void 0;
var _$state = void 0;
var lang = void 0;
var currentRoute = void 0;

var ChangeLang = function () {
    function ChangeLang($scope, $window, UserRestService, $state) {
        _classCallCheck(this, ChangeLang);

        _$scope = $scope;
        _$window = $window;
        _$state = $state;
        _$scope.languages = [];
        _$scope.changeLanguage = this.changeLanguage;
        _$scope.currentLanguage = _$window.location.pathname;
        _user = _index.MeRepository.getMyUser();
        _UserRestService = UserRestService;

        angular.forEach(CWCONFIG.languages, function (value, key) {

            _$scope.languages.push({ code: key, name: value });
        });
    }

    _createClass(ChangeLang, [{
        key: 'changeLanguage',
        value: function changeLanguage(inputLanguage) {

            var payload = {
                data: {
                    id: _user.id,
                    attributes: {
                        language: inputLanguage
                    },
                    type: _user.type
                }
            };

            _UserRestService.update(_user.id, payload).then(function () {

                lang = inputLanguage;

                if (_$state.params.resourceId === 'all') {
                    var _$window$location$pat = _$window.location.pathname.split('all');

                    // get the first position from split


                    var _$window$location$pat2 = _slicedToArray(_$window$location$pat, 1);

                    currentRoute = _$window$location$pat2[0];

                    currentRoute = currentRoute.slice(0, -1);
                } else {
                    var _$window$location$pat3 = _$window.location.pathname.split('ltb').slice(0, -1);

                    // get the first position from split


                    var _$window$location$pat4 = _slicedToArray(_$window$location$pat3, 1);

                    currentRoute = _$window$location$pat4[0];

                    currentRoute = currentRoute.slice(0, -1);
                }

                _$window.location.pathname = currentRoute.replace(CWCONFIG.language, lang);
            }).catch(function () {

                _RFC2.default.error('cw.notification.system.error');
            });
        }
    }]);

    return ChangeLang;
}();

_serviceDependencies.push(ChangeLang);

angular.module('controllers').controller('LanguageSwitcherCtrl', _serviceDependencies);

/***/ }),

/***/ "hkAL":
/***/ (function(module, exports) {

module.exports = "<div class=\"subscriptions-holder\">\n    <div>\n        <div class=\"dashboard-tabs-holder\">\n            <div class=\"dashboard-tabs text-left multiple-tabs\">\n                <span class=\"text-l text-dark crs-pointer\" translate=\"cw.general.profile\" ui-sref=\"root.dashboard.my-account({tab: 'profile'})\" ng-click=\"onTabClick('Profile')\" connectqa-mya=\"profile-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" translate=\"cw.general.security\" ui-sref=\"root.dashboard.my-account({tab: 'security'})\"  ng-click=\"onTabClick('Security')\" connectqa-mya=\"security-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" translate=\"cw.profile.tabs.dataSettings\" ui-sref=\"root.dashboard.my-account({tab: 'data-settings'})\" ng-click=\"onTabClick('Manage Account')\" connectqa-mya=\"data-settings-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" translate=\"cw.profile.tabs.notifications\" ui-sref=\"root.dashboard.my-account({tab: 'notifications'})\" ng-click=\"onTabClick('Notifications')\" connectqa-mya=\"notifications-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" translate=\"cw.profile.tabs.payment\" ui-sref=\"root.dashboard.my-account({tab: 'payment'})\" ng-if=\"paymentTypes.length\" ng-click=\"onTabClick('Payment')\" connectqa-mya=\"payment-tab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'history'}\" ui-sref=\"root.dashboard.subscriptions({tab: 'history'})\" translate=\"cw.my_account.menu.payment_history\" connectqa-subscriptions=\"payment-history\" ng-if=\"transactions.length > 0\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'otc'}\" ui-sref=\"root.dashboard.subscriptions({tab: 'otc'})\" translate=\"cw.subscriptions.tab_otc\" connectqa-subscriptions=\"activate-license\" ng-if=\"showOTCTab\"></span>\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'plans'}\" ui-sref=\"root.dashboard.subscriptions({tab: 'plans'})\" translate=\"cw.section.subscriptions.title\" connectqa-subscriptions=\"licenses\"></span>\n            </div>\n        </div>\n\n        <div ng-if=\"currentTab === 'plans'\">\n\n            <!-- Prime trial offer banner -->\n            <div class=\"subscriptions text-center\"\n                 ng-if=\"finalStepActivationWizard === false &&\n                        activationCodes.length === 0 &&\n                        userTrialLicenses.length === 0 &&\n                        $root.hasUsCompliance\">\n\n                <div>\n                    <welcome-offer ng-if=\"$root.dwmStatusLoaded && !$root.isMobileAppSession\"></welcome-offer>\n                </div>\n\n                <div class=\"no_subscriptions_holder\">\n                    <div class=\"no_subscriptions_img\"></div>\n                    <h2 translate=\"cw.subscriptions.no_licenses.title\" class=\"text-xl mb10 text-grey-1\"></h2>\n                    <p translate=\"cw.subscriptions.no_licenses.desc\" class=\"text-m text-grey-2 mb30 no-color-child\" translate-values=\"{brandname : brandName}\"></p>\n\n                    <button class=\"btn btn-primary btn-large mb15\"\n                            ng-if=\"!$root.isMobileAppSession\"\n                            ng-click=\"subscriptionsCtrl.goToStore('ConnectWeb My Subscriptions Store Click No Licenses')\"\n                            translate=\"cw.subscriptions.no_licenses.button\"></button>\n                </div>\n\n            </div>\n\n            <div ng-if=\"!$root.hasUsCompliance &&\n                activationCodes.length === 0 &&\n                userTrialLicenses.length === 0\" class=\"text-center\">\n                <i class=\"icon-info-blue mt100\"></i>\n                <h3 class=\"text-xl text-grey-1 text-center mt20 mb20\" translate=\"cw.compliance_failed.desc\"></h3>\n                <h3 class=\"text-xl text-grey-1 text-center mb10\" translate=\"cw.compliance_failed.reason_1\"></h3>\n                <h3 class=\"text-xl text-grey-1 text-center\" translate=\"cw.compliance_failed.reason_2\"></h3>\n            </div>\n\n            <!-- End Prime trial offer banner -->\n\n            <div ng-if=\"!firstexpiringLicense && !$root.hideSecondOfferUntilRefresh && !hideRecommendationBanner && $root.hasUsCompliance && !$root.isMobileAppSession\">\n                <recommendation-banner></recommendation-banner>\n            </div>\n\n            <ul class=\"subscriptions\"\n                ng-if=\"firstexpiringLicense\n                    && !firstexpiringLicense.attributes.customInfo.isNonrenewableApp\n                    && !firstexpiringLicense.attributes.has_partner_id\n                    && !userHaveActivePrime\n                    && !firstexpiringLicense.attributes.customInfo.hideTrialExpiringNotification\n                    && !firstexpiringLicense.isCardDeleted\n                    && $root.hasUsCompliance\n                    && !firstexpiringLicense.attributes.customInfo.expiringToday\">\n                <li class=\"expire-banner white-space-nowrap\">\n                    <div class=\"inline-block ml20 mr10 v-middle\">\n                        <i class=\"icon icon-expire-license\"></i>\n                    </div>\n                    <div class=\"inline-block w70 ml40 v-middle white-space-normal\">\n                        <h3 class=\"text-xxl text-grey-3 mb10 inline-block w100\" translate=\"cw.subscriptions.renew_banner.title_1\"></h3>\n\n                        <h4 class=\"text-l banner-subtitle\"\n                            ng-if=\"firstexpiringLicense.attributes.customInfo.showExpirationNotification &&\n                            firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration !== 1 && firstexpiringLicense.attributes.type === 'paid'\" translate=\"cw.subscriptions.renew_banner_subscription.subtitle_plural_1\"\n                            translate-values=\"{\n                                product: appIntegrations[firstexpiringLicense.relationships.app.data.id].attributes.resource.oeName || 'Avira',\n                                days: firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration\n                            }\">\n                        </h4>\n\n                        <h4 class=\"text-l banner-subtitle\"\n                            ng-if=\"firstexpiringLicense.attributes.customInfo.showExpirationNotification &&\n                            firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration === 1 && firstexpiringLicense.attributes.type === 'paid'\"\n                            translate=\"cw.subscriptions.renew_banner_subscription.subtitle_singular_1\"\n                            translate-values=\"{\n                                product: appIntegrations[firstexpiringLicense.relationships.app.data.id].attributes.resource.oeName || 'Avira',\n                                days: firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration\n                            }\">\n                        </h4>\n\n                        <h4 class=\"text-l banner-subtitle\"\n                            ng-if=\"firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration !== 1 && firstexpiringLicense.attributes.type === 'eval'\"\n                            translate=\"cw.subscriptions.renew_banner_trial.subtitle_1_plural\"\n                            translate-values=\"{\n                                product: appIntegrations[firstexpiringLicense.relationships.app.data.id].attributes.resource.oeName || 'Avira',\n                                days: firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration\n                            }\">\n                        </h4>\n\n                        <h4 class=\"text-l banner-subtitle\"\n                            ng-if=\"firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration === 1 && firstexpiringLicense.attributes.type === 'eval'\" translate=\"cw.subscriptions.renew_banner_trial.subtitle_1_singular\"\n                            translate-values=\"{\n                                product: appIntegrations[firstexpiringLicense.relationships.app.data.id].attributes.resource.oeName || 'Avira',\n                                days: firstexpiringLicense.attributes.customInfo.remainingDaysUntilExpiration\n                            }\">\n                        </h4>\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.isStaticOTC === true && firstexpiringLicense.attributes.type !== 'eval' && !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.subscriptionToggle(firstexpiringLicense, 'Expiration banner')\" connectqa-subscriptions=\"toggle-subscription\" ng-href=\"{{renewLinkBanner}}\"\n                            target=\"_blank\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                    translate=\"cw.subscriptions.cma.tooltip\"\n                                    translate-values=\"{\n                                        cancellation: '{{cancellationPolicy}}',\n                                        contact: '{{contactUs}}'\n                                    }\">\n                                </div>\n                            </div>\n                        </span>\n\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.isStaticOTC === false &&\n                            firstexpiringLicense.attributes.type === 'paid' &&\n                            !(firstexpiringLicense.attributes.app === 'aapd0' ||\n                            firstexpiringLicense.attributes.app === 'aapd5') &&\n                            !isVoucherPurchase(firstexpiringLicense) &&\n                            !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.subscriptionToggle(firstexpiringLicense, 'Expiration banner');\" connectqa-subscriptions=\"toggle-subscription\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                translate=\"cw.subscriptions.cma.tooltip\"\n                                translate-values=\"{\n                                    cancellation: '{{cancellationPolicy}}',\n                                    contact: '{{contactUs}}'\n                                }\">\n                                </div>\n                            </div>\n                        </span>\n                        <!-- Voucher renew button -->\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.isStaticOTC === false &&\n                        firstexpiringLicense.attributes.type === 'paid' &&\n                        !(firstexpiringLicense.attributes.app === 'aapd0' ||\n                        firstexpiringLicense.attributes.app === 'aapd5') &&\n                        isVoucherPurchase(firstexpiringLicense) &&\n                        !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.activateFirstExpiringLicense(firstexpiringLicense, 'Voucher')\" connectqa-subscriptions=\"toggle-subscription\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                translate=\"cw.subscriptions.cma.tooltip\"\n                                translate-values=\"{\n                                    cancellation: '{{cancellationPolicy}}',\n                                    contact: '{{contactUs}}'\n                                }\">\n                                </div>\n                            </div>\n                        </span>\n                        <!-- End voucher renew button -->\n                        <!-- Av pro campaign - keep me protected btn -->\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.isStaticOTC === false &&\n                        firstexpiringLicense.attributes.type === 'paid' &&\n                        (firstexpiringLicense.attributes.app === 'aapd0' ||\n                        firstexpiringLicense.attributes.app === 'aapd5') &&\n                        !firstexpiringLicense.removedPaymentOption &&\n                        !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.subscriptionToggle(firstexpiringLicense, 'Expiration banner');\n                            subscriptionsCtrl.sendMixpanelEventEnableSubscription(firstexpiringLicense, 'Enable subscription', 'Autorenew On')\" connectqa-subscriptions=\"toggle-subscription\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                translate=\"cw.subscriptions.cma.tooltip\"\n                                translate-values=\"{\n                                    cancellation: '{{cancellationPolicy}}',\n                                    contact: '{{contactUs}}'\n                                }\">\n                                </div>\n                            </div>\n                        </span>\n                        <!-- End Av pro campaign- keep me protected btn-->\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.attributes.type === 'eval' && !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.firstExpiringLicenseEvent(firstexpiringLicense, 'Trial')\"\n                            ng-href=\"{{renewLinkBanner}}\"\n                            target=\"_blank\" connectqa-subscriptions=\"toggle-subscription\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                translate=\"cw.subscriptions.cma.tooltip\"\n                                translate-values=\"{\n                                    cancellation: '{{cancellationPolicy}}',\n                                    contact: '{{contactUs}}'\n                                }\">\n                                </div>\n                            </div>\n                        </span>\n                        <!-- Card deleted button -->\n                        <span class=\"subscription-toggle-link\" ng-if=\"firstexpiringLicense.removedPaymentOption && !$root.isMobileAppSession\">\n                            <a class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.firstExpiringLicenseEvent(firstexpiringLicense, 'Card deleted')\"\n                            ng-href=\"{{renewLinkBanner}}\" connectqa-subscriptions=\"toggle-subscription\"></a>\n                            <div class=\"info-tooltip-holder inline-block v-middle\">\n                                <i class=\"icon icon-info\"></i>\n                                <div class=\"info-tooltip arrow-left subscription-notification\"\n                                translate=\"cw.subscriptions.cma.tooltip\"\n                                translate-values=\"{\n                                    cancellation: '{{cancellationPolicy}}',\n                                    contact: '{{contactUs}}'\n                                }\">\n                                </div>\n                            </div>\n                        </span>\n                        <!-- End card deleted button -->\n                    </div>\n                </li>\n            </ul>\n            <!-- End Renew subscription offer banner -->\n\n            <h2 class=\"mt50 mb20 text-xxl text-grey-1 subscriptions-section-title\" translate=\"cw.subscriptions.active_subscriptions\" ng-if=\"userTrialLicenses.length > 0 || activationCodes.length > 0\"></h2>\n\n            <ul class=\"subscriptions\" connectqa-subscriptions=\"trial-list\">\n                <!-- Trial Licenses List -->\n                <li ng-repeat=\"licenseCode in userTrialLicenses\"\n                    ng-class=\"{'hide-details' : !toggle}\"\n                    class=\"toggle-details-trial\">\n                    <div class=\"activated\">\n                        <div class=\"box-shot-icon\" ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img ng-src=\"{{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                        </div>\n                        <div class=\"icon-holder\" ng-if=\"!appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    ng-src=\"{{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.type === 'bundle' && !appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.type !== 'bundle' && !appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n                        </div>\n\n                        <div class=\"header-wrapper v-middle inline-block\">\n\n                            <h1 class=\"v-middle inline-block text-xxl text-grey-3\">\n                                {{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.oeName || 'Avira'}}\n                            </h1>\n                            <div class=\"os-wrap\"\n                                ng-show=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.type !== 'bundle'\"\n                                class=\"fl-right\">\n                                <div ng-repeat=\"osType in appIntegrations[licenseCode.relationships.app.data.id].attributes.custom.manifest.os\"\n                                    class=\"inline-block os-icon icon icon-xxs icon-grey-4 icon-{{osType}}\">\n                                </div>\n                            </div>\n                            <div>\n                                <div ng-show=\"$root.cmaGBapplies\">\n                                    <a class=\"show-more-button\"\n                                        ng-show=\"!toggle\"\n                                        connectqa-subscriptions=\"see-details-gb\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;subscriptionsCtrl.sendMixpanelEventDetailsButton(licenseCode, toggle ? 'Seen details' : ' Close details')\">\n                                        <span class=\"see-less-text\" translate=\"cw.subscriptions.cma.close_features\"></span>\n                                        <span class=\"see-more-text\" translate=\"cw.subscriptions.cma.see_features\"></span>\n                                    </a>\n                                    <a class=\"show-more-button\"\n                                        connectqa-subscriptions=\"close-details-gb\"\n                                        ng-show=\"toggle\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;subscriptionsCtrl.sendMixpanelEventDetailsButton(licenseCode, toggle ? 'Seen details' : ' Close details')\">\n                                        <span class=\"see-less-text\" translate=\"cw.subscriptions.cma.close_features\"></span>\n                                        <span class=\"see-more-text\" translate=\"cw.subscriptions.cma.see_features\"></span>\n                                    </a>\n                                </div>\n\n                                <div ng-show=\"!$root.cmaGBapplies\">\n                                    <a class=\"show-more-button\"\n                                        ng-show=\"!toggle\"\n                                        connectqa-subscriptions=\"see-details-row\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;toggleSubscriptionDetails=!toggleSubscriptionDetails;subscriptionsCtrl.sendMixpanelEventDetailsButton(licenseCode, toggle ? 'Seen details' : ' Close details');\n                                        $root.promotionsTooltips[activationCode.id] = false\"\n                                        ng-show=\"activationCode.attributes.app !== 'adwp1'\">\n                                            <span class=\"see-less-text\" translate=\"cw.subscriptions.hide_renewal_settings\">\n                                            </span>\n                                            <span class=\"see-more-text\" translate=\"cw.subscriptions.show_renewal_settings\">\n                                            </span>\n\n                                    </a>\n                                    <a class=\"show-more-button\"\n                                        connectqa-subscriptions=\"close-details-row\"\n                                        ng-show=\"toggle\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;toggleSubscriptionDetails=!toggleSubscriptionDetails;subscriptionsCtrl.sendMixpanelEventDetailsButton(licenseCode, toggle ? 'Seen details' : ' Close details');\n                                        $root.promotionsTooltips[activationCode.id] = false\"\n                                        ng-show=\"activationCode.attributes.app !== 'adwp1'\">\n                                            <span class=\"see-less-text\" translate=\"cw.subscriptions.hide_renewal_settings\">\n                                            </span>\n                                            <span class=\"see-more-text\" translate=\"cw.subscriptions.show_renewal_settings\">\n                                            </span>\n\n                                    </a>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"installed-on fl-right\"\n                            ng-class=\"{'mt10' : !licenseCode.attributes.customInfo.showExpirationNotification}\">\n                            <a class=\"show-dropdown single-device\"\n                                ng-class=\"[licenseCode.attributes.customInfo.devices[0].attributes.type+'-'+licenseCode.attributes.customInfo.devices[0].attributes.os]\"\n                                ng-show=\"licenseCode.attributes.customInfo.devices.length == 1\"\n                                ui-sref=\"root.dashboard.device-details({resourceId: licenseCode.attributes.customInfo.devices[0].id, tab: 'apps'})\"\n                                translate=\"cw.dashboard.services.installed_on_text\"\n                                translate-values=\"{systemprofilename : licenseCode.attributes.customInfo.devices[0].attributes.alias || licenseCode.attributes.customInfo.devices[0].attributes.name}\">\n                            </a>\n                            <a class=\"show-dropdown\"\n                                ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                ng-show=\"licenseCode.attributes.customInfo.devices.length > 1\"\n                                ng-click=\"toggleDropdown=!toggleDropdown\">\n                                <span translate=\"cw.subscriptions.multiple_install\"></span>\n                            </a>\n                            <span class=\"show-dropdown\"\n                                ng-show=\"!licenseCode.attributes.customInfo.devices.length\">\n                                <span translate=\"cw.dashboard.device.not_installed\"></span>\n                            </span>\n\n                            <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                    <li ng-repeat=\"device in licenseCode.attributes.customInfo.devices\" ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                                        <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}}\"></i>{{device.attributes.alias || device.attributes.name }}\n                                    </li>\n                                </div>\n                            </ul>\n                        </div>\n                    </div>\n\n                    <ul class=\"info-holder subscription-details\">\n\n                        <li class=\"p-relative subscription-toggle\" ng-if=\"licenseCode.attributes.cmp !== 'cobi2020avpro' && !$root.isMobileAppSession\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n\n                            <span class=\"subscription-toggle-link\">\n                                <span class=\"crs-pointer\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.onRenewalClick(licenseCode, 'Trial')\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                <div class=\"info-tooltip-holder inline-block v-middle\">\n                                    <i class=\"icon icon-info\"></i>\n                                    <div class=\"info-tooltip arrow-left subscription-notification\"\n                                    translate=\"cw.subscriptions.cma.tooltip\"\n                                    translate-values=\"{\n                                        cancellation: '{{cancellationPolicy}}',\n                                        contact: '{{contactUs}}'\n                                    }\">\n                                    </div>\n                                </div>\n                            </span>\n                        </li>\n\n                        <li ng-if=\"licenseCode.attributes.runtime === 365 && licenseCode.attributes.cmp === 'cobi2020avpro'\" class=\"subscription-period\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.general.runtime\"></h6>\n                            <h5 connectqa-subscriptions=\"license-type\">\n                                <span ng-if=\"licenseCode.attributes.runtime === 365\" translate=\"cw.subscriptions.cma.annual\">\n                                </span>\n                            </h5>\n                        </li>\n\n                        <li ng-if=\"licenseCode.attributes.cmp !== 'cobi2020avpro'\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.general.type\"></h6>\n                            <h5>\n                                <span translate=\"cw.general.trial\"></span>\n                            </h5>\n                        </li>\n                        <li ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <span>\n                                <h6 translate=\"cw.subscriptions.cma.expires_on\"></h6>\n                                <h5>{{licenseCode.attributes.customInfo.formatted_expiration_date}}</h5>\n                            </span>\n                        </li>\n\n                        <li ng-if=\"licenseCode.attributes.cmp === 'cobi2020avpro'\"\n                            ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 0\"\n                            ng-class=\"{'short-view-width': !toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1}\"\n                        >\n                            <h6 translate=\"cw.menu.devices\"></h6>\n                            <h5>\n                                <span translate=\"cw.general.devices.one\" translate-values=\"{total: '1'}\"></span>\n                            </h5>\n                        </li>\n\n                        <li ng-if=\"licenseCode.attributes.devices_limit !== null\"\n                            ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 0\"\n                            ng-class=\"{'short-view-width': !toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1}\"\n                        >\n                            <h6 translate=\"cw.menu.devices\"></h6>\n\n                            <h5>\n                                <span translate=\"cw.general.devices.one\"></span>\n                                <span ng-if=\"licenseCode.attributes.devices_limit > 1\"\n                                        translate=\"cw.general.devices.many\"\n                                        translate-values=\"{total: licenseCode.attributes.activationCode.attributes.devices_limit}\"></span>\n                            </h5>\n                        </li>\n                    </ul>\n                    <ul class=\"info-holder\">\n                        <li class=\"key-section w30\" ng-if=\"!$root.cmaGBapplies\" ng-hide=\"toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <div>\n                                <h6 translate=\"cw.subscriptions.trial_expires_in\"></h6>\n                                <h5 class=\"inline-block v-middle\" connectqa-subscriptions=\"transaction-id\">\n                                    {{licenseCode.attributes.customInfo.remainingDaysUntilExpiration}}\n                                    <span ng-if=\"licenseCode.attributes.customInfo.remainingDaysUntilExpiration === 1\" translate=\"cw.general.day\"></span>\n                                    <span ng-if=\"licenseCode.attributes.customInfo.remainingDaysUntilExpiration > 1\" translate=\"cw.general.days\"></span>\n                                </h5>\n                            </div>\n                        </li>\n                        <li\n                            class=\"button-section\"\n                            ng-if=\"!licenseCode.attributes.expired && appIntegrations[licenseCode.relationships.app.data.id].attributes.custom.manifest.os\" ng-class=\"{\n                                'full-width': $root.cmaGBapplies || (!$root.cmaGBapplies && toggleSubscriptionDetails && licenseCode.attributes.cmp === 'cobi2020avpro') ||\n                                (!$root.cmaGBapplies && toggleSubscriptionDetails),\n                                'detailes-hidden': !toggleSubscriptionDetails && !$root.cmaGBapplies\n                            }\">\n                            <!-- <a\n                                class=\"btn btn-medium btn-orange mb10\"\n                                translate=\"cw.general.buy\"\n                                target=\"_blank\"\n                                ng-click=\"subscriptionsCtrl.onRenewalClick(licenseCode, 'Trial')\"\n                                ng-href=\"{{renewLink}}\"\n                                connectqa-subscriptions=\"buy-now\"\n                                ng-if=\"licenseCode.attributes.cmp !== 'cobi2020avpro'\">\n                            </a>\n\n                            <a\n                                class=\"btn btn-medium btn-orange mb10\"\n                                translate=\"cw.general.buy\"\n                                target=\"_blank\"\n                                ng-click=\"subscriptionsCtrl.onRenewalClick(licenseCode, 'Trial', 'cobi2020avpro')\"\n                                connectqa-subscriptions=\"buy-now\"\n                                ng-href=\"{{licenseCode.attributes.renewal_link}}&x-a-source=cw\"\n                                ng-if=\"licenseCode.attributes.cmp === 'cobi2020avpro'\">\n                            </a> -->\n\n                            <span class=\"crs-pointer btn btn-medium btn-orange\" translate=\"cw.subscriptions.cma.activate\" ng-click=\"subscriptionsCtrl.onRenewalClick(licenseCode, 'Trial')\" connectqa-subscriptions=\"toggle-subscription\" ng-if=\"!$root.cmaGBapplies && licenseCode.attributes.cmp !== 'cobi2020avpro' && !$root.isMobileAppSession\"></span>\n\n                            <div ng-if=\"subscriptionsCtrl.getButtonAction(licenseCode) === 'install' && $root.hasUsCompliance\"\n                                class=\"inline-block ml20 install-btn-dropdown\"\n                                ng-init=\"toggleDropdown = false;\">\n                                <div class=\"btn-group\">\n                                    <button class=\"btn btn-medium btn-primary btn-main\"\n                                        translate=\"cw.general.ui.install\"\n                                        ng-click=\"subscriptionsCtrl.showService(licenseCode.relationships.app.data.id, licenseCode.id, currentTab, licenseCode.attributes.cmp === 'cobi2020avpro' ? 'cobi2020avpro' : '')\"\n                                        connectqa-subscriptions=\"install\">\n                                    </button>\n                                    <button class=\"btn btn-primary dropdown-toggle\"\n                                        ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                        ng-click=\"toggleDropdown=!toggleDropdown\"\n                                        connectqa-subscriptions=\"install-dropdown\"></button>\n                                    </button>\n                                    <ul class=\"dropdown-menu\"\n                                        ng-show=\"toggleDropdown\">\n                                        <li class=\"dropdown-item install-on-this-device\"\n                                            ng-click=\"subscriptionsCtrl.showService(licenseCode.relationships.app.data.id, licenseCode.id, currentTab, licenseCode.attributes.cmp === 'cobi2020avpro' ? 'cobi2020avpro' : '')\"\n                                        >\n                                            <i class=\"icon icon-Cloud\"></i>\n                                            <span translate=\"cw.install.on.current\"></span>\n                                        </li>\n                                        <li class=\"dropdown-item install-on-another-device\"\n                                            ng-click=\"subscriptionsCtrl.showService(licenseCode.relationships.app.data.id, licenseCode.id, currentTab, licenseCode.attributes.cmp === 'cobi2020avpro' ? 'cobi2020avpro' : '', 'other_device')\">\n                                            <i class=\"icon icon-devices\"></i>\n                                            <span translate=\"cw.deploy.modal.auto-install.button.primary-action\"></span>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                            <span ng-if=\"subscriptionsCtrl.getButtonAction(licenseCode) === 'open'\">\n                                <button class=\"btn btn-medium btn-primary\"\n                                        translate=\"cw.general.open\"\n                                        ng-click=\"subscriptionsCtrl.showService(licenseCode.relationships.app.data.id, licenseCode.id, currentTab)\"\n                                        connectqa-subscriptions=\"open\"\n                                ></button>\n                            </span>\n                        </li>\n                    </ul>\n                    <div ng-show=\"toggle && appIntegrations[licenseCode.relationships.app.data.id].attributes.type === 'bundle'\" class='included-products'>\n                        <ul>\n                            <li ng-repeat=\"app in appIntegrations[licenseCode.relationships.app.data.id].appComponents\"\n                                ng-hide=\"app.id.indexOf('aib0') > -1\">\n                                <img class=\"product-icon\" src=\"{{app.attributes.resource.wsLargeImageUrl}}\" alt=\"{{app.attributes.resource.oeName}}\" />\n                                <div class=\"inline-block\">\n                                    <div class=\"product-name\">{{app.attributes.resource.oeName}}</div>\n                                    <div ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                        class=\"os-icon icon icon-xxs icon-grey-4 icon-{{osType}}\">\n                                    </div>\n                                </div>\n                            </li>\n                            <li ng-show=\"licenseCode.relationships.app.data.id === 'aps10' || licenseCode.relationships.app.data.id === 'aps20'\">\n                                <img class=\"product-icon\" src=\"{{AppIntegrationsRepository.getById('adwp1').attributes.resource.wsLargeImageUrl}}\" alt=\"{{AppIntegrationsRepository.getById('adwp1').attributes.resource.oeName}}\" />\n                                <div class=\"inline-block\">\n                                    <div class=\"product-name\" translate=\"cw.dwm.tabs.dwm\"></div>\n                                    <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n                                        class=\"text-xs text-blue-1 bottom-link\"\n                                        translate=\"cw.subscriptions.see_details\"\n                                        ng-click=\"subscriptionsCtrl.sendMixpanelEventAIAPrimeDetails()\"></a>\n                                </div>\n                            </li>\n                        </ul>\n                    </div>\n                </li>\n                <!-- End Trial Licenses List -->\n            </ul>\n\n            <ul class=\"subscriptions\" connectqa-subscriptions=\"subscriptions-list\">\n                <!-- Subscriptions List-->\n                <li ng-repeat=\"activationCode in activationCodes\"\n                    ng-if=\"finalStepActivationWizard === false\"\n                    connectqa-subscriptions=\"{{appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName}}\"\n                    ng-init=\"toggle = false; toggleDropdown = false; toggleSubscriptionDetails = false;\"\n                    ng-class=\"{'hide-details' : !toggle}\"\n                    class=\"toggle-details\">\n                    <div class=\"activated\">\n                        <div class=\"box-shot-icon\" ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img src=\"{{appIntegrations[activationCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot}}\" />\n                        </div>\n                        <div class=\"icon-holder\" ng-if=\"!appIntegrations[activationCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img\n                                    ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    ng-src=\"{{appIntegrations[activationCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.type === 'bundle' && !appIntegrations[activationCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.type !== 'bundle' && !appIntegrations[activationCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n                        </div>\n\n                        <div class=\"header-wrapper v-middle inline-block\">\n                            <h1 class=\"text-xxl text-grey-3 inline-block v-middle\">\n                                {{appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName || 'Avira'}}\n                                <div ng-if=\"activationCode.attributes.promotion_id\n                                    && activationCode.attributes.promotion_cycles > 0\n                                    && activationCode.attributes.subscription === 1\n                                    && activationCode.attributes.promotion.attributes.discount > 0\"\n                                    class=\"discount-icon v-middle\">\n                                    <span class=\"inline-block w100\">%</span>\n                                    <div class='info-tooltip-holder ml5'>\n                                        <!-- prices order is switched, discountedPrice is fullPrice and vice versa -->\n                                        <!-- <div class=\"info-tooltip arrow-bottom text-center\"\n                                            translate=\"cw.subscription.discount_applied\"\n                                            ng-class=\"{'visible': $root.promotionsTooltips[activationCode.id]}\"\n                                            >\n                                        </div> -->\n                                        <div ng-if=\"activationCode.attributes.customInfo.showAnnual\"\n                                        class=\"info-tooltip arrow-bottom text-center\"\n                                        translate=\"cw.subscription.discount_applied_1\"\n                                        translate-values=\"{percent: activationCode.attributes.promotion.attributes.discount,\n                                            discountedPrice: activationCode.attributes.promotion.attributes.pc_price_string,\n                                            fullPrice: activationCode.attributes.promotion.attributes.total_price_string}\">\n                                        </div>\n                                        <div ng-if=\"activationCode.attributes.customInfo.showMonthly\"\n                                        translate=\"cw.subscription.discount_applied_monthly\"\n                                        class=\"info-tooltip arrow-bottom text-center\"\n                                        translate-values=\"{percent: activationCode.attributes.promotion.attributes.discount,\n                                            discountedPrice: activationCode.attributes.promotion.attributes.pc_price_string,\n                                            fullPrice: activationCode.attributes.promotion.attributes.total_price_string}\">\n                                        </div>\n                                    </div>\n                                </div>\n                            </h1>\n                            <span ng-if=\"licenses[activationCode.id].attributes.is_beta_otc === true\"\n                                class=\"label-large label-blue label-position-right mlr5 inline-block v-middle\"\n                                translate=\"cw.general.beta\">\n                            </span>\n                            <div class=\"os-wrap\"\n                                ng-show=\"appIntegrations[activationCode.relationships.app.data.id].attributes.type !== 'bundle' && activationCode.attributes.app !== 'adwp1'\"\n                                ng-class=\"right-icons\">\n                                <div ng-repeat=\"osType in appIntegrations[activationCode.relationships.app.data.id].attributes.custom.manifest.os\"\n                                    class=\"inline-block os-icon icon icon-xxs icon-grey-4 icon-{{osType}}\">\n                                </div>\n                            </div>\n                            <div>\n                                <div ng-show=\"$root.cmaGBapplies\">\n                                    <a class=\"show-more-button\"\n                                        connectqa-subscriptions=\"see-details-gb\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;subscriptionsCtrl.sendMixpanelEventDetailsButton(activationCode, toggle ? 'Seen details' : ' Close details');\n                                        $root.promotionsTooltips[activationCode.id] = false\"\n                                        ng-show=\"activationCode.attributes.app !== 'adwp1'\">\n                                        <span class=\"see-less-text\" translate=\"cw.subscriptions.cma.close_features\"></span>\n                                        <span class=\"see-more-text\" translate=\"cw.subscriptions.cma.see_features\"></span>\n                                    </a>\n                                </div>\n                                <div ng-show=\"!$root.cmaGBapplies\">\n\n                                    <a class=\"show-more-button\"\n                                        ng-show=\"!toggle\"\n                                        connectqa-subscriptions=\"see-details-row\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;toggleSubscriptionDetails=!toggleSubscriptionDetails;subscriptionsCtrl.sendMixpanelEventDetailsButton(activationCode, toggle ? 'Seen details' : ' Close details');\n                                        $root.promotionsTooltips[activationCode.id] = false\"\n                                        >\n                                            <span class=\"see-less-text\" translate=\"cw.subscriptions.hide_renewal_settings\">\n                                            </span>\n                                            <span class=\"see-more-text\" translate=\"cw.subscriptions.show_renewal_settings\">\n                                            </span>\n                                    </a>\n\n                                    <a class=\"show-more-button\"\n                                        ng-show=\"toggle\"\n                                        connectqa-subscriptions=\"close-details-row\"\n                                        ng-class=\"{'opened' : toggle, 'closed': !toggle}\"\n                                        ng-click=\"toggle=!toggle;toggleSubscriptionDetails=!toggleSubscriptionDetails;subscriptionsCtrl.sendMixpanelEventDetailsButton(activationCode, toggle ? 'Seen details' : ' Close details');\n                                        $root.promotionsTooltips[activationCode.id] = false\"\n                                        >\n                                            <span class=\"see-less-text\" translate=\"cw.subscriptions.hide_renewal_settings\">\n                                            </span>\n                                            <span class=\"see-more-text\" translate=\"cw.subscriptions.show_renewal_settings\">\n                                            </span>\n                                    </a>\n\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"installed-on fl-right\"\n                            ng-class=\"{'mt10' : !activationCode.attributes.customInfo.showExpirationNotification}\">\n                            <a class=\"show-dropdown single-device\"\n                                ng-class=\"[activationCode.attributes.customInfo.devices[0].attributes.type+'-'+activationCode.attributes.customInfo.devices[0].attributes.os]\"\n                                ng-show=\"activationCode.attributes.customInfo.devices.length == 1\"\n                                ui-sref=\"root.dashboard.device-details({resourceId: activationCode.attributes.customInfo.devices[0].id, tab: 'apps'})\"\n                                translate=\"cw.dashboard.services.installed_on_text\"\n                                translate-values=\"{systemprofilename : activationCode.attributes.customInfo.devices[0].attributes.alias || activationCode.attributes.customInfo.devices[0].attributes.name}\"\n                                title=\"{{activationCode.attributes.customInfo.devices[0].attributes.alias || activationCode.attributes.customInfo.devices[0].attributes.name}}\"\n                            >\n                            </a>\n                            <a class=\"show-dropdown\"\n                                ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                ng-show=\"activationCode.attributes.customInfo.devices.length > 1\"\n                                ng-click=\"toggleDropdown=!toggleDropdown\">\n                                <span translate=\"cw.subscriptions.multiple_install\"></span>\n                            </a>\n                            <span class=\"show-dropdown\"\n                                ng-show=\"!activationCode.attributes.customInfo.devices.length && activationCode.attributes.app !== 'adwp1'\">\n                                <span translate=\"cw.dashboard.device.not_installed\"></span>\n                            </span>\n\n                            <ul class=\"dropdown-devices\" ng-show=\"toggleDropdown\">\n                                <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                    <li ng-repeat=\"device in activationCode.attributes.customInfo.devices\" ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                                        <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}}\"></i>{{device.attributes.alias || device.attributes.name }}\n                                    </li>\n                                </div>\n                            </ul>\n                            <span ng-if=\"activationCode.attributes.status !== 'used' &&\n                                    !activationCode.attributes.customInfo.showExpirationNotification\"\n                                class=\"text-s device-status after size-l offline\"\n                                ng-class=\"{'padding-right' : activationCode.attributes.customInfo.devices.length > 1}\"\n                                translate=\"cw.general.inactive\"></span>\n                        </div>\n                    </div>\n\n                    <ul class=\"info-holder subscription-details\">\n                        <li ng-if=\"activationCode.attributes.subscription_type !== 'prepaid' && (activationCode.attributes.runtime === 12 || activationCode.attributes.runtime === 1)\" class=\"subscription-period\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.general.runtime\"></h6>\n                            <h5 connectqa-subscriptions=\"license-type\">\n                                <span\n                                    ng-if=\"activationCode.attributes.subscription_type === 'yearly' || activationCode.attributes.subscription_type === 'annual' || activationCode.attributes.subscription_type === 'annual-trial'\" translate=\"cw.subscriptions.cma.annual\">\n                                </span>\n                                <span\n                                    ng-if=\"activationCode.attributes.subscription_type === 'monthly' || activationCode.attributes.subscription_type === 'monthly-trial'\"\n                                    translate=\"cw.general.monthly\">\n                                </span>\n                            </h5>\n                        </li>\n                        <li ng-if=\"activationCode.attributes.subscription_type !== 'prepaid' && activationCode.attributes.runtime !== 1 && activationCode.attributes.runtime !== 12\" class=\"subscription-period\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.general.runtime\"></h6>\n                            <h5 connectqa-subscriptions=\"license-type\">\n                                <span\n                                    ng-if=\"activationCode.attributes.runtime % 12 !== 0\"\n                                    translate=\"cw.general.monthly_extended\"\n                                    translate-values=\"{interval: {{activationCode.attributes.runtime}}}\">\n                                </span>\n                                <span\n                                    ng-if=\"activationCode.attributes.runtime % 12 === 0\"\n                                    translate=\"cw.general.yearly_extended\"\n                                    translate-values=\"{interval: {{activationCode.attributes.runtime}} / 12}\">\n                                </span>\n                            </h5>\n                        </li>\n                        <!-- Autorenew toggle -->\n                        <li ng-if=\"activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                !activationCode.attributes.customInfo.isNonrenewableApp &&\n                                !isMobilePurchase(activationCode) &&\n                                !isVoucherPurchase(activationCode) &&\n                                !activationCode.removedPaymentOption &&\n                                isUsComplied(activationCode) &&\n                                !activationCode.attributes.customInfo.expiringToday\"\n                            class=\"p-relative subscription-toggle\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n                            <!-- <div class=\"switch-button v-middle crs-pointer\"\n                                    ng-class=\"{'enabled': activationCode.attributes.subscription !== 0}\"\n                                    ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" connectqa-subscriptions=\"toggle-subscription\">\n\n                                <span class=\"switch-knob\"></span>\n                            </div> -->\n\n                            <span class=\"subscription-toggle-link\">\n                                <span class=\"crs-pointer\" ng-if=\"activationCode.attributes.subscription === 1\" ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" translate=\"cw.subscriptions.cma.cancel\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                <span class=\"crs-pointer\" ng-if=\"activationCode.attributes.subscription === 0 && !$root.isMobileAppSession\" ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" translate=\"cw.subscriptions.cma.activate\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                <div class=\"info-tooltip-holder inline-block v-middle\">\n                                    <i class=\"icon icon-info\"></i>\n                                    <div class=\"info-tooltip arrow-left subscription-notification\"\n                                        translate=\"cw.subscriptions.cma.tooltip\"\n                                        translate-values=\"{\n                                            cancellation: '{{cancellationPolicy}}',\n                                            contact: '{{contactUs}}'\n                                        }\">\n                                    </div>\n                                </div>\n                            </span>\n                        </li>\n\n                        <!-- Renew for voucher -->\n                        <li ng-if=\"activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                !activationCode.attributes.customInfo.isNonrenewableApp &&\n                                !isMobilePurchase(activationCode) &&\n                                isVoucherPurchase(activationCode) &&\n                                !activationCode.removedPaymentOption &&\n                                isUsComplied(activationCode) &&\n                                !$root.isMobileAppSession\"\n                            class=\"p-relative subscription-toggle\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n\n                            <span class=\"subscription-toggle-link\">\n                                <span class=\"crs-pointer\" ng-if=\"activationCode.attributes.subscription === 0\" ng-click=\"subscriptionsCtrl.onRenewalClick(activationCode, 'Voucher')\" translate=\"cw.subscriptions.cma.activate\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                <div class=\"info-tooltip-holder inline-block v-middle\">\n                                    <i class=\"icon icon-info\"></i>\n                                    <div class=\"info-tooltip arrow-left subscription-notification\"\n                                        translate=\"cw.subscriptions.cma.tooltip\"\n                                        translate-values=\"{\n                                            cancellation: '{{cancellationPolicy}}',\n                                            contact: '{{contactUs}}'\n                                        }\">\n                                    </div>\n                                </div>\n                            </span>\n                        </li>\n                        <!-- End renew for voucher -->\n\n                        <!-- Disabled autorenew toggle for licenses without a valid payment type -->\n                        <li ng-if=\"activationCode.attributes.status === 'used' &&\n                            !activationCode.attributes.has_partner_id &&\n                            !activationCode.attributes.customInfo.isNonrenewableApp &&\n                            !isMobilePurchase(activationCode) &&\n                            !isVoucherPurchase(activationCode) &&\n                            activationCode.removedPaymentOption &&\n                            activationCode.attributes.subscription === 0 &&\n                            !$root.isMobileAppSession\"\n                            class=\"subscription-toggle\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <div class=\"knob-holder\">\n                                <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n                                <span class=\"subscription-toggle-link\">\n                                    <span class=\"crs-pointer\" ng-click=\"subscriptionsCtrl.onRenewalClick(activationCode, 'Credit card deleted')\" translate=\"cw.subscriptions.cma.activate\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                                        <i class=\"icon icon-info\"></i>\n                                        <div class=\"info-tooltip arrow-left subscription-notification\"\n                                            translate=\"cw.subscriptions.cma.tooltip\"\n                                            translate-values=\"{\n                                                cancellation: '{{cancellationPolicy}}',\n                                                contact: '{{contactUs}}'\n                                            }\">\n                                        </div>\n                                    </div>\n                                </span>\n                            </div>\n                            <!-- <div class='info-tooltip-holder'>\n                                <div class=\"info-tooltip arrow-bottom\"\n                                    translate=\"cw.subscriptions.tooltip.missing_payment_details\">\n                                </div>\n                            </div> -->\n                        </li>\n\n                        <li ng-if=\"activationCode.attributes.status === 'used' &&\n                            !activationCode.attributes.has_partner_id &&\n                            !activationCode.attributes.customInfo.isNonrenewableApp &&\n                            !isMobilePurchase(activationCode) &&\n                            !isVoucherPurchase(activationCode) &&\n                            activationCode.removedPaymentOption &&\n                            activationCode.attributes.subscription === 1\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <div class=\"knob-holder\">\n                                <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n                                <span class=\"subscription-toggle-link\">\n                                    <span class=\"crs-pointer\" ng-if=\"activationCode.attributes.subscription === 1\" ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" translate=\"cw.subscriptions.cma.cancel\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                    <span class=\"crs-pointer\" ng-if=\"activationCode.attributes.subscription === 0\" ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" translate=\"cw.subscriptions.cma.activate\" connectqa-subscriptions=\"toggle-subscription\"></span>\n                                    <div class=\"info-tooltip-holder inline-block v-middle\">\n                                        <i class=\"icon icon-info\"></i>\n                                        <div class=\"info-tooltip arrow-left subscription-notification\"\n                                            translate=\"cw.subscriptions.cma.tooltip\"\n                                            translate-values=\"{\n                                                cancellation: '{{cancellationPolicy}}',\n                                                contact: '{{contactUs}}'\n                                            }\">\n                                        </div>\n                                    </div>\n                                </span>\n                            </div>\n                        </li>\n\n                        <!--Disabled autorenew toggle for business products-->\n                        <li ng-if=\"(activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                activationCode.attributes.app.indexOf('aib0') === -1 &&\n                                isBusinessProduct(activationCode) &&\n                                !activationCode.removedPaymentOption) ||\n                                !isUsComplied(activationCode)\"\n                                class=\"disabled-toggle\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n\n                            <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n                            <span class=\"subscription-toggle-link\">\n                                <span ng-if=\"activationCode.attributes.subscription === 0\" translate=\"cw.subscriptions.cma.activate\"></span>\n                                <div class=\"info-tooltip-holder inline-block v-middle\">\n                                    <i class=\"icon icon-info\"></i>\n                                    <!-- <div class=\"info-tooltip arrow-left subscription-notification\"\n                                        translate=\"cw.subscriptions.cma.tooltip\"\n                                        translate-values=\"{\n                                            cancellation: '{{cancellationPolicy}}',\n                                            contact: '{{contactUs}}'\n                                        }\">\n                                    </div> -->\n                                </div>\n                            </span>\n                            <div class='info-tooltip-holder'>\n                                <div class=\"info-tooltip arrow-bottom\" translate=\"cw.subscriptions.autorenew_disabled\"></div>\n                            </div>\n                        </li>\n\n                        <!--Hide autorenew toggle for subscription managed by Google/Apple-->\n                        <li ng-if=\"activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                activationCode.attributes.app.indexOf('aib0') === -1 &&\n                                isMobilePurchase(activationCode)\"\n                                class=\"subscription-toggle\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <div>\n                                <h6 translate=\"cw.subscriptions.cma.subscription_renewal\"></h6>\n                                <div>\n                                    <span class=\"text-m mr5 inline-block v-middle\" translate=\"cw.subscriptions.mobile_subscription_desc\"></span>\n                                    <div class='info-tooltip-holder show-tooltip v-middle'>\n                                        <i class=\"icon icon-info icon-xxs icon-blue-2 v-middle inline-block\"></i>\n                                        <div class=\"info-tooltip arrow-bottom mobile-license-info\"\n                                            translate=\"cw.subscriptions.mobile_subscription_tooltip_2\"\n                                            translate-values=\"{infoLink: mobileAppInfoLink}\"></div>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </li>\n\n                        <li ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <span>\n                                <h6 ng-if=\"activationCode.attributes.subscription === 0\" translate=\"cw.subscriptions.cma.expires_on\"></h6>\n                                <h6 ng-if=\"activationCode.attributes.subscription === 1\" translate=\"cw.subscriptions.cma.renews_on\"></h6>\n                                <h5 connectqa-subscriptions=\"expiry-date\">{{activationCode.attributes.customInfo.formatted_date_expire}}</h5>\n                            </span>\n                        </li>\n                        <!-- Hide next renewal date if the app was purchased from Google or Apple -->\n                        <li ng-if=\"activationCode.attributes.subscription !== 0 &&\n                            activationCode.attributes.status === 'used' &&\n                            !isMobilePurchase(activationCode) &&\n                            (activationCode.attributes.next_billing_event | dateInMiliseconds) > subscriptionsCtrl.currentDateInMiliseconds\" ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <span>\n                                <h6 translate=\"cw.subscriptions.cma.charged_on\"></h6>\n                                <h5 connectqa-subscriptions=\"next-renewal\">\n                                    <span class=\"inline-block v-top\">{{activationCode.attributes.customInfo.formatted_next_billing_event}}</span>\n                                </h5>\n                            </span>\n                        </li>\n                        <li ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 0\"\n                            ng-class=\"{'short-view-width': !toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1}\"\n                        >\n                            <h6 translate=\"cw.menu.devices\"></h6>\n                            <h5 ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.unit_type === 'device' || subscriptionsCtrl.hardcodeDeviceLicenseType(activationCode.relationships.app.data.id) === true\" connectqa-subscriptions=\"max-activations\">\n                                <span ng-if=\"activationCode.attributes.max_activations === 1 && !subscriptionsCtrl.hardcodeDevicesNumber(activationCode.relationships.app.data.id)\"\n                                        translate=\"cw.general.devices.one\"></span>\n                                <span ng-if=\"activationCode.attributes.max_activations > 1 && !subscriptionsCtrl.hardcodeDevicesNumber(activationCode.relationships.app.data.id)\"\n                                        translate=\"cw.general.devices.many\"\n                                        translate-values=\"{total: activationCode.attributes.max_activations}\"></span>\n                                <span ng-if=\"subscriptionsCtrl.hardcodeDevicesNumber(activationCode.relationships.app.data.id)\"\n                                    translate=\"cw.general.devices.many\"\n                                    translate-values=\"{total: subscriptionsCtrl.hardcodeDevicesNumber(activationCode.relationships.app.data.id)}\"></span>\n                            </h5>\n\n                            <h5 ng-if=\"appIntegrations[activationCode.relationships.app.data.id].attributes.unit_type !== 'device' && subscriptionsCtrl.hardcodeDeviceLicenseType(activationCode.relationships.app.data.id) === false\" connectqa-subscriptions=\"max-activations\">\n                                <span ng-if=\"activationCode.attributes.max_activations === 1\" translate=\"cw.general.one_user\"></span>\n                                <span ng-if=\"activationCode.attributes.max_activations > 1\"\n                                        translate=\"cw.general.count_users\"\n                                        translate-values=\"{number: activationCode.attributes.max_activations}\">\n                                </span>\n                            </h5>\n                        </li>\n                        <li class=\"key-section\"\n                            ng-hide=\"!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 0\"\n                            ng-class=\"{'short-view-width': !toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1}\"\n                        >\n                            <div ng-if='activationCode.attributes.customInfo.transactionId &&\n                                        !isMobilePurchase(activationCode)'>\n                                <h6 translate=\"cw.general.reference\"></h6>\n                                <h5 class=\"inline-block v-middle\" connectqa-subscriptions=\"transaction-id\">\n                                    {{activationCode.attributes.customInfo.transactionId}}\n                                </h5>\n                            </div>\n                        </li>\n\n                        <li class=\"key-section w30\" ng-if=\"!$root.cmaGBapplies && activationCode.attributes.subscription === 0\" ng-hide=\"toggleSubscriptionDetails && !$root.cmaGBapplies\">\n                            <div>\n                                <h6 translate=\"cw.subscriptions.subscription_expires_in\"></h6>\n                                <h5 class=\"inline-block v-middle\" connectqa-subscriptions=\"transaction-id\">\n                                    {{activationCode.attributes.customInfo.remainingDaysUntilExpiration}}\n                                    <span ng-if=\"activationCode.attributes.customInfo.remainingDaysUntilExpiration === 1\" translate=\"cw.general.day\"></span>\n                                    <span ng-if=\"activationCode.attributes.customInfo.remainingDaysUntilExpiration > 1\" translate=\"cw.general.days\"></span>\n                                </h5>\n                            </div>\n                        </li>\n\n                        <li class=\"key-section short-view-width short-view-custom\"\n                            ng-show=\"!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1\"\n                        >\n                            <span>\n                                <h6 ng-if=\"activationCode.attributes.subscription === 0\" translate=\"cw.subscriptions.cma.expires_on\"></h6>\n                                <h6 ng-if=\"activationCode.attributes.subscription === 1\" translate=\"cw.subscriptions.cma.renews_on\"></h6>\n                                <h5 connectqa-subscriptions=\"expiry-date\">{{activationCode.attributes.customInfo.formatted_date_expire}}</h5>\n                            </span>\n                        </li>\n\n                        <li class=\"button-section\"\n                            ng-class=\"{\n                                    'full-width': (subscriptionsCtrl.checkStaticOTC(activationCode) && $root.cmaGBapplies) || (!toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1) || (subscriptionsCtrl.checkStaticOTC(activationCode) && !$root.cmaGBapplies && toggleSubscriptionDetails) || (!$root.cmaGBapplies && isMobilePurchase(activationCode)) || (activationCode.attributes.customInfo.expiringToday && toggleSubscriptionDetails) || (activationCode.attributes.customInfo.expiringToday && $root.cmaGBapplies),\n                                    'subscription-off': activationCode.attributes.subscription === 0 || (activationCode.attributes.next_billing_event | dateInMiliseconds) < subscriptionsCtrl.currentDateInMiliseconds,\n                                    'full-width-voucher': (isVoucherPurchase(activationCode) || isMobilePurchase(activationCode)) && $root.cmaGBapplies,\n                                    'detailes-hidden': !toggleSubscriptionDetails && !$root.cmaGBapplies,\n                                    'inline-width': !toggleSubscriptionDetails && !$root.cmaGBapplies && activationCode.attributes.subscription === 1,\n                                }\">\n\n\n                            <span class=\"crs-pointer btn btn-medium btn-orange\"\n                                ng-if=\"!$root.cmaGBapplies &&\n                                activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                !activationCode.attributes.customInfo.isNonrenewableApp &&\n                                !isMobilePurchase(activationCode) &&\n                                isVoucherPurchase(activationCode) &&\n                                !activationCode.removedPaymentOption &&\n                                isUsComplied(activationCode) &&\n                                !$root.isMobileAppSession\" ng-click=\"subscriptionsCtrl.onRenewalClick(activationCode, 'Voucher')\" translate=\"cw.subscriptions.cma.activate\">Activate Subscription Renewal</span>\n\n                            <span class=\"crs-pointer btn btn-medium btn-orange\"\n                                ng-if=\"activationCode.attributes.subscription === 0 &&\n                                    !$root.cmaGBapplies &&\n                                    !isBusinessProduct(activationCode) &&\n                                    !activationCode.attributes.has_partner_id &&\n                                    !activationCode.attributes.customInfo.isNonrenewableApp &&\n                                    !isMobilePurchase(activationCode) &&\n                                    !isVoucherPurchase(activationCode) &&\n                                    !activationCode.removedPaymentOption &&\n                                    isUsComplied(activationCode) &&\n                                    !activationCode.attributes.customInfo.expiringToday &&\n                                    !$root.isMobileAppSession\" ng-click=\"subscriptionsCtrl.subscriptionToggle(activationCode, 'Expanded view')\" translate=\"cw.subscriptions.cma.activate\">Activate Subscription Renewal</span>\n\n                            <span class=\"crs-pointer btn btn-medium btn-orange\"\n                                ng-if=\"!$root.cmaGBapplies &&\n                                activationCode.attributes.status === 'used' &&\n                                !activationCode.attributes.has_partner_id &&\n                                !activationCode.attributes.customInfo.isNonrenewableApp &&\n                                !isMobilePurchase(activationCode) &&\n                                !isVoucherPurchase(activationCode) &&\n                                activationCode.removedPaymentOption &&\n                                activationCode.attributes.subscription === 0 &&\n                                !$root.isMobileAppSession\" ng-click=\"subscriptionsCtrl.onRenewalClick(activationCode, 'Credit card deleted')\" translate=\"cw.subscriptions.cma.activate\">Activate Subscription Renewal</span>\n\n                            <div ng-if=\"subscriptionsCtrl.getButtonAction(activationCode) === 'install' && $root.hasUsCompliance\"\n                                class=\"inline-block ml20 install-btn-dropdown\"\n                                ng-init=\"toggleDropdown = false;\">\n\n                                <div class=\"info-tooltip-holder\"\n                                    ng-if=\"$root.ocpSubscriptionTooltipAppId === activationCode.attributes.app && deviceOs === 'osx'\">\n                                    <div class=\"info-tooltip arrow-right\" connectqa-subscriptions=\"tooltip\">\n                                        <p class=\"text-s\" translate=\"cw.subscriptions.product_ready.title\" connectqa-subscriptions=\"tooltip-title\"></p>\n                                        <p class=\"text-xs text-grey-5\"  translate=\"cw.subscriptions.subscription_ready.description\" translate-values=\"{product: appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName || 'Avira'}\" connectqa-subscriptions=\"tooltip-description\"></p>\n                                    </div>\n                                </div>\n\n                                <div class=\"info-tooltip-holder\"\n                                    ng-if=\"switchedToMonthlyTooltips[activationCode.id] === true && activationCode.attributes.subscription === 1\">\n                                    <div class=\"info-tooltip arrow-right\" connectqa-subscriptions=\"tooltip\">\n                                        <p class=\"text-xs\" translate=\"cw.subscription.unsubscribe_modal.options_modal.success.desc\"\n                                            translate-values=\"{date:  activationCode.attributes.customInfo.formatted_next_billing_event }\"></p>\n                                    </div>\n                                </div>\n                                <div class=\"btn-group\">\n                                    <button class=\"btn btn-medium btn-primary btn-main\"\n                                        translate=\"cw.general.ui.install\"\n                                        ng-click=\"subscriptionsCtrl.showService(activationCode.relationships.app.data.id, activationCode.id)\"\n                                        connectqa-subscriptions=\"install\">\n                                    </button>\n                                    <button class=\"btn btn-primary dropdown-toggle\"\n                                        ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                                        ng-click=\"toggleDropdown=!toggleDropdown\"\n                                        connectqa-subscriptions=\"install-dropdown\"></button>\n                                    </button>\n                                    <ul class=\"dropdown-menu\"\n                                        ng-show=\"toggleDropdown\">\n                                        <li class=\"dropdown-item install-on-this-device\"\n                                            ng-click=\"toggleDropdown=!toggleDropdown; subscriptionsCtrl.showService(activationCode.relationships.app.data.id, activationCode.id)\"\n                                        >\n                                            <i class=\"icon icon-Cloud\"></i>\n                                            <span translate=\"cw.install.on.current\"></span>\n                                        </li>\n                                        <li class=\"dropdown-item install-on-another-device\"\n                                            ng-click=\"toggleDropdown=!toggleDropdown; subscriptionsCtrl.showService(activationCode.relationships.app.data.id, activationCode.id,'','', 'other_device')\">\n                                            <i class=\"icon icon-devices\"></i>\n                                            <span translate=\"cw.deploy.modal.auto-install.button.primary-action\"></span>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                            <div ng-if=\"activationCode.attributes.app === 'adwp1'\" class=\"inline-block ml20 open-aia-button-wrapper\">\n                                <a class=\"btn btn-medium btn-primary btn-main\" ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n                                    translate=\"cw.general.open\"></a>\n                            </div>\n                        </li>\n                    </ul>\n\n                    <div ng-show=\"toggle && appIntegrations[activationCode.relationships.app.data.id].attributes.type === 'bundle'\" class='included-products'>\n                        <ul>\n                            <li ng-repeat=\"app in appIntegrations[activationCode.relationships.app.data.id].appComponents\"\n                                ng-hide=\"app.id.indexOf('aib0') > -1\">\n                                <img class=\"product-icon\" src=\"{{app.attributes.resource.wsLargeImageUrl}}\" alt=\"{{app.attributes.resource.oeName}}\" />\n                                <div class=\"inline-block\">\n                                    <div class=\"product-name\">{{app.attributes.resource.oeName}}</div>\n                                    <div ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                        class=\"os-icon icon icon-xxs icon-grey-4 icon-{{osType}}\">\n                                    </div>\n                                </div>\n                            </li>\n                            <li ng-show=\"activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20'\">\n                                <img class=\"product-icon\" src=\"{{AppIntegrationsRepository.getById('adwp1').attributes.resource.wsLargeImageUrl}}\" alt=\"{{AppIntegrationsRepository.getById('adwp1').attributes.resource.oeName}}\" />\n                                <div class=\"inline-block\">\n                                    <div class=\"product-name\" translate=\"cw.dwm.tabs.dwm\"></div>\n                                    <a ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\"\n                                        class=\"text-xs text-blue-1 bottom-link\"\n                                        translate=\"cw.subscriptions.see_details\"\n                                        ng-click=\"subscriptionsCtrl.sendMixpanelEventAIAPrimeDetails()\"></a>\n                                </div>\n                            </li>\n                        </ul>\n                    </div>\n                </li>\n                <!-- End -->\n            </ul>\n\n        </div>\n\n        <div ng-if=\"currentTab === 'plans'\">\n            <div id=\"expired-subscriptions-anchor\"></div>\n            <h2 class=\"mt50 mb20 text-xxl text-grey-1 subscriptions-section-title\" ng-if=\"expiredLicenses.length > 0\" translate=\"cw.subscriptions.tab_expired\"></h2>\n            <ul class=\"subscriptions\" connectqa-subscriptions=\"expired-subscriptions-list\">\n                <li ng-repeat=\"licenseCode in expiredLicenses\"\n                    connectqa-subscriptions=\"{{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.oeName}}\"\n                    class=\"expired-subscription\">\n                    <div class=\"activated\">\n                        <div class=\"box-shot-icon no-pending\" ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\"\n                                    ng-src=\"{{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n\n                            <img\n                                    ng-if=\"!appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\"\n                                    src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n                        </div>\n                        <div class=\"icon-holder no-pending\" ng-if=\"!appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.cwStoreBoxshot\">\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    ng-src=\"{{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.type === 'bundle' && !appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                            <img\n                                    ng-if=\"appIntegrations[licenseCode.relationships.app.data.id].attributes.type !== 'bundle' && !appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.wsLargeImageUrl\"\n                                    src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n                        </div>\n\n                        <div class=\"header-wrapper v-middle inline-block\">\n                            <h1 class=\"text-xxl text-grey-3 inline-block v-middle\">\n                                {{appIntegrations[licenseCode.relationships.app.data.id].attributes.resource.oeName || 'Avira'}}\n                            </h1>\n                        </div>\n                    </div>\n\n                    <ul class=\"info-holder\">\n                        <li class=\"key-section\">\n                            <div class=\"inline-block v-top w40\">\n                                <h6 translate=\"cw.general.runtime\"></h6>\n                                <h5 connectqa-subscriptions=\"license-type\">\n                                    <!-- Yearly subscriptions (including otc) -->\n                                    <span\n                                        ng-if=\"(licenseCode.attributes.subscription_type === 'yearly' && licenseCode.attributes.type !== 'eval') ||\n                                                (licenseCode.attributes.subscription_type === 'annual' && licenseCode.attributes.runtime === 12) ||\n                                                (licenseCode.attributes.subscription_type === 'prepaid' && licenseCode.attributes.runtime === 12)\" translate=\"cw.subscriptions.cma.annual\">\n                                    </span>\n                                    <!-- Monthly subscriptions (including otc) -->\n                                    <span\n                                        ng-if=\"licenseCode.attributes.subscription_type === 'monthly' ||\n                                            (licenseCode.attributes.subscription_type === 'prepaid' && licenseCode.attributes.runtime === 1)\"\n                                        translate=\"cw.general.monthly\">\n                                    </span>\n                                    <!-- Multiple months -->\n                                    <span\n                                        ng-if=\"licenseCode.attributes.subscription_type === 'annual' && licenseCode.attributes.runtime !== 1 &&\n                                            licenseCode.attributes.runtime !== 12 && licenseCode.attributes.runtime % 12 !== 0\"\n                                        translate=\"cw.general.monthly_extended\"\n                                        translate-values=\"{interval: {{licenseCode.attributes.runtime}}}\">\n                                    </span>\n                                    <!-- Multiple years -->\n                                    <span\n                                        ng-if=\"licenseCode.attributes.subscription_type === 'annual' && licenseCode.attributes.runtime !== 1 &&\n                                            licenseCode.attributes.runtime !== 12 && licenseCode.attributes.runtime % 12 === 0\"\n                                        translate=\"cw.general.yearly_extended\"\n                                        translate-values=\"{interval: {{licenseCode.attributes.runtime}} / 12}\">\n                                    </span>\n                                    <!-- Trial licenses -->\n                                    <span\n                                        ng-if=\"licenseCode.attributes.type === 'eval' && !licenseCode.attributes.cmp\"\n                                        translate=\"cw.general.monthly\">\n                                    </span>\n                                    <!-- Cobi trial license -->\n                                    <span\n                                        ng-if=\"licenseCode.attributes.type === 'eval' && licenseCode.attributes.cmp === 'cobi2020avpro'\" translate=\"cw.subscriptions.cma.annual\">\n                                    </span>\n                                </h5>\n                            </div>\n\n                            <div class=\"inline-block v-top w40\"\n                                ng-if=\"licenseCode.attributes.type ==='paid' && licenseCode.attributes.subscription_type !== 'prepaid' &&\n                                    licenseCode.attributes.transactionId\">\n                                <span>\n                                    <h6 translate=\"cw.general.reference\"></h6>\n                                    <h5 connectqa-subscriptions=\"transaction-id\">{{licenseCode.attributes.transactionId}}</h5>\n                                </span>\n                            </div>\n                        </li>\n\n                        <li ng-if=\"$root.hasUsCompliance && !$root.isMobileAppSession\" class=\"button-section top-margin\">\n                            <a\n                                class=\"btn btn-medium btn-primary\"\n                                ng-click=\"subscriptionsCtrl.goToStore('ConnectWeb Subscriptions View Offers Click')\"\n                                translate=\"cw.subscriptions.view_new_offers\"\n                                connectqa-subscriptions=\"view-new-offers\">\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n\n        </div>\n\n        <div ng-if=\"currentTab === 'otc'\">\n            <!-- Activation section -->\n            <ul class=\"subscriptions\">\n                <li class=\"text-center\"\n                    connectqa-subscriptions=\"add-more-subscriptions\">\n\n                    <div class=\"success-screen\" ng-if=\"successAnimation === true\">\n                        <div class=\"subscription-pic active\" ></div>\n                        <h4 class=\"text-l text-grey-4\"\n                            translate=\"cw.subscription.activation_success_desc\"\n                            translate-values=\"{appName: appName}\"\n                        ></h4>\n                    </div>\n\n                    <div ng-show=\"successAnimation === false\">\n                        <div ng-if=\"activationCodes.length && finalStepActivationWizard === false\">\n                            <h3 class=\"text-xxl mb10\" translate=\"cw.subscriptions.add_more\" ></h3>\n                            <h4 class=\"text-l text-grey-3 mb20\" translate=\"cw.subscriptions.activate_desc\"></h4>\n                        </div>\n\n                        <div ng-if=\"!activationCodes.length ||\n                                    (activationCodes.length === 1 && finalStepActivationWizard === true)\">\n\n                            <!-- show the image for no paid plans when the user has at least a trial license -->\n                            <div ng-if=\"finalStepActivationWizard === false\">\n                                <div class=\"subscription-pic inactive\"></div>\n                                <h3 class=\"text-xxl mb10\" translate=\"cw.subscription.no_subscriptions\"></h3>\n                                <h4 class=\"text-l text-grey-2 mb20\" translate=\"cw.subscription.no_subscriptions_desc\"></h4>\n                            </div>\n\n                            <div ng-if=\"finalStepActivationWizard === true\">\n                                <div class=\"subscription-pic active\"></div>\n                                <h3 class=\"text-xxl mb10\" ng-if=\"!isStaticOTC\" translate=\"cw.subscription.activation_success\"></h3>\n                                <h4 class=\"text-l text-grey-4 mb20\"\n                                    translate=\"cw.subscription.activation_success_desc\"\n                                    translate-values=\"{appName: appName}\"\n                                ></h4>\n                            </div>\n                        </div>\n\n                        <div class=\"mb20\">\n                            <span class=\"activation-input\"\n                                ng-class=\"{'error': activationStatus === 'error' || activationStatus === 'serverError'}\">\n                                <input type=\"text\" ng-model=\"inputActivationCode\"\n                                    id=\"activation\"\n                                    maxlength=\"29\"\n                                    placeholder=\"00000-00000-00000-00000-00000\"\n                                    ng-disabled=\"activationStatus === 'success' && finalStepActivationWizard === true\"\n                                    ng-focus=\"subscriptionsCtrl.resetActivationStatus()\" connectqa-subscriptions=\"activation-input\"/>\n\n                                <label for=\"activation\" class=\"fallback-input\" ng-if=\"!inputActivationCode\">00000-00000-00000-00000-00000</label>\n                                <p class=\"error-message\" ng-if=\"activationStatus === 'error'\" translate=\"cw.subscription.error.status_code_invalid\"></p>\n                                <p class=\"error-message\" ng-if=\"activationStatus === 'serverError'\">{{serverErrorTranslate | translate}}</p>\n                            </span>\n\n                            <button class=\"inline-block v-top btn btn-primary btn-large mb10\"\n                                    translate=\"cw.subscriptions.activate_license\"\n                                    ng-disabled=\"loadingButton\"\n                                    ng-hide=\"activationStatus === 'success' && finalStepActivationWizard === true\"\n                                    ng-click=\"subscriptionsCtrl.activateSubscription(inputActivationCode)\" connectqa-subscriptions=\"activate-license\"></button>\n                        </div>\n\n                        <button class=\"btn btn-secondary btn-large\"\n                                translate=\"cw.general.fixed_it\"\n                                ng-if=\"activationStatus === 'success' && finalStepActivationWizard === true\"\n                                ng-click=\"subscriptionsCtrl.closeActivationWizard()\"\n                                connectqa-subscriptions=\"confirm-license\"></button>\n\n                        <a ng-if=\"!$root.isMobileAppSession\"\n                           ng-click=\"subscriptionsCtrl.goToStore('ConnectWeb My Subscriptions Store Click')\"\n                           class=\"text-xl text-blue-3 underline crs-pointer\"\n                           ng-hide=\"activationStatus === 'success' && finalStepActivationWizard === true\"\n                           translate=\"cw.subscriptions.more_offers\" connectqa-subscriptions=\"store-link\"></a>\n                    </div>\n                </li>\n                <!-- End -->\n            </ul>\n        </div>\n\n        <!-- Transactions History section -->\n        <div ng-if=\"currentTab === 'history'\">\n\n            <ul class=\"subscriptions text-center\">\n\n                <li class=\"history-holder\">\n                    <div class=\"history-table-header\" ng-if=\"transactions.length > 0\">\n                        <div class=\"column product\" translate=\"cw.general.ui.product\"></div>\n                        <div class=\"column\" translate=\"cw.general.reference\"></div>\n                        <div class=\"column\" translate=\"cw.general.order_date\"></div>\n                        <div class=\"column subscription-period\" translate=\"cw.general.runtime\"></div>\n                        <div class=\"column\" translate=\"cw.my_devices.system_info.disk_space.total\"></div>\n                        <div class=\"column\" translate=\"cw.subscriptions.receipt\"></div>\n                    </div>\n\n                    <div class=\"history-table\">\n                        <div class=\"transaction\" ng-repeat=\"transaction in transactions\"\n                            connectqa-subscriptions=\" {{AppIntegrationsRepository.getById(transaction.relationships.app.data.id).attributes.resource.oeName}}\">\n                            <div class=\"column product\" connectqa-subscriptions=\"product\">\n                                {{AppIntegrationsRepository.getById(transaction.relationships.app.data.id).attributes.resource.oeName}}\n                            </div>\n                            <!-- The transaction-id cell will be empty if transaction is from GOOGLE or APPLE -->\n                            <div ng-if=\"!(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\"\n                                class=\"column\" connectqa-subscriptions=\"transaction-id\">{{transaction.attributes.payment_transaction_id}}</div>\n                            <div class=\"column\"\n                                ng-if=\"(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\"\n                                connectqa-subscriptions=\"transaction-id\">\n                                <span>---</span>\n                            </div>\n                            <div class=\"column\" connectqa-subscriptions=\"order-date\">{{transaction.attributes.formatted_date_create}}</div>\n                            <div ng-if=\"transaction.attributes.runtime === 12 || transaction.attributes.runtime === 1\" class=\"column subscription-period\" connectqa-subscriptions=\"subscription-type\">\n                                <span\n                                    ng-if=\"transaction.attributes.subscription_type === 'yearly' || transaction.attributes.subscription_type === 'annual'\" translate=\"cw.subscriptions.cma.annual\">\n                                </span>\n                                <span\n                                    ng-if=\"transaction.attributes.subscription_type === 'monthly' || transaction.attributes.subscription_type === 'monthly-trial'\"\n                                    translate=\"cw.general.monthly\">\n                                </span>\n                            </div>\n                            <div ng-if=\"transaction.attributes.runtime !== 1 && transaction.attributes.runtime !== 12\" class=\"column subscription-period\" connectqa-subscriptions=\"subscription-type\">\n                                <span\n                                    ng-if=\"transaction.attributes.runtime % 12 !== 0\"\n                                    translate=\"cw.general.monthly_extended\"\n                                    translate-values=\"{interval: {{transaction.attributes.runtime}}}\">\n                                </span>\n                                <span\n                                    ng-if=\"transaction.attributes.runtime % 12 === 0\"\n                                    translate=\"cw.general.yearly_extended\"\n                                    translate-values=\"{interval: {{transaction.attributes.runtime}} / 12}\">\n                                </span>\n                            </div>\n                            <div class=\"column\" connectqa-subscriptions=\"price\">{{transaction.attributes.price}} {{transaction.attributes.currency}}</div>\n                            <!-- The receipt cell will be empty if transaction is from GOOGLE or APPLE -->\n                            <div class=\"column\"\n                                ng-if=\"!(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\"\n                                connectqa-subscriptions=\"receipt\">\n                                <a ng-if=\"transaction.attributes.invoice_url\" ng-href=\"{{transaction.attributes.invoice_url}}\" translate=\"cw.general.download_pdf\" class=\"text-blue-3\" target=\"_blank\"></a>\n                                <span ng-if=\"!transaction.attributes.invoice_url\">\n                                    <span translate=\"cw.general.ui.pending\"></span>\n                                    <a class=\"icon icon-refresh icon-xxs icon-blue-3 ml5 inline-block crs-pointer\" ng-click=\"subscriptionsCtrl.refreshTransactions()\"\n                                    ng-if=\"refreshRequests < 5\"\n                                    ng-class=\"{ 'icon-grey-4': refreshLoader }\"></a>\n                                </span>\n                            </div>\n                            <div class=\"column text-center\"\n                                ng-if=\"(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\"\n                                connectqa-subscriptions=\"receipt\">\n                                <span>---</span>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n\n                <li class=\"history-holder-mobile\">\n                    <div class=\"history-table-mobile\">\n                        <div class=\"transaction card\" ng-repeat=\"transaction in transactions\" ng-init=\"toggleMobile = ($index === 0)\" connectqa-subscriptions=\" {{AppIntegrationsRepository.getById(transaction.relationships.app.data.id).attributes.resource.oeName}}\">\n                            <div class=\"table-line\" ng-click=\"toggleMobile=!toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.general.ui.product\"></span><span>: </span></div>\n                                <div class=\"value\" connectqa-subscriptions=\"product\">{{AppIntegrationsRepository.getById(transaction.relationships.app.data.id).attributes.resource.oeName}}</div>\n                                <a class=\"details-button\" connectqa-subscriptions=\"see-details\" ng-class=\"{'opened' : toggleMobile, 'closed': !toggleMobile}\"></a>\n                            </div>\n                            <div class=\"table-line\" ng-show=\"toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.general.reference\"></span><span>: </span></div>\n                                <div class=\"value\" connectqa-subscriptions=\"transaction-id\">{{transaction.attributes.payment_transaction_id}}</div>\n                                <div class=\"value\" ng-if=\"(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\" connectqa-subscriptions=\"transaction-id\">\n                                    <span>---</span>\n                                </div>\n                            </div>\n                            <div class=\"table-line\" ng-show=\"toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.general.order_date\"></span><span>: </span></div>\n                                <div class=\"value\" connectqa-subscriptions=\"order-date\">{{transaction.attributes.formatted_date_create}}</div>\n                            </div>\n                            <div class=\"table-line\" ng-show=\"toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.general.runtime\"></span><span>: </span></div>\n                                <div class=\"value\" ng-if=\"transaction.attributes.runtime === 12 || transaction.attributes.runtime === 1\"  connectqa-subscriptions=\"subscription-type\">\n                                    <div ng-if=\"transaction.attributes.subscription_type === 'yearly' || transaction.attributes.subscription_type === 'annual'\" translate=\"cw.subscriptions.cma.annual\"></div>\n                                    <div ng-if=\"transaction.attributes.subscription_type === 'monthly' || transaction.attributes.subscription_type === 'monthly-trial'\" translate=\"cw.general.monthly\" ></div>\n                                </div>\n                                <div class=\"value\" ng-if=\"transaction.attributes.runtime !== 1 && transaction.attributes.runtime !== 12\"  connectqa-subscriptions=\"subscription-type\">\n                                    <span\n                                        ng-if=\"transaction.attributes.runtime % 12 !== 0\"\n                                        translate=\"cw.general.monthly_extended\"\n                                        translate-values=\"{interval: {{transaction.attributes.runtime}}}\">\n                                    </span>\n                                    <span\n                                        ng-if=\"transaction.attributes.runtime % 12 === 0\"\n                                        translate=\"cw.general.yearly_extended\"\n                                        translate-values=\"{interval: {{transaction.attributes.runtime}} / 12}\">\n                                    </span>\n                                </div>\n                            </div>\n                            <div class=\"table-line\" ng-show=\"toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.my_devices.system_info.disk_space.total\"></span><span>: </span></div>\n                                <div class=\"value\" connectqa-subscriptions=\"price\">{{transaction.attributes.price}} {{transaction.attributes.currency}}</div>\n                            </div>\n                            <div class=\"table-line\" ng-show=\"toggleMobile\">\n                                <div class=\"title text-grey-1 font-bold\"><span translate=\"cw.subscriptions.receipt\"></span><span>: </span></div>\n                                <div class=\"value\" ng-if=\"!(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\" connectqa-subscriptions=\"receipt\">\n                                    <a ng-if=\"transaction.attributes.invoice_url\" ng-href=\"{{transaction.attributes.invoice_url}}\" translate=\"cw.general.download_pdf\" class=\"text-blue-3\" target=\"_blank\"></a>\n                                    <span ng-if=\"!transaction.attributes.invoice_url\">\n                                        <span translate=\"cw.general.ui.pending\"></span>\n                                        <a class=\"icon icon-refresh icon-xxs icon-blue-3 ml5 inline-block crs-pointer\"\n                                        ng-click=\"subscriptionsCtrl.refreshTransactions()\"\n                                        ng-if=\"refreshRequests < 5\"\n                                        ng-class=\"{ 'icon-grey-4': refreshLoader }\"></a>\n                                    </span>\n                                </div>\n                                <div class=\"value\" ng-if=\"(transaction.attributes.payment_gateway === 'GOOG' || transaction.attributes.payment_gateway === 'AAPL')\" connectqa-subscriptions=\"receipt\">\n                                    <span>---</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n        <!-- End -->\n    </div>\n    <cma-disclaimer ng-if=\"(showCmaDisclaimer.otc || showCmaDisclaimer.trial || showCmaDisclaimer.banner || showCmaDisclaimer.cardDeleted || showCmaDisclaimer.withdrawalConsent)\"></cma-disclaimer>\n</div>\n"

/***/ }),

/***/ "hm4D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$stateParams', '$location', '$state', '$filter', 'DeviceRestService'];

var _$scope = void 0;
var _$state = void 0;
var _$filter = void 0;
var _DeviceRestService = void 0;
var _DevicesRepository = void 0;
/**
 * @ngdoc service
 * @name controllers.UnlockDevice
 *
 * @description
 * Unlock Device
 */

var UnlockDevice = function () {

    /**
     * @param  {any} $scope
     * @param  {any} _$filter
     * @param  {any} $stateParams
     * @param  {any} $location
     * @param  {any} DeviceRestService
     */
    function UnlockDevice($scope, $stateParams, $location, $state, $filter, DeviceRestService) {
        _classCallCheck(this, UnlockDevice);

        var deviceId = $stateParams.resourceId;

        if (!deviceId) {

            return $location.path('/dashboard/home');
        }

        _DeviceRestService = DeviceRestService;
        _DevicesRepository = _index.DevicesRepository;

        _$filter = $filter;
        _$scope = $scope;
        _$state = $state;
        _$scope.device = _index.DevicesRepository.getById(deviceId);
        _$scope.brandName = CWCONFIG.partnerConfig.name;

        // $scope assigned function
        _$scope.unlockDevice = this.unlockDevice;
    }

    _createClass(UnlockDevice, [{
        key: 'unlockDevice',
        value: function unlockDevice() {

            var parentState = _$state.current.parent;
            var page = '';

            if (parentState === 'dashboard.devices') {

                page = 'My Devices';
            } else if (parentState === 'dashboard.device-details') {

                page = 'Device Details';
            }

            _RFC4.default.send('ConnectWeb Unlock Confirm Click', {
                Page: page
            });

            var devicePayload = {
                data: {
                    attributes: {
                        locked: false
                    },
                    type: 'devices',
                    id: _$scope.device.id
                }
            };

            _DeviceRestService.update(_$scope.device && _$scope.device.id, devicePayload).then(function (response) {

                // update device repository, close modal and alert success
                _DevicesRepository.update(response.data.data);
                _$scope.close();

                _RFC2.default.success({
                    message: 'cw.unlock_device.success'
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device),
                        brandname: CWCONFIG.partnerConfig.name
                    }
                });
            }).then(null, function () {

                // close modal and alert error
                _$scope.close();
                _RFC2.default.error({
                    message: 'cw.unlock_device.error'
                }, {
                    message: {
                        device: _$filter('deviceName')(_$scope.device)
                    }
                });
            });
        }
    }]);

    return UnlockDevice;
}();

_serviceDependencies.push(UnlockDevice);

angular.module('controllers').controller('UnlockDevice', _serviceDependencies);

/***/ }),

/***/ "hr0c":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("tZex"),
    baseForOwn = __webpack_require__("TBo3"),
    baseIteratee = __webpack_require__("EAyW");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "hwaY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* eslint prefer-destructuring: 0 */
/* eslint consistent-return: 0 */

/**
 * @ngdoc service
 * @name services.Util
 *
 * @description
 * System information helper functions
 */

angular.module('services').factory('SystemInformation', function () {
    return {
        disks: function disks(diskInfo) {

            angular.forEach(diskInfo, function (disk) {

                if (!disk.shortName && disk.name) {
                    var _disk$name$match = disk.name.match(/[\w]+/i),
                        _disk$name$match2 = _slicedToArray(_disk$name$match, 1),
                        shortName = _disk$name$match2[0];

                    switch (shortName.toLowerCase()) {

                        case 'intel':
                            disk.shortName = 'Intel';
                            if (disk.name.indexOf('SSD') !== -1) {

                                disk.type = 'SSD';
                            }
                            break;
                        case 'western':
                            disk.shortName = 'Western Digital';
                            break;
                        case 'vmware':
                            disk.shortName = 'VMware Virtual Disk';
                            break;
                        default:
                            disk.shortName = shortName || disk.name;

                    }
                }
            });
            return diskInfo;
        },

        cpu: function cpu(_cpu) {

            if (_cpu && !_cpu.shortName) {

                if (_cpu.name) {

                    _cpu.shortName = _cpu.name.replace(/CPU|\(R\)|\(TM\)|@.+/g, '');
                }
            }

            return _cpu;
        },
        motherboard: function motherboard(_motherboard) {

            if (!_motherboard) {

                return;
            }
            if (_motherboard.brand && !_motherboard.shortBrand) {

                _motherboard.shortBrand = _motherboard.brand.split(' ')[0];
            }

            if (_motherboard.model && !_motherboard.shortModel) {

                _motherboard.shortModel = _motherboard.model.replace(new RegExp(_motherboard.shortBrand, 'gi'), '');
            }

            return _motherboard;
        },
        resolution: function resolution(_resolution) {

            var sResolution = _resolution ? _resolution.match(/\d+x\d+/i) : '';

            return sResolution && sResolution[0];
        }
    };
});

/***/ }),

/***/ "hyfS":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("r1rA"),
    isObjectLike = __webpack_require__("7Zib");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "i148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("yRWb");

__webpack_require__("9EHJ");

__webpack_require__("bcrZ");

__webpack_require__("iHtB");

__webpack_require__("fDqN");

__webpack_require__("HSGj");

__webpack_require__("BqL9");

__webpack_require__("1aLy");

__webpack_require__("5TFR");

__webpack_require__("EcjD");

__webpack_require__("0+3i");

__webpack_require__("dxLk");

__webpack_require__("XLyR");

__webpack_require__("hwaY");

__webpack_require__("Y4ls");

__webpack_require__("et4X");

/***/ }),

/***/ "i3TI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FilterDeviceName = function FilterDeviceName(device) {

    if (!device || !device.attributes) {

        return 'Unknown';
    }

    if (device) {

        if (device.attributes.alias) {

            return device.attributes.alias;
        } else if (device.attributes.name) {

            return device.attributes.name;
        } else if (device.attributes.brand && device.attributes.model) {

            if (device.attributes.model.toLowerCase().indexOf(device.attributes.brand.toLowerCase()) > -1) {

                return device.attributes.model;
            }
            return [device.attributes.brand, device.attributes.model].join(' ');
        } else if (device.attributes.brand) {

            return device.attributes.brand;
        } else if (device.attributes.model) {

            return device.attributes.model;
        }

        return 'Unknown';
    }

    return undefined;
};

exports.default = FilterDeviceName;

/***/ }),

/***/ "i9Rx":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "iDtk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("poBF");

var _index2 = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$rootScope', '$state', 'Util'];

var TrialModal = function TrialModal($scope, $rootScope, $state, Util) {
    _classCallCheck(this, TrialModal);

    $scope.trialPromotion = _index2.FlexiblePromotionsRepository.getPromotionById('prime_anual_trial');
    $rootScope.primeTrialShopUrl = $scope.trialPromotion.attributes.promotion_url;

    if (!$scope.trialPromotion) {

        Util.closeModal();
    }

    var mixpanelPayload = {
        Source: 'Trial 60 Days',
        Modal: 'Prime 60 Days Trial',
        Product: 'aps10',
        Page: Util.getPageName()
    };

    _RFC2.default.send('ConnectWeb Modal Open ', mixpanelPayload);

    // Save the trial timeline object
    // Calculate the last day of trial based on the runtime value
    var runtime = 60;
    var trialEndDate = new Date(new Date().setDate(new Date().getDate() + runtime));

    // Calculate the reminder date based on the runtime value and the reminder email days
    var reminderEmailDays = 15;
    var reminderEmailDate = new Date(new Date().setDate(new Date().getDate() + runtime - reminderEmailDays));

    $scope.trialTimeline = {
        startDate: new Date().getDate(),
        startMonth: new Date().getMonth() + 1,
        endDate: trialEndDate.getDate(),
        endMonth: trialEndDate.getMonth() + 1,
        reminderDate: reminderEmailDate.getDate(),
        reminderMonth: reminderEmailDate.getMonth() + 1
    };

    $scope.checkPayNowPrice = function () {

        var repoPrice = _index.AppPricesProcessor.getSinglePrice('aps10', '12', '1');

        // Regular price
        var price = repoPrice.attributes.promotion.total_price_string;

        // Check digit positions
        var regex = new RegExp('\\d', 'g');
        var digit = void 0;
        var positions = [];
        // eslint-disable-next-line no-cond-assign
        while (digit = regex.exec(price)) {

            positions.push(digit.index);
        }

        // Save the pay now price in the price_string format
        price = positions[0] === 0 ? '0'.concat(price.substring(positions[positions.length - 1] + 1)) : price.substring(0, positions[0]).concat('0');

        return price;
    };

    // CMA Links
    var currentLanguage = CWCONFIG.language;
    var configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
    var redirectSupportLanguage = '';

    if (configSupportLanguages.find(function (lang) {
        return lang === currentLanguage;
    })) {

        if (currentLanguage === 'en') {

            redirectSupportLanguage = 'en-us';
        } else {

            redirectSupportLanguage = currentLanguage;
        }
    } else {

        redirectSupportLanguage = 'en-us';
    }

    $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
    $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
    $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
    $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
    $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
    $scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
    $scope.learnHow = CWCONFIG.cma.subscriptions.learnHow.replace(/\[language\]/gi, currentLanguage);
    $scope.cancelOrRefund = CWCONFIG.cma.subscriptions.cancelOrRefund.replace(/\[language\]/gi, currentLanguage);
    $scope.yourAccount = CWCONFIG.cma.subscriptions.yourAccount.replace(/\[language\]/gi, currentLanguage);
    $scope.cancelContractDetails = CWCONFIG.cma.subscriptions.cancelContractDetails.replace(/\[language\]/gi, redirectSupportLanguage);
    $scope.cancelContractDetailsNew = CWCONFIG.cma.subscriptions.cancelContractDetailsNew.replace(/\[language\]/gi, redirectSupportLanguage);
    // End CMA links

    $scope.showCMAscreen = false;

    $scope.showCMAscreenClick = function () {

        $scope.showCMAscreen = true;
    };

    $scope.backToTrialScreen = function () {

        $scope.showCMAscreen = false;
    };

    $scope.activateTrial = function () {

        var mixpanelDetails = {
            Modal: 'Prime 60 Days Trial',
            'Button Label': 'Start trial',
            Product: 'Prime 60 Days Trial',
            'Product ID': 'aps10',
            Page: Util.getPageName()
        };

        _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

        $state.go($state.current.name, {
            ltb: 'payment-cart',
            resourceId: 'aps10',
            trial: true
        });

        sessionStorage.setItem('trialModalClosed', 'true');
    };
};

_serviceDependencies.push(TrialModal);

angular.module('controllers').controller('TrialModal', _serviceDependencies);

/***/ }),

/***/ "iHtB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable */

angular.module('services').service('Facebook', ['$q', '$window', function ($q, $window) {

    var exports = void 0;
    /**
        The script tag HTML id for the FB JS SDK
        @type String
    */
    var SCRIPT_ID = 'facebook-jssdk';

    /**
        Indicates whether the debug version of the FB JS SDK is loaded
        @type Boolean
    */
    var SCRIPT_DEBUG = false;

    /**
        The Facebook application id
        @type String
    */
    var APP_ID = '438101322915896';

    /**
        The Facebook application url
        @type String
    */
    var APP_URL = 'https://www.facebook.com';

    /**
        The list of API methods that will be wrapped for handling
        common error scenarios together with the index in the arguments list
        for each method where the callback is passed.
        @type Array
    */
    var WRAP_API = [{ f: 'api', cbIndex: 1 }, { f: 'login', cbIndex: 0 }, { f: 'logout', cbIndex: 0 }, { f: 'getLoginStatus', cbIndex: 0 }];

    /**
        The list of error codes return by the FB API that should be handled
        by retrying the call after a predefined timeout.
        @type Array
    */
    var RETRY_CODES = [1, 2, 4, 17];

    /**
        The timeout for reissueing a previous FB API call that resulted in
        an error code from {@link RETRY_CODES}.
        @type Number
    */
    var RETRY_TIMEOUT = 1000;

    /**
        The maximum number a call should be retried before dropping it.
        @type Number
    */
    var MAX_RETRIES = 3;

    /**
        The queue of wrapped calls that are issued.
        Calls are retried from this queue if the response error code indicates
        this. The call is removed from this queue once a call results in a
        success or in a particular error response that cannot be handled in a
        general way or the number of retries reaches the maximum value.
        @type Array
    */
    var queue = [];

    /**
        A deferred object for keeping the status of loading the FB SDK
        @type {$q.defer}
    */
    var deferred = $q.defer();

    /**
        A compiled template function to return the Facebook JS SDK URL
        taking into account the locale and the debug setting
        @type Function
    */
    var getScriptSrc = _.template('//connect.facebook.net/<% print(locale || \'en_US\'); %>/all' + (SCRIPT_DEBUG ? '/debug' : '') + '.js');

    /**
        Initializer for the Sandbox extension.
        Loads the Facebook JS SDK and sets up its initialization.
    */
    function init() {

        var fbJs = $window.document.getElementsByTagName('script')[0];
        var fbscript = $window.document.createElement('script');

        if ($window.document.getElementById(SCRIPT_ID)) {

            deferred.resolve();
            return;
        }

        fbscript.id = SCRIPT_ID;
        fbscript.src = getScriptSrc({ locale: '' });

        fbJs.parentNode.insertBefore(fbscript, fbJs);

        $window.fbAsyncInit = initAPI;
    }

    /**
        Initializes the Facebook JS SDK.
        Extends this modules export object with the FB JS SDK's API
        and takes care to wrap methods listed in {@link WRAP_API}
    */
    function initAPI() {

        FB.init({
            appId: APP_ID,
            status: true,
            cookie: true
        });

        _.extend(exports, FB, _.reduce(WRAP_API, function (o, w) {

            o[w.f] = _.partial(wrap, w.f, w.cbIndex);
            return o;
        }, {}));

        deferred.resolve();
    }

    /**
        Common wrapper for API calls that return similar responses.
        Pushes a call specification in the {@link queue} and makes the
        actual FB API call.
    */
    function wrap(f, cbIndex) {

        var rest = _.rest(arguments, 2);
        var cb = rest[cbIndex];

        // Keep a reference to the call specification so it can be reissued
        // later if necessary
        var call = {
            f: f,
            args: rest,
            cb: cb,
            cbIndex: cbIndex,
            count: 0,
            deferred: $q.defer()
        };
        queue.push(call);

        // Call the actual FB API
        callAPI(call);

        // Enhance the API by returning a promise
        return call.deferred.promise;
    }

    /**
        Handler for wrapped methods.
        If a response error code from {@link RETRY_CODES} arrives it
        reschedules the call to be reissued after {@link RETRY_TIMEOUT}.
         @param {Object} response
        @param {Object} call The call specification
    */
    function handle(call, response) {

        if (!response) {

            drop(call);
            return;
        }

        if (response.error && _.indexOf(RETRY_CODES, response.error) !== -1) {

            if (++call.count < MAX_RETRIES) {

                setTimeout(_.partial(callAPI, call), RETRY_TIMEOUT);
            } else {

                drop(call);
            }
        }

        drop(call);

        if (call.cb) {

            call.cb(response);
        }
        call.deferred.resolve(response);
    }

    /**
        Drops a call from the queue.
        @param {Object} call A call specification object
    */
    function drop(call) {

        queue = _.without(queue, call);
    }

    /**
        Makes the actual FB API call based on a call specification.
        @param {Object} call A call specification object
        @param {String} call.f The method name
        @param {Array} call.args The original arguments
        @param {Function} call.cb The passed callback
        @param {Number} call.cbIndex The arguments index where the callback is
        @param {Number} call.count The number of times this call was retried
    */
    function callAPI(call) {
        var _FB;

        // Make a copy of the original arguments so we don't alter them
        var args = call.args.slice();
        // Replace the original callback argument with {@link handle}
        args.splice(call.cbIndex, 1, _.partial(handle, call));

        // Call the original API method
        (_FB = FB)[call.f].apply(_FB, _toConsumableArray(args));
    }

    /**
        Returns a promise that will be resolved when the FB SDK is loaded
        @returns {jQuery.Promise}
    */
    function loaded() {

        return deferred.promise;
    }

    /**
        Display Facebook authentification page.
     */
    function dialogOAuth() {

        var path = '/dialog/oauth';
        var query = '?client_id=' + APP_ID + '&scope=email' + ('&redirect_uri=' + encodeURIComponent($window.location.href));

        $window.location = APP_URL + path + query;
    }

    /**
        The exported API of this module.
         This is a clone of the FB JS SDK so all possible calls are available
        through this object, with the exception of the wrapped methods which
        handle common error scenarios on top of the actual FB calls.
    */
    exports = {
        init: init,
        loaded: loaded,
        dialogOAuth: dialogOAuth
    };

    return exports;
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "iJR4":
/***/ (function(module, exports) {

module.exports = "<div class=\"two-factor-auth\">\n\n    <div class=\"mya-section-info\">\n        <div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.login_history.card.title_right\"></div>\n        <div class=\"text-m text-grey-3\" translate=\"cw.tfa.settings.body\" translate-values=\"{brandname : brandName}\">\n        </div>\n    </div>\n\n    <div class=\"mya-section-forms max-width-m\">\n        <div class=\"tfa-verification\">\n            <div class=\"tfa-img\"\n                ng-class=\"{'active': tfaValidationStep === 'tfaEnabled','inactive': tfaValidationStep === 'tfaDisabled'}\">\n            </div>\n\n            <div>\n                <!-- Verification OFF -->\n                <div class=\"tfa-form\" ng-if=\"tfaValidationStep === 'tfaDisabled'\">\n\n                    <div class=\"tfa-form-title mb10\">\n                        <span class=\"text-xl text-grey-2\" translate=\"cw.tfa.verif.is\"></span>\n                        <span class=\"text-red-2 text-xl\" translate=\"cw.antivirus.status.off\"></span>\n                    </div>\n\n                    <button class=\"btn btn-medium btn-primary text-l mb10\" ng-click=\"TwoFactorAuthCtrl.enableTwoFactor()\"\n                        ng-disabled=\"disabledButton\" translate=\"cw.tfa.enable\" connectqa-mya=\"enable-2fa\">\n                    </button>\n                </div>\n\n                <!-- Verification ON -->\n                <div class=\"tfa-form\" ng-if=\"tfaValidationStep === 'tfaEnabled'\">\n                    <div class=\"tfa-form-title mb10\" connectqa-mya=\"2fa-status\">\n                        <span class=\"text-xl text-grey-2\" translate=\"cw.tfa.verif.is\"></span>\n                        <span class=\"text-green-2 text-xl\" translate=\"cw.tfa.on\"></span>\n                    </div>\n\n                    <div class=\"tfa-form-title text-m text-grey-3 mb10\" translate=\"cw.tfa.verif.sign\"></div>\n\n                    <div class=\"tfa-form-title text-l\">\n\n                        <span class=\"text-grey-2\"\n                            connectqa-mya=\"active-2fa-number\">{{TwoFactorAuthCtrl.getPhoneNumber()}}</span>\n                        <span class=\"icon icon-edit text-blue-2 mlr5 icon-xxs inline-block\"\n                            ng-click=\"TwoFactorAuthCtrl.enableTwoFactor()\" connectqa-mya=\"edit-2fa-number\">\n                        </span>\n\n                        <span class=\"tfa-link text-grey-3 mlr5 text-l\" ng-click=\"TwoFactorAuthCtrl.disableTwoFactor()\"\n                            translate=\"cw.tfa.disable\" connectqa-mya=\"disable-2fa\">\n                        </span>\n                    </div>\n                    <a class=\"underline-hover link text-l inline-block mt20 text-blue-2\" ng-if=\"$root.isComingFromCrypto\"\n                        ng-click=\"goBackToCrypto()\" ui-sref=\"root.dashboard.crypto({tab: 'wallet'})\">\n                        <span translate=\"cw.tfa.back_to_crypto\">Go back to Avira Crypto</span>\n                        <i class=\"icon icon-arrow-right-slim inline-block v-middle icon-xxxxs ml10\"></i>\n                    </a>\n                </div>\n\n                <!-- Verification Phone -->\n                <div class=\"tfa-form\" ng-if=\"tfaValidationStep === 'tfaPhoneInput'\">\n                    <div class=\"text-xl text-grey-2 tfa-form-title\" translate=\"cw.tfa.sms.title\"></div>\n                    <div class=\"panel-body\">\n                        <div class=\"tfa-country-selector\">\n                            <div country-selector class=\"country-selector\" selected-device=\"selectedDevice\"\n                                next=\"sendCode()\" input-error=\"inputError\"></div>\n                        </div>\n                    </div>\n                    <p class=\"error-message\" ng-show=\"inputError\"\n                        translate=\"cw.tfa.messages.invalid_phone_number\"></p>\n\n                    <div class=\"tfa-form-title mb15 mt5\">\n                        <i class=\"icon icon-xxxs icon-warning icon-orange-2 inline-block mr5\"></i>\n                        <span class=\"text-xs text-grey-2 font-super-light\" translate=\"cw.tfa.sms.note\"></span>\n                    </div>\n\n\n                    <button ng-show=\"!showCaptcha\" class=\"btn btn-medium btn-primary text-l mb10\" ng-click=\"TwoFactorAuthCtrl.onSubmitPhone()\"\n                        ng-disabled=\"disabledButton\" translate=\"cw.tfa.sms.btn_send_code\" connectqa-mya=\"send-2fa-code\">\n                    </button>\n                </div>\n\n                <!-- Verification Code -->\n                <div class=\"tfa-form\" ng-if=\"tfaValidationStep === 'tfaCodeInput'\">\n                    <div class=\"text-xl text-grey-2 tfa-form-title\" translate=\"cw.tfa.sms.title\"></div>\n                    <div class=\"form-group mt10\">\n                        <form name=\"verificationCode\" role=\"form\" novalidate>\n                            <label class=\"fallback-input\" ng-hide=\"verificationCode.code.$viewValue.length > 0\" for=\"code\"\n                                translate=\"cw.tfa.form.code\"></label>\n                            <input type=\"text\" ng-focus=\"isFocusOnCode = true\" ng-blur=\"isFocusOnCode = false\" name=\"code\"\n                                id=\"code\" ng-class=\"{'error': TwoFactorAuthCtrl.otpError}\"\n                                ng-keydown=\"TwoFactorAuthCtrl.otpError = false\" class=\"otp-code-input\" ng-model=\"otp.code\"\n                                placeholder=\"{{ 'cw.tfa.form.code' | translate }}\">\n                        </form>\n                    </div>\n                    <p class=\"error-message\" ng-show=\"TwoFactorAuthCtrl.otpError\" translate=\"cw.tfa.messages.invalid_code\">\n                    </p>\n\n                    <div class=\"text-xs text-grey-3 mb10\">\n                        <div translate=\"cw.tfa.code.note\"></div>\n                        <div class=\"text-s\">{{TwoFactorAuthCtrl.getPhoneNumber()}}.</div>\n                    </div>\n\n                    <div class=\"text-xs text-grey-3 mb10\">\n                        <span class=\"text-s\" translate=\"cw.tfa.get.code\"></span>\n                        <span class=\"tfa-link text-s text-blue-2\" ng-click=\"TwoFactorAuthCtrl.onSubmitPhone()\"\n                            translate=\"cw.tfa.code.btn_resend\"></span>\n                    </div>\n\n                    <div class=\"input-checkbox mb25 ml25\">\n                        <input id=\"logout\" type=\"checkbox\">\n                        <label for=\"logout\" class=\"text-m text-grey-2 ng-scope\"\n                            ng-click=\"TwoFactorAuthCtrl.toggleLogoutCheckbox()\"\n                            translate=\"cw.general.logout_from_all_devices\"></label>\n                    </div>\n\n                    <button class=\"btn btn-medium btn-primary text-l mb10\" ng-click=\"TwoFactorAuthCtrl.sendOtpCode()\"\n                        ng-disabled=\"disabledButton\" translate=\"cw.tfa.code.btn_verify\" connectqa-mya=\"verify-2fa-code\">\n                    </button>\n                </div>\n\n                <!-- Phone Captcha-->\n                <div class=\"phone-captcha-holder\" ng-show=\"showCaptcha\">\n                    <div class=\"phone-captcha-div\">\n                        <div class=\"phone-captcha-text text-xs text-grey-2\" translate=\"cw.tfa.sms.captcha_warning\"></div>\n                        <div class=\"phone-captcha\">\n                            <div vc-recaptcha\n                                class=\"captcha2\"\n                                key=\"Recaptcha.captchaKey\"\n                                on-create=\"Recaptcha.setWidgetId(widgetId)\"\n                                on-success=\"setCaptchaResponse(response)\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "iRhb":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content no-padding marketing-card-cnt\" oe-mcard-container=\"{{service}}\">\n\n    <div id=\"marketing-card\" class=\"mkt_card\" ng-class=\"{'screenshot-active': screenshotSelected}\">\n\n        <div class=\"top-cnt\"></div>\n\n        <div class=\"mid-cnt\">\n            <div class=\"mkt-block-iconapp\">\n                <div class=\"back-screen\" ng-show=\"screenshotSelected\" ng-click=\"backScreen()\"> < </div>\n                <img class=\"sprite-serviceSmall mb10\" ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\"/>\n                <div class=\"mkt-apps-stars\"><div class=\"mkt-show-stars s5\"></div></div>\n            </div>\n\n            <div class=\"mkt-block-infoapp\">\n\n                <!-- Regular app buttons -->\n                <!-- <div ng-if=\"!app.attributes.custom.manifest.browserExtensionUrl\">\n\n                    <a ng-click=\"buy(app.id)\" class=\"btn btn-medium btn-primary\" translate=\"cw.general.buy\"\n                        connectqa-mcard=\"buy\">\n                    </a>\n\n                </div> -->\n\n                <h3 class=\"text-xl title-cards\">{{app.attributes.resource.oeName}}</h3>\n                <div ng-hide=\"screenshotSelected\" class=\"available-os-holder\">\n                    <div class=\"inline-block available-os\">\n                        <span ng-repeat=\"osType in app.attributes.custom.manifest.os\"\n                                ng-if=\"app.attributes.custom.manifest.os.length\"\n                                class=\"icon icon-xxs icon-grey-4 icon-{{osType}}\"\n                                ng-hide=\"service === 'antivirus' && osType === 'ios'\">\n                        </span>\n                    </div>\n\n                    <p class=\"text-m uppercase mb10 text-grey-4 inline-block\" translate=\"cw.ui.general.pro_version\"></p>\n                </div>\n\n                <p class=\"text-m text-grey-2\"> {{app.attributes.resource.shortDescription}}</p>\n\n            </div>\n        </div>\n\n        <div class=\"mkt-card-tabs\">\n            <a ng-class=\"{'active': tab === 'screenshots'}\">\n                <span translate=\"cw.mkt.card.tabs.screenshots\" ng-click=\"onTabClick('screenshots')\" connectqa-mcard=\"screenshots\"></span>\n                <i></i>\n            </a>\n            <a ng-class=\"{'active': tab === 'details'}\">\n                <span ng-click=\"onTabClick('details')\" translate=\"cw.dashboard.button.details\" connectqa-mcard=\"details\"></span>\n                <i></i>\n            </a>\n            <a ng-class=\"{'active': tab === 'features'}\" ng-show=\"features.length > 0\">\n                <span translate=\"cw.mkt.card.tabs.features\" ng-click=\"onTabClick('features')\" connectqa-mcard=\"features\"></span>\n                <i></i>\n            </a>\n        </div>\n\n        <div class=\"mkt-content-tabs\">\n\n            <div class=\"screenshots-cnt\"\n                ng-class=\"{'hide-background': app.attributes.resource.screenshots.length}\"\n                ng-show=\"tab === 'screenshots'\"\n            >\n                <img ng-repeat=\"screenshot in app.attributes.resource.screenshots\" ng-src=\"{{screenshot.img_src | imageUrlParse}}\" width=\"180\" height=\"120\" connectqa-mcard=\"image\"/>\n            </div>\n            <div class=\"details-cnt\" ng-show=\"tab === 'details'\">\n                <p class=\"text-m\" ng-bind-html=\"app.attributes.resource.longDescription\"></p>\n            </div>\n\n                <div class=\"features-cnt\"  ng-show=\"tab === 'features'\" ng-init=\"idx = 0;\">\n                <ul class=\"features-title\">\n                    <li ng-class=\"{active: ($parent.idx === $index)}\" ng-click=\"$parent.idx = $index;\"\n                        ng-repeat=\"feature in features track by $index\" connectqa-mcard=\"{{features[$index].title | lowercase}}\">\n                        <a class=\"text-grey-4 text-l\">{{features[$index].title}}</a><i></i>\n                    </li>\n                </ul>\n                <div class=\"ft-list\">\n                    <ul>\n                        <li class=\"text-black text-m\" ng-bind-html=\"features[idx].description\"></li>\n                    </ul>\n                </div>\n                <div class=\"vertical-bar\"></div>\n                <div class=\"clear\"></div>\n            </div>\n        </div>\n    </div>\n\n    <!-- activate event handlers for screenshots functionality when html is ready -->\n    {{loadPictures()}}\n</div>\n";
var path = 'scripts/controllers/modals/store-product-card/product-card.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "iqiA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint max-len: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * One Click Payment controller
 * Handles ocp payment calls
 */

angular.module('controllers').controller('OneClickPayment', ['$scope', 'Util', 'ActivationCodeRestService', 'LicenseRestService', 'PaymentsRestService', '$filter', 'RecommendationsRestService', 'TransactionRestService', '$rootScope', 'DeployRestService', '$state', function ($scope, Util, ActivationCodeRestService, LicenseRestService, PaymentsRestService, $filter, RecommendationsRestService, TransactionRestService, $rootScope, DeployRestService, $state) {

    $rootScope.disableCloseModalOCP = true;
    $scope.showOcpScreen = false;

    /* this variable is used to delay the second OCP
    banner in case he already purchased one product.
    E.g: user buys ISEC and after the payment is completed, we show Prime offer immediately */
    $rootScope.hideSecondOfferUntilRefresh = false;

    // feature/OE-7610-a-b-test-aia-banner-copy-ocp
    // if ($state.params.resourceId === 'adwp1') {

    var recommendations = _index.RecommendationsRepository.getAll();

    $scope.recommendation = recommendations.find(function (recommendation) {
        return recommendation.attributes.acronym === $state.params.resourceId;
    });

    // } else {

    //     [$scope.recommendation] = RecommendationsRepository.getAll();

    // }
    // feature/OE-7610-a-b-test-aia-banner-copy-ocp

    var _ActivationCodesRepos = _index.ActivationCodesRepository.getAll(),
        _ActivationCodesRepos2 = _slicedToArray(_ActivationCodesRepos, 1),
        onMergingActivationCode = _ActivationCodesRepos2[0];

    var _LicensesRepository$g = _index.LicensesRepository.getAll(),
        _LicensesRepository$g2 = _slicedToArray(_LicensesRepository$g, 1),
        currentLicense = _LicensesRepository$g2[0];

    var modifyDate = new Date(Util.deepFind(currentLicense, 'attributes.modify_date'));

    $scope.submitted = false;
    // CMA Links
    var currentLanguage = CWCONFIG.language;

    $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
    $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
    $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
    $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
    $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
    $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage) + '" target="_blank"';
    // End CMA links

    if (!$rootScope.cmaGBapplies) {

        $scope.acceptedRowTerms = false;

        $scope.onChangeCheckboxROW = function () {

            $scope.acceptedRowTerms = !$scope.acceptedRowTerms;
        };
    } else {

        $scope.acceptedGbTerms1 = false;
        $scope.acceptedGbTerms2 = false;

        $scope.onChangeCheckboxGB1 = function () {

            $scope.acceptedGbTerms1 = !$scope.acceptedGbTerms1;
        };
        $scope.onChangeCheckboxGB2 = function () {

            $scope.acceptedGbTerms2 = !$scope.acceptedGbTerms2;
        };
    }

    if ($scope.recommendation) {

        $scope.showOcpScreen = true;
        // link to support page
        var language = CWCONFIG.language === 'de' ? 'de' : 'en';
        $scope.supportUrl = '/dashboard/support/tabs/support';

        // reset of the world region
        $scope.paymentSupportUrlRegionCB = 'https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=' + language;
        // USA region
        $scope.paymentSupportUrlRegionCA = 'https://shop.avira.com/819/?scope=cuseco&cfg=webcart_2017_tax&language=' + language;

        /**
         * User will be billed and renewed 1 day before the expiration of the free 30 days
         * so we need to show him the billing date 29 days from the day he activated
         */
        var currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 29); // add 29 days to current date
        $scope.trialExpirationDate = $filter('date')(currentDate);
        $scope.brandName = CWCONFIG.partnerConfig.name;
        $scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
        $scope.hrefPrivacyPolicy = CWCONFIG.partnerConfig.translationsLinks.eula.privacyPolicy.replace('{language}', CWCONFIG.language);
        $scope.hrefRightWithdrawal = CWCONFIG.partnerConfig.translationsLinks.eula.rightWithdrawal.replace('{language}', CWCONFIG.language);
        $scope.hrefSupportProductLifecycle = CWCONFIG.partnerConfig.translationsLinks.eula.supportProductLifecycle.replace('{language}', CWCONFIG.language);
        $scope.product1 = _index.AppIntegrationsRepository.getAppName('isec0');
        $scope.product2 = _index.AppIntegrationsRepository.getAppName('aps10');

        var languagesTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.languages;

        if (languagesTermsOfUse.find(function (element) {
            return element === CWCONFIG.language;
        })) {

            $scope.hrefTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.href.replace('{language}', CWCONFIG.language);
        } else {

            $scope.hrefTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.href.replace('{language}', 'en');
        }

        // get recommendation details
        $scope.recommendedProduct = _index.AppIntegrationsRepository.getById($scope.recommendation.attributes.acronym);

        // get the users payment types and use the last one
        var allPaymentTypes = _index.PaymentTypesRepository.getAll();
        $scope.paymentInfo = allPaymentTypes[allPaymentTypes.length - 1].attributes;

        // check if the recommendation is a yearly payment subscription
        $scope.isYearlyPayment = $scope.recommendation.attributes.subscription_type === 'annual';

        $scope.activateRecommendations = function () {

            if (!$rootScope.cmaGBapplies && !$scope.acceptedRowTerms) {

                if (!$scope.submitted) {

                    $scope.submitted = true;
                }
                return;
            }

            if ($rootScope.cmaGBapplies && (!$scope.acceptedGbTerms1 || !$scope.acceptedGbTerms2)) {

                if (!$scope.submitted) {

                    $scope.submitted = true;
                }
                return;
            }

            // Different error screen for cleverbrigde fail
            var cleverbridgeErrorCodes = ['23002', '23003', '23004', '23006', '23007'];

            $scope.showOcpScreen = false;
            $scope.showPendingScreen = true;

            var mixpanelDetails = {
                Modal: 'OCP Product Details Modal',
                'Button Label': 'Buy',
                Product: $scope.recommendedProduct.attributes.name,
                'Product ID': $scope.recommendedProduct.id,
                'Recommendation ID': $scope.recommendation.id,
                Page: Util.getPageName(),
                Price: Util.deepFind($scope.recommendation, 'attributes.total_price_string'),
                Discount: Util.deepFind($scope.recommendation, 'attributes.discount'),
                Runtimes: Util.deepFind($scope.recommendation, 'attributes.runtime')
            };

            _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

            var xamedium = '' + $rootScope.ocp_xa_medium + $scope.recommendedProduct.id;

            var payload = {
                data: {
                    type: 'payments',
                    attributes: {
                        tag: 'one-click'
                    },
                    relationships: {
                        'app-recommendation': {
                            data: {
                                type: 'app-recommendations',
                                id: $scope.recommendation.id
                            }
                        }
                    }
                },
                meta: {
                    'x-params': {
                        'x-a-source': 'cw',
                        'x-a-medium': xamedium,
                        'x-a-content': '' + $rootScope.ocp_xa_content + $scope.recommendedProduct.id + '-' + $scope.recommendation.id,
                        'x-a-aiatest': '' + $rootScope.ocp_xa_aiatest,
                        'x-a-button': '' + $rootScope.ocp_xa_button
                    }
                }
            };

            var ssoExtraParams = sessionStorage.getItem('SsoExtraUrlParams');

            if (ssoExtraParams && ssoExtraParams.indexOf('cw_lp_paid_search') > -1) {

                payload.meta['x-params']['x-a-campaign'] = 'cw_lp_paid_search';
            }

            _index.LicensesRepository.getObservable().subscribe(function (data) {

                data.forEach(function (license) {

                    var newLicenseModifyDate = new Date(Util.deepFind(license, 'attributes.modify_date'));

                    if (license.relationships.app.data.id === $scope.recommendedProduct.id && modifyDate.getTime() !== newLicenseModifyDate.getTime()) {

                        clearTimeout($scope.getLicenseTimeout);
                        _RFC6.default.broadcast('purchase completed');
                        var onMergingAppId = Util.deepFind(onMergingActivationCode, 'relationships.app.data.id');
                        $scope.onMergingApp = _index.AppIntegrationsRepository.getById(onMergingAppId);
                        $scope.extraRuntime = Util.getExtraRuntime(license);
                        $scope.totalRuntime = Util.getRemainingRuntime(license);

                        $scope.showPendingScreen = false;
                        // check if the success modal is already displayed
                        // don't send mixpanel event twice
                        if ($scope.showSuccessScreen === true) {

                            return;
                        }
                        $scope.showSuccessScreen = true;

                        /* update transactions repository after the pruchase has been made
                           and get the transactions id and the invoice url for that specific purchase */
                        TransactionRestService.getAllAsync().then(function (response) {

                            _index.TransactionsRepository.replace(response.data.data);

                            var transactions = _index.TransactionsRepository.getAll() || [];

                            var currentTransaction = transactions.find(function (transaction) {
                                return transaction.attributes.activation_code === license.relationships['activation-code'].data.id && transaction.attributes.app === license.relationships.app.data.id;
                            });
                            $scope.transactionId = Util.deepFind(currentTransaction, 'attributes.payment_transaction_id');
                        });

                        // get activationCode after the license is received
                        ActivationCodeRestService.getAllAsync().then(function (response) {

                            _index.ActivationCodesRepository.replace(response.data.data);

                            $rootScope.ocpSubscriptionTooltipAppId = Util.deepFind($scope.recommendation, 'attributes.acronym');
                        });

                        // Auto deploy ISEC for all Windows devices after purchase
                        var devices = _index.DevicesRepository.getDevicesByOs('windows') || [];

                        devices.forEach(function (device) {

                            var deploymentPayload = {
                                deviceId: device.id,
                                userId: Util.deepFind(device, 'relationships.user.data.id'),
                                appId: license.relationships.app.data.id
                            };

                            DeployRestService.deployOnDevice(deploymentPayload).then(function () {}).then(null, function (e) {

                                // 409 === Conflict
                                // An instance for this application already exists (pending) - ignore
                                if (e.status === 409) {

                                    return;
                                }

                                _RFC4.default.error({
                                    message: 'cw.modal.server-error.desc',
                                    icon: {
                                        cssClasses: 'icon-' + Util.deepFind(device, 'attributes.type')
                                    }
                                });
                            });
                        });

                        $rootScope.hideSecondOfferUntilRefresh = true;

                        var mixpanelSuccess = {
                            Source: 'OCP',
                            Modal: 'OCP Success Modal',
                            Product: $scope.recommendedProduct.attributes.name,
                            'Product ID': $scope.recommendedProduct.id,
                            'Recommendation ID': $scope.recommendation.id,
                            'CW User ID': license.relationships.user.data.id,
                            Page: Util.getPageName()
                        };

                        _RFC2.default.send('ConnectWeb Modal Open ', mixpanelSuccess);
                    }
                });
            });

            /**
             * Start a timeout to get the licenses if we don't receive any acp
             * with the new licenses
             */
            $scope.getLicenseTimeout = setTimeout(function () {
                return LicenseRestService.getAllAsync().then(function (response) {

                    _index.LicensesRepository.replace(response.data.data);
                });
            }, CWCONFIG.timeouts.getLicenseTimeout);

            PaymentsRestService.create(payload).then(function () {

                /**
                 * Get recommendations will be empty, observable in recommendations banner
                 * will be triggered and hide the banner
                 */
                RecommendationsRestService.getAllAsync().then(function (response) {

                    _index.RecommendationsRepository.replace(response.data.data);
                });

                var activationCodesPromise = ActivationCodeRestService.getAllAsync().then(function (response) {

                    _index.ActivationCodesRepository.replace(response.data.data);
                });

                var transactionsPromise = TransactionRestService.getAllAsync().then(function (response) {

                    _index.TransactionsRepository.replace(response.data.data);
                });

                if ($scope.recommendedProduct.id === 'aps10' || $scope.recommendedProduct.id === 'aps20') {

                    $rootScope.$broadcast('prime_purchase_completed');
                }

                var promisesArray = [activationCodesPromise, transactionsPromise];

                Promise.allSettled(promisesArray).then(function () {

                    var activationCodes = _index.ActivationCodesRepository.getAll();
                    var transactions = _index.TransactionsRepository.getAll();

                    var currentTransaction = transactions.find(function (transaction) {
                        return transaction.attributes.payment_transaction_id === $scope.transactionId;
                    });
                    var currentActivationCode = activationCodes.find(function (activationCode) {
                        return activationCode.id === currentTransaction.relationships['activation-code'].data.id;
                    });
                    var currentRuntime = Util.deepFind(currentActivationCode, 'attributes.runtime');
                    var currentAppId = Util.deepFind(currentActivationCode, 'attributes.app');
                    var expirationDate = Util.deepFind(currentActivationCode, 'attributes.date_expire');
                    var subscriptionType = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
                    $scope.formattedExpireDate = moment($scope.expireDate).format('L');

                    var nextBillingEvent = Util.deepFind(currentActivationCode, 'attributes.next_billing_event');

                    if (!nextBillingEvent) {

                        switch (subscriptionType) {

                            case 'yearly':
                                nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                                break;
                            case 'monthly':
                                nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                                break;
                            case 'annual':
                                nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                                break;
                            case 'monthly-trial':
                                nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                                break;
                            case 'annual-trial':
                                nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                                break;
                            default:
                                nextBillingEvent = expirationDate;

                        }
                    }

                    $scope.nextBillingEvent = moment(nextBillingEvent).format('L');

                    $scope.currentPrice = _index.AppPricesRepository.getSinglePrice(currentAppId, currentRuntime, '1');
                    var hasPromotion = Util.deepFind($scope.currentPrice, 'attributes.promotion');

                    if (hasPromotion) {

                        $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.promotion.pc_price_string');
                    } else {

                        $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.price_string');
                    }
                });
            }).catch(function (e) {

                $scope.showPendingScreen = false;
                $scope.showErrorScreen = true;

                if (e.data.errors && e.data.errors.length > 0) {

                    $scope.errorName = e.data.errors[0].statusText;

                    // cleverbridge error
                    if (e.data.errors[0].code && cleverbridgeErrorCodes.indexOf(e.data.errors[0].code) > -1) {

                        $scope.cleverBridgeError = true;
                        $scope.errorCode = e.data.errors[0].code;
                    } else if (e.data.errors[0].code) {

                        // standard error
                        $scope.errorCode = e.data.errors[0].code;
                    } else {

                        // standard error
                        $scope.errorCode = e.data.errors[0].status;
                    }
                }

                var mixpanelSuccess = {
                    Source: 'OCP',
                    Modal: 'OCP Error Modal',
                    Product: $scope.recommendedProduct.attributes.name,
                    'Product ID': $scope.recommendedProduct.id,
                    'Recommendation ID': $scope.recommendation.id,
                    'Error Code': $scope.errorCode || null,
                    'Error Name': $scope.errorName || null,
                    Page: Util.getPageName()
                };

                _RFC2.default.send('ConnectWeb OCP Buy Click', mixpanelSuccess);
            });
        };

        $scope.cancel = function () {

            var mixpanelDetails = {
                Modal: 'OCP Product Details Modal',
                'Button Label': 'Cancel',
                Product: $scope.recommendedProduct.attributes.name,
                'Product ID': $scope.recommendedProduct.id,
                'Recommendation ID': $scope.recommendation.id,
                Page: Util.getPageName()
            };

            _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

            Util.closeModal();
        };

        $scope.closeOCP = function () {

            Util.closeModal();
        };
        $scope.redirectToSubscriptionPage = function () {

            if ($scope.recommendedProduct.id === 'adwp1') {

                $state.go('root.dashboard.dwm', {
                    tab: 'dwm'
                });
            } else {

                $state.go('root.dashboard.subscriptions', {
                    tab: 'plans'
                });
            }
        };
    } else {

        Util.closeModal();
    }

    $scope.$on('$destroy', function () {

        $rootScope.disableCloseModalOCP = false;
    });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "iw+y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppIntegrationRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about app integrations
 * using http requests.
 */

var AppIntegrationRestService = function (_BaseRestService) {
    _inherits(AppIntegrationRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function AppIntegrationRestService($http, $q, Util) {
        _classCallCheck(this, AppIntegrationRestService);

        return _possibleConstructorReturn(this, (AppIntegrationRestService.__proto__ || Object.getPrototypeOf(AppIntegrationRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.AppIntegrationRestService#getAllAsync
     * @methodOf rest.services.AppIntegrationRestService
     * @function
     *
     * @description
     * Retrieves app integrations.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(AppIntegrationRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(AppIntegrationRestService.prototype.__proto__ || Object.getPrototypeOf(AppIntegrationRestService.prototype), 'getAllAsync', this).call(this, 'app-integrations?filter[to]=dashboard&include=from&lang=' + CWCONFIG.language);
        }
    }]);

    return AppIntegrationRestService;
}(_baseRestService2.default);

exports.default = AppIntegrationRestService;


_serviceDependencies.push(AppIntegrationRestService);

angular.module('rest.services').service('AppIntegrationRestService', _serviceDependencies);

/***/ }),

/***/ "j2Hg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

/**
 * Activation codes Processor - activation codes sorted by state of subscription and expiration date
 */

var processedActivationCodes = [];
var observableProcessedActivationCodes = new Rx.BehaviorSubject(processedActivationCodes);

var _ref = CWCONFIG || [],
    primeAppIds = _ref.primeAppIds;
/**
 * Sort activation codes by state of the subscription and expiration date
 * @param {Array} data
 */


function sortActivationCodes(currentActivationCodeInArray, nextActivationCodeInArray) {

    // check if both subscriptions are on or off
    if (currentActivationCodeInArray.attributes.subscription === nextActivationCodeInArray.attributes.subscription) {

        // check the expiration date of the subscriptions
        if (moment(currentActivationCodeInArray.attributes.date_expire) >= moment(nextActivationCodeInArray.attributes.date_expire)) {

            return 1;
        }

        // second subscription has a greater expiration date
        return -1;
    }

    // check if first subscription is off
    if (currentActivationCodeInArray.attributes.subscription === 0) {

        return -1;
    }

    // second subscription is off
    return 1;
}
/**
* @ngdoc service
* @name processors.ActivationCodesProcessor
*
* @description
* This class is used to process activation codes.
*/
var ActivationCodesProcessor = {

    /**
     * Replace all activation codes with received data
     * @param {Array} data
     */
    onNext: function onNext(data) {

        processedActivationCodes = [];
        var sortedActivationCodes = data.sort(sortActivationCodes);
        processedActivationCodes = sortedActivationCodes.sort(this.sortPrimeFirst);
        observableProcessedActivationCodes.onNext(processedActivationCodes);
    },
    sortPrimeFirst: function sortPrimeFirst(currentActivationCodeInArray, nextActivationCodeInArray) {

        if (primeAppIds.indexOf(currentActivationCodeInArray.attributes.app) > -1 && primeAppIds.indexOf(nextActivationCodeInArray.attributes.app) > -1) {

            sortActivationCodes(currentActivationCodeInArray, nextActivationCodeInArray);
        } else if (primeAppIds.indexOf(currentActivationCodeInArray.attributes.app) > -1) {

            return -1;
        } else if (primeAppIds.indexOf(nextActivationCodeInArray.attributes.app) > -1) {

            return 1;
        }
        return 0;
    },


    /**
     * @ngdoc function
     * @name processors.ActivationCodesProcessor#getAll
     * @methodOf processors.ActivationCodesProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed activation codes.
     *
     * @returns {Array} all processed activation codes
     */
    getSortedActivationCodes: function getSortedActivationCodes() {

        return processedActivationCodes;
    },


    /**
    * @ngdoc function
    * @name processors.ActivationCodesProcessor#getObservable
    * @methodOf processors.ActivationCodesProcessor
    * @function
    *
    * @description
    * This function can be used to get an observable object for processed activation codes.
    * @returns {Object} an observable object for processed activation codes.
    */
    getObservable: function getObservable() {

        return observableProcessedActivationCodes;
    }
};

var subjectActiovationCodesRepository = _index.ActivationCodesRepository.getObservable();

subjectActiovationCodesRepository.subscribe(function (data) {
    return ActivationCodesProcessor.onNext(data);
}, function () {}, function () {});

exports.default = ActivationCodesProcessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "j7ko":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$timeout', '$location', '$window', '$scope', '$rootScope'];

var CookiePolicyController = function () {
    function CookiePolicyController($timeout, $location, $window, $scope, $rootScope) {
        _classCallCheck(this, CookiePolicyController);

        this.$timeout = $timeout;
        this.$window = $window;
        this.isNotificationVisible = false;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.cookiePolicyUrl = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);

        this.$scope.webSite = CWCONFIG.partnerConfig.translationsLinks.webSite;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        var hasCookiePolicy = _RFC2.default.get(CWCONFIG.cookie.cookiePolicy);
        var isRestricted = $location.path().indexOf('not-allowed') > -1;

        if (!hasCookiePolicy && !isRestricted) {

            this.showNotification();
        }
    }

    _createClass(CookiePolicyController, [{
        key: 'closeNotification',
        value: function closeNotification() {

            this.isNotificationVisible = false;

            _RFC2.default.set(CWCONFIG.cookie.cookiePolicy, true, {
                path: '/',
                domain: CWCONFIG.cookie.domain,
                expires: 9999
            });

            this.$rootScope.cookieBannerHeight = { 'padding-bottom': '11px' };
            this.$rootScope.cmaDisclaimerHeight = { 'padding-bottom': '0' };
        }
    }, {
        key: 'showNotification',
        value: function showNotification() {
            var _this = this;

            this.$timeout(function () {

                _this.isNotificationVisible = true;

                angular.element('#policyUrl a').on('click', function () {

                    window.open(_this.cookiePolicyUrl, ' _blank');
                });
            }, 500);
        }
    }]);

    return CookiePolicyController;
}();

var CookiePolicyDirective = function CookiePolicyDirective() {
    _classCallCheck(this, CookiePolicyDirective);

    this.template = __webpack_require__("NH+E");
    this.restrict = 'E';
    this.replace = true;

    _controllerDependencies.push(function ($timeout, $location, $window, $scope, $rootScope) {
        return new CookiePolicyController($timeout, $location, $window, $scope, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'cookiePolicyCtrl';
};

_directiveDependencies.push(function () {
    return new CookiePolicyDirective();
});

angular.module('directives').directive('cookiePolicy', _directiveDependencies);

/***/ }),

/***/ "jVrz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmGamerTags = function DwmGamerTags($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmGamerTags);

    $scope.tagIsValid = true;
    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};
        if (assets.primaryMember) {

            $scope.gamerTags = assets.primaryMember.monitoredAccounts.gamerTags;

            $scope.gamerTags.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('#tag').focus();
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.tagIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newGamerTag = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.gamerTags.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                var newEntry = Object.assign({}, entry);
                $scope.updateEntryPayload = newEntry;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-tag').focus();
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.tagIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.gamerTags.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};
    };

    $scope.validateTag = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.tagIsValid = validations.gamerTagValidator($event.currentTarget.value);
        }

        $scope.newGamerTag = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.tagIsValid = validations.gamerTagValidator($scope.newGamerTag);

        $scope.newEntrySubmitted = true;

        if ($scope.tagIsValid) {

            $scope.savenewGamerTagIsLoading = true;

            var payload = {
                gamerTags: {
                    tag: $scope.newGamerTag
                }
            };

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newGamerTag = '';
                $scope.savenewGamerTagIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;


                    _RFC4.default.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Gamer tag'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.savenewGamerTagIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            gamerTags: {
                id: $scope.gamerTags.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newGamerTag = '';
            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Gamer tag'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.showUpdateButton = false;
                $scope.showAddNewButton = true;
                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.entryUpdateValue = function ($event) {

        $scope.tagIsValid = validations.gamerTagValidator($event.currentTarget.value);

        if ($scope.tagIsValid) {

            $scope.updateEntryPayload.tag = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: {
                gamerTags: {
                    tag: $scope.updateEntryPayload.tag,
                    id: $scope.updateEntryPayload.id
                }
            }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Gamer tag'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }

            $scope.gamerTags.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });

            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;
        });
    };
};

_serviceDependencies.push(DwmGamerTags);

angular.module('controllers').controller('DwmGamerTags', _serviceDependencies);

/***/ }),

/***/ "jb5T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.LicenseRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about licenses
 * using http requests.
 */

var LicenseRestService = function (_BaseRestService) {
    _inherits(LicenseRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function LicenseRestService($http, $q, Util) {
        _classCallCheck(this, LicenseRestService);

        return _possibleConstructorReturn(this, (LicenseRestService.__proto__ || Object.getPrototypeOf(LicenseRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.LicenseRestService#getAllAsync
     * @methodOf rest.services.LicenseRestService
     * @function
     *
     * @description
     * Retrieves licenses.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(LicenseRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(LicenseRestService.prototype.__proto__ || Object.getPrototypeOf(LicenseRestService.prototype), 'getAllAsync', this).call(this, 'licenses/');
        }

        /**
         * @ngdoc function
         * @name rest.services.LicenseRestService#create
         * @methodOf rest.services.LicenseRestService
         * @function
         *
         * @description
         * Create a license.
         *
         * @param {object} licensePayload payload
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'create',
        value: function create(licensePayload) {

            return _get(LicenseRestService.prototype.__proto__ || Object.getPrototypeOf(LicenseRestService.prototype), 'create', this).call(this, licensePayload, 'licenses/');
        }
    }]);

    return LicenseRestService;
}(_baseRestService2.default);

exports.default = LicenseRestService;


_serviceDependencies.push(LicenseRestService);

angular.module('rest.services').service('LicenseRestService', _serviceDependencies);

/***/ }),

/***/ "jdje":
/***/ (function(module, exports) {

module.exports = "<span class=\"fl-right crs-pointer auth-language-directive\" ng-click=\"ChangeLanguageCtrl.openModal('change-lang')\" connectqa-login=\"change-language\">\n    <span class=\"fl-left icon language-switcher icon-grey-4 icon-xs\"></span>\n    <span class=\"text-grey-4 mlr5\">{{currentLanguage}}</span>\n</span>\n"

/***/ }),

/***/ "jhMV":
/***/ (function(module, exports) {

module.exports = "<div class=\"tab-content\">\n    <div class=\"loader-wrapper\" ng-if=\"walletIsLoading\">\n        <div class=\"main-loader\"></div>\n    </div>\n    <div class=\"crypto-card-header display-flex justify-content-space-between align-item-center\" ng-if=\"!walletIsLoading\">\n        <div class=\"w40\">\n            <i class=\"icon icon-crypto-wallet inline-block large-icon\"></i>\n            <h2 class=\"inline-block v-middle text-grey-1\" translate=\"cw.dashboard.crypto.wallet.title\">\n            </h2>\n            <div class=\"input-holder mt20\">\n                <ui-select class=\"text-m\" ng-model=\"currency\" ng-change=\"changeCurrency($select.selected)\"\n                    theme=\"selectize\">\n                    <ui-select-match class=\"text-m\"\n                        placeholder=\"{{ 'cw.dashboard.crypto.wallet.currency' | translate }}\"\n                        >\n                        <span data-ng-bind=\"$select.selected\"></span>\n                    </ui-select-match>\n                    <ui-select-choices class=\"text-m\" repeat=\"currency in currencies | filterCurrencies : $select.search\">\n                        <span class=\"text-m\" data-ng-bind=\"currency\"></span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n        <div class=\"w50 text-right\">\n            <p class=\"text-m text-grey-3\" translate=\"cw.dashboard.crypto.wallet.total_assets\"></p>\n            <p class=\"text-m text-grey-3\">\n                <span class=\"font-bold text-xxl text-grey-1\">≈ {{moneyBalance}} {{currency}}</span>\n            </p>\n            <p class=\"text-m text-grey-1 mt20\" ng-if=\"tfaValidationStep === 'tfaDisabled'\">\n                <i class=\"icon icon-warning inline-block v-middle icon-orange-2 icon-m mr10\"></i>\n                <span class=\"inline-block v-middle text-left\">\n                    <a class=\"underline-hover\"\n                    ng-click=\"goToTFA()\"\n                    ui-sref=\"root.dashboard.my-account({tab: 'security'})\" translate=\"cw.dashboard.crypto.wallet.enable_tfa_1\"></a><br>\n                    <span translate=\"cw.dashboard.crypto.wallet.enable_tfa_2\"></span>\n                </span>\n            </p>\n            <p class=\"text-m text-grey-1 mt20\" ng-if=\"showTimeNotification\">\n                <i class=\"icon icon-checkmark inline-block v-middle icon-green-2 icon-m mr10\"></i>\n                <span class=\"inline-block v-middle text-left\"\n                translate=\"cw.dashboard.crypto.wallet.tfa_message\">\n            </p>\n            <a class=\"btn btn-primary btn-medium mt20\"\n                ng-if=\"showWithdrawButton\"\n                ng-click=\"connectCoinbase()\"\n                translate=\"cw.dashboard.crypto.wallet.withdraw\">\n            </a>\n        </div>\n    </div>\n\n    <div class=\"balances display-flex justify-content-space-between align-item-center mt30\" ng-repeat=\"crypto in cryptoCurrencies\" ng-if=\"!walletIsLoading\">\n        <div class=\"w40\">\n            <div class=\"{{crypto.toLowerCase()}}-green-icon\"></div>\n            <div class=\"inline-block v-middle ml10\">\n                <p class=\"text-xl font-bold\">{{crypto}}</p>\n                <p class=\"text-m text-grey-3\">1 {{crypto}} = {{ethPrice}} {{currency}}</p>\n            </div>\n        </div>\n        <p class=\"amount text-xl text-right font-bold w40\">\n            {{ customToFixed(wallets[crypto].balance, 6) }} {{crypto}}</p>\n    </div>\n\n</div>"

/***/ }),

/***/ "jih4":
/***/ (function(module, exports) {

module.exports = "<news-tabs></news-tabs>\n\n<div class=\"news-content news-container\">\n    <div ng-if=\"isLoading === true\" class=\"main-loader\"><i></i></div>\n    <ul class=\"articles-list security\" ng-if=\"currentCategory === 'threats'\" connectwebqa=\"guides-news/{{currentCategory}}-articles-list\">\n\n        <li class=\"article article-card\" ng-repeat=\"article in news[currentPage - 1][currentCategory]\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-card\">\n            <div class=\"inline-block w25 fl-right article-image-wrapper crs-pointer\" ng-click=\"NewsCtrl.switchView(article.id, currentPage)\">\n                <div class=\"article-image\" style=\"background:url('{{article.image}}');background-size:cover;background-repeat: no-repeat;background-position: center;\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-image\"></div>\n            </div>\n            <div class=\"inline-block w70 article-details\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-details\">\n                <h2 connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-title\">\n                    <a ng-click=\"NewsCtrl.switchView(article.id, currentPage)\">\n                        <strong ng-bind-html=\"article.title.rendered\"></strong>\n                    </a>\n                </h2>\n                <div class=\"details\">\n                    <span\n                        class=\"inline-block v-middle\"\n                        translate=\"cw.news.list_view.details\"\n                        translate-values=\"{\n                            date: '{{article.date}}',\n                            author: '{{article._embedded.author[0].name}}'}\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-time-author\">\n                    </span>\n                    <span\n                        class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-empty'\n                        ng-if=\"article.bookmarkStatus === false\"\n                        ng-click=\"NewsCtrl.saveArticle(article.id, article.bookmarkStatus, currentPage - 1, currentCategory)\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-empty-heart\">\n                    </span>\n                    <span\n                        class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-filled-blue'\n                        ng-if=\"article.bookmarkStatus === true\"\n                        ng-click=\"NewsCtrl.removeArticle(article.id, article.bookmarkStatus, currentPage - 1, currentCategory)\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-filled-heart\">\n                    </span>\n                </div>\n\n                <p ng-bind-html=\"article.shortDescription\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-short-description\"></p>\n\n                <a class='read-more text-blue-3'\n                    ng-click=\"NewsCtrl.switchView(article.id, currentPage)\"\n                    translate=\"cw.news.read_more\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-read-more\">\n                </a>\n            </div>\n        </li>\n    </ul>\n\n    <ul class=\"articles-list guides\" ng-if=\"currentCategory === 'how-to'\" connectwebqa=\"guides-news/{{currentCategory}}-articles-list\">\n        <li class=\"article article-card\" ng-repeat=\"article in news[currentPage - 1][currentCategory]\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-card\">\n            <div class=\"inline-block w25 fl-right article-image-wrapper crs-pointer\" ng-click=\"NewsCtrl.switchView(article.id, currentPage)\">\n                <div class=\"article-image\" style=\"background:url('{{article.image}}');background-size:cover;background-repeat: no-repeat;background-position: center;\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-image\"></div>\n            </div>\n            <div class=\"inline-block w70 article-details\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-details\">\n                <h2 connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-title\">\n                    <a ng-click=\"NewsCtrl.switchView(article.id, currentPage)\">\n                        <strong ng-bind-html=\"article.title.rendered\"></strong>\n                    </a>\n                </h2>\n                <div class=\"details\">\n                    <span\n                        class=\"inline-block v-middle\"\n                        translate=\"cw.news.list_view.details\"\n                        translate-values=\"{\n                            date: '{{article.date}}',\n                            author: '{{article._embedded.author[0].name}}'}\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-time-author\">\n                    </span>\n                    <span\n                        class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-empty'\n                        ng-if=\"article.bookmarkStatus === false\"\n                        ng-click=\"NewsCtrl.saveArticle(article.id, article.bookmarkStatus, currentPage - 1, currentCategory)\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-empty-heart\">\n                    </span>\n                    <span\n                        class='text-blue-3 inline-block v-middle ml5 bookmark-button icon-heart-filled-blue'\n                        ng-if=\"article.bookmarkStatus === true\"\n                        ng-click=\"NewsCtrl.removeArticle(article.id, article.bookmarkStatus, currentPage - 1, currentCategory)\"\n                        connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-filled-heart\">\n                    </span>\n                </div>\n                <p ng-bind-html=\"article.shortDescription\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-short-description\"></p>\n\n                <a class='read-more text-blue-3'\n                    ng-click=\"NewsCtrl.switchView(article.id, currentPage)\"\n                    translate=\"cw.news.read_more\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-read-more\">\n                </a>\n            </div>\n        </li>\n    </ul>\n\n    <ul class=\"articles-list bookmarks\" ng-if=\"currentCategory === 'bookmarks'\" connectwebqa=\"guides-news/{{currentCategory}}-articles-list\">\n        <li class=\"article article-card\" ng-repeat=\"article in bookmarks[currentLanguage]\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-card\">\n            <div>\n                <span\n                    ng-click=\"NewsCtrl.removeArticleBookmarksTab(article.id)\"\n                    class=\"bookmark-button icon-heart-filled-blue inline-block\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-filled-heart\">\n                </span>\n                <h2 class=\"mb10 ml10 inline-block v-top w90\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-title\">\n                    <a ng-click=\"NewsCtrl.switchView(article.id, currentPage)\">\n                        <strong ng-bind-html=\"article.title.rendered\"></strong>\n                    </a>\n                </h2>\n\n                <p ng-bind-html=\"article.shortDescription\" connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-short-description\"></p>\n                <a class='read-more text-blue-3'\n                    ng-click=\"NewsCtrl.switchView(article.id, currentPage)\"\n                    translate=\"cw.news.read_more\"\n                    connectwebqa=\"guides-news/{{currentCategory}}-article-{{$index + 1}}-read-more\">\n                </a>\n            </div>\n        </li>\n        <li ng-if=\"bookmarks[currentLanguage].length === 0\" class=\"mt100\">\n            <div class='text-center text-grey-4 article'>\n                <h2 translate=\"cw.news.empty_bookmarks\" connectwebqa=\"guides-news/{{currentCategory}}-empty-title\">\n                </h2>\n            </div>\n        </li>\n\n    </ul>\n\n    <div ng-if=\"currentCategory === 'threats' || currentCategory === 'how-to'\" ng-show=\"isLoading === false\" class=\"pagination text-center\">\n        <a ng-repeat=\"page in news track by $index\"\n            ng-class=\"currentPages[currentCategory] === $index + 1 ? 'active' : ''\"\n            class=\"inline-block v-middle\"\n            ng-click=\"NewsCtrl.switchPage($index + 1)\"\n            ng-if=\"page[currentCategory].length > 0\"\n            connectwebqa=\"guides-news/{{currentCategory}}-page-{{$index + 1}}\">\n            {{$index + 1}}\n        </a>\n\n    </div>\n</div>"

/***/ }),

/***/ "jmhn":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("7jJu");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "jnYZ":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("S8m2");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "jszl":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "jwra":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
     value: true
});
var _expiredLicenses = [];
var observableExpiredLicenses = new Rx.BehaviorSubject(_expiredLicenses);

/**
     * @ngdoc service
     * @name repositories.ExpiredLicensesRepository
     *
     * @description
     * This class is used to save/add license objects.
     */
var ExpiredLicensesRepository = {

     /**
          * @ngdoc function
          * @name repositories.ExpiredLicensesRepository#replace
          * @methodOf repositories.ExpiredLicensesRepository
          * @function
          *
          * @description
          * This function can be used to replace all stored licenses with provided data.
          *
          * @param {Array} data An array with new licenses.
          */
     replace: function replace(data) {

          _expiredLicenses = this.getExpired(data);
          observableExpiredLicenses.onNext(_expiredLicenses);
     },


     /**
          * @ngdoc function
          * @name repositories.ExpiredLicensesRepository#getExpired
          * @methodOf repositories.ExpiredLicensesRepository
          * @function
          *
          * @description
          * This function can be used to get the expired licenses.
          *
          * @param {Array} data An array with all licenses.
          */
     getExpired: function getExpired(data) {

          return data.filter(function (license) {
               return license.attributes.expired;
          });
     },


     /**
          * @ngdoc function
          * @name repositories.ExpiredLicensesRepository#getAll
          * @methodOf repositories.ExpiredLicensesRepository
          * @function
          *
          * @description
          * This function can be used to retrieves all licenses from repository.
          *
          * @returns {Array} all expired licenses from repository
          */
     getAll: function getAll() {

          return _expiredLicenses;
     },


     /**
          * @ngdoc function
          * @name repositories.ExpiredLicensesRepository#getObservable
          * @methodOf repositories.ExpiredLicensesRepository
          * @function
          *
          * @description
          * This function can be used to get an observable object for expired licenses repository.
          * @returns {Object} an observable object for expired licenses repository.
          */
     getObservable: function getObservable() {

          return observableExpiredLicenses;
     }
};

exports.default = ExpiredLicensesRepository;

/***/ }),

/***/ "k9SW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["c"] = fill;
/* harmony export (immutable) */ __webpack_exports__["f"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["d"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractExceptionKeysForMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dropUndefinedKeys;
/* unused harmony export objectify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("xgwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__("v/3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__("+d4d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__memo__ = __webpack_require__("Ux8H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stacktrace__ = __webpack_require__("c8NG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__("mjKZ");






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        // Accessing event attributes can throw (see https://github.com/getsentry/sentry-javascript/issues/768 and
        // https://github.com/getsentry/sentry-javascript/issues/838), but accessing `type` hasn't been wrapped in a
        // try-catch in at least two years and no one's complained, so that's likely not an issue anymore
        source.type = event_1.type;
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["b" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["b" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_2__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var attr in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, attr)) {
                source[attr] = event_1[attr];
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    // It's safe to use `window` and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.
    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_4__stacktrace__["a" /* getFunctionName */])(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_3__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["h" /* isPlainObject */])(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("GTd5")))

/***/ }),

/***/ "kEQl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var currentDeviceOS = window.deviceOs;

var _directiveDependencies = [];
var _controllerDependencies = ['DeploymentUrlsRestService', '$stateParams', '$window', '$location', '$timeout', '$state', '$scope', 'Util', '$rootScope'];

var PcDeploymentWizardController = function () {
    function PcDeploymentWizardController(DeploymentUrlsRestService, $stateParams, $window, $location, $timeout, $state, $scope, Util, $rootScope) {
        var _this = this;

        _classCallCheck(this, PcDeploymentWizardController);

        this.$window = $window;
        this.$location = $location;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.user = _index.MeRepository.getMyUser();
        this.isMyEmailConfirmed = this.user.attributes.optin !== 'single';
        this.Util = Util;
        this.LicensesRepository = _index.LicensesRepository;
        this.$rootScope = $rootScope;
        this.deployCheck = {
            isEmailValid: false,
            showEmailError: false
        };

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        this.osType = Util.deepFind(this.app, 'attributes.custom.manifest.compatibleWithServer') ? 'server' : 'desktop';

        this.license = this.getLicense();
        this.licenseId = this.Util.deepFind(this.license, 'id') || '';
        this.$scope.isStep2Finished = false;
        this.$scope.isStep3Finished = false;
        this.$scope.app = this.app;

        this.$timeout(function () {

            _this.$rootScope.showDownloadTooltip = false;
        }, 0);

        if (this.$scope.inputData && !this.$scope.inputData.emails) {

            this.$scope.inputData = angular.extend(this.$scope.inputData, { emails: [this.user.attributes.email] });
        }

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();
        }

        this.deployChoose = {
            option: 'download',
            isForMe: !!this.user.id,
            showDownloadTooltip: false,
            waitingResponse: false
        };

        // check if we're on a mobile device
        if (currentDeviceOS === 'android' || currentDeviceOS === 'ios') {

            var isDesktopProduct = ['windows', 'osx'].indexOf(this.$scope.inputData.os) !== -1;
            // and trying to install a desktop product, which hides the download button
            if (isDesktopProduct) {

                this.isFromMobile = true;
                this.deployChoose.option = 'email';
            }
        }
        var timeTooltip = void 0;
        // open download tooltip when receive 'download-tooltip:show' event
        _RFC6.default.subscribe('download-tooltip:show', function () {

            _this.$rootScope.showDownloadTooltip = true;
            timeTooltip = _this.$timeout(function () {

                _this.$rootScope.showDownloadTooltip = false;
            }, CWCONFIG.timeouts.notification);
        });

        // close download tooltip when user close modal
        _RFC6.default.subscribe('modal:close', function () {

            _this.$timeout(function () {

                _this.$rootScope.showDownloadTooltip = false;
            }, 0);
            _this.$timeout.cancel(timeTooltip);
        });

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(function () {

            var deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload'));
            deployViaDownloadElement.on('click', function () {
                return _this.deployViaDownload();
            });
        }, 0);

        this.autoInstall = this.$scope.inputData.autoInstall;
        this.initialautoInstallValue = this.$scope.inputData.autoInstall;
        // if we can automatically install the product initiate deploy sequence
        if (this.autoInstall) {

            this.deployViaDownload();
        }

        var queryParams = this.$location.search();

        // if we get back to the deployment wizard a second time
        // when we deploy on another device, we disable auto install
        this.$scope.inputData = angular.extend(this.$scope.inputData, queryParams, {
            autoInstall: false
        });

        this.deviceNavigator = Util.getDeviceNavigator();

        // if user move mouse outside of browser we will mark that run program step is started
        this.addEvent(document, 'mouseout', function (e) {

            e = e || window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {

                _this.$timeout(function () {

                    _this.$scope.isStep2Finished = true;
                }, 3000);
            }
        });
        // when the app instance repo is updated it means user have succesful install the app,
        // then checkmark the install step
        var appInstancesObservable = _index.AppInstancesRepository.getObservable();
        var appInstancesSubscriber = appInstancesObservable.subscribe(function (data) {
            return _this.appInstancesNext(data);
        }, function () {}, function () {});

        $scope.$on('$destroy', function () {

            appInstancesSubscriber.dispose();

            // this.$rootScope.showPendingInstallCard = true;
            _this.$rootScope.pendingInstallCardOs = _this.$scope.inputData.os;
        });
        this.triggerInstall = false;
    }

    _createClass(PcDeploymentWizardController, [{
        key: 'getPageName',
        value: function getPageName() {

            var pageName = '';

            if (this.$state.current.name.indexOf('.home') > -1) {

                pageName = 'Homepage';
            } else if (this.$state.current.name.indexOf('.devices') > -1) {

                pageName = 'Devices';
            } else if (this.$state.current.name.indexOf('.products') > -1) {

                pageName = 'Products';
            } else if (this.$state.current.name.indexOf('.subscriptions') > -1) {

                pageName = 'Subscriptions';
            }

            return pageName;
        }
    }, {
        key: 'appInstancesNext',
        value: function appInstancesNext() {
            var _this2 = this;

            if (this.triggerInstall) {

                this.$timeout(function () {

                    _this2.$scope.isStep3Finished = true;
                }, 0);
            }
            this.triggerInstall = true;
        }
        // add event to the obj param

    }, {
        key: 'addEvent',
        value: function addEvent(obj, evt, fn) {

            if (obj.addEventListener) {

                obj.addEventListener(evt, fn, false);
            } else if (obj.attachEvent) {

                obj.attachEvent('on ' + evt, fn);
            }
        }

        // find and return license from /licenses

    }, {
        key: 'getLicense',
        value: function getLicense() {
            var _this3 = this;

            var licenseData = void 0;
            var licenseResourceId = this.$state.params.resourceId;

            // try to get license from license id or activation code from URL resourceId param
            licenseData = this.LicensesRepository.getLicenseBy(licenseResourceId) || this.LicensesRepository.getLicenseById(licenseResourceId);

            // try to get license from LicenseRepository based of app id (case for bundle)
            if (!licenseData) {

                licenseData = this.LicensesRepository.getLicenseByAppId(this.$scope.inputData.appId);
            }

            // license not found, try to find license based on component
            if (typeof licenseData === 'undefined') {

                var allLicenses = this.LicensesRepository.getAll();

                /**
                 * Search each appid of each license in appIntegrationRepository
                 */
                allLicenses.forEach(function (license) {

                    // bundle id of each license
                    var licenseBundleId = license.relationships.app.data.id;

                    // get app integration for the bundle id of license
                    var appIntegration = _index.AppIntegrationsRepository.getById(licenseBundleId);

                    // stop at first find
                    if (!licenseData && _this3.Util.deepFind(appIntegration, 'relationships.apps')) {

                        // search component to be deployed (from URL) in components of the bundle
                        appIntegration.relationships.apps.data.find(function (app) {

                            // component found === license found
                            if (app.id === _this3.$scope.inputData.appId) {

                                licenseData = license;

                                return true;
                            }
                            return false;
                        });
                    }
                });
            }

            return licenseData;
        }
    }, {
        key: 'deployViaEmail',
        value: function deployViaEmail() {
            var _this4 = this;

            this.deployChoose.waitingResponse = true;

            _RFC4.default.send('ConnectWeb Deployment Email Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'New User': false,
                'Product ID': this.$scope.inputData.appId,
                'Device Os': window.deviceOs,
                Page: this.getPageName()
            });

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                licenseId: this.licenseId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os,
                meta: {
                    send_email: true,
                    email: this.user.attributes.email
                }
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function () {

                // success handler

                _this4.deployChoose.waitingResponse = false;
                _this4.$scope.inputData = { emails: [_this4.user.attributes.email] };
                _this4.$scope.showSuccessScreen()('email', 'pc', {});
            }, function () {

                // error handler
                _this4.deployChoose.waitingResponse = false;
                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc'
                    }
                });
                _this4.Util.closeModal();
            });
        }
    }, {
        key: 'deployViaDownload',
        value: function deployViaDownload() {
            var _this5 = this;

            _RFC4.default.send('ConnectWeb Deployment Download Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product OS': this.$scope.inputData.os,
                'Product ID': this.$scope.inputData.appId,
                'Device Os': window.deviceOs,
                Page: this.getPageName()
            });

            this.deployChoose.waitingResponse = true;

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                license_number: this.licenseId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                // success handler

                _this5.deployChoose.waitingResponse = false;
                var downloadUrl = _this5.Util.deepFind(response, 'data.data.attributes.download_url');

                if (downloadUrl) {

                    if (!_this5.initialautoInstallValue) {

                        _this5.$scope.showSuccessScreen()('download', 'pc', {});
                    }

                    _this5.$window.location.href = downloadUrl;

                    var timeTooltip = _this5.$timeout(function () {

                        _RFC6.default.broadcast('download-tooltip:show');
                        _this5.$timeout.cancel(timeTooltip);
                    }, 2500);

                    _this5.$rootScope.showPendingInstallCard = true;
                } else {

                    _RFC2.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {
                            cssClasses: 'icon-pc'
                        }
                    });
                    _this5.Util.closeModal();
                }
            }, function () {

                // error handler


                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc'
                    }
                });
                _this5.Util.closeModal();
            });
        }
    }, {
        key: 'deployOnAnotherDevice',
        value: function deployOnAnotherDevice() {

            var stateName = this.$state.current.name;

            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';
            }

            var stateParams = angular.extend({ ltb: 'deploy' }, this.$stateParams);

            // if we're on the subscriptions page we always install on a new device
            // to simplify the flow
            if (stateName.indexOf('subscriptions') !== -1 || stateName.indexOf('store') !== -1 || stateName.indexOf('home') !== -1) {

                stateParams = angular.extend(stateParams, { deviceId: 'new', appId: this.$scope.inputData.appId });
            }

            var page = 'None';

            if (stateName.indexOf('.products') !== -1) {

                page = 'Products';
            } else if (stateName.indexOf('.subscriptions') !== -1) {

                page = 'Subscriptions';
            } else if (stateName.indexOf('.store') !== -1) {

                page = 'Store';
            } else if (stateName.indexOf('.home') !== -1) {

                page = 'Homepage';
            }

            _RFC4.default.send('ConnectWeb Install Click', {
                Product: this.Util.deepFind(this.app, 'attributes.resource.oeName'),
                'Product ID': this.app.id,
                Page: page,
                Label: 'Other Device'
            });

            this.$scope.changeWizard()(stateName, stateParams, {
                reload: false
            });
        }
    }]);

    return PcDeploymentWizardController;
}();

var PcDeploymentWizardDirective = function PcDeploymentWizardDirective() {
    _classCallCheck(this, PcDeploymentWizardDirective);

    this.template = __webpack_require__("nIpj");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (DeploymentUrlsRestService, $stateParams, $window, $location, $state, $scope, $timeout, Util, $rootScope) {
        return new PcDeploymentWizardController(DeploymentUrlsRestService, $stateParams, $window, $location, $state, $scope, $timeout, Util, $rootScope);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'pcDeploymentWizardCtrl';
};

_directiveDependencies.push(function () {
    return new PcDeploymentWizardDirective();
});

angular.module('directives').directive('pcDeploymentWizard', _directiveDependencies);

/***/ }),

/***/ "kEiM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$stateParams', '$http', '$rootScope', 'Util'];

var DwmNotifications = function DwmNotifications($scope, $stateParams, $http, $rootScope, Util) {
    _classCallCheck(this, DwmNotifications);

    var notificationId = $stateParams.resourceId;
    $scope.user = _index.MeRepository.getMyUser();
    $scope.showOtpScreen = false;
    $scope.addOtpScreen = false;
    $scope.otpCode = { value: '' };

    var onDwmDataNext = function onDwmDataNext() {

        var alertsDetails = _index.dwmRepository.getAll('alertsDetails');
        var statusApi = _index.dwmRepository.getAll('statusApi');

        if (Object.keys(statusApi).length) {

            var aiaSubscriptioneStatus = Util.deepFind(statusApi, 'products.identityAssist.subscriptionStatus');
            var dwmLiteSubscriptionStatus = Util.deepFind(statusApi, 'products.dwmLite.subscriptionStatus');

            var aiaSubscriptionCancelled = aiaSubscriptioneStatus === 'cancelled' || aiaSubscriptioneStatus === 'none' || aiaSubscriptioneStatus === 'unknown';
            var dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none' || dwmLiteSubscriptionStatus === 'unknown';
            var aiaSubscriptionActive = aiaSubscriptioneStatus === 'active';
            var dwmLiteSubscriptionActive = dwmLiteSubscriptionStatus === 'active';

            if (aiaSubscriptionCancelled && !aiaSubscriptionActive && !dwmLiteSubscriptionActive) {

                Util.closeModal();
            } else if (dwmLiteSubscriptionCancelled && !aiaSubscriptionActive && !dwmLiteSubscriptionActive) {

                Util.closeModal();
            }
        }

        if (!alertsDetails[notificationId]) {

            $scope.notificationStatus = 'loading';
        } else {

            $scope.notificationStatus = 'loaded';

            var alertDetail = alertsDetails[notificationId];
            var configNextSteps = CWCONFIG.dwm.nextStepsLinks;

            var currentLanguage = CWCONFIG.language;

            var redirectLanguage = '';
            if (currentLanguage === 'en') {

                redirectLanguage = 'en-us';
            } else {

                redirectLanguage = currentLanguage;
            }

            alertDetail.detailViews.forEach(function (alert) {

                var section6 = alert.sections.find(function (section) {
                    return section.sectionId === 'next_steps';
                });
                var section6Index = alert.sections.findIndex(function (section) {
                    return section.sectionId === 'next_steps';
                });

                if (section6) {

                    if (section6.params) {

                        section6.params.forEach(function (param) {

                            var aviraLink = configNextSteps.find(function (link) {
                                return link.action === param.action;
                            });
                            var link = void 0;

                            if (aviraLink) {

                                link = '<a href=\'' + aviraLink.articleUrl.replace(/\[language\]/gi, redirectLanguage) + '\' ' + (aviraLink.target ? 'target=_blank' : '') + ' class=\'text-blue-1\'>' + param.displayText.replace('Norton', 'Avira') + '</a>';
                            }

                            var stringToReplace = '${' + param.paramName + '}';

                            var paramToReplace = void 0;

                            if (section6.data) {

                                paramToReplace = section6.data.find(function (data) {
                                    return data.indexOf(stringToReplace) > -1;
                                });
                            } else if (section6.text) {

                                paramToReplace = section6.text.find(function (data) {
                                    return data.indexOf(stringToReplace) > -1;
                                });
                            }

                            if (paramToReplace) {

                                paramToReplace = paramToReplace.replace(stringToReplace, link);
                            }

                            if (section6.data) {

                                section6.data.forEach(function (data, index2) {

                                    alert.sections[section6Index].data[index2] = data.replace(stringToReplace, link);
                                });
                            }

                            if (section6.text) {

                                section6.text.forEach(function (data, index2) {

                                    alert.sections[section6Index].text[index2] = data.replace(stringToReplace, link);
                                });
                            }
                        });
                    }
                }
            });
        }

        if ($rootScope.dwmNortonToken && !alertsDetails[notificationId]) {

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/alerts/' + notificationId,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                    lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US'
                }

            }).then(function (response) {

                _index.dwmRepository.updateAlertsDetails(notificationId, response.data.alertDetail);
                $scope.notificationStatus = 'loaded';
            }).catch(function () {

                $scope.notificationStatuses = 'error';
                _RFC2.default.error('cw.modal.server-error.desc');
            });
        } else if (Object.keys(alertsDetails).length > 0 && notificationId) {

            $scope.notifications = alertsDetails[notificationId];
            $scope.hasPagination = $scope.notifications.detailViews.length > 1;
            $scope.notificationIndex = 0;
            $scope.nextArrowEnabled = true;
            $scope.prevArrowEnabled = false;
            $scope.activePage = 1;
            $scope.notification = alertsDetails[notificationId].detailViews[$scope.notificationIndex];
        }
    };

    $scope.nextPage = function () {

        $scope.activePage += 1;
        $scope.notificationIndex += 1;
        $scope.nextArrowEnabled = !!($scope.activePage < $scope.notifications.detailViews.length);
        $scope.prevArrowEnabled = !!($scope.activePage !== 1);
        $scope.notification = $scope.notifications.detailViews[$scope.notificationIndex];
    };

    $scope.prevPage = function () {

        $scope.activePage -= 1;
        $scope.notificationIndex -= 1;
        $scope.nextArrowEnabled = !!($scope.activePage < $scope.notifications.detailViews.length);
        $scope.prevArrowEnabled = !!($scope.activePage !== 1);
        $scope.notification = $scope.notifications.detailViews[$scope.notificationIndex];
    };

    $scope.showPassword = function (email) {

        _RFC4.default.send('ConnectWeb AIA Notification Show Password Click');
        $scope.showOtpScreen = true;
        $scope.currentNotificationEmailAddress = email;
    };

    $scope.showAddOtpScreen = function () {

        $scope.addOtpScreen = true;
    };

    $scope.sendOtpOnEmail = function () {

        $scope.loading = true;

        $http({
            method: 'POST',
            url: CWCONFIG.dwm.restApi + '/v1/auth/email',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: {
                emailAddress: $scope.currentNotificationEmailAddress,
                alertId: notificationId
            }

        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Notification Send OTP Success');
            $scope.loading = false;
            $scope.addOtpScreen = true;
        }).catch(function () {

            $scope.loading = false;
            _RFC2.default.error('cw.modal.server-error.desc');
        });
    };

    $scope.requestNewCode = function () {

        $scope.otpCode = { value: '' };
        $scope.otpError = false;
        $scope.addOtpScreen = false;
    };

    $scope.updateOtpError = function () {

        $scope.otpError = false;
    };

    $scope.verifyOtpOnEmail = function () {

        $scope.loading = true;
        $scope.otpError = false;

        if ($scope.otpCode.value && $scope.otpCode.value.length === 6) {

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/auth/email/verify',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: {
                    emailAddress: $scope.currentNotificationEmailAddress,
                    otp: $scope.otpCode.value
                }
            }).then(function () {

                _RFC4.default.send('ConnectWeb AIA Notification Verify OTP Success');
                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/alerts/' + notificationId,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                        lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US'
                    }

                }).then(function (response) {

                    _index.dwmRepository.updateAlertsDetails(notificationId, response.data.alertDetail);

                    $scope.loading = false;
                    $scope.showOtpSuccess = true;
                }).catch(function () {

                    $scope.loading = false;
                    $scope.notificationStatuses = 'error';
                    _RFC2.default.error('cw.modal.server-error.desc');
                });
            }).catch(function (responseError) {

                $scope.loading = false;
                $scope.otpError = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 150002) {

                        _RFC2.default.error('cw.auth.tfa.error.expired_otp');
                    } else {

                        _RFC2.default.error('w.modal.server-error.desc');
                    }
                }
            });
        } else {

            $scope.loading = false;
            $scope.otpError = true;
        }
    };

    $scope.backToNotification = function () {

        $scope.showOtpScreen = false;
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    var dwmSubscriber = dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.$on('$destroy', function () {

        if ($rootScope.dwmNortonToken) {

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/alerts',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                    lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US'
                }

            }).then(function (alertsResponse) {

                _index.dwmRepository.replace('alerts', alertsResponse.data);

                var aiaUnreadAlerts = 0;
                var aiaReadAlerts = 0;

                if (alertsResponse.data.alertList.length > 0) {

                    alertsResponse.data.alertList.forEach(function (alert) {

                        if (alert.isRead === false && alert.bucket === 'inbox') {

                            aiaUnreadAlerts += 1;
                        }
                    });

                    aiaReadAlerts = alertsResponse.data.alertList.length - aiaUnreadAlerts;
                }

                if (aiaUnreadAlerts > 0) {

                    $rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;
                } else if (aiaUnreadAlerts === 0 && $rootScope.dwmCardUnreadNotifications > 0) {

                    $rootScope.showDwmCardHomepage = false;
                    $rootScope.showDwmUnreadNotificationsCard = false;
                }

                _RFC4.default.setCommonProperty('AIA Unread Alerts', aiaUnreadAlerts);
                _RFC4.default.setCommonProperty('AIA Read Alerts', aiaReadAlerts);

                dwmSubscriber.dispose();
            }).catch(function () {

                _RFC2.default.error('cw.modal.server-error.desc');
                dwmSubscriber.dispose();
            });
        }
    });

    _RFC4.default.send('ConnectWeb AIA Notification Open');
};

_serviceDependencies.push(DwmNotifications);

angular.module('controllers').controller('DwmNotifications', _serviceDependencies);

/***/ }),

/***/ "kaM4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* jshint bitwise : false */
/* eslint no-bitwise: 0 */
angular.module('filters').filter('formatTime', ['$translate', 'Util', function ($translate, Util) {
    return function (diffTime, actionDone, actionFailed, format) {

        format = format === 'short' ? '_short' : '';

        diffTime = Util.getElapsedMilli(diffTime);

        actionFailed = !actionFailed ? $translate.instant('cw.general.time.unknown') : $translate.instant(actionFailed);
        actionDone = !actionDone ? '' : $translate.instant(actionDone);

        if (!diffTime) {

            return actionFailed;
        }

        if (diffTime < 0) {

            diffTime = 0;
        }

        var seconds = Math.floor(diffTime / 1000);
        var interval = Math.floor(seconds / 31536000);

        var timeAgo = function getTimeAgo() {

            if (interval >= 2) {

                return ['years_ago', ~~interval];
            } else if (interval >= 1) {

                return ['year_ago', ~~interval];
            }

            interval = seconds / 2592000;
            if (interval >= 2) {

                return ['months_ago', ~~interval];
            } else if (interval >= 1) {

                return ['month_ago', ~~interval];
            }

            interval = seconds / 604800;
            if (interval >= 2) {

                return ['weeks_ago', ~~interval];
            } else if (interval >= 1) {

                return ['week_ago', ~~interval];
            }

            interval = seconds / 86400;
            if (interval >= 2) {

                return ['days_ago', ~~interval];
            } else if (interval >= 1) {

                return ['day_ago', ~~interval];
            }

            interval = seconds / 3600;
            if (interval >= 2) {

                return ['hours_ago', ~~interval];
            } else if (interval >= 1) {

                return ['hour_ago', ~~interval];
            }

            interval = seconds / 60;
            if (interval >= 2) {

                return ['minutes_ago', ~~interval];
            } else if (interval >= 1) {

                return ['minute_ago', ~~interval];
            }

            return ['just_now', seconds];
        }();

        return actionDone + ' ' + $translate.instant('cw.general.time.' + timeAgo[0] + format, { interval: timeAgo[1] });
    };
}]);

/***/ }),

/***/ "kdEy":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"card-header\">\n        <h3 class=\"text-grey-1 text-l font-bold\" translate=\"cw.homepage.devices.title\" ng-if=\"!lastDeviceAdded\"></h3>\n        <h3 class=\"text-grey-1 text-l font-bold\" translate=\"cw.homepage.devices.last_device_added\" ng-if=\"lastDeviceAdded\"></h3>\n        <a ng-if=\"lastDeviceAdded && devicesLength > 1\"\n            ui-sref=\"root.dashboard.devices\" class=\"text-s text-blue-1\"\n            translate=\"cw.homepage.devices.view_multiple\"\n            translate-values=\"{devices: '{{devicesLength}}'}\"\n            ng-click=\"sendDevicesMixpanel('View all devices')\"></a>\n        <a ng-if=\"lastDeviceAdded && devicesLength === 1\"\n            ui-sref=\"root.dashboard.devices\" class=\"text-s text-blue-1\"\n            translate=\"cw.homepage.devices.view_single\"\n            translate-values=\"{devices: '{{devicesLength}}'}\"\n            ng-click=\"sendDevicesMixpanel('View all devices')\"></a>\n    </div>\n\n    <div class=\"inline-block left-column v-middle p-relative\"\n        ng-if=\"lastDeviceAdded\">\n        <i class=\"icon icon-{{lastDeviceAdded.attributes.type}}-{{lastDeviceAdded.attributes.os}} icon-grey-3\"></i>\n        <div class=\"inline-block w100\">\n            <p class=\"text-grey-1 text-l mb5 device-name\" title='{{lastDeviceAdded.name}}'>{{lastDeviceAdded.name}}</p>\n            <!-- Free user - single product -->\n            <p class=\"text-grey-3 text-m\"\n                ng-if='lastDeviceAdded.attributes.licenses.length === 0 && lastDeviceAdded.attributes.freeProductsInstalled.length === 1'\n                translate=\"cw.homepage.devices.license_installed\"\n                translate-values=\"{license: '{{lastDeviceAdded.attributes.freeProductsInstalled[0]}}' }\">\n            </p>\n            <!-- Free user - multiple products -->\n            <p class=\"text-grey-3 text-m\"\n                ng-if='lastDeviceAdded.attributes.licenses.length === 0 && lastDeviceAdded.attributes.freeProductsInstalled.length > 1'\n                translate=\"cw.homepage.devices.free_products\"\n                translate-values=\"{brandname : brandName}\">\n            </p>\n            <!-- No products installed  -->\n            <p class=\"text-grey-3 text-m\"\n                ng-if='lastDeviceAdded.attributes.licenses.length === 0 && lastDeviceAdded.attributes.freeProductsInstalled.length === 0'\n                translate=\"cw.homepage.devices.no_products_installed\">\n            </p>\n            <!-- Paid user - single license  -->\n            <p class=\"text-grey-3 text-m\"\n                ng-if='lastDeviceAdded.attributes.licenses.length === 1'\n                translate=\"cw.homepage.devices.license_installed\"\n                translate-values=\"{license: '{{lastDeviceAdded.attributes.licenses[0]}}' }\">\n            </p>\n            <!-- Paid user - multiple licenses  -->\n            <div class=\"text-grey-3 text-m inline-block\" ng-if='lastDeviceAdded.attributes.licenses.length > 1'>\n                <span class='custom-tooltip-holder'>\n                    <span translate=\"cw.homepage.devices.licenses_installed\"></span>\n                    <div class=\"info-tooltip-holder ml5\">\n                        <span class=\"icon icon-info text-blue-1 icon-xs\"></span>\n                        <div class=\"info-tooltip arrow-bottom\">\n                            <p ng-repeat=\"license in lastDeviceAdded.attributes.licenses\">\n                                {{license}}\n                            </p>\n                        </div>\n                    </div>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"inline-block left-column v-middle no-devices\"\n        ng-if=\"!lastDeviceAdded\">\n        <h4 class=\"text-m text-grey-1 mb5\" translate=\"cw.homepage.devices.no_devices_title\"></h4>\n        <p class=\"text-s text-grey-3\" translate=\"cw.homepage.devices.no_devices_desc_2\" translate-values=\"{brandname : brandName}\"></p>\n    </div>\n\n    <div class=\"inline-block right-column text-center v-middle\">\n        <p class=\"text-grey-3 text-m mb10 header\"\n            ng-if=\"lastDeviceAdded\"\n            translate=\"cw.homepage.devices.protect_more_devices\">\n        </p>\n        <!-- Device added -->\n        <div ng-if=\"lastDeviceAdded\">\n            <a class='btn btn-medium btn-primary btn-full-width text-m'\n                ng-click=\"deployOnCategory('all')\"\n                translate=\"cw.mkt.antitheft.card.activation_button_nd\"\n                ng-if=\"lastDeviceAdded.attributes.licenses.length > 0 || lastDeviceAdded.attributes.freeProductsInstalled.length > 0 || licenses.length > 0 || activationCodes.length > 0\"></a>\n\n            <a class='btn btn-medium btn-primary btn-full-width text-m'\n                ng-click=\"deployOnCategory('all')\"\n                ng-if=\"lastDeviceAdded.attributes.licenses.length === 0 && lastDeviceAdded.attributes.freeProductsInstalled.length === 0 && licenses.length === 0 && activationCodes.length === 0\"\n                translate=\"cw.homepage.devices.install_fss\"\n                translate-values= \"{brandname: brandName}\">\n            </a>\n        </div>\n\n        <!-- No device added -->\n        <div ng-if=\"!lastDeviceAdded\">\n            <a class='btn btn-medium btn-primary btn-full-width text-m'\n                ng-click=\"deployOnCategory('all')\"\n                ng-if=\"licenses.length === 0 && activationCodes.length === 0\"\n                translate=\"cw.homepage.devices.install_fss\"\n                translate-values= \"{brandname: brandName}\">\n            </a>\n\n            <a class='btn btn-medium btn-primary btn-full-width text-m'\n                ng-click=\"deployOnCategory('all')\"\n                ng-if=\"licenses.length > 0 || activationCodes.length > 0\"\n                translate=\"cw.mkt.antitheft.card.activation_button_nd\">\n            </a>\n        </div>\n\n    </div>\n</div>"

/***/ }),

/***/ "khiU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var processedIssues = []; /**
                           * Issues Processor - issues grouped deviceId,
                           * must be taken from the AppInstancesRepository
                           */

var observableProcessedIssues = new Rx.BehaviorSubject(processedIssues);
var subjectAppInstancesRepository = _index.AppInstancesRepository.getObservable();
var subjectDevicesRepository = _index.DevicesRepository.getObservable();
/**
 * @ngdoc service
 * @name processors.IssuesProcessor
 *
 * @description
 * IssuesProcessor.
 */
var IssuesProcessor = {

    /**
     * Replace all instances with received data
     * @param {Array} data
     */
    onNext: function onNext(data) {
        var _this = this;

        processedIssues = [];
        data.forEach(function (appInstance) {

            if (_this._hasIssueOn(appInstance)) {

                _this.addIssue(appInstance);
            }
        });

        observableProcessedIssues.onNext(processedIssues);
    },
    _hasIssueOn: function _hasIssueOn(instance) {

        // Get device by instance
        var device = void 0;
        if (instance.relationships.device) {

            device = _index.DevicesRepository.getById(instance.relationships.device.data.id);
        }

        // Detect issues only if the device is online/offline
        if (device && (device.attributes.state === 'online' || device.attributes.state === 'offline') && !device.attributes.hidden) {

            if (instance.attributes.status.svc && instance.attributes.app_status === 'not_protected' && (instance.attributes.status.svc.guard !== 1 || instance.attributes.status.svc.firewall !== 1 || instance.attributes.status.svc.mailguard !== 1 || instance.attributes.status.svc.webguard !== 1) && instance.attributes.state === 'active') {

                return true;
            }
        }
        return false;
    },


    /**
     * Add issue based on its deviceId
     * @param appInstance
     */
    addIssue: function addIssue(appInstance) {

        var deviceId = appInstance.relationships.device.data.id;
        processedIssues[deviceId] = appInstance;
    },


    /**
     * @ngdoc function
     * @name processors.IssuesProcessor#getAll
     * @methodOf processors.IssuesProcessor
     * @function
     *
     * @description
     * This function can be used to retun all processed issues.
     *
     * @returns {Array} all processed issues
     */
    getAll: function getAll() {

        return processedIssues;
    },
    getObservable: function getObservable() {

        return observableProcessedIssues;
    }
};

// subscribe on instances changes

subjectAppInstancesRepository.subscribe(function (data) {
    return IssuesProcessor.onNext(data);
}, function () {}, function () {});

// subscribe on devices changes

subjectDevicesRepository.subscribe(function () {

    subjectAppInstancesRepository.onNext(_index.AppInstancesRepository.getAll());
}, function () {}, function () {});

exports.default = IssuesProcessor;

/***/ }),

/***/ "kodP":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content\">\n\n\t<div class=\"lock-device-screen\"></div>\n\n\t<h1 class=\"text-xxl mb20\" translate=\"cw.ui.general.change_permissions\"></h1>\n\n\t<p class=\"text-l text-grey-4 mb30\" translate=\"cw.lock_device.confirmation\" translate-values=\"{device: (device | deviceName), brandname : brandName}\"></p>\n\n\t<button class=\"btn btn-secondary btn-medium inline-block mlr10\" ng-click=\"close()\" translate=\"cw.general.ui.decline\"></button>\n\n\t<button class=\"btn btn-primary btn-medium inline-block\" ng-click=\"lockDevice()\" translate=\"cw.general.ui.confirm\"></button>\n</div>\n";
var path = 'scripts/controllers/modals/device/lock-device/lock-device.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "kxrs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('convertOSVersion', function () {
    return function (versionNr, osType) {

        var version = versionNr;
        /* for desktop versions take only the number from the versionNr */
        if (osType === 'desktop') {

            version = parseFloat(versionNr);
            if (version === 10) {

                if (versionNr.split('.')[2] && parseFloat(versionNr.split('.')[2].slice(0, 2)) > 21) {

                    version = 11;
                }
            }

            if (Number.isNaN(version)) {

                return '';
            }
        }

        switch (version) {

            case 6.1:
                return !osType || osType === 'desktop' ? '7' : 'Server 2008 R2';
            case 6.0:
                return !osType || osType === 'desktop' ? 'Vista' : 'Server 2008';
            case 6.3:
                return !osType || osType === 'desktop' ? '8.1' : 'Server 2012';
            case 6.2:
                return !osType || osType === 'desktop' ? '8' : '';
            case 5.2:
                return !osType || osType === 'desktop' ? 'XP 64-Bit' : 'Server 2003';
            case 5.1:
                return !osType || osType === 'desktop' ? 'XP' : '';
            case 5.0:
                return !osType || osType === 'desktop' ? '2000' : '';
            case 8.1:
                return !osType || osType === 'desktop' ? '8.1' : 'Server 2012';
            case 10.0:
                return !osType || osType === 'desktop' ? '10' : '';
            case 11.0:
                return !osType || osType === 'desktop' ? '11' : '';
            case 'iPhone1,1':
                return 'iPhone';
            case 'iPhone1,2':
                return 'iPhone 3G';
            case 'iPhone2,1':
                return 'iPhone 3GS';
            case 'iPhone3,1':
            case 'iPhone3,2':
            case 'iPhone3,3':
                return 'iPhone 4';
            case 'iPhone4,1':
                return 'iPhone 4S';
            case 'iPhone5,1':
            case 'iPhone5,2':
                return 'iPhone 5';
            case 'iPhone5,3':
            case 'iPhone5,4':
                return 'iPhone 5C';
            case 'iPhone6,1':
            case 'iPhone6,2':
                return 'iPhone 5S';
            case 'iPhone7,2':
                return 'iPhone 6';
            case 'iPhone7,1':
                return 'iPhone 6 Plus';
            case 'iPhone8,1':
                return 'iPhone 6S';
            case 'iPhone8,2':
                return 'iPhone 6S Plus';
            case 'iPad1,1':
                return 'iPad';
            case 'iPad2,1':
            case 'iPad2,2':
            case 'iPad2,3':
                return 'iPad 2';
            case 'iPad3,1':
            case 'iPad3,2':
            case 'iPad3,3':
                return 'iPad 3';
            case 'iPad3,4':
            case 'iPad3,5':
            case 'iPad3,6':
                return 'iPad 4';
            case 'iPad4,1':
            case 'iPad4,2':
            case 'iPad4,3':
                return 'iPad Air';
            case 'iPad5,3':
            case 'iPad5,4':
                return 'iPad Air 2';
            case 'iPad6,7':
            case 'iPad6,8':
                return 'iPad Pro';
            case 'iPad2,5':
            case 'iPad2,6':
            case 'iPad2,7':
                return 'iPad mini';
            case 'iPad4,4':
            case 'iPad4,5':
            case 'iPad4,6':
                return 'iPad mini 2';
            case 'iPad4,7':
            case 'iPad4,8':
            case 'iPad4,9':
                return 'iPad mini 3';
            case 'iPad5,1':
            case 'iPad5,2':
                return 'iPad mini 4';

            default:
                return '';

        }
    };
});

/***/ }),

/***/ "l+/6":
/***/ (function(module, exports) {

module.exports = "<form name=\"form.renameDevice\" role=\"form\" ng-submit=\"rename()\" novalidate>\n    <div class=\"form-group rename-device__form\">\n        <input\n        type=\"text\"\n        name=\"name\"\n        maxlength=\"40\"\n        id=\"renameDevice\"\n        class=\"rename-device__input text-xl\"\n        ng-class=\"{'error': form.submitted && form.renameDevice.name.$invalid}\"\n        spellcheck=\"false\"\n        autocorrect=\"off\"\n        autocomplete=\"off\"\n        autocapitalize=\"off\"\n        autofocus\n        ng-model=\"localDevice.name\"\n        ng-pattern=\"localDevice.nameRegExp\"\n        ng-blur=\"rename()\"\n        onblur=\"this.focus()\"\n        ng-hide=\"!localDevice.isEditable\"\n        required\n        connectqa-devicename=\"{{localDevice.name}}\"\n        connectqa-input=\"rename-device\">\n        <div class=\"device-name-label text-l text-grey-2 inline-block\" ng-click=\"toggleEditable()\" ng-hide=\"localDevice.isEditable\" title=\"{{localDevice.name}}\">\n            <span class=\"device-status-dot\"\n                ng-class=\"{'online': localDevice.status === 'online'}\"\n                ng-if=\"localDevice.type === 'laptop' || localDevice.type === 'pc'\"></span>\n            {{localDevice.name}}\n        </div>\n        <i class=\"icon icon-edit icon-grey-4 icon-xxs rename-device__icon inline-block ml10 crs-pointer\"\n            ng-hide=\"localDevice.isEditable || isOnListView\"\n            connectqa-device=\"edit\" ng-click=\"toggleEditable()\"></i>\n        <div ng-show=\"form.submitted && form.renameDevice.name.$invalid\">\n            <p class=\"error-message rename-device__form-error\" ng-if=\"form.renameDevice.name.$error.required\" translate=\"cw.validator.messages.required\"></p>\n            <p class=\"error-message rename-device__form-error ru-fix\" ng-if=\"form.renameDevice.name.$error.pattern\" translate=\"cw.validator.messages.invalid\"></p>\n        </div>\n    </div>\n</form>"

/***/ }),

/***/ "l+DQ":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("8ZmK"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ "lCSl":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("K2yx");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "lD2H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _index = __webpack_require__("lSlM");

var _loggers = __webpack_require__("+htc");

var _RFC = __webpack_require__("LBU6");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFCSession = __webpack_require__("DyxV");

var _RFCUtil = __webpack_require__("fIlE");

var _RFCUtil2 = _interopRequireDefault(_RFCUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _events = [];

var _commonProperties = {
    Language: CWCONFIG.language,
    OS: window.navigator.platform,
    'OS Detailed': _RFC2.default.getOSVersion(),
    'Browser Version': window.browserName + window.browserVersion,
    'Device Size': window.screen.width + 'x' + window.screen.height,
    'Browser Size': window.innerWidth + 'x' + window.innerHeight,
    'User Type': 'unregistered', // if no anonymous jwt token
    'Referral Code': 'None',
    'Redirect Client': 'None', // SSO thirdParty login
    'Campaign Name': 'None',
    'Content Id': 'None',
    'Redirect URI': 'None',
    Licenses: '',
    'Licenses Names': '',
    'Runtimes Remaining': '',
    'Runtimes Remaining Min': '',
    'Runtimes Remaining Max': '',
    'Subscription Statuses': '',
    'Subscription Types': '',
    'Valid Payment Method': '',
    'Subscription Runtimes': '',
    Theme: localStorage.getItem('theme').indexOf('dark') > -1 ? 'Dark' : 'Light'
};

// observable for MeRepository
var meSubscriber = void 0;
var meObservable = _index.MeRepository.getObservable();
var onNextMe = function onNextMe(user) {

    if (user) {

        _commonProperties['User Type'] = _RFCUtil2.default.isAnonymous() ? 'anonymous' : 'registered';

        /* unsubscribe meObservable when the user is not anonymous anymore */
        if (user.data.attributes.email) {

            meSubscriber.dispose();
        }
    }
};
meSubscriber = meObservable.subscribe(onNextMe, function () {}, function () {});

_RFCSession.Session.Observable().from(_RFCSession.SessionKeys.ReferralCode).subscribe(function () {

    _commonProperties['Referral Code'] = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ReferralCode);
}, angular.noop, angular.noop);

_RFCSession.Session.Observable().from(_RFCSession.SessionKeys.SsoExtraUrlParams).subscribe(function () {

    // SSO set the client_id, redirect_uri and campaign params to mixpanel common
    var ssoParams = sessionStorage.getItem('SsoExtraUrlParams');
    if (ssoParams) {

        var parsedSsoParams = JSON.parse(ssoParams);

        _commonProperties['Redirect Client'] = parsedSsoParams.client_id || 'None';
        _commonProperties['Campaign Name'] = parsedSsoParams.campaign || 'None';
        _commonProperties['Content Id'] = parsedSsoParams.content_id || 'None';
        _commonProperties['Campaign Type'] = parsedSsoParams.campaign_type || 'None';
        _commonProperties['Redirect URI'] = parsedSsoParams.redirect_uri || 'None';

        if (_commonProperties['Redirect URI'] !== 'None') {

            var redirectParams = _commonProperties['Redirect URI'].split('/');

            if (redirectParams.includes('identity-assistant') && redirectParams.includes('ltb') && redirectParams.includes('notifications')) {

                redirectParams.splice(redirectParams.indexOf('ltb') - 1, 1);
                var redirectNotificationUrl = redirectParams.join('/');
                _commonProperties['Redirect URI'] = redirectNotificationUrl;
            }
        }

        if (parsedSsoParams.cw_ref_code) {

            _commonProperties['Referral Code'] = parsedSsoParams.cw_ref_code;
        } else if (parsedSsoParams.redirect_uri && parsedSsoParams.redirect_uri.indexOf('cw_ref_code') > -1) {

            var redirectUri = parsedSsoParams.redirect_uri;
            var params = redirectUri.split('?');

            if (params.length > 0) {

                var refCodeIndex = params.findIndex(function (param) {
                    return param.indexOf('cw_ref_code') > -1;
                });
                if (refCodeIndex) {

                    var splittedParams = params[refCodeIndex].split('=');
                    var _splittedParams = splittedParams;

                    var _splittedParams2 = _slicedToArray(_splittedParams, 2);

                    splittedParams = _splittedParams2[1];

                    _commonProperties['Referral Code'] = splittedParams;
                }
            }
        }
    }

    // retrieve the x-a-* params and add them to the mixpanel common properties
    var queryParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.SsoExtraUrlParams);
    Object.keys(queryParams).forEach(function (key) {

        if (key.indexOf('x-a-') > -1) {

            _commonProperties[key] = queryParams[key];
        }
    });
}, angular.noop, angular.noop);

/**
 * @ngdoc service
 * @name services.Mixpanel
 *
 * @description
 * This class is a wrapper over mixpanel library.
 */
var Mixpanel = {

    /**
     * @ngdoc function
     * @name services.Mixpanel#send
     * @methodOf services.Mixpanel
     * @function
     *
     * @description
     * This method is used to send mixapanel events
     *
     * @param {string} eventName The name of the event. This can be anything
     * @param {object} properties A set of properties to include with the event you're sending
     */
    send: function send(eventName, properties) {

        var payloadMixpanel = {};
        angular.extend(payloadMixpanel, _commonProperties);

        if (angular.isObject(properties)) {

            angular.extend(payloadMixpanel, properties);
        }

        _events.push(eventName);

        _loggers.mixpanelLogger.info({
            type: eventName,
            data: payloadMixpanel
        });

        // disable the event tracking for the internal test users eg. test@oemail.avira.com
        var user = _index.MeRepository.getMyUser();
        if (user && user.attributes.email && user.attributes.email.endsWith('.avira.com')) {

            return null;
        }
        return window.mixpanel.track(eventName, payloadMixpanel);
    },


    /**
     * @ngdoc function
     * @name services.Mixpanel#getEvents
     * @methodOf services.Mixpanel
     * @function
     *
     * @description
     * This method returns event list
     *
     * @returns {array} list of events
     */
    getEvents: function getEvents() {

        return _events;
    },


    /**
    * @ngdoc function
    * @name services.Mixpanel#clearEvents
    * @methodOf services.Mixpanel
    * @function
    *
    * @description
    * This method remove all events from list
    */
    clearEvents: function clearEvents() {

        _events = [];
    },


    /**
    * @ngdoc function
    * @name services.Mixpanel#clearCommonProperty
    * @methodOf services.Mixpanel
    * @function
    *
    * @description
    * This method removes a property from the default Mixpanel properties
    */
    clearCommonProperty: function clearCommonProperty(property) {

        delete _commonProperties[property];
    },


    /**
    * @ngdoc function
    * @name services.Mixpanel#setCommonProperty
    * @methodOf services.Mixpanel
    * @function
    *
    * @description
    * This method sets the value of a property from the default Mixpanel properties
    */
    setCommonProperty: function setCommonProperty(property, value) {

        _commonProperties[property] = value;
    }
};

exports.default = Mixpanel;

/***/ }),

/***/ "lFCP":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"auth-left-colors\"></div>\n    <div class=\"auth-right-colors\"></div>\n</div>\n"

/***/ }),

/***/ "lQ6f":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email license-m\">\n    <div class='content-wrapper'>\n        <!-- <i class=\"avira-logo mb20\"></i> -->\n        <i class=\"icon icon-avira-logo mb20\"></i>\n        <div>\n            <h2 class=\"text-xxl2 text-grey-2 mb30\" ng-if=\"inputData.os === 'ios' || inputData.os === 'android'\" translate=\"cw.deploy.select_license_mobile.title\"></h2>\n            <h2 class=\"text-xxl2 text-grey-2 mb30\" ng-if=\"inputData.os === 'windows' || inputData.os === 'osx'\" translate=\"cw.deploy.select_license.title\"></h2>\n        </div>\n        <p class=\"text-m text-grey-4 mb20\" translate=\"cw.deploy.select_license.select_one_to_use\"></p>\n\n        <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n            <ul class=\"deploy-available-licenses\">\n                <li ng-repeat=\"app in paidDeploymentWizardCtrl.allPaidApps | orderBy:'-type'\"\n                    ng-hide=\"!app.id || ((app.id === 'aasc0' || app.id === 'mspa0') && inputData.os === 'ios')\"\n                    ng-click=\"paidDeploymentWizardCtrl.selectApp(app.id, $event, appIntegrations[app.id].attributes.resource.oeName)\"\n                    connectqa-deploy-modal=\"select-license\">\n                    <div class=\"box-shot-holder\" ng-if=\"appIntegrations[app.id].attributes.resource.cwStoreBoxshot && !isMobileDeploy\">\n\n                        <img ng-src=\"{{appIntegrations[app.id].attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n\n                    </div>\n                    <div class=\"icon-holder\" ng-if=\"!appIntegrations[app.id].attributes.resource.cwStoreBoxshot || isMobileDeploy\">\n\n                        <img ng-if=\"appIntegrations[app.id].attributes.resource.wsLargeImageUrl\"\n                            ng-src=\"{{appIntegrations[app.id].attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                        <img ng-if=\"appIntegrations[app.id].attributes.type === 'bundle' && !appIntegrations[app.id].attributes.resource.wsLargeImageUrl\"\n                            src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                        <img ng-if=\"appIntegrations[app.id].attributes.type !== 'bundle' && !appIntegrations[app.id].attributes.resource.wsLargeImageUrl\"\n                            src=\"https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png\" />\n\n                    </div>\n\n                    <h4 class=\"text-m\">\n                        {{appIntegrations[app.id].attributes.resource.oeName}}\n                        <span ng-hide=\"app.trueBundle === true && app.type!=='app'\" translate=\"cw.ui.general.pro_version\"></span>\n                    </h4>\n\n                </li>\n\n                <li ng-if=\"showFreeApp\">\n                    <div class=\"icon-holder\">\n                        <img ng-src=\"{{osDefaultIntegration.attributes.resource.wsLargeImageUrl | imageUrlParse}}\"\n                            ng-if=\"osDefaultIntegration.attributes.resource.wsLargeImageUrl\" />\n\n                        <img ng-if=\"osDefaultIntegration.attributes.type === 'bundle' &&\n                                    !appIntegrations[app.id].attributes.resource.wsLargeImageUrl\"\n                            ng-src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                        <img ng-if=\"osDefaultIntegration.attributes.type !== 'bundle' &&\n                                    !osDefaultIntegration.attributes.resource.wsLargeImageUrl\"\n                            src=\"{{imgPath}}/no-image.png\" />\n                    </div>\n\n                    <h4 class=\"text-l\">\n                        {{osDefaultIntegration.attributes.resource.oeName}}\n                    </h4>\n\n                    <button class=\"btn btn-primary btn-medium mb10\" ng-click=\"paidDeploymentWizardCtrl.selectApp(osDefaultAppId, $event, {{osDefaultIntegration.attributes.resource.oeName}})\" translate=\"cw.general.select\"></button>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "lQta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var modules_namespaceObject = {};
__webpack_require__.d(modules_namespaceObject, "VERSION", function() { return _setup["e" /* VERSION */]; });
__webpack_require__.d(modules_namespaceObject, "restArguments", function() { return restArguments; });
__webpack_require__.d(modules_namespaceObject, "isObject", function() { return isObject; });
__webpack_require__.d(modules_namespaceObject, "isNull", function() { return isNull; });
__webpack_require__.d(modules_namespaceObject, "isUndefined", function() { return isUndefined; });
__webpack_require__.d(modules_namespaceObject, "isBoolean", function() { return isBoolean; });
__webpack_require__.d(modules_namespaceObject, "isElement", function() { return isElement; });
__webpack_require__.d(modules_namespaceObject, "isString", function() { return isString; });
__webpack_require__.d(modules_namespaceObject, "isNumber", function() { return isNumber; });
__webpack_require__.d(modules_namespaceObject, "isDate", function() { return isDate; });
__webpack_require__.d(modules_namespaceObject, "isRegExp", function() { return isRegExp; });
__webpack_require__.d(modules_namespaceObject, "isError", function() { return isError; });
__webpack_require__.d(modules_namespaceObject, "isSymbol", function() { return isSymbol; });
__webpack_require__.d(modules_namespaceObject, "isArrayBuffer", function() { return isArrayBuffer; });
__webpack_require__.d(modules_namespaceObject, "isDataView", function() { return modules_isDataView; });
__webpack_require__.d(modules_namespaceObject, "isArray", function() { return isArray; });
__webpack_require__.d(modules_namespaceObject, "isFunction", function() { return modules_isFunction; });
__webpack_require__.d(modules_namespaceObject, "isArguments", function() { return modules_isArguments; });
__webpack_require__.d(modules_namespaceObject, "isFinite", function() { return isFinite_isFinite; });
__webpack_require__.d(modules_namespaceObject, "isNaN", function() { return isNaN_isNaN; });
__webpack_require__.d(modules_namespaceObject, "isTypedArray", function() { return modules_isTypedArray; });
__webpack_require__.d(modules_namespaceObject, "isEmpty", function() { return isEmpty; });
__webpack_require__.d(modules_namespaceObject, "isMatch", function() { return isMatch; });
__webpack_require__.d(modules_namespaceObject, "isEqual", function() { return isEqual; });
__webpack_require__.d(modules_namespaceObject, "isMap", function() { return isMap; });
__webpack_require__.d(modules_namespaceObject, "isWeakMap", function() { return isWeakMap; });
__webpack_require__.d(modules_namespaceObject, "isSet", function() { return isSet; });
__webpack_require__.d(modules_namespaceObject, "isWeakSet", function() { return isWeakSet; });
__webpack_require__.d(modules_namespaceObject, "keys", function() { return keys_keys; });
__webpack_require__.d(modules_namespaceObject, "allKeys", function() { return allKeys; });
__webpack_require__.d(modules_namespaceObject, "values", function() { return values_values; });
__webpack_require__.d(modules_namespaceObject, "pairs", function() { return pairs_pairs; });
__webpack_require__.d(modules_namespaceObject, "invert", function() { return invert; });
__webpack_require__.d(modules_namespaceObject, "functions", function() { return functions; });
__webpack_require__.d(modules_namespaceObject, "methods", function() { return functions; });
__webpack_require__.d(modules_namespaceObject, "extend", function() { return extend; });
__webpack_require__.d(modules_namespaceObject, "extendOwn", function() { return extendOwn; });
__webpack_require__.d(modules_namespaceObject, "assign", function() { return extendOwn; });
__webpack_require__.d(modules_namespaceObject, "defaults", function() { return defaults; });
__webpack_require__.d(modules_namespaceObject, "create", function() { return create; });
__webpack_require__.d(modules_namespaceObject, "clone", function() { return clone; });
__webpack_require__.d(modules_namespaceObject, "tap", function() { return tap; });
__webpack_require__.d(modules_namespaceObject, "get", function() { return get; });
__webpack_require__.d(modules_namespaceObject, "has", function() { return has_has; });
__webpack_require__.d(modules_namespaceObject, "mapObject", function() { return mapObject; });
__webpack_require__.d(modules_namespaceObject, "identity", function() { return identity; });
__webpack_require__.d(modules_namespaceObject, "constant", function() { return constant; });
__webpack_require__.d(modules_namespaceObject, "noop", function() { return noop; });
__webpack_require__.d(modules_namespaceObject, "toPath", function() { return toPath; });
__webpack_require__.d(modules_namespaceObject, "property", function() { return property; });
__webpack_require__.d(modules_namespaceObject, "propertyOf", function() { return propertyOf; });
__webpack_require__.d(modules_namespaceObject, "matcher", function() { return matcher_matcher; });
__webpack_require__.d(modules_namespaceObject, "matches", function() { return matcher_matcher; });
__webpack_require__.d(modules_namespaceObject, "times", function() { return times; });
__webpack_require__.d(modules_namespaceObject, "random", function() { return random; });
__webpack_require__.d(modules_namespaceObject, "now", function() { return now; });
__webpack_require__.d(modules_namespaceObject, "escape", function() { return modules_escape; });
__webpack_require__.d(modules_namespaceObject, "unescape", function() { return modules_unescape; });
__webpack_require__.d(modules_namespaceObject, "templateSettings", function() { return templateSettings; });
__webpack_require__.d(modules_namespaceObject, "template", function() { return template_template; });
__webpack_require__.d(modules_namespaceObject, "result", function() { return result_result; });
__webpack_require__.d(modules_namespaceObject, "uniqueId", function() { return uniqueId; });
__webpack_require__.d(modules_namespaceObject, "chain", function() { return chain; });
__webpack_require__.d(modules_namespaceObject, "iteratee", function() { return iteratee_iteratee; });
__webpack_require__.d(modules_namespaceObject, "partial", function() { return modules_partial; });
__webpack_require__.d(modules_namespaceObject, "bind", function() { return bind; });
__webpack_require__.d(modules_namespaceObject, "bindAll", function() { return bindAll; });
__webpack_require__.d(modules_namespaceObject, "memoize", function() { return memoize_memoize; });
__webpack_require__.d(modules_namespaceObject, "delay", function() { return delay; });
__webpack_require__.d(modules_namespaceObject, "defer", function() { return defer; });
__webpack_require__.d(modules_namespaceObject, "throttle", function() { return throttle; });
__webpack_require__.d(modules_namespaceObject, "debounce", function() { return debounce; });
__webpack_require__.d(modules_namespaceObject, "wrap", function() { return wrap; });
__webpack_require__.d(modules_namespaceObject, "negate", function() { return negate; });
__webpack_require__.d(modules_namespaceObject, "compose", function() { return compose; });
__webpack_require__.d(modules_namespaceObject, "after", function() { return after; });
__webpack_require__.d(modules_namespaceObject, "before", function() { return before; });
__webpack_require__.d(modules_namespaceObject, "once", function() { return once; });
__webpack_require__.d(modules_namespaceObject, "findKey", function() { return findKey; });
__webpack_require__.d(modules_namespaceObject, "findIndex", function() { return findIndex; });
__webpack_require__.d(modules_namespaceObject, "findLastIndex", function() { return findLastIndex; });
__webpack_require__.d(modules_namespaceObject, "sortedIndex", function() { return sortedIndex_sortedIndex; });
__webpack_require__.d(modules_namespaceObject, "indexOf", function() { return indexOf; });
__webpack_require__.d(modules_namespaceObject, "lastIndexOf", function() { return lastIndexOf; });
__webpack_require__.d(modules_namespaceObject, "find", function() { return find; });
__webpack_require__.d(modules_namespaceObject, "detect", function() { return find; });
__webpack_require__.d(modules_namespaceObject, "findWhere", function() { return findWhere; });
__webpack_require__.d(modules_namespaceObject, "each", function() { return each; });
__webpack_require__.d(modules_namespaceObject, "forEach", function() { return each; });
__webpack_require__.d(modules_namespaceObject, "map", function() { return map_map; });
__webpack_require__.d(modules_namespaceObject, "collect", function() { return map_map; });
__webpack_require__.d(modules_namespaceObject, "reduce", function() { return reduce; });
__webpack_require__.d(modules_namespaceObject, "foldl", function() { return reduce; });
__webpack_require__.d(modules_namespaceObject, "inject", function() { return reduce; });
__webpack_require__.d(modules_namespaceObject, "reduceRight", function() { return reduceRight; });
__webpack_require__.d(modules_namespaceObject, "foldr", function() { return reduceRight; });
__webpack_require__.d(modules_namespaceObject, "filter", function() { return filter; });
__webpack_require__.d(modules_namespaceObject, "select", function() { return filter; });
__webpack_require__.d(modules_namespaceObject, "reject", function() { return reject; });
__webpack_require__.d(modules_namespaceObject, "every", function() { return every; });
__webpack_require__.d(modules_namespaceObject, "all", function() { return every; });
__webpack_require__.d(modules_namespaceObject, "some", function() { return some; });
__webpack_require__.d(modules_namespaceObject, "any", function() { return some; });
__webpack_require__.d(modules_namespaceObject, "contains", function() { return contains; });
__webpack_require__.d(modules_namespaceObject, "includes", function() { return contains; });
__webpack_require__.d(modules_namespaceObject, "include", function() { return contains; });
__webpack_require__.d(modules_namespaceObject, "invoke", function() { return invoke; });
__webpack_require__.d(modules_namespaceObject, "pluck", function() { return pluck; });
__webpack_require__.d(modules_namespaceObject, "where", function() { return where; });
__webpack_require__.d(modules_namespaceObject, "max", function() { return max; });
__webpack_require__.d(modules_namespaceObject, "min", function() { return min; });
__webpack_require__.d(modules_namespaceObject, "shuffle", function() { return shuffle; });
__webpack_require__.d(modules_namespaceObject, "sample", function() { return sample_sample; });
__webpack_require__.d(modules_namespaceObject, "sortBy", function() { return sortBy; });
__webpack_require__.d(modules_namespaceObject, "groupBy", function() { return groupBy; });
__webpack_require__.d(modules_namespaceObject, "indexBy", function() { return indexBy; });
__webpack_require__.d(modules_namespaceObject, "countBy", function() { return countBy; });
__webpack_require__.d(modules_namespaceObject, "partition", function() { return modules_partition; });
__webpack_require__.d(modules_namespaceObject, "toArray", function() { return toArray; });
__webpack_require__.d(modules_namespaceObject, "size", function() { return size; });
__webpack_require__.d(modules_namespaceObject, "pick", function() { return pick; });
__webpack_require__.d(modules_namespaceObject, "omit", function() { return omit; });
__webpack_require__.d(modules_namespaceObject, "first", function() { return first; });
__webpack_require__.d(modules_namespaceObject, "head", function() { return first; });
__webpack_require__.d(modules_namespaceObject, "take", function() { return first; });
__webpack_require__.d(modules_namespaceObject, "initial", function() { return initial_initial; });
__webpack_require__.d(modules_namespaceObject, "last", function() { return last_last; });
__webpack_require__.d(modules_namespaceObject, "rest", function() { return rest_rest; });
__webpack_require__.d(modules_namespaceObject, "tail", function() { return rest_rest; });
__webpack_require__.d(modules_namespaceObject, "drop", function() { return rest_rest; });
__webpack_require__.d(modules_namespaceObject, "compact", function() { return compact; });
__webpack_require__.d(modules_namespaceObject, "flatten", function() { return flatten_flatten; });
__webpack_require__.d(modules_namespaceObject, "without", function() { return without; });
__webpack_require__.d(modules_namespaceObject, "uniq", function() { return uniq; });
__webpack_require__.d(modules_namespaceObject, "unique", function() { return uniq; });
__webpack_require__.d(modules_namespaceObject, "union", function() { return union; });
__webpack_require__.d(modules_namespaceObject, "intersection", function() { return intersection; });
__webpack_require__.d(modules_namespaceObject, "difference", function() { return difference; });
__webpack_require__.d(modules_namespaceObject, "unzip", function() { return unzip; });
__webpack_require__.d(modules_namespaceObject, "transpose", function() { return unzip; });
__webpack_require__.d(modules_namespaceObject, "zip", function() { return zip; });
__webpack_require__.d(modules_namespaceObject, "object", function() { return object_object; });
__webpack_require__.d(modules_namespaceObject, "range", function() { return range; });
__webpack_require__.d(modules_namespaceObject, "chunk", function() { return chunk; });
__webpack_require__.d(modules_namespaceObject, "mixin", function() { return mixin; });
__webpack_require__.d(modules_namespaceObject, "default", function() { return underscore_array_methods; });

// EXTERNAL MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_setup.js
var _setup = __webpack_require__("RfKI");

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/restArguments.js
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function restArguments(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
        rest = Array(length),
        index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isObject.js
// Is a given variable an object?
function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isNull.js
// Is a given value equal to null?
function isNull(obj) {
  return obj === null;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isUndefined.js
// Is a given variable undefined?
function isUndefined(obj) {
  return obj === void 0;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isBoolean.js


// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || _setup["t" /* toString */].call(obj) === '[object Boolean]';
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isElement.js
// Is a given value a DOM element?
function isElement(obj) {
  return !!(obj && obj.nodeType === 1);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_tagTester.js


// Internal function for creating a `toString`-based type tester.
function tagTester(name) {
  var tag = '[object ' + name + ']';
  return function(obj) {
    return _setup["t" /* toString */].call(obj) === tag;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isString.js


/* harmony default export */ var isString = (tagTester('String'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isNumber.js


/* harmony default export */ var isNumber = (tagTester('Number'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isDate.js


/* harmony default export */ var isDate = (tagTester('Date'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isRegExp.js


/* harmony default export */ var isRegExp = (tagTester('RegExp'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isError.js


/* harmony default export */ var isError = (tagTester('Error'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isSymbol.js


/* harmony default export */ var isSymbol = (tagTester('Symbol'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isArrayBuffer.js


/* harmony default export */ var isArrayBuffer = (tagTester('ArrayBuffer'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isFunction.js



var isFunction = tagTester('Function');

// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var nodelist = _setup["p" /* root */].document && _setup["p" /* root */].document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
  isFunction = function(obj) {
    return typeof obj == 'function' || false;
  };
}

/* harmony default export */ var modules_isFunction = (isFunction);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_hasObjectTag.js


/* harmony default export */ var _hasObjectTag = (tagTester('Object'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_stringTagBug.js



// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
var hasStringTagBug = (
      _setup["s" /* supportsDataView */] && _hasObjectTag(new DataView(new ArrayBuffer(8)))
    ),
    isIE11 = (typeof Map !== 'undefined' && _hasObjectTag(new Map));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isDataView.js





var isDataView = tagTester('DataView');

// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
function ie10IsDataView(obj) {
  return obj != null && modules_isFunction(obj.getInt8) && isArrayBuffer(obj.buffer);
}

/* harmony default export */ var modules_isDataView = (hasStringTagBug ? ie10IsDataView : isDataView);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isArray.js



// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
/* harmony default export */ var isArray = (_setup["k" /* nativeIsArray */] || tagTester('Array'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_has.js


// Internal function to check whether `key` is an own property name of `obj`.
function has(obj, key) {
  return obj != null && _setup["i" /* hasOwnProperty */].call(obj, key);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isArguments.js



var isArguments = tagTester('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
  if (!isArguments(arguments)) {
    isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }
}());

/* harmony default export */ var modules_isArguments = (isArguments);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isFinite.js



// Is a given object a finite number?
function isFinite_isFinite(obj) {
  return !isSymbol(obj) && Object(_setup["f" /* _isFinite */])(obj) && !isNaN(parseFloat(obj));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isNaN.js



// Is the given value `NaN`?
function isNaN_isNaN(obj) {
  return isNumber(obj) && Object(_setup["g" /* _isNaN */])(obj);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/constant.js
// Predicate-generating function. Often useful outside of Underscore.
function constant(value) {
  return function() {
    return value;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createSizePropertyCheck.js


// Common internal logic for `isArrayLike` and `isBufferLike`.
function createSizePropertyCheck(getSizeProperty) {
  return function(collection) {
    var sizeProperty = getSizeProperty(collection);
    return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= _setup["b" /* MAX_ARRAY_INDEX */];
  }
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_shallowProperty.js
// Internal helper to generate a function to obtain property `key` from `obj`.
function shallowProperty(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_getByteLength.js


// Internal helper to obtain the `byteLength` property of an object.
/* harmony default export */ var _getByteLength = (shallowProperty('byteLength'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_isBufferLike.js



// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
/* harmony default export */ var _isBufferLike = (createSizePropertyCheck(_getByteLength));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isTypedArray.js





// Is a given value a typed array?
var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(obj) {
  // `ArrayBuffer.isView` is the most future-proof, so use it when available.
  // Otherwise, fall back on the above regular expression.
  return _setup["l" /* nativeIsView */] ? (Object(_setup["l" /* nativeIsView */])(obj) && !modules_isDataView(obj)) :
                _isBufferLike(obj) && typedArrayPattern.test(_setup["t" /* toString */].call(obj));
}

/* harmony default export */ var modules_isTypedArray = (_setup["r" /* supportsArrayBuffer */] ? isTypedArray : constant(false));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_getLength.js


// Internal helper to obtain the `length` property of an object.
/* harmony default export */ var _getLength = (shallowProperty('length'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_collectNonEnumProps.js




// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function(key) { return hash[key]; },
    push: function(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = _setup["n" /* nonEnumerableProps */].length;
  var constructor = obj.constructor;
  var proto = modules_isFunction(constructor) && constructor.prototype || _setup["c" /* ObjProto */];

  // Constructor is a special case.
  var prop = 'constructor';
  if (has(obj, prop) && !keys.contains(prop)) keys.push(prop);

  while (nonEnumIdx--) {
    prop = _setup["n" /* nonEnumerableProps */][nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/keys.js





// Retrieve the names of an object's own properties.
// Delegates to **ECMAScript 5**'s native `Object.keys`.
function keys_keys(obj) {
  if (!isObject(obj)) return [];
  if (_setup["m" /* nativeKeys */]) return Object(_setup["m" /* nativeKeys */])(obj);
  var keys = [];
  for (var key in obj) if (has(obj, key)) keys.push(key);
  // Ahem, IE < 9.
  if (_setup["h" /* hasEnumBug */]) collectNonEnumProps(obj, keys);
  return keys;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isEmpty.js






// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = _getLength(obj);
  if (typeof length == 'number' && (
    isArray(obj) || isString(obj) || modules_isArguments(obj)
  )) return length === 0;
  return _getLength(keys_keys(obj)) === 0;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isMatch.js


// Returns whether an object has a given set of `key:value` pairs.
function isMatch(object, attrs) {
  var _keys = keys_keys(attrs), length = _keys.length;
  if (object == null) return !length;
  var obj = Object(object);
  for (var i = 0; i < length; i++) {
    var key = _keys[i];
    if (attrs[key] !== obj[key] || !(key in obj)) return false;
  }
  return true;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/underscore.js


// If Underscore is called as a function, it returns a wrapped object that can
// be used OO-style. This wrapper holds altered versions of all functions added
// through `_.mixin`. Wrapped objects may be chained.
function _(obj) {
  if (obj instanceof _) return obj;
  if (!(this instanceof _)) return new _(obj);
  this._wrapped = obj;
}

_.VERSION = _setup["e" /* VERSION */];

// Extracts the result from a wrapped and chained object.
_.prototype.value = function() {
  return this._wrapped;
};

// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
_.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

_.prototype.toString = function() {
  return String(this._wrapped);
};

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_toBufferView.js


// Internal function to wrap or shallow-copy an ArrayBuffer,
// typed array or DataView to a new view, reusing the buffer.
function toBufferView(bufferSource) {
  return new Uint8Array(
    bufferSource.buffer || bufferSource,
    bufferSource.byteOffset || 0,
    _getByteLength(bufferSource)
  );
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isEqual.js











// We use this string twice, so give it a name for minification.
var tagDataView = '[object DataView]';

// Internal recursive comparison function for `_.isEqual`.
function eq(a, b, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) return a !== 0 || 1 / a === 1 / b;
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) return false;
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) return b !== b;
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
  return deepEq(a, b, aStack, bStack);
}

// Internal recursive comparison function for `_.isEqual`.
function deepEq(a, b, aStack, bStack) {
  // Unwrap any wrapped objects.
  if (a instanceof _) a = a._wrapped;
  if (b instanceof _) b = b._wrapped;
  // Compare `[[Class]]` names.
  var className = _setup["t" /* toString */].call(a);
  if (className !== _setup["t" /* toString */].call(b)) return false;
  // Work around a bug in IE 10 - Edge 13.
  if (hasStringTagBug && className == '[object Object]' && modules_isDataView(a)) {
    if (!modules_isDataView(b)) return false;
    className = tagDataView;
  }
  switch (className) {
    // These types are compared by value.
    case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case '[object String]':
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return '' + a === '' + b;
    case '[object Number]':
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) return +b !== +b;
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case '[object Date]':
    case '[object Boolean]':
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case '[object Symbol]':
      return _setup["d" /* SymbolProto */].valueOf.call(a) === _setup["d" /* SymbolProto */].valueOf.call(b);
    case '[object ArrayBuffer]':
    case tagDataView:
      // Coerce to typed array so we can fall through.
      return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
  }

  var areArrays = className === '[object Array]';
  if (!areArrays && modules_isTypedArray(a)) {
      var byteLength = _getByteLength(a);
      if (byteLength !== _getByteLength(b)) return false;
      if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
      areArrays = true;
  }
  if (!areArrays) {
    if (typeof a != 'object' || typeof b != 'object') return false;

    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(modules_isFunction(aCtor) && aCtor instanceof aCtor &&
                             modules_isFunction(bCtor) && bCtor instanceof bCtor)
                        && ('constructor' in a && 'constructor' in b)) {
      return false;
    }
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) return bStack[length] === b;
  }

  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);

  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) return false;
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], aStack, bStack)) return false;
    }
  } else {
    // Deep compare objects.
    var _keys = keys_keys(a), key;
    length = _keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (keys_keys(b).length !== length) return false;
    while (length--) {
      // Deep compare each member
      key = _keys[length];
      if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}

// Perform a deep comparison to check if two objects are equal.
function isEqual(a, b) {
  return eq(a, b);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/allKeys.js




// Retrieve all the enumerable property names of an object.
function allKeys(obj) {
  if (!isObject(obj)) return [];
  var keys = [];
  for (var key in obj) keys.push(key);
  // Ahem, IE < 9.
  if (_setup["h" /* hasEnumBug */]) collectNonEnumProps(obj, keys);
  return keys;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_methodFingerprint.js




// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = _getLength(methods);
  return function(obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = allKeys(obj);
    if (_getLength(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!modules_isFunction(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !modules_isFunction(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
    hasName = 'has',
    commonInit = ['clear', 'delete'],
    mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = commonInit.concat(forEachName, mapTail),
    weakMapMethods = commonInit.concat(mapTail),
    setMethods = ['add'].concat(commonInit, forEachName, hasName);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isMap.js




/* harmony default export */ var isMap = (isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isWeakMap.js




/* harmony default export */ var isWeakMap = (isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isSet.js




/* harmony default export */ var isSet = (isIE11 ? ie11fingerprint(setMethods) : tagTester('Set'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/isWeakSet.js


/* harmony default export */ var isWeakSet = (tagTester('WeakSet'));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/values.js


// Retrieve the values of an object's properties.
function values_values(obj) {
  var _keys = keys_keys(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/pairs.js


// Convert an object into a list of `[key, value]` pairs.
// The opposite of `_.object` with one argument.
function pairs_pairs(obj) {
  var _keys = keys_keys(obj);
  var length = _keys.length;
  var pairs = Array(length);
  for (var i = 0; i < length; i++) {
    pairs[i] = [_keys[i], obj[_keys[i]]];
  }
  return pairs;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/invert.js


// Invert the keys and values of an object. The values must be serializable.
function invert(obj) {
  var result = {};
  var _keys = keys_keys(obj);
  for (var i = 0, length = _keys.length; i < length; i++) {
    result[obj[_keys[i]]] = _keys[i];
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/functions.js


// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if (modules_isFunction(obj[key])) names.push(key);
  }
  return names.sort();
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createAssigner.js
// An internal function for creating assigner functions.
function createAssigner(keysFunc, defaults) {
  return function(obj) {
    var length = arguments.length;
    if (defaults) obj = Object(obj);
    if (length < 2 || obj == null) return obj;
    for (var index = 1; index < length; index++) {
      var source = arguments[index],
          keys = keysFunc(source),
          l = keys.length;
      for (var i = 0; i < l; i++) {
        var key = keys[i];
        if (!defaults || obj[key] === void 0) obj[key] = source[key];
      }
    }
    return obj;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/extend.js



// Extend a given object with all the properties in passed-in object(s).
/* harmony default export */ var extend = (createAssigner(allKeys));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/extendOwn.js



// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
/* harmony default export */ var extendOwn = (createAssigner(keys_keys));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/defaults.js



// Fill in a given object with default properties.
/* harmony default export */ var defaults = (createAssigner(allKeys, true));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_baseCreate.js



// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function(){};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!isObject(prototype)) return {};
  if (_setup["j" /* nativeCreate */]) return Object(_setup["j" /* nativeCreate */])(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor;
  Ctor.prototype = null;
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/create.js



// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = baseCreate(prototype);
  if (props) extendOwn(result, props);
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/clone.js




// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!isObject(obj)) return obj;
  return isArray(obj) ? obj.slice() : extend({}, obj);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/tap.js
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function tap(obj, interceptor) {
  interceptor(obj);
  return obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/toPath.js



// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return isArray(path) ? path : [path];
}
_.toPath = toPath;

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_toPath.js



// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function _toPath_toPath(path) {
  return _.toPath(path);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_deepGet.js
// Internal function to obtain a nested property in `obj` along `path`.
function deepGet(obj, path) {
  var length = path.length;
  for (var i = 0; i < length; i++) {
    if (obj == null) return void 0;
    obj = obj[path[i]];
  }
  return length ? obj : void 0;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/get.js




// Get the value of the (deep) property on `path` from `object`.
// If any property in `path` does not exist or if the value is
// `undefined`, return `defaultValue` instead.
// The `path` is normalized through `_.toPath`.
function get(object, path, defaultValue) {
  var value = deepGet(object, _toPath_toPath(path));
  return isUndefined(value) ? defaultValue : value;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/has.js



// Shortcut function for checking if an object has a given property directly on
// itself (in other words, not on a prototype). Unlike the internal `has`
// function, this public version can also traverse nested properties.
function has_has(obj, path) {
  path = _toPath_toPath(path);
  var length = path.length;
  for (var i = 0; i < length; i++) {
    var key = path[i];
    if (!has(obj, key)) return false;
    obj = obj[key];
  }
  return !!length;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/identity.js
// Keep the identity function around for default iteratees.
function identity(value) {
  return value;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/matcher.js



// Returns a predicate for checking whether an object has a given set of
// `key:value` pairs.
function matcher_matcher(attrs) {
  attrs = extendOwn({}, attrs);
  return function(obj) {
    return isMatch(obj, attrs);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/property.js



// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = _toPath_toPath(path);
  return function(obj) {
    return deepGet(obj, path);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_optimizeCb.js
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function optimizeCb(func, context, argCount) {
  if (context === void 0) return func;
  switch (argCount == null ? 3 : argCount) {
    case 1: return function(value) {
      return func.call(context, value);
    };
    // The 2-argument case is omitted because we’re not using it.
    case 3: return function(value, index, collection) {
      return func.call(context, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(context, accumulator, value, index, collection);
    };
  }
  return function() {
    return func.apply(context, arguments);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_baseIteratee.js








// An internal function to generate callbacks that can be applied to each
// element in a collection, returning the desired result — either `_.identity`,
// an arbitrary callback, a property matcher, or a property accessor.
function baseIteratee(value, context, argCount) {
  if (value == null) return identity;
  if (modules_isFunction(value)) return optimizeCb(value, context, argCount);
  if (isObject(value) && !isArray(value)) return matcher_matcher(value);
  return property(value);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/iteratee.js



// External wrapper for our callback generator. Users may customize
// `_.iteratee` if they want additional predicate/iteratee shorthand styles.
// This abstraction hides the internal-only `argCount` argument.
function iteratee_iteratee(value, context) {
  return baseIteratee(value, context, Infinity);
}
_.iteratee = iteratee_iteratee;

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_cb.js




// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (_.iteratee !== iteratee_iteratee) return _.iteratee(value, context);
  return baseIteratee(value, context, argCount);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/mapObject.js



// Returns the results of applying the `iteratee` to each element of `obj`.
// In contrast to `_.map` it returns an object.
function mapObject(obj, iteratee, context) {
  iteratee = cb(iteratee, context);
  var _keys = keys_keys(obj),
      length = _keys.length,
      results = {};
  for (var index = 0; index < length; index++) {
    var currentKey = _keys[index];
    results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/noop.js
// Predicate-generating function. Often useful outside of Underscore.
function noop(){}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/propertyOf.js



// Generates a function for a given object that returns a given property.
function propertyOf(obj) {
  if (obj == null) return noop;
  return function(path) {
    return get(obj, path);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/times.js


// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = optimizeCb(iteratee, context, 1);
  for (var i = 0; i < n; i++) accum[i] = iteratee(i);
  return accum;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/random.js
// Return a random integer between `min` and `max` (inclusive).
function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/now.js
// A (possibly faster) way to get the current timestamp as an integer.
/* harmony default export */ var now = (Date.now || function() {
  return new Date().getTime();
});

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createEscaper.js


// Internal helper to generate functions for escaping and unescaping strings
// to/from HTML interpolation.
function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  // Regexes for identifying a key that needs to be escaped.
  var source = '(?:' + keys_keys(map).join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_escapeMap.js
// Internal list of HTML entities for escaping.
/* harmony default export */ var _escapeMap = ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
});

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/escape.js



// Function for escaping strings to HTML interpolation.
/* harmony default export */ var modules_escape = (createEscaper(_escapeMap));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_unescapeMap.js



// Internal list of HTML entities for unescaping.
/* harmony default export */ var _unescapeMap = (invert(_escapeMap));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/unescape.js



// Function for unescaping strings from HTML interpolation.
/* harmony default export */ var modules_unescape = (createEscaper(_unescapeMap));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/templateSettings.js


// By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
/* harmony default export */ var templateSettings = (_.templateSettings = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g,
  escape: /<%-([\s\S]+?)%>/g
});

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/template.js




// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var noMatch = /(.)^/;

// Certain characters need to be escaped so that they can be put into a
// string literal.
var escapes = {
  "'": "'",
  '\\': '\\',
  '\r': 'r',
  '\n': 'n',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
  return '\\' + escapes[match];
}

// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var bareIdentifier = /^\s*(\w|\$)+\s*$/;

// JavaScript micro-templating, similar to John Resig's implementation.
// Underscore templating handles arbitrary delimiters, preserves whitespace,
// and correctly escapes quotes within interpolated code.
// NB: `oldSettings` only exists for backwards compatibility.
function template_template(text, settings, oldSettings) {
  if (!settings && oldSettings) settings = oldSettings;
  settings = defaults({}, settings, _.templateSettings);

  // Combine delimiters into one regular expression via alternation.
  var matcher = RegExp([
    (settings.escape || noMatch).source,
    (settings.interpolate || noMatch).source,
    (settings.evaluate || noMatch).source
  ].join('|') + '|$', 'g');

  // Compile the template source, escaping string literals appropriately.
  var index = 0;
  var source = "__p+='";
  text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
    source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
    index = offset + match.length;

    if (escape) {
      source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
    } else if (interpolate) {
      source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
    } else if (evaluate) {
      source += "';\n" + evaluate + "\n__p+='";
    }

    // Adobe VMs need the match returned to produce the correct offset.
    return match;
  });
  source += "';\n";

  var argument = settings.variable;
  if (argument) {
    // Insure against third-party code injection. (CVE-2021-23358)
    if (!bareIdentifier.test(argument)) throw new Error(
      'variable is not a bare identifier: ' + argument
    );
  } else {
    // If a variable is not specified, place data values in local scope.
    source = 'with(obj||{}){\n' + source + '}\n';
    argument = 'obj';
  }

  source = "var __t,__p='',__j=Array.prototype.join," +
    "print=function(){__p+=__j.call(arguments,'');};\n" +
    source + 'return __p;\n';

  var render;
  try {
    render = new Function(argument, '_', source);
  } catch (e) {
    e.source = source;
    throw e;
  }

  var template = function(data) {
    return render.call(this, data, _);
  };

  // Provide the compiled source as a convenience for precompilation.
  template.source = 'function(' + argument + '){\n' + source + '}';

  return template;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/result.js



// Traverses the children of `obj` along `path`. If a child is a function, it
// is invoked with its parent as context. Returns the value of the final
// child, or `fallback` if any child is undefined.
function result_result(obj, path, fallback) {
  path = _toPath_toPath(path);
  var length = path.length;
  if (!length) {
    return modules_isFunction(fallback) ? fallback.call(obj) : fallback;
  }
  for (var i = 0; i < length; i++) {
    var prop = obj == null ? void 0 : obj[path[i]];
    if (prop === void 0) {
      prop = fallback;
      i = length; // Ensure we don't continue iterating.
    }
    obj = modules_isFunction(prop) ? prop.call(obj) : prop;
  }
  return obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/uniqueId.js
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/chain.js


// Start chaining a wrapped Underscore object.
function chain(obj) {
  var instance = _(obj);
  instance._chain = true;
  return instance;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_executeBound.js



// Internal function to execute `sourceFunc` bound to `context` with optional
// `args`. Determines whether to execute a function as a constructor or as a
// normal function.
function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
  if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
  var self = baseCreate(sourceFunc.prototype);
  var result = sourceFunc.apply(self, args);
  if (isObject(result)) return result;
  return self;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/partial.js




// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var partial = restArguments(function(func, boundArgs) {
  var placeholder = partial.placeholder;
  var bound = function() {
    var position = 0, length = boundArgs.length;
    var args = Array(length);
    for (var i = 0; i < length; i++) {
      args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
    }
    while (position < arguments.length) args.push(arguments[position++]);
    return executeBound(func, bound, this, this, args);
  };
  return bound;
});

partial.placeholder = _;
/* harmony default export */ var modules_partial = (partial);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/bind.js




// Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
/* harmony default export */ var bind = (restArguments(function(func, context, args) {
  if (!modules_isFunction(func)) throw new TypeError('Bind must be called on a function');
  var bound = restArguments(function(callArgs) {
    return executeBound(func, bound, context, this, args.concat(callArgs));
  });
  return bound;
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_isArrayLike.js



// Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
/* harmony default export */ var _isArrayLike = (createSizePropertyCheck(_getLength));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_flatten.js





// Internal implementation of a recursive `flatten` function.
function flatten(input, depth, strict, output) {
  output = output || [];
  if (!depth && depth !== 0) {
    depth = Infinity;
  } else if (depth <= 0) {
    return output.concat(input);
  }
  var idx = output.length;
  for (var i = 0, length = _getLength(input); i < length; i++) {
    var value = input[i];
    if (_isArrayLike(value) && (isArray(value) || modules_isArguments(value))) {
      // Flatten current level of array or arguments object.
      if (depth > 1) {
        flatten(value, depth - 1, strict, output);
        idx = output.length;
      } else {
        var j = 0, len = value.length;
        while (j < len) output[idx++] = value[j++];
      }
    } else if (!strict) {
      output[idx++] = value;
    }
  }
  return output;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/bindAll.js




// Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
/* harmony default export */ var bindAll = (restArguments(function(obj, keys) {
  keys = flatten(keys, false, false);
  var index = keys.length;
  if (index < 1) throw new Error('bindAll must be passed function names');
  while (index--) {
    var key = keys[index];
    obj[key] = bind(obj[key], obj);
  }
  return obj;
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/memoize.js


// Memoize an expensive function by storing its results.
function memoize_memoize(func, hasher) {
  var memoize = function(key) {
    var cache = memoize.cache;
    var address = '' + (hasher ? hasher.apply(this, arguments) : key);
    if (!has(cache, address)) cache[address] = func.apply(this, arguments);
    return cache[address];
  };
  memoize.cache = {};
  return memoize;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/delay.js


// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
/* harmony default export */ var delay = (restArguments(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/defer.js




// Defers a function, scheduling it to run after the current call stack has
// cleared.
/* harmony default export */ var defer = (modules_partial(delay, _, 1));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/throttle.js


// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function() {
    var _now = now();
    if (!previous && options.leading === false) previous = _now;
    var remaining = wait - (_now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = _now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function() {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/debounce.js



// When a sequence of calls of the returned function ends, the argument
// function is triggered. The end of a sequence is defined by the `wait`
// parameter. If `immediate` is passed, the argument function will be
// triggered at the beginning of the sequence instead of at the end.
function debounce(func, wait, immediate) {
  var timeout, previous, args, result, context;

  var later = function() {
    var passed = now() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) result = func.apply(context, args);
      // This check is needed because `func` can recursively invoke `debounced`.
      if (!timeout) args = context = null;
    }
  };

  var debounced = restArguments(function(_args) {
    context = this;
    args = _args;
    previous = now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) result = func.apply(context, args);
    }
    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = args = context = null;
  };

  return debounced;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/wrap.js


// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return modules_partial(wrapper, func);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/negate.js
// Returns a negated version of the passed-in predicate.
function negate(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/compose.js
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function compose() {
  var args = arguments;
  var start = args.length - 1;
  return function() {
    var i = start;
    var result = args[start].apply(this, arguments);
    while (i--) result = args[i].call(this, result);
    return result;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/after.js
// Returns a function that will only be executed on and after the Nth call.
function after(times, func) {
  return function() {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/before.js
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function before(times, func) {
  var memo;
  return function() {
    if (--times > 0) {
      memo = func.apply(this, arguments);
    }
    if (times <= 1) func = null;
    return memo;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/once.js



// Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
/* harmony default export */ var once = (modules_partial(before, 2));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/findKey.js



// Returns the first key on an object that passes a truth test.
function findKey(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = keys_keys(obj), key;
  for (var i = 0, length = _keys.length; i < length; i++) {
    key = _keys[i];
    if (predicate(obj[key], key, obj)) return key;
  }
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createPredicateIndexFinder.js



// Internal function to generate `_.findIndex` and `_.findLastIndex`.
function createPredicateIndexFinder(dir) {
  return function(array, predicate, context) {
    predicate = cb(predicate, context);
    var length = _getLength(array);
    var index = dir > 0 ? 0 : length - 1;
    for (; index >= 0 && index < length; index += dir) {
      if (predicate(array[index], index, array)) return index;
    }
    return -1;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/findIndex.js


// Returns the first index on an array-like that passes a truth test.
/* harmony default export */ var findIndex = (createPredicateIndexFinder(1));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/findLastIndex.js


// Returns the last index on an array-like that passes a truth test.
/* harmony default export */ var findLastIndex = (createPredicateIndexFinder(-1));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/sortedIndex.js



// Use a comparator function to figure out the smallest index at which
// an object should be inserted so as to maintain order. Uses binary search.
function sortedIndex_sortedIndex(array, obj, iteratee, context) {
  iteratee = cb(iteratee, context, 1);
  var value = iteratee(obj);
  var low = 0, high = _getLength(array);
  while (low < high) {
    var mid = Math.floor((low + high) / 2);
    if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
  }
  return low;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createIndexFinder.js




// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function(array, item, idx) {
    var i = 0, length = _getLength(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(_setup["q" /* slice */].call(array, i, length), isNaN_isNaN);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/indexOf.js




// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
/* harmony default export */ var indexOf = (createIndexFinder(1, findIndex, sortedIndex_sortedIndex));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/lastIndexOf.js



// Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
/* harmony default export */ var lastIndexOf = (createIndexFinder(-1, findLastIndex));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/find.js




// Return the first value which passes a truth test.
function find(obj, predicate, context) {
  var keyFinder = _isArrayLike(obj) ? findIndex : findKey;
  var key = keyFinder(obj, predicate, context);
  if (key !== void 0 && key !== -1) return obj[key];
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/findWhere.js



// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return find(obj, matcher_matcher(attrs));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/each.js




// The cornerstone for collection functions, an `each`
// implementation, aka `forEach`.
// Handles raw objects in addition to array-likes. Treats all
// sparse array-likes as if they were dense.
function each(obj, iteratee, context) {
  iteratee = optimizeCb(iteratee, context);
  var i, length;
  if (_isArrayLike(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var _keys = keys_keys(obj);
    for (i = 0, length = _keys.length; i < length; i++) {
      iteratee(obj[_keys[i]], _keys[i], obj);
    }
  }
  return obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/map.js




// Return the results of applying the iteratee to each element.
function map_map(obj, iteratee, context) {
  iteratee = cb(iteratee, context);
  var _keys = !_isArrayLike(obj) && keys_keys(obj),
      length = (_keys || obj).length,
      results = Array(length);
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    results[index] = iteratee(obj[currentKey], currentKey, obj);
  }
  return results;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_createReduce.js




// Internal helper to create a reducing function, iterating left or right.
function createReduce(dir) {
  // Wrap code that reassigns argument variables in a separate function than
  // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
  var reducer = function(obj, iteratee, memo, initial) {
    var _keys = !_isArrayLike(obj) && keys_keys(obj),
        length = (_keys || obj).length,
        index = dir > 0 ? 0 : length - 1;
    if (!initial) {
      memo = obj[_keys ? _keys[index] : index];
      index += dir;
    }
    for (; index >= 0 && index < length; index += dir) {
      var currentKey = _keys ? _keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  return function(obj, iteratee, memo, context) {
    var initial = arguments.length >= 3;
    return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/reduce.js


// **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
/* harmony default export */ var reduce = (createReduce(1));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/reduceRight.js


// The right-associative version of reduce, also known as `foldr`.
/* harmony default export */ var reduceRight = (createReduce(-1));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/filter.js



// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = cb(predicate, context);
  each(obj, function(value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/reject.js




// Return all the elements for which a truth test fails.
function reject(obj, predicate, context) {
  return filter(obj, negate(cb(predicate)), context);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/every.js




// Determine whether all of the elements pass a truth test.
function every(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = !_isArrayLike(obj) && keys_keys(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (!predicate(obj[currentKey], currentKey, obj)) return false;
  }
  return true;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/some.js




// Determine if at least one element in the object passes a truth test.
function some(obj, predicate, context) {
  predicate = cb(predicate, context);
  var _keys = !_isArrayLike(obj) && keys_keys(obj),
      length = (_keys || obj).length;
  for (var index = 0; index < length; index++) {
    var currentKey = _keys ? _keys[index] : index;
    if (predicate(obj[currentKey], currentKey, obj)) return true;
  }
  return false;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/contains.js




// Determine if the array or object contains a given item (using `===`).
function contains(obj, item, fromIndex, guard) {
  if (!_isArrayLike(obj)) obj = values_values(obj);
  if (typeof fromIndex != 'number' || guard) fromIndex = 0;
  return indexOf(obj, item, fromIndex) >= 0;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/invoke.js






// Invoke a method (with arguments) on every item in a collection.
/* harmony default export */ var invoke = (restArguments(function(obj, path, args) {
  var contextPath, func;
  if (modules_isFunction(path)) {
    func = path;
  } else {
    path = _toPath_toPath(path);
    contextPath = path.slice(0, -1);
    path = path[path.length - 1];
  }
  return map_map(obj, function(context) {
    var method = func;
    if (!method) {
      if (contextPath && contextPath.length) {
        context = deepGet(context, contextPath);
      }
      if (context == null) return void 0;
      method = context[path];
    }
    return method == null ? method : method.apply(context, args);
  });
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/pluck.js



// Convenience version of a common use case of `_.map`: fetching a property.
function pluck(obj, key) {
  return map_map(obj, property(key));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/where.js



// Convenience version of a common use case of `_.filter`: selecting only
// objects containing specific `key:value` pairs.
function where(obj, attrs) {
  return filter(obj, matcher_matcher(attrs));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/max.js





// Return the maximum element (or element-based computation).
function max(obj, iteratee, context) {
  var result = -Infinity, lastComputed = -Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = _isArrayLike(obj) ? obj : values_values(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value > result) {
        result = value;
      }
    }
  } else {
    iteratee = cb(iteratee, context);
    each(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/min.js





// Return the minimum element (or element-based computation).
function min(obj, iteratee, context) {
  var result = Infinity, lastComputed = Infinity,
      value, computed;
  if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
    obj = _isArrayLike(obj) ? obj : values_values(obj);
    for (var i = 0, length = obj.length; i < length; i++) {
      value = obj[i];
      if (value != null && value < result) {
        result = value;
      }
    }
  } else {
    iteratee = cb(iteratee, context);
    each(obj, function(v, index, list) {
      computed = iteratee(v, index, list);
      if (computed < lastComputed || computed === Infinity && result === Infinity) {
        result = v;
        lastComputed = computed;
      }
    });
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/sample.js






// Sample **n** random values from a collection using the modern version of the
// [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
// If **n** is not specified, returns a single random element.
// The internal `guard` argument allows it to work with `_.map`.
function sample_sample(obj, n, guard) {
  if (n == null || guard) {
    if (!_isArrayLike(obj)) obj = values_values(obj);
    return obj[random(obj.length - 1)];
  }
  var sample = _isArrayLike(obj) ? clone(obj) : values_values(obj);
  var length = _getLength(sample);
  n = Math.max(Math.min(n, length), 0);
  var last = length - 1;
  for (var index = 0; index < n; index++) {
    var rand = random(index, last);
    var temp = sample[index];
    sample[index] = sample[rand];
    sample[rand] = temp;
  }
  return sample.slice(0, n);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/shuffle.js


// Shuffle a collection.
function shuffle(obj) {
  return sample_sample(obj, Infinity);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/sortBy.js




// Sort the object's values by a criterion produced by an iteratee.
function sortBy(obj, iteratee, context) {
  var index = 0;
  iteratee = cb(iteratee, context);
  return pluck(map_map(obj, function(value, key, list) {
    return {
      value: value,
      index: index++,
      criteria: iteratee(value, key, list)
    };
  }).sort(function(left, right) {
    var a = left.criteria;
    var b = right.criteria;
    if (a !== b) {
      if (a > b || a === void 0) return 1;
      if (a < b || b === void 0) return -1;
    }
    return left.index - right.index;
  }), 'value');
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_group.js



// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function(obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = cb(iteratee, context);
    each(obj, function(value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/groupBy.js



// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
/* harmony default export */ var groupBy = (group(function(result, value, key) {
  if (has(result, key)) result[key].push(value); else result[key] = [value];
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/indexBy.js


// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
/* harmony default export */ var indexBy = (group(function(result, value, key) {
  result[key] = value;
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/countBy.js



// Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
/* harmony default export */ var countBy = (group(function(result, value, key) {
  if (has(result, key)) result[key]++; else result[key] = 1;
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/partition.js


// Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
/* harmony default export */ var modules_partition = (group(function(result, value, pass) {
  result[pass ? 0 : 1].push(value);
}, true));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/toArray.js








// Safely create a real, live array from anything iterable.
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray(obj) {
  if (!obj) return [];
  if (isArray(obj)) return _setup["q" /* slice */].call(obj);
  if (isString(obj)) {
    // Keep surrogate pair characters together.
    return obj.match(reStrSymbol);
  }
  if (_isArrayLike(obj)) return map_map(obj, identity);
  return values_values(obj);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/size.js



// Return the number of elements in a collection.
function size(obj) {
  if (obj == null) return 0;
  return _isArrayLike(obj) ? obj.length : keys_keys(obj).length;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_keyInObj.js
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function keyInObj(value, key, obj) {
  return key in obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/pick.js







// Return a copy of the object only containing the allowed properties.
/* harmony default export */ var pick = (restArguments(function(obj, keys) {
  var result = {}, iteratee = keys[0];
  if (obj == null) return result;
  if (modules_isFunction(iteratee)) {
    if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
    keys = allKeys(obj);
  } else {
    iteratee = keyInObj;
    keys = flatten(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/omit.js








// Return a copy of the object without the disallowed properties.
/* harmony default export */ var omit = (restArguments(function(obj, keys) {
  var iteratee = keys[0], context;
  if (modules_isFunction(iteratee)) {
    iteratee = negate(iteratee);
    if (keys.length > 1) context = keys[1];
  } else {
    keys = map_map(flatten(keys, false, false), String);
    iteratee = function(value, key) {
      return !contains(keys, key);
    };
  }
  return pick(obj, iteratee, context);
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/initial.js


// Returns everything but the last entry of the array. Especially useful on
// the arguments object. Passing **n** will return all the values in
// the array, excluding the last N.
function initial_initial(array, n, guard) {
  return _setup["q" /* slice */].call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/first.js


// Get the first element of an array. Passing **n** will return the first N
// values in the array. The **guard** check allows it to work with `_.map`.
function first(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[0];
  return initial_initial(array, array.length - n);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/rest.js


// Returns everything but the first entry of the `array`. Especially useful on
// the `arguments` object. Passing an **n** will return the rest N values in the
// `array`.
function rest_rest(array, n, guard) {
  return _setup["q" /* slice */].call(array, n == null || guard ? 1 : n);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/last.js


// Get the last element of an array. Passing **n** will return the last N
// values in the array.
function last_last(array, n, guard) {
  if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
  if (n == null || guard) return array[array.length - 1];
  return rest_rest(array, Math.max(0, array.length - n));
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/compact.js


// Trim out all falsy values from an array.
function compact(array) {
  return filter(array, Boolean);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/flatten.js


// Flatten out an array, either recursively (by default), or up to `depth`.
// Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
function flatten_flatten(array, depth) {
  return flatten(array, depth, false);
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/difference.js





// Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
/* harmony default export */ var difference = (restArguments(function(array, rest) {
  rest = flatten(rest, true, true);
  return filter(array, function(value){
    return !contains(rest, value);
  });
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/without.js



// Return a version of the array that does not contain the specified value(s).
/* harmony default export */ var without = (restArguments(function(array, otherArrays) {
  return difference(array, otherArrays);
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/uniq.js





// Produce a duplicate-free version of the array. If the array has already
// been sorted, you have the option of using a faster algorithm.
// The faster algorithm will not work with an iteratee if the iteratee
// is not a one-to-one function, so providing an iteratee will disable
// the faster algorithm.
function uniq(array, isSorted, iteratee, context) {
  if (!isBoolean(isSorted)) {
    context = iteratee;
    iteratee = isSorted;
    isSorted = false;
  }
  if (iteratee != null) iteratee = cb(iteratee, context);
  var result = [];
  var seen = [];
  for (var i = 0, length = _getLength(array); i < length; i++) {
    var value = array[i],
        computed = iteratee ? iteratee(value, i, array) : value;
    if (isSorted && !iteratee) {
      if (!i || seen !== computed) result.push(value);
      seen = computed;
    } else if (iteratee) {
      if (!contains(seen, computed)) {
        seen.push(computed);
        result.push(value);
      }
    } else if (!contains(result, value)) {
      result.push(value);
    }
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/union.js




// Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
/* harmony default export */ var union = (restArguments(function(arrays) {
  return uniq(flatten(arrays, true, true));
}));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/intersection.js



// Produce an array that contains every item shared between all the
// passed-in arrays.
function intersection(array) {
  var result = [];
  var argsLength = arguments.length;
  for (var i = 0, length = _getLength(array); i < length; i++) {
    var item = array[i];
    if (contains(result, item)) continue;
    var j;
    for (j = 1; j < argsLength; j++) {
      if (!contains(arguments[j], item)) break;
    }
    if (j === argsLength) result.push(item);
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/unzip.js




// Complement of zip. Unzip accepts an array of arrays and groups
// each array's elements on shared indices.
function unzip(array) {
  var length = array && max(array, _getLength).length || 0;
  var result = Array(length);

  for (var index = 0; index < length; index++) {
    result[index] = pluck(array, index);
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/zip.js



// Zip together multiple lists into a single array -- elements that share
// an index go together.
/* harmony default export */ var zip = (restArguments(unzip));

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/object.js


// Converts lists into objects. Pass either a single array of `[key, value]`
// pairs, or two parallel arrays of the same length -- one of keys, and one of
// the corresponding values. Passing by pairs is the reverse of `_.pairs`.
function object_object(list, values) {
  var result = {};
  for (var i = 0, length = _getLength(list); i < length; i++) {
    if (values) {
      result[list[i]] = values[i];
    } else {
      result[list[i][0]] = list[i][1];
    }
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/range.js
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function range(start, stop, step) {
  if (stop == null) {
    stop = start || 0;
    start = 0;
  }
  if (!step) {
    step = stop < start ? -1 : 1;
  }

  var length = Math.max(Math.ceil((stop - start) / step), 0);
  var range = Array(length);

  for (var idx = 0; idx < length; idx++, start += step) {
    range[idx] = start;
  }

  return range;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/chunk.js


// Chunk a single array into multiple arrays, each containing `count` or fewer
// items.
function chunk(array, count) {
  if (count == null || count < 1) return [];
  var result = [];
  var i = 0, length = array.length;
  while (i < length) {
    result.push(_setup["q" /* slice */].call(array, i, i += count));
  }
  return result;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/_chainResult.js


// Helper function to continue chaining intermediate results.
function chainResult(instance, obj) {
  return instance._chain ? _(obj).chain() : obj;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/mixin.js






// Add your own custom functions to the Underscore object.
function mixin(obj) {
  each(functions(obj), function(name) {
    var func = _[name] = obj[name];
    _.prototype[name] = function() {
      var args = [this._wrapped];
      _setup["o" /* push */].apply(args, arguments);
      return chainResult(this, func.apply(_, args));
    };
  });
  return _;
}

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/underscore-array-methods.js





// Add all mutator `Array` functions to the wrapper.
each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
  var method = _setup["a" /* ArrayProto */][name];
  _.prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) {
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) {
        delete obj[0];
      }
    }
    return chainResult(this, obj);
  };
});

// Add all accessor `Array` functions to the wrapper.
each(['concat', 'join', 'slice'], function(name) {
  var method = _setup["a" /* ArrayProto */][name];
  _.prototype[name] = function() {
    var obj = this._wrapped;
    if (obj != null) obj = method.apply(obj, arguments);
    return chainResult(this, obj);
  };
});

/* harmony default export */ var underscore_array_methods = (_);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/index.js
// Named Exports
// =============

//     Underscore.js 1.13.1
//     https://underscorejs.org
//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

// Baseline setup.



// Object Functions
// ----------------
// Our most fundamental functions operate on any JavaScript object.
// Most functions in Underscore depend on at least one function in this section.

// A group of functions that check the types of core JavaScript values.
// These are often informally referred to as the "isType" functions.



























// Functions that treat an object as a dictionary of key-value pairs.
















// Utility Functions
// -----------------
// A bit of a grab bag: Predicate-generating functions for use with filters and
// loops, string escaping and templating, create random numbers and unique ids,
// and functions that facilitate Underscore's chaining and iteration conventions.



















// Function (ahem) Functions
// -------------------------
// These functions take a function as an argument and return a new function
// as the result. Also known as higher-order functions.















// Finders
// -------
// Functions that extract (the position of) a single element from an object
// or array based on some criterion.









// Collection Functions
// --------------------
// Functions that work on any collection of elements: either an array, or
// an object of key-value pairs.
























// `_.pick` and `_.omit` are actually object functions, but we put
// them here in order to create a more natural reading order in the
// monolithic build as they depend on `_.contains`.



// Array Functions
// ---------------
// Functions that operate on arrays (and array-likes) only, because they’re
// expressed in terms of operations on an ordered list of values.

















// OOP
// ---
// These modules support the "object-oriented" calling style. See also
// `underscore.js` and `index-default.js`.



// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/index-default.js
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```



// Add all of the Underscore functions to the wrapper object.
var index_default__ = mixin(modules_namespaceObject);
// Legacy Node.js API.
index_default__._ = index_default__;
// Export the Underscore API.
/* harmony default export */ var index_default = (index_default__);

// CONCATENATED MODULE: /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/underscore/modules/index-all.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return index_default; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "VERSION", function() { return _setup["e" /* VERSION */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "restArguments", function() { return restArguments; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNull", function() { return isNull; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isUndefined", function() { return isUndefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isBoolean", function() { return isBoolean; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isElement", function() { return isElement; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNumber", function() { return isNumber; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isDate", function() { return isDate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isRegExp", function() { return isRegExp; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isError", function() { return isError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isSymbol", function() { return isSymbol; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArrayBuffer", function() { return isArrayBuffer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isDataView", function() { return modules_isDataView; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isFunction", function() { return modules_isFunction; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isArguments", function() { return modules_isArguments; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isFinite", function() { return isFinite_isFinite; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isNaN", function() { return isNaN_isNaN; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isTypedArray", function() { return modules_isTypedArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMatch", function() { return isMatch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEqual", function() { return isEqual; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isMap", function() { return isMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWeakMap", function() { return isWeakMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isSet", function() { return isSet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isWeakSet", function() { return isWeakSet; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "keys", function() { return keys_keys; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "allKeys", function() { return allKeys; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "values", function() { return values_values; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pairs", function() { return pairs_pairs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "functions", function() { return functions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "methods", function() { return functions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "extendOwn", function() { return extendOwn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "assign", function() { return extendOwn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tap", function() { return tap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "has", function() { return has_has; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mapObject", function() { return mapObject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "identity", function() { return identity; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "constant", function() { return constant; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "noop", function() { return noop; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toPath", function() { return toPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "property", function() { return property; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "propertyOf", function() { return propertyOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matcher", function() { return matcher_matcher; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matches", function() { return matcher_matcher; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "times", function() { return times; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "random", function() { return random; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "now", function() { return now; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "escape", function() { return modules_escape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unescape", function() { return modules_unescape; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "templateSettings", function() { return templateSettings; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "template", function() { return template_template; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "result", function() { return result_result; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniqueId", function() { return uniqueId; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "chain", function() { return chain; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "iteratee", function() { return iteratee_iteratee; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partial", function() { return modules_partial; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bind", function() { return bind; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindAll", function() { return bindAll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "memoize", function() { return memoize_memoize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "delay", function() { return delay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defer", function() { return defer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "wrap", function() { return wrap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "negate", function() { return negate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "after", function() { return after; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "before", function() { return before; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "once", function() { return once; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findKey", function() { return findKey; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findLastIndex", function() { return findLastIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortedIndex", function() { return sortedIndex_sortedIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "lastIndexOf", function() { return lastIndexOf; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "detect", function() { return find; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findWhere", function() { return findWhere; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "each", function() { return each; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "forEach", function() { return each; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "map", function() { return map_map; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "collect", function() { return map_map; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "foldl", function() { return reduce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "inject", function() { return reduce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reduceRight", function() { return reduceRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "foldr", function() { return reduceRight; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "select", function() { return filter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reject", function() { return reject; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "all", function() { return every; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "some", function() { return some; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "any", function() { return some; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "contains", function() { return contains; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "includes", function() { return contains; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "include", function() { return contains; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "invoke", function() { return invoke; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pluck", function() { return pluck; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "where", function() { return where; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "shuffle", function() { return shuffle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sample", function() { return sample_sample; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sortBy", function() { return sortBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "indexBy", function() { return indexBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "countBy", function() { return countBy; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partition", function() { return modules_partition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toArray", function() { return toArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pick", function() { return pick; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "omit", function() { return omit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "first", function() { return first; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "head", function() { return first; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "take", function() { return first; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "initial", function() { return initial_initial; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "last", function() { return last_last; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "rest", function() { return rest_rest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tail", function() { return rest_rest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "drop", function() { return rest_rest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compact", function() { return compact; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatten", function() { return flatten_flatten; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "without", function() { return without; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "uniq", function() { return uniq; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unique", function() { return uniq; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "intersection", function() { return intersection; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "difference", function() { return difference; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "unzip", function() { return unzip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "transpose", function() { return unzip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zip", function() { return zip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "object", function() { return object_object; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "chunk", function() { return chunk; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mixin", function() { return mixin; });
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.




/***/ }),

/***/ "lSlM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dwmRepository = exports.CryptoRepository = exports.ExpiredLicensesRepository = exports.FlexiblePromotionsRepository = exports.GdprReportsRepository = exports.AppPricesRepository = exports.PaymentUrlsRepository = exports.NewsRepository = exports.RecommendationsRepository = exports.AppInstancesRepository = exports.PaymentTypesRepository = exports.UsersRepository = exports.ActivationCodesRepository = exports.GdprActionsRepository = exports.EventsRepository = exports.LicensesRepository = exports.MeRepository = exports.TransactionsRepository = exports.DevicesRepository = exports.AppIntegrationsRepository = undefined;

var _RFC = __webpack_require__("DaMF");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("PONE");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("xtm7");

var _RFC6 = _interopRequireDefault(_RFC5);

var _RFC7 = __webpack_require__("Iq1o");

var _RFC8 = _interopRequireDefault(_RFC7);

var _RFC9 = __webpack_require__("gE/G");

var _RFC10 = _interopRequireDefault(_RFC9);

var _RFC11 = __webpack_require__("fFqN");

var _RFC12 = _interopRequireDefault(_RFC11);

var _RFC13 = __webpack_require__("wR9E");

var _RFC14 = _interopRequireDefault(_RFC13);

var _RFC15 = __webpack_require__("nhjq");

var _RFC16 = _interopRequireDefault(_RFC15);

var _RFC17 = __webpack_require__("Fa4y");

var _RFC18 = _interopRequireDefault(_RFC17);

var _RFC19 = __webpack_require__("OTi5");

var _RFC20 = _interopRequireDefault(_RFC19);

var _RFC21 = __webpack_require__("XEU7");

var _RFC22 = _interopRequireDefault(_RFC21);

var _RFC23 = __webpack_require__("HimL");

var _RFC24 = _interopRequireDefault(_RFC23);

var _RFC25 = __webpack_require__("zmiE");

var _RFC26 = _interopRequireDefault(_RFC25);

var _RFC27 = __webpack_require__("o92E");

var _RFC28 = _interopRequireDefault(_RFC27);

var _RFC29 = __webpack_require__("Qxat");

var _RFC30 = _interopRequireDefault(_RFC29);

var _RFC31 = __webpack_require__("ROsk");

var _RFC32 = _interopRequireDefault(_RFC31);

var _RFC33 = __webpack_require__("zOZQ");

var _RFC34 = _interopRequireDefault(_RFC33);

var _RFC35 = __webpack_require__("jwra");

var _RFC36 = _interopRequireDefault(_RFC35);

var _RFC37 = __webpack_require__("7onk");

var _RFC38 = _interopRequireDefault(_RFC37);

var _RFC39 = __webpack_require__("GozI");

var _RFC40 = _interopRequireDefault(_RFC39);

__webpack_require__("mkCZ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AppIntegrationsRepository = _RFC2.default;
exports.DevicesRepository = _RFC4.default;
exports.TransactionsRepository = _RFC6.default;
exports.MeRepository = _RFC8.default;
exports.LicensesRepository = _RFC10.default;
exports.EventsRepository = _RFC12.default;
exports.GdprActionsRepository = _RFC14.default;
exports.ActivationCodesRepository = _RFC16.default;
exports.UsersRepository = _RFC18.default;
exports.PaymentTypesRepository = _RFC20.default;
exports.AppInstancesRepository = _RFC22.default;
exports.RecommendationsRepository = _RFC24.default;
exports.NewsRepository = _RFC26.default;
exports.PaymentUrlsRepository = _RFC28.default;
exports.AppPricesRepository = _RFC30.default;
exports.GdprReportsRepository = _RFC32.default;
exports.FlexiblePromotionsRepository = _RFC34.default;
exports.ExpiredLicensesRepository = _RFC36.default;
exports.CryptoRepository = _RFC38.default;
exports.dwmRepository = _RFC40.default; /* eslint import/prefer-default-export: 0 */

/***/ }),

/***/ "lTTh":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("719l"),
    ListCache = __webpack_require__("ICfp"),
    Map = __webpack_require__("9u6A");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "ldPQ":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-device\" ng-if=\"!OnlineDeploymentCtrl.deploying\">\n    <div class=\"top-elements content-wrapper\">\n        <div>\n            <div class=\"animation-holder-online\"\n                 style=\"background:url(https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/sit-back.gif?v{{OnlineDeploymentCtrl.randomNumber}}) 0 0 no-repeat;\"></div>\n            <h2 class=\"text-xxl mb10\" translate=\"cw.deploy.sitback.title\"></h2>\n        </div>\n\n        <p class=\"text-l text-grey-4 deploy-text-container\" translate-values=\"{service: OnlineDeploymentCtrl.app.attributes.resource.oeName}\" translate=\"cw.deploy.sitback.info\"></p>\n\n        <button class=\"btn btn-primary btn-large mt20\" translate=\"cw.general.fixed_it\" ng-click=\"OnlineDeploymentCtrl.close()\"></button>\n    </div>\n</div>\n"

/***/ }),

/***/ "liN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* @ngdoc service
* @name notifications.PaymentTypesNotifications
*
* @description
* This class is used to process notifications on payment_types enpoint.
*/
var PaymentTypesNotifications = {

    alertDisplayed: false,

    /**
     * @ngdoc function
     * @name notifications.PaymentTypesNotifications#isCardExpired
     * @methodOf notifications.PaymentTypesNotifications
     * @function
     *
     * @description
     * This function can be used to check is a payment method has been/ will be
     * expired within the notification time of days
     *
     * @param {object} payments An object with paymentsTypes
     * @param {number} notificationsTime a number of days
     */
    isCardExpired: function isCardExpired(payment, notificationsTime) {

        var now = moment();
        var formatedDate = payment.attributes.expiration_date.split('-');
        if (formatedDate.length > 1) {

            // create a new date at last day of month
            var paymentExpirationDate = moment(new Date(Number(formatedDate[0]), Number(formatedDate[1]), 0));
            return paymentExpirationDate.diff(now, 'days') <= notificationsTime;
        }
        return false;
    },


    /**
     * @ngdoc function
     * @name notifications.PaymentTypesNotifications#processCheckPayments
     * @methodOf notifications.PaymentTypesNotifications
     * @function
     *
     * @description
     * This function can be used to process the creation
     * of payments types and send notifications if any are expired
     *
     * @param {object} payments An object with paymentsTypes
     */

    processCheckPayments: function processCheckPayments(payments) {
        var _this = this;

        var showExpiredAlert = false;

        payments.forEach(function (payment) {

            // check if the expiration date has this format 2018-11-16T15:02:04+02:00
            if (!payment.attributes.expiration_date || payment.attributes.expiration_date.indexOf('-') === -1) {

                return;
            }
            // notify with 10days before
            var daysBeforeExpiration = CWCONFIG.features.paymentTypesDaysBeforeExpiration || 10;
            if (_this.isCardExpired(payment, daysBeforeExpiration)) {

                showExpiredAlert = true;
            }
        });

        if (showExpiredAlert && this.alertDisplayed === false) {

            this.alertDisplayed = true;

            setTimeout(function () {
                return _RFC2.default.warning('cw.payment.expired_notification');
            }, CWCONFIG.timeouts.expiredPaymentTypes);
        }
    }
}; /* eslint array-callback-return: 0 */

exports.default = PaymentTypesNotifications;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "ll/X":
/***/ (function(module, exports) {

module.exports = "<div class=\"dashboard-tabs-holder\">\n    <div class=\"dashboard-tabs text-left crypto-tabs\">\n        <span class='text-center text-l text-dark crs-pointer' ng-class=\"{'active': activeTab === 'mining'}\"\n            ng-click=\"switchTab('mining', 'Mining')\"\n            connectqa-crypto-tab=\"Mining\">\n            <p translate=\"cw.dashboard.crypto.tabs.mining\"></p>\n            <p class=\"label-medium label-orange label-position-right\" translate=\"cw.general.ui.disabled\"></p>\n        </span>\n        <span class='text-center text-l text-dark crs-pointer' ng-class=\"{'active': activeTab === 'wallet'}\"\n            ng-click=\"switchTab('wallet', 'Wallet')\"\n            translate=\"cw.dashboard.crypto.tabs.wallet\"\n            connectqa-crypto-tab=\"Wallet\">\n        </span>\n        <span class='text-center text-l text-dark crs-pointer' ng-class=\"{'active': activeTab === 'faq'}\"\n            ng-click=\"switchTab('faq', 'FAQ')\"\n            translate=\"cw.dashboard.crypto.tabs.faq\"\n            connectqa-crypto-tab=\"FAQ\">\n        </span>\n    </div>\n</div>\n\n<div class=\"crypto\">\n    <div class=\"crypto-container\">\n        <!-- Mining tab -->\n        <crypto-mining ng-if=\"activeTab === 'mining'\"></crypto-mining>\n        <!-- End mining tab -->\n\n        <!-- Wallet tab -->\n        <div class=\"wallet\" ng-if=\"activeTab === 'wallet'\">\n            <div class=\"content-wrapper card\" connectqa-crypto-section=\"Wallet\">\n                <crypto-wallet></crypto-wallet>\n            </div>\n            <div class=\"content-wrapper card mt50\" connectqa-crypto-section=\"Transactions\">\n                <crypto-transactions></crypto-transactions>\n            </div>\n        </div><!-- Ene wallet tab -->\n\n        <!-- FAQ tab -->\n        <div class=\"content-wrapper card\" ng-if=\"activeTab === 'faq'\">\n            <crypto-faq></crypto-faq>\n        </div><!-- Ene FAQ tab -->\n    </div>\n\n    <!-- Disabled mining modal -->\n    <div ng-if=\"activeTab === 'mining' || activeTab === 'wallet'\" class=\"crypto-modal\"\n        ng-class=\"{\n            'closed': activeTab === 'wallet' && disabledMiningModalClosed\n        }\n        \">\n        <div class=\"overlay\"></div>\n        <div class=\"modal-content card\">\n            <i ng-if=\"activeTab === 'wallet'\" class=\"close-lightbox icon icon-close icon-grey-2\" ng-click=\"closeDisabledMiningModal();\"></i>\n            <div class=\"icon-warning-light\"></div>\n            <h2 class=\"mt40 mb20 text-xxl text-grey-1\" translate=\"cw.dashboard.crypto.disabled_mining.title\"></h2>\n            <p class=\"font-bold text-m text-grey-4 mb10\" translate=\"cw.dashboard.crypto.disabled_mining.desc_1\" translate-values=\"{link: '/dashboard/crypto/tabs/faq'}\" translate-compile></p>\n            <p class=\"text-m text-grey-4 mb10\" translate=\"cw.dashboard.crypto.disabled_mining.desc_2\"></p>\n            <p class=\"text-m text-grey-4 mb10\" ng-if=\"$root.moneyBalance && $root.cryptoCurrency && $root.cryptoBalance && $root.cryptoSymbol\" translate=\"cw.dashboard.crypto.disabled_mining.desc_3\" translate-values=\"{\n                moneyBalance: $root.moneyBalance,\n                moneyCurrency: $root.cryptoCurrency,\n                cryptoBalance: $root.cryptoBalance,\n                cryptoCurrency: $root.cryptoSymbol\n            }\">\n            </p>\n            <p class=\"text-m text-grey-4\" translate=\"cw.dashboard.crypto.disabled_mining.desc_4\"></p>\n            <div class=\"btn btn-medium btn-secondary mt40\" ng-if=\"activeTab === 'mining'\" ng-click=\"openWallet()\" translate=\"cw.dashboard.crypto.disabled_mining.open_wallet\">\n            </div>\n            <div class=\"btn btn-medium btn-secondary mt40\" ng-if=\"activeTab === 'wallet'\" ng-click=\"closeDisabledMiningModal();\" translate=\"cw.general.ui.close\">\n            </div>\n        </div>\n    </div>\n    <!-- Disabled mining modal -->\n\n</div>"

/***/ }),

/***/ "m0M4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint max-len: 0 */
/* eslint consistent-return: 0 */

/**
 * Url module for configuring the route provider
 * Stores all app routes
 */
angular.module('urls').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {

    var Resolvers = angular.module('resolvers');
    var Modals = angular.module('modals');

    if (window.location.href.indexOf('/dashboard/renewal') > -1) {

        window.activeNavSection = 'renewal';
    }

    var rule = function rule($injector, $location) {

        var path = $location.path();

        if (path.indexOf('sld/') > -1) {

            $location.replace().path(path.replace(/\/(sld)\/(.*)/gi, ''));
        }

        if (path.slice(-1) === '/') {

            $location.replace().path(path.slice(0, -1));
        }

        /*  Redirect Reset Password URLS that are still coming with JWT tokens (old links)
            This condition should be removed after all the clients will
            send the new SSO route for reset password flow */
        if (path.indexOf('/auth/reset/jwt/') > -1) {

            var urlRoute = path.split('/') || [];
            var jwtIndex = urlRoute.findIndex(function (route) {
                return route === 'jwt';
            }) + 1;

            window.location.href = '/' + CWCONFIG.language + '/auth/reset?access_token=' + urlRoute[jwtIndex] + '&client_id=dashboard';
        }

        // Fallback for old download kit page
        if (path.indexOf('/downloadKit/service/') > -1) {

            var getDownloadUrl = path.substr(path.lastIndexOf('/') + 1) || '';
            var decodeDownloadUrl = atob(getDownloadUrl) || '';
            var appId = decodeDownloadUrl.split('_')[2];
            var detectOsByFileExtension = decodeDownloadUrl.substr(decodeDownloadUrl.lastIndexOf('.') + 1) || '';

            var os = 'windows';

            if (detectOsByFileExtension === 'dmg') {

                os = 'osx';
            }

            window.location.href = '/' + CWCONFIG.language + '/auth/login?client_id=dashboard&redirect_uri=/dashboard/devices/new/ltb/deploy?appId=' + appId + '%26os=' + os;
        }
    };

    var subscriptionsRule = function subscriptionsRule($injector, $location) {

        var path = $location.path();
        if (path.indexOf('subscriptions') > -1 && path.indexOf('tabs') === -1) {

            // fix missing tabs
            return path.replace('/subscriptions', '/subscriptions/tabs/plans');
        }
    };

    var routeError = function routeError($injector, $location) {

        $location.replace().path('/');
    };

    rule.$inject = ['$injector', '$location'];

    // rules for Dashboard
    $urlRouterProvider.when('/', '/dashboard/home').when('/apple-login', '/auth/login').when('/dashboard', '/dashboard/home').when('/dashboard/apps/:resourceId/devices/:deviceId', '/dashboard/home')

    // redirect old routes
    .when('/registration/:notFound*options', '/auth/register').when('/auth/login/myat/:ahash*options', '/auth/login/t/:ahash*options').when('/dashboard/subscriptions', '/dashboard/subscriptions/tabs/plans').when('/dashboard/subscriptions/', '/dashboard/subscriptions/tabs/plans').when('/dashboard/support', '/dashboard/support/tabs/support').when('/dashboard/support/', '/dashboard/support/tabs/support')

    // CMA Redirect
    .when('/dashboard/renewal', '/dashboard/subscriptions/tabs/plans').when('/dashboard/renewal/tabs/plans', '/dashboard/subscriptions/tabs/plans')

    // TODO these rules must be deleted when the URL will contain only JWT
    .when('/auth/login/adt/:token*options', '/auth/login/jwt/:token*options').when('/auth/login/t/:token*options', '/auth/login/jwt/:token*options').otherwise(routeError)
    // Allow all routes to end with a trailing `/` and redirect to the normal route
    .rule(rule)
    // Fill all old subscriptions routes
    .rule(subscriptionsRule);

    $stateProvider

    // Root state
    .state('root', {
        abstract: true,
        views: {
            root: {
                controller: 'Root'
            }
        },
        resolve: {
            translation: Resolvers.Translation,
            tab: ['RootResolver', '$q', function (RootResolver, $q) {

                var deferred = $q.defer();

                // waiting for RootResolver to be resolved
                RootResolver.then(function () {

                    deferred.resolve();
                });

                return deferred.promise;
            }]
        }
    })

    // DEBUG ROUTE
    .state('debug', {
        views: {
            'debug.abstract': {
                template: '',
                controller: 'forceDebug'
            }
        },
        url: '/debug'
    }).state('root.main', {
        url: '/'
    })

    // AUTH
    .state('root.auth', {
        abstract: true,
        views: {
            'landing.auth': {
                template: __webpack_require__("lFCP")
            },
            'main.auth': {
                template: __webpack_require__("9wlN"),
                controller: 'BaseAuth'
            }
        },
        url: '/auth',
        onEnter: function () {

            var onEnter = function onEnter($document) {

                angular.element($document[0].body).addClass('auth');
            };
            onEnter.$inject = ['$document'];
            onEnter.$inject = ['$document'];

            return onEnter;
        }(),
        onExit: function () {

            var onExit = function onExit($document) {

                angular.element($document[0].body).removeClass('auth');
            };
            onExit.$inject = ['$document'];
            onExit.$inject = ['$document'];

            return onExit;
        }()
    }).state('root.auth.set-password', {
        url: '/set-password/*options',
        views: {
            'main.auth@root': {
                template: __webpack_require__("57js"),
                controller: 'SetPassword',
                controllerAs: 'oauthCtrl'
            }
        }
    }).state('root.auth.login', {
        url: '/login',
        template: __webpack_require__("nGYS"),
        controller: 'Login',
        controllerAs: 'oauthCtrl'
    })
    // LTB Login
    .state('root.auth.login.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    }).state('root.auth.register', {
        url: '/register',
        template: __webpack_require__("Psd9"),
        controller: 'Register',
        controllerAs: 'oauthCtrl'
    })
    // LTB Register
    .state('root.auth.register.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    }).state('root.auth.forgot', {
        url: '/forgot',
        template: __webpack_require__("ycmm"),
        controller: 'Forgot',
        controllerAs: 'oauthCtrl'
    })
    // LTB Forgot
    .state('root.auth.forgot.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    }).state('root.auth.reset', {
        url: '/reset',
        template: __webpack_require__("OMn1"),
        controller: 'Reset',
        controllerAs: 'oauthCtrl'
    })
    // LTB Reset
    .state('root.auth.reset.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    }).state('root.auth.confirm', {
        url: '/confirm',
        template: __webpack_require__("vS/D"),
        controller: 'Confirm',
        controllerAs: 'oauthCtrl'
    })
    // LTB Confirm
    .state('root.auth.confirm.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    }).state('root.auth.jwt', {
        url: '/login/jwt/:token*options',
        template: '',
        controller: 'LoginJWT'
    }).state('root.auth.ahash', {
        url: '/login/myat/:ahash*options',
        template: '',
        controller: 'LoginAHash'
    }).state('root.auth.tfa', {
        url: '/tfa',
        template: __webpack_require__("Sf4F"),
        controller: 'Tfa',
        controllerAs: 'oauthCtrl'
    })
    // LTB TFA
    .state('root.auth.tfa.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })
    // SSO Logout
    .state('root.auth.logout', {
        url: '/logout',
        resolve: {
            auth: ['Auth', function (Auth) {

                Auth.logOut();
            }]
        }
    })

    // BASE STATE
    .state('root.dashboard', {
        abstract: true,
        views: {
            'main.dashboard': {
                template: __webpack_require__("OWtL"),
                controller: 'Dashboard',
                controllerAs: 'dashboardCtrl'
            },
            'dashboard.navigation@root.dashboard': {
                template: __webpack_require__("3EC6"),
                controller: 'DashboardNavigation'
            },
            'dashboard.body@root.dashboard': {
                template: __webpack_require__("Qc0x"),
                controller: 'DashboardBody'
            }
        },
        url: '/dashboard',
        resolve: {
            tab: ['RootResolver', 'DashboardResolver', '$q', '$rootScope', function (RootResolver, DashboardResolver, $q, $rootScope) {

                var deferred = $q.defer();

                // wait for RootResolver to be done to get dashboard resources
                RootResolver.then(function () {

                    // get dashboard resources and hide loading state
                    DashboardResolver.getDashboardResourcesPromise().then(function () {

                        deferred.resolve();
                        $rootScope.State.loading = false;
                    });
                });

                return deferred.promise;
            }]
        }
    })

    // MY ACCOUNT TABS
    .state('root.dashboard.my-account', {
        url: '/my-account/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("S3Zr"),
                controller: 'MyAccount'
            }
        }
    })

    // LTB MY ACCOUNT
    .state('root.dashboard.my-account.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // NEWS
    .state('root.dashboard.news', {
        url: '/news/tabs/:tab?page',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("jih4"),
                controller: 'News',
                controllerAs: 'NewsCtrl'
            }
        }
    })

    // NEWS SINGLE ARTICLE VIEW
    .state('root.dashboard.article', {
        url: '/news/tabs/:tab/article/:id?page',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("Pohv"),
                controller: 'Article',
                controllerAs: 'ArticleCtrl'
            }
        }
    })

    // HOME
    .state('root.dashboard.home', {
        url: '/home',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("Y592"),
                controller: 'Homepage',
                controllerAs: 'homepageCtrl'
            }
        }
    })

    // LTB HOME
    .state('root.dashboard.home.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB NEWS LIST
    .state('root.dashboard.news.ltb', {
        url: '/:resourceId/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB NEWS ARTICLE
    .state('root.dashboard.article.ltb', {
        url: '/:resourceId/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB HOME DEPLOY
    // .state('root.dashboard.home.ltb.deploy', {
    //     parent: 'root.dashboard.home.ltb',
    //     url: '?deviceId&os&autoInstall',
    // })

    .state('root.dashboard.home.ltb.deploy', {
        parent: 'root.dashboard.home.ltb',
        url: '?appId&os&deviceCategory'
    })

    // LTB HOME BANNER PAYMENT
    .state('root.dashboard.home.ltb.banner', {
        parent: 'root.dashboard.home.ltb',
        url: '?promotion&subsource&variant&runtime'
    })

    // LTB HOME RENEW
    .state('root.dashboard.home.ltb.renew', {
        parent: 'root.dashboard.home.ltb',
        url: '?subsource?licenseId'
    })

    // MY DEVICES
    .state('root.dashboard.devices', {
        url: '/devices?deploy',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("+36T"),
                controller: 'Devices'
            }
        }
    })

    // LTB MY DEVICES
    .state('root.dashboard.devices.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB MY DEVICES DEPLOY
    .state('root.dashboard.devices.ltb.deploy', {
        parent: 'root.dashboard.devices.ltb',
        url: '?appId&os&deviceCategory'
    })

    // LTB MY DEVICES BANNER PAYMENT
    .state('root.dashboard.devices.ltb.banner', {
        parent: 'root.dashboard.devices.ltb',
        url: '?promotion&subsource&variant&runtime'
    })

    // DEVICE DETAILS
    // DEVICE DETAILS TAB
    .state('root.dashboard.device-details', {
        url: '/devices/:resourceId/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("9MNA"),
                controller: 'DeviceDetails'
            }
        }
    })

    // LTB DEVICE DETAILS TAB
    .state('root.dashboard.device-details.ltb', {
        parent: 'root.dashboard.device-details',
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB DEVICE DETAILS TAB DEPLOY
    .state('root.dashboard.device-details.ltb.deploy', {
        parent: 'root.dashboard.device-details.ltb',
        url: '?appId?autoInstall'
    })

    // LTB DEVICE DETAILS TAB ACTIVATE
    .state('root.dashboard.device-details.ltb.activate', {
        parent: 'root.dashboard.device-details.ltb',
        url: '?appId&bundle&installed'
    })

    // LTB DEVICE DETAILS BUY
    .state('root.dashboard.device-details.ltb.buy', {
        parent: 'root.dashboard.device-details.ltb',
        url: '?appId&promotion&subsource'
    })

    // APP DETAILS
    .state('root.dashboard.device-details.app-details', {
        parent: 'root.dashboard.device-details',
        url: '/apps/:appId'
    })

    // SUBSCRIPTIONS
    .state('root.dashboard.subscriptions', {
        url: '/subscriptions/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("hkAL"),
                controller: 'Subscriptions',
                controllerAs: 'subscriptionsCtrl'
            }
        }
    })

    // LTB MY SUBSCRIPTIONS
    .state('root.dashboard.subscriptions.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB MY SUBSCRIPTIONS DEPLOY
    .state('root.dashboard.subscriptions.ltb.deploy', {
        parent: 'root.dashboard.subscriptions.ltb',
        url: '?deviceId&appId&os&autoInstall'
    })

    // LTB MY SUBSCRIPTIONS RENEW
    .state('root.dashboard.subscriptions.ltb.renew', {
        parent: 'root.dashboard.subscriptions.ltb',
        url: '?subsource?licenseId'
    })

    // LTB MY SUBSCRIPTIONS BANNER PAYMENT
    .state('root.dashboard.subscriptions.ltb.banner', {
        parent: 'root.dashboard.subscriptions.ltb',
        url: '?promotion&subsource&variant&runtime'
    })

    // MY PRODUCTS
    .state('root.dashboard.products', {
        url: '/products',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("1Qb/"),
                controller: 'Products'
            }
        }
    })

    // LTB MY PRODUCTS
    .state('root.dashboard.products.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB MY PRODUCTS DEPLOY
    .state('root.dashboard.products.ltb.deploy', {
        parent: 'root.dashboard.products.ltb',
        url: '?deviceId&os&autoInstall&deployType'
    })

    // LTB MY PRODUCTS
    .state('root.dashboard.products.ltb.activate', {
        parent: 'root.dashboard.products.ltb',
        url: '?appId&os'
    })

    // LTB MY PRODUCTS BANNER PAYMENT
    .state('root.dashboard.products.ltb.banner', {
        parent: 'root.dashboard.products.ltb',
        url: '?promotion&subsource&variant&runtime'
    })

    // LTB MY PRODUCTS BUY
    .state('root.dashboard.products.ltb.buy', {
        parent: 'root.dashboard.products.ltb',
        url: '?promotion&subsource'
    })

    // STORE
    .state('root.dashboard.store', {
        url: '/store',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("4sKI"),
                controller: 'Store'
            }
        }
    })

    // LTB STORE
    .state('root.dashboard.store.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB STORE BUY
    .state('root.dashboard.store.ltb.buy', {
        parent: 'root.dashboard.store.ltb',
        url: '?promotion&runtime&subsource&variant'
    })

    // SUPPORT
    .state('root.dashboard.support', {
        url: '/support/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("xwt4"),
                controller: 'Support',
                controllerAs: 'supportCtrl'
            }
        }
    })

    // CRYPTO
    .state('root.dashboard.crypto', {
        url: '/crypto/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("ll/X"),
                controller: 'Crypto',
                controllerAs: 'cryptoCtrl'
            }
        }
    })

    // LTB CRYPTO
    .state('root.dashboard.crypto.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // DWM
    .state('root.dashboard.dwm', {
        url: '/identity-assistant/tabs/:tab',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("sy/n"),
                controller: 'Dwm',
                controllerAs: 'dwmCtrl'
            }
        }
    })

    // LTB DWM
    .state('root.dashboard.dwm.ltb', {
        url: '/:resourceId/ltb/:ltb?trial',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // LTB DWM BUY
    .state('root.dashboard.dwm.ltb.buy', {
        parent: 'root.dashboard.dwm.ltb',
        url: '?promotion&runtime&subsource&variant&test&button'
    })

    // LTB SUPPORT
    .state('root.dashboard.support.ltb', {
        url: '/ltb/:ltb',
        onEnter: Modals.openModal,
        onExit: Modals.closeModal
    })

    // GDPR Report Print Page
    .state('root.dashboard.print-gdpr-report', {
        url: '/print-gdpr-report',
        views: {
            'dashboard.body.content': {
                template: __webpack_require__("Mbmr"),
                controller: 'PrintGDPRReport',
                controllerAs: 'printGDPRReportCtrl'
            }
        }
    })

    // not allowed page
    .state('notAllowed', {
        url: '/not-allowed',
        views: {
            'main.abstract': {
                template: __webpack_require__("12Ij"),
                controller: 'NotAllowed',
                controllerAs: 'notAllowedCtrl'
            }
        }
    })

    // US Compliance failed
    .state('complianceFailed', {
        url: '/compliance-failed',
        views: {
            'main.abstract': {
                template: __webpack_require__("/nLZ"),
                controller: 'UsComplianceFailed',
                controllerAs: 'UsComplianceFailedCtrl'
            }
        }
    });
}]);

/***/ }),

/***/ "m7dZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$sce'];

var ThreatsLandscape = function ThreatsLandscape($scope, $sce) {
    _classCallCheck(this, ThreatsLandscape);

    var availableLanguages = ['en', 'de', 'fr', 'es', 'it', 'ru', 'pt-br'];
    var currentLanguage = CWCONFIG.language;
    var iframeLanguage = void 0;
    var isAvailableForCurrentLang = availableLanguages.find(function (lang) {
        return lang === currentLanguage;
    });

    if (isAvailableForCurrentLang) {

        iframeLanguage = isAvailableForCurrentLang;
    } else {

        iframeLanguage = 'en';
    }

    $scope.iframeUrl = $sce.trustAsResourceUrl('https://www.avira.com/' + iframeLanguage + '/threat-landscape?source=cw');

    setTimeout(function () {

        angular.element('.click-area-lightbox').addClass('threats-landscape-wrapper');
    }, 0);

    _RFC2.default.send('ConnectWeb News Open', {
        Tab: 'Threats Landscape'
    });
};

_serviceDependencies.push(ThreatsLandscape);

angular.module('controllers').controller('ThreatsLandscape', _serviceDependencies);

/***/ }),

/***/ "mJvl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fromPairs = __webpack_require__("Tv9X");
var ngcomponent_1 = __webpack_require__("+1bw");
var React = __webpack_require__("ccIB");
var react_dom_1 = __webpack_require__("x9tB");
/**
 * Wraps a React component in Angular. Returns a new Angular component.
 *
 * Usage:
 *
 *   ```ts
 *   type Props = { foo: number }
 *   class ReactComponent extends React.Component<Props, S> {}
 *   const AngularComponent = react2angular(ReactComponent, ['foo'])
 *   ```
 */
function react2angular(Class, bindingNames, injectNames) {
    if (bindingNames === void 0) { bindingNames = null; }
    if (injectNames === void 0) { injectNames = []; }
    var names = bindingNames
        || (Class.propTypes && Object.keys(Class.propTypes))
        || [];
    return {
        bindings: fromPairs(names.map(function (_) { return [_, '<']; })),
        controller: ['$element'].concat(injectNames, [/** @class */ (function (_super) {
                __extends(class_1, _super);
                function class_1($element) {
                    var injectedProps = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        injectedProps[_i - 1] = arguments[_i];
                    }
                    var _this = _super.call(this) || this;
                    _this.$element = $element;
                    _this.isDestroyed = false;
                    _this.injectedProps = {};
                    injectNames.forEach(function (name, i) {
                        _this.injectedProps[name] = injectedProps[i];
                    });
                    return _this;
                }
                Object.defineProperty(class_1, "$$ngIsClass", {
                    get: function () {
                        return true;
                    },
                    enumerable: true,
                    configurable: true
                });
                class_1.prototype.render = function () {
                    if (!this.isDestroyed) {
                        react_dom_1.render(React.createElement(Class, __assign({}, this.props, this.injectedProps)), this.$element[0]);
                    }
                };
                class_1.prototype.componentWillUnmount = function () {
                    this.isDestroyed = true;
                    react_dom_1.unmountComponentAtNode(this.$element[0]);
                };
                return class_1;
            }(ngcomponent_1.default))])
    };
}
exports.react2angular = react2angular;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "mL1V":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "mTRq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state'];

var DwmUpsell = function DwmUpsell($scope, $state) {
    _classCallCheck(this, DwmUpsell);

    $scope.buy = function (appId) {

        appId = 'adwp1';
        // const mixpanelData = {
        //     'Product ID': appId,
        //     Page: 'AIA Store Page',
        //     Runtimes: 12,
        // };

        // Mixpanel.send('ConnectWeb Store Buy Click', mixpanelData);

        var subsource = 'store';

        $state.go('root.dashboard.dwm.ltb.buy', {
            ltb: 'payment-cart',
            resourceId: appId,
            subsource: subsource
        }, {
            reload: false
        });
    };
};

_serviceDependencies.push(DwmUpsell);

angular.module('controllers').controller('DwmUpsell', _serviceDependencies);

/***/ }),

/***/ "mVn8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope'];

var LatestNewsController = function LatestNewsController($scope) {
    _classCallCheck(this, LatestNewsController);

    $scope.brandName = CWCONFIG.partnerConfig.name;
    $scope.sendSupportMixpanel = function (buttonLabel) {

        _RFC2.default.send('ConnectWeb Home Click', {
            Label: 'Support',
            'Button label': buttonLabel
        });
    };
};

var SupportDirective = function SupportDirective() {
    _classCallCheck(this, SupportDirective);

    this.template = __webpack_require__("7RjL");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope) {
        return new LatestNewsController($scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'latestNewsCtrl';
};

_directiveDependencies.push(function () {
    return new SupportDirective();
});

angular.module('directives').directive('support', _directiveDependencies);

/***/ }),

/***/ "mX7V":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("g5RI"),
    nativeKeys = __webpack_require__("nsWR");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "mbrn":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-credit-cards\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.credit_cards.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"creditCard in creditDebitCards.entries\">\n                            <div class=\"col-3 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.credit_cards.credit_card\" translate-values=\"{index : $index + 1}\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <p class=\"text-grey-1 break-word text-l\" ng-if=\"!creditCard.showUpdateInput\">{{creditCard.cardNumber}}</p>\n                                <div ng-if=\"creditCard.showUpdateInput\">\n                                    <input type=\"text\" ng-class=\"{'error': !creditCardNumberIsValid}\" name=\"cardNumber\"\n                                        autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.credit_cards.credit_card_number' | translate }}\" class=\"update-credit-card-number\"\n                                        ng-keyup=\"updateCreditCardNumber($event);\">\n                                    <p class=\"error-message\" ng-show=\"!creditCardNumberIsValid\"\n                                        translate=\"cw.dwm.entity.credit_cards.invalid_card_number\"></p>\n                                </div>\n                            </div>\n                            <div class=\"col-3 col-text text-right\" ng-if=\"!creditCard.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-3 col-text text-left\">\n                                <p class=\"text-grey-3 text-l\"\n                                translate=\"cw.dwm.entity.credit_cards.credit_card\" translate-values=\"{index: creditDebitCards.entries.length + 1}\"></p>\n                            </div>\n                            <div class=\"col-2 col-text text-left\">\n                                <input type=\"text\" ng-class=\"{'error': !creditCardNumberIsValid}\" name=\"cardNumber\" ng-model=\"newCreditCardNumber\"\n                                    autocomplete=\"off\" placeholder=\"{{ 'cw.dwm.entity.credit_cards.credit_card_number' | translate }}\" class=\"update-credit-card-number\" id=\"creditCardNumber\"\n                                    ng-keyup=\"validateCreditCardNumber($event)\">\n                                <p class=\"error-message\" ng-show=\"!creditCardNumberIsValid\"\n                                    translate=\"cw.dwm.entity.credit_cards.invalid_card_number\"></p>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.credit_cards.remove_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\"translate=\"cw.dwm.entity.credit_cards.remove_desc_1\">\n                        </p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\">\n                        </p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.credit_cards.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.credit_cards.entity_details.desc_1\">\n                    </p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\"\n                ng-if=\"showAddNewButton && (creditDebitCards.maxCount > creditDebitCards.entries.length)\" ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewCreditCardIsLoading}\"\n                    ng-disabled=\"saveNewCreditCardIsLoading || !creditCardNumberIsValid\" ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveUpdatedEntryIsLoading}\"\n                    ng-disabled=\"saveUpdatedEntryIsLoading || !creditCardNumberIsValid\" ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/credit-cards/credit-cards.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "mec4":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"notifications\">\n        <div class=\"notifications-title text-l text-grey-2 mb40\" translate=\"cw.notifications.title\"></div>\n        <form name=\"notificationsForm\" role=\"form\" novalidate ng-submit=\"NotificationsCtrl.changeNotifications()\">\n\n            <div class=\"text-l text-grey-2 mb10 mt20\" translate=\"cw.notifications.product_communications\"></div>\n\n            <div class=\"input-checkbox mb5 ml30\" connectqa-mya=\"news-and-features\">\n                <input id=\"product_information\" type=\"checkbox\" ng-model=\"notifications.product_information\">\n                <label for=\"product_information\" class=\"text-m text-grey-3\" translate=\"cw.notifications.product.title\" translate-values=\"{brandname : brandName}\"></label>\n            </div>\n\n            <div class=\"input-checkbox mb5 ml30\" ng-if=\"notifications.renewal_reminders !== undefined\" connectqa-mya=\"renewal-reminders\">\n                <input id=\"renewal_reminders\" type=\"checkbox\" ng-model=\"notifications.renewal_reminders\">\n                <label for=\"renewal_reminders\" class=\"text-m text-grey-3\" translate=\"cw.notifications.renewal.title\"></label>\n            </div>\n\n            <div class=\"text-l text-grey-2 mb10 mt20\" translate=\"cw.notifications.promotional_communications\"></div>\n\n            <div class=\"input-checkbox mb5 ml30\" connectqa-mya=\"great-deals\">\n                <input id=\"exclusive_offers\" type=\"checkbox\" ng-model=\"notifications.exclusive_offers\">\n                <label for=\"exclusive_offers\" class=\"text-m text-grey-3\" translate=\"cw.notifications.exclusive.title\" translate-values=\"{brandname : brandName}\"></label>\n            </div>\n\n            <div class=\"input-checkbox mb5 ml30\" connectqa-mya=\"exclusive-offers\">\n                <input id=\"offers_partners\" type=\"checkbox\" ng-model=\"notifications.offers_partners\">\n                <label for=\"offers_partners\" class=\"text-m text-grey-3\" translate=\"cw.notifications.partners.title\" translate-values=\"{brandname : brandName}\"></label>\n            </div>\n\n            <div class=\"text-l text-grey-2 mb10 mt20\" translate=\"cw.notifications.other\"></div>\n\n            <div class=\"input-checkbox mb5 ml30\" connectqa-mya=\"avira-surveys\" ng-if=\"notifications.surveys !== undefined\" >\n                <input id=\"avira_surveys\" type=\"checkbox\" ng-model=\"notifications.surveys\">\n                <label for=\"avira_surveys\" class=\"text-m text-grey-3\" translate=\"cw.notifications.surveys.title_2\" translate-values=\"{brandname : brandName}\"></label>\n            </div>\n\n            <div class=\"input-checkbox mb5 ml30\" connectqa-mya=\"avira-newsletter\">\n                <input id=\"avira_newsletter\" type=\"checkbox\" ng-model=\"notifications.avira_newsletter\">\n                <label for=\"avira_newsletter\" class=\"text-m text-grey-3\" translate=\"cw.notifications.newsletter.title\" translate-values=\"{brandname : brandName}\"></label>\n            </div>\n\n            <button class=\"btn btn-large btn-primary mt30\"\n                    ng-disabled=\"loading\"\n                    translate=\"cw.notifications.save\" connectqa-mya=\"save-notification-changes\">\n            </button>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "mjKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["c"] = snipLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* unused harmony export escapeStringForRegex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__("+d4d");

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        // eslint-disable-next-line no-param-reassign
        colno = ll;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(value)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map

/***/ }),

/***/ "mkCZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("BrLi");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("CExF");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("fIlE");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _actions = [];
var _serviceDependencies = [];

/**
     * @ngdoc service
     * @name repositories.ActionsRepository
     *
     * @description
     * This class is used to save/add devices objects.
     */

var ActionsRepository = function () {
    function ActionsRepository() {
        _classCallCheck(this, ActionsRepository);

        _actions = [];

        this.observableActions = new Rx.BehaviorSubject(_actions);
    }

    /**
         * @ngdoc function
         * @name repositories.ActionsRepository#replace
         * @methodOf repositories.ActionsRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored actions with provided data.
         *
         * @param {Array} data An array with new actions.
         */


    _createClass(ActionsRepository, [{
        key: 'replace',
        value: function replace(data) {

            _actions = data || [];
            this.observableActions.onNext(_actions);
        }

        /**
             * @ngdoc function
             * @name repositories.ActionsRepository#getAll
             * @methodOf repositories.ActionsRepository
             * @function
             *
             * @description
             * This function can be used to retrieves all actions from repository.
             *
             * @returns {Array} actions all actions from repository
             */

    }, {
        key: 'getAll',
        value: function getAll() {

            return _actions;
        }

        /**
             * @ngdoc function
             * @name repositories.ActionsRepository#getById
             * @methodOf repositories.ActionsRepository
             * @function
             *
             * @description
             * This function can be used to retrieves a device based on specified id.
             *
             * @param {integer} deviceId id of device
             *
             * @returns {object} a device based on specified id
             */

    }, {
        key: 'getById',
        value: function getById(deviceId) {

            return _actions.find(function (device) {
                return String(device.relationships.device.data.id) === String(deviceId);
            });
        }

        /**
             * @ngdoc function
             * @name repositories.ActionsRepository#update
             * @methodOf repositories.ActionsRepository
             * @function
             *
             * @description
             * This function can be used to update an action from repository
             *
             * @param {object} an action object with new values
             */

    }, {
        key: 'update',
        value: function update(action) {

            if (String(action.id)) {

                var indexOfAction = _actions.findIndex(function (_action) {
                    return String(_action.id) === String(action.id);
                });

                if (indexOfAction >= 0) {

                    var flattenDiff = _RFC2.default.getFlattenDiff(_actions[indexOfAction], action);

                    _RFC4.default.processUpdate(flattenDiff, _actions[indexOfAction], action);

                    if (!angular.equals(flattenDiff, {})) {

                        _actions[indexOfAction] = action;

                        this.observableActions.onNext(_actions);
                    }
                } else if (_RFC6.default.deepFind(action, 'attributes.action_type') === 'logout') {

                    _RFC4.default.processUpdate(null, _actions[indexOfAction], action);
                }
            }
        }

        /**
             * @ngdoc function
             * @name repositories.ActionsRepository#add
             * @methodOf repositories.ActionsRepository
             * @function
             *
             * @description
             * This function can be used to add a new action to repository.
             *
             * @param {object} action An action object.
             */

    }, {
        key: 'add',
        value: function add(action) {

            var indexOfActions = _actions.findIndex(function (_action) {
                return String(_action.id) === String(action.id);
            });

            if (indexOfActions === -1) {

                _actions.push(action);

                this.observableActions.onNext(_actions);
            }
        }

        /**
             * @ngdoc function
             * @name repositories.ActionsRepository#getObservable
             * @methodOf repositories.ActionsRepository
             * @function
             *
             * @description
             * This function can be used to get an observable object for actios repository.
             * @returns {Object} an observable object for actions repository.
             */

    }, {
        key: 'getObservable',
        value: function getObservable() {

            return this.observableActions;
        }
    }]);

    return ActionsRepository;
}();

_serviceDependencies.push(ActionsRepository);

angular.module('services').service('ActionsRepository', _serviceDependencies);

/***/ }),

/***/ "mko8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

/* eslint func-names: 0 */

/**
 * Store timeouts and intervals in Timers service
 * Provide a method to easily clear all timeouts (at logout)
 */

var Timers = {
    intervals: [],
    timeouts: [],
    /**
     * On logout, clear all timers started during the session to avoid unexpected events
     * after the user logs out
     */
    clear: function clear() {

        _.each(this.intervals, function (item) {

            clearInterval(item);
        });
        _.each(this.timeouts, function (item) {

            clearTimeout(item);
        });

        Timers.intervals = [];
        Timers.timeouts = [];
    }
};

exports.default = Timers;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "mvQj":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("Vf/c");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "n8UT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("8Wj0");

__webpack_require__("2tFT");

/***/ }),

/***/ "nFaA":
/***/ (function(module, exports) {

module.exports = "<div>\n\t<div class=\"mya-section-info\">\n\t\t<div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.data_settings.user_data_title\"></div>\n\t\t<div class=\"text-m mt5 text-grey-3\" translate=\"cw.my_account.data_settings.user_data_desc\" translate-values=\"{brandname : brandName}\"></div>\n\t</div>\n\n\t<div class=\"mya-section-forms max-width-l gdpr-report-section\">\n\t\t<button\n\t\t\tclass=\"btn btn-large btn-primary mb10 mt5 spin-loader\"\n\t\t\tng-click=\"userDataCtrl.getReport()\"\n\t\t\tng-disabled=\"loading\"\n\t\t\ttranslate=\"cw.general.get_report\">\n\t\t</button>\n\n\t\t<button\n\t\t\tclass=\"btn btn-large btn-secondary mb10 mt5 spin-loader ml20\"\n\t\t\tng-click=\"userDataCtrl.showReport()\"\n\t\t\tng-if=\"hasReport && userDataCtrl.showGdprButton\"\n\t\t\ttranslate=\"cw.my_account.data_settings.view_report\"\n\t\t\tng-disabled=\"loading\">\n\t\t</button>\n\n\t\t<h2\n\t\t\tng-if=\"dataReportPending\"\n\t\t\tclass=\"text-s text-grey-3 mb5\"\n\t\t\ttranslate=\"cw.my_account.data_settings.user_data_requested\"\n\t\t\ttranslate-values=\"{status: '{{dataReportDate}}'}\">\n\t\t</h2>\n    </div>\n</div>"

/***/ }),

/***/ "nGYS":
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"{\n    'reactivate-license': showReactivateLogin\n}\">\n    <div class=\"text-center mt15 plr20 reactivate-license-header\" ng-if=\"showReactivateLogin\">\n        <h1 class=\"mb5\" translate=\"cw.auth.reactivate_license.title\"></h1>\n        <p class=\"text-grey-3 text-xl\" translate=\"cw.auth.reactivate_license.description\"></p>\n    </div>\n\n    <div class=\"main-auth\"  ng-class=\"{'two-columns-auth' : showCustomAuth }\">\n\n        <div class=\"auth-region auth-form-tabs\">\n\n            <!-- SSO SKIP -->\n            <div ng-if=\"showSkipButton || showCloseButton\" class=\"auth-sso-header\">\n                <div class=\"sso-move\" ng-if=\"showCloseButton\" onmousedown=\"window.external.Execute('aoe://Move')\"></div>\n                <div ng-if=\"showSkipButton\" class=\"sso-skip\" ng-click=\"oauthCtrl.skip()\">\n                    <i class=\"icon icon-back icon-grey-4 icon-xxs fl-left\"></i>\n                    <a class=\"text-m text-grey-4 fl-left ml10\" translate=\"cw.general.ui.back\"></a>\n                </div>\n                <div class=\"sso-logo centerMiddle\"></div>\n                <div ng-if=\"showCloseButton\" class=\"sso-close\">\n                    <a class=\"text-m text-grey-4 fl-right\" href=\"aoe://close\">\n                        <i class=\"icon icon-close3 icon-grey-4 icon-xxs fl-right ml10\"></i>\n                        <span class=\"text-m text-grey-4 fl-right\" translate=\"cw.general.ui.close\"></span>\n                    </a>\n                </div>\n            </div>\n            <!-- end -->\n\n            <div class=\"right fixed\">\n\n                <div class=\"left-background\"></div>\n                <div class=\"right-background\"></div>\n                <a ng-if=\"!showSkipButton && !showCloseButton\" ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n                    <i class=\"sprite sprite-logo\"></i>\n                    <h1>{{State.partner.name}}</h1>\n                </a>\n                <ul ng-show=\"!showSimplifiedLogin\" class=\"auth-tabs\">\n                    <li class=\"fl-left\" ng-if=\"!$root.isComingFromEmbargoedCountry\" ui-sref=\"root.auth.register\" connectqa-auth-tab=\"register\">\n                        <span translate=\"cw.auth.login.create_account\"></span>\n                    </li>\n                    <li class=\"fl-left disabled info-tooltip-holder\" ng-if=\"$root.isComingFromEmbargoedCountry\" connectqa-auth-tab=\"register\">\n                        <span translate=\"cw.auth.login.create_account\"></span>\n                        <div class=\"info-tooltip arrow-bottom\" translate=\"cw.homepage.blocked_country\"></div>\n                    </li>\n                    <li class=\"fl-right active\" connectqa-auth-tab=\"login\">\n                        <span translate=\"cw.auth.login_label\"></span>\n                    </li>\n                </ul>\n                <div class=\"form-wrapper auth-nopadding-left-right\" ng-class=\"{'border-fix': showSimplifiedLogin}\">\n\n                    <div ng-show=\"showSimplifiedLogin\">\n                        <div class=\"picture-holder mb10\" ng-class=\"{'no-pic': !lastLogin.profilePic}\">\n                            <div class=\"no-picture-holder\" ng-if=\"!lastLogin.profilePic\">\n                                <span class=\"text-white inline-block text-xxl\">\n                                    {{lastLogin.firstName.toUpperCase() | limitTo: 1}}\n                                    {{lastLogin.lastName.toUpperCase() | limitTo: 1}}\n                                </span>\n                            </div>\n                            <img ng-if=\"lastLogin.profilePic\"\n                                    ng-src=\"{{lastLogin.profilePic}}\" />\n                        </div>\n\n                        <h2 class=\"text-xl mb10\" translate=\"cw.general.hello\" translate-values=\"{name: lastLogin.firstName}\"></h3>\n                        <p class=\"text-m mb20\" translate=\"cw.auth.login_simplified.description\"></p>\n                    </div>\n\n                    <div class=\"auth-padding60-left-right\">\n\n                        <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                            <change-language ng-if=\"showChangeLang\"></change-language>\n                        </h3>\n\n                        <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': oauthCtrl.Auth.error}\">\n\n                            <!-- invalid credentials error message -->\n                            <h5 class=\"text-m text-red-2\" id=\"error-message-form\" ng-if=\"oauthCtrl.Auth.error && submitted\" translate=\"cw.auth.login.error.email_password\" connectqa-login=\"form-general-error\"></h5>\n                            <!-- reset password message -->\n                            <a ui-sref=\"root.auth.forgot\" class=\"text-m text-blue-2\" ng-click=\"oauthCtrl.setEmail()\" ng-if=\"oauthCtrl.Auth.error && submitted && oauthCtrl.Auth.failedLogins === 2 && !oauthCtrl.Auth.captchaRequired\" translate=\"cw.auth.login.error.recover\" connectqa-login=\"reset-password-error-message\"></a>\n\n                        </div>\n\n                        <!-- <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': oauthCtrl.Auth.captchaRequired}\">\n                            <h5 class=\"text-m text-red-2\" id=\"error-message-captcha\" ng-show=\"submitted && oauthCtrl.Auth.captchaRequired\" translate=\"cw.notification.auth.signup.require_captcha\"></h5>\n                        </div> -->\n\n                        <div ng-if=\"showSocialLogin\">\n                            <div class=\"mb20\">\n                                <a ng-if=\"(fb.feature && !showSimplifiedLogin)\n                                    || (showSimplifiedLogin && lastLogin.loginType === 'fb_auth')\"\n                                ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'facebook'}\"\n                                ng-click=\"fb.authenticate('Login')\"\n                                class=\"button-scm fb-nd text-m\"\n                                connectqa-login=\"login-with-facebook\"><i></i><em>Facebook</em></a>\n\n                                <a ng-if=\"(gplus.feature && !showSimplifiedLogin)\n                                    || (showSimplifiedLogin && lastLogin.loginType === 'gg_auth')\"\n                                ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'google'}\"\n                                ng-click=\"gplus.authenticate('Login')\"\n                                class=\"button-scm gp-nd text-m\"\n                                connectqa-login=\"login-with-google\"><i></i><em>Google</em></a>\n\n                                <span class=\"inline-block p-relative w100 info-tooltip-holder\"\n                                    ng-show=\"(appleID.feature && browserName !== 'ie' && !showSimplifiedLogin)\n                                    || (showSimplifiedLogin && lastLogin.loginType === 'apl_auth')\">\n                                    <a\n                                    ng-class=\"{disabled: oauthCtrl.Auth.socialLogin.loginAttempt, ' spin-loader': oauthCtrl.Auth.socialLogin.socialLoginButton === 'apple'}\"\n                                    ng-click=\"appleID.authenticate('Login')\"\n                                    class=\"button-scm apple-nd text-m\"\n                                    connectqa-login=\"login-with-appleID\"><i></i><em>Apple ID</em></a>\n                                    <span class=\"info-tooltip-holder auth-btn-tooltip-holder\">\n                                        <span class=\"icon icon-info icon-grey-5 icon-xs\"></span>\n                                        <div class=\"info-tooltip arrow-bottom ng-scope text-s\" translate=\"cw.auth.apple_regitration_info\" translate-values=\"{brandname : brandName}\"></div>\n                                    </span>\n                                </span>\n\n                            </div>\n\n                            <div ng-if=\"(fb.feature || gplus.feature || (appleID.feature && browserName !== 'ie')) && !showSimplifiedLogin\"\n                                class=\"mb5 text-m text-grey-4 text-medium uppercase\" translate=\"cw.form.or\"></div>\n                        </div>\n\n                        <div ng-if=\"showEmbeddedSocialLogin\">\n                            <a\n                                ng-click=\"oauthCtrl.socialLoginRedirect()\"\n                                class=\"btn btn-large btn-full-width spotlight-btn-secondary spotlight-social-login text-m\"\n                                connectqa-login=\"login-with-social\">\n                                <i class=\"fb\" ng-if=\"fb.feature\"></i>\n                                <i class=\"gp\" ng-if=\"gplus.feature\"></i>\n                                <i class=\"apl\" ng-show=\"appleID.feature\"></i>\n                                <em translate=\"cw.auth.login.continue_with\"></em>\n                            </a>\n\n                            <div class=\"mt10 mb5 text-m text-grey-4 text-medium uppercase\" translate=\"cw.form.or\"></div>\n                        </div>\n\n                        <form ng-show= \"!showSimplifiedLogin || (showSimplifiedLogin && lastLogin.loginType === 'password')\" class=\"auth-form\" name=\"loginForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.onSubmit()\">\n                            <div class=\"form-group\">\n                                <input type=\"email\"\n                                    ng-model=\"email\"\n                                    spellcheck=\"false\"\n                                    autocorrect=\"off\"\n                                    autocomplete=\"on\"\n                                    autocapitalize=\"off\"\n                                    name=\"email\"\n                                    maxlength=\"100\"\n                                    ng-class=\"{'error': loginForm.email.$invalid && submitted}\"\n                                    id=\"email\"\n                                    placeholder=\"{{ 'cw.form.email' | translate }}\"\n                                    ng-pattern=\"emailRegExp\"\n                                    required connectqa-login=\"email-address\"/>\n\n                                <label ng-hide=\"loginForm.email.$viewValue.length > 0\" class=\"fallback-input\" for=\"email\" translate=\"cw.form.email\"></label>\n                                <p class=\"error-message\" ng-show=\"loginForm.email.$invalid && submitted\" translate=\"cw.validator.messages.email\" connectqa-login=\"email-field-error\"></p>\n                            </div>\n\n                            <div class=\"form-group\">\n                                <input type=\"password\"\n                                    ng-model=\"password\"\n                                    name=\"password\"\n                                    ng-class=\"{'error': loginForm.password.$invalid && submitted}\"\n                                    maxlength=\"100\"\n                                    autocomplete=\"off\"\n                                    placeholder=\"{{ 'cw.form.password' | translate }}\"\n                                    ng-minlength=\"5\"\n                                    id=\"password\"\n                                    required connectqa-login=\"password\"/>\n\n                                <label ng-hide=\"loginForm.password.$viewValue.length > 0\" translate=\"cw.form.password\" for=\"password\" class=\"fallback-input\"></label>\n                                <p class=\"error-message\" ng-show=\"loginForm.password.$invalid && submitted\" translate=\"cw.input.current_password.error.no_characters\" connectqa-login=\"password-too-short\"></p>\n                                <p class=\"error-message\" ng-show=\"loginForm.password.$viewValue.length === 100\" translate=\"cw.validator.messages.password.maximum_length\" connectqa-login=\"password-too-long\"></p>\n                            </div>\n\n                            <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\"\n                                    translate=\"cw.auth.login_label\"\n                                    ng-disabled=\"oauthCtrl.Auth.loading\" connectqa-login=\"login-button\">\n                            </button>\n\n                            <div class=\"auth-actions mb5\">\n                                <a class=\"text-m text-grey-4 fl-right\" ui-sref=\"root.auth.forgot\" translate=\"cw.form.forgot_password\" connectqa-login=\"forgot-password-link\"></a>\n                            </div>\n                        </form>\n\n                        <div ng-show=\"showSimplifiedLogin\" class=\"mb30\">\n                            <div class=\"mb10 text-m text-grey-4 text-medium uppercase\" translate=\"cw.form.or\"></div>\n\n\n                            <button ng-click=\"oauthCtrl.switchLoginView()\"\n                                class=\"btn btn-large btn-secondary btn-full-width text-l other-options-btn\"\n                                translate=\"cw.auth.login_simplified.other_button\"\n                                ng-disabled=\"oauthCtrl.Auth.loading\"></button>\n                        </div>\n\n                    </div>\n\n                    <div class=\"section-social-media v2\">\n                        <div class=\"text-center text-grey-4 eula text-xs auth-eula\" translate=\"cw.auth.eula_v2\" translate-values= \"{hrefenduser : hrefEndUser, hreflegalterms : hrefLegalTerms}\"></div>\n                        <div class=\"text-center text-grey-4 eula text-xs\">\n                            <span translate=\"cw.auth.privacy_policy\" translate-values= \"{hrefGeneralPrivacy : hrefGeneralPrivacy}\"></span>\n                            <span class=\"separator\"></span>\n                            <span translate=\"cw.auth.imprint\" translate-values= \"{hrefGeneralImprint : hrefGeneralImprint}\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"left content-section login-left\">\n            <div class=\"column-container\">\n                <div class=\"text-center\">\n                    <a ng-if=\"!showSkipButton && !showCloseButton\" ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n                        <i class=\"sprite sprite-logo\"></i>\n                        <h1>{{State.partner.name}}</h1>\n                    </a>\n                </div>\n                <h2 class=\"text-xl mt30 mb50 text-center text-white\"\n                    translate=\"cw.auth.two_columns.auth.title\"></h2>\n                <div class=\"slider text-center\">\n                    <div class=\"inline-block\">\n                        <div class=\"animation\">\n                            <i class=\"icon for-desktop icon-digital-health icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-1\"}'></i>\n                            <i class=\"icon for-desktop icon-indentify icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-3\"}'></i>\n                            <i class=\"icon for-desktop icon-pc-phone icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-2\"}'></i>\n\n                            <i class=\"icon for-mobile icon-digital-health icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-1\"}'></i>\n                            <i class=\"icon for-mobile icon-indentify icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-3\"}'></i>\n                            <i class=\"icon for-mobile icon-pc-phone icon-white\"\n                                ng-class='{\"active\" : activeSlide === \"slide-2\"}'></i>\n                        </div>\n                        <div class=\"dots text-center mt20\">\n                            <div class=\"dot inline-block v-middle\"\n                                ng-class='{\"active\" : activeSlide === \"slide-1\"}'\n                                ng-click='oauthCtrl.switchSlide(\"slide-1\");oauthCtrl.stopAutoPlay();'\n                            ></div>\n                            <div class=\"dot inline-block ml5 v-middle\"\n                                ng-class='{\"active\" : activeSlide === \"slide-2\"}'\n                                ng-click='oauthCtrl.switchSlide(\"slide-2\");oauthCtrl.stopAutoPlay();'></div>\n                            <div class=\"dot inline-block ml5 v-middle\"\n                                ng-class='{\"active\" : activeSlide === \"slide-3\"}'\n                                ng-click='oauthCtrl.switchSlide(\"slide-3\");oauthCtrl.stopAutoPlay();'\n                            ></div>\n                        </div>\n                    </div>\n                    <div class='inline-block w100 v-top text-center mt30 text-slides-wrapper'>\n                        <div class=\"slide\" ng-class='{\"active\" : activeSlide === \"slide-1\"}'>\n                            <h3 class=\"text-l text-white font-regular\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_1.title\"></h3>\n                            <p class=\"text-m text-white mt5\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_1.description\"\n                                translate-values=\"{ brandname : brandName }\">\n                            </p>\n                        </div>\n                        <div class=\"slide\" ng-class='{\"active\" : activeSlide === \"slide-2\"}'>\n                            <h3 class=\"text-l text-white font-regular\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_2.title\"></h3>\n                            <p class=\"text-m text-white mt5\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_2.description\">\n                            </p>\n                        </div>\n\n                        <div class=\"slide\" ng-class='{\"active\" : activeSlide === \"slide-3\"}'>\n                            <h3 class=\"text-l text-white font-regular\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_3.title\"></h3>\n                            <p class=\"text-m text-white mt5\"\n                                translate=\"cw.auth.two_columns.login.slider.slide_3.description\">\n                            </p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"text-center mt30\">\n                    <!-- <h2 class=\"text-l mb5 font-regular text-white\"\n                        translate=\"cw.auth.two_columns.awards_title\"></h2> -->\n                    <p class=\"text-m text-grey-4 text-white\"\n                        translate=\"cw.auth.two_columns.awards_description\"></p>\n                    <!-- <div class=\"row\">\n                        <div class=\"years-graphic mr50 text-left\">\n                            <div class=\"bullets mt30 mb15\">\n                                <div class=\"bullet\"></div>\n                                <div class=\"bullet fl-right active\"></div>\n                            </div>\n                            <div class=\"labels\">\n                                <div class=\"inline-block text-l text-grey-2\">2004</div>\n                                <div class=\"text-l text-grey-2 fl-right active\">2019</div>\n                            </div>\n                        </div>\n\n                    </div> -->\n                    <div class=\"awards inline-block v-top w60\"></div>\n                    <!-- <div class=\"text-center new-tab-link\" translate=\"cw.auth.two_columns.awards_button\" translate-values=\"{href: hrefAwards}\"></div> -->\n                </div>\n            </div>\n\n            <!-- <div class=\"grey-footer\">\n                <div class=\"column-container\">\n                    <p class=\"text-l text-grey-2 inline-block\"\n                        translate=\"cw.auth.two_columns.footer\"></p>\n                    <i class=\"icon icon-windows icon-grey-4 icon-xs ml5 inline-block v-middle\"></i>\n                    <i class=\"icon icon-osx icon-grey-4 icon-xs ml5 inline-block v-middle\"></i>\n                    <i class=\"icon icon-android icon-grey-4 icon-xs ml5 inline-block v-middle\"></i>\n                    <i class=\"icon icon-ios icon-grey-4 icon-xs ml5 inline-block v-middle\"></i>\n                </div>\n            </div> -->\n        </div>\n\n        </div>\n    </div>\n\n    <div class=\"text-center plr20\" ng-if=\"showReactivateLogin\">\n        <a class=\"inline-block text-xl mt15 text-blue-1 crs-pointer\" ng-click=\"cancelReactivateLicense()\" translate=\"cw.auth.reactivate_license.action\"></a>\n    </div>\n\n</div>"

/***/ }),

/***/ "nHzQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint no-unneeded-ternary: 0 */
var isVisible = function isVisible(product) {
    return product.attributes.custom.manifest.visible === 1;
};

var hasEssentialProps = function hasEssentialProps(hiddenProducts) {
    return function (product) {

        var condition = product.attributes.custom.manifest.name && product.attributes.custom.manifest.os ? true : false;

        if (condition) {

            return true;
        }

        hiddenProducts.push(product);
        return false;
    };
};

var hasUnsupportedBrowsers = function hasUnsupportedBrowsers(Util, $scope) {
    return function (product) {

        var productManifest = product.attributes.custom.manifest;

        // browser not supported, remove extension from app list
        if (Util.deepFind(product, 'attributes.custom.manifest.browsers') && productManifest.browsers.indexOf($scope.browserName) === -1) {

            return false;
        }

        return true;
    };
};

exports.isVisible = isVisible;
exports.hasEssentialProps = hasEssentialProps;
exports.hasUnsupportedBrowsers = hasUnsupportedBrowsers;

/***/ }),

/***/ "nIVx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    angular.module('filters').filter('phoneCountryCode', ['Countries', function (Countries) {

        var dialCode = function () {

            var dc = {};
            angular.forEach(Countries, function (country) {

                dc[country.dialCode.substring(1)] = country.code;
            });

            return dc;
        }();

        return function (phoneNumber) {

            var countryCode = void 0;
            var prefix = void 0;
            var startIdx = 0;
            var n = 5;

            if (phoneNumber.charAt(0) === '+') {

                startIdx = 1;
            } else if (phoneNumber.substring(0, 2) === '00') {

                startIdx = 2;
            }

            while (!countryCode && n > 0) {

                prefix = phoneNumber.substring(startIdx, n);

                if (dialCode[prefix]) {

                    return dialCode[prefix];
                }

                n -= 1;
            }

            return '';
        };
    }]);
})();

/***/ }),

/***/ "nIpj":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email license-m\" connectqa-deploy-modal=\"pc-device\">\n\n    <!-- IF AUTO INSTALL -->\n    <div ng-if=\"pcDeploymentWizardCtrl.autoInstall\" class=\"autoInstall_modal content-wrapper\">\n        <div class=\"mb20\">\n            <i class=\"icon icon-avira-logo\"></i>\n        </div>\n\n        <h3 class=\"text-xxl2 font-bold mb40 text-grey-2 download-title\" translate=\"cw.deploy.auto-install.title\"></h3>\n\n        <div class=\"mb20\">\n            <p class=\"text-grey-3 download-subtitle\" translate=\"cw.deploy.auto-install.desc\"></p>\n        </div>\n        <div class=\"download-progress mb20\">\n            <div class=\"download-step inline-block finished-step-1 \">\n                <i class=\"icon icon-Cloudlarge\"></i>\n                <p class=\"download-step-text\" translate=\"cw.general.ui.download\"></p>\n            </div>\n            <div class=\"download-dot download-dot-step-1 inline-block \"\n                ng-class=\"{'loading-dots':!isStep2Finished}\">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n            <div class=\"download-step inline-block download-step-2\"\n                ng-class=\"{'finished-step-2': isStep2Finished}\">\n                <i class=\"icon icon-Folder\"></i>\n                <p class=\"download-step-text\" translate=\"cw.general.run-program\"></p>\n            </div>\n            <div class=\"download-dot download-dot-step-2 inline-block \"\n                ng-class=\"{'loading-dots':isStep2Finished}\">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n            <div class=\"download-step inline-block\"\n                ng-class=\"{'finished-step-3': isStep3Finished}\">\n                <i class=\"icon icon-Cog\"></i>\n                <p class=\"download-step-text\" translate=\"cw.general.install\"></p>\n            </div>\n        </div>\n        <div>\n            <p class=\"text-m text-grey-3 ng-scope\" translate=\"cw.deploy.auto-install.footer\"></p>\n            <a id=\"deployActionDownload\" class=\"text-m try-again-link\" translate=\"cw.general.try-again-now\"></a>\n        </div>\n\n    </div>\n\n    <!-- IF CLASSIC INSTALL -->\n    <div ng-if=\"!pcDeploymentWizardCtrl.autoInstall\" class=\"download-v2\">\n        <div class=\"content-wrapper mobile-margin-bottom\">\n            <div class=\"text-left\">\n                <div class=\"app-icon inline-block\"\n                    ng-show=\"!app.attributes.resource.cwStoreBoxshot\"\n                    ng-class=\"{'v-middle': !app.attributes.resource.shortDescription && !app.attributes.resource.cmsShortdescription}\">\n                        <img\n                            ng-if=\"app.attributes.resource.wsLargeImageUrl\"\n                            ng-src=\"{{app.attributes.resource.wsLargeImageUrl | imageUrlParse}}\" />\n\n                        <img\n                            ng-if=\"app.attributes.type === 'bundle' && !app.attributes.resource.wsLargeImageUrl\"\n                            src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n\n                        <img\n                            ng-if=\"app.attributes.type !== 'bundle' && !app.attributes.resource.wsLargeImageUrl\"\n                            src=\"https://dmxl1l6antpot.cloudfront.net/extras/templates/emails/images/desc2-av-logo.jpg\" />\n                </div>\n                <div class=\"box-shot-holder inline-block\"\n                    ng-show=\"app.attributes.resource.cwStoreBoxshot\"\n                    ng-class=\"{'v-middle': !app.attributes.resource.shortDescription && !app.attributes.resource.cmsShortdescription}\">\n                        <img ng-src=\"{{app.attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                </div>\n\n                <div class=\"inline-block v-top ml20 product-description w90\"\n                    ng-class=\"{'v-middle': !app.attributes.resource.shortDescription && !app.attributes.resource.cmsShortdescription}\"\n                    connectqa-deploy-modal=\"license-description\">\n                    <h3 class=\"text-xl mb5\">{{app.attributes.resource.oeName}}</h3>\n                    <p ng-if=\"app.attributes.resource.shortDescription\" class=\"text-grey-3 text-s\">\n                        {{app.attributes.resource.shortDescription}}\n                    </p>\n                    <p ng-if=\"!app.attributes.resource.shortDescription && app.attributes.resource.cmsShortdescription\" class=\"text-grey-3 text-s\">\n                        {{app.attributes.resource.cmsShortdescription}}\n                    </p>\n                </div>\n            </div>\n        </div>\n\n        <!--TABS-->\n        <div class=\"content-wrapper mobile-margin-bottom deploy-options\">\n            <div class=\"mb10\">\n                <p class=\"text-m text-grey-2\"\n                    translate=\"cw.deploy.download_ready\"\n                    translate-values=\"{product: app.attributes.resource.oeName}\">\n                </p>\n                <button class=\"btn btn-medium btn-primary\"\n                    ng-click=\"pcDeploymentWizardCtrl.deployViaDownload();\"\n                    translate=\"cw.general.ui.download_product\" connectqa-deploy-modal=\"download-button\"></button>\n            </div>\n            <div>\n                <p class=\"text-m text-grey-2\"\n                    translate=\"cw.deploy.download.send_email_v2\"\n                    translate-values=\"{email: inputData.emails[0]}\">\n                </p>\n                <button class=\"btn btn-medium btn-secondary\"\n                        ng-click=\"pcDeploymentWizardCtrl.deployViaEmail();\"\n                        ng-disabled=\"pcDeploymentWizardCtrl.deployChoose.waitingResponse\"\n                        translate=\"cw.deploy.product.send_email\" connectqa-deploy-modal=\"send-via-email-button\"></button>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "nNKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimestampInSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timestampInSeconds; });
/* unused harmony export timestampWithMs */
/* unused harmony export usingPerformanceAPI */
/* unused harmony export _browserPerformanceTimeOriginMode */
/* unused harmony export browserPerformanceTimeOrigin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("0VhR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node__ = __webpack_require__("w0ZA");


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobalObject */])().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = Object(__WEBPACK_IMPORTED_MODULE_1__node__["a" /* dynamicRequire */])(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = Object(__WEBPACK_IMPORTED_MODULE_1__node__["b" /* isNodeEnv */])() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobalObject */])().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("i9Rx")(module)))

/***/ }),

/***/ "nPrn":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "nRO4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var offersConfiguration = [
// 20% discount with voucher codew
// {
//     product: 'Prime',
//     productId: 'aps10',
//     learnMoreUrl: 'https://www.avira.com/{language}/avira-prime?x-a-source=cw',
//     eshopUrl: 'https://e-shop.avira.com/checkout?product=1955&language={language}&x-subscription-type=annual&runtime=12&users=1&x-a-source=cw',
//     discount: '<span>20%</span>',
//     voucher: 'Prime19-BF',
//     bundleIds: ['aps10', 'aps20'],
//     translationKeys: {
//         discountDesc: 'cw.prime_offer.discount_desc',
//         learnMore: 'cw.prime_offer.btn_learn_more',
//         button: 'cw.prime_offer.btn_get_prime',
//     },
// },
// {
//     product: 'Internet Security Suite',
//     productId: 'isec0',
//     learnMoreUrl: 'https://www.avira.com/{language}/avira-internet-security-suite?x-a-source=cw',
//     eshopUrl: 'https://e-shop.avira.com/checkout?product=1905&language={language}&x-subscription-type=annual&runtime=12&users=1&x-a-source=cw',
//     discount: '<span>20%</span>',
//     voucher: 'Isec19-BF',
//     bundleIds: ['aps10', 'aps20', 'isec0'],
//     translationKeys: {
//         discountDesc: 'cw.isec_offer.discount_desc',
//         learnMore: 'cw.isec_offer.btn_learn_more',
//         button: 'cw.isec_offer.btn_get_isec',
//     },
// },

// New Year, 35% discount without voucher code
// {
//     product: 'Prime',
//     productId: 'aps10',
//     learnMoreUrl: 'https://www.avira.com/{language}/prime-new-year-2019?x-a-source=cw',
//     eshopUrl: 'https://e-shop.avira.com/checkout?1&promotion=cw-banner-prm-35-ny&language={language}&product=1&x-a-source=cw&x-a-medium=cw-ny-banner',
//     discount: '<span>35%</span>',
//     bundleIds: ['aps10', 'aps20'],
//     translationKeys: {
//         learnMore: 'cw.prime_offer.btn_learn_more',
//         button: 'cw.prime_offer.btn_get_prime',
//     },
// },

// 20% discount without voucher code Last one live
{
    product: 'Avira Prime',
    productId: 'aps10',
    learnMoreUrl: 'https://www.avira.com/{language}/prime?x-a-source=cw',
    bundleIds: ['aps10', 'aps20'],
    translationKeys: {
        discountDesc: 'cw.banner.generic_desc_1',
        learnMore: 'cw.prime_offer.btn_learn_more',
        button: 'cw.general.upgrade'
    }
}, {
    product: 'Internet Security',
    productId: 'isec0',
    learnMoreUrl: 'https://www.avira.com/{language}/internet-security-suite?x-a-source=cw',
    bundleIds: ['aps10', 'aps20', 'isec0'],
    translationKeys: {
        discountDesc: 'cw.banner.generic_desc_1',
        learnMore: 'cw.isec_offer.btn_learn_more',
        button: 'cw.general.upgrade'
    }
}];

exports.default = offersConfiguration;

/***/ }),

/***/ "nZXu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable max-len */
/* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmMothersName = function DwmMothersName($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmMothersName);

    $scope.mothersMaidenNameIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};

        if (assets.primaryMember) {

            $scope.mothersMaidenName = assets.primaryMember.monitoredAccounts.mothersMaidenName;
            $scope.mothersMaidenName.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('.update-mothers-maiden-name').trigger('focus');
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.mothersMaidenNameIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newMothersMaidenName = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.mothersMaidenName.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                $scope.updateEntryPayload = entry;
                $scope.initialMothersMaidenName = entry.name;
                $scope.initialEntryIndex = loopIndex;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-mothers-maiden-name').trigger('focus');
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.mothersMaidenNameIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.mothersMaidenName.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};

        $scope.mothersMaidenName.entries[$scope.initialEntryIndex].name = $scope.initialMothersMaidenName;
    };

    $scope.validateMothersMaidenName = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.mothersMaidenNameIsValid = $event.currentTarget.value && validations.mothersMaidenNameValidator($event.currentTarget.value.trim());
        }

        $scope.newMothersMaidenName = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.mothersMaidenNameIsValid = $scope.newMothersMaidenName === undefined ? false : validations.mothersMaidenNameValidator($scope.newMothersMaidenName.trim());

        $scope.newEntrySubmitted = true;

        if ($scope.mothersMaidenNameIsValid) {

            $scope.saveNewMothersMaidenNameIsLoading = true;

            var payload = {
                mothersMaidenName: {
                    name: $scope.newMothersMaidenName,
                    type: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newMothersMaidenName = '';
                $scope.saveNewMothersMaidenNameIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;

                    _RFC4.default.setCommonProperty('AIA Asset Mothers Name', monitoredAccounts.mothersMaidenName.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Mothers maiden name'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewMothersMaidenNameIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            mothersMaidenName: {
                id: $scope.mothersMaidenName.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newMothersMaidenName = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Mothers Name', monitoredAccounts.mothersMaidenName.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Mothers maiden name'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.updateMothersMaidenName = function ($event) {

        $scope.mothersMaidenNameIsValid = $event.currentTarget.value && validations.mothersMaidenNameValidator($event.currentTarget.value.trim());

        if ($scope.mothersMaidenNameIsValid) {

            $scope.updateEntryPayload.name = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { mothersMaidenName: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Mothers maiden name'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmMothersName);

angular.module('controllers').controller('DwmMothersName', _serviceDependencies);

/***/ }),

/***/ "nc0B":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "nhjq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _RFC = __webpack_require__("BrLi");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("e4MQ");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _activationCodes = [];
var observableActivationCodes = new Rx.BehaviorSubject(_activationCodes);

var _ref = CWCONFIG || [],
    primeAppIds = _ref.primeAppIds;

/**
     * @ngdoc service
     * @name repositories.ActivationCodesRepository
     *
     * @description
     * This class is used to get activation codes objects.
     */


var ActivationCodesRepository = {

    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#getAll
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to retrieves all activation codes from repository.
         *
         * @returns {Array} activationCodes all activation codes from repository
         */
    getAll: function getAll() {

        return _activationCodes;
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#addOrUpdate
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to add/update an activation code to repository.
         *
         * @param {object} activationCode An activation code object.
         */
    addOrUpdate: function addOrUpdate(activationCode) {

        var indexOfActivationCode = _activationCodes.findIndex(function (_activationCode) {
            return String(_activationCode.id) === String(activationCode.id);
        });

        if (indexOfActivationCode === -1) {

            this.add(activationCode);
        } else {

            this.update(activationCode);
        }
    },


    /**
        * @ngdoc function
        * @name repositories.ActivationCodesRepository#add
        * @methodOf repositories.ActivationCodesRepository
        * @function
        *
        * @description
        * This function can be used to add a new activation code to repository.
        *
        * @param {object} activationCode An activation code object.
        */
    add: function add(activationCode) {

        var indexOfActivationCode = _activationCodes.findIndex(function (_activationCode) {
            return String(_activationCode.id) === String(activationCode.id);
        });

        if (indexOfActivationCode === -1) {

            _RFC4.default.processCreate(activationCode);
            _activationCodes.push(activationCode);
            observableActivationCodes.onNext(_activationCodes);
        }
    },


    /**
        * @ngdoc function
        * @name repositories.ActivationCodesRepository#update
        * @methodOf repositories.ActivationCodesRepository
        * @function
        *
        * @description
        * This function can be used to update an activation code to repository.
        *
        * @param {object} activationCode An activation code object.
        */
    update: function update(activationCode) {

        var indexOfActivationCode = _activationCodes.findIndex(function (_activationCode) {
            return String(_activationCode.id) === String(activationCode.id);
        });

        if (indexOfActivationCode >= 0) {

            var flattenDiff = _RFC2.default.getFlattenDiff(_activationCodes[indexOfActivationCode], activationCode);

            _RFC4.default.processUpdate(flattenDiff, _activationCodes[indexOfActivationCode], activationCode);

            if (!angular.equals(flattenDiff, {})) {

                _activationCodes[indexOfActivationCode] = activationCode;
                observableActivationCodes.onNext(_activationCodes);
            }
        }
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#replace
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored activation codes with provided data.
         *
         * @param {Array} data An array with new activation codes.
         */
    replace: function replace(data) {

        _activationCodes = data;
        observableActivationCodes.onNext(_activationCodes);
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#getById
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to retrieves an activation codes from repository.
         *
         * @returns {Object} activationCode an activation code from repository
         */
    getById: function getById(id) {

        return _activationCodes.find(function (activationCode) {
            return String(activationCode.id) === String(id);
        });
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#getByAppId
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to retrieves an activation codes from repository.
         *
         * @returns {Object} activationCode an activation code from repository
         */
    getByAppId: function getByAppId(appId) {

        return _activationCodes.find(function (activationCode) {
            return String(activationCode.attributes.app) === String(appId);
        });
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#getObservable
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for activation codes repository.
         * @returns {Object} an observable object for activation codes repository.
         */
    getObservable: function getObservable() {

        return observableActivationCodes;
    },

    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#hasTPLinkLicence
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to check whether repo contains a TP-link licence(Prime aps30).
         * @returns {Boolean}.
         */
    hasTPLinkLicence: function hasTPLinkLicence() {

        return _activationCodes.findIndex(function (activationCode) {
            return activationCode.relationships.app.data.id === 'aps30';
        }) > -1;
    },

    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#hasActivePrime
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * check whether repo contains a active/subscription ON Prime activation code.
         * @returns {Boolean}.
         */
    hasActivePrime: function hasActivePrime() {

        var userHavePrime = _activationCodes.findIndex(function (activationCode) {
            return primeAppIds.indexOf(activationCode.relationships.app.data.id) > -1 && activationCode.attributes.subscription === 1;
        }) > -1;

        return userHavePrime;
    },


    /**
         * @ngdoc function
         * @name repositories.ActivationCodesRepository#deleteActivationCodeById
         * @methodOf repositories.ActivationCodesRepository
         * @function
         *
         * @description
         * This function can be used to delete a specific activation code
         * from repository based on id.
         * @returns {Object}.
         */
    deleteActivationCodeById: function deleteActivationCodeById(id) {

        _activationCodes = _activationCodes.filter(function (activationCode) {
            return activationCode.id !== id;
        });
        observableActivationCodes.onNext(_activationCodes);
    }
};

exports.default = ActivationCodesRepository;

/***/ }),

/***/ "nnQ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFCSession = __webpack_require__("DyxV");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-undef : 0 */
var _serviceDependencies = ['Auth', '$rootScope'];

/**
 * @ngdoc service
 * @name controllers.Root
 *
 * @description
 * Root controller
 */

var Root =

/**
 * @param  {any} Auth
 * @param  {any} $rootScopeuth
 */
function Root(Auth, $rootScope) {
    _classCallCheck(this, Root);

    Auth.sendAcpPing();

    var urlParams = decodeURIComponent(_RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams));

    // check if there are Spotlight newsletter campaign params
    if (urlParams && urlParams.indexOf('trial_source=ws_spotlight') > -1) {

        sessionStorage.setItem('TrialSourceSpotlight', 'ws_spotlight');
    }

    if (sessionStorage.getItem('TrialSourceSpotlight')) {

        $rootScope.isFromSpotlightNewsletterCampaign = true;
    }
};

_serviceDependencies.push(Root);

angular.module('controllers').controller('Root', _serviceDependencies);

/***/ }),

/***/ "nogF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state'];

var _$state = void 0;
var rid = void 0;

var LanguageSwitcherController = function () {
    function LanguageSwitcherController($state) {
        _classCallCheck(this, LanguageSwitcherController);

        var userLanguage = _index.MeRepository.getMyUser().attributes.language;

        // translate en -> English from config file
        this.Language = CWCONFIG.languages[userLanguage] || userLanguage;
        _$state = $state;
    }

    _createClass(LanguageSwitcherController, [{
        key: 'openModal',
        value: function openModal(modal) {

            if (!_$state.params.resourceId) {

                rid = 'all';
                _$state.go(_$state.current.name + '.ltb', {
                    ltb: modal,
                    resourceId: rid
                });
            } else {

                _$state.go(_$state.current.name + '.ltb', {
                    ltb: modal
                });
            }
        }
    }]);

    return LanguageSwitcherController;
}();

var LanguageSwitcherDirective = function LanguageSwitcherDirective() {
    _classCallCheck(this, LanguageSwitcherDirective);

    this.template = __webpack_require__("aMXR");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state) {
        return new LanguageSwitcherController($state);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'languageSwitcherCtrl';
};

_directiveDependencies.push(function () {
    return new LanguageSwitcherDirective();
});

angular.module('directives').directive('languageSwitcher', _directiveDependencies);

/***/ }),

/***/ "nsWR":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("QRZr");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "nylO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-console: 0 */
var _serviceDependencies = ['$rootScope', '$scope', 'Launcher', 'Auth'];

/**
 * @ngdoc service
 * @name controllers.NotAllowed
 *
 * @description
 * NotAllowed controller
 */

var NotAllowed =

/**
 * @param  {any} $rootScope
 * @param  {any} $scope
 * @param  {any} Launcher
 */

function NotAllowed($rootScope, $scope, Launcher, Auth) {
    _classCallCheck(this, NotAllowed);

    $rootScope.State.loading = false;
    $rootScope.State.finishedLoadingAnimation = true;
    $scope.brandName = CWCONFIG.partnerConfig.name;

    try {

        Launcher.resizeModal(650, 499);
        $scope.isLauncherWindow = window.outerWidth === 650 && window.outerHeight === 499;
    } catch (err) {

        console.log(err.message + ' - Not Allowed Page Opened from browser');
    }

    this.closeLauncher = function () {

        Launcher.closeModal();
    };

    this.removeLoginCookies = function () {

        Auth.removeLoginCookies();
    };
};

_serviceDependencies.push(NotAllowed);

angular.module('controllers').controller('NotAllowed', _serviceDependencies);

/***/ }),

/***/ "o92E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _paymentUrls = [];
var observablePaymentUrls = new Rx.BehaviorSubject(_paymentUrls);

/**
 * @ngdoc service
 * @name repositories.PaymentUrlsRepository
 *
 * @description
 * PaymentUrlsRepository.
 */
var PaymentUrlsRepository = {
    replace: function replace(data) {

        _paymentUrls = data;
        observablePaymentUrls.onNext(_paymentUrls);
    },
    getAll: function getAll() {

        return _paymentUrls;
    },
    getObservable: function getObservable() {

        return observablePaymentUrls;
    }
};

exports.default = PaymentUrlsRepository;

/***/ }),

/***/ "oKEH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.OAuthRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to manage authentication
 * using http requests.
 */

var OAuthRestService = function (_BaseRestService) {
    _inherits(OAuthRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function OAuthRestService($http, $q, Util) {
        _classCallCheck(this, OAuthRestService);

        return _possibleConstructorReturn(this, (OAuthRestService.__proto__ || Object.getPrototypeOf(OAuthRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.OAuthRestService#post
    * @methodOf rest.services.OAuthRestService
    * @function
    *
    * @description
    * This method will make a http request (POST) with user's credentials
    * in order to obtain the token.
    *
    * @param {object} oauthPayload OAuth payload
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(OAuthRestService, [{
        key: 'post',
        value: function post(oauthPayload, extraHeaders) {

            return _get(OAuthRestService.prototype.__proto__ || Object.getPrototypeOf(OAuthRestService.prototype), 'post', this).call(this, oauthPayload, 'oauth/', extraHeaders);
        }
    }]);

    return OAuthRestService;
}(_baseRestService2.default);

exports.default = OAuthRestService;


_serviceDependencies.push(OAuthRestService);

angular.module('rest.services').service('OAuthRestService', _serviceDependencies);

/***/ }),

/***/ "oNKH":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email license-m\" connectqa-deploy-modal=\"web-app-device\">\n    <div class=\"content-wrapper\">\n        <div class=\"circle-loader mb30 m-auto\"></div>\n\n        <h2 class=\"text-xl text-grey-2 measure m-auto\"\n                translate=\"cw.deploy.modal.web-app.title\"\n                translate-values=\"{product: '{{webAppDeploymentCtrl.app.attributes.resource.oeName}}' }\"\n        ></h2>\n    </div>\n</div>\n"

/***/ }),

/***/ "oXJa":
/***/ (function(module, exports) {

module.exports = " <!-- ConnectWeb Store -->\n <div>\n    <div class=\"new-store\">\n        <div class=\"store-panel\">\n            <!-- Store bundles comparison table -->\n            <div class=\"section\">\n\n                <h1 class=\"section-title text-grey-3 mb50\" translate=\"cw.store.section1.title\"></h1>\n\n                <div class=\"comparison-table\">\n                    <div class=\"awards-box card\">\n                        <p class=\"text-xs mb10\" translate=\"cw.store.awards.description\" translate-values=\"{brandname: brandName}\"></p>\n                        <p class=\"mb10 text-xs\" translate=\"cw.store.awards.link\" translate-values=\"{href: hrefAwards}\"></p>\n                        <span class=\"awards\"></span>\n                    </div>\n                    <ul class=\"header\">\n                        <li class=\"first-column\"></li>\n                        <li class=\"column crs-pointer\"\n                            ng-repeat=\"bundle in comparisonBundles\"\n                            ng-click=\"buy(bundle)\"\n                        >\n                            <div ng-if=\"productsConfig[bundle].highlight\" class=\"column-highlight\"></div>\n                            <div class=\"p-relative\">\n                                <div class=\"highlight\" ng-if=\"productsConfig[bundle].highlight\">\n                                    <span translate=\"cw.store.label.best_offer\"></span>\n                                </div>\n                                <img class=\"bundle-box\" ng-src=\"{{productData[bundle].attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                            </div>\n                            <span\n                                class=\"text-l font-medium text-grey-3\">{{productData[bundle].attributes.resource.oeName}}</span>\n                        </li>\n                    </ul>\n                    <ul class=\"bundles-prices mb5\">\n                        <li class=\"first-column\"></li>\n                        <li class=\"column\" ng-repeat=\"bundle in comparisonBundles\">\n                            <app-price appid='bundle + \"_12_1\"'\n                                showyearlabel=\"true\"\n                                showtotalprice=\"false\"\n                                showcmalabel=\"true\"\n                                class=\"inline-block w100\">\n                            </app-price>\n                            <button class=\"btn btn-small btn-primary\"\n                                ng-click=\"buy(bundle)\"\n                                translate=\"cw.store.buy\"\n                                connectqa-store=\"buy-{{bundle}}\">\n                            </button>\n                        </li>\n                    </ul>\n                    <ul class=\"comparison-features\">\n                        <li ng-repeat=\"feature in comparisonFeatures\">\n                            <div class=\"first-column text-m font-light\" translate=\"{{'cw.store.' + feature}}\"></div>\n                            <div\n                                class=\"column\"\n                                ng-repeat=\"bundle in comparisonBundles\"\n                            >\n                                <i ng-if=\"bundleComparisonFeatures[bundle][feature]\"\n                                    class=\"icon icon-checked icon-xs text-green-3\"></i>\n                                <div ng-if=\"!bundleComparisonFeatures[bundle][feature]\" class=\"missing-feature\">\n                                </div>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n            <!-- Store standalone products section -->\n            <div class=\"section\">\n                <h1 class=\"section-title mb50\" translate=\"cw.store.section2.title\"></h1>\n\n                <!-- Store For Home -->\n                <ul class=\"products\">\n                    <li class=\"product-card\"\n                        ng-style=\"{'border-top': '4px solid ' + productsConfig[product].headerColor}\"\n                        ng-repeat=\"product in products\"\n                        ng-class=\"{\n                            'hidden': product === 'adwp1' && !$root.showAIACardInFreeStore\n                        }\"\n                        connectqa-free-store=\"{{product}}\">\n                        <img class=\"product-box\" ng-src=\"{{productData[product].attributes.resource.cwStoreBoxshot | imageUrlParse}}\" />\n                        <div class=\"product-name\">{{productData[product].attributes.resource.oeName}}</div>\n                        <div class=\"product-description\">\n                            {{productData[product].attributes.resource.shortDescription | cut:true:150:'...'}}</div>\n\n                            <!-- <app-price\n                                showyearlabel=\"true\"\n                                class='product-price'\n                                showcmalabel=\"true\"\n                                appid='productData[product].productConfig'>\n                            </app-price> -->\n\n                            <app-price\n                                showyearlabel=\"true\"\n                                class='product-price'\n                                showcmalabel=\"true\"\n                                appid='productData[product].productConfig'>\n                            </app-price>\n\n                            <button class=\"btn btn-small btn-primary\" ng-click=\"buy(product)\" translate=\"cw.store.buy\" connectqa-store=\"buy-{{product}}\"></button>\n\n                        <a ng-click=\"openMarketingCard(product)\"\n                            class=\"text-s text-blue-2 mt10 crs-pointer showBlock\"\n                            translate=\"cw.store.learn_more\">\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <cma-disclaimer></cma-disclaimer>\n</div>\n"

/***/ }),

/***/ "oY6I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', '$state', '$http', '$stateParams', '$sce', '$translate'];

/**
 * @ngdoc service
 * @name controllers.News
 *
 * @description
 * News controller
 */
var _$scope = void 0;
var _$http = void 0;
var _$sce = void 0;
var languages = {};
var lang = CWCONFIG.language;
var parsedBookmarks = void 0;
var bookmarkStatus = void 0;
var _$translate = void 0;
var callUrl = CWCONFIG.news.getUrl;

var Article = function () {
    function Article($scope, $state, $http, $stateParams, $sce, $translate) {
        var _this = this;

        _classCallCheck(this, Article);

        var blogLanguages = CWCONFIG.news.languages;
        var isAvailable = blogLanguages.find(function (language) {
            return language === lang;
        });
        if (!isAvailable) {

            $state.go('root.dashboard.home');
            return false;
        }

        /**
         * Check if how-to category is avalable, if not set threats category default
         */
        var availableCategory = 'how-to';

        /**
         * Check if blog language was updated
         */

        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                localStorage.setItem('news_language', lang);

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1'
                });

                return false;
            }
        } else {

            localStorage.setItem('news_language', lang);
        }

        languages = {
            en: {
                threats: 2,
                'how-to': 2282
            },
            de: {
                threats: 2,
                'how-to': 1214
            },
            fr: {
                threats: 2,
                'how-to': 2300
            },
            es: {
                threats: 2,
                'how-to': 6858
            },
            it: {
                threats: 2,
                'how-to': 2300
            },
            'pt-br': {
                threats: 2,
                'how-to': 6858
            }
        };

        _$scope = $scope;
        _$http = $http;
        _$sce = $sce;
        _$scope.currentCategory = $state.params.tab;
        _$translate = $translate;
        _$scope.postcontent = [];
        _$scope.currentPages = _index.NewsRepository.getPageNumber();
        _$scope.currentLanguage = lang;

        parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));
        _$scope.availableCategories = languages[lang];
        var articleId = $stateParams.id;
        _$scope.articleId = $stateParams.id;
        var newsList = _index.NewsRepository.getAll();
        bookmarkStatus = this.checkIfArticleIsSaved($stateParams.id);

        if (newsList.length) {

            var found = false;

            newsList.forEach(function (item) {

                if (item) {

                    Object.keys(item).forEach(function (category) {

                        item[category].forEach(function (article) {

                            if (article.id === parseInt(articleId, 0)) {

                                $scope.currentArticle = article;
                                $scope.trustedHtmlContent = $sce.trustAsHtml(article.content.rendered);
                                _this.setArticleCategory();
                                found = true;
                                _this.calculateTimeToRead(article.content.rendered.replace(/<(?:.|\n)*?>/gm, ''));
                                _this.updateLazyLoadResources();
                            }
                        });
                    });
                }
            });

            if (found === false) {

                this.articleRequest(articleId);
                _$scope.isLoading = true;
            }
        } else {

            this.articleRequest(articleId);
            _$scope.isLoading = true;
        }

        if (bookmarkStatus) {

            _$scope.bookmarkStatus = true;
        }

        if (bookmarkStatus === undefined) {

            _$scope.bookmarkStatus = false;
        }

        _RFC2.default.send('ConnectWeb News Article Open');
    }

    /**
     * Get the article by id
     * param @string
     */


    _createClass(Article, [{
        key: 'articleRequest',
        value: function articleRequest(articleId) {
            var _this2 = this;

            _$http({

                method: 'GET',
                url: callUrl + '/' + articleId + '?_embed'

            }).then(function (response) {

                _$scope.currentArticle = response.data;
                _$scope.trustedHtmlContent = _$sce.trustAsHtml(response.data.content.rendered);
                _this2.calculateTimeToRead(response.data.content.rendered.replace(/<(?:.|\n)*?>/gm, ''));
                var date = response.data.date.split('T');

                var _date = _slicedToArray(date, 1);

                response.data.date = _date[0];

                _this2.setArticleCategory();
                _$scope.isLoading = false;
                _this2.updateLazyLoadResources();
            });
        }

        /**
         * Calculate time to read
         * param @object
         */

    }, {
        key: 'calculateTimeToRead',
        value: function calculateTimeToRead(content) {

            var wordsPerMinute = 200;

            var textLength = content.split(' ').length;

            if (textLength > 0) {

                var value = Math.ceil(textLength / wordsPerMinute);

                _$scope.timeToRead = value;
            }
        }

        /**
         * Check if article is bookmarked
         * param @string
         */

    }, {
        key: 'checkIfArticleIsSaved',
        value: function checkIfArticleIsSaved(articleId) {

            bookmarkStatus = parsedBookmarks[lang].find(function (element) {
                return element === parseInt(articleId, 0);
            });
            return bookmarkStatus;
        }

        /**
         * Save article in bookmarks list
         * param @string
         */

    }, {
        key: 'saveArticle',
        value: function saveArticle(articleId) {

            if (_$scope.bookmarkStatus === false) {

                parsedBookmarks[lang].push(parseInt(articleId, 0));
                localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                this.getSavedArticle(articleId);
                _$scope.bookmarkStatus = true;

                _RFC2.default.send('ConnectWeb News Bookmark Click', {
                    Bookmark: 'Save'
                });
            }
        }

        /**
         * Remove article from bookmarks list
         * param @string
         */

    }, {
        key: 'removeArticle',
        value: function removeArticle(articleId) {

            if (_$scope.bookmarkStatus === true) {

                parsedBookmarks[lang].forEach(function (localStorageItem) {

                    if (localStorageItem === parseInt(articleId, 0)) {

                        var remove = function remove(array, element) {

                            return array.filter(function (el) {
                                return el !== element;
                            });
                        };

                        parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                        localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                        _index.NewsRepository.deleteBookmark(parseInt(articleId, 0), lang);
                        _$scope.bookmarkStatus = false;
                    }
                });

                _RFC2.default.send('ConnectWeb News Bookmark Click', {
                    Bookmark: 'Unsave'
                });
            }
        }

        /**
         * Update bookmarks repo
         * param @string
         */

    }, {
        key: 'getSavedArticle',
        value: function getSavedArticle(articleId) {
            var _this3 = this;

            _$http({

                method: 'GET',
                url: callUrl + '/' + articleId

            }).then(function (response) {

                _index.NewsRepository.addBookmark(response.data, lang);
                _this3.getShortDescriptionSingleArticle(response.data);
            });
        }
    }, {
        key: 'getShortDescriptionSingleArticle',
        value: function getShortDescriptionSingleArticle(data) {

            data.shortDescription = data.excerpt.rendered.split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 300);
        }
    }, {
        key: 'updateLazyLoadResources',
        value: function updateLazyLoadResources() {

            setTimeout(function () {

                angular.forEach(angular.element('.article-body img'), function (value) {

                    var imageUrl = angular.element(value).attr('data-src');
                    if (imageUrl) {

                        angular.element(value).removeAttr('src');
                        angular.element(value).attr('src', imageUrl);
                    }
                });

                angular.forEach(angular.element('.article-body iframe'), function (value) {

                    var iframeUrl = angular.element(value).attr('data-src');

                    if (!iframeUrl) {

                        iframeUrl = angular.element(value).attr('src');
                    }
                    var linkVideo = angular.element('<a class="external-link" href="' + iframeUrl + '" target="_blank">' + _$translate.instant('cw.news.see_video_here') + '</a>');
                    linkVideo.insertAfter(angular.element(value));
                    angular.element(value).remove();
                });
            }, 0);
        }
    }, {
        key: 'setArticleCategory',
        value: function setArticleCategory() {

            if (_$scope.currentCategory === 'bookmarks') {

                _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.bookmarks');
            } else if (_$scope.currentCategory === 'threats') {

                _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.threats');
            } else if (_$scope.currentCategory === 'how-to') {

                _$scope.currentCategoryName = _$translate.instant('cw.news.category_name.how_to');
            }
        }
    }]);

    return Article;
}();

_serviceDependencies.push(Article);

angular.module('controllers').controller('Article', _serviceDependencies);

/***/ }),

/***/ "obUG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
        Cut a description and add ellipsis
     */
angular.module('filters').filter('cut', function () {
    return function (value, wordwise, max, tail) {

        var lastspace = void 0;

        if (!value) {

            return '';
        }

        max = parseInt(max, 10);

        if (!max) {

            return value;
        }

        if (value.length <= max) {

            return value;
        }

        value = value.substr(0, max);

        if (wordwise) {

            lastspace = value.lastIndexOf(' ');
            if (lastspace !== -1) {

                value = value.substr(0, lastspace);
            }
        }
        if (value.slice(-1) === '.') {

            return value + '..';
        }
        return value + (tail || '...');
    };
});

/***/ }),

/***/ "odJ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable max-len */


var _index = __webpack_require__("poBF");

var _index2 = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'Util', '$filter', '$state', 'ActivationCodeRestService', '$rootScope'];

var SubscriptionsTimelineController = function () {
    function SubscriptionsTimelineController($scope, Util, $filter, $state, ActivationCodeRestService, $rootScope) {
        var _this = this;

        _classCallCheck(this, SubscriptionsTimelineController);

        this.activationCodes = _index.ActivationCodesProcessor.getSortedActivationCodes();
        this.licenses = _index2.LicensesRepository.getAll();
        this.expiredLicenses = _index.ExpiredLicensesProcessor.getAll();
        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.Util = Util;
        this.$rootScope = $rootScope;

        var currentLanguage = CWCONFIG.language;
        var configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        var redirectSupportLanguage = '';

        if (configSupportLanguages.find(function (lang) {
            return lang === currentLanguage;
        })) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';
            } else {

                redirectSupportLanguage = currentLanguage;
            }
        } else {

            redirectSupportLanguage = 'en-us';
        }
        this.$scope.cancellationPolicy = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        this.$scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);

        if (this.licenses.length > 0) {

            this.$scope.showLiceses = true;

            this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(this.licenses) : {};
        } else if (this.expiredLicenses.length > 0) {
            var _expiredLicenses = _slicedToArray(this.expiredLicenses, 1);

            this.$scope.firstExpiredLicense = _expiredLicenses[0];

            this.$scope.firstExpiredLicense.appIntegration = _index2.AppIntegrationsRepository.getById(this.Util.deepFind(this.$scope.firstExpiredLicense, 'relationships.app.data.id'));
            this.$scope.showExpiredLiceses = true;
        } else {

            this.$scope.showDefault = true;
        }

        this.transactions = _index2.TransactionsRepository.getAll();
        this.paymentTypes = _index2.PaymentTypesRepository.getAll();

        this.ActivationCodeRestService = ActivationCodeRestService;

        this.subjectActivationCodes = _index.ActivationCodesProcessor.getObservable();
        this.activationCodesSubscriber = this.subjectActivationCodes.subscribe(function (data) {
            return _this.onActivationCodesNext(data);
        }, function () {}, function () {});

        this.licensesRepository = _index2.LicensesRepository.getObservable();
        this.licensesSubscriber = this.licensesRepository.subscribe(function (data) {
            return _this.onLicensesNext(data);
        }, function () {}, function () {});

        if (!sessionStorage.getItem('subscriptionWidgetNotification')) {

            sessionStorage.setItem('subscriptionWidgetNotification', true);
        }

        $scope.showNotification = sessionStorage.getItem('subscriptionWidgetNotification');

        $scope.goToRenewalSettings = function () {

            _this.$rootScope.activeNavSection = 'renewal';
        };

        $scope.checkStaticOTC = function (activationCode) {

            var staticOTC = false;
            if (activationCode) {

                staticOTC = activationCode.attributes.subscription === 0 && (activationCode.attributes.subscription_type === 'yearly' || activationCode.attributes.subscription_type === 'prepaid');
            }

            return staticOTC;
        };

        $scope.isBusinessProduct = function (activationCode) {

            var isBusinessProduct = false;

            if (activationCode) {
                var _ref = CWCONFIG.store || [],
                    businessProducts = _ref.businessProducts;

                isBusinessProduct = !!businessProducts.find(function (app) {
                    return activationCode.attributes.app === app;
                });
            }

            return isBusinessProduct;
        };
    }

    _createClass(SubscriptionsTimelineController, [{
        key: 'onActivationCodesNext',
        value: function onActivationCodesNext() {
            var _this2 = this;

            var licenses = _index2.LicensesRepository.getAll();
            licenses.forEach(function (license) {

                var appId = _this2.Util.deepFind(license, 'relationships.app.data.id');
                var activationCode = _this2.Util.deepFind(license, 'relationships.activation-code.data.id');
                license.appIntegration = _index2.AppIntegrationsRepository.getById(appId);

                if (activationCode) {

                    license.activationCode = _index2.ActivationCodesRepository.getById(activationCode);

                    if (license && license.activationCode) {

                        var expirationDate = _this2.Util.deepFind(license.activationCode, 'attributes.date_expire');

                        if (expirationDate) {

                            var todayFormatted = moment().format('L');
                            var expirationDateFormatted = moment(expirationDate).format('L');
                            license.activationCode.attributes.expiringToday = !!(todayFormatted === expirationDateFormatted);
                        }

                        license.activationCode.isVoucherPurchase = _this2.isVoucherPurchase(license.activationCode.id);
                        _this2.hasPaymentDetails(license.activationCode);
                    }
                }
            });

            this.$scope.licenses = licenses;
            this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(licenses) : {};
        }
    }, {
        key: 'onLicensesNext',
        value: function onLicensesNext(data) {
            var _this3 = this;

            if (data.length > 0) {

                this.$scope.showLiceses = true;
                this.$scope.showDefault = false;
            } else if (this.expiredLicenses.length > 0) {

                this.$scope.showExpiredLiceses = true;
            } else {

                this.$scope.showDefault = true;
            }

            this.ActivationCodeRestService.getAllAsync().then(function (response) {

                _index2.ActivationCodesRepository.replace(response.data.data);
            });

            data.forEach(function (license) {

                var appId = _this3.Util.deepFind(license, 'relationships.app.data.id');
                var activationCode = _this3.Util.deepFind(license, 'relationships.activation-code.data.id');
                license.appIntegration = _index2.AppIntegrationsRepository.getById(appId);

                if (activationCode) {

                    license.activationCode = _index2.ActivationCodesRepository.getById(activationCode);
                }
            });

            this.$scope.licenses = data;
            this.$scope.firstUnsubscribedLicense = this.$rootScope.hasSubscriptionOff ? this.checkUnsubscribedLicenses(data) : {};
        }
    }, {
        key: 'subscriptionToggle',
        value: function subscriptionToggle(activationCode) {

            this.$state.go('root.dashboard.home.ltb', {
                ltb: 'confirm',
                resourceId: activationCode.id
            }, {
                reload: false
            });
        }
    }, {
        key: 'onRenewalClick',
        value: function onRenewalClick(licenseCode) {

            var appId = this.Util.deepFind(licenseCode, 'relationships.app.data.id');
            var isIframeProduct = CWCONFIG.subscriptions.iframeProducts.find(function (product) {
                return product === appId;
            });

            if (isIframeProduct && licenseCode.attributes.cmp !== 'cobi2020avpro') {

                var licenseId = licenseCode.type === 'licenses' ? licenseCode.id : _index2.LicensesRepository.getLicenseBy(licenseCode.id).id;
                this.$scope.renewLink = '';

                this.$state.go('root.dashboard.home.ltb.renew', {
                    ltb: 'payment-cart',
                    resourceId: appId,
                    subsource: 'renew',
                    licenseId: licenseId
                }, {
                    reload: false
                });
            } else {

                this.$scope.renewLink = this.Util.deepFind(licenseCode, 'attributes.renewal_link') + '&x-a-source=cw';
            }

            this.$scope.cardDeletedRenewLink = isIframeProduct ? '' : this.Util.deepFind(licenseCode, 'attributes.renewal_link') + '&x-a-source=cw';
        }
    }, {
        key: 'sendSubscriptionsMixpanel',
        value: function sendSubscriptionsMixpanel(buttonLabel, licenseName, currentLicenseStatus) {

            var cmp = this.Util.deepFind(this.$scope.firstExpiringLicense, 'attributes.cmp');
            var isCobiLicense = false;

            if (cmp === 'cobi2020avpro') {

                isCobiLicense = true;
            }

            var mixpanelPayload = {
                Label: 'Subscriptions',
                'Button label': buttonLabel,
                'License Name': licenseName || '',
                'COBI License': isCobiLicense,
                'Current License Status': currentLicenseStatus || '',
                'Notification overlay': this.$scope.showNotification.toString()
            };

            _RFC2.default.send('ConnectWeb Home Click', mixpanelPayload);
        }
    }, {
        key: 'setScrollToExpiredSubscriptions',
        value: function setScrollToExpiredSubscriptions() {

            this.$rootScope.scrollToExpiredSubscriptions = true;
        }

        /* check if this was purchased by family and friend voucher so we will
            hide autorenew toogle and enable subscription button */

    }, {
        key: 'isVoucherPurchase',
        value: function isVoucherPurchase(activateCode) {

            var getTransactions = _index2.TransactionsRepository.getAll();
            var transactionWithVoucher = getTransactions.find(function (transaction) {
                return transaction.attributes.activation_code === activateCode;
            });

            if (transactionWithVoucher && transactionWithVoucher.attributes) {

                return transactionWithVoucher.attributes.payment_type === 'Voucher';
            }

            return false;
        }
    }, {
        key: 'hasPaymentDetails',
        value: function hasPaymentDetails(license) {

            var activationCodePurchaseDate = this.transactions.find(function (transaction) {
                return transaction.attributes.activation_code === license.id;
            });

            // Check if the payment type associated with the current activation code was removed
            // Get transaction id associated with the current activation code
            var paymentTransactionId = this.Util.deepFind(activationCodePurchaseDate, 'attributes.payment_transaction_id');

            // Get payment type details based on the transaction id
            var paymentTypeDetails = this.paymentTypes.find(function (payment) {
                return payment.id === paymentTransactionId;
            });

            // If the card was removed, so we need to disable the auto-renewal toggle
            if (this.Util.isPaymentCardDeleted(paymentTypeDetails)) {

                license.removedPaymentOption = true;
            }
        }

        /* Check if there are licenses with subscription off and return the first one */

    }, {
        key: 'checkUnsubscribedLicenses',
        value: function checkUnsubscribedLicenses(licenses) {

            var firstUnsubscribedLicense = {};
            var unsubscribedLicenses = licenses.filter(function (license) {
                return license.attributes.subscription === 0;
            });

            if (unsubscribedLicenses.length > 0) {

                var latestDate = unsubscribedLicenses.map(function (license) {
                    return license.attributes.expiration_date;
                }).sort()[0];
                firstUnsubscribedLicense = unsubscribedLicenses.find(function (license) {
                    return license.attributes.expiration_date === latestDate;
                });

                var appIntegration = _index2.AppIntegrationsRepository.getById(this.Util.deepFind(firstUnsubscribedLicense, 'relationships.app.data.id'));
                firstUnsubscribedLicense.productName = appIntegration.attributes.resource.oeName;
            }

            // Hide subscriptions card from homepage on certain activation code properties (moved from html)
            if (firstUnsubscribedLicense.productName) {

                // check if it's a static otc
                var staticOTC = firstUnsubscribedLicense.attributes.subscription_type === 'yearly' || firstUnsubscribedLicense.attributes.subscription_type === 'prepaid';

                // check if it's a business product

                var _ref2 = CWCONFIG.store || [],
                    businessProducts = _ref2.businessProducts;

                var appId = this.Util.deepFind(firstUnsubscribedLicense, 'relationships.app.data.id');
                var isBusinessProduct = !!businessProducts.find(function (app) {
                    return appId === app;
                });

                if (staticOTC || isBusinessProduct || firstUnsubscribedLicense.attributes.has_partner_id || firstUnsubscribedLicense.attributes.expiringToday) {

                    angular.element('.subscriptions-card').css('display', 'none');
                }

                if (firstUnsubscribedLicense.activationCode && (firstUnsubscribedLicense.activationCode.removedPaymentOption || firstUnsubscribedLicense.activationCode.isVoucherPurchase)) {

                    angular.element('.subscriptions-card').css('display', 'none');
                }
            }

            return firstUnsubscribedLicense;
        }
    }]);

    return SubscriptionsTimelineController;
}();

var SubscriptionsTimelineDirective = function SubscriptionsTimelineDirective() {
    _classCallCheck(this, SubscriptionsTimelineDirective);

    this.template = __webpack_require__("+Tt2");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, Util, $filter, $state, ActivationCodeRestService, $rootScope) {
        return new SubscriptionsTimelineController($scope, Util, $filter, $state, ActivationCodeRestService, $rootScope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'SubscriptionsTimelineCtrl';
};

_directiveDependencies.push(function () {
    return new SubscriptionsTimelineDirective();
});

angular.module('directives').directive('subscriptionsTimeline', _directiveDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "onJI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ActivationCodeRestService
 *
 * @description
 * This class contains methods used to manage information about activation codes
 * using http requests.
 */

var ActivationCodeRestService = function (_BaseRestService) {
    _inherits(ActivationCodeRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function ActivationCodeRestService($http, $q, Util) {
        _classCallCheck(this, ActivationCodeRestService);

        return _possibleConstructorReturn(this, (ActivationCodeRestService.__proto__ || Object.getPrototypeOf(ActivationCodeRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.ActivationCodeRestService#getAllAsync
     * @methodOf rest.services.ActivationCodeRestService
     * @function
     *
     * @description
     * Retrieves activation-codes.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(ActivationCodeRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(ActivationCodeRestService.prototype.__proto__ || Object.getPrototypeOf(ActivationCodeRestService.prototype), 'getAllAsync', this).call(this, 'activation-codes/');
        }

        /**
        * @ngdoc function
        * @name rest.services.ActivationCodeRestService#getById
        * @methodOf rest.services.ActivationCodeRestService
        * @function
        *
        * @description
        * Retrieves activation-code.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getById',
        value: function getById(id) {

            return _get(ActivationCodeRestService.prototype.__proto__ || Object.getPrototypeOf(ActivationCodeRestService.prototype), 'getAllAsync', this).call(this, 'activation-codes/' + id + '/');
        }

        /**
         * @ngdoc function
         * @name rest.services.ActivationCodeRestService#updateAsync
         * @methodOf rest.services.ActivationCodeRestService
         * @function
         *
         * @description
         * Updates an activation code.
         *
         * @param {string} activationCodeId activation code identifier
         * @param {object} activationCodePayload activation code payload
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'updateAsync',
        value: function updateAsync(activationCodeId, activationCodePayload) {

            return _get(ActivationCodeRestService.prototype.__proto__ || Object.getPrototypeOf(ActivationCodeRestService.prototype), 'update', this).call(this, activationCodeId, activationCodePayload, 'activation-codes/');
        }
    }]);

    return ActivationCodeRestService;
}(_baseRestService2.default);

exports.default = ActivationCodeRestService;


_serviceDependencies.push(ActivationCodeRestService);

angular.module('rest.services').service('ActivationCodeRestService', _serviceDependencies);

/***/ }),

/***/ "ov1h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controller for /dashboard/desktop route
 */
angular.module('controllers').controller('ForceDesktop', ['$state', function ($state) {

    var cookieConfig = CWCONFIG.cookie;
    var domain = cookieConfig.domain;


    _RFC2.default.set(cookieConfig.forceDesktop, true, { path: '/', domain: domain });
    $state.go('root.dashboard.home', null, { location: 'replace' });
}]);

/***/ }),

/***/ "p8AI":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("frJZ");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "p8C+":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-xlarge-width\"\n    ng-class=\"{\n        'trial-modal': !showCMAscreen,\n        'trial-modal-cma': showCMAscreen\n    }\"\n>\n    <div ng-if=\"!showCMAscreen\">\n        <div class=\"header\">\n            <h3 translate=\"cw.subscriptions.trial_modal.product\"></h3>\n            <h2 translate=\"cw.subscriptions.trial_modal.title\"></h2>\n            <div class=\"subtitle\">\n                <span translate=\"cw.subscriptions.trial_modal.desc_1\"></span>\n                <div class=\"info-tooltip-holder\">\n                    <i class=\"icon icon-info text-blue-1 ml5\"></i>\n                    <div class=\"info-tooltip arrow-top text-xs\" translate=\"cw.subscriptions.trial_modal.desc_tooltip\"></div>\n                </div>\n                <span translate=\"cw.subscriptions.trial_modal.desc_2\"></span>\n            </div>\n        </div>\n        <div class=\"content\">\n            <div class=\"timeline-wrapper\">\n                <div class=\"timeline-labels-top\">\n                    <p class=\"trial-label text-green-1 text-l\" translate=\"cw.subscriptions.trial_modal.timeline.label\"></p>\n                    <div class=\"first-bill\">\n                        <p class=\"text-s\" translate=\"cw.subscriptions.trial_modal.timeline.first_bill\"></p>\n                        <p class=\"text-xs text-grey-3\"\n                            translate=\"{{'cw.subscriptions.trial_modal.timeline.date_month' + trialTimeline.endMonth}}\"\n                            translate-values=\"{date : trialTimeline.endDate}\"></p>\n                    </div>\n                </div>\n                <div class=\"timeline\"></div>\n                <div class=\"timeline-labels-bottom\">\n                    <div class=\"pay-now\">\n                        <p class=\"text-xs text-grey-3\"\n                            translate=\"{{'cw.subscriptions.trial_modal.timeline.date_month' + trialTimeline.startMonth}}\"\n                            translate-values=\"{date : trialTimeline.startDate}\"></p>\n                        <p class=\"text-s\" translate=\"cw.subscriptions.trial_modal.timeline.pay_now\"\n                            translate-values=\"{ price: checkPayNowPrice() }\"></p>\n                    </div>\n                    <div class=\"reminder\">\n                        <p class=\"text-xs text-grey-3\"\n                            translate=\"{{'cw.subscriptions.trial_modal.timeline.date_month' + trialTimeline.reminderMonth}}\"\n                            translate-values=\"{date : trialTimeline.reminderDate}\"></p>\n                        <p class=\"text-s\" translate=\"cw.subscriptions.trial_modal.timeline.reminder.title\"></p>\n                        <p class=\"text-xs text-grey-3\" translate=\"cw.subscriptions.trial_modal.timeline.reminder.desc\"></p>\n                    </div>\n                </div>\n            </div>\n            <p class=\"text-s disclaimer text-grey-3\"\n                translate=\"cw.subscriptions.trial_modal.disclaimer\"\n                translate-values=\"{price : trialPromotion.attributes.total_price_string}\"></p>\n            <a class=\"btn btn-medium btn-primary\" translate=\"cw.subscriptions.trial_modal.cta\" ng-click=\"activateTrial()\"></a>\n            <div class=\"text-center\">\n                <a class=\"mt20 text-blue-1 crs-pointer inline-block\" ng-click=\"showCMAscreenClick()\" translate=\"cw.cma_disclaimer.title\"></a>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"showCMAscreen\">\n        <h2 translate=\"cw.cma_disclaimer.title\"></h2>\n        <div class=\"text-left mt40 mb40\">\n\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span>\n                <span translate=\"cw.cma_disclaimer.contract_type_desc\"\n                translate-values=\"{termsOfSale: termsOfSale}\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.set_up\"></span>\n                <span translate=\"cw.cma_disclaimer.set_up_desc\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.free_trial\"></span>\n                <span translate=\"cw.cma_disclaimer.free_trial_desc\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span>\n                <span translate=\"cw.cma_disclaimer.renewal_cycle_desc\"\n                translate-values=\"{\n                    yourAccount: yourAccount,\n                    contactUs: contactUs,\n                    learnHow: learnHow\n                }\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_prices\"></span>\n                <span translate=\"cw.cma_disclaimer.renewal_prices_desc\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span>\n\n                <span ng-if=\"!$root.cmaGBapplies && !$root.cmaNLapplies && !$root.cmaDEapplies && !$root.cmaFRapplies\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_row\"\n                translate-values=\"{\n                    cancellation: cancellation,\n                    cancelOrRefund: cancelContractDetails\n                }\"></span>\n\n                <span ng-if=\"!$root.cmaGBapplies && !$root.cmaNLapplies && ($root.cmaDEapplies || $root.cmaFRapplies)\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_row\"\n                translate-values=\"{\n                    cancellation: cancellation,\n                    cancelOrRefund: cancelContractDetailsNew\n                }\"></span>\n\n                <span ng-if=\"$root.cmaGBapplies || $root.cmaNLapplies\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_gb\" translate-values=\"{\n                    cancellation: cancellation,\n                    cancelOrRefund: cancelContractDetails\n                }\"></span>\n            </p>\n            <p class=\"text-m text-grey-3 mb10\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.updates\"></span>\n                <span translate=\"cw.cma_disclaimer.updates_desc\" translate-values=\"{\n                    licenseAgreement: licenseAgreement\n                }\"></span>\n            </p>\n            <p class=\"text-m text-grey-3\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.usage\"></span>\n                <span translate=\"cw.cma_disclaimer.Usage_desc\" translate-values=\"{\n                    contactUs: contactUs\n                }\"></span>\n            </p>\n        </div>\n        <a class=\"btn btn-medium btn-primary\" ng-click=\"backToTrialScreen()\" translate=\"cw.deploy.got.it\"></a>\n    </div>\n</div>\n\n";
var path = 'scripts/controllers/modals/trial-modal/trial-modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "pScZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _index = __webpack_require__("lSlM");

angular.module('directives').directive('countrySelector', ['$focus', 'Countries', function ($focus, Countries) {
    return {
        template: __webpack_require__("pnOh"),
        restrict: 'EA',
        replace: true,
        scope: {
            selectedDevice: '=',
            next: '&',
            inputError: '='
        },
        compile: function compile() {
            return {
                pre: function pre(scope) {

                    var phone = void 0;
                    scope.countries = [];

                    angular.copy(Countries, scope.countries);
                    scope.hasPrefix = false;

                    if (!scope.selectedDevice) {

                        scope.selectedDevice = {};
                    }
                    scope.dialCode = {};

                    var User = _index.MeRepository.getMyUser();

                    if (User.attributes.phone) {

                        phone = User.attributes.phone.split('/');
                    }

                    _.each(Countries, function (country) {

                        scope.dialCode[country.dialCode.substring(1)] = country;

                        // check countryCode for input field
                        if (country.code === User.attributes.country.toLowerCase() && !scope.selectedDevice.country) {

                            scope.selectedDevice.country = country;
                        }

                        // check phone & dialCode for input field
                        if (phone && phone[0].indexOf(country.dialCode) === 0 && (
                        // countries that have NO space (Ex: +40 RO ) and are not US or CA
                        phone[0].charAt(2) !== ' ' && country.dialCode !== '+1' ||
                        // countries that have space (Ex: +1 393 PR ) and are not US or CA
                        phone[0].charAt(2) === ' ' && country.dialCode !== '+1' ||
                        // +1 countries that are US or CA and are not ( +1268 AG or +1664 MS )
                        phone[0].charAt(2) !== ' ' && country.dialCode === '+1' && phone[0].indexOf('+1268') === -1 && phone[0].indexOf('+1664') === -1)) {

                            scope.selectedDevice.country = country;

                            // fix for numbers that contain a slash e.g +49/33242....
                            if (phone[0] === country.dialCode) {

                                scope.selectedDevice.phoneNumber = phone[1] || '';
                            } else {

                                scope.selectedDevice.phoneNumber = phone[0].replace(country.dialCode, '');
                            }
                        }
                    });
                },
                post: function post(scope, element) {

                    /* listen for ENTER key pressed */
                    element.bind('keydown', function (event) {

                        var key = event.keyCode || event.which;
                        var keyCodesMappings = {
                            ENTER: 13
                        };
                        if (key === keyCodesMappings.ENTER) {

                            scope.next();
                        }
                    });

                    scope.$watch('selectedDevice.phoneNumber', function (phoneNumber) {

                        var foundPrefix = false;
                        var prefix = '';
                        var startIdx = 0;
                        var idx = 1;

                        if (!phoneNumber) {

                            return;
                        }

                        if (startIdx === 1 && phoneNumber.charAt(0) === '+' || startIdx === 2 && phoneNumber.substring(0, 2) === '00') {

                            idx = startIdx + 1;
                            while (!foundPrefix && idx <= phoneNumber.length) {

                                prefix = phoneNumber.substring(startIdx, idx);
                                if (scope.dialCode[prefix]) {

                                    foundPrefix = true;
                                    scope.hasPrefix = true;
                                    scope.selectedDevice.country = scope.dialCode[prefix];
                                }
                                idx += 1;
                            }
                        }
                        if (!foundPrefix) {

                            scope.hasPrefix = false;
                        }
                    });

                    scope.$watch('selectedDevice.country.name', function (newValue, oldValue) {

                        if (!angular.isUndefined(newValue) && !angular.isUndefined(oldValue) && newValue !== oldValue) {

                            scope.hasPrefix = false;
                        }
                        $focus(scope, 'phoneNumber');
                    });

                    scope.hideError = function () {

                        if (scope.inputError) {

                            scope.inputError = false;
                        }
                    };
                }
            };
        }
    };
}]);

angular.module('filters').filter('filterCountry', function () {
    return function (countries, query) {

        if (angular.isUndefined(query) || !query) {

            return countries;
        }
        return _.filter(countries, function (country) {

            var dialCode = country.dialCode || '';
            if (!country.name) {

                return false;
            }
            return country.name.toLowerCase().indexOf(query.toLowerCase()) === 0 || dialCode.indexOf(query) >= 0;
        });
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "pW+S":
/***/ (function(module, exports) {

module.exports = "<div>\n\t<div class=\"profile-details\">\n\n\t\t<div class=\"mya-section-info\">\n\t\t\t<div class=\"text-xxl text-grey-2\" translate=\"cw.profile.info\"></div>\n\t\t\t<div class=\"text-m mt5 text-grey-3\" translate=\"cw.profile.deff\" translate-values=\"{brandname : brandName}\"></div>\n\t\t\t<div class=\"text-xs mt10 text-grey-3\" translate=\"cw.general.required_fields\"></div>\n\t\t</div>\n\n\t\t<div class=\"mya-section-forms max-width-l\">\n\t\t\t<div class=\"details-form\">\n\t\t\t\t<form name=\"profileDetailsForm\" role=\"form\" novalidate ng-submit=\"ProfileDetailsCtrl.changeProfileDetails()\">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<!-- Company Name -->\n\t\t\t\t\t\t<div ng-show=\"userDetails.organization_name\" class=\"input-holder adapt-width\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\">\n\t\t\t\t\t\t\t\t<span translate=\"cw.account.details.organization_name\"></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\tng-model=\"userDetails.organization_name\"\n\t\t\t\t\t\t\t\t\treadonly=\"true\"\n\t\t\t\t\t\t\t\t\tname=\"organizationName\"\n\t\t\t\t\t\t\t\t\tid=\"organizationName\"\n\t\t\t\t\t\t\t\t\tconnectqa-mya=\"company-name\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<!-- First name -->\n\t\t\t\t\t\t<div class=\"input-holder mr20 v-top\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\">\n\t\t\t\t\t\t\t\t<span translate=\"cw.form.profile.first_name\"></span>\n\t\t\t\t\t\t\t\t<span> *</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\tng-model=\"userFirstName\"\n\t\t\t\t\t\t\t\t\tplaceholder=\"\"\n\t\t\t\t\t\t\t\t\tname=\"userFirstName\"\n\t\t\t\t\t\t\t\t\tmaxlength=\"100\"\n\t\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\t\tng-class=\"{'error': (profileDetailsForm.userFirstName.$error.required && submitted) || (profileDetailsForm.userFirstName.$pristine && profileDetailsForm.userFirstName.$error.serverValidation && submitted)}\"\n\t\t\t\t\t\t\t\t\tid=\"userFirstName\"\n\t\t\t\t\t\t\t\t\trequired connectqa-mya=\"first-name\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class=\"error-message\"\n\t\t\t\t\t\t\tng-show=\"profileDetailsForm.userFirstName.$error.required && submitted\"\n\t\t\t\t\t\t\ttranslate=\"cw.account.details.firstname.error\" connectqa-mya=\"empty-firstname\">\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"error-message\"\n\t\t\t\t\t\t\t\tng-show=\"profileDetailsForm.userFirstName.$pristine && profileDetailsForm.userFirstName.$error.serverValidation && submitted\"\n\t\t\t\t\t\t\t\ttranslate=\"cw.validator.messages.invalid\" connectqa-mya=\"invalid-firstname\"></p>\n\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t<!-- Last Name -->\n\t\t\t\t\t\t<div class=\"input-holder\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.last_name\"></div>\n\n\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\tng-model=\"userLastName\"\n\t\t\t\t\t\t\t\t\tplaceholder=\"\"\n\t\t\t\t\t\t\t\t\tname=\"userLastName\"\n\t\t\t\t\t\t\t\t\tmaxlength=\"100\"\n\t\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\t\tng-class=\"{'error': (profileDetailsForm.userLastName.$pristine && profileDetailsForm.userLastName.$error.serverValidation && submitted)}\"\n\t\t\t\t\t\t\t\t\tid=\"userLastName\"\n\t\t\t\t\t\t\t\t\tconnectqa-mya=\"last-name\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class=\"error-message\"\n\t\t\t\t\t\t\t\tng-show=\"profileDetailsForm.userLastName.$pristine && profileDetailsForm.userLastName.$error.serverValidation && submitted\"\n\t\t\t\t\t\t\t\ttranslate=\"cw.validator.messages.invalid\" connectqa-mya=\"invalid-lastname\"></p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- Billing Address -->\n\t\t\t\t\t<div class=\"input-holder adapt-width\">\n\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.billing_address\"></div>\n\n\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\tng-model=\"billingAddress\"\n\t\t\t\t\t\t\t\tplaceholder=\"\"\n\t\t\t\t\t\t\t\tname=\"billingAddress\"\n\t\t\t\t\t\t\t\tmaxlength=\"500\"\n\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\tng-class=\"{'error': profileDetailsForm.billingAddress.$invalid || (profileDetailsForm.billingAddress.$pristine && profileDetailsForm.billingAddress.$error.serverValidation && submitted)}\"\n\t\t\t\t\t\t\t\tid=\"billingAddress\"\n\t\t\t\t\t\t\t\tconnectqa-mya=\"billing-address\"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div>\n\n\t\t\t\t\t\t<!-- City -->\n\t\t\t\t\t\t<div class=\"input-holder v-top mr20\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.city\"></div>\n\n\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\tng-model=\"city\"\n\t\t\t\t\t\t\t\t\tplaceholder=\"\"\n\t\t\t\t\t\t\t\t\tname=\"city\"\n\t\t\t\t\t\t\t\t\tmaxlength=\"80\"\n\t\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\t\tng-class=\"{'error': profileDetailsForm.city.$invalid || (profileDetailsForm.city.$pristine && profileDetailsForm.city.$error.serverValidation && submitted)}\"\n\t\t\t\t\t\t\t\t\tid=\"city\"\n\t\t\t\t\t\t\t\t\tconnectqa-mya=\"city\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Country -->\n\t\t\t\t\t\t<div class=\"input-holder v-top mr20\" connectqa-mya=\"country-holder\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.country\" connectqa-mya=\"country\"></div>\n\t\t\t\t\t\t\t<ui-select class=\"text-m\" ng-model=\"userCountry.selectedValue\" theme=\"selectize\" connectqa-mya=\"country-input\">\n\n\t\t\t\t\t\t\t\t<ui-select-match class=\"text-m\" placeholder=\"{{ 'cw.account.details.select.country' | translate }}\">\n\t\t\t\t\t\t\t\t\t<span data-ng-bind=\"$select.selected.name\"></span>\n\t\t\t\t\t\t\t\t</ui-select-match>\n\n\t\t\t\t\t\t\t\t<ui-select-choices class=\"text-m\" repeat=\"userCountry in countries | filterCountry : $select.search\" connectqa-mya=\"{{ userCountry }}\">\n\t\t\t\t\t\t\t\t\t<span class=\"text-m\" data-ng-bind=\"userCountry.name\"></span>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- State -->\n\t\t\t\t\t\t<div ng-show=\"userCountry.selectedValue.code === 'US'\" class=\"input-holder v-top mr20\" connectqa-mya=\"state-holder\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.state\"></div>\n\n\t\t\t\t\t\t\t<ui-select class=\"text-m\" ng-model=\"userState.selectedValue\" theme=\"selectize\" connectqa-mya=\"state-input\">\n\n\t\t\t\t\t\t\t\t<ui-select-match class=\"text-m\" placeholder=\"{{ 'cw.account.details.select.state' | translate }}\">\n\t\t\t\t\t\t\t\t\t<span data-ng-bind=\"$select.selected.name\"></span>\n\t\t\t\t\t\t\t\t</ui-select-match>\n\n\t\t\t\t\t\t\t\t<ui-select-choices class=\"text-m\" repeat=\"userState in states | filterState : $select.search\" connectqa-mya=\"{{ userState }}\">\n\t\t\t\t\t\t\t\t\t<span class=\"text-m\" data-ng-bind=\"userState.name\"></span>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- ZipCode -->\n\t\t\t\t\t\t<div class=\"input-holder v-top mr20\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.zipcode\"></div>\n\n\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\tng-model=\"zipcode\"\n\t\t\t\t\t\t\t\t\tplaceholder=\"\"\n\t\t\t\t\t\t\t\t\tname=\"zipcode\"\n\t\t\t\t\t\t\t\t\tmaxlength=\"25\"\n\t\t\t\t\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t\t\t\t\tng-class=\"{'error': profileDetailsForm.zipcode.$invalid || (profileDetailsForm.zipcode.$pristine && profileDetailsForm.zipcode.$error.serverValidation && submitted)}\"\n\t\t\t\t\t\t\t\t\tng-pattern=\"zipcodeRegexPattern\"\n\t\t\t\t\t\t\t\t\tid=\"zipcode\"\n\t\t\t\t\t\t\t\t\tconnectqa-mya=\"zipcode\"\n\t\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p class=\"error-message\" ng-show=\"profileDetailsForm.zipcode.$invalid || (profileDetailsForm.zipcode.$pristine && profileDetailsForm.zipcode.$error.serverValidation && submitted)\"\n\t\t\t\t\t\t\t\ttranslate=\"cw.validator.messages.invalid\" connectqa-mya=\"invalid-zipcode\"></p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Phone Number -->\n\t\t\t\t\t\t<div ng-show=\"userDetails.phone\" class=\"input-holder v-top mr20\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.form.profile.phone_number\"></div>\n\n\t\t\t\t\t\t\t<div country-selector class=\"country-selector\" selected-device=\"selectedDevice\" next=\"sendCode()\" input-error=\"phoneInputError\"></div>\n\n\t\t\t\t\t\t\t<p class=\"error-message\" ng-show=\"!isValidNumber\"\n\t\t\t\t\t\t\t\ttranslate=\"cw.input.error.invalid_phone\" connectqa-mya=\"invalid-phone\"></p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Language -->\n\t\t\t\t\t\t<div class=\"input-holder\" connectqa-mya=\"language-holder\">\n\t\t\t\t\t\t\t<div class=\"text-m text-grey-4 pass-text\" translate=\"cw.profile.lang\"></div>\n\t\t\t\t\t\t\t<ui-select class=\"text-m\" ng-model=\"userLanguage.selectedValue\" theme=\"selectize\" connectqa-mya=\"language-input\">\n\n\t\t\t\t\t\t\t\t<ui-select-match class=\"text-m\" placeholder=\"{{ 'cw.account.details.select.lang' | translate }}\">\n\t\t\t\t\t\t\t\t\t<span data-ng-bind=\"$select.selected.name\"></span>\n\t\t\t\t\t\t\t\t</ui-select-match>\n\n\t\t\t\t\t\t\t\t<ui-select-choices class=\"text-m\" repeat=\"userLanguage in languages | filterCountry : $select.search\">\n\t\t\t\t\t\t\t\t\t<span class=\"text-m\" data-ng-bind=\"userLanguage.name\" connectqa-mya=\"{{userLanguage.code}}\"></span>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<button class=\"btn btn-large btn-primary mt15\"\n\t\t\t\t\t\t\tng-disabled=\"profileDetailsForm.submitted\"\n\t\t\t\t\t\t\ttranslate=\"cw.form.profile.save\" connectqa-mya=\"save-profile-changes\">\n\t\t\t\t\t</button>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t</div>\n\n\n\t</div>\n</div>"

/***/ }),

/***/ "pci3":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email\">\n    <div class=\"top-elements content-wrapper\">\n        <i class=\"icon icon-avira-logo mb20\"></i>\n        <h2 class=\"text-xxl2 text-grey-2 mb10\" translate=\"cw.deploy.product.sent\"></h2>\n        <p class=\"text-l text-grey-2 mb40\" translate=\"cw.deploy.product.instructions\" translate-values=\"{email: inputData.emails[0]}\"></p>\n        <p ng-if=\"inputData.emails.length > 1\" class=\"text-l text-grey-2 mb40\" translate=\"cw.deploy.product.instructions_multiple_emails\"></p>\n\n        <ul class=\"tour-tutorial-steps mb20 deploy-product-pc\">\n            <li>\n                <div class=\"icon icon-l icon-pc icon-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">1</i>\n                    <div class=\"icon icon-envelope text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-m text-grey-2 ng-scope\" translate=\"cw.deploy.email.step_1\"></p>\n            </li>\n\n            <div class=\"download-dot download-dot-step-1 inline-block \">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n\n            <li>\n                <div class=\"icon icon-l icon-pc icon-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">2</i>\n                    <div class=\"icon icon-Cloudlarge text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-m text-grey-2 ng-scope\" translate=\"cw.deploy.product.step_2\"></p>\n            </li>\n\n            <div class=\"download-dot download-dot-step-1 inline-block \">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n\n            <li>\n                <div class=\"icon icon-l icon-pc icon-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">3</i>\n                    <div class=\"icon icon-Cog text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-m text-grey-2\" translate=\"cw.deploy.email.step_3\"></p>\n            </li>\n        </ul>\n\n        <button class=\"btn btn-medium btn-primary\" ng-click=\"PcEmailDeploymentSuccessCtrl.close();\" translate=\"cw.general.fixed_it\"></button>\n    </div>\n</div>\n"

/***/ }),

/***/ "pl0f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

    /**
        Make a string's first character uppercase
     */
    angular.module('filters').filter('ucfirst', function () {
        return function (string) {

            if (!string) {

                return '';
            }

            return string.charAt(0).toUpperCase() + string.slice(1);
        };
    });
})();

/***/ }),

/***/ "pnOh":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"send-sms-inputs\">\n        <div ui-select ng-model=\"selectedDevice.country\" theme=\"selectize\" style=\"width: 100px;\">\n            <div ui-select-match placeholder=\"{{ 'cw.form.profile.country' | translate }}\">\n                <span ng-show=\"hasPrefix\" class=\"cnt-woutprefix\" connectqa-deploy-modal=\"country-extension\">\n                    <i class=\"flag-large flag-{{$select.selected.code || selectedDevice.country.code }}\"></i>\n                </span>\n                <span ng-show=\"!hasPrefix\" class=\"cnt-wprefix\" connectqa-deploy-modal=\"country-extension\">\n                    <i class=\"flag-{{$select.selected.code || selectedDevice.country.code }}\"></i>\n                    <span> {{$select.selected.dialCode || selectedDevice.country.dialCode}} </span>\n                </span>\n            </div>\n            <ui-select-choices repeat=\"item in countries | filterCountry: $select.search\"\n            >\n                <div bindonce>\n                    <div\n                        class=\"name-country\"\n                    >{{item.name}}</div>\n                    <div class=\"flag-country\">\n                        <span boHtml=\"item.dialCode | highlight: $select.search\"></span>\n                        <i class=\"flag-{{item.code}}\"></i>\n                    </div>\n                </div>\n            </ui-select-choices>\n        </div>\n        <div class=\"form-group fl-left\">\n            <input type=\"text\" focus=\"phoneNumber\" ng-keypress=\"validate($event)\" placeholder=\"{{ 'cw.my_devices.system_info.phone_number' | translate }}\" ng-model=\"selectedDevice.phoneNumber\" connectqa-deploy-modal=\"phone-number\" ng-class=\"{'error': inputError}\" ng-keydown=\"hideError()\" />\n        </div>\n\n        <div class=\"invalid info\"\n             ng-mouseover=\"showTooltip = true\"\n             ng-mouseleave=\"showTooltip = false\" style=\"display:none;\">\n            <div class=\"glyphicon\"></div>\n            <div class=\"block-text-err\" ng-if=\"showTooltip\">\n                <i></i>\n                <p translate=\"cw.deploy.sms.info\"></p>\n                <em></em>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "poBF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ExpiredLicensesProcessor = exports.AppPricesProcessor = exports.ActivationCodesProcessor = exports.LicensesProcessor = exports.IssuesProcessor = exports.DevicesProcessor = exports.AppIntegrationsInactiveProcessor = exports.AppInstancesProcessor = exports.AppIntegrationsProcessor = undefined;

var _RFC = __webpack_require__("/+00");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("vtkU");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("CYsp");

var _RFC6 = _interopRequireDefault(_RFC5);

var _RFC7 = __webpack_require__("L91C");

var _RFC8 = _interopRequireDefault(_RFC7);

var _RFC9 = __webpack_require__("khiU");

var _RFC10 = _interopRequireDefault(_RFC9);

var _RFC11 = __webpack_require__("MCvD");

var _RFC12 = _interopRequireDefault(_RFC11);

var _RFC13 = __webpack_require__("j2Hg");

var _RFC14 = _interopRequireDefault(_RFC13);

var _RFC15 = __webpack_require__("POGy");

var _RFC16 = _interopRequireDefault(_RFC15);

var _RFC17 = __webpack_require__("+Vki");

var _RFC18 = _interopRequireDefault(_RFC17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AppIntegrationsProcessor = _RFC2.default;
exports.AppInstancesProcessor = _RFC4.default;
exports.AppIntegrationsInactiveProcessor = _RFC6.default;
exports.DevicesProcessor = _RFC8.default;
exports.IssuesProcessor = _RFC10.default;
exports.LicensesProcessor = _RFC12.default;
exports.ActivationCodesProcessor = _RFC14.default;
exports.AppPricesProcessor = _RFC16.default;
exports.ExpiredLicensesProcessor = _RFC18.default; /* eslint import/prefer-default-export: 0 */

/***/ }),

/***/ "prWK":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email\">\n    <div class=\"autoInstall_modal content-wrapper\">\n        <div class=\"mb20\">\n            <i class=\"icon icon-avira-logo\"></i>\n        </div>\n\n        <h3 class=\"text-xxl2 font-bold mb40 text-grey-2 download-title\" translate=\"cw.deploy.done.final_step.title\"></h3>\n\n        <div class=\"mb20\">\n            <p class=\"text-grey-3 download-subtitle\" translate=\"cw.deploy.done.final_step.desc\"></p>\n        </div>\n        <div class=\"download-progress mb20\">\n            <div class=\"download-step inline-block finished-step-1 \">\n                <i class=\"icon icon-Cloudlarge\"></i>\n                <p class=\"download-step-text\" translate=\"cw.general.ui.download\"></p>\n            </div>\n            <div class=\"download-dot download-dot-step-1 inline-block\"\n                ng-class=\"{'loading-dots':!isStep2Finished}\">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n            <div class=\"download-step inline-block\"\n                ng-class=\"{'finished-step-2': isStep2Finished}\">\n                <i class=\"icon icon-Folder\"></i>\n                <p class=\"download-step-text\" translate=\"cw.deploy.done.final_step.open\"></p>\n            </div>\n            <div class=\"download-dot download-dot-step-2 inline-block\"\n                ng-class=\"{'loading-dots':isStep2Finished}\">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n            <div class=\"download-step inline-block\"\n                ng-class=\"{'finished-step-3': isStep3Finished}\">\n                <i class=\"icon icon-Cog\"></i>\n                <p class=\"download-step-text\" translate=\"cw.general.install\"></p>\n            </div>\n        </div>\n        <div>\n            <p class=\"text-m text-grey-3 ng-scope\" translate=\"cw.deploy.done.final_step.download_link\"></p>\n            <a id=\"deployActionDownload\" class=\"text-m try-again-link\" translate=\"cw.deploy.done.final_step.try_again\"></a>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),

/***/ "q8ap":
/***/ (function(module, exports) {

module.exports = "<div>\n\t<div class=\"mya-section-info\">\n\t\t<div class=\"text-xxl text-grey-2 mb10\" translate=\"cw.my_account.delete_account.title\"></div>\n\t\t<div class=\"text-m mt5 mb10 text-grey-3\" translate=\"cw.my_account.delete_account.desc\" translate-values=\"{brandname : brandName}\"></div>\n\t\t<a class=\"text-l crs-pointer text-red-2\" ng-click=\"deleteAccountCtrl.deleteAccount()\" translate=\"cw.my_account.delete_account.btn\"></a>\n\t</div>\n</div>\n\n"

/***/ }),

/***/ "qACu":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("1zte");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "qGAt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint func-names: 0 */
angular.module('controllers').controller('TrialCard', ['$scope', '$state', '$stateParams', '$window', '$location', 'Util', 'LicenseRestService', 'DeployRestService', function ($scope, $state, $stateParams, $window, $location, Util, LicenseRestService, DeployRestService) {

    var queryParams = $location.search();

    $scope.showFirstScreen = true;
    $scope.loadingButton = false;
    $scope.trialDeploySuccess = false;
    $scope.appId = queryParams.appId || $stateParams.resourceId;

    var windowsDevices = _index.DevicesRepository.getDevicesByOs('windows');

    $scope.hasWindowsDevice = windowsDevices.length > 0;

    $scope.app = _index.AppIntegrationsRepository.getById($scope.appId);
    $scope.brandName = CWCONFIG.partnerConfig.name;
    $scope.product = _index.AppIntegrationsRepository.getAppName('aps10');

    $scope.close = function (newState) {

        var currentState = void 0;
        if (!newState) {

            currentState = $state.current.name;
            newState = currentState.substr(0, currentState.indexOf('.ltb'));
        }
        $state.go(newState);
    };

    if ($stateParams.modal) {

        $stateParams.modal.result.then(function () {}, function () {

            $scope.close();
        });
    }

    $scope.init = function () {

        // redirect to dashboard if the service is not active
        if (!$scope.app) {

            $scope.close();
            return;
        }

        _RFC2.default.send('ConnectWeb Modal Open ', {
            Modal: 'Prime Trial',
            Page: Util.getPageName()
        });
    };

    /**
     * If the user has windows devices, deploy the Trial app on all the devices,
     * otherwise, download the kit
     */
    var deployTrialApp = function deployTrialApp(license) {

        // deploy on all windows devices
        if ($scope.hasWindowsDevice) {

            windowsDevices.forEach(function (device) {

                var deploymentPayload = {
                    deviceId: device.id,
                    userId: Util.deepFind(device, 'relationships.user.data.id'),
                    appId: $scope.appId
                };

                DeployRestService.deployOnDevice(deploymentPayload).then(function () {}).then(null, function (e) {

                    // 409 === Conflict
                    // An instance for this application already exists (pending) - ignore
                    if (e.status === 409) {

                        return;
                    }

                    _RFC4.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {

                            cssClasses: 'icon-' + Util.deepFind(device, 'attributes.type')

                        }

                    });
                });
            });
        } else {

            // no windows devices, download kit

            // check whether we can deploy the product on the current device
            var matchingOS = _index2.DevicesProcessor.getDeployOSfor($scope.appId, window.deviceOs) || null;
            var hasMatchingOS = !!matchingOS;

            var stateName = $state.current.name;

            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';
            }

            $state.go(stateName, {
                ltb: 'deploy',
                resourceId: license.data.data.id,
                appId: $scope.appId,
                deviceId: 'new',
                os: matchingOS,
                autoInstall: hasMatchingOS
            }, {
                reload: false
            });
        }
    };

    /**
     * Create a Trial license for the user.
     * If successful, deploy/download the trial app to the user
     */
    $scope.activateTrial = function () {

        $scope.loadingButton = true;

        _RFC2.default.send('ConnectWeb Install Click', {
            Page: 'Trial Modal'
        });

        var licensePayload = {
            data: {
                relationships: {
                    app: {
                        data: {
                            type: 'apps',
                            id: $scope.appId
                        }
                    }
                }
            },
            meta: {
                cmp: CWCONFIG.features.trialModal.campaignId
            }
        };

        LicenseRestService.create(licensePayload).then(function (response) {

            $scope.loadingButton = false;
            $scope.trialDeploySuccess = true;

            deployTrialApp(response);
        }).then(null, function (error) {

            $scope.loadingButton = false;

            var errorCode = false;

            if (error.data.errors && error.data.errors[0]) {

                errorCode = error.data.errors[0].code;
            }

            $scope.activationStatus = 'serverError';
            $scope.serverErrorTranslate = '';
            $scope.loadingButton = false;

            switch (errorCode) {

                case '21224':
                    // activation code was not found

                    Util.triggerAnimation('.error', 'animated shake');
                    $scope.serverErrorTranslate = 'cw.subscription.error.status_code_not_found';
                    break;

                case '21223': // activation code invalid
                case '21246':
                    // code not found in database

                    Util.triggerAnimation('.error', 'animated shake');
                    $scope.serverErrorTranslate = 'cw.subscription.error.status_code_invalid';
                    break;

                case '21236':
                    // activation code already used

                    Util.triggerAnimation('.error', 'animated shake');
                    $scope.serverErrorTranslate = 'cw.subscription.error.status_code_already_used';
                    break;

                case '21225':
                    // activation code expired

                    Util.triggerAnimation('.error', 'animated shake');
                    $scope.serverErrorTranslate = 'cw.subscription.error.status_code_expired';
                    break;

                case '21241':
                    // maximum users for activation code

                    Util.triggerAnimation('.error', 'animated shake');
                    $scope.serverErrorTranslate = 'cw.subscription.error.max_users_reached';
                    break;

                default:

                    _RFC4.default.error('cw.notification.system.error');
                    $scope.serverErrorTranslate = undefined;

            }
        });
    };

    /**
     * Redirect to subscriptions page
     */
    $scope.goToSubscriptions = function () {

        $state.go('root.dashboard.subscriptions', {
            tab: 'plans'
        });
    };

    $scope.init();
}]);

/***/ }),

/***/ "qJJc":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("1WNX"),
    getSymbols = __webpack_require__("WfqQ"),
    keys = __webpack_require__("d+Uu");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "qj7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * One Click Payment Product Comparison
 */

/* eslint max-len: 0 */
angular.module('controllers').controller('OcpComparison', ['$scope', '$state', 'Util', '$rootScope', function ($scope, $state, Util, $rootScope) {

    var activationCodes = _index.ActivationCodesRepository.getAll();
    var currentUserAppId = activationCodes[0].attributes.app;
    var recommendationAppFeatures = {};
    $scope.recommendationDetails = _index.RecommendationsRepository.getAll() || [];
    $scope.recommendedApp = _index.AppIntegrationsRepository.getById($state.params.resourceId) || {};
    $scope.currentUserApp = _index.AppIntegrationsRepository.getById(currentUserAppId) || {};
    $scope.resourceId = $state.params.resourceId;
    $scope.language = CWCONFIG.language === 'de' ? 'de' : null;

    recommendationAppFeatures[$state.params.resourceId] = Util.deepFind($scope.recommendedApp, 'attributes.resource.comparisonFeatures');

    recommendationAppFeatures[currentUserAppId] = Util.deepFind($scope.currentUserApp, 'attributes.resource.comparisonFeatures');

    /**
     * Reorder recommended app features that match the users' current app to be first (top in comparison chart)
     */
    recommendationAppFeatures[currentUserAppId].forEach(function (feature) {

        var featurePos = recommendationAppFeatures[$state.params.resourceId].indexOf(feature);

        if (featurePos > -1) {

            // remove feature from current position and add it to the beginning of the array
            recommendationAppFeatures[$state.params.resourceId].splice(featurePos, 1);
            recommendationAppFeatures[$state.params.resourceId].unshift(feature);
        }
    });

    $scope.closeModal = function () {

        Util.closeModal();
    };

    $scope.checkFeature = function (newFeature) {
        return recommendationAppFeatures[currentUserAppId].find(function (currentFeature) {
            return newFeature === currentFeature;
        });
    };
    $scope.recommendationAppFeatures = recommendationAppFeatures;

    $scope.upgradeNow = function () {

        var stateName = $state.current.name;
        var ltbName = 'one-click-payment';
        var subsource = void 0;
        var promotion = void 0;

        if (stateName.indexOf('.ltb') === -1) {

            stateName += '.ltb';
        }
        var recomendationAcronym = Util.deepFind($scope.recommendationDetails[0], 'attributes.acronym');
        if ($rootScope.hasValidPayment === false || recomendationAcronym !== $scope.resourceId || $scope.recommendationDetails.length === 0) {

            stateName += '.banner';
            ltbName = 'payment-cart';
            subsource = 'banner';
            promotion = true;
        }

        var recomendationId = $scope.recommendationDetails.length > 0 ? $scope.recommendationDetails[0].id : '';
        var productId = $scope.recommendedApp ? $scope.recommendedApp.id : '';
        var mixpanelDetails = {
            Modal: 'OCP Comparison Chart',
            'Button Label': 'Upgrade',
            Product: $scope.recommendedApp.attributes.name,
            'Product ID': productId,
            'Recommendation ID': recomendationId,
            Page: Util.getPageName()
        };

        _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

        // open modal
        $state.go(stateName, {
            ltb: ltbName,
            resourceId: $scope.recommendedApp.id,
            subsource: subsource,
            promotion: promotion
        }, {
            reload: false
        });
    };
}]);

/***/ }),

/***/ "qubf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppPricesRestService
 *
 * @description
 * This class contains methods used to retrieve information about product prices
 * using http requests.
 */

var AppPricesRestService = function (_BaseRestService) {
    _inherits(AppPricesRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function AppPricesRestService($http, $q, Util) {
        _classCallCheck(this, AppPricesRestService);

        return _possibleConstructorReturn(this, (AppPricesRestService.__proto__ || Object.getPrototypeOf(AppPricesRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.AppPricesRestService#getByAppId
    * @methodOf rest.services.AppPricesRestService
    * @function
    *
    * @description
    * Retrieves product prices.
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(AppPricesRestService, [{
        key: 'getByAppId',
        value: function getByAppId(appId) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId);
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getByAppIdAndCurrency
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves product prices with specified currency.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndCurrency',
        value: function getByAppIdAndCurrency(appId, currency) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + (currency ? '&filter[currency]=' + currency : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getByAppIdAndRuntime
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves product prices for a specific runtime.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndRuntime',
        value: function getByAppIdAndRuntime(appId, runtime) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + '&filter[runtimes]=' + runtime);
        }
    }, {
        key: 'getByAppIdAndRuntimeAndNumberOfUsers',
        value: function getByAppIdAndRuntimeAndNumberOfUsers(appId, runtime, numberOfUsers) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + '&filter[runtimes]=' + runtime + '&filter[users]=' + numberOfUsers);
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getByAppIdAndRuntimeAndCurrency
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves product prices for a specific runtime with specified currency.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndRuntimeAndCurrency',
        value: function getByAppIdAndRuntimeAndCurrency(appId, runtime, currency) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + '&filter[runtimes]=' + runtime + (currency ? '&filter[currency]=' + currency : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getByAppIdAndNumberOfUsers
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves product prices based on users.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndNumberOfUsers',
        value: function getByAppIdAndNumberOfUsers(appId, numberOfUsers) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + '&filter[users]=' + numberOfUsers);
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getByAppIdAndNumberOfUsersAndRuntime
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves product prices based on users.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndNumberOfUsersAndRuntime',
        value: function getByAppIdAndNumberOfUsersAndRuntime(appId, numberOfUsers, runtime, currency) {

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + appId + '&filter[users]=' + numberOfUsers + '&filter[runtimes]=' + runtime + (currency ? '&filter[currency]=' + currency : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.AppPricesRestService#getAllAsync
        * @methodOf rest.services.AppPricesRestService
        * @function
        *
        * @description
        * Retrieves all product prices defined in config.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getAllAsync',
        value: function getAllAsync() {

            var productsArr = CWCONFIG.store.products;
            var businessProductsArr = CWCONFIG.store.businessProducts;
            var bundlesArr = CWCONFIG.store.bundles;
            var productsList = productsArr.join() + ',' + bundlesArr.join() + ',' + businessProductsArr.join() + ',aps20,aps50,adwp1,ispm0';

            return _get(AppPricesRestService.prototype.__proto__ || Object.getPrototypeOf(AppPricesRestService.prototype), 'getAllAsync', this).call(this, 'app-prices/?filter[apps]=' + productsList + '&filter[users]=1,3,5,25&filter[runtimes]=1,12,24,36');
        }
    }]);

    return AppPricesRestService;
}(_baseRestService2.default);

exports.default = AppPricesRestService;


_serviceDependencies.push(AppPricesRestService);

angular.module('rest.services').service('AppPricesRestService', _serviceDependencies);

/***/ }),

/***/ "qzsh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-nested-ternary: 0 */
/* eslint no-extra-boolean-cast: 0 */

angular.module('directives').directive('serviceScroll', ['$parse', '$window', function ($parse, $window) {
    return {
        template: '<div><div class="ngsb-wrap">' + '<div class="ngsb-container" ng-transclude></div>' + '<div class="ngsb-scrollbar" style="position: absolute; display: block;"' + 'ng-show="showYScrollbar"><div class="ngsb-thumb-container">' + '<div class="ngsb-thumb-pos" oncontextmenu="return false;">' + '<div class="ngsb-thumb" ></div></div><div class="ngsb-track"></div>' + '</div></div></div></div>',
        restrict: 'A',
        transclude: true,
        replace: true,

        link: function link(scope, element, attrs) {

            var mainElm = void 0;
            var transculdedContainer = void 0;
            var tools = void 0;
            var thumb = void 0;
            var thumbLine = void 0;
            var track = void 0;
            var flags = { bottom: Object.prototype.hasOwnProperty.call(attrs, 'bottom') };
            var win = angular.element($window);
            var dragger = { top: 0 };
            var page = { top: 0 };
            var scrollboxStyle = void 0;
            var draggerStyle = void 0;
            var draggerLineStyle = void 0;
            var pageStyle = void 0;
            var calcStyles = function calcStyles() {

                scrollboxStyle = {
                    position: 'relative',
                    overflow: 'hidden',
                    'max-width': '100%',
                    height: '100%'
                };
                if (page.height) {

                    scrollboxStyle.height = page.height + 'px';
                }
                draggerStyle = {
                    position: 'absolute',
                    height: dragger.height + 'px',
                    top: dragger.top + 'px'
                };
                draggerLineStyle = {
                    position: 'relative',
                    'line-height': dragger.height + 'px'
                };
                pageStyle = {
                    position: 'relative',
                    top: 0 + 'px',
                    overflow: 'hidden'
                };
            };

            var redraw = function redraw() {

                var draggerOffset = dragger.top / page.height;
                thumb.css('top', dragger.top + 'px');
                page.top = -Math.round(page.scrollHeight * draggerOffset);
                angular.element(transculdedContainer.children()[1]).css('top', page.top + 'px');
            };
            var trackClick = function trackClick(event) {

                var offsetY = Object.prototype.hasOwnProperty.call(event, 'offsetY') ? event.offsetY : event.layerY;
                var newTop = Math.max(0, Math.min(parseInt(dragger.trackHeight, 10) - parseInt(dragger.height, 10), offsetY));
                dragger.top = newTop;
                redraw();
                event.stopPropagation();
            };
            var wheelHandler = function wheelHandler(event) {

                var wheelDivider = 20;
                var deltaY = event.wheelDeltaY !== undefined ? event.wheelDeltaY / wheelDivider : event.wheelDelta !== undefined ? event.wheelDelta / wheelDivider : -event.detail * (wheelDivider / 10);

                dragger.top = Math.max(0, Math.min(parseInt(page.height, 10) - parseInt(dragger.height, 10), parseInt(dragger.top, 10) - deltaY));
                redraw();
                if (!!event.preventDefault) {

                    event.preventDefault();
                }
            };
            var lastOffsetY = void 0;
            var thumbDrag = function thumbDrag(event, offsetX, offsetY) {

                dragger.top = Math.max(0, Math.min(parseInt(dragger.trackHeight, 10) - parseInt(dragger.height, 10), offsetY));
                event.stopPropagation();
            };
            var dragHandler = function dragHandler(event) {

                var newOffsetY = event.pageY - thumb[0].scrollTop - lastOffsetY;
                var newOffsetX = 0;
                thumbDrag(event, newOffsetX, newOffsetY);
                redraw();
            };

            var buildScrollbar = function buildScrollbar(rollToBottom) {

                var wheelEvent = win[0].onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';

                rollToBottom = flags.bottom || rollToBottom;
                mainElm = angular.element(element.children()[0]);
                transculdedContainer = angular.element(mainElm.children()[0]);
                tools = angular.element(mainElm.children()[1]);
                thumb = angular.element(angular.element(tools.children()[0]).children()[0]);
                thumbLine = angular.element(thumb.children()[0]);
                track = angular.element(angular.element(tools.children()[0]).children()[1]);
                page.height = element[0].offsetHeight;
                page.scrollHeight = transculdedContainer[0].offsetHeight;

                if (page.height < page.scrollHeight) {

                    scope.showYScrollbar = true;
                    dragger.height = Math.round(page.height / page.scrollHeight * page.height);
                    dragger.trackHeight = page.height;
                    calcStyles();
                    element.css({ overflow: 'hidden' });
                    mainElm.css(scrollboxStyle);
                    transculdedContainer.css(pageStyle);
                    thumb.css(draggerStyle);
                    thumbLine.css(draggerLineStyle);
                    track.bind('click', trackClick);
                    transculdedContainer[0].addEventListener(wheelEvent, wheelHandler, false);
                    thumb.on('mousedown', function (event) {

                        lastOffsetY = event.pageY - thumb[0].offsetTop;
                        win.on('mouseup', function () {

                            win.off('mousemove', dragHandler);
                            event.stopPropagation();
                        });
                        win.on('mousemove', dragHandler);
                        event.preventDefault();
                    });
                    if (rollToBottom) {

                        flags.bottom = false;
                        dragger.top = parseInt(page.height, 10) - parseInt(dragger.height, 10);
                    } else {

                        dragger.top = Math.max(0, Math.min(parseInt(page.height, 10) - parseInt(dragger.height, 10), parseInt(dragger.top, 10)));
                    }
                    redraw();
                } else {

                    scope.showYScrollbar = false;
                    thumb.off('mousedown');
                    transculdedContainer[0].removeEventListener(wheelEvent, wheelHandler, false);
                    transculdedContainer.attr('style', 'position:relative;top:0');
                    mainElm.css({ height: '100%' });
                }
            };

            var rebuildTimer = void 0;
            var rebuild = function rebuild(e, data) {

                var rollToBottom = !!data && !!data.rollToBottom;
                if (rebuildTimer !== null) {

                    clearTimeout(rebuildTimer);
                }

                rebuildTimer = setTimeout(function () {

                    page.height = null;
                    buildScrollbar(rollToBottom);
                    if (!scope.$$phase) {

                        scope.$digest();
                    }
                }, 72);
            };

            // load scrollbar on window ready
            scope.$watch(function () {

                if (!angular.element(document).find('html').hasClass('ie8')) {

                    buildScrollbar();
                }
            });

            if (!!attrs.rebuildOn) {

                attrs.rebuildOn.split(' ').forEach(function (eventName) {

                    scope.$on(eventName, rebuild);
                });
            }
            if (Object.prototype.hasOwnProperty.call(attrs, 'rebuildOnResize')) {

                win.on('resize', rebuild);
            }
        }
    };
}]);

/***/ }),

/***/ "r1rA":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("S8m2"),
    getRawTag = __webpack_require__("jnYZ"),
    objectToString = __webpack_require__("C0bq");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "rCgA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

var _index = __webpack_require__("lSlM");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Listen events for App Instances Model
 */
angular.module('listeners').service('AppInstancesListener', function () {

    _RFC2.default.subscribe('socket:app-instances', function (response) {

        if (response.verb === 'POST') {

            _index.AppInstancesRepository.add(response.payload.data);
        }

        if (response.verb === 'PUT') {

            _index.AppInstancesRepository.update(response.payload.data);
        }

        if (response.verb === 'DELETE') {

            _index.AppInstancesRepository.remove(response.payload.data.id);
        }
    });
});

/***/ }),

/***/ "rH1J":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "rHek":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Subscription activation confirmation controller
 * Handles activation status (unused -> used).
 */

angular.module('controllers').controller('ActivationConfirmation', ['$scope', '$window', '$stateParams', 'Util', 'ActivationCodeRestService', 'LicenseRestService', function ($scope, $window, $stateParams, Util, ActivationCodeRestService, LicenseRestService) {

    var activationCodeId = $stateParams.resourceId;
    var activationCode = _index.ActivationCodesRepository.getById(activationCodeId);

    var fetchActivationCodeOf = function fetchActivationCodeOf(license) {

        var activationCodeNr = Util.deepFind(license, 'relationships.activation-code.data.id');

        if (activationCodeNr) {

            ActivationCodeRestService.getById(activationCodeNr).then(function (response) {

                var responseData = Util.deepFind(response, 'data.data');
                _index.ActivationCodesRepository.addOrUpdate(responseData);
            }).then(null, function () {

                _RFC2.default.error('cw.general.ui.error');
            });
        }
    };

    $scope.appIntegration = _index.AppIntegrationsRepository.getById(activationCode.relationships.app.data.id);

    $scope.cancel = function () {

        Util.closeModal();
    };

    $scope.confirm = function () {

        var licensePayload = {
            data: {
                type: 'licenses',
                relationships: {
                    'activation-code': {
                        data: { type: 'activation-codes', id: activationCodeId }
                    },
                    provider: {
                        data: { type: 'providers', id: $window.appName }
                    }
                }
            }
        };

        _RFC4.default.send('ConnectWeb Activate Click', {
            Page: 'Subscriptions',
            Product: $scope.appIntegration.attributes.resource.oeName,
            'Product ID': activationCode.relationships.app.data.id
        });

        LicenseRestService.create(licensePayload).then(function (response) {

            Util.closeModal();
            fetchActivationCodeOf(Util.deepFind(response, 'data.data'));
        }).then(null, function (error) {

            var errorCode = error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

            Util.closeModal();

            switch (errorCode) {

                case '21224':
                    // activation code was not found

                    _RFC2.default.error('cw.subscription.error.status_code_not_found');
                    break;

                case '21223':
                    // activation code invalid

                    _RFC2.default.error('cw.subscription.error.status_code_invalid');
                    break;

                case '21236':
                    // activation code already used

                    _RFC2.default.error('cw.subscription.error.status_code_already_used');
                    break;

                case '21225':
                    // activation code expired

                    _RFC2.default.error('cw.subscription.error.status_code_expired');
                    break;

                case '21241':
                    // maximum users for activation code

                    _RFC2.default.error('cw.subscription.error.max_users_reached');
                    break;

                default:

                    _RFC2.default.error('cw.notification.system.error');

            }
        });
    };
}]);

/***/ }),

/***/ "rIec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['$scope', 'Util', 'DeployRestService'];

var OfflineDeploymentController = function () {
    function OfflineDeploymentController($scope, Util, DeployRestService) {
        _classCallCheck(this, OfflineDeploymentController);

        this.$scope = $scope;
        this.Util = Util;
        this.DevicesRepository = _index.DevicesRepository;
        this.DeployRestService = DeployRestService;

        this.cdnUrl = CWCONFIG.cdn;
        this.randomNumber = Math.floor(Math.random() * 1000 + 1);

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();
        } else {

            this._deploy();
        }
    }

    _createClass(OfflineDeploymentController, [{
        key: '_deploy',
        value: function _deploy() {
            var _this = this;

            this.deploying = true;
            var device = this.DevicesRepository.getById(this.$scope.inputData.deviceId);
            var deploymentPayload = {
                deviceId: device.id,
                userId: this.Util.deepFind(device, 'relationships.user.data.id'),
                appId: this.app.id
            };

            this.DeployRestService.deployOnDevice(deploymentPayload).then(function () {

                _this.deploying = false;
                _this.$scope.deployOnDeviceSuccess()(device, _this.app.id, {});
            }).then(null, function (e) {

                // 409 === Conflict
                // An instance for this application already exists (pending)
                // Do not hide the modal
                if (e.status === 409) {

                    _this.deploying = false;
                    return;
                }

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-' + _this.Util.deepFind(device, 'attributes.type')
                    }
                });
                _this.Util.closeModal();
            });
        }
    }, {
        key: 'close',
        value: function close() {

            this.Util.closeModal();
        }
    }]);

    return OfflineDeploymentController;
}();

var OfflineDeploymentDirective = function OfflineDeploymentDirective() {
    _classCallCheck(this, OfflineDeploymentDirective);

    this.template = __webpack_require__("yEuq");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, Util, DeployRestService) {
        return new OfflineDeploymentController($scope, Util, DeployRestService);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'OfflineDeploymentCtrl';
};

_directiveDependencies.push(function () {
    return new OfflineDeploymentDirective();
});

angular.module('directives').directive('offlineDeployment', _directiveDependencies);

/***/ }),

/***/ "rPHv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['Util'];

var PhoneEmailDeploymentSuccessController = function () {
    function PhoneEmailDeploymentSuccessController(Util) {
        _classCallCheck(this, PhoneEmailDeploymentSuccessController);

        this.Util = Util;
    }

    _createClass(PhoneEmailDeploymentSuccessController, [{
        key: 'close',
        value: function close() {

            this.Util.closeModal();
        }
    }]);

    return PhoneEmailDeploymentSuccessController;
}();

var PhoneEmailDeploymentSuccessDirective = function PhoneEmailDeploymentSuccessDirective() {
    _classCallCheck(this, PhoneEmailDeploymentSuccessDirective);

    this.template = __webpack_require__("yKT5");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (Util) {
        return new PhoneEmailDeploymentSuccessController(Util);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'PhoneEmailDeploymentSuccessCtrl';
};

_directiveDependencies.push(function () {
    return new PhoneEmailDeploymentSuccessDirective();
});

angular.module('directives').directive('phoneEmailDeploymentSuccess', _directiveDependencies);

/***/ }),

/***/ "rZS/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AlertSearchRestService
 *
 * @description
 * This class contains methods used to manage information about activation codes
 * using http requests.
 */

var AlertSearchRestService = function (_BaseRestService) {
    _inherits(AlertSearchRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function AlertSearchRestService($http, $q, Util) {
        _classCallCheck(this, AlertSearchRestService);

        return _possibleConstructorReturn(this, (AlertSearchRestService.__proto__ || Object.getPrototypeOf(AlertSearchRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.AlertSearchRestService#getById
    * @methodOf rest.services.AlertSearchRestService
    * @function
    *
    * @description
    * Retrieves activation-code.
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(AlertSearchRestService, [{
        key: 'getByEmail',
        value: function getByEmail(email, lang) {

            return _get(AlertSearchRestService.prototype.__proto__ || Object.getPrototypeOf(AlertSearchRestService.prototype), 'getAllAsync', this).call(this, 'alert-search?filter[emails]=' + email + '&filter[language]=' + lang);
        }
    }]);

    return AlertSearchRestService;
}(_baseRestService2.default);

exports.default = AlertSearchRestService;


_serviceDependencies.push(AlertSearchRestService);

angular.module('rest.services').service('AlertSearchRestService', _serviceDependencies);

/***/ }),

/***/ "rkCg":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"fancy-checkbox\" ng-class=\"{'fancy-checkbox-active': twoStepValidationCheckbox}\">\n\n    <div class=\"checkbox-wrap\">\n        <div class=\"checkbox-track\"></div>\n        <div class=\"checkbox-drag\"></div>\n    </div>\n    <span class=\"label label-on\" translate=\"cw.label_on\"></span>\n    <span class=\"label label-off\" translate=\"cw.label_off\"></span>\n</div>\n"

/***/ }),

/***/ "rqSe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$scope', '$state', 'Util', 'Auth', 'OAuthRestService', 'GdprActionsRestService'];

var _$rootScope = void 0;
var _$scope = void 0;
var _Util = void 0;
var _Auth = void 0;
var _User = void 0;
var _OAuthRestService = void 0;
var _oauthPayload = {};
var _verifyIdentity = void 0;
var _formIsValid = null;
var _$state = void 0;

/**
 * @ngdoc service
 * @name controllers.PasswordConfirmationModal
 *
 * @description
 * Crop Image controller
 */

var PasswordConfirmationModal = function () {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} Recaptcha
     * @param  {any} OAuthRestService
     */
    function PasswordConfirmationModal($rootScope, $scope, $state, Util, Auth, OAuthRestService) {
        _classCallCheck(this, PasswordConfirmationModal);

        _Util = Util;
        _Auth = Auth;
        _OAuthRestService = OAuthRestService;
        _User = _index.MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;
        _verifyIdentity = this.verifyIdentity;
        _$state = $state;

        // functions
        _$scope.nextModal = this.nextModal;
        _$scope.closeModal = this.closeModal;
        _$scope.onSubmit = this.onSubmit;
        _$scope.setEmail = this.setEmail;
        _$scope.setCaptchaResponse = this.setCaptchaResponse;

        // variables
        _$scope.captchaRequired = false;
        _$scope.authError = false;
        _$scope.loading = false;
        _$scope.loadingConfirm = false;
        _$scope.failedLogins = 0;
        _$scope.Recaptcha = _recaptcha2.default;
        _$scope.modalStylingClasses = {};
        _$scope.Auth = Auth;

        if (_$rootScope.passwordComnfirmationFor === 'delete-account-confirmation') {

            _$scope.modalStylingClasses = {
                titleColor: 'text-grey-2 mb30',
                titleKey: 'cw.validator.password.error.enter_password',
                btnColor: ''
            };
        }
    }

    _createClass(PasswordConfirmationModal, [{
        key: 'nextModal',
        value: function nextModal() {

            _$state.go('root.dashboard.my-account.ltb', {
                ltb: _$rootScope.passwordComnfirmationFor
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {

            _Util.closeModal();
        }
    }, {
        key: 'verifyIdentity',
        value: function verifyIdentity() {
            var _this = this;

            _$scope.submitted = true;

            _oauthPayload = {
                grant_type: 'password',
                username: _User.attributes.email,
                password: this.verifyIdentityForm.password.$viewValue
            };

            var headers = {
                Authorization: 'Basic ' + _Util.base64encode(CWCONFIG.oauthKey)
            };

            var captchaRespose = _$scope.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            var deviceToken = _Auth.getDeviceToken();
            if (deviceToken) {

                _oauthPayload.device_token = deviceToken;
            }

            /* if captcha is required and there is no captcha response available,
                   trigger alert and stop login process */
            if (_$scope.captchaRequired && !_$scope.captchaRespose) {

                _Util.triggerAnimation('#error-message-captcha', 'animated shake');
                return;
            }

            if (_formIsValid) {

                _$scope.loading = true;

                _OAuthRestService.post(_oauthPayload, headers).then(function () {

                    _$scope.nextModal();
                    _$scope.loading = false;
                    _$scope.failedLogins = 0;
                    _$scope.Recaptcha.disableCaptcha();
                    _$rootScope.kp = _this.verifyIdentityForm.password.$viewValue;
                }).then(null, function (error) {

                    var responseError = _Util.deepFind(error, 'data.error');
                    _$scope.loading = false;
                    _$scope.failedLogins += 1;

                    switch (responseError) {

                        case 'invalid_credentials':

                            _$scope.authError = true;

                            _Util.triggerAnimation('#error-message-form', 'animated shake');

                            // check error header for captcha required

                            if (error.headers('X-Avira-Captcha') === 'required') {

                                _$scope.Recaptcha.enableCaptcha();
                            }

                            break;

                        case 'required_captcha':

                            _$scope.Recaptcha.execute();
                            break;

                        case 'retries_exceeded':

                            _RFC2.default.error('cw.auth.tfa.error.retries_exceeded');
                            break;

                        case 'invalid_otp':

                            _$scope.nextModal();
                            _$rootScope.kp = _this.verifyIdentityForm.password.$viewValue;

                            break;

                        default:

                            _RFC2.default.error('cw.notification.system.error');

                    }
                });
            } else {

                _Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            _formIsValid = this.verifyIdentityForm.$valid;

            if (_$scope.Recaptcha.captchaRetries <= _$scope.failedLogins) {

                _$scope.Recaptcha.enableCaptcha();
            }

            if (_$scope.Recaptcha.isCaptchaRequired()) {

                _$scope.Recaptcha.execute();
            } else {

                _formIsValid = this.verifyIdentityForm.$valid;
                var _verifyIdentityBind = _verifyIdentity.bind(this);
                _verifyIdentityBind();
            }
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            _formIsValid = this.verifyIdentityForm.$valid;
            _$scope.Recaptcha.setCaptchaResponse(response);
            var _verifyIdentityBind = _verifyIdentity.bind(this);
            _verifyIdentityBind();
        }
    }, {
        key: 'setEmail',
        value: function setEmail() {

            _$rootScope.forgotEmail = _User.attributes.email;
        }
    }]);

    return PasswordConfirmationModal;
}();

_serviceDependencies.push(PasswordConfirmationModal);

angular.module('controllers').controller('PasswordConfirmationModal', _serviceDependencies);

/***/ }),

/***/ "s0mi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state', '$scope', '$window'];

var NewsTabsController = function NewsTabsController($state, $scope, $window) {
    _classCallCheck(this, NewsTabsController);

    var currentPath = $state.current.name;
    var threatsLandscapeRoute = void 0;

    var browser = $window.browserName.toLowerCase() + $window.browserVersion;

    if (browser !== 'ie11') {

        $scope.showThreatsTab = true;
    }

    if (currentPath.indexOf('.news') > -1) {

        threatsLandscapeRoute = 'root.dashboard.news.ltb';
    } else {

        threatsLandscapeRoute = 'root.dashboard.article.ltb';
    }
    $scope.openThreatsLandscape = function () {

        $state.go(threatsLandscapeRoute, {
            resourceId: 'news-lightbox',
            ltb: 'threats-landscape'
        });
    };
};

var NewsTabsDirective = function NewsTabsDirective() {
    _classCallCheck(this, NewsTabsDirective);

    this.template = __webpack_require__("enUf");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state, $scope, $window) {
        return new NewsTabsController($state, $scope, $window);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'newsTabsCtrl';
};

_directiveDependencies.push(function () {
    return new NewsTabsDirective();
});

angular.module('directives').directive('newsTabs', _directiveDependencies);

/***/ }),

/***/ "s42q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable max-len */
/* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmInsuranceCards = function DwmInsuranceCards($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmInsuranceCards);

    $scope.insuranceAccountNameIsValid = true;
    $scope.insuranceAccountNumberIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};

        if (assets.primaryMember) {

            $scope.insuranceCards = assets.primaryMember.monitoredAccounts.insuranceCards;
            $scope.insuranceCards.entries.forEach(function (entry) {

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('.update-insurance-account-name').trigger('focus');
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.insuranceAccountNameIsValid = true;
        $scope.insuranceAccountNumberIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newInsuranceAccountName = '';
        $scope.newInsuranceAccountNumber = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.insuranceCards.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                $scope.updateEntryPayload = entry;

                // Save initial entry values to use in case of update is canceled
                $scope.initialInsuranceAccountName = entry.providerName;
                $scope.initialInsuranceAccountNumber = entry.policyNumber;
                $scope.initialEntryIndex = loopIndex;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-insurance-account-name').trigger('focus');
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.insuranceAccountNameIsValid = true;
        $scope.insuranceAccountNumberIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.insuranceCards.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};

        // Revert changes of the selected entry
        $scope.insuranceCards.entries[$scope.initialEntryIndex].providerName = $scope.initialInsuranceAccountName;
        $scope.insuranceCards.entries[$scope.initialEntryIndex].policyNumber = $scope.initialInsuranceAccountNumber;
    };

    $scope.validateInsuranceAccountName = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.insuranceAccountNameIsValid = $event.currentTarget.value && validations.insuranceNameValidator($event.currentTarget.value.trim());
        }

        $scope.newInsuranceAccountName = $event.currentTarget.value;
    };

    $scope.validateInsuranceAccountNumber = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.insuranceAccountNumberIsValid = $event.currentTarget.value && validations.insuranceNumberValidator($event.currentTarget.value.trim());
        }

        $scope.newInsuranceAccountNumber = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.insuranceAccountNameIsValid = $scope.newInsuranceAccountName === undefined ? false : validations.insuranceNameValidator($scope.newInsuranceAccountName.trim());
        $scope.insuranceAccountNumberIsValid = $scope.newInsuranceAccountNumber === undefined ? false : validations.insuranceNumberValidator($scope.newInsuranceAccountNumber.trim());

        $scope.newEntrySubmitted = true;

        if ($scope.insuranceAccountNameIsValid && $scope.insuranceAccountNumberIsValid) {

            $scope.saveNewInsuranceCardIsLoading = true;

            var payload = {
                insuranceCards: {
                    providerName: $scope.newInsuranceAccountName,
                    policyNumber: $scope.newInsuranceAccountNumber,
                    type: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newInsuranceAccountName = '';
                $scope.newInsuranceAccountNumber = '';
                $scope.saveNewInsuranceCardIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;

                    _RFC4.default.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Insurance cards'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewInsuranceCardIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            insuranceCards: {
                id: $scope.insuranceCards.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newInsuranceAccountName = '';
            $scope.newInsuranceAccountNumber = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Insurance cards'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.updateInsuranceAccountName = function ($event) {

        $scope.insuranceAccountNameIsValid = $event.currentTarget.value && validations.insuranceNameValidator($event.currentTarget.value.trim());

        if ($scope.insuranceAccountNameIsValid) {

            $scope.updateEntryPayload.providerName = $event.currentTarget.value;
        }
    };

    $scope.updateInsuranceAccountNumber = function ($event) {

        $scope.insuranceAccountNumberIsValid = $event.currentTarget.value && validations.insuranceNumberValidator($event.currentTarget.value.trim());

        if ($scope.insuranceAccountNumberIsValid) {

            $scope.updateEntryPayload.policyNumber = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { insuranceCards: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Insurance cards'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmInsuranceCards);

angular.module('controllers').controller('DwmInsuranceCards', _serviceDependencies);

/***/ }),

/***/ "s6Ep":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content dwm-lightbox dwm\">\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loading' || $root.dwmResoucesStatuses.members === 'loading'\">\n        <div class=\"loader-wrapper\">\n            <div class=\"main-loader\"></div>\n        </div>\n    </div>\n    <div ng-if=\"$root.dwmResoucesStatuses.token === 'loaded' && $root.dwmResoucesStatuses.members === 'loaded'\">\n        <div class=\"display-flex align-item-center\">\n            <div class=\"dwm-lightbox-icon icon-mothers-maiden-name\"></div>\n            <h2 class=\"text-grey-1 text-xl ml30 mb15\" translate=\"cw.dwm.entity.mothers_maiden_name.title\"></h2>\n        </div>\n        <div class=\"dwm-lightbox-content mt20\">\n            <div class=\"dwm-lightbox-content-box display-flex align-item-stretch\">\n                <div class=\"left-column w60\">\n                    <div ng-if=\"!showRemoveEntryScreen\">\n                        <div class=\"row display-flex align-item-center\" ng-repeat=\"mothersMaidenName in mothersMaidenName.entries\">\n                            <div class=\"col-4 col-text text-left\" ng-if=\"!mothersMaidenName.showUpdateInput\">\n                                    <div class=\"text-grey-1 text-l\">{{mothersMaidenName.name}}</div>\n                            </div>\n                            <div class=\"col-7 col-text text-right\" ng-if=\"!mothersMaidenName.showUpdateInput\">\n                                <span class=\"action\" ng-click=\"updateEntry($index);\" translate=\"cw.dwm.entity.email.update\"></span> / <span\n                                    class=\"action\" ng-click=\"removeEntry($index)\" translate=\"cw.my_devices.link.remove\"></span>\n                            </div>\n                            <div class=\"col-2 col-text text-left\" ng-if=\"mothersMaidenName.showUpdateInput\">\n                                <div>\n                                    <input type=\"text\"\n                                        ng-class=\"{'error': !mothersMaidenNameIsValid}\"\n                                        name=\"mothersMaidenName\"\n                                        minlength=\"1\"\n                                        maxlength=\"20\"\n                                        placeholder=\"{{ 'cw.dwm.entity.mothers_maiden_name.name' | translate }}\"\n                                        autocomplete=\"off\"\n                                        class=\"update-mothers-maiden-name\"\n                                        ng-keyup=\"updateMothersMaidenName($event);\">\n                                    <p class=\"error-message\" ng-show=\"!mothersMaidenNameIsValid\"\n                                        translate=\"cw.dwm.entity.mothers_maiden_name.invalid_name\">\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"row display-flex align-item-center\" ng-if=\"newEntryVisible\">\n                            <div class=\"col-2 col-text text-left\">\n                                <div>\n                                    <input type=\"text\" ng-class=\"{'error': !mothersMaidenNameIsValid}\"\n                                        name=\"mothersMaidenName\" ng-model=\"newMothersMaidenName\" placeholder=\"{{ 'cw.dwm.entity.mothers_maiden_name.name' | translate }}\" minlength=\"1\" maxlength=\"20\" autocomplete=\"off\"\n                                        id=\"mothersMaidenName\" class=\"update-mothers-maiden-name\" ng-keyup=\"validateMothersMaidenName($event)\">\n                                        <p class=\"error-message\" ng-show=\"!mothersMaidenNameIsValid\"\n                                            translate=\"cw.dwm.entity.mothers_maiden_name.invalid_name\"></p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"showRemoveEntryScreen\" class=\"remove-entry\">\n                        <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.mothers_maiden_name.remove_title\"></h3>\n                        <p class=\"text-l mb10 text-grey-3\" translate=\"cw.dwm.entity.mothers_maiden_name.remove_desc_1\"></p>\n                        <p class=\"text-l text-grey-3\" translate=\"cw.dwm.entity.email.remove_entry_desc_2\"></p>\n                    </div>\n                </div>\n                <div class=\"right-column w40 text-left\">\n                    <h3 class=\"text-l uppercase mb20 text-grey-1\" translate=\"cw.dwm.entity.mothers_maiden_name.entity_details.title\"></h3>\n                    <p class=\"text-xs mb10 text-grey-3\" translate=\"cw.dwm.entity.mothers_maiden_name.entity_details.desc_1\"></p>\n                    <p class=\"text-xs text-grey-3\" translate=\"cw.dwm.entity.mothers_maiden_name.entity_details.desc_2\"></p>\n                </div>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"!showRemoveEntryScreen\">\n            <button class=\"btn btn-primary btn-medium\" ng-if=\"showAddNewButton && (mothersMaidenName.maxCount > mothersMaidenName.entries.length)\"\n                ng-click=\"addNewEntry()\" translate=\"cw.dwm.assets.add_new\"></button>\n            <div ng-if=\"showSaveButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewMothersMaidenNameIsLoading}\"\n                    ng-disabled=\"saveNewMothersMaidenNameIsLoading || !mothersMaidenNameIsValid\"\n                    ng-click=\"saveNewEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n            <div ng-if=\"showUpdateButton\">\n                <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelUpdateNewEntry()\" translate=\"cw.form.profile.cancel\"></button>\n                <button class=\"btn btn-primary btn-medium\" ng-class=\"{'spin-loader': saveNewMothersMaidenNameIsLoading}\"\n                    ng-disabled=\"saveNewMothersMaidenNameIsLoading || !mothersMaidenNameIsValid\"\n                    ng-click=\"saveUpdatedEntry()\" translate=\"cw.dwm.entity.email.save\"></button>\n            </div>\n        </div>\n        <div class=\"buttons mt40\" ng-if=\"showRemoveEntryScreen\">\n            <button class=\"btn btn-secondary btn-medium mr10\" ng-click=\"cancelRemoveEntry()\" translate=\"cw.form.profile.cancel\"></button>\n            <button class=\"btn btn-orange btn-medium spin-loader\" ng-disabled=\"confirmRemoveIsLoading\"\n                ng-click=\"confirmRemoveEntry()\" translate=\"cw.my_devices.link.remove\"></button>\n        </div>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/dwm/mothers-name/mothers-name.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "s8o5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc service
 * @name controllers.WelcomeModalSpotlight
 *
 * @description
 * Welcome Modal Spotlight
 */
angular.module('controllers').controller('WelcomeModalSpotlight', ['$scope', '$state', '$document', 'LicenseRestService', 'Sso', 'ActivationCodeRestService', 'Util', 'DeployRestService', function ($scope, $state, $document, LicenseRestService, Sso, ActivationCodeRestService, Util, DeployRestService) {

    angular.element($document[0].body).addClass('splash-screen');

    // retrieve the x-a-* params and forward them to the backend
    var ssoParams = Sso.getParams();
    var metaParams = {};
    var currentDeviceOS = Util.getDeviceNavigator();

    Object.keys(ssoParams).forEach(function (key) {

        if (key.indexOf('x-a-') > -1) {

            metaParams[key] = ssoParams[key];
        }
    });

    $scope.product = _index.AppIntegrationsRepository.getAppName('aps10');
    $scope.brandName = CWCONFIG.partnerConfig.name;
    $scope.license = _index.LicensesRepository.getLicenseByAppId($state.params.resourceId);
    if (!$scope.license) {

        var licensePayload = {
            data: {
                relationships: {
                    app: {
                        data: {
                            type: 'apps',
                            id: $state.params.resourceId
                        }
                    }
                }
            },
            meta: {
                'x-params': metaParams
            }
        };
        // add campgain param in meta
        if (metaParams['x-a-channel']) {

            licensePayload.meta.cmp = metaParams['x-a-channel'];
        }
        LicenseRestService.create(licensePayload).then(function (license) {

            $scope.license = license;

            // get activationCode after the license is received
            ActivationCodeRestService.getAllAsync().then(function (response) {

                _index.ActivationCodesRepository.replace(response.data.data);
            });
        }).catch(function () {

            $scope.closeModal();
        });
    }

    var mixpanelPayload = {
        Source: 'ws_spotlight',
        Modal: 'Spotlight Welcome Modal',
        Page: Util.getPageName()
    };

    _RFC2.default.send('ConnectWeb Modal Open ', mixpanelPayload);

    $scope.$on('$destroy', function () {

        angular.element($document[0].body).removeClass('splash-screen');
    });

    $scope.installApp = function () {

        var mixpanelData = {
            Modal: 'Spotlight Welcome Modal',
            'Button Label': 'Install now',
            'Product ID': $state.params.resourceId,
            Page: Util.getPageName()
        };

        _RFC2.default.send('ConnectWeb Modal Button Click', mixpanelData);

        var devices = _index.DevicesRepository.getVisibleDevices();

        devices.forEach(function (device) {

            // if device has Windows OS
            if (device.attributes.os === 'windows') {

                var deploymentPayload = {
                    deviceId: device.id,
                    userId: Util.deepFind(device, 'relationships.user.data.id'),
                    appId: 'aps10'
                };

                DeployRestService.deployOnDevice(deploymentPayload).then(function () {

                    /*  if there are only Windows devices redirect
                        the user to Subscriptions page */
                    if (!devices.find(function (deviceItem) {
                        return deviceItem.attributes.os !== 'windows';
                    })) {

                        $state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        });
                    }
                }).then(null, function (e) {

                    /* 409 === Conflict
                    An instance for this application already
                    exists (pending) - ignore */
                    if (e.status === 409) {

                        return;
                    }

                    _RFC4.default.error({
                        message: 'cw.modal.server-error.desc',
                        icon: {

                            cssClasses: 'icon-' + Util.deepFind(device, 'attributes.type')

                        }

                    });
                });
            }
        });

        /* if there are no devices or the current user OS
            is not Windows show autoInstall modal */
        if (devices.length === 0 || devices.find(function (device) {
            return device.attributes.os !== 'windows';
        })) {

            var matchingOS = _index2.DevicesProcessor.getDeployOSfor('aps10', currentDeviceOS) || null;
            var hasMatchingOS = !!matchingOS;

            $scope.closeModal();

            setTimeout(function () {

                $state.go('root.dashboard.subscriptions.ltb.deploy', {
                    ltb: 'deploy',
                    deviceId: 'new',
                    resourceId: 'aps10',
                    appId: 'aps10',
                    os: matchingOS,
                    autoInstall: hasMatchingOS
                });
            }, 400);
        }
    };

    $scope.closeModal = function () {

        $state.go('root.dashboard.subscriptions', {
            tab: 'plans'
        });
    };
}]);

/***/ }),

/***/ "sK5d":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "sRTE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('directives').directive('tooltipScroll', function () {
    return {
        template: '',
        restrict: 'A',
        replace: false,
        link: function link(scope, element) {

            // show tooltip
            element.parent().on('mouseenter', function () {

                if (!_RFC2.default.get('scrolltooltip')) {

                    element.addClass('flipInX');
                    setTimeout(function () {

                        element.removeClass('flipInX');
                    }, CWCONFIG.timeouts.tooltip);
                }

                _RFC2.default.set('scrolltooltip', true, { expires: 365, path: '/' });
            });
        }
    };
});

/***/ }),

/***/ "saA2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFCSession = __webpack_require__("DyxV");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$state', '$location'];

/**
 * @ngdoc service
 * @name services.Redirect
 *
 * @description
 * This class is used to redirect routes (usually old routes)
 * to their new counterparts
 */

var Redirect = function () {

    /**
     * @param {any} $rootScope $rootScope
     * @param {any} $state $state
     */
    function Redirect($rootScope, $state, $location) {
        _classCallCheck(this, Redirect);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$location = $location;
    }

    /**
     * @ngdoc function
     * @name services.Redirect#redirectUrl
     * @methodOf services.Redirect
     * @function
     *
     * @description
     * This method is used to redirect URLs (usually old ones)
     *
     */


    _createClass(Redirect, [{
        key: 'redirectUrl',
        value: function redirectUrl() {

            // redirects for URLs coming from login
            if (typeof this.$rootScope.loginUrlRedirect !== 'undefined') {

                if (this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/deviceType/pc') > -1) {

                    this.$state.go('root.dashboard.devices.ltb.deploy', {
                        ltb: 'deploy',
                        resourceId: 'new',
                        os: 'windows'
                    });
                } else if (this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/deviceType/phone') > -1 || this.$rootScope.loginUrlRedirect.indexOf('ltb/deploy/svc/antitheft') > -1) {

                    this.$state.go('root.dashboard.products.ltb.deploy', {
                        ltb: 'deploy',
                        resourceId: CWCONFIG.defaultDeployedAppId.android,
                        deviceId: 'new'
                    });
                } else if (this.$rootScope.loginUrlRedirect.indexOf('ltb/my-profile') > -1) {

                    /**
                     * my-profile redirects
                     */

                    // subsection of my-profile redirect
                    if (this.$rootScope.loginUrlRedirect.indexOf('/notifications') > -1) {

                        this.$location.path('/dashboard/my-account/tabs/notifications');
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('/change-password') > -1) {

                        this.$location.path('/dashboard/my-account/tabs/security');
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('/two-step-verification') > -1) {

                        this.$location.path('/dashboard/my-account/tabs/security');
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('/products') > -1) {

                        this.$state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        });
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('/payment-history') > -1) {

                        this.$location.path('/dashboard/subscriptions/tabs/history');
                    } else {

                        this.$location.url('/dashboard/my-account/tabs/profile');
                    }
                } else if (this.$rootScope.loginUrlRedirect.indexOf('subscriptions') > -1 && this.$rootScope.loginUrlRedirect.indexOf('deploy') === -1 || this.$rootScope.loginUrlRedirect.indexOf('url/deploy-pc') > -1 || this.$rootScope.loginUrlRedirect.indexOf('url/deploy-mobile') > -1) {

                    if (this.$rootScope.loginUrlRedirect.indexOf('/otc') > -1) {

                        this.$state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        });
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('history') > -1) {

                        this.$state.go('root.dashboard.subscriptions', {
                            tab: 'history'
                        });
                    } else if (this.$rootScope.loginUrlRedirect.indexOf('expired') > -1) {

                        this.$state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        });
                    } else {

                        this.$state.go('root.dashboard.subscriptions', {
                            tab: 'plans'
                        });
                    }
                } else if (this.$rootScope.loginUrlRedirect.indexOf('subscriptions') > -1 && this.$rootScope.loginUrlRedirect.indexOf('deploy') > -1) {

                    /* if url contains subscriptions and deploy params, redirect to subscription page.
                    After the user is redirected to subscription page, the deployment modal will
                    be opened from "dashboard.es6" controller */

                    // prevent redirect if the user is already on subscription page or set password page
                    if (this.$state.current.name.indexOf('root.dashboard.subscriptions') === -1) {

                        var authExtraUrlParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams);

                        if (authExtraUrlParams && authExtraUrlParams.indexOf('/dashboard') > -1) {

                            var nextRoute = authExtraUrlParams.substring(authExtraUrlParams.indexOf('/dashboard'));

                            this.$location.url('' + nextRoute);
                        } else {

                            this.$state.go('root.dashboard.subscriptions', { tab: 'plans' });
                        }
                    }
                } else {

                    var newUrl = null;

                    if (this.$rootScope.loginUrlRedirect.indexOf('/dashboard') > -1) {

                        newUrl = this.$rootScope.loginUrlRedirect.slice(this.$rootScope.loginUrlRedirect.indexOf('/dashboard'));

                        if (newUrl.indexOf('/ltb/notifications&') > -1) {

                            var newUrlReplace = newUrl.replace('notifications&', 'notifications?');
                            newUrl = newUrlReplace;
                        }

                        if (newUrl.indexOf('/my-account/tabs/payment&') > -1) {

                            var _newUrlReplace = newUrl.replace('/my-account/tabs/payment&', '/my-account/tabs/payment?');
                            newUrl = _newUrlReplace;
                        }

                        this.$location.url(newUrl);
                    } else {

                        // when user comes from email
                        this.$state.go('root.dashboard.home');
                    }
                }
            } else if (this.$location.path().indexOf('/auth/') >= 0) {
                // when no jwt

                this.$state.go('root.dashboard.home');
            }
        }
    }]);

    return Redirect;
}();

_serviceDependencies.push(Redirect);

angular.module('services').service('Redirect', _serviceDependencies);

/***/ }),

/***/ "sd1L":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("lTTh"),
    mapCacheDelete = __webpack_require__("MDzN"),
    mapCacheGet = __webpack_require__("0iGx"),
    mapCacheHas = __webpack_require__("8+/4"),
    mapCacheSet = __webpack_require__("dj/A");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "sejk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* @ngdoc class
* @name Deferred
*
* @description
* Polyfill for the angular $q.defer()
*/
var Deferred = function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this.promise = new Promise(function (resolve, reject) {

        _this.resolve = resolve;
        _this.reject = reject;
    });
};

exports.default = Deferred;

/***/ }),

/***/ "shbC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PaymentUrlsRestService
 *
 * @description
 * This class contains methods used to retrieve information about payment urls
 * using http requests.
 */

var PaymentUrlsRestService = function (_BaseRestService) {
    _inherits(PaymentUrlsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function PaymentUrlsRestService($http, $q, Util) {
        _classCallCheck(this, PaymentUrlsRestService);

        return _possibleConstructorReturn(this, (PaymentUrlsRestService.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.PaymentUrlsRestService#getByAppId
    * @methodOf rest.services.PaymentUrlsRestService
    * @function
    *
    * @description
    * Retrieves payment urls.
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(PaymentUrlsRestService, [{
        key: 'getByAppId',
        value: function getByAppId(appId, subsource) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + (subsource ? '&filter[subsource]=' + subsource : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.PaymentUrlsRestService#getByAppIdAndLicenseId
        * @methodOf rest.services.PaymentUrlsRestService
        * @function
        *
        * @description
        * Retrieves payment urls.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndLicenseId',
        value: function getByAppIdAndLicenseId(appId, subsource, licenseId) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + (subsource ? '&filter[subsource]=' + subsource : '') + '&filter[license]=' + licenseId);
        }

        /**
        * @ngdoc function
        * @name rest.services.PaymentUrlsRestService#getPromotionByAppId
        * @methodOf rest.services.PaymentUrlsRestService
        * @function
        *
        * @description
        * Retrieves payment urls.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getPromotionByAppId',
        value: function getPromotionByAppId(appId, subsource) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + '&upsaleTo=' + appId + (subsource ? '&filter[subsource]=' + subsource : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.PaymentUrlsRestService#getByAppIdAndRuntime
        * @methodOf rest.services.PaymentUrlsRestService
        * @function
        *
        * @description
        * Retrieves payment urls.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdAndRuntime',
        value: function getByAppIdAndRuntime(appId, runtime, subsource) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + '&filter[runtime]=' + runtime + (subsource ? '&filter[subsource]=' + subsource : ''));
        }

        /**
        * @ngdoc function
        * @name rest.services.PaymentUrlsRestService#ggetByAppIdRuntimeAndUpsell
        * @methodOf rest.services.PaymentUrlsRestService
        * @function
        *
        * @description
        * Retrieves payment urls.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getByAppIdRuntimeAndUpsell',
        value: function getByAppIdRuntimeAndUpsell(appId, runtime, subsource, licenseId) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + '&filter[runtime]=' + runtime + (subsource ? '&filter[subsource]=' + subsource : '') + '&filter[license]=' + licenseId + '&upsellTo=' + appId);
        }

        /**
        * @ngdoc function
        * @name rest.services.PaymentUrlsRestService#getPromotionByAppIdAndUpsell
        * @methodOf rest.services.PaymentUrlsRestService
        * @function
        *
        * @description
        * Retrieves payment urls.
        *
        * @returns {Promise} The promise of the call.
        */

    }, {
        key: 'getPromotionByAppIdAndUpsell',
        value: function getPromotionByAppIdAndUpsell(appId, subsource, licenseId) {

            return _get(PaymentUrlsRestService.prototype.__proto__ || Object.getPrototypeOf(PaymentUrlsRestService.prototype), 'getAllAsync', this).call(this, 'payment-urls/?filter[source]=cw&filter[app]=' + appId + '&upsaleTo=' + appId + (subsource ? '&filter[subsource]=' + subsource : '') + '&filter[license]=' + licenseId + '&upsellTo=' + appId);
        }
    }]);

    return PaymentUrlsRestService;
}(_baseRestService2.default);

exports.default = PaymentUrlsRestService;


_serviceDependencies.push(PaymentUrlsRestService);

angular.module('rest.services').service('PaymentUrlsRestService', _serviceDependencies);

/***/ }),

/***/ "sy/n":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"dwm\">\n        <div class=\"dashboard-tabs-holder\" ng-if=\"currentTab !=='store'\">\n            <div class=\"dashboard-tabs multiple-tabs text-left\" ng-class=\"{\n                'inactive': (showMainLoader && !$root.dwmStatus) || activateLicensePending\n            }\">\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'dwm'}\" ui-sref=\"root.dashboard.dwm({tab: 'dwm'})\" translate=\"cw.dwm.tabs.dwm\" connect-qa-dwm-tab=\"dwm\">\n                </span>\n\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'restoration'}\" ng-click=\"restorationTabClick()\" translate=\"cw.dwm.tabs.restoration\" ng-hide=\"$root.showDWMLiteStrippedDashboard\" connect-qa-dwm-tab=\"restoration\">\n                </span>\n\n                <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentTab === 'faq'}\" ui-sref=\"root.dashboard.dwm({tab: 'faq'})\" translate=\"cw.dashboard.crypto.tabs.faq\" connect-qa-dwm-tab=\"faq\">\n                </span>\n\n            </div>\n            <div class=\"status\" ng-if=\"$root.dwmStatus\">\n                <div ng-click=\"toggleMontoring()\" class=\"toggle-monitoring\" ng-class=\"{\n                    'crs-pointer': !activateLicensePending,\n                    'info-tooltip-holder': ($root.aiaSubscriptionCancelled || $root.dwmLiteSubscriptionCancelled) && !activateLicensePending\n                }\">\n                    <span class=\"inline-block v-middle text-grey-3 text-s uppercase text-with-loading\"\n                        ng-if=\"activateLicensePending\" translate=\"cw.general.ui.pending\"\n                        ng-class=\"{\n                            'spin-loader disabled': activateLicensePending,\n                            'mr10': !activateLicensePending\n                        }\"\n                        ng-disabled=\"activateLicensePending\" connect-qa-dwm-status-text=\"inactive\"></span>\n\n                    <span class=\"inline-block v-middle text-red-1 text-s uppercase mr10\"\n                        ng-if=\"($root.aiaSubscriptionCancelled || $root.dwmLiteSubscriptionCancelled) && !activateLicensePending\"\n                        translate=\"cw.dwm.assets.monitoring_inactive\" connect-qa-dwm-status-text=\"inactive\"></span>\n\n                    <span class=\"inline-block v-middle text-green-1 text-s uppercase mr10\" translate=\"cw.dwm.assets.monitoring_active\" ng-if=\"($root.dwmStatus.products.identityAssist.subscriptionStatus === 'active' || $root.dwmStatus.products.dwmLite.subscriptionStatus === 'active') && !activateLicensePending\" connect-qa-dwm-status-text=\"active\"></span>\n\n                    <div class=\"switch-button-theme v-middle\" ng-class=\"{\n                        'enabled' : $root.dwmStatus.products.identityAssist.subscriptionStatus === 'active' || $root.dwmStatus.products.dwmLite.subscriptionStatus === 'active',\n                        'pending' : activateLicensePending,\n                        'disabled' : ($root.aiaSubscriptionCancelled || $root.dwmLiteSubscriptionCancelled) && !activateLicensePending\n                    }\" ng-if=\"!activateLicensePending\">\n                        <span class=\"switch-knob\"></span>\n                    </div>\n\n                    <div class=\"info-tooltip tooltip-monitoring-inactive arrow-top\" ng-if=\"$root.aiaSubscriptionCancelled || $root.dwmLiteSubscriptionCancelled\"\n                        translate=\"cw.dwm.assets.monitoring_inactive_tooltip\" connect-qa-dwm-tooltip=\"inactive-monitoring\"></div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"currentTab === 'dwm'\">\n            <div class=\"content-wrapper\">\n\n                <div class=\"loader-wrapper\" ng-if=\"showMainLoader\">\n                    <div class=\"main-loader mt100\"></div>\n                </div>\n\n                <div ng-if=\"!showMainLoader\">\n                    <dwm-assets></dwm-assets>\n                    <dwm-alerts></dwm-alerts>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"currentTab === 'restoration'\">\n            <div class=\"content-wrapper-large\">\n                <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_1\">\n                </h2>\n                <p class=\"text-grey-3 text-s\" translate=\"cw.dwm.restoration.desc_1\"></p>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <div class=\"section-with-icon\">\n                    <i class=\"icon icon-dwm-eye icon-grey-2\"></i>\n                    <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_2\">\n                    </h2>\n                    <p class=\"text-grey-3 text-s\" translate=\"cw.dwm.restoration.desc_2\">\n                    </p>\n                    <a ui-sref=\"root.dashboard.support({tab:'support'})\" class=\"btn-medium btn-secondary mt20 inline-block\" ng-click=\"sendMixpanelSupport()\" translate=\"cw.dwm.restoration.contact_support\"></a>\n                </div>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1\" translate=\"cw.dwm.restoration.title_3\">\n                </h2>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <div class=\"section-with-icon\">\n                    <i class=\"icon icon-dwm-restoration icon-grey-2\"></i>\n                    <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_1\">\n                    </h2>\n                    <p class=\"text-grey-3 text-s mb10\" translate=\"cw.dwm.restoration.desc_4\">\n                    </p>\n                    <ul>\n                        <li class=\"text-grey-3 text-s mb5\" translate=\"cw.dwm.restoration.feature_4_1\"></li>\n                        <li class=\"text-grey-3 text-s mb5\" translate=\"cw.dwm.restoration.feature_4_2\"></li>\n                        <li class=\"text-grey-3 text-s\" translate=\"cw.dwm.restoration.feature_4_3\"></li>\n                    </ul>\n                </div>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <div class=\"section-with-icon\">\n                    <i class=\"icon icon-dwm-notification-2 icon-grey-2\"></i>\n                    <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_5\">\n                    </h2>\n                    <p class=\"text-grey-3 text-s mb10\" translate=\"cw.dwm.restoration.desc_5\"></p>\n                    <ul>\n                        <li class=\"text-grey-3 text-s mb5\" translate=\"cw.dwm.restoration.feature_5_1\"></li>\n                        <li class=\"text-grey-3 text-s mb5\" translate=\"cw.dwm.restoration.feature_5_2\"></li>\n                        <li class=\"text-grey-3 text-s\" translate=\"cw.dwm.restoration.feature_5_3\"></li>\n                    </ul>\n                </div>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <div class=\"section-with-icon\">\n                    <i class=\"icon icon-dwm-wallet icon-grey-2\"></i>\n                    <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_7\">\n                    </h2>\n                    <p class=\"text-grey-3 text-s mb10\" translate=\"cw.dwm.restoration.desc_9\"></p>\n                    <ul>\n                        <li class=\"text-grey-3 text-s mb5\" translate=\"cw.dwm.restoration.feature_7_1\"></li>\n                    </ul>\n                </div>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <div class=\"section-with-icon\">\n                    <i class=\"icon icon-vip-support icon-grey-2\"></i>\n                    <h2 class=\"inline-block text-xl font-bold v-middle text-grey-1 mb10\" translate=\"cw.dwm.restoration.title_6\">\n                    </h2>\n                    <p class=\"text-grey-3 text-s mb10\" translate=\"cw.dwm.restoration.desc_6\"></p>\n                </div>\n                <div class=\"section-separator mt30 mb30\"></div>\n                <p class=\"text-grey-3 text-s mb10\" translate=\"cw.dwm.restoration.desc_7\"></p>\n                <p class=\"text-grey-3 text-s\" translate=\"cw.dwm.restoration.desc_8\"></p>\n            </div>\n        </div>\n\n        <div ng-if=\"currentTab === 'faq'\">\n            <div class=\"container-dwm-faq\">\n                <div class=\"content-wrapper-faq card\">\n                    <dwm-faq></dwm-faq>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"currentTab === 'store'\" ng-class=\"{'white-background': !showMainLoader && State.theme !== 'dark'}\">\n            <div class=\"loader-wrapper\" ng-if=\"showMainLoader\">\n                <div class=\"main-loader store-loader\"></div>\n            </div>\n            <dwm-store ng-if=\"!showMainLoader\"></dwm-store>\n        </div>\n    </div>\n    <link rel=\"preconnect\" href=\"https://fonts.googleapis.com\">\n    <link rel=\"preconnect\" href=\"https://fonts.gstatic.com\" crossorigin>\n    <link href=\"https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap\" rel=\"stylesheet\">\n</div>\n"

/***/ }),

/***/ "syvy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

angular.module('filters').filter('filterState', function () {
    return function (states, query) {

        if (angular.isUndefined(query) || !query) {

            return states;
        }
        return _.filter(states, function (state) {

            if (!state.name) {

                return false;
            }
            return state.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
        });
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "tBMr":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"threats-landscape lightbox-content modal-xxlarge-width\">\n    <div class=\"main-loader\"></div>\n    <div class=\"content\" data-jquery-scrollbar>\n        <iframe src=\"{{iframeUrl}}\" id=\"threats-landscape-iframe\"></iframe>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/threats-landscape/threats-landscape.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "tGka":
/***/ (function(module, exports) {

module.exports = "<div class=\"cma-disclaimer\" id=\"cma-disclaimer\" ng-style=\"$root.cmaDisclaimerHeight\">\n    <div class=\"cma-container\">\n        <p ng-if=\"$root.extraCMAinfoForDwm\" class=\"text-m text-grey-3 mb30\" translate=\"cw.cma_disclaimer.dwm.desc_1\"></p>\n        <p ng-if=\"$root.extraCMAinfoForDwm\" class=\"text-m text-grey-3 mb30\" translate=\"cw.cma_disclaimer.dwm.desc_2\"></p>\n\n        <p ng-if=\"$root.showCmaDisclaimer.withdrawalConsent\"\n           class=\"text-m text-grey-3 mb10\"\n           ng-click=\"trackEuWithdrawClick($event)\"\n           translate=\"cw.cma_disclaimer.eu_withdraw_from_contract\"\n           translate-values=\"{withdrawUrl: euWithdrawFromContract}\">\n        </p>\n\n        <p class=\"text-l font-bold text-grey-1 mb10\" translate=\"cw.cma_disclaimer.title\"></p>\n\n        <div ng-repeat=\"(key, promotion) in $root.welcomeOffers\" ng-if=\"!$root.cmaGBapplies\">\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\">{{promotion.product}} - </span>\n                <span ng-if=\"key !== 'aps20_12_1'\"\n                    translate=\"cw.offer.generic_disclaimer_row\"\n                    translate-values=\"{\n                        endDate: promotion.endDate,\n                        discountedPrice: promotion.discountedPrice,\n                        discountedAmount: promotion.discountedAmount,\n                        firstYearPrice: promotion.firstYearPrice,\n                        renewalPrice: promotion.renewalPrice\n                    }\"\n                ></span>\n                <span ng-if=\"key === 'aps20_12_1'\"\n                    translate=\"cw.offer.prime25_generic_disclaimer_row\"\n                    translate-values=\"{\n                        endDate: promotion.endDate,\n                        renewalPrice: promotion.renewalPrice\n                    }\"\n                ></span>\n            </p>\n        </div>\n\n        <div ng-repeat=\"promotion in $root.welcomeOffers\" ng-if=\"$root.cmaGBapplies\">\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\">{{promotion.product}} - </span>\n                <span\n                    translate=\"cw.offer.generic_disclaimer_uk\"\n                    translate-values=\"{\n                        endDate: promotion.endDate,\n                        renewalPrice: promotion.renewalPrice\n                    }\"\n                ></span>\n            </p>\n        </div>\n\n        <div ng-if=\"$root.welcomeOffer.campaign\" class=\"mb10\">\n            <p class=\"text-m text-grey-3 mb5\">\n                <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.special_offer\"></span>\n                <span translate=\"cw.cma_disclaimer.special_offer_desc_1\"\n                translate-values=\"{\n                    startingDate: $root.welcomeOffer.startDate,\n                    endingDate: $root.welcomeOffer.endDate\n                }\"></span>\n            </p>\n\n            <p class=\"text-m text-grey-3 campaign-label\" translate=\"cw.cma_disclaimer.special_offer_desc_2_yearly\"\n                translate-values=\"{\n                    product: $root.welcomeOffer.product,\n                    discountedPrice: $root.welcomeOffer.discountedPrice,\n                    discountedAmount: $root.welcomeOffer.discountedAmount,\n                    standardFirstYearPrice: $root.welcomeOffer.renewalPrice,\n                    renewalPrice: $root.welcomeOffer.renewalPrice,\n                }\"\n            ></p>\n        </div>\n\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.contract_type\"></span>\n            <span translate=\"cw.cma_disclaimer.contract_type_desc\"\n            translate-values=\"{termsOfSale: termsOfSale}\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.set_up\"></span>\n            <span translate=\"cw.cma_disclaimer.set_up_desc\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.free_trial\"></span>\n            <span translate=\"cw.cma_disclaimer.free_trial_desc\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_cycle\"></span>\n            <span translate=\"cw.cma_disclaimer.renewal_cycle_desc\"\n            translate-values=\"{\n                yourAccount: yourAccount,\n                contactUs: contactUs,\n                learnHow: learnHow\n            }\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.renewal_prices\"></span>\n            <span translate=\"cw.cma_disclaimer.renewal_prices_desc\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.subscribe.cancellation_refund\"></span>\n\n            <span ng-if=\"!$root.cmaGBapplies && !$root.cmaNLapplies && !$root.cmaDEapplies && !$root.cmaFRapplies\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_row\"\n            translate-values=\"{\n                cancellation: cancellation,\n                cancelOrRefund: cancelContractDetails\n            }\"></span>\n\n            <span ng-if=\"!$root.cmaGBapplies && !$root.cmaNLapplies && ($root.cmaDEapplies || $root.cmaFRapplies)\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_row\"\n            translate-values=\"{\n                cancellation: cancellation,\n                cancelOrRefund: cancelContractDetailsNew\n            }\"></span>\n\n            <span ng-if=\"$root.cmaGBapplies || $root.cmaNLapplies\" translate=\"cw.cma_disclaimer.cancellation_refund_desc_gb\" translate-values=\"{\n                cancellation: cancellation,\n                cancelOrRefund: cancelContractDetails\n            }\"></span>\n        </p>\n        <p class=\"text-m text-grey-3 mb5\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.updates\"></span>\n            <span translate=\"cw.cma_disclaimer.updates_desc\" translate-values=\"{\n                licenseAgreement: licenseAgreement\n            }\"></span>\n        </p>\n        <p class=\"text-m text-grey-3\">\n            <span class=\"font-bold text-grey-1\" translate=\"cw.cma_disclaimer.usage\"></span>\n            <span translate=\"cw.cma_disclaimer.Usage_desc\" translate-values=\"{\n                contactUs: contactUs\n            }\"></span>\n        </p>\n    </div>\n</div>\n"

/***/ }),

/***/ "tK+i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint no-inner-declarations: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-console: 0 */
/* eslint no-restricted-syntax: 0 */

var _browser = __webpack_require__("W/hB");

var Sentry = _interopRequireWildcard(_browser);

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _exceptionHandler = __webpack_require__("yRFa");

var _exceptionHandler2 = _interopRequireDefault(_exceptionHandler);

var _appStateDebugger = __webpack_require__("he/w");

var _appStateDebugger2 = _interopRequireDefault(_appStateDebugger);

var _initAppState = __webpack_require__("3Onw");

var _initAppState2 = _interopRequireDefault(_initAppState);

var _storeUrlParamLogic = __webpack_require__("XH9K");

var _storeUrlParamLogic2 = _interopRequireDefault(_storeUrlParamLogic);

var _package = __webpack_require__("OjAK");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initiate Angular Boostrap App - Workaround to fix the
// compatibility between Angular 1.8.2 and jQuery 3.6.0
setTimeout(function () {

    angular.bootstrap(document.getElementById('oeApp'), ['oe']);
}, 0);

// For local environment, make sure we set the deviceOs to a default

window.deviceOs = window.deviceOs !== '{{ m_os }}' ? window.deviceOs : 'windows';

/* if the server returns MacOSX and we have touch points it
   means that the user is coming from iPad device */
if (window.deviceOs && window.deviceOs.toLowerCase().indexOf('mac') > -1 && window.navigator.maxTouchPoints > 2) {

    window.deviceOs = 'ios';
}

function deepFreeze(object) {

    // Retrieve the property names defined on object
    var propNames = Object.getOwnPropertyNames(object);

    // Freeze properties before freezing self
    propNames.forEach(function (name) {

        var value = object[name];

        object[name] = value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? deepFreeze(value) : value;
    });

    return Object.freeze(object);
}

window.CWCONFIG = deepFreeze(window.CWCONFIG);

angular.module('ngModules', ['ngAnimate', 'ngSanitize']);
angular.module('3rdPartyModules', ['pascalprecht.translate', 'ui.router', 'ui.bootstrap.modal', 'ui.select', 'duScroll', 'pasvaz.bindonce', 'utf8-base64', 'jQueryScrollbar', 'vcRecaptcha', 'angular-jwt', 'uiCropper']);
angular.module('i18nConfig', []);
angular.module('oe.core', []);
angular.module('oe.enums', []);
angular.module('filters', []);
angular.module('services', []);
angular.module('rest.services', []);
angular.module('models', []);
angular.module('listeners', ['models']);
angular.module('debug', []);
angular.module('decorators', ['debug']);
angular.module('directives', ['templates', 'ngHtmlCompile', 'animations']);
angular.module('animations', []);
angular.module('controllers', ['templates']);
angular.module('resolvers', []);
angular.module('modals', []);
angular.module('templates', []);
angular.module('urls', ['templates', 'resolvers', 'controllers', 'modals']);
angular.module('oe', ['ngModules', '3rdPartyModules', 'i18nConfig', 'urls', 'oe.core', 'oe.enums', 'filters', 'services', 'rest.services', 'directives', 'controllers', 'animations', 'models', 'listeners', 'resolvers', 'debug', 'decorators']).config(['$httpProvider', function ($httpProvider) {

    // enable CORS calls
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    $httpProvider.defaults.headers.common = {};
    $httpProvider.defaults.headers.post = {};
    $httpProvider.defaults.headers.put = {};
    $httpProvider.defaults.headers.patch = {};

    if (!window.appName) {

        window.appName = 'avira';
    }
    if (window.appName.indexOf('partner_id }}') >= 0) {

        window.appName = 'avira';
    }

    var _CWCONFIG = CWCONFIG,
        language = _CWCONFIG.language,
        languages = _CWCONFIG.languages;
    var _window = window,
        defaultLanguage = _window.defaultLanguage;

    // redirect to under maintenance page

    if (CWCONFIG.underMaintenance) {

        if (window.location.pathname.indexOf('under-maintenance') === -1) {

            window.location.href = '/en/under-maintenance';
        }
    }

    if (_.indexOf(_.keys(languages), language) === -1) {

        // redirect with default language
        window.location.pathname = window.location.pathname.replace(language, defaultLanguage);
    }

    if (window && window.mixpanel && window.mixpanel.init) {

        window.mixpanel.init(CWCONFIG.mixpanel, { property_blacklist: ['$current_url', 'mp_page'] });
    }

    // Init sentry service

    var _CWCONFIG2 = CWCONFIG,
        enableSentry = _CWCONFIG2.enableSentry;


    if (enableSentry) {

        var sentryDsn = CWCONFIG.sentryConfig.dsn;
        var sentryDebug = CWCONFIG.sentryConfig.debug;

        Sentry.init({
            dsn: sentryDsn,
            debug: sentryDebug,
            beforeSend: function beforeSend(event, hint) {

                if (hint.originalException.indexOf('Timeout') > -1) return null;
                return event;
            },

            ignoreErrors: ['[$rootScope:inprog] $apply already in progress http://errors.angularjs.org/1.5.11/$rootScope/inprog?p0=%24apply', "Cannot read properties of null (reading 'style')", "Unable to get property 'style' of undefined or null reference", 'ErrorPage Opened with status code -1', 'Request retrying failed for https://api.my.avira.com/v2/ping with errorCode: -1'],
            release: _package.version,
            environment: 'production'
        });
    }
}]).config(['vcRecaptchaServiceProvider', function (vcRecaptchaServiceProvider) {

    vcRecaptchaServiceProvider.setLang(CWCONFIG.language);
    vcRecaptchaServiceProvider.setGlobal(true);
}])
// Angular 1.6.0: "Possibly unhandled rejection" error [duplicate]
.config(['$qProvider', function ($qProvider) {

    $qProvider.errorOnUnhandledRejections(false);
}])
/**
 * Use html5 pushstate if supported
 */
.config(['$locationProvider', function ($locationProvider) {

    $locationProvider.html5Mode(true);
}])
/**
 * Add an interceptor for ajax requests (to prefix requests with the correct cdn)
 */
.config(['$httpProvider', function ($httpProvider) {

    // Add interceptors to the $httpProvider
    $httpProvider.interceptors.push('LogHttpRESTAPIInterceptor');
    $httpProvider.interceptors.push('RetryRequestInterceptor');
}])
/**
 * Get default language and use it for the translation service
 */
.config(['$translateProvider', function ($translateProvider) {
    var _CWCONFIG3 = CWCONFIG,
        language = _CWCONFIG3.language;
    var _CWCONFIG4 = CWCONFIG,
        cdn = _CWCONFIG4.cdn;

    $translateProvider.useStaticFilesLoader({
        prefix: cdn + '/lang/' + "a24774b8e621ab1d79" + '-',
        suffix: '.json'
    });
    $translateProvider.preferredLanguage(language);
    $translateProvider.useInterpolation('Interpolation');
}]).config(_exceptionHandler2.default).run(['$document', function ($document) {

    // Dynamic page title
    $document.prop('title', 'My ' + CWCONFIG.partnerConfig.name + ' Account');

    // Dynamic meta description
    var metaDescription = angular.element('meta[name=description]');
    var description = CWCONFIG.partnerConfig.description;

    metaDescription.attr('content', description);

    // Dynamic favicons
    var cdnAssets = CWCONFIG.cdn_assets;
    var brand = CWCONFIG.partnerConfig.themeId;

    var favicons = [{
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '57x57',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-57x57.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '114x114',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-114x114.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '72x72',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-72x72.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '144x144',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-144x144.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '60x60',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-60x60.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '120x120',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-120x120.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '76x76',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-76x76.png'
    }, {
        tag: 'link',
        rel: 'apple-touch-icon-precomposed',
        sizes: '152x152',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/apple-touch-icon-152x152.png'
    }, {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '196x196',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/favicon-196x196.png'
    }, {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/favicon-96x96.png'
    }, {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/favicon-32x32.png'
    }, {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/favicon-16x16.png'
    }, {
        tag: 'link',
        rel: 'icon',
        type: 'image/png',
        sizes: '128x128',
        href: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/favicon-128.png'
    }, {
        tag: 'meta',
        name: 'msapplication-TileColor',
        content: '#FFFFFF'
    }, {
        tag: 'meta',
        name: 'msapplication-TileImage',
        content: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/mstile-144x144.png'
    }, {
        tag: 'meta',
        name: 'msapplication-square70x70logo',
        content: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/mstile-70x70.png'
    }, {
        tag: 'meta',
        name: 'msapplication-square150x150logo',
        content: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/mstile-150x150.png'
    }, {
        tag: 'meta',
        name: 'msapplication-wide310x150logo',
        content: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/mstile-310x150.png'
    }, {
        tag: 'meta',
        name: 'msapplication-square310x310logo',
        content: cdnAssets + '/extras/templates/bba_cw_images/' + brand + '/favicons/mstile-310x310.png'
    }];

    var tag = '';
    favicons.forEach(function (favicon) {

        var htmlTag = favicon.tag;
        var rel = favicon.rel ? 'rel="' + favicon.rel + '"' : '';
        var sizes = favicon.sizes ? 'sizez="' + favicon.sizes + '"' : '';
        var href = favicon.href ? 'href="' + favicon.href + '"' : '';
        var type = favicon.type ? 'type="' + favicon.type + '"' : '';
        var name = favicon.name ? 'name="' + favicon.name + '"' : '';
        var content = favicon.content ? 'content="' + favicon.content + '"' : '';

        tag = '<' + htmlTag + ' ' + rel + ' ' + type + ' ' + name + ' ' + sizes + ' ' + href + ' ' + content + ' />';
        tag = tag.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' ');

        angular.element(tag).appendTo('head');
    });
}]).run(['$rootScope', '$window', function ($rootScope, $window) {

    var cookieLang = CWCONFIG.cookie.language;
    var rootDomain = CWCONFIG.cookie.rootDomain;


    $rootScope.cdn = CWCONFIG.cdn;
    $rootScope.appName = $window.appName;

    // we use this variable to determine when to show the confirm page
    $rootScope.newRegisteredUser = false;

    // Set language cookie (duration, path and domain)
    _RFC2.default.set(cookieLang, CWCONFIG.language, {
        expires: 30,
        path: '/',
        domain: rootDomain || 'avira.com'
    });
}]).run(_appStateDebugger2.default).run(_initAppState2.default).run(['$rootScope', '$location', 'Auth', function ($rootScope, $location, Auth) {

    // Clear any cookie if page url is register, forgot or reset
    if (/auth\/register/.test($location.path()) || /auth\/forgot/.test($location.path()) || /auth\/reset/.test($location.path())) {

        Auth.removeLoginCookies();
    }

    if (window.location.href.indexOf('callback=coinbase') > -1) {

        if (window.opener) {

            window.opener.parent.postMessage('coinbase_login', window.location.origin);
            window.close();
        }
    }

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {

        // set noScroll when modals are opened
        var noScroll = false;

        if (toState.url) {

            $rootScope.State.page = toState.url;
            $rootScope.State.state = toState.name;
        }

        noScroll = _.indexOf(['dashboard.ltb', 'dashboard.ltb.next', 'dashboard.ltb.service', 'dashboard.ltb.service.deviceid', 'dashboard.ltb.devicetype', 'dashboard.device_details', 'dashboard.device_details.ltb', 'dashboard.device_details.ltb.next', 'dashboard.device_details.service', 'dashboard.device_details.service.ltb', 'dashboard.device_details.service.ltb.next', 'dashboard.device_details.service.ltb.profile', 'apps.product.ltb', 'apps.product.ltb.screen', 'apps.main.ltb', 'apps.main.ltb.info', 'dashboard.ltb.summary', 'dashboard.ltb.service.embedded', 'notAllowed'], toState.name) !== -1;

        if (!$rootScope.State.ftu) {

            $rootScope.State.noscroll = noScroll;
        }
    });
}])
/**
 * Store each page route upon navigation
 */
.run(_storeUrlParamLogic2.default);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "tZex":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("jmhn");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "u8TA":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div id=\"lightbox\" class=\"central-position no-background\">\n        <div class=\"table-display\">\n            <div class=\"table-cell-display\">\n                <div class=\"lightbox-content\">\n                    <div class=\"error-img error-expire\"></div>\n                    <h1 class=\"text-xxxl mb10\" ng-if=\"modalParams === 'offline'\" translate=\"cw.general.oouch\"></h1>\n                    <h1 class=\"text-xxxl mb10\" ng-if=\"modalParams === 'session-expired'\" translate=\"cw.dashboard.session_expired.title\"></h1>\n\n                    <h2 class=\"text-xl text-grey-4 mb30\" translate=\"cw.modal.offline_text\" ng-if=\"modalParams === 'offline'\"></h2>\n\n                    <div ng-if=\"modalParams === 'session-expired'\">\n                        <h2 class=\"text-xl text-grey-4 mb30\" translate=\"cw.dashboard.session_expired.reload_text\" ></h2>\n                        <button class=\"btn btn-large btn-primary\" ng-click=\"refreshPage()\" ng-disabled=\"waitingResponse\" translate=\"cw.general.reload_page\"></button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "u8m5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = [];

var AccountChooserController = function () {
    function AccountChooserController() {
        _classCallCheck(this, AccountChooserController);

        this.myId = _index.MeRepository.getMyId();
    }

    _createClass(AccountChooserController, [{
        key: 'mixpClickHdlAnon',
        value: function mixpClickHdlAnon(element) {

            var elmToName = {
                login: 'Login',
                register: 'Registration'
            };

            if (elmToName[element]) {

                if (this.myId) {

                    _RFC2.default.send('Dashboard Home Click ' + elmToName[element]);
                } else {

                    var source = element === 'Registration' ? 'Register Button' : 'Dashboard';
                    var msg = 'Anonymous Dashboard ' + elmToName[element] + ' Click';

                    _RFC2.default.send(msg, { Source: source });
                }
            }
        }
    }]);

    return AccountChooserController;
}();

var AccountChooserDirective = function AccountChooserDirective() {
    _classCallCheck(this, AccountChooserDirective);

    this.template = __webpack_require__("crKe");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function () {
        return new AccountChooserController();
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'accountChooserCtrl';
};

_directiveDependencies.push(function () {
    return new AccountChooserDirective();
});

angular.module('directives').directive('accountChooser', _directiveDependencies);

/***/ }),

/***/ "uAg+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

var _index = __webpack_require__("lSlM");

var _index2 = __webpack_require__("poBF");

var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFCSession = __webpack_require__("DyxV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Header directive
 */

angular.module('directives').directive('header', function () {
    return {
        restrict: 'E',
        replace: true,
        template: __webpack_require__("cgV+"),
        scope: {},
        compile: function compile() {
            return {
                pre: function pre(scope) {

                    scope.User = _index.MeRepository.getMyUser();
                    scope.issueType = '';

                    scope.referralCode = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ReferralCode) || '';
                },
                post: function post(scope) {

                    scope.setIssueType = function () {

                        scope.issueType = '';
                        scope.instancesWithIssues = scope.instancesWithIssues || [];

                        if (scope.instancesWithIssues.length > 1) {

                            scope.issueType = 'multiple';
                        } else if (scope.instancesWithIssues.length === 1) {

                            var issue = scope.instancesWithIssues[0];
                            scope.device = _index.DevicesRepository.getById(issue.relationships.device.data.id);

                            if (issue.attributes.status.svc.guard === 2 || issue.attributes.status.svc.guard === 4) {

                                scope.issueType = 'guard';
                                return;
                            }
                            if (issue.attributes.status.svc.firewall === 2 || issue.attributes.status.svc.firewall === 4) {

                                scope.issueType = 'firewall';
                                return;
                            }
                            if (issue.attributes.status.svc.mailguard === 2 || issue.attributes.status.svc.mailguard === 4) {

                                scope.issueType = 'mailguard';
                                return;
                            }
                            if (issue.attributes.status.svc.webguard === 2 || issue.attributes.status.svc.webguard === 4) {

                                scope.issueType = 'webguard';
                            }
                        }
                    };

                    // broadcast when the user mouseover the header
                    scope.broadcastMouseOver = function () {

                        _RFC2.default.broadcast('mainControlls:hover');
                    };

                    // direct binding for issues
                    var issuesObservable = _index2.IssuesProcessor.getObservable();
                    var issuesSubscriber = issuesObservable.subscribe(function (data) {

                        scope.instancesWithIssues = _.values(data);
                        scope.setIssueType();
                    }, function () {}, function () {});

                    scope.$on('$destroy', function () {

                        issuesSubscriber.dispose();
                    });

                    // direct binding for devices
                    var devicesObservable = _index.DevicesRepository.getObservable();
                    var onNextDevice = function onNextDevice() {

                        scope.setIssueType();
                    };
                    var devicesSubscriber = devicesObservable.subscribe(onNextDevice, function () {}, function () {});

                    scope.$on('$destroy', function () {

                        devicesSubscriber.dispose();
                    });
                }
            };
        }
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "uH2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates', '$compile'];

var DeploymentWizardGeneratorDirective = function DeploymentWizardGeneratorDirective(Templates, $compile) {
    _classCallCheck(this, DeploymentWizardGeneratorDirective);

    this.template = __webpack_require__("ef7C");
    this.restrict = 'EA';
    this.replace = true;
    this.scope = {
        dynamicDirectiveTag: '=', // used to change directives on the fly,
        // DO NOT change the value of the directive when using the changeWizard fn
        // as a weird bug happens and the user gets stuck in the same modal.
        inputData: '=?', // used to pass around parameters between deployment modals, the inputData is marked as optional
        changeWizard: '&', // used to pass a method in the directive scope, so it can be called within our directive,
        showSuccessScreen: '&',
        deployOnDeviceSuccess: '&'
    };
    this.link = function (scope, element) {

        // every time we change the directive we recompile
        scope.$watch('dynamicDirectiveTag', function (newValue) {

            element.html($compile(newValue)(scope));
        });
    };
};

_directiveDependencies.push(function (Templates, $compile) {
    return new DeploymentWizardGeneratorDirective(Templates, $compile);
});

angular.module('directives').directive('deploymentWizardGenerator', _directiveDependencies);

/***/ }),

/***/ "uOGN":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content modal-standard-width\" connectqa-modal=\"confirm-login\">\n\t<div class=\"content-holder\">\n\t\t<div class=\" mt30 mb30\">\n\t\t\t<i class=\"icon-restricted\"></i>\n\t\t</div>\n\t\t<h2 class=\"text-xxl mb20\" translate=\"cw.login.confirm_modal_title\"></h2>\n\t\t<p class=\"text-m mb20\" translate=\"cw.login.confirm_modal_description\" translate-values=\"{brandname: brandName}\"></p>\n\t\t<div class=\"mb20\">\n\t\t\t<button class=\"btn btn-medium btn-secondary mlr5\" ng-click=\"cancel()\" translate=\"cw.form.profile.cancel\"\n\t\t\t\tconnectqa-button=\"cancel\"></button>\n\t\t\t<button class=\"btn btn-medium btn-primary mlr5\" ng-click=\"confirm()\" translate=\"cw.general.ui.confirm\"\n\t\t\t\tconnectqa-button=\"confirm-login\"></button>\n\t\t</div>\n\t</div>\n</div>\n";
var path = 'scripts/controllers/modals/confirm-login/confirm-login.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "uOJ5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _RFCSession = __webpack_require__("DyxV");

var _index = __webpack_require__("lSlM");

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$rootScope', '$interval', '$scope', 'Auth', 'Util', 'Sso', '$window', 'MyAccountCountriesService', 'UserRestService', '$state'];
/**
 * @ngdoc service
 * @name controllers.Register
 *
 * @description
 * Register controller
 */

var Register = function () {

    /**
     * @param  {any} $scope
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} Sso
     * @param  {any} $window
     */
    function Register($rootScope, $interval, $scope, Auth, Util, Sso, $window, MyAccountCountriesService, UserRestService, $state) {
        var _this = this;

        _classCallCheck(this, Register);

        this.Auth = Auth;
        this.Sso = Sso;
        this.$window = $window;
        this.Util = Util;
        this.Recaptcha = _recaptcha2.default;
        this.$rootScope = $rootScope;
        this.$interval = $interval;
        this.$scope = $scope;
        this.$scope.submitted = false;
        this.$scope.socialMediaSubmitted = false;
        this.$scope.firstStepSubmited = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.firstNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.lastNameRegExp = this.Util.getFullNameValidationRegExp();
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.showChangeLang = true;
        this.$scope.showSocialLogin = true;
        this.$scope.showEmbeddedSocialLogin = false;
        this.$scope.clientId = 'dashboard';
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
        this.$scope.hrefLegalTerms = CWCONFIG.partnerConfig.translationsLinks.eula.legalTerms.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralPrivacy = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralImprint = CWCONFIG.partnerConfig.translationsLinks.generalImprint.replace('{language}', CWCONFIG.language);
        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);
        this.MeRepository = _index.MeRepository;
        this.UserRestService = UserRestService;
        this.$state = $state;

        var user = this.MeRepository.getMyUser();
        this.$scope.countries = MyAccountCountriesService.getCountries();
        this.$rootScope.registerActiveStep = '1';
        this.$scope.country = '';

        if (user) {

            this.$scope.firstName = Util.deepFind(user, 'attributes.first_name') || '';
            this.$scope.lastName = Util.deepFind(user, 'attributes.last_name') || '';
            var userCountry = Util.deepFind(user, 'attributes.country') || '';
            this.$scope.country = this.$scope.countries.find(function (value) {
                return value.code === userCountry;
            });
        }

        this.$scope.validateEmailError = true;

        $scope.validateConfirmEnail = function () {

            if (_this.$scope.email === _this.$scope.confirmEmail) {

                _this.$scope.validateEmailError = false;
            } else {

                _this.$scope.validateEmailError = true;
            }
        };

        $scope.validateCountry = function (country) {

            if (country) {

                _this.$scope.country = country;
                _this.$scope.countryError = false;
            }
        };

        var initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));

        this.$scope.showCustomAuth = false;

        this.socialLoginUrl = initialUrl;

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();

            // show the embedded social login button if we receive a embedded_social=true param
            this.$scope.showEmbeddedSocialLogin = this.Sso.getEmbeddedSocialLogin();

            this.$scope.clientId = this.Sso.getClientId();

            if (initialUrl.indexOf('client_id=spotlight') > -1) {

                /**
                 * Set the URL for the social button that will redirect to the Sso page
                 * in the browser with other default values
                 */
                var token = Util.getToken();
                // close the embedded sso page if sso token is missing
                if (!token || token === 'undefined') {

                    if (window.external && 'CloseHtml' in window.external) {

                        window.external.CloseHtml('social login redirect to dashboard');
                    }
                }
                this.socialLoginUrl = this.socialLoginUrl.replace('embedded_social=true', 'embedded_social=false').replace('social_login=false', 'social_login=true').replace('change_lang=false', 'change_lang=true').replace('embedded=true', 'embedded=false').replace(Util.getParams(initialUrl).access_token, token);

                // this means user landed in login page and switched tabs to register
                // so our redirect must now be to register
                if (this.socialLoginUrl.indexOf('auth/login') > -1) {

                    this.socialLoginUrl = this.socialLoginUrl.replace('auth/login', 'auth/register');
                }
            }
        }

        _RFC2.default.send('ConnectWeb Auth Register Open', {
            Source: 'Direct'
        });
        this.passwordScore = {};

        this.$scope.$on('$destroy', function () {

            if (_this.$scope.showCustomAuth) {

                angular.element('.landing-page-auth').show();
            }
        });
    }

    _createClass(Register, [{
        key: 'register',
        value: function register() {

            var oauthPayload = {
                grant_type: 'client_credentials'
            };

            var headers = {};

            var captchaRespose = this.Recaptcha.getCaptchaResponse();

            if (captchaRespose) {

                headers['X-Avira-Captcha-Token'] = captchaRespose;
            }

            // UTC timestamp ISO 8601
            var timestamp = moment().toISOString();

            // retrieve the x-a-* params and forward them to the backend
            var ssoParams = this.Sso.getParams();
            var metaParams = {};
            Object.keys(ssoParams).forEach(function (key) {

                if (key.indexOf('x-a-') > -1) {

                    metaParams[key] = ssoParams[key];
                }
            });

            var userPayload = {
                type: 'users',
                data: {
                    attributes: {
                        first_name: this.$scope.firstName,
                        last_name: this.$scope.lastName,
                        email: this.$scope.email,
                        password: this.$scope.password,
                        language: CWCONFIG.language,
                        gdpr_consent: timestamp,
                        country: this.$scope.country.code
                    }
                },
                meta: {
                    'x-params': metaParams,
                    check_ustc: true,
                    check_ustc_synchronous: true
                }
            };

            this.getPasswordScore(this.$scope.password);

            // Check if the username, email and password are valid
            var formIsValid = this.$scope.registerForm.$valid && this.passwordScore.valid && this.$scope.country.code;

            _RFC2.default.send('ConnectWeb Register Click', {
                Page: 'Auth Register'
            });

            if (!this.$scope.country.name) {

                this.$scope.countryError = true;
            }

            this.$scope.submitted = true;

            var mixpanelError = '';

            if (formIsValid) {

                this.Auth.loading = true;

                // if the user is anonymous
                if (this.Util.isAnonymous()) {

                    this.Auth.loginType = 'Register Anon'; // Login type for mixpanel event
                    this.Auth.registerAnon(userPayload);
                } else {

                    this.Auth.loginType = 'Register'; // Login type for mixpanel event
                    this.Auth.register(oauthPayload, headers, userPayload);
                }
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');

                if (this.$scope.registerForm.firstName.$invalid) {

                    mixpanelError += 'name is empty, ';
                }

                if (this.$scope.registerForm.email.$invalid) {

                    if (typeof this.$scope.registerForm.email.$viewValue === 'undefined' || this.$scope.registerForm.email.$viewValue === '') {

                        mixpanelError += 'email is empty, ';
                    } else {

                        mixpanelError += 'email format not correct, ';
                    }
                }

                if (this.$scope.registerForm.password.$invalid) {

                    if (typeof this.$scope.registerForm.password.$viewValue === 'undefined' || this.$scope.registerForm.password.$viewValue === '') {

                        mixpanelError += 'password is empty, ';
                    } else {

                        mixpanelError += 'password format not correct, ';
                    }
                }

                _RFC2.default.send('ConnectWeb Register Error', {
                    'Error Name': mixpanelError.replace(/,\s*$/, '') // remove last ',' and ' '
                });
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {

            if (this.Recaptcha.captchaRetries <= this.Auth.failedLogins) {

                this.Recaptcha.enableCaptcha();
            }

            if (this.Recaptcha.isCaptchaRequired()) {

                this.Recaptcha.execute();
            } else {

                this.register();
            }
        }
    }, {
        key: 'onSubmitSocialMedia',
        value: function onSubmitSocialMedia() {
            var _this2 = this;

            var ssoParams = JSON.parse(sessionStorage.getItem('SsoExtraUrlParams'));

            var formIsValid = this.$scope.registerFormSocialMedia.$valid;
            var user = this.MeRepository.getMyUser();
            this.$scope.socialMediaSubmitted = true;
            var initialUrl = String(_RFCSession.Session.getValue(_RFCSession.SessionKeys.InitialUrl));

            if (!this.$scope.country.name) {

                this.$scope.countryError = true;
            }

            if (formIsValid) {

                this.$scope.submitSocialMediaLoading = true;
                var userPayload = {
                    type: user.type,
                    id: user.id,
                    data: {
                        attributes: {
                            first_name: this.$scope.firstName,
                            last_name: this.$scope.lastName,
                            country: this.$scope.country.code
                        }
                    },
                    meta: {
                        check_ustc: true
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: user.relationships.partner.data.type,
                                id: user.relationships.partner.data.id
                            }
                        }
                    }
                };

                if (this.$rootScope.userCheckSync) {

                    userPayload.meta.check_ustc_synchronous = true;
                }

                this.UserRestService.update(user.id, userPayload).then(function (response) {

                    _this2.MeRepository.update(response.data.data);
                    _this2.$scope.submitSocialMediaLoading = false;

                    if (ssoParams) {

                        if (ssoParams.client_id === 'unicorn' && ssoParams.redirect_uri === 'avira-security://embargo') {

                            _RFC4.default.success('Submitted true');
                            _this2.$window.location.href = ssoParams.redirect_uri;
                        }
                    }

                    if (initialUrl.indexOf('client_id=spotlight') > -1) {

                        if (window.external && 'CloseHtml' in window.external) {

                            window.external.CloseHtml('confirmed');
                        }
                    }
                }).then(null, function (error) {

                    _this2.$scope.submitSocialMediaLoading = false;
                    var errorObj = _this2.Util.deepFind(error, 'data.errors')[0];
                    var errorCode = _this2.Util.deepFind(errorObj, 'code');

                    if (errorCode === '22906') {

                        _this2.$rootScope.isComingFromEmbargoedCountry = true;

                        if (initialUrl.indexOf('client_id=spotlight') > -1 && initialUrl.indexOf('action=user_check_sync') > -1) {

                            _this2.$rootScope.showLoginTitle = true;
                        }

                        _this2.UserRestService.getMeAsync().then(function (response) {

                            _this2.MeRepository.update(response.data.data);
                        });
                    }
                });
            } else {

                this.$scope.socialMediaSubmitted = true;
                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }, {
        key: 'setCaptchaResponse',
        value: function setCaptchaResponse(response) {

            this.Recaptcha.setCaptchaResponse(response);
            this.register();
        }

        // SSO skip the login and redirect to skip_uri received in params

    }, {
        key: 'skip',
        value: function skip() {

            _RFC2.default.send('ConnectWeb Skip Click', {
                Page: 'Auth Login'
            });

            this.$window.location = this.$scope.skipUri;
        }
    }, {
        key: 'showPassword',
        value: function showPassword() {

            var inputType = angular.element('#password')[0];

            if (inputType.type === 'text') {

                inputType.type = 'password';
            } else {

                inputType.type = 'text';
            }

            this.$scope.inputType = inputType.type;
        }
    }, {
        key: 'getPasswordScore',
        value: function getPasswordScore(password) {

            this.passwordScore = this.Util.getPasswordScore(password);
        }

        // redirect from Spotlight to dashboard Sso in the default browser of the user

    }, {
        key: 'socialLoginRedirect',
        value: function socialLoginRedirect() {

            if (window.external && 'OpenUrl' in window.external) {

                window.external.OpenUrl(this.socialLoginUrl);
            } else {

                window.open(this.socialLoginUrl, '_blank');
            }

            if (window.external && 'CloseHtml' in window.external) {

                window.external.CloseHtml('social login redirect to dashboard');
            }
        }
    }, {
        key: 'proceedToNextStep',
        value: function proceedToNextStep() {
            var _this3 = this;

            this.$scope.firstStepSubmited = true;
            this.$scope.submitted = false;

            if (this.$scope.registerForm.email.$valid && !this.$scope.validateEmailError && this.$scope.registerForm.password.$valid && this.passwordScore.valid) {

                this.$rootScope.registerActiveStep = '2';

                if (this.$rootScope.requestCountry) {

                    this.$scope.country = this.$scope.countries.find(function (value) {
                        return value.code === _this3.$rootScope.requestCountry;
                    });
                }
            } else {

                this.Util.triggerAnimation('.error', 'animated shake');
            }
        }
    }]);

    return Register;
}();

_serviceDependencies.push(Register);

angular.module('controllers').controller('Register', _serviceDependencies);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "ubfM":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("SiCv");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "ueyR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _index2 = __webpack_require__("poBF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', '$state', 'Util'];

/**
 * @ngdoc service
 * @name directives.ChooseDeviceDeploymentWizardController
 *
 * @description
 * ChooseDeviceDeploymentWizardController
 */

var ChooseDeviceDeploymentWizardController = function () {
    function ChooseDeviceDeploymentWizardController($scope, $state, Util) {
        _classCallCheck(this, ChooseDeviceDeploymentWizardController);

        this.$scope = $scope;
        this.$state = $state;
        this.MeRepository = _index.MeRepository;
        this.DevicesRepository = _index.DevicesRepository;
        this.DevicesProcessor = _index2.DevicesProcessor;
        this.AppInstancesProcessor = _index2.AppInstancesProcessor;
        this.Util = Util;

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found
            this.Util.closeModal();
        }

        this.$scope.displayedDevicesList = this.DevicesProcessor.getCompatibleDevices(this.app.id, this.app.attributes.prototype);

        if (!this.$scope.displayedDevicesList.length) {

            this.addNewDevice();
        }
    }

    _createClass(ChooseDeviceDeploymentWizardController, [{
        key: 'addNewDeviceFromView',
        value: function addNewDeviceFromView() {

            _RFC2.default.send('ConnectWeb Add New Device Click', { Page: 'Deployment Modal' });

            this.addNewDevice();
        }
    }, {
        key: 'addNewDevice',
        value: function addNewDevice() {

            var supportedOs = _index.AppIntegrationsRepository.getSupportedOs(this.app.id) || ['windows'];

            var stateName = this.$state.current.name;
            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';
            }

            if (this.$scope.inputData.deployType) {

                // Deploy
                this.$scope.changeWizard()(stateName, {
                    resourceId: this.app.id,
                    deviceId: 'new',
                    os: 'windows'
                }, {
                    reload: false
                });
            } else if (supportedOs.length >= 2) {

                // Choose OS

                this.$scope.changeWizard()(stateName, {
                    resourceId: this.$scope.inputData.resourceId || this.$state.params.resourceId,
                    appId: this.app.id,
                    deviceId: 'new'
                }, {
                    reload: false
                });
            } else {

                // Deploy
                this.$scope.changeWizard()(stateName, {
                    resourceId: this.app.id,
                    deviceId: 'new',
                    os: supportedOs[0]
                }, {
                    reload: false
                });
            }
        }

        /**
         * @ngdoc function
         * @name directives.ChooseDeviceDeploymentWizardController#deployOn
         * @methodOf directives.ChooseDeviceDeploymentWizardController
         * @function
         *
         * @description
         * This function chooses online deployment or offline deployment.
         *
         * @param {Object} device The device object
         */

    }, {
        key: 'deployOn',
        value: function deployOn(device) {

            _RFC2.default.send('ConnectWeb Existing Device Click', { Page: 'Deployment Modal' });

            this.$scope.deployOnDeviceSuccess()(device, this.app.id, {});
        }
    }]);

    return ChooseDeviceDeploymentWizardController;
}();

var ChooseDeviceDeploymentWizardDirective = function ChooseDeviceDeploymentWizardDirective() {
    _classCallCheck(this, ChooseDeviceDeploymentWizardDirective);

    this.template = __webpack_require__("Jcyh");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, $state, Util) {
        return new ChooseDeviceDeploymentWizardController($scope, $state, Util);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'chooseDeviceDeploymentWizardCtrl';
};

_directiveDependencies.push(function () {
    return new ChooseDeviceDeploymentWizardDirective();
});

angular.module('directives').directive('chooseDeviceDeploymentWizard', _directiveDependencies);

/***/ }),

/***/ "ujNk":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("TBo3"),
    createBaseEach = __webpack_require__("lCSl");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "unVR":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("MS9Y"),
    getMatchData = __webpack_require__("Fh6p"),
    matchesStrictComparable = __webpack_require__("jszl");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "uqfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("pScZ");

__webpack_require__("hIFk");

__webpack_require__("X1NH");

__webpack_require__("/jWC");

__webpack_require__("qzsh");

__webpack_require__("sRTE");

__webpack_require__("/6DI");

__webpack_require__("1Qa8");

__webpack_require__("eMuH");

__webpack_require__("MWVi");

__webpack_require__("QoJf");

__webpack_require__("4VYb");

__webpack_require__("H/dH");

__webpack_require__("6JCO");

__webpack_require__("W4hc");

__webpack_require__("CyOw");

__webpack_require__("j7ko");

__webpack_require__("2kat");

__webpack_require__("K3ju");

__webpack_require__("s0mi");

__webpack_require__("DL1i");

__webpack_require__("VetG");

__webpack_require__("L/rC");

__webpack_require__("/Up0");

__webpack_require__("+2WP");

__webpack_require__("+quY");

__webpack_require__("mVn8");

__webpack_require__("cbBA");

__webpack_require__("odJ+");

__webpack_require__("z2L+");

__webpack_require__("IfBK");

__webpack_require__("Z9TC");

__webpack_require__("NRXx");

__webpack_require__("Jsc+");

__webpack_require__("9bIT");

__webpack_require__("8v5l");

__webpack_require__("BuSR");

__webpack_require__("QHS2");

__webpack_require__("aqbE");

__webpack_require__("6Tbp");

__webpack_require__("uAg+");

__webpack_require__("u8m5");

__webpack_require__("gPoZ");

__webpack_require__("yBp6");

__webpack_require__("nogF");

__webpack_require__("CA8a");

__webpack_require__("OkiX");

__webpack_require__("eZcD");

__webpack_require__("X9N5");

__webpack_require__("WqM0");

__webpack_require__("1QLL");

__webpack_require__("PKth");

__webpack_require__("P3ym");

__webpack_require__("f+JQ");

__webpack_require__("Pyvz");

__webpack_require__("BqaP");

__webpack_require__("6yWV");

__webpack_require__("EAai");

__webpack_require__("ueyR");

__webpack_require__("vitq");

__webpack_require__("rIec");

__webpack_require__("eQXF");

__webpack_require__("V5z1");

__webpack_require__("kEQl");

__webpack_require__("3ZGu");

__webpack_require__("wS4J");

__webpack_require__("Z24y");

__webpack_require__("rPHv");

__webpack_require__("amg2");

__webpack_require__("Bn/k");

__webpack_require__("uH2G");

__webpack_require__("I/a1");

__webpack_require__("8wEn");

/***/ }),

/***/ "v/3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = htmlTreeAsString;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocationHref;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("0VhR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__("+d4d");


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var _a, _b;
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = ((_a = keyAttrs) === null || _a === void 0 ? void 0 : _a.length) ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if ((_b = keyAttrPairs) === null || _b === void 0 ? void 0 : _b.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobalObject */])();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ "v0w9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

angular.module('resolvers').myaToken = function ($q) {

    var deferred = $q.defer();

    if (_index.MeRepository.getMyaHash()) {

        deferred.resolve();
    }

    return deferred.promise;
};

angular.module('resolvers').myaToken.$inject = ['$q'];

/***/ }),

/***/ "v3EM":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("DYPj");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "v7hp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint class-methods-use-this: 0 */


var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$scope', 'Util'];

var _Util = void 0;
/**
 * @ngdoc service
 * @name controllers.GetReport
 *
 * @description
 * Request GDPR report modal confimartion
 */

var GetReport = function () {

    /**
     * @param  {any} $scope
     * @param  {any} Util
     */
    function GetReport($scope, Util) {
        _classCallCheck(this, GetReport);

        _Util = Util;
        $scope.email = _index.MeRepository.getMyUser().attributes.email;
        $scope.closeModal = this.closeModal;
    }

    _createClass(GetReport, [{
        key: 'closeModal',
        value: function closeModal() {

            _Util.closeModal();
        }
    }]);

    return GetReport;
}();

_serviceDependencies.push(GetReport);

angular.module('controllers').controller('GetReport', _serviceDependencies);

/***/ }),

/***/ "vDBK":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("ICfp"),
    Map = __webpack_require__("9u6A"),
    MapCache = __webpack_require__("sd1L");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "vKGA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.RecommendationsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */

var RecommendationsRestService = function (_BaseRestService) {
    _inherits(RecommendationsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function RecommendationsRestService($http, $q, Util) {
        _classCallCheck(this, RecommendationsRestService);

        return _possibleConstructorReturn(this, (RecommendationsRestService.__proto__ || Object.getPrototypeOf(RecommendationsRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.RecommendationsRestService#getAllAsync
    * @methodOf rest.services.RecommendationsRestService
    * @function
    *
    * @description
    * Retrieves app information.
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(RecommendationsRestService, [{
        key: 'getAllAsync',
        value: function getAllAsync() {

            return _get(RecommendationsRestService.prototype.__proto__ || Object.getPrototypeOf(RecommendationsRestService.prototype), 'getAllAsync', this).call(this, 'app-recommendations/');
        }
    }]);

    return RecommendationsRestService;
}(_baseRestService2.default);

exports.default = RecommendationsRestService;


_serviceDependencies.push(RecommendationsRestService);

angular.module('rest.services').service('RecommendationsRestService', _serviceDependencies);

/***/ }),

/***/ "vL8v":
/***/ (function(module, exports) {

module.exports = "\n<ul>\n    <li ng-repeat=\"device in source\"\n        ng-if=\"!device.attributes.hidden\"\n        class=\"card\"\n        ng-class=\"{'pending-device-card': device.attributes.state === 'pending'}\"\n        connectqa-device=\"{{device.attributes.os}}-{{device.attributes.type}}\">\n\n        <div class=\"restricted-access\" ng-if=\"device.attributes.locked\">\n            <div class=\"icon icon-xs icon-grey-3 icon-lock inline-block\"></div>\n        </div>\n\n        <div class=\"license-status\">\n            <!-- User Paid -->\n            <div ng-if=\"userHasSubscriptions\">\n                <!-- Protected -->\n                <div class=\"info-tooltip-holder\"\n                    ng-if=\"device.attributes.licenses.length > 0 && !device.attributes.showLicenseWarning && device.attributes.hasBundle\">\n                    <span class=\"icon icon-size icon-Shield icon-green-2\"></span>\n                    <div class=\"info-tooltip arrow-bottom\"\n                        translate=\"cw.my_devices.license_tooltip.protected\"\n                        translate-values=\"{brandname : brandName}\"></div>\n                </div>\n                <!-- Maximize -->\n                <!-- <div class=\"info-tooltip-holder crs-pointer\"\n                    ng-if=\"(device.attributes.licenses.length > 0 && !device.attributes.showLicenseWarning && !device.attributes.hasBundle && $root.hasUsCompliance)\n                            || (device.attributes.licenses.length === 0 && device.attributes.hasIncompatibleLicense && $root.hasUsCompliance)\"\n                    ui-sref=\"root.dashboard.store\"\n                    ng-click=\"deviceCardCtrl.sendMixpanelEvent('tooltip', 'Maximize protection')\">\n                    <span class=\"icon icon-size icon-Information-outline icon-blue-3\"></span>\n                    <div class=\"info-tooltip arrow-bottom\">\n                        <span>+ <span>\n                        <a class=\"text-white underline-hover\" translate=\"cw.my_devices.license_tooltip.maximize\"></a>\n                    </div>\n                </div> -->\n                <!-- Expiring -->\n                <div class=\"info-tooltip-holder crs-pointer\"\n                     ng-if=\"device.attributes.showLicenseWarning && $root.hasUsCompliance\"\n                     ui-sref=\"root.dashboard.subscriptions({tab:'plans'})\"\n                     ng-click=\"deviceCardCtrl.sendMixpanelEvent('tooltip', 'Expiring license')\">\n                    <span class=\"icon icon-size icon-Alert--outline icon-orange-2\"></span>\n                    <div class=\"info-tooltip arrow-bottom\">\n                        <span>+ <span>\n                        <a class=\"text-white underline-hover\" translate=\"cw.my_devices.license_tooltip.expiring\"></a>\n                    </div>\n                </div>\n                <!-- Install -->\n                <div class=\"info-tooltip-holder crs-pointer\"\n                     ng-if=\"device.attributes.licenses.length === 0 && !device.attributes.hasIncompatibleLicense && $root.hasUsCompliance && !hasOnlyAiaLicense\"\n                     ng-click=\"deviceCardCtrl.deployOn(device.attributes.os); deviceCardCtrl.sendMixpanelEvent('tooltip', 'Install license')\">\n                    <span class=\"icon icon-size icon-Information-outline icon-blue-3\"></span>\n                    <div class=\"info-tooltip arrow-bottom\">\n                        <span>+ <span>\n                        <a class=\"text-white underline-hover\" translate=\"cw.my_devices.license_tooltip.install_license\"></a>\n                    </div>\n                </div>\n            </div>\n            <!-- User Free -->\n            <div ng-if=\"!userHasSubscriptions && $root.hasUsCompliance\">\n                <!-- Upgrade -->\n                <!-- <div class=\"info-tooltip-holder crs-pointer\"\n                     ng-if=\"device.attributes.hasInstances\"\n                     ui-sref=\"root.dashboard.store\"\n                     ng-click=\"deviceCardCtrl.sendMixpanelEvent('tooltip', 'Upgrade free user')\">\n                    <span class=\"icon icon-size icon-Information-outline icon-blue-3\"></span>\n                    <div class=\"info-tooltip arrow-bottom\">\n                        <span>+ <span>\n                        <a class=\"text-white underline-hover\"  translate=\"cw.my_devices.license_tooltip.upgrade\"></a>\n                    </div>\n                </div> -->\n                <!-- Install -->\n                <div class=\"info-tooltip-holder crs-pointer\"\n                     ng-if=\"!device.attributes.hasInstances\"\n                     ng-click=\"deviceCardCtrl.deployOn(device.attributes.os); deviceCardCtrl.sendMixpanelEvent('tooltip', 'Install FSS')\">\n                    <span class=\"icon icon-size icon-Information-outline icon-blue-3\"></span>\n                    <div class=\"info-tooltip arrow-bottom\">\n                        <span>+ <span>\n                        <a class=\"text-white underline-hover\" translate=\"cw.my_devices.license_tooltip.install_free\" translate-values= \"{brandname: brandName, product: product}\"></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"top-holder\">\n\n            <div class=\"icon icon-xs icon-grey-3 icon-remove crs-pointer\"\n                ng-if=\"device.attributes.state === 'pending'\"\n                ui-sref=\"root.dashboard.devices.ltb({ltb: 'remove-device', resourceId: device.id})\"\n                connectqa-pending=\"trash-bin\">\n            </div>\n        </div>\n\n        <!-- non pending device -->\n        <div ng-if=\"device.attributes.state !== 'pending'\" connectqa-device=\"non-pending\">\n            <div class=\"medium-holder\">\n                <div class=\"device-details-section\"\n                    ng-click=\"deviceCardCtrl.viewDetailsFromListView(device.id); deviceCardCtrl.sendMixpanelEvent('device_details');\">\n                    <div class=\"device-icon-holder inline-block mb20\">\n                        <i class=\"icon icon-{{device.attributes.type}}-{{device.attributes.os}} icon-l icon-grey-3\"></i>\n                    </div>\n\n                    <div>\n                        <device-rename data=\"device\" ></device-rename>\n                    </div>\n                </div>\n\n                <div class=\"device-licenses text-grey-3\">\n                    <!-- No license -->\n                    <div ng-if=\"device.attributes.licenses.length === 0\">\n                        <span class=\"license-pre-text-grid\" translate=\"cw.device_info.installed_license_label\"></span>\n                        <span class=\"text-grey-1\" translate=\"cw.general.none\"\n                        connectqa-device=\"no-license\"></span>\n                    </div>\n\n                    <!-- 1 license -->\n                    <div ng-if=\"device.attributes.licenses.length === 1\">\n                        <span class=\"license-pre-text-grid\" translate=\"cw.device_info.installed_license_label\"></span>\n                        <span class=\"text-green-1\"\n                        connectqa-device=\"one-license\">{{device.attributes.licenses[0]}}</span>\n                    </div>\n\n                    <!-- Multiple licenses -->\n                    <div ng-if=\"device.attributes.licenses.length > 1\">\n                        <a class=\"show-dropdown\"\n                            ng-class=\"{'opened' : toggleDropdown, 'closed': !toggleDropdown}\"\n                            ng-click=\"toggleDropdown=!toggleDropdown\"\n                            connectqa-device=\"multiple-licenses\">\n                            <span class=\"license-pre-text-grid\" translate=\"cw.device_info.installed_licenses_label\"></span>\n                            <span class=\"license-pre-text-list\" translate=\"cw.general.licenses\"></span>\n                        </a>\n\n                        <ul class=\"dropdown-licenses\" ng-show=\"toggleDropdown\">\n                            <div class=\"scrollbar-dynamic\" data-jquery-scrollbar>\n                                <li ng-repeat=\"license in device.attributes.licenses\">\n                                    {{license}}\n                                </li>\n                            </div>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"bottom-holder\">\n                <div class=\"click-holder btn-secondary\"\n                     ng-click=\"deviceCardCtrl.sendMixpanelEvent('device_details')\"\n                     ui-sref=\"root.dashboard.device-details({resourceId: device.id, tab: 'apps'})\">\n                    <a class=\"text-m detail-button\" translate=\"cw.dashboard.device.view_details\" connectqa-device=\"details\"></a>\n                </div>\n\n            </div>\n        </div>\n    </li>\n\n    <!-- Add Devices -->\n    <li id=\"deploy-by-os\" class=\"add-device-card card\" ng-if=\"!source && $root.hasUsCompliance\">\n        <div class=\"text-center\">\n            <div class=\"medium-holder\">\n                <h1 class=\"text-grey-2 text-xl\" translate=\"cw.device.protect\"></h1>\n                <h2 class=\"text-grey-3 text-m\">\n                    <span ng-hide=\"licenses\" translate=\"cw.device.choose_os\"></span>\n                </h2>\n                <div class=\"card-button-holder\">\n                    <a id=\"deploy-on-windows\" ng-click=\"deviceCardCtrl.deployOn('windows')\">\n                        <i class=\"icon icon-windows icon-grey-3 icon-m mb10\"></i>\n                        <span class=\"text-m text-grey-3\" translate=\"cw.general.os.windows\"></span>\n                    </a>\n                    <a id=\"deploy-on-osx\" ng-click=\"deviceCardCtrl.deployOn('osx')\">\n                        <i class=\"icon icon-osx icon-grey-3 icon-m mb10\"></i>\n                        <span class=\"text-m text-grey-3\" translate=\"cw.general.os.osx\"></span>\n                    </a>\n\n                    <a id=\"deploy-on-android\" ng-click=\"deviceCardCtrl.deployOn('android')\">\n                        <i class=\"icon icon-android icon-grey-3 icon-m mb10\"></i>\n                        <span class=\"text-m text-grey-3\" translate=\"cw.general.os.android\"></span>\n                    </a>\n\n                    <a id=\"deploy-on-ios\" ng-click=\"deviceCardCtrl.deployOn('ios')\">\n                        <i class=\"icon icon-ios icon-grey-3 icon-m mb10\"></i>\n                        <span class=\"text-m text-grey-3\" translate=\"cw.general.os.ios\"></span>\n                    </a>\n                </div>\n                <div class=\"card-horizontal-bar\"></div>\n                <div class=\"card-vertical-bar\"></div>\n            </div>\n            <div class=\"medium-holder-list-view\"\n                 ng-click=\"deviceCardCtrl.deployOnCategory(category); deviceCardCtrl.sendMixpanelEvent('add_device');\">\n                <div class='add-device-hexagon-button'>\n                    <div class='hexagon'>\n                        <i class=\"icon icon-plus-2 icon-grey-3\"></i>\n                    </div>\n                    <span class='text-blue-1' translate=\"cw.my_devices.add_device\"></span>\n                </div>\n            </div>\n\n        </div>\n    </li>\n\n    <li\n        class=\"card pending-install-card\"\n        ng-if=\"!source && $root.hasUsCompliance && $root.showPendingInstallCard\"\n        ng-class=\"{'pending-device-card': device.attributes.state === 'pending'}\">\n        <div class=\"medium-holder\">\n            <div class=\"device-details-section\">\n                <div class=\"device-icon-holder inline-block mb30\">\n                    <i class=\"icon icon-pc-{{$root.pendingInstallCardOs}} icon-l icon-grey-3\"></i>\n                </div>\n            </div>\n            <div class=\"text-m text-grey-2 inline-block plr20\" translate=\"cw.deploy.auto-install.desc\"></div>\n            <div class=\"loader-wrapper\">\n                <div class=\"main-loader mt15\"></div>\n            </div>\n        </div>\n    </li>\n\n</ul>"

/***/ }),

/***/ "vS/D":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-auth\">\n    <div class=\"auth-region\">\n\n        <a ui-sref=\"root.auth.login\" ng-click=\"oauthCtrl.Auth.removeLoginCookies()\" class=\"logo-mobile\">\n            <i class=\"sprite sprite-logo\"></i>\n            <h1>{{State.partner.name}}</h1>\n        </a>\n\n        <div class=\"form-wrapper\">\n\n            <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                <change-language ng-if=\"showChangeLang\"></change-language>\n            </h3>\n\n            <h1 class=\"text-xxl text-grey-1 mb5\" translate=\"cw.auth.confirm.title\" connectqa-confirm=\"header\"></h1>\n            <h2 class=\"text-l text-grey-4 mb15\" translate=\"cw.auth.confirm.desc\" connectqa-confirm=\"paragraph\"></h2>\n\n            <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': oauthCtrl.Auth.error}\">\n                <h5 class=\"text-m text-red-2\" id=\"error-message-form\" ng-if=\"oauthCtrl.Auth.error\">\n                    <span translate=\"cw.notification.sendEmail.error\"></span>\n                </h5>\n            </div>\n\n            <form class=\"auth-form\" name=\"confirmAccountForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.onSubmit()\">\n\n                <div class=\"form-group\">\n                    <input type=\"text\"\n                           ng-model=\"email\"\n                           name=\"email\"\n                           maxlength=\"100\"\n                           focus=\"email\"\n                           autocomplete=\"off\"\n                           ng-class=\"{'error': confirmAccountForm.email.$invalid && submitted}\"\n                           id=\"email\"\n                           placeholder=\"{{ 'cw.form.email' | translate }}\"\n                           ng-disabled=\"isDisabled\"\n                           ng-pattern=\"emailRegExp\"\n                           required connectqa-confirm=\"email-address\"/>\n\n                    <label ng-hide=\"confirmAccountForm.email.$viewValue.length > 0\" class=\"fallback-input\" for=\"email\" translate=\"cw.form.email\"></label>\n                    <p class=\"error-message\" ng-show=\"confirmAccountForm.email.$invalid && submitted\" translate=\"cw.validator.messages.email\"></p>\n                </div>\n\n                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\" ng-disabled=\"oauthCtrl.Auth.loading\" translate=\"cw.dashboard.device.resend_email\" connectqa-confirm=\"resend-button\"></button>\n\n                <div ng-if=\"clientId !== 'spotlight'\" class=\"auth-actions\">\n                    <a class=\"text-m text-blue-2 mt10 inline-block\" ui-sref=\"root.auth.login\" ng-click=\"oauthCtrl.Auth.removeLoginCookies()\" connectqa-confirm=\"go-to-login-page\"><span class=\"text-xl\">&lsaquo; </span><span translate=\"cw.auth.go_to_login\"></span></a>\n                </div>\n\n            </form>\n        </div>\n    </div>\n\n    <div vc-recaptcha\n        class=\"captcha2\"\n        key=\"Recaptcha.captchaKey\"\n        on-create=\"Recaptcha.setWidgetId(widgetId)\"\n        on-success=\"oauthCtrl.setCaptchaResponse(response)\"\n        size=\"invisible\">\n    </div>\n</div>\n"

/***/ }),

/***/ "vTUv":
/***/ (function(module, exports) {

module.exports = "<div class=\"settings\">\n    <i class=\"icon icon-settings icon-grey-3 icon-xs\" connectqa-device=\"sprocket\"></i>\n    <div class=\"settings_dropdown\">\n        <ul class=\"settings_dropdown_wrap settings_dropdown_wrap-small settings_dropdown_wrap-bottom\">\n\n            <li ng-if=\"deviceSettingsCtrl.isLockFunctionalityAvailable\">\n\n                <!-- Lock Button -->\n                <a  ng-if=\"!isLocked\"\n                    ng-click=\"deviceSettingsCtrl.onSettingsItemClick('Lock')\">\n\n                    <i class=\"icon icon-grey-3 icon-xxs icon-lock\" connectqa-settings=\"restrict-access\"></i>\n                    {{'cw.ui.general.change_permissions' | translate}}\n                </a>\n\n                <!-- Unlock Button -->\n                <a  ng-if=\"isLocked\"\n                    ng-click=\"deviceSettingsCtrl.onSettingsItemClick('Unlock')\">\n\n                    <i class=\"icon icon-grey-3 icon-xxs icon-unlock\" connectqa-settings=\"allow-access\"></i>\n                    {{'cw.my_devices.unlock_device.button' | translate}}\n                </a>\n            </li>\n\n            <!-- Remove Button -->\n            <li>\n                <a ng-click=\"deviceSettingsCtrl.onSettingsItemClick('Remove')\" connectqa-device-settings=\"remove\">\n                   <i class=\"icon icon-grey-3 icon-xxs icon-remove\"></i>\n                   {{'cw.my_devices.confirm.button' | translate}}\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ }),

/***/ "vUnG":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content crop-modal change-lang\">\n\n\t<div class=\"text-xxxl text-center mb50 font-regular\" translate=\"cw.change.lang\"></div>\n\n\t<div class=\"lang-selector\">\n\n\t\t<div class=\"text-l mb20 fl-left w33 p-relative text-left\"\n\t\t\t ng-class=\"currentLanguage.indexOf(language.code) === 1 ? 'font-regular' : 'text-grey-3'\"\n\t\t\t ng-repeat=\"language in languages\">\n\n\t\t\t<span class=\"p-absolute\" ng-class=\"{'icon icon-checked2':currentLanguage.indexOf(language.code) === 1 }\"></span>\n\n\t\t\t<a class=\"text-left crs-pointer\" ng-click=\"changeLanguage(language.code)\">{{language.name}}</a>\n\t\t</div>\n\t</div>\n</div>\n";
var path = 'scripts/controllers/modals/change-lang/change-lang.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "vZC1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

var DwmEmails = function DwmEmails($scope, $http, $rootScope, Util, dwmValidations) {
    _classCallCheck(this, DwmEmails);

    $scope.emailIsValid = true;

    var validations = dwmValidations;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};
        if (assets.primaryMember) {

            $scope.primaryEmail = assets.primaryMember.primaryEmail;
            $scope.emails = assets.primaryMember.monitoredAccounts.emails;
            var index = 1;
            $scope.emails.entries.forEach(function (entry) {

                index += 1;
                entry.index = index;
                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
        setTimeout(function () {

            angular.element('#email').focus();
        }, 100);
    };

    $scope.cancelNewEntry = function () {

        $scope.emailIsValid = true;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newEmail = '';
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.emails.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                var newEntry = Object.assign({}, entry);
                $scope.updateEntryPayload = newEntry;
            } else {

                entry.showUpdateInput = false;
            }
        });

        setTimeout(function () {

            angular.element('.update-email').focus();
        }, 100);
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.emailIsValid = true;
        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;

        $scope.emails.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};
    };

    $scope.validateEmail = function ($event) {

        if ($scope.newEntrySubmitted) {

            $scope.emailIsValid = validations.emailValidator($event.currentTarget.value);
        }

        $scope.newEmail = $event.currentTarget.value;
    };

    $scope.saveNewEntry = function () {

        $scope.emailIsValid = validations.emailValidator($scope.newEmail);

        $scope.newEntrySubmitted = true;

        if ($scope.emailIsValid) {

            $scope.saveNewEmailIsLoading = true;

            var payload = {
                emails: {
                    emailAddress: $scope.newEmail,
                    type: 'OTHER'
                }
            };
            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newEmail = '';
                $scope.saveNewEmailIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);
                    $scope.cancelNewEntry();

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;


                    _RFC4.default.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Email'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }
                });
            }).catch(function (responseError) {

                $scope.saveNewEmailIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            emails: {
                id: $scope.emails.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newEmail = '';

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Email', monitoredAccounts.emails.entries.length + 1);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Email'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.entryUpdateValue = function ($event) {

        $scope.emailIsValid = validations.emailValidator($event.currentTarget.value);

        if ($scope.emailIsValid) {

            $scope.updateEntryPayload.emailAddress = $event.currentTarget.value;
        }
    };

    $scope.saveUpdatedEntry = function () {

        $scope.saveUpdatedEntryIsLoading = true;

        $http({
            method: 'PUT',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            },
            data: { emails: $scope.updateEntryPayload }
        }).then(function () {

            _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                Action: 'Update',
                Entry: 'Email'
            });

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;
            $scope.updateEntryPayload = {};
            $scope.saveUpdatedEntryIsLoading = false;

            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);
                $scope.confirmRemoveIsLoading = false;
            });
        }).catch(function (responseError) {

            $scope.saveUpdatedEntryIsLoading = false;

            if (responseError.data) {

                if (responseError.data.errorCode === 4013) {

                    _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                } else {

                    _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support'
                        }
                    });
                }
            }
        });
    };
};

_serviceDependencies.push(DwmEmails);

angular.module('controllers').controller('DwmEmails', _serviceDependencies);

/***/ }),

/***/ "vajS":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "vitq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['$state', '$scope', 'Util'];

var ChooseDeviceOsDeploymentWizardController = function () {
    function ChooseDeviceOsDeploymentWizardController($state, $scope, Util) {
        _classCallCheck(this, ChooseDeviceOsDeploymentWizardController);

        this.$state = $state;
        this.$scope = $scope;
        this.Util = Util;

        $scope.imgPath = CWCONFIG.imgPath;

        this.app = _index.AppIntegrationsRepository.getById(this.$scope.inputData.appId);
        if (!this.app) {

            // app not found
            this.Util.closeModal();
        }
        this.supportedOs = _index.AppIntegrationsRepository.getSupportedOs(this.app.id);

        // Product page with FSS banner allow users to download Phantom VPN only for mobile user
        // We filter the supportOs list for avpn0 only if deploy url is from product page
        if ($state.current.name.indexOf('root.dashboard.products') > -1 && this.$scope.inputData.appId === 'avpn0') {

            this.supportedOs = this.supportedOs.filter(function (os) {
                return os === 'android' || os === 'ios';
            });
        }

        if (this.supportedOs && this.supportedOs.length === 1) {

            this.deployOn(this.supportedOs[0]);
        }
    }

    _createClass(ChooseDeviceOsDeploymentWizardController, [{
        key: 'deployOn',
        value: function deployOn(os) {

            var stateName = this.$state.current.name;
            if (stateName.indexOf('.deploy') === -1) {

                stateName += '.deploy';
            }

            var params = {};

            if (this.$scope.inputData.deployType && os === 'windows' && this.$state.current.name.indexOf('root.dashboard.products') === -1) {

                params = angular.extend(params, {
                    appId: this.$scope.inputData.appId,
                    deployType: this.$scope.inputData.deployType,
                    os: os
                });
            } else {

                params = angular.extend(this.$state.params, {
                    resourceId: this.$scope.inputData.resourceId,
                    appId: this.app.id,
                    deviceId: 'new',
                    os: os,
                    licenseId: this.$scope.inputData.licenseId
                });
            }

            this.$scope.changeWizard()(stateName, params, { reload: false });
        }
    }]);

    return ChooseDeviceOsDeploymentWizardController;
}();

var ChooseDeviceOsDeploymentWizardDirective = function ChooseDeviceOsDeploymentWizardDirective() {
    _classCallCheck(this, ChooseDeviceOsDeploymentWizardDirective);

    this.template = __webpack_require__("9xPA");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state, $scope, Util) {
        return new ChooseDeviceOsDeploymentWizardController($state, $scope, Util);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'chooseDeviceOsDeploymentWizardCtrl';
};

_directiveDependencies.push(function () {
    return new ChooseDeviceOsDeploymentWizardDirective();
});

angular.module('directives').directive('chooseOsTypeDeploymentWizard', _directiveDependencies);

/***/ }),

/***/ "vjep":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _regenerator = __webpack_require__("dOW8");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("/6Pw");

var _RFC6 = _interopRequireDefault(_RFC5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable max-len */


/**
 * Subscription confirmation controller
 * Handles subscription on/off modal template.
 */

angular.module('controllers').controller('SubscriptionConfirmation', ['$scope', '$stateParams', '$window', 'Util', 'ActivationCodeRestService', '$sce', 'FlexiblePromotionsRestService', 'ErrorHandler', '$filter', '$rootScope', 'AppPricesRestService', '$http', '$timeout', function ($scope, $stateParams, $window, Util, ActivationCodeRestService, $sce, FlexiblePromotionsRestService, ErrorHandler, $filter, $rootScope, AppPricesRestService, $http, $timeout) {

    var key = $stateParams.resourceId;
    $scope.activationCode = _index.ActivationCodesRepository.getById(key);
    var subscriptionRuntime = $scope.activationCode.attributes.runtime;
    $scope.loading = false;
    $scope.surveyFlow = false;
    $scope.showSurveyScreen = false;
    $scope.showSuccessScreen = false;
    $scope.showDiscountScreen = false;
    $scope.isLoading = true;
    $scope.showDiscountAddedScreen = false;
    $scope.showDiscountAdded = false;
    $scope.expireDate = Util.deepFind($scope.activationCode, 'attributes.date_expire');
    $scope.nextBillingEvent = Util.deepFind($scope.activationCode, 'attributes.next_billing_event');
    $scope.showDiscountCard = false;
    $scope.isAnimationEnable = localStorage.getItem('animation') === 'true' && CWCONFIG.unsubscribeAnimation;
    $scope.animationDuration = 700;
    $scope.showOptions = true;
    $scope.submitted = false;
    $scope.discountFreeDays = CWCONFIG.discountFreeDays10;
    $scope.showSurveyModal = false;
    $scope.showBenefitsModal = false;
    $scope.showSuccessCancellationScreen = false;
    $scope.showUnsubscribeFeedbackModal = false;
    $scope.showDiscountModal = false;
    $scope.showFeedbackModalFirst = false;

    // CMA Links
    var currentLanguage = CWCONFIG.language;

    $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
    $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
    $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
    $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
    $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
    $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
    // End CMA links

    if (!$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies && Util.getDeviceNavigator() !== 'android' && Util.getDeviceNavigator() !== 'ios') {

        $scope.showCloseButton = true;

        $scope.onCloseButtonClick = function (modalDetail) {

            _RFC4.default.send('ConnectWeb Modal Button Click', {
                Modal: 'Subscription Confirmation',
                'Button Label': 'Close-Button-Unsubscribe',
                'Modal Detail': modalDetail
            });
            $scope.closeModal();
        };
    }

    $scope.formattedexpireDate = moment($scope.expireDate).format('L');

    if (!$rootScope.cmaGBapplies) {

        $scope.acceptedRowTerms = false;

        $scope.onChangeCheckboxROW = function () {

            $scope.acceptedRowTerms = !$scope.acceptedRowTerms;
        };
    } else {

        $scope.acceptedGbTerms1 = false;
        $scope.acceptedGbTerms2 = false;

        $scope.onChangeCheckboxGB1 = function () {

            $scope.acceptedGbTerms1 = !$scope.acceptedGbTerms1;
        };
        $scope.onChangeCheckboxGB2 = function () {

            $scope.acceptedGbTerms2 = !$scope.acceptedGbTerms2;
        };
    }

    var subscriptionTypeValue = Util.deepFind($scope.activationCode, 'attributes.subscription_type');
    if (subscriptionTypeValue === 'yearly' || subscriptionTypeValue === 'annual' || subscriptionTypeValue === 'annual-trial') {

        $scope.showAnnual = true;
    } else if (subscriptionTypeValue === 'monthly' || subscriptionTypeValue === 'monthly-trial') {

        $scope.showMonthly = true;
    }

    var devices = 1;

    if ($scope.activationCode.attributes.max_activations) {

        devices = $scope.activationCode.attributes.max_activations;
    }

    var runtime = 12;
    if ($scope.activationCode.attributes.runtime === 1) {

        runtime = 1;
    }

    if ($scope.activationCode.attributes.promotion) {

        $scope.nextBillingPrice = $scope.activationCode.attributes.promotion.attributes.total_price_string;
    } else {

        var appPrice = _index.AppPricesRepository.getSinglePrice($scope.activationCode.attributes.app, runtime, devices);

        if (appPrice) {

            $scope.nextBillingPrice = appPrice.attributes.price_string;
        } else {

            var appIdForPrice = $scope.activationCode.attributes.app;
            var rutimeForPrice = runtime;

            AppPricesRestService.getByAppIdAndRuntimeAndNumberOfUsers(appIdForPrice, rutimeForPrice, devices).then(function (response) {

                _index.AppPricesRepository.add(response.data.data);
                if (response.data.data.length) {

                    var nextBillingPrice = response.data.data.find(function (price) {
                        return price.id === appIdForPrice + '_' + rutimeForPrice + '_' + devices;
                    });

                    if (nextBillingPrice) {

                        $scope.nextBillingPrice = nextBillingPrice.attributes.price_string;
                    }
                }
            });
        }
    }

    if ($scope.activationCode) {

        var nextBillingEvent = Util.deepFind($scope.activationCode, 'attributes.next_billing_event');
        var subscriptionType = Util.deepFind($scope.activationCode, 'attributes.subscription_type');
        var expirationDate = Util.deepFind($scope.activationCode, 'attributes.date_expire');

        if (!nextBillingEvent) {

            switch (subscriptionType) {

                case 'yearly':
                    nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                    break;
                case 'monthly':
                    nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                    break;
                case 'annual':
                    nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                    break;
                case 'monthly-trial':
                    nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                    break;
                case 'annual-trial':
                    nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                    break;
                default:
                    nextBillingEvent = expirationDate;

            }
        }

        $scope.activationCode.formatted_date_expire = moment(expirationDate).format('L');
        $scope.activationCode.formatted_next_billing_event = $scope.activationCode.attributes.customBillingDateForCMA || moment(nextBillingEvent).format('L');
    }

    var user = _index.MeRepository.getMyUser();
    var userCountry = Util.deepFind(user, 'attributes.country');
    var userLanguage = Util.deepFind(user, 'attributes.language');

    var _ref = CWCONFIG || [],
        phoneModalLanguage = _ref.phoneModalLanguage;

    var isDach = (userCountry === 'DE' || userCountry === 'AT' || userCountry === 'CH') && phoneModalLanguage.find(function (lang) {
        return lang === userLanguage;
    });
    var date = new Date();
    var currentHour = date.getHours();
    // Interval in which the modal with options should be displayed
    var startingHour = CWCONFIG.phoneModalStartingHour || 9;
    var endingHour = CWCONFIG.phoneModalEndingHour || 17;
    var phoneModalAcceptedValues = CWCONFIG.phoneModalVisibleValues || [];
    var activationCodes = _index.ActivationCodesRepository.getAll();
    $scope.numberOfSubscriptions = activationCodes.length;
    var chatModalAcceptedValues = CWCONFIG.chatModalVisibleValues || [];
    $scope.canOfferChatSupport = false;
    $scope.filterName = $filter('friendName')(user);

    if ($scope.activationCode.relationships.app.data.id === 'aps20') {

        $scope.appIntegration = _index.AppIntegrationsRepository.getById('aps10');
    } else {

        $scope.appIntegration = _index.AppIntegrationsRepository.getById($scope.activationCode.relationships.app.data.id);
    }

    // If the user has multiple licenses
    // We need to check if those can be merged
    if (activationCodes.length >= 2) {
        var bundles = CWCONFIG.devices.bundles;

        var currentBundles = [];
        var appsCount = {};
        // Generate array with bundles ids on this account
        activationCodes.forEach(function (activationCode) {

            var appId = activationCode.attributes.app;
            if (bundles.find(function (bundle) {
                return bundle === appId;
            }) && !currentBundles.find(function (bundle) {
                return bundle === appId;
            })) {

                currentBundles.push(appId);
            }

            // Count licenses to check for duplicates
            if (!appsCount[appId]) {

                appsCount[appId] = 1;
            } else {

                appsCount[appId] += 1;
            }
        });

        var hasSameProduct = false;
        // Check for duplicated licenses
        Object.values(appsCount).forEach(function (value) {

            if (value > 1) {

                hasSameProduct = true;
            }
        });

        // Check if user has multiple licenses that can be merged
        if (currentBundles.length > 0) {

            // If user has Prime, show the tooltip
            var hasPrime = currentBundles.find(function (bundle) {
                return bundle === 'aps20';
            }) || currentBundles.find(function (bundle) {
                return bundle === 'aps10';
            });

            if (hasPrime) {

                $scope.showMultipleLicensesTooltip = true;
            } else if (hasSameProduct) {

                $scope.showMultipleLicensesTooltip = true;
            } else {

                // If we find any other bundle
                // We need to check if the user has another
                // license for any component from the bundle
                currentBundles.forEach(function (bundle) {

                    var bundleIntegrations = _index.AppIntegrationsRepository.getById(bundle);
                    var bundleComponents = bundleIntegrations.appComponents;

                    if (bundleComponents) {

                        activationCodes.forEach(function (activationCode) {

                            var activationCodeIntegration = _index.AppIntegrationsRepository.getById(activationCode.attributes.app);
                            var commonLicense = bundleComponents.find(function (app) {
                                return Util.compareString(Util.deepFind(app, 'attributes.resource.oeName'), Util.deepFind(activationCodeIntegration, 'attributes.resource.oeName')) || Util.compareString(Util.deepFind(app, 'attributes.name'), Util.deepFind(activationCodeIntegration, 'attributes.name')) || Util.compareString(Util.deepFind(app, 'attributes.prototype'), Util.deepFind(activationCodeIntegration, 'attributes.prototype'));
                            });

                            if (commonLicense) {

                                $scope.showMultipleLicensesTooltip = true;
                            }
                        });
                    }
                });
            }
        }
    }

    /**
    * AV Pro campaign
    * get campaign param value from localstorage and check if this offer -10% discount
    */
    $scope.campaign = localStorage.getItem('offerAutoSubscription');
    $scope.isCampaignOfferDiscount = !!($scope.campaign === 'auto-subscription-1' && !$scope.activationCode.attributes.promotion && ($scope.activationCode.attributes.app === 'aapd5' || $scope.activationCode.attributes.app === 'aapd0'));

    var random = void 0;

    if (!sessionStorage.getItem('phoneModalValue')) {

        random = Math.floor(Math.random() * 10) + 1;
        sessionStorage.setItem('phoneModalValue', random);
    } else {

        random = parseInt(sessionStorage.getItem('phoneModalValue'), 0);
    }

    var isInAcceptedValues = phoneModalAcceptedValues.find(function (value) {
        return value === random;
    });

    $scope.canOfferPhoneSupport = isDach && currentHour >= startingHour && currentHour < endingHour && isInAcceptedValues;

    var optionsModalActions = function optionsModalActions() {

        $scope.backToOptions = function () {

            // a/b test animation
            $scope.animateCardsEntrance();
            $timeout(function () {

                angular.element('#unsubscribe-modal').removeClass('animation');
                angular.element('#options-modal').removeClass('options-modal-animation');
            }, 0);

            $scope.showPromotionModal = false;
            $scope.showMonthlySwitch = false;
            $scope.showPhoneModal = false;
            $scope.showChatModal = false;
            $scope.showOptions = true;

            if (angular.element('#ze-snippet').length > 0) {

                $scope.canOfferChatSupport = false;

                if (!$scope.canOfferChatSupport && !$scope.canSwitchToMonthly && !$scope.canOfferChatSupport && !$scope.canOfferPhoneSupport) {

                    Util.closeModal();
                }
            }

            _RFC4.default.send('ConnectWeb Modal Button Click', {
                Modal: 'Subscription Confirmation',
                'Button Label': 'Back',
                'Modal Detail': 'Unsubscribe Options',
                Page: Util.getPageName()
            });
        };

        $scope.showPromotionScreen = function () {

            // a/b test animation
            if ($scope.isAnimationEnable) {

                $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                $scope.triggerCardAnimation('promotion-option');
                $timeout(function () {

                    $scope.showOptions = false;
                    $scope.showPromotionModal = true;

                    _RFC4.default.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Discount',
                        'Modal Detail': 'Unsubscribe Options'
                    });
                }, $scope.animationDuration);
            } else {

                $scope.showOptions = false;
                $scope.showPromotionModal = true;

                _RFC4.default.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Discount',
                    'Modal Detail': 'Unsubscribe Options'
                });
            }

            // Mixpanel.send('ConnectWeb Modal Button Click', {
            //     Modal: 'Subscription Confirmation',
            //     'Button Label': 'Discount',
            //     'Modal Detail': 'Unsubscribe Options',
            //     Page: Util.getPageName(),
            // });
        };

        $scope.showPhoneScreen = function () {

            if ($scope.isAnimationEnable) {

                $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                $scope.triggerCardAnimation('phone-option');
                $timeout(function () {

                    $scope.showOptions = false;
                    $scope.showPhoneModal = true;

                    _RFC4.default.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Phone support',
                        'Modal Detail': 'Unsubscribe Options',
                        Page: Util.getPageName()
                    });
                }, $scope.animationDuration);
            } else {

                $scope.showOptions = false;
                $scope.showPhoneModal = true;

                _RFC4.default.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Phone support',
                    'Modal Detail': 'Unsubscribe Options',
                    Page: Util.getPageName()
                });
            }
        };

        $scope.showChatScreen = function () {

            $scope.chatWidgetIsLoading = true;

            if (angular.element('#ze-snippet').length === 0) {

                var chatScriptUrl = 'https://static.zdassets.com/ekr/snippet.js?key=e574cc8f-ee6b-4fa8-ac52-e9ed8324d299';
                var scriptTag = angular.element(document.createElement('script'));
                scriptTag.attr('src', chatScriptUrl);
                scriptTag.attr('id', 'ze-snippet');
                angular.element('body').append(scriptTag);
                $scope.triggerChatClickInterval = setInterval($scope.triggerChatClick, 2000);
            }

            window.zESettings = {
                webWidget: {
                    offset: { horizontal: '40px', vertical: '60px' }
                }
            };

            _RFC6.default.broadcast('zendesk-chat:started');

            // a/b test animation
            if ($scope.isAnimationEnable) {

                $scope.triggerAnimation('#unsubscribe-modal', 'animation');
                $scope.triggerCardAnimation('chat-option');

                $timeout(function () {

                    $scope.showOptions = false;
                    $scope.showChatModal = true;

                    _RFC4.default.send('ConnectWeb Modal Button Click', {
                        Modal: 'Subscription Confirmation',
                        'Button Label': 'Chat support',
                        'Modal Detail': 'Unsubscribe Options',
                        Page: Util.getPageName()
                    });
                }, $scope.animationDuration);
            } else {

                $scope.showOptions = false;
                $scope.showChatModal = true;

                _RFC4.default.send('ConnectWeb Modal Button Click', {
                    Modal: 'Subscription Confirmation',
                    'Button Label': 'Chat support',
                    'Modal Detail': 'Unsubscribe Options',
                    Page: Util.getPageName()
                });
            }
        };

        $scope.contactSupport = function () {

            _RFC4.default.send('ConnectWeb Modal Button Click', {
                Modal: 'Subscription Confirmation',
                'Button Label': 'Support',
                'Modal Detail': 'Unsubscribe Options'
            });
        };

        $scope.isLoading = !$scope.isLoading;

        // when subsription is off
        if ($scope.activationCode.attributes.subscription !== 1) {

            _RFC4.default.send('ConnectWeb Modal Open ', { Modal: 'Subscription Activation' });
        } else if ($scope.showFeedbackModalFirst) {

            _RFC4.default.send('ConnectWeb Modal Open ', { Modal: 'Unsubscribe Feedback' });
        } else {

            _RFC4.default.send('ConnectWeb Modal Open ', { Modal: 'Unsubscribe Offers' });
        }

        // when subsription is off

        $scope.$apply();
    };

    if (!$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies) {

        $scope.showUnsubscribeFeedbackModal = true;
    } else {

        $scope.showUnsubscribeFeedbackModal = false;
    }

    var promisesArray = [];

    var currentAppId = $scope.activationCode.attributes.app;
    // Check if the current product has a discount
    var flexiblePromotionsPromise = FlexiblePromotionsRestService.getPromotionByActivationCode(key, subscriptionRuntime, currentAppId).then(function (response) {

        var currentRuntime = $scope.activationCode.attributes.runtime;

        if (response.data.data.length > 0 && !$scope.activationCode.attributes.promotion) {

            // Hide the discount option for AV 1 month
            if (currentAppId === 'aapd5' || currentAppId === 'aapd0') {

                if (currentRuntime > 1) {

                    // if (!localStorage.getItem('UnsubscribePromotionVariant')) {

                    //     localStorage.setItem(
                    //         'UnsubscribePromotionVariant',
                    //         Math.floor(Math.random() * 2),
                    //     );

                    // }

                    // const testGroup =
                    // localStorage.getItem('UnsubscribePromotionVariant') === '0' ? 'control' : 'test';
                    // $scope.testGroup = 'test';
                    // Mixpanel.setCommonProperty('A/B Test Unsubscribe New Discount Phase 2', testGroup);

                    // if (testGroup === 'control') {

                    //     const promo10 = response.data.data.find(promo => promo.attributes.discount === 10);
                    //     $scope.promotionDetails = promo10;
                    //     FlexiblePromotionsRepository.add([promo10]);
                    //     $scope.discountFreeDays = CWCONFIG.discountFreeDays10;

                    // } else {

                    var promo20 = response.data.data.find(function (promo) {
                        return promo.attributes.discount === 20;
                    });
                    $scope.promotionDetails = promo20;
                    // FlexiblePromotionsRepository.add([promo20]);
                    _index.FlexiblePromotionsRepository.add(response.data.data);
                    $scope.discountFreeDays = CWCONFIG.discountFreeDays20;

                    // }

                    $scope.canOfferDiscount = true;
                }
            } else if (currentAppId === 'aps10' || currentAppId === 'aps20') {

                var _promo = response.data.data.find(function (promo) {
                    return promo.attributes.discount === 20;
                });
                $scope.promotionDetails = _promo;
                // FlexiblePromotionsRepository.add([promo20]);
                _index.FlexiblePromotionsRepository.add(response.data.data);
                $scope.discountFreeDays = CWCONFIG.discountFreeDays20;
                $scope.canOfferDiscount = true;
            } else {

                // if (!localStorage.getItem('UnsubscribePromotionVariant')) {

                //     localStorage.setItem(
                //         'UnsubscribePromotionVariant',
                //         Math.floor(Math.random() * 2),
                //     );

                // }

                // const testGroup =
                //     localStorage.getItem('UnsubscribePromotionVariant') === '0' ? 'control' : 'test';
                // $scope.testGroup = testGroup;
                // Mixpanel.setCommonProperty('A/B Test Unsubscribe New Discount Phase 2', testGroup);

                // if (testGroup === 'control') {

                var promo10 = response.data.data.find(function (promo) {
                    return promo.attributes.discount === 10;
                });
                $scope.promotionDetails = promo10;
                _index.FlexiblePromotionsRepository.add([promo10]);
                $scope.discountFreeDays = CWCONFIG.discountFreeDays10;

                // } else {

                //     const promo20 = response.data.data.find(promo => promo.attributes.discount === 20);
                //     $scope.promotionDetails = promo20;
                //     FlexiblePromotionsRepository.add([promo20]);
                //     $scope.discountFreeDays = CWCONFIG.discountFreeDays20;

                // }

                $scope.canOfferDiscount = true;
            }

            if ($scope.canOfferDiscount && !$rootScope.cmaGBapplies && !$rootScope.cmaUSapplies) {

                $scope.showFeedbackModalFirst = true;

                if (!localStorage.getItem('UnsubscribeReasonVariant')) {

                    localStorage.setItem('UnsubscribeReasonVariant', Math.floor(Math.random() * 2));
                }

                $scope.testGroup = localStorage.getItem('UnsubscribeReasonVariant') === '0' ? 'control' : 'test';

                _RFC4.default.setCommonProperty('A/B Test Unsubscribe Reasons Discount', $scope.testGroup);
            } else {

                $scope.showFeedbackModalFirst = false;
            }

            if ($scope.isCampaignOfferDiscount) {

                $scope.isLoadingAvCampaign = false;
                $scope.showDiscountScreen = true;
            }
        } else {

            var enableSubscriptionDiscount = $scope.isCampaignOfferDiscount;

            if (enableSubscriptionDiscount) {

                $scope.isCampaignOfferDiscount = false;
            }
        }
    }).then(null, function () {

        $scope.canOfferDiscount = false;
    });

    if ($scope.activationCode.attributes.subscription === 1) {

        // Check if any support agent is available
        var _CWCONFIG = CWCONFIG,
            enableChatSupport = _CWCONFIG.enableChatSupport;
        var _CWCONFIG2 = CWCONFIG,
            chatSupportLanguages = _CWCONFIG2.chatSupportLanguages;

        var checkChatLanguage = chatSupportLanguages.find(function (lang) {
            return lang === userLanguage;
        });
        var chatSupportPromise = void 0;
        var chatDepartments = CWCONFIG.partnerConfig.support.chatDepartmentByLanguage;
        var departmentKey = chatDepartments ? chatDepartments[checkChatLanguage] : undefined;
        var checkAgentAvailability = !!(enableChatSupport && checkChatLanguage && departmentKey);

        if (checkAgentAvailability === true) {

            chatSupportPromise = $http({

                method: 'GET',
                url: 'https://support-surveys.avira.com/chat/agents_online'

            }).then(function (response) {

                // Allow chat only if there are > 0 agents online for the user's language confirmed using the department key
                if (response && response.data && departmentKey in response.data && response.data[departmentKey] > 0) {

                    if (angular.element('#ze-snippet').length === 0) {

                        $scope.canOfferChatSupport = true;
                        $scope.offerChatSupport = false;

                        var randomChatValue = void 0;

                        if (!localStorage.getItem('chatModalValue')) {

                            randomChatValue = Math.floor(Math.random() * 10) + 1;
                            localStorage.setItem('chatModalValue', randomChatValue);
                        } else {

                            randomChatValue = parseInt(localStorage.getItem('chatModalValue'), 0);
                        }

                        var chatAcceptedValues = chatModalAcceptedValues.find(function (value) {
                            return value === randomChatValue;
                        });

                        if (chatAcceptedValues) {

                            $scope.offerChatSupport = true;
                        }

                        _RFC4.default.setCommonProperty('A/B Test Chat Visibility', $scope.offerChatSupport);
                    }
                }
            });
        }

        Promise.allSettled = function (promises) {

            var mappedPromises = promises.map(function (p) {
                return p.then(function (value) {
                    return {
                        status: 'fulfilled',
                        value: value
                    };
                }).catch(function (reason) {
                    return {
                        status: 'rejected',
                        reason: reason
                    };
                });
            });
            return Promise.all(mappedPromises);
        };

        if (checkAgentAvailability) {

            promisesArray = [flexiblePromotionsPromise, chatSupportPromise];
        } else {

            promisesArray = [flexiblePromotionsPromise];
        }
    }

    Promise.allSettled(promisesArray).then(function () {

        optionsModalActions();
    });

    $scope.triggerChatClick = function () {

        var chatButtonIframe = angular.element('#launcher');

        if (chatButtonIframe) {

            var chatButton = chatButtonIframe.contents().find('.wrapper-AtBcr');
            chatButton.trigger('click');
            $scope.chatWidgetIsLoading = false;
            $scope.$apply();
            clearInterval($scope.triggerChatClickInterval);
            _RFC4.default.send('ConnectWeb Chat Open');

            if (window.zE) {

                window.zE('webWidget', 'identify', {

                    name: $scope.filterName,
                    email: Util.deepFind(user, 'attributes.email')

                });
            }
        }
    };

    $scope.formattedCreatedDate = moment($rootScope.dateABTest).format('L');
    $scope.formattedExpireDate = moment($scope.expireDate).format('L');

    // delete dateABTest variable when $scope is destroyed
    $scope.$on('$destroy', function () {

        delete $rootScope.dateABTest;
    });

    var surveyIsActive = Util.deepFind(CWCONFIG, 'features.unsubscribeSurvey.enabled');

    if (!$scope.activationCode) {

        Util.closeModal();
        return;
    }

    $scope.closeModal = function () {

        Util.closeModal();
    };

    /**
     * show custom unsubscribe modal with components for products that have relationships
     * some products do have an empty relationship and we show the default Unsubscribe modal
     */
    if ($scope.appIntegration.relationships.apps) {

        $scope.appComponents = [];
        var hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];
        // get the data for every component of the bundle
        $scope.appIntegration.relationships.apps.data.forEach(function (app) {

            if (!hiddenAppInBundleIds.find(function (id) {
                return app.id === id;
            })) {

                $scope.appComponents.push(_index.AppIntegrationsRepository.getById(app.id));
            }
        });
    }

    $scope.textFromProductCatalog = Util.deepFind($scope.appIntegration, 'attributes.resource.unsubscribetext');

    // send feedback
    $scope.sendFeedback = function (buttonLabel) {

        $scope.showTakeSurveyScreen = false;
        $scope.showSuccessScreen = true;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Subscription Confirmation',
            'Modal Detail': 'Unsubscribe Feedback',
            'Button Label': buttonLabel,
            Page: Util.getPageName()
        });
    };

    $scope.closeModal = function () {

        Util.closeModal();
    };

    $scope.cancel = function (subscriptionModalDetail, appId) {

        var mixpanelDetails = {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Cancel',
            'Modal Detail': subscriptionModalDetail || '',
            'Product ID': appId || '',
            'Subscription Runtime': $scope.activationCode.attributes.runtime,
            'Subscription Type': $scope.activationCode.attributes.subscription_type,
            Page: Util.getPageName()
        };

        _RFC4.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

        Util.closeModal();
    };

    $scope.confirm = function (subscriptionModalDetail, appId, buttonLabel, enableWithDiscount) {

        var subscriptionStatus = Util.deepFind($scope.activationCode, 'attributes.subscription');

        if (subscriptionStatus === 0) {

            if (!$rootScope.cmaGBapplies && !$scope.acceptedRowTerms) {

                if (!$scope.submitted) {

                    $scope.submitted = true;
                }

                return;
            }

            if ($rootScope.cmaGBapplies && (!$scope.acceptedGbTerms1 || !$scope.acceptedGbTerms2)) {

                if (!$scope.submitted) {

                    $scope.submitted = true;
                }

                return;
            }
        }

        $scope.loading = true;

        /*
        * enableWithDiscount parameter is not required
        * it is used to avoid sending the mixpanel event twice
        * when the user receive a discount for turning the subscription on
        */
        if (!enableWithDiscount) {

            var mixpanelDetails = {
                Modal: 'Subscription Confirmation',
                'Button Label': buttonLabel || 'Confirm',
                'Modal Detail': subscriptionModalDetail || '',
                'Product ID': appId || '',
                'Subscription Runtime': $scope.activationCode.attributes.runtime,
                'Subscription Type': $scope.activationCode.attributes.subscription_type,
                Page: Util.getPageName()
            };

            _RFC4.default.send('ConnectWeb Modal Button Click', mixpanelDetails);
        }

        /*
        * AV Pro Campaign
        * check if user enable appd5 or aadp0 subsciption
        * from campaign 'auto-subscription-0' or 'auto-subscription-1'
        * then sent a custom mixpanel event in order to
        * keep track of a total number of confirmation clicks
        */
        if ($scope.campaign === 'auto-subscription-0' && (appId === 'aapd5' || appId === 'aapd0') && subscriptionStatus === 0 || subscriptionModalDetail === 'Apply discount and Enable Subscription') {

            _RFC4.default.send('ConnectWeb Total AutoSubscriptions Confirmation Click', {
                Source: 'Subscriptions',
                'Modal Detail': subscriptionModalDetail || '',
                'Product ID': appId || '',
                'Campaign Variant': $scope.campaign || ''
            });
        }

        var payloadActivationCode = {
            data: {
                attributes: {
                    subscription: String(subscriptionStatus) === '0' ? '1' : '0'
                },
                relationships: {
                    provider: {
                        data: {
                            type: 'providers',
                            id: $window.appName
                        }
                    }
                }
            }
        };

        ActivationCodeRestService.updateAsync(key, payloadActivationCode).then(function (response) {

            $scope.loading = false;

            _index.ActivationCodesRepository.update(response.data.data);

            // subscription has been canceled & unsubscribe survey is active
            if (subscriptionStatus === 1 && surveyIsActive && $rootScope.hasUsCompliance) {

                if ($scope.showUnsubscribeFeedbackModal) {

                    if ($scope.showFeedbackModalFirst) {

                        $scope.showDiscountModal = false;
                        $scope.showSuccessCancellationScreen = true;
                    } else {

                        $scope.showBenefitsModal = false;
                        $scope.showSuccessCancellationScreen = true;
                    }
                } else {

                    $scope.surveyFlow = true;
                    $scope.showTakeSurveyScreen = true;
                }
            } else if (subscriptionModalDetail !== 'Apply discount and Enable Subscription') {

                // subscription has been activated or unsubscribe survey is not active
                // AV pro campaign
                // do not close modal after discount applied and activation confirmation
                Util.closeModal();
            }
        }).then(null, function (error) {

            var responseError = error.data && error.data.errors && error.data.errors[0] ? error.data.errors[0].code : false;

            $scope.loading = false;

            switch (responseError) {

                case '21312':
                    _RFC2.default.error('cw.subscription.error.no-payment');
                    break;

                case '21313':
                    _RFC2.default.error('cw.subscription.error.status_no_change_appstore');
                    break;

                case '21315':
                    _RFC2.default.error('cw.subscription.error.no-payment');
                    break;

                case '21316':
                    _RFC2.default.error('cw.subscription.error.status_no_change_google_play');
                    break;

                case '21317':
                    _RFC2.default.error('cw.subscription.error.status_no_change_google_play');
                    break;

                default:
                    _RFC2.default.error('cw.notification.system.error');

            }
        });
    };

    $scope.applyDiscount = function (subscriptionModalDetail, appId) {

        var promotionId = Util.deepFind($scope.promotionDetails, 'id');
        $scope.isLoading = !$scope.isLoading;
        $scope.showPromotionModal = false;
        $scope.expireDate = $filter('date')($scope.activationCode.attributes.date_expire);
        $scope.formattedNextBillingEvent = $rootScope.customBillingDateForCMA || moment($scope.nextBillingEvent).format('L');

        if ($scope.showFeedbackModalFirst) {

            $scope.showDiscountModal = false;
        }

        if ($scope.isCampaignOfferDiscount) {

            $scope.showDiscountScreen = !$scope.showDiscountScreen;
            $scope.isLoadingAvCampaign = !$scope.isLoadingAvCampaign;
        }

        var mixpanelDetails = {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Confirm',
            'Modal Detail': subscriptionModalDetail || '',
            'Product ID': appId || '',
            'Subscription Runtime': $scope.activationCode.attributes.runtime,
            'Subscription Type': $scope.activationCode.attributes.subscription_type,
            Page: Util.getPageName()
        };

        _RFC4.default.send('ConnectWeb Modal Button Click', mixpanelDetails);

        var payloadActivationCode = {
            data: {
                attributes: {
                    promotion_id: promotionId
                },
                relationships: {
                    provider: {
                        data: {
                            type: 'providers',
                            id: $window.appName
                        }
                    }
                }
            }
        };

        ActivationCodeRestService.updateAsync(key, payloadActivationCode).then(function (response) {

            _index.ActivationCodesRepository.update(response.data.data);

            if (!$rootScope.promotionsTooltips[key]) {

                $rootScope.promotionsTooltips[key] = true;
            }

            if ($scope.isCampaignOfferDiscount) {

                $scope.isLoadingAvCampaign = false;
                $scope.showDiscountScreen = false;
                $scope.showOptions = false;
                $scope.showDiscountAddedScreen = true;
            } else {

                $scope.isLoading = false;
                $scope.showPromotionModal = false;
                $scope.showOptions = false;
                $scope.showDiscountAdded = true;
            }

            if (subscriptionModalDetail === 'Apply discount and Enable Subscription') {

                // eslint-disable-next-line max-len
                $scope.confirm(subscriptionModalDetail, $scope.activationCode.attributes.app, '', true);
            } else {

                var mixpanelPayload = {
                    Source: 'Subscriptions',
                    Modal: 'Cancel Subscription - Discount Applied',
                    Product: $scope.activationCode.attributes.app,
                    Page: Util.getPageName()
                };

                _RFC4.default.send('ConnectWeb Modal Open ', mixpanelPayload);
            }
        }).then(null, function (error) {

            ErrorHandler.reportEvent('Apply Discount Subscription', error);
            _RFC2.default.error('cw.notification.discount_not_applied.error');
            Util.closeModal();
        });
    };
    $scope.triggerAnimation = function (id, className) {
        return Util.triggerAnimation(id, className);
    };
    $scope.triggerCardAnimation = function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
            var card, optionsList, cardClone, _card$getBoundingClie, top, left, width, height, _optionsList$getBound, topParrent, leftParrent, widthParrent, heightParrent, otherThanCartIconElements;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            card = $window.document.getElementById(id);
                            optionsList = $window.document.getElementById('options-modal');
                            // remove animation previously set in card entrance animation

                            card.style.animation = 'unset';
                            // clone the card
                            cardClone = card.cloneNode(true);
                            // get the location of the card in the view

                            _card$getBoundingClie = card.getBoundingClientRect(), top = _card$getBoundingClie.top, left = _card$getBoundingClie.left, width = _card$getBoundingClie.width, height = _card$getBoundingClie.height;
                            _optionsList$getBound = optionsList.getBoundingClientRect(), topParrent = _optionsList$getBound.top, leftParrent = _optionsList$getBound.left, widthParrent = _optionsList$getBound.width, heightParrent = _optionsList$getBound.height;

                            // position the clone on top of the original

                            cardClone.style.position = 'fixed';
                            cardClone.style.top = top + 'px';
                            cardClone.style.left = left + 'px';
                            cardClone.style.width = width + 'px';
                            cardClone.style.height = height + 'px';
                            card.style.opacity = '0';
                            card.parentNode.appendChild(cardClone);
                            otherThanCartIconElements = cardClone.querySelectorAll('.large-card > :not(.background-holder)');

                            otherThanCartIconElements.forEach(function (element) {

                                element.style.display = 'none';
                            });

                            // expand the clone card to the size of the card lists holder
                            _context.next = 17;
                            return angular.element('#options-modal').removeClass('options-modal-animation');

                        case 17:
                            _context.next = 19;
                            return $scope.cardExpansion(cardClone, {
                                top: topParrent + 50 + 'px',
                                left: leftParrent + 'px',
                                width: widthParrent + 'px',
                                height: heightParrent + 'px'
                            });

                        case 19:
                            // set the display block so the content will follow the normal flow
                            // in case the original card is not display block
                            cardClone.style.display = 'block';

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    $scope.cardExpansion = function (element, to) {
        var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 700;
        return new Promise(function (res) {

            var cardIcon = element.querySelector('.background-holder');
            // remove the .background-holder class name to avoid fade out animation in css file
            cardIcon.classList.remove('background-holder');
            cardIcon.animate([{ // from
                opacity: '1',
                transform: 'scale(1)'
            }, { // to
                opacity: '0',
                transform: 'scale(2)'
            }], { duration: duration, fill: 'both' });
            element.animate([{ // to
                top: to.top,
                left: to.left,
                width: to.width,
                height: to.height
            }], { duration: duration, fill: 'both', easing: 'ease-in' });

            setTimeout(res, duration);
        });
    };
    $scope.animateCardsEntrance = function () {

        var cardElements = angular.element('#options-list > .large-card');
        if (cardElements.length > 0 && $scope.isAnimationEnable) {

            var duration = 0.5;
            var i = 1;
            for (var j = 0; j < cardElements.length; j += 1) {

                i += 1;
                angular.element('#' + cardElements[j].id).css('animationDelay', duration * i + 's');
            }
            angular.element('#unsubscribe-link').css('animationDelay', duration * (i + 1) + 's');
        }
    };

    $scope.goToCancelScreenRow = function () {

        $scope.showCancelScreenRow = true;
        $scope.showOptions = false;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Cancel now',
            'Modal Detail': 'Unsubscribe Options'
        });
    };

    $scope.goToSurveyModal = function () {

        $scope.showSurveyModal = true;
        $scope.showOptions = false;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Cancel now',
            'Modal Detail': 'Unsubscribe Feedback'
        });
    };

    $scope.sendFeedbackFromModal = function (buttonLabel) {

        if (!$scope.feedbackFocusedAutoRenew && !$scope.feedbackFocusedQuality && !$scope.feedbackFocusedSupport && !$scope.feedbackFocusedPrice && !$scope.feedbackFocusedOther) {

            _RFC4.default.send('ConnectWeb Modal Button Click', {
                Modal: 'Subscription Confirmation',
                'Modal Detail': 'Unsubscribe Feedback',
                'Button Label': buttonLabel,
                Page: Util.getPageName()
            });

            if (buttonLabel === 'Auto-Renew') {

                $scope.feedbackFocusedAutoRenew = true;
            }

            if (buttonLabel === 'Quality') {

                $scope.feedbackFocusedQuality = true;
            }

            if (buttonLabel === 'Support') {

                $scope.feedbackFocusedSupport = true;
            }

            if (buttonLabel === 'Price') {

                $scope.feedbackFocusedPrice = true;
            }

            if (buttonLabel === 'Other') {

                $scope.feedbackFocusedOther = true;
            }
        }
    };

    $scope.goToBenefitsModal = function () {

        if ($scope.showFeedbackModalFirst) {

            $scope.showBenefitsModal = true;
            $scope.showOptions = false;
        } else {

            $scope.showBenefitsModal = true;
            $scope.showSurveyModal = false;
        }

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Cancel now',
            'Modal Detail': 'Unsubscribe Options'
        });
    };

    $scope.goToPromotionModal = function () {

        $scope.showDiscountModal = true;
        $scope.showBenefitsModal = false;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Subscription Confirmation',
            'Button Label': 'Cancel now',
            'Modal Detail': 'Unsubscribe Offers'
        });
    };

    $scope.determineModalToOpen = function () {

        if ($scope.testGroup === 'control') {

            $scope.goToPromotionModal();
        } else {

            if (!$scope.feedbackFocusedAutoRenew && !$scope.feedbackFocusedPrice) {

                var allPromotions = _index.FlexiblePromotionsRepository.getAll();
                $scope.promotionDetails = allPromotions.find(function (promo) {
                    return promo.attributes.discount === 10;
                });
                $scope.discountFreeDays = CWCONFIG.discountFreeDays10;
            }

            $scope.goToPromotionModal();
        }
    };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "vlgB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PasswordsRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to update user passwords
 * using http requests.
 */

var PasswordsRestService = function (_BaseRestService) {
    _inherits(PasswordsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function PasswordsRestService($http, $q, Util) {
        _classCallCheck(this, PasswordsRestService);

        return _possibleConstructorReturn(this, (PasswordsRestService.__proto__ || Object.getPrototypeOf(PasswordsRestService)).call(this, $http, $q, Util));
    }

    /**
     * @ngdoc function
     * @name rest.services.PasswordsRestService#resetPassword
     * @methodOf rest.services.PasswordsRestService
     * @function
     *
     * @description
     * This method will make a http request (POST) with the user's email
     * and after that the backend will send the reset password link.
     *
     * @param {object} payload  The payload will contain the partner and the user's email.
     *
     * @returns {Promise} The promise of the call.
     */


    _createClass(PasswordsRestService, [{
        key: 'post',
        value: function post(payload, headers) {

            return _get(PasswordsRestService.prototype.__proto__ || Object.getPrototypeOf(PasswordsRestService.prototype), 'post', this).call(this, payload, 'passwords/', headers);
        }

        /**
         * @ngdoc function
         * @name rest.services.PasswordsRestService#update
         * @methodOf rest.services.PasswordsRestService
         * @function
         *
         * @description
         * Updates user password.
         *
         * @param {object} payload New password payload
         *
         * @returns {Promise} The promise of the call.
         */

    }, {
        key: 'update',
        value: function update(payload, headers) {

            return _get(PasswordsRestService.prototype.__proto__ || Object.getPrototypeOf(PasswordsRestService.prototype), 'update', this).call(this, null, payload, 'passwords/', headers);
        }
    }]);

    return PasswordsRestService;
}(_baseRestService2.default);

exports.default = PasswordsRestService;


_serviceDependencies.push(PasswordsRestService);

angular.module('rest.services').service('PasswordsRestService', _serviceDependencies);

/***/ }),

/***/ "vtkU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("fIlE");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Instance Processor - instances grouped by userId and device
 * The instances for the user based integrations(scope = user)
 * must be taken from the AppInstancesRepository
 */

// these are the app instances grouped by userId
var processedAppInstances = [];

var observableProcessedAppInstances = new Rx.BehaviorSubject(processedAppInstances);

var AppInstancesProcessor = {

    /**
     * Replace all instances with received data
     * @param {Array} data
     */
    onNext: function onNext(data) {
        var _this = this;

        processedAppInstances = [];
        data.forEach(function (appInstance) {

            if (appInstance.relationships.device) {

                _this.addAppInstance(appInstance);
            }
        });

        observableProcessedAppInstances.onNext(processedAppInstances);
    },


    /**
     * Add appInstance based on its userId and state
     * @param appInstance
     */
    addAppInstance: function addAppInstance(appInstance) {

        var processedAppInstance = angular.copy(appInstance);
        var userId = appInstance.relationships.user.data.id;
        var deviceId = appInstance.relationships.device.data.id;
        var appIntegration = _index.AppIntegrationsRepository.getById(appInstance.relationships.app.data.id);

        var appName = _RFC2.default.deepFind(appIntegration, 'attributes.resource.oeName');
        var appShortDescription = _RFC2.default.deepFind(appIntegration, 'attributes.resource.shortDescription');
        var appIcon = _RFC2.default.deepFind(appIntegration, 'attributes.resource.wsLargeImageUrl');
        var prototype = _RFC2.default.deepFind(appIntegration, 'attributes.prototype');
        var order = _RFC2.default.deepFind(appIntegration, 'attributes.custom.manifest.order');
        var appType = _RFC2.default.deepFind(appIntegration, 'attributes.custom.manifest.appType');
        var browsers = _RFC2.default.deepFind(appIntegration, 'attributes.custom.manifest.browsers');
        var os = _RFC2.default.deepFind(appIntegration, 'attributes.custom.manifest.os');
        var visible = _RFC2.default.deepFind(appIntegration, 'attributes.custom.manifest.visible');

        processedAppInstances[userId] = processedAppInstances[userId] || [];
        processedAppInstances[userId][deviceId] = processedAppInstances[userId][deviceId] || [];

        processedAppInstance.customAppInfo = {
            name: appName,
            shortDescription: appShortDescription,
            icon: appIcon,
            prototype: prototype,
            order: order,
            appType: appType,
            browsers: browsers,
            os: os,
            visible: visible
        };
        processedAppInstances[userId][deviceId].push(processedAppInstance);
    },
    getObservable: function getObservable() {

        return observableProcessedAppInstances;
    },


    /**
     * @ngdoc function
     * @name processors.InstanceProcessor#getAll
     * @methodOf processors.InstanceProcessor
     * @function
     *
     * @description
     * This function can be used to return all processed instances.
     *
     * @returns {Array} all processed instances
     */

    getAll: function getAll() {

        return processedAppInstances;
    },


    /**
     * Returns the instances of an user for a specific integration.
     * @param userId
     * @param integrationId
     */
    getByAppIntegration: function getByAppIntegration(userId, integrationId) {

        var instances = [];

        if (!processedAppInstances[userId]) {

            return instances;
        }

        _.values(processedAppInstances[userId]).forEach(function (deviceAppInstances) {

            deviceAppInstances.forEach(function (instance) {

                if (String(instance.relationships.app.data.id) === String(integrationId)) {

                    instances.push(instance);
                }
            });
        });

        return instances;
    },


    /**
     * Returns the instances of an user for a specific prototype.
     * @param userId
     * @param prototype
     */
    getInstancesByPrototype: function getInstancesByPrototype(userId, prototype) {

        var instances = [];

        if (!processedAppInstances[userId]) {

            return instances;
        }

        _.values(processedAppInstances[userId]).forEach(function (deviceAppInstances) {

            deviceAppInstances.forEach(function (instance) {

                if (_RFC2.default.deepFind(instance, 'customAppInfo.prototype') === prototype && _RFC2.default.deepFind(instance, 'attributes.state') !== 'pending') {

                    var device = _index.DevicesRepository.getById(_RFC2.default.deepFind(instance, 'relationships.device.data.id'));
                    if (_index.DevicesRepository.isVisible(device)) {

                        instances.push(instance);
                    }
                }
            });
        });

        return instances;
    },


    /**
     * Returns the instances of an user for a specific id if the param licenseId exists in instance.
     * @param userId
     * @param licenseId
     */
    getInstancesByLicenseId: function getInstancesByLicenseId(userId, licenseId) {

        var instances = [];

        _.values(processedAppInstances[userId]).forEach(function (deviceAppInstances) {

            deviceAppInstances.forEach(function (instance) {

                if (_RFC2.default.deepFind(instance, 'relationships.license.data.id') === licenseId) {

                    instances.push(instance);
                }
            });
        });

        return instances;
    },


    /**
     * Returns the instances of an user for a specific prototype and a specific device.
     * @param userId
     * @param prototype
     * @param device
     */
    getInstancesByPrototypeAndDevice: function getInstancesByPrototypeAndDevice(userId, prototype, device) {

        var instances = [];

        if (!device) {

            return instances;
        }

        if (!processedAppInstances[userId]) {

            return instances;
        }

        _.values(processedAppInstances[userId][device.id]).forEach(function (instance) {

            if (instance.customAppInfo.prototype === prototype) {

                instances.push(instance);
            }
        });

        return instances;
    },


    /**
     * Returns the instances of an user for a specific device.
     * @param userId
     * @param deviceId
     */
    getInstancesByDevice: function getInstancesByDevice(userId, deviceId) {

        var instances = [];

        if (!processedAppInstances[userId]) {

            return instances;
        }

        return processedAppInstances[userId][deviceId];
    },


    /**
     * Returns the instance of an user for a specific integration and a specific device.
     * @param userId
     * @param integrationId
     * @param deviceId
     */
    getByAppIntegrationAndDevice: function getByAppIntegrationAndDevice(userId, integrationId, deviceId) {

        if (!processedAppInstances[userId] || !processedAppInstances[userId][deviceId]) {

            return undefined;
        }

        return processedAppInstances[userId][deviceId].find(function (appInstance) {
            return String(appInstance.relationships.app.data.id) === String(integrationId) && String(appInstance.relationships.device.data.id) === String(deviceId);
        });
    },


    /**
     * Returns the instance of an user for a specific prototype and a specific device.
     * @param userId
     * @param prototype
     * @param deviceId
     */
    getByAppPrototypeAndDevice: function getByAppPrototypeAndDevice(userId, prototype, deviceId) {

        if (!processedAppInstances[userId] || !processedAppInstances[userId][deviceId]) {

            return undefined;
        }

        return processedAppInstances[userId][deviceId].find(function (appInstance) {
            return appInstance.customAppInfo.prototype === prototype && String(appInstance.relationships.device.data.id) === String(deviceId);
        });
    },


    /**
     * Checks if a provided instance is antitheft instance or not.
     * It looks after a location in its content.
     * @param {Object} instance The instance object.
     */
    hasLocationInfo: function hasLocationInfo(instance) {

        return !!_RFC2.default.deepFind(instance, 'attributes.status.LOCATE.lastLocation');
    }
};

var subjectAppInstancesRepository = _index.AppInstancesRepository.getObservable();
subjectAppInstancesRepository.subscribe(function (data) {
    return AppInstancesProcessor.onNext(data);
}, function () {}, function () {});

exports.default = AppInstancesProcessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lQta")))

/***/ }),

/***/ "vzeB":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("Vf/c");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "w/r9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _serviceDependencies = ['$q', '$timeout', 'Util'];
var _requests = void 0;

/**
 * @ngdoc service
 * @name services.RequestHandler
 *
 * @description
 * This class is used to handle request errors
 */

var RequestHandler = function () {

    /**
     * @param {any} $q
     * @param {any} $timeout
     * @param {any} Util
     */
    function RequestHandler($q, $timeout, Util) {
        _classCallCheck(this, RequestHandler);

        this.$q = $q;
        this.$timeout = $timeout;
        this.Util = Util;
        _requests = [];
    }

    /**
     * @ngdoc function
     * @name services.RequestHandler#retry
     * @methodOf services.RequestHandler
     * @function
     *
     * @description
     * This method is used to retry a request in case we receive
     * http server errors or browser errors (500, 504, net::ERR_TIMED_OUT etc...)
     *
     * @param {Object} error Info about the error (url, status code, method etc...)
     */


    _createClass(RequestHandler, [{
        key: 'retry',
        value: function retry(error) {

            var requestDeferred = this.$q.defer();
            var retryTimer = 3000; // miliseconds
            var retryNumber = 3;
            var errorCode = error.status;
            var url = error.config && error.config.url;
            var requestCounter = 0;

            // get REST API resource from url e.g. /me, /devices, /app-integrations
            var urlRestResource = this.Util.getRestResourceFromUrl(url);

            // create request object with the resource from url
            var request = { restResource: urlRestResource };

            // push the request object in _requests array
            _requests.push(request);

            /* iterate through _requests array and count
               the requests for a specific resource from url */
            angular.forEach(_requests, function (value) {

                if (value.restResource === urlRestResource) {

                    requestCounter += 1;
                }
            });

            /* if the number of requests for a specific resource is smaller
               or equal with the retryNumber, resolve the promise */
            if (requestCounter <= retryNumber && (errorCode === 0 || errorCode === 504)) {

                this.$timeout(function () {

                    requestDeferred.resolve();
                }, retryTimer);
            } else {

                /* if the number of requests for a specific resource is bigger
                   than retryNumber, reject the promise.
                   Here we also clear the list of requests for a specific resource
                   in order to reactivate the retry system in case of
                   another call made by application or user
                */
                angular.forEach(_requests, function (value, key) {

                    if (value.restResource === urlRestResource) {

                        delete _requests[key];
                    }
                });

                requestDeferred.reject();
            }

            return requestDeferred.promise;
        }
    }]);

    return RequestHandler;
}();

_serviceDependencies.push(RequestHandler);

angular.module('services').service('RequestHandler', _serviceDependencies);

/***/ }),

/***/ "w0ZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (immutable) */ __webpack_exports__["b"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicRequire;
/* unused harmony export loadModule */
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("rH1J"), __webpack_require__("i9Rx")(module)))

/***/ }),

/***/ "wByq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__("xHnf");

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),

/***/ "wHLP":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "wPTc":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content get-report-modal\">\n\n\t<h1 class=\"text-xxl mb10\" translate=\"cw.my_account.data_settings.get_report_confirmation_title\"></h1>\n\t<h2 class=\"text-m text-grey-3 mb20 w90 m-auto\"\n\t\ttranslate=\"cw.my_account.data_settings.get_report_confirmation_desc\"\n\t\ttranslate-values=\"{\temail: email}\"></h2>\n\t<button class=\"btn btn-large btn-half-width btn-secondary mt5\" ng-click=\"closeModal()\" translate=\"cw.deploy.got.it\"></button>\n</div>";
var path = 'scripts/controllers/modals/my-account/get-report/get-report.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "wR9E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _actions = [];
var observableActions = new Rx.BehaviorSubject(_actions);

/**
 * @ngdoc service
 * @name repositories.GdprActionsRepository
 *
 * @description
 * This class is used to save/add devices objects.
 */
var GdprActionsRepository = {

    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#replace
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored actions with provided data.
     *
     * @param {Array} data An array with new actions.
     */
    replace: function replace(data) {

        _actions = data || [];
        observableActions.onNext(_actions);
    },


    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#getAll
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all actions from repository.
     *
     * @returns {Array} actions all actions from repository
     */
    getAll: function getAll() {

        return _actions;
    },


    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#add
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to add a new action to repository.
     *
     * @param {object} action An action object.
     */
    add: function add(action) {

        var indexOfActions = _actions.findIndex(function (_action) {
            return String(_action.id) === String(action.id);
        });

        if (indexOfActions === -1) {

            _actions.push(action);

            observableActions.onNext(_actions);
        }
    },


    /**
     * @ngdoc function
     * @name repositories.GdprActionsRepository#getObservable
     * @methodOf repositories.GdprActionsRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for actios repository.
     * @returns {Object} an observable object for actions repository.
     */
    getObservable: function getObservable() {

        return observableActions;
    }
};

exports.default = GdprActionsRepository;

/***/ }),

/***/ "wS4J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = ['Templates'];
var _controllerDependencies = ['Util', '$scope', 'DeploymentUrlsRestService', '$timeout', '$window'];

var PcDownloadDeploymentSuccessController = function () {
    function PcDownloadDeploymentSuccessController(Util, $scope, DeploymentUrlsRestService, $timeout, $window) {
        var _this = this;

        _classCallCheck(this, PcDownloadDeploymentSuccessController);

        this.$scope = $scope;
        this.Util = Util;
        this.DeploymentUrlsRestService = DeploymentUrlsRestService;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$scope.isStep2Finished = false;
        this.$scope.isStep3Finished = false;

        // if user move mouse outside of browser we will mark that run program step is started
        this.addEvent(document, 'mouseout', function (e) {

            e = e || window.event;
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName === 'HTML') {

                _this.$timeout(function () {

                    _this.$scope.isStep2Finished = true;
                }, 3000);
            }
        });

        // when the app instance repo is updated it means user have succesful install the app,
        // then checkmark the install step
        var appInstancesObservable = _index.AppInstancesRepository.getObservable();
        var appInstancesSubscriber = appInstancesObservable.subscribe(function (data) {
            return _this.appInstancesNext(data);
        }, function () {}, function () {});

        $scope.$on('$destroy', function () {

            appInstancesSubscriber.dispose();
        });

        this.triggerInstall = false;

        // click handler for link to redeploy on current device
        // timeout hack is used to make sure the dom has been loaded
        this.$timeout(function () {

            var deployViaDownloadElement = angular.element(document.querySelector('#deployActionDownload'));
            deployViaDownloadElement.on('click', function () {
                return _this.deployViaDownload();
            });
        }, 0);
    }

    _createClass(PcDownloadDeploymentSuccessController, [{
        key: 'appInstancesNext',
        value: function appInstancesNext() {
            var _this2 = this;

            if (this.triggerInstall) {

                this.$timeout(function () {

                    _this2.$scope.isStep3Finished = true;
                }, 0);
            }
            this.triggerInstall = true;
        }
        // add event to the obj param

    }, {
        key: 'addEvent',
        value: function addEvent(obj, evt, fn) {

            if (obj.addEventListener) {

                obj.addEventListener(evt, fn, false);
            } else if (obj.attachEvent) {

                obj.attachEvent('on ' + evt, fn);
            }
        }
    }, {
        key: 'deployViaDownload',
        value: function deployViaDownload() {
            var _this3 = this;

            var deploymentPayload = {
                appId: this.$scope.inputData.appId,
                license_type: this.licenseId !== '' ? 'paid' : 'free',
                download_source: this.licenseId !== '' ? 'wdp' : 'wdf',
                license_number: this.licenseId,
                beta: !!this.Util.deepFind(this.license, 'attributes.is_beta_otc'),
                os: this.$scope.inputData.os
            };

            this.DeploymentUrlsRestService.deploy(deploymentPayload).then(function (response) {

                var downloadUrl = _this3.Util.deepFind(response, 'data.data.attributes.download_url');

                if (downloadUrl) {

                    _this3.$window.location.href = downloadUrl;
                }
            }, function () {

                _RFC2.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-pc'
                    }
                });
                _this3.Util.closeModal();
            });
        }
    }]);

    return PcDownloadDeploymentSuccessController;
}();

var PcDownloadDeploymentSuccessDirective = function PcDownloadDeploymentSuccessDirective() {
    _classCallCheck(this, PcDownloadDeploymentSuccessDirective);

    this.template = __webpack_require__("prWK");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function (Util, $scope, DeploymentUrlsRestService, $timeout, $window) {
        return new PcDownloadDeploymentSuccessController(Util, $scope, DeploymentUrlsRestService, $timeout, $window);
    });

    this.controller = _controllerDependencies;
    this.controllerAs = 'PcDownloadDeploymentSuccessCtrl';
};

_directiveDependencies.push(function () {
    return new PcDownloadDeploymentSuccessDirective();
});

angular.module('directives').directive('pcDownloadDeploymentSuccess', _directiveDependencies);

/***/ }),

/***/ "wTs6":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("VjBI");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "wW1Q":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"splash-screen-modal\">\n    <div class=\"splash-screen-close-button crs-pointer \" ng-click=\"closeModal()\">\n        <i class=\"icon icon-s icon-close3 mb10\"></i>\n        <a class=\"text-s\"\n            translate=\"cw.modal.welcome.close\">\n        </a>\n    </div>\n    <div class=\"splash-screen-content\">\n        <h1 class=\"text-white text-xxxl mb10\" translate=\"cw.modal.welcome.title\" translate-values=\"{brandname: brandName, product: product}\"></h1>\n        <h2 class=\"text-l text-grey-6 mb35\" translate=\"cw.modal.welcome.subtitle\"></h2>\n        <ul class=\"splash-screen-features text-m text-grey-5 mb50\">\n            <li translate=\"cw.modal.welcome.feature1\"></li>\n            <li translate=\"cw.modal.welcome.feature2\"></li>\n        </ul>\n        <button\n            ng-if=\"license\"\n            class=\"btn btn-primary btn-large\"\n            ng-click=\"installApp()\"\n            translate=\"cw.modal.welcome.install\">\n        </button>\n    </div>\n</div>\n";
var path = 'scripts/controllers/modals/welcome-modal/welcome-modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "wdeh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Translation resolver which returns a resolved promise only when
 * the translation service has been set up (it uses a language and
 * the ajax call getting the json with the language has been returned)
 */
angular.module('resolvers').Translation = function ($translate) {

    if (!CWCONFIG.language) {

        return false;
    }
    return $translate.use(CWCONFIG.language);
};

angular.module('resolvers').Translation.$inject = ['$translate'];

/***/ }),

/***/ "wla/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("IAQu");

__webpack_require__("QcWw");

__webpack_require__("8j2B");

/***/ }),

/***/ "x5Bi":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("r1rA"),
    isObjectLike = __webpack_require__("7Zib");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "x9tB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__("9MtQ");
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),

/***/ "xHnf":
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__("1RHo");

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),

/***/ "xImZ":
/***/ (function(module, exports) {

var _module_exports = "<div class=\"lightbox-content crop-modal\">\n\n\t<h1 class=\"text-xxxl text-grey-1\" translate=\"cw.profile.picture.crop_title\"></h1>\n\t<h2 class=\"text-m text-grey-2 mb20\" translate=\"cw.profile.picture.crop_desc\"></h2>\n\n\t<div class=\"cropArea mb20\">\n\t\t<ui-cropper image=\"image\"\n\t\t\t\t\tresult-image=\"croppedImage\"\n\t\t\t\t\tarea-min-size=\"150\"\n\t\t\t\t\tarea-type=\"square\"\n\t\t\t\t\tresult-image-size={w:150,h:150}\n\t\t\t\t\ton-load-done=\"onLoadDone()\"\n\t\t\t\t\ton-load-error=\"onError()\">\n\t\t</ui-cropper>\n\t</div>\n\n\t<button class=\"btn btn-medium btn-secondary mlr5\" translate=\"cw.form.profile.cancel\" ng-click=\"closeModal()\"></button>\n\t<button class=\"btn btn-medium btn-primary mlr5 spin-loader\" ng-click=\"uploadImage()\" ng-disabled=\"disabledButton\" translate=\"cw.profile.picture.save_btn\"></button>\n</div>\n";
var path = 'scripts/controllers/modals/my-account/crop-image/crop-image.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;

/***/ }),

/***/ "xOlx":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("r1rA"),
    isObject = __webpack_require__("xwKO");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "xSqx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _RFC = __webpack_require__("/6Pw");

var _RFC2 = _interopRequireDefault(_RFC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('controllers').controller('SessionExpire', ['$scope', '$rootScope', '$document', '$location', '$window', '$modal', '$modalInstance', 'modalParams', function ($scope, $rootScope, $document, $location, $window, $modal, $modalInstance, modalParams) {

    // modalParams is a parameter injected from $modal.open() -> SessionManagement model
    $scope.modalParams = modalParams;

    // append class to body when session expire modal appears
    angular.element($document[0].body).addClass('expire-modal');

    // Close modal if the user's internet connection is back online
    _RFC2.default.subscribe('connection:online', function () {

        if ($scope.modalParams === 'offline') {

            angular.element($document[0].body).removeClass('expire-modal');
            $modalInstance.close();
        }
    });

    $scope.refreshPage = function () {

        $window.location.href = $location.path();
    };
}]);

/***/ }),

/***/ "xcrU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),

/***/ "xfUU":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("dwD7");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "xgwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["d"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["f"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* harmony export (immutable) */ __webpack_exports__["e"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ "xmlI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
    Parse images URL in order to display them corectly.
    If the value is null the function returns a default image.
 */

angular.module('filters').filter('imageUrlParse', function () {
    return function (value) {

        if (value) {

            return JSON.parse('"' + value + '"');
        }
        return 'https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/no-image.png';
    };
});

/***/ }),

/***/ "xsvA":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("SiCv");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "xtm7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var transactions = [];
var observableTransactions = new Rx.BehaviorSubject(transactions);

/**
 * @ngdoc service
 * @name repositories.TransactionsRepository
 *
 * @description
 * TransactionsRepository.
 */
var TransactionsRepository = {
    replace: function replace(data) {

        transactions = data;
        observableTransactions.onNext(transactions);
    },
    getAll: function getAll() {

        return transactions;
    },


    /**
     * Return true if the purchase type is voucher
     * @param activationCodeId activation code id
     */
    isVoucherPurchase: function isVoucherPurchase(activationCodeId) {

        var transactionWithVoucher = transactions.find(function (transaction) {
            return transaction.attributes.activation_code === activationCodeId;
        });

        if (transactionWithVoucher && transactionWithVoucher.attributes) {

            return transactionWithVoucher.attributes.payment_type === 'Voucher';
        }

        return false;
    },
    getObservable: function getObservable() {

        return observableTransactions;
    },


    /**
     * Return the transaction details for a given id.
     * @param transactionId The transaction id
     */
    getById: function getById(transactionId) {

        return transactions.find(function (transaction) {
            return String(transaction.id) === String(transactionId);
        });
    }
};

exports.default = TransactionsRepository;

/***/ }),

/***/ "xwKO":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "xwt4":
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"support\">\n\n        <div ng-if=\"currentTab === 'support'\" class='text-center'>\n\n            <div class='icon-support-logo mt30 mb20 inline-block'></div>\n            <div class=\"text-grey-2 font-bold text-xxl2 mt20\" translate=\"cw.support.header\"></div>\n            <div class=\"text-grey-2 text-l  mb20\" translate=\"cw.support.header_description\"></div>\n            <div class=\"dashboard-tabs-holder\" ng-if=\"isPersonalAccount && isBusinessAccount\">\n                <div class=\"dashboard-tabs text-center\">\n                    <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentSection === 'personal'}\" ng-click=\"updatecurrentSection('personal')\" translate=\"cw.dashboard.support.tabs.personal\"></span>\n                    <span class=\"text-l text-dark crs-pointer\" ng-class=\"{'active': currentSection === 'business'}\" ng-click=\"updatecurrentSection('business')\" translate=\"cw.dashboard.support.tabs.business\"></span>\n                </div>\n            </div>\n\n            <div ng-if=\"isPersonalAccount && currentSection === 'personal'\" class=\"mt30\">\n                <div class=\"flex-space-between w100\">\n                    <a href=\"{{infoSupportURL}}\" target=\"_blank\" class=\"info-support card w50\"\n                        ng-click='sendMixpanelClickEvent(\"Knowledge Base\")'>\n                        <div class=\"mb20\">\n                            <i class='icon icon-light-bulb icon-m icon-grey-3 inline-block v-middle mr5'></i>\n                            <span class=\"text-grey-2 text-xxl inline-block v-middle\" translate=\"cw.dashboard.support.info_support\"></span>\n                        </div>\n                        <div class=\"text-grey-4 text-m\" translate=\"cw.support.FAQ_description\"></div>\n                    </a>\n\n                    <a href=\"{{communityURL}}\" target=\"_blank\" class=\"info-support card w50\"\n                        ng-click='sendMixpanelClickEvent(\"Community\")'>\n                        <div class=\"mb20\">\n                            <i class='icon icon-social icon-m icon-grey-3 inline-block v-middle mr5'></i>\n                            <span class=\"text-grey-2 text-xxl inline-block v-middle\" translate=\"cw.support.community\"></span>\n                        </div>\n                        <div class=\"text-grey-4 text-m\" translate=\"cw.support.community_description\"></div>\n                    </a>\n\n                    <div class=\"text-l w100 mb30 font-bold\" translate=\"cw.support.further_support\"></div>\n\n                    <a href=\"{{viewActivityURL}}\" target=\"_blank\"\n                        class=\"view-activity card\" ng-click='sendMixpanelClickEvent(\"My support activity\")'\n                        ng-class=\"{'w30': showPhoneSupport || showChatSupport, 'w50': !showPhoneSupport || !showChatSupport}\">\n                        <div class='icon icon-historic icon-m icon-grey-3 mb20'></div>\n                        <span class=\"text-grey-4 text-m\" translate=\"cw.support.my_request\"></span>\n                    </a>\n\n                    <a class=\"chat-support card w30 info-tooltip-holder\" ng-if='showChatSupport'\n                        ng-click='openChat()'\n                        ng-class=\"{'w30': showPhoneSupport || showChatSupport, 'w50': !showPhoneSupport || !showChatSupport, 'disabled': !chatAvailable || $root.chatIsOpened}\">\n                        <div class='icon icon-m icon-grey-3 icon-chat-support mb20' ng-if=\"!chatWidgetIsLoading || $root.chatIsOpened\"></div>\n                        <div class=\"chat-loader-wrapper\" ng-if=\"chatWidgetIsLoading && !$root.chatIsOpened\">\n                            <div class=\"main-loader\"></div>\n                        </div>\n                        <span class=\"text-m\" translate=\"cw.support.chat_support\"></span>\n                        <div class=\"info-tooltip arrow-bottom\" ng-if=\"!chatAvailable && !$root.chatIsOpened && !chatWidgetIsLoading\" translate=\"cw.support.chat_support_disabled\"></div>\n                    </a>\n\n                    <a href=\"{{emailSupportURL}}\" target=\"_blank\"\n                        class=\"email-support card\" ng-click='sendMixpanelClickEvent(\"Email\")'\n                        ng-class=\"{'w30': showPhoneSupport || showChatSupport, 'w50': !showPhoneSupport || !showChatSupport}\">\n                        <div class='icon icon-mail-support icon-m icon-grey-3 mb20'></div>\n                        <span class=\"text-grey-4 text-m\" translate=\"cw.dashboard.support.email_support\"></span>\n                    </a>\n\n                    <a href=\"{{phoneSupportURL}}\" target=\"_blank\"\n                        class=\"phone-support card w30\" ng-if='showPhoneSupport'\n                        ng-click='sendMixpanelClickEvent(\"Phone\")'\n                        ng-class=\"{'w30': showPhoneSupport || showChatSupport, 'w50': !showPhoneSupport || !showChatSupport}\">\n                        <div class='icon icon-phone-support icon-m icon-grey-3 mb20'></div>\n                        <span class=\"text-grey-4 text-m\" translate=\"cw.dashboard.support.phone_support\"></span>\n                    </a>\n\n                </div>\n                <span ng-if='showEmailSupportInfo' class=\"text-grey-2 text-m mail-info\">\n                    <i class=\"icon icon-info icon icon-info inline-block mr5 text-blue-2\"></i>\n                    <span translate=\"cw.dashboard.support.email_info\"></span>\n                </span>\n            </div>\n\n            <div ng-if=\"isBusinessAccount && currentSection === 'business'\" class=\"mt30\">\n                <div class=\"flex-space-between w100\">\n                    <a href=\"{{businessInfoSupportURL}}\" target=\"_blank\" class=\"info-support card w50\"\n                        ng-click='sendMixpanelClickEvent(\"Knowledge Base business\")'>\n                        <div class=\"mb20\">\n                            <i class='icon icon-light-bulb icon-m icon-grey-3 inline-block v-middle mr5'></i>\n                            <span class=\"text-grey-2 text-xxl inline-block v-middle\" translate=\"cw.dashboard.support.info_support\"></span>\n                        </div>\n                        <div class=\"text-grey-4 text-m\" translate=\"cw.support.FAQ_description\"></div>\n                    </a>\n\n                    <a href=\"{{businessEmailSupportURL}}\" target=\"_blank\" class=\"email-support card w50\"\n                        ng-click='sendMixpanelClickEvent(\"Email business\")'>\n                        <div class='icon icon-mail-support icon-m icon-grey-3 mb20'></div>\n                        <span class=\"text-grey-4 text-m\" translate=\"cw.dashboard.support.email_support\"></span>\n                    </a>\n                </div>\n                <span ng-if='showEmailSupportInfo' class=\"text-grey-2 text-m mail-info\">\n                    <i class=\"icon icon-info icon icon-info inline-block mr5 text-blue-2\"></i>\n                    <span translate=\"cw.dashboard.support.email_info\"></span>\n                </span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "xy7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('filters').filter('versionNumber', function () {
    return function (version, fractionSize) {

        if (version) {

            return parseFloat(version).toFixed(fractionSize);
        }

        return version;
    };
});

/***/ }),

/***/ "yA7R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _baseRestService = __webpack_require__("//V8");

var _baseRestService2 = _interopRequireDefault(_baseRestService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.AppsRestService
 *
 * @description
 * This class contains methods used to retrieve information about apps
 * using http requests.
 */

var AppsRestService = function (_BaseRestService) {
    _inherits(AppsRestService, _BaseRestService);

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    function AppsRestService($http, $q, Util) {
        _classCallCheck(this, AppsRestService);

        return _possibleConstructorReturn(this, (AppsRestService.__proto__ || Object.getPrototypeOf(AppsRestService)).call(this, $http, $q, Util));
    }

    /**
    * @ngdoc function
    * @name rest.services.AppsRestService#getById
    * @methodOf rest.services.AppsRestService
    * @function
    *
    * @description
    * Retrieves app information.
    *
    * @returns {Promise} The promise of the call.
    */


    _createClass(AppsRestService, [{
        key: 'getById',
        value: function getById(id) {

            return _get(AppsRestService.prototype.__proto__ || Object.getPrototypeOf(AppsRestService.prototype), 'getAllAsync', this).call(this, 'apps/' + id + '?lang=' + CWCONFIG.language);
        }
    }]);

    return AppsRestService;
}(_baseRestService2.default);

exports.default = AppsRestService;


_serviceDependencies.push(AppsRestService);

angular.module('rest.services').service('AppsRestService', _serviceDependencies);

/***/ }),

/***/ "yBp6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$state'];

var UserInfoController = function () {
    function UserInfoController($state) {
        var _this = this;

        _classCallCheck(this, UserInfoController);

        this.$state = $state;
        this.User = _index.MeRepository.getMyUser();

        // MeRepository Observable
        var meRepositoryObservable = _index.MeRepository.getObservable();
        var onNextMeRepository = function onNextMeRepository() {

            // get user from MeRepository
            _this.User = _index.MeRepository.getMyUser();
        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(onNextMeRepository, function () {}, function () {});
    }

    _createClass(UserInfoController, [{
        key: 'changePicture',
        value: function changePicture() {

            _RFC2.default.send('ConnectWeb User Icon Click');
            _RFC4.default.broadcast('user-menu:clicked');
            this.$state.go('root.dashboard.my-account', { tab: 'profile' });
        }
    }]);

    return UserInfoController;
}();

var UserInfoDirective = function UserInfoDirective() {
    _classCallCheck(this, UserInfoDirective);

    this.template = __webpack_require__("7tCK");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($state, $scope) {
        return new UserInfoController($state, $scope);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'userInfoCtrl';
};

_directiveDependencies.push(function () {
    return new UserInfoDirective();
});

angular.module('directives').directive('userInfo', _directiveDependencies);

/***/ }),

/***/ "yEuq":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-device\" ng-if=\"!OfflineDeploymentCtrl.deploying\">\n    <div class=\"top-elements content-wrapper\">\n\n        <div class=\"service-offline-animation\"\n            style=\"background:url(https://dn077dd3nr6fh.cloudfront.net/extras/templates/cw_images/offline-deploy-animation.gif?v{{OfflineDeploymentCtrl.randomNumber}}) 0 0 no-repeat;\">\n        </div>\n\n        <p class=\"text-grey-1 deploy-text-container text-offline-msg\"\n            translate-values=\"{servicename: OfflineDeploymentCtrl.app.attributes.resource.oeName}\"\n            translate=\"cw.deploy.service.modal.info_offline\"></p>\n        <button class=\"btn btn-primary btn-large mt20\" translate=\"cw.general.fixed_it\" ng-click=\"OfflineDeploymentCtrl.close()\"></button>\n    </div>\n</div>\n"

/***/ }),

/***/ "yGKA":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("2mhJ"),
    arraySome = __webpack_require__("AeKI"),
    cacheHas = __webpack_require__("3AGJ");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "yKT5":
/***/ (function(module, exports) {

module.exports = "<div class=\"deploy deploy-email\">\n    <div class=\"top-elements content-wrapper\">\n\n        <i class=\"icon icon-avira-logo mb20\"></i>\n        <h2 class=\"text-xxl2 text-grey-2 mb10\" translate=\"cw.deploy.product.sent\"></h2>\n        <p ng-if=\"inputData.emails.length === 1\" class=\"text-l text-grey-2 mb40\" translate=\"cw.deploy.product.instructions\" translate-values=\"{email: inputData.emails[0]}\"></p>\n        <p ng-if=\"inputData.emails.length > 1\" class=\"text-l text-grey-2 mb40\" translate=\"cw.deploy.product.instructions_multiple_emails\"></p>\n\n        <ul class=\"tour-tutorial-steps mb10 deploy-product-mobile\">\n            <li>\n                <div class=\"icon icon-l icon-phone text-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">1</i>\n                    <div class=\"icon icon-envelope text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-l text-grey-2 ng-scope\" translate=\"cw.deploy.email.step_1\"></p>\n            </li>\n\n            <div class=\"download-dot download-dot-step-1 inline-block \">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n\n            <li>\n                <div class=\"icon icon-l icon-phone text-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">2</i>\n                    <div class=\"icon icon-Cloudlarge text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-l text-grey-2 ng-scope\" translate=\"cw.tour.user.tap_link\"></p>\n            </li>\n\n            <div class=\"download-dot download-dot-step-1 inline-block \">\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n                <span>.</span>\n            </div>\n\n            <li>\n                <div class=\"icon icon-l icon-phone text-grey-3 mb15\">\n                    <i class=\"step-number font-regular\">3</i>\n                    <div class=\"icon icon-Cog text-blue-3 centerMiddle\"></div>\n                </div>\n                <p class=\"text-l text-grey-2\" translate=\"cw.tour.user.step_3\"></p>\n            </li>\n        </ul>\n\n        <button class=\"btn btn-large btn-primary\" ng-click=\"PhoneEmailDeploymentSuccessCtrl.close();\" translate=\"cw.general.fixed_it\"></button>\n    </div>\n</div>\n"

/***/ }),

/***/ "yRFa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _browser = __webpack_require__("W/hB");

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exceptionHandler = ['$provide', function ($provide) {

    var extendExceptionHandler = function extendExceptionHandler($delegate) {

        var appErrorPrefix = '--------------->>>>>>>>>>>>>>>>>>>>>>>>>>';
        return function (exception, cause) {

            if (CWCONFIG.features.customDebug) {

                $delegate(exception, cause);
                if (appErrorPrefix && exception.message && exception.message.indexOf(appErrorPrefix) === 0) {

                    return;
                }

                var errorData = {
                    exception: exception,
                    cause: cause
                };
                var msg = appErrorPrefix + exception.message;
                _loggers2.default.error(appErrorPrefix, errorData);

                var body = angular.element('body');

                body.append('' + ('<div class="testing" style="width:400px; padding:20px;' + 'background-color:#b45555; position:fixed; top:0; color:#fff; max-height:300px;' + 'z-index:1000; font-size:14px; word-break:break-word; overflow:auto;">') + errorData.exception.message + '______' + msg + '___' + JSON.stringify(errorData.exception) + '</div>');

                Sentry.withScope(function (scope) {

                    scope.setLevel('error');
                    Sentry.captureMessage('Internal JS error: ' + errorData.exception.message + '______' + msg + '___' + JSON.stringify(errorData.exception));
                });
            }
        };
    };

    $provide.decorator('$exceptionHandler', ['$delegate', extendExceptionHandler]);
}];

exports.default = exceptionHandler;

/***/ }),

/***/ "yRWb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFCSession = __webpack_require__("DyxV");

var _RFC = __webpack_require__("YW9j");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

var _RFC5 = __webpack_require__("lD2H");

var _RFC6 = _interopRequireDefault(_RFC5);

var _recaptcha = __webpack_require__("35YC");

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _webSockets = __webpack_require__("0+3i");

var _webSockets2 = _interopRequireDefault(_webSockets);

var _browser = __webpack_require__("W/hB");

var Sentry = _interopRequireWildcard(_browser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc service
 * @name services.Auth
 *
 * @description
 * Auth service for making login, signup, logout, forgout & reset backend calls and
 * checking if a user is logged in or not (using data from cookies).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the Auth service for all auth events (i.e:
 * login, reset, forgot, sign up, log out) and for performing the initial token check.
 * </div>
 */

/* eslint no-use-before-define : 0 */
angular.module('services').service('Auth', ['$rootScope', '$window', '$state', '$location', '$timeout', 'Util', 'UserRestService', 'OAuthRestService', 'PasswordsRestService', 'ErrorHandler', 'LogoutRestService', 'JWT', function ($rootScope, $window, $state, $location, $timeout, Util, UserRestService, OAuthRestService, PasswordsRestService, ErrorHandler, LogoutRestService, JWT) {

    var cookieConfig = CWCONFIG.cookie;
    var domain = cookieConfig.domain,
        rootDomain = cookieConfig.rootDomain;


    var Auth = {

        /**
         * @ngdoc property
         * @name services.Auth#request
         * @propertyOf services.Auth
         *
         * @description
         * If no login request has been made, its value is false,
         * otherwise will be set to true.
         */
        loading: false,
        // keep track of info when trying to login with a social account
        socialLogin: {
            socialLoginButton: '', // button type (facebook/google)
            loginAttempt: false
        },
        error: false,
        errorReason: '',
        failedLogins: 0,
        captchaRequired: false,
        rememberTfa: false,

        /**
         * @ngdoc function
         * @name services.Auth#login
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. Send a http request to server with user's payload & header and on success
         * we set the login cookies and prepare the user session.
         * @param {Object} payload Payload for the http request.
         * (grant_type: 'password', email: '', password: '')
         * @param {Object} header Payload for the http request.
         * ('X-Avira-Otp': '', 'X-Avira-Browser': '',
            'X-Avira-Browser-Trusted': '', 'X-Avira-Os': '')
         */
        login: function login(payload, header, page, provider) {

            var deviceToken = this.getDeviceToken();
            if (deviceToken) {

                payload.device_token = deviceToken;
            }

            // Send token from session storage for launcher forgot flow
            var connectClientToken = localStorage.getItem('ConnectClientToken');
            var connectClientDeviceID = localStorage.getItem('ConnectClientDeviceID');
            var resetEmailDeviceID = localStorage.getItem('ResetEmailDeviceID');

            if (connectClientToken && connectClientDeviceID === resetEmailDeviceID) {

                header.Authorization = 'Bearer ' + connectClientToken;
            }

            OAuthRestService.post(payload, header).then(function (response) {

                /* page param is passed when the user
                authetication is done via Google, Facebook or Apple */
                var pageName = page || 'Login';

                /* if a user is coming from apple sign in don't log out
                   the user is he has 2fa active */
                if (Auth.socialLogin.socialLoginButton === 'apple') {

                    sessionStorage.setItem('TfaSessionStorage', 'apple_auth');
                }

                Auth.error = false;
                _recaptcha2.default.disableCaptcha();
                Auth.failedLogins = 0;
                _RFCSession.Session.setValue(_RFCSession.SessionKeys.TokenExpiration, response.data.expires_in);
                Auth.setLoginCookies(response);
                Auth.setDeviceToken(response);
                Auth.startLogoutInterval(response.data.expires_in);
                Auth.getMeAsync();
                Auth.sendAcpPing();

                _RFC6.default.send('ConnectWeb ' + pageName + ' Success', {
                    Method: Util.deepFind(response, 'config.data.grant_type')
                });

                // reset socialLogin info
                setTimeout(function () {

                    Auth.socialLogin.socialLoginButton = '';
                    Auth.socialLogin.loginAttempt = false;
                }, 10000);

                localStorage.removeItem('ConnectClientToken');
                localStorage.removeItem('ConnectClientDeviceID');
                localStorage.removeItem('ResetEmailDeviceID');
            }).then(null, function (error) {

                var responseError = Util.deepFind(error, 'data.error');
                var phoneNumber = void 0;

                // if the user doesn't try to use tfa, it means we have a genuine error
                if (responseError !== 'invalid_otp') {

                    _RFC6.default.send('ConnectWeb Login Error', {
                        'Error Name': responseError,
                        'Error Code': error.status
                    });
                }
                Auth.loading = false;

                // reset socialLogin info
                Auth.socialLogin.socialLoginButton = '';
                Auth.socialLogin.loginAttempt = false;
                Auth.failedLogins += 1;

                switch (responseError) {

                    case 'invalid_credentials':

                        Auth.error = true;

                        Util.triggerAnimation('#error-message-form', 'animated shake');

                        // check error header for captcha required
                        if (error.headers('X-Avira-Captcha') === 'required') {

                            _recaptcha2.default.enableCaptcha();
                        }

                        break;

                    case 'required_captcha':

                        _recaptcha2.default.execute();

                        break;

                    case 'invalid_otp':

                        /* save login payload and redirect to TFA Page */
                        $rootScope.userCredentials = {
                            email: Util.deepFind(error, 'config.data.username'),
                            password: Util.deepFind(error, 'config.data.password'),
                            grant_type: Util.deepFind(error, 'config.data.grant_type'),
                            partner: Util.deepFind(error, 'config.data.partner'),
                            token: Util.deepFind(error, 'config.data.token')
                        };

                        phoneNumber = error.headers()['x-avira-phone'];
                        Auth.sendPhoneNumberAlertSuccess(phoneNumber);

                        Auth.gotoTfa();
                        sessionStorage.setItem('TfaSessionStorage', 'invalid_otp');

                        break;

                    case 'retries_exceeded':

                        _RFC4.default.error('cw.auth.tfa.error.retries_exceeded');
                        break;

                    case 'disabled_account':
                        _RFC4.default.error('cw.auth.account.disabled');
                        break;

                    case 'no_external_email':
                        _RFC4.default.error({
                            message: 'cw.error.no_external_email'
                        }, {
                            message: {
                                provider: provider
                            }
                        });
                        break;

                    default:

                        _RFC4.default.error('cw.notification.system.error');

                }
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#sendPhoneNumberAlertSuccess
         * @methodOf services.Auth
         *
         * @description
         * Notify the user that a code was sent to his phone number (ex: ******214)
         */
        sendPhoneNumberAlertSuccess: function sendPhoneNumberAlertSuccess(phoneNumber) {

            _RFC4.default.success({ message: 'cw.notification.tfa.phoneNumber' }, { message: { phoneNumber: phoneNumber } });
        },


        /**
         * @ngdoc function
         * @name services.Auth#tfaLogin
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. Send a http request to server with user's payload & header and on success
         * Log in the user with a 2fa code from mobile device
         * @param {Object} payload Payload for the http request.
         * (grant_type: 'password', email: '', password: '')
         * @param {Object} header Payload for the http request.
         * ('X-Avira-Otp': '', 'X-Avira-Browser': '',
            'X-Avira-Browser-Trusted': '', 'X-Avira-Os': '')
         */
        tfaLogin: function tfaLogin(payload, header, isResendRequest) {

            var deviceToken = this.getDeviceToken();
            if (deviceToken) {

                payload.device_token = deviceToken;
            }

            OAuthRestService.post(payload, header).then(function (response) {

                var responseTfaToken = void 0;

                Auth.error = false;
                Auth.captchaRequired = false;
                _RFCSession.Session.setValue(_RFCSession.SessionKeys.TokenExpiration, response.data.expires_in);
                Auth.setLoginCookies(response);
                Auth.setDeviceToken(response);
                Auth.startLogoutInterval(response.data.expires_in);
                Auth.getMeAsync();
                Auth.sendAcpPing();

                _RFC6.default.send('ConnectWeb Login Success', {
                    Method: Util.deepFind(response, 'config.data.grant_type')
                });

                if (Auth.rememberTfa) {

                    responseTfaToken = response.headers()['x-avira-token'];

                    Auth.setTfaCookie(responseTfaToken);
                }

                // $rootScope userCredentials cleanup
                delete $rootScope.userCredentials;
            }).then(null, function (error) {

                var responseError = Util.deepFind(error, 'data.error');
                var phoneNumber = void 0;

                Auth.loading = false;

                _RFC6.default.send('ConnectWeb Login Error', {
                    'Error Name': responseError,
                    'Error Code': error.status
                });

                switch (responseError) {

                    case 'expired_otp':

                        _RFC4.default.error('cw.auth.tfa.error.expired_otp');
                        break;

                    case 'retries_exceeded':

                        _RFC4.default.error('cw.auth.tfa.error.retries_exceeded');
                        break;

                    case 'invalid_otp':

                        // alert success on resending 2FA code
                        if (isResendRequest) {

                            phoneNumber = error.headers()['x-avira-phone'];
                            Auth.sendPhoneNumberAlertSuccess(phoneNumber);

                            Auth.error = false;
                        } else {

                            Auth.error = true;
                            Util.triggerAnimation('.error', 'animated shake');
                        }

                        break;

                    case 'disabled_account':
                        _RFC4.default.error('cw.auth.account.disabled');
                        break;

                    default:

                        _RFC4.default.error('cw.notification.system.error');
                        ErrorHandler.handleError(error, '2FA OAUTH');

                }
            });
        },

        /**
         * @ngdoc function
         * @name services.Auth#loginWithToken
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. Log in the user with existing token (example: token from launcher)
         * @param {String} token This parameter is used to authenticate the user
         */
        loginWithToken: function loginWithToken(token) {

            // Expected format to use token
            var data = {
                data: {
                    access_token: token
                }
            };

            Auth.removeLoginCookies();
            Auth.setLoginCookies(data);
            Auth.getMeAsync();
        },


        /**
         * @ngdoc function
         * @name services.Auth#register
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. We make a http request in order to obtain a temporary token and
         *    set a cookie with token value. - OAuthRestService.post
         * 2. We create a new user with the information taken from register page.
         *    (userPayload) -
         *    UserRestService.crate(userPayload) - fullname, email, passowrd
         * @param {Object} oauthPayload Payload for the http request.
         * (grant_type: 'client_credentials')
         * @param {Object} userPayload  Payload with user information.
         * (fullname, email, password)
         */
        register: function register(oauthPayload, headers, userPayload) {

            OAuthRestService.post(oauthPayload, headers).then(function (oauthResponse) {

                Auth.setLoginCookies(oauthResponse);
                Auth.createUser(userPayload, headers);
            }).then(null, function (error) {

                var responseError = Util.deepFind(error, 'data.error');

                if (responseError === 'required_captcha') {

                    _recaptcha2.default.enableCaptcha();
                }

                Auth.loading = false;
                _RFC4.default.error('cw.notification.system.error');
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#registerAnon
         * @methodOf services.Auth
         * @function
         *
         * @description
         * This method is used to create a user when we already
         * have a token stored in cookie
         */
        registerAnon: function registerAnon(userPayload) {

            Auth.createUser(userPayload);
        },


        /**
         * @ngdoc function
         * @name services.Auth#createUser
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. We make a http request in order to create a new user.
         * 2. On success we log the user into Avira Connect (Launcher/MYA/Backend)
         * and we redirect him to confirmation page.
         * @param {Object} userPayload  Payload with user information.
         * (fullname, email, password)
         */
        createUser: function createUser(userPayload, headers) {

            UserRestService.create(userPayload, headers).then(function (response) {

                $rootScope.newRegisteredUser = true;

                _index.MeRepository.replace(response.data);

                Auth.logIntoAviraConnect(userPayload, headers);

                Auth.error = false;
            }).then(null, function (error) {

                var errorObj = Util.deepFind(error, 'data.errors')[0];
                var errorText = Util.deepFind(errorObj, 'detail');
                var errorCode = Util.deepFind(errorObj, 'code');
                var token = _RFC2.default.get(CWCONFIG.cookie.token);

                Auth.error = false;
                Auth.failedLogins += 1;

                _RFC6.default.send('ConnectWeb Register Error', {
                    'Error Name': errorText,
                    'Error Code': errorCode
                });

                /* if the user has temporary token and receives an error
                    the temporary token will be deleted in order to
                    let the user make other OAUTH calls. */
                if (token) {

                    var tokenValues = JWT.getTokenPayload(token);

                    var isTemporaryToken = tokenValues.tid;
                    var tokenScope = tokenValues.scope;

                    if (isTemporaryToken && tokenScope && tokenScope.indexOf('me:GET,users:POST,devices:POST') > -1) {

                        Auth.removeLoginCookies();
                    }
                }

                __triggerFormErrors(error);
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#forgotPassword
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. We make a http request (POST) with the user email, language and partner.
         *    PasswordsRestService.forgotPassword(payload)
         * 2. The user will receive an email with the reset password link.
         * @param {Object} payload Payload for the http request. (email, partner, language)
         */
        forgotPassword: function forgotPassword(payload, headers) {

            PasswordsRestService.post(payload, headers).then(function () {

                Auth.loading = false;
                $state.go('root.auth.login');
                _RFC4.default.success('cw.auth.forgot.request_success2');
            }).then(null, function (err) {

                var errors = Util.deepFind(err, 'data.errors');

                if (errors && errors.length && errors[0].status === '429') {

                    Auth.loading = false;
                    _RFC4.default.error('cw.auth.forgot.tries_exceeded');
                } else {

                    Auth.loading = false;
                    _RFC4.default.error('cw.auth.forgot.request_error');
                }
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#resetPassword
         * @methodOf services.Auth
         * @function
         *
         * @description
         * 1. We set a cookie with the temporary token value in order to make the http request.
         * 2. We make a http request (PUT) and update user's password.
         *    PasswordsRestService.update(payload)
         * 3. On success we delete the temporary token
         * @param {Object} payload Payload for the http request. (password)
         */
        resetPassword: function resetPassword(payload, token) {

            // set temporary token in order to make http calls
            _RFC2.default.set(cookieConfig.token, token, {
                expires: 30,
                path: '/',
                domain: rootDomain || domain
            });

            PasswordsRestService.update(payload).then(function () {

                // remove temporary token
                Auth.removeLoginCookies();

                Auth.loading = false;
                Auth.error = false;
                $state.go('root.auth.login');
                _RFC4.default.success('cw.auth.password_changed');

                _RFC6.default.send('ConnectWeb Reset Password Success', {
                    Logout: payload.meta.logout ? 'true' : 'false'
                });
            }).then(null, function (error) {

                Auth.loading = false;
                Auth.error = true;
                Auth.errorReason = error.data.error;

                if (error.data.error !== 'expired_token') {

                    __triggerFormErrors(error);
                }
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#sendAcpPing
         * @methodOf services.Auth
         * @function
         *
         * @description
         * This command is trying to establish a connection to our websocket server
         * in order to receive ACP notifications.
         */
        sendAcpPing: function sendAcpPing(tokenPayload) {

            var token = tokenPayload || _RFC2.default.get(cookieConfig.token);

            if (token) {

                if (!_webSockets2.default.isConnected) {

                    _webSockets2.default.connect();
                }
            }
        },


        /**
         * @ngdoc function
         * @name services.Auth#getMeAsync
         * @methodOf services.Auth
         * @function
         *
         * @description
         * This method gets the current logged user
         * and on success we update the MeRepository.
         */
        getMeAsync: function getMeAsync() {

            var errorReason = void 0;

            UserRestService.getMeAsync().then(function (response) {

                _index.MeRepository.replace(response.data);
            }).then(null, function (error) {

                var token = _RFC2.default.get(CWCONFIG.cookie.token);
                var tokenSource = 'none';
                var tokenClient = 'none';

                if (token) {

                    tokenSource = JWT.getTokenPayload(token).src || 'none';
                    tokenClient = JWT.getTokenPayload(token).cid || 'none';
                }

                // apply retry handler only for 0 and 504 statuses
                if (error.status === 0 || error.status === 504) {

                    if (Util.deepFind(error, 'data.error')) {

                        errorReason = error.data.error;
                    } else if (Util.deepFind(error, 'data.errors')) {

                        errorReason = error.data.errors[0].detail;
                    }

                    _RFC6.default.send('ConnectWeb ErrorPage Open', {
                        'Error Name': error.statusText,
                        'Error Code': error.status.toString(),
                        'API Resource': Util.getRestResourceFromUrl(error.config.url),
                        'Error Reason': errorReason,
                        'Error Object Data': error.data,
                        'Token Source': tokenSource,
                        'Token Client': tokenClient
                    });

                    /* Remove cookies and redirect to login
                    (possible reasons: bad token or request timeout) */
                    Auth.logOut();
                } else if (error.status === 401 && error.data && error.data.errors && error.data.errors.length && error.data.errors[0].code === '910') {

                    _RFC6.default.send('ConnectWeb ErrorPage Open', {
                        'Error Name': error.statusText,
                        'Error Code': error.status.toString(),
                        'API Resource': Util.getRestResourceFromUrl(error.config.url),
                        'Error Reason': errorReason,
                        'Error Object Data': error.data,
                        'Token Source': tokenSource,
                        'Token Client': tokenClient
                    });

                    // If the user is deleted we receive 910 error code
                    Auth.removeLoginCookies();

                    _RFC4.default.error({ message: 'cw.auth.error.account_deleted' }, {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            product1: _index.AppIntegrationsRepository.getAppName('avpa0'),
                            product2: _index.AppIntegrationsRepository.getAppName('pasm0')
                        }
                    });

                    Auth.gotoRegister();

                    // wait for location path to be changed firefox/safari bug
                    $timeout(function () {

                        $window.location.reload();
                    }, CWCONFIG.timeouts.notification);
                } else if (error.status === 401 && error.data && error.data.error !== 'expired_token' || error.status === 401 && error.data && error.data.errors) {

                    /* /me resource
                        1. any other error code different
                        2. expired_token condition
                        is triggered from LogHttpRESTAPIInterceptor
                        3. 401 error which is not handled by LogHttpRESTAPIInterceptor
                    */

                    var errorLocation = 'Auth.getMeAsync 401 Error';

                    ErrorHandler.handleError(error, errorLocation);

                    Auth.removeLoginCookies();

                    Auth.gotoLogin();
                } else {

                    var _errorLocation = 'Auth.getMeAsync Other Error';

                    // SSO reset password error (e.g. expired token)
                    if ($location.url().indexOf('auth/reset') > -1 && $location.url().indexOf('client_id=dashboard') > -1) {

                        Auth.removeLoginCookies();
                        Auth.gotoLogin();
                    }

                    // Handle all other errors
                    ErrorHandler.handleError(error, _errorLocation);
                }
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#logOut
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Removes all hashtags from URL
         * Removes the cookies from session
         * Redirects to login page.
         */
        logOut: function logOut() {

            var clearCookiesAndReload = function clearCookiesAndReload() {

                // remove hashtags
                $location.hash(null);

                var acceptedRedirectUrl = 'https://support.avira.com/';

                Auth.removeLoginTypeCookie();
                Auth.removeLoginCookies();

                Auth.removeSsoCookies();

                var queryParams = $location.search();

                // Set url if return_to param exists
                if (queryParams.return_to && queryParams.return_to.indexOf('http') === 0) {

                    var unsafeCharacters = ['(', ')', '[', ']', '{', '}', '<', '>', '^', '|', 'javascript'];

                    var hasUnsafeChars = unsafeCharacters.find(function (char) {
                        return queryParams.return_to.indexOf(char) > -1;
                    });

                    if (hasUnsafeChars || decodeURI(queryParams.return_to).indexOf(acceptedRedirectUrl) !== 0) {

                        $location.url('/auth/login');
                    } else {

                        $window.location.href = queryParams.return_to;
                    }

                    return true;
                }

                // Set SSO client_id to the new login flow
                var loginPath = queryParams.client_id ? '/auth/login?client_id=' + queryParams.client_id : '/auth/login';

                $location.url(loginPath);

                // wait for location path to be changed firefox/safari bug
                $timeout(function () {

                    $window.location.reload();
                }, 0);

                return true;
            };

            $rootScope.State.loading = true;
            LogoutRestService.getAllAsync().then(function () {

                clearCookiesAndReload();
            }).catch(function () {

                clearCookiesAndReload();
            });
        },

        /**
         * @ngdoc function
         * @name services.Auth#loginWithFacebook
         * @methodOf services.Auth
         * @function
         *
         * @description
         * We make a http request (POST) with Facebook token
         * in order to log in the user into dashboard.
         *
         * @param {Object} payload Facebook authentication details
         */
        loginWithFacebook: function loginWithFacebook(payload, page) {

            var loginWithFacebookPayload = {
                grant_type: 'fb_auth',
                partner: $rootScope.appName,
                token: payload.accessToken,
                language: CWCONFIG.language
            };

            // 2FA "remember me" header
            var oauthHeader = {
                'X-Avira-Token': Auth.getTfaCookie()
            };

            // add loading spinner until the Facebook login is ready
            Auth.socialLogin.socialLoginButton = 'facebook';
            Auth.socialLogin.loginAttempt = true;

            Auth.login(loginWithFacebookPayload, oauthHeader, page, 'Facebook');
        },


        /**
         * @ngdoc function
         * @name services.Auth#loginWithGooglePlus
         * @methodOf services.Auth
         * @function
         *
         * @description
         * We make a http request (POST) with Google token
         * in order to log in the user into dashboard.
         *
         * @param {Object} payload Google profile details
         */
        loginWithGooglePlus: function loginWithGooglePlus(payload, page) {

            var loginWithGooglePayload = {
                grant_type: 'gg_auth',
                partner: $rootScope.appName,
                token: payload.access_token
            };

            // 2FA "remember me" header
            var oauthHeader = {
                'X-Avira-Token': Auth.getTfaCookie()
            };

            // add loading spinner until the Google Plus login is ready
            Auth.socialLogin.socialLoginButton = 'google';
            Auth.socialLogin.loginAttempt = true;

            Auth.login(loginWithGooglePayload, oauthHeader, page, 'Google');
        },


        /**
         * @ngdoc function
         * @name services.Auth#loginWithAppleID
         * @methodOf services.Auth
         * @function
         *
         * @description
         * We make a http request (POST) with Apple token
         * in order to log in the user into dashboard.
         *
         * @param {Object} payload Apple profile details
         */
        loginWithAppleID: function loginWithAppleID(code, page) {

            var loginWithAppleIDPayload = {
                grant_type: 'apl_auth',
                partner: $rootScope.appName,
                token: code
            };

            // 2FA "remember me" header
            var oauthHeader = {
                'X-Avira-Token': Auth.getTfaCookie()
            };

            // add loading spinner until the Google Plus login is ready
            Auth.socialLogin.socialLoginButton = 'apple';
            Auth.socialLogin.loginAttempt = true;

            Auth.login(loginWithAppleIDPayload, oauthHeader, page, 'Apple');
        },


        /**
         * @ngdoc function
         * @name services.Auth#setLoginCookie
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Sets the session id and token cookies.
         */
        setLoginCookies: function setLoginCookies(data) {

            var tokenExpireInDays = void 0;
            var grantType = Util.deepFind(data, 'config.data.grant_type');

            if (data && data.data && data.data.access_token) {

                // the expire time is received in seconds and we convert it to days
                tokenExpireInDays = parseInt(data.data.expires_in, 10) / 60 / 60 / 24;

                _RFC2.default.set(cookieConfig.token, data.data.access_token, {
                    expires: Math.round(tokenExpireInDays) || 3,
                    path: '/',
                    domain: rootDomain || domain
                });

                _RFC2.default.set(cookieConfig.refreshToken, data.data.refresh_token, {
                    expires: Math.round(tokenExpireInDays) || 3,
                    path: '/',
                    domain: rootDomain || domain
                });
            }

            // set cookie with user's login type (facebook, google, apple or password)
            if (grantType && (grantType === 'fb_auth' || grantType === 'gg_auth' || grantType === 'apl_auth' || grantType === 'password')) {

                _RFC2.default.set(cookieConfig.loginType, data.config.data.grant_type, {
                    expires: 90,
                    path: '/',
                    domain: rootDomain || domain
                });
            }
        },


        /**
         * @ngdoc function
         * @name services.Auth#setTfaCookie
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Sets the 2fa token cookie.
         */
        setTfaCookie: function setTfaCookie(value) {

            _RFC2.default.set(cookieConfig.tfat, value, {
                path: '/',
                domain: domain,
                expires: 90
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#removeTfaCookie
         * @methodOf services.Auth
         * @function
         *
         * @description
         * removes the 2fa token cookie.
         */
        removeTfaCookie: function removeTfaCookie() {

            _RFC2.default.remove(cookieConfig.tfat, {
                path: '/',
                domain: domain
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#getTfaCookie
         * @methodOf services.Auth
         * @function
         *
         * @description
         * gets the 2fa token cookie.
         */
        getTfaCookie: function getTfaCookie() {

            return _RFC2.default.get(cookieConfig.tfat);
        },


        /**
         * @ngdoc function
         * @name services.Auth#removeLoginCookies
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Remove all token cookies set at login.
         */
        removeLoginCookies: function removeLoginCookies() {

            _RFC2.default.remove(cookieConfig.token, {
                path: '/',
                domain: domain
            });

            _RFC2.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: domain
            });

            _RFC2.default.remove(cookieConfig.token, {
                path: '/',
                domain: rootDomain
            });

            _RFC2.default.remove(cookieConfig.refreshToken, {
                path: '/',
                domain: rootDomain
            });

            setTimeout(function () {

                _index.MeRepository.replace();
            }, 0);
        },


        /**
         * @ngdoc function
         * @name services.Auth#removeLoginTypeCookie
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Remove login type cookie.
         */
        removeLoginTypeCookie: function removeLoginTypeCookie() {

            _RFC2.default.remove(cookieConfig.loginType, {
                path: '/',
                domain: domain
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#removeSsoCookies
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Remove all cookies set at login by the Sso service
         */
        removeSsoCookies: function removeSsoCookies() {

            // get all cookies
            var cookies = document.cookie;
            // regex to match all sso keys
            // example: prod_launcher_sso or prod_launcher_refresh_sso
            var regex = new RegExp('^(' + CWCONFIG.cookie.ssoToken + '[a-z]+[_a-z]*?_sso)', 'g');
            cookies.split('; ').map(function (cookie) {

                // check if cookie matches the regex
                var match = cookie.match(regex);
                if (match) {

                    _RFC2.default.remove(match[0], {
                        path: '/',
                        domain: domain
                    });

                    _RFC2.default.remove(match[0], {
                        path: '/',
                        domain: rootDomain
                    });
                }

                return '';
            });
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoDashboard
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Redirect to dashboard page.
         */

        gotoDashboard: function gotoDashboard() {

            $location.path('/dashboard');
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoLogin
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Clears the loading state and redirects to login page.
         */
        gotoLogin: function gotoLogin() {

            $rootScope.State.loading = false;
            $location.path('/auth/login');
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoSetPassword
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Clears the loading state and redirects to setPassword page.
         */
        gotoSetPassword: function gotoSetPassword() {

            var path = $location.url();

            var authExtraUrlParams = _RFCSession.Session.getValue(_RFCSession.SessionKeys.ExtraUrlParams);

            $rootScope.State.loading = false;

            if (authExtraUrlParams) {

                var nextRoute = authExtraUrlParams.substring(authExtraUrlParams.indexOf('/dashboard'));

                $location.url('/auth/set-password' + nextRoute);
            } else if (path.indexOf('subscriptions') > -1) {

                $location.url(path);
            } else {

                $location.url('/auth/set-password/default');
            }
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoRegister
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Clears the loading state and redirects to register page.
         */
        gotoRegister: function gotoRegister() {

            $rootScope.State.loading = false;
            $location.path('/auth/register');
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoConfirm
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Clears the loading state and redirects to confirmation page.
         */
        gotoConfirm: function gotoConfirm() {

            $rootScope.State.loading = false;
            $location.path('/auth/confirm');
        },


        /**
         * @ngdoc function
         * @name services.Auth#gotoTfa
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Clears the loading state and redirects to TFA page.
         */
        gotoTfa: function gotoTfa() {

            $rootScope.State.loading = false;
            $location.path('/auth/tfa');
        },


        /**
         * @ngdoc function
         * @name services.Auth#startLogoutInterval
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Start an interval which logout current user based on the token expiration time
         */
        startLogoutInterval: function startLogoutInterval(tokenExpirationTime) {

            var tokenExpirationTimeInMiliseconds = tokenExpirationTime * 1000;
            /* substract one hour from token expiration time in order
            to logout the user before token expires */
            var logoutInterval = tokenExpirationTimeInMiliseconds - 3600 * 1000;

            $rootScope.logoutIntervalIsOn = true;

            if (logoutInterval && logoutInterval > 0) {

                $timeout(function () {

                    Auth.logOut();
                }, Math.min(logoutInterval, 2147483647));
            }
        },


        /**
         * @ngdoc function
         * @name services.Auth#logIntoAviraConnect
         * @methodOf services.Auth
         * @function
         *
         * @description
         * This method is used to log the user
         * into Avira Connect System (MYA/Launcher/Backend), not Dashboard
         */

        logIntoAviraConnect: function logIntoAviraConnect(userPayload, headers) {

            var loginPayload = {
                grant_type: 'password',
                username: userPayload.data.attributes.email,
                password: userPayload.data.attributes.password
            };

            var deviceToken = this.getDeviceToken();

            if (deviceToken) {

                loginPayload.device_token = deviceToken;
            }

            if (!Util.isAnonymous()) {

                headers.Authorization = 'Basic ' + Util.base64encode(CWCONFIG.oauthKey);
            }

            /* this timeout is added because we have to wait 3-4 seconds
               after a user is created to get a permanent token */
            $timeout(function () {

                OAuthRestService.post(loginPayload, headers).then(function (response) {

                    _RFC6.default.send('ConnectWeb Register Success', {
                        Method: 'password'
                    });

                    Auth.failedLogins = 0;
                    Auth.removeLoginCookies();
                    Auth.setLoginCookies(response);
                    Auth.setDeviceToken(response);
                    Auth.startLogoutInterval(response.data.expires_in);
                    Auth.getMeAsync();
                    Auth.sendAcpPing();

                    $rootScope.newRegisteredUser = false;
                }).then(null, function (error) {

                    var responseError = Util.deepFind(error, 'data.error');

                    Auth.failedLogins += 1;

                    Sentry.withScope(function (scope) {

                        scope.setLevel('error');
                        Sentry.captureMessage('User register error with code ' + error.status, undefined, responseError);
                    });

                    switch (responseError) {

                        case 'required_captcha':
                            _recaptcha2.default.enableCaptcha();
                            Auth.loading = false;
                            break;

                        case 'invalid_otp':
                            _RFC6.default.send('ConnectWeb Login Error', {
                                'Error Name': responseError,
                                'Error Code': error.status
                            });
                            break;

                        default:
                            Auth.loading = false;
                            break;

                    }

                    _RFC4.default.error('cw.notification.system.error');
                });
            }, CWCONFIG.timeouts.authRegisterDelay);
        },


        /**
         * @ngdoc function
         * @name services.Auth#setDeviceToken
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Sets the device_token in local storage
         */
        setDeviceToken: function setDeviceToken(data) {

            localStorage.setItem(CWCONFIG.localStorage.authDeviceToken, data.data.device_token);
        },


        /**
         * @ngdoc function
         * @name services.Auth#getDeviceToken
         * @methodOf services.Auth
         * @function
         *
         * @description
         * Get the device_token from local storage
         */

        getDeviceToken: function getDeviceToken() {

            return localStorage.getItem(CWCONFIG.localStorage.authDeviceToken);
        }
    };

    /**
     * @ngdoc function
     * @name services.Auth#__triggerFormErrors
     * @methodOf services.Auth
     * @function
     *
     * @description
     * This method triggers alerts for common errors.
     */
    function __triggerFormErrors(error) {

        var responseError = false;

        if (error.data.errors && error.data.errors[0]) {

            responseError = error.data.errors[0].code;
        } else if (error.data.error) {

            responseError = error.data.error;
        }

        Auth.loading = false;

        switch (responseError) {

            case '21111':
                // email already exists

                Auth.error = true;
                Util.triggerAnimation('#error-message-form', 'animated shake');
                $rootScope.registerActiveStep = '1';

                break;

            case '909':
                // password not strong enough

                _RFC4.default.error('cw.validator.messages.password.strength');

                break;

            case '21109':
                // invalid user name

                _RFC4.default.error('cw.auth.error.full_name');

                break;

            case '918':
                // captcha required

                // show captcha directly
                _recaptcha2.default.execute();

                break;
            case 'used_token':

                _RFC4.default.error('cw.notification.messages.reset_password_error');

                break;

            case '22906':

                $state.go('complianceFailed');

                break;

            default:

                _RFC4.default.error('cw.notification.system.error');

        }
    }

    return Auth;
}]);

/***/ }),

/***/ "yUGW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(moment) {

var _regenerator = __webpack_require__("dOW8");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _RFC3 = __webpack_require__("/6Pw");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable max-len */
/* eslint-disable no-undef */


angular.module('controllers').controller('PaymentCart', ['$scope', '$stateParams', '$state', '$window', '$location', 'Util', 'ActivationCodeRestService', 'PaymentUrlsRestService', 'PaymentTypesRestService', 'TransactionRestService', 'LicenseRestService', '$rootScope', function ($scope, $stateParams, $state, $window, $location, Util, ActivationCodeRestService, PaymentUrlsRestService, PaymentTypesRestService, TransactionRestService, LicenseRestService, $rootScope) {

    $scope.showLoading = true;
    var userCountry = _index.MeRepository.getMyUser().attributes.country;

    var subsource = $stateParams.subsource,
        promotion = $stateParams.promotion,
        runtime = $stateParams.runtime,
        variant = $stateParams.variant,
        trial = $stateParams.trial,
        test = $stateParams.test,
        button = $stateParams.button;


    var appId = $state.current.name.indexOf('.device-details') > -1 ? $stateParams.appId : $stateParams.resourceId;
    $rootScope.dwmPurchaseEventSend = false;
    $rootScope.primePurchaseEventSend = false;

    // CMA Links
    var currentLanguage = CWCONFIG.language;
    $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
    $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
    $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
    $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
    $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage) + '" target="_blank"';
    // End CMA links

    // Get app data for the success modal
    $scope.app = _index.AppIntegrationsRepository.getById(appId);
    $scope.brandName = CWCONFIG.partnerConfig.name;
    var isBusinessProduct = CWCONFIG.store.businessProducts.find(function (product) {
        return product === appId;
    });

    var mixpanelDetails = {
        Page: Util.getPageName(),
        Source: subsource,
        Modal: 'Cart Iframe',
        Product: trial ? 'Prime 60 Days Trial' : $scope.app.attributes.name,
        'Product ID': $scope.app.id,
        Region: 'CB',
        'License Merged': false
    };

    var sortActivationCodeAfterRuntime = function sortActivationCodeAfterRuntime(nextActivationCode, currentActivationCode) {

        if (Util.getRemainingRuntime(nextActivationCode) < Util.getRemainingRuntime(currentActivationCode)) {

            return 1;
        } else if (Util.getRemainingRuntime(nextActivationCode) > Util.getRemainingRuntime(currentActivationCode)) {

            return -1;
        }

        return 0;
    };

    var getLicenseIdForMerge = function getLicenseIdForMerge() {

        var appComponents = Util.deepFind($scope.app, 'relationships.apps') || {};

        var availableLicensesForMerge = [];
        angular.copy(_index.ActivationCodesRepository.getAll(), availableLicensesForMerge);

        // if it is not Prime we accept only apps that is found in its app components
        if (!(appId === 'aps10' || appId === 'aps20')) {

            var appComponentsIntergration = [];
            if (appComponents.data) {

                appComponentsIntergration = appComponents.data.map(function (app) {
                    return _index.AppIntegrationsRepository.getById(app.id);
                });
            }

            availableLicensesForMerge = availableLicensesForMerge.filter(function (activationCode) {

                var activationCodeIntegration = _index.AppIntegrationsRepository.getById(activationCode.attributes.app);

                var commonLicense = appComponentsIntergration.find(function (app) {
                    return Util.compareString(Util.deepFind(app, 'attributes.resource.oeName'), Util.deepFind(activationCodeIntegration, 'attributes.resource.oeName')) || Util.compareString(Util.deepFind(app, 'attributes.name'), Util.deepFind(activationCodeIntegration, 'attributes.name')) || Util.compareString(Util.deepFind(app, 'attributes.prototype'), Util.deepFind(activationCodeIntegration, 'attributes.prototype'));
                });

                return !!commonLicense;
            });
        }

        var sortedAvailableLicensesForMerge = [];
        if (availableLicensesForMerge.length > 0) {

            // sort the array after runtime
            sortedAvailableLicensesForMerge = availableLicensesForMerge.sort(sortActivationCodeAfterRuntime);

            // remove stand-alone licenses if there is any available bundle for merge
            var availableBundleForMerge = sortedAvailableLicensesForMerge.filter(function (activationCode) {

                var appIntegration = _index.AppIntegrationsRepository.getById(activationCode.attributes.app);
                var bundleType = Util.deepFind(appIntegration, 'attributes.type');
                var includedApps = Util.deepFind(appIntegration, 'relationships.apps.data');

                return bundleType === 'bundle' && includedApps.length > 1;
            });

            // choose bundle with the highest priority (based on its order in the CWCONFIG array)
            if (availableBundleForMerge.length > 0) {

                var bundleIds = CWCONFIG.devices.bundles;
                var index = 0;
                var chosenBundleForMerge = void 0;
                var availableBundleId = availableBundleForMerge.map(function (activationCode) {
                    return activationCode.attributes.app;
                });
                while (index < bundleIds.length && !chosenBundleForMerge) {

                    var commonIdIndex = availableBundleId.indexOf(bundleIds[index]);
                    if (commonIdIndex === -1) {

                        index += 1;
                    } else {

                        chosenBundleForMerge = availableBundleForMerge[commonIdIndex];
                    }
                }

                sortedAvailableLicensesForMerge = chosenBundleForMerge ? [chosenBundleForMerge] : availableBundleForMerge;
            }
        }

        if (sortedAvailableLicensesForMerge.length > 0) {

            var license = _index.LicensesRepository.getLicenseBy(sortedAvailableLicensesForMerge[0].id);
            return license && license.id;
        }

        return undefined;
    };

    var licenseId = $stateParams.licenseId;

    licenseId = licenseId || getLicenseIdForMerge();

    var onMergingLicense = licenseId ? _index.LicensesRepository.getLicenseById(licenseId) : {};

    var navigator = Util.getDeviceNavigator();

    var processPaymentUrlResponse = function processPaymentUrlResponse(response) {

        var shopUrl = Util.deepFind(response.data.data[0], 'attributes.url');

        if (trial === 'true') {

            shopUrl = $rootScope.primeTrialShopUrl + '&x-a-source=cw&x-a-license_type=trial-store';
        }

        /*  Add x-a-content param in purchase url if exists.
            The parameter is used in Cleverbridge to filter purchases
            when we are doing A/B tests in dashboard */
        if (variant) {

            shopUrl = Util.deepFind(response.data.data[0], 'attributes.url') + '&x-a-content=' + variant;
        }

        var ssoExtraParams = sessionStorage.getItem('SsoExtraUrlParams');

        if (ssoExtraParams && ssoExtraParams.indexOf('cw_lp_paid_search') > -1) {

            shopUrl = shopUrl + '&x-a-campaign=cw_lp_paid_search';
        }

        if (!$stateParams.licenseId && getLicenseIdForMerge()) {

            shopUrl = shopUrl + '&x-operation=upgrade';
        }

        if (test) {

            shopUrl = shopUrl + '&x-a-aiatest=' + test;
        }

        if (button) {

            shopUrl = shopUrl + '&x-a-button=' + button;
        }

        $scope.shopUrl = shopUrl;

        // open new tab for business products - All regions
        if (isBusinessProduct) {

            if (userCountry === 'US' || userCountry === 'CA') {

                mixpanelDetails.Region = 'CA';
            }

            _RFC2.default.send('ConnectWeb Modal Open', mixpanelDetails);

            if (navigator === 'ios') {

                $window.location.href = $scope.shopUrl;
            } else {

                $window.open($scope.shopUrl, '_blank');
            }
            $scope.closeModal();
        } else if (userCountry === 'US' || userCountry === 'CA') {

            // open new tab for consumer products - CA region (US and CA only)
            mixpanelDetails.Region = 'CA';
            _RFC2.default.send('ConnectWeb Modal Open', mixpanelDetails);

            if (navigator === 'ios') {

                $window.location.href = $scope.shopUrl;
                $scope.closeModal();
            }

            $scope.showCartIframe = true;
        } else {

            // show iframe for consumer products - CB region (rest of the world)
            $scope.showCartIframe = true;
        }
    };

    var processPaymentUrlError = function processPaymentUrlError(error, callMethod) {

        // Error reporting
        _loggers2.default.error(error);
        ErrorHandler.reportEvent('Cart Iframe Payment', { method: callMethod, error: error });

        // Fallback in case something went wrong and the url is not available
        var eshopUrl = CWCONFIG.store.fallbackShopUrl;
        eshopUrl = eshopUrl.replace('{language}', CWCONFIG.language);

        if (navigator === 'ios') {

            $window.location.href = eshopUrl + '&x-a-content=' + subsource + '-' + appId;
        } else {

            $window.open(eshopUrl + '&x-a-content=' + subsource + '-' + appId, '_blank');
        }
    };

    // Get Payment Urls
    if (runtime && !licenseId) {

        PaymentUrlsRestService.getByAppIdAndRuntime(appId, runtime, subsource).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdAndRuntime');
        });
    } else if (runtime && licenseId) {

        PaymentUrlsRestService.getByAppIdRuntimeAndUpsell(appId, runtime, subsource, licenseId).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdRuntimeAndUpsell');
        });
    } else if (promotion && !licenseId) {

        PaymentUrlsRestService.getPromotionByAppId(appId, subsource).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getPromotionByAppId');
        });
    } else if (promotion && licenseId) {

        PaymentUrlsRestService.getPromotionByAppIdAndUpsell(appId, subsource, licenseId).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdRuntimeAndUpsell');
        });
    } else if (subsource === 'renew') {

        PaymentUrlsRestService.getByAppIdAndLicenseId(appId, subsource, licenseId).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppIdAndLicenseId');
        });
    } else {

        PaymentUrlsRestService.getByAppId(appId, subsource).then(function (response) {

            processPaymentUrlResponse(response);
        }).catch(function (err) {

            processPaymentUrlError(err, 'PaymentUrlsRestService.getByAppId');
        });
    }

    $scope.closeModal = function () {

        Util.closeModal();
    };

    $scope.onIframeError = function (error) {

        var mixpanelPayload = {
            'Error object data': error
        };

        _RFC2.default.send('ConnectWeb Cart Iframe Error', mixpanelPayload);

        if (!$scope.error) {

            // TODO: Check status code in eventData
            $scope.error = true;
            Util.closeModal();
        }
    };

    $scope.onIframeReady = function () {

        if (!$scope.cartIframeReady) {

            $scope.cartIframeReady = true;
            $scope.showLoading = true;
        }
    };

    $scope.onIframeContentLoaded = function () {

        $scope.checkIframeInterval = setInterval($scope.checkIframe, 1000);
    };

    $scope.checkIframe = function () {

        var cartVariant = Cleverbridge.getCurrentScope();

        if (cartVariant) {

            clearInterval($scope.checkIframeInterval);

            var mixpanelCartVersion = void 0;
            $scope.cartVariant = cartVariant;
            if ($scope.cartVariant === 'checkout') {

                mixpanelCartVersion = 'test';
                angular.element('#lightbox .click-area-lightbox').addClass('payment-card-large-click-area-lightbox');
            }
            if ($scope.cartVariant === 'cart') {

                mixpanelCartVersion = 'control';
            }

            $scope.showLoading = false;
            $scope.showCartIframe = true;

            mixpanelDetails['A/B Test Payment Cart'] = mixpanelCartVersion;
            _RFC2.default.send('ConnectWeb Modal Open', mixpanelDetails);

            $scope.$apply();
        }
    };

    $scope.onPurchaseReady = function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(transactionId) {
            var language, mergedLicense, onMergingLicenseAppId, mergedLicenseAppId, onMergingLicenseExpirationDate, mergedLicenseExpirationDate, hasRuntimeIncreased, checkRuntimeNotExpired;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            language = CWCONFIG.language === 'de' ? 'de' : 'en';
                            // link to support page

                            $scope.supportUrl = 'https://www.avira.com/' + language + '/support';
                            // reset of the world region
                            $scope.paymentSupportUrlRegionCB = 'https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=' + language;

                            $scope.transactionId = transactionId;

                            $scope.showLoading = true;
                            $scope.showCartIframe = false;
                            $scope.showMergedLicensesSuccess = false;
                            angular.element('.payment-cart-modal').css('min-height', '445px');

                            $scope.getActivationCodeDetails(transactionId);

                            mergedLicense = void 0;
                            _context.next = 12;
                            return LicenseRestService.getAllAsync().then(function (response) {

                                mergedLicense = response.data.data.find(function (license) {
                                    return license.id === licenseId;
                                });
                                _index.LicensesRepository.replace(response.data.data);
                            });

                        case 12:

                            _RFC4.default.broadcast('purchase completed');

                            if (appId === 'adwp1' && $rootScope.dwmPurchaseEventSend === false) {

                                $rootScope.dwmPurchaseEventSend = true;
                                $rootScope.$broadcast('dwm_purchase_completed');
                            }

                            if ((appId === 'aps10' || appId === 'aps20') && $rootScope.primePurchaseEventSend === false) {

                                $rootScope.primePurchaseEventSend = true;
                                $rootScope.$broadcast('prime_purchase_completed');
                            }

                            if (!$scope.showSuccessModal) {

                                // check if a merge licenses has been occurred
                                // conditions is for the same licenseId:
                                // 1. if the app id has changed after purchase then it's true
                                // 2. if the the app id has not changed but runtime is extended and was not expired then it's true
                                if (onMergingLicense && mergedLicense) {
                                    onMergingLicenseAppId = Util.deepFind(onMergingLicense, 'relationships.app.data.id');
                                    mergedLicenseAppId = Util.deepFind(mergedLicense, 'relationships.app.data.id');
                                    onMergingLicenseExpirationDate = moment(Util.deepFind(onMergingLicense, 'attributes.expiration_date'));
                                    mergedLicenseExpirationDate = moment(Util.deepFind(mergedLicense, 'attributes.expiration_date'));


                                    if (onMergingLicenseAppId !== mergedLicenseAppId) {

                                        $scope.showMergedLicensesSuccess = true;
                                    } else {
                                        hasRuntimeIncreased = onMergingLicenseExpirationDate < mergedLicenseExpirationDate;
                                        checkRuntimeNotExpired = Util.deepFind(onMergingLicense, 'attributes.expired') === false;

                                        $scope.showMergedLicensesSuccess = hasRuntimeIncreased && checkRuntimeNotExpired;
                                    }

                                    $scope.onMergingApp = _index.AppIntegrationsRepository.getById(onMergingLicenseAppId);
                                    $scope.extraRuntime = Util.getExtraRuntime(mergedLicense);
                                    $scope.showTitleWithTwoProducts = $scope.app.attributes.name !== $scope.onMergingApp.attributes.name;
                                    $scope.totalRuntime = Util.getRemainingRuntime(mergedLicense);
                                }

                                mixpanelDetails['License Merged'] = $scope.showMergedLicensesSuccess;
                                mixpanelDetails.Modal = 'Cart Iframe Payment Successful';
                                mixpanelDetails['Payment Method'] = 'Card';
                                _RFC2.default.send('ConnectWeb Modal Open', mixpanelDetails);

                                // hide welcome offer banner until next time if user just have succesful made a purchase from banner
                                if (subsource === 'banner' || subsource === 'store') {

                                    sessionStorage.setItem('hideWOB', true);
                                }

                                $scope.updateTransactionAndPaymentData();
                                $scope.showSuccessModal = true;
                                $scope.showLoading = false;
                                sessionStorage.setItem('trialModalClosed', 'true');
                            }

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    $scope.updateTransactionAndPaymentData = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return PaymentTypesRestService.getAllAsync().then(function (response) {

                            _index.PaymentTypesRepository.replace(response.data.data);
                        });

                    case 2:
                        _context2.next = 4;
                        return TransactionRestService.getAllAsync().then(function (response) {

                            _index.TransactionsRepository.replace(response.data.data);
                        });

                    case 4:
                        _RFC4.default.broadcast('purchase completed');

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    $scope.getModalWidth = function () {

        var defaultModalWidth = 750 - 2; // 2px for the border;
        var viewPortWidth = window.innerWidth;
        var clickAreaWidth = 32;

        return viewPortWidth > 830 ? defaultModalWidth : viewPortWidth - clickAreaWidth;
    };

    $scope.getActivationCodeDetails = function (transactionId) {

        var activationCodesPromise = ActivationCodeRestService.getAllAsync().then(function (response) {

            _index.ActivationCodesRepository.replace(response.data.data);

            // Hide subscriptions widget from homepage
            var hasAPaidLicense = response.data.data.length;
            if (hasAPaidLicense && !$rootScope.cmaGBapplies) {

                $rootScope.hideHomepageSubscriptionWidget = true;
            } else {

                $rootScope.hideHomepageSubscriptionWidget = false;
            }
            // End hide subscriptions widget from homepage
        });

        var transactionsPromise = TransactionRestService.getAllAsync().then(function (response) {

            _index.TransactionsRepository.replace(response.data.data);
        });

        var promisesArray = [activationCodesPromise, transactionsPromise];

        Promise.allSettled(promisesArray).then(function () {

            var activationCodes = _index.ActivationCodesRepository.getAll();
            var transactions = _index.TransactionsRepository.getAll();

            var currentActivationCode = void 0;

            var currentTransaction = transactions.find(function (transaction) {
                return transaction.attributes.payment_transaction_id === transactionId;
            });

            // If the transaction is missing, we are looking for the annual trial
            if (currentTransaction) {

                currentActivationCode = activationCodes.find(function (activationCode) {
                    return activationCode.id === currentTransaction.relationships['activation-code'].data.id;
                });
            } else {

                currentActivationCode = activationCodes.find(function (activationCode) {
                    return activationCode.attributes.subscription_type === 'annual-trial' && activationCode.relationships.app.data.id === 'aps10';
                });
                $scope.showFreeTrialCmaInfo = true;
            }
            // const currentRuntime = Util.deepFind(currentActivationCode, 'attributes.runtime');
            var currentAppId = Util.deepFind(currentActivationCode, 'attributes.app');

            var subscriptionType = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
            $scope.formattedExpireDate = moment($scope.expireDate).format('L');

            var nextBillingEvent = Util.deepFind(currentActivationCode, 'attributes.next_billing_event');

            if (!nextBillingEvent) {

                switch (subscriptionType) {

                    case 'yearly':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly':
                        nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                        break;
                    case 'annual':
                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                        break;
                    case 'monthly-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    case 'annual-trial':
                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                        break;
                    default:
                        nextBillingEvent = expirationDate;

                }
            }

            $scope.nextBillingEvent = moment(nextBillingEvent).format('L');

            var subscriptionTypeValue = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
            if (subscriptionTypeValue === 'yearly' || subscriptionTypeValue === 'annual' || subscriptionTypeValue === 'annual-trial') {

                $scope.isAnnual = true;
                $scope.currentPrice = _index.AppPricesRepository.getSinglePrice(currentAppId, '12', '1');
            } else if (subscriptionTypeValue === 'monthly' || subscriptionTypeValue === 'monthly-trial') {

                $scope.isMonthly = true;
                $scope.currentPrice = _index.AppPricesRepository.getSinglePrice(currentAppId, '1', '1');
            }

            var hasPromotion = Util.deepFind($scope.currentPrice, 'attributes.promotion');

            if (hasPromotion) {

                $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.promotion.pc_price_string');
            } else {

                $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.price_string');
            }
        });
    };

    var _LicensesRepository$g = _index.LicensesRepository.getAll(),
        _LicensesRepository$g2 = _slicedToArray(_LicensesRepository$g, 1),
        currentLicense = _LicensesRepository$g2[0];

    var modifyDate = new Date(Util.deepFind(currentLicense, 'attributes.modify_date'));
    // The flags are used to prevent multiple calls to the backend
    var checkPaypalPaymentFunctionCall = false;
    var checkPaypalPaymentFunctionApiCalls = true;

    Promise.allSettled = function (promises) {

        var mappedPromises = promises.map(function (p) {
            return p.then(function (value) {
                return {
                    status: 'fulfilled',
                    value: value
                };
            }).catch(function (reason) {
                return {
                    status: 'rejected',
                    reason: reason
                };
            });
        });
        return Promise.all(mappedPromises);
    };

    // Check if the last transaction was made using PayPal
    var checkPaypalPayment = function checkPaypalPayment() {

        if (checkPaypalPaymentFunctionCall && checkPaypalPaymentFunctionApiCalls) {

            var activationCodesPromise = ActivationCodeRestService.getAllAsync().then(function (response) {

                _index.ActivationCodesRepository.replace(response.data.data);
            });

            var paymentTypesPromise = PaymentTypesRestService.getAllAsync().then(function (response) {

                _index.PaymentTypesRepository.replace(response.data.data);
            });

            var transactionsPromise = TransactionRestService.getAllAsync().then(function (response) {

                _index.TransactionsRepository.replace(response.data.data);
            });

            var promisesArray = [activationCodesPromise, paymentTypesPromise, transactionsPromise];

            Promise.allSettled(promisesArray).then(function () {

                checkPaypalPaymentFunctionApiCalls = false;
                var licenses = _index.LicensesRepository.getAll();
                var activationCodes = _index.ActivationCodesRepository.getAll();
                var transactions = _index.TransactionsRepository.getAll();
                var paymentTypes = _index.PaymentTypesRepository.getAll();

                if (licenses.length > 0 && activationCodes.length > 0 && transactions.length > 0 && paymentTypes.length > 0) {
                    var _licenses = _slicedToArray(licenses, 1),
                        lastLicense = _licenses[0];

                    var newLicenseModifyDate = new Date(Util.deepFind(lastLicense, 'attributes.modify_date'));

                    var _transactions = _slicedToArray(transactions, 1),
                        transaction = _transactions[0];

                    var transactionId = Util.deepFind(transaction, 'attributes.payment_transaction_id');
                    var associatedPayment = paymentTypes.find(function (paymentType) {
                        return paymentType.id === transactionId;
                    });
                    var associatedPaymentType = associatedPayment && associatedPayment.attributes.payment_type ? associatedPayment.attributes.payment_type.toLowerCase() : '';

                    if (modifyDate.getTime() !== newLicenseModifyDate.getTime() && associatedPaymentType.indexOf('paypal') > -1) {

                        angular.element('.payment-cart-modal').css('min-height', '445px');
                        $scope.showLoading = false;
                        $scope.showCartIframe = false;
                        $scope.showSuccessModal = true;
                        $scope.transactionId = transactionId;
                        $scope.$apply();

                        mixpanelDetails.Modal = 'Cart Iframe Payment Successful';
                        mixpanelDetails['Payment Method'] = 'PayPal';
                        _RFC2.default.send('ConnectWeb Modal Open', mixpanelDetails);
                    }
                }
            });
        } else {

            checkPaypalPaymentFunctionCall = true;
        }
    };

    var licensesRepository = _index.LicensesRepository.getObservable();
    var licensesRepositorySubscriber = licensesRepository.subscribe(function () {
        return checkPaypalPayment();
    }, function () {}, function () {});

    $scope.$on('$destroy', function () {

        licensesRepositorySubscriber.dispose();
    });

    $scope.actionDone = function () {

        if ($scope.app.id === 'adwp1') {

            if ($state.current.name.indexOf('.store') > -1 || $state.current.name.indexOf('.ltb.buy') > -1) {

                $state.go('root.dashboard.dwm', {
                    tab: 'dwm'
                });
            } else {

                $scope.closeModal();
            }
        } else {

            $state.go('root.dashboard.subscriptions', {
                tab: 'plans'
            });
        }
    };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("9dPI")))

/***/ }),

/***/ "ycmm":
/***/ (function(module, exports) {

module.exports = "<div class=\"main-auth\">\n    <div class=\"auth-region\">\n\n        <!-- SSO SKIP -->\n        <div ng-if=\"showSkipButton || showCloseButton\" class=\"auth-sso-header\">\n            <div class=\"sso-move\" ng-if=\"showCloseButton\" onmousedown=\"window.external.Execute('aoe://Move')\"></div>\n            <div ng-if=\"showSkipButton\" class=\"sso-skip\" ng-click=\"oauthCtrl.skip()\">\n                <i class=\"icon icon-back icon-grey-4 icon-xxs fl-left\"></i>\n                <a class=\"text-m text-grey-4 fl-left ml10\" translate=\"cw.general.ui.back\"></a>\n            </div>\n            <div class=\"sso-logo centerMiddle\"></div>\n            <div ng-if=\"showCloseButton\" class=\"sso-close\">\n                <a class=\"text-m text-grey-4 fl-right\" href=\"aoe://close\">\n                    <i class=\"icon icon-close3 icon-grey-4 icon-xxs fl-right ml10\"></i>\n                    <span class=\"text-m text-grey-4 fl-right\" translate=\"cw.general.ui.close\"></span>\n                </a>\n            </div>\n        </div>\n        <!-- end -->\n\n        <a ng-if=\"!showSkipButton && !showCloseButton\" ui-sref=\"root.auth.login\" class=\"logo-mobile\">\n            <i class=\"sprite sprite-logo\"></i>\n            <h1>{{State.partner.name}}</h1>\n        </a>\n\n        <div class=\"auth-forgot-form form-wrapper\">\n\n            <h3 class=\"text-m text-grey-4 text-right mb90 auth-language\">\n                <change-language ng-if=\"showChangeLang\"></change-language>\n            </h3>\n\n            <h1 class=\"text-xxl text-grey-1 mb5\" translate=\"cw.auth.forgot.title2\" connectqa-forgot=\"header\"></h1>\n            <h2 class=\"text-l text-grey-4 mb15\" translate=\"cw.auth.forgot.title\" connectqa-forgot=\"paragraph\"></h2>\n\n            <div class=\"hideCssBlock\" ng-class=\"{'showCssBlock': captchaError}\">\n                <h5 class=\"text-m text-red-2\" id=\"error-message-captcha\" ng-show=\"submitted && captchaRequired\" translate=\"cw.notification.auth.signup.require_captcha\"></h5>\n            </div>\n\n            <form class=\"auth-form\" name=\"forgotPasswordForm\" role=\"form\" novalidate ng-submit=\"oauthCtrl.onSubmit()\">\n\n                <div class=\"form-group\">\n                    <input type=\"email\"\n                        spellcheck=\"false\"\n                        autocorrect=\"off\"\n                        autocomplete=\"off\"\n                        autocapitalize=\"off\"\n                        ng-model=\"email\"\n                        name=\"email\"\n                        maxlength=\"100\"\n                        autocomplete=\"off\"\n                        ng-class=\"{'error': forgotPasswordForm.email.$invalid && submitted}\"\n                        id=\"email\"\n                        placeholder=\"{{ 'cw.form.email' | translate }}\"\n                        ng-pattern=\"emailRegExp\"\n                        required\n                        connectqa-forgot=\"email-address\"\n                    />\n\n                    <label ng-hide=\"forgotPasswordForm.email.$viewValue.length > 0\" class=\"fallback-input\" for=\"email\" translate=\"cw.form.email\"></label>\n                    <p class=\"error-message\" ng-show=\"forgotPasswordForm.email.$invalid && submitted\" translate=\"cw.validator.messages.email\" connectqa-forgot=\"empty-email-error-message\"></p>\n                </div>\n\n                <button class=\"btn btn-large btn-full-width btn-primary mb10 spin-loader\" ng-disabled=\"oauthCtrl.Auth.loading\" translate=\"cw.auth.forgot.button\"\n                    connectqa-forgot=\"password-reset\">\n                </button>\n\n                <div class=\"auth-actions mb20\">\n                    <a class=\"text-m text-blue-3 mt10 inline-block\" ui-sref=\"root.auth.login\">\n                        <span class=\"text-xl\">&lsaquo; </span>\n                        <span translate=\"cw.auth.go_to_login\" connectqa-forgot=\"go-to-login-page\"></span>\n                    </a>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "yjMe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$window', '$http', '$rootScope', 'Util', '$translate'];

var CoinbaseAccount = function CoinbaseAccount($scope, $window, $http, $rootScope, Util, $translate) {
    _classCallCheck(this, CoinbaseAccount);

    $scope.isLoggedInCoinbase = false;
    $scope.dataIsLoading = true;
    $scope.activeCrypto = 'ETH';
    $scope.activeCurrency = $rootScope.cryptoCurrency || 'USD';
    $scope.amountValue = 0;
    $scope.transactionConsent = false;
    $scope.transactionConsentError = false;
    $scope.enableReviewWithdraw = false;
    $scope.hasErrorsReviewWithdraw = true;
    $scope.hasErrorsWithdraw = true;
    $scope.withdrawFromWallet = {};
    $scope.withdrawFromWallet.selected = '';
    $scope.withdrawToWallet = {};
    $scope.withdrawToWallet.selected = '';
    $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_1');

    $scope.withdrawStep = '1';

    $scope.back = function () {

        $scope.withdrawStep = '1';
    };

    $scope.getWithdrawQuote = function () {

        $scope.quote = { networkFee: '', transfer: '', networkFeeNumber: 0 };
        var fee = +$scope.fees.txFeeMap[$scope.activeCrypto];
        var feeInCurrency = fee * $scope.prices.conversionRateMap[$scope.activeCurrency];
        $scope.quote.networkFee = +Util.toFixed(fee, 6) + ' ' + $scope.activeCrypto + ' (' + Util.toFixed(feeInCurrency, 2) + ' ' + $scope.activeCurrency + ')';

        $scope.quote.networkFeeNumber = Util.toFixed(fee, 6);

        if (!$scope.amountError && $scope.amountValue > 0) {

            var transferCrypto = $scope.amountValue - fee;
            var transferInCurency = transferCrypto * $scope.prices.conversionRateMap[$scope.activeCurrency];
            $scope.quote.transfer = Util.toFixed(transferCrypto, 6) + ' ' + $scope.activeCrypto + ' (' + Util.toFixed(transferInCurency, 2) + ' ' + $scope.activeCurrency + ')';

            if ($scope.quote.transfer.indexOf('-') > -1) {

                $scope.amountError = true;
                $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_2');
                $scope.quote.transfer = '0 ' + $scope.activeCrypto + ' (0 ' + $scope.activeCurrency + ')';
            } else {

                $scope.hasErrorsReviewWithdraw = false;
            }
        } else {

            $scope.quote.transfer = '0 ' + $scope.activeCrypto + ' (0 ' + $scope.activeCurrency + ')';

            if ($scope.quote.transfer.indexOf('0') > -1) {

                $scope.amountError = true;
            } else {

                $scope.hasErrorsReviewWithdraw = false;
            }
        }
    };

    $scope.onChangeCheckbox = function () {

        $scope.transactionConsent = !$scope.transactionConsent;

        if ($scope.transactionConsent) {

            $scope.transactionConsentError = false;
            $scope.hasErrorsWithdraw = false;
        } else {

            $scope.transactionConsentError = true;
            $scope.hasErrorsWithdraw = true;
        }
    };

    $scope.validateReviewWithdraw = function () {

        if ($scope.amountError || typeof $scope.amountError === 'undefined' || $scope.WithdrawFromError || typeof $scope.WithdrawFromError === 'undefined' || $scope.WithdrawToError || typeof $scope.WithdrawToError === 'undefined') {

            $scope.hasErrorsReviewWithdraw = true;
        } else {

            $scope.hasErrorsReviewWithdraw = false;
        }
    };

    $scope.maxAmoutValue = function () {

        angular.element('#amount').val($scope.totalBalance);
        $scope.amountValue = $scope.totalBalance;
        $scope.amountError = false;
        $scope.getWithdrawQuote();
        $scope.validateReviewWithdraw();
    };

    var onCryptoDataNext = function onCryptoDataNext() {

        $scope.wallets = _index.CryptoRepository.getAll('wallets') || {};
        $scope.fees = _index.CryptoRepository.getAll('fees') || {};
        $scope.prices = _index.CryptoRepository.getAll('prices') || {};

        if (Object.keys($scope.wallets).length >= 1) {

            $scope.balance = Util.toFixed($scope.wallets[$scope.activeCrypto].balance, 6);

            $scope.totalBalance = $scope.wallets[$scope.activeCrypto].balance;
            $scope.amountValue = $scope.totalBalance;
            $scope.walletCurrencies = Object.keys($scope.wallets);
            $scope.withdrawFromWallet.selected = [$scope.walletCurrencies];
            $scope.amountError = false;
            $scope.WithdrawToError = false;
        }

        if (Object.keys($scope.fees).length >= 1 && Object.keys($scope.prices).length >= 1) {

            $scope.getWithdrawQuote();
        }
    };

    this.cryptoRepository = _index.CryptoRepository.getObservable();
    this.cryptoSubscriber = this.cryptoRepository.subscribe(function (data) {
        return onCryptoDataNext(data);
    }, function () {}, function () {});

    $scope.validateAmount = function ($event) {

        $event.currentTarget.value = $event.currentTarget.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');

        if (isNaN(parseFloat($event.currentTarget.value)) || parseFloat($event.currentTarget.value) > $scope.totalBalance) {

            $scope.amountError = true;
            if (isNaN(parseFloat($event.currentTarget.value))) {

                $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_1');
            } else if (parseFloat($event.currentTarget.value) > $scope.totalBalance) {

                $scope.amountErrorMessage = $translate.instant('cw.dashboard.crypto.coinbase.amount_error_3');
            }
        } else {

            $scope.amountError = false;
            $scope.amountValue = $event.currentTarget.value;
            $scope.getWithdrawQuote();
        }

        $scope.validateReviewWithdraw();
    };

    $scope.validateWithdrawFrom = function (activeWallet) {

        if (activeWallet) {

            $scope.WithdrawFrom = $scope.wallets[activeWallet];
            $scope.WithdrawFromError = false;
            $scope.withdrawFromWallet.selected = activeWallet;
        }

        $scope.validateReviewWithdraw();
    };

    $scope.validateWithdrawTo = function (activeWallet) {

        if (activeWallet) {

            $scope.WithdrawTo = activeWallet;
            $scope.WithdrawToError = false;
            $scope.withdrawToWallet.selected = activeWallet;
        }

        $scope.validateReviewWithdraw();
    };

    $scope.reviewWithdraw = function () {

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Crypto Withdraw Details',
            'Button Label': 'Review Withdraw',
            Destination: 'Coinbase',
            Coin: 'ETH',
            Amount: $scope.amountValue,
            'Network Fee': $scope.quote.networkFeeNumber
        });

        if (!$scope.hasErrorsReviewWithdraw) {

            $scope.withdrawStep = '2';

            _RFC4.default.send('ConnectWeb Modal Open', {
                Modal: ' Crypto Withdraw Review',
                Destination: 'Coinbase',
                Coin: 'ETH',
                Amount: $scope.amountValue,
                'Network Fee': $scope.quote.networkFeeNumber
            });
        }
    };

    $scope.proceedToCoinbase = function () {

        var width = 800;var height = 800;
        var left = $window.innerWidth / 2 - width / 2;
        var top = $window.innerHeight / 2 - height / 2;
        var strWindowFeatures = 'toolbar=no, menubar=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left;
        var clientId = CWCONFIG.coinbase.clientId;
        var redirectURI = CWCONFIG.coinbase.redirectURI;

        $window.open('https://www.coinbase.com/oauth/authorize?client_id=' + clientId + '&redirect_uri=' + redirectURI + '&response_type=code&scope=wallet:accounts:read,wallet:addresses:read,wallet:addresses:create&account_currency=ETH', 'coinbaseAuth', strWindowFeatures);
        $scope.waitingForCoinbase = true;

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Crypto Withdraw Options',
            'Button Label': 'Link Coinbase Account'
        });

        _RFC4.default.send('ConnectWeb Modal Open', {
            Modal: 'Crypto Coinbase Instructions'
        });
    };

    $scope.checkCoibaseAuth = function () {

        $scope.getCookie = function (cname) {

            var name = cname + '=';
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            // eslint-disable-next-line no-plusplus
            for (var i = 0; i < ca.length; i++) {

                var c = ca[i];
                while (c.charAt(0) === ' ') {

                    c = c.substring(1);
                }

                if (c.indexOf(name) === 0) {

                    return c.substring(name.length, c.length);
                }
            }

            return '';
        };

        var coinbaseCookie = $scope.getCookie('coinbase_token').replace(/\\"/g, '"').replace(/"{/g, '{')
        // eslint-disable-next-line no-useless-escape
        .replace(/}\"/g, '}').replace(/\\054/g, ',');

        if (coinbaseCookie) {

            var parsedCookie = JSON.parse(coinbaseCookie);
            var coinbaseAccessToken = parsedCookie.access_token;

            $http({
                method: 'GET',
                url: 'https://api.coinbase.com/v2/user',
                headers: {
                    Authorization: 'Bearer ' + coinbaseAccessToken
                }

            }).then(function (response) {

                $scope.coinbaseUserData = response.data;
                $scope.userName = Util.deepFind($scope.coinbaseUserData, 'data.name');
                $scope.isLoggedInCoinbase = true;
                $scope.dataIsLoading = false;

                _RFC4.default.send('ConnectWeb Modal Open', {
                    Modal: 'Crypto Withdraw Details'
                });
            }).catch(function () {

                $scope.isLoggedInCoinbase = false;
                $scope.dataIsLoading = false;

                _RFC4.default.send('ConnectWeb Modal Open', {
                    Modal: 'Crypto Withdraw Options'
                });
            });

            $http({
                method: 'GET',
                url: 'https://api.coinbase.com/v2/accounts?scope=wallet:accounts:read',
                headers: {
                    Authorization: 'Bearer ' + coinbaseAccessToken
                }

            }).then(function (response) {

                $scope.coinbaseAccounts = [];
                var ethAccount = response.data.data.find(function (account) {
                    return account.currency.code === 'ETH';
                });
                $scope.withdrawToWallet.selected = ethAccount;
                $scope.WithdrawFromError = false;

                if (ethAccount) {

                    $scope.coinbaseAccounts.push(ethAccount);
                    $scope.getAddresses();
                } else {

                    $http({
                        method: 'GET',
                        url: 'https://api.coinbase.com/v2/accounts/ETH?scope=wallet:accounts:create',
                        headers: {
                            Authorization: 'Bearer ' + coinbaseAccessToken
                        }

                    }).then(function (response2) {

                        $scope.coinbaseAccounts.push(response2.data.data);
                        $scope.withdrawToWallet.selected = response2.data.data;
                        $scope.getAddresses();

                        _RFC4.default.send('ConnectWeb Crypto Account Create Success', {
                            Resource: 'CREATE coinbase-accounts'
                        });
                    }).catch(function (error) {

                        _RFC2.default.error('<strong>ETH account cannot be created.</strong>');

                        _RFC4.default.send('ConnectWeb Crypto Error', {
                            Resource: 'CREATE coinbase-accounts',
                            'Error Details': error.data.errors
                        });
                    });

                    _RFC4.default.send('ConnectWeb Crypto Error', {
                        'Error Code': 'None',
                        'Error Name': 'No ETH account found',
                        Resource: 'GET coinbase-accounts'
                    });
                }
            }).catch(function () {

                $scope.coinbaseAccounts = [];
            });
        } else {

            $scope.dataIsLoading = false;

            _RFC4.default.send('ConnectWeb Modal Open', {
                Modal: 'Crypto Withdraw Options'
            });
        }
    };

    $scope.getAddresses = function () {

        var coinbaseCookie = $scope.getCookie('coinbase_token').replace(/\\"/g, '"').replace(/"{/g, '{')
        // eslint-disable-next-line no-useless-escape
        .replace(/}\"/g, '}').replace(/\\054/g, ',');

        var parsedCookie = JSON.parse(coinbaseCookie);
        var coinbaseAccessToken = parsedCookie.access_token;

        if ($scope.coinbaseAccounts[0]) {

            $http({
                method: 'GET',
                url: 'https://api.coinbase.com/v2/accounts/' + $scope.coinbaseAccounts[0].id + '/addresses',
                headers: {
                    Authorization: 'Bearer ' + coinbaseAccessToken
                }
            }).then(function (rsp) {

                if (rsp.data.data.length === 0) {

                    var payload = {
                        name: 'ETH Wallet'
                    };

                    $http({
                        method: 'POST',
                        url: 'https://api.coinbase.com/v2/accounts/' + $scope.coinbaseAccounts[0].id + '/addresses',
                        headers: {
                            Authorization: 'Bearer ' + coinbaseAccessToken
                        },
                        payload: payload
                    }).then(function () {

                        $http({
                            method: 'GET',
                            url: 'https://api.coinbase.com/v2/accounts/' + $scope.coinbaseAccounts[0].id + '/addresses',
                            headers: {
                                Authorization: 'Bearer ' + coinbaseAccessToken
                            }
                        }).then(function (rsp2) {

                            $scope.ethWalletAddress = rsp2.data.data[0].address;
                        });
                    });
                } else {

                    $scope.ethWalletAddress = rsp.data.data[0].address;
                }

                if (rsp.data.data.length === 0) {

                    _RFC4.default.send('ConnectWeb Crypto Error', {
                        'Error Code': 'None',
                        'Error Name': 'No ETH address found',
                        Resource: 'GET coinbase-addresses'
                    });
                }
            });
        }
    };

    $scope.checkCoibaseAuth();

    $scope.withdraw = function () {

        if (!$scope.transactionConsent) {

            $scope.transactionConsentError = true;
            return;
        }

        $scope.withdrawStep = 'loading';

        _RFC4.default.send('ConnectWeb Modal Button Click', {
            Modal: 'Crypto Withdraw Review',
            'Button Label': 'Confirm Withdraw',
            Destination: 'Coinbase',
            Coin: 'ETH',
            Amount: $scope.amountValue,
            'Network Fee': $scope.quote.networkFeeNumber
        });

        var data = {
            nortonGuid: $rootScope.nortonGuid,
            currency: 'ETH',
            address: $scope.ethWalletAddress,
            amount: $scope.amountValue
        };

        var _CWCONFIG = CWCONFIG,
            cryptoRestApi = _CWCONFIG.cryptoRestApi;


        $http({
            method: 'POST',
            url: cryptoRestApi + '/wallet/api/withdraw',
            headers: {
                Authorization: 'Bearer ' + Util.getToken()
            },
            data: data

        }).then(function () {

            _RFC4.default.send('ConnectWeb Modal Open', {
                Modal: 'Crypto Withdraw Success',
                Destination: 'Coinbase',
                Coin: 'ETH',
                Amount: $scope.amountValue,
                'Network Fee': $scope.quote.networkFeeNumber
            });

            $scope.withdrawStep = 'withdraw-complete';
        }).catch(function (error) {

            _RFC2.default.error('<strong>' + error.status + '</strong>: ' + error.data);
            _RFC4.default.send('ConnectWeb Crypto Error', {
                'Error Code': error.status,
                'Error Name': error.data ? error.data : 'No error message',
                Resource: 'POST withdraw'
            });
            Util.closeModal();
        });
    };

    $scope.closeModal = function () {

        Util.closeModal();
    };

    window.addEventListener('message', function (event) {

        if (event.data === 'coinbase_login') {

            $scope.checkCoibaseAuth();
        }
    });
};

_serviceDependencies.push(CoinbaseAccount);

angular.module('controllers').controller('CoinbaseAccount', _serviceDependencies);

/***/ }),

/***/ "z/zf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

var _RFC = __webpack_require__("Tk6B");

var _RFC2 = _interopRequireDefault(_RFC);

var _RFC3 = __webpack_require__("lD2H");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-restricted-globals */


var _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util'];

var DwmPhoneNumbers = function DwmPhoneNumbers($scope, $http, $rootScope, Util) {
    _classCallCheck(this, DwmPhoneNumbers);

    $scope.selectedDevice = $scope.selectedDevice || {};
    $scope.phoneNumberIsValid = false;
    $rootScope.phoneNumberErrorDWM = false;

    var onDwmDataNext = function onDwmDataNext() {

        var assets = _index.dwmRepository.getAll('assets') || {};
        if (assets.primaryMember) {

            $scope.phoneNumbers = assets.primaryMember.monitoredAccounts.phoneNumbers;

            $scope.phoneNumbers.entries.forEach(function (entry) {

                if (entry.countryCallingCode === null && entry.countryCode === 'DE') {

                    entry.countryCallingCode = '49';
                }

                entry.showUpdateInput = false;
            });
        }
    };

    var dwmRepositoryObservable = _index.dwmRepository.getObservable();
    dwmRepositoryObservable.subscribe(function (data) {
        return onDwmDataNext(data);
    }, function () {}, function () {});

    $scope.newEntryVisible = false;
    $scope.showAddNewButton = true;
    $scope.showSaveButton = false;
    $scope.showRemoveEntryScreen = false;
    $scope.showUpdateButton = false;

    $scope.addNewEntry = function () {

        $scope.newEntryVisible = true;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = true;
    };

    $scope.cancelNewEntry = function () {

        $rootScope.phoneNumberErrorDWM = false;
        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.newPhoneNumber = '';
        $scope.selectedDevice = {};
        $scope.newEntrySubmitted = false;
    };

    $scope.updateEntry = function (index) {

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = false;
        $scope.showSaveButton = false;
        $scope.showUpdateButton = true;

        $scope.phoneNumbers.entries.forEach(function (entry, loopIndex) {

            if (index === loopIndex) {

                entry.showUpdateInput = true;
                $scope.updateEntryPayload = entry;
                $scope.updateEntryIndex = index;

                // Save initial phone number to use in case of update with the same value
                $scope.initialPhoneNumber = entry.phoneNumber;

                // Save the entry values to autofill country-selector
                $scope.selectedDevice = {
                    phoneNumber: entry.phoneNumber,
                    country: {
                        code: entry.countryCode.toLowerCase(),
                        dialCode: '+' + entry.countryCallingCode
                    }
                };
            } else {

                entry.showUpdateInput = false;
            }
        });
    };

    $scope.cancelUpdateNewEntry = function () {

        $scope.showAddNewButton = true;
        $scope.showUpdateButton = false;
        $rootScope.phoneNumberErrorDWM = false;

        $scope.phoneNumbers.entries.forEach(function (entry) {

            entry.showUpdateInput = false;
        });

        $scope.updateEntryPayload = {};
        $scope.selectedDevice = {};
    };

    $scope.validatePhoneNumber = function () {

        var countryCode = $scope.selectedDevice.country ? $scope.selectedDevice.country.code.substring(0, 2) : '';

        // Check if the phone number is from international calling zone 1 and add to phoneNumber
        var isZoneOne = $scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
        var phoneNumberZoneOne = isZoneOne ? $scope.selectedDevice.country.dialCode.substring(3).concat($scope.selectedDevice.phoneNumber) : '';

        var isValidNumber = isZoneOne ? Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) : Util.isValidPhoneNumber($scope.selectedDevice.phoneNumber, countryCode);

        $scope.newPhoneNumber = $scope.selectedDevice.phoneNumber;
        $scope.countryCode = countryCode.toUpperCase();

        var phoneExists = $scope.phoneNumbers.entries.find(function (phone) {
            return phone.countryCode === $scope.countryCode && phone.phoneNumber === $scope.newPhoneNumber;
        });

        $scope.phoneExistsError = phoneExists;
        return isValidNumber && !phoneExists;
    };

    $scope.saveNewEntry = function () {

        $scope.phoneNumberIsValid = $scope.validatePhoneNumber();
        $scope.newEntrySubmitted = true;

        if ($scope.phoneNumberIsValid) {

            $scope.saveNewPhoneIsLoading = true;
            $rootScope.phoneNumberErrorDWM = false;
            var payload = void 0;
            if ($scope.phoneNumbers.entries.length === 0) {

                payload = {
                    primaryPhone: {
                        phoneNumber: $scope.newPhoneNumber,
                        countryCode: $scope.countryCode,
                        type: 'Mobile',
                        isPrimaryPhoneEmpty: true
                    }
                };
            } else {

                payload = {
                    phoneNumbers: {
                        phoneNumber: $scope.newPhoneNumber,
                        countryCode: $scope.countryCode,
                        type: 'Mobile'
                    }
                };
            }

            $http({
                method: 'POST',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: payload

            }).then(function () {

                $scope.newPhoneNumber = '';
                $scope.saveNewPhoneIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);

                    var _membersResponse$data = membersResponse.data.primaryMember,
                        monitoredAccounts = _membersResponse$data.monitoredAccounts,
                        dwmCardStatus = _membersResponse$data.dwmCardStatus;


                    _RFC4.default.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);

                    _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Add',
                        Entry: 'Phone numbers'
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;
                    } else {

                        $rootScope.showDwmCardHomepage = false;
                    }

                    $scope.cancelNewEntry();
                });
            }).catch(function (responseError) {

                $scope.saveNewPhoneIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        } else {

            $rootScope.phoneNumberErrorDWM = true;
        }
    };

    $scope.removeEntry = function (index) {

        $scope.showRemoveEntryScreen = true;
        $scope.cancelNewEntry();

        $scope.removeEntryPayload = {
            phoneNumbers: {
                id: $scope.phoneNumbers.entries[index].id
            }
        };
    };

    $scope.confirmRemoveEntry = function () {

        $scope.confirmRemoveIsLoading = true;

        $http({
            method: 'DELETE',
            url: CWCONFIG.dwm.restApi + '/v1/modifyAccount?payload=' + encodeURIComponent(JSON.stringify($scope.removeEntryPayload)),
            headers: {
                client_id: 'avira',
                origin: 'https://avira.com',
                access_token: $rootScope.dwmNortonToken,
                'Content-Type': 'application/json'
            }
        }).then(function () {

            $scope.newPhoneNumber = '';
            $http({
                method: 'GET',
                url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                }

            }).then(function (membersResponse) {

                _index.dwmRepository.replace('assets', membersResponse.data);

                var _membersResponse$data2 = membersResponse.data.primaryMember,
                    monitoredAccounts = _membersResponse$data2.monitoredAccounts,
                    dwmCardStatus = _membersResponse$data2.dwmCardStatus;

                _RFC4.default.setCommonProperty('AIA Asset Phone', monitoredAccounts.phoneNumbers.entries.length);

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Delete',
                    Entry: 'Phone numbers'
                });

                if (dwmCardStatus === 'add-more-data') {

                    $rootScope.showDwmCardHomepage = true;
                    $rootScope.showDwmAddMoreDataCard = true;
                } else {

                    $rootScope.showDwmCardHomepage = false;
                }

                $scope.confirmRemoveIsLoading = false;
                $scope.cancelRemoveEntry();
                $scope.cancelUpdateNewEntry();
            });
        }).catch(function (responseError) {

            $scope.confirmRemoveIsLoading = false;

            if (responseError.data) {

                _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                    message: {
                        brandname: CWCONFIG.partnerConfig.name,
                        url: '/dashboard/support/tabs/support'
                    }
                });
            }
        });
    };

    $scope.cancelRemoveEntry = function () {

        $scope.showRemoveEntryScreen = false;
        $scope.removeEntryPayload = {};
    };

    $scope.saveUpdatedEntry = function () {

        $scope.phoneNumberIsValid = $scope.validatePhoneNumber();
        $scope.saveUpdatedEntryIsLoading = true;

        if ($scope.phoneNumberIsValid && $scope.newPhoneNumber !== $scope.initialPhoneNumber) {

            $rootScope.phoneNumberErrorDWM = false;
            $scope.updateEntryPayload.phoneNumber = $scope.newPhoneNumber;
            $scope.updateEntryPayload.countryCode = $scope.countryCode;

            var data = void 0;
            if ($scope.updateEntryIndex === 0) {

                data = {
                    primaryPhone: {
                        phoneNumber: $scope.updateEntryPayload.phoneNumber,
                        type: 'MOBILE',
                        countryCode: $scope.updateEntryPayload.countryCode,
                        isPrimaryPhoneEmpty: false
                    }

                };
            } else {

                data = {
                    phoneNumbers: $scope.updateEntryPayload
                };
            }

            $http({
                method: 'PUT',
                url: CWCONFIG.dwm.restApi + '/v1/modifyAccount',
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json'
                },
                data: data
            }).then(function () {

                _RFC4.default.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Phone numbers'
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: CWCONFIG.dwm.restApi + '/v1/partner/members',
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json'
                    }

                }).then(function (membersResponse) {

                    _index.dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;
                });
            }).catch(function (responseError) {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        _RFC2.default.error('cw.dwm.dupliacte_entry_error');
                    } else {

                        _RFC2.default.error({ message: 'cw.recommendation.error.connection_failed' }, {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support'
                            }
                        });
                    }
                }
            });
        } else {

            $scope.saveUpdatedEntryIsLoading = false;
            $rootScope.phoneNumberErrorDWM = true;
        }
    };
};

_serviceDependencies.push(DwmPhoneNumbers);

angular.module('controllers').controller('DwmPhoneNumbers', _serviceDependencies);

/***/ }),

/***/ "z2L+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("lSlM");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _directiveDependencies = [];
var _controllerDependencies = ['$scope', 'Util'];

var CryptoMiningController = function CryptoMiningController($scope, Util) {
    _classCallCheck(this, CryptoMiningController);

    $scope.isMining = false;
    $scope.currency = 'ETH';

    $scope.updateRigs = function () {

        $scope.rigs = _index.CryptoRepository.getAllRigs() || [];

        var overallHashRate = 0;

        if ($scope.rigs.length > 0) {

            $scope.rigs.forEach(function (rig) {

                if (!rig.hashRate) {

                    rig.hashRate = 0;
                }

                overallHashRate += parseFloat(rig.hashRate);

                rig.updatedHash = $scope.getHashRate(rig.hashRate);

                if (rig.isMining) {

                    $scope.isMining = true;
                }
            });
        }

        $scope.overallHashRate = $scope.getHashRate(overallHashRate);
    };

    $scope.updateRigs();

    var onCryptoDataNext = function onCryptoDataNext() {

        $scope.updateRigs();
    };

    var onPayoutConfigNext = function onPayoutConfigNext() {

        var pendingBalances = _index.CryptoRepository.getAll('pendingBalances') || {};
        var payoutConfig = _index.CryptoRepository.getAll('payoutConfig') || {};

        if (Object.keys(pendingBalances).length > 0) {

            $scope.pendingBalance = Util.toFixed(pendingBalances[$scope.currency], 6).toString();
        }

        if (Object.keys(payoutConfig).length > 0) {

            $scope.payoutConfig = payoutConfig[$scope.currency].minPayout;
        }
    };

    this.cryptoRepository = _index.CryptoRepository.getObservableRigs();
    this.cryptoSubscriber = this.cryptoRepository.subscribe(function (data) {
        return onCryptoDataNext(data);
    }, function () {}, function () {});

    this.cryptoRepository = _index.CryptoRepository.getObservable();
    this.cryptoSubscriber = this.cryptoRepository.subscribe(function (data) {
        return onPayoutConfigNext(data);
    }, function () {}, function () {});
};

var CryptoMiningDirective = function CryptoMiningDirective() {
    _classCallCheck(this, CryptoMiningDirective);

    this.template = __webpack_require__("2ZBq");
    this.restrict = 'EA';
    this.replace = true;

    _controllerDependencies.push(function ($scope, Util) {
        return new CryptoMiningController($scope, Util);
    });
    this.controller = _controllerDependencies;
    this.controllerAs = 'CryptoMiningCtrl';
};

_directiveDependencies.push(function () {
    return new CryptoMiningDirective();
});

angular.module('directives').directive('cryptoMining', _directiveDependencies);

/***/ }),

/***/ "zOZQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var _flexiblePromotions = [];
var observableFlexiblePromotions = new Rx.BehaviorSubject(_flexiblePromotions);

var FlexiblePromotionsRepository = {
    add: function add(data) {
        var _this = this;

        data.forEach(function (item) {

            if (item.attributes.promotion_type === 'public') {

                var indexOfProduct = _this.getIndex(item.id);

                if (indexOfProduct === -1) {

                    var acronym = item.attributes.product_acronym;
                    var runtime = item.attributes.runtime;
                    var devices = item.attributes.devices;

                    var priceId = acronym + '_' + runtime + '_' + devices;
                    item.price_id = priceId;
                    _flexiblePromotions.push(item);
                }
            } else if (item.attributes.promotion_type === 'subscription_trial') {

                var _indexOfProduct = _this.getIndex(item.id);

                if (_indexOfProduct === -1) {

                    var _priceId = 'prime_anual_trial';
                    item.price_id = _priceId;
                    _flexiblePromotions.push(item);
                }
            }
        });

        observableFlexiblePromotions.onNext(_flexiblePromotions);
    },
    getPromotionById: function getPromotionById(promotionId) {

        return _flexiblePromotions.find(function (promotion) {
            return promotion.price_id === promotionId;
        });
    },
    getAll: function getAll() {

        return _flexiblePromotions;
    },
    replace: function replace(data) {

        _flexiblePromotions = data;
        observableFlexiblePromotions.onNext(_flexiblePromotions);
    },
    concatPromotions: function concatPromotions(data) {

        if (data[0]) {

            var indexOfPromotion = _flexiblePromotions.findIndex(function (promotion) {
                return promotion.id === data[0].id;
            });

            if (indexOfPromotion === -1) {

                _flexiblePromotions = _flexiblePromotions.concat(data);
            }
        }

        observableFlexiblePromotions.onNext(_flexiblePromotions);
    },
    getIndex: function getIndex(dataId) {

        return _flexiblePromotions.findIndex(function (_flexiblePromotion) {
            return String(_flexiblePromotion.id) === String(dataId);
        });
    },
    getObservable: function getObservable() {

        return observableFlexiblePromotions;
    }
};

exports.default = FlexiblePromotionsRepository;

/***/ }),

/***/ "zOp4":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "zSYf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__("poBF");

var _RFC = __webpack_require__("lD2H");

var _RFC2 = _interopRequireDefault(_RFC);

var _loggers = __webpack_require__("+htc");

var _loggers2 = _interopRequireDefault(_loggers);

var _index2 = __webpack_require__("lSlM");

var _productFilters = __webpack_require__("nHzQ");

var _RFC3 = __webpack_require__("Tk6B");

var _RFC4 = _interopRequireDefault(_RFC3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-unneeded-ternary: 0 */
/* eslint array-callback-return: 0 */

var currentDeviceOS = window.deviceOs;
var _devicesWithoutAppInstalled = {};

/**
 * Products
 */
angular.module('controllers').controller('Products', ['$scope', '$state', 'Util', '$window', 'DeployRestService', function ($scope, $state, Util, $window, DeployRestService) {

    $scope.browserName = $window.browserName.toLowerCase();
    $scope.unsupportedApps = CWCONFIG.hiddenAppInBundle || [];
    $scope.currentDeviceOS = currentDeviceOS;
    $scope.isWindowsOS = !!(currentDeviceOS.toLowerCase().indexOf('windows') > -1);
    $scope.language = CWCONFIG.language === 'de' ? 'de' : null;
    $scope.brandName = CWCONFIG.partnerConfig.name;

    var isBrowserExtension = function isBrowserExtension(app) {

        var platformList = Util.deepFind(app, 'attributes.platform.type') || Util.deepFind(app, 'attributes.custom.manifest.os');
        if (!platformList) {

            return false;
        }
        if (platformList.indexOf('browser') !== -1 || platformList.indexOf('webapp') !== -1) {

            return true;
        }
        return false;
    };
    var isIOTApps = function isIOTApps(app) {

        if (Util.deepFind(app, 'attributes.custom.manifest.id') === 'iot') {

            return true;
        }

        return false;
    };
    $scope.apps = filterProducts(_index2.AppIntegrationsRepository.getAll());
    $scope.browserExtensions = $scope.apps.filter(isBrowserExtension);
    $scope.mobileApps = $scope.apps.filter(function (app) {
        return app.attributes.platform.type.find(function (os) {
            return os === 'android' || os === 'ios';
        });
    });
    $scope.iotApps = $scope.apps.filter(isIOTApps);

    // assign a proper FSS banner's title and download bundle based on user's subscription
    var defaultDeployedAppId = void 0;
    if ($scope.isWindowsOS) {

        defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.windows || 'sptl1';
    } else if (currentDeviceOS === 'mac_os_x') {

        defaultDeployedAppId = CWCONFIG.defaultDeployedAppId.osx || 'fass0';
    }

    var licensesRepo = _index2.LicensesRepository.getAll();

    var hasPrime = function hasPrime(appId) {
        return !!licensesRepo.find(function (license) {
            return appId === license.relationships.app.data.id && license.attributes.expired === false;
        });
    };

    if (hasPrime('aps20')) {

        defaultDeployedAppId = 'aps20';
    } else if (hasPrime('aps10')) {

        defaultDeployedAppId = 'aps10';
    } else if (hasPrime('aps30')) {

        defaultDeployedAppId = 'aps30';
    }
    $scope.featureApp = _index2.AppIntegrationsRepository.getById(defaultDeployedAppId) || {};

    var appName = _index2.AppIntegrationsRepository.getAppName(defaultDeployedAppId) || '';

    $scope.featureAppTitle = licensesRepo.length === 0 ? appName : $scope.brandName + ' ' + appName.replace(/free/i, '');

    // if default appId is SPTL1 we offer FASS0 app intergrations instead
    var AppIntegrations = defaultDeployedAppId === 'sptl1' ? _index2.AppIntegrationsRepository.getById('fass0') : _index2.AppIntegrationsRepository.getById(defaultDeployedAppId);

    var appComponents = [];
    var includedApps = Util.deepFind(AppIntegrations, 'relationships.apps') || {};
    if (includedApps.data) {

        includedApps.data.forEach(function (app) {

            if (!$scope.unsupportedApps.find(function (id) {
                return app.id === id;
            }) && _index2.AppIntegrationsRepository.getById(app.id) !== undefined) {

                appComponents.push(_index2.AppIntegrationsRepository.getById(app.id));
            }
        });
    }
    // sort app components by category
    $scope.servicesByCategory = {
        security: [],
        privacy: [],
        performance: []
    };
    appComponents = appComponents.filter((0, _productFilters.hasUnsupportedBrowsers)(Util, $scope));
    appComponents.forEach(function (integration) {

        // e.g. antivirus
        var serviceName = integration.attributes.prototype || integration.attributes.service;

        var category = CWCONFIG.servicesByCategory[serviceName];

        if (category) {

            $scope.servicesByCategory[category].push(integration);
        }
    });

    // we go through each product and we apply two sequential filters
    // we show items that pass both filters, both only log items that don't pass the second
    function filterProducts(products) {

        var filteredProducts = [];
        var hiddenProducts = [];

        var essentialProps = (0, _productFilters.hasEssentialProps)(hiddenProducts);

        /**
         * Remove browser extensions if the current browser is not compatible with the extension
         */
        var unsupportedBrowsers = (0, _productFilters.hasUnsupportedBrowsers)(Util, $scope);

        products.filter(_productFilters.isVisible).filter(essentialProps).filter(unsupportedBrowsers).map(function (product) {

            // Password Manager is a webapp, so we add Windows & OSX in order
            // to show it when these filters are selected
            if (product.attributes.platform.type.length === 1 && product.attributes.platform.type[0] === 'webapp') {

                Array.prototype.push.apply(product.attributes.platform.type, ['windows', 'osx']);

                product.devices = _index.DevicesProcessor.getDevicesByApp(product);
            }

            var serviceName = product.attributes.prototype || product.attributes.service;

            // compatible devices that have the product installed
            product.devices = _index.DevicesProcessor.getDevicesByApp(product).filter(function (device) {

                var productOs = Util.deepFind(product, 'attributes.platform.type');
                if (productOs) {

                    return productOs.indexOf(device.attributes.os) > -1;
                }

                return false;
            });
            product.mobileDevices = product.devices.filter(function (device) {
                return device.attributes.os === 'android' || device.attributes.os === 'ios';
            });

            // add 'category' property
            product.category = CWCONFIG.servicesByCategory[serviceName];

            product.buttonLabel = getButtonLabel(product);

            filteredProducts.push(product);
        });

        if (hiddenProducts.length > 0) {

            _loggers2.default.log({
                type: 'Product Catalog - free products that are hidden',
                cmd: '',
                data: hiddenProducts
            });
        }

        return filteredProducts;
    }

    _RFC2.default.send('ConnectWeb Free Products Open', {
        Source: 'Direct'
    });

    /**
     * Shows details of a product
     * @param {Object} app The object of the product
     */
    $scope.showDetails = function (app) {

        _RFC2.default.send('ConnectWeb Learn More Click', {
            Page: 'Free Products',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });

        $state.go('root.dashboard.products.ltb.activate', {
            ltb: 'activate',
            resourceId: app.id
        });
    };

    // direct binding for devices
    var devicesObservable = _index.DevicesProcessor.getObservable();
    var onNextDevice = function onNextDevice() {

        $scope.apps.forEach(function (app, index) {

            $scope.apps[index].buttonLabel = getButtonLabel(app);
        });

        filterProducts($scope.apps);
    };
    var devicesSubscriber = devicesObservable.subscribe(onNextDevice, function () {}, function () {});

    // direct binding for app-instances
    var appInstancesObservable = _index.AppInstancesProcessor.getObservable();
    var onNextAppInstance = function onNextAppInstance() {

        $scope.apps.forEach(function (app, index) {

            $scope.apps[index].buttonLabel = getButtonLabel(app);
        });

        filterProducts($scope.apps);
    };

    var appInstancesSubscriber = appInstancesObservable.subscribe(onNextAppInstance, function () {}, function () {});

    /**
     * Checks if the app is compatible with the user devices and if it's already installed
     * Returns activate if can be deployed or install if there is no
     * @param {Object} app
     */
    function getButtonLabel(app) {

        // Webapp
        var productUrl = Util.deepFind(app, 'attributes.custom.manifest.product_url');

        if (productUrl) {

            return 'open';
        } else if (app.devices.length > 0) {

            return 'install_other';
        }
        // the install btn for Home Guard should always be 'install_other'
        // because we allow users to download only android version from product page
        if (app.id === 'ashs0') {

            return 'install_other';
        }

        return 'install';
    }

    /**
     * @param {Object} app The app object
     */
    $scope.installService = function (app, installType) {

        var stateName = $state.current.name;
        // check whether we can deploy the product on the current device
        var matchingOS = _index.DevicesProcessor.getDeployOSfor(app.id, currentDeviceOS) || null;
        var hasMatchingOS = !!matchingOS;

        _RFC2.default.send('ConnectWeb Install Click', {
            Page: 'Free Products',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });

        if (stateName.indexOf('.ltb.deploy') === -1) {

            stateName += '.ltb.deploy';
        }

        // install on other device
        if (installType === 'other_device') {

            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                resourceId: app.id,
                deployType: 'other'
            }, {
                reload: false
            });
        } else {

            // normal install
            $state.go(stateName, {
                ltb: 'deploy',
                deviceId: 'new',
                resourceId: app.id,
                os: matchingOS,
                autoInstall: hasMatchingOS
            }, {
                reload: false
            });
        }
    };

    /**
     * @param {Object} app The app object
     */
    $scope.openServiceLink = function (app) {

        _RFC2.default.send('ConnectWeb Open Click', {
            Page: 'Free Products',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });

        window.open(app.attributes.custom.manifest.product_url, '_blank');
    };

    /**
     * @param {String} extensionId The extension id for Opera
     * @param {String} appId The app integration id
     */
    $scope.installOperaExtension = function (extensionId, appId) {

        var operaObj = $window.opr || {};

        if (operaObj.addons) {

            operaObj.addons.installExtension(extensionId);
        } else {

            var extensionUrl = CWCONFIG.operaExtensions[appId];
            extensionUrl = extensionUrl.replace('{language}', CWCONFIG.language);

            $window.open(extensionUrl, '_blank');
        }
    };

    /**
     * @param {Object} app The app integration object
     */
    $scope.sendMixpanelEvent = function (app) {

        _RFC2.default.send('ConnectWeb Install Click', {
            Page: 'Free Products',
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });
    };
    $scope.sendMixpanelEventDetailsButton = function (app, label) {

        _RFC2.default.send('ConnectWeb Product Page Details Click', {
            Page: 'Free Products',
            Label: label,
            Product: Util.deepFind(app, 'attributes.resource.oeName'),
            'Product ID': app.id
        });
    };

    /**
     * @param {Object} app The app integration object
     */
    $scope.deploy = function (app) {

        var deployState = void 0;

        _devicesWithoutAppInstalled[app.id].forEach(function (device) {

            // set the last deploy type, priority has the offline deploy
            var deviceState = Util.deepFind(device, 'attributes.state');
            if (!deployState) {

                deployState = {
                    type: deviceState === 'online' ? 'online' : 'offline',
                    device: device
                };
            } else if (deployState && deviceState !== 'online') {

                deployState = {
                    type: 'offline',
                    device: device
                };
            }

            var deploymentPayload = {
                deviceId: device.id,
                userId: Util.deepFind(device, 'relationships.user.data.id'),
                appId: app.id
            };

            DeployRestService.deployOnDevice(deploymentPayload).then(function (response) {

                _loggers2.default.debug('Products -> DeployRestService success', deploymentPayload, response);
            }).then(null, function (e) {

                // 409 === Conflict
                // An instance for this application already exists (pending)
                // Do not hide the modal
                if (e.status === 409) {

                    return;
                }

                _loggers2.default.debug('Products -> DeployRestService error', deploymentPayload, e);

                _RFC4.default.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: 'icon-' + Util.deepFind(device, 'attributes.type')
                    }
                });
            });
        });

        // Open the deploy modal for the last device set in the deployState variable
        $state.go('root.dashboard.products.ltb.deploy', {
            ltb: 'deploy',
            resourceId: deployState.device.id,
            appId: app.id
        }, {
            reload: false
        });
    };

    $scope.$on('$destroy', function () {

        devicesSubscriber.dispose();
        appInstancesSubscriber.dispose();
    });
}]);

/***/ }),

/***/ "zcic":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "zmiE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var news = [];
var bookmarks = {
    en: [],
    de: [],
    fr: [],
    es: [],
    it: [],
    'pt-br': []
};
var currentPages = {
    threats: 1,
    'how-to': 1
};

var NewsRepository = {
    setPages: function setPages(numberofpages) {

        news = new Array(numberofpages).fill(null);

        return news;
    },
    replace: function replace(data, page, category) {

        var categories = {
            threats: [],
            'how-to': []
        };

        if (typeof data !== 'undefined' && typeof page !== 'undefined' && typeof category !== 'undefined') {

            if (!news[page - 1]) {

                news[page - 1] = categories;
            }

            news[page - 1][category] = data;
        }

        return news;
    },
    replaceBookmarks: function replaceBookmarks(data, language) {

        var bookmark = bookmarks[language].find(function (element) {
            return element.id === data.id;
        });

        if (!bookmark) {

            bookmarks[language].push(data);
        }
    },
    getAll: function getAll() {

        return news;
    },
    getAllBookmarks: function getAllBookmarks() {

        return bookmarks;
    },
    deleteBookmark: function deleteBookmark(articleId, language) {

        bookmarks[language].forEach(function (article) {

            if (articleId === article.id) {

                var remove = function remove(array, element) {

                    return array.filter(function (el) {
                        return el.id !== element.id;
                    });
                };

                bookmarks[language] = remove(bookmarks[language], article);
            }
        });

        return bookmarks;
    },
    addBookmark: function addBookmark(data, language) {

        bookmarks[language].push(data);
    },
    getPageNumber: function getPageNumber() {

        return currentPages;
    },
    updateCurrentPage: function updateCurrentPage(category, pageNumber) {

        currentPages[category] = parseInt(pageNumber, 0);
        return currentPages;
    }
};

exports.default = NewsRepository;

/***/ }),

/***/ "zw2X":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("VjBI");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "zzbF":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("Vygv"),
    isObjectLike = __webpack_require__("7Zib");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ })

},["3qiv"]);


// WEBPACK FOOTER //
// scripts/main.31fe57bf5ee496c09628.js